(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://cdn.printos.com/apps/start/2.14.1/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(12);
	__webpack_require__(28);
	__webpack_require__(29);
	__webpack_require__(88);
	__webpack_require__(8);
	__webpack_require__(521);
	__webpack_require__(89);
	__webpack_require__(520);
	__webpack_require__(91);
	__webpack_require__(38);
	__webpack_require__(93);
	__webpack_require__(4);
	__webpack_require__(7);
	__webpack_require__(41);
	__webpack_require__(95);
	__webpack_require__(522);
	__webpack_require__(82);
	__webpack_require__(3);
	__webpack_require__(282);
	__webpack_require__(570);
	__webpack_require__(571);
	__webpack_require__(283);
	module.exports = __webpack_require__(519);


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function(useSourceMap) {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			return this.map(function (item) {
				var content = cssWithMappingToString(item, useSourceMap);
				if(item[2]) {
					return "@media " + item[2] + "{" + content + "}";
				} else {
					return content;
				}
			}).join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};
	
	function cssWithMappingToString(item, useSourceMap) {
		var content = item[1] || '';
		var cssMapping = item[3];
		if (!cssMapping) {
			return content;
		}
	
		if (useSourceMap && typeof btoa === 'function') {
			var sourceMapping = toComment(cssMapping);
			var sourceURLs = cssMapping.sources.map(function (source) {
				return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
			});
	
			return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
		}
	
		return [content].join('\n');
	}
	
	// Adapted from convert-source-map (MIT)
	function toComment(sourceMap) {
		// eslint-disable-next-line no-undef
		var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
		var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;
	
		return '/*# ' + data + ' */';
	}


/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0;
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function createStyleElement() {
		var styleElement = document.createElement("style");
		var head = getHeadElement();
		styleElement.type = "text/css";
		head.appendChild(styleElement);
		return styleElement;
	}
	
	function createLinkElement() {
		var linkElement = document.createElement("link");
		var head = getHeadElement();
		linkElement.rel = "stylesheet";
		head.appendChild(linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement());
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement();
			update = updateLink.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement();
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return (Object.getOwnPropertyNames(obj).length === 0);
	        } else {
	            var k;
	            for (k in obj) {
	                if (obj.hasOwnProperty(k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null,
	            rfc2822         : false,
	            weekdayMismatch : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid = isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            }
	            else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid (flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        ss : '%d seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function set$1 (mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	            }
	            else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        if (!m) {
	            return isArray(this._months) ? this._months :
	                this._months['standalone'];
	        }
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        if (!m) {
	            return isArray(this._monthsShort) ? this._monthsShort :
	                this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            var args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays (ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        var weekdays = isArray(this._weekdays) ? this._weekdays :
	            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
	        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
	            : (m) ? weekdays[m.day()] : weekdays;
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('k',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour they want. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var localeFamilies = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                var aliasedRequire = require;
	                __webpack_require__(42)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {}
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	            else {
	                if ((typeof console !==  'undefined') && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var locale, parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, tmpLocale, parentConfig = baseConfig;
	            // MERGE
	            tmpLocale = loadLocale(name);
	            if (tmpLocale != null) {
	                parentConfig = tmpLocale._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            var curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10)
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    var obsOffsets = {
	        UT: 0,
	        GMT: 0,
	        EDT: -4 * 60,
	        EST: -5 * 60,
	        CDT: -5 * 60,
	        CST: -6 * 60,
	        MDT: -6 * 60,
	        MST: -7 * 60,
	        PDT: -7 * 60,
	        PST: -8 * 60
	    };
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10);
	            var m = hm % 100, h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i));
	        if (match) {
	            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        // Final attempt, use Input Fallback
	        hooks.createFromInputFallback(config);
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	        'discouraged and will be removed in an upcoming major release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	    function isDurationValid(m) {
	        for (var key in m) {
	            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	                return false;
	            }
	        }
	
	        var unitHasDecimal = false;
	        for (var i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher);
	
	        if (matches === null) {
	            return null;
	        }
	
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ?
	          0 :
	          parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            }
	            else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (isNumber(input)) {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])                         * sign,
	                h  : toInt(match[HOUR])                         * sign,
	                m  : toInt(match[MINUTE])                       * sign,
	                s  : toInt(match[SECOND])                       * sign,
	                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add      = createAdder(1, 'add');
	    var subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function calendar$1 (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year': output = monthDiff(this, that) / 12; break;
	            case 'month': output = monthDiff(this, that); break;
	            case 'quarter': output = monthDiff(this, that) / 3; break;
	            case 'second': output = (this - that) / 1e3; break; // 1000
	            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default: output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true;
	        var m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect () {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment';
	        var zone = '';
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        var prefix = '[' + func + '("]';
	        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        var suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000;
	    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
	    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
	    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return (dividend % divisor + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2 () {
	        return isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict ?
	          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	          locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add               = add;
	    proto.calendar          = calendar$1;
	    proto.clone             = clone;
	    proto.diff              = diff;
	    proto.endOf             = endOf;
	    proto.format            = format;
	    proto.from              = from;
	    proto.fromNow           = fromNow;
	    proto.to                = to;
	    proto.toNow             = toNow;
	    proto.get               = stringGet;
	    proto.invalidAt         = invalidAt;
	    proto.isAfter           = isAfter;
	    proto.isBefore          = isBefore;
	    proto.isBetween         = isBetween;
	    proto.isSame            = isSame;
	    proto.isSameOrAfter     = isSameOrAfter;
	    proto.isSameOrBefore    = isSameOrBefore;
	    proto.isValid           = isValid$2;
	    proto.lang              = lang;
	    proto.locale            = locale;
	    proto.localeData        = localeData;
	    proto.max               = prototypeMax;
	    proto.min               = prototypeMin;
	    proto.parsingFlags      = parsingFlags;
	    proto.set               = stringSet;
	    proto.startOf           = startOf;
	    proto.subtract          = subtract;
	    proto.toArray           = toArray;
	    proto.toObject          = toObject;
	    proto.toDate            = toDate;
	    proto.toISOString       = toISOString;
	    proto.inspect           = inspect;
	    proto.toJSON            = toJSON;
	    proto.toString          = toString;
	    proto.unix              = unix;
	    proto.valueOf           = valueOf;
	    proto.creationData      = creationData;
	    proto.year       = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear    = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month       = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week           = proto.weeks        = getSetWeek;
	    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	    proto.weeksInYear    = getWeeksInYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.date       = getSetDayOfMonth;
	    proto.day        = proto.days             = getSetDayOfWeek;
	    proto.weekday    = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear  = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset            = getSetOffset;
	    proto.utc                  = setOffsetToUTC;
	    proto.local                = setOffsetToLocal;
	    proto.parseZone            = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST                = isDaylightSavingTime;
	    proto.isLocal              = isLocal;
	    proto.isUtcOffset          = isUtcOffset;
	    proto.isUtc                = isUtc;
	    proto.isUTC                = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    function createUnix (input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone () {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar        = calendar;
	    proto$1.longDateFormat  = longDateFormat;
	    proto$1.invalidDate     = invalidDate;
	    proto$1.ordinal         = ordinal;
	    proto$1.preparse        = preParsePostFormat;
	    proto$1.postformat      = preParsePostFormat;
	    proto$1.relativeTime    = relativeTime;
	    proto$1.pastFuture      = pastFuture;
	    proto$1.set             = set;
	
	    proto$1.months            =        localeMonths;
	    proto$1.monthsShort       =        localeMonthsShort;
	    proto$1.monthsParse       =        localeMonthsParse;
	    proto$1.monthsRegex       = monthsRegex;
	    proto$1.monthsShortRegex  = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays       =        localeWeekdays;
	    proto$1.weekdaysMin    =        localeWeekdaysMin;
	    proto$1.weekdaysShort  =        localeWeekdaysShort;
	    proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	    proto$1.weekdaysRegex       =        weekdaysRegex;
	    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1 (format, index, field, setter) {
	        var locale = getLocale();
	        var utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	    var mathAbs = Math.abs;
	
	    function abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1 (duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1 (input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1 (input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':   return months;
	                case 'quarter': return months / 3;
	                case 'year':    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1 () {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asQuarters     = makeAs('Q');
	    var asYears        = makeAs('y');
	
	    function clone$1 () {
	        return createDuration(this);
	    }
	
	    function get$2 (units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        ss: 44,         // a few seconds to seconds
	        s : 45,         // seconds to minute
	        m : 45,         // minutes to hour
	        h : 22,         // hours to day
	        d : 26,         // days to month
	        M : 11          // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	        var duration = createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds <= thresholds.ss && ['s', seconds]  ||
	                seconds < thresholds.s   && ['ss', seconds] ||
	                minutes <= 1             && ['m']           ||
	                minutes < thresholds.m   && ['mm', minutes] ||
	                hours   <= 1             && ['h']           ||
	                hours   < thresholds.h   && ['hh', hours]   ||
	                days    <= 1             && ['d']           ||
	                days    < thresholds.d   && ['dd', days]    ||
	                months  <= 1             && ['M']           ||
	                months  < thresholds.M   && ['MM', months]  ||
	                years   <= 1             && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var locale = this.localeData();
	        var output = relativeTime$1(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return ((x > 0) - (x < 0)) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000;
	        var days         = abs$1(this._days);
	        var months       = abs$1(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        var totalSign = total < 0 ? '-' : '';
	        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return totalSign + 'P' +
	            (Y ? ymSign + Y + 'Y' : '') +
	            (M ? ymSign + M + 'M' : '') +
	            (D ? daysSign + D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? hmsSign + h + 'H' : '') +
	            (m ? hmsSign + m + 'M' : '') +
	            (s ? hmsSign + s + 'S' : '');
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid        = isValid$1;
	    proto$2.abs            = abs;
	    proto$2.add            = add$1;
	    proto$2.subtract       = subtract$1;
	    proto$2.as             = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds      = asSeconds;
	    proto$2.asMinutes      = asMinutes;
	    proto$2.asHours        = asHours;
	    proto$2.asDays         = asDays;
	    proto$2.asWeeks        = asWeeks;
	    proto$2.asMonths       = asMonths;
	    proto$2.asQuarters     = asQuarters;
	    proto$2.asYears        = asYears;
	    proto$2.valueOf        = valueOf$1;
	    proto$2._bubble        = bubble;
	    proto$2.clone          = clone$1;
	    proto$2.get            = get$2;
	    proto$2.milliseconds   = milliseconds;
	    proto$2.seconds        = seconds;
	    proto$2.minutes        = minutes;
	    proto$2.hours          = hours;
	    proto$2.days           = days;
	    proto$2.weeks          = weeks;
	    proto$2.months         = months;
	    proto$2.years          = years;
	    proto$2.humanize       = humanize;
	    proto$2.toISOString    = toISOString$1;
	    proto$2.toString       = toISOString$1;
	    proto$2.toJSON         = toISOString$1;
	    proto$2.locale         = locale;
	    proto$2.localeData     = localeData;
	
	    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	    proto$2.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    hooks.version = '2.24.0';
	
	    setHookCallback(createLocal);
	
	    hooks.fn                    = proto;
	    hooks.min                   = min;
	    hooks.max                   = max;
	    hooks.now                   = now;
	    hooks.utc                   = createUTC;
	    hooks.unix                  = createUnix;
	    hooks.months                = listMonths;
	    hooks.isDate                = isDate;
	    hooks.locale                = getSetGlobalLocale;
	    hooks.invalid               = createInvalid;
	    hooks.duration              = createDuration;
	    hooks.isMoment              = isMoment;
	    hooks.weekdays              = listWeekdays;
	    hooks.parseZone             = createInZone;
	    hooks.localeData            = getLocale;
	    hooks.isDuration            = isDuration;
	    hooks.monthsShort           = listMonthsShort;
	    hooks.weekdaysMin           = listWeekdaysMin;
	    hooks.defineLocale          = defineLocale;
	    hooks.updateLocale          = updateLocale;
	    hooks.locales               = listLocales;
	    hooks.weekdaysShort         = listWeekdaysShort;
	    hooks.normalizeUnits        = normalizeUnits;
	    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat        = getCalendarFormat;
	    hooks.prototype             = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD',                             // <input type="date" />
	        TIME: 'HH:mm',                                  // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
	        MONTH: 'YYYY-MM'                                // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)(module)))

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * angular-translate - v2.8.1 - 2015-10-01
	 * 
	 * Copyright (c) 2015 The angular-translate team, Pascal Precht; Licensed MIT
	 */
	(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module unless amdModuleId is set
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return (factory());
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    factory();
	  }
	}(this, function () {
	
	/**
	 * @ngdoc overview
	 * @name pascalprecht.translate
	 *
	 * @description
	 * The main module which holds everything together.
	 */
	angular.module('pascalprecht.translate', ['ng'])
	  .run(runTranslate);
	
	function runTranslate($translate) {
	
	  'use strict';
	
	  var key = $translate.storageKey(),
	    storage = $translate.storage();
	
	  var fallbackFromIncorrectStorageValue = function () {
	    var preferred = $translate.preferredLanguage();
	    if (angular.isString(preferred)) {
	      $translate.use(preferred);
	      // $translate.use() will also remember the language.
	      // So, we don't need to call storage.put() here.
	    } else {
	      storage.put(key, $translate.use());
	    }
	  };
	
	  fallbackFromIncorrectStorageValue.displayName = 'fallbackFromIncorrectStorageValue';
	
	  if (storage) {
	    if (!storage.get(key)) {
	      fallbackFromIncorrectStorageValue();
	    } else {
	      $translate.use(storage.get(key))['catch'](fallbackFromIncorrectStorageValue);
	    }
	  } else if (angular.isString($translate.preferredLanguage())) {
	    $translate.use($translate.preferredLanguage());
	  }
	}
	runTranslate.$inject = ['$translate'];
	
	runTranslate.displayName = 'runTranslate';
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateSanitizationProvider
	 *
	 * @description
	 *
	 * Configurations for $translateSanitization
	 */
	angular.module('pascalprecht.translate').provider('$translateSanitization', $translateSanitizationProvider);
	
	function $translateSanitizationProvider () {
	
	  'use strict';
	
	  var $sanitize,
	      currentStrategy = null, // TODO change to either 'sanitize', 'escape' or ['sanitize', 'escapeParameters'] in 3.0.
	      hasConfiguredStrategy = false,
	      hasShownNoStrategyConfiguredWarning = false,
	      strategies;
	
	  /**
	   * Definition of a sanitization strategy function
	   * @callback StrategyFunction
	   * @param {string|object} value - value to be sanitized (either a string or an interpolated value map)
	   * @param {string} mode - either 'text' for a string (translation) or 'params' for the interpolated params
	   * @return {string|object}
	   */
	
	  /**
	   * @ngdoc property
	   * @name strategies
	   * @propertyOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Following strategies are built-in:
	   * <dl>
	   *   <dt>sanitize</dt>
	   *   <dd>Sanitizes HTML in the translation text using $sanitize</dd>
	   *   <dt>escape</dt>
	   *   <dd>Escapes HTML in the translation</dd>
	   *   <dt>sanitizeParameters</dt>
	   *   <dd>Sanitizes HTML in the values of the interpolation parameters using $sanitize</dd>
	   *   <dt>escapeParameters</dt>
	   *   <dd>Escapes HTML in the values of the interpolation parameters</dd>
	   *   <dt>escaped</dt>
	   *   <dd>Support legacy strategy name 'escaped' for backwards compatibility (will be removed in 3.0)</dd>
	   * </dl>
	   *
	   */
	
	  strategies = {
	    sanitize: function (value, mode) {
	      if (mode === 'text') {
	        value = htmlSanitizeValue(value);
	      }
	      return value;
	    },
	    escape: function (value, mode) {
	      if (mode === 'text') {
	        value = htmlEscapeValue(value);
	      }
	      return value;
	    },
	    sanitizeParameters: function (value, mode) {
	      if (mode === 'params') {
	        value = mapInterpolationParameters(value, htmlSanitizeValue);
	      }
	      return value;
	    },
	    escapeParameters: function (value, mode) {
	      if (mode === 'params') {
	        value = mapInterpolationParameters(value, htmlEscapeValue);
	      }
	      return value;
	    }
	  };
	  // Support legacy strategy name 'escaped' for backwards compatibility.
	  // TODO should be removed in 3.0
	  strategies.escaped = strategies.escapeParameters;
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateSanitizationProvider#addStrategy
	   * @methodOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Adds a sanitization strategy to the list of known strategies.
	   *
	   * @param {string} strategyName - unique key for a strategy
	   * @param {StrategyFunction} strategyFunction - strategy function
	   * @returns {object} this
	   */
	  this.addStrategy = function (strategyName, strategyFunction) {
	    strategies[strategyName] = strategyFunction;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateSanitizationProvider#removeStrategy
	   * @methodOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Removes a sanitization strategy from the list of known strategies.
	   *
	   * @param {string} strategyName - unique key for a strategy
	   * @returns {object} this
	   */
	  this.removeStrategy = function (strategyName) {
	    delete strategies[strategyName];
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateSanitizationProvider#useStrategy
	   * @methodOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
	   *
	   * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
	   * @returns {object} this
	   */
	  this.useStrategy = function (strategy) {
	    hasConfiguredStrategy = true;
	    currentStrategy = strategy;
	    return this;
	  };
	
	  /**
	   * @ngdoc object
	   * @name pascalprecht.translate.$translateSanitization
	   * @requires $injector
	   * @requires $log
	   *
	   * @description
	   * Sanitizes interpolation parameters and translated texts.
	   *
	   */
	  this.$get = ['$injector', '$log', function ($injector, $log) {
	
	    var cachedStrategyMap = {};
	
	    var applyStrategies = function (value, mode, selectedStrategies) {
	      angular.forEach(selectedStrategies, function (selectedStrategy) {
	        if (angular.isFunction(selectedStrategy)) {
	          value = selectedStrategy(value, mode);
	        } else if (angular.isFunction(strategies[selectedStrategy])) {
	          value = strategies[selectedStrategy](value, mode);
	        } else if (angular.isString(strategies[selectedStrategy])) {
	          if (!cachedStrategyMap[strategies[selectedStrategy]]) {
	            try {
	              cachedStrategyMap[strategies[selectedStrategy]] = $injector.get(strategies[selectedStrategy]);
	            } catch (e) {
	              cachedStrategyMap[strategies[selectedStrategy]] = function() {};
	              throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
	            }
	          }
	          value = cachedStrategyMap[strategies[selectedStrategy]](value, mode);
	        } else {
	          throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
	        }
	      });
	      return value;
	    };
	
	    // TODO: should be removed in 3.0
	    var showNoStrategyConfiguredWarning = function () {
	      if (!hasConfiguredStrategy && !hasShownNoStrategyConfiguredWarning) {
	        $log.warn('pascalprecht.translate.$translateSanitization: No sanitization strategy has been configured. This can have serious security implications. See http://angular-translate.github.io/docs/#/guide/19_security for details.');
	        hasShownNoStrategyConfiguredWarning = true;
	      }
	    };
	
	    if ($injector.has('$sanitize')) {
	      $sanitize = $injector.get('$sanitize');
	    }
	
	    return {
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translateSanitization#useStrategy
	       * @methodOf pascalprecht.translate.$translateSanitization
	       *
	       * @description
	       * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
	       *
	       * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
	       */
	      useStrategy: (function (self) {
	        return function (strategy) {
	          self.useStrategy(strategy);
	        };
	      })(this),
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translateSanitization#sanitize
	       * @methodOf pascalprecht.translate.$translateSanitization
	       *
	       * @description
	       * Sanitizes a value.
	       *
	       * @param {string|object} value The value which should be sanitized.
	       * @param {string} mode The current sanitization mode, either 'params' or 'text'.
	       * @param {string|StrategyFunction|array} [strategy] Optional custom strategy which should be used instead of the currently selected strategy.
	       * @returns {string|object} sanitized value
	       */
	      sanitize: function (value, mode, strategy) {
	        if (!currentStrategy) {
	          showNoStrategyConfiguredWarning();
	        }
	
	        if (arguments.length < 3) {
	          strategy = currentStrategy;
	        }
	
	        if (!strategy) {
	          return value;
	        }
	
	        var selectedStrategies = angular.isArray(strategy) ? strategy : [strategy];
	        return applyStrategies(value, mode, selectedStrategies);
	      }
	    };
	  }];
	
	  var htmlEscapeValue = function (value) {
	    var element = angular.element('<div></div>');
	    element.text(value); // not chainable, see #1044
	    return element.html();
	  };
	
	  var htmlSanitizeValue = function (value) {
	    if (!$sanitize) {
	      throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sanitize service. Either include the ngSanitize module (https://docs.angularjs.org/api/ngSanitize) or use a sanitization strategy which does not depend on $sanitize, such as \'escape\'.');
	    }
	    return $sanitize(value);
	  };
	
	  var mapInterpolationParameters = function (value, iteratee) {
	    if (angular.isObject(value)) {
	      var result = angular.isArray(value) ? [] : {};
	
	      angular.forEach(value, function (propertyValue, propertyKey) {
	        result[propertyKey] = mapInterpolationParameters(propertyValue, iteratee);
	      });
	
	      return result;
	    } else if (angular.isNumber(value)) {
	      return value;
	    } else {
	      return iteratee(value);
	    }
	  };
	}
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateProvider
	 * @description
	 *
	 * $translateProvider allows developers to register translation-tables, asynchronous loaders
	 * and similar to configure translation behavior directly inside of a module.
	 *
	 */
	angular.module('pascalprecht.translate')
	.constant('pascalprechtTranslateOverrider', {})
	.provider('$translate', $translate);
	
	function $translate($STORAGE_KEY, $windowProvider, $translateSanitizationProvider, pascalprechtTranslateOverrider) {
	
	  'use strict';
	
	  var $translationTable = {},
	      $preferredLanguage,
	      $availableLanguageKeys = [],
	      $languageKeyAliases,
	      $fallbackLanguage,
	      $fallbackWasString,
	      $uses,
	      $nextLang,
	      $storageFactory,
	      $storageKey = $STORAGE_KEY,
	      $storagePrefix,
	      $missingTranslationHandlerFactory,
	      $interpolationFactory,
	      $interpolatorFactories = [],
	      $loaderFactory,
	      $cloakClassName = 'translate-cloak',
	      $loaderOptions,
	      $notFoundIndicatorLeft,
	      $notFoundIndicatorRight,
	      $postCompilingEnabled = false,
	      $forceAsyncReloadEnabled = false,
	      $nestedObjectDelimeter = '.',
	      $isReady = false,
	      loaderCache,
	      directivePriority = 0,
	      statefulFilter = true,
	      uniformLanguageTagResolver = 'default',
	      languageTagResolver = {
	        'default': function (tag) {
	          return (tag || '').split('-').join('_');
	        },
	        java: function (tag) {
	          var temp = (tag || '').split('-').join('_');
	          var parts = temp.split('_');
	          return parts.length > 1 ? (parts[0].toLowerCase() + '_' + parts[1].toUpperCase()) : temp;
	        },
	        bcp47: function (tag) {
	          var temp = (tag || '').split('_').join('-');
	          var parts = temp.split('-');
	          return parts.length > 1 ? (parts[0].toLowerCase() + '-' + parts[1].toUpperCase()) : temp;
	        }
	      };
	
	  var version = '2.8.1';
	
	  // tries to determine the browsers language
	  var getFirstBrowserLanguage = function () {
	
	    // internal purpose only
	    if (angular.isFunction(pascalprechtTranslateOverrider.getLocale)) {
	      return pascalprechtTranslateOverrider.getLocale();
	    }
	
	    var nav = $windowProvider.$get().navigator,
	        browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
	        i,
	        language;
	
	    // support for HTML 5.1 "navigator.languages"
	    if (angular.isArray(nav.languages)) {
	      for (i = 0; i < nav.languages.length; i++) {
	        language = nav.languages[i];
	        if (language && language.length) {
	          return language;
	        }
	      }
	    }
	
	    // support for other well known properties in browsers
	    for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
	      language = nav[browserLanguagePropertyKeys[i]];
	      if (language && language.length) {
	        return language;
	      }
	    }
	
	    return null;
	  };
	  getFirstBrowserLanguage.displayName = 'angular-translate/service: getFirstBrowserLanguage';
	
	  // tries to determine the browsers locale
	  var getLocale = function () {
	    var locale = getFirstBrowserLanguage() || '';
	    if (languageTagResolver[uniformLanguageTagResolver]) {
	      locale = languageTagResolver[uniformLanguageTagResolver](locale);
	    }
	    return locale;
	  };
	  getLocale.displayName = 'angular-translate/service: getLocale';
	
	  /**
	   * @name indexOf
	   * @private
	   *
	   * @description
	   * indexOf polyfill. Kinda sorta.
	   *
	   * @param {array} array Array to search in.
	   * @param {string} searchElement Element to search for.
	   *
	   * @returns {int} Index of search element.
	   */
	  var indexOf = function(array, searchElement) {
	    for (var i = 0, len = array.length; i < len; i++) {
	      if (array[i] === searchElement) {
	        return i;
	      }
	    }
	    return -1;
	  };
	
	  /**
	   * @name trim
	   * @private
	   *
	   * @description
	   * trim polyfill
	   *
	   * @returns {string} The string stripped of whitespace from both ends
	   */
	  var trim = function() {
	    return this.toString().replace(/^\s+|\s+$/g, '');
	  };
	
	  var negotiateLocale = function (preferred) {
	
	    var avail = [],
	        locale = angular.lowercase(preferred),
	        i = 0,
	        n = $availableLanguageKeys.length;
	
	    for (; i < n; i++) {
	      avail.push(angular.lowercase($availableLanguageKeys[i]));
	    }
	
	    if (indexOf(avail, locale) > -1) {
	      return preferred;
	    }
	
	    if ($languageKeyAliases) {
	      var alias;
	      for (var langKeyAlias in $languageKeyAliases) {
	        var hasWildcardKey = false;
	        var hasExactKey = Object.prototype.hasOwnProperty.call($languageKeyAliases, langKeyAlias) &&
	          angular.lowercase(langKeyAlias) === angular.lowercase(preferred);
	
	        if (langKeyAlias.slice(-1) === '*') {
	          hasWildcardKey = langKeyAlias.slice(0, -1) === preferred.slice(0, langKeyAlias.length-1);
	        }
	        if (hasExactKey || hasWildcardKey) {
	          alias = $languageKeyAliases[langKeyAlias];
	          if (indexOf(avail, angular.lowercase(alias)) > -1) {
	            return alias;
	          }
	        }
	      }
	    }
	
	    if (preferred) {
	      var parts = preferred.split('_');
	
	      if (parts.length > 1 && indexOf(avail, angular.lowercase(parts[0])) > -1) {
	        return parts[0];
	      }
	    }
	
	    // If everything fails, just return the preferred, unchanged.
	    return preferred;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translations
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a new translation table for specific language key.
	   *
	   * To register a translation table for specific language, pass a defined language
	   * key as first parameter.
	   *
	   * <pre>
	   *  // register translation table for language: 'de_DE'
	   *  $translateProvider.translations('de_DE', {
	   *    'GREETING': 'Hallo Welt!'
	   *  });
	   *
	   *  // register another one
	   *  $translateProvider.translations('en_US', {
	   *    'GREETING': 'Hello world!'
	   *  });
	   * </pre>
	   *
	   * When registering multiple translation tables for for the same language key,
	   * the actual translation table gets extended. This allows you to define module
	   * specific translation which only get added, once a specific module is loaded in
	   * your app.
	   *
	   * Invoking this method with no arguments returns the translation table which was
	   * registered with no language key. Invoking it with a language key returns the
	   * related translation table.
	   *
	   * @param {string} key A language key.
	   * @param {object} translationTable A plain old JavaScript object that represents a translation table.
	   *
	   */
	  var translations = function (langKey, translationTable) {
	
	    if (!langKey && !translationTable) {
	      return $translationTable;
	    }
	
	    if (langKey && !translationTable) {
	      if (angular.isString(langKey)) {
	        return $translationTable[langKey];
	      }
	    } else {
	      if (!angular.isObject($translationTable[langKey])) {
	        $translationTable[langKey] = {};
	      }
	      angular.extend($translationTable[langKey], flatObject(translationTable));
	    }
	    return this;
	  };
	
	  this.translations = translations;
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#cloakClassName
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   *
	   * Let's you change the class name for `translate-cloak` directive.
	   * Default class name is `translate-cloak`.
	   *
	   * @param {string} name translate-cloak class name
	   */
	  this.cloakClassName = function (name) {
	    if (!name) {
	      return $cloakClassName;
	    }
	    $cloakClassName = name;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#nestedObjectDelimeter
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   *
	   * Let's you change the delimiter for namespaced translations.
	   * Default delimiter is `.`.
	   *
	   * @param {string} delimiter namespace separator
	   */
	  this.nestedObjectDelimeter = function (delimiter) {
	    if (!delimiter) {
	      return $nestedObjectDelimeter;
	    }
	    $nestedObjectDelimeter = delimiter;
	    return this;
	  };
	
	  /**
	   * @name flatObject
	   * @private
	   *
	   * @description
	   * Flats an object. This function is used to flatten given translation data with
	   * namespaces, so they are later accessible via dot notation.
	   */
	  var flatObject = function (data, path, result, prevKey) {
	    var key, keyWithPath, keyWithShortPath, val;
	
	    if (!path) {
	      path = [];
	    }
	    if (!result) {
	      result = {};
	    }
	    for (key in data) {
	      if (!Object.prototype.hasOwnProperty.call(data, key)) {
	        continue;
	      }
	      val = data[key];
	      if (angular.isObject(val)) {
	        flatObject(val, path.concat(key), result, key);
	      } else {
	        keyWithPath = path.length ? ('' + path.join($nestedObjectDelimeter) + $nestedObjectDelimeter + key) : key;
	        if(path.length && key === prevKey){
	          // Create shortcut path (foo.bar == foo.bar.bar)
	          keyWithShortPath = '' + path.join($nestedObjectDelimeter);
	          // Link it to original path
	          result[keyWithShortPath] = '@:' + keyWithPath;
	        }
	        result[keyWithPath] = val;
	      }
	    }
	    return result;
	  };
	  flatObject.displayName = 'flatObject';
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#addInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Adds interpolation services to angular-translate, so it can manage them.
	   *
	   * @param {object} factory Interpolation service factory
	   */
	  this.addInterpolation = function (factory) {
	    $interpolatorFactories.push(factory);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMessageFormatInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use interpolation functionality of messageformat.js.
	   * This is useful when having high level pluralization and gender selection.
	   */
	  this.useMessageFormatInterpolation = function () {
	    return this.useInterpolation('$translateMessageFormatInterpolation');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate which interpolation style to use as default, application-wide.
	   * Simply pass a factory/service name. The interpolation service has to implement
	   * the correct interface.
	   *
	   * @param {string} factory Interpolation service name.
	   */
	  this.useInterpolation = function (factory) {
	    $interpolationFactory = factory;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useSanitizeStrategy
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Simply sets a sanitation strategy type.
	   *
	   * @param {string} value Strategy type.
	   */
	  this.useSanitizeValueStrategy = function (value) {
	    $translateSanitizationProvider.useStrategy(value);
	    return this;
	  };
	
	 /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#preferredLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which of the registered translation tables to use for translation
	   * at initial startup by passing a language key. Similar to `$translateProvider#use`
	   * only that it says which language to **prefer**.
	   *
	   * @param {string} langKey A language key.
	   */
	  this.preferredLanguage = function(langKey) {
	    if (langKey) {
	      setupPreferredLanguage(langKey);
	      return this;
	    }
	    return $preferredLanguage;
	  };
	  var setupPreferredLanguage = function (langKey) {
	    if (langKey) {
	      $preferredLanguage = langKey;
	    }
	    return $preferredLanguage;
	  };
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicator
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found. E.g. when
	   * setting the indicator as 'X' and one tries to translate a translation id
	   * called `NOT_FOUND`, this will result in `X NOT_FOUND X`.
	   *
	   * Internally this methods sets a left indicator and a right indicator using
	   * `$translateProvider.translationNotFoundIndicatorLeft()` and
	   * `$translateProvider.translationNotFoundIndicatorRight()`.
	   *
	   * **Note**: These methods automatically add a whitespace between the indicators
	   * and the translation id.
	   *
	   * @param {string} indicator An indicator, could be any string.
	   */
	  this.translationNotFoundIndicator = function (indicator) {
	    this.translationNotFoundIndicatorLeft(indicator);
	    this.translationNotFoundIndicatorRight(indicator);
	    return this;
	  };
	
	  /**
	   * ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found left to the
	   * translation id.
	   *
	   * @param {string} indicator An indicator.
	   */
	  this.translationNotFoundIndicatorLeft = function (indicator) {
	    if (!indicator) {
	      return $notFoundIndicatorLeft;
	    }
	    $notFoundIndicatorLeft = indicator;
	    return this;
	  };
	
	  /**
	   * ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found right to the
	   * translation id.
	   *
	   * @param {string} indicator An indicator.
	   */
	  this.translationNotFoundIndicatorRight = function (indicator) {
	    if (!indicator) {
	      return $notFoundIndicatorRight;
	    }
	    $notFoundIndicatorRight = indicator;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#fallbackLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which of the registered translation tables to use when missing translations
	   * at initial startup by passing a language key. Similar to `$translateProvider#use`
	   * only that it says which language to **fallback**.
	   *
	   * @param {string||array} langKey A language key.
	   *
	   */
	  this.fallbackLanguage = function (langKey) {
	    fallbackStack(langKey);
	    return this;
	  };
	
	  var fallbackStack = function (langKey) {
	    if (langKey) {
	      if (angular.isString(langKey)) {
	        $fallbackWasString = true;
	        $fallbackLanguage = [ langKey ];
	      } else if (angular.isArray(langKey)) {
	        $fallbackWasString = false;
	        $fallbackLanguage = langKey;
	      }
	      if (angular.isString($preferredLanguage)  && indexOf($fallbackLanguage, $preferredLanguage) < 0) {
	        $fallbackLanguage.push($preferredLanguage);
	      }
	
	      return this;
	    } else {
	      if ($fallbackWasString) {
	        return $fallbackLanguage[0];
	      } else {
	        return $fallbackLanguage;
	      }
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#use
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Set which translation table to use for translation by given language key. When
	   * trying to 'use' a language which isn't provided, it'll throw an error.
	   *
	   * You actually don't have to use this method since `$translateProvider#preferredLanguage`
	   * does the job too.
	   *
	   * @param {string} langKey A language key.
	   */
	  this.use = function (langKey) {
	    if (langKey) {
	      if (!$translationTable[langKey] && (!$loaderFactory)) {
	        // only throw an error, when not loading translation data asynchronously
	        throw new Error('$translateProvider couldn\'t find translationTable for langKey: \'' + langKey + '\'');
	      }
	      $uses = langKey;
	      return this;
	    }
	    return $uses;
	  };
	
	 /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#storageKey
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which key must represent the choosed language by a user in the storage.
	   *
	   * @param {string} key A key for the storage.
	   */
	  var storageKey = function(key) {
	    if (!key) {
	      if ($storagePrefix) {
	        return $storagePrefix + $storageKey;
	      }
	      return $storageKey;
	    }
	    $storageKey = key;
	    return this;
	  };
	
	  this.storageKey = storageKey;
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useUrlLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateUrlLoader` extension service as loader.
	   *
	   * @param {string} url Url
	   * @param {Object=} options Optional configuration object
	   */
	  this.useUrlLoader = function (url, options) {
	    return this.useLoader('$translateUrlLoader', angular.extend({ url: url }, options));
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useStaticFilesLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateStaticFilesLoader` extension service as loader.
	   *
	   * @param {Object=} options Optional configuration object
	   */
	  this.useStaticFilesLoader = function (options) {
	    return this.useLoader('$translateStaticFilesLoader', options);
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use any other service as loader.
	   *
	   * @param {string} loaderFactory Factory name to use
	   * @param {Object=} options Optional configuration object
	   */
	  this.useLoader = function (loaderFactory, options) {
	    $loaderFactory = loaderFactory;
	    $loaderOptions = options || {};
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLocalStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateLocalStorage` service as storage layer.
	   *
	   */
	  this.useLocalStorage = function () {
	    return this.useStorage('$translateLocalStorage');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useCookieStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateCookieStorage` service as storage layer.
	   */
	  this.useCookieStorage = function () {
	    return this.useStorage('$translateCookieStorage');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use custom service as storage layer.
	   */
	  this.useStorage = function (storageFactory) {
	    $storageFactory = storageFactory;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#storagePrefix
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets prefix for storage key.
	   *
	   * @param {string} prefix Storage key prefix
	   */
	  this.storagePrefix = function (prefix) {
	    if (!prefix) {
	      return prefix;
	    }
	    $storagePrefix = prefix;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandlerLog
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use built-in log handler when trying to translate
	   * a translation Id which doesn't exist.
	   *
	   * This is actually a shortcut method for `useMissingTranslationHandler()`.
	   *
	   */
	  this.useMissingTranslationHandlerLog = function () {
	    return this.useMissingTranslationHandler('$translateMissingTranslationHandlerLog');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandler
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Expects a factory name which later gets instantiated with `$injector`.
	   * This method can be used to tell angular-translate to use a custom
	   * missingTranslationHandler. Just build a factory which returns a function
	   * and expects a translation id as argument.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.useMissingTranslationHandler('customHandler');
	   *  });
	   *
	   *  app.factory('customHandler', function (dep1, dep2) {
	   *    return function (translationId) {
	   *      // something with translationId and dep1 and dep2
	   *    };
	   *  });
	   * </pre>
	   *
	   * @param {string} factory Factory name
	   */
	  this.useMissingTranslationHandler = function (factory) {
	    $missingTranslationHandlerFactory = factory;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#usePostCompiling
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * If post compiling is enabled, all translated values will be processed
	   * again with AngularJS' $compile.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.usePostCompiling(true);
	   *  });
	   * </pre>
	   *
	   * @param {string} factory Factory name
	   */
	  this.usePostCompiling = function (value) {
	    $postCompilingEnabled = !(!value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#forceAsyncReload
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * If force async reload is enabled, async loader will always be called
	   * even if $translationTable already contains the language key, adding
	   * possible new entries to the $translationTable.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.forceAsyncReload(true);
	   *  });
	   * </pre>
	   *
	   * @param {boolean} value - valid values are true or false
	   */
	  this.forceAsyncReload = function (value) {
	    $forceAsyncReloadEnabled = !(!value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#uniformLanguageTag
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate which language tag should be used as a result when determining
	   * the current browser language.
	   *
	   * This setting must be set before invoking {@link pascalprecht.translate.$translateProvider#methods_determinePreferredLanguage determinePreferredLanguage()}.
	   *
	   * <pre>
	   * $translateProvider
	   *   .uniformLanguageTag('bcp47')
	   *   .determinePreferredLanguage()
	   * </pre>
	   *
	   * The resolver currently supports:
	   * * default
	   *     (traditionally: hyphens will be converted into underscores, i.e. en-US => en_US)
	   *     en-US => en_US
	   *     en_US => en_US
	   *     en-us => en_us
	   * * java
	   *     like default, but the second part will be always in uppercase
	   *     en-US => en_US
	   *     en_US => en_US
	   *     en-us => en_US
	   * * BCP 47 (RFC 4646 & 4647)
	   *     en-US => en-US
	   *     en_US => en-US
	   *     en-us => en-US
	   *
	   * See also:
	   * * http://en.wikipedia.org/wiki/IETF_language_tag
	   * * http://www.w3.org/International/core/langtags/
	   * * http://tools.ietf.org/html/bcp47
	   *
	   * @param {string|object} options - options (or standard)
	   * @param {string} options.standard - valid values are 'default', 'bcp47', 'java'
	   */
	  this.uniformLanguageTag = function (options) {
	
	    if (!options) {
	      options = {};
	    } else if (angular.isString(options)) {
	      options = {
	        standard: options
	      };
	    }
	
	    uniformLanguageTagResolver = options.standard;
	
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#determinePreferredLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to try to determine on its own which language key
	   * to set as preferred language. When `fn` is given, angular-translate uses it
	   * to determine a language key, otherwise it uses the built-in `getLocale()`
	   * method.
	   *
	   * The `getLocale()` returns a language key in the format `[lang]_[country]` or
	   * `[lang]` depending on what the browser provides.
	   *
	   * Use this method at your own risk, since not all browsers return a valid
	   * locale (see {@link pascalprecht.translate.$translateProvider#methods_uniformLanguageTag uniformLanguageTag()}).
	   *
	   * @param {Function=} fn Function to determine a browser's locale
	   */
	  this.determinePreferredLanguage = function (fn) {
	
	    var locale = (fn && angular.isFunction(fn)) ? fn() : getLocale();
	
	    if (!$availableLanguageKeys.length) {
	      $preferredLanguage = locale;
	    } else {
	      $preferredLanguage = negotiateLocale(locale);
	    }
	
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#registerAvailableLanguageKeys
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a set of language keys the app will work with. Use this method in
	   * combination with
	   * {@link pascalprecht.translate.$translateProvider#determinePreferredLanguage determinePreferredLanguage}.
	   * When available languages keys are registered, angular-translate
	   * tries to find the best fitting language key depending on the browsers locale,
	   * considering your language key convention.
	   *
	   * @param {object} languageKeys Array of language keys the your app will use
	   * @param {object=} aliases Alias map.
	   */
	  this.registerAvailableLanguageKeys = function (languageKeys, aliases) {
	    if (languageKeys) {
	      $availableLanguageKeys = languageKeys;
	      if (aliases) {
	        $languageKeyAliases = aliases;
	      }
	      return this;
	    }
	    return $availableLanguageKeys;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLoaderCache
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a cache for internal $http based loaders.
	   * {@link pascalprecht.translate.$translationCache $translationCache}.
	   * When false the cache will be disabled (default). When true or undefined
	   * the cache will be a default (see $cacheFactory). When an object it will
	   * be treat as a cache object itself: the usage is $http({cache: cache})
	   *
	   * @param {object} cache boolean, string or cache-object
	   */
	  this.useLoaderCache = function (cache) {
	    if (cache === false) {
	      // disable cache
	      loaderCache = undefined;
	    } else if (cache === true) {
	      // enable cache using AJS defaults
	      loaderCache = true;
	    } else if (typeof(cache) === 'undefined') {
	      // enable cache using default
	      loaderCache = '$translationCache';
	    } else if (cache) {
	      // enable cache using given one (see $cacheFactory)
	      loaderCache = cache;
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#directivePriority
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets the default priority of the translate directive. The standard value is `0`.
	   * Calling this function without an argument will return the current value.
	   *
	   * @param {number} priority for the translate-directive
	   */
	  this.directivePriority = function (priority) {
	    if (priority === undefined) {
	      // getter
	      return directivePriority;
	    } else {
	      // setter with chaining
	      directivePriority = priority;
	      return this;
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#statefulFilter
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Since AngularJS 1.3, filters which are not stateless (depending at the scope)
	   * have to explicit define this behavior.
	   * Sets whether the translate filter should be stateful or stateless. The standard value is `true`
	   * meaning being stateful.
	   * Calling this function without an argument will return the current value.
	   *
	   * @param {boolean} state - defines the state of the filter
	   */
	  this.statefulFilter = function (state) {
	    if (state === undefined) {
	      // getter
	      return statefulFilter;
	    } else {
	      // setter with chaining
	      statefulFilter = state;
	      return this;
	    }
	  };
	
	  /**
	   * @ngdoc object
	   * @name pascalprecht.translate.$translate
	   * @requires $interpolate
	   * @requires $log
	   * @requires $rootScope
	   * @requires $q
	   *
	   * @description
	   * The `$translate` service is the actual core of angular-translate. It expects a translation id
	   * and optional interpolate parameters to translate contents.
	   *
	   * <pre>
	   *  $translate('HEADLINE_TEXT').then(function (translation) {
	   *    $scope.translatedText = translation;
	   *  });
	   * </pre>
	   *
	   * @param {string|array} translationId A token which represents a translation id
	   *                                     This can be optionally an array of translation ids which
	   *                                     results that the function returns an object where each key
	   *                                     is the translation id and the value the translation.
	   * @param {object=} interpolateParams An object hash for dynamic values
	   * @param {string} interpolationId The id of the interpolation to use
	   * @returns {object} promise
	   */
	  this.$get = [
	    '$log',
	    '$injector',
	    '$rootScope',
	    '$q',
	    function ($log, $injector, $rootScope, $q) {
	
	      var Storage,
	          defaultInterpolator = $injector.get($interpolationFactory || '$translateDefaultInterpolation'),
	          pendingLoader = false,
	          interpolatorHashMap = {},
	          langPromises = {},
	          fallbackIndex,
	          startFallbackIteration;
	
	      var $translate = function (translationId, interpolateParams, interpolationId, defaultTranslationText) {
	
	        // Duck detection: If the first argument is an array, a bunch of translations was requested.
	        // The result is an object.
	        if (angular.isArray(translationId)) {
	          // Inspired by Q.allSettled by Kris Kowal
	          // https://github.com/kriskowal/q/blob/b0fa72980717dc202ffc3cbf03b936e10ebbb9d7/q.js#L1553-1563
	          // This transforms all promises regardless resolved or rejected
	          var translateAll = function (translationIds) {
	            var results = {}; // storing the actual results
	            var promises = []; // promises to wait for
	            // Wraps the promise a) being always resolved and b) storing the link id->value
	            var translate = function (translationId) {
	              var deferred = $q.defer();
	              var regardless = function (value) {
	                results[translationId] = value;
	                deferred.resolve([translationId, value]);
	              };
	              // we don't care whether the promise was resolved or rejected; just store the values
	              $translate(translationId, interpolateParams, interpolationId, defaultTranslationText).then(regardless, regardless);
	              return deferred.promise;
	            };
	            for (var i = 0, c = translationIds.length; i < c; i++) {
	              promises.push(translate(translationIds[i]));
	            }
	            // wait for all (including storing to results)
	            return $q.all(promises).then(function () {
	              // return the results
	              return results;
	            });
	          };
	          return translateAll(translationId);
	        }
	
	        var deferred = $q.defer();
	
	        // trim off any whitespace
	        if (translationId) {
	          translationId = trim.apply(translationId);
	        }
	
	        var promiseToWaitFor = (function () {
	          var promise = $preferredLanguage ?
	            langPromises[$preferredLanguage] :
	            langPromises[$uses];
	
	          fallbackIndex = 0;
	
	          if ($storageFactory && !promise) {
	            // looks like there's no pending promise for $preferredLanguage or
	            // $uses. Maybe there's one pending for a language that comes from
	            // storage.
	            var langKey = Storage.get($storageKey);
	            promise = langPromises[langKey];
	
	            if ($fallbackLanguage && $fallbackLanguage.length) {
	                var index = indexOf($fallbackLanguage, langKey);
	                // maybe the language from storage is also defined as fallback language
	                // we increase the fallback language index to not search in that language
	                // as fallback, since it's probably the first used language
	                // in that case the index starts after the first element
	                fallbackIndex = (index === 0) ? 1 : 0;
	
	                // but we can make sure to ALWAYS fallback to preferred language at least
	                if (indexOf($fallbackLanguage, $preferredLanguage) < 0) {
	                  $fallbackLanguage.push($preferredLanguage);
	                }
	            }
	          }
	          return promise;
	        }());
	
	        if (!promiseToWaitFor) {
	          // no promise to wait for? okay. Then there's no loader registered
	          // nor is a one pending for language that comes from storage.
	          // We can just translate.
	          determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText).then(deferred.resolve, deferred.reject);
	        } else {
	          var promiseResolved = function () {
	            determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText).then(deferred.resolve, deferred.reject);
	          };
	          promiseResolved.displayName = 'promiseResolved';
	
	          promiseToWaitFor['finally'](promiseResolved, deferred.reject);
	        }
	        return deferred.promise;
	      };
	
	      /**
	       * @name applyNotFoundIndicators
	       * @private
	       *
	       * @description
	       * Applies not fount indicators to given translation id, if needed.
	       * This function gets only executed, if a translation id doesn't exist,
	       * which is why a translation id is expected as argument.
	       *
	       * @param {string} translationId Translation id.
	       * @returns {string} Same as given translation id but applied with not found
	       * indicators.
	       */
	      var applyNotFoundIndicators = function (translationId) {
	        // applying notFoundIndicators
	        if ($notFoundIndicatorLeft) {
	          translationId = [$notFoundIndicatorLeft, translationId].join(' ');
	        }
	        if ($notFoundIndicatorRight) {
	          translationId = [translationId, $notFoundIndicatorRight].join(' ');
	        }
	        return translationId;
	      };
	
	      /**
	       * @name useLanguage
	       * @private
	       *
	       * @description
	       * Makes actual use of a language by setting a given language key as used
	       * language and informs registered interpolators to also use the given
	       * key as locale.
	       *
	       * @param {key} Locale key.
	       */
	      var useLanguage = function (key) {
	        $uses = key;
	
	        // make sure to store new language key before triggering success event
	        if ($storageFactory) {
	          Storage.put($translate.storageKey(), $uses);
	        }
	
	        $rootScope.$emit('$translateChangeSuccess', {language: key});
	
	        // inform default interpolator
	        defaultInterpolator.setLocale($uses);
	
	        var eachInterpolator = function (interpolator, id) {
	          interpolatorHashMap[id].setLocale($uses);
	        };
	        eachInterpolator.displayName = 'eachInterpolatorLocaleSetter';
	
	        // inform all others too!
	        angular.forEach(interpolatorHashMap, eachInterpolator);
	        $rootScope.$emit('$translateChangeEnd', {language: key});
	      };
	
	      /**
	       * @name loadAsync
	       * @private
	       *
	       * @description
	       * Kicks of registered async loader using `$injector` and applies existing
	       * loader options. When resolved, it updates translation tables accordingly
	       * or rejects with given language key.
	       *
	       * @param {string} key Language key.
	       * @return {Promise} A promise.
	       */
	      var loadAsync = function (key) {
	        if (!key) {
	          throw 'No language key specified for loading.';
	        }
	
	        var deferred = $q.defer();
	
	        $rootScope.$emit('$translateLoadingStart', {language: key});
	        pendingLoader = true;
	
	        var cache = loaderCache;
	        if (typeof(cache) === 'string') {
	          // getting on-demand instance of loader
	          cache = $injector.get(cache);
	        }
	
	        var loaderOptions = angular.extend({}, $loaderOptions, {
	          key: key,
	          $http: angular.extend({}, {
	            cache: cache
	          }, $loaderOptions.$http)
	        });
	
	        var onLoaderSuccess = function (data) {
	          var translationTable = {};
	          $rootScope.$emit('$translateLoadingSuccess', {language: key});
	
	          if (angular.isArray(data)) {
	            angular.forEach(data, function (table) {
	              angular.extend(translationTable, flatObject(table));
	            });
	          } else {
	            angular.extend(translationTable, flatObject(data));
	          }
	          pendingLoader = false;
	          deferred.resolve({
	            key: key,
	            table: translationTable
	          });
	          $rootScope.$emit('$translateLoadingEnd', {language: key});
	        };
	        onLoaderSuccess.displayName = 'onLoaderSuccess';
	
	        var onLoaderError = function (key) {
	          $rootScope.$emit('$translateLoadingError', {language: key});
	          deferred.reject(key);
	          $rootScope.$emit('$translateLoadingEnd', {language: key});
	        };
	        onLoaderError.displayName = 'onLoaderError';
	
	        $injector.get($loaderFactory)(loaderOptions)
	          .then(onLoaderSuccess, onLoaderError);
	
	        return deferred.promise;
	      };
	
	      if ($storageFactory) {
	        Storage = $injector.get($storageFactory);
	
	        if (!Storage.get || !Storage.put) {
	          throw new Error('Couldn\'t use storage \'' + $storageFactory + '\', missing get() or put() method!');
	        }
	      }
	
	      // if we have additional interpolations that were added via
	      // $translateProvider.addInterpolation(), we have to map'em
	      if ($interpolatorFactories.length) {
	        var eachInterpolationFactory = function (interpolatorFactory) {
	          var interpolator = $injector.get(interpolatorFactory);
	          // setting initial locale for each interpolation service
	          interpolator.setLocale($preferredLanguage || $uses);
	          // make'em recognizable through id
	          interpolatorHashMap[interpolator.getInterpolationIdentifier()] = interpolator;
	        };
	        eachInterpolationFactory.displayName = 'interpolationFactoryAdder';
	
	        angular.forEach($interpolatorFactories, eachInterpolationFactory);
	      }
	
	      /**
	       * @name getTranslationTable
	       * @private
	       *
	       * @description
	       * Returns a promise that resolves to the translation table
	       * or is rejected if an error occurred.
	       *
	       * @param langKey
	       * @returns {Q.promise}
	       */
	      var getTranslationTable = function (langKey) {
	        var deferred = $q.defer();
	        if (Object.prototype.hasOwnProperty.call($translationTable, langKey)) {
	          deferred.resolve($translationTable[langKey]);
	        } else if (langPromises[langKey]) {
	          var onResolve = function (data) {
	            translations(data.key, data.table);
	            deferred.resolve(data.table);
	          };
	          onResolve.displayName = 'translationTableResolver';
	          langPromises[langKey].then(onResolve, deferred.reject);
	        } else {
	          deferred.reject();
	        }
	        return deferred.promise;
	      };
	
	      /**
	       * @name getFallbackTranslation
	       * @private
	       *
	       * @description
	       * Returns a promise that will resolve to the translation
	       * or be rejected if no translation was found for the language.
	       * This function is currently only used for fallback language translation.
	       *
	       * @param langKey The language to translate to.
	       * @param translationId
	       * @param interpolateParams
	       * @param Interpolator
	       * @returns {Q.promise}
	       */
	      var getFallbackTranslation = function (langKey, translationId, interpolateParams, Interpolator) {
	        var deferred = $q.defer();
	
	        var onResolve = function (translationTable) {
	          if (Object.prototype.hasOwnProperty.call(translationTable, translationId)) {
	            Interpolator.setLocale(langKey);
	            var translation = translationTable[translationId];
	            if (translation.substr(0, 2) === '@:') {
	              getFallbackTranslation(langKey, translation.substr(2), interpolateParams, Interpolator)
	                .then(deferred.resolve, deferred.reject);
	            } else {
	              deferred.resolve(Interpolator.interpolate(translationTable[translationId], interpolateParams));
	            }
	            Interpolator.setLocale($uses);
	          } else {
	            deferred.reject();
	          }
	        };
	        onResolve.displayName = 'fallbackTranslationResolver';
	
	        getTranslationTable(langKey).then(onResolve, deferred.reject);
	
	        return deferred.promise;
	      };
	
	      /**
	       * @name getFallbackTranslationInstant
	       * @private
	       *
	       * @description
	       * Returns a translation
	       * This function is currently only used for fallback language translation.
	       *
	       * @param langKey The language to translate to.
	       * @param translationId
	       * @param interpolateParams
	       * @param Interpolator
	       * @returns {string} translation
	       */
	      var getFallbackTranslationInstant = function (langKey, translationId, interpolateParams, Interpolator) {
	        var result, translationTable = $translationTable[langKey];
	
	        if (translationTable && Object.prototype.hasOwnProperty.call(translationTable, translationId)) {
	          Interpolator.setLocale(langKey);
	          result = Interpolator.interpolate(translationTable[translationId], interpolateParams);
	          if (result.substr(0, 2) === '@:') {
	            return getFallbackTranslationInstant(langKey, result.substr(2), interpolateParams, Interpolator);
	          }
	          Interpolator.setLocale($uses);
	        }
	
	        return result;
	      };
	
	
	      /**
	       * @name translateByHandler
	       * @private
	       *
	       * Translate by missing translation handler.
	       *
	       * @param translationId
	       * @returns translation created by $missingTranslationHandler or translationId is $missingTranslationHandler is
	       * absent
	       */
	      var translateByHandler = function (translationId, interpolateParams) {
	        // If we have a handler factory - we might also call it here to determine if it provides
	        // a default text for a translationid that can't be found anywhere in our tables
	        if ($missingTranslationHandlerFactory) {
	          var resultString = $injector.get($missingTranslationHandlerFactory)(translationId, $uses, interpolateParams);
	          if (resultString !== undefined) {
	            return resultString;
	          } else {
	            return translationId;
	          }
	        } else {
	          return translationId;
	        }
	      };
	
	      /**
	       * @name resolveForFallbackLanguage
	       * @private
	       *
	       * Recursive helper function for fallbackTranslation that will sequentially look
	       * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
	       *
	       * @param fallbackLanguageIndex
	       * @param translationId
	       * @param interpolateParams
	       * @param Interpolator
	       * @returns {Q.promise} Promise that will resolve to the translation.
	       */
	      var resolveForFallbackLanguage = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, defaultTranslationText) {
	        var deferred = $q.defer();
	
	        if (fallbackLanguageIndex < $fallbackLanguage.length) {
	          var langKey = $fallbackLanguage[fallbackLanguageIndex];
	          getFallbackTranslation(langKey, translationId, interpolateParams, Interpolator).then(
	            deferred.resolve,
	            function () {
	              // Look in the next fallback language for a translation.
	              // It delays the resolving by passing another promise to resolve.
	              resolveForFallbackLanguage(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator, defaultTranslationText).then(deferred.resolve);
	            }
	          );
	        } else {
	          // No translation found in any fallback language
	          // if a default translation text is set in the directive, then return this as a result
	          if (defaultTranslationText) {
	            deferred.resolve(defaultTranslationText);
	          } else {
	            // if no default translation is set and an error handler is defined, send it to the handler
	            // and then return the result
	            deferred.resolve(translateByHandler(translationId, interpolateParams));
	          }
	        }
	        return deferred.promise;
	      };
	
	      /**
	       * @name resolveForFallbackLanguageInstant
	       * @private
	       *
	       * Recursive helper function for fallbackTranslation that will sequentially look
	       * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
	       *
	       * @param fallbackLanguageIndex
	       * @param translationId
	       * @param interpolateParams
	       * @param Interpolator
	       * @returns {string} translation
	       */
	      var resolveForFallbackLanguageInstant = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator) {
	        var result;
	
	        if (fallbackLanguageIndex < $fallbackLanguage.length) {
	          var langKey = $fallbackLanguage[fallbackLanguageIndex];
	          result = getFallbackTranslationInstant(langKey, translationId, interpolateParams, Interpolator);
	          if (!result) {
	            result = resolveForFallbackLanguageInstant(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator);
	          }
	        }
	        return result;
	      };
	
	      /**
	       * Translates with the usage of the fallback languages.
	       *
	       * @param translationId
	       * @param interpolateParams
	       * @param Interpolator
	       * @returns {Q.promise} Promise, that resolves to the translation.
	       */
	      var fallbackTranslation = function (translationId, interpolateParams, Interpolator, defaultTranslationText) {
	        // Start with the fallbackLanguage with index 0
	        return resolveForFallbackLanguage((startFallbackIteration>0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, defaultTranslationText);
	      };
	
	      /**
	       * Translates with the usage of the fallback languages.
	       *
	       * @param translationId
	       * @param interpolateParams
	       * @param Interpolator
	       * @returns {String} translation
	       */
	      var fallbackTranslationInstant = function (translationId, interpolateParams, Interpolator) {
	        // Start with the fallbackLanguage with index 0
	        return resolveForFallbackLanguageInstant((startFallbackIteration>0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator);
	      };
	
	      var determineTranslation = function (translationId, interpolateParams, interpolationId, defaultTranslationText) {
	
	        var deferred = $q.defer();
	
	        var table = $uses ? $translationTable[$uses] : $translationTable,
	            Interpolator = (interpolationId) ? interpolatorHashMap[interpolationId] : defaultInterpolator;
	
	        // if the translation id exists, we can just interpolate it
	        if (table && Object.prototype.hasOwnProperty.call(table, translationId)) {
	          var translation = table[translationId];
	
	          // If using link, rerun $translate with linked translationId and return it
	          if (translation.substr(0, 2) === '@:') {
	
	            $translate(translation.substr(2), interpolateParams, interpolationId, defaultTranslationText)
	              .then(deferred.resolve, deferred.reject);
	          } else {
	            deferred.resolve(Interpolator.interpolate(translation, interpolateParams));
	          }
	        } else {
	          var missingTranslationHandlerTranslation;
	          // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
	          if ($missingTranslationHandlerFactory && !pendingLoader) {
	            missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams);
	          }
	
	          // since we couldn't translate the inital requested translation id,
	          // we try it now with one or more fallback languages, if fallback language(s) is
	          // configured.
	          if ($uses && $fallbackLanguage && $fallbackLanguage.length) {
	            fallbackTranslation(translationId, interpolateParams, Interpolator, defaultTranslationText)
	                .then(function (translation) {
	                  deferred.resolve(translation);
	                }, function (_translationId) {
	                  deferred.reject(applyNotFoundIndicators(_translationId));
	                });
	          } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
	            // looks like the requested translation id doesn't exists.
	            // Now, if there is a registered handler for missing translations and no
	            // asyncLoader is pending, we execute the handler
	            if (defaultTranslationText) {
	              deferred.resolve(defaultTranslationText);
	              } else {
	                deferred.resolve(missingTranslationHandlerTranslation);
	              }
	          } else {
	            if (defaultTranslationText) {
	              deferred.resolve(defaultTranslationText);
	            } else {
	              deferred.reject(applyNotFoundIndicators(translationId));
	            }
	          }
	        }
	        return deferred.promise;
	      };
	
	      var determineTranslationInstant = function (translationId, interpolateParams, interpolationId) {
	
	        var result, table = $uses ? $translationTable[$uses] : $translationTable,
	            Interpolator = defaultInterpolator;
	
	        // if the interpolation id exists use custom interpolator
	        if (interpolatorHashMap && Object.prototype.hasOwnProperty.call(interpolatorHashMap, interpolationId)) {
	          Interpolator = interpolatorHashMap[interpolationId];
	        }
	
	        // if the translation id exists, we can just interpolate it
	        if (table && Object.prototype.hasOwnProperty.call(table, translationId)) {
	          var translation = table[translationId];
	
	          // If using link, rerun $translate with linked translationId and return it
	          if (translation.substr(0, 2) === '@:') {
	            result = determineTranslationInstant(translation.substr(2), interpolateParams, interpolationId);
	          } else {
	            result = Interpolator.interpolate(translation, interpolateParams);
	          }
	        } else {
	          var missingTranslationHandlerTranslation;
	          // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
	          if ($missingTranslationHandlerFactory && !pendingLoader) {
	            missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams);
	          }
	
	          // since we couldn't translate the inital requested translation id,
	          // we try it now with one or more fallback languages, if fallback language(s) is
	          // configured.
	          if ($uses && $fallbackLanguage && $fallbackLanguage.length) {
	            fallbackIndex = 0;
	            result = fallbackTranslationInstant(translationId, interpolateParams, Interpolator);
	          } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
	            // looks like the requested translation id doesn't exists.
	            // Now, if there is a registered handler for missing translations and no
	            // asyncLoader is pending, we execute the handler
	            result = missingTranslationHandlerTranslation;
	          } else {
	            result = applyNotFoundIndicators(translationId);
	          }
	        }
	
	        return result;
	      };
	
	      var clearNextLangAndPromise = function(key) {
	        if ($nextLang === key) {
	          $nextLang = undefined;
	        }
	        langPromises[key] = undefined;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#preferredLanguage
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns the language key for the preferred language.
	       *
	       * @param {string} langKey language String or Array to be used as preferredLanguage (changing at runtime)
	       *
	       * @return {string} preferred language key
	       */
	      $translate.preferredLanguage = function (langKey) {
	        if(langKey) {
	          setupPreferredLanguage(langKey);
	        }
	        return $preferredLanguage;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#cloakClassName
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns the configured class name for `translate-cloak` directive.
	       *
	       * @return {string} cloakClassName
	       */
	      $translate.cloakClassName = function () {
	        return $cloakClassName;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#nestedObjectDelimeter
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns the configured delimiter for nested namespaces.
	       *
	       * @return {string} nestedObjectDelimeter
	       */
	      $translate.nestedObjectDelimeter = function () {
	        return $nestedObjectDelimeter;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#fallbackLanguage
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns the language key for the fallback languages or sets a new fallback stack.
	       *
	       * @param {string=} langKey language String or Array of fallback languages to be used (to change stack at runtime)
	       *
	       * @return {string||array} fallback language key
	       */
	      $translate.fallbackLanguage = function (langKey) {
	        if (langKey !== undefined && langKey !== null) {
	          fallbackStack(langKey);
	
	          // as we might have an async loader initiated and a new translation language might have been defined
	          // we need to add the promise to the stack also. So - iterate.
	          if ($loaderFactory) {
	            if ($fallbackLanguage && $fallbackLanguage.length) {
	              for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
	                if (!langPromises[$fallbackLanguage[i]]) {
	                  langPromises[$fallbackLanguage[i]] = loadAsync($fallbackLanguage[i]);
	                }
	              }
	            }
	          }
	          $translate.use($translate.use());
	        }
	        if ($fallbackWasString) {
	          return $fallbackLanguage[0];
	        } else {
	          return $fallbackLanguage;
	        }
	
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#useFallbackLanguage
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Sets the first key of the fallback language stack to be used for translation.
	       * Therefore all languages in the fallback array BEFORE this key will be skipped!
	       *
	       * @param {string=} langKey Contains the langKey the iteration shall start with. Set to false if you want to
	       * get back to the whole stack
	       */
	      $translate.useFallbackLanguage = function (langKey) {
	        if (langKey !== undefined && langKey !== null) {
	          if (!langKey) {
	            startFallbackIteration = 0;
	          } else {
	            var langKeyPosition = indexOf($fallbackLanguage, langKey);
	            if (langKeyPosition > -1) {
	              startFallbackIteration = langKeyPosition;
	            }
	          }
	
	        }
	
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#proposedLanguage
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns the language key of language that is currently loaded asynchronously.
	       *
	       * @return {string} language key
	       */
	      $translate.proposedLanguage = function () {
	        return $nextLang;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#storage
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns registered storage.
	       *
	       * @return {object} Storage
	       */
	      $translate.storage = function () {
	        return Storage;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#use
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Tells angular-translate which language to use by given language key. This method is
	       * used to change language at runtime. It also takes care of storing the language
	       * key in a configured store to let your app remember the choosed language.
	       *
	       * When trying to 'use' a language which isn't available it tries to load it
	       * asynchronously with registered loaders.
	       *
	       * Returns promise object with loaded language file data or string of the currently used language.
	       *
	       * If no or a falsy key is given it returns the currently used language key.
	       * The returned string will be ```undefined``` if setting up $translate hasn't finished.
	       * @example
	       * $translate.use("en_US").then(function(data){
	       *   $scope.text = $translate("HELLO");
	       * });
	       *
	       * @param {string} [key] Language key
	       * @return {object|string} Promise with loaded language data or the language key if a falsy param was given.
	       */
	      $translate.use = function (key) {
	        if (!key) {
	          return $uses;
	        }
	
	        var deferred = $q.defer();
	
	        $rootScope.$emit('$translateChangeStart', {language: key});
	
	        // Try to get the aliased language key
	        var aliasedKey = negotiateLocale(key);
	        if (aliasedKey) {
	          key = aliasedKey;
	        }
	
	        // if there isn't a translation table for the language we've requested,
	        // we load it asynchronously
	        if (($forceAsyncReloadEnabled || !$translationTable[key]) && $loaderFactory && !langPromises[key]) {
	          $nextLang = key;
	          langPromises[key] = loadAsync(key).then(function (translation) {
	            translations(translation.key, translation.table);
	            deferred.resolve(translation.key);
	            if ($nextLang === key) {
	              useLanguage(translation.key);
	            }
	            return translation;
	          }, function (key) {
	            $rootScope.$emit('$translateChangeError', {language: key});
	            deferred.reject(key);
	            $rootScope.$emit('$translateChangeEnd', {language: key});
	            return $q.reject(key);
	          });
	          langPromises[key]['finally'](function () {
	            clearNextLangAndPromise(key);
	          });
	        } else if ($nextLang === key && langPromises[key]) {
	          // we are already loading this asynchronously
	          // resolve our new deferred when the old langPromise is resolved
	          langPromises[key].then(function (translation) {
	            deferred.resolve(translation.key);
	            return translation;
	          }, function (key) {
	            deferred.reject(key);
	            return $q.reject(key);
	          });
	        } else {
	          deferred.resolve(key);
	          useLanguage(key);
	        }
	
	        return deferred.promise;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#storageKey
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns the key for the storage.
	       *
	       * @return {string} storage key
	       */
	      $translate.storageKey = function () {
	        return storageKey();
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#isPostCompilingEnabled
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns whether post compiling is enabled or not
	       *
	       * @return {bool} storage key
	       */
	      $translate.isPostCompilingEnabled = function () {
	        return $postCompilingEnabled;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#isForceAsyncReloadEnabled
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns whether force async reload is enabled or not
	       *
	       * @return {boolean} forceAsyncReload value
	       */
	      $translate.isForceAsyncReloadEnabled = function () {
	        return $forceAsyncReloadEnabled;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#refresh
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Refreshes a translation table pointed by the given langKey. If langKey is not specified,
	       * the module will drop all existent translation tables and load new version of those which
	       * are currently in use.
	       *
	       * Refresh means that the module will drop target translation table and try to load it again.
	       *
	       * In case there are no loaders registered the refresh() method will throw an Error.
	       *
	       * If the module is able to refresh translation tables refresh() method will broadcast
	       * $translateRefreshStart and $translateRefreshEnd events.
	       *
	       * @example
	       * // this will drop all currently existent translation tables and reload those which are
	       * // currently in use
	       * $translate.refresh();
	       * // this will refresh a translation table for the en_US language
	       * $translate.refresh('en_US');
	       *
	       * @param {string} langKey A language key of the table, which has to be refreshed
	       *
	       * @return {promise} Promise, which will be resolved in case a translation tables refreshing
	       * process is finished successfully, and reject if not.
	       */
	      $translate.refresh = function (langKey) {
	        if (!$loaderFactory) {
	          throw new Error('Couldn\'t refresh translation table, no loader registered!');
	        }
	
	        var deferred = $q.defer();
	
	        function resolve() {
	          deferred.resolve();
	          $rootScope.$emit('$translateRefreshEnd', {language: langKey});
	        }
	
	        function reject() {
	          deferred.reject();
	          $rootScope.$emit('$translateRefreshEnd', {language: langKey});
	        }
	
	        $rootScope.$emit('$translateRefreshStart', {language: langKey});
	
	        if (!langKey) {
	          // if there's no language key specified we refresh ALL THE THINGS!
	          var tables = [], loadingKeys = {};
	
	          // reload registered fallback languages
	          if ($fallbackLanguage && $fallbackLanguage.length) {
	            for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
	              tables.push(loadAsync($fallbackLanguage[i]));
	              loadingKeys[$fallbackLanguage[i]] = true;
	            }
	          }
	
	          // reload currently used language
	          if ($uses && !loadingKeys[$uses]) {
	            tables.push(loadAsync($uses));
	          }
	
	          var allTranslationsLoaded = function (tableData) {
	            $translationTable = {};
	            angular.forEach(tableData, function (data) {
	              translations(data.key, data.table);
	            });
	            if ($uses) {
	              useLanguage($uses);
	            }
	            resolve();
	          };
	          allTranslationsLoaded.displayName = 'refreshPostProcessor';
	
	          $q.all(tables).then(allTranslationsLoaded, reject);
	
	        } else if ($translationTable[langKey]) {
	
	          var oneTranslationsLoaded = function (data) {
	            translations(data.key, data.table);
	            if (langKey === $uses) {
	              useLanguage($uses);
	            }
	            resolve();
	          };
	          oneTranslationsLoaded.displayName = 'refreshPostProcessor';
	
	          loadAsync(langKey).then(oneTranslationsLoaded, reject);
	
	        } else {
	          reject();
	        }
	        return deferred.promise;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#instant
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns a translation instantly from the internal state of loaded translation. All rules
	       * regarding the current language, the preferred language of even fallback languages will be
	       * used except any promise handling. If a language was not found, an asynchronous loading
	       * will be invoked in the background.
	       *
	       * @param {string|array} translationId A token which represents a translation id
	       *                                     This can be optionally an array of translation ids which
	       *                                     results that the function's promise returns an object where
	       *                                     each key is the translation id and the value the translation.
	       * @param {object} interpolateParams Params
	       * @param {string} interpolationId The id of the interpolation to use
	       *
	       * @return {string|object} translation
	       */
	      $translate.instant = function (translationId, interpolateParams, interpolationId) {
	
	        // Detect undefined and null values to shorten the execution and prevent exceptions
	        if (translationId === null || angular.isUndefined(translationId)) {
	          return translationId;
	        }
	
	        // Duck detection: If the first argument is an array, a bunch of translations was requested.
	        // The result is an object.
	        if (angular.isArray(translationId)) {
	          var results = {};
	          for (var i = 0, c = translationId.length; i < c; i++) {
	            results[translationId[i]] = $translate.instant(translationId[i], interpolateParams, interpolationId);
	          }
	          return results;
	        }
	
	        // We discarded unacceptable values. So we just need to verify if translationId is empty String
	        if (angular.isString(translationId) && translationId.length < 1) {
	          return translationId;
	        }
	
	        // trim off any whitespace
	        if (translationId) {
	          translationId = trim.apply(translationId);
	        }
	
	        var result, possibleLangKeys = [];
	        if ($preferredLanguage) {
	          possibleLangKeys.push($preferredLanguage);
	        }
	        if ($uses) {
	          possibleLangKeys.push($uses);
	        }
	        if ($fallbackLanguage && $fallbackLanguage.length) {
	          possibleLangKeys = possibleLangKeys.concat($fallbackLanguage);
	        }
	        for (var j = 0, d = possibleLangKeys.length; j < d; j++) {
	          var possibleLangKey = possibleLangKeys[j];
	          if ($translationTable[possibleLangKey]) {
	            if (typeof $translationTable[possibleLangKey][translationId] !== 'undefined') {
	              result = determineTranslationInstant(translationId, interpolateParams, interpolationId);
	            } else if ($notFoundIndicatorLeft || $notFoundIndicatorRight) {
	              result = applyNotFoundIndicators(translationId);
	            }
	          }
	          if (typeof result !== 'undefined') {
	            break;
	          }
	        }
	
	        if (!result && result !== '') {
	          // Return translation of default interpolator if not found anything.
	          result = defaultInterpolator.interpolate(translationId, interpolateParams);
	          if ($missingTranslationHandlerFactory && !pendingLoader) {
	            result = translateByHandler(translationId, interpolateParams);
	          }
	        }
	
	        return result;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#versionInfo
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns the current version information for the angular-translate library
	       *
	       * @return {string} angular-translate version
	       */
	      $translate.versionInfo = function () {
	        return version;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#loaderCache
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns the defined loaderCache.
	       *
	       * @return {boolean|string|object} current value of loaderCache
	       */
	      $translate.loaderCache = function () {
	        return loaderCache;
	      };
	
	      // internal purpose only
	      $translate.directivePriority = function () {
	        return directivePriority;
	      };
	
	      // internal purpose only
	      $translate.statefulFilter = function () {
	        return statefulFilter;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#isReady
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns whether the service is "ready" to translate (i.e. loading 1st language).
	       *
	       * See also {@link pascalprecht.translate.$translate#methods_onReady onReady()}.
	       *
	       * @return {boolean} current value of ready
	       */
	      $translate.isReady = function () {
	        return $isReady;
	      };
	
	      var $onReadyDeferred = $q.defer();
	      $onReadyDeferred.promise.then(function () {
	        $isReady = true;
	      });
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#onReady
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns whether the service is "ready" to translate (i.e. loading 1st language).
	       *
	       * See also {@link pascalprecht.translate.$translate#methods_isReady isReady()}.
	       *
	       * @param {Function=} fn Function to invoke when service is ready
	       * @return {object} Promise resolved when service is ready
	       */
	      $translate.onReady = function (fn) {
	        var deferred = $q.defer();
	        if (angular.isFunction(fn)) {
	          deferred.promise.then(fn);
	        }
	        if ($isReady) {
	          deferred.resolve();
	        } else {
	          $onReadyDeferred.promise.then(deferred.resolve);
	        }
	        return deferred.promise;
	      };
	
	      // Whenever $translateReady is being fired, this will ensure the state of $isReady
	      var globalOnReadyListener = $rootScope.$on('$translateReady', function () {
	        $onReadyDeferred.resolve();
	        globalOnReadyListener(); // one time only
	        globalOnReadyListener = null;
	      });
	      var globalOnChangeListener = $rootScope.$on('$translateChangeEnd', function () {
	        $onReadyDeferred.resolve();
	        globalOnChangeListener(); // one time only
	        globalOnChangeListener = null;
	      });
	
	      if ($loaderFactory) {
	
	        // If at least one async loader is defined and there are no
	        // (default) translations available we should try to load them.
	        if (angular.equals($translationTable, {})) {
	          if ($translate.use()) {
	            $translate.use($translate.use());
	          }
	        }
	
	        // Also, if there are any fallback language registered, we start
	        // loading them asynchronously as soon as we can.
	        if ($fallbackLanguage && $fallbackLanguage.length) {
	          var processAsyncResult = function (translation) {
	            translations(translation.key, translation.table);
	            $rootScope.$emit('$translateChangeEnd', { language: translation.key });
	            return translation;
	          };
	          for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
	            var fallbackLanguageId = $fallbackLanguage[i];
	            if ($forceAsyncReloadEnabled || !$translationTable[fallbackLanguageId]) {
	              langPromises[fallbackLanguageId] = loadAsync(fallbackLanguageId).then(processAsyncResult);
	            }
	          }
	        }
	      } else {
	        $rootScope.$emit('$translateReady', { language: $translate.use() });
	      }
	
	      return $translate;
	    }
	  ];
	}
	$translate.$inject = ['$STORAGE_KEY', '$windowProvider', '$translateSanitizationProvider', 'pascalprechtTranslateOverrider'];
	
	$translate.displayName = 'displayName';
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateDefaultInterpolation
	 * @requires $interpolate
	 *
	 * @description
	 * Uses angular's `$interpolate` services to interpolate strings against some values.
	 *
	 * Be aware to configure a proper sanitization strategy.
	 *
	 * See also:
	 * * {@link pascalprecht.translate.$translateSanitization}
	 *
	 * @return {object} $translateDefaultInterpolation Interpolator service
	 */
	angular.module('pascalprecht.translate').factory('$translateDefaultInterpolation', $translateDefaultInterpolation);
	
	function $translateDefaultInterpolation ($interpolate, $translateSanitization) {
	
	  'use strict';
	
	  var $translateInterpolator = {},
	      $locale,
	      $identifier = 'default';
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#setLocale
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Sets current locale (this is currently not use in this interpolation).
	   *
	   * @param {string} locale Language key or locale.
	   */
	  $translateInterpolator.setLocale = function (locale) {
	    $locale = locale;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#getInterpolationIdentifier
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Returns an identifier for this interpolation service.
	   *
	   * @returns {string} $identifier
	   */
	  $translateInterpolator.getInterpolationIdentifier = function () {
	    return $identifier;
	  };
	
	  /**
	   * @deprecated will be removed in 3.0
	   * @see {@link pascalprecht.translate.$translateSanitization}
	   */
	  $translateInterpolator.useSanitizeValueStrategy = function (value) {
	    $translateSanitization.useStrategy(value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#interpolate
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Interpolates given string agains given interpolate params using angulars
	   * `$interpolate` service.
	   *
	   * @returns {string} interpolated string.
	   */
	  $translateInterpolator.interpolate = function (string, interpolationParams) {
	    interpolationParams = interpolationParams || {};
	    interpolationParams = $translateSanitization.sanitize(interpolationParams, 'params');
	
	    var interpolatedText = $interpolate(string)(interpolationParams);
	    interpolatedText = $translateSanitization.sanitize(interpolatedText, 'text');
	
	    return interpolatedText;
	  };
	
	  return $translateInterpolator;
	}
	$translateDefaultInterpolation.$inject = ['$interpolate', '$translateSanitization'];
	
	$translateDefaultInterpolation.displayName = '$translateDefaultInterpolation';
	
	angular.module('pascalprecht.translate').constant('$STORAGE_KEY', 'NG_TRANSLATE_LANG_KEY');
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translate
	 * @requires $compile
	 * @requires $filter
	 * @requires $interpolate
	 * @restrict A
	 *
	 * @description
	 * Translates given translation id either through attribute or DOM content.
	 * Internally it uses `translate` filter to translate translation id. It possible to
	 * pass an optional `translate-values` object literal as string into translation id.
	 *
	 * @param {string=} translate Translation id which could be either string or interpolated string.
	 * @param {string=} translate-values Values to pass into translation id. Can be passed as object literal string or interpolated object.
	 * @param {string=} translate-attr-ATTR translate Translation id and put it into ATTR attribute.
	 * @param {string=} translate-default will be used unless translation was successful
	 * @param {boolean=} translate-compile (default true if present) defines locally activation of {@link pascalprecht.translate.$translateProvider#methods_usePostCompiling}
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div ng-controller="TranslateCtrl">
	
	        <pre translate="TRANSLATION_ID"></pre>
	        <pre translate>TRANSLATION_ID</pre>
	        <pre translate translate-attr-title="TRANSLATION_ID"></pre>
	        <pre translate="{{translationId}}"></pre>
	        <pre translate>{{translationId}}</pre>
	        <pre translate="WITH_VALUES" translate-values="{value: 5}"></pre>
	        <pre translate translate-values="{value: 5}">WITH_VALUES</pre>
	        <pre translate="WITH_VALUES" translate-values="{{values}}"></pre>
	        <pre translate translate-values="{{values}}">WITH_VALUES</pre>
	        <pre translate translate-attr-title="WITH_VALUES" translate-values="{{values}}"></pre>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en',{
	          'TRANSLATION_ID': 'Hello there!',
	          'WITH_VALUES': 'The following value is dynamic: {{value}}'
	        }).preferredLanguage('en');
	
	      });
	
	      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	        $scope.translationId = 'TRANSLATION_ID';
	
	        $scope.values = {
	          value: 78
	        };
	      });
	    </file>
	    <file name="scenario.js">
	      it('should translate', function () {
	        inject(function ($rootScope, $compile) {
	          $rootScope.translationId = 'TRANSLATION_ID';
	
	          element = $compile('<p translate="TRANSLATION_ID"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate="{{translationId}}"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate>TRANSLATION_ID</p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate>{{translationId}}</p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate translate-attr-title="TRANSLATION_ID"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.attr('title')).toBe('Hello there!');
	        });
	      });
	    </file>
	   </example>
	 */
	.directive('translate', translateDirective);
	function translateDirective($translate, $q, $interpolate, $compile, $parse, $rootScope) {
	
	  'use strict';
	
	  /**
	   * @name trim
	   * @private
	   *
	   * @description
	   * trim polyfill
	   *
	   * @returns {string} The string stripped of whitespace from both ends
	   */
	  var trim = function() {
	    return this.toString().replace(/^\s+|\s+$/g, '');
	  };
	
	  return {
	    restrict: 'AE',
	    scope: true,
	    priority: $translate.directivePriority(),
	    compile: function (tElement, tAttr) {
	
	      var translateValuesExist = (tAttr.translateValues) ?
	        tAttr.translateValues : undefined;
	
	      var translateInterpolation = (tAttr.translateInterpolation) ?
	        tAttr.translateInterpolation : undefined;
	
	      var translateValueExist = tElement[0].outerHTML.match(/translate-value-+/i);
	
	      var interpolateRegExp = '^(.*)(' + $interpolate.startSymbol() + '.*' + $interpolate.endSymbol() + ')(.*)',
	          watcherRegExp = '^(.*)' + $interpolate.startSymbol() + '(.*)' + $interpolate.endSymbol() + '(.*)';
	
	      return function linkFn(scope, iElement, iAttr) {
	
	        scope.interpolateParams = {};
	        scope.preText = '';
	        scope.postText = '';
	        scope.translateNamespace = getTranslateNamespace(scope);
	        var translationIds = {};
	
	        var initInterpolationParams = function (interpolateParams, iAttr, tAttr) {
	          // initial setup
	          if (iAttr.translateValues) {
	            angular.extend(interpolateParams, $parse(iAttr.translateValues)(scope.$parent));
	          }
	          // initially fetch all attributes if existing and fill the params
	          if (translateValueExist) {
	            for (var attr in tAttr) {
	              if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
	                var attributeName = angular.lowercase(attr.substr(14, 1)) + attr.substr(15);
	                interpolateParams[attributeName] = tAttr[attr];
	              }
	            }
	          }
	        };
	
	        // Ensures any change of the attribute "translate" containing the id will
	        // be re-stored to the scope's "translationId".
	        // If the attribute has no content, the element's text value (white spaces trimmed off) will be used.
	        var observeElementTranslation = function (translationId) {
	
	          // Remove any old watcher
	          if (angular.isFunction(observeElementTranslation._unwatchOld)) {
	            observeElementTranslation._unwatchOld();
	            observeElementTranslation._unwatchOld = undefined;
	          }
	
	          if (angular.equals(translationId , '') || !angular.isDefined(translationId)) {
	            var iElementText = trim.apply(iElement.text());
	
	            // Resolve translation id by inner html if required
	            var interpolateMatches = iElementText.match(interpolateRegExp);
	            // Interpolate translation id if required
	            if (angular.isArray(interpolateMatches)) {
	              scope.preText = interpolateMatches[1];
	              scope.postText = interpolateMatches[3];
	              translationIds.translate = $interpolate(interpolateMatches[2])(scope.$parent);
	              var watcherMatches = iElementText.match(watcherRegExp);
	              if (angular.isArray(watcherMatches) && watcherMatches[2] && watcherMatches[2].length) {
	                observeElementTranslation._unwatchOld = scope.$watch(watcherMatches[2], function (newValue) {
	                  translationIds.translate = newValue;
	                  updateTranslations();
	                });
	              }
	            } else {
	              translationIds.translate = iElementText;
	            }
	          } else {
	            translationIds.translate = translationId;
	          }
	          updateTranslations();
	        };
	
	        var observeAttributeTranslation = function (translateAttr) {
	          iAttr.$observe(translateAttr, function (translationId) {
	            translationIds[translateAttr] = translationId;
	            updateTranslations();
	          });
	        };
	
	        // initial setup with values
	        initInterpolationParams(scope.interpolateParams, iAttr, tAttr);
	
	        var firstAttributeChangedEvent = true;
	        iAttr.$observe('translate', function (translationId) {
	          if (typeof translationId === 'undefined') {
	            // case of element "<translate>xyz</translate>"
	            observeElementTranslation('');
	          } else {
	            // case of regular attribute
	            if (translationId !== '' || !firstAttributeChangedEvent) {
	              translationIds.translate = translationId;
	              updateTranslations();
	            }
	          }
	          firstAttributeChangedEvent = false;
	        });
	
	        for (var translateAttr in iAttr) {
	          if (iAttr.hasOwnProperty(translateAttr) && translateAttr.substr(0, 13) === 'translateAttr') {
	            observeAttributeTranslation(translateAttr);
	          }
	        }
	
	        iAttr.$observe('translateDefault', function (value) {
	          scope.defaultText = value;
	        });
	
	        if (translateValuesExist) {
	          iAttr.$observe('translateValues', function (interpolateParams) {
	            if (interpolateParams) {
	              scope.$parent.$watch(function () {
	                angular.extend(scope.interpolateParams, $parse(interpolateParams)(scope.$parent));
	              });
	            }
	          });
	        }
	
	        if (translateValueExist) {
	          var observeValueAttribute = function (attrName) {
	            iAttr.$observe(attrName, function (value) {
	              var attributeName = angular.lowercase(attrName.substr(14, 1)) + attrName.substr(15);
	              scope.interpolateParams[attributeName] = value;
	            });
	          };
	          for (var attr in iAttr) {
	            if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
	              observeValueAttribute(attr);
	            }
	          }
	        }
	
	        // Master update function
	        var updateTranslations = function () {
	          for (var key in translationIds) {
	
	            if (translationIds.hasOwnProperty(key) && translationIds[key] !== undefined) {
	              updateTranslation(key, translationIds[key], scope, scope.interpolateParams, scope.defaultText, scope.translateNamespace);
	            }
	          }
	        };
	
	        // Put translation processing function outside loop
	        var updateTranslation = function(translateAttr, translationId, scope, interpolateParams, defaultTranslationText, translateNamespace) {
	          if (translationId) {
	            // if translation id starts with '.' and translateNamespace given, prepend namespace
	            if (translateNamespace && translationId.charAt(0) === '.') {
	              translationId = translateNamespace + translationId;
	            }
	
	            $translate(translationId, interpolateParams, translateInterpolation, defaultTranslationText)
	              .then(function (translation) {
	                applyTranslation(translation, scope, true, translateAttr);
	              }, function (translationId) {
	                applyTranslation(translationId, scope, false, translateAttr);
	              });
	          } else {
	            // as an empty string cannot be translated, we can solve this using successful=false
	            applyTranslation(translationId, scope, false, translateAttr);
	          }
	        };
	
	        var applyTranslation = function (value, scope, successful, translateAttr) {
	          if (translateAttr === 'translate') {
	            // default translate into innerHTML
	            if (!successful && typeof scope.defaultText !== 'undefined') {
	              value = scope.defaultText;
	            }
	            iElement.empty().append(scope.preText + value + scope.postText);
	            var globallyEnabled = $translate.isPostCompilingEnabled();
	            var locallyDefined = typeof tAttr.translateCompile !== 'undefined';
	            var locallyEnabled = locallyDefined && tAttr.translateCompile !== 'false';
	            if ((globallyEnabled && !locallyDefined) || locallyEnabled) {
	              $compile(iElement.contents())(scope);
	            }
	          } else {
	            // translate attribute
	            if (!successful && typeof scope.defaultText !== 'undefined') {
	              value = scope.defaultText;
	            }
	            var attributeName = iAttr.$attr[translateAttr];
	            if (attributeName.substr(0, 5) === 'data-') {
	              // ensure html5 data prefix is stripped
	              attributeName = attributeName.substr(5);
	            }
	            attributeName = attributeName.substr(15);
	            iElement.attr(attributeName, value);
	          }
	        };
	
	        if (translateValuesExist || translateValueExist || iAttr.translateDefault) {
	          scope.$watch('interpolateParams', updateTranslations, true);
	        }
	
	        // Ensures the text will be refreshed after the current language was changed
	        // w/ $translate.use(...)
	        var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);
	
	        // ensure translation will be looked up at least one
	        if (iElement.text().length) {
	          if (iAttr.translate) {
	            observeElementTranslation(iAttr.translate);
	          } else {
	            observeElementTranslation('');
	          }
	        } else if (iAttr.translate) {
	          // ensure attribute will be not skipped
	          observeElementTranslation(iAttr.translate);
	        }
	        updateTranslations();
	        scope.$on('$destroy', unbind);
	      };
	    }
	  };
	}
	translateDirective.$inject = ['$translate', '$q', '$interpolate', '$compile', '$parse', '$rootScope'];
	
	/**
	 * Returns the scope's namespace.
	 * @private
	 * @param scope
	 * @returns {string}
	 */
	function getTranslateNamespace(scope) {
	  'use strict';
	  if (scope.translateNamespace) {
	    return scope.translateNamespace;
	  }
	  if (scope.$parent) {
	    return getTranslateNamespace(scope.$parent);
	  }
	}
	
	translateDirective.displayName = 'translateDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translateCloak
	 * @requires $rootScope
	 * @requires $translate
	 * @restrict A
	 *
	 * $description
	 * Adds a `translate-cloak` class name to the given element where this directive
	 * is applied initially and removes it, once a loader has finished loading.
	 *
	 * This directive can be used to prevent initial flickering when loading translation
	 * data asynchronously.
	 *
	 * The class name is defined in
	 * {@link pascalprecht.translate.$translateProvider#cloakClassName $translate.cloakClassName()}.
	 *
	 * @param {string=} translate-cloak If a translationId is provided, it will be used for showing
	 *                                  or hiding the cloak. Basically it relies on the translation
	 *                                  resolve.
	 */
	.directive('translateCloak', translateCloakDirective);
	
	function translateCloakDirective($translate) {
	
	  'use strict';
	
	  return {
	    compile: function (tElement) {
	      var applyCloak = function () {
	        tElement.addClass($translate.cloakClassName());
	      },
	      removeCloak = function () {
	        tElement.removeClass($translate.cloakClassName());
	      };
	      $translate.onReady(function () {
	        removeCloak();
	      });
	      applyCloak();
	
	      return function linkFn(scope, iElement, iAttr) {
	        // Register a watcher for the defined translation allowing a fine tuned cloak
	        if (iAttr.translateCloak && iAttr.translateCloak.length) {
	          iAttr.$observe('translateCloak', function (translationId) {
	            $translate(translationId).then(removeCloak, applyCloak);
	          });
	        }
	      };
	    }
	  };
	}
	translateCloakDirective.$inject = ['$translate'];
	
	translateCloakDirective.displayName = 'translateCloakDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translateNamespace
	 * @restrict A
	 *
	 * @description
	 * Translates given translation id either through attribute or DOM content.
	 * Internally it uses `translate` filter to translate translation id. It possible to
	 * pass an optional `translate-values` object literal as string into translation id.
	 *
	 * @param {string=} translate namespace name which could be either string or interpolated string.
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div translate-namespace="CONTENT">
	
	        <div>
	            <h1 translate>.HEADERS.TITLE</h1>
	            <h1 translate>.HEADERS.WELCOME</h1>
	        </div>
	
	        <div translate-namespace=".HEADERS">
	            <h1 translate>.TITLE</h1>
	            <h1 translate>.WELCOME</h1>
	        </div>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en',{
	          'TRANSLATION_ID': 'Hello there!',
	          'CONTENT': {
	            'HEADERS': {
	                TITLE: 'Title'
	            }
	          },
	          'CONTENT.HEADERS.WELCOME': 'Welcome'
	        }).preferredLanguage('en');
	
	      });
	
	    </file>
	   </example>
	 */
	.directive('translateNamespace', translateNamespaceDirective);
	
	function translateNamespaceDirective() {
	
	  'use strict';
	
	  return {
	    restrict: 'A',
	    scope: true,
	    compile: function () {
	      return {
	        pre: function (scope, iElement, iAttrs) {
	          scope.translateNamespace = getTranslateNamespace(scope);
	
	          if (scope.translateNamespace && iAttrs.translateNamespace.charAt(0) === '.') {
	            scope.translateNamespace += iAttrs.translateNamespace;
	          } else {
	            scope.translateNamespace = iAttrs.translateNamespace;
	          }
	        }
	      };
	    }
	  };
	}
	
	/**
	 * Returns the scope's namespace.
	 * @private
	 * @param scope
	 * @returns {string}
	 */
	function getTranslateNamespace(scope) {
	  'use strict';
	  if (scope.translateNamespace) {
	    return scope.translateNamespace;
	  }
	  if (scope.$parent) {
	    return getTranslateNamespace(scope.$parent);
	  }
	}
	
	translateNamespaceDirective.displayName = 'translateNamespaceDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc filter
	 * @name pascalprecht.translate.filter:translate
	 * @requires $parse
	 * @requires pascalprecht.translate.$translate
	 * @function
	 *
	 * @description
	 * Uses `$translate` service to translate contents. Accepts interpolate parameters
	 * to pass dynamized values though translation.
	 *
	 * @param {string} translationId A translation id to be translated.
	 * @param {*=} interpolateParams Optional object literal (as hash or string) to pass values into translation.
	 *
	 * @returns {string} Translated text.
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div ng-controller="TranslateCtrl">
	
	        <pre>{{ 'TRANSLATION_ID' | translate }}</pre>
	        <pre>{{ translationId | translate }}</pre>
	        <pre>{{ 'WITH_VALUES' | translate:'{value: 5}' }}</pre>
	        <pre>{{ 'WITH_VALUES' | translate:values }}</pre>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en', {
	          'TRANSLATION_ID': 'Hello there!',
	          'WITH_VALUES': 'The following value is dynamic: {{value}}'
	        });
	        $translateProvider.preferredLanguage('en');
	
	      });
	
	      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	        $scope.translationId = 'TRANSLATION_ID';
	
	        $scope.values = {
	          value: 78
	        };
	      });
	    </file>
	   </example>
	 */
	.filter('translate', translateFilterFactory);
	
	function translateFilterFactory($parse, $translate) {
	
	  'use strict';
	
	  var translateFilter = function (translationId, interpolateParams, interpolation) {
	
	    if (!angular.isObject(interpolateParams)) {
	      interpolateParams = $parse(interpolateParams)(this);
	    }
	
	    return $translate.instant(translationId, interpolateParams, interpolation);
	  };
	
	  if ($translate.statefulFilter()) {
	    translateFilter.$stateful = true;
	  }
	
	  return translateFilter;
	}
	translateFilterFactory.$inject = ['$parse', '$translate'];
	
	translateFilterFactory.displayName = 'translateFilterFactory';
	
	angular.module('pascalprecht.translate')
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translationCache
	 * @requires $cacheFactory
	 *
	 * @description
	 * The first time a translation table is used, it is loaded in the translation cache for quick retrieval. You
	 * can load translation tables directly into the cache by consuming the
	 * `$translationCache` service directly.
	 *
	 * @return {object} $cacheFactory object.
	 */
	  .factory('$translationCache', $translationCache);
	
	function $translationCache($cacheFactory) {
	
	  'use strict';
	
	  return $cacheFactory('translations');
	}
	$translationCache.$inject = ['$cacheFactory'];
	
	$translationCache.displayName = '$translationCache';
	return 'pascalprecht.translate';
	
	}));


/***/ }),

/***/ 7:
/***/ (function(module, exports) {

	/**
	 * State-based routing for AngularJS
	 * @version v0.4.2
	 * @link http://angular-ui.github.com/
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	
	/* commonjs package manager support (eg componentjs) */
	if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports){
	  module.exports = 'ui.router';
	}
	
	(function (window, angular, undefined) {
	/*jshint globalstrict:true*/
	/*global angular:false*/
	'use strict';
	
	var isDefined = angular.isDefined,
	    isFunction = angular.isFunction,
	    isString = angular.isString,
	    isObject = angular.isObject,
	    isArray = angular.isArray,
	    forEach = angular.forEach,
	    extend = angular.extend,
	    copy = angular.copy,
	    toJson = angular.toJson;
	
	function inherit(parent, extra) {
	  return extend(new (extend(function() {}, { prototype: parent }))(), extra);
	}
	
	function merge(dst) {
	  forEach(arguments, function(obj) {
	    if (obj !== dst) {
	      forEach(obj, function(value, key) {
	        if (!dst.hasOwnProperty(key)) dst[key] = value;
	      });
	    }
	  });
	  return dst;
	}
	
	/**
	 * Finds the common ancestor path between two states.
	 *
	 * @param {Object} first The first state.
	 * @param {Object} second The second state.
	 * @return {Array} Returns an array of state names in descending order, not including the root.
	 */
	function ancestors(first, second) {
	  var path = [];
	
	  for (var n in first.path) {
	    if (first.path[n] !== second.path[n]) break;
	    path.push(first.path[n]);
	  }
	  return path;
	}
	
	/**
	 * IE8-safe wrapper for `Object.keys()`.
	 *
	 * @param {Object} object A JavaScript object.
	 * @return {Array} Returns the keys of the object as an array.
	 */
	function objectKeys(object) {
	  if (Object.keys) {
	    return Object.keys(object);
	  }
	  var result = [];
	
	  forEach(object, function(val, key) {
	    result.push(key);
	  });
	  return result;
	}
	
	/**
	 * IE8-safe wrapper for `Array.prototype.indexOf()`.
	 *
	 * @param {Array} array A JavaScript array.
	 * @param {*} value A value to search the array for.
	 * @return {Number} Returns the array index value of `value`, or `-1` if not present.
	 */
	function indexOf(array, value) {
	  if (Array.prototype.indexOf) {
	    return array.indexOf(value, Number(arguments[2]) || 0);
	  }
	  var len = array.length >>> 0, from = Number(arguments[2]) || 0;
	  from = (from < 0) ? Math.ceil(from) : Math.floor(from);
	
	  if (from < 0) from += len;
	
	  for (; from < len; from++) {
	    if (from in array && array[from] === value) return from;
	  }
	  return -1;
	}
	
	/**
	 * Merges a set of parameters with all parameters inherited between the common parents of the
	 * current state and a given destination state.
	 *
	 * @param {Object} currentParams The value of the current state parameters ($stateParams).
	 * @param {Object} newParams The set of parameters which will be composited with inherited params.
	 * @param {Object} $current Internal definition of object representing the current state.
	 * @param {Object} $to Internal definition of object representing state to transition to.
	 */
	function inheritParams(currentParams, newParams, $current, $to) {
	  var parents = ancestors($current, $to), parentParams, inherited = {}, inheritList = [];
	
	  for (var i in parents) {
	    if (!parents[i] || !parents[i].params) continue;
	    parentParams = objectKeys(parents[i].params);
	    if (!parentParams.length) continue;
	
	    for (var j in parentParams) {
	      if (indexOf(inheritList, parentParams[j]) >= 0) continue;
	      inheritList.push(parentParams[j]);
	      inherited[parentParams[j]] = currentParams[parentParams[j]];
	    }
	  }
	  return extend({}, inherited, newParams);
	}
	
	/**
	 * Performs a non-strict comparison of the subset of two objects, defined by a list of keys.
	 *
	 * @param {Object} a The first object.
	 * @param {Object} b The second object.
	 * @param {Array} keys The list of keys within each object to compare. If the list is empty or not specified,
	 *                     it defaults to the list of keys in `a`.
	 * @return {Boolean} Returns `true` if the keys match, otherwise `false`.
	 */
	function equalForKeys(a, b, keys) {
	  if (!keys) {
	    keys = [];
	    for (var n in a) keys.push(n); // Used instead of Object.keys() for IE8 compatibility
	  }
	
	  for (var i=0; i<keys.length; i++) {
	    var k = keys[i];
	    if (a[k] != b[k]) return false; // Not '===', values aren't necessarily normalized
	  }
	  return true;
	}
	
	/**
	 * Returns the subset of an object, based on a list of keys.
	 *
	 * @param {Array} keys
	 * @param {Object} values
	 * @return {Boolean} Returns a subset of `values`.
	 */
	function filterByKeys(keys, values) {
	  var filtered = {};
	
	  forEach(keys, function (name) {
	    filtered[name] = values[name];
	  });
	  return filtered;
	}
	
	// like _.indexBy
	// when you know that your index values will be unique, or you want last-one-in to win
	function indexBy(array, propName) {
	  var result = {};
	  forEach(array, function(item) {
	    result[item[propName]] = item;
	  });
	  return result;
	}
	
	// extracted from underscore.js
	// Return a copy of the object only containing the whitelisted properties.
	function pick(obj) {
	  var copy = {};
	  var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
	  forEach(keys, function(key) {
	    if (key in obj) copy[key] = obj[key];
	  });
	  return copy;
	}
	
	// extracted from underscore.js
	// Return a copy of the object omitting the blacklisted properties.
	function omit(obj) {
	  var copy = {};
	  var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
	  for (var key in obj) {
	    if (indexOf(keys, key) == -1) copy[key] = obj[key];
	  }
	  return copy;
	}
	
	function pluck(collection, key) {
	  var result = isArray(collection) ? [] : {};
	
	  forEach(collection, function(val, i) {
	    result[i] = isFunction(key) ? key(val) : val[key];
	  });
	  return result;
	}
	
	function filter(collection, callback) {
	  var array = isArray(collection);
	  var result = array ? [] : {};
	  forEach(collection, function(val, i) {
	    if (callback(val, i)) {
	      result[array ? result.length : i] = val;
	    }
	  });
	  return result;
	}
	
	function map(collection, callback) {
	  var result = isArray(collection) ? [] : {};
	
	  forEach(collection, function(val, i) {
	    result[i] = callback(val, i);
	  });
	  return result;
	}
	
	// issue #2676 #2889
	function silenceUncaughtInPromise (promise) {
	  return promise.then(undefined, function() {}) && promise;
	}
	
	/**
	 * @ngdoc overview
	 * @name ui.router.util
	 *
	 * @description
	 * # ui.router.util sub-module
	 *
	 * This module is a dependency of other sub-modules. Do not include this module as a dependency
	 * in your angular app (use {@link ui.router} module instead).
	 *
	 */
	angular.module('ui.router.util', ['ng']);
	
	/**
	 * @ngdoc overview
	 * @name ui.router.router
	 * 
	 * @requires ui.router.util
	 *
	 * @description
	 * # ui.router.router sub-module
	 *
	 * This module is a dependency of other sub-modules. Do not include this module as a dependency
	 * in your angular app (use {@link ui.router} module instead).
	 */
	angular.module('ui.router.router', ['ui.router.util']);
	
	/**
	 * @ngdoc overview
	 * @name ui.router.state
	 * 
	 * @requires ui.router.router
	 * @requires ui.router.util
	 *
	 * @description
	 * # ui.router.state sub-module
	 *
	 * This module is a dependency of the main ui.router module. Do not include this module as a dependency
	 * in your angular app (use {@link ui.router} module instead).
	 * 
	 */
	angular.module('ui.router.state', ['ui.router.router', 'ui.router.util']);
	
	/**
	 * @ngdoc overview
	 * @name ui.router
	 *
	 * @requires ui.router.state
	 *
	 * @description
	 * # ui.router
	 * 
	 * ## The main module for ui.router 
	 * There are several sub-modules included with the ui.router module, however only this module is needed
	 * as a dependency within your angular app. The other modules are for organization purposes. 
	 *
	 * The modules are:
	 * * ui.router - the main "umbrella" module
	 * * ui.router.router - 
	 * 
	 * *You'll need to include **only** this module as the dependency within your angular app.*
	 * 
	 * <pre>
	 * <!doctype html>
	 * <html ng-app="myApp">
	 * <head>
	 *   <script src="js/angular.js"></script>
	 *   <!-- Include the ui-router script -->
	 *   <script src="js/angular-ui-router.min.js"></script>
	 *   <script>
	 *     // ...and add 'ui.router' as a dependency
	 *     var myApp = angular.module('myApp', ['ui.router']);
	 *   </script>
	 * </head>
	 * <body>
	 * </body>
	 * </html>
	 * </pre>
	 */
	angular.module('ui.router', ['ui.router.state']);
	
	angular.module('ui.router.compat', ['ui.router']);
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.$resolve
	 *
	 * @requires $q
	 * @requires $injector
	 *
	 * @description
	 * Manages resolution of (acyclic) graphs of promises.
	 */
	$Resolve.$inject = ['$q', '$injector'];
	function $Resolve(  $q,    $injector) {
	  
	  var VISIT_IN_PROGRESS = 1,
	      VISIT_DONE = 2,
	      NOTHING = {},
	      NO_DEPENDENCIES = [],
	      NO_LOCALS = NOTHING,
	      NO_PARENT = extend($q.when(NOTHING), { $$promises: NOTHING, $$values: NOTHING });
	  
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$resolve#study
	   * @methodOf ui.router.util.$resolve
	   *
	   * @description
	   * Studies a set of invocables that are likely to be used multiple times.
	   * <pre>
	   * $resolve.study(invocables)(locals, parent, self)
	   * </pre>
	   * is equivalent to
	   * <pre>
	   * $resolve.resolve(invocables, locals, parent, self)
	   * </pre>
	   * but the former is more efficient (in fact `resolve` just calls `study` 
	   * internally).
	   *
	   * @param {object} invocables Invocable objects
	   * @return {function} a function to pass in locals, parent and self
	   */
	  this.study = function (invocables) {
	    if (!isObject(invocables)) throw new Error("'invocables' must be an object");
	    var invocableKeys = objectKeys(invocables || {});
	    
	    // Perform a topological sort of invocables to build an ordered plan
	    var plan = [], cycle = [], visited = {};
	    function visit(value, key) {
	      if (visited[key] === VISIT_DONE) return;
	      
	      cycle.push(key);
	      if (visited[key] === VISIT_IN_PROGRESS) {
	        cycle.splice(0, indexOf(cycle, key));
	        throw new Error("Cyclic dependency: " + cycle.join(" -> "));
	      }
	      visited[key] = VISIT_IN_PROGRESS;
	      
	      if (isString(value)) {
	        plan.push(key, [ function() { return $injector.get(value); }], NO_DEPENDENCIES);
	      } else {
	        var params = $injector.annotate(value);
	        forEach(params, function (param) {
	          if (param !== key && invocables.hasOwnProperty(param)) visit(invocables[param], param);
	        });
	        plan.push(key, value, params);
	      }
	      
	      cycle.pop();
	      visited[key] = VISIT_DONE;
	    }
	    forEach(invocables, visit);
	    invocables = cycle = visited = null; // plan is all that's required
	    
	    function isResolve(value) {
	      return isObject(value) && value.then && value.$$promises;
	    }
	    
	    return function (locals, parent, self) {
	      if (isResolve(locals) && self === undefined) {
	        self = parent; parent = locals; locals = null;
	      }
	      if (!locals) locals = NO_LOCALS;
	      else if (!isObject(locals)) {
	        throw new Error("'locals' must be an object");
	      }       
	      if (!parent) parent = NO_PARENT;
	      else if (!isResolve(parent)) {
	        throw new Error("'parent' must be a promise returned by $resolve.resolve()");
	      }
	      
	      // To complete the overall resolution, we have to wait for the parent
	      // promise and for the promise for each invokable in our plan.
	      var resolution = $q.defer(),
	          result = silenceUncaughtInPromise(resolution.promise),
	          promises = result.$$promises = {},
	          values = extend({}, locals),
	          wait = 1 + plan.length/3,
	          merged = false;
	
	      silenceUncaughtInPromise(result);
	          
	      function done() {
	        // Merge parent values we haven't got yet and publish our own $$values
	        if (!--wait) {
	          if (!merged) merge(values, parent.$$values); 
	          result.$$values = values;
	          result.$$promises = result.$$promises || true; // keep for isResolve()
	          delete result.$$inheritedValues;
	          resolution.resolve(values);
	        }
	      }
	      
	      function fail(reason) {
	        result.$$failure = reason;
	        resolution.reject(reason);
	      }
	
	      // Short-circuit if parent has already failed
	      if (isDefined(parent.$$failure)) {
	        fail(parent.$$failure);
	        return result;
	      }
	      
	      if (parent.$$inheritedValues) {
	        merge(values, omit(parent.$$inheritedValues, invocableKeys));
	      }
	
	      // Merge parent values if the parent has already resolved, or merge
	      // parent promises and wait if the parent resolve is still in progress.
	      extend(promises, parent.$$promises);
	      if (parent.$$values) {
	        merged = merge(values, omit(parent.$$values, invocableKeys));
	        result.$$inheritedValues = omit(parent.$$values, invocableKeys);
	        done();
	      } else {
	        if (parent.$$inheritedValues) {
	          result.$$inheritedValues = omit(parent.$$inheritedValues, invocableKeys);
	        }        
	        parent.then(done, fail);
	      }
	      
	      // Process each invocable in the plan, but ignore any where a local of the same name exists.
	      for (var i=0, ii=plan.length; i<ii; i+=3) {
	        if (locals.hasOwnProperty(plan[i])) done();
	        else invoke(plan[i], plan[i+1], plan[i+2]);
	      }
	      
	      function invoke(key, invocable, params) {
	        // Create a deferred for this invocation. Failures will propagate to the resolution as well.
	        var invocation = $q.defer(), waitParams = 0;
	        function onfailure(reason) {
	          invocation.reject(reason);
	          fail(reason);
	        }
	        // Wait for any parameter that we have a promise for (either from parent or from this
	        // resolve; in that case study() will have made sure it's ordered before us in the plan).
	        forEach(params, function (dep) {
	          if (promises.hasOwnProperty(dep) && !locals.hasOwnProperty(dep)) {
	            waitParams++;
	            promises[dep].then(function (result) {
	              values[dep] = result;
	              if (!(--waitParams)) proceed();
	            }, onfailure);
	          }
	        });
	        if (!waitParams) proceed();
	        function proceed() {
	          if (isDefined(result.$$failure)) return;
	          try {
	            invocation.resolve($injector.invoke(invocable, self, values));
	            invocation.promise.then(function (result) {
	              values[key] = result;
	              done();
	            }, onfailure);
	          } catch (e) {
	            onfailure(e);
	          }
	        }
	        // Publish promise synchronously; invocations further down in the plan may depend on it.
	        promises[key] = silenceUncaughtInPromise(invocation.promise);
	      }
	      
	      return result;
	    };
	  };
	  
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$resolve#resolve
	   * @methodOf ui.router.util.$resolve
	   *
	   * @description
	   * Resolves a set of invocables. An invocable is a function to be invoked via 
	   * `$injector.invoke()`, and can have an arbitrary number of dependencies. 
	   * An invocable can either return a value directly,
	   * or a `$q` promise. If a promise is returned it will be resolved and the 
	   * resulting value will be used instead. Dependencies of invocables are resolved 
	   * (in this order of precedence)
	   *
	   * - from the specified `locals`
	   * - from another invocable that is part of this `$resolve` call
	   * - from an invocable that is inherited from a `parent` call to `$resolve` 
	   *   (or recursively
	   * - from any ancestor `$resolve` of that parent).
	   *
	   * The return value of `$resolve` is a promise for an object that contains 
	   * (in this order of precedence)
	   *
	   * - any `locals` (if specified)
	   * - the resolved return values of all injectables
	   * - any values inherited from a `parent` call to `$resolve` (if specified)
	   *
	   * The promise will resolve after the `parent` promise (if any) and all promises 
	   * returned by injectables have been resolved. If any invocable 
	   * (or `$injector.invoke`) throws an exception, or if a promise returned by an 
	   * invocable is rejected, the `$resolve` promise is immediately rejected with the 
	   * same error. A rejection of a `parent` promise (if specified) will likewise be 
	   * propagated immediately. Once the `$resolve` promise has been rejected, no 
	   * further invocables will be called.
	   * 
	   * Cyclic dependencies between invocables are not permitted and will cause `$resolve`
	   * to throw an error. As a special case, an injectable can depend on a parameter 
	   * with the same name as the injectable, which will be fulfilled from the `parent` 
	   * injectable of the same name. This allows inherited values to be decorated. 
	   * Note that in this case any other injectable in the same `$resolve` with the same
	   * dependency would see the decorated value, not the inherited value.
	   *
	   * Note that missing dependencies -- unlike cyclic dependencies -- will cause an 
	   * (asynchronous) rejection of the `$resolve` promise rather than a (synchronous) 
	   * exception.
	   *
	   * Invocables are invoked eagerly as soon as all dependencies are available. 
	   * This is true even for dependencies inherited from a `parent` call to `$resolve`.
	   *
	   * As a special case, an invocable can be a string, in which case it is taken to 
	   * be a service name to be passed to `$injector.get()`. This is supported primarily 
	   * for backwards-compatibility with the `resolve` property of `$routeProvider` 
	   * routes.
	   *
	   * @param {object} invocables functions to invoke or 
	   * `$injector` services to fetch.
	   * @param {object} locals  values to make available to the injectables
	   * @param {object} parent  a promise returned by another call to `$resolve`.
	   * @param {object} self  the `this` for the invoked methods
	   * @return {object} Promise for an object that contains the resolved return value
	   * of all invocables, as well as any inherited and local values.
	   */
	  this.resolve = function (invocables, locals, parent, self) {
	    return this.study(invocables)(locals, parent, self);
	  };
	}
	
	angular.module('ui.router.util').service('$resolve', $Resolve);
	
	
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.$templateFactoryProvider
	 *
	 * @description
	 * Provider for $templateFactory. Manages which template-loading mechanism to
	 * use, and will default to the most recent one ($templateRequest on Angular
	 * versions starting from 1.3, $http otherwise).
	 */
	function TemplateFactoryProvider() {
	  var shouldUnsafelyUseHttp = angular.version.minor < 3;
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactoryProvider#shouldUnsafelyUseHttp
	   * @methodOf ui.router.util.$templateFactoryProvider
	   *
	   * @description
	   * Forces $templateFactory to use $http instead of $templateRequest. This
	   * might cause XSS, as $http doesn't enforce the regular security checks for
	   * templates that have been introduced in Angular 1.3. Note that setting this
	   * to false on Angular older than 1.3.x will crash, as the $templateRequest
	   * service (and the security checks) are not implemented on these versions.
	   *
	   * See the $sce documentation, section
	   * <a href="https://docs.angularjs.org/api/ng/service/$sce#impact-on-loading-templates">
	   * Impact on loading templates</a> for more details about this mechanism.
	   *
	   * @param {boolean} value
	   */
	  this.shouldUnsafelyUseHttp = function(value) {
	    shouldUnsafelyUseHttp = !!value;
	  };
	
	  /**
	   * @ngdoc object
	   * @name ui.router.util.$templateFactory
	   *
	   * @requires $http
	   * @requires $templateCache
	   * @requires $injector
	   *
	   * @description
	   * Service. Manages loading of templates.
	   */
	  this.$get = ['$http', '$templateCache', '$injector', function($http, $templateCache, $injector){
	    return new TemplateFactory($http, $templateCache, $injector, shouldUnsafelyUseHttp);}];
	}
	
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.$templateFactory
	 *
	 * @requires $http
	 * @requires $templateCache
	 * @requires $injector
	 *
	 * @description
	 * Service. Manages loading of templates.
	 */
	function TemplateFactory($http, $templateCache, $injector, shouldUnsafelyUseHttp) {
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromConfig
	   * @methodOf ui.router.util.$templateFactory
	   *
	   * @description
	   * Creates a template from a configuration object. 
	   *
	   * @param {object} config Configuration object for which to load a template. 
	   * The following properties are search in the specified order, and the first one 
	   * that is defined is used to create the template:
	   *
	   * @param {string|object} config.template html string template or function to 
	   * load via {@link ui.router.util.$templateFactory#fromString fromString}.
	   * @param {string|object} config.templateUrl url to load or a function returning 
	   * the url to load via {@link ui.router.util.$templateFactory#fromUrl fromUrl}.
	   * @param {Function} config.templateProvider function to invoke via 
	   * {@link ui.router.util.$templateFactory#fromProvider fromProvider}.
	   * @param {object} params  Parameters to pass to the template function.
	   * @param {object} locals Locals to pass to `invoke` if the template is loaded 
	   * via a `templateProvider`. Defaults to `{ params: params }`.
	   *
	   * @return {string|object}  The template html as a string, or a promise for 
	   * that string,or `null` if no template is configured.
	   */
	  this.fromConfig = function (config, params, locals) {
	    return (
	      isDefined(config.template) ? this.fromString(config.template, params) :
	      isDefined(config.templateUrl) ? this.fromUrl(config.templateUrl, params) :
	      isDefined(config.templateProvider) ? this.fromProvider(config.templateProvider, params, locals) :
	      null
	    );
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromString
	   * @methodOf ui.router.util.$templateFactory
	   *
	   * @description
	   * Creates a template from a string or a function returning a string.
	   *
	   * @param {string|object} template html template as a string or function that 
	   * returns an html template as a string.
	   * @param {object} params Parameters to pass to the template function.
	   *
	   * @return {string|object} The template html as a string, or a promise for that 
	   * string.
	   */
	  this.fromString = function (template, params) {
	    return isFunction(template) ? template(params) : template;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromUrl
	   * @methodOf ui.router.util.$templateFactory
	   * 
	   * @description
	   * Loads a template from the a URL via `$http` and `$templateCache`.
	   *
	   * @param {string|Function} url url of the template to load, or a function 
	   * that returns a url.
	   * @param {Object} params Parameters to pass to the url function.
	   * @return {string|Promise.<string>} The template html as a string, or a promise 
	   * for that string.
	   */
	  this.fromUrl = function (url, params) {
	    if (isFunction(url)) url = url(params);
	    if (url == null) return null;
	    else {
	      if(!shouldUnsafelyUseHttp) {
	        return $injector.get('$templateRequest')(url);
	      } else {
	        return $http
	          .get(url, { cache: $templateCache, headers: { Accept: 'text/html' }})
	          .then(function(response) { return response.data; });
	      }
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromProvider
	   * @methodOf ui.router.util.$templateFactory
	   *
	   * @description
	   * Creates a template by invoking an injectable provider function.
	   *
	   * @param {Function} provider Function to invoke via `$injector.invoke`
	   * @param {Object} params Parameters for the template.
	   * @param {Object} locals Locals to pass to `invoke`. Defaults to 
	   * `{ params: params }`.
	   * @return {string|Promise.<string>} The template html as a string, or a promise 
	   * for that string.
	   */
	  this.fromProvider = function (provider, params, locals) {
	    return $injector.invoke(provider, null, locals || { params: params });
	  };
	}
	
	angular.module('ui.router.util').provider('$templateFactory', TemplateFactoryProvider);
	
	var $$UMFP; // reference to $UrlMatcherFactoryProvider
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Matches URLs against patterns and extracts named parameters from the path or the search
	 * part of the URL. A URL pattern consists of a path pattern, optionally followed by '?' and a list
	 * of search parameters. Multiple search parameter names are separated by '&'. Search parameters
	 * do not influence whether or not a URL is matched, but their values are passed through into
	 * the matched parameters returned by {@link ui.router.util.type:UrlMatcher#methods_exec exec}.
	 *
	 * Path parameter placeholders can be specified using simple colon/catch-all syntax or curly brace
	 * syntax, which optionally allows a regular expression for the parameter to be specified:
	 *
	 * * `':'` name - colon placeholder
	 * * `'*'` name - catch-all placeholder
	 * * `'{' name '}'` - curly placeholder
	 * * `'{' name ':' regexp|type '}'` - curly placeholder with regexp or type name. Should the
	 *   regexp itself contain curly braces, they must be in matched pairs or escaped with a backslash.
	 *
	 * Parameter names may contain only word characters (latin letters, digits, and underscore) and
	 * must be unique within the pattern (across both path and search parameters). For colon
	 * placeholders or curly placeholders without an explicit regexp, a path parameter matches any
	 * number of characters other than '/'. For catch-all placeholders the path parameter matches
	 * any number of characters.
	 *
	 * Examples:
	 *
	 * * `'/hello/'` - Matches only if the path is exactly '/hello/'. There is no special treatment for
	 *   trailing slashes, and patterns have to match the entire path, not just a prefix.
	 * * `'/user/:id'` - Matches '/user/bob' or '/user/1234!!!' or even '/user/' but not '/user' or
	 *   '/user/bob/details'. The second path segment will be captured as the parameter 'id'.
	 * * `'/user/{id}'` - Same as the previous example, but using curly brace syntax.
	 * * `'/user/{id:[^/]*}'` - Same as the previous example.
	 * * `'/user/{id:[0-9a-fA-F]{1,8}}'` - Similar to the previous example, but only matches if the id
	 *   parameter consists of 1 to 8 hex digits.
	 * * `'/files/{path:.*}'` - Matches any URL starting with '/files/' and captures the rest of the
	 *   path into the parameter 'path'.
	 * * `'/files/*path'` - ditto.
	 * * `'/calendar/{start:date}'` - Matches "/calendar/2014-11-12" (because the pattern defined
	 *   in the built-in  `date` Type matches `2014-11-12`) and provides a Date object in $stateParams.start
	 *
	 * @param {string} pattern  The pattern to compile into a matcher.
	 * @param {Object} config  A configuration object hash:
	 * @param {Object=} parentMatcher Used to concatenate the pattern/config onto
	 *   an existing UrlMatcher
	 *
	 * * `caseInsensitive` - `true` if URL matching should be case insensitive, otherwise `false`, the default value (for backward compatibility) is `false`.
	 * * `strict` - `false` if matching against a URL with a trailing slash should be treated as equivalent to a URL without a trailing slash, the default value is `true`.
	 *
	 * @property {string} prefix  A static prefix of this pattern. The matcher guarantees that any
	 *   URL matching this matcher (i.e. any string for which {@link ui.router.util.type:UrlMatcher#methods_exec exec()} returns
	 *   non-null) will start with this prefix.
	 *
	 * @property {string} source  The pattern that was passed into the constructor
	 *
	 * @property {string} sourcePath  The path portion of the source property
	 *
	 * @property {string} sourceSearch  The search portion of the source property
	 *
	 * @property {string} regex  The constructed regex that will be used to match against the url when
	 *   it is time to determine which url will match.
	 *
	 * @returns {Object}  New `UrlMatcher` object
	 */
	function UrlMatcher(pattern, config, parentMatcher) {
	  config = extend({ params: {} }, isObject(config) ? config : {});
	
	  // Find all placeholders and create a compiled pattern, using either classic or curly syntax:
	  //   '*' name
	  //   ':' name
	  //   '{' name '}'
	  //   '{' name ':' regexp '}'
	  // The regular expression is somewhat complicated due to the need to allow curly braces
	  // inside the regular expression. The placeholder regexp breaks down as follows:
	  //    ([:*])([\w\[\]]+)              - classic placeholder ($1 / $2) (search version has - for snake-case)
	  //    \{([\w\[\]]+)(?:\:\s*( ... ))?\}  - curly brace placeholder ($3) with optional regexp/type ... ($4) (search version has - for snake-case
	  //    (?: ... | ... | ... )+         - the regexp consists of any number of atoms, an atom being either
	  //    [^{}\\]+                       - anything other than curly braces or backslash
	  //    \\.                            - a backslash escape
	  //    \{(?:[^{}\\]+|\\.)*\}          - a matched set of curly braces containing other atoms
	  var placeholder       = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
	      searchPlaceholder = /([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
	      compiled = '^', last = 0, m,
	      segments = this.segments = [],
	      parentParams = parentMatcher ? parentMatcher.params : {},
	      params = this.params = parentMatcher ? parentMatcher.params.$$new() : new $$UMFP.ParamSet(),
	      paramNames = [];
	
	  function addParameter(id, type, config, location) {
	    paramNames.push(id);
	    if (parentParams[id]) return parentParams[id];
	    if (!/^\w+([-.]+\w+)*(?:\[\])?$/.test(id)) throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
	    if (params[id]) throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
	    params[id] = new $$UMFP.Param(id, type, config, location);
	    return params[id];
	  }
	
	  function quoteRegExp(string, pattern, squash, optional) {
	    var surroundPattern = ['',''], result = string.replace(/[\\\[\]\^$*+?.()|{}]/g, "\\$&");
	    if (!pattern) return result;
	    switch(squash) {
	      case false: surroundPattern = ['(', ')' + (optional ? "?" : "")]; break;
	      case true:
	        result = result.replace(/\/$/, '');
	        surroundPattern = ['(?:\/(', ')|\/)?'];
	      break;
	      default:    surroundPattern = ['(' + squash + "|", ')?']; break;
	    }
	    return result + surroundPattern[0] + pattern + surroundPattern[1];
	  }
	
	  this.source = pattern;
	
	  // Split into static segments separated by path parameter placeholders.
	  // The number of segments is always 1 more than the number of parameters.
	  function matchDetails(m, isSearch) {
	    var id, regexp, segment, type, cfg, arrayMode;
	    id          = m[2] || m[3]; // IE[78] returns '' for unmatched groups instead of null
	    cfg         = config.params[id];
	    segment     = pattern.substring(last, m.index);
	    regexp      = isSearch ? m[4] : m[4] || (m[1] == '*' ? '.*' : null);
	
	    if (regexp) {
	      type      = $$UMFP.type(regexp) || inherit($$UMFP.type("string"), { pattern: new RegExp(regexp, config.caseInsensitive ? 'i' : undefined) });
	    }
	
	    return {
	      id: id, regexp: regexp, segment: segment, type: type, cfg: cfg
	    };
	  }
	
	  var p, param, segment;
	  while ((m = placeholder.exec(pattern))) {
	    p = matchDetails(m, false);
	    if (p.segment.indexOf('?') >= 0) break; // we're into the search part
	
	    param = addParameter(p.id, p.type, p.cfg, "path");
	    compiled += quoteRegExp(p.segment, param.type.pattern.source, param.squash, param.isOptional);
	    segments.push(p.segment);
	    last = placeholder.lastIndex;
	  }
	  segment = pattern.substring(last);
	
	  // Find any search parameter names and remove them from the last segment
	  var i = segment.indexOf('?');
	
	  if (i >= 0) {
	    var search = this.sourceSearch = segment.substring(i);
	    segment = segment.substring(0, i);
	    this.sourcePath = pattern.substring(0, last + i);
	
	    if (search.length > 0) {
	      last = 0;
	      while ((m = searchPlaceholder.exec(search))) {
	        p = matchDetails(m, true);
	        param = addParameter(p.id, p.type, p.cfg, "search");
	        last = placeholder.lastIndex;
	        // check if ?&
	      }
	    }
	  } else {
	    this.sourcePath = pattern;
	    this.sourceSearch = '';
	  }
	
	  compiled += quoteRegExp(segment) + (config.strict === false ? '\/?' : '') + '$';
	  segments.push(segment);
	
	  this.regexp = new RegExp(compiled, config.caseInsensitive ? 'i' : undefined);
	  this.prefix = segments[0];
	  this.$$paramNames = paramNames;
	}
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#concat
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Returns a new matcher for a pattern constructed by appending the path part and adding the
	 * search parameters of the specified pattern to this pattern. The current pattern is not
	 * modified. This can be understood as creating a pattern for URLs that are relative to (or
	 * suffixes of) the current pattern.
	 *
	 * @example
	 * The following two matchers are equivalent:
	 * <pre>
	 * new UrlMatcher('/user/{id}?q').concat('/details?date');
	 * new UrlMatcher('/user/{id}/details?q&date');
	 * </pre>
	 *
	 * @param {string} pattern  The pattern to append.
	 * @param {Object} config  An object hash of the configuration for the matcher.
	 * @returns {UrlMatcher}  A matcher for the concatenated pattern.
	 */
	UrlMatcher.prototype.concat = function (pattern, config) {
	  // Because order of search parameters is irrelevant, we can add our own search
	  // parameters to the end of the new pattern. Parse the new pattern by itself
	  // and then join the bits together, but it's much easier to do this on a string level.
	  var defaultConfig = {
	    caseInsensitive: $$UMFP.caseInsensitive(),
	    strict: $$UMFP.strictMode(),
	    squash: $$UMFP.defaultSquashPolicy()
	  };
	  return new UrlMatcher(this.sourcePath + pattern + this.sourceSearch, extend(defaultConfig, config), this);
	};
	
	UrlMatcher.prototype.toString = function () {
	  return this.source;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#exec
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Tests the specified path against this matcher, and returns an object containing the captured
	 * parameter values, or null if the path does not match. The returned object contains the values
	 * of any search parameters that are mentioned in the pattern, but their value may be null if
	 * they are not present in `searchParams`. This means that search parameters are always treated
	 * as optional.
	 *
	 * @example
	 * <pre>
	 * new UrlMatcher('/user/{id}?q&r').exec('/user/bob', {
	 *   x: '1', q: 'hello'
	 * });
	 * // returns { id: 'bob', q: 'hello', r: null }
	 * </pre>
	 *
	 * @param {string} path  The URL path to match, e.g. `$location.path()`.
	 * @param {Object} searchParams  URL search parameters, e.g. `$location.search()`.
	 * @returns {Object}  The captured parameter values.
	 */
	UrlMatcher.prototype.exec = function (path, searchParams) {
	  var m = this.regexp.exec(path);
	  if (!m) return null;
	  searchParams = searchParams || {};
	
	  var paramNames = this.parameters(), nTotal = paramNames.length,
	    nPath = this.segments.length - 1,
	    values = {}, i, j, cfg, paramName;
	
	  if (nPath !== m.length - 1) throw new Error("Unbalanced capture group in route '" + this.source + "'");
	
	  function decodePathArray(string) {
	    function reverseString(str) { return str.split("").reverse().join(""); }
	    function unquoteDashes(str) { return str.replace(/\\-/g, "-"); }
	
	    var split = reverseString(string).split(/-(?!\\)/);
	    var allReversed = map(split, reverseString);
	    return map(allReversed, unquoteDashes).reverse();
	  }
	
	  var param, paramVal;
	  for (i = 0; i < nPath; i++) {
	    paramName = paramNames[i];
	    param = this.params[paramName];
	    paramVal = m[i+1];
	    // if the param value matches a pre-replace pair, replace the value before decoding.
	    for (j = 0; j < param.replace.length; j++) {
	      if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
	    }
	    if (paramVal && param.array === true) paramVal = decodePathArray(paramVal);
	    if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
	    values[paramName] = param.value(paramVal);
	  }
	  for (/**/; i < nTotal; i++) {
	    paramName = paramNames[i];
	    values[paramName] = this.params[paramName].value(searchParams[paramName]);
	    param = this.params[paramName];
	    paramVal = searchParams[paramName];
	    for (j = 0; j < param.replace.length; j++) {
	      if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
	    }
	    if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
	    values[paramName] = param.value(paramVal);
	  }
	
	  return values;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#parameters
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Returns the names of all path and search parameters of this pattern in an unspecified order.
	 *
	 * @returns {Array.<string>}  An array of parameter names. Must be treated as read-only. If the
	 *    pattern has no parameters, an empty array is returned.
	 */
	UrlMatcher.prototype.parameters = function (param) {
	  if (!isDefined(param)) return this.$$paramNames;
	  return this.params[param] || null;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#validates
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Checks an object hash of parameters to validate their correctness according to the parameter
	 * types of this `UrlMatcher`.
	 *
	 * @param {Object} params The object hash of parameters to validate.
	 * @returns {boolean} Returns `true` if `params` validates, otherwise `false`.
	 */
	UrlMatcher.prototype.validates = function (params) {
	  return this.params.$$validates(params);
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#format
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Creates a URL that matches this pattern by substituting the specified values
	 * for the path and search parameters. Null values for path parameters are
	 * treated as empty strings.
	 *
	 * @example
	 * <pre>
	 * new UrlMatcher('/user/{id}?q').format({ id:'bob', q:'yes' });
	 * // returns '/user/bob?q=yes'
	 * </pre>
	 *
	 * @param {Object} values  the values to substitute for the parameters in this pattern.
	 * @returns {string}  the formatted URL (path and optionally search part).
	 */
	UrlMatcher.prototype.format = function (values) {
	  values = values || {};
	  var segments = this.segments, params = this.parameters(), paramset = this.params;
	  if (!this.validates(values)) return null;
	
	  var i, search = false, nPath = segments.length - 1, nTotal = params.length, result = segments[0];
	
	  function encodeDashes(str) { // Replace dashes with encoded "\-"
	    return encodeURIComponent(str).replace(/-/g, function(c) { return '%5C%' + c.charCodeAt(0).toString(16).toUpperCase(); });
	  }
	
	  for (i = 0; i < nTotal; i++) {
	    var isPathParam = i < nPath;
	    var name = params[i], param = paramset[name], value = param.value(values[name]);
	    var isDefaultValue = param.isOptional && param.type.equals(param.value(), value);
	    var squash = isDefaultValue ? param.squash : false;
	    var encoded = param.type.encode(value);
	
	    if (isPathParam) {
	      var nextSegment = segments[i + 1];
	      var isFinalPathParam = i + 1 === nPath;
	
	      if (squash === false) {
	        if (encoded != null) {
	          if (isArray(encoded)) {
	            result += map(encoded, encodeDashes).join("-");
	          } else {
	            result += encodeURIComponent(encoded);
	          }
	        }
	        result += nextSegment;
	      } else if (squash === true) {
	        var capture = result.match(/\/$/) ? /\/?(.*)/ : /(.*)/;
	        result += nextSegment.match(capture)[1];
	      } else if (isString(squash)) {
	        result += squash + nextSegment;
	      }
	
	      if (isFinalPathParam && param.squash === true && result.slice(-1) === '/') result = result.slice(0, -1);
	    } else {
	      if (encoded == null || (isDefaultValue && squash !== false)) continue;
	      if (!isArray(encoded)) encoded = [ encoded ];
	      if (encoded.length === 0) continue;
	      encoded = map(encoded, encodeURIComponent).join('&' + name + '=');
	      result += (search ? '&' : '?') + (name + '=' + encoded);
	      search = true;
	    }
	  }
	
	  return result;
	};
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.type:Type
	 *
	 * @description
	 * Implements an interface to define custom parameter types that can be decoded from and encoded to
	 * string parameters matched in a URL. Used by {@link ui.router.util.type:UrlMatcher `UrlMatcher`}
	 * objects when matching or formatting URLs, or comparing or validating parameter values.
	 *
	 * See {@link ui.router.util.$urlMatcherFactory#methods_type `$urlMatcherFactory#type()`} for more
	 * information on registering custom types.
	 *
	 * @param {Object} config  A configuration object which contains the custom type definition.  The object's
	 *        properties will override the default methods and/or pattern in `Type`'s public interface.
	 * @example
	 * <pre>
	 * {
	 *   decode: function(val) { return parseInt(val, 10); },
	 *   encode: function(val) { return val && val.toString(); },
	 *   equals: function(a, b) { return this.is(a) && a === b; },
	 *   is: function(val) { return angular.isNumber(val) isFinite(val) && val % 1 === 0; },
	 *   pattern: /\d+/
	 * }
	 * </pre>
	 *
	 * @property {RegExp} pattern The regular expression pattern used to match values of this type when
	 *           coming from a substring of a URL.
	 *
	 * @returns {Object}  Returns a new `Type` object.
	 */
	function Type(config) {
	  extend(this, config);
	}
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#is
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Detects whether a value is of a particular type. Accepts a native (decoded) value
	 * and determines whether it matches the current `Type` object.
	 *
	 * @param {*} val  The value to check.
	 * @param {string} key  Optional. If the type check is happening in the context of a specific
	 *        {@link ui.router.util.type:UrlMatcher `UrlMatcher`} object, this is the name of the
	 *        parameter in which `val` is stored. Can be used for meta-programming of `Type` objects.
	 * @returns {Boolean}  Returns `true` if the value matches the type, otherwise `false`.
	 */
	Type.prototype.is = function(val, key) {
	  return true;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#encode
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Encodes a custom/native type value to a string that can be embedded in a URL. Note that the
	 * return value does *not* need to be URL-safe (i.e. passed through `encodeURIComponent()`), it
	 * only needs to be a representation of `val` that has been coerced to a string.
	 *
	 * @param {*} val  The value to encode.
	 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
	 *        meta-programming of `Type` objects.
	 * @returns {string}  Returns a string representation of `val` that can be encoded in a URL.
	 */
	Type.prototype.encode = function(val, key) {
	  return val;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#decode
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Converts a parameter value (from URL string or transition param) to a custom/native value.
	 *
	 * @param {string} val  The URL parameter value to decode.
	 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
	 *        meta-programming of `Type` objects.
	 * @returns {*}  Returns a custom representation of the URL parameter value.
	 */
	Type.prototype.decode = function(val, key) {
	  return val;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#equals
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Determines whether two decoded values are equivalent.
	 *
	 * @param {*} a  A value to compare against.
	 * @param {*} b  A value to compare against.
	 * @returns {Boolean}  Returns `true` if the values are equivalent/equal, otherwise `false`.
	 */
	Type.prototype.equals = function(a, b) {
	  return a == b;
	};
	
	Type.prototype.$subPattern = function() {
	  var sub = this.pattern.toString();
	  return sub.substr(1, sub.length - 2);
	};
	
	Type.prototype.pattern = /.*/;
	
	Type.prototype.toString = function() { return "{Type:" + this.name + "}"; };
	
	/** Given an encoded string, or a decoded object, returns a decoded object */
	Type.prototype.$normalize = function(val) {
	  return this.is(val) ? val : this.decode(val);
	};
	
	/*
	 * Wraps an existing custom Type as an array of Type, depending on 'mode'.
	 * e.g.:
	 * - urlmatcher pattern "/path?{queryParam[]:int}"
	 * - url: "/path?queryParam=1&queryParam=2
	 * - $stateParams.queryParam will be [1, 2]
	 * if `mode` is "auto", then
	 * - url: "/path?queryParam=1 will create $stateParams.queryParam: 1
	 * - url: "/path?queryParam=1&queryParam=2 will create $stateParams.queryParam: [1, 2]
	 */
	Type.prototype.$asArray = function(mode, isSearch) {
	  if (!mode) return this;
	  if (mode === "auto" && !isSearch) throw new Error("'auto' array mode is for query parameters only");
	
	  function ArrayType(type, mode) {
	    function bindTo(type, callbackName) {
	      return function() {
	        return type[callbackName].apply(type, arguments);
	      };
	    }
	
	    // Wrap non-array value as array
	    function arrayWrap(val) { return isArray(val) ? val : (isDefined(val) ? [ val ] : []); }
	    // Unwrap array value for "auto" mode. Return undefined for empty array.
	    function arrayUnwrap(val) {
	      switch(val.length) {
	        case 0: return undefined;
	        case 1: return mode === "auto" ? val[0] : val;
	        default: return val;
	      }
	    }
	    function falsey(val) { return !val; }
	
	    // Wraps type (.is/.encode/.decode) functions to operate on each value of an array
	    function arrayHandler(callback, allTruthyMode) {
	      return function handleArray(val) {
	        if (isArray(val) && val.length === 0) return val;
	        val = arrayWrap(val);
	        var result = map(val, callback);
	        if (allTruthyMode === true)
	          return filter(result, falsey).length === 0;
	        return arrayUnwrap(result);
	      };
	    }
	
	    // Wraps type (.equals) functions to operate on each value of an array
	    function arrayEqualsHandler(callback) {
	      return function handleArray(val1, val2) {
	        var left = arrayWrap(val1), right = arrayWrap(val2);
	        if (left.length !== right.length) return false;
	        for (var i = 0; i < left.length; i++) {
	          if (!callback(left[i], right[i])) return false;
	        }
	        return true;
	      };
	    }
	
	    this.encode = arrayHandler(bindTo(type, 'encode'));
	    this.decode = arrayHandler(bindTo(type, 'decode'));
	    this.is     = arrayHandler(bindTo(type, 'is'), true);
	    this.equals = arrayEqualsHandler(bindTo(type, 'equals'));
	    this.pattern = type.pattern;
	    this.$normalize = arrayHandler(bindTo(type, '$normalize'));
	    this.name = type.name;
	    this.$arrayMode = mode;
	  }
	
	  return new ArrayType(this, mode);
	};
	
	
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.$urlMatcherFactory
	 *
	 * @description
	 * Factory for {@link ui.router.util.type:UrlMatcher `UrlMatcher`} instances. The factory
	 * is also available to providers under the name `$urlMatcherFactoryProvider`.
	 */
	function $UrlMatcherFactory() {
	  $$UMFP = this;
	
	  var isCaseInsensitive = false, isStrictMode = true, defaultSquashPolicy = false;
	
	  // Use tildes to pre-encode slashes.
	  // If the slashes are simply URLEncoded, the browser can choose to pre-decode them,
	  // and bidirectional encoding/decoding fails.
	  // Tilde was chosen because it's not a RFC 3986 section 2.2 Reserved Character
	  function valToString(val) { return val != null ? val.toString().replace(/(~|\/)/g, function (m) { return {'~':'~~', '/':'~2F'}[m]; }) : val; }
	  function valFromString(val) { return val != null ? val.toString().replace(/(~~|~2F)/g, function (m) { return {'~~':'~', '~2F':'/'}[m]; }) : val; }
	
	  var $types = {}, enqueue = true, typeQueue = [], injector, defaultTypes = {
	    "string": {
	      encode: valToString,
	      decode: valFromString,
	      // TODO: in 1.0, make string .is() return false if value is undefined/null by default.
	      // In 0.2.x, string params are optional by default for backwards compat
	      is: function(val) { return val == null || !isDefined(val) || typeof val === "string"; },
	      pattern: /[^/]*/
	    },
	    "int": {
	      encode: valToString,
	      decode: function(val) { return parseInt(val, 10); },
	      is: function(val) { return val !== undefined && val !== null && this.decode(val.toString()) === val; },
	      pattern: /\d+/
	    },
	    "bool": {
	      encode: function(val) { return val ? 1 : 0; },
	      decode: function(val) { return parseInt(val, 10) !== 0; },
	      is: function(val) { return val === true || val === false; },
	      pattern: /0|1/
	    },
	    "date": {
	      encode: function (val) {
	        if (!this.is(val))
	          return undefined;
	        return [ val.getFullYear(),
	          ('0' + (val.getMonth() + 1)).slice(-2),
	          ('0' + val.getDate()).slice(-2)
	        ].join("-");
	      },
	      decode: function (val) {
	        if (this.is(val)) return val;
	        var match = this.capture.exec(val);
	        return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
	      },
	      is: function(val) { return val instanceof Date && !isNaN(val.valueOf()); },
	      equals: function (a, b) { return this.is(a) && this.is(b) && a.toISOString() === b.toISOString(); },
	      pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
	      capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/
	    },
	    "json": {
	      encode: angular.toJson,
	      decode: angular.fromJson,
	      is: angular.isObject,
	      equals: angular.equals,
	      pattern: /[^/]*/
	    },
	    "any": { // does not encode/decode
	      encode: angular.identity,
	      decode: angular.identity,
	      equals: angular.equals,
	      pattern: /.*/
	    }
	  };
	
	  function getDefaultConfig() {
	    return {
	      strict: isStrictMode,
	      caseInsensitive: isCaseInsensitive
	    };
	  }
	
	  function isInjectable(value) {
	    return (isFunction(value) || (isArray(value) && isFunction(value[value.length - 1])));
	  }
	
	  /**
	   * [Internal] Get the default value of a parameter, which may be an injectable function.
	   */
	  $UrlMatcherFactory.$$getDefaultValue = function(config) {
	    if (!isInjectable(config.value)) return config.value;
	    if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
	    return injector.invoke(config.value);
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#caseInsensitive
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Defines whether URL matching should be case sensitive (the default behavior), or not.
	   *
	   * @param {boolean} value `false` to match URL in a case sensitive manner; otherwise `true`;
	   * @returns {boolean} the current value of caseInsensitive
	   */
	  this.caseInsensitive = function(value) {
	    if (isDefined(value))
	      isCaseInsensitive = value;
	    return isCaseInsensitive;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#strictMode
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Defines whether URLs should match trailing slashes, or not (the default behavior).
	   *
	   * @param {boolean=} value `false` to match trailing slashes in URLs, otherwise `true`.
	   * @returns {boolean} the current value of strictMode
	   */
	  this.strictMode = function(value) {
	    if (isDefined(value))
	      isStrictMode = value;
	    return isStrictMode;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#defaultSquashPolicy
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Sets the default behavior when generating or matching URLs with default parameter values.
	   *
	   * @param {string} value A string that defines the default parameter URL squashing behavior.
	   *    `nosquash`: When generating an href with a default parameter value, do not squash the parameter value from the URL
	   *    `slash`: When generating an href with a default parameter value, squash (remove) the parameter value, and, if the
	   *             parameter is surrounded by slashes, squash (remove) one slash from the URL
	   *    any other string, e.g. "~": When generating an href with a default parameter value, squash (remove)
	   *             the parameter value from the URL and replace it with this string.
	   */
	  this.defaultSquashPolicy = function(value) {
	    if (!isDefined(value)) return defaultSquashPolicy;
	    if (value !== true && value !== false && !isString(value))
	      throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
	    defaultSquashPolicy = value;
	    return value;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#compile
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Creates a {@link ui.router.util.type:UrlMatcher `UrlMatcher`} for the specified pattern.
	   *
	   * @param {string} pattern  The URL pattern.
	   * @param {Object} config  The config object hash.
	   * @returns {UrlMatcher}  The UrlMatcher.
	   */
	  this.compile = function (pattern, config) {
	    return new UrlMatcher(pattern, extend(getDefaultConfig(), config));
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#isMatcher
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Returns true if the specified object is a `UrlMatcher`, or false otherwise.
	   *
	   * @param {Object} object  The object to perform the type check against.
	   * @returns {Boolean}  Returns `true` if the object matches the `UrlMatcher` interface, by
	   *          implementing all the same methods.
	   */
	  this.isMatcher = function (o) {
	    if (!isObject(o)) return false;
	    var result = true;
	
	    forEach(UrlMatcher.prototype, function(val, name) {
	      if (isFunction(val)) {
	        result = result && (isDefined(o[name]) && isFunction(o[name]));
	      }
	    });
	    return result;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#type
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Registers a custom {@link ui.router.util.type:Type `Type`} object that can be used to
	   * generate URLs with typed parameters.
	   *
	   * @param {string} name  The type name.
	   * @param {Object|Function} definition   The type definition. See
	   *        {@link ui.router.util.type:Type `Type`} for information on the values accepted.
	   * @param {Object|Function} definitionFn (optional) A function that is injected before the app
	   *        runtime starts.  The result of this function is merged into the existing `definition`.
	   *        See {@link ui.router.util.type:Type `Type`} for information on the values accepted.
	   *
	   * @returns {Object}  Returns `$urlMatcherFactoryProvider`.
	   *
	   * @example
	   * This is a simple example of a custom type that encodes and decodes items from an
	   * array, using the array index as the URL-encoded value:
	   *
	   * <pre>
	   * var list = ['John', 'Paul', 'George', 'Ringo'];
	   *
	   * $urlMatcherFactoryProvider.type('listItem', {
	   *   encode: function(item) {
	   *     // Represent the list item in the URL using its corresponding index
	   *     return list.indexOf(item);
	   *   },
	   *   decode: function(item) {
	   *     // Look up the list item by index
	   *     return list[parseInt(item, 10)];
	   *   },
	   *   is: function(item) {
	   *     // Ensure the item is valid by checking to see that it appears
	   *     // in the list
	   *     return list.indexOf(item) > -1;
	   *   }
	   * });
	   *
	   * $stateProvider.state('list', {
	   *   url: "/list/{item:listItem}",
	   *   controller: function($scope, $stateParams) {
	   *     console.log($stateParams.item);
	   *   }
	   * });
	   *
	   * // ...
	   *
	   * // Changes URL to '/list/3', logs "Ringo" to the console
	   * $state.go('list', { item: "Ringo" });
	   * </pre>
	   *
	   * This is a more complex example of a type that relies on dependency injection to
	   * interact with services, and uses the parameter name from the URL to infer how to
	   * handle encoding and decoding parameter values:
	   *
	   * <pre>
	   * // Defines a custom type that gets a value from a service,
	   * // where each service gets different types of values from
	   * // a backend API:
	   * $urlMatcherFactoryProvider.type('dbObject', {}, function(Users, Posts) {
	   *
	   *   // Matches up services to URL parameter names
	   *   var services = {
	   *     user: Users,
	   *     post: Posts
	   *   };
	   *
	   *   return {
	   *     encode: function(object) {
	   *       // Represent the object in the URL using its unique ID
	   *       return object.id;
	   *     },
	   *     decode: function(value, key) {
	   *       // Look up the object by ID, using the parameter
	   *       // name (key) to call the correct service
	   *       return services[key].findById(value);
	   *     },
	   *     is: function(object, key) {
	   *       // Check that object is a valid dbObject
	   *       return angular.isObject(object) && object.id && services[key];
	   *     }
	   *     equals: function(a, b) {
	   *       // Check the equality of decoded objects by comparing
	   *       // their unique IDs
	   *       return a.id === b.id;
	   *     }
	   *   };
	   * });
	   *
	   * // In a config() block, you can then attach URLs with
	   * // type-annotated parameters:
	   * $stateProvider.state('users', {
	   *   url: "/users",
	   *   // ...
	   * }).state('users.item', {
	   *   url: "/{user:dbObject}",
	   *   controller: function($scope, $stateParams) {
	   *     // $stateParams.user will now be an object returned from
	   *     // the Users service
	   *   },
	   *   // ...
	   * });
	   * </pre>
	   */
	  this.type = function (name, definition, definitionFn) {
	    if (!isDefined(definition)) return $types[name];
	    if ($types.hasOwnProperty(name)) throw new Error("A type named '" + name + "' has already been defined.");
	
	    $types[name] = new Type(extend({ name: name }, definition));
	    if (definitionFn) {
	      typeQueue.push({ name: name, def: definitionFn });
	      if (!enqueue) flushTypeQueue();
	    }
	    return this;
	  };
	
	  // `flushTypeQueue()` waits until `$urlMatcherFactory` is injected before invoking the queued `definitionFn`s
	  function flushTypeQueue() {
	    while(typeQueue.length) {
	      var type = typeQueue.shift();
	      if (type.pattern) throw new Error("You cannot override a type's .pattern at runtime.");
	      angular.extend($types[type.name], injector.invoke(type.def));
	    }
	  }
	
	  // Register default types. Store them in the prototype of $types.
	  forEach(defaultTypes, function(type, name) { $types[name] = new Type(extend({name: name}, type)); });
	  $types = inherit($types, {});
	
	  /* No need to document $get, since it returns this */
	  this.$get = ['$injector', function ($injector) {
	    injector = $injector;
	    enqueue = false;
	    flushTypeQueue();
	
	    forEach(defaultTypes, function(type, name) {
	      if (!$types[name]) $types[name] = new Type(type);
	    });
	    return this;
	  }];
	
	  this.Param = function Param(id, type, config, location) {
	    var self = this;
	    config = unwrapShorthand(config);
	    type = getType(config, type, location);
	    var arrayMode = getArrayMode();
	    type = arrayMode ? type.$asArray(arrayMode, location === "search") : type;
	    if (type.name === "string" && !arrayMode && location === "path" && config.value === undefined)
	      config.value = ""; // for 0.2.x; in 0.3.0+ do not automatically default to ""
	    var isOptional = config.value !== undefined;
	    var squash = getSquashPolicy(config, isOptional);
	    var replace = getReplace(config, arrayMode, isOptional, squash);
	
	    function unwrapShorthand(config) {
	      var keys = isObject(config) ? objectKeys(config) : [];
	      var isShorthand = indexOf(keys, "value") === -1 && indexOf(keys, "type") === -1 &&
	                        indexOf(keys, "squash") === -1 && indexOf(keys, "array") === -1;
	      if (isShorthand) config = { value: config };
	      config.$$fn = isInjectable(config.value) ? config.value : function () { return config.value; };
	      return config;
	    }
	
	    function getType(config, urlType, location) {
	      if (config.type && urlType) throw new Error("Param '"+id+"' has two type configurations.");
	      if (urlType) return urlType;
	      if (!config.type) return (location === "config" ? $types.any : $types.string);
	
	      if (angular.isString(config.type))
	        return $types[config.type];
	      if (config.type instanceof Type)
	        return config.type;
	      return new Type(config.type);
	    }
	
	    // array config: param name (param[]) overrides default settings.  explicit config overrides param name.
	    function getArrayMode() {
	      var arrayDefaults = { array: (location === "search" ? "auto" : false) };
	      var arrayParamNomenclature = id.match(/\[\]$/) ? { array: true } : {};
	      return extend(arrayDefaults, arrayParamNomenclature, config).array;
	    }
	
	    /**
	     * returns false, true, or the squash value to indicate the "default parameter url squash policy".
	     */
	    function getSquashPolicy(config, isOptional) {
	      var squash = config.squash;
	      if (!isOptional || squash === false) return false;
	      if (!isDefined(squash) || squash == null) return defaultSquashPolicy;
	      if (squash === true || isString(squash)) return squash;
	      throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
	    }
	
	    function getReplace(config, arrayMode, isOptional, squash) {
	      var replace, configuredKeys, defaultPolicy = [
	        { from: "",   to: (isOptional || arrayMode ? undefined : "") },
	        { from: null, to: (isOptional || arrayMode ? undefined : "") }
	      ];
	      replace = isArray(config.replace) ? config.replace : [];
	      if (isString(squash))
	        replace.push({ from: squash, to: undefined });
	      configuredKeys = map(replace, function(item) { return item.from; } );
	      return filter(defaultPolicy, function(item) { return indexOf(configuredKeys, item.from) === -1; }).concat(replace);
	    }
	
	    /**
	     * [Internal] Get the default value of a parameter, which may be an injectable function.
	     */
	    function $$getDefaultValue() {
	      if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
	      var defaultValue = injector.invoke(config.$$fn);
	      if (defaultValue !== null && defaultValue !== undefined && !self.type.is(defaultValue))
	        throw new Error("Default value (" + defaultValue + ") for parameter '" + self.id + "' is not an instance of Type (" + self.type.name + ")");
	      return defaultValue;
	    }
	
	    /**
	     * [Internal] Gets the decoded representation of a value if the value is defined, otherwise, returns the
	     * default value, which may be the result of an injectable function.
	     */
	    function $value(value) {
	      function hasReplaceVal(val) { return function(obj) { return obj.from === val; }; }
	      function $replace(value) {
	        var replacement = map(filter(self.replace, hasReplaceVal(value)), function(obj) { return obj.to; });
	        return replacement.length ? replacement[0] : value;
	      }
	      value = $replace(value);
	      return !isDefined(value) ? $$getDefaultValue() : self.type.$normalize(value);
	    }
	
	    function toString() { return "{Param:" + id + " " + type + " squash: '" + squash + "' optional: " + isOptional + "}"; }
	
	    extend(this, {
	      id: id,
	      type: type,
	      location: location,
	      array: arrayMode,
	      squash: squash,
	      replace: replace,
	      isOptional: isOptional,
	      value: $value,
	      dynamic: undefined,
	      config: config,
	      toString: toString
	    });
	  };
	
	  function ParamSet(params) {
	    extend(this, params || {});
	  }
	
	  ParamSet.prototype = {
	    $$new: function() {
	      return inherit(this, extend(new ParamSet(), { $$parent: this}));
	    },
	    $$keys: function () {
	      var keys = [], chain = [], parent = this,
	        ignore = objectKeys(ParamSet.prototype);
	      while (parent) { chain.push(parent); parent = parent.$$parent; }
	      chain.reverse();
	      forEach(chain, function(paramset) {
	        forEach(objectKeys(paramset), function(key) {
	            if (indexOf(keys, key) === -1 && indexOf(ignore, key) === -1) keys.push(key);
	        });
	      });
	      return keys;
	    },
	    $$values: function(paramValues) {
	      var values = {}, self = this;
	      forEach(self.$$keys(), function(key) {
	        values[key] = self[key].value(paramValues && paramValues[key]);
	      });
	      return values;
	    },
	    $$equals: function(paramValues1, paramValues2) {
	      var equal = true, self = this;
	      forEach(self.$$keys(), function(key) {
	        var left = paramValues1 && paramValues1[key], right = paramValues2 && paramValues2[key];
	        if (!self[key].type.equals(left, right)) equal = false;
	      });
	      return equal;
	    },
	    $$validates: function $$validate(paramValues) {
	      var keys = this.$$keys(), i, param, rawVal, normalized, encoded;
	      for (i = 0; i < keys.length; i++) {
	        param = this[keys[i]];
	        rawVal = paramValues[keys[i]];
	        if ((rawVal === undefined || rawVal === null) && param.isOptional)
	          break; // There was no parameter value, but the param is optional
	        normalized = param.type.$normalize(rawVal);
	        if (!param.type.is(normalized))
	          return false; // The value was not of the correct Type, and could not be decoded to the correct Type
	        encoded = param.type.encode(normalized);
	        if (angular.isString(encoded) && !param.type.pattern.exec(encoded))
	          return false; // The value was of the correct type, but when encoded, did not match the Type's regexp
	      }
	      return true;
	    },
	    $$parent: undefined
	  };
	
	  this.ParamSet = ParamSet;
	}
	
	// Register as a provider so it's available to other providers
	angular.module('ui.router.util').provider('$urlMatcherFactory', $UrlMatcherFactory);
	angular.module('ui.router.util').run(['$urlMatcherFactory', function($urlMatcherFactory) { }]);
	
	/**
	 * @ngdoc object
	 * @name ui.router.router.$urlRouterProvider
	 *
	 * @requires ui.router.util.$urlMatcherFactoryProvider
	 * @requires $locationProvider
	 *
	 * @description
	 * `$urlRouterProvider` has the responsibility of watching `$location`. 
	 * When `$location` changes it runs through a list of rules one by one until a 
	 * match is found. `$urlRouterProvider` is used behind the scenes anytime you specify 
	 * a url in a state configuration. All urls are compiled into a UrlMatcher object.
	 *
	 * There are several methods on `$urlRouterProvider` that make it useful to use directly
	 * in your module config.
	 */
	$UrlRouterProvider.$inject = ['$locationProvider', '$urlMatcherFactoryProvider'];
	function $UrlRouterProvider(   $locationProvider,   $urlMatcherFactory) {
	  var rules = [], otherwise = null, interceptDeferred = false, listener;
	
	  // Returns a string that is a prefix of all strings matching the RegExp
	  function regExpPrefix(re) {
	    var prefix = /^\^((?:\\[^a-zA-Z0-9]|[^\\\[\]\^$*+?.()|{}]+)*)/.exec(re.source);
	    return (prefix != null) ? prefix[1].replace(/\\(.)/g, "$1") : '';
	  }
	
	  // Interpolates matched values into a String.replace()-style pattern
	  function interpolate(pattern, match) {
	    return pattern.replace(/\$(\$|\d{1,2})/, function (m, what) {
	      return match[what === '$' ? 0 : Number(what)];
	    });
	  }
	
	  /**
	   * @ngdoc function
	   * @name ui.router.router.$urlRouterProvider#rule
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Defines rules that are used by `$urlRouterProvider` to find matches for
	   * specific URLs.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *   // Here's an example of how you might allow case insensitive urls
	   *   $urlRouterProvider.rule(function ($injector, $location) {
	   *     var path = $location.path(),
	   *         normalized = path.toLowerCase();
	   *
	   *     if (path !== normalized) {
	   *       return normalized;
	   *     }
	   *   });
	   * });
	   * </pre>
	   *
	   * @param {function} rule Handler function that takes `$injector` and `$location`
	   * services as arguments. You can use them to return a valid path as a string.
	   *
	   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
	   */
	  this.rule = function (rule) {
	    if (!isFunction(rule)) throw new Error("'rule' must be a function");
	    rules.push(rule);
	    return this;
	  };
	
	  /**
	   * @ngdoc object
	   * @name ui.router.router.$urlRouterProvider#otherwise
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Defines a path that is used when an invalid route is requested.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *   // if the path doesn't match any of the urls you configured
	   *   // otherwise will take care of routing the user to the
	   *   // specified url
	   *   $urlRouterProvider.otherwise('/index');
	   *
	   *   // Example of using function rule as param
	   *   $urlRouterProvider.otherwise(function ($injector, $location) {
	   *     return '/a/valid/url';
	   *   });
	   * });
	   * </pre>
	   *
	   * @param {string|function} rule The url path you want to redirect to or a function 
	   * rule that returns the url path. The function version is passed two params: 
	   * `$injector` and `$location` services, and must return a url string.
	   *
	   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
	   */
	  this.otherwise = function (rule) {
	    if (isString(rule)) {
	      var redirect = rule;
	      rule = function () { return redirect; };
	    }
	    else if (!isFunction(rule)) throw new Error("'rule' must be a function");
	    otherwise = rule;
	    return this;
	  };
	
	
	  function handleIfMatch($injector, handler, match) {
	    if (!match) return false;
	    var result = $injector.invoke(handler, handler, { $match: match });
	    return isDefined(result) ? result : true;
	  }
	
	  /**
	   * @ngdoc function
	   * @name ui.router.router.$urlRouterProvider#when
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Registers a handler for a given url matching. 
	   * 
	   * If the handler is a string, it is
	   * treated as a redirect, and is interpolated according to the syntax of match
	   * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
	   *
	   * If the handler is a function, it is injectable. It gets invoked if `$location`
	   * matches. You have the option of inject the match object as `$match`.
	   *
	   * The handler can return
	   *
	   * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
	   *   will continue trying to find another one that matches.
	   * - **string** which is treated as a redirect and passed to `$location.url()`
	   * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
	   *     if ($state.$current.navigable !== state ||
	   *         !equalForKeys($match, $stateParams) {
	   *      $state.transitionTo(state, $match, false);
	   *     }
	   *   });
	   * });
	   * </pre>
	   *
	   * @param {string|object} what The incoming path that you want to redirect.
	   * @param {string|function} handler The path you want to redirect your user to.
	   */
	  this.when = function (what, handler) {
	    var redirect, handlerIsString = isString(handler);
	    if (isString(what)) what = $urlMatcherFactory.compile(what);
	
	    if (!handlerIsString && !isFunction(handler) && !isArray(handler))
	      throw new Error("invalid 'handler' in when()");
	
	    var strategies = {
	      matcher: function (what, handler) {
	        if (handlerIsString) {
	          redirect = $urlMatcherFactory.compile(handler);
	          handler = ['$match', function ($match) { return redirect.format($match); }];
	        }
	        return extend(function ($injector, $location) {
	          return handleIfMatch($injector, handler, what.exec($location.path(), $location.search()));
	        }, {
	          prefix: isString(what.prefix) ? what.prefix : ''
	        });
	      },
	      regex: function (what, handler) {
	        if (what.global || what.sticky) throw new Error("when() RegExp must not be global or sticky");
	
	        if (handlerIsString) {
	          redirect = handler;
	          handler = ['$match', function ($match) { return interpolate(redirect, $match); }];
	        }
	        return extend(function ($injector, $location) {
	          return handleIfMatch($injector, handler, what.exec($location.path()));
	        }, {
	          prefix: regExpPrefix(what)
	        });
	      }
	    };
	
	    var check = { matcher: $urlMatcherFactory.isMatcher(what), regex: what instanceof RegExp };
	
	    for (var n in check) {
	      if (check[n]) return this.rule(strategies[n](what, handler));
	    }
	
	    throw new Error("invalid 'what' in when()");
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.router.$urlRouterProvider#deferIntercept
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Disables (or enables) deferring location change interception.
	   *
	   * If you wish to customize the behavior of syncing the URL (for example, if you wish to
	   * defer a transition but maintain the current URL), call this method at configuration time.
	   * Then, at run time, call `$urlRouter.listen()` after you have configured your own
	   * `$locationChangeSuccess` event handler.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *
	   *   // Prevent $urlRouter from automatically intercepting URL changes;
	   *   // this allows you to configure custom behavior in between
	   *   // location changes and route synchronization:
	   *   $urlRouterProvider.deferIntercept();
	   *
	   * }).run(function ($rootScope, $urlRouter, UserService) {
	   *
	   *   $rootScope.$on('$locationChangeSuccess', function(e) {
	   *     // UserService is an example service for managing user state
	   *     if (UserService.isLoggedIn()) return;
	   *
	   *     // Prevent $urlRouter's default handler from firing
	   *     e.preventDefault();
	   *
	   *     UserService.handleLogin().then(function() {
	   *       // Once the user has logged in, sync the current URL
	   *       // to the router:
	   *       $urlRouter.sync();
	   *     });
	   *   });
	   *
	   *   // Configures $urlRouter's listener *after* your custom listener
	   *   $urlRouter.listen();
	   * });
	   * </pre>
	   *
	   * @param {boolean} defer Indicates whether to defer location change interception. Passing
	            no parameter is equivalent to `true`.
	   */
	  this.deferIntercept = function (defer) {
	    if (defer === undefined) defer = true;
	    interceptDeferred = defer;
	  };
	
	  /**
	   * @ngdoc object
	   * @name ui.router.router.$urlRouter
	   *
	   * @requires $location
	   * @requires $rootScope
	   * @requires $injector
	   * @requires $browser
	   *
	   * @description
	   *
	   */
	  this.$get = $get;
	  $get.$inject = ['$location', '$rootScope', '$injector', '$browser', '$sniffer'];
	  function $get(   $location,   $rootScope,   $injector,   $browser,   $sniffer) {
	
	    var baseHref = $browser.baseHref(), location = $location.url(), lastPushedUrl;
	
	    function appendBasePath(url, isHtml5, absolute) {
	      if (baseHref === '/') return url;
	      if (isHtml5) return baseHref.slice(0, -1) + url;
	      if (absolute) return baseHref.slice(1) + url;
	      return url;
	    }
	
	    // TODO: Optimize groups of rules with non-empty prefix into some sort of decision tree
	    function update(evt) {
	      if (evt && evt.defaultPrevented) return;
	      var ignoreUpdate = lastPushedUrl && $location.url() === lastPushedUrl;
	      lastPushedUrl = undefined;
	      // TODO: Re-implement this in 1.0 for https://github.com/angular-ui/ui-router/issues/1573
	      //if (ignoreUpdate) return true;
	
	      function check(rule) {
	        var handled = rule($injector, $location);
	
	        if (!handled) return false;
	        if (isString(handled)) $location.replace().url(handled);
	        return true;
	      }
	      var n = rules.length, i;
	
	      for (i = 0; i < n; i++) {
	        if (check(rules[i])) return;
	      }
	      // always check otherwise last to allow dynamic updates to the set of rules
	      if (otherwise) check(otherwise);
	    }
	
	    function listen() {
	      listener = listener || $rootScope.$on('$locationChangeSuccess', update);
	      return listener;
	    }
	
	    if (!interceptDeferred) listen();
	
	    return {
	      /**
	       * @ngdoc function
	       * @name ui.router.router.$urlRouter#sync
	       * @methodOf ui.router.router.$urlRouter
	       *
	       * @description
	       * Triggers an update; the same update that happens when the address bar url changes, aka `$locationChangeSuccess`.
	       * This method is useful when you need to use `preventDefault()` on the `$locationChangeSuccess` event,
	       * perform some custom logic (route protection, auth, config, redirection, etc) and then finally proceed
	       * with the transition by calling `$urlRouter.sync()`.
	       *
	       * @example
	       * <pre>
	       * angular.module('app', ['ui.router'])
	       *   .run(function($rootScope, $urlRouter) {
	       *     $rootScope.$on('$locationChangeSuccess', function(evt) {
	       *       // Halt state change from even starting
	       *       evt.preventDefault();
	       *       // Perform custom logic
	       *       var meetsRequirement = ...
	       *       // Continue with the update and state transition if logic allows
	       *       if (meetsRequirement) $urlRouter.sync();
	       *     });
	       * });
	       * </pre>
	       */
	      sync: function() {
	        update();
	      },
	
	      listen: function() {
	        return listen();
	      },
	
	      update: function(read) {
	        if (read) {
	          location = $location.url();
	          return;
	        }
	        if ($location.url() === location) return;
	
	        $location.url(location);
	        $location.replace();
	      },
	
	      push: function(urlMatcher, params, options) {
	         var url = urlMatcher.format(params || {});
	
	        // Handle the special hash param, if needed
	        if (url !== null && params && params['#']) {
	            url += '#' + params['#'];
	        }
	
	        $location.url(url);
	        lastPushedUrl = options && options.$$avoidResync ? $location.url() : undefined;
	        if (options && options.replace) $location.replace();
	      },
	
	      /**
	       * @ngdoc function
	       * @name ui.router.router.$urlRouter#href
	       * @methodOf ui.router.router.$urlRouter
	       *
	       * @description
	       * A URL generation method that returns the compiled URL for a given
	       * {@link ui.router.util.type:UrlMatcher `UrlMatcher`}, populated with the provided parameters.
	       *
	       * @example
	       * <pre>
	       * $bob = $urlRouter.href(new UrlMatcher("/about/:person"), {
	       *   person: "bob"
	       * });
	       * // $bob == "/about/bob";
	       * </pre>
	       *
	       * @param {UrlMatcher} urlMatcher The `UrlMatcher` object which is used as the template of the URL to generate.
	       * @param {object=} params An object of parameter values to fill the matcher's required parameters.
	       * @param {object=} options Options object. The options are:
	       *
	       * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
	       *
	       * @returns {string} Returns the fully compiled URL, or `null` if `params` fail validation against `urlMatcher`
	       */
	      href: function(urlMatcher, params, options) {
	        if (!urlMatcher.validates(params)) return null;
	
	        var isHtml5 = $locationProvider.html5Mode();
	        if (angular.isObject(isHtml5)) {
	          isHtml5 = isHtml5.enabled;
	        }
	
	        isHtml5 = isHtml5 && $sniffer.history;
	        
	        var url = urlMatcher.format(params);
	        options = options || {};
	
	        if (!isHtml5 && url !== null) {
	          url = "#" + $locationProvider.hashPrefix() + url;
	        }
	
	        // Handle special hash param, if needed
	        if (url !== null && params && params['#']) {
	          url += '#' + params['#'];
	        }
	
	        url = appendBasePath(url, isHtml5, options.absolute);
	
	        if (!options.absolute || !url) {
	          return url;
	        }
	
	        var slash = (!isHtml5 && url ? '/' : ''), port = $location.port();
	        port = (port === 80 || port === 443 ? '' : ':' + port);
	
	        return [$location.protocol(), '://', $location.host(), port, slash, url].join('');
	      }
	    };
	  }
	}
	
	angular.module('ui.router.router').provider('$urlRouter', $UrlRouterProvider);
	
	/**
	 * @ngdoc object
	 * @name ui.router.state.$stateProvider
	 *
	 * @requires ui.router.router.$urlRouterProvider
	 * @requires ui.router.util.$urlMatcherFactoryProvider
	 *
	 * @description
	 * The new `$stateProvider` works similar to Angular's v1 router, but it focuses purely
	 * on state.
	 *
	 * A state corresponds to a "place" in the application in terms of the overall UI and
	 * navigation. A state describes (via the controller / template / view properties) what
	 * the UI looks like and does at that place.
	 *
	 * States often have things in common, and the primary way of factoring out these
	 * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
	 * nested states.
	 *
	 * The `$stateProvider` provides interfaces to declare these states for your app.
	 */
	$StateProvider.$inject = ['$urlRouterProvider', '$urlMatcherFactoryProvider'];
	function $StateProvider(   $urlRouterProvider,   $urlMatcherFactory) {
	
	  var root, states = {}, $state, queue = {}, abstractKey = 'abstract';
	
	  // Builds state properties from definition passed to registerState()
	  var stateBuilder = {
	
	    // Derive parent state from a hierarchical name only if 'parent' is not explicitly defined.
	    // state.children = [];
	    // if (parent) parent.children.push(state);
	    parent: function(state) {
	      if (isDefined(state.parent) && state.parent) return findState(state.parent);
	      // regex matches any valid composite state name
	      // would match "contact.list" but not "contacts"
	      var compositeName = /^(.+)\.[^.]+$/.exec(state.name);
	      return compositeName ? findState(compositeName[1]) : root;
	    },
	
	    // inherit 'data' from parent and override by own values (if any)
	    data: function(state) {
	      if (state.parent && state.parent.data) {
	        state.data = state.self.data = inherit(state.parent.data, state.data);
	      }
	      return state.data;
	    },
	
	    // Build a URLMatcher if necessary, either via a relative or absolute URL
	    url: function(state) {
	      var url = state.url, config = { params: state.params || {} };
	
	      if (isString(url)) {
	        if (url.charAt(0) == '^') return $urlMatcherFactory.compile(url.substring(1), config);
	        return (state.parent.navigable || root).url.concat(url, config);
	      }
	
	      if (!url || $urlMatcherFactory.isMatcher(url)) return url;
	      throw new Error("Invalid url '" + url + "' in state '" + state + "'");
	    },
	
	    // Keep track of the closest ancestor state that has a URL (i.e. is navigable)
	    navigable: function(state) {
	      return state.url ? state : (state.parent ? state.parent.navigable : null);
	    },
	
	    // Own parameters for this state. state.url.params is already built at this point. Create and add non-url params
	    ownParams: function(state) {
	      var params = state.url && state.url.params || new $$UMFP.ParamSet();
	      forEach(state.params || {}, function(config, id) {
	        if (!params[id]) params[id] = new $$UMFP.Param(id, null, config, "config");
	      });
	      return params;
	    },
	
	    // Derive parameters for this state and ensure they're a super-set of parent's parameters
	    params: function(state) {
	      var ownParams = pick(state.ownParams, state.ownParams.$$keys());
	      return state.parent && state.parent.params ? extend(state.parent.params.$$new(), ownParams) : new $$UMFP.ParamSet();
	    },
	
	    // If there is no explicit multi-view configuration, make one up so we don't have
	    // to handle both cases in the view directive later. Note that having an explicit
	    // 'views' property will mean the default unnamed view properties are ignored. This
	    // is also a good time to resolve view names to absolute names, so everything is a
	    // straight lookup at link time.
	    views: function(state) {
	      var views = {};
	
	      forEach(isDefined(state.views) ? state.views : { '': state }, function (view, name) {
	        if (name.indexOf('@') < 0) name += '@' + state.parent.name;
	        view.resolveAs = view.resolveAs || state.resolveAs || '$resolve';
	        views[name] = view;
	      });
	      return views;
	    },
	
	    // Keep a full path from the root down to this state as this is needed for state activation.
	    path: function(state) {
	      return state.parent ? state.parent.path.concat(state) : []; // exclude root from path
	    },
	
	    // Speed up $state.contains() as it's used a lot
	    includes: function(state) {
	      var includes = state.parent ? extend({}, state.parent.includes) : {};
	      includes[state.name] = true;
	      return includes;
	    },
	
	    $delegates: {}
	  };
	
	  function isRelative(stateName) {
	    return stateName.indexOf(".") === 0 || stateName.indexOf("^") === 0;
	  }
	
	  function findState(stateOrName, base) {
	    if (!stateOrName) return undefined;
	
	    var isStr = isString(stateOrName),
	        name  = isStr ? stateOrName : stateOrName.name,
	        path  = isRelative(name);
	
	    if (path) {
	      if (!base) throw new Error("No reference point given for path '"  + name + "'");
	      base = findState(base);
	      
	      var rel = name.split("."), i = 0, pathLength = rel.length, current = base;
	
	      for (; i < pathLength; i++) {
	        if (rel[i] === "" && i === 0) {
	          current = base;
	          continue;
	        }
	        if (rel[i] === "^") {
	          if (!current.parent) throw new Error("Path '" + name + "' not valid for state '" + base.name + "'");
	          current = current.parent;
	          continue;
	        }
	        break;
	      }
	      rel = rel.slice(i).join(".");
	      name = current.name + (current.name && rel ? "." : "") + rel;
	    }
	    var state = states[name];
	
	    if (state && (isStr || (!isStr && (state === stateOrName || state.self === stateOrName)))) {
	      return state;
	    }
	    return undefined;
	  }
	
	  function queueState(parentName, state) {
	    if (!queue[parentName]) {
	      queue[parentName] = [];
	    }
	    queue[parentName].push(state);
	  }
	
	  function flushQueuedChildren(parentName) {
	    var queued = queue[parentName] || [];
	    while(queued.length) {
	      registerState(queued.shift());
	    }
	  }
	
	  function registerState(state) {
	    // Wrap a new object around the state so we can store our private details easily.
	    state = inherit(state, {
	      self: state,
	      resolve: state.resolve || {},
	      toString: function() { return this.name; }
	    });
	
	    var name = state.name;
	    if (!isString(name) || name.indexOf('@') >= 0) throw new Error("State must have a valid name");
	    if (states.hasOwnProperty(name)) throw new Error("State '" + name + "' is already defined");
	
	    // Get parent name
	    var parentName = (name.indexOf('.') !== -1) ? name.substring(0, name.lastIndexOf('.'))
	        : (isString(state.parent)) ? state.parent
	        : (isObject(state.parent) && isString(state.parent.name)) ? state.parent.name
	        : '';
	
	    // If parent is not registered yet, add state to queue and register later
	    if (parentName && !states[parentName]) {
	      return queueState(parentName, state.self);
	    }
	
	    for (var key in stateBuilder) {
	      if (isFunction(stateBuilder[key])) state[key] = stateBuilder[key](state, stateBuilder.$delegates[key]);
	    }
	    states[name] = state;
	
	    // Register the state in the global state list and with $urlRouter if necessary.
	    if (!state[abstractKey] && state.url) {
	      $urlRouterProvider.when(state.url, ['$match', '$stateParams', function ($match, $stateParams) {
	        if ($state.$current.navigable != state || !equalForKeys($match, $stateParams)) {
	          $state.transitionTo(state, $match, { inherit: true, location: false });
	        }
	      }]);
	    }
	
	    // Register any queued children
	    flushQueuedChildren(name);
	
	    return state;
	  }
	
	  // Checks text to see if it looks like a glob.
	  function isGlob (text) {
	    return text.indexOf('*') > -1;
	  }
	
	  // Returns true if glob matches current $state name.
	  function doesStateMatchGlob (glob) {
	    var globSegments = glob.split('.'),
	        segments = $state.$current.name.split('.');
	
	    //match single stars
	    for (var i = 0, l = globSegments.length; i < l; i++) {
	      if (globSegments[i] === '*') {
	        segments[i] = '*';
	      }
	    }
	
	    //match greedy starts
	    if (globSegments[0] === '**') {
	       segments = segments.slice(indexOf(segments, globSegments[1]));
	       segments.unshift('**');
	    }
	    //match greedy ends
	    if (globSegments[globSegments.length - 1] === '**') {
	       segments.splice(indexOf(segments, globSegments[globSegments.length - 2]) + 1, Number.MAX_VALUE);
	       segments.push('**');
	    }
	
	    if (globSegments.length != segments.length) {
	      return false;
	    }
	
	    return segments.join('') === globSegments.join('');
	  }
	
	
	  // Implicit root state that is always active
	  root = registerState({
	    name: '',
	    url: '^',
	    views: null,
	    'abstract': true
	  });
	  root.navigable = null;
	
	
	  /**
	   * @ngdoc function
	   * @name ui.router.state.$stateProvider#decorator
	   * @methodOf ui.router.state.$stateProvider
	   *
	   * @description
	   * Allows you to extend (carefully) or override (at your own peril) the 
	   * `stateBuilder` object used internally by `$stateProvider`. This can be used 
	   * to add custom functionality to ui-router, for example inferring templateUrl 
	   * based on the state name.
	   *
	   * When passing only a name, it returns the current (original or decorated) builder
	   * function that matches `name`.
	   *
	   * The builder functions that can be decorated are listed below. Though not all
	   * necessarily have a good use case for decoration, that is up to you to decide.
	   *
	   * In addition, users can attach custom decorators, which will generate new 
	   * properties within the state's internal definition. There is currently no clear 
	   * use-case for this beyond accessing internal states (i.e. $state.$current), 
	   * however, expect this to become increasingly relevant as we introduce additional 
	   * meta-programming features.
	   *
	   * **Warning**: Decorators should not be interdependent because the order of 
	   * execution of the builder functions in non-deterministic. Builder functions 
	   * should only be dependent on the state definition object and super function.
	   *
	   *
	   * Existing builder functions and current return values:
	   *
	   * - **parent** `{object}` - returns the parent state object.
	   * - **data** `{object}` - returns state data, including any inherited data that is not
	   *   overridden by own values (if any).
	   * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
	   *   or `null`.
	   * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is 
	   *   navigable).
	   * - **params** `{object}` - returns an array of state params that are ensured to 
	   *   be a super-set of parent's params.
	   * - **views** `{object}` - returns a views object where each key is an absolute view 
	   *   name (i.e. "viewName@stateName") and each value is the config object 
	   *   (template, controller) for the view. Even when you don't use the views object 
	   *   explicitly on a state config, one is still created for you internally.
	   *   So by decorating this builder function you have access to decorating template 
	   *   and controller properties.
	   * - **ownParams** `{object}` - returns an array of params that belong to the state, 
	   *   not including any params defined by ancestor states.
	   * - **path** `{string}` - returns the full path from the root down to this state. 
	   *   Needed for state activation.
	   * - **includes** `{object}` - returns an object that includes every state that 
	   *   would pass a `$state.includes()` test.
	   *
	   * @example
	   * <pre>
	   * // Override the internal 'views' builder with a function that takes the state
	   * // definition, and a reference to the internal function being overridden:
	   * $stateProvider.decorator('views', function (state, parent) {
	   *   var result = {},
	   *       views = parent(state);
	   *
	   *   angular.forEach(views, function (config, name) {
	   *     var autoName = (state.name + '.' + name).replace('.', '/');
	   *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
	   *     result[name] = config;
	   *   });
	   *   return result;
	   * });
	   *
	   * $stateProvider.state('home', {
	   *   views: {
	   *     'contact.list': { controller: 'ListController' },
	   *     'contact.item': { controller: 'ItemController' }
	   *   }
	   * });
	   *
	   * // ...
	   *
	   * $state.go('home');
	   * // Auto-populates list and item views with /partials/home/contact/list.html,
	   * // and /partials/home/contact/item.html, respectively.
	   * </pre>
	   *
	   * @param {string} name The name of the builder function to decorate. 
	   * @param {object} func A function that is responsible for decorating the original 
	   * builder function. The function receives two parameters:
	   *
	   *   - `{object}` - state - The state config object.
	   *   - `{object}` - super - The original builder function.
	   *
	   * @return {object} $stateProvider - $stateProvider instance
	   */
	  this.decorator = decorator;
	  function decorator(name, func) {
	    /*jshint validthis: true */
	    if (isString(name) && !isDefined(func)) {
	      return stateBuilder[name];
	    }
	    if (!isFunction(func) || !isString(name)) {
	      return this;
	    }
	    if (stateBuilder[name] && !stateBuilder.$delegates[name]) {
	      stateBuilder.$delegates[name] = stateBuilder[name];
	    }
	    stateBuilder[name] = func;
	    return this;
	  }
	
	  /**
	   * @ngdoc function
	   * @name ui.router.state.$stateProvider#state
	   * @methodOf ui.router.state.$stateProvider
	   *
	   * @description
	   * Registers a state configuration under a given state name. The stateConfig object
	   * has the following acceptable properties.
	   *
	   * @param {string} name A unique state name, e.g. "home", "about", "contacts".
	   * To create a parent/child state use a dot, e.g. "about.sales", "home.newest".
	   * @param {object} stateConfig State configuration object.
	   * @param {string|function=} stateConfig.template
	   * <a id='template'></a>
	   *   html template as a string or a function that returns
	   *   an html template as a string which should be used by the uiView directives. This property 
	   *   takes precedence over templateUrl.
	   *   
	   *   If `template` is a function, it will be called with the following parameters:
	   *
	   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by
	   *     applying the current state
	   *
	   * <pre>template:
	   *   "<h1>inline template definition</h1>" +
	   *   "<div ui-view></div>"</pre>
	   * <pre>template: function(params) {
	   *       return "<h1>generated template</h1>"; }</pre>
	   * </div>
	   *
	   * @param {string|function=} stateConfig.templateUrl
	   * <a id='templateUrl'></a>
	   *
	   *   path or function that returns a path to an html
	   *   template that should be used by uiView.
	   *   
	   *   If `templateUrl` is a function, it will be called with the following parameters:
	   *
	   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by 
	   *     applying the current state
	   *
	   * <pre>templateUrl: "home.html"</pre>
	   * <pre>templateUrl: function(params) {
	   *     return myTemplates[params.pageId]; }</pre>
	   *
	   * @param {function=} stateConfig.templateProvider
	   * <a id='templateProvider'></a>
	   *    Provider function that returns HTML content string.
	   * <pre> templateProvider:
	   *       function(MyTemplateService, params) {
	   *         return MyTemplateService.getTemplate(params.pageId);
	   *       }</pre>
	   *
	   * @param {string|function=} stateConfig.controller
	   * <a id='controller'></a>
	   *
	   *  Controller fn that should be associated with newly
	   *   related scope or the name of a registered controller if passed as a string.
	   *   Optionally, the ControllerAs may be declared here.
	   * <pre>controller: "MyRegisteredController"</pre>
	   * <pre>controller:
	   *     "MyRegisteredController as fooCtrl"}</pre>
	   * <pre>controller: function($scope, MyService) {
	   *     $scope.data = MyService.getData(); }</pre>
	   *
	   * @param {function=} stateConfig.controllerProvider
	   * <a id='controllerProvider'></a>
	   *
	   * Injectable provider function that returns the actual controller or string.
	   * <pre>controllerProvider:
	   *   function(MyResolveData) {
	   *     if (MyResolveData.foo)
	   *       return "FooCtrl"
	   *     else if (MyResolveData.bar)
	   *       return "BarCtrl";
	   *     else return function($scope) {
	   *       $scope.baz = "Qux";
	   *     }
	   *   }</pre>
	   *
	   * @param {string=} stateConfig.controllerAs
	   * <a id='controllerAs'></a>
	   * 
	   * A controller alias name. If present the controller will be
	   *   published to scope under the controllerAs name.
	   * <pre>controllerAs: "myCtrl"</pre>
	   *
	   * @param {string|object=} stateConfig.parent
	   * <a id='parent'></a>
	   * Optionally specifies the parent state of this state.
	   *
	   * <pre>parent: 'parentState'</pre>
	   * <pre>parent: parentState // JS variable</pre>
	   *
	   * @param {object=} stateConfig.resolve
	   * <a id='resolve'></a>
	   *
	   * An optional map&lt;string, function&gt; of dependencies which
	   *   should be injected into the controller. If any of these dependencies are promises, 
	   *   the router will wait for them all to be resolved before the controller is instantiated.
	   *   If all the promises are resolved successfully, the $stateChangeSuccess event is fired
	   *   and the values of the resolved promises are injected into any controllers that reference them.
	   *   If any  of the promises are rejected the $stateChangeError event is fired.
	   *
	   *   The map object is:
	   *   
	   *   - key - {string}: name of dependency to be injected into controller
	   *   - factory - {string|function}: If string then it is alias for service. Otherwise if function, 
	   *     it is injected and return value it treated as dependency. If result is a promise, it is 
	   *     resolved before its value is injected into controller.
	   *
	   * <pre>resolve: {
	   *     myResolve1:
	   *       function($http, $stateParams) {
	   *         return $http.get("/api/foos/"+stateParams.fooID);
	   *       }
	   *     }</pre>
	   *
	   * @param {string=} stateConfig.url
	   * <a id='url'></a>
	   *
	   *   A url fragment with optional parameters. When a state is navigated or
	   *   transitioned to, the `$stateParams` service will be populated with any 
	   *   parameters that were passed.
	   *
	   *   (See {@link ui.router.util.type:UrlMatcher UrlMatcher} `UrlMatcher`} for
	   *   more details on acceptable patterns )
	   *
	   * examples:
	   * <pre>url: "/home"
	   * url: "/users/:userid"
	   * url: "/books/{bookid:[a-zA-Z_-]}"
	   * url: "/books/{categoryid:int}"
	   * url: "/books/{publishername:string}/{categoryid:int}"
	   * url: "/messages?before&after"
	   * url: "/messages?{before:date}&{after:date}"
	   * url: "/messages/:mailboxid?{before:date}&{after:date}"
	   * </pre>
	   *
	   * @param {object=} stateConfig.views
	   * <a id='views'></a>
	   * an optional map&lt;string, object&gt; which defined multiple views, or targets views
	   * manually/explicitly.
	   *
	   * Examples:
	   *
	   * Targets three named `ui-view`s in the parent state's template
	   * <pre>views: {
	   *     header: {
	   *       controller: "headerCtrl",
	   *       templateUrl: "header.html"
	   *     }, body: {
	   *       controller: "bodyCtrl",
	   *       templateUrl: "body.html"
	   *     }, footer: {
	   *       controller: "footCtrl",
	   *       templateUrl: "footer.html"
	   *     }
	   *   }</pre>
	   *
	   * Targets named `ui-view="header"` from grandparent state 'top''s template, and named `ui-view="body" from parent state's template.
	   * <pre>views: {
	   *     'header@top': {
	   *       controller: "msgHeaderCtrl",
	   *       templateUrl: "msgHeader.html"
	   *     }, 'body': {
	   *       controller: "messagesCtrl",
	   *       templateUrl: "messages.html"
	   *     }
	   *   }</pre>
	   *
	   * @param {boolean=} [stateConfig.abstract=false]
	   * <a id='abstract'></a>
	   * An abstract state will never be directly activated,
	   *   but can provide inherited properties to its common children states.
	   * <pre>abstract: true</pre>
	   *
	   * @param {function=} stateConfig.onEnter
	   * <a id='onEnter'></a>
	   *
	   * Callback function for when a state is entered. Good way
	   *   to trigger an action or dispatch an event, such as opening a dialog.
	   * If minifying your scripts, make sure to explicitly annotate this function,
	   * because it won't be automatically annotated by your build tools.
	   *
	   * <pre>onEnter: function(MyService, $stateParams) {
	   *     MyService.foo($stateParams.myParam);
	   * }</pre>
	   *
	   * @param {function=} stateConfig.onExit
	   * <a id='onExit'></a>
	   *
	   * Callback function for when a state is exited. Good way to
	   *   trigger an action or dispatch an event, such as opening a dialog.
	   * If minifying your scripts, make sure to explicitly annotate this function,
	   * because it won't be automatically annotated by your build tools.
	   *
	   * <pre>onExit: function(MyService, $stateParams) {
	   *     MyService.cleanup($stateParams.myParam);
	   * }</pre>
	   *
	   * @param {boolean=} [stateConfig.reloadOnSearch=true]
	   * <a id='reloadOnSearch'></a>
	   *
	   * If `false`, will not retrigger the same state
	   *   just because a search/query parameter has changed (via $location.search() or $location.hash()). 
	   *   Useful for when you'd like to modify $location.search() without triggering a reload.
	   * <pre>reloadOnSearch: false</pre>
	   *
	   * @param {object=} stateConfig.data
	   * <a id='data'></a>
	   *
	   * Arbitrary data object, useful for custom configuration.  The parent state's `data` is
	   *   prototypally inherited.  In other words, adding a data property to a state adds it to
	   *   the entire subtree via prototypal inheritance.
	   *
	   * <pre>data: {
	   *     requiredRole: 'foo'
	   * } </pre>
	   *
	   * @param {object=} stateConfig.params
	   * <a id='params'></a>
	   *
	   * A map which optionally configures parameters declared in the `url`, or
	   *   defines additional non-url parameters.  For each parameter being
	   *   configured, add a configuration object keyed to the name of the parameter.
	   *
	   *   Each parameter configuration object may contain the following properties:
	   *
	   *   - ** value ** - {object|function=}: specifies the default value for this
	   *     parameter.  This implicitly sets this parameter as optional.
	   *
	   *     When UI-Router routes to a state and no value is
	   *     specified for this parameter in the URL or transition, the
	   *     default value will be used instead.  If `value` is a function,
	   *     it will be injected and invoked, and the return value used.
	   *
	   *     *Note*: `undefined` is treated as "no default value" while `null`
	   *     is treated as "the default value is `null`".
	   *
	   *     *Shorthand*: If you only need to configure the default value of the
	   *     parameter, you may use a shorthand syntax.   In the **`params`**
	   *     map, instead mapping the param name to a full parameter configuration
	   *     object, simply set map it to the default parameter value, e.g.:
	   *
	   * <pre>// define a parameter's default value
	   * params: {
	   *     param1: { value: "defaultValue" }
	   * }
	   * // shorthand default values
	   * params: {
	   *     param1: "defaultValue",
	   *     param2: "param2Default"
	   * }</pre>
	   *
	   *   - ** array ** - {boolean=}: *(default: false)* If true, the param value will be
	   *     treated as an array of values.  If you specified a Type, the value will be
	   *     treated as an array of the specified Type.  Note: query parameter values
	   *     default to a special `"auto"` mode.
	   *
	   *     For query parameters in `"auto"` mode, if multiple  values for a single parameter
	   *     are present in the URL (e.g.: `/foo?bar=1&bar=2&bar=3`) then the values
	   *     are mapped to an array (e.g.: `{ foo: [ '1', '2', '3' ] }`).  However, if
	   *     only one value is present (e.g.: `/foo?bar=1`) then the value is treated as single
	   *     value (e.g.: `{ foo: '1' }`).
	   *
	   * <pre>params: {
	   *     param1: { array: true }
	   * }</pre>
	   *
	   *   - ** squash ** - {bool|string=}: `squash` configures how a default parameter value is represented in the URL when
	   *     the current parameter value is the same as the default value. If `squash` is not set, it uses the
	   *     configured default squash policy.
	   *     (See {@link ui.router.util.$urlMatcherFactory#methods_defaultSquashPolicy `defaultSquashPolicy()`})
	   *
	   *   There are three squash settings:
	   *
	   *     - false: The parameter's default value is not squashed.  It is encoded and included in the URL
	   *     - true: The parameter's default value is omitted from the URL.  If the parameter is preceeded and followed
	   *       by slashes in the state's `url` declaration, then one of those slashes are omitted.
	   *       This can allow for cleaner looking URLs.
	   *     - `"<arbitrary string>"`: The parameter's default value is replaced with an arbitrary placeholder of  your choice.
	   *
	   * <pre>params: {
	   *     param1: {
	   *       value: "defaultId",
	   *       squash: true
	   * } }
	   * // squash "defaultValue" to "~"
	   * params: {
	   *     param1: {
	   *       value: "defaultValue",
	   *       squash: "~"
	   * } }
	   * </pre>
	   *
	   *
	   * @example
	   * <pre>
	   * // Some state name examples
	   *
	   * // stateName can be a single top-level name (must be unique).
	   * $stateProvider.state("home", {});
	   *
	   * // Or it can be a nested state name. This state is a child of the
	   * // above "home" state.
	   * $stateProvider.state("home.newest", {});
	   *
	   * // Nest states as deeply as needed.
	   * $stateProvider.state("home.newest.abc.xyz.inception", {});
	   *
	   * // state() returns $stateProvider, so you can chain state declarations.
	   * $stateProvider
	   *   .state("home", {})
	   *   .state("about", {})
	   *   .state("contacts", {});
	   * </pre>
	   *
	   */
	  this.state = state;
	  function state(name, definition) {
	    /*jshint validthis: true */
	    if (isObject(name)) definition = name;
	    else definition.name = name;
	    registerState(definition);
	    return this;
	  }
	
	  /**
	   * @ngdoc object
	   * @name ui.router.state.$state
	   *
	   * @requires $rootScope
	   * @requires $q
	   * @requires ui.router.state.$view
	   * @requires $injector
	   * @requires ui.router.util.$resolve
	   * @requires ui.router.state.$stateParams
	   * @requires ui.router.router.$urlRouter
	   *
	   * @property {object} params A param object, e.g. {sectionId: section.id)}, that 
	   * you'd like to test against the current active state.
	   * @property {object} current A reference to the state's config object. However 
	   * you passed it in. Useful for accessing custom data.
	   * @property {object} transition Currently pending transition. A promise that'll 
	   * resolve or reject.
	   *
	   * @description
	   * `$state` service is responsible for representing states as well as transitioning
	   * between them. It also provides interfaces to ask for current state or even states
	   * you're coming from.
	   */
	  this.$get = $get;
	  $get.$inject = ['$rootScope', '$q', '$view', '$injector', '$resolve', '$stateParams', '$urlRouter', '$location', '$urlMatcherFactory'];
	  function $get(   $rootScope,   $q,   $view,   $injector,   $resolve,   $stateParams,   $urlRouter,   $location,   $urlMatcherFactory) {
	
	    var TransitionSupersededError = new Error('transition superseded');
	
	    var TransitionSuperseded = silenceUncaughtInPromise($q.reject(TransitionSupersededError));
	    var TransitionPrevented = silenceUncaughtInPromise($q.reject(new Error('transition prevented')));
	    var TransitionAborted = silenceUncaughtInPromise($q.reject(new Error('transition aborted')));
	    var TransitionFailed = silenceUncaughtInPromise($q.reject(new Error('transition failed')));
	
	    // Handles the case where a state which is the target of a transition is not found, and the user
	    // can optionally retry or defer the transition
	    function handleRedirect(redirect, state, params, options) {
	      /**
	       * @ngdoc event
	       * @name ui.router.state.$state#$stateNotFound
	       * @eventOf ui.router.state.$state
	       * @eventType broadcast on root scope
	       * @description
	       * Fired when a requested state **cannot be found** using the provided state name during transition.
	       * The event is broadcast allowing any handlers a single chance to deal with the error (usually by
	       * lazy-loading the unfound state). A special `unfoundState` object is passed to the listener handler,
	       * you can see its three properties in the example. You can use `event.preventDefault()` to abort the
	       * transition and the promise returned from `go` will be rejected with a `'transition aborted'` value.
	       *
	       * @param {Object} event Event object.
	       * @param {Object} unfoundState Unfound State information. Contains: `to, toParams, options` properties.
	       * @param {State} fromState Current state object.
	       * @param {Object} fromParams Current state params.
	       *
	       * @example
	       *
	       * <pre>
	       * // somewhere, assume lazy.state has not been defined
	       * $state.go("lazy.state", {a:1, b:2}, {inherit:false});
	       *
	       * // somewhere else
	       * $scope.$on('$stateNotFound',
	       * function(event, unfoundState, fromState, fromParams){
	       *     console.log(unfoundState.to); // "lazy.state"
	       *     console.log(unfoundState.toParams); // {a:1, b:2}
	       *     console.log(unfoundState.options); // {inherit:false} + default options
	       * })
	       * </pre>
	       */
	      var evt = $rootScope.$broadcast('$stateNotFound', redirect, state, params);
	
	      if (evt.defaultPrevented) {
	        $urlRouter.update();
	        return TransitionAborted;
	      }
	
	      if (!evt.retry) {
	        return null;
	      }
	
	      // Allow the handler to return a promise to defer state lookup retry
	      if (options.$retry) {
	        $urlRouter.update();
	        return TransitionFailed;
	      }
	      var retryTransition = $state.transition = $q.when(evt.retry);
	
	      retryTransition.then(function() {
	        if (retryTransition !== $state.transition) {
	          $rootScope.$broadcast('$stateChangeCancel', redirect.to, redirect.toParams, state, params);
	          return TransitionSuperseded;
	        }
	        redirect.options.$retry = true;
	        return $state.transitionTo(redirect.to, redirect.toParams, redirect.options);
	      }, function() {
	        return TransitionAborted;
	      });
	      $urlRouter.update();
	
	      return retryTransition;
	    }
	
	    root.locals = { resolve: null, globals: { $stateParams: {} } };
	
	    $state = {
	      params: {},
	      current: root.self,
	      $current: root,
	      transition: null
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#reload
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * A method that force reloads the current state. All resolves are re-resolved,
	     * controllers reinstantiated, and events re-fired.
	     *
	     * @example
	     * <pre>
	     * var app angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.reload = function(){
	     *     $state.reload();
	     *   }
	     * });
	     * </pre>
	     *
	     * `reload()` is just an alias for:
	     * <pre>
	     * $state.transitionTo($state.current, $stateParams, { 
	     *   reload: true, inherit: false, notify: true
	     * });
	     * </pre>
	     *
	     * @param {string=|object=} state - A state name or a state object, which is the root of the resolves to be re-resolved.
	     * @example
	     * <pre>
	     * //assuming app application consists of 3 states: 'contacts', 'contacts.detail', 'contacts.detail.item' 
	     * //and current state is 'contacts.detail.item'
	     * var app angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.reload = function(){
	     *     //will reload 'contact.detail' and 'contact.detail.item' states
	     *     $state.reload('contact.detail');
	     *   }
	     * });
	     * </pre>
	     *
	     * `reload()` is just an alias for:
	     * <pre>
	     * $state.transitionTo($state.current, $stateParams, { 
	     *   reload: true, inherit: false, notify: true
	     * });
	     * </pre>
	
	     * @returns {promise} A promise representing the state of the new transition. See
	     * {@link ui.router.state.$state#methods_go $state.go}.
	     */
	    $state.reload = function reload(state) {
	      return $state.transitionTo($state.current, $stateParams, { reload: state || true, inherit: false, notify: true});
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#go
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Convenience method for transitioning to a new state. `$state.go` calls 
	     * `$state.transitionTo` internally but automatically sets options to 
	     * `{ location: true, inherit: true, relative: $state.$current, notify: true }`. 
	     * This allows you to easily use an absolute or relative to path and specify 
	     * only the parameters you'd like to update (while letting unspecified parameters 
	     * inherit from the currently active ancestor states).
	     *
	     * @example
	     * <pre>
	     * var app = angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.changeState = function () {
	     *     $state.go('contact.detail');
	     *   };
	     * });
	     * </pre>
	     * <img src='../ngdoc_assets/StateGoExamples.png'/>
	     *
	     * @param {string} to Absolute state name or relative state path. Some examples:
	     *
	     * - `$state.go('contact.detail')` - will go to the `contact.detail` state
	     * - `$state.go('^')` - will go to a parent state
	     * - `$state.go('^.sibling')` - will go to a sibling state
	     * - `$state.go('.child.grandchild')` - will go to grandchild state
	     *
	     * @param {object=} params A map of the parameters that will be sent to the state, 
	     * will populate $stateParams. Any parameters that are not specified will be inherited from currently 
	     * defined parameters. Only parameters specified in the state definition can be overridden, new 
	     * parameters will be ignored. This allows, for example, going to a sibling state that shares parameters
	     * specified in a parent state. Parameter inheritance only works between common ancestor states, I.e.
	     * transitioning to a sibling will get you the parameters for all parents, transitioning to a child
	     * will get you all current parameters, etc.
	     * @param {object=} options Options object. The options are:
	     *
	     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
	     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
	     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
	     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
	     *    defines which state to be relative from.
	     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
	     * - **`reload`** (v0.2.5) - {boolean=false|string|object}, If `true` will force transition even if no state or params
	     *    have changed.  It will reload the resolves and views of the current state and parent states.
	     *    If `reload` is a string (or state object), the state object is fetched (by name, or object reference); and \
	     *    the transition reloads the resolves and views for that matched state, and all its children states.
	     *
	     * @returns {promise} A promise representing the state of the new transition.
	     *
	     * Possible success values:
	     *
	     * - $state.current
	     *
	     * <br/>Possible rejection values:
	     *
	     * - 'transition superseded' - when a newer transition has been started after this one
	     * - 'transition prevented' - when `event.preventDefault()` has been called in a `$stateChangeStart` listener
	     * - 'transition aborted' - when `event.preventDefault()` has been called in a `$stateNotFound` listener or
	     *   when a `$stateNotFound` `event.retry` promise errors.
	     * - 'transition failed' - when a state has been unsuccessfully found after 2 tries.
	     * - *resolve error* - when an error has occurred with a `resolve`
	     *
	     */
	    $state.go = function go(to, params, options) {
	      return $state.transitionTo(to, params, extend({ inherit: true, relative: $state.$current }, options));
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#transitionTo
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Low-level method for transitioning to a new state. {@link ui.router.state.$state#methods_go $state.go}
	     * uses `transitionTo` internally. `$state.go` is recommended in most situations.
	     *
	     * @example
	     * <pre>
	     * var app = angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.changeState = function () {
	     *     $state.transitionTo('contact.detail');
	     *   };
	     * });
	     * </pre>
	     *
	     * @param {string} to State name.
	     * @param {object=} toParams A map of the parameters that will be sent to the state,
	     * will populate $stateParams.
	     * @param {object=} options Options object. The options are:
	     *
	     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
	     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
	     * - **`inherit`** - {boolean=false}, If `true` will inherit url parameters from current url.
	     * - **`relative`** - {object=}, When transitioning with relative path (e.g '^'), 
	     *    defines which state to be relative from.
	     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
	     * - **`reload`** (v0.2.5) - {boolean=false|string=|object=}, If `true` will force transition even if the state or params 
	     *    have not changed, aka a reload of the same state. It differs from reloadOnSearch because you'd
	     *    use this when you want to force a reload when *everything* is the same, including search params.
	     *    if String, then will reload the state with the name given in reload, and any children.
	     *    if Object, then a stateObj is expected, will reload the state found in stateObj, and any children.
	     *
	     * @returns {promise} A promise representing the state of the new transition. See
	     * {@link ui.router.state.$state#methods_go $state.go}.
	     */
	    $state.transitionTo = function transitionTo(to, toParams, options) {
	      toParams = toParams || {};
	      options = extend({
	        location: true, inherit: false, relative: null, notify: true, reload: false, $retry: false
	      }, options || {});
	
	      var from = $state.$current, fromParams = $state.params, fromPath = from.path;
	      var evt, toState = findState(to, options.relative);
	
	      // Store the hash param for later (since it will be stripped out by various methods)
	      var hash = toParams['#'];
	
	      if (!isDefined(toState)) {
	        var redirect = { to: to, toParams: toParams, options: options };
	        var redirectResult = handleRedirect(redirect, from.self, fromParams, options);
	
	        if (redirectResult) {
	          return redirectResult;
	        }
	
	        // Always retry once if the $stateNotFound was not prevented
	        // (handles either redirect changed or state lazy-definition)
	        to = redirect.to;
	        toParams = redirect.toParams;
	        options = redirect.options;
	        toState = findState(to, options.relative);
	
	        if (!isDefined(toState)) {
	          if (!options.relative) throw new Error("No such state '" + to + "'");
	          throw new Error("Could not resolve '" + to + "' from state '" + options.relative + "'");
	        }
	      }
	      if (toState[abstractKey]) throw new Error("Cannot transition to abstract state '" + to + "'");
	      if (options.inherit) toParams = inheritParams($stateParams, toParams || {}, $state.$current, toState);
	      if (!toState.params.$$validates(toParams)) return TransitionFailed;
	
	      toParams = toState.params.$$values(toParams);
	      to = toState;
	
	      var toPath = to.path;
	
	      // Starting from the root of the path, keep all levels that haven't changed
	      var keep = 0, state = toPath[keep], locals = root.locals, toLocals = [];
	
	      if (!options.reload) {
	        while (state && state === fromPath[keep] && state.ownParams.$$equals(toParams, fromParams)) {
	          locals = toLocals[keep] = state.locals;
	          keep++;
	          state = toPath[keep];
	        }
	      } else if (isString(options.reload) || isObject(options.reload)) {
	        if (isObject(options.reload) && !options.reload.name) {
	          throw new Error('Invalid reload state object');
	        }
	        
	        var reloadState = options.reload === true ? fromPath[0] : findState(options.reload);
	        if (options.reload && !reloadState) {
	          throw new Error("No such reload state '" + (isString(options.reload) ? options.reload : options.reload.name) + "'");
	        }
	
	        while (state && state === fromPath[keep] && state !== reloadState) {
	          locals = toLocals[keep] = state.locals;
	          keep++;
	          state = toPath[keep];
	        }
	      }
	
	      // If we're going to the same state and all locals are kept, we've got nothing to do.
	      // But clear 'transition', as we still want to cancel any other pending transitions.
	      // TODO: We may not want to bump 'transition' if we're called from a location change
	      // that we've initiated ourselves, because we might accidentally abort a legitimate
	      // transition initiated from code?
	      if (shouldSkipReload(to, toParams, from, fromParams, locals, options)) {
	        if (hash) toParams['#'] = hash;
	        $state.params = toParams;
	        copy($state.params, $stateParams);
	        copy(filterByKeys(to.params.$$keys(), $stateParams), to.locals.globals.$stateParams);
	        if (options.location && to.navigable && to.navigable.url) {
	          $urlRouter.push(to.navigable.url, toParams, {
	            $$avoidResync: true, replace: options.location === 'replace'
	          });
	          $urlRouter.update(true);
	        }
	        $state.transition = null;
	        return $q.when($state.current);
	      }
	
	      // Filter parameters before we pass them to event handlers etc.
	      toParams = filterByKeys(to.params.$$keys(), toParams || {});
	      
	      // Re-add the saved hash before we start returning things or broadcasting $stateChangeStart
	      if (hash) toParams['#'] = hash;
	      
	      // Broadcast start event and cancel the transition if requested
	      if (options.notify) {
	        /**
	         * @ngdoc event
	         * @name ui.router.state.$state#$stateChangeStart
	         * @eventOf ui.router.state.$state
	         * @eventType broadcast on root scope
	         * @description
	         * Fired when the state transition **begins**. You can use `event.preventDefault()`
	         * to prevent the transition from happening and then the transition promise will be
	         * rejected with a `'transition prevented'` value.
	         *
	         * @param {Object} event Event object.
	         * @param {State} toState The state being transitioned to.
	         * @param {Object} toParams The params supplied to the `toState`.
	         * @param {State} fromState The current state, pre-transition.
	         * @param {Object} fromParams The params supplied to the `fromState`.
	         *
	         * @example
	         *
	         * <pre>
	         * $rootScope.$on('$stateChangeStart',
	         * function(event, toState, toParams, fromState, fromParams){
	         *     event.preventDefault();
	         *     // transitionTo() promise will be rejected with
	         *     // a 'transition prevented' error
	         * })
	         * </pre>
	         */
	        if ($rootScope.$broadcast('$stateChangeStart', to.self, toParams, from.self, fromParams, options).defaultPrevented) {
	          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
	          //Don't update and resync url if there's been a new transition started. see issue #2238, #600
	          if ($state.transition == null) $urlRouter.update();
	          return TransitionPrevented;
	        }
	      }
	
	      // Resolve locals for the remaining states, but don't update any global state just
	      // yet -- if anything fails to resolve the current state needs to remain untouched.
	      // We also set up an inheritance chain for the locals here. This allows the view directive
	      // to quickly look up the correct definition for each view in the current state. Even
	      // though we create the locals object itself outside resolveState(), it is initially
	      // empty and gets filled asynchronously. We need to keep track of the promise for the
	      // (fully resolved) current locals, and pass this down the chain.
	      var resolved = $q.when(locals);
	
	      for (var l = keep; l < toPath.length; l++, state = toPath[l]) {
	        locals = toLocals[l] = inherit(locals);
	        resolved = resolveState(state, toParams, state === to, resolved, locals, options);
	      }
	
	      // Once everything is resolved, we are ready to perform the actual transition
	      // and return a promise for the new state. We also keep track of what the
	      // current promise is, so that we can detect overlapping transitions and
	      // keep only the outcome of the last transition.
	      var transition = $state.transition = resolved.then(function () {
	        var l, entering, exiting;
	
	        if ($state.transition !== transition) {
	          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
	          return TransitionSuperseded;
	        }
	
	        // Exit 'from' states not kept
	        for (l = fromPath.length - 1; l >= keep; l--) {
	          exiting = fromPath[l];
	          if (exiting.self.onExit) {
	            $injector.invoke(exiting.self.onExit, exiting.self, exiting.locals.globals);
	          }
	          exiting.locals = null;
	        }
	
	        // Enter 'to' states not kept
	        for (l = keep; l < toPath.length; l++) {
	          entering = toPath[l];
	          entering.locals = toLocals[l];
	          if (entering.self.onEnter) {
	            $injector.invoke(entering.self.onEnter, entering.self, entering.locals.globals);
	          }
	        }
	
	        // Run it again, to catch any transitions in callbacks
	        if ($state.transition !== transition) {
	          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
	          return TransitionSuperseded;
	        }
	
	        // Update globals in $state
	        $state.$current = to;
	        $state.current = to.self;
	        $state.params = toParams;
	        copy($state.params, $stateParams);
	        $state.transition = null;
	
	        if (options.location && to.navigable) {
	          $urlRouter.push(to.navigable.url, to.navigable.locals.globals.$stateParams, {
	            $$avoidResync: true, replace: options.location === 'replace'
	          });
	        }
	
	        if (options.notify) {
	        /**
	         * @ngdoc event
	         * @name ui.router.state.$state#$stateChangeSuccess
	         * @eventOf ui.router.state.$state
	         * @eventType broadcast on root scope
	         * @description
	         * Fired once the state transition is **complete**.
	         *
	         * @param {Object} event Event object.
	         * @param {State} toState The state being transitioned to.
	         * @param {Object} toParams The params supplied to the `toState`.
	         * @param {State} fromState The current state, pre-transition.
	         * @param {Object} fromParams The params supplied to the `fromState`.
	         */
	          $rootScope.$broadcast('$stateChangeSuccess', to.self, toParams, from.self, fromParams);
	        }
	        $urlRouter.update(true);
	
	        return $state.current;
	      }).then(null, function (error) {
	        // propagate TransitionSuperseded error without emitting $stateChangeCancel
	        // as it was already emitted in the success handler above
	        if (error === TransitionSupersededError) return TransitionSuperseded;
	
	        if ($state.transition !== transition) {
	          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
	          return TransitionSuperseded;
	        }
	
	        $state.transition = null;
	        /**
	         * @ngdoc event
	         * @name ui.router.state.$state#$stateChangeError
	         * @eventOf ui.router.state.$state
	         * @eventType broadcast on root scope
	         * @description
	         * Fired when an **error occurs** during transition. It's important to note that if you
	         * have any errors in your resolve functions (javascript errors, non-existent services, etc)
	         * they will not throw traditionally. You must listen for this $stateChangeError event to
	         * catch **ALL** errors.
	         *
	         * @param {Object} event Event object.
	         * @param {State} toState The state being transitioned to.
	         * @param {Object} toParams The params supplied to the `toState`.
	         * @param {State} fromState The current state, pre-transition.
	         * @param {Object} fromParams The params supplied to the `fromState`.
	         * @param {Error} error The resolve error object.
	         */
	        evt = $rootScope.$broadcast('$stateChangeError', to.self, toParams, from.self, fromParams, error);
	
	        if (!evt.defaultPrevented) {
	          $urlRouter.update();
	        }
	
	        return $q.reject(error);
	      });
	
	      silenceUncaughtInPromise(transition);
	      return transition;
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#is
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Similar to {@link ui.router.state.$state#methods_includes $state.includes},
	     * but only checks for the full state name. If params is supplied then it will be
	     * tested for strict equality against the current active params object, so all params
	     * must match with none missing and no extras.
	     *
	     * @example
	     * <pre>
	     * $state.$current.name = 'contacts.details.item';
	     *
	     * // absolute name
	     * $state.is('contact.details.item'); // returns true
	     * $state.is(contactDetailItemStateObject); // returns true
	     *
	     * // relative name (. and ^), typically from a template
	     * // E.g. from the 'contacts.details' template
	     * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
	     * </pre>
	     *
	     * @param {string|object} stateOrName The state name (absolute or relative) or state object you'd like to check.
	     * @param {object=} params A param object, e.g. `{sectionId: section.id}`, that you'd like
	     * to test against the current active state.
	     * @param {object=} options An options object.  The options are:
	     *
	     * - **`relative`** - {string|object} -  If `stateOrName` is a relative state name and `options.relative` is set, .is will
	     * test relative to `options.relative` state (or name).
	     *
	     * @returns {boolean} Returns true if it is the state.
	     */
	    $state.is = function is(stateOrName, params, options) {
	      options = extend({ relative: $state.$current }, options || {});
	      var state = findState(stateOrName, options.relative);
	
	      if (!isDefined(state)) { return undefined; }
	      if ($state.$current !== state) { return false; }
	
	      return !params || objectKeys(params).reduce(function(acc, key) {
	        var paramDef = state.params[key];
	        return acc && !paramDef || paramDef.type.equals($stateParams[key], params[key]);
	      }, true);
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#includes
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * A method to determine if the current active state is equal to or is the child of the
	     * state stateName. If any params are passed then they will be tested for a match as well.
	     * Not all the parameters need to be passed, just the ones you'd like to test for equality.
	     *
	     * @example
	     * Partial and relative names
	     * <pre>
	     * $state.$current.name = 'contacts.details.item';
	     *
	     * // Using partial names
	     * $state.includes("contacts"); // returns true
	     * $state.includes("contacts.details"); // returns true
	     * $state.includes("contacts.details.item"); // returns true
	     * $state.includes("contacts.list"); // returns false
	     * $state.includes("about"); // returns false
	     *
	     * // Using relative names (. and ^), typically from a template
	     * // E.g. from the 'contacts.details' template
	     * <div ng-class="{highlighted: $state.includes('.item')}">Item</div>
	     * </pre>
	     *
	     * Basic globbing patterns
	     * <pre>
	     * $state.$current.name = 'contacts.details.item.url';
	     *
	     * $state.includes("*.details.*.*"); // returns true
	     * $state.includes("*.details.**"); // returns true
	     * $state.includes("**.item.**"); // returns true
	     * $state.includes("*.details.item.url"); // returns true
	     * $state.includes("*.details.*.url"); // returns true
	     * $state.includes("*.details.*"); // returns false
	     * $state.includes("item.**"); // returns false
	     * </pre>
	     *
	     * @param {string} stateOrName A partial name, relative name, or glob pattern
	     * to be searched for within the current state name.
	     * @param {object=} params A param object, e.g. `{sectionId: section.id}`,
	     * that you'd like to test against the current active state.
	     * @param {object=} options An options object.  The options are:
	     *
	     * - **`relative`** - {string|object=} -  If `stateOrName` is a relative state reference and `options.relative` is set,
	     * .includes will test relative to `options.relative` state (or name).
	     *
	     * @returns {boolean} Returns true if it does include the state
	     */
	    $state.includes = function includes(stateOrName, params, options) {
	      options = extend({ relative: $state.$current }, options || {});
	      if (isString(stateOrName) && isGlob(stateOrName)) {
	        if (!doesStateMatchGlob(stateOrName)) {
	          return false;
	        }
	        stateOrName = $state.$current.name;
	      }
	
	      var state = findState(stateOrName, options.relative);
	      if (!isDefined(state)) { return undefined; }
	      if (!isDefined($state.$current.includes[state.name])) { return false; }
	      if (!params) { return true; }
	
	      var keys = objectKeys(params);
	      for (var i = 0; i < keys.length; i++) {
	        var key = keys[i], paramDef = state.params[key];
	        if (paramDef && !paramDef.type.equals($stateParams[key], params[key])) {
	          return false;
	        }
	      }
	
	      return objectKeys(params).reduce(function(acc, key) {
	        var paramDef = state.params[key];
	        return acc && !paramDef || paramDef.type.equals($stateParams[key], params[key]);
	      }, true);
	    };
	
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#href
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * A url generation method that returns the compiled url for the given state populated with the given params.
	     *
	     * @example
	     * <pre>
	     * expect($state.href("about.person", { person: "bob" })).toEqual("/about/bob");
	     * </pre>
	     *
	     * @param {string|object} stateOrName The state name or state object you'd like to generate a url from.
	     * @param {object=} params An object of parameter values to fill the state's required parameters.
	     * @param {object=} options Options object. The options are:
	     *
	     * - **`lossy`** - {boolean=true} -  If true, and if there is no url associated with the state provided in the
	     *    first parameter, then the constructed href url will be built from the first navigable ancestor (aka
	     *    ancestor with a valid url).
	     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
	     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
	     *    defines which state to be relative from.
	     * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
	     * 
	     * @returns {string} compiled state url
	     */
	    $state.href = function href(stateOrName, params, options) {
	      options = extend({
	        lossy:    true,
	        inherit:  true,
	        absolute: false,
	        relative: $state.$current
	      }, options || {});
	
	      var state = findState(stateOrName, options.relative);
	
	      if (!isDefined(state)) return null;
	      if (options.inherit) params = inheritParams($stateParams, params || {}, $state.$current, state);
	      
	      var nav = (state && options.lossy) ? state.navigable : state;
	
	      if (!nav || nav.url === undefined || nav.url === null) {
	        return null;
	      }
	      return $urlRouter.href(nav.url, filterByKeys(state.params.$$keys().concat('#'), params || {}), {
	        absolute: options.absolute
	      });
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#get
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Returns the state configuration object for any specific state or all states.
	     *
	     * @param {string|object=} stateOrName (absolute or relative) If provided, will only get the config for
	     * the requested state. If not provided, returns an array of ALL state configs.
	     * @param {string|object=} context When stateOrName is a relative state reference, the state will be retrieved relative to context.
	     * @returns {Object|Array} State configuration object or array of all objects.
	     */
	    $state.get = function (stateOrName, context) {
	      if (arguments.length === 0) return map(objectKeys(states), function(name) { return states[name].self; });
	      var state = findState(stateOrName, context || $state.$current);
	      return (state && state.self) ? state.self : null;
	    };
	
	    function resolveState(state, params, paramsAreFiltered, inherited, dst, options) {
	      // Make a restricted $stateParams with only the parameters that apply to this state if
	      // necessary. In addition to being available to the controller and onEnter/onExit callbacks,
	      // we also need $stateParams to be available for any $injector calls we make during the
	      // dependency resolution process.
	      var $stateParams = (paramsAreFiltered) ? params : filterByKeys(state.params.$$keys(), params);
	      var locals = { $stateParams: $stateParams };
	
	      // Resolve 'global' dependencies for the state, i.e. those not specific to a view.
	      // We're also including $stateParams in this; that way the parameters are restricted
	      // to the set that should be visible to the state, and are independent of when we update
	      // the global $state and $stateParams values.
	      dst.resolve = $resolve.resolve(state.resolve, locals, dst.resolve, state);
	      var promises = [dst.resolve.then(function (globals) {
	        dst.globals = globals;
	      })];
	      if (inherited) promises.push(inherited);
	
	      function resolveViews() {
	        var viewsPromises = [];
	
	        // Resolve template and dependencies for all views.
	        forEach(state.views, function (view, name) {
	          var injectables = (view.resolve && view.resolve !== state.resolve ? view.resolve : {});
	          injectables.$template = [ function () {
	            return $view.load(name, { view: view, locals: dst.globals, params: $stateParams, notify: options.notify }) || '';
	          }];
	
	          viewsPromises.push($resolve.resolve(injectables, dst.globals, dst.resolve, state).then(function (result) {
	            // References to the controller (only instantiated at link time)
	            if (isFunction(view.controllerProvider) || isArray(view.controllerProvider)) {
	              var injectLocals = angular.extend({}, injectables, dst.globals);
	              result.$$controller = $injector.invoke(view.controllerProvider, null, injectLocals);
	            } else {
	              result.$$controller = view.controller;
	            }
	            // Provide access to the state itself for internal use
	            result.$$state = state;
	            result.$$controllerAs = view.controllerAs;
	            result.$$resolveAs = view.resolveAs;
	            dst[name] = result;
	          }));
	        });
	
	        return $q.all(viewsPromises).then(function(){
	          return dst.globals;
	        });
	      }
	
	      // Wait for all the promises and then return the activation object
	      return $q.all(promises).then(resolveViews).then(function (values) {
	        return dst;
	      });
	    }
	
	    return $state;
	  }
	
	  function shouldSkipReload(to, toParams, from, fromParams, locals, options) {
	    // Return true if there are no differences in non-search (path/object) params, false if there are differences
	    function nonSearchParamsEqual(fromAndToState, fromParams, toParams) {
	      // Identify whether all the parameters that differ between `fromParams` and `toParams` were search params.
	      function notSearchParam(key) {
	        return fromAndToState.params[key].location != "search";
	      }
	      var nonQueryParamKeys = fromAndToState.params.$$keys().filter(notSearchParam);
	      var nonQueryParams = pick.apply({}, [fromAndToState.params].concat(nonQueryParamKeys));
	      var nonQueryParamSet = new $$UMFP.ParamSet(nonQueryParams);
	      return nonQueryParamSet.$$equals(fromParams, toParams);
	    }
	
	    // If reload was not explicitly requested
	    // and we're transitioning to the same state we're already in
	    // and    the locals didn't change
	    //     or they changed in a way that doesn't merit reloading
	    //        (reloadOnParams:false, or reloadOnSearch.false and only search params changed)
	    // Then return true.
	    if (!options.reload && to === from &&
	      (locals === from.locals || (to.self.reloadOnSearch === false && nonSearchParamsEqual(from, fromParams, toParams)))) {
	      return true;
	    }
	  }
	}
	
	angular.module('ui.router.state')
	  .factory('$stateParams', function () { return {}; })
	  .constant("$state.runtime", { autoinject: true })
	  .provider('$state', $StateProvider)
	  // Inject $state to initialize when entering runtime. #2574
	  .run(['$injector', function ($injector) {
	    // Allow tests (stateSpec.js) to turn this off by defining this constant
	    if ($injector.get("$state.runtime").autoinject) {
	      $injector.get('$state');
	    }
	  }]);
	
	
	$ViewProvider.$inject = [];
	function $ViewProvider() {
	
	  this.$get = $get;
	  /**
	   * @ngdoc object
	   * @name ui.router.state.$view
	   *
	   * @requires ui.router.util.$templateFactory
	   * @requires $rootScope
	   *
	   * @description
	   *
	   */
	  $get.$inject = ['$rootScope', '$templateFactory'];
	  function $get(   $rootScope,   $templateFactory) {
	    return {
	      // $view.load('full.viewName', { template: ..., controller: ..., resolve: ..., async: false, params: ... })
	      /**
	       * @ngdoc function
	       * @name ui.router.state.$view#load
	       * @methodOf ui.router.state.$view
	       *
	       * @description
	       *
	       * @param {string} name name
	       * @param {object} options option object.
	       */
	      load: function load(name, options) {
	        var result, defaults = {
	          template: null, controller: null, view: null, locals: null, notify: true, async: true, params: {}
	        };
	        options = extend(defaults, options);
	
	        if (options.view) {
	          result = $templateFactory.fromConfig(options.view, options.params, options.locals);
	        }
	        return result;
	      }
	    };
	  }
	}
	
	angular.module('ui.router.state').provider('$view', $ViewProvider);
	
	/**
	 * @ngdoc object
	 * @name ui.router.state.$uiViewScrollProvider
	 *
	 * @description
	 * Provider that returns the {@link ui.router.state.$uiViewScroll} service function.
	 */
	function $ViewScrollProvider() {
	
	  var useAnchorScroll = false;
	
	  /**
	   * @ngdoc function
	   * @name ui.router.state.$uiViewScrollProvider#useAnchorScroll
	   * @methodOf ui.router.state.$uiViewScrollProvider
	   *
	   * @description
	   * Reverts back to using the core [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll) service for
	   * scrolling based on the url anchor.
	   */
	  this.useAnchorScroll = function () {
	    useAnchorScroll = true;
	  };
	
	  /**
	   * @ngdoc object
	   * @name ui.router.state.$uiViewScroll
	   *
	   * @requires $anchorScroll
	   * @requires $timeout
	   *
	   * @description
	   * When called with a jqLite element, it scrolls the element into view (after a
	   * `$timeout` so the DOM has time to refresh).
	   *
	   * If you prefer to rely on `$anchorScroll` to scroll the view to the anchor,
	   * this can be enabled by calling {@link ui.router.state.$uiViewScrollProvider#methods_useAnchorScroll `$uiViewScrollProvider.useAnchorScroll()`}.
	   */
	  this.$get = ['$anchorScroll', '$timeout', function ($anchorScroll, $timeout) {
	    if (useAnchorScroll) {
	      return $anchorScroll;
	    }
	
	    return function ($element) {
	      return $timeout(function () {
	        $element[0].scrollIntoView();
	      }, 0, false);
	    };
	  }];
	}
	
	angular.module('ui.router.state').provider('$uiViewScroll', $ViewScrollProvider);
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-view
	 *
	 * @requires ui.router.state.$state
	 * @requires $compile
	 * @requires $controller
	 * @requires $injector
	 * @requires ui.router.state.$uiViewScroll
	 * @requires $document
	 *
	 * @restrict ECA
	 *
	 * @description
	 * The ui-view directive tells $state where to place your templates.
	 *
	 * @param {string=} name A view name. The name should be unique amongst the other views in the
	 * same state. You can have views of the same name that live in different states.
	 *
	 * @param {string=} autoscroll It allows you to set the scroll behavior of the browser window
	 * when a view is populated. By default, $anchorScroll is overridden by ui-router's custom scroll
	 * service, {@link ui.router.state.$uiViewScroll}. This custom service let's you
	 * scroll ui-view elements into view when they are populated during a state activation.
	 *
	 * *Note: To revert back to old [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll)
	 * functionality, call `$uiViewScrollProvider.useAnchorScroll()`.*
	 *
	 * @param {string=} onload Expression to evaluate whenever the view updates.
	 *
	 * @example
	 * A view can be unnamed or named.
	 * <pre>
	 * <!-- Unnamed -->
	 * <div ui-view></div>
	 *
	 * <!-- Named -->
	 * <div ui-view="viewName"></div>
	 * </pre>
	 *
	 * You can only have one unnamed view within any template (or root html). If you are only using a
	 * single view and it is unnamed then you can populate it like so:
	 * <pre>
	 * <div ui-view></div>
	 * $stateProvider.state("home", {
	 *   template: "<h1>HELLO!</h1>"
	 * })
	 * </pre>
	 *
	 * The above is a convenient shortcut equivalent to specifying your view explicitly with the {@link ui.router.state.$stateProvider#methods_state `views`}
	 * config property, by name, in this case an empty name:
	 * <pre>
	 * $stateProvider.state("home", {
	 *   views: {
	 *     "": {
	 *       template: "<h1>HELLO!</h1>"
	 *     }
	 *   }    
	 * })
	 * </pre>
	 *
	 * But typically you'll only use the views property if you name your view or have more than one view
	 * in the same template. There's not really a compelling reason to name a view if its the only one,
	 * but you could if you wanted, like so:
	 * <pre>
	 * <div ui-view="main"></div>
	 * </pre>
	 * <pre>
	 * $stateProvider.state("home", {
	 *   views: {
	 *     "main": {
	 *       template: "<h1>HELLO!</h1>"
	 *     }
	 *   }    
	 * })
	 * </pre>
	 *
	 * Really though, you'll use views to set up multiple views:
	 * <pre>
	 * <div ui-view></div>
	 * <div ui-view="chart"></div>
	 * <div ui-view="data"></div>
	 * </pre>
	 *
	 * <pre>
	 * $stateProvider.state("home", {
	 *   views: {
	 *     "": {
	 *       template: "<h1>HELLO!</h1>"
	 *     },
	 *     "chart": {
	 *       template: "<chart_thing/>"
	 *     },
	 *     "data": {
	 *       template: "<data_thing/>"
	 *     }
	 *   }    
	 * })
	 * </pre>
	 *
	 * Examples for `autoscroll`:
	 *
	 * <pre>
	 * <!-- If autoscroll present with no expression,
	 *      then scroll ui-view into view -->
	 * <ui-view autoscroll/>
	 *
	 * <!-- If autoscroll present with valid expression,
	 *      then scroll ui-view into view if expression evaluates to true -->
	 * <ui-view autoscroll='true'/>
	 * <ui-view autoscroll='false'/>
	 * <ui-view autoscroll='scopeVariable'/>
	 * </pre>
	 *
	 * Resolve data:
	 *
	 * The resolved data from the state's `resolve` block is placed on the scope as `$resolve` (this
	 * can be customized using [[ViewDeclaration.resolveAs]]).  This can be then accessed from the template.
	 *
	 * Note that when `controllerAs` is being used, `$resolve` is set on the controller instance *after* the
	 * controller is instantiated.  The `$onInit()` hook can be used to perform initialization code which
	 * depends on `$resolve` data.
	 *
	 * Example usage of $resolve in a view template
	 * <pre>
	 * $stateProvider.state('home', {
	 *   template: '<my-component user="$resolve.user"></my-component>',
	 *   resolve: {
	 *     user: function(UserService) { return UserService.fetchUser(); }
	 *   }
	 * });
	 * </pre>
	 */
	$ViewDirective.$inject = ['$state', '$injector', '$uiViewScroll', '$interpolate', '$q'];
	function $ViewDirective(   $state,   $injector,   $uiViewScroll,   $interpolate,   $q) {
	
	  function getService() {
	    return ($injector.has) ? function(service) {
	      return $injector.has(service) ? $injector.get(service) : null;
	    } : function(service) {
	      try {
	        return $injector.get(service);
	      } catch (e) {
	        return null;
	      }
	    };
	  }
	
	  var service = getService(),
	      $animator = service('$animator'),
	      $animate = service('$animate');
	
	  // Returns a set of DOM manipulation functions based on which Angular version
	  // it should use
	  function getRenderer(attrs, scope) {
	    var statics = function() {
	      return {
	        enter: function (element, target, cb) { target.after(element); cb(); },
	        leave: function (element, cb) { element.remove(); cb(); }
	      };
	    };
	
	    if ($animate) {
	      return {
	        enter: function(element, target, cb) {
	          if (angular.version.minor > 2) {
	            $animate.enter(element, null, target).then(cb);
	          } else {
	            $animate.enter(element, null, target, cb);
	          }
	        },
	        leave: function(element, cb) {
	          if (angular.version.minor > 2) {
	            $animate.leave(element).then(cb);
	          } else {
	            $animate.leave(element, cb);
	          }
	        }
	      };
	    }
	
	    if ($animator) {
	      var animate = $animator && $animator(scope, attrs);
	
	      return {
	        enter: function(element, target, cb) {animate.enter(element, null, target); cb(); },
	        leave: function(element, cb) { animate.leave(element); cb(); }
	      };
	    }
	
	    return statics();
	  }
	
	  var directive = {
	    restrict: 'ECA',
	    terminal: true,
	    priority: 400,
	    transclude: 'element',
	    compile: function (tElement, tAttrs, $transclude) {
	      return function (scope, $element, attrs) {
	        var previousEl, currentEl, currentScope, latestLocals,
	            onloadExp     = attrs.onload || '',
	            autoScrollExp = attrs.autoscroll,
	            renderer      = getRenderer(attrs, scope),
	            inherited     = $element.inheritedData('$uiView');
	
	        scope.$on('$stateChangeSuccess', function() {
	          updateView(false);
	        });
	
	        updateView(true);
	
	        function cleanupLastView() {
	          if (previousEl) {
	            previousEl.remove();
	            previousEl = null;
	          }
	
	          if (currentScope) {
	            currentScope.$destroy();
	            currentScope = null;
	          }
	
	          if (currentEl) {
	            var $uiViewData = currentEl.data('$uiViewAnim');
	            renderer.leave(currentEl, function() {
	              $uiViewData.$$animLeave.resolve();
	              previousEl = null;
	            });
	
	            previousEl = currentEl;
	            currentEl = null;
	          }
	        }
	
	        function updateView(firstTime) {
	          var newScope,
	              name            = getUiViewName(scope, attrs, $element, $interpolate),
	              previousLocals  = name && $state.$current && $state.$current.locals[name];
	
	          if (!firstTime && previousLocals === latestLocals) return; // nothing to do
	          newScope = scope.$new();
	          latestLocals = $state.$current.locals[name];
	
	          /**
	           * @ngdoc event
	           * @name ui.router.state.directive:ui-view#$viewContentLoading
	           * @eventOf ui.router.state.directive:ui-view
	           * @eventType emits on ui-view directive scope
	           * @description
	           *
	           * Fired once the view **begins loading**, *before* the DOM is rendered.
	           *
	           * @param {Object} event Event object.
	           * @param {string} viewName Name of the view.
	           */
	          newScope.$emit('$viewContentLoading', name);
	
	          var clone = $transclude(newScope, function(clone) {
	            var animEnter = $q.defer(), animLeave = $q.defer();
	            var viewAnimData = {
	              $animEnter: animEnter.promise,
	              $animLeave: animLeave.promise,
	              $$animLeave: animLeave
	            };
	
	            clone.data('$uiViewAnim', viewAnimData);
	            renderer.enter(clone, $element, function onUiViewEnter() {
	              animEnter.resolve();
	              if(currentScope) {
	                currentScope.$emit('$viewContentAnimationEnded');
	              }
	
	              if (angular.isDefined(autoScrollExp) && !autoScrollExp || scope.$eval(autoScrollExp)) {
	                $uiViewScroll(clone);
	              }
	            });
	            cleanupLastView();
	          });
	
	          currentEl = clone;
	          currentScope = newScope;
	          /**
	           * @ngdoc event
	           * @name ui.router.state.directive:ui-view#$viewContentLoaded
	           * @eventOf ui.router.state.directive:ui-view
	           * @eventType emits on ui-view directive scope
	           * @description
	           * Fired once the view is **loaded**, *after* the DOM is rendered.
	           *
	           * @param {Object} event Event object.
	           * @param {string} viewName Name of the view.
	           */
	          currentScope.$emit('$viewContentLoaded', name);
	          currentScope.$eval(onloadExp);
	        }
	      };
	    }
	  };
	
	  return directive;
	}
	
	$ViewDirectiveFill.$inject = ['$compile', '$controller', '$state', '$interpolate'];
	function $ViewDirectiveFill (  $compile,   $controller,   $state,   $interpolate) {
	  return {
	    restrict: 'ECA',
	    priority: -400,
	    compile: function (tElement) {
	      var initial = tElement.html();
	      if (tElement.empty) {
	        tElement.empty();
	      } else {
	        // ng 1.0.0 doesn't have empty(), which cleans up data and handlers
	        tElement[0].innerHTML = null;
	      }
	
	      return function (scope, $element, attrs) {
	        var current = $state.$current,
	            name = getUiViewName(scope, attrs, $element, $interpolate),
	            locals  = current && current.locals[name];
	
	        if (! locals) {
	          $element.html(initial);
	          $compile($element.contents())(scope);
	          return;
	        }
	
	        $element.data('$uiView', { name: name, state: locals.$$state });
	        $element.html(locals.$template ? locals.$template : initial);
	
	        var resolveData = angular.extend({}, locals);
	        scope[locals.$$resolveAs] = resolveData;
	
	        var link = $compile($element.contents());
	
	        if (locals.$$controller) {
	          locals.$scope = scope;
	          locals.$element = $element;
	          var controller = $controller(locals.$$controller, locals);
	          if (locals.$$controllerAs) {
	            scope[locals.$$controllerAs] = controller;
	            scope[locals.$$controllerAs][locals.$$resolveAs] = resolveData;
	          }
	          if (isFunction(controller.$onInit)) controller.$onInit();
	          $element.data('$ngControllerController', controller);
	          $element.children().data('$ngControllerController', controller);
	        }
	
	        link(scope);
	      };
	    }
	  };
	}
	
	/**
	 * Shared ui-view code for both directives:
	 * Given scope, element, and its attributes, return the view's name
	 */
	function getUiViewName(scope, attrs, element, $interpolate) {
	  var name = $interpolate(attrs.uiView || attrs.name || '')(scope);
	  var uiViewCreatedBy = element.inheritedData('$uiView');
	  return name.indexOf('@') >= 0 ?  name :  (name + '@' + (uiViewCreatedBy ? uiViewCreatedBy.state.name : ''));
	}
	
	angular.module('ui.router.state').directive('uiView', $ViewDirective);
	angular.module('ui.router.state').directive('uiView', $ViewDirectiveFill);
	
	function parseStateRef(ref, current) {
	  var preparsed = ref.match(/^\s*({[^}]*})\s*$/), parsed;
	  if (preparsed) ref = current + '(' + preparsed[1] + ')';
	  parsed = ref.replace(/\n/g, " ").match(/^([^(]+?)\s*(\((.*)\))?$/);
	  if (!parsed || parsed.length !== 4) throw new Error("Invalid state ref '" + ref + "'");
	  return { state: parsed[1], paramExpr: parsed[3] || null };
	}
	
	function stateContext(el) {
	  var stateData = el.parent().inheritedData('$uiView');
	
	  if (stateData && stateData.state && stateData.state.name) {
	    return stateData.state;
	  }
	}
	
	function getTypeInfo(el) {
	  // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	  var isSvg = Object.prototype.toString.call(el.prop('href')) === '[object SVGAnimatedString]';
	  var isForm = el[0].nodeName === "FORM";
	
	  return {
	    attr: isForm ? "action" : (isSvg ? 'xlink:href' : 'href'),
	    isAnchor: el.prop("tagName").toUpperCase() === "A",
	    clickable: !isForm
	  };
	}
	
	function clickHook(el, $state, $timeout, type, current) {
	  return function(e) {
	    var button = e.which || e.button, target = current();
	
	    if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || el.attr('target'))) {
	      // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
	      var transition = $timeout(function() {
	        $state.go(target.state, target.params, target.options);
	      });
	      e.preventDefault();
	
	      // if the state has no URL, ignore one preventDefault from the <a> directive.
	      var ignorePreventDefaultCount = type.isAnchor && !target.href ? 1: 0;
	
	      e.preventDefault = function() {
	        if (ignorePreventDefaultCount-- <= 0) $timeout.cancel(transition);
	      };
	    }
	  };
	}
	
	function defaultOpts(el, $state) {
	  return { relative: stateContext(el) || $state.$current, inherit: true };
	}
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-sref
	 *
	 * @requires ui.router.state.$state
	 * @requires $timeout
	 *
	 * @restrict A
	 *
	 * @description
	 * A directive that binds a link (`<a>` tag) to a state. If the state has an associated
	 * URL, the directive will automatically generate & update the `href` attribute via
	 * the {@link ui.router.state.$state#methods_href $state.href()} method. Clicking
	 * the link will trigger a state transition with optional parameters.
	 *
	 * Also middle-clicking, right-clicking, and ctrl-clicking on the link will be
	 * handled natively by the browser.
	 *
	 * You can also use relative state paths within ui-sref, just like the relative
	 * paths passed to `$state.go()`. You just need to be aware that the path is relative
	 * to the state that the link lives in, in other words the state that loaded the
	 * template containing the link.
	 *
	 * You can specify options to pass to {@link ui.router.state.$state#methods_go $state.go()}
	 * using the `ui-sref-opts` attribute. Options are restricted to `location`, `inherit`,
	 * and `reload`.
	 *
	 * @example
	 * Here's an example of how you'd use ui-sref and how it would compile. If you have the
	 * following template:
	 * <pre>
	 * <a ui-sref="home">Home</a> | <a ui-sref="about">About</a> | <a ui-sref="{page: 2}">Next page</a>
	 *
	 * <ul>
	 *     <li ng-repeat="contact in contacts">
	 *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
	 *     </li>
	 * </ul>
	 * </pre>
	 *
	 * Then the compiled html would be (assuming Html5Mode is off and current state is contacts):
	 * <pre>
	 * <a href="#/home" ui-sref="home">Home</a> | <a href="#/about" ui-sref="about">About</a> | <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
	 *
	 * <ul>
	 *     <li ng-repeat="contact in contacts">
	 *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
	 *     </li>
	 *     <li ng-repeat="contact in contacts">
	 *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
	 *     </li>
	 *     <li ng-repeat="contact in contacts">
	 *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
	 *     </li>
	 * </ul>
	 *
	 * <a ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
	 * </pre>
	 *
	 * @param {string} ui-sref 'stateName' can be any valid absolute or relative state
	 * @param {Object} ui-sref-opts options to pass to {@link ui.router.state.$state#methods_go $state.go()}
	 */
	$StateRefDirective.$inject = ['$state', '$timeout'];
	function $StateRefDirective($state, $timeout) {
	  return {
	    restrict: 'A',
	    require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	    link: function(scope, element, attrs, uiSrefActive) {
	      var ref    = parseStateRef(attrs.uiSref, $state.current.name);
	      var def    = { state: ref.state, href: null, params: null };
	      var type   = getTypeInfo(element);
	      var active = uiSrefActive[1] || uiSrefActive[0];
	      var unlinkInfoFn = null;
	      var hookFn;
	
	      def.options = extend(defaultOpts(element, $state), attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {});
	
	      var update = function(val) {
	        if (val) def.params = angular.copy(val);
	        def.href = $state.href(ref.state, def.params, def.options);
	
	        if (unlinkInfoFn) unlinkInfoFn();
	        if (active) unlinkInfoFn = active.$$addStateInfo(ref.state, def.params);
	        if (def.href !== null) attrs.$set(type.attr, def.href);
	      };
	
	      if (ref.paramExpr) {
	        scope.$watch(ref.paramExpr, function(val) { if (val !== def.params) update(val); }, true);
	        def.params = angular.copy(scope.$eval(ref.paramExpr));
	      }
	      update();
	
	      if (!type.clickable) return;
	      hookFn = clickHook(element, $state, $timeout, type, function() { return def; });
	      element[element.on ? 'on' : 'bind']("click", hookFn);
	      scope.$on('$destroy', function() {
	        element[element.off ? 'off' : 'unbind']("click", hookFn);
	      });
	    }
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-state
	 *
	 * @requires ui.router.state.uiSref
	 *
	 * @restrict A
	 *
	 * @description
	 * Much like ui-sref, but will accept named $scope properties to evaluate for a state definition,
	 * params and override options.
	 *
	 * @param {string} ui-state 'stateName' can be any valid absolute or relative state
	 * @param {Object} ui-state-params params to pass to {@link ui.router.state.$state#methods_href $state.href()}
	 * @param {Object} ui-state-opts options to pass to {@link ui.router.state.$state#methods_go $state.go()}
	 */
	$StateRefDynamicDirective.$inject = ['$state', '$timeout'];
	function $StateRefDynamicDirective($state, $timeout) {
	  return {
	    restrict: 'A',
	    require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	    link: function(scope, element, attrs, uiSrefActive) {
	      var type   = getTypeInfo(element);
	      var active = uiSrefActive[1] || uiSrefActive[0];
	      var group  = [attrs.uiState, attrs.uiStateParams || null, attrs.uiStateOpts || null];
	      var watch  = '[' + group.map(function(val) { return val || 'null'; }).join(', ') + ']';
	      var def    = { state: null, params: null, options: null, href: null };
	      var unlinkInfoFn = null;
	      var hookFn;
	
	      function runStateRefLink (group) {
	        def.state = group[0]; def.params = group[1]; def.options = group[2];
	        def.href = $state.href(def.state, def.params, def.options);
	
	        if (unlinkInfoFn) unlinkInfoFn();
	        if (active) unlinkInfoFn = active.$$addStateInfo(def.state, def.params);
	        if (def.href) attrs.$set(type.attr, def.href);
	      }
	
	      scope.$watch(watch, runStateRefLink, true);
	      runStateRefLink(scope.$eval(watch));
	
	      if (!type.clickable) return;
	      hookFn = clickHook(element, $state, $timeout, type, function() { return def; });
	      element[element.on ? 'on' : 'bind']("click", hookFn);
	      scope.$on('$destroy', function() {
	        element[element.off ? 'off' : 'unbind']("click", hookFn);
	      });
	    }
	  };
	}
	
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-sref-active
	 *
	 * @requires ui.router.state.$state
	 * @requires ui.router.state.$stateParams
	 * @requires $interpolate
	 *
	 * @restrict A
	 *
	 * @description
	 * A directive working alongside ui-sref to add classes to an element when the
	 * related ui-sref directive's state is active, and removing them when it is inactive.
	 * The primary use-case is to simplify the special appearance of navigation menus
	 * relying on `ui-sref`, by having the "active" state's menu button appear different,
	 * distinguishing it from the inactive menu items.
	 *
	 * ui-sref-active can live on the same element as ui-sref or on a parent element. The first
	 * ui-sref-active found at the same level or above the ui-sref will be used.
	 *
	 * Will activate when the ui-sref's target state or any child state is active. If you
	 * need to activate only when the ui-sref target state is active and *not* any of
	 * it's children, then you will use
	 * {@link ui.router.state.directive:ui-sref-active-eq ui-sref-active-eq}
	 *
	 * @example
	 * Given the following template:
	 * <pre>
	 * <ul>
	 *   <li ui-sref-active="active" class="item">
	 *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
	 *   </li>
	 * </ul>
	 * </pre>
	 *
	 *
	 * When the app state is "app.user" (or any children states), and contains the state parameter "user" with value "bilbobaggins",
	 * the resulting HTML will appear as (note the 'active' class):
	 * <pre>
	 * <ul>
	 *   <li ui-sref-active="active" class="item active">
	 *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
	 *   </li>
	 * </ul>
	 * </pre>
	 *
	 * The class name is interpolated **once** during the directives link time (any further changes to the
	 * interpolated value are ignored).
	 *
	 * Multiple classes may be specified in a space-separated format:
	 * <pre>
	 * <ul>
	 *   <li ui-sref-active='class1 class2 class3'>
	 *     <a ui-sref="app.user">link</a>
	 *   </li>
	 * </ul>
	 * </pre>
	 *
	 * It is also possible to pass ui-sref-active an expression that evaluates
	 * to an object hash, whose keys represent active class names and whose
	 * values represent the respective state names/globs.
	 * ui-sref-active will match if the current active state **includes** any of
	 * the specified state names/globs, even the abstract ones.
	 *
	 * @Example
	 * Given the following template, with "admin" being an abstract state:
	 * <pre>
	 * <div ui-sref-active="{'active': 'admin.*'}">
	 *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
	 * </div>
	 * </pre>
	 *
	 * When the current state is "admin.roles" the "active" class will be applied
	 * to both the <div> and <a> elements. It is important to note that the state
	 * names/globs passed to ui-sref-active shadow the state provided by ui-sref.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-sref-active-eq
	 *
	 * @requires ui.router.state.$state
	 * @requires ui.router.state.$stateParams
	 * @requires $interpolate
	 *
	 * @restrict A
	 *
	 * @description
	 * The same as {@link ui.router.state.directive:ui-sref-active ui-sref-active} but will only activate
	 * when the exact target state used in the `ui-sref` is active; no child states.
	 *
	 */
	$StateRefActiveDirective.$inject = ['$state', '$stateParams', '$interpolate'];
	function $StateRefActiveDirective($state, $stateParams, $interpolate) {
	  return  {
	    restrict: "A",
	    controller: ['$scope', '$element', '$attrs', '$timeout', function ($scope, $element, $attrs, $timeout) {
	      var states = [], activeClasses = {}, activeEqClass, uiSrefActive;
	
	      // There probably isn't much point in $observing this
	      // uiSrefActive and uiSrefActiveEq share the same directive object with some
	      // slight difference in logic routing
	      activeEqClass = $interpolate($attrs.uiSrefActiveEq || '', false)($scope);
	
	      try {
	        uiSrefActive = $scope.$eval($attrs.uiSrefActive);
	      } catch (e) {
	        // Do nothing. uiSrefActive is not a valid expression.
	        // Fall back to using $interpolate below
	      }
	      uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || '', false)($scope);
	      if (isObject(uiSrefActive)) {
	        forEach(uiSrefActive, function(stateOrName, activeClass) {
	          if (isString(stateOrName)) {
	            var ref = parseStateRef(stateOrName, $state.current.name);
	            addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
	          }
	        });
	      }
	
	      // Allow uiSref to communicate with uiSrefActive[Equals]
	      this.$$addStateInfo = function (newState, newParams) {
	        // we already got an explicit state provided by ui-sref-active, so we
	        // shadow the one that comes from ui-sref
	        if (isObject(uiSrefActive) && states.length > 0) {
	          return;
	        }
	        var deregister = addState(newState, newParams, uiSrefActive);
	        update();
	        return deregister;
	      };
	
	      $scope.$on('$stateChangeSuccess', update);
	
	      function addState(stateName, stateParams, activeClass) {
	        var state = $state.get(stateName, stateContext($element));
	        var stateHash = createStateHash(stateName, stateParams);
	
	        var stateInfo = {
	          state: state || { name: stateName },
	          params: stateParams,
	          hash: stateHash
	        };
	
	        states.push(stateInfo);
	        activeClasses[stateHash] = activeClass;
	
	        return function removeState() {
	          var idx = states.indexOf(stateInfo);
	          if (idx !== -1) states.splice(idx, 1);
	        };
	      }
	
	      /**
	       * @param {string} state
	       * @param {Object|string} [params]
	       * @return {string}
	       */
	      function createStateHash(state, params) {
	        if (!isString(state)) {
	          throw new Error('state should be a string');
	        }
	        if (isObject(params)) {
	          return state + toJson(params);
	        }
	        params = $scope.$eval(params);
	        if (isObject(params)) {
	          return state + toJson(params);
	        }
	        return state;
	      }
	
	      // Update route state
	      function update() {
	        for (var i = 0; i < states.length; i++) {
	          if (anyMatch(states[i].state, states[i].params)) {
	            addClass($element, activeClasses[states[i].hash]);
	          } else {
	            removeClass($element, activeClasses[states[i].hash]);
	          }
	
	          if (exactMatch(states[i].state, states[i].params)) {
	            addClass($element, activeEqClass);
	          } else {
	            removeClass($element, activeEqClass);
	          }
	        }
	      }
	
	      function addClass(el, className) { $timeout(function () { el.addClass(className); }); }
	      function removeClass(el, className) { el.removeClass(className); }
	      function anyMatch(state, params) { return $state.includes(state.name, params); }
	      function exactMatch(state, params) { return $state.is(state.name, params); }
	
	      update();
	    }]
	  };
	}
	
	angular.module('ui.router.state')
	  .directive('uiSref', $StateRefDirective)
	  .directive('uiSrefActive', $StateRefActiveDirective)
	  .directive('uiSrefActiveEq', $StateRefActiveDirective)
	  .directive('uiState', $StateRefDynamicDirective);
	
	/**
	 * @ngdoc filter
	 * @name ui.router.state.filter:isState
	 *
	 * @requires ui.router.state.$state
	 *
	 * @description
	 * Translates to {@link ui.router.state.$state#methods_is $state.is("stateName")}.
	 */
	$IsStateFilter.$inject = ['$state'];
	function $IsStateFilter($state) {
	  var isFilter = function (state, params) {
	    return $state.is(state, params);
	  };
	  isFilter.$stateful = true;
	  return isFilter;
	}
	
	/**
	 * @ngdoc filter
	 * @name ui.router.state.filter:includedByState
	 *
	 * @requires ui.router.state.$state
	 *
	 * @description
	 * Translates to {@link ui.router.state.$state#methods_includes $state.includes('fullOrPartialStateName')}.
	 */
	$IncludedByStateFilter.$inject = ['$state'];
	function $IncludedByStateFilter($state) {
	  var includesFilter = function (state, params, options) {
	    return $state.includes(state, params, options);
	  };
	  includesFilter.$stateful = true;
	  return  includesFilter;
	}
	
	angular.module('ui.router.state')
	  .filter('isState', $IsStateFilter)
	  .filter('includedByState', $IncludedByStateFilter);
	})(window, window.angular);

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

	// Should already be required, here for clarity
	__webpack_require__(12);
	
	// Load Angular and dependent libs
	__webpack_require__(28);
	__webpack_require__(29);
	
	// Now load Angular Material
	__webpack_require__(37);
	
	// Export namespace
	module.exports = 'ngMaterial';


/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(39);
	module.exports = angular;


/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de;
	
	})));


/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enGb = moment.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enGb;
	
	})));


/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es;
	
	})));


/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fr = moment.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	
	})));


/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var it = moment.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return it;
	
	})));


/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ja = moment.defineLocale('ja', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日 dddd HH:mm',
	            l : 'YYYY/MM/DD',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日(ddd) HH:mm'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM : function (input) {
	            return input === '午後';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar : {
	            sameDay : '[今日] LT',
	            nextDay : '[明日] LT',
	            nextWeek : function (now) {
	                if (now.week() < this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay : '[昨日] LT',
	            lastWeek : function (now) {
	                if (this.week() < now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}日/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s後',
	            past : '%s前',
	            s : '数秒',
	            ss : '%d秒',
	            m : '1分',
	            mm : '%d分',
	            h : '1時間',
	            hh : '%d時間',
	            d : '1日',
	            dd : '%d日',
	            M : '1ヶ月',
	            MM : '%dヶ月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });
	
	    return ja;
	
	})));


/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ko = moment.defineLocale('ko', {
	        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY년 MMMM D일',
	            LLL : 'YYYY년 MMMM D일 A h:mm',
	            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	            l : 'YYYY.MM.DD.',
	            ll : 'YYYY년 MMMM D일',
	            lll : 'YYYY년 MMMM D일 A h:mm',
	            llll : 'YYYY년 MMMM D일 dddd A h:mm'
	        },
	        calendar : {
	            sameDay : '오늘 LT',
	            nextDay : '내일 LT',
	            nextWeek : 'dddd LT',
	            lastDay : '어제 LT',
	            lastWeek : '지난주 dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s 후',
	            past : '%s 전',
	            s : '몇 초',
	            ss : '%d초',
	            m : '1분',
	            mm : '%d분',
	            h : '한 시간',
	            hh : '%d시간',
	            d : '하루',
	            dd : '%d일',
	            M : '한 달',
	            MM : '%d달',
	            y : '일 년',
	            yy : '%d년'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse : /오전|오후/,
	        isPM : function (token) {
	            return token === '오후';
	        },
	        meridiem : function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    return ko;
	
	})));


/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var pt = moment.defineLocale('pt', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pt;
	
	})));


/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months : {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	        },
	        monthsShort : {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	        },
	        weekdays : {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	        },
	        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соотвествует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., H:mm',
	            LLLL : 'dddd, D MMMM YYYY г., H:mm'
	        },
	        calendar : {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'через %s',
	            past : '%s назад',
	            s : 'несколько секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'час',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM : function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ru;
	
	})));


/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[yarın saat] LT',
	            nextWeek : '[gelecek] dddd [saat] LT',
	            lastDay : '[dün] LT',
	            lastWeek : '[geçen] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s önce',
	            s : 'birkaç saniye',
	            ss : '%d saniye',
	            m : 'bir dakika',
	            mm : '%d dakika',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir yıl',
	            yy : '%d yıl'
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {  // special case for zero
	                        return number + '\'ıncı';
	                    }
	                    var a = number % 10,
	                        b = number % 100 - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return tr;
	
	})));


/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah点mm分',
	            LLLL : 'YYYY年M月D日ddddAh点mm分',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            ss : '%d 秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return zhCn;
	
	})));


/***/ }),

/***/ 27:
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(35);
	module.exports = 'ngAnimate';


/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(36);
	module.exports = 'ngAria';


/***/ }),

/***/ 35:
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.6.4
	 * (c) 2010-2017 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	var ELEMENT_NODE = 1;
	var COMMENT_NODE = 8;
	
	var ADD_CLASS_SUFFIX = '-add';
	var REMOVE_CLASS_SUFFIX = '-remove';
	var EVENT_CLASS_PREFIX = 'ng-';
	var ACTIVE_CLASS_SUFFIX = '-active';
	var PREPARE_CLASS_SUFFIX = '-prepare';
	
	var NG_ANIMATE_CLASSNAME = 'ng-animate';
	var NG_ANIMATE_CHILDREN_DATA = '$$ngAnimateChildren';
	
	// Detect proper transitionend/animationend event names.
	var CSS_PREFIX = '', TRANSITION_PROP, TRANSITIONEND_EVENT, ANIMATION_PROP, ANIMATIONEND_EVENT;
	
	// If unprefixed events are not supported but webkit-prefixed are, use the latter.
	// Otherwise, just use W3C names, browsers not supporting them at all will just ignore them.
	// Note: Chrome implements `window.onwebkitanimationend` and doesn't implement `window.onanimationend`
	// but at the same time dispatches the `animationend` event and not `webkitAnimationEnd`.
	// Register both events in case `window.onanimationend` is not supported because of that,
	// do the same for `transitionend` as Safari is likely to exhibit similar behavior.
	// Also, the only modern browser that uses vendor prefixes for transitions/keyframes is webkit
	// therefore there is no reason to test anymore for other vendor prefixes:
	// http://caniuse.com/#search=transition
	if ((window.ontransitionend === undefined) && (window.onwebkittransitionend !== undefined)) {
	  CSS_PREFIX = '-webkit-';
	  TRANSITION_PROP = 'WebkitTransition';
	  TRANSITIONEND_EVENT = 'webkitTransitionEnd transitionend';
	} else {
	  TRANSITION_PROP = 'transition';
	  TRANSITIONEND_EVENT = 'transitionend';
	}
	
	if ((window.onanimationend === undefined) && (window.onwebkitanimationend !== undefined)) {
	  CSS_PREFIX = '-webkit-';
	  ANIMATION_PROP = 'WebkitAnimation';
	  ANIMATIONEND_EVENT = 'webkitAnimationEnd animationend';
	} else {
	  ANIMATION_PROP = 'animation';
	  ANIMATIONEND_EVENT = 'animationend';
	}
	
	var DURATION_KEY = 'Duration';
	var PROPERTY_KEY = 'Property';
	var DELAY_KEY = 'Delay';
	var TIMING_KEY = 'TimingFunction';
	var ANIMATION_ITERATION_COUNT_KEY = 'IterationCount';
	var ANIMATION_PLAYSTATE_KEY = 'PlayState';
	var SAFE_FAST_FORWARD_DURATION_VALUE = 9999;
	
	var ANIMATION_DELAY_PROP = ANIMATION_PROP + DELAY_KEY;
	var ANIMATION_DURATION_PROP = ANIMATION_PROP + DURATION_KEY;
	var TRANSITION_DELAY_PROP = TRANSITION_PROP + DELAY_KEY;
	var TRANSITION_DURATION_PROP = TRANSITION_PROP + DURATION_KEY;
	
	var ngMinErr = angular.$$minErr('ng');
	function assertArg(arg, name, reason) {
	  if (!arg) {
	    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
	  }
	  return arg;
	}
	
	function mergeClasses(a,b) {
	  if (!a && !b) return '';
	  if (!a) return b;
	  if (!b) return a;
	  if (isArray(a)) a = a.join(' ');
	  if (isArray(b)) b = b.join(' ');
	  return a + ' ' + b;
	}
	
	function packageStyles(options) {
	  var styles = {};
	  if (options && (options.to || options.from)) {
	    styles.to = options.to;
	    styles.from = options.from;
	  }
	  return styles;
	}
	
	function pendClasses(classes, fix, isPrefix) {
	  var className = '';
	  classes = isArray(classes)
	      ? classes
	      : classes && isString(classes) && classes.length
	          ? classes.split(/\s+/)
	          : [];
	  forEach(classes, function(klass, i) {
	    if (klass && klass.length > 0) {
	      className += (i > 0) ? ' ' : '';
	      className += isPrefix ? fix + klass
	                            : klass + fix;
	    }
	  });
	  return className;
	}
	
	function removeFromArray(arr, val) {
	  var index = arr.indexOf(val);
	  if (val >= 0) {
	    arr.splice(index, 1);
	  }
	}
	
	function stripCommentsFromElement(element) {
	  if (element instanceof jqLite) {
	    switch (element.length) {
	      case 0:
	        return element;
	
	      case 1:
	        // there is no point of stripping anything if the element
	        // is the only element within the jqLite wrapper.
	        // (it's important that we retain the element instance.)
	        if (element[0].nodeType === ELEMENT_NODE) {
	          return element;
	        }
	        break;
	
	      default:
	        return jqLite(extractElementNode(element));
	    }
	  }
	
	  if (element.nodeType === ELEMENT_NODE) {
	    return jqLite(element);
	  }
	}
	
	function extractElementNode(element) {
	  if (!element[0]) return element;
	  for (var i = 0; i < element.length; i++) {
	    var elm = element[i];
	    if (elm.nodeType === ELEMENT_NODE) {
	      return elm;
	    }
	  }
	}
	
	function $$addClass($$jqLite, element, className) {
	  forEach(element, function(elm) {
	    $$jqLite.addClass(elm, className);
	  });
	}
	
	function $$removeClass($$jqLite, element, className) {
	  forEach(element, function(elm) {
	    $$jqLite.removeClass(elm, className);
	  });
	}
	
	function applyAnimationClassesFactory($$jqLite) {
	  return function(element, options) {
	    if (options.addClass) {
	      $$addClass($$jqLite, element, options.addClass);
	      options.addClass = null;
	    }
	    if (options.removeClass) {
	      $$removeClass($$jqLite, element, options.removeClass);
	      options.removeClass = null;
	    }
	  };
	}
	
	function prepareAnimationOptions(options) {
	  options = options || {};
	  if (!options.$$prepared) {
	    var domOperation = options.domOperation || noop;
	    options.domOperation = function() {
	      options.$$domOperationFired = true;
	      domOperation();
	      domOperation = noop;
	    };
	    options.$$prepared = true;
	  }
	  return options;
	}
	
	function applyAnimationStyles(element, options) {
	  applyAnimationFromStyles(element, options);
	  applyAnimationToStyles(element, options);
	}
	
	function applyAnimationFromStyles(element, options) {
	  if (options.from) {
	    element.css(options.from);
	    options.from = null;
	  }
	}
	
	function applyAnimationToStyles(element, options) {
	  if (options.to) {
	    element.css(options.to);
	    options.to = null;
	  }
	}
	
	function mergeAnimationDetails(element, oldAnimation, newAnimation) {
	  var target = oldAnimation.options || {};
	  var newOptions = newAnimation.options || {};
	
	  var toAdd = (target.addClass || '') + ' ' + (newOptions.addClass || '');
	  var toRemove = (target.removeClass || '') + ' ' + (newOptions.removeClass || '');
	  var classes = resolveElementClasses(element.attr('class'), toAdd, toRemove);
	
	  if (newOptions.preparationClasses) {
	    target.preparationClasses = concatWithSpace(newOptions.preparationClasses, target.preparationClasses);
	    delete newOptions.preparationClasses;
	  }
	
	  // noop is basically when there is no callback; otherwise something has been set
	  var realDomOperation = target.domOperation !== noop ? target.domOperation : null;
	
	  extend(target, newOptions);
	
	  // TODO(matsko or sreeramu): proper fix is to maintain all animation callback in array and call at last,but now only leave has the callback so no issue with this.
	  if (realDomOperation) {
	    target.domOperation = realDomOperation;
	  }
	
	  if (classes.addClass) {
	    target.addClass = classes.addClass;
	  } else {
	    target.addClass = null;
	  }
	
	  if (classes.removeClass) {
	    target.removeClass = classes.removeClass;
	  } else {
	    target.removeClass = null;
	  }
	
	  oldAnimation.addClass = target.addClass;
	  oldAnimation.removeClass = target.removeClass;
	
	  return target;
	}
	
	function resolveElementClasses(existing, toAdd, toRemove) {
	  var ADD_CLASS = 1;
	  var REMOVE_CLASS = -1;
	
	  var flags = {};
	  existing = splitClassesToLookup(existing);
	
	  toAdd = splitClassesToLookup(toAdd);
	  forEach(toAdd, function(value, key) {
	    flags[key] = ADD_CLASS;
	  });
	
	  toRemove = splitClassesToLookup(toRemove);
	  forEach(toRemove, function(value, key) {
	    flags[key] = flags[key] === ADD_CLASS ? null : REMOVE_CLASS;
	  });
	
	  var classes = {
	    addClass: '',
	    removeClass: ''
	  };
	
	  forEach(flags, function(val, klass) {
	    var prop, allow;
	    if (val === ADD_CLASS) {
	      prop = 'addClass';
	      allow = !existing[klass] || existing[klass + REMOVE_CLASS_SUFFIX];
	    } else if (val === REMOVE_CLASS) {
	      prop = 'removeClass';
	      allow = existing[klass] || existing[klass + ADD_CLASS_SUFFIX];
	    }
	    if (allow) {
	      if (classes[prop].length) {
	        classes[prop] += ' ';
	      }
	      classes[prop] += klass;
	    }
	  });
	
	  function splitClassesToLookup(classes) {
	    if (isString(classes)) {
	      classes = classes.split(' ');
	    }
	
	    var obj = {};
	    forEach(classes, function(klass) {
	      // sometimes the split leaves empty string values
	      // incase extra spaces were applied to the options
	      if (klass.length) {
	        obj[klass] = true;
	      }
	    });
	    return obj;
	  }
	
	  return classes;
	}
	
	function getDomNode(element) {
	  return (element instanceof jqLite) ? element[0] : element;
	}
	
	function applyGeneratedPreparationClasses(element, event, options) {
	  var classes = '';
	  if (event) {
	    classes = pendClasses(event, EVENT_CLASS_PREFIX, true);
	  }
	  if (options.addClass) {
	    classes = concatWithSpace(classes, pendClasses(options.addClass, ADD_CLASS_SUFFIX));
	  }
	  if (options.removeClass) {
	    classes = concatWithSpace(classes, pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX));
	  }
	  if (classes.length) {
	    options.preparationClasses = classes;
	    element.addClass(classes);
	  }
	}
	
	function clearGeneratedClasses(element, options) {
	  if (options.preparationClasses) {
	    element.removeClass(options.preparationClasses);
	    options.preparationClasses = null;
	  }
	  if (options.activeClasses) {
	    element.removeClass(options.activeClasses);
	    options.activeClasses = null;
	  }
	}
	
	function blockTransitions(node, duration) {
	  // we use a negative delay value since it performs blocking
	  // yet it doesn't kill any existing transitions running on the
	  // same element which makes this safe for class-based animations
	  var value = duration ? '-' + duration + 's' : '';
	  applyInlineStyle(node, [TRANSITION_DELAY_PROP, value]);
	  return [TRANSITION_DELAY_PROP, value];
	}
	
	function blockKeyframeAnimations(node, applyBlock) {
	  var value = applyBlock ? 'paused' : '';
	  var key = ANIMATION_PROP + ANIMATION_PLAYSTATE_KEY;
	  applyInlineStyle(node, [key, value]);
	  return [key, value];
	}
	
	function applyInlineStyle(node, styleTuple) {
	  var prop = styleTuple[0];
	  var value = styleTuple[1];
	  node.style[prop] = value;
	}
	
	function concatWithSpace(a,b) {
	  if (!a) return b;
	  if (!b) return a;
	  return a + ' ' + b;
	}
	
	var $$rAFSchedulerFactory = ['$$rAF', function($$rAF) {
	  var queue, cancelFn;
	
	  function scheduler(tasks) {
	    // we make a copy since RAFScheduler mutates the state
	    // of the passed in array variable and this would be difficult
	    // to track down on the outside code
	    queue = queue.concat(tasks);
	    nextTick();
	  }
	
	  queue = scheduler.queue = [];
	
	  /* waitUntilQuiet does two things:
	   * 1. It will run the FINAL `fn` value only when an uncanceled RAF has passed through
	   * 2. It will delay the next wave of tasks from running until the quiet `fn` has run.
	   *
	   * The motivation here is that animation code can request more time from the scheduler
	   * before the next wave runs. This allows for certain DOM properties such as classes to
	   * be resolved in time for the next animation to run.
	   */
	  scheduler.waitUntilQuiet = function(fn) {
	    if (cancelFn) cancelFn();
	
	    cancelFn = $$rAF(function() {
	      cancelFn = null;
	      fn();
	      nextTick();
	    });
	  };
	
	  return scheduler;
	
	  function nextTick() {
	    if (!queue.length) return;
	
	    var items = queue.shift();
	    for (var i = 0; i < items.length; i++) {
	      items[i]();
	    }
	
	    if (!cancelFn) {
	      $$rAF(function() {
	        if (!cancelFn) nextTick();
	      });
	    }
	  }
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngAnimateChildren
	 * @restrict AE
	 * @element ANY
	 *
	 * @description
	 *
	 * ngAnimateChildren allows you to specify that children of this element should animate even if any
	 * of the children's parents are currently animating. By default, when an element has an active `enter`, `leave`, or `move`
	 * (structural) animation, child elements that also have an active structural animation are not animated.
	 *
	 * Note that even if `ngAnimateChildren` is set, no child animations will run when the parent element is removed from the DOM (`leave` animation).
	 *
	 *
	 * @param {string} ngAnimateChildren If the value is empty, `true` or `on`,
	 *     then child animations are allowed. If the value is `false`, child animations are not allowed.
	 *
	 * @example
	 * <example module="ngAnimateChildren" name="ngAnimateChildren" deps="angular-animate.js" animations="true">
	     <file name="index.html">
	       <div ng-controller="MainController as main">
	         <label>Show container? <input type="checkbox" ng-model="main.enterElement" /></label>
	         <label>Animate children? <input type="checkbox" ng-model="main.animateChildren" /></label>
	         <hr>
	         <div ng-animate-children="{{main.animateChildren}}">
	           <div ng-if="main.enterElement" class="container">
	             List of items:
	             <div ng-repeat="item in [0, 1, 2, 3]" class="item">Item {{item}}</div>
	           </div>
	         </div>
	       </div>
	     </file>
	     <file name="animations.css">
	
	      .container.ng-enter,
	      .container.ng-leave {
	        transition: all ease 1.5s;
	      }
	
	      .container.ng-enter,
	      .container.ng-leave-active {
	        opacity: 0;
	      }
	
	      .container.ng-leave,
	      .container.ng-enter-active {
	        opacity: 1;
	      }
	
	      .item {
	        background: firebrick;
	        color: #FFF;
	        margin-bottom: 10px;
	      }
	
	      .item.ng-enter,
	      .item.ng-leave {
	        transition: transform 1.5s ease;
	      }
	
	      .item.ng-enter {
	        transform: translateX(50px);
	      }
	
	      .item.ng-enter-active {
	        transform: translateX(0);
	      }
	    </file>
	    <file name="script.js">
	      angular.module('ngAnimateChildren', ['ngAnimate'])
	        .controller('MainController', function MainController() {
	          this.animateChildren = false;
	          this.enterElement = false;
	        });
	    </file>
	  </example>
	 */
	var $$AnimateChildrenDirective = ['$interpolate', function($interpolate) {
	  return {
	    link: function(scope, element, attrs) {
	      var val = attrs.ngAnimateChildren;
	      if (isString(val) && val.length === 0) { //empty attribute
	        element.data(NG_ANIMATE_CHILDREN_DATA, true);
	      } else {
	        // Interpolate and set the value, so that it is available to
	        // animations that run right after compilation
	        setData($interpolate(val)(scope));
	        attrs.$observe('ngAnimateChildren', setData);
	      }
	
	      function setData(value) {
	        value = value === 'on' || value === 'true';
	        element.data(NG_ANIMATE_CHILDREN_DATA, value);
	      }
	    }
	  };
	}];
	
	/* exported $AnimateCssProvider */
	
	var ANIMATE_TIMER_KEY = '$$animateCss';
	
	/**
	 * @ngdoc service
	 * @name $animateCss
	 * @kind object
	 *
	 * @description
	 * The `$animateCss` service is a useful utility to trigger customized CSS-based transitions/keyframes
	 * from a JavaScript-based animation or directly from a directive. The purpose of `$animateCss` is NOT
	 * to side-step how `$animate` and ngAnimate work, but the goal is to allow pre-existing animations or
	 * directives to create more complex animations that can be purely driven using CSS code.
	 *
	 * Note that only browsers that support CSS transitions and/or keyframe animations are capable of
	 * rendering animations triggered via `$animateCss` (bad news for IE9 and lower).
	 *
	 * ## Usage
	 * Once again, `$animateCss` is designed to be used inside of a registered JavaScript animation that
	 * is powered by ngAnimate. It is possible to use `$animateCss` directly inside of a directive, however,
	 * any automatic control over cancelling animations and/or preventing animations from being run on
	 * child elements will not be handled by Angular. For this to work as expected, please use `$animate` to
	 * trigger the animation and then setup a JavaScript animation that injects `$animateCss` to trigger
	 * the CSS animation.
	 *
	 * The example below shows how we can create a folding animation on an element using `ng-if`:
	 *
	 * ```html
	 * <!-- notice the `fold-animation` CSS class -->
	 * <div ng-if="onOff" class="fold-animation">
	 *   This element will go BOOM
	 * </div>
	 * <button ng-click="onOff=true">Fold In</button>
	 * ```
	 *
	 * Now we create the **JavaScript animation** that will trigger the CSS transition:
	 *
	 * ```js
	 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
	 *   return {
	 *     enter: function(element, doneFn) {
	 *       var height = element[0].offsetHeight;
	 *       return $animateCss(element, {
	 *         from: { height:'0px' },
	 *         to: { height:height + 'px' },
	 *         duration: 1 // one second
	 *       });
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * ## More Advanced Uses
	 *
	 * `$animateCss` is the underlying code that ngAnimate uses to power **CSS-based animations** behind the scenes. Therefore CSS hooks
	 * like `.ng-EVENT`, `.ng-EVENT-active`, `.ng-EVENT-stagger` are all features that can be triggered using `$animateCss` via JavaScript code.
	 *
	 * This also means that just about any combination of adding classes, removing classes, setting styles, dynamically setting a keyframe animation,
	 * applying a hardcoded duration or delay value, changing the animation easing or applying a stagger animation are all options that work with
	 * `$animateCss`. The service itself is smart enough to figure out the combination of options and examine the element styling properties in order
	 * to provide a working animation that will run in CSS.
	 *
	 * The example below showcases a more advanced version of the `.fold-animation` from the example above:
	 *
	 * ```js
	 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
	 *   return {
	 *     enter: function(element, doneFn) {
	 *       var height = element[0].offsetHeight;
	 *       return $animateCss(element, {
	 *         addClass: 'red large-text pulse-twice',
	 *         easing: 'ease-out',
	 *         from: { height:'0px' },
	 *         to: { height:height + 'px' },
	 *         duration: 1 // one second
	 *       });
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * Since we're adding/removing CSS classes then the CSS transition will also pick those up:
	 *
	 * ```css
	 * /&#42; since a hardcoded duration value of 1 was provided in the JavaScript animation code,
	 * the CSS classes below will be transitioned despite them being defined as regular CSS classes &#42;/
	 * .red { background:red; }
	 * .large-text { font-size:20px; }
	 *
	 * /&#42; we can also use a keyframe animation and $animateCss will make it work alongside the transition &#42;/
	 * .pulse-twice {
	 *   animation: 0.5s pulse linear 2;
	 *   -webkit-animation: 0.5s pulse linear 2;
	 * }
	 *
	 * @keyframes pulse {
	 *   from { transform: scale(0.5); }
	 *   to { transform: scale(1.5); }
	 * }
	 *
	 * @-webkit-keyframes pulse {
	 *   from { -webkit-transform: scale(0.5); }
	 *   to { -webkit-transform: scale(1.5); }
	 * }
	 * ```
	 *
	 * Given this complex combination of CSS classes, styles and options, `$animateCss` will figure everything out and make the animation happen.
	 *
	 * ## How the Options are handled
	 *
	 * `$animateCss` is very versatile and intelligent when it comes to figuring out what configurations to apply to the element to ensure the animation
	 * works with the options provided. Say for example we were adding a class that contained a keyframe value and we wanted to also animate some inline
	 * styles using the `from` and `to` properties.
	 *
	 * ```js
	 * var animator = $animateCss(element, {
	 *   from: { background:'red' },
	 *   to: { background:'blue' }
	 * });
	 * animator.start();
	 * ```
	 *
	 * ```css
	 * .rotating-animation {
	 *   animation:0.5s rotate linear;
	 *   -webkit-animation:0.5s rotate linear;
	 * }
	 *
	 * @keyframes rotate {
	 *   from { transform: rotate(0deg); }
	 *   to { transform: rotate(360deg); }
	 * }
	 *
	 * @-webkit-keyframes rotate {
	 *   from { -webkit-transform: rotate(0deg); }
	 *   to { -webkit-transform: rotate(360deg); }
	 * }
	 * ```
	 *
	 * The missing pieces here are that we do not have a transition set (within the CSS code nor within the `$animateCss` options) and the duration of the animation is
	 * going to be detected from what the keyframe styles on the CSS class are. In this event, `$animateCss` will automatically create an inline transition
	 * style matching the duration detected from the keyframe style (which is present in the CSS class that is being added) and then prepare both the transition
	 * and keyframe animations to run in parallel on the element. Then when the animation is underway the provided `from` and `to` CSS styles will be applied
	 * and spread across the transition and keyframe animation.
	 *
	 * ## What is returned
	 *
	 * `$animateCss` works in two stages: a preparation phase and an animation phase. Therefore when `$animateCss` is first called it will NOT actually
	 * start the animation. All that is going on here is that the element is being prepared for the animation (which means that the generated CSS classes are
	 * added and removed on the element). Once `$animateCss` is called it will return an object with the following properties:
	 *
	 * ```js
	 * var animator = $animateCss(element, { ... });
	 * ```
	 *
	 * Now what do the contents of our `animator` variable look like:
	 *
	 * ```js
	 * {
	 *   // starts the animation
	 *   start: Function,
	 *
	 *   // ends (aborts) the animation
	 *   end: Function
	 * }
	 * ```
	 *
	 * To actually start the animation we need to run `animation.start()` which will then return a promise that we can hook into to detect when the animation ends.
	 * If we choose not to run the animation then we MUST run `animation.end()` to perform a cleanup on the element (since some CSS classes and styles may have been
	 * applied to the element during the preparation phase). Note that all other properties such as duration, delay, transitions and keyframes are just properties
	 * and that changing them will not reconfigure the parameters of the animation.
	 *
	 * ### runner.done() vs runner.then()
	 * It is documented that `animation.start()` will return a promise object and this is true, however, there is also an additional method available on the
	 * runner called `.done(callbackFn)`. The done method works the same as `.finally(callbackFn)`, however, it does **not trigger a digest to occur**.
	 * Therefore, for performance reasons, it's always best to use `runner.done(callback)` instead of `runner.then()`, `runner.catch()` or `runner.finally()`
	 * unless you really need a digest to kick off afterwards.
	 *
	 * Keep in mind that, to make this easier, ngAnimate has tweaked the JS animations API to recognize when a runner instance is returned from $animateCss
	 * (so there is no need to call `runner.done(doneFn)` inside of your JavaScript animation code).
	 * Check the {@link ngAnimate.$animateCss#usage animation code above} to see how this works.
	 *
	 * @param {DOMElement} element the element that will be animated
	 * @param {object} options the animation-related options that will be applied during the animation
	 *
	 * * `event` - The DOM event (e.g. enter, leave, move). When used, a generated CSS class of `ng-EVENT` and `ng-EVENT-active` will be applied
	 * to the element during the animation. Multiple events can be provided when spaces are used as a separator. (Note that this will not perform any DOM operation.)
	 * * `structural` - Indicates that the `ng-` prefix will be added to the event class. Setting to `false` or omitting will turn `ng-EVENT` and
	 * `ng-EVENT-active` in `EVENT` and `EVENT-active`. Unused if `event` is omitted.
	 * * `easing` - The CSS easing value that will be applied to the transition or keyframe animation (or both).
	 * * `transitionStyle` - The raw CSS transition style that will be used (e.g. `1s linear all`).
	 * * `keyframeStyle` - The raw CSS keyframe animation style that will be used (e.g. `1s my_animation linear`).
	 * * `from` - The starting CSS styles (a key/value object) that will be applied at the start of the animation.
	 * * `to` - The ending CSS styles (a key/value object) that will be applied across the animation via a CSS transition.
	 * * `addClass` - A space separated list of CSS classes that will be added to the element and spread across the animation.
	 * * `removeClass` - A space separated list of CSS classes that will be removed from the element and spread across the animation.
	 * * `duration` - A number value representing the total duration of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `0`
	 * is provided then the animation will be skipped entirely.
	 * * `delay` - A number value representing the total delay of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `true` is
	 * used then whatever delay value is detected from the CSS classes will be mirrored on the elements styles (e.g. by setting delay true then the style value
	 * of the element will be `transition-delay: DETECTED_VALUE`). Using `true` is useful when you want the CSS classes and inline styles to all share the same
	 * CSS delay value.
	 * * `stagger` - A numeric time value representing the delay between successively animated elements
	 * ({@link ngAnimate#css-staggering-animations Click here to learn how CSS-based staggering works in ngAnimate.})
	 * * `staggerIndex` - The numeric index representing the stagger item (e.g. a value of 5 is equal to the sixth item in the stagger; therefore when a
	 *   `stagger` option value of `0.1` is used then there will be a stagger delay of `600ms`)
	 * * `applyClassesEarly` - Whether or not the classes being added or removed will be used when detecting the animation. This is set by `$animate` when enter/leave/move animations are fired to ensure that the CSS classes are resolved in time. (Note that this will prevent any transitions from occurring on the classes being added and removed.)
	 * * `cleanupStyles` - Whether or not the provided `from` and `to` styles will be removed once
	 *    the animation is closed. This is useful for when the styles are used purely for the sake of
	 *    the animation and do not have a lasting visual effect on the element (e.g. a collapse and open animation).
	 *    By default this value is set to `false`.
	 *
	 * @return {object} an object with start and end methods and details about the animation.
	 *
	 * * `start` - The method to start the animation. This will return a `Promise` when called.
	 * * `end` - This method will cancel the animation and remove all applied CSS classes and styles.
	 */
	var ONE_SECOND = 1000;
	
	var ELAPSED_TIME_MAX_DECIMAL_PLACES = 3;
	var CLOSING_TIME_BUFFER = 1.5;
	
	var DETECT_CSS_PROPERTIES = {
	  transitionDuration:      TRANSITION_DURATION_PROP,
	  transitionDelay:         TRANSITION_DELAY_PROP,
	  transitionProperty:      TRANSITION_PROP + PROPERTY_KEY,
	  animationDuration:       ANIMATION_DURATION_PROP,
	  animationDelay:          ANIMATION_DELAY_PROP,
	  animationIterationCount: ANIMATION_PROP + ANIMATION_ITERATION_COUNT_KEY
	};
	
	var DETECT_STAGGER_CSS_PROPERTIES = {
	  transitionDuration:      TRANSITION_DURATION_PROP,
	  transitionDelay:         TRANSITION_DELAY_PROP,
	  animationDuration:       ANIMATION_DURATION_PROP,
	  animationDelay:          ANIMATION_DELAY_PROP
	};
	
	function getCssKeyframeDurationStyle(duration) {
	  return [ANIMATION_DURATION_PROP, duration + 's'];
	}
	
	function getCssDelayStyle(delay, isKeyframeAnimation) {
	  var prop = isKeyframeAnimation ? ANIMATION_DELAY_PROP : TRANSITION_DELAY_PROP;
	  return [prop, delay + 's'];
	}
	
	function computeCssStyles($window, element, properties) {
	  var styles = Object.create(null);
	  var detectedStyles = $window.getComputedStyle(element) || {};
	  forEach(properties, function(formalStyleName, actualStyleName) {
	    var val = detectedStyles[formalStyleName];
	    if (val) {
	      var c = val.charAt(0);
	
	      // only numerical-based values have a negative sign or digit as the first value
	      if (c === '-' || c === '+' || c >= 0) {
	        val = parseMaxTime(val);
	      }
	
	      // by setting this to null in the event that the delay is not set or is set directly as 0
	      // then we can still allow for negative values to be used later on and not mistake this
	      // value for being greater than any other negative value.
	      if (val === 0) {
	        val = null;
	      }
	      styles[actualStyleName] = val;
	    }
	  });
	
	  return styles;
	}
	
	function parseMaxTime(str) {
	  var maxValue = 0;
	  var values = str.split(/\s*,\s*/);
	  forEach(values, function(value) {
	    // it's always safe to consider only second values and omit `ms` values since
	    // getComputedStyle will always handle the conversion for us
	    if (value.charAt(value.length - 1) === 's') {
	      value = value.substring(0, value.length - 1);
	    }
	    value = parseFloat(value) || 0;
	    maxValue = maxValue ? Math.max(value, maxValue) : value;
	  });
	  return maxValue;
	}
	
	function truthyTimingValue(val) {
	  return val === 0 || val != null;
	}
	
	function getCssTransitionDurationStyle(duration, applyOnlyDuration) {
	  var style = TRANSITION_PROP;
	  var value = duration + 's';
	  if (applyOnlyDuration) {
	    style += DURATION_KEY;
	  } else {
	    value += ' linear all';
	  }
	  return [style, value];
	}
	
	function createLocalCacheLookup() {
	  var cache = Object.create(null);
	  return {
	    flush: function() {
	      cache = Object.create(null);
	    },
	
	    count: function(key) {
	      var entry = cache[key];
	      return entry ? entry.total : 0;
	    },
	
	    get: function(key) {
	      var entry = cache[key];
	      return entry && entry.value;
	    },
	
	    put: function(key, value) {
	      if (!cache[key]) {
	        cache[key] = { total: 1, value: value };
	      } else {
	        cache[key].total++;
	      }
	    }
	  };
	}
	
	// we do not reassign an already present style value since
	// if we detect the style property value again we may be
	// detecting styles that were added via the `from` styles.
	// We make use of `isDefined` here since an empty string
	// or null value (which is what getPropertyValue will return
	// for a non-existing style) will still be marked as a valid
	// value for the style (a falsy value implies that the style
	// is to be removed at the end of the animation). If we had a simple
	// "OR" statement then it would not be enough to catch that.
	function registerRestorableStyles(backup, node, properties) {
	  forEach(properties, function(prop) {
	    backup[prop] = isDefined(backup[prop])
	        ? backup[prop]
	        : node.style.getPropertyValue(prop);
	  });
	}
	
	var $AnimateCssProvider = ['$animateProvider', /** @this */ function($animateProvider) {
	  var gcsLookup = createLocalCacheLookup();
	  var gcsStaggerLookup = createLocalCacheLookup();
	
	  this.$get = ['$window', '$$jqLite', '$$AnimateRunner', '$timeout',
	               '$$forceReflow', '$sniffer', '$$rAFScheduler', '$$animateQueue',
	       function($window,   $$jqLite,   $$AnimateRunner,   $timeout,
	                $$forceReflow,   $sniffer,   $$rAFScheduler, $$animateQueue) {
	
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	
	    var parentCounter = 0;
	    function gcsHashFn(node, extraClasses) {
	      var KEY = '$$ngAnimateParentKey';
	      var parentNode = node.parentNode;
	      var parentID = parentNode[KEY] || (parentNode[KEY] = ++parentCounter);
	      return parentID + '-' + node.getAttribute('class') + '-' + extraClasses;
	    }
	
	    function computeCachedCssStyles(node, className, cacheKey, properties) {
	      var timings = gcsLookup.get(cacheKey);
	
	      if (!timings) {
	        timings = computeCssStyles($window, node, properties);
	        if (timings.animationIterationCount === 'infinite') {
	          timings.animationIterationCount = 1;
	        }
	      }
	
	      // we keep putting this in multiple times even though the value and the cacheKey are the same
	      // because we're keeping an internal tally of how many duplicate animations are detected.
	      gcsLookup.put(cacheKey, timings);
	      return timings;
	    }
	
	    function computeCachedCssStaggerStyles(node, className, cacheKey, properties) {
	      var stagger;
	
	      // if we have one or more existing matches of matching elements
	      // containing the same parent + CSS styles (which is how cacheKey works)
	      // then staggering is possible
	      if (gcsLookup.count(cacheKey) > 0) {
	        stagger = gcsStaggerLookup.get(cacheKey);
	
	        if (!stagger) {
	          var staggerClassName = pendClasses(className, '-stagger');
	
	          $$jqLite.addClass(node, staggerClassName);
	
	          stagger = computeCssStyles($window, node, properties);
	
	          // force the conversion of a null value to zero incase not set
	          stagger.animationDuration = Math.max(stagger.animationDuration, 0);
	          stagger.transitionDuration = Math.max(stagger.transitionDuration, 0);
	
	          $$jqLite.removeClass(node, staggerClassName);
	
	          gcsStaggerLookup.put(cacheKey, stagger);
	        }
	      }
	
	      return stagger || {};
	    }
	
	    var rafWaitQueue = [];
	    function waitUntilQuiet(callback) {
	      rafWaitQueue.push(callback);
	      $$rAFScheduler.waitUntilQuiet(function() {
	        gcsLookup.flush();
	        gcsStaggerLookup.flush();
	
	        // DO NOT REMOVE THIS LINE OR REFACTOR OUT THE `pageWidth` variable.
	        // PLEASE EXAMINE THE `$$forceReflow` service to understand why.
	        var pageWidth = $$forceReflow();
	
	        // we use a for loop to ensure that if the queue is changed
	        // during this looping then it will consider new requests
	        for (var i = 0; i < rafWaitQueue.length; i++) {
	          rafWaitQueue[i](pageWidth);
	        }
	        rafWaitQueue.length = 0;
	      });
	    }
	
	    function computeTimings(node, className, cacheKey) {
	      var timings = computeCachedCssStyles(node, className, cacheKey, DETECT_CSS_PROPERTIES);
	      var aD = timings.animationDelay;
	      var tD = timings.transitionDelay;
	      timings.maxDelay = aD && tD
	          ? Math.max(aD, tD)
	          : (aD || tD);
	      timings.maxDuration = Math.max(
	          timings.animationDuration * timings.animationIterationCount,
	          timings.transitionDuration);
	
	      return timings;
	    }
	
	    return function init(element, initialOptions) {
	      // all of the animation functions should create
	      // a copy of the options data, however, if a
	      // parent service has already created a copy then
	      // we should stick to using that
	      var options = initialOptions || {};
	      if (!options.$$prepared) {
	        options = prepareAnimationOptions(copy(options));
	      }
	
	      var restoreStyles = {};
	      var node = getDomNode(element);
	      if (!node
	          || !node.parentNode
	          || !$$animateQueue.enabled()) {
	        return closeAndReturnNoopAnimator();
	      }
	
	      var temporaryStyles = [];
	      var classes = element.attr('class');
	      var styles = packageStyles(options);
	      var animationClosed;
	      var animationPaused;
	      var animationCompleted;
	      var runner;
	      var runnerHost;
	      var maxDelay;
	      var maxDelayTime;
	      var maxDuration;
	      var maxDurationTime;
	      var startTime;
	      var events = [];
	
	      if (options.duration === 0 || (!$sniffer.animations && !$sniffer.transitions)) {
	        return closeAndReturnNoopAnimator();
	      }
	
	      var method = options.event && isArray(options.event)
	            ? options.event.join(' ')
	            : options.event;
	
	      var isStructural = method && options.structural;
	      var structuralClassName = '';
	      var addRemoveClassName = '';
	
	      if (isStructural) {
	        structuralClassName = pendClasses(method, EVENT_CLASS_PREFIX, true);
	      } else if (method) {
	        structuralClassName = method;
	      }
	
	      if (options.addClass) {
	        addRemoveClassName += pendClasses(options.addClass, ADD_CLASS_SUFFIX);
	      }
	
	      if (options.removeClass) {
	        if (addRemoveClassName.length) {
	          addRemoveClassName += ' ';
	        }
	        addRemoveClassName += pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX);
	      }
	
	      // there may be a situation where a structural animation is combined together
	      // with CSS classes that need to resolve before the animation is computed.
	      // However this means that there is no explicit CSS code to block the animation
	      // from happening (by setting 0s none in the class name). If this is the case
	      // we need to apply the classes before the first rAF so we know to continue if
	      // there actually is a detected transition or keyframe animation
	      if (options.applyClassesEarly && addRemoveClassName.length) {
	        applyAnimationClasses(element, options);
	      }
	
	      var preparationClasses = [structuralClassName, addRemoveClassName].join(' ').trim();
	      var fullClassName = classes + ' ' + preparationClasses;
	      var activeClasses = pendClasses(preparationClasses, ACTIVE_CLASS_SUFFIX);
	      var hasToStyles = styles.to && Object.keys(styles.to).length > 0;
	      var containsKeyframeAnimation = (options.keyframeStyle || '').length > 0;
	
	      // there is no way we can trigger an animation if no styles and
	      // no classes are being applied which would then trigger a transition,
	      // unless there a is raw keyframe value that is applied to the element.
	      if (!containsKeyframeAnimation
	           && !hasToStyles
	           && !preparationClasses) {
	        return closeAndReturnNoopAnimator();
	      }
	
	      var cacheKey, stagger;
	      if (options.stagger > 0) {
	        var staggerVal = parseFloat(options.stagger);
	        stagger = {
	          transitionDelay: staggerVal,
	          animationDelay: staggerVal,
	          transitionDuration: 0,
	          animationDuration: 0
	        };
	      } else {
	        cacheKey = gcsHashFn(node, fullClassName);
	        stagger = computeCachedCssStaggerStyles(node, preparationClasses, cacheKey, DETECT_STAGGER_CSS_PROPERTIES);
	      }
	
	      if (!options.$$skipPreparationClasses) {
	        $$jqLite.addClass(element, preparationClasses);
	      }
	
	      var applyOnlyDuration;
	
	      if (options.transitionStyle) {
	        var transitionStyle = [TRANSITION_PROP, options.transitionStyle];
	        applyInlineStyle(node, transitionStyle);
	        temporaryStyles.push(transitionStyle);
	      }
	
	      if (options.duration >= 0) {
	        applyOnlyDuration = node.style[TRANSITION_PROP].length > 0;
	        var durationStyle = getCssTransitionDurationStyle(options.duration, applyOnlyDuration);
	
	        // we set the duration so that it will be picked up by getComputedStyle later
	        applyInlineStyle(node, durationStyle);
	        temporaryStyles.push(durationStyle);
	      }
	
	      if (options.keyframeStyle) {
	        var keyframeStyle = [ANIMATION_PROP, options.keyframeStyle];
	        applyInlineStyle(node, keyframeStyle);
	        temporaryStyles.push(keyframeStyle);
	      }
	
	      var itemIndex = stagger
	          ? options.staggerIndex >= 0
	              ? options.staggerIndex
	              : gcsLookup.count(cacheKey)
	          : 0;
	
	      var isFirst = itemIndex === 0;
	
	      // this is a pre-emptive way of forcing the setup classes to be added and applied INSTANTLY
	      // without causing any combination of transitions to kick in. By adding a negative delay value
	      // it forces the setup class' transition to end immediately. We later then remove the negative
	      // transition delay to allow for the transition to naturally do it's thing. The beauty here is
	      // that if there is no transition defined then nothing will happen and this will also allow
	      // other transitions to be stacked on top of each other without any chopping them out.
	      if (isFirst && !options.skipBlocking) {
	        blockTransitions(node, SAFE_FAST_FORWARD_DURATION_VALUE);
	      }
	
	      var timings = computeTimings(node, fullClassName, cacheKey);
	      var relativeDelay = timings.maxDelay;
	      maxDelay = Math.max(relativeDelay, 0);
	      maxDuration = timings.maxDuration;
	
	      var flags = {};
	      flags.hasTransitions          = timings.transitionDuration > 0;
	      flags.hasAnimations           = timings.animationDuration > 0;
	      flags.hasTransitionAll        = flags.hasTransitions && timings.transitionProperty === 'all';
	      flags.applyTransitionDuration = hasToStyles && (
	                                        (flags.hasTransitions && !flags.hasTransitionAll)
	                                         || (flags.hasAnimations && !flags.hasTransitions));
	      flags.applyAnimationDuration  = options.duration && flags.hasAnimations;
	      flags.applyTransitionDelay    = truthyTimingValue(options.delay) && (flags.applyTransitionDuration || flags.hasTransitions);
	      flags.applyAnimationDelay     = truthyTimingValue(options.delay) && flags.hasAnimations;
	      flags.recalculateTimingStyles = addRemoveClassName.length > 0;
	
	      if (flags.applyTransitionDuration || flags.applyAnimationDuration) {
	        maxDuration = options.duration ? parseFloat(options.duration) : maxDuration;
	
	        if (flags.applyTransitionDuration) {
	          flags.hasTransitions = true;
	          timings.transitionDuration = maxDuration;
	          applyOnlyDuration = node.style[TRANSITION_PROP + PROPERTY_KEY].length > 0;
	          temporaryStyles.push(getCssTransitionDurationStyle(maxDuration, applyOnlyDuration));
	        }
	
	        if (flags.applyAnimationDuration) {
	          flags.hasAnimations = true;
	          timings.animationDuration = maxDuration;
	          temporaryStyles.push(getCssKeyframeDurationStyle(maxDuration));
	        }
	      }
	
	      if (maxDuration === 0 && !flags.recalculateTimingStyles) {
	        return closeAndReturnNoopAnimator();
	      }
	
	      if (options.delay != null) {
	        var delayStyle;
	        if (typeof options.delay !== 'boolean') {
	          delayStyle = parseFloat(options.delay);
	          // number in options.delay means we have to recalculate the delay for the closing timeout
	          maxDelay = Math.max(delayStyle, 0);
	        }
	
	        if (flags.applyTransitionDelay) {
	          temporaryStyles.push(getCssDelayStyle(delayStyle));
	        }
	
	        if (flags.applyAnimationDelay) {
	          temporaryStyles.push(getCssDelayStyle(delayStyle, true));
	        }
	      }
	
	      // we need to recalculate the delay value since we used a pre-emptive negative
	      // delay value and the delay value is required for the final event checking. This
	      // property will ensure that this will happen after the RAF phase has passed.
	      if (options.duration == null && timings.transitionDuration > 0) {
	        flags.recalculateTimingStyles = flags.recalculateTimingStyles || isFirst;
	      }
	
	      maxDelayTime = maxDelay * ONE_SECOND;
	      maxDurationTime = maxDuration * ONE_SECOND;
	      if (!options.skipBlocking) {
	        flags.blockTransition = timings.transitionDuration > 0;
	        flags.blockKeyframeAnimation = timings.animationDuration > 0 &&
	                                       stagger.animationDelay > 0 &&
	                                       stagger.animationDuration === 0;
	      }
	
	      if (options.from) {
	        if (options.cleanupStyles) {
	          registerRestorableStyles(restoreStyles, node, Object.keys(options.from));
	        }
	        applyAnimationFromStyles(element, options);
	      }
	
	      if (flags.blockTransition || flags.blockKeyframeAnimation) {
	        applyBlocking(maxDuration);
	      } else if (!options.skipBlocking) {
	        blockTransitions(node, false);
	      }
	
	      // TODO(matsko): for 1.5 change this code to have an animator object for better debugging
	      return {
	        $$willAnimate: true,
	        end: endFn,
	        start: function() {
	          if (animationClosed) return;
	
	          runnerHost = {
	            end: endFn,
	            cancel: cancelFn,
	            resume: null, //this will be set during the start() phase
	            pause: null
	          };
	
	          runner = new $$AnimateRunner(runnerHost);
	
	          waitUntilQuiet(start);
	
	          // we don't have access to pause/resume the animation
	          // since it hasn't run yet. AnimateRunner will therefore
	          // set noop functions for resume and pause and they will
	          // later be overridden once the animation is triggered
	          return runner;
	        }
	      };
	
	      function endFn() {
	        close();
	      }
	
	      function cancelFn() {
	        close(true);
	      }
	
	      function close(rejected) {
	        // if the promise has been called already then we shouldn't close
	        // the animation again
	        if (animationClosed || (animationCompleted && animationPaused)) return;
	        animationClosed = true;
	        animationPaused = false;
	
	        if (!options.$$skipPreparationClasses) {
	          $$jqLite.removeClass(element, preparationClasses);
	        }
	        $$jqLite.removeClass(element, activeClasses);
	
	        blockKeyframeAnimations(node, false);
	        blockTransitions(node, false);
	
	        forEach(temporaryStyles, function(entry) {
	          // There is only one way to remove inline style properties entirely from elements.
	          // By using `removeProperty` this works, but we need to convert camel-cased CSS
	          // styles down to hyphenated values.
	          node.style[entry[0]] = '';
	        });
	
	        applyAnimationClasses(element, options);
	        applyAnimationStyles(element, options);
	
	        if (Object.keys(restoreStyles).length) {
	          forEach(restoreStyles, function(value, prop) {
	            if (value) {
	              node.style.setProperty(prop, value);
	            } else {
	              node.style.removeProperty(prop);
	            }
	          });
	        }
	
	        // the reason why we have this option is to allow a synchronous closing callback
	        // that is fired as SOON as the animation ends (when the CSS is removed) or if
	        // the animation never takes off at all. A good example is a leave animation since
	        // the element must be removed just after the animation is over or else the element
	        // will appear on screen for one animation frame causing an overbearing flicker.
	        if (options.onDone) {
	          options.onDone();
	        }
	
	        if (events && events.length) {
	          // Remove the transitionend / animationend listener(s)
	          element.off(events.join(' '), onAnimationProgress);
	        }
	
	        //Cancel the fallback closing timeout and remove the timer data
	        var animationTimerData = element.data(ANIMATE_TIMER_KEY);
	        if (animationTimerData) {
	          $timeout.cancel(animationTimerData[0].timer);
	          element.removeData(ANIMATE_TIMER_KEY);
	        }
	
	        // if the preparation function fails then the promise is not setup
	        if (runner) {
	          runner.complete(!rejected);
	        }
	      }
	
	      function applyBlocking(duration) {
	        if (flags.blockTransition) {
	          blockTransitions(node, duration);
	        }
	
	        if (flags.blockKeyframeAnimation) {
	          blockKeyframeAnimations(node, !!duration);
	        }
	      }
	
	      function closeAndReturnNoopAnimator() {
	        runner = new $$AnimateRunner({
	          end: endFn,
	          cancel: cancelFn
	        });
	
	        // should flush the cache animation
	        waitUntilQuiet(noop);
	        close();
	
	        return {
	          $$willAnimate: false,
	          start: function() {
	            return runner;
	          },
	          end: endFn
	        };
	      }
	
	      function onAnimationProgress(event) {
	        event.stopPropagation();
	        var ev = event.originalEvent || event;
	
	        // we now always use `Date.now()` due to the recent changes with
	        // event.timeStamp in Firefox, Webkit and Chrome (see #13494 for more info)
	        var timeStamp = ev.$manualTimeStamp || Date.now();
	
	        /* Firefox (or possibly just Gecko) likes to not round values up
	         * when a ms measurement is used for the animation */
	        var elapsedTime = parseFloat(ev.elapsedTime.toFixed(ELAPSED_TIME_MAX_DECIMAL_PLACES));
	
	        /* $manualTimeStamp is a mocked timeStamp value which is set
	         * within browserTrigger(). This is only here so that tests can
	         * mock animations properly. Real events fallback to event.timeStamp,
	         * or, if they don't, then a timeStamp is automatically created for them.
	         * We're checking to see if the timeStamp surpasses the expected delay,
	         * but we're using elapsedTime instead of the timeStamp on the 2nd
	         * pre-condition since animationPauseds sometimes close off early */
	        if (Math.max(timeStamp - startTime, 0) >= maxDelayTime && elapsedTime >= maxDuration) {
	          // we set this flag to ensure that if the transition is paused then, when resumed,
	          // the animation will automatically close itself since transitions cannot be paused.
	          animationCompleted = true;
	          close();
	        }
	      }
	
	      function start() {
	        if (animationClosed) return;
	        if (!node.parentNode) {
	          close();
	          return;
	        }
	
	        // even though we only pause keyframe animations here the pause flag
	        // will still happen when transitions are used. Only the transition will
	        // not be paused since that is not possible. If the animation ends when
	        // paused then it will not complete until unpaused or cancelled.
	        var playPause = function(playAnimation) {
	          if (!animationCompleted) {
	            animationPaused = !playAnimation;
	            if (timings.animationDuration) {
	              var value = blockKeyframeAnimations(node, animationPaused);
	              if (animationPaused) {
	                temporaryStyles.push(value);
	              } else {
	                removeFromArray(temporaryStyles, value);
	              }
	            }
	          } else if (animationPaused && playAnimation) {
	            animationPaused = false;
	            close();
	          }
	        };
	
	        // checking the stagger duration prevents an accidentally cascade of the CSS delay style
	        // being inherited from the parent. If the transition duration is zero then we can safely
	        // rely that the delay value is an intentional stagger delay style.
	        var maxStagger = itemIndex > 0
	                         && ((timings.transitionDuration && stagger.transitionDuration === 0) ||
	                            (timings.animationDuration && stagger.animationDuration === 0))
	                         && Math.max(stagger.animationDelay, stagger.transitionDelay);
	        if (maxStagger) {
	          $timeout(triggerAnimationStart,
	                   Math.floor(maxStagger * itemIndex * ONE_SECOND),
	                   false);
	        } else {
	          triggerAnimationStart();
	        }
	
	        // this will decorate the existing promise runner with pause/resume methods
	        runnerHost.resume = function() {
	          playPause(true);
	        };
	
	        runnerHost.pause = function() {
	          playPause(false);
	        };
	
	        function triggerAnimationStart() {
	          // just incase a stagger animation kicks in when the animation
	          // itself was cancelled entirely
	          if (animationClosed) return;
	
	          applyBlocking(false);
	
	          forEach(temporaryStyles, function(entry) {
	            var key = entry[0];
	            var value = entry[1];
	            node.style[key] = value;
	          });
	
	          applyAnimationClasses(element, options);
	          $$jqLite.addClass(element, activeClasses);
	
	          if (flags.recalculateTimingStyles) {
	            fullClassName = node.getAttribute('class') + ' ' + preparationClasses;
	            cacheKey = gcsHashFn(node, fullClassName);
	
	            timings = computeTimings(node, fullClassName, cacheKey);
	            relativeDelay = timings.maxDelay;
	            maxDelay = Math.max(relativeDelay, 0);
	            maxDuration = timings.maxDuration;
	
	            if (maxDuration === 0) {
	              close();
	              return;
	            }
	
	            flags.hasTransitions = timings.transitionDuration > 0;
	            flags.hasAnimations = timings.animationDuration > 0;
	          }
	
	          if (flags.applyAnimationDelay) {
	            relativeDelay = typeof options.delay !== 'boolean' && truthyTimingValue(options.delay)
	                  ? parseFloat(options.delay)
	                  : relativeDelay;
	
	            maxDelay = Math.max(relativeDelay, 0);
	            timings.animationDelay = relativeDelay;
	            delayStyle = getCssDelayStyle(relativeDelay, true);
	            temporaryStyles.push(delayStyle);
	            node.style[delayStyle[0]] = delayStyle[1];
	          }
	
	          maxDelayTime = maxDelay * ONE_SECOND;
	          maxDurationTime = maxDuration * ONE_SECOND;
	
	          if (options.easing) {
	            var easeProp, easeVal = options.easing;
	            if (flags.hasTransitions) {
	              easeProp = TRANSITION_PROP + TIMING_KEY;
	              temporaryStyles.push([easeProp, easeVal]);
	              node.style[easeProp] = easeVal;
	            }
	            if (flags.hasAnimations) {
	              easeProp = ANIMATION_PROP + TIMING_KEY;
	              temporaryStyles.push([easeProp, easeVal]);
	              node.style[easeProp] = easeVal;
	            }
	          }
	
	          if (timings.transitionDuration) {
	            events.push(TRANSITIONEND_EVENT);
	          }
	
	          if (timings.animationDuration) {
	            events.push(ANIMATIONEND_EVENT);
	          }
	
	          startTime = Date.now();
	          var timerTime = maxDelayTime + CLOSING_TIME_BUFFER * maxDurationTime;
	          var endTime = startTime + timerTime;
	
	          var animationsData = element.data(ANIMATE_TIMER_KEY) || [];
	          var setupFallbackTimer = true;
	          if (animationsData.length) {
	            var currentTimerData = animationsData[0];
	            setupFallbackTimer = endTime > currentTimerData.expectedEndTime;
	            if (setupFallbackTimer) {
	              $timeout.cancel(currentTimerData.timer);
	            } else {
	              animationsData.push(close);
	            }
	          }
	
	          if (setupFallbackTimer) {
	            var timer = $timeout(onAnimationExpired, timerTime, false);
	            animationsData[0] = {
	              timer: timer,
	              expectedEndTime: endTime
	            };
	            animationsData.push(close);
	            element.data(ANIMATE_TIMER_KEY, animationsData);
	          }
	
	          if (events.length) {
	            element.on(events.join(' '), onAnimationProgress);
	          }
	
	          if (options.to) {
	            if (options.cleanupStyles) {
	              registerRestorableStyles(restoreStyles, node, Object.keys(options.to));
	            }
	            applyAnimationToStyles(element, options);
	          }
	        }
	
	        function onAnimationExpired() {
	          var animationsData = element.data(ANIMATE_TIMER_KEY);
	
	          // this will be false in the event that the element was
	          // removed from the DOM (via a leave animation or something
	          // similar)
	          if (animationsData) {
	            for (var i = 1; i < animationsData.length; i++) {
	              animationsData[i]();
	            }
	            element.removeData(ANIMATE_TIMER_KEY);
	          }
	        }
	      }
	    };
	  }];
	}];
	
	var $$AnimateCssDriverProvider = ['$$animationProvider', /** @this */ function($$animationProvider) {
	  $$animationProvider.drivers.push('$$animateCssDriver');
	
	  var NG_ANIMATE_SHIM_CLASS_NAME = 'ng-animate-shim';
	  var NG_ANIMATE_ANCHOR_CLASS_NAME = 'ng-anchor';
	
	  var NG_OUT_ANCHOR_CLASS_NAME = 'ng-anchor-out';
	  var NG_IN_ANCHOR_CLASS_NAME = 'ng-anchor-in';
	
	  function isDocumentFragment(node) {
	    return node.parentNode && node.parentNode.nodeType === 11;
	  }
	
	  this.$get = ['$animateCss', '$rootScope', '$$AnimateRunner', '$rootElement', '$sniffer', '$$jqLite', '$document',
	       function($animateCss,   $rootScope,   $$AnimateRunner,   $rootElement,   $sniffer,   $$jqLite,   $document) {
	
	    // only browsers that support these properties can render animations
	    if (!$sniffer.animations && !$sniffer.transitions) return noop;
	
	    var bodyNode = $document[0].body;
	    var rootNode = getDomNode($rootElement);
	
	    var rootBodyElement = jqLite(
	      // this is to avoid using something that exists outside of the body
	      // we also special case the doc fragment case because our unit test code
	      // appends the $rootElement to the body after the app has been bootstrapped
	      isDocumentFragment(rootNode) || bodyNode.contains(rootNode) ? rootNode : bodyNode
	    );
	
	    return function initDriverFn(animationDetails) {
	      return animationDetails.from && animationDetails.to
	          ? prepareFromToAnchorAnimation(animationDetails.from,
	                                         animationDetails.to,
	                                         animationDetails.classes,
	                                         animationDetails.anchors)
	          : prepareRegularAnimation(animationDetails);
	    };
	
	    function filterCssClasses(classes) {
	      //remove all the `ng-` stuff
	      return classes.replace(/\bng-\S+\b/g, '');
	    }
	
	    function getUniqueValues(a, b) {
	      if (isString(a)) a = a.split(' ');
	      if (isString(b)) b = b.split(' ');
	      return a.filter(function(val) {
	        return b.indexOf(val) === -1;
	      }).join(' ');
	    }
	
	    function prepareAnchoredAnimation(classes, outAnchor, inAnchor) {
	      var clone = jqLite(getDomNode(outAnchor).cloneNode(true));
	      var startingClasses = filterCssClasses(getClassVal(clone));
	
	      outAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);
	      inAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);
	
	      clone.addClass(NG_ANIMATE_ANCHOR_CLASS_NAME);
	
	      rootBodyElement.append(clone);
	
	      var animatorIn, animatorOut = prepareOutAnimation();
	
	      // the user may not end up using the `out` animation and
	      // only making use of the `in` animation or vice-versa.
	      // In either case we should allow this and not assume the
	      // animation is over unless both animations are not used.
	      if (!animatorOut) {
	        animatorIn = prepareInAnimation();
	        if (!animatorIn) {
	          return end();
	        }
	      }
	
	      var startingAnimator = animatorOut || animatorIn;
	
	      return {
	        start: function() {
	          var runner;
	
	          var currentAnimation = startingAnimator.start();
	          currentAnimation.done(function() {
	            currentAnimation = null;
	            if (!animatorIn) {
	              animatorIn = prepareInAnimation();
	              if (animatorIn) {
	                currentAnimation = animatorIn.start();
	                currentAnimation.done(function() {
	                  currentAnimation = null;
	                  end();
	                  runner.complete();
	                });
	                return currentAnimation;
	              }
	            }
	            // in the event that there is no `in` animation
	            end();
	            runner.complete();
	          });
	
	          runner = new $$AnimateRunner({
	            end: endFn,
	            cancel: endFn
	          });
	
	          return runner;
	
	          function endFn() {
	            if (currentAnimation) {
	              currentAnimation.end();
	            }
	          }
	        }
	      };
	
	      function calculateAnchorStyles(anchor) {
	        var styles = {};
	
	        var coords = getDomNode(anchor).getBoundingClientRect();
	
	        // we iterate directly since safari messes up and doesn't return
	        // all the keys for the coords object when iterated
	        forEach(['width','height','top','left'], function(key) {
	          var value = coords[key];
	          switch (key) {
	            case 'top':
	              value += bodyNode.scrollTop;
	              break;
	            case 'left':
	              value += bodyNode.scrollLeft;
	              break;
	          }
	          styles[key] = Math.floor(value) + 'px';
	        });
	        return styles;
	      }
	
	      function prepareOutAnimation() {
	        var animator = $animateCss(clone, {
	          addClass: NG_OUT_ANCHOR_CLASS_NAME,
	          delay: true,
	          from: calculateAnchorStyles(outAnchor)
	        });
	
	        // read the comment within `prepareRegularAnimation` to understand
	        // why this check is necessary
	        return animator.$$willAnimate ? animator : null;
	      }
	
	      function getClassVal(element) {
	        return element.attr('class') || '';
	      }
	
	      function prepareInAnimation() {
	        var endingClasses = filterCssClasses(getClassVal(inAnchor));
	        var toAdd = getUniqueValues(endingClasses, startingClasses);
	        var toRemove = getUniqueValues(startingClasses, endingClasses);
	
	        var animator = $animateCss(clone, {
	          to: calculateAnchorStyles(inAnchor),
	          addClass: NG_IN_ANCHOR_CLASS_NAME + ' ' + toAdd,
	          removeClass: NG_OUT_ANCHOR_CLASS_NAME + ' ' + toRemove,
	          delay: true
	        });
	
	        // read the comment within `prepareRegularAnimation` to understand
	        // why this check is necessary
	        return animator.$$willAnimate ? animator : null;
	      }
	
	      function end() {
	        clone.remove();
	        outAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
	        inAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
	      }
	    }
	
	    function prepareFromToAnchorAnimation(from, to, classes, anchors) {
	      var fromAnimation = prepareRegularAnimation(from, noop);
	      var toAnimation = prepareRegularAnimation(to, noop);
	
	      var anchorAnimations = [];
	      forEach(anchors, function(anchor) {
	        var outElement = anchor['out'];
	        var inElement = anchor['in'];
	        var animator = prepareAnchoredAnimation(classes, outElement, inElement);
	        if (animator) {
	          anchorAnimations.push(animator);
	        }
	      });
	
	      // no point in doing anything when there are no elements to animate
	      if (!fromAnimation && !toAnimation && anchorAnimations.length === 0) return;
	
	      return {
	        start: function() {
	          var animationRunners = [];
	
	          if (fromAnimation) {
	            animationRunners.push(fromAnimation.start());
	          }
	
	          if (toAnimation) {
	            animationRunners.push(toAnimation.start());
	          }
	
	          forEach(anchorAnimations, function(animation) {
	            animationRunners.push(animation.start());
	          });
	
	          var runner = new $$AnimateRunner({
	            end: endFn,
	            cancel: endFn // CSS-driven animations cannot be cancelled, only ended
	          });
	
	          $$AnimateRunner.all(animationRunners, function(status) {
	            runner.complete(status);
	          });
	
	          return runner;
	
	          function endFn() {
	            forEach(animationRunners, function(runner) {
	              runner.end();
	            });
	          }
	        }
	      };
	    }
	
	    function prepareRegularAnimation(animationDetails) {
	      var element = animationDetails.element;
	      var options = animationDetails.options || {};
	
	      if (animationDetails.structural) {
	        options.event = animationDetails.event;
	        options.structural = true;
	        options.applyClassesEarly = true;
	
	        // we special case the leave animation since we want to ensure that
	        // the element is removed as soon as the animation is over. Otherwise
	        // a flicker might appear or the element may not be removed at all
	        if (animationDetails.event === 'leave') {
	          options.onDone = options.domOperation;
	        }
	      }
	
	      // We assign the preparationClasses as the actual animation event since
	      // the internals of $animateCss will just suffix the event token values
	      // with `-active` to trigger the animation.
	      if (options.preparationClasses) {
	        options.event = concatWithSpace(options.event, options.preparationClasses);
	      }
	
	      var animator = $animateCss(element, options);
	
	      // the driver lookup code inside of $$animation attempts to spawn a
	      // driver one by one until a driver returns a.$$willAnimate animator object.
	      // $animateCss will always return an object, however, it will pass in
	      // a flag as a hint as to whether an animation was detected or not
	      return animator.$$willAnimate ? animator : null;
	    }
	  }];
	}];
	
	// TODO(matsko): use caching here to speed things up for detection
	// TODO(matsko): add documentation
	//  by the time...
	
	var $$AnimateJsProvider = ['$animateProvider', /** @this */ function($animateProvider) {
	  this.$get = ['$injector', '$$AnimateRunner', '$$jqLite',
	       function($injector,   $$AnimateRunner,   $$jqLite) {
	
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	         // $animateJs(element, 'enter');
	    return function(element, event, classes, options) {
	      var animationClosed = false;
	
	      // the `classes` argument is optional and if it is not used
	      // then the classes will be resolved from the element's className
	      // property as well as options.addClass/options.removeClass.
	      if (arguments.length === 3 && isObject(classes)) {
	        options = classes;
	        classes = null;
	      }
	
	      options = prepareAnimationOptions(options);
	      if (!classes) {
	        classes = element.attr('class') || '';
	        if (options.addClass) {
	          classes += ' ' + options.addClass;
	        }
	        if (options.removeClass) {
	          classes += ' ' + options.removeClass;
	        }
	      }
	
	      var classesToAdd = options.addClass;
	      var classesToRemove = options.removeClass;
	
	      // the lookupAnimations function returns a series of animation objects that are
	      // matched up with one or more of the CSS classes. These animation objects are
	      // defined via the module.animation factory function. If nothing is detected then
	      // we don't return anything which then makes $animation query the next driver.
	      var animations = lookupAnimations(classes);
	      var before, after;
	      if (animations.length) {
	        var afterFn, beforeFn;
	        if (event === 'leave') {
	          beforeFn = 'leave';
	          afterFn = 'afterLeave'; // TODO(matsko): get rid of this
	        } else {
	          beforeFn = 'before' + event.charAt(0).toUpperCase() + event.substr(1);
	          afterFn = event;
	        }
	
	        if (event !== 'enter' && event !== 'move') {
	          before = packageAnimations(element, event, options, animations, beforeFn);
	        }
	        after  = packageAnimations(element, event, options, animations, afterFn);
	      }
	
	      // no matching animations
	      if (!before && !after) return;
	
	      function applyOptions() {
	        options.domOperation();
	        applyAnimationClasses(element, options);
	      }
	
	      function close() {
	        animationClosed = true;
	        applyOptions();
	        applyAnimationStyles(element, options);
	      }
	
	      var runner;
	
	      return {
	        $$willAnimate: true,
	        end: function() {
	          if (runner) {
	            runner.end();
	          } else {
	            close();
	            runner = new $$AnimateRunner();
	            runner.complete(true);
	          }
	          return runner;
	        },
	        start: function() {
	          if (runner) {
	            return runner;
	          }
	
	          runner = new $$AnimateRunner();
	          var closeActiveAnimations;
	          var chain = [];
	
	          if (before) {
	            chain.push(function(fn) {
	              closeActiveAnimations = before(fn);
	            });
	          }
	
	          if (chain.length) {
	            chain.push(function(fn) {
	              applyOptions();
	              fn(true);
	            });
	          } else {
	            applyOptions();
	          }
	
	          if (after) {
	            chain.push(function(fn) {
	              closeActiveAnimations = after(fn);
	            });
	          }
	
	          runner.setHost({
	            end: function() {
	              endAnimations();
	            },
	            cancel: function() {
	              endAnimations(true);
	            }
	          });
	
	          $$AnimateRunner.chain(chain, onComplete);
	          return runner;
	
	          function onComplete(success) {
	            close(success);
	            runner.complete(success);
	          }
	
	          function endAnimations(cancelled) {
	            if (!animationClosed) {
	              (closeActiveAnimations || noop)(cancelled);
	              onComplete(cancelled);
	            }
	          }
	        }
	      };
	
	      function executeAnimationFn(fn, element, event, options, onDone) {
	        var args;
	        switch (event) {
	          case 'animate':
	            args = [element, options.from, options.to, onDone];
	            break;
	
	          case 'setClass':
	            args = [element, classesToAdd, classesToRemove, onDone];
	            break;
	
	          case 'addClass':
	            args = [element, classesToAdd, onDone];
	            break;
	
	          case 'removeClass':
	            args = [element, classesToRemove, onDone];
	            break;
	
	          default:
	            args = [element, onDone];
	            break;
	        }
	
	        args.push(options);
	
	        var value = fn.apply(fn, args);
	        if (value) {
	          if (isFunction(value.start)) {
	            value = value.start();
	          }
	
	          if (value instanceof $$AnimateRunner) {
	            value.done(onDone);
	          } else if (isFunction(value)) {
	            // optional onEnd / onCancel callback
	            return value;
	          }
	        }
	
	        return noop;
	      }
	
	      function groupEventedAnimations(element, event, options, animations, fnName) {
	        var operations = [];
	        forEach(animations, function(ani) {
	          var animation = ani[fnName];
	          if (!animation) return;
	
	          // note that all of these animations will run in parallel
	          operations.push(function() {
	            var runner;
	            var endProgressCb;
	
	            var resolved = false;
	            var onAnimationComplete = function(rejected) {
	              if (!resolved) {
	                resolved = true;
	                (endProgressCb || noop)(rejected);
	                runner.complete(!rejected);
	              }
	            };
	
	            runner = new $$AnimateRunner({
	              end: function() {
	                onAnimationComplete();
	              },
	              cancel: function() {
	                onAnimationComplete(true);
	              }
	            });
	
	            endProgressCb = executeAnimationFn(animation, element, event, options, function(result) {
	              var cancelled = result === false;
	              onAnimationComplete(cancelled);
	            });
	
	            return runner;
	          });
	        });
	
	        return operations;
	      }
	
	      function packageAnimations(element, event, options, animations, fnName) {
	        var operations = groupEventedAnimations(element, event, options, animations, fnName);
	        if (operations.length === 0) {
	          var a, b;
	          if (fnName === 'beforeSetClass') {
	            a = groupEventedAnimations(element, 'removeClass', options, animations, 'beforeRemoveClass');
	            b = groupEventedAnimations(element, 'addClass', options, animations, 'beforeAddClass');
	          } else if (fnName === 'setClass') {
	            a = groupEventedAnimations(element, 'removeClass', options, animations, 'removeClass');
	            b = groupEventedAnimations(element, 'addClass', options, animations, 'addClass');
	          }
	
	          if (a) {
	            operations = operations.concat(a);
	          }
	          if (b) {
	            operations = operations.concat(b);
	          }
	        }
	
	        if (operations.length === 0) return;
	
	        // TODO(matsko): add documentation
	        return function startAnimation(callback) {
	          var runners = [];
	          if (operations.length) {
	            forEach(operations, function(animateFn) {
	              runners.push(animateFn());
	            });
	          }
	
	          if (runners.length) {
	            $$AnimateRunner.all(runners, callback);
	          }  else {
	            callback();
	          }
	
	          return function endFn(reject) {
	            forEach(runners, function(runner) {
	              if (reject) {
	                runner.cancel();
	              } else {
	                runner.end();
	              }
	            });
	          };
	        };
	      }
	    };
	
	    function lookupAnimations(classes) {
	      classes = isArray(classes) ? classes : classes.split(' ');
	      var matches = [], flagMap = {};
	      for (var i = 0; i < classes.length; i++) {
	        var klass = classes[i],
	            animationFactory = $animateProvider.$$registeredAnimations[klass];
	        if (animationFactory && !flagMap[klass]) {
	          matches.push($injector.get(animationFactory));
	          flagMap[klass] = true;
	        }
	      }
	      return matches;
	    }
	  }];
	}];
	
	var $$AnimateJsDriverProvider = ['$$animationProvider', /** @this */ function($$animationProvider) {
	  $$animationProvider.drivers.push('$$animateJsDriver');
	  this.$get = ['$$animateJs', '$$AnimateRunner', function($$animateJs, $$AnimateRunner) {
	    return function initDriverFn(animationDetails) {
	      if (animationDetails.from && animationDetails.to) {
	        var fromAnimation = prepareAnimation(animationDetails.from);
	        var toAnimation = prepareAnimation(animationDetails.to);
	        if (!fromAnimation && !toAnimation) return;
	
	        return {
	          start: function() {
	            var animationRunners = [];
	
	            if (fromAnimation) {
	              animationRunners.push(fromAnimation.start());
	            }
	
	            if (toAnimation) {
	              animationRunners.push(toAnimation.start());
	            }
	
	            $$AnimateRunner.all(animationRunners, done);
	
	            var runner = new $$AnimateRunner({
	              end: endFnFactory(),
	              cancel: endFnFactory()
	            });
	
	            return runner;
	
	            function endFnFactory() {
	              return function() {
	                forEach(animationRunners, function(runner) {
	                  // at this point we cannot cancel animations for groups just yet. 1.5+
	                  runner.end();
	                });
	              };
	            }
	
	            function done(status) {
	              runner.complete(status);
	            }
	          }
	        };
	      } else {
	        return prepareAnimation(animationDetails);
	      }
	    };
	
	    function prepareAnimation(animationDetails) {
	      // TODO(matsko): make sure to check for grouped animations and delegate down to normal animations
	      var element = animationDetails.element;
	      var event = animationDetails.event;
	      var options = animationDetails.options;
	      var classes = animationDetails.classes;
	      return $$animateJs(element, event, classes, options);
	    }
	  }];
	}];
	
	var NG_ANIMATE_ATTR_NAME = 'data-ng-animate';
	var NG_ANIMATE_PIN_DATA = '$ngAnimatePin';
	var $$AnimateQueueProvider = ['$animateProvider', /** @this */ function($animateProvider) {
	  var PRE_DIGEST_STATE = 1;
	  var RUNNING_STATE = 2;
	  var ONE_SPACE = ' ';
	
	  var rules = this.rules = {
	    skip: [],
	    cancel: [],
	    join: []
	  };
	
	  function makeTruthyCssClassMap(classString) {
	    if (!classString) {
	      return null;
	    }
	
	    var keys = classString.split(ONE_SPACE);
	    var map = Object.create(null);
	
	    forEach(keys, function(key) {
	      map[key] = true;
	    });
	    return map;
	  }
	
	  function hasMatchingClasses(newClassString, currentClassString) {
	    if (newClassString && currentClassString) {
	      var currentClassMap = makeTruthyCssClassMap(currentClassString);
	      return newClassString.split(ONE_SPACE).some(function(className) {
	        return currentClassMap[className];
	      });
	    }
	  }
	
	  function isAllowed(ruleType, currentAnimation, previousAnimation) {
	    return rules[ruleType].some(function(fn) {
	      return fn(currentAnimation, previousAnimation);
	    });
	  }
	
	  function hasAnimationClasses(animation, and) {
	    var a = (animation.addClass || '').length > 0;
	    var b = (animation.removeClass || '').length > 0;
	    return and ? a && b : a || b;
	  }
	
	  rules.join.push(function(newAnimation, currentAnimation) {
	    // if the new animation is class-based then we can just tack that on
	    return !newAnimation.structural && hasAnimationClasses(newAnimation);
	  });
	
	  rules.skip.push(function(newAnimation, currentAnimation) {
	    // there is no need to animate anything if no classes are being added and
	    // there is no structural animation that will be triggered
	    return !newAnimation.structural && !hasAnimationClasses(newAnimation);
	  });
	
	  rules.skip.push(function(newAnimation, currentAnimation) {
	    // why should we trigger a new structural animation if the element will
	    // be removed from the DOM anyway?
	    return currentAnimation.event === 'leave' && newAnimation.structural;
	  });
	
	  rules.skip.push(function(newAnimation, currentAnimation) {
	    // if there is an ongoing current animation then don't even bother running the class-based animation
	    return currentAnimation.structural && currentAnimation.state === RUNNING_STATE && !newAnimation.structural;
	  });
	
	  rules.cancel.push(function(newAnimation, currentAnimation) {
	    // there can never be two structural animations running at the same time
	    return currentAnimation.structural && newAnimation.structural;
	  });
	
	  rules.cancel.push(function(newAnimation, currentAnimation) {
	    // if the previous animation is already running, but the new animation will
	    // be triggered, but the new animation is structural
	    return currentAnimation.state === RUNNING_STATE && newAnimation.structural;
	  });
	
	  rules.cancel.push(function(newAnimation, currentAnimation) {
	    // cancel the animation if classes added / removed in both animation cancel each other out,
	    // but only if the current animation isn't structural
	
	    if (currentAnimation.structural) return false;
	
	    var nA = newAnimation.addClass;
	    var nR = newAnimation.removeClass;
	    var cA = currentAnimation.addClass;
	    var cR = currentAnimation.removeClass;
	
	    // early detection to save the global CPU shortage :)
	    if ((isUndefined(nA) && isUndefined(nR)) || (isUndefined(cA) && isUndefined(cR))) {
	      return false;
	    }
	
	    return hasMatchingClasses(nA, cR) || hasMatchingClasses(nR, cA);
	  });
	
	  this.$get = ['$$rAF', '$rootScope', '$rootElement', '$document', '$$Map',
	               '$$animation', '$$AnimateRunner', '$templateRequest', '$$jqLite', '$$forceReflow',
	               '$$isDocumentHidden',
	       function($$rAF,   $rootScope,   $rootElement,   $document,   $$Map,
	                $$animation,   $$AnimateRunner,   $templateRequest,   $$jqLite,   $$forceReflow,
	                $$isDocumentHidden) {
	
	    var activeAnimationsLookup = new $$Map();
	    var disabledElementsLookup = new $$Map();
	    var animationsEnabled = null;
	
	    function postDigestTaskFactory() {
	      var postDigestCalled = false;
	      return function(fn) {
	        // we only issue a call to postDigest before
	        // it has first passed. This prevents any callbacks
	        // from not firing once the animation has completed
	        // since it will be out of the digest cycle.
	        if (postDigestCalled) {
	          fn();
	        } else {
	          $rootScope.$$postDigest(function() {
	            postDigestCalled = true;
	            fn();
	          });
	        }
	      };
	    }
	
	    // Wait until all directive and route-related templates are downloaded and
	    // compiled. The $templateRequest.totalPendingRequests variable keeps track of
	    // all of the remote templates being currently downloaded. If there are no
	    // templates currently downloading then the watcher will still fire anyway.
	    var deregisterWatch = $rootScope.$watch(
	      function() { return $templateRequest.totalPendingRequests === 0; },
	      function(isEmpty) {
	        if (!isEmpty) return;
	        deregisterWatch();
	
	        // Now that all templates have been downloaded, $animate will wait until
	        // the post digest queue is empty before enabling animations. By having two
	        // calls to $postDigest calls we can ensure that the flag is enabled at the
	        // very end of the post digest queue. Since all of the animations in $animate
	        // use $postDigest, it's important that the code below executes at the end.
	        // This basically means that the page is fully downloaded and compiled before
	        // any animations are triggered.
	        $rootScope.$$postDigest(function() {
	          $rootScope.$$postDigest(function() {
	            // we check for null directly in the event that the application already called
	            // .enabled() with whatever arguments that it provided it with
	            if (animationsEnabled === null) {
	              animationsEnabled = true;
	            }
	          });
	        });
	      }
	    );
	
	    var callbackRegistry = Object.create(null);
	
	    // remember that the classNameFilter is set during the provider/config
	    // stage therefore we can optimize here and setup a helper function
	    var classNameFilter = $animateProvider.classNameFilter();
	    var isAnimatableClassName = !classNameFilter
	              ? function() { return true; }
	              : function(className) {
	                return classNameFilter.test(className);
	              };
	
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	
	    function normalizeAnimationDetails(element, animation) {
	      return mergeAnimationDetails(element, animation, {});
	    }
	
	    // IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
	    var contains = window.Node.prototype.contains || /** @this */ function(arg) {
	      // eslint-disable-next-line no-bitwise
	      return this === arg || !!(this.compareDocumentPosition(arg) & 16);
	    };
	
	    function findCallbacks(targetParentNode, targetNode, event) {
	      var matches = [];
	      var entries = callbackRegistry[event];
	      if (entries) {
	        forEach(entries, function(entry) {
	          if (contains.call(entry.node, targetNode)) {
	            matches.push(entry.callback);
	          } else if (event === 'leave' && contains.call(entry.node, targetParentNode)) {
	            matches.push(entry.callback);
	          }
	        });
	      }
	
	      return matches;
	    }
	
	    function filterFromRegistry(list, matchContainer, matchCallback) {
	      var containerNode = extractElementNode(matchContainer);
	      return list.filter(function(entry) {
	        var isMatch = entry.node === containerNode &&
	                        (!matchCallback || entry.callback === matchCallback);
	        return !isMatch;
	      });
	    }
	
	    function cleanupEventListeners(phase, node) {
	      if (phase === 'close' && !node.parentNode) {
	        // If the element is not attached to a parentNode, it has been removed by
	        // the domOperation, and we can safely remove the event callbacks
	        $animate.off(node);
	      }
	    }
	
	    var $animate = {
	      on: function(event, container, callback) {
	        var node = extractElementNode(container);
	        callbackRegistry[event] = callbackRegistry[event] || [];
	        callbackRegistry[event].push({
	          node: node,
	          callback: callback
	        });
	
	        // Remove the callback when the element is removed from the DOM
	        jqLite(container).on('$destroy', function() {
	          var animationDetails = activeAnimationsLookup.get(node);
	
	          if (!animationDetails) {
	            // If there's an animation ongoing, the callback calling code will remove
	            // the event listeners. If we'd remove here, the callbacks would be removed
	            // before the animation ends
	            $animate.off(event, container, callback);
	          }
	        });
	      },
	
	      off: function(event, container, callback) {
	        if (arguments.length === 1 && !isString(arguments[0])) {
	          container = arguments[0];
	          for (var eventType in callbackRegistry) {
	            callbackRegistry[eventType] = filterFromRegistry(callbackRegistry[eventType], container);
	          }
	
	          return;
	        }
	
	        var entries = callbackRegistry[event];
	        if (!entries) return;
	
	        callbackRegistry[event] = arguments.length === 1
	            ? null
	            : filterFromRegistry(entries, container, callback);
	      },
	
	      pin: function(element, parentElement) {
	        assertArg(isElement(element), 'element', 'not an element');
	        assertArg(isElement(parentElement), 'parentElement', 'not an element');
	        element.data(NG_ANIMATE_PIN_DATA, parentElement);
	      },
	
	      push: function(element, event, options, domOperation) {
	        options = options || {};
	        options.domOperation = domOperation;
	        return queueAnimation(element, event, options);
	      },
	
	      // this method has four signatures:
	      //  () - global getter
	      //  (bool) - global setter
	      //  (element) - element getter
	      //  (element, bool) - element setter<F37>
	      enabled: function(element, bool) {
	        var argCount = arguments.length;
	
	        if (argCount === 0) {
	          // () - Global getter
	          bool = !!animationsEnabled;
	        } else {
	          var hasElement = isElement(element);
	
	          if (!hasElement) {
	            // (bool) - Global setter
	            bool = animationsEnabled = !!element;
	          } else {
	            var node = getDomNode(element);
	
	            if (argCount === 1) {
	              // (element) - Element getter
	              bool = !disabledElementsLookup.get(node);
	            } else {
	              // (element, bool) - Element setter
	              disabledElementsLookup.set(node, !bool);
	            }
	          }
	        }
	
	        return bool;
	      }
	    };
	
	    return $animate;
	
	    function queueAnimation(originalElement, event, initialOptions) {
	      // we always make a copy of the options since
	      // there should never be any side effects on
	      // the input data when running `$animateCss`.
	      var options = copy(initialOptions);
	
	      var element = stripCommentsFromElement(originalElement);
	      var node = getDomNode(element);
	      var parentNode = node && node.parentNode;
	
	      options = prepareAnimationOptions(options);
	
	      // we create a fake runner with a working promise.
	      // These methods will become available after the digest has passed
	      var runner = new $$AnimateRunner();
	
	      // this is used to trigger callbacks in postDigest mode
	      var runInNextPostDigestOrNow = postDigestTaskFactory();
	
	      if (isArray(options.addClass)) {
	        options.addClass = options.addClass.join(' ');
	      }
	
	      if (options.addClass && !isString(options.addClass)) {
	        options.addClass = null;
	      }
	
	      if (isArray(options.removeClass)) {
	        options.removeClass = options.removeClass.join(' ');
	      }
	
	      if (options.removeClass && !isString(options.removeClass)) {
	        options.removeClass = null;
	      }
	
	      if (options.from && !isObject(options.from)) {
	        options.from = null;
	      }
	
	      if (options.to && !isObject(options.to)) {
	        options.to = null;
	      }
	
	      // there are situations where a directive issues an animation for
	      // a jqLite wrapper that contains only comment nodes... If this
	      // happens then there is no way we can perform an animation
	      if (!node) {
	        close();
	        return runner;
	      }
	
	      var className = [node.getAttribute('class'), options.addClass, options.removeClass].join(' ');
	      if (!isAnimatableClassName(className)) {
	        close();
	        return runner;
	      }
	
	      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;
	
	      var documentHidden = $$isDocumentHidden();
	
	      // this is a hard disable of all animations for the application or on
	      // the element itself, therefore  there is no need to continue further
	      // past this point if not enabled
	      // Animations are also disabled if the document is currently hidden (page is not visible
	      // to the user), because browsers slow down or do not flush calls to requestAnimationFrame
	      var skipAnimations = !animationsEnabled || documentHidden || disabledElementsLookup.get(node);
	      var existingAnimation = (!skipAnimations && activeAnimationsLookup.get(node)) || {};
	      var hasExistingAnimation = !!existingAnimation.state;
	
	      // there is no point in traversing the same collection of parent ancestors if a followup
	      // animation will be run on the same element that already did all that checking work
	      if (!skipAnimations && (!hasExistingAnimation || existingAnimation.state !== PRE_DIGEST_STATE)) {
	        skipAnimations = !areAnimationsAllowed(node, parentNode, event);
	      }
	
	      if (skipAnimations) {
	        // Callbacks should fire even if the document is hidden (regression fix for issue #14120)
	        if (documentHidden) notifyProgress(runner, event, 'start');
	        close();
	        if (documentHidden) notifyProgress(runner, event, 'close');
	        return runner;
	      }
	
	      if (isStructural) {
	        closeChildAnimations(node);
	      }
	
	      var newAnimation = {
	        structural: isStructural,
	        element: element,
	        event: event,
	        addClass: options.addClass,
	        removeClass: options.removeClass,
	        close: close,
	        options: options,
	        runner: runner
	      };
	
	      if (hasExistingAnimation) {
	        var skipAnimationFlag = isAllowed('skip', newAnimation, existingAnimation);
	        if (skipAnimationFlag) {
	          if (existingAnimation.state === RUNNING_STATE) {
	            close();
	            return runner;
	          } else {
	            mergeAnimationDetails(element, existingAnimation, newAnimation);
	            return existingAnimation.runner;
	          }
	        }
	        var cancelAnimationFlag = isAllowed('cancel', newAnimation, existingAnimation);
	        if (cancelAnimationFlag) {
	          if (existingAnimation.state === RUNNING_STATE) {
	            // this will end the animation right away and it is safe
	            // to do so since the animation is already running and the
	            // runner callback code will run in async
	            existingAnimation.runner.end();
	          } else if (existingAnimation.structural) {
	            // this means that the animation is queued into a digest, but
	            // hasn't started yet. Therefore it is safe to run the close
	            // method which will call the runner methods in async.
	            existingAnimation.close();
	          } else {
	            // this will merge the new animation options into existing animation options
	            mergeAnimationDetails(element, existingAnimation, newAnimation);
	
	            return existingAnimation.runner;
	          }
	        } else {
	          // a joined animation means that this animation will take over the existing one
	          // so an example would involve a leave animation taking over an enter. Then when
	          // the postDigest kicks in the enter will be ignored.
	          var joinAnimationFlag = isAllowed('join', newAnimation, existingAnimation);
	          if (joinAnimationFlag) {
	            if (existingAnimation.state === RUNNING_STATE) {
	              normalizeAnimationDetails(element, newAnimation);
	            } else {
	              applyGeneratedPreparationClasses(element, isStructural ? event : null, options);
	
	              event = newAnimation.event = existingAnimation.event;
	              options = mergeAnimationDetails(element, existingAnimation, newAnimation);
	
	              //we return the same runner since only the option values of this animation will
	              //be fed into the `existingAnimation`.
	              return existingAnimation.runner;
	            }
	          }
	        }
	      } else {
	        // normalization in this case means that it removes redundant CSS classes that
	        // already exist (addClass) or do not exist (removeClass) on the element
	        normalizeAnimationDetails(element, newAnimation);
	      }
	
	      // when the options are merged and cleaned up we may end up not having to do
	      // an animation at all, therefore we should check this before issuing a post
	      // digest callback. Structural animations will always run no matter what.
	      var isValidAnimation = newAnimation.structural;
	      if (!isValidAnimation) {
	        // animate (from/to) can be quickly checked first, otherwise we check if any classes are present
	        isValidAnimation = (newAnimation.event === 'animate' && Object.keys(newAnimation.options.to || {}).length > 0)
	                            || hasAnimationClasses(newAnimation);
	      }
	
	      if (!isValidAnimation) {
	        close();
	        clearElementAnimationState(node);
	        return runner;
	      }
	
	      // the counter keeps track of cancelled animations
	      var counter = (existingAnimation.counter || 0) + 1;
	      newAnimation.counter = counter;
	
	      markElementAnimationState(node, PRE_DIGEST_STATE, newAnimation);
	
	      $rootScope.$$postDigest(function() {
	        // It is possible that the DOM nodes inside `originalElement` have been replaced. This can
	        // happen if the animated element is a transcluded clone and also has a `templateUrl`
	        // directive on it. Therefore, we must recreate `element` in order to interact with the
	        // actual DOM nodes.
	        // Note: We still need to use the old `node` for certain things, such as looking up in
	        //       HashMaps where it was used as the key.
	
	        element = stripCommentsFromElement(originalElement);
	
	        var animationDetails = activeAnimationsLookup.get(node);
	        var animationCancelled = !animationDetails;
	        animationDetails = animationDetails || {};
	
	        // if addClass/removeClass is called before something like enter then the
	        // registered parent element may not be present. The code below will ensure
	        // that a final value for parent element is obtained
	        var parentElement = element.parent() || [];
	
	        // animate/structural/class-based animations all have requirements. Otherwise there
	        // is no point in performing an animation. The parent node must also be set.
	        var isValidAnimation = parentElement.length > 0
	                                && (animationDetails.event === 'animate'
	                                    || animationDetails.structural
	                                    || hasAnimationClasses(animationDetails));
	
	        // this means that the previous animation was cancelled
	        // even if the follow-up animation is the same event
	        if (animationCancelled || animationDetails.counter !== counter || !isValidAnimation) {
	          // if another animation did not take over then we need
	          // to make sure that the domOperation and options are
	          // handled accordingly
	          if (animationCancelled) {
	            applyAnimationClasses(element, options);
	            applyAnimationStyles(element, options);
	          }
	
	          // if the event changed from something like enter to leave then we do
	          // it, otherwise if it's the same then the end result will be the same too
	          if (animationCancelled || (isStructural && animationDetails.event !== event)) {
	            options.domOperation();
	            runner.end();
	          }
	
	          // in the event that the element animation was not cancelled or a follow-up animation
	          // isn't allowed to animate from here then we need to clear the state of the element
	          // so that any future animations won't read the expired animation data.
	          if (!isValidAnimation) {
	            clearElementAnimationState(node);
	          }
	
	          return;
	        }
	
	        // this combined multiple class to addClass / removeClass into a setClass event
	        // so long as a structural event did not take over the animation
	        event = !animationDetails.structural && hasAnimationClasses(animationDetails, true)
	            ? 'setClass'
	            : animationDetails.event;
	
	        markElementAnimationState(node, RUNNING_STATE);
	        var realRunner = $$animation(element, event, animationDetails.options);
	
	        // this will update the runner's flow-control events based on
	        // the `realRunner` object.
	        runner.setHost(realRunner);
	        notifyProgress(runner, event, 'start', {});
	
	        realRunner.done(function(status) {
	          close(!status);
	          var animationDetails = activeAnimationsLookup.get(node);
	          if (animationDetails && animationDetails.counter === counter) {
	            clearElementAnimationState(node);
	          }
	          notifyProgress(runner, event, 'close', {});
	        });
	      });
	
	      return runner;
	
	      function notifyProgress(runner, event, phase, data) {
	        runInNextPostDigestOrNow(function() {
	          var callbacks = findCallbacks(parentNode, node, event);
	          if (callbacks.length) {
	            // do not optimize this call here to RAF because
	            // we don't know how heavy the callback code here will
	            // be and if this code is buffered then this can
	            // lead to a performance regression.
	            $$rAF(function() {
	              forEach(callbacks, function(callback) {
	                callback(element, phase, data);
	              });
	              cleanupEventListeners(phase, node);
	            });
	          } else {
	            cleanupEventListeners(phase, node);
	          }
	        });
	        runner.progress(event, phase, data);
	      }
	
	      function close(reject) {
	        clearGeneratedClasses(element, options);
	        applyAnimationClasses(element, options);
	        applyAnimationStyles(element, options);
	        options.domOperation();
	        runner.complete(!reject);
	      }
	    }
	
	    function closeChildAnimations(node) {
	      var children = node.querySelectorAll('[' + NG_ANIMATE_ATTR_NAME + ']');
	      forEach(children, function(child) {
	        var state = parseInt(child.getAttribute(NG_ANIMATE_ATTR_NAME), 10);
	        var animationDetails = activeAnimationsLookup.get(child);
	        if (animationDetails) {
	          switch (state) {
	            case RUNNING_STATE:
	              animationDetails.runner.end();
	              /* falls through */
	            case PRE_DIGEST_STATE:
	              activeAnimationsLookup.delete(child);
	              break;
	          }
	        }
	      });
	    }
	
	    function clearElementAnimationState(node) {
	      node.removeAttribute(NG_ANIMATE_ATTR_NAME);
	      activeAnimationsLookup.delete(node);
	    }
	
	    /**
	     * This fn returns false if any of the following is true:
	     * a) animations on any parent element are disabled, and animations on the element aren't explicitly allowed
	     * b) a parent element has an ongoing structural animation, and animateChildren is false
	     * c) the element is not a child of the body
	     * d) the element is not a child of the $rootElement
	     */
	    function areAnimationsAllowed(node, parentNode, event) {
	      var bodyNode = $document[0].body;
	      var rootNode = getDomNode($rootElement);
	
	      var bodyNodeDetected = (node === bodyNode) || node.nodeName === 'HTML';
	      var rootNodeDetected = (node === rootNode);
	      var parentAnimationDetected = false;
	      var elementDisabled = disabledElementsLookup.get(node);
	      var animateChildren;
	
	      var parentHost = jqLite.data(node, NG_ANIMATE_PIN_DATA);
	      if (parentHost) {
	        parentNode = getDomNode(parentHost);
	      }
	
	      while (parentNode) {
	        if (!rootNodeDetected) {
	          // angular doesn't want to attempt to animate elements outside of the application
	          // therefore we need to ensure that the rootElement is an ancestor of the current element
	          rootNodeDetected = (parentNode === rootNode);
	        }
	
	        if (parentNode.nodeType !== ELEMENT_NODE) {
	          // no point in inspecting the #document element
	          break;
	        }
	
	        var details = activeAnimationsLookup.get(parentNode) || {};
	        // either an enter, leave or move animation will commence
	        // therefore we can't allow any animations to take place
	        // but if a parent animation is class-based then that's ok
	        if (!parentAnimationDetected) {
	          var parentNodeDisabled = disabledElementsLookup.get(parentNode);
	
	          if (parentNodeDisabled === true && elementDisabled !== false) {
	            // disable animations if the user hasn't explicitly enabled animations on the
	            // current element
	            elementDisabled = true;
	            // element is disabled via parent element, no need to check anything else
	            break;
	          } else if (parentNodeDisabled === false) {
	            elementDisabled = false;
	          }
	          parentAnimationDetected = details.structural;
	        }
	
	        if (isUndefined(animateChildren) || animateChildren === true) {
	          var value = jqLite.data(parentNode, NG_ANIMATE_CHILDREN_DATA);
	          if (isDefined(value)) {
	            animateChildren = value;
	          }
	        }
	
	        // there is no need to continue traversing at this point
	        if (parentAnimationDetected && animateChildren === false) break;
	
	        if (!bodyNodeDetected) {
	          // we also need to ensure that the element is or will be a part of the body element
	          // otherwise it is pointless to even issue an animation to be rendered
	          bodyNodeDetected = (parentNode === bodyNode);
	        }
	
	        if (bodyNodeDetected && rootNodeDetected) {
	          // If both body and root have been found, any other checks are pointless,
	          // as no animation data should live outside the application
	          break;
	        }
	
	        if (!rootNodeDetected) {
	          // If `rootNode` is not detected, check if `parentNode` is pinned to another element
	          parentHost = jqLite.data(parentNode, NG_ANIMATE_PIN_DATA);
	          if (parentHost) {
	            // The pin target element becomes the next parent element
	            parentNode = getDomNode(parentHost);
	            continue;
	          }
	        }
	
	        parentNode = parentNode.parentNode;
	      }
	
	      var allowAnimation = (!parentAnimationDetected || animateChildren) && elementDisabled !== true;
	      return allowAnimation && rootNodeDetected && bodyNodeDetected;
	    }
	
	    function markElementAnimationState(node, state, details) {
	      details = details || {};
	      details.state = state;
	
	      node.setAttribute(NG_ANIMATE_ATTR_NAME, state);
	
	      var oldValue = activeAnimationsLookup.get(node);
	      var newValue = oldValue
	          ? extend(oldValue, details)
	          : details;
	      activeAnimationsLookup.set(node, newValue);
	    }
	  }];
	}];
	
	/* exported $$AnimationProvider */
	
	var $$AnimationProvider = ['$animateProvider', /** @this */ function($animateProvider) {
	  var NG_ANIMATE_REF_ATTR = 'ng-animate-ref';
	
	  var drivers = this.drivers = [];
	
	  var RUNNER_STORAGE_KEY = '$$animationRunner';
	
	  function setRunner(element, runner) {
	    element.data(RUNNER_STORAGE_KEY, runner);
	  }
	
	  function removeRunner(element) {
	    element.removeData(RUNNER_STORAGE_KEY);
	  }
	
	  function getRunner(element) {
	    return element.data(RUNNER_STORAGE_KEY);
	  }
	
	  this.$get = ['$$jqLite', '$rootScope', '$injector', '$$AnimateRunner', '$$Map', '$$rAFScheduler',
	       function($$jqLite,   $rootScope,   $injector,   $$AnimateRunner,   $$Map,   $$rAFScheduler) {
	
	    var animationQueue = [];
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	
	    function sortAnimations(animations) {
	      var tree = { children: [] };
	      var i, lookup = new $$Map();
	
	      // this is done first beforehand so that the map
	      // is filled with a list of the elements that will be animated
	      for (i = 0; i < animations.length; i++) {
	        var animation = animations[i];
	        lookup.set(animation.domNode, animations[i] = {
	          domNode: animation.domNode,
	          fn: animation.fn,
	          children: []
	        });
	      }
	
	      for (i = 0; i < animations.length; i++) {
	        processNode(animations[i]);
	      }
	
	      return flatten(tree);
	
	      function processNode(entry) {
	        if (entry.processed) return entry;
	        entry.processed = true;
	
	        var elementNode = entry.domNode;
	        var parentNode = elementNode.parentNode;
	        lookup.set(elementNode, entry);
	
	        var parentEntry;
	        while (parentNode) {
	          parentEntry = lookup.get(parentNode);
	          if (parentEntry) {
	            if (!parentEntry.processed) {
	              parentEntry = processNode(parentEntry);
	            }
	            break;
	          }
	          parentNode = parentNode.parentNode;
	        }
	
	        (parentEntry || tree).children.push(entry);
	        return entry;
	      }
	
	      function flatten(tree) {
	        var result = [];
	        var queue = [];
	        var i;
	
	        for (i = 0; i < tree.children.length; i++) {
	          queue.push(tree.children[i]);
	        }
	
	        var remainingLevelEntries = queue.length;
	        var nextLevelEntries = 0;
	        var row = [];
	
	        for (i = 0; i < queue.length; i++) {
	          var entry = queue[i];
	          if (remainingLevelEntries <= 0) {
	            remainingLevelEntries = nextLevelEntries;
	            nextLevelEntries = 0;
	            result.push(row);
	            row = [];
	          }
	          row.push(entry.fn);
	          entry.children.forEach(function(childEntry) {
	            nextLevelEntries++;
	            queue.push(childEntry);
	          });
	          remainingLevelEntries--;
	        }
	
	        if (row.length) {
	          result.push(row);
	        }
	
	        return result;
	      }
	    }
	
	    // TODO(matsko): document the signature in a better way
	    return function(element, event, options) {
	      options = prepareAnimationOptions(options);
	      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;
	
	      // there is no animation at the current moment, however
	      // these runner methods will get later updated with the
	      // methods leading into the driver's end/cancel methods
	      // for now they just stop the animation from starting
	      var runner = new $$AnimateRunner({
	        end: function() { close(); },
	        cancel: function() { close(true); }
	      });
	
	      if (!drivers.length) {
	        close();
	        return runner;
	      }
	
	      setRunner(element, runner);
	
	      var classes = mergeClasses(element.attr('class'), mergeClasses(options.addClass, options.removeClass));
	      var tempClasses = options.tempClasses;
	      if (tempClasses) {
	        classes += ' ' + tempClasses;
	        options.tempClasses = null;
	      }
	
	      var prepareClassName;
	      if (isStructural) {
	        prepareClassName = 'ng-' + event + PREPARE_CLASS_SUFFIX;
	        $$jqLite.addClass(element, prepareClassName);
	      }
	
	      animationQueue.push({
	        // this data is used by the postDigest code and passed into
	        // the driver step function
	        element: element,
	        classes: classes,
	        event: event,
	        structural: isStructural,
	        options: options,
	        beforeStart: beforeStart,
	        close: close
	      });
	
	      element.on('$destroy', handleDestroyedElement);
	
	      // we only want there to be one function called within the post digest
	      // block. This way we can group animations for all the animations that
	      // were apart of the same postDigest flush call.
	      if (animationQueue.length > 1) return runner;
	
	      $rootScope.$$postDigest(function() {
	        var animations = [];
	        forEach(animationQueue, function(entry) {
	          // the element was destroyed early on which removed the runner
	          // form its storage. This means we can't animate this element
	          // at all and it already has been closed due to destruction.
	          if (getRunner(entry.element)) {
	            animations.push(entry);
	          } else {
	            entry.close();
	          }
	        });
	
	        // now any future animations will be in another postDigest
	        animationQueue.length = 0;
	
	        var groupedAnimations = groupAnimations(animations);
	        var toBeSortedAnimations = [];
	
	        forEach(groupedAnimations, function(animationEntry) {
	          toBeSortedAnimations.push({
	            domNode: getDomNode(animationEntry.from ? animationEntry.from.element : animationEntry.element),
	            fn: function triggerAnimationStart() {
	              // it's important that we apply the `ng-animate` CSS class and the
	              // temporary classes before we do any driver invoking since these
	              // CSS classes may be required for proper CSS detection.
	              animationEntry.beforeStart();
	
	              var startAnimationFn, closeFn = animationEntry.close;
	
	              // in the event that the element was removed before the digest runs or
	              // during the RAF sequencing then we should not trigger the animation.
	              var targetElement = animationEntry.anchors
	                  ? (animationEntry.from.element || animationEntry.to.element)
	                  : animationEntry.element;
	
	              if (getRunner(targetElement)) {
	                var operation = invokeFirstDriver(animationEntry);
	                if (operation) {
	                  startAnimationFn = operation.start;
	                }
	              }
	
	              if (!startAnimationFn) {
	                closeFn();
	              } else {
	                var animationRunner = startAnimationFn();
	                animationRunner.done(function(status) {
	                  closeFn(!status);
	                });
	                updateAnimationRunners(animationEntry, animationRunner);
	              }
	            }
	          });
	        });
	
	        // we need to sort each of the animations in order of parent to child
	        // relationships. This ensures that the child classes are applied at the
	        // right time.
	        $$rAFScheduler(sortAnimations(toBeSortedAnimations));
	      });
	
	      return runner;
	
	      // TODO(matsko): change to reference nodes
	      function getAnchorNodes(node) {
	        var SELECTOR = '[' + NG_ANIMATE_REF_ATTR + ']';
	        var items = node.hasAttribute(NG_ANIMATE_REF_ATTR)
	              ? [node]
	              : node.querySelectorAll(SELECTOR);
	        var anchors = [];
	        forEach(items, function(node) {
	          var attr = node.getAttribute(NG_ANIMATE_REF_ATTR);
	          if (attr && attr.length) {
	            anchors.push(node);
	          }
	        });
	        return anchors;
	      }
	
	      function groupAnimations(animations) {
	        var preparedAnimations = [];
	        var refLookup = {};
	        forEach(animations, function(animation, index) {
	          var element = animation.element;
	          var node = getDomNode(element);
	          var event = animation.event;
	          var enterOrMove = ['enter', 'move'].indexOf(event) >= 0;
	          var anchorNodes = animation.structural ? getAnchorNodes(node) : [];
	
	          if (anchorNodes.length) {
	            var direction = enterOrMove ? 'to' : 'from';
	
	            forEach(anchorNodes, function(anchor) {
	              var key = anchor.getAttribute(NG_ANIMATE_REF_ATTR);
	              refLookup[key] = refLookup[key] || {};
	              refLookup[key][direction] = {
	                animationID: index,
	                element: jqLite(anchor)
	              };
	            });
	          } else {
	            preparedAnimations.push(animation);
	          }
	        });
	
	        var usedIndicesLookup = {};
	        var anchorGroups = {};
	        forEach(refLookup, function(operations, key) {
	          var from = operations.from;
	          var to = operations.to;
	
	          if (!from || !to) {
	            // only one of these is set therefore we can't have an
	            // anchor animation since all three pieces are required
	            var index = from ? from.animationID : to.animationID;
	            var indexKey = index.toString();
	            if (!usedIndicesLookup[indexKey]) {
	              usedIndicesLookup[indexKey] = true;
	              preparedAnimations.push(animations[index]);
	            }
	            return;
	          }
	
	          var fromAnimation = animations[from.animationID];
	          var toAnimation = animations[to.animationID];
	          var lookupKey = from.animationID.toString();
	          if (!anchorGroups[lookupKey]) {
	            var group = anchorGroups[lookupKey] = {
	              structural: true,
	              beforeStart: function() {
	                fromAnimation.beforeStart();
	                toAnimation.beforeStart();
	              },
	              close: function() {
	                fromAnimation.close();
	                toAnimation.close();
	              },
	              classes: cssClassesIntersection(fromAnimation.classes, toAnimation.classes),
	              from: fromAnimation,
	              to: toAnimation,
	              anchors: [] // TODO(matsko): change to reference nodes
	            };
	
	            // the anchor animations require that the from and to elements both have at least
	            // one shared CSS class which effectively marries the two elements together to use
	            // the same animation driver and to properly sequence the anchor animation.
	            if (group.classes.length) {
	              preparedAnimations.push(group);
	            } else {
	              preparedAnimations.push(fromAnimation);
	              preparedAnimations.push(toAnimation);
	            }
	          }
	
	          anchorGroups[lookupKey].anchors.push({
	            'out': from.element, 'in': to.element
	          });
	        });
	
	        return preparedAnimations;
	      }
	
	      function cssClassesIntersection(a,b) {
	        a = a.split(' ');
	        b = b.split(' ');
	        var matches = [];
	
	        for (var i = 0; i < a.length; i++) {
	          var aa = a[i];
	          if (aa.substring(0,3) === 'ng-') continue;
	
	          for (var j = 0; j < b.length; j++) {
	            if (aa === b[j]) {
	              matches.push(aa);
	              break;
	            }
	          }
	        }
	
	        return matches.join(' ');
	      }
	
	      function invokeFirstDriver(animationDetails) {
	        // we loop in reverse order since the more general drivers (like CSS and JS)
	        // may attempt more elements, but custom drivers are more particular
	        for (var i = drivers.length - 1; i >= 0; i--) {
	          var driverName = drivers[i];
	          var factory = $injector.get(driverName);
	          var driver = factory(animationDetails);
	          if (driver) {
	            return driver;
	          }
	        }
	      }
	
	      function beforeStart() {
	        element.addClass(NG_ANIMATE_CLASSNAME);
	        if (tempClasses) {
	          $$jqLite.addClass(element, tempClasses);
	        }
	        if (prepareClassName) {
	          $$jqLite.removeClass(element, prepareClassName);
	          prepareClassName = null;
	        }
	      }
	
	      function updateAnimationRunners(animation, newRunner) {
	        if (animation.from && animation.to) {
	          update(animation.from.element);
	          update(animation.to.element);
	        } else {
	          update(animation.element);
	        }
	
	        function update(element) {
	          var runner = getRunner(element);
	          if (runner) runner.setHost(newRunner);
	        }
	      }
	
	      function handleDestroyedElement() {
	        var runner = getRunner(element);
	        if (runner && (event !== 'leave' || !options.$$domOperationFired)) {
	          runner.end();
	        }
	      }
	
	      function close(rejected) {
	        element.off('$destroy', handleDestroyedElement);
	        removeRunner(element);
	
	        applyAnimationClasses(element, options);
	        applyAnimationStyles(element, options);
	        options.domOperation();
	
	        if (tempClasses) {
	          $$jqLite.removeClass(element, tempClasses);
	        }
	
	        element.removeClass(NG_ANIMATE_CLASSNAME);
	        runner.complete(!rejected);
	      }
	    };
	  }];
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngAnimateSwap
	 * @restrict A
	 * @scope
	 *
	 * @description
	 *
	 * ngAnimateSwap is a animation-oriented directive that allows for the container to
	 * be removed and entered in whenever the associated expression changes. A
	 * common usecase for this directive is a rotating banner or slider component which
	 * contains one image being present at a time. When the active image changes
	 * then the old image will perform a `leave` animation and the new element
	 * will be inserted via an `enter` animation.
	 *
	 * @animations
	 * | Animation                        | Occurs                               |
	 * |----------------------------------|--------------------------------------|
	 * | {@link ng.$animate#enter enter}  | when the new element is inserted to the DOM  |
	 * | {@link ng.$animate#leave leave}  | when the old element is removed from the DOM |
	 *
	 * @example
	 * <example name="ngAnimateSwap-directive" module="ngAnimateSwapExample"
	 *          deps="angular-animate.js"
	 *          animations="true" fixBase="true">
	 *   <file name="index.html">
	 *     <div class="container" ng-controller="AppCtrl">
	 *       <div ng-animate-swap="number" class="cell swap-animation" ng-class="colorClass(number)">
	 *         {{ number }}
	 *       </div>
	 *     </div>
	 *   </file>
	 *   <file name="script.js">
	 *     angular.module('ngAnimateSwapExample', ['ngAnimate'])
	 *       .controller('AppCtrl', ['$scope', '$interval', function($scope, $interval) {
	 *         $scope.number = 0;
	 *         $interval(function() {
	 *           $scope.number++;
	 *         }, 1000);
	 *
	 *         var colors = ['red','blue','green','yellow','orange'];
	 *         $scope.colorClass = function(number) {
	 *           return colors[number % colors.length];
	 *         };
	 *       }]);
	 *   </file>
	 *  <file name="animations.css">
	 *  .container {
	 *    height:250px;
	 *    width:250px;
	 *    position:relative;
	 *    overflow:hidden;
	 *    border:2px solid black;
	 *  }
	 *  .container .cell {
	 *    font-size:150px;
	 *    text-align:center;
	 *    line-height:250px;
	 *    position:absolute;
	 *    top:0;
	 *    left:0;
	 *    right:0;
	 *    border-bottom:2px solid black;
	 *  }
	 *  .swap-animation.ng-enter, .swap-animation.ng-leave {
	 *    transition:0.5s linear all;
	 *  }
	 *  .swap-animation.ng-enter {
	 *    top:-250px;
	 *  }
	 *  .swap-animation.ng-enter-active {
	 *    top:0px;
	 *  }
	 *  .swap-animation.ng-leave {
	 *    top:0px;
	 *  }
	 *  .swap-animation.ng-leave-active {
	 *    top:250px;
	 *  }
	 *  .red { background:red; }
	 *  .green { background:green; }
	 *  .blue { background:blue; }
	 *  .yellow { background:yellow; }
	 *  .orange { background:orange; }
	 *  </file>
	 * </example>
	 */
	var ngAnimateSwapDirective = ['$animate', '$rootScope', function($animate, $rootScope) {
	  return {
	    restrict: 'A',
	    transclude: 'element',
	    terminal: true,
	    priority: 600, // we use 600 here to ensure that the directive is caught before others
	    link: function(scope, $element, attrs, ctrl, $transclude) {
	      var previousElement, previousScope;
	      scope.$watchCollection(attrs.ngAnimateSwap || attrs['for'], function(value) {
	        if (previousElement) {
	          $animate.leave(previousElement);
	        }
	        if (previousScope) {
	          previousScope.$destroy();
	          previousScope = null;
	        }
	        if (value || value === 0) {
	          previousScope = scope.$new();
	          $transclude(previousScope, function(element) {
	            previousElement = element;
	            $animate.enter(element, null, $element);
	          });
	        }
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc module
	 * @name ngAnimate
	 * @description
	 *
	 * The `ngAnimate` module provides support for CSS-based animations (keyframes and transitions) as well as JavaScript-based animations via
	 * callback hooks. Animations are not enabled by default, however, by including `ngAnimate` the animation hooks are enabled for an Angular app.
	 *
	 * <div doc-module-components="ngAnimate"></div>
	 *
	 * # Usage
	 * Simply put, there are two ways to make use of animations when ngAnimate is used: by using **CSS** and **JavaScript**. The former works purely based
	 * using CSS (by using matching CSS selectors/styles) and the latter triggers animations that are registered via `module.animation()`. For
	 * both CSS and JS animations the sole requirement is to have a matching `CSS class` that exists both in the registered animation and within
	 * the HTML element that the animation will be triggered on.
	 *
	 * ## Directive Support
	 * The following directives are "animation aware":
	 *
	 * | Directive                                                                                                | Supported Animations                                                     |
	 * |----------------------------------------------------------------------------------------------------------|--------------------------------------------------------------------------|
	 * | {@link ng.directive:ngRepeat#animations ngRepeat}                                                        | enter, leave and move                                                    |
	 * | {@link ngRoute.directive:ngView#animations ngView}                                                       | enter and leave                                                          |
	 * | {@link ng.directive:ngInclude#animations ngInclude}                                                      | enter and leave                                                          |
	 * | {@link ng.directive:ngSwitch#animations ngSwitch}                                                        | enter and leave                                                          |
	 * | {@link ng.directive:ngIf#animations ngIf}                                                                | enter and leave                                                          |
	 * | {@link ng.directive:ngClass#animations ngClass}                                                          | add and remove (the CSS class(es) present)                               |
	 * | {@link ng.directive:ngShow#animations ngShow} & {@link ng.directive:ngHide#animations ngHide}            | add and remove (the ng-hide class value)                                 |
	 * | {@link ng.directive:form#animation-hooks form} & {@link ng.directive:ngModel#animation-hooks ngModel}    | add and remove (dirty, pristine, valid, invalid & all other validations) |
	 * | {@link module:ngMessages#animations ngMessages}                                                          | add and remove (ng-active & ng-inactive)                                 |
	 * | {@link module:ngMessages#animations ngMessage}                                                           | enter and leave                                                          |
	 *
	 * (More information can be found by visiting each the documentation associated with each directive.)
	 *
	 * ## CSS-based Animations
	 *
	 * CSS-based animations with ngAnimate are unique since they require no JavaScript code at all. By using a CSS class that we reference between our HTML
	 * and CSS code we can create an animation that will be picked up by Angular when an underlying directive performs an operation.
	 *
	 * The example below shows how an `enter` animation can be made possible on an element using `ng-if`:
	 *
	 * ```html
	 * <div ng-if="bool" class="fade">
	 *    Fade me in out
	 * </div>
	 * <button ng-click="bool=true">Fade In!</button>
	 * <button ng-click="bool=false">Fade Out!</button>
	 * ```
	 *
	 * Notice the CSS class **fade**? We can now create the CSS transition code that references this class:
	 *
	 * ```css
	 * /&#42; The starting CSS styles for the enter animation &#42;/
	 * .fade.ng-enter {
	 *   transition:0.5s linear all;
	 *   opacity:0;
	 * }
	 *
	 * /&#42; The finishing CSS styles for the enter animation &#42;/
	 * .fade.ng-enter.ng-enter-active {
	 *   opacity:1;
	 * }
	 * ```
	 *
	 * The key thing to remember here is that, depending on the animation event (which each of the directives above trigger depending on what's going on) two
	 * generated CSS classes will be applied to the element; in the example above we have `.ng-enter` and `.ng-enter-active`. For CSS transitions, the transition
	 * code **must** be defined within the starting CSS class (in this case `.ng-enter`). The destination class is what the transition will animate towards.
	 *
	 * If for example we wanted to create animations for `leave` and `move` (ngRepeat triggers move) then we can do so using the same CSS naming conventions:
	 *
	 * ```css
	 * /&#42; now the element will fade out before it is removed from the DOM &#42;/
	 * .fade.ng-leave {
	 *   transition:0.5s linear all;
	 *   opacity:1;
	 * }
	 * .fade.ng-leave.ng-leave-active {
	 *   opacity:0;
	 * }
	 * ```
	 *
	 * We can also make use of **CSS Keyframes** by referencing the keyframe animation within the starting CSS class:
	 *
	 * ```css
	 * /&#42; there is no need to define anything inside of the destination
	 * CSS class since the keyframe will take charge of the animation &#42;/
	 * .fade.ng-leave {
	 *   animation: my_fade_animation 0.5s linear;
	 *   -webkit-animation: my_fade_animation 0.5s linear;
	 * }
	 *
	 * @keyframes my_fade_animation {
	 *   from { opacity:1; }
	 *   to { opacity:0; }
	 * }
	 *
	 * @-webkit-keyframes my_fade_animation {
	 *   from { opacity:1; }
	 *   to { opacity:0; }
	 * }
	 * ```
	 *
	 * Feel free also mix transitions and keyframes together as well as any other CSS classes on the same element.
	 *
	 * ### CSS Class-based Animations
	 *
	 * Class-based animations (animations that are triggered via `ngClass`, `ngShow`, `ngHide` and some other directives) have a slightly different
	 * naming convention. Class-based animations are basic enough that a standard transition or keyframe can be referenced on the class being added
	 * and removed.
	 *
	 * For example if we wanted to do a CSS animation for `ngHide` then we place an animation on the `.ng-hide` CSS class:
	 *
	 * ```html
	 * <div ng-show="bool" class="fade">
	 *   Show and hide me
	 * </div>
	 * <button ng-click="bool=!bool">Toggle</button>
	 *
	 * <style>
	 * .fade.ng-hide {
	 *   transition:0.5s linear all;
	 *   opacity:0;
	 * }
	 * </style>
	 * ```
	 *
	 * All that is going on here with ngShow/ngHide behind the scenes is the `.ng-hide` class is added/removed (when the hidden state is valid). Since
	 * ngShow and ngHide are animation aware then we can match up a transition and ngAnimate handles the rest.
	 *
	 * In addition the addition and removal of the CSS class, ngAnimate also provides two helper methods that we can use to further decorate the animation
	 * with CSS styles.
	 *
	 * ```html
	 * <div ng-class="{on:onOff}" class="highlight">
	 *   Highlight this box
	 * </div>
	 * <button ng-click="onOff=!onOff">Toggle</button>
	 *
	 * <style>
	 * .highlight {
	 *   transition:0.5s linear all;
	 * }
	 * .highlight.on-add {
	 *   background:white;
	 * }
	 * .highlight.on {
	 *   background:yellow;
	 * }
	 * .highlight.on-remove {
	 *   background:black;
	 * }
	 * </style>
	 * ```
	 *
	 * We can also make use of CSS keyframes by placing them within the CSS classes.
	 *
	 *
	 * ### CSS Staggering Animations
	 * A Staggering animation is a collection of animations that are issued with a slight delay in between each successive operation resulting in a
	 * curtain-like effect. The ngAnimate module (versions >=1.2) supports staggering animations and the stagger effect can be
	 * performed by creating a **ng-EVENT-stagger** CSS class and attaching that class to the base CSS class used for
	 * the animation. The style property expected within the stagger class can either be a **transition-delay** or an
	 * **animation-delay** property (or both if your animation contains both transitions and keyframe animations).
	 *
	 * ```css
	 * .my-animation.ng-enter {
	 *   /&#42; standard transition code &#42;/
	 *   transition: 1s linear all;
	 *   opacity:0;
	 * }
	 * .my-animation.ng-enter-stagger {
	 *   /&#42; this will have a 100ms delay between each successive leave animation &#42;/
	 *   transition-delay: 0.1s;
	 *
	 *   /&#42; As of 1.4.4, this must always be set: it signals ngAnimate
	 *     to not accidentally inherit a delay property from another CSS class &#42;/
	 *   transition-duration: 0s;
	 *
	 *   /&#42; if you are using animations instead of transitions you should configure as follows:
	 *     animation-delay: 0.1s;
	 *     animation-duration: 0s; &#42;/
	 * }
	 * .my-animation.ng-enter.ng-enter-active {
	 *   /&#42; standard transition styles &#42;/
	 *   opacity:1;
	 * }
	 * ```
	 *
	 * Staggering animations work by default in ngRepeat (so long as the CSS class is defined). Outside of ngRepeat, to use staggering animations
	 * on your own, they can be triggered by firing multiple calls to the same event on $animate. However, the restrictions surrounding this
	 * are that each of the elements must have the same CSS className value as well as the same parent element. A stagger operation
	 * will also be reset if one or more animation frames have passed since the multiple calls to `$animate` were fired.
	 *
	 * The following code will issue the **ng-leave-stagger** event on the element provided:
	 *
	 * ```js
	 * var kids = parent.children();
	 *
	 * $animate.leave(kids[0]); //stagger index=0
	 * $animate.leave(kids[1]); //stagger index=1
	 * $animate.leave(kids[2]); //stagger index=2
	 * $animate.leave(kids[3]); //stagger index=3
	 * $animate.leave(kids[4]); //stagger index=4
	 *
	 * window.requestAnimationFrame(function() {
	 *   //stagger has reset itself
	 *   $animate.leave(kids[5]); //stagger index=0
	 *   $animate.leave(kids[6]); //stagger index=1
	 *
	 *   $scope.$digest();
	 * });
	 * ```
	 *
	 * Stagger animations are currently only supported within CSS-defined animations.
	 *
	 * ### The `ng-animate` CSS class
	 *
	 * When ngAnimate is animating an element it will apply the `ng-animate` CSS class to the element for the duration of the animation.
	 * This is a temporary CSS class and it will be removed once the animation is over (for both JavaScript and CSS-based animations).
	 *
	 * Therefore, animations can be applied to an element using this temporary class directly via CSS.
	 *
	 * ```css
	 * .zipper.ng-animate {
	 *   transition:0.5s linear all;
	 * }
	 * .zipper.ng-enter {
	 *   opacity:0;
	 * }
	 * .zipper.ng-enter.ng-enter-active {
	 *   opacity:1;
	 * }
	 * .zipper.ng-leave {
	 *   opacity:1;
	 * }
	 * .zipper.ng-leave.ng-leave-active {
	 *   opacity:0;
	 * }
	 * ```
	 *
	 * (Note that the `ng-animate` CSS class is reserved and it cannot be applied on an element directly since ngAnimate will always remove
	 * the CSS class once an animation has completed.)
	 *
	 *
	 * ### The `ng-[event]-prepare` class
	 *
	 * This is a special class that can be used to prevent unwanted flickering / flash of content before
	 * the actual animation starts. The class is added as soon as an animation is initialized, but removed
	 * before the actual animation starts (after waiting for a $digest).
	 * It is also only added for *structural* animations (`enter`, `move`, and `leave`).
	 *
	 * In practice, flickering can appear when nesting elements with structural animations such as `ngIf`
	 * into elements that have class-based animations such as `ngClass`.
	 *
	 * ```html
	 * <div ng-class="{red: myProp}">
	 *   <div ng-class="{blue: myProp}">
	 *     <div class="message" ng-if="myProp"></div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * It is possible that during the `enter` animation, the `.message` div will be briefly visible before it starts animating.
	 * In that case, you can add styles to the CSS that make sure the element stays hidden before the animation starts:
	 *
	 * ```css
	 * .message.ng-enter-prepare {
	 *   opacity: 0;
	 * }
	 *
	 * ```
	 *
	 * ## JavaScript-based Animations
	 *
	 * ngAnimate also allows for animations to be consumed by JavaScript code. The approach is similar to CSS-based animations (where there is a shared
	 * CSS class that is referenced in our HTML code) but in addition we need to register the JavaScript animation on the module. By making use of the
	 * `module.animation()` module function we can register the animation.
	 *
	 * Let's see an example of a enter/leave animation using `ngRepeat`:
	 *
	 * ```html
	 * <div ng-repeat="item in items" class="slide">
	 *   {{ item }}
	 * </div>
	 * ```
	 *
	 * See the **slide** CSS class? Let's use that class to define an animation that we'll structure in our module code by using `module.animation`:
	 *
	 * ```js
	 * myModule.animation('.slide', [function() {
	 *   return {
	 *     // make note that other events (like addClass/removeClass)
	 *     // have different function input parameters
	 *     enter: function(element, doneFn) {
	 *       jQuery(element).fadeIn(1000, doneFn);
	 *
	 *       // remember to call doneFn so that angular
	 *       // knows that the animation has concluded
	 *     },
	 *
	 *     move: function(element, doneFn) {
	 *       jQuery(element).fadeIn(1000, doneFn);
	 *     },
	 *
	 *     leave: function(element, doneFn) {
	 *       jQuery(element).fadeOut(1000, doneFn);
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * The nice thing about JS-based animations is that we can inject other services and make use of advanced animation libraries such as
	 * greensock.js and velocity.js.
	 *
	 * If our animation code class-based (meaning that something like `ngClass`, `ngHide` and `ngShow` triggers it) then we can still define
	 * our animations inside of the same registered animation, however, the function input arguments are a bit different:
	 *
	 * ```html
	 * <div ng-class="color" class="colorful">
	 *   this box is moody
	 * </div>
	 * <button ng-click="color='red'">Change to red</button>
	 * <button ng-click="color='blue'">Change to blue</button>
	 * <button ng-click="color='green'">Change to green</button>
	 * ```
	 *
	 * ```js
	 * myModule.animation('.colorful', [function() {
	 *   return {
	 *     addClass: function(element, className, doneFn) {
	 *       // do some cool animation and call the doneFn
	 *     },
	 *     removeClass: function(element, className, doneFn) {
	 *       // do some cool animation and call the doneFn
	 *     },
	 *     setClass: function(element, addedClass, removedClass, doneFn) {
	 *       // do some cool animation and call the doneFn
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * ## CSS + JS Animations Together
	 *
	 * AngularJS 1.4 and higher has taken steps to make the amalgamation of CSS and JS animations more flexible. However, unlike earlier versions of Angular,
	 * defining CSS and JS animations to work off of the same CSS class will not work anymore. Therefore the example below will only result in **JS animations taking
	 * charge of the animation**:
	 *
	 * ```html
	 * <div ng-if="bool" class="slide">
	 *   Slide in and out
	 * </div>
	 * ```
	 *
	 * ```js
	 * myModule.animation('.slide', [function() {
	 *   return {
	 *     enter: function(element, doneFn) {
	 *       jQuery(element).slideIn(1000, doneFn);
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * ```css
	 * .slide.ng-enter {
	 *   transition:0.5s linear all;
	 *   transform:translateY(-100px);
	 * }
	 * .slide.ng-enter.ng-enter-active {
	 *   transform:translateY(0);
	 * }
	 * ```
	 *
	 * Does this mean that CSS and JS animations cannot be used together? Do JS-based animations always have higher priority? We can make up for the
	 * lack of CSS animations by using the `$animateCss` service to trigger our own tweaked-out, CSS-based animations directly from
	 * our own JS-based animation code:
	 *
	 * ```js
	 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
	 *   return {
	 *     enter: function(element) {
	*        // this will trigger `.slide.ng-enter` and `.slide.ng-enter-active`.
	 *       return $animateCss(element, {
	 *         event: 'enter',
	 *         structural: true
	 *       });
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * The nice thing here is that we can save bandwidth by sticking to our CSS-based animation code and we don't need to rely on a 3rd-party animation framework.
	 *
	 * The `$animateCss` service is very powerful since we can feed in all kinds of extra properties that will be evaluated and fed into a CSS transition or
	 * keyframe animation. For example if we wanted to animate the height of an element while adding and removing classes then we can do so by providing that
	 * data into `$animateCss` directly:
	 *
	 * ```js
	 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
	 *   return {
	 *     enter: function(element) {
	 *       return $animateCss(element, {
	 *         event: 'enter',
	 *         structural: true,
	 *         addClass: 'maroon-setting',
	 *         from: { height:0 },
	 *         to: { height: 200 }
	 *       });
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * Now we can fill in the rest via our transition CSS code:
	 *
	 * ```css
	 * /&#42; the transition tells ngAnimate to make the animation happen &#42;/
	 * .slide.ng-enter { transition:0.5s linear all; }
	 *
	 * /&#42; this extra CSS class will be absorbed into the transition
	 * since the $animateCss code is adding the class &#42;/
	 * .maroon-setting { background:red; }
	 * ```
	 *
	 * And `$animateCss` will figure out the rest. Just make sure to have the `done()` callback fire the `doneFn` function to signal when the animation is over.
	 *
	 * To learn more about what's possible be sure to visit the {@link ngAnimate.$animateCss $animateCss service}.
	 *
	 * ## Animation Anchoring (via `ng-animate-ref`)
	 *
	 * ngAnimate in AngularJS 1.4 comes packed with the ability to cross-animate elements between
	 * structural areas of an application (like views) by pairing up elements using an attribute
	 * called `ng-animate-ref`.
	 *
	 * Let's say for example we have two views that are managed by `ng-view` and we want to show
	 * that there is a relationship between two components situated in within these views. By using the
	 * `ng-animate-ref` attribute we can identify that the two components are paired together and we
	 * can then attach an animation, which is triggered when the view changes.
	 *
	 * Say for example we have the following template code:
	 *
	 * ```html
	 * <!-- index.html -->
	 * <div ng-view class="view-animation">
	 * </div>
	 *
	 * <!-- home.html -->
	 * <a href="#/banner-page">
	 *   <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
	 * </a>
	 *
	 * <!-- banner-page.html -->
	 * <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
	 * ```
	 *
	 * Now, when the view changes (once the link is clicked), ngAnimate will examine the
	 * HTML contents to see if there is a match reference between any components in the view
	 * that is leaving and the view that is entering. It will scan both the view which is being
	 * removed (leave) and inserted (enter) to see if there are any paired DOM elements that
	 * contain a matching ref value.
	 *
	 * The two images match since they share the same ref value. ngAnimate will now create a
	 * transport element (which is a clone of the first image element) and it will then attempt
	 * to animate to the position of the second image element in the next view. For the animation to
	 * work a special CSS class called `ng-anchor` will be added to the transported element.
	 *
	 * We can now attach a transition onto the `.banner.ng-anchor` CSS class and then
	 * ngAnimate will handle the entire transition for us as well as the addition and removal of
	 * any changes of CSS classes between the elements:
	 *
	 * ```css
	 * .banner.ng-anchor {
	 *   /&#42; this animation will last for 1 second since there are
	 *          two phases to the animation (an `in` and an `out` phase) &#42;/
	 *   transition:0.5s linear all;
	 * }
	 * ```
	 *
	 * We also **must** include animations for the views that are being entered and removed
	 * (otherwise anchoring wouldn't be possible since the new view would be inserted right away).
	 *
	 * ```css
	 * .view-animation.ng-enter, .view-animation.ng-leave {
	 *   transition:0.5s linear all;
	 *   position:fixed;
	 *   left:0;
	 *   top:0;
	 *   width:100%;
	 * }
	 * .view-animation.ng-enter {
	 *   transform:translateX(100%);
	 * }
	 * .view-animation.ng-leave,
	 * .view-animation.ng-enter.ng-enter-active {
	 *   transform:translateX(0%);
	 * }
	 * .view-animation.ng-leave.ng-leave-active {
	 *   transform:translateX(-100%);
	 * }
	 * ```
	 *
	 * Now we can jump back to the anchor animation. When the animation happens, there are two stages that occur:
	 * an `out` and an `in` stage. The `out` stage happens first and that is when the element is animated away
	 * from its origin. Once that animation is over then the `in` stage occurs which animates the
	 * element to its destination. The reason why there are two animations is to give enough time
	 * for the enter animation on the new element to be ready.
	 *
	 * The example above sets up a transition for both the in and out phases, but we can also target the out or
	 * in phases directly via `ng-anchor-out` and `ng-anchor-in`.
	 *
	 * ```css
	 * .banner.ng-anchor-out {
	 *   transition: 0.5s linear all;
	 *
	 *   /&#42; the scale will be applied during the out animation,
	 *          but will be animated away when the in animation runs &#42;/
	 *   transform: scale(1.2);
	 * }
	 *
	 * .banner.ng-anchor-in {
	 *   transition: 1s linear all;
	 * }
	 * ```
	 *
	 *
	 *
	 *
	 * ### Anchoring Demo
	 *
	  <example module="anchoringExample"
	           name="anchoringExample"
	           id="anchoringExample"
	           deps="angular-animate.js;angular-route.js"
	           animations="true">
	    <file name="index.html">
	      <a href="#!/">Home</a>
	      <hr />
	      <div class="view-container">
	        <div ng-view class="view"></div>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('anchoringExample', ['ngAnimate', 'ngRoute'])
	        .config(['$routeProvider', function($routeProvider) {
	          $routeProvider.when('/', {
	            templateUrl: 'home.html',
	            controller: 'HomeController as home'
	          });
	          $routeProvider.when('/profile/:id', {
	            templateUrl: 'profile.html',
	            controller: 'ProfileController as profile'
	          });
	        }])
	        .run(['$rootScope', function($rootScope) {
	          $rootScope.records = [
	            { id: 1, title: 'Miss Beulah Roob' },
	            { id: 2, title: 'Trent Morissette' },
	            { id: 3, title: 'Miss Ava Pouros' },
	            { id: 4, title: 'Rod Pouros' },
	            { id: 5, title: 'Abdul Rice' },
	            { id: 6, title: 'Laurie Rutherford Sr.' },
	            { id: 7, title: 'Nakia McLaughlin' },
	            { id: 8, title: 'Jordon Blanda DVM' },
	            { id: 9, title: 'Rhoda Hand' },
	            { id: 10, title: 'Alexandrea Sauer' }
	          ];
	        }])
	        .controller('HomeController', [function() {
	          //empty
	        }])
	        .controller('ProfileController', ['$rootScope', '$routeParams',
	            function ProfileController($rootScope, $routeParams) {
	          var index = parseInt($routeParams.id, 10);
	          var record = $rootScope.records[index - 1];
	
	          this.title = record.title;
	          this.id = record.id;
	        }]);
	    </file>
	    <file name="home.html">
	      <h2>Welcome to the home page</h1>
	      <p>Please click on an element</p>
	      <a class="record"
	         ng-href="#!/profile/{{ record.id }}"
	         ng-animate-ref="{{ record.id }}"
	         ng-repeat="record in records">
	        {{ record.title }}
	      </a>
	    </file>
	    <file name="profile.html">
	      <div class="profile record" ng-animate-ref="{{ profile.id }}">
	        {{ profile.title }}
	      </div>
	    </file>
	    <file name="animations.css">
	      .record {
	        display:block;
	        font-size:20px;
	      }
	      .profile {
	        background:black;
	        color:white;
	        font-size:100px;
	      }
	      .view-container {
	        position:relative;
	      }
	      .view-container > .view.ng-animate {
	        position:absolute;
	        top:0;
	        left:0;
	        width:100%;
	        min-height:500px;
	      }
	      .view.ng-enter, .view.ng-leave,
	      .record.ng-anchor {
	        transition:0.5s linear all;
	      }
	      .view.ng-enter {
	        transform:translateX(100%);
	      }
	      .view.ng-enter.ng-enter-active, .view.ng-leave {
	        transform:translateX(0%);
	      }
	      .view.ng-leave.ng-leave-active {
	        transform:translateX(-100%);
	      }
	      .record.ng-anchor-out {
	        background:red;
	      }
	    </file>
	  </example>
	 *
	 * ### How is the element transported?
	 *
	 * When an anchor animation occurs, ngAnimate will clone the starting element and position it exactly where the starting
	 * element is located on screen via absolute positioning. The cloned element will be placed inside of the root element
	 * of the application (where ng-app was defined) and all of the CSS classes of the starting element will be applied. The
	 * element will then animate into the `out` and `in` animations and will eventually reach the coordinates and match
	 * the dimensions of the destination element. During the entire animation a CSS class of `.ng-animate-shim` will be applied
	 * to both the starting and destination elements in order to hide them from being visible (the CSS styling for the class
	 * is: `visibility:hidden`). Once the anchor reaches its destination then it will be removed and the destination element
	 * will become visible since the shim class will be removed.
	 *
	 * ### How is the morphing handled?
	 *
	 * CSS Anchoring relies on transitions and keyframes and the internal code is intelligent enough to figure out
	 * what CSS classes differ between the starting element and the destination element. These different CSS classes
	 * will be added/removed on the anchor element and a transition will be applied (the transition that is provided
	 * in the anchor class). Long story short, ngAnimate will figure out what classes to add and remove which will
	 * make the transition of the element as smooth and automatic as possible. Be sure to use simple CSS classes that
	 * do not rely on DOM nesting structure so that the anchor element appears the same as the starting element (since
	 * the cloned element is placed inside of root element which is likely close to the body element).
	 *
	 * Note that if the root element is on the `<html>` element then the cloned node will be placed inside of body.
	 *
	 *
	 * ## Using $animate in your directive code
	 *
	 * So far we've explored how to feed in animations into an Angular application, but how do we trigger animations within our own directives in our application?
	 * By injecting the `$animate` service into our directive code, we can trigger structural and class-based hooks which can then be consumed by animations. Let's
	 * imagine we have a greeting box that shows and hides itself when the data changes
	 *
	 * ```html
	 * <greeting-box active="onOrOff">Hi there</greeting-box>
	 * ```
	 *
	 * ```js
	 * ngModule.directive('greetingBox', ['$animate', function($animate) {
	 *   return function(scope, element, attrs) {
	 *     attrs.$observe('active', function(value) {
	 *       value ? $animate.addClass(element, 'on') : $animate.removeClass(element, 'on');
	 *     });
	 *   });
	 * }]);
	 * ```
	 *
	 * Now the `on` CSS class is added and removed on the greeting box component. Now if we add a CSS class on top of the greeting box element
	 * in our HTML code then we can trigger a CSS or JS animation to happen.
	 *
	 * ```css
	 * /&#42; normally we would create a CSS class to reference on the element &#42;/
	 * greeting-box.on { transition:0.5s linear all; background:green; color:white; }
	 * ```
	 *
	 * The `$animate` service contains a variety of other methods like `enter`, `leave`, `animate` and `setClass`. To learn more about what's
	 * possible be sure to visit the {@link ng.$animate $animate service API page}.
	 *
	 *
	 * ## Callbacks and Promises
	 *
	 * When `$animate` is called it returns a promise that can be used to capture when the animation has ended. Therefore if we were to trigger
	 * an animation (within our directive code) then we can continue performing directive and scope related activities after the animation has
	 * ended by chaining onto the returned promise that animation method returns.
	 *
	 * ```js
	 * // somewhere within the depths of the directive
	 * $animate.enter(element, parent).then(function() {
	 *   //the animation has completed
	 * });
	 * ```
	 *
	 * (Note that earlier versions of Angular prior to v1.4 required the promise code to be wrapped using `$scope.$apply(...)`. This is not the case
	 * anymore.)
	 *
	 * In addition to the animation promise, we can also make use of animation-related callbacks within our directives and controller code by registering
	 * an event listener using the `$animate` service. Let's say for example that an animation was triggered on our view
	 * routing controller to hook into that:
	 *
	 * ```js
	 * ngModule.controller('HomePageController', ['$animate', function($animate) {
	 *   $animate.on('enter', ngViewElement, function(element) {
	 *     // the animation for this route has completed
	 *   }]);
	 * }])
	 * ```
	 *
	 * (Note that you will need to trigger a digest within the callback to get angular to notice any scope-related changes.)
	 */
	
	var copy;
	var extend;
	var forEach;
	var isArray;
	var isDefined;
	var isElement;
	var isFunction;
	var isObject;
	var isString;
	var isUndefined;
	var jqLite;
	var noop;
	
	/**
	 * @ngdoc service
	 * @name $animate
	 * @kind object
	 *
	 * @description
	 * The ngAnimate `$animate` service documentation is the same for the core `$animate` service.
	 *
	 * Click here {@link ng.$animate to learn more about animations with `$animate`}.
	 */
	angular.module('ngAnimate', [], function initAngularHelpers() {
	  // Access helpers from angular core.
	  // Do it inside a `config` block to ensure `window.angular` is available.
	  noop        = angular.noop;
	  copy        = angular.copy;
	  extend      = angular.extend;
	  jqLite      = angular.element;
	  forEach     = angular.forEach;
	  isArray     = angular.isArray;
	  isString    = angular.isString;
	  isObject    = angular.isObject;
	  isUndefined = angular.isUndefined;
	  isDefined   = angular.isDefined;
	  isFunction  = angular.isFunction;
	  isElement   = angular.isElement;
	})
	  .info({ angularVersion: '1.6.4' })
	  .directive('ngAnimateSwap', ngAnimateSwapDirective)
	
	  .directive('ngAnimateChildren', $$AnimateChildrenDirective)
	  .factory('$$rAFScheduler', $$rAFSchedulerFactory)
	
	  .provider('$$animateQueue', $$AnimateQueueProvider)
	  .provider('$$animation', $$AnimationProvider)
	
	  .provider('$animateCss', $AnimateCssProvider)
	  .provider('$$animateCssDriver', $$AnimateCssDriverProvider)
	
	  .provider('$$animateJs', $$AnimateJsProvider)
	  .provider('$$animateJsDriver', $$AnimateJsDriverProvider);
	
	
	})(window, window.angular);


/***/ }),

/***/ 36:
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.6.4
	 * (c) 2010-2017 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/**
	 * @ngdoc module
	 * @name ngAria
	 * @description
	 *
	 * The `ngAria` module provides support for common
	 * [<abbr title="Accessible Rich Internet Applications">ARIA</abbr>](http://www.w3.org/TR/wai-aria/)
	 * attributes that convey state or semantic information about the application for users
	 * of assistive technologies, such as screen readers.
	 *
	 * <div doc-module-components="ngAria"></div>
	 *
	 * ## Usage
	 *
	 * For ngAria to do its magic, simply include the module `ngAria` as a dependency. The following
	 * directives are supported:
	 * `ngModel`, `ngChecked`, `ngReadonly`, `ngRequired`, `ngValue`, `ngDisabled`, `ngShow`, `ngHide`, `ngClick`,
	 * `ngDblClick`, and `ngMessages`.
	 *
	 * Below is a more detailed breakdown of the attributes handled by ngAria:
	 *
	 * | Directive                                   | Supported Attributes                                                                                |
	 * |---------------------------------------------|-----------------------------------------------------------------------------------------------------|
	 * | {@link ng.directive:ngModel ngModel}        | aria-checked, aria-valuemin, aria-valuemax, aria-valuenow, aria-invalid, aria-required, input roles |
	 * | {@link ng.directive:ngDisabled ngDisabled}  | aria-disabled                                                                                       |
	 * | {@link ng.directive:ngRequired ngRequired}  | aria-required                                                                                       |
	 * | {@link ng.directive:ngChecked ngChecked}    | aria-checked                                                                                        |
	 * | {@link ng.directive:ngReadonly ngReadonly}  | aria-readonly                                                                                       |
	 * | {@link ng.directive:ngValue ngValue}        | aria-checked                                                                                        |
	 * | {@link ng.directive:ngShow ngShow}          | aria-hidden                                                                                         |
	 * | {@link ng.directive:ngHide ngHide}          | aria-hidden                                                                                         |
	 * | {@link ng.directive:ngDblclick ngDblclick}  | tabindex                                                                                            |
	 * | {@link module:ngMessages ngMessages}        | aria-live                                                                                           |
	 * | {@link ng.directive:ngClick ngClick}        | tabindex, keydown event, button role                                                                |
	 *
	 * Find out more information about each directive by reading the
	 * {@link guide/accessibility ngAria Developer Guide}.
	 *
	 * ## Example
	 * Using ngDisabled with ngAria:
	 * ```html
	 * <md-checkbox ng-disabled="disabled">
	 * ```
	 * Becomes:
	 * ```html
	 * <md-checkbox ng-disabled="disabled" aria-disabled="true">
	 * ```
	 *
	 * ## Disabling Attributes
	 * It's possible to disable individual attributes added by ngAria with the
	 * {@link ngAria.$ariaProvider#config config} method. For more details, see the
	 * {@link guide/accessibility Developer Guide}.
	 */
	var ngAriaModule = angular.module('ngAria', ['ng']).
	                        info({ angularVersion: '1.6.4' }).
	                        provider('$aria', $AriaProvider);
	
	/**
	* Internal Utilities
	*/
	var nodeBlackList = ['BUTTON', 'A', 'INPUT', 'TEXTAREA', 'SELECT', 'DETAILS', 'SUMMARY'];
	
	var isNodeOneOf = function(elem, nodeTypeArray) {
	  if (nodeTypeArray.indexOf(elem[0].nodeName) !== -1) {
	    return true;
	  }
	};
	/**
	 * @ngdoc provider
	 * @name $ariaProvider
	 * @this
	 *
	 * @description
	 *
	 * Used for configuring the ARIA attributes injected and managed by ngAria.
	 *
	 * ```js
	 * angular.module('myApp', ['ngAria'], function config($ariaProvider) {
	 *   $ariaProvider.config({
	 *     ariaValue: true,
	 *     tabindex: false
	 *   });
	 * });
	 *```
	 *
	 * ## Dependencies
	 * Requires the {@link ngAria} module to be installed.
	 *
	 */
	function $AriaProvider() {
	  var config = {
	    ariaHidden: true,
	    ariaChecked: true,
	    ariaReadonly: true,
	    ariaDisabled: true,
	    ariaRequired: true,
	    ariaInvalid: true,
	    ariaValue: true,
	    tabindex: true,
	    bindKeydown: true,
	    bindRoleForClick: true
	  };
	
	  /**
	   * @ngdoc method
	   * @name $ariaProvider#config
	   *
	   * @param {object} config object to enable/disable specific ARIA attributes
	   *
	   *  - **ariaHidden** – `{boolean}` – Enables/disables aria-hidden tags
	   *  - **ariaChecked** – `{boolean}` – Enables/disables aria-checked tags
	   *  - **ariaReadonly** – `{boolean}` – Enables/disables aria-readonly tags
	   *  - **ariaDisabled** – `{boolean}` – Enables/disables aria-disabled tags
	   *  - **ariaRequired** – `{boolean}` – Enables/disables aria-required tags
	   *  - **ariaInvalid** – `{boolean}` – Enables/disables aria-invalid tags
	   *  - **ariaValue** – `{boolean}` – Enables/disables aria-valuemin, aria-valuemax and
	   *    aria-valuenow tags
	   *  - **tabindex** – `{boolean}` – Enables/disables tabindex tags
	   *  - **bindKeydown** – `{boolean}` – Enables/disables keyboard event binding on non-interactive
	   *    elements (such as `div` or `li`) using ng-click, making them more accessible to users of
	   *    assistive technologies
	   *  - **bindRoleForClick** – `{boolean}` – Adds role=button to non-interactive elements (such as
	   *    `div` or `li`) using ng-click, making them more accessible to users of assistive
	   *    technologies
	   *
	   * @description
	   * Enables/disables various ARIA attributes
	   */
	  this.config = function(newConfig) {
	    config = angular.extend(config, newConfig);
	  };
	
	  function watchExpr(attrName, ariaAttr, nodeBlackList, negate) {
	    return function(scope, elem, attr) {
	      var ariaCamelName = attr.$normalize(ariaAttr);
	      if (config[ariaCamelName] && !isNodeOneOf(elem, nodeBlackList) && !attr[ariaCamelName]) {
	        scope.$watch(attr[attrName], function(boolVal) {
	          // ensure boolean value
	          boolVal = negate ? !boolVal : !!boolVal;
	          elem.attr(ariaAttr, boolVal);
	        });
	      }
	    };
	  }
	  /**
	   * @ngdoc service
	   * @name $aria
	   *
	   * @description
	   * @priority 200
	   *
	   * The $aria service contains helper methods for applying common
	   * [ARIA](http://www.w3.org/TR/wai-aria/) attributes to HTML directives.
	   *
	   * ngAria injects common accessibility attributes that tell assistive technologies when HTML
	   * elements are enabled, selected, hidden, and more. To see how this is performed with ngAria,
	   * let's review a code snippet from ngAria itself:
	   *
	   *```js
	   * ngAriaModule.directive('ngDisabled', ['$aria', function($aria) {
	   *   return $aria.$$watchExpr('ngDisabled', 'aria-disabled', nodeBlackList, false);
	   * }])
	   *```
	   * Shown above, the ngAria module creates a directive with the same signature as the
	   * traditional `ng-disabled` directive. But this ngAria version is dedicated to
	   * solely managing accessibility attributes on custom elements. The internal `$aria` service is
	   * used to watch the boolean attribute `ngDisabled`. If it has not been explicitly set by the
	   * developer, `aria-disabled` is injected as an attribute with its value synchronized to the
	   * value in `ngDisabled`.
	   *
	   * Because ngAria hooks into the `ng-disabled` directive, developers do not have to do
	   * anything to enable this feature. The `aria-disabled` attribute is automatically managed
	   * simply as a silent side-effect of using `ng-disabled` with the ngAria module.
	   *
	   * The full list of directives that interface with ngAria:
	   * * **ngModel**
	   * * **ngChecked**
	   * * **ngReadonly**
	   * * **ngRequired**
	   * * **ngDisabled**
	   * * **ngValue**
	   * * **ngShow**
	   * * **ngHide**
	   * * **ngClick**
	   * * **ngDblclick**
	   * * **ngMessages**
	   *
	   * Read the {@link guide/accessibility ngAria Developer Guide} for a thorough explanation of each
	   * directive.
	   *
	   *
	   * ## Dependencies
	   * Requires the {@link ngAria} module to be installed.
	   */
	  this.$get = function() {
	    return {
	      config: function(key) {
	        return config[key];
	      },
	      $$watchExpr: watchExpr
	    };
	  };
	}
	
	
	ngAriaModule.directive('ngShow', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngShow', 'aria-hidden', [], true);
	}])
	.directive('ngHide', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngHide', 'aria-hidden', [], false);
	}])
	.directive('ngValue', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngValue', 'aria-checked', nodeBlackList, false);
	}])
	.directive('ngChecked', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngChecked', 'aria-checked', nodeBlackList, false);
	}])
	.directive('ngReadonly', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngReadonly', 'aria-readonly', nodeBlackList, false);
	}])
	.directive('ngRequired', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngRequired', 'aria-required', nodeBlackList, false);
	}])
	.directive('ngModel', ['$aria', function($aria) {
	
	  function shouldAttachAttr(attr, normalizedAttr, elem, allowBlacklistEls) {
	    return $aria.config(normalizedAttr) && !elem.attr(attr) && (allowBlacklistEls || !isNodeOneOf(elem, nodeBlackList));
	  }
	
	  function shouldAttachRole(role, elem) {
	    // if element does not have role attribute
	    // AND element type is equal to role (if custom element has a type equaling shape) <-- remove?
	    // AND element is not in nodeBlackList
	    return !elem.attr('role') && (elem.attr('type') === role) && !isNodeOneOf(elem, nodeBlackList);
	  }
	
	  function getShape(attr, elem) {
	    var type = attr.type,
	        role = attr.role;
	
	    return ((type || role) === 'checkbox' || role === 'menuitemcheckbox') ? 'checkbox' :
	           ((type || role) === 'radio'    || role === 'menuitemradio') ? 'radio' :
	           (type === 'range'              || role === 'progressbar' || role === 'slider') ? 'range' : '';
	  }
	
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    priority: 200, //Make sure watches are fired after any other directives that affect the ngModel value
	    compile: function(elem, attr) {
	      var shape = getShape(attr, elem);
	
	      return {
	        post: function(scope, elem, attr, ngModel) {
	          var needsTabIndex = shouldAttachAttr('tabindex', 'tabindex', elem, false);
	
	          function ngAriaWatchModelValue() {
	            return ngModel.$modelValue;
	          }
	
	          function getRadioReaction(newVal) {
	            // Strict comparison would cause a BC
	            // eslint-disable-next-line eqeqeq
	            var boolVal = (attr.value == ngModel.$viewValue);
	            elem.attr('aria-checked', boolVal);
	          }
	
	          function getCheckboxReaction() {
	            elem.attr('aria-checked', !ngModel.$isEmpty(ngModel.$viewValue));
	          }
	
	          switch (shape) {
	            case 'radio':
	            case 'checkbox':
	              if (shouldAttachRole(shape, elem)) {
	                elem.attr('role', shape);
	              }
	              if (shouldAttachAttr('aria-checked', 'ariaChecked', elem, false)) {
	                scope.$watch(ngAriaWatchModelValue, shape === 'radio' ?
	                    getRadioReaction : getCheckboxReaction);
	              }
	              if (needsTabIndex) {
	                elem.attr('tabindex', 0);
	              }
	              break;
	            case 'range':
	              if (shouldAttachRole(shape, elem)) {
	                elem.attr('role', 'slider');
	              }
	              if ($aria.config('ariaValue')) {
	                var needsAriaValuemin = !elem.attr('aria-valuemin') &&
	                    (attr.hasOwnProperty('min') || attr.hasOwnProperty('ngMin'));
	                var needsAriaValuemax = !elem.attr('aria-valuemax') &&
	                    (attr.hasOwnProperty('max') || attr.hasOwnProperty('ngMax'));
	                var needsAriaValuenow = !elem.attr('aria-valuenow');
	
	                if (needsAriaValuemin) {
	                  attr.$observe('min', function ngAriaValueMinReaction(newVal) {
	                    elem.attr('aria-valuemin', newVal);
	                  });
	                }
	                if (needsAriaValuemax) {
	                  attr.$observe('max', function ngAriaValueMinReaction(newVal) {
	                    elem.attr('aria-valuemax', newVal);
	                  });
	                }
	                if (needsAriaValuenow) {
	                  scope.$watch(ngAriaWatchModelValue, function ngAriaValueNowReaction(newVal) {
	                    elem.attr('aria-valuenow', newVal);
	                  });
	                }
	              }
	              if (needsTabIndex) {
	                elem.attr('tabindex', 0);
	              }
	              break;
	          }
	
	          if (!attr.hasOwnProperty('ngRequired') && ngModel.$validators.required
	            && shouldAttachAttr('aria-required', 'ariaRequired', elem, false)) {
	            // ngModel.$error.required is undefined on custom controls
	            attr.$observe('required', function() {
	              elem.attr('aria-required', !!attr['required']);
	            });
	          }
	
	          if (shouldAttachAttr('aria-invalid', 'ariaInvalid', elem, true)) {
	            scope.$watch(function ngAriaInvalidWatch() {
	              return ngModel.$invalid;
	            }, function ngAriaInvalidReaction(newVal) {
	              elem.attr('aria-invalid', !!newVal);
	            });
	          }
	        }
	      };
	    }
	  };
	}])
	.directive('ngDisabled', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngDisabled', 'aria-disabled', nodeBlackList, false);
	}])
	.directive('ngMessages', function() {
	  return {
	    restrict: 'A',
	    require: '?ngMessages',
	    link: function(scope, elem, attr, ngMessages) {
	      if (!elem.attr('aria-live')) {
	        elem.attr('aria-live', 'assertive');
	      }
	    }
	  };
	})
	.directive('ngClick',['$aria', '$parse', function($aria, $parse) {
	  return {
	    restrict: 'A',
	    compile: function(elem, attr) {
	      var fn = $parse(attr.ngClick);
	      return function(scope, elem, attr) {
	
	        if (!isNodeOneOf(elem, nodeBlackList)) {
	
	          if ($aria.config('bindRoleForClick') && !elem.attr('role')) {
	            elem.attr('role', 'button');
	          }
	
	          if ($aria.config('tabindex') && !elem.attr('tabindex')) {
	            elem.attr('tabindex', 0);
	          }
	
	          if ($aria.config('bindKeydown') && !attr.ngKeydown && !attr.ngKeypress && !attr.ngKeyup) {
	            elem.on('keydown', function(event) {
	              var keyCode = event.which || event.keyCode;
	              if (keyCode === 32 || keyCode === 13) {
	                scope.$apply(callback);
	              }
	
	              function callback() {
	                fn(scope, { $event: event });
	              }
	            });
	          }
	        }
	      };
	    }
	  };
	}])
	.directive('ngDblclick', ['$aria', function($aria) {
	  return function(scope, elem, attr) {
	    if ($aria.config('tabindex') && !elem.attr('tabindex') && !isNodeOneOf(elem, nodeBlackList)) {
	      elem.attr('tabindex', 0);
	    }
	  };
	}]);
	
	
	})(window, window.angular);


/***/ }),

/***/ 37:
/***/ (function(module, exports) {

	/*!
	 * AngularJS Material Design
	 * https://github.com/angular/material
	 * @license MIT
	 * v1.1.4
	 */
	(function( window, angular, undefined ){
	"use strict";
	
	(function(){
	"use strict";
	
	angular.module('ngMaterial', ["ng","ngAnimate","ngAria","material.core","material.core.interaction","material.core.gestures","material.core.layout","material.core.meta","material.core.theming.palette","material.core.theming","material.core.animate","material.components.autocomplete","material.components.backdrop","material.components.bottomSheet","material.components.button","material.components.card","material.components.checkbox","material.components.chips","material.components.colors","material.components.content","material.components.datepicker","material.components.dialog","material.components.divider","material.components.fabActions","material.components.fabShared","material.components.fabSpeedDial","material.components.fabToolbar","material.components.gridList","material.components.icon","material.components.input","material.components.list","material.components.menu","material.components.menuBar","material.components.navBar","material.components.progressCircular","material.components.panel","material.components.progressLinear","material.components.radioButton","material.components.showHide","material.components.sidenav","material.components.select","material.components.slider","material.components.sticky","material.components.subheader","material.components.switch","material.components.swipe","material.components.tabs","material.components.toast","material.components.toolbar","material.components.tooltip","material.components.truncate","material.components.virtualRepeat","material.components.whiteframe"]);
	})();
	(function(){
	"use strict";
	
	/**
	 * Initialization function that validates environment
	 * requirements.
	 */
	DetectNgTouch.$inject = ["$log", "$injector"];
	MdCoreConfigure.$inject = ["$provide", "$mdThemingProvider"];
	rAFDecorator.$inject = ["$delegate"];
	qDecorator.$inject = ["$delegate"];
	angular
	  .module('material.core', [
	    'ngAnimate',
	    'material.core.animate',
	    'material.core.layout',
	    'material.core.interaction',
	    'material.core.gestures',
	    'material.core.theming'
	  ])
	  .config(MdCoreConfigure)
	  .run(DetectNgTouch);
	
	
	/**
	 * Detect if the ng-Touch module is also being used.
	 * Warn if detected.
	 * @ngInject
	 */
	function DetectNgTouch($log, $injector) {
	  if ( $injector.has('$swipe') ) {
	    var msg = "" +
	      "You are using the ngTouch module. \n" +
	      "AngularJS Material already has mobile click, tap, and swipe support... \n" +
	      "ngTouch is not supported with AngularJS Material!";
	    $log.warn(msg);
	  }
	}
	
	/**
	 * @ngInject
	 */
	function MdCoreConfigure($provide, $mdThemingProvider) {
	
	  $provide.decorator('$$rAF', ['$delegate', rAFDecorator]);
	  $provide.decorator('$q', ['$delegate', qDecorator]);
	
	  $mdThemingProvider.theme('default')
	    .primaryPalette('indigo')
	    .accentPalette('pink')
	    .warnPalette('deep-orange')
	    .backgroundPalette('grey');
	}
	
	/**
	 * @ngInject
	 */
	function rAFDecorator($delegate) {
	  /**
	   * Use this to throttle events that come in often.
	   * The throttled function will always use the *last* invocation before the
	   * coming frame.
	   *
	   * For example, window resize events that fire many times a second:
	   * If we set to use an raf-throttled callback on window resize, then
	   * our callback will only be fired once per frame, with the last resize
	   * event that happened before that frame.
	   *
	   * @param {function} callback function to debounce
	   */
	  $delegate.throttle = function(cb) {
	    var queuedArgs, alreadyQueued, queueCb, context;
	    return function debounced() {
	      queuedArgs = arguments;
	      context = this;
	      queueCb = cb;
	      if (!alreadyQueued) {
	        alreadyQueued = true;
	        $delegate(function() {
	          queueCb.apply(context, Array.prototype.slice.call(queuedArgs));
	          alreadyQueued = false;
	        });
	      }
	    };
	  };
	  return $delegate;
	}
	
	/**
	 * @ngInject
	 */
	function qDecorator($delegate) {
	  /**
	   * Adds a shim for $q.resolve for AngularJS version that don't have it,
	   * so we don't have to think about it.
	   *
	   * via https://github.com/angular/angular.js/pull/11987
	   */
	
	  // TODO(crisbeto): this won't be necessary once we drop AngularJS 1.3
	  if (!$delegate.resolve) {
	    $delegate.resolve = $delegate.when;
	  }
	  return $delegate;
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdAutofocusDirective.$inject = ["$parse"];angular.module('material.core')
	  .directive('mdAutofocus', MdAutofocusDirective)
	
	  // Support the deprecated md-auto-focus and md-sidenav-focus as well
	  .directive('mdAutoFocus', MdAutofocusDirective)
	  .directive('mdSidenavFocus', MdAutofocusDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdAutofocus
	 * @module material.core.util
	 *
	 * @description
	 *
	 * `[md-autofocus]` provides an optional way to identify the focused element when a `$mdDialog`,
	 * `$mdBottomSheet`, `$mdMenu` or `$mdSidenav` opens or upon page load for input-like elements.
	 *
	 * When one of these opens, it will find the first nested element with the `[md-autofocus]`
	 * attribute directive and optional expression. An expression may be specified as the directive
	 * value to enable conditional activation of the autofocus.
	 *
	 * @usage
	 *
	 * ### Dialog
	 * <hljs lang="html">
	 * <md-dialog>
	 *   <form>
	 *     <md-input-container>
	 *       <label for="testInput">Label</label>
	 *       <input id="testInput" type="text" md-autofocus>
	 *     </md-input-container>
	 *   </form>
	 * </md-dialog>
	 * </hljs>
	 *
	 * ### Bottomsheet
	 * <hljs lang="html">
	 * <md-bottom-sheet class="md-list md-has-header">
	 *  <md-subheader>Comment Actions</md-subheader>
	 *  <md-list>
	 *    <md-list-item ng-repeat="item in items">
	 *
	 *      <md-button md-autofocus="$index == 2">
	 *        <md-icon md-svg-src="{{item.icon}}"></md-icon>
	 *        <span class="md-inline-list-icon-label">{{ item.name }}</span>
	 *      </md-button>
	 *
	 *    </md-list-item>
	 *  </md-list>
	 * </md-bottom-sheet>
	 * </hljs>
	 *
	 * ### Autocomplete
	 * <hljs lang="html">
	 *   <md-autocomplete
	 *       md-autofocus
	 *       md-selected-item="selectedItem"
	 *       md-search-text="searchText"
	 *       md-items="item in getMatches(searchText)"
	 *       md-item-text="item.display">
	 *     <span md-highlight-text="searchText">{{item.display}}</span>
	 *   </md-autocomplete>
	 * </hljs>
	 *
	 * ### Sidenav
	 * <hljs lang="html">
	 * <div layout="row" ng-controller="MyController">
	 *   <md-sidenav md-component-id="left" class="md-sidenav-left">
	 *     Left Nav!
	 *   </md-sidenav>
	 *
	 *   <md-content>
	 *     Center Content
	 *     <md-button ng-click="openLeftMenu()">
	 *       Open Left Menu
	 *     </md-button>
	 *   </md-content>
	 *
	 *   <md-sidenav md-component-id="right"
	 *     md-is-locked-open="$mdMedia('min-width: 333px')"
	 *     class="md-sidenav-right">
	 *     <form>
	 *       <md-input-container>
	 *         <label for="testInput">Test input</label>
	 *         <input id="testInput" type="text"
	 *                ng-model="data" md-autofocus>
	 *       </md-input-container>
	 *     </form>
	 *   </md-sidenav>
	 * </div>
	 * </hljs>
	 **/
	function MdAutofocusDirective($parse) {
	  return {
	    restrict: 'A',
	    link: {
	      pre: preLink
	    }
	  };
	
	  function preLink(scope, element, attr) {
	    var attrExp = attr.mdAutoFocus || attr.mdAutofocus || attr.mdSidenavFocus;
	
	    // Initially update the expression by manually parsing the expression as per $watch source.
	    updateExpression($parse(attrExp)(scope));
	
	    // Only watch the expression if it is not empty.
	    if (attrExp) {
	      scope.$watch(attrExp, updateExpression);
	    }
	
	    /**
	     * Updates the autofocus class which is used to determine whether the attribute
	     * expression evaluates to true or false.
	     * @param {string|boolean} value Attribute Value
	     */
	    function updateExpression(value) {
	
	      // Rather than passing undefined to the jqLite toggle class function we explicitly set the
	      // value to true. Otherwise the class will be just toggled instead of being forced.
	      if (angular.isUndefined(value)) {
	        value = true;
	      }
	
	      element.toggleClass('md-autofocus', !!value);
	    }
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.core.colorUtil
	 * @description
	 * Color Util
	 */
	angular
	  .module('material.core')
	  .factory('$mdColorUtil', ColorUtilFactory);
	
	function ColorUtilFactory() {
	  /**
	   * Converts hex value to RGBA string
	   * @param color {string}
	   * @returns {string}
	   */
	  function hexToRgba (color) {
	    var hex   = color[ 0 ] === '#' ? color.substr(1) : color,
	      dig   = hex.length / 3,
	      red   = hex.substr(0, dig),
	      green = hex.substr(dig, dig),
	      blue  = hex.substr(dig * 2);
	    if (dig === 1) {
	      red += red;
	      green += green;
	      blue += blue;
	    }
	    return 'rgba(' + parseInt(red, 16) + ',' + parseInt(green, 16) + ',' + parseInt(blue, 16) + ',0.1)';
	  }
	
	  /**
	   * Converts rgba value to hex string
	   * @param color {string}
	   * @returns {string}
	   */
	  function rgbaToHex(color) {
	    color = color.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
	
	    var hex = (color && color.length === 4) ? "#" +
	    ("0" + parseInt(color[1],10).toString(16)).slice(-2) +
	    ("0" + parseInt(color[2],10).toString(16)).slice(-2) +
	    ("0" + parseInt(color[3],10).toString(16)).slice(-2) : '';
	
	    return hex.toUpperCase();
	  }
	
	  /**
	   * Converts an RGB color to RGBA
	   * @param color {string}
	   * @returns {string}
	   */
	  function rgbToRgba (color) {
	    return color.replace(')', ', 0.1)').replace('(', 'a(');
	  }
	
	  /**
	   * Converts an RGBA color to RGB
	   * @param color {string}
	   * @returns {string}
	   */
	  function rgbaToRgb (color) {
	    return color
	      ? color.replace('rgba', 'rgb').replace(/,[^\),]+\)/, ')')
	      : 'rgb(0,0,0)';
	  }
	
	  return {
	    rgbaToHex: rgbaToHex,
	    hexToRgba: hexToRgba,
	    rgbToRgba: rgbToRgba,
	    rgbaToRgb: rgbaToRgb
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	angular.module('material.core')
	.factory('$mdConstant', MdConstantFactory);
	
	/**
	 * Factory function that creates the grab-bag $mdConstant service.
	 * @ngInject
	 */
	function MdConstantFactory() {
	
	  var prefixTestEl = document.createElement('div');
	  var vendorPrefix = getVendorPrefix(prefixTestEl);
	  var isWebkit = /webkit/i.test(vendorPrefix);
	  var SPECIAL_CHARS_REGEXP = /([:\-_]+(.))/g;
	
	  function vendorProperty(name) {
	    // Add a dash between the prefix and name, to be able to transform the string into camelcase.
	    var prefixedName = vendorPrefix + '-' + name;
	    var ucPrefix = camelCase(prefixedName);
	    var lcPrefix = ucPrefix.charAt(0).toLowerCase() + ucPrefix.substring(1);
	
	    return hasStyleProperty(prefixTestEl, name)     ? name     :       // The current browser supports the un-prefixed property
	           hasStyleProperty(prefixTestEl, ucPrefix) ? ucPrefix :       // The current browser only supports the prefixed property.
	           hasStyleProperty(prefixTestEl, lcPrefix) ? lcPrefix : name; // Some browsers are only supporting the prefix in lowercase.
	  }
	
	  function hasStyleProperty(testElement, property) {
	    return angular.isDefined(testElement.style[property]);
	  }
	
	  function camelCase(input) {
	    return input.replace(SPECIAL_CHARS_REGEXP, function(matches, separator, letter, offset) {
	      return offset ? letter.toUpperCase() : letter;
	    });
	  }
	
	  function getVendorPrefix(testElement) {
	    var prop, match;
	    var vendorRegex = /^(Moz|webkit|ms)(?=[A-Z])/;
	
	    for (prop in testElement.style) {
	      if (match = vendorRegex.exec(prop)) {
	        return match[0];
	      }
	    }
	  }
	
	  var self = {
	    isInputKey : function(e) { return (e.keyCode >= 31 && e.keyCode <= 90); },
	    isNumPadKey : function(e) { return (3 === e.location && e.keyCode >= 97 && e.keyCode <= 105); },
	    isMetaKey: function(e) { return (e.keyCode >= 91 && e.keyCode <= 93); },
	    isFnLockKey: function(e) { return (e.keyCode >= 112 && e.keyCode <= 145); },
	    isNavigationKey : function(e) {
	      var kc = self.KEY_CODE, NAVIGATION_KEYS =  [kc.SPACE, kc.ENTER, kc.UP_ARROW, kc.DOWN_ARROW];
	      return (NAVIGATION_KEYS.indexOf(e.keyCode) != -1);
	    },
	    hasModifierKey: function(e) {
	      return e.ctrlKey || e.metaKey || e.altKey;
	    },
	
	    /**
	     * Maximum size, in pixels, that can be explicitly set to an element. The actual value varies
	     * between browsers, but IE11 has the very lowest size at a mere 1,533,917px. Ideally we could
	     * compute this value, but Firefox always reports an element to have a size of zero if it
	     * goes over the max, meaning that we'd have to binary search for the value.
	     */
	    ELEMENT_MAX_PIXELS: 1533917,
	
	    /**
	     * Priority for a directive that should run before the directives from ngAria.
	     */
	    BEFORE_NG_ARIA: 210,
	
	    /**
	     * Common Keyboard actions and their associated keycode.
	     */
	    KEY_CODE: {
	      COMMA: 188,
	      SEMICOLON : 186,
	      ENTER: 13,
	      ESCAPE: 27,
	      SPACE: 32,
	      PAGE_UP: 33,
	      PAGE_DOWN: 34,
	      END: 35,
	      HOME: 36,
	      LEFT_ARROW : 37,
	      UP_ARROW : 38,
	      RIGHT_ARROW : 39,
	      DOWN_ARROW : 40,
	      TAB : 9,
	      BACKSPACE: 8,
	      DELETE: 46
	    },
	
	    /**
	     * Vendor prefixed CSS properties to be used to support the given functionality in older browsers
	     * as well.
	     */
	    CSS: {
	      /* Constants */
	      TRANSITIONEND: 'transitionend' + (isWebkit ? ' webkitTransitionEnd' : ''),
	      ANIMATIONEND: 'animationend' + (isWebkit ? ' webkitAnimationEnd' : ''),
	
	      TRANSFORM: vendorProperty('transform'),
	      TRANSFORM_ORIGIN: vendorProperty('transformOrigin'),
	      TRANSITION: vendorProperty('transition'),
	      TRANSITION_DURATION: vendorProperty('transitionDuration'),
	      ANIMATION_PLAY_STATE: vendorProperty('animationPlayState'),
	      ANIMATION_DURATION: vendorProperty('animationDuration'),
	      ANIMATION_NAME: vendorProperty('animationName'),
	      ANIMATION_TIMING: vendorProperty('animationTimingFunction'),
	      ANIMATION_DIRECTION: vendorProperty('animationDirection')
	    },
	
	    /**
	     * As defined in core/style/variables.scss
	     *
	     * $layout-breakpoint-xs:     600px !default;
	     * $layout-breakpoint-sm:     960px !default;
	     * $layout-breakpoint-md:     1280px !default;
	     * $layout-breakpoint-lg:     1920px !default;
	     *
	     */
	    MEDIA: {
	      'xs'        : '(max-width: 599px)'                         ,
	      'gt-xs'     : '(min-width: 600px)'                         ,
	      'sm'        : '(min-width: 600px) and (max-width: 959px)'  ,
	      'gt-sm'     : '(min-width: 960px)'                         ,
	      'md'        : '(min-width: 960px) and (max-width: 1279px)' ,
	      'gt-md'     : '(min-width: 1280px)'                        ,
	      'lg'        : '(min-width: 1280px) and (max-width: 1919px)',
	      'gt-lg'     : '(min-width: 1920px)'                        ,
	      'xl'        : '(min-width: 1920px)'                        ,
	      'landscape' : '(orientation: landscape)'                   ,
	      'portrait'  : '(orientation: portrait)'                    ,
	      'print' : 'print'
	    },
	
	    MEDIA_PRIORITY: [
	      'xl',
	      'gt-lg',
	      'lg',
	      'gt-md',
	      'md',
	      'gt-sm',
	      'sm',
	      'gt-xs',
	      'xs',
	      'landscape',
	      'portrait',
	      'print'
	    ]
	  };
	
	  return self;
	}
	
	})();
	(function(){
	"use strict";
	
	  angular
	    .module('material.core')
	    .config( ["$provide", function($provide){
	       $provide.decorator('$mdUtil', ['$delegate', function ($delegate){
	           /**
	            * Inject the iterator facade to easily support iteration and accessors
	            * @see iterator below
	            */
	           $delegate.iterator = MdIterator;
	
	           return $delegate;
	         }
	       ]);
	     }]);
	
	  /**
	   * iterator is a list facade to easily support iteration and accessors
	   *
	   * @param items Array list which this iterator will enumerate
	   * @param reloop Boolean enables iterator to consider the list as an endless reloop
	   */
	  function MdIterator(items, reloop) {
	    var trueFn = function() { return true; };
	
	    if (items && !angular.isArray(items)) {
	      items = Array.prototype.slice.call(items);
	    }
	
	    reloop = !!reloop;
	    var _items = items || [ ];
	
	    // Published API
	    return {
	      items: getItems,
	      count: count,
	
	      inRange: inRange,
	      contains: contains,
	      indexOf: indexOf,
	      itemAt: itemAt,
	
	      findBy: findBy,
	
	      add: add,
	      remove: remove,
	
	      first: first,
	      last: last,
	      next: angular.bind(null, findSubsequentItem, false),
	      previous: angular.bind(null, findSubsequentItem, true),
	
	      hasPrevious: hasPrevious,
	      hasNext: hasNext
	
	    };
	
	    /**
	     * Publish copy of the enumerable set
	     * @returns {Array|*}
	     */
	    function getItems() {
	      return [].concat(_items);
	    }
	
	    /**
	     * Determine length of the list
	     * @returns {Array.length|*|number}
	     */
	    function count() {
	      return _items.length;
	    }
	
	    /**
	     * Is the index specified valid
	     * @param index
	     * @returns {Array.length|*|number|boolean}
	     */
	    function inRange(index) {
	      return _items.length && ( index > -1 ) && (index < _items.length );
	    }
	
	    /**
	     * Can the iterator proceed to the next item in the list; relative to
	     * the specified item.
	     *
	     * @param item
	     * @returns {Array.length|*|number|boolean}
	     */
	    function hasNext(item) {
	      return item ? inRange(indexOf(item) + 1) : false;
	    }
	
	    /**
	     * Can the iterator proceed to the previous item in the list; relative to
	     * the specified item.
	     *
	     * @param item
	     * @returns {Array.length|*|number|boolean}
	     */
	    function hasPrevious(item) {
	      return item ? inRange(indexOf(item) - 1) : false;
	    }
	
	    /**
	     * Get item at specified index/position
	     * @param index
	     * @returns {*}
	     */
	    function itemAt(index) {
	      return inRange(index) ? _items[index] : null;
	    }
	
	    /**
	     * Find all elements matching the key/value pair
	     * otherwise return null
	     *
	     * @param val
	     * @param key
	     *
	     * @return array
	     */
	    function findBy(key, val) {
	      return _items.filter(function(item) {
	        return item[key] === val;
	      });
	    }
	
	    /**
	     * Add item to list
	     * @param item
	     * @param index
	     * @returns {*}
	     */
	    function add(item, index) {
	      if ( !item ) return -1;
	
	      if (!angular.isNumber(index)) {
	        index = _items.length;
	      }
	
	      _items.splice(index, 0, item);
	
	      return indexOf(item);
	    }
	
	    /**
	     * Remove item from list...
	     * @param item
	     */
	    function remove(item) {
	      if ( contains(item) ){
	        _items.splice(indexOf(item), 1);
	      }
	    }
	
	    /**
	     * Get the zero-based index of the target item
	     * @param item
	     * @returns {*}
	     */
	    function indexOf(item) {
	      return _items.indexOf(item);
	    }
	
	    /**
	     * Boolean existence check
	     * @param item
	     * @returns {boolean}
	     */
	    function contains(item) {
	      return item && (indexOf(item) > -1);
	    }
	
	    /**
	     * Return first item in the list
	     * @returns {*}
	     */
	    function first() {
	      return _items.length ? _items[0] : null;
	    }
	
	    /**
	     * Return last item in the list...
	     * @returns {*}
	     */
	    function last() {
	      return _items.length ? _items[_items.length - 1] : null;
	    }
	
	    /**
	     * Find the next item. If reloop is true and at the end of the list, it will go back to the
	     * first item. If given, the `validate` callback will be used to determine whether the next item
	     * is valid. If not valid, it will try to find the next item again.
	     *
	     * @param {boolean} backwards Specifies the direction of searching (forwards/backwards)
	     * @param {*} item The item whose subsequent item we are looking for
	     * @param {Function=} validate The `validate` function
	     * @param {integer=} limit The recursion limit
	     *
	     * @returns {*} The subsequent item or null
	     */
	    function findSubsequentItem(backwards, item, validate, limit) {
	      validate = validate || trueFn;
	
	      var curIndex = indexOf(item);
	      while (true) {
	        if (!inRange(curIndex)) return null;
	
	        var nextIndex = curIndex + (backwards ? -1 : 1);
	        var foundItem = null;
	        if (inRange(nextIndex)) {
	          foundItem = _items[nextIndex];
	        } else if (reloop) {
	          foundItem = backwards ? last() : first();
	          nextIndex = indexOf(foundItem);
	        }
	
	        if ((foundItem === null) || (nextIndex === limit)) return null;
	        if (validate(foundItem)) return foundItem;
	
	        if (angular.isUndefined(limit)) limit = nextIndex;
	
	        curIndex = nextIndex;
	      }
	    }
	  }
	
	
	})();
	(function(){
	"use strict";
	
	
	mdMediaFactory.$inject = ["$mdConstant", "$rootScope", "$window"];angular.module('material.core')
	.factory('$mdMedia', mdMediaFactory);
	
	/**
	 * @ngdoc service
	 * @name $mdMedia
	 * @module material.core
	 *
	 * @description
	 * `$mdMedia` is used to evaluate whether a given media query is true or false given the
	 * current device's screen / window size. The media query will be re-evaluated on resize, allowing
	 * you to register a watch.
	 *
	 * `$mdMedia` also has pre-programmed support for media queries that match the layout breakpoints:
	 *
	 *  <table class="md-api-table">
	 *    <thead>
	 *    <tr>
	 *      <th>Breakpoint</th>
	 *      <th>mediaQuery</th>
	 *    </tr>
	 *    </thead>
	 *    <tbody>
	 *    <tr>
	 *      <td>xs</td>
	 *      <td>(max-width: 599px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>gt-xs</td>
	 *      <td>(min-width: 600px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>sm</td>
	 *      <td>(min-width: 600px) and (max-width: 959px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>gt-sm</td>
	 *      <td>(min-width: 960px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>md</td>
	 *      <td>(min-width: 960px) and (max-width: 1279px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>gt-md</td>
	 *      <td>(min-width: 1280px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>lg</td>
	 *      <td>(min-width: 1280px) and (max-width: 1919px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>gt-lg</td>
	 *      <td>(min-width: 1920px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>xl</td>
	 *      <td>(min-width: 1920px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>landscape</td>
	 *      <td>landscape</td>
	 *    </tr>
	 *    <tr>
	 *      <td>portrait</td>
	 *      <td>portrait</td>
	 *    </tr>
	 *    <tr>
	 *      <td>print</td>
	 *      <td>print</td>
	 *    </tr>
	 *    </tbody>
	 *  </table>
	 *
	 *  See Material Design's <a href="https://material.google.com/layout/responsive-ui.html">Layout - Adaptive UI</a> for more details.
	 *
	 *  <a href="https://www.google.com/design/spec/layout/adaptive-ui.html">
	 *  <img src="https://material-design.storage.googleapis.com/publish/material_v_4/material_ext_publish/0B8olV15J7abPSGFxemFiQVRtb1k/layout_adaptive_breakpoints_01.png" width="100%" height="100%"></img>
	 *  </a>
	 *
	 * @returns {boolean} a boolean representing whether or not the given media query is true or false.
	 *
	 * @usage
	 * <hljs lang="js">
	 * app.controller('MyController', function($mdMedia, $scope) {
	 *   $scope.$watch(function() { return $mdMedia('lg'); }, function(big) {
	 *     $scope.bigScreen = big;
	 *   });
	 *
	 *   $scope.screenIsSmall = $mdMedia('sm');
	 *   $scope.customQuery = $mdMedia('(min-width: 1234px)');
	 *   $scope.anotherCustom = $mdMedia('max-width: 300px');
	 * });
	 * </hljs>
	 */
	
	/* @ngInject */
	function mdMediaFactory($mdConstant, $rootScope, $window) {
	  var queries = {};
	  var mqls = {};
	  var results = {};
	  var normalizeCache = {};
	
	  $mdMedia.getResponsiveAttribute = getResponsiveAttribute;
	  $mdMedia.getQuery = getQuery;
	  $mdMedia.watchResponsiveAttributes = watchResponsiveAttributes;
	
	  return $mdMedia;
	
	  function $mdMedia(query) {
	    var validated = queries[query];
	    if (angular.isUndefined(validated)) {
	      validated = queries[query] = validate(query);
	    }
	
	    var result = results[validated];
	    if (angular.isUndefined(result)) {
	      result = add(validated);
	    }
	
	    return result;
	  }
	
	  function validate(query) {
	    return $mdConstant.MEDIA[query] ||
	           ((query.charAt(0) !== '(') ? ('(' + query + ')') : query);
	  }
	
	  function add(query) {
	    var result = mqls[query];
	    if ( !result ) {
	      result = mqls[query] = $window.matchMedia(query);
	    }
	
	    result.addListener(onQueryChange);
	    return (results[result.media] = !!result.matches);
	  }
	
	  function onQueryChange(query) {
	    $rootScope.$evalAsync(function() {
	      results[query.media] = !!query.matches;
	    });
	  }
	
	  function getQuery(name) {
	    return mqls[name];
	  }
	
	  function getResponsiveAttribute(attrs, attrName) {
	    for (var i = 0; i < $mdConstant.MEDIA_PRIORITY.length; i++) {
	      var mediaName = $mdConstant.MEDIA_PRIORITY[i];
	      if (!mqls[queries[mediaName]].matches) {
	        continue;
	      }
	
	      var normalizedName = getNormalizedName(attrs, attrName + '-' + mediaName);
	      if (attrs[normalizedName]) {
	        return attrs[normalizedName];
	      }
	    }
	
	    // fallback on unprefixed
	    return attrs[getNormalizedName(attrs, attrName)];
	  }
	
	  function watchResponsiveAttributes(attrNames, attrs, watchFn) {
	    var unwatchFns = [];
	    attrNames.forEach(function(attrName) {
	      var normalizedName = getNormalizedName(attrs, attrName);
	      if (angular.isDefined(attrs[normalizedName])) {
	        unwatchFns.push(
	            attrs.$observe(normalizedName, angular.bind(void 0, watchFn, null)));
	      }
	
	      for (var mediaName in $mdConstant.MEDIA) {
	        normalizedName = getNormalizedName(attrs, attrName + '-' + mediaName);
	        if (angular.isDefined(attrs[normalizedName])) {
	          unwatchFns.push(
	              attrs.$observe(normalizedName, angular.bind(void 0, watchFn, mediaName)));
	        }
	      }
	    });
	
	    return function unwatch() {
	      unwatchFns.forEach(function(fn) { fn(); });
	    };
	  }
	
	  // Improves performance dramatically
	  function getNormalizedName(attrs, attrName) {
	    return normalizeCache[attrName] ||
	        (normalizeCache[attrName] = attrs.$normalize(attrName));
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	angular
	  .module('material.core')
	  .config( ["$provide", function($provide) {
	    $provide.decorator('$mdUtil', ['$delegate', function ($delegate) {
	
	      // Inject the prefixer into our original $mdUtil service.
	      $delegate.prefixer = MdPrefixer;
	
	      return $delegate;
	    }]);
	  }]);
	
	function MdPrefixer(initialAttributes, buildSelector) {
	  var PREFIXES = ['data', 'x'];
	
	  if (initialAttributes) {
	    // The prefixer also accepts attributes as a parameter, and immediately builds a list or selector for
	    // the specified attributes.
	    return buildSelector ? _buildSelector(initialAttributes) : _buildList(initialAttributes);
	  }
	
	  return {
	    buildList: _buildList,
	    buildSelector: _buildSelector,
	    hasAttribute: _hasAttribute,
	    removeAttribute: _removeAttribute
	  };
	
	  function _buildList(attributes) {
	    attributes = angular.isArray(attributes) ? attributes : [attributes];
	
	    attributes.forEach(function(item) {
	      PREFIXES.forEach(function(prefix) {
	        attributes.push(prefix + '-' + item);
	      });
	    });
	
	    return attributes;
	  }
	
	  function _buildSelector(attributes) {
	    attributes = angular.isArray(attributes) ? attributes : [attributes];
	
	    return _buildList(attributes)
	      .map(function(item) {
	        return '[' + item + ']';
	      })
	      .join(',');
	  }
	
	  function _hasAttribute(element, attribute) {
	    element = _getNativeElement(element);
	
	    if (!element) {
	      return false;
	    }
	
	    var prefixedAttrs = _buildList(attribute);
	
	    for (var i = 0; i < prefixedAttrs.length; i++) {
	      if (element.hasAttribute(prefixedAttrs[i])) {
	        return true;
	      }
	    }
	
	    return false;
	  }
	
	  function _removeAttribute(element, attribute) {
	    element = _getNativeElement(element);
	
	    if (!element) {
	      return;
	    }
	
	    _buildList(attribute).forEach(function(prefixedAttribute) {
	      element.removeAttribute(prefixedAttribute);
	    });
	  }
	
	  /**
	   * Transforms a jqLite or DOM element into a HTML element.
	   * This is useful when supporting jqLite elements and DOM elements at
	   * same time.
	   * @param element {JQLite|Element} Element to be parsed
	   * @returns {HTMLElement} Parsed HTMLElement
	   */
	  function _getNativeElement(element) {
	    element =  element[0] || element;
	
	    if (element.nodeType) {
	      return element;
	    }
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/*
	 * This var has to be outside the angular factory, otherwise when
	 * there are multiple material apps on the same page, each app
	 * will create its own instance of this array and the app's IDs
	 * will not be unique.
	 */
	UtilFactory.$inject = ["$document", "$timeout", "$compile", "$rootScope", "$$mdAnimate", "$interpolate", "$log", "$rootElement", "$window", "$$rAF"];
	var nextUniqueId = 0;
	
	/**
	 * @ngdoc module
	 * @name material.core.util
	 * @description
	 * Util
	 */
	angular
	  .module('material.core')
	  .factory('$mdUtil', UtilFactory);
	
	/**
	 * @ngInject
	 */
	function UtilFactory($document, $timeout, $compile, $rootScope, $$mdAnimate, $interpolate, $log, $rootElement, $window, $$rAF) {
	  // Setup some core variables for the processTemplate method
	  var startSymbol = $interpolate.startSymbol(),
	    endSymbol = $interpolate.endSymbol(),
	    usesStandardSymbols = ((startSymbol === '{{') && (endSymbol === '}}'));
	
	  /**
	   * Checks if the target element has the requested style by key
	   * @param {DOMElement|JQLite} target Target element
	   * @param {string} key Style key
	   * @param {string=} expectedVal Optional expected value
	   * @returns {boolean} Whether the target element has the style or not
	   */
	  var hasComputedStyle = function (target, key, expectedVal) {
	    var hasValue = false;
	
	    if ( target && target.length  ) {
	      var computedStyles = $window.getComputedStyle(target[0]);
	      hasValue = angular.isDefined(computedStyles[key]) && (expectedVal ? computedStyles[key] == expectedVal : true);
	    }
	
	    return hasValue;
	  };
	
	  function validateCssValue(value) {
	    return !value       ? '0'   :
	      hasPx(value) || hasPercent(value) ? value : value + 'px';
	  }
	
	  function hasPx(value) {
	    return String(value).indexOf('px') > -1;
	  }
	
	  function hasPercent(value) {
	    return String(value).indexOf('%') > -1;
	
	  }
	
	  var $mdUtil = {
	    dom: {},
	    now: window.performance && window.performance.now ?
	      angular.bind(window.performance, window.performance.now) : Date.now || function() {
	      return new Date().getTime();
	    },
	
	    /**
	     * Cross-version compatibility method to retrieve an option of a ngModel controller,
	     * which supports the breaking changes in the AngularJS snapshot (SHA 87a2ff76af5d0a9268d8eb84db5755077d27c84c).
	     * @param {!angular.ngModelCtrl} ngModelCtrl
	     * @param {!string} optionName
	     * @returns {Object|undefined}
	     */
	    getModelOption: function (ngModelCtrl, optionName) {
	      if (!ngModelCtrl.$options) {
	        return;
	      }
	
	      var $options = ngModelCtrl.$options;
	
	      // The newer versions of AngularJS introduced a `getOption function and made the option values no longer
	      // visible on the $options object.
	      return $options.getOption ? $options.getOption(optionName) : $options[optionName]
	    },
	
	    /**
	     * Bi-directional accessor/mutator used to easily update an element's
	     * property based on the current 'dir'ectional value.
	     */
	    bidi : function(element, property, lValue, rValue) {
	      var ltr = !($document[0].dir == 'rtl' || $document[0].body.dir == 'rtl');
	
	      // If accessor
	      if ( arguments.length == 0 ) return ltr ? 'ltr' : 'rtl';
	
	      // If mutator
	      var elem = angular.element(element);
	
	      if ( ltr && angular.isDefined(lValue)) {
	        elem.css(property, validateCssValue(lValue));
	      }
	      else if ( !ltr && angular.isDefined(rValue)) {
	        elem.css(property, validateCssValue(rValue) );
	      }
	    },
	
	    bidiProperty: function (element, lProperty, rProperty, value) {
	      var ltr = !($document[0].dir == 'rtl' || $document[0].body.dir == 'rtl');
	
	      var elem = angular.element(element);
	
	      if ( ltr && angular.isDefined(lProperty)) {
	        elem.css(lProperty, validateCssValue(value));
	        elem.css(rProperty, '');
	      }
	      else if ( !ltr && angular.isDefined(rProperty)) {
	        elem.css(rProperty, validateCssValue(value) );
	        elem.css(lProperty, '');
	      }
	    },
	
	    clientRect: function(element, offsetParent, isOffsetRect) {
	      var node = getNode(element);
	      offsetParent = getNode(offsetParent || node.offsetParent || document.body);
	      var nodeRect = node.getBoundingClientRect();
	
	      // The user can ask for an offsetRect: a rect relative to the offsetParent,
	      // or a clientRect: a rect relative to the page
	      var offsetRect = isOffsetRect ?
	        offsetParent.getBoundingClientRect() :
	      {left: 0, top: 0, width: 0, height: 0};
	      return {
	        left: nodeRect.left - offsetRect.left,
	        top: nodeRect.top - offsetRect.top,
	        width: nodeRect.width,
	        height: nodeRect.height
	      };
	    },
	    offsetRect: function(element, offsetParent) {
	      return $mdUtil.clientRect(element, offsetParent, true);
	    },
	
	    // Annoying method to copy nodes to an array, thanks to IE
	    nodesToArray: function(nodes) {
	      nodes = nodes || [];
	
	      var results = [];
	      for (var i = 0; i < nodes.length; ++i) {
	        results.push(nodes.item(i));
	      }
	      return results;
	    },
	
	    /**
	     * Determines the absolute position of the viewport.
	     * Useful when making client rectangles absolute.
	     * @returns {number}
	     */
	    getViewportTop: function() {
	      return window.scrollY || window.pageYOffset || 0;
	    },
	
	    /**
	     * Finds the proper focus target by searching the DOM.
	     *
	     * @param containerEl
	     * @param attributeVal
	     * @returns {*}
	     */
	    findFocusTarget: function(containerEl, attributeVal) {
	      var AUTO_FOCUS = this.prefixer('md-autofocus', true);
	      var elToFocus;
	
	      elToFocus = scanForFocusable(containerEl, attributeVal || AUTO_FOCUS);
	
	      if ( !elToFocus && attributeVal != AUTO_FOCUS) {
	        // Scan for deprecated attribute
	        elToFocus = scanForFocusable(containerEl, this.prefixer('md-auto-focus', true));
	
	        if ( !elToFocus ) {
	          // Scan for fallback to 'universal' API
	          elToFocus = scanForFocusable(containerEl, AUTO_FOCUS);
	        }
	      }
	
	      return elToFocus;
	
	      /**
	       * Can target and nested children for specified Selector (attribute)
	       * whose value may be an expression that evaluates to True/False.
	       */
	      function scanForFocusable(target, selector) {
	        var elFound, items = target[0].querySelectorAll(selector);
	
	        // Find the last child element with the focus attribute
	        if ( items && items.length ){
	          items.length && angular.forEach(items, function(it) {
	            it = angular.element(it);
	
	            // Check the element for the md-autofocus class to ensure any associated expression
	            // evaluated to true.
	            var isFocusable = it.hasClass('md-autofocus');
	            if (isFocusable) elFound = it;
	          });
	        }
	        return elFound;
	      }
	    },
	
	    /**
	     * Disables scroll around the passed parent element.
	     * @param element Unused
	     * @param {!Element|!angular.JQLite} parent Element to disable scrolling within.
	     *   Defaults to body if none supplied.
	     * @param options Object of options to modify functionality
	     *   - disableScrollMask Boolean of whether or not to create a scroll mask element or
	     *     use the passed parent element.
	     */
	    disableScrollAround: function(element, parent, options) {
	      options = options || {};
	
	      $mdUtil.disableScrollAround._count = Math.max(0, $mdUtil.disableScrollAround._count || 0);
	      $mdUtil.disableScrollAround._count++;
	
	      if ($mdUtil.disableScrollAround._restoreScroll) {
	        return $mdUtil.disableScrollAround._restoreScroll;
	      }
	
	      var body = $document[0].body;
	      var restoreBody = disableBodyScroll();
	      var restoreElement = disableElementScroll(parent);
	
	      return $mdUtil.disableScrollAround._restoreScroll = function() {
	        if (--$mdUtil.disableScrollAround._count <= 0) {
	          restoreBody();
	          restoreElement();
	          delete $mdUtil.disableScrollAround._restoreScroll;
	        }
	      };
	
	      /**
	       * Creates a virtual scrolling mask to prevent touchmove, keyboard, scrollbar clicking,
	       * and wheel events
	       */
	      function disableElementScroll(element) {
	        element = angular.element(element || body);
	
	        var scrollMask;
	
	        if (options.disableScrollMask) {
	          scrollMask = element;
	        } else {
	          scrollMask = angular.element(
	            '<div class="md-scroll-mask">' +
	            '  <div class="md-scroll-mask-bar"></div>' +
	            '</div>');
	          element.append(scrollMask);
	        }
	
	        scrollMask.on('wheel', preventDefault);
	        scrollMask.on('touchmove', preventDefault);
	
	        return function restoreElementScroll() {
	          scrollMask.off('wheel');
	          scrollMask.off('touchmove');
	
	          if (!options.disableScrollMask) {
	            scrollMask[0].parentNode.removeChild(scrollMask[0]);
	          }
	        };
	
	        function preventDefault(e) {
	          e.preventDefault();
	        }
	      }
	
	      // Converts the body to a position fixed block and translate it to the proper scroll position
	      function disableBodyScroll() {
	        var documentElement = $document[0].documentElement;
	
	        var prevDocumentStyle = documentElement.style.cssText || '';
	        var prevBodyStyle = body.style.cssText || '';
	
	        var viewportTop = $mdUtil.getViewportTop();
	        var clientWidth = body.clientWidth;
	        var hasVerticalScrollbar = body.scrollHeight > body.clientHeight + 1;
	
	        if (hasVerticalScrollbar) {
	          angular.element(body).css({
	            position: 'fixed',
	            width: '100%',
	            top: -viewportTop + 'px'
	          });
	        }
	
	        if (body.clientWidth < clientWidth) {
	          body.style.overflow = 'hidden';
	        }
	
	        // This should be applied after the manipulation to the body, because
	        // adding a scrollbar can potentially resize it, causing the measurement
	        // to change.
	        if (hasVerticalScrollbar) {
	          documentElement.style.overflowY = 'scroll';
	        }
	
	        return function restoreScroll() {
	          // Reset the inline style CSS to the previous.
	          body.style.cssText = prevBodyStyle;
	          documentElement.style.cssText = prevDocumentStyle;
	
	          // The body loses its scroll position while being fixed.
	          body.scrollTop = viewportTop;
	        };
	      }
	
	    },
	
	    enableScrolling: function() {
	      var restoreFn = this.disableScrollAround._restoreScroll;
	      restoreFn && restoreFn();
	    },
	
	    floatingScrollbars: function() {
	      if (this.floatingScrollbars.cached === undefined) {
	        var tempNode = angular.element('<div><div></div></div>').css({
	          width: '100%',
	          'z-index': -1,
	          position: 'absolute',
	          height: '35px',
	          'overflow-y': 'scroll'
	        });
	        tempNode.children().css('height', '60px');
	
	        $document[0].body.appendChild(tempNode[0]);
	        this.floatingScrollbars.cached = (tempNode[0].offsetWidth == tempNode[0].childNodes[0].offsetWidth);
	        tempNode.remove();
	      }
	      return this.floatingScrollbars.cached;
	    },
	
	    // Mobile safari only allows you to set focus in click event listeners...
	    forceFocus: function(element) {
	      var node = element[0] || element;
	
	      document.addEventListener('click', function focusOnClick(ev) {
	        if (ev.target === node && ev.$focus) {
	          node.focus();
	          ev.stopImmediatePropagation();
	          ev.preventDefault();
	          node.removeEventListener('click', focusOnClick);
	        }
	      }, true);
	
	      var newEvent = document.createEvent('MouseEvents');
	      newEvent.initMouseEvent('click', false, true, window, {}, 0, 0, 0, 0,
	        false, false, false, false, 0, null);
	      newEvent.$material = true;
	      newEvent.$focus = true;
	      node.dispatchEvent(newEvent);
	    },
	
	    /**
	     * facade to build md-backdrop element with desired styles
	     * NOTE: Use $compile to trigger backdrop postLink function
	     */
	    createBackdrop: function(scope, addClass) {
	      return $compile($mdUtil.supplant('<md-backdrop class="{0}">', [addClass]))(scope);
	    },
	
	    /**
	     * supplant() method from Crockford's `Remedial Javascript`
	     * Equivalent to use of $interpolate; without dependency on
	     * interpolation symbols and scope. Note: the '{<token>}' can
	     * be property names, property chains, or array indices.
	     */
	    supplant: function(template, values, pattern) {
	      pattern = pattern || /\{([^\{\}]*)\}/g;
	      return template.replace(pattern, function(a, b) {
	        var p = b.split('.'),
	          r = values;
	        try {
	          for (var s in p) {
	            if (p.hasOwnProperty(s) ) {
	              r = r[p[s]];
	            }
	          }
	        } catch (e) {
	          r = a;
	        }
	        return (typeof r === 'string' || typeof r === 'number') ? r : a;
	      });
	    },
	
	    fakeNgModel: function() {
	      return {
	        $fake: true,
	        $setTouched: angular.noop,
	        $setViewValue: function(value) {
	          this.$viewValue = value;
	          this.$render(value);
	          this.$viewChangeListeners.forEach(function(cb) {
	            cb();
	          });
	        },
	        $isEmpty: function(value) {
	          return ('' + value).length === 0;
	        },
	        $parsers: [],
	        $formatters: [],
	        $viewChangeListeners: [],
	        $render: angular.noop
	      };
	    },
	
	    // Returns a function, that, as long as it continues to be invoked, will not
	    // be triggered. The function will be called after it stops being called for
	    // N milliseconds.
	    // @param wait Integer value of msecs to delay (since last debounce reset); default value 10 msecs
	    // @param invokeApply should the $timeout trigger $digest() dirty checking
	    debounce: function(func, wait, scope, invokeApply) {
	      var timer;
	
	      return function debounced() {
	        var context = scope,
	          args = Array.prototype.slice.call(arguments);
	
	        $timeout.cancel(timer);
	        timer = $timeout(function() {
	
	          timer = undefined;
	          func.apply(context, args);
	
	        }, wait || 10, invokeApply);
	      };
	    },
	
	    // Returns a function that can only be triggered every `delay` milliseconds.
	    // In other words, the function will not be called unless it has been more
	    // than `delay` milliseconds since the last call.
	    throttle: function throttle(func, delay) {
	      var recent;
	      return function throttled() {
	        var context = this;
	        var args = arguments;
	        var now = $mdUtil.now();
	
	        if (!recent || (now - recent > delay)) {
	          func.apply(context, args);
	          recent = now;
	        }
	      };
	    },
	
	    /**
	     * Measures the number of milliseconds taken to run the provided callback
	     * function. Uses a high-precision timer if available.
	     */
	    time: function time(cb) {
	      var start = $mdUtil.now();
	      cb();
	      return $mdUtil.now() - start;
	    },
	
	    /**
	     * Create an implicit getter that caches its `getter()`
	     * lookup value
	     */
	    valueOnUse : function (scope, key, getter) {
	      var value = null, args = Array.prototype.slice.call(arguments);
	      var params = (args.length > 3) ? args.slice(3) : [ ];
	
	      Object.defineProperty(scope, key, {
	        get: function () {
	          if (value === null) value = getter.apply(scope, params);
	          return value;
	        }
	      });
	    },
	
	    /**
	     * Get a unique ID.
	     *
	     * @returns {string} an unique numeric string
	     */
	    nextUid: function() {
	      return '' + nextUniqueId++;
	    },
	
	    // Stop watchers and events from firing on a scope without destroying it,
	    // by disconnecting it from its parent and its siblings' linked lists.
	    disconnectScope: function disconnectScope(scope) {
	      if (!scope) return;
	
	      // we can't destroy the root scope or a scope that has been already destroyed
	      if (scope.$root === scope) return;
	      if (scope.$$destroyed) return;
	
	      var parent = scope.$parent;
	      scope.$$disconnected = true;
	
	      // See Scope.$destroy
	      if (parent.$$childHead === scope) parent.$$childHead = scope.$$nextSibling;
	      if (parent.$$childTail === scope) parent.$$childTail = scope.$$prevSibling;
	      if (scope.$$prevSibling) scope.$$prevSibling.$$nextSibling = scope.$$nextSibling;
	      if (scope.$$nextSibling) scope.$$nextSibling.$$prevSibling = scope.$$prevSibling;
	
	      scope.$$nextSibling = scope.$$prevSibling = null;
	
	    },
	
	    // Undo the effects of disconnectScope above.
	    reconnectScope: function reconnectScope(scope) {
	      if (!scope) return;
	
	      // we can't disconnect the root node or scope already disconnected
	      if (scope.$root === scope) return;
	      if (!scope.$$disconnected) return;
	
	      var child = scope;
	
	      var parent = child.$parent;
	      child.$$disconnected = false;
	      // See Scope.$new for this logic...
	      child.$$prevSibling = parent.$$childTail;
	      if (parent.$$childHead) {
	        parent.$$childTail.$$nextSibling = child;
	        parent.$$childTail = child;
	      } else {
	        parent.$$childHead = parent.$$childTail = child;
	      }
	    },
	
	    /*
	     * getClosest replicates jQuery.closest() to walk up the DOM tree until it finds a matching nodeName
	     *
	     * @param el Element to start walking the DOM from
	     * @param check Either a string or a function. If a string is passed, it will be evaluated against
	     * each of the parent nodes' tag name. If a function is passed, the loop will call it with each of
	     * the parents and will use the return value to determine whether the node is a match.
	     * @param onlyParent Only start checking from the parent element, not `el`.
	     */
	    getClosest: function getClosest(el, validateWith, onlyParent) {
	      if ( angular.isString(validateWith) ) {
	        var tagName = validateWith.toUpperCase();
	        validateWith = function(el) {
	          return el.nodeName.toUpperCase() === tagName;
	        };
	      }
	
	      if (el instanceof angular.element) el = el[0];
	      if (onlyParent) el = el.parentNode;
	      if (!el) return null;
	
	      do {
	        if (validateWith(el)) {
	          return el;
	        }
	      } while (el = el.parentNode);
	
	      return null;
	    },
	
	    /**
	     * Build polyfill for the Node.contains feature (if needed)
	     */
	    elementContains: function(node, child) {
	      var hasContains = (window.Node && window.Node.prototype && Node.prototype.contains);
	      var findFn = hasContains ? angular.bind(node, node.contains) : angular.bind(node, function(arg) {
	        // compares the positions of two nodes and returns a bitmask
	        return (node === child) || !!(this.compareDocumentPosition(arg) & 16)
	      });
	
	      return findFn(child);
	    },
	
	    /**
	     * Functional equivalent for $element.filter(‘md-bottom-sheet’)
	     * useful with interimElements where the element and its container are important...
	     *
	     * @param {[]} elements to scan
	     * @param {string} name of node to find (e.g. 'md-dialog')
	     * @param {boolean=} optional flag to allow deep scans; defaults to 'false'.
	     * @param {boolean=} optional flag to enable log warnings; defaults to false
	     */
	    extractElementByName: function(element, nodeName, scanDeep, warnNotFound) {
	      var found = scanTree(element);
	      if (!found && !!warnNotFound) {
	        $log.warn( $mdUtil.supplant("Unable to find node '{0}' in element '{1}'.",[nodeName, element[0].outerHTML]) );
	      }
	
	      return angular.element(found || element);
	
	      /**
	       * Breadth-First tree scan for element with matching `nodeName`
	       */
	      function scanTree(element) {
	        return scanLevel(element) || (!!scanDeep ? scanChildren(element) : null);
	      }
	
	      /**
	       * Case-insensitive scan of current elements only (do not descend).
	       */
	      function scanLevel(element) {
	        if ( element ) {
	          for (var i = 0, len = element.length; i < len; i++) {
	            if (element[i].nodeName.toLowerCase() === nodeName) {
	              return element[i];
	            }
	          }
	        }
	        return null;
	      }
	
	      /**
	       * Scan children of specified node
	       */
	      function scanChildren(element) {
	        var found;
	        if ( element ) {
	          for (var i = 0, len = element.length; i < len; i++) {
	            var target = element[i];
	            if ( !found ) {
	              for (var j = 0, numChild = target.childNodes.length; j < numChild; j++) {
	                found = found || scanTree([target.childNodes[j]]);
	              }
	            }
	          }
	        }
	        return found;
	      }
	
	    },
	
	    /**
	     * Give optional properties with no value a boolean true if attr provided or false otherwise
	     */
	    initOptionalProperties: function(scope, attr, defaults) {
	      defaults = defaults || {};
	      angular.forEach(scope.$$isolateBindings, function(binding, key) {
	        if (binding.optional && angular.isUndefined(scope[key])) {
	          var attrIsDefined = angular.isDefined(attr[binding.attrName]);
	          scope[key] = angular.isDefined(defaults[key]) ? defaults[key] : attrIsDefined;
	        }
	      });
	    },
	
	    /**
	     * Alternative to $timeout calls with 0 delay.
	     * nextTick() coalesces all calls within a single frame
	     * to minimize $digest thrashing
	     *
	     * @param callback
	     * @param digest
	     * @returns {*}
	     */
	    nextTick: function(callback, digest, scope) {
	      //-- grab function reference for storing state details
	      var nextTick = $mdUtil.nextTick;
	      var timeout = nextTick.timeout;
	      var queue = nextTick.queue || [];
	
	      //-- add callback to the queue
	      queue.push({scope: scope, callback: callback});
	
	      //-- set default value for digest
	      if (digest == null) digest = true;
	
	      //-- store updated digest/queue values
	      nextTick.digest = nextTick.digest || digest;
	      nextTick.queue = queue;
	
	      //-- either return existing timeout or create a new one
	      return timeout || (nextTick.timeout = $timeout(processQueue, 0, false));
	
	      /**
	       * Grab a copy of the current queue
	       * Clear the queue for future use
	       * Process the existing queue
	       * Trigger digest if necessary
	       */
	      function processQueue() {
	        var queue = nextTick.queue;
	        var digest = nextTick.digest;
	
	        nextTick.queue = [];
	        nextTick.timeout = null;
	        nextTick.digest = false;
	
	        queue.forEach(function(queueItem) {
	          var skip = queueItem.scope && queueItem.scope.$$destroyed;
	          if (!skip) {
	            queueItem.callback();
	          }
	        });
	
	        if (digest) $rootScope.$digest();
	      }
	    },
	
	    /**
	     * Processes a template and replaces the start/end symbols if the application has
	     * overriden them.
	     *
	     * @param template The template to process whose start/end tags may be replaced.
	     * @returns {*}
	     */
	    processTemplate: function(template) {
	      if (usesStandardSymbols) {
	        return template;
	      } else {
	        if (!template || !angular.isString(template)) return template;
	        return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
	      }
	    },
	
	    /**
	     * Scan up dom hierarchy for enabled parent;
	     */
	    getParentWithPointerEvents: function (element) {
	      var parent = element.parent();
	
	      // jqLite might return a non-null, but still empty, parent; so check for parent and length
	      while (hasComputedStyle(parent, 'pointer-events', 'none')) {
	        parent = parent.parent();
	      }
	
	      return parent;
	    },
	
	    getNearestContentElement: function (element) {
	      var current = element.parent()[0];
	      // Look for the nearest parent md-content, stopping at the rootElement.
	      while (current && current !== $rootElement[0] && current !== document.body && current.nodeName.toUpperCase() !== 'MD-CONTENT') {
	        current = current.parentNode;
	      }
	      return current;
	    },
	
	    /**
	     * Checks if the current browser is natively supporting the `sticky` position.
	     * @returns {string} supported sticky property name
	     */
	    checkStickySupport: function() {
	      var stickyProp;
	      var testEl = angular.element('<div>');
	      $document[0].body.appendChild(testEl[0]);
	
	      var stickyProps = ['sticky', '-webkit-sticky'];
	      for (var i = 0; i < stickyProps.length; ++i) {
	        testEl.css({
	          position: stickyProps[i],
	          top: 0,
	          'z-index': 2
	        });
	
	        if (testEl.css('position') == stickyProps[i]) {
	          stickyProp = stickyProps[i];
	          break;
	        }
	      }
	
	      testEl.remove();
	
	      return stickyProp;
	    },
	
	    /**
	     * Parses an attribute value, mostly a string.
	     * By default checks for negated values and returns `false´ if present.
	     * Negated values are: (native falsy) and negative strings like:
	     * `false` or `0`.
	     * @param value Attribute value which should be parsed.
	     * @param negatedCheck When set to false, won't check for negated values.
	     * @returns {boolean}
	     */
	    parseAttributeBoolean: function(value, negatedCheck) {
	      return value === '' || !!value && (negatedCheck === false || value !== 'false' && value !== '0');
	    },
	
	    hasComputedStyle: hasComputedStyle,
	
	    /**
	     * Returns true if the parent form of the element has been submitted.
	     *
	     * @param element An AngularJS or HTML5 element.
	     *
	     * @returns {boolean}
	     */
	    isParentFormSubmitted: function(element) {
	      var parent = $mdUtil.getClosest(element, 'form');
	      var form = parent ? angular.element(parent).controller('form') : null;
	
	      return form ? form.$submitted : false;
	    },
	
	    /**
	     * Animate the requested element's scrollTop to the requested scrollPosition with basic easing.
	     *
	     * @param {!HTMLElement} element The element to scroll.
	     * @param {number} scrollEnd The new/final scroll position.
	     * @param {number=} duration Duration of the scroll. Default is 1000ms.
	     */
	    animateScrollTo: function(element, scrollEnd, duration) {
	      var scrollStart = element.scrollTop;
	      var scrollChange = scrollEnd - scrollStart;
	      var scrollingDown = scrollStart < scrollEnd;
	      var startTime = $mdUtil.now();
	
	      $$rAF(scrollChunk);
	
	      function scrollChunk() {
	        var newPosition = calculateNewPosition();
	
	        element.scrollTop = newPosition;
	
	        if (scrollingDown ? newPosition < scrollEnd : newPosition > scrollEnd) {
	          $$rAF(scrollChunk);
	        }
	      }
	
	      function calculateNewPosition() {
	        var easeDuration = duration || 1000;
	        var currentTime = $mdUtil.now() - startTime;
	
	        return ease(currentTime, scrollStart, scrollChange, easeDuration);
	      }
	
	      function ease(currentTime, start, change, duration) {
	        // If the duration has passed (which can occur if our app loses focus due to $$rAF), jump
	        // straight to the proper position
	        if (currentTime > duration) {
	          return start + change;
	        }
	
	        var ts = (currentTime /= duration) * currentTime;
	        var tc = ts * currentTime;
	
	        return start + change * (-2 * tc + 3 * ts);
	      }
	    },
	
	    /**
	     * Provides an easy mechanism for removing duplicates from an array.
	     *
	     *    var myArray = [1, 2, 2, 3, 3, 3, 4, 4, 4, 4];
	     *
	     *    $mdUtil.uniq(myArray) => [1, 2, 3, 4]
	     *
	     * @param {array} array The array whose unique values should be returned.
	     *
	     * @returns {array} A copy of the array containing only unique values.
	     */
	    uniq: function(array) {
	      if (!array) { return; }
	
	      return array.filter(function(value, index, self) {
	        return self.indexOf(value) === index;
	      });
	    }
	  };
	
	
	// Instantiate other namespace utility methods
	
	  $mdUtil.dom.animator = $$mdAnimate($mdUtil);
	
	  return $mdUtil;
	
	  function getNode(el) {
	    return el[0] || el;
	  }
	
	}
	
	/*
	 * Since removing jQuery from the demos, some code that uses `element.focus()` is broken.
	 * We need to add `element.focus()`, because it's testable unlike `element[0].focus`.
	 */
	
	angular.element.prototype.focus = angular.element.prototype.focus || function() {
	    if (this.length) {
	      this[0].focus();
	    }
	    return this;
	  };
	angular.element.prototype.blur = angular.element.prototype.blur || function() {
	    if (this.length) {
	      this[0].blur();
	    }
	    return this;
	  };
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.core.compiler
	 * @description
	 * AngularJS Material template and element compiler.
	 */
	MdCompilerService.$inject = ["$q", "$templateRequest", "$injector", "$compile", "$controller"];
	angular
	  .module('material.core')
	  .service('$mdCompiler', MdCompilerService);
	
	/**
	 * @ngdoc service
	 * @name $mdCompiler
	 * @module material.core.compiler
	 * @description
	 * The $mdCompiler service is an abstraction of AngularJS's compiler, that allows developers
	 * to easily compile an element with options like in a Directive Definition Object.
	 *
	 * > The compiler powers a lot of components inside of AngularJS Material.
	 * > Like the `$mdPanel` or `$mdDialog`.
	 *
	 * @usage
	 *
	 * Basic Usage with a template
	 *
	 * <hljs lang="js">
	 *   $mdCompiler.compile({
	 *     templateUrl: 'modal.html',
	 *     controller: 'ModalCtrl',
	 *     locals: {
	 *       modal: myModalInstance;
	 *     }
	 *   }).then(function (compileData) {
	 *     compileData.element; // Compiled DOM element
	 *     compileData.link(myScope); // Instantiate controller and link element to scope.
	 *   });
	 * </hljs>
	 *
	 * Example with a content element
	 *
	 * <hljs lang="js">
	 *
	 *   // Create a virtual element and link it manually.
	 *   // The compiler doesn't need to recompile the element each time.
	 *   var myElement = $compile('<span>Test</span>')(myScope);
	 *
	 *   $mdCompiler.compile({
	 *     contentElement: myElement
	 *   }).then(function (compileData) {
	 *     compileData.element // Content Element (same as above)
	 *     compileData.link // This does nothing when using a contentElement.
	 *   });
	 * </hljs>
	 *
	 * > Content Element is a significant performance improvement when the developer already knows that the
	 * > compiled element will be always the same and the scope will not change either.
	 *
	 * The `contentElement` option also supports DOM elements which will be temporary removed and restored
	 * at its old position.
	 *
	 * <hljs lang="js">
	 *   var domElement = document.querySelector('#myElement');
	 *
	 *   $mdCompiler.compile({
	 *     contentElement: myElement
	 *   }).then(function (compileData) {
	 *     compileData.element // Content Element (same as above)
	 *     compileData.link // This does nothing when using a contentElement.
	 *   });
	 * </hljs>
	 *
	 * The `$mdCompiler` can also query for the element in the DOM itself.
	 *
	 * <hljs lang="js">
	 *   $mdCompiler.compile({
	 *     contentElement: '#myElement'
	 *   }).then(function (compileData) {
	 *     compileData.element // Content Element (same as above)
	 *     compileData.link // This does nothing when using a contentElement.
	 *   });
	 * </hljs>
	 *
	 */
	function MdCompilerService($q, $templateRequest, $injector, $compile, $controller) {
	  /** @private @const {!angular.$q} */
	  this.$q = $q;
	
	  /** @private @const {!angular.$templateRequest} */
	  this.$templateRequest = $templateRequest;
	
	  /** @private @const {!angular.$injector} */
	  this.$injector = $injector;
	
	  /** @private @const {!angular.$compile} */
	  this.$compile = $compile;
	
	  /** @private @const {!angular.$controller} */
	  this.$controller = $controller;
	}
	
	/**
	 * @ngdoc method
	 * @name $mdCompiler#compile
	 * @description
	 *
	 * A method to compile a HTML template with the AngularJS compiler.
	 * The `$mdCompiler` is wrapper around the AngularJS compiler and provides extra functionality
	 * like controller instantiation or async resolves.
	 *
	 * @param {!Object} options An options object, with the following properties:
	 *
	 *    - `controller` - `{string|Function}` Controller fn that should be associated with
	 *         newly created scope or the name of a registered controller if passed as a string.
	 *    - `controllerAs` - `{string=}` A controller alias name. If present the controller will be
	 *         published to scope under the `controllerAs` name.
	 *    - `contentElement` - `{string|Element}`: Instead of using a template, which will be
	 *         compiled each time, you can also use a DOM element.<br/>
	 *    - `template` - `{string=}` An html template as a string.
	 *    - `templateUrl` - `{string=}` A path to an html template.
	 *    - `transformTemplate` - `{function(template)=}` A function which transforms the template after
	 *        it is loaded. It will be given the template string as a parameter, and should
	 *        return a a new string representing the transformed template.
	 *    - `resolve` - `{Object.<string, function>=}` - An optional map of dependencies which should
	 *        be injected into the controller. If any of these dependencies are promises, the compiler
	 *        will wait for them all to be resolved, or if one is rejected before the controller is
	 *        instantiated `compile()` will fail..
	 *      * `key` - `{string}`: a name of a dependency to be injected into the controller.
	 *      * `factory` - `{string|function}`: If `string` then it is an alias for a service.
	 *        Otherwise if function, then it is injected and the return value is treated as the
	 *        dependency. If the result is a promise, it is resolved before its value is
	 *        injected into the controller.
	 *
	 * @returns {Object} promise A promise, which will be resolved with a `compileData` object.
	 * `compileData` has the following properties:
	 *
	 *   - `element` - `{element}`: an uncompiled element matching the provided template.
	 *   - `link` - `{function(scope)}`: A link function, which, when called, will compile
	 *     the element and instantiate the provided controller (if given).
	 *   - `locals` - `{object}`: The locals which will be passed into the controller once `link` is
	 *     called. If `bindToController` is true, they will be coppied to the ctrl instead
	 *
	 */
	MdCompilerService.prototype.compile = function(options) {
	
	  if (options.contentElement) {
	    return this._prepareContentElement(options);
	  } else {
	    return this._compileTemplate(options);
	  }
	
	};
	
	/**
	 * Instead of compiling any template, the compiler just fetches an existing HTML element from the DOM and
	 * provides a restore function to put the element back it old DOM position.
	 * @param {!Object} options Options to be used for the compiler.
	 * @private
	 */
	MdCompilerService.prototype._prepareContentElement = function(options) {
	
	  var contentElement = this._fetchContentElement(options);
	
	  return this.$q.resolve({
	    element: contentElement.element,
	    cleanup: contentElement.restore,
	    locals: {},
	    link: function() {
	      return contentElement.element;
	    }
	  });
	
	};
	
	/**
	 * Compiles a template by considering all options and waiting for all resolves to be ready.
	 * @param {!Object} options Compile options
	 * @returns {!Object} Compile data with link function.
	 * @private
	 */
	MdCompilerService.prototype._compileTemplate = function(options) {
	
	  var self = this;
	  var templateUrl = options.templateUrl;
	  var template = options.template || '';
	  var resolve = angular.extend({}, options.resolve);
	  var locals = angular.extend({}, options.locals);
	  var transformTemplate = options.transformTemplate || angular.identity;
	
	  // Take resolve values and invoke them.
	  // Resolves can either be a string (value: 'MyRegisteredAngularConst'),
	  // or an invokable 'factory' of sorts: (value: function ValueGetter($dependency) {})
	  angular.forEach(resolve, function(value, key) {
	    if (angular.isString(value)) {
	      resolve[key] = self.$injector.get(value);
	    } else {
	      resolve[key] = self.$injector.invoke(value);
	    }
	  });
	
	  // Add the locals, which are just straight values to inject
	  // eg locals: { three: 3 }, will inject three into the controller
	  angular.extend(resolve, locals);
	
	  if (templateUrl) {
	    resolve.$$ngTemplate = this.$templateRequest(templateUrl);
	  } else {
	    resolve.$$ngTemplate = this.$q.when(template);
	  }
	
	
	  // Wait for all the resolves to finish if they are promises
	  return this.$q.all(resolve).then(function(locals) {
	
	    var template = transformTemplate(locals.$$ngTemplate, options);
	    var element = options.element || angular.element('<div>').html(template.trim()).contents();
	
	    return self._compileElement(locals, element, options);
	  });
	
	};
	
	/**
	 * Method to compile an element with the given options.
	 * @param {!Object} locals Locals to be injected to the controller if present
	 * @param {!JQLite} element Element to be compiled and linked
	 * @param {!Object} options Options to be used for linking.
	 * @returns {!Object} Compile data with link function.
	 * @private
	 */
	MdCompilerService.prototype._compileElement = function(locals, element, options) {
	  var self = this;
	  var ngLinkFn = this.$compile(element);
	
	  var compileData = {
	    element: element,
	    cleanup: element.remove.bind(element),
	    locals: locals,
	    link: linkFn
	  };
	
	  function linkFn(scope) {
	    locals.$scope = scope;
	
	    // Instantiate controller if the developer provided one.
	    if (options.controller) {
	
	      var injectLocals = angular.extend(locals, {
	        $element: element
	      });
	
	      var invokeCtrl = self.$controller(options.controller, injectLocals, true, options.controllerAs);
	
	      if (options.bindToController) {
	        angular.extend(invokeCtrl.instance, locals);
	      }
	
	      var ctrl = invokeCtrl();
	
	      // Unique identifier for AngularJS Route ngView controllers.
	      element.data('$ngControllerController', ctrl);
	      element.children().data('$ngControllerController', ctrl);
	
	      // Expose the instantiated controller to the compile data
	      compileData.controller = ctrl;
	    }
	
	    // Invoke the AngularJS $compile link function.
	    return ngLinkFn(scope);
	  }
	
	  return compileData;
	
	};
	
	/**
	 * Fetches an element removing it from the DOM and using it temporary for the compiler.
	 * Elements which were fetched will be restored after use.
	 * @param {!Object} options Options to be used for the compilation.
	 * @returns {{element: !JQLite, restore: !Function}}
	 * @private
	 */
	MdCompilerService.prototype._fetchContentElement = function(options) {
	
	  var contentEl = options.contentElement;
	  var restoreFn = null;
	
	  if (angular.isString(contentEl)) {
	    contentEl = document.querySelector(contentEl);
	    restoreFn = createRestoreFn(contentEl);
	  } else {
	    contentEl = contentEl[0] || contentEl;
	
	    // When the element is visible in the DOM, then we restore it at close of the dialog.
	    // Otherwise it will be removed from the DOM after close.
	    if (document.contains(contentEl)) {
	      restoreFn = createRestoreFn(contentEl);
	    } else {
	      restoreFn = function() {
	        if (contentEl.parentNode) {
	          contentEl.parentNode.removeChild(contentEl);
	        }
	      }
	    }
	  }
	
	  return {
	    element: angular.element(contentEl),
	    restore: restoreFn
	  };
	
	  function createRestoreFn(element) {
	    var parent = element.parentNode;
	    var nextSibling = element.nextElementSibling;
	
	    return function() {
	      if (!nextSibling) {
	        // When the element didn't had any sibling, then it can be simply appended to the
	        // parent, because it plays no role, which index it had before.
	        parent.appendChild(element);
	      } else {
	        // When the element had a sibling, which marks the previous position of the element
	        // in the DOM, we insert it correctly before the sibling, to have the same index as
	        // before.
	        parent.insertBefore(element, nextSibling);
	      }
	    }
	  }
	};
	
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.core.aria
	 * @description
	 * Aria Expectations for AngularJS Material components.
	 */
	MdAriaService.$inject = ["$$rAF", "$log", "$window", "$interpolate"];
	angular
	  .module('material.core')
	  .provider('$mdAria', MdAriaProvider);
	
	/**
	 * @ngdoc service
	 * @name $mdAriaProvider
	 * @module material.core.aria
	 *
	 * @description
	 *
	 * Modify options of the `$mdAria` service, which will be used by most of the AngularJS Material
	 * components.
	 *
	 * You are able to disable `$mdAria` warnings, by using the following markup.
	 *
	 * <hljs lang="js">
	 *   app.config(function($mdAriaProvider) {
	 *     // Globally disables all ARIA warnings.
	 *     $mdAriaProvider.disableWarnings();
	 *   });
	 * </hljs>
	 *
	 */
	function MdAriaProvider() {
	
	  var config = {
	    /** Whether we should show ARIA warnings in the console if labels are missing on the element */
	    showWarnings: true
	  };
	
	  return {
	    disableWarnings: disableWarnings,
	    $get: ["$$rAF", "$log", "$window", "$interpolate", function($$rAF, $log, $window, $interpolate) {
	      return MdAriaService.apply(config, arguments);
	    }]
	  };
	
	  /**
	   * @ngdoc method
	   * @name $mdAriaProvider#disableWarnings
	   * @description Disables all ARIA warnings generated by AngularJS Material.
	   */
	  function disableWarnings() {
	    config.showWarnings = false;
	  }
	}
	
	/*
	 * @ngInject
	 */
	function MdAriaService($$rAF, $log, $window, $interpolate) {
	
	  // Load the showWarnings option from the current context and store it inside of a scope variable,
	  // because the context will be probably lost in some function calls.
	  var showWarnings = this.showWarnings;
	
	  return {
	    expect: expect,
	    expectAsync: expectAsync,
	    expectWithText: expectWithText,
	    expectWithoutText: expectWithoutText,
	    getText: getText,
	    hasAriaLabel: hasAriaLabel,
	    parentHasAriaLabel: parentHasAriaLabel
	  };
	
	  /**
	   * Check if expected attribute has been specified on the target element or child
	   * @param element
	   * @param attrName
	   * @param {optional} defaultValue What to set the attr to if no value is found
	   */
	  function expect(element, attrName, defaultValue) {
	
	    var node = angular.element(element)[0] || element;
	
	    // if node exists and neither it nor its children have the attribute
	    if (node &&
	       ((!node.hasAttribute(attrName) ||
	        node.getAttribute(attrName).length === 0) &&
	        !childHasAttribute(node, attrName))) {
	
	      defaultValue = angular.isString(defaultValue) ? defaultValue.trim() : '';
	      if (defaultValue.length) {
	        element.attr(attrName, defaultValue);
	      } else if (showWarnings) {
	        $log.warn('ARIA: Attribute "', attrName, '", required for accessibility, is missing on node:', node);
	      }
	
	    }
	  }
	
	  function expectAsync(element, attrName, defaultValueGetter) {
	    // Problem: when retrieving the element's contents synchronously to find the label,
	    // the text may not be defined yet in the case of a binding.
	    // There is a higher chance that a binding will be defined if we wait one frame.
	    $$rAF(function() {
	        expect(element, attrName, defaultValueGetter());
	    });
	  }
	
	  function expectWithText(element, attrName) {
	    var content = getText(element) || "";
	    var hasBinding = content.indexOf($interpolate.startSymbol()) > -1;
	
	    if (hasBinding) {
	      expectAsync(element, attrName, function() {
	        return getText(element);
	      });
	    } else {
	      expect(element, attrName, content);
	    }
	  }
	
	  function expectWithoutText(element, attrName) {
	    var content = getText(element);
	    var hasBinding = content.indexOf($interpolate.startSymbol()) > -1;
	
	    if ( !hasBinding && !content) {
	      expect(element, attrName, content);
	    }
	  }
	
	  function getText(element) {
	    element = element[0] || element;
	    var walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null, false);
	    var text = '';
	
	    var node;
	    while (node = walker.nextNode()) {
	      if (!isAriaHiddenNode(node)) {
	        text += node.textContent;
	      }
	    }
	
	    return text.trim() || '';
	
	    function isAriaHiddenNode(node) {
	      while (node.parentNode && (node = node.parentNode) !== element) {
	        if (node.getAttribute && node.getAttribute('aria-hidden') === 'true') {
	          return true;
	        }
	      }
	    }
	  }
	
	  function childHasAttribute(node, attrName) {
	    var hasChildren = node.hasChildNodes(),
	        hasAttr = false;
	
	    function isHidden(el) {
	      var style = el.currentStyle ? el.currentStyle : $window.getComputedStyle(el);
	      return (style.display === 'none');
	    }
	
	    if (hasChildren) {
	      var children = node.childNodes;
	      for (var i=0; i < children.length; i++) {
	        var child = children[i];
	        if (child.nodeType === 1 && child.hasAttribute(attrName)) {
	          if (!isHidden(child)) {
	            hasAttr = true;
	          }
	        }
	      }
	    }
	    return hasAttr;
	  }
	
	  /**
	   * Check if expected element has aria label attribute
	   * @param element
	   */
	  function hasAriaLabel(element) {
	    var node = angular.element(element)[0] || element;
	
	    /* Check if compatible node type (ie: not HTML Document node) */
	    if (!node.hasAttribute) {
	      return false;
	    }
	
	    /* Check label or description attributes */
	    return node.hasAttribute('aria-label') || node.hasAttribute('aria-labelledby') || node.hasAttribute('aria-describedby');
	  }
	
	  /**
	   * Check if expected element's parent has aria label attribute and has valid role and tagName
	   * @param element
	   * @param {optional} level Number of levels deep search should be performed
	   */
	  function parentHasAriaLabel(element, level) {
	    level = level || 1;
	    var node = angular.element(element)[0] || element;
	    if (!node.parentNode) {
	      return false;
	    }
	    if (performCheck(node.parentNode)) {
	      return true;
	    }
	    level--;
	    if (level) {
	      return parentHasAriaLabel(node.parentNode, level);
	    }
	    return false;
	
	    function performCheck(parentNode) {
	      if (!hasAriaLabel(parentNode)) {
	        return false;
	      }
	      /* Perform role blacklist check */
	      if (parentNode.hasAttribute('role')) {
	        switch(parentNode.getAttribute('role').toLowerCase()) {
	          case 'command':
	          case 'definition':
	          case 'directory':
	          case 'grid':
	          case 'list':
	          case 'listitem':
	          case 'log':
	          case 'marquee':
	          case 'menu':
	          case 'menubar':
	          case 'note':
	          case 'presentation':
	          case 'separator':
	          case 'scrollbar':
	          case 'status':
	          case 'tablist':
	            return false;
	        }
	      }
	      /* Perform tagName blacklist check */
	      switch(parentNode.tagName.toLowerCase()) {
	        case 'abbr':
	        case 'acronym':
	        case 'address':
	        case 'applet':
	        case 'audio':
	        case 'b':
	        case 'bdi':
	        case 'bdo':
	        case 'big':
	        case 'blockquote':
	        case 'br':
	        case 'canvas':
	        case 'caption':
	        case 'center':
	        case 'cite':
	        case 'code':
	        case 'col':
	        case 'data':
	        case 'dd':
	        case 'del':
	        case 'dfn':
	        case 'dir':
	        case 'div':
	        case 'dl':
	        case 'em':
	        case 'embed':
	        case 'fieldset':
	        case 'figcaption':
	        case 'font':
	        case 'h1':
	        case 'h2':
	        case 'h3':
	        case 'h4':
	        case 'h5':
	        case 'h6':
	        case 'hgroup':
	        case 'html':
	        case 'i':
	        case 'ins':
	        case 'isindex':
	        case 'kbd':
	        case 'keygen':
	        case 'label':
	        case 'legend':
	        case 'li':
	        case 'map':
	        case 'mark':
	        case 'menu':
	        case 'object':
	        case 'ol':
	        case 'output':
	        case 'pre':
	        case 'presentation':
	        case 'q':
	        case 'rt':
	        case 'ruby':
	        case 'samp':
	        case 'small':
	        case 'source':
	        case 'span':
	        case 'status':
	        case 'strike':
	        case 'strong':
	        case 'sub':
	        case 'sup':
	        case 'svg':
	        case 'tbody':
	        case 'td':
	        case 'th':
	        case 'thead':
	        case 'time':
	        case 'tr':
	        case 'track':
	        case 'tt':
	        case 'ul':
	        case 'var':
	          return false;
	      }
	      return true;
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.core.interaction
	 * @description
	 * User interaction detection to provide proper accessibility.
	 */
	MdInteractionService.$inject = ["$timeout", "$mdUtil"];
	angular
	  .module('material.core.interaction', [])
	  .service('$mdInteraction', MdInteractionService);
	
	
	/**
	 * @ngdoc service
	 * @name $mdInteraction
	 * @module material.core.interaction
	 *
	 * @description
	 *
	 * Service which keeps track of the last interaction type and validates them for several browsers.
	 * The service hooks into the document's body and listens for touch, mouse and keyboard events.
	 *
	 * The most recent interaction type can be retrieved by calling the `getLastInteractionType` method.
	 *
	 * Here is an example markup for using the interaction service.
	 *
	 * <hljs lang="js">
	 *   var lastType = $mdInteraction.getLastInteractionType();
	 *
	 *   if (lastType === 'keyboard') {
	 *     // We only restore the focus for keyboard users.
	 *     restoreFocus();
	 *   }
	 * </hljs>
	 *
	 */
	function MdInteractionService($timeout, $mdUtil) {
	  this.$timeout = $timeout;
	  this.$mdUtil = $mdUtil;
	
	  this.bodyElement = angular.element(document.body);
	  this.isBuffering = false;
	  this.bufferTimeout = null;
	  this.lastInteractionType = null;
	  this.lastInteractionTime = null;
	
	  // Type Mappings for the different events
	  // There will be three three interaction types
	  // `keyboard`, `mouse` and `touch`
	  // type `pointer` will be evaluated in `pointerMap` for IE Browser events
	  this.inputEventMap = {
	    'keydown': 'keyboard',
	    'mousedown': 'mouse',
	    'mouseenter': 'mouse',
	    'touchstart': 'touch',
	    'pointerdown': 'pointer',
	    'MSPointerDown': 'pointer'
	  };
	
	  // IE PointerDown events will be validated in `touch` or `mouse`
	  // Index numbers referenced here: https://msdn.microsoft.com/library/windows/apps/hh466130.aspx
	  this.iePointerMap = {
	    2: 'touch',
	    3: 'touch',
	    4: 'mouse'
	  };
	
	  this.initializeEvents();
	}
	
	/**
	 * Initializes the interaction service, by registering all interaction events to the
	 * body element.
	 */
	MdInteractionService.prototype.initializeEvents = function() {
	  // IE browsers can also trigger pointer events, which also leads to an interaction.
	  var pointerEvent = 'MSPointerEvent' in window ? 'MSPointerDown' : 'PointerEvent' in window ? 'pointerdown' : null;
	
	  this.bodyElement.on('keydown mousedown', this.onInputEvent.bind(this));
	
	  if ('ontouchstart' in document.documentElement) {
	    this.bodyElement.on('touchstart', this.onBufferInputEvent.bind(this));
	  }
	
	  if (pointerEvent) {
	    this.bodyElement.on(pointerEvent, this.onInputEvent.bind(this));
	  }
	
	};
	
	/**
	 * Event listener for normal interaction events, which should be tracked.
	 * @param event {MouseEvent|KeyboardEvent|PointerEvent|TouchEvent}
	 */
	MdInteractionService.prototype.onInputEvent = function(event) {
	  if (this.isBuffering) {
	    return;
	  }
	
	  var type = this.inputEventMap[event.type];
	
	  if (type === 'pointer') {
	    type = this.iePointerMap[event.pointerType] || event.pointerType;
	  }
	
	  this.lastInteractionType = type;
	  this.lastInteractionTime = this.$mdUtil.now();
	};
	
	/**
	 * Event listener for interaction events which should be buffered (touch events).
	 * @param event {TouchEvent}
	 */
	MdInteractionService.prototype.onBufferInputEvent = function(event) {
	  this.$timeout.cancel(this.bufferTimeout);
	
	  this.onInputEvent(event);
	  this.isBuffering = true;
	
	  // The timeout of 650ms is needed to delay the touchstart, because otherwise the touch will call
	  // the `onInput` function multiple times.
	  this.bufferTimeout = this.$timeout(function() {
	    this.isBuffering = false;
	  }.bind(this), 650, false);
	
	};
	
	/**
	 * @ngdoc method
	 * @name $mdInteraction#getLastInteractionType
	 * @description Retrieves the last interaction type triggered in body.
	 * @returns {string|null} Last interaction type.
	 */
	MdInteractionService.prototype.getLastInteractionType = function() {
	  return this.lastInteractionType;
	};
	
	/**
	 * @ngdoc method
	 * @name $mdInteraction#isUserInvoked
	 * @description Method to detect whether any interaction happened recently or not.
	 * @param {number=} checkDelay Time to check for any interaction to have been triggered.
	 * @returns {boolean} Whether there was any interaction or not.
	 */
	MdInteractionService.prototype.isUserInvoked = function(checkDelay) {
	  var delay = angular.isNumber(checkDelay) ? checkDelay : 15;
	
	  // Check for any interaction to be within the specified check time.
	  return this.lastInteractionTime >= this.$mdUtil.now() - delay;
	};
	
	})();
	(function(){
	"use strict";
	
	
	MdGesture.$inject = ["$$MdGestureHandler", "$$rAF", "$timeout"];
	attachToDocument.$inject = ["$mdGesture", "$$MdGestureHandler"];var HANDLERS = {};
	
	/* The state of the current 'pointer'
	 * The pointer represents the state of the current touch.
	 * It contains normalized x and y coordinates from DOM events,
	 * as well as other information abstracted from the DOM.
	 */
	
	var pointer, lastPointer, forceSkipClickHijack = false;
	
	/**
	 * The position of the most recent click if that click was on a label element.
	 * @type {{x: number, y: number}?}
	 */
	var lastLabelClickPos = null;
	
	// Used to attach event listeners once when multiple ng-apps are running.
	var isInitialized = false;
	
	angular
	  .module('material.core.gestures', [ ])
	  .provider('$mdGesture', MdGestureProvider)
	  .factory('$$MdGestureHandler', MdGestureHandler)
	  .run( attachToDocument );
	
	/**
	   * @ngdoc service
	   * @name $mdGestureProvider
	   * @module material.core.gestures
	   *
	   * @description
	   * In some scenarios on Mobile devices (without jQuery), the click events should NOT be hijacked.
	   * `$mdGestureProvider` is used to configure the Gesture module to ignore or skip click hijacking on mobile
	   * devices.
	   *
	   * <hljs lang="js">
	   *   app.config(function($mdGestureProvider) {
	   *
	   *     // For mobile devices without jQuery loaded, do not
	   *     // intercept click events during the capture phase.
	   *     $mdGestureProvider.skipClickHijack();
	   *
	   *   });
	   * </hljs>
	   *
	   */
	function MdGestureProvider() { }
	
	MdGestureProvider.prototype = {
	
	  // Publish access to setter to configure a variable  BEFORE the
	  // $mdGesture service is instantiated...
	  skipClickHijack: function() {
	    return forceSkipClickHijack = true;
	  },
	
	  /**
	   * $get is used to build an instance of $mdGesture
	   * @ngInject
	   */
	  $get : ["$$MdGestureHandler", "$$rAF", "$timeout", function($$MdGestureHandler, $$rAF, $timeout) {
	       return new MdGesture($$MdGestureHandler, $$rAF, $timeout);
	  }]
	};
	
	
	
	/**
	 * MdGesture factory construction function
	 * @ngInject
	 */
	function MdGesture($$MdGestureHandler, $$rAF, $timeout) {
	  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
	  var isIos = userAgent.match(/ipad|iphone|ipod/i);
	  var isAndroid = userAgent.match(/android/i);
	  var touchActionProperty = getTouchAction();
	  var hasJQuery =  (typeof window.jQuery !== 'undefined') && (angular.element === window.jQuery);
	
	  var self = {
	    handler: addHandler,
	    register: register,
	    // On mobile w/out jQuery, we normally intercept clicks. Should we skip that?
	    isHijackingClicks: (isIos || isAndroid) && !hasJQuery && !forceSkipClickHijack
	  };
	
	  if (self.isHijackingClicks) {
	    var maxClickDistance = 6;
	    self.handler('click', {
	      options: {
	        maxDistance: maxClickDistance
	      },
	      onEnd: checkDistanceAndEmit('click')
	    });
	
	    self.handler('focus', {
	      options: {
	        maxDistance: maxClickDistance
	      },
	      onEnd: function(ev, pointer) {
	        if (pointer.distance < this.state.options.maxDistance) {
	          if (canFocus(ev.target)) {
	            this.dispatchEvent(ev, 'focus', pointer);
	            ev.target.focus();
	          }
	        }
	
	        function canFocus(element) {
	          var focusableElements = ['INPUT', 'SELECT', 'BUTTON', 'TEXTAREA', 'VIDEO', 'AUDIO'];
	
	          return (element.getAttribute('tabindex') != '-1') &&
	              !element.hasAttribute('DISABLED') &&
	              (element.hasAttribute('tabindex') || element.hasAttribute('href') || element.isContentEditable ||
	              (focusableElements.indexOf(element.nodeName) != -1));
	        }
	      }
	    });
	
	    self.handler('mouseup', {
	      options: {
	        maxDistance: maxClickDistance
	      },
	      onEnd: checkDistanceAndEmit('mouseup')
	    });
	
	    self.handler('mousedown', {
	      onStart: function(ev) {
	        this.dispatchEvent(ev, 'mousedown');
	      }
	    });
	  }
	
	  function checkDistanceAndEmit(eventName) {
	    return function(ev, pointer) {
	      if (pointer.distance < this.state.options.maxDistance) {
	        this.dispatchEvent(ev, eventName, pointer);
	      }
	    };
	  }
	
	  /*
	   * Register an element to listen for a handler.
	   * This allows an element to override the default options for a handler.
	   * Additionally, some handlers like drag and hold only dispatch events if
	   * the domEvent happens inside an element that's registered to listen for these events.
	   *
	   * @see GestureHandler for how overriding of default options works.
	   * @example $mdGesture.register(myElement, 'drag', { minDistance: 20, horziontal: false })
	   */
	  function register(element, handlerName, options) {
	    var handler = HANDLERS[handlerName.replace(/^\$md./, '')];
	    if (!handler) {
	      throw new Error('Failed to register element with handler ' + handlerName + '. ' +
	      'Available handlers: ' + Object.keys(HANDLERS).join(', '));
	    }
	    return handler.registerElement(element, options);
	  }
	
	  /*
	   * add a handler to $mdGesture. see below.
	   */
	  function addHandler(name, definition) {
	    var handler = new $$MdGestureHandler(name);
	    angular.extend(handler, definition);
	    HANDLERS[name] = handler;
	
	    return self;
	  }
	
	  /*
	   * Register handlers. These listen to touch/start/move events, interpret them,
	   * and dispatch gesture events depending on options & conditions. These are all
	   * instances of GestureHandler.
	   * @see GestureHandler
	   */
	  return self
	    /*
	     * The press handler dispatches an event on touchdown/touchend.
	     * It's a simple abstraction of touch/mouse/pointer start and end.
	     */
	    .handler('press', {
	      onStart: function (ev, pointer) {
	        this.dispatchEvent(ev, '$md.pressdown');
	      },
	      onEnd: function (ev, pointer) {
	        this.dispatchEvent(ev, '$md.pressup');
	      }
	    })
	
	    /*
	     * The hold handler dispatches an event if the user keeps their finger within
	     * the same <maxDistance> area for <delay> ms.
	     * The hold handler will only run if a parent of the touch target is registered
	     * to listen for hold events through $mdGesture.register()
	     */
	    .handler('hold', {
	      options: {
	        maxDistance: 6,
	        delay: 500
	      },
	      onCancel: function () {
	        $timeout.cancel(this.state.timeout);
	      },
	      onStart: function (ev, pointer) {
	        // For hold, require a parent to be registered with $mdGesture.register()
	        // Because we prevent scroll events, this is necessary.
	        if (!this.state.registeredParent) return this.cancel();
	
	        this.state.pos = {x: pointer.x, y: pointer.y};
	        this.state.timeout = $timeout(angular.bind(this, function holdDelayFn() {
	          this.dispatchEvent(ev, '$md.hold');
	          this.cancel(); //we're done!
	        }), this.state.options.delay, false);
	      },
	      onMove: function (ev, pointer) {
	        // Don't scroll while waiting for hold.
	        // If we don't preventDefault touchmove events here, Android will assume we don't
	        // want to listen to anymore touch events. It will start scrolling and stop sending
	        // touchmove events.
	        if (!touchActionProperty && ev.type === 'touchmove') ev.preventDefault();
	
	        // If the user moves greater than <maxDistance> pixels, stop the hold timer
	        // set in onStart
	        var dx = this.state.pos.x - pointer.x;
	        var dy = this.state.pos.y - pointer.y;
	        if (Math.sqrt(dx * dx + dy * dy) > this.options.maxDistance) {
	          this.cancel();
	        }
	      },
	      onEnd: function () {
	        this.onCancel();
	      }
	    })
	
	    /*
	     * The drag handler dispatches a drag event if the user holds and moves his finger greater than
	     * <minDistance> px in the x or y direction, depending on options.horizontal.
	     * The drag will be cancelled if the user moves his finger greater than <minDistance>*<cancelMultiplier> in
	     * the perpendicular direction. Eg if the drag is horizontal and the user moves his finger <minDistance>*<cancelMultiplier>
	     * pixels vertically, this handler won't consider the move part of a drag.
	     */
	    .handler('drag', {
	      options: {
	        minDistance: 6,
	        horizontal: true,
	        cancelMultiplier: 1.5
	      },
	      onSetup: function(element, options) {
	        if (touchActionProperty) {
	          // We check for horizontal to be false, because otherwise we would overwrite the default opts.
	          this.oldTouchAction = element[0].style[touchActionProperty];
	          element[0].style[touchActionProperty] = options.horizontal ? 'pan-y' : 'pan-x';
	        }
	      },
	      onCleanup: function(element) {
	        if (this.oldTouchAction) {
	          element[0].style[touchActionProperty] = this.oldTouchAction;
	        }
	      },
	      onStart: function (ev) {
	        // For drag, require a parent to be registered with $mdGesture.register()
	        if (!this.state.registeredParent) this.cancel();
	      },
	      onMove: function (ev, pointer) {
	        var shouldStartDrag, shouldCancel;
	        // Don't scroll while deciding if this touchmove qualifies as a drag event.
	        // If we don't preventDefault touchmove events here, Android will assume we don't
	        // want to listen to anymore touch events. It will start scrolling and stop sending
	        // touchmove events.
	        if (!touchActionProperty && ev.type === 'touchmove') ev.preventDefault();
	
	        if (!this.state.dragPointer) {
	          if (this.state.options.horizontal) {
	            shouldStartDrag = Math.abs(pointer.distanceX) > this.state.options.minDistance;
	            shouldCancel = Math.abs(pointer.distanceY) > this.state.options.minDistance * this.state.options.cancelMultiplier;
	          } else {
	            shouldStartDrag = Math.abs(pointer.distanceY) > this.state.options.minDistance;
	            shouldCancel = Math.abs(pointer.distanceX) > this.state.options.minDistance * this.state.options.cancelMultiplier;
	          }
	
	          if (shouldStartDrag) {
	            // Create a new pointer representing this drag, starting at this point where the drag started.
	            this.state.dragPointer = makeStartPointer(ev);
	            updatePointerState(ev, this.state.dragPointer);
	            this.dispatchEvent(ev, '$md.dragstart', this.state.dragPointer);
	
	          } else if (shouldCancel) {
	            this.cancel();
	          }
	        } else {
	          this.dispatchDragMove(ev);
	        }
	      },
	      // Only dispatch dragmove events every frame; any more is unnecessary
	      dispatchDragMove: $$rAF.throttle(function (ev) {
	        // Make sure the drag didn't stop while waiting for the next frame
	        if (this.state.isRunning) {
	          updatePointerState(ev, this.state.dragPointer);
	          this.dispatchEvent(ev, '$md.drag', this.state.dragPointer);
	        }
	      }),
	      onEnd: function (ev, pointer) {
	        if (this.state.dragPointer) {
	          updatePointerState(ev, this.state.dragPointer);
	          this.dispatchEvent(ev, '$md.dragend', this.state.dragPointer);
	        }
	      }
	    })
	
	    /*
	     * The swipe handler will dispatch a swipe event if, on the end of a touch,
	     * the velocity and distance were high enough.
	     */
	    .handler('swipe', {
	      options: {
	        minVelocity: 0.65,
	        minDistance: 10
	      },
	      onEnd: function (ev, pointer) {
	        var eventType;
	
	        if (Math.abs(pointer.velocityX) > this.state.options.minVelocity &&
	          Math.abs(pointer.distanceX) > this.state.options.minDistance) {
	          eventType = pointer.directionX == 'left' ? '$md.swipeleft' : '$md.swiperight';
	          this.dispatchEvent(ev, eventType);
	        }
	        else if (Math.abs(pointer.velocityY) > this.state.options.minVelocity &&
	          Math.abs(pointer.distanceY) > this.state.options.minDistance) {
	          eventType = pointer.directionY == 'up' ? '$md.swipeup' : '$md.swipedown';
	          this.dispatchEvent(ev, eventType);
	        }
	      }
	    });
	
	  function getTouchAction() {
	    var testEl = document.createElement('div');
	    var vendorPrefixes = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
	
	    for (var i = 0; i < vendorPrefixes.length; i++) {
	      var prefix = vendorPrefixes[i];
	      var property = prefix ? prefix + 'TouchAction' : 'touchAction';
	      if (angular.isDefined(testEl.style[property])) {
	        return property;
	      }
	    }
	  }
	
	}
	
	/**
	 * MdGestureHandler
	 * A GestureHandler is an object which is able to dispatch custom dom events
	 * based on native dom {touch,pointer,mouse}{start,move,end} events.
	 *
	 * A gesture will manage its lifecycle through the start,move,end, and cancel
	 * functions, which are called by native dom events.
	 *
	 * A gesture has the concept of 'options' (eg a swipe's required velocity), which can be
	 * overridden by elements registering through $mdGesture.register()
	 */
	function GestureHandler (name) {
	  this.name = name;
	  this.state = {};
	}
	
	function MdGestureHandler() {
	  var hasJQuery =  (typeof window.jQuery !== 'undefined') && (angular.element === window.jQuery);
	
	  GestureHandler.prototype = {
	    options: {},
	    // jQuery listeners don't work with custom DOMEvents, so we have to dispatch events
	    // differently when jQuery is loaded
	    dispatchEvent: hasJQuery ?  jQueryDispatchEvent : nativeDispatchEvent,
	
	    // These are overridden by the registered handler
	    onSetup: angular.noop,
	    onCleanup: angular.noop,
	    onStart: angular.noop,
	    onMove: angular.noop,
	    onEnd: angular.noop,
	    onCancel: angular.noop,
	
	    // onStart sets up a new state for the handler, which includes options from the
	    // nearest registered parent element of ev.target.
	    start: function (ev, pointer) {
	      if (this.state.isRunning) return;
	      var parentTarget = this.getNearestParent(ev.target);
	      // Get the options from the nearest registered parent
	      var parentTargetOptions = parentTarget && parentTarget.$mdGesture[this.name] || {};
	
	      this.state = {
	        isRunning: true,
	        // Override the default options with the nearest registered parent's options
	        options: angular.extend({}, this.options, parentTargetOptions),
	        // Pass in the registered parent node to the state so the onStart listener can use
	        registeredParent: parentTarget
	      };
	      this.onStart(ev, pointer);
	    },
	    move: function (ev, pointer) {
	      if (!this.state.isRunning) return;
	      this.onMove(ev, pointer);
	    },
	    end: function (ev, pointer) {
	      if (!this.state.isRunning) return;
	      this.onEnd(ev, pointer);
	      this.state.isRunning = false;
	    },
	    cancel: function (ev, pointer) {
	      this.onCancel(ev, pointer);
	      this.state = {};
	    },
	
	    // Find and return the nearest parent element that has been registered to
	    // listen for this handler via $mdGesture.register(element, 'handlerName').
	    getNearestParent: function (node) {
	      var current = node;
	      while (current) {
	        if ((current.$mdGesture || {})[this.name]) {
	          return current;
	        }
	        current = current.parentNode;
	      }
	      return null;
	    },
	
	    // Called from $mdGesture.register when an element registers itself with a handler.
	    // Store the options the user gave on the DOMElement itself. These options will
	    // be retrieved with getNearestParent when the handler starts.
	    registerElement: function (element, options) {
	      var self = this;
	      element[0].$mdGesture = element[0].$mdGesture || {};
	      element[0].$mdGesture[this.name] = options || {};
	      element.on('$destroy', onDestroy);
	
	      self.onSetup(element, options || {});
	
	      return onDestroy;
	
	      function onDestroy() {
	        delete element[0].$mdGesture[self.name];
	        element.off('$destroy', onDestroy);
	
	        self.onCleanup(element, options || {});
	      }
	    }
	  };
	
	  return GestureHandler;
	
	  /*
	   * Dispatch an event with jQuery
	   * TODO: Make sure this sends bubbling events
	   *
	   * @param srcEvent the original DOM touch event that started this.
	   * @param eventType the name of the custom event to send (eg 'click' or '$md.drag')
	   * @param eventPointer the pointer object that matches this event.
	   */
	  function jQueryDispatchEvent(srcEvent, eventType, eventPointer) {
	    eventPointer = eventPointer || pointer;
	    var eventObj = new angular.element.Event(eventType);
	
	    eventObj.$material = true;
	    eventObj.pointer = eventPointer;
	    eventObj.srcEvent = srcEvent;
	
	    angular.extend(eventObj, {
	      clientX: eventPointer.x,
	      clientY: eventPointer.y,
	      screenX: eventPointer.x,
	      screenY: eventPointer.y,
	      pageX: eventPointer.x,
	      pageY: eventPointer.y,
	      ctrlKey: srcEvent.ctrlKey,
	      altKey: srcEvent.altKey,
	      shiftKey: srcEvent.shiftKey,
	      metaKey: srcEvent.metaKey
	    });
	    angular.element(eventPointer.target).trigger(eventObj);
	  }
	
	  /*
	   * NOTE: nativeDispatchEvent is very performance sensitive.
	   * @param srcEvent the original DOM touch event that started this.
	   * @param eventType the name of the custom event to send (eg 'click' or '$md.drag')
	   * @param eventPointer the pointer object that matches this event.
	   */
	  function nativeDispatchEvent(srcEvent, eventType, eventPointer) {
	    eventPointer = eventPointer || pointer;
	    var eventObj;
	
	    if (eventType === 'click' || eventType == 'mouseup' || eventType == 'mousedown' ) {
	      eventObj = document.createEvent('MouseEvents');
	      eventObj.initMouseEvent(
	        eventType, true, true, window, srcEvent.detail,
	        eventPointer.x, eventPointer.y, eventPointer.x, eventPointer.y,
	        srcEvent.ctrlKey, srcEvent.altKey, srcEvent.shiftKey, srcEvent.metaKey,
	        srcEvent.button, srcEvent.relatedTarget || null
	      );
	
	    } else {
	      eventObj = document.createEvent('CustomEvent');
	      eventObj.initCustomEvent(eventType, true, true, {});
	    }
	    eventObj.$material = true;
	    eventObj.pointer = eventPointer;
	    eventObj.srcEvent = srcEvent;
	    eventPointer.target.dispatchEvent(eventObj);
	  }
	
	}
	
	/**
	 * Attach Gestures: hook document and check shouldHijack clicks
	 * @ngInject
	 */
	function attachToDocument( $mdGesture, $$MdGestureHandler ) {
	
	  // Polyfill document.contains for IE11.
	  // TODO: move to util
	  document.contains || (document.contains = function (node) {
	    return document.body.contains(node);
	  });
	
	  if (!isInitialized && $mdGesture.isHijackingClicks ) {
	    /*
	     * If hijack clicks is true, we preventDefault any click that wasn't
	     * sent by AngularJS Material. This is because on older Android & iOS, a false, or 'ghost',
	     * click event will be sent ~400ms after a touchend event happens.
	     * The only way to know if this click is real is to prevent any normal
	     * click events, and add a flag to events sent by material so we know not to prevent those.
	     *
	     * Two exceptions to click events that should be prevented are:
	     *  - click events sent by the keyboard (eg form submit)
	     *  - events that originate from an Ionic app
	     */
	    document.addEventListener('click'    , clickHijacker     , true);
	    document.addEventListener('mouseup'  , mouseInputHijacker, true);
	    document.addEventListener('mousedown', mouseInputHijacker, true);
	    document.addEventListener('focus'    , mouseInputHijacker, true);
	
	    isInitialized = true;
	  }
	
	  function mouseInputHijacker(ev) {
	    var isKeyClick = !ev.clientX && !ev.clientY;
	    if (!isKeyClick && !ev.$material && !ev.isIonicTap
	      && !isInputEventFromLabelClick(ev)) {
	      ev.preventDefault();
	      ev.stopPropagation();
	    }
	  }
	
	  function clickHijacker(ev) {
	    var isKeyClick = ev.clientX === 0 && ev.clientY === 0;
	    var isSubmitEvent = ev.target && ev.target.type === 'submit';
	    if (!isKeyClick && !ev.$material && !ev.isIonicTap
	      && !isInputEventFromLabelClick(ev)
	      && !isSubmitEvent) {
	      ev.preventDefault();
	      ev.stopPropagation();
	      lastLabelClickPos = null;
	    } else {
	      lastLabelClickPos = null;
	      if (ev.target.tagName.toLowerCase() == 'label') {
	        lastLabelClickPos = {x: ev.x, y: ev.y};
	      }
	    }
	  }
	
	
	  // Listen to all events to cover all platforms.
	  var START_EVENTS = 'mousedown touchstart pointerdown';
	  var MOVE_EVENTS = 'mousemove touchmove pointermove';
	  var END_EVENTS = 'mouseup mouseleave touchend touchcancel pointerup pointercancel';
	
	  angular.element(document)
	    .on(START_EVENTS, gestureStart)
	    .on(MOVE_EVENTS, gestureMove)
	    .on(END_EVENTS, gestureEnd)
	    // For testing
	    .on('$$mdGestureReset', function gestureClearCache () {
	      lastPointer = pointer = null;
	    });
	
	  /*
	   * When a DOM event happens, run all registered gesture handlers' lifecycle
	   * methods which match the DOM event.
	   * Eg when a 'touchstart' event happens, runHandlers('start') will call and
	   * run `handler.cancel()` and `handler.start()` on all registered handlers.
	   */
	  function runHandlers(handlerEvent, event) {
	    var handler;
	    for (var name in HANDLERS) {
	      handler = HANDLERS[name];
	      if( handler instanceof $$MdGestureHandler ) {
	
	        if (handlerEvent === 'start') {
	          // Run cancel to reset any handlers' state
	          handler.cancel();
	        }
	        handler[handlerEvent](event, pointer);
	
	      }
	    }
	  }
	
	  /*
	   * gestureStart vets if a start event is legitimate (and not part of a 'ghost click' from iOS/Android)
	   * If it is legitimate, we initiate the pointer state and mark the current pointer's type
	   * For example, for a touchstart event, mark the current pointer as a 'touch' pointer, so mouse events
	   * won't effect it.
	   */
	  function gestureStart(ev) {
	    // If we're already touched down, abort
	    if (pointer) return;
	
	    var now = +Date.now();
	
	    // iOS & old android bug: after a touch event, a click event is sent 350 ms later.
	    // If <400ms have passed, don't allow an event of a different type than the previous event
	    if (lastPointer && !typesMatch(ev, lastPointer) && (now - lastPointer.endTime < 1500)) {
	      return;
	    }
	
	    pointer = makeStartPointer(ev);
	
	    runHandlers('start', ev);
	  }
	  /*
	   * If a move event happens of the right type, update the pointer and run all the move handlers.
	   * "of the right type": if a mousemove happens but our pointer started with a touch event, do nothing.
	   */
	  function gestureMove(ev) {
	    if (!pointer || !typesMatch(ev, pointer)) return;
	
	    updatePointerState(ev, pointer);
	    runHandlers('move', ev);
	  }
	  /*
	   * If an end event happens of the right type, update the pointer, run endHandlers, and save the pointer as 'lastPointer'
	   */
	  function gestureEnd(ev) {
	    if (!pointer || !typesMatch(ev, pointer)) return;
	
	    updatePointerState(ev, pointer);
	    pointer.endTime = +Date.now();
	
	    runHandlers('end', ev);
	
	    lastPointer = pointer;
	    pointer = null;
	  }
	
	}
	
	// ********************
	// Module Functions
	// ********************
	
	/*
	 * Initiate the pointer. x, y, and the pointer's type.
	 */
	function makeStartPointer(ev) {
	  var point = getEventPoint(ev);
	  var startPointer = {
	    startTime: +Date.now(),
	    target: ev.target,
	    // 'p' for pointer events, 'm' for mouse, 't' for touch
	    type: ev.type.charAt(0)
	  };
	  startPointer.startX = startPointer.x = point.pageX;
	  startPointer.startY = startPointer.y = point.pageY;
	  return startPointer;
	}
	
	/*
	 * return whether the pointer's type matches the event's type.
	 * Eg if a touch event happens but the pointer has a mouse type, return false.
	 */
	function typesMatch(ev, pointer) {
	  return ev && pointer && ev.type.charAt(0) === pointer.type;
	}
	
	/**
	 * Gets whether the given event is an input event that was caused by clicking on an
	 * associated label element.
	 *
	 * This is necessary because the browser will, upon clicking on a label element, fire an
	 * *extra* click event on its associated input (if any). mdGesture is able to flag the label
	 * click as with `$material` correctly, but not the second input click.
	 *
	 * In order to determine whether an input event is from a label click, we compare the (x, y) for
	 * the event to the (x, y) for the most recent label click (which is cleared whenever a non-label
	 * click occurs). Unfortunately, there are no event properties that tie the input and the label
	 * together (such as relatedTarget).
	 *
	 * @param {MouseEvent} event
	 * @returns {boolean}
	 */
	function isInputEventFromLabelClick(event) {
	  return lastLabelClickPos
	      && lastLabelClickPos.x == event.x
	      && lastLabelClickPos.y == event.y;
	}
	
	/*
	 * Update the given pointer based upon the given DOMEvent.
	 * Distance, velocity, direction, duration, etc
	 */
	function updatePointerState(ev, pointer) {
	  var point = getEventPoint(ev);
	  var x = pointer.x = point.pageX;
	  var y = pointer.y = point.pageY;
	
	  pointer.distanceX = x - pointer.startX;
	  pointer.distanceY = y - pointer.startY;
	  pointer.distance = Math.sqrt(
	    pointer.distanceX * pointer.distanceX + pointer.distanceY * pointer.distanceY
	  );
	
	  pointer.directionX = pointer.distanceX > 0 ? 'right' : pointer.distanceX < 0 ? 'left' : '';
	  pointer.directionY = pointer.distanceY > 0 ? 'down' : pointer.distanceY < 0 ? 'up' : '';
	
	  pointer.duration = +Date.now() - pointer.startTime;
	  pointer.velocityX = pointer.distanceX / pointer.duration;
	  pointer.velocityY = pointer.distanceY / pointer.duration;
	}
	
	/*
	 * Normalize the point where the DOM event happened whether it's touch or mouse.
	 * @returns point event obj with pageX and pageY on it.
	 */
	function getEventPoint(ev) {
	  ev = ev.originalEvent || ev; // support jQuery events
	  return (ev.touches && ev.touches[0]) ||
	    (ev.changedTouches && ev.changedTouches[0]) ||
	    ev;
	}
	
	})();
	(function(){
	"use strict";
	
	angular.module('material.core')
	  .provider('$$interimElement', InterimElementProvider);
	
	/*
	 * @ngdoc service
	 * @name $$interimElement
	 * @module material.core
	 *
	 * @description
	 *
	 * Factory that contructs `$$interimElement.$service` services.
	 * Used internally in material design for elements that appear on screen temporarily.
	 * The service provides a promise-like API for interacting with the temporary
	 * elements.
	 *
	 * ```js
	 * app.service('$mdToast', function($$interimElement) {
	 *   var $mdToast = $$interimElement(toastDefaultOptions);
	 *   return $mdToast;
	 * });
	 * ```
	 * @param {object=} defaultOptions Options used by default for the `show` method on the service.
	 *
	 * @returns {$$interimElement.$service}
	 *
	 */
	
	function InterimElementProvider() {
	  InterimElementFactory.$inject = ["$document", "$q", "$rootScope", "$timeout", "$rootElement", "$animate", "$mdUtil", "$mdCompiler", "$mdTheming", "$injector", "$exceptionHandler"];
	  createInterimElementProvider.$get = InterimElementFactory;
	  return createInterimElementProvider;
	
	  /**
	   * Returns a new provider which allows configuration of a new interimElement
	   * service. Allows configuration of default options & methods for options,
	   * as well as configuration of 'preset' methods (eg dialog.basic(): basic is a preset method)
	   */
	  function createInterimElementProvider(interimFactoryName) {
	    factory.$inject = ["$$interimElement", "$injector"];
	    var EXPOSED_METHODS = ['onHide', 'onShow', 'onRemove'];
	
	    var customMethods = {};
	    var providerConfig = {
	      presets: {}
	    };
	
	    var provider = {
	      setDefaults: setDefaults,
	      addPreset: addPreset,
	      addMethod: addMethod,
	      $get: factory
	    };
	
	    /**
	     * all interim elements will come with the 'build' preset
	     */
	    provider.addPreset('build', {
	      methods: ['controller', 'controllerAs', 'resolve', 'multiple',
	        'template', 'templateUrl', 'themable', 'transformTemplate', 'parent', 'contentElement']
	    });
	
	    return provider;
	
	    /**
	     * Save the configured defaults to be used when the factory is instantiated
	     */
	    function setDefaults(definition) {
	      providerConfig.optionsFactory = definition.options;
	      providerConfig.methods = (definition.methods || []).concat(EXPOSED_METHODS);
	      return provider;
	    }
	
	    /**
	     * Add a method to the factory that isn't specific to any interim element operations
	     */
	
	    function addMethod(name, fn) {
	      customMethods[name] = fn;
	      return provider;
	    }
	
	    /**
	     * Save the configured preset to be used when the factory is instantiated
	     */
	    function addPreset(name, definition) {
	      definition = definition || {};
	      definition.methods = definition.methods || [];
	      definition.options = definition.options || function() { return {}; };
	
	      if (/^cancel|hide|show$/.test(name)) {
	        throw new Error("Preset '" + name + "' in " + interimFactoryName + " is reserved!");
	      }
	      if (definition.methods.indexOf('_options') > -1) {
	        throw new Error("Method '_options' in " + interimFactoryName + " is reserved!");
	      }
	      providerConfig.presets[name] = {
	        methods: definition.methods.concat(EXPOSED_METHODS),
	        optionsFactory: definition.options,
	        argOption: definition.argOption
	      };
	      return provider;
	    }
	
	    function addPresetMethod(presetName, methodName, method) {
	      providerConfig.presets[presetName][methodName] = method;
	    }
	
	    /**
	     * Create a factory that has the given methods & defaults implementing interimElement
	     */
	    /* @ngInject */
	    function factory($$interimElement, $injector) {
	      var defaultMethods;
	      var defaultOptions;
	      var interimElementService = $$interimElement();
	
	      /*
	       * publicService is what the developer will be using.
	       * It has methods hide(), cancel(), show(), build(), and any other
	       * presets which were set during the config phase.
	       */
	      var publicService = {
	        hide: interimElementService.hide,
	        cancel: interimElementService.cancel,
	        show: showInterimElement,
	
	        // Special internal method to destroy an interim element without animations
	        // used when navigation changes causes a $scope.$destroy() action
	        destroy : destroyInterimElement
	      };
	
	
	      defaultMethods = providerConfig.methods || [];
	      // This must be invoked after the publicService is initialized
	      defaultOptions = invokeFactory(providerConfig.optionsFactory, {});
	
	      // Copy over the simple custom methods
	      angular.forEach(customMethods, function(fn, name) {
	        publicService[name] = fn;
	      });
	
	      angular.forEach(providerConfig.presets, function(definition, name) {
	        var presetDefaults = invokeFactory(definition.optionsFactory, {});
	        var presetMethods = (definition.methods || []).concat(defaultMethods);
	
	        // Every interimElement built with a preset has a field called `$type`,
	        // which matches the name of the preset.
	        // Eg in preset 'confirm', options.$type === 'confirm'
	        angular.extend(presetDefaults, { $type: name });
	
	        // This creates a preset class which has setter methods for every
	        // method given in the `.addPreset()` function, as well as every
	        // method given in the `.setDefaults()` function.
	        //
	        // @example
	        // .setDefaults({
	        //   methods: ['hasBackdrop', 'clickOutsideToClose', 'escapeToClose', 'targetEvent'],
	        //   options: dialogDefaultOptions
	        // })
	        // .addPreset('alert', {
	        //   methods: ['title', 'ok'],
	        //   options: alertDialogOptions
	        // })
	        //
	        // Set values will be passed to the options when interimElement.show() is called.
	        function Preset(opts) {
	          this._options = angular.extend({}, presetDefaults, opts);
	        }
	        angular.forEach(presetMethods, function(name) {
	          Preset.prototype[name] = function(value) {
	            this._options[name] = value;
	            return this;
	          };
	        });
	
	        // Create shortcut method for one-linear methods
	        if (definition.argOption) {
	          var methodName = 'show' + name.charAt(0).toUpperCase() + name.slice(1);
	          publicService[methodName] = function(arg) {
	            var config = publicService[name](arg);
	            return publicService.show(config);
	          };
	        }
	
	        // eg $mdDialog.alert() will return a new alert preset
	        publicService[name] = function(arg) {
	          // If argOption is supplied, eg `argOption: 'content'`, then we assume
	          // if the argument is not an options object then it is the `argOption` option.
	          //
	          // @example `$mdToast.simple('hello')` // sets options.content to hello
	          //                                     // because argOption === 'content'
	          if (arguments.length && definition.argOption &&
	              !angular.isObject(arg) && !angular.isArray(arg))  {
	
	            return (new Preset())[definition.argOption](arg);
	
	          } else {
	            return new Preset(arg);
	          }
	
	        };
	      });
	
	      return publicService;
	
	      /**
	       *
	       */
	      function showInterimElement(opts) {
	        // opts is either a preset which stores its options on an _options field,
	        // or just an object made up of options
	        opts = opts || { };
	        if (opts._options) opts = opts._options;
	
	        return interimElementService.show(
	          angular.extend({}, defaultOptions, opts)
	        );
	      }
	
	      /**
	       *  Special method to hide and destroy an interimElement WITHOUT
	       *  any 'leave` or hide animations ( an immediate force hide/remove )
	       *
	       *  NOTE: This calls the onRemove() subclass method for each component...
	       *  which must have code to respond to `options.$destroy == true`
	       */
	      function destroyInterimElement(opts) {
	          return interimElementService.destroy(opts);
	      }
	
	      /**
	       * Helper to call $injector.invoke with a local of the factory name for
	       * this provider.
	       * If an $mdDialog is providing options for a dialog and tries to inject
	       * $mdDialog, a circular dependency error will happen.
	       * We get around that by manually injecting $mdDialog as a local.
	       */
	      function invokeFactory(factory, defaultVal) {
	        var locals = {};
	        locals[interimFactoryName] = publicService;
	        return $injector.invoke(factory || function() { return defaultVal; }, {}, locals);
	      }
	
	    }
	
	  }
	
	  /* @ngInject */
	  function InterimElementFactory($document, $q, $rootScope, $timeout, $rootElement, $animate,
	                                 $mdUtil, $mdCompiler, $mdTheming, $injector, $exceptionHandler) {
	    return function createInterimElementService() {
	      var SHOW_CANCELLED = false;
	
	      /*
	       * @ngdoc service
	       * @name $$interimElement.$service
	       *
	       * @description
	       * A service used to control inserting and removing an element into the DOM.
	       *
	       */
	
	      var service;
	
	      var showPromises = []; // Promises for the interim's which are currently opening.
	      var hidePromises = []; // Promises for the interim's which are currently hiding.
	      var showingInterims = []; // Interim elements which are currently showing up.
	
	      // Publish instance $$interimElement service;
	      // ... used as $mdDialog, $mdToast, $mdMenu, and $mdSelect
	
	      return service = {
	        show: show,
	        hide: waitForInterim(hide),
	        cancel: waitForInterim(cancel),
	        destroy : destroy,
	        $injector_: $injector
	      };
	
	      /*
	       * @ngdoc method
	       * @name $$interimElement.$service#show
	       * @kind function
	       *
	       * @description
	       * Adds the `$interimElement` to the DOM and returns a special promise that will be resolved or rejected
	       * with hide or cancel, respectively. To external cancel/hide, developers should use the
	       *
	       * @param {*} options is hashMap of settings
	       * @returns a Promise
	       *
	       */
	      function show(options) {
	        options = options || {};
	        var interimElement = new InterimElement(options || {});
	
	        // When an interim element is currently showing, we have to cancel it.
	        // Just hiding it, will resolve the InterimElement's promise, the promise should be
	        // rejected instead.
	        var hideAction = options.multiple ? $q.resolve() : $q.all(showPromises);
	
	        if (!options.multiple) {
	          // Wait for all opening interim's to finish their transition.
	          hideAction = hideAction.then(function() {
	            // Wait for all closing and showing interim's to be completely closed.
	            var promiseArray = hidePromises.concat(showingInterims.map(service.cancel));
	            return $q.all(promiseArray);
	          });
	        }
	
	        var showAction = hideAction.then(function() {
	
	          return interimElement
	            .show()
	            .catch(function(reason) { return reason; })
	            .finally(function() {
	              showPromises.splice(showPromises.indexOf(showAction), 1);
	              showingInterims.push(interimElement);
	            });
	
	        });
	
	        showPromises.push(showAction);
	
	        // In AngularJS 1.6+, exceptions inside promises will cause a rejection. We need to handle
	        // the rejection and only log it if it's an error.
	        interimElement.deferred.promise.catch(function(fault) {
	          if (fault instanceof Error) {
	            $exceptionHandler(fault);
	          }
	
	          return fault;
	        });
	
	        // Return a promise that will be resolved when the interim
	        // element is hidden or cancelled...
	        return interimElement.deferred.promise;
	      }
	
	      /*
	       * @ngdoc method
	       * @name $$interimElement.$service#hide
	       * @kind function
	       *
	       * @description
	       * Removes the `$interimElement` from the DOM and resolves the promise returned from `show`
	       *
	       * @param {*} resolveParam Data to resolve the promise with
	       * @returns a Promise that will be resolved after the element has been removed.
	       *
	       */
	      function hide(reason, options) {
	        options = options || {};
	
	        if (options.closeAll) {
	          // We have to make a shallow copy of the array, because otherwise the map will break.
	          return $q.all(showingInterims.slice().reverse().map(closeElement));
	        } else if (options.closeTo !== undefined) {
	          return $q.all(showingInterims.slice(options.closeTo).map(closeElement));
	        }
	
	        // Hide the latest showing interim element.
	        return closeElement(showingInterims[showingInterims.length - 1]);
	
	        function closeElement(interim) {
	
	          var hideAction = interim
	            .remove(reason, false, options || { })
	            .catch(function(reason) { return reason; })
	            .finally(function() {
	              hidePromises.splice(hidePromises.indexOf(hideAction), 1);
	            });
	
	          showingInterims.splice(showingInterims.indexOf(interim), 1);
	          hidePromises.push(hideAction);
	
	          return interim.deferred.promise;
	        }
	      }
	
	      /*
	       * @ngdoc method
	       * @name $$interimElement.$service#cancel
	       * @kind function
	       *
	       * @description
	       * Removes the `$interimElement` from the DOM and rejects the promise returned from `show`
	       *
	       * @param {*} reason Data to reject the promise with
	       * @returns Promise that will be resolved after the element has been removed.
	       *
	       */
	      function cancel(reason, options) {
	        var interim = showingInterims.pop();
	        if (!interim) {
	          return $q.when(reason);
	        }
	
	        var cancelAction = interim
	          .remove(reason, true, options || {})
	          .catch(function(reason) { return reason; })
	          .finally(function() {
	            hidePromises.splice(hidePromises.indexOf(cancelAction), 1);
	          });
	
	        hidePromises.push(cancelAction);
	
	        // Since AngularJS 1.6.7, promises will be logged to $exceptionHandler when the promise
	        // is not handling the rejection. We create a pseudo catch handler, which will prevent the
	        // promise from being logged to the $exceptionHandler.
	        return interim.deferred.promise.catch(angular.noop);
	      }
	
	      /**
	       * Creates a function to wait for at least one interim element to be available.
	       * @param callbackFn Function to be used as callback
	       * @returns {Function}
	       */
	      function waitForInterim(callbackFn) {
	        return function() {
	          var fnArguments = arguments;
	
	          if (!showingInterims.length) {
	            // When there are still interim's opening, then wait for the first interim element to
	            // finish its open animation.
	            if (showPromises.length) {
	              return showPromises[0].finally(function () {
	                return callbackFn.apply(service, fnArguments);
	              });
	            }
	
	            return $q.when("No interim elements currently showing up.");
	          }
	
	          return callbackFn.apply(service, fnArguments);
	        };
	      }
	
	      /*
	       * Special method to quick-remove the interim element without animations
	       * Note: interim elements are in "interim containers"
	       */
	      function destroy(targetEl) {
	        var interim = !targetEl ? showingInterims.shift() : null;
	
	        var parentEl = angular.element(targetEl).length && angular.element(targetEl)[0].parentNode;
	
	        if (parentEl) {
	          // Try to find the interim in the stack which corresponds to the supplied DOM element.
	          var filtered = showingInterims.filter(function(entry) {
	            return entry.options.element[0] === parentEl;
	          });
	
	          // Note: This function might be called when the element already has been removed,
	          // in which case we won't find any matches.
	          if (filtered.length) {
	            interim = filtered[0];
	            showingInterims.splice(showingInterims.indexOf(interim), 1);
	          }
	        }
	
	        return interim ? interim.remove(SHOW_CANCELLED, false, { '$destroy': true }) :
	                         $q.when(SHOW_CANCELLED);
	      }
	
	      /*
	       * Internal Interim Element Object
	       * Used internally to manage the DOM element and related data
	       */
	      function InterimElement(options) {
	        var self, element, showAction = $q.when(true);
	
	        options = configureScopeAndTransitions(options);
	
	        return self = {
	          options : options,
	          deferred: $q.defer(),
	          show    : createAndTransitionIn,
	          remove  : transitionOutAndRemove
	        };
	
	        /**
	         * Compile, link, and show this interim element
	         * Use optional autoHided and transition-in effects
	         */
	        function createAndTransitionIn() {
	          return $q(function(resolve, reject) {
	
	            // Trigger onCompiling callback before the compilation starts.
	            // This is useful, when modifying options, which can be influenced by developers.
	            options.onCompiling && options.onCompiling(options);
	
	            compileElement(options)
	              .then(function( compiledData ) {
	                element = linkElement( compiledData, options );
	
	                // Expose the cleanup function from the compiler.
	                options.cleanupElement = compiledData.cleanup;
	
	                showAction = showElement(element, options, compiledData.controller)
	                  .then(resolve, rejectAll);
	              }).catch(rejectAll);
	
	            function rejectAll(fault) {
	              // Force the '$md<xxx>.show()' promise to reject
	              self.deferred.reject(fault);
	
	              // Continue rejection propagation
	              reject(fault);
	            }
	          });
	        }
	
	        /**
	         * After the show process has finished/rejected:
	         * - announce 'removing',
	         * - perform the transition-out, and
	         * - perform optional clean up scope.
	         */
	        function transitionOutAndRemove(response, isCancelled, opts) {
	
	          // abort if the show() and compile failed
	          if ( !element ) return $q.when(false);
	
	          options = angular.extend(options || {}, opts || {});
	          options.cancelAutoHide && options.cancelAutoHide();
	          options.element.triggerHandler('$mdInterimElementRemove');
	
	          if ( options.$destroy === true ) {
	
	            return hideElement(options.element, options).then(function(){
	              (isCancelled && rejectAll(response)) || resolveAll(response);
	            });
	
	          } else {
	            $q.when(showAction).finally(function() {
	              hideElement(options.element, options).then(function() {
	                isCancelled ? rejectAll(response) : resolveAll(response);
	              }, rejectAll);
	            });
	
	            return self.deferred.promise;
	          }
	
	
	          /**
	           * The `show()` returns a promise that will be resolved when the interim
	           * element is hidden or cancelled...
	           */
	          function resolveAll(response) {
	            self.deferred.resolve(response);
	          }
	
	          /**
	           * Force the '$md<xxx>.show()' promise to reject
	           */
	          function rejectAll(fault) {
	            self.deferred.reject(fault);
	          }
	        }
	
	        /**
	         * Prepare optional isolated scope and prepare $animate with default enter and leave
	         * transitions for the new element instance.
	         */
	        function configureScopeAndTransitions(options) {
	          options = options || { };
	          if ( options.template ) {
	            options.template = $mdUtil.processTemplate(options.template);
	          }
	
	          return angular.extend({
	            preserveScope: false,
	            cancelAutoHide : angular.noop,
	            scope: options.scope || $rootScope.$new(options.isolateScope),
	
	            /**
	             * Default usage to enable $animate to transition-in; can be easily overridden via 'options'
	             */
	            onShow: function transitionIn(scope, element, options) {
	              return $animate.enter(element, options.parent);
	            },
	
	            /**
	             * Default usage to enable $animate to transition-out; can be easily overridden via 'options'
	             */
	            onRemove: function transitionOut(scope, element) {
	              // Element could be undefined if a new element is shown before
	              // the old one finishes compiling.
	              return element && $animate.leave(element) || $q.when();
	            }
	          }, options );
	
	        }
	
	        /**
	         * Compile an element with a templateUrl, controller, and locals
	         */
	        function compileElement(options) {
	
	          var compiled = !options.skipCompile ? $mdCompiler.compile(options) : null;
	
	          return compiled || $q(function (resolve) {
	              resolve({
	                locals: {},
	                link: function () {
	                  return options.element;
	                }
	              });
	            });
	        }
	
	        /**
	         *  Link an element with compiled configuration
	         */
	        function linkElement(compileData, options){
	          angular.extend(compileData.locals, options);
	
	          var element = compileData.link(options.scope);
	
	          // Search for parent at insertion time, if not specified
	          options.element = element;
	          options.parent = findParent(element, options);
	          if (options.themable) $mdTheming(element);
	
	          return element;
	        }
	
	        /**
	         * Search for parent at insertion time, if not specified
	         */
	        function findParent(element, options) {
	          var parent = options.parent;
	
	          // Search for parent at insertion time, if not specified
	          if (angular.isFunction(parent)) {
	            parent = parent(options.scope, element, options);
	          } else if (angular.isString(parent)) {
	            parent = angular.element($document[0].querySelector(parent));
	          } else {
	            parent = angular.element(parent);
	          }
	
	          // If parent querySelector/getter function fails, or it's just null,
	          // find a default.
	          if (!(parent || {}).length) {
	            var el;
	            if ($rootElement[0] && $rootElement[0].querySelector) {
	              el = $rootElement[0].querySelector(':not(svg) > body');
	            }
	            if (!el) el = $rootElement[0];
	            if (el.nodeName == '#comment') {
	              el = $document[0].body;
	            }
	            return angular.element(el);
	          }
	
	          return parent;
	        }
	
	        /**
	         * If auto-hide is enabled, start timer and prepare cancel function
	         */
	        function startAutoHide() {
	          var autoHideTimer, cancelAutoHide = angular.noop;
	
	          if (options.hideDelay) {
	            autoHideTimer = $timeout(service.hide, options.hideDelay) ;
	            cancelAutoHide = function() {
	              $timeout.cancel(autoHideTimer);
	            };
	          }
	
	          // Cache for subsequent use
	          options.cancelAutoHide = function() {
	            cancelAutoHide();
	            options.cancelAutoHide = undefined;
	          };
	        }
	
	        /**
	         * Show the element ( with transitions), notify complete and start
	         * optional auto-Hide
	         */
	        function showElement(element, options, controller) {
	          // Trigger onShowing callback before the `show()` starts
	          var notifyShowing = options.onShowing || angular.noop;
	          // Trigger onComplete callback when the `show()` finishes
	          var notifyComplete = options.onComplete || angular.noop;
	
	          // Necessary for consistency between AngularJS 1.5 and 1.6.
	          try {
	            notifyShowing(options.scope, element, options, controller);
	          } catch (e) {
	            return $q.reject(e);
	          }
	
	          return $q(function (resolve, reject) {
	            try {
	              // Start transitionIn
	              $q.when(options.onShow(options.scope, element, options, controller))
	                .then(function () {
	                  notifyComplete(options.scope, element, options);
	                  startAutoHide();
	
	                  resolve(element);
	                }, reject);
	
	            } catch (e) {
	              reject(e.message);
	            }
	          });
	        }
	
	        function hideElement(element, options) {
	          var announceRemoving = options.onRemoving || angular.noop;
	
	          return $q(function (resolve, reject) {
	            try {
	              // Start transitionIn
	              var action = $q.when( options.onRemove(options.scope, element, options) || true );
	
	              // Trigger callback *before* the remove operation starts
	              announceRemoving(element, action);
	
	              if (options.$destroy) {
	                // For $destroy, onRemove should be synchronous
	                resolve(element);
	
	                if (!options.preserveScope && options.scope ) {
	                  // scope destroy should still be be done after the current digest is done
	                  action.then( function() { options.scope.$destroy(); });
	                }
	              } else {
	                // Wait until transition-out is done
	                action.then(function () {
	                  if (!options.preserveScope && options.scope ) {
	                    options.scope.$destroy();
	                  }
	
	                  resolve(element);
	                }, reject);
	              }
	            } catch (e) {
	              reject(e.message);
	            }
	          });
	        }
	
	      }
	    };
	
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  var $mdUtil, $interpolate, $log;
	
	  var SUFFIXES = /(-gt)?-(sm|md|lg|print)/g;
	  var WHITESPACE = /\s+/g;
	
	  var FLEX_OPTIONS = ['grow', 'initial', 'auto', 'none', 'noshrink', 'nogrow' ];
	  var LAYOUT_OPTIONS = ['row', 'column'];
	  var ALIGNMENT_MAIN_AXIS= [ "", "start", "center", "end", "stretch", "space-around", "space-between" ];
	  var ALIGNMENT_CROSS_AXIS= [ "", "start", "center", "end", "stretch" ];
	
	  var config = {
	    /**
	     * Enable directive attribute-to-class conversions
	     * Developers can use `<body md-layout-css />` to quickly
	     * disable the Layout directives and prohibit the injection of Layout classNames
	     */
	    enabled: true,
	
	    /**
	     * List of mediaQuery breakpoints and associated suffixes
	     *
	     *   [
	     *    { suffix: "sm", mediaQuery: "screen and (max-width: 599px)" },
	     *    { suffix: "md", mediaQuery: "screen and (min-width: 600px) and (max-width: 959px)" }
	     *   ]
	     */
	    breakpoints: []
	  };
	
	  registerLayoutAPI( angular.module('material.core.layout', ['ng']) );
	
	  /**
	   *   registerLayoutAPI()
	   *
	   *   The original AngularJS Material Layout solution used attribute selectors and CSS.
	   *
	   *  ```html
	   *  <div layout="column"> My Content </div>
	   *  ```
	   *
	   *  ```css
	   *  [layout] {
	   *    box-sizing: border-box;
	   *    display:flex;
	   *  }
	   *  [layout=column] {
	   *    flex-direction : column
	   *  }
	   *  ```
	   *
	   *  Use of attribute selectors creates significant performance impacts in some
	   *  browsers... mainly IE.
	   *
	   *  This module registers directives that allow the same layout attributes to be
	   *  interpreted and converted to class selectors. The directive will add equivalent classes to each element that
	   *  contains a Layout directive.
	   *
	   * ```html
	   *   <div layout="column" class="layout layout-column"> My Content </div>
	   *```
	   *
	   *  ```css
	   *  .layout {
	   *    box-sizing: border-box;
	   *    display:flex;
	   *  }
	   *  .layout-column {
	   *    flex-direction : column
	   *  }
	   *  ```
	   */
	  function registerLayoutAPI(module){
	    var PREFIX_REGEXP = /^((?:x|data)[\:\-_])/i;
	    var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
	
	    // NOTE: these are also defined in constants::MEDIA_PRIORITY and constants::MEDIA
	    var BREAKPOINTS     = [ "", "xs", "gt-xs", "sm", "gt-sm", "md", "gt-md", "lg", "gt-lg", "xl", "print" ];
	    var API_WITH_VALUES = [ "layout", "flex", "flex-order", "flex-offset", "layout-align" ];
	    var API_NO_VALUES   = [ "show", "hide", "layout-padding", "layout-margin" ];
	
	
	    // Build directive registration functions for the standard Layout API... for all breakpoints.
	    angular.forEach(BREAKPOINTS, function(mqb) {
	
	      // Attribute directives with expected, observable value(s)
	      angular.forEach( API_WITH_VALUES, function(name){
	        var fullName = mqb ? name + "-" + mqb : name;
	        module.directive( directiveNormalize(fullName), attributeWithObserve(fullName));
	      });
	
	      // Attribute directives with no expected value(s)
	      angular.forEach( API_NO_VALUES, function(name){
	        var fullName = mqb ? name + "-" + mqb : name;
	        module.directive( directiveNormalize(fullName), attributeWithoutValue(fullName));
	      });
	
	    });
	
	    // Register other, special directive functions for the Layout features:
	    module
	
	      .provider('$$mdLayout'     , function() {
	        // Publish internal service for Layouts
	        return {
	          $get : angular.noop,
	          validateAttributeValue : validateAttributeValue,
	          validateAttributeUsage : validateAttributeUsage,
	          /**
	           * Easy way to disable/enable the Layout API.
	           * When disabled, this stops all attribute-to-classname generations
	           */
	          disableLayouts  : function(isDisabled) {
	            config.enabled =  (isDisabled !== true);
	          }
	        };
	      })
	
	      .directive('mdLayoutCss'        , disableLayoutDirective )
	      .directive('ngCloak'            , buildCloakInterceptor('ng-cloak'))
	
	      .directive('layoutWrap'   , attributeWithoutValue('layout-wrap'))
	      .directive('layoutNowrap' , attributeWithoutValue('layout-nowrap'))
	      .directive('layoutNoWrap' , attributeWithoutValue('layout-no-wrap'))
	      .directive('layoutFill'   , attributeWithoutValue('layout-fill'))
	
	      // !! Deprecated attributes: use the `-lt` (aka less-than) notations
	
	      .directive('layoutLtMd'     , warnAttrNotSupported('layout-lt-md', true))
	      .directive('layoutLtLg'     , warnAttrNotSupported('layout-lt-lg', true))
	      .directive('flexLtMd'       , warnAttrNotSupported('flex-lt-md', true))
	      .directive('flexLtLg'       , warnAttrNotSupported('flex-lt-lg', true))
	
	      .directive('layoutAlignLtMd', warnAttrNotSupported('layout-align-lt-md'))
	      .directive('layoutAlignLtLg', warnAttrNotSupported('layout-align-lt-lg'))
	      .directive('flexOrderLtMd'  , warnAttrNotSupported('flex-order-lt-md'))
	      .directive('flexOrderLtLg'  , warnAttrNotSupported('flex-order-lt-lg'))
	      .directive('offsetLtMd'     , warnAttrNotSupported('flex-offset-lt-md'))
	      .directive('offsetLtLg'     , warnAttrNotSupported('flex-offset-lt-lg'))
	
	      .directive('hideLtMd'       , warnAttrNotSupported('hide-lt-md'))
	      .directive('hideLtLg'       , warnAttrNotSupported('hide-lt-lg'))
	      .directive('showLtMd'       , warnAttrNotSupported('show-lt-md'))
	      .directive('showLtLg'       , warnAttrNotSupported('show-lt-lg'))
	
	      // Determine if
	      .config( detectDisabledLayouts );
	
	    /**
	     * Converts snake_case to camelCase.
	     * Also there is special case for Moz prefix starting with upper case letter.
	     * @param name Name to normalize
	     */
	    function directiveNormalize(name) {
	      return name
	        .replace(PREFIX_REGEXP, '')
	        .replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
	          return offset ? letter.toUpperCase() : letter;
	        });
	    }
	
	  }
	
	
	  /**
	    * Detect if any of the HTML tags has a [md-layouts-disabled] attribute;
	    * If yes, then immediately disable all layout API features
	    *
	    * Note: this attribute should be specified on either the HTML or BODY tags
	    */
	   /**
	    * @ngInject
	    */
	   function detectDisabledLayouts() {
	     var isDisabled = !!document.querySelector('[md-layouts-disabled]');
	     config.enabled = !isDisabled;
	   }
	
	  /**
	   * Special directive that will disable ALL Layout conversions of layout
	   * attribute(s) to classname(s).
	   *
	   * <link rel="stylesheet" href="angular-material.min.css">
	   * <link rel="stylesheet" href="angular-material.layout.css">
	   *
	   * <body md-layout-css>
	   *  ...
	   * </body>
	   *
	   * Note: Using md-layout-css directive requires the developer to load the Material
	   * Layout Attribute stylesheet (which only uses attribute selectors):
	   *
	   *       `angular-material.layout.css`
	   *
	   * Another option is to use the LayoutProvider to configure and disable the attribute
	   * conversions; this would obviate the use of the `md-layout-css` directive
	   *
	   */
	  function disableLayoutDirective() {
	    // Return a 1x-only, first-match attribute directive
	    config.enabled = false;
	
	    return {
	      restrict : 'A',
	      priority : '900'
	    };
	  }
	
	  /**
	   * Tail-hook ngCloak to delay the uncloaking while Layout transformers
	   * finish processing. Eliminates flicker with Material.Layouts
	   */
	  function buildCloakInterceptor(className) {
	    return [ '$timeout', function($timeout){
	      return {
	        restrict : 'A',
	        priority : -10,   // run after normal ng-cloak
	        compile  : function( element ) {
	          if (!config.enabled) return angular.noop;
	
	          // Re-add the cloak
	          element.addClass(className);
	
	          return function( scope, element ) {
	            // Wait while layout injectors configure, then uncloak
	            // NOTE: $rAF does not delay enough... and this is a 1x-only event,
	            //       $timeout is acceptable.
	            $timeout( function(){
	              element.removeClass(className);
	            }, 10, false);
	          };
	        }
	      };
	    }];
	  }
	
	
	  // *********************************************************************************
	  //
	  // These functions create registration functions for AngularJS Material Layout attribute directives
	  // This provides easy translation to switch AngularJS Material attribute selectors to
	  // CLASS selectors and directives; which has huge performance implications
	  // for IE Browsers
	  //
	  // *********************************************************************************
	
	  /**
	   * Creates a directive registration function where a possible dynamic attribute
	   * value will be observed/watched.
	   * @param {string} className attribute name; eg `layout-gt-md` with value ="row"
	   */
	  function attributeWithObserve(className) {
	
	    return ['$mdUtil', '$interpolate', "$log", function(_$mdUtil_, _$interpolate_, _$log_) {
	      $mdUtil = _$mdUtil_;
	      $interpolate = _$interpolate_;
	      $log = _$log_;
	
	      return {
	        restrict: 'A',
	        compile: function(element, attr) {
	          var linkFn;
	          if (config.enabled) {
	            // immediately replace static (non-interpolated) invalid values...
	
	            validateAttributeUsage(className, attr, element, $log);
	
	            validateAttributeValue( className,
	              getNormalizedAttrValue(className, attr, ""),
	              buildUpdateFn(element, className, attr)
	            );
	
	            linkFn = translateWithValueToCssClass;
	          }
	
	          // Use for postLink to account for transforms after ng-transclude.
	          return linkFn || angular.noop;
	        }
	      };
	    }];
	
	    /**
	     * Add as transformed class selector(s), then
	     * remove the deprecated attribute selector
	     */
	    function translateWithValueToCssClass(scope, element, attrs) {
	      var updateFn = updateClassWithValue(element, className, attrs);
	      var unwatch = attrs.$observe(attrs.$normalize(className), updateFn);
	
	      updateFn(getNormalizedAttrValue(className, attrs, ""));
	      scope.$on("$destroy", function() { unwatch(); });
	    }
	  }
	
	  /**
	   * Creates a registration function for AngularJS Material Layout attribute directive.
	   * This is a `simple` transpose of attribute usage to class usage; where we ignore
	   * any attribute value
	   */
	  function attributeWithoutValue(className) {
	    return ['$mdUtil', '$interpolate', "$log", function(_$mdUtil_, _$interpolate_, _$log_) {
	      $mdUtil = _$mdUtil_;
	      $interpolate = _$interpolate_;
	      $log = _$log_;
	
	      return {
	        restrict: 'A',
	        compile: function(element, attr) {
	          var linkFn;
	          if (config.enabled) {
	            // immediately replace static (non-interpolated) invalid values...
	
	            validateAttributeValue( className,
	              getNormalizedAttrValue(className, attr, ""),
	              buildUpdateFn(element, className, attr)
	            );
	
	            translateToCssClass(null, element);
	
	            // Use for postLink to account for transforms after ng-transclude.
	            linkFn = translateToCssClass;
	          }
	
	          return linkFn || angular.noop;
	        }
	      };
	    }];
	
	    /**
	     * Add as transformed class selector, then
	     * remove the deprecated attribute selector
	     */
	    function translateToCssClass(scope, element) {
	      element.addClass(className);
	    }
	  }
	
	
	
	  /**
	   * After link-phase, do NOT remove deprecated layout attribute selector.
	   * Instead watch the attribute so interpolated data-bindings to layout
	   * selectors will continue to be supported.
	   *
	   * $observe() the className and update with new class (after removing the last one)
	   *
	   * e.g. `layout="{{layoutDemo.direction}}"` will update...
	   *
	   * NOTE: The value must match one of the specified styles in the CSS.
	   * For example `flex-gt-md="{{size}}`  where `scope.size == 47` will NOT work since
	   * only breakpoints for 0, 5, 10, 15... 100, 33, 34, 66, 67 are defined.
	   *
	   */
	  function updateClassWithValue(element, className) {
	    var lastClass;
	
	    return function updateClassFn(newValue) {
	      var value = validateAttributeValue(className, newValue || "");
	      if ( angular.isDefined(value) ) {
	        if (lastClass) element.removeClass(lastClass);
	        lastClass = !value ? className : className + "-" + value.trim().replace(WHITESPACE, "-");
	        element.addClass(lastClass);
	      }
	    };
	  }
	
	  /**
	   * Provide console warning that this layout attribute has been deprecated
	   *
	   */
	  function warnAttrNotSupported(className) {
	    var parts = className.split("-");
	    return ["$log", function($log) {
	      $log.warn(className + "has been deprecated. Please use a `" + parts[0] + "-gt-<xxx>` variant.");
	      return angular.noop;
	    }];
	  }
	
	  /**
	   * Centralize warnings for known flexbox issues (especially IE-related issues)
	   */
	  function validateAttributeUsage(className, attr, element, $log){
	    var message, usage, url;
	    var nodeName = element[0].nodeName.toLowerCase();
	
	    switch(className.replace(SUFFIXES,"")) {
	      case "flex":
	        if ((nodeName == "md-button") || (nodeName == "fieldset")){
	          // @see https://github.com/philipwalton/flexbugs#9-some-html-elements-cant-be-flex-containers
	          // Use <div flex> wrapper inside (preferred) or outside
	
	          usage = "<" + nodeName + " " + className + "></" + nodeName + ">";
	          url = "https://github.com/philipwalton/flexbugs#9-some-html-elements-cant-be-flex-containers";
	          message = "Markup '{0}' may not work as expected in IE Browsers. Consult '{1}' for details.";
	
	          $log.warn( $mdUtil.supplant(message, [usage, url]) );
	        }
	    }
	
	  }
	
	
	  /**
	   * For the Layout attribute value, validate or replace with default
	   * fallback value
	   */
	  function validateAttributeValue(className, value, updateFn) {
	    var origValue;
	
	    if (!needsInterpolation(value)) {
	      switch (className.replace(SUFFIXES,"")) {
	        case 'layout'        :
	          if ( !findIn(value, LAYOUT_OPTIONS) ) {
	            value = LAYOUT_OPTIONS[0];    // 'row';
	          }
	          break;
	
	        case 'flex'          :
	          if (!findIn(value, FLEX_OPTIONS)) {
	            if (isNaN(value)) {
	              value = '';
	            }
	          }
	          break;
	
	        case 'flex-offset' :
	        case 'flex-order'    :
	          if (!value || isNaN(+value)) {
	            value = '0';
	          }
	          break;
	
	        case 'layout-align'  :
	          var axis = extractAlignAxis(value);
	          value = $mdUtil.supplant("{main}-{cross}",axis);
	          break;
	
	        case 'layout-padding' :
	        case 'layout-margin'  :
	        case 'layout-fill'    :
	        case 'layout-wrap'    :
	        case 'layout-nowrap'  :
	        case 'layout-nowrap' :
	          value = '';
	          break;
	      }
	
	      if (value != origValue) {
	        (updateFn || angular.noop)(value);
	      }
	    }
	
	    return value ? value.trim() : "";
	  }
	
	  /**
	   * Replace current attribute value with fallback value
	   */
	  function buildUpdateFn(element, className, attrs) {
	    return function updateAttrValue(fallback) {
	      if (!needsInterpolation(fallback)) {
	        // Do not modify the element's attribute value; so
	        // uses '<ui-layout layout="/api/sidebar.html" />' will not
	        // be affected. Just update the attrs value.
	        attrs[attrs.$normalize(className)] = fallback;
	      }
	    };
	  }
	
	  /**
	   * See if the original value has interpolation symbols:
	   * e.g.  flex-gt-md="{{triggerPoint}}"
	   */
	  function needsInterpolation(value) {
	    return (value || "").indexOf($interpolate.startSymbol()) > -1;
	  }
	
	  function getNormalizedAttrValue(className, attrs, defaultVal) {
	    var normalizedAttr = attrs.$normalize(className);
	    return attrs[normalizedAttr] ? attrs[normalizedAttr].trim().replace(WHITESPACE, "-") : defaultVal || null;
	  }
	
	  function findIn(item, list, replaceWith) {
	    item = replaceWith && item ? item.replace(WHITESPACE, replaceWith) : item;
	
	    var found = false;
	    if (item) {
	      list.forEach(function(it) {
	        it = replaceWith ? it.replace(WHITESPACE, replaceWith) : it;
	        found = found || (it === item);
	      });
	    }
	    return found;
	  }
	
	  function extractAlignAxis(attrValue) {
	    var axis = {
	      main : "start",
	      cross: "stretch"
	    }, values;
	
	    attrValue = (attrValue || "");
	
	    if ( attrValue.indexOf("-") === 0 || attrValue.indexOf(" ") === 0) {
	      // For missing main-axis values
	      attrValue = "none" + attrValue;
	    }
	
	    values = attrValue.toLowerCase().trim().replace(WHITESPACE, "-").split("-");
	    if ( values.length && (values[0] === "space") ) {
	      // for main-axis values of "space-around" or "space-between"
	      values = [ values[0]+"-"+values[1],values[2] ];
	    }
	
	    if ( values.length > 0 ) axis.main  = values[0] || axis.main;
	    if ( values.length > 1 ) axis.cross = values[1] || axis.cross;
	
	    if ( ALIGNMENT_MAIN_AXIS.indexOf(axis.main) < 0 )   axis.main = "start";
	    if ( ALIGNMENT_CROSS_AXIS.indexOf(axis.cross) < 0 ) axis.cross = "stretch";
	
	    return axis;
	  }
	
	
	})();
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.core.liveannouncer
	 * @description
	 * AngularJS Material Live Announcer to provide accessibility for Voice Readers.
	 */
	MdLiveAnnouncer.$inject = ["$timeout"];
	angular
	  .module('material.core')
	  .service('$mdLiveAnnouncer', MdLiveAnnouncer);
	
	/**
	 * @ngdoc service
	 * @name $mdLiveAnnouncer
	 * @module material.core.liveannouncer
	 *
	 * @description
	 *
	 * Service to announce messages to supported screenreaders.
	 *
	 * > The `$mdLiveAnnouncer` service is internally used for components to provide proper accessibility.
	 *
	 * <hljs lang="js">
	 *   module.controller('AppCtrl', function($mdLiveAnnouncer) {
	 *     // Basic announcement (Polite Mode)
	 *     $mdLiveAnnouncer.announce('Hey Google');
	 *
	 *     // Custom announcement (Assertive Mode)
	 *     $mdLiveAnnouncer.announce('Hey Google', 'assertive');
	 *   });
	 * </hljs>
	 *
	 */
	function MdLiveAnnouncer($timeout) {
	  /** @private @const @type {!angular.$timeout} */
	  this._$timeout = $timeout;
	
	  /** @private @const @type {!HTMLElement} */
	  this._liveElement = this._createLiveElement();
	
	  /** @private @const @type {!number} */
	  this._announceTimeout = 100;
	}
	
	/**
	 * @ngdoc method
	 * @name $mdLiveAnnouncer#announce
	 * @description Announces messages to supported screenreaders.
	 * @param {string} message Message to be announced to the screenreader
	 * @param {'off'|'polite'|'assertive'} politeness The politeness of the announcer element.
	 */
	MdLiveAnnouncer.prototype.announce = function(message, politeness) {
	  if (!politeness) {
	    politeness = 'polite';
	  }
	
	  var self = this;
	
	  self._liveElement.textContent = '';
	  self._liveElement.setAttribute('aria-live', politeness);
	
	  // This 100ms timeout is necessary for some browser + screen-reader combinations:
	  // - Both JAWS and NVDA over IE11 will not announce anything without a non-zero timeout.
	  // - With Chrome and IE11 with NVDA or JAWS, a repeated (identical) message won't be read a
	  //   second time without clearing and then using a non-zero delay.
	  // (using JAWS 17 at time of this writing).
	  self._$timeout(function() {
	    self._liveElement.textContent = message;
	  }, self._announceTimeout, false);
	};
	
	/**
	 * Creates a live announcer element, which listens for DOM changes and announces them
	 * to the screenreaders.
	 * @returns {!HTMLElement}
	 * @private
	 */
	MdLiveAnnouncer.prototype._createLiveElement = function() {
	  var liveEl = document.createElement('div');
	
	  liveEl.classList.add('md-visually-hidden');
	  liveEl.setAttribute('role', 'status');
	  liveEl.setAttribute('aria-atomic', 'true');
	  liveEl.setAttribute('aria-live', 'polite');
	
	  document.body.appendChild(liveEl);
	
	  return liveEl;
	};
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc service
	 * @name $$mdMeta
	 * @module material.core.meta
	 *
	 * @description
	 *
	 * A provider and a service that simplifies meta tags access
	 *
	 * Note: This is intended only for use with dynamic meta tags such as browser color and title.
	 * Tags that are only processed when the page is rendered (such as `charset`, and `http-equiv`)
	 * will not work since `$$mdMeta` adds the tags after the page has already been loaded.
	 *
	 * ```js
	 * app.config(function($$mdMetaProvider) {
	 *   var removeMeta = $$mdMetaProvider.setMeta('meta-name', 'content');
	 *   var metaValue  = $$mdMetaProvider.getMeta('meta-name'); // -> 'content'
	 *
	 *   removeMeta();
	 * });
	 *
	 * app.controller('myController', function($$mdMeta) {
	 *   var removeMeta = $$mdMeta.setMeta('meta-name', 'content');
	 *   var metaValue  = $$mdMeta.getMeta('meta-name'); // -> 'content'
	 *
	 *   removeMeta();
	 * });
	 * ```
	 *
	 * @returns {$$mdMeta.$service}
	 *
	 */
	angular.module('material.core.meta', [])
	  .provider('$$mdMeta', function () {
	    var head = angular.element(document.head);
	    var metaElements = {};
	
	    /**
	     * Checks if the requested element was written manually and maps it
	     *
	     * @param {string} name meta tag 'name' attribute value
	     * @returns {boolean} returns true if there is an element with the requested name
	     */
	    function mapExistingElement(name) {
	      if (metaElements[name]) {
	        return true;
	      }
	
	      var element = document.getElementsByName(name)[0];
	
	      if (!element) {
	        return false;
	      }
	
	      metaElements[name] = angular.element(element);
	
	      return true;
	    }
	
	    /**
	     * @ngdoc method
	     * @name $$mdMeta#setMeta
	     *
	     * @description
	     * Creates meta element with the 'name' and 'content' attributes,
	     * if the meta tag is already created than we replace the 'content' value
	     *
	     * @param {string} name meta tag 'name' attribute value
	     * @param {string} content meta tag 'content' attribute value
	     * @returns {function} remove function
	     *
	     */
	    function setMeta(name, content) {
	      mapExistingElement(name);
	
	      if (!metaElements[name]) {
	        var newMeta = angular.element('<meta name="' + name + '" content="' + content + '"/>');
	        head.append(newMeta);
	        metaElements[name] = newMeta;
	      }
	      else {
	        metaElements[name].attr('content', content);
	      }
	
	      return function () {
	        metaElements[name].attr('content', '');
	        metaElements[name].remove();
	        delete metaElements[name];
	      };
	    }
	
	    /**
	     * @ngdoc method
	     * @name $$mdMeta#getMeta
	     *
	     * @description
	     * Gets the 'content' attribute value of the wanted meta element
	     *
	     * @param {string} name meta tag 'name' attribute value
	     * @returns {string} content attribute value
	     */
	    function getMeta(name) {
	      if (!mapExistingElement(name)) {
	        throw Error('$$mdMeta: could not find a meta tag with the name \'' + name + '\'');
	      }
	
	      return metaElements[name].attr('content');
	    }
	
	    var module = {
	      setMeta: setMeta,
	      getMeta: getMeta
	    };
	
	    return angular.extend({}, module, {
	      $get: function () {
	        return module;
	      }
	    });
	  });
	})();
	(function(){
	"use strict";
	
	  /**
	   * @ngdoc module
	   * @name material.core.componentRegistry
	   *
	   * @description
	   * A component instance registration service.
	   * Note: currently this as a private service in the SideNav component.
	   */
	  ComponentRegistry.$inject = ["$log", "$q"];
	  angular.module('material.core')
	    .factory('$mdComponentRegistry', ComponentRegistry);
	
	  /*
	   * @private
	   * @ngdoc factory
	   * @name ComponentRegistry
	   * @module material.core.componentRegistry
	   *
	   */
	  function ComponentRegistry($log, $q) {
	
	    var self;
	    var instances = [ ];
	    var pendings = { };
	
	    return self = {
	      /**
	       * Used to print an error when an instance for a handle isn't found.
	       */
	      notFoundError: function(handle, msgContext) {
	        $log.error( (msgContext || "") + 'No instance found for handle', handle);
	      },
	      /**
	       * Return all registered instances as an array.
	       */
	      getInstances: function() {
	        return instances;
	      },
	
	      /**
	       * Get a registered instance.
	       * @param handle the String handle to look up for a registered instance.
	       */
	      get: function(handle) {
	        if ( !isValidID(handle) ) return null;
	
	        var i, j, instance;
	        for(i = 0, j = instances.length; i < j; i++) {
	          instance = instances[i];
	          if(instance.$$mdHandle === handle) {
	            return instance;
	          }
	        }
	        return null;
	      },
	
	      /**
	       * Register an instance.
	       * @param instance the instance to register
	       * @param handle the handle to identify the instance under.
	       */
	      register: function(instance, handle) {
	        if ( !handle ) return angular.noop;
	
	        instance.$$mdHandle = handle;
	        instances.push(instance);
	        resolveWhen();
	
	        return deregister;
	
	        /**
	         * Remove registration for an instance
	         */
	        function deregister() {
	          var index = instances.indexOf(instance);
	          if (index !== -1) {
	            instances.splice(index, 1);
	          }
	        }
	
	        /**
	         * Resolve any pending promises for this instance
	         */
	        function resolveWhen() {
	          var dfd = pendings[handle];
	          if ( dfd ) {
	            dfd.forEach(function (promise) {
	              promise.resolve(instance);
	            });
	            delete pendings[handle];
	          }
	        }
	      },
	
	      /**
	       * Async accessor to registered component instance
	       * If not available then a promise is created to notify
	       * all listeners when the instance is registered.
	       */
	      when : function(handle) {
	        if ( isValidID(handle) ) {
	          var deferred = $q.defer();
	          var instance = self.get(handle);
	
	          if ( instance )  {
	            deferred.resolve( instance );
	          } else {
	            if (pendings[handle] === undefined) {
	              pendings[handle] = [];
	            }
	            pendings[handle].push(deferred);
	          }
	
	          return deferred.promise;
	        }
	        return $q.reject("Invalid `md-component-id` value.");
	      }
	
	    };
	
	    function isValidID(handle){
	      return handle && (handle !== "");
	    }
	
	  }
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc service
	   * @name $mdButtonInkRipple
	   * @module material.core
	   *
	   * @description
	   * Provides ripple effects for md-button.  See $mdInkRipple service for all possible configuration options.
	   *
	   * @param {object=} scope Scope within the current context
	   * @param {object=} element The element the ripple effect should be applied to
	   * @param {object=} options (Optional) Configuration options to override the default ripple configuration
	   */
	
	  MdButtonInkRipple.$inject = ["$mdInkRipple"];
	  angular.module('material.core')
	    .factory('$mdButtonInkRipple', MdButtonInkRipple);
	
	  function MdButtonInkRipple($mdInkRipple) {
	    return {
	      attach: function attachRipple(scope, element, options) {
	        options = angular.extend(optionsForElement(element), options);
	
	        return $mdInkRipple.attach(scope, element, options);
	      }
	    };
	
	    function optionsForElement(element) {
	      if (element.hasClass('md-icon-button')) {
	        return {
	          isMenuItem: element.hasClass('md-menu-item'),
	          fitRipple: true,
	          center: true
	        };
	      } else {
	        return {
	          isMenuItem: element.hasClass('md-menu-item'),
	          dimBackground: true
	        };
	      }
	    }
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	    /**
	   * @ngdoc service
	   * @name $mdCheckboxInkRipple
	   * @module material.core
	   *
	   * @description
	   * Provides ripple effects for md-checkbox.  See $mdInkRipple service for all possible configuration options.
	   *
	   * @param {object=} scope Scope within the current context
	   * @param {object=} element The element the ripple effect should be applied to
	   * @param {object=} options (Optional) Configuration options to override the defaultripple configuration
	   */
	
	  MdCheckboxInkRipple.$inject = ["$mdInkRipple"];
	  angular.module('material.core')
	    .factory('$mdCheckboxInkRipple', MdCheckboxInkRipple);
	
	  function MdCheckboxInkRipple($mdInkRipple) {
	    return {
	      attach: attach
	    };
	
	    function attach(scope, element, options) {
	      return $mdInkRipple.attach(scope, element, angular.extend({
	        center: true,
	        dimBackground: false,
	        fitRipple: true
	      }, options));
	    }
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc service
	   * @name $mdListInkRipple
	   * @module material.core
	   *
	   * @description
	   * Provides ripple effects for md-list.  See $mdInkRipple service for all possible configuration options.
	   *
	   * @param {object=} scope Scope within the current context
	   * @param {object=} element The element the ripple effect should be applied to
	   * @param {object=} options (Optional) Configuration options to override the defaultripple configuration
	   */
	
	  MdListInkRipple.$inject = ["$mdInkRipple"];
	  angular.module('material.core')
	    .factory('$mdListInkRipple', MdListInkRipple);
	
	  function MdListInkRipple($mdInkRipple) {
	    return {
	      attach: attach
	    };
	
	    function attach(scope, element, options) {
	      return $mdInkRipple.attach(scope, element, angular.extend({
	        center: false,
	        dimBackground: true,
	        outline: false,
	        rippleSize: 'full'
	      }, options));
	    }
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.core.ripple
	 * @description
	 * Ripple
	 */
	InkRippleCtrl.$inject = ["$scope", "$element", "rippleOptions", "$window", "$timeout", "$mdUtil", "$mdColorUtil"];
	InkRippleDirective.$inject = ["$mdButtonInkRipple", "$mdCheckboxInkRipple"];
	angular.module('material.core')
	    .provider('$mdInkRipple', InkRippleProvider)
	    .directive('mdInkRipple', InkRippleDirective)
	    .directive('mdNoInk', attrNoDirective)
	    .directive('mdNoBar', attrNoDirective)
	    .directive('mdNoStretch', attrNoDirective);
	
	var DURATION = 450;
	
	/**
	 * @ngdoc directive
	 * @name mdInkRipple
	 * @module material.core.ripple
	 *
	 * @description
	 * The `md-ink-ripple` directive allows you to specify the ripple color or id a ripple is allowed.
	 *
	 * @param {string|boolean} md-ink-ripple A color string `#FF0000` or boolean (`false` or `0`) for preventing ripple
	 *
	 * @usage
	 * ### String values
	 * <hljs lang="html">
	 *   <ANY md-ink-ripple="#FF0000">
	 *     Ripples in red
	 *   </ANY>
	 *
	 *   <ANY md-ink-ripple="false">
	 *     Not rippling
	 *   </ANY>
	 * </hljs>
	 *
	 * ### Interpolated values
	 * <hljs lang="html">
	 *   <ANY md-ink-ripple="{{ randomColor() }}">
	 *     Ripples with the return value of 'randomColor' function
	 *   </ANY>
	 *
	 *   <ANY md-ink-ripple="{{ canRipple() }}">
	 *     Ripples if 'canRipple' function return value is not 'false' or '0'
	 *   </ANY>
	 * </hljs>
	 */
	function InkRippleDirective ($mdButtonInkRipple, $mdCheckboxInkRipple) {
	  return {
	    controller: angular.noop,
	    link:       function (scope, element, attr) {
	      attr.hasOwnProperty('mdInkRippleCheckbox')
	          ? $mdCheckboxInkRipple.attach(scope, element)
	          : $mdButtonInkRipple.attach(scope, element);
	    }
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $mdInkRipple
	 * @module material.core.ripple
	 *
	 * @description
	 * `$mdInkRipple` is a service for adding ripples to any element
	 *
	 * @usage
	 * <hljs lang="js">
	 * app.factory('$myElementInkRipple', function($mdInkRipple) {
	 *   return {
	 *     attach: function (scope, element, options) {
	 *       return $mdInkRipple.attach(scope, element, angular.extend({
	 *         center: false,
	 *         dimBackground: true
	 *       }, options));
	 *     }
	 *   };
	 * });
	 *
	 * app.controller('myController', function ($scope, $element, $myElementInkRipple) {
	 *   $scope.onClick = function (ev) {
	 *     $myElementInkRipple.attach($scope, angular.element(ev.target), { center: true });
	 *   }
	 * });
	 * </hljs>
	 *
	 * ### Disabling ripples globally
	 * If you want to disable ink ripples globally, for all components, you can call the
	 * `disableInkRipple` method in your app's config.
	 *
	 * <hljs lang="js">
	 * app.config(function ($mdInkRippleProvider) {
	 *   $mdInkRippleProvider.disableInkRipple();
	 * });
	 */
	
	function InkRippleProvider () {
	  var isDisabledGlobally = false;
	
	  return {
	    disableInkRipple: disableInkRipple,
	    $get: ["$injector", function($injector) {
	      return { attach: attach };
	
	      /**
	       * @ngdoc method
	       * @name $mdInkRipple#attach
	       *
	       * @description
	       * Attaching given scope, element and options to inkRipple controller
	       *
	       * @param {object=} scope Scope within the current context
	       * @param {object=} element The element the ripple effect should be applied to
	       * @param {object=} options (Optional) Configuration options to override the defaultRipple configuration
	       * * `center` -  Whether the ripple should start from the center of the container element
	       * * `dimBackground` - Whether the background should be dimmed with the ripple color
	       * * `colorElement` - The element the ripple should take its color from, defined by css property `color`
	       * * `fitRipple` - Whether the ripple should fill the element
	       */
	      function attach (scope, element, options) {
	        if (isDisabledGlobally || element.controller('mdNoInk')) return angular.noop;
	        return $injector.instantiate(InkRippleCtrl, {
	          $scope:        scope,
	          $element:      element,
	          rippleOptions: options
	        });
	      }
	    }]
	  };
	
	  /**
	   * @ngdoc method
	   * @name $mdInkRipple#disableInkRipple
	   *
	   * @description
	   * A config-time method that, when called, disables ripples globally.
	   */
	  function disableInkRipple () {
	    isDisabledGlobally = true;
	  }
	}
	
	/**
	 * Controller used by the ripple service in order to apply ripples
	 * @ngInject
	 */
	function InkRippleCtrl ($scope, $element, rippleOptions, $window, $timeout, $mdUtil, $mdColorUtil) {
	  this.$window    = $window;
	  this.$timeout   = $timeout;
	  this.$mdUtil    = $mdUtil;
	  this.$mdColorUtil    = $mdColorUtil;
	  this.$scope     = $scope;
	  this.$element   = $element;
	  this.options    = rippleOptions;
	  this.mousedown  = false;
	  this.ripples    = [];
	  this.timeout    = null; // Stores a reference to the most-recent ripple timeout
	  this.lastRipple = null;
	
	  $mdUtil.valueOnUse(this, 'container', this.createContainer);
	
	  this.$element.addClass('md-ink-ripple');
	
	  // attach method for unit tests
	  ($element.controller('mdInkRipple') || {}).createRipple = angular.bind(this, this.createRipple);
	  ($element.controller('mdInkRipple') || {}).setColor = angular.bind(this, this.color);
	
	  this.bindEvents();
	}
	
	
	/**
	 * Either remove or unlock any remaining ripples when the user mouses off of the element (either by
	 * mouseup or mouseleave event)
	 */
	function autoCleanup (self, cleanupFn) {
	
	  if ( self.mousedown || self.lastRipple ) {
	    self.mousedown = false;
	    self.$mdUtil.nextTick( angular.bind(self, cleanupFn), false);
	  }
	
	}
	
	
	/**
	 * Returns the color that the ripple should be (either based on CSS or hard-coded)
	 * @returns {string}
	 */
	InkRippleCtrl.prototype.color = function (value) {
	  var self = this;
	
	  // If assigning a color value, apply it to background and the ripple color
	  if (angular.isDefined(value)) {
	    self._color = self._parseColor(value);
	  }
	
	  // If color lookup, use assigned, defined, or inherited
	  return self._color || self._parseColor( self.inkRipple() ) || self._parseColor( getElementColor() );
	
	  /**
	   * Finds the color element and returns its text color for use as default ripple color
	   * @returns {string}
	   */
	  function getElementColor () {
	    var items = self.options && self.options.colorElement ? self.options.colorElement : [];
	    var elem =  items.length ? items[ 0 ] : self.$element[ 0 ];
	
	    return elem ? self.$window.getComputedStyle(elem).color : 'rgb(0,0,0)';
	  }
	};
	
	/**
	 * Updating the ripple colors based on the current inkRipple value
	 * or the element's computed style color
	 */
	InkRippleCtrl.prototype.calculateColor = function () {
	  return this.color();
	};
	
	
	/**
	 * Takes a string color and converts it to RGBA format
	 * @param color {string}
	 * @param [multiplier] {int}
	 * @returns {string}
	 */
	
	InkRippleCtrl.prototype._parseColor = function parseColor (color, multiplier) {
	  multiplier = multiplier || 1;
	  var colorUtil = this.$mdColorUtil;
	
	  if (!color) return;
	  if (color.indexOf('rgba') === 0) return color.replace(/\d?\.?\d*\s*\)\s*$/, (0.1 * multiplier).toString() + ')');
	  if (color.indexOf('rgb') === 0) return colorUtil.rgbToRgba(color);
	  if (color.indexOf('#') === 0) return colorUtil.hexToRgba(color);
	
	};
	
	/**
	 * Binds events to the root element for
	 */
	InkRippleCtrl.prototype.bindEvents = function () {
	  this.$element.on('mousedown', angular.bind(this, this.handleMousedown));
	  this.$element.on('mouseup touchend', angular.bind(this, this.handleMouseup));
	  this.$element.on('mouseleave', angular.bind(this, this.handleMouseup));
	  this.$element.on('touchmove', angular.bind(this, this.handleTouchmove));
	};
	
	/**
	 * Create a new ripple on every mousedown event from the root element
	 * @param event {MouseEvent}
	 */
	InkRippleCtrl.prototype.handleMousedown = function (event) {
	  if ( this.mousedown ) return;
	
	  // When jQuery is loaded, we have to get the original event
	  if (event.hasOwnProperty('originalEvent')) event = event.originalEvent;
	  this.mousedown = true;
	  if (this.options.center) {
	    this.createRipple(this.container.prop('clientWidth') / 2, this.container.prop('clientWidth') / 2);
	  } else {
	
	    // We need to calculate the relative coordinates if the target is a sublayer of the ripple element
	    if (event.srcElement !== this.$element[0]) {
	      var layerRect = this.$element[0].getBoundingClientRect();
	      var layerX = event.clientX - layerRect.left;
	      var layerY = event.clientY - layerRect.top;
	
	      this.createRipple(layerX, layerY);
	    } else {
	      this.createRipple(event.offsetX, event.offsetY);
	    }
	  }
	};
	
	/**
	 * Either remove or unlock any remaining ripples when the user mouses off of the element (either by
	 * mouseup, touchend or mouseleave event)
	 */
	InkRippleCtrl.prototype.handleMouseup = function () {
	  autoCleanup(this, this.clearRipples);
	};
	
	/**
	 * Either remove or unlock any remaining ripples when the user mouses off of the element (by
	 * touchmove)
	 */
	InkRippleCtrl.prototype.handleTouchmove = function () {
	  autoCleanup(this, this.deleteRipples);
	};
	
	/**
	 * Cycles through all ripples and attempts to remove them.
	 */
	InkRippleCtrl.prototype.deleteRipples = function () {
	  for (var i = 0; i < this.ripples.length; i++) {
	    this.ripples[ i ].remove();
	  }
	};
	
	/**
	 * Cycles through all ripples and attempts to remove them with fade.
	 * Depending on logic within `fadeInComplete`, some removals will be postponed.
	 */
	InkRippleCtrl.prototype.clearRipples = function () {
	  for (var i = 0; i < this.ripples.length; i++) {
	    this.fadeInComplete(this.ripples[ i ]);
	  }
	};
	
	/**
	 * Creates the ripple container element
	 * @returns {*}
	 */
	InkRippleCtrl.prototype.createContainer = function () {
	  var container = angular.element('<div class="md-ripple-container"></div>');
	  this.$element.append(container);
	  return container;
	};
	
	InkRippleCtrl.prototype.clearTimeout = function () {
	  if (this.timeout) {
	    this.$timeout.cancel(this.timeout);
	    this.timeout = null;
	  }
	};
	
	InkRippleCtrl.prototype.isRippleAllowed = function () {
	  var element = this.$element[0];
	  do {
	    if (!element.tagName || element.tagName === 'BODY') break;
	
	    if (element && angular.isFunction(element.hasAttribute)) {
	      if (element.hasAttribute('disabled')) return false;
	      if (this.inkRipple() === 'false' || this.inkRipple() === '0') return false;
	    }
	
	  } while (element = element.parentNode);
	  return true;
	};
	
	/**
	 * The attribute `md-ink-ripple` may be a static or interpolated
	 * color value OR a boolean indicator (used to disable ripples)
	 */
	InkRippleCtrl.prototype.inkRipple = function () {
	  return this.$element.attr('md-ink-ripple');
	};
	
	/**
	 * Creates a new ripple and adds it to the container.  Also tracks ripple in `this.ripples`.
	 * @param left
	 * @param top
	 */
	InkRippleCtrl.prototype.createRipple = function (left, top) {
	  if (!this.isRippleAllowed()) return;
	
	  var ctrl        = this;
	  var colorUtil   = ctrl.$mdColorUtil;
	  var ripple      = angular.element('<div class="md-ripple"></div>');
	  var width       = this.$element.prop('clientWidth');
	  var height      = this.$element.prop('clientHeight');
	  var x           = Math.max(Math.abs(width - left), left) * 2;
	  var y           = Math.max(Math.abs(height - top), top) * 2;
	  var size        = getSize(this.options.fitRipple, x, y);
	  var color       = this.calculateColor();
	
	  ripple.css({
	    left:            left + 'px',
	    top:             top + 'px',
	    background:      'black',
	    width:           size + 'px',
	    height:          size + 'px',
	    backgroundColor: colorUtil.rgbaToRgb(color),
	    borderColor:     colorUtil.rgbaToRgb(color)
	  });
	  this.lastRipple = ripple;
	
	  // we only want one timeout to be running at a time
	  this.clearTimeout();
	  this.timeout    = this.$timeout(function () {
	    ctrl.clearTimeout();
	    if (!ctrl.mousedown) ctrl.fadeInComplete(ripple);
	  }, DURATION * 0.35, false);
	
	  if (this.options.dimBackground) this.container.css({ backgroundColor: color });
	  this.container.append(ripple);
	  this.ripples.push(ripple);
	  ripple.addClass('md-ripple-placed');
	
	  this.$mdUtil.nextTick(function () {
	
	    ripple.addClass('md-ripple-scaled md-ripple-active');
	    ctrl.$timeout(function () {
	      ctrl.clearRipples();
	    }, DURATION, false);
	
	  }, false);
	
	  function getSize (fit, x, y) {
	    return fit
	        ? Math.max(x, y)
	        : Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
	  }
	};
	
	
	
	/**
	 * After fadeIn finishes, either kicks off the fade-out animation or queues the element for removal on mouseup
	 * @param ripple
	 */
	InkRippleCtrl.prototype.fadeInComplete = function (ripple) {
	  if (this.lastRipple === ripple) {
	    if (!this.timeout && !this.mousedown) {
	      this.removeRipple(ripple);
	    }
	  } else {
	    this.removeRipple(ripple);
	  }
	};
	
	/**
	 * Kicks off the animation for removing a ripple
	 * @param ripple {Element}
	 */
	InkRippleCtrl.prototype.removeRipple = function (ripple) {
	  var ctrl  = this;
	  var index = this.ripples.indexOf(ripple);
	  if (index < 0) return;
	  this.ripples.splice(this.ripples.indexOf(ripple), 1);
	  ripple.removeClass('md-ripple-active');
	  ripple.addClass('md-ripple-remove');
	  if (this.ripples.length === 0) this.container.css({ backgroundColor: '' });
	  // use a 2-second timeout in order to allow for the animation to finish
	  // we don't actually care how long the animation takes
	  this.$timeout(function () {
	    ctrl.fadeOutComplete(ripple);
	  }, DURATION, false);
	};
	
	/**
	 * Removes the provided ripple from the DOM
	 * @param ripple
	 */
	InkRippleCtrl.prototype.fadeOutComplete = function (ripple) {
	  ripple.remove();
	  this.lastRipple = null;
	};
	
	/**
	 * Used to create an empty directive.  This is used to track flag-directives whose children may have
	 * functionality based on them.
	 *
	 * Example: `md-no-ink` will potentially be used by all child directives.
	 */
	function attrNoDirective () {
	  return { controller: angular.noop };
	}
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	    /**
	   * @ngdoc service
	   * @name $mdTabInkRipple
	   * @module material.core
	   *
	   * @description
	   * Provides ripple effects for md-tabs.  See $mdInkRipple service for all possible configuration options.
	   *
	   * @param {object=} scope Scope within the current context
	   * @param {object=} element The element the ripple effect should be applied to
	   * @param {object=} options (Optional) Configuration options to override the defaultripple configuration
	   */
	
	  MdTabInkRipple.$inject = ["$mdInkRipple"];
	  angular.module('material.core')
	    .factory('$mdTabInkRipple', MdTabInkRipple);
	
	  function MdTabInkRipple($mdInkRipple) {
	    return {
	      attach: attach
	    };
	
	    function attach(scope, element, options) {
	      return $mdInkRipple.attach(scope, element, angular.extend({
	        center: false,
	        dimBackground: true,
	        outline: false,
	        rippleSize: 'full'
	      }, options));
	    }
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	angular.module('material.core.theming.palette', [])
	.constant('$mdColorPalette', {
	  'red': {
	    '50': '#ffebee',
	    '100': '#ffcdd2',
	    '200': '#ef9a9a',
	    '300': '#e57373',
	    '400': '#ef5350',
	    '500': '#f44336',
	    '600': '#e53935',
	    '700': '#d32f2f',
	    '800': '#c62828',
	    '900': '#b71c1c',
	    'A100': '#ff8a80',
	    'A200': '#ff5252',
	    'A400': '#ff1744',
	    'A700': '#d50000',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 300 A100',
	    'contrastStrongLightColors': '400 500 600 700 A200 A400 A700'
	  },
	  'pink': {
	    '50': '#fce4ec',
	    '100': '#f8bbd0',
	    '200': '#f48fb1',
	    '300': '#f06292',
	    '400': '#ec407a',
	    '500': '#e91e63',
	    '600': '#d81b60',
	    '700': '#c2185b',
	    '800': '#ad1457',
	    '900': '#880e4f',
	    'A100': '#ff80ab',
	    'A200': '#ff4081',
	    'A400': '#f50057',
	    'A700': '#c51162',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 A100',
	    'contrastStrongLightColors': '500 600 A200 A400 A700'
	  },
	  'purple': {
	    '50': '#f3e5f5',
	    '100': '#e1bee7',
	    '200': '#ce93d8',
	    '300': '#ba68c8',
	    '400': '#ab47bc',
	    '500': '#9c27b0',
	    '600': '#8e24aa',
	    '700': '#7b1fa2',
	    '800': '#6a1b9a',
	    '900': '#4a148c',
	    'A100': '#ea80fc',
	    'A200': '#e040fb',
	    'A400': '#d500f9',
	    'A700': '#aa00ff',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 A100',
	    'contrastStrongLightColors': '300 400 A200 A400 A700'
	  },
	  'deep-purple': {
	    '50': '#ede7f6',
	    '100': '#d1c4e9',
	    '200': '#b39ddb',
	    '300': '#9575cd',
	    '400': '#7e57c2',
	    '500': '#673ab7',
	    '600': '#5e35b1',
	    '700': '#512da8',
	    '800': '#4527a0',
	    '900': '#311b92',
	    'A100': '#b388ff',
	    'A200': '#7c4dff',
	    'A400': '#651fff',
	    'A700': '#6200ea',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 A100',
	    'contrastStrongLightColors': '300 400 A200'
	  },
	  'indigo': {
	    '50': '#e8eaf6',
	    '100': '#c5cae9',
	    '200': '#9fa8da',
	    '300': '#7986cb',
	    '400': '#5c6bc0',
	    '500': '#3f51b5',
	    '600': '#3949ab',
	    '700': '#303f9f',
	    '800': '#283593',
	    '900': '#1a237e',
	    'A100': '#8c9eff',
	    'A200': '#536dfe',
	    'A400': '#3d5afe',
	    'A700': '#304ffe',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 A100',
	    'contrastStrongLightColors': '300 400 A200 A400'
	  },
	  'blue': {
	    '50': '#e3f2fd',
	    '100': '#bbdefb',
	    '200': '#90caf9',
	    '300': '#64b5f6',
	    '400': '#42a5f5',
	    '500': '#2196f3',
	    '600': '#1e88e5',
	    '700': '#1976d2',
	    '800': '#1565c0',
	    '900': '#0d47a1',
	    'A100': '#82b1ff',
	    'A200': '#448aff',
	    'A400': '#2979ff',
	    'A700': '#2962ff',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 300 400 A100',
	    'contrastStrongLightColors': '500 600 700 A200 A400 A700'
	  },
	  'light-blue': {
	    '50': '#e1f5fe',
	    '100': '#b3e5fc',
	    '200': '#81d4fa',
	    '300': '#4fc3f7',
	    '400': '#29b6f6',
	    '500': '#03a9f4',
	    '600': '#039be5',
	    '700': '#0288d1',
	    '800': '#0277bd',
	    '900': '#01579b',
	    'A100': '#80d8ff',
	    'A200': '#40c4ff',
	    'A400': '#00b0ff',
	    'A700': '#0091ea',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '600 700 800 900 A700',
	    'contrastStrongLightColors': '600 700 800 A700'
	  },
	  'cyan': {
	    '50': '#e0f7fa',
	    '100': '#b2ebf2',
	    '200': '#80deea',
	    '300': '#4dd0e1',
	    '400': '#26c6da',
	    '500': '#00bcd4',
	    '600': '#00acc1',
	    '700': '#0097a7',
	    '800': '#00838f',
	    '900': '#006064',
	    'A100': '#84ffff',
	    'A200': '#18ffff',
	    'A400': '#00e5ff',
	    'A700': '#00b8d4',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '700 800 900',
	    'contrastStrongLightColors': '700 800 900'
	  },
	  'teal': {
	    '50': '#e0f2f1',
	    '100': '#b2dfdb',
	    '200': '#80cbc4',
	    '300': '#4db6ac',
	    '400': '#26a69a',
	    '500': '#009688',
	    '600': '#00897b',
	    '700': '#00796b',
	    '800': '#00695c',
	    '900': '#004d40',
	    'A100': '#a7ffeb',
	    'A200': '#64ffda',
	    'A400': '#1de9b6',
	    'A700': '#00bfa5',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '500 600 700 800 900',
	    'contrastStrongLightColors': '500 600 700'
	  },
	  'green': {
	    '50': '#e8f5e9',
	    '100': '#c8e6c9',
	    '200': '#a5d6a7',
	    '300': '#81c784',
	    '400': '#66bb6a',
	    '500': '#4caf50',
	    '600': '#43a047',
	    '700': '#388e3c',
	    '800': '#2e7d32',
	    '900': '#1b5e20',
	    'A100': '#b9f6ca',
	    'A200': '#69f0ae',
	    'A400': '#00e676',
	    'A700': '#00c853',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '500 600 700 800 900',
	    'contrastStrongLightColors': '500 600 700'
	  },
	  'light-green': {
	    '50': '#f1f8e9',
	    '100': '#dcedc8',
	    '200': '#c5e1a5',
	    '300': '#aed581',
	    '400': '#9ccc65',
	    '500': '#8bc34a',
	    '600': '#7cb342',
	    '700': '#689f38',
	    '800': '#558b2f',
	    '900': '#33691e',
	    'A100': '#ccff90',
	    'A200': '#b2ff59',
	    'A400': '#76ff03',
	    'A700': '#64dd17',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '700 800 900',
	    'contrastStrongLightColors': '700 800 900'
	  },
	  'lime': {
	    '50': '#f9fbe7',
	    '100': '#f0f4c3',
	    '200': '#e6ee9c',
	    '300': '#dce775',
	    '400': '#d4e157',
	    '500': '#cddc39',
	    '600': '#c0ca33',
	    '700': '#afb42b',
	    '800': '#9e9d24',
	    '900': '#827717',
	    'A100': '#f4ff81',
	    'A200': '#eeff41',
	    'A400': '#c6ff00',
	    'A700': '#aeea00',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '900',
	    'contrastStrongLightColors': '900'
	  },
	  'yellow': {
	    '50': '#fffde7',
	    '100': '#fff9c4',
	    '200': '#fff59d',
	    '300': '#fff176',
	    '400': '#ffee58',
	    '500': '#ffeb3b',
	    '600': '#fdd835',
	    '700': '#fbc02d',
	    '800': '#f9a825',
	    '900': '#f57f17',
	    'A100': '#ffff8d',
	    'A200': '#ffff00',
	    'A400': '#ffea00',
	    'A700': '#ffd600',
	    'contrastDefaultColor': 'dark'
	  },
	  'amber': {
	    '50': '#fff8e1',
	    '100': '#ffecb3',
	    '200': '#ffe082',
	    '300': '#ffd54f',
	    '400': '#ffca28',
	    '500': '#ffc107',
	    '600': '#ffb300',
	    '700': '#ffa000',
	    '800': '#ff8f00',
	    '900': '#ff6f00',
	    'A100': '#ffe57f',
	    'A200': '#ffd740',
	    'A400': '#ffc400',
	    'A700': '#ffab00',
	    'contrastDefaultColor': 'dark'
	  },
	  'orange': {
	    '50': '#fff3e0',
	    '100': '#ffe0b2',
	    '200': '#ffcc80',
	    '300': '#ffb74d',
	    '400': '#ffa726',
	    '500': '#ff9800',
	    '600': '#fb8c00',
	    '700': '#f57c00',
	    '800': '#ef6c00',
	    '900': '#e65100',
	    'A100': '#ffd180',
	    'A200': '#ffab40',
	    'A400': '#ff9100',
	    'A700': '#ff6d00',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '800 900',
	    'contrastStrongLightColors': '800 900'
	  },
	  'deep-orange': {
	    '50': '#fbe9e7',
	    '100': '#ffccbc',
	    '200': '#ffab91',
	    '300': '#ff8a65',
	    '400': '#ff7043',
	    '500': '#ff5722',
	    '600': '#f4511e',
	    '700': '#e64a19',
	    '800': '#d84315',
	    '900': '#bf360c',
	    'A100': '#ff9e80',
	    'A200': '#ff6e40',
	    'A400': '#ff3d00',
	    'A700': '#dd2c00',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 300 400 A100 A200',
	    'contrastStrongLightColors': '500 600 700 800 900 A400 A700'
	  },
	  'brown': {
	    '50': '#efebe9',
	    '100': '#d7ccc8',
	    '200': '#bcaaa4',
	    '300': '#a1887f',
	    '400': '#8d6e63',
	    '500': '#795548',
	    '600': '#6d4c41',
	    '700': '#5d4037',
	    '800': '#4e342e',
	    '900': '#3e2723',
	    'A100': '#d7ccc8',
	    'A200': '#bcaaa4',
	    'A400': '#8d6e63',
	    'A700': '#5d4037',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 A100 A200',
	    'contrastStrongLightColors': '300 400'
	  },
	  'grey': {
	    '50': '#fafafa',
	    '100': '#f5f5f5',
	    '200': '#eeeeee',
	    '300': '#e0e0e0',
	    '400': '#bdbdbd',
	    '500': '#9e9e9e',
	    '600': '#757575',
	    '700': '#616161',
	    '800': '#424242',
	    '900': '#212121',
	    'A100': '#ffffff',
	    'A200': '#000000',
	    'A400': '#303030',
	    'A700': '#616161',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '600 700 800 900 A200 A400 A700'
	  },
	  'blue-grey': {
	    '50': '#eceff1',
	    '100': '#cfd8dc',
	    '200': '#b0bec5',
	    '300': '#90a4ae',
	    '400': '#78909c',
	    '500': '#607d8b',
	    '600': '#546e7a',
	    '700': '#455a64',
	    '800': '#37474f',
	    '900': '#263238',
	    'A100': '#cfd8dc',
	    'A200': '#b0bec5',
	    'A400': '#78909c',
	    'A700': '#455a64',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 300 A100 A200',
	    'contrastStrongLightColors': '400 500 700'
	  }
	});
	
	})();
	(function(){
	"use strict";
	
	(function(angular) {
	  'use strict';
	/**
	 * @ngdoc module
	 * @name material.core.theming
	 * @description
	 * Theming
	 */
	detectDisabledThemes.$inject = ["$mdThemingProvider"];
	ThemingDirective.$inject = ["$mdTheming", "$interpolate", "$parse", "$mdUtil", "$q", "$log"];
	ThemableDirective.$inject = ["$mdTheming"];
	ThemingProvider.$inject = ["$mdColorPalette", "$$mdMetaProvider"];
	generateAllThemes.$inject = ["$injector", "$mdTheming"];
	angular.module('material.core.theming', ['material.core.theming.palette', 'material.core.meta'])
	  .directive('mdTheme', ThemingDirective)
	  .directive('mdThemable', ThemableDirective)
	  .directive('mdThemesDisabled', disableThemesDirective )
	  .provider('$mdTheming', ThemingProvider)
	  .config( detectDisabledThemes )
	  .run(generateAllThemes);
	
	/**
	 * Detect if the HTML or the BODY tags has a [md-themes-disabled] attribute
	 * If yes, then immediately disable all theme stylesheet generation and DOM injection
	 */
	/**
	 * @ngInject
	 */
	function detectDisabledThemes($mdThemingProvider) {
	  var isDisabled = !!document.querySelector('[md-themes-disabled]');
	  $mdThemingProvider.disableTheming(isDisabled);
	}
	
	/**
	 * @ngdoc service
	 * @name $mdThemingProvider
	 * @module material.core.theming
	 *
	 * @description Provider to configure the `$mdTheming` service.
	 *
	 * ### Default Theme
	 * The `$mdThemingProvider` uses by default the following theme configuration:
	 *
	 * - Primary Palette: `Blue`
	 * - Accent Palette: `Pink`
	 * - Warn Palette: `Deep-Orange`
	 * - Background Palette: `Grey`
	 *
	 * If you don't want to use the `md-theme` directive on the elements itself, you may want to overwrite
	 * the default theme.<br/>
	 * This can be done by using the following markup.
	 *
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdThemingProvider) {
	 *     $mdThemingProvider
	 *       .theme('default')
	 *       .primaryPalette('blue')
	 *       .accentPalette('teal')
	 *       .warnPalette('red')
	 *       .backgroundPalette('grey');
	 *   });
	 * </hljs>
	 *
	
	 * ### Dynamic Themes
	 *
	 * By default, if you change a theme at runtime, the `$mdTheming` service will not detect those changes.<br/>
	 * If you have an application, which changes its theme on runtime, you have to enable theme watching.
	 *
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdThemingProvider) {
	 *     // Enable theme watching.
	 *     $mdThemingProvider.alwaysWatchTheme(true);
	 *   });
	 * </hljs>
	 *
	 * ### Custom Theme Styles
	 *
	 * Sometimes you may want to use your own theme styles for some custom components.<br/>
	 * You are able to register your own styles by using the following markup.
	 *
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdThemingProvider) {
	 *     // Register our custom stylesheet into the theming provider.
	 *     $mdThemingProvider.registerStyles(STYLESHEET);
	 *   });
	 * </hljs>
	 *
	 * The `registerStyles` method only accepts strings as value, so you're actually not able to load an external
	 * stylesheet file into the `$mdThemingProvider`.
	 *
	 * If it's necessary to load an external stylesheet, we suggest using a bundler, which supports including raw content,
	 * like [raw-loader](https://github.com/webpack/raw-loader) for `webpack`.
	 *
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdThemingProvider) {
	 *     // Register your custom stylesheet into the theming provider.
	 *     $mdThemingProvider.registerStyles(require('../styles/my-component.theme.css'));
	 *   });
	 * </hljs>
	 *
	 * ### Browser color
	 *
	 * Enables browser header coloring
	 * for more info please visit:
	 * https://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color
	 *
	 * Options parameter: <br/>
	 * `theme`   - A defined theme via `$mdThemeProvider` to use the palettes from. Default is `default` theme. <br/>
	 * `palette` - Can be any one of the basic material design palettes, extended defined palettes and 'primary',
	 *             'accent', 'background' and 'warn'. Default is `primary`. <br/>
	 * `hue`     - The hue from the selected palette. Default is `800`<br/>
	 *
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdThemingProvider) {
	 *     // Enable browser color
	 *     $mdThemingProvider.enableBrowserColor({
	 *       theme: 'myTheme', // Default is 'default'
	 *       palette: 'accent', // Default is 'primary', any basic material palette and extended palettes are available
	 *       hue: '200' // Default is '800'
	 *     });
	 *   });
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdThemingProvider#registerStyles
	 * @param {string} styles The styles to be appended to AngularJS Material's built in theme css.
	 */
	/**
	 * @ngdoc method
	 * @name $mdThemingProvider#setNonce
	 * @param {string} nonceValue The nonce to be added as an attribute to the theme style tags.
	 * Setting a value allows the use of CSP policy without using the unsafe-inline directive.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdThemingProvider#setDefaultTheme
	 * @param {string} themeName Default theme name to be applied to elements. Default value is `default`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdThemingProvider#alwaysWatchTheme
	 * @param {boolean} watch Whether or not to always watch themes for changes and re-apply
	 * classes when they change. Default is `false`. Enabling can reduce performance.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdThemingProvider#enableBrowserColor
	 * @param {Object=} options Options object for the browser color<br/>
	 * `theme`   - A defined theme via `$mdThemeProvider` to use the palettes from. Default is `default` theme. <br/>
	 * `palette` - Can be any one of the basic material design palettes, extended defined palettes and 'primary',
	 *             'accent', 'background' and 'warn'. Default is `primary`. <br/>
	 * `hue`     - The hue from the selected palette. Default is `800`<br/>
	 * @returns {Function} remove function of the browser color
	 */
	
	/* Some Example Valid Theming Expressions
	 * =======================================
	 *
	 * Intention group expansion: (valid for primary, accent, warn, background)
	 *
	 * {{primary-100}} - grab shade 100 from the primary palette
	 * {{primary-100-0.7}} - grab shade 100, apply opacity of 0.7
	 * {{primary-100-contrast}} - grab shade 100's contrast color
	 * {{primary-hue-1}} - grab the shade assigned to hue-1 from the primary palette
	 * {{primary-hue-1-0.7}} - apply 0.7 opacity to primary-hue-1
	 * {{primary-color}} - Generates .md-hue-1, .md-hue-2, .md-hue-3 with configured shades set for each hue
	 * {{primary-color-0.7}} - Apply 0.7 opacity to each of the above rules
	 * {{primary-contrast}} - Generates .md-hue-1, .md-hue-2, .md-hue-3 with configured contrast (ie. text) color shades set for each hue
	 * {{primary-contrast-0.7}} - Apply 0.7 opacity to each of the above rules
	 *
	 * Foreground expansion: Applies rgba to black/white foreground text
	 *
	 * {{foreground-1}} - used for primary text
	 * {{foreground-2}} - used for secondary text/divider
	 * {{foreground-3}} - used for disabled text
	 * {{foreground-4}} - used for dividers
	 *
	 */
	
	// In memory generated CSS rules; registered by theme.name
	var GENERATED = { };
	
	// In memory storage of defined themes and color palettes (both loaded by CSS, and user specified)
	var PALETTES;
	
	// Text Colors on light and dark backgrounds
	// @see https://www.google.com/design/spec/style/color.html#color-text-background-colors
	var DARK_FOREGROUND = {
	  name: 'dark',
	  '1': 'rgba(0,0,0,0.87)',
	  '2': 'rgba(0,0,0,0.54)',
	  '3': 'rgba(0,0,0,0.38)',
	  '4': 'rgba(0,0,0,0.12)'
	};
	var LIGHT_FOREGROUND = {
	  name: 'light',
	  '1': 'rgba(255,255,255,1.0)',
	  '2': 'rgba(255,255,255,0.7)',
	  '3': 'rgba(255,255,255,0.5)',
	  '4': 'rgba(255,255,255,0.12)'
	};
	
	var DARK_SHADOW = '1px 1px 0px rgba(0,0,0,0.4), -1px -1px 0px rgba(0,0,0,0.4)';
	var LIGHT_SHADOW = '';
	
	var DARK_CONTRAST_COLOR = colorToRgbaArray('rgba(0,0,0,0.87)');
	var LIGHT_CONTRAST_COLOR = colorToRgbaArray('rgba(255,255,255,0.87)');
	var STRONG_LIGHT_CONTRAST_COLOR = colorToRgbaArray('rgb(255,255,255)');
	
	var THEME_COLOR_TYPES = ['primary', 'accent', 'warn', 'background'];
	var DEFAULT_COLOR_TYPE = 'primary';
	
	// A color in a theme will use these hues by default, if not specified by user.
	var LIGHT_DEFAULT_HUES = {
	  'accent': {
	    'default': 'A200',
	    'hue-1': 'A100',
	    'hue-2': 'A400',
	    'hue-3': 'A700'
	  },
	  'background': {
	    'default': '50',
	    'hue-1': 'A100',
	    'hue-2': '100',
	    'hue-3': '300'
	  }
	};
	
	var DARK_DEFAULT_HUES = {
	  'background': {
	    'default': 'A400',
	    'hue-1': '800',
	    'hue-2': '900',
	    'hue-3': 'A200'
	  }
	};
	THEME_COLOR_TYPES.forEach(function(colorType) {
	  // Color types with unspecified default hues will use these default hue values
	  var defaultDefaultHues = {
	    'default': '500',
	    'hue-1': '300',
	    'hue-2': '800',
	    'hue-3': 'A100'
	  };
	  if (!LIGHT_DEFAULT_HUES[colorType]) LIGHT_DEFAULT_HUES[colorType] = defaultDefaultHues;
	  if (!DARK_DEFAULT_HUES[colorType]) DARK_DEFAULT_HUES[colorType] = defaultDefaultHues;
	});
	
	var VALID_HUE_VALUES = [
	  '50', '100', '200', '300', '400', '500', '600',
	  '700', '800', '900', 'A100', 'A200', 'A400', 'A700'
	];
	
	var themeConfig = {
	  disableTheming : false,   // Generate our themes at run time; also disable stylesheet DOM injection
	  generateOnDemand : false, // Whether or not themes are to be generated on-demand (vs. eagerly).
	  registeredStyles : [],    // Custom styles registered to be used in the theming of custom components.
	  nonce : null              // Nonce to be added as an attribute to the generated themes style tags.
	};
	
	/**
	 *
	 */
	function ThemingProvider($mdColorPalette, $$mdMetaProvider) {
	  ThemingService.$inject = ["$rootScope", "$mdUtil", "$q", "$log"];
	  PALETTES = { };
	  var THEMES = { };
	
	  var themingProvider;
	
	  var alwaysWatchTheme = false;
	  var defaultTheme = 'default';
	
	  // Load JS Defined Palettes
	  angular.extend(PALETTES, $mdColorPalette);
	
	  // Default theme defined in core.js
	
	  /**
	   * Adds `theme-color` and `msapplication-navbutton-color` meta tags with the color parameter
	   * @param {string} color Hex value of the wanted browser color
	   * @returns {Function} Remove function of the meta tags
	   */
	  var setBrowserColor = function (color) {
	    // Chrome, Firefox OS and Opera
	    var removeChrome = $$mdMetaProvider.setMeta('theme-color', color);
	    // Windows Phone
	    var removeWindows = $$mdMetaProvider.setMeta('msapplication-navbutton-color', color);
	
	    return function () {
	      removeChrome();
	      removeWindows();
	    };
	  };
	
	  /**
	   * Enables browser header coloring
	   * for more info please visit:
	   * https://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color
	   *
	   * The default color is `800` from `primary` palette of the `default` theme
	   *
	   * options are:
	   * `theme`   - A defined theme via `$mdThemeProvider` to use the palettes from. Default is `default` theme
	   * `palette` - Can be any one of the basic material design palettes, extended defined palettes and 'primary',
	   *             'accent', 'background' and 'warn'. Default is `primary`
	   * `hue`     - The hue from the selected palette. Default is `800`
	   *
	   * @param {Object=} options Options object for the browser color
	   * @returns {Function} remove function of the browser color
	   */
	  var enableBrowserColor = function (options) {
	    options = angular.isObject(options) ? options : {};
	
	    var theme = options.theme || 'default';
	    var hue = options.hue || '800';
	
	    var palette = PALETTES[options.palette] ||
	      PALETTES[THEMES[theme].colors[options.palette || 'primary'].name];
	
	    var color = angular.isObject(palette[hue]) ? palette[hue].hex : palette[hue];
	
	    return setBrowserColor(color);
	  };
	
	  return themingProvider = {
	    definePalette: definePalette,
	    extendPalette: extendPalette,
	    theme: registerTheme,
	
	    /**
	     * return a read-only clone of the current theme configuration
	     */
	    configuration : function() {
	      return angular.extend( { }, themeConfig, {
	        defaultTheme : defaultTheme,
	        alwaysWatchTheme : alwaysWatchTheme,
	        registeredStyles : [].concat(themeConfig.registeredStyles)
	      });
	    },
	
	    /**
	     * Easy way to disable theming without having to use
	     * `.constant("$MD_THEME_CSS","");` This disables
	     * all dynamic theme style sheet generations and injections...
	     */
	    disableTheming: function(isDisabled) {
	      themeConfig.disableTheming = angular.isUndefined(isDisabled) || !!isDisabled;
	    },
	
	    registerStyles: function(styles) {
	      themeConfig.registeredStyles.push(styles);
	    },
	
	    setNonce: function(nonceValue) {
	      themeConfig.nonce = nonceValue;
	    },
	
	    generateThemesOnDemand: function(onDemand) {
	      themeConfig.generateOnDemand = onDemand;
	    },
	
	    setDefaultTheme: function(theme) {
	      defaultTheme = theme;
	    },
	
	    alwaysWatchTheme: function(alwaysWatch) {
	      alwaysWatchTheme = alwaysWatch;
	    },
	
	    enableBrowserColor: enableBrowserColor,
	
	    $get: ThemingService,
	    _LIGHT_DEFAULT_HUES: LIGHT_DEFAULT_HUES,
	    _DARK_DEFAULT_HUES: DARK_DEFAULT_HUES,
	    _PALETTES: PALETTES,
	    _THEMES: THEMES,
	    _parseRules: parseRules,
	    _rgba: rgba
	  };
	
	  // Example: $mdThemingProvider.definePalette('neonRed', { 50: '#f5fafa', ... });
	  function definePalette(name, map) {
	    map = map || {};
	    PALETTES[name] = checkPaletteValid(name, map);
	    return themingProvider;
	  }
	
	  // Returns an new object which is a copy of a given palette `name` with variables from
	  // `map` overwritten
	  // Example: var neonRedMap = $mdThemingProvider.extendPalette('red', { 50: '#f5fafafa' });
	  function extendPalette(name, map) {
	    return checkPaletteValid(name,  angular.extend({}, PALETTES[name] || {}, map) );
	  }
	
	  // Make sure that palette has all required hues
	  function checkPaletteValid(name, map) {
	    var missingColors = VALID_HUE_VALUES.filter(function(field) {
	      return !map[field];
	    });
	    if (missingColors.length) {
	      throw new Error("Missing colors %1 in palette %2!"
	                      .replace('%1', missingColors.join(', '))
	                      .replace('%2', name));
	    }
	
	    return map;
	  }
	
	  // Register a theme (which is a collection of color palettes to use with various states
	  // ie. warn, accent, primary )
	  // Optionally inherit from an existing theme
	  // $mdThemingProvider.theme('custom-theme').primaryPalette('red');
	  function registerTheme(name, inheritFrom) {
	    if (THEMES[name]) return THEMES[name];
	
	    inheritFrom = inheritFrom || 'default';
	
	    var parentTheme = typeof inheritFrom === 'string' ? THEMES[inheritFrom] : inheritFrom;
	    var theme = new Theme(name);
	
	    if (parentTheme) {
	      angular.forEach(parentTheme.colors, function(color, colorType) {
	        theme.colors[colorType] = {
	          name: color.name,
	          // Make sure a COPY of the hues is given to the child color,
	          // not the same reference.
	          hues: angular.extend({}, color.hues)
	        };
	      });
	    }
	    THEMES[name] = theme;
	
	    return theme;
	  }
	
	  function Theme(name) {
	    var self = this;
	    self.name = name;
	    self.colors = {};
	
	    self.dark = setDark;
	    setDark(false);
	
	    function setDark(isDark) {
	      isDark = arguments.length === 0 ? true : !!isDark;
	
	      // If no change, abort
	      if (isDark === self.isDark) return;
	
	      self.isDark = isDark;
	
	      self.foregroundPalette = self.isDark ? LIGHT_FOREGROUND : DARK_FOREGROUND;
	      self.foregroundShadow = self.isDark ? DARK_SHADOW : LIGHT_SHADOW;
	
	      // Light and dark themes have different default hues.
	      // Go through each existing color type for this theme, and for every
	      // hue value that is still the default hue value from the previous light/dark setting,
	      // set it to the default hue value from the new light/dark setting.
	      var newDefaultHues = self.isDark ? DARK_DEFAULT_HUES : LIGHT_DEFAULT_HUES;
	      var oldDefaultHues = self.isDark ? LIGHT_DEFAULT_HUES : DARK_DEFAULT_HUES;
	      angular.forEach(newDefaultHues, function(newDefaults, colorType) {
	        var color = self.colors[colorType];
	        var oldDefaults = oldDefaultHues[colorType];
	        if (color) {
	          for (var hueName in color.hues) {
	            if (color.hues[hueName] === oldDefaults[hueName]) {
	              color.hues[hueName] = newDefaults[hueName];
	            }
	          }
	        }
	      });
	
	      return self;
	    }
	
	    THEME_COLOR_TYPES.forEach(function(colorType) {
	      var defaultHues = (self.isDark ? DARK_DEFAULT_HUES : LIGHT_DEFAULT_HUES)[colorType];
	      self[colorType + 'Palette'] = function setPaletteType(paletteName, hues) {
	        var color = self.colors[colorType] = {
	          name: paletteName,
	          hues: angular.extend({}, defaultHues, hues)
	        };
	
	        Object.keys(color.hues).forEach(function(name) {
	          if (!defaultHues[name]) {
	            throw new Error("Invalid hue name '%1' in theme %2's %3 color %4. Available hue names: %4"
	              .replace('%1', name)
	              .replace('%2', self.name)
	              .replace('%3', paletteName)
	              .replace('%4', Object.keys(defaultHues).join(', '))
	            );
	          }
	        });
	        Object.keys(color.hues).map(function(key) {
	          return color.hues[key];
	        }).forEach(function(hueValue) {
	          if (VALID_HUE_VALUES.indexOf(hueValue) == -1) {
	            throw new Error("Invalid hue value '%1' in theme %2's %3 color %4. Available hue values: %5"
	              .replace('%1', hueValue)
	              .replace('%2', self.name)
	              .replace('%3', colorType)
	              .replace('%4', paletteName)
	              .replace('%5', VALID_HUE_VALUES.join(', '))
	            );
	          }
	        });
	        return self;
	      };
	
	      self[colorType + 'Color'] = function() {
	        var args = Array.prototype.slice.call(arguments);
	        console.warn('$mdThemingProviderTheme.' + colorType + 'Color() has been deprecated. ' +
	                     'Use $mdThemingProviderTheme.' + colorType + 'Palette() instead.');
	        return self[colorType + 'Palette'].apply(self, args);
	      };
	    });
	  }
	
	  /**
	   * @ngdoc service
	   * @name $mdTheming
	   * @module material.core.theming
	   *
	   * @description
	   *
	   * Service that makes an element apply theming related <b>classes</b> to itself.
	   *
	   * <hljs lang="js">
	   * app.directive('myFancyDirective', function($mdTheming) {
	   *   return {
	   *     restrict: 'e',
	   *     link: function(scope, el, attrs) {
	   *       $mdTheming(el);
	   *
	   *       $mdTheming.defineTheme('myTheme', {
	   *         primary: 'blue',
	   *         accent: 'pink',
	   *         dark: true
	   *       })
	   *     }
	   *   };
	   * });
	   * </hljs>
	   * @param {element=} element to apply theming to
	   */
	
	  /**
	   * @ngdoc property
	   * @name $mdTheming#THEMES
	   * @description
	   * Property to get all the themes defined
	   * @returns {Object} All the themes defined with their properties
	   */
	
	  /**
	   * @ngdoc property
	   * @name $mdTheming#PALETTES
	   * @description
	   * Property to get all the palettes defined
	   * @returns {Object} All the palettes defined with their colors
	   */
	
	  /**
	   * @ngdoc method
	   * @name $mdTheming#registered
	   * @description
	   * Determine is specified theme name is a valid, registered theme
	   * @param {string} themeName the theme to check if registered
	   * @returns {boolean} whether the theme is registered or not
	   */
	
	  /**
	   * @ngdoc method
	   * @name $mdTheming#defaultTheme
	   * @description
	   * Returns the default theme
	   * @returns {string} The default theme
	   */
	
	  /**
	   * @ngdoc method
	   * @name $mdTheming#generateTheme
	   * @description
	   * Lazy generate themes - by default, every theme is generated when defined.
	   * You can disable this in the configuration section using the
	   * `$mdThemingProvider.generateThemesOnDemand(true);`
	   *
	   * The theme name that is passed in must match the name of the theme that was defined as part of the configuration block.
	   *
	   * @param name {string} theme name to generate
	   */
	
	  /**
	   * @ngdoc method
	   * @name $mdTheming#setBrowserColor
	   * @description
	   * Sets browser header coloring
	   * for more info please visit:
	   * https://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color
	   *
	   * The default color is `800` from `primary` palette of the `default` theme
	   *
	   * options are:<br/>
	   * `theme`   - A defined theme via `$mdThemeProvider` to use the palettes from. Default is `default` theme.<br/>
	   * `palette` - Can be any one of the basic material design palettes, extended defined palettes and 'primary',
	   *             'accent', 'background' and 'warn'. Default is `primary`<br/>
	   * `hue`     - The hue from the selected palette. Default is `800`
	   *
	   * @param {Object} options Options object for the browser color
	   * @returns {Function} remove function of the browser color
	   */
	
	  /**
	   * @ngdoc method
	   * @name $mdTheming#defineTheme
	   * @description
	   * Dynamically define a theme by an options object
	   *
	   * options are:<br/>
	   * `primary`    - The primary palette of the theme.<br/>
	   * `accent`     - The accent palette of the theme.<br/>
	   * `warn`       - The warn palette of the theme.<br/>
	   * `background` - The background palette of the theme.<br/>
	   * `dark`       - Indicates if it's a dark theme.<br/>
	   *
	   * @param {String} name Theme name to define
	   * @param {Object} options Theme definition options
	   * @returns {Promise<string>} A resolved promise with the theme name
	   */
	
	  /* @ngInject */
	  function ThemingService($rootScope, $mdUtil, $q, $log) {
	        // Allow us to be invoked via a linking function signature.
	    var applyTheme = function (scope, el) {
	          if (el === undefined) { el = scope; scope = undefined; }
	          if (scope === undefined) { scope = $rootScope; }
	          applyTheme.inherit(el, el);
	        };
	
	    Object.defineProperty(applyTheme, 'THEMES', {
	      get: function () {
	        return angular.extend({}, THEMES);
	      }
	    });
	    Object.defineProperty(applyTheme, 'PALETTES', {
	      get: function () {
	        return angular.extend({}, PALETTES);
	      }
	    });
	    Object.defineProperty(applyTheme, 'ALWAYS_WATCH', {
	      get: function () {
	        return alwaysWatchTheme;
	      }
	    });
	    applyTheme.inherit = inheritTheme;
	    applyTheme.registered = registered;
	    applyTheme.defaultTheme = function() { return defaultTheme; };
	    applyTheme.generateTheme = function(name) { generateTheme(THEMES[name], name, themeConfig.nonce); };
	    applyTheme.defineTheme = function(name, options) {
	      options = options || {};
	
	      var theme = registerTheme(name);
	
	      if (options.primary) {
	        theme.primaryPalette(options.primary);
	      }
	      if (options.accent) {
	        theme.accentPalette(options.accent);
	      }
	      if (options.warn) {
	        theme.warnPalette(options.warn);
	      }
	      if (options.background) {
	        theme.backgroundPalette(options.background);
	      }
	      if (options.dark){
	        theme.dark();
	      }
	
	      this.generateTheme(name);
	
	      return $q.resolve(name);
	    };
	    applyTheme.setBrowserColor = enableBrowserColor;
	
	    return applyTheme;
	
	    /**
	     * Determine is specified theme name is a valid, registered theme
	     */
	    function registered(themeName) {
	      if (themeName === undefined || themeName === '') return true;
	      return applyTheme.THEMES[themeName] !== undefined;
	    }
	
	    /**
	     * Get theme name for the element, then update with Theme CSS class
	     */
	    function inheritTheme (el, parent) {
	      var ctrl = parent.controller('mdTheme') || el.data('$mdThemeController');
	
	      updateThemeClass(lookupThemeName());
	
	      if (ctrl) {
	        var watchTheme = alwaysWatchTheme ||
	                         ctrl.$shouldWatch ||
	                         $mdUtil.parseAttributeBoolean(el.attr('md-theme-watch'));
	
	        var unwatch = ctrl.registerChanges(function (name) {
	          updateThemeClass(name);
	
	          if (!watchTheme) {
	            unwatch();
	          }
	          else {
	            el.on('$destroy', unwatch);
	          }
	        });
	      }
	
	      /**
	       * Find the theme name from the parent controller or element data
	       */
	      function lookupThemeName() {
	        // As a few components (dialog) add their controllers later, we should also watch for a controller init.
	        return ctrl && ctrl.$mdTheme || (defaultTheme == 'default' ? '' : defaultTheme);
	      }
	
	      /**
	       * Remove old theme class and apply a new one
	       * NOTE: if not a valid theme name, then the current name is not changed
	       */
	      function updateThemeClass(theme) {
	        if (!theme) return;
	        if (!registered(theme)) {
	          $log.warn('Attempted to use unregistered theme \'' + theme + '\'. ' +
	                    'Register it with $mdThemingProvider.theme().');
	        }
	
	        var oldTheme = el.data('$mdThemeName');
	        if (oldTheme) el.removeClass('md-' + oldTheme +'-theme');
	        el.addClass('md-' + theme + '-theme');
	        el.data('$mdThemeName', theme);
	        if (ctrl) {
	          el.data('$mdThemeController', ctrl);
	        }
	      }
	    }
	
	  }
	}
	
	function ThemingDirective($mdTheming, $interpolate, $parse, $mdUtil, $q, $log) {
	  return {
	    priority: 101, // has to be more than 100 to be before interpolation (issue on IE)
	    link: {
	      pre: function(scope, el, attrs) {
	        var registeredCallbacks = [];
	
	        var startSymbol = $interpolate.startSymbol();
	        var endSymbol = $interpolate.endSymbol();
	
	        var theme = attrs.mdTheme.trim();
	
	        var hasInterpolation =
	          theme.substr(0, startSymbol.length) === startSymbol &&
	          theme.lastIndexOf(endSymbol) === theme.length - endSymbol.length;
	
	        var oneTimeOperator = '::';
	        var oneTimeBind = attrs.mdTheme
	            .split(startSymbol).join('')
	            .split(endSymbol).join('')
	            .trim()
	            .substr(0, oneTimeOperator.length) === oneTimeOperator;
	
	        var ctrl = {
	          registerChanges: function (cb, context) {
	            if (context) {
	              cb = angular.bind(context, cb);
	            }
	
	            registeredCallbacks.push(cb);
	
	            return function () {
	              var index = registeredCallbacks.indexOf(cb);
	
	              if (index > -1) {
	                registeredCallbacks.splice(index, 1);
	              }
	            };
	          },
	          $setTheme: function (theme) {
	            if (!$mdTheming.registered(theme)) {
	              $log.warn('attempted to use unregistered theme \'' + theme + '\'');
	            }
	
	            ctrl.$mdTheme = theme;
	
	            // Iterating backwards to support unregistering during iteration
	            // http://stackoverflow.com/a/9882349/890293
	            // we don't use `reverse()` of array because it mutates the array and we don't want it to get re-indexed
	            for (var i = registeredCallbacks.length; i--;) {
	              registeredCallbacks[i](theme);
	            }
	          },
	          $shouldWatch: $mdUtil.parseAttributeBoolean(el.attr('md-theme-watch')) ||
	                        $mdTheming.ALWAYS_WATCH ||
	                        (hasInterpolation && !oneTimeBind)
	        };
	
	        el.data('$mdThemeController', ctrl);
	
	        var getTheme = function () {
	          var interpolation = $interpolate(attrs.mdTheme)(scope);
	          return $parse(interpolation)(scope) || interpolation;
	        };
	
	        var setParsedTheme = function (theme) {
	          if (typeof theme === 'string') {
	            return ctrl.$setTheme(theme);
	          }
	
	          $q.when( angular.isFunction(theme) ?  theme() : theme )
	            .then(function(name){
	              ctrl.$setTheme(name);
	            });
	        };
	
	        setParsedTheme(getTheme());
	
	        var unwatch = scope.$watch(getTheme, function(theme) {
	          if (theme) {
	            setParsedTheme(theme);
	
	            if (!ctrl.$shouldWatch) {
	              unwatch();
	            }
	          }
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Special directive that will disable ALL runtime Theme style generation and DOM injection
	 *
	 * <link rel="stylesheet" href="angular-material.min.css">
	 * <link rel="stylesheet" href="angular-material.themes.css">
	 *
	 * <body md-themes-disabled>
	 *  ...
	 * </body>
	 *
	 * Note: Using md-themes-css directive requires the developer to load external
	 * theme stylesheets; e.g. custom themes from Material-Tools:
	 *
	 *       `angular-material.themes.css`
	 *
	 * Another option is to use the ThemingProvider to configure and disable the attribute
	 * conversions; this would obviate the use of the `md-themes-css` directive
	 *
	 */
	function disableThemesDirective() {
	  themeConfig.disableTheming = true;
	
	  // Return a 1x-only, first-match attribute directive
	  return {
	    restrict : 'A',
	    priority : '900'
	  };
	}
	
	function ThemableDirective($mdTheming) {
	  return $mdTheming;
	}
	
	function parseRules(theme, colorType, rules) {
	  checkValidPalette(theme, colorType);
	
	  rules = rules.replace(/THEME_NAME/g, theme.name);
	  var generatedRules = [];
	  var color = theme.colors[colorType];
	
	  var themeNameRegex = new RegExp('\\.md-' + theme.name + '-theme', 'g');
	  // Matches '{{ primary-color }}', etc
	  var hueRegex = new RegExp('(\'|")?{{\\s*(' + colorType + ')-(color|contrast)-?(\\d\\.?\\d*)?\\s*}}(\"|\')?','g');
	  var simpleVariableRegex = /'?"?\{\{\s*([a-zA-Z]+)-(A?\d+|hue\-[0-3]|shadow|default)-?(\d\.?\d*)?(contrast)?\s*\}\}'?"?/g;
	  var palette = PALETTES[color.name];
	
	  // find and replace simple variables where we use a specific hue, not an entire palette
	  // eg. "{{primary-100}}"
	  //\(' + THEME_COLOR_TYPES.join('\|') + '\)'
	  rules = rules.replace(simpleVariableRegex, function(match, colorType, hue, opacity, contrast) {
	    if (colorType === 'foreground') {
	      if (hue == 'shadow') {
	        return theme.foregroundShadow;
	      } else {
	        return theme.foregroundPalette[hue] || theme.foregroundPalette['1'];
	      }
	    }
	
	    // `default` is also accepted as a hue-value, because the background palettes are
	    // using it as a name for the default hue.
	    if (hue.indexOf('hue') === 0 || hue === 'default') {
	      hue = theme.colors[colorType].hues[hue];
	    }
	
	    return rgba( (PALETTES[ theme.colors[colorType].name ][hue] || '')[contrast ? 'contrast' : 'value'], opacity );
	  });
	
	  // For each type, generate rules for each hue (ie. default, md-hue-1, md-hue-2, md-hue-3)
	  angular.forEach(color.hues, function(hueValue, hueName) {
	    var newRule = rules
	      .replace(hueRegex, function(match, _, colorType, hueType, opacity) {
	        return rgba(palette[hueValue][hueType === 'color' ? 'value' : 'contrast'], opacity);
	      });
	    if (hueName !== 'default') {
	      newRule = newRule.replace(themeNameRegex, '.md-' + theme.name + '-theme.md-' + hueName);
	    }
	
	    // Don't apply a selector rule to the default theme, making it easier to override
	    // styles of the base-component
	    if (theme.name == 'default') {
	      var themeRuleRegex = /((?:\s|>|\.|\w|-|:|\(|\)|\[|\]|"|'|=)*)\.md-default-theme((?:\s|>|\.|\w|-|:|\(|\)|\[|\]|"|'|=)*)/g;
	
	      newRule = newRule.replace(themeRuleRegex, function(match, start, end) {
	        return match + ', ' + start + end;
	      });
	    }
	    generatedRules.push(newRule);
	  });
	
	  return generatedRules;
	}
	
	var rulesByType = {};
	
	// Generate our themes at run time given the state of THEMES and PALETTES
	function generateAllThemes($injector, $mdTheming) {
	  var head = document.head;
	  var firstChild = head ? head.firstElementChild : null;
	  var themeCss = !themeConfig.disableTheming && $injector.has('$MD_THEME_CSS') ? $injector.get('$MD_THEME_CSS') : '';
	
	  // Append our custom registered styles to the theme stylesheet.
	  themeCss += themeConfig.registeredStyles.join('');
	
	  if ( !firstChild ) return;
	  if (themeCss.length === 0) return; // no rules, so no point in running this expensive task
	
	  // Expose contrast colors for palettes to ensure that text is always readable
	  angular.forEach(PALETTES, sanitizePalette);
	
	  // MD_THEME_CSS is a string generated by the build process that includes all the themable
	  // components as templates
	
	  // Break the CSS into individual rules
	  var rules = themeCss
	                  .split(/\}(?!(\}|'|"|;))/)
	                  .filter(function(rule) { return rule && rule.trim().length; })
	                  .map(function(rule) { return rule.trim() + '}'; });
	
	
	  var ruleMatchRegex = new RegExp('md-(' + THEME_COLOR_TYPES.join('|') + ')', 'g');
	
	  THEME_COLOR_TYPES.forEach(function(type) {
	    rulesByType[type] = '';
	  });
	
	
	  // Sort the rules based on type, allowing us to do color substitution on a per-type basis
	  rules.forEach(function(rule) {
	    var match = rule.match(ruleMatchRegex);
	    // First: test that if the rule has '.md-accent', it goes into the accent set of rules
	    for (var i = 0, type; type = THEME_COLOR_TYPES[i]; i++) {
	      if (rule.indexOf('.md-' + type) > -1) {
	        return rulesByType[type] += rule;
	      }
	    }
	
	    // If no eg 'md-accent' class is found, try to just find 'accent' in the rule and guess from
	    // there
	    for (i = 0; type = THEME_COLOR_TYPES[i]; i++) {
	      if (rule.indexOf(type) > -1) {
	        return rulesByType[type] += rule;
	      }
	    }
	
	    // Default to the primary array
	    return rulesByType[DEFAULT_COLOR_TYPE] += rule;
	  });
	
	  // If themes are being generated on-demand, quit here. The user will later manually
	  // call generateTheme to do this on a theme-by-theme basis.
	  if (themeConfig.generateOnDemand) return;
	
	  angular.forEach($mdTheming.THEMES, function(theme) {
	    if (!GENERATED[theme.name] && !($mdTheming.defaultTheme() !== 'default' && theme.name === 'default')) {
	      generateTheme(theme, theme.name, themeConfig.nonce);
	    }
	  });
	
	
	  // *************************
	  // Internal functions
	  // *************************
	
	  // The user specifies a 'default' contrast color as either light or dark,
	  // then explicitly lists which hues are the opposite contrast (eg. A100 has dark, A200 has light)
	  function sanitizePalette(palette, name) {
	    var defaultContrast = palette.contrastDefaultColor;
	    var lightColors = palette.contrastLightColors || [];
	    var strongLightColors = palette.contrastStrongLightColors || [];
	    var darkColors = palette.contrastDarkColors || [];
	
	    // These colors are provided as space-separated lists
	    if (typeof lightColors === 'string') lightColors = lightColors.split(' ');
	    if (typeof strongLightColors === 'string') strongLightColors = strongLightColors.split(' ');
	    if (typeof darkColors === 'string') darkColors = darkColors.split(' ');
	
	    // Cleanup after ourselves
	    delete palette.contrastDefaultColor;
	    delete palette.contrastLightColors;
	    delete palette.contrastStrongLightColors;
	    delete palette.contrastDarkColors;
	
	    // Change { 'A100': '#fffeee' } to { 'A100': { value: '#fffeee', contrast:DARK_CONTRAST_COLOR }
	    angular.forEach(palette, function(hueValue, hueName) {
	      if (angular.isObject(hueValue)) return; // Already converted
	      // Map everything to rgb colors
	      var rgbValue = colorToRgbaArray(hueValue);
	      if (!rgbValue) {
	        throw new Error("Color %1, in palette %2's hue %3, is invalid. Hex or rgb(a) color expected."
	                        .replace('%1', hueValue)
	                        .replace('%2', palette.name)
	                        .replace('%3', hueName));
	      }
	
	      palette[hueName] = {
	        hex: palette[hueName],
	        value: rgbValue,
	        contrast: getContrastColor()
	      };
	      function getContrastColor() {
	        if (defaultContrast === 'light') {
	          if (darkColors.indexOf(hueName) > -1) {
	            return DARK_CONTRAST_COLOR;
	          } else {
	            return strongLightColors.indexOf(hueName) > -1 ? STRONG_LIGHT_CONTRAST_COLOR
	              : LIGHT_CONTRAST_COLOR;
	          }
	        } else {
	          if (lightColors.indexOf(hueName) > -1) {
	            return strongLightColors.indexOf(hueName) > -1 ? STRONG_LIGHT_CONTRAST_COLOR
	              : LIGHT_CONTRAST_COLOR;
	          } else {
	            return DARK_CONTRAST_COLOR;
	          }
	        }
	      }
	    });
	  }
	}
	
	function generateTheme(theme, name, nonce) {
	  var head = document.head;
	  var firstChild = head ? head.firstElementChild : null;
	
	  if (!GENERATED[name]) {
	    // For each theme, use the color palettes specified for
	    // `primary`, `warn` and `accent` to generate CSS rules.
	    THEME_COLOR_TYPES.forEach(function(colorType) {
	      var styleStrings = parseRules(theme, colorType, rulesByType[colorType]);
	      while (styleStrings.length) {
	        var styleContent = styleStrings.shift();
	        if (styleContent) {
	          var style = document.createElement('style');
	          style.setAttribute('md-theme-style', '');
	          if (nonce) {
	            style.setAttribute('nonce', nonce);
	          }
	          style.appendChild(document.createTextNode(styleContent));
	          head.insertBefore(style, firstChild);
	        }
	      }
	    });
	
	    GENERATED[theme.name] = true;
	  }
	
	}
	
	
	function checkValidPalette(theme, colorType) {
	  // If theme attempts to use a palette that doesnt exist, throw error
	  if (!PALETTES[ (theme.colors[colorType] || {}).name ]) {
	    throw new Error(
	      "You supplied an invalid color palette for theme %1's %2 palette. Available palettes: %3"
	                    .replace('%1', theme.name)
	                    .replace('%2', colorType)
	                    .replace('%3', Object.keys(PALETTES).join(', '))
	    );
	  }
	}
	
	function colorToRgbaArray(clr) {
	  if (angular.isArray(clr) && clr.length == 3) return clr;
	  if (/^rgb/.test(clr)) {
	    return clr.replace(/(^\s*rgba?\(|\)\s*$)/g, '').split(',').map(function(value, i) {
	      return i == 3 ? parseFloat(value, 10) : parseInt(value, 10);
	    });
	  }
	  if (clr.charAt(0) == '#') clr = clr.substring(1);
	  if (!/^([a-fA-F0-9]{3}){1,2}$/g.test(clr)) return;
	
	  var dig = clr.length / 3;
	  var red = clr.substr(0, dig);
	  var grn = clr.substr(dig, dig);
	  var blu = clr.substr(dig * 2);
	  if (dig === 1) {
	    red += red;
	    grn += grn;
	    blu += blu;
	  }
	  return [parseInt(red, 16), parseInt(grn, 16), parseInt(blu, 16)];
	}
	
	function rgba(rgbArray, opacity) {
	  if ( !rgbArray ) return "rgb('0,0,0')";
	
	  if (rgbArray.length == 4) {
	    rgbArray = angular.copy(rgbArray);
	    opacity ? rgbArray.pop() : opacity = rgbArray.pop();
	  }
	  return opacity && (typeof opacity == 'number' || (typeof opacity == 'string' && opacity.length)) ?
	    'rgba(' + rgbArray.join(',') + ',' + opacity + ')' :
	    'rgb(' + rgbArray.join(',') + ')';
	}
	
	
	})(window.angular);
	
	})();
	(function(){
	"use strict";
	
	// Polyfill angular < 1.4 (provide $animateCss)
	angular
	  .module('material.core')
	  .factory('$$mdAnimate', ["$q", "$timeout", "$mdConstant", "$animateCss", function($q, $timeout, $mdConstant, $animateCss){
	
	     // Since $$mdAnimate is injected into $mdUtil... use a wrapper function
	     // to subsequently inject $mdUtil as an argument to the AnimateDomUtils
	
	     return function($mdUtil) {
	       return AnimateDomUtils( $mdUtil, $q, $timeout, $mdConstant, $animateCss);
	     };
	   }]);
	
	/**
	 * Factory function that requires special injections
	 */
	function AnimateDomUtils($mdUtil, $q, $timeout, $mdConstant, $animateCss) {
	  var self;
	  return self = {
	    /**
	     *
	     */
	    translate3d : function( target, from, to, options ) {
	      return $animateCss(target, {
	        from: from,
	        to: to,
	        addClass: options.transitionInClass,
	        removeClass: options.transitionOutClass,
	        duration: options.duration
	      })
	      .start()
	      .then(function(){
	          // Resolve with reverser function...
	          return reverseTranslate;
	      });
	
	      /**
	       * Specific reversal of the request translate animation above...
	       */
	      function reverseTranslate (newFrom) {
	        return $animateCss(target, {
	           to: newFrom || from,
	           addClass: options.transitionOutClass,
	           removeClass: options.transitionInClass,
	           duration: options.duration
	        }).start();
	
	      }
	    },
	
	    /**
	     * Listen for transitionEnd event (with optional timeout)
	     * Announce completion or failure via promise handlers
	     */
	    waitTransitionEnd: function (element, opts) {
	      var TIMEOUT = 3000; // fallback is 3 secs
	
	      return $q(function(resolve, reject){
	        opts = opts || { };
	
	        // If there is no transition is found, resolve immediately
	        //
	        // NOTE: using $mdUtil.nextTick() causes delays/issues
	        if (noTransitionFound(opts.cachedTransitionStyles)) {
	          TIMEOUT = 0;
	        }
	
	        var timer = $timeout(finished, opts.timeout || TIMEOUT);
	        element.on($mdConstant.CSS.TRANSITIONEND, finished);
	
	        /**
	         * Upon timeout or transitionEnd, reject or resolve (respectively) this promise.
	         * NOTE: Make sure this transitionEnd didn't bubble up from a child
	         */
	        function finished(ev) {
	          if ( ev && ev.target !== element[0]) return;
	
	          if ( ev  ) $timeout.cancel(timer);
	          element.off($mdConstant.CSS.TRANSITIONEND, finished);
	
	          // Never reject since ngAnimate may cause timeouts due missed transitionEnd events
	          resolve();
	
	        }
	
	        /**
	         * Checks whether or not there is a transition.
	         *
	         * @param styles The cached styles to use for the calculation. If null, getComputedStyle()
	         * will be used.
	         *
	         * @returns {boolean} True if there is no transition/duration; false otherwise.
	         */
	        function noTransitionFound(styles) {
	          styles = styles || window.getComputedStyle(element[0]);
	
	          return styles.transitionDuration == '0s' || (!styles.transition && !styles.transitionProperty);
	        }
	
	      });
	    },
	
	    calculateTransformValues: function (element, originator) {
	      var origin = originator.element;
	      var bounds = originator.bounds;
	
	      if (origin || bounds) {
	        var originBnds = origin ? self.clientRect(origin) || currentBounds() : self.copyRect(bounds);
	        var dialogRect = self.copyRect(element[0].getBoundingClientRect());
	        var dialogCenterPt = self.centerPointFor(dialogRect);
	        var originCenterPt = self.centerPointFor(originBnds);
	
	        return {
	          centerX: originCenterPt.x - dialogCenterPt.x,
	          centerY: originCenterPt.y - dialogCenterPt.y,
	          scaleX: Math.round(100 * Math.min(0.5, originBnds.width / dialogRect.width)) / 100,
	          scaleY: Math.round(100 * Math.min(0.5, originBnds.height / dialogRect.height)) / 100
	        };
	      }
	      return {centerX: 0, centerY: 0, scaleX: 0.5, scaleY: 0.5};
	
	      /**
	       * This is a fallback if the origin information is no longer valid, then the
	       * origin bounds simply becomes the current bounds for the dialogContainer's parent
	       */
	      function currentBounds() {
	        var cntr = element ? element.parent() : null;
	        var parent = cntr ? cntr.parent() : null;
	
	        return parent ? self.clientRect(parent) : null;
	      }
	    },
	
	    /**
	     * Calculate the zoom transform from dialog to origin.
	     *
	     * We use this to set the dialog position immediately;
	     * then the md-transition-in actually translates back to
	     * `translate3d(0,0,0) scale(1.0)`...
	     *
	     * NOTE: all values are rounded to the nearest integer
	     */
	    calculateZoomToOrigin: function (element, originator) {
	      var zoomTemplate = "translate3d( {centerX}px, {centerY}px, 0 ) scale( {scaleX}, {scaleY} )";
	      var buildZoom = angular.bind(null, $mdUtil.supplant, zoomTemplate);
	
	      return buildZoom(self.calculateTransformValues(element, originator));
	    },
	
	    /**
	     * Calculate the slide transform from panel to origin.
	     * NOTE: all values are rounded to the nearest integer
	     */
	    calculateSlideToOrigin: function (element, originator) {
	      var slideTemplate = "translate3d( {centerX}px, {centerY}px, 0 )";
	      var buildSlide = angular.bind(null, $mdUtil.supplant, slideTemplate);
	
	      return buildSlide(self.calculateTransformValues(element, originator));
	    },
	
	    /**
	     * Enhance raw values to represent valid css stylings...
	     */
	    toCss : function( raw ) {
	      var css = { };
	      var lookups = 'left top right bottom width height x y min-width min-height max-width max-height';
	
	      angular.forEach(raw, function(value,key) {
	        if ( angular.isUndefined(value) ) return;
	
	        if ( lookups.indexOf(key) >= 0 ) {
	          css[key] = value + 'px';
	        } else {
	          switch (key) {
	            case 'transition':
	              convertToVendor(key, $mdConstant.CSS.TRANSITION, value);
	              break;
	            case 'transform':
	              convertToVendor(key, $mdConstant.CSS.TRANSFORM, value);
	              break;
	            case 'transformOrigin':
	              convertToVendor(key, $mdConstant.CSS.TRANSFORM_ORIGIN, value);
	              break;
	            case 'font-size':
	              css['font-size'] = value; // font sizes aren't always in px
	              break;
	          }
	        }
	      });
	
	      return css;
	
	      function convertToVendor(key, vendor, value) {
	        angular.forEach(vendor.split(' '), function (key) {
	          css[key] = value;
	        });
	      }
	    },
	
	    /**
	     * Convert the translate CSS value to key/value pair(s).
	     */
	    toTransformCss: function (transform, addTransition, transition) {
	      var css = {};
	      angular.forEach($mdConstant.CSS.TRANSFORM.split(' '), function (key) {
	        css[key] = transform;
	      });
	
	      if (addTransition) {
	        transition = transition || "all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1) !important";
	        css.transition = transition;
	      }
	
	      return css;
	    },
	
	    /**
	     *  Clone the Rect and calculate the height/width if needed
	     */
	    copyRect: function (source, destination) {
	      if (!source) return null;
	
	      destination = destination || {};
	
	      angular.forEach('left top right bottom width height'.split(' '), function (key) {
	        destination[key] = Math.round(source[key]);
	      });
	
	      destination.width = destination.width || (destination.right - destination.left);
	      destination.height = destination.height || (destination.bottom - destination.top);
	
	      return destination;
	    },
	
	    /**
	     * Calculate ClientRect of element; return null if hidden or zero size
	     */
	    clientRect: function (element) {
	      var bounds = angular.element(element)[0].getBoundingClientRect();
	      var isPositiveSizeClientRect = function (rect) {
	        return rect && (rect.width > 0) && (rect.height > 0);
	      };
	
	      // If the event origin element has zero size, it has probably been hidden.
	      return isPositiveSizeClientRect(bounds) ? self.copyRect(bounds) : null;
	    },
	
	    /**
	     *  Calculate 'rounded' center point of Rect
	     */
	    centerPointFor: function (targetRect) {
	      return targetRect ? {
	        x: Math.round(targetRect.left + (targetRect.width / 2)),
	        y: Math.round(targetRect.top + (targetRect.height / 2))
	      } : { x : 0, y : 0 };
	    }
	
	  };
	}
	
	
	})();
	(function(){
	"use strict";
	
	if (angular.version.minor >= 4) {
	  angular.module('material.core.animate', []);
	} else {
	(function() {
	  "use strict";
	
	  var forEach = angular.forEach;
	
	  var WEBKIT = angular.isDefined(document.documentElement.style.WebkitAppearance);
	  var TRANSITION_PROP = WEBKIT ? 'WebkitTransition' : 'transition';
	  var ANIMATION_PROP = WEBKIT ? 'WebkitAnimation' : 'animation';
	  var PREFIX = WEBKIT ? '-webkit-' : '';
	
	  var TRANSITION_EVENTS = (WEBKIT ? 'webkitTransitionEnd ' : '') + 'transitionend';
	  var ANIMATION_EVENTS = (WEBKIT ? 'webkitAnimationEnd ' : '') + 'animationend';
	
	  var $$ForceReflowFactory = ['$document', function($document) {
	    return function() {
	      return $document[0].body.clientWidth + 1;
	    };
	  }];
	
	  var $$rAFMutexFactory = ['$$rAF', function($$rAF) {
	    return function() {
	      var passed = false;
	      $$rAF(function() {
	        passed = true;
	      });
	      return function(fn) {
	        passed ? fn() : $$rAF(fn);
	      };
	    };
	  }];
	
	  var $$AnimateRunnerFactory = ['$q', '$$rAFMutex', function($q, $$rAFMutex) {
	    var INITIAL_STATE = 0;
	    var DONE_PENDING_STATE = 1;
	    var DONE_COMPLETE_STATE = 2;
	
	    function AnimateRunner(host) {
	      this.setHost(host);
	
	      this._doneCallbacks = [];
	      this._runInAnimationFrame = $$rAFMutex();
	      this._state = 0;
	    }
	
	    AnimateRunner.prototype = {
	      setHost: function(host) {
	        this.host = host || {};
	      },
	
	      done: function(fn) {
	        if (this._state === DONE_COMPLETE_STATE) {
	          fn();
	        } else {
	          this._doneCallbacks.push(fn);
	        }
	      },
	
	      progress: angular.noop,
	
	      getPromise: function() {
	        if (!this.promise) {
	          var self = this;
	          this.promise = $q(function(resolve, reject) {
	            self.done(function(status) {
	              status === false ? reject() : resolve();
	            });
	          });
	        }
	        return this.promise;
	      },
	
	      then: function(resolveHandler, rejectHandler) {
	        return this.getPromise().then(resolveHandler, rejectHandler);
	      },
	
	      'catch': function(handler) {
	        return this.getPromise()['catch'](handler);
	      },
	
	      'finally': function(handler) {
	        return this.getPromise()['finally'](handler);
	      },
	
	      pause: function() {
	        if (this.host.pause) {
	          this.host.pause();
	        }
	      },
	
	      resume: function() {
	        if (this.host.resume) {
	          this.host.resume();
	        }
	      },
	
	      end: function() {
	        if (this.host.end) {
	          this.host.end();
	        }
	        this._resolve(true);
	      },
	
	      cancel: function() {
	        if (this.host.cancel) {
	          this.host.cancel();
	        }
	        this._resolve(false);
	      },
	
	      complete: function(response) {
	        var self = this;
	        if (self._state === INITIAL_STATE) {
	          self._state = DONE_PENDING_STATE;
	          self._runInAnimationFrame(function() {
	            self._resolve(response);
	          });
	        }
	      },
	
	      _resolve: function(response) {
	        if (this._state !== DONE_COMPLETE_STATE) {
	          forEach(this._doneCallbacks, function(fn) {
	            fn(response);
	          });
	          this._doneCallbacks.length = 0;
	          this._state = DONE_COMPLETE_STATE;
	        }
	      }
	    };
	
	    // Polyfill AnimateRunner.all which is used by input animations
	    AnimateRunner.all = function(runners, callback) {
	      var count = 0;
	      var status = true;
	      forEach(runners, function(runner) {
	        runner.done(onProgress);
	      });
	
	      function onProgress(response) {
	        status = status && response;
	        if (++count === runners.length) {
	          callback(status);
	        }
	      }
	    };
	
	    return AnimateRunner;
	  }];
	
	  angular
	    .module('material.core.animate', [])
	    .factory('$$forceReflow', $$ForceReflowFactory)
	    .factory('$$AnimateRunner', $$AnimateRunnerFactory)
	    .factory('$$rAFMutex', $$rAFMutexFactory)
	    .factory('$animateCss', ['$window', '$$rAF', '$$AnimateRunner', '$$forceReflow', '$$jqLite', '$timeout', '$animate',
	                     function($window,   $$rAF,   $$AnimateRunner,   $$forceReflow,   $$jqLite,   $timeout, $animate) {
	
	      function init(element, options) {
	
	        var temporaryStyles = [];
	        var node = getDomNode(element);
	        var areAnimationsAllowed = node && $animate.enabled();
	
	        var hasCompleteStyles = false;
	        var hasCompleteClasses = false;
	
	        if (areAnimationsAllowed) {
	          if (options.transitionStyle) {
	            temporaryStyles.push([PREFIX + 'transition', options.transitionStyle]);
	          }
	
	          if (options.keyframeStyle) {
	            temporaryStyles.push([PREFIX + 'animation', options.keyframeStyle]);
	          }
	
	          if (options.delay) {
	            temporaryStyles.push([PREFIX + 'transition-delay', options.delay + 's']);
	          }
	
	          if (options.duration) {
	            temporaryStyles.push([PREFIX + 'transition-duration', options.duration + 's']);
	          }
	
	          hasCompleteStyles = options.keyframeStyle ||
	              (options.to && (options.duration > 0 || options.transitionStyle));
	          hasCompleteClasses = !!options.addClass || !!options.removeClass;
	
	          blockTransition(element, true);
	        }
	
	        var hasCompleteAnimation = areAnimationsAllowed && (hasCompleteStyles || hasCompleteClasses);
	
	        applyAnimationFromStyles(element, options);
	
	        var animationClosed = false;
	        var events, eventFn;
	
	        return {
	          close: $window.close,
	          start: function() {
	            var runner = new $$AnimateRunner();
	            waitUntilQuiet(function() {
	              blockTransition(element, false);
	              if (!hasCompleteAnimation) {
	                return close();
	              }
	
	              forEach(temporaryStyles, function(entry) {
	                var key = entry[0];
	                var value = entry[1];
	                node.style[camelCase(key)] = value;
	              });
	
	              applyClasses(element, options);
	
	              var timings = computeTimings(element);
	              if (timings.duration === 0) {
	                return close();
	              }
	
	              var moreStyles = [];
	
	              if (options.easing) {
	                if (timings.transitionDuration) {
	                  moreStyles.push([PREFIX + 'transition-timing-function', options.easing]);
	                }
	                if (timings.animationDuration) {
	                  moreStyles.push([PREFIX + 'animation-timing-function', options.easing]);
	                }
	              }
	
	              if (options.delay && timings.animationDelay) {
	                moreStyles.push([PREFIX + 'animation-delay', options.delay + 's']);
	              }
	
	              if (options.duration && timings.animationDuration) {
	                moreStyles.push([PREFIX + 'animation-duration', options.duration + 's']);
	              }
	
	              forEach(moreStyles, function(entry) {
	                var key = entry[0];
	                var value = entry[1];
	                node.style[camelCase(key)] = value;
	                temporaryStyles.push(entry);
	              });
	
	              var maxDelay = timings.delay;
	              var maxDelayTime = maxDelay * 1000;
	              var maxDuration = timings.duration;
	              var maxDurationTime = maxDuration * 1000;
	              var startTime = Date.now();
	
	              events = [];
	              if (timings.transitionDuration) {
	                events.push(TRANSITION_EVENTS);
	              }
	              if (timings.animationDuration) {
	                events.push(ANIMATION_EVENTS);
	              }
	              events = events.join(' ');
	              eventFn = function(event) {
	                event.stopPropagation();
	                var ev = event.originalEvent || event;
	                var timeStamp = ev.timeStamp || Date.now();
	                var elapsedTime = parseFloat(ev.elapsedTime.toFixed(3));
	                if (Math.max(timeStamp - startTime, 0) >= maxDelayTime && elapsedTime >= maxDuration) {
	                  close();
	                }
	              };
	              element.on(events, eventFn);
	
	              applyAnimationToStyles(element, options);
	
	              $timeout(close, maxDelayTime + maxDurationTime * 1.5, false);
	            });
	
	            return runner;
	
	            function close() {
	              if (animationClosed) return;
	              animationClosed = true;
	
	              if (events && eventFn) {
	                element.off(events, eventFn);
	              }
	              applyClasses(element, options);
	              applyAnimationStyles(element, options);
	              forEach(temporaryStyles, function(entry) {
	                node.style[camelCase(entry[0])] = '';
	              });
	              runner.complete(true);
	              return runner;
	            }
	          }
	        };
	      }
	
	      function applyClasses(element, options) {
	        if (options.addClass) {
	          $$jqLite.addClass(element, options.addClass);
	          options.addClass = null;
	        }
	        if (options.removeClass) {
	          $$jqLite.removeClass(element, options.removeClass);
	          options.removeClass = null;
	        }
	      }
	
	      function computeTimings(element) {
	        var node = getDomNode(element);
	        var cs = $window.getComputedStyle(node);
	        var tdr = parseMaxTime(cs[prop('transitionDuration')]);
	        var adr = parseMaxTime(cs[prop('animationDuration')]);
	        var tdy = parseMaxTime(cs[prop('transitionDelay')]);
	        var ady = parseMaxTime(cs[prop('animationDelay')]);
	
	        adr *= (parseInt(cs[prop('animationIterationCount')], 10) || 1);
	        var duration = Math.max(adr, tdr);
	        var delay = Math.max(ady, tdy);
	
	        return {
	          duration: duration,
	          delay: delay,
	          animationDuration: adr,
	          transitionDuration: tdr,
	          animationDelay: ady,
	          transitionDelay: tdy
	        };
	
	        function prop(key) {
	          return WEBKIT ? 'Webkit' + key.charAt(0).toUpperCase() + key.substr(1)
	                        : key;
	        }
	      }
	
	      function parseMaxTime(str) {
	        var maxValue = 0;
	        var values = (str || "").split(/\s*,\s*/);
	        forEach(values, function(value) {
	          // it's always safe to consider only second values and omit `ms` values since
	          // getComputedStyle will always handle the conversion for us
	          if (value.charAt(value.length - 1) == 's') {
	            value = value.substring(0, value.length - 1);
	          }
	          value = parseFloat(value) || 0;
	          maxValue = maxValue ? Math.max(value, maxValue) : value;
	        });
	        return maxValue;
	      }
	
	      var cancelLastRAFRequest;
	      var rafWaitQueue = [];
	      function waitUntilQuiet(callback) {
	        if (cancelLastRAFRequest) {
	          cancelLastRAFRequest(); //cancels the request
	        }
	        rafWaitQueue.push(callback);
	        cancelLastRAFRequest = $$rAF(function() {
	          cancelLastRAFRequest = null;
	
	          // DO NOT REMOVE THIS LINE OR REFACTOR OUT THE `pageWidth` variable.
	          // PLEASE EXAMINE THE `$$forceReflow` service to understand why.
	          var pageWidth = $$forceReflow();
	
	          // we use a for loop to ensure that if the queue is changed
	          // during this looping then it will consider new requests
	          for (var i = 0; i < rafWaitQueue.length; i++) {
	            rafWaitQueue[i](pageWidth);
	          }
	          rafWaitQueue.length = 0;
	        });
	      }
	
	      function applyAnimationStyles(element, options) {
	        applyAnimationFromStyles(element, options);
	        applyAnimationToStyles(element, options);
	      }
	
	      function applyAnimationFromStyles(element, options) {
	        if (options.from) {
	          element.css(options.from);
	          options.from = null;
	        }
	      }
	
	      function applyAnimationToStyles(element, options) {
	        if (options.to) {
	          element.css(options.to);
	          options.to = null;
	        }
	      }
	
	      function getDomNode(element) {
	        for (var i = 0; i < element.length; i++) {
	          if (element[i].nodeType === 1) return element[i];
	        }
	      }
	
	      function blockTransition(element, bool) {
	        var node = getDomNode(element);
	        var key = camelCase(PREFIX + 'transition-delay');
	        node.style[key] = bool ? '-9999s' : '';
	      }
	
	      return init;
	    }]);
	
	  /**
	   * Older browsers [FF31] expect camelCase
	   * property keys.
	   * e.g.
	   *  animation-duration --> animationDuration
	   */
	  function camelCase(str) {
	    return str.replace(/-[a-z]/g, function(str) {
	      return str.charAt(1).toUpperCase();
	    });
	  }
	
	})();
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.autocomplete
	 */
	/*
	 * @see js folder for autocomplete implementation
	 */
	angular.module('material.components.autocomplete', [
	  'material.core',
	  'material.components.icon',
	  'material.components.virtualRepeat'
	]);
	
	})();
	(function(){
	"use strict";
	
	/*
	 * @ngdoc module
	 * @name material.components.backdrop
	 * @description Backdrop
	 */
	
	/**
	 * @ngdoc directive
	 * @name mdBackdrop
	 * @module material.components.backdrop
	 *
	 * @restrict E
	 *
	 * @description
	 * `<md-backdrop>` is a backdrop element used by other components, such as dialog and bottom sheet.
	 * Apply class `opaque` to make the backdrop use the theme backdrop color.
	 *
	 */
	
	angular
	  .module('material.components.backdrop', ['material.core'])
	  .directive('mdBackdrop', ["$mdTheming", "$mdUtil", "$animate", "$rootElement", "$window", "$log", "$$rAF", "$document", function BackdropDirective($mdTheming, $mdUtil, $animate, $rootElement, $window, $log, $$rAF, $document) {
	    var ERROR_CSS_POSITION = '<md-backdrop> may not work properly in a scrolled, static-positioned parent container.';
	
	    return {
	      restrict: 'E',
	      link: postLink
	    };
	
	    function postLink(scope, element, attrs) {
	      // backdrop may be outside the $rootElement, tell ngAnimate to animate regardless
	      if ($animate.pin) $animate.pin(element, $rootElement);
	
	      var bodyStyles;
	
	      $$rAF(function() {
	        // If body scrolling has been disabled using mdUtil.disableBodyScroll(),
	        // adjust the 'backdrop' height to account for the fixed 'body' top offset.
	        // Note that this can be pretty expensive and is better done inside the $$rAF.
	        bodyStyles = $window.getComputedStyle($document[0].body);
	
	        if (bodyStyles.position === 'fixed') {
	          var resizeHandler = $mdUtil.debounce(function(){
	            bodyStyles = $window.getComputedStyle($document[0].body);
	            resize();
	          }, 60, null, false);
	
	          resize();
	          angular.element($window).on('resize', resizeHandler);
	
	          scope.$on('$destroy', function() {
	            angular.element($window).off('resize', resizeHandler);
	          });
	        }
	
	        // Often $animate.enter() is used to append the backDrop element
	        // so let's wait until $animate is done...
	        var parent = element.parent();
	
	        if (parent.length) {
	          if (parent[0].nodeName === 'BODY') {
	            element.css('position', 'fixed');
	          }
	
	          var styles = $window.getComputedStyle(parent[0]);
	
	          if (styles.position === 'static') {
	            // backdrop uses position:absolute and will not work properly with parent position:static (default)
	            $log.warn(ERROR_CSS_POSITION);
	          }
	
	          // Only inherit the parent if the backdrop has a parent.
	          $mdTheming.inherit(element, parent);
	        }
	      });
	
	      function resize() {
	        var viewportHeight = parseInt(bodyStyles.height, 10) + Math.abs(parseInt(bodyStyles.top, 10));
	        element.css('height', viewportHeight + 'px');
	      }
	    }
	
	  }]);
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.bottomSheet
	 * @description
	 * BottomSheet
	 */
	MdBottomSheetDirective.$inject = ["$mdBottomSheet"];
	MdBottomSheetProvider.$inject = ["$$interimElementProvider"];
	angular
	  .module('material.components.bottomSheet', [
	    'material.core',
	    'material.components.backdrop'
	  ])
	  .directive('mdBottomSheet', MdBottomSheetDirective)
	  .provider('$mdBottomSheet', MdBottomSheetProvider);
	
	/* @ngInject */
	function MdBottomSheetDirective($mdBottomSheet) {
	  return {
	    restrict: 'E',
	    link : function postLink(scope, element) {
	      element.addClass('_md');     // private md component indicator for styling
	
	      // When navigation force destroys an interimElement, then
	      // listen and $destroy() that interim instance...
	      scope.$on('$destroy', function() {
	        $mdBottomSheet.destroy();
	      });
	    }
	  };
	}
	
	
	/**
	 * @ngdoc service
	 * @name $mdBottomSheet
	 * @module material.components.bottomSheet
	 *
	 * @description
	 * `$mdBottomSheet` opens a bottom sheet over the app and provides a simple promise API.
	 *
	 * ## Restrictions
	 *
	 * - The bottom sheet's template must have an outer `<md-bottom-sheet>` element.
	 * - Add the `md-grid` class to the bottom sheet for a grid layout.
	 * - Add the `md-list` class to the bottom sheet for a list layout.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div ng-controller="MyController">
	 *   <md-button ng-click="openBottomSheet()">
	 *     Open a Bottom Sheet!
	 *   </md-button>
	 * </div>
	 * </hljs>
	 * <hljs lang="js">
	 * var app = angular.module('app', ['ngMaterial']);
	 * app.controller('MyController', function($scope, $mdBottomSheet) {
	 *   $scope.openBottomSheet = function() {
	 *     $mdBottomSheet.show({
	 *       template: '<md-bottom-sheet>' +
	 *       'Hello! <md-button ng-click="closeBottomSheet()">Close</md-button>' +
	 *       '</md-bottom-sheet>'
	 *     })
	 *
	 *     // Fires when the hide() method is used
	 *     .then(function() {
	 *       console.log('You clicked the button to close the bottom sheet!');
	 *     })
	 *
	 *     // Fires when the cancel() method is used
	 *     .catch(function() {
	 *       console.log('You hit escape or clicked the backdrop to close.');
	 *     });
	 *   };
	 *
	 *   $scope.closeBottomSheet = function($scope, $mdBottomSheet) {
	 *     $mdBottomSheet.hide();
	 *   }
	 *
	 * });
	 * </hljs>
	 */
	
	 /**
	 * @ngdoc method
	 * @name $mdBottomSheet#show
	 *
	 * @description
	 * Show a bottom sheet with the specified options.
	 *
	 * <em><b>Note:</b> You should <b>always</b> provide a `.catch()` method in case the user hits the
	 * `esc` key or clicks the background to close. In this case, the `cancel()` method will
	 * automatically be called on the bottom sheet which will `reject()` the promise. See the @usage
	 * section above for an example.
	 *
	 * Newer versions of Angular will throw a `Possibly unhandled rejection` exception if you forget
	 * this.</em>
	 *
	 * @param {object} options An options object, with the following properties:
	 *
	 *   - `templateUrl` - `{string=}`: The url of an html template file that will
	 *   be used as the content of the bottom sheet. Restrictions: the template must
	 *   have an outer `md-bottom-sheet` element.
	 *   - `template` - `{string=}`: Same as templateUrl, except this is an actual
	 *   template string.
	 *   - `scope` - `{object=}`: the scope to link the template / controller to. If none is specified, it will create a new child scope.
	 *     This scope will be destroyed when the bottom sheet is removed unless `preserveScope` is set to true.
	 *   - `preserveScope` - `{boolean=}`: whether to preserve the scope when the element is removed. Default is false
	 *   - `controller` - `{string=}`: The controller to associate with this bottom sheet.
	 *   - `locals` - `{string=}`: An object containing key/value pairs. The keys will
	 *   be used as names of values to inject into the controller. For example,
	 *   `locals: {three: 3}` would inject `three` into the controller with the value
	 *   of 3.
	 *   - `clickOutsideToClose` - `{boolean=}`: Whether the user can click outside the bottom sheet to
	 *     close it. Default true.
	 *   - `bindToController` - `{boolean=}`: When set to true, the locals will be bound to the controller instance.
	 *   - `disableBackdrop` - `{boolean=}`: When set to true, the bottomsheet will not show a backdrop.
	 *   - `escapeToClose` - `{boolean=}`: Whether the user can press escape to close the bottom sheet.
	 *     Default true.
	 *   - `resolve` - `{object=}`: Similar to locals, except it takes promises as values
	 *   and the bottom sheet will not open until the promises resolve.
	 *   - `controllerAs` - `{string=}`: An alias to assign the controller to on the scope.
	 *   - `parent` - `{element=}`: The element to append the bottom sheet to. The `parent` may be a `function`, `string`,
	 *   `object`, or null. Defaults to appending to the body of the root element (or the root element) of the application.
	 *   e.g. angular.element(document.getElementById('content')) or "#content"
	 *   - `disableParentScroll` - `{boolean=}`: Whether to disable scrolling while the bottom sheet is open.
	 *     Default true.
	 *
	 * @returns {promise} A promise that can be resolved with `$mdBottomSheet.hide()` or
	 * rejected with `$mdBottomSheet.cancel()`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdBottomSheet#hide
	 *
	 * @description
	 * Hide the existing bottom sheet and resolve the promise returned from
	 * `$mdBottomSheet.show()`. This call will close the most recently opened/current bottomsheet (if
	 * any).
	 *
	 * <em><b>Note:</b> Use a `.then()` on your `.show()` to handle this callback.</em>
	 *
	 * @param {*=} response An argument for the resolved promise.
	 *
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdBottomSheet#cancel
	 *
	 * @description
	 * Hide the existing bottom sheet and reject the promise returned from
	 * `$mdBottomSheet.show()`.
	 *
	 * <em><b>Note:</b> Use a `.catch()` on your `.show()` to handle this callback.</em>
	 *
	 * @param {*=} response An argument for the rejected promise.
	 *
	 */
	
	function MdBottomSheetProvider($$interimElementProvider) {
	  // how fast we need to flick down to close the sheet, pixels/ms
	  bottomSheetDefaults.$inject = ["$animate", "$mdConstant", "$mdUtil", "$mdTheming", "$mdBottomSheet", "$rootElement", "$mdGesture", "$log"];
	  var CLOSING_VELOCITY = 0.5;
	  var PADDING = 80; // same as css
	
	  return $$interimElementProvider('$mdBottomSheet')
	    .setDefaults({
	      methods: ['disableParentScroll', 'escapeToClose', 'clickOutsideToClose'],
	      options: bottomSheetDefaults
	    });
	
	  /* @ngInject */
	  function bottomSheetDefaults($animate, $mdConstant, $mdUtil, $mdTheming, $mdBottomSheet, $rootElement,
	                               $mdGesture, $log) {
	    var backdrop;
	
	    return {
	      themable: true,
	      onShow: onShow,
	      onRemove: onRemove,
	      disableBackdrop: false,
	      escapeToClose: true,
	      clickOutsideToClose: true,
	      disableParentScroll: true
	    };
	
	
	    function onShow(scope, element, options, controller) {
	
	      element = $mdUtil.extractElementByName(element, 'md-bottom-sheet');
	
	      // prevent tab focus or click focus on the bottom-sheet container
	      element.attr('tabindex',"-1");
	
	      // Once the md-bottom-sheet has `ng-cloak` applied on his template the opening animation will not work properly.
	      // This is a very common problem, so we have to notify the developer about this.
	      if (element.hasClass('ng-cloak')) {
	        var message = '$mdBottomSheet: using `<md-bottom-sheet ng-cloak >` will affect the bottom-sheet opening animations.';
	        $log.warn( message, element[0] );
	      }
	
	      if (!options.disableBackdrop) {
	        // Add a backdrop that will close on click
	        backdrop = $mdUtil.createBackdrop(scope, "md-bottom-sheet-backdrop md-opaque");
	
	        // Prevent mouse focus on backdrop; ONLY programatic focus allowed.
	        // This allows clicks on backdrop to propogate to the $rootElement and
	        // ESC key events to be detected properly.
	        
	        backdrop[0].tabIndex = -1;
	
	        if (options.clickOutsideToClose) {
	          backdrop.on('click', function() {
	            $mdUtil.nextTick($mdBottomSheet.cancel,true);
	          });
	        }
	
	        $mdTheming.inherit(backdrop, options.parent);
	
	        $animate.enter(backdrop, options.parent, null);
	      }
	
	      var bottomSheet = new BottomSheet(element, options.parent);
	      options.bottomSheet = bottomSheet;
	
	      $mdTheming.inherit(bottomSheet.element, options.parent);
	
	      if (options.disableParentScroll) {
	        options.restoreScroll = $mdUtil.disableScrollAround(bottomSheet.element, options.parent);
	      }
	
	      return $animate.enter(bottomSheet.element, options.parent, backdrop)
	        .then(function() {
	          var focusable = $mdUtil.findFocusTarget(element) || angular.element(
	            element[0].querySelector('button') ||
	            element[0].querySelector('a') ||
	            element[0].querySelector($mdUtil.prefixer('ng-click', true))
	          ) || backdrop;
	
	          if (options.escapeToClose) {
	            options.rootElementKeyupCallback = function(e) {
	              if (e.keyCode === $mdConstant.KEY_CODE.ESCAPE) {
	                $mdUtil.nextTick($mdBottomSheet.cancel,true);
	              }
	            };
	
	            $rootElement.on('keyup', options.rootElementKeyupCallback);
	            focusable && focusable.focus();
	          }
	        });
	
	    }
	
	    function onRemove(scope, element, options) {
	
	      var bottomSheet = options.bottomSheet;
	
	      if (!options.disableBackdrop) $animate.leave(backdrop);
	      return $animate.leave(bottomSheet.element).then(function() {
	        if (options.disableParentScroll) {
	          options.restoreScroll();
	          delete options.restoreScroll;
	        }
	
	        bottomSheet.cleanup();
	      });
	    }
	
	    /**
	     * BottomSheet class to apply bottom-sheet behavior to an element
	     */
	    function BottomSheet(element, parent) {
	      var deregister = $mdGesture.register(parent, 'drag', { horizontal: false });
	      parent.on('$md.dragstart', onDragStart)
	        .on('$md.drag', onDrag)
	        .on('$md.dragend', onDragEnd);
	
	      return {
	        element: element,
	        cleanup: function cleanup() {
	          deregister();
	          parent.off('$md.dragstart', onDragStart);
	          parent.off('$md.drag', onDrag);
	          parent.off('$md.dragend', onDragEnd);
	        }
	      };
	
	      function onDragStart(ev) {
	        // Disable transitions on transform so that it feels fast
	        element.css($mdConstant.CSS.TRANSITION_DURATION, '0ms');
	      }
	
	      function onDrag(ev) {
	        var transform = ev.pointer.distanceY;
	        if (transform < 5) {
	          // Slow down drag when trying to drag up, and stop after PADDING
	          transform = Math.max(-PADDING, transform / 2);
	        }
	        element.css($mdConstant.CSS.TRANSFORM, 'translate3d(0,' + (PADDING + transform) + 'px,0)');
	      }
	
	      function onDragEnd(ev) {
	        if (ev.pointer.distanceY > 0 &&
	            (ev.pointer.distanceY > 20 || Math.abs(ev.pointer.velocityY) > CLOSING_VELOCITY)) {
	          var distanceRemaining = element.prop('offsetHeight') - ev.pointer.distanceY;
	          var transitionDuration = Math.min(distanceRemaining / ev.pointer.velocityY * 0.75, 500);
	          element.css($mdConstant.CSS.TRANSITION_DURATION, transitionDuration + 'ms');
	          $mdUtil.nextTick($mdBottomSheet.cancel,true);
	        } else {
	          element.css($mdConstant.CSS.TRANSITION_DURATION, '');
	          element.css($mdConstant.CSS.TRANSFORM, '');
	        }
	      }
	    }
	
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.button
	 * @description
	 *
	 * Button
	 */
	MdButtonDirective.$inject = ["$mdButtonInkRipple", "$mdTheming", "$mdAria", "$mdInteraction"];
	MdAnchorDirective.$inject = ["$mdTheming"];
	angular
	    .module('material.components.button', [ 'material.core' ])
	    .directive('mdButton', MdButtonDirective)
	    .directive('a', MdAnchorDirective);
	
	
	/**
	 * @private
	 * @restrict E
	 *
	 * @description
	 * `a` is an anchor directive used to inherit theme colors for md-primary, md-accent, etc.
	 *
	 * @usage
	 *
	 * <hljs lang="html">
	 *  <md-content md-theme="myTheme">
	 *    <a href="#chapter1" class="md-accent"></a>
	 *  </md-content>
	 * </hljs>
	 */
	function MdAnchorDirective($mdTheming) {
	  return {
	    restrict : 'E',
	    link : function postLink(scope, element) {
	      // Make sure to inherit theme so stand-alone anchors
	      // support theme colors for md-primary, md-accent, etc.
	      $mdTheming(element);
	    }
	  };
	}
	
	
	/**
	 * @ngdoc directive
	 * @name mdButton
	 * @module material.components.button
	 *
	 * @restrict E
	 *
	 * @description
	 * `<md-button>` is a button directive with optional ink ripples (default enabled).
	 *
	 * If you supply a `href` or `ng-href` attribute, it will become an `<a>` element. Otherwise, it
	 * will become a `<button>` element. As per the
	 * [Material Design specifications](https://material.google.com/style/color.html#color-color-palette)
	 * the FAB button background is filled with the accent color [by default]. The primary color palette
	 * may be used with the `md-primary` class.
	 *
	 * Developers can also change the color palette of the button, by using the following classes
	 * - `md-primary`
	 * - `md-accent`
	 * - `md-warn`
	 *
	 * See for example
	 *
	 * <hljs lang="html">
	 *   <md-button class="md-primary">Primary Button</md-button>
	 * </hljs>
	 *
	 * Button can be also raised, which means that they will use the current color palette to fill the button.
	 *
	 * <hljs lang="html">
	 *   <md-button class="md-accent md-raised">Raised and Accent Button</md-button>
	 * </hljs>
	 *
	 * It is also possible to disable the focus effect on the button, by using the following markup.
	 *
	 * <hljs lang="html">
	 *   <md-button class="md-no-focus">No Focus Style</md-button>
	 * </hljs>
	 *
	 * @param {boolean=} md-no-ink If present, disable ripple ink effects.
	 * @param {expression=} ng-disabled En/Disable based on the expression
	 * @param {string=} md-ripple-size Overrides the default ripple size logic. Options: `full`, `partial`, `auto`
	 * @param {string=} aria-label Adds alternative text to button for accessibility, useful for icon buttons.
	 * If no default text is found, a warning will be logged.
	 *
	 * @usage
	 *
	 * Regular buttons:
	 *
	 * <hljs lang="html">
	 *  <md-button> Flat Button </md-button>
	 *  <md-button href="http://google.com"> Flat link </md-button>
	 *  <md-button class="md-raised"> Raised Button </md-button>
	 *  <md-button ng-disabled="true"> Disabled Button </md-button>
	 *  <md-button>
	 *    <md-icon md-svg-src="your/icon.svg"></md-icon>
	 *    Register Now
	 *  </md-button>
	 * </hljs>
	 *
	 * FAB buttons:
	 *
	 * <hljs lang="html">
	 *  <md-button class="md-fab" aria-label="FAB">
	 *    <md-icon md-svg-src="your/icon.svg"></md-icon>
	 *  </md-button>
	 *  <!-- mini-FAB -->
	 *  <md-button class="md-fab md-mini" aria-label="Mini FAB">
	 *    <md-icon md-svg-src="your/icon.svg"></md-icon>
	 *  </md-button>
	 *  <!-- Button with SVG Icon -->
	 *  <md-button class="md-icon-button" aria-label="Custom Icon Button">
	 *    <md-icon md-svg-icon="path/to/your.svg"></md-icon>
	 *  </md-button>
	 * </hljs>
	 */
	function MdButtonDirective($mdButtonInkRipple, $mdTheming, $mdAria, $mdInteraction) {
	
	  return {
	    restrict: 'EA',
	    replace: true,
	    transclude: true,
	    template: getTemplate,
	    link: postLink
	  };
	
	  function isAnchor(attr) {
	    return angular.isDefined(attr.href) || angular.isDefined(attr.ngHref) || angular.isDefined(attr.ngLink) || angular.isDefined(attr.uiSref);
	  }
	
	  function getTemplate(element, attr) {
	    if (isAnchor(attr)) {
	      return '<a class="md-button" ng-transclude></a>';
	    } else {
	      //If buttons don't have type="button", they will submit forms automatically.
	      var btnType = (typeof attr.type === 'undefined') ? 'button' : attr.type;
	      return '<button class="md-button" type="' + btnType + '" ng-transclude></button>';
	    }
	  }
	
	  function postLink(scope, element, attr) {
	    $mdTheming(element);
	    $mdButtonInkRipple.attach(scope, element);
	
	    // Use async expect to support possible bindings in the button label
	    $mdAria.expectWithoutText(element, 'aria-label');
	
	    // For anchor elements, we have to set tabindex manually when the
	    // element is disabled
	    if (isAnchor(attr) && angular.isDefined(attr.ngDisabled) ) {
	      scope.$watch(attr.ngDisabled, function(isDisabled) {
	        element.attr('tabindex', isDisabled ? -1 : 0);
	      });
	    }
	
	    // disabling click event when disabled is true
	    element.on('click', function(e){
	      if (attr.disabled === true) {
	        e.preventDefault();
	        e.stopImmediatePropagation();
	      }
	    });
	
	    if (!element.hasClass('md-no-focus')) {
	
	      element.on('focus', function() {
	
	        // Only show the focus effect when being focused through keyboard interaction or programmatically
	        if (!$mdInteraction.isUserInvoked() || $mdInteraction.getLastInteractionType() === 'keyboard') {
	          element.addClass('md-focused');
	        }
	
	      });
	
	      element.on('blur', function() {
	        element.removeClass('md-focused');
	      });
	    }
	
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.card
	 *
	 * @description
	 * Card components.
	 */
	mdCardDirective.$inject = ["$mdTheming"];
	angular.module('material.components.card', [
	    'material.core'
	  ])
	  .directive('mdCard', mdCardDirective);
	
	
	/**
	 * @ngdoc directive
	 * @name mdCard
	 * @module material.components.card
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-card>` directive is a container element used within `<md-content>` containers.
	 *
	 * An image included as a direct descendant will fill the card's width. If you want to avoid this,
	 * you can add the `md-image-no-fill` class to the parent element. The `<md-card-content>`
	 * container will wrap text content and provide padding. An `<md-card-footer>` element can be
	 * optionally included to put content flush against the bottom edge of the card.
	 *
	 * Action buttons can be included in an `<md-card-actions>` element, similar to `<md-dialog-actions>`.
	 * You can then position buttons using layout attributes.
	 *
	 * Card is built with:
	 * * `<md-card-header>` - Header for the card, holds avatar, text and squared image
	 *  - `<md-card-avatar>` - Card avatar
	 *    - `md-user-avatar` - Class for user image
	 *    - `<md-icon>`
	 *  - `<md-card-header-text>` - Contains elements for the card description
	 *    - `md-title` - Class for the card title
	 *    - `md-subhead` - Class for the card sub header
	 * * `<img>` - Image for the card
	 * * `<md-card-title>` - Card content title
	 *  - `<md-card-title-text>`
	 *    - `md-headline` - Class for the card content title
	 *    - `md-subhead` - Class for the card content sub header
	 *  - `<md-card-title-media>` - Squared image within the title
	 *    - `md-media-sm` - Class for small image
	 *    - `md-media-md` - Class for medium image
	 *    - `md-media-lg` - Class for large image
	 *    - `md-media-xl` - Class for extra large image
	 * * `<md-card-content>` - Card content
	 * * `<md-card-actions>` - Card actions
	 *  - `<md-card-icon-actions>` - Icon actions
	 *
	 * Cards have constant width and variable heights; where the maximum height is limited to what can
	 * fit within a single view on a platform, but it can temporarily expand as needed.
	 *
	 * @usage
	 * ### Card with optional footer
	 * <hljs lang="html">
	 * <md-card>
	 *  <img src="card-image.png" class="md-card-image" alt="image caption">
	 *  <md-card-content>
	 *    <h2>Card headline</h2>
	 *    <p>Card content</p>
	 *  </md-card-content>
	 *  <md-card-footer>
	 *    Card footer
	 *  </md-card-footer>
	 * </md-card>
	 * </hljs>
	 *
	 * ### Card with actions
	 * <hljs lang="html">
	 * <md-card>
	 *  <img src="card-image.png" class="md-card-image" alt="image caption">
	 *  <md-card-content>
	 *    <h2>Card headline</h2>
	 *    <p>Card content</p>
	 *  </md-card-content>
	 *  <md-card-actions layout="row" layout-align="end center">
	 *    <md-button>Action 1</md-button>
	 *    <md-button>Action 2</md-button>
	 *  </md-card-actions>
	 * </md-card>
	 * </hljs>
	 *
	 * ### Card with header, image, title actions and content
	 * <hljs lang="html">
	 * <md-card>
	 *   <md-card-header>
	 *     <md-card-avatar>
	 *       <img class="md-user-avatar" src="avatar.png"/>
	 *     </md-card-avatar>
	 *     <md-card-header-text>
	 *       <span class="md-title">Title</span>
	 *       <span class="md-subhead">Sub header</span>
	 *     </md-card-header-text>
	 *   </md-card-header>
	 *   <img ng-src="card-image.png" class="md-card-image" alt="image caption">
	 *   <md-card-title>
	 *     <md-card-title-text>
	 *       <span class="md-headline">Card headline</span>
	 *       <span class="md-subhead">Card subheader</span>
	 *     </md-card-title-text>
	 *   </md-card-title>
	 *   <md-card-actions layout="row" layout-align="start center">
	 *     <md-button>Action 1</md-button>
	 *     <md-button>Action 2</md-button>
	 *     <md-card-icon-actions>
	 *       <md-button class="md-icon-button" aria-label="icon">
	 *         <md-icon md-svg-icon="icon"></md-icon>
	 *       </md-button>
	 *     </md-card-icon-actions>
	 *   </md-card-actions>
	 *   <md-card-content>
	 *     <p>
	 *      Card content
	 *     </p>
	 *   </md-card-content>
	 * </md-card>
	 * </hljs>
	 */
	function mdCardDirective($mdTheming) {
	  return {
	    restrict: 'E',
	    link: function ($scope, $element, attr) {
	      $element.addClass('_md');     // private md component indicator for styling
	      $mdTheming($element);
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.checkbox
	 * @description Checkbox module!
	 */
	MdCheckboxDirective.$inject = ["inputDirective", "$mdAria", "$mdConstant", "$mdTheming", "$mdUtil", "$mdInteraction"];
	angular
	  .module('material.components.checkbox', ['material.core'])
	  .directive('mdCheckbox', MdCheckboxDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdCheckbox
	 * @module material.components.checkbox
	 * @restrict E
	 *
	 * @description
	 * The checkbox directive is used like the normal [angular checkbox](https://docs.angularjs.org/api/ng/input/input%5Bcheckbox%5D).
	 *
	 * As per the [material design spec](http://www.google.com/design/spec/style/color.html#color-color-schemes)
	 * the checkbox is in the accent color by default. The primary color palette may be used with
	 * the `md-primary` class.
	 *
	 * @param {string} ng-model Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {expression=} ng-true-value The value to which the expression should be set when selected.
	 * @param {expression=} ng-false-value The value to which the expression should be set when not selected.
	 * @param {string=} ng-change AngularJS expression to be executed when input changes due to user interaction with the input element.
	 * @param {boolean=} md-no-ink Use of attribute indicates use of ripple ink effects
	 * @param {string=} aria-label Adds label to checkbox for accessibility.
	 *     Defaults to checkbox's text. If no default text is found, a warning will be logged.
	 * @param {expression=} md-indeterminate This determines when the checkbox should be rendered as 'indeterminate'.
	 *     If a truthy expression or no value is passed in the checkbox renders in the md-indeterminate state.
	 *     If falsy expression is passed in it just looks like a normal unchecked checkbox.
	 *     The indeterminate, checked, and unchecked states are mutually exclusive. A box cannot be in any two states at the same time.
	 *     Adding the 'md-indeterminate' attribute overrides any checked/unchecked rendering logic.
	 *     When using the 'md-indeterminate' attribute use 'ng-checked' to define rendering logic instead of using 'ng-model'.
	 * @param {expression=} ng-checked If this expression evaluates as truthy, the 'md-checked' css class is added to the checkbox and it
	 *     will appear checked.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-checkbox ng-model="isChecked" aria-label="Finished?">
	 *   Finished ?
	 * </md-checkbox>
	 *
	 * <md-checkbox md-no-ink ng-model="hasInk" aria-label="No Ink Effects">
	 *   No Ink Effects
	 * </md-checkbox>
	 *
	 * <md-checkbox ng-disabled="true" ng-model="isDisabled" aria-label="Disabled">
	 *   Disabled
	 * </md-checkbox>
	 *
	 * </hljs>
	 *
	 */
	function MdCheckboxDirective(inputDirective, $mdAria, $mdConstant, $mdTheming, $mdUtil, $mdInteraction) {
	  inputDirective = inputDirective[0];
	
	  return {
	    restrict: 'E',
	    transclude: true,
	    require: ['^?mdInputContainer', '?ngModel', '?^form'],
	    priority: $mdConstant.BEFORE_NG_ARIA,
	    template:
	      '<div class="md-container" md-ink-ripple md-ink-ripple-checkbox>' +
	        '<div class="md-icon"></div>' +
	      '</div>' +
	      '<div ng-transclude class="md-label"></div>',
	    compile: compile
	  };
	
	  // **********************************************************
	  // Private Methods
	  // **********************************************************
	
	  function compile (tElement, tAttrs) {
	    tAttrs.$set('tabindex', tAttrs.tabindex || '0');
	    tAttrs.$set('type', 'checkbox');
	    tAttrs.$set('role', tAttrs.type);
	
	    return  {
	      pre: function(scope, element) {
	        // Attach a click handler during preLink, in order to immediately stop propagation
	        // (especially for ng-click) when the checkbox is disabled.
	        element.on('click', function(e) {
	          if (this.hasAttribute('disabled')) {
	            e.stopImmediatePropagation();
	          }
	        });
	      },
	      post: postLink
	    };
	
	    function postLink(scope, element, attr, ctrls) {
	      var isIndeterminate;
	      var containerCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1] || $mdUtil.fakeNgModel();
	      var formCtrl = ctrls[2];
	
	      if (containerCtrl) {
	        var isErrorGetter = containerCtrl.isErrorGetter || function() {
	          return ngModelCtrl.$invalid && (ngModelCtrl.$touched || (formCtrl && formCtrl.$submitted));
	        };
	
	        containerCtrl.input = element;
	
	        scope.$watch(isErrorGetter, containerCtrl.setInvalid);
	      }
	
	      $mdTheming(element);
	
	      // Redirect focus events to the root element, because IE11 is always focusing the container element instead
	      // of the md-checkbox element. This causes issues when using ngModelOptions: `updateOnBlur`
	      element.children().on('focus', function() {
	        element.focus();
	      });
	
	      if ($mdUtil.parseAttributeBoolean(attr.mdIndeterminate)) {
	        setIndeterminateState();
	        scope.$watch(attr.mdIndeterminate, setIndeterminateState);
	      }
	
	      if (attr.ngChecked) {
	        scope.$watch(scope.$eval.bind(scope, attr.ngChecked), function(value) {
	          ngModelCtrl.$setViewValue(value);
	          ngModelCtrl.$render();
	        });
	      }
	
	      $$watchExpr('ngDisabled', 'tabindex', {
	        true: '-1',
	        false: attr.tabindex
	      });
	
	      $mdAria.expectWithText(element, 'aria-label');
	
	      // Reuse the original input[type=checkbox] directive from AngularJS core.
	      // This is a bit hacky as we need our own event listener and own render
	      // function.
	      inputDirective.link.pre(scope, {
	        on: angular.noop,
	        0: {}
	      }, attr, [ngModelCtrl]);
	
	      element.on('click', listener)
	        .on('keypress', keypressHandler)
	        .on('focus', function() {
	          if ($mdInteraction.getLastInteractionType() === 'keyboard') {
	            element.addClass('md-focused');
	          }
	        })
	        .on('blur', function() {
	          element.removeClass('md-focused');
	        });
	
	      ngModelCtrl.$render = render;
	
	      function $$watchExpr(expr, htmlAttr, valueOpts) {
	        if (attr[expr]) {
	          scope.$watch(attr[expr], function(val) {
	            if (valueOpts[val]) {
	              element.attr(htmlAttr, valueOpts[val]);
	            }
	          });
	        }
	      }
	
	      function keypressHandler(ev) {
	        var keyCode = ev.which || ev.keyCode;
	        if (keyCode === $mdConstant.KEY_CODE.SPACE || keyCode === $mdConstant.KEY_CODE.ENTER) {
	          ev.preventDefault();
	          element.addClass('md-focused');
	          listener(ev);
	        }
	      }
	
	      function listener(ev) {
	        // skipToggle boolean is used by the switch directive to prevent the click event
	        // when releasing the drag. There will be always a click if releasing the drag over the checkbox
	        if (element[0].hasAttribute('disabled') || scope.skipToggle) {
	          return;
	        }
	
	        scope.$apply(function() {
	          // Toggle the checkbox value...
	          var viewValue = attr.ngChecked && attr.ngClick ? attr.checked : !ngModelCtrl.$viewValue;
	
	          ngModelCtrl.$setViewValue(viewValue, ev && ev.type);
	          ngModelCtrl.$render();
	        });
	      }
	
	      function render() {
	        // Cast the $viewValue to a boolean since it could be undefined
	        element.toggleClass('md-checked', !!ngModelCtrl.$viewValue && !isIndeterminate);
	      }
	
	      function setIndeterminateState(newValue) {
	        isIndeterminate = newValue !== false;
	        if (isIndeterminate) {
	          element.attr('aria-checked', 'mixed');
	        }
	        element.toggleClass('md-indeterminate', isIndeterminate);
	      }
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.chips
	 */
	/*
	 * @see js folder for chips implementation
	 */
	angular.module('material.components.chips', [
	  'material.core',
	  'material.components.autocomplete'
	]);
	
	})();
	(function(){
	"use strict";
	
	(function () {
	  "use strict";
	
	  /**
	   *  Use a RegExp to check if the `md-colors="<expression>"` is static string
	   *  or one that should be observed and dynamically interpolated.
	   */
	  MdColorsDirective.$inject = ["$mdColors", "$mdUtil", "$log", "$parse"];
	  MdColorsService.$inject = ["$mdTheming", "$mdUtil", "$log"];
	  var STATIC_COLOR_EXPRESSION = /^{((\s|,)*?["'a-zA-Z-]+?\s*?:\s*?('|")[a-zA-Z0-9-.]*('|"))+\s*}$/;
	  var colorPalettes = null;
	
	  /**
	   * @ngdoc module
	   * @name material.components.colors
	   *
	   * @description
	   * Define $mdColors service and a `md-colors=""` attribute directive
	   */
	  angular
	    .module('material.components.colors', ['material.core'])
	    .directive('mdColors', MdColorsDirective)
	    .service('$mdColors', MdColorsService);
	
	  /**
	   * @ngdoc service
	   * @name $mdColors
	   * @module material.components.colors
	   *
	   * @description
	   * With only defining themes, one couldn't get non AngularJS Material elements colored with Material colors,
	   * `$mdColors` service is used by the md-color directive to convert the 1..n color expressions to RGBA values and will apply
	   * those values to element as CSS property values.
	   *
	   *  @usage
	   *  <hljs lang="js">
	   *    angular.controller('myCtrl', function ($mdColors) {
	   *      var color = $mdColors.getThemeColor('myTheme-red-200-0.5');
	   *      ...
	   *    });
	   *  </hljs>
	   *
	   */
	  function MdColorsService($mdTheming, $mdUtil, $log) {
	    colorPalettes = colorPalettes || Object.keys($mdTheming.PALETTES);
	
	    // Publish service instance
	    return {
	      applyThemeColors: applyThemeColors,
	      getThemeColor: getThemeColor,
	      hasTheme: hasTheme
	    };
	
	    // ********************************************
	    // Internal Methods
	    // ********************************************
	
	    /**
	     * @ngdoc method
	     * @name $mdColors#applyThemeColors
	     *
	     * @description
	     * Gets a color json object, keys are css properties and values are string of the wanted color
	     * Then calculate the rgba() values based on the theme color parts
	     *
	     * @param {DOMElement} element the element to apply the styles on.
	     * @param {object} colorExpression json object, keys are css properties and values are string of the wanted color,
	     * for example: `{color: 'red-A200-0.3'}`.
	     *
	     * @usage
	     * <hljs lang="js">
	     *   app.directive('myDirective', function($mdColors) {
	     *     return {
	     *       ...
	     *       link: function (scope, elem) {
	     *         $mdColors.applyThemeColors(elem, {color: 'red'});
	     *       }
	     *    }
	     *   });
	     * </hljs>
	     */
	    function applyThemeColors(element, colorExpression) {
	      try {
	        if (colorExpression) {
	          // Assign the calculate RGBA color values directly as inline CSS
	          element.css(interpolateColors(colorExpression));
	        }
	      } catch (e) {
	        $log.error(e.message);
	      }
	
	    }
	
	    /**
	     * @ngdoc method
	     * @name $mdColors#getThemeColor
	     *
	     * @description
	     * Get parsed color from expression
	     *
	     * @param {string} expression string of a color expression (for instance `'red-700-0.8'`)
	     *
	     * @returns {string} a css color expression (for instance `rgba(211, 47, 47, 0.8)`)
	     *
	     * @usage
	     *  <hljs lang="js">
	     *    angular.controller('myCtrl', function ($mdColors) {
	     *      var color = $mdColors.getThemeColor('myTheme-red-200-0.5');
	     *      ...
	     *    });
	     *  </hljs>
	     */
	    function getThemeColor(expression) {
	      var color = extractColorOptions(expression);
	
	      return parseColor(color);
	    }
	
	    /**
	     * Return the parsed color
	     * @param color hashmap of color definitions
	     * @param contrast whether use contrast color for foreground
	     * @returns rgba color string
	     */
	    function parseColor(color, contrast) {
	      contrast = contrast || false;
	      var rgbValues = $mdTheming.PALETTES[color.palette][color.hue];
	
	      rgbValues = contrast ? rgbValues.contrast : rgbValues.value;
	
	      return $mdUtil.supplant('rgba({0}, {1}, {2}, {3})',
	        [rgbValues[0], rgbValues[1], rgbValues[2], rgbValues[3] || color.opacity]
	      );
	    }
	
	    /**
	     * Convert the color expression into an object with scope-interpolated values
	     * Then calculate the rgba() values based on the theme color parts
	     *
	     * @results Hashmap of CSS properties with associated `rgba( )` string vales
	     *
	     *
	     */
	    function interpolateColors(themeColors) {
	      var rgbColors = {};
	
	      var hasColorProperty = themeColors.hasOwnProperty('color');
	
	      angular.forEach(themeColors, function (value, key) {
	        var color = extractColorOptions(value);
	        var hasBackground = key.indexOf('background') > -1;
	
	        rgbColors[key] = parseColor(color);
	        if (hasBackground && !hasColorProperty) {
	          rgbColors.color = parseColor(color, true);
	        }
	      });
	
	      return rgbColors;
	    }
	
	    /**
	     * Check if expression has defined theme
	     * e.g.
	     * 'myTheme-primary' => true
	     * 'red-800' => false
	     */
	    function hasTheme(expression) {
	      return angular.isDefined($mdTheming.THEMES[expression.split('-')[0]]);
	    }
	
	    /**
	     * For the evaluated expression, extract the color parts into a hash map
	     */
	    function extractColorOptions(expression) {
	      var parts = expression.split('-');
	      var hasTheme = angular.isDefined($mdTheming.THEMES[parts[0]]);
	      var theme = hasTheme ? parts.splice(0, 1)[0] : $mdTheming.defaultTheme();
	
	      return {
	        theme: theme,
	        palette: extractPalette(parts, theme),
	        hue: extractHue(parts, theme),
	        opacity: parts[2] || 1
	      };
	    }
	
	    /**
	     * Calculate the theme palette name
	     */
	    function extractPalette(parts, theme) {
	      // If the next section is one of the palettes we assume it's a two word palette
	      // Two word palette can be also written in camelCase, forming camelCase to dash-case
	
	      var isTwoWord = parts.length > 1 && colorPalettes.indexOf(parts[1]) !== -1;
	      var palette = parts[0].replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
	
	      if (isTwoWord)  palette = parts[0] + '-' + parts.splice(1, 1);
	
	      if (colorPalettes.indexOf(palette) === -1) {
	        // If the palette is not in the palette list it's one of primary/accent/warn/background
	        var scheme = $mdTheming.THEMES[theme].colors[palette];
	        if (!scheme) {
	          throw new Error($mdUtil.supplant('mdColors: couldn\'t find \'{palette}\' in the palettes.', {palette: palette}));
	        }
	        palette = scheme.name;
	      }
	
	      return palette;
	    }
	
	    function extractHue(parts, theme) {
	      var themeColors = $mdTheming.THEMES[theme].colors;
	
	      if (parts[1] === 'hue') {
	        var hueNumber = parseInt(parts.splice(2, 1)[0], 10);
	
	        if (hueNumber < 1 || hueNumber > 3) {
	          throw new Error($mdUtil.supplant('mdColors: \'hue-{hueNumber}\' is not a valid hue, can be only \'hue-1\', \'hue-2\' and \'hue-3\'', {hueNumber: hueNumber}));
	        }
	        parts[1] = 'hue-' + hueNumber;
	
	        if (!(parts[0] in themeColors)) {
	          throw new Error($mdUtil.supplant('mdColors: \'hue-x\' can only be used with [{availableThemes}], but was used with \'{usedTheme}\'', {
	            availableThemes: Object.keys(themeColors).join(', '),
	            usedTheme: parts[0]
	          }));
	        }
	
	        return themeColors[parts[0]].hues[parts[1]];
	      }
	
	      return parts[1] || themeColors[parts[0] in themeColors ? parts[0] : 'primary'].hues['default'];
	    }
	  }
	
	  /**
	   * @ngdoc directive
	   * @name mdColors
	   * @module material.components.colors
	   *
	   * @restrict A
	   *
	   * @description
	   * `mdColors` directive will apply the theme-based color expression as RGBA CSS style values.
	   *
	   *   The format will be similar to our color defining in the scss files:
	   *
	   *   ## `[?theme]-[palette]-[?hue]-[?opacity]`
	   *   - [theme]    - default value is the default theme
	   *   - [palette]  - can be either palette name or primary/accent/warn/background
	   *   - [hue]      - default is 500 (hue-x can be used with primary/accent/warn/background)
	   *   - [opacity]  - default is 1
	   *
	   *   > `?` indicates optional parameter
	   *
	   * @usage
	   * <hljs lang="html">
	   *   <div md-colors="{background: 'myTheme-accent-900-0.43'}">
	   *     <div md-colors="{color: 'red-A100', 'border-color': 'primary-600'}">
	   *       <span>Color demo</span>
	   *     </div>
	   *   </div>
	   * </hljs>
	   *
	   * `mdColors` directive will automatically watch for changes in the expression if it recognizes an interpolation
	   * expression or a function. For performance options, you can use `::` prefix to the `md-colors` expression
	   * to indicate a one-time data binding.
	   * <hljs lang="html">
	   *   <md-card md-colors="::{background: '{{theme}}-primary-700'}">
	   *   </md-card>
	   * </hljs>
	   *
	   */
	  function MdColorsDirective($mdColors, $mdUtil, $log, $parse) {
	    return {
	      restrict: 'A',
	      require: ['^?mdTheme'],
	      compile: function (tElem, tAttrs) {
	        var shouldWatch = shouldColorsWatch();
	
	        return function (scope, element, attrs, ctrl) {
	          var mdThemeController = ctrl[0];
	
	          var lastColors = {};
	
	          var parseColors = function (theme) {
	            if (typeof theme !== 'string') {
	              theme = '';
	            }
	
	            if (!attrs.mdColors) {
	              attrs.mdColors = '{}';
	            }
	
	            /**
	             * Json.parse() does not work because the keys are not quoted;
	             * use $parse to convert to a hash map
	             */
	            var colors = $parse(attrs.mdColors)(scope);
	
	            /**
	             * If mdTheme is defined up the DOM tree
	             * we add mdTheme theme to colors who doesn't specified a theme
	             *
	             * # example
	             * <hljs lang="html">
	             *   <div md-theme="myTheme">
	             *     <div md-colors="{background: 'primary-600'}">
	             *       <span md-colors="{background: 'mySecondTheme-accent-200'}">Color demo</span>
	             *     </div>
	             *   </div>
	             * </hljs>
	             *
	             * 'primary-600' will be 'myTheme-primary-600',
	             * but 'mySecondTheme-accent-200' will stay the same cause it has a theme prefix
	             */
	            if (mdThemeController) {
	              Object.keys(colors).forEach(function (prop) {
	                var color = colors[prop];
	                if (!$mdColors.hasTheme(color)) {
	                  colors[prop] = (theme || mdThemeController.$mdTheme) + '-' + color;
	                }
	              });
	            }
	
	            cleanElement(colors);
	
	            return colors;
	          };
	
	          var cleanElement = function (colors) {
	            if (!angular.equals(colors, lastColors)) {
	              var keys = Object.keys(lastColors);
	
	              if (lastColors.background && !keys.color) {
	                keys.push('color');
	              }
	
	              keys.forEach(function (key) {
	                element.css(key, '');
	              });
	            }
	
	            lastColors = colors;
	          };
	
	          /**
	           * Registering for mgTheme changes and asking mdTheme controller run our callback whenever a theme changes
	           */
	          var unregisterChanges = angular.noop;
	
	          if (mdThemeController) {
	            unregisterChanges = mdThemeController.registerChanges(function (theme) {
	              $mdColors.applyThemeColors(element, parseColors(theme));
	            });
	          }
	
	          scope.$on('$destroy', function () {
	            unregisterChanges();
	          });
	
	          try {
	            if (shouldWatch) {
	              scope.$watch(parseColors, angular.bind(this,
	                $mdColors.applyThemeColors, element
	              ), true);
	            }
	            else {
	              $mdColors.applyThemeColors(element, parseColors());
	            }
	
	          }
	          catch (e) {
	            $log.error(e.message);
	          }
	
	        };
	
	        function shouldColorsWatch() {
	          // Simulate 1x binding and mark mdColorsWatch == false
	          var rawColorExpression = tAttrs.mdColors;
	          var bindOnce = rawColorExpression.indexOf('::') > -1;
	          var isStatic = bindOnce ? true : STATIC_COLOR_EXPRESSION.test(tAttrs.mdColors);
	
	          // Remove it for the postLink...
	          tAttrs.mdColors = rawColorExpression.replace('::', '');
	
	          var hasWatchAttr = angular.isDefined(tAttrs.mdColorsWatch);
	
	          return (bindOnce || isStatic) ? false :
	            hasWatchAttr ? $mdUtil.parseAttributeBoolean(tAttrs.mdColorsWatch) : true;
	        }
	      }
	    };
	
	  }
	
	
	})();
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.content
	 *
	 * @description
	 * Scrollable content
	 */
	mdContentDirective.$inject = ["$mdTheming"];
	angular.module('material.components.content', [
	  'material.core'
	])
	  .directive('mdContent', mdContentDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdContent
	 * @module material.components.content
	 *
	 * @restrict E
	 *
	 * @description
	 *
	 * The `<md-content>` directive is a container element useful for scrollable content. It achieves
	 * this by setting the CSS `overflow` property to `auto` so that content can properly scroll.
	 *
	 * In general, `<md-content>` components are not designed to be nested inside one another. If
	 * possible, it is better to make them siblings. This often results in a better user experience as
	 * having nested scrollbars may confuse the user.
	 *
	 * ## Troubleshooting
	 *
	 * In some cases, you may wish to apply the `md-no-momentum` class to ensure that Safari's
	 * momentum scrolling is disabled. Momentum scrolling can cause flickering issues while scrolling
	 * SVG icons and some other components.
	 *
	 * Additionally, we now also offer the `md-no-flicker` class which can be applied to any element
	 * and uses a Webkit-specific filter of `blur(0px)` that forces GPU rendering of all elements
	 * inside (which eliminates the flicker on iOS devices).
	 *
	 * _<b>Note:</b> Forcing an element to render on the GPU can have unintended side-effects, especially
	 * related to the z-index of elements. Please use with caution and only on the elements needed._
	 *
	 * @usage
	 *
	 * Add the `[layout-padding]` attribute to make the content padded.
	 *
	 * <hljs lang="html">
	 *  <md-content layout-padding>
	 *      Lorem ipsum dolor sit amet, ne quod novum mei.
	 *  </md-content>
	 * </hljs>
	 */
	
	function mdContentDirective($mdTheming) {
	  return {
	    restrict: 'E',
	    controller: ['$scope', '$element', ContentController],
	    link: function(scope, element) {
	      element.addClass('_md');     // private md component indicator for styling
	
	      $mdTheming(element);
	      scope.$broadcast('$mdContentLoaded', element);
	
	      iosScrollFix(element[0]);
	    }
	  };
	
	  function ContentController($scope, $element) {
	    this.$scope = $scope;
	    this.$element = $element;
	  }
	}
	
	function iosScrollFix(node) {
	  // IOS FIX:
	  // If we scroll where there is no more room for the webview to scroll,
	  // by default the webview itself will scroll up and down, this looks really
	  // bad.  So if we are scrolling to the very top or bottom, add/subtract one
	  angular.element(node).on('$md.pressdown', function(ev) {
	    // Only touch events
	    if (ev.pointer.type !== 't') return;
	    // Don't let a child content's touchstart ruin it for us.
	    if (ev.$materialScrollFixed) return;
	    ev.$materialScrollFixed = true;
	
	    if (node.scrollTop === 0) {
	      node.scrollTop = 1;
	    } else if (node.scrollHeight === node.scrollTop + node.offsetHeight) {
	      node.scrollTop -= 1;
	    }
	  });
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.datepicker
	 * @description Module for the datepicker component.
	 */
	
	angular.module('material.components.datepicker', [
	  'material.core',
	  'material.components.icon',
	  'material.components.virtualRepeat'
	]);
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.dialog
	 */
	MdDialogDirective.$inject = ["$$rAF", "$mdTheming", "$mdDialog"];
	MdDialogProvider.$inject = ["$$interimElementProvider"];
	angular
	  .module('material.components.dialog', [
	    'material.core',
	    'material.components.backdrop'
	  ])
	  .directive('mdDialog', MdDialogDirective)
	  .provider('$mdDialog', MdDialogProvider);
	
	/**
	 * @ngdoc directive
	 * @name mdDialog
	 * @module material.components.dialog
	 *
	 * @restrict E
	 *
	 * @description
	 * `<md-dialog>` - The dialog's template must be inside this element.
	 *
	 * Inside, use an `<md-dialog-content>` element for the dialog's content, and use
	 * an `<md-dialog-actions>` element for the dialog's actions.
	 *
	 * ## CSS
	 * - `.md-dialog-content` - class that sets the padding on the content as the spec file
	 *
	 * ## Notes
	 * - If you specify an `id` for the `<md-dialog>`, the `<md-dialog-content>` will have the same `id`
	 * prefixed with `dialogContent_`.
	 *
	 * @usage
	 * ### Dialog template
	 * <hljs lang="html">
	 * <md-dialog aria-label="List dialog">
	 *   <md-dialog-content>
	 *     <md-list>
	 *       <md-list-item ng-repeat="item in items">
	 *         <p>Number {{item}}</p>
	 *       </md-list-item>
	 *     </md-list>
	 *   </md-dialog-content>
	 *   <md-dialog-actions>
	 *     <md-button ng-click="closeDialog()" class="md-primary">Close Dialog</md-button>
	 *   </md-dialog-actions>
	 * </md-dialog>
	 * </hljs>
	 */
	function MdDialogDirective($$rAF, $mdTheming, $mdDialog) {
	  return {
	    restrict: 'E',
	    link: function(scope, element) {
	      element.addClass('_md');     // private md component indicator for styling
	
	      $mdTheming(element);
	      $$rAF(function() {
	        var images;
	        var content = element[0].querySelector('md-dialog-content');
	
	        if (content) {
	          images = content.getElementsByTagName('img');
	          addOverflowClass();
	          //-- delayed image loading may impact scroll height, check after images are loaded
	          angular.element(images).on('load', addOverflowClass);
	        }
	
	        scope.$on('$destroy', function() {
	          $mdDialog.destroy(element);
	        });
	
	        /**
	         *
	         */
	        function addOverflowClass() {
	          element.toggleClass('md-content-overflow', content.scrollHeight > content.clientHeight);
	        }
	
	
	      });
	    }
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $mdDialog
	 * @module material.components.dialog
	 *
	 * @description
	 * `$mdDialog` opens a dialog over the app to inform users about critical information or require
	 *  them to make decisions. There are two approaches for setup: a simple promise API
	 *  and regular object syntax.
	 *
	 * ## Restrictions
	 *
	 * - The dialog is always given an isolate scope.
	 * - The dialog's template must have an outer `<md-dialog>` element.
	 *   Inside, use an `<md-dialog-content>` element for the dialog's content, and use
	 *   an `<md-dialog-actions>` element for the dialog's actions.
	 * - Dialogs must cover the entire application to keep interactions inside of them.
	 * Use the `parent` option to change where dialogs are appended.
	 *
	 * ## Sizing
	 * - Complex dialogs can be sized with `flex="percentage"`, i.e. `flex="66"`.
	 * - Default max-width is 80% of the `rootElement` or `parent`.
	 *
	 * ## CSS
	 * - `.md-dialog-content` - class that sets the padding on the content as the spec file
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div  ng-app="demoApp" ng-controller="EmployeeController">
	 *   <div>
	 *     <md-button ng-click="showAlert()" class="md-raised md-warn">
	 *       Employee Alert!
	 *       </md-button>
	 *   </div>
	 *   <div>
	 *     <md-button ng-click="showDialog($event)" class="md-raised">
	 *       Custom Dialog
	 *       </md-button>
	 *   </div>
	 *   <div>
	 *     <md-button ng-click="closeAlert()" ng-disabled="!hasAlert()" class="md-raised">
	 *       Close Alert
	 *     </md-button>
	 *   </div>
	 *   <div>
	 *     <md-button ng-click="showGreeting($event)" class="md-raised md-primary" >
	 *       Greet Employee
	 *       </md-button>
	 *   </div>
	 * </div>
	 * </hljs>
	 *
	 * ### JavaScript: object syntax
	 * <hljs lang="js">
	 * (function(angular, undefined){
	 *   "use strict";
	 *
	 *   angular
	 *    .module('demoApp', ['ngMaterial'])
	 *    .controller('AppCtrl', AppController);
	 *
	 *   function AppController($scope, $mdDialog) {
	 *     var alert;
	 *     $scope.showAlert = showAlert;
	 *     $scope.showDialog = showDialog;
	 *     $scope.items = [1, 2, 3];
	 *
	 *     // Internal method
	 *     function showAlert() {
	 *       alert = $mdDialog.alert({
	 *         title: 'Attention',
	 *         textContent: 'This is an example of how easy dialogs can be!',
	 *         ok: 'Close'
	 *       });
	 *
	 *       $mdDialog
	 *         .show( alert )
	 *         .finally(function() {
	 *           alert = undefined;
	 *         });
	 *     }
	 *
	 *     function showDialog($event) {
	 *        var parentEl = angular.element(document.body);
	 *        $mdDialog.show({
	 *          parent: parentEl,
	 *          targetEvent: $event,
	 *          template:
	 *            '<md-dialog aria-label="List dialog">' +
	 *            '  <md-dialog-content>'+
	 *            '    <md-list>'+
	 *            '      <md-list-item ng-repeat="item in items">'+
	 *            '       <p>Number {{item}}</p>' +
	 *            '      </md-item>'+
	 *            '    </md-list>'+
	 *            '  </md-dialog-content>' +
	 *            '  <md-dialog-actions>' +
	 *            '    <md-button ng-click="closeDialog()" class="md-primary">' +
	 *            '      Close Dialog' +
	 *            '    </md-button>' +
	 *            '  </md-dialog-actions>' +
	 *            '</md-dialog>',
	 *          locals: {
	 *            items: $scope.items
	 *          },
	 *          controller: DialogController
	 *       });
	 *       function DialogController($scope, $mdDialog, items) {
	 *         $scope.items = items;
	 *         $scope.closeDialog = function() {
	 *           $mdDialog.hide();
	 *         }
	 *       }
	 *     }
	 *   }
	 * })(angular);
	 * </hljs>
	 *
	 * ### Multiple Dialogs
	 * Using the `multiple` option for the `$mdDialog` service allows developers to show multiple dialogs
	 * at the same time.
	 *
	 * <hljs lang="js">
	 *   // From plain options
	 *   $mdDialog.show({
	 *     multiple: true
	 *   });
	 *
	 *   // From a dialog preset
	 *   $mdDialog.show(
	 *     $mdDialog
	 *       .alert()
	 *       .multiple(true)
	 *   );
	 *
	 * </hljs>
	 *
	 * ### Pre-Rendered Dialogs
	 * By using the `contentElement` option, it is possible to use an already existing element in the DOM.
	 *
	 * > Pre-rendered dialogs will be not linked to any scope and will not instantiate any new controller.<br/>
	 * > You can manually link the elements to a scope or instantiate a controller from the template (`ng-controller`)
	 *
	 * <hljs lang="js">
	 *   $scope.showPrerenderedDialog = function() {
	 *     $mdDialog.show({
	 *       contentElement: '#myStaticDialog',
	 *       parent: angular.element(document.body)
	 *     });
	 *   };
	 * </hljs>
	 *
	 * When using a string as value, `$mdDialog` will automatically query the DOM for the specified CSS selector.
	 *
	 * <hljs lang="html">
	 *   <div style="visibility: hidden">
	 *     <div class="md-dialog-container" id="myStaticDialog">
	 *       <md-dialog>
	 *         This is a pre-rendered dialog.
	 *       </md-dialog>
	 *     </div>
	 *   </div>
	 * </hljs>
	 *
	 * **Notice**: It is important, to use the `.md-dialog-container` as the content element, otherwise the dialog
	 * will not show up.
	 *
	 * It also possible to use a DOM element for the `contentElement` option.
	 * - `contentElement: document.querySelector('#myStaticDialog')`
	 * - `contentElement: angular.element(TEMPLATE)`
	 *
	 * When using a `template` as content element, it will be not compiled upon open.
	 * This allows you to compile the element yourself and use it each time the dialog opens.
	 *
	 * ### Custom Presets
	 * Developers are also able to create their own preset, which can be easily used without repeating
	 * their options each time.
	 *
	 * <hljs lang="js">
	 *   $mdDialogProvider.addPreset('testPreset', {
	 *     options: function() {
	 *       return {
	 *         template:
	 *           '<md-dialog>' +
	 *             'This is a custom preset' +
	 *           '</md-dialog>',
	 *         controllerAs: 'dialog',
	 *         bindToController: true,
	 *         clickOutsideToClose: true,
	 *         escapeToClose: true
	 *       };
	 *     }
	 *   });
	 * </hljs>
	 *
	 * After you created your preset at config phase, you can easily access it.
	 *
	 * <hljs lang="js">
	 *   $mdDialog.show(
	 *     $mdDialog.testPreset()
	 *   );
	 * </hljs>
	 *
	 * ### JavaScript: promise API syntax, custom dialog template
	 * <hljs lang="js">
	 * (function(angular, undefined){
	 *   "use strict";
	 *
	 *   angular
	 *     .module('demoApp', ['ngMaterial'])
	 *     .controller('EmployeeController', EmployeeEditor)
	 *     .controller('GreetingController', GreetingController);
	 *
	 *   // Fictitious Employee Editor to show how to use simple and complex dialogs.
	 *
	 *   function EmployeeEditor($scope, $mdDialog) {
	 *     var alert;
	 *
	 *     $scope.showAlert = showAlert;
	 *     $scope.closeAlert = closeAlert;
	 *     $scope.showGreeting = showCustomGreeting;
	 *
	 *     $scope.hasAlert = function() { return !!alert };
	 *     $scope.userName = $scope.userName || 'Bobby';
	 *
	 *     // Dialog #1 - Show simple alert dialog and cache
	 *     // reference to dialog instance
	 *
	 *     function showAlert() {
	 *       alert = $mdDialog.alert()
	 *         .title('Attention, ' + $scope.userName)
	 *         .textContent('This is an example of how easy dialogs can be!')
	 *         .ok('Close');
	 *
	 *       $mdDialog
	 *           .show( alert )
	 *           .finally(function() {
	 *             alert = undefined;
	 *           });
	 *     }
	 *
	 *     // Close the specified dialog instance and resolve with 'finished' flag
	 *     // Normally this is not needed, just use '$mdDialog.hide()' to close
	 *     // the most recent dialog popup.
	 *
	 *     function closeAlert() {
	 *       $mdDialog.hide( alert, "finished" );
	 *       alert = undefined;
	 *     }
	 *
	 *     // Dialog #2 - Demonstrate more complex dialogs construction and popup.
	 *
	 *     function showCustomGreeting($event) {
	 *         $mdDialog.show({
	 *           targetEvent: $event,
	 *           template:
	 *             '<md-dialog>' +
	 *
	 *             '  <md-dialog-content>Hello {{ employee }}!</md-dialog-content>' +
	 *
	 *             '  <md-dialog-actions>' +
	 *             '    <md-button ng-click="closeDialog()" class="md-primary">' +
	 *             '      Close Greeting' +
	 *             '    </md-button>' +
	 *             '  </md-dialog-actions>' +
	 *             '</md-dialog>',
	 *           controller: 'GreetingController',
	 *           onComplete: afterShowAnimation,
	 *           locals: { employee: $scope.userName }
	 *         });
	 *
	 *         // When the 'enter' animation finishes...
	 *
	 *         function afterShowAnimation(scope, element, options) {
	 *            // post-show code here: DOM element focus, etc.
	 *         }
	 *     }
	 *
	 *     // Dialog #3 - Demonstrate use of ControllerAs and passing $scope to dialog
	 *     //             Here we used ng-controller="GreetingController as vm" and
	 *     //             $scope.vm === <controller instance>
	 *
	 *     function showCustomGreeting() {
	 *
	 *        $mdDialog.show({
	 *           clickOutsideToClose: true,
	 *
	 *           scope: $scope,        // use parent scope in template
	 *           preserveScope: true,  // do not forget this if use parent scope
	
	 *           // Since GreetingController is instantiated with ControllerAs syntax
	 *           // AND we are passing the parent '$scope' to the dialog, we MUST
	 *           // use 'vm.<xxx>' in the template markup
	 *
	 *           template: '<md-dialog>' +
	 *                     '  <md-dialog-content>' +
	 *                     '     Hi There {{vm.employee}}' +
	 *                     '  </md-dialog-content>' +
	 *                     '</md-dialog>',
	 *
	 *           controller: function DialogController($scope, $mdDialog) {
	 *             $scope.closeDialog = function() {
	 *               $mdDialog.hide();
	 *             }
	 *           }
	 *        });
	 *     }
	 *
	 *   }
	 *
	 *   // Greeting controller used with the more complex 'showCustomGreeting()' custom dialog
	 *
	 *   function GreetingController($scope, $mdDialog, employee) {
	 *     // Assigned from construction <code>locals</code> options...
	 *     $scope.employee = employee;
	 *
	 *     $scope.closeDialog = function() {
	 *       // Easily hides most recent dialog shown...
	 *       // no specific instance reference is needed.
	 *       $mdDialog.hide();
	 *     };
	 *   }
	 *
	 * })(angular);
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdDialog#alert
	 *
	 * @description
	 * Builds a preconfigured dialog with the specified message.
	 *
	 * @returns {obj} an `$mdDialogPreset` with the chainable configuration methods:
	 *
	 * - $mdDialogPreset#title(string) - Sets the alert title.
	 * - $mdDialogPreset#textContent(string) - Sets the alert message.
	 * - $mdDialogPreset#htmlContent(string) - Sets the alert message as HTML. Requires ngSanitize
	 *     module to be loaded. HTML is not run through Angular's compiler.
	 * - $mdDialogPreset#ok(string) - Sets the alert "Okay" button text.
	 * - $mdDialogPreset#theme(string) - Sets the theme of the alert dialog.
	 * - $mdDialogPreset#targetEvent(DOMClickEvent=) - A click's event object. When passed in as an option,
	 *     the location of the click will be used as the starting point for the opening animation
	 *     of the the dialog.
	 *
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdDialog#confirm
	 *
	 * @description
	 * Builds a preconfigured dialog with the specified message. You can call show and the promise returned
	 * will be resolved only if the user clicks the confirm action on the dialog.
	 *
	 * @returns {obj} an `$mdDialogPreset` with the chainable configuration methods:
	 *
	 * Additionally, it supports the following methods:
	 *
	 * - $mdDialogPreset#title(string) - Sets the confirm title.
	 * - $mdDialogPreset#textContent(string) - Sets the confirm message.
	 * - $mdDialogPreset#htmlContent(string) - Sets the confirm message as HTML. Requires ngSanitize
	 *     module to be loaded. HTML is not run through Angular's compiler.
	 * - $mdDialogPreset#ok(string) - Sets the confirm "Okay" button text.
	 * - $mdDialogPreset#cancel(string) - Sets the confirm "Cancel" button text.
	 * - $mdDialogPreset#theme(string) - Sets the theme of the confirm dialog.
	 * - $mdDialogPreset#targetEvent(DOMClickEvent=) - A click's event object. When passed in as an option,
	 *     the location of the click will be used as the starting point for the opening animation
	 *     of the the dialog.
	 *
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdDialog#prompt
	 *
	 * @description
	 * Builds a preconfigured dialog with the specified message and input box. You can call show and the promise returned
	 * will be resolved only if the user clicks the prompt action on the dialog, passing the input value as the first argument.
	 *
	 * @returns {obj} an `$mdDialogPreset` with the chainable configuration methods:
	 *
	 * Additionally, it supports the following methods:
	 *
	 * - $mdDialogPreset#title(string) - Sets the prompt title.
	 * - $mdDialogPreset#textContent(string) - Sets the prompt message.
	 * - $mdDialogPreset#htmlContent(string) - Sets the prompt message as HTML. Requires ngSanitize
	 *     module to be loaded. HTML is not run through Angular's compiler.
	 * - $mdDialogPreset#placeholder(string) - Sets the placeholder text for the input.
	 * - $mdDialogPreset#initialValue(string) - Sets the initial value for the prompt input.
	 * - $mdDialogPreset#ok(string) - Sets the prompt "Okay" button text.
	 * - $mdDialogPreset#cancel(string) - Sets the prompt "Cancel" button text.
	 * - $mdDialogPreset#theme(string) - Sets the theme of the prompt dialog.
	 * - $mdDialogPreset#targetEvent(DOMClickEvent=) - A click's event object. When passed in as an option,
	 *     the location of the click will be used as the starting point for the opening animation
	 *     of the the dialog.
	 *
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdDialog#show
	 *
	 * @description
	 * Show a dialog with the specified options.
	 *
	 * @param {object} optionsOrPreset Either provide an `$mdDialogPreset` returned from `alert()`, and
	 * `confirm()`, or an options object with the following properties:
	 *   - `templateUrl` - `{string=}`: The url of a template that will be used as the content
	 *   of the dialog.
	 *   - `template` - `{string=}`: HTML template to show in the dialog. This **must** be trusted HTML
	 *      with respect to Angular's [$sce service](https://docs.angularjs.org/api/ng/service/$sce).
	 *      This template should **never** be constructed with any kind of user input or user data.
	 *   - `contentElement` - `{string|Element}`: Instead of using a template, which will be compiled each time a
	 *     dialog opens, you can also use a DOM element.<br/>
	 *     * When specifying an element, which is present on the DOM, `$mdDialog` will temporary fetch the element into
	 *       the dialog and restores it at the old DOM position upon close.
	 *     * When specifying a string, the string be used as a CSS selector, to lookup for the element in the DOM.
	 *   - `autoWrap` - `{boolean=}`: Whether or not to automatically wrap the template with a
	 *     `<md-dialog>` tag if one is not provided. Defaults to true. Can be disabled if you provide a
	 *     custom dialog directive.
	 *   - `targetEvent` - `{DOMClickEvent=}`: A click's event object. When passed in as an option,
	 *     the location of the click will be used as the starting point for the opening animation
	 *     of the the dialog.
	 *   - `openFrom` - `{string|Element|object}`: The query selector, DOM element or the Rect object
	 *     that is used to determine the bounds (top, left, height, width) from which the Dialog will
	 *     originate.
	 *   - `closeTo` - `{string|Element|object}`: The query selector, DOM element or the Rect object
	 *     that is used to determine the bounds (top, left, height, width) to which the Dialog will
	 *     target.
	 *   - `scope` - `{object=}`: the scope to link the template / controller to. If none is specified,
	 *     it will create a new isolate scope.
	 *     This scope will be destroyed when the dialog is removed unless `preserveScope` is set to true.
	 *   - `preserveScope` - `{boolean=}`: whether to preserve the scope when the element is removed. Default is false
	 *   - `disableParentScroll` - `{boolean=}`: Whether to disable scrolling while the dialog is open.
	 *     Default true.
	 *   - `hasBackdrop` - `{boolean=}`: Whether there should be an opaque backdrop behind the dialog.
	 *     Default true.
	 *   - `clickOutsideToClose` - `{boolean=}`: Whether the user can click outside the dialog to
	 *     close it. Default false.
	 *   - `escapeToClose` - `{boolean=}`: Whether the user can press escape to close the dialog.
	 *     Default true.
	 *   - `focusOnOpen` - `{boolean=}`: An option to override focus behavior on open. Only disable if
	 *     focusing some other way, as focus management is required for dialogs to be accessible.
	 *     Defaults to true.
	 *   - `controller` - `{function|string=}`: The controller to associate with the dialog. The controller
	 *     will be injected with the local `$mdDialog`, which passes along a scope for the dialog.
	 *   - `locals` - `{object=}`: An object containing key/value pairs. The keys will be used as names
	 *     of values to inject into the controller. For example, `locals: {three: 3}` would inject
	 *     `three` into the controller, with the value 3. If `bindToController` is true, they will be
	 *     copied to the controller instead.
	 *   - `bindToController` - `bool`: bind the locals to the controller, instead of passing them in.
	 *   - `resolve` - `{object=}`: Similar to locals, except it takes promises as values, and the
	 *     dialog will not open until all of the promises resolve.
	 *   - `controllerAs` - `{string=}`: An alias to assign the controller to on the scope.
	 *   - `parent` - `{element=}`: The element to append the dialog to. Defaults to appending
	 *     to the root element of the application.
	 *   - `onShowing` - `function(scope, element)`: Callback function used to announce the show() action is
	 *     starting.
	 *   - `onComplete` - `function(scope, element)`: Callback function used to announce when the show() action is
	 *     finished.
	 *   - `onRemoving` - `function(element, removePromise)`: Callback function used to announce the
	 *      close/hide() action is starting. This allows developers to run custom animations
	 *      in parallel the close animations.
	 *   - `fullscreen` `{boolean=}`: An option to toggle whether the dialog should show in fullscreen
	 *      or not. Defaults to `false`.
	 *   - `multiple` `{boolean=}`: An option to allow this dialog to display over one that's currently open.
	 * @returns {promise} A promise that can be resolved with `$mdDialog.hide()` or
	 * rejected with `$mdDialog.cancel()`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdDialog#hide
	 *
	 * @description
	 * Hide an existing dialog and resolve the promise returned from `$mdDialog.show()`.
	 *
	 * @param {*=} response An argument for the resolved promise.
	 *
	 * @returns {promise} A promise that is resolved when the dialog has been closed.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdDialog#cancel
	 *
	 * @description
	 * Hide an existing dialog and reject the promise returned from `$mdDialog.show()`.
	 *
	 * @param {*=} response An argument for the rejected promise.
	 *
	 * @returns {promise} A promise that is resolved when the dialog has been closed.
	 */
	
	function MdDialogProvider($$interimElementProvider) {
	  // Elements to capture and redirect focus when the user presses tab at the dialog boundary.
	  advancedDialogOptions.$inject = ["$mdDialog", "$mdConstant"];
	  dialogDefaultOptions.$inject = ["$mdDialog", "$mdAria", "$mdUtil", "$mdConstant", "$animate", "$document", "$window", "$rootElement", "$log", "$injector", "$mdTheming", "$interpolate", "$mdInteraction"];
	  var topFocusTrap, bottomFocusTrap;
	
	  return $$interimElementProvider('$mdDialog')
	    .setDefaults({
	      methods: ['disableParentScroll', 'hasBackdrop', 'clickOutsideToClose', 'escapeToClose',
	          'targetEvent', 'closeTo', 'openFrom', 'parent', 'fullscreen', 'multiple'],
	      options: dialogDefaultOptions
	    })
	    .addPreset('alert', {
	      methods: ['title', 'htmlContent', 'textContent', 'content', 'ariaLabel', 'ok', 'theme',
	          'css'],
	      options: advancedDialogOptions
	    })
	    .addPreset('confirm', {
	      methods: ['title', 'htmlContent', 'textContent', 'content', 'ariaLabel', 'ok', 'cancel',
	          'theme', 'css'],
	      options: advancedDialogOptions
	    })
	    .addPreset('prompt', {
	      methods: ['title', 'htmlContent', 'textContent', 'initialValue', 'content', 'placeholder', 'ariaLabel',
	          'ok', 'cancel', 'theme', 'css'],
	      options: advancedDialogOptions
	    });
	
	  /* @ngInject */
	  function advancedDialogOptions($mdDialog, $mdConstant) {
	    return {
	      template: [
	        '<md-dialog md-theme="{{ dialog.theme || dialog.defaultTheme }}" aria-label="{{ dialog.ariaLabel }}" ng-class="dialog.css">',
	        '  <md-dialog-content class="md-dialog-content" role="document" tabIndex="-1">',
	        '    <h2 class="md-title">{{ dialog.title }}</h2>',
	        '    <div ng-if="::dialog.mdHtmlContent" class="md-dialog-content-body" ',
	        '        ng-bind-html="::dialog.mdHtmlContent"></div>',
	        '    <div ng-if="::!dialog.mdHtmlContent" class="md-dialog-content-body">',
	        '      <p>{{::dialog.mdTextContent}}</p>',
	        '    </div>',
	        '    <md-input-container md-no-float ng-if="::dialog.$type == \'prompt\'" class="md-prompt-input-container">',
	        '      <input ng-keypress="dialog.keypress($event)" md-autofocus ng-model="dialog.result" ' +
	        '             placeholder="{{::dialog.placeholder}}">',
	        '    </md-input-container>',
	        '  </md-dialog-content>',
	        '  <md-dialog-actions>',
	        '    <md-button ng-if="dialog.$type === \'confirm\' || dialog.$type === \'prompt\'"' +
	        '               ng-click="dialog.abort()" class="md-primary md-cancel-button">',
	        '      {{ dialog.cancel }}',
	        '    </md-button>',
	        '    <md-button ng-click="dialog.hide()" class="md-primary md-confirm-button" md-autofocus="dialog.$type===\'alert\'">',
	        '      {{ dialog.ok }}',
	        '    </md-button>',
	        '  </md-dialog-actions>',
	        '</md-dialog>'
	      ].join('').replace(/\s\s+/g, ''),
	      controller: function mdDialogCtrl() {
	        var isPrompt = this.$type == 'prompt';
	
	        if (isPrompt && this.initialValue) {
	          this.result = this.initialValue;
	        }
	
	        this.hide = function() {
	          $mdDialog.hide(isPrompt ? this.result : true);
	        };
	        this.abort = function() {
	          $mdDialog.cancel();
	        };
	        this.keypress = function($event) {
	          if ($event.keyCode === $mdConstant.KEY_CODE.ENTER) {
	            $mdDialog.hide(this.result);
	          }
	        };
	      },
	      controllerAs: 'dialog',
	      bindToController: true,
	    };
	  }
	
	  /* @ngInject */
	  function dialogDefaultOptions($mdDialog, $mdAria, $mdUtil, $mdConstant, $animate, $document, $window, $rootElement,
	                                $log, $injector, $mdTheming, $interpolate, $mdInteraction) {
	
	    return {
	      hasBackdrop: true,
	      isolateScope: true,
	      onCompiling: beforeCompile,
	      onShow: onShow,
	      onShowing: beforeShow,
	      onRemove: onRemove,
	      clickOutsideToClose: false,
	      escapeToClose: true,
	      targetEvent: null,
	      closeTo: null,
	      openFrom: null,
	      focusOnOpen: true,
	      disableParentScroll: true,
	      autoWrap: true,
	      fullscreen: false,
	      transformTemplate: function(template, options) {
	        // Make the dialog container focusable, because otherwise the focus will be always redirected to
	        // an element outside of the container, and the focus trap won't work probably..
	        // Also the tabindex is needed for the `escapeToClose` functionality, because
	        // the keyDown event can't be triggered when the focus is outside of the container.
	        var startSymbol = $interpolate.startSymbol();
	        var endSymbol = $interpolate.endSymbol();
	        var theme = startSymbol + (options.themeWatch ? '' : '::') + 'theme' + endSymbol;
	        return '<div class="md-dialog-container" tabindex="-1" md-theme="' + theme + '">' + validatedTemplate(template) + '</div>';
	
	        /**
	         * The specified template should contain a <md-dialog> wrapper element....
	         */
	        function validatedTemplate(template) {
	          if (options.autoWrap && !/<\/md-dialog>/g.test(template)) {
	            return '<md-dialog>' + (template || '') + '</md-dialog>';
	          } else {
	            return template || '';
	          }
	        }
	      }
	    };
	
	    function beforeCompile(options) {
	      // Automatically apply the theme, if the user didn't specify a theme explicitly.
	      // Those option changes need to be done, before the compilation has started, because otherwise
	      // the option changes will be not available in the $mdCompilers locales.
	      options.defaultTheme = $mdTheming.defaultTheme();
	
	      detectTheming(options);
	    }
	
	    function beforeShow(scope, element, options, controller) {
	
	      if (controller) {
	        var mdHtmlContent = controller.htmlContent || options.htmlContent || '';
	        var mdTextContent = controller.textContent || options.textContent ||
	            controller.content || options.content || '';
	
	        if (mdHtmlContent && !$injector.has('$sanitize')) {
	          throw Error('The ngSanitize module must be loaded in order to use htmlContent.');
	        }
	
	        if (mdHtmlContent && mdTextContent) {
	          throw Error('md-dialog cannot have both `htmlContent` and `textContent`');
	        }
	
	        // Only assign the content if nothing throws, otherwise it'll still be compiled.
	        controller.mdHtmlContent = mdHtmlContent;
	        controller.mdTextContent = mdTextContent;
	      }
	    }
	
	    /** Show method for dialogs */
	    function onShow(scope, element, options, controller) {
	      angular.element($document[0].body).addClass('md-dialog-is-showing');
	
	      var dialogElement = element.find('md-dialog');
	
	      // Once a dialog has `ng-cloak` applied on his template the dialog animation will not work properly.
	      // This is a very common problem, so we have to notify the developer about this.
	      if (dialogElement.hasClass('ng-cloak')) {
	        var message = '$mdDialog: using `<md-dialog ng-cloak>` will affect the dialog opening animations.';
	        $log.warn( message, element[0] );
	      }
	
	      captureParentAndFromToElements(options);
	      configureAria(dialogElement, options);
	      showBackdrop(scope, element, options);
	      activateListeners(element, options);
	
	      return dialogPopIn(element, options)
	        .then(function() {
	          lockScreenReader(element, options);
	          warnDeprecatedActions();
	          focusOnOpen();
	        });
	
	      /**
	       * Check to see if they used the deprecated .md-actions class and log a warning
	       */
	      function warnDeprecatedActions() {
	        if (element[0].querySelector('.md-actions')) {
	          $log.warn('Using a class of md-actions is deprecated, please use <md-dialog-actions>.');
	        }
	      }
	
	      /**
	       * For alerts, focus on content... otherwise focus on
	       * the close button (or equivalent)
	       */
	      function focusOnOpen() {
	        if (options.focusOnOpen) {
	          var target = $mdUtil.findFocusTarget(element) || findCloseButton() || dialogElement;
	          target.focus();
	        }
	
	        /**
	         * If no element with class dialog-close, try to find the last
	         * button child in md-actions and assume it is a close button.
	         *
	         * If we find no actions at all, log a warning to the console.
	         */
	        function findCloseButton() {
	          return element[0].querySelector('.dialog-close, md-dialog-actions button:last-child');
	        }
	      }
	    }
	
	    /**
	     * Remove function for all dialogs
	     */
	    function onRemove(scope, element, options) {
	      options.deactivateListeners();
	      options.unlockScreenReader();
	      options.hideBackdrop(options.$destroy);
	
	      // Remove the focus traps that we added earlier for keeping focus within the dialog.
	      if (topFocusTrap && topFocusTrap.parentNode) {
	        topFocusTrap.parentNode.removeChild(topFocusTrap);
	      }
	
	      if (bottomFocusTrap && bottomFocusTrap.parentNode) {
	        bottomFocusTrap.parentNode.removeChild(bottomFocusTrap);
	      }
	
	      // For navigation $destroy events, do a quick, non-animated removal,
	      // but for normal closes (from clicks, etc) animate the removal
	      return !!options.$destroy ? detachAndClean() : animateRemoval().then( detachAndClean );
	
	      /**
	       * For normal closes, animate the removal.
	       * For forced closes (like $destroy events), skip the animations
	       */
	      function animateRemoval() {
	        return dialogPopOut(element, options);
	      }
	
	      /**
	       * Detach the element
	       */
	      function detachAndClean() {
	        angular.element($document[0].body).removeClass('md-dialog-is-showing');
	
	        // Reverse the container stretch if using a content element.
	        if (options.contentElement) {
	          options.reverseContainerStretch();
	        }
	
	        // Exposed cleanup function from the $mdCompiler.
	        options.cleanupElement();
	
	        // Restores the focus to the origin element if the last interaction upon opening was a keyboard.
	        if (!options.$destroy && options.originInteraction === 'keyboard') {
	          options.origin.focus();
	        }
	      }
	    }
	
	    function detectTheming(options) {
	      // Once the user specifies a targetEvent, we will automatically try to find the correct
	      // nested theme.
	      var targetEl;
	      if (options.targetEvent && options.targetEvent.target) {
	        targetEl = angular.element(options.targetEvent.target);
	      }
	
	      var themeCtrl = targetEl && targetEl.controller('mdTheme');
	
	      if (!themeCtrl) {
	        return;
	      }
	
	      options.themeWatch = themeCtrl.$shouldWatch;
	
	      var theme = options.theme || themeCtrl.$mdTheme;
	
	      if (theme) {
	        options.scope.theme = theme;
	      }
	
	      var unwatch = themeCtrl.registerChanges(function (newTheme) {
	        options.scope.theme = newTheme;
	
	        if (!options.themeWatch) {
	          unwatch();
	        }
	      });
	    }
	
	    /**
	     * Capture originator/trigger/from/to element information (if available)
	     * and the parent container for the dialog; defaults to the $rootElement
	     * unless overridden in the options.parent
	     */
	    function captureParentAndFromToElements(options) {
	          options.origin = angular.extend({
	            element: null,
	            bounds: null,
	            focus: angular.noop
	          }, options.origin || {});
	
	          options.parent   = getDomElement(options.parent, $rootElement);
	          options.closeTo  = getBoundingClientRect(getDomElement(options.closeTo));
	          options.openFrom = getBoundingClientRect(getDomElement(options.openFrom));
	
	          if ( options.targetEvent ) {
	            options.origin = getBoundingClientRect(options.targetEvent.target, options.origin);
	            options.originInteraction = $mdInteraction.getLastInteractionType();
	          }
	
	
	          /**
	           * Identify the bounding RECT for the target element
	           *
	           */
	          function getBoundingClientRect (element, orig) {
	            var source = angular.element((element || {}));
	            if (source && source.length) {
	              // Compute and save the target element's bounding rect, so that if the
	              // element is hidden when the dialog closes, we can shrink the dialog
	              // back to the same position it expanded from.
	              //
	              // Checking if the source is a rect object or a DOM element
	              var bounds = {top:0,left:0,height:0,width:0};
	              var hasFn = angular.isFunction(source[0].getBoundingClientRect);
	
	              return angular.extend(orig || {}, {
	                  element : hasFn ? source : undefined,
	                  bounds  : hasFn ? source[0].getBoundingClientRect() : angular.extend({}, bounds, source[0]),
	                  focus   : angular.bind(source, source.focus),
	              });
	            }
	          }
	
	          /**
	           * If the specifier is a simple string selector, then query for
	           * the DOM element.
	           */
	          function getDomElement(element, defaultElement) {
	            if (angular.isString(element)) {
	              element = $document[0].querySelector(element);
	            }
	
	            // If we have a reference to a raw dom element, always wrap it in jqLite
	            return angular.element(element || defaultElement);
	          }
	
	        }
	
	    /**
	     * Listen for escape keys and outside clicks to auto close
	     */
	    function activateListeners(element, options) {
	      var window = angular.element($window);
	      var onWindowResize = $mdUtil.debounce(function() {
	        stretchDialogContainerToViewport(element, options);
	      }, 60);
	
	      var removeListeners = [];
	      var smartClose = function() {
	        // Only 'confirm' dialogs have a cancel button... escape/clickOutside will
	        // cancel or fallback to hide.
	        var closeFn = ( options.$type == 'alert' ) ? $mdDialog.hide : $mdDialog.cancel;
	        $mdUtil.nextTick(closeFn, true);
	      };
	
	      if (options.escapeToClose) {
	        var parentTarget = options.parent;
	        var keyHandlerFn = function(ev) {
	          if (ev.keyCode === $mdConstant.KEY_CODE.ESCAPE) {
	            ev.stopPropagation();
	            ev.preventDefault();
	
	            smartClose();
	          }
	        };
	
	        // Add keydown listeners
	        element.on('keydown', keyHandlerFn);
	        parentTarget.on('keydown', keyHandlerFn);
	
	        // Queue remove listeners function
	        removeListeners.push(function() {
	
	          element.off('keydown', keyHandlerFn);
	          parentTarget.off('keydown', keyHandlerFn);
	
	        });
	      }
	
	      // Register listener to update dialog on window resize
	      window.on('resize', onWindowResize);
	
	      removeListeners.push(function() {
	        window.off('resize', onWindowResize);
	      });
	
	      if (options.clickOutsideToClose) {
	        var target = element;
	        var sourceElem;
	
	        // Keep track of the element on which the mouse originally went down
	        // so that we can only close the backdrop when the 'click' started on it.
	        // A simple 'click' handler does not work,
	        // it sets the target object as the element the mouse went down on.
	        var mousedownHandler = function(ev) {
	          sourceElem = ev.target;
	        };
	
	        // We check if our original element and the target is the backdrop
	        // because if the original was the backdrop and the target was inside the dialog
	        // we don't want to dialog to close.
	        var mouseupHandler = function(ev) {
	          if (sourceElem === target[0] && ev.target === target[0]) {
	            ev.stopPropagation();
	            ev.preventDefault();
	
	            smartClose();
	          }
	        };
	
	        // Add listeners
	        target.on('mousedown', mousedownHandler);
	        target.on('mouseup', mouseupHandler);
	
	        // Queue remove listeners function
	        removeListeners.push(function() {
	          target.off('mousedown', mousedownHandler);
	          target.off('mouseup', mouseupHandler);
	        });
	      }
	
	      // Attach specific `remove` listener handler
	      options.deactivateListeners = function() {
	        removeListeners.forEach(function(removeFn) {
	          removeFn();
	        });
	        options.deactivateListeners = null;
	      };
	    }
	
	    /**
	     * Show modal backdrop element...
	     */
	    function showBackdrop(scope, element, options) {
	
	      if (options.disableParentScroll) {
	        // !! DO this before creating the backdrop; since disableScrollAround()
	        //    configures the scroll offset; which is used by mdBackDrop postLink()
	        options.restoreScroll = $mdUtil.disableScrollAround(element, options.parent);
	      }
	
	      if (options.hasBackdrop) {
	        options.backdrop = $mdUtil.createBackdrop(scope, "md-dialog-backdrop md-opaque");
	        $animate.enter(options.backdrop, options.parent);
	      }
	
	      /**
	       * Hide modal backdrop element...
	       */
	      options.hideBackdrop = function hideBackdrop($destroy) {
	        if (options.backdrop) {
	          if ( !!$destroy ) options.backdrop.remove();
	          else              $animate.leave(options.backdrop);
	        }
	
	
	        if (options.disableParentScroll) {
	          options.restoreScroll && options.restoreScroll();
	          delete options.restoreScroll;
	        }
	
	        options.hideBackdrop = null;
	      };
	    }
	
	    /**
	     * Inject ARIA-specific attributes appropriate for Dialogs
	     */
	    function configureAria(element, options) {
	
	      var role = (options.$type === 'alert') ? 'alertdialog' : 'dialog';
	      var dialogContent = element.find('md-dialog-content');
	      var existingDialogId = element.attr('id');
	      var dialogContentId = 'dialogContent_' + (existingDialogId || $mdUtil.nextUid());
	
	      element.attr({
	        'role': role,
	        'tabIndex': '-1'
	      });
	
	      if (dialogContent.length === 0) {
	        dialogContent = element;
	        // If the dialog element already had an ID, don't clobber it.
	        if (existingDialogId) {
	          dialogContentId = existingDialogId;
	        }
	      }
	
	      dialogContent.attr('id', dialogContentId);
	      element.attr('aria-describedby', dialogContentId);
	
	      if (options.ariaLabel) {
	        $mdAria.expect(element, 'aria-label', options.ariaLabel);
	      }
	      else {
	        $mdAria.expectAsync(element, 'aria-label', function() {
	          var words = dialogContent.text().split(/\s+/);
	          if (words.length > 3) words = words.slice(0, 3).concat('...');
	          return words.join(' ');
	        });
	      }
	
	      // Set up elements before and after the dialog content to capture focus and
	      // redirect back into the dialog.
	      topFocusTrap = document.createElement('div');
	      topFocusTrap.classList.add('md-dialog-focus-trap');
	      topFocusTrap.tabIndex = 0;
	
	      bottomFocusTrap = topFocusTrap.cloneNode(false);
	
	      // When focus is about to move out of the dialog, we want to intercept it and redirect it
	      // back to the dialog element.
	      var focusHandler = function() {
	        element.focus();
	      };
	      topFocusTrap.addEventListener('focus', focusHandler);
	      bottomFocusTrap.addEventListener('focus', focusHandler);
	
	      // The top focus trap inserted immeidately before the md-dialog element (as a sibling).
	      // The bottom focus trap is inserted at the very end of the md-dialog element (as a child).
	      element[0].parentNode.insertBefore(topFocusTrap, element[0]);
	      element.after(bottomFocusTrap);
	    }
	
	    /**
	     * Prevents screen reader interaction behind modal window
	     * on swipe interfaces
	     */
	    function lockScreenReader(element, options) {
	      var isHidden = true;
	
	      // get raw DOM node
	      walkDOM(element[0]);
	
	      options.unlockScreenReader = function() {
	        isHidden = false;
	        walkDOM(element[0]);
	
	        options.unlockScreenReader = null;
	      };
	
	      /**
	       * Walk DOM to apply or remove aria-hidden on sibling nodes
	       * and parent sibling nodes
	       *
	       */
	      function walkDOM(element) {
	        while (element.parentNode) {
	          if (element === document.body) {
	            return;
	          }
	          var children = element.parentNode.children;
	          for (var i = 0; i < children.length; i++) {
	            // skip over child if it is an ascendant of the dialog
	            // or a script or style tag
	            if (element !== children[i] && !isNodeOneOf(children[i], ['SCRIPT', 'STYLE'])) {
	              children[i].setAttribute('aria-hidden', isHidden);
	            }
	          }
	
	          walkDOM(element = element.parentNode);
	        }
	      }
	    }
	
	    /**
	     * Ensure the dialog container fill-stretches to the viewport
	     */
	    function stretchDialogContainerToViewport(container, options) {
	      var isFixed = $window.getComputedStyle($document[0].body).position == 'fixed';
	      var backdrop = options.backdrop ? $window.getComputedStyle(options.backdrop[0]) : null;
	      var height = backdrop ? Math.min($document[0].body.clientHeight, Math.ceil(Math.abs(parseInt(backdrop.height, 10)))) : 0;
	
	      var previousStyles = {
	        top: container.css('top'),
	        height: container.css('height')
	      };
	
	      // If the body is fixed, determine the distance to the viewport in relative from the parent.
	      var parentTop = Math.abs(options.parent[0].getBoundingClientRect().top);
	
	      container.css({
	        top: (isFixed ? parentTop : 0) + 'px',
	        height: height ? height + 'px' : '100%'
	      });
	
	      return function() {
	        // Reverts the modified styles back to the previous values.
	        // This is needed for contentElements, which should have the same styles after close
	        // as before.
	        container.css(previousStyles);
	      };
	    }
	
	    /**
	     *  Dialog open and pop-in animation
	     */
	    function dialogPopIn(container, options) {
	      // Add the `md-dialog-container` to the DOM
	      options.parent.append(container);
	      options.reverseContainerStretch = stretchDialogContainerToViewport(container, options);
	
	      var dialogEl = container.find('md-dialog');
	      var animator = $mdUtil.dom.animator;
	      var buildTranslateToOrigin = animator.calculateZoomToOrigin;
	      var translateOptions = {transitionInClass: 'md-transition-in', transitionOutClass: 'md-transition-out'};
	      var from = animator.toTransformCss(buildTranslateToOrigin(dialogEl, options.openFrom || options.origin));
	      var to = animator.toTransformCss("");  // defaults to center display (or parent or $rootElement)
	
	      dialogEl.toggleClass('md-dialog-fullscreen', !!options.fullscreen);
	
	      return animator
	        .translate3d(dialogEl, from, to, translateOptions)
	        .then(function(animateReversal) {
	
	          // Build a reversal translate function synced to this translation...
	          options.reverseAnimate = function() {
	            delete options.reverseAnimate;
	
	            if (options.closeTo) {
	              // Using the opposite classes to create a close animation to the closeTo element
	              translateOptions = {transitionInClass: 'md-transition-out', transitionOutClass: 'md-transition-in'};
	              from = to;
	              to = animator.toTransformCss(buildTranslateToOrigin(dialogEl, options.closeTo));
	
	              return animator
	                .translate3d(dialogEl, from, to,translateOptions);
	            }
	
	            return animateReversal(
	              to = animator.toTransformCss(
	                // in case the origin element has moved or is hidden,
	                // let's recalculate the translateCSS
	                buildTranslateToOrigin(dialogEl, options.origin)
	              )
	            );
	
	          };
	
	          // Function to revert the generated animation styles on the dialog element.
	          // Useful when using a contentElement instead of a template.
	          options.clearAnimate = function() {
	            delete options.clearAnimate;
	
	            // Remove the transition classes, added from $animateCSS, since those can't be removed
	            // by reversely running the animator.
	            dialogEl.removeClass([
	              translateOptions.transitionOutClass,
	              translateOptions.transitionInClass
	            ].join(' '));
	
	            // Run the animation reversely to remove the previous added animation styles.
	            return animator.translate3d(dialogEl, to, animator.toTransformCss(''), {});
	          };
	
	          return true;
	        });
	    }
	
	    /**
	     * Dialog close and pop-out animation
	     */
	    function dialogPopOut(container, options) {
	      return options.reverseAnimate().then(function() {
	        if (options.contentElement) {
	          // When we use a contentElement, we want the element to be the same as before.
	          // That means, that we have to clear all the animation properties, like transform.
	          options.clearAnimate();
	        }
	      });
	    }
	
	    /**
	     * Utility function to filter out raw DOM nodes
	     */
	    function isNodeOneOf(elem, nodeTypeArray) {
	      if (nodeTypeArray.indexOf(elem.nodeName) !== -1) {
	        return true;
	      }
	    }
	
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.divider
	 * @description Divider module!
	 */
	MdDividerDirective.$inject = ["$mdTheming"];
	angular.module('material.components.divider', [
	  'material.core'
	])
	  .directive('mdDivider', MdDividerDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdDivider
	 * @module material.components.divider
	 * @restrict E
	 *
	 * @description
	 * Dividers group and separate content within lists and page layouts using strong visual and spatial distinctions. This divider is a thin rule, lightweight enough to not distract the user from content.
	 *
	 * @param {boolean=} md-inset Add this attribute to activate the inset divider style.
	 * @usage
	 * <hljs lang="html">
	 * <md-divider></md-divider>
	 *
	 * <md-divider md-inset></md-divider>
	 * </hljs>
	 *
	 */
	function MdDividerDirective($mdTheming) {
	  return {
	    restrict: 'E',
	    link: $mdTheming
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc module
	   * @name material.components.fabActions
	   */
	  MdFabActionsDirective.$inject = ["$mdUtil"];
	  angular
	    .module('material.components.fabActions', ['material.core'])
	    .directive('mdFabActions', MdFabActionsDirective);
	
	  /**
	   * @ngdoc directive
	   * @name mdFabActions
	   * @module material.components.fabActions
	   *
	   * @restrict E
	   *
	   * @description
	   * The `<md-fab-actions>` directive is used inside of a `<md-fab-speed-dial>` or
	   * `<md-fab-toolbar>` directive to mark an element (or elements) as the actions and setup the
	   * proper event listeners.
	   *
	   * @usage
	   * See the `<md-fab-speed-dial>` or `<md-fab-toolbar>` directives for example usage.
	   */
	  function MdFabActionsDirective($mdUtil) {
	    return {
	      restrict: 'E',
	
	      require: ['^?mdFabSpeedDial', '^?mdFabToolbar'],
	
	      compile: function(element, attributes) {
	        var children = element.children();
	
	        var hasNgRepeat = $mdUtil.prefixer().hasAttribute(children, 'ng-repeat');
	
	        // Support both ng-repeat and static content
	        if (hasNgRepeat) {
	          children.addClass('md-fab-action-item');
	        } else {
	          // Wrap every child in a new div and add a class that we can scale/fling independently
	          children.wrap('<div class="md-fab-action-item">');
	        }
	      }
	    };
	  }
	
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  MdFabController.$inject = ["$scope", "$element", "$animate", "$mdUtil", "$mdConstant", "$timeout"];
	  angular.module('material.components.fabShared', ['material.core'])
	    .controller('MdFabController', MdFabController);
	
	  function MdFabController($scope, $element, $animate, $mdUtil, $mdConstant, $timeout) {
	    var vm = this;
	    var initialAnimationAttempts = 0;
	
	    // NOTE: We use async eval(s) below to avoid conflicts with any existing digest loops
	
	    vm.open = function() {
	      $scope.$evalAsync("vm.isOpen = true");
	    };
	
	    vm.close = function() {
	      // Async eval to avoid conflicts with existing digest loops
	      $scope.$evalAsync("vm.isOpen = false");
	
	      // Focus the trigger when the element closes so users can still tab to the next item
	      $element.find('md-fab-trigger')[0].focus();
	    };
	
	    // Toggle the open/close state when the trigger is clicked
	    vm.toggle = function() {
	      $scope.$evalAsync("vm.isOpen = !vm.isOpen");
	    };
	
	    /*
	     * AngularJS Lifecycle hook for newer AngularJS versions.
	     * Bindings are not guaranteed to have been assigned in the controller, but they are in the $onInit hook.
	     */
	    vm.$onInit = function() {
	      setupDefaults();
	      setupListeners();
	      setupWatchers();
	
	      fireInitialAnimations();
	    };
	
	    // For AngularJS 1.4 and older, where there are no lifecycle hooks but bindings are pre-assigned,
	    // manually call the $onInit hook.
	    if (angular.version.major === 1 && angular.version.minor <= 4) {
	      this.$onInit();
	    }
	
	    function setupDefaults() {
	      // Set the default direction to 'down' if none is specified
	      vm.direction = vm.direction || 'down';
	
	      // Set the default to be closed
	      vm.isOpen = vm.isOpen || false;
	
	      // Start the keyboard interaction at the first action
	      resetActionIndex();
	
	      // Add an animations waiting class so we know not to run
	      $element.addClass('md-animations-waiting');
	    }
	
	    function setupListeners() {
	      var eventTypes = [
	        'click', 'focusin', 'focusout'
	      ];
	
	      // Add our listeners
	      angular.forEach(eventTypes, function(eventType) {
	        $element.on(eventType, parseEvents);
	      });
	
	      // Remove our listeners when destroyed
	      $scope.$on('$destroy', function() {
	        angular.forEach(eventTypes, function(eventType) {
	          $element.off(eventType, parseEvents);
	        });
	
	        // remove any attached keyboard handlers in case element is removed while
	        // speed dial is open
	        disableKeyboard();
	      });
	    }
	
	    var closeTimeout;
	    function parseEvents(event) {
	      // If the event is a click, just handle it
	      if (event.type == 'click') {
	        handleItemClick(event);
	      }
	
	      // If we focusout, set a timeout to close the element
	      if (event.type == 'focusout' && !closeTimeout) {
	        closeTimeout = $timeout(function() {
	          vm.close();
	        }, 100, false);
	      }
	
	      // If we see a focusin and there is a timeout about to run, cancel it so we stay open
	      if (event.type == 'focusin' && closeTimeout) {
	        $timeout.cancel(closeTimeout);
	        closeTimeout = null;
	      }
	    }
	
	    function resetActionIndex() {
	      vm.currentActionIndex = -1;
	    }
	
	    function setupWatchers() {
	      // Watch for changes to the direction and update classes/attributes
	      $scope.$watch('vm.direction', function(newDir, oldDir) {
	        // Add the appropriate classes so we can target the direction in the CSS
	        $animate.removeClass($element, 'md-' + oldDir);
	        $animate.addClass($element, 'md-' + newDir);
	
	        // Reset the action index since it may have changed
	        resetActionIndex();
	      });
	
	      var trigger, actions;
	
	      // Watch for changes to md-open
	      $scope.$watch('vm.isOpen', function(isOpen) {
	        // Reset the action index since it may have changed
	        resetActionIndex();
	
	        // We can't get the trigger/actions outside of the watch because the component hasn't been
	        // linked yet, so we wait until the first watch fires to cache them.
	        if (!trigger || !actions) {
	          trigger = getTriggerElement();
	          actions = getActionsElement();
	        }
	
	        if (isOpen) {
	          enableKeyboard();
	        } else {
	          disableKeyboard();
	        }
	
	        var toAdd = isOpen ? 'md-is-open' : '';
	        var toRemove = isOpen ? '' : 'md-is-open';
	
	        // Set the proper ARIA attributes
	        trigger.attr('aria-haspopup', true);
	        trigger.attr('aria-expanded', isOpen);
	        actions.attr('aria-hidden', !isOpen);
	
	        // Animate the CSS classes
	        $animate.setClass($element, toAdd, toRemove);
	      });
	    }
	
	    function fireInitialAnimations() {
	      // If the element is actually visible on the screen
	      if ($element[0].scrollHeight > 0) {
	        // Fire our animation
	        $animate.addClass($element, '_md-animations-ready').then(function() {
	          // Remove the waiting class
	          $element.removeClass('md-animations-waiting');
	        });
	      }
	
	      // Otherwise, try for up to 1 second before giving up
	      else if (initialAnimationAttempts < 10) {
	        $timeout(fireInitialAnimations, 100);
	
	        // Increment our counter
	        initialAnimationAttempts = initialAnimationAttempts + 1;
	      }
	    }
	
	    function enableKeyboard() {
	      $element.on('keydown', keyPressed);
	
	      // On the next tick, setup a check for outside clicks; we do this on the next tick to avoid
	      // clicks/touches that result in the isOpen attribute changing (e.g. a bound radio button)
	      $mdUtil.nextTick(function() {
	        angular.element(document).on('click touchend', checkForOutsideClick);
	      });
	
	      // TODO: On desktop, we should be able to reset the indexes so you cannot tab through, but
	      // this breaks accessibility, especially on mobile, since you have no arrow keys to press
	      //resetActionTabIndexes();
	    }
	
	    function disableKeyboard() {
	      $element.off('keydown', keyPressed);
	      angular.element(document).off('click touchend', checkForOutsideClick);
	    }
	
	    function checkForOutsideClick(event) {
	      if (event.target) {
	        var closestTrigger = $mdUtil.getClosest(event.target, 'md-fab-trigger');
	        var closestActions = $mdUtil.getClosest(event.target, 'md-fab-actions');
	
	        if (!closestTrigger && !closestActions) {
	          vm.close();
	        }
	      }
	    }
	
	    function keyPressed(event) {
	      switch (event.which) {
	        case $mdConstant.KEY_CODE.ESCAPE: vm.close(); event.preventDefault(); return false;
	        case $mdConstant.KEY_CODE.LEFT_ARROW: doKeyLeft(event); return false;
	        case $mdConstant.KEY_CODE.UP_ARROW: doKeyUp(event); return false;
	        case $mdConstant.KEY_CODE.RIGHT_ARROW: doKeyRight(event); return false;
	        case $mdConstant.KEY_CODE.DOWN_ARROW: doKeyDown(event); return false;
	      }
	    }
	
	    function doActionPrev(event) {
	      focusAction(event, -1);
	    }
	
	    function doActionNext(event) {
	      focusAction(event, 1);
	    }
	
	    function focusAction(event, direction) {
	      var actions = resetActionTabIndexes();
	
	      // Increment/decrement the counter with restrictions
	      vm.currentActionIndex = vm.currentActionIndex + direction;
	      vm.currentActionIndex = Math.min(actions.length - 1, vm.currentActionIndex);
	      vm.currentActionIndex = Math.max(0, vm.currentActionIndex);
	
	      // Focus the element
	      var focusElement =  angular.element(actions[vm.currentActionIndex]).children()[0];
	      angular.element(focusElement).attr('tabindex', 0);
	      focusElement.focus();
	
	      // Make sure the event doesn't bubble and cause something else
	      event.preventDefault();
	      event.stopImmediatePropagation();
	    }
	
	    function resetActionTabIndexes() {
	      // Grab all of the actions
	      var actions = getActionsElement()[0].querySelectorAll('.md-fab-action-item');
	
	      // Disable all other actions for tabbing
	      angular.forEach(actions, function(action) {
	        angular.element(angular.element(action).children()[0]).attr('tabindex', -1);
	      });
	
	      return actions;
	    }
	
	    function doKeyLeft(event) {
	      if (vm.direction === 'left') {
	        doActionNext(event);
	      } else {
	        doActionPrev(event);
	      }
	    }
	
	    function doKeyUp(event) {
	      if (vm.direction === 'down') {
	        doActionPrev(event);
	      } else {
	        doActionNext(event);
	      }
	    }
	
	    function doKeyRight(event) {
	      if (vm.direction === 'left') {
	        doActionPrev(event);
	      } else {
	        doActionNext(event);
	      }
	    }
	
	    function doKeyDown(event) {
	      if (vm.direction === 'up') {
	        doActionPrev(event);
	      } else {
	        doActionNext(event);
	      }
	    }
	
	    function isTrigger(element) {
	      return $mdUtil.getClosest(element, 'md-fab-trigger');
	    }
	
	    function isAction(element) {
	      return $mdUtil.getClosest(element, 'md-fab-actions');
	    }
	
	    function handleItemClick(event) {
	      if (isTrigger(event.target)) {
	        vm.toggle();
	      }
	
	      if (isAction(event.target)) {
	        vm.close();
	      }
	    }
	
	    function getTriggerElement() {
	      return $element.find('md-fab-trigger');
	    }
	
	    function getActionsElement() {
	      return $element.find('md-fab-actions');
	    }
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * The duration of the CSS animation in milliseconds.
	   *
	   * @type {number}
	   */
	  MdFabSpeedDialFlingAnimation.$inject = ["$timeout"];
	  MdFabSpeedDialScaleAnimation.$inject = ["$timeout"];
	  var cssAnimationDuration = 300;
	
	  /**
	   * @ngdoc module
	   * @name material.components.fabSpeedDial
	   */
	  angular
	    // Declare our module
	    .module('material.components.fabSpeedDial', [
	      'material.core',
	      'material.components.fabShared',
	      'material.components.fabActions'
	    ])
	
	    // Register our directive
	    .directive('mdFabSpeedDial', MdFabSpeedDialDirective)
	
	    // Register our custom animations
	    .animation('.md-fling', MdFabSpeedDialFlingAnimation)
	    .animation('.md-scale', MdFabSpeedDialScaleAnimation)
	
	    // Register a service for each animation so that we can easily inject them into unit tests
	    .service('mdFabSpeedDialFlingAnimation', MdFabSpeedDialFlingAnimation)
	    .service('mdFabSpeedDialScaleAnimation', MdFabSpeedDialScaleAnimation);
	
	  /**
	   * @ngdoc directive
	   * @name mdFabSpeedDial
	   * @module material.components.fabSpeedDial
	   *
	   * @restrict E
	   *
	   * @description
	   * The `<md-fab-speed-dial>` directive is used to present a series of popup elements (usually
	   * `<md-button>`s) for quick access to common actions.
	   *
	   * There are currently two animations available by applying one of the following classes to
	   * the component:
	   *
	   *  - `md-fling` - The speed dial items appear from underneath the trigger and move into their
	   *    appropriate positions.
	   *  - `md-scale` - The speed dial items appear in their proper places by scaling from 0% to 100%.
	   *
	   * You may also easily position the trigger by applying one one of the following classes to the
	   * `<md-fab-speed-dial>` element:
	   *  - `md-fab-top-left`
	   *  - `md-fab-top-right`
	   *  - `md-fab-bottom-left`
	   *  - `md-fab-bottom-right`
	   *
	   * These CSS classes use `position: absolute`, so you need to ensure that the container element
	   * also uses `position: absolute` or `position: relative` in order for them to work.
	   *
	   * Additionally, you may use the standard `ng-mouseenter` and `ng-mouseleave` directives to
	   * open or close the speed dial. However, if you wish to allow users to hover over the empty
	   * space where the actions will appear, you must also add the `md-hover-full` class to the speed
	   * dial element. Without this, the hover effect will only occur on top of the trigger.
	   *
	   * See the demos for more information.
	   *
	   * ## Troubleshooting
	   *
	   * If your speed dial shows the closing animation upon launch, you may need to use `ng-cloak` on
	   * the parent container to ensure that it is only visible once ready. We have plans to remove this
	   * necessity in the future.
	   *
	   * @usage
	   * <hljs lang="html">
	   * <md-fab-speed-dial md-direction="up" class="md-fling">
	   *   <md-fab-trigger>
	   *     <md-button aria-label="Add..."><md-icon md-svg-src="/img/icons/plus.svg"></md-icon></md-button>
	   *   </md-fab-trigger>
	   *
	   *   <md-fab-actions>
	   *     <md-button aria-label="Add User">
	   *       <md-icon md-svg-src="/img/icons/user.svg"></md-icon>
	   *     </md-button>
	   *
	   *     <md-button aria-label="Add Group">
	   *       <md-icon md-svg-src="/img/icons/group.svg"></md-icon>
	   *     </md-button>
	   *   </md-fab-actions>
	   * </md-fab-speed-dial>
	   * </hljs>
	   *
	   * @param {string} md-direction From which direction you would like the speed dial to appear
	   * relative to the trigger element.
	   * @param {expression=} md-open Programmatically control whether or not the speed-dial is visible.
	   */
	  function MdFabSpeedDialDirective() {
	    return {
	      restrict: 'E',
	
	      scope: {
	        direction: '@?mdDirection',
	        isOpen: '=?mdOpen'
	      },
	
	      bindToController: true,
	      controller: 'MdFabController',
	      controllerAs: 'vm',
	
	      link: FabSpeedDialLink
	    };
	
	    function FabSpeedDialLink(scope, element) {
	      // Prepend an element to hold our CSS variables so we can use them in the animations below
	      element.prepend('<div class="_md-css-variables"></div>');
	    }
	  }
	
	  function MdFabSpeedDialFlingAnimation($timeout) {
	    function delayDone(done) { $timeout(done, cssAnimationDuration, false); }
	
	    function runAnimation(element) {
	      // Don't run if we are still waiting and we are not ready
	      if (element.hasClass('md-animations-waiting') && !element.hasClass('_md-animations-ready')) {
	        return;
	      }
	
	      var el = element[0];
	      var ctrl = element.controller('mdFabSpeedDial');
	      var items = el.querySelectorAll('.md-fab-action-item');
	
	      // Grab our trigger element
	      var triggerElement = el.querySelector('md-fab-trigger');
	
	      // Grab our element which stores CSS variables
	      var variablesElement = el.querySelector('._md-css-variables');
	
	      // Setup JS variables based on our CSS variables
	      var startZIndex = parseInt(window.getComputedStyle(variablesElement).zIndex);
	
	      // Always reset the items to their natural position/state
	      angular.forEach(items, function(item, index) {
	        var styles = item.style;
	
	        styles.transform = styles.webkitTransform = '';
	        styles.transitionDelay = '';
	        styles.opacity = 1;
	
	        // Make the items closest to the trigger have the highest z-index
	        styles.zIndex = (items.length - index) + startZIndex;
	      });
	
	      // Set the trigger to be above all of the actions so they disappear behind it.
	      triggerElement.style.zIndex = startZIndex + items.length + 1;
	
	      // If the control is closed, hide the items behind the trigger
	      if (!ctrl.isOpen) {
	        angular.forEach(items, function(item, index) {
	          var newPosition, axis;
	          var styles = item.style;
	
	          // Make sure to account for differences in the dimensions of the trigger verses the items
	          // so that we can properly center everything; this helps hide the item's shadows behind
	          // the trigger.
	          var triggerItemHeightOffset = (triggerElement.clientHeight - item.clientHeight) / 2;
	          var triggerItemWidthOffset = (triggerElement.clientWidth - item.clientWidth) / 2;
	
	          switch (ctrl.direction) {
	            case 'up':
	              newPosition = (item.scrollHeight * (index + 1) + triggerItemHeightOffset);
	              axis = 'Y';
	              break;
	            case 'down':
	              newPosition = -(item.scrollHeight * (index + 1) + triggerItemHeightOffset);
	              axis = 'Y';
	              break;
	            case 'left':
	              newPosition = (item.scrollWidth * (index + 1) + triggerItemWidthOffset);
	              axis = 'X';
	              break;
	            case 'right':
	              newPosition = -(item.scrollWidth * (index + 1) + triggerItemWidthOffset);
	              axis = 'X';
	              break;
	          }
	
	          var newTranslate = 'translate' + axis + '(' + newPosition + 'px)';
	
	          styles.transform = styles.webkitTransform = newTranslate;
	        });
	      }
	    }
	
	    return {
	      addClass: function(element, className, done) {
	        if (element.hasClass('md-fling')) {
	          runAnimation(element);
	          delayDone(done);
	        } else {
	          done();
	        }
	      },
	      removeClass: function(element, className, done) {
	        runAnimation(element);
	        delayDone(done);
	      }
	    };
	  }
	
	  function MdFabSpeedDialScaleAnimation($timeout) {
	    function delayDone(done) { $timeout(done, cssAnimationDuration, false); }
	
	    var delay = 65;
	
	    function runAnimation(element) {
	      var el = element[0];
	      var ctrl = element.controller('mdFabSpeedDial');
	      var items = el.querySelectorAll('.md-fab-action-item');
	
	      // Grab our element which stores CSS variables
	      var variablesElement = el.querySelector('._md-css-variables');
	
	      // Setup JS variables based on our CSS variables
	      var startZIndex = parseInt(window.getComputedStyle(variablesElement).zIndex);
	
	      // Always reset the items to their natural position/state
	      angular.forEach(items, function(item, index) {
	        var styles = item.style,
	          offsetDelay = index * delay;
	
	        styles.opacity = ctrl.isOpen ? 1 : 0;
	        styles.transform = styles.webkitTransform = ctrl.isOpen ? 'scale(1)' : 'scale(0)';
	        styles.transitionDelay = (ctrl.isOpen ? offsetDelay : (items.length - offsetDelay)) + 'ms';
	
	        // Make the items closest to the trigger have the highest z-index
	        styles.zIndex = (items.length - index) + startZIndex;
	      });
	    }
	
	    return {
	      addClass: function(element, className, done) {
	        runAnimation(element);
	        delayDone(done);
	      },
	
	      removeClass: function(element, className, done) {
	        runAnimation(element);
	        delayDone(done);
	      }
	    };
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc module
	   * @name material.components.fabToolbar
	   */
	  angular
	    // Declare our module
	    .module('material.components.fabToolbar', [
	      'material.core',
	      'material.components.fabShared',
	      'material.components.fabActions'
	    ])
	
	    // Register our directive
	    .directive('mdFabToolbar', MdFabToolbarDirective)
	
	    // Register our custom animations
	    .animation('.md-fab-toolbar', MdFabToolbarAnimation)
	
	    // Register a service for the animation so that we can easily inject it into unit tests
	    .service('mdFabToolbarAnimation', MdFabToolbarAnimation);
	
	  /**
	   * @ngdoc directive
	   * @name mdFabToolbar
	   * @module material.components.fabToolbar
	   *
	   * @restrict E
	   *
	   * @description
	   *
	   * The `<md-fab-toolbar>` directive is used to present a toolbar of elements (usually `<md-button>`s)
	   * for quick access to common actions when a floating action button is activated (via click or
	   * keyboard navigation).
	   *
	   * You may also easily position the trigger by applying one one of the following classes to the
	   * `<md-fab-toolbar>` element:
	   *  - `md-fab-top-left`
	   *  - `md-fab-top-right`
	   *  - `md-fab-bottom-left`
	   *  - `md-fab-bottom-right`
	   *
	   * These CSS classes use `position: absolute`, so you need to ensure that the container element
	   * also uses `position: absolute` or `position: relative` in order for them to work.
	   *
	   * @usage
	   *
	   * <hljs lang="html">
	   * <md-fab-toolbar md-direction='left'>
	   *   <md-fab-trigger>
	   *     <md-button aria-label="Add..."><md-icon md-svg-src="/img/icons/plus.svg"></md-icon></md-button>
	   *   </md-fab-trigger>
	   *
	   *   <md-toolbar>
	   *    <md-fab-actions>
	   *      <md-button aria-label="Add User">
	   *        <md-icon md-svg-src="/img/icons/user.svg"></md-icon>
	   *      </md-button>
	   *
	   *      <md-button aria-label="Add Group">
	   *        <md-icon md-svg-src="/img/icons/group.svg"></md-icon>
	   *      </md-button>
	   *    </md-fab-actions>
	   *   </md-toolbar>
	   * </md-fab-toolbar>
	   * </hljs>
	   *
	   * @param {string} md-direction From which direction you would like the toolbar items to appear
	   * relative to the trigger element. Supports `left` and `right` directions.
	   * @param {expression=} md-open Programmatically control whether or not the toolbar is visible.
	   */
	  function MdFabToolbarDirective() {
	    return {
	      restrict: 'E',
	      transclude: true,
	      template: '<div class="md-fab-toolbar-wrapper">' +
	      '  <div class="md-fab-toolbar-content" ng-transclude></div>' +
	      '</div>',
	
	      scope: {
	        direction: '@?mdDirection',
	        isOpen: '=?mdOpen'
	      },
	
	      bindToController: true,
	      controller: 'MdFabController',
	      controllerAs: 'vm',
	
	      link: link
	    };
	
	    function link(scope, element, attributes) {
	      // Add the base class for animations
	      element.addClass('md-fab-toolbar');
	
	      // Prepend the background element to the trigger's button
	      element.find('md-fab-trigger').find('button')
	        .prepend('<div class="md-fab-toolbar-background"></div>');
	    }
	  }
	
	  function MdFabToolbarAnimation() {
	
	    function runAnimation(element, className, done) {
	      // If no className was specified, don't do anything
	      if (!className) {
	        return;
	      }
	
	      var el = element[0];
	      var ctrl = element.controller('mdFabToolbar');
	
	      // Grab the relevant child elements
	      var backgroundElement = el.querySelector('.md-fab-toolbar-background');
	      var triggerElement = el.querySelector('md-fab-trigger button');
	      var toolbarElement = el.querySelector('md-toolbar');
	      var iconElement = el.querySelector('md-fab-trigger button md-icon');
	      var actions = element.find('md-fab-actions').children();
	
	      // If we have both elements, use them to position the new background
	      if (triggerElement && backgroundElement) {
	        // Get our variables
	        var color = window.getComputedStyle(triggerElement).getPropertyValue('background-color');
	        var width = el.offsetWidth;
	        var height = el.offsetHeight;
	
	        // Make it twice as big as it should be since we scale from the center
	        var scale = 2 * (width / triggerElement.offsetWidth);
	
	        // Set some basic styles no matter what animation we're doing
	        backgroundElement.style.backgroundColor = color;
	        backgroundElement.style.borderRadius = width + 'px';
	
	        // If we're open
	        if (ctrl.isOpen) {
	          // Turn on toolbar pointer events when closed
	          toolbarElement.style.pointerEvents = 'inherit';
	
	          backgroundElement.style.width = triggerElement.offsetWidth + 'px';
	          backgroundElement.style.height = triggerElement.offsetHeight + 'px';
	          backgroundElement.style.transform = 'scale(' + scale + ')';
	
	          // Set the next close animation to have the proper delays
	          backgroundElement.style.transitionDelay = '0ms';
	          iconElement && (iconElement.style.transitionDelay = '.3s');
	
	          // Apply a transition delay to actions
	          angular.forEach(actions, function(action, index) {
	            action.style.transitionDelay = (actions.length - index) * 25 + 'ms';
	          });
	        } else {
	          // Turn off toolbar pointer events when closed
	          toolbarElement.style.pointerEvents = 'none';
	
	          // Scale it back down to the trigger's size
	          backgroundElement.style.transform = 'scale(1)';
	
	          // Reset the position
	          backgroundElement.style.top = '0';
	
	          if (element.hasClass('md-right')) {
	            backgroundElement.style.left = '0';
	            backgroundElement.style.right = null;
	          }
	
	          if (element.hasClass('md-left')) {
	            backgroundElement.style.right = '0';
	            backgroundElement.style.left = null;
	          }
	
	          // Set the next open animation to have the proper delays
	          backgroundElement.style.transitionDelay = '200ms';
	          iconElement && (iconElement.style.transitionDelay = '0ms');
	
	          // Apply a transition delay to actions
	          angular.forEach(actions, function(action, index) {
	            action.style.transitionDelay = 200 + (index * 25) + 'ms';
	          });
	        }
	      }
	    }
	
	    return {
	      addClass: function(element, className, done) {
	        runAnimation(element, className, done);
	        done();
	      },
	
	      removeClass: function(element, className, done) {
	        runAnimation(element, className, done);
	        done();
	      }
	    };
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.gridList
	 */
	GridListController.$inject = ["$mdUtil"];
	GridLayoutFactory.$inject = ["$mdUtil"];
	GridListDirective.$inject = ["$interpolate", "$mdConstant", "$mdGridLayout", "$mdMedia"];
	GridTileDirective.$inject = ["$mdMedia"];
	angular.module('material.components.gridList', ['material.core'])
	       .directive('mdGridList', GridListDirective)
	       .directive('mdGridTile', GridTileDirective)
	       .directive('mdGridTileFooter', GridTileCaptionDirective)
	       .directive('mdGridTileHeader', GridTileCaptionDirective)
	       .factory('$mdGridLayout', GridLayoutFactory);
	
	/**
	 * @ngdoc directive
	 * @name mdGridList
	 * @module material.components.gridList
	 * @restrict E
	 * @description
	 * Grid lists are an alternative to standard list views. Grid lists are distinct
	 * from grids used for layouts and other visual presentations.
	 *
	 * A grid list is best suited to presenting a homogenous data type, typically
	 * images, and is optimized for visual comprehension and differentiating between
	 * like data types.
	 *
	 * A grid list is a continuous element consisting of tessellated, regular
	 * subdivisions called cells that contain tiles (`md-grid-tile`).
	 *
	 * <img src="//material-design.storage.googleapis.com/publish/v_2/material_ext_publish/0Bx4BSt6jniD7OVlEaXZ5YmU1Xzg/components_grids_usage2.png"
	 *    style="width: 300px; height: auto; margin-right: 16px;" alt="Concept of grid explained visually">
	 * <img src="//material-design.storage.googleapis.com/publish/v_2/material_ext_publish/0Bx4BSt6jniD7VGhsOE5idWlJWXM/components_grids_usage3.png"
	 *    style="width: 300px; height: auto;" alt="Grid concepts legend">
	 *
	 * Cells are arrayed vertically and horizontally within the grid.
	 *
	 * Tiles hold content and can span one or more cells vertically or horizontally.
	 *
	 * ### Responsive Attributes
	 *
	 * The `md-grid-list` directive supports "responsive" attributes, which allow
	 * different `md-cols`, `md-gutter` and `md-row-height` values depending on the
	 * currently matching media query.
	 *
	 * In order to set a responsive attribute, first define the fallback value with
	 * the standard attribute name, then add additional attributes with the
	 * following convention: `{base-attribute-name}-{media-query-name}="{value}"`
	 * (ie. `md-cols-lg="8"`)
	 *
	 * @param {number} md-cols Number of columns in the grid.
	 * @param {string} md-row-height One of
	 * <ul>
	 *   <li>CSS length - Fixed height rows (eg. `8px` or `1rem`)</li>
	 *   <li>`{width}:{height}` - Ratio of width to height (eg.
	 *   `md-row-height="16:9"`)</li>
	 *   <li>`"fit"` - Height will be determined by subdividing the available
	 *   height by the number of rows</li>
	 * </ul>
	 * @param {string=} md-gutter The amount of space between tiles in CSS units
	 *     (default 1px)
	 * @param {expression=} md-on-layout Expression to evaluate after layout. Event
	 *     object is available as `$event`, and contains performance information.
	 *
	 * @usage
	 * Basic:
	 * <hljs lang="html">
	 * <md-grid-list md-cols="5" md-gutter="1em" md-row-height="4:3">
	 *   <md-grid-tile></md-grid-tile>
	 * </md-grid-list>
	 * </hljs>
	 *
	 * Fixed-height rows:
	 * <hljs lang="html">
	 * <md-grid-list md-cols="4" md-row-height="200px" ...>
	 *   <md-grid-tile></md-grid-tile>
	 * </md-grid-list>
	 * </hljs>
	 *
	 * Fit rows:
	 * <hljs lang="html">
	 * <md-grid-list md-cols="4" md-row-height="fit" style="height: 400px;" ...>
	 *   <md-grid-tile></md-grid-tile>
	 * </md-grid-list>
	 * </hljs>
	 *
	 * Using responsive attributes:
	 * <hljs lang="html">
	 * <md-grid-list
	 *     md-cols-sm="2"
	 *     md-cols-md="4"
	 *     md-cols-lg="8"
	 *     md-cols-gt-lg="12"
	 *     ...>
	 *   <md-grid-tile></md-grid-tile>
	 * </md-grid-list>
	 * </hljs>
	 */
	function GridListDirective($interpolate, $mdConstant, $mdGridLayout, $mdMedia) {
	  return {
	    restrict: 'E',
	    controller: GridListController,
	    scope: {
	      mdOnLayout: '&'
	    },
	    link: postLink
	  };
	
	  function postLink(scope, element, attrs, ctrl) {
	    element.addClass('_md');     // private md component indicator for styling
	    
	    // Apply semantics
	    element.attr('role', 'list');
	
	    // Provide the controller with a way to trigger layouts.
	    ctrl.layoutDelegate = layoutDelegate;
	
	    var invalidateLayout = angular.bind(ctrl, ctrl.invalidateLayout),
	        unwatchAttrs = watchMedia();
	      scope.$on('$destroy', unwatchMedia);
	
	    /**
	     * Watches for changes in media, invalidating layout as necessary.
	     */
	    function watchMedia() {
	      for (var mediaName in $mdConstant.MEDIA) {
	        $mdMedia(mediaName); // initialize
	        $mdMedia.getQuery($mdConstant.MEDIA[mediaName])
	            .addListener(invalidateLayout);
	      }
	      return $mdMedia.watchResponsiveAttributes(
	          ['md-cols', 'md-row-height', 'md-gutter'], attrs, layoutIfMediaMatch);
	    }
	
	    function unwatchMedia() {
	      ctrl.layoutDelegate = angular.noop;
	
	      unwatchAttrs();
	      for (var mediaName in $mdConstant.MEDIA) {
	        $mdMedia.getQuery($mdConstant.MEDIA[mediaName])
	            .removeListener(invalidateLayout);
	      }
	    }
	
	    /**
	     * Performs grid layout if the provided mediaName matches the currently
	     * active media type.
	     */
	    function layoutIfMediaMatch(mediaName) {
	      if (mediaName == null) {
	        // TODO(shyndman): It would be nice to only layout if we have
	        // instances of attributes using this media type
	        ctrl.invalidateLayout();
	      } else if ($mdMedia(mediaName)) {
	        ctrl.invalidateLayout();
	      }
	    }
	
	    var lastLayoutProps;
	
	    /**
	     * Invokes the layout engine, and uses its results to lay out our
	     * tile elements.
	     *
	     * @param {boolean} tilesInvalidated Whether tiles have been
	     *    added/removed/moved since the last layout. This is to avoid situations
	     *    where tiles are replaced with properties identical to their removed
	     *    counterparts.
	     */
	    function layoutDelegate(tilesInvalidated) {
	      var tiles = getTileElements();
	      var props = {
	        tileSpans: getTileSpans(tiles),
	        colCount: getColumnCount(),
	        rowMode: getRowMode(),
	        rowHeight: getRowHeight(),
	        gutter: getGutter()
	      };
	
	      if (!tilesInvalidated && angular.equals(props, lastLayoutProps)) {
	        return;
	      }
	
	      var performance =
	        $mdGridLayout(props.colCount, props.tileSpans, tiles)
	          .map(function(tilePositions, rowCount) {
	            return {
	              grid: {
	                element: element,
	                style: getGridStyle(props.colCount, rowCount,
	                    props.gutter, props.rowMode, props.rowHeight)
	              },
	              tiles: tilePositions.map(function(ps, i) {
	                return {
	                  element: angular.element(tiles[i]),
	                  style: getTileStyle(ps.position, ps.spans,
	                      props.colCount, rowCount,
	                      props.gutter, props.rowMode, props.rowHeight)
	                }
	              })
	            }
	          })
	          .reflow()
	          .performance();
	
	      // Report layout
	      scope.mdOnLayout({
	        $event: {
	          performance: performance
	        }
	      });
	
	      lastLayoutProps = props;
	    }
	
	    // Use $interpolate to do some simple string interpolation as a convenience.
	
	    var startSymbol = $interpolate.startSymbol();
	    var endSymbol = $interpolate.endSymbol();
	
	    // Returns an expression wrapped in the interpolator's start and end symbols.
	    function expr(exprStr) {
	      return startSymbol + exprStr + endSymbol;
	    }
	
	    // The amount of space a single 1x1 tile would take up (either width or height), used as
	    // a basis for other calculations. This consists of taking the base size percent (as would be
	    // if evenly dividing the size between cells), and then subtracting the size of one gutter.
	    // However, since there are no gutters on the edges, each tile only uses a fration
	    // (gutterShare = numGutters / numCells) of the gutter size. (Imagine having one gutter per
	    // tile, and then breaking up the extra gutter on the edge evenly among the cells).
	    var UNIT = $interpolate(expr('share') + '% - (' + expr('gutter') + ' * ' + expr('gutterShare') + ')');
	
	    // The horizontal or vertical position of a tile, e.g., the 'top' or 'left' property value.
	    // The position comes the size of a 1x1 tile plus gutter for each previous tile in the
	    // row/column (offset).
	    var POSITION  = $interpolate('calc((' + expr('unit') + ' + ' + expr('gutter') + ') * ' + expr('offset') + ')');
	
	    // The actual size of a tile, e.g., width or height, taking rowSpan or colSpan into account.
	    // This is computed by multiplying the base unit by the rowSpan/colSpan, and then adding back
	    // in the space that the gutter would normally have used (which was already accounted for in
	    // the base unit calculation).
	    var DIMENSION = $interpolate('calc((' + expr('unit') + ') * ' + expr('span') + ' + (' + expr('span') + ' - 1) * ' + expr('gutter') + ')');
	
	    /**
	     * Gets the styles applied to a tile element described by the given parameters.
	     * @param {{row: number, col: number}} position The row and column indices of the tile.
	     * @param {{row: number, col: number}} spans The rowSpan and colSpan of the tile.
	     * @param {number} colCount The number of columns.
	     * @param {number} rowCount The number of rows.
	     * @param {string} gutter The amount of space between tiles. This will be something like
	     *     '5px' or '2em'.
	     * @param {string} rowMode The row height mode. Can be one of:
	     *     'fixed': all rows have a fixed size, given by rowHeight,
	     *     'ratio': row height defined as a ratio to width, or
	     *     'fit': fit to the grid-list element height, divinding evenly among rows.
	     * @param {string|number} rowHeight The height of a row. This is only used for 'fixed' mode and
	     *     for 'ratio' mode. For 'ratio' mode, this is the *ratio* of width-to-height (e.g., 0.75).
	     * @returns {Object} Map of CSS properties to be applied to the style element. Will define
	     *     values for top, left, width, height, marginTop, and paddingTop.
	     */
	    function getTileStyle(position, spans, colCount, rowCount, gutter, rowMode, rowHeight) {
	      // TODO(shyndman): There are style caching opportunities here.
	
	      // Percent of the available horizontal space that one column takes up.
	      var hShare = (1 / colCount) * 100;
	
	      // Fraction of the gutter size that each column takes up.
	      var hGutterShare = (colCount - 1) / colCount;
	
	      // Base horizontal size of a column.
	      var hUnit = UNIT({share: hShare, gutterShare: hGutterShare, gutter: gutter});
	
	      // The width and horizontal position of each tile is always calculated the same way, but the
	      // height and vertical position depends on the rowMode.
	      var ltr = document.dir != 'rtl' && document.body.dir != 'rtl';
	      var style = ltr ? {
	          left: POSITION({ unit: hUnit, offset: position.col, gutter: gutter }),
	          width: DIMENSION({ unit: hUnit, span: spans.col, gutter: gutter }),
	          // resets
	          paddingTop: '',
	          marginTop: '',
	          top: '',
	          height: ''
	        } : {
	        right: POSITION({ unit: hUnit, offset: position.col, gutter: gutter }),
	        width: DIMENSION({ unit: hUnit, span: spans.col, gutter: gutter }),
	        // resets
	        paddingTop: '',
	        marginTop: '',
	        top: '',
	        height: ''
	      };
	
	      switch (rowMode) {
	        case 'fixed':
	          // In fixed mode, simply use the given rowHeight.
	          style.top = POSITION({ unit: rowHeight, offset: position.row, gutter: gutter });
	          style.height = DIMENSION({ unit: rowHeight, span: spans.row, gutter: gutter });
	          break;
	
	        case 'ratio':
	          // Percent of the available vertical space that one row takes up. Here, rowHeight holds
	          // the ratio value. For example, if the width:height ratio is 4:3, rowHeight = 1.333.
	          var vShare = hShare / rowHeight;
	
	          // Base veritcal size of a row.
	          var vUnit = UNIT({ share: vShare, gutterShare: hGutterShare, gutter: gutter });
	
	          // padidngTop and marginTop are used to maintain the given aspect ratio, as
	          // a percentage-based value for these properties is applied to the *width* of the
	          // containing block. See http://www.w3.org/TR/CSS2/box.html#margin-properties
	          style.paddingTop = DIMENSION({ unit: vUnit, span: spans.row, gutter: gutter});
	          style.marginTop = POSITION({ unit: vUnit, offset: position.row, gutter: gutter });
	          break;
	
	        case 'fit':
	          // Fraction of the gutter size that each column takes up.
	          var vGutterShare = (rowCount - 1) / rowCount;
	
	          // Percent of the available vertical space that one row takes up.
	          var vShare = (1 / rowCount) * 100;
	
	          // Base vertical size of a row.
	          var vUnit = UNIT({share: vShare, gutterShare: vGutterShare, gutter: gutter});
	
	          style.top = POSITION({unit: vUnit, offset: position.row, gutter: gutter});
	          style.height = DIMENSION({unit: vUnit, span: spans.row, gutter: gutter});
	          break;
	      }
	
	      return style;
	    }
	
	    function getGridStyle(colCount, rowCount, gutter, rowMode, rowHeight) {
	      var style = {};
	
	      switch(rowMode) {
	        case 'fixed':
	          style.height = DIMENSION({ unit: rowHeight, span: rowCount, gutter: gutter });
	          style.paddingBottom = '';
	          break;
	
	        case 'ratio':
	          // rowHeight is width / height
	          var hGutterShare = colCount === 1 ? 0 : (colCount - 1) / colCount,
	              hShare = (1 / colCount) * 100,
	              vShare = hShare * (1 / rowHeight),
	              vUnit = UNIT({ share: vShare, gutterShare: hGutterShare, gutter: gutter });
	
	          style.height = '';
	          style.paddingBottom = DIMENSION({ unit: vUnit, span: rowCount, gutter: gutter});
	          break;
	
	        case 'fit':
	          // noop, as the height is user set
	          break;
	      }
	
	      return style;
	    }
	
	    function getTileElements() {
	      return [].filter.call(element.children(), function(ele) {
	        return ele.tagName == 'MD-GRID-TILE' && !ele.$$mdDestroyed;
	      });
	    }
	
	    /**
	     * Gets an array of objects containing the rowspan and colspan for each tile.
	     * @returns {Array<{row: number, col: number}>}
	     */
	    function getTileSpans(tileElements) {
	      return [].map.call(tileElements, function(ele) {
	        var ctrl = angular.element(ele).controller('mdGridTile');
	        return {
	          row: parseInt(
	              $mdMedia.getResponsiveAttribute(ctrl.$attrs, 'md-rowspan'), 10) || 1,
	          col: parseInt(
	              $mdMedia.getResponsiveAttribute(ctrl.$attrs, 'md-colspan'), 10) || 1
	        };
	      });
	    }
	
	    function getColumnCount() {
	      var colCount = parseInt($mdMedia.getResponsiveAttribute(attrs, 'md-cols'), 10);
	      if (isNaN(colCount)) {
	        throw 'md-grid-list: md-cols attribute was not found, or contained a non-numeric value';
	      }
	      return colCount;
	    }
	
	    function getGutter() {
	      return applyDefaultUnit($mdMedia.getResponsiveAttribute(attrs, 'md-gutter') || 1);
	    }
	
	    function getRowHeight() {
	      var rowHeight = $mdMedia.getResponsiveAttribute(attrs, 'md-row-height');
	      if (!rowHeight) {
	        throw 'md-grid-list: md-row-height attribute was not found';
	      }
	
	      switch (getRowMode()) {
	        case 'fixed':
	          return applyDefaultUnit(rowHeight);
	        case 'ratio':
	          var whRatio = rowHeight.split(':');
	          return parseFloat(whRatio[0]) / parseFloat(whRatio[1]);
	        case 'fit':
	          return 0; // N/A
	      }
	    }
	
	    function getRowMode() {
	      var rowHeight = $mdMedia.getResponsiveAttribute(attrs, 'md-row-height');
	      if (!rowHeight) {
	        throw 'md-grid-list: md-row-height attribute was not found';
	      }
	
	      if (rowHeight == 'fit') {
	        return 'fit';
	      } else if (rowHeight.indexOf(':') !== -1) {
	        return 'ratio';
	      } else {
	        return 'fixed';
	      }
	    }
	
	    function applyDefaultUnit(val) {
	      return /\D$/.test(val) ? val : val + 'px';
	    }
	  }
	}
	
	/* @ngInject */
	function GridListController($mdUtil) {
	  this.layoutInvalidated = false;
	  this.tilesInvalidated = false;
	  this.$timeout_ = $mdUtil.nextTick;
	  this.layoutDelegate = angular.noop;
	}
	
	GridListController.prototype = {
	  invalidateTiles: function() {
	    this.tilesInvalidated = true;
	    this.invalidateLayout();
	  },
	
	  invalidateLayout: function() {
	    if (this.layoutInvalidated) {
	      return;
	    }
	    this.layoutInvalidated = true;
	    this.$timeout_(angular.bind(this, this.layout));
	  },
	
	  layout: function() {
	    try {
	      this.layoutDelegate(this.tilesInvalidated);
	    } finally {
	      this.layoutInvalidated = false;
	      this.tilesInvalidated = false;
	    }
	  }
	};
	
	
	/* @ngInject */
	function GridLayoutFactory($mdUtil) {
	  var defaultAnimator = GridTileAnimator;
	
	  /**
	   * Set the reflow animator callback
	   */
	  GridLayout.animateWith = function(customAnimator) {
	    defaultAnimator = !angular.isFunction(customAnimator) ? GridTileAnimator : customAnimator;
	  };
	
	  return GridLayout;
	
	  /**
	   * Publish layout function
	   */
	  function GridLayout(colCount, tileSpans) {
	      var self, layoutInfo, gridStyles, layoutTime, mapTime, reflowTime;
	
	      layoutTime = $mdUtil.time(function() {
	        layoutInfo = calculateGridFor(colCount, tileSpans);
	      });
	
	      return self = {
	
	        /**
	         * An array of objects describing each tile's position in the grid.
	         */
	        layoutInfo: function() {
	          return layoutInfo;
	        },
	
	        /**
	         * Maps grid positioning to an element and a set of styles using the
	         * provided updateFn.
	         */
	        map: function(updateFn) {
	          mapTime = $mdUtil.time(function() {
	            var info = self.layoutInfo();
	            gridStyles = updateFn(info.positioning, info.rowCount);
	          });
	          return self;
	        },
	
	        /**
	         * Default animator simply sets the element.css( <styles> ). An alternate
	         * animator can be provided as an argument. The function has the following
	         * signature:
	         *
	         *    function({grid: {element: JQLite, style: Object}, tiles: Array<{element: JQLite, style: Object}>)
	         */
	        reflow: function(animatorFn) {
	          reflowTime = $mdUtil.time(function() {
	            var animator = animatorFn || defaultAnimator;
	            animator(gridStyles.grid, gridStyles.tiles);
	          });
	          return self;
	        },
	
	        /**
	         * Timing for the most recent layout run.
	         */
	        performance: function() {
	          return {
	            tileCount: tileSpans.length,
	            layoutTime: layoutTime,
	            mapTime: mapTime,
	            reflowTime: reflowTime,
	            totalTime: layoutTime + mapTime + reflowTime
	          };
	        }
	      };
	    }
	
	  /**
	   * Default Gridlist animator simple sets the css for each element;
	   * NOTE: any transitions effects must be manually set in the CSS.
	   * e.g.
	   *
	   *  md-grid-tile {
	   *    transition: all 700ms ease-out 50ms;
	   *  }
	   *
	   */
	  function GridTileAnimator(grid, tiles) {
	    grid.element.css(grid.style);
	    tiles.forEach(function(t) {
	      t.element.css(t.style);
	    })
	  }
	
	  /**
	   * Calculates the positions of tiles.
	   *
	   * The algorithm works as follows:
	   *    An Array<Number> with length colCount (spaceTracker) keeps track of
	   *    available tiling positions, where elements of value 0 represents an
	   *    empty position. Space for a tile is reserved by finding a sequence of
	   *    0s with length <= than the tile's colspan. When such a space has been
	   *    found, the occupied tile positions are incremented by the tile's
	   *    rowspan value, as these positions have become unavailable for that
	   *    many rows.
	   *
	   *    If the end of a row has been reached without finding space for the
	   *    tile, spaceTracker's elements are each decremented by 1 to a minimum
	   *    of 0. Rows are searched in this fashion until space is found.
	   */
	  function calculateGridFor(colCount, tileSpans) {
	    var curCol = 0,
	        curRow = 0,
	        spaceTracker = newSpaceTracker();
	
	    return {
	      positioning: tileSpans.map(function(spans, i) {
	        return {
	          spans: spans,
	          position: reserveSpace(spans, i)
	        };
	      }),
	      rowCount: curRow + Math.max.apply(Math, spaceTracker)
	    };
	
	    function reserveSpace(spans, i) {
	      if (spans.col > colCount) {
	        throw 'md-grid-list: Tile at position ' + i + ' has a colspan ' +
	            '(' + spans.col + ') that exceeds the column count ' +
	            '(' + colCount + ')';
	      }
	
	      var start = 0,
	          end = 0;
	
	      // TODO(shyndman): This loop isn't strictly necessary if you can
	      // determine the minimum number of rows before a space opens up. To do
	      // this, recognize that you've iterated across an entire row looking for
	      // space, and if so fast-forward by the minimum rowSpan count. Repeat
	      // until the required space opens up.
	      while (end - start < spans.col) {
	        if (curCol >= colCount) {
	          nextRow();
	          continue;
	        }
	
	        start = spaceTracker.indexOf(0, curCol);
	        if (start === -1 || (end = findEnd(start + 1)) === -1) {
	          start = end = 0;
	          nextRow();
	          continue;
	        }
	
	        curCol = end + 1;
	      }
	
	      adjustRow(start, spans.col, spans.row);
	      curCol = start + spans.col;
	
	      return {
	        col: start,
	        row: curRow
	      };
	    }
	
	    function nextRow() {
	      curCol = 0;
	      curRow++;
	      adjustRow(0, colCount, -1); // Decrement row spans by one
	    }
	
	    function adjustRow(from, cols, by) {
	      for (var i = from; i < from + cols; i++) {
	        spaceTracker[i] = Math.max(spaceTracker[i] + by, 0);
	      }
	    }
	
	    function findEnd(start) {
	      var i;
	      for (i = start; i < spaceTracker.length; i++) {
	        if (spaceTracker[i] !== 0) {
	          return i;
	        }
	      }
	
	      if (i === spaceTracker.length) {
	        return i;
	      }
	    }
	
	    function newSpaceTracker() {
	      var tracker = [];
	      for (var i = 0; i < colCount; i++) {
	        tracker.push(0);
	      }
	      return tracker;
	    }
	  }
	}
	
	/**
	 * @ngdoc directive
	 * @name mdGridTile
	 * @module material.components.gridList
	 * @restrict E
	 * @description
	 * Tiles contain the content of an `md-grid-list`. They span one or more grid
	 * cells vertically or horizontally, and use `md-grid-tile-{footer,header}` to
	 * display secondary content.
	 *
	 * ### Responsive Attributes
	 *
	 * The `md-grid-tile` directive supports "responsive" attributes, which allow
	 * different `md-rowspan` and `md-colspan` values depending on the currently
	 * matching media query.
	 *
	 * In order to set a responsive attribute, first define the fallback value with
	 * the standard attribute name, then add additional attributes with the
	 * following convention: `{base-attribute-name}-{media-query-name}="{value}"`
	 * (ie. `md-colspan-sm="4"`)
	 *
	 * @param {number=} md-colspan The number of columns to span (default 1). Cannot
	 *    exceed the number of columns in the grid. Supports interpolation.
	 * @param {number=} md-rowspan The number of rows to span (default 1). Supports
	 *     interpolation.
	 *
	 * @usage
	 * With header:
	 * <hljs lang="html">
	 * <md-grid-tile>
	 *   <md-grid-tile-header>
	 *     <h3>This is a header</h3>
	 *   </md-grid-tile-header>
	 * </md-grid-tile>
	 * </hljs>
	 *
	 * With footer:
	 * <hljs lang="html">
	 * <md-grid-tile>
	 *   <md-grid-tile-footer>
	 *     <h3>This is a footer</h3>
	 *   </md-grid-tile-footer>
	 * </md-grid-tile>
	 * </hljs>
	 *
	 * Spanning multiple rows/columns:
	 * <hljs lang="html">
	 * <md-grid-tile md-colspan="2" md-rowspan="3">
	 * </md-grid-tile>
	 * </hljs>
	 *
	 * Responsive attributes:
	 * <hljs lang="html">
	 * <md-grid-tile md-colspan="1" md-colspan-sm="3" md-colspan-md="5">
	 * </md-grid-tile>
	 * </hljs>
	 */
	function GridTileDirective($mdMedia) {
	  return {
	    restrict: 'E',
	    require: '^mdGridList',
	    template: '<figure ng-transclude></figure>',
	    transclude: true,
	    scope: {},
	    // Simple controller that exposes attributes to the grid directive
	    controller: ["$attrs", function($attrs) {
	      this.$attrs = $attrs;
	    }],
	    link: postLink
	  };
	
	  function postLink(scope, element, attrs, gridCtrl) {
	    // Apply semantics
	    element.attr('role', 'listitem');
	
	    // If our colspan or rowspan changes, trigger a layout
	    var unwatchAttrs = $mdMedia.watchResponsiveAttributes(['md-colspan', 'md-rowspan'],
	        attrs, angular.bind(gridCtrl, gridCtrl.invalidateLayout));
	
	    // Tile registration/deregistration
	    gridCtrl.invalidateTiles();
	    scope.$on('$destroy', function() {
	      // Mark the tile as destroyed so it is no longer considered in layout,
	      // even if the DOM element sticks around (like during a leave animation)
	      element[0].$$mdDestroyed = true;
	      unwatchAttrs();
	      gridCtrl.invalidateLayout();
	    });
	
	    if (angular.isDefined(scope.$parent.$index)) {
	      scope.$watch(function() { return scope.$parent.$index; },
	        function indexChanged(newIdx, oldIdx) {
	          if (newIdx === oldIdx) {
	            return;
	          }
	          gridCtrl.invalidateTiles();
	        });
	    }
	  }
	}
	
	
	function GridTileCaptionDirective() {
	  return {
	    template: '<figcaption ng-transclude></figcaption>',
	    transclude: true
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.icon
	 * @description
	 * Icon
	 */
	angular.module('material.components.icon', ['material.core']);
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.input
	 */
	mdInputContainerDirective.$inject = ["$mdTheming", "$parse"];
	inputTextareaDirective.$inject = ["$mdUtil", "$window", "$mdAria", "$timeout", "$mdGesture"];
	mdMaxlengthDirective.$inject = ["$animate", "$mdUtil"];
	placeholderDirective.$inject = ["$compile"];
	ngMessageDirective.$inject = ["$mdUtil"];
	mdSelectOnFocusDirective.$inject = ["$timeout"];
	mdInputInvalidMessagesAnimation.$inject = ["$$AnimateRunner", "$animateCss", "$mdUtil", "$log"];
	ngMessagesAnimation.$inject = ["$$AnimateRunner", "$animateCss", "$mdUtil", "$log"];
	ngMessageAnimation.$inject = ["$$AnimateRunner", "$animateCss", "$mdUtil", "$log"];
	var inputModule = angular.module('material.components.input', [
	    'material.core'
	  ])
	  .directive('mdInputContainer', mdInputContainerDirective)
	  .directive('label', labelDirective)
	  .directive('input', inputTextareaDirective)
	  .directive('textarea', inputTextareaDirective)
	  .directive('mdMaxlength', mdMaxlengthDirective)
	  .directive('placeholder', placeholderDirective)
	  .directive('ngMessages', ngMessagesDirective)
	  .directive('ngMessage', ngMessageDirective)
	  .directive('ngMessageExp', ngMessageDirective)
	  .directive('mdSelectOnFocus', mdSelectOnFocusDirective)
	
	  .animation('.md-input-invalid', mdInputInvalidMessagesAnimation)
	  .animation('.md-input-messages-animation', ngMessagesAnimation)
	  .animation('.md-input-message-animation', ngMessageAnimation);
	
	// If we are running inside of tests; expose some extra services so that we can test them
	if (window._mdMocksIncluded) {
	  inputModule.service('$$mdInput', function() {
	    return {
	      // special accessor to internals... useful for testing
	      messages: {
	        show        : showInputMessages,
	        hide        : hideInputMessages,
	        getElement  : getMessagesElement
	      }
	    }
	  })
	
	  // Register a service for each animation so that we can easily inject them into unit tests
	  .service('mdInputInvalidAnimation', mdInputInvalidMessagesAnimation)
	  .service('mdInputMessagesAnimation', ngMessagesAnimation)
	  .service('mdInputMessageAnimation', ngMessageAnimation);
	}
	
	/**
	 * @ngdoc directive
	 * @name mdInputContainer
	 * @module material.components.input
	 *
	 * @restrict E
	 *
	 * @description
	 * `<md-input-container>` is the parent of any input or textarea element.
	 *
	 * Input and textarea elements will not behave properly unless the md-input-container
	 * parent is provided.
	 *
	 * A single `<md-input-container>` should contain only one `<input>` element, otherwise it will throw an error.
	 *
	 * <b>Exception:</b> Hidden inputs (`<input type="hidden" />`) are ignored and will not throw an error, so
	 * you may combine these with other inputs.
	 *
	 * <b>Note:</b> When using `ngMessages` with your input element, make sure the message and container elements
	 * are *block* elements, otherwise animations applied to the messages will not look as intended. Either use a `div` and
	 * apply the `ng-message` and `ng-messages` classes respectively, or use the `md-block` class on your element.
	 *
	 * @param md-is-error {expression=} When the given expression evaluates to true, the input container
	 *   will go into error state. Defaults to erroring if the input has been touched and is invalid.
	 * @param md-no-float {boolean=} When present, `placeholder` attributes on the input will not be converted to floating
	 *   labels.
	 *
	 * @usage
	 * <hljs lang="html">
	 *
	 * <md-input-container>
	 *   <label>Username</label>
	 *   <input type="text" ng-model="user.name">
	 * </md-input-container>
	 *
	 * <md-input-container>
	 *   <label>Description</label>
	 *   <textarea ng-model="user.description"></textarea>
	 * </md-input-container>
	 *
	 * </hljs>
	 *
	 * <h3>When disabling floating labels</h3>
	 * <hljs lang="html">
	 *
	 * <md-input-container md-no-float>
	 *   <input type="text" placeholder="Non-Floating Label">
	 * </md-input-container>
	 *
	 * </hljs>
	 */
	function mdInputContainerDirective($mdTheming, $parse) {
	
	  ContainerCtrl.$inject = ["$scope", "$element", "$attrs", "$animate"];
	  var INPUT_TAGS = ['INPUT', 'TEXTAREA', 'SELECT', 'MD-SELECT'];
	
	  var LEFT_SELECTORS = INPUT_TAGS.reduce(function(selectors, isel) {
	    return selectors.concat(['md-icon ~ ' + isel, '.md-icon ~ ' + isel]);
	  }, []).join(",");
	
	  var RIGHT_SELECTORS = INPUT_TAGS.reduce(function(selectors, isel) {
	    return selectors.concat([isel + ' ~ md-icon', isel + ' ~ .md-icon']);
	  }, []).join(",");
	
	  return {
	    restrict: 'E',
	    compile: compile,
	    controller: ContainerCtrl
	  };
	
	  function compile(tElement) {
	    // Check for both a left & right icon
	    var leftIcon = tElement[0].querySelector(LEFT_SELECTORS);
	    var rightIcon = tElement[0].querySelector(RIGHT_SELECTORS);
	
	    if (leftIcon) { tElement.addClass('md-icon-left'); }
	    if (rightIcon) { tElement.addClass('md-icon-right'); }
	
	    return function postLink(scope, element) {
	      $mdTheming(element);
	    };
	  }
	
	  function ContainerCtrl($scope, $element, $attrs, $animate) {
	    var self = this;
	
	    self.isErrorGetter = $attrs.mdIsError && $parse($attrs.mdIsError);
	
	    self.delegateClick = function() {
	      self.input.focus();
	    };
	    self.element = $element;
	    self.setFocused = function(isFocused) {
	      $element.toggleClass('md-input-focused', !!isFocused);
	    };
	    self.setHasValue = function(hasValue) {
	      $element.toggleClass('md-input-has-value', !!hasValue);
	    };
	    self.setHasPlaceholder = function(hasPlaceholder) {
	      $element.toggleClass('md-input-has-placeholder', !!hasPlaceholder);
	    };
	    self.setInvalid = function(isInvalid) {
	      if (isInvalid) {
	        $animate.addClass($element, 'md-input-invalid');
	      } else {
	        $animate.removeClass($element, 'md-input-invalid');
	      }
	    };
	    $scope.$watch(function() {
	      return self.label && self.input;
	    }, function(hasLabelAndInput) {
	      if (hasLabelAndInput && !self.label.attr('for')) {
	        self.label.attr('for', self.input.attr('id'));
	      }
	    });
	  }
	}
	
	function labelDirective() {
	  return {
	    restrict: 'E',
	    require: '^?mdInputContainer',
	    link: function(scope, element, attr, containerCtrl) {
	      if (!containerCtrl || attr.mdNoFloat || element.hasClass('md-container-ignore')) return;
	
	      containerCtrl.label = element;
	      scope.$on('$destroy', function() {
	        containerCtrl.label = null;
	      });
	    }
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name mdInput
	 * @restrict E
	 * @module material.components.input
	 *
	 * @description
	 * You can use any `<input>` or `<textarea>` element as a child of an `<md-input-container>`. This
	 * allows you to build complex forms for data entry.
	 *
	 * When the input is required and uses a floating label, then the label will automatically contain
	 * an asterisk (`*`).<br/>
	 * This behavior can be disabled by using the `md-no-asterisk` attribute.
	 *
	 * @param {number=} md-maxlength The maximum number of characters allowed in this input. If this is
	 *   specified, a character counter will be shown underneath the input.<br/><br/>
	 *   The purpose of **`md-maxlength`** is exactly to show the max length counter text. If you don't
	 *   want the counter text and only need "plain" validation, you can use the "simple" `ng-maxlength`
	 *   or maxlength attributes.<br/><br/>
	 *   **Note:** Only valid for text/string inputs (not numeric).
	 *
	 * @param {string=} aria-label Aria-label is required when no label is present.  A warning message
	 *   will be logged in the console if not present.
	 * @param {string=} placeholder An alternative approach to using aria-label when the label is not
	 *   PRESENT. The placeholder text is copied to the aria-label attribute.
	 * @param md-no-autogrow {boolean=} When present, textareas will not grow automatically.
	 * @param md-no-asterisk {boolean=} When present, an asterisk will not be appended to the inputs floating label
	 * @param md-no-resize {boolean=} Disables the textarea resize handle.
	 * @param {number=} max-rows The maximum amount of rows for a textarea.
	 * @param md-detect-hidden {boolean=} When present, textareas will be sized properly when they are
	 *   revealed after being hidden. This is off by default for performance reasons because it
	 *   guarantees a reflow every digest cycle.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-input-container>
	 *   <label>Color</label>
	 *   <input type="text" ng-model="color" required md-maxlength="10">
	 * </md-input-container>
	 * </hljs>
	 *
	 * <h3>With Errors</h3>
	 *
	 * `md-input-container` also supports errors using the standard `ng-messages` directives and
	 * animates the messages when they become visible using from the `ngEnter`/`ngLeave` events or
	 * the `ngShow`/`ngHide` events.
	 *
	 * By default, the messages will be hidden until the input is in an error state. This is based off
	 * of the `md-is-error` expression of the `md-input-container`. This gives the user a chance to
	 * fill out the form before the errors become visible.
	 *
	 * <hljs lang="html">
	 * <form name="colorForm">
	 *   <md-input-container>
	 *     <label>Favorite Color</label>
	 *     <input name="favoriteColor" ng-model="favoriteColor" required>
	 *     <div ng-messages="colorForm.favoriteColor.$error">
	 *       <div ng-message="required">This is required!</div>
	 *     </div>
	 *   </md-input-container>
	 * </form>
	 * </hljs>
	 *
	 * We automatically disable this auto-hiding functionality if you provide any of the following
	 * visibility directives on the `ng-messages` container:
	 *
	 *  - `ng-if`
	 *  - `ng-show`/`ng-hide`
	 *  - `ng-switch-when`/`ng-switch-default`
	 *
	 * You can also disable this functionality manually by adding the `md-auto-hide="false"` expression
	 * to the `ng-messages` container. This may be helpful if you always want to see the error messages
	 * or if you are building your own visibilty directive.
	 *
	 * _<b>Note:</b> The `md-auto-hide` attribute is a static string that is  only checked upon
	 * initialization of the `ng-messages` directive to see if it equals the string `false`._
	 *
	 * <hljs lang="html">
	 * <form name="userForm">
	 *   <md-input-container>
	 *     <label>Last Name</label>
	 *     <input name="lastName" ng-model="lastName" required md-maxlength="10" minlength="4">
	 *     <div ng-messages="userForm.lastName.$error" ng-show="userForm.lastName.$dirty">
	 *       <div ng-message="required">This is required!</div>
	 *       <div ng-message="md-maxlength">That's too long!</div>
	 *       <div ng-message="minlength">That's too short!</div>
	 *     </div>
	 *   </md-input-container>
	 *   <md-input-container>
	 *     <label>Biography</label>
	 *     <textarea name="bio" ng-model="biography" required md-maxlength="150"></textarea>
	 *     <div ng-messages="userForm.bio.$error" ng-show="userForm.bio.$dirty">
	 *       <div ng-message="required">This is required!</div>
	 *       <div ng-message="md-maxlength">That's too long!</div>
	 *     </div>
	 *   </md-input-container>
	 *   <md-input-container>
	 *     <input aria-label='title' ng-model='title'>
	 *   </md-input-container>
	 *   <md-input-container>
	 *     <input placeholder='title' ng-model='title'>
	 *   </md-input-container>
	 * </form>
	 * </hljs>
	 *
	 * <h3>Notes</h3>
	 *
	 * - Requires [ngMessages](https://docs.angularjs.org/api/ngMessages).
	 * - Behaves like the [AngularJS input directive](https://docs.angularjs.org/api/ng/directive/input).
	 *
	 * The `md-input` and `md-input-container` directives use very specific positioning to achieve the
	 * error animation effects. Therefore, it is *not* advised to use the Layout system inside of the
	 * `<md-input-container>` tags. Instead, use relative or absolute positioning.
	 *
	 *
	 * <h3>Textarea directive</h3>
	 * The `textarea` element within a `md-input-container` has the following specific behavior:
	 * - By default the `textarea` grows as the user types. This can be disabled via the `md-no-autogrow`
	 * attribute.
	 * - If a `textarea` has the `rows` attribute, it will treat the `rows` as the minimum height and will
	 * continue growing as the user types. For example a textarea with `rows="3"` will be 3 lines of text
	 * high initially. If no rows are specified, the directive defaults to 1.
	 * - The textarea's height gets set on initialization, as well as while the user is typing. In certain situations
	 * (e.g. while animating) the directive might have been initialized, before the element got it's final height. In
	 * those cases, you can trigger a resize manually by broadcasting a `md-resize-textarea` event on the scope.
	 * - If you want a `textarea` to stop growing at a certain point, you can specify the `max-rows` attribute.
	 * - The textarea's bottom border acts as a handle which users can drag, in order to resize the element vertically.
	 * Once the user has resized a `textarea`, the autogrowing functionality becomes disabled. If you don't want a
	 * `textarea` to be resizeable by the user, you can add the `md-no-resize` attribute.
	 */
	
	function inputTextareaDirective($mdUtil, $window, $mdAria, $timeout, $mdGesture) {
	  return {
	    restrict: 'E',
	    require: ['^?mdInputContainer', '?ngModel', '?^form'],
	    link: postLink
	  };
	
	  function postLink(scope, element, attr, ctrls) {
	
	    var containerCtrl = ctrls[0];
	    var hasNgModel = !!ctrls[1];
	    var ngModelCtrl = ctrls[1] || $mdUtil.fakeNgModel();
	    var parentForm = ctrls[2];
	    var isReadonly = angular.isDefined(attr.readonly);
	    var mdNoAsterisk = $mdUtil.parseAttributeBoolean(attr.mdNoAsterisk);
	    var tagName = element[0].tagName.toLowerCase();
	
	
	    if (!containerCtrl) return;
	    if (attr.type === 'hidden') {
	      element.attr('aria-hidden', 'true');
	      return;
	    } else if (containerCtrl.input) {
	      if (containerCtrl.input[0].contains(element[0])) {
	        return;
	      } else {
	        throw new Error("<md-input-container> can only have *one* <input>, <textarea> or <md-select> child element!");
	      }
	    }
	    containerCtrl.input = element;
	
	    setupAttributeWatchers();
	
	    // Add an error spacer div after our input to provide space for the char counter and any ng-messages
	    var errorsSpacer = angular.element('<div class="md-errors-spacer">');
	    element.after(errorsSpacer);
	
	    if (!containerCtrl.label) {
	      $mdAria.expect(element, 'aria-label', attr.placeholder);
	    }
	
	    element.addClass('md-input');
	    if (!element.attr('id')) {
	      element.attr('id', 'input_' + $mdUtil.nextUid());
	    }
	
	    // This works around a Webkit issue where number inputs, placed in a flexbox, that have
	    // a `min` and `max` will collapse to about 1/3 of their proper width. Please check #7349
	    // for more info. Also note that we don't override the `step` if the user has specified it,
	    // in order to prevent some unexpected behaviour.
	    if (tagName === 'input' && attr.type === 'number' && attr.min && attr.max && !attr.step) {
	      element.attr('step', 'any');
	    } else if (tagName === 'textarea') {
	      setupTextarea();
	    }
	
	    // If the input doesn't have an ngModel, it may have a static value. For that case,
	    // we have to do one initial check to determine if the container should be in the
	    // "has a value" state.
	    if (!hasNgModel) {
	      inputCheckValue();
	    }
	
	    var isErrorGetter = containerCtrl.isErrorGetter || function() {
	      return ngModelCtrl.$invalid && (ngModelCtrl.$touched || (parentForm && parentForm.$submitted));
	    };
	
	    scope.$watch(isErrorGetter, containerCtrl.setInvalid);
	
	    // When the developer uses the ngValue directive for the input, we have to observe the attribute, because
	    // AngularJS's ngValue directive is just setting the `value` attribute.
	    if (attr.ngValue) {
	      attr.$observe('value', inputCheckValue);
	    }
	
	    ngModelCtrl.$parsers.push(ngModelPipelineCheckValue);
	    ngModelCtrl.$formatters.push(ngModelPipelineCheckValue);
	
	    element.on('input', inputCheckValue);
	
	    if (!isReadonly) {
	      element
	        .on('focus', function(ev) {
	          $mdUtil.nextTick(function() {
	            containerCtrl.setFocused(true);
	          });
	        })
	        .on('blur', function(ev) {
	          $mdUtil.nextTick(function() {
	            containerCtrl.setFocused(false);
	            inputCheckValue();
	          });
	        });
	    }
	
	    scope.$on('$destroy', function() {
	      containerCtrl.setFocused(false);
	      containerCtrl.setHasValue(false);
	      containerCtrl.input = null;
	    });
	
	    /** Gets run through ngModel's pipeline and set the `has-value` class on the container. */
	    function ngModelPipelineCheckValue(arg) {
	      containerCtrl.setHasValue(!ngModelCtrl.$isEmpty(arg));
	      return arg;
	    }
	
	    function setupAttributeWatchers() {
	      if (containerCtrl.label) {
	        attr.$observe('required', function (value) {
	          // We don't need to parse the required value, it's always a boolean because of angular's
	          // required directive.
	          containerCtrl.label.toggleClass('md-required', value && !mdNoAsterisk);
	        });
	      }
	    }
	
	    function inputCheckValue() {
	      // An input's value counts if its length > 0,
	      // or if the input's validity state says it has bad input (eg string in a number input)
	      containerCtrl.setHasValue(element.val().length > 0 || (element[0].validity || {}).badInput);
	    }
	
	    function setupTextarea() {
	      var isAutogrowing = !attr.hasOwnProperty('mdNoAutogrow');
	
	      attachResizeHandle();
	
	      if (!isAutogrowing) return;
	
	      // Can't check if height was or not explicity set,
	      // so rows attribute will take precedence if present
	      var minRows = attr.hasOwnProperty('rows') ? parseInt(attr.rows) : NaN;
	      var maxRows = attr.hasOwnProperty('maxRows') ? parseInt(attr.maxRows) : NaN;
	      var scopeResizeListener = scope.$on('md-resize-textarea', growTextarea);
	      var lineHeight = null;
	      var node = element[0];
	
	      // This timeout is necessary, because the browser needs a little bit
	      // of time to calculate the `clientHeight` and `scrollHeight`.
	      $timeout(function() {
	        $mdUtil.nextTick(growTextarea);
	      }, 10, false);
	
	      // We could leverage ngModel's $parsers here, however it
	      // isn't reliable, because AngularJS trims the input by default,
	      // which means that growTextarea won't fire when newlines and
	      // spaces are added.
	      element.on('input', growTextarea);
	
	      // We should still use the $formatters, because they fire when
	      // the value was changed from outside the textarea.
	      if (hasNgModel) {
	        ngModelCtrl.$formatters.push(formattersListener);
	      }
	
	      if (!minRows) {
	        element.attr('rows', 1);
	      }
	
	      angular.element($window).on('resize', growTextarea);
	      scope.$on('$destroy', disableAutogrow);
	
	      function growTextarea() {
	        // temporarily disables element's flex so its height 'runs free'
	        element
	          .attr('rows', 1)
	          .css('height', 'auto')
	          .addClass('md-no-flex');
	
	        var height = getHeight();
	
	        if (!lineHeight) {
	          // offsetHeight includes padding which can throw off our value
	          var originalPadding = element[0].style.padding || '';
	          lineHeight = element.css('padding', 0).prop('offsetHeight');
	          element[0].style.padding = originalPadding;
	        }
	
	        if (minRows && lineHeight) {
	          height = Math.max(height, lineHeight * minRows);
	        }
	
	        if (maxRows && lineHeight) {
	          var maxHeight = lineHeight * maxRows;
	
	          if (maxHeight < height) {
	            element.attr('md-no-autogrow', '');
	            height = maxHeight;
	          } else {
	            element.removeAttr('md-no-autogrow');
	          }
	        }
	
	        if (lineHeight) {
	          element.attr('rows', Math.round(height / lineHeight));
	        }
	
	        element
	          .css('height', height + 'px')
	          .removeClass('md-no-flex');
	      }
	
	      function getHeight() {
	        var offsetHeight = node.offsetHeight;
	        var line = node.scrollHeight - offsetHeight;
	        return offsetHeight + Math.max(line, 0);
	      }
	
	      function formattersListener(value) {
	        $mdUtil.nextTick(growTextarea);
	        return value;
	      }
	
	      function disableAutogrow() {
	        if (!isAutogrowing) return;
	
	        isAutogrowing = false;
	        angular.element($window).off('resize', growTextarea);
	        scopeResizeListener && scopeResizeListener();
	        element
	          .attr('md-no-autogrow', '')
	          .off('input', growTextarea);
	
	        if (hasNgModel) {
	          var listenerIndex = ngModelCtrl.$formatters.indexOf(formattersListener);
	
	          if (listenerIndex > -1) {
	            ngModelCtrl.$formatters.splice(listenerIndex, 1);
	          }
	        }
	      }
	
	      function attachResizeHandle() {
	        if (attr.hasOwnProperty('mdNoResize')) return;
	
	        var handle = angular.element('<div class="md-resize-handle"></div>');
	        var isDragging = false;
	        var dragStart = null;
	        var startHeight = 0;
	        var container = containerCtrl.element;
	        var dragGestureHandler = $mdGesture.register(handle, 'drag', { horizontal: false });
	
	
	        element.wrap('<div class="md-resize-wrapper">').after(handle);
	        handle.on('mousedown', onMouseDown);
	
	        container
	          .on('$md.dragstart', onDragStart)
	          .on('$md.drag', onDrag)
	          .on('$md.dragend', onDragEnd);
	
	        scope.$on('$destroy', function() {
	          handle
	            .off('mousedown', onMouseDown)
	            .remove();
	
	          container
	            .off('$md.dragstart', onDragStart)
	            .off('$md.drag', onDrag)
	            .off('$md.dragend', onDragEnd);
	
	          dragGestureHandler();
	          handle = null;
	          container = null;
	          dragGestureHandler = null;
	        });
	
	        function onMouseDown(ev) {
	          ev.preventDefault();
	          isDragging = true;
	          dragStart = ev.clientY;
	          startHeight = parseFloat(element.css('height')) || element.prop('offsetHeight');
	        }
	
	        function onDragStart(ev) {
	          if (!isDragging) return;
	          ev.preventDefault();
	          disableAutogrow();
	          container.addClass('md-input-resized');
	        }
	
	        function onDrag(ev) {
	          if (!isDragging) return;
	
	          element.css('height', (startHeight + ev.pointer.distanceY) + 'px');
	        }
	
	        function onDragEnd(ev) {
	          if (!isDragging) return;
	          isDragging = false;
	          container.removeClass('md-input-resized');
	        }
	      }
	
	      // Attach a watcher to detect when the textarea gets shown.
	      if (attr.hasOwnProperty('mdDetectHidden')) {
	
	        var handleHiddenChange = function() {
	          var wasHidden = false;
	
	          return function() {
	            var isHidden = node.offsetHeight === 0;
	
	            if (isHidden === false && wasHidden === true) {
	              growTextarea();
	            }
	
	            wasHidden = isHidden;
	          };
	        }();
	
	        // Check every digest cycle whether the visibility of the textarea has changed.
	        // Queue up to run after the digest cycle is complete.
	        scope.$watch(function() {
	          $mdUtil.nextTick(handleHiddenChange, false);
	          return true;
	        });
	      }
	    }
	  }
	}
	
	function mdMaxlengthDirective($animate, $mdUtil) {
	  return {
	    restrict: 'A',
	    require: ['ngModel', '^mdInputContainer'],
	    link: postLink
	  };
	
	  function postLink(scope, element, attr, ctrls) {
	    var maxlength;
	    var ngModelCtrl = ctrls[0];
	    var containerCtrl = ctrls[1];
	    var charCountEl, errorsSpacer;
	
	    // Wait until the next tick to ensure that the input has setup the errors spacer where we will
	    // append our counter
	    $mdUtil.nextTick(function() {
	      errorsSpacer = angular.element(containerCtrl.element[0].querySelector('.md-errors-spacer'));
	      charCountEl = angular.element('<div class="md-char-counter">');
	
	      // Append our character counter inside the errors spacer
	      errorsSpacer.append(charCountEl);
	
	      // Stop model from trimming. This makes it so whitespace
	      // over the maxlength still counts as invalid.
	      attr.$set('ngTrim', 'false');
	
	      scope.$watch(attr.mdMaxlength, function(value) {
	        maxlength = value;
	        if (angular.isNumber(value) && value > 0) {
	          if (!charCountEl.parent().length) {
	            $animate.enter(charCountEl, errorsSpacer);
	          }
	          renderCharCount();
	        } else {
	          $animate.leave(charCountEl);
	        }
	      });
	
	      ngModelCtrl.$validators['md-maxlength'] = function(modelValue, viewValue) {
	        if (!angular.isNumber(maxlength) || maxlength < 0) {
	          return true;
	        }
	
	        // We always update the char count, when the modelValue has changed.
	        // Using the $validators for triggering the update works very well.
	        renderCharCount();
	
	        return ( modelValue || element.val() || viewValue || '' ).length <= maxlength;
	      };
	    });
	
	    function renderCharCount(value) {
	      // If we have not been appended to the body yet; do not render
	      if (!charCountEl.parent) {
	        return value;
	      }
	
	      // Force the value into a string since it may be a number,
	      // which does not have a length property.
	      charCountEl.text(String(element.val() || value || '').length + ' / ' + maxlength);
	      return value;
	    }
	  }
	}
	
	function placeholderDirective($compile) {
	  return {
	    restrict: 'A',
	    require: '^^?mdInputContainer',
	    priority: 200,
	    link: {
	      // Note that we need to do this in the pre-link, as opposed to the post link, if we want to
	      // support data bindings in the placeholder. This is necessary, because we have a case where
	      // we transfer the placeholder value to the `<label>` and we remove it from the original `<input>`.
	      // If we did this in the post-link, AngularJS would have set up the observers already and would be
	      // re-adding the attribute, even though we removed it from the element.
	      pre: preLink
	    }
	  };
	
	  function preLink(scope, element, attr, inputContainer) {
	    // If there is no input container, just return
	    if (!inputContainer) return;
	
	    var label = inputContainer.element.find('label');
	    var noFloat = inputContainer.element.attr('md-no-float');
	
	    // If we have a label, or they specify the md-no-float attribute, just return
	    if ((label && label.length) || noFloat === '' || scope.$eval(noFloat)) {
	      // Add a placeholder class so we can target it in the CSS
	      inputContainer.setHasPlaceholder(true);
	      return;
	    }
	
	    // md-select handles placeholders on it's own
	    if (element[0].nodeName != 'MD-SELECT') {
	      // Move the placeholder expression to the label
	      var newLabel = angular.element('<label ng-click="delegateClick()" tabindex="-1">' + attr.placeholder + '</label>');
	
	      // Note that we unset it via `attr`, in order to get AngularJS
	      // to remove any observers that it might have set up. Otherwise
	      // the attribute will be added on the next digest.
	      attr.$set('placeholder', null);
	
	      // We need to compile the label manually in case it has any bindings.
	      // A gotcha here is that we first add the element to the DOM and we compile
	      // it later. This is necessary, because if we compile the element beforehand,
	      // it won't be able to find the `mdInputContainer` controller.
	      inputContainer.element
	        .addClass('md-icon-float')
	        .prepend(newLabel);
	
	      $compile(newLabel)(scope);
	    }
	  }
	}
	
	/**
	 * @ngdoc directive
	 * @name mdSelectOnFocus
	 * @module material.components.input
	 *
	 * @restrict A
	 *
	 * @description
	 * The `md-select-on-focus` directive allows you to automatically select the element's input text on focus.
	 *
	 * <h3>Notes</h3>
	 * - The use of `md-select-on-focus` is restricted to `<input>` and `<textarea>` elements.
	 *
	 * @usage
	 * <h3>Using with an Input</h3>
	 * <hljs lang="html">
	 *
	 * <md-input-container>
	 *   <label>Auto Select</label>
	 *   <input type="text" md-select-on-focus>
	 * </md-input-container>
	 * </hljs>
	 *
	 * <h3>Using with a Textarea</h3>
	 * <hljs lang="html">
	 *
	 * <md-input-container>
	 *   <label>Auto Select</label>
	 *   <textarea md-select-on-focus>This text will be selected on focus.</textarea>
	 * </md-input-container>
	 *
	 * </hljs>
	 */
	function mdSelectOnFocusDirective($timeout) {
	
	  return {
	    restrict: 'A',
	    link: postLink
	  };
	
	  function postLink(scope, element, attr) {
	    if (element[0].nodeName !== 'INPUT' && element[0].nodeName !== "TEXTAREA") return;
	
	    var preventMouseUp = false;
	
	    element
	      .on('focus', onFocus)
	      .on('mouseup', onMouseUp);
	
	    scope.$on('$destroy', function() {
	      element
	        .off('focus', onFocus)
	        .off('mouseup', onMouseUp);
	    });
	
	    function onFocus() {
	      preventMouseUp = true;
	
	      $timeout(function() {
	        // Use HTMLInputElement#select to fix firefox select issues.
	        // The debounce is here for Edge's sake, otherwise the selection doesn't work.
	        element[0].select();
	
	        // This should be reset from inside the `focus`, because the event might
	        // have originated from something different than a click, e.g. a keyboard event.
	        preventMouseUp = false;
	      }, 1, false);
	    }
	
	    // Prevents the default action of the first `mouseup` after a focus.
	    // This is necessary, because browsers fire a `mouseup` right after the element
	    // has been focused. In some browsers (Firefox in particular) this can clear the
	    // selection. There are examples of the problem in issue #7487.
	    function onMouseUp(event) {
	      if (preventMouseUp) {
	        event.preventDefault();
	      }
	    }
	  }
	}
	
	var visibilityDirectives = ['ngIf', 'ngShow', 'ngHide', 'ngSwitchWhen', 'ngSwitchDefault'];
	function ngMessagesDirective() {
	  return {
	    restrict: 'EA',
	    link: postLink,
	
	    // This is optional because we don't want target *all* ngMessage instances, just those inside of
	    // mdInputContainer.
	    require: '^^?mdInputContainer'
	  };
	
	  function postLink(scope, element, attrs, inputContainer) {
	    // If we are not a child of an input container, don't do anything
	    if (!inputContainer) return;
	
	    // Add our animation class
	    element.toggleClass('md-input-messages-animation', true);
	
	    // Add our md-auto-hide class to automatically hide/show messages when container is invalid
	    element.toggleClass('md-auto-hide', true);
	
	    // If we see some known visibility directives, remove the md-auto-hide class
	    if (attrs.mdAutoHide == 'false' || hasVisibiltyDirective(attrs)) {
	      element.toggleClass('md-auto-hide', false);
	    }
	  }
	
	  function hasVisibiltyDirective(attrs) {
	    return visibilityDirectives.some(function(attr) {
	      return attrs[attr];
	    });
	  }
	}
	
	function ngMessageDirective($mdUtil) {
	  return {
	    restrict: 'EA',
	    compile: compile,
	    priority: 100
	  };
	
	  function compile(tElement) {
	    if (!isInsideInputContainer(tElement)) {
	
	      // When the current element is inside of a document fragment, then we need to check for an input-container
	      // in the postLink, because the element will be later added to the DOM and is currently just in a temporary
	      // fragment, which causes the input-container check to fail.
	      if (isInsideFragment()) {
	        return function (scope, element) {
	          if (isInsideInputContainer(element)) {
	            // Inside of the postLink function, a ngMessage directive will be a comment element, because it's
	            // currently hidden. To access the shown element, we need to use the element from the compile function.
	            initMessageElement(tElement);
	          }
	        };
	      }
	    } else {
	      initMessageElement(tElement);
	    }
	
	    function isInsideFragment() {
	      var nextNode = tElement[0];
	      while (nextNode = nextNode.parentNode) {
	        if (nextNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
	          return true;
	        }
	      }
	      return false;
	    }
	
	    function isInsideInputContainer(element) {
	      return !!$mdUtil.getClosest(element, "md-input-container");
	    }
	
	    function initMessageElement(element) {
	      // Add our animation class
	      element.toggleClass('md-input-message-animation', true);
	    }
	  }
	}
	
	var $$AnimateRunner, $animateCss, $mdUtil, $log;
	
	function mdInputInvalidMessagesAnimation($$AnimateRunner, $animateCss, $mdUtil, $log) {
	  saveSharedServices($$AnimateRunner, $animateCss, $mdUtil, $log);
	
	  return {
	    addClass: function(element, className, done) {
	      showInputMessages(element, done);
	    }
	
	    // NOTE: We do not need the removeClass method, because the message ng-leave animation will fire
	  };
	}
	
	function ngMessagesAnimation($$AnimateRunner, $animateCss, $mdUtil, $log) {
	  saveSharedServices($$AnimateRunner, $animateCss, $mdUtil, $log);
	
	  return {
	    enter: function(element, done) {
	      showInputMessages(element, done);
	    },
	
	    leave: function(element, done) {
	      hideInputMessages(element, done);
	    },
	
	    addClass: function(element, className, done) {
	      if (className == "ng-hide") {
	        hideInputMessages(element, done);
	      } else {
	        done();
	      }
	    },
	
	    removeClass: function(element, className, done) {
	      if (className == "ng-hide") {
	        showInputMessages(element, done);
	      } else {
	        done();
	      }
	    }
	  };
	}
	
	function ngMessageAnimation($$AnimateRunner, $animateCss, $mdUtil, $log) {
	  saveSharedServices($$AnimateRunner, $animateCss, $mdUtil, $log);
	
	  return {
	    enter: function(element, done) {
	      var animator = showMessage(element);
	
	      animator.start().done(done);
	    },
	
	    leave: function(element, done) {
	      var animator = hideMessage(element);
	
	      animator.start().done(done);
	    }
	  };
	}
	
	function showInputMessages(element, done) {
	  var animators = [], animator;
	  var messages = getMessagesElement(element);
	  var children = messages.children();
	
	  if (messages.length == 0 || children.length == 0) {
	    $log.warn('mdInput messages show animation called on invalid messages element: ', element);
	    done();
	    return;
	  }
	
	  angular.forEach(children, function(child) {
	    animator = showMessage(angular.element(child));
	
	    animators.push(animator.start());
	  });
	
	  $$AnimateRunner.all(animators, done);
	}
	
	function hideInputMessages(element, done) {
	  var animators = [], animator;
	  var messages = getMessagesElement(element);
	  var children = messages.children();
	
	  if (messages.length == 0 || children.length == 0) {
	    $log.warn('mdInput messages hide animation called on invalid messages element: ', element);
	    done();
	    return;
	  }
	
	  angular.forEach(children, function(child) {
	    animator = hideMessage(angular.element(child));
	
	    animators.push(animator.start());
	  });
	
	  $$AnimateRunner.all(animators, done);
	}
	
	function showMessage(element) {
	  var height = parseInt(window.getComputedStyle(element[0]).height);
	  var topMargin = parseInt(window.getComputedStyle(element[0]).marginTop);
	
	  var messages = getMessagesElement(element);
	  var container = getInputElement(element);
	
	  // Check to see if the message is already visible so we can skip
	  var alreadyVisible = (topMargin > -height);
	
	  // If we have the md-auto-hide class, the md-input-invalid animation will fire, so we can skip
	  if (alreadyVisible || (messages.hasClass('md-auto-hide') && !container.hasClass('md-input-invalid'))) {
	    return $animateCss(element, {});
	  }
	
	  return $animateCss(element, {
	    event: 'enter',
	    structural: true,
	    from: {"opacity": 0, "margin-top": -height + "px"},
	    to: {"opacity": 1, "margin-top": "0"},
	    duration: 0.3
	  });
	}
	
	function hideMessage(element) {
	  var height = element[0].offsetHeight;
	  var styles = window.getComputedStyle(element[0]);
	
	  // If we are already hidden, just return an empty animation
	  if (parseInt(styles.opacity) === 0) {
	    return $animateCss(element, {});
	  }
	
	  // Otherwise, animate
	  return $animateCss(element, {
	    event: 'leave',
	    structural: true,
	    from: {"opacity": 1, "margin-top": 0},
	    to: {"opacity": 0, "margin-top": -height + "px"},
	    duration: 0.3
	  });
	}
	
	function getInputElement(element) {
	  var inputContainer = element.controller('mdInputContainer');
	
	  return inputContainer.element;
	}
	
	function getMessagesElement(element) {
	  // If we ARE the messages element, just return ourself
	  if (element.hasClass('md-input-messages-animation')) {
	    return element;
	  }
	
	  // If we are a ng-message element, we need to traverse up the DOM tree
	  if (element.hasClass('md-input-message-animation')) {
	    return angular.element($mdUtil.getClosest(element, function(node) {
	      return node.classList.contains('md-input-messages-animation');
	    }));
	  }
	
	  // Otherwise, we can traverse down
	  return angular.element(element[0].querySelector('.md-input-messages-animation'));
	}
	
	function saveSharedServices(_$$AnimateRunner_, _$animateCss_, _$mdUtil_, _$log_) {
	  $$AnimateRunner = _$$AnimateRunner_;
	  $animateCss = _$animateCss_;
	  $mdUtil = _$mdUtil_;
	  $log = _$log_;
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.list
	 * @description
	 * List module
	 */
	MdListController.$inject = ["$scope", "$element", "$mdListInkRipple"];
	mdListDirective.$inject = ["$mdTheming"];
	mdListItemDirective.$inject = ["$mdAria", "$mdConstant", "$mdUtil", "$timeout"];
	angular.module('material.components.list', [
	  'material.core'
	])
	  .controller('MdListController', MdListController)
	  .directive('mdList', mdListDirective)
	  .directive('mdListItem', mdListItemDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdList
	 * @module material.components.list
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-list>` directive is a list container for 1..n `<md-list-item>` tags.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-list>
	 *   <md-list-item class="md-2-line" ng-repeat="item in todos">
	 *     <md-checkbox ng-model="item.done"></md-checkbox>
	 *     <div class="md-list-item-text">
	 *       <h3>{{item.title}}</h3>
	 *       <p>{{item.description}}</p>
	 *     </div>
	 *   </md-list-item>
	 * </md-list>
	 * </hljs>
	 */
	
	function mdListDirective($mdTheming) {
	  return {
	    restrict: 'E',
	    compile: function(tEl) {
	      tEl[0].setAttribute('role', 'list');
	      return $mdTheming;
	    }
	  };
	}
	/**
	 * @ngdoc directive
	 * @name mdListItem
	 * @module material.components.list
	 *
	 * @restrict E
	 *
	 * @description
	 * A `md-list-item` element can be used to represent some information in a row.<br/>
	 *
	 * @usage
	 * ### Single Row Item
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <span>Single Row Item</span>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * ### Multiple Lines
	 * By using the following markup, you will be able to have two lines inside of one `md-list-item`.
	 *
	 * <hljs lang="html">
	 *   <md-list-item class="md-2-line">
	 *     <div class="md-list-item-text" layout="column">
	 *       <p>First Line</p>
	 *       <p>Second Line</p>
	 *     </div>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * It is also possible to have three lines inside of one list item.
	 *
	 * <hljs lang="html">
	 *   <md-list-item class="md-3-line">
	 *     <div class="md-list-item-text" layout="column">
	 *       <p>First Line</p>
	 *       <p>Second Line</p>
	 *       <p>Third Line</p>
	 *     </div>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * ### Secondary Items
	 * Secondary items are elements which will be aligned at the end of the `md-list-item`.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <span>Single Row Item</span>
	 *     <md-button class="md-secondary">
	 *       Secondary Button
	 *     </md-button>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * It also possible to have multiple secondary items inside of one `md-list-item`.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <span>Single Row Item</span>
	 *     <md-button class="md-secondary">First Button</md-button>
	 *     <md-button class="md-secondary">Second Button</md-button>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * ### Proxy Item
	 * Proxies are elements, which will execute their specific action on click<br/>
	 * Currently supported proxy items are
	 * - `md-checkbox` (Toggle)
	 * - `md-switch` (Toggle)
	 * - `md-menu` (Open)
	 *
	 * This means, when using a supported proxy item inside of `md-list-item`, the list item will
	 * automatically become clickable and executes the associated action of the proxy element on click.
	 *
	 * It is possible to disable this behavior by applying the `md-no-proxy` class to the list item.
	 *
	 * <hljs lang="html">
	 *   <md-list-item class="md-no-proxy">
	 *     <span>No Proxy List</span>
	 *     <md-checkbox class="md-secondary"></md-checkbox>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * Here are a few examples of proxy elements inside of a list item.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <span>First Line</span>
	 *     <md-checkbox class="md-secondary"></md-checkbox>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * The `md-checkbox` element will be automatically detected as a proxy element and will toggle on click.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <span>First Line</span>
	 *     <md-switch class="md-secondary"></md-switch>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * The recognized `md-switch` will toggle its state, when the user clicks on the `md-list-item`.
	 *
	 * It is also possible to have a `md-menu` inside of a `md-list-item`.
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <p>Click anywhere to fire the secondary action</p>
	 *     <md-menu class="md-secondary">
	 *       <md-button class="md-icon-button">
	 *         <md-icon md-svg-icon="communication:message"></md-icon>
	 *       </md-button>
	 *       <md-menu-content width="4">
	 *         <md-menu-item>
	 *           <md-button>
	 *             Redial
	 *           </md-button>
	 *         </md-menu-item>
	 *         <md-menu-item>
	 *           <md-button>
	 *             Check voicemail
	 *           </md-button>
	 *         </md-menu-item>
	 *         <md-menu-divider></md-menu-divider>
	 *         <md-menu-item>
	 *           <md-button>
	 *             Notifications
	 *           </md-button>
	 *         </md-menu-item>
	 *       </md-menu-content>
	 *     </md-menu>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * The menu will automatically open, when the users clicks on the `md-list-item`.<br/>
	 *
	 * If the developer didn't specify any position mode on the menu, the `md-list-item` will automatically detect the
	 * position mode and applies it to the `md-menu`.
	 *
	 * ### Avatars
	 * Sometimes you may want to have some avatars inside of the `md-list-item `.<br/>
	 * You are able to create a optimized icon for the list item, by applying the `.md-avatar` class on the `<img>` element.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <img src="my-avatar.png" class="md-avatar">
	 *     <span>Alan Turing</span>
	 * </hljs>
	 *
	 * When using `<md-icon>` for an avatar, you have to use the `.md-avatar-icon` class.
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <md-icon class="md-avatar-icon" md-svg-icon="avatars:timothy"></md-icon>
	 *     <span>Timothy Kopra</span>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * In cases, you have a `md-list-item`, which doesn't have any avatar,
	 * but you want to align it with the other avatar items, you have to use the `.md-offset` class.
	 *
	 * <hljs lang="html">
	 *   <md-list-item class="md-offset">
	 *     <span>Jon Doe</span>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * ### DOM modification
	 * The `md-list-item` component automatically detects if the list item should be clickable.
	 *
	 * ---
	 * If the `md-list-item` is clickable, we wrap all content inside of a `<div>` and create
	 * an overlaying button, which will will execute the given actions (like `ng-href`, `ng-click`)
	 *
	 * We create an overlaying button, instead of wrapping all content inside of the button,
	 * because otherwise some elements may not be clickable inside of the button.
	 *
	 * ---
	 * When using a secondary item inside of your list item, the `md-list-item` component will automatically create
	 * a secondary container at the end of the `md-list-item`, which contains all secondary items.
	 *
	 * The secondary item container is not static, because otherwise the overflow will not work properly on the
	 * list item.
	 *
	 */
	function mdListItemDirective($mdAria, $mdConstant, $mdUtil, $timeout) {
	  var proxiedTypes = ['md-checkbox', 'md-switch', 'md-menu'];
	  return {
	    restrict: 'E',
	    controller: 'MdListController',
	    compile: function(tEl, tAttrs) {
	
	      // Check for proxy controls (no ng-click on parent, and a control inside)
	      var secondaryItems = tEl[0].querySelectorAll('.md-secondary');
	      var hasProxiedElement;
	      var proxyElement;
	      var itemContainer = tEl;
	
	      tEl[0].setAttribute('role', 'listitem');
	
	      if (tAttrs.ngClick || tAttrs.ngDblclick ||  tAttrs.ngHref || tAttrs.href || tAttrs.uiSref || tAttrs.ngAttrUiSref) {
	        wrapIn('button');
	      } else if (!tEl.hasClass('md-no-proxy')) {
	
	        for (var i = 0, type; type = proxiedTypes[i]; ++i) {
	          if (proxyElement = tEl[0].querySelector(type)) {
	            hasProxiedElement = true;
	            break;
	          }
	        }
	
	        if (hasProxiedElement) {
	          wrapIn('div');
	        } else {
	          tEl.addClass('md-no-proxy');
	        }
	
	      }
	
	      wrapSecondaryItems();
	      setupToggleAria();
	
	      if (hasProxiedElement && proxyElement.nodeName === "MD-MENU") {
	        setupProxiedMenu();
	      }
	
	      function setupToggleAria() {
	        var toggleTypes = ['md-switch', 'md-checkbox'];
	        var toggle;
	
	        for (var i = 0, toggleType; toggleType = toggleTypes[i]; ++i) {
	          if (toggle = tEl.find(toggleType)[0]) {
	            if (!toggle.hasAttribute('aria-label')) {
	              var p = tEl.find('p')[0];
	              if (!p) return;
	              toggle.setAttribute('aria-label', 'Toggle ' + p.textContent);
	            }
	          }
	        }
	      }
	
	      function setupProxiedMenu() {
	        var menuEl = angular.element(proxyElement);
	
	        var isEndAligned = menuEl.parent().hasClass('md-secondary-container') ||
	                           proxyElement.parentNode.firstElementChild !== proxyElement;
	
	        var xAxisPosition = 'left';
	
	        if (isEndAligned) {
	          // When the proxy item is aligned at the end of the list, we have to set the origin to the end.
	          xAxisPosition = 'right';
	        }
	
	        // Set the position mode / origin of the proxied menu.
	        if (!menuEl.attr('md-position-mode')) {
	          menuEl.attr('md-position-mode', xAxisPosition + ' target');
	        }
	
	        // Apply menu open binding to menu button
	        var menuOpenButton = menuEl.children().eq(0);
	        if (!hasClickEvent(menuOpenButton[0])) {
	          menuOpenButton.attr('ng-click', '$mdMenu.open($event)');
	        }
	
	        if (!menuOpenButton.attr('aria-label')) {
	          menuOpenButton.attr('aria-label', 'Open List Menu');
	        }
	      }
	
	      function wrapIn(type) {
	        if (type == 'div') {
	          itemContainer = angular.element('<div class="md-no-style md-list-item-inner">');
	          itemContainer.append(tEl.contents());
	          tEl.addClass('md-proxy-focus');
	        } else {
	          // Element which holds the default list-item content.
	          itemContainer = angular.element(
	            '<div class="md-button md-no-style">'+
	            '   <div class="md-list-item-inner"></div>'+
	            '</div>'
	          );
	
	          // Button which shows ripple and executes primary action.
	          var buttonWrap = angular.element(
	            '<md-button class="md-no-style"></md-button>'
	          );
	
	          copyAttributes(tEl[0], buttonWrap[0]);
	
	          // If there is no aria-label set on the button (previously copied over if present)
	          // we determine the label from the content and copy it to the button.
	          if (!buttonWrap.attr('aria-label')) {
	            buttonWrap.attr('aria-label', $mdAria.getText(tEl));
	          }
	
	          // We allow developers to specify the `md-no-focus` class, to disable the focus style
	          // on the button executor. Once more classes should be forwarded, we should probably make the
	          // class forward more generic.
	          if (tEl.hasClass('md-no-focus')) {
	            buttonWrap.addClass('md-no-focus');
	          }
	
	          // Append the button wrap before our list-item content, because it will overlay in relative.
	          itemContainer.prepend(buttonWrap);
	          itemContainer.children().eq(1).append(tEl.contents());
	
	          tEl.addClass('_md-button-wrap');
	        }
	
	        tEl[0].setAttribute('tabindex', '-1');
	        tEl.append(itemContainer);
	      }
	
	      function wrapSecondaryItems() {
	        var secondaryItemsWrapper = angular.element('<div class="md-secondary-container">');
	
	        angular.forEach(secondaryItems, function(secondaryItem) {
	          wrapSecondaryItem(secondaryItem, secondaryItemsWrapper);
	        });
	
	        itemContainer.append(secondaryItemsWrapper);
	      }
	
	      function wrapSecondaryItem(secondaryItem, container) {
	        // If the current secondary item is not a button, but contains a ng-click attribute,
	        // the secondary item will be automatically wrapped inside of a button.
	        if (secondaryItem && !isButton(secondaryItem) && secondaryItem.hasAttribute('ng-click')) {
	
	          $mdAria.expect(secondaryItem, 'aria-label');
	          var buttonWrapper = angular.element('<md-button class="md-secondary md-icon-button">');
	
	          // Copy the attributes from the secondary item to the generated button.
	          // We also support some additional attributes from the secondary item,
	          // because some developers may use a ngIf, ngHide, ngShow on their item.
	          copyAttributes(secondaryItem, buttonWrapper[0], ['ng-if', 'ng-hide', 'ng-show']);
	
	          secondaryItem.setAttribute('tabindex', '-1');
	          buttonWrapper.append(secondaryItem);
	
	          secondaryItem = buttonWrapper[0];
	        }
	
	        if (secondaryItem && (!hasClickEvent(secondaryItem) || (!tAttrs.ngClick && isProxiedElement(secondaryItem)))) {
	          // In this case we remove the secondary class, so we can identify it later, when we searching for the
	          // proxy items.
	          angular.element(secondaryItem).removeClass('md-secondary');
	        }
	
	        tEl.addClass('md-with-secondary');
	        container.append(secondaryItem);
	      }
	
	      /**
	       * Copies attributes from a source element to the destination element
	       * By default the function will copy the most necessary attributes, supported
	       * by the button executor for clickable list items.
	       * @param source Element with the specified attributes
	       * @param destination Element which will retrieve the attributes
	       * @param extraAttrs Additional attributes, which will be copied over.
	       */
	      function copyAttributes(source, destination, extraAttrs) {
	        var copiedAttrs = $mdUtil.prefixer([
	          'ng-if', 'ng-click', 'ng-dblclick', 'aria-label', 'ng-disabled', 'ui-sref',
	          'href', 'ng-href', 'target', 'ng-attr-ui-sref', 'ui-sref-opts'
	        ]);
	
	        if (extraAttrs) {
	          copiedAttrs = copiedAttrs.concat($mdUtil.prefixer(extraAttrs));
	        }
	
	        angular.forEach(copiedAttrs, function(attr) {
	          if (source.hasAttribute(attr)) {
	            destination.setAttribute(attr, source.getAttribute(attr));
	            source.removeAttribute(attr);
	          }
	        });
	      }
	
	      function isProxiedElement(el) {
	        return proxiedTypes.indexOf(el.nodeName.toLowerCase()) != -1;
	      }
	
	      function isButton(el) {
	        var nodeName = el.nodeName.toUpperCase();
	
	        return nodeName == "MD-BUTTON" || nodeName == "BUTTON";
	      }
	
	      function hasClickEvent (element) {
	        var attr = element.attributes;
	        for (var i = 0; i < attr.length; i++) {
	          if (tAttrs.$normalize(attr[i].name) === 'ngClick') return true;
	        }
	        return false;
	      }
	
	      return postLink;
	
	      function postLink($scope, $element, $attr, ctrl) {
	        $element.addClass('_md');     // private md component indicator for styling
	
	        var proxies       = [],
	            firstElement  = $element[0].firstElementChild,
	            isButtonWrap  = $element.hasClass('_md-button-wrap'),
	            clickChild    = isButtonWrap ? firstElement.firstElementChild : firstElement,
	            hasClick      = clickChild && hasClickEvent(clickChild),
	            noProxies     = $element.hasClass('md-no-proxy');
	
	        computeProxies();
	        computeClickable();
	
	        if (proxies.length) {
	          angular.forEach(proxies, function(proxy) {
	            proxy = angular.element(proxy);
	
	            $scope.mouseActive = false;
	            proxy.on('mousedown', function() {
	              $scope.mouseActive = true;
	              $timeout(function(){
	                $scope.mouseActive = false;
	              }, 100);
	            })
	            .on('focus', function() {
	              if ($scope.mouseActive === false) { $element.addClass('md-focused'); }
	              proxy.on('blur', function proxyOnBlur() {
	                $element.removeClass('md-focused');
	                proxy.off('blur', proxyOnBlur);
	              });
	            });
	          });
	        }
	
	
	        function computeProxies() {
	
	          if (firstElement && firstElement.children && !hasClick && !noProxies) {
	
	            angular.forEach(proxiedTypes, function(type) {
	
	              // All elements which are not capable for being used a proxy have the .md-secondary class
	              // applied. These items had been sorted out in the secondary wrap function.
	              angular.forEach(firstElement.querySelectorAll(type + ':not(.md-secondary)'), function(child) {
	                proxies.push(child);
	              });
	            });
	
	          }
	        }
	
	        function computeClickable() {
	          if (proxies.length == 1 || hasClick) {
	            $element.addClass('md-clickable');
	
	            if (!hasClick) {
	              ctrl.attachRipple($scope, angular.element($element[0].querySelector('.md-no-style')));
	            }
	          }
	        }
	
	        function isEventFromControl(event) {
	          var forbiddenControls = ['md-slider'];
	
	          // If there is no path property in the event, then we can assume that the event was not bubbled.
	          if (!event.path) {
	            return forbiddenControls.indexOf(event.target.tagName.toLowerCase()) !== -1;
	          }
	
	          // We iterate the event path up and check for a possible component.
	          // Our maximum index to search, is the list item root.
	          var maxPath = event.path.indexOf($element.children()[0]);
	
	          for (var i = 0; i < maxPath; i++) {
	            if (forbiddenControls.indexOf(event.path[i].tagName.toLowerCase()) !== -1) {
	              return true;
	            }
	          }
	        }
	
	        var clickChildKeypressListener = function(e) {
	          if (e.target.nodeName != 'INPUT' && e.target.nodeName != 'TEXTAREA' && !e.target.isContentEditable) {
	            var keyCode = e.which || e.keyCode;
	            if (keyCode == $mdConstant.KEY_CODE.SPACE) {
	              if (clickChild) {
	                clickChild.click();
	                e.preventDefault();
	                e.stopPropagation();
	              }
	            }
	          }
	        };
	
	        if (!hasClick && !proxies.length) {
	          clickChild && clickChild.addEventListener('keypress', clickChildKeypressListener);
	        }
	
	        $element.off('click');
	        $element.off('keypress');
	
	        if (proxies.length == 1 && clickChild) {
	          $element.children().eq(0).on('click', function(e) {
	            // When the event is coming from an control and it should not trigger the proxied element
	            // then we are skipping.
	            if (isEventFromControl(e)) return;
	
	            var parentButton = $mdUtil.getClosest(e.target, 'BUTTON');
	            if (!parentButton && clickChild.contains(e.target)) {
	              angular.forEach(proxies, function(proxy) {
	                if (e.target !== proxy && !proxy.contains(e.target)) {
	                  if (proxy.nodeName === 'MD-MENU') {
	                    proxy = proxy.children[0];
	                  }
	                  angular.element(proxy).triggerHandler('click');
	                }
	              });
	            }
	          });
	        }
	
	        $scope.$on('$destroy', function () {
	          clickChild && clickChild.removeEventListener('keypress', clickChildKeypressListener);
	        });
	      }
	    }
	  };
	}
	
	/*
	 * @private
	 * @ngdoc controller
	 * @name MdListController
	 * @module material.components.list
	 *
	 */
	function MdListController($scope, $element, $mdListInkRipple) {
	  var ctrl = this;
	  ctrl.attachRipple = attachRipple;
	
	  function attachRipple (scope, element) {
	    var options = {};
	    $mdListInkRipple.attach(scope, element, options);
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.menu
	 */
	
	angular.module('material.components.menu', [
	  'material.core',
	  'material.components.backdrop'
	]);
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.menuBar
	 */
	
	angular.module('material.components.menuBar', [
	  'material.core',
	  'material.components.icon',
	  'material.components.menu'
	]);
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.navBar
	 */
	
	
	MdNavBarController.$inject = ["$element", "$scope", "$timeout", "$mdConstant"];
	MdNavItem.$inject = ["$mdAria", "$$rAF"];
	MdNavItemController.$inject = ["$element"];
	MdNavBar.$inject = ["$mdAria", "$mdTheming"];
	angular.module('material.components.navBar', ['material.core'])
	    .controller('MdNavBarController', MdNavBarController)
	    .directive('mdNavBar', MdNavBar)
	    .controller('MdNavItemController', MdNavItemController)
	    .directive('mdNavItem', MdNavItem);
	
	
	/*****************************************************************************
	 *                            PUBLIC DOCUMENTATION                           *
	 *****************************************************************************/
	/**
	 * @ngdoc directive
	 * @name mdNavBar
	 * @module material.components.navBar
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-nav-bar>` directive renders a list of material tabs that can be used
	 * for top-level page navigation. Unlike `<md-tabs>`, it has no concept of a tab
	 * body and no bar pagination.
	 *
	 * Because it deals with page navigation, certain routing concepts are built-in.
	 * Route changes via via ng-href, ui-sref, or ng-click events are supported.
	 * Alternatively, the user could simply watch currentNavItem for changes.
	 *
	 * Accessibility functionality is implemented as a site navigator with a
	 * listbox, according to
	 * https://www.w3.org/TR/wai-aria-practices/#Site_Navigator_Tabbed_Style
	 *
	 * @param {string=} mdSelectedNavItem The name of the current tab; this must
	 *     match the name attribute of `<md-nav-item>`
	 * @param {boolean=} mdNoInkBar If set to true, the ink bar will be hidden.
	 * @param {string=} navBarAriaLabel An aria-label for the nav-bar
	 *
	 * @usage
	 * <hljs lang="html">
	 *  <md-nav-bar md-selected-nav-item="currentNavItem">
	 *    <md-nav-item md-nav-click="goto('page1')" name="page1">
	 *      Page One
	 *    </md-nav-item>
	 *    <md-nav-item md-nav-href="#page2" name="page3">Page Two</md-nav-item>
	 *    <md-nav-item md-nav-sref="page3" name="page2">Page Three</md-nav-item>
	 *    <md-nav-item
	 *      md-nav-sref="app.page4"
	 *      sref-opts="{reload: true, notify: true}"
	 *      name="page4">
	 *      Page Four
	 *    </md-nav-item>
	 *  </md-nav-bar>
	 *</hljs>
	 * <hljs lang="js">
	 * (function() {
	 *   'use strict';
	 *
	 *    $rootScope.$on('$routeChangeSuccess', function(event, current) {
	 *      $scope.currentLink = getCurrentLinkFromRoute(current);
	 *    });
	 * });
	 * </hljs>
	 */
	
	/*****************************************************************************
	 *                            mdNavItem
	 *****************************************************************************/
	/**
	 * @ngdoc directive
	 * @name mdNavItem
	 * @module material.components.navBar
	 *
	 * @restrict E
	 *
	 * @description
	 * `<md-nav-item>` describes a page navigation link within the `<md-nav-bar>`
	 * component. It renders an md-button as the actual link.
	 *
	 * Exactly one of the mdNavClick, mdNavHref, mdNavSref attributes are required
	 * to be specified.
	 *
	 * @param {Function=} mdNavClick Function which will be called when the
	 *     link is clicked to change the page. Renders as an `ng-click`.
	 * @param {string=} mdNavHref url to transition to when this link is clicked.
	 *     Renders as an `ng-href`.
	 * @param {string=} mdNavSref Ui-router state to transition to when this link is
	 *     clicked. Renders as a `ui-sref`.
	 * @param {!Object=} srefOpts Ui-router options that are passed to the
	 *     `$state.go()` function. See the [Ui-router documentation for details]
	 *     (https://ui-router.github.io/docs/latest/interfaces/transition.transitionoptions.html).
	 * @param {string=} name The name of this link. Used by the nav bar to know
	 *     which link is currently selected.
	 * @param {string=} aria-label Adds alternative text for accessibility
	 *
	 * @usage
	 * See `<md-nav-bar>` for usage.
	 */
	
	
	/*****************************************************************************
	 *                                IMPLEMENTATION                             *
	 *****************************************************************************/
	
	function MdNavBar($mdAria, $mdTheming) {
	  return {
	    restrict: 'E',
	    transclude: true,
	    controller: MdNavBarController,
	    controllerAs: 'ctrl',
	    bindToController: true,
	    scope: {
	      'mdSelectedNavItem': '=?',
	      'mdNoInkBar': '=?',
	      'navBarAriaLabel': '@?',
	    },
	    template:
	      '<div class="md-nav-bar">' +
	        '<nav role="navigation">' +
	          '<ul class="_md-nav-bar-list" ng-transclude role="listbox"' +
	            'tabindex="0"' +
	            'ng-focus="ctrl.onFocus()"' +
	            'ng-keydown="ctrl.onKeydown($event)"' +
	            'aria-label="{{ctrl.navBarAriaLabel}}">' +
	          '</ul>' +
	        '</nav>' +
	        '<md-nav-ink-bar ng-hide="ctrl.mdNoInkBar"></md-nav-ink-bar>' +
	      '</div>',
	    link: function(scope, element, attrs, ctrl) {
	      $mdTheming(element);
	      if (!ctrl.navBarAriaLabel) {
	        $mdAria.expectAsync(element, 'aria-label', angular.noop);
	      }
	    },
	  };
	}
	
	/**
	 * Controller for the nav-bar component.
	 *
	 * Accessibility functionality is implemented as a site navigator with a
	 * listbox, according to
	 * https://www.w3.org/TR/wai-aria-practices/#Site_Navigator_Tabbed_Style
	 * @param {!angular.JQLite} $element
	 * @param {!angular.Scope} $scope
	 * @param {!angular.Timeout} $timeout
	 * @param {!Object} $mdConstant
	 * @constructor
	 * @final
	 * @ngInject
	 */
	function MdNavBarController($element, $scope, $timeout, $mdConstant) {
	  // Injected variables
	  /** @private @const {!angular.Timeout} */
	  this._$timeout = $timeout;
	
	  /** @private @const {!angular.Scope} */
	  this._$scope = $scope;
	
	  /** @private @const {!Object} */
	  this._$mdConstant = $mdConstant;
	
	  // Data-bound variables.
	  /** @type {string} */
	  this.mdSelectedNavItem;
	
	  /** @type {string} */
	  this.navBarAriaLabel;
	
	  // State variables.
	
	  /** @type {?angular.JQLite} */
	  this._navBarEl = $element[0];
	
	  /** @type {?angular.JQLite} */
	  this._inkbar;
	
	  var self = this;
	  // need to wait for transcluded content to be available
	  var deregisterTabWatch = this._$scope.$watch(function() {
	    return self._navBarEl.querySelectorAll('._md-nav-button').length;
	  },
	  function(newLength) {
	    if (newLength > 0) {
	      self._initTabs();
	      deregisterTabWatch();
	    }
	  });
	}
	
	
	
	/**
	 * Initializes the tab components once they exist.
	 * @private
	 */
	MdNavBarController.prototype._initTabs = function() {
	  this._inkbar = angular.element(this._navBarEl.querySelector('md-nav-ink-bar'));
	
	  var self = this;
	  this._$timeout(function() {
	    self._updateTabs(self.mdSelectedNavItem, undefined);
	  });
	
	  this._$scope.$watch('ctrl.mdSelectedNavItem', function(newValue, oldValue) {
	    // Wait a digest before update tabs for products doing
	    // anything dynamic in the template.
	    self._$timeout(function() {
	      self._updateTabs(newValue, oldValue);
	    });
	  });
	};
	
	/**
	 * Set the current tab to be selected.
	 * @param {string|undefined} newValue New current tab name.
	 * @param {string|undefined} oldValue Previous tab name.
	 * @private
	 */
	MdNavBarController.prototype._updateTabs = function(newValue, oldValue) {
	  var self = this;
	  var tabs = this._getTabs();
	
	  // this._getTabs can return null if nav-bar has not yet been initialized
	  if(!tabs)
	    return;
	
	  var oldIndex = -1;
	  var newIndex = -1;
	  var newTab = this._getTabByName(newValue);
	  var oldTab = this._getTabByName(oldValue);
	
	  if (oldTab) {
	    oldTab.setSelected(false);
	    oldIndex = tabs.indexOf(oldTab);
	  }
	
	  if (newTab) {
	    newTab.setSelected(true);
	    newIndex = tabs.indexOf(newTab);
	  }
	
	  this._$timeout(function() {
	    self._updateInkBarStyles(newTab, newIndex, oldIndex);
	  });
	};
	
	/**
	 * Repositions the ink bar to the selected tab.
	 * @private
	 */
	MdNavBarController.prototype._updateInkBarStyles = function(tab, newIndex, oldIndex) {
	  this._inkbar.toggleClass('_md-left', newIndex < oldIndex)
	      .toggleClass('_md-right', newIndex > oldIndex);
	
	  this._inkbar.css({display: newIndex < 0 ? 'none' : ''});
	
	  if (tab) {
	    var tabEl = tab.getButtonEl();
	    var left = tabEl.offsetLeft;
	
	    this._inkbar.css({left: left + 'px', width: tabEl.offsetWidth + 'px'});
	  }
	};
	
	/**
	 * Returns an array of the current tabs.
	 * @return {!Array<!NavItemController>}
	 * @private
	 */
	MdNavBarController.prototype._getTabs = function() {
	  var controllers = Array.prototype.slice.call(
	    this._navBarEl.querySelectorAll('.md-nav-item'))
	    .map(function(el) {
	      return angular.element(el).controller('mdNavItem')
	    });
	  return controllers.indexOf(undefined) ? controllers : null;
	};
	
	/**
	 * Returns the tab with the specified name.
	 * @param {string} name The name of the tab, found in its name attribute.
	 * @return {!NavItemController|undefined}
	 * @private
	 */
	MdNavBarController.prototype._getTabByName = function(name) {
	  return this._findTab(function(tab) {
	    return tab.getName() == name;
	  });
	};
	
	/**
	 * Returns the selected tab.
	 * @return {!NavItemController|undefined}
	 * @private
	 */
	MdNavBarController.prototype._getSelectedTab = function() {
	  return this._findTab(function(tab) {
	    return tab.isSelected();
	  });
	};
	
	/**
	 * Returns the focused tab.
	 * @return {!NavItemController|undefined}
	 */
	MdNavBarController.prototype.getFocusedTab = function() {
	  return this._findTab(function(tab) {
	    return tab.hasFocus();
	  });
	};
	
	/**
	 * Find a tab that matches the specified function.
	 * @private
	 */
	MdNavBarController.prototype._findTab = function(fn) {
	  var tabs = this._getTabs();
	  for (var i = 0; i < tabs.length; i++) {
	    if (fn(tabs[i])) {
	      return tabs[i];
	    }
	  }
	
	  return null;
	};
	
	/**
	 * Direct focus to the selected tab when focus enters the nav bar.
	 */
	MdNavBarController.prototype.onFocus = function() {
	  var tab = this._getSelectedTab();
	  if (tab) {
	    tab.setFocused(true);
	  }
	};
	
	/**
	 * Move focus from oldTab to newTab.
	 * @param {!NavItemController} oldTab
	 * @param {!NavItemController} newTab
	 * @private
	 */
	MdNavBarController.prototype._moveFocus = function(oldTab, newTab) {
	  oldTab.setFocused(false);
	  newTab.setFocused(true);
	};
	
	/**
	 * Responds to keypress events.
	 * @param {!Event} e
	 */
	MdNavBarController.prototype.onKeydown = function(e) {
	  var keyCodes = this._$mdConstant.KEY_CODE;
	  var tabs = this._getTabs();
	  var focusedTab = this.getFocusedTab();
	  if (!focusedTab) return;
	
	  var focusedTabIndex = tabs.indexOf(focusedTab);
	
	  // use arrow keys to navigate between tabs
	  switch (e.keyCode) {
	    case keyCodes.UP_ARROW:
	    case keyCodes.LEFT_ARROW:
	      if (focusedTabIndex > 0) {
	        this._moveFocus(focusedTab, tabs[focusedTabIndex - 1]);
	      }
	      break;
	    case keyCodes.DOWN_ARROW:
	    case keyCodes.RIGHT_ARROW:
	      if (focusedTabIndex < tabs.length - 1) {
	        this._moveFocus(focusedTab, tabs[focusedTabIndex + 1]);
	      }
	      break;
	    case keyCodes.SPACE:
	    case keyCodes.ENTER:
	      // timeout to avoid a "digest already in progress" console error
	      this._$timeout(function() {
	        focusedTab.getButtonEl().click();
	      });
	      break;
	  }
	};
	
	/**
	 * @ngInject
	 */
	function MdNavItem($mdAria, $$rAF) {
	  return {
	    restrict: 'E',
	    require: ['mdNavItem', '^mdNavBar'],
	    controller: MdNavItemController,
	    bindToController: true,
	    controllerAs: 'ctrl',
	    replace: true,
	    transclude: true,
	    template: function(tElement, tAttrs) {
	      var hasNavClick = tAttrs.mdNavClick;
	      var hasNavHref = tAttrs.mdNavHref;
	      var hasNavSref = tAttrs.mdNavSref;
	      var hasSrefOpts = tAttrs.srefOpts;
	      var navigationAttribute;
	      var navigationOptions;
	      var buttonTemplate;
	
	      // Cannot specify more than one nav attribute
	      if ((hasNavClick ? 1:0) + (hasNavHref ? 1:0) + (hasNavSref ? 1:0) > 1) {
	        throw Error(
	          'Must not specify more than one of the md-nav-click, md-nav-href, ' +
	          'or md-nav-sref attributes per nav-item directive.'
	        );
	      }
	
	      if (hasNavClick) {
	        navigationAttribute = 'ng-click="ctrl.mdNavClick()"';
	      } else if (hasNavHref) {
	        navigationAttribute = 'ng-href="{{ctrl.mdNavHref}}"';
	      } else if (hasNavSref) {
	        navigationAttribute = 'ui-sref="{{ctrl.mdNavSref}}"';
	      }
	
	      navigationOptions = hasSrefOpts ? 'ui-sref-opts="{{ctrl.srefOpts}}" ' : '';
	
	      if (navigationAttribute) {
	        buttonTemplate = '' +
	          '<md-button class="_md-nav-button md-accent" ' +
	            'ng-class="ctrl.getNgClassMap()" ' +
	            'ng-blur="ctrl.setFocused(false)" ' +
	            'tabindex="-1" ' +
	            navigationOptions +
	            navigationAttribute + '>' +
	            '<span ng-transclude class="_md-nav-button-text"></span>' +
	          '</md-button>';
	      }
	
	      return '' +
	        '<li class="md-nav-item" ' +
	          'role="option" ' +
	          'aria-selected="{{ctrl.isSelected()}}">' +
	          (buttonTemplate || '') +
	        '</li>';
	    },
	    scope: {
	      'mdNavClick': '&?',
	      'mdNavHref': '@?',
	      'mdNavSref': '@?',
	      'srefOpts': '=?',
	      'name': '@',
	    },
	    link: function(scope, element, attrs, controllers) {
	      // When accessing the element's contents synchronously, they
	      // may not be defined yet because of transclusion. There is a higher
	      // chance that it will be accessible if we wait one frame.
	      $$rAF(function() {
	        var mdNavItem = controllers[0];
	        var mdNavBar = controllers[1];
	        var navButton = angular.element(element[0].querySelector('._md-nav-button'));
	
	        if (!mdNavItem.name) {
	          mdNavItem.name = angular.element(element[0]
	              .querySelector('._md-nav-button-text')).text().trim();
	        }
	
	        navButton.on('click', function() {
	          mdNavBar.mdSelectedNavItem = mdNavItem.name;
	          scope.$apply();
	        });
	
	        $mdAria.expectWithText(element, 'aria-label');
	      });
	    }
	  };
	}
	
	/**
	 * Controller for the nav-item component.
	 * @param {!angular.JQLite} $element
	 * @constructor
	 * @final
	 * @ngInject
	 */
	function MdNavItemController($element) {
	
	  /** @private @const {!angular.JQLite} */
	  this._$element = $element;
	
	  // Data-bound variables
	
	  /** @const {?Function} */
	  this.mdNavClick;
	
	  /** @const {?string} */
	  this.mdNavHref;
	
	  /** @const {?string} */
	  this.mdNavSref;
	  /** @const {?Object} */
	  this.srefOpts;
	  /** @const {?string} */
	  this.name;
	
	  // State variables
	  /** @private {boolean} */
	  this._selected = false;
	
	  /** @private {boolean} */
	  this._focused = false;
	}
	
	/**
	 * Returns a map of class names and values for use by ng-class.
	 * @return {!Object<string,boolean>}
	 */
	MdNavItemController.prototype.getNgClassMap = function() {
	  return {
	    'md-active': this._selected,
	    'md-primary': this._selected,
	    'md-unselected': !this._selected,
	    'md-focused': this._focused,
	  };
	};
	
	/**
	 * Get the name attribute of the tab.
	 * @return {string}
	 */
	MdNavItemController.prototype.getName = function() {
	  return this.name;
	};
	
	/**
	 * Get the button element associated with the tab.
	 * @return {!Element}
	 */
	MdNavItemController.prototype.getButtonEl = function() {
	  return this._$element[0].querySelector('._md-nav-button');
	};
	
	/**
	 * Set the selected state of the tab.
	 * @param {boolean} isSelected
	 */
	MdNavItemController.prototype.setSelected = function(isSelected) {
	  this._selected = isSelected;
	};
	
	/**
	 * @return {boolean}
	 */
	MdNavItemController.prototype.isSelected = function() {
	  return this._selected;
	};
	
	/**
	 * Set the focused state of the tab.
	 * @param {boolean} isFocused
	 */
	MdNavItemController.prototype.setFocused = function(isFocused) {
	  this._focused = isFocused;
	
	  if (isFocused) {
	    this.getButtonEl().focus();
	  }
	};
	
	/**
	 * @return {boolean}
	 */
	MdNavItemController.prototype.hasFocus = function() {
	  return this._focused;
	};
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.progressCircular
	 * @description Module for a circular progressbar
	 */
	
	angular.module('material.components.progressCircular', ['material.core']);
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.panel
	 */
	MdPanelService.$inject = ["presets", "$rootElement", "$rootScope", "$injector", "$window"];
	angular
	  .module('material.components.panel', [
	    'material.core',
	    'material.components.backdrop'
	  ])
	  .provider('$mdPanel', MdPanelProvider);
	
	
	/*****************************************************************************
	 *                            PUBLIC DOCUMENTATION                           *
	 *****************************************************************************/
	
	
	/**
	 * @ngdoc service
	 * @name $mdPanelProvider
	 * @module material.components.panel
	 *
	 * @description
	 * `$mdPanelProvider` allows users to create configuration presets that will be
	 * stored within a cached presets object. When the configuration is needed, the
	 * user can request the preset by passing it as the first parameter in the
	 * `$mdPanel.create` or `$mdPanel.open` methods.
	 *
	 * @usage
	 * <hljs lang="js">
	 * (function(angular, undefined) {
	 *   'use strict';
	 *
	 *   angular
	 *       .module('demoApp', ['ngMaterial'])
	 *       .config(DemoConfig)
	 *       .controller('DemoCtrl', DemoCtrl)
	 *       .controller('DemoMenuCtrl', DemoMenuCtrl);
	 *
	 *   function DemoConfig($mdPanelProvider) {
	 *     $mdPanelProvider.definePreset('demoPreset', {
	 *       attachTo: angular.element(document.body),
	 *       controller: DemoMenuCtrl,
	 *       controllerAs: 'ctrl',
	 *       template: '' +
	 *           '<div class="menu-panel" md-whiteframe="4">' +
	 *           '  <div class="menu-content">' +
	 *           '    <div class="menu-item" ng-repeat="item in ctrl.items">' +
	 *           '      <button class="md-button">' +
	 *           '        <span>{{item}}</span>' +
	 *           '      </button>' +
	 *           '    </div>' +
	 *           '    <md-divider></md-divider>' +
	 *           '    <div class="menu-item">' +
	 *           '      <button class="md-button" ng-click="ctrl.closeMenu()">' +
	 *           '        <span>Close Menu</span>' +
	 *           '      </button>' +
	 *           '    </div>' +
	 *           '  </div>' +
	 *           '</div>',
	 *       panelClass: 'menu-panel-container',
	 *       focusOnOpen: false,
	 *       zIndex: 100,
	 *       propagateContainerEvents: true,
	 *       groupName: 'menus'
	 *     });
	 *   }
	 *
	 *   function PanelProviderCtrl($mdPanel) {
	 *     this.navigation = {
	 *       name: 'navigation',
	 *       items: [
	 *         'Home',
	 *         'About',
	 *         'Contact'
	 *       ]
	 *     };
	 *     this.favorites = {
	 *       name: 'favorites',
	 *       items: [
	 *         'Add to Favorites'
	 *       ]
	 *     };
	 *     this.more = {
	 *       name: 'more',
	 *       items: [
	 *         'Account',
	 *         'Sign Out'
	 *       ]
	 *     };
	 *
	 *     $mdPanel.newPanelGroup('menus', {
	 *       maxOpen: 2
	 *     });
	 *
	 *     this.showMenu = function($event, menu) {
	 *       $mdPanel.open('demoPreset', {
	 *         id: 'menu_' + menu.name,
	 *         position: $mdPanel.newPanelPosition()
	 *             .relativeTo($event.srcElement)
	 *             .addPanelPosition(
	 *               $mdPanel.xPosition.ALIGN_START,
	 *               $mdPanel.yPosition.BELOW
	 *             ),
	 *         locals: {
	 *           items: menu.items
	 *         },
	 *         openFrom: $event
	 *       });
	 *     };
	 *   }
	 *
	 *   function PanelMenuCtrl(mdPanelRef) {
	 *     this.closeMenu = function() {
	 *       mdPanelRef && mdPanelRef.close();
	 *     };
	 *   }
	 * })(angular);
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdPanelProvider#definePreset
	 * @description
	 * Takes the passed in preset name and preset configuration object and adds it
	 * to the `_presets` object of the provider. This `_presets` object is then
	 * passed along to the `$mdPanel` service.
	 *
	 * @param {string} name Preset name.
	 * @param {!Object} preset Specific configuration object that can contain any
	 *     and all of the parameters avaialble within the `$mdPanel.create` method.
	 *     However, parameters that pertain to id, position, animation, and user
	 *     interaction are not allowed and will be removed from the preset
	 *     configuration.
	 */
	
	
	/*****************************************************************************
	 *                               MdPanel Service                             *
	 *****************************************************************************/
	
	
	/**
	 * @ngdoc service
	 * @name $mdPanel
	 * @module material.components.panel
	 *
	 * @description
	 * `$mdPanel` is a robust, low-level service for creating floating panels on
	 * the screen. It can be used to implement tooltips, dialogs, pop-ups, etc.
	 *
	 * @usage
	 * <hljs lang="js">
	 * (function(angular, undefined) {
	 *   'use strict';
	 *
	 *   angular
	 *       .module('demoApp', ['ngMaterial'])
	 *       .controller('DemoDialogController', DialogController);
	 *
	 *   var panelRef;
	 *
	 *   function showPanel($event) {
	 *     var panelPosition = $mdPanel.newPanelPosition()
	 *         .absolute()
	 *         .top('50%')
	 *         .left('50%');
	 *
	 *     var panelAnimation = $mdPanel.newPanelAnimation()
	 *         .targetEvent($event)
	 *         .defaultAnimation('md-panel-animate-fly')
	 *         .closeTo('.show-button');
	 *
	 *     var config = {
	 *       attachTo: angular.element(document.body),
	 *       controller: DialogController,
	 *       controllerAs: 'ctrl',
	 *       position: panelPosition,
	 *       animation: panelAnimation,
	 *       targetEvent: $event,
	 *       templateUrl: 'dialog-template.html',
	 *       clickOutsideToClose: true,
	 *       escapeToClose: true,
	 *       focusOnOpen: true
	 *     }
	 *
	 *     $mdPanel.open(config)
	 *         .then(function(result) {
	 *           panelRef = result;
	 *         });
	 *   }
	 *
	 *   function DialogController(MdPanelRef) {
	 *     function closeDialog() {
	 *       if (MdPanelRef) MdPanelRef.close();
	 *     }
	 *   }
	 * })(angular);
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdPanel#create
	 * @description
	 * Creates a panel with the specified options.
	 *
	 * @param config {!Object=} Specific configuration object that may contain the
	 *     following properties:
	 *
	 *   - `id` - `{string=}`: An ID to track the panel by. When an ID is provided,
	 *     the created panel is added to a tracked panels object. Any subsequent
	 *     requests made to create a panel with that ID are ignored. This is useful
	 *     in having the panel service not open multiple panels from the same user
	 *     interaction when there is no backdrop and events are propagated. Defaults
	 *     to an arbitrary string that is not tracked.
	 *   - `template` - `{string=}`: HTML template to show in the panel. This
	 *     **must** be trusted HTML with respect to AngularJS’s
	 *     [$sce service](https://docs.angularjs.org/api/ng/service/$sce).
	 *   - `templateUrl` - `{string=}`: The URL that will be used as the content of
	 *     the panel.
	 *   - `contentElement` - `{(string|!angular.JQLite|!Element)=}`: Pre-compiled
	 *     element to be used as the panel's content.
	 *   - `controller` - `{(function|string)=}`: The controller to associate with
	 *     the panel. The controller can inject a reference to the returned
	 *     panelRef, which allows the panel to be closed, hidden, and shown. Any
	 *     fields passed in through locals or resolve will be bound to the
	 *     controller.
	 *   - `controllerAs` - `{string=}`: An alias to assign the controller to on
	 *     the scope.
	 *   - `bindToController` - `{boolean=}`: Binds locals to the controller
	 *     instead of passing them in. Defaults to true, as this is a best
	 *     practice.
	 *   - `locals` - `{Object=}`: An object containing key/value pairs. The keys
	 *     will be used as names of values to inject into the controller. For
	 *     example, `locals: {three: 3}` would inject `three` into the controller,
	 *     with the value 3.
	 *   - `resolve` - `{Object=}`: Similar to locals, except it takes promises as
	 *     values. The panel will not open until all of the promises resolve.
	 *   - `attachTo` - `{(string|!angular.JQLite|!Element)=}`: The element to
	 *     attach the panel to. Defaults to appending to the root element of the
	 *     application.
	 *   - `propagateContainerEvents` - `{boolean=}`: Whether pointer or touch
	 *     events should be allowed to propagate 'go through' the container, aka the
	 *     wrapper, of the panel. Defaults to false.
	 *   - `panelClass` - `{string=}`: A css class to apply to the panel element.
	 *     This class should define any borders, box-shadow, etc. for the panel.
	 *   - `zIndex` - `{number=}`: The z-index to place the panel at.
	 *     Defaults to 80.
	 *   - `position` - `{MdPanelPosition=}`: An MdPanelPosition object that
	 *     specifies the alignment of the panel. For more information, see
	 *     `MdPanelPosition`.
	 *   - `clickOutsideToClose` - `{boolean=}`: Whether the user can click
	 *     outside the panel to close it. Defaults to false.
	 *   - `escapeToClose` - `{boolean=}`: Whether the user can press escape to
	 *     close the panel. Defaults to false.
	 *   - `onCloseSuccess` - `{function(!panelRef, string)=}`: Function that is
	 *     called after the close successfully finishes. The first parameter passed
	 *     into this function is the current panelRef and the 2nd is an optional
	 *     string explaining the close reason. The currently supported closeReasons
	 *     can be found in the MdPanelRef.closeReasons enum. These are by default
	 *     passed along by the panel.
	 *   - `trapFocus` - `{boolean=}`: Whether focus should be trapped within the
	 *     panel. If `trapFocus` is true, the user will not be able to interact
	 *     with the rest of the page until the panel is dismissed. Defaults to
	 *     false.
	 *   - `focusOnOpen` - `{boolean=}`: An option to override focus behavior on
	 *     open. Only disable if focusing some other way, as focus management is
	 *     required for panels to be accessible. Defaults to true.
	 *   - `fullscreen` - `{boolean=}`: Whether the panel should be full screen.
	 *     Applies the class `._md-panel-fullscreen` to the panel on open. Defaults
	 *     to false.
	 *   - `animation` - `{MdPanelAnimation=}`: An MdPanelAnimation object that
	 *     specifies the animation of the panel. For more information, see
	 *     `MdPanelAnimation`.
	 *   - `hasBackdrop` - `{boolean=}`: Whether there should be an opaque backdrop
	 *     behind the panel. Defaults to false.
	 *   - `disableParentScroll` - `{boolean=}`: Whether the user can scroll the
	 *     page behind the panel. Defaults to false.
	 *   - `onDomAdded` - `{function=}`: Callback function used to announce when
	 *     the panel is added to the DOM.
	 *   - `onOpenComplete` - `{function=}`: Callback function used to announce
	 *     when the open() action is finished.
	 *   - `onRemoving` - `{function=}`: Callback function used to announce the
	 *     close/hide() action is starting.
	 *   - `onDomRemoved` - `{function=}`: Callback function used to announce when
	 *     the panel is removed from the DOM.
	 *   - `origin` - `{(string|!angular.JQLite|!Element)=}`: The element to focus
	 *     on when the panel closes. This is commonly the element which triggered
	 *     the opening of the panel. If you do not use `origin`, you need to control
	 *     the focus manually.
	 *   - `groupName` - `{(string|!Array<string>)=}`: A group name or an array of
	 *     group names. The group name is used for creating a group of panels. The
	 *     group is used for configuring the number of open panels and identifying
	 *     specific behaviors for groups. For instance, all tooltips could be
	 *     identified using the same groupName.
	 *
	 * @returns {!MdPanelRef} panelRef
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdPanel#open
	 * @description
	 * Calls the create method above, then opens the panel. This is a shortcut for
	 * creating and then calling open manually. If custom methods need to be
	 * called when the panel is added to the DOM or opened, do not use this method.
	 * Instead create the panel, chain promises on the domAdded and openComplete
	 * methods, and call open from the returned panelRef.
	 *
	 * @param {!Object=} config Specific configuration object that may contain
	 *     the properties defined in `$mdPanel.create`.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} panelRef A promise that resolves
	 *     to an instance of the panel.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdPanel#newPanelPosition
	 * @description
	 * Returns a new instance of the MdPanelPosition object. Use this to create
	 * the position config object.
	 *
	 * @returns {!MdPanelPosition} panelPosition
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdPanel#newPanelAnimation
	 * @description
	 * Returns a new instance of the MdPanelAnimation object. Use this to create
	 * the animation config object.
	 *
	 * @returns {!MdPanelAnimation} panelAnimation
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdPanel#newPanelGroup
	 * @description
	 * Creates a panel group and adds it to a tracked list of panel groups.
	 *
	 * @param {string} groupName Name of the group to create.
	 * @param {!Object=} config Specific configuration object that may contain the
	 *     following properties:
	 *
	 *   - `maxOpen` - `{number=}`: The maximum number of panels that are allowed to
	 *     be open within a defined panel group.
	 *
	 * @returns {!Object<string,
	 *     {panels: !Array<!MdPanelRef>,
	 *     openPanels: !Array<!MdPanelRef>,
	 *     maxOpen: number}>} panelGroup
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdPanel#setGroupMaxOpen
	 * @description
	 * Sets the maximum number of panels in a group that can be opened at a given
	 * time.
	 *
	 * @param {string} groupName The name of the group to configure.
	 * @param {number} maxOpen The maximum number of panels that can be
	 *     opened. Infinity can be passed in to remove the maxOpen limit.
	 */
	
	
	/*****************************************************************************
	 *                                 MdPanelRef                                *
	 *****************************************************************************/
	
	
	/**
	 * @ngdoc type
	 * @name MdPanelRef
	 * @module material.components.panel
	 * @description
	 * A reference to a created panel. This reference contains a unique id for the
	 * panel, along with the following properties:
	 *
	 *   - `id` - `{string}`: The unique id for the panel. This id is used to track
	 *     when a panel was interacted with.
	 *   - `config` - `{!Object=}`: The entire config object that was used in
	 *     create.
	 *   - `isAttached` - `{boolean}`: Whether the panel is attached to the DOM.
	 *     Visibility to the user does not factor into isAttached.
	 *   - `panelContainer` - `{angular.JQLite}`: The wrapper element containing the
	 *     panel. This property is added in order to have access to the `addClass`,
	 *     `removeClass`, `toggleClass`, etc methods.
	 *   - `panelEl` - `{angular.JQLite}`: The panel element. This property is added
	 *     in order to have access to the `addClass`, `removeClass`, `toggleClass`,
	 *     etc methods.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#open
	 * @description
	 * Attaches and shows the panel.
	 *
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel is
	 *     opened.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#close
	 * @description
	 * Hides and detaches the panel. Note that this will **not** destroy the panel.
	 * If you don't intend on using the panel again, call the {@link #destroy
	 * destroy} method afterwards.
	 *
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel is
	 *     closed.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#attach
	 * @description
	 * Create the panel elements and attach them to the DOM. The panel will be
	 * hidden by default.
	 *
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel is
	 *     attached.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#detach
	 * @description
	 * Removes the panel from the DOM. This will NOT hide the panel before removing
	 * it.
	 *
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel is
	 *     detached.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#show
	 * @description
	 * Shows the panel.
	 *
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel has
	 *     shown and animations are completed.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#hide
	 * @description
	 * Hides the panel.
	 *
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel has
	 *     hidden and animations are completed.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#destroy
	 * @description
	 * Destroys the panel. The panel cannot be opened again after this is called.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#addClass
	 * @deprecated
	 * This method is in the process of being deprecated in favor of using the panel
	 * and container JQLite elements that are referenced in the MdPanelRef object.
	 * Full deprecation is scheduled for material 1.2.
	 * @description
	 * Adds a class to the panel. DO NOT use this hide/show the panel.
	 *
	 * @param {string} newClass class to be added.
	 * @param {boolean} toElement Whether or not to add the class to the panel
	 *     element instead of the container.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#removeClass
	 * @deprecated
	 * This method is in the process of being deprecated in favor of using the panel
	 * and container JQLite elements that are referenced in the MdPanelRef object.
	 * Full deprecation is scheduled for material 1.2.
	 * @description
	 * Removes a class from the panel. DO NOT use this to hide/show the panel.
	 *
	 * @param {string} oldClass Class to be removed.
	 * @param {boolean} fromElement Whether or not to remove the class from the
	 *     panel element instead of the container.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#toggleClass
	 * @deprecated
	 * This method is in the process of being deprecated in favor of using the panel
	 * and container JQLite elements that are referenced in the MdPanelRef object.
	 * Full deprecation is scheduled for material 1.2.
	 * @description
	 * Toggles a class on the panel. DO NOT use this to hide/show the panel.
	 *
	 * @param {string} toggleClass Class to be toggled.
	 * @param {boolean} onElement Whether or not to remove the class from the panel
	 *     element instead of the container.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#updatePosition
	 * @description
	 * Updates the position configuration of a panel. Use this to update the
	 * position of a panel that is open, without having to close and re-open the
	 * panel.
	 *
	 * @param {!MdPanelPosition} position
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#addToGroup
	 * @description
	 * Adds a panel to a group if the panel does not exist within the group already.
	 * A panel can only exist within a single group.
	 *
	 * @param {string} groupName The name of the group to add the panel to.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#removeFromGroup
	 * @description
	 * Removes a panel from a group if the panel exists within that group. The group
	 * must be created ahead of time.
	 *
	 * @param {string} groupName The name of the group.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#registerInterceptor
	 * @description
	 * Registers an interceptor with the panel. The callback should return a promise,
	 * which will allow the action to continue when it gets resolved, or will
	 * prevent an action if it is rejected. The interceptors are called sequentially
	 * and it reverse order. `type` must be one of the following
	 * values available on `$mdPanel.interceptorTypes`:
	 * * `CLOSE` - Gets called before the panel begins closing.
	 *
	 * @param {string} type Type of interceptor.
	 * @param {!angular.$q.Promise<any>} callback Callback to be registered.
	 * @returns {!MdPanelRef}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#removeInterceptor
	 * @description
	 * Removes a registered interceptor.
	 *
	 * @param {string} type Type of interceptor to be removed.
	 * @param {function(): !angular.$q.Promise<any>} callback Interceptor to be removed.
	 * @returns {!MdPanelRef}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#removeAllInterceptors
	 * @description
	 * Removes all interceptors. If a type is supplied, only the
	 * interceptors of that type will be cleared.
	 *
	 * @param {string=} type Type of interceptors to be removed.
	 * @returns {!MdPanelRef}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#updateAnimation
	 * @description
	 * Updates the animation configuration for a panel. You can use this to change
	 * the panel's animation without having to re-create it.
	 *
	 * @param {!MdPanelAnimation} animation
	 */
	
	
	/*****************************************************************************
	 *                               MdPanelPosition                            *
	 *****************************************************************************/
	
	
	/**
	 * @ngdoc type
	 * @name MdPanelPosition
	 * @module material.components.panel
	 * @description
	 *
	 * Object for configuring the position of the panel.
	 *
	 * @usage
	 *
	 * #### Centering the panel
	 *
	 * <hljs lang="js">
	 * new MdPanelPosition().absolute().center();
	 * </hljs>
	 *
	 * #### Overlapping the panel with an element
	 *
	 * <hljs lang="js">
	 * new MdPanelPosition()
	 *     .relativeTo(someElement)
	 *     .addPanelPosition(
	 *       $mdPanel.xPosition.ALIGN_START,
	 *       $mdPanel.yPosition.ALIGN_TOPS
	 *     );
	 * </hljs>
	 *
	 * #### Aligning the panel with the bottom of an element
	 *
	 * <hljs lang="js">
	 * new MdPanelPosition()
	 *     .relativeTo(someElement)
	 *     .addPanelPosition($mdPanel.xPosition.CENTER, $mdPanel.yPosition.BELOW);
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#absolute
	 * @description
	 * Positions the panel absolutely relative to the parent element. If the parent
	 * is document.body, this is equivalent to positioning the panel absolutely
	 * within the viewport.
	 *
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#relativeTo
	 * @description
	 * Positions the panel relative to a specific element.
	 *
	 * @param {string|!Element|!angular.JQLite} element Query selector, DOM element,
	 *     or angular element to position the panel with respect to.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#top
	 * @description
	 * Sets the value of `top` for the panel. Clears any previously set vertical
	 * position.
	 *
	 * @param {string=} top Value of `top`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#bottom
	 * @description
	 * Sets the value of `bottom` for the panel. Clears any previously set vertical
	 * position.
	 *
	 * @param {string=} bottom Value of `bottom`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#start
	 * @description
	 * Sets the panel to the start of the page - `left` if `ltr` or `right` for
	 * `rtl`. Clears any previously set horizontal position.
	 *
	 * @param {string=} start Value of position. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#end
	 * @description
	 * Sets the panel to the end of the page - `right` if `ltr` or `left` for `rtl`.
	 * Clears any previously set horizontal position.
	 *
	 * @param {string=} end Value of position. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#left
	 * @description
	 * Sets the value of `left` for the panel. Clears any previously set
	 * horizontal position.
	 *
	 * @param {string=} left Value of `left`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#right
	 * @description
	 * Sets the value of `right` for the panel. Clears any previously set
	 * horizontal position.
	 *
	 * @param {string=} right Value of `right`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#centerHorizontally
	 * @description
	 * Centers the panel horizontally in the viewport. Clears any previously set
	 * horizontal position.
	 *
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#centerVertically
	 * @description
	 * Centers the panel vertically in the viewport. Clears any previously set
	 * vertical position.
	 *
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#center
	 * @description
	 * Centers the panel horizontally and vertically in the viewport. This is
	 * equivalent to calling both `centerHorizontally` and `centerVertically`.
	 * Clears any previously set horizontal and vertical positions.
	 *
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#addPanelPosition
	 * @description
	 * Sets the x and y position for the panel relative to another element. Can be
	 * called multiple times to specify an ordered list of panel positions. The
	 * first position which allows the panel to be completely on-screen will be
	 * chosen; the last position will be chose whether it is on-screen or not.
	 *
	 * xPosition must be one of the following values available on
	 * $mdPanel.xPosition:
	 *
	 *
	 * CENTER | ALIGN_START | ALIGN_END | OFFSET_START | OFFSET_END
	 *
	 * <pre>
	 *    *************
	 *    *           *
	 *    *   PANEL   *
	 *    *           *
	 *    *************
	 *   A B    C    D E
	 *
	 * A: OFFSET_START (for LTR displays)
	 * B: ALIGN_START (for LTR displays)
	 * C: CENTER
	 * D: ALIGN_END (for LTR displays)
	 * E: OFFSET_END (for LTR displays)
	 * </pre>
	 *
	 * yPosition must be one of the following values available on
	 * $mdPanel.yPosition:
	 *
	 * CENTER | ALIGN_TOPS | ALIGN_BOTTOMS | ABOVE | BELOW
	 *
	 * <pre>
	 *   F
	 *   G *************
	 *     *           *
	 *   H *   PANEL   *
	 *     *           *
	 *   I *************
	 *   J
	 *
	 * F: BELOW
	 * G: ALIGN_TOPS
	 * H: CENTER
	 * I: ALIGN_BOTTOMS
	 * J: ABOVE
	 * </pre>
	 *
	 * @param {string} xPosition
	 * @param {string} yPosition
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#withOffsetX
	 * @description
	 * Sets the value of the offset in the x-direction.
	 *
	 * @param {string} offsetX
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#withOffsetY
	 * @description
	 * Sets the value of the offset in the y-direction.
	 *
	 * @param {string} offsetY
	 * @returns {!MdPanelPosition}
	 */
	
	
	/*****************************************************************************
	 *                               MdPanelAnimation                            *
	 *****************************************************************************/
	
	
	/**
	 * @ngdoc type
	 * @name MdPanelAnimation
	 * @module material.components.panel
	 * @description
	 * Animation configuration object. To use, create an MdPanelAnimation with the
	 * desired properties, then pass the object as part of $mdPanel creation.
	 *
	 * @usage
	 *
	 * <hljs lang="js">
	 * var panelAnimation = new MdPanelAnimation()
	 *     .openFrom(myButtonEl)
	 *     .duration(1337)
	 *     .closeTo('.my-button')
	 *     .withAnimation($mdPanel.animation.SCALE);
	 *
	 * $mdPanel.create({
	 *   animation: panelAnimation
	 * });
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelAnimation#openFrom
	 * @description
	 * Specifies where to start the open animation. `openFrom` accepts a
	 * click event object, query selector, DOM element, or a Rect object that
	 * is used to determine the bounds. When passed a click event, the location
	 * of the click will be used as the position to start the animation.
	 *
	 * @param {string|!Element|!Event|{top: number, left: number}}
	 * @returns {!MdPanelAnimation}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelAnimation#closeTo
	 * @description
	 * Specifies where to animate the panel close. `closeTo` accepts a
	 * query selector, DOM element, or a Rect object that is used to determine
	 * the bounds.
	 *
	 * @param {string|!Element|{top: number, left: number}}
	 * @returns {!MdPanelAnimation}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelAnimation#withAnimation
	 * @description
	 * Specifies the animation class.
	 *
	 * There are several default animations that can be used:
	 * ($mdPanel.animation)
	 *   SLIDE: The panel slides in and out from the specified
	 *       elements. It will not fade in or out.
	 *   SCALE: The panel scales in and out. Slide and fade are
	 *       included in this animation.
	 *   FADE: The panel fades in and out.
	 *
	 * Custom classes will by default fade in and out unless
	 * "transition: opacity 1ms" is added to the to custom class.
	 *
	 * @param {string|{open: string, close: string}} cssClass
	 * @returns {!MdPanelAnimation}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelAnimation#duration
	 * @description
	 * Specifies the duration of the animation in milliseconds. The `duration`
	 * method accepts either a number or an object with separate open and close
	 * durations.
	 *
	 * @param {number|{open: number, close: number}} duration
	 * @returns {!MdPanelAnimation}
	 */
	
	
	/*****************************************************************************
	 *                            PUBLIC DOCUMENTATION                           *
	 *****************************************************************************/
	
	
	var MD_PANEL_Z_INDEX = 80;
	var MD_PANEL_HIDDEN = '_md-panel-hidden';
	var FOCUS_TRAP_TEMPLATE = angular.element(
	    '<div class="_md-panel-focus-trap" tabindex="0"></div>');
	
	var _presets = {};
	
	
	/**
	 * A provider that is used for creating presets for the panel API.
	 * @final @constructor @ngInject
	 */
	function MdPanelProvider() {
	  return {
	    'definePreset': definePreset,
	    'getAllPresets': getAllPresets,
	    'clearPresets': clearPresets,
	    '$get': $getProvider()
	  };
	}
	
	
	/**
	 * Takes the passed in panel configuration object and adds it to the `_presets`
	 * object at the specified name.
	 * @param {string} name Name of the preset to set.
	 * @param {!Object} preset Specific configuration object that can contain any
	 *     and all of the parameters avaialble within the `$mdPanel.create` method.
	 *     However, parameters that pertain to id, position, animation, and user
	 *     interaction are not allowed and will be removed from the preset
	 *     configuration.
	 */
	function definePreset(name, preset) {
	  if (!name || !preset) {
	    throw new Error('mdPanelProvider: The panel preset definition is ' +
	        'malformed. The name and preset object are required.');
	  } else if (_presets.hasOwnProperty(name)) {
	    throw new Error('mdPanelProvider: The panel preset you have requested ' +
	        'has already been defined.');
	  }
	
	  // Delete any property on the preset that is not allowed.
	  delete preset.id;
	  delete preset.position;
	  delete preset.animation;
	
	  _presets[name] = preset;
	}
	
	
	/**
	 * Gets a clone of the `_presets`.
	 * @return {!Object}
	 */
	function getAllPresets() {
	  return angular.copy(_presets);
	}
	
	
	/**
	 * Clears all of the stored presets.
	 */
	function clearPresets() {
	  _presets = {};
	}
	
	
	/**
	 * Represents the `$get` method of the AngularJS provider. From here, a new
	 * reference to the MdPanelService is returned where the needed arguments are
	 * passed in including the MdPanelProvider `_presets`.
	 * @param {!Object} _presets
	 * @param {!angular.JQLite} $rootElement
	 * @param {!angular.Scope} $rootScope
	 * @param {!angular.$injector} $injector
	 * @param {!angular.$window} $window
	 */
	function $getProvider() {
	  return [
	    '$rootElement', '$rootScope', '$injector', '$window',
	    function($rootElement, $rootScope, $injector, $window) {
	      return new MdPanelService(_presets, $rootElement, $rootScope,
	          $injector, $window);
	    }
	  ];
	}
	
	
	/*****************************************************************************
	 *                               MdPanel Service                             *
	 *****************************************************************************/
	
	
	/**
	 * A service that is used for controlling/displaying panels on the screen.
	 * @param {!Object} presets
	 * @param {!angular.JQLite} $rootElement
	 * @param {!angular.Scope} $rootScope
	 * @param {!angular.$injector} $injector
	 * @param {!angular.$window} $window
	 * @final @constructor @ngInject
	 */
	function MdPanelService(presets, $rootElement, $rootScope, $injector, $window) {
	  /**
	   * Default config options for the panel.
	   * Anything angular related needs to be done later. Therefore
	   *     scope: $rootScope.$new(true),
	   *     attachTo: $rootElement,
	   * are added later.
	   * @private {!Object}
	   */
	  this._defaultConfigOptions = {
	    bindToController: true,
	    clickOutsideToClose: false,
	    disableParentScroll: false,
	    escapeToClose: false,
	    focusOnOpen: true,
	    fullscreen: false,
	    hasBackdrop: false,
	    propagateContainerEvents: false,
	    transformTemplate: angular.bind(this, this._wrapTemplate),
	    trapFocus: false,
	    zIndex: MD_PANEL_Z_INDEX
	  };
	
	  /** @private {!Object} */
	  this._config = {};
	
	  /** @private {!Object} */
	  this._presets = presets;
	
	  /** @private @const */
	  this._$rootElement = $rootElement;
	
	  /** @private @const */
	  this._$rootScope = $rootScope;
	
	  /** @private @const */
	  this._$injector = $injector;
	
	  /** @private @const */
	  this._$window = $window;
	
	  /** @private @const */
	  this._$mdUtil = this._$injector.get('$mdUtil');
	
	  /** @private {!Object<string, !MdPanelRef>} */
	  this._trackedPanels = {};
	
	  /**
	   * @private {!Object<string,
	   *     {panels: !Array<!MdPanelRef>,
	   *     openPanels: !Array<!MdPanelRef>,
	   *     maxOpen: number}>}
	   */
	  this._groups = Object.create(null);
	
	  /**
	   * Default animations that can be used within the panel.
	   * @type {enum}
	   */
	  this.animation = MdPanelAnimation.animation;
	
	  /**
	   * Possible values of xPosition for positioning the panel relative to
	   * another element.
	   * @type {enum}
	   */
	  this.xPosition = MdPanelPosition.xPosition;
	
	  /**
	   * Possible values of yPosition for positioning the panel relative to
	   * another element.
	   * @type {enum}
	   */
	  this.yPosition = MdPanelPosition.yPosition;
	
	  /**
	   * Possible values for the interceptors that can be registered on a panel.
	   * @type {enum}
	   */
	  this.interceptorTypes = MdPanelRef.interceptorTypes;
	
	  /**
	   * Possible values for closing of a panel.
	   * @type {enum}
	   */
	  this.closeReasons = MdPanelRef.closeReasons;
	
	  /**
	   * Possible values of absolute position.
	   * @type {enum}
	   */
	  this.absPosition = MdPanelPosition.absPosition;
	}
	
	
	/**
	 * Creates a panel with the specified options.
	 * @param {string=} preset Name of a preset configuration that can be used to
	 *     extend the panel configuration.
	 * @param {!Object=} config Configuration object for the panel.
	 * @returns {!MdPanelRef}
	 */
	MdPanelService.prototype.create = function(preset, config) {
	  if (typeof preset === 'string') {
	    preset = this._getPresetByName(preset);
	  } else if (typeof preset === 'object' &&
	      (angular.isUndefined(config) || !config)) {
	    config = preset;
	    preset = {};
	  }
	
	  preset = preset || {};
	  config = config || {};
	
	  // If the passed-in config contains an ID and the ID is within _trackedPanels,
	  // return the tracked panel after updating its config with the passed-in
	  // config.
	  if (angular.isDefined(config.id) && this._trackedPanels[config.id]) {
	    var trackedPanel = this._trackedPanels[config.id];
	    angular.extend(trackedPanel.config, config);
	    return trackedPanel;
	  }
	
	  // Combine the passed-in config, the _defaultConfigOptions, and the preset
	  // configuration into the `_config`.
	  this._config = angular.extend({
	    // If no ID is set within the passed-in config, then create an arbitrary ID.
	    id: config.id || 'panel_' + this._$mdUtil.nextUid(),
	    scope: this._$rootScope.$new(true),
	    attachTo: this._$rootElement
	  }, this._defaultConfigOptions, config, preset);
	
	  // Create the panelRef and add it to the `_trackedPanels` object.
	  var panelRef = new MdPanelRef(this._config, this._$injector);
	  this._trackedPanels[config.id] = panelRef;
	
	  // Add the panel to each of its requested groups.
	  if (this._config.groupName) {
	    if (angular.isString(this._config.groupName)) {
	      this._config.groupName = [this._config.groupName];
	    }
	    angular.forEach(this._config.groupName, function(group) {
	      panelRef.addToGroup(group);
	    });
	  }
	
	  this._config.scope.$on('$destroy', angular.bind(panelRef, panelRef.detach));
	
	  return panelRef;
	};
	
	
	/**
	 * Creates and opens a panel with the specified options.
	 * @param {string=} preset Name of a preset configuration that can be used to
	 *     extend the panel configuration.
	 * @param {!Object=} config Configuration object for the panel.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} The panel created from create.
	 */
	MdPanelService.prototype.open = function(preset, config) {
	  var panelRef = this.create(preset, config);
	  return panelRef.open().then(function() {
	    return panelRef;
	  });
	};
	
	
	/**
	 * Gets a specific preset configuration object saved within `_presets`.
	 * @param {string} preset Name of the preset to search for.
	 * @returns {!Object} The preset configuration object.
	 */
	MdPanelService.prototype._getPresetByName = function(preset) {
	  if (!this._presets[preset]) {
	    throw new Error('mdPanel: The panel preset configuration that you ' +
	        'requested does not exist. Use the $mdPanelProvider to create a ' +
	        'preset before requesting one.');
	  }
	  return this._presets[preset];
	};
	
	
	/**
	 * Returns a new instance of the MdPanelPosition. Use this to create the
	 * positioning object.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelService.prototype.newPanelPosition = function() {
	  return new MdPanelPosition(this._$injector);
	};
	
	
	/**
	 * Returns a new instance of the MdPanelAnimation. Use this to create the
	 * animation object.
	 * @returns {!MdPanelAnimation}
	 */
	MdPanelService.prototype.newPanelAnimation = function() {
	  return new MdPanelAnimation(this._$injector);
	};
	
	
	/**
	 * Creates a panel group and adds it to a tracked list of panel groups.
	 * @param groupName {string} Name of the group to create.
	 * @param config {!Object=} Specific configuration object that may contain the
	 *     following properties:
	 *
	 *   - `maxOpen` - `{number=}`: The maximum number of panels that are allowed
	 *     open within a defined panel group.
	 *
	 * @returns {!Object<string,
	 *     {panels: !Array<!MdPanelRef>,
	 *     openPanels: !Array<!MdPanelRef>,
	 *     maxOpen: number}>} panelGroup
	 */
	MdPanelService.prototype.newPanelGroup = function(groupName, config) {
	  if (!this._groups[groupName]) {
	    config = config || {};
	    var group = {
	      panels: [],
	      openPanels: [],
	      maxOpen: config.maxOpen > 0 ? config.maxOpen : Infinity
	    };
	    this._groups[groupName] = group;
	  }
	  return this._groups[groupName];
	};
	
	
	/**
	 * Sets the maximum number of panels in a group that can be opened at a given
	 * time.
	 * @param {string} groupName The name of the group to configure.
	 * @param {number} maxOpen The maximum number of panels that can be
	 *     opened. Infinity can be passed in to remove the maxOpen limit.
	 */
	MdPanelService.prototype.setGroupMaxOpen = function(groupName, maxOpen) {
	  if (this._groups[groupName]) {
	    this._groups[groupName].maxOpen = maxOpen;
	  } else {
	    throw new Error('mdPanel: Group does not exist yet. Call newPanelGroup().');
	  }
	};
	
	
	/**
	 * Determines if the current number of open panels within a group exceeds the
	 * limit of allowed open panels.
	 * @param {string} groupName The name of the group to check.
	 * @returns {boolean} true if open count does exceed maxOpen and false if not.
	 * @private
	 */
	MdPanelService.prototype._openCountExceedsMaxOpen = function(groupName) {
	  if (this._groups[groupName]) {
	    var group = this._groups[groupName];
	    return group.maxOpen > 0 && group.openPanels.length > group.maxOpen;
	  }
	  return false;
	};
	
	
	/**
	 * Closes the first open panel within a specific group.
	 * @param {string} groupName The name of the group.
	 * @private
	 */
	MdPanelService.prototype._closeFirstOpenedPanel = function(groupName) {
	  this._groups[groupName].openPanels[0].close();
	};
	
	
	/**
	 * Wraps the users template in two elements, md-panel-outer-wrapper, which
	 * covers the entire attachTo element, and md-panel, which contains only the
	 * template. This allows the panel control over positioning, animations,
	 * and similar properties.
	 * @param {string} origTemplate The original template.
	 * @returns {string} The wrapped template.
	 * @private
	 */
	MdPanelService.prototype._wrapTemplate = function(origTemplate) {
	  var template = origTemplate || '';
	
	  // The panel should be initially rendered offscreen so we can calculate
	  // height and width for positioning.
	  return '' +
	      '<div class="md-panel-outer-wrapper">' +
	      '  <div class="md-panel _md-panel-offscreen">' + template + '</div>' +
	      '</div>';
	};
	
	
	/**
	 * Wraps a content element in a md-panel-outer wrapper and
	 * positions it off-screen. Allows for proper control over positoning
	 * and animations.
	 * @param {!angular.JQLite} contentElement Element to be wrapped.
	 * @return {!angular.JQLite} Wrapper element.
	 * @private
	 */
	MdPanelService.prototype._wrapContentElement = function(contentElement) {
	  var wrapper = angular.element('<div class="md-panel-outer-wrapper">');
	
	  contentElement.addClass('md-panel _md-panel-offscreen');
	  wrapper.append(contentElement);
	
	  return wrapper;
	};
	
	
	/*****************************************************************************
	 *                                 MdPanelRef                                *
	 *****************************************************************************/
	
	
	/**
	 * A reference to a created panel. This reference contains a unique id for the
	 * panel, along with properties/functions used to control the panel.
	 * @param {!Object} config
	 * @param {!angular.$injector} $injector
	 * @final @constructor
	 */
	function MdPanelRef(config, $injector) {
	  // Injected variables.
	  /** @private @const {!angular.$q} */
	  this._$q = $injector.get('$q');
	
	  /** @private @const {!angular.$mdCompiler} */
	  this._$mdCompiler = $injector.get('$mdCompiler');
	
	  /** @private @const {!angular.$mdConstant} */
	  this._$mdConstant = $injector.get('$mdConstant');
	
	  /** @private @const {!angular.$mdUtil} */
	  this._$mdUtil = $injector.get('$mdUtil');
	
	  /** @private @const {!angular.$mdTheming} */
	  this._$mdTheming = $injector.get('$mdTheming');
	
	  /** @private @const {!angular.Scope} */
	  this._$rootScope = $injector.get('$rootScope');
	
	  /** @private @const {!angular.$animate} */
	  this._$animate = $injector.get('$animate');
	
	  /** @private @const {!MdPanelRef} */
	  this._$mdPanel = $injector.get('$mdPanel');
	
	  /** @private @const {!angular.$log} */
	  this._$log = $injector.get('$log');
	
	  /** @private @const {!angular.$window} */
	  this._$window = $injector.get('$window');
	
	  /** @private @const {!Function} */
	  this._$$rAF = $injector.get('$$rAF');
	
	  // Public variables.
	  /**
	   * Unique id for the panelRef.
	   * @type {string}
	   */
	  this.id = config.id;
	
	  /** @type {!Object} */
	  this.config = config;
	
	  /** @type {!angular.JQLite|undefined} */
	  this.panelContainer;
	
	  /** @type {!angular.JQLite|undefined} */
	  this.panelEl;
	
	  /**
	   * Whether the panel is attached. This is synchronous. When attach is called,
	   * isAttached is set to true. When detach is called, isAttached is set to
	   * false.
	   * @type {boolean}
	   */
	  this.isAttached = false;
	
	  // Private variables.
	  /** @private {Array<function()>} */
	  this._removeListeners = [];
	
	  /** @private {!angular.JQLite|undefined} */
	  this._topFocusTrap;
	
	  /** @private {!angular.JQLite|undefined} */
	  this._bottomFocusTrap;
	
	  /** @private {!$mdPanel|undefined} */
	  this._backdropRef;
	
	  /** @private {Function?} */
	  this._restoreScroll = null;
	
	  /**
	   * Keeps track of all the panel interceptors.
	   * @private {!Object}
	   */
	  this._interceptors = Object.create(null);
	
	  /**
	   * Cleanup function, provided by `$mdCompiler` and assigned after the element
	   * has been compiled. When `contentElement` is used, the function is used to
	   * restore the element to it's proper place in the DOM.
	   * @private {!Function}
	   */
	  this._compilerCleanup = null;
	
	  /**
	   * Cache for saving and restoring element inline styles, CSS classes etc.
	   * @type {{styles: string, classes: string}}
	   */
	  this._restoreCache = {
	    styles: '',
	    classes: ''
	  };
	}
	
	
	MdPanelRef.interceptorTypes = {
	  CLOSE: 'onClose'
	};
	
	
	/**
	 * Opens an already created and configured panel. If the panel is already
	 * visible, does nothing.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
	 *     the panel is opened and animations finish.
	 */
	MdPanelRef.prototype.open = function() {
	  var self = this;
	  return this._$q(function(resolve, reject) {
	    var done = self._done(resolve, self);
	    var show = self._simpleBind(self.show, self);
	    var checkGroupMaxOpen = function() {
	      if (self.config.groupName) {
	        angular.forEach(self.config.groupName, function(group) {
	          if (self._$mdPanel._openCountExceedsMaxOpen(group)) {
	            self._$mdPanel._closeFirstOpenedPanel(group);
	          }
	        });
	      }
	    };
	
	    self.attach()
	        .then(show)
	        .then(checkGroupMaxOpen)
	        .then(done)
	        .catch(reject);
	  });
	};
	
	
	/**
	 * Closes the panel.
	 * @param {string} closeReason The event type that triggered the close.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
	 *     the panel is closed and animations finish.
	 */
	MdPanelRef.prototype.close = function(closeReason) {
	  var self = this;
	
	  return this._$q(function(resolve, reject) {
	    self._callInterceptors(MdPanelRef.interceptorTypes.CLOSE).then(function() {
	      var done = self._done(resolve, self);
	      var detach = self._simpleBind(self.detach, self);
	      var onCloseSuccess = self.config['onCloseSuccess'] || angular.noop;
	      onCloseSuccess = angular.bind(self, onCloseSuccess, self, closeReason);
	
	      self.hide()
	          .then(detach)
	          .then(done)
	          .then(onCloseSuccess)
	          .catch(reject);
	    }, reject);
	  });
	};
	
	
	/**
	 * Attaches the panel. The panel will be hidden afterwards.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
	 *     the panel is attached.
	 */
	MdPanelRef.prototype.attach = function() {
	  if (this.isAttached && this.panelEl) {
	    return this._$q.when(this);
	  }
	
	  var self = this;
	  return this._$q(function(resolve, reject) {
	    var done = self._done(resolve, self);
	    var onDomAdded = self.config['onDomAdded'] || angular.noop;
	    var addListeners = function(response) {
	      self.isAttached = true;
	      self._addEventListeners();
	      return response;
	    };
	
	    self._$q.all([
	        self._createBackdrop(),
	        self._createPanel()
	            .then(addListeners)
	            .catch(reject)
	    ]).then(onDomAdded)
	      .then(done)
	      .catch(reject);
	  });
	};
	
	
	/**
	 * Only detaches the panel. Will NOT hide the panel first.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
	 *     the panel is detached.
	 */
	MdPanelRef.prototype.detach = function() {
	  if (!this.isAttached) {
	    return this._$q.when(this);
	  }
	
	  var self = this;
	  var onDomRemoved = self.config['onDomRemoved'] || angular.noop;
	
	  var detachFn = function() {
	    self._removeEventListeners();
	
	    // Remove the focus traps that we added earlier for keeping focus within
	    // the panel.
	    if (self._topFocusTrap && self._topFocusTrap.parentNode) {
	      self._topFocusTrap.parentNode.removeChild(self._topFocusTrap);
	    }
	
	    if (self._bottomFocusTrap && self._bottomFocusTrap.parentNode) {
	      self._bottomFocusTrap.parentNode.removeChild(self._bottomFocusTrap);
	    }
	
	    if (self._restoreCache.classes) {
	      self.panelEl[0].className = self._restoreCache.classes;
	    }
	
	    // Either restore the saved styles or clear the ones set by mdPanel.
	    self.panelEl[0].style.cssText = self._restoreCache.styles || '';
	
	    self._compilerCleanup();
	    self.panelContainer.remove();
	    self.isAttached = false;
	    return self._$q.when(self);
	  };
	
	  if (this._restoreScroll) {
	    this._restoreScroll();
	    this._restoreScroll = null;
	  }
	
	  return this._$q(function(resolve, reject) {
	    var done = self._done(resolve, self);
	
	    self._$q.all([
	      detachFn(),
	      self._backdropRef ? self._backdropRef.detach() : true
	    ]).then(onDomRemoved)
	      .then(done)
	      .catch(reject);
	  });
	};
	
	
	/**
	 * Destroys the panel. The Panel cannot be opened again after this.
	 */
	MdPanelRef.prototype.destroy = function() {
	  var self = this;
	  if (this.config.groupName) {
	    angular.forEach(this.config.groupName, function(group) {
	      self.removeFromGroup(group);
	    });
	  }
	  this.config.scope.$destroy();
	  this.config.locals = null;
	  this._interceptors = null;
	};
	
	
	/**
	 * Shows the panel.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
	 *     the panel has shown and animations finish.
	 */
	MdPanelRef.prototype.show = function() {
	  if (!this.panelContainer) {
	    return this._$q(function(resolve, reject) {
	      reject('mdPanel: Panel does not exist yet. Call open() or attach().');
	    });
	  }
	
	  if (!this.panelContainer.hasClass(MD_PANEL_HIDDEN)) {
	    return this._$q.when(this);
	  }
	
	  var self = this;
	  var animatePromise = function() {
	    self.panelContainer.removeClass(MD_PANEL_HIDDEN);
	    return self._animateOpen();
	  };
	
	  return this._$q(function(resolve, reject) {
	    var done = self._done(resolve, self);
	    var onOpenComplete = self.config['onOpenComplete'] || angular.noop;
	    var addToGroupOpen = function() {
	      if (self.config.groupName) {
	        angular.forEach(self.config.groupName, function(group) {
	          self._$mdPanel._groups[group].openPanels.push(self);
	        });
	      }
	    };
	
	    self._$q.all([
	      self._backdropRef ? self._backdropRef.show() : self,
	      animatePromise().then(function() { self._focusOnOpen(); }, reject)
	    ]).then(onOpenComplete)
	      .then(addToGroupOpen)
	      .then(done)
	      .catch(reject);
	  });
	};
	
	
	/**
	 * Hides the panel.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
	 *     the panel has hidden and animations finish.
	 */
	MdPanelRef.prototype.hide = function() {
	  if (!this.panelContainer) {
	    return this._$q(function(resolve, reject) {
	      reject('mdPanel: Panel does not exist yet. Call open() or attach().');
	    });
	  }
	
	  if (this.panelContainer.hasClass(MD_PANEL_HIDDEN)) {
	    return this._$q.when(this);
	  }
	
	  var self = this;
	
	  return this._$q(function(resolve, reject) {
	    var done = self._done(resolve, self);
	    var onRemoving = self.config['onRemoving'] || angular.noop;
	    var hidePanel = function() {
	      self.panelContainer.addClass(MD_PANEL_HIDDEN);
	    };
	    var removeFromGroupOpen = function() {
	      if (self.config.groupName) {
	        var group, index;
	        angular.forEach(self.config.groupName, function(group) {
	          group = self._$mdPanel._groups[group];
	          index = group.openPanels.indexOf(self);
	          if (index > -1) {
	            group.openPanels.splice(index, 1);
	          }
	        });
	      }
	    };
	    var focusOnOrigin = function() {
	      var origin = self.config['origin'];
	      if (origin) {
	        getElement(origin).focus();
	      }
	    };
	
	    self._$q.all([
	      self._backdropRef ? self._backdropRef.hide() : self,
	      self._animateClose()
	          .then(onRemoving)
	          .then(hidePanel)
	          .then(removeFromGroupOpen)
	          .then(focusOnOrigin)
	          .catch(reject)
	    ]).then(done, reject);
	  });
	};
	
	
	/**
	 * Add a class to the panel. DO NOT use this to hide/show the panel.
	 * @deprecated
	 * This method is in the process of being deprecated in favor of using the panel
	 * and container JQLite elements that are referenced in the MdPanelRef object.
	 * Full deprecation is scheduled for material 1.2.
	 *
	 * @param {string} newClass Class to be added.
	 * @param {boolean} toElement Whether or not to add the class to the panel
	 *     element instead of the container.
	 */
	MdPanelRef.prototype.addClass = function(newClass, toElement) {
	  this._$log.warn(
	      'mdPanel: The addClass method is in the process of being deprecated. ' +
	      'Full deprecation is scheduled for the AngularJS Material 1.2 release. ' +
	      'To achieve the same results, use the panelContainer or panelEl ' +
	      'JQLite elements that are referenced in MdPanelRef.');
	
	  if (!this.panelContainer) {
	    throw new Error(
	        'mdPanel: Panel does not exist yet. Call open() or attach().');
	  }
	
	  if (!toElement && !this.panelContainer.hasClass(newClass)) {
	    this.panelContainer.addClass(newClass);
	  } else if (toElement && !this.panelEl.hasClass(newClass)) {
	    this.panelEl.addClass(newClass);
	  }
	};
	
	
	/**
	 * Remove a class from the panel. DO NOT use this to hide/show the panel.
	 * @deprecated
	 * This method is in the process of being deprecated in favor of using the panel
	 * and container JQLite elements that are referenced in the MdPanelRef object.
	 * Full deprecation is scheduled for material 1.2.
	 *
	 * @param {string} oldClass Class to be removed.
	 * @param {boolean} fromElement Whether or not to remove the class from the
	 *     panel element instead of the container.
	 */
	MdPanelRef.prototype.removeClass = function(oldClass, fromElement) {
	  this._$log.warn(
	      'mdPanel: The removeClass method is in the process of being deprecated. ' +
	      'Full deprecation is scheduled for the AngularJS Material 1.2 release. ' +
	      'To achieve the same results, use the panelContainer or panelEl ' +
	      'JQLite elements that are referenced in MdPanelRef.');
	
	  if (!this.panelContainer) {
	    throw new Error(
	        'mdPanel: Panel does not exist yet. Call open() or attach().');
	  }
	
	  if (!fromElement && this.panelContainer.hasClass(oldClass)) {
	    this.panelContainer.removeClass(oldClass);
	  } else if (fromElement && this.panelEl.hasClass(oldClass)) {
	    this.panelEl.removeClass(oldClass);
	  }
	};
	
	
	/**
	 * Toggle a class on the panel. DO NOT use this to hide/show the panel.
	 * @deprecated
	 * This method is in the process of being deprecated in favor of using the panel
	 * and container JQLite elements that are referenced in the MdPanelRef object.
	 * Full deprecation is scheduled for material 1.2.
	 *
	 * @param {string} toggleClass The class to toggle.
	 * @param {boolean} onElement Whether or not to toggle the class on the panel
	 *     element instead of the container.
	 */
	MdPanelRef.prototype.toggleClass = function(toggleClass, onElement) {
	  this._$log.warn(
	      'mdPanel: The toggleClass method is in the process of being deprecated. ' +
	      'Full deprecation is scheduled for the AngularJS Material 1.2 release. ' +
	      'To achieve the same results, use the panelContainer or panelEl ' +
	      'JQLite elements that are referenced in MdPanelRef.');
	
	  if (!this.panelContainer) {
	    throw new Error(
	        'mdPanel: Panel does not exist yet. Call open() or attach().');
	  }
	
	  if (!onElement) {
	    this.panelContainer.toggleClass(toggleClass);
	  } else {
	    this.panelEl.toggleClass(toggleClass);
	  }
	};
	
	
	/**
	 * Compiles the panel, according to the passed in config and appends it to
	 * the DOM. Helps normalize differences in the compilation process between
	 * using a string template and a content element.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} Promise that is resolved when
	 *     the element has been compiled and added to the DOM.
	 * @private
	 */
	MdPanelRef.prototype._compile = function() {
	  var self = this;
	
	  // Compile the element via $mdCompiler. Note that when using a
	  // contentElement, the element isn't actually being compiled, rather the
	  // compiler saves it's place in the DOM and provides a way of restoring it.
	  return self._$mdCompiler.compile(self.config).then(function(compileData) {
	    var config = self.config;
	
	    if (config.contentElement) {
	      var panelEl = compileData.element;
	
	      // Since mdPanel modifies the inline styles and CSS classes, we need
	      // to save them in order to be able to restore on close.
	      self._restoreCache.styles = panelEl[0].style.cssText;
	      self._restoreCache.classes = panelEl[0].className;
	
	      self.panelContainer = self._$mdPanel._wrapContentElement(panelEl);
	      self.panelEl = panelEl;
	    } else {
	      self.panelContainer = compileData.link(config['scope']);
	      self.panelEl = angular.element(
	        self.panelContainer[0].querySelector('.md-panel')
	      );
	    }
	
	    // Save a reference to the cleanup function from the compiler.
	    self._compilerCleanup = compileData.cleanup;
	
	    // Attach the panel to the proper place in the DOM.
	    getElement(self.config['attachTo']).append(self.panelContainer);
	
	    return self;
	  });
	};
	
	
	/**
	 * Creates a panel and adds it to the dom.
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel is
	 *     created.
	 * @private
	 */
	MdPanelRef.prototype._createPanel = function() {
	  var self = this;
	
	  return this._$q(function(resolve, reject) {
	    if (!self.config.locals) {
	      self.config.locals = {};
	    }
	
	    self.config.locals.mdPanelRef = self;
	
	    self._compile().then(function() {
	      if (self.config['disableParentScroll']) {
	        self._restoreScroll = self._$mdUtil.disableScrollAround(
	          null,
	          self.panelContainer,
	          { disableScrollMask: true }
	        );
	      }
	
	      // Add a custom CSS class to the panel element.
	      if (self.config['panelClass']) {
	        self.panelEl.addClass(self.config['panelClass']);
	      }
	
	      // Handle click and touch events for the panel container.
	      if (self.config['propagateContainerEvents']) {
	        self.panelContainer.css('pointer-events', 'none');
	      }
	
	      // Panel may be outside the $rootElement, tell ngAnimate to animate
	      // regardless.
	      if (self._$animate.pin) {
	        self._$animate.pin(
	          self.panelContainer,
	          getElement(self.config['attachTo'])
	        );
	      }
	
	      self._configureTrapFocus();
	      self._addStyles().then(function() {
	        resolve(self);
	      }, reject);
	    }, reject);
	
	  });
	};
	
	
	/**
	 * Adds the styles for the panel, such as positioning and z-index. Also,
	 * themes the panel element and panel container using `$mdTheming`.
	 * @returns {!angular.$q.Promise<!MdPanelRef>}
	 * @private
	 */
	MdPanelRef.prototype._addStyles = function() {
	  var self = this;
	  return this._$q(function(resolve) {
	    self.panelContainer.css('z-index', self.config['zIndex']);
	    self.panelEl.css('z-index', self.config['zIndex'] + 1);
	
	    var hideAndResolve = function() {
	      // Theme the element and container.
	      self._setTheming();
	
	      // Remove offscreen class and add hidden class.
	      self.panelEl.removeClass('_md-panel-offscreen');
	      self.panelContainer.addClass(MD_PANEL_HIDDEN);
	
	      resolve(self);
	    };
	
	    if (self.config['fullscreen']) {
	      self.panelEl.addClass('_md-panel-fullscreen');
	      hideAndResolve();
	      return; // Don't setup positioning.
	    }
	
	    var positionConfig = self.config['position'];
	    if (!positionConfig) {
	      hideAndResolve();
	      return; // Don't setup positioning.
	    }
	
	    // Wait for angular to finish processing the template
	    self._$rootScope['$$postDigest'](function() {
	      // Position it correctly. This is necessary so that the panel will have a
	      // defined height and width.
	      self._updatePosition(true);
	
	      // Theme the element and container.
	      self._setTheming();
	
	      resolve(self);
	    });
	  });
	};
	
	
	/**
	 * Sets the `$mdTheming` classes on the `panelContainer` and `panelEl`.
	 * @private
	 */
	MdPanelRef.prototype._setTheming = function() {
	  this._$mdTheming(this.panelEl);
	  this._$mdTheming(this.panelContainer);
	};
	
	
	/**
	 * Updates the position configuration of a panel
	 * @param {!MdPanelPosition} position
	 */
	MdPanelRef.prototype.updatePosition = function(position) {
	  if (!this.panelContainer) {
	    throw new Error(
	        'mdPanel: Panel does not exist yet. Call open() or attach().');
	  }
	
	  this.config['position'] = position;
	  this._updatePosition();
	};
	
	
	/**
	 * Calculates and updates the position of the panel.
	 * @param {boolean=} init
	 * @private
	 */
	MdPanelRef.prototype._updatePosition = function(init) {
	  var positionConfig = this.config['position'];
	
	  if (positionConfig) {
	    positionConfig._setPanelPosition(this.panelEl);
	
	    // Hide the panel now that position is known.
	    if (init) {
	      this.panelEl.removeClass('_md-panel-offscreen');
	      this.panelContainer.addClass(MD_PANEL_HIDDEN);
	    }
	
	    this.panelEl.css(
	      MdPanelPosition.absPosition.TOP,
	      positionConfig.getTop()
	    );
	    this.panelEl.css(
	      MdPanelPosition.absPosition.BOTTOM,
	      positionConfig.getBottom()
	    );
	    this.panelEl.css(
	      MdPanelPosition.absPosition.LEFT,
	      positionConfig.getLeft()
	    );
	    this.panelEl.css(
	      MdPanelPosition.absPosition.RIGHT,
	      positionConfig.getRight()
	    );
	  }
	};
	
	
	/**
	 * Focuses on the panel or the first focus target.
	 * @private
	 */
	MdPanelRef.prototype._focusOnOpen = function() {
	  if (this.config['focusOnOpen']) {
	    // Wait for the template to finish rendering to guarantee md-autofocus has
	    // finished adding the class md-autofocus, otherwise the focusable element
	    // isn't available to focus.
	    var self = this;
	    this._$rootScope['$$postDigest'](function() {
	      var target = self._$mdUtil.findFocusTarget(self.panelEl) ||
	          self.panelEl;
	      target.focus();
	    });
	  }
	};
	
	
	/**
	 * Shows the backdrop.
	 * @returns {!angular.$q.Promise} A promise that is resolved when the backdrop
	 *     is created and attached.
	 * @private
	 */
	MdPanelRef.prototype._createBackdrop = function() {
	  if (this.config.hasBackdrop) {
	    if (!this._backdropRef) {
	      var backdropAnimation = this._$mdPanel.newPanelAnimation()
	          .openFrom(this.config.attachTo)
	          .withAnimation({
	            open: '_md-opaque-enter',
	            close: '_md-opaque-leave'
	          });
	
	      if (this.config.animation) {
	        backdropAnimation.duration(this.config.animation._rawDuration);
	      }
	
	      var backdropConfig = {
	        animation: backdropAnimation,
	        attachTo: this.config.attachTo,
	        focusOnOpen: false,
	        panelClass: '_md-panel-backdrop',
	        zIndex: this.config.zIndex - 1
	      };
	
	      this._backdropRef = this._$mdPanel.create(backdropConfig);
	    }
	    if (!this._backdropRef.isAttached) {
	      return this._backdropRef.attach();
	    }
	  }
	};
	
	
	/**
	 * Listen for escape keys and outside clicks to auto close.
	 * @private
	 */
	MdPanelRef.prototype._addEventListeners = function() {
	  this._configureEscapeToClose();
	  this._configureClickOutsideToClose();
	  this._configureScrollListener();
	};
	
	
	/**
	 * Remove event listeners added in _addEventListeners.
	 * @private
	 */
	MdPanelRef.prototype._removeEventListeners = function() {
	  this._removeListeners && this._removeListeners.forEach(function(removeFn) {
	    removeFn();
	  });
	  this._removeListeners = [];
	};
	
	
	/**
	 * Setup the escapeToClose event listeners.
	 * @private
	 */
	MdPanelRef.prototype._configureEscapeToClose = function() {
	  if (this.config['escapeToClose']) {
	    var parentTarget = getElement(this.config['attachTo']);
	    var self = this;
	
	    var keyHandlerFn = function(ev) {
	      if (ev.keyCode === self._$mdConstant.KEY_CODE.ESCAPE) {
	        ev.stopPropagation();
	        ev.preventDefault();
	
	        self.close(MdPanelRef.closeReasons.ESCAPE);
	      }
	    };
	
	    // Add keydown listeners
	    this.panelContainer.on('keydown', keyHandlerFn);
	    parentTarget.on('keydown', keyHandlerFn);
	
	    // Queue remove listeners function
	    this._removeListeners.push(function() {
	      self.panelContainer.off('keydown', keyHandlerFn);
	      parentTarget.off('keydown', keyHandlerFn);
	    });
	  }
	};
	
	
	/**
	 * Setup the clickOutsideToClose event listeners.
	 * @private
	 */
	MdPanelRef.prototype._configureClickOutsideToClose = function() {
	  if (this.config['clickOutsideToClose']) {
	    var target = this.config['propagateContainerEvents'] ?
	        angular.element(document.body) :
	        this.panelContainer;
	    var sourceEl;
	
	    // Keep track of the element on which the mouse originally went down
	    // so that we can only close the backdrop when the 'click' started on it.
	    // A simple 'click' handler does not work, it sets the target object as the
	    // element the mouse went down on.
	    var mousedownHandler = function(ev) {
	      sourceEl = ev.target;
	    };
	
	    // We check if our original element and the target is the backdrop
	    // because if the original was the backdrop and the target was inside the
	    // panel we don't want to panel to close.
	    var self = this;
	    var mouseupHandler = function(ev) {
	      if (self.config['propagateContainerEvents']) {
	
	        // We check if the sourceEl of the event is the panel element or one
	        // of it's children. If it is not, then close the panel.
	        if (sourceEl !== self.panelEl[0] && !self.panelEl[0].contains(sourceEl)) {
	          self.close();
	        }
	
	      } else if (sourceEl === target[0] && ev.target === target[0]) {
	        ev.stopPropagation();
	        ev.preventDefault();
	
	        self.close(MdPanelRef.closeReasons.CLICK_OUTSIDE);
	      }
	    };
	
	    // Add listeners
	    target.on('mousedown', mousedownHandler);
	    target.on('mouseup', mouseupHandler);
	
	    // Queue remove listeners function
	    this._removeListeners.push(function() {
	      target.off('mousedown', mousedownHandler);
	      target.off('mouseup', mouseupHandler);
	    });
	  }
	};
	
	
	/**
	 * Configures the listeners for updating the panel position on scroll.
	 * @private
	*/
	MdPanelRef.prototype._configureScrollListener = function() {
	  // No need to bind the event if scrolling is disabled.
	  if (!this.config['disableParentScroll']) {
	    var updatePosition = angular.bind(this, this._updatePosition);
	    var debouncedUpdatePosition = this._$$rAF.throttle(updatePosition);
	    var self = this;
	
	    var onScroll = function() {
	      debouncedUpdatePosition();
	    };
	
	    // Add listeners.
	    this._$window.addEventListener('scroll', onScroll, true);
	
	    // Queue remove listeners function.
	    this._removeListeners.push(function() {
	      self._$window.removeEventListener('scroll', onScroll, true);
	    });
	  }
	};
	
	
	/**
	 * Setup the focus traps. These traps will wrap focus when tabbing past the
	 * panel. When shift-tabbing, the focus will stick in place.
	 * @private
	 */
	MdPanelRef.prototype._configureTrapFocus = function() {
	  // Focus doesn't remain inside of the panel without this.
	  this.panelEl.attr('tabIndex', '-1');
	  if (this.config['trapFocus']) {
	    var element = this.panelEl;
	    // Set up elements before and after the panel to capture focus and
	    // redirect back into the panel.
	    this._topFocusTrap = FOCUS_TRAP_TEMPLATE.clone()[0];
	    this._bottomFocusTrap = FOCUS_TRAP_TEMPLATE.clone()[0];
	
	    // When focus is about to move out of the panel, we want to intercept it
	    // and redirect it back to the panel element.
	    var focusHandler = function() {
	      element.focus();
	    };
	    this._topFocusTrap.addEventListener('focus', focusHandler);
	    this._bottomFocusTrap.addEventListener('focus', focusHandler);
	
	    // Queue remove listeners function
	    this._removeListeners.push(this._simpleBind(function() {
	      this._topFocusTrap.removeEventListener('focus', focusHandler);
	      this._bottomFocusTrap.removeEventListener('focus', focusHandler);
	    }, this));
	
	    // The top focus trap inserted immediately before the md-panel element (as
	    // a sibling). The bottom focus trap inserted immediately after the
	    // md-panel element (as a sibling).
	    element[0].parentNode.insertBefore(this._topFocusTrap, element[0]);
	    element.after(this._bottomFocusTrap);
	  }
	};
	
	
	/**
	 * Updates the animation of a panel.
	 * @param {!MdPanelAnimation} animation
	 */
	MdPanelRef.prototype.updateAnimation = function(animation) {
	  this.config['animation'] = animation;
	
	  if (this._backdropRef) {
	    this._backdropRef.config.animation.duration(animation._rawDuration);
	  }
	};
	
	
	/**
	 * Animate the panel opening.
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel has
	 *     animated open.
	 * @private
	 */
	MdPanelRef.prototype._animateOpen = function() {
	  this.panelContainer.addClass('md-panel-is-showing');
	  var animationConfig = this.config['animation'];
	  if (!animationConfig) {
	    // Promise is in progress, return it.
	    this.panelContainer.addClass('_md-panel-shown');
	    return this._$q.when(this);
	  }
	
	  var self = this;
	  return this._$q(function(resolve) {
	    var done = self._done(resolve, self);
	    var warnAndOpen = function() {
	      self._$log.warn(
	          'mdPanel: MdPanel Animations failed. ' +
	          'Showing panel without animating.');
	      done();
	    };
	
	    animationConfig.animateOpen(self.panelEl)
	        .then(done, warnAndOpen);
	  });
	};
	
	
	/**
	 * Animate the panel closing.
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel has
	 *     animated closed.
	 * @private
	 */
	MdPanelRef.prototype._animateClose = function() {
	  var animationConfig = this.config['animation'];
	  if (!animationConfig) {
	    this.panelContainer.removeClass('md-panel-is-showing');
	    this.panelContainer.removeClass('_md-panel-shown');
	    return this._$q.when(this);
	  }
	
	  var self = this;
	  return this._$q(function(resolve) {
	    var done = function() {
	      self.panelContainer.removeClass('md-panel-is-showing');
	      resolve(self);
	    };
	    var warnAndClose = function() {
	      self._$log.warn(
	          'mdPanel: MdPanel Animations failed. ' +
	          'Hiding panel without animating.');
	      done();
	    };
	
	    animationConfig.animateClose(self.panelEl)
	        .then(done, warnAndClose);
	  });
	};
	
	
	/**
	 * Registers a interceptor with the panel. The callback should return a promise,
	 * which will allow the action to continue when it gets resolved, or will
	 * prevent an action if it is rejected.
	 * @param {string} type Type of interceptor.
	 * @param {!angular.$q.Promise<!any>} callback Callback to be registered.
	 * @returns {!MdPanelRef}
	 */
	MdPanelRef.prototype.registerInterceptor = function(type, callback) {
	  var error = null;
	
	  if (!angular.isString(type)) {
	    error = 'Interceptor type must be a string, instead got ' + typeof type;
	  } else if (!angular.isFunction(callback)) {
	    error = 'Interceptor callback must be a function, instead got ' + typeof callback;
	  }
	
	  if (error) {
	    throw new Error('MdPanel: ' + error);
	  }
	
	  var interceptors = this._interceptors[type] = this._interceptors[type] || [];
	
	  if (interceptors.indexOf(callback) === -1) {
	    interceptors.push(callback);
	  }
	
	  return this;
	};
	
	
	/**
	 * Removes a registered interceptor.
	 * @param {string} type Type of interceptor to be removed.
	 * @param {Function} callback Interceptor to be removed.
	 * @returns {!MdPanelRef}
	 */
	MdPanelRef.prototype.removeInterceptor = function(type, callback) {
	  var index = this._interceptors[type] ?
	    this._interceptors[type].indexOf(callback) : -1;
	
	  if (index > -1) {
	    this._interceptors[type].splice(index, 1);
	  }
	
	  return this;
	};
	
	
	/**
	 * Removes all interceptors.
	 * @param {string=} type Type of interceptors to be removed.
	 *     If ommited, all interceptors types will be removed.
	 * @returns {!MdPanelRef}
	 */
	MdPanelRef.prototype.removeAllInterceptors = function(type) {
	  if (type) {
	    this._interceptors[type] = [];
	  } else {
	    this._interceptors = Object.create(null);
	  }
	
	  return this;
	};
	
	
	/**
	 * Invokes all the interceptors of a certain type sequantially in
	 *     reverse order. Works in a similar way to `$q.all`, except it
	 *     respects the order of the functions.
	 * @param {string} type Type of interceptors to be invoked.
	 * @returns {!angular.$q.Promise<!MdPanelRef>}
	 * @private
	 */
	MdPanelRef.prototype._callInterceptors = function(type) {
	  var self = this;
	  var $q = self._$q;
	  var interceptors = self._interceptors && self._interceptors[type] || [];
	
	  return interceptors.reduceRight(function(promise, interceptor) {
	    var isPromiseLike = interceptor && angular.isFunction(interceptor.then);
	    var response = isPromiseLike ? interceptor : null;
	
	    /**
	    * For interceptors to reject/cancel subsequent portions of the chain, simply
	    * return a `$q.reject(<value>)`
	    */
	    return promise.then(function() {
	      if (!response) {
	        try {
	          response = interceptor(self);
	        } catch(e) {
	          response = $q.reject(e);
	        }
	      }
	
	     return response;
	    });
	  }, $q.resolve(self));
	};
	
	
	/**
	 * Faster, more basic than angular.bind
	 * http://jsperf.com/angular-bind-vs-custom-vs-native
	 * @param {function} callback
	 * @param {!Object} self
	 * @return {function} Callback function with a bound self.
	 */
	MdPanelRef.prototype._simpleBind = function(callback, self) {
	  return function(value) {
	    return callback.apply(self, value);
	  };
	};
	
	
	/**
	 * @param {function} callback
	 * @param {!Object} self
	 * @return {function} Callback function with a self param.
	 */
	MdPanelRef.prototype._done = function(callback, self) {
	  return function() {
	    callback(self);
	  };
	};
	
	
	/**
	 * Adds a panel to a group if the panel does not exist within the group already.
	 * A panel can only exist within a single group.
	 * @param {string} groupName The name of the group.
	 */
	MdPanelRef.prototype.addToGroup = function(groupName) {
	  if (!this._$mdPanel._groups[groupName]) {
	    this._$mdPanel.newPanelGroup(groupName);
	  }
	
	  var group = this._$mdPanel._groups[groupName];
	  var index = group.panels.indexOf(this);
	
	  if (index < 0) {
	    group.panels.push(this);
	  }
	};
	
	
	/**
	 * Removes a panel from a group if the panel exists within that group. The group
	 * must be created ahead of time.
	 * @param {string} groupName The name of the group.
	 */
	MdPanelRef.prototype.removeFromGroup = function(groupName) {
	  if (!this._$mdPanel._groups[groupName]) {
	    throw new Error('mdPanel: The group ' + groupName + ' does not exist.');
	  }
	
	  var group = this._$mdPanel._groups[groupName];
	  var index = group.panels.indexOf(this);
	
	  if (index > -1) {
	    group.panels.splice(index, 1);
	  }
	};
	
	
	/**
	 * Possible default closeReasons for the close function.
	 * @enum {string}
	 */
	MdPanelRef.closeReasons = {
	  CLICK_OUTSIDE: 'clickOutsideToClose',
	  ESCAPE: 'escapeToClose',
	};
	
	
	/*****************************************************************************
	 *                               MdPanelPosition                             *
	 *****************************************************************************/
	
	
	/**
	 * Position configuration object. To use, create an MdPanelPosition with the
	 * desired properties, then pass the object as part of $mdPanel creation.
	 *
	 * Example:
	 *
	 * var panelPosition = new MdPanelPosition()
	 *     .relativeTo(myButtonEl)
	 *     .addPanelPosition(
	 *       $mdPanel.xPosition.CENTER,
	 *       $mdPanel.yPosition.ALIGN_TOPS
	 *     );
	 *
	 * $mdPanel.create({
	 *   position: panelPosition
	 * });
	 *
	 * @param {!angular.$injector} $injector
	 * @final @constructor
	 */
	function MdPanelPosition($injector) {
	  /** @private @const {!angular.$window} */
	  this._$window = $injector.get('$window');
	
	  /** @private {boolean} */
	  this._isRTL = $injector.get('$mdUtil').bidi() === 'rtl';
	
	  /** @private @const {!angular.$mdConstant} */
	  this._$mdConstant = $injector.get('$mdConstant');
	
	  /** @private {boolean} */
	  this._absolute = false;
	
	  /** @private {!angular.JQLite} */
	  this._relativeToEl;
	
	  /** @private {string} */
	  this._top = '';
	
	  /** @private {string} */
	  this._bottom = '';
	
	  /** @private {string} */
	  this._left = '';
	
	  /** @private {string} */
	  this._right = '';
	
	  /** @private {!Array<string>} */
	  this._translateX = [];
	
	  /** @private {!Array<string>} */
	  this._translateY = [];
	
	  /** @private {!Array<{x:string, y:string}>} */
	  this._positions = [];
	
	  /** @private {?{x:string, y:string}} */
	  this._actualPosition;
	}
	
	
	/**
	 * Possible values of xPosition.
	 * @enum {string}
	 */
	MdPanelPosition.xPosition = {
	  CENTER: 'center',
	  ALIGN_START: 'align-start',
	  ALIGN_END: 'align-end',
	  OFFSET_START: 'offset-start',
	  OFFSET_END: 'offset-end'
	};
	
	
	/**
	 * Possible values of yPosition.
	 * @enum {string}
	 */
	MdPanelPosition.yPosition = {
	  CENTER: 'center',
	  ALIGN_TOPS: 'align-tops',
	  ALIGN_BOTTOMS: 'align-bottoms',
	  ABOVE: 'above',
	  BELOW: 'below'
	};
	
	
	/**
	 * Possible values of absolute position.
	 * @enum {string}
	 */
	MdPanelPosition.absPosition = {
	  TOP: 'top',
	  RIGHT: 'right',
	  BOTTOM: 'bottom',
	  LEFT: 'left'
	};
	
	/**
	 * Margin between the edges of a panel and the viewport.
	 * @const {number}
	 */
	MdPanelPosition.viewportMargin = 8;
	
	
	/**
	 * Sets absolute positioning for the panel.
	 * @return {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.absolute = function() {
	  this._absolute = true;
	  return this;
	};
	
	
	/**
	 * Sets the value of a position for the panel. Clears any previously set
	 * position.
	 * @param {string} position Position to set
	 * @param {string=} value Value of the position. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 * @private
	 */
	MdPanelPosition.prototype._setPosition = function(position, value) {
	  if (position === MdPanelPosition.absPosition.RIGHT ||
	      position === MdPanelPosition.absPosition.LEFT) {
	    this._left = this._right = '';
	  } else if (
	      position === MdPanelPosition.absPosition.BOTTOM ||
	      position === MdPanelPosition.absPosition.TOP) {
	    this._top = this._bottom = '';
	  } else {
	    var positions = Object.keys(MdPanelPosition.absPosition).join()
	        .toLowerCase();
	
	    throw new Error('mdPanel: Position must be one of ' + positions + '.');
	  }
	
	  this['_' +  position] = angular.isString(value) ? value : '0';
	
	  return this;
	};
	
	
	/**
	 * Sets the value of `top` for the panel. Clears any previously set vertical
	 * position.
	 * @param {string=} top Value of `top`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.top = function(top) {
	  return this._setPosition(MdPanelPosition.absPosition.TOP, top);
	};
	
	
	/**
	 * Sets the value of `bottom` for the panel. Clears any previously set vertical
	 * position.
	 * @param {string=} bottom Value of `bottom`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.bottom = function(bottom) {
	  return this._setPosition(MdPanelPosition.absPosition.BOTTOM, bottom);
	};
	
	
	/**
	 * Sets the panel to the start of the page - `left` if `ltr` or `right` for
	 * `rtl`. Clears any previously set horizontal position.
	 * @param {string=} start Value of position. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.start = function(start) {
	  var position = this._isRTL ? MdPanelPosition.absPosition.RIGHT : MdPanelPosition.absPosition.LEFT;
	  return this._setPosition(position, start);
	};
	
	
	/**
	 * Sets the panel to the end of the page - `right` if `ltr` or `left` for `rtl`.
	 * Clears any previously set horizontal position.
	 * @param {string=} end Value of position. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.end = function(end) {
	  var position = this._isRTL ? MdPanelPosition.absPosition.LEFT : MdPanelPosition.absPosition.RIGHT;
	  return this._setPosition(position, end);
	};
	
	
	/**
	 * Sets the value of `left` for the panel. Clears any previously set
	 * horizontal position.
	 * @param {string=} left Value of `left`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.left = function(left) {
	  return this._setPosition(MdPanelPosition.absPosition.LEFT, left);
	};
	
	
	/**
	 * Sets the value of `right` for the panel. Clears any previously set
	 * horizontal position.
	 * @param {string=} right Value of `right`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	*/
	MdPanelPosition.prototype.right = function(right) {
	  return this._setPosition(MdPanelPosition.absPosition.RIGHT, right);
	};
	
	
	/**
	 * Centers the panel horizontally in the viewport. Clears any previously set
	 * horizontal position.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.centerHorizontally = function() {
	  this._left = '50%';
	  this._right = '';
	  this._translateX = ['-50%'];
	  return this;
	};
	
	
	/**
	 * Centers the panel vertically in the viewport. Clears any previously set
	 * vertical position.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.centerVertically = function() {
	  this._top = '50%';
	  this._bottom = '';
	  this._translateY = ['-50%'];
	  return this;
	};
	
	
	/**
	 * Centers the panel horizontally and vertically in the viewport. This is
	 * equivalent to calling both `centerHorizontally` and `centerVertically`.
	 * Clears any previously set horizontal and vertical positions.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.center = function() {
	  return this.centerHorizontally().centerVertically();
	};
	
	
	/**
	 * Sets element for relative positioning.
	 * @param {string|!Element|!angular.JQLite} element Query selector, DOM element,
	 *     or angular element to set the panel relative to.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.relativeTo = function(element) {
	  this._absolute = false;
	  this._relativeToEl = getElement(element);
	  return this;
	};
	
	
	/**
	 * Sets the x and y positions for the panel relative to another element.
	 * @param {string} xPosition must be one of the MdPanelPosition.xPosition
	 *     values.
	 * @param {string} yPosition must be one of the MdPanelPosition.yPosition
	 *     values.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.addPanelPosition = function(xPosition, yPosition) {
	  if (!this._relativeToEl) {
	    throw new Error('mdPanel: addPanelPosition can only be used with ' +
	        'relative positioning. Set relativeTo first.');
	  }
	
	  this._validateXPosition(xPosition);
	  this._validateYPosition(yPosition);
	
	  this._positions.push({
	      x: xPosition,
	      y: yPosition,
	  });
	  return this;
	};
	
	
	/**
	 * Ensures that yPosition is a valid position name. Throw an exception if not.
	 * @param {string} yPosition
	 */
	MdPanelPosition.prototype._validateYPosition = function(yPosition) {
	  // empty is ok
	  if (yPosition == null) {
	      return;
	  }
	
	  var positionKeys = Object.keys(MdPanelPosition.yPosition);
	  var positionValues = [];
	  for (var key, i = 0; key = positionKeys[i]; i++) {
	    var position = MdPanelPosition.yPosition[key];
	    positionValues.push(position);
	
	    if (position === yPosition) {
	      return;
	    }
	  }
	
	  throw new Error('mdPanel: Panel y position only accepts the following ' +
	      'values:\n' + positionValues.join(' | '));
	};
	
	
	/**
	 * Ensures that xPosition is a valid position name. Throw an exception if not.
	 * @param {string} xPosition
	 */
	MdPanelPosition.prototype._validateXPosition = function(xPosition) {
	  // empty is ok
	  if (xPosition == null) {
	      return;
	  }
	
	  var positionKeys = Object.keys(MdPanelPosition.xPosition);
	  var positionValues = [];
	  for (var key, i = 0; key = positionKeys[i]; i++) {
	    var position = MdPanelPosition.xPosition[key];
	    positionValues.push(position);
	    if (position === xPosition) {
	      return;
	    }
	  }
	
	  throw new Error('mdPanel: Panel x Position only accepts the following ' +
	      'values:\n' + positionValues.join(' | '));
	};
	
	
	/**
	 * Sets the value of the offset in the x-direction. This will add to any
	 * previously set offsets.
	 * @param {string|function(MdPanelPosition): string} offsetX
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.withOffsetX = function(offsetX) {
	  this._translateX.push(offsetX);
	  return this;
	};
	
	
	/**
	 * Sets the value of the offset in the y-direction. This will add to any
	 * previously set offsets.
	 * @param {string|function(MdPanelPosition): string} offsetY
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.withOffsetY = function(offsetY) {
	  this._translateY.push(offsetY);
	  return this;
	};
	
	
	/**
	 * Gets the value of `top` for the panel.
	 * @returns {string}
	 */
	MdPanelPosition.prototype.getTop = function() {
	  return this._top;
	};
	
	
	/**
	 * Gets the value of `bottom` for the panel.
	 * @returns {string}
	 */
	MdPanelPosition.prototype.getBottom = function() {
	  return this._bottom;
	};
	
	
	/**
	 * Gets the value of `left` for the panel.
	 * @returns {string}
	 */
	MdPanelPosition.prototype.getLeft = function() {
	  return this._left;
	};
	
	
	/**
	 * Gets the value of `right` for the panel.
	 * @returns {string}
	 */
	MdPanelPosition.prototype.getRight = function() {
	  return this._right;
	};
	
	
	/**
	 * Gets the value of `transform` for the panel.
	 * @returns {string}
	 */
	MdPanelPosition.prototype.getTransform = function() {
	  var translateX = this._reduceTranslateValues('translateX', this._translateX);
	  var translateY = this._reduceTranslateValues('translateY', this._translateY);
	
	  // It's important to trim the result, because the browser will ignore the set
	  // operation if the string contains only whitespace.
	  return (translateX + ' ' + translateY).trim();
	};
	
	
	/**
	 * Sets the `transform` value for a panel element.
	 * @param {!angular.JQLite} panelEl
	 * @returns {!angular.JQLite}
	 * @private
	 */
	MdPanelPosition.prototype._setTransform = function(panelEl) {
	  return panelEl.css(this._$mdConstant.CSS.TRANSFORM, this.getTransform());
	};
	
	
	/**
	 * True if the panel is completely on-screen with this positioning; false
	 * otherwise.
	 * @param {!angular.JQLite} panelEl
	 * @return {boolean}
	 * @private
	 */
	MdPanelPosition.prototype._isOnscreen = function(panelEl) {
	  // this works because we always use fixed positioning for the panel,
	  // which is relative to the viewport.
	  var left = parseInt(this.getLeft());
	  var top = parseInt(this.getTop());
	
	  if (this._translateX.length || this._translateY.length) {
	    var prefixedTransform = this._$mdConstant.CSS.TRANSFORM;
	    var offsets = getComputedTranslations(panelEl, prefixedTransform);
	    left += offsets.x;
	    top += offsets.y;
	  }
	
	  var right = left + panelEl[0].offsetWidth;
	  var bottom = top + panelEl[0].offsetHeight;
	
	  return (left >= 0) &&
	    (top >= 0) &&
	    (bottom <= this._$window.innerHeight) &&
	    (right <= this._$window.innerWidth);
	};
	
	
	/**
	 * Gets the first x/y position that can fit on-screen.
	 * @returns {{x: string, y: string}}
	 */
	MdPanelPosition.prototype.getActualPosition = function() {
	  return this._actualPosition;
	};
	
	
	/**
	 * Reduces a list of translate values to a string that can be used within
	 * transform.
	 * @param {string} translateFn
	 * @param {!Array<string>} values
	 * @returns {string}
	 * @private
	 */
	MdPanelPosition.prototype._reduceTranslateValues =
	    function(translateFn, values) {
	      return values.map(function(translation) {
	        // TODO(crisbeto): this should add the units after #9609 is merged.
	        var translationValue = angular.isFunction(translation) ?
	            translation(this) : translation;
	        return translateFn + '(' + translationValue + ')';
	      }, this).join(' ');
	    };
	
	
	/**
	 * Sets the panel position based on the created panel element and best x/y
	 * positioning.
	 * @param {!angular.JQLite} panelEl
	 * @private
	 */
	MdPanelPosition.prototype._setPanelPosition = function(panelEl) {
	  // Remove the "position adjusted" class in case it has been added before.
	  panelEl.removeClass('_md-panel-position-adjusted');
	
	  // Only calculate the position if necessary.
	  if (this._absolute) {
	    this._setTransform(panelEl);
	    return;
	  }
	
	  if (this._actualPosition) {
	    this._calculatePanelPosition(panelEl, this._actualPosition);
	    this._setTransform(panelEl);
	    this._constrainToViewport(panelEl);
	    return;
	  }
	
	  for (var i = 0; i < this._positions.length; i++) {
	    this._actualPosition = this._positions[i];
	    this._calculatePanelPosition(panelEl, this._actualPosition);
	    this._setTransform(panelEl);
	
	    if (this._isOnscreen(panelEl)) {
	      return;
	    }
	  }
	
	  this._constrainToViewport(panelEl);
	};
	
	
	/**
	 * Constrains a panel's position to the viewport.
	 * @param {!angular.JQLite} panelEl
	 * @private
	 */
	MdPanelPosition.prototype._constrainToViewport = function(panelEl) {
	  var margin = MdPanelPosition.viewportMargin;
	  var initialTop = this._top;
	  var initialLeft = this._left;
	
	  if (this.getTop()) {
	    var top = parseInt(this.getTop());
	    var bottom = panelEl[0].offsetHeight + top;
	    var viewportHeight = this._$window.innerHeight;
	
	    if (top < margin) {
	      this._top = margin + 'px';
	    } else if (bottom > viewportHeight) {
	      this._top = top - (bottom - viewportHeight + margin) + 'px';
	    }
	  }
	
	  if (this.getLeft()) {
	    var left = parseInt(this.getLeft());
	    var right = panelEl[0].offsetWidth + left;
	    var viewportWidth = this._$window.innerWidth;
	
	    if (left < margin) {
	      this._left = margin + 'px';
	    } else if (right > viewportWidth) {
	      this._left = left - (right - viewportWidth + margin) + 'px';
	    }
	  }
	
	  // Class that can be used to re-style the panel if it was repositioned.
	  panelEl.toggleClass(
	    '_md-panel-position-adjusted',
	    this._top !== initialTop || this._left !== initialLeft
	  );
	};
	
	
	/**
	 * Switches between 'start' and 'end'.
	 * @param {string} position Horizontal position of the panel
	 * @returns {string} Reversed position
	 * @private
	 */
	MdPanelPosition.prototype._reverseXPosition = function(position) {
	  if (position === MdPanelPosition.xPosition.CENTER) {
	    return;
	  }
	
	  var start = 'start';
	  var end = 'end';
	
	  return position.indexOf(start) > -1 ? position.replace(start, end) : position.replace(end, start);
	};
	
	
	/**
	 * Handles horizontal positioning in rtl or ltr environments.
	 * @param {string} position Horizontal position of the panel
	 * @returns {string} The correct position according the page direction
	 * @private
	 */
	MdPanelPosition.prototype._bidi = function(position) {
	  return this._isRTL ? this._reverseXPosition(position) : position;
	};
	
	
	/**
	 * Calculates the panel position based on the created panel element and the
	 * provided positioning.
	 * @param {!angular.JQLite} panelEl
	 * @param {!{x:string, y:string}} position
	 * @private
	 */
	MdPanelPosition.prototype._calculatePanelPosition = function(panelEl, position) {
	
	  var panelBounds = panelEl[0].getBoundingClientRect();
	  var panelWidth = panelBounds.width;
	  var panelHeight = panelBounds.height;
	
	  var targetBounds = this._relativeToEl[0].getBoundingClientRect();
	
	  var targetLeft = targetBounds.left;
	  var targetRight = targetBounds.right;
	  var targetWidth = targetBounds.width;
	
	  switch (this._bidi(position.x)) {
	    case MdPanelPosition.xPosition.OFFSET_START:
	      this._left = targetLeft - panelWidth + 'px';
	      break;
	    case MdPanelPosition.xPosition.ALIGN_END:
	      this._left = targetRight - panelWidth + 'px';
	      break;
	    case MdPanelPosition.xPosition.CENTER:
	      var left = targetLeft + (0.5 * targetWidth) - (0.5 * panelWidth);
	      this._left = left + 'px';
	      break;
	    case MdPanelPosition.xPosition.ALIGN_START:
	      this._left = targetLeft + 'px';
	      break;
	    case MdPanelPosition.xPosition.OFFSET_END:
	      this._left = targetRight + 'px';
	      break;
	  }
	
	  var targetTop = targetBounds.top;
	  var targetBottom = targetBounds.bottom;
	  var targetHeight = targetBounds.height;
	
	  switch (position.y) {
	    case MdPanelPosition.yPosition.ABOVE:
	      this._top = targetTop - panelHeight + 'px';
	      break;
	    case MdPanelPosition.yPosition.ALIGN_BOTTOMS:
	      this._top = targetBottom - panelHeight + 'px';
	      break;
	    case MdPanelPosition.yPosition.CENTER:
	      var top = targetTop + (0.5 * targetHeight) - (0.5 * panelHeight);
	      this._top = top + 'px';
	      break;
	    case MdPanelPosition.yPosition.ALIGN_TOPS:
	      this._top = targetTop + 'px';
	      break;
	    case MdPanelPosition.yPosition.BELOW:
	      this._top = targetBottom + 'px';
	      break;
	  }
	};
	
	
	/*****************************************************************************
	 *                               MdPanelAnimation                            *
	 *****************************************************************************/
	
	
	/**
	 * Animation configuration object. To use, create an MdPanelAnimation with the
	 * desired properties, then pass the object as part of $mdPanel creation.
	 *
	 * Example:
	 *
	 * var panelAnimation = new MdPanelAnimation()
	 *     .openFrom(myButtonEl)
	 *     .closeTo('.my-button')
	 *     .withAnimation($mdPanel.animation.SCALE);
	 *
	 * $mdPanel.create({
	 *   animation: panelAnimation
	 * });
	 *
	 * @param {!angular.$injector} $injector
	 * @final @constructor
	 */
	function MdPanelAnimation($injector) {
	  /** @private @const {!angular.$mdUtil} */
	  this._$mdUtil = $injector.get('$mdUtil');
	
	  /**
	   * @private {{element: !angular.JQLite|undefined, bounds: !DOMRect}|
	   *     undefined}
	   */
	  this._openFrom;
	
	  /**
	   * @private {{element: !angular.JQLite|undefined, bounds: !DOMRect}|
	   *     undefined}
	   */
	  this._closeTo;
	
	  /** @private {string|{open: string, close: string}} */
	  this._animationClass = '';
	
	  /** @private {number} */
	  this._openDuration;
	
	  /** @private {number} */
	  this._closeDuration;
	
	  /** @private {number|{open: number, close: number}} */
	  this._rawDuration;
	}
	
	
	/**
	 * Possible default animations.
	 * @enum {string}
	 */
	MdPanelAnimation.animation = {
	  SLIDE: 'md-panel-animate-slide',
	  SCALE: 'md-panel-animate-scale',
	  FADE: 'md-panel-animate-fade'
	};
	
	
	/**
	 * Specifies where to start the open animation. `openFrom` accepts a
	 * click event object, query selector, DOM element, or a Rect object that
	 * is used to determine the bounds. When passed a click event, the location
	 * of the click will be used as the position to start the animation.
	 * @param {string|!Element|!Event|{top: number, left: number}} openFrom
	 * @returns {!MdPanelAnimation}
	 */
	MdPanelAnimation.prototype.openFrom = function(openFrom) {
	  // Check if 'openFrom' is an Event.
	  openFrom = openFrom.target ? openFrom.target : openFrom;
	
	  this._openFrom = this._getPanelAnimationTarget(openFrom);
	
	  if (!this._closeTo) {
	    this._closeTo = this._openFrom;
	  }
	  return this;
	};
	
	
	/**
	 * Specifies where to animate the panel close. `closeTo` accepts a
	 * query selector, DOM element, or a Rect object that is used to determine
	 * the bounds.
	 * @param {string|!Element|{top: number, left: number}} closeTo
	 * @returns {!MdPanelAnimation}
	 */
	MdPanelAnimation.prototype.closeTo = function(closeTo) {
	  this._closeTo = this._getPanelAnimationTarget(closeTo);
	  return this;
	};
	
	
	/**
	 * Specifies the duration of the animation in milliseconds.
	 * @param {number|{open: number, close: number}} duration
	 * @returns {!MdPanelAnimation}
	 */
	MdPanelAnimation.prototype.duration = function(duration) {
	  if (duration) {
	    if (angular.isNumber(duration)) {
	      this._openDuration = this._closeDuration = toSeconds(duration);
	    } else if (angular.isObject(duration)) {
	      this._openDuration = toSeconds(duration.open);
	      this._closeDuration = toSeconds(duration.close);
	    }
	  }
	
	  // Save the original value so it can be passed to the backdrop.
	  this._rawDuration = duration;
	
	  return this;
	
	  function toSeconds(value) {
	    if (angular.isNumber(value)) return value / 1000;
	  }
	};
	
	
	/**
	 * Returns the element and bounds for the animation target.
	 * @param {string|!Element|{top: number, left: number}} location
	 * @returns {{element: !angular.JQLite|undefined, bounds: !DOMRect}}
	 * @private
	 */
	MdPanelAnimation.prototype._getPanelAnimationTarget = function(location) {
	  if (angular.isDefined(location.top) || angular.isDefined(location.left)) {
	    return {
	      element: undefined,
	      bounds: {
	        top: location.top || 0,
	        left: location.left || 0
	      }
	    };
	  } else {
	    return this._getBoundingClientRect(getElement(location));
	  }
	};
	
	
	/**
	 * Specifies the animation class.
	 *
	 * There are several default animations that can be used:
	 * (MdPanelAnimation.animation)
	 *   SLIDE: The panel slides in and out from the specified
	 *        elements.
	 *   SCALE: The panel scales in and out.
	 *   FADE: The panel fades in and out.
	 *
	 * @param {string|{open: string, close: string}} cssClass
	 * @returns {!MdPanelAnimation}
	 */
	MdPanelAnimation.prototype.withAnimation = function(cssClass) {
	  this._animationClass = cssClass;
	  return this;
	};
	
	
	/**
	 * Animate the panel open.
	 * @param {!angular.JQLite} panelEl
	 * @returns {!angular.$q.Promise} A promise that is resolved when the open
	 *     animation is complete.
	 */
	MdPanelAnimation.prototype.animateOpen = function(panelEl) {
	  var animator = this._$mdUtil.dom.animator;
	
	  this._fixBounds(panelEl);
	  var animationOptions = {};
	
	  // Include the panel transformations when calculating the animations.
	  var panelTransform = panelEl[0].style.transform || '';
	
	  var openFrom = animator.toTransformCss(panelTransform);
	  var openTo = animator.toTransformCss(panelTransform);
	
	  switch (this._animationClass) {
	    case MdPanelAnimation.animation.SLIDE:
	      // Slide should start with opacity: 1.
	      panelEl.css('opacity', '1');
	
	      animationOptions = {
	        transitionInClass: '_md-panel-animate-enter'
	      };
	
	      var openSlide = animator.calculateSlideToOrigin(
	              panelEl, this._openFrom) || '';
	      openFrom = animator.toTransformCss(openSlide + ' ' + panelTransform);
	      break;
	
	    case MdPanelAnimation.animation.SCALE:
	      animationOptions = {
	        transitionInClass: '_md-panel-animate-enter'
	      };
	
	      var openScale = animator.calculateZoomToOrigin(
	              panelEl, this._openFrom) || '';
	      openFrom = animator.toTransformCss(openScale + ' ' + panelTransform);
	      break;
	
	    case MdPanelAnimation.animation.FADE:
	      animationOptions = {
	        transitionInClass: '_md-panel-animate-enter'
	      };
	      break;
	
	    default:
	      if (angular.isString(this._animationClass)) {
	        animationOptions = {
	          transitionInClass: this._animationClass
	        };
	      } else {
	        animationOptions = {
	          transitionInClass: this._animationClass['open'],
	          transitionOutClass: this._animationClass['close'],
	        };
	      }
	  }
	
	  animationOptions.duration = this._openDuration;
	
	  return animator
	      .translate3d(panelEl, openFrom, openTo, animationOptions);
	};
	
	
	/**
	 * Animate the panel close.
	 * @param {!angular.JQLite} panelEl
	 * @returns {!angular.$q.Promise} A promise that resolves when the close
	 *     animation is complete.
	 */
	MdPanelAnimation.prototype.animateClose = function(panelEl) {
	  var animator = this._$mdUtil.dom.animator;
	  var reverseAnimationOptions = {};
	
	  // Include the panel transformations when calculating the animations.
	  var panelTransform = panelEl[0].style.transform || '';
	
	  var closeFrom = animator.toTransformCss(panelTransform);
	  var closeTo = animator.toTransformCss(panelTransform);
	
	  switch (this._animationClass) {
	    case MdPanelAnimation.animation.SLIDE:
	      // Slide should start with opacity: 1.
	      panelEl.css('opacity', '1');
	      reverseAnimationOptions = {
	        transitionInClass: '_md-panel-animate-leave'
	      };
	
	      var closeSlide = animator.calculateSlideToOrigin(
	              panelEl, this._closeTo) || '';
	      closeTo = animator.toTransformCss(closeSlide + ' ' + panelTransform);
	      break;
	
	    case MdPanelAnimation.animation.SCALE:
	      reverseAnimationOptions = {
	        transitionInClass: '_md-panel-animate-scale-out _md-panel-animate-leave'
	      };
	
	      var closeScale = animator.calculateZoomToOrigin(
	              panelEl, this._closeTo) || '';
	      closeTo = animator.toTransformCss(closeScale + ' ' + panelTransform);
	      break;
	
	    case MdPanelAnimation.animation.FADE:
	      reverseAnimationOptions = {
	        transitionInClass: '_md-panel-animate-fade-out _md-panel-animate-leave'
	      };
	      break;
	
	    default:
	      if (angular.isString(this._animationClass)) {
	        reverseAnimationOptions = {
	          transitionOutClass: this._animationClass
	        };
	      } else {
	        reverseAnimationOptions = {
	          transitionInClass: this._animationClass['close'],
	          transitionOutClass: this._animationClass['open']
	        };
	      }
	  }
	
	  reverseAnimationOptions.duration = this._closeDuration;
	
	  return animator
	      .translate3d(panelEl, closeFrom, closeTo, reverseAnimationOptions);
	};
	
	
	/**
	 * Set the height and width to match the panel if not provided.
	 * @param {!angular.JQLite} panelEl
	 * @private
	 */
	MdPanelAnimation.prototype._fixBounds = function(panelEl) {
	  var panelWidth = panelEl[0].offsetWidth;
	  var panelHeight = panelEl[0].offsetHeight;
	
	  if (this._openFrom && this._openFrom.bounds.height == null) {
	    this._openFrom.bounds.height = panelHeight;
	  }
	  if (this._openFrom && this._openFrom.bounds.width == null) {
	    this._openFrom.bounds.width = panelWidth;
	  }
	  if (this._closeTo && this._closeTo.bounds.height == null) {
	    this._closeTo.bounds.height = panelHeight;
	  }
	  if (this._closeTo && this._closeTo.bounds.width == null) {
	    this._closeTo.bounds.width = panelWidth;
	  }
	};
	
	
	/**
	 * Identify the bounding RECT for the target element.
	 * @param {!angular.JQLite} element
	 * @returns {{element: !angular.JQLite|undefined, bounds: !DOMRect}}
	 * @private
	 */
	MdPanelAnimation.prototype._getBoundingClientRect = function(element) {
	  if (element instanceof angular.element) {
	    return {
	      element: element,
	      bounds: element[0].getBoundingClientRect()
	    };
	  }
	};
	
	
	/*****************************************************************************
	 *                                Util Methods                               *
	 *****************************************************************************/
	
	
	/**
	 * Returns the angular element associated with a css selector or element.
	 * @param el {string|!angular.JQLite|!Element}
	 * @returns {!angular.JQLite}
	 */
	function getElement(el) {
	  var queryResult = angular.isString(el) ?
	      document.querySelector(el) : el;
	  return angular.element(queryResult);
	}
	
	
	/**
	 * Gets the computed values for an element's translateX and translateY in px.
	 * @param {!angular.JQLite|!Element} el
	 * @param {string} property
	 * @return {{x: number, y: number}}
	 */
	function getComputedTranslations(el, property) {
	  // The transform being returned by `getComputedStyle` is in the format:
	  // `matrix(a, b, c, d, translateX, translateY)` if defined and `none`
	  // if the element doesn't have a transform.
	  var transform = getComputedStyle(el[0] || el)[property];
	  var openIndex = transform.indexOf('(');
	  var closeIndex = transform.lastIndexOf(')');
	  var output = { x: 0, y: 0 };
	
	  if (openIndex > -1 && closeIndex > -1) {
	    var parsedValues = transform
	      .substring(openIndex + 1, closeIndex)
	      .split(', ')
	      .slice(-2);
	
	    output.x = parseInt(parsedValues[0]);
	    output.y = parseInt(parsedValues[1]);
	  }
	
	  return output;
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.progressLinear
	 * @description Linear Progress module!
	 */
	MdProgressLinearDirective.$inject = ["$mdTheming", "$mdUtil", "$log"];
	angular.module('material.components.progressLinear', [
	  'material.core'
	])
	  .directive('mdProgressLinear', MdProgressLinearDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdProgressLinear
	 * @module material.components.progressLinear
	 * @restrict E
	 *
	 * @description
	 * The linear progress directive is used to make loading content
	 * in your app as delightful and painless as possible by minimizing
	 * the amount of visual change a user sees before they can view
	 * and interact with content.
	 *
	 * Each operation should only be represented by one activity indicator
	 * For example: one refresh operation should not display both a
	 * refresh bar and an activity circle.
	 *
	 * For operations where the percentage of the operation completed
	 * can be determined, use a determinate indicator. They give users
	 * a quick sense of how long an operation will take.
	 *
	 * For operations where the user is asked to wait a moment while
	 * something finishes up, and it’s not necessary to expose what's
	 * happening behind the scenes and how long it will take, use an
	 * indeterminate indicator.
	 *
	 * @param {string} md-mode Select from one of four modes: determinate, indeterminate, buffer or query.
	 *
	 * Note: if the `md-mode` value is set as undefined or specified as 1 of the four (4) valid modes, then `indeterminate`
	 * will be auto-applied as the mode.
	 *
	 * Note: if not configured, the `md-mode="indeterminate"` will be auto injected as an attribute. If `value=""` is also specified, however,
	 * then `md-mode="determinate"` would be auto-injected instead.
	 * @param {number=} value In determinate and buffer modes, this number represents the percentage of the primary progress bar. Default: 0
	 * @param {number=} md-buffer-value In the buffer mode, this number represents the percentage of the secondary progress bar. Default: 0
	 * @param {boolean=} ng-disabled Determines whether to disable the progress element.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-progress-linear md-mode="determinate" value="..."></md-progress-linear>
	 *
	 * <md-progress-linear md-mode="determinate" ng-value="..."></md-progress-linear>
	 *
	 * <md-progress-linear md-mode="indeterminate"></md-progress-linear>
	 *
	 * <md-progress-linear md-mode="buffer" value="..." md-buffer-value="..."></md-progress-linear>
	 *
	 * <md-progress-linear md-mode="query"></md-progress-linear>
	 * </hljs>
	 */
	function MdProgressLinearDirective($mdTheming, $mdUtil, $log) {
	  var MODE_DETERMINATE = "determinate";
	  var MODE_INDETERMINATE = "indeterminate";
	  var MODE_BUFFER = "buffer";
	  var MODE_QUERY = "query";
	  var DISABLED_CLASS = "_md-progress-linear-disabled";
	
	  return {
	    restrict: 'E',
	    template: '<div class="md-container">' +
	      '<div class="md-dashed"></div>' +
	      '<div class="md-bar md-bar1"></div>' +
	      '<div class="md-bar md-bar2"></div>' +
	      '</div>',
	    compile: compile
	  };
	
	  function compile(tElement, tAttrs, transclude) {
	    tElement.attr('aria-valuemin', 0);
	    tElement.attr('aria-valuemax', 100);
	    tElement.attr('role', 'progressbar');
	
	    return postLink;
	  }
	  function postLink(scope, element, attr) {
	    $mdTheming(element);
	
	    var lastMode;
	    var isDisabled = attr.hasOwnProperty('disabled');
	    var toVendorCSS = $mdUtil.dom.animator.toCss;
	    var bar1 = angular.element(element[0].querySelector('.md-bar1'));
	    var bar2 = angular.element(element[0].querySelector('.md-bar2'));
	    var container = angular.element(element[0].querySelector('.md-container'));
	
	    element
	      .attr('md-mode', mode())
	      .toggleClass(DISABLED_CLASS, isDisabled);
	
	    validateMode();
	    watchAttributes();
	
	    /**
	     * Watch the value, md-buffer-value, and md-mode attributes
	     */
	    function watchAttributes() {
	      attr.$observe('value', function(value) {
	        var percentValue = clamp(value);
	        element.attr('aria-valuenow', percentValue);
	
	        if (mode() != MODE_QUERY) animateIndicator(bar2, percentValue);
	      });
	
	      attr.$observe('mdBufferValue', function(value) {
	        animateIndicator(bar1, clamp(value));
	      });
	
	      attr.$observe('disabled', function(value) {
	        if (value === true || value === false) {
	          isDisabled = !!value;
	        } else {
	          isDisabled = angular.isDefined(value);
	        }
	
	        element.toggleClass(DISABLED_CLASS, isDisabled);
	        container.toggleClass(lastMode, !isDisabled);
	      });
	
	      attr.$observe('mdMode', function(mode) {
	        if (lastMode) container.removeClass( lastMode );
	
	        switch( mode ) {
	          case MODE_QUERY:
	          case MODE_BUFFER:
	          case MODE_DETERMINATE:
	          case MODE_INDETERMINATE:
	            container.addClass( lastMode = "md-mode-" + mode );
	            break;
	          default:
	            container.addClass( lastMode = "md-mode-" + MODE_INDETERMINATE );
	            break;
	        }
	      });
	    }
	
	    /**
	     * Auto-defaults the mode to either `determinate` or `indeterminate` mode; if not specified
	     */
	    function validateMode() {
	      if ( angular.isUndefined(attr.mdMode) ) {
	        var hasValue = angular.isDefined(attr.value);
	        var mode = hasValue ? MODE_DETERMINATE : MODE_INDETERMINATE;
	        var info = "Auto-adding the missing md-mode='{0}' to the ProgressLinear element";
	
	        //$log.debug( $mdUtil.supplant(info, [mode]) );
	
	        element.attr("md-mode", mode);
	        attr.mdMode = mode;
	      }
	    }
	
	    /**
	     * Is the md-mode a valid option?
	     */
	    function mode() {
	      var value = (attr.mdMode || "").trim();
	      if ( value ) {
	        switch(value) {
	          case MODE_DETERMINATE:
	          case MODE_INDETERMINATE:
	          case MODE_BUFFER:
	          case MODE_QUERY:
	            break;
	          default:
	            value = MODE_INDETERMINATE;
	            break;
	        }
	      }
	      return value;
	    }
	
	    /**
	     * Manually set CSS to animate the Determinate indicator based on the specified
	     * percentage value (0-100).
	     */
	    function animateIndicator(target, value) {
	      if ( isDisabled || !mode() ) return;
	
	      var to = $mdUtil.supplant("translateX({0}%) scale({1},1)", [ (value-100)/2, value/100 ]);
	      var styles = toVendorCSS({ transform : to });
	      angular.element(target).css( styles );
	    }
	  }
	
	  /**
	   * Clamps the value to be between 0 and 100.
	   * @param {number} value The value to clamp.
	   * @returns {number}
	   */
	  function clamp(value) {
	    return Math.max(0, Math.min(value || 0, 100));
	  }
	}
	
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.radioButton
	 * @description radioButton module!
	 */
	mdRadioGroupDirective.$inject = ["$mdUtil", "$mdConstant", "$mdTheming", "$timeout"];
	mdRadioButtonDirective.$inject = ["$mdAria", "$mdUtil", "$mdTheming"];
	angular.module('material.components.radioButton', [
	  'material.core'
	])
	  .directive('mdRadioGroup', mdRadioGroupDirective)
	  .directive('mdRadioButton', mdRadioButtonDirective);
	
	/**
	 * @ngdoc directive
	 * @module material.components.radioButton
	 * @name mdRadioGroup
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-radio-group>` directive identifies a grouping
	 * container for the 1..n grouped radio buttons; specified using nested
	 * `<md-radio-button>` tags.
	 *
	 * As per the [material design spec](http://www.google.com/design/spec/style/color.html#color-ui-color-application)
	 * the radio button is in the accent color by default. The primary color palette may be used with
	 * the `md-primary` class.
	 *
	 * Note: `<md-radio-group>` and `<md-radio-button>` handle tabindex differently
	 * than the native `<input type='radio'>` controls. Whereas the native controls
	 * force the user to tab through all the radio buttons, `<md-radio-group>`
	 * is focusable, and by default the `<md-radio-button>`s are not.
	 *
	 * @param {string} ng-model Assignable angular expression to data-bind to.
	 * @param {boolean=} md-no-ink Use of attribute indicates flag to disable ink ripple effects.
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	 *    interaction with the input element.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-radio-group ng-model="selected">
	 *
	 *   <md-radio-button
	 *        ng-repeat="d in colorOptions"
	 *        ng-value="d.value" aria-label="{{ d.label }}">
	 *
	 *          {{ d.label }}
	 *
	 *   </md-radio-button>
	 *
	 * </md-radio-group>
	 * </hljs>
	 *
	 */
	function mdRadioGroupDirective($mdUtil, $mdConstant, $mdTheming, $timeout) {
	  RadioGroupController.prototype = createRadioGroupControllerProto();
	
	  return {
	    restrict: 'E',
	    controller: ['$element', RadioGroupController],
	    require: ['mdRadioGroup', '?ngModel'],
	    link: { pre: linkRadioGroup }
	  };
	
	  function linkRadioGroup(scope, element, attr, ctrls) {
	    element.addClass('_md');     // private md component indicator for styling
	    $mdTheming(element);
	
	    var rgCtrl = ctrls[0];
	    var ngModelCtrl = ctrls[1] || $mdUtil.fakeNgModel();
	
	    rgCtrl.init(ngModelCtrl);
	
	    scope.mouseActive = false;
	
	    element
	      .attr({
	        'role': 'radiogroup',
	        'tabIndex': element.attr('tabindex') || '0'
	      })
	      .on('keydown', keydownListener)
	      .on('mousedown', function(event) {
	        scope.mouseActive = true;
	        $timeout(function() {
	          scope.mouseActive = false;
	        }, 100);
	      })
	      .on('focus', function() {
	        if(scope.mouseActive === false) {
	          rgCtrl.$element.addClass('md-focused');
	        }
	      })
	      .on('blur', function() {
	        rgCtrl.$element.removeClass('md-focused');
	      });
	
	    /**
	     *
	     */
	    function setFocus() {
	      if (!element.hasClass('md-focused')) { element.addClass('md-focused'); }
	    }
	
	    /**
	     *
	     */
	    function keydownListener(ev) {
	      var keyCode = ev.which || ev.keyCode;
	
	      // Only listen to events that we originated ourselves
	      // so that we don't trigger on things like arrow keys in
	      // inputs.
	
	      if (keyCode != $mdConstant.KEY_CODE.ENTER &&
	          ev.currentTarget != ev.target) {
	        return;
	      }
	
	      switch (keyCode) {
	        case $mdConstant.KEY_CODE.LEFT_ARROW:
	        case $mdConstant.KEY_CODE.UP_ARROW:
	          ev.preventDefault();
	          rgCtrl.selectPrevious();
	          setFocus();
	          break;
	
	        case $mdConstant.KEY_CODE.RIGHT_ARROW:
	        case $mdConstant.KEY_CODE.DOWN_ARROW:
	          ev.preventDefault();
	          rgCtrl.selectNext();
	          setFocus();
	          break;
	
	        case $mdConstant.KEY_CODE.ENTER:
	          var form = angular.element($mdUtil.getClosest(element[0], 'form'));
	          if (form.length > 0) {
	            form.triggerHandler('submit');
	          }
	          break;
	      }
	
	    }
	  }
	
	  function RadioGroupController($element) {
	    this._radioButtonRenderFns = [];
	    this.$element = $element;
	  }
	
	  function createRadioGroupControllerProto() {
	    return {
	      init: function(ngModelCtrl) {
	        this._ngModelCtrl = ngModelCtrl;
	        this._ngModelCtrl.$render = angular.bind(this, this.render);
	      },
	      add: function(rbRender) {
	        this._radioButtonRenderFns.push(rbRender);
	      },
	      remove: function(rbRender) {
	        var index = this._radioButtonRenderFns.indexOf(rbRender);
	        if (index !== -1) {
	          this._radioButtonRenderFns.splice(index, 1);
	        }
	      },
	      render: function() {
	        this._radioButtonRenderFns.forEach(function(rbRender) {
	          rbRender();
	        });
	      },
	      setViewValue: function(value, eventType) {
	        this._ngModelCtrl.$setViewValue(value, eventType);
	        // update the other radio buttons as well
	        this.render();
	      },
	      getViewValue: function() {
	        return this._ngModelCtrl.$viewValue;
	      },
	      selectNext: function() {
	        return changeSelectedButton(this.$element, 1);
	      },
	      selectPrevious: function() {
	        return changeSelectedButton(this.$element, -1);
	      },
	      setActiveDescendant: function (radioId) {
	        this.$element.attr('aria-activedescendant', radioId);
	      },
	      isDisabled: function() {
	        return this.$element[0].hasAttribute('disabled');
	      }
	    };
	  }
	  /**
	   * Change the radio group's selected button by a given increment.
	   * If no button is selected, select the first button.
	   */
	  function changeSelectedButton(parent, increment) {
	    // Coerce all child radio buttons into an array, then wrap then in an iterator
	    var buttons = $mdUtil.iterator(parent[0].querySelectorAll('md-radio-button'), true);
	
	    if (buttons.count()) {
	      var validate = function (button) {
	        // If disabled, then NOT valid
	        return !angular.element(button).attr("disabled");
	      };
	
	      var selected = parent[0].querySelector('md-radio-button.md-checked');
	      var target = buttons[increment < 0 ? 'previous' : 'next'](selected, validate) || buttons.first();
	
	      // Activate radioButton's click listener (triggerHandler won't create a real click event)
	      angular.element(target).triggerHandler('click');
	    }
	  }
	
	}
	
	/**
	 * @ngdoc directive
	 * @module material.components.radioButton
	 * @name mdRadioButton
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-radio-button>`directive is the child directive required to be used within `<md-radio-group>` elements.
	 *
	 * While similar to the `<input type="radio" ng-model="" value="">` directive,
	 * the `<md-radio-button>` directive provides ink effects, ARIA support, and
	 * supports use within named radio groups.
	 *
	 * @param {string} ngValue AngularJS expression which sets the value to which the expression should
	 *    be set when selected.
	 * @param {string} value The value to which the expression should be set when selected.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} aria-label Adds label to radio button for accessibility.
	 * Defaults to radio button's text. If no text content is available, a warning will be logged.
	 *
	 * @usage
	 * <hljs lang="html">
	 *
	 * <md-radio-button value="1" aria-label="Label 1">
	 *   Label 1
	 * </md-radio-button>
	 *
	 * <md-radio-button ng-value="specialValue" aria-label="Green">
	 *   Green
	 * </md-radio-button>
	 *
	 * </hljs>
	 *
	 */
	function mdRadioButtonDirective($mdAria, $mdUtil, $mdTheming) {
	
	  var CHECKED_CSS = 'md-checked';
	
	  return {
	    restrict: 'E',
	    require: '^mdRadioGroup',
	    transclude: true,
	    template: '<div class="md-container" md-ink-ripple md-ink-ripple-checkbox>' +
	                '<div class="md-off"></div>' +
	                '<div class="md-on"></div>' +
	              '</div>' +
	              '<div ng-transclude class="md-label"></div>',
	    link: link
	  };
	
	  function link(scope, element, attr, rgCtrl) {
	    var lastChecked;
	
	    $mdTheming(element);
	    configureAria(element, scope);
	
	    // ngAria overwrites the aria-checked inside a $watch for ngValue.
	    // We should defer the initialization until all the watches have fired.
	    // This can also be fixed by removing the `lastChecked` check, but that'll
	    // cause more DOM manipulation on each digest.
	    if (attr.ngValue) {
	      $mdUtil.nextTick(initialize, false);
	    } else {
	      initialize();
	    }
	
	    /**
	     * Initializes the component.
	     */
	    function initialize() {
	      if (!rgCtrl) {
	        throw 'RadioButton: No RadioGroupController could be found.';
	      }
	
	      rgCtrl.add(render);
	      attr.$observe('value', render);
	
	      element
	        .on('click', listener)
	        .on('$destroy', function() {
	          rgCtrl.remove(render);
	        });
	    }
	
	    /**
	     * On click functionality.
	     */
	    function listener(ev) {
	      if (element[0].hasAttribute('disabled') || rgCtrl.isDisabled()) return;
	
	      scope.$apply(function() {
	        rgCtrl.setViewValue(attr.value, ev && ev.type);
	      });
	    }
	
	    /**
	     *  Add or remove the `.md-checked` class from the RadioButton (and conditionally its parent).
	     *  Update the `aria-activedescendant` attribute.
	     */
	    function render() {
	      var checked = rgCtrl.getViewValue() == attr.value;
	
	      if (checked === lastChecked) return;
	
	      if (element[0].parentNode.nodeName.toLowerCase() !== 'md-radio-group') {
	        // If the radioButton is inside a div, then add class so highlighting will work
	        element.parent().toggleClass(CHECKED_CSS, checked);
	      }
	
	      if (checked) {
	        rgCtrl.setActiveDescendant(element.attr('id'));
	      }
	
	      lastChecked = checked;
	
	      element
	        .attr('aria-checked', checked)
	        .toggleClass(CHECKED_CSS, checked);
	    }
	
	    /**
	     * Inject ARIA-specific attributes appropriate for each radio button
	     */
	    function configureAria(element, scope){
	      element.attr({
	        id: attr.id || 'radio_' + $mdUtil.nextUid(),
	        role: 'radio',
	        'aria-checked': 'false'
	      });
	
	      $mdAria.expectWithText(element, 'aria-label');
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.showHide
	 */
	
	// Add additional handlers to ng-show and ng-hide that notify directives
	// contained within that they should recompute their size.
	// These run in addition to AngularJS's built-in ng-hide and ng-show directives.
	angular.module('material.components.showHide', [
	  'material.core'
	])
	  .directive('ngShow', createDirective('ngShow', true))
	  .directive('ngHide', createDirective('ngHide', false));
	
	
	function createDirective(name, targetValue) {
	  return ['$mdUtil', '$window', function($mdUtil, $window) {
	    return {
	      restrict: 'A',
	      multiElement: true,
	      link: function($scope, $element, $attr) {
	        var unregister = $scope.$on('$md-resize-enable', function() {
	          unregister();
	
	          var node = $element[0];
	          var cachedTransitionStyles = node.nodeType === $window.Node.ELEMENT_NODE ?
	            $window.getComputedStyle(node) : {};
	
	          $scope.$watch($attr[name], function(value) {
	            if (!!value === targetValue) {
	              $mdUtil.nextTick(function() {
	                $scope.$broadcast('$md-resize');
	              });
	
	              var opts = {
	                cachedTransitionStyles: cachedTransitionStyles
	              };
	
	              $mdUtil.dom.animator.waitTransitionEnd($element, opts).then(function() {
	                $scope.$broadcast('$md-resize');
	              });
	            }
	          });
	        });
	      }
	    };
	  }];
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.sidenav
	 *
	 * @description
	 * A Sidenav QP component.
	 */
	SidenavService.$inject = ["$mdComponentRegistry", "$mdUtil", "$q", "$log"];
	SidenavDirective.$inject = ["$mdMedia", "$mdUtil", "$mdConstant", "$mdTheming", "$mdInteraction", "$animate", "$compile", "$parse", "$log", "$q", "$document", "$window", "$$rAF"];
	SidenavController.$inject = ["$scope", "$attrs", "$mdComponentRegistry", "$q", "$interpolate"];
	angular
	  .module('material.components.sidenav', [
	    'material.core',
	    'material.components.backdrop'
	  ])
	  .factory('$mdSidenav', SidenavService )
	  .directive('mdSidenav', SidenavDirective)
	  .directive('mdSidenavFocus', SidenavFocusDirective)
	  .controller('$mdSidenavController', SidenavController);
	
	
	/**
	 * @ngdoc service
	 * @name $mdSidenav
	 * @module material.components.sidenav
	 *
	 * @description
	 * `$mdSidenav` makes it easy to interact with multiple sidenavs
	 * in an app. When looking up a sidenav instance, you can either look
	 * it up synchronously or wait for it to be initializied asynchronously.
	 * This is done by passing the second argument to `$mdSidenav`.
	 *
	 * @usage
	 * <hljs lang="js">
	 * // Async lookup for sidenav instance; will resolve when the instance is available
	 * $mdSidenav(componentId, true).then(function(instance) {
	 *   $log.debug( componentId + "is now ready" );
	 * });
	 * // Sync lookup for sidenav instance; this will resolve immediately.
	 * $mdSidenav(componentId).then(function(instance) {
	 *   $log.debug( componentId + "is now ready" );
	 * });
	 * // Async toggle the given sidenav;
	 * // when instance is known ready and lazy lookup is not needed.
	 * $mdSidenav(componentId)
	 *    .toggle()
	 *    .then(function(){
	 *      $log.debug('toggled');
	 *    });
	 * // Async open the given sidenav
	 * $mdSidenav(componentId)
	 *    .open()
	 *    .then(function(){
	 *      $log.debug('opened');
	 *    });
	 * // Async close the given sidenav
	 * $mdSidenav(componentId)
	 *    .close()
	 *    .then(function(){
	 *      $log.debug('closed');
	 *    });
	 * // Sync check to see if the specified sidenav is set to be open
	 * $mdSidenav(componentId).isOpen();
	 * // Sync check to whether given sidenav is locked open
	 * // If this is true, the sidenav will be open regardless of close()
	 * $mdSidenav(componentId).isLockedOpen();
	 * // On close callback to handle close, backdrop click or escape key pressed
	 * // Callback happens BEFORE the close action occurs.
	 * $mdSidenav(componentId).onClose(function () {
	 *   $log.debug('closing');
	 * });
	 * </hljs>
	 */
	function SidenavService($mdComponentRegistry, $mdUtil, $q, $log) {
	  var errorMsg = "SideNav '{0}' is not available! Did you use md-component-id='{0}'?";
	  var service = {
	        find    : findInstance,     //  sync  - returns proxy API
	        waitFor : waitForInstance   //  async - returns promise
	      };
	
	  /**
	   * Service API that supports three (3) usages:
	   *   $mdSidenav().find("left")                       // sync (must already exist) or returns undefined
	   *   $mdSidenav("left").toggle();                    // sync (must already exist) or returns reject promise;
	   *   $mdSidenav("left",true).then( function(left){   // async returns instance when available
	   *    left.toggle();
	   *   });
	   */
	  return function(handle, enableWait) {
	    if ( angular.isUndefined(handle) ) return service;
	
	    var shouldWait = enableWait === true;
	    var instance = service.find(handle, shouldWait);
	    return  !instance && shouldWait ? service.waitFor(handle) :
	            !instance && angular.isUndefined(enableWait) ? addLegacyAPI(service, handle) : instance;
	  };
	
	  /**
	   * For failed instance/handle lookups, older-clients expect an response object with noops
	   * that include `rejected promise APIs`
	   */
	  function addLegacyAPI(service, handle) {
	      var falseFn  = function() { return false; };
	      var rejectFn = function() {
	            return $q.when($mdUtil.supplant(errorMsg, [handle || ""]));
	          };
	
	      return angular.extend({
	        isLockedOpen : falseFn,
	        isOpen       : falseFn,
	        toggle       : rejectFn,
	        open         : rejectFn,
	        close        : rejectFn,
	        onClose      : angular.noop,
	        then : function(callback) {
	          return waitForInstance(handle)
	            .then(callback || angular.noop);
	        }
	       }, service);
	    }
	    /**
	     * Synchronously lookup the controller instance for the specified sidNav instance which has been
	     * registered with the markup `md-component-id`
	     */
	    function findInstance(handle, shouldWait) {
	      var instance = $mdComponentRegistry.get(handle);
	
	      if (!instance && !shouldWait) {
	
	        // Report missing instance
	        $log.error( $mdUtil.supplant(errorMsg, [handle || ""]) );
	
	        // The component has not registered itself... most like NOT yet created
	        // return null to indicate that the Sidenav is not in the DOM
	        return undefined;
	      }
	      return instance;
	    }
	
	    /**
	     * Asynchronously wait for the component instantiation,
	     * Deferred lookup of component instance using $component registry
	     */
	    function waitForInstance(handle) {
	      return $mdComponentRegistry.when(handle).catch($log.error);
	    }
	}
	/**
	 * @ngdoc directive
	 * @name mdSidenavFocus
	 * @module material.components.sidenav
	 *
	 * @restrict A
	 *
	 * @description
	 * `mdSidenavFocus` provides a way to specify the focused element when a sidenav opens.
	 * This is completely optional, as the sidenav itself is focused by default.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-sidenav>
	 *   <form>
	 *     <md-input-container>
	 *       <label for="testInput">Label</label>
	 *       <input id="testInput" type="text" md-sidenav-focus>
	 *     </md-input-container>
	 *   </form>
	 * </md-sidenav>
	 * </hljs>
	 **/
	function SidenavFocusDirective() {
	  return {
	    restrict: 'A',
	    require: '^mdSidenav',
	    link: function(scope, element, attr, sidenavCtrl) {
	      // @see $mdUtil.findFocusTarget(...)
	    }
	  };
	}
	/**
	 * @ngdoc directive
	 * @name mdSidenav
	 * @module material.components.sidenav
	 * @restrict E
	 *
	 * @description
	 *
	 * A Sidenav component that can be opened and closed programatically.
	 *
	 * By default, upon opening it will slide out on top of the main content area.
	 *
	 * For keyboard and screen reader accessibility, focus is sent to the sidenav wrapper by default.
	 * It can be overridden with the `md-autofocus` directive on the child element you want focused.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div layout="row" ng-controller="MyController">
	 *   <md-sidenav md-component-id="left" class="md-sidenav-left">
	 *     Left Nav!
	 *   </md-sidenav>
	 *
	 *   <md-content>
	 *     Center Content
	 *     <md-button ng-click="openLeftMenu()">
	 *       Open Left Menu
	 *     </md-button>
	 *   </md-content>
	 *
	 *   <md-sidenav md-component-id="right"
	 *     md-is-locked-open="$mdMedia('min-width: 333px')"
	 *     class="md-sidenav-right">
	 *     <form>
	 *       <md-input-container>
	 *         <label for="testInput">Test input</label>
	 *         <input id="testInput" type="text"
	 *                ng-model="data" md-autofocus>
	 *       </md-input-container>
	 *     </form>
	 *   </md-sidenav>
	 * </div>
	 * </hljs>
	 *
	 * <hljs lang="js">
	 * var app = angular.module('myApp', ['ngMaterial']);
	 * app.controller('MyController', function($scope, $mdSidenav) {
	 *   $scope.openLeftMenu = function() {
	 *     $mdSidenav('left').toggle();
	 *   };
	 * });
	 * </hljs>
	 *
	 * @param {expression=} md-is-open A model bound to whether the sidenav is opened.
	 * @param {boolean=} md-disable-backdrop When present in the markup, the sidenav will not show a backdrop.
	 * @param {string=} md-component-id componentId to use with $mdSidenav service.
	 * @param {expression=} md-is-locked-open When this expression evaluates to true,
	 * the sidenav 'locks open': it falls into the content's flow instead
	 * of appearing over it. This overrides the `md-is-open` attribute.
	 * @param {string=} md-disable-scroll-target Selector, pointing to an element, whose scrolling will
	 * be disabled when the sidenav is opened. By default this is the sidenav's direct parent.
	 *
	* The $mdMedia() service is exposed to the is-locked-open attribute, which
	 * can be given a media query or one of the `sm`, `gt-sm`, `md`, `gt-md`, `lg` or `gt-lg` presets.
	 * Examples:
	 *
	 *   - `<md-sidenav md-is-locked-open="shouldLockOpen"></md-sidenav>`
	 *   - `<md-sidenav md-is-locked-open="$mdMedia('min-width: 1000px')"></md-sidenav>`
	 *   - `<md-sidenav md-is-locked-open="$mdMedia('sm')"></md-sidenav>` (locks open on small screens)
	 */
	function SidenavDirective($mdMedia, $mdUtil, $mdConstant, $mdTheming, $mdInteraction, $animate,
	                          $compile, $parse, $log, $q, $document, $window, $$rAF) {
	  return {
	    restrict: 'E',
	    scope: {
	      isOpen: '=?mdIsOpen'
	    },
	    controller: '$mdSidenavController',
	    compile: function(element) {
	      element.addClass('md-closed').attr('tabIndex', '-1');
	      return postLink;
	    }
	  };
	
	  /**
	   * Directive Post Link function...
	   */
	  function postLink(scope, element, attr, sidenavCtrl) {
	    var lastParentOverFlow;
	    var backdrop;
	    var disableScrollTarget = null;
	    var triggeringInteractionType;
	    var triggeringElement = null;
	    var previousContainerStyles;
	    var promise = $q.when(true);
	    var isLockedOpenParsed = $parse(attr.mdIsLockedOpen);
	    var ngWindow = angular.element($window);
	    var isLocked = function() {
	      return isLockedOpenParsed(scope.$parent, {
	        $media: function(arg) {
	          $log.warn("$media is deprecated for is-locked-open. Use $mdMedia instead.");
	          return $mdMedia(arg);
	        },
	        $mdMedia: $mdMedia
	      });
	    };
	
	    if (attr.mdDisableScrollTarget) {
	      disableScrollTarget = $document[0].querySelector(attr.mdDisableScrollTarget);
	
	      if (disableScrollTarget) {
	        disableScrollTarget = angular.element(disableScrollTarget);
	      } else {
	        $log.warn($mdUtil.supplant('mdSidenav: couldn\'t find element matching ' +
	          'selector "{selector}". Falling back to parent.', { selector: attr.mdDisableScrollTarget }));
	      }
	    }
	
	    if (!disableScrollTarget) {
	      disableScrollTarget = element.parent();
	    }
	
	    // Only create the backdrop if the backdrop isn't disabled.
	    if (!attr.hasOwnProperty('mdDisableBackdrop')) {
	      backdrop = $mdUtil.createBackdrop(scope, "md-sidenav-backdrop md-opaque ng-enter");
	    }
	
	    element.addClass('_md');     // private md component indicator for styling
	    $mdTheming(element);
	
	    // The backdrop should inherit the sidenavs theme,
	    // because the backdrop will take its parent theme by default.
	    if ( backdrop ) $mdTheming.inherit(backdrop, element);
	
	    element.on('$destroy', function() {
	      backdrop && backdrop.remove();
	      sidenavCtrl.destroy();
	    });
	
	    scope.$on('$destroy', function(){
	      backdrop && backdrop.remove();
	    });
	
	    scope.$watch(isLocked, updateIsLocked);
	    scope.$watch('isOpen', updateIsOpen);
	
	
	    // Publish special accessor for the Controller instance
	    sidenavCtrl.$toggleOpen = toggleOpen;
	
	    /**
	     * Toggle the DOM classes to indicate `locked`
	     * @param isLocked
	     */
	    function updateIsLocked(isLocked, oldValue) {
	      scope.isLockedOpen = isLocked;
	      if (isLocked === oldValue) {
	        element.toggleClass('md-locked-open', !!isLocked);
	      } else {
	        $animate[isLocked ? 'addClass' : 'removeClass'](element, 'md-locked-open');
	      }
	      if (backdrop) {
	        backdrop.toggleClass('md-locked-open', !!isLocked);
	      }
	    }
	
	    /**
	     * Toggle the SideNav view and attach/detach listeners
	     * @param isOpen
	     */
	    function updateIsOpen(isOpen) {
	      // Support deprecated md-sidenav-focus attribute as fallback
	      var focusEl = $mdUtil.findFocusTarget(element) || $mdUtil.findFocusTarget(element,'[md-sidenav-focus]') || element;
	      var parent = element.parent();
	
	      parent[isOpen ? 'on' : 'off']('keydown', onKeyDown);
	      if (backdrop) backdrop[isOpen ? 'on' : 'off']('click', close);
	
	      var restorePositioning = updateContainerPositions(parent, isOpen);
	
	      if ( isOpen ) {
	        // Capture upon opening..
	        triggeringElement = $document[0].activeElement;
	        triggeringInteractionType = $mdInteraction.getLastInteractionType();
	      }
	
	      disableParentScroll(isOpen);
	
	      return promise = $q.all([
	        isOpen && backdrop ? $animate.enter(backdrop, parent) : backdrop ?
	                             $animate.leave(backdrop) : $q.when(true),
	        $animate[isOpen ? 'removeClass' : 'addClass'](element, 'md-closed')
	      ]).then(function() {
	        // Perform focus when animations are ALL done...
	        if (scope.isOpen) {
	          $$rAF(function() {
	            // Notifies child components that the sidenav was opened. Should wait
	            // a frame in order to allow for the element height to be computed.
	            ngWindow.triggerHandler('resize');
	          });
	
	          focusEl && focusEl.focus();
	        }
	
	        // Restores the positioning on the sidenav and backdrop.
	        restorePositioning && restorePositioning();
	      });
	    }
	
	    function updateContainerPositions(parent, willOpen) {
	      var drawerEl = element[0];
	      var scrollTop = parent[0].scrollTop;
	
	      if (willOpen && scrollTop) {
	        previousContainerStyles = {
	          top: drawerEl.style.top,
	          bottom: drawerEl.style.bottom,
	          height: drawerEl.style.height
	        };
	
	        // When the parent is scrolled down, then we want to be able to show the sidenav at the current scroll
	        // position. We're moving the sidenav down to the correct scroll position and apply the height of the
	        // parent, to increase the performance. Using 100% as height, will impact the performance heavily.
	        var positionStyle = {
	          top: scrollTop + 'px',
	          bottom: 'auto',
	          height: parent[0].clientHeight + 'px'
	        };
	
	        // Apply the new position styles to the sidenav and backdrop.
	        element.css(positionStyle);
	        backdrop.css(positionStyle);
	      }
	
	      // When the sidenav is closing and we have previous defined container styles,
	      // then we return a restore function, which resets the sidenav and backdrop.
	      if (!willOpen && previousContainerStyles) {
	        return function() {
	          drawerEl.style.top = previousContainerStyles.top;
	          drawerEl.style.bottom = previousContainerStyles.bottom;
	          drawerEl.style.height = previousContainerStyles.height;
	
	          backdrop[0].style.top = null;
	          backdrop[0].style.bottom = null;
	          backdrop[0].style.height = null;
	
	          previousContainerStyles = null;
	        };
	      }
	    }
	
	    /**
	     * Prevent parent scrolling (when the SideNav is open)
	     */
	    function disableParentScroll(disabled) {
	      if ( disabled && !lastParentOverFlow ) {
	        lastParentOverFlow = disableScrollTarget.css('overflow');
	        disableScrollTarget.css('overflow', 'hidden');
	      } else if (angular.isDefined(lastParentOverFlow)) {
	        disableScrollTarget.css('overflow', lastParentOverFlow);
	        lastParentOverFlow = undefined;
	      }
	    }
	
	    /**
	     * Toggle the sideNav view and publish a promise to be resolved when
	     * the view animation finishes.
	     *
	     * @param isOpen
	     * @returns {*}
	     */
	    function toggleOpen( isOpen ) {
	      if (scope.isOpen == isOpen ) {
	
	        return $q.when(true);
	
	      } else {
	        if (scope.isOpen && sidenavCtrl.onCloseCb) sidenavCtrl.onCloseCb();
	
	        return $q(function(resolve){
	          // Toggle value to force an async `updateIsOpen()` to run
	          scope.isOpen = isOpen;
	
	          $mdUtil.nextTick(function() {
	            // When the current `updateIsOpen()` animation finishes
	            promise.then(function(result) {
	
	              if ( !scope.isOpen && triggeringElement && triggeringInteractionType === 'keyboard') {
	                // reset focus to originating element (if available) upon close
	                triggeringElement.focus();
	                triggeringElement = null;
	              }
	
	              resolve(result);
	            });
	          });
	
	        });
	
	      }
	    }
	
	    /**
	     * Auto-close sideNav when the `escape` key is pressed.
	     * @param evt
	     */
	    function onKeyDown(ev) {
	      var isEscape = (ev.keyCode === $mdConstant.KEY_CODE.ESCAPE);
	      return isEscape ? close(ev) : $q.when(true);
	    }
	
	    /**
	     * With backdrop `clicks` or `escape` key-press, immediately
	     * apply the CSS close transition... Then notify the controller
	     * to close() and perform its own actions.
	     */
	    function close(ev) {
	      ev.preventDefault();
	
	      return sidenavCtrl.close();
	    }
	
	  }
	}
	
	/*
	 * @private
	 * @ngdoc controller
	 * @name SidenavController
	 * @module material.components.sidenav
	 */
	function SidenavController($scope, $attrs, $mdComponentRegistry, $q, $interpolate) {
	
	  var self = this;
	
	  // Use Default internal method until overridden by directive postLink
	
	  // Synchronous getters
	  self.isOpen = function() { return !!$scope.isOpen; };
	  self.isLockedOpen = function() { return !!$scope.isLockedOpen; };
	
	  // Synchronous setters
	  self.onClose = function (callback) {
	    self.onCloseCb = callback;
	    return self;
	  };
	
	  // Async actions
	  self.open   = function() { return self.$toggleOpen( true );  };
	  self.close  = function() { return self.$toggleOpen( false ); };
	  self.toggle = function() { return self.$toggleOpen( !$scope.isOpen );  };
	  self.$toggleOpen = function(value) { return $q.when($scope.isOpen = value); };
	
	  // Evaluate the component id.
	  var rawId = $attrs.mdComponentId;
	  var hasDataBinding = rawId && rawId.indexOf($interpolate.startSymbol()) > -1;
	  var componentId = hasDataBinding ? $interpolate(rawId)($scope.$parent) : rawId;
	
	  // Register the component.
	  self.destroy = $mdComponentRegistry.register(self, componentId);
	
	  // Watch and update the component, if the id has changed.
	  if (hasDataBinding) {
	    $attrs.$observe('mdComponentId', function(id) {
	      if (id && id !== self.$$mdHandle) {
	        self.destroy(); // `destroy` only deregisters the old component id so we can add the new one.
	        self.destroy = $mdComponentRegistry.register(self, id);
	      }
	    });
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.select
	 */
	
	/***************************************************
	
	 ### TODO - POST RC1 ###
	 - [ ] Abstract placement logic in $mdSelect service to $mdMenu service
	
	 ***************************************************/
	
	SelectDirective.$inject = ["$mdSelect", "$mdUtil", "$mdConstant", "$mdTheming", "$mdAria", "$parse", "$sce", "$injector"];
	SelectMenuDirective.$inject = ["$parse", "$mdUtil", "$mdConstant", "$mdTheming"];
	OptionDirective.$inject = ["$mdButtonInkRipple", "$mdUtil", "$mdTheming"];
	SelectProvider.$inject = ["$$interimElementProvider"];
	var SELECT_EDGE_MARGIN = 8;
	var selectNextId = 0;
	var CHECKBOX_SELECTION_INDICATOR =
	  angular.element('<div class="md-container"><div class="md-icon"></div></div>');
	
	angular.module('material.components.select', [
	    'material.core',
	    'material.components.backdrop'
	  ])
	  .directive('mdSelect', SelectDirective)
	  .directive('mdSelectMenu', SelectMenuDirective)
	  .directive('mdOption', OptionDirective)
	  .directive('mdOptgroup', OptgroupDirective)
	  .directive('mdSelectHeader', SelectHeaderDirective)
	  .provider('$mdSelect', SelectProvider);
	
	/**
	 * @ngdoc directive
	 * @name mdSelect
	 * @restrict E
	 * @module material.components.select
	 *
	 * @description Displays a select box, bound to an ng-model.
	 *
	 * When the select is required and uses a floating label, then the label will automatically contain
	 * an asterisk (`*`). This behavior can be disabled by using the `md-no-asterisk` attribute.
	 *
	 * By default, the select will display with an underline to match other form elements. This can be
	 * disabled by applying the `md-no-underline` CSS class.
	 *
	 * ### Option Params
	 *
	 * When applied, `md-option-empty` will mark the option as "empty" allowing the option to  clear the
	 * select and put it back in it's default state. You may supply this attribute on any option you
	 * wish, however, it is automatically applied to an option whose `value` or `ng-value` are not
	 * defined.
	 *
	 * **Automatically Applied**
	 *
	 *  - `<md-option>`
	 *  - `<md-option value>`
	 *  - `<md-option value="">`
	 *  - `<md-option ng-value>`
	 *  - `<md-option ng-value="">`
	 *
	 * **NOT Automatically Applied**
	 *
	 *  - `<md-option ng-value="1">`
	 *  - `<md-option ng-value="''">`
	 *  - `<md-option ng-value="undefined">`
	 *  - `<md-option value="undefined">` (this evaluates to the string `"undefined"`)
	 *  - <code ng-non-bindable>&lt;md-option ng-value="{{someValueThatMightBeUndefined}}"&gt;</code>
	 *
	 * **Note:** A value of `undefined` ***is considered a valid value*** (and does not auto-apply this
	 * attribute) since you may wish this to be your "Not Available" or "None" option.
	 *
	 * **Note:** Using the `value` attribute (as opposed to `ng-value`) always evaluates to a string, so
	 * `value="null"` will require the test `ng-if="myValue != 'null'"` rather than `ng-if="!myValue"`.
	 *
	 * @param {expression} ng-model The model!
	 * @param {boolean=} multiple When set to true, allows for more than one option to be selected. The model is an array with the selected choices.
	 * @param {expression=} md-on-close Expression to be evaluated when the select is closed.
	 * @param {expression=} md-on-open Expression to be evaluated when opening the select.
	 * Will hide the select options and show a spinner until the evaluated promise resolves.
	 * @param {expression=} md-selected-text Expression to be evaluated that will return a string
	 * to be displayed as a placeholder in the select input box when it is closed. The value
	 * will be treated as *text* (not html).
	 * @param {expression=} md-selected-html Expression to be evaluated that will return a string
	 * to be displayed as a placeholder in the select input box when it is closed. The value
	 * will be treated as *html*. The value must either be explicitly marked as trustedHtml or
	 * the ngSanitize module must be loaded.
	 * @param {string=} placeholder Placeholder hint text.
	 * @param md-no-asterisk {boolean=} When set to true, an asterisk will not be appended to the
	 * floating label. **Note:** This attribute is only evaluated once; it is not watched.
	 * @param {string=} aria-label Optional label for accessibility. Only necessary if no placeholder or
	 * explicit label is present.
	 * @param {string=} md-container-class Class list to get applied to the `.md-select-menu-container`
	 * element (for custom styling).
	 *
	 * @usage
	 * With a placeholder (label and aria-label are added dynamically)
	 * <hljs lang="html">
	 *   <md-input-container>
	 *     <md-select
	 *       ng-model="someModel"
	 *       placeholder="Select a state">
	 *       <md-option ng-value="opt" ng-repeat="opt in neighborhoods2">{{ opt }}</md-option>
	 *     </md-select>
	 *   </md-input-container>
	 * </hljs>
	 *
	 * With an explicit label
	 * <hljs lang="html">
	 *   <md-input-container>
	 *     <label>State</label>
	 *     <md-select
	 *       ng-model="someModel">
	 *       <md-option ng-value="opt" ng-repeat="opt in neighborhoods2">{{ opt }}</md-option>
	 *     </md-select>
	 *   </md-input-container>
	 * </hljs>
	 *
	 * With a select-header
	 *
	 * When a developer needs to put more than just a text label in the
	 * md-select-menu, they should use the md-select-header.
	 * The user can put custom HTML inside of the header and style it to their liking.
	 * One common use case of this would be a sticky search bar.
	 *
	 * When using the md-select-header the labels that would previously be added to the
	 * OptGroupDirective are ignored.
	 *
	 * <hljs lang="html">
	 *   <md-input-container>
	 *     <md-select ng-model="someModel">
	 *       <md-select-header>
	 *         <span> Neighborhoods - </span>
	 *       </md-select-header>
	 *       <md-option ng-value="opt" ng-repeat="opt in neighborhoods2">{{ opt }}</md-option>
	 *     </md-select>
	 *   </md-input-container>
	 * </hljs>
	 *
	 * ## Selects and object equality
	 * When using a `md-select` to pick from a list of objects, it is important to realize how javascript handles
	 * equality. Consider the following example:
	 * <hljs lang="js">
	 * angular.controller('MyCtrl', function($scope) {
	 *   $scope.users = [
	 *     { id: 1, name: 'Bob' },
	 *     { id: 2, name: 'Alice' },
	 *     { id: 3, name: 'Steve' }
	 *   ];
	 *   $scope.selectedUser = { id: 1, name: 'Bob' };
	 * });
	 * </hljs>
	 * <hljs lang="html">
	 * <div ng-controller="MyCtrl">
	 *   <md-select ng-model="selectedUser">
	 *     <md-option ng-value="user" ng-repeat="user in users">{{ user.name }}</md-option>
	 *   </md-select>
	 * </div>
	 * </hljs>
	 *
	 * At first one might expect that the select should be populated with "Bob" as the selected user. However,
	 * this is not true. To determine whether something is selected,
	 * `ngModelController` is looking at whether `$scope.selectedUser == (any user in $scope.users);`;
	 *
	 * Javascript's `==` operator does not check for deep equality (ie. that all properties
	 * on the object are the same), but instead whether the objects are *the same object in memory*.
	 * In this case, we have two instances of identical objects, but they exist in memory as unique
	 * entities. Because of this, the select will have no value populated for a selected user.
	 *
	 * To get around this, `ngModelController` provides a `track by` option that allows us to specify a different
	 * expression which will be used for the equality operator. As such, we can update our `html` to
	 * make use of this by specifying the `ng-model-options="{trackBy: '$value.id'}"` on the `md-select`
	 * element. This converts our equality expression to be
	 * `$scope.selectedUser.id == (any id in $scope.users.map(function(u) { return u.id; }));`
	 * which results in Bob being selected as desired.
	 *
	 * Working HTML:
	 * <hljs lang="html">
	 * <div ng-controller="MyCtrl">
	 *   <md-select ng-model="selectedUser" ng-model-options="{trackBy: '$value.id'}">
	 *     <md-option ng-value="user" ng-repeat="user in users">{{ user.name }}</md-option>
	 *   </md-select>
	 * </div>
	 * </hljs>
	 */
	function SelectDirective($mdSelect, $mdUtil, $mdConstant, $mdTheming, $mdAria, $parse, $sce,
	    $injector) {
	  var keyCodes = $mdConstant.KEY_CODE;
	  var NAVIGATION_KEYS = [keyCodes.SPACE, keyCodes.ENTER, keyCodes.UP_ARROW, keyCodes.DOWN_ARROW];
	
	  return {
	    restrict: 'E',
	    require: ['^?mdInputContainer', 'mdSelect', 'ngModel', '?^form'],
	    compile: compile,
	    controller: function() {
	    } // empty placeholder controller to be initialized in link
	  };
	
	  function compile(element, attr) {
	    // add the select value that will hold our placeholder or selected option value
	    var valueEl = angular.element('<md-select-value><span></span></md-select-value>');
	    valueEl.append('<span class="md-select-icon" aria-hidden="true"></span>');
	    valueEl.addClass('md-select-value');
	    if (!valueEl[0].hasAttribute('id')) {
	      valueEl.attr('id', 'select_value_label_' + $mdUtil.nextUid());
	    }
	
	    // There's got to be an md-content inside. If there's not one, let's add it.
	    if (!element.find('md-content').length) {
	      element.append(angular.element('<md-content>').append(element.contents()));
	    }
	
	
	    // Add progress spinner for md-options-loading
	    if (attr.mdOnOpen) {
	
	      // Show progress indicator while loading async
	      // Use ng-hide for `display:none` so the indicator does not interfere with the options list
	      element
	        .find('md-content')
	        .prepend(angular.element(
	          '<div>' +
	          ' <md-progress-circular md-mode="indeterminate" ng-if="$$loadingAsyncDone === false" md-diameter="25px"></md-progress-circular>' +
	          '</div>'
	        ));
	
	      // Hide list [of item options] while loading async
	      element
	        .find('md-option')
	        .attr('ng-show', '$$loadingAsyncDone');
	    }
	
	    if (attr.name) {
	      var autofillClone = angular.element('<select class="md-visually-hidden">');
	      autofillClone.attr({
	        'name': attr.name,
	        'aria-hidden': 'true',
	        'tabindex': '-1'
	      });
	      var opts = element.find('md-option');
	      angular.forEach(opts, function(el) {
	        var newEl = angular.element('<option>' + el.innerHTML + '</option>');
	        if (el.hasAttribute('ng-value')) newEl.attr('ng-value', el.getAttribute('ng-value'));
	        else if (el.hasAttribute('value')) newEl.attr('value', el.getAttribute('value'));
	        autofillClone.append(newEl);
	      });
	
	      // Adds an extra option that will hold the selected value for the
	      // cases where the select is a part of a non-angular form. This can be done with a ng-model,
	      // however if the `md-option` is being `ng-repeat`-ed, AngularJS seems to insert a similar
	      // `option` node, but with a value of `? string: <value> ?` which would then get submitted.
	      // This also goes around having to prepend a dot to the name attribute.
	      autofillClone.append(
	        '<option ng-value="' + attr.ngModel + '" selected></option>'
	      );
	
	      element.parent().append(autofillClone);
	    }
	
	    var isMultiple = $mdUtil.parseAttributeBoolean(attr.multiple);
	
	    // Use everything that's left inside element.contents() as the contents of the menu
	    var multipleContent = isMultiple ? 'multiple' : '';
	    var selectTemplate = '' +
	      '<div class="md-select-menu-container" aria-hidden="true">' +
	      '<md-select-menu {0}>{1}</md-select-menu>' +
	      '</div>';
	
	    selectTemplate = $mdUtil.supplant(selectTemplate, [multipleContent, element.html()]);
	    element.empty().append(valueEl);
	    element.append(selectTemplate);
	
	    if(!attr.tabindex){
	      attr.$set('tabindex', 0);
	    }
	
	    return function postLink(scope, element, attr, ctrls) {
	      var untouched = true;
	      var isDisabled, ariaLabelBase;
	
	      var containerCtrl = ctrls[0];
	      var mdSelectCtrl = ctrls[1];
	      var ngModelCtrl = ctrls[2];
	      var formCtrl = ctrls[3];
	      // grab a reference to the select menu value label
	      var valueEl = element.find('md-select-value');
	      var isReadonly = angular.isDefined(attr.readonly);
	      var disableAsterisk = $mdUtil.parseAttributeBoolean(attr.mdNoAsterisk);
	
	      if (disableAsterisk) {
	        element.addClass('md-no-asterisk');
	      }
	
	      if (containerCtrl) {
	        var isErrorGetter = containerCtrl.isErrorGetter || function() {
	          return ngModelCtrl.$invalid && (ngModelCtrl.$touched || (formCtrl && formCtrl.$submitted));
	        };
	
	        if (containerCtrl.input) {
	          // We ignore inputs that are in the md-select-header (one
	          // case where this might be useful would be adding as searchbox)
	          if (element.find('md-select-header').find('input')[0] !== containerCtrl.input[0]) {
	            throw new Error("<md-input-container> can only have *one* child <input>, <textarea> or <select> element!");
	          }
	        }
	
	        containerCtrl.input = element;
	        if (!containerCtrl.label) {
	          $mdAria.expect(element, 'aria-label', element.attr('placeholder'));
	        }
	
	        scope.$watch(isErrorGetter, containerCtrl.setInvalid);
	      }
	
	      var selectContainer, selectScope, selectMenuCtrl;
	
	      findSelectContainer();
	      $mdTheming(element);
	
	      if (formCtrl && angular.isDefined(attr.multiple)) {
	        $mdUtil.nextTick(function() {
	          var hasModelValue = ngModelCtrl.$modelValue || ngModelCtrl.$viewValue;
	          if (hasModelValue) {
	            formCtrl.$setPristine();
	          }
	        });
	      }
	
	      var originalRender = ngModelCtrl.$render;
	      ngModelCtrl.$render = function() {
	        originalRender();
	        syncLabelText();
	        syncAriaLabel();
	        inputCheckValue();
	      };
	
	      attr.$observe('placeholder', ngModelCtrl.$render);
	
	      if (containerCtrl && containerCtrl.label) {
	        attr.$observe('required', function (value) {
	          // Toggle the md-required class on the input containers label, because the input container is automatically
	          // applying the asterisk indicator on the label.
	          containerCtrl.label.toggleClass('md-required', value && !disableAsterisk);
	        });
	      }
	
	      mdSelectCtrl.setLabelText = function(text) {
	        mdSelectCtrl.setIsPlaceholder(!text);
	
	        // Whether the select label has been given via user content rather than the internal
	        // template of <md-option>
	        var isSelectLabelFromUser = false;
	
	        if (attr.mdSelectedText && attr.mdSelectedHtml) {
	          throw Error('md-select cannot have both `md-selected-text` and `md-selected-html`');
	        }
	
	        if (attr.mdSelectedText || attr.mdSelectedHtml) {
	          text = $parse(attr.mdSelectedText || attr.mdSelectedHtml)(scope);
	          isSelectLabelFromUser = true;
	        } else if (!text) {
	          // Use placeholder attribute, otherwise fallback to the md-input-container label
	          var tmpPlaceholder = attr.placeholder ||
	              (containerCtrl && containerCtrl.label ? containerCtrl.label.text() : '');
	
	          text = tmpPlaceholder || '';
	          isSelectLabelFromUser = true;
	        }
	
	        var target = valueEl.children().eq(0);
	
	        if (attr.mdSelectedHtml) {
	            // Using getTrustedHtml will run the content through $sanitize if it is not already
	            // explicitly trusted. If the ngSanitize module is not loaded, this will
	            // *correctly* throw an sce error.
	            target.html($sce.getTrustedHtml(text));
	        } else if (isSelectLabelFromUser) {
	          target.text(text);
	        } else {
	          // If we've reached this point, the text is not user-provided.
	          target.html(text);
	        }
	      };
	
	      mdSelectCtrl.setIsPlaceholder = function(isPlaceholder) {
	        if (isPlaceholder) {
	          valueEl.addClass('md-select-placeholder');
	          if (containerCtrl && containerCtrl.label) {
	            containerCtrl.label.addClass('md-placeholder');
	          }
	        } else {
	          valueEl.removeClass('md-select-placeholder');
	          if (containerCtrl && containerCtrl.label) {
	            containerCtrl.label.removeClass('md-placeholder');
	          }
	        }
	      };
	
	      if (!isReadonly) {
	        element
	          .on('focus', function(ev) {
	            // Always focus the container (if we have one) so floating labels and other styles are
	            // applied properly
	            containerCtrl && containerCtrl.setFocused(true);
	          });
	
	        // Attach before ngModel's blur listener to stop propagation of blur event
	        // to prevent from setting $touched.
	        element.on('blur', function(event) {
	          if (untouched) {
	            untouched = false;
	            if (selectScope._mdSelectIsOpen) {
	              event.stopImmediatePropagation();
	            }
	          }
	
	          if (selectScope._mdSelectIsOpen) return;
	          containerCtrl && containerCtrl.setFocused(false);
	          inputCheckValue();
	        });
	      }
	
	      mdSelectCtrl.triggerClose = function() {
	        $parse(attr.mdOnClose)(scope);
	      };
	
	      scope.$$postDigest(function() {
	        initAriaLabel();
	        syncLabelText();
	        syncAriaLabel();
	      });
	
	      function initAriaLabel() {
	        var labelText = element.attr('aria-label') || element.attr('placeholder');
	        if (!labelText && containerCtrl && containerCtrl.label) {
	          labelText = containerCtrl.label.text();
	        }
	        ariaLabelBase = labelText;
	        $mdAria.expect(element, 'aria-label', labelText);
	      }
	
	      scope.$watch(function() {
	        return selectMenuCtrl.selectedLabels();
	      }, syncLabelText);
	
	      function syncLabelText() {
	        if (selectContainer) {
	          selectMenuCtrl = selectMenuCtrl || selectContainer.find('md-select-menu').controller('mdSelectMenu');
	          mdSelectCtrl.setLabelText(selectMenuCtrl.selectedLabels());
	        }
	      }
	
	      function syncAriaLabel() {
	        if (!ariaLabelBase) return;
	        var ariaLabels = selectMenuCtrl.selectedLabels({mode: 'aria'});
	        element.attr('aria-label', ariaLabels.length ? ariaLabelBase + ': ' + ariaLabels : ariaLabelBase);
	      }
	
	      var deregisterWatcher;
	      attr.$observe('ngMultiple', function(val) {
	        if (deregisterWatcher) deregisterWatcher();
	        var parser = $parse(val);
	        deregisterWatcher = scope.$watch(function() {
	          return parser(scope);
	        }, function(multiple, prevVal) {
	          if (multiple === undefined && prevVal === undefined) return; // assume compiler did a good job
	          if (multiple) {
	            element.attr('multiple', 'multiple');
	          } else {
	            element.removeAttr('multiple');
	          }
	          element.attr('aria-multiselectable', multiple ? 'true' : 'false');
	          if (selectContainer) {
	            selectMenuCtrl.setMultiple(multiple);
	            originalRender = ngModelCtrl.$render;
	            ngModelCtrl.$render = function() {
	              originalRender();
	              syncLabelText();
	              syncAriaLabel();
	              inputCheckValue();
	            };
	            ngModelCtrl.$render();
	          }
	        });
	      });
	
	      attr.$observe('disabled', function(disabled) {
	        if (angular.isString(disabled)) {
	          disabled = true;
	        }
	        // Prevent click event being registered twice
	        if (isDisabled !== undefined && isDisabled === disabled) {
	          return;
	        }
	        isDisabled = disabled;
	        if (disabled) {
	          element
	            .attr({'aria-disabled': 'true'})
	            .removeAttr('tabindex')
	            .off('click', openSelect)
	            .off('keydown', handleKeypress);
	        } else {
	          element
	            .attr({'tabindex': attr.tabindex, 'aria-disabled': 'false'})
	            .on('click', openSelect)
	            .on('keydown', handleKeypress);
	        }
	      });
	
	      if (!attr.hasOwnProperty('disabled') && !attr.hasOwnProperty('ngDisabled')) {
	        element.attr({'aria-disabled': 'false'});
	        element.on('click', openSelect);
	        element.on('keydown', handleKeypress);
	      }
	
	      var ariaAttrs = {
	        role: 'listbox',
	        'aria-expanded': 'false',
	        'aria-multiselectable': isMultiple && !attr.ngMultiple ? 'true' : 'false'
	      };
	
	      if (!element[0].hasAttribute('id')) {
	        ariaAttrs.id = 'select_' + $mdUtil.nextUid();
	      }
	
	      var containerId = 'select_container_' + $mdUtil.nextUid();
	      selectContainer.attr('id', containerId);
	      ariaAttrs['aria-owns'] = containerId;
	      element.attr(ariaAttrs);
	
	      scope.$on('$destroy', function() {
	        $mdSelect
	          .destroy()
	          .finally(function() {
	            if (containerCtrl) {
	              containerCtrl.setFocused(false);
	              containerCtrl.setHasValue(false);
	              containerCtrl.input = null;
	            }
	            ngModelCtrl.$setTouched();
	          });
	      });
	
	
	
	      function inputCheckValue() {
	        // The select counts as having a value if one or more options are selected,
	        // or if the input's validity state says it has bad input (eg string in a number input)
	        containerCtrl && containerCtrl.setHasValue(selectMenuCtrl.selectedLabels().length > 0 || (element[0].validity || {}).badInput);
	      }
	
	      function findSelectContainer() {
	        selectContainer = angular.element(
	          element[0].querySelector('.md-select-menu-container')
	        );
	        selectScope = scope;
	        if (attr.mdContainerClass) {
	          var value = selectContainer[0].getAttribute('class') + ' ' + attr.mdContainerClass;
	          selectContainer[0].setAttribute('class', value);
	        }
	        selectMenuCtrl = selectContainer.find('md-select-menu').controller('mdSelectMenu');
	        selectMenuCtrl.init(ngModelCtrl, attr.ngModel);
	        element.on('$destroy', function() {
	          selectContainer.remove();
	        });
	      }
	
	      function handleKeypress(e) {
	        if ($mdConstant.isNavigationKey(e)) {
	          // prevent page scrolling on interaction
	          e.preventDefault();
	          openSelect(e);
	        } else {
	          if (shouldHandleKey(e, $mdConstant)) {
	            e.preventDefault();
	
	            var node = selectMenuCtrl.optNodeForKeyboardSearch(e);
	            if (!node || node.hasAttribute('disabled')) return;
	            var optionCtrl = angular.element(node).controller('mdOption');
	            if (!selectMenuCtrl.isMultiple) {
	              selectMenuCtrl.deselect(Object.keys(selectMenuCtrl.selected)[0]);
	            }
	            selectMenuCtrl.select(optionCtrl.hashKey, optionCtrl.value);
	            selectMenuCtrl.refreshViewValue();
	          }
	        }
	      }
	
	      function openSelect() {
	        selectScope._mdSelectIsOpen = true;
	        element.attr('aria-expanded', 'true');
	
	        $mdSelect.show({
	          scope: selectScope,
	          preserveScope: true,
	          skipCompile: true,
	          element: selectContainer,
	          target: element[0],
	          selectCtrl: mdSelectCtrl,
	          preserveElement: true,
	          hasBackdrop: true,
	          loadingAsync: attr.mdOnOpen ? scope.$eval(attr.mdOnOpen) || true : false
	        }).finally(function() {
	          selectScope._mdSelectIsOpen = false;
	          element.focus();
	          element.attr('aria-expanded', 'false');
	          ngModelCtrl.$setTouched();
	        });
	      }
	
	    };
	  }
	}
	
	function SelectMenuDirective($parse, $mdUtil, $mdConstant, $mdTheming) {
	  // We want the scope to be set to 'false' so an isolated scope is not created
	  // which would interfere with the md-select-header's access to the
	  // parent scope.
	  SelectMenuController.$inject = ["$scope", "$attrs", "$element"];
	  return {
	    restrict: 'E',
	    require: ['mdSelectMenu'],
	    scope: false,
	    controller: SelectMenuController,
	    link: {pre: preLink}
	  };
	
	  // We use preLink instead of postLink to ensure that the select is initialized before
	  // its child options run postLink.
	  function preLink(scope, element, attr, ctrls) {
	    var selectCtrl = ctrls[0];
	
	    element.addClass('_md');     // private md component indicator for styling
	
	    $mdTheming(element);
	    element.on('click', clickListener);
	    element.on('keypress', keyListener);
	
	    function keyListener(e) {
	      if (e.keyCode == 13 || e.keyCode == 32) {
	        clickListener(e);
	      }
	    }
	
	    function clickListener(ev) {
	      var option = $mdUtil.getClosest(ev.target, 'md-option');
	      var optionCtrl = option && angular.element(option).data('$mdOptionController');
	      if (!option || !optionCtrl) return;
	      if (option.hasAttribute('disabled')) {
	        ev.stopImmediatePropagation();
	        return false;
	      }
	
	      var optionHashKey = selectCtrl.hashGetter(optionCtrl.value);
	      var isSelected = angular.isDefined(selectCtrl.selected[optionHashKey]);
	
	      scope.$apply(function() {
	        if (selectCtrl.isMultiple) {
	          if (isSelected) {
	            selectCtrl.deselect(optionHashKey);
	          } else {
	            selectCtrl.select(optionHashKey, optionCtrl.value);
	          }
	        } else {
	          if (!isSelected) {
	            selectCtrl.deselect(Object.keys(selectCtrl.selected)[0]);
	            selectCtrl.select(optionHashKey, optionCtrl.value);
	          }
	        }
	        selectCtrl.refreshViewValue();
	      });
	    }
	  }
	
	  function SelectMenuController($scope, $attrs, $element) {
	    var self = this;
	    self.isMultiple = angular.isDefined($attrs.multiple);
	    // selected is an object with keys matching all of the selected options' hashed values
	    self.selected = {};
	    // options is an object with keys matching every option's hash value,
	    // and values matching every option's controller.
	    self.options = {};
	
	    $scope.$watchCollection(function() {
	      return self.options;
	    }, function() {
	      self.ngModel.$render();
	    });
	
	    var deregisterCollectionWatch;
	    var defaultIsEmpty;
	    self.setMultiple = function(isMultiple) {
	      var ngModel = self.ngModel;
	      defaultIsEmpty = defaultIsEmpty || ngModel.$isEmpty;
	
	      self.isMultiple = isMultiple;
	      if (deregisterCollectionWatch) deregisterCollectionWatch();
	
	      if (self.isMultiple) {
	        ngModel.$validators['md-multiple'] = validateArray;
	        ngModel.$render = renderMultiple;
	
	        // watchCollection on the model because by default ngModel only watches the model's
	        // reference. This allowed the developer to also push and pop from their array.
	        $scope.$watchCollection(self.modelBinding, function(value) {
	          if (validateArray(value)) renderMultiple(value);
	          self.ngModel.$setPristine();
	        });
	
	        ngModel.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	      } else {
	        delete ngModel.$validators['md-multiple'];
	        ngModel.$render = renderSingular;
	      }
	
	      function validateArray(modelValue, viewValue) {
	        // If a value is truthy but not an array, reject it.
	        // If value is undefined/falsy, accept that it's an empty array.
	        return angular.isArray(modelValue || viewValue || []);
	      }
	    };
	
	    var searchStr = '';
	    var clearSearchTimeout, optNodes, optText;
	    var CLEAR_SEARCH_AFTER = 300;
	
	    self.optNodeForKeyboardSearch = function(e) {
	      clearSearchTimeout && clearTimeout(clearSearchTimeout);
	      clearSearchTimeout = setTimeout(function() {
	        clearSearchTimeout = undefined;
	        searchStr = '';
	        optText = undefined;
	        optNodes = undefined;
	      }, CLEAR_SEARCH_AFTER);
	
	      // Support 1-9 on numpad
	      var keyCode = e.keyCode - ($mdConstant.isNumPadKey(e) ? 48 : 0);
	
	      searchStr += String.fromCharCode(keyCode);
	      var search = new RegExp('^' + searchStr, 'i');
	      if (!optNodes) {
	        optNodes = $element.find('md-option');
	        optText = new Array(optNodes.length);
	        angular.forEach(optNodes, function(el, i) {
	          optText[i] = el.textContent.trim();
	        });
	      }
	      for (var i = 0; i < optText.length; ++i) {
	        if (search.test(optText[i])) {
	          return optNodes[i];
	        }
	      }
	    };
	
	    self.init = function(ngModel, binding) {
	      self.ngModel = ngModel;
	      self.modelBinding = binding;
	
	      // Setup a more robust version of isEmpty to ensure value is a valid option
	      self.ngModel.$isEmpty = function($viewValue) {
	        // We have to transform the viewValue into the hashKey, because otherwise the
	        // OptionCtrl may not exist. Developers may have specified a trackBy function.
	        return !self.options[self.hashGetter($viewValue)];
	      };
	
	      // Allow users to provide `ng-model="foo" ng-model-options="{trackBy: 'foo.id'}"` so
	      // that we can properly compare objects set on the model to the available options
	      var trackByOption = $mdUtil.getModelOption(ngModel, 'trackBy');
	
	      if (trackByOption) {
	        var trackByLocals = {};
	        var trackByParsed = $parse(trackByOption);
	        self.hashGetter = function(value, valueScope) {
	          trackByLocals.$value = value;
	          return trackByParsed(valueScope || $scope, trackByLocals);
	        };
	        // If the user doesn't provide a trackBy, we automatically generate an id for every
	        // value passed in
	      } else {
	        self.hashGetter = function getHashValue(value) {
	          if (angular.isObject(value)) {
	            return 'object_' + (value.$$mdSelectId || (value.$$mdSelectId = ++selectNextId));
	          }
	          return value;
	        };
	      }
	      self.setMultiple(self.isMultiple);
	    };
	
	    self.selectedLabels = function(opts) {
	      opts = opts || {};
	      var mode = opts.mode || 'html';
	      var selectedOptionEls = $mdUtil.nodesToArray($element[0].querySelectorAll('md-option[selected]'));
	      if (selectedOptionEls.length) {
	        var mapFn;
	
	        if (mode == 'html') {
	          // Map the given element to its innerHTML string. If the element has a child ripple
	          // container remove it from the HTML string, before returning the string.
	          mapFn = function(el) {
	            // If we do not have a `value` or `ng-value`, assume it is an empty option which clears the select
	            if (el.hasAttribute('md-option-empty')) {
	              return '';
	            }
	
	            var html = el.innerHTML;
	
	            // Remove the ripple container from the selected option, copying it would cause a CSP violation.
	            var rippleContainer = el.querySelector('.md-ripple-container');
	            if (rippleContainer) {
	              html = html.replace(rippleContainer.outerHTML, '');
	            }
	
	            // Remove the checkbox container, because it will cause the label to wrap inside of the placeholder.
	            // It should be not displayed inside of the label element.
	            var checkboxContainer = el.querySelector('.md-container');
	            if (checkboxContainer) {
	              html = html.replace(checkboxContainer.outerHTML, '');
	            }
	
	            return html;
	          };
	        } else if (mode == 'aria') {
	          mapFn = function(el) { return el.hasAttribute('aria-label') ? el.getAttribute('aria-label') : el.textContent; };
	        }
	
	        // Ensure there are no duplicates; see https://github.com/angular/material/issues/9442
	        return $mdUtil.uniq(selectedOptionEls.map(mapFn)).join(', ');
	      } else {
	        return '';
	      }
	    };
	
	    self.select = function(hashKey, hashedValue) {
	      var option = self.options[hashKey];
	      option && option.setSelected(true);
	      self.selected[hashKey] = hashedValue;
	    };
	    self.deselect = function(hashKey) {
	      var option = self.options[hashKey];
	      option && option.setSelected(false);
	      delete self.selected[hashKey];
	    };
	
	    self.addOption = function(hashKey, optionCtrl) {
	      if (angular.isDefined(self.options[hashKey])) {
	        throw new Error('Duplicate md-option values are not allowed in a select. ' +
	          'Duplicate value "' + optionCtrl.value + '" found.');
	      }
	
	      self.options[hashKey] = optionCtrl;
	
	      // If this option's value was already in our ngModel, go ahead and select it.
	      if (angular.isDefined(self.selected[hashKey])) {
	        self.select(hashKey, optionCtrl.value);
	
	        // When the current $modelValue of the ngModel Controller is using the same hash as
	        // the current option, which will be added, then we can be sure, that the validation
	        // of the option has occurred before the option was added properly.
	        // This means, that we have to manually trigger a new validation of the current option.
	        if (angular.isDefined(self.ngModel.$modelValue) && self.hashGetter(self.ngModel.$modelValue) === hashKey) {
	          self.ngModel.$validate();
	        }
	
	        self.refreshViewValue();
	      }
	    };
	    self.removeOption = function(hashKey) {
	      delete self.options[hashKey];
	      // Don't deselect an option when it's removed - the user's ngModel should be allowed
	      // to have values that do not match a currently available option.
	    };
	
	    self.refreshViewValue = function() {
	      var values = [];
	      var option;
	      for (var hashKey in self.selected) {
	        // If this hashKey has an associated option, push that option's value to the model.
	        if ((option = self.options[hashKey])) {
	          values.push(option.value);
	        } else {
	          // Otherwise, the given hashKey has no associated option, and we got it
	          // from an ngModel value at an earlier time. Push the unhashed value of
	          // this hashKey to the model.
	          // This allows the developer to put a value in the model that doesn't yet have
	          // an associated option.
	          values.push(self.selected[hashKey]);
	        }
	      }
	      var usingTrackBy = $mdUtil.getModelOption(self.ngModel, 'trackBy');
	
	      var newVal = self.isMultiple ? values : values[0];
	      var prevVal = self.ngModel.$modelValue;
	
	      if (usingTrackBy ? !angular.equals(prevVal, newVal) : (prevVal + '') !== newVal) {
	        self.ngModel.$setViewValue(newVal);
	        self.ngModel.$render();
	      }
	    };
	
	    function renderMultiple() {
	      var newSelectedValues = self.ngModel.$modelValue || self.ngModel.$viewValue || [];
	      if (!angular.isArray(newSelectedValues)) return;
	
	      var oldSelected = Object.keys(self.selected);
	
	      var newSelectedHashes = newSelectedValues.map(self.hashGetter);
	      var deselected = oldSelected.filter(function(hash) {
	        return newSelectedHashes.indexOf(hash) === -1;
	      });
	
	      deselected.forEach(self.deselect);
	      newSelectedHashes.forEach(function(hashKey, i) {
	        self.select(hashKey, newSelectedValues[i]);
	      });
	    }
	
	    function renderSingular() {
	      var value = self.ngModel.$viewValue || self.ngModel.$modelValue;
	      Object.keys(self.selected).forEach(self.deselect);
	      self.select(self.hashGetter(value), value);
	    }
	  }
	
	}
	
	function OptionDirective($mdButtonInkRipple, $mdUtil, $mdTheming) {
	
	  OptionController.$inject = ["$element"];
	  return {
	    restrict: 'E',
	    require: ['mdOption', '^^mdSelectMenu'],
	    controller: OptionController,
	    compile: compile
	  };
	
	  function compile(element, attr) {
	    // Manual transclusion to avoid the extra inner <span> that ng-transclude generates
	    element.append(angular.element('<div class="md-text">').append(element.contents()));
	
	    element.attr('tabindex', attr.tabindex || '0');
	
	    if (!hasDefinedValue(attr)) {
	      element.attr('md-option-empty', '');
	    }
	
	    return postLink;
	  }
	
	  function hasDefinedValue(attr) {
	    var value = attr.value;
	    var ngValue = attr.ngValue;
	
	    return value || ngValue;
	  }
	
	  function postLink(scope, element, attr, ctrls) {
	    var optionCtrl = ctrls[0];
	    var selectCtrl = ctrls[1];
	
	    $mdTheming(element);
	
	    if (selectCtrl.isMultiple) {
	      element.addClass('md-checkbox-enabled');
	      element.prepend(CHECKBOX_SELECTION_INDICATOR.clone());
	    }
	
	    if (angular.isDefined(attr.ngValue)) {
	      scope.$watch(attr.ngValue, setOptionValue);
	    } else if (angular.isDefined(attr.value)) {
	      setOptionValue(attr.value);
	    } else {
	      scope.$watch(function() {
	        return element.text().trim();
	      }, setOptionValue);
	    }
	
	    attr.$observe('disabled', function(disabled) {
	      if (disabled) {
	        element.attr('tabindex', '-1');
	      } else {
	        element.attr('tabindex', '0');
	      }
	    });
	
	    scope.$$postDigest(function() {
	      attr.$observe('selected', function(selected) {
	        if (!angular.isDefined(selected)) return;
	        if (typeof selected == 'string') selected = true;
	        if (selected) {
	          if (!selectCtrl.isMultiple) {
	            selectCtrl.deselect(Object.keys(selectCtrl.selected)[0]);
	          }
	          selectCtrl.select(optionCtrl.hashKey, optionCtrl.value);
	        } else {
	          selectCtrl.deselect(optionCtrl.hashKey);
	        }
	        selectCtrl.refreshViewValue();
	      });
	    });
	
	    $mdButtonInkRipple.attach(scope, element);
	    configureAria();
	
	    function setOptionValue(newValue, oldValue, prevAttempt) {
	      if (!selectCtrl.hashGetter) {
	        if (!prevAttempt) {
	          scope.$$postDigest(function() {
	            setOptionValue(newValue, oldValue, true);
	          });
	        }
	        return;
	      }
	      var oldHashKey = selectCtrl.hashGetter(oldValue, scope);
	      var newHashKey = selectCtrl.hashGetter(newValue, scope);
	
	      optionCtrl.hashKey = newHashKey;
	      optionCtrl.value = newValue;
	
	      selectCtrl.removeOption(oldHashKey, optionCtrl);
	      selectCtrl.addOption(newHashKey, optionCtrl);
	    }
	
	    scope.$on('$destroy', function() {
	      selectCtrl.removeOption(optionCtrl.hashKey, optionCtrl);
	    });
	
	    function configureAria() {
	      var ariaAttrs = {
	        'role': 'option',
	        'aria-selected': 'false'
	      };
	
	      if (!element[0].hasAttribute('id')) {
	        ariaAttrs.id = 'select_option_' + $mdUtil.nextUid();
	      }
	      element.attr(ariaAttrs);
	    }
	  }
	
	  function OptionController($element) {
	    this.selected = false;
	    this.setSelected = function(isSelected) {
	      if (isSelected && !this.selected) {
	        $element.attr({
	          'selected': 'selected',
	          'aria-selected': 'true'
	        });
	      } else if (!isSelected && this.selected) {
	        $element.removeAttr('selected');
	        $element.attr('aria-selected', 'false');
	      }
	      this.selected = isSelected;
	    };
	  }
	
	}
	
	function OptgroupDirective() {
	  return {
	    restrict: 'E',
	    compile: compile
	  };
	  function compile(el, attrs) {
	    // If we have a select header element, we don't want to add the normal label
	    // header.
	    if (!hasSelectHeader()) {
	      setupLabelElement();
	    }
	
	    function hasSelectHeader() {
	      return el.parent().find('md-select-header').length;
	    }
	
	    function setupLabelElement() {
	      var labelElement = el.find('label');
	      if (!labelElement.length) {
	        labelElement = angular.element('<label>');
	        el.prepend(labelElement);
	      }
	      labelElement.addClass('md-container-ignore');
	      if (attrs.label) labelElement.text(attrs.label);
	    }
	  }
	}
	
	function SelectHeaderDirective() {
	  return {
	    restrict: 'E',
	  };
	}
	
	function SelectProvider($$interimElementProvider) {
	  selectDefaultOptions.$inject = ["$mdSelect", "$mdConstant", "$mdUtil", "$window", "$q", "$$rAF", "$animateCss", "$animate", "$document"];
	  return $$interimElementProvider('$mdSelect')
	    .setDefaults({
	      methods: ['target'],
	      options: selectDefaultOptions
	    });
	
	  /* @ngInject */
	  function selectDefaultOptions($mdSelect, $mdConstant, $mdUtil, $window, $q, $$rAF, $animateCss, $animate, $document) {
	    var ERROR_TARGET_EXPECTED = "$mdSelect.show() expected a target element in options.target but got '{0}'!";
	    var animator = $mdUtil.dom.animator;
	    var keyCodes = $mdConstant.KEY_CODE;
	
	    return {
	      parent: 'body',
	      themable: true,
	      onShow: onShow,
	      onRemove: onRemove,
	      hasBackdrop: true,
	      disableParentScroll: true
	    };
	
	    /**
	     * Interim-element onRemove logic....
	     */
	    function onRemove(scope, element, opts) {
	      opts = opts || { };
	      opts.cleanupInteraction();
	      opts.cleanupResizing();
	      opts.hideBackdrop();
	
	      // For navigation $destroy events, do a quick, non-animated removal,
	      // but for normal closes (from clicks, etc) animate the removal
	
	      return  (opts.$destroy === true) ? cleanElement() : animateRemoval().then( cleanElement );
	
	      /**
	       * For normal closes (eg clicks), animate the removal.
	       * For forced closes (like $destroy events from navigation),
	       * skip the animations
	       */
	      function animateRemoval() {
	        return $animateCss(element, {addClass: 'md-leave'}).start();
	      }
	
	      /**
	       * Restore the element to a closed state
	       */
	      function cleanElement() {
	
	        element.removeClass('md-active');
	        element.attr('aria-hidden', 'true');
	        element[0].style.display = 'none';
	
	        announceClosed(opts);
	
	        if (!opts.$destroy && opts.restoreFocus) {
	          opts.target.focus();
	        }
	      }
	
	    }
	
	    /**
	     * Interim-element onShow logic....
	     */
	    function onShow(scope, element, opts) {
	
	      watchAsyncLoad();
	      sanitizeAndConfigure(scope, opts);
	
	      opts.hideBackdrop = showBackdrop(scope, element, opts);
	
	      return showDropDown(scope, element, opts)
	        .then(function(response) {
	          element.attr('aria-hidden', 'false');
	          opts.alreadyOpen = true;
	          opts.cleanupInteraction = activateInteraction();
	          opts.cleanupResizing = activateResizing();
	
	          return response;
	        }, opts.hideBackdrop);
	
	      // ************************************
	      // Closure Functions
	      // ************************************
	
	      /**
	       *  Attach the select DOM element(s) and animate to the correct positions
	       *  and scalings...
	       */
	      function showDropDown(scope, element, opts) {
	        opts.parent.append(element);
	
	        return $q(function(resolve, reject) {
	
	          try {
	
	            $animateCss(element, {removeClass: 'md-leave', duration: 0})
	              .start()
	              .then(positionAndFocusMenu)
	              .then(resolve);
	
	          } catch (e) {
	            reject(e);
	          }
	
	        });
	      }
	
	      /**
	       * Initialize container and dropDown menu positions/scale, then animate
	       * to show... and autoFocus.
	       */
	      function positionAndFocusMenu() {
	        return $q(function(resolve) {
	          if (opts.isRemoved) return $q.reject(false);
	
	          var info = calculateMenuPositions(scope, element, opts);
	
	          info.container.element.css(animator.toCss(info.container.styles));
	          info.dropDown.element.css(animator.toCss(info.dropDown.styles));
	
	          $$rAF(function() {
	            element.addClass('md-active');
	            info.dropDown.element.css(animator.toCss({transform: ''}));
	
	            autoFocus(opts.focusedNode);
	            resolve();
	          });
	
	        });
	      }
	
	      /**
	       * Show modal backdrop element...
	       */
	      function showBackdrop(scope, element, options) {
	
	        // If we are not within a dialog...
	        if (options.disableParentScroll && !$mdUtil.getClosest(options.target, 'MD-DIALOG')) {
	          // !! DO this before creating the backdrop; since disableScrollAround()
	          //    configures the scroll offset; which is used by mdBackDrop postLink()
	          options.restoreScroll = $mdUtil.disableScrollAround(options.element, options.parent);
	        } else {
	          options.disableParentScroll = false;
	        }
	
	        if (options.hasBackdrop) {
	          // Override duration to immediately show invisible backdrop
	          options.backdrop = $mdUtil.createBackdrop(scope, "md-select-backdrop md-click-catcher");
	          $animate.enter(options.backdrop, $document[0].body, null, {duration: 0});
	        }
	
	        /**
	         * Hide modal backdrop element...
	         */
	        return function hideBackdrop() {
	          if (options.backdrop) options.backdrop.remove();
	          if (options.disableParentScroll) options.restoreScroll();
	
	          delete options.restoreScroll;
	        };
	      }
	
	      /**
	       *
	       */
	      function autoFocus(focusedNode) {
	        if (focusedNode && !focusedNode.hasAttribute('disabled')) {
	          focusedNode.focus();
	        }
	      }
	
	      /**
	       * Check for valid opts and set some sane defaults
	       */
	      function sanitizeAndConfigure(scope, options) {
	        var selectEl = element.find('md-select-menu');
	
	        if (!options.target) {
	          throw new Error($mdUtil.supplant(ERROR_TARGET_EXPECTED, [options.target]));
	        }
	
	        angular.extend(options, {
	          isRemoved: false,
	          target: angular.element(options.target), //make sure it's not a naked dom node
	          parent: angular.element(options.parent),
	          selectEl: selectEl,
	          contentEl: element.find('md-content'),
	          optionNodes: selectEl[0].getElementsByTagName('md-option')
	        });
	      }
	
	      /**
	       * Configure various resize listeners for screen changes
	       */
	      function activateResizing() {
	        var debouncedOnResize = (function(scope, target, options) {
	
	          return function() {
	            if (options.isRemoved) return;
	
	            var updates = calculateMenuPositions(scope, target, options);
	            var container = updates.container;
	            var dropDown = updates.dropDown;
	
	            container.element.css(animator.toCss(container.styles));
	            dropDown.element.css(animator.toCss(dropDown.styles));
	          };
	
	        })(scope, element, opts);
	
	        var window = angular.element($window);
	        window.on('resize', debouncedOnResize);
	        window.on('orientationchange', debouncedOnResize);
	
	        // Publish deactivation closure...
	        return function deactivateResizing() {
	
	          // Disable resizing handlers
	          window.off('resize', debouncedOnResize);
	          window.off('orientationchange', debouncedOnResize);
	        };
	      }
	
	      /**
	       *  If asynchronously loading, watch and update internal
	       *  '$$loadingAsyncDone' flag
	       */
	      function watchAsyncLoad() {
	        if (opts.loadingAsync && !opts.isRemoved) {
	          scope.$$loadingAsyncDone = false;
	
	          $q.when(opts.loadingAsync)
	            .then(function() {
	              scope.$$loadingAsyncDone = true;
	              delete opts.loadingAsync;
	            }).then(function() {
	              $$rAF(positionAndFocusMenu);
	            });
	        }
	      }
	
	      /**
	       *
	       */
	      function activateInteraction() {
	        if (opts.isRemoved) return;
	
	        var dropDown = opts.selectEl;
	        var selectCtrl = dropDown.controller('mdSelectMenu') || {};
	
	        element.addClass('md-clickable');
	
	        // Close on backdrop click
	        opts.backdrop && opts.backdrop.on('click', onBackdropClick);
	
	        // Escape to close
	        // Cycling of options, and closing on enter
	        dropDown.on('keydown', onMenuKeyDown);
	        dropDown.on('click', checkCloseMenu);
	
	        return function cleanupInteraction() {
	          opts.backdrop && opts.backdrop.off('click', onBackdropClick);
	          dropDown.off('keydown', onMenuKeyDown);
	          dropDown.off('click', checkCloseMenu);
	
	          element.removeClass('md-clickable');
	          opts.isRemoved = true;
	        };
	
	        // ************************************
	        // Closure Functions
	        // ************************************
	
	        function onBackdropClick(e) {
	          e.preventDefault();
	          e.stopPropagation();
	          opts.restoreFocus = false;
	          $mdUtil.nextTick($mdSelect.hide, true);
	        }
	
	        function onMenuKeyDown(ev) {
	          ev.preventDefault();
	          ev.stopPropagation();
	
	          switch (ev.keyCode) {
	            case keyCodes.UP_ARROW:
	              return focusPrevOption();
	            case keyCodes.DOWN_ARROW:
	              return focusNextOption();
	            case keyCodes.SPACE:
	            case keyCodes.ENTER:
	              var option = $mdUtil.getClosest(ev.target, 'md-option');
	              if (option) {
	                dropDown.triggerHandler({
	                  type: 'click',
	                  target: option
	                });
	                ev.preventDefault();
	              }
	              checkCloseMenu(ev);
	              break;
	            case keyCodes.TAB:
	            case keyCodes.ESCAPE:
	              ev.stopPropagation();
	              ev.preventDefault();
	              opts.restoreFocus = true;
	              $mdUtil.nextTick($mdSelect.hide, true);
	              break;
	            default:
	              if (shouldHandleKey(ev, $mdConstant)) {
	                var optNode = dropDown.controller('mdSelectMenu').optNodeForKeyboardSearch(ev);
	                opts.focusedNode = optNode || opts.focusedNode;
	                optNode && optNode.focus();
	              }
	          }
	        }
	
	        function focusOption(direction) {
	          var optionsArray = $mdUtil.nodesToArray(opts.optionNodes);
	          var index = optionsArray.indexOf(opts.focusedNode);
	
	          var newOption;
	
	          do {
	            if (index === -1) {
	              // We lost the previously focused element, reset to first option
	              index = 0;
	            } else if (direction === 'next' && index < optionsArray.length - 1) {
	              index++;
	            } else if (direction === 'prev' && index > 0) {
	              index--;
	            }
	            newOption = optionsArray[index];
	            if (newOption.hasAttribute('disabled')) newOption = undefined;
	          } while (!newOption && index < optionsArray.length - 1 && index > 0);
	
	          newOption && newOption.focus();
	          opts.focusedNode = newOption;
	        }
	
	        function focusNextOption() {
	          focusOption('next');
	        }
	
	        function focusPrevOption() {
	          focusOption('prev');
	        }
	
	        function checkCloseMenu(ev) {
	          if (ev && ( ev.type == 'click') && (ev.currentTarget != dropDown[0])) return;
	          if ( mouseOnScrollbar() ) return;
	
	          var option = $mdUtil.getClosest(ev.target, 'md-option');
	          if (option && option.hasAttribute && !option.hasAttribute('disabled')) {
	            ev.preventDefault();
	            ev.stopPropagation();
	            if (!selectCtrl.isMultiple) {
	              opts.restoreFocus = true;
	
	              $mdUtil.nextTick(function () {
	                $mdSelect.hide(selectCtrl.ngModel.$viewValue);
	              }, true);
	            }
	          }
	          /**
	           * check if the mouseup event was on a scrollbar
	           */
	          function mouseOnScrollbar() {
	            var clickOnScrollbar = false;
	            if (ev && (ev.currentTarget.children.length > 0)) {
	              var child = ev.currentTarget.children[0];
	              var hasScrollbar = child.scrollHeight > child.clientHeight;
	              if (hasScrollbar && child.children.length > 0) {
	                var relPosX = ev.pageX - ev.currentTarget.getBoundingClientRect().left;
	                if (relPosX > child.querySelector('md-option').offsetWidth)
	                  clickOnScrollbar = true;
	              }
	            }
	            return clickOnScrollbar;
	          }
	        }
	      }
	
	    }
	
	    /**
	     * To notify listeners that the Select menu has closed,
	     * trigger the [optional] user-defined expression
	     */
	    function announceClosed(opts) {
	      var mdSelect = opts.selectCtrl;
	      if (mdSelect) {
	        var menuController = opts.selectEl.controller('mdSelectMenu');
	        mdSelect.setLabelText(menuController ? menuController.selectedLabels() : '');
	        mdSelect.triggerClose();
	      }
	    }
	
	
	    /**
	     * Calculate the
	     */
	    function calculateMenuPositions(scope, element, opts) {
	      var
	        containerNode = element[0],
	        targetNode = opts.target[0].children[0], // target the label
	        parentNode = $document[0].body,
	        selectNode = opts.selectEl[0],
	        contentNode = opts.contentEl[0],
	        parentRect = parentNode.getBoundingClientRect(),
	        targetRect = targetNode.getBoundingClientRect(),
	        shouldOpenAroundTarget = false,
	        bounds = {
	          left: parentRect.left + SELECT_EDGE_MARGIN,
	          top: SELECT_EDGE_MARGIN,
	          bottom: parentRect.height - SELECT_EDGE_MARGIN,
	          right: parentRect.width - SELECT_EDGE_MARGIN - ($mdUtil.floatingScrollbars() ? 16 : 0)
	        },
	        spaceAvailable = {
	          top: targetRect.top - bounds.top,
	          left: targetRect.left - bounds.left,
	          right: bounds.right - (targetRect.left + targetRect.width),
	          bottom: bounds.bottom - (targetRect.top + targetRect.height)
	        },
	        maxWidth = parentRect.width - SELECT_EDGE_MARGIN * 2,
	        selectedNode = selectNode.querySelector('md-option[selected]'),
	        optionNodes = selectNode.getElementsByTagName('md-option'),
	        optgroupNodes = selectNode.getElementsByTagName('md-optgroup'),
	        isScrollable = calculateScrollable(element, contentNode),
	        centeredNode;
	
	      var loading = isPromiseLike(opts.loadingAsync);
	      if (!loading) {
	        // If a selected node, center around that
	        if (selectedNode) {
	          centeredNode = selectedNode;
	          // If there are option groups, center around the first option group
	        } else if (optgroupNodes.length) {
	          centeredNode = optgroupNodes[0];
	          // Otherwise - if we are not loading async - center around the first optionNode
	        } else if (optionNodes.length) {
	          centeredNode = optionNodes[0];
	          // In case there are no options, center on whatever's in there... (eg progress indicator)
	        } else {
	          centeredNode = contentNode.firstElementChild || contentNode;
	        }
	      } else {
	        // If loading, center on progress indicator
	        centeredNode = contentNode.firstElementChild || contentNode;
	      }
	
	      if (contentNode.offsetWidth > maxWidth) {
	        contentNode.style['max-width'] = maxWidth + 'px';
	      } else {
	        contentNode.style.maxWidth = null;
	      }
	      if (shouldOpenAroundTarget) {
	        contentNode.style['min-width'] = targetRect.width + 'px';
	      }
	
	      // Remove padding before we compute the position of the menu
	      if (isScrollable) {
	        selectNode.classList.add('md-overflow');
	      }
	
	      var focusedNode = centeredNode;
	      if ((focusedNode.tagName || '').toUpperCase() === 'MD-OPTGROUP') {
	        focusedNode = optionNodes[0] || contentNode.firstElementChild || contentNode;
	        centeredNode = focusedNode;
	      }
	      // Cache for autoFocus()
	      opts.focusedNode = focusedNode;
	
	      // Get the selectMenuRect *after* max-width is possibly set above
	      containerNode.style.display = 'block';
	      var selectMenuRect = selectNode.getBoundingClientRect();
	      var centeredRect = getOffsetRect(centeredNode);
	
	      if (centeredNode) {
	        var centeredStyle = $window.getComputedStyle(centeredNode);
	        centeredRect.paddingLeft = parseInt(centeredStyle.paddingLeft, 10) || 0;
	        centeredRect.paddingRight = parseInt(centeredStyle.paddingRight, 10) || 0;
	      }
	
	      if (isScrollable) {
	        var scrollBuffer = contentNode.offsetHeight / 2;
	        contentNode.scrollTop = centeredRect.top + centeredRect.height / 2 - scrollBuffer;
	
	        if (spaceAvailable.top < scrollBuffer) {
	          contentNode.scrollTop = Math.min(
	            centeredRect.top,
	            contentNode.scrollTop + scrollBuffer - spaceAvailable.top
	          );
	        } else if (spaceAvailable.bottom < scrollBuffer) {
	          contentNode.scrollTop = Math.max(
	            centeredRect.top + centeredRect.height - selectMenuRect.height,
	            contentNode.scrollTop - scrollBuffer + spaceAvailable.bottom
	          );
	        }
	      }
	
	      var left, top, transformOrigin, minWidth, fontSize;
	      if (shouldOpenAroundTarget) {
	        left = targetRect.left;
	        top = targetRect.top + targetRect.height;
	        transformOrigin = '50% 0';
	        if (top + selectMenuRect.height > bounds.bottom) {
	          top = targetRect.top - selectMenuRect.height;
	          transformOrigin = '50% 100%';
	        }
	      } else {
	        left = (targetRect.left + centeredRect.left - centeredRect.paddingLeft) + 2;
	        top = Math.floor(targetRect.top + targetRect.height / 2 - centeredRect.height / 2 -
	            centeredRect.top + contentNode.scrollTop) + 2;
	
	        transformOrigin = (centeredRect.left + targetRect.width / 2) + 'px ' +
	          (centeredRect.top + centeredRect.height / 2 - contentNode.scrollTop) + 'px 0px';
	
	        minWidth = Math.min(targetRect.width + centeredRect.paddingLeft + centeredRect.paddingRight, maxWidth);
	
	        fontSize = window.getComputedStyle(targetNode)['font-size'];
	      }
	
	      // Keep left and top within the window
	      var containerRect = containerNode.getBoundingClientRect();
	      var scaleX = Math.round(100 * Math.min(targetRect.width / selectMenuRect.width, 1.0)) / 100;
	      var scaleY = Math.round(100 * Math.min(targetRect.height / selectMenuRect.height, 1.0)) / 100;
	
	      return {
	        container: {
	          element: angular.element(containerNode),
	          styles: {
	            left: Math.floor(clamp(bounds.left, left, bounds.right - containerRect.width)),
	            top: Math.floor(clamp(bounds.top, top, bounds.bottom - containerRect.height)),
	            'min-width': minWidth,
	            'font-size': fontSize
	          }
	        },
	        dropDown: {
	          element: angular.element(selectNode),
	          styles: {
	            transformOrigin: transformOrigin,
	            transform: !opts.alreadyOpen ? $mdUtil.supplant('scale({0},{1})', [scaleX, scaleY]) : ""
	          }
	        }
	      };
	
	    }
	
	  }
	
	  function isPromiseLike(obj) {
	    return obj && angular.isFunction(obj.then);
	  }
	
	  function clamp(min, n, max) {
	    return Math.max(min, Math.min(n, max));
	  }
	
	  function getOffsetRect(node) {
	    return node ? {
	      left: node.offsetLeft,
	      top: node.offsetTop,
	      width: node.offsetWidth,
	      height: node.offsetHeight
	    } : {left: 0, top: 0, width: 0, height: 0};
	  }
	
	  function calculateScrollable(element, contentNode) {
	    var isScrollable = false;
	
	    try {
	      var oldDisplay = element[0].style.display;
	
	      // Set the element's display to block so that this calculation is correct
	      element[0].style.display = 'block';
	
	      isScrollable = contentNode.scrollHeight > contentNode.offsetHeight;
	
	      // Reset it back afterwards
	      element[0].style.display = oldDisplay;
	    } finally {
	      // Nothing to do
	    }
	    return isScrollable;
	  }
	
	}
	
	function shouldHandleKey(ev, $mdConstant) {
	  var char = String.fromCharCode(ev.keyCode);
	  var isNonUsefulKey = (ev.keyCode <= 31);
	
	  return (char && char.length && !isNonUsefulKey &&
	    !$mdConstant.isMetaKey(ev) && !$mdConstant.isFnLockKey(ev) && !$mdConstant.hasModifierKey(ev));
	}
	
	})();
	(function(){
	"use strict";
	
	  /**
	   * @ngdoc module
	   * @name material.components.slider
	   */
	SliderDirective.$inject = ["$$rAF", "$window", "$mdAria", "$mdUtil", "$mdConstant", "$mdTheming", "$mdGesture", "$parse", "$log", "$timeout"];
	  angular.module('material.components.slider', [
	    'material.core'
	  ])
	  .directive('mdSlider', SliderDirective)
	  .directive('mdSliderContainer', SliderContainerDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdSliderContainer
	 * @module material.components.slider
	 * @restrict E
	 * @description
	 * The `<md-slider-container>` contains slider with two other elements.
	 *
	 *
	 * @usage
	 * <h4>Normal Mode</h4>
	 * <hljs lang="html">
	 * </hljs>
	 */
	function SliderContainerDirective() {
	  return {
	    controller: function () {},
	    compile: function (elem) {
	      var slider = elem.find('md-slider');
	
	      if (!slider) {
	        return;
	      }
	
	      var vertical = slider.attr('md-vertical');
	
	      if (vertical !== undefined) {
	        elem.attr('md-vertical', '');
	      }
	
	      if(!slider.attr('flex')) {
	        slider.attr('flex', '');
	      }
	
	      return function postLink(scope, element, attr, ctrl) {
	        element.addClass('_md');     // private md component indicator for styling
	
	        // We have to manually stop the $watch on ngDisabled because it exists
	        // on the parent scope, and won't be automatically destroyed when
	        // the component is destroyed.
	        function setDisable(value) {
	          element.children().attr('disabled', value);
	          element.find('input').attr('disabled', value);
	        }
	
	        var stopDisabledWatch = angular.noop;
	
	        if (attr.disabled) {
	          setDisable(true);
	        }
	        else if (attr.ngDisabled) {
	          stopDisabledWatch = scope.$watch(attr.ngDisabled, function (value) {
	            setDisable(value);
	          });
	        }
	
	        scope.$on('$destroy', function () {
	          stopDisabledWatch();
	        });
	
	        var initialMaxWidth;
	
	        ctrl.fitInputWidthToTextLength = function (length) {
	          var input = element[0].querySelector('md-input-container');
	
	          if (input) {
	            var computedStyle = getComputedStyle(input);
	            var minWidth = parseInt(computedStyle.minWidth);
	            var padding = parseInt(computedStyle.padding) * 2;
	
	            initialMaxWidth = initialMaxWidth || parseInt(computedStyle.maxWidth);
	            var newMaxWidth = Math.max(initialMaxWidth, minWidth + padding + (minWidth / 2 * length));
	
	            input.style.maxWidth = newMaxWidth + 'px';
	          }
	        };
	      };
	    }
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name mdSlider
	 * @module material.components.slider
	 * @restrict E
	 * @description
	 * The `<md-slider>` component allows the user to choose from a range of
	 * values.
	 *
	 * As per the [material design spec](http://www.google.com/design/spec/style/color.html#color-ui-color-application)
	 * the slider is in the accent color by default. The primary color palette may be used with
	 * the `md-primary` class.
	 *
	 * It has two modes: 'normal' mode, where the user slides between a wide range
	 * of values, and 'discrete' mode, where the user slides between only a few
	 * select values.
	 *
	 * To enable discrete mode, add the `md-discrete` attribute to a slider,
	 * and use the `step` attribute to change the distance between
	 * values the user is allowed to pick.
	 *
	 * @usage
	 * <h4>Normal Mode</h4>
	 * <hljs lang="html">
	 * <md-slider ng-model="myValue" min="5" max="500">
	 * </md-slider>
	 * </hljs>
	 * <h4>Discrete Mode</h4>
	 * <hljs lang="html">
	 * <md-slider md-discrete ng-model="myDiscreteValue" step="10" min="10" max="130">
	 * </md-slider>
	 * </hljs>
	 * <h4>Invert Mode</h4>
	 * <hljs lang="html">
	 * <md-slider md-invert ng-model="myValue" step="10" min="10" max="130">
	 * </md-slider>
	 * </hljs>
	 *
	 * @param {boolean=} md-discrete Whether to enable discrete mode.
	 * @param {boolean=} md-invert Whether to enable invert mode.
	 * @param {number=} step The distance between values the user is allowed to pick. Default 1.
	 * @param {number=} min The minimum value the user is allowed to pick. Default 0.
	 * @param {number=} max The maximum value the user is allowed to pick. Default 100.
	 * @param {number=} round The amount of numbers after the decimal point, maximum is 6 to prevent scientific notation. Default 3.
	 */
	function SliderDirective($$rAF, $window, $mdAria, $mdUtil, $mdConstant, $mdTheming, $mdGesture, $parse, $log, $timeout) {
	  return {
	    scope: {},
	    require: ['?ngModel', '?^mdSliderContainer'],
	    template:
	      '<div class="md-slider-wrapper">' +
	        '<div class="md-slider-content">' +
	          '<div class="md-track-container">' +
	            '<div class="md-track"></div>' +
	            '<div class="md-track md-track-fill"></div>' +
	            '<div class="md-track-ticks"></div>' +
	          '</div>' +
	          '<div class="md-thumb-container">' +
	            '<div class="md-thumb"></div>' +
	            '<div class="md-focus-thumb"></div>' +
	            '<div class="md-focus-ring"></div>' +
	            '<div class="md-sign">' +
	              '<span class="md-thumb-text"></span>' +
	            '</div>' +
	            '<div class="md-disabled-thumb"></div>' +
	          '</div>' +
	        '</div>' +
	      '</div>',
	    compile: compile
	  };
	
	  // **********************************************************
	  // Private Methods
	  // **********************************************************
	
	  function compile (tElement, tAttrs) {
	    var wrapper = angular.element(tElement[0].getElementsByClassName('md-slider-wrapper'));
	
	    var tabIndex = tAttrs.tabindex || 0;
	    wrapper.attr('tabindex', tabIndex);
	
	    if (tAttrs.disabled || tAttrs.ngDisabled) wrapper.attr('tabindex', -1);
	
	    wrapper.attr('role', 'slider');
	
	    $mdAria.expect(tElement, 'aria-label');
	
	    return postLink;
	  }
	
	  function postLink(scope, element, attr, ctrls) {
	    $mdTheming(element);
	    var ngModelCtrl = ctrls[0] || {
	      // Mock ngModelController if it doesn't exist to give us
	      // the minimum functionality needed
	      $setViewValue: function(val) {
	        this.$viewValue = val;
	        this.$viewChangeListeners.forEach(function(cb) { cb(); });
	      },
	      $parsers: [],
	      $formatters: [],
	      $viewChangeListeners: []
	    };
	
	    var containerCtrl = ctrls[1];
	    var container = angular.element($mdUtil.getClosest(element, '_md-slider-container', true));
	    var isDisabled = attr.ngDisabled ? angular.bind(null, $parse(attr.ngDisabled), scope.$parent) : function () {
	          return element[0].hasAttribute('disabled');
	        };
	
	    var thumb = angular.element(element[0].querySelector('.md-thumb'));
	    var thumbText = angular.element(element[0].querySelector('.md-thumb-text'));
	    var thumbContainer = thumb.parent();
	    var trackContainer = angular.element(element[0].querySelector('.md-track-container'));
	    var activeTrack = angular.element(element[0].querySelector('.md-track-fill'));
	    var tickContainer = angular.element(element[0].querySelector('.md-track-ticks'));
	    var wrapper = angular.element(element[0].getElementsByClassName('md-slider-wrapper'));
	    var content = angular.element(element[0].getElementsByClassName('md-slider-content'));
	    var throttledRefreshDimensions = $mdUtil.throttle(refreshSliderDimensions, 5000);
	
	    // Default values, overridable by attrs
	    var DEFAULT_ROUND = 3;
	    var vertical = angular.isDefined(attr.mdVertical);
	    var discrete = angular.isDefined(attr.mdDiscrete);
	    var invert = angular.isDefined(attr.mdInvert);
	    angular.isDefined(attr.min) ? attr.$observe('min', updateMin) : updateMin(0);
	    angular.isDefined(attr.max) ? attr.$observe('max', updateMax) : updateMax(100);
	    angular.isDefined(attr.step)? attr.$observe('step', updateStep) : updateStep(1);
	    angular.isDefined(attr.round)? attr.$observe('round', updateRound) : updateRound(DEFAULT_ROUND);
	
	    // We have to manually stop the $watch on ngDisabled because it exists
	    // on the parent scope, and won't be automatically destroyed when
	    // the component is destroyed.
	    var stopDisabledWatch = angular.noop;
	    if (attr.ngDisabled) {
	      stopDisabledWatch = scope.$parent.$watch(attr.ngDisabled, updateAriaDisabled);
	    }
	
	    $mdGesture.register(wrapper, 'drag', { horizontal: !vertical });
	
	    scope.mouseActive = false;
	
	    wrapper
	      .on('keydown', keydownListener)
	      .on('mousedown', mouseDownListener)
	      .on('focus', focusListener)
	      .on('blur', blurListener)
	      .on('$md.pressdown', onPressDown)
	      .on('$md.pressup', onPressUp)
	      .on('$md.dragstart', onDragStart)
	      .on('$md.drag', onDrag)
	      .on('$md.dragend', onDragEnd);
	
	    // On resize, recalculate the slider's dimensions and re-render
	    function updateAll() {
	      refreshSliderDimensions();
	      ngModelRender();
	    }
	    setTimeout(updateAll, 0);
	
	    var debouncedUpdateAll = $$rAF.throttle(updateAll);
	    angular.element($window).on('resize', debouncedUpdateAll);
	
	    scope.$on('$destroy', function() {
	      angular.element($window).off('resize', debouncedUpdateAll);
	    });
	
	    ngModelCtrl.$render = ngModelRender;
	    ngModelCtrl.$viewChangeListeners.push(ngModelRender);
	    ngModelCtrl.$formatters.push(minMaxValidator);
	    ngModelCtrl.$formatters.push(stepValidator);
	
	    /**
	     * Attributes
	     */
	    var min;
	    var max;
	    var step;
	    var round;
	    function updateMin(value) {
	      min = parseFloat(value);
	      element.attr('aria-valuemin', value);
	      updateAll();
	    }
	    function updateMax(value) {
	      max = parseFloat(value);
	      element.attr('aria-valuemax', value);
	      updateAll();
	    }
	    function updateStep(value) {
	      step = parseFloat(value);
	    }
	    function updateRound(value) {
	      // Set max round digits to 6, after 6 the input uses scientific notation
	      round = minMaxValidator(parseInt(value), 0, 6);
	    }
	    function updateAriaDisabled() {
	      element.attr('aria-disabled', !!isDisabled());
	    }
	
	    // Draw the ticks with canvas.
	    // The alternative to drawing ticks with canvas is to draw one element for each tick,
	    // which could quickly become a performance bottleneck.
	    var tickCanvas, tickCtx;
	    function redrawTicks() {
	      if (!discrete || isDisabled()) return;
	      if ( angular.isUndefined(step) )         return;
	
	      if ( step <= 0 ) {
	        var msg = 'Slider step value must be greater than zero when in discrete mode';
	        $log.error(msg);
	        throw new Error(msg);
	      }
	
	      var numSteps = Math.floor( (max - min) / step );
	      if (!tickCanvas) {
	        tickCanvas = angular.element('<canvas>').css('position', 'absolute');
	        tickContainer.append(tickCanvas);
	
	        tickCtx = tickCanvas[0].getContext('2d');
	      }
	
	      var dimensions = getSliderDimensions();
	
	      // If `dimensions` doesn't have height and width it might be the first attempt so we will refresh dimensions
	      if (dimensions && !dimensions.height && !dimensions.width) {
	        refreshSliderDimensions();
	        dimensions = sliderDimensions;
	      }
	
	      tickCanvas[0].width = dimensions.width;
	      tickCanvas[0].height = dimensions.height;
	
	      var distance;
	      for (var i = 0; i <= numSteps; i++) {
	        var trackTicksStyle = $window.getComputedStyle(tickContainer[0]);
	        tickCtx.fillStyle = trackTicksStyle.color || 'black';
	
	        distance = Math.floor((vertical ? dimensions.height : dimensions.width) * (i / numSteps));
	
	        tickCtx.fillRect(vertical ? 0 : distance - 1,
	          vertical ? distance - 1 : 0,
	          vertical ? dimensions.width : 2,
	          vertical ? 2 : dimensions.height);
	      }
	    }
	
	    function clearTicks() {
	      if(tickCanvas && tickCtx) {
	        var dimensions = getSliderDimensions();
	        tickCtx.clearRect(0, 0, dimensions.width, dimensions.height);
	      }
	    }
	
	    /**
	     * Refreshing Dimensions
	     */
	    var sliderDimensions = {};
	    refreshSliderDimensions();
	    function refreshSliderDimensions() {
	      sliderDimensions = trackContainer[0].getBoundingClientRect();
	    }
	    function getSliderDimensions() {
	      throttledRefreshDimensions();
	      return sliderDimensions;
	    }
	
	    /**
	     * left/right/up/down arrow listener
	     */
	    function keydownListener(ev) {
	      if (isDisabled()) return;
	
	      var changeAmount;
	      if (vertical ? ev.keyCode === $mdConstant.KEY_CODE.DOWN_ARROW : ev.keyCode === $mdConstant.KEY_CODE.LEFT_ARROW) {
	        changeAmount = -step;
	      } else if (vertical ? ev.keyCode === $mdConstant.KEY_CODE.UP_ARROW : ev.keyCode === $mdConstant.KEY_CODE.RIGHT_ARROW) {
	        changeAmount = step;
	      }
	      changeAmount = invert ? -changeAmount : changeAmount;
	      if (changeAmount) {
	        if (ev.metaKey || ev.ctrlKey || ev.altKey) {
	          changeAmount *= 4;
	        }
	        ev.preventDefault();
	        ev.stopPropagation();
	        scope.$evalAsync(function() {
	          setModelValue(ngModelCtrl.$viewValue + changeAmount);
	        });
	      }
	    }
	
	    function mouseDownListener() {
	      redrawTicks();
	
	      scope.mouseActive = true;
	      wrapper.removeClass('md-focused');
	
	      $timeout(function() {
	        scope.mouseActive = false;
	      }, 100);
	    }
	
	    function focusListener() {
	      if (scope.mouseActive === false) {
	        wrapper.addClass('md-focused');
	      }
	    }
	
	    function blurListener() {
	      wrapper.removeClass('md-focused');
	      element.removeClass('md-active');
	      clearTicks();
	    }
	
	    /**
	     * ngModel setters and validators
	     */
	    function setModelValue(value) {
	      ngModelCtrl.$setViewValue( minMaxValidator(stepValidator(value)) );
	    }
	    function ngModelRender() {
	      if (isNaN(ngModelCtrl.$viewValue)) {
	        ngModelCtrl.$viewValue = ngModelCtrl.$modelValue;
	      }
	
	      ngModelCtrl.$viewValue = minMaxValidator(ngModelCtrl.$viewValue);
	
	      var percent = valueToPercent(ngModelCtrl.$viewValue);
	      scope.modelValue = ngModelCtrl.$viewValue;
	      element.attr('aria-valuenow', ngModelCtrl.$viewValue);
	      setSliderPercent(percent);
	      thumbText.text( ngModelCtrl.$viewValue );
	    }
	
	    function minMaxValidator(value, minValue, maxValue) {
	      if (angular.isNumber(value)) {
	        minValue = angular.isNumber(minValue) ? minValue : min;
	        maxValue = angular.isNumber(maxValue) ? maxValue : max;
	
	        return Math.max(minValue, Math.min(maxValue, value));
	      }
	    }
	
	    function stepValidator(value) {
	      if (angular.isNumber(value)) {
	        var formattedValue = (Math.round((value - min) / step) * step + min);
	        formattedValue = (Math.round(formattedValue * Math.pow(10, round)) / Math.pow(10, round));
	
	        if (containerCtrl && containerCtrl.fitInputWidthToTextLength){
	          $mdUtil.debounce(function () {
	            containerCtrl.fitInputWidthToTextLength(formattedValue.toString().length);
	          }, 100)();
	        }
	
	        return formattedValue;
	      }
	    }
	
	    /**
	     * @param percent 0-1
	     */
	    function setSliderPercent(percent) {
	
	      percent = clamp(percent);
	
	      var thumbPosition = (percent * 100) + '%';
	      var activeTrackPercent = invert ? (1 - percent) * 100 + '%' : thumbPosition;
	
	      if (vertical) {
	        thumbContainer.css('bottom', thumbPosition);
	      }
	      else {
	        $mdUtil.bidiProperty(thumbContainer, 'left', 'right', thumbPosition);
	      }
	
	      
	      activeTrack.css(vertical ? 'height' : 'width', activeTrackPercent);
	
	      element.toggleClass((invert ? 'md-max' : 'md-min'), percent === 0);
	      element.toggleClass((invert ? 'md-min' : 'md-max'), percent === 1);
	    }
	
	    /**
	     * Slide listeners
	     */
	    var isDragging = false;
	
	    function onPressDown(ev) {
	      if (isDisabled()) return;
	
	      element.addClass('md-active');
	      element[0].focus();
	      refreshSliderDimensions();
	
	      var exactVal = percentToValue( positionToPercent( vertical ? ev.pointer.y : ev.pointer.x ));
	      var closestVal = minMaxValidator( stepValidator(exactVal) );
	      scope.$apply(function() {
	        setModelValue( closestVal );
	        setSliderPercent( valueToPercent(closestVal));
	      });
	    }
	    function onPressUp(ev) {
	      if (isDisabled()) return;
	
	      element.removeClass('md-dragging');
	
	      var exactVal = percentToValue( positionToPercent( vertical ? ev.pointer.y : ev.pointer.x ));
	      var closestVal = minMaxValidator( stepValidator(exactVal) );
	      scope.$apply(function() {
	        setModelValue(closestVal);
	        ngModelRender();
	      });
	    }
	    function onDragStart(ev) {
	      if (isDisabled()) return;
	      isDragging = true;
	
	      ev.stopPropagation();
	
	      element.addClass('md-dragging');
	      setSliderFromEvent(ev);
	    }
	    function onDrag(ev) {
	      if (!isDragging) return;
	      ev.stopPropagation();
	      setSliderFromEvent(ev);
	    }
	    function onDragEnd(ev) {
	      if (!isDragging) return;
	      ev.stopPropagation();
	      isDragging = false;
	    }
	
	    function setSliderFromEvent(ev) {
	      // While panning discrete, update only the
	      // visual positioning but not the model value.
	      if ( discrete ) adjustThumbPosition( vertical ? ev.pointer.y : ev.pointer.x );
	      else            doSlide( vertical ? ev.pointer.y : ev.pointer.x );
	    }
	
	    /**
	     * Slide the UI by changing the model value
	     * @param x
	     */
	    function doSlide( x ) {
	      scope.$evalAsync( function() {
	        setModelValue( percentToValue( positionToPercent(x) ));
	      });
	    }
	
	    /**
	     * Slide the UI without changing the model (while dragging/panning)
	     * @param x
	     */
	    function adjustThumbPosition( x ) {
	      var exactVal = percentToValue( positionToPercent( x ));
	      var closestVal = minMaxValidator( stepValidator(exactVal) );
	      setSliderPercent( positionToPercent(x) );
	      thumbText.text( closestVal );
	    }
	
	    /**
	    * Clamps the value to be between 0 and 1.
	    * @param {number} value The value to clamp.
	    * @returns {number}
	    */
	    function clamp(value) {
	      return Math.max(0, Math.min(value || 0, 1));
	    }
	
	    /**
	     * Convert position on slider to percentage value of offset from beginning...
	     * @param position
	     * @returns {number}
	     */
	    function positionToPercent( position ) {
	      var offset = vertical ? sliderDimensions.top : sliderDimensions.left;
	      var size = vertical ? sliderDimensions.height : sliderDimensions.width;
	      var calc = (position - offset) / size;
	
	      if (!vertical && $mdUtil.bidi() === 'rtl') {
	        calc = 1 - calc;
	      }
	
	      return Math.max(0, Math.min(1, vertical ? 1 - calc : calc));
	    }
	
	    /**
	     * Convert percentage offset on slide to equivalent model value
	     * @param percent
	     * @returns {*}
	     */
	    function percentToValue( percent ) {
	      var adjustedPercent = invert ? (1 - percent) : percent;
	      return (min + adjustedPercent * (max - min));
	    }
	
	    function valueToPercent( val ) {
	      var percent = (val - min) / (max - min);
	      return invert ? (1 - percent) : percent;
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.sticky
	 * @description
	 * Sticky effects for md
	 *
	 */
	MdSticky.$inject = ["$mdConstant", "$$rAF", "$mdUtil", "$compile"];
	angular
	  .module('material.components.sticky', [
	    'material.core',
	    'material.components.content'
	  ])
	  .factory('$mdSticky', MdSticky);
	
	/**
	 * @ngdoc service
	 * @name $mdSticky
	 * @module material.components.sticky
	 *
	 * @description
	 * The `$mdSticky`service provides a mixin to make elements sticky.
	 *
	 * Whenever the current browser supports stickiness natively, the `$mdSticky` service will just
	 * use the native browser stickiness.
	 *
	 * By default the `$mdSticky` service compiles the cloned element, when not specified through the `elementClone`
	 * parameter, in the same scope as the actual element lives.
	 *
	 *
	 * <h3>Notes</h3>
	 * When using an element which is containing a compiled directive, which changed its DOM structure during compilation,
	 * you should compile the clone yourself using the plain template.<br/><br/>
	 * See the right usage below:
	 * <hljs lang="js">
	 *   angular.module('myModule')
	 *     .directive('stickySelect', function($mdSticky, $compile) {
	 *       var SELECT_TEMPLATE =
	 *         '<md-select ng-model="selected">' +
	 *           '<md-option>Option 1</md-option>' +
	 *         '</md-select>';
	 *
	 *       return {
	 *         restrict: 'E',
	 *         replace: true,
	 *         template: SELECT_TEMPLATE,
	 *         link: function(scope,element) {
	 *           $mdSticky(scope, element, $compile(SELECT_TEMPLATE)(scope));
	 *         }
	 *       };
	 *     });
	 * </hljs>
	 *
	 * @usage
	 * <hljs lang="js">
	 *   angular.module('myModule')
	 *     .directive('stickyText', function($mdSticky, $compile) {
	 *       return {
	 *         restrict: 'E',
	 *         template: '<span>Sticky Text</span>',
	 *         link: function(scope,element) {
	 *           $mdSticky(scope, element);
	 *         }
	 *       };
	 *     });
	 * </hljs>
	 *
	 * @returns A `$mdSticky` function that takes three arguments:
	 *   - `scope`
	 *   - `element`: The element that will be 'sticky'
	 *   - `elementClone`: A clone of the element, that will be shown
	 *     when the user starts scrolling past the original element.
	 *     If not provided, it will use the result of `element.clone()` and compiles it in the given scope.
	 */
	function MdSticky($mdConstant, $$rAF, $mdUtil, $compile) {
	
	  var browserStickySupport = $mdUtil.checkStickySupport();
	
	  /**
	   * Registers an element as sticky, used internally by directives to register themselves
	   */
	  return function registerStickyElement(scope, element, stickyClone) {
	    var contentCtrl = element.controller('mdContent');
	    if (!contentCtrl) return;
	
	    if (browserStickySupport) {
	      element.css({
	        position: browserStickySupport,
	        top: 0,
	        'z-index': 2
	      });
	    } else {
	      var $$sticky = contentCtrl.$element.data('$$sticky');
	      if (!$$sticky) {
	        $$sticky = setupSticky(contentCtrl);
	        contentCtrl.$element.data('$$sticky', $$sticky);
	      }
	
	      // Compile our cloned element, when cloned in this service, into the given scope.
	      var cloneElement = stickyClone || $compile(element.clone())(scope);
	
	      var deregister = $$sticky.add(element, cloneElement);
	      scope.$on('$destroy', deregister);
	    }
	  };
	
	  function setupSticky(contentCtrl) {
	    var contentEl = contentCtrl.$element;
	
	    // Refresh elements is very expensive, so we use the debounced
	    // version when possible.
	    var debouncedRefreshElements = $$rAF.throttle(refreshElements);
	
	    // setupAugmentedScrollEvents gives us `$scrollstart` and `$scroll`,
	    // more reliable than `scroll` on android.
	    setupAugmentedScrollEvents(contentEl);
	    contentEl.on('$scrollstart', debouncedRefreshElements);
	    contentEl.on('$scroll', onScroll);
	
	    var self;
	    return self = {
	      prev: null,
	      current: null, //the currently stickied item
	      next: null,
	      items: [],
	      add: add,
	      refreshElements: refreshElements
	    };
	
	    /***************
	     * Public
	     ***************/
	    // Add an element and its sticky clone to this content's sticky collection
	    function add(element, stickyClone) {
	      stickyClone.addClass('md-sticky-clone');
	
	      var item = {
	        element: element,
	        clone: stickyClone
	      };
	      self.items.push(item);
	
	      $mdUtil.nextTick(function() {
	        contentEl.prepend(item.clone);
	      });
	
	      debouncedRefreshElements();
	
	      return function remove() {
	        self.items.forEach(function(item, index) {
	          if (item.element[0] === element[0]) {
	            self.items.splice(index, 1);
	            item.clone.remove();
	          }
	        });
	        debouncedRefreshElements();
	      };
	    }
	
	    function refreshElements() {
	      // Sort our collection of elements by their current position in the DOM.
	      // We need to do this because our elements' order of being added may not
	      // be the same as their order of display.
	      self.items.forEach(refreshPosition);
	      self.items = self.items.sort(function(a, b) {
	        return a.top < b.top ? -1 : 1;
	      });
	
	      // Find which item in the list should be active, 
	      // based upon the content's current scroll position
	      var item;
	      var currentScrollTop = contentEl.prop('scrollTop');
	      for (var i = self.items.length - 1; i >= 0; i--) {
	        if (currentScrollTop > self.items[i].top) {
	          item = self.items[i];
	          break;
	        }
	      }
	      setCurrentItem(item);
	    }
	
	    /***************
	     * Private
	     ***************/
	
	    // Find the `top` of an item relative to the content element,
	    // and also the height.
	    function refreshPosition(item) {
	      // Find the top of an item by adding to the offsetHeight until we reach the 
	      // content element.
	      var current = item.element[0];
	      item.top = 0;
	      item.left = 0;
	      item.right = 0;
	      while (current && current !== contentEl[0]) {
	        item.top += current.offsetTop;
	        item.left += current.offsetLeft;
	        if ( current.offsetParent ){
	          item.right += current.offsetParent.offsetWidth - current.offsetWidth - current.offsetLeft; //Compute offsetRight
	        }
	        current = current.offsetParent;
	      }
	      item.height = item.element.prop('offsetHeight');
	
	      var defaultVal = $mdUtil.floatingScrollbars() ? '0' : undefined;
	      $mdUtil.bidi(item.clone, 'margin-left', item.left, defaultVal);
	      $mdUtil.bidi(item.clone, 'margin-right', defaultVal, item.right);
	    }
	
	    // As we scroll, push in and select the correct sticky element.
	    function onScroll() {
	      var scrollTop = contentEl.prop('scrollTop');
	      var isScrollingDown = scrollTop > (onScroll.prevScrollTop || 0);
	
	      // Store the previous scroll so we know which direction we are scrolling
	      onScroll.prevScrollTop = scrollTop;
	
	      //
	      // AT TOP (not scrolling)
	      //
	      if (scrollTop === 0) {
	        // If we're at the top, just clear the current item and return
	        setCurrentItem(null);
	        return;
	      }
	
	      //
	      // SCROLLING DOWN (going towards the next item)
	      //
	      if (isScrollingDown) {
	
	        // If we've scrolled down past the next item's position, sticky it and return
	        if (self.next && self.next.top <= scrollTop) {
	          setCurrentItem(self.next);
	          return;
	        }
	
	        // If the next item is close to the current one, push the current one up out of the way
	        if (self.current && self.next && self.next.top - scrollTop <= self.next.height) {
	          translate(self.current, scrollTop + (self.next.top - self.next.height - scrollTop));
	          return;
	        }
	      }
	
	      //
	      // SCROLLING UP (not at the top & not scrolling down; must be scrolling up)
	      //
	      if (!isScrollingDown) {
	
	        // If we've scrolled up past the previous item's position, sticky it and return
	        if (self.current && self.prev && scrollTop < self.current.top) {
	          setCurrentItem(self.prev);
	          return;
	        }
	
	        // If the next item is close to the current one, pull the current one down into view
	        if (self.next && self.current && (scrollTop >= (self.next.top - self.current.height))) {
	          translate(self.current, scrollTop + (self.next.top - scrollTop - self.current.height));
	          return;
	        }
	      }
	
	      //
	      // Otherwise, just move the current item to the proper place (scrolling up or down)
	      //
	      if (self.current) {
	        translate(self.current, scrollTop);
	      }
	    }
	
	    function setCurrentItem(item) {
	      if (self.current === item) return;
	      // Deactivate currently active item
	      if (self.current) {
	        translate(self.current, null);
	        setStickyState(self.current, null);
	      }
	
	      // Activate new item if given
	      if (item) {
	        setStickyState(item, 'active');
	      }
	
	      self.current = item;
	      var index = self.items.indexOf(item);
	      // If index === -1, index + 1 = 0. It works out.
	      self.next = self.items[index + 1];
	      self.prev = self.items[index - 1];
	      setStickyState(self.next, 'next');
	      setStickyState(self.prev, 'prev');
	    }
	
	    function setStickyState(item, state) {
	      if (!item || item.state === state) return;
	      if (item.state) {
	        item.clone.attr('sticky-prev-state', item.state);
	        item.element.attr('sticky-prev-state', item.state);
	      }
	      item.clone.attr('sticky-state', state);
	      item.element.attr('sticky-state', state);
	      item.state = state;
	    }
	
	    function translate(item, amount) {
	      if (!item) return;
	      if (amount === null || amount === undefined) {
	        if (item.translateY) {
	          item.translateY = null;
	          item.clone.css($mdConstant.CSS.TRANSFORM, '');
	        }
	      } else {
	        item.translateY = amount;
	
	        $mdUtil.bidi( item.clone, $mdConstant.CSS.TRANSFORM,
	          'translate3d(' + item.left + 'px,' + amount + 'px,0)',
	          'translateY(' + amount + 'px)'
	        );
	      }
	    }
	  }
	
	
	  // Android 4.4 don't accurately give scroll events.
	  // To fix this problem, we setup a fake scroll event. We say:
	  // > If a scroll or touchmove event has happened in the last DELAY milliseconds, 
	  //   then send a `$scroll` event every animationFrame.
	  // Additionally, we add $scrollstart and $scrollend events.
	  function setupAugmentedScrollEvents(element) {
	    var SCROLL_END_DELAY = 200;
	    var isScrolling;
	    var lastScrollTime;
	    element.on('scroll touchmove', function() {
	      if (!isScrolling) {
	        isScrolling = true;
	        $$rAF.throttle(loopScrollEvent);
	        element.triggerHandler('$scrollstart');
	      }
	      element.triggerHandler('$scroll');
	      lastScrollTime = +$mdUtil.now();
	    });
	
	    function loopScrollEvent() {
	      if (+$mdUtil.now() - lastScrollTime > SCROLL_END_DELAY) {
	        isScrolling = false;
	        element.triggerHandler('$scrollend');
	      } else {
	        element.triggerHandler('$scroll');
	        $$rAF.throttle(loopScrollEvent);
	      }
	    }
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.subheader
	 * @description
	 * SubHeader module
	 *
	 *  Subheaders are special list tiles that delineate distinct sections of a
	 *  list or grid list and are typically related to the current filtering or
	 *  sorting criteria. Subheader tiles are either displayed inline with tiles or
	 *  can be associated with content, for example, in an adjacent column.
	 *
	 *  Upon scrolling, subheaders remain pinned to the top of the screen and remain
	 *  pinned until pushed on or off screen by the next subheader. @see [Material
	 *  Design Specifications](https://www.google.com/design/spec/components/subheaders.html)
	 *
	 *  > To improve the visual grouping of content, use the system color for your subheaders.
	 *
	 */
	MdSubheaderDirective.$inject = ["$mdSticky", "$compile", "$mdTheming", "$mdUtil", "$mdAria"];
	angular
	  .module('material.components.subheader', [
	    'material.core',
	    'material.components.sticky'
	  ])
	  .directive('mdSubheader', MdSubheaderDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdSubheader
	 * @module material.components.subheader
	 *
	 * @restrict E
	 *
	 * @description
	 * The `md-subheader` directive creates a sticky subheader for a section.
	 *
	 * Developers are able to disable the stickiness of the subheader by using the following markup
	 *
	 * <hljs lang="html">
	 *   <md-subheader class="md-no-sticky">Not Sticky</md-subheader>
	 * </hljs>
	 *
	 * ### Notes
	 * - The `md-subheader` directive uses the <a ng-href="api/service/$mdSticky">$mdSticky</a> service
	 * to make the subheader sticky.
	 *
	 * > Whenever the current browser doesn't support stickiness natively, the subheader
	 * will be compiled twice to create a sticky clone of the subheader.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-subheader>Online Friends</md-subheader>
	 * </hljs>
	 */
	
	function MdSubheaderDirective($mdSticky, $compile, $mdTheming, $mdUtil, $mdAria) {
	  return {
	    restrict: 'E',
	    replace: true,
	    transclude: true,
	    template: (
	    '<div class="md-subheader _md">' +
	    '  <div class="md-subheader-inner">' +
	    '    <div class="md-subheader-content"></div>' +
	    '  </div>' +
	    '</div>'
	    ),
	    link: function postLink(scope, element, attr, controllers, transclude) {
	      $mdTheming(element);
	      element.addClass('_md');
	
	      // Remove the ngRepeat attribute from the root element, because we don't want to compile
	      // the ngRepeat for the sticky clone again.
	      $mdUtil.prefixer().removeAttribute(element, 'ng-repeat');
	
	      var outerHTML = element[0].outerHTML;
	
	      function getContent(el) {
	        return angular.element(el[0].querySelector('.md-subheader-content'));
	      }
	
	      // Set the ARIA attributes on the original element since it keeps it's original place in
	      // the DOM, whereas the clones are in reverse order. Should be done after the outerHTML,
	      // in order to avoid having multiple element be marked as headers.
	      attr.$set('role', 'heading');
	      $mdAria.expect(element, 'aria-level', '2');
	
	      // Transclude the user-given contents of the subheader
	      // the conventional way.
	      transclude(scope, function(clone) {
	        getContent(element).append(clone);
	      });
	
	      // Create another clone, that uses the outer and inner contents
	      // of the element, that will be 'stickied' as the user scrolls.
	      if (!element.hasClass('md-no-sticky')) {
	        transclude(scope, function(clone) {
	          // If the user adds an ng-if or ng-repeat directly to the md-subheader element, the
	          // compiled clone below will only be a comment tag (since they replace their elements with
	          // a comment) which cannot be properly passed to the $mdSticky; so we wrap it in our own
	          // DIV to ensure we have something $mdSticky can use
	          var wrapper = $compile('<div class="md-subheader-wrapper" aria-hidden="true">' + outerHTML + '</div>')(scope);
	
	          // Delay initialization until after any `ng-if`/`ng-repeat`/etc has finished before
	          // attempting to create the clone
	          $mdUtil.nextTick(function() {
	            // Append our transcluded clone into the wrapper.
	            // We don't have to recompile the element again, because the clone is already
	            // compiled in it's transclusion scope. If we recompile the outerHTML of the new clone, we would lose
	            // our ngIf's and other previous registered bindings / properties.
	            getContent(wrapper).append(clone);
	          });
	
	          // Make the element sticky and provide the stickyClone our self, to avoid recompilation of the subheader
	          // element.
	          $mdSticky(scope, element, wrapper);
	        });
	      }
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.switch
	 */
	
	MdSwitch.$inject = ["mdCheckboxDirective", "$mdUtil", "$mdConstant", "$parse", "$$rAF", "$mdGesture", "$timeout"];
	angular.module('material.components.switch', [
	  'material.core',
	  'material.components.checkbox'
	])
	  .directive('mdSwitch', MdSwitch);
	
	/**
	 * @ngdoc directive
	 * @module material.components.switch
	 * @name mdSwitch
	 * @restrict E
	 *
	 * The switch directive is used very much like the normal [angular checkbox](https://docs.angularjs.org/api/ng/input/input%5Bcheckbox%5D).
	 *
	 * As per the [material design spec](http://www.google.com/design/spec/style/color.html#color-ui-color-application)
	 * the switch is in the accent color by default. The primary color palette may be used with
	 * the `md-primary` class.
	 *
	 * @param {string} ng-model Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {expression=} ng-true-value The value to which the expression should be set when selected.
	 * @param {expression=} ng-false-value The value to which the expression should be set when not selected.
	 * @param {string=} ng-change AngularJS expression to be executed when input changes due to user interaction with the input element.
	 * @param {expression=} ng-disabled En/Disable based on the expression.
	 * @param {boolean=} md-no-ink Use of attribute indicates use of ripple ink effects.
	 * @param {string=} aria-label Publish the button label used by screen-readers for accessibility. Defaults to the switch's text.
	 * @param {boolean=} md-invert When set to true, the switch will be inverted.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-switch ng-model="isActive" aria-label="Finished?">
	 *   Finished ?
	 * </md-switch>
	 *
	 * <md-switch md-no-ink ng-model="hasInk" aria-label="No Ink Effects">
	 *   No Ink Effects
	 * </md-switch>
	 *
	 * <md-switch ng-disabled="true" ng-model="isDisabled" aria-label="Disabled">
	 *   Disabled
	 * </md-switch>
	 *
	 * </hljs>
	 */
	function MdSwitch(mdCheckboxDirective, $mdUtil, $mdConstant, $parse, $$rAF, $mdGesture, $timeout) {
	  var checkboxDirective = mdCheckboxDirective[0];
	
	  return {
	    restrict: 'E',
	    priority: $mdConstant.BEFORE_NG_ARIA,
	    transclude: true,
	    template:
	      '<div class="md-container">' +
	        '<div class="md-bar"></div>' +
	        '<div class="md-thumb-container">' +
	          '<div class="md-thumb" md-ink-ripple md-ink-ripple-checkbox></div>' +
	        '</div>'+
	      '</div>' +
	      '<div ng-transclude class="md-label"></div>',
	    require: ['^?mdInputContainer', '?ngModel', '?^form'],
	    compile: mdSwitchCompile
	  };
	
	  function mdSwitchCompile(element, attr) {
	    var checkboxLink = checkboxDirective.compile(element, attr).post;
	    // No transition on initial load.
	    element.addClass('md-dragging');
	
	    return function (scope, element, attr, ctrls) {
	      var containerCtrl = ctrls[0];
	      var ngModel = ctrls[1] || $mdUtil.fakeNgModel();
	      var formCtrl = ctrls[2];
	
	      var disabledGetter = null;
	      if (attr.disabled != null) {
	        disabledGetter = function() { return true; };
	      } else if (attr.ngDisabled) {
	        disabledGetter = $parse(attr.ngDisabled);
	      }
	
	      var thumbContainer = angular.element(element[0].querySelector('.md-thumb-container'));
	      var switchContainer = angular.element(element[0].querySelector('.md-container'));
	      var labelContainer = angular.element(element[0].querySelector('.md-label'));
	
	      // no transition on initial load
	      $$rAF(function() {
	        element.removeClass('md-dragging');
	      });
	
	      checkboxLink(scope, element, attr, ctrls);
	
	      if (disabledGetter) {
	        scope.$watch(disabledGetter, function(isDisabled) {
	          element.attr('tabindex', isDisabled ? -1 : 0);
	        });
	      }
	
	      attr.$observe('mdInvert', function(newValue) {
	        var isInverted = $mdUtil.parseAttributeBoolean(newValue);
	
	        isInverted ? element.prepend(labelContainer) : element.prepend(switchContainer);
	
	        // Toggle a CSS class to update the margin.
	        element.toggleClass('md-inverted', isInverted);
	      });
	
	      // These events are triggered by setup drag
	      $mdGesture.register(switchContainer, 'drag');
	      switchContainer
	        .on('$md.dragstart', onDragStart)
	        .on('$md.drag', onDrag)
	        .on('$md.dragend', onDragEnd);
	
	      var drag;
	      function onDragStart(ev) {
	        // Don't go if the switch is disabled.
	        if (disabledGetter && disabledGetter(scope)) return;
	        ev.stopPropagation();
	
	        element.addClass('md-dragging');
	        drag = {width: thumbContainer.prop('offsetWidth')};
	      }
	
	      function onDrag(ev) {
	        if (!drag) return;
	        ev.stopPropagation();
	        ev.srcEvent && ev.srcEvent.preventDefault();
	
	        var percent = ev.pointer.distanceX / drag.width;
	
	        //if checked, start from right. else, start from left
	        var translate = ngModel.$viewValue ?  1 + percent : percent;
	        // Make sure the switch stays inside its bounds, 0-1%
	        translate = Math.max(0, Math.min(1, translate));
	
	        thumbContainer.css($mdConstant.CSS.TRANSFORM, 'translate3d(' + (100*translate) + '%,0,0)');
	        drag.translate = translate;
	      }
	
	      function onDragEnd(ev) {
	        if (!drag) return;
	        ev.stopPropagation();
	
	        element.removeClass('md-dragging');
	        thumbContainer.css($mdConstant.CSS.TRANSFORM, '');
	
	        // We changed if there is no distance (this is a click a click),
	        // or if the drag distance is >50% of the total.
	        var isChanged = ngModel.$viewValue ? drag.translate < 0.5 : drag.translate > 0.5;
	        if (isChanged) {
	          applyModelValue(!ngModel.$viewValue);
	        }
	        drag = null;
	
	        // Wait for incoming mouse click
	        scope.skipToggle = true;
	        $timeout(function() {
	          scope.skipToggle = false;
	        }, 1);
	      }
	
	      function applyModelValue(newValue) {
	        scope.$apply(function() {
	          ngModel.$setViewValue(newValue);
	          ngModel.$render();
	        });
	      }
	
	    };
	  }
	
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.swipe
	 * @description Swipe module!
	 */
	/**
	 * @ngdoc directive
	 * @module material.components.swipe
	 * @name mdSwipeLeft
	 *
	 * @restrict A
	 *
	 * @description
	 * The md-swipe-left directive allows you to specify custom behavior when an element is swiped
	 * left.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div md-swipe-left="onSwipeLeft()">Swipe me left!</div>
	 * </hljs>
	 */
	/**
	 * @ngdoc directive
	 * @module material.components.swipe
	 * @name mdSwipeRight
	 *
	 * @restrict A
	 *
	 * @description
	 * The md-swipe-right directive allows you to specify custom behavior when an element is swiped
	 * right.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div md-swipe-right="onSwipeRight()">Swipe me right!</div>
	 * </hljs>
	 */
	/**
	 * @ngdoc directive
	 * @module material.components.swipe
	 * @name mdSwipeUp
	 *
	 * @restrict A
	 *
	 * @description
	 * The md-swipe-up directive allows you to specify custom behavior when an element is swiped
	 * up.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div md-swipe-up="onSwipeUp()">Swipe me up!</div>
	 * </hljs>
	 */
	/**
	 * @ngdoc directive
	 * @module material.components.swipe
	 * @name mdSwipeDown
	 *
	 * @restrict A
	 *
	 * @description
	 * The md-swipe-down directive allows you to specify custom behavior when an element is swiped
	 * down.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div md-swipe-down="onSwipDown()">Swipe me down!</div>
	 * </hljs>
	 */
	
	angular.module('material.components.swipe', ['material.core'])
	    .directive('mdSwipeLeft', getDirective('SwipeLeft'))
	    .directive('mdSwipeRight', getDirective('SwipeRight'))
	    .directive('mdSwipeUp', getDirective('SwipeUp'))
	    .directive('mdSwipeDown', getDirective('SwipeDown'));
	
	function getDirective(name) {
	    DirectiveFactory.$inject = ["$parse"];
	  var directiveName = 'md' + name;
	  var eventName = '$md.' + name.toLowerCase();
	
	  return DirectiveFactory;
	
	  /* @ngInject */
	  function DirectiveFactory($parse) {
	      return {restrict: 'A', link: postLink};
	
	    function postLink(scope, element, attr) {
	        element.css('touch-action', attr['mdSwipeTouchAction'] || 'none');
	
	        var fn = $parse(attr[directiveName]);
	        element.on(eventName, function(ev) {
	          scope.$applyAsync(function() { fn(scope, { $event: ev }); });
	        });
	      }
	    }
	}
	
	
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.tabs
	 * @description
	 *
	 *  Tabs, created with the `<md-tabs>` directive provide *tabbed* navigation with different styles.
	 *  The Tabs component consists of clickable tabs that are aligned horizontally side-by-side.
	 *
	 *  Features include support for:
	 *
	 *  - static or dynamic tabs,
	 *  - responsive designs,
	 *  - accessibility support (ARIA),
	 *  - tab pagination,
	 *  - external or internal tab content,
	 *  - focus indicators and arrow-key navigations,
	 *  - programmatic lookup and access to tab controllers, and
	 *  - dynamic transitions through different tab contents.
	 *
	 */
	/*
	 * @see js folder for tabs implementation
	 */
	angular.module('material.components.tabs', [
	  'material.core',
	  'material.components.icon'
	]);
	
	})();
	(function(){
	"use strict";
	
	/**
	  * @ngdoc module
	  * @name material.components.toast
	  * @description
	  * Toast
	  */
	MdToastDirective.$inject = ["$mdToast"];
	MdToastProvider.$inject = ["$$interimElementProvider"];
	angular.module('material.components.toast', [
	  'material.core',
	  'material.components.button'
	])
	  .directive('mdToast', MdToastDirective)
	  .provider('$mdToast', MdToastProvider);
	
	/* @ngInject */
	function MdToastDirective($mdToast) {
	  return {
	    restrict: 'E',
	    link: function postLink(scope, element) {
	      element.addClass('_md');     // private md component indicator for styling
	      
	      // When navigation force destroys an interimElement, then
	      // listen and $destroy() that interim instance...
	      scope.$on('$destroy', function() {
	        $mdToast.destroy();
	      });
	    }
	  };
	}
	
	/**
	  * @ngdoc service
	  * @name $mdToast
	  * @module material.components.toast
	  *
	  * @description
	  * `$mdToast` is a service to build a toast notification on any position
	  * on the screen with an optional duration, and provides a simple promise API.
	  *
	  * The toast will be always positioned at the `bottom`, when the screen size is
	  * between `600px` and `959px` (`sm` breakpoint)
	  *
	  * ## Restrictions on custom toasts
	  * - The toast's template must have an outer `<md-toast>` element.
	  * - For a toast action, use element with class `md-action`.
	  * - Add the class `md-capsule` for curved corners.
	  *
	  * ### Custom Presets
	  * Developers are also able to create their own preset, which can be easily used without repeating
	  * their options each time.
	  *
	  * <hljs lang="js">
	  *   $mdToastProvider.addPreset('testPreset', {
	  *     options: function() {
	  *       return {
	  *         template:
	  *           '<md-toast>' +
	  *             '<div class="md-toast-content">' +
	  *               'This is a custom preset' +
	  *             '</div>' +
	  *           '</md-toast>',
	  *         controllerAs: 'toast',
	  *         bindToController: true
	  *       };
	  *     }
	  *   });
	  * </hljs>
	  *
	  * After you created your preset at config phase, you can easily access it.
	  *
	  * <hljs lang="js">
	  *   $mdToast.show(
	  *     $mdToast.testPreset()
	  *   );
	  * </hljs>
	  *
	  * ## Parent container notes
	  *
	  * The toast is positioned using absolute positioning relative to its first non-static parent
	  * container. Thus, if the requested parent container uses static positioning, we will temporarily
	  * set its positioning to `relative` while the toast is visible and reset it when the toast is
	  * hidden.
	  *
	  * Because of this, it is usually best to ensure that the parent container has a fixed height and
	  * prevents scrolling by setting the `overflow: hidden;` style. Since the position is based off of
	  * the parent's height, the toast may be mispositioned if you allow the parent to scroll.
	  *
	  * You can, however, have a scrollable element inside of the container; just make sure the
	  * container itself does not scroll.
	  *
	  * <hljs lang="html">
	  * <div layout-fill id="toast-container">
	  *   <md-content>
	  *     I can have lots of content and scroll!
	  *   </md-content>
	  * </div>
	  * </hljs>
	  *
	  * @usage
	  * <hljs lang="html">
	  * <div ng-controller="MyController">
	  *   <md-button ng-click="openToast()">
	  *     Open a Toast!
	  *   </md-button>
	  * </div>
	  * </hljs>
	  *
	  * <hljs lang="js">
	  * var app = angular.module('app', ['ngMaterial']);
	  * app.controller('MyController', function($scope, $mdToast) {
	  *   $scope.openToast = function($event) {
	  *     $mdToast.show($mdToast.simple().textContent('Hello!'));
	  *     // Could also do $mdToast.showSimple('Hello');
	  *   };
	  * });
	  * </hljs>
	  */
	
	/**
	 * @ngdoc method
	 * @name $mdToast#showSimple
	 * 
	 * @param {string} message The message to display inside the toast
	 * @description
	 * Convenience method which builds and shows a simple toast.
	 *
	 * @returns {promise} A promise that can be resolved with `$mdToast.hide()` or
	 * rejected with `$mdToast.cancel()`.
	 *
	 */
	
	 /**
	  * @ngdoc method
	  * @name $mdToast#simple
	  *
	  * @description
	  * Builds a preconfigured toast.
	  *
	  * @returns {obj} a `$mdToastPreset` with the following chainable configuration methods.
	  *
	  * _**Note:** These configuration methods are provided in addition to the methods provided by
	  * the `build()` and `show()` methods below._
	  *
	  * <table class="md-api-table methods">
	  *    <thead>
	  *      <tr>
	  *        <th>Method</th>
	  *        <th>Description</th>
	  *      </tr>
	  *    </thead>
	  *    <tbody>
	  *      <tr>
	  *        <td>`.textContent(string)`</td>
	  *        <td>Sets the toast content to the specified string</td>
	  *      </tr>
	  *      <tr>
	  *        <td>`.action(string)`</td>
	  *        <td>
	  *          Adds an action button. <br/>
	  *          If clicked, the promise (returned from `show()`)
	  *          will resolve with the value `'ok'`; otherwise, it is resolved with `true` after a `hideDelay`
	  *          timeout
	  *        </td>
	  *      </tr>
	  *      <tr>
	  *        <td>`.highlightAction(boolean)`</td>
	  *        <td>
	  *          Whether or not the action button will have an additional highlight class.<br/>
	  *          By default the `accent` color will be applied to the action button.
	  *        </td>
	  *      </tr>
	  *      <tr>
	  *        <td>`.highlightClass(string)`</td>
	  *        <td>
	  *          If set, the given class will be applied to the highlighted action button.<br/>
	  *          This allows you to specify the highlight color easily. Highlight classes are `md-primary`, `md-warn`
	  *          and `md-accent`
	  *        </td>
	  *      </tr>
	  *      <tr>
	  *        <td>`.capsule(boolean)`</td>
	  *        <td>Whether or not to add the `md-capsule` class to the toast to provide rounded corners</td>
	  *      </tr>
	  *      <tr>
	  *        <td>`.theme(string)`</td>
	  *        <td>Sets the theme on the toast to the requested theme. Default is `$mdThemingProvider`'s default.</td>
	  *      </tr>
	  *      <tr>
	  *        <td>`.toastClass(string)`</td>
	  *        <td>Sets a class on the toast element</td>
	  *      </tr>
	  *    </tbody>
	  * </table>
	  *
	  */
	
	/**
	  * @ngdoc method
	  * @name $mdToast#updateTextContent
	  *
	  * @description
	  * Updates the content of an existing toast. Useful for updating things like counts, etc.
	  *
	  */
	
	 /**
	  * @ngdoc method
	  * @name $mdToast#build
	  *
	  * @description
	  * Creates a custom `$mdToastPreset` that you can configure.
	  *
	  * @returns {obj} a `$mdToastPreset` with the chainable configuration methods for shows' options (see below).
	  */
	
	 /**
	  * @ngdoc method
	  * @name $mdToast#show
	  *
	  * @description Shows the toast.
	  *
	  * @param {object} optionsOrPreset Either provide an `$mdToastPreset` returned from `simple()`
	  * and `build()`, or an options object with the following properties:
	  *
	  *   - `templateUrl` - `{string=}`: The url of an html template file that will
	  *     be used as the content of the toast. Restrictions: the template must
	  *     have an outer `md-toast` element.
	  *   - `template` - `{string=}`: Same as templateUrl, except this is an actual
	  *     template string.
	  *   - `autoWrap` - `{boolean=}`: Whether or not to automatically wrap the template content with a
	  *     `<div class="md-toast-content">` if one is not provided. Defaults to true. Can be disabled if you provide a
	  *     custom toast directive.
	  *   - `scope` - `{object=}`: the scope to link the template / controller to. If none is specified, it will create a new child scope.
	  *     This scope will be destroyed when the toast is removed unless `preserveScope` is set to true.
	  *   - `preserveScope` - `{boolean=}`: whether to preserve the scope when the element is removed. Default is false
	  *   - `hideDelay` - `{number=}`: How many milliseconds the toast should stay
	  *     active before automatically closing.  Set to 0 or false to have the toast stay open until
	  *     closed manually. Default: 3000.
	  *   - `position` - `{string=}`: Sets the position of the toast. <br/>
	  *     Available: any combination of `'bottom'`, `'left'`, `'top'`, `'right'`, `'end'` and `'start'`.
	  *     The properties `'end'` and `'start'` are dynamic and can be used for RTL support.<br/>
	  *     Default combination: `'bottom left'`.
	  *   - `toastClass` - `{string=}`: A class to set on the toast element.
	  *   - `controller` - `{string=}`: The controller to associate with this toast.
	  *     The controller will be injected the local `$mdToast.hide( )`, which is a function
	  *     used to hide the toast.
	  *   - `locals` - `{string=}`: An object containing key/value pairs. The keys will
	  *     be used as names of values to inject into the controller. For example,
	  *     `locals: {three: 3}` would inject `three` into the controller with the value
	  *     of 3.
	  *   - `bindToController` - `bool`: bind the locals to the controller, instead of passing them in.
	  *   - `resolve` - `{object=}`: Similar to locals, except it takes promises as values
	  *     and the toast will not open until the promises resolve.
	  *   - `controllerAs` - `{string=}`: An alias to assign the controller to on the scope.
	  *   - `parent` - `{element=}`: The element to append the toast to. Defaults to appending
	  *     to the root element of the application.
	  *
	  * @returns {promise} A promise that can be resolved with `$mdToast.hide()` or
	  * rejected with `$mdToast.cancel()`. `$mdToast.hide()` will resolve either with a Boolean
	  * value == 'true' or the value passed as an argument to `$mdToast.hide()`.
	  * And `$mdToast.cancel()` will resolve the promise with a Boolean value == 'false'
	  */
	
	/**
	  * @ngdoc method
	  * @name $mdToast#hide
	  *
	  * @description
	  * Hide an existing toast and resolve the promise returned from `$mdToast.show()`.
	  *
	  * @param {*=} response An argument for the resolved promise.
	  *
	  * @returns {promise} a promise that is called when the existing element is removed from the DOM.
	  * The promise is resolved with either a Boolean value == 'true' or the value passed as the
	  * argument to `.hide()`.
	  *
	  */
	
	/**
	  * @ngdoc method
	  * @name $mdToast#cancel
	  *
	  * @description
	  * `DEPRECATED` - The promise returned from opening a toast is used only to notify about the closing of the toast.
	  * As such, there isn't any reason to also allow that promise to be rejected,
	  * since it's not clear what the difference between resolve and reject would be.
	  *
	  * Hide the existing toast and reject the promise returned from
	  * `$mdToast.show()`.
	  *
	  * @param {*=} response An argument for the rejected promise.
	  *
	  * @returns {promise} a promise that is called when the existing element is removed from the DOM
	  * The promise is resolved with a Boolean value == 'false'.
	  *
	  */
	
	function MdToastProvider($$interimElementProvider) {
	  // Differentiate promise resolves: hide timeout (value == true) and hide action clicks (value == ok).
	  toastDefaultOptions.$inject = ["$animate", "$mdToast", "$mdUtil", "$mdMedia"];
	  var ACTION_RESOLVE = 'ok';
	
	  var activeToastContent;
	  var $mdToast = $$interimElementProvider('$mdToast')
	    .setDefaults({
	      methods: ['position', 'hideDelay', 'capsule', 'parent', 'position', 'toastClass'],
	      options: toastDefaultOptions
	    })
	    .addPreset('simple', {
	      argOption: 'textContent',
	      methods: ['textContent', 'content', 'action', 'highlightAction', 'highlightClass', 'theme', 'parent' ],
	      options: /* @ngInject */ ["$mdToast", "$mdTheming", function($mdToast, $mdTheming) {
	        return {
	          template:
	            '<md-toast md-theme="{{ toast.theme }}" ng-class="{\'md-capsule\': toast.capsule}">' +
	            '  <div class="md-toast-content">' +
	            '    <span class="md-toast-text" role="alert" aria-relevant="all" aria-atomic="true">' +
	            '      {{ toast.content }}' +
	            '    </span>' +
	            '    <md-button class="md-action" ng-if="toast.action" ng-click="toast.resolve()" ' +
	            '        ng-class="highlightClasses">' +
	            '      {{ toast.action }}' +
	            '    </md-button>' +
	            '  </div>' +
	            '</md-toast>',
	          controller: /* @ngInject */ ["$scope", function mdToastCtrl($scope) {
	            var self = this;
	
	            if (self.highlightAction) {
	              $scope.highlightClasses = [
	                'md-highlight',
	                self.highlightClass
	              ]
	            }
	
	            $scope.$watch(function() { return activeToastContent; }, function() {
	              self.content = activeToastContent;
	            });
	
	            this.resolve = function() {
	              $mdToast.hide( ACTION_RESOLVE );
	            };
	          }],
	          theme: $mdTheming.defaultTheme(),
	          controllerAs: 'toast',
	          bindToController: true
	        };
	      }]
	    })
	    .addMethod('updateTextContent', updateTextContent)
	    .addMethod('updateContent', updateTextContent);
	
	    function updateTextContent(newContent) {
	      activeToastContent = newContent;
	    }
	
	    return $mdToast;
	
	  /* @ngInject */
	  function toastDefaultOptions($animate, $mdToast, $mdUtil, $mdMedia) {
	    var SWIPE_EVENTS = '$md.swipeleft $md.swiperight $md.swipeup $md.swipedown';
	    return {
	      onShow: onShow,
	      onRemove: onRemove,
	      toastClass: '',
	      position: 'bottom left',
	      themable: true,
	      hideDelay: 3000,
	      autoWrap: true,
	      transformTemplate: function(template, options) {
	        var shouldAddWrapper = options.autoWrap && template && !/md-toast-content/g.test(template);
	
	        if (shouldAddWrapper) {
	          // Root element of template will be <md-toast>. We need to wrap all of its content inside of
	          // of <div class="md-toast-content">. All templates provided here should be static, developer-controlled
	          // content (meaning we're not attempting to guard against XSS).
	          var templateRoot = document.createElement('md-template');
	          templateRoot.innerHTML = template;
	
	          // Iterate through all root children, to detect possible md-toast directives.
	          for (var i = 0; i < templateRoot.children.length; i++) {
	            if (templateRoot.children[i].nodeName === 'MD-TOAST') {
	              var wrapper = angular.element('<div class="md-toast-content">');
	
	              // Wrap the children of the `md-toast` directive in jqLite, to be able to append multiple
	              // nodes with the same execution.
	              wrapper.append(angular.element(templateRoot.children[i].childNodes));
	
	              // Append the new wrapped element to the `md-toast` directive.
	              templateRoot.children[i].appendChild(wrapper[0]);
	            }
	          }
	
	          // We have to return the innerHTMl, because we do not want to have the `md-template` element to be
	          // the root element of our interimElement.
	          return templateRoot.innerHTML;
	        }
	
	        return template || '';
	      }
	    };
	
	    function onShow(scope, element, options) {
	      activeToastContent = options.textContent || options.content; // support deprecated #content method
	
	      var isSmScreen = !$mdMedia('gt-sm');
	
	      element = $mdUtil.extractElementByName(element, 'md-toast', true);
	      options.element = element;
	
	      options.onSwipe = function(ev, gesture) {
	        //Add the relevant swipe class to the element so it can animate correctly
	        var swipe = ev.type.replace('$md.','');
	        var direction = swipe.replace('swipe', '');
	
	        // If the swipe direction is down/up but the toast came from top/bottom don't fade away
	        // Unless the screen is small, then the toast always on bottom
	        if ((direction === 'down' && options.position.indexOf('top') != -1 && !isSmScreen) ||
	            (direction === 'up' && (options.position.indexOf('bottom') != -1 || isSmScreen))) {
	          return;
	        }
	
	        if ((direction === 'left' || direction === 'right') && isSmScreen) {
	          return;
	        }
	
	        element.addClass('md-' + swipe);
	        $mdUtil.nextTick($mdToast.cancel);
	      };
	      options.openClass = toastOpenClass(options.position);
	
	      element.addClass(options.toastClass);
	
	      // 'top left' -> 'md-top md-left'
	      options.parent.addClass(options.openClass);
	
	      // static is the default position
	      if ($mdUtil.hasComputedStyle(options.parent, 'position', 'static')) {
	        options.parent.css('position', 'relative');
	      }
	
	      element.on(SWIPE_EVENTS, options.onSwipe);
	      element.addClass(isSmScreen ? 'md-bottom' : options.position.split(' ').map(function(pos) {
	        return 'md-' + pos;
	      }).join(' '));
	
	      if (options.parent) options.parent.addClass('md-toast-animating');
	      return $animate.enter(element, options.parent).then(function() {
	        if (options.parent) options.parent.removeClass('md-toast-animating');
	      });
	    }
	
	    function onRemove(scope, element, options) {
	      element.off(SWIPE_EVENTS, options.onSwipe);
	      if (options.parent) options.parent.addClass('md-toast-animating');
	      if (options.openClass) options.parent.removeClass(options.openClass);
	
	      return ((options.$destroy == true) ? element.remove() : $animate.leave(element))
	        .then(function () {
	          if (options.parent) options.parent.removeClass('md-toast-animating');
	          if ($mdUtil.hasComputedStyle(options.parent, 'position', 'static')) {
	            options.parent.css('position', '');
	          }
	        });
	    }
	
	    function toastOpenClass(position) {
	      // For mobile, always open full-width on bottom
	      if (!$mdMedia('gt-xs')) {
	        return 'md-toast-open-bottom';
	      }
	
	      return 'md-toast-open-' +
	        (position.indexOf('top') > -1 ? 'top' : 'bottom');
	    }
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.toolbar
	 */
	mdToolbarDirective.$inject = ["$$rAF", "$mdConstant", "$mdUtil", "$mdTheming", "$animate"];
	angular.module('material.components.toolbar', [
	  'material.core',
	  'material.components.content'
	])
	  .directive('mdToolbar', mdToolbarDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdToolbar
	 * @module material.components.toolbar
	 * @restrict E
	 * @description
	 * `md-toolbar` is used to place a toolbar in your app.
	 *
	 * Toolbars are usually used above a content area to display the title of the
	 * current page, and show relevant action buttons for that page.
	 *
	 * You can change the height of the toolbar by adding either the
	 * `md-medium-tall` or `md-tall` class to the toolbar.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div layout="column" layout-fill>
	 *   <md-toolbar>
	 *
	 *     <div class="md-toolbar-tools">
	 *       <h2 md-truncate flex>My App's Title</h2>
	 *
	 *       <md-button>
	 *         Right Bar Button
	 *       </md-button>
	 *     </div>
	 *
	 *   </md-toolbar>
	 *   <md-content>
	 *     Hello!
	 *   </md-content>
	 * </div>
	 * </hljs>
	 *
	 * <i><b>Note:</b> The code above shows usage with the `md-truncate` component which provides an
	 * ellipsis if the title is longer than the width of the Toolbar.</i>
	 *
	 * ## CSS & Styles
	 *
	 * The `<md-toolbar>` provides a few custom CSS classes that you may use to enhance the
	 * functionality of your toolbar.
	 *
	 * <div>
	 * <docs-css-api-table>
	 *
	 *   <docs-css-selector code="md-toolbar .md-toolbar-tools">
	 *     The `md-toolbar-tools` class provides quite a bit of automatic styling for your toolbar
	 *     buttons and text. When applied, it will center the buttons and text vertically for you.
	 *   </docs-css-selector>
	 *
	 * </docs-css-api-table>
	 * </div>
	 *
	 * ### Private Classes
	 *
	 * Currently, the only private class is the `md-toolbar-transitions` class. All other classes are
	 * considered public.
	 *
	 * @param {boolean=} md-scroll-shrink Whether the header should shrink away as
	 * the user scrolls down, and reveal itself as the user scrolls up.
	 *
	 * _**Note (1):** for scrollShrink to work, the toolbar must be a sibling of a
	 * `md-content` element, placed before it. See the scroll shrink demo._
	 *
	 * _**Note (2):** The `md-scroll-shrink` attribute is only parsed on component
	 * initialization, it does not watch for scope changes._
	 *
	 *
	 * @param {number=} md-shrink-speed-factor How much to change the speed of the toolbar's
	 * shrinking by. For example, if 0.25 is given then the toolbar will shrink
	 * at one fourth the rate at which the user scrolls down. Default 0.5.
	 *
	 */
	
	function mdToolbarDirective($$rAF, $mdConstant, $mdUtil, $mdTheming, $animate) {
	  var translateY = angular.bind(null, $mdUtil.supplant, 'translate3d(0,{0}px,0)');
	
	  return {
	    template: '',
	    restrict: 'E',
	
	    link: function(scope, element, attr) {
	
	      element.addClass('_md');     // private md component indicator for styling
	      $mdTheming(element);
	
	      $mdUtil.nextTick(function () {
	        element.addClass('_md-toolbar-transitions');     // adding toolbar transitions after digest
	      }, false);
	
	      if (angular.isDefined(attr.mdScrollShrink)) {
	        setupScrollShrink();
	      }
	
	      function setupScrollShrink() {
	
	        var toolbarHeight;
	        var contentElement;
	        var disableScrollShrink = angular.noop;
	
	        // Current "y" position of scroll
	        // Store the last scroll top position
	        var y = 0;
	        var prevScrollTop = 0;
	        var shrinkSpeedFactor = attr.mdShrinkSpeedFactor || 0.5;
	
	        var debouncedContentScroll = $$rAF.throttle(onContentScroll);
	        var debouncedUpdateHeight = $mdUtil.debounce(updateToolbarHeight, 5 * 1000);
	
	        // Wait for $mdContentLoaded event from mdContent directive.
	        // If the mdContent element is a sibling of our toolbar, hook it up
	        // to scroll events.
	
	        scope.$on('$mdContentLoaded', onMdContentLoad);
	
	        // If the toolbar is used inside an ng-if statement, we may miss the
	        // $mdContentLoaded event, so we attempt to fake it if we have a
	        // md-content close enough.
	
	        attr.$observe('mdScrollShrink', onChangeScrollShrink);
	
	        // If the toolbar has ngShow or ngHide we need to update height immediately as it changed
	        // and not wait for $mdUtil.debounce to happen
	
	        if (attr.ngShow) { scope.$watch(attr.ngShow, updateToolbarHeight); }
	        if (attr.ngHide) { scope.$watch(attr.ngHide, updateToolbarHeight); }
	
	        // If the scope is destroyed (which could happen with ng-if), make sure
	        // to disable scroll shrinking again
	
	        scope.$on('$destroy', disableScrollShrink);
	
	        /**
	         *
	         */
	        function onChangeScrollShrink(shrinkWithScroll) {
	          var closestContent = element.parent().find('md-content');
	
	          // If we have a content element, fake the call; this might still fail
	          // if the content element isn't a sibling of the toolbar
	
	          if (!contentElement && closestContent.length) {
	            onMdContentLoad(null, closestContent);
	          }
	
	          // Evaluate the expression
	          shrinkWithScroll = scope.$eval(shrinkWithScroll);
	
	          // Disable only if the attribute's expression evaluates to false
	          if (shrinkWithScroll === false) {
	            disableScrollShrink();
	          } else {
	            disableScrollShrink = enableScrollShrink();
	          }
	        }
	
	        /**
	         *
	         */
	        function onMdContentLoad($event, newContentEl) {
	          // Toolbar and content must be siblings
	          if (newContentEl && element.parent()[0] === newContentEl.parent()[0]) {
	            // unhook old content event listener if exists
	            if (contentElement) {
	              contentElement.off('scroll', debouncedContentScroll);
	            }
	
	            contentElement = newContentEl;
	            disableScrollShrink = enableScrollShrink();
	          }
	        }
	
	        /**
	         *
	         */
	        function onContentScroll(e) {
	          var scrollTop = e ? e.target.scrollTop : prevScrollTop;
	
	          debouncedUpdateHeight();
	
	          y = Math.min(
	            toolbarHeight / shrinkSpeedFactor,
	            Math.max(0, y + scrollTop - prevScrollTop)
	          );
	
	          element.css($mdConstant.CSS.TRANSFORM, translateY([-y * shrinkSpeedFactor]));
	          contentElement.css($mdConstant.CSS.TRANSFORM, translateY([(toolbarHeight - y) * shrinkSpeedFactor]));
	
	          prevScrollTop = scrollTop;
	
	          $mdUtil.nextTick(function() {
	            var hasWhiteFrame = element.hasClass('md-whiteframe-z1');
	
	            if (hasWhiteFrame && !y) {
	              $animate.removeClass(element, 'md-whiteframe-z1');
	            } else if (!hasWhiteFrame && y) {
	              $animate.addClass(element, 'md-whiteframe-z1');
	            }
	          });
	
	        }
	
	        /**
	         *
	         */
	        function enableScrollShrink() {
	          if (!contentElement)     return angular.noop;           // no md-content
	
	          contentElement.on('scroll', debouncedContentScroll);
	          contentElement.attr('scroll-shrink', 'true');
	
	          $mdUtil.nextTick(updateToolbarHeight, false);
	
	          return function disableScrollShrink() {
	            contentElement.off('scroll', debouncedContentScroll);
	            contentElement.attr('scroll-shrink', 'false');
	
	            updateToolbarHeight();
	          };
	        }
	
	        /**
	         *
	         */
	        function updateToolbarHeight() {
	          toolbarHeight = element.prop('offsetHeight');
	          // Add a negative margin-top the size of the toolbar to the content el.
	          // The content will start transformed down the toolbarHeight amount,
	          // so everything looks normal.
	          //
	          // As the user scrolls down, the content will be transformed up slowly
	          // to put the content underneath where the toolbar was.
	          var margin = (-toolbarHeight * shrinkSpeedFactor) + 'px';
	
	          contentElement.css({
	            "margin-top": margin,
	            "margin-bottom": margin
	          });
	
	          onContentScroll();
	        }
	
	      }
	
	    }
	  };
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.tooltip
	 */
	MdTooltipDirective.$inject = ["$timeout", "$window", "$$rAF", "$document", "$interpolate", "$mdUtil", "$mdPanel", "$$mdTooltipRegistry"];
	angular
	    .module('material.components.tooltip', [
	      'material.core',
	      'material.components.panel'
	    ])
	    .directive('mdTooltip', MdTooltipDirective)
	    .service('$$mdTooltipRegistry', MdTooltipRegistry);
	
	
	/**
	 * @ngdoc directive
	 * @name mdTooltip
	 * @module material.components.tooltip
	 * @description
	 * Tooltips are used to describe elements that are interactive and primarily
	 * graphical (not textual).
	 *
	 * Place a `<md-tooltip>` as a child of the element it describes.
	 *
	 * A tooltip will activate when the user hovers over, focuses, or touches the
	 * parent element.
	 *
	 * @usage
	 * <hljs lang="html">
	 *   <md-button class="md-fab md-accent" aria-label="Play">
	 *     <md-tooltip>Play Music</md-tooltip>
	 *     <md-icon md-svg-src="img/icons/ic_play_arrow_24px.svg"></md-icon>
	 *   </md-button>
	 * </hljs>
	 *
	 * @param {number=} md-z-index The visual level that the tooltip will appear
	 *     in comparison with the rest of the elements of the application.
	 * @param {expression=} md-visible Boolean bound to whether the tooltip is
	 *     currently visible.
	 * @param {number=} md-delay How many milliseconds to wait to show the tooltip
	 *     after the user hovers over, focuses, or touches the parent element.
	 *     Defaults to 0ms on non-touch devices and 75ms on touch.
	 * @param {boolean=} md-autohide If present or provided with a boolean value,
	 *     the tooltip will hide on mouse leave, regardless of focus.
	 * @param {string=} md-direction The direction that the tooltip is shown,
	 *     relative to the parent element. Supports top, right, bottom, and left.
	 *     Defaults to bottom.
	 */
	function MdTooltipDirective($timeout, $window, $$rAF, $document, $interpolate,
	    $mdUtil, $mdPanel, $$mdTooltipRegistry) {
	
	  var ENTER_EVENTS = 'focus touchstart mouseenter';
	  var LEAVE_EVENTS = 'blur touchcancel mouseleave';
	  var TOOLTIP_DEFAULT_Z_INDEX = 100;
	  var TOOLTIP_DEFAULT_SHOW_DELAY = 0;
	  var TOOLTIP_DEFAULT_DIRECTION = 'bottom';
	  var TOOLTIP_DIRECTIONS = {
	    top: { x: $mdPanel.xPosition.CENTER, y: $mdPanel.yPosition.ABOVE },
	    right: { x: $mdPanel.xPosition.OFFSET_END, y: $mdPanel.yPosition.CENTER },
	    bottom: { x: $mdPanel.xPosition.CENTER, y: $mdPanel.yPosition.BELOW },
	    left: { x: $mdPanel.xPosition.OFFSET_START, y: $mdPanel.yPosition.CENTER }
	  };
	
	  return {
	    restrict: 'E',
	    priority: 210, // Before ngAria
	    scope: {
	      mdZIndex: '=?mdZIndex',
	      mdDelay: '=?mdDelay',
	      mdVisible: '=?mdVisible',
	      mdAutohide: '=?mdAutohide',
	      mdDirection: '@?mdDirection' // Do not expect expressions.
	    },
	    link: linkFunc
	  };
	
	  function linkFunc(scope, element, attr) {
	    // Set constants.
	    var tooltipId = 'md-tooltip-' + $mdUtil.nextUid();
	    var parent = $mdUtil.getParentWithPointerEvents(element);
	    var debouncedOnResize = $$rAF.throttle(updatePosition);
	    var mouseActive = false;
	    var origin, position, panelPosition, panelRef, autohide, showTimeout,
	        elementFocusedOnWindowBlur = null;
	
	    // Set defaults
	    setDefaults();
	
	    // Set parent aria-label.
	    addAriaLabel();
	
	    // Remove the element from its current DOM position.
	    element.detach();
	
	    updatePosition();
	    bindEvents();
	    configureWatchers();
	
	    function setDefaults() {
	      scope.mdZIndex = scope.mdZIndex || TOOLTIP_DEFAULT_Z_INDEX;
	      scope.mdDelay = scope.mdDelay || TOOLTIP_DEFAULT_SHOW_DELAY;
	      if (!TOOLTIP_DIRECTIONS[scope.mdDirection]) {
	        scope.mdDirection = TOOLTIP_DEFAULT_DIRECTION;
	      }
	    }
	
	    function addAriaLabel(labelText) {
	      // Only interpolate the text from the HTML element because otherwise the custom text could
	      // be interpolated twice and cause XSS violations.
	      var interpolatedText = labelText || $interpolate(element.text().trim())(scope.$parent);
	
	      // Only add the `aria-label` to the parent if there isn't already one, if there isn't an
	      // already present `aria-labelledby`, or if the previous `aria-label` was added by the
	      // tooltip directive.
	      if (
	        (!parent.attr('aria-label') && !parent.attr('aria-labelledby')) ||
	        parent.attr('md-labeled-by-tooltip')
	      ) {
	        parent.attr('aria-label', interpolatedText);
	
	        // Set the `md-labeled-by-tooltip` attribute if it has not already been set.
	        if (!parent.attr('md-labeled-by-tooltip')) {
	          parent.attr('md-labeled-by-tooltip', tooltipId);
	        }
	      }
	    }
	
	    function updatePosition() {
	      setDefaults();
	
	      // If the panel has already been created, remove the current origin
	      // class from the panel element.
	      if (panelRef && panelRef.panelEl) {
	        panelRef.panelEl.removeClass(origin);
	      }
	
	      // Set the panel element origin class based off of the current
	      // mdDirection.
	      origin = 'md-origin-' + scope.mdDirection;
	
	      // Create the position of the panel based off of the mdDirection.
	      position = TOOLTIP_DIRECTIONS[scope.mdDirection];
	
	      // Using the newly created position object, use the MdPanel
	      // panelPosition API to build the panel's position.
	      panelPosition = $mdPanel.newPanelPosition()
	          .relativeTo(parent)
	          .addPanelPosition(position.x, position.y);
	
	      // If the panel has already been created, add the new origin class to
	      // the panel element and update it's position with the panelPosition.
	      if (panelRef && panelRef.panelEl) {
	        panelRef.panelEl.addClass(origin);
	        panelRef.updatePosition(panelPosition);
	      }
	    }
	
	    function bindEvents() {
	      // Add a mutationObserver where there is support for it and the need
	      // for it in the form of viable host(parent[0]).
	      if (parent[0] && 'MutationObserver' in $window) {
	        // Use a mutationObserver to tackle #2602.
	        var attributeObserver = new MutationObserver(function(mutations) {
	          if (isDisabledMutation(mutations)) {
	            $mdUtil.nextTick(function() {
	              setVisible(false);
	            });
	          }
	        });
	
	        attributeObserver.observe(parent[0], {
	          attributes: true
	        });
	      }
	
	      elementFocusedOnWindowBlur = false;
	
	      $$mdTooltipRegistry.register('scroll', windowScrollEventHandler, true);
	      $$mdTooltipRegistry.register('blur', windowBlurEventHandler);
	      $$mdTooltipRegistry.register('resize', debouncedOnResize);
	
	      scope.$on('$destroy', onDestroy);
	
	      // To avoid 'synthetic clicks', we listen to mousedown instead of
	      // 'click'.
	      parent.on('mousedown', mousedownEventHandler);
	      parent.on(ENTER_EVENTS, enterEventHandler);
	
	      function isDisabledMutation(mutations) {
	        mutations.some(function(mutation) {
	          return mutation.attributeName === 'disabled' && parent[0].disabled;
	        });
	        return false;
	      }
	
	      function windowScrollEventHandler() {
	        setVisible(false);
	      }
	
	      function windowBlurEventHandler() {
	        elementFocusedOnWindowBlur = document.activeElement === parent[0];
	      }
	
	      function enterEventHandler($event) {
	        // Prevent the tooltip from showing when the window is receiving
	        // focus.
	        if ($event.type === 'focus' && elementFocusedOnWindowBlur) {
	          elementFocusedOnWindowBlur = false;
	        } else if (!scope.mdVisible) {
	          parent.on(LEAVE_EVENTS, leaveEventHandler);
	          setVisible(true);
	
	          // If the user is on a touch device, we should bind the tap away
	          // after the 'touched' in order to prevent the tooltip being
	          // removed immediately.
	          if ($event.type === 'touchstart') {
	            parent.one('touchend', function() {
	              $mdUtil.nextTick(function() {
	                $document.one('touchend', leaveEventHandler);
	              }, false);
	            });
	          }
	        }
	      }
	
	      function leaveEventHandler() {
	        autohide = scope.hasOwnProperty('mdAutohide') ?
	            scope.mdAutohide :
	            attr.hasOwnProperty('mdAutohide');
	
	        if (autohide || mouseActive ||
	            $document[0].activeElement !== parent[0]) {
	          // When a show timeout is currently in progress, then we have
	          // to cancel it, otherwise the tooltip will remain showing
	          // without focus or hover.
	          if (showTimeout) {
	            $timeout.cancel(showTimeout);
	            setVisible.queued = false;
	            showTimeout = null;
	          }
	
	          parent.off(LEAVE_EVENTS, leaveEventHandler);
	          parent.triggerHandler('blur');
	          setVisible(false);
	        }
	        mouseActive = false;
	      }
	
	      function mousedownEventHandler() {
	        mouseActive = true;
	      }
	
	      function onDestroy() {
	        $$mdTooltipRegistry.deregister('scroll', windowScrollEventHandler, true);
	        $$mdTooltipRegistry.deregister('blur', windowBlurEventHandler);
	        $$mdTooltipRegistry.deregister('resize', debouncedOnResize);
	
	        parent
	            .off(ENTER_EVENTS, enterEventHandler)
	            .off(LEAVE_EVENTS, leaveEventHandler)
	            .off('mousedown', mousedownEventHandler);
	
	        // Trigger the handler in case any of the tooltips are
	        // still visible.
	        leaveEventHandler();
	        attributeObserver && attributeObserver.disconnect();
	      }
	    }
	
	    function configureWatchers() {
	      if (element[0] && 'MutationObserver' in $window) {
	        var attributeObserver = new MutationObserver(function(mutations) {
	          mutations.forEach(function(mutation) {
	            if (mutation.attributeName === 'md-visible' &&
	                !scope.visibleWatcher ) {
	              scope.visibleWatcher = scope.$watch('mdVisible',
	                  onVisibleChanged);
	            }
	          });
	        });
	
	        attributeObserver.observe(element[0], {
	          attributes: true
	        });
	
	        // Build watcher only if mdVisible is being used.
	        if (attr.hasOwnProperty('mdVisible')) {
	          scope.visibleWatcher = scope.$watch('mdVisible',
	              onVisibleChanged);
	        }
	      } else {
	        // MutationObserver not supported
	        scope.visibleWatcher = scope.$watch('mdVisible', onVisibleChanged);
	      }
	
	      // Direction watcher
	      scope.$watch('mdDirection', updatePosition);
	
	      // Clean up if the element or parent was removed via jqLite's .remove.
	      // A couple of notes:
	      //   - In these cases the scope might not have been destroyed, which
	      //     is why we destroy it manually. An example of this can be having
	      //     `md-visible="false"` and adding tooltips while they're
	      //     invisible. If `md-visible` becomes true, at some point, you'd
	      //     usually get a lot of tooltips.
	      //   - We use `.one`, not `.on`, because this only needs to fire once.
	      //     If we were using `.on`, it would get thrown into an infinite
	      //     loop.
	      //   - This kicks off the scope's `$destroy` event which finishes the
	      //     cleanup.
	      element.one('$destroy', onElementDestroy);
	      parent.one('$destroy', onElementDestroy);
	      scope.$on('$destroy', function() {
	        setVisible(false);
	        panelRef && panelRef.destroy();
	        attributeObserver && attributeObserver.disconnect();
	        element.remove();
	      });
	
	      // Updates the aria-label when the element text changes. This watch
	      // doesn't need to be set up if the element doesn't have any data
	      // bindings.
	      if (element.text().indexOf($interpolate.startSymbol()) > -1) {
	        scope.$watch(function() {
	          return element.text().trim();
	        }, addAriaLabel);
	      }
	
	      function onElementDestroy() {
	        scope.$destroy();
	      }
	    }
	
	    function setVisible(value) {
	      // Break if passed value is already in queue or there is no queue and
	      // passed value is current in the controller.
	      if (setVisible.queued && setVisible.value === !!value ||
	          !setVisible.queued && scope.mdVisible === !!value) {
	        return;
	      }
	      setVisible.value = !!value;
	
	      if (!setVisible.queued) {
	        if (value) {
	          setVisible.queued = true;
	          showTimeout = $timeout(function() {
	            scope.mdVisible = setVisible.value;
	            setVisible.queued = false;
	            showTimeout = null;
	            if (!scope.visibleWatcher) {
	              onVisibleChanged(scope.mdVisible);
	            }
	          }, scope.mdDelay);
	        } else {
	          $mdUtil.nextTick(function() {
	            scope.mdVisible = false;
	            if (!scope.visibleWatcher) {
	              onVisibleChanged(false);
	            }
	          });
	        }
	      }
	    }
	
	    function onVisibleChanged(isVisible) {
	      isVisible ? showTooltip() : hideTooltip();
	    }
	
	    function showTooltip() {
	      // Do not show the tooltip if the text is empty.
	      if (!element[0].textContent.trim()) {
	        throw new Error('Text for the tooltip has not been provided. ' +
	            'Please include text within the mdTooltip element.');
	      }
	
	      if (!panelRef) {
	        var attachTo = angular.element(document.body);
	        var panelAnimation = $mdPanel.newPanelAnimation()
	            .openFrom(parent)
	            .closeTo(parent)
	            .withAnimation({
	              open: 'md-show',
	              close: 'md-hide'
	            });
	
	        var panelConfig = {
	          id: tooltipId,
	          attachTo: attachTo,
	          contentElement: element,
	          propagateContainerEvents: true,
	          panelClass: 'md-tooltip ' + origin,
	          animation: panelAnimation,
	          position: panelPosition,
	          zIndex: scope.mdZIndex,
	          focusOnOpen: false
	        };
	
	        panelRef = $mdPanel.create(panelConfig);
	      }
	
	      panelRef.open().then(function() {
	        panelRef.panelEl.attr('role', 'tooltip');
	      });
	    }
	
	    function hideTooltip() {
	      panelRef && panelRef.close();
	    }
	  }
	
	}
	
	
	/**
	 * Service that is used to reduce the amount of listeners that are being
	 * registered on the `window` by the tooltip component. Works by collecting
	 * the individual event handlers and dispatching them from a global handler.
	 *
	 * @ngInject
	 */
	function MdTooltipRegistry() {
	  var listeners = {};
	  var ngWindow = angular.element(window);
	
	  return {
	    register: register,
	    deregister: deregister
	  };
	
	  /**
	   * Global event handler that dispatches the registered handlers in the
	   * service.
	   * @param {!Event} event Event object passed in by the browser
	   */
	  function globalEventHandler(event) {
	    if (listeners[event.type]) {
	      listeners[event.type].forEach(function(currentHandler) {
	        currentHandler.call(this, event);
	      }, this);
	    }
	  }
	
	  /**
	   * Registers a new handler with the service.
	   * @param {string} type Type of event to be registered.
	   * @param {!Function} handler Event handler.
	   * @param {boolean} useCapture Whether to use event capturing.
	   */
	  function register(type, handler, useCapture) {
	    var handlers = listeners[type] = listeners[type] || [];
	
	    if (!handlers.length) {
	      useCapture ? window.addEventListener(type, globalEventHandler, true) :
	          ngWindow.on(type, globalEventHandler);
	    }
	
	    if (handlers.indexOf(handler) === -1) {
	      handlers.push(handler);
	    }
	  }
	
	  /**
	   * Removes an event handler from the service.
	   * @param {string} type Type of event handler.
	   * @param {!Function} handler The event handler itself.
	   * @param {boolean} useCapture Whether the event handler used event capturing.
	   */
	  function deregister(type, handler, useCapture) {
	    var handlers = listeners[type];
	    var index = handlers ? handlers.indexOf(handler) : -1;
	
	    if (index > -1) {
	      handlers.splice(index, 1);
	
	      if (handlers.length === 0) {
	        useCapture ? window.removeEventListener(type, globalEventHandler, true) :
	            ngWindow.off(type, globalEventHandler);
	      }
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.truncate
	 */
	MdTruncateController.$inject = ["$element"];
	angular.module('material.components.truncate', ['material.core'])
	  .directive('mdTruncate', MdTruncateDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdTruncate
	 * @module material.components.truncate
	 * @restrict AE
	 * @description
	 *
	 * The `md-truncate` component displays a label that will automatically clip text which is wider
	 * than the component. By default, it displays an ellipsis, but you may apply the `md-clip` CSS
	 * class to override this default and use a standard "clipping" approach.
	 *
	 * <i><b>Note:</b> The `md-truncate` component does not automatically adjust it's width. You must
	 * provide the `flex` attribute, or some other CSS-based width management. See the
	 * <a ng-href="./demo/truncate">demos</a> for examples.</i>
	 *
	 * @usage
	 *
	 * ### As an Element
	 *
	 * <hljs lang="html">
	 *   <div layout="row">
	 *     <md-button>Back</md-button>
	 *
	 *     <md-truncate flex>Chapter 1 - The Way of the Old West</md-truncate>
	 *
	 *     <md-button>Forward</md-button>
	 *   </div>
	 * </hljs>
	 *
	 * ### As an Attribute
	 *
	 * <hljs lang="html">
	 *   <h2 md-truncate style="max-width: 100px;">Some Title With a Lot of Text</h2>
	 * </hljs>
	 *
	 * ## CSS & Styles
	 *
	 * `<md-truncate>` provides two CSS classes that you may use to control the type of clipping.
	 *
	 * <i><b>Note:</b> The `md-truncate` also applies a setting of `width: 0;` when used with the `flex`
	 * attribute to fix an issue with the flex element not shrinking properly.</i>
	 *
	 * <div>
	 * <docs-css-api-table>
	 *
	 *   <docs-css-selector code=".md-ellipsis">
	 *     Assigns the "ellipsis" behavior (default) which will cut off mid-word and append an ellipsis
	 *     (&hellip;) to the end of the text.
	 *   </docs-css-selector>
	 *
	 *   <docs-css-selector code=".md-clip">
	 *     Assigns the "clipping" behavior which will simply chop off the text. This may happen
	 *     mid-word or even mid-character.
	 *   </docs-css-selector>
	 *
	 * </docs-css-api-table>
	 * </div>
	 */
	function MdTruncateDirective() {
	  return {
	    restrict: 'AE',
	
	    controller: MdTruncateController,
	    controllerAs: '$ctrl',
	    bindToController: true
	  }
	}
	
	/**
	 * Controller for the <md-truncate> component.
	 *
	 * @param $element The md-truncate element.
	 *
	 * @constructor
	 * @ngInject
	 */
	function MdTruncateController($element) {
	  $element.addClass('md-truncate');
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.virtualRepeat
	 */
	VirtualRepeatContainerController.$inject = ["$$rAF", "$mdUtil", "$mdConstant", "$parse", "$rootScope", "$window", "$scope", "$element", "$attrs"];
	VirtualRepeatController.$inject = ["$scope", "$element", "$attrs", "$browser", "$document", "$rootScope", "$$rAF", "$mdUtil"];
	VirtualRepeatDirective.$inject = ["$parse"];
	angular.module('material.components.virtualRepeat', [
	  'material.core',
	  'material.components.showHide'
	])
	.directive('mdVirtualRepeatContainer', VirtualRepeatContainerDirective)
	.directive('mdVirtualRepeat', VirtualRepeatDirective);
	
	
	/**
	 * @ngdoc directive
	 * @name mdVirtualRepeatContainer
	 * @module material.components.virtualRepeat
	 * @restrict E
	 * @description
	 * `md-virtual-repeat-container` provides the scroll container for md-virtual-repeat.
	 *
	 * VirtualRepeat is a limited substitute for ng-repeat that renders only
	 * enough DOM nodes to fill the container and recycling them as the user scrolls.
	 *
	 * Once an element is not visible anymore, the VirtualRepeat recycles it and will reuse it for
	 * another visible item by replacing the previous dataset with the new one.
	 *
	 * ### Common Issues
	 *
	 * - When having one-time bindings inside of the view template, the VirtualRepeat will not properly
	 *   update the bindings for new items, since the view will be recycled.
	 *
	 * - Directives inside of a VirtualRepeat will be only compiled (linked) once, because those
	 *   are will be recycled items and used for other items.
	 *   The VirtualRepeat just updates the scope bindings.
	 *
	 *
	 * ### Notes
	 *
	 * > The VirtualRepeat is a similar implementation to the Android
	 * [RecyclerView](https://developer.android.com/reference/android/support/v7/widget/RecyclerView.html)
	 *
	 * <!-- This comment forces a break between blockquotes //-->
	 *
	 * > Please also review the <a ng-href="api/directive/mdVirtualRepeat">VirtualRepeat</a>
	 * documentation for more information.
	 *
	 *
	 * @usage
	 * <hljs lang="html">
	 *
	 * <md-virtual-repeat-container md-top-index="topIndex">
	 *   <div md-virtual-repeat="i in items" md-item-size="20">Hello {{i}}!</div>
	 * </md-virtual-repeat-container>
	 * </hljs>
	 *
	 * @param {number=} md-top-index Binds the index of the item that is at the top of the scroll
	 *     container to $scope. It can both read and set the scroll position.
	 * @param {boolean=} md-orient-horizontal Whether the container should scroll horizontally
	 *     (defaults to orientation and scrolling vertically).
	 * @param {boolean=} md-auto-shrink When present, the container will shrink to fit
	 *     the number of items when that number is less than its original size.
	 * @param {number=} md-auto-shrink-min Minimum number of items that md-auto-shrink
	 *     will shrink to (default: 0).
	 */
	function VirtualRepeatContainerDirective() {
	  return {
	    controller: VirtualRepeatContainerController,
	    template: virtualRepeatContainerTemplate,
	    compile: function virtualRepeatContainerCompile($element, $attrs) {
	      $element
	          .addClass('md-virtual-repeat-container')
	          .addClass($attrs.hasOwnProperty('mdOrientHorizontal')
	              ? 'md-orient-horizontal'
	              : 'md-orient-vertical');
	    }
	  };
	}
	
	
	function virtualRepeatContainerTemplate($element) {
	  return '<div class="md-virtual-repeat-scroller">' +
	    '<div class="md-virtual-repeat-sizer"></div>' +
	    '<div class="md-virtual-repeat-offsetter">' +
	      $element[0].innerHTML +
	    '</div></div>';
	}
	
	/**
	 * Number of additional elements to render above and below the visible area inside
	 * of the virtual repeat container. A higher number results in less flicker when scrolling
	 * very quickly in Safari, but comes with a higher rendering and dirty-checking cost.
	 * @const {number}
	 */
	var NUM_EXTRA = 3;
	
	/** @ngInject */
	function VirtualRepeatContainerController($$rAF, $mdUtil, $mdConstant, $parse, $rootScope, $window, $scope,
	                                          $element, $attrs) {
	  this.$rootScope = $rootScope;
	  this.$scope = $scope;
	  this.$element = $element;
	  this.$attrs = $attrs;
	
	  /** @type {number} The width or height of the container */
	  this.size = 0;
	  /** @type {number} The scroll width or height of the scroller */
	  this.scrollSize = 0;
	  /** @type {number} The scrollLeft or scrollTop of the scroller */
	  this.scrollOffset = 0;
	  /** @type {boolean} Whether the scroller is oriented horizontally */
	  this.horizontal = this.$attrs.hasOwnProperty('mdOrientHorizontal');
	  /** @type {!VirtualRepeatController} The repeater inside of this container */
	  this.repeater = null;
	  /** @type {boolean} Whether auto-shrink is enabled */
	  this.autoShrink = this.$attrs.hasOwnProperty('mdAutoShrink');
	  /** @type {number} Minimum number of items to auto-shrink to */
	  this.autoShrinkMin = parseInt(this.$attrs.mdAutoShrinkMin, 10) || 0;
	  /** @type {?number} Original container size when shrank */
	  this.originalSize = null;
	  /** @type {number} Amount to offset the total scroll size by. */
	  this.offsetSize = parseInt(this.$attrs.mdOffsetSize, 10) || 0;
	  /** @type {?string} height or width element style on the container prior to auto-shrinking. */
	  this.oldElementSize = null;
	  /** @type {!number} Maximum amount of pixels allowed for a single DOM element */
	  this.maxElementPixels = $mdConstant.ELEMENT_MAX_PIXELS;
	
	  if (this.$attrs.mdTopIndex) {
	    /** @type {function(angular.Scope): number} Binds to topIndex on AngularJS scope */
	    this.bindTopIndex = $parse(this.$attrs.mdTopIndex);
	    /** @type {number} The index of the item that is at the top of the scroll container */
	    this.topIndex = this.bindTopIndex(this.$scope);
	
	    if (!angular.isDefined(this.topIndex)) {
	      this.topIndex = 0;
	      this.bindTopIndex.assign(this.$scope, 0);
	    }
	
	    this.$scope.$watch(this.bindTopIndex, angular.bind(this, function(newIndex) {
	      if (newIndex !== this.topIndex) {
	        this.scrollToIndex(newIndex);
	      }
	    }));
	  } else {
	    this.topIndex = 0;
	  }
	
	  this.scroller = $element[0].querySelector('.md-virtual-repeat-scroller');
	  this.sizer = this.scroller.querySelector('.md-virtual-repeat-sizer');
	  this.offsetter = this.scroller.querySelector('.md-virtual-repeat-offsetter');
	
	  // After the dom stablizes, measure the initial size of the container and
	  // make a best effort at re-measuring as it changes.
	  var boundUpdateSize = angular.bind(this, this.updateSize);
	
	  $$rAF(angular.bind(this, function() {
	    boundUpdateSize();
	
	    var debouncedUpdateSize = $mdUtil.debounce(boundUpdateSize, 10, null, false);
	    var jWindow = angular.element($window);
	
	    // Make one more attempt to get the size if it is 0.
	    // This is not by any means a perfect approach, but there's really no
	    // silver bullet here.
	    if (!this.size) {
	      debouncedUpdateSize();
	    }
	
	    jWindow.on('resize', debouncedUpdateSize);
	    $scope.$on('$destroy', function() {
	      jWindow.off('resize', debouncedUpdateSize);
	    });
	
	    $scope.$emit('$md-resize-enable');
	    $scope.$on('$md-resize', boundUpdateSize);
	  }));
	}
	
	
	/** Called by the md-virtual-repeat inside of the container at startup. */
	VirtualRepeatContainerController.prototype.register = function(repeaterCtrl) {
	  this.repeater = repeaterCtrl;
	
	  angular.element(this.scroller)
	      .on('scroll wheel touchmove touchend', angular.bind(this, this.handleScroll_));
	};
	
	
	/** @return {boolean} Whether the container is configured for horizontal scrolling. */
	VirtualRepeatContainerController.prototype.isHorizontal = function() {
	  return this.horizontal;
	};
	
	
	/** @return {number} The size (width or height) of the container. */
	VirtualRepeatContainerController.prototype.getSize = function() {
	  return this.size;
	};
	
	
	/**
	 * Resizes the container.
	 * @private
	 * @param {number} size The new size to set.
	 */
	VirtualRepeatContainerController.prototype.setSize_ = function(size) {
	  var dimension = this.getDimensionName_();
	
	  this.size = size;
	  this.$element[0].style[dimension] = size + 'px';
	};
	
	
	VirtualRepeatContainerController.prototype.unsetSize_ = function() {
	  this.$element[0].style[this.getDimensionName_()] = this.oldElementSize;
	  this.oldElementSize = null;
	};
	
	
	/** Instructs the container to re-measure its size. */
	VirtualRepeatContainerController.prototype.updateSize = function() {
	  // If the original size is already determined, we can skip the update.
	  if (this.originalSize) return;
	
	  this.size = this.isHorizontal()
	      ? this.$element[0].clientWidth
	      : this.$element[0].clientHeight;
	
	  // Recheck the scroll position after updating the size. This resolves
	  // problems that can result if the scroll position was measured while the
	  // element was display: none or detached from the document.
	  this.handleScroll_();
	
	  this.repeater && this.repeater.containerUpdated();
	};
	
	
	/** @return {number} The container's scrollHeight or scrollWidth. */
	VirtualRepeatContainerController.prototype.getScrollSize = function() {
	  return this.scrollSize;
	};
	
	
	VirtualRepeatContainerController.prototype.getDimensionName_ = function() {
	  return this.isHorizontal() ? 'width' : 'height';
	};
	
	
	/**
	 * Sets the scroller element to the specified size.
	 * @private
	 * @param {number} size The new size.
	 */
	VirtualRepeatContainerController.prototype.sizeScroller_ = function(size) {
	  var dimension =  this.getDimensionName_();
	  var crossDimension = this.isHorizontal() ? 'height' : 'width';
	
	  // Clear any existing dimensions.
	  this.sizer.innerHTML = '';
	
	  // If the size falls within the browser's maximum explicit size for a single element, we can
	  // set the size and be done. Otherwise, we have to create children that add up the the desired
	  // size.
	  if (size < this.maxElementPixels) {
	    this.sizer.style[dimension] = size + 'px';
	  } else {
	    this.sizer.style[dimension] = 'auto';
	    this.sizer.style[crossDimension] = 'auto';
	
	    // Divide the total size we have to render into N max-size pieces.
	    var numChildren = Math.floor(size / this.maxElementPixels);
	
	    // Element template to clone for each max-size piece.
	    var sizerChild = document.createElement('div');
	    sizerChild.style[dimension] = this.maxElementPixels + 'px';
	    sizerChild.style[crossDimension] = '1px';
	
	    for (var i = 0; i < numChildren; i++) {
	      this.sizer.appendChild(sizerChild.cloneNode(false));
	    }
	
	    // Re-use the element template for the remainder.
	    sizerChild.style[dimension] = (size - (numChildren * this.maxElementPixels)) + 'px';
	    this.sizer.appendChild(sizerChild);
	  }
	};
	
	
	/**
	 * If auto-shrinking is enabled, shrinks or unshrinks as appropriate.
	 * @private
	 * @param {number} size The new size.
	 */
	VirtualRepeatContainerController.prototype.autoShrink_ = function(size) {
	  var shrinkSize = Math.max(size, this.autoShrinkMin * this.repeater.getItemSize());
	
	  if (this.autoShrink && shrinkSize !== this.size) {
	    if (this.oldElementSize === null) {
	      this.oldElementSize = this.$element[0].style[this.getDimensionName_()];
	    }
	
	    var currentSize = this.originalSize || this.size;
	
	    if (!currentSize || shrinkSize < currentSize) {
	      if (!this.originalSize) {
	        this.originalSize = this.size;
	      }
	
	      // Now we update the containers size, because shrinking is enabled.
	      this.setSize_(shrinkSize);
	    } else if (this.originalSize !== null) {
	      // Set the size back to our initial size.
	      this.unsetSize_();
	
	      var _originalSize = this.originalSize;
	      this.originalSize = null;
	
	      // We determine the repeaters size again, if the original size was zero.
	      // The originalSize needs to be null, to be able to determine the size.
	      if (!_originalSize) this.updateSize();
	
	      // Apply the original size or the determined size back to the container, because
	      // it has been overwritten before, in the shrink block.
	      this.setSize_(_originalSize || this.size);
	    }
	
	    this.repeater.containerUpdated();
	  }
	};
	
	
	/**
	 * Sets the scrollHeight or scrollWidth. Called by the repeater based on
	 * its item count and item size.
	 * @param {number} itemsSize The total size of the items.
	 */
	VirtualRepeatContainerController.prototype.setScrollSize = function(itemsSize) {
	  var size = itemsSize + this.offsetSize;
	  if (this.scrollSize === size) return;
	
	  this.sizeScroller_(size);
	  this.autoShrink_(size);
	  this.scrollSize = size;
	};
	
	
	/** @return {number} The container's current scroll offset. */
	VirtualRepeatContainerController.prototype.getScrollOffset = function() {
	  return this.scrollOffset;
	};
	
	/**
	 * Scrolls to a given scrollTop position.
	 * @param {number} position
	 */
	VirtualRepeatContainerController.prototype.scrollTo = function(position) {
	  this.scroller[this.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = position;
	  this.handleScroll_();
	};
	
	/**
	 * Scrolls the item with the given index to the top of the scroll container.
	 * @param {number} index
	 */
	VirtualRepeatContainerController.prototype.scrollToIndex = function(index) {
	  var itemSize = this.repeater.getItemSize();
	  var itemsLength = this.repeater.itemsLength;
	  if(index > itemsLength) {
	    index = itemsLength - 1;
	  }
	  this.scrollTo(itemSize * index);
	};
	
	VirtualRepeatContainerController.prototype.resetScroll = function() {
	  this.scrollTo(0);
	};
	
	
	VirtualRepeatContainerController.prototype.handleScroll_ = function() {
	  var ltr = document.dir != 'rtl' && document.body.dir != 'rtl';
	  if(!ltr && !this.maxSize) {
	    this.scroller.scrollLeft = this.scrollSize;
	    this.maxSize = this.scroller.scrollLeft;
	  }
	  var offset = this.isHorizontal() ?
	      (ltr?this.scroller.scrollLeft : this.maxSize - this.scroller.scrollLeft)
	      : this.scroller.scrollTop;
	  if (offset === this.scrollOffset || offset > this.scrollSize - this.size) return;
	
	  var itemSize = this.repeater.getItemSize();
	  if (!itemSize) return;
	
	  var numItems = Math.max(0, Math.floor(offset / itemSize) - NUM_EXTRA);
	
	  var transform = (this.isHorizontal() ? 'translateX(' : 'translateY(') +
	      (!this.isHorizontal() || ltr ? (numItems * itemSize) : - (numItems * itemSize))  + 'px)';
	
	  this.scrollOffset = offset;
	  this.offsetter.style.webkitTransform = transform;
	  this.offsetter.style.transform = transform;
	
	  if (this.bindTopIndex) {
	    var topIndex = Math.floor(offset / itemSize);
	    if (topIndex !== this.topIndex && topIndex < this.repeater.getItemCount()) {
	      this.topIndex = topIndex;
	      this.bindTopIndex.assign(this.$scope, topIndex);
	      if (!this.$rootScope.$$phase) this.$scope.$digest();
	    }
	  }
	
	  this.repeater.containerUpdated();
	};
	
	
	/**
	 * @ngdoc directive
	 * @name mdVirtualRepeat
	 * @module material.components.virtualRepeat
	 * @restrict A
	 * @priority 1000
	 * @description
	 * `md-virtual-repeat` specifies an element to repeat using virtual scrolling.
	 *
	 * Virtual repeat is a limited substitute for ng-repeat that renders only
	 * enough DOM nodes to fill the container and recycling them as the user scrolls.
	 *
	 * Arrays, but not objects are supported for iteration.
	 * Track by, as alias, and (key, value) syntax are not supported.
	 *
	 * ### On-Demand Async Item Loading
	 *
	 * When using the `md-on-demand` attribute and loading some asynchronous data, the `getItemAtIndex` function will
	 * mostly return nothing.
	 *
	 * <hljs lang="js">
	 *   DynamicItems.prototype.getItemAtIndex = function(index) {
	 *     if (this.pages[index]) {
	 *       return this.pages[index];
	 *     } else {
	 *       // This is an asynchronous action and does not return any value.
	 *       this.loadPage(index);
	 *     }
	 *   };
	 * </hljs>
	 *
	 * This means that the VirtualRepeat will not have any value for the given index.<br/>
	 * After the data loading completed, the user expects the VirtualRepeat to recognize the change.
	 *
	 * To make sure that the VirtualRepeat properly detects any change, you need to run the operation
	 * in another digest.
	 *
	 * <hljs lang="js">
	 *   DynamicItems.prototype.loadPage = function(index) {
	 *     var self = this;
	 *
	 *     // Trigger a new digest by using $timeout
	 *     $timeout(function() {
	 *       self.pages[index] = Data;
	 *     });
	 *   };
	 * </hljs>
	 *
	 * > <b>Note:</b> Please also review the
	 *   <a ng-href="api/directive/mdVirtualRepeatContainer">VirtualRepeatContainer</a> documentation
	 *   for more information.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-virtual-repeat-container>
	 *   <div md-virtual-repeat="i in items">Hello {{i}}!</div>
	 * </md-virtual-repeat-container>
	 *
	 * <md-virtual-repeat-container md-orient-horizontal>
	 *   <div md-virtual-repeat="i in items" md-item-size="20">Hello {{i}}!</div>
	 * </md-virtual-repeat-container>
	 * </hljs>
	 *
	 * @param {number=} md-item-size The height or width of the repeated elements (which must be
	 *   identical for each element). Optional. Will attempt to read the size from the dom if missing,
	 *   but still assumes that all repeated nodes have same height or width.
	 * @param {string=} md-extra-name Evaluates to an additional name to which the current iterated item
	 *   can be assigned on the repeated scope (needed for use in `md-autocomplete`).
	 * @param {boolean=} md-on-demand When present, treats the md-virtual-repeat argument as an object
	 *   that can fetch rows rather than an array.
	 *
	 *   **NOTE:** This object must implement the following interface with two (2) methods:
	 *
	 *   - `getItemAtIndex: function(index) [object]` The item at that index or null if it is not yet
	 *     loaded (it should start downloading the item in that case).
	 *   - `getLength: function() [number]` The data length to which the repeater container
	 *     should be sized. Ideally, when the count is known, this method should return it.
	 *     Otherwise, return a higher number than the currently loaded items to produce an
	 *     infinite-scroll behavior.
	 */
	function VirtualRepeatDirective($parse) {
	  return {
	    controller: VirtualRepeatController,
	    priority: 1000,
	    require: ['mdVirtualRepeat', '^^mdVirtualRepeatContainer'],
	    restrict: 'A',
	    terminal: true,
	    transclude: 'element',
	    compile: function VirtualRepeatCompile($element, $attrs) {
	      var expression = $attrs.mdVirtualRepeat;
	      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)\s*$/);
	      var repeatName = match[1];
	      var repeatListExpression = $parse(match[2]);
	      var extraName = $attrs.mdExtraName && $parse($attrs.mdExtraName);
	
	      return function VirtualRepeatLink($scope, $element, $attrs, ctrl, $transclude) {
	        ctrl[0].link_(ctrl[1], $transclude, repeatName, repeatListExpression, extraName);
	      };
	    }
	  };
	}
	
	
	/** @ngInject */
	function VirtualRepeatController($scope, $element, $attrs, $browser, $document, $rootScope,
	    $$rAF, $mdUtil) {
	  this.$scope = $scope;
	  this.$element = $element;
	  this.$attrs = $attrs;
	  this.$browser = $browser;
	  this.$document = $document;
	  this.$rootScope = $rootScope;
	  this.$$rAF = $$rAF;
	
	  /** @type {boolean} Whether we are in on-demand mode. */
	  this.onDemand = $mdUtil.parseAttributeBoolean($attrs.mdOnDemand);
	  /** @type {!Function} Backup reference to $browser.$$checkUrlChange */
	  this.browserCheckUrlChange = $browser.$$checkUrlChange;
	  /** @type {number} Most recent starting repeat index (based on scroll offset) */
	  this.newStartIndex = 0;
	  /** @type {number} Most recent ending repeat index (based on scroll offset) */
	  this.newEndIndex = 0;
	  /** @type {number} Most recent end visible index (based on scroll offset) */
	  this.newVisibleEnd = 0;
	  /** @type {number} Previous starting repeat index (based on scroll offset) */
	  this.startIndex = 0;
	  /** @type {number} Previous ending repeat index (based on scroll offset) */
	  this.endIndex = 0;
	  // TODO: measure width/height of first element from dom if not provided.
	  // getComputedStyle?
	  /** @type {?number} Height/width of repeated elements. */
	  this.itemSize = $scope.$eval($attrs.mdItemSize) || null;
	
	  /** @type {boolean} Whether this is the first time that items are rendered. */
	  this.isFirstRender = true;
	
	  /**
	   * @private {boolean} Whether the items in the list are already being updated. Used to prevent
	   *     nested calls to virtualRepeatUpdate_.
	   */
	  this.isVirtualRepeatUpdating_ = false;
	
	  /** @type {number} Most recently seen length of items. */
	  this.itemsLength = 0;
	
	  /**
	   * @type {!Function} Unwatch callback for item size (when md-items-size is
	   *     not specified), or angular.noop otherwise.
	   */
	  this.unwatchItemSize_ = angular.noop;
	
	  /**
	   * Presently rendered blocks by repeat index.
	   * @type {Object<number, !VirtualRepeatController.Block}
	   */
	  this.blocks = {};
	  /** @type {Array<!VirtualRepeatController.Block>} A pool of presently unused blocks. */
	  this.pooledBlocks = [];
	
	  $scope.$on('$destroy', angular.bind(this, this.cleanupBlocks_));
	}
	
	
	/**
	 * An object representing a repeated item.
	 * @typedef {{element: !jqLite, new: boolean, scope: !angular.Scope}}
	 */
	VirtualRepeatController.Block;
	
	
	/**
	 * Called at startup by the md-virtual-repeat postLink function.
	 * @param {!VirtualRepeatContainerController} container The container's controller.
	 * @param {!Function} transclude The repeated element's bound transclude function.
	 * @param {string} repeatName The left hand side of the repeat expression, indicating
	 *     the name for each item in the array.
	 * @param {!Function} repeatListExpression A compiled expression based on the right hand side
	 *     of the repeat expression. Points to the array to repeat over.
	 * @param {string|undefined} extraName The optional extra repeatName.
	 */
	VirtualRepeatController.prototype.link_ =
	    function(container, transclude, repeatName, repeatListExpression, extraName) {
	  this.container = container;
	  this.transclude = transclude;
	  this.repeatName = repeatName;
	  this.rawRepeatListExpression = repeatListExpression;
	  this.extraName = extraName;
	  this.sized = false;
	
	  this.repeatListExpression = angular.bind(this, this.repeatListExpression_);
	
	  this.container.register(this);
	};
	
	
	/** @private Cleans up unused blocks. */
	VirtualRepeatController.prototype.cleanupBlocks_ = function() {
	  angular.forEach(this.pooledBlocks, function cleanupBlock(block) {
	    block.element.remove();
	  });
	};
	
	
	/** @private Attempts to set itemSize by measuring a repeated element in the dom */
	VirtualRepeatController.prototype.readItemSize_ = function() {
	  if (this.itemSize) {
	    // itemSize was successfully read in a different asynchronous call.
	    return;
	  }
	
	  this.items = this.repeatListExpression(this.$scope);
	  this.parentNode = this.$element[0].parentNode;
	  var block = this.getBlock_(0);
	  if (!block.element[0].parentNode) {
	    this.parentNode.appendChild(block.element[0]);
	  }
	
	  this.itemSize = block.element[0][
	      this.container.isHorizontal() ? 'offsetWidth' : 'offsetHeight'] || null;
	
	  this.blocks[0] = block;
	  this.poolBlock_(0);
	
	  if (this.itemSize) {
	    this.containerUpdated();
	  }
	};
	
	
	/**
	 * Returns the user-specified repeat list, transforming it into an array-like
	 * object in the case of infinite scroll/dynamic load mode.
	 * @param {!angular.Scope} The scope.
	 * @return {!Array|!Object} An array or array-like object for iteration.
	 */
	VirtualRepeatController.prototype.repeatListExpression_ = function(scope) {
	  var repeatList = this.rawRepeatListExpression(scope);
	
	  if (this.onDemand && repeatList) {
	    var virtualList = new VirtualRepeatModelArrayLike(repeatList);
	    virtualList.$$includeIndexes(this.newStartIndex, this.newVisibleEnd);
	    return virtualList;
	  } else {
	    return repeatList;
	  }
	};
	
	
	/**
	 * Called by the container. Informs us that the containers scroll or size has
	 * changed.
	 */
	VirtualRepeatController.prototype.containerUpdated = function() {
	  // If itemSize is unknown, attempt to measure it.
	  if (!this.itemSize) {
	    // Make sure to clean up watchers if we can (see #8178)
	    if(this.unwatchItemSize_ && this.unwatchItemSize_ !== angular.noop){
	      this.unwatchItemSize_();
	    }
	    this.unwatchItemSize_ = this.$scope.$watchCollection(
	        this.repeatListExpression,
	        angular.bind(this, function(items) {
	          if (items && items.length) {
	            this.readItemSize_();
	          }
	        }));
	    if (!this.$rootScope.$$phase) this.$scope.$digest();
	
	    return;
	  } else if (!this.sized) {
	    this.items = this.repeatListExpression(this.$scope);
	  }
	
	  if (!this.sized) {
	    this.unwatchItemSize_();
	    this.sized = true;
	    this.$scope.$watchCollection(this.repeatListExpression,
	        angular.bind(this, function(items, oldItems) {
	          if (!this.isVirtualRepeatUpdating_) {
	            this.virtualRepeatUpdate_(items, oldItems);
	          }
	        }));
	  }
	
	  this.updateIndexes_();
	
	  if (this.newStartIndex !== this.startIndex ||
	      this.newEndIndex !== this.endIndex ||
	      this.container.getScrollOffset() > this.container.getScrollSize()) {
	    if (this.items instanceof VirtualRepeatModelArrayLike) {
	      this.items.$$includeIndexes(this.newStartIndex, this.newEndIndex);
	    }
	    this.virtualRepeatUpdate_(this.items, this.items);
	  }
	};
	
	
	/**
	 * Called by the container. Returns the size of a single repeated item.
	 * @return {?number} Size of a repeated item.
	 */
	VirtualRepeatController.prototype.getItemSize = function() {
	  return this.itemSize;
	};
	
	
	/**
	 * Called by the container. Returns the size of a single repeated item.
	 * @return {?number} Size of a repeated item.
	 */
	VirtualRepeatController.prototype.getItemCount = function() {
	  return this.itemsLength;
	};
	
	
	/**
	 * Updates the order and visible offset of repeated blocks in response to scrolling
	 * or items updates.
	 * @private
	 */
	VirtualRepeatController.prototype.virtualRepeatUpdate_ = function(items, oldItems) {
	  this.isVirtualRepeatUpdating_ = true;
	
	  var itemsLength = items && items.length || 0;
	  var lengthChanged = false;
	
	  // If the number of items shrank, keep the scroll position.
	  if (this.items && itemsLength < this.items.length && this.container.getScrollOffset() !== 0) {
	    this.items = items;
	    var previousScrollOffset = this.container.getScrollOffset();
	    this.container.resetScroll();
	    this.container.scrollTo(previousScrollOffset);
	  }
	
	  if (itemsLength !== this.itemsLength) {
	    lengthChanged = true;
	    this.itemsLength = itemsLength;
	  }
	
	  this.items = items;
	  if (items !== oldItems || lengthChanged) {
	    this.updateIndexes_();
	  }
	
	  this.parentNode = this.$element[0].parentNode;
	
	  if (lengthChanged) {
	    this.container.setScrollSize(itemsLength * this.itemSize);
	  }
	
	  var cleanupFirstRender = false, firstRenderStartIndex;
	  if (this.isFirstRender) {
	    cleanupFirstRender = true;
	    this.isFirstRender = false;
	    firstRenderStartIndex = this.$attrs.mdStartIndex ?
	      this.$scope.$eval(this.$attrs.mdStartIndex) :
	      this.container.topIndex;
	    this.container.scrollToIndex(firstRenderStartIndex);
	  }
	
	  // Detach and pool any blocks that are no longer in the viewport.
	  Object.keys(this.blocks).forEach(function(blockIndex) {
	    var index = parseInt(blockIndex, 10);
	    if (index < this.newStartIndex || index >= this.newEndIndex) {
	      this.poolBlock_(index);
	    }
	  }, this);
	
	  // Add needed blocks.
	  // For performance reasons, temporarily block browser url checks as we digest
	  // the restored block scopes ($$checkUrlChange reads window.location to
	  // check for changes and trigger route change, etc, which we don't need when
	  // trying to scroll at 60fps).
	  this.$browser.$$checkUrlChange = angular.noop;
	
	  var i, block,
	      newStartBlocks = [],
	      newEndBlocks = [];
	
	  // Collect blocks at the top.
	  for (i = this.newStartIndex; i < this.newEndIndex && this.blocks[i] == null; i++) {
	    block = this.getBlock_(i);
	    this.updateBlock_(block, i);
	    newStartBlocks.push(block);
	  }
	
	  // Update blocks that are already rendered.
	  for (; this.blocks[i] != null; i++) {
	    this.updateBlock_(this.blocks[i], i);
	  }
	  var maxIndex = i - 1;
	
	  // Collect blocks at the end.
	  for (; i < this.newEndIndex; i++) {
	    block = this.getBlock_(i);
	    this.updateBlock_(block, i);
	    newEndBlocks.push(block);
	  }
	
	  // Attach collected blocks to the document.
	  if (newStartBlocks.length) {
	    this.parentNode.insertBefore(
	        this.domFragmentFromBlocks_(newStartBlocks),
	        this.$element[0].nextSibling);
	  }
	  if (newEndBlocks.length) {
	    this.parentNode.insertBefore(
	        this.domFragmentFromBlocks_(newEndBlocks),
	        this.blocks[maxIndex] && this.blocks[maxIndex].element[0].nextSibling);
	  }
	
	  // DOM manipulation may have altered scroll, so scroll again
	  if (cleanupFirstRender) {
	    this.container.scrollToIndex(firstRenderStartIndex);
	  }
	  // Restore $$checkUrlChange.
	  this.$browser.$$checkUrlChange = this.browserCheckUrlChange;
	
	  this.startIndex = this.newStartIndex;
	  this.endIndex = this.newEndIndex;
	
	  this.isVirtualRepeatUpdating_ = false;
	};
	
	
	/**
	 * @param {number} index Where the block is to be in the repeated list.
	 * @return {!VirtualRepeatController.Block} A new or pooled block to place at the specified index.
	 * @private
	 */
	VirtualRepeatController.prototype.getBlock_ = function(index) {
	  if (this.pooledBlocks.length) {
	    return this.pooledBlocks.pop();
	  }
	
	  var block;
	  this.transclude(angular.bind(this, function(clone, scope) {
	    block = {
	      element: clone,
	      new: true,
	      scope: scope
	    };
	
	    this.updateScope_(scope, index);
	    this.parentNode.appendChild(clone[0]);
	  }));
	
	  return block;
	};
	
	
	/**
	 * Updates and if not in a digest cycle, digests the specified block's scope to the data
	 * at the specified index.
	 * @param {!VirtualRepeatController.Block} block The block whose scope should be updated.
	 * @param {number} index The index to set.
	 * @private
	 */
	VirtualRepeatController.prototype.updateBlock_ = function(block, index) {
	  this.blocks[index] = block;
	
	  if (!block.new &&
	      (block.scope.$index === index && block.scope[this.repeatName] === this.items[index])) {
	    return;
	  }
	  block.new = false;
	
	  // Update and digest the block's scope.
	  this.updateScope_(block.scope, index);
	
	  // Perform digest before reattaching the block.
	  // Any resulting synchronous dom mutations should be much faster as a result.
	  // This might break some directives, but I'm going to try it for now.
	  if (!this.$rootScope.$$phase) {
	    block.scope.$digest();
	  }
	};
	
	
	/**
	 * Updates scope to the data at the specified index.
	 * @param {!angular.Scope} scope The scope which should be updated.
	 * @param {number} index The index to set.
	 * @private
	 */
	VirtualRepeatController.prototype.updateScope_ = function(scope, index) {
	  scope.$index = index;
	  scope[this.repeatName] = this.items && this.items[index];
	  if (this.extraName) scope[this.extraName(this.$scope)] = this.items[index];
	};
	
	
	/**
	 * Pools the block at the specified index (Pulls its element out of the dom and stores it).
	 * @param {number} index The index at which the block to pool is stored.
	 * @private
	 */
	VirtualRepeatController.prototype.poolBlock_ = function(index) {
	  this.pooledBlocks.push(this.blocks[index]);
	  this.parentNode.removeChild(this.blocks[index].element[0]);
	  delete this.blocks[index];
	};
	
	
	/**
	 * Produces a dom fragment containing the elements from the list of blocks.
	 * @param {!Array<!VirtualRepeatController.Block>} blocks The blocks whose elements
	 *     should be added to the document fragment.
	 * @return {DocumentFragment}
	 * @private
	 */
	VirtualRepeatController.prototype.domFragmentFromBlocks_ = function(blocks) {
	  var fragment = this.$document[0].createDocumentFragment();
	  blocks.forEach(function(block) {
	    fragment.appendChild(block.element[0]);
	  });
	  return fragment;
	};
	
	
	/**
	 * Updates start and end indexes based on length of repeated items and container size.
	 * @private
	 */
	VirtualRepeatController.prototype.updateIndexes_ = function() {
	  var itemsLength = this.items ? this.items.length : 0;
	  var containerLength = Math.ceil(this.container.getSize() / this.itemSize);
	
	  this.newStartIndex = Math.max(0, Math.min(
	      itemsLength - containerLength,
	      Math.floor(this.container.getScrollOffset() / this.itemSize)));
	  this.newVisibleEnd = this.newStartIndex + containerLength + NUM_EXTRA;
	  this.newEndIndex = Math.min(itemsLength, this.newVisibleEnd);
	  this.newStartIndex = Math.max(0, this.newStartIndex - NUM_EXTRA);
	};
	
	/**
	 * This VirtualRepeatModelArrayLike class enforces the interface requirements
	 * for infinite scrolling within a mdVirtualRepeatContainer. An object with this
	 * interface must implement the following interface with two (2) methods:
	 *
	 * getItemAtIndex: function(index) -> item at that index or null if it is not yet
	 *     loaded (It should start downloading the item in that case).
	 *
	 * getLength: function() -> number The data legnth to which the repeater container
	 *     should be sized. Ideally, when the count is known, this method should return it.
	 *     Otherwise, return a higher number than the currently loaded items to produce an
	 *     infinite-scroll behavior.
	 *
	 * @usage
	 * <hljs lang="html">
	 *  <md-virtual-repeat-container md-orient-horizontal>
	 *    <div md-virtual-repeat="i in items" md-on-demand>
	 *      Hello {{i}}!
	 *    </div>
	 *  </md-virtual-repeat-container>
	 * </hljs>
	 *
	 */
	function VirtualRepeatModelArrayLike(model) {
	  if (!angular.isFunction(model.getItemAtIndex) ||
	      !angular.isFunction(model.getLength)) {
	    throw Error('When md-on-demand is enabled, the Object passed to md-virtual-repeat must implement ' +
	        'functions getItemAtIndex() and getLength() ');
	  }
	
	  this.model = model;
	}
	
	
	VirtualRepeatModelArrayLike.prototype.$$includeIndexes = function(start, end) {
	  for (var i = start; i < end; i++) {
	    if (!this.hasOwnProperty(i)) {
	      this[i] = this.model.getItemAtIndex(i);
	    }
	  }
	  this.length = this.model.getLength();
	};
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.whiteframe
	 */
	MdWhiteframeDirective.$inject = ["$log"];
	angular
	  .module('material.components.whiteframe', ['material.core'])
	  .directive('mdWhiteframe', MdWhiteframeDirective);
	
	/**
	 * @ngdoc directive
	 * @module material.components.whiteframe
	 * @name mdWhiteframe
	 *
	 * @description
	 * The md-whiteframe directive allows you to apply an elevation shadow to an element.
	 *
	 * The attribute values needs to be a number between 1 and 24 or -1.
	 * When set to -1 no style is applied.
	 *
	 * ### Notes
	 * - If there is no value specified it defaults to 4dp.
	 * - If the value is not valid it defaults to 4dp.
	
	 * @usage
	 * <hljs lang="html">
	 * <div md-whiteframe="3">
	 *   <span>Elevation of 3dp</span>
	 * </div>
	 * </hljs>
	 *
	 * <hljs lang="html">
	 * <div md-whiteframe="-1">
	 *   <span>No elevation shadow applied</span>
	 * </div>
	 * </hljs>
	 *
	 * <hljs lang="html">
	 * <div ng-init="elevation = 5" md-whiteframe="{{elevation}}">
	 *   <span>Elevation of 5dp with an interpolated value</span>
	 * </div>
	 * </hljs>
	 */
	function MdWhiteframeDirective($log) {
	  var DISABLE_DP = -1;
	  var MIN_DP = 1;
	  var MAX_DP = 24;
	  var DEFAULT_DP = 4;
	
	  return {
	    link: postLink
	  };
	
	  function postLink(scope, element, attr) {
	    var oldClass = '';
	
	    attr.$observe('mdWhiteframe', function(elevation) {
	      elevation = parseInt(elevation, 10) || DEFAULT_DP;
	
	      if (elevation != DISABLE_DP && (elevation > MAX_DP || elevation < MIN_DP)) {
	        $log.warn('md-whiteframe attribute value is invalid. It should be a number between ' + MIN_DP + ' and ' + MAX_DP, element[0]);
	        elevation = DEFAULT_DP;
	      }
	
	      var newClass = elevation == DISABLE_DP ? '' : 'md-whiteframe-' + elevation + 'dp';
	      attr.$updateClass(newClass, oldClass);
	      oldClass = newClass;
	    });
	  }
	}
	
	
	})();
	(function(){
	"use strict";
	
	
	MdAutocompleteCtrl.$inject = ["$scope", "$element", "$mdUtil", "$mdConstant", "$mdTheming", "$window", "$animate", "$rootElement", "$attrs", "$q", "$log", "$mdLiveAnnouncer"];angular
	    .module('material.components.autocomplete')
	    .controller('MdAutocompleteCtrl', MdAutocompleteCtrl);
	
	var ITEM_HEIGHT   = 48,
	    MAX_ITEMS     = 5,
	    MENU_PADDING  = 8,
	    INPUT_PADDING = 2; // Padding provided by `md-input-container`
	
	function MdAutocompleteCtrl ($scope, $element, $mdUtil, $mdConstant, $mdTheming, $window,
	                             $animate, $rootElement, $attrs, $q, $log, $mdLiveAnnouncer) {
	
	  // Internal Variables.
	  var ctrl                 = this,
	      itemParts            = $scope.itemsExpr.split(/ in /i),
	      itemExpr             = itemParts[ 1 ],
	      elements             = null,
	      cache                = {},
	      noBlur               = false,
	      selectedItemWatchers = [],
	      hasFocus             = false,
	      fetchesInProgress    = 0,
	      enableWrapScroll     = null,
	      inputModelCtrl       = null,
	      debouncedOnResize    = $mdUtil.debounce(onWindowResize);
	
	  // Public Exported Variables with handlers
	  defineProperty('hidden', handleHiddenChange, true);
	
	  // Public Exported Variables
	  ctrl.scope      = $scope;
	  ctrl.parent     = $scope.$parent;
	  ctrl.itemName   = itemParts[ 0 ];
	  ctrl.matches    = [];
	  ctrl.loading    = false;
	  ctrl.hidden     = true;
	  ctrl.index      = null;
	  ctrl.id         = $mdUtil.nextUid();
	  ctrl.isDisabled = null;
	  ctrl.isRequired = null;
	  ctrl.isReadonly = null;
	  ctrl.hasNotFound = false;
	
	  // Public Exported Methods
	  ctrl.keydown                       = keydown;
	  ctrl.blur                          = blur;
	  ctrl.focus                         = focus;
	  ctrl.clear                         = clearValue;
	  ctrl.select                        = select;
	  ctrl.listEnter                     = onListEnter;
	  ctrl.listLeave                     = onListLeave;
	  ctrl.mouseUp                       = onMouseup;
	  ctrl.getCurrentDisplayValue        = getCurrentDisplayValue;
	  ctrl.registerSelectedItemWatcher   = registerSelectedItemWatcher;
	  ctrl.unregisterSelectedItemWatcher = unregisterSelectedItemWatcher;
	  ctrl.notFoundVisible               = notFoundVisible;
	  ctrl.loadingIsVisible              = loadingIsVisible;
	  ctrl.positionDropdown              = positionDropdown;
	
	  /**
	   * Report types to be used for the $mdLiveAnnouncer
	   * @enum {number} Unique flag id.
	   */
	  var ReportType = {
	    Count: 1,
	    Selected: 2
	  };
	
	  return init();
	
	  //-- initialization methods
	
	  /**
	   * Initialize the controller, setup watchers, gather elements
	   */
	  function init () {
	
	    $mdUtil.initOptionalProperties($scope, $attrs, {
	      searchText: '',
	      selectedItem: null,
	      clearButton: false
	    });
	
	    $mdTheming($element);
	    configureWatchers();
	    $mdUtil.nextTick(function () {
	
	      gatherElements();
	      moveDropdown();
	
	      // Forward all focus events to the input element when autofocus is enabled
	      if ($scope.autofocus) {
	        $element.on('focus', focusInputElement);
	      }
	    });
	  }
	
	  function updateModelValidators() {
	    if (!$scope.requireMatch || !inputModelCtrl) return;
	
	    inputModelCtrl.$setValidity('md-require-match', !!$scope.selectedItem || !$scope.searchText);
	  }
	
	  /**
	   * Calculates the dropdown's position and applies the new styles to the menu element
	   * @returns {*}
	   */
	  function positionDropdown () {
	    if (!elements) {
	      return $mdUtil.nextTick(positionDropdown, false, $scope);
	    }
	
	    var dropdownHeight = ($scope.dropdownItems || MAX_ITEMS) * ITEM_HEIGHT;
	
	    var hrect  = elements.wrap.getBoundingClientRect(),
	        vrect  = elements.snap.getBoundingClientRect(),
	        root   = elements.root.getBoundingClientRect(),
	        top    = vrect.bottom - root.top,
	        bot    = root.bottom - vrect.top,
	        left   = hrect.left - root.left,
	        width  = hrect.width,
	        offset = getVerticalOffset(),
	        position = $scope.dropdownPosition,
	        styles;
	
	    // Automatically determine dropdown placement based on available space in viewport.
	    if (!position) {
	      position = (top > bot && root.height - top - MENU_PADDING < dropdownHeight) ? 'top' : 'bottom';
	    }
	    // Adjust the width to account for the padding provided by `md-input-container`
	    if ($attrs.mdFloatingLabel) {
	      left += INPUT_PADDING;
	      width -= INPUT_PADDING * 2;
	    }
	    styles = {
	      left:     left + 'px',
	      minWidth: width + 'px',
	      maxWidth: Math.max(hrect.right - root.left, root.right - hrect.left) - MENU_PADDING + 'px'
	    };
	
	    if (position === 'top') {
	      styles.top       = 'auto';
	      styles.bottom    = bot + 'px';
	      styles.maxHeight = Math.min(dropdownHeight, hrect.top - root.top - MENU_PADDING) + 'px';
	    } else {
	      var bottomSpace = root.bottom - hrect.bottom - MENU_PADDING + $mdUtil.getViewportTop();
	
	      styles.top       = (top - offset) + 'px';
	      styles.bottom    = 'auto';
	      styles.maxHeight = Math.min(dropdownHeight, bottomSpace) + 'px';
	    }
	
	    elements.$.scrollContainer.css(styles);
	    $mdUtil.nextTick(correctHorizontalAlignment, false);
	
	    /**
	     * Calculates the vertical offset for floating label examples to account for ngMessages
	     * @returns {number}
	     */
	    function getVerticalOffset () {
	      var offset = 0;
	      var inputContainer = $element.find('md-input-container');
	      if (inputContainer.length) {
	        var input = inputContainer.find('input');
	        offset = inputContainer.prop('offsetHeight');
	        offset -= input.prop('offsetTop');
	        offset -= input.prop('offsetHeight');
	        // add in the height left up top for the floating label text
	        offset += inputContainer.prop('offsetTop');
	      }
	      return offset;
	    }
	
	    /**
	     * Makes sure that the menu doesn't go off of the screen on either side.
	     */
	    function correctHorizontalAlignment () {
	      var dropdown = elements.scrollContainer.getBoundingClientRect(),
	          styles   = {};
	      if (dropdown.right > root.right - MENU_PADDING) {
	        styles.left = (hrect.right - dropdown.width) + 'px';
	      }
	      elements.$.scrollContainer.css(styles);
	    }
	  }
	
	  /**
	   * Moves the dropdown menu to the body tag in order to avoid z-index and overflow issues.
	   */
	  function moveDropdown () {
	    if (!elements.$.root.length) return;
	    $mdTheming(elements.$.scrollContainer);
	    elements.$.scrollContainer.detach();
	    elements.$.root.append(elements.$.scrollContainer);
	    if ($animate.pin) $animate.pin(elements.$.scrollContainer, $rootElement);
	  }
	
	  /**
	   * Sends focus to the input element.
	   */
	  function focusInputElement () {
	    elements.input.focus();
	  }
	
	  /**
	   * Sets up any watchers used by autocomplete
	   */
	  function configureWatchers () {
	    var wait = parseInt($scope.delay, 10) || 0;
	
	    $attrs.$observe('disabled', function (value) { ctrl.isDisabled = $mdUtil.parseAttributeBoolean(value, false); });
	    $attrs.$observe('required', function (value) { ctrl.isRequired = $mdUtil.parseAttributeBoolean(value, false); });
	    $attrs.$observe('readonly', function (value) { ctrl.isReadonly = $mdUtil.parseAttributeBoolean(value, false); });
	
	    $scope.$watch('searchText', wait ? $mdUtil.debounce(handleSearchText, wait) : handleSearchText);
	    $scope.$watch('selectedItem', selectedItemChange);
	
	    angular.element($window).on('resize', debouncedOnResize);
	
	    $scope.$on('$destroy', cleanup);
	  }
	
	  /**
	   * Removes any events or leftover elements created by this controller
	   */
	  function cleanup () {
	    if (!ctrl.hidden) {
	      $mdUtil.enableScrolling();
	    }
	
	    angular.element($window).off('resize', debouncedOnResize);
	
	    if ( elements ){
	      var items = ['ul', 'scroller', 'scrollContainer', 'input'];
	      angular.forEach(items, function(key){
	        elements.$[key].remove();
	      });
	    }
	  }
	
	  /**
	   * Event handler to be called whenever the window resizes.
	   */
	  function onWindowResize() {
	    if (!ctrl.hidden) {
	      positionDropdown();
	    }
	  }
	
	  /**
	   * Gathers all of the elements needed for this controller
	   */
	  function gatherElements () {
	
	    var snapWrap = gatherSnapWrap();
	
	    elements = {
	      main:  $element[0],
	      scrollContainer: $element[0].querySelector('.md-virtual-repeat-container'),
	      scroller: $element[0].querySelector('.md-virtual-repeat-scroller'),
	      ul:    $element.find('ul')[0],
	      input: $element.find('input')[0],
	      wrap:  snapWrap.wrap,
	      snap:  snapWrap.snap,
	      root:  document.body
	    };
	
	    elements.li   = elements.ul.getElementsByTagName('li');
	    elements.$    = getAngularElements(elements);
	
	    inputModelCtrl = elements.$.input.controller('ngModel');
	  }
	
	  /**
	   * Gathers the snap and wrap elements
	   *
	   */
	  function gatherSnapWrap() {
	    var element;
	    var value;
	    for (element = $element; element.length; element = element.parent()) {
	      value = element.attr('md-autocomplete-snap');
	      if (angular.isDefined(value)) break;
	    }
	
	    if (element.length) {
	      return {
	        snap: element[0],
	        wrap: (value.toLowerCase() === 'width') ? element[0] : $element.find('md-autocomplete-wrap')[0]
	      };
	    }
	
	    var wrap = $element.find('md-autocomplete-wrap')[0];
	    return {
	      snap: wrap,
	      wrap: wrap
	    };
	  }
	
	  /**
	   * Gathers angular-wrapped versions of each element
	   * @param elements
	   * @returns {{}}
	   */
	  function getAngularElements (elements) {
	    var obj = {};
	    for (var key in elements) {
	      if (elements.hasOwnProperty(key)) obj[ key ] = angular.element(elements[ key ]);
	    }
	    return obj;
	  }
	
	  //-- event/change handlers
	
	  /**
	   * Handles changes to the `hidden` property.
	   * @param hidden
	   * @param oldHidden
	   */
	  function handleHiddenChange (hidden, oldHidden) {
	    if (!hidden && oldHidden) {
	      positionDropdown();
	
	      // Report in polite mode, because the screenreader should finish the default description of
	      // the input. element.
	      reportMessages(true, ReportType.Count | ReportType.Selected);
	
	      if (elements) {
	        $mdUtil.disableScrollAround(elements.ul);
	        enableWrapScroll = disableElementScrollEvents(angular.element(elements.wrap));
	      }
	    } else if (hidden && !oldHidden) {
	      $mdUtil.enableScrolling();
	
	      if (enableWrapScroll) {
	        enableWrapScroll();
	        enableWrapScroll = null;
	      }
	    }
	  }
	
	  /**
	   * Disables scrolling for a specific element
	   */
	  function disableElementScrollEvents(element) {
	
	    function preventDefault(e) {
	      e.preventDefault();
	    }
	
	    element.on('wheel', preventDefault);
	    element.on('touchmove', preventDefault);
	
	    return function() {
	      element.off('wheel', preventDefault);
	      element.off('touchmove', preventDefault);
	    };
	  }
	
	  /**
	   * When the user mouses over the dropdown menu, ignore blur events.
	   */
	  function onListEnter () {
	    noBlur = true;
	  }
	
	  /**
	   * When the user's mouse leaves the menu, blur events may hide the menu again.
	   */
	  function onListLeave () {
	    if (!hasFocus && !ctrl.hidden) elements.input.focus();
	    noBlur = false;
	    ctrl.hidden = shouldHide();
	  }
	
	  /**
	   * When the mouse button is released, send focus back to the input field.
	   */
	  function onMouseup () {
	    elements.input.focus();
	  }
	
	  /**
	   * Handles changes to the selected item.
	   * @param selectedItem
	   * @param previousSelectedItem
	   */
	  function selectedItemChange (selectedItem, previousSelectedItem) {
	
	    updateModelValidators();
	
	    if (selectedItem) {
	      getDisplayValue(selectedItem).then(function (val) {
	        $scope.searchText = val;
	        handleSelectedItemChange(selectedItem, previousSelectedItem);
	      });
	    } else if (previousSelectedItem && $scope.searchText) {
	      getDisplayValue(previousSelectedItem).then(function(displayValue) {
	        // Clear the searchText, when the selectedItem is set to null.
	        // Do not clear the searchText, when the searchText isn't matching with the previous
	        // selected item.
	        if (angular.isString($scope.searchText)
	          && displayValue.toString().toLowerCase() === $scope.searchText.toLowerCase()) {
	          $scope.searchText = '';
	        }
	      });
	    }
	
	    if (selectedItem !== previousSelectedItem) announceItemChange();
	  }
	
	  /**
	   * Use the user-defined expression to announce changes each time a new item is selected
	   */
	  function announceItemChange () {
	    angular.isFunction($scope.itemChange) && $scope.itemChange(getItemAsNameVal($scope.selectedItem));
	  }
	
	  /**
	   * Use the user-defined expression to announce changes each time the search text is changed
	   */
	  function announceTextChange () {
	    angular.isFunction($scope.textChange) && $scope.textChange();
	  }
	
	  /**
	   * Calls any external watchers listening for the selected item.  Used in conjunction with
	   * `registerSelectedItemWatcher`.
	   * @param selectedItem
	   * @param previousSelectedItem
	   */
	  function handleSelectedItemChange (selectedItem, previousSelectedItem) {
	    selectedItemWatchers.forEach(function (watcher) { watcher(selectedItem, previousSelectedItem); });
	  }
	
	  /**
	   * Register a function to be called when the selected item changes.
	   * @param cb
	   */
	  function registerSelectedItemWatcher (cb) {
	    if (selectedItemWatchers.indexOf(cb) == -1) {
	      selectedItemWatchers.push(cb);
	    }
	  }
	
	  /**
	   * Unregister a function previously registered for selected item changes.
	   * @param cb
	   */
	  function unregisterSelectedItemWatcher (cb) {
	    var i = selectedItemWatchers.indexOf(cb);
	    if (i != -1) {
	      selectedItemWatchers.splice(i, 1);
	    }
	  }
	
	  /**
	   * Handles changes to the searchText property.
	   * @param searchText
	   * @param previousSearchText
	   */
	  function handleSearchText (searchText, previousSearchText) {
	    ctrl.index = getDefaultIndex();
	
	    // do nothing on init
	    if (searchText === previousSearchText) return;
	
	    updateModelValidators();
	
	    getDisplayValue($scope.selectedItem).then(function (val) {
	      // clear selected item if search text no longer matches it
	      if (searchText !== val) {
	        $scope.selectedItem = null;
	
	
	        // trigger change event if available
	        if (searchText !== previousSearchText) announceTextChange();
	
	        // cancel results if search text is not long enough
	        if (!isMinLengthMet()) {
	          ctrl.matches = [];
	
	          setLoading(false);
	          reportMessages(false, ReportType.Count);
	
	        } else {
	          handleQuery();
	        }
	      }
	    });
	
	  }
	
	  /**
	   * Handles input blur event, determines if the dropdown should hide.
	   */
	  function blur($event) {
	    hasFocus = false;
	
	    if (!noBlur) {
	      ctrl.hidden = shouldHide();
	      evalAttr('ngBlur', { $event: $event });
	    }
	  }
	
	  /**
	   * Force blur on input element
	   * @param forceBlur
	   */
	  function doBlur(forceBlur) {
	    if (forceBlur) {
	      noBlur = false;
	      hasFocus = false;
	    }
	    elements.input.blur();
	  }
	
	  /**
	   * Handles input focus event, determines if the dropdown should show.
	   */
	  function focus($event) {
	    hasFocus = true;
	
	    if (isSearchable() && isMinLengthMet()) {
	      handleQuery();
	    }
	
	    ctrl.hidden = shouldHide();
	
	    evalAttr('ngFocus', { $event: $event });
	  }
	
	  /**
	   * Handles keyboard input.
	   * @param event
	   */
	  function keydown (event) {
	    switch (event.keyCode) {
	      case $mdConstant.KEY_CODE.DOWN_ARROW:
	        if (ctrl.loading) return;
	        event.stopPropagation();
	        event.preventDefault();
	        ctrl.index   = Math.min(ctrl.index + 1, ctrl.matches.length - 1);
	        updateScroll();
	        reportMessages(false, ReportType.Selected);
	        break;
	      case $mdConstant.KEY_CODE.UP_ARROW:
	        if (ctrl.loading) return;
	        event.stopPropagation();
	        event.preventDefault();
	        ctrl.index   = ctrl.index < 0 ? ctrl.matches.length - 1 : Math.max(0, ctrl.index - 1);
	        updateScroll();
	        reportMessages(false, ReportType.Selected);
	        break;
	      case $mdConstant.KEY_CODE.TAB:
	        // If we hit tab, assume that we've left the list so it will close
	        onListLeave();
	
	        if (ctrl.hidden || ctrl.loading || ctrl.index < 0 || ctrl.matches.length < 1) return;
	        select(ctrl.index);
	        break;
	      case $mdConstant.KEY_CODE.ENTER:
	        if (ctrl.hidden || ctrl.loading || ctrl.index < 0 || ctrl.matches.length < 1) return;
	        if (hasSelection()) return;
	        event.stopPropagation();
	        event.preventDefault();
	        select(ctrl.index);
	        break;
	      case $mdConstant.KEY_CODE.ESCAPE:
	        event.preventDefault(); // Prevent browser from always clearing input
	        if (!shouldProcessEscape()) return;
	        event.stopPropagation();
	
	        clearSelectedItem();
	        if ($scope.searchText && hasEscapeOption('clear')) {
	          clearSearchText();
	        }
	
	        // Manually hide (needed for mdNotFound support)
	        ctrl.hidden = true;
	
	        if (hasEscapeOption('blur')) {
	          // Force the component to blur if they hit escape
	          doBlur(true);
	        }
	
	        break;
	      default:
	    }
	  }
	
	  //-- getters
	
	  /**
	   * Returns the minimum length needed to display the dropdown.
	   * @returns {*}
	   */
	  function getMinLength () {
	    return angular.isNumber($scope.minLength) ? $scope.minLength : 1;
	  }
	
	  /**
	   * Returns the display value for an item.
	   * @param item
	   * @returns {*}
	   */
	  function getDisplayValue (item) {
	    return $q.when(getItemText(item) || item).then(function(itemText) {
	      if (itemText && !angular.isString(itemText)) {
	        $log.warn('md-autocomplete: Could not resolve display value to a string. ' +
	          'Please check the `md-item-text` attribute.');
	      }
	
	      return itemText;
	    });
	
	    /**
	     * Getter function to invoke user-defined expression (in the directive)
	     * to convert your object to a single string.
	     */
	    function getItemText (item) {
	      return (item && $scope.itemText) ? $scope.itemText(getItemAsNameVal(item)) : null;
	    }
	  }
	
	  /**
	   * Returns the locals object for compiling item templates.
	   * @param item
	   * @returns {{}}
	   */
	  function getItemAsNameVal (item) {
	    if (!item) return undefined;
	
	    var locals = {};
	    if (ctrl.itemName) locals[ ctrl.itemName ] = item;
	
	    return locals;
	  }
	
	  /**
	   * Returns the default index based on whether or not autoselect is enabled.
	   * @returns {number}
	   */
	  function getDefaultIndex () {
	    return $scope.autoselect ? 0 : -1;
	  }
	
	  /**
	   * Sets the loading parameter and updates the hidden state.
	   * @param value {boolean} Whether or not the component is currently loading.
	   */
	  function setLoading(value) {
	    if (ctrl.loading != value) {
	      ctrl.loading = value;
	    }
	
	    // Always refresh the hidden variable as something else might have changed
	    ctrl.hidden = shouldHide();
	  }
	
	  /**
	   * Determines if the menu should be hidden.
	   * @returns {boolean}
	   */
	  function shouldHide () {
	    if (!isSearchable()) return true;    // Hide when not able to query
	    else return !shouldShow();            // Hide when the dropdown is not able to show.
	  }
	
	  /**
	   * Determines whether the autocomplete is able to query within the current state.
	   * @returns {boolean}
	   */
	  function isSearchable() {
	    if (ctrl.loading && !hasMatches()) return false; // No query when query is in progress.
	    else if (hasSelection()) return false;           // No query if there is already a selection
	    else if (!hasFocus) return false;                // No query if the input does not have focus
	    return true;
	  }
	
	  /**
	   * Determines if the escape keydown should be processed
	   * @returns {boolean}
	   */
	  function shouldProcessEscape() {
	    return hasEscapeOption('blur') || !ctrl.hidden || ctrl.loading || hasEscapeOption('clear') && $scope.searchText;
	  }
	
	  /**
	   * Determines if an escape option is set
	   * @returns {boolean}
	   */
	  function hasEscapeOption(option) {
	    return !$scope.escapeOptions || $scope.escapeOptions.toLowerCase().indexOf(option) !== -1;
	  }
	
	  /**
	   * Determines if the menu should be shown.
	   * @returns {boolean}
	   */
	  function shouldShow() {
	    return (isMinLengthMet() && hasMatches()) || notFoundVisible();
	  }
	
	  /**
	   * Returns true if the search text has matches.
	   * @returns {boolean}
	   */
	  function hasMatches() {
	    return ctrl.matches.length ? true : false;
	  }
	
	  /**
	   * Returns true if the autocomplete has a valid selection.
	   * @returns {boolean}
	   */
	  function hasSelection() {
	    return ctrl.scope.selectedItem ? true : false;
	  }
	
	  /**
	   * Returns true if the loading indicator is, or should be, visible.
	   * @returns {boolean}
	   */
	  function loadingIsVisible() {
	    return ctrl.loading && !hasSelection();
	  }
	
	  /**
	   * Returns the display value of the current item.
	   * @returns {*}
	   */
	  function getCurrentDisplayValue () {
	    return getDisplayValue(ctrl.matches[ ctrl.index ]);
	  }
	
	  /**
	   * Determines if the minimum length is met by the search text.
	   * @returns {*}
	   */
	  function isMinLengthMet () {
	    return ($scope.searchText || '').length >= getMinLength();
	  }
	
	  //-- actions
	
	  /**
	   * Defines a public property with a handler and a default value.
	   * @param key
	   * @param handler
	   * @param value
	   */
	  function defineProperty (key, handler, value) {
	    Object.defineProperty(ctrl, key, {
	      get: function () { return value; },
	      set: function (newValue) {
	        var oldValue = value;
	        value        = newValue;
	        handler(newValue, oldValue);
	      }
	    });
	  }
	
	  /**
	   * Selects the item at the given index.
	   * @param index
	   */
	  function select (index) {
	    //-- force form to update state for validation
	    $mdUtil.nextTick(function () {
	      getDisplayValue(ctrl.matches[ index ]).then(function (val) {
	        var ngModel = elements.$.input.controller('ngModel');
	        ngModel.$setViewValue(val);
	        ngModel.$render();
	      }).finally(function () {
	        $scope.selectedItem = ctrl.matches[ index ];
	        setLoading(false);
	      });
	    }, false);
	  }
	
	  /**
	   * Clears the searchText value and selected item.
	   */
	  function clearValue () {
	    clearSelectedItem();
	    clearSearchText();
	  }
	
	  /**
	   * Clears the selected item
	   */
	  function clearSelectedItem () {
	    // Reset our variables
	    ctrl.index = 0;
	    ctrl.matches = [];
	  }
	
	  /**
	   * Clears the searchText value
	   */
	  function clearSearchText () {
	    // Set the loading to true so we don't see flashes of content.
	    // The flashing will only occur when an async request is running.
	    // So the loading process will stop when the results had been retrieved.
	    setLoading(true);
	
	    $scope.searchText = '';
	
	    // Normally, triggering the change / input event is unnecessary, because the browser detects it properly.
	    // But some browsers are not detecting it properly, which means that we have to trigger the event.
	    // Using the `input` is not working properly, because for example IE11 is not supporting the `input` event.
	    // The `change` event is a good alternative and is supported by all supported browsers.
	    var eventObj = document.createEvent('CustomEvent');
	    eventObj.initCustomEvent('change', true, true, { value: '' });
	    elements.input.dispatchEvent(eventObj);
	
	    // For some reason, firing the above event resets the value of $scope.searchText if
	    // $scope.searchText has a space character at the end, so we blank it one more time and then
	    // focus.
	    elements.input.blur();
	    $scope.searchText = '';
	    elements.input.focus();
	  }
	
	  /**
	   * Fetches the results for the provided search text.
	   * @param searchText
	   */
	  function fetchResults (searchText) {
	    var items = $scope.$parent.$eval(itemExpr),
	        term  = searchText.toLowerCase(),
	        isList = angular.isArray(items),
	        isPromise = !!items.then; // Every promise should contain a `then` property
	
	    if (isList) onResultsRetrieved(items);
	    else if (isPromise) handleAsyncResults(items);
	
	    function handleAsyncResults(items) {
	      if ( !items ) return;
	
	      items = $q.when(items);
	      fetchesInProgress++;
	      setLoading(true);
	
	      $mdUtil.nextTick(function () {
	          items
	            .then(onResultsRetrieved)
	            .finally(function(){
	              if (--fetchesInProgress === 0) {
	                setLoading(false);
	              }
	            });
	      },true, $scope);
	    }
	
	    function onResultsRetrieved(matches) {
	      cache[term] = matches;
	
	      // Just cache the results if the request is now outdated.
	      // The request becomes outdated, when the new searchText has changed during the result fetching.
	      if ((searchText || '') !== ($scope.searchText || '')) {
	        return;
	      }
	
	      handleResults(matches);
	    }
	  }
	
	
	  /**
	   * Reports given message types to supported screenreaders.
	   * @param {boolean} isPolite Whether the announcement should be polite.
	   * @param {!number} types Message flags to be reported to the screenreader.
	   */
	  function reportMessages(isPolite, types) {
	
	    var politeness = isPolite ? 'polite' : 'assertive';
	    var messages = [];
	
	    if (types & ReportType.Selected && ctrl.index !== -1) {
	      messages.push(getCurrentDisplayValue());
	    }
	
	    if (types & ReportType.Count) {
	      messages.push($q.resolve(getCountMessage()));
	    }
	
	    $q.all(messages).then(function(data) {
	      $mdLiveAnnouncer.announce(data.join(' '), politeness);
	    });
	
	  }
	
	  /**
	   * Returns the ARIA message for how many results match the current query.
	   * @returns {*}
	   */
	  function getCountMessage () {
	    switch (ctrl.matches.length) {
	      case 0:
	        return 'There are no matches available.';
	      case 1:
	        return 'There is 1 match available.';
	      default:
	        return 'There are ' + ctrl.matches.length + ' matches available.';
	    }
	  }
	
	  /**
	   * Makes sure that the focused element is within view.
	   */
	  function updateScroll () {
	    if (!elements.li[0]) return;
	    var height = elements.li[0].offsetHeight,
	        top = height * ctrl.index,
	        bot = top + height,
	        hgt = elements.scroller.clientHeight,
	        scrollTop = elements.scroller.scrollTop;
	    if (top < scrollTop) {
	      scrollTo(top);
	    } else if (bot > scrollTop + hgt) {
	      scrollTo(bot - hgt);
	    }
	  }
	
	  function isPromiseFetching() {
	    return fetchesInProgress !== 0;
	  }
	
	  function scrollTo (offset) {
	    elements.$.scrollContainer.controller('mdVirtualRepeatContainer').scrollTo(offset);
	  }
	
	  function notFoundVisible () {
	    var textLength = (ctrl.scope.searchText || '').length;
	
	    return ctrl.hasNotFound && !hasMatches() && (!ctrl.loading || isPromiseFetching()) && textLength >= getMinLength() && (hasFocus || noBlur) && !hasSelection();
	  }
	
	  /**
	   * Starts the query to gather the results for the current searchText.  Attempts to return cached
	   * results first, then forwards the process to `fetchResults` if necessary.
	   */
	  function handleQuery () {
	    var searchText = $scope.searchText || '';
	    var term = searchText.toLowerCase();
	
	    // If caching is enabled and the current searchText is stored in the cache
	    if (!$scope.noCache && cache[term]) {
	      // The results should be handled as same as a normal un-cached request does.
	      handleResults(cache[term]);
	    } else {
	      fetchResults(searchText);
	    }
	
	    ctrl.hidden = shouldHide();
	  }
	
	  /**
	   * Handles the retrieved results by showing them in the autocompletes dropdown.
	   * @param results Retrieved results
	   */
	  function handleResults(results) {
	    ctrl.matches = results;
	    ctrl.hidden  = shouldHide();
	
	    // If loading is in progress, then we'll end the progress. This is needed for example,
	    // when the `clear` button was clicked, because there we always show the loading process, to prevent flashing.
	    if (ctrl.loading) setLoading(false);
	
	    if ($scope.selectOnMatch) selectItemOnMatch();
	
	    positionDropdown();
	    reportMessages(true, ReportType.Count);
	  }
	
	  /**
	   * If there is only one matching item and the search text matches its display value exactly,
	   * automatically select that item.  Note: This function is only called if the user uses the
	   * `md-select-on-match` flag.
	   */
	  function selectItemOnMatch () {
	    var searchText = $scope.searchText,
	        matches    = ctrl.matches,
	        item       = matches[ 0 ];
	    if (matches.length === 1) getDisplayValue(item).then(function (displayValue) {
	      var isMatching = searchText == displayValue;
	      if ($scope.matchInsensitive && !isMatching) {
	        isMatching = searchText.toLowerCase() == displayValue.toLowerCase();
	      }
	
	      if (isMatching) select(0);
	    });
	  }
	
	  /**
	   * Evaluates an attribute expression against the parent scope.
	   * @param {String} attr Name of the attribute to be evaluated.
	   * @param {Object?} locals Properties to be injected into the evaluation context.
	   */
	 function evalAttr(attr, locals) {
	    if ($attrs[attr]) {
	      $scope.$parent.$eval($attrs[attr], locals || {});
	    }
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdAutocomplete.$inject = ["$$mdSvgRegistry"];angular
	    .module('material.components.autocomplete')
	    .directive('mdAutocomplete', MdAutocomplete);
	
	/**
	 * @ngdoc directive
	 * @name mdAutocomplete
	 * @module material.components.autocomplete
	 *
	 * @description
	 * `<md-autocomplete>` is a special input component with a drop-down of all possible matches to a
	 *     custom query. This component allows you to provide real-time suggestions as the user types
	 *     in the input area.
	 *
	 * To start, you will need to specify the required parameters and provide a template for your
	 *     results. The content inside `md-autocomplete` will be treated as a template.
	 *
	 * In more complex cases, you may want to include other content such as a message to display when
	 *     no matches were found.  You can do this by wrapping your template in `md-item-template` and
	 *     adding a tag for `md-not-found`.  An example of this is shown below.
	 *
	 * To reset the displayed value you must clear both values for `md-search-text` and `md-selected-item`.
	 *
	 * ### Validation
	 *
	 * You can use `ng-messages` to include validation the same way that you would normally validate;
	 *     however, if you want to replicate a standard input with a floating label, you will have to
	 *     do the following:
	 *
	 * - Make sure that your template is wrapped in `md-item-template`
	 * - Add your `ng-messages` code inside of `md-autocomplete`
	 * - Add your validation properties to `md-autocomplete` (ie. `required`)
	 * - Add a `name` to `md-autocomplete` (to be used on the generated `input`)
	 *
	 * There is an example below of how this should look.
	 *
	 * ### Snapping Drop-Down
	 *
	 * You can cause the autocomplete drop-down to snap to an ancestor element by applying the
	 *     `md-autocomplete-snap` attribute to that element. You can also snap to the width of
	 *     the `md-autocomplete-snap` element by setting the attribute's value to `width`
	 *     (ie. `md-autocomplete-snap="width"`).
	 *
	 * ### Notes
	 *
	 * **Autocomplete Dropdown Items Rendering**
	 *
	 * The `md-autocomplete` uses the the <a ng-href="api/directive/mdVirtualRepeatContainer">VirtualRepeat</a>
	 * directive for displaying the results inside of the dropdown.<br/>
	 *
	 * > When encountering issues regarding the item template please take a look at the
	 *   <a ng-href="api/directive/mdVirtualRepeatContainer">VirtualRepeatContainer</a> documentation.
	 *
	 * **Autocomplete inside of a Virtual Repeat**
	 *
	 * When using the `md-autocomplete` directive inside of a
	 * <a ng-href="api/directive/mdVirtualRepeatContainer">VirtualRepeatContainer</a> the dropdown items might
	 * not update properly, because caching of the results is enabled by default.
	 *
	 * The autocomplete will then show invalid dropdown items, because the VirtualRepeat only updates the
	 * scope bindings, rather than re-creating the `md-autocomplete` and the previous cached results will be used.
	 *
	 * > To avoid such problems ensure that the autocomplete does not cache any results.
	 *
	 * <hljs lang="html">
	 *   <md-autocomplete
	 *       md-no-cache="true"
	 *       md-selected-item="selectedItem"
	 *       md-items="item in items"
	 *       md-search-text="searchText"
	 *       md-item-text="item.display">
	 *     <span>{{ item.display }}</span>
	 *   </md-autocomplete>
	 * </hljs>
	 *
	 *
	 *
	 * @param {expression} md-items An expression in the format of `item in results` to iterate over
	 *     matches for your search.<br/><br/>
	 *     The `results` expression can be also a function, which returns the results synchronously
	 *     or asynchronously (per Promise)
	 * @param {expression=} md-selected-item-change An expression to be run each time a new item is
	 *     selected
	 * @param {expression=} md-search-text-change An expression to be run each time the search text
	 *     updates
	 * @param {expression=} md-search-text A model to bind the search query text to
	 * @param {object=} md-selected-item A model to bind the selected item to
	 * @param {expression=} md-item-text An expression that will convert your object to a single string.
	 * @param {string=} placeholder Placeholder text that will be forwarded to the input.
	 * @param {boolean=} md-no-cache Disables the internal caching that happens in autocomplete
	 * @param {boolean=} ng-disabled Determines whether or not to disable the input field
	 * @param {boolean=} md-require-match When set to true, the autocomplete will add a validator,
	 *     which will evaluate to false, when no item is currently selected.
	 * @param {number=} md-min-length Specifies the minimum length of text before autocomplete will
	 *     make suggestions
	 * @param {number=} md-delay Specifies the amount of time (in milliseconds) to wait before looking
	 *     for results
	 * @param {boolean=} md-clear-button Whether the clear button for the autocomplete input should show up or not.
	 * @param {boolean=} md-autofocus If true, the autocomplete will be automatically focused when a `$mdDialog`,
	 *     `$mdBottomsheet` or `$mdSidenav`, which contains the autocomplete, is opening. <br/><br/>
	 *     Also the autocomplete will immediately focus the input element.
	 * @param {boolean=} md-no-asterisk When present, asterisk will not be appended to the floating label
	 * @param {boolean=} md-autoselect If set to true, the first item will be automatically selected
	 *     in the dropdown upon open.
	 * @param {string=} md-menu-class This will be applied to the dropdown menu for styling
	 * @param {string=} md-floating-label This will add a floating label to autocomplete and wrap it in
	 *     `md-input-container`
	 * @param {string=} md-input-name The name attribute given to the input element to be used with
	 *     FormController
	 * @param {string=} md-select-on-focus When present the inputs text will be automatically selected
	 *     on focus.
	 * @param {string=} md-input-id An ID to be added to the input element
	 * @param {number=} md-input-minlength The minimum length for the input's value for validation
	 * @param {number=} md-input-maxlength The maximum length for the input's value for validation
	 * @param {boolean=} md-select-on-match When set, autocomplete will automatically select exact
	 *     the item if the search text is an exact match. <br/><br/>
	 *     Exact match means that there is only one match showing up.
	 * @param {boolean=} md-match-case-insensitive When set and using `md-select-on-match`, autocomplete
	 *     will select on case-insensitive match
	 * @param {string=} md-escape-options Override escape key logic. Default is `blur clear`.<br/>
	 *     Options: `blur | clear`, `none`
	 * @param {string=} md-dropdown-items Specifies the maximum amount of items to be shown in
	 *     the dropdown.<br/><br/>
	 *     When the dropdown doesn't fit into the viewport, the dropdown will shrink
	 *     as less as possible.
	 * @param {string=} md-dropdown-position Overrides the default dropdown position. Options: `top`, `bottom`.
	 * @param {string=} ng-trim If set to false, the search text will be not trimmed automatically.
	 *     Defaults to true.
	 * @param {string=} ng-pattern Adds the pattern validator to the ngModel of the search text.
	 *     [ngPattern Directive](https://docs.angularjs.org/api/ng/directive/ngPattern)
	 *
	 * @usage
	 * ### Basic Example
	 * <hljs lang="html">
	 *   <md-autocomplete
	 *       md-selected-item="selectedItem"
	 *       md-search-text="searchText"
	 *       md-items="item in getMatches(searchText)"
	 *       md-item-text="item.display">
	 *     <span md-highlight-text="searchText">{{item.display}}</span>
	 *   </md-autocomplete>
	 * </hljs>
	 *
	 * ### Example with "not found" message
	 * <hljs lang="html">
	 * <md-autocomplete
	 *     md-selected-item="selectedItem"
	 *     md-search-text="searchText"
	 *     md-items="item in getMatches(searchText)"
	 *     md-item-text="item.display">
	 *   <md-item-template>
	 *     <span md-highlight-text="searchText">{{item.display}}</span>
	 *   </md-item-template>
	 *   <md-not-found>
	 *     No matches found.
	 *   </md-not-found>
	 * </md-autocomplete>
	 * </hljs>
	 *
	 * In this example, our code utilizes `md-item-template` and `md-not-found` to specify the
	 *     different parts that make up our component.
	 *
	 * ### Clear button for the input
	 * By default, for floating label autocomplete's the clear button is not showing up
	 * ([See specs](https://material.google.com/components/text-fields.html#text-fields-auto-complete-text-field))
	 *
	 * Nevertheless, developers are able to explicitly toggle the clear button for all types of autocomplete's.
	 *
	 * <hljs lang="html">
	 *   <md-autocomplete ... md-clear-button="true"></md-autocomplete>
	 *   <md-autocomplete ... md-clear-button="false"></md-autocomplete>
	 * </hljs>
	 *
	 * ### Example with validation
	 * <hljs lang="html">
	 * <form name="autocompleteForm">
	 *   <md-autocomplete
	 *       required
	 *       md-input-name="autocomplete"
	 *       md-selected-item="selectedItem"
	 *       md-search-text="searchText"
	 *       md-items="item in getMatches(searchText)"
	 *       md-item-text="item.display">
	 *     <md-item-template>
	 *       <span md-highlight-text="searchText">{{item.display}}</span>
	 *     </md-item-template>
	 *     <div ng-messages="autocompleteForm.autocomplete.$error">
	 *       <div ng-message="required">This field is required</div>
	 *     </div>
	 *   </md-autocomplete>
	 * </form>
	 * </hljs>
	 *
	 * In this example, our code utilizes `md-item-template` and `ng-messages` to specify
	 *     input validation for the field.
	 *
	 * ### Asynchronous Results
	 * The autocomplete items expression also supports promises, which will resolve with the query results.
	 *
	 * <hljs lang="js">
	 *   function AppController($scope, $http) {
	 *     $scope.query = function(searchText) {
	 *       return $http
	 *         .get(BACKEND_URL + '/items/' + searchText)
	 *         .then(function(data) {
	 *           // Map the response object to the data object.
	 *           return data;
	 *         });
	 *     };
	 *   }
	 * </hljs>
	 *
	 * <hljs lang="html">
	 *   <md-autocomplete
	 *       md-selected-item="selectedItem"
	 *       md-search-text="searchText"
	 *       md-items="item in query(searchText)">
	 *     <md-item-template>
	 *       <span md-highlight-text="searchText">{{item}}</span>
	 *     </md-item-template>
	 * </md-autocomplete>
	 * </hljs>
	 *
	 */
	
	function MdAutocomplete ($$mdSvgRegistry) {
	
	  return {
	    controller:   'MdAutocompleteCtrl',
	    controllerAs: '$mdAutocompleteCtrl',
	    scope:        {
	      inputName:        '@mdInputName',
	      inputMinlength:   '@mdInputMinlength',
	      inputMaxlength:   '@mdInputMaxlength',
	      searchText:       '=?mdSearchText',
	      selectedItem:     '=?mdSelectedItem',
	      itemsExpr:        '@mdItems',
	      itemText:         '&mdItemText',
	      placeholder:      '@placeholder',
	      noCache:          '=?mdNoCache',
	      requireMatch:     '=?mdRequireMatch',
	      selectOnMatch:    '=?mdSelectOnMatch',
	      matchInsensitive: '=?mdMatchCaseInsensitive',
	      itemChange:       '&?mdSelectedItemChange',
	      textChange:       '&?mdSearchTextChange',
	      minLength:        '=?mdMinLength',
	      delay:            '=?mdDelay',
	      autofocus:        '=?mdAutofocus',
	      floatingLabel:    '@?mdFloatingLabel',
	      autoselect:       '=?mdAutoselect',
	      menuClass:        '@?mdMenuClass',
	      inputId:          '@?mdInputId',
	      escapeOptions:    '@?mdEscapeOptions',
	      dropdownItems:    '=?mdDropdownItems',
	      dropdownPosition: '@?mdDropdownPosition',
	      clearButton:      '=?mdClearButton'
	    },
	    compile: function(tElement, tAttrs) {
	      var attributes = ['md-select-on-focus', 'md-no-asterisk', 'ng-trim', 'ng-pattern'];
	      var input = tElement.find('input');
	
	      attributes.forEach(function(attribute) {
	        var attrValue = tAttrs[tAttrs.$normalize(attribute)];
	
	        if (attrValue !== null) {
	          input.attr(attribute, attrValue);
	        }
	      });
	
	      return function(scope, element, attrs, ctrl) {
	        // Retrieve the state of using a md-not-found template by using our attribute, which will
	        // be added to the element in the template function.
	        ctrl.hasNotFound = !!element.attr('md-has-not-found');
	
	        // By default the inset autocomplete should show the clear button when not explicitly overwritten.
	        if (!angular.isDefined(attrs.mdClearButton) && !scope.floatingLabel) {
	          scope.clearButton = true;
	        }
	      }
	    },
	    template:     function (element, attr) {
	      var noItemsTemplate = getNoItemsTemplate(),
	          itemTemplate    = getItemTemplate(),
	          leftover        = element.html(),
	          tabindex        = attr.tabindex;
	
	      // Set our attribute for the link function above which runs later.
	      // We will set an attribute, because otherwise the stored variables will be trashed when
	      // removing the element is hidden while retrieving the template. For example when using ngIf.
	      if (noItemsTemplate) element.attr('md-has-not-found', true);
	
	      // Always set our tabindex of the autocomplete directive to -1, because our input
	      // will hold the actual tabindex.
	      element.attr('tabindex', '-1');
	
	      return '\
	        <md-autocomplete-wrap\
	            ng-class="{ \'md-whiteframe-z1\': !floatingLabel, \
	                        \'md-menu-showing\': !$mdAutocompleteCtrl.hidden, \
	                        \'md-show-clear-button\': !!clearButton }">\
	          ' + getInputElement() + '\
	          ' + getClearButton() + '\
	          <md-progress-linear\
	              class="' + (attr.mdFloatingLabel ? 'md-inline' : '') + '"\
	              ng-if="$mdAutocompleteCtrl.loadingIsVisible()"\
	              md-mode="indeterminate"></md-progress-linear>\
	          <md-virtual-repeat-container\
	              md-auto-shrink\
	              md-auto-shrink-min="1"\
	              ng-mouseenter="$mdAutocompleteCtrl.listEnter()"\
	              ng-mouseleave="$mdAutocompleteCtrl.listLeave()"\
	              ng-mouseup="$mdAutocompleteCtrl.mouseUp()"\
	              ng-hide="$mdAutocompleteCtrl.hidden"\
	              class="md-autocomplete-suggestions-container md-whiteframe-z1"\
	              ng-class="{ \'md-not-found\': $mdAutocompleteCtrl.notFoundVisible() }"\
	              role="presentation">\
	            <ul class="md-autocomplete-suggestions"\
	                ng-class="::menuClass"\
	                id="ul-{{$mdAutocompleteCtrl.id}}">\
	              <li md-virtual-repeat="item in $mdAutocompleteCtrl.matches"\
	                  ng-class="{ selected: $index === $mdAutocompleteCtrl.index }"\
	                  ng-click="$mdAutocompleteCtrl.select($index)"\
	                  md-extra-name="$mdAutocompleteCtrl.itemName">\
	                  ' + itemTemplate + '\
	                  </li>' + noItemsTemplate + '\
	            </ul>\
	          </md-virtual-repeat-container>\
	        </md-autocomplete-wrap>';
	
	      function getItemTemplate() {
	        var templateTag = element.find('md-item-template').detach(),
	            html = templateTag.length ? templateTag.html() : element.html();
	        if (!templateTag.length) element.empty();
	        return '<md-autocomplete-parent-scope md-autocomplete-replace>' + html + '</md-autocomplete-parent-scope>';
	      }
	
	      function getNoItemsTemplate() {
	        var templateTag = element.find('md-not-found').detach(),
	            template = templateTag.length ? templateTag.html() : '';
	        return template
	            ? '<li ng-if="$mdAutocompleteCtrl.notFoundVisible()"\
	                         md-autocomplete-parent-scope>' + template + '</li>'
	            : '';
	
	      }
	
	      function getInputElement () {
	        if (attr.mdFloatingLabel) {
	          return '\
	            <md-input-container ng-if="floatingLabel">\
	              <label>{{floatingLabel}}</label>\
	              <input type="search"\
	                  ' + (tabindex != null ? 'tabindex="' + tabindex + '"' : '') + '\
	                  id="{{ inputId || \'fl-input-\' + $mdAutocompleteCtrl.id }}"\
	                  name="{{inputName}}"\
	                  autocomplete="off"\
	                  ng-required="$mdAutocompleteCtrl.isRequired"\
	                  ng-readonly="$mdAutocompleteCtrl.isReadonly"\
	                  ng-minlength="inputMinlength"\
	                  ng-maxlength="inputMaxlength"\
	                  ng-disabled="$mdAutocompleteCtrl.isDisabled"\
	                  ng-model="$mdAutocompleteCtrl.scope.searchText"\
	                  ng-model-options="{ allowInvalid: true }"\
	                  ng-keydown="$mdAutocompleteCtrl.keydown($event)"\
	                  ng-blur="$mdAutocompleteCtrl.blur($event)"\
	                  ng-focus="$mdAutocompleteCtrl.focus($event)"\
	                  aria-owns="ul-{{$mdAutocompleteCtrl.id}}"\
	                  aria-label="{{floatingLabel}}"\
	                  aria-autocomplete="list"\
	                  role="combobox"\
	                  aria-haspopup="true"\
	                  aria-activedescendant=""\
	                  aria-expanded="{{!$mdAutocompleteCtrl.hidden}}"/>\
	              <div md-autocomplete-parent-scope md-autocomplete-replace>' + leftover + '</div>\
	            </md-input-container>';
	        } else {
	          return '\
	            <input type="search"\
	                ' + (tabindex != null ? 'tabindex="' + tabindex + '"' : '') + '\
	                id="{{ inputId || \'input-\' + $mdAutocompleteCtrl.id }}"\
	                name="{{inputName}}"\
	                ng-if="!floatingLabel"\
	                autocomplete="off"\
	                ng-required="$mdAutocompleteCtrl.isRequired"\
	                ng-disabled="$mdAutocompleteCtrl.isDisabled"\
	                ng-readonly="$mdAutocompleteCtrl.isReadonly"\
	                ng-minlength="inputMinlength"\
	                ng-maxlength="inputMaxlength"\
	                ng-model="$mdAutocompleteCtrl.scope.searchText"\
	                ng-keydown="$mdAutocompleteCtrl.keydown($event)"\
	                ng-blur="$mdAutocompleteCtrl.blur($event)"\
	                ng-focus="$mdAutocompleteCtrl.focus($event)"\
	                placeholder="{{placeholder}}"\
	                aria-owns="ul-{{$mdAutocompleteCtrl.id}}"\
	                aria-label="{{placeholder}}"\
	                aria-autocomplete="list"\
	                role="combobox"\
	                aria-haspopup="true"\
	                aria-activedescendant=""\
	                aria-expanded="{{!$mdAutocompleteCtrl.hidden}}"/>';
	        }
	      }
	
	      function getClearButton() {
	        return '' +
	          '<button ' +
	              'type="button" ' +
	              'aria-label="Clear Input" ' +
	              'tabindex="-1" ' +
	              'ng-if="clearButton && $mdAutocompleteCtrl.scope.searchText && !$mdAutocompleteCtrl.isDisabled" ' +
	              'ng-click="$mdAutocompleteCtrl.clear($event)">' +
	            '<md-icon md-svg-src="' + $$mdSvgRegistry.mdClose + '"></md-icon>' +
	          '</button>';
	        }
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdAutocompleteItemScopeDirective.$inject = ["$compile", "$mdUtil"];angular
	  .module('material.components.autocomplete')
	  .directive('mdAutocompleteParentScope', MdAutocompleteItemScopeDirective);
	
	function MdAutocompleteItemScopeDirective($compile, $mdUtil) {
	  return {
	    restrict: 'AE',
	    compile: compile,
	    terminal: true,
	    transclude: 'element'
	  };
	
	  function compile(tElement, tAttr, transclude) {
	    return function postLink(scope, element, attr) {
	      var ctrl = scope.$mdAutocompleteCtrl;
	      var newScope = ctrl.parent.$new();
	      var itemName = ctrl.itemName;
	
	      // Watch for changes to our scope's variables and copy them to the new scope
	      watchVariable('$index', '$index');
	      watchVariable('item', itemName);
	
	      // Ensure that $digest calls on our scope trigger $digest on newScope.
	      connectScopes();
	
	      // Link the element against newScope.
	      transclude(newScope, function(clone) {
	        element.after(clone);
	      });
	
	      /**
	       * Creates a watcher for variables that are copied from the parent scope
	       * @param variable
	       * @param alias
	       */
	      function watchVariable(variable, alias) {
	        newScope[alias] = scope[variable];
	
	        scope.$watch(variable, function(value) {
	          $mdUtil.nextTick(function() {
	            newScope[alias] = value;
	          });
	        });
	      }
	
	      /**
	       * Creates watchers on scope and newScope that ensure that for any
	       * $digest of scope, newScope is also $digested.
	       */
	      function connectScopes() {
	        var scopeDigesting = false;
	        var newScopeDigesting = false;
	
	        scope.$watch(function() {
	          if (newScopeDigesting || scopeDigesting) {
	            return;
	          }
	
	          scopeDigesting = true;
	          scope.$$postDigest(function() {
	            if (!newScopeDigesting) {
	              newScope.$digest();
	            }
	
	            scopeDigesting = newScopeDigesting = false;
	          });
	        });
	
	        newScope.$watch(function() {
	          newScopeDigesting = true;
	        });
	      }
	    };
	  }
	}
	})();
	(function(){
	"use strict";
	
	
	MdHighlightCtrl.$inject = ["$scope", "$element", "$attrs"];angular
	    .module('material.components.autocomplete')
	    .controller('MdHighlightCtrl', MdHighlightCtrl);
	
	function MdHighlightCtrl ($scope, $element, $attrs) {
	  this.$scope = $scope;
	  this.$element = $element;
	  this.$attrs = $attrs;
	
	  // Cache the Regex to avoid rebuilding each time.
	  this.regex = null;
	}
	
	MdHighlightCtrl.prototype.init = function(unsafeTermFn, unsafeContentFn) {
	
	  this.flags = this.$attrs.mdHighlightFlags || '';
	
	  this.unregisterFn = this.$scope.$watch(function($scope) {
	    return {
	      term: unsafeTermFn($scope),
	      contentText: unsafeContentFn($scope)
	    };
	  }.bind(this), this.onRender.bind(this), true);
	
	  this.$element.on('$destroy', this.unregisterFn);
	};
	
	/**
	 * Triggered once a new change has been recognized and the highlighted
	 * text needs to be updated.
	 */
	MdHighlightCtrl.prototype.onRender = function(state, prevState) {
	
	  var contentText = state.contentText;
	
	  /* Update the regex if it's outdated, because we don't want to rebuilt it constantly. */
	  if (this.regex === null || state.term !== prevState.term) {
	    this.regex = this.createRegex(state.term, this.flags);
	  }
	
	  /* If a term is available apply the regex to the content */
	  if (state.term) {
	    this.applyRegex(contentText);
	  } else {
	    this.$element.text(contentText);
	  }
	
	};
	
	/**
	 * Decomposes the specified text into different tokens (whether match or not).
	 * Breaking down the string guarantees proper XSS protection due to the native browser
	 * escaping of unsafe text.
	 */
	MdHighlightCtrl.prototype.applyRegex = function(text) {
	  var tokens = this.resolveTokens(text);
	
	  this.$element.empty();
	
	  tokens.forEach(function (token) {
	
	    if (token.isMatch) {
	      var tokenEl = angular.element('<span class="highlight">').text(token.text);
	
	      this.$element.append(tokenEl);
	    } else {
	      this.$element.append(document.createTextNode(token));
	    }
	
	  }.bind(this));
	
	};
	
	  /**
	 * Decomposes the specified text into different tokens by running the regex against the text.
	 */
	MdHighlightCtrl.prototype.resolveTokens = function(string) {
	  var tokens = [];
	  var lastIndex = 0;
	
	  // Use replace here, because it supports global and single regular expressions at same time.
	  string.replace(this.regex, function(match, index) {
	    appendToken(lastIndex, index);
	
	    tokens.push({
	      text: match,
	      isMatch: true
	    });
	
	    lastIndex = index + match.length;
	  });
	
	  // Append the missing text as a token.
	  appendToken(lastIndex);
	
	  return tokens;
	
	  function appendToken(from, to) {
	    var targetText = string.slice(from, to);
	    targetText && tokens.push(targetText);
	  }
	};
	
	/** Creates a regex for the specified text with the given flags. */
	MdHighlightCtrl.prototype.createRegex = function(term, flags) {
	  var startFlag = '', endFlag = '';
	  var regexTerm = this.sanitizeRegex(term);
	
	  if (flags.indexOf('^') >= 0) startFlag = '^';
	  if (flags.indexOf('$') >= 0) endFlag = '$';
	
	  return new RegExp(startFlag + regexTerm + endFlag, flags.replace(/[$\^]/g, ''));
	};
	
	/** Sanitizes a regex by removing all common RegExp identifiers */
	MdHighlightCtrl.prototype.sanitizeRegex = function(term) {
	  return term && term.toString().replace(/[\\\^\$\*\+\?\.\(\)\|\{}\[\]]/g, '\\$&');
	};
	
	})();
	(function(){
	"use strict";
	
	
	MdHighlight.$inject = ["$interpolate", "$parse"];angular
	    .module('material.components.autocomplete')
	    .directive('mdHighlightText', MdHighlight);
	
	/**
	 * @ngdoc directive
	 * @name mdHighlightText
	 * @module material.components.autocomplete
	 *
	 * @description
	 * The `md-highlight-text` directive allows you to specify text that should be highlighted within
	 *     an element.  Highlighted text will be wrapped in `<span class="highlight"></span>` which can
	 *     be styled through CSS.  Please note that child elements may not be used with this directive.
	 *
	 * @param {string} md-highlight-text A model to be searched for
	 * @param {string=} md-highlight-flags A list of flags (loosely based on JavaScript RexExp flags).
	 * #### **Supported flags**:
	 * - `g`: Find all matches within the provided text
	 * - `i`: Ignore case when searching for matches
	 * - `$`: Only match if the text ends with the search term
	 * - `^`: Only match if the text begins with the search term
	 *
	 * @usage
	 * <hljs lang="html">
	 * <input placeholder="Enter a search term..." ng-model="searchTerm" type="text" />
	 * <ul>
	 *   <li ng-repeat="result in results" md-highlight-text="searchTerm">
	 *     {{result.text}}
	 *   </li>
	 * </ul>
	 * </hljs>
	 */
	
	function MdHighlight ($interpolate, $parse) {
	  return {
	    terminal: true,
	    controller: 'MdHighlightCtrl',
	    compile: function mdHighlightCompile(tElement, tAttr) {
	      var termExpr = $parse(tAttr.mdHighlightText);
	      var unsafeContentExpr = $interpolate(tElement.html());
	
	      return function mdHighlightLink(scope, element, attr, ctrl) {
	        ctrl.init(termExpr, unsafeContentExpr);
	      };
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdChipCtrl.$inject = ["$scope", "$element", "$mdConstant", "$timeout", "$mdUtil"];angular
	  .module('material.components.chips')
	  .controller('MdChipCtrl', MdChipCtrl);
	
	/**
	 * Controller for the MdChip component. Responsible for handling keyboard
	 * events and editting the chip if needed.
	 *
	 * @param $scope
	 * @param $element
	 * @param $mdConstant
	 * @param $timeout
	 * @param $mdUtil
	 * @constructor
	 */
	function MdChipCtrl ($scope, $element, $mdConstant, $timeout, $mdUtil) {
	  /**
	   * @type {$scope}
	   */
	  this.$scope = $scope;
	
	  /**
	   * @type {$element}
	   */
	  this.$element = $element;
	
	  /**
	   * @type {$mdConstant}
	   */
	  this.$mdConstant = $mdConstant;
	
	  /**
	   * @type {$timeout}
	   */
	  this.$timeout = $timeout;
	
	  /**
	   * @type {$mdUtil}
	   */
	  this.$mdUtil = $mdUtil;
	
	  /**
	   * @type {boolean}
	   */
	  this.isEditting = false;
	
	  /**
	   * @type {MdChipsCtrl}
	   */
	  this.parentController = undefined;
	
	  /**
	   * @type {boolean}
	   */
	  this.enableChipEdit = false;
	}
	
	
	/**
	 * @param {MdChipsCtrl} controller
	 */
	MdChipCtrl.prototype.init = function(controller) {
	  this.parentController = controller;
	  this.enableChipEdit = this.parentController.enableChipEdit;
	
	  if (this.enableChipEdit) {
	    this.$element.on('keydown', this.chipKeyDown.bind(this));
	    this.$element.on('mousedown', this.chipMouseDown.bind(this));
	    this.getChipContent().addClass('_md-chip-content-edit-is-enabled');
	  }
	};
	
	
	/**
	 * @return {Object}
	 */
	MdChipCtrl.prototype.getChipContent = function() {
	  var chipContents = this.$element[0].getElementsByClassName('md-chip-content');
	  return angular.element(chipContents[0]);
	};
	
	
	/**
	 * @return {Object}
	 */
	MdChipCtrl.prototype.getContentElement = function() {
	  return angular.element(this.getChipContent().children()[0]);
	};
	
	
	/**
	 * @return {number}
	 */
	MdChipCtrl.prototype.getChipIndex = function() {
	  return parseInt(this.$element.attr('index'));
	};
	
	
	/**
	 * Presents an input element to edit the contents of the chip.
	 */
	MdChipCtrl.prototype.goOutOfEditMode = function() {
	  if (!this.isEditting) return;
	
	  this.isEditting = false;
	  this.$element.removeClass('_md-chip-editing');
	  this.getChipContent()[0].contentEditable = 'false';
	  var chipIndex = this.getChipIndex();
	
	  var content = this.getContentElement().text();
	  if (content) {
	    this.parentController.updateChipContents(
	        chipIndex,
	        this.getContentElement().text()
	    );
	
	    this.$mdUtil.nextTick(function() {
	      if (this.parentController.selectedChip === chipIndex) {
	        this.parentController.focusChip(chipIndex);
	      }
	    }.bind(this));
	  } else {
	    this.parentController.removeChipAndFocusInput(chipIndex);
	  }
	};
	
	
	/**
	 * Given an HTML element. Selects contents of it.
	 * @param node
	 */
	MdChipCtrl.prototype.selectNodeContents = function(node) {
	  var range, selection;
	  if (document.body.createTextRange) {
	    range = document.body.createTextRange();
	    range.moveToElementText(node);
	    range.select();
	  } else if (window.getSelection) {
	    selection = window.getSelection();
	    range = document.createRange();
	    range.selectNodeContents(node);
	    selection.removeAllRanges();
	    selection.addRange(range);
	  }
	};
	
	
	/**
	 * Presents an input element to edit the contents of the chip.
	 */
	MdChipCtrl.prototype.goInEditMode = function() {
	  this.isEditting = true;
	  this.$element.addClass('_md-chip-editing');
	  this.getChipContent()[0].contentEditable = 'true';
	  this.getChipContent().on('blur', function() {
	    this.goOutOfEditMode();
	  }.bind(this));
	
	  this.selectNodeContents(this.getChipContent()[0]);
	};
	
	
	/**
	 * Handles the keydown event on the chip element. If enable-chip-edit attribute is
	 * set to true, space or enter keys can trigger going into edit mode. Enter can also
	 * trigger submitting if the chip is already being edited.
	 * @param event
	 */
	MdChipCtrl.prototype.chipKeyDown = function(event) {
	  if (!this.isEditting &&
	    (event.keyCode === this.$mdConstant.KEY_CODE.ENTER ||
	    event.keyCode === this.$mdConstant.KEY_CODE.SPACE)) {
	    event.preventDefault();
	    this.goInEditMode();
	  } else if (this.isEditting &&
	    event.keyCode === this.$mdConstant.KEY_CODE.ENTER) {
	    event.preventDefault();
	    this.goOutOfEditMode();
	  }
	};
	
	
	/**
	 * Handles the double click event
	 */
	MdChipCtrl.prototype.chipMouseDown = function() {
	  if(this.getChipIndex() == this.parentController.selectedChip &&
	    this.enableChipEdit &&
	    !this.isEditting) {
	    this.goInEditMode();
	  }
	};
	
	})();
	(function(){
	"use strict";
	
	
	MdChip.$inject = ["$mdTheming", "$mdUtil", "$compile", "$timeout"];angular
	  .module('material.components.chips')
	  .directive('mdChip', MdChip);
	
	/**
	 * @ngdoc directive
	 * @name mdChip
	 * @module material.components.chips
	 *
	 * @description
	 * `<md-chip>` is a component used within `<md-chips>` and is responsible for rendering individual
	 * chips.
	 *
	 *
	 * @usage
	 * <hljs lang="html">
	 *   <md-chip>{{$chip}}</md-chip>
	 * </hljs>
	 *
	 */
	
	// This hint text is hidden within a chip but used by screen readers to
	// inform the user how they can interact with a chip.
	var DELETE_HINT_TEMPLATE = '\
	    <span ng-if="!$mdChipsCtrl.readonly" class="md-visually-hidden">\
	      {{$mdChipsCtrl.deleteHint}}\
	    </span>';
	
	/**
	 * MDChip Directive Definition
	 *
	 * @param $mdTheming
	 * @param $mdUtil
	 * @ngInject
	 */
	function MdChip($mdTheming, $mdUtil, $compile, $timeout) {
	  var deleteHintTemplate = $mdUtil.processTemplate(DELETE_HINT_TEMPLATE);
	
	  return {
	    restrict: 'E',
	    require: ['^?mdChips', 'mdChip'],
	    link: postLink,
	    controller: 'MdChipCtrl'
	  };
	
	  function postLink(scope, element, attr, ctrls) {
	    var chipsController = ctrls.shift();
	    var chipController = ctrls.shift();
	    var chipContentElement = angular.element(element[0].querySelector('.md-chip-content'));
	
	    $mdTheming(element);
	
	    if (chipsController) {
	      chipController.init(chipsController);
	
	      // Append our delete hint to the div.md-chip-content (which does not exist at compile time)
	      chipContentElement.append($compile(deleteHintTemplate)(scope));
	
	      // When a chip is blurred, make sure to unset (or reset) the selected chip so that tabbing
	      // through elements works properly
	      chipContentElement.on('blur', function() {
	        chipsController.resetSelectedChip();
	        chipsController.$scope.$applyAsync();
	      });
	    }
	
	    // Use $timeout to ensure we run AFTER the element has been added to the DOM so we can focus it.
	    $timeout(function() {
	      if (!chipsController) {
	        return;
	      }
	
	      if (chipsController.shouldFocusLastChip) {
	        chipsController.focusLastChipThenInput();
	      }
	    });
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdChipRemove.$inject = ["$timeout"];angular
	    .module('material.components.chips')
	    .directive('mdChipRemove', MdChipRemove);
	
	/**
	 * @ngdoc directive
	 * @name mdChipRemove
	 * @restrict A
	 * @module material.components.chips
	 *
	 * @description
	 * Designates an element to be used as the delete button for a chip. <br/>
	 * This element is passed as a child of the `md-chips` element.
	 *
	 * The designated button will be just appended to the chip and removes the given chip on click.<br/>
	 * By default the button is not being styled by the `md-chips` component.
	 *
	 * @usage
	 * <hljs lang="html">
	 *   <md-chips>
	 *     <button md-chip-remove="">
	 *       <md-icon md-svg-icon="md-close"></md-icon>
	 *     </button>
	 *   </md-chips>
	 * </hljs>
	 */
	
	
	/**
	 * MdChipRemove Directive Definition.
	 * 
	 * @param $timeout
	 * @returns {{restrict: string, require: string[], link: Function, scope: boolean}}
	 * @constructor
	 */
	function MdChipRemove ($timeout) {
	  return {
	    restrict: 'A',
	    require: '^mdChips',
	    scope: false,
	    link: postLink
	  };
	
	  function postLink(scope, element, attr, ctrl) {
	    element.on('click', function(event) {
	      scope.$apply(function() {
	        ctrl.removeChip(scope.$$replacedScope.$index);
	      });
	    });
	
	    // Child elements aren't available until after a $timeout tick as they are hidden by an
	    // `ng-if`. see http://goo.gl/zIWfuw
	    $timeout(function() {
	      element.attr({ tabindex: -1, 'aria-hidden': true });
	      element.find('button').attr('tabindex', '-1');
	    });
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdChipTransclude.$inject = ["$compile"];angular
	    .module('material.components.chips')
	    .directive('mdChipTransclude', MdChipTransclude);
	
	function MdChipTransclude ($compile) {
	  return {
	    restrict: 'EA',
	    terminal: true,
	    link: link,
	    scope: false
	  };
	  function link (scope, element, attr) {
	    var ctrl = scope.$parent.$mdChipsCtrl,
	        newScope = ctrl.parent.$new(false, ctrl.parent);
	    newScope.$$replacedScope = scope;
	    newScope.$chip = scope.$chip;
	    newScope.$index = scope.$index;
	    newScope.$mdChipsCtrl = ctrl;
	
	    var newHtml = ctrl.$scope.$eval(attr.mdChipTransclude);
	
	    element.html(newHtml);
	    $compile(element.contents())(newScope);
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * The default chip append delay.
	 *
	 * @type {number}
	 */
	MdChipsCtrl.$inject = ["$scope", "$attrs", "$mdConstant", "$log", "$element", "$timeout", "$mdUtil"];
	var DEFAULT_CHIP_APPEND_DELAY = 300;
	
	angular
	    .module('material.components.chips')
	    .controller('MdChipsCtrl', MdChipsCtrl);
	
	/**
	 * Controller for the MdChips component. Responsible for adding to and
	 * removing from the list of chips, marking chips as selected, and binding to
	 * the models of various input components.
	 *
	 * @param $scope
	 * @param $attrs
	 * @param $mdConstant
	 * @param $log
	 * @param $element
	 * @param $timeout
	 * @param $mdUtil
	 * @constructor
	 */
	function MdChipsCtrl ($scope, $attrs, $mdConstant, $log, $element, $timeout, $mdUtil) {
	  /** @type {$timeout} **/
	  this.$timeout = $timeout;
	
	  /** @type {Object} */
	  this.$mdConstant = $mdConstant;
	
	  /** @type {angular.$scope} */
	  this.$scope = $scope;
	
	  /** @type {angular.$scope} */
	  this.parent = $scope.$parent;
	
	  /** @type {$mdUtil} */
	  this.$mdUtil = $mdUtil;
	
	  /** @type {$log} */
	  this.$log = $log;
	
	  /** @type {$element} */
	  this.$element = $element;
	
	  /** @type {$attrs} */
	  this.$attrs = $attrs;
	
	  /** @type {angular.NgModelController} */
	  this.ngModelCtrl = null;
	
	  /** @type {angular.NgModelController} */
	  this.userInputNgModelCtrl = null;
	
	  /** @type {MdAutocompleteCtrl} */
	  this.autocompleteCtrl = null;
	
	  /** @type {Element} */
	  this.userInputElement = null;
	
	  /** @type {Array.<Object>} */
	  this.items = [];
	
	  /** @type {number} */
	  this.selectedChip = -1;
	
	  /** @type {string} */
	  this.enableChipEdit = $mdUtil.parseAttributeBoolean($attrs.mdEnableChipEdit);
	
	  /** @type {string} */
	  this.addOnBlur = $mdUtil.parseAttributeBoolean($attrs.mdAddOnBlur);
	
	  /**
	   * The text to be used as the aria-label for the input.
	   * @type {string}
	   */
	  this.inputAriaLabel = 'Chips input.';
	
	  /**
	   * Hidden hint text to describe the chips container. Used to give context to screen readers when
	   * the chips are readonly and the input cannot be selected.
	   *
	   * @type {string}
	   */
	  this.containerHint = 'Chips container. Use arrow keys to select chips.';
	
	  /**
	   * Hidden hint text for how to delete a chip. Used to give context to screen readers.
	   * @type {string}
	   */
	  this.deleteHint = 'Press delete to remove this chip.';
	
	  /**
	   * Hidden label for the delete button. Used to give context to screen readers.
	   * @type {string}
	   */
	  this.deleteButtonLabel = 'Remove';
	
	  /**
	   * Model used by the input element.
	   * @type {string}
	   */
	  this.chipBuffer = '';
	
	  /**
	   * Whether to use the transformChip expression to transform the chip buffer
	   * before appending it to the list.
	   * @type {boolean}
	   */
	  this.useTransformChip = false;
	
	  /**
	   * Whether to use the onAdd expression to notify of chip additions.
	   * @type {boolean}
	   */
	  this.useOnAdd = false;
	
	  /**
	   * Whether to use the onRemove expression to notify of chip removals.
	   * @type {boolean}
	   */
	  this.useOnRemove = false;
	
	  /**
	   * The ID of the chips wrapper which is used to build unique IDs for the chips and the aria-owns
	   * attribute.
	   *
	   * Defaults to '_md-chips-wrapper-' plus a unique number.
	   *
	   * @type {string}
	   */
	  this.wrapperId = '';
	
	  /**
	   * Array of unique numbers which will be auto-generated any time the items change, and is used to
	   * create unique IDs for the aria-owns attribute.
	   *
	   * @type {Array}
	   */
	  this.contentIds = [];
	
	  /**
	   * The index of the chip that should have it's tabindex property set to 0 so it is selectable
	   * via the keyboard.
	   *
	   * @type {int}
	   */
	  this.ariaTabIndex = null;
	
	  /**
	   * After appending a chip, the chip will be focused for this number of milliseconds before the
	   * input is refocused.
	   *
	   * **Note:** This is **required** for compatibility with certain screen readers in order for
	   * them to properly allow keyboard access.
	   *
	   * @type {number}
	   */
	  this.chipAppendDelay = DEFAULT_CHIP_APPEND_DELAY;
	
	  this.init();
	}
	
	/**
	 * Initializes variables and sets up watchers
	 */
	MdChipsCtrl.prototype.init = function() {
	  var ctrl = this;
	
	  // Set the wrapper ID
	  ctrl.wrapperId = '_md-chips-wrapper-' + ctrl.$mdUtil.nextUid();
	
	  // Setup a watcher which manages the role and aria-owns attributes
	  ctrl.$scope.$watchCollection('$mdChipsCtrl.items', function() {
	    // Make sure our input and wrapper have the correct ARIA attributes
	    ctrl.setupInputAria();
	    ctrl.setupWrapperAria();
	  });
	
	  ctrl.$attrs.$observe('mdChipAppendDelay', function(newValue) {
	    ctrl.chipAppendDelay = parseInt(newValue) || DEFAULT_CHIP_APPEND_DELAY;
	  });
	};
	
	/**
	 * If we have an input, ensure it has the appropriate ARIA attributes.
	 */
	MdChipsCtrl.prototype.setupInputAria = function() {
	  var input = this.$element.find('input');
	
	  // If we have no input, just return
	  if (!input) {
	    return;
	  }
	
	  input.attr('role', 'textbox');
	  input.attr('aria-multiline', true);
	};
	
	/**
	 * Ensure our wrapper has the appropriate ARIA attributes.
	 */
	MdChipsCtrl.prototype.setupWrapperAria = function() {
	  var ctrl = this,
	      wrapper = this.$element.find('md-chips-wrap');
	
	  if (this.items && this.items.length) {
	    // Dynamically add the listbox role on every change because it must be removed when there are
	    // no items.
	    wrapper.attr('role', 'listbox');
	
	    // Generate some random (but unique) IDs for each chip
	    this.contentIds = this.items.map(function() {
	      return ctrl.wrapperId + '-chip-' + ctrl.$mdUtil.nextUid();
	    });
	
	    // Use the contentIDs above to generate the aria-owns attribute
	    wrapper.attr('aria-owns', this.contentIds.join(' '));
	  } else {
	    // If we have no items, then the role and aria-owns attributes MUST be removed
	    wrapper.removeAttr('role');
	    wrapper.removeAttr('aria-owns');
	  }
	};
	
	/**
	 * Handles the keydown event on the input element: by default <enter> appends
	 * the buffer to the chip list, while backspace removes the last chip in the
	 * list if the current buffer is empty.
	 * @param event
	 */
	MdChipsCtrl.prototype.inputKeydown = function(event) {
	  var chipBuffer = this.getChipBuffer();
	
	  // If we have an autocomplete, and it handled the event, we have nothing to do
	  if (this.autocompleteCtrl && event.isDefaultPrevented && event.isDefaultPrevented()) {
	    return;
	  }
	
	  if (event.keyCode === this.$mdConstant.KEY_CODE.BACKSPACE) {
	    // Only select and focus the previous chip, if the current caret position of the
	    // input element is at the beginning.
	    if (this.getCursorPosition(event.target) !== 0) {
	      return;
	    }
	
	    event.preventDefault();
	    event.stopPropagation();
	
	    if (this.items.length) {
	      this.selectAndFocusChipSafe(this.items.length - 1);
	    }
	
	    return;
	  }
	
	  // By default <enter> appends the buffer to the chip list.
	  if (!this.separatorKeys || this.separatorKeys.length < 1) {
	    this.separatorKeys = [this.$mdConstant.KEY_CODE.ENTER];
	  }
	
	  // Support additional separator key codes in an array of `md-separator-keys`.
	  if (this.separatorKeys.indexOf(event.keyCode) !== -1) {
	    if ((this.autocompleteCtrl && this.requireMatch) || !chipBuffer) return;
	    event.preventDefault();
	
	    // Only append the chip and reset the chip buffer if the max chips limit isn't reached.
	    if (this.hasMaxChipsReached()) return;
	
	    this.appendChip(chipBuffer.trim());
	    this.resetChipBuffer();
	
	    return false;
	  }
	};
	
	/**
	 * Returns the cursor position of the specified input element.
	 * @param element HTMLInputElement
	 * @returns {Number} Cursor Position of the input.
	 */
	MdChipsCtrl.prototype.getCursorPosition = function(element) {
	  /*
	   * Figure out whether the current input for the chips buffer is valid for using
	   * the selectionStart / end property to retrieve the cursor position.
	   * Some browsers do not allow the use of those attributes, on different input types.
	   */
	  try {
	    if (element.selectionStart === element.selectionEnd) {
	      return element.selectionStart;
	    }
	  } catch (e) {
	    if (!element.value) {
	      return 0;
	    }
	  }
	};
	
	
	/**
	 * Updates the content of the chip at given index
	 * @param chipIndex
	 * @param chipContents
	 */
	MdChipsCtrl.prototype.updateChipContents = function(chipIndex, chipContents){
	  if(chipIndex >= 0 && chipIndex < this.items.length) {
	    this.items[chipIndex] = chipContents;
	    this.ngModelCtrl.$setDirty();
	  }
	};
	
	
	/**
	 * Returns true if a chip is currently being edited. False otherwise.
	 * @return {boolean}
	 */
	MdChipsCtrl.prototype.isEditingChip = function() {
	  return !!this.$element[0].querySelector('._md-chip-editing');
	};
	
	
	MdChipsCtrl.prototype.isRemovable = function() {
	  // Return false if we have static chips
	  if (!this.ngModelCtrl) {
	    return false;
	  }
	
	  return this.readonly ? this.removable :
	         angular.isDefined(this.removable) ? this.removable : true;
	};
	
	/**
	 * Handles the keydown event on the chip elements: backspace removes the selected chip, arrow
	 * keys switch which chips is active
	 * @param event
	 */
	MdChipsCtrl.prototype.chipKeydown = function (event) {
	  if (this.getChipBuffer()) return;
	  if (this.isEditingChip()) return;
	
	  switch (event.keyCode) {
	    case this.$mdConstant.KEY_CODE.BACKSPACE:
	    case this.$mdConstant.KEY_CODE.DELETE:
	      if (this.selectedChip < 0) return;
	      event.preventDefault();
	      // Cancel the delete action only after the event cancel. Otherwise the page will go back.
	      if (!this.isRemovable()) return;
	      this.removeAndSelectAdjacentChip(this.selectedChip);
	      break;
	    case this.$mdConstant.KEY_CODE.LEFT_ARROW:
	      event.preventDefault();
	      // By default, allow selection of -1 which will focus the input; if we're readonly, don't go
	      // below 0
	      if (this.selectedChip < 0 || (this.readonly && this.selectedChip == 0)) {
	        this.selectedChip = this.items.length;
	      }
	      if (this.items.length) this.selectAndFocusChipSafe(this.selectedChip - 1);
	      break;
	    case this.$mdConstant.KEY_CODE.RIGHT_ARROW:
	      event.preventDefault();
	      this.selectAndFocusChipSafe(this.selectedChip + 1);
	      break;
	    case this.$mdConstant.KEY_CODE.ESCAPE:
	    case this.$mdConstant.KEY_CODE.TAB:
	      if (this.selectedChip < 0) return;
	      event.preventDefault();
	      this.onFocus();
	      break;
	  }
	};
	
	/**
	 * Get the input's placeholder - uses `placeholder` when list is empty and `secondary-placeholder`
	 * when the list is non-empty. If `secondary-placeholder` is not provided, `placeholder` is used
	 * always.
	 */
	MdChipsCtrl.prototype.getPlaceholder = function() {
	  // Allow `secondary-placeholder` to be blank.
	  var useSecondary = (this.items && this.items.length &&
	      (this.secondaryPlaceholder == '' || this.secondaryPlaceholder));
	  return useSecondary ? this.secondaryPlaceholder : this.placeholder;
	};
	
	/**
	 * Removes chip at {@code index} and selects the adjacent chip.
	 * @param index
	 */
	MdChipsCtrl.prototype.removeAndSelectAdjacentChip = function(index) {
	  var self = this;
	  var selIndex = self.getAdjacentChipIndex(index);
	  var wrap = this.$element[0].querySelector('md-chips-wrap');
	  var chip = this.$element[0].querySelector('md-chip[index="' + index + '"]');
	
	  self.removeChip(index);
	
	  // The dobule-timeout is currently necessary to ensure that the DOM has finalized and the select()
	  // will find the proper chip since the selection is index-based.
	  //
	  // TODO: Investigate calling from within chip $scope.$on('$destroy') to reduce/remove timeouts
	  self.$timeout(function() {
	    self.$timeout(function() {
	      self.selectAndFocusChipSafe(selIndex);
	    });
	  });
	};
	
	/**
	 * Sets the selected chip index to -1.
	 */
	MdChipsCtrl.prototype.resetSelectedChip = function() {
	  this.selectedChip = -1;
	  this.ariaTabIndex = null;
	};
	
	/**
	 * Gets the index of an adjacent chip to select after deletion. Adjacency is
	 * determined as the next chip in the list, unless the target chip is the
	 * last in the list, then it is the chip immediately preceding the target. If
	 * there is only one item in the list, -1 is returned (select none).
	 * The number returned is the index to select AFTER the target has been
	 * removed.
	 * If the current chip is not selected, then -1 is returned to select none.
	 */
	MdChipsCtrl.prototype.getAdjacentChipIndex = function(index) {
	  var len = this.items.length - 1;
	  return (len == 0) ? -1 :
	      (index == len) ? index -1 : index;
	};
	
	/**
	 * Append the contents of the buffer to the chip list. This method will first
	 * call out to the md-transform-chip method, if provided.
	 *
	 * @param newChip
	 */
	MdChipsCtrl.prototype.appendChip = function(newChip) {
	  this.shouldFocusLastChip = true;
	  if (this.useTransformChip && this.transformChip) {
	    var transformedChip = this.transformChip({'$chip': newChip});
	
	    // Check to make sure the chip is defined before assigning it, otherwise, we'll just assume
	    // they want the string version.
	    if (angular.isDefined(transformedChip)) {
	      newChip = transformedChip;
	    }
	  }
	
	  // If items contains an identical object to newChip, do not append
	  if (angular.isObject(newChip)){
	    var identical = this.items.some(function(item){
	      return angular.equals(newChip, item);
	    });
	    if (identical) return;
	  }
	
	  // Check for a null (but not undefined), or existing chip and cancel appending
	  if (newChip == null || this.items.indexOf(newChip) + 1) return;
	
	  // Append the new chip onto our list
	  var length = this.items.push(newChip);
	  var index = length - 1;
	
	  // Update model validation
	  this.ngModelCtrl.$setDirty();
	  this.validateModel();
	
	  // If they provide the md-on-add attribute, notify them of the chip addition
	  if (this.useOnAdd && this.onAdd) {
	    this.onAdd({ '$chip': newChip, '$index': index });
	  }
	};
	
	/**
	 * Sets whether to use the md-transform-chip expression. This expression is
	 * bound to scope and controller in {@code MdChipsDirective} as
	 * {@code transformChip}. Due to the nature of directive scope bindings, the
	 * controller cannot know on its own/from the scope whether an expression was
	 * actually provided.
	 */
	MdChipsCtrl.prototype.useTransformChipExpression = function() {
	  this.useTransformChip = true;
	};
	
	/**
	 * Sets whether to use the md-on-add expression. This expression is
	 * bound to scope and controller in {@code MdChipsDirective} as
	 * {@code onAdd}. Due to the nature of directive scope bindings, the
	 * controller cannot know on its own/from the scope whether an expression was
	 * actually provided.
	 */
	MdChipsCtrl.prototype.useOnAddExpression = function() {
	  this.useOnAdd = true;
	};
	
	/**
	 * Sets whether to use the md-on-remove expression. This expression is
	 * bound to scope and controller in {@code MdChipsDirective} as
	 * {@code onRemove}. Due to the nature of directive scope bindings, the
	 * controller cannot know on its own/from the scope whether an expression was
	 * actually provided.
	 */
	MdChipsCtrl.prototype.useOnRemoveExpression = function() {
	  this.useOnRemove = true;
	};
	
	/*
	 * Sets whether to use the md-on-select expression. This expression is
	 * bound to scope and controller in {@code MdChipsDirective} as
	 * {@code onSelect}. Due to the nature of directive scope bindings, the
	 * controller cannot know on its own/from the scope whether an expression was
	 * actually provided.
	 */
	MdChipsCtrl.prototype.useOnSelectExpression = function() {
	  this.useOnSelect = true;
	};
	
	/**
	 * Gets the input buffer. The input buffer can be the model bound to the
	 * default input item {@code this.chipBuffer}, the {@code selectedItem}
	 * model of an {@code md-autocomplete}, or, through some magic, the model
	 * bound to any inpput or text area element found within a
	 * {@code md-input-container} element.
	 * @return {string}
	 */
	MdChipsCtrl.prototype.getChipBuffer = function() {
	  var chipBuffer =  !this.userInputElement ? this.chipBuffer :
	                     this.userInputNgModelCtrl ? this.userInputNgModelCtrl.$viewValue :
	                     this.userInputElement[0].value;
	
	  // Ensure that the chip buffer is always a string. For example, the input element buffer might be falsy.
	  return angular.isString(chipBuffer) ? chipBuffer : '';
	};
	
	/**
	 * Resets the input buffer for either the internal input or user provided input element.
	 */
	MdChipsCtrl.prototype.resetChipBuffer = function() {
	  if (this.userInputElement) {
	    if (this.userInputNgModelCtrl) {
	      this.userInputNgModelCtrl.$setViewValue('');
	      this.userInputNgModelCtrl.$render();
	    } else {
	      this.userInputElement[0].value = '';
	    }
	  } else {
	    this.chipBuffer = '';
	  }
	};
	
	MdChipsCtrl.prototype.hasMaxChipsReached = function() {
	  if (angular.isString(this.maxChips)) this.maxChips = parseInt(this.maxChips, 10) || 0;
	
	  return this.maxChips > 0 && this.items.length >= this.maxChips;
	};
	
	/**
	 * Updates the validity properties for the ngModel.
	 */
	MdChipsCtrl.prototype.validateModel = function() {
	  this.ngModelCtrl.$setValidity('md-max-chips', !this.hasMaxChipsReached());
	};
	
	/**
	 * Removes the chip at the given index.
	 * @param index
	 */
	MdChipsCtrl.prototype.removeChip = function(index) {
	  var removed = this.items.splice(index, 1);
	
	  // Update model validation
	  this.ngModelCtrl.$setDirty();
	  this.validateModel();
	
	  if (removed && removed.length && this.useOnRemove && this.onRemove) {
	    this.onRemove({ '$chip': removed[0], '$index': index });
	  }
	};
	
	MdChipsCtrl.prototype.removeChipAndFocusInput = function (index) {
	  this.removeChip(index);
	
	  if (this.autocompleteCtrl) {
	    // Always hide the autocomplete dropdown before focusing the autocomplete input.
	    // Wait for the input to move horizontally, because the chip was removed.
	    // This can lead to an incorrect dropdown position.
	    this.autocompleteCtrl.hidden = true;
	    this.$mdUtil.nextTick(this.onFocus.bind(this));
	  } else {
	    this.onFocus();
	  }
	
	};
	/**
	 * Selects the chip at `index`,
	 * @param index
	 */
	MdChipsCtrl.prototype.selectAndFocusChipSafe = function(index) {
	  // If we have no chips, or are asked to select a chip before the first, just focus the input
	  if (!this.items.length || index === -1) {
	    return this.focusInput();
	  }
	
	  // If we are asked to select a chip greater than the number of chips...
	  if (index >= this.items.length) {
	    if (this.readonly) {
	      // If we are readonly, jump back to the start (because we have no input)
	      index = 0;
	    } else {
	      // If we are not readonly, we should attempt to focus the input
	      return this.onFocus();
	    }
	  }
	
	  index = Math.max(index, 0);
	  index = Math.min(index, this.items.length - 1);
	
	  this.selectChip(index);
	  this.focusChip(index);
	};
	
	MdChipsCtrl.prototype.focusLastChipThenInput = function() {
	  var ctrl = this;
	
	  ctrl.shouldFocusLastChip = false;
	
	  ctrl.focusChip(this.items.length - 1);
	
	  ctrl.$timeout(function() {
	    ctrl.focusInput();
	  }, ctrl.chipAppendDelay);
	};
	
	MdChipsCtrl.prototype.focusInput = function() {
	  this.selectChip(-1);
	  this.onFocus();
	};
	
	/**
	 * Marks the chip at the given index as selected.
	 * @param index
	 */
	MdChipsCtrl.prototype.selectChip = function(index) {
	  if (index >= -1 && index <= this.items.length) {
	    this.selectedChip = index;
	
	    // Fire the onSelect if provided
	    if (this.useOnSelect && this.onSelect) {
	      this.onSelect({'$chip': this.items[index] });
	    }
	  } else {
	    this.$log.warn('Selected Chip index out of bounds; ignoring.');
	  }
	};
	
	/**
	 * Selects the chip at `index` and gives it focus.
	 * @param index
	 */
	MdChipsCtrl.prototype.selectAndFocusChip = function(index) {
	  this.selectChip(index);
	  if (index != -1) {
	    this.focusChip(index);
	  }
	};
	
	/**
	 * Call `focus()` on the chip at `index`
	 */
	MdChipsCtrl.prototype.focusChip = function(index) {
	  var chipContent = this.$element[0].querySelector('md-chip[index="' + index + '"] .md-chip-content');
	
	  this.ariaTabIndex = index;
	
	  chipContent.focus();
	};
	
	/**
	 * Configures the required interactions with the ngModel Controller.
	 * Specifically, set {@code this.items} to the {@code NgModelCtrl#$viewVale}.
	 * @param ngModelCtrl
	 */
	MdChipsCtrl.prototype.configureNgModel = function(ngModelCtrl) {
	  this.ngModelCtrl = ngModelCtrl;
	
	  var self = this;
	  ngModelCtrl.$render = function() {
	    // model is updated. do something.
	    self.items = self.ngModelCtrl.$viewValue;
	  };
	};
	
	MdChipsCtrl.prototype.onFocus = function () {
	  var input = this.$element[0].querySelector('input');
	  input && input.focus();
	  this.resetSelectedChip();
	};
	
	MdChipsCtrl.prototype.onInputFocus = function () {
	  this.inputHasFocus = true;
	
	  // Make sure we have the appropriate ARIA attributes
	  this.setupInputAria();
	
	  // Make sure we don't have any chips selected
	  this.resetSelectedChip();
	};
	
	MdChipsCtrl.prototype.onInputBlur = function () {
	  this.inputHasFocus = false;
	
	  if (this.shouldAddOnBlur()) {
	    this.appendChip(this.getChipBuffer().trim());
	    this.resetChipBuffer();
	  }
	};
	
	/**
	 * Configure event bindings on a user-provided input element.
	 * @param inputElement
	 */
	MdChipsCtrl.prototype.configureUserInput = function(inputElement) {
	  this.userInputElement = inputElement;
	
	  // Find the NgModelCtrl for the input element
	  var ngModelCtrl = inputElement.controller('ngModel');
	  // `.controller` will look in the parent as well.
	  if (ngModelCtrl != this.ngModelCtrl) {
	    this.userInputNgModelCtrl = ngModelCtrl;
	  }
	
	  var scope = this.$scope;
	  var ctrl = this;
	
	  // Run all of the events using evalAsync because a focus may fire a blur in the same digest loop
	  var scopeApplyFn = function(event, fn) {
	    scope.$evalAsync(angular.bind(ctrl, fn, event));
	  };
	
	  // Bind to keydown and focus events of input
	  inputElement
	      .attr({ tabindex: 0 })
	      .on('keydown', function(event) { scopeApplyFn(event, ctrl.inputKeydown) })
	      .on('focus', function(event) { scopeApplyFn(event, ctrl.onInputFocus) })
	      .on('blur', function(event) { scopeApplyFn(event, ctrl.onInputBlur) })
	};
	
	MdChipsCtrl.prototype.configureAutocomplete = function(ctrl) {
	  if (ctrl) {
	    this.autocompleteCtrl = ctrl;
	
	    ctrl.registerSelectedItemWatcher(angular.bind(this, function (item) {
	      if (item) {
	        // Only append the chip and reset the chip buffer if the max chips limit isn't reached.
	        if (this.hasMaxChipsReached()) return;
	
	        this.appendChip(item);
	        this.resetChipBuffer();
	      }
	    }));
	
	    this.$element.find('input')
	        .on('focus',angular.bind(this, this.onInputFocus) )
	        .on('blur', angular.bind(this, this.onInputBlur) );
	  }
	};
	
	/**
	 * Whether the current chip buffer should be added on input blur or not.
	 * @returns {boolean}
	 */
	MdChipsCtrl.prototype.shouldAddOnBlur = function() {
	
	  // Update the custom ngModel validators from the chips component.
	  this.validateModel();
	
	  var chipBuffer = this.getChipBuffer().trim();
	  var isModelValid = this.ngModelCtrl.$valid;
	  var isAutocompleteShowing = this.autocompleteCtrl && !this.autocompleteCtrl.hidden;
	
	  if (this.userInputNgModelCtrl) {
	    isModelValid = isModelValid && this.userInputNgModelCtrl.$valid;
	  }
	
	  return this.addOnBlur && !this.requireMatch && chipBuffer && isModelValid && !isAutocompleteShowing;
	};
	
	MdChipsCtrl.prototype.hasFocus = function () {
	  return this.inputHasFocus || this.selectedChip >= 0;
	};
	
	MdChipsCtrl.prototype.contentIdFor = function(index) {
	  return this.contentIds[index];
	};
	
	})();
	(function(){
	"use strict";
	
	  
	  MdChips.$inject = ["$mdTheming", "$mdUtil", "$compile", "$log", "$timeout", "$$mdSvgRegistry"];angular
	      .module('material.components.chips')
	      .directive('mdChips', MdChips);
	
	  /**
	   * @ngdoc directive
	   * @name mdChips
	   * @module material.components.chips
	   *
	   * @description
	   * `<md-chips>` is an input component for building lists of strings or objects. The list items are
	   * displayed as 'chips'. This component can make use of an `<input>` element or an 
	   * `<md-autocomplete>` element.
	   *
	   * ### Custom templates
	   * A custom template may be provided to render the content of each chip. This is achieved by
	   * specifying an `<md-chip-template>` element containing the custom content as a child of
	   * `<md-chips>`.
	   *
	   * Note: Any attributes on
	   * `<md-chip-template>` will be dropped as only the innerHTML is used for the chip template. The
	   * variables `$chip` and `$index` are available in the scope of `<md-chip-template>`, representing
	   * the chip object and its index in the list of chips, respectively.
	   * To override the chip delete control, include an element (ideally a button) with the attribute
	   * `md-chip-remove`. A click listener to remove the chip will be added automatically. The element
	   * is also placed as a sibling to the chip content (on which there are also click listeners) to
	   * avoid a nested ng-click situation.
	   *
	   * <!-- Note: We no longer want to include this in the site docs; but it should remain here for
	   * future developers and those looking at the documentation.
	   *
	   * <h3> Pending Features </h3>
	   * <ul style="padding-left:20px;">
	   *
	   *   <ul>Style
	   *     <li>Colours for hover, press states (ripple?).</li>
	   *   </ul>
	   *
	   *   <ul>Validation
	   *     <li>allow a validation callback</li>
	   *     <li>hilighting style for invalid chips</li>
	   *   </ul>
	   *
	   *   <ul>Item mutation
	   *     <li>Support `
	   *       <md-chip-edit>` template, show/hide the edit element on tap/click? double tap/double
	   *       click?
	   *     </li>
	   *   </ul>
	   *
	   *   <ul>Truncation and Disambiguation (?)
	   *     <li>Truncate chip text where possible, but do not truncate entries such that two are
	   *     indistinguishable.</li>
	   *   </ul>
	   *
	   *   <ul>Drag and Drop
	   *     <li>Drag and drop chips between related `<md-chips>` elements.
	   *     </li>
	   *   </ul>
	   * </ul>
	   *
	   * //-->
	   *
	   * Sometimes developers want to limit the amount of possible chips.<br/>
	   * You can specify the maximum amount of chips by using the following markup.
	   *
	   * <hljs lang="html">
	   *   <md-chips
	   *       ng-model="myItems"
	   *       placeholder="Add an item"
	   *       md-max-chips="5">
	   *   </md-chips>
	   * </hljs>
	   *
	   * In some cases, you have an autocomplete inside of the `md-chips`.<br/>
	   * When the maximum amount of chips has been reached, you can also disable the autocomplete selection.<br/>
	   * Here is an example markup.
	   *
	   * <hljs lang="html">
	   *   <md-chips ng-model="myItems" md-max-chips="5">
	   *     <md-autocomplete ng-hide="myItems.length > 5" ...></md-autocomplete>
	   *   </md-chips>
	   * </hljs>
	   *
	   * ### Accessibility
	   *
	   * The `md-chips` component supports keyboard and screen reader users since Version 1.1.2. In
	   * order to achieve this, we modified the chips behavior to select newly appended chips for
	   * `300ms` before re-focusing the input and allowing the user to type.
	   *
	   * For most users, this delay is small enough that it will not be noticeable but allows certain
	   * screen readers to function properly (JAWS and NVDA in particular).
	   *
	   * We introduced a new `md-chip-append-delay` option to allow developers to better control this
	   * behavior.
	   *
	   * Please refer to the documentation of this option (below) for more information.
	   *
	   * @param {string=|object=} ng-model A model to which the list of items will be bound.
	   * @param {string=} placeholder Placeholder text that will be forwarded to the input.
	   * @param {string=} secondary-placeholder Placeholder text that will be forwarded to the input,
	   *    displayed when there is at least one item in the list
	   * @param {boolean=} md-removable Enables or disables the deletion of chips through the
	   *    removal icon or the Delete/Backspace key. Defaults to true.
	   * @param {boolean=} readonly Disables list manipulation (deleting or adding list items), hiding
	   *    the input and delete buttons. If no `ng-model` is provided, the chips will automatically be
	   *    marked as readonly.<br/><br/>
	   *    When `md-removable` is not defined, the `md-remove` behavior will be overwritten and disabled.
	   * @param {string=} md-enable-chip-edit Set this to "true" to enable editing of chip contents. The user can 
	   *    go into edit mode with pressing "space", "enter", or double clicking on the chip. Chip edit is only
	   *    supported for chips with basic template.
	   * @param {number=} md-max-chips The maximum number of chips allowed to add through user input.
	   *    <br/><br/>The validation property `md-max-chips` can be used when the max chips
	   *    amount is reached.
	   * @param {boolean=} md-add-on-blur When set to true, remaining text inside of the input will
	   *    be converted into a new chip on blur.
	   * @param {expression} md-transform-chip An expression of form `myFunction($chip)` that when called
	   *    expects one of the following return values:
	   *    - an object representing the `$chip` input string
	   *    - `undefined` to simply add the `$chip` input string, or
	   *    - `null` to prevent the chip from being appended
	   * @param {expression=} md-on-add An expression which will be called when a chip has been
	   *    added.
	   * @param {expression=} md-on-remove An expression which will be called when a chip has been
	   *    removed.
	   * @param {expression=} md-on-select An expression which will be called when a chip is selected.
	   * @param {boolean} md-require-match If true, and the chips template contains an autocomplete,
	   *    only allow selection of pre-defined chips (i.e. you cannot add new ones).
	   * @param {string=} input-aria-label A string read by screen readers to identify the input.
	   * @param {string=} container-hint A string read by screen readers informing users of how to
	   *    navigate the chips. Used in readonly mode.
	   * @param {string=} delete-hint A string read by screen readers instructing users that pressing
	   *    the delete key will remove the chip.
	   * @param {string=} delete-button-label A label for the delete button. Also hidden and read by
	   *    screen readers.
	   * @param {expression=} md-separator-keys An array of key codes used to separate chips.
	   * @param {string=} md-chip-append-delay The number of milliseconds that the component will select
	   *    a newly appended chip before allowing a user to type into the input. This is **necessary**
	   *    for keyboard accessibility for screen readers. It defaults to 300ms and any number less than
	   *    300 can cause issues with screen readers (particularly JAWS and sometimes NVDA).
	   *
	   *    _Available since Version 1.1.2._
	   *
	   *    **Note:** You can safely set this to `0` in one of the following two instances:
	   *
	   *    1. You are targeting an iOS or Safari-only application (where users would use VoiceOver) or
	   *    only ChromeVox users.
	   *
	   *    2. If you have utilized the `md-separator-keys` to disable the `enter` keystroke in
	   *    favor of another one (such as `,` or `;`).
	   *
	   * @usage
	   * <hljs lang="html">
	   *   <md-chips
	   *       ng-model="myItems"
	   *       placeholder="Add an item"
	   *       readonly="isReadOnly">
	   *   </md-chips>
	   * </hljs>
	   *
	   * <h3>Validation</h3>
	   * When using [ngMessages](https://docs.angularjs.org/api/ngMessages), you can show errors based
	   * on our custom validators.
	   * <hljs lang="html">
	   *   <form name="userForm">
	   *     <md-chips
	   *       name="fruits"
	   *       ng-model="myItems"
	   *       placeholder="Add an item"
	   *       md-max-chips="5">
	   *     </md-chips>
	   *     <div ng-messages="userForm.fruits.$error" ng-if="userForm.$dirty">
	   *       <div ng-message="md-max-chips">You reached the maximum amount of chips</div>
	   *    </div>
	   *   </form>
	   * </hljs>
	   *
	   */
	
	  var MD_CHIPS_TEMPLATE = '\
	      <md-chips-wrap\
	          id="{{$mdChipsCtrl.wrapperId}}"\
	          tabindex="{{$mdChipsCtrl.readonly ? 0 : -1}}"\
	          ng-keydown="$mdChipsCtrl.chipKeydown($event)"\
	          ng-class="{ \'md-focused\': $mdChipsCtrl.hasFocus(), \
	                      \'md-readonly\': !$mdChipsCtrl.ngModelCtrl || $mdChipsCtrl.readonly,\
	                      \'md-removable\': $mdChipsCtrl.isRemovable() }"\
	          aria-setsize="{{$mdChipsCtrl.items.length}}"\
	          class="md-chips">\
	        <span ng-if="$mdChipsCtrl.readonly" class="md-visually-hidden">\
	          {{$mdChipsCtrl.containerHint}}\
	        </span>\
	        <md-chip ng-repeat="$chip in $mdChipsCtrl.items"\
	            index="{{$index}}"\
	            ng-class="{\'md-focused\': $mdChipsCtrl.selectedChip == $index, \'md-readonly\': !$mdChipsCtrl.ngModelCtrl || $mdChipsCtrl.readonly}">\
	          <div class="md-chip-content"\
	              tabindex="{{$mdChipsCtrl.ariaTabIndex == $index ? 0 : -1}}"\
	              id="{{$mdChipsCtrl.contentIdFor($index)}}"\
	              role="option"\
	              aria-selected="{{$mdChipsCtrl.selectedChip == $index}}" \
	              aria-posinset="{{$index}}"\
	              ng-click="!$mdChipsCtrl.readonly && $mdChipsCtrl.focusChip($index)"\
	              ng-focus="!$mdChipsCtrl.readonly && $mdChipsCtrl.selectChip($index)"\
	              md-chip-transclude="$mdChipsCtrl.chipContentsTemplate"></div>\
	          <div ng-if="$mdChipsCtrl.isRemovable()"\
	               class="md-chip-remove-container"\
	               tabindex="-1"\
	               md-chip-transclude="$mdChipsCtrl.chipRemoveTemplate"></div>\
	        </md-chip>\
	        <div class="md-chip-input-container" ng-if="!$mdChipsCtrl.readonly && $mdChipsCtrl.ngModelCtrl">\
	          <div md-chip-transclude="$mdChipsCtrl.chipInputTemplate"></div>\
	        </div>\
	      </md-chips-wrap>';
	
	  var CHIP_INPUT_TEMPLATE = '\
	        <input\
	            class="md-input"\
	            tabindex="0"\
	            aria-label="{{$mdChipsCtrl.inputAriaLabel}}" \
	            placeholder="{{$mdChipsCtrl.getPlaceholder()}}"\
	            ng-model="$mdChipsCtrl.chipBuffer"\
	            ng-focus="$mdChipsCtrl.onInputFocus()"\
	            ng-blur="$mdChipsCtrl.onInputBlur()"\
	            ng-keydown="$mdChipsCtrl.inputKeydown($event)">';
	
	  var CHIP_DEFAULT_TEMPLATE = '\
	      <span>{{$chip}}</span>';
	
	  var CHIP_REMOVE_TEMPLATE = '\
	      <button\
	          class="md-chip-remove"\
	          ng-if="$mdChipsCtrl.isRemovable()"\
	          ng-click="$mdChipsCtrl.removeChipAndFocusInput($$replacedScope.$index)"\
	          type="button"\
	          tabindex="-1">\
	        <md-icon md-svg-src="{{ $mdChipsCtrl.mdCloseIcon }}"></md-icon>\
	        <span class="md-visually-hidden">\
	          {{$mdChipsCtrl.deleteButtonLabel}}\
	        </span>\
	      </button>';
	
	  /**
	   * MDChips Directive Definition
	   */
	  function MdChips ($mdTheming, $mdUtil, $compile, $log, $timeout, $$mdSvgRegistry) {
	    // Run our templates through $mdUtil.processTemplate() to allow custom start/end symbols
	    var templates = getTemplates();
	
	    return {
	      template: function(element, attrs) {
	        // Clone the element into an attribute. By prepending the attribute
	        // name with '$', AngularJS won't write it into the DOM. The cloned
	        // element propagates to the link function via the attrs argument,
	        // where various contained-elements can be consumed.
	        attrs['$mdUserTemplate'] = element.clone();
	        return templates.chips;
	      },
	      require: ['mdChips'],
	      restrict: 'E',
	      controller: 'MdChipsCtrl',
	      controllerAs: '$mdChipsCtrl',
	      bindToController: true,
	      compile: compile,
	      scope: {
	        readonly: '=readonly',
	        removable: '=mdRemovable',
	        placeholder: '@',
	        secondaryPlaceholder: '@',
	        maxChips: '@mdMaxChips',
	        transformChip: '&mdTransformChip',
	        onAppend: '&mdOnAppend',
	        onAdd: '&mdOnAdd',
	        onRemove: '&mdOnRemove',
	        onSelect: '&mdOnSelect',
	        inputAriaLabel: '@',
	        containerHint: '@',
	        deleteHint: '@',
	        deleteButtonLabel: '@',
	        separatorKeys: '=?mdSeparatorKeys',
	        requireMatch: '=?mdRequireMatch',
	        chipAppendDelayString: '@?mdChipAppendDelay'
	      }
	    };
	
	    /**
	     * Builds the final template for `md-chips` and returns the postLink function.
	     *
	     * Building the template involves 3 key components:
	     * static chips
	     * chip template
	     * input control
	     *
	     * If no `ng-model` is provided, only the static chip work needs to be done.
	     *
	     * If no user-passed `md-chip-template` exists, the default template is used. This resulting
	     * template is appended to the chip content element.
	     *
	     * The remove button may be overridden by passing an element with an md-chip-remove attribute.
	     *
	     * If an `input` or `md-autocomplete` element is provided by the caller, it is set aside for
	     * transclusion later. The transclusion happens in `postLink` as the parent scope is required.
	     * If no user input is provided, a default one is appended to the input container node in the
	     * template.
	     *
	     * Static Chips (i.e. `md-chip` elements passed from the caller) are gathered and set aside for
	     * transclusion in the `postLink` function.
	     *
	     *
	     * @param element
	     * @param attr
	     * @returns {Function}
	     */
	    function compile(element, attr) {
	      // Grab the user template from attr and reset the attribute to null.
	      var userTemplate = attr['$mdUserTemplate'];
	      attr['$mdUserTemplate'] = null;
	
	      var chipTemplate = getTemplateByQuery('md-chips>md-chip-template');
	
	      var chipRemoveSelector = $mdUtil
	        .prefixer()
	        .buildList('md-chip-remove')
	        .map(function(attr) {
	          return 'md-chips>*[' + attr + ']';
	        })
	        .join(',');
	
	      // Set the chip remove, chip contents and chip input templates. The link function will put
	      // them on the scope for transclusion later.
	      var chipRemoveTemplate   = getTemplateByQuery(chipRemoveSelector) || templates.remove,
	          chipContentsTemplate = chipTemplate || templates.default,
	          chipInputTemplate    = getTemplateByQuery('md-chips>md-autocomplete')
	              || getTemplateByQuery('md-chips>input')
	              || templates.input,
	          staticChips = userTemplate.find('md-chip');
	
	      // Warn of malformed template. See #2545
	      if (userTemplate[0].querySelector('md-chip-template>*[md-chip-remove]')) {
	        $log.warn('invalid placement of md-chip-remove within md-chip-template.');
	      }
	
	      function getTemplateByQuery (query) {
	        if (!attr.ngModel) return;
	        var element = userTemplate[0].querySelector(query);
	        return element && element.outerHTML;
	      }
	
	      /**
	       * Configures controller and transcludes.
	       */
	      return function postLink(scope, element, attrs, controllers) {
	        $mdUtil.initOptionalProperties(scope, attr);
	
	        $mdTheming(element);
	        var mdChipsCtrl = controllers[0];
	        if(chipTemplate) {
	          // Chip editing functionality assumes we are using the default chip template.
	          mdChipsCtrl.enableChipEdit = false;
	        }
	
	        mdChipsCtrl.chipContentsTemplate = chipContentsTemplate;
	        mdChipsCtrl.chipRemoveTemplate   = chipRemoveTemplate;
	        mdChipsCtrl.chipInputTemplate    = chipInputTemplate;
	
	        mdChipsCtrl.mdCloseIcon = $$mdSvgRegistry.mdClose;
	
	        element
	            .attr({ tabindex: -1 })
	            .on('focus', function () { mdChipsCtrl.onFocus(); });
	
	        if (attr.ngModel) {
	          mdChipsCtrl.configureNgModel(element.controller('ngModel'));
	
	          // If an `md-transform-chip` attribute was set, tell the controller to use the expression
	          // before appending chips.
	          if (attrs.mdTransformChip) mdChipsCtrl.useTransformChipExpression();
	
	          // If an `md-on-append` attribute was set, tell the controller to use the expression
	          // when appending chips.
	          //
	          // DEPRECATED: Will remove in official 1.0 release
	          if (attrs.mdOnAppend) mdChipsCtrl.useOnAppendExpression();
	
	          // If an `md-on-add` attribute was set, tell the controller to use the expression
	          // when adding chips.
	          if (attrs.mdOnAdd) mdChipsCtrl.useOnAddExpression();
	
	          // If an `md-on-remove` attribute was set, tell the controller to use the expression
	          // when removing chips.
	          if (attrs.mdOnRemove) mdChipsCtrl.useOnRemoveExpression();
	
	          // If an `md-on-select` attribute was set, tell the controller to use the expression
	          // when selecting chips.
	          if (attrs.mdOnSelect) mdChipsCtrl.useOnSelectExpression();
	
	          // The md-autocomplete and input elements won't be compiled until after this directive
	          // is complete (due to their nested nature). Wait a tick before looking for them to
	          // configure the controller.
	          if (chipInputTemplate != templates.input) {
	            // The autocomplete will not appear until the readonly attribute is not true (i.e.
	            // false or undefined), so we have to watch the readonly and then on the next tick
	            // after the chip transclusion has run, we can configure the autocomplete and user
	            // input.
	            scope.$watch('$mdChipsCtrl.readonly', function(readonly) {
	              if (!readonly) {
	
	                $mdUtil.nextTick(function(){
	
	                  if (chipInputTemplate.indexOf('<md-autocomplete') === 0) {
	                    var autocompleteEl = element.find('md-autocomplete');
	                    mdChipsCtrl.configureAutocomplete(autocompleteEl.controller('mdAutocomplete'));
	                  }
	
	                  mdChipsCtrl.configureUserInput(element.find('input'));
	                });
	              }
	            });
	          }
	
	          // At the next tick, if we find an input, make sure it has the md-input class
	          $mdUtil.nextTick(function() {
	            var input = element.find('input');
	
	            input && input.toggleClass('md-input', true);
	          });
	        }
	
	        // Compile with the parent's scope and prepend any static chips to the wrapper.
	        if (staticChips.length > 0) {
	          var compiledStaticChips = $compile(staticChips.clone())(scope.$parent);
	          $timeout(function() { element.find('md-chips-wrap').prepend(compiledStaticChips); });
	        }
	      };
	    }
	
	    function getTemplates() {
	      return {
	        chips: $mdUtil.processTemplate(MD_CHIPS_TEMPLATE),
	        input: $mdUtil.processTemplate(CHIP_INPUT_TEMPLATE),
	        default: $mdUtil.processTemplate(CHIP_DEFAULT_TEMPLATE),
	        remove: $mdUtil.processTemplate(CHIP_REMOVE_TEMPLATE)
	      };
	    }
	  }
	
	})();
	(function(){
	"use strict";
	
	angular
	    .module('material.components.chips')
	    .controller('MdContactChipsCtrl', MdContactChipsCtrl);
	
	
	
	/**
	 * Controller for the MdContactChips component
	 * @constructor
	 */
	function MdContactChipsCtrl () {
	  /** @type {Object} */
	  this.selectedItem = null;
	
	  /** @type {string} */
	  this.searchText = '';
	}
	
	
	MdContactChipsCtrl.prototype.queryContact = function(searchText) {
	  return this.contactQuery({'$query': searchText});
	};
	
	
	MdContactChipsCtrl.prototype.itemName = function(item) {
	  return item[this.contactName];
	};
	
	})();
	(function(){
	"use strict";
	
	
	MdContactChips.$inject = ["$mdTheming", "$mdUtil"];angular
	  .module('material.components.chips')
	  .directive('mdContactChips', MdContactChips);
	
	/**
	 * @ngdoc directive
	 * @name mdContactChips
	 * @module material.components.chips
	 *
	 * @description
	 * `<md-contact-chips>` is an input component based on `md-chips` and makes use of an
	 * `md-autocomplete` element. The component allows the caller to supply a query expression which
	 * returns  a list of possible contacts. The user can select one of these and add it to the list of
	 * chips.
	 *
	 * You may also use the `md-highlight-text` directive along with its parameters to control the
	 * appearance of the matched text inside of the contacts' autocomplete popup.
	 *
	 * @param {string=|object=} ng-model A model to bind the list of items to
	 * @param {string=} placeholder Placeholder text that will be forwarded to the input.
	 * @param {string=} secondary-placeholder Placeholder text that will be forwarded to the input,
	 *    displayed when there is at least on item in the list
	 * @param {expression} md-contacts An expression expected to return contacts matching the search
	 *    test, `$query`. If this expression involves a promise, a loading bar is displayed while
	 *    waiting for it to resolve.
	 * @param {string} md-contact-name The field name of the contact object representing the
	 *    contact's name.
	 * @param {string} md-contact-email The field name of the contact object representing the
	 *    contact's email address.
	 * @param {string} md-contact-image The field name of the contact object representing the
	 *    contact's image.
	 * @param {number=} md-min-length Specifies the minimum length of text before autocomplete will
	 *    make suggestions
	 *
	 * @param {expression=} filter-selected Whether to filter selected contacts from the list of
	 *    suggestions shown in the autocomplete.
	 *
	 *    ***Note:** This attribute has been removed but may come back.*
	 *
	 *
	 *
	 * @usage
	 * <hljs lang="html">
	 *   <md-contact-chips
	 *       ng-model="ctrl.contacts"
	 *       md-contacts="ctrl.querySearch($query)"
	 *       md-contact-name="name"
	 *       md-contact-image="image"
	 *       md-contact-email="email"
	 *       placeholder="To">
	 *   </md-contact-chips>
	 * </hljs>
	 *
	 */
	
	
	var MD_CONTACT_CHIPS_TEMPLATE = '\
	      <md-chips class="md-contact-chips"\
	          ng-model="$mdContactChipsCtrl.contacts"\
	          md-require-match="$mdContactChipsCtrl.requireMatch"\
	          md-chip-append-delay="{{$mdContactChipsCtrl.chipAppendDelay}}" \
	          md-autocomplete-snap>\
	          <md-autocomplete\
	              md-menu-class="md-contact-chips-suggestions"\
	              md-selected-item="$mdContactChipsCtrl.selectedItem"\
	              md-search-text="$mdContactChipsCtrl.searchText"\
	              md-items="item in $mdContactChipsCtrl.queryContact($mdContactChipsCtrl.searchText)"\
	              md-item-text="$mdContactChipsCtrl.itemName(item)"\
	              md-no-cache="true"\
	              md-min-length="$mdContactChipsCtrl.minLength"\
	              md-autoselect\
	              placeholder="{{$mdContactChipsCtrl.contacts.length == 0 ?\
	                  $mdContactChipsCtrl.placeholder : $mdContactChipsCtrl.secondaryPlaceholder}}">\
	            <div class="md-contact-suggestion">\
	              <img \
	                  ng-src="{{item[$mdContactChipsCtrl.contactImage]}}"\
	                  alt="{{item[$mdContactChipsCtrl.contactName]}}"\
	                  ng-if="item[$mdContactChipsCtrl.contactImage]" />\
	              <span class="md-contact-name" md-highlight-text="$mdContactChipsCtrl.searchText"\
	                    md-highlight-flags="{{$mdContactChipsCtrl.highlightFlags}}">\
	                {{item[$mdContactChipsCtrl.contactName]}}\
	              </span>\
	              <span class="md-contact-email" >{{item[$mdContactChipsCtrl.contactEmail]}}</span>\
	            </div>\
	          </md-autocomplete>\
	          <md-chip-template>\
	            <div class="md-contact-avatar">\
	              <img \
	                  ng-src="{{$chip[$mdContactChipsCtrl.contactImage]}}"\
	                  alt="{{$chip[$mdContactChipsCtrl.contactName]}}"\
	                  ng-if="$chip[$mdContactChipsCtrl.contactImage]" />\
	            </div>\
	            <div class="md-contact-name">\
	              {{$chip[$mdContactChipsCtrl.contactName]}}\
	            </div>\
	          </md-chip-template>\
	      </md-chips>';
	
	
	/**
	 * MDContactChips Directive Definition
	 *
	 * @param $mdTheming
	 * @returns {*}
	 * @ngInject
	 */
	function MdContactChips($mdTheming, $mdUtil) {
	  return {
	    template: function(element, attrs) {
	      return MD_CONTACT_CHIPS_TEMPLATE;
	    },
	    restrict: 'E',
	    controller: 'MdContactChipsCtrl',
	    controllerAs: '$mdContactChipsCtrl',
	    bindToController: true,
	    compile: compile,
	    scope: {
	      contactQuery: '&mdContacts',
	      placeholder: '@',
	      secondaryPlaceholder: '@',
	      contactName: '@mdContactName',
	      contactImage: '@mdContactImage',
	      contactEmail: '@mdContactEmail',
	      contacts: '=ngModel',
	      requireMatch: '=?mdRequireMatch',
	      minLength: '=?mdMinLength',
	      highlightFlags: '@?mdHighlightFlags',
	      chipAppendDelay: '@?mdChipAppendDelay'
	    }
	  };
	
	  function compile(element, attr) {
	    return function postLink(scope, element, attrs, controllers) {
	      var contactChipsController = controllers;
	
	      $mdUtil.initOptionalProperties(scope, attr);
	      $mdTheming(element);
	
	      element.attr('tabindex', '-1');
	
	      attrs.$observe('mdChipAppendDelay', function(newValue) {
	        contactChipsController.chipAppendDelay = newValue;
	      });
	    };
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc directive
	   * @name mdCalendar
	   * @module material.components.datepicker
	   *
	   * @param {Date} ng-model The component's model. Should be a Date object.
	   * @param {Date=} md-min-date Expression representing the minimum date.
	   * @param {Date=} md-max-date Expression representing the maximum date.
	   * @param {(function(Date): boolean)=} md-date-filter Function expecting a date and returning a boolean whether it can be selected or not.
	   *
	   * @description
	   * `<md-calendar>` is a component that renders a calendar that can be used to select a date.
	   * It is a part of the `<md-datepicker>` pane, however it can also be used on it's own.
	   *
	   * @usage
	   *
	   * <hljs lang="html">
	   *   <md-calendar ng-model="birthday"></md-calendar>
	   * </hljs>
	   */
	  CalendarCtrl.$inject = ["$element", "$scope", "$$mdDateUtil", "$mdUtil", "$mdConstant", "$mdTheming", "$$rAF", "$attrs", "$mdDateLocale"];
	  angular.module('material.components.datepicker')
	    .directive('mdCalendar', calendarDirective);
	
	  // POST RELEASE
	  // TODO(jelbourn): Mac Cmd + left / right == Home / End
	  // TODO(jelbourn): Refactor month element creation to use cloneNode (performance).
	  // TODO(jelbourn): Define virtual scrolling constants (compactness) users can override.
	  // TODO(jelbourn): Animated month transition on ng-model change (virtual-repeat)
	  // TODO(jelbourn): Scroll snapping (virtual repeat)
	  // TODO(jelbourn): Remove superfluous row from short months (virtual-repeat)
	  // TODO(jelbourn): Month headers stick to top when scrolling.
	  // TODO(jelbourn): Previous month opacity is lowered when partially scrolled out of view.
	  // TODO(jelbourn): Support md-calendar standalone on a page (as a tabstop w/ aria-live
	  //     announcement and key handling).
	  // Read-only calendar (not just date-picker).
	
	  function calendarDirective() {
	    return {
	      template: function(tElement, tAttr) {
	        // TODO(crisbeto): This is a workaround that allows the calendar to work, without
	        // a datepicker, until issue #8585 gets resolved. It can safely be removed
	        // afterwards. This ensures that the virtual repeater scrolls to the proper place on load by
	        // deferring the execution until the next digest. It's necessary only if the calendar is used
	        // without a datepicker, otherwise it's already wrapped in an ngIf.
	        var extraAttrs = tAttr.hasOwnProperty('ngIf') ? '' : 'ng-if="calendarCtrl.isInitialized"';
	        var template = '' +
	          '<div ng-switch="calendarCtrl.currentView" ' + extraAttrs + '>' +
	            '<md-calendar-year ng-switch-when="year"></md-calendar-year>' +
	            '<md-calendar-month ng-switch-default></md-calendar-month>' +
	          '</div>';
	
	        return template;
	      },
	      scope: {
	        minDate: '=mdMinDate',
	        maxDate: '=mdMaxDate',
	        dateFilter: '=mdDateFilter',
	        _currentView: '@mdCurrentView'
	      },
	      require: ['ngModel', 'mdCalendar'],
	      controller: CalendarCtrl,
	      controllerAs: 'calendarCtrl',
	      bindToController: true,
	      link: function(scope, element, attrs, controllers) {
	        var ngModelCtrl = controllers[0];
	        var mdCalendarCtrl = controllers[1];
	        mdCalendarCtrl.configureNgModel(ngModelCtrl);
	      }
	    };
	  }
	
	  /**
	   * Occasionally the hideVerticalScrollbar method might read an element's
	   * width as 0, because it hasn't been laid out yet. This value will be used
	   * as a fallback, in order to prevent scenarios where the element's width
	   * would otherwise have been set to 0. This value is the "usual" width of a
	   * calendar within a floating calendar pane.
	   */
	  var FALLBACK_WIDTH = 340;
	
	  /** Next identifier for calendar instance. */
	  var nextUniqueId = 0;
	
	  /**
	   * Controller for the mdCalendar component.
	   * @ngInject @constructor
	   */
	  function CalendarCtrl($element, $scope, $$mdDateUtil, $mdUtil,
	    $mdConstant, $mdTheming, $$rAF, $attrs, $mdDateLocale) {
	
	    $mdTheming($element);
	
	    /** @final {!angular.JQLite} */
	    this.$element = $element;
	
	    /** @final {!angular.Scope} */
	    this.$scope = $scope;
	
	    /** @final */
	    this.dateUtil = $$mdDateUtil;
	
	    /** @final */
	    this.$mdUtil = $mdUtil;
	
	    /** @final */
	    this.keyCode = $mdConstant.KEY_CODE;
	
	    /** @final */
	    this.$$rAF = $$rAF;
	
	    /** @final */
	    this.$mdDateLocale = $mdDateLocale;
	
	    /** @final {Date} */
	    this.today = this.dateUtil.createDateAtMidnight();
	
	    /** @type {!angular.NgModelController} */
	    this.ngModelCtrl = null;
	
	    /** @type {String} Class applied to the selected date cell. */
	    this.SELECTED_DATE_CLASS = 'md-calendar-selected-date';
	
	    /** @type {String} Class applied to the cell for today. */
	    this.TODAY_CLASS = 'md-calendar-date-today';
	
	    /** @type {String} Class applied to the focused cell. */
	    this.FOCUSED_DATE_CLASS = 'md-focus';
	
	    /** @final {number} Unique ID for this calendar instance. */
	    this.id = nextUniqueId++;
	
	    /**
	     * The date that is currently focused or showing in the calendar. This will initially be set
	     * to the ng-model value if set, otherwise to today. It will be updated as the user navigates
	     * to other months. The cell corresponding to the displayDate does not necesarily always have
	     * focus in the document (such as for cases when the user is scrolling the calendar).
	     * @type {Date}
	     */
	    this.displayDate = null;
	
	    /**
	     * The selected date. Keep track of this separately from the ng-model value so that we
	     * can know, when the ng-model value changes, what the previous value was before it's updated
	     * in the component's UI.
	     *
	     * @type {Date}
	     */
	    this.selectedDate = null;
	
	    /**
	     * The first date that can be rendered by the calendar. The default is taken
	     * from the mdDateLocale provider and is limited by the mdMinDate.
	     * @type {Date}
	     */
	    this.firstRenderableDate = null;
	
	    /**
	     * The last date that can be rendered by the calendar. The default comes
	     * from the mdDateLocale provider and is limited by the maxDate.
	     * @type {Date}
	     */
	    this.lastRenderableDate = null;
	
	    /**
	     * Used to toggle initialize the root element in the next digest.
	     * @type {Boolean}
	     */
	    this.isInitialized = false;
	
	    /**
	     * Cache for the  width of the element without a scrollbar. Used to hide the scrollbar later on
	     * and to avoid extra reflows when switching between views.
	     * @type {Number}
	     */
	    this.width = 0;
	
	    /**
	     * Caches the width of the scrollbar in order to be used when hiding it and to avoid extra reflows.
	     * @type {Number}
	     */
	    this.scrollbarWidth = 0;
	
	    // Unless the user specifies so, the calendar should not be a tab stop.
	    // This is necessary because ngAria might add a tabindex to anything with an ng-model
	    // (based on whether or not the user has turned that particular feature on/off).
	    if (!$attrs.tabindex) {
	      $element.attr('tabindex', '-1');
	    }
	
	    var boundKeyHandler = angular.bind(this, this.handleKeyEvent);
	
	
	
	    // If use the md-calendar directly in the body without datepicker,
	    // handleKeyEvent will disable other inputs on the page.
	    // So only apply the handleKeyEvent on the body when the md-calendar inside datepicker,
	    // otherwise apply on the calendar element only.
	
	    var handleKeyElement;
	    if ($element.parent().hasClass('md-datepicker-calendar')) {
	      handleKeyElement = angular.element(document.body);
	    } else {
	      handleKeyElement = $element;
	    }
	
	    // Bind the keydown handler to the body, in order to handle cases where the focused
	    // element gets removed from the DOM and stops propagating click events.
	    handleKeyElement.on('keydown', boundKeyHandler);
	
	    $scope.$on('$destroy', function() {
	      handleKeyElement.off('keydown', boundKeyHandler);
	    });
	
	    // For AngularJS 1.4 and older, where there are no lifecycle hooks but bindings are pre-assigned,
	    // manually call the $onInit hook.
	    if (angular.version.major === 1 && angular.version.minor <= 4) {
	      this.$onInit();
	    }
	
	  }
	
	  /**
	   * AngularJS Lifecycle hook for newer AngularJS versions.
	   * Bindings are not guaranteed to have been assigned in the controller, but they are in the $onInit hook.
	   */
	  CalendarCtrl.prototype.$onInit = function() {
	
	    /**
	     * The currently visible calendar view. Note the prefix on the scope value,
	     * which is necessary, because the datepicker seems to reset the real one value if the
	     * calendar is open, but the value on the datepicker's scope is empty.
	     * @type {String}
	     */
	    this.currentView = this._currentView || 'month';
	
	    var dateLocale = this.$mdDateLocale;
	
	    if (this.minDate && this.minDate > dateLocale.firstRenderableDate) {
	      this.firstRenderableDate = this.minDate;
	    } else {
	      this.firstRenderableDate = dateLocale.firstRenderableDate;
	    }
	
	    if (this.maxDate && this.maxDate < dateLocale.lastRenderableDate) {
	      this.lastRenderableDate = this.maxDate;
	    } else {
	      this.lastRenderableDate = dateLocale.lastRenderableDate;
	    }
	  };
	
	  /**
	   * Sets up the controller's reference to ngModelController.
	   * @param {!angular.NgModelController} ngModelCtrl
	   */
	  CalendarCtrl.prototype.configureNgModel = function(ngModelCtrl) {
	    var self = this;
	
	    self.ngModelCtrl = ngModelCtrl;
	
	    self.$mdUtil.nextTick(function() {
	      self.isInitialized = true;
	    });
	
	    ngModelCtrl.$render = function() {
	      var value = this.$viewValue;
	
	      // Notify the child scopes of any changes.
	      self.$scope.$broadcast('md-calendar-parent-changed', value);
	
	      // Set up the selectedDate if it hasn't been already.
	      if (!self.selectedDate) {
	        self.selectedDate = value;
	      }
	
	      // Also set up the displayDate.
	      if (!self.displayDate) {
	        self.displayDate = self.selectedDate || self.today;
	      }
	    };
	  };
	
	  /**
	   * Sets the ng-model value for the calendar and emits a change event.
	   * @param {Date} date
	   */
	  CalendarCtrl.prototype.setNgModelValue = function(date) {
	    var value = this.dateUtil.createDateAtMidnight(date);
	    this.focus(value);
	    this.$scope.$emit('md-calendar-change', value);
	    this.ngModelCtrl.$setViewValue(value);
	    this.ngModelCtrl.$render();
	    return value;
	  };
	
	  /**
	   * Sets the current view that should be visible in the calendar
	   * @param {string} newView View name to be set.
	   * @param {number|Date} time Date object or a timestamp for the new display date.
	   */
	  CalendarCtrl.prototype.setCurrentView = function(newView, time) {
	    var self = this;
	
	    self.$mdUtil.nextTick(function() {
	      self.currentView = newView;
	
	      if (time) {
	        self.displayDate = angular.isDate(time) ? time : new Date(time);
	      }
	    });
	  };
	
	  /**
	   * Focus the cell corresponding to the given date.
	   * @param {Date} date The date to be focused.
	   */
	  CalendarCtrl.prototype.focus = function(date) {
	    if (this.dateUtil.isValidDate(date)) {
	      var previousFocus = this.$element[0].querySelector('.md-focus');
	      if (previousFocus) {
	        previousFocus.classList.remove(this.FOCUSED_DATE_CLASS);
	      }
	
	      var cellId = this.getDateId(date, this.currentView);
	      var cell = document.getElementById(cellId);
	      if (cell) {
	        cell.classList.add(this.FOCUSED_DATE_CLASS);
	        cell.focus();
	        this.displayDate = date;
	      }
	    } else {
	      var rootElement = this.$element[0].querySelector('[ng-switch]');
	
	      if (rootElement) {
	        rootElement.focus();
	      }
	    }
	  };
	
	  /**
	   * Normalizes the key event into an action name. The action will be broadcast
	   * to the child controllers.
	   * @param {KeyboardEvent} event
	   * @returns {String} The action that should be taken, or null if the key
	   * does not match a calendar shortcut.
	   */
	  CalendarCtrl.prototype.getActionFromKeyEvent = function(event) {
	    var keyCode = this.keyCode;
	
	    switch (event.which) {
	      case keyCode.ENTER: return 'select';
	
	      case keyCode.RIGHT_ARROW: return 'move-right';
	      case keyCode.LEFT_ARROW: return 'move-left';
	
	      // TODO(crisbeto): Might want to reconsider using metaKey, because it maps
	      // to the "Windows" key on PC, which opens the start menu or resizes the browser.
	      case keyCode.DOWN_ARROW: return event.metaKey ? 'move-page-down' : 'move-row-down';
	      case keyCode.UP_ARROW: return event.metaKey ? 'move-page-up' : 'move-row-up';
	
	      case keyCode.PAGE_DOWN: return 'move-page-down';
	      case keyCode.PAGE_UP: return 'move-page-up';
	
	      case keyCode.HOME: return 'start';
	      case keyCode.END: return 'end';
	
	      default: return null;
	    }
	  };
	
	  /**
	   * Handles a key event in the calendar with the appropriate action. The action will either
	   * be to select the focused date or to navigate to focus a new date.
	   * @param {KeyboardEvent} event
	   */
	  CalendarCtrl.prototype.handleKeyEvent = function(event) {
	    var self = this;
	
	    this.$scope.$apply(function() {
	      // Capture escape and emit back up so that a wrapping component
	      // (such as a date-picker) can decide to close.
	      if (event.which == self.keyCode.ESCAPE || event.which == self.keyCode.TAB) {
	        self.$scope.$emit('md-calendar-close');
	
	        if (event.which == self.keyCode.TAB) {
	          event.preventDefault();
	        }
	
	        return;
	      }
	
	      // Broadcast the action that any child controllers should take.
	      var action = self.getActionFromKeyEvent(event);
	      if (action) {
	        event.preventDefault();
	        event.stopPropagation();
	        self.$scope.$broadcast('md-calendar-parent-action', action);
	      }
	    });
	  };
	
	  /**
	   * Hides the vertical scrollbar on the calendar scroller of a child controller by
	   * setting the width on the calendar scroller and the `overflow: hidden` wrapper
	   * around the scroller, and then setting a padding-right on the scroller equal
	   * to the width of the browser's scrollbar.
	   *
	   * This will cause a reflow.
	   *
	   * @param {object} childCtrl The child controller whose scrollbar should be hidden.
	   */
	  CalendarCtrl.prototype.hideVerticalScrollbar = function(childCtrl) {
	    var self = this;
	    var element = childCtrl.$element[0];
	    var scrollMask = element.querySelector('.md-calendar-scroll-mask');
	
	    if (self.width > 0) {
	      setWidth();
	    } else {
	      self.$$rAF(function() {
	        var scroller = childCtrl.calendarScroller;
	
	        self.scrollbarWidth = scroller.offsetWidth - scroller.clientWidth;
	        self.width = element.querySelector('table').offsetWidth;
	        setWidth();
	      });
	    }
	
	    function setWidth() {
	      var width = self.width || FALLBACK_WIDTH;
	      var scrollbarWidth = self.scrollbarWidth;
	      var scroller = childCtrl.calendarScroller;
	
	      scrollMask.style.width = width + 'px';
	      scroller.style.width = (width + scrollbarWidth) + 'px';
	      scroller.style.paddingRight = scrollbarWidth + 'px';
	    }
	  };
	
	  /**
	   * Gets an identifier for a date unique to the calendar instance for internal
	   * purposes. Not to be displayed.
	   * @param {Date} date The date for which the id is being generated
	   * @param {string} namespace Namespace for the id. (month, year etc.)
	   * @returns {string}
	   */
	  CalendarCtrl.prototype.getDateId = function(date, namespace) {
	    if (!namespace) {
	      throw new Error('A namespace for the date id has to be specified.');
	    }
	
	    return [
	      'md',
	      this.id,
	      namespace,
	      date.getFullYear(),
	      date.getMonth(),
	      date.getDate()
	    ].join('-');
	  };
	
	  /**
	   * Util to trigger an extra digest on a parent scope, in order to to ensure that
	   * any child virtual repeaters have updated. This is necessary, because the virtual
	   * repeater doesn't update the $index the first time around since the content isn't
	   * in place yet. The case, in which this is an issue, is when the repeater has less
	   * than a page of content (e.g. a month or year view has a min or max date).
	   */
	  CalendarCtrl.prototype.updateVirtualRepeat = function() {
	    var scope = this.$scope;
	    var virtualRepeatResizeListener = scope.$on('$md-resize-enable', function() {
	      if (!scope.$$phase) {
	        scope.$apply();
	      }
	
	      virtualRepeatResizeListener();
	    });
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  CalendarMonthCtrl.$inject = ["$element", "$scope", "$animate", "$q", "$$mdDateUtil", "$mdDateLocale"];
	  angular.module('material.components.datepicker')
	    .directive('mdCalendarMonth', calendarDirective);
	
	  /**
	   * Height of one calendar month tbody. This must be made known to the virtual-repeat and is
	   * subsequently used for scrolling to specific months.
	   */
	  var TBODY_HEIGHT = 265;
	
	  /**
	   * Height of a calendar month with a single row. This is needed to calculate the offset for
	   * rendering an extra month in virtual-repeat that only contains one row.
	   */
	  var TBODY_SINGLE_ROW_HEIGHT = 45;
	
	  /** Private directive that represents a list of months inside the calendar. */
	  function calendarDirective() {
	    return {
	      template:
	        '<table aria-hidden="true" class="md-calendar-day-header"><thead></thead></table>' +
	        '<div class="md-calendar-scroll-mask">' +
	        '<md-virtual-repeat-container class="md-calendar-scroll-container" ' +
	              'md-offset-size="' + (TBODY_SINGLE_ROW_HEIGHT - TBODY_HEIGHT) + '">' +
	            '<table role="grid" tabindex="0" class="md-calendar" aria-readonly="true">' +
	              '<tbody ' +
	                  'md-calendar-month-body ' +
	                  'role="rowgroup" ' +
	                  'md-virtual-repeat="i in monthCtrl.items" ' +
	                  'md-month-offset="$index" ' +
	                  'class="md-calendar-month" ' +
	                  'md-start-index="monthCtrl.getSelectedMonthIndex()" ' +
	                  'md-item-size="' + TBODY_HEIGHT + '">' +
	
	                // The <tr> ensures that the <tbody> will always have the
	                // proper height, even if it's empty. If it's content is
	                // compiled, the <tr> will be overwritten.
	                '<tr aria-hidden="true" style="height:' + TBODY_HEIGHT + 'px;"></tr>' +
	              '</tbody>' +
	            '</table>' +
	          '</md-virtual-repeat-container>' +
	        '</div>',
	      require: ['^^mdCalendar', 'mdCalendarMonth'],
	      controller: CalendarMonthCtrl,
	      controllerAs: 'monthCtrl',
	      bindToController: true,
	      link: function(scope, element, attrs, controllers) {
	        var calendarCtrl = controllers[0];
	        var monthCtrl = controllers[1];
	        monthCtrl.initialize(calendarCtrl);
	      }
	    };
	  }
	
	  /**
	   * Controller for the calendar month component.
	   * @ngInject @constructor
	   */
	  function CalendarMonthCtrl($element, $scope, $animate, $q,
	    $$mdDateUtil, $mdDateLocale) {
	
	    /** @final {!angular.JQLite} */
	    this.$element = $element;
	
	    /** @final {!angular.Scope} */
	    this.$scope = $scope;
	
	    /** @final {!angular.$animate} */
	    this.$animate = $animate;
	
	    /** @final {!angular.$q} */
	    this.$q = $q;
	
	    /** @final */
	    this.dateUtil = $$mdDateUtil;
	
	    /** @final */
	    this.dateLocale = $mdDateLocale;
	
	    /** @final {HTMLElement} */
	    this.calendarScroller = $element[0].querySelector('.md-virtual-repeat-scroller');
	
	    /** @type {boolean} */
	    this.isInitialized = false;
	
	    /** @type {boolean} */
	    this.isMonthTransitionInProgress = false;
	
	    var self = this;
	
	    /**
	     * Handles a click event on a date cell.
	     * Created here so that every cell can use the same function instance.
	     * @this {HTMLTableCellElement} The cell that was clicked.
	     */
	    this.cellClickHandler = function() {
	      var timestamp = $$mdDateUtil.getTimestampFromNode(this);
	      self.$scope.$apply(function() {
	        self.calendarCtrl.setNgModelValue(timestamp);
	      });
	    };
	
	    /**
	     * Handles click events on the month headers. Switches
	     * the calendar to the year view.
	     * @this {HTMLTableCellElement} The cell that was clicked.
	     */
	    this.headerClickHandler = function() {
	      self.calendarCtrl.setCurrentView('year', $$mdDateUtil.getTimestampFromNode(this));
	    };
	  }
	
	  /*** Initialization ***/
	
	  /**
	   * Initialize the controller by saving a reference to the calendar and
	   * setting up the object that will be iterated by the virtual repeater.
	   */
	  CalendarMonthCtrl.prototype.initialize = function(calendarCtrl) {
	    /**
	     * Dummy array-like object for virtual-repeat to iterate over. The length is the total
	     * number of months that can be viewed. We add 2 months: one to include the current month
	     * and one for the last dummy month.
	     *
	     * This is shorter than ideal because of a (potential) Firefox bug
	     * https://bugzilla.mozilla.org/show_bug.cgi?id=1181658.
	     */
	
	    this.items = {
	      length: this.dateUtil.getMonthDistance(
	        calendarCtrl.firstRenderableDate,
	        calendarCtrl.lastRenderableDate
	      ) + 2
	    };
	
	    this.calendarCtrl = calendarCtrl;
	    this.attachScopeListeners();
	    calendarCtrl.updateVirtualRepeat();
	
	    // Fire the initial render, since we might have missed it the first time it fired.
	    calendarCtrl.ngModelCtrl && calendarCtrl.ngModelCtrl.$render();
	  };
	
	  /**
	   * Gets the "index" of the currently selected date as it would be in the virtual-repeat.
	   * @returns {number}
	   */
	  CalendarMonthCtrl.prototype.getSelectedMonthIndex = function() {
	    var calendarCtrl = this.calendarCtrl;
	
	    return this.dateUtil.getMonthDistance(
	      calendarCtrl.firstRenderableDate,
	      calendarCtrl.displayDate || calendarCtrl.selectedDate || calendarCtrl.today
	    );
	  };
	
	  /**
	   * Change the selected date in the calendar (ngModel value has already been changed).
	   * @param {Date} date
	   */
	  CalendarMonthCtrl.prototype.changeSelectedDate = function(date) {
	    var self = this;
	    var calendarCtrl = self.calendarCtrl;
	    var previousSelectedDate = calendarCtrl.selectedDate;
	    calendarCtrl.selectedDate = date;
	
	    this.changeDisplayDate(date).then(function() {
	      var selectedDateClass = calendarCtrl.SELECTED_DATE_CLASS;
	      var namespace = 'month';
	
	      // Remove the selected class from the previously selected date, if any.
	      if (previousSelectedDate) {
	        var prevDateCell = document.getElementById(calendarCtrl.getDateId(previousSelectedDate, namespace));
	        if (prevDateCell) {
	          prevDateCell.classList.remove(selectedDateClass);
	          prevDateCell.setAttribute('aria-selected', 'false');
	        }
	      }
	
	      // Apply the select class to the new selected date if it is set.
	      if (date) {
	        var dateCell = document.getElementById(calendarCtrl.getDateId(date, namespace));
	        if (dateCell) {
	          dateCell.classList.add(selectedDateClass);
	          dateCell.setAttribute('aria-selected', 'true');
	        }
	      }
	    });
	  };
	
	  /**
	   * Change the date that is being shown in the calendar. If the given date is in a different
	   * month, the displayed month will be transitioned.
	   * @param {Date} date
	   */
	  CalendarMonthCtrl.prototype.changeDisplayDate = function(date) {
	    // Initialization is deferred until this function is called because we want to reflect
	    // the starting value of ngModel.
	    if (!this.isInitialized) {
	      this.buildWeekHeader();
	      this.calendarCtrl.hideVerticalScrollbar(this);
	      this.isInitialized = true;
	      return this.$q.when();
	    }
	
	    // If trying to show an invalid date or a transition is in progress, do nothing.
	    if (!this.dateUtil.isValidDate(date) || this.isMonthTransitionInProgress) {
	      return this.$q.when();
	    }
	
	    this.isMonthTransitionInProgress = true;
	    var animationPromise = this.animateDateChange(date);
	
	    this.calendarCtrl.displayDate = date;
	
	    var self = this;
	    animationPromise.then(function() {
	      self.isMonthTransitionInProgress = false;
	    });
	
	    return animationPromise;
	  };
	
	  /**
	   * Animates the transition from the calendar's current month to the given month.
	   * @param {Date} date
	   * @returns {angular.$q.Promise} The animation promise.
	   */
	  CalendarMonthCtrl.prototype.animateDateChange = function(date) {
	    if (this.dateUtil.isValidDate(date)) {
	      var monthDistance = this.dateUtil.getMonthDistance(this.calendarCtrl.firstRenderableDate, date);
	      this.calendarScroller.scrollTop = monthDistance * TBODY_HEIGHT;
	    }
	
	    return this.$q.when();
	  };
	
	  /**
	   * Builds and appends a day-of-the-week header to the calendar.
	   * This should only need to be called once during initialization.
	   */
	  CalendarMonthCtrl.prototype.buildWeekHeader = function() {
	    var firstDayOfWeek = this.dateLocale.firstDayOfWeek;
	    var shortDays = this.dateLocale.shortDays;
	
	    var row = document.createElement('tr');
	    for (var i = 0; i < 7; i++) {
	      var th = document.createElement('th');
	      th.textContent = shortDays[(i + firstDayOfWeek) % 7];
	      row.appendChild(th);
	    }
	
	    this.$element.find('thead').append(row);
	  };
	
	  /**
	   * Attaches listeners for the scope events that are broadcast by the calendar.
	   */
	  CalendarMonthCtrl.prototype.attachScopeListeners = function() {
	    var self = this;
	
	    self.$scope.$on('md-calendar-parent-changed', function(event, value) {
	      self.changeSelectedDate(value);
	    });
	
	    self.$scope.$on('md-calendar-parent-action', angular.bind(this, this.handleKeyEvent));
	  };
	
	  /**
	   * Handles the month-specific keyboard interactions.
	   * @param {Object} event Scope event object passed by the calendar.
	   * @param {String} action Action, corresponding to the key that was pressed.
	   */
	  CalendarMonthCtrl.prototype.handleKeyEvent = function(event, action) {
	    var calendarCtrl = this.calendarCtrl;
	    var displayDate = calendarCtrl.displayDate;
	
	    if (action === 'select') {
	      calendarCtrl.setNgModelValue(displayDate);
	    } else {
	      var date = null;
	      var dateUtil = this.dateUtil;
	
	      switch (action) {
	        case 'move-right': date = dateUtil.incrementDays(displayDate, 1); break;
	        case 'move-left': date = dateUtil.incrementDays(displayDate, -1); break;
	
	        case 'move-page-down': date = dateUtil.incrementMonths(displayDate, 1); break;
	        case 'move-page-up': date = dateUtil.incrementMonths(displayDate, -1); break;
	
	        case 'move-row-down': date = dateUtil.incrementDays(displayDate, 7); break;
	        case 'move-row-up': date = dateUtil.incrementDays(displayDate, -7); break;
	
	        case 'start': date = dateUtil.getFirstDateOfMonth(displayDate); break;
	        case 'end': date = dateUtil.getLastDateOfMonth(displayDate); break;
	      }
	
	      if (date) {
	        date = this.dateUtil.clampDate(date, calendarCtrl.minDate, calendarCtrl.maxDate);
	
	        this.changeDisplayDate(date).then(function() {
	          calendarCtrl.focus(date);
	        });
	      }
	    }
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  mdCalendarMonthBodyDirective.$inject = ["$compile", "$$mdSvgRegistry"];
	  CalendarMonthBodyCtrl.$inject = ["$element", "$$mdDateUtil", "$mdDateLocale"];
	  angular.module('material.components.datepicker')
	      .directive('mdCalendarMonthBody', mdCalendarMonthBodyDirective);
	
	  /**
	   * Private directive consumed by md-calendar-month. Having this directive lets the calender use
	   * md-virtual-repeat and also cleanly separates the month DOM construction functions from
	   * the rest of the calendar controller logic.
	   * @ngInject
	   */
	  function mdCalendarMonthBodyDirective($compile, $$mdSvgRegistry) {
	    var ARROW_ICON = $compile('<md-icon md-svg-src="' +
	      $$mdSvgRegistry.mdTabsArrow + '"></md-icon>')({})[0];
	
	    return {
	      require: ['^^mdCalendar', '^^mdCalendarMonth', 'mdCalendarMonthBody'],
	      scope: { offset: '=mdMonthOffset' },
	      controller: CalendarMonthBodyCtrl,
	      controllerAs: 'mdMonthBodyCtrl',
	      bindToController: true,
	      link: function(scope, element, attrs, controllers) {
	        var calendarCtrl = controllers[0];
	        var monthCtrl = controllers[1];
	        var monthBodyCtrl = controllers[2];
	
	        monthBodyCtrl.calendarCtrl = calendarCtrl;
	        monthBodyCtrl.monthCtrl = monthCtrl;
	        monthBodyCtrl.arrowIcon = ARROW_ICON.cloneNode(true);
	
	        // The virtual-repeat re-uses the same DOM elements, so there are only a limited number
	        // of repeated items that are linked, and then those elements have their bindings updated.
	        // Since the months are not generated by bindings, we simply regenerate the entire thing
	        // when the binding (offset) changes.
	        scope.$watch(function() { return monthBodyCtrl.offset; }, function(offset) {
	          if (angular.isNumber(offset)) {
	            monthBodyCtrl.generateContent();
	          }
	        });
	      }
	    };
	  }
	
	  /**
	   * Controller for a single calendar month.
	   * @ngInject @constructor
	   */
	  function CalendarMonthBodyCtrl($element, $$mdDateUtil, $mdDateLocale) {
	    /** @final {!angular.JQLite} */
	    this.$element = $element;
	
	    /** @final */
	    this.dateUtil = $$mdDateUtil;
	
	    /** @final */
	    this.dateLocale = $mdDateLocale;
	
	    /** @type {Object} Reference to the month view. */
	    this.monthCtrl = null;
	
	    /** @type {Object} Reference to the calendar. */
	    this.calendarCtrl = null;
	
	    /**
	     * Number of months from the start of the month "items" that the currently rendered month
	     * occurs. Set via angular data binding.
	     * @type {number}
	     */
	    this.offset = null;
	
	    /**
	     * Date cell to focus after appending the month to the document.
	     * @type {HTMLElement}
	     */
	    this.focusAfterAppend = null;
	  }
	
	  /** Generate and append the content for this month to the directive element. */
	  CalendarMonthBodyCtrl.prototype.generateContent = function() {
	    var date = this.dateUtil.incrementMonths(this.calendarCtrl.firstRenderableDate, this.offset);
	
	    this.$element
	      .empty()
	      .append(this.buildCalendarForMonth(date));
	
	    if (this.focusAfterAppend) {
	      this.focusAfterAppend.classList.add(this.calendarCtrl.FOCUSED_DATE_CLASS);
	      this.focusAfterAppend.focus();
	      this.focusAfterAppend = null;
	    }
	  };
	
	  /**
	   * Creates a single cell to contain a date in the calendar with all appropriate
	   * attributes and classes added. If a date is given, the cell content will be set
	   * based on the date.
	   * @param {Date=} opt_date
	   * @returns {HTMLElement}
	   */
	  CalendarMonthBodyCtrl.prototype.buildDateCell = function(opt_date) {
	    var monthCtrl = this.monthCtrl;
	    var calendarCtrl = this.calendarCtrl;
	
	    // TODO(jelbourn): cloneNode is likely a faster way of doing this.
	    var cell = document.createElement('td');
	    cell.tabIndex = -1;
	    cell.classList.add('md-calendar-date');
	    cell.setAttribute('role', 'gridcell');
	
	    if (opt_date) {
	      cell.setAttribute('tabindex', '-1');
	      cell.setAttribute('aria-label', this.dateLocale.longDateFormatter(opt_date));
	      cell.id = calendarCtrl.getDateId(opt_date, 'month');
	
	      // Use `data-timestamp` attribute because IE10 does not support the `dataset` property.
	      cell.setAttribute('data-timestamp', opt_date.getTime());
	
	      // TODO(jelourn): Doing these comparisons for class addition during generation might be slow.
	      // It may be better to finish the construction and then query the node and add the class.
	      if (this.dateUtil.isSameDay(opt_date, calendarCtrl.today)) {
	        cell.classList.add(calendarCtrl.TODAY_CLASS);
	      }
	
	      if (this.dateUtil.isValidDate(calendarCtrl.selectedDate) &&
	          this.dateUtil.isSameDay(opt_date, calendarCtrl.selectedDate)) {
	        cell.classList.add(calendarCtrl.SELECTED_DATE_CLASS);
	        cell.setAttribute('aria-selected', 'true');
	      }
	
	      var cellText = this.dateLocale.dates[opt_date.getDate()];
	
	      if (this.isDateEnabled(opt_date)) {
	        // Add a indicator for select, hover, and focus states.
	        var selectionIndicator = document.createElement('span');
	        selectionIndicator.classList.add('md-calendar-date-selection-indicator');
	        selectionIndicator.textContent = cellText;
	        cell.appendChild(selectionIndicator);
	        cell.addEventListener('click', monthCtrl.cellClickHandler);
	
	        if (calendarCtrl.displayDate && this.dateUtil.isSameDay(opt_date, calendarCtrl.displayDate)) {
	          this.focusAfterAppend = cell;
	        }
	      } else {
	        cell.classList.add('md-calendar-date-disabled');
	        cell.textContent = cellText;
	      }
	    }
	
	    return cell;
	  };
	
	  /**
	   * Check whether date is in range and enabled
	   * @param {Date=} opt_date
	   * @return {boolean} Whether the date is enabled.
	   */
	  CalendarMonthBodyCtrl.prototype.isDateEnabled = function(opt_date) {
	    return this.dateUtil.isDateWithinRange(opt_date,
	          this.calendarCtrl.minDate, this.calendarCtrl.maxDate) &&
	          (!angular.isFunction(this.calendarCtrl.dateFilter)
	           || this.calendarCtrl.dateFilter(opt_date));
	  };
	
	  /**
	   * Builds a `tr` element for the calendar grid.
	   * @param rowNumber The week number within the month.
	   * @returns {HTMLElement}
	   */
	  CalendarMonthBodyCtrl.prototype.buildDateRow = function(rowNumber) {
	    var row = document.createElement('tr');
	    row.setAttribute('role', 'row');
	
	    // Because of an NVDA bug (with Firefox), the row needs an aria-label in order
	    // to prevent the entire row being read aloud when the user moves between rows.
	    // See http://community.nvda-project.org/ticket/4643.
	    row.setAttribute('aria-label', this.dateLocale.weekNumberFormatter(rowNumber));
	
	    return row;
	  };
	
	  /**
	   * Builds the <tbody> content for the given date's month.
	   * @param {Date=} opt_dateInMonth
	   * @returns {DocumentFragment} A document fragment containing the <tr> elements.
	   */
	  CalendarMonthBodyCtrl.prototype.buildCalendarForMonth = function(opt_dateInMonth) {
	    var date = this.dateUtil.isValidDate(opt_dateInMonth) ? opt_dateInMonth : new Date();
	
	    var firstDayOfMonth = this.dateUtil.getFirstDateOfMonth(date);
	    var firstDayOfTheWeek = this.getLocaleDay_(firstDayOfMonth);
	    var numberOfDaysInMonth = this.dateUtil.getNumberOfDaysInMonth(date);
	
	    // Store rows for the month in a document fragment so that we can append them all at once.
	    var monthBody = document.createDocumentFragment();
	
	    var rowNumber = 1;
	    var row = this.buildDateRow(rowNumber);
	    monthBody.appendChild(row);
	
	    // If this is the final month in the list of items, only the first week should render,
	    // so we should return immediately after the first row is complete and has been
	    // attached to the body.
	    var isFinalMonth = this.offset === this.monthCtrl.items.length - 1;
	
	    // Add a label for the month. If the month starts on a Sun/Mon/Tues, the month label
	    // goes on a row above the first of the month. Otherwise, the month label takes up the first
	    // two cells of the first row.
	    var blankCellOffset = 0;
	    var monthLabelCell = document.createElement('td');
	    var monthLabelCellContent = document.createElement('span');
	
	    monthLabelCellContent.textContent = this.dateLocale.monthHeaderFormatter(date);
	    monthLabelCell.appendChild(monthLabelCellContent);
	    monthLabelCell.classList.add('md-calendar-month-label');
	    // If the entire month is after the max date, render the label as a disabled state.
	    if (this.calendarCtrl.maxDate && firstDayOfMonth > this.calendarCtrl.maxDate) {
	      monthLabelCell.classList.add('md-calendar-month-label-disabled');
	    } else {
	      monthLabelCell.addEventListener('click', this.monthCtrl.headerClickHandler);
	      monthLabelCell.setAttribute('data-timestamp', firstDayOfMonth.getTime());
	      monthLabelCell.setAttribute('aria-label', this.dateLocale.monthFormatter(date));
	      monthLabelCell.appendChild(this.arrowIcon.cloneNode(true));
	    }
	
	    if (firstDayOfTheWeek <= 2) {
	      monthLabelCell.setAttribute('colspan', '7');
	
	      var monthLabelRow = this.buildDateRow();
	      monthLabelRow.appendChild(monthLabelCell);
	      monthBody.insertBefore(monthLabelRow, row);
	
	      if (isFinalMonth) {
	        return monthBody;
	      }
	    } else {
	      blankCellOffset = 3;
	      monthLabelCell.setAttribute('colspan', '3');
	      row.appendChild(monthLabelCell);
	    }
	
	    // Add a blank cell for each day of the week that occurs before the first of the month.
	    // For example, if the first day of the month is a Tuesday, add blank cells for Sun and Mon.
	    // The blankCellOffset is needed in cases where the first N cells are used by the month label.
	    for (var i = blankCellOffset; i < firstDayOfTheWeek; i++) {
	      row.appendChild(this.buildDateCell());
	    }
	
	    // Add a cell for each day of the month, keeping track of the day of the week so that
	    // we know when to start a new row.
	    var dayOfWeek = firstDayOfTheWeek;
	    var iterationDate = firstDayOfMonth;
	    for (var d = 1; d <= numberOfDaysInMonth; d++) {
	      // If we've reached the end of the week, start a new row.
	      if (dayOfWeek === 7) {
	        // We've finished the first row, so we're done if this is the final month.
	        if (isFinalMonth) {
	          return monthBody;
	        }
	        dayOfWeek = 0;
	        rowNumber++;
	        row = this.buildDateRow(rowNumber);
	        monthBody.appendChild(row);
	      }
	
	      iterationDate.setDate(d);
	      var cell = this.buildDateCell(iterationDate);
	      row.appendChild(cell);
	
	      dayOfWeek++;
	    }
	
	    // Ensure that the last row of the month has 7 cells.
	    while (row.childNodes.length < 7) {
	      row.appendChild(this.buildDateCell());
	    }
	
	    // Ensure that all months have 6 rows. This is necessary for now because the virtual-repeat
	    // requires that all items have exactly the same height.
	    while (monthBody.childNodes.length < 6) {
	      var whitespaceRow = this.buildDateRow();
	      for (var j = 0; j < 7; j++) {
	        whitespaceRow.appendChild(this.buildDateCell());
	      }
	      monthBody.appendChild(whitespaceRow);
	    }
	
	    return monthBody;
	  };
	
	  /**
	   * Gets the day-of-the-week index for a date for the current locale.
	   * @private
	   * @param {Date} date
	   * @returns {number} The column index of the date in the calendar.
	   */
	  CalendarMonthBodyCtrl.prototype.getLocaleDay_ = function(date) {
	    return (date.getDay() + (7 - this.dateLocale.firstDayOfWeek)) % 7;
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  CalendarYearCtrl.$inject = ["$element", "$scope", "$animate", "$q", "$$mdDateUtil"];
	  angular.module('material.components.datepicker')
	    .directive('mdCalendarYear', calendarDirective);
	
	  /**
	   * Height of one calendar year tbody. This must be made known to the virtual-repeat and is
	   * subsequently used for scrolling to specific years.
	   */
	  var TBODY_HEIGHT = 88;
	
	  /** Private component, representing a list of years in the calendar. */
	  function calendarDirective() {
	    return {
	      template:
	        '<div class="md-calendar-scroll-mask">' +
	          '<md-virtual-repeat-container class="md-calendar-scroll-container">' +
	            '<table role="grid" tabindex="0" class="md-calendar" aria-readonly="true">' +
	              '<tbody ' +
	                  'md-calendar-year-body ' +
	                  'role="rowgroup" ' +
	                  'md-virtual-repeat="i in yearCtrl.items" ' +
	                  'md-year-offset="$index" class="md-calendar-year" ' +
	                  'md-start-index="yearCtrl.getFocusedYearIndex()" ' +
	                  'md-item-size="' + TBODY_HEIGHT + '">' +
	                // The <tr> ensures that the <tbody> will have the proper
	                // height, even though it may be empty.
	                '<tr aria-hidden="true" style="height:' + TBODY_HEIGHT + 'px;"></tr>' +
	              '</tbody>' +
	            '</table>' +
	          '</md-virtual-repeat-container>' +
	        '</div>',
	      require: ['^^mdCalendar', 'mdCalendarYear'],
	      controller: CalendarYearCtrl,
	      controllerAs: 'yearCtrl',
	      bindToController: true,
	      link: function(scope, element, attrs, controllers) {
	        var calendarCtrl = controllers[0];
	        var yearCtrl = controllers[1];
	        yearCtrl.initialize(calendarCtrl);
	      }
	    };
	  }
	
	  /**
	   * Controller for the mdCalendar component.
	   * @ngInject @constructor
	   */
	  function CalendarYearCtrl($element, $scope, $animate, $q, $$mdDateUtil) {
	
	    /** @final {!angular.JQLite} */
	    this.$element = $element;
	
	    /** @final {!angular.Scope} */
	    this.$scope = $scope;
	
	    /** @final {!angular.$animate} */
	    this.$animate = $animate;
	
	    /** @final {!angular.$q} */
	    this.$q = $q;
	
	    /** @final */
	    this.dateUtil = $$mdDateUtil;
	
	    /** @final {HTMLElement} */
	    this.calendarScroller = $element[0].querySelector('.md-virtual-repeat-scroller');
	
	    /** @type {boolean} */
	    this.isInitialized = false;
	
	    /** @type {boolean} */
	    this.isMonthTransitionInProgress = false;
	
	    var self = this;
	
	    /**
	     * Handles a click event on a date cell.
	     * Created here so that every cell can use the same function instance.
	     * @this {HTMLTableCellElement} The cell that was clicked.
	     */
	    this.cellClickHandler = function() {
	      self.calendarCtrl.setCurrentView('month', $$mdDateUtil.getTimestampFromNode(this));
	    };
	  }
	
	  /**
	   * Initialize the controller by saving a reference to the calendar and
	   * setting up the object that will be iterated by the virtual repeater.
	   */
	  CalendarYearCtrl.prototype.initialize = function(calendarCtrl) {
	    /**
	     * Dummy array-like object for virtual-repeat to iterate over. The length is the total
	     * number of years that can be viewed. We add 1 extra in order to include the current year.
	     */
	    this.items = {
	      length: this.dateUtil.getYearDistance(
	        calendarCtrl.firstRenderableDate,
	        calendarCtrl.lastRenderableDate
	      ) + 1
	    };
	
	    this.calendarCtrl = calendarCtrl;
	    this.attachScopeListeners();
	    calendarCtrl.updateVirtualRepeat();
	
	    // Fire the initial render, since we might have missed it the first time it fired.
	    calendarCtrl.ngModelCtrl && calendarCtrl.ngModelCtrl.$render();
	  };
	
	  /**
	   * Gets the "index" of the currently selected date as it would be in the virtual-repeat.
	   * @returns {number}
	   */
	  CalendarYearCtrl.prototype.getFocusedYearIndex = function() {
	    var calendarCtrl = this.calendarCtrl;
	
	    return this.dateUtil.getYearDistance(
	      calendarCtrl.firstRenderableDate,
	      calendarCtrl.displayDate || calendarCtrl.selectedDate || calendarCtrl.today
	    );
	  };
	
	  /**
	   * Change the date that is highlighted in the calendar.
	   * @param {Date} date
	   */
	  CalendarYearCtrl.prototype.changeDate = function(date) {
	    // Initialization is deferred until this function is called because we want to reflect
	    // the starting value of ngModel.
	    if (!this.isInitialized) {
	      this.calendarCtrl.hideVerticalScrollbar(this);
	      this.isInitialized = true;
	      return this.$q.when();
	    } else if (this.dateUtil.isValidDate(date) && !this.isMonthTransitionInProgress) {
	      var self = this;
	      var animationPromise = this.animateDateChange(date);
	
	      self.isMonthTransitionInProgress = true;
	      self.calendarCtrl.displayDate = date;
	
	      return animationPromise.then(function() {
	        self.isMonthTransitionInProgress = false;
	      });
	    }
	  };
	
	  /**
	   * Animates the transition from the calendar's current month to the given month.
	   * @param {Date} date
	   * @returns {angular.$q.Promise} The animation promise.
	   */
	  CalendarYearCtrl.prototype.animateDateChange = function(date) {
	    if (this.dateUtil.isValidDate(date)) {
	      var monthDistance = this.dateUtil.getYearDistance(this.calendarCtrl.firstRenderableDate, date);
	      this.calendarScroller.scrollTop = monthDistance * TBODY_HEIGHT;
	    }
	
	    return this.$q.when();
	  };
	
	  /**
	   * Handles the year-view-specific keyboard interactions.
	   * @param {Object} event Scope event object passed by the calendar.
	   * @param {String} action Action, corresponding to the key that was pressed.
	   */
	  CalendarYearCtrl.prototype.handleKeyEvent = function(event, action) {
	    var calendarCtrl = this.calendarCtrl;
	    var displayDate = calendarCtrl.displayDate;
	
	    if (action === 'select') {
	      this.changeDate(displayDate).then(function() {
	        calendarCtrl.setCurrentView('month', displayDate);
	        calendarCtrl.focus(displayDate);
	      });
	    } else {
	      var date = null;
	      var dateUtil = this.dateUtil;
	
	      switch (action) {
	        case 'move-right': date = dateUtil.incrementMonths(displayDate, 1); break;
	        case 'move-left': date = dateUtil.incrementMonths(displayDate, -1); break;
	
	        case 'move-row-down': date = dateUtil.incrementMonths(displayDate, 6); break;
	        case 'move-row-up': date = dateUtil.incrementMonths(displayDate, -6); break;
	      }
	
	      if (date) {
	        var min = calendarCtrl.minDate ? dateUtil.getFirstDateOfMonth(calendarCtrl.minDate) : null;
	        var max = calendarCtrl.maxDate ? dateUtil.getFirstDateOfMonth(calendarCtrl.maxDate) : null;
	        date = dateUtil.getFirstDateOfMonth(this.dateUtil.clampDate(date, min, max));
	
	        this.changeDate(date).then(function() {
	          calendarCtrl.focus(date);
	        });
	      }
	    }
	  };
	
	  /**
	   * Attaches listeners for the scope events that are broadcast by the calendar.
	   */
	  CalendarYearCtrl.prototype.attachScopeListeners = function() {
	    var self = this;
	
	    self.$scope.$on('md-calendar-parent-changed', function(event, value) {
	      self.changeDate(value);
	    });
	
	    self.$scope.$on('md-calendar-parent-action', angular.bind(self, self.handleKeyEvent));
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  CalendarYearBodyCtrl.$inject = ["$element", "$$mdDateUtil", "$mdDateLocale"];
	  angular.module('material.components.datepicker')
	      .directive('mdCalendarYearBody', mdCalendarYearDirective);
	
	  /**
	   * Private component, consumed by the md-calendar-year, which separates the DOM construction logic
	   * and allows for the year view to use md-virtual-repeat.
	   */
	  function mdCalendarYearDirective() {
	    return {
	      require: ['^^mdCalendar', '^^mdCalendarYear', 'mdCalendarYearBody'],
	      scope: { offset: '=mdYearOffset' },
	      controller: CalendarYearBodyCtrl,
	      controllerAs: 'mdYearBodyCtrl',
	      bindToController: true,
	      link: function(scope, element, attrs, controllers) {
	        var calendarCtrl = controllers[0];
	        var yearCtrl = controllers[1];
	        var yearBodyCtrl = controllers[2];
	
	        yearBodyCtrl.calendarCtrl = calendarCtrl;
	        yearBodyCtrl.yearCtrl = yearCtrl;
	
	        scope.$watch(function() { return yearBodyCtrl.offset; }, function(offset) {
	          if (angular.isNumber(offset)) {
	            yearBodyCtrl.generateContent();
	          }
	        });
	      }
	    };
	  }
	
	  /**
	   * Controller for a single year.
	   * @ngInject @constructor
	   */
	  function CalendarYearBodyCtrl($element, $$mdDateUtil, $mdDateLocale) {
	    /** @final {!angular.JQLite} */
	    this.$element = $element;
	
	    /** @final */
	    this.dateUtil = $$mdDateUtil;
	
	    /** @final */
	    this.dateLocale = $mdDateLocale;
	
	    /** @type {Object} Reference to the calendar. */
	    this.calendarCtrl = null;
	
	    /** @type {Object} Reference to the year view. */
	    this.yearCtrl = null;
	
	    /**
	     * Number of months from the start of the month "items" that the currently rendered month
	     * occurs. Set via angular data binding.
	     * @type {number}
	     */
	    this.offset = null;
	
	    /**
	     * Date cell to focus after appending the month to the document.
	     * @type {HTMLElement}
	     */
	    this.focusAfterAppend = null;
	  }
	
	  /** Generate and append the content for this year to the directive element. */
	  CalendarYearBodyCtrl.prototype.generateContent = function() {
	    var date = this.dateUtil.incrementYears(this.calendarCtrl.firstRenderableDate, this.offset);
	
	    this.$element
	      .empty()
	      .append(this.buildCalendarForYear(date));
	
	    if (this.focusAfterAppend) {
	      this.focusAfterAppend.classList.add(this.calendarCtrl.FOCUSED_DATE_CLASS);
	      this.focusAfterAppend.focus();
	      this.focusAfterAppend = null;
	    }
	  };
	
	  /**
	   * Creates a single cell to contain a year in the calendar.
	   * @param {number} opt_year Four-digit year.
	   * @param {number} opt_month Zero-indexed month.
	   * @returns {HTMLElement}
	   */
	  CalendarYearBodyCtrl.prototype.buildMonthCell = function(year, month) {
	    var calendarCtrl = this.calendarCtrl;
	    var yearCtrl = this.yearCtrl;
	    var cell = this.buildBlankCell();
	
	    // Represent this month/year as a date.
	    var firstOfMonth = new Date(year, month, 1);
	    cell.setAttribute('aria-label', this.dateLocale.monthFormatter(firstOfMonth));
	    cell.id = calendarCtrl.getDateId(firstOfMonth, 'year');
	
	    // Use `data-timestamp` attribute because IE10 does not support the `dataset` property.
	    cell.setAttribute('data-timestamp', firstOfMonth.getTime());
	
	    if (this.dateUtil.isSameMonthAndYear(firstOfMonth, calendarCtrl.today)) {
	      cell.classList.add(calendarCtrl.TODAY_CLASS);
	    }
	
	    if (this.dateUtil.isValidDate(calendarCtrl.selectedDate) &&
	        this.dateUtil.isSameMonthAndYear(firstOfMonth, calendarCtrl.selectedDate)) {
	      cell.classList.add(calendarCtrl.SELECTED_DATE_CLASS);
	      cell.setAttribute('aria-selected', 'true');
	    }
	
	    var cellText = this.dateLocale.shortMonths[month];
	
	    if (this.dateUtil.isMonthWithinRange(firstOfMonth,
	        calendarCtrl.minDate, calendarCtrl.maxDate)) {
	      var selectionIndicator = document.createElement('span');
	      selectionIndicator.classList.add('md-calendar-date-selection-indicator');
	      selectionIndicator.textContent = cellText;
	      cell.appendChild(selectionIndicator);
	      cell.addEventListener('click', yearCtrl.cellClickHandler);
	
	      if (calendarCtrl.displayDate && this.dateUtil.isSameMonthAndYear(firstOfMonth, calendarCtrl.displayDate)) {
	        this.focusAfterAppend = cell;
	      }
	    } else {
	      cell.classList.add('md-calendar-date-disabled');
	      cell.textContent = cellText;
	    }
	
	    return cell;
	  };
	
	  /**
	   * Builds a blank cell.
	   * @return {HTMLTableCellElement}
	   */
	  CalendarYearBodyCtrl.prototype.buildBlankCell = function() {
	    var cell = document.createElement('td');
	    cell.tabIndex = -1;
	    cell.classList.add('md-calendar-date');
	    cell.setAttribute('role', 'gridcell');
	
	    cell.setAttribute('tabindex', '-1');
	    return cell;
	  };
	
	  /**
	   * Builds the <tbody> content for the given year.
	   * @param {Date} date Date for which the content should be built.
	   * @returns {DocumentFragment} A document fragment containing the months within the year.
	   */
	  CalendarYearBodyCtrl.prototype.buildCalendarForYear = function(date) {
	    // Store rows for the month in a document fragment so that we can append them all at once.
	    var year = date.getFullYear();
	    var yearBody = document.createDocumentFragment();
	
	    var monthCell, i;
	    // First row contains label and Jan-Jun.
	    var firstRow = document.createElement('tr');
	    var labelCell = document.createElement('td');
	    labelCell.className = 'md-calendar-month-label';
	    labelCell.textContent = year;
	    firstRow.appendChild(labelCell);
	
	    for (i = 0; i < 6; i++) {
	      firstRow.appendChild(this.buildMonthCell(year, i));
	    }
	    yearBody.appendChild(firstRow);
	
	    // Second row contains a blank cell and Jul-Dec.
	    var secondRow = document.createElement('tr');
	    secondRow.appendChild(this.buildBlankCell());
	    for (i = 6; i < 12; i++) {
	      secondRow.appendChild(this.buildMonthCell(year, i));
	    }
	    yearBody.appendChild(secondRow);
	
	    return yearBody;
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc service
	   * @name $mdDateLocaleProvider
	   * @module material.components.datepicker
	   *
	   * @description
	   * The `$mdDateLocaleProvider` is the provider that creates the `$mdDateLocale` service.
	   * This provider that allows the user to specify messages, formatters, and parsers for date
	   * internationalization. The `$mdDateLocale` service itself is consumed by AngularJS Material
	   * components that deal with dates.
	   *
	   * @property {(Array<string>)=} months Array of month names (in order).
	   * @property {(Array<string>)=} shortMonths Array of abbreviated month names.
	   * @property {(Array<string>)=} days Array of the days of the week (in order).
	   * @property {(Array<string>)=} shortDays Array of abbreviated days of the week.
	   * @property {(Array<string>)=} dates Array of dates of the month. Only necessary for locales
	   *     using a numeral system other than [1, 2, 3...].
	   * @property {(Array<string>)=} firstDayOfWeek The first day of the week. Sunday = 0, Monday = 1,
	   *    etc.
	   * @property {(function(string): Date)=} parseDate Function to parse a date object from a string.
	   * @property {(function(Date, string): string)=} formatDate Function to format a date object to a
	   *     string. The datepicker directive also provides the time zone, if it was specified.
	   * @property {(function(Date): string)=} monthHeaderFormatter Function that returns the label for
	   *     a month given a date.
	   * @property {(function(Date): string)=} monthFormatter Function that returns the full name of a month
	   *     for a given date.
	   * @property {(function(number): string)=} weekNumberFormatter Function that returns a label for
	   *     a week given the week number.
	   * @property {(string)=} msgCalendar Translation of the label "Calendar" for the current locale.
	   * @property {(string)=} msgOpenCalendar Translation of the button label "Open calendar" for the
	   *     current locale.
	   * @property {Date=} firstRenderableDate The date from which the datepicker calendar will begin
	   * rendering. Note that this will be ignored if a minimum date is set. Defaults to January 1st 1880.
	   * @property {Date=} lastRenderableDate The last date that will be rendered by the datepicker
	   * calendar. Note that this will be ignored if a maximum date is set. Defaults to January 1st 2130.
	   *
	   * @usage
	   * <hljs lang="js">
	   * myAppModule.config(function($mdDateLocaleProvider) {
	   *
	   *     // Example of a French localization.
	   *     $mdDateLocaleProvider.months = ['janvier', 'février', 'mars', ...];
	   *     $mdDateLocaleProvider.shortMonths = ['janv', 'févr', 'mars', ...];
	   *     $mdDateLocaleProvider.days = ['dimanche', 'lundi', 'mardi', ...];
	   *     $mdDateLocaleProvider.shortDays = ['Di', 'Lu', 'Ma', ...];
	   *
	   *     // Can change week display to start on Monday.
	   *     $mdDateLocaleProvider.firstDayOfWeek = 1;
	   *
	   *     // Optional.
	   *     $mdDateLocaleProvider.dates = [1, 2, 3, 4, 5, 6, ...];
	   *
	   *     // Example uses moment.js to parse and format dates.
	   *     $mdDateLocaleProvider.parseDate = function(dateString) {
	   *       var m = moment(dateString, 'L', true);
	   *       return m.isValid() ? m.toDate() : new Date(NaN);
	   *     };
	   *
	   *     $mdDateLocaleProvider.formatDate = function(date) {
	   *       var m = moment(date);
	   *       return m.isValid() ? m.format('L') : '';
	   *     };
	   *
	   *     $mdDateLocaleProvider.monthHeaderFormatter = function(date) {
	   *       return myShortMonths[date.getMonth()] + ' ' + date.getFullYear();
	   *     };
	   *
	   *     // In addition to date display, date components also need localized messages
	   *     // for aria-labels for screen-reader users.
	   *
	   *     $mdDateLocaleProvider.weekNumberFormatter = function(weekNumber) {
	   *       return 'Semaine ' + weekNumber;
	   *     };
	   *
	   *     $mdDateLocaleProvider.msgCalendar = 'Calendrier';
	   *     $mdDateLocaleProvider.msgOpenCalendar = 'Ouvrir le calendrier';
	   *
	   *     // You can also set when your calendar begins and ends.
	   *     $mdDateLocaleProvider.firstRenderableDate = new Date(1776, 6, 4);
	   *     $mdDateLocaleProvider.lastRenderableDate = new Date(2012, 11, 21);
	   * });
	   * </hljs>
	   *
	   */
	  angular.module('material.components.datepicker').config(["$provide", function($provide) {
	    // TODO(jelbourn): Assert provided values are correctly formatted. Need assertions.
	
	    /** @constructor */
	    function DateLocaleProvider() {
	      /** Array of full month names. E.g., ['January', 'Febuary', ...] */
	      this.months = null;
	
	      /** Array of abbreviated month names. E.g., ['Jan', 'Feb', ...] */
	      this.shortMonths = null;
	
	      /** Array of full day of the week names. E.g., ['Monday', 'Tuesday', ...] */
	      this.days = null;
	
	      /** Array of abbreviated dat of the week names. E.g., ['M', 'T', ...] */
	      this.shortDays = null;
	
	      /** Array of dates of a month (1 - 31). Characters might be different in some locales. */
	      this.dates = null;
	
	      /** Index of the first day of the week. 0 = Sunday, 1 = Monday, etc. */
	      this.firstDayOfWeek = 0;
	
	      /**
	       * Function that converts the date portion of a Date to a string.
	       * @type {(function(Date): string)}
	       */
	      this.formatDate = null;
	
	      /**
	       * Function that converts a date string to a Date object (the date portion)
	       * @type {function(string): Date}
	       */
	      this.parseDate = null;
	
	      /**
	       * Function that formats a Date into a month header string.
	       * @type {function(Date): string}
	       */
	      this.monthHeaderFormatter = null;
	
	      /**
	       * Function that formats a week number into a label for the week.
	       * @type {function(number): string}
	       */
	      this.weekNumberFormatter = null;
	
	      /**
	       * Function that formats a date into a long aria-label that is read
	       * when the focused date changes.
	       * @type {function(Date): string}
	       */
	      this.longDateFormatter = null;
	
	      /**
	       * ARIA label for the calendar "dialog" used in the datepicker.
	       * @type {string}
	       */
	      this.msgCalendar = '';
	
	      /**
	       * ARIA label for the datepicker's "Open calendar" buttons.
	       * @type {string}
	       */
	      this.msgOpenCalendar = '';
	    }
	
	    /**
	     * Factory function that returns an instance of the dateLocale service.
	     * @ngInject
	     * @param $locale
	     * @returns {DateLocale}
	     */
	    DateLocaleProvider.prototype.$get = function($locale, $filter) {
	      /**
	       * Default date-to-string formatting function.
	       * @param {!Date} date
	       * @param {string=} timezone
	       * @returns {string}
	       */
	      function defaultFormatDate(date, timezone) {
	        if (!date) {
	          return '';
	        }
	
	        // All of the dates created through ng-material *should* be set to midnight.
	        // If we encounter a date where the localeTime shows at 11pm instead of midnight,
	        // we have run into an issue with DST where we need to increment the hour by one:
	        // var d = new Date(1992, 9, 8, 0, 0, 0);
	        // d.toLocaleString(); // == "10/7/1992, 11:00:00 PM"
	        var localeTime = date.toLocaleTimeString();
	        var formatDate = date;
	        if (date.getHours() === 0 &&
	            (localeTime.indexOf('11:') !== -1 || localeTime.indexOf('23:') !== -1)) {
	          formatDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 1, 0, 0);
	        }
	
	        return $filter('date')(formatDate, 'M/d/yyyy', timezone);
	      }
	
	      /**
	       * Default string-to-date parsing function.
	       * @param {string} dateString
	       * @returns {!Date}
	       */
	      function defaultParseDate(dateString) {
	        return new Date(dateString);
	      }
	
	      /**
	       * Default function to determine whether a string makes sense to be
	       * parsed to a Date object.
	       *
	       * This is very permissive and is just a basic sanity check to ensure that
	       * things like single integers aren't able to be parsed into dates.
	       * @param {string} dateString
	       * @returns {boolean}
	       */
	      function defaultIsDateComplete(dateString) {
	        dateString = dateString.trim();
	
	        // Looks for three chunks of content (either numbers or text) separated
	        // by delimiters.
	        var re = /^(([a-zA-Z]{3,}|[0-9]{1,4})([ \.,]+|[\/\-])){2}([a-zA-Z]{3,}|[0-9]{1,4})$/;
	        return re.test(dateString);
	      }
	
	      /**
	       * Default date-to-string formatter to get a month header.
	       * @param {!Date} date
	       * @returns {string}
	       */
	      function defaultMonthHeaderFormatter(date) {
	        return service.shortMonths[date.getMonth()] + ' ' + date.getFullYear();
	      }
	
	      /**
	       * Default formatter for a month.
	       * @param {!Date} date
	       * @returns {string}
	       */
	      function defaultMonthFormatter(date) {
	        return service.months[date.getMonth()] + ' ' + date.getFullYear();
	      }
	
	      /**
	       * Default week number formatter.
	       * @param number
	       * @returns {string}
	       */
	      function defaultWeekNumberFormatter(number) {
	        return 'Week ' + number;
	      }
	
	      /**
	       * Default formatter for date cell aria-labels.
	       * @param {!Date} date
	       * @returns {string}
	       */
	      function defaultLongDateFormatter(date) {
	        // Example: 'Thursday June 18 2015'
	        return [
	          service.days[date.getDay()],
	          service.months[date.getMonth()],
	          service.dates[date.getDate()],
	          date.getFullYear()
	        ].join(' ');
	      }
	
	      // The default "short" day strings are the first character of each day,
	      // e.g., "Monday" => "M".
	      var defaultShortDays = $locale.DATETIME_FORMATS.SHORTDAY.map(function(day) {
	        return day.substring(0, 1);
	      });
	
	      // The default dates are simply the numbers 1 through 31.
	      var defaultDates = Array(32);
	      for (var i = 1; i <= 31; i++) {
	        defaultDates[i] = i;
	      }
	
	      // Default ARIA messages are in English (US).
	      var defaultMsgCalendar = 'Calendar';
	      var defaultMsgOpenCalendar = 'Open calendar';
	
	      // Default start/end dates that are rendered in the calendar.
	      var defaultFirstRenderableDate = new Date(1880, 0, 1);
	      var defaultLastRendereableDate = new Date(defaultFirstRenderableDate.getFullYear() + 250, 0, 1);
	
	      var service = {
	        months: this.months || $locale.DATETIME_FORMATS.MONTH,
	        shortMonths: this.shortMonths || $locale.DATETIME_FORMATS.SHORTMONTH,
	        days: this.days || $locale.DATETIME_FORMATS.DAY,
	        shortDays: this.shortDays || defaultShortDays,
	        dates: this.dates || defaultDates,
	        firstDayOfWeek: this.firstDayOfWeek || 0,
	        formatDate: this.formatDate || defaultFormatDate,
	        parseDate: this.parseDate || defaultParseDate,
	        isDateComplete: this.isDateComplete || defaultIsDateComplete,
	        monthHeaderFormatter: this.monthHeaderFormatter || defaultMonthHeaderFormatter,
	        monthFormatter: this.monthFormatter || defaultMonthFormatter,
	        weekNumberFormatter: this.weekNumberFormatter || defaultWeekNumberFormatter,
	        longDateFormatter: this.longDateFormatter || defaultLongDateFormatter,
	        msgCalendar: this.msgCalendar || defaultMsgCalendar,
	        msgOpenCalendar: this.msgOpenCalendar || defaultMsgOpenCalendar,
	        firstRenderableDate: this.firstRenderableDate || defaultFirstRenderableDate,
	        lastRenderableDate: this.lastRenderableDate || defaultLastRendereableDate
	      };
	
	      return service;
	    };
	    DateLocaleProvider.prototype.$get.$inject = ["$locale", "$filter"];
	
	    $provide.provider('$mdDateLocale', new DateLocaleProvider());
	  }]);
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * Utility for performing date calculations to facilitate operation of the calendar and
	   * datepicker.
	   */
	  angular.module('material.components.datepicker').factory('$$mdDateUtil', function() {
	    return {
	      getFirstDateOfMonth: getFirstDateOfMonth,
	      getNumberOfDaysInMonth: getNumberOfDaysInMonth,
	      getDateInNextMonth: getDateInNextMonth,
	      getDateInPreviousMonth: getDateInPreviousMonth,
	      isInNextMonth: isInNextMonth,
	      isInPreviousMonth: isInPreviousMonth,
	      getDateMidpoint: getDateMidpoint,
	      isSameMonthAndYear: isSameMonthAndYear,
	      getWeekOfMonth: getWeekOfMonth,
	      incrementDays: incrementDays,
	      incrementMonths: incrementMonths,
	      getLastDateOfMonth: getLastDateOfMonth,
	      isSameDay: isSameDay,
	      getMonthDistance: getMonthDistance,
	      isValidDate: isValidDate,
	      setDateTimeToMidnight: setDateTimeToMidnight,
	      createDateAtMidnight: createDateAtMidnight,
	      isDateWithinRange: isDateWithinRange,
	      incrementYears: incrementYears,
	      getYearDistance: getYearDistance,
	      clampDate: clampDate,
	      getTimestampFromNode: getTimestampFromNode,
	      isMonthWithinRange: isMonthWithinRange
	    };
	
	    /**
	     * Gets the first day of the month for the given date's month.
	     * @param {Date} date
	     * @returns {Date}
	     */
	    function getFirstDateOfMonth(date) {
	      return new Date(date.getFullYear(), date.getMonth(), 1);
	    }
	
	    /**
	     * Gets the number of days in the month for the given date's month.
	     * @param date
	     * @returns {number}
	     */
	    function getNumberOfDaysInMonth(date) {
	      return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
	    }
	
	    /**
	     * Get an arbitrary date in the month after the given date's month.
	     * @param date
	     * @returns {Date}
	     */
	    function getDateInNextMonth(date) {
	      return new Date(date.getFullYear(), date.getMonth() + 1, 1);
	    }
	
	    /**
	     * Get an arbitrary date in the month before the given date's month.
	     * @param date
	     * @returns {Date}
	     */
	    function getDateInPreviousMonth(date) {
	      return new Date(date.getFullYear(), date.getMonth() - 1, 1);
	    }
	
	    /**
	     * Gets whether two dates have the same month and year.
	     * @param {Date} d1
	     * @param {Date} d2
	     * @returns {boolean}
	     */
	    function isSameMonthAndYear(d1, d2) {
	      return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth();
	    }
	
	    /**
	     * Gets whether two dates are the same day (not not necesarily the same time).
	     * @param {Date} d1
	     * @param {Date} d2
	     * @returns {boolean}
	     */
	    function isSameDay(d1, d2) {
	      return d1.getDate() == d2.getDate() && isSameMonthAndYear(d1, d2);
	    }
	
	    /**
	     * Gets whether a date is in the month immediately after some date.
	     * @param {Date} startDate The date from which to compare.
	     * @param {Date} endDate The date to check.
	     * @returns {boolean}
	     */
	    function isInNextMonth(startDate, endDate) {
	      var nextMonth = getDateInNextMonth(startDate);
	      return isSameMonthAndYear(nextMonth, endDate);
	    }
	
	    /**
	     * Gets whether a date is in the month immediately before some date.
	     * @param {Date} startDate The date from which to compare.
	     * @param {Date} endDate The date to check.
	     * @returns {boolean}
	     */
	    function isInPreviousMonth(startDate, endDate) {
	      var previousMonth = getDateInPreviousMonth(startDate);
	      return isSameMonthAndYear(endDate, previousMonth);
	    }
	
	    /**
	     * Gets the midpoint between two dates.
	     * @param {Date} d1
	     * @param {Date} d2
	     * @returns {Date}
	     */
	    function getDateMidpoint(d1, d2) {
	      return createDateAtMidnight((d1.getTime() + d2.getTime()) / 2);
	    }
	
	    /**
	     * Gets the week of the month that a given date occurs in.
	     * @param {Date} date
	     * @returns {number} Index of the week of the month (zero-based).
	     */
	    function getWeekOfMonth(date) {
	      var firstDayOfMonth = getFirstDateOfMonth(date);
	      return Math.floor((firstDayOfMonth.getDay() + date.getDate() - 1) / 7);
	    }
	
	    /**
	     * Gets a new date incremented by the given number of days. Number of days can be negative.
	     * @param {Date} date
	     * @param {number} numberOfDays
	     * @returns {Date}
	     */
	    function incrementDays(date, numberOfDays) {
	      return new Date(date.getFullYear(), date.getMonth(), date.getDate() + numberOfDays);
	    }
	
	    /**
	     * Gets a new date incremented by the given number of months. Number of months can be negative.
	     * If the date of the given month does not match the target month, the date will be set to the
	     * last day of the month.
	     * @param {Date} date
	     * @param {number} numberOfMonths
	     * @returns {Date}
	     */
	    function incrementMonths(date, numberOfMonths) {
	      // If the same date in the target month does not actually exist, the Date object will
	      // automatically advance *another* month by the number of missing days.
	      // For example, if you try to go from Jan. 30 to Feb. 30, you'll end up on March 2.
	      // So, we check if the month overflowed and go to the last day of the target month instead.
	      var dateInTargetMonth = new Date(date.getFullYear(), date.getMonth() + numberOfMonths, 1);
	      var numberOfDaysInMonth = getNumberOfDaysInMonth(dateInTargetMonth);
	      if (numberOfDaysInMonth < date.getDate()) {
	        dateInTargetMonth.setDate(numberOfDaysInMonth);
	      } else {
	        dateInTargetMonth.setDate(date.getDate());
	      }
	
	      return dateInTargetMonth;
	    }
	
	    /**
	     * Get the integer distance between two months. This *only* considers the month and year
	     * portion of the Date instances.
	     *
	     * @param {Date} start
	     * @param {Date} end
	     * @returns {number} Number of months between `start` and `end`. If `end` is before `start`
	     *     chronologically, this number will be negative.
	     */
	    function getMonthDistance(start, end) {
	      return (12 * (end.getFullYear() - start.getFullYear())) + (end.getMonth() - start.getMonth());
	    }
	
	    /**
	     * Gets the last day of the month for the given date.
	     * @param {Date} date
	     * @returns {Date}
	     */
	    function getLastDateOfMonth(date) {
	      return new Date(date.getFullYear(), date.getMonth(), getNumberOfDaysInMonth(date));
	    }
	
	    /**
	     * Checks whether a date is valid.
	     * @param {Date} date
	     * @return {boolean} Whether the date is a valid Date.
	     */
	    function isValidDate(date) {
	      return date && date.getTime && !isNaN(date.getTime());
	    }
	
	    /**
	     * Sets a date's time to midnight.
	     * @param {Date} date
	     */
	    function setDateTimeToMidnight(date) {
	      if (isValidDate(date)) {
	        date.setHours(0, 0, 0, 0);
	      }
	    }
	
	    /**
	     * Creates a date with the time set to midnight.
	     * Drop-in replacement for two forms of the Date constructor:
	     * 1. No argument for Date representing now.
	     * 2. Single-argument value representing number of seconds since Unix Epoch
	     * or a Date object.
	     * @param {number|Date=} opt_value
	     * @return {Date} New date with time set to midnight.
	     */
	    function createDateAtMidnight(opt_value) {
	      var date;
	      if (angular.isUndefined(opt_value)) {
	        date = new Date();
	      } else {
	        date = new Date(opt_value);
	      }
	      setDateTimeToMidnight(date);
	      return date;
	    }
	
	     /**
	      * Checks if a date is within a min and max range, ignoring the time component.
	      * If minDate or maxDate are not dates, they are ignored.
	      * @param {Date} date
	      * @param {Date} minDate
	      * @param {Date} maxDate
	      */
	     function isDateWithinRange(date, minDate, maxDate) {
	       var dateAtMidnight = createDateAtMidnight(date);
	       var minDateAtMidnight = isValidDate(minDate) ? createDateAtMidnight(minDate) : null;
	       var maxDateAtMidnight = isValidDate(maxDate) ? createDateAtMidnight(maxDate) : null;
	       return (!minDateAtMidnight || minDateAtMidnight <= dateAtMidnight) &&
	           (!maxDateAtMidnight || maxDateAtMidnight >= dateAtMidnight);
	     }
	
	    /**
	     * Gets a new date incremented by the given number of years. Number of years can be negative.
	     * See `incrementMonths` for notes on overflow for specific dates.
	     * @param {Date} date
	     * @param {number} numberOfYears
	     * @returns {Date}
	     */
	     function incrementYears(date, numberOfYears) {
	       return incrementMonths(date, numberOfYears * 12);
	     }
	
	     /**
	      * Get the integer distance between two years. This *only* considers the year portion of the
	      * Date instances.
	      *
	      * @param {Date} start
	      * @param {Date} end
	      * @returns {number} Number of months between `start` and `end`. If `end` is before `start`
	      *     chronologically, this number will be negative.
	      */
	     function getYearDistance(start, end) {
	       return end.getFullYear() - start.getFullYear();
	     }
	
	     /**
	      * Clamps a date between a minimum and a maximum date.
	      * @param {Date} date Date to be clamped
	      * @param {Date=} minDate Minimum date
	      * @param {Date=} maxDate Maximum date
	      * @return {Date}
	      */
	     function clampDate(date, minDate, maxDate) {
	       var boundDate = date;
	       if (minDate && date < minDate) {
	         boundDate = new Date(minDate.getTime());
	       }
	       if (maxDate && date > maxDate) {
	         boundDate = new Date(maxDate.getTime());
	       }
	       return boundDate;
	     }
	
	     /**
	      * Extracts and parses the timestamp from a DOM node.
	      * @param  {HTMLElement} node Node from which the timestamp will be extracted.
	      * @return {number} Time since epoch.
	      */
	     function getTimestampFromNode(node) {
	       if (node && node.hasAttribute('data-timestamp')) {
	         return Number(node.getAttribute('data-timestamp'));
	       }
	     }
	
	     /**
	      * Checks if a month is within a min and max range, ignoring the date and time components.
	      * If minDate or maxDate are not dates, they are ignored.
	      * @param {Date} date
	      * @param {Date} minDate
	      * @param {Date} maxDate
	      */
	     function isMonthWithinRange(date, minDate, maxDate) {
	       var month = date.getMonth();
	       var year = date.getFullYear();
	
	       return (!minDate || minDate.getFullYear() < year || minDate.getMonth() <= month) &&
	        (!maxDate || maxDate.getFullYear() > year || maxDate.getMonth() >= month);
	     }
	  });
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  // POST RELEASE
	  // TODO(jelbourn): Demo that uses moment.js
	  // TODO(jelbourn): make sure this plays well with validation and ngMessages.
	  // TODO(jelbourn): calendar pane doesn't open up outside of visible viewport.
	  // TODO(jelbourn): forward more attributes to the internal input (required, autofocus, etc.)
	  // TODO(jelbourn): something better for mobile (calendar panel takes up entire screen?)
	  // TODO(jelbourn): input behavior (masking? auto-complete?)
	
	
	  DatePickerCtrl.$inject = ["$scope", "$element", "$attrs", "$window", "$mdConstant", "$mdTheming", "$mdUtil", "$mdDateLocale", "$$mdDateUtil", "$$rAF", "$filter"];
	  datePickerDirective.$inject = ["$$mdSvgRegistry", "$mdUtil", "$mdAria", "inputDirective"];
	  angular.module('material.components.datepicker')
	      .directive('mdDatepicker', datePickerDirective);
	
	  /**
	   * @ngdoc directive
	   * @name mdDatepicker
	   * @module material.components.datepicker
	   *
	   * @param {Date} ng-model The component's model. Expects either a JavaScript Date object or a value that can be parsed into one (e.g. a ISO 8601 string).
	   * @param {Object=} ng-model-options Allows tuning of the way in which `ng-model` is being updated. Also allows
	   * for a timezone to be specified. <a href="https://docs.angularjs.org/api/ng/directive/ngModelOptions#usage">Read more at the ngModelOptions docs.</a>
	   * @param {expression=} ng-change Expression evaluated when the model value changes.
	   * @param {expression=} ng-focus Expression evaluated when the input is focused or the calendar is opened.
	   * @param {expression=} ng-blur Expression evaluated when focus is removed from the input or the calendar is closed.
	   * @param {boolean=} ng-disabled Whether the datepicker is disabled.
	   * @param {boolean=} ng-required Whether a value is required for the datepicker.
	   * @param {Date=} md-min-date Expression representing a min date (inclusive).
	   * @param {Date=} md-max-date Expression representing a max date (inclusive).
	   * @param {(function(Date): boolean)=} md-date-filter Function expecting a date and returning a boolean whether it can be selected or not.
	   * @param {String=} md-placeholder The date input placeholder value.
	   * @param {String=} md-open-on-focus When present, the calendar will be opened when the input is focused.
	   * @param {Boolean=} md-is-open Expression that can be used to open the datepicker's calendar on-demand.
	   * @param {String=} md-current-view Default open view of the calendar pane. Can be either "month" or "year".
	   * @param {String=} md-hide-icons Determines which datepicker icons should be hidden. Note that this may cause the
	   * datepicker to not align properly with other components. **Use at your own risk.** Possible values are:
	   * * `"all"` - Hides all icons.
	   * * `"calendar"` - Only hides the calendar icon.
	   * * `"triangle"` - Only hides the triangle icon.
	   * @param {Object=} md-date-locale Allows for the values from the `$mdDateLocaleProvider` to be
	   * ovewritten on a per-element basis (e.g. `msgOpenCalendar` can be overwritten with
	   * `md-date-locale="{ msgOpenCalendar: 'Open a special calendar' }"`).
	   *
	   * @description
	   * `<md-datepicker>` is a component used to select a single date.
	   * For information on how to configure internationalization for the date picker,
	   * see `$mdDateLocaleProvider`.
	   *
	   * This component supports [ngMessages](https://docs.angularjs.org/api/ngMessages/directive/ngMessages).
	   * Supported attributes are:
	   * * `required`: whether a required date is not set.
	   * * `mindate`: whether the selected date is before the minimum allowed date.
	   * * `maxdate`: whether the selected date is after the maximum allowed date.
	   * * `debounceInterval`: ms to delay input processing (since last debounce reset); default value 500ms
	   *
	   * @usage
	   * <hljs lang="html">
	   *   <md-datepicker ng-model="birthday"></md-datepicker>
	   * </hljs>
	   *
	   */
	
	  function datePickerDirective($$mdSvgRegistry, $mdUtil, $mdAria, inputDirective) {
	    return {
	      template: function(tElement, tAttrs) {
	        // Buttons are not in the tab order because users can open the calendar via keyboard
	        // interaction on the text input, and multiple tab stops for one component (picker)
	        // may be confusing.
	        var hiddenIcons = tAttrs.mdHideIcons;
	        var ariaLabelValue = tAttrs.ariaLabel || tAttrs.mdPlaceholder;
	
	        var calendarButton = (hiddenIcons === 'all' || hiddenIcons === 'calendar') ? '' :
	          '<md-button class="md-datepicker-button md-icon-button" type="button" ' +
	              'tabindex="-1" aria-hidden="true" ' +
	              'ng-click="ctrl.openCalendarPane($event)">' +
	            '<md-icon class="md-datepicker-calendar-icon" aria-label="md-calendar" ' +
	                     'md-svg-src="' + $$mdSvgRegistry.mdCalendar + '"></md-icon>' +
	          '</md-button>';
	
	        var triangleButton = '';
	
	        if (hiddenIcons !== 'all' && hiddenIcons !== 'triangle') {
	          triangleButton = '' +
	            '<md-button type="button" md-no-ink ' +
	              'class="md-datepicker-triangle-button md-icon-button" ' +
	              'ng-click="ctrl.openCalendarPane($event)" ' +
	              'aria-label="{{::ctrl.locale.msgOpenCalendar}}">' +
	            '<div class="md-datepicker-expand-triangle"></div>' +
	          '</md-button>';
	
	          tElement.addClass(HAS_TRIANGLE_ICON_CLASS);
	        }
	
	        return calendarButton +
	        '<div class="md-datepicker-input-container" ng-class="{\'md-datepicker-focused\': ctrl.isFocused}">' +
	          '<input ' +
	            (ariaLabelValue ? 'aria-label="' + ariaLabelValue + '" ' : '') +
	            'class="md-datepicker-input" ' +
	            'aria-haspopup="true" ' +
	            'aria-expanded="{{ctrl.isCalendarOpen}}" ' +
	            'ng-focus="ctrl.setFocused(true)" ' +
	            'ng-blur="ctrl.setFocused(false)"> ' +
	            triangleButton +
	        '</div>' +
	
	        // This pane will be detached from here and re-attached to the document body.
	        '<div class="md-datepicker-calendar-pane md-whiteframe-z1" id="{{::ctrl.calendarPaneId}}">' +
	          '<div class="md-datepicker-input-mask">' +
	            '<div class="md-datepicker-input-mask-opaque"></div>' +
	          '</div>' +
	          '<div class="md-datepicker-calendar">' +
	            '<md-calendar role="dialog" aria-label="{{::ctrl.locale.msgCalendar}}" ' +
	                'md-current-view="{{::ctrl.currentView}}"' +
	                'md-min-date="ctrl.minDate"' +
	                'md-max-date="ctrl.maxDate"' +
	                'md-date-filter="ctrl.dateFilter"' +
	                'ng-model="ctrl.date" ng-if="ctrl.isCalendarOpen">' +
	            '</md-calendar>' +
	          '</div>' +
	        '</div>';
	      },
	      require: ['ngModel', 'mdDatepicker', '?^mdInputContainer', '?^form'],
	      scope: {
	        minDate: '=mdMinDate',
	        maxDate: '=mdMaxDate',
	        placeholder: '@mdPlaceholder',
	        currentView: '@mdCurrentView',
	        dateFilter: '=mdDateFilter',
	        isOpen: '=?mdIsOpen',
	        debounceInterval: '=mdDebounceInterval',
	        dateLocale: '=mdDateLocale'
	      },
	      controller: DatePickerCtrl,
	      controllerAs: 'ctrl',
	      bindToController: true,
	      link: function(scope, element, attr, controllers) {
	        var ngModelCtrl = controllers[0];
	        var mdDatePickerCtrl = controllers[1];
	        var mdInputContainer = controllers[2];
	        var parentForm = controllers[3];
	        var mdNoAsterisk = $mdUtil.parseAttributeBoolean(attr.mdNoAsterisk);
	
	        mdDatePickerCtrl.configureNgModel(ngModelCtrl, mdInputContainer, inputDirective);
	
	        if (mdInputContainer) {
	          // We need to move the spacer after the datepicker itself,
	          // because md-input-container adds it after the
	          // md-datepicker-input by default. The spacer gets wrapped in a
	          // div, because it floats and gets aligned next to the datepicker.
	          // There are easier ways of working around this with CSS (making the
	          // datepicker 100% wide, change the `display` etc.), however they
	          // break the alignment with any other form controls.
	          var spacer = element[0].querySelector('.md-errors-spacer');
	
	          if (spacer) {
	            element.after(angular.element('<div>').append(spacer));
	          }
	
	          mdInputContainer.setHasPlaceholder(attr.mdPlaceholder);
	          mdInputContainer.input = element;
	          mdInputContainer.element
	            .addClass(INPUT_CONTAINER_CLASS)
	            .toggleClass(HAS_CALENDAR_ICON_CLASS, attr.mdHideIcons !== 'calendar' && attr.mdHideIcons !== 'all');
	
	          if (!mdInputContainer.label) {
	            $mdAria.expect(element, 'aria-label', attr.mdPlaceholder);
	          } else if(!mdNoAsterisk) {
	            attr.$observe('required', function(value) {
	              mdInputContainer.label.toggleClass('md-required', !!value);
	            });
	          }
	
	          scope.$watch(mdInputContainer.isErrorGetter || function() {
	            return ngModelCtrl.$invalid && (ngModelCtrl.$touched || (parentForm && parentForm.$submitted));
	          }, mdInputContainer.setInvalid);
	        } else if (parentForm) {
	          // If invalid, highlights the input when the parent form is submitted.
	          var parentSubmittedWatcher = scope.$watch(function() {
	            return parentForm.$submitted;
	          }, function(isSubmitted) {
	            if (isSubmitted) {
	              mdDatePickerCtrl.updateErrorState();
	              parentSubmittedWatcher();
	            }
	          });
	        }
	      }
	    };
	  }
	
	  /** Additional offset for the input's `size` attribute, which is updated based on its content. */
	  var EXTRA_INPUT_SIZE = 3;
	
	  /** Class applied to the container if the date is invalid. */
	  var INVALID_CLASS = 'md-datepicker-invalid';
	
	  /** Class applied to the datepicker when it's open. */
	  var OPEN_CLASS = 'md-datepicker-open';
	
	  /** Class applied to the md-input-container, if a datepicker is placed inside it */
	  var INPUT_CONTAINER_CLASS = '_md-datepicker-floating-label';
	
	  /** Class to be applied when the calendar icon is enabled. */
	  var HAS_CALENDAR_ICON_CLASS = '_md-datepicker-has-calendar-icon';
	
	  /** Class to be applied when the triangle icon is enabled. */
	  var HAS_TRIANGLE_ICON_CLASS = '_md-datepicker-has-triangle-icon';
	
	  /** Default time in ms to debounce input event by. */
	  var DEFAULT_DEBOUNCE_INTERVAL = 500;
	
	  /**
	   * Height of the calendar pane used to check if the pane is going outside the boundary of
	   * the viewport. See calendar.scss for how $md-calendar-height is computed; an extra 20px is
	   * also added to space the pane away from the exact edge of the screen.
	   *
	   *  This is computed statically now, but can be changed to be measured if the circumstances
	   *  of calendar sizing are changed.
	   */
	  var CALENDAR_PANE_HEIGHT = 368;
	
	  /**
	   * Width of the calendar pane used to check if the pane is going outside the boundary of
	   * the viewport. See calendar.scss for how $md-calendar-width is computed; an extra 20px is
	   * also added to space the pane away from the exact edge of the screen.
	   *
	   *  This is computed statically now, but can be changed to be measured if the circumstances
	   *  of calendar sizing are changed.
	   */
	  var CALENDAR_PANE_WIDTH = 360;
	
	  /** Used for checking whether the current user agent is on iOS or Android. */
	  var IS_MOBILE_REGEX = /ipad|iphone|ipod|android/i;
	
	  /**
	   * Controller for md-datepicker.
	   *
	   * @ngInject @constructor
	   */
	  function DatePickerCtrl($scope, $element, $attrs, $window, $mdConstant,
	    $mdTheming, $mdUtil, $mdDateLocale, $$mdDateUtil, $$rAF, $filter) {
	
	    /** @final */
	    this.$window = $window;
	
	    /** @final */
	    this.dateUtil = $$mdDateUtil;
	
	    /** @final */
	    this.$mdConstant = $mdConstant;
	
	    /* @final */
	    this.$mdUtil = $mdUtil;
	
	    /** @final */
	    this.$$rAF = $$rAF;
	
	    /** @final */
	    this.$mdDateLocale = $mdDateLocale;
	
	    /**
	     * The root document element. This is used for attaching a top-level click handler to
	     * close the calendar panel when a click outside said panel occurs. We use `documentElement`
	     * instead of body because, when scrolling is disabled, some browsers consider the body element
	     * to be completely off the screen and propagate events directly to the html element.
	     * @type {!angular.JQLite}
	     */
	    this.documentElement = angular.element(document.documentElement);
	
	    /** @type {!angular.NgModelController} */
	    this.ngModelCtrl = null;
	
	    /** @type {HTMLInputElement} */
	    this.inputElement = $element[0].querySelector('input');
	
	    /** @final {!angular.JQLite} */
	    this.ngInputElement = angular.element(this.inputElement);
	
	    /** @type {HTMLElement} */
	    this.inputContainer = $element[0].querySelector('.md-datepicker-input-container');
	
	    /** @type {HTMLElement} Floating calendar pane. */
	    this.calendarPane = $element[0].querySelector('.md-datepicker-calendar-pane');
	
	    /** @type {HTMLElement} Calendar icon button. */
	    this.calendarButton = $element[0].querySelector('.md-datepicker-button');
	
	    /**
	     * Element covering everything but the input in the top of the floating calendar pane.
	     * @type {!angular.JQLite}
	     */
	    this.inputMask = angular.element($element[0].querySelector('.md-datepicker-input-mask-opaque'));
	
	    /** @final {!angular.JQLite} */
	    this.$element = $element;
	
	    /** @final {!angular.Attributes} */
	    this.$attrs = $attrs;
	
	    /** @final {!angular.Scope} */
	    this.$scope = $scope;
	
	    /** @type {Date} */
	    this.date = null;
	
	    /** @type {boolean} */
	    this.isFocused = false;
	
	    /** @type {boolean} */
	    this.isDisabled;
	    this.setDisabled($element[0].disabled || angular.isString($attrs.disabled));
	
	    /** @type {boolean} Whether the date-picker's calendar pane is open. */
	    this.isCalendarOpen = false;
	
	    /** @type {boolean} Whether the calendar should open when the input is focused. */
	    this.openOnFocus = $attrs.hasOwnProperty('mdOpenOnFocus');
	
	    /** @final */
	    this.mdInputContainer = null;
	
	    /**
	     * Element from which the calendar pane was opened. Keep track of this so that we can return
	     * focus to it when the pane is closed.
	     * @type {HTMLElement}
	     */
	    this.calendarPaneOpenedFrom = null;
	
	    /** @type {String} Unique id for the calendar pane. */
	    this.calendarPaneId = 'md-date-pane-' + $mdUtil.nextUid();
	
	    /** Pre-bound click handler is saved so that the event listener can be removed. */
	    this.bodyClickHandler = angular.bind(this, this.handleBodyClick);
	
	    /**
	     * Name of the event that will trigger a close. Necessary to sniff the browser, because
	     * the resize event doesn't make sense on mobile and can have a negative impact since it
	     * triggers whenever the browser zooms in on a focused input.
	     */
	    this.windowEventName = IS_MOBILE_REGEX.test(
	      navigator.userAgent || navigator.vendor || window.opera
	    ) ? 'orientationchange' : 'resize';
	
	    /** Pre-bound close handler so that the event listener can be removed. */
	    this.windowEventHandler = $mdUtil.debounce(angular.bind(this, this.closeCalendarPane), 100);
	
	    /** Pre-bound handler for the window blur event. Allows for it to be removed later. */
	    this.windowBlurHandler = angular.bind(this, this.handleWindowBlur);
	
	    /** The built-in AngularJS date filter. */
	    this.ngDateFilter = $filter('date');
	
	    /** @type {Number} Extra margin for the left side of the floating calendar pane. */
	    this.leftMargin = 20;
	
	    /** @type {Number} Extra margin for the top of the floating calendar. Gets determined on the first open. */
	    this.topMargin = null;
	
	    // Unless the user specifies so, the datepicker should not be a tab stop.
	    // This is necessary because ngAria might add a tabindex to anything with an ng-model
	    // (based on whether or not the user has turned that particular feature on/off).
	    if ($attrs.tabindex) {
	      this.ngInputElement.attr('tabindex', $attrs.tabindex);
	      $attrs.$set('tabindex', null);
	    } else {
	      $attrs.$set('tabindex', '-1');
	    }
	
	    $attrs.$set('aria-owns', this.calendarPaneId);
	
	    $mdTheming($element);
	    $mdTheming(angular.element(this.calendarPane));
	
	    var self = this;
	
	    $scope.$on('$destroy', function() {
	      self.detachCalendarPane();
	    });
	
	    if ($attrs.mdIsOpen) {
	      $scope.$watch('ctrl.isOpen', function(shouldBeOpen) {
	        if (shouldBeOpen) {
	          self.openCalendarPane({
	            target: self.inputElement
	          });
	        } else {
	          self.closeCalendarPane();
	        }
	      });
	    }
	
	    // For AngularJS 1.4 and older, where there are no lifecycle hooks but bindings are pre-assigned,
	    // manually call the $onInit hook.
	    if (angular.version.major === 1 && angular.version.minor <= 4) {
	      this.$onInit();
	    }
	
	  }
	
	  /**
	   * AngularJS Lifecycle hook for newer AngularJS versions.
	   * Bindings are not guaranteed to have been assigned in the controller, but they are in the $onInit hook.
	   */
	  DatePickerCtrl.prototype.$onInit = function() {
	
	    /**
	     * Holds locale-specific formatters, parsers, labels etc. Allows
	     * the user to override specific ones from the $mdDateLocale provider.
	     * @type {!Object}
	     */
	    this.locale = this.dateLocale ? angular.extend({}, this.$mdDateLocale, this.dateLocale) : this.$mdDateLocale;
	
	    this.installPropertyInterceptors();
	    this.attachChangeListeners();
	    this.attachInteractionListeners();
	  };
	
	  /**
	   * Sets up the controller's reference to ngModelController and
	   * applies AngularJS's `input[type="date"]` directive.
	   * @param {!angular.NgModelController} ngModelCtrl Instance of the ngModel controller.
	   * @param {Object} mdInputContainer Instance of the mdInputContainer controller.
	   * @param {Object} inputDirective Config for AngularJS's `input` directive.
	   */
	  DatePickerCtrl.prototype.configureNgModel = function(ngModelCtrl, mdInputContainer, inputDirective) {
	    this.ngModelCtrl = ngModelCtrl;
	    this.mdInputContainer = mdInputContainer;
	
	    // The input needs to be [type="date"] in order to be picked up by AngularJS.
	    this.$attrs.$set('type', 'date');
	
	    // Invoke the `input` directive link function, adding a stub for the element.
	    // This allows us to re-use AngularJS's logic for setting the timezone via ng-model-options.
	    // It works by calling the link function directly which then adds the proper `$parsers` and
	    // `$formatters` to the ngModel controller.
	    inputDirective[0].link.pre(this.$scope, {
	      on: angular.noop,
	      val: angular.noop,
	      0: {}
	    }, this.$attrs, [ngModelCtrl]);
	
	    var self = this;
	
	    // Responds to external changes to the model value.
	    self.ngModelCtrl.$formatters.push(function(value) {
	      var parsedValue = angular.isDefined(value) ? Date.parse(value) : null;
	
	      // `parsedValue` is the time since epoch if valid or `NaN` if invalid.
	      if (!isNaN(parsedValue) && angular.isNumber(parsedValue)) {
	        value = new Date(parsedValue);
	      }
	
	      if (value && !(value instanceof Date)) {
	        throw Error(
	          'The ng-model for md-datepicker must be a Date instance or a value ' +
	          'that can be parsed into a date. Currently the model is of type: ' + typeof value
	        );
	      }
	
	      self.onExternalChange(value);
	
	      return value;
	    });
	
	    // Responds to external error state changes (e.g. ng-required based on another input).
	    ngModelCtrl.$viewChangeListeners.unshift(angular.bind(this, this.updateErrorState));
	
	    // Forwards any events from the input to the root element. This is necessary to get `updateOn`
	    // working for events that don't bubble (e.g. 'blur') since AngularJS binds the handlers to
	    // the `<md-datepicker>`.
	    var updateOn = self.$mdUtil.getModelOption(ngModelCtrl, 'updateOn');
	
	    if (updateOn) {
	      this.ngInputElement.on(
	        updateOn,
	        angular.bind(this.$element, this.$element.triggerHandler, updateOn)
	      );
	    }
	  };
	
	  /**
	   * Attach event listeners for both the text input and the md-calendar.
	   * Events are used instead of ng-model so that updates don't infinitely update the other
	   * on a change. This should also be more performant than using a $watch.
	   */
	  DatePickerCtrl.prototype.attachChangeListeners = function() {
	    var self = this;
	
	    self.$scope.$on('md-calendar-change', function(event, date) {
	      self.setModelValue(date);
	      self.onExternalChange(date);
	      self.closeCalendarPane();
	    });
	
	    self.ngInputElement.on('input', angular.bind(self, self.resizeInputElement));
	
	    var debounceInterval = angular.isDefined(this.debounceInterval) ?
	        this.debounceInterval : DEFAULT_DEBOUNCE_INTERVAL;
	    self.ngInputElement.on('input', self.$mdUtil.debounce(self.handleInputEvent,
	        debounceInterval, self));
	  };
	
	  /** Attach event listeners for user interaction. */
	  DatePickerCtrl.prototype.attachInteractionListeners = function() {
	    var self = this;
	    var $scope = this.$scope;
	    var keyCodes = this.$mdConstant.KEY_CODE;
	
	    // Add event listener through angular so that we can triggerHandler in unit tests.
	    self.ngInputElement.on('keydown', function(event) {
	      if (event.altKey && event.keyCode == keyCodes.DOWN_ARROW) {
	        self.openCalendarPane(event);
	        $scope.$digest();
	      }
	    });
	
	    if (self.openOnFocus) {
	      self.ngInputElement.on('focus', angular.bind(self, self.openCalendarPane));
	      angular.element(self.$window).on('blur', self.windowBlurHandler);
	
	      $scope.$on('$destroy', function() {
	        angular.element(self.$window).off('blur', self.windowBlurHandler);
	      });
	    }
	
	    $scope.$on('md-calendar-close', function() {
	      self.closeCalendarPane();
	    });
	  };
	
	  /**
	   * Capture properties set to the date-picker and imperitively handle internal changes.
	   * This is done to avoid setting up additional $watches.
	   */
	  DatePickerCtrl.prototype.installPropertyInterceptors = function() {
	    var self = this;
	
	    if (this.$attrs.ngDisabled) {
	      // The expression is to be evaluated against the directive element's scope and not
	      // the directive's isolate scope.
	      var scope = this.$scope.$parent;
	
	      if (scope) {
	        scope.$watch(this.$attrs.ngDisabled, function(isDisabled) {
	          self.setDisabled(isDisabled);
	        });
	      }
	    }
	
	    Object.defineProperty(this, 'placeholder', {
	      get: function() { return self.inputElement.placeholder; },
	      set: function(value) { self.inputElement.placeholder = value || ''; }
	    });
	  };
	
	  /**
	   * Sets whether the date-picker is disabled.
	   * @param {boolean} isDisabled
	   */
	  DatePickerCtrl.prototype.setDisabled = function(isDisabled) {
	    this.isDisabled = isDisabled;
	    this.inputElement.disabled = isDisabled;
	
	    if (this.calendarButton) {
	      this.calendarButton.disabled = isDisabled;
	    }
	  };
	
	  /**
	   * Sets the custom ngModel.$error flags to be consumed by ngMessages. Flags are:
	   *   - mindate: whether the selected date is before the minimum date.
	   *   - maxdate: whether the selected flag is after the maximum date.
	   *   - filtered: whether the selected date is allowed by the custom filtering function.
	   *   - valid: whether the entered text input is a valid date
	   *
	   * The 'required' flag is handled automatically by ngModel.
	   *
	   * @param {Date=} opt_date Date to check. If not given, defaults to the datepicker's model value.
	   */
	  DatePickerCtrl.prototype.updateErrorState = function(opt_date) {
	    var date = opt_date || this.date;
	
	    // Clear any existing errors to get rid of anything that's no longer relevant.
	    this.clearErrorState();
	
	    if (this.dateUtil.isValidDate(date)) {
	      // Force all dates to midnight in order to ignore the time portion.
	      date = this.dateUtil.createDateAtMidnight(date);
	
	      if (this.dateUtil.isValidDate(this.minDate)) {
	        var minDate = this.dateUtil.createDateAtMidnight(this.minDate);
	        this.ngModelCtrl.$setValidity('mindate', date >= minDate);
	      }
	
	      if (this.dateUtil.isValidDate(this.maxDate)) {
	        var maxDate = this.dateUtil.createDateAtMidnight(this.maxDate);
	        this.ngModelCtrl.$setValidity('maxdate', date <= maxDate);
	      }
	
	      if (angular.isFunction(this.dateFilter)) {
	        this.ngModelCtrl.$setValidity('filtered', this.dateFilter(date));
	      }
	    } else {
	      // The date is seen as "not a valid date" if there is *something* set
	      // (i.e.., not null or undefined), but that something isn't a valid date.
	      this.ngModelCtrl.$setValidity('valid', date == null);
	    }
	
	    angular.element(this.inputContainer).toggleClass(INVALID_CLASS, !this.ngModelCtrl.$valid);
	  };
	
	  /** Clears any error flags set by `updateErrorState`. */
	  DatePickerCtrl.prototype.clearErrorState = function() {
	    this.inputContainer.classList.remove(INVALID_CLASS);
	    ['mindate', 'maxdate', 'filtered', 'valid'].forEach(function(field) {
	      this.ngModelCtrl.$setValidity(field, true);
	    }, this);
	  };
	
	  /** Resizes the input element based on the size of its content. */
	  DatePickerCtrl.prototype.resizeInputElement = function() {
	    this.inputElement.size = this.inputElement.value.length + EXTRA_INPUT_SIZE;
	  };
	
	  /**
	   * Sets the model value if the user input is a valid date.
	   * Adds an invalid class to the input element if not.
	   */
	  DatePickerCtrl.prototype.handleInputEvent = function() {
	    var inputString = this.inputElement.value;
	    var parsedDate = inputString ? this.locale.parseDate(inputString) : null;
	    this.dateUtil.setDateTimeToMidnight(parsedDate);
	
	    // An input string is valid if it is either empty (representing no date)
	    // or if it parses to a valid date that the user is allowed to select.
	    var isValidInput = inputString == '' || (
	      this.dateUtil.isValidDate(parsedDate) &&
	      this.locale.isDateComplete(inputString) &&
	      this.isDateEnabled(parsedDate)
	    );
	
	    // The datepicker's model is only updated when there is a valid input.
	    if (isValidInput) {
	      this.setModelValue(parsedDate);
	      this.date = parsedDate;
	    }
	
	    this.updateErrorState(parsedDate);
	  };
	
	  /**
	   * Check whether date is in range and enabled
	   * @param {Date=} opt_date
	   * @return {boolean} Whether the date is enabled.
	   */
	  DatePickerCtrl.prototype.isDateEnabled = function(opt_date) {
	    return this.dateUtil.isDateWithinRange(opt_date, this.minDate, this.maxDate) &&
	          (!angular.isFunction(this.dateFilter) || this.dateFilter(opt_date));
	  };
	
	  /** Position and attach the floating calendar to the document. */
	  DatePickerCtrl.prototype.attachCalendarPane = function() {
	    var calendarPane = this.calendarPane;
	    var body = document.body;
	
	    calendarPane.style.transform = '';
	    this.$element.addClass(OPEN_CLASS);
	    this.mdInputContainer && this.mdInputContainer.element.addClass(OPEN_CLASS);
	    angular.element(body).addClass('md-datepicker-is-showing');
	
	    var elementRect = this.inputContainer.getBoundingClientRect();
	    var bodyRect = body.getBoundingClientRect();
	
	    if (!this.topMargin || this.topMargin < 0) {
	      this.topMargin = (this.inputMask.parent().prop('clientHeight') - this.ngInputElement.prop('clientHeight')) / 2;
	    }
	
	    // Check to see if the calendar pane would go off the screen. If so, adjust position
	    // accordingly to keep it within the viewport.
	    var paneTop = elementRect.top - bodyRect.top - this.topMargin;
	    var paneLeft = elementRect.left - bodyRect.left - this.leftMargin;
	
	    // If ng-material has disabled body scrolling (for example, if a dialog is open),
	    // then it's possible that the already-scrolled body has a negative top/left. In this case,
	    // we want to treat the "real" top as (0 - bodyRect.top). In a normal scrolling situation,
	    // though, the top of the viewport should just be the body's scroll position.
	    var viewportTop = (bodyRect.top < 0 && document.body.scrollTop == 0) ?
	        -bodyRect.top :
	        document.body.scrollTop;
	
	    var viewportLeft = (bodyRect.left < 0 && document.body.scrollLeft == 0) ?
	        -bodyRect.left :
	        document.body.scrollLeft;
	
	    var viewportBottom = viewportTop + this.$window.innerHeight;
	    var viewportRight = viewportLeft + this.$window.innerWidth;
	
	    // Creates an overlay with a hole the same size as element. We remove a pixel or two
	    // on each end to make it overlap slightly. The overlay's background is added in
	    // the theme in the form of a box-shadow with a huge spread.
	    this.inputMask.css({
	      position: 'absolute',
	      left: this.leftMargin + 'px',
	      top: this.topMargin + 'px',
	      width: (elementRect.width - 1) + 'px',
	      height: (elementRect.height - 2) + 'px'
	    });
	
	    // If the right edge of the pane would be off the screen and shifting it left by the
	    // difference would not go past the left edge of the screen. If the calendar pane is too
	    // big to fit on the screen at all, move it to the left of the screen and scale the entire
	    // element down to fit.
	    if (paneLeft + CALENDAR_PANE_WIDTH > viewportRight) {
	      if (viewportRight - CALENDAR_PANE_WIDTH > 0) {
	        paneLeft = viewportRight - CALENDAR_PANE_WIDTH;
	      } else {
	        paneLeft = viewportLeft;
	        var scale = this.$window.innerWidth / CALENDAR_PANE_WIDTH;
	        calendarPane.style.transform = 'scale(' + scale + ')';
	      }
	
	      calendarPane.classList.add('md-datepicker-pos-adjusted');
	    }
	
	    // If the bottom edge of the pane would be off the screen and shifting it up by the
	    // difference would not go past the top edge of the screen.
	    if (paneTop + CALENDAR_PANE_HEIGHT > viewportBottom &&
	        viewportBottom - CALENDAR_PANE_HEIGHT > viewportTop) {
	      paneTop = viewportBottom - CALENDAR_PANE_HEIGHT;
	      calendarPane.classList.add('md-datepicker-pos-adjusted');
	    }
	
	    calendarPane.style.left = paneLeft + 'px';
	    calendarPane.style.top = paneTop + 'px';
	    document.body.appendChild(calendarPane);
	
	    // Add CSS class after one frame to trigger open animation.
	    this.$$rAF(function() {
	      calendarPane.classList.add('md-pane-open');
	    });
	  };
	
	  /** Detach the floating calendar pane from the document. */
	  DatePickerCtrl.prototype.detachCalendarPane = function() {
	    this.$element.removeClass(OPEN_CLASS);
	    this.mdInputContainer && this.mdInputContainer.element.removeClass(OPEN_CLASS);
	    angular.element(document.body).removeClass('md-datepicker-is-showing');
	    this.calendarPane.classList.remove('md-pane-open');
	    this.calendarPane.classList.remove('md-datepicker-pos-adjusted');
	
	    if (this.isCalendarOpen) {
	      this.$mdUtil.enableScrolling();
	    }
	
	    if (this.calendarPane.parentNode) {
	      // Use native DOM removal because we do not want any of the
	      // angular state of this element to be disposed.
	      this.calendarPane.parentNode.removeChild(this.calendarPane);
	    }
	  };
	
	  /**
	   * Open the floating calendar pane.
	   * @param {Event} event
	   */
	  DatePickerCtrl.prototype.openCalendarPane = function(event) {
	    if (!this.isCalendarOpen && !this.isDisabled && !this.inputFocusedOnWindowBlur) {
	      this.isCalendarOpen = this.isOpen = true;
	      this.calendarPaneOpenedFrom = event.target;
	
	      // Because the calendar pane is attached directly to the body, it is possible that the
	      // rest of the component (input, etc) is in a different scrolling container, such as
	      // an md-content. This means that, if the container is scrolled, the pane would remain
	      // stationary. To remedy this, we disable scrolling while the calendar pane is open, which
	      // also matches the native behavior for things like `<select>` on Mac and Windows.
	      this.$mdUtil.disableScrollAround(this.calendarPane);
	
	      this.attachCalendarPane();
	      this.focusCalendar();
	      this.evalAttr('ngFocus');
	
	      // Attach click listener inside of a timeout because, if this open call was triggered by a
	      // click, we don't want it to be immediately propogated up to the body and handled.
	      var self = this;
	      this.$mdUtil.nextTick(function() {
	        // Use 'touchstart` in addition to click in order to work on iOS Safari, where click
	        // events aren't propogated under most circumstances.
	        // See http://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
	        self.documentElement.on('click touchstart', self.bodyClickHandler);
	      }, false);
	
	      window.addEventListener(this.windowEventName, this.windowEventHandler);
	    }
	  };
	
	  /** Close the floating calendar pane. */
	  DatePickerCtrl.prototype.closeCalendarPane = function() {
	    if (this.isCalendarOpen) {
	      var self = this;
	
	      self.detachCalendarPane();
	      self.ngModelCtrl.$setTouched();
	      self.evalAttr('ngBlur');
	
	      self.documentElement.off('click touchstart', self.bodyClickHandler);
	      window.removeEventListener(self.windowEventName, self.windowEventHandler);
	
	      self.calendarPaneOpenedFrom.focus();
	      self.calendarPaneOpenedFrom = null;
	
	      if (self.openOnFocus) {
	        // Ensures that all focus events have fired before resetting
	        // the calendar. Prevents the calendar from reopening immediately
	        // in IE when md-open-on-focus is set. Also it needs to trigger
	        // a digest, in order to prevent issues where the calendar wasn't
	        // showing up on the next open.
	        self.$mdUtil.nextTick(reset);
	      } else {
	        reset();
	      }
	    }
	
	    function reset(){
	      self.isCalendarOpen = self.isOpen = false;
	    }
	  };
	
	  /** Gets the controller instance for the calendar in the floating pane. */
	  DatePickerCtrl.prototype.getCalendarCtrl = function() {
	    return angular.element(this.calendarPane.querySelector('md-calendar')).controller('mdCalendar');
	  };
	
	  /** Focus the calendar in the floating pane. */
	  DatePickerCtrl.prototype.focusCalendar = function() {
	    // Use a timeout in order to allow the calendar to be rendered, as it is gated behind an ng-if.
	    var self = this;
	    this.$mdUtil.nextTick(function() {
	      self.getCalendarCtrl().focus();
	    }, false);
	  };
	
	  /**
	   * Sets whether the input is currently focused.
	   * @param {boolean} isFocused
	   */
	  DatePickerCtrl.prototype.setFocused = function(isFocused) {
	    if (!isFocused) {
	      this.ngModelCtrl.$setTouched();
	    }
	
	    // The ng* expressions shouldn't be evaluated when mdOpenOnFocus is on,
	    // because they also get called when the calendar is opened/closed.
	    if (!this.openOnFocus) {
	      this.evalAttr(isFocused ? 'ngFocus' : 'ngBlur');
	    }
	
	    this.isFocused = isFocused;
	  };
	
	  /**
	   * Handles a click on the document body when the floating calendar pane is open.
	   * Closes the floating calendar pane if the click is not inside of it.
	   * @param {MouseEvent} event
	   */
	  DatePickerCtrl.prototype.handleBodyClick = function(event) {
	    if (this.isCalendarOpen) {
	      var isInCalendar = this.$mdUtil.getClosest(event.target, 'md-calendar');
	
	      if (!isInCalendar) {
	        this.closeCalendarPane();
	      }
	
	      this.$scope.$digest();
	    }
	  };
	
	  /**
	   * Handles the event when the user navigates away from the current tab. Keeps track of
	   * whether the input was focused when the event happened, in order to prevent the calendar
	   * from re-opening.
	   */
	  DatePickerCtrl.prototype.handleWindowBlur = function() {
	    this.inputFocusedOnWindowBlur = document.activeElement === this.inputElement;
	  };
	
	  /**
	   * Evaluates an attribute expression against the parent scope.
	   * @param {String} attr Name of the attribute to be evaluated.
	   */
	  DatePickerCtrl.prototype.evalAttr = function(attr) {
	    if (this.$attrs[attr]) {
	      this.$scope.$parent.$eval(this.$attrs[attr]);
	    }
	  };
	
	  /**
	   * Sets the ng-model value by first converting the date object into a strng. Converting it
	   * is necessary, in order to pass AngularJS's `input[type="date"]` validations. AngularJS turns
	   * the value into a Date object afterwards, before setting it on the model.
	   * @param {Date=} value Date to be set as the model value.
	   */
	  DatePickerCtrl.prototype.setModelValue = function(value) {
	    var timezone = this.$mdUtil.getModelOption(this.ngModelCtrl, 'timezone');
	    this.ngModelCtrl.$setViewValue(this.ngDateFilter(value, 'yyyy-MM-dd', timezone));
	  };
	
	  /**
	   * Updates the datepicker when a model change occurred externally.
	   * @param {Date=} value Value that was set to the model.
	   */
	  DatePickerCtrl.prototype.onExternalChange = function(value) {
	    var timezone = this.$mdUtil.getModelOption(this.ngModelCtrl, 'timezone');
	
	    this.date = value;
	    this.inputElement.value = this.locale.formatDate(value, timezone);
	    this.mdInputContainer && this.mdInputContainer.setHasValue(!!value);
	    this.resizeInputElement();
	    this.updateErrorState();
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	angular
	  .module('material.components.icon')
	  .directive('mdIcon', ['$mdIcon', '$mdTheming', '$mdAria', '$sce', mdIconDirective]);
	
	/**
	 * @ngdoc directive
	 * @name mdIcon
	 * @module material.components.icon
	 *
	 * @restrict E
	 *
	 * @description
	 * The `md-icon` directive makes it easier to use vector-based icons in your app (as opposed to
	 * raster-based icons types like PNG). The directive supports both icon fonts and SVG icons.
	 *
	 * Icons should be considered view-only elements that should not be used directly as buttons; instead nest a `<md-icon>`
	 * inside a `md-button` to add hover and click features.
	 *
	 * ### Icon fonts
	 * Icon fonts are a technique in which you use a font where the glyphs in the font are
	 * your icons instead of text. Benefits include a straightforward way to bundle everything into a
	 * single HTTP request, simple scaling, easy color changing, and more.
	 *
	 * `md-icon` lets you consume an icon font by letting you reference specific icons in that font
	 * by name rather than character code.
	 *
	 * ### SVG
	 * For SVGs, the problem with using `<img>` or a CSS `background-image` is that you can't take
	 * advantage of some SVG features, such as styling specific parts of the icon with CSS or SVG
	 * animation.
	 *
	 * `md-icon` makes it easier to use SVG icons by *inlining* the SVG into an `<svg>` element in the
	 * document. The most straightforward way of referencing an SVG icon is via URL, just like a
	 * traditional `<img>`. `$mdIconProvider`, as a convenience, lets you _name_ an icon so you can
	 * reference it by name instead of URL throughout your templates.
	 *
	 * Additionally, you may not want to make separate HTTP requests for every icon, so you can bundle
	 * your SVG icons together and pre-load them with $mdIconProvider as an icon set. An icon set can
	 * also be given a name, which acts as a namespace for individual icons, so you can reference them
	 * like `"social:cake"`.
	 *
	 * When using SVGs, both external SVGs (via URLs) or sets of SVGs [from icon sets] can be
	 * easily loaded and used. When using font-icons, developers must follow three (3) simple steps:
	 *
	 * <ol>
	 * <li>Load the font library. e.g.<br/>
	 *    `<link href="https://fonts.googleapis.com/icon?family=Material+Icons"
	 *    rel="stylesheet">`
	 * </li>
	 * <li>
	 *   Use either (a) font-icon class names or (b) a fontset and a font ligature to render the font glyph by
	 *   using its textual name _or_ numerical character reference. Note that `material-icons` is the default fontset when
	 *   none is specified.
	 * </li>
	 * <li> Use any of the following templates: <br/>
	 *   <ul>
	 *     <li>`<md-icon md-font-icon="classname"></md-icon>`</li>
	 *     <li>`<md-icon md-font-set="font library classname or alias">textual_name</md-icon>`</li>
	 *     <li>`<md-icon> numerical_character_reference </md-icon>`</li>
	 *     <li>`<md-icon ng_bind="'textual_name'"></md-icon>`</li>
	 *     <li>`<md-icon ng-bind="scopeVariable"></md-icon>`</li>
	 *   </ul>
	 * </li>
	 * </ol>
	 *
	 * Full details for these steps can be found:
	 *
	 * <ul>
	 * <li>http://google.github.io/material-design-icons/</li>
	 * <li>http://google.github.io/material-design-icons/#icon-font-for-the-web</li>
	 * </ul>
	 *
	 * The Material Design icon style <code>.material-icons</code> and the icon font references are published in
	 * Material Design Icons:
	 *
	 * <ul>
	 * <li>https://design.google.com/icons/</li>
	 * <li>https://design.google.com/icons/#ic_accessibility</li>
	 * </ul>
	 *
	 * ### Localization
	 *
	 * Because an `md-icon` element's text content is not intended to translated, it is recommended to declare the text
	 * content for an `md-icon` element in its start tag. Instead of using the HTML text content, consider using `ng-bind`
	 * with a scope variable or literal string.
	 *
	 * Examples:
	 *
	 * <ul>
	 *   <li>`<md-icon ng-bind="myIconVariable"></md-icon>`</li>
	 *   <li>`<md-icon ng-bind="'menu'"></md-icon>`
	 * </ul>
	 *
	 * <h2 id="material_design_icons">Material Design Icons</h2>
	 * Using the Material Design Icon-Selector, developers can easily and quickly search for a Material Design font-icon and
	 * determine its textual name and character reference code. Click on any icon to see the slide-up information
	 * panel with details regarding a SVG download or information on the font-icon usage.
	 *
	 * <a href="https://www.google.com/design/icons/#ic_accessibility" target="_blank" style="border-bottom:none;">
	 * <img src="https://cloud.githubusercontent.com/assets/210413/7902490/fe8dd14c-0780-11e5-98fb-c821cc6475e6.png"
	 *      aria-label="Material Design Icon-Selector" style="max-width:75%;padding-left:10%">
	 * </a>
	 *
	 * <span class="image_caption">
	 *  Click on the image above to link to the
	 *  <a href="https://design.google.com/icons/#ic_accessibility" target="_blank">Material Design Icon-Selector</a>.
	 * </span>
	 *
	 * @param {string} md-font-icon String name of CSS icon associated with the font-face will be used
	 * to render the icon. Requires the fonts and the named CSS styles to be preloaded.
	 * @param {string} md-font-set CSS style name associated with the font library; which will be assigned as
	 * the class for the font-icon ligature. This value may also be an alias that is used to lookup the classname;
	 * internally use `$mdIconProvider.fontSet(<alias>)` to determine the style name.
	 * @param {string} md-svg-src String URL (or expression) used to load, cache, and display an
	 *     external SVG.
	 * @param {string} md-svg-icon md-svg-icon String name used for lookup of the icon from the internal cache;
	 *     interpolated strings or expressions may also be used. Specific set names can be used with
	 *     the syntax `<set name>:<icon name>`.<br/><br/>
	 * To use icon sets, developers are required to pre-register the sets using the `$mdIconProvider` service.
	 * @param {string=} aria-label Labels icon for accessibility. If an empty string is provided, icon
	 * will be hidden from accessibility layer with `aria-hidden="true"`. If there's no aria-label on the icon
	 * nor a label on the parent element, a warning will be logged to the console.
	 * @param {string=} alt Labels icon for accessibility. If an empty string is provided, icon
	 * will be hidden from accessibility layer with `aria-hidden="true"`. If there's no alt on the icon
	 * nor a label on the parent element, a warning will be logged to the console.
	 *
	 * @usage
	 * When using SVGs:
	 * <hljs lang="html">
	 *
	 *  <!-- Icon ID; may contain optional icon set prefix; icons must registered using $mdIconProvider -->
	 *  <md-icon md-svg-icon="social:android"    aria-label="android " ></md-icon>
	 *
	 *  <!-- Icon urls; may be preloaded in templateCache -->
	 *  <md-icon md-svg-src="/android.svg"       aria-label="android " ></md-icon>
	 *  <md-icon md-svg-src="{{ getAndroid() }}" aria-label="android " ></md-icon>
	 *
	 * </hljs>
	 *
	 * Use the <code>$mdIconProvider</code> to configure your application with
	 * svg iconsets.
	 *
	 * <hljs lang="js">
	 *  angular.module('appSvgIconSets', ['ngMaterial'])
	 *    .controller('DemoCtrl', function($scope) {})
	 *    .config(function($mdIconProvider) {
	 *      $mdIconProvider
	 *         .iconSet('social', 'img/icons/sets/social-icons.svg', 24)
	 *         .defaultIconSet('img/icons/sets/core-icons.svg', 24);
	 *     });
	 * </hljs>
	 *
	 *
	 * When using Font Icons with classnames:
	 * <hljs lang="html">
	 *
	 *  <md-icon md-font-icon="android" aria-label="android" ></md-icon>
	 *  <md-icon class="icon_home"      aria-label="Home"    ></md-icon>
	 *
	 * </hljs>
	 *
	 * When using Material Font Icons with ligatures:
	 * <hljs lang="html">
	 *  <!--
	 *  For Material Design Icons
	 *  The class '.material-icons' is auto-added if a style has NOT been specified
	 *  since `material-icons` is the default fontset. So your markup:
	 *  -->
	 *  <md-icon> face </md-icon>
	 *  <!-- becomes this at runtime: -->
	 *  <md-icon md-font-set="material-icons"> face </md-icon>
	 *  <!-- If the fontset does not support ligature names, then we need to use the ligature unicode.-->
	 *  <md-icon> &#xE87C; </md-icon>
	 *  <!-- The class '.material-icons' must be manually added if other styles are also specified-->
	 *  <md-icon class="material-icons md-light md-48"> face </md-icon>
	 * </hljs>
	 *
	 * When using other Font-Icon libraries:
	 *
	 * <hljs lang="js">
	 *  // Specify a font-icon style alias
	 *  angular.config(function($mdIconProvider) {
	 *    $mdIconProvider.fontSet('md', 'material-icons');
	 *  });
	 * </hljs>
	 *
	 * <hljs lang="html">
	 *  <md-icon md-font-set="md">favorite</md-icon>
	 * </hljs>
	 *
	 */
	function mdIconDirective($mdIcon, $mdTheming, $mdAria, $sce) {
	
	  return {
	    restrict: 'E',
	    link : postLink
	  };
	
	
	  /**
	   * Directive postLink
	   * Supports embedded SVGs, font-icons, & external SVGs
	   */
	  function postLink(scope, element, attr) {
	    $mdTheming(element);
	    var lastFontIcon = attr.mdFontIcon;
	    var lastFontSet = $mdIcon.fontSet(attr.mdFontSet);
	
	    prepareForFontIcon();
	
	    attr.$observe('mdFontIcon', fontIconChanged);
	    attr.$observe('mdFontSet', fontIconChanged);
	
	    // Keep track of the content of the svg src so we can compare against it later to see if the
	    // attribute is static (and thus safe).
	    var originalSvgSrc = element[0].getAttribute(attr.$attr.mdSvgSrc);
	
	    // If using a font-icon, then the textual name of the icon itself
	    // provides the aria-label.
	
	    var attrName = attr.$normalize(attr.$attr.mdSvgIcon || attr.$attr.mdSvgSrc || '');
	
	    /* Provide a default accessibility role of img */
	    if (!attr.role) {
	      $mdAria.expect(element, 'role', 'img');
	      /* manually update attr variable */
	      attr.role = 'img';
	    }
	
	    /* Don't process ARIA if already valid */
	    if ( attr.role === "img" && !attr.ariaHidden && !$mdAria.hasAriaLabel(element) ) {
	      var iconName;
	      if (attr.alt) {
	        /* Use alt text by default if available */
	        $mdAria.expect(element, 'aria-label', attr.alt);
	      } else if ($mdAria.parentHasAriaLabel(element, 2)) {
	        /* Parent has ARIA so we will assume it will describe the image */
	        $mdAria.expect(element, 'aria-hidden', 'true');
	      } else if (iconName = (attr.mdFontIcon || attr.mdSvgIcon || element.text())) {
	        /* Use icon name as aria-label */
	        $mdAria.expect(element, 'aria-label', iconName);
	      } else {
	        /* No label found */
	        $mdAria.expect(element, 'aria-hidden', 'true');
	      }
	    }
	
	    if (attrName) {
	      // Use either pre-configured SVG or URL source, respectively.
	      attr.$observe(attrName, function(attrVal) {
	        element.empty();
	        if (attrVal) {
	          $mdIcon(attrVal)
	            .then(function(svg) {
	            element.empty();
	            element.append(svg);
	          });
	        }
	      });
	    }
	
	    function prepareForFontIcon() {
	      if (!attr.mdSvgIcon && !attr.mdSvgSrc) {
	        if (attr.mdFontIcon) {
	          element.addClass('md-font ' + attr.mdFontIcon);
	        }
	
	        element.addClass(lastFontSet);
	      }
	    }
	
	    function fontIconChanged() {
	      if (!attr.mdSvgIcon && !attr.mdSvgSrc) {
	        if (attr.mdFontIcon) {
	          element.removeClass(lastFontIcon);
	          element.addClass(attr.mdFontIcon);
	
	          lastFontIcon = attr.mdFontIcon;
	        }
	
	        var fontSet = $mdIcon.fontSet(attr.mdFontSet);
	
	        if (lastFontSet !== fontSet) {
	          element.removeClass(lastFontSet);
	          element.addClass(fontSet);
	
	          lastFontSet = fontSet;
	        }
	      }
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	  
	MdIconService.$inject = ["config", "$templateRequest", "$q", "$log", "$mdUtil", "$sce"];angular
	    .module('material.components.icon')
	    .constant('$$mdSvgRegistry', {
	        'mdTabsArrow':   'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwb2x5Z29uIHBvaW50cz0iMTUuNCw3LjQgMTQsNiA4LDEyIDE0LDE4IDE1LjQsMTYuNiAxMC44LDEyICIvPjwvZz48L3N2Zz4=',
	        'mdClose':       'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik0xOSA2LjQxbC0xLjQxLTEuNDEtNS41OSA1LjU5LTUuNTktNS41OS0xLjQxIDEuNDEgNS41OSA1LjU5LTUuNTkgNS41OSAxLjQxIDEuNDEgNS41OS01LjU5IDUuNTkgNS41OSAxLjQxLTEuNDEtNS41OS01LjU5eiIvPjwvZz48L3N2Zz4=',
	        'mdCancel':      'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik0xMiAyYy01LjUzIDAtMTAgNC40Ny0xMCAxMHM0LjQ3IDEwIDEwIDEwIDEwLTQuNDcgMTAtMTAtNC40Ny0xMC0xMC0xMHptNSAxMy41OWwtMS40MSAxLjQxLTMuNTktMy41OS0zLjU5IDMuNTktMS40MS0xLjQxIDMuNTktMy41OS0zLjU5LTMuNTkgMS40MS0xLjQxIDMuNTkgMy41OSAzLjU5LTMuNTkgMS40MSAxLjQxLTMuNTkgMy41OSAzLjU5IDMuNTl6Ii8+PC9nPjwvc3ZnPg==',
	        'mdMenu':        'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0zLDZIMjFWOEgzVjZNMywxMUgyMVYxM0gzVjExTTMsMTZIMjFWMThIM1YxNloiIC8+PC9zdmc+',
	        'mdToggleArrow': 'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgNDggNDgiPjxwYXRoIGQ9Ik0yNCAxNmwtMTIgMTIgMi44MyAyLjgzIDkuMTctOS4xNyA5LjE3IDkuMTcgMi44My0yLjgzeiIvPjxwYXRoIGQ9Ik0wIDBoNDh2NDhoLTQ4eiIgZmlsbD0ibm9uZSIvPjwvc3ZnPg==',
	        'mdCalendar':    'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTkgM2gtMVYxaC0ydjJIOFYxSDZ2Mkg1Yy0xLjExIDAtMS45OS45LTEuOTkgMkwzIDE5YzAgMS4xLjg5IDIgMiAyaDE0YzEuMSAwIDItLjkgMi0yVjVjMC0xLjEtLjktMi0yLTJ6bTAgMTZINVY4aDE0djExek03IDEwaDV2NUg3eiIvPjwvc3ZnPg==',
	        'mdChecked':     'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik05IDE2LjE3TDQuODMgMTJsLTEuNDIgMS40MUw5IDE5IDIxIDdsLTEuNDEtMS40MXoiLz48L2c+PC9zdmc+'
	    })
	    .provider('$mdIcon', MdIconProvider);
	
	/**
	 * @ngdoc service
	 * @name $mdIconProvider
	 * @module material.components.icon
	 *
	 * @description
	 * `$mdIconProvider` is used only to register icon IDs with URLs. These configuration features allow
	 * icons and icon sets to be pre-registered and associated with source URLs **before** the `<md-icon />`
	 * directives are compiled.
	 *
	 * If using font-icons, the developer is responsible for loading the fonts.
	 *
	 * If using SVGs, loading of the actual svg files are deferred to on-demand requests and are loaded
	 * internally by the `$mdIcon` service using the `$templateRequest` service. When an SVG is
	 * requested by name/ID, the `$mdIcon` service searches its registry for the associated source URL;
	 * that URL is used to on-demand load and parse the SVG dynamically.
	 *
	 * The `$templateRequest` service expects the icons source to be loaded over trusted URLs.<br/>
	 * This means, when loading icons from an external URL, you have to trust the URL in the `$sceDelegateProvider`.
	 *
	 * <hljs lang="js">
	 *   app.config(function($sceDelegateProvider) {
	 *     $sceDelegateProvider.resourceUrlWhitelist([
	 *       // Adding 'self' to the whitelist, will allow requests from the current origin.
	 *       'self',
	 *       // Using double asterisks here, will allow all URLs to load.
	 *       // We recommend to only specify the given domain you want to allow.
	 *       '**'
	 *     ]);
	 *   });
	 * </hljs>
	 *
	 * Read more about the [$sceDelegateProvider](https://docs.angularjs.org/api/ng/provider/$sceDelegateProvider).
	 *
	 * **Notice:** Most font-icons libraries do not support ligatures (for example `fontawesome`).<br/>
	 *  In such cases you are not able to use the icon's ligature name - Like so:
	 *
	 *  <hljs lang="html">
	 *    <md-icon md-font-set="fa">fa-bell</md-icon>
	 *  </hljs>
	 *
	 * You should instead use the given unicode, instead of the ligature name.
	 *
	 * <p ng-hide="true"> ##// Notice we can't use a hljs element here, because the characters will be escaped.</p>
	 *  ```html
	 *    <md-icon md-font-set="fa">&#xf0f3</md-icon>
	 *  ```
	 *
	 * All unicode ligatures are prefixed with the `&#x` string.
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	    *
	    *     // Configure URLs for icons specified by [set:]id.
	    *
	    *     $mdIconProvider
	    *          .defaultFontSet( 'fa' )                   // This sets our default fontset className.
	    *          .defaultIconSet('my/app/icons.svg')       // Register a default set of SVG icons
	    *          .iconSet('social', 'my/app/social.svg')   // Register a named icon set of SVGs
	    *          .icon('android', 'my/app/android.svg')    // Register a specific icon (by name)
	    *          .icon('work:chair', 'my/app/chair.svg');  // Register icon in a specific set
	    *   });
	 * </hljs>
	 *
	 * SVG icons and icon sets can be easily pre-loaded and cached using either (a) a build process or (b) a runtime
	 * **startup** process (shown below):
	 *
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	    *
	    *     // Register a default set of SVG icon definitions
	    *     $mdIconProvider.defaultIconSet('my/app/icons.svg')
	    *
	    *   })
	 *   .run(function($templateRequest){
	    *
	    *     // Pre-fetch icons sources by URL and cache in the $templateCache...
	    *     // subsequent $templateRequest calls will look there first.
	    *
	    *     var urls = [ 'imy/app/icons.svg', 'img/icons/android.svg'];
	    *
	    *     angular.forEach(urls, function(url) {
	    *       $templateRequest(url);
	    *     });
	    *
	    *   });
	 *
	 * </hljs>
	 *
	 * > <b>Note:</b> The loaded SVG data is subsequently cached internally for future requests.
	 *
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdIconProvider#icon
	 *
	 * @description
	 * Register a source URL for a specific icon name; the name may include optional 'icon set' name prefix.
	 * These icons  will later be retrieved from the cache using `$mdIcon( <icon name> )`
	 *
	 * @param {string} id Icon name/id used to register the icon
	 * @param {string} url specifies the external location for the data file. Used internally by
	 * `$templateRequest` to load the data or as part of the lookup in `$templateCache` if pre-loading
	 * was configured.
	 * @param {number=} viewBoxSize Sets the width and height the icon's viewBox.
	 * It is ignored for icons with an existing viewBox. Default size is 24.
	 *
	 * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	    *
	    *     // Configure URLs for icons specified by [set:]id.
	    *
	    *     $mdIconProvider
	    *          .icon('android', 'my/app/android.svg')    // Register a specific icon (by name)
	    *          .icon('work:chair', 'my/app/chair.svg');  // Register icon in a specific set
	    *   });
	 * </hljs>
	 *
	 */
	/**
	 * @ngdoc method
	 * @name $mdIconProvider#iconSet
	 *
	 * @description
	 * Register a source URL for a 'named' set of icons; group of SVG definitions where each definition
	 * has an icon id. Individual icons can be subsequently retrieved from this cached set using
	 * `$mdIcon(<icon set name>:<icon name>)`
	 *
	 * @param {string} id Icon name/id used to register the iconset
	 * @param {string} url specifies the external location for the data file. Used internally by
	 * `$templateRequest` to load the data or as part of the lookup in `$templateCache` if pre-loading
	 * was configured.
	 * @param {number=} viewBoxSize Sets the width and height of the viewBox of all icons in the set.
	 * It is ignored for icons with an existing viewBox. All icons in the icon set should be the same size.
	 * Default value is 24.
	 *
	 * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
	 *
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	    *
	    *     // Configure URLs for icons specified by [set:]id.
	    *
	    *     $mdIconProvider
	    *          .iconSet('social', 'my/app/social.svg')   // Register a named icon set
	    *   });
	 * </hljs>
	 *
	 */
	/**
	 * @ngdoc method
	 * @name $mdIconProvider#defaultIconSet
	 *
	 * @description
	 * Register a source URL for the default 'named' set of icons. Unless explicitly registered,
	 * subsequent lookups of icons will failover to search this 'default' icon set.
	 * Icon can be retrieved from this cached, default set using `$mdIcon(<name>)`
	 *
	 * @param {string} url specifies the external location for the data file. Used internally by
	 * `$templateRequest` to load the data or as part of the lookup in `$templateCache` if pre-loading
	 * was configured.
	 * @param {number=} viewBoxSize Sets the width and height of the viewBox of all icons in the set.
	 * It is ignored for icons with an existing viewBox. All icons in the icon set should be the same size.
	 * Default value is 24.
	 *
	 * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	    *
	    *     // Configure URLs for icons specified by [set:]id.
	    *
	    *     $mdIconProvider
	    *          .defaultIconSet( 'my/app/social.svg' )   // Register a default icon set
	    *   });
	 * </hljs>
	 *
	 */
	/**
	 * @ngdoc method
	 * @name $mdIconProvider#defaultFontSet
	 *
	 * @description
	 * When using Font-Icons, AngularJS Material assumes the the Material Design icons will be used and automatically
	 * configures the default font-set == 'material-icons'. Note that the font-set references the font-icon library
	 * class style that should be applied to the `<md-icon>`.
	 *
	 * Configuring the default means that the attributes
	 * `md-font-set="material-icons"` or `class="material-icons"` do not need to be explicitly declared on the
	 * `<md-icon>` markup. For example:
	 *
	 *  `<md-icon> face </md-icon>`
	 *  will render as
	 *  `<span class="material-icons"> face </span>`, and
	 *
	 *  `<md-icon md-font-set="fa"> face </md-icon>`
	 *  will render as
	 *  `<span class="fa"> face </span>`
	 *
	 * @param {string} name of the font-library style that should be applied to the md-icon DOM element
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	   *     $mdIconProvider.defaultFontSet( 'fa' );
	   *   });
	 * </hljs>
	 *
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdIconProvider#fontSet
	 *
	 * @description
	 * When using a font set for `<md-icon>` you must specify the correct font classname in the `md-font-set`
	 * attribute. If the fonset className is really long, your markup may become cluttered... an easy
	 * solution is to define an `alias` for your fontset:
	 *
	 * @param {string} alias of the specified fontset.
	 * @param {string} className of the fontset.
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	   *     // In this case, we set an alias for the `material-icons` fontset.
	   *     $mdIconProvider.fontSet('md', 'material-icons');
	   *   });
	 * </hljs>
	 *
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdIconProvider#defaultViewBoxSize
	 *
	 * @description
	 * While `<md-icon />` markup can also be style with sizing CSS, this method configures
	 * the default width **and** height used for all icons; unless overridden by specific CSS.
	 * The default sizing is (24px, 24px).
	 * @param {number=} viewBoxSize Sets the width and height of the viewBox for an icon or an icon set.
	 * All icons in a set should be the same size. The default value is 24.
	 *
	 * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	    *
	    *     // Configure URLs for icons specified by [set:]id.
	    *
	    *     $mdIconProvider
	    *          .defaultViewBoxSize(36)   // Register a default icon size (width == height)
	    *   });
	 * </hljs>
	 *
	 */
	
	var config = {
	  defaultViewBoxSize: 24,
	  defaultFontSet: 'material-icons',
	  fontSets: []
	};
	
	function MdIconProvider() {
	}
	
	MdIconProvider.prototype = {
	  icon: function(id, url, viewBoxSize) {
	    if (id.indexOf(':') == -1) id = '$default:' + id;
	
	    config[id] = new ConfigurationItem(url, viewBoxSize);
	    return this;
	  },
	
	  iconSet: function(id, url, viewBoxSize) {
	    config[id] = new ConfigurationItem(url, viewBoxSize);
	    return this;
	  },
	
	  defaultIconSet: function(url, viewBoxSize) {
	    var setName = '$default';
	
	    if (!config[setName]) {
	      config[setName] = new ConfigurationItem(url, viewBoxSize);
	    }
	
	    config[setName].viewBoxSize = viewBoxSize || config.defaultViewBoxSize;
	
	    return this;
	  },
	
	  defaultViewBoxSize: function(viewBoxSize) {
	    config.defaultViewBoxSize = viewBoxSize;
	    return this;
	  },
	
	  /**
	   * Register an alias name associated with a font-icon library style ;
	   */
	  fontSet: function fontSet(alias, className) {
	    config.fontSets.push({
	      alias: alias,
	      fontSet: className || alias
	    });
	    return this;
	  },
	
	  /**
	   * Specify a default style name associated with a font-icon library
	   * fallback to Material Icons.
	   *
	   */
	  defaultFontSet: function defaultFontSet(className) {
	    config.defaultFontSet = !className ? '' : className;
	    return this;
	  },
	
	  defaultIconSize: function defaultIconSize(iconSize) {
	    config.defaultIconSize = iconSize;
	    return this;
	  },
	
	  $get: ['$templateRequest', '$q', '$log', '$mdUtil', '$sce', function($templateRequest, $q, $log, $mdUtil, $sce) {
	    return MdIconService(config, $templateRequest, $q, $log, $mdUtil, $sce);
	  }]
	};
	
	/**
	 *  Configuration item stored in the Icon registry; used for lookups
	 *  to load if not already cached in the `loaded` cache
	 */
	function ConfigurationItem(url, viewBoxSize) {
	  this.url = url;
	  this.viewBoxSize = viewBoxSize || config.defaultViewBoxSize;
	}
	
	/**
	 * @ngdoc service
	 * @name $mdIcon
	 * @module material.components.icon
	 *
	 * @description
	 * The `$mdIcon` service is a function used to lookup SVG icons.
	 *
	 * @param {string} id Query value for a unique Id or URL. If the argument is a URL, then the service will retrieve the icon element
	 * from its internal cache or load the icon and cache it first. If the value is not a URL-type string, then an ID lookup is
	 * performed. The Id may be a unique icon ID or may include an iconSet ID prefix.
	 *
	 * For the **id** query to work properly, this means that all id-to-URL mappings must have been previously configured
	 * using the `$mdIconProvider`.
	 *
	 * @returns {angular.$q.Promise} A promise that gets resolved to a clone of the initial SVG DOM element; which was
	 * created from the SVG markup in the SVG data file. If an error occurs (e.g. the icon cannot be found) the promise
	 * will get rejected.
	 *
	 * @usage
	 * <hljs lang="js">
	 * function SomeDirective($mdIcon) {
	  *
	  *   // See if the icon has already been loaded, if not
	  *   // then lookup the icon from the registry cache, load and cache
	  *   // it for future requests.
	  *   // NOTE: ID queries require configuration with $mdIconProvider
	  *
	  *   $mdIcon('android').then(function(iconEl)    { element.append(iconEl); });
	  *   $mdIcon('work:chair').then(function(iconEl) { element.append(iconEl); });
	  *
	  *   // Load and cache the external SVG using a URL
	  *
	  *   $mdIcon('img/icons/android.svg').then(function(iconEl) {
	  *     element.append(iconEl);
	  *   });
	  * };
	 * </hljs>
	 *
	 * > <b>Note:</b> The `<md-icon>` directive internally uses the `$mdIcon` service to query, loaded,
	 *   and instantiate SVG DOM elements.
	 */
	
	/* @ngInject */
	function MdIconService(config, $templateRequest, $q, $log, $mdUtil, $sce) {
	  var iconCache = {};
	  var svgCache = {};
	  var urlRegex = /[-\w@:%\+.~#?&//=]{2,}\.[a-z]{2,4}\b(\/[-\w@:%\+.~#?&//=]*)?/i;
	  var dataUrlRegex = /^data:image\/svg\+xml[\s*;\w\-\=]*?(base64)?,(.*)$/i;
	
	  Icon.prototype = {clone: cloneSVG, prepare: prepareAndStyle};
	  getIcon.fontSet = findRegisteredFontSet;
	
	  // Publish service...
	  return getIcon;
	
	  /**
	   * Actual $mdIcon service is essentially a lookup function
	   */
	  function getIcon(id) {
	    id = id || '';
	
	    // If the "id" provided is not a string, the only other valid value is a $sce trust wrapper
	    // over a URL string. If the value is not trusted, this will intentionally throw an error
	    // because the user is attempted to use an unsafe URL, potentially opening themselves up
	    // to an XSS attack.
	    if (!angular.isString(id)) {
	      id = $sce.getTrustedUrl(id);
	    }
	
	    // If already loaded and cached, use a clone of the cached icon.
	    // Otherwise either load by URL, or lookup in the registry and then load by URL, and cache.
	
	    if (iconCache[id]) {
	      return $q.when(transformClone(iconCache[id]));
	    }
	
	    if (urlRegex.test(id) || dataUrlRegex.test(id)) {
	      return loadByURL(id).then(cacheIcon(id));
	    }
	
	    if (id.indexOf(':') == -1) {
	      id = '$default:' + id;
	    }
	
	    var load = config[id] ? loadByID : loadFromIconSet;
	    return load(id)
	      .then(cacheIcon(id));
	  }
	
	  /**
	   * Lookup registered fontSet style using its alias...
	   * If not found,
	   */
	  function findRegisteredFontSet(alias) {
	    var useDefault = angular.isUndefined(alias) || !(alias && alias.length);
	    if (useDefault) return config.defaultFontSet;
	
	    var result = alias;
	    angular.forEach(config.fontSets, function(it) {
	      if (it.alias == alias) result = it.fontSet || result;
	    });
	
	    return result;
	  }
	
	  function transformClone(cacheElement) {
	    var clone = cacheElement.clone();
	    var cacheSuffix = '_cache' + $mdUtil.nextUid();
	
	    // We need to modify for each cached icon the id attributes.
	    // This is needed because SVG id's are treated as normal DOM ids
	    // and should not have a duplicated id.
	    if (clone.id) clone.id += cacheSuffix;
	    angular.forEach(clone.querySelectorAll('[id]'), function(item) {
	      item.id += cacheSuffix;
	    });
	
	    return clone;
	  }
	
	  /**
	   * Prepare and cache the loaded icon for the specified `id`
	   */
	  function cacheIcon(id) {
	
	    return function updateCache(icon) {
	      iconCache[id] = isIcon(icon) ? icon : new Icon(icon, config[id]);
	
	      return iconCache[id].clone();
	    };
	  }
	
	  /**
	   * Lookup the configuration in the registry, if !registered throw an error
	   * otherwise load the icon [on-demand] using the registered URL.
	   *
	   */
	  function loadByID(id) {
	    var iconConfig = config[id];
	    return loadByURL(iconConfig.url).then(function(icon) {
	      return new Icon(icon, iconConfig);
	    });
	  }
	
	  /**
	   *    Loads the file as XML and uses querySelector( <id> ) to find
	   *    the desired node...
	   */
	  function loadFromIconSet(id) {
	    var setName = id.substring(0, id.lastIndexOf(':')) || '$default';
	    var iconSetConfig = config[setName];
	
	    return !iconSetConfig ? announceIdNotFound(id) : loadByURL(iconSetConfig.url).then(extractFromSet);
	
	    function extractFromSet(set) {
	      var iconName = id.slice(id.lastIndexOf(':') + 1);
	      var icon = set.querySelector('#' + iconName);
	      return icon ? new Icon(icon, iconSetConfig) : announceIdNotFound(id);
	    }
	
	    function announceIdNotFound(id) {
	      var msg = 'icon ' + id + ' not found';
	      $log.warn(msg);
	
	      return $q.reject(msg || id);
	    }
	  }
	
	  /**
	   * Load the icon by URL (may use the $templateCache).
	   * Extract the data for later conversion to Icon
	   */
	  function loadByURL(url) {
	    /* Load the icon from embedded data URL. */
	    function loadByDataUrl(url) {
	      var results = dataUrlRegex.exec(url);
	      var isBase64 = /base64/i.test(url);
	      var data = isBase64 ? window.atob(results[2]) : results[2];
	
	      return $q.when(angular.element(data)[0]);
	    }
	
	    /* Load the icon by URL using HTTP. */
	    function loadByHttpUrl(url) {
	      return $q(function(resolve, reject) {
	        // Catch HTTP or generic errors not related to incorrect icon IDs.
	        var announceAndReject = function(err) {
	            var msg = angular.isString(err) ? err : (err.message || err.data || err.statusText);
	            $log.warn(msg);
	            reject(err);
	          },
	          extractSvg = function(response) {
	            if (!svgCache[url]) {
	              svgCache[url] = angular.element('<div>').append(response)[0].querySelector('svg');
	            }
	            resolve(svgCache[url]);
	          };
	
	        $templateRequest(url, true).then(extractSvg, announceAndReject);
	      });
	    }
	
	    return dataUrlRegex.test(url)
	      ? loadByDataUrl(url)
	      : loadByHttpUrl(url);
	  }
	
	  /**
	   * Check target signature to see if it is an Icon instance.
	   */
	  function isIcon(target) {
	    return angular.isDefined(target.element) && angular.isDefined(target.config);
	  }
	
	  /**
	   *  Define the Icon class
	   */
	  function Icon(el, config) {
	    if (el && el.tagName != 'svg') {
	      el = angular.element('<svg xmlns="http://www.w3.org/2000/svg">').append(el.cloneNode(true))[0];
	    }
	
	    // Inject the namespace if not available...
	    if (!el.getAttribute('xmlns')) {
	      el.setAttribute('xmlns', "http://www.w3.org/2000/svg");
	    }
	
	    this.element = el;
	    this.config = config;
	    this.prepare();
	  }
	
	  /**
	   *  Prepare the DOM element that will be cached in the
	   *  loaded iconCache store.
	   */
	  function prepareAndStyle() {
	    var viewBoxSize = this.config ? this.config.viewBoxSize : config.defaultViewBoxSize;
	    angular.forEach({
	      'fit': '',
	      'height': '100%',
	      'width': '100%',
	      'preserveAspectRatio': 'xMidYMid meet',
	      'viewBox': this.element.getAttribute('viewBox') || ('0 0 ' + viewBoxSize + ' ' + viewBoxSize),
	      'focusable': false // Disable IE11s default behavior to make SVGs focusable
	    }, function(val, attr) {
	      this.element.setAttribute(attr, val);
	    }, this);
	  }
	
	  /**
	   * Clone the Icon DOM element.
	   */
	  function cloneSVG() {
	    // If the element or any of its children have a style attribute, then a CSP policy without
	    // 'unsafe-inline' in the style-src directive, will result in a violation.
	    return this.element.cloneNode(true);
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	
	
	MenuController.$inject = ["$mdMenu", "$attrs", "$element", "$scope", "$mdUtil", "$timeout", "$rootScope", "$q", "$log"];
	angular
	    .module('material.components.menu')
	    .controller('mdMenuCtrl', MenuController);
	
	/**
	 * @ngInject
	 */
	function MenuController($mdMenu, $attrs, $element, $scope, $mdUtil, $timeout, $rootScope, $q, $log) {
	
	  var prefixer = $mdUtil.prefixer();
	  var menuContainer;
	  var self = this;
	  var triggerElement;
	
	  this.nestLevel = parseInt($attrs.mdNestLevel, 10) || 0;
	
	  /**
	   * Called by our linking fn to provide access to the menu-content
	   * element removed during link
	   */
	  this.init = function init(setMenuContainer, opts) {
	    opts = opts || {};
	    menuContainer = setMenuContainer;
	
	    // Default element for ARIA attributes has the ngClick or ngMouseenter expression
	    triggerElement = $element[0].querySelector(prefixer.buildSelector(['ng-click', 'ng-mouseenter']));
	    triggerElement.setAttribute('aria-expanded', 'false');
	
	    this.isInMenuBar = opts.isInMenuBar;
	    this.nestedMenus = $mdUtil.nodesToArray(menuContainer[0].querySelectorAll('.md-nested-menu'));
	
	    menuContainer.on('$mdInterimElementRemove', function() {
	      self.isOpen = false;
	      $mdUtil.nextTick(function(){ self.onIsOpenChanged(self.isOpen);});
	    });
	    $mdUtil.nextTick(function(){ self.onIsOpenChanged(self.isOpen);});
	
	    var menuContainerId = 'menu_container_' + $mdUtil.nextUid();
	    menuContainer.attr('id', menuContainerId);
	    angular.element(triggerElement).attr({
	      'aria-owns': menuContainerId,
	      'aria-haspopup': 'true'
	    });
	
	    $scope.$on('$destroy', angular.bind(this, function() {
	      this.disableHoverListener();
	      $mdMenu.destroy();
	    }));
	
	    menuContainer.on('$destroy', function() {
	      $mdMenu.destroy();
	    });
	  };
	
	  var openMenuTimeout, menuItems, deregisterScopeListeners = [];
	  this.enableHoverListener = function() {
	    deregisterScopeListeners.push($rootScope.$on('$mdMenuOpen', function(event, el) {
	      if (menuContainer[0].contains(el[0])) {
	        self.currentlyOpenMenu = el.controller('mdMenu');
	        self.isAlreadyOpening = false;
	        self.currentlyOpenMenu.registerContainerProxy(self.triggerContainerProxy.bind(self));
	      }
	    }));
	    deregisterScopeListeners.push($rootScope.$on('$mdMenuClose', function(event, el) {
	      if (menuContainer[0].contains(el[0])) {
	        self.currentlyOpenMenu = undefined;
	      }
	    }));
	    menuItems = angular.element($mdUtil.nodesToArray(menuContainer[0].children[0].children));
	    menuItems.on('mouseenter', self.handleMenuItemHover);
	    menuItems.on('mouseleave', self.handleMenuItemMouseLeave);
	  };
	
	  this.disableHoverListener = function() {
	    while (deregisterScopeListeners.length) {
	      deregisterScopeListeners.shift()();
	    }
	    menuItems && menuItems.off('mouseenter', self.handleMenuItemHover);
	    menuItems && menuItems.off('mouseleave', self.handleMenuItemMouseLeave);
	  };
	
	  this.handleMenuItemHover = function(event) {
	    if (self.isAlreadyOpening) return;
	    var nestedMenu = (
	      event.target.querySelector('md-menu')
	        || $mdUtil.getClosest(event.target, 'MD-MENU')
	    );
	    openMenuTimeout = $timeout(function() {
	      if (nestedMenu) {
	        nestedMenu = angular.element(nestedMenu).controller('mdMenu');
	      }
	
	      if (self.currentlyOpenMenu && self.currentlyOpenMenu != nestedMenu) {
	        var closeTo = self.nestLevel + 1;
	        self.currentlyOpenMenu.close(true, { closeTo: closeTo });
	        self.isAlreadyOpening = !!nestedMenu;
	        nestedMenu && nestedMenu.open();
	      } else if (nestedMenu && !nestedMenu.isOpen && nestedMenu.open) {
	        self.isAlreadyOpening = !!nestedMenu;
	        nestedMenu && nestedMenu.open();
	      }
	    }, nestedMenu ? 100 : 250);
	    var focusableTarget = event.currentTarget.querySelector('.md-button:not([disabled])');
	    focusableTarget && focusableTarget.focus();
	  };
	
	  this.handleMenuItemMouseLeave = function() {
	    if (openMenuTimeout) {
	      $timeout.cancel(openMenuTimeout);
	      openMenuTimeout = undefined;
	    }
	  };
	
	
	  /**
	   * Uses the $mdMenu interim element service to open the menu contents
	   */
	  this.open = function openMenu(ev) {
	    ev && ev.stopPropagation();
	    ev && ev.preventDefault();
	    if (self.isOpen) return;
	    self.enableHoverListener();
	    self.isOpen = true;
	    $mdUtil.nextTick(function(){ self.onIsOpenChanged(self.isOpen);});
	    triggerElement = triggerElement || (ev ? ev.target : $element[0]);
	    triggerElement.setAttribute('aria-expanded', 'true');
	    $scope.$emit('$mdMenuOpen', $element);
	    $mdMenu.show({
	      scope: $scope,
	      mdMenuCtrl: self,
	      nestLevel: self.nestLevel,
	      element: menuContainer,
	      target: triggerElement,
	      preserveElement: true,
	      parent: 'body'
	    }).finally(function() {
	      triggerElement.setAttribute('aria-expanded', 'false');
	      self.disableHoverListener();
	    });
	  };
	
	  this.onIsOpenChanged = function(isOpen) {
	    if (isOpen) {
	      menuContainer.attr('aria-hidden', 'false');
	      $element[0].classList.add('md-open');
	      angular.forEach(self.nestedMenus, function(el) {
	        el.classList.remove('md-open');
	      });
	    } else {
	      menuContainer.attr('aria-hidden', 'true');
	      $element[0].classList.remove('md-open');
	    }
	    $scope.$mdMenuIsOpen = self.isOpen;
	  };
	
	  this.focusMenuContainer = function focusMenuContainer() {
	    var focusTarget = menuContainer[0]
	      .querySelector(prefixer.buildSelector(['md-menu-focus-target', 'md-autofocus']));
	
	    if (!focusTarget) focusTarget = menuContainer[0].querySelector('.md-button:not([disabled])');
	    focusTarget.focus();
	  };
	
	  this.registerContainerProxy = function registerContainerProxy(handler) {
	    this.containerProxy = handler;
	  };
	
	  this.triggerContainerProxy = function triggerContainerProxy(ev) {
	    this.containerProxy && this.containerProxy(ev);
	  };
	
	  this.destroy = function() {
	    return self.isOpen ? $mdMenu.destroy() : $q.when(false);
	  };
	
	  // Use the $mdMenu interim element service to close the menu contents
	  this.close = function closeMenu(skipFocus, closeOpts) {
	    if ( !self.isOpen ) return;
	    self.isOpen = false;
	    $mdUtil.nextTick(function(){ self.onIsOpenChanged(self.isOpen);});
	
	    var eventDetails = angular.extend({}, closeOpts, { skipFocus: skipFocus });
	    $scope.$emit('$mdMenuClose', $element, eventDetails);
	    $mdMenu.hide(null, closeOpts);
	
	    if (!skipFocus) {
	      var el = self.restoreFocusTo || $element.find('button')[0];
	      if (el instanceof angular.element) el = el[0];
	      if (el) el.focus();
	    }
	  };
	
	  /**
	   * Build a nice object out of our string attribute which specifies the
	   * target mode for left and top positioning
	   */
	  this.positionMode = function positionMode() {
	    var attachment = ($attrs.mdPositionMode || 'target').split(' ');
	
	    // If attachment is a single item, duplicate it for our second value.
	    // ie. 'target' -> 'target target'
	    if (attachment.length == 1) {
	      attachment.push(attachment[0]);
	    }
	
	    return {
	      left: attachment[0],
	      top: attachment[1]
	    };
	  };
	
	  /**
	   * Build a nice object out of our string attribute which specifies
	   * the offset of top and left in pixels.
	   */
	  this.offsets = function offsets() {
	    var position = ($attrs.mdOffset || '0 0').split(' ').map(parseFloat);
	    if (position.length == 2) {
	      return {
	        left: position[0],
	        top: position[1]
	      };
	    } else if (position.length == 1) {
	      return {
	        top: position[0],
	        left: position[0]
	      };
	    } else {
	      throw Error('Invalid offsets specified. Please follow format <x, y> or <n>');
	    }
	  };
	
	  // Functionality that is exposed in the view.
	  $scope.$mdMenu = {
	    open: this.open,
	    close: this.close
	  };
	
	  // Deprecated APIs
	  $scope.$mdOpenMenu = angular.bind(this, function() {
	    $log.warn('mdMenu: The $mdOpenMenu method is deprecated. Please use `$mdMenu.open`.');
	    return this.open.apply(this, arguments);
	  });
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc directive
	 * @name mdMenu
	 * @module material.components.menu
	 * @restrict E
	 * @description
	 *
	 * Menus are elements that open when clicked. They are useful for displaying
	 * additional options within the context of an action.
	 *
	 * Every `md-menu` must specify exactly two child elements. The first element is what is
	 * left in the DOM and is used to open the menu. This element is called the trigger element.
	 * The trigger element's scope has access to `$mdMenu.open($event)`
	 * which it may call to open the menu. By passing $event as argument, the
	 * corresponding event is stopped from propagating up the DOM-tree. Similarly, `$mdMenu.close()`
	 * can be used to close the menu.
	 *
	 * The second element is the `md-menu-content` element which represents the
	 * contents of the menu when it is open. Typically this will contain `md-menu-item`s,
	 * but you can do custom content as well.
	 *
	 * <hljs lang="html">
	 * <md-menu>
	 *  <!-- Trigger element is a md-button with an icon -->
	 *  <md-button ng-click="$mdMenu.open($event)" class="md-icon-button" aria-label="Open sample menu">
	 *    <md-icon md-svg-icon="call:phone"></md-icon>
	 *  </md-button>
	 *  <md-menu-content>
	 *    <md-menu-item><md-button ng-click="doSomething()">Do Something</md-button></md-menu-item>
	 *  </md-menu-content>
	 * </md-menu>
	 * </hljs>
	
	 * ## Sizing Menus
	 *
	 * The width of the menu when it is open may be specified by specifying a `width`
	 * attribute on the `md-menu-content` element.
	 * See the [Material Design Spec](https://material.google.com/components/menus.html#menus-simple-menus)
	 * for more information.
	 *
	 *
	 * ## Aligning Menus
	 *
	 * When a menu opens, it is important that the content aligns with the trigger element.
	 * Failure to align menus can result in jarring experiences for users as content
	 * suddenly shifts. To help with this, `md-menu` provides serveral APIs to help
	 * with alignment.
	 *
	 * ### Target Mode
	 *
	 * By default, `md-menu` will attempt to align the `md-menu-content` by aligning
	 * designated child elements in both the trigger and the menu content.
	 *
	 * To specify the alignment element in the `trigger` you can use the `md-menu-origin`
	 * attribute on a child element. If no `md-menu-origin` is specified, the `md-menu`
	 * will be used as the origin element.
	 *
	 * Similarly, the `md-menu-content` may specify a `md-menu-align-target` for a
	 * `md-menu-item` to specify the node that it should try and align with.
	 *
	 * In this example code, we specify an icon to be our origin element, and an
	 * icon in our menu content to be our alignment target. This ensures that both
	 * icons are aligned when the menu opens.
	 *
	 * <hljs lang="html">
	 * <md-menu>
	 *  <md-button ng-click="$mdMenu.open($event)" class="md-icon-button" aria-label="Open some menu">
	 *    <md-icon md-menu-origin md-svg-icon="call:phone"></md-icon>
	 *  </md-button>
	 *  <md-menu-content>
	 *    <md-menu-item>
	 *      <md-button ng-click="doSomething()" aria-label="Do something">
	 *        <md-icon md-menu-align-target md-svg-icon="call:phone"></md-icon>
	 *        Do Something
	 *      </md-button>
	 *    </md-menu-item>
	 *  </md-menu-content>
	 * </md-menu>
	 * </hljs>
	 *
	 * Sometimes we want to specify alignment on the right side of an element, for example
	 * if we have a menu on the right side a toolbar, we want to right align our menu content.
	 *
	 * We can specify the origin by using the `md-position-mode` attribute on both
	 * the `x` and `y` axis. Right now only the `x-axis` has more than one option.
	 * You may specify the default mode of `target target` or
	 * `target-right target` to specify a right-oriented alignment target. See the
	 * position section of the demos for more examples.
	 *
	 * ### Menu Offsets
	 *
	 * It is sometimes unavoidable to need to have a deeper level of control for
	 * the positioning of a menu to ensure perfect alignment. `md-menu` provides
	 * the `md-offset` attribute to allow pixel level specificty of adjusting the
	 * exact positioning.
	 *
	 * This offset is provided in the format of `x y` or `n` where `n` will be used
	 * in both the `x` and `y` axis.
	 *
	 * For example, to move a menu by `2px` down from the top, we can use:
	 * <hljs lang="html">
	 * <md-menu md-offset="0 2">
	 *   <!-- menu-content -->
	 * </md-menu>
	 * </hljs>
	 *
	 * ### Auto Focus
	 * By default, when a menu opens, `md-menu` focuses the first button in the menu content.
	 *
	 * But sometimes you would like to focus another specific menu item instead of the first.<br/>
	 * This can be done by applying the `md-autofocus` directive on the given element.
	 *
	 * <hljs lang="html">
	 * <md-menu-item>
	 *   <md-button md-autofocus ng-click="doSomething()">
	 *     Auto Focus
	 *   </md-button>
	 * </md-menu-item>
	 * </hljs>
	 *
	 *
	 * ### Preventing close
	 *
	 * Sometimes you would like to be able to click on a menu item without having the menu
	 * close. To do this, AngularJS Material exposes the `md-prevent-menu-close` attribute which
	 * can be added to a button inside a menu to stop the menu from automatically closing.
	 * You can then close the menu either by using `$mdMenu.close()` in the template,
	 * or programatically by injecting `$mdMenu` and calling `$mdMenu.hide()`.
	 *
	 * <hljs lang="html">
	 * <md-menu-content ng-mouseleave="$mdMenu.close()">
	 *   <md-menu-item>
	 *     <md-button ng-click="doSomething()" aria-label="Do something" md-prevent-menu-close="md-prevent-menu-close">
	 *       <md-icon md-menu-align-target md-svg-icon="call:phone"></md-icon>
	 *       Do Something
	 *     </md-button>
	 *   </md-menu-item>
	 * </md-menu-content>
	 * </hljs>
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-menu>
	 *  <md-button ng-click="$mdMenu.open($event)" class="md-icon-button">
	 *    <md-icon md-svg-icon="call:phone"></md-icon>
	 *  </md-button>
	 *  <md-menu-content>
	 *    <md-menu-item><md-button ng-click="doSomething()">Do Something</md-button></md-menu-item>
	 *  </md-menu-content>
	 * </md-menu>
	 * </hljs>
	 *
	 * @param {string} md-position-mode The position mode in the form of
	 *           `x`, `y`. Default value is `target`,`target`. Right now the `x` axis
	 *           also supports `target-right`.
	 * @param {string} md-offset An offset to apply to the dropdown after positioning
	 *           `x`, `y`. Default value is `0`,`0`.
	 *
	 */
	
	MenuDirective.$inject = ["$mdUtil"];
	angular
	    .module('material.components.menu')
	    .directive('mdMenu', MenuDirective);
	
	/**
	 * @ngInject
	 */
	function MenuDirective($mdUtil) {
	  var INVALID_PREFIX = 'Invalid HTML for md-menu: ';
	  return {
	    restrict: 'E',
	    require: ['mdMenu', '?^mdMenuBar'],
	    controller: 'mdMenuCtrl', // empty function to be built by link
	    scope: true,
	    compile: compile
	  };
	
	  function compile(templateElement) {
	    templateElement.addClass('md-menu');
	
	    var triggerEl = templateElement.children()[0];
	    var contentEl = templateElement.children()[1];
	
	    var prefixer = $mdUtil.prefixer();
	
	    if (!prefixer.hasAttribute(triggerEl, 'ng-click')) {
	      triggerEl = triggerEl
	          .querySelector(prefixer.buildSelector(['ng-click', 'ng-mouseenter'])) || triggerEl;
	    }
	
	    var isButtonTrigger = triggerEl.nodeName === 'MD-BUTTON' || triggerEl.nodeName === 'BUTTON';
	
	    if (triggerEl && isButtonTrigger && !triggerEl.hasAttribute('type')) {
	      triggerEl.setAttribute('type', 'button');
	    }
	
	    if (!triggerEl) {
	      throw Error(INVALID_PREFIX + 'Expected the menu to have a trigger element.');
	    }
	
	    if (!contentEl || contentEl.nodeName !== 'MD-MENU-CONTENT') {
	      throw Error(INVALID_PREFIX + 'Expected the menu to contain a `md-menu-content` element.');
	    }
	
	    // Default element for ARIA attributes has the ngClick or ngMouseenter expression
	    triggerEl && triggerEl.setAttribute('aria-haspopup', 'true');
	
	    var nestedMenus = templateElement[0].querySelectorAll('md-menu');
	    var nestingDepth = parseInt(templateElement[0].getAttribute('md-nest-level'), 10) || 0;
	    if (nestedMenus) {
	      angular.forEach($mdUtil.nodesToArray(nestedMenus), function(menuEl) {
	        if (!menuEl.hasAttribute('md-position-mode')) {
	          menuEl.setAttribute('md-position-mode', 'cascade');
	        }
	        menuEl.classList.add('_md-nested-menu');
	        menuEl.setAttribute('md-nest-level', nestingDepth + 1);
	      });
	    }
	    return link;
	  }
	
	  function link(scope, element, attr, ctrls) {
	    var mdMenuCtrl = ctrls[0];
	    var isInMenuBar = !!ctrls[1];
	    // Move everything into a md-menu-container and pass it to the controller
	    var menuContainer = angular.element( '<div class="_md md-open-menu-container md-whiteframe-z2"></div>');
	    var menuContents = element.children()[1];
	
	    element.addClass('_md');     // private md component indicator for styling
	
	    if (!menuContents.hasAttribute('role')) {
	      menuContents.setAttribute('role', 'menu');
	    }
	    menuContainer.append(menuContents);
	
	    element.on('$destroy', function() {
	      menuContainer.remove();
	    });
	
	    element.append(menuContainer);
	    menuContainer[0].style.display = 'none';
	    mdMenuCtrl.init(menuContainer, { isInMenuBar: isInMenuBar });
	
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	
	MenuProvider.$inject = ["$$interimElementProvider"];angular
	  .module('material.components.menu')
	  .provider('$mdMenu', MenuProvider);
	
	/*
	 * Interim element provider for the menu.
	 * Handles behavior for a menu while it is open, including:
	 *    - handling animating the menu opening/closing
	 *    - handling key/mouse events on the menu element
	 *    - handling enabling/disabling scroll while the menu is open
	 *    - handling redrawing during resizes and orientation changes
	 *
	 */
	
	function MenuProvider($$interimElementProvider) {
	  menuDefaultOptions.$inject = ["$mdUtil", "$mdTheming", "$mdConstant", "$document", "$window", "$q", "$$rAF", "$animateCss", "$animate", "$log"];
	  var MENU_EDGE_MARGIN = 8;
	
	  return $$interimElementProvider('$mdMenu')
	    .setDefaults({
	      methods: ['target'],
	      options: menuDefaultOptions
	    });
	
	  /* @ngInject */
	  function menuDefaultOptions($mdUtil, $mdTheming, $mdConstant, $document, $window, $q, $$rAF,
	                              $animateCss, $animate, $log) {
	
	    var prefixer = $mdUtil.prefixer();
	    var animator = $mdUtil.dom.animator;
	
	    return {
	      parent: 'body',
	      onShow: onShow,
	      onRemove: onRemove,
	      hasBackdrop: true,
	      disableParentScroll: true,
	      skipCompile: true,
	      preserveScope: true,
	      multiple: true,
	      themable: true
	    };
	
	    /**
	     * Show modal backdrop element...
	     * @returns {function(): void} A function that removes this backdrop
	     */
	    function showBackdrop(scope, element, options) {
	      if (options.nestLevel) return angular.noop;
	
	      // If we are not within a dialog...
	      if (options.disableParentScroll && !$mdUtil.getClosest(options.target, 'MD-DIALOG')) {
	        // !! DO this before creating the backdrop; since disableScrollAround()
	        //    configures the scroll offset; which is used by mdBackDrop postLink()
	        options.restoreScroll = $mdUtil.disableScrollAround(options.element, options.parent);
	      } else {
	        options.disableParentScroll = false;
	      }
	
	      if (options.hasBackdrop) {
	        options.backdrop = $mdUtil.createBackdrop(scope, "md-menu-backdrop md-click-catcher");
	
	        $animate.enter(options.backdrop, $document[0].body);
	      }
	
	      /**
	       * Hide and destroys the backdrop created by showBackdrop()
	       */
	      return function hideBackdrop() {
	        if (options.backdrop) options.backdrop.remove();
	        if (options.disableParentScroll) options.restoreScroll();
	      };
	    }
	
	    /**
	     * Removing the menu element from the DOM and remove all associated event listeners
	     * and backdrop
	     */
	    function onRemove(scope, element, opts) {
	      opts.cleanupInteraction();
	      opts.cleanupBackdrop();
	      opts.cleanupResizing();
	      opts.hideBackdrop();
	
	      // Before the menu is closing remove the clickable class.
	      element.removeClass('md-clickable');
	
	      // For navigation $destroy events, do a quick, non-animated removal,
	      // but for normal closes (from clicks, etc) animate the removal
	
	      return (opts.$destroy === true) ? detachAndClean() : animateRemoval().then( detachAndClean );
	
	      /**
	       * For normal closes, animate the removal.
	       * For forced closes (like $destroy events), skip the animations
	       */
	      function animateRemoval() {
	        return $animateCss(element, {addClass: 'md-leave'}).start();
	      }
	
	      /**
	       * Detach the element
	       */
	      function detachAndClean() {
	        element.removeClass('md-active');
	        detachElement(element, opts);
	        opts.alreadyOpen = false;
	      }
	
	    }
	
	    /**
	     * Inserts and configures the staged Menu element into the DOM, positioning it,
	     * and wiring up various interaction events
	     */
	    function onShow(scope, element, opts) {
	      sanitizeAndConfigure(opts);
	
	      if (opts.menuContentEl[0]) {
	        // Inherit the theme from the target element.
	        $mdTheming.inherit(opts.menuContentEl, opts.target);
	      } else {
	        $log.warn(
	          '$mdMenu: Menu elements should always contain a `md-menu-content` element,' +
	          'otherwise interactivity features will not work properly.',
	          element
	        );
	      }
	      
	      // Register various listeners to move menu on resize/orientation change
	      opts.cleanupResizing = startRepositioningOnResize();
	      opts.hideBackdrop = showBackdrop(scope, element, opts);
	
	      // Return the promise for when our menu is done animating in
	      return showMenu()
	        .then(function(response) {
	          opts.alreadyOpen = true;
	          opts.cleanupInteraction = activateInteraction();
	          opts.cleanupBackdrop = setupBackdrop();
	
	          // Since the menu finished its animation, mark the menu as clickable.
	          element.addClass('md-clickable');
	
	          return response;
	        });
	
	      /**
	       * Place the menu into the DOM and call positioning related functions
	       */
	      function showMenu() {
	        opts.parent.append(element);
	        element[0].style.display = '';
	
	        return $q(function(resolve) {
	          var position = calculateMenuPosition(element, opts);
	
	          element.removeClass('md-leave');
	
	          // Animate the menu scaling, and opacity [from its position origin (default == top-left)]
	          // to normal scale.
	          $animateCss(element, {
	            addClass: 'md-active',
	            from: animator.toCss(position),
	            to: animator.toCss({transform: ''})
	          })
	          .start()
	          .then(resolve);
	
	        });
	      }
	
	      /**
	       * Check for valid opts and set some sane defaults
	       */
	      function sanitizeAndConfigure() {
	        if (!opts.target) {
	          throw Error(
	            '$mdMenu.show() expected a target to animate from in options.target'
	          );
	        }
	        angular.extend(opts, {
	          alreadyOpen: false,
	          isRemoved: false,
	          target: angular.element(opts.target), //make sure it's not a naked dom node
	          parent: angular.element(opts.parent),
	          menuContentEl: angular.element(element[0].querySelector('md-menu-content'))
	        });
	      }
	
	      /**
	       * Configure various resize listeners for screen changes
	       */
	      function startRepositioningOnResize() {
	
	        var repositionMenu = (function(target, options) {
	          return $$rAF.throttle(function() {
	            if (opts.isRemoved) return;
	            var position = calculateMenuPosition(target, options);
	
	            target.css(animator.toCss(position));
	          });
	        })(element, opts);
	
	        $window.addEventListener('resize', repositionMenu);
	        $window.addEventListener('orientationchange', repositionMenu);
	
	        return function stopRepositioningOnResize() {
	
	          // Disable resizing handlers
	          $window.removeEventListener('resize', repositionMenu);
	          $window.removeEventListener('orientationchange', repositionMenu);
	
	        };
	      }
	
	      /**
	       * Sets up the backdrop and listens for click elements.
	       * Once the backdrop will be clicked, the menu will automatically close.
	       * @returns {!Function} Function to remove the backdrop.
	       */
	      function setupBackdrop() {
	        if (!opts.backdrop) return angular.noop;
	
	        opts.backdrop.on('click', onBackdropClick);
	
	        return function() {
	          opts.backdrop.off('click', onBackdropClick);
	        }
	      }
	
	      /**
	       * Function to be called whenever the backdrop is clicked.
	       * @param {!MouseEvent} event
	       */
	      function onBackdropClick(event) {
	        event.preventDefault();
	        event.stopPropagation();
	
	        scope.$apply(function() {
	          opts.mdMenuCtrl.close(true, { closeAll: true });
	        });
	      }
	
	      /**
	       * Activate interaction on the menu. Resolves the focus target and closes the menu on
	       * escape or option click.
	       * @returns {!Function} Function to deactivate the interaction listeners.
	       */
	      function activateInteraction() {
	        if (!opts.menuContentEl[0]) return angular.noop;
	
	        // Wire up keyboard listeners.
	        // - Close on escape,
	        // - focus next item on down arrow,
	        // - focus prev item on up
	        opts.menuContentEl.on('keydown', onMenuKeyDown);
	        opts.menuContentEl[0].addEventListener('click', captureClickListener, true);
	
	        // kick off initial focus in the menu on the first enabled element
	        var focusTarget = opts.menuContentEl[0]
	          .querySelector(prefixer.buildSelector(['md-menu-focus-target', 'md-autofocus']));
	
	        if ( !focusTarget ) {
	          var childrenLen = opts.menuContentEl[0].children.length;
	          for(var childIndex = 0; childIndex < childrenLen; childIndex++) {
	            var child = opts.menuContentEl[0].children[childIndex];
	            focusTarget = child.querySelector('.md-button:not([disabled])');
	            if (focusTarget) {
	              break;
	            }
	            if (child.firstElementChild && !child.firstElementChild.disabled) {
	              focusTarget = child.firstElementChild;
	              break;
	            }
	          }
	        }
	
	        focusTarget && focusTarget.focus();
	
	        return function cleanupInteraction() {
	          opts.menuContentEl.off('keydown', onMenuKeyDown);
	          opts.menuContentEl[0].removeEventListener('click', captureClickListener, true);
	        };
	
	        // ************************************
	        // internal functions
	        // ************************************
	
	        function onMenuKeyDown(ev) {
	          var handled;
	          switch (ev.keyCode) {
	            case $mdConstant.KEY_CODE.ESCAPE:
	              opts.mdMenuCtrl.close(false, { closeAll: true });
	              handled = true;
	              break;
	            case $mdConstant.KEY_CODE.UP_ARROW:
	              if (!focusMenuItem(ev, opts.menuContentEl, opts, -1) && !opts.nestLevel) {
	                opts.mdMenuCtrl.triggerContainerProxy(ev);
	              }
	              handled = true;
	              break;
	            case $mdConstant.KEY_CODE.DOWN_ARROW:
	              if (!focusMenuItem(ev, opts.menuContentEl, opts, 1) && !opts.nestLevel) {
	                opts.mdMenuCtrl.triggerContainerProxy(ev);
	              }
	              handled = true;
	              break;
	            case $mdConstant.KEY_CODE.LEFT_ARROW:
	              if (opts.nestLevel) {
	                opts.mdMenuCtrl.close();
	              } else {
	                opts.mdMenuCtrl.triggerContainerProxy(ev);
	              }
	              handled = true;
	              break;
	            case $mdConstant.KEY_CODE.RIGHT_ARROW:
	              var parentMenu = $mdUtil.getClosest(ev.target, 'MD-MENU');
	              if (parentMenu && parentMenu != opts.parent[0]) {
	                ev.target.click();
	              } else {
	                opts.mdMenuCtrl.triggerContainerProxy(ev);
	              }
	              handled = true;
	              break;
	          }
	          if (handled) {
	            ev.preventDefault();
	            ev.stopImmediatePropagation();
	          }
	        }
	
	        function onBackdropClick(e) {
	          e.preventDefault();
	          e.stopPropagation();
	          scope.$apply(function() {
	            opts.mdMenuCtrl.close(true, { closeAll: true });
	          });
	        }
	
	        // Close menu on menu item click, if said menu-item is not disabled
	        function captureClickListener(e) {
	          var target = e.target;
	          // Traverse up the event until we get to the menuContentEl to see if
	          // there is an ng-click and that the ng-click is not disabled
	          do {
	            if (target == opts.menuContentEl[0]) return;
	            if ((hasAnyAttribute(target, ['ng-click', 'ng-href', 'ui-sref']) ||
	                target.nodeName == 'BUTTON' || target.nodeName == 'MD-BUTTON') && !hasAnyAttribute(target, ['md-prevent-menu-close'])) {
	              var closestMenu = $mdUtil.getClosest(target, 'MD-MENU');
	              if (!target.hasAttribute('disabled') && (!closestMenu || closestMenu == opts.parent[0])) {
	                close();
	              }
	              break;
	            }
	          } while (target = target.parentNode);
	
	          function close() {
	            scope.$apply(function() {
	              opts.mdMenuCtrl.close(true, { closeAll: true });
	            });
	          }
	
	          function hasAnyAttribute(target, attrs) {
	            if (!target) return false;
	
	            for (var i = 0, attr; attr = attrs[i]; ++i) {
	              if (prefixer.hasAttribute(target, attr)) {
	                return true;
	              }
	            }
	
	            return false;
	          }
	        }
	
	      }
	    }
	
	    /**
	     * Takes a keypress event and focuses the next/previous menu
	     * item from the emitting element
	     * @param {event} e - The origin keypress event
	     * @param {angular.element} menuEl - The menu element
	     * @param {object} opts - The interim element options for the mdMenu
	     * @param {number} direction - The direction to move in (+1 = next, -1 = prev)
	     */
	    function focusMenuItem(e, menuEl, opts, direction) {
	      var currentItem = $mdUtil.getClosest(e.target, 'MD-MENU-ITEM');
	
	      var items = $mdUtil.nodesToArray(menuEl[0].children);
	      var currentIndex = items.indexOf(currentItem);
	
	      // Traverse through our elements in the specified direction (+/-1) and try to
	      // focus them until we find one that accepts focus
	      var didFocus;
	      for (var i = currentIndex + direction; i >= 0 && i < items.length; i = i + direction) {
	        var focusTarget = items[i].querySelector('.md-button');
	        didFocus = attemptFocus(focusTarget);
	        if (didFocus) {
	          break;
	        }
	      }
	      return didFocus;
	    }
	
	    /**
	     * Attempts to focus an element. Checks whether that element is the currently
	     * focused element after attempting.
	     * @param {HTMLElement} el - the element to attempt focus on
	     * @returns {bool} - whether the element was successfully focused
	     */
	    function attemptFocus(el) {
	      if (el && el.getAttribute('tabindex') != -1) {
	        el.focus();
	        return ($document[0].activeElement == el);
	      }
	    }
	
	    /**
	     * Use browser to remove this element without triggering a $destroy event
	     */
	    function detachElement(element, opts) {
	      if (!opts.preserveElement) {
	        if (toNode(element).parentNode === toNode(opts.parent)) {
	          toNode(opts.parent).removeChild(toNode(element));
	        }
	      } else {
	        toNode(element).style.display = 'none';
	      }
	    }
	
	    /**
	     * Computes menu position and sets the style on the menu container
	     * @param {HTMLElement} el - the menu container element
	     * @param {object} opts - the interim element options object
	     */
	    function calculateMenuPosition(el, opts) {
	
	      var containerNode = el[0],
	        openMenuNode = el[0].firstElementChild,
	        openMenuNodeRect = openMenuNode.getBoundingClientRect(),
	        boundryNode = $document[0].body,
	        boundryNodeRect = boundryNode.getBoundingClientRect();
	
	      var menuStyle = $window.getComputedStyle(openMenuNode);
	
	      var originNode = opts.target[0].querySelector(prefixer.buildSelector('md-menu-origin')) || opts.target[0],
	        originNodeRect = originNode.getBoundingClientRect();
	
	      var bounds = {
	        left: boundryNodeRect.left + MENU_EDGE_MARGIN,
	        top: Math.max(boundryNodeRect.top, 0) + MENU_EDGE_MARGIN,
	        bottom: Math.max(boundryNodeRect.bottom, Math.max(boundryNodeRect.top, 0) + boundryNodeRect.height) - MENU_EDGE_MARGIN,
	        right: boundryNodeRect.right - MENU_EDGE_MARGIN
	      };
	
	      var alignTarget, alignTargetRect = { top:0, left : 0, right:0, bottom:0 }, existingOffsets  = { top:0, left : 0, right:0, bottom:0  };
	      var positionMode = opts.mdMenuCtrl.positionMode();
	
	      if (positionMode.top == 'target' || positionMode.left == 'target' || positionMode.left == 'target-right') {
	        alignTarget = firstVisibleChild();
	        if ( alignTarget ) {
	          // TODO: Allow centering on an arbitrary node, for now center on first menu-item's child
	          alignTarget = alignTarget.firstElementChild || alignTarget;
	          alignTarget = alignTarget.querySelector(prefixer.buildSelector('md-menu-align-target')) || alignTarget;
	          alignTargetRect = alignTarget.getBoundingClientRect();
	
	          existingOffsets = {
	            top: parseFloat(containerNode.style.top || 0),
	            left: parseFloat(containerNode.style.left || 0)
	          };
	        }
	      }
	
	      var position = {};
	      var transformOrigin = 'top ';
	
	      switch (positionMode.top) {
	        case 'target':
	          position.top = existingOffsets.top + originNodeRect.top - alignTargetRect.top;
	          break;
	        case 'cascade':
	          position.top = originNodeRect.top - parseFloat(menuStyle.paddingTop) - originNode.style.top;
	          break;
	        case 'bottom':
	          position.top = originNodeRect.top + originNodeRect.height;
	          break;
	        default:
	          throw new Error('Invalid target mode "' + positionMode.top + '" specified for md-menu on Y axis.');
	      }
	
	      var rtl = ($mdUtil.bidi() == 'rtl');
	
	      switch (positionMode.left) {
	        case 'target':
	          position.left = existingOffsets.left + originNodeRect.left - alignTargetRect.left;
	          transformOrigin += rtl ? 'right'  : 'left';
	          break;
	        case 'target-left':
	          position.left = originNodeRect.left;
	          transformOrigin += 'left';
	          break;
	        case 'target-right':
	          position.left = originNodeRect.right - openMenuNodeRect.width + (openMenuNodeRect.right - alignTargetRect.right);
	          transformOrigin += 'right';
	          break;
	        case 'cascade':
	          var willFitRight = rtl ? (originNodeRect.left - openMenuNodeRect.width) < bounds.left : (originNodeRect.right + openMenuNodeRect.width) < bounds.right;
	          position.left = willFitRight ? originNodeRect.right - originNode.style.left : originNodeRect.left - originNode.style.left - openMenuNodeRect.width;
	          transformOrigin += willFitRight ? 'left' : 'right';
	          break;
	        case 'right':
	          if (rtl) {
	            position.left = originNodeRect.right - originNodeRect.width;
	            transformOrigin += 'left';
	          } else {
	            position.left = originNodeRect.right - openMenuNodeRect.width;
	            transformOrigin += 'right';
	          }
	          break;
	        case 'left':
	          if (rtl) {
	            position.left = originNodeRect.right - openMenuNodeRect.width;
	            transformOrigin += 'right';
	          } else {
	            position.left = originNodeRect.left;
	            transformOrigin += 'left';
	          }
	          break;
	        default:
	          throw new Error('Invalid target mode "' + positionMode.left + '" specified for md-menu on X axis.');
	      }
	
	      var offsets = opts.mdMenuCtrl.offsets();
	      position.top += offsets.top;
	      position.left += offsets.left;
	
	      clamp(position);
	
	      var scaleX = Math.round(100 * Math.min(originNodeRect.width / containerNode.offsetWidth, 1.0)) / 100;
	      var scaleY = Math.round(100 * Math.min(originNodeRect.height / containerNode.offsetHeight, 1.0)) / 100;
	
	      return {
	        top: Math.round(position.top),
	        left: Math.round(position.left),
	        // Animate a scale out if we aren't just repositioning
	        transform: !opts.alreadyOpen ? $mdUtil.supplant('scale({0},{1})', [scaleX, scaleY]) : undefined,
	        transformOrigin: transformOrigin
	      };
	
	      /**
	       * Clamps the repositioning of the menu within the confines of
	       * bounding element (often the screen/body)
	       */
	      function clamp(pos) {
	        pos.top = Math.max(Math.min(pos.top, bounds.bottom - containerNode.offsetHeight), bounds.top);
	        pos.left = Math.max(Math.min(pos.left, bounds.right - containerNode.offsetWidth), bounds.left);
	      }
	
	      /**
	       * Gets the first visible child in the openMenuNode
	       * Necessary incase menu nodes are being dynamically hidden
	       */
	      function firstVisibleChild() {
	        for (var i = 0; i < openMenuNode.children.length; ++i) {
	          if ($window.getComputedStyle(openMenuNode.children[i]).display != 'none') {
	            return openMenuNode.children[i];
	          }
	        }
	      }
	    }
	  }
	  function toNode(el) {
	    if (el instanceof angular.element) {
	      el = el[0];
	    }
	    return el;
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	
	MenuBarController.$inject = ["$scope", "$rootScope", "$element", "$attrs", "$mdConstant", "$document", "$mdUtil", "$timeout"];
	angular
	  .module('material.components.menuBar')
	  .controller('MenuBarController', MenuBarController);
	
	var BOUND_MENU_METHODS = ['handleKeyDown', 'handleMenuHover', 'scheduleOpenHoveredMenu', 'cancelScheduledOpen'];
	
	/**
	 * @ngInject
	 */
	function MenuBarController($scope, $rootScope, $element, $attrs, $mdConstant, $document, $mdUtil, $timeout) {
	  this.$element = $element;
	  this.$attrs = $attrs;
	  this.$mdConstant = $mdConstant;
	  this.$mdUtil = $mdUtil;
	  this.$document = $document;
	  this.$scope = $scope;
	  this.$rootScope = $rootScope;
	  this.$timeout = $timeout;
	
	  var self = this;
	  angular.forEach(BOUND_MENU_METHODS, function(methodName) {
	    self[methodName] = angular.bind(self, self[methodName]);
	  });
	}
	
	MenuBarController.prototype.init = function() {
	  var $element = this.$element;
	  var $mdUtil = this.$mdUtil;
	  var $scope = this.$scope;
	
	  var self = this;
	  var deregisterFns = [];
	  $element.on('keydown', this.handleKeyDown);
	  this.parentToolbar = $mdUtil.getClosest($element, 'MD-TOOLBAR');
	
	  deregisterFns.push(this.$rootScope.$on('$mdMenuOpen', function(event, el) {
	    if (self.getMenus().indexOf(el[0]) != -1) {
	      $element[0].classList.add('md-open');
	      el[0].classList.add('md-open');
	      self.currentlyOpenMenu = el.controller('mdMenu');
	      self.currentlyOpenMenu.registerContainerProxy(self.handleKeyDown);
	      self.enableOpenOnHover();
	    }
	  }));
	
	  deregisterFns.push(this.$rootScope.$on('$mdMenuClose', function(event, el, opts) {
	    var rootMenus = self.getMenus();
	    if (rootMenus.indexOf(el[0]) != -1) {
	      $element[0].classList.remove('md-open');
	      el[0].classList.remove('md-open');
	    }
	
	    if ($element[0].contains(el[0])) {
	      var parentMenu = el[0];
	      while (parentMenu && rootMenus.indexOf(parentMenu) == -1) {
	        parentMenu = $mdUtil.getClosest(parentMenu, 'MD-MENU', true);
	      }
	      if (parentMenu) {
	        if (!opts.skipFocus) parentMenu.querySelector('button:not([disabled])').focus();
	        self.currentlyOpenMenu = undefined;
	        self.disableOpenOnHover();
	        self.setKeyboardMode(true);
	      }
	    }
	  }));
	
	  $scope.$on('$destroy', function() {
	    self.disableOpenOnHover();
	    while (deregisterFns.length) {
	      deregisterFns.shift()();
	    }
	  });
	
	
	  this.setKeyboardMode(true);
	};
	
	MenuBarController.prototype.setKeyboardMode = function(enabled) {
	  if (enabled) this.$element[0].classList.add('md-keyboard-mode');
	  else this.$element[0].classList.remove('md-keyboard-mode');
	};
	
	MenuBarController.prototype.enableOpenOnHover = function() {
	  if (this.openOnHoverEnabled) return;
	
	  var self = this;
	
	  self.openOnHoverEnabled = true;
	
	  if (self.parentToolbar) {
	    self.parentToolbar.classList.add('md-has-open-menu');
	
	    // Needs to be on the next tick so it doesn't close immediately.
	    self.$mdUtil.nextTick(function() {
	      angular.element(self.parentToolbar).on('click', self.handleParentClick);
	    }, false);
	  }
	
	  angular
	    .element(self.getMenus())
	    .on('mouseenter', self.handleMenuHover);
	};
	
	MenuBarController.prototype.handleMenuHover = function(e) {
	  this.setKeyboardMode(false);
	  if (this.openOnHoverEnabled) {
	    this.scheduleOpenHoveredMenu(e);
	  }
	};
	
	MenuBarController.prototype.disableOpenOnHover = function() {
	  if (!this.openOnHoverEnabled) return;
	
	  this.openOnHoverEnabled = false;
	
	  if (this.parentToolbar) {
	    this.parentToolbar.classList.remove('md-has-open-menu');
	    angular.element(this.parentToolbar).off('click', this.handleParentClick);
	  }
	
	  angular
	    .element(this.getMenus())
	    .off('mouseenter', this.handleMenuHover);
	};
	
	MenuBarController.prototype.scheduleOpenHoveredMenu = function(e) {
	  var menuEl = angular.element(e.currentTarget);
	  var menuCtrl = menuEl.controller('mdMenu');
	  this.setKeyboardMode(false);
	  this.scheduleOpenMenu(menuCtrl);
	};
	
	MenuBarController.prototype.scheduleOpenMenu = function(menuCtrl) {
	  var self = this;
	  var $timeout = this.$timeout;
	  if (menuCtrl != self.currentlyOpenMenu) {
	    $timeout.cancel(self.pendingMenuOpen);
	    self.pendingMenuOpen = $timeout(function() {
	      self.pendingMenuOpen = undefined;
	      if (self.currentlyOpenMenu) {
	        self.currentlyOpenMenu.close(true, { closeAll: true });
	      }
	      menuCtrl.open();
	    }, 200, false);
	  }
	};
	
	MenuBarController.prototype.handleKeyDown = function(e) {
	  var keyCodes = this.$mdConstant.KEY_CODE;
	  var currentMenu = this.currentlyOpenMenu;
	  var wasOpen = currentMenu && currentMenu.isOpen;
	  this.setKeyboardMode(true);
	  var handled, newMenu, newMenuCtrl;
	  switch (e.keyCode) {
	    case keyCodes.DOWN_ARROW:
	      if (currentMenu) {
	        currentMenu.focusMenuContainer();
	      } else {
	        this.openFocusedMenu();
	      }
	      handled = true;
	      break;
	    case keyCodes.UP_ARROW:
	      currentMenu && currentMenu.close();
	      handled = true;
	      break;
	    case keyCodes.LEFT_ARROW:
	      newMenu = this.focusMenu(-1);
	      if (wasOpen) {
	        newMenuCtrl = angular.element(newMenu).controller('mdMenu');
	        this.scheduleOpenMenu(newMenuCtrl);
	      }
	      handled = true;
	      break;
	    case keyCodes.RIGHT_ARROW:
	      newMenu = this.focusMenu(+1);
	      if (wasOpen) {
	        newMenuCtrl = angular.element(newMenu).controller('mdMenu');
	        this.scheduleOpenMenu(newMenuCtrl);
	      }
	      handled = true;
	      break;
	  }
	  if (handled) {
	    e && e.preventDefault && e.preventDefault();
	    e && e.stopImmediatePropagation && e.stopImmediatePropagation();
	  }
	};
	
	MenuBarController.prototype.focusMenu = function(direction) {
	  var menus = this.getMenus();
	  var focusedIndex = this.getFocusedMenuIndex();
	
	  if (focusedIndex == -1) { focusedIndex = this.getOpenMenuIndex(); }
	
	  var changed = false;
	
	  if (focusedIndex == -1) { focusedIndex = 0; changed = true; }
	  else if (
	    direction < 0 && focusedIndex > 0 ||
	    direction > 0 && focusedIndex < menus.length - direction
	  ) {
	    focusedIndex += direction;
	    changed = true;
	  }
	  if (changed) {
	    menus[focusedIndex].querySelector('button').focus();
	    return menus[focusedIndex];
	  }
	};
	
	MenuBarController.prototype.openFocusedMenu = function() {
	  var menu = this.getFocusedMenu();
	  menu && angular.element(menu).controller('mdMenu').open();
	};
	
	MenuBarController.prototype.getMenus = function() {
	  var $element = this.$element;
	  return this.$mdUtil.nodesToArray($element[0].children)
	    .filter(function(el) { return el.nodeName == 'MD-MENU'; });
	};
	
	MenuBarController.prototype.getFocusedMenu = function() {
	  return this.getMenus()[this.getFocusedMenuIndex()];
	};
	
	MenuBarController.prototype.getFocusedMenuIndex = function() {
	  var $mdUtil = this.$mdUtil;
	  var focusedEl = $mdUtil.getClosest(
	    this.$document[0].activeElement,
	    'MD-MENU'
	  );
	  if (!focusedEl) return -1;
	
	  var focusedIndex = this.getMenus().indexOf(focusedEl);
	  return focusedIndex;
	};
	
	MenuBarController.prototype.getOpenMenuIndex = function() {
	  var menus = this.getMenus();
	  for (var i = 0; i < menus.length; ++i) {
	    if (menus[i].classList.contains('md-open')) return i;
	  }
	  return -1;
	};
	
	MenuBarController.prototype.handleParentClick = function(event) {
	  var openMenu = this.querySelector('md-menu.md-open');
	
	  if (openMenu && !openMenu.contains(event.target)) {
	    angular.element(openMenu).controller('mdMenu').close(true, {
	      closeAll: true
	    });
	  }
	};
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc directive
	 * @name mdMenuBar
	 * @module material.components.menuBar
	 * @restrict E
	 * @description
	 *
	 * Menu bars are containers that hold multiple menus. They change the behavior and appearence
	 * of the `md-menu` directive to behave similar to an operating system provided menu.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-menu-bar>
	 *   <md-menu>
	 *     <button ng-click="$mdMenu.open()">
	 *       File
	 *     </button>
	 *     <md-menu-content>
	 *       <md-menu-item>
	 *         <md-button ng-click="ctrl.sampleAction('share', $event)">
	 *           Share...
	 *         </md-button>
	 *       </md-menu-item>
	 *       <md-menu-divider></md-menu-divider>
	 *       <md-menu-item>
	 *       <md-menu-item>
	 *         <md-menu>
	 *           <md-button ng-click="$mdMenu.open()">New</md-button>
	 *           <md-menu-content>
	 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Document', $event)">Document</md-button></md-menu-item>
	 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Spreadsheet', $event)">Spreadsheet</md-button></md-menu-item>
	 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Presentation', $event)">Presentation</md-button></md-menu-item>
	 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Form', $event)">Form</md-button></md-menu-item>
	 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Drawing', $event)">Drawing</md-button></md-menu-item>
	 *           </md-menu-content>
	 *         </md-menu>
	 *       </md-menu-item>
	 *     </md-menu-content>
	 *   </md-menu>
	 * </md-menu-bar>
	 * </hljs>
	 *
	 * ## Menu Bar Controls
	 *
	 * You may place `md-menu-items` that function as controls within menu bars.
	 * There are two modes that are exposed via the `type` attribute of the `md-menu-item`.
	 * `type="checkbox"` will function as a boolean control for the `ng-model` attribute of the
	 * `md-menu-item`. `type="radio"` will function like a radio button, setting the `ngModel`
	 * to the `string` value of the `value` attribute. If you need non-string values, you can use
	 * `ng-value` to provide an expression (this is similar to how angular's native `input[type=radio]` works.
	 *
	 * <hljs lang="html">
	 * <md-menu-bar>
	 *  <md-menu>
	 *    <button ng-click="$mdMenu.open()">
	 *      Sample Menu
	 *    </button>
	 *    <md-menu-content>
	 *      <md-menu-item type="checkbox" ng-model="settings.allowChanges">Allow changes</md-menu-item>
	 *      <md-menu-divider></md-menu-divider>
	 *      <md-menu-item type="radio" ng-model="settings.mode" ng-value="1">Mode 1</md-menu-item>
	 *      <md-menu-item type="radio" ng-model="settings.mode" ng-value="1">Mode 2</md-menu-item>
	 *      <md-menu-item type="radio" ng-model="settings.mode" ng-value="1">Mode 3</md-menu-item>
	 *    </md-menu-content>
	 *  </md-menu>
	 * </md-menu-bar>
	 * </hljs>
	 *
	 *
	 * ### Nesting Menus
	 *
	 * Menus may be nested within menu bars. This is commonly called cascading menus.
	 * To nest a menu place the nested menu inside the content of the `md-menu-item`.
	 * <hljs lang="html">
	 * <md-menu-item>
	 *   <md-menu>
	 *     <button ng-click="$mdMenu.open()">New</md-button>
	 *     <md-menu-content>
	 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Document', $event)">Document</md-button></md-menu-item>
	 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Spreadsheet', $event)">Spreadsheet</md-button></md-menu-item>
	 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Presentation', $event)">Presentation</md-button></md-menu-item>
	 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Form', $event)">Form</md-button></md-menu-item>
	 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Drawing', $event)">Drawing</md-button></md-menu-item>
	 *     </md-menu-content>
	 *   </md-menu>
	 * </md-menu-item>
	 * </hljs>
	 *
	 */
	
	MenuBarDirective.$inject = ["$mdUtil", "$mdTheming"];
	angular
	  .module('material.components.menuBar')
	  .directive('mdMenuBar', MenuBarDirective);
	
	/* @ngInject */
	function MenuBarDirective($mdUtil, $mdTheming) {
	  return {
	    restrict: 'E',
	    require: 'mdMenuBar',
	    controller: 'MenuBarController',
	
	    compile: function compile(templateEl, templateAttrs) {
	      if (!templateAttrs.ariaRole) {
	        templateEl[0].setAttribute('role', 'menubar');
	      }
	      angular.forEach(templateEl[0].children, function(menuEl) {
	        if (menuEl.nodeName == 'MD-MENU') {
	          if (!menuEl.hasAttribute('md-position-mode')) {
	            menuEl.setAttribute('md-position-mode', 'left bottom');
	
	            // Since we're in the compile function and actual `md-buttons` are not compiled yet,
	            // we need to query for possible `md-buttons` as well.
	            menuEl.querySelector('button, a, md-button').setAttribute('role', 'menuitem');
	          }
	          var contentEls = $mdUtil.nodesToArray(menuEl.querySelectorAll('md-menu-content'));
	          angular.forEach(contentEls, function(contentEl) {
	            contentEl.classList.add('md-menu-bar-menu');
	            contentEl.classList.add('md-dense');
	            if (!contentEl.hasAttribute('width')) {
	              contentEl.setAttribute('width', 5);
	            }
	          });
	        }
	      });
	
	      // Mark the child menu items that they're inside a menu bar. This is necessary,
	      // because mnMenuItem has special behaviour during compilation, depending on
	      // whether it is inside a mdMenuBar. We can usually figure this out via the DOM,
	      // however if a directive that uses documentFragment is applied to the child (e.g. ngRepeat),
	      // the element won't have a parent and won't compile properly.
	      templateEl.find('md-menu-item').addClass('md-in-menu-bar');
	
	      return function postLink(scope, el, attr, ctrl) {
	        el.addClass('_md');     // private md component indicator for styling
	        $mdTheming(scope, el);
	        ctrl.init();
	      };
	    }
	  };
	
	}
	
	})();
	(function(){
	"use strict";
	
	
	angular
	  .module('material.components.menuBar')
	  .directive('mdMenuDivider', MenuDividerDirective);
	
	
	function MenuDividerDirective() {
	  return {
	    restrict: 'E',
	    compile: function(templateEl, templateAttrs) {
	      if (!templateAttrs.role) {
	        templateEl[0].setAttribute('role', 'separator');
	      }
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	
	MenuItemController.$inject = ["$scope", "$element", "$attrs"];
	angular
	  .module('material.components.menuBar')
	  .controller('MenuItemController', MenuItemController);
	
	
	/**
	 * @ngInject
	 */
	function MenuItemController($scope, $element, $attrs) {
	  this.$element = $element;
	  this.$attrs = $attrs;
	  this.$scope = $scope;
	}
	
	MenuItemController.prototype.init = function(ngModel) {
	  var $element = this.$element;
	  var $attrs = this.$attrs;
	
	  this.ngModel = ngModel;
	  if ($attrs.type == 'checkbox' || $attrs.type == 'radio') {
	    this.mode  = $attrs.type;
	    this.iconEl = $element[0].children[0];
	    this.buttonEl = $element[0].children[1];
	    if (ngModel) {
	      // Clear ngAria set attributes
	      this.initClickListeners();
	    }
	  }
	};
	
	// ngAria auto sets attributes on a menu-item with a ngModel.
	// We don't want this because our content (buttons) get the focus
	// and set their own aria attributes appropritately. Having both
	// breaks NVDA / JAWS. This undeoes ngAria's attrs.
	MenuItemController.prototype.clearNgAria = function() {
	  var el = this.$element[0];
	  var clearAttrs = ['role', 'tabindex', 'aria-invalid', 'aria-checked'];
	  angular.forEach(clearAttrs, function(attr) {
	    el.removeAttribute(attr);
	  });
	};
	
	MenuItemController.prototype.initClickListeners = function() {
	  var self = this;
	  var ngModel = this.ngModel;
	  var $scope = this.$scope;
	  var $attrs = this.$attrs;
	  var $element = this.$element;
	  var mode = this.mode;
	
	  this.handleClick = angular.bind(this, this.handleClick);
	
	  var icon = this.iconEl;
	  var button = angular.element(this.buttonEl);
	  var handleClick = this.handleClick;
	
	  $attrs.$observe('disabled', setDisabled);
	  setDisabled($attrs.disabled);
	
	  ngModel.$render = function render() {
	    self.clearNgAria();
	    if (isSelected()) {
	      icon.style.display = '';
	      button.attr('aria-checked', 'true');
	    } else {
	      icon.style.display = 'none';
	      button.attr('aria-checked', 'false');
	    }
	  };
	
	  $scope.$$postDigest(ngModel.$render);
	
	  function isSelected() {
	    if (mode == 'radio') {
	      var val = $attrs.ngValue ? $scope.$eval($attrs.ngValue) : $attrs.value;
	      return ngModel.$modelValue == val;
	    } else {
	      return ngModel.$modelValue;
	    }
	  }
	
	  function setDisabled(disabled) {
	    if (disabled) {
	      button.off('click', handleClick);
	    } else {
	      button.on('click', handleClick);
	    }
	  }
	};
	
	MenuItemController.prototype.handleClick = function(e) {
	  var mode = this.mode;
	  var ngModel = this.ngModel;
	  var $attrs = this.$attrs;
	  var newVal;
	  if (mode == 'checkbox') {
	    newVal = !ngModel.$modelValue;
	  } else if (mode == 'radio') {
	    newVal = $attrs.ngValue ? this.$scope.$eval($attrs.ngValue) : $attrs.value;
	  }
	  ngModel.$setViewValue(newVal);
	  ngModel.$render();
	};
	
	})();
	(function(){
	"use strict";
	
	
	MenuItemDirective.$inject = ["$mdUtil", "$mdConstant", "$$mdSvgRegistry"];
	angular
	  .module('material.components.menuBar')
	  .directive('mdMenuItem', MenuItemDirective);
	
	 /* @ngInject */
	function MenuItemDirective($mdUtil, $mdConstant, $$mdSvgRegistry) {
	  return {
	    controller: 'MenuItemController',
	    require: ['mdMenuItem', '?ngModel'],
	    priority: $mdConstant.BEFORE_NG_ARIA,
	    compile: function(templateEl, templateAttrs) {
	      var type = templateAttrs.type;
	      var inMenuBarClass = 'md-in-menu-bar';
	
	      // Note: This allows us to show the `check` icon for the md-menu-bar items.
	      // The `md-in-menu-bar` class is set by the mdMenuBar directive.
	      if ((type == 'checkbox' || type == 'radio') && templateEl.hasClass(inMenuBarClass)) {
	        var text = templateEl[0].textContent;
	        var buttonEl = angular.element('<md-button type="button"></md-button>');
	        var iconTemplate = '<md-icon md-svg-src="' + $$mdSvgRegistry.mdChecked + '"></md-icon>';
	
	        buttonEl.html(text);
	        buttonEl.attr('tabindex', '0');
	
	        templateEl.html('');
	        templateEl.append(angular.element(iconTemplate));
	        templateEl.append(buttonEl);
	        templateEl.addClass('md-indent').removeClass(inMenuBarClass);
	
	        setDefault('role', type == 'checkbox' ? 'menuitemcheckbox' : 'menuitemradio', buttonEl);
	        moveAttrToButton('ng-disabled');
	
	      } else {
	        setDefault('role', 'menuitem', templateEl[0].querySelector('md-button, button, a'));
	      }
	
	
	      return function(scope, el, attrs, ctrls) {
	        var ctrl = ctrls[0];
	        var ngModel = ctrls[1];
	        ctrl.init(ngModel);
	      };
	
	      function setDefault(attr, val, el) {
	        el = el || templateEl;
	        if (el instanceof angular.element) {
	          el = el[0];
	        }
	        if (!el.hasAttribute(attr)) {
	          el.setAttribute(attr, val);
	        }
	      }
	
	      function moveAttrToButton(attribute) {
	        var attributes = $mdUtil.prefixer(attribute);
	
	        angular.forEach(attributes, function(attr) {
	          if (templateEl[0].hasAttribute(attr)) {
	            var val = templateEl[0].getAttribute(attr);
	            buttonEl[0].setAttribute(attr, val);
	            templateEl[0].removeAttribute(attr);
	          }
	        });
	      }
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc directive
	 * @name mdProgressCircular
	 * @module material.components.progressCircular
	 * @restrict E
	 *
	 * @description
	 * The circular progress directive is used to make loading content in your app as delightful and
	 * painless as possible by minimizing the amount of visual change a user sees before they can view
	 * and interact with content.
	 *
	 * For operations where the percentage of the operation completed can be determined, use a
	 * determinate indicator. They give users a quick sense of how long an operation will take.
	 *
	 * For operations where the user is asked to wait a moment while something finishes up, and it’s
	 * not necessary to expose what's happening behind the scenes and how long it will take, use an
	 * indeterminate indicator.
	 *
	 * @param {string} md-mode Select from one of two modes: **'determinate'** and **'indeterminate'**.
	 *
	 * Note: if the `md-mode` value is set as undefined or specified as not 1 of the two (2) valid modes, then **'indeterminate'**
	 * will be auto-applied as the mode.
	 *
	 * Note: if not configured, the `md-mode="indeterminate"` will be auto injected as an attribute.
	 * If `value=""` is also specified, however, then `md-mode="determinate"` would be auto-injected instead.
	 * @param {number=} value In determinate mode, this number represents the percentage of the
	 *     circular progress. Default: 0
	 * @param {number=} md-diameter This specifies the diameter of the circular progress. The value
	 * should be a pixel-size value (eg '100'). If this attribute is
	 * not present then a default value of '50px' is assumed.
	 *
	 * @param {boolean=} ng-disabled Determines whether to disable the progress element.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-progress-circular md-mode="determinate" value="..."></md-progress-circular>
	 *
	 * <md-progress-circular md-mode="determinate" ng-value="..."></md-progress-circular>
	 *
	 * <md-progress-circular md-mode="determinate" value="..." md-diameter="100"></md-progress-circular>
	 *
	 * <md-progress-circular md-mode="indeterminate"></md-progress-circular>
	 * </hljs>
	 */
	
	MdProgressCircularDirective.$inject = ["$window", "$mdProgressCircular", "$mdTheming", "$mdUtil", "$interval", "$log"];
	angular
	  .module('material.components.progressCircular')
	  .directive('mdProgressCircular', MdProgressCircularDirective);
	
	/* @ngInject */
	function MdProgressCircularDirective($window, $mdProgressCircular, $mdTheming,
	                                     $mdUtil, $interval, $log) {
	
	  // Note that this shouldn't use use $$rAF, because it can cause an infinite loop
	  // in any tests that call $animate.flush.
	  var rAF = $window.requestAnimationFrame ||
	            $window.webkitRequestAnimationFrame ||
	            angular.noop;
	
	  var cAF = $window.cancelAnimationFrame ||
	            $window.webkitCancelAnimationFrame ||
	            $window.webkitCancelRequestAnimationFrame ||
	            angular.noop;
	
	  var MODE_DETERMINATE = 'determinate';
	  var MODE_INDETERMINATE = 'indeterminate';
	  var DISABLED_CLASS = '_md-progress-circular-disabled';
	  var INDETERMINATE_CLASS = 'md-mode-indeterminate';
	
	  return {
	    restrict: 'E',
	    scope: {
	      value: '@',
	      mdDiameter: '@',
	      mdMode: '@'
	    },
	    template:
	      '<svg xmlns="http://www.w3.org/2000/svg">' +
	        '<path fill="none"/>' +
	      '</svg>',
	    compile: function(element, attrs) {
	      element.attr({
	        'aria-valuemin': 0,
	        'aria-valuemax': 100,
	        'role': 'progressbar'
	      });
	
	      if (angular.isUndefined(attrs.mdMode)) {
	        var mode = attrs.hasOwnProperty('value') ? MODE_DETERMINATE : MODE_INDETERMINATE;
	        attrs.$set('mdMode', mode);
	      } else {
	        attrs.$set('mdMode', attrs.mdMode.trim());
	      }
	
	      return MdProgressCircularLink;
	    }
	  };
	
	  function MdProgressCircularLink(scope, element, attrs) {
	    var node = element[0];
	    var svg = angular.element(node.querySelector('svg'));
	    var path = angular.element(node.querySelector('path'));
	    var startIndeterminate = $mdProgressCircular.startIndeterminate;
	    var endIndeterminate = $mdProgressCircular.endIndeterminate;
	    var iterationCount = 0;
	    var lastAnimationId = 0;
	    var lastDrawFrame;
	    var interval;
	
	    $mdTheming(element);
	    element.toggleClass(DISABLED_CLASS, attrs.hasOwnProperty('disabled'));
	
	    // If the mode is indeterminate, it doesn't need to
	    // wait for the next digest. It can start right away.
	    if(scope.mdMode === MODE_INDETERMINATE){
	      startIndeterminateAnimation();
	    }
	
	    scope.$on('$destroy', function(){
	      cleanupIndeterminateAnimation();
	
	      if (lastDrawFrame) {
	        cAF(lastDrawFrame);
	      }
	    });
	
	    scope.$watchGroup(['value', 'mdMode', function() {
	      var isDisabled = node.disabled;
	
	      // Sometimes the browser doesn't return a boolean, in
	      // which case we should check whether the attribute is
	      // present.
	      if (isDisabled === true || isDisabled === false){
	        return isDisabled;
	      }
	
	      return angular.isDefined(element.attr('disabled'));
	    }], function(newValues, oldValues) {
	      var mode = newValues[1];
	      var isDisabled = newValues[2];
	      var wasDisabled = oldValues[2];
	
	      if (isDisabled !== wasDisabled) {
	        element.toggleClass(DISABLED_CLASS, !!isDisabled);
	      }
	
	      if (isDisabled) {
	        cleanupIndeterminateAnimation();
	      } else {
	        if (mode !== MODE_DETERMINATE && mode !== MODE_INDETERMINATE) {
	          mode = MODE_INDETERMINATE;
	          attrs.$set('mdMode', mode);
	        }
	
	        if (mode === MODE_INDETERMINATE) {
	          startIndeterminateAnimation();
	        } else {
	          var newValue = clamp(newValues[0]);
	
	          cleanupIndeterminateAnimation();
	
	          element.attr('aria-valuenow', newValue);
	          renderCircle(clamp(oldValues[0]), newValue);
	        }
	      }
	
	    });
	
	    // This is in a separate watch in order to avoid layout, unless
	    // the value has actually changed.
	    scope.$watch('mdDiameter', function(newValue) {
	      var diameter = getSize(newValue);
	      var strokeWidth = getStroke(diameter);
	      var value = clamp(scope.value);
	      var transformOrigin = (diameter / 2) + 'px';
	      var dimensions = {
	        width: diameter + 'px',
	        height: diameter + 'px'
	      };
	
	      // The viewBox has to be applied via setAttribute, because it is
	      // case-sensitive. If jQuery is included in the page, `.attr` lowercases
	      // all attribute names.
	      svg[0].setAttribute('viewBox', '0 0 ' + diameter + ' ' + diameter);
	
	      // Usually viewBox sets the dimensions for the SVG, however that doesn't
	      // seem to be the case on IE10.
	      // Important! The transform origin has to be set from here and it has to
	      // be in the format of "Ypx Ypx Ypx", otherwise the rotation wobbles in
	      // IE and Edge, because they don't account for the stroke width when
	      // rotating. Also "center" doesn't help in this case, it has to be a
	      // precise value.
	      svg
	        .css(dimensions)
	        .css('transform-origin', transformOrigin + ' ' + transformOrigin + ' ' + transformOrigin);
	
	      element.css(dimensions);
	
	      path.attr('stroke-width', strokeWidth);
	      path.attr('stroke-linecap', 'square');
	      if (scope.mdMode == MODE_INDETERMINATE) {
	        path.attr('d', getSvgArc(diameter, strokeWidth, true));
	        path.attr('stroke-dasharray', (diameter - strokeWidth) * $window.Math.PI * 0.75);
	        path.attr('stroke-dashoffset', getDashLength(diameter, strokeWidth, 1, 75));
	      } else {
	        path.attr('d', getSvgArc(diameter, strokeWidth, false));
	        path.attr('stroke-dasharray', (diameter - strokeWidth) * $window.Math.PI);
	        path.attr('stroke-dashoffset', getDashLength(diameter, strokeWidth, 0, 100));
	        renderCircle(value, value);
	      }
	
	    });
	
	    function renderCircle(animateFrom, animateTo, easing, duration, iterationCount, maxValue) {
	      var id = ++lastAnimationId;
	      var startTime = $mdUtil.now();
	      var changeInValue = animateTo - animateFrom;
	      var diameter = getSize(scope.mdDiameter);
	      var strokeWidth = getStroke(diameter);
	      var ease = easing || $mdProgressCircular.easeFn;
	      var animationDuration = duration || $mdProgressCircular.duration;
	      var rotation = -90 * (iterationCount || 0);
	      var dashLimit = maxValue || 100;
	
	      // No need to animate it if the values are the same
	      if (animateTo === animateFrom) {
	        renderFrame(animateTo);
	      } else {
	        lastDrawFrame = rAF(function animation() {
	          var currentTime = $window.Math.max(0, $window.Math.min($mdUtil.now() - startTime, animationDuration));
	
	          renderFrame(ease(currentTime, animateFrom, changeInValue, animationDuration));
	
	          // Do not allow overlapping animations
	          if (id === lastAnimationId && currentTime < animationDuration) {
	            lastDrawFrame = rAF(animation);
	          }
	        });
	      }
	
	      function renderFrame(value) {
	        path.attr('stroke-dashoffset', getDashLength(diameter, strokeWidth, value, dashLimit));
	        path.attr('transform','rotate(' + (rotation) + ' ' + diameter/2 + ' ' + diameter/2 + ')');
	      }
	    }
	
	    function animateIndeterminate() {
	      renderCircle(
	        startIndeterminate,
	        endIndeterminate,
	        $mdProgressCircular.easeFnIndeterminate,
	        $mdProgressCircular.durationIndeterminate,
	        iterationCount,
	        75
	      );
	
	      // The %4 technically isn't necessary, but it keeps the rotation
	      // under 360, instead of becoming a crazy large number.
	      iterationCount = ++iterationCount % 4;
	
	    }
	
	    function startIndeterminateAnimation() {
	      if (!interval) {
	        // Note that this interval isn't supposed to trigger a digest.
	        interval = $interval(
	          animateIndeterminate,
	          $mdProgressCircular.durationIndeterminate,
	          0,
	          false
	        );
	
	        animateIndeterminate();
	
	        element
	          .addClass(INDETERMINATE_CLASS)
	          .removeAttr('aria-valuenow');
	      }
	    }
	
	    function cleanupIndeterminateAnimation() {
	      if (interval) {
	        $interval.cancel(interval);
	        interval = null;
	        element.removeClass(INDETERMINATE_CLASS);
	      }
	    }
	  }
	
	  /**
	   * Returns SVG path data for progress circle
	   * Syntax spec: https://www.w3.org/TR/SVG/paths.html#PathDataEllipticalArcCommands
	   *
	   * @param {number} diameter Diameter of the container.
	   * @param {number} strokeWidth Stroke width to be used when drawing circle
	   * @param {boolean} indeterminate Use if progress circle will be used for indeterminate
	   *
	   * @returns {string} String representation of an SVG arc.
	   */
	  function getSvgArc(diameter, strokeWidth, indeterminate) {
	    var radius = diameter / 2;
	    var offset = strokeWidth / 2;
	    var start = radius + ',' + offset; // ie: (25, 2.5) or 12 o'clock
	    var end = offset + ',' + radius;   // ie: (2.5, 25) or  9 o'clock
	    var arcRadius = radius - offset;
	    return 'M' + start
	         + 'A' + arcRadius + ',' + arcRadius + ' 0 1 1 ' + end // 75% circle
	         + (indeterminate ? '' : 'A' + arcRadius + ',' + arcRadius + ' 0 0 1 ' + start); // loop to start
	  }
	
	  /**
	   * Return stroke length for progress circle
	   *
	   * @param {number} diameter Diameter of the container.
	   * @param {number} strokeWidth Stroke width to be used when drawing circle
	   * @param {number} value Percentage of circle (between 0 and 100)
	   * @param {number} limit Max percentage for circle
	   *
	   * @returns {number} Stroke length for progres circle
	   */
	  function getDashLength(diameter, strokeWidth, value, limit) {
	    return (diameter - strokeWidth) * $window.Math.PI * ( (3 * (limit || 100) / 100) - (value/100) );
	  }
	
	  /**
	   * Limits a value between 0 and 100.
	   */
	  function clamp(value) {
	    return $window.Math.max(0, $window.Math.min(value || 0, 100));
	  }
	
	  /**
	   * Determines the size of a progress circle, based on the provided
	   * value in the following formats: `X`, `Ypx`, `Z%`.
	   */
	  function getSize(value) {
	    var defaultValue = $mdProgressCircular.progressSize;
	
	    if (value) {
	      var parsed = parseFloat(value);
	
	      if (value.lastIndexOf('%') === value.length - 1) {
	        parsed = (parsed / 100) * defaultValue;
	      }
	
	      return parsed;
	    }
	
	    return defaultValue;
	  }
	
	  /**
	   * Determines the circle's stroke width, based on
	   * the provided diameter.
	   */
	  function getStroke(diameter) {
	    return $mdProgressCircular.strokeWidth / 100 * diameter;
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc service
	 * @name $mdProgressCircular
	 * @module material.components.progressCircular
	 *
	 * @description
	 * Allows the user to specify the default options for the `progressCircular` directive.
	 *
	 * @property {number} progressSize Diameter of the progress circle in pixels.
	 * @property {number} strokeWidth Width of the circle's stroke as a percentage of the circle's size.
	 * @property {number} duration Length of the circle animation in milliseconds.
	 * @property {function} easeFn Default easing animation function.
	 * @property {object} easingPresets Collection of pre-defined easing functions.
	 *
	 * @property {number} durationIndeterminate Duration of the indeterminate animation.
	 * @property {number} startIndeterminate Indeterminate animation start point.
	 * @property {number} endIndeterminate Indeterminate animation end point.
	 * @property {function} easeFnIndeterminate Easing function to be used when animating
	 * between the indeterminate values.
	 *
	 * @property {(function(object): object)} configure Used to modify the default options.
	 *
	 * @usage
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdProgressCircularProvider) {
	 *
	 *     // Example of changing the default progress options.
	 *     $mdProgressCircularProvider.configure({
	 *       progressSize: 100,
	 *       strokeWidth: 20,
	 *       duration: 800
	 *     });
	 * });
	 * </hljs>
	 *
	 */
	
	angular
	  .module('material.components.progressCircular')
	  .provider("$mdProgressCircular", MdProgressCircularProvider);
	
	function MdProgressCircularProvider() {
	  var progressConfig = {
	    progressSize: 50,
	    strokeWidth: 10,
	    duration: 100,
	    easeFn: linearEase,
	
	    durationIndeterminate: 1333,
	    startIndeterminate: 1,
	    endIndeterminate: 149,
	    easeFnIndeterminate: materialEase,
	
	    easingPresets: {
	      linearEase: linearEase,
	      materialEase: materialEase
	    }
	  };
	
	  return {
	    configure: function(options) {
	      progressConfig = angular.extend(progressConfig, options || {});
	      return progressConfig;
	    },
	    $get: function() { return progressConfig; }
	  };
	
	  function linearEase(t, b, c, d) {
	    return c * t / d + b;
	  }
	
	  function materialEase(t, b, c, d) {
	    // via http://www.timotheegroleau.com/Flash/experiments/easing_function_generator.htm
	    // with settings of [0, 0, 1, 1]
	    var ts = (t /= d) * t;
	    var tc = ts * t;
	    return b + c * (6 * tc * ts + -15 * ts * ts + 10 * tc);
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc directive
	 * @name mdTab
	 * @module material.components.tabs
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-tab>` is a nested directive used within `<md-tabs>` to specify a tab with a **label** and optional *view content*.
	 *
	 * If the `label` attribute is not specified, then an optional `<md-tab-label>` tag can be used to specify more
	 * complex tab header markup. If neither the **label** nor the **md-tab-label** are specified, then the nested
	 * markup of the `<md-tab>` is used as the tab header markup.
	 *
	 * Please note that if you use `<md-tab-label>`, your content **MUST** be wrapped in the `<md-tab-body>` tag.  This
	 * is to define a clear separation between the tab content and the tab label.
	 *
	 * This container is used by the TabsController to show/hide the active tab's content view. This synchronization is
	 * automatically managed by the internal TabsController whenever the tab selection changes. Selection changes can
	 * be initiated via data binding changes, programmatic invocation, or user gestures.
	 *
	 * @param {string=} label Optional attribute to specify a simple string as the tab label
	 * @param {boolean=} ng-disabled If present and expression evaluates to truthy, disabled tab selection.
	 * @param {expression=} md-on-deselect Expression to be evaluated after the tab has been de-selected.
	 * @param {expression=} md-on-select Expression to be evaluated after the tab has been selected.
	 * @param {boolean=} md-active When true, sets the active tab.  Note: There can only be one active tab at a time.
	 *
	 *
	 * @usage
	 *
	 * <hljs lang="html">
	 * <md-tab label="" ng-disabled md-on-select="" md-on-deselect="" >
	 *   <h3>My Tab content</h3>
	 * </md-tab>
	 *
	 * <md-tab >
	 *   <md-tab-label>
	 *     <h3>My Tab content</h3>
	 *   </md-tab-label>
	 *   <md-tab-body>
	 *     <p>
	 *       Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium,
	 *       totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae
	 *       dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit,
	 *       sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.
	 *     </p>
	 *   </md-tab-body>
	 * </md-tab>
	 * </hljs>
	 *
	 */
	angular
	    .module('material.components.tabs')
	    .directive('mdTab', MdTab);
	
	function MdTab () {
	  return {
	    require:  '^?mdTabs',
	    terminal: true,
	    compile:  function (element, attr) {
	      var label = firstChild(element, 'md-tab-label'),
	          body  = firstChild(element, 'md-tab-body');
	
	      if (label.length === 0) {
	        label = angular.element('<md-tab-label></md-tab-label>');
	        if (attr.label) label.text(attr.label);
	        else label.append(element.contents());
	
	        if (body.length === 0) {
	          var contents = element.contents().detach();
	          body         = angular.element('<md-tab-body></md-tab-body>');
	          body.append(contents);
	        }
	      }
	
	      element.append(label);
	      if (body.html()) element.append(body);
	
	      return postLink;
	    },
	    scope:    {
	      active:   '=?mdActive',
	      disabled: '=?ngDisabled',
	      select:   '&?mdOnSelect',
	      deselect: '&?mdOnDeselect'
	    }
	  };
	
	  function postLink (scope, element, attr, ctrl) {
	    if (!ctrl) return;
	    var index = ctrl.getTabElementIndex(element),
	        body  = firstChild(element, 'md-tab-body').remove(),
	        label = firstChild(element, 'md-tab-label').remove(),
	        data  = ctrl.insertTab({
	          scope:    scope,
	          parent:   scope.$parent,
	          index:    index,
	          element:  element,
	          template: body.html(),
	          label:    label.html()
	        }, index);
	
	    scope.select   = scope.select || angular.noop;
	    scope.deselect = scope.deselect || angular.noop;
	
	    scope.$watch('active', function (active) { if (active) ctrl.select(data.getIndex(), true); });
	    scope.$watch('disabled', function () { ctrl.refreshIndex(); });
	    scope.$watch(
	        function () {
	          return ctrl.getTabElementIndex(element);
	        },
	        function (newIndex) {
	          data.index = newIndex;
	          ctrl.updateTabOrder();
	        }
	    );
	    scope.$on('$destroy', function () { ctrl.removeTab(data); });
	  }
	
	  function firstChild (element, tagName) {
	    var children = element[0].children;
	    for (var i = 0, len = children.length; i < len; i++) {
	      var child = children[i];
	      if (child.tagName === tagName.toUpperCase()) return angular.element(child);
	    }
	    return angular.element();
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	angular
	    .module('material.components.tabs')
	    .directive('mdTabItem', MdTabItem);
	
	function MdTabItem () {
	  return {
	    require: '^?mdTabs',
	    link:    function link (scope, element, attr, ctrl) {
	      if (!ctrl) return;
	      ctrl.attachRipple(scope, element);
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	angular
	    .module('material.components.tabs')
	    .directive('mdTabLabel', MdTabLabel);
	
	function MdTabLabel () {
	  return { terminal: true };
	}
	
	
	})();
	(function(){
	"use strict";
	
	
	MdTabScroll.$inject = ["$parse"];angular.module('material.components.tabs')
	    .directive('mdTabScroll', MdTabScroll);
	
	function MdTabScroll ($parse) {
	  return {
	    restrict: 'A',
	    compile: function ($element, attr) {
	      var fn = $parse(attr.mdTabScroll, null, true);
	      return function ngEventHandler (scope, element) {
	        element.on('mousewheel', function (event) {
	          scope.$apply(function () { fn(scope, { $event: event }); });
	        });
	      };
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdTabsController.$inject = ["$scope", "$element", "$window", "$mdConstant", "$mdTabInkRipple", "$mdUtil", "$animateCss", "$attrs", "$compile", "$mdTheming", "$mdInteraction"];angular
	    .module('material.components.tabs')
	    .controller('MdTabsController', MdTabsController);
	
	/**
	 * @ngInject
	 */
	function MdTabsController ($scope, $element, $window, $mdConstant, $mdTabInkRipple, $mdUtil,
	                           $animateCss, $attrs, $compile, $mdTheming, $mdInteraction) {
	  // define private properties
	  var ctrl      = this,
	      locked    = false,
	      elements  = getElements(),
	      queue     = [],
	      destroyed = false,
	      loaded    = false;
	
	
	  // Define public methods
	  ctrl.$onInit            = $onInit;
	  ctrl.updatePagination   = $mdUtil.debounce(updatePagination, 100);
	  ctrl.redirectFocus      = redirectFocus;
	  ctrl.attachRipple       = attachRipple;
	  ctrl.insertTab          = insertTab;
	  ctrl.removeTab          = removeTab;
	  ctrl.select             = select;
	  ctrl.scroll             = scroll;
	  ctrl.nextPage           = nextPage;
	  ctrl.previousPage       = previousPage;
	  ctrl.keydown            = keydown;
	  ctrl.canPageForward     = canPageForward;
	  ctrl.canPageBack        = canPageBack;
	  ctrl.refreshIndex       = refreshIndex;
	  ctrl.incrementIndex     = incrementIndex;
	  ctrl.getTabElementIndex = getTabElementIndex;
	  ctrl.updateInkBarStyles = $mdUtil.debounce(updateInkBarStyles, 100);
	  ctrl.updateTabOrder     = $mdUtil.debounce(updateTabOrder, 100);
	  ctrl.getFocusedTabId    = getFocusedTabId;
	
	  // For AngularJS 1.4 and older, where there are no lifecycle hooks but bindings are pre-assigned,
	  // manually call the $onInit hook.
	  if (angular.version.major === 1 && angular.version.minor <= 4) {
	    this.$onInit();
	  }
	
	  /**
	   * AngularJS Lifecycle hook for newer AngularJS versions.
	   * Bindings are not guaranteed to have been assigned in the controller, but they are in the $onInit hook.
	   */
	  function $onInit() {
	    // Define one-way bindings
	    defineOneWayBinding('stretchTabs', handleStretchTabs);
	
	    // Define public properties with change handlers
	    defineProperty('focusIndex', handleFocusIndexChange, ctrl.selectedIndex || 0);
	    defineProperty('offsetLeft', handleOffsetChange, 0);
	    defineProperty('hasContent', handleHasContent, false);
	    defineProperty('maxTabWidth', handleMaxTabWidth, getMaxTabWidth());
	    defineProperty('shouldPaginate', handleShouldPaginate, false);
	
	    // Define boolean attributes
	    defineBooleanAttribute('noInkBar', handleInkBar);
	    defineBooleanAttribute('dynamicHeight', handleDynamicHeight);
	    defineBooleanAttribute('noPagination');
	    defineBooleanAttribute('swipeContent');
	    defineBooleanAttribute('noDisconnect');
	    defineBooleanAttribute('autoselect');
	    defineBooleanAttribute('noSelectClick');
	    defineBooleanAttribute('centerTabs', handleCenterTabs, false);
	    defineBooleanAttribute('enableDisconnect');
	
	    // Define public properties
	    ctrl.scope             = $scope;
	    ctrl.parent            = $scope.$parent;
	    ctrl.tabs              = [];
	    ctrl.lastSelectedIndex = null;
	    ctrl.hasFocus          = false;
	    ctrl.styleTabItemFocus = false;
	    ctrl.shouldCenterTabs  = shouldCenterTabs();
	    ctrl.tabContentPrefix  = 'tab-content-';
	
	    // Setup the tabs controller after all bindings are available.
	    setupTabsController();
	  }
	
	  /**
	   * Perform setup for the controller, setup events and watcher(s)
	   */
	  function setupTabsController () {
	    ctrl.selectedIndex = ctrl.selectedIndex || 0;
	    compileTemplate();
	    configureWatchers();
	    bindEvents();
	    $mdTheming($element);
	    $mdUtil.nextTick(function () {
	      // Note that the element references need to be updated, because certain "browsers"
	      // (IE/Edge) lose them and start throwing "Invalid calling object" errors, when we
	      // compile the element contents down in `compileElement`.
	      elements = getElements();
	      updateHeightFromContent();
	      adjustOffset();
	      updateInkBarStyles();
	      ctrl.tabs[ ctrl.selectedIndex ] && ctrl.tabs[ ctrl.selectedIndex ].scope.select();
	      loaded = true;
	      updatePagination();
	    });
	  }
	
	  /**
	   * Compiles the template provided by the user.  This is passed as an attribute from the tabs
	   * directive's template function.
	   */
	  function compileTemplate () {
	    var template = $attrs.$mdTabsTemplate,
	        element  = angular.element($element[0].querySelector('md-tab-data'));
	
	    element.html(template);
	    $compile(element.contents())(ctrl.parent);
	    delete $attrs.$mdTabsTemplate;
	  }
	
	  /**
	   * Binds events used by the tabs component.
	   */
	  function bindEvents () {
	    angular.element($window).on('resize', handleWindowResize);
	    $scope.$on('$destroy', cleanup);
	  }
	
	  /**
	   * Configure watcher(s) used by Tabs
	   */
	  function configureWatchers () {
	    $scope.$watch('$mdTabsCtrl.selectedIndex', handleSelectedIndexChange);
	  }
	
	  /**
	   * Creates a one-way binding manually rather than relying on AngularJS's isolated scope
	   * @param key
	   * @param handler
	   */
	  function defineOneWayBinding (key, handler) {
	    var attr = $attrs.$normalize('md-' + key);
	    if (handler) defineProperty(key, handler);
	    $attrs.$observe(attr, function (newValue) { ctrl[ key ] = newValue; });
	  }
	
	  /**
	   * Defines boolean attributes with default value set to true.  (ie. md-stretch-tabs with no value
	   * will be treated as being truthy)
	   * @param key
	   * @param handler
	   */
	  function defineBooleanAttribute (key, handler) {
	    var attr = $attrs.$normalize('md-' + key);
	    if (handler) defineProperty(key, handler);
	    if ($attrs.hasOwnProperty(attr)) updateValue($attrs[attr]);
	    $attrs.$observe(attr, updateValue);
	    function updateValue (newValue) {
	      ctrl[ key ] = newValue !== 'false';
	    }
	  }
	
	  /**
	   * Remove any events defined by this controller
	   */
	  function cleanup () {
	    destroyed = true;
	    angular.element($window).off('resize', handleWindowResize);
	  }
	
	  // Change handlers
	
	  /**
	   * Toggles stretch tabs class and updates inkbar when tab stretching changes
	   * @param stretchTabs
	   */
	  function handleStretchTabs (stretchTabs) {
	    var elements = getElements();
	    angular.element(elements.wrapper).toggleClass('md-stretch-tabs', shouldStretchTabs());
	    updateInkBarStyles();
	  }
	
	  function handleCenterTabs (newValue) {
	    ctrl.shouldCenterTabs = shouldCenterTabs();
	  }
	
	  function handleMaxTabWidth (newWidth, oldWidth) {
	    if (newWidth !== oldWidth) {
	      var elements = getElements();
	
	      angular.forEach(elements.tabs, function(tab) {
	        tab.style.maxWidth = newWidth + 'px';
	      });
	      $mdUtil.nextTick(ctrl.updateInkBarStyles);
	    }
	  }
	
	  function handleShouldPaginate (newValue, oldValue) {
	    if (newValue !== oldValue) {
	      ctrl.maxTabWidth      = getMaxTabWidth();
	      ctrl.shouldCenterTabs = shouldCenterTabs();
	      $mdUtil.nextTick(function () {
	        ctrl.maxTabWidth = getMaxTabWidth();
	        adjustOffset(ctrl.selectedIndex);
	      });
	    }
	  }
	
	  /**
	   * Add/remove the `md-no-tab-content` class depending on `ctrl.hasContent`
	   * @param hasContent
	   */
	  function handleHasContent (hasContent) {
	    $element[ hasContent ? 'removeClass' : 'addClass' ]('md-no-tab-content');
	  }
	
	  /**
	   * Apply ctrl.offsetLeft to the paging element when it changes
	   * @param left
	   */
	  function handleOffsetChange (left) {
	    var elements = getElements();
	    var newValue = ctrl.shouldCenterTabs ? '' : '-' + left + 'px';
	
	    angular.element(elements.paging).css($mdConstant.CSS.TRANSFORM, 'translate3d(' + newValue + ', 0, 0)');
	    $scope.$broadcast('$mdTabsPaginationChanged');
	  }
	
	  /**
	   * Update the UI whenever `ctrl.focusIndex` is updated
	   * @param newIndex
	   * @param oldIndex
	   */
	  function handleFocusIndexChange (newIndex, oldIndex) {
	    if (newIndex === oldIndex) return;
	    if (!getElements().tabs[ newIndex ]) return;
	    adjustOffset();
	    redirectFocus();
	  }
	
	  /**
	   * Update the UI whenever the selected index changes. Calls user-defined select/deselect methods.
	   * @param newValue
	   * @param oldValue
	   */
	  function handleSelectedIndexChange (newValue, oldValue) {
	    if (newValue === oldValue) return;
	
	    ctrl.selectedIndex     = getNearestSafeIndex(newValue);
	    ctrl.lastSelectedIndex = oldValue;
	    ctrl.updateInkBarStyles();
	    updateHeightFromContent();
	    adjustOffset(newValue);
	    $scope.$broadcast('$mdTabsChanged');
	    ctrl.tabs[ oldValue ] && ctrl.tabs[ oldValue ].scope.deselect();
	    ctrl.tabs[ newValue ] && ctrl.tabs[ newValue ].scope.select();
	  }
	
	  function getTabElementIndex(tabEl){
	    var tabs = $element[0].getElementsByTagName('md-tab');
	    return Array.prototype.indexOf.call(tabs, tabEl[0]);
	  }
	
	  /**
	   * Queues up a call to `handleWindowResize` when a resize occurs while the tabs component is
	   * hidden.
	   */
	  function handleResizeWhenVisible () {
	    // if there is already a watcher waiting for resize, do nothing
	    if (handleResizeWhenVisible.watcher) return;
	    // otherwise, we will abuse the $watch function to check for visible
	    handleResizeWhenVisible.watcher = $scope.$watch(function () {
	      // since we are checking for DOM size, we use $mdUtil.nextTick() to wait for after the DOM updates
	      $mdUtil.nextTick(function () {
	        // if the watcher has already run (ie. multiple digests in one cycle), do nothing
	        if (!handleResizeWhenVisible.watcher) return;
	
	        if ($element.prop('offsetParent')) {
	          handleResizeWhenVisible.watcher();
	          handleResizeWhenVisible.watcher = null;
	
	          handleWindowResize();
	        }
	      }, false);
	    });
	  }
	
	  // Event handlers / actions
	
	  /**
	   * Handle user keyboard interactions
	   * @param event
	   */
	  function keydown (event) {
	    switch (event.keyCode) {
	      case $mdConstant.KEY_CODE.LEFT_ARROW:
	        event.preventDefault();
	        incrementIndex(-1, true);
	        break;
	      case $mdConstant.KEY_CODE.RIGHT_ARROW:
	        event.preventDefault();
	        incrementIndex(1, true);
	        break;
	      case $mdConstant.KEY_CODE.SPACE:
	      case $mdConstant.KEY_CODE.ENTER:
	        event.preventDefault();
	        if (!locked) select(ctrl.focusIndex);
	        break;
	    }
	  }
	
	  /**
	   * Update the selected index. Triggers a click event on the original `md-tab` element in order
	   * to fire user-added click events if canSkipClick or `md-no-select-click` are false.
	   * @param index
	   * @param canSkipClick Optionally allow not firing the click event if `md-no-select-click` is also true.
	   */
	  function select (index, canSkipClick) {
	    if (!locked) ctrl.focusIndex = ctrl.selectedIndex = index;
	    // skip the click event if noSelectClick is enabled
	    if (canSkipClick && ctrl.noSelectClick) return;
	    // nextTick is required to prevent errors in user-defined click events
	    $mdUtil.nextTick(function () {
	      ctrl.tabs[ index ].element.triggerHandler('click');
	    }, false);
	  }
	
	  /**
	   * When pagination is on, this makes sure the selected index is in view.
	   * @param event
	   */
	  function scroll (event) {
	    if (!ctrl.shouldPaginate) return;
	    event.preventDefault();
	    ctrl.offsetLeft = fixOffset(ctrl.offsetLeft - event.wheelDelta);
	  }
	
	  /**
	   * Slides the tabs over approximately one page forward.
	   */
	  function nextPage () {
	    var elements = getElements();
	    var viewportWidth = elements.canvas.clientWidth,
	        totalWidth    = viewportWidth + ctrl.offsetLeft,
	        i, tab;
	    for (i = 0; i < elements.tabs.length; i++) {
	      tab = elements.tabs[ i ];
	      if (tab.offsetLeft + tab.offsetWidth > totalWidth) break;
	    }
	
	    if (viewportWidth > tab.offsetWidth) {
	      //Canvas width *greater* than tab width: usual positioning
	      ctrl.offsetLeft = fixOffset(tab.offsetLeft);
	    } else {
	      /**
	       * Canvas width *smaller* than tab width: positioning at the *end* of current tab to let
	       * pagination "for loop" to proceed correctly on next tab when nextPage() is called again
	       */
	      ctrl.offsetLeft = fixOffset(tab.offsetLeft + (tab.offsetWidth - viewportWidth + 1));
	    }
	  }
	
	  /**
	   * Slides the tabs over approximately one page backward.
	   */
	  function previousPage () {
	    var i, tab, elements = getElements();
	
	    for (i = 0; i < elements.tabs.length; i++) {
	      tab = elements.tabs[ i ];
	      if (tab.offsetLeft + tab.offsetWidth >= ctrl.offsetLeft) break;
	    }
	
	    if (elements.canvas.clientWidth > tab.offsetWidth) {
	      //Canvas width *greater* than tab width: usual positioning
	      ctrl.offsetLeft = fixOffset(tab.offsetLeft + tab.offsetWidth - elements.canvas.clientWidth);
	    } else {
	      /**
	       * Canvas width *smaller* than tab width: positioning at the *beginning* of current tab to let
	       * pagination "for loop" to break correctly on previous tab when previousPage() is called again
	       */
	      ctrl.offsetLeft = fixOffset(tab.offsetLeft);
	    }
	  }
	
	  /**
	   * Update size calculations when the window is resized.
	   */
	  function handleWindowResize () {
	    ctrl.lastSelectedIndex = ctrl.selectedIndex;
	    ctrl.offsetLeft        = fixOffset(ctrl.offsetLeft);
	    $mdUtil.nextTick(function () {
	      ctrl.updateInkBarStyles();
	      updatePagination();
	    });
	  }
	
	  function handleInkBar (hide) {
	    angular.element(getElements().inkBar).toggleClass('ng-hide', hide);
	  }
	
	  /**
	   * Toggle dynamic height class when value changes
	   * @param value
	   */
	  function handleDynamicHeight (value) {
	    $element.toggleClass('md-dynamic-height', value);
	  }
	
	  /**
	   * Remove a tab from the data and select the nearest valid tab.
	   * @param tabData
	   */
	  function removeTab (tabData) {
	    if (destroyed) return;
	    var selectedIndex = ctrl.selectedIndex,
	        tab           = ctrl.tabs.splice(tabData.getIndex(), 1)[ 0 ];
	    refreshIndex();
	    // when removing a tab, if the selected index did not change, we have to manually trigger the
	    //   tab select/deselect events
	    if (ctrl.selectedIndex === selectedIndex) {
	      tab.scope.deselect();
	      ctrl.tabs[ ctrl.selectedIndex ] && ctrl.tabs[ ctrl.selectedIndex ].scope.select();
	    }
	    $mdUtil.nextTick(function () {
	      updatePagination();
	      ctrl.offsetLeft = fixOffset(ctrl.offsetLeft);
	    });
	  }
	
	  /**
	   * Create an entry in the tabs array for a new tab at the specified index.
	   * @param tabData
	   * @param index
	   * @returns {*}
	   */
	  function insertTab (tabData, index) {
	    var hasLoaded = loaded;
	    var proto     = {
	          getIndex:     function () { return ctrl.tabs.indexOf(tab); },
	          isActive:     function () { return this.getIndex() === ctrl.selectedIndex; },
	          isLeft:       function () { return this.getIndex() < ctrl.selectedIndex; },
	          isRight:      function () { return this.getIndex() > ctrl.selectedIndex; },
	          shouldRender: function () { return !ctrl.noDisconnect || this.isActive(); },
	          hasFocus:     function () {
	            return ctrl.styleTabItemFocus
	                && ctrl.hasFocus && this.getIndex() === ctrl.focusIndex;
	          },
	          id:           $mdUtil.nextUid(),
	          hasContent: !!(tabData.template && tabData.template.trim())
	        },
	        tab       = angular.extend(proto, tabData);
	    if (angular.isDefined(index)) {
	      ctrl.tabs.splice(index, 0, tab);
	    } else {
	      ctrl.tabs.push(tab);
	    }
	
	    processQueue();
	    updateHasContent();
	    $mdUtil.nextTick(function () {
	      updatePagination();
	      setAriaControls(tab);
	
	      // if autoselect is enabled, select the newly added tab
	      if (hasLoaded && ctrl.autoselect) $mdUtil.nextTick(function () {
	        $mdUtil.nextTick(function () { select(ctrl.tabs.indexOf(tab)); });
	      });
	    });
	    return tab;
	  }
	
	  // Getter methods
	
	  /**
	   * Gathers references to all of the DOM elements used by this controller.
	   * @returns {{}}
	   */
	  function getElements () {
	    var elements = {};
	    var node = $element[0];
	
	    // gather tab bar elements
	    elements.wrapper = node.querySelector('md-tabs-wrapper');
	    elements.canvas  = elements.wrapper.querySelector('md-tabs-canvas');
	    elements.paging  = elements.canvas.querySelector('md-pagination-wrapper');
	    elements.inkBar  = elements.paging.querySelector('md-ink-bar');
	
	    elements.contents = node.querySelectorAll('md-tabs-content-wrapper > md-tab-content');
	    elements.tabs    = elements.paging.querySelectorAll('md-tab-item');
	    elements.dummies = elements.canvas.querySelectorAll('md-dummy-tab');
	
	    return elements;
	  }
	
	  /**
	   * Determines whether or not the left pagination arrow should be enabled.
	   * @returns {boolean}
	   */
	  function canPageBack () {
	    return ctrl.offsetLeft > 0;
	  }
	
	  /**
	   * Determines whether or not the right pagination arrow should be enabled.
	   * @returns {*|boolean}
	   */
	  function canPageForward () {
	    var elements = getElements();
	    var lastTab = elements.tabs[ elements.tabs.length - 1 ];
	    return lastTab && lastTab.offsetLeft + lastTab.offsetWidth > elements.canvas.clientWidth +
	        ctrl.offsetLeft;
	  }
	
	  /**
	   * Returns currently focused tab item's element ID
	   */
	  function getFocusedTabId() {
	    var focusedTab = ctrl.tabs[ctrl.focusIndex];
	    if (!focusedTab || !focusedTab.id) {
	      return null;
	    }
	    return 'tab-item-' + focusedTab.id;
	  }
	
	  /**
	   * Determines if the UI should stretch the tabs to fill the available space.
	   * @returns {*}
	   */
	  function shouldStretchTabs () {
	    switch (ctrl.stretchTabs) {
	      case 'always':
	        return true;
	      case 'never':
	        return false;
	      default:
	        return !ctrl.shouldPaginate
	            && $window.matchMedia('(max-width: 600px)').matches;
	    }
	  }
	
	  /**
	   * Determines if the tabs should appear centered.
	   * @returns {string|boolean}
	   */
	  function shouldCenterTabs () {
	    return ctrl.centerTabs && !ctrl.shouldPaginate;
	  }
	
	  /**
	   * Determines if pagination is necessary to display the tabs within the available space.
	   * @returns {boolean}
	   */
	  function shouldPaginate () {
	    if (ctrl.noPagination || !loaded) return false;
	    var canvasWidth = $element.prop('clientWidth');
	
	    angular.forEach(getElements().dummies, function (tab) {
	      canvasWidth -= tab.offsetWidth;
	    });
	
	    return canvasWidth < 0;
	  }
	
	  /**
	   * Finds the nearest tab index that is available.  This is primarily used for when the active
	   * tab is removed.
	   * @param newIndex
	   * @returns {*}
	   */
	  function getNearestSafeIndex (newIndex) {
	    if (newIndex === -1) return -1;
	    var maxOffset = Math.max(ctrl.tabs.length - newIndex, newIndex),
	        i, tab;
	    for (i = 0; i <= maxOffset; i++) {
	      tab = ctrl.tabs[ newIndex + i ];
	      if (tab && (tab.scope.disabled !== true)) return tab.getIndex();
	      tab = ctrl.tabs[ newIndex - i ];
	      if (tab && (tab.scope.disabled !== true)) return tab.getIndex();
	    }
	    return newIndex;
	  }
	
	  // Utility methods
	
	  /**
	   * Defines a property using a getter and setter in order to trigger a change handler without
	   * using `$watch` to observe changes.
	   * @param key
	   * @param handler
	   * @param value
	   */
	  function defineProperty (key, handler, value) {
	    Object.defineProperty(ctrl, key, {
	      get: function () { return value; },
	      set: function (newValue) {
	        var oldValue = value;
	        value        = newValue;
	        handler && handler(newValue, oldValue);
	      }
	    });
	  }
	
	  /**
	   * Updates whether or not pagination should be displayed.
	   */
	  function updatePagination () {
	    ctrl.maxTabWidth = getMaxTabWidth();
	    ctrl.shouldPaginate = shouldPaginate();
	  }
	
	  /**
	   * Calculates the width of the pagination wrapper by summing the widths of the dummy tabs.
	   * @returns {number}
	   */
	  function calcPagingWidth () {
	    return calcTabsWidth(getElements().dummies);
	  }
	
	  function calcTabsWidth(tabs) {
	    var width = 0;
	
	    angular.forEach(tabs, function (tab) {
	      //-- Uses the larger value between `getBoundingClientRect().width` and `offsetWidth`.  This
	      //   prevents `offsetWidth` value from being rounded down and causing wrapping issues, but
	      //   also handles scenarios where `getBoundingClientRect()` is inaccurate (ie. tabs inside
	      //   of a dialog)
	      width += Math.max(tab.offsetWidth, tab.getBoundingClientRect().width);
	    });
	
	    return Math.ceil(width);
	  }
	
	  function getMaxTabWidth () {
	    return $element.prop('clientWidth');
	  }
	
	  /**
	   * Re-orders the tabs and updates the selected and focus indexes to their new positions.
	   * This is triggered by `tabDirective.js` when the user's tabs have been re-ordered.
	   */
	  function updateTabOrder () {
	    var selectedItem   = ctrl.tabs[ ctrl.selectedIndex ],
	        focusItem      = ctrl.tabs[ ctrl.focusIndex ];
	    ctrl.tabs          = ctrl.tabs.sort(function (a, b) {
	      return a.index - b.index;
	    });
	    ctrl.selectedIndex = ctrl.tabs.indexOf(selectedItem);
	    ctrl.focusIndex    = ctrl.tabs.indexOf(focusItem);
	  }
	
	  /**
	   * This moves the selected or focus index left or right.  This is used by the keydown handler.
	   * @param inc
	   */
	  function incrementIndex (inc, focus) {
	    var newIndex,
	        key   = focus ? 'focusIndex' : 'selectedIndex',
	        index = ctrl[ key ];
	    for (newIndex = index + inc;
	         ctrl.tabs[ newIndex ] && ctrl.tabs[ newIndex ].scope.disabled;
	         newIndex += inc) {}
	    if (ctrl.tabs[ newIndex ]) {
	      ctrl[ key ] = newIndex;
	    }
	  }
	
	  /**
	   * This is used to forward focus to dummy elements.  This method is necessary to avoid animation
	   * issues when attempting to focus an item that is out of view.
	   */
	  function redirectFocus () {
	    ctrl.styleTabItemFocus = ($mdInteraction.getLastInteractionType() === 'keyboard');
	    getElements().dummies[ ctrl.focusIndex ].focus();
	  }
	
	  /**
	   * Forces the pagination to move the focused tab into view.
	   */
	  function adjustOffset (index) {
	    var elements = getElements();
	
	    if (!angular.isNumber(index)) index = ctrl.focusIndex;
	    if (!elements.tabs[ index ]) return;
	    if (ctrl.shouldCenterTabs) return;
	    var tab         = elements.tabs[ index ],
	        left        = tab.offsetLeft,
	        right       = tab.offsetWidth + left;
	    ctrl.offsetLeft = Math.max(ctrl.offsetLeft, fixOffset(right - elements.canvas.clientWidth + 32 * 2));
	    ctrl.offsetLeft = Math.min(ctrl.offsetLeft, fixOffset(left));
	  }
	
	  /**
	   * Iterates through all queued functions and clears the queue.  This is used for functions that
	   * are called before the UI is ready, such as size calculations.
	   */
	  function processQueue () {
	    queue.forEach(function (func) { $mdUtil.nextTick(func); });
	    queue = [];
	  }
	
	  /**
	   * Determines if the tab content area is needed.
	   */
	  function updateHasContent () {
	    var hasContent  = false;
	
	    for (var i = 0; i < ctrl.tabs.length; i++) {
	      if (ctrl.tabs[i].hasContent) {
	        hasContent = true;
	        break;
	      }
	    }
	
	    ctrl.hasContent = hasContent;
	  }
	
	  /**
	   * Moves the indexes to their nearest valid values.
	   */
	  function refreshIndex () {
	    ctrl.selectedIndex = getNearestSafeIndex(ctrl.selectedIndex);
	    ctrl.focusIndex    = getNearestSafeIndex(ctrl.focusIndex);
	  }
	
	  /**
	   * Calculates the content height of the current tab.
	   * @returns {*}
	   */
	  function updateHeightFromContent () {
	    if (!ctrl.dynamicHeight) return $element.css('height', '');
	    if (!ctrl.tabs.length) return queue.push(updateHeightFromContent);
	
	    var elements = getElements();
	
	    var tabContent    = elements.contents[ ctrl.selectedIndex ],
	        contentHeight = tabContent ? tabContent.offsetHeight : 0,
	        tabsHeight    = elements.wrapper.offsetHeight,
	        newHeight     = contentHeight + tabsHeight,
	        currentHeight = $element.prop('clientHeight');
	
	    if (currentHeight === newHeight) return;
	
	    // Adjusts calculations for when the buttons are bottom-aligned since this relies on absolute
	    // positioning.  This should probably be cleaned up if a cleaner solution is possible.
	    if ($element.attr('md-align-tabs') === 'bottom') {
	      currentHeight -= tabsHeight;
	      newHeight -= tabsHeight;
	      // Need to include bottom border in these calculations
	      if ($element.attr('md-border-bottom') !== undefined) ++currentHeight;
	    }
	
	    // Lock during animation so the user can't change tabs
	    locked = true;
	
	    var fromHeight = { height: currentHeight + 'px' },
	        toHeight = { height: newHeight + 'px' };
	
	    // Set the height to the current, specific pixel height to fix a bug on iOS where the height
	    // first animates to 0, then back to the proper height causing a visual glitch
	    $element.css(fromHeight);
	
	    // Animate the height from the old to the new
	    $animateCss($element, {
	      from: fromHeight,
	      to: toHeight,
	      easing: 'cubic-bezier(0.35, 0, 0.25, 1)',
	      duration: 0.5
	    }).start().done(function () {
	      // Then (to fix the same iOS issue as above), disable transitions and remove the specific
	      // pixel height so the height can size with browser width/content changes, etc.
	      $element.css({
	        transition: 'none',
	        height: ''
	      });
	
	      // In the next tick, re-allow transitions (if we do it all at once, $element.css is "smart"
	      // enough to batch it for us instead of doing it immediately, which undoes the original
	      // transition: none)
	      $mdUtil.nextTick(function() {
	        $element.css('transition', '');
	      });
	
	      // And unlock so tab changes can occur
	      locked = false;
	    });
	  }
	
	  /**
	   * Repositions the ink bar to the selected tab.
	   * @returns {*}
	   */
	  function updateInkBarStyles () {
	    var elements = getElements();
	
	    if (!elements.tabs[ ctrl.selectedIndex ]) {
	      angular.element(elements.inkBar).css({ left: 'auto', right: 'auto' });
	      return;
	    }
	
	    if (!ctrl.tabs.length) return queue.push(ctrl.updateInkBarStyles);
	    // if the element is not visible, we will not be able to calculate sizes until it is
	    // we should treat that as a resize event rather than just updating the ink bar
	    if (!$element.prop('offsetParent')) return handleResizeWhenVisible();
	
	    var index      = ctrl.selectedIndex,
	        totalWidth = elements.paging.offsetWidth,
	        tab        = elements.tabs[ index ],
	        left       = tab.offsetLeft,
	        right      = totalWidth - left - tab.offsetWidth;
	
	    if (ctrl.shouldCenterTabs) {
	      // We need to use the same calculate process as in the pagination wrapper, to avoid rounding deviations.
	      var tabWidth = calcTabsWidth(elements.tabs);
	
	      if (totalWidth > tabWidth) {
	        $mdUtil.nextTick(updateInkBarStyles, false);
	      }
	    }
	    updateInkBarClassName();
	    angular.element(elements.inkBar).css({ left: left + 'px', right: right + 'px' });
	  }
	
	  /**
	   * Adds left/right classes so that the ink bar will animate properly.
	   */
	  function updateInkBarClassName () {
	    var elements = getElements();
	    var newIndex = ctrl.selectedIndex,
	        oldIndex = ctrl.lastSelectedIndex,
	        ink      = angular.element(elements.inkBar);
	    if (!angular.isNumber(oldIndex)) return;
	    ink
	        .toggleClass('md-left', newIndex < oldIndex)
	        .toggleClass('md-right', newIndex > oldIndex);
	  }
	
	  /**
	   * Takes an offset value and makes sure that it is within the min/max allowed values.
	   * @param value
	   * @returns {*}
	   */
	  function fixOffset (value) {
	    var elements = getElements();
	
	    if (!elements.tabs.length || !ctrl.shouldPaginate) return 0;
	    var lastTab    = elements.tabs[ elements.tabs.length - 1 ],
	        totalWidth = lastTab.offsetLeft + lastTab.offsetWidth;
	    value          = Math.max(0, value);
	    value          = Math.min(totalWidth - elements.canvas.clientWidth, value);
	    return value;
	  }
	
	  /**
	   * Attaches a ripple to the tab item element.
	   * @param scope
	   * @param element
	   */
	  function attachRipple (scope, element) {
	    var elements = getElements();
	    var options = { colorElement: angular.element(elements.inkBar) };
	    $mdTabInkRipple.attach(scope, element, options);
	  }
	
	  /**
	   * Sets the `aria-controls` attribute to the elements that
	   * correspond to the passed-in tab.
	   * @param tab
	   */
	  function setAriaControls (tab) {
	    if (tab.hasContent) {
	      var nodes = $element[0].querySelectorAll('[md-tab-id="' + tab.id + '"]');
	      angular.element(nodes).attr('aria-controls', ctrl.tabContentPrefix + tab.id);
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc directive
	 * @name mdTabs
	 * @module material.components.tabs
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-tabs>` directive serves as the container for 1..n `<md-tab>` child directives to
	 * produces a Tabs components. In turn, the nested `<md-tab>` directive is used to specify a tab
	 * label for the **header button** and a [optional] tab view content that will be associated with
	 * each tab button.
	 *
	 * Below is the markup for its simplest usage:
	 *
	 *  <hljs lang="html">
	 *  <md-tabs>
	 *    <md-tab label="Tab #1"></md-tab>
	 *    <md-tab label="Tab #2"></md-tab>
	 *    <md-tab label="Tab #3"></md-tab>
	 *  </md-tabs>
	 *  </hljs>
	 *
	 * Tabs supports three (3) usage scenarios:
	 *
	 *  1. Tabs (buttons only)
	 *  2. Tabs with internal view content
	 *  3. Tabs with external view content
	 *
	 * **Tab-only** support is useful when tab buttons are used for custom navigation regardless of any
	 * other components, content, or views.
	 *
	 * <i><b>Note:</b> If you are using the Tabs component for page-level navigation, please take a look
	 * at the <a ng-href="./api/directive/mdNavBar">NavBar component</a> instead as it can handle this
	 * case a bit more natively.</i>
	 *
	 * **Tabs with internal views** are the traditional usages where each tab has associated view
	 * content and the view switching is managed internally by the Tabs component.
	 *
	 * **Tabs with external view content** is often useful when content associated with each tab is
	 * independently managed and data-binding notifications announce tab selection changes.
	 *
	 * Additional features also include:
	 *
	 * *  Content can include any markup.
	 * *  If a tab is disabled while active/selected, then the next tab will be auto-selected.
	 *
	 * ### Explanation of tab stretching
	 *
	 * Initially, tabs will have an inherent size.  This size will either be defined by how much space is needed to accommodate their text or set by the user through CSS.  Calculations will be based on this size.
	 *
	 * On mobile devices, tabs will be expanded to fill the available horizontal space.  When this happens, all tabs will become the same size.
	 *
	 * On desktops, by default, stretching will never occur.
	 *
	 * This default behavior can be overridden through the `md-stretch-tabs` attribute.  Here is a table showing when stretching will occur:
	 *
	 * `md-stretch-tabs` | mobile    | desktop
	 * ------------------|-----------|--------
	 * `auto`            | stretched | ---
	 * `always`          | stretched | stretched
	 * `never`           | ---       | ---
	 *
	 * @param {integer=} md-selected Index of the active/selected tab
	 * @param {boolean=} md-no-ink If present, disables ink ripple effects.
	 * @param {boolean=} md-no-ink-bar If present, disables the selection ink bar.
	 * @param {string=}  md-align-tabs Attribute to indicate position of tab buttons: `bottom` or `top`; default is `top`
	 * @param {string=} md-stretch-tabs Attribute to indicate whether or not to stretch tabs: `auto`, `always`, or `never`; default is `auto`
	 * @param {boolean=} md-dynamic-height When enabled, the tab wrapper will resize based on the contents of the selected tab
	 * @param {boolean=} md-border-bottom If present, shows a solid `1px` border between the tabs and their content
	 * @param {boolean=} md-center-tabs When enabled, tabs will be centered provided there is no need for pagination
	 * @param {boolean=} md-no-pagination When enabled, pagination will remain off
	 * @param {boolean=} md-swipe-content When enabled, swipe gestures will be enabled for the content area to jump between tabs
	 * @param {boolean=} md-enable-disconnect When enabled, scopes will be disconnected for tabs that are not being displayed.  This provides a performance boost, but may also cause unexpected issues and is not recommended for most users.
	 * @param {boolean=} md-autoselect When present, any tabs added after the initial load will be automatically selected
	 * @param {boolean=} md-no-select-click When enabled, click events will not be fired when selecting tabs
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-tabs md-selected="selectedIndex" >
	 *   <img ng-src="img/angular.png" class="centered">
	 *   <md-tab
	 *       ng-repeat="tab in tabs | orderBy:predicate:reversed"
	 *       md-on-select="onTabSelected(tab)"
	 *       md-on-deselect="announceDeselected(tab)"
	 *       ng-disabled="tab.disabled">
	 *     <md-tab-label>
	 *       {{tab.title}}
	 *       <img src="img/removeTab.png" ng-click="removeTab(tab)" class="delete">
	 *     </md-tab-label>
	 *     <md-tab-body>
	 *       {{tab.content}}
	 *     </md-tab-body>
	 *   </md-tab>
	 * </md-tabs>
	 * </hljs>
	 *
	 */
	MdTabs.$inject = ["$$mdSvgRegistry"];
	angular
	    .module('material.components.tabs')
	    .directive('mdTabs', MdTabs);
	
	function MdTabs ($$mdSvgRegistry) {
	  return {
	    scope:            {
	      selectedIndex: '=?mdSelected'
	    },
	    template:         function (element, attr) {
	      attr.$mdTabsTemplate = element.html();
	      return '' +
	        '<md-tabs-wrapper> ' +
	          '<md-tab-data></md-tab-data> ' +
	          '<md-prev-button ' +
	              'tabindex="-1" ' +
	              'role="button" ' +
	              'aria-label="Previous Page" ' +
	              'aria-disabled="{{!$mdTabsCtrl.canPageBack()}}" ' +
	              'ng-class="{ \'md-disabled\': !$mdTabsCtrl.canPageBack() }" ' +
	              'ng-if="$mdTabsCtrl.shouldPaginate" ' +
	              'ng-click="$mdTabsCtrl.previousPage()"> ' +
	            '<md-icon md-svg-src="'+ $$mdSvgRegistry.mdTabsArrow +'"></md-icon> ' +
	          '</md-prev-button> ' +
	          '<md-next-button ' +
	              'tabindex="-1" ' +
	              'role="button" ' +
	              'aria-label="Next Page" ' +
	              'aria-disabled="{{!$mdTabsCtrl.canPageForward()}}" ' +
	              'ng-class="{ \'md-disabled\': !$mdTabsCtrl.canPageForward() }" ' +
	              'ng-if="$mdTabsCtrl.shouldPaginate" ' +
	              'ng-click="$mdTabsCtrl.nextPage()"> ' +
	            '<md-icon md-svg-src="'+ $$mdSvgRegistry.mdTabsArrow +'"></md-icon> ' +
	          '</md-next-button> ' +
	          '<md-tabs-canvas ' +
	              'tabindex="{{ $mdTabsCtrl.hasFocus ? -1 : 0 }}" ' +
	              'aria-activedescendant="{{$mdTabsCtrl.getFocusedTabId()}}" ' +
	              'ng-focus="$mdTabsCtrl.redirectFocus()" ' +
	              'ng-class="{ ' +
	                  '\'md-paginated\': $mdTabsCtrl.shouldPaginate, ' +
	                  '\'md-center-tabs\': $mdTabsCtrl.shouldCenterTabs ' +
	              '}" ' +
	              'ng-keydown="$mdTabsCtrl.keydown($event)" ' +
	              'role="tablist"> ' +
	            '<md-pagination-wrapper ' +
	                'ng-class="{ \'md-center-tabs\': $mdTabsCtrl.shouldCenterTabs }" ' +
	                'md-tab-scroll="$mdTabsCtrl.scroll($event)"> ' +
	              '<md-tab-item ' +
	                  'tabindex="-1" ' +
	                  'class="md-tab" ' +
	                  'ng-repeat="tab in $mdTabsCtrl.tabs" ' +
	                  'role="tab" ' +
	                  'md-tab-id="{{::tab.id}}"' +
	                  'aria-selected="{{tab.isActive()}}" ' +
	                  'aria-disabled="{{tab.scope.disabled || \'false\'}}" ' +
	                  'ng-click="$mdTabsCtrl.select(tab.getIndex())" ' +
	                  'ng-class="{ ' +
	                      '\'md-active\':    tab.isActive(), ' +
	                      '\'md-focused\':   tab.hasFocus(), ' +
	                      '\'md-disabled\':  tab.scope.disabled ' +
	                  '}" ' +
	                  'ng-disabled="tab.scope.disabled" ' +
	                  'md-swipe-left="$mdTabsCtrl.nextPage()" md-swipe-touch-action="pan-y" ' +
	                  'md-swipe-right="$mdTabsCtrl.previousPage()" ' +
	                  'md-tabs-template="::tab.label" ' +
	                  'md-scope="::tab.parent"></md-tab-item> ' +
	              '<md-ink-bar></md-ink-bar> ' +
	            '</md-pagination-wrapper> ' +
	            '<md-tabs-dummy-wrapper class="md-visually-hidden md-dummy-wrapper"> ' +
	              '<md-dummy-tab ' +
	                  'class="md-tab" ' +
	                  'tabindex="-1" ' +
	                  'id="tab-item-{{::tab.id}}" ' +
	                  'md-tab-id="{{::tab.id}}"' +
	                  'aria-selected="{{tab.isActive()}}" ' +
	                  'aria-disabled="{{tab.scope.disabled || \'false\'}}" ' +
	                  'ng-focus="$mdTabsCtrl.hasFocus = true" ' +
	                  'ng-blur="$mdTabsCtrl.hasFocus = false" ' +
	                  'ng-repeat="tab in $mdTabsCtrl.tabs" ' +
	                  'md-tabs-template="::tab.label" ' +
	                  'md-scope="::tab.parent"></md-dummy-tab> ' +
	            '</md-tabs-dummy-wrapper> ' +
	          '</md-tabs-canvas> ' +
	        '</md-tabs-wrapper> ' +
	        '<md-tabs-content-wrapper ng-show="$mdTabsCtrl.hasContent && $mdTabsCtrl.selectedIndex >= 0" class="_md"> ' +
	          '<md-tab-content ' +
	              'id="{{:: $mdTabsCtrl.tabContentPrefix + tab.id}}" ' +
	              'class="_md" ' +
	              'role="tabpanel" ' +
	              'aria-labelledby="tab-item-{{::tab.id}}" ' +
	              'md-swipe-left="$mdTabsCtrl.swipeContent && $mdTabsCtrl.incrementIndex(1)" ' +
	              'md-swipe-right="$mdTabsCtrl.swipeContent && $mdTabsCtrl.incrementIndex(-1)" ' +
	              'md-swipe-touch-action="pan-y" ' +
	              'ng-if="tab.hasContent" ' +
	              'ng-repeat="(index, tab) in $mdTabsCtrl.tabs" ' +
	              'ng-class="{ ' +
	                '\'md-no-transition\': $mdTabsCtrl.lastSelectedIndex == null, ' +
	                '\'md-active\':        tab.isActive(), ' +
	                '\'md-left\':          tab.isLeft(), ' +
	                '\'md-right\':         tab.isRight(), ' +
	                '\'md-no-scroll\':     $mdTabsCtrl.dynamicHeight ' +
	              '}"> ' +
	            '<div ' +
	                'md-tabs-template="::tab.template" ' +
	                'md-connected-if="tab.isActive()" ' +
	                'md-scope="::tab.parent" ' +
	                'ng-if="$mdTabsCtrl.enableDisconnect || tab.shouldRender()"></div> ' +
	          '</md-tab-content> ' +
	        '</md-tabs-content-wrapper>';
	    },
	    controller:       'MdTabsController',
	    controllerAs:     '$mdTabsCtrl',
	    bindToController: true
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdTabsDummyWrapper.$inject = ["$mdUtil", "$window"];angular
	  .module('material.components.tabs')
	  .directive('mdTabsDummyWrapper', MdTabsDummyWrapper);
	
	/**
	 * @private
	 *
	 * @param $mdUtil
	 * @param $window
	 * @returns {{require: string, link: link}}
	 * @constructor
	 *
	 * @ngInject
	 */
	function MdTabsDummyWrapper ($mdUtil, $window) {
	  return {
	    require: '^?mdTabs',
	    link:    function link (scope, element, attr, ctrl) {
	      if (!ctrl) return;
	
	      var observer;
	      var disconnect;
	
	      var mutationCallback = function() {
	        ctrl.updatePagination();
	        ctrl.updateInkBarStyles();
	      };
	
	      if('MutationObserver' in $window) {
	        var config = {
	          childList: true,
	          subtree: true,
	          // Per https://bugzilla.mozilla.org/show_bug.cgi?id=1138368, browsers will not fire
	          // the childList mutation, once a <span> element's innerText changes.
	          // The characterData of the <span> element will change.
	          characterData: true
	        };
	
	        observer = new MutationObserver(mutationCallback);
	        observer.observe(element[0], config);
	        disconnect = observer.disconnect.bind(observer);
	      } else {
	        var debounced = $mdUtil.debounce(mutationCallback, 15, null, false);
	        
	        element.on('DOMSubtreeModified', debounced);
	        disconnect = element.off.bind(element, 'DOMSubtreeModified', debounced);
	      }
	
	      // Disconnect the observer
	      scope.$on('$destroy', function() {
	        disconnect();
	      });
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdTabsTemplate.$inject = ["$compile", "$mdUtil"];angular
	    .module('material.components.tabs')
	    .directive('mdTabsTemplate', MdTabsTemplate);
	
	function MdTabsTemplate ($compile, $mdUtil) {
	  return {
	    restrict: 'A',
	    link:     link,
	    scope:    {
	      template:     '=mdTabsTemplate',
	      connected:    '=?mdConnectedIf',
	      compileScope: '=mdScope'
	    },
	    require:  '^?mdTabs'
	  };
	  function link (scope, element, attr, ctrl) {
	    if (!ctrl) return;
	
	    var compileScope = ctrl.enableDisconnect ? scope.compileScope.$new() : scope.compileScope;
	
	    element.html(scope.template);
	    $compile(element.contents())(compileScope);
	
	    return $mdUtil.nextTick(handleScope);
	
	    function handleScope () {
	      scope.$watch('connected', function (value) { value === false ? disconnect() : reconnect(); });
	      scope.$on('$destroy', reconnect);
	    }
	
	    function disconnect () {
	      if (ctrl.enableDisconnect) $mdUtil.disconnectScope(compileScope);
	    }
	
	    function reconnect () {
	      if (ctrl.enableDisconnect) $mdUtil.reconnectScope(compileScope);
	    }
	  }
	}
	
	})();
	(function(){ 
	angular.module("material.core").constant("$MD_THEME_CSS", "md-autocomplete.md-THEME_NAME-theme{background:\"{{background-A100}}\"}md-autocomplete.md-THEME_NAME-theme[disabled]:not([md-floating-label]){background:\"{{background-100}}\"}md-autocomplete.md-THEME_NAME-theme button md-icon path{fill:\"{{background-600}}\"}md-autocomplete.md-THEME_NAME-theme button:after{background:\"{{background-600-0.3}}\"}.md-autocomplete-suggestions-container.md-THEME_NAME-theme{background:\"{{background-A100}}\"}.md-autocomplete-suggestions-container.md-THEME_NAME-theme li{color:\"{{background-900}}\"}.md-autocomplete-suggestions-container.md-THEME_NAME-theme li .highlight{color:\"{{background-600}}\"}.md-autocomplete-suggestions-container.md-THEME_NAME-theme li.selected,.md-autocomplete-suggestions-container.md-THEME_NAME-theme li:hover{background:\"{{background-200}}\"}md-backdrop{background-color:\"{{background-900-0.0}}\"}md-backdrop.md-opaque.md-THEME_NAME-theme{background-color:\"{{background-900-1.0}}\"}md-bottom-sheet.md-THEME_NAME-theme{background-color:\"{{background-50}}\";border-top-color:\"{{background-300}}\"}md-bottom-sheet.md-THEME_NAME-theme.md-list md-list-item{color:\"{{foreground-1}}\"}md-bottom-sheet.md-THEME_NAME-theme .md-subheader{background-color:\"{{background-50}}\";color:\"{{foreground-1}}\"}.md-button.md-THEME_NAME-theme:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme:not([disabled]):hover{background-color:\"{{background-500-0.2}}\"}.md-button.md-THEME_NAME-theme:not([disabled]).md-icon-button:hover{background-color:transparent}.md-button.md-THEME_NAME-theme.md-fab md-icon{color:\"{{accent-contrast}}\"}.md-button.md-THEME_NAME-theme.md-primary{color:\"{{primary-color}}\"}.md-button.md-THEME_NAME-theme.md-primary.md-fab,.md-button.md-THEME_NAME-theme.md-primary.md-raised{color:\"{{primary-contrast}}\";background-color:\"{{primary-color}}\"}.md-button.md-THEME_NAME-theme.md-primary.md-fab:not([disabled]) md-icon,.md-button.md-THEME_NAME-theme.md-primary.md-raised:not([disabled]) md-icon{color:\"{{primary-contrast}}\"}.md-button.md-THEME_NAME-theme.md-primary.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-primary.md-fab:not([disabled]):hover,.md-button.md-THEME_NAME-theme.md-primary.md-raised:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-primary.md-raised:not([disabled]):hover{background-color:\"{{primary-600}}\"}.md-button.md-THEME_NAME-theme.md-primary:not([disabled]) md-icon{color:\"{{primary-color}}\"}.md-button.md-THEME_NAME-theme.md-fab{background-color:\"{{accent-color}}\";color:\"{{accent-contrast}}\"}.md-button.md-THEME_NAME-theme.md-fab:not([disabled]) .md-icon{color:\"{{accent-contrast}}\"}.md-button.md-THEME_NAME-theme.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-fab:not([disabled]):hover{background-color:\"{{accent-A700}}\"}.md-button.md-THEME_NAME-theme.md-raised{color:\"{{background-900}}\";background-color:\"{{background-50}}\"}.md-button.md-THEME_NAME-theme.md-raised:not([disabled]) md-icon{color:\"{{background-900}}\"}.md-button.md-THEME_NAME-theme.md-raised:not([disabled]):hover{background-color:\"{{background-50}}\"}.md-button.md-THEME_NAME-theme.md-raised:not([disabled]).md-focused{background-color:\"{{background-200}}\"}.md-button.md-THEME_NAME-theme.md-warn{color:\"{{warn-color}}\"}.md-button.md-THEME_NAME-theme.md-warn.md-fab,.md-button.md-THEME_NAME-theme.md-warn.md-raised{color:\"{{warn-contrast}}\";background-color:\"{{warn-color}}\"}.md-button.md-THEME_NAME-theme.md-warn.md-fab:not([disabled]) md-icon,.md-button.md-THEME_NAME-theme.md-warn.md-raised:not([disabled]) md-icon{color:\"{{warn-contrast}}\"}.md-button.md-THEME_NAME-theme.md-warn.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-warn.md-fab:not([disabled]):hover,.md-button.md-THEME_NAME-theme.md-warn.md-raised:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-warn.md-raised:not([disabled]):hover{background-color:\"{{warn-600}}\"}.md-button.md-THEME_NAME-theme.md-warn:not([disabled]) md-icon{color:\"{{warn-color}}\"}.md-button.md-THEME_NAME-theme.md-accent{color:\"{{accent-color}}\"}.md-button.md-THEME_NAME-theme.md-accent.md-fab,.md-button.md-THEME_NAME-theme.md-accent.md-raised{color:\"{{accent-contrast}}\";background-color:\"{{accent-color}}\"}.md-button.md-THEME_NAME-theme.md-accent.md-fab:not([disabled]) md-icon,.md-button.md-THEME_NAME-theme.md-accent.md-raised:not([disabled]) md-icon{color:\"{{accent-contrast}}\"}.md-button.md-THEME_NAME-theme.md-accent.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-accent.md-fab:not([disabled]):hover,.md-button.md-THEME_NAME-theme.md-accent.md-raised:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-accent.md-raised:not([disabled]):hover{background-color:\"{{accent-A700}}\"}.md-button.md-THEME_NAME-theme.md-accent:not([disabled]) md-icon{color:\"{{accent-color}}\"}.md-button.md-THEME_NAME-theme.md-accent[disabled],.md-button.md-THEME_NAME-theme.md-fab[disabled],.md-button.md-THEME_NAME-theme.md-raised[disabled],.md-button.md-THEME_NAME-theme.md-warn[disabled],.md-button.md-THEME_NAME-theme[disabled]{color:\"{{foreground-3}}\";cursor:default}.md-button.md-THEME_NAME-theme.md-accent[disabled] md-icon,.md-button.md-THEME_NAME-theme.md-fab[disabled] md-icon,.md-button.md-THEME_NAME-theme.md-raised[disabled] md-icon,.md-button.md-THEME_NAME-theme.md-warn[disabled] md-icon,.md-button.md-THEME_NAME-theme[disabled] md-icon{color:\"{{foreground-3}}\"}.md-button.md-THEME_NAME-theme.md-fab[disabled],.md-button.md-THEME_NAME-theme.md-raised[disabled]{background-color:\"{{foreground-4}}\"}.md-button.md-THEME_NAME-theme[disabled]{background-color:transparent}._md a.md-THEME_NAME-theme:not(.md-button).md-primary{color:\"{{primary-color}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-primary:hover{color:\"{{primary-700}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-accent{color:\"{{accent-color}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-accent:hover{color:\"{{accent-A700}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-warn{color:\"{{warn-color}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-warn:hover{color:\"{{warn-700}}\"}md-card.md-THEME_NAME-theme{color:\"{{foreground-1}}\";background-color:\"{{background-hue-1}}\";border-radius:2px}md-card.md-THEME_NAME-theme .md-card-image{border-radius:2px 2px 0 0}md-card.md-THEME_NAME-theme md-card-header md-card-avatar md-icon{color:\"{{background-color}}\";background-color:\"{{foreground-3}}\"}md-card.md-THEME_NAME-theme md-card-header md-card-header-text .md-subhead,md-card.md-THEME_NAME-theme md-card-title md-card-title-text:not(:only-child) .md-subhead{color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme .md-ripple{color:\"{{accent-A700}}\"}md-checkbox.md-THEME_NAME-theme.md-checked .md-ripple{color:\"{{background-600}}\"}md-checkbox.md-THEME_NAME-theme.md-checked.md-focused .md-container:before{background-color:\"{{accent-color-0.26}}\"}md-checkbox.md-THEME_NAME-theme .md-ink-ripple{color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme.md-checked .md-ink-ripple{color:\"{{accent-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not(.md-checked) .md-icon{border-color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme.md-checked .md-icon{background-color:\"{{accent-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme.md-checked .md-icon:after{border-color:\"{{accent-contrast-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary .md-ripple{color:\"{{primary-600}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ripple{color:\"{{background-600}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary .md-ink-ripple{color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ink-ripple{color:\"{{primary-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary:not(.md-checked) .md-icon{border-color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-icon{background-color:\"{{primary-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked.md-focused .md-container:before{background-color:\"{{primary-color-0.26}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-icon:after{border-color:\"{{primary-contrast-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary .md-indeterminate[disabled] .md-container{color:\"{{foreground-3}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn .md-ripple{color:\"{{warn-600}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn .md-ink-ripple{color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-ink-ripple{color:\"{{warn-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn:not(.md-checked) .md-icon{border-color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-icon{background-color:\"{{warn-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked.md-focused:not([disabled]) .md-container:before{background-color:\"{{warn-color-0.26}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-icon:after{border-color:\"{{background-200}}\"}md-checkbox.md-THEME_NAME-theme[disabled]:not(.md-checked) .md-icon{border-color:\"{{foreground-3}}\"}md-checkbox.md-THEME_NAME-theme[disabled].md-checked .md-icon{background-color:\"{{foreground-3}}\"}md-checkbox.md-THEME_NAME-theme[disabled].md-checked .md-icon:after{border-color:\"{{background-200}}\"}md-checkbox.md-THEME_NAME-theme[disabled] .md-icon:after{border-color:\"{{foreground-3}}\"}md-checkbox.md-THEME_NAME-theme[disabled] .md-label{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme .md-chips{box-shadow:0 1px \"{{foreground-4}}\"}md-chips.md-THEME_NAME-theme .md-chips.md-focused{box-shadow:0 2px \"{{primary-color}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input{color:\"{{foreground-1}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input:-moz-placeholder,md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input::-moz-placeholder{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input:-ms-input-placeholder{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input::-webkit-input-placeholder{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme md-chip{background:\"{{background-300}}\";color:\"{{background-800}}\"}md-chips.md-THEME_NAME-theme md-chip md-icon{color:\"{{background-700}}\"}md-chips.md-THEME_NAME-theme md-chip.md-focused{background:\"{{primary-color}}\";color:\"{{primary-contrast}}\"}md-chips.md-THEME_NAME-theme md-chip.md-focused md-icon{color:\"{{primary-contrast}}\"}md-chips.md-THEME_NAME-theme md-chip._md-chip-editing{background:transparent;color:\"{{background-800}}\"}md-chips.md-THEME_NAME-theme md-chip-remove .md-button md-icon path{fill:\"{{background-500}}\"}.md-contact-suggestion span.md-contact-email{color:\"{{background-400}}\"}md-content.md-THEME_NAME-theme{color:\"{{foreground-1}}\";background-color:\"{{background-default}}\"}.md-calendar.md-THEME_NAME-theme{background:\"{{background-A100}}\";color:\"{{background-A200-0.87}}\"}.md-calendar.md-THEME_NAME-theme tr:last-child td{border-bottom-color:\"{{background-200}}\"}.md-THEME_NAME-theme .md-calendar-day-header{background:\"{{background-300}}\";color:\"{{background-A200-0.87}}\"}.md-THEME_NAME-theme .md-calendar-date.md-calendar-date-today .md-calendar-date-selection-indicator{border:1px solid \"{{primary-500}}\"}.md-THEME_NAME-theme .md-calendar-date.md-calendar-date-today.md-calendar-date-disabled{color:\"{{primary-500-0.6}}\"}.md-calendar-date.md-focus .md-THEME_NAME-theme .md-calendar-date-selection-indicator,.md-THEME_NAME-theme .md-calendar-date-selection-indicator:hover{background:\"{{background-300}}\"}.md-THEME_NAME-theme .md-calendar-date.md-calendar-selected-date .md-calendar-date-selection-indicator,.md-THEME_NAME-theme .md-calendar-date.md-focus.md-calendar-selected-date .md-calendar-date-selection-indicator{background:\"{{primary-500}}\";color:\"{{primary-500-contrast}}\";border-color:transparent}.md-THEME_NAME-theme .md-calendar-date-disabled,.md-THEME_NAME-theme .md-calendar-month-label-disabled{color:\"{{background-A200-0.435}}\"}.md-THEME_NAME-theme .md-datepicker-input{color:\"{{foreground-1}}\"}.md-THEME_NAME-theme .md-datepicker-input:-moz-placeholder,.md-THEME_NAME-theme .md-datepicker-input::-moz-placeholder{color:\"{{foreground-3}}\"}.md-THEME_NAME-theme .md-datepicker-input:-ms-input-placeholder{color:\"{{foreground-3}}\"}.md-THEME_NAME-theme .md-datepicker-input::-webkit-input-placeholder{color:\"{{foreground-3}}\"}.md-THEME_NAME-theme .md-datepicker-input-container{border-bottom-color:\"{{foreground-4}}\"}.md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-focused{border-bottom-color:\"{{primary-color}}\"}.md-accent .md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-focused{border-bottom-color:\"{{accent-color}}\"}.md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-invalid,.md-warn .md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-focused{border-bottom-color:\"{{warn-A700}}\"}.md-THEME_NAME-theme .md-datepicker-calendar-pane{border-color:\"{{background-hue-1}}\"}.md-THEME_NAME-theme .md-datepicker-triangle-button .md-datepicker-expand-triangle{border-top-color:\"{{foreground-2}}\"}.md-THEME_NAME-theme .md-datepicker-open .md-datepicker-calendar-icon{color:\"{{primary-color}}\"}.md-accent .md-THEME_NAME-theme .md-datepicker-open .md-datepicker-calendar-icon,.md-THEME_NAME-theme .md-datepicker-open.md-accent .md-datepicker-calendar-icon{color:\"{{accent-color}}\"}.md-THEME_NAME-theme .md-datepicker-open.md-warn .md-datepicker-calendar-icon,.md-warn .md-THEME_NAME-theme .md-datepicker-open .md-datepicker-calendar-icon{color:\"{{warn-A700}}\"}.md-THEME_NAME-theme .md-datepicker-calendar{background:\"{{background-A100}}\"}.md-THEME_NAME-theme .md-datepicker-input-mask-opaque{box-shadow:0 0 0 9999px \"{{background-hue-1}}\"}.md-THEME_NAME-theme .md-datepicker-open .md-datepicker-input-container{background:\"{{background-hue-1}}\"}md-dialog.md-THEME_NAME-theme{border-radius:4px;background-color:\"{{background-hue-1}}\";color:\"{{foreground-1}}\"}md-dialog.md-THEME_NAME-theme.md-content-overflow .md-actions,md-dialog.md-THEME_NAME-theme.md-content-overflow md-dialog-actions,md-divider.md-THEME_NAME-theme{border-top-color:\"{{foreground-4}}\"}.layout-gt-lg-row>md-divider.md-THEME_NAME-theme,.layout-gt-md-row>md-divider.md-THEME_NAME-theme,.layout-gt-sm-row>md-divider.md-THEME_NAME-theme,.layout-gt-xs-row>md-divider.md-THEME_NAME-theme,.layout-lg-row>md-divider.md-THEME_NAME-theme,.layout-md-row>md-divider.md-THEME_NAME-theme,.layout-row>md-divider.md-THEME_NAME-theme,.layout-sm-row>md-divider.md-THEME_NAME-theme,.layout-xl-row>md-divider.md-THEME_NAME-theme,.layout-xs-row>md-divider.md-THEME_NAME-theme{border-right-color:\"{{foreground-4}}\"}md-icon.md-THEME_NAME-theme{color:\"{{foreground-2}}\"}md-icon.md-THEME_NAME-theme.md-primary{color:\"{{primary-color}}\"}md-icon.md-THEME_NAME-theme.md-accent{color:\"{{accent-color}}\"}md-icon.md-THEME_NAME-theme.md-warn{color:\"{{warn-color}}\"}md-input-container.md-THEME_NAME-theme .md-input{color:\"{{foreground-1}}\";border-color:\"{{foreground-4}}\"}md-input-container.md-THEME_NAME-theme .md-input:-moz-placeholder,md-input-container.md-THEME_NAME-theme .md-input::-moz-placeholder{color:\"{{foreground-3}}\"}md-input-container.md-THEME_NAME-theme .md-input:-ms-input-placeholder{color:\"{{foreground-3}}\"}md-input-container.md-THEME_NAME-theme .md-input::-webkit-input-placeholder{color:\"{{foreground-3}}\"}md-input-container.md-THEME_NAME-theme>md-icon{color:\"{{foreground-1}}\"}md-input-container.md-THEME_NAME-theme .md-placeholder,md-input-container.md-THEME_NAME-theme label{color:\"{{foreground-3}}\"}md-input-container.md-THEME_NAME-theme label.md-required:after{color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-focused):not(.md-input-invalid) label.md-required:after{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme .md-input-message-animation,md-input-container.md-THEME_NAME-theme .md-input-messages-animation{color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme .md-input-message-animation .md-char-counter,md-input-container.md-THEME_NAME-theme .md-input-messages-animation .md-char-counter{color:\"{{foreground-1}}\"}md-input-container.md-THEME_NAME-theme.md-input-focused .md-input:-moz-placeholder,md-input-container.md-THEME_NAME-theme.md-input-focused .md-input::-moz-placeholder{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme.md-input-focused .md-input:-ms-input-placeholder{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme.md-input-focused .md-input::-webkit-input-placeholder{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-has-value label{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused .md-input,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-resized .md-input{border-color:\"{{primary-color}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused label,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused md-icon{color:\"{{primary-color}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-accent .md-input{border-color:\"{{accent-color}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-accent label,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-accent md-icon{color:\"{{accent-color}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-warn .md-input{border-color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-warn label,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-warn md-icon{color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme.md-input-invalid .md-input{border-color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme.md-input-invalid .md-char-counter,md-input-container.md-THEME_NAME-theme.md-input-invalid .md-input-message-animation,md-input-container.md-THEME_NAME-theme.md-input-invalid label{color:\"{{warn-A700}}\"}[disabled] md-input-container.md-THEME_NAME-theme .md-input,md-input-container.md-THEME_NAME-theme .md-input[disabled]{border-bottom-color:transparent;color:\"{{foreground-3}}\";background-image:linear-gradient(90deg,\"{{foreground-3}}\" 0,\"{{foreground-3}}\" 33%,transparent 0);background-image:-ms-linear-gradient(left,transparent 0,\"{{foreground-3}}\" 100%)}md-list.md-THEME_NAME-theme md-list-item.md-2-line .md-list-item-text h3,md-list.md-THEME_NAME-theme md-list-item.md-2-line .md-list-item-text h4,md-list.md-THEME_NAME-theme md-list-item.md-3-line .md-list-item-text h3,md-list.md-THEME_NAME-theme md-list-item.md-3-line .md-list-item-text h4{color:\"{{foreground-1}}\"}md-list.md-THEME_NAME-theme md-list-item.md-2-line .md-list-item-text p,md-list.md-THEME_NAME-theme md-list-item.md-3-line .md-list-item-text p{color:\"{{foreground-2}}\"}md-list.md-THEME_NAME-theme .md-proxy-focus.md-focused div.md-no-style{background-color:\"{{background-100}}\"}md-list.md-THEME_NAME-theme md-list-item .md-avatar-icon{background-color:\"{{foreground-3}}\";color:\"{{background-color}}\"}md-list.md-THEME_NAME-theme md-list-item>md-icon{color:\"{{foreground-2}}\"}md-list.md-THEME_NAME-theme md-list-item>md-icon.md-highlight{color:\"{{primary-color}}\"}md-list.md-THEME_NAME-theme md-list-item>md-icon.md-highlight.md-accent{color:\"{{accent-color}}\"}md-menu-content.md-THEME_NAME-theme{background-color:\"{{background-A100}}\"}md-menu-content.md-THEME_NAME-theme md-menu-item{color:\"{{background-A200-0.87}}\"}md-menu-content.md-THEME_NAME-theme md-menu-item md-icon{color:\"{{background-A200-0.54}}\"}md-menu-content.md-THEME_NAME-theme md-menu-item .md-button[disabled],md-menu-content.md-THEME_NAME-theme md-menu-item .md-button[disabled] md-icon{color:\"{{background-A200-0.25}}\"}md-menu-content.md-THEME_NAME-theme md-menu-divider{background-color:\"{{background-A200-0.11}}\"}md-menu-bar.md-THEME_NAME-theme>button.md-button{color:\"{{foreground-2}}\";border-radius:2px}md-menu-bar.md-THEME_NAME-theme md-menu.md-open>button,md-menu-bar.md-THEME_NAME-theme md-menu>button:focus{outline:none;background:\"{{background-200}}\"}md-menu-bar.md-THEME_NAME-theme.md-open:not(.md-keyboard-mode) md-menu:hover>button{background-color:\"{{ background-500-0.2}}\"}md-menu-bar.md-THEME_NAME-theme:not(.md-keyboard-mode):not(.md-open) md-menu button:focus,md-menu-bar.md-THEME_NAME-theme:not(.md-keyboard-mode):not(.md-open) md-menu button:hover{background:transparent}md-menu-content.md-THEME_NAME-theme .md-menu>.md-button:after{color:\"{{background-A200-0.54}}\"}md-menu-content.md-THEME_NAME-theme .md-menu.md-open>.md-button{background-color:\"{{ background-500-0.2}}\"}md-toolbar.md-THEME_NAME-theme.md-menu-toolbar{background-color:\"{{background-A100}}\";color:\"{{background-A200}}\"}md-toolbar.md-THEME_NAME-theme.md-menu-toolbar md-toolbar-filler{background-color:\"{{primary-color}}\";color:\"{{background-A100-0.87}}\"}md-toolbar.md-THEME_NAME-theme.md-menu-toolbar md-toolbar-filler md-icon{color:\"{{background-A100-0.87}}\"}md-nav-bar.md-THEME_NAME-theme .md-nav-bar{background-color:transparent;border-color:\"{{foreground-4}}\"}md-nav-bar.md-THEME_NAME-theme .md-button._md-nav-button.md-unselected{color:\"{{foreground-2}}\"}md-nav-bar.md-THEME_NAME-theme md-nav-ink-bar{color:\"{{accent-color}}\";background:\"{{accent-color}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar{background-color:\"{{accent-color}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar .md-button._md-nav-button{color:\"{{accent-A100}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar .md-button._md-nav-button.md-active,md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{accent-contrast}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{accent-contrast-0.1}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar md-nav-ink-bar{color:\"{{primary-600-1}}\";background:\"{{primary-600-1}}\"}md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar{background-color:\"{{warn-color}}\"}md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar .md-button._md-nav-button{color:\"{{warn-100}}\"}md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar .md-button._md-nav-button.md-active,md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{warn-contrast}}\"}md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{warn-contrast-0.1}}\"}md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar{background-color:\"{{primary-color}}\"}md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar .md-button._md-nav-button{color:\"{{primary-100}}\"}md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar .md-button._md-nav-button.md-active,md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{primary-contrast}}\"}md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{primary-contrast-0.1}}\"}md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar{background-color:\"{{primary-color}}\"}md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button{color:\"{{primary-100}}\"}md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-active,md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{primary-contrast}}\"}md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{primary-contrast-0.1}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar{background-color:\"{{accent-color}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button{color:\"{{accent-A100}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-active,md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{accent-contrast}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{accent-contrast-0.1}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar md-nav-ink-bar{color:\"{{primary-600-1}}\";background:\"{{primary-600-1}}\"}md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar{background-color:\"{{warn-color}}\"}md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button{color:\"{{warn-100}}\"}md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-active,md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{warn-contrast}}\"}md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{warn-contrast-0.1}}\"}md-progress-circular.md-THEME_NAME-theme path{stroke:\"{{primary-color}}\"}md-progress-circular.md-THEME_NAME-theme.md-warn path{stroke:\"{{warn-color}}\"}md-progress-circular.md-THEME_NAME-theme.md-accent path{stroke:\"{{accent-color}}\"}._md-panel-backdrop.md-THEME_NAME-theme{background-color:\"{{background-900-1.0}}\"}md-progress-linear.md-THEME_NAME-theme .md-container{background-color:\"{{primary-100}}\"}md-progress-linear.md-THEME_NAME-theme .md-bar{background-color:\"{{primary-color}}\"}md-progress-linear.md-THEME_NAME-theme.md-warn .md-container{background-color:\"{{warn-100}}\"}md-progress-linear.md-THEME_NAME-theme.md-warn .md-bar{background-color:\"{{warn-color}}\"}md-progress-linear.md-THEME_NAME-theme.md-accent .md-container{background-color:\"{{accent-100}}\"}md-progress-linear.md-THEME_NAME-theme.md-accent .md-bar{background-color:\"{{accent-color}}\"}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-warn .md-bar1{background-color:\"{{warn-100}}\"}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-warn .md-dashed:before{background:radial-gradient(\"{{warn-100}}\" 0,\"{{warn-100}}\" 16%,transparent 42%)}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-accent .md-bar1{background-color:\"{{accent-100}}\"}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-accent .md-dashed:before{background:radial-gradient(\"{{accent-100}}\" 0,\"{{accent-100}}\" 16%,transparent 42%)}md-radio-button.md-THEME_NAME-theme .md-off{border-color:\"{{foreground-2}}\"}md-radio-button.md-THEME_NAME-theme .md-on{background-color:\"{{accent-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme.md-checked .md-off{border-color:\"{{accent-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme.md-checked .md-ink-ripple{color:\"{{accent-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme .md-container .md-ripple{color:\"{{accent-A700}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-on,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-on{background-color:\"{{primary-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-off{border-color:\"{{primary-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-ink-ripple{color:\"{{primary-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-container .md-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-container .md-ripple{color:\"{{primary-600}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-on,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-on{background-color:\"{{warn-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-off{border-color:\"{{warn-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-ink-ripple{color:\"{{warn-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-container .md-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-container .md-ripple{color:\"{{warn-600}}\"}md-radio-button.md-THEME_NAME-theme[disabled],md-radio-group.md-THEME_NAME-theme[disabled]{color:\"{{foreground-3}}\"}md-radio-button.md-THEME_NAME-theme[disabled] .md-container .md-off,md-radio-button.md-THEME_NAME-theme[disabled] .md-container .md-on,md-radio-group.md-THEME_NAME-theme[disabled] .md-container .md-off,md-radio-group.md-THEME_NAME-theme[disabled] .md-container .md-on{border-color:\"{{foreground-3}}\"}md-radio-group.md-THEME_NAME-theme .md-checked .md-ink-ripple{color:\"{{accent-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme .md-checked:not([disabled]).md-primary .md-ink-ripple,md-radio-group.md-THEME_NAME-theme.md-primary .md-checked:not([disabled]) .md-ink-ripple{color:\"{{primary-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme .md-checked.md-primary .md-ink-ripple{color:\"{{warn-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty) .md-checked .md-container:before{background-color:\"{{accent-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty) .md-checked.md-primary .md-container:before,md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty).md-primary .md-checked .md-container:before{background-color:\"{{primary-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty) .md-checked.md-warn .md-container:before,md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty).md-warn .md-checked .md-container:before{background-color:\"{{warn-color-0.26}}\"}md-sidenav.md-THEME_NAME-theme,md-sidenav.md-THEME_NAME-theme md-content{background-color:\"{{background-hue-1}}\"}md-input-container md-select.md-THEME_NAME-theme .md-select-value span:first-child:after{color:\"{{warn-A700}}\"}md-input-container:not(.md-input-focused):not(.md-input-invalid) md-select.md-THEME_NAME-theme .md-select-value span:first-child:after{color:\"{{foreground-3}}\"}md-input-container.md-input-focused:not(.md-input-has-value) md-select.md-THEME_NAME-theme .md-select-value,md-input-container.md-input-focused:not(.md-input-has-value) md-select.md-THEME_NAME-theme .md-select-value.md-select-placeholder{color:\"{{primary-color}}\"}md-input-container.md-input-invalid md-select.md-THEME_NAME-theme .md-select-value{color:\"{{warn-A700}}\"!important;border-bottom-color:\"{{warn-A700}}\"!important}md-input-container.md-input-invalid md-select.md-THEME_NAME-theme.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme[disabled] .md-select-value{border-bottom-color:transparent;background-image:linear-gradient(90deg,\"{{foreground-3}}\" 0,\"{{foreground-3}}\" 33%,transparent 0);background-image:-ms-linear-gradient(left,transparent 0,\"{{foreground-3}}\" 100%)}md-select.md-THEME_NAME-theme .md-select-value{border-bottom-color:\"{{foreground-4}}\"}md-select.md-THEME_NAME-theme .md-select-value.md-select-placeholder{color:\"{{foreground-3}}\"}md-select.md-THEME_NAME-theme .md-select-value span:first-child:after{color:\"{{warn-A700}}\"}md-select.md-THEME_NAME-theme.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme.ng-invalid.ng-touched .md-select-value{color:\"{{warn-A700}}\"!important;border-bottom-color:\"{{warn-A700}}\"!important}md-select.md-THEME_NAME-theme.ng-invalid.ng-touched.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme:not([disabled]):focus .md-select-value{border-bottom-color:\"{{primary-color}}\";color:\"{{ foreground-1 }}\"}md-select.md-THEME_NAME-theme:not([disabled]):focus .md-select-value.md-select-placeholder{color:\"{{ foreground-1 }}\"}md-select.md-THEME_NAME-theme:not([disabled]):focus.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme:not([disabled]):focus.md-accent .md-select-value{border-bottom-color:\"{{accent-color}}\"}md-select.md-THEME_NAME-theme:not([disabled]):focus.md-warn .md-select-value{border-bottom-color:\"{{warn-color}}\"}md-select.md-THEME_NAME-theme[disabled] .md-select-icon,md-select.md-THEME_NAME-theme[disabled] .md-select-value,md-select.md-THEME_NAME-theme[disabled] .md-select-value.md-select-placeholder{color:\"{{foreground-3}}\"}md-select.md-THEME_NAME-theme .md-select-icon{color:\"{{foreground-2}}\"}md-select-menu.md-THEME_NAME-theme md-content{background:\"{{background-A100}}\"}md-select-menu.md-THEME_NAME-theme md-content md-optgroup{color:\"{{background-600-0.87}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option{color:\"{{background-900-0.87}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[disabled] .md-text{color:\"{{background-400-0.87}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option:not([disabled]):focus,md-select-menu.md-THEME_NAME-theme md-content md-option:not([disabled]):hover{background:\"{{background-200}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[selected]{color:\"{{primary-500}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[selected]:focus{color:\"{{primary-600}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[selected].md-accent{color:\"{{accent-color}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[selected].md-accent:focus{color:\"{{accent-A700}}\"}.md-checkbox-enabled.md-THEME_NAME-theme .md-ripple{color:\"{{primary-600}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-ripple{color:\"{{background-600}}\"}.md-checkbox-enabled.md-THEME_NAME-theme .md-ink-ripple{color:\"{{foreground-2}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-ink-ripple{color:\"{{primary-color-0.87}}\"}.md-checkbox-enabled.md-THEME_NAME-theme:not(.md-checked) .md-icon{border-color:\"{{foreground-2}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-icon{background-color:\"{{primary-color-0.87}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected].md-focused .md-container:before{background-color:\"{{primary-color-0.26}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-icon:after{border-color:\"{{primary-contrast-0.87}}\"}.md-checkbox-enabled.md-THEME_NAME-theme .md-indeterminate[disabled] .md-container{color:\"{{foreground-3}}\"}.md-checkbox-enabled.md-THEME_NAME-theme md-option .md-text{color:\"{{background-900-0.87}}\"}md-slider.md-THEME_NAME-theme .md-track{background-color:\"{{foreground-3}}\"}md-slider.md-THEME_NAME-theme .md-track-ticks{color:\"{{background-contrast}}\"}md-slider.md-THEME_NAME-theme .md-focus-ring{background-color:\"{{accent-A200-0.2}}\"}md-slider.md-THEME_NAME-theme .md-disabled-thumb{border-color:\"{{background-color}}\";background-color:\"{{background-color}}\"}md-slider.md-THEME_NAME-theme.md-min .md-thumb:after{background-color:\"{{background-color}}\";border-color:\"{{foreground-3}}\"}md-slider.md-THEME_NAME-theme.md-min .md-focus-ring{background-color:\"{{foreground-3-0.38}}\"}md-slider.md-THEME_NAME-theme.md-min[md-discrete] .md-thumb:after{background-color:\"{{background-contrast}}\";border-color:transparent}md-slider.md-THEME_NAME-theme.md-min[md-discrete] .md-sign{background-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme.md-min[md-discrete] .md-sign:after{border-top-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme.md-min[md-discrete][md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme .md-track.md-track-fill{background-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme .md-thumb:after{border-color:\"{{accent-color}}\";background-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme .md-sign{background-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme .md-sign:after{border-top-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme[md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme .md-thumb-text{color:\"{{accent-contrast}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-focus-ring{background-color:\"{{warn-200-0.38}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-track.md-track-fill{background-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-thumb:after{border-color:\"{{warn-color}}\";background-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-sign{background-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-sign:after{border-top-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn[md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-thumb-text{color:\"{{warn-contrast}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-focus-ring{background-color:\"{{primary-200-0.38}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-track.md-track-fill{background-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-thumb:after{border-color:\"{{primary-color}}\";background-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-sign{background-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-sign:after{border-top-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary[md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-thumb-text{color:\"{{primary-contrast}}\"}md-slider.md-THEME_NAME-theme[disabled] .md-thumb:after{border-color:transparent}md-slider.md-THEME_NAME-theme[disabled]:not(.md-min) .md-thumb:after,md-slider.md-THEME_NAME-theme[disabled][md-discrete] .md-thumb:after{background-color:\"{{foreground-3}}\";border-color:transparent}md-slider.md-THEME_NAME-theme[disabled][readonly] .md-sign{background-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme[disabled][readonly] .md-sign:after{border-top-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme[disabled][readonly][md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme[disabled][readonly] .md-disabled-thumb{border-color:transparent;background-color:transparent}md-slider-container[disabled]>:first-child:not(md-slider),md-slider-container[disabled]>:last-child:not(md-slider){color:\"{{foreground-3}}\"}.md-subheader.md-THEME_NAME-theme{color:\"{{ foreground-2-0.23 }}\";background-color:\"{{background-default}}\"}.md-subheader.md-THEME_NAME-theme.md-primary{color:\"{{primary-color}}\"}.md-subheader.md-THEME_NAME-theme.md-accent{color:\"{{accent-color}}\"}.md-subheader.md-THEME_NAME-theme.md-warn{color:\"{{warn-color}}\"}md-switch.md-THEME_NAME-theme .md-ink-ripple{color:\"{{background-500}}\"}md-switch.md-THEME_NAME-theme .md-thumb{background-color:\"{{background-50}}\"}md-switch.md-THEME_NAME-theme .md-bar{background-color:\"{{background-500}}\"}md-switch.md-THEME_NAME-theme.md-checked .md-ink-ripple{color:\"{{accent-color}}\"}md-switch.md-THEME_NAME-theme.md-checked .md-thumb{background-color:\"{{accent-color}}\"}md-switch.md-THEME_NAME-theme.md-checked .md-bar{background-color:\"{{accent-color-0.5}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-focused .md-thumb:before{background-color:\"{{accent-color-0.26}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-primary .md-ink-ripple{color:\"{{primary-color}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-primary .md-thumb{background-color:\"{{primary-color}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-primary .md-bar{background-color:\"{{primary-color-0.5}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-primary.md-focused .md-thumb:before{background-color:\"{{primary-color-0.26}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-warn .md-ink-ripple{color:\"{{warn-color}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-warn .md-thumb{background-color:\"{{warn-color}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-warn .md-bar{background-color:\"{{warn-color-0.5}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-warn.md-focused .md-thumb:before{background-color:\"{{warn-color-0.26}}\"}md-switch.md-THEME_NAME-theme[disabled] .md-thumb{background-color:\"{{background-400}}\"}md-switch.md-THEME_NAME-theme[disabled] .md-bar{background-color:\"{{foreground-4}}\"}md-tabs.md-THEME_NAME-theme md-tabs-wrapper{background-color:transparent;border-color:\"{{foreground-4}}\"}md-tabs.md-THEME_NAME-theme .md-paginator md-icon{color:\"{{primary-color}}\"}md-tabs.md-THEME_NAME-theme md-ink-bar{color:\"{{accent-color}}\";background:\"{{accent-color}}\"}md-tabs.md-THEME_NAME-theme .md-tab{color:\"{{foreground-2}}\"}md-tabs.md-THEME_NAME-theme .md-tab[disabled],md-tabs.md-THEME_NAME-theme .md-tab[disabled] md-icon{color:\"{{foreground-3}}\"}md-tabs.md-THEME_NAME-theme .md-tab.md-active,md-tabs.md-THEME_NAME-theme .md-tab.md-active md-icon,md-tabs.md-THEME_NAME-theme .md-tab.md-focused,md-tabs.md-THEME_NAME-theme .md-tab.md-focused md-icon{color:\"{{primary-color}}\"}md-tabs.md-THEME_NAME-theme .md-tab.md-focused{background:\"{{primary-color-0.1}}\"}md-tabs.md-THEME_NAME-theme .md-tab .md-ripple-container{color:\"{{accent-A100}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper{background-color:\"{{accent-color}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{accent-A100}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{accent-contrast}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{accent-contrast-0.1}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-ink-bar{color:\"{{primary-600-1}}\";background:\"{{primary-600-1}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper{background-color:\"{{primary-color}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{primary-100}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{primary-contrast}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{primary-contrast-0.1}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper{background-color:\"{{warn-color}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{warn-100}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{warn-contrast}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{warn-contrast-0.1}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper{background-color:\"{{primary-color}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{primary-100}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{primary-contrast}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{primary-contrast-0.1}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper{background-color:\"{{accent-color}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{accent-A100}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{accent-contrast}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{accent-contrast-0.1}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-ink-bar{color:\"{{primary-600-1}}\";background:\"{{primary-600-1}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper{background-color:\"{{warn-color}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{warn-100}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{warn-contrast}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{warn-contrast-0.1}}\"}md-toast.md-THEME_NAME-theme .md-toast-content{background-color:#323232;color:\"{{background-50}}\"}md-toast.md-THEME_NAME-theme .md-toast-content .md-button{color:\"{{background-50}}\"}md-toast.md-THEME_NAME-theme .md-toast-content .md-button.md-highlight{color:\"{{accent-color}}\"}md-toast.md-THEME_NAME-theme .md-toast-content .md-button.md-highlight.md-primary{color:\"{{primary-color}}\"}md-toast.md-THEME_NAME-theme .md-toast-content .md-button.md-highlight.md-warn{color:\"{{warn-color}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar){background-color:\"{{primary-color}}\";color:\"{{primary-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-icon{color:\"{{primary-contrast}}\";fill:\"{{primary-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) .md-button[disabled] md-icon{color:\"{{primary-contrast-0.26}}\";fill:\"{{primary-contrast-0.26}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent{background-color:\"{{accent-color}}\";color:\"{{accent-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent .md-ink-ripple{color:\"{{accent-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-icon{color:\"{{accent-contrast}}\";fill:\"{{accent-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent .md-button[disabled] md-icon{color:\"{{accent-contrast-0.26}}\";fill:\"{{accent-contrast-0.26}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn{background-color:\"{{warn-color}}\";color:\"{{warn-contrast}}\"}.md-panel.md-tooltip.md-THEME_NAME-theme{color:\"{{background-700-contrast}}\";background-color:\"{{background-700}}\"}body.md-THEME_NAME-theme,html.md-THEME_NAME-theme{color:\"{{foreground-1}}\";background-color:\"{{background-color}}\"}"); 
	})();
	
	
	})(window, window.angular);;window.ngMaterial={version:{full: "1.1.4"}};

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* angular-moment.js / v1.0.1 / (c) 2013, 2014, 2015, 2016 Uri Shaked / MIT Licence */
	
	'format amd';
	/* global define */
	
	(function () {
		'use strict';
	
		function isUndefinedOrNull(val) {
			return angular.isUndefined(val) || val === null;
		}
	
		function requireMoment() {
			try {
				return __webpack_require__(3); // Using nw.js or browserify?
			} catch (e) {
				throw new Error('Please install moment via npm. Please reference to: https://github.com/urish/angular-moment'); // Add wiki/troubleshooting section?
			}
		}
	
		function angularMoment(angular, moment) {
	
			if(typeof moment === 'undefined') {
				if(true) {
					moment = requireMoment();
				}else{
					throw new Error('Moment cannot be found by angular-moment! Please reference to: https://github.com/urish/angular-moment'); // Add wiki/troubleshooting section?
				}
			}
	
			/**
			 * @ngdoc overview
			 * @name angularMoment
			 *
			 * @description
			 * angularMoment module provides moment.js functionality for angular.js apps.
			 */
			angular.module('angularMoment', [])
	
			/**
			 * @ngdoc object
			 * @name angularMoment.config:angularMomentConfig
			 *
			 * @description
			 * Common configuration of the angularMoment module
			 */
				.constant('angularMomentConfig', {
					/**
					 * @ngdoc property
					 * @name angularMoment.config.angularMomentConfig#preprocess
					 * @propertyOf angularMoment.config:angularMomentConfig
					 * @returns {function} A preprocessor function that will be applied on all incoming dates
					 *
					 * @description
					 * Defines a preprocessor function to apply on all input dates (e.g. the input of `am-time-ago`,
					 * `amCalendar`, etc.). The function must return a `moment` object.
					 *
					 * @example
					 *   // Causes angular-moment to always treat the input values as unix timestamps
					 *   angularMomentConfig.preprocess = function(value) {
					 * 	   return moment.unix(value);
					 *   }
					 */
					preprocess: null,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.angularMomentConfig#timezone
					 * @propertyOf angularMoment.config:angularMomentConfig
					 * @returns {string} The default timezone
					 *
					 * @description
					 * The default timezone (e.g. 'Europe/London'). Empty string by default (does not apply
					 * any timezone shift).
					 *
					 * NOTE: This option requires moment-timezone >= 0.3.0.
					 */
					timezone: null,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.angularMomentConfig#format
					 * @propertyOf angularMoment.config:angularMomentConfig
					 * @returns {string} The pre-conversion format of the date
					 *
					 * @description
					 * Specify the format of the input date. Essentially it's a
					 * default and saves you from specifying a format in every
					 * element. Overridden by element attr. Null by default.
					 */
					format: null,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.angularMomentConfig#statefulFilters
					 * @propertyOf angularMoment.config:angularMomentConfig
					 * @returns {boolean} Whether angular-moment filters should be stateless (or not)
					 *
					 * @description
					 * Specifies whether the filters included with angular-moment are stateful.
					 * Stateful filters will automatically re-evaluate whenever you change the timezone
					 * or locale settings, but may negatively impact performance. true by default.
					 */
					statefulFilters: true
				})
	
			/**
			 * @ngdoc object
			 * @name angularMoment.object:moment
			 *
			 * @description
			 * moment global (as provided by the moment.js library)
			 */
				.constant('moment', moment)
	
			/**
			 * @ngdoc object
			 * @name angularMoment.config:amTimeAgoConfig
			 * @module angularMoment
			 *
			 * @description
			 * configuration specific to the amTimeAgo directive
			 */
				.constant('amTimeAgoConfig', {
					/**
					 * @ngdoc property
					 * @name angularMoment.config.amTimeAgoConfig#withoutSuffix
					 * @propertyOf angularMoment.config:amTimeAgoConfig
					 * @returns {boolean} Whether to include a suffix in am-time-ago directive
					 *
					 * @description
					 * Defaults to false.
					 */
					withoutSuffix: false,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.amTimeAgoConfig#serverTime
					 * @propertyOf angularMoment.config:amTimeAgoConfig
					 * @returns {number} Server time in milliseconds since the epoch
					 *
					 * @description
					 * If set, time ago will be calculated relative to the given value.
					 * If null, local time will be used. Defaults to null.
					 */
					serverTime: null,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.amTimeAgoConfig#titleFormat
					 * @propertyOf angularMoment.config:amTimeAgoConfig
					 * @returns {string} The format of the date to be displayed in the title of the element. If null,
					 *        the directive set the title of the element.
					 *
					 * @description
					 * The format of the date used for the title of the element. null by default.
					 */
					titleFormat: null,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.amTimeAgoConfig#fullDateThreshold
					 * @propertyOf angularMoment.config:amTimeAgoConfig
					 * @returns {number} The minimum number of days for showing a full date instead of relative time
					 *
					 * @description
					 * The threshold for displaying a full date. The default is null, which means the date will always
					 * be relative, and full date will never be displayed.
					 */
					fullDateThreshold: null,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.amTimeAgoConfig#fullDateFormat
					 * @propertyOf angularMoment.config:amTimeAgoConfig
					 * @returns {string} The format to use when displaying a full date.
					 *
					 * @description
					 * Specify the format of the date when displayed as full date. null by default.
					 */
					fullDateFormat: null,
	
					fullDateThresholdUnit: 'day'
				})
	
			/**
			 * @ngdoc directive
			 * @name angularMoment.directive:amTimeAgo
			 * @module angularMoment
			 *
			 * @restrict A
			 */
				.directive('amTimeAgo', ['$window', 'moment', 'amMoment', 'amTimeAgoConfig', function ($window, moment, amMoment, amTimeAgoConfig) {
	
					return function (scope, element, attr) {
						var activeTimeout = null;
						var currentValue;
						var withoutSuffix = amTimeAgoConfig.withoutSuffix;
						var titleFormat = amTimeAgoConfig.titleFormat;
						var fullDateThreshold = amTimeAgoConfig.fullDateThreshold;
						var fullDateFormat = amTimeAgoConfig.fullDateFormat;
						var fullDateThresholdUnit = amTimeAgoConfig.fullDateThresholdUnit;
	
						var localDate = new Date().getTime();
						var modelName = attr.amTimeAgo;
						var currentFrom;
						var isTimeElement = ('TIME' === element[0].nodeName.toUpperCase());
						var setTitleTime = !element.attr('title');
	
						function getNow() {
							var now;
							if (currentFrom) {
								now = currentFrom;
							} else if (amTimeAgoConfig.serverTime) {
								var localNow = new Date().getTime();
								var nowMillis = localNow - localDate + amTimeAgoConfig.serverTime;
								now = moment(nowMillis);
							}
							else {
								now = moment();
							}
							return now;
						}
	
						function cancelTimer() {
							if (activeTimeout) {
								$window.clearTimeout(activeTimeout);
								activeTimeout = null;
							}
						}
	
						function updateTime(momentInstance) {
							var timeAgo = getNow().diff(momentInstance, fullDateThresholdUnit);
							var showFullDate = fullDateThreshold && timeAgo >= fullDateThreshold;
	
							if (showFullDate) {
								element.text(momentInstance.format(fullDateFormat));
							} else {
								element.text(momentInstance.from(getNow(), withoutSuffix));
							}
	
							if (titleFormat && setTitleTime) {
								element.attr('title', momentInstance.format(titleFormat));
							}
	
							if (!showFullDate) {
								var howOld = Math.abs(getNow().diff(momentInstance, 'minute'));
								var secondsUntilUpdate = 3600;
								if (howOld < 1) {
									secondsUntilUpdate = 1;
								} else if (howOld < 60) {
									secondsUntilUpdate = 30;
								} else if (howOld < 180) {
									secondsUntilUpdate = 300;
								}
	
								activeTimeout = $window.setTimeout(function () {
									updateTime(momentInstance);
								}, secondsUntilUpdate * 1000);
							}
						}
	
						function updateDateTimeAttr(value) {
							if (isTimeElement) {
								element.attr('datetime', value);
							}
						}
	
						function updateMoment() {
							cancelTimer();
							if (currentValue) {
								var momentValue = amMoment.preprocessDate(currentValue);
								updateTime(momentValue);
								updateDateTimeAttr(momentValue.toISOString());
							}
						}
	
						scope.$watch(modelName, function (value) {
							if (isUndefinedOrNull(value) || (value === '')) {
								cancelTimer();
								if (currentValue) {
									element.text('');
									updateDateTimeAttr('');
									currentValue = null;
								}
								return;
							}
	
							currentValue = value;
							updateMoment();
						});
	
						if (angular.isDefined(attr.amFrom)) {
							scope.$watch(attr.amFrom, function (value) {
								if (isUndefinedOrNull(value) || (value === '')) {
									currentFrom = null;
								} else {
									currentFrom = moment(value);
								}
								updateMoment();
							});
						}
	
						if (angular.isDefined(attr.amWithoutSuffix)) {
							scope.$watch(attr.amWithoutSuffix, function (value) {
								if (typeof value === 'boolean') {
									withoutSuffix = value;
									updateMoment();
								} else {
									withoutSuffix = amTimeAgoConfig.withoutSuffix;
								}
							});
						}
	
						attr.$observe('amFullDateThreshold', function (newValue) {
							fullDateThreshold = newValue;
							updateMoment();
						});
	
						attr.$observe('amFullDateFormat', function (newValue) {
							fullDateFormat = newValue;
							updateMoment();
						});
	
						attr.$observe('amFullDateThresholdUnit', function (newValue) {
							fullDateThresholdUnit = newValue;
							updateMoment();
						});
	
						scope.$on('$destroy', function () {
							cancelTimer();
						});
	
						scope.$on('amMoment:localeChanged', function () {
							updateMoment();
						});
					};
				}])
	
			/**
			 * @ngdoc service
			 * @name angularMoment.service.amMoment
			 * @module angularMoment
			 */
				.service('amMoment', ['moment', '$rootScope', '$log', 'angularMomentConfig', function (moment, $rootScope, $log, angularMomentConfig) {
					var defaultTimezone = null;
	
					/**
					 * @ngdoc function
					 * @name angularMoment.service.amMoment#changeLocale
					 * @methodOf angularMoment.service.amMoment
					 *
					 * @description
					 * Changes the locale for moment.js and updates all the am-time-ago directive instances
					 * with the new locale. Also broadcasts an `amMoment:localeChanged` event on $rootScope.
					 *
					 * @param {string} locale Locale code (e.g. en, es, ru, pt-br, etc.)
					 * @param {object} customization object of locale strings to override
					 */
					this.changeLocale = function (locale, customization) {
						var result = moment.locale(locale, customization);
						if (angular.isDefined(locale)) {
							$rootScope.$broadcast('amMoment:localeChanged');
	
						}
						return result;
					};
	
					/**
					 * @ngdoc function
					 * @name angularMoment.service.amMoment#changeTimezone
					 * @methodOf angularMoment.service.amMoment
					 *
					 * @description
					 * Changes the default timezone for amCalendar, amDateFormat and amTimeAgo. Also broadcasts an
					 * `amMoment:timezoneChanged` event on $rootScope.
					 *
					 * Note: this method works only if moment-timezone > 0.3.0 is loaded
					 *
					 * @param {string} timezone Timezone name (e.g. UTC)
					 */
					this.changeTimezone = function (timezone) {
						if (moment.tz && moment.tz.setDefault) {
							moment.tz.setDefault(timezone);
							$rootScope.$broadcast('amMoment:timezoneChanged');
						} else {
							$log.warn('angular-moment: changeTimezone() works only with moment-timezone.js v0.3.0 or greater.');
						}
						angularMomentConfig.timezone = timezone;
						defaultTimezone = timezone;
					};
	
					/**
					 * @ngdoc function
					 * @name angularMoment.service.amMoment#preprocessDate
					 * @methodOf angularMoment.service.amMoment
					 *
					 * @description
					 * Preprocess a given value and convert it into a Moment instance appropriate for use in the
					 * am-time-ago directive and the filters. The behavior of this function can be overriden by
					 * setting `angularMomentConfig.preprocess`.
					 *
					 * @param {*} value The value to be preprocessed
					 * @return {Moment} A `moment` object
					 */
					this.preprocessDate = function (value) {
						// Configure the default timezone if needed
						if (defaultTimezone !== angularMomentConfig.timezone) {
							this.changeTimezone(angularMomentConfig.timezone);
						}
	
						if (angularMomentConfig.preprocess) {
							return angularMomentConfig.preprocess(value);
						}
	
						if (!isNaN(parseFloat(value)) && isFinite(value)) {
							// Milliseconds since the epoch
							return moment(parseInt(value, 10));
						}
	
						// else just returns the value as-is.
						return moment(value);
					};
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amParse
			 * @module angularMoment
			 */
				.filter('amParse', ['moment', function (moment) {
					return function (value, format) {
						return moment(value, format);
					};
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amFromUnix
			 * @module angularMoment
			 */
				.filter('amFromUnix', ['moment', function (moment) {
					return function (value) {
						return moment.unix(value);
					};
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amUtc
			 * @module angularMoment
			 */
				.filter('amUtc', ['moment', function (moment) {
					return function (value) {
						return moment.utc(value);
					};
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amUtcOffset
			 * @module angularMoment
			 *
			 * @description
			 * Adds a UTC offset to the given timezone object. The offset can be a number of minutes, or a string such as
			 * '+0300', '-0300' or 'Z'.
			 */
				.filter('amUtcOffset', ['amMoment', function (amMoment) {
					function amUtcOffset(value, offset) {
						return amMoment.preprocessDate(value).utcOffset(offset);
					}
	
					return amUtcOffset;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amLocal
			 * @module angularMoment
			 */
				.filter('amLocal', ['moment', function (moment) {
					return function (value) {
						return moment.isMoment(value) ? value.local() : null;
					};
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amTimezone
			 * @module angularMoment
			 *
			 * @description
			 * Apply a timezone onto a given moment object, e.g. 'America/Phoenix').
			 *
			 * You need to include moment-timezone.js for timezone support.
			 */
				.filter('amTimezone', ['amMoment', 'angularMomentConfig', '$log', function (amMoment, angularMomentConfig, $log) {
					function amTimezone(value, timezone) {
						var aMoment = amMoment.preprocessDate(value);
	
						if (!timezone) {
							return aMoment;
						}
	
						if (aMoment.tz) {
							return aMoment.tz(timezone);
						} else {
							$log.warn('angular-moment: named timezone specified but moment.tz() is undefined. Did you forget to include moment-timezone.js ?');
							return aMoment;
						}
					}
	
					return amTimezone;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amCalendar
			 * @module angularMoment
			 */
				.filter('amCalendar', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
					function amCalendarFilter(value, referenceTime, formats) {
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						var date = amMoment.preprocessDate(value);
						return date.isValid() ? date.calendar(referenceTime, formats) : '';
					}
	
					// Since AngularJS 1.3, filters have to explicitly define being stateful
					// (this is no longer the default).
					amCalendarFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amCalendarFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amDifference
			 * @module angularMoment
			 */
				.filter('amDifference', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
					function amDifferenceFilter(value, otherValue, unit, usePrecision) {
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						var date = amMoment.preprocessDate(value);
						var date2 = !isUndefinedOrNull(otherValue) ? amMoment.preprocessDate(otherValue) : moment();
	
						if (!date.isValid() || !date2.isValid()) {
							return '';
						}
	
						return date.diff(date2, unit, usePrecision);
					}
	
					amDifferenceFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amDifferenceFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amDateFormat
			 * @module angularMoment
			 * @function
			 */
				.filter('amDateFormat', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
					function amDateFormatFilter(value, format) {
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						var date = amMoment.preprocessDate(value);
						if (!date.isValid()) {
							return '';
						}
	
						return date.format(format);
					}
	
					amDateFormatFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amDateFormatFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amDurationFormat
			 * @module angularMoment
			 * @function
			 */
				.filter('amDurationFormat', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
					function amDurationFormatFilter(value, format, suffix) {
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						return moment.duration(value, format).humanize(suffix);
					}
	
					amDurationFormatFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amDurationFormatFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amTimeAgo
			 * @module angularMoment
			 * @function
			 */
				.filter('amTimeAgo', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
					function amTimeAgoFilter(value, suffix, from) {
						var date, dateFrom;
	
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						value = amMoment.preprocessDate(value);
						date = moment(value);
						if (!date.isValid()) {
							return '';
						}
	
						dateFrom = moment(from);
						if (!isUndefinedOrNull(from) && dateFrom.isValid()) {
							return date.from(dateFrom, suffix);
						}
	
						return date.fromNow(suffix);
					}
	
					amTimeAgoFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amTimeAgoFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amSubtract
			 * @module angularMoment
			 * @function
			 */
				.filter('amSubtract', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
					function amSubtractFilter(value, amount, type) {
	
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						return moment(value).subtract(parseInt(amount, 10), type);
					}
	
					amSubtractFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amSubtractFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amAdd
			 * @module angularMoment
			 * @function
			 */
				.filter('amAdd', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
					function amAddFilter(value, amount, type) {
	
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						return moment(value).add(parseInt(amount, 10), type);
					}
	
					amAddFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amAddFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amStartOf
			 * @module angularMoment
			 * @function
			 */
				.filter('amStartOf', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
					function amStartOfFilter(value, type) {
	
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						return moment(value).startOf(type);
					}
	
					amStartOfFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amStartOfFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amEndOf
			 * @module angularMoment
			 * @function
			 */
				.filter('amEndOf', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
					function amEndOfFilter(value, type) {
	
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						return moment(value).endOf(type);
					}
	
					amEndOfFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amEndOfFilter;
	 			}]);
	
			return 'angularMoment';
		}
	
		var isElectron = window && window.process && window.process.type;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(12), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (angularMoment), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module && module.exports && (typeof require === 'function') && !isElectron) {
			module.exports = angularMoment(require('angular'), require('moment'));
		} else {
			angularMoment(angular, (typeof global !== 'undefined' ? global : window).moment);
		}
	})();


/***/ }),

/***/ 39:
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.6.4
	 * (c) 2010-2017 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window) {'use strict';
	
	/**
	 * @description
	 *
	 * This object provides a utility for producing rich Error messages within
	 * Angular. It can be called as follows:
	 *
	 * var exampleMinErr = minErr('example');
	 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
	 *
	 * The above creates an instance of minErr in the example namespace. The
	 * resulting error will have a namespaced error code of example.one.  The
	 * resulting error will replace {0} with the value of foo, and {1} with the
	 * value of bar. The object is not restricted in the number of arguments it can
	 * take.
	 *
	 * If fewer arguments are specified than necessary for interpolation, the extra
	 * interpolation markers will be preserved in the final string.
	 *
	 * Since data will be parsed statically during a build step, some restrictions
	 * are applied with respect to how minErr instances are created and called.
	 * Instances should have names of the form namespaceMinErr for a minErr created
	 * using minErr('namespace') . Error codes, namespaces and template strings
	 * should all be static strings, not variables or general expressions.
	 *
	 * @param {string} module The namespace to use for the new minErr instance.
	 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
	 *   error from returned function, for cases when a particular type of error is useful.
	 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
	 */
	
	function minErr(module, ErrorConstructor) {
	  ErrorConstructor = ErrorConstructor || Error;
	  return function() {
	    var code = arguments[0],
	      template = arguments[1],
	      message = '[' + (module ? module + ':' : '') + code + '] ',
	      templateArgs = sliceArgs(arguments, 2).map(function(arg) {
	        return toDebugString(arg, minErrConfig.objectMaxDepth);
	      }),
	      paramPrefix, i;
	
	    message += template.replace(/\{\d+\}/g, function(match) {
	      var index = +match.slice(1, -1);
	
	      if (index < templateArgs.length) {
	        return templateArgs[index];
	      }
	
	      return match;
	    });
	
	    message += '\nhttp://errors.angularjs.org/1.6.4/' +
	      (module ? module + '/' : '') + code;
	
	    for (i = 0, paramPrefix = '?'; i < templateArgs.length; i++, paramPrefix = '&') {
	      message += paramPrefix + 'p' + i + '=' + encodeURIComponent(templateArgs[i]);
	    }
	
	    return new ErrorConstructor(message);
	  };
	}
	
	/* We need to tell ESLint what variables are being exported */
	/* exported
	  angular,
	  msie,
	  jqLite,
	  jQuery,
	  slice,
	  splice,
	  push,
	  toString,
	  minErrConfig,
	  errorHandlingConfig,
	  isValidObjectMaxDepth,
	  ngMinErr,
	  angularModule,
	  uid,
	  REGEX_STRING_REGEXP,
	  VALIDITY_STATE_PROPERTY,
	
	  lowercase,
	  uppercase,
	  manualLowercase,
	  manualUppercase,
	  nodeName_,
	  isArrayLike,
	  forEach,
	  forEachSorted,
	  reverseParams,
	  nextUid,
	  setHashKey,
	  extend,
	  toInt,
	  inherit,
	  merge,
	  noop,
	  identity,
	  valueFn,
	  isUndefined,
	  isDefined,
	  isObject,
	  isBlankObject,
	  isString,
	  isNumber,
	  isNumberNaN,
	  isDate,
	  isArray,
	  isFunction,
	  isRegExp,
	  isWindow,
	  isScope,
	  isFile,
	  isFormData,
	  isBlob,
	  isBoolean,
	  isPromiseLike,
	  trim,
	  escapeForRegexp,
	  isElement,
	  makeMap,
	  includes,
	  arrayRemove,
	  copy,
	  simpleCompare,
	  equals,
	  csp,
	  jq,
	  concat,
	  sliceArgs,
	  bind,
	  toJsonReplacer,
	  toJson,
	  fromJson,
	  convertTimezoneToLocal,
	  timezoneToOffset,
	  startingTag,
	  tryDecodeURIComponent,
	  parseKeyValue,
	  toKeyValue,
	  encodeUriSegment,
	  encodeUriQuery,
	  angularInit,
	  bootstrap,
	  getTestability,
	  snake_case,
	  bindJQuery,
	  assertArg,
	  assertArgFn,
	  assertNotHasOwnProperty,
	  getter,
	  getBlockNodes,
	  hasOwnProperty,
	  createMap,
	  stringify,
	
	  NODE_TYPE_ELEMENT,
	  NODE_TYPE_ATTRIBUTE,
	  NODE_TYPE_TEXT,
	  NODE_TYPE_COMMENT,
	  NODE_TYPE_DOCUMENT,
	  NODE_TYPE_DOCUMENT_FRAGMENT
	*/
	
	////////////////////////////////////
	
	/**
	 * @ngdoc module
	 * @name ng
	 * @module ng
	 * @installation
	 * @description
	 *
	 * # ng (core module)
	 * The ng module is loaded by default when an AngularJS application is started. The module itself
	 * contains the essential components for an AngularJS application to function. The table below
	 * lists a high level breakdown of each of the services/factories, filters, directives and testing
	 * components available within this core module.
	 *
	 * <div doc-module-components="ng"></div>
	 */
	
	var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;
	
	// The name of a form control's ValidityState property.
	// This is used so that it's possible for internal tests to create mock ValidityStates.
	var VALIDITY_STATE_PROPERTY = 'validity';
	
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var minErrConfig = {
	  objectMaxDepth: 5
	};
	
	 /**
	 * @ngdoc function
	 * @name angular.errorHandlingConfig
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Configure several aspects of error handling in AngularJS if used as a setter or return the
	 * current configuration if used as a getter. The following options are supported:
	 *
	 * - **objectMaxDepth**: The maximum depth to which objects are traversed when stringified for error messages.
	 *
	 * Omitted or undefined options will leave the corresponding configuration values unchanged.
	 *
	 * @param {Object=} config - The configuration object. May only contain the options that need to be
	 *     updated. Supported keys:
	 *
	 * * `objectMaxDepth`  **{Number}** - The max depth for stringifying objects. Setting to a
	 *   non-positive or non-numeric value, removes the max depth limit.
	 *   Default: 5
	 */
	function errorHandlingConfig(config) {
	  if (isObject(config)) {
	    if (isDefined(config.objectMaxDepth)) {
	      minErrConfig.objectMaxDepth = isValidObjectMaxDepth(config.objectMaxDepth) ? config.objectMaxDepth : NaN;
	    }
	  } else {
	    return minErrConfig;
	  }
	}
	
	/**
	 * @private
	 * @param {Number} maxDepth
	 * @return {boolean}
	 */
	function isValidObjectMaxDepth(maxDepth) {
	  return isNumber(maxDepth) && maxDepth > 0;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.lowercase
	 * @module ng
	 * @kind function
	 *
	 * @deprecated
	 * sinceVersion="1.5.0"
	 * removeVersion="1.7.0"
	 * Use [String.prototype.toLowerCase](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/toLowerCase) instead.
	 *
	 * @description Converts the specified string to lowercase.
	 * @param {string} string String to be converted to lowercase.
	 * @returns {string} Lowercased string.
	 */
	var lowercase = function(string) {return isString(string) ? string.toLowerCase() : string;};
	
	/**
	 * @ngdoc function
	 * @name angular.uppercase
	 * @module ng
	 * @kind function
	 *
	 * @deprecated
	 * sinceVersion="1.5.0"
	 * removeVersion="1.7.0"
	 * Use [String.prototype.toUpperCase](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/toUpperCase) instead.
	 *
	 * @description Converts the specified string to uppercase.
	 * @param {string} string String to be converted to uppercase.
	 * @returns {string} Uppercased string.
	 */
	var uppercase = function(string) {return isString(string) ? string.toUpperCase() : string;};
	
	
	var manualLowercase = function(s) {
	  /* eslint-disable no-bitwise */
	  return isString(s)
	      ? s.replace(/[A-Z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) | 32);})
	      : s;
	  /* eslint-enable */
	};
	var manualUppercase = function(s) {
	  /* eslint-disable no-bitwise */
	  return isString(s)
	      ? s.replace(/[a-z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) & ~32);})
	      : s;
	  /* eslint-enable */
	};
	
	
	// String#toLowerCase and String#toUpperCase don't produce correct results in browsers with Turkish
	// locale, for this reason we need to detect this case and redefine lowercase/uppercase methods
	// with correct but slower alternatives. See https://github.com/angular/angular.js/issues/11387
	if ('i' !== 'I'.toLowerCase()) {
	  lowercase = manualLowercase;
	  uppercase = manualUppercase;
	}
	
	
	var
	    msie,             // holds major version number for IE, or NaN if UA is not IE.
	    jqLite,           // delay binding since jQuery could be loaded after us.
	    jQuery,           // delay binding
	    slice             = [].slice,
	    splice            = [].splice,
	    push              = [].push,
	    toString          = Object.prototype.toString,
	    getPrototypeOf    = Object.getPrototypeOf,
	    ngMinErr          = minErr('ng'),
	
	    /** @name angular */
	    angular           = window.angular || (window.angular = {}),
	    angularModule,
	    uid               = 0;
	
	// Support: IE 9-11 only
	/**
	 * documentMode is an IE-only property
	 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
	 */
	msie = window.document.documentMode;
	
	
	/**
	 * @private
	 * @param {*} obj
	 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
	 *                   String ...)
	 */
	function isArrayLike(obj) {
	
	  // `null`, `undefined` and `window` are not array-like
	  if (obj == null || isWindow(obj)) return false;
	
	  // arrays, strings and jQuery/jqLite objects are array like
	  // * jqLite is either the jQuery or jqLite constructor function
	  // * we have to check the existence of jqLite first as this method is called
	  //   via the forEach method when constructing the jqLite object in the first place
	  if (isArray(obj) || isString(obj) || (jqLite && obj instanceof jqLite)) return true;
	
	  // Support: iOS 8.2 (not reproducible in simulator)
	  // "length" in obj used to prevent JIT error (gh-11508)
	  var length = 'length' in Object(obj) && obj.length;
	
	  // NodeList objects (with `item` method) and
	  // other objects with suitable length characteristics are array-like
	  return isNumber(length) &&
	    (length >= 0 && ((length - 1) in obj || obj instanceof Array) || typeof obj.item === 'function');
	
	}
	
	/**
	 * @ngdoc function
	 * @name angular.forEach
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
	 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
	 * is the value of an object property or an array element, `key` is the object property key or
	 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
	 *
	 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
	 * using the `hasOwnProperty` method.
	 *
	 * Unlike ES262's
	 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
	 * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
	 * return the value provided.
	 *
	   ```js
	     var values = {name: 'misko', gender: 'male'};
	     var log = [];
	     angular.forEach(values, function(value, key) {
	       this.push(key + ': ' + value);
	     }, log);
	     expect(log).toEqual(['name: misko', 'gender: male']);
	   ```
	 *
	 * @param {Object|Array} obj Object to iterate over.
	 * @param {Function} iterator Iterator function.
	 * @param {Object=} context Object to become context (`this`) for the iterator function.
	 * @returns {Object|Array} Reference to `obj`.
	 */
	
	function forEach(obj, iterator, context) {
	  var key, length;
	  if (obj) {
	    if (isFunction(obj)) {
	      for (key in obj) {
	        if (key !== 'prototype' && key !== 'length' && key !== 'name' && obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (isArray(obj) || isArrayLike(obj)) {
	      var isPrimitive = typeof obj !== 'object';
	      for (key = 0, length = obj.length; key < length; key++) {
	        if (isPrimitive || key in obj) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (obj.forEach && obj.forEach !== forEach) {
	        obj.forEach(iterator, context, obj);
	    } else if (isBlankObject(obj)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in obj) {
	        iterator.call(context, obj[key], key, obj);
	      }
	    } else if (typeof obj.hasOwnProperty === 'function') {
	      // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
	      for (key in obj) {
	        if (obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else {
	      // Slow path for objects which do not have a method `hasOwnProperty`
	      for (key in obj) {
	        if (hasOwnProperty.call(obj, key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    }
	  }
	  return obj;
	}
	
	function forEachSorted(obj, iterator, context) {
	  var keys = Object.keys(obj).sort();
	  for (var i = 0; i < keys.length; i++) {
	    iterator.call(context, obj[keys[i]], keys[i]);
	  }
	  return keys;
	}
	
	
	/**
	 * when using forEach the params are value, key, but it is often useful to have key, value.
	 * @param {function(string, *)} iteratorFn
	 * @returns {function(*, string)}
	 */
	function reverseParams(iteratorFn) {
	  return function(value, key) {iteratorFn(key, value);};
	}
	
	/**
	 * A consistent way of creating unique IDs in angular.
	 *
	 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
	 * we hit number precision issues in JavaScript.
	 *
	 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
	 *
	 * @returns {number} an unique alpha-numeric string
	 */
	function nextUid() {
	  return ++uid;
	}
	
	
	/**
	 * Set or clear the hashkey for an object.
	 * @param obj object
	 * @param h the hashkey (!truthy to delete the hashkey)
	 */
	function setHashKey(obj, h) {
	  if (h) {
	    obj.$$hashKey = h;
	  } else {
	    delete obj.$$hashKey;
	  }
	}
	
	
	function baseExtend(dst, objs, deep) {
	  var h = dst.$$hashKey;
	
	  for (var i = 0, ii = objs.length; i < ii; ++i) {
	    var obj = objs[i];
	    if (!isObject(obj) && !isFunction(obj)) continue;
	    var keys = Object.keys(obj);
	    for (var j = 0, jj = keys.length; j < jj; j++) {
	      var key = keys[j];
	      var src = obj[key];
	
	      if (deep && isObject(src)) {
	        if (isDate(src)) {
	          dst[key] = new Date(src.valueOf());
	        } else if (isRegExp(src)) {
	          dst[key] = new RegExp(src);
	        } else if (src.nodeName) {
	          dst[key] = src.cloneNode(true);
	        } else if (isElement(src)) {
	          dst[key] = src.clone();
	        } else {
	          if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
	          baseExtend(dst[key], [src], true);
	        }
	      } else {
	        dst[key] = src;
	      }
	    }
	  }
	
	  setHashKey(dst, h);
	  return dst;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.extend
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
	 *
	 * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
	 * {@link angular.merge} for this.
	 *
	 * @param {Object} dst Destination object.
	 * @param {...Object} src Source object(s).
	 * @returns {Object} Reference to `dst`.
	 */
	function extend(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), false);
	}
	
	
	/**
	* @ngdoc function
	* @name angular.merge
	* @module ng
	* @kind function
	*
	* @description
	* Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	* to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	* by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
	*
	* Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
	* objects, performing a deep copy.
	*
	* @param {Object} dst Destination object.
	* @param {...Object} src Source object(s).
	* @returns {Object} Reference to `dst`.
	*/
	function merge(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), true);
	}
	
	
	
	function toInt(str) {
	  return parseInt(str, 10);
	}
	
	var isNumberNaN = Number.isNaN || function isNumberNaN(num) {
	  // eslint-disable-next-line no-self-compare
	  return num !== num;
	};
	
	
	function inherit(parent, extra) {
	  return extend(Object.create(parent), extra);
	}
	
	/**
	 * @ngdoc function
	 * @name angular.noop
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that performs no operations. This function can be useful when writing code in the
	 * functional style.
	   ```js
	     function foo(callback) {
	       var result = calculateResult();
	       (callback || angular.noop)(result);
	     }
	   ```
	 */
	function noop() {}
	noop.$inject = [];
	
	
	/**
	 * @ngdoc function
	 * @name angular.identity
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that returns its first argument. This function is useful when writing code in the
	 * functional style.
	 *
	   ```js
	   function transformer(transformationFn, value) {
	     return (transformationFn || angular.identity)(value);
	   };
	
	   // E.g.
	   function getResult(fn, input) {
	     return (fn || angular.identity)(input);
	   };
	
	   getResult(function(n) { return n * 2; }, 21);   // returns 42
	   getResult(null, 21);                            // returns 21
	   getResult(undefined, 21);                       // returns 21
	   ```
	 *
	 * @param {*} value to be returned.
	 * @returns {*} the value passed in.
	 */
	function identity($) {return $;}
	identity.$inject = [];
	
	
	function valueFn(value) {return function valueRef() {return value;};}
	
	function hasCustomToString(obj) {
	  return isFunction(obj.toString) && obj.toString !== toString;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isUndefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is undefined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is undefined.
	 */
	function isUndefined(value) {return typeof value === 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is defined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is defined.
	 */
	function isDefined(value) {return typeof value !== 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isObject
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
	 * considered to be objects. Note that JavaScript arrays are objects.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Object` but not `null`.
	 */
	function isObject(value) {
	  // http://jsperf.com/isobject4
	  return value !== null && typeof value === 'object';
	}
	
	
	/**
	 * Determine if a value is an object with a null prototype
	 *
	 * @returns {boolean} True if `value` is an `Object` with a null prototype
	 */
	function isBlankObject(value) {
	  return value !== null && typeof value === 'object' && !getPrototypeOf(value);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isString
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `String`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `String`.
	 */
	function isString(value) {return typeof value === 'string';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isNumber
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Number`.
	 *
	 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
	 *
	 * If you wish to exclude these then you can use the native
	 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
	 * method.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Number`.
	 */
	function isNumber(value) {return typeof value === 'number';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDate
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a value is a date.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Date`.
	 */
	function isDate(value) {
	  return toString.call(value) === '[object Date]';
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isArray
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Array`. Alias of Array.isArray.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Array`.
	 */
	var isArray = Array.isArray;
	
	/**
	 * @ngdoc function
	 * @name angular.isFunction
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Function`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Function`.
	 */
	function isFunction(value) {return typeof value === 'function';}
	
	
	/**
	 * Determines if a value is a regular expression object.
	 *
	 * @private
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `RegExp`.
	 */
	function isRegExp(value) {
	  return toString.call(value) === '[object RegExp]';
	}
	
	
	/**
	 * Checks if `obj` is a window object.
	 *
	 * @private
	 * @param {*} obj Object to check
	 * @returns {boolean} True if `obj` is a window obj.
	 */
	function isWindow(obj) {
	  return obj && obj.window === obj;
	}
	
	
	function isScope(obj) {
	  return obj && obj.$evalAsync && obj.$watch;
	}
	
	
	function isFile(obj) {
	  return toString.call(obj) === '[object File]';
	}
	
	
	function isFormData(obj) {
	  return toString.call(obj) === '[object FormData]';
	}
	
	
	function isBlob(obj) {
	  return toString.call(obj) === '[object Blob]';
	}
	
	
	function isBoolean(value) {
	  return typeof value === 'boolean';
	}
	
	
	function isPromiseLike(obj) {
	  return obj && isFunction(obj.then);
	}
	
	
	var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array]$/;
	function isTypedArray(value) {
	  return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
	}
	
	function isArrayBuffer(obj) {
	  return toString.call(obj) === '[object ArrayBuffer]';
	}
	
	
	var trim = function(value) {
	  return isString(value) ? value.trim() : value;
	};
	
	// Copied from:
	// http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
	// Prereq: s is a string.
	var escapeForRegexp = function(s) {
	  return s
	    .replace(/([-()[\]{}+?*.$^|,:#<!\\])/g, '\\$1')
	    // eslint-disable-next-line no-control-regex
	    .replace(/\x08/g, '\\x08');
	};
	
	
	/**
	 * @ngdoc function
	 * @name angular.isElement
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a DOM element (or wrapped jQuery element).
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
	 */
	function isElement(node) {
	  return !!(node &&
	    (node.nodeName  // We are a direct element.
	    || (node.prop && node.attr && node.find)));  // We have an on and find method part of jQuery API.
	}
	
	/**
	 * @param str 'key1,key2,...'
	 * @returns {object} in the form of {key1:true, key2:true, ...}
	 */
	function makeMap(str) {
	  var obj = {}, items = str.split(','), i;
	  for (i = 0; i < items.length; i++) {
	    obj[items[i]] = true;
	  }
	  return obj;
	}
	
	
	function nodeName_(element) {
	  return lowercase(element.nodeName || (element[0] && element[0].nodeName));
	}
	
	function includes(array, obj) {
	  return Array.prototype.indexOf.call(array, obj) !== -1;
	}
	
	function arrayRemove(array, value) {
	  var index = array.indexOf(value);
	  if (index >= 0) {
	    array.splice(index, 1);
	  }
	  return index;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.copy
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Creates a deep copy of `source`, which should be an object or an array.
	 *
	 * * If no destination is supplied, a copy of the object or array is created.
	 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
	 *   are deleted and then all elements/properties from the source are copied to it.
	 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
	 * * If `source` is identical to `destination` an exception will be thrown.
	 *
	 * <br />
	 * <div class="alert alert-warning">
	 *   Only enumerable properties are taken into account. Non-enumerable properties (both on `source`
	 *   and on `destination`) will be ignored.
	 * </div>
	 *
	 * @param {*} source The source that will be used to make a copy.
	 *                   Can be any type, including primitives, `null`, and `undefined`.
	 * @param {(Object|Array)=} destination Destination into which the source is copied. If
	 *     provided, must be of the same type as `source`.
	 * @returns {*} The copy or updated `destination`, if `destination` was specified.
	 *
	 * @example
	  <example module="copyExample" name="angular-copy">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate class="simple-form">
	          <label>Name: <input type="text" ng-model="user.name" /></label><br />
	          <label>Age:  <input type="number" ng-model="user.age" /></label><br />
	          Gender: <label><input type="radio" ng-model="user.gender" value="male" />male</label>
	                  <label><input type="radio" ng-model="user.gender" value="female" />female</label><br />
	          <button ng-click="reset()">RESET</button>
	          <button ng-click="update(user)">SAVE</button>
	        </form>
	        <pre>form = {{user | json}}</pre>
	        <pre>master = {{master | json}}</pre>
	      </div>
	    </file>
	    <file name="script.js">
	      // Module: copyExample
	      angular.
	        module('copyExample', []).
	        controller('ExampleController', ['$scope', function($scope) {
	          $scope.master = {};
	
	          $scope.reset = function() {
	            // Example with 1 argument
	            $scope.user = angular.copy($scope.master);
	          };
	
	          $scope.update = function(user) {
	            // Example with 2 arguments
	            angular.copy(user, $scope.master);
	          };
	
	          $scope.reset();
	        }]);
	    </file>
	  </example>
	 */
	function copy(source, destination, maxDepth) {
	  var stackSource = [];
	  var stackDest = [];
	  maxDepth = isValidObjectMaxDepth(maxDepth) ? maxDepth : NaN;
	
	  if (destination) {
	    if (isTypedArray(destination) || isArrayBuffer(destination)) {
	      throw ngMinErr('cpta', 'Can\'t copy! TypedArray destination cannot be mutated.');
	    }
	    if (source === destination) {
	      throw ngMinErr('cpi', 'Can\'t copy! Source and destination are identical.');
	    }
	
	    // Empty the destination object
	    if (isArray(destination)) {
	      destination.length = 0;
	    } else {
	      forEach(destination, function(value, key) {
	        if (key !== '$$hashKey') {
	          delete destination[key];
	        }
	      });
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	    return copyRecurse(source, destination, maxDepth);
	  }
	
	  return copyElement(source, maxDepth);
	
	  function copyRecurse(source, destination, maxDepth) {
	    maxDepth--;
	    if (maxDepth < 0) {
	      return '...';
	    }
	    var h = destination.$$hashKey;
	    var key;
	    if (isArray(source)) {
	      for (var i = 0, ii = source.length; i < ii; i++) {
	        destination.push(copyElement(source[i], maxDepth));
	      }
	    } else if (isBlankObject(source)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in source) {
	        destination[key] = copyElement(source[key], maxDepth);
	      }
	    } else if (source && typeof source.hasOwnProperty === 'function') {
	      // Slow path, which must rely on hasOwnProperty
	      for (key in source) {
	        if (source.hasOwnProperty(key)) {
	          destination[key] = copyElement(source[key], maxDepth);
	        }
	      }
	    } else {
	      // Slowest path --- hasOwnProperty can't be called as a method
	      for (key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          destination[key] = copyElement(source[key], maxDepth);
	        }
	      }
	    }
	    setHashKey(destination, h);
	    return destination;
	  }
	
	  function copyElement(source, maxDepth) {
	    // Simple values
	    if (!isObject(source)) {
	      return source;
	    }
	
	    // Already copied values
	    var index = stackSource.indexOf(source);
	    if (index !== -1) {
	      return stackDest[index];
	    }
	
	    if (isWindow(source) || isScope(source)) {
	      throw ngMinErr('cpws',
	        'Can\'t copy! Making copies of Window or Scope instances is not supported.');
	    }
	
	    var needsRecurse = false;
	    var destination = copyType(source);
	
	    if (destination === undefined) {
	      destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
	      needsRecurse = true;
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	
	    return needsRecurse
	      ? copyRecurse(source, destination, maxDepth)
	      : destination;
	  }
	
	  function copyType(source) {
	    switch (toString.call(source)) {
	      case '[object Int8Array]':
	      case '[object Int16Array]':
	      case '[object Int32Array]':
	      case '[object Float32Array]':
	      case '[object Float64Array]':
	      case '[object Uint8Array]':
	      case '[object Uint8ClampedArray]':
	      case '[object Uint16Array]':
	      case '[object Uint32Array]':
	        return new source.constructor(copyElement(source.buffer), source.byteOffset, source.length);
	
	      case '[object ArrayBuffer]':
	        // Support: IE10
	        if (!source.slice) {
	          // If we're in this case we know the environment supports ArrayBuffer
	          /* eslint-disable no-undef */
	          var copied = new ArrayBuffer(source.byteLength);
	          new Uint8Array(copied).set(new Uint8Array(source));
	          /* eslint-enable */
	          return copied;
	        }
	        return source.slice(0);
	
	      case '[object Boolean]':
	      case '[object Number]':
	      case '[object String]':
	      case '[object Date]':
	        return new source.constructor(source.valueOf());
	
	      case '[object RegExp]':
	        var re = new RegExp(source.source, source.toString().match(/[^/]*$/)[0]);
	        re.lastIndex = source.lastIndex;
	        return re;
	
	      case '[object Blob]':
	        return new source.constructor([source], {type: source.type});
	    }
	
	    if (isFunction(source.cloneNode)) {
	      return source.cloneNode(true);
	    }
	  }
	}
	
	
	// eslint-disable-next-line no-self-compare
	function simpleCompare(a, b) { return a === b || (a !== a && b !== b); }
	
	
	/**
	 * @ngdoc function
	 * @name angular.equals
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if two objects or two values are equivalent. Supports value types, regular
	 * expressions, arrays and objects.
	 *
	 * Two objects or values are considered equivalent if at least one of the following is true:
	 *
	 * * Both objects or values pass `===` comparison.
	 * * Both objects or values are of the same type and all of their properties are equal by
	 *   comparing them with `angular.equals`.
	 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
	 * * Both values represent the same regular expression (In JavaScript,
	 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
	 *   representation matches).
	 *
	 * During a property comparison, properties of `function` type and properties with names
	 * that begin with `$` are ignored.
	 *
	 * Scope and DOMWindow objects are being compared only by identify (`===`).
	 *
	 * @param {*} o1 Object or value to compare.
	 * @param {*} o2 Object or value to compare.
	 * @returns {boolean} True if arguments are equal.
	 *
	 * @example
	   <example module="equalsExample" name="equalsExample">
	     <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate>
	          <h3>User 1</h3>
	          Name: <input type="text" ng-model="user1.name">
	          Age: <input type="number" ng-model="user1.age">
	
	          <h3>User 2</h3>
	          Name: <input type="text" ng-model="user2.name">
	          Age: <input type="number" ng-model="user2.age">
	
	          <div>
	            <br/>
	            <input type="button" value="Compare" ng-click="compare()">
	          </div>
	          User 1: <pre>{{user1 | json}}</pre>
	          User 2: <pre>{{user2 | json}}</pre>
	          Equal: <pre>{{result}}</pre>
	        </form>
	      </div>
	    </file>
	    <file name="script.js">
	        angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
	          $scope.user1 = {};
	          $scope.user2 = {};
	          $scope.compare = function() {
	            $scope.result = angular.equals($scope.user1, $scope.user2);
	          };
	        }]);
	    </file>
	  </example>
	 */
	function equals(o1, o2) {
	  if (o1 === o2) return true;
	  if (o1 === null || o2 === null) return false;
	  // eslint-disable-next-line no-self-compare
	  if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
	  var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
	  if (t1 === t2 && t1 === 'object') {
	    if (isArray(o1)) {
	      if (!isArray(o2)) return false;
	      if ((length = o1.length) === o2.length) {
	        for (key = 0; key < length; key++) {
	          if (!equals(o1[key], o2[key])) return false;
	        }
	        return true;
	      }
	    } else if (isDate(o1)) {
	      if (!isDate(o2)) return false;
	      return simpleCompare(o1.getTime(), o2.getTime());
	    } else if (isRegExp(o1)) {
	      if (!isRegExp(o2)) return false;
	      return o1.toString() === o2.toString();
	    } else {
	      if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) ||
	        isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
	      keySet = createMap();
	      for (key in o1) {
	        if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
	        if (!equals(o1[key], o2[key])) return false;
	        keySet[key] = true;
	      }
	      for (key in o2) {
	        if (!(key in keySet) &&
	            key.charAt(0) !== '$' &&
	            isDefined(o2[key]) &&
	            !isFunction(o2[key])) return false;
	      }
	      return true;
	    }
	  }
	  return false;
	}
	
	var csp = function() {
	  if (!isDefined(csp.rules)) {
	
	
	    var ngCspElement = (window.document.querySelector('[ng-csp]') ||
	                    window.document.querySelector('[data-ng-csp]'));
	
	    if (ngCspElement) {
	      var ngCspAttribute = ngCspElement.getAttribute('ng-csp') ||
	                    ngCspElement.getAttribute('data-ng-csp');
	      csp.rules = {
	        noUnsafeEval: !ngCspAttribute || (ngCspAttribute.indexOf('no-unsafe-eval') !== -1),
	        noInlineStyle: !ngCspAttribute || (ngCspAttribute.indexOf('no-inline-style') !== -1)
	      };
	    } else {
	      csp.rules = {
	        noUnsafeEval: noUnsafeEval(),
	        noInlineStyle: false
	      };
	    }
	  }
	
	  return csp.rules;
	
	  function noUnsafeEval() {
	    try {
	      // eslint-disable-next-line no-new, no-new-func
	      new Function('');
	      return false;
	    } catch (e) {
	      return true;
	    }
	  }
	};
	
	/**
	 * @ngdoc directive
	 * @module ng
	 * @name ngJq
	 *
	 * @element ANY
	 * @param {string=} ngJq the name of the library available under `window`
	 * to be used for angular.element
	 * @description
	 * Use this directive to force the angular.element library.  This should be
	 * used to force either jqLite by leaving ng-jq blank or setting the name of
	 * the jquery variable under window (eg. jQuery).
	 *
	 * Since angular looks for this directive when it is loaded (doesn't wait for the
	 * DOMContentLoaded event), it must be placed on an element that comes before the script
	 * which loads angular. Also, only the first instance of `ng-jq` will be used and all
	 * others ignored.
	 *
	 * @example
	 * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq>
	 ...
	 ...
	 </html>
	 ```
	 * @example
	 * This example shows how to use a jQuery based library of a different name.
	 * The library name must be available at the top most 'window'.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq="jQueryLib">
	 ...
	 ...
	 </html>
	 ```
	 */
	var jq = function() {
	  if (isDefined(jq.name_)) return jq.name_;
	  var el;
	  var i, ii = ngAttrPrefixes.length, prefix, name;
	  for (i = 0; i < ii; ++i) {
	    prefix = ngAttrPrefixes[i];
	    el = window.document.querySelector('[' + prefix.replace(':', '\\:') + 'jq]');
	    if (el) {
	      name = el.getAttribute(prefix + 'jq');
	      break;
	    }
	  }
	
	  return (jq.name_ = name);
	};
	
	function concat(array1, array2, index) {
	  return array1.concat(slice.call(array2, index));
	}
	
	function sliceArgs(args, startIndex) {
	  return slice.call(args, startIndex || 0);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.bind
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
	 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
	 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
	 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
	 *
	 * @param {Object} self Context which `fn` should be evaluated in.
	 * @param {function()} fn Function to be bound.
	 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
	 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
	 */
	function bind(self, fn) {
	  var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
	  if (isFunction(fn) && !(fn instanceof RegExp)) {
	    return curryArgs.length
	      ? function() {
	          return arguments.length
	            ? fn.apply(self, concat(curryArgs, arguments, 0))
	            : fn.apply(self, curryArgs);
	        }
	      : function() {
	          return arguments.length
	            ? fn.apply(self, arguments)
	            : fn.call(self);
	        };
	  } else {
	    // In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
	    return fn;
	  }
	}
	
	
	function toJsonReplacer(key, value) {
	  var val = value;
	
	  if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
	    val = undefined;
	  } else if (isWindow(value)) {
	    val = '$WINDOW';
	  } else if (value &&  window.document === value) {
	    val = '$DOCUMENT';
	  } else if (isScope(value)) {
	    val = '$SCOPE';
	  }
	
	  return val;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.toJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
	 * stripped since angular uses this notation internally.
	 *
	 * @param {Object|Array|Date|string|number|boolean} obj Input to be serialized into JSON.
	 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
	 *    If set to an integer, the JSON output will contain that many spaces per indentation.
	 * @returns {string|undefined} JSON-ified string representing `obj`.
	 * @knownIssue
	 *
	 * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
	 * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
	 * `Date.prototype.toJSON` method as follows:
	 *
	 * ```
	 * var _DatetoJSON = Date.prototype.toJSON;
	 * Date.prototype.toJSON = function() {
	 *   try {
	 *     return _DatetoJSON.call(this);
	 *   } catch(e) {
	 *     if (e instanceof RangeError) {
	 *       return null;
	 *     }
	 *     throw e;
	 *   }
	 * };
	 * ```
	 *
	 * See https://github.com/angular/angular.js/pull/14221 for more information.
	 */
	function toJson(obj, pretty) {
	  if (isUndefined(obj)) return undefined;
	  if (!isNumber(pretty)) {
	    pretty = pretty ? 2 : null;
	  }
	  return JSON.stringify(obj, toJsonReplacer, pretty);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.fromJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Deserializes a JSON string.
	 *
	 * @param {string} json JSON string to deserialize.
	 * @returns {Object|Array|string|number} Deserialized JSON string.
	 */
	function fromJson(json) {
	  return isString(json)
	      ? JSON.parse(json)
	      : json;
	}
	
	
	var ALL_COLONS = /:/g;
	function timezoneToOffset(timezone, fallback) {
	  // Support: IE 9-11 only, Edge 13-14+
	  // IE/Edge do not "understand" colon (`:`) in timezone
	  timezone = timezone.replace(ALL_COLONS, '');
	  var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
	  return isNumberNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
	}
	
	
	function addDateMinutes(date, minutes) {
	  date = new Date(date.getTime());
	  date.setMinutes(date.getMinutes() + minutes);
	  return date;
	}
	
	
	function convertTimezoneToLocal(date, timezone, reverse) {
	  reverse = reverse ? -1 : 1;
	  var dateTimezoneOffset = date.getTimezoneOffset();
	  var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	  return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
	}
	
	
	/**
	 * @returns {string} Returns the string representation of the element.
	 */
	function startingTag(element) {
	  element = jqLite(element).clone();
	  try {
	    // turns out IE does not let you set .html() on elements which
	    // are not allowed to have children. So we just ignore it.
	    element.empty();
	  } catch (e) { /* empty */ }
	  var elemHtml = jqLite('<div>').append(element).html();
	  try {
	    return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) :
	        elemHtml.
	          match(/^(<[^>]+>)/)[1].
	          replace(/^<([\w-]+)/, function(match, nodeName) {return '<' + lowercase(nodeName);});
	  } catch (e) {
	    return lowercase(elemHtml);
	  }
	
	}
	
	
	/////////////////////////////////////////////////
	
	/**
	 * Tries to decode the URI component without throwing an exception.
	 *
	 * @private
	 * @param str value potential URI component to check.
	 * @returns {boolean} True if `value` can be decoded
	 * with the decodeURIComponent function.
	 */
	function tryDecodeURIComponent(value) {
	  try {
	    return decodeURIComponent(value);
	  } catch (e) {
	    // Ignore any invalid uri component.
	  }
	}
	
	
	/**
	 * Parses an escaped url query string into key-value pairs.
	 * @returns {Object.<string,boolean|Array>}
	 */
	function parseKeyValue(/**string*/keyValue) {
	  var obj = {};
	  forEach((keyValue || '').split('&'), function(keyValue) {
	    var splitPoint, key, val;
	    if (keyValue) {
	      key = keyValue = keyValue.replace(/\+/g,'%20');
	      splitPoint = keyValue.indexOf('=');
	      if (splitPoint !== -1) {
	        key = keyValue.substring(0, splitPoint);
	        val = keyValue.substring(splitPoint + 1);
	      }
	      key = tryDecodeURIComponent(key);
	      if (isDefined(key)) {
	        val = isDefined(val) ? tryDecodeURIComponent(val) : true;
	        if (!hasOwnProperty.call(obj, key)) {
	          obj[key] = val;
	        } else if (isArray(obj[key])) {
	          obj[key].push(val);
	        } else {
	          obj[key] = [obj[key],val];
	        }
	      }
	    }
	  });
	  return obj;
	}
	
	function toKeyValue(obj) {
	  var parts = [];
	  forEach(obj, function(value, key) {
	    if (isArray(value)) {
	      forEach(value, function(arrayValue) {
	        parts.push(encodeUriQuery(key, true) +
	                   (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
	      });
	    } else {
	    parts.push(encodeUriQuery(key, true) +
	               (value === true ? '' : '=' + encodeUriQuery(value, true)));
	    }
	  });
	  return parts.length ? parts.join('&') : '';
	}
	
	
	/**
	 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
	 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
	 * segments:
	 *    segment       = *pchar
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriSegment(val) {
	  return encodeUriQuery(val, true).
	             replace(/%26/gi, '&').
	             replace(/%3D/gi, '=').
	             replace(/%2B/gi, '+');
	}
	
	
	/**
	 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
	 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
	 * encoded per http://tools.ietf.org/html/rfc3986:
	 *    query         = *( pchar / "/" / "?" )
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriQuery(val, pctEncodeSpaces) {
	  return encodeURIComponent(val).
	             replace(/%40/gi, '@').
	             replace(/%3A/gi, ':').
	             replace(/%24/g, '$').
	             replace(/%2C/gi, ',').
	             replace(/%3B/gi, ';').
	             replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
	}
	
	var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];
	
	function getNgAttribute(element, ngAttr) {
	  var attr, i, ii = ngAttrPrefixes.length;
	  for (i = 0; i < ii; ++i) {
	    attr = ngAttrPrefixes[i] + ngAttr;
	    if (isString(attr = element.getAttribute(attr))) {
	      return attr;
	    }
	  }
	  return null;
	}
	
	function allowAutoBootstrap(document) {
	  var script = document.currentScript;
	
	  if (!script) {
	    // IE does not have `document.currentScript`
	    return true;
	  }
	
	  // If the `currentScript` property has been clobbered just return false, since this indicates a probable attack
	  if (!(script instanceof window.HTMLScriptElement || script instanceof window.SVGScriptElement)) {
	    return false;
	  }
	
	  var attributes = script.attributes;
	  var srcs = [attributes.getNamedItem('src'), attributes.getNamedItem('href'), attributes.getNamedItem('xlink:href')];
	
	  return srcs.every(function(src) {
	    if (!src) {
	      return true;
	    }
	    if (!src.value) {
	      return false;
	    }
	
	    var link = document.createElement('a');
	    link.href = src.value;
	
	    if (document.location.origin === link.origin) {
	      // Same-origin resources are always allowed, even for non-whitelisted schemes.
	      return true;
	    }
	    // Disabled bootstrapping unless angular.js was loaded from a known scheme used on the web.
	    // This is to prevent angular.js bundled with browser extensions from being used to bypass the
	    // content security policy in web pages and other browser extensions.
	    switch (link.protocol) {
	      case 'http:':
	      case 'https:':
	      case 'ftp:':
	      case 'blob:':
	      case 'file:':
	      case 'data:':
	        return true;
	      default:
	        return false;
	    }
	  });
	}
	
	// Cached as it has to run during loading so that document.currentScript is available.
	var isAutoBootstrapAllowed = allowAutoBootstrap(window.document);
	
	/**
	 * @ngdoc directive
	 * @name ngApp
	 * @module ng
	 *
	 * @element ANY
	 * @param {angular.Module} ngApp an optional application
	 *   {@link angular.module module} name to load.
	 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
	 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
	 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
	 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
	 *   tracking down the root of these bugs.
	 *
	 * @description
	 *
	 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
	 * designates the **root element** of the application and is typically placed near the root element
	 * of the page - e.g. on the `<body>` or `<html>` tags.
	 *
	 * There are a few things to keep in mind when using `ngApp`:
	 * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
	 *   found in the document will be used to define the root element to auto-bootstrap as an
	 *   application. To run multiple applications in an HTML document you must manually bootstrap them using
	 *   {@link angular.bootstrap} instead.
	 * - AngularJS applications cannot be nested within each other.
	 * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
	 *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
	 *   {@link ngRoute.ngView `ngView`}.
	 *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 *   causing animations to stop working and making the injector inaccessible from outside the app.
	 *
	 * You can specify an **AngularJS module** to be used as the root module for the application.  This
	 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
	 * should contain the application code needed or have dependencies on other modules that will
	 * contain the code. See {@link angular.module} for more information.
	 *
	 * In the example below if the `ngApp` directive were not placed on the `html` element then the
	 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
	 * would not be resolved to `3`.
	 *
	 * `ngApp` is the easiest, and most common way to bootstrap an application.
	 *
	 <example module="ngAppDemo" name="ng-app">
	   <file name="index.html">
	   <div ng-controller="ngAppDemoController">
	     I can add: {{a}} + {{b}} =  {{ a+b }}
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
	     $scope.a = 1;
	     $scope.b = 2;
	   });
	   </file>
	 </example>
	 *
	 * Using `ngStrictDi`, you would see something like this:
	 *
	 <example ng-app-included="true" name="strict-di">
	   <file name="index.html">
	   <div ng-app="ngAppStrictDemo" ng-strict-di>
	       <div ng-controller="GoodController1">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style (see
	              script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="GoodController2">
	           Name: <input ng-model="name"><br />
	           Hello, {{name}}!
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style
	              (see script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="BadController">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>The controller could not be instantiated, due to relying
	              on automatic function annotations (which are disabled in
	              strict mode). As such, the content of this section is not
	              interpolated, and there should be an error in your web console.
	           </p>
	       </div>
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppStrictDemo', [])
	     // BadController will fail to instantiate, due to relying on automatic function annotation,
	     // rather than an explicit annotation
	     .controller('BadController', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     })
	     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
	     // due to using explicit annotations using the array style and $inject property, respectively.
	     .controller('GoodController1', ['$scope', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     }])
	     .controller('GoodController2', GoodController2);
	     function GoodController2($scope) {
	       $scope.name = 'World';
	     }
	     GoodController2.$inject = ['$scope'];
	   </file>
	   <file name="style.css">
	   div[ng-controller] {
	       margin-bottom: 1em;
	       -webkit-border-radius: 4px;
	       border-radius: 4px;
	       border: 1px solid;
	       padding: .5em;
	   }
	   div[ng-controller^=Good] {
	       border-color: #d6e9c6;
	       background-color: #dff0d8;
	       color: #3c763d;
	   }
	   div[ng-controller^=Bad] {
	       border-color: #ebccd1;
	       background-color: #f2dede;
	       color: #a94442;
	       margin-bottom: 0;
	   }
	   </file>
	 </example>
	 */
	function angularInit(element, bootstrap) {
	  var appElement,
	      module,
	      config = {};
	
	  // The element `element` has priority over any other element.
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	
	    if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
	      appElement = element;
	      module = element.getAttribute(name);
	    }
	  });
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	    var candidate;
	
	    if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
	      appElement = candidate;
	      module = candidate.getAttribute(name);
	    }
	  });
	  if (appElement) {
	    if (!isAutoBootstrapAllowed) {
	      window.console.error('Angular: disabling automatic bootstrap. <script> protocol indicates ' +
	          'an extension, document.location.href does not match.');
	      return;
	    }
	    config.strictDi = getNgAttribute(appElement, 'strict-di') !== null;
	    bootstrap(appElement, module ? [module] : [], config);
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.bootstrap
	 * @module ng
	 * @description
	 * Use this function to manually start up angular application.
	 *
	 * For more information, see the {@link guide/bootstrap Bootstrap guide}.
	 *
	 * Angular will detect if it has been loaded into the browser more than once and only allow the
	 * first loaded script to be bootstrapped and will report a warning to the browser console for
	 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
	 * multiple instances of Angular try to work on the DOM.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
	 * They must use {@link ng.directive:ngApp ngApp}.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
	 * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
	 * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 * causing animations to stop working and making the injector inaccessible from outside the app.
	 * </div>
	 *
	 * ```html
	 * <!doctype html>
	 * <html>
	 * <body>
	 * <div ng-controller="WelcomeController">
	 *   {{greeting}}
	 * </div>
	 *
	 * <script src="angular.js"></script>
	 * <script>
	 *   var app = angular.module('demo', [])
	 *   .controller('WelcomeController', function($scope) {
	 *       $scope.greeting = 'Welcome!';
	 *   });
	 *   angular.bootstrap(document, ['demo']);
	 * </script>
	 * </body>
	 * </html>
	 * ```
	 *
	 * @param {DOMElement} element DOM element which is the root of angular application.
	 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
	 *     Each item in the array should be the name of a predefined module or a (DI annotated)
	 *     function that will be invoked by the injector as a `config` block.
	 *     See: {@link angular.module modules}
	 * @param {Object=} config an object for defining configuration options for the application. The
	 *     following keys are supported:
	 *
	 * * `strictDi` - disable automatic function annotation for the application. This is meant to
	 *   assist in finding bugs which break minified code. Defaults to `false`.
	 *
	 * @returns {auto.$injector} Returns the newly created injector for this app.
	 */
	function bootstrap(element, modules, config) {
	  if (!isObject(config)) config = {};
	  var defaultConfig = {
	    strictDi: false
	  };
	  config = extend(defaultConfig, config);
	  var doBootstrap = function() {
	    element = jqLite(element);
	
	    if (element.injector()) {
	      var tag = (element[0] === window.document) ? 'document' : startingTag(element);
	      // Encode angle brackets to prevent input from being sanitized to empty string #8683.
	      throw ngMinErr(
	          'btstrpd',
	          'App already bootstrapped with this element \'{0}\'',
	          tag.replace(/</,'&lt;').replace(/>/,'&gt;'));
	    }
	
	    modules = modules || [];
	    modules.unshift(['$provide', function($provide) {
	      $provide.value('$rootElement', element);
	    }]);
	
	    if (config.debugInfoEnabled) {
	      // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
	      modules.push(['$compileProvider', function($compileProvider) {
	        $compileProvider.debugInfoEnabled(true);
	      }]);
	    }
	
	    modules.unshift('ng');
	    var injector = createInjector(modules, config.strictDi);
	    injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector',
	       function bootstrapApply(scope, element, compile, injector) {
	        scope.$apply(function() {
	          element.data('$injector', injector);
	          compile(element)(scope);
	        });
	      }]
	    );
	    return injector;
	  };
	
	  var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
	  var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;
	
	  if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
	    config.debugInfoEnabled = true;
	    window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
	  }
	
	  if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
	    return doBootstrap();
	  }
	
	  window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
	  angular.resumeBootstrap = function(extraModules) {
	    forEach(extraModules, function(module) {
	      modules.push(module);
	    });
	    return doBootstrap();
	  };
	
	  if (isFunction(angular.resumeDeferredBootstrap)) {
	    angular.resumeDeferredBootstrap();
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.reloadWithDebugInfo
	 * @module ng
	 * @description
	 * Use this function to reload the current application with debug information turned on.
	 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
	 *
	 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
	 */
	function reloadWithDebugInfo() {
	  window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
	  window.location.reload();
	}
	
	/**
	 * @name angular.getTestability
	 * @module ng
	 * @description
	 * Get the testability service for the instance of Angular on the given
	 * element.
	 * @param {DOMElement} element DOM element which is the root of angular application.
	 */
	function getTestability(rootElement) {
	  var injector = angular.element(rootElement).injector();
	  if (!injector) {
	    throw ngMinErr('test',
	      'no injector found for element argument to getTestability');
	  }
	  return injector.get('$$testability');
	}
	
	var SNAKE_CASE_REGEXP = /[A-Z]/g;
	function snake_case(name, separator) {
	  separator = separator || '_';
	  return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
	    return (pos ? separator : '') + letter.toLowerCase();
	  });
	}
	
	var bindJQueryFired = false;
	function bindJQuery() {
	  var originalCleanData;
	
	  if (bindJQueryFired) {
	    return;
	  }
	
	  // bind to jQuery if present;
	  var jqName = jq();
	  jQuery = isUndefined(jqName) ? window.jQuery :   // use jQuery (if present)
	           !jqName             ? undefined     :   // use jqLite
	                                 window[jqName];   // use jQuery specified by `ngJq`
	
	  // Use jQuery if it exists with proper functionality, otherwise default to us.
	  // Angular 1.2+ requires jQuery 1.7+ for on()/off() support.
	  // Angular 1.3+ technically requires at least jQuery 2.1+ but it may work with older
	  // versions. It will not work for sure with jQuery <1.7, though.
	  if (jQuery && jQuery.fn.on) {
	    jqLite = jQuery;
	    extend(jQuery.fn, {
	      scope: JQLitePrototype.scope,
	      isolateScope: JQLitePrototype.isolateScope,
	      controller: /** @type {?} */ (JQLitePrototype).controller,
	      injector: JQLitePrototype.injector,
	      inheritedData: JQLitePrototype.inheritedData
	    });
	
	    // All nodes removed from the DOM via various jQuery APIs like .remove()
	    // are passed through jQuery.cleanData. Monkey-patch this method to fire
	    // the $destroy event on all removed nodes.
	    originalCleanData = jQuery.cleanData;
	    jQuery.cleanData = function(elems) {
	      var events;
	      for (var i = 0, elem; (elem = elems[i]) != null; i++) {
	        events = jQuery._data(elem, 'events');
	        if (events && events.$destroy) {
	          jQuery(elem).triggerHandler('$destroy');
	        }
	      }
	      originalCleanData(elems);
	    };
	  } else {
	    jqLite = JQLite;
	  }
	
	  angular.element = jqLite;
	
	  // Prevent double-proxying.
	  bindJQueryFired = true;
	}
	
	/**
	 * throw error if the argument is falsy.
	 */
	function assertArg(arg, name, reason) {
	  if (!arg) {
	    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
	  }
	  return arg;
	}
	
	function assertArgFn(arg, name, acceptArrayAnnotation) {
	  if (acceptArrayAnnotation && isArray(arg)) {
	      arg = arg[arg.length - 1];
	  }
	
	  assertArg(isFunction(arg), name, 'not a function, got ' +
	      (arg && typeof arg === 'object' ? arg.constructor.name || 'Object' : typeof arg));
	  return arg;
	}
	
	/**
	 * throw error if the name given is hasOwnProperty
	 * @param  {String} name    the name to test
	 * @param  {String} context the context in which the name is used, such as module or directive
	 */
	function assertNotHasOwnProperty(name, context) {
	  if (name === 'hasOwnProperty') {
	    throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	  }
	}
	
	/**
	 * Return the value accessible from the object by path. Any undefined traversals are ignored
	 * @param {Object} obj starting object
	 * @param {String} path path to traverse
	 * @param {boolean} [bindFnToScope=true]
	 * @returns {Object} value as accessible by path
	 */
	//TODO(misko): this function needs to be removed
	function getter(obj, path, bindFnToScope) {
	  if (!path) return obj;
	  var keys = path.split('.');
	  var key;
	  var lastInstance = obj;
	  var len = keys.length;
	
	  for (var i = 0; i < len; i++) {
	    key = keys[i];
	    if (obj) {
	      obj = (lastInstance = obj)[key];
	    }
	  }
	  if (!bindFnToScope && isFunction(obj)) {
	    return bind(lastInstance, obj);
	  }
	  return obj;
	}
	
	/**
	 * Return the DOM siblings between the first and last node in the given array.
	 * @param {Array} array like object
	 * @returns {Array} the inputted object or a jqLite collection containing the nodes
	 */
	function getBlockNodes(nodes) {
	  // TODO(perf): update `nodes` instead of creating a new object?
	  var node = nodes[0];
	  var endNode = nodes[nodes.length - 1];
	  var blockNodes;
	
	  for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
	    if (blockNodes || nodes[i] !== node) {
	      if (!blockNodes) {
	        blockNodes = jqLite(slice.call(nodes, 0, i));
	      }
	      blockNodes.push(node);
	    }
	  }
	
	  return blockNodes || nodes;
	}
	
	
	/**
	 * Creates a new object without a prototype. This object is useful for lookup without having to
	 * guard against prototypically inherited properties via hasOwnProperty.
	 *
	 * Related micro-benchmarks:
	 * - http://jsperf.com/object-create2
	 * - http://jsperf.com/proto-map-lookup/2
	 * - http://jsperf.com/for-in-vs-object-keys2
	 *
	 * @returns {Object}
	 */
	function createMap() {
	  return Object.create(null);
	}
	
	function stringify(value) {
	  if (value == null) { // null || undefined
	    return '';
	  }
	  switch (typeof value) {
	    case 'string':
	      break;
	    case 'number':
	      value = '' + value;
	      break;
	    default:
	      if (hasCustomToString(value) && !isArray(value) && !isDate(value)) {
	        value = value.toString();
	      } else {
	        value = toJson(value);
	      }
	  }
	
	  return value;
	}
	
	var NODE_TYPE_ELEMENT = 1;
	var NODE_TYPE_ATTRIBUTE = 2;
	var NODE_TYPE_TEXT = 3;
	var NODE_TYPE_COMMENT = 8;
	var NODE_TYPE_DOCUMENT = 9;
	var NODE_TYPE_DOCUMENT_FRAGMENT = 11;
	
	/**
	 * @ngdoc type
	 * @name angular.Module
	 * @module ng
	 * @description
	 *
	 * Interface for configuring angular {@link angular.module modules}.
	 */
	
	function setupModuleLoader(window) {
	
	  var $injectorMinErr = minErr('$injector');
	  var ngMinErr = minErr('ng');
	
	  function ensure(obj, name, factory) {
	    return obj[name] || (obj[name] = factory());
	  }
	
	  var angular = ensure(window, 'angular', Object);
	
	  // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
	  angular.$$minErr = angular.$$minErr || minErr;
	
	  return ensure(angular, 'module', function() {
	    /** @type {Object.<string, angular.Module>} */
	    var modules = {};
	
	    /**
	     * @ngdoc function
	     * @name angular.module
	     * @module ng
	     * @description
	     *
	     * The `angular.module` is a global place for creating, registering and retrieving Angular
	     * modules.
	     * All modules (angular core or 3rd party) that should be available to an application must be
	     * registered using this mechanism.
	     *
	     * Passing one argument retrieves an existing {@link angular.Module},
	     * whereas passing more than one argument creates a new {@link angular.Module}
	     *
	     *
	     * # Module
	     *
	     * A module is a collection of services, directives, controllers, filters, and configuration information.
	     * `angular.module` is used to configure the {@link auto.$injector $injector}.
	     *
	     * ```js
	     * // Create a new module
	     * var myModule = angular.module('myModule', []);
	     *
	     * // register a new service
	     * myModule.value('appName', 'MyCoolApp');
	     *
	     * // configure existing services inside initialization blocks.
	     * myModule.config(['$locationProvider', function($locationProvider) {
	     *   // Configure existing providers
	     *   $locationProvider.hashPrefix('!');
	     * }]);
	     * ```
	     *
	     * Then you can create an injector and load your modules like this:
	     *
	     * ```js
	     * var injector = angular.injector(['ng', 'myModule'])
	     * ```
	     *
	     * However it's more likely that you'll just use
	     * {@link ng.directive:ngApp ngApp} or
	     * {@link angular.bootstrap} to simplify this process for you.
	     *
	     * @param {!string} name The name of the module to create or retrieve.
	     * @param {!Array.<string>=} requires If specified then new module is being created. If
	     *        unspecified then the module is being retrieved for further configuration.
	     * @param {Function=} configFn Optional configuration function for the module. Same as
	     *        {@link angular.Module#config Module#config()}.
	     * @returns {angular.Module} new module with the {@link angular.Module} api.
	     */
	    return function module(name, requires, configFn) {
	
	      var info = {};
	
	      var assertNotHasOwnProperty = function(name, context) {
	        if (name === 'hasOwnProperty') {
	          throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	        }
	      };
	
	      assertNotHasOwnProperty(name, 'module');
	      if (requires && modules.hasOwnProperty(name)) {
	        modules[name] = null;
	      }
	      return ensure(modules, name, function() {
	        if (!requires) {
	          throw $injectorMinErr('nomod', 'Module \'{0}\' is not available! You either misspelled ' +
	             'the module name or forgot to load it. If registering a module ensure that you ' +
	             'specify the dependencies as the second argument.', name);
	        }
	
	        /** @type {!Array.<Array.<*>>} */
	        var invokeQueue = [];
	
	        /** @type {!Array.<Function>} */
	        var configBlocks = [];
	
	        /** @type {!Array.<Function>} */
	        var runBlocks = [];
	
	        var config = invokeLater('$injector', 'invoke', 'push', configBlocks);
	
	        /** @type {angular.Module} */
	        var moduleInstance = {
	          // Private state
	          _invokeQueue: invokeQueue,
	          _configBlocks: configBlocks,
	          _runBlocks: runBlocks,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#info
	           * @module ng
	           *
	           * @param {Object=} info Information about the module
	           * @returns {Object|Module} The current info object for this module if called as a getter,
	           *                          or `this` if called as a setter.
	           *
	           * @description
	           * Read and write custom information about this module.
	           * For example you could put the version of the module in here.
	           *
	           * ```js
	           * angular.module('myModule', []).info({ version: '1.0.0' });
	           * ```
	           *
	           * The version could then be read back out by accessing the module elsewhere:
	           *
	           * ```
	           * var version = angular.module('myModule').info().version;
	           * ```
	           *
	           * You can also retrieve this information during runtime via the
	           * {@link $injector#modules `$injector.modules`} property:
	           *
	           * ```js
	           * var version = $injector.modules['myModule'].info().version;
	           * ```
	           */
	          info: function(value) {
	            if (isDefined(value)) {
	              if (!isObject(value)) throw ngMinErr('aobj', 'Argument \'{0}\' must be an object', 'value');
	              info = value;
	              return this;
	            }
	            return info;
	          },
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#requires
	           * @module ng
	           *
	           * @description
	           * Holds the list of modules which the injector will load before the current module is
	           * loaded.
	           */
	          requires: requires,
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#name
	           * @module ng
	           *
	           * @description
	           * Name of the module.
	           */
	          name: name,
	
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#provider
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerType Construction function for creating new instance of the
	           *                                service.
	           * @description
	           * See {@link auto.$provide#provider $provide.provider()}.
	           */
	          provider: invokeLaterAndSetModuleName('$provide', 'provider'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#factory
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerFunction Function for creating new instance of the service.
	           * @description
	           * See {@link auto.$provide#factory $provide.factory()}.
	           */
	          factory: invokeLaterAndSetModuleName('$provide', 'factory'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#service
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} constructor A constructor function that will be instantiated.
	           * @description
	           * See {@link auto.$provide#service $provide.service()}.
	           */
	          service: invokeLaterAndSetModuleName('$provide', 'service'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#value
	           * @module ng
	           * @param {string} name service name
	           * @param {*} object Service instance object.
	           * @description
	           * See {@link auto.$provide#value $provide.value()}.
	           */
	          value: invokeLater('$provide', 'value'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#constant
	           * @module ng
	           * @param {string} name constant name
	           * @param {*} object Constant value.
	           * @description
	           * Because the constants are fixed, they get applied before other provide methods.
	           * See {@link auto.$provide#constant $provide.constant()}.
	           */
	          constant: invokeLater('$provide', 'constant', 'unshift'),
	
	           /**
	           * @ngdoc method
	           * @name angular.Module#decorator
	           * @module ng
	           * @param {string} name The name of the service to decorate.
	           * @param {Function} decorFn This function will be invoked when the service needs to be
	           *                           instantiated and should return the decorated service instance.
	           * @description
	           * See {@link auto.$provide#decorator $provide.decorator()}.
	           */
	          decorator: invokeLaterAndSetModuleName('$provide', 'decorator', configBlocks),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#animation
	           * @module ng
	           * @param {string} name animation name
	           * @param {Function} animationFactory Factory function for creating new instance of an
	           *                                    animation.
	           * @description
	           *
	           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
	           *
	           *
	           * Defines an animation hook that can be later used with
	           * {@link $animate $animate} service and directives that use this service.
	           *
	           * ```js
	           * module.animation('.animation-name', function($inject1, $inject2) {
	           *   return {
	           *     eventName : function(element, done) {
	           *       //code to run the animation
	           *       //once complete, then run done()
	           *       return function cancellationFunction(element) {
	           *         //code to cancel the animation
	           *       }
	           *     }
	           *   }
	           * })
	           * ```
	           *
	           * See {@link ng.$animateProvider#register $animateProvider.register()} and
	           * {@link ngAnimate ngAnimate module} for more information.
	           */
	          animation: invokeLaterAndSetModuleName('$animateProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#filter
	           * @module ng
	           * @param {string} name Filter name - this must be a valid angular expression identifier
	           * @param {Function} filterFactory Factory function for creating new instance of filter.
	           * @description
	           * See {@link ng.$filterProvider#register $filterProvider.register()}.
	           *
	           * <div class="alert alert-warning">
	           * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	           * (`myapp_subsection_filterx`).
	           * </div>
	           */
	          filter: invokeLaterAndSetModuleName('$filterProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#controller
	           * @module ng
	           * @param {string|Object} name Controller name, or an object map of controllers where the
	           *    keys are the names and the values are the constructors.
	           * @param {Function} constructor Controller constructor function.
	           * @description
	           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
	           */
	          controller: invokeLaterAndSetModuleName('$controllerProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#directive
	           * @module ng
	           * @param {string|Object} name Directive name, or an object map of directives where the
	           *    keys are the names and the values are the factories.
	           * @param {Function} directiveFactory Factory function for creating new instance of
	           * directives.
	           * @description
	           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
	           */
	          directive: invokeLaterAndSetModuleName('$compileProvider', 'directive'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#component
	           * @module ng
	           * @param {string} name Name of the component in camel-case (i.e. myComp which will match as my-comp)
	           * @param {Object} options Component definition object (a simplified
	           *    {@link ng.$compile#directive-definition-object directive definition object})
	           *
	           * @description
	           * See {@link ng.$compileProvider#component $compileProvider.component()}.
	           */
	          component: invokeLaterAndSetModuleName('$compileProvider', 'component'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#config
	           * @module ng
	           * @param {Function} configFn Execute this function on module load. Useful for service
	           *    configuration.
	           * @description
	           * Use this method to register work which needs to be performed on module loading.
	           * For more about how to configure services, see
	           * {@link providers#provider-recipe Provider Recipe}.
	           */
	          config: config,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#run
	           * @module ng
	           * @param {Function} initializationFn Execute this function after injector creation.
	           *    Useful for application initialization.
	           * @description
	           * Use this method to register work which should be performed when the injector is done
	           * loading all modules.
	           */
	          run: function(block) {
	            runBlocks.push(block);
	            return this;
	          }
	        };
	
	        if (configFn) {
	          config(configFn);
	        }
	
	        return moduleInstance;
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @param {String=} insertMethod
	         * @returns {angular.Module}
	         */
	        function invokeLater(provider, method, insertMethod, queue) {
	          if (!queue) queue = invokeQueue;
	          return function() {
	            queue[insertMethod || 'push']([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @returns {angular.Module}
	         */
	        function invokeLaterAndSetModuleName(provider, method, queue) {
	          if (!queue) queue = invokeQueue;
	          return function(recipeName, factoryFunction) {
	            if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
	            queue.push([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	      });
	    };
	  });
	
	}
	
	/* global shallowCopy: true */
	
	/**
	 * Creates a shallow copy of an object, an array or a primitive.
	 *
	 * Assumes that there are no proto properties for objects.
	 */
	function shallowCopy(src, dst) {
	  if (isArray(src)) {
	    dst = dst || [];
	
	    for (var i = 0, ii = src.length; i < ii; i++) {
	      dst[i] = src[i];
	    }
	  } else if (isObject(src)) {
	    dst = dst || {};
	
	    for (var key in src) {
	      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	        dst[key] = src[key];
	      }
	    }
	  }
	
	  return dst || src;
	}
	
	/* global toDebugString: true */
	
	function serializeObject(obj, maxDepth) {
	  var seen = [];
	
	  // There is no direct way to stringify object until reaching a specific depth
	  // and a very deep object can cause a performance issue, so we copy the object
	  // based on this specific depth and then stringify it.
	  if (isValidObjectMaxDepth(maxDepth)) {
	    obj = copy(obj, null, maxDepth);
	  }
	  return JSON.stringify(obj, function(key, val) {
	    val = toJsonReplacer(key, val);
	    if (isObject(val)) {
	
	      if (seen.indexOf(val) >= 0) return '...';
	
	      seen.push(val);
	    }
	    return val;
	  });
	}
	
	function toDebugString(obj, maxDepth) {
	  if (typeof obj === 'function') {
	    return obj.toString().replace(/ \{[\s\S]*$/, '');
	  } else if (isUndefined(obj)) {
	    return 'undefined';
	  } else if (typeof obj !== 'string') {
	    return serializeObject(obj, maxDepth);
	  }
	  return obj;
	}
	
	/* global angularModule: true,
	  version: true,
	
	  $CompileProvider,
	
	  htmlAnchorDirective,
	  inputDirective,
	  inputDirective,
	  formDirective,
	  scriptDirective,
	  selectDirective,
	  optionDirective,
	  ngBindDirective,
	  ngBindHtmlDirective,
	  ngBindTemplateDirective,
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective,
	  ngCloakDirective,
	  ngControllerDirective,
	  ngFormDirective,
	  ngHideDirective,
	  ngIfDirective,
	  ngIncludeDirective,
	  ngIncludeFillContentDirective,
	  ngInitDirective,
	  ngNonBindableDirective,
	  ngPluralizeDirective,
	  ngRepeatDirective,
	  ngShowDirective,
	  ngStyleDirective,
	  ngSwitchDirective,
	  ngSwitchWhenDirective,
	  ngSwitchDefaultDirective,
	  ngOptionsDirective,
	  ngTranscludeDirective,
	  ngModelDirective,
	  ngListDirective,
	  ngChangeDirective,
	  patternDirective,
	  patternDirective,
	  requiredDirective,
	  requiredDirective,
	  minlengthDirective,
	  minlengthDirective,
	  maxlengthDirective,
	  maxlengthDirective,
	  ngValueDirective,
	  ngModelOptionsDirective,
	  ngAttributeAliasDirectives,
	  ngEventDirectives,
	
	  $AnchorScrollProvider,
	  $AnimateProvider,
	  $CoreAnimateCssProvider,
	  $$CoreAnimateJsProvider,
	  $$CoreAnimateQueueProvider,
	  $$AnimateRunnerFactoryProvider,
	  $$AnimateAsyncRunFactoryProvider,
	  $BrowserProvider,
	  $CacheFactoryProvider,
	  $ControllerProvider,
	  $DateProvider,
	  $DocumentProvider,
	  $$IsDocumentHiddenProvider,
	  $ExceptionHandlerProvider,
	  $FilterProvider,
	  $$ForceReflowProvider,
	  $InterpolateProvider,
	  $IntervalProvider,
	  $HttpProvider,
	  $HttpParamSerializerProvider,
	  $HttpParamSerializerJQLikeProvider,
	  $HttpBackendProvider,
	  $xhrFactoryProvider,
	  $jsonpCallbacksProvider,
	  $LocationProvider,
	  $LogProvider,
	  $$MapProvider,
	  $ParseProvider,
	  $RootScopeProvider,
	  $QProvider,
	  $$QProvider,
	  $$SanitizeUriProvider,
	  $SceProvider,
	  $SceDelegateProvider,
	  $SnifferProvider,
	  $TemplateCacheProvider,
	  $TemplateRequestProvider,
	  $$TestabilityProvider,
	  $TimeoutProvider,
	  $$RAFProvider,
	  $WindowProvider,
	  $$jqLiteProvider,
	  $$CookieReaderProvider
	*/
	
	
	/**
	 * @ngdoc object
	 * @name angular.version
	 * @module ng
	 * @description
	 * An object that contains information about the current AngularJS version.
	 *
	 * This object has the following properties:
	 *
	 * - `full` – `{string}` – Full version string, such as "0.9.18".
	 * - `major` – `{number}` – Major version number, such as "0".
	 * - `minor` – `{number}` – Minor version number, such as "9".
	 * - `dot` – `{number}` – Dot version number, such as "18".
	 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
	 */
	var version = {
	  // These placeholder strings will be replaced by grunt's `build` task.
	  // They need to be double- or single-quoted.
	  full: '1.6.4',
	  major: 1,
	  minor: 6,
	  dot: 4,
	  codeName: 'phenomenal-footnote'
	};
	
	
	function publishExternalAPI(angular) {
	  extend(angular, {
	    'errorHandlingConfig': errorHandlingConfig,
	    'bootstrap': bootstrap,
	    'copy': copy,
	    'extend': extend,
	    'merge': merge,
	    'equals': equals,
	    'element': jqLite,
	    'forEach': forEach,
	    'injector': createInjector,
	    'noop': noop,
	    'bind': bind,
	    'toJson': toJson,
	    'fromJson': fromJson,
	    'identity': identity,
	    'isUndefined': isUndefined,
	    'isDefined': isDefined,
	    'isString': isString,
	    'isFunction': isFunction,
	    'isObject': isObject,
	    'isNumber': isNumber,
	    'isElement': isElement,
	    'isArray': isArray,
	    'version': version,
	    'isDate': isDate,
	    'lowercase': lowercase,
	    'uppercase': uppercase,
	    'callbacks': {$$counter: 0},
	    'getTestability': getTestability,
	    'reloadWithDebugInfo': reloadWithDebugInfo,
	    '$$minErr': minErr,
	    '$$csp': csp,
	    '$$encodeUriSegment': encodeUriSegment,
	    '$$encodeUriQuery': encodeUriQuery,
	    '$$stringify': stringify
	  });
	
	  angularModule = setupModuleLoader(window);
	
	  angularModule('ng', ['ngLocale'], ['$provide',
	    function ngModule($provide) {
	      // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
	      $provide.provider({
	        $$sanitizeUri: $$SanitizeUriProvider
	      });
	      $provide.provider('$compile', $CompileProvider).
	        directive({
	            a: htmlAnchorDirective,
	            input: inputDirective,
	            textarea: inputDirective,
	            form: formDirective,
	            script: scriptDirective,
	            select: selectDirective,
	            option: optionDirective,
	            ngBind: ngBindDirective,
	            ngBindHtml: ngBindHtmlDirective,
	            ngBindTemplate: ngBindTemplateDirective,
	            ngClass: ngClassDirective,
	            ngClassEven: ngClassEvenDirective,
	            ngClassOdd: ngClassOddDirective,
	            ngCloak: ngCloakDirective,
	            ngController: ngControllerDirective,
	            ngForm: ngFormDirective,
	            ngHide: ngHideDirective,
	            ngIf: ngIfDirective,
	            ngInclude: ngIncludeDirective,
	            ngInit: ngInitDirective,
	            ngNonBindable: ngNonBindableDirective,
	            ngPluralize: ngPluralizeDirective,
	            ngRepeat: ngRepeatDirective,
	            ngShow: ngShowDirective,
	            ngStyle: ngStyleDirective,
	            ngSwitch: ngSwitchDirective,
	            ngSwitchWhen: ngSwitchWhenDirective,
	            ngSwitchDefault: ngSwitchDefaultDirective,
	            ngOptions: ngOptionsDirective,
	            ngTransclude: ngTranscludeDirective,
	            ngModel: ngModelDirective,
	            ngList: ngListDirective,
	            ngChange: ngChangeDirective,
	            pattern: patternDirective,
	            ngPattern: patternDirective,
	            required: requiredDirective,
	            ngRequired: requiredDirective,
	            minlength: minlengthDirective,
	            ngMinlength: minlengthDirective,
	            maxlength: maxlengthDirective,
	            ngMaxlength: maxlengthDirective,
	            ngValue: ngValueDirective,
	            ngModelOptions: ngModelOptionsDirective
	        }).
	        directive({
	          ngInclude: ngIncludeFillContentDirective
	        }).
	        directive(ngAttributeAliasDirectives).
	        directive(ngEventDirectives);
	      $provide.provider({
	        $anchorScroll: $AnchorScrollProvider,
	        $animate: $AnimateProvider,
	        $animateCss: $CoreAnimateCssProvider,
	        $$animateJs: $$CoreAnimateJsProvider,
	        $$animateQueue: $$CoreAnimateQueueProvider,
	        $$AnimateRunner: $$AnimateRunnerFactoryProvider,
	        $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
	        $browser: $BrowserProvider,
	        $cacheFactory: $CacheFactoryProvider,
	        $controller: $ControllerProvider,
	        $document: $DocumentProvider,
	        $$isDocumentHidden: $$IsDocumentHiddenProvider,
	        $exceptionHandler: $ExceptionHandlerProvider,
	        $filter: $FilterProvider,
	        $$forceReflow: $$ForceReflowProvider,
	        $interpolate: $InterpolateProvider,
	        $interval: $IntervalProvider,
	        $http: $HttpProvider,
	        $httpParamSerializer: $HttpParamSerializerProvider,
	        $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
	        $httpBackend: $HttpBackendProvider,
	        $xhrFactory: $xhrFactoryProvider,
	        $jsonpCallbacks: $jsonpCallbacksProvider,
	        $location: $LocationProvider,
	        $log: $LogProvider,
	        $parse: $ParseProvider,
	        $rootScope: $RootScopeProvider,
	        $q: $QProvider,
	        $$q: $$QProvider,
	        $sce: $SceProvider,
	        $sceDelegate: $SceDelegateProvider,
	        $sniffer: $SnifferProvider,
	        $templateCache: $TemplateCacheProvider,
	        $templateRequest: $TemplateRequestProvider,
	        $$testability: $$TestabilityProvider,
	        $timeout: $TimeoutProvider,
	        $window: $WindowProvider,
	        $$rAF: $$RAFProvider,
	        $$jqLite: $$jqLiteProvider,
	        $$Map: $$MapProvider,
	        $$cookieReader: $$CookieReaderProvider
	      });
	    }
	  ])
	  .info({ angularVersion: '1.6.4' });
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* global
	  JQLitePrototype: true,
	  BOOLEAN_ATTR: true,
	  ALIASED_ATTR: true
	*/
	
	//////////////////////////////////
	//JQLite
	//////////////////////////////////
	
	/**
	 * @ngdoc function
	 * @name angular.element
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
	 *
	 * If jQuery is available, `angular.element` is an alias for the
	 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
	 * delegates to Angular's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
	 *
	 * jqLite is a tiny, API-compatible subset of jQuery that allows
	 * Angular to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
	 * commonly needed functionality with the goal of having a very small footprint.
	 *
	 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
	 * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
	 * specific version of jQuery if multiple versions exist on the page.
	 *
	 * <div class="alert alert-info">**Note:** All element references in Angular are always wrapped with jQuery or
	 * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
	 *
	 * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
	 * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
	 * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
	 *
	 * ## Angular's jqLite
	 * jqLite provides only the following jQuery methods:
	 *
	 * - [`addClass()`](http://api.jquery.com/addClass/) - Does not support a function as first argument
	 * - [`after()`](http://api.jquery.com/after/)
	 * - [`append()`](http://api.jquery.com/append/)
	 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
	 * - [`bind()`](http://api.jquery.com/bind/) (_deprecated_, use [`on()`](http://api.jquery.com/on/)) - Does not support namespaces, selectors or eventData
	 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
	 * - [`clone()`](http://api.jquery.com/clone/)
	 * - [`contents()`](http://api.jquery.com/contents/)
	 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
	 *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
	 * - [`data()`](http://api.jquery.com/data/)
	 * - [`detach()`](http://api.jquery.com/detach/)
	 * - [`empty()`](http://api.jquery.com/empty/)
	 * - [`eq()`](http://api.jquery.com/eq/)
	 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
	 * - [`hasClass()`](http://api.jquery.com/hasClass/)
	 * - [`html()`](http://api.jquery.com/html/)
	 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
	 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
	 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
	 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
	 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
	 * - [`prepend()`](http://api.jquery.com/prepend/)
	 * - [`prop()`](http://api.jquery.com/prop/)
	 * - [`ready()`](http://api.jquery.com/ready/) (_deprecated_, use `angular.element(callback)` instead of `angular.element(document).ready(callback)`)
	 * - [`remove()`](http://api.jquery.com/remove/)
	 * - [`removeAttr()`](http://api.jquery.com/removeAttr/) - Does not support multiple attributes
	 * - [`removeClass()`](http://api.jquery.com/removeClass/) - Does not support a function as first argument
	 * - [`removeData()`](http://api.jquery.com/removeData/)
	 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
	 * - [`text()`](http://api.jquery.com/text/)
	 * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
	 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
	 * - [`unbind()`](http://api.jquery.com/unbind/) (_deprecated_, use [`off()`](http://api.jquery.com/off/)) - Does not support namespaces or event object as parameter
	 * - [`val()`](http://api.jquery.com/val/)
	 * - [`wrap()`](http://api.jquery.com/wrap/)
	 *
	 * ## jQuery/jqLite Extras
	 * Angular also provides the following additional methods and events to both jQuery and jqLite:
	 *
	 * ### Events
	 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
	 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
	 *    element before it is removed.
	 *
	 * ### Methods
	 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
	 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
	 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
	 *   `'ngModel'`).
	 * - `injector()` - retrieves the injector of the current element or its parent.
	 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
	 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
	 *   be enabled.
	 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
	 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
	 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
	 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
	 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
	 *   parent element is reached.
	 *
	 * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
	 * https://github.com/angular/angular.js/issues/14251 for more information.
	 *
	 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
	 * @returns {Object} jQuery object.
	 */
	
	JQLite.expando = 'ng339';
	
	var jqCache = JQLite.cache = {},
	    jqId = 1;
	
	/*
	 * !!! This is an undocumented "private" function !!!
	 */
	JQLite._data = function(node) {
	  //jQuery always returns an object on cache miss
	  return this.cache[node[this.expando]] || {};
	};
	
	function jqNextId() { return ++jqId; }
	
	
	var DASH_LOWERCASE_REGEXP = /-([a-z])/g;
	var MS_HACK_REGEXP = /^-ms-/;
	var MOUSE_EVENT_MAP = { mouseleave: 'mouseout', mouseenter: 'mouseover' };
	var jqLiteMinErr = minErr('jqLite');
	
	/**
	 * Converts kebab-case to camelCase.
	 * There is also a special case for the ms prefix starting with a lowercase letter.
	 * @param name Name to normalize
	 */
	function cssKebabToCamel(name) {
	    return kebabToCamel(name.replace(MS_HACK_REGEXP, 'ms-'));
	}
	
	function fnCamelCaseReplace(all, letter) {
	  return letter.toUpperCase();
	}
	
	/**
	 * Converts kebab-case to camelCase.
	 * @param name Name to normalize
	 */
	function kebabToCamel(name) {
	  return name
	    .replace(DASH_LOWERCASE_REGEXP, fnCamelCaseReplace);
	}
	
	var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
	var HTML_REGEXP = /<|&#?\w+;/;
	var TAG_NAME_REGEXP = /<([\w:-]+)/;
	var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;
	
	var wrapMap = {
	  'option': [1, '<select multiple="multiple">', '</select>'],
	
	  'thead': [1, '<table>', '</table>'],
	  'col': [2, '<table><colgroup>', '</colgroup></table>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	  'td': [3, '<table><tbody><tr>', '</tr></tbody></table>'],
	  '_default': [0, '', '']
	};
	
	wrapMap.optgroup = wrapMap.option;
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function jqLiteIsTextNode(html) {
	  return !HTML_REGEXP.test(html);
	}
	
	function jqLiteAcceptsData(node) {
	  // The window object can accept data but has no nodeType
	  // Otherwise we are only interested in elements (1) and documents (9)
	  var nodeType = node.nodeType;
	  return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
	}
	
	function jqLiteHasData(node) {
	  for (var key in jqCache[node.ng339]) {
	    return true;
	  }
	  return false;
	}
	
	function jqLiteBuildFragment(html, context) {
	  var tmp, tag, wrap,
	      fragment = context.createDocumentFragment(),
	      nodes = [], i;
	
	  if (jqLiteIsTextNode(html)) {
	    // Convert non-html into a text node
	    nodes.push(context.createTextNode(html));
	  } else {
	    // Convert html into DOM nodes
	    tmp = fragment.appendChild(context.createElement('div'));
	    tag = (TAG_NAME_REGEXP.exec(html) || ['', ''])[1].toLowerCase();
	    wrap = wrapMap[tag] || wrapMap._default;
	    tmp.innerHTML = wrap[1] + html.replace(XHTML_TAG_REGEXP, '<$1></$2>') + wrap[2];
	
	    // Descend through wrappers to the right content
	    i = wrap[0];
	    while (i--) {
	      tmp = tmp.lastChild;
	    }
	
	    nodes = concat(nodes, tmp.childNodes);
	
	    tmp = fragment.firstChild;
	    tmp.textContent = '';
	  }
	
	  // Remove wrapper from fragment
	  fragment.textContent = '';
	  fragment.innerHTML = ''; // Clear inner HTML
	  forEach(nodes, function(node) {
	    fragment.appendChild(node);
	  });
	
	  return fragment;
	}
	
	function jqLiteParseHTML(html, context) {
	  context = context || window.document;
	  var parsed;
	
	  if ((parsed = SINGLE_TAG_REGEXP.exec(html))) {
	    return [context.createElement(parsed[1])];
	  }
	
	  if ((parsed = jqLiteBuildFragment(html, context))) {
	    return parsed.childNodes;
	  }
	
	  return [];
	}
	
	function jqLiteWrapNode(node, wrapper) {
	  var parent = node.parentNode;
	
	  if (parent) {
	    parent.replaceChild(wrapper, node);
	  }
	
	  wrapper.appendChild(node);
	}
	
	
	// IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
	var jqLiteContains = window.Node.prototype.contains || /** @this */ function(arg) {
	  // eslint-disable-next-line no-bitwise
	  return !!(this.compareDocumentPosition(arg) & 16);
	};
	
	/////////////////////////////////////////////
	function JQLite(element) {
	  if (element instanceof JQLite) {
	    return element;
	  }
	
	  var argIsString;
	
	  if (isString(element)) {
	    element = trim(element);
	    argIsString = true;
	  }
	  if (!(this instanceof JQLite)) {
	    if (argIsString && element.charAt(0) !== '<') {
	      throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
	    }
	    return new JQLite(element);
	  }
	
	  if (argIsString) {
	    jqLiteAddNodes(this, jqLiteParseHTML(element));
	  } else if (isFunction(element)) {
	    jqLiteReady(element);
	  } else {
	    jqLiteAddNodes(this, element);
	  }
	}
	
	function jqLiteClone(element) {
	  return element.cloneNode(true);
	}
	
	function jqLiteDealoc(element, onlyDescendants) {
	  if (!onlyDescendants && jqLiteAcceptsData(element)) jqLite.cleanData([element]);
	
	  if (element.querySelectorAll) {
	    jqLite.cleanData(element.querySelectorAll('*'));
	  }
	}
	
	function jqLiteOff(element, type, fn, unsupported) {
	  if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');
	
	  var expandoStore = jqLiteExpandoStore(element);
	  var events = expandoStore && expandoStore.events;
	  var handle = expandoStore && expandoStore.handle;
	
	  if (!handle) return; //no listeners registered
	
	  if (!type) {
	    for (type in events) {
	      if (type !== '$destroy') {
	        element.removeEventListener(type, handle);
	      }
	      delete events[type];
	    }
	  } else {
	
	    var removeHandler = function(type) {
	      var listenerFns = events[type];
	      if (isDefined(fn)) {
	        arrayRemove(listenerFns || [], fn);
	      }
	      if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
	        element.removeEventListener(type, handle);
	        delete events[type];
	      }
	    };
	
	    forEach(type.split(' '), function(type) {
	      removeHandler(type);
	      if (MOUSE_EVENT_MAP[type]) {
	        removeHandler(MOUSE_EVENT_MAP[type]);
	      }
	    });
	  }
	}
	
	function jqLiteRemoveData(element, name) {
	  var expandoId = element.ng339;
	  var expandoStore = expandoId && jqCache[expandoId];
	
	  if (expandoStore) {
	    if (name) {
	      delete expandoStore.data[name];
	      return;
	    }
	
	    if (expandoStore.handle) {
	      if (expandoStore.events.$destroy) {
	        expandoStore.handle({}, '$destroy');
	      }
	      jqLiteOff(element);
	    }
	    delete jqCache[expandoId];
	    element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
	  }
	}
	
	
	function jqLiteExpandoStore(element, createIfNecessary) {
	  var expandoId = element.ng339,
	      expandoStore = expandoId && jqCache[expandoId];
	
	  if (createIfNecessary && !expandoStore) {
	    element.ng339 = expandoId = jqNextId();
	    expandoStore = jqCache[expandoId] = {events: {}, data: {}, handle: undefined};
	  }
	
	  return expandoStore;
	}
	
	
	function jqLiteData(element, key, value) {
	  if (jqLiteAcceptsData(element)) {
	    var prop;
	
	    var isSimpleSetter = isDefined(value);
	    var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
	    var massGetter = !key;
	    var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
	    var data = expandoStore && expandoStore.data;
	
	    if (isSimpleSetter) { // data('key', value)
	      data[kebabToCamel(key)] = value;
	    } else {
	      if (massGetter) {  // data()
	        return data;
	      } else {
	        if (isSimpleGetter) { // data('key')
	          // don't force creation of expandoStore if it doesn't exist yet
	          return data && data[kebabToCamel(key)];
	        } else { // mass-setter: data({key1: val1, key2: val2})
	          for (prop in key) {
	            data[kebabToCamel(prop)] = key[prop];
	          }
	        }
	      }
	    }
	  }
	}
	
	function jqLiteHasClass(element, selector) {
	  if (!element.getAttribute) return false;
	  return ((' ' + (element.getAttribute('class') || '') + ' ').replace(/[\n\t]/g, ' ').
	      indexOf(' ' + selector + ' ') > -1);
	}
	
	function jqLiteRemoveClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    forEach(cssClasses.split(' '), function(cssClass) {
	      element.setAttribute('class', trim(
	          (' ' + (element.getAttribute('class') || '') + ' ')
	          .replace(/[\n\t]/g, ' ')
	          .replace(' ' + trim(cssClass) + ' ', ' '))
	      );
	    });
	  }
	}
	
	function jqLiteAddClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
	                            .replace(/[\n\t]/g, ' ');
	
	    forEach(cssClasses.split(' '), function(cssClass) {
	      cssClass = trim(cssClass);
	      if (existingClasses.indexOf(' ' + cssClass + ' ') === -1) {
	        existingClasses += cssClass + ' ';
	      }
	    });
	
	    element.setAttribute('class', trim(existingClasses));
	  }
	}
	
	
	function jqLiteAddNodes(root, elements) {
	  // THIS CODE IS VERY HOT. Don't make changes without benchmarking.
	
	  if (elements) {
	
	    // if a Node (the most common case)
	    if (elements.nodeType) {
	      root[root.length++] = elements;
	    } else {
	      var length = elements.length;
	
	      // if an Array or NodeList and not a Window
	      if (typeof length === 'number' && elements.window !== elements) {
	        if (length) {
	          for (var i = 0; i < length; i++) {
	            root[root.length++] = elements[i];
	          }
	        }
	      } else {
	        root[root.length++] = elements;
	      }
	    }
	  }
	}
	
	
	function jqLiteController(element, name) {
	  return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
	}
	
	function jqLiteInheritedData(element, name, value) {
	  // if element is the document object work with the html element instead
	  // this makes $(document).scope() possible
	  if (element.nodeType === NODE_TYPE_DOCUMENT) {
	    element = element.documentElement;
	  }
	  var names = isArray(name) ? name : [name];
	
	  while (element) {
	    for (var i = 0, ii = names.length; i < ii; i++) {
	      if (isDefined(value = jqLite.data(element, names[i]))) return value;
	    }
	
	    // If dealing with a document fragment node with a host element, and no parent, use the host
	    // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
	    // to lookup parent controllers.
	    element = element.parentNode || (element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host);
	  }
	}
	
	function jqLiteEmpty(element) {
	  jqLiteDealoc(element, true);
	  while (element.firstChild) {
	    element.removeChild(element.firstChild);
	  }
	}
	
	function jqLiteRemove(element, keepData) {
	  if (!keepData) jqLiteDealoc(element);
	  var parent = element.parentNode;
	  if (parent) parent.removeChild(element);
	}
	
	
	function jqLiteDocumentLoaded(action, win) {
	  win = win || window;
	  if (win.document.readyState === 'complete') {
	    // Force the action to be run async for consistent behavior
	    // from the action's point of view
	    // i.e. it will definitely not be in a $apply
	    win.setTimeout(action);
	  } else {
	    // No need to unbind this handler as load is only ever called once
	    jqLite(win).on('load', action);
	  }
	}
	
	function jqLiteReady(fn) {
	  function trigger() {
	    window.document.removeEventListener('DOMContentLoaded', trigger);
	    window.removeEventListener('load', trigger);
	    fn();
	  }
	
	  // check if document is already loaded
	  if (window.document.readyState === 'complete') {
	    window.setTimeout(fn);
	  } else {
	    // We can not use jqLite since we are not done loading and jQuery could be loaded later.
	
	    // Works for modern browsers and IE9
	    window.document.addEventListener('DOMContentLoaded', trigger);
	
	    // Fallback to window.onload for others
	    window.addEventListener('load', trigger);
	  }
	}
	
	//////////////////////////////////////////
	// Functions which are declared directly.
	//////////////////////////////////////////
	var JQLitePrototype = JQLite.prototype = {
	  ready: jqLiteReady,
	  toString: function() {
	    var value = [];
	    forEach(this, function(e) { value.push('' + e);});
	    return '[' + value.join(', ') + ']';
	  },
	
	  eq: function(index) {
	      return (index >= 0) ? jqLite(this[index]) : jqLite(this[this.length + index]);
	  },
	
	  length: 0,
	  push: push,
	  sort: [].sort,
	  splice: [].splice
	};
	
	//////////////////////////////////////////
	// Functions iterating getter/setters.
	// these functions return self on setter and
	// value on get.
	//////////////////////////////////////////
	var BOOLEAN_ATTR = {};
	forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function(value) {
	  BOOLEAN_ATTR[lowercase(value)] = value;
	});
	var BOOLEAN_ELEMENTS = {};
	forEach('input,select,option,textarea,button,form,details'.split(','), function(value) {
	  BOOLEAN_ELEMENTS[value] = true;
	});
	var ALIASED_ATTR = {
	  'ngMinlength': 'minlength',
	  'ngMaxlength': 'maxlength',
	  'ngMin': 'min',
	  'ngMax': 'max',
	  'ngPattern': 'pattern',
	  'ngStep': 'step'
	};
	
	function getBooleanAttrName(element, name) {
	  // check dom last since we will most likely fail on name
	  var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];
	
	  // booleanAttr is here twice to minimize DOM access
	  return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
	}
	
	function getAliasedAttrName(name) {
	  return ALIASED_ATTR[name];
	}
	
	forEach({
	  data: jqLiteData,
	  removeData: jqLiteRemoveData,
	  hasData: jqLiteHasData,
	  cleanData: function jqLiteCleanData(nodes) {
	    for (var i = 0, ii = nodes.length; i < ii; i++) {
	      jqLiteRemoveData(nodes[i]);
	    }
	  }
	}, function(fn, name) {
	  JQLite[name] = fn;
	});
	
	forEach({
	  data: jqLiteData,
	  inheritedData: jqLiteInheritedData,
	
	  scope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
	  },
	
	  isolateScope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
	  },
	
	  controller: jqLiteController,
	
	  injector: function(element) {
	    return jqLiteInheritedData(element, '$injector');
	  },
	
	  removeAttr: function(element, name) {
	    element.removeAttribute(name);
	  },
	
	  hasClass: jqLiteHasClass,
	
	  css: function(element, name, value) {
	    name = cssKebabToCamel(name);
	
	    if (isDefined(value)) {
	      element.style[name] = value;
	    } else {
	      return element.style[name];
	    }
	  },
	
	  attr: function(element, name, value) {
	    var ret;
	    var nodeType = element.nodeType;
	    if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT ||
	      !element.getAttribute) {
	      return;
	    }
	
	    var lowercasedName = lowercase(name);
	    var isBooleanAttr = BOOLEAN_ATTR[lowercasedName];
	
	    if (isDefined(value)) {
	      // setter
	
	      if (value === null || (value === false && isBooleanAttr)) {
	        element.removeAttribute(name);
	      } else {
	        element.setAttribute(name, isBooleanAttr ? lowercasedName : value);
	      }
	    } else {
	      // getter
	
	      ret = element.getAttribute(name);
	
	      if (isBooleanAttr && ret !== null) {
	        ret = lowercasedName;
	      }
	      // Normalize non-existing attributes to undefined (as jQuery).
	      return ret === null ? undefined : ret;
	    }
	  },
	
	  prop: function(element, name, value) {
	    if (isDefined(value)) {
	      element[name] = value;
	    } else {
	      return element[name];
	    }
	  },
	
	  text: (function() {
	    getText.$dv = '';
	    return getText;
	
	    function getText(element, value) {
	      if (isUndefined(value)) {
	        var nodeType = element.nodeType;
	        return (nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT) ? element.textContent : '';
	      }
	      element.textContent = value;
	    }
	  })(),
	
	  val: function(element, value) {
	    if (isUndefined(value)) {
	      if (element.multiple && nodeName_(element) === 'select') {
	        var result = [];
	        forEach(element.options, function(option) {
	          if (option.selected) {
	            result.push(option.value || option.text);
	          }
	        });
	        return result;
	      }
	      return element.value;
	    }
	    element.value = value;
	  },
	
	  html: function(element, value) {
	    if (isUndefined(value)) {
	      return element.innerHTML;
	    }
	    jqLiteDealoc(element, true);
	    element.innerHTML = value;
	  },
	
	  empty: jqLiteEmpty
	}, function(fn, name) {
	  /**
	   * Properties: writes return selection, reads return first value
	   */
	  JQLite.prototype[name] = function(arg1, arg2) {
	    var i, key;
	    var nodeCount = this.length;
	
	    // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
	    // in a way that survives minification.
	    // jqLiteEmpty takes no arguments but is a setter.
	    if (fn !== jqLiteEmpty &&
	        (isUndefined((fn.length === 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)) ? arg1 : arg2))) {
	      if (isObject(arg1)) {
	
	        // we are a write, but the object properties are the key/values
	        for (i = 0; i < nodeCount; i++) {
	          if (fn === jqLiteData) {
	            // data() takes the whole object in jQuery
	            fn(this[i], arg1);
	          } else {
	            for (key in arg1) {
	              fn(this[i], key, arg1[key]);
	            }
	          }
	        }
	        // return self for chaining
	        return this;
	      } else {
	        // we are a read, so read the first child.
	        // TODO: do we still need this?
	        var value = fn.$dv;
	        // Only if we have $dv do we iterate over all, otherwise it is just the first element.
	        var jj = (isUndefined(value)) ? Math.min(nodeCount, 1) : nodeCount;
	        for (var j = 0; j < jj; j++) {
	          var nodeValue = fn(this[j], arg1, arg2);
	          value = value ? value + nodeValue : nodeValue;
	        }
	        return value;
	      }
	    } else {
	      // we are a write, so apply to all children
	      for (i = 0; i < nodeCount; i++) {
	        fn(this[i], arg1, arg2);
	      }
	      // return self for chaining
	      return this;
	    }
	  };
	});
	
	function createEventHandler(element, events) {
	  var eventHandler = function(event, type) {
	    // jQuery specific api
	    event.isDefaultPrevented = function() {
	      return event.defaultPrevented;
	    };
	
	    var eventFns = events[type || event.type];
	    var eventFnsLength = eventFns ? eventFns.length : 0;
	
	    if (!eventFnsLength) return;
	
	    if (isUndefined(event.immediatePropagationStopped)) {
	      var originalStopImmediatePropagation = event.stopImmediatePropagation;
	      event.stopImmediatePropagation = function() {
	        event.immediatePropagationStopped = true;
	
	        if (event.stopPropagation) {
	          event.stopPropagation();
	        }
	
	        if (originalStopImmediatePropagation) {
	          originalStopImmediatePropagation.call(event);
	        }
	      };
	    }
	
	    event.isImmediatePropagationStopped = function() {
	      return event.immediatePropagationStopped === true;
	    };
	
	    // Some events have special handlers that wrap the real handler
	    var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;
	
	    // Copy event handlers in case event handlers array is modified during execution.
	    if ((eventFnsLength > 1)) {
	      eventFns = shallowCopy(eventFns);
	    }
	
	    for (var i = 0; i < eventFnsLength; i++) {
	      if (!event.isImmediatePropagationStopped()) {
	        handlerWrapper(element, event, eventFns[i]);
	      }
	    }
	  };
	
	  // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
	  //       events on `element`
	  eventHandler.elem = element;
	  return eventHandler;
	}
	
	function defaultHandlerWrapper(element, event, handler) {
	  handler.call(element, event);
	}
	
	function specialMouseHandlerWrapper(target, event, handler) {
	  // Refer to jQuery's implementation of mouseenter & mouseleave
	  // Read about mouseenter and mouseleave:
	  // http://www.quirksmode.org/js/events_mouse.html#link8
	  var related = event.relatedTarget;
	  // For mousenter/leave call the handler if related is outside the target.
	  // NB: No relatedTarget if the mouse left/entered the browser window
	  if (!related || (related !== target && !jqLiteContains.call(target, related))) {
	    handler.call(target, event);
	  }
	}
	
	//////////////////////////////////////////
	// Functions iterating traversal.
	// These functions chain results into a single
	// selector.
	//////////////////////////////////////////
	forEach({
	  removeData: jqLiteRemoveData,
	
	  on: function jqLiteOn(element, type, fn, unsupported) {
	    if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');
	
	    // Do not add event handlers to non-elements because they will not be cleaned up.
	    if (!jqLiteAcceptsData(element)) {
	      return;
	    }
	
	    var expandoStore = jqLiteExpandoStore(element, true);
	    var events = expandoStore.events;
	    var handle = expandoStore.handle;
	
	    if (!handle) {
	      handle = expandoStore.handle = createEventHandler(element, events);
	    }
	
	    // http://jsperf.com/string-indexof-vs-split
	    var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
	    var i = types.length;
	
	    var addHandler = function(type, specialHandlerWrapper, noEventListener) {
	      var eventFns = events[type];
	
	      if (!eventFns) {
	        eventFns = events[type] = [];
	        eventFns.specialHandlerWrapper = specialHandlerWrapper;
	        if (type !== '$destroy' && !noEventListener) {
	          element.addEventListener(type, handle);
	        }
	      }
	
	      eventFns.push(fn);
	    };
	
	    while (i--) {
	      type = types[i];
	      if (MOUSE_EVENT_MAP[type]) {
	        addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
	        addHandler(type, undefined, true);
	      } else {
	        addHandler(type);
	      }
	    }
	  },
	
	  off: jqLiteOff,
	
	  one: function(element, type, fn) {
	    element = jqLite(element);
	
	    //add the listener twice so that when it is called
	    //you can remove the original function and still be
	    //able to call element.off(ev, fn) normally
	    element.on(type, function onFn() {
	      element.off(type, fn);
	      element.off(type, onFn);
	    });
	    element.on(type, fn);
	  },
	
	  replaceWith: function(element, replaceNode) {
	    var index, parent = element.parentNode;
	    jqLiteDealoc(element);
	    forEach(new JQLite(replaceNode), function(node) {
	      if (index) {
	        parent.insertBefore(node, index.nextSibling);
	      } else {
	        parent.replaceChild(node, element);
	      }
	      index = node;
	    });
	  },
	
	  children: function(element) {
	    var children = [];
	    forEach(element.childNodes, function(element) {
	      if (element.nodeType === NODE_TYPE_ELEMENT) {
	        children.push(element);
	      }
	    });
	    return children;
	  },
	
	  contents: function(element) {
	    return element.contentDocument || element.childNodes || [];
	  },
	
	  append: function(element, node) {
	    var nodeType = element.nodeType;
	    if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;
	
	    node = new JQLite(node);
	
	    for (var i = 0, ii = node.length; i < ii; i++) {
	      var child = node[i];
	      element.appendChild(child);
	    }
	  },
	
	  prepend: function(element, node) {
	    if (element.nodeType === NODE_TYPE_ELEMENT) {
	      var index = element.firstChild;
	      forEach(new JQLite(node), function(child) {
	        element.insertBefore(child, index);
	      });
	    }
	  },
	
	  wrap: function(element, wrapNode) {
	    jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
	  },
	
	  remove: jqLiteRemove,
	
	  detach: function(element) {
	    jqLiteRemove(element, true);
	  },
	
	  after: function(element, newElement) {
	    var index = element, parent = element.parentNode;
	
	    if (parent) {
	      newElement = new JQLite(newElement);
	
	      for (var i = 0, ii = newElement.length; i < ii; i++) {
	        var node = newElement[i];
	        parent.insertBefore(node, index.nextSibling);
	        index = node;
	      }
	    }
	  },
	
	  addClass: jqLiteAddClass,
	  removeClass: jqLiteRemoveClass,
	
	  toggleClass: function(element, selector, condition) {
	    if (selector) {
	      forEach(selector.split(' '), function(className) {
	        var classCondition = condition;
	        if (isUndefined(classCondition)) {
	          classCondition = !jqLiteHasClass(element, className);
	        }
	        (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
	      });
	    }
	  },
	
	  parent: function(element) {
	    var parent = element.parentNode;
	    return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
	  },
	
	  next: function(element) {
	    return element.nextElementSibling;
	  },
	
	  find: function(element, selector) {
	    if (element.getElementsByTagName) {
	      return element.getElementsByTagName(selector);
	    } else {
	      return [];
	    }
	  },
	
	  clone: jqLiteClone,
	
	  triggerHandler: function(element, event, extraParameters) {
	
	    var dummyEvent, eventFnsCopy, handlerArgs;
	    var eventName = event.type || event;
	    var expandoStore = jqLiteExpandoStore(element);
	    var events = expandoStore && expandoStore.events;
	    var eventFns = events && events[eventName];
	
	    if (eventFns) {
	      // Create a dummy event to pass to the handlers
	      dummyEvent = {
	        preventDefault: function() { this.defaultPrevented = true; },
	        isDefaultPrevented: function() { return this.defaultPrevented === true; },
	        stopImmediatePropagation: function() { this.immediatePropagationStopped = true; },
	        isImmediatePropagationStopped: function() { return this.immediatePropagationStopped === true; },
	        stopPropagation: noop,
	        type: eventName,
	        target: element
	      };
	
	      // If a custom event was provided then extend our dummy event with it
	      if (event.type) {
	        dummyEvent = extend(dummyEvent, event);
	      }
	
	      // Copy event handlers in case event handlers array is modified during execution.
	      eventFnsCopy = shallowCopy(eventFns);
	      handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];
	
	      forEach(eventFnsCopy, function(fn) {
	        if (!dummyEvent.isImmediatePropagationStopped()) {
	          fn.apply(element, handlerArgs);
	        }
	      });
	    }
	  }
	}, function(fn, name) {
	  /**
	   * chaining functions
	   */
	  JQLite.prototype[name] = function(arg1, arg2, arg3) {
	    var value;
	
	    for (var i = 0, ii = this.length; i < ii; i++) {
	      if (isUndefined(value)) {
	        value = fn(this[i], arg1, arg2, arg3);
	        if (isDefined(value)) {
	          // any function which returns a value needs to be wrapped
	          value = jqLite(value);
	        }
	      } else {
	        jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
	      }
	    }
	    return isDefined(value) ? value : this;
	  };
	});
	
	// bind legacy bind/unbind to on/off
	JQLite.prototype.bind = JQLite.prototype.on;
	JQLite.prototype.unbind = JQLite.prototype.off;
	
	
	// Provider for private $$jqLite service
	/** @this */
	function $$jqLiteProvider() {
	  this.$get = function $$jqLite() {
	    return extend(JQLite, {
	      hasClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteHasClass(node, classes);
	      },
	      addClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteAddClass(node, classes);
	      },
	      removeClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteRemoveClass(node, classes);
	      }
	    });
	  };
	}
	
	/**
	 * Computes a hash of an 'obj'.
	 * Hash of a:
	 *  string is string
	 *  number is number as string
	 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
	 *         that is also assigned to the $$hashKey property of the object.
	 *
	 * @param obj
	 * @returns {string} hash string such that the same input will have the same hash string.
	 *         The resulting string key is in 'type:hashKey' format.
	 */
	function hashKey(obj, nextUidFn) {
	  var key = obj && obj.$$hashKey;
	
	  if (key) {
	    if (typeof key === 'function') {
	      key = obj.$$hashKey();
	    }
	    return key;
	  }
	
	  var objType = typeof obj;
	  if (objType === 'function' || (objType === 'object' && obj !== null)) {
	    key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
	  } else {
	    key = objType + ':' + obj;
	  }
	
	  return key;
	}
	
	// A minimal ES2015 Map implementation.
	// Should be bug/feature equivalent to the native implementations of supported browsers
	// (for the features required in Angular).
	// See https://kangax.github.io/compat-table/es6/#test-Map
	var nanKey = Object.create(null);
	function NgMapShim() {
	  this._keys = [];
	  this._values = [];
	  this._lastKey = NaN;
	  this._lastIndex = -1;
	}
	NgMapShim.prototype = {
	  _idx: function(key) {
	    if (key === this._lastKey) {
	      return this._lastIndex;
	    }
	    this._lastKey = key;
	    this._lastIndex = this._keys.indexOf(key);
	    return this._lastIndex;
	  },
	  _transformKey: function(key) {
	    return isNumberNaN(key) ? nanKey : key;
	  },
	  get: function(key) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx !== -1) {
	      return this._values[idx];
	    }
	  },
	  set: function(key, value) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx === -1) {
	      idx = this._lastIndex = this._keys.length;
	    }
	    this._keys[idx] = key;
	    this._values[idx] = value;
	
	    // Support: IE11
	    // Do not `return this` to simulate the partial IE11 implementation
	  },
	  delete: function(key) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx === -1) {
	      return false;
	    }
	    this._keys.splice(idx, 1);
	    this._values.splice(idx, 1);
	    this._lastKey = NaN;
	    this._lastIndex = -1;
	    return true;
	  }
	};
	
	// For now, always use `NgMapShim`, even if `window.Map` is available. Some native implementations
	// are still buggy (often in subtle ways) and can cause hard-to-debug failures. When native `Map`
	// implementations get more stable, we can reconsider switching to `window.Map` (when available).
	var NgMap = NgMapShim;
	
	var $$MapProvider = [/** @this */function() {
	  this.$get = [function() {
	    return NgMap;
	  }];
	}];
	
	/**
	 * @ngdoc function
	 * @module ng
	 * @name angular.injector
	 * @kind function
	 *
	 * @description
	 * Creates an injector object that can be used for retrieving services as well as for
	 * dependency injection (see {@link guide/di dependency injection}).
	 *
	 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
	 *     {@link angular.module}. The `ng` module must be explicitly added.
	 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
	 *     disallows argument name annotation inference.
	 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
	 *
	 * @example
	 * Typical usage
	 * ```js
	 *   // create an injector
	 *   var $injector = angular.injector(['ng']);
	 *
	 *   // use the injector to kick off your application
	 *   // use the type inference to auto inject arguments, or use implicit injection
	 *   $injector.invoke(function($rootScope, $compile, $document) {
	 *     $compile($document)($rootScope);
	 *     $rootScope.$digest();
	 *   });
	 * ```
	 *
	 * Sometimes you want to get access to the injector of a currently running Angular app
	 * from outside Angular. Perhaps, you want to inject and compile some markup after the
	 * application has been bootstrapped. You can do this using the extra `injector()` added
	 * to JQuery/jqLite elements. See {@link angular.element}.
	 *
	 * *This is fairly rare but could be the case if a third party library is injecting the
	 * markup.*
	 *
	 * In the following example a new block of HTML containing a `ng-controller`
	 * directive is added to the end of the document body by JQuery. We then compile and link
	 * it into the current AngularJS scope.
	 *
	 * ```js
	 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
	 * $(document.body).append($div);
	 *
	 * angular.element(document).injector().invoke(function($compile) {
	 *   var scope = angular.element($div).scope();
	 *   $compile($div)(scope);
	 * });
	 * ```
	 */
	
	
	/**
	 * @ngdoc module
	 * @name auto
	 * @installation
	 * @description
	 *
	 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
	 */
	
	var ARROW_ARG = /^([^(]+?)=>/;
	var FN_ARGS = /^[^(]*\(\s*([^)]*)\)/m;
	var FN_ARG_SPLIT = /,/;
	var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
	var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
	var $injectorMinErr = minErr('$injector');
	
	function stringifyFn(fn) {
	  return Function.prototype.toString.call(fn);
	}
	
	function extractArgs(fn) {
	  var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ''),
	      args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
	  return args;
	}
	
	function anonFn(fn) {
	  // For anonymous functions, showing at the very least the function signature can help in
	  // debugging.
	  var args = extractArgs(fn);
	  if (args) {
	    return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
	  }
	  return 'fn';
	}
	
	function annotate(fn, strictDi, name) {
	  var $inject,
	      argDecl,
	      last;
	
	  if (typeof fn === 'function') {
	    if (!($inject = fn.$inject)) {
	      $inject = [];
	      if (fn.length) {
	        if (strictDi) {
	          if (!isString(name) || !name) {
	            name = fn.name || anonFn(fn);
	          }
	          throw $injectorMinErr('strictdi',
	            '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
	        }
	        argDecl = extractArgs(fn);
	        forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
	          arg.replace(FN_ARG, function(all, underscore, name) {
	            $inject.push(name);
	          });
	        });
	      }
	      fn.$inject = $inject;
	    }
	  } else if (isArray(fn)) {
	    last = fn.length - 1;
	    assertArgFn(fn[last], 'fn');
	    $inject = fn.slice(0, last);
	  } else {
	    assertArgFn(fn, 'fn', true);
	  }
	  return $inject;
	}
	
	///////////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $injector
	 *
	 * @description
	 *
	 * `$injector` is used to retrieve object instances as defined by
	 * {@link auto.$provide provider}, instantiate types, invoke methods,
	 * and load modules.
	 *
	 * The following always holds true:
	 *
	 * ```js
	 *   var $injector = angular.injector();
	 *   expect($injector.get('$injector')).toBe($injector);
	 *   expect($injector.invoke(function($injector) {
	 *     return $injector;
	 *   })).toBe($injector);
	 * ```
	 *
	 * # Injection Function Annotation
	 *
	 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
	 * following are all valid ways of annotating function with injection arguments and are equivalent.
	 *
	 * ```js
	 *   // inferred (only works if code not minified/obfuscated)
	 *   $injector.invoke(function(serviceA){});
	 *
	 *   // annotated
	 *   function explicit(serviceA) {};
	 *   explicit.$inject = ['serviceA'];
	 *   $injector.invoke(explicit);
	 *
	 *   // inline
	 *   $injector.invoke(['serviceA', function(serviceA){}]);
	 * ```
	 *
	 * ## Inference
	 *
	 * In JavaScript calling `toString()` on a function returns the function definition. The definition
	 * can then be parsed and the function arguments can be extracted. This method of discovering
	 * annotations is disallowed when the injector is in strict mode.
	 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
	 * argument names.
	 *
	 * ## `$inject` Annotation
	 * By adding an `$inject` property onto a function the injection parameters can be specified.
	 *
	 * ## Inline
	 * As an array of injection names, where the last item in the array is the function to call.
	 */
	
	/**
	 * @ngdoc property
	 * @name $injector#modules
	 * @type {Object}
	 * @description
	 * A hash containing all the modules that have been loaded into the
	 * $injector.
	 *
	 * You can use this property to find out information about a module via the
	 * {@link angular.Module#info `myModule.info(...)`} method.
	 *
	 * For example:
	 *
	 * ```
	 * var info = $injector.modules['ngAnimate'].info();
	 * ```
	 *
	 * **Do not use this property to attempt to modify the modules after the application
	 * has been bootstrapped.**
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $injector#get
	 *
	 * @description
	 * Return an instance of the service.
	 *
	 * @param {string} name The name of the instance to retrieve.
	 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
	 * @return {*} The instance.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#invoke
	 *
	 * @description
	 * Invoke the method and supply the method arguments from the `$injector`.
	 *
	 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
	 *   injected according to the {@link guide/di $inject Annotation} rules.
	 * @param {Object=} self The `this` for the invoked method.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 *                         object first, before the `$injector` is consulted.
	 * @returns {*} the value returned by the invoked `fn` function.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#has
	 *
	 * @description
	 * Allows the user to query if the particular service exists.
	 *
	 * @param {string} name Name of the service to query.
	 * @returns {boolean} `true` if injector has given service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#instantiate
	 * @description
	 * Create a new instance of JS type. The method takes a constructor function, invokes the new
	 * operator, and supplies all of the arguments to the constructor function as specified by the
	 * constructor annotation.
	 *
	 * @param {Function} Type Annotated constructor function.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 * object first, before the `$injector` is consulted.
	 * @returns {Object} new instance of `Type`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#annotate
	 *
	 * @description
	 * Returns an array of service names which the function is requesting for injection. This API is
	 * used by the injector to determine which services need to be injected into the function when the
	 * function is invoked. There are three ways in which the function can be annotated with the needed
	 * dependencies.
	 *
	 * # Argument names
	 *
	 * The simplest form is to extract the dependencies from the arguments of the function. This is done
	 * by converting the function into a string using `toString()` method and extracting the argument
	 * names.
	 * ```js
	 *   // Given
	 *   function MyController($scope, $route) {
	 *     // ...
	 *   }
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * You can disallow this method by using strict injection mode.
	 *
	 * This method does not work with code minification / obfuscation. For this reason the following
	 * annotation strategies are supported.
	 *
	 * # The `$inject` property
	 *
	 * If a function has an `$inject` property and its value is an array of strings, then the strings
	 * represent names of services to be injected into the function.
	 * ```js
	 *   // Given
	 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
	 *     // ...
	 *   }
	 *   // Define function dependencies
	 *   MyController['$inject'] = ['$scope', '$route'];
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * # The array notation
	 *
	 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
	 * is very inconvenient. In these situations using the array notation to specify the dependencies in
	 * a way that survives minification is a better choice:
	 *
	 * ```js
	 *   // We wish to write this (not minification / obfuscation safe)
	 *   injector.invoke(function($compile, $rootScope) {
	 *     // ...
	 *   });
	 *
	 *   // We are forced to write break inlining
	 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
	 *     // ...
	 *   };
	 *   tmpFn.$inject = ['$compile', '$rootScope'];
	 *   injector.invoke(tmpFn);
	 *
	 *   // To better support inline function the inline annotation is supported
	 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
	 *     // ...
	 *   }]);
	 *
	 *   // Therefore
	 *   expect(injector.annotate(
	 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
	 *    ).toEqual(['$compile', '$rootScope']);
	 * ```
	 *
	 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
	 * be retrieved as described above.
	 *
	 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
	 *
	 * @returns {Array.<string>} The names of the services which the function requires.
	 */
	
	
	
	/**
	 * @ngdoc service
	 * @name $provide
	 *
	 * @description
	 *
	 * The {@link auto.$provide $provide} service has a number of methods for registering components
	 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
	 * {@link angular.Module}.
	 *
	 * An Angular **service** is a singleton object created by a **service factory**.  These **service
	 * factories** are functions which, in turn, are created by a **service provider**.
	 * The **service providers** are constructor functions. When instantiated they must contain a
	 * property called `$get`, which holds the **service factory** function.
	 *
	 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
	 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
	 * function to get the instance of the **service**.
	 *
	 * Often services have no configuration options and there is no need to add methods to the service
	 * provider.  The provider will be no more than a constructor function with a `$get` property. For
	 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
	 * services without specifying a provider.
	 *
	 * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
	 *     {@link auto.$injector $injector}
	 * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
	 *     providers and services.
	 * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
	 *     services, not providers.
	 * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
	 *     given factory function.
	 * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
	 *      a new object using the given constructor function.
	 * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
	 *      will be able to modify or replace the implementation of another service.
	 *
	 * See the individual methods for more information and examples.
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#provider
	 * @description
	 *
	 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
	 * are constructor functions, whose instances are responsible for "providing" a factory for a
	 * service.
	 *
	 * Service provider names start with the name of the service they provide followed by `Provider`.
	 * For example, the {@link ng.$log $log} service has a provider called
	 * {@link ng.$logProvider $logProvider}.
	 *
	 * Service provider objects can have additional methods which allow configuration of the provider
	 * and its service. Importantly, you can configure what kind of service is created by the `$get`
	 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
	 * method {@link ng.$logProvider#debugEnabled debugEnabled}
	 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
	 * console or not.
	 *
	 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
	                        'Provider'` key.
	 * @param {(Object|function())} provider If the provider is:
	 *
	 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
	 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
	 *   - `Constructor`: a new instance of the provider will be created using
	 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
	 *
	 * @returns {Object} registered provider instance
	
	 * @example
	 *
	 * The following example shows how to create a simple event tracking service and register it using
	 * {@link auto.$provide#provider $provide.provider()}.
	 *
	 * ```js
	 *  // Define the eventTracker provider
	 *  function EventTrackerProvider() {
	 *    var trackingUrl = '/track';
	 *
	 *    // A provider method for configuring where the tracked events should been saved
	 *    this.setTrackingUrl = function(url) {
	 *      trackingUrl = url;
	 *    };
	 *
	 *    // The service factory function
	 *    this.$get = ['$http', function($http) {
	 *      var trackedEvents = {};
	 *      return {
	 *        // Call this to track an event
	 *        event: function(event) {
	 *          var count = trackedEvents[event] || 0;
	 *          count += 1;
	 *          trackedEvents[event] = count;
	 *          return count;
	 *        },
	 *        // Call this to save the tracked events to the trackingUrl
	 *        save: function() {
	 *          $http.post(trackingUrl, trackedEvents);
	 *        }
	 *      };
	 *    }];
	 *  }
	 *
	 *  describe('eventTracker', function() {
	 *    var postSpy;
	 *
	 *    beforeEach(module(function($provide) {
	 *      // Register the eventTracker provider
	 *      $provide.provider('eventTracker', EventTrackerProvider);
	 *    }));
	 *
	 *    beforeEach(module(function(eventTrackerProvider) {
	 *      // Configure eventTracker provider
	 *      eventTrackerProvider.setTrackingUrl('/custom-track');
	 *    }));
	 *
	 *    it('tracks events', inject(function(eventTracker) {
	 *      expect(eventTracker.event('login')).toEqual(1);
	 *      expect(eventTracker.event('login')).toEqual(2);
	 *    }));
	 *
	 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
	 *      postSpy = spyOn($http, 'post');
	 *      eventTracker.event('login');
	 *      eventTracker.save();
	 *      expect(postSpy).toHaveBeenCalled();
	 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
	 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
	 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
	 *    }));
	 *  });
	 * ```
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#factory
	 * @description
	 *
	 * Register a **service factory**, which will be called to return the service instance.
	 * This is short for registering a service where its provider consists of only a `$get` property,
	 * which is the given service factory function.
	 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
	 * configure your service in a provider.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
	 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service
	 * ```js
	 *   $provide.factory('ping', ['$http', function($http) {
	 *     return function ping() {
	 *       return $http.send('/ping');
	 *     };
	 *   }]);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#service
	 * @description
	 *
	 * Register a **service constructor**, which will be invoked with `new` to create the service
	 * instance.
	 * This is short for registering a service where its provider's `$get` property is a factory
	 * function that returns an instance instantiated by the injector from the service constructor
	 * function.
	 *
	 * Internally it looks a bit like this:
	 *
	 * ```
	 * {
	 *   $get: function() {
	 *     return $injector.instantiate(constructor);
	 *   }
	 * }
	 * ```
	 *
	 *
	 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
	 * as a type/class.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
	 *     that will be instantiated.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service using
	 * {@link auto.$provide#service $provide.service(class)}.
	 * ```js
	 *   var Ping = function($http) {
	 *     this.$http = $http;
	 *   };
	 *
	 *   Ping.$inject = ['$http'];
	 *
	 *   Ping.prototype.send = function() {
	 *     return this.$http.get('/ping');
	 *   };
	 *   $provide.service('ping', Ping);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping.send();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#value
	 * @description
	 *
	 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
	 * number, an array, an object or a function. This is short for registering a service where its
	 * provider's `$get` property is a factory function that takes no arguments and returns the **value
	 * service**. That also means it is not possible to inject other services into a value service.
	 *
	 * Value services are similar to constant services, except that they cannot be injected into a
	 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
	 * an Angular {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the instance.
	 * @param {*} value The value.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here are some examples of creating value services.
	 * ```js
	 *   $provide.value('ADMIN_USER', 'admin');
	 *
	 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
	 *
	 *   $provide.value('halfOf', function(value) {
	 *     return value / 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#constant
	 * @description
	 *
	 * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
	 * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
	 * possible to inject other services into a constant.
	 *
	 * But unlike {@link auto.$provide#value value}, a constant can be
	 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
	 * be overridden by an Angular {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the constant.
	 * @param {*} value The constant value.
	 * @returns {Object} registered instance
	 *
	 * @example
	 * Here a some examples of creating constants:
	 * ```js
	 *   $provide.constant('SHARD_HEIGHT', 306);
	 *
	 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
	 *
	 *   $provide.constant('double', function(value) {
	 *     return value * 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#decorator
	 * @description
	 *
	 * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
	 * intercepts the creation of a service, allowing it to override or modify the behavior of the
	 * service. The return value of the decorator function may be the original service, or a new service
	 * that replaces (or wraps and delegates to) the original service.
	 *
	 * You can find out more about using decorators in the {@link guide/decorators} guide.
	 *
	 * @param {string} name The name of the service to decorate.
	 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
	 *    provided and should return the decorated service instance. The function is called using
	 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
	 *    Local injection arguments:
	 *
	 *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
	 *      decorated or delegated to.
	 *
	 * @example
	 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
	 * calls to {@link ng.$log#error $log.warn()}.
	 * ```js
	 *   $provide.decorator('$log', ['$delegate', function($delegate) {
	 *     $delegate.warn = $delegate.error;
	 *     return $delegate;
	 *   }]);
	 * ```
	 */
	
	
	function createInjector(modulesToLoad, strictDi) {
	  strictDi = (strictDi === true);
	  var INSTANTIATING = {},
	      providerSuffix = 'Provider',
	      path = [],
	      loadedModules = new NgMap(),
	      providerCache = {
	        $provide: {
	            provider: supportObject(provider),
	            factory: supportObject(factory),
	            service: supportObject(service),
	            value: supportObject(value),
	            constant: supportObject(constant),
	            decorator: decorator
	          }
	      },
	      providerInjector = (providerCache.$injector =
	          createInternalInjector(providerCache, function(serviceName, caller) {
	            if (angular.isString(caller)) {
	              path.push(caller);
	            }
	            throw $injectorMinErr('unpr', 'Unknown provider: {0}', path.join(' <- '));
	          })),
	      instanceCache = {},
	      protoInstanceInjector =
	          createInternalInjector(instanceCache, function(serviceName, caller) {
	            var provider = providerInjector.get(serviceName + providerSuffix, caller);
	            return instanceInjector.invoke(
	                provider.$get, provider, undefined, serviceName);
	          }),
	      instanceInjector = protoInstanceInjector;
	
	  providerCache['$injector' + providerSuffix] = { $get: valueFn(protoInstanceInjector) };
	  instanceInjector.modules = providerInjector.modules = createMap();
	  var runBlocks = loadModules(modulesToLoad);
	  instanceInjector = protoInstanceInjector.get('$injector');
	  instanceInjector.strictDi = strictDi;
	  forEach(runBlocks, function(fn) { if (fn) instanceInjector.invoke(fn); });
	
	  return instanceInjector;
	
	  ////////////////////////////////////
	  // $provider
	  ////////////////////////////////////
	
	  function supportObject(delegate) {
	    return function(key, value) {
	      if (isObject(key)) {
	        forEach(key, reverseParams(delegate));
	      } else {
	        return delegate(key, value);
	      }
	    };
	  }
	
	  function provider(name, provider_) {
	    assertNotHasOwnProperty(name, 'service');
	    if (isFunction(provider_) || isArray(provider_)) {
	      provider_ = providerInjector.instantiate(provider_);
	    }
	    if (!provider_.$get) {
	      throw $injectorMinErr('pget', 'Provider \'{0}\' must define $get factory method.', name);
	    }
	    return (providerCache[name + providerSuffix] = provider_);
	  }
	
	  function enforceReturnValue(name, factory) {
	    return /** @this */ function enforcedReturnValue() {
	      var result = instanceInjector.invoke(factory, this);
	      if (isUndefined(result)) {
	        throw $injectorMinErr('undef', 'Provider \'{0}\' must return a value from $get factory method.', name);
	      }
	      return result;
	    };
	  }
	
	  function factory(name, factoryFn, enforce) {
	    return provider(name, {
	      $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
	    });
	  }
	
	  function service(name, constructor) {
	    return factory(name, ['$injector', function($injector) {
	      return $injector.instantiate(constructor);
	    }]);
	  }
	
	  function value(name, val) { return factory(name, valueFn(val), false); }
	
	  function constant(name, value) {
	    assertNotHasOwnProperty(name, 'constant');
	    providerCache[name] = value;
	    instanceCache[name] = value;
	  }
	
	  function decorator(serviceName, decorFn) {
	    var origProvider = providerInjector.get(serviceName + providerSuffix),
	        orig$get = origProvider.$get;
	
	    origProvider.$get = function() {
	      var origInstance = instanceInjector.invoke(orig$get, origProvider);
	      return instanceInjector.invoke(decorFn, null, {$delegate: origInstance});
	    };
	  }
	
	  ////////////////////////////////////
	  // Module Loading
	  ////////////////////////////////////
	  function loadModules(modulesToLoad) {
	    assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), 'modulesToLoad', 'not an array');
	    var runBlocks = [], moduleFn;
	    forEach(modulesToLoad, function(module) {
	      if (loadedModules.get(module)) return;
	      loadedModules.set(module, true);
	
	      function runInvokeQueue(queue) {
	        var i, ii;
	        for (i = 0, ii = queue.length; i < ii; i++) {
	          var invokeArgs = queue[i],
	              provider = providerInjector.get(invokeArgs[0]);
	
	          provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
	        }
	      }
	
	      try {
	        if (isString(module)) {
	          moduleFn = angularModule(module);
	          instanceInjector.modules[module] = moduleFn;
	          runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
	          runInvokeQueue(moduleFn._invokeQueue);
	          runInvokeQueue(moduleFn._configBlocks);
	        } else if (isFunction(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else if (isArray(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else {
	          assertArgFn(module, 'module');
	        }
	      } catch (e) {
	        if (isArray(module)) {
	          module = module[module.length - 1];
	        }
	        if (e.message && e.stack && e.stack.indexOf(e.message) === -1) {
	          // Safari & FF's stack traces don't contain error.message content
	          // unlike those of Chrome and IE
	          // So if stack doesn't contain message, we create a new string that contains both.
	          // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
	          // eslint-disable-next-line no-ex-assign
	          e = e.message + '\n' + e.stack;
	        }
	        throw $injectorMinErr('modulerr', 'Failed to instantiate module {0} due to:\n{1}',
	                  module, e.stack || e.message || e);
	      }
	    });
	    return runBlocks;
	  }
	
	  ////////////////////////////////////
	  // internal Injector
	  ////////////////////////////////////
	
	  function createInternalInjector(cache, factory) {
	
	    function getService(serviceName, caller) {
	      if (cache.hasOwnProperty(serviceName)) {
	        if (cache[serviceName] === INSTANTIATING) {
	          throw $injectorMinErr('cdep', 'Circular dependency found: {0}',
	                    serviceName + ' <- ' + path.join(' <- '));
	        }
	        return cache[serviceName];
	      } else {
	        try {
	          path.unshift(serviceName);
	          cache[serviceName] = INSTANTIATING;
	          cache[serviceName] = factory(serviceName, caller);
	          return cache[serviceName];
	        } catch (err) {
	          if (cache[serviceName] === INSTANTIATING) {
	            delete cache[serviceName];
	          }
	          throw err;
	        } finally {
	          path.shift();
	        }
	      }
	    }
	
	
	    function injectionArgs(fn, locals, serviceName) {
	      var args = [],
	          $inject = createInjector.$$annotate(fn, strictDi, serviceName);
	
	      for (var i = 0, length = $inject.length; i < length; i++) {
	        var key = $inject[i];
	        if (typeof key !== 'string') {
	          throw $injectorMinErr('itkn',
	                  'Incorrect injection token! Expected service name as string, got {0}', key);
	        }
	        args.push(locals && locals.hasOwnProperty(key) ? locals[key] :
	                                                         getService(key, serviceName));
	      }
	      return args;
	    }
	
	    function isClass(func) {
	      // Support: IE 9-11 only
	      // IE 9-11 do not support classes and IE9 leaks with the code below.
	      if (msie || typeof func !== 'function') {
	        return false;
	      }
	      var result = func.$$ngIsClass;
	      if (!isBoolean(result)) {
	        // Support: Edge 12-13 only
	        // See: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/6156135/
	        result = func.$$ngIsClass = /^(?:class\b|constructor\()/.test(stringifyFn(func));
	      }
	      return result;
	    }
	
	    function invoke(fn, self, locals, serviceName) {
	      if (typeof locals === 'string') {
	        serviceName = locals;
	        locals = null;
	      }
	
	      var args = injectionArgs(fn, locals, serviceName);
	      if (isArray(fn)) {
	        fn = fn[fn.length - 1];
	      }
	
	      if (!isClass(fn)) {
	        // http://jsperf.com/angularjs-invoke-apply-vs-switch
	        // #5388
	        return fn.apply(self, args);
	      } else {
	        args.unshift(null);
	        return new (Function.prototype.bind.apply(fn, args))();
	      }
	    }
	
	
	    function instantiate(Type, locals, serviceName) {
	      // Check if Type is annotated and use just the given function at n-1 as parameter
	      // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
	      var ctor = (isArray(Type) ? Type[Type.length - 1] : Type);
	      var args = injectionArgs(Type, locals, serviceName);
	      // Empty object at position 0 is ignored for invocation with `new`, but required.
	      args.unshift(null);
	      return new (Function.prototype.bind.apply(ctor, args))();
	    }
	
	
	    return {
	      invoke: invoke,
	      instantiate: instantiate,
	      get: getService,
	      annotate: createInjector.$$annotate,
	      has: function(name) {
	        return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
	      }
	    };
	  }
	}
	
	createInjector.$$annotate = annotate;
	
	/**
	 * @ngdoc provider
	 * @name $anchorScrollProvider
	 * @this
	 *
	 * @description
	 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
	 * {@link ng.$location#hash $location.hash()} changes.
	 */
	function $AnchorScrollProvider() {
	
	  var autoScrollingEnabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $anchorScrollProvider#disableAutoScrolling
	   *
	   * @description
	   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
	   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
	   * Use this method to disable automatic scrolling.
	   *
	   * If automatic scrolling is disabled, one must explicitly call
	   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
	   * current hash.
	   */
	  this.disableAutoScrolling = function() {
	    autoScrollingEnabled = false;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $anchorScroll
	   * @kind function
	   * @requires $window
	   * @requires $location
	   * @requires $rootScope
	   *
	   * @description
	   * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
	   * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
	   * in the
	   * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
	   *
	   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
	   * match any anchor whenever it changes. This can be disabled by calling
	   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
	   *
	   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
	   * vertical scroll-offset (either fixed or dynamic).
	   *
	   * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
	   *                       {@link ng.$location#hash $location.hash()} will be used.
	   *
	   * @property {(number|function|jqLite)} yOffset
	   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
	   * positioned elements at the top of the page, such as navbars, headers etc.
	   *
	   * `yOffset` can be specified in various ways:
	   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
	   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
	   *   a number representing the offset (in pixels).<br /><br />
	   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
	   *   the top of the page to the element's bottom will be used as offset.<br />
	   *   **Note**: The element will be taken into account only as long as its `position` is set to
	   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
	   *   their height and/or positioning according to the viewport's size.
	   *
	   * <br />
	   * <div class="alert alert-warning">
	   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
	   * not some child element.
	   * </div>
	   *
	   * @example
	     <example module="anchorScrollExample" name="anchor-scroll">
	       <file name="index.html">
	         <div id="scrollArea" ng-controller="ScrollController">
	           <a ng-click="gotoBottom()">Go to bottom</a>
	           <a id="bottom"></a> You're at the bottom!
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollExample', [])
	           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
	             function($scope, $location, $anchorScroll) {
	               $scope.gotoBottom = function() {
	                 // set the location.hash to the id of
	                 // the element you wish to scroll to.
	                 $location.hash('bottom');
	
	                 // call $anchorScroll()
	                 $anchorScroll();
	               };
	             }]);
	       </file>
	       <file name="style.css">
	         #scrollArea {
	           height: 280px;
	           overflow: auto;
	         }
	
	         #bottom {
	           display: block;
	           margin-top: 2000px;
	         }
	       </file>
	     </example>
	   *
	   * <hr />
	   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
	   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
	   *
	   * @example
	     <example module="anchorScrollOffsetExample" name="anchor-scroll-offset">
	       <file name="index.html">
	         <div class="fixed-header" ng-controller="headerCtrl">
	           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
	             Go to anchor {{x}}
	           </a>
	         </div>
	         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
	           Anchor {{x}} of 5
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollOffsetExample', [])
	           .run(['$anchorScroll', function($anchorScroll) {
	             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
	           }])
	           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
	             function($anchorScroll, $location, $scope) {
	               $scope.gotoAnchor = function(x) {
	                 var newHash = 'anchor' + x;
	                 if ($location.hash() !== newHash) {
	                   // set the $location.hash to `newHash` and
	                   // $anchorScroll will automatically scroll to it
	                   $location.hash('anchor' + x);
	                 } else {
	                   // call $anchorScroll() explicitly,
	                   // since $location.hash hasn't changed
	                   $anchorScroll();
	                 }
	               };
	             }
	           ]);
	       </file>
	       <file name="style.css">
	         body {
	           padding-top: 50px;
	         }
	
	         .anchor {
	           border: 2px dashed DarkOrchid;
	           padding: 10px 10px 200px 10px;
	         }
	
	         .fixed-header {
	           background-color: rgba(0, 0, 0, 0.2);
	           height: 50px;
	           position: fixed;
	           top: 0; left: 0; right: 0;
	         }
	
	         .fixed-header > a {
	           display: inline-block;
	           margin: 5px 15px;
	         }
	       </file>
	     </example>
	   */
	  this.$get = ['$window', '$location', '$rootScope', function($window, $location, $rootScope) {
	    var document = $window.document;
	
	    // Helper function to get first anchor from a NodeList
	    // (using `Array#some()` instead of `angular#forEach()` since it's more performant
	    //  and working in all supported browsers.)
	    function getFirstAnchor(list) {
	      var result = null;
	      Array.prototype.some.call(list, function(element) {
	        if (nodeName_(element) === 'a') {
	          result = element;
	          return true;
	        }
	      });
	      return result;
	    }
	
	    function getYOffset() {
	
	      var offset = scroll.yOffset;
	
	      if (isFunction(offset)) {
	        offset = offset();
	      } else if (isElement(offset)) {
	        var elem = offset[0];
	        var style = $window.getComputedStyle(elem);
	        if (style.position !== 'fixed') {
	          offset = 0;
	        } else {
	          offset = elem.getBoundingClientRect().bottom;
	        }
	      } else if (!isNumber(offset)) {
	        offset = 0;
	      }
	
	      return offset;
	    }
	
	    function scrollTo(elem) {
	      if (elem) {
	        elem.scrollIntoView();
	
	        var offset = getYOffset();
	
	        if (offset) {
	          // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
	          // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
	          // top of the viewport.
	          //
	          // IF the number of pixels from the top of `elem` to the end of the page's content is less
	          // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
	          // way down the page.
	          //
	          // This is often the case for elements near the bottom of the page.
	          //
	          // In such cases we do not need to scroll the whole `offset` up, just the difference between
	          // the top of the element and the offset, which is enough to align the top of `elem` at the
	          // desired position.
	          var elemTop = elem.getBoundingClientRect().top;
	          $window.scrollBy(0, elemTop - offset);
	        }
	      } else {
	        $window.scrollTo(0, 0);
	      }
	    }
	
	    function scroll(hash) {
	      // Allow numeric hashes
	      hash = isString(hash) ? hash : isNumber(hash) ? hash.toString() : $location.hash();
	      var elm;
	
	      // empty hash, scroll to the top of the page
	      if (!hash) scrollTo(null);
	
	      // element with given id
	      else if ((elm = document.getElementById(hash))) scrollTo(elm);
	
	      // first anchor with given name :-D
	      else if ((elm = getFirstAnchor(document.getElementsByName(hash)))) scrollTo(elm);
	
	      // no element and hash === 'top', scroll to the top of the page
	      else if (hash === 'top') scrollTo(null);
	    }
	
	    // does not scroll when user clicks on anchor link that is currently on
	    // (no url change, no $location.hash() change), browser native does scroll
	    if (autoScrollingEnabled) {
	      $rootScope.$watch(function autoScrollWatch() {return $location.hash();},
	        function autoScrollWatchAction(newVal, oldVal) {
	          // skip the initial scroll if $location.hash is empty
	          if (newVal === oldVal && newVal === '') return;
	
	          jqLiteDocumentLoaded(function() {
	            $rootScope.$evalAsync(scroll);
	          });
	        });
	    }
	
	    return scroll;
	  }];
	}
	
	var $animateMinErr = minErr('$animate');
	var ELEMENT_NODE = 1;
	var NG_ANIMATE_CLASSNAME = 'ng-animate';
	
	function mergeClasses(a,b) {
	  if (!a && !b) return '';
	  if (!a) return b;
	  if (!b) return a;
	  if (isArray(a)) a = a.join(' ');
	  if (isArray(b)) b = b.join(' ');
	  return a + ' ' + b;
	}
	
	function extractElementNode(element) {
	  for (var i = 0; i < element.length; i++) {
	    var elm = element[i];
	    if (elm.nodeType === ELEMENT_NODE) {
	      return elm;
	    }
	  }
	}
	
	function splitClasses(classes) {
	  if (isString(classes)) {
	    classes = classes.split(' ');
	  }
	
	  // Use createMap() to prevent class assumptions involving property names in
	  // Object.prototype
	  var obj = createMap();
	  forEach(classes, function(klass) {
	    // sometimes the split leaves empty string values
	    // incase extra spaces were applied to the options
	    if (klass.length) {
	      obj[klass] = true;
	    }
	  });
	  return obj;
	}
	
	// if any other type of options value besides an Object value is
	// passed into the $animate.method() animation then this helper code
	// will be run which will ignore it. While this patch is not the
	// greatest solution to this, a lot of existing plugins depend on
	// $animate to either call the callback (< 1.2) or return a promise
	// that can be changed. This helper function ensures that the options
	// are wiped clean incase a callback function is provided.
	function prepareAnimateOptions(options) {
	  return isObject(options)
	      ? options
	      : {};
	}
	
	var $$CoreAnimateJsProvider = /** @this */ function() {
	  this.$get = noop;
	};
	
	// this is prefixed with Core since it conflicts with
	// the animateQueueProvider defined in ngAnimate/animateQueue.js
	var $$CoreAnimateQueueProvider = /** @this */ function() {
	  var postDigestQueue = new NgMap();
	  var postDigestElements = [];
	
	  this.$get = ['$$AnimateRunner', '$rootScope',
	       function($$AnimateRunner,   $rootScope) {
	    return {
	      enabled: noop,
	      on: noop,
	      off: noop,
	      pin: noop,
	
	      push: function(element, event, options, domOperation) {
	        if (domOperation) {
	          domOperation();
	        }
	
	        options = options || {};
	        if (options.from) {
	          element.css(options.from);
	        }
	        if (options.to) {
	          element.css(options.to);
	        }
	
	        if (options.addClass || options.removeClass) {
	          addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
	        }
	
	        var runner = new $$AnimateRunner();
	
	        // since there are no animations to run the runner needs to be
	        // notified that the animation call is complete.
	        runner.complete();
	        return runner;
	      }
	    };
	
	
	    function updateData(data, classes, value) {
	      var changed = false;
	      if (classes) {
	        classes = isString(classes) ? classes.split(' ') :
	                  isArray(classes) ? classes : [];
	        forEach(classes, function(className) {
	          if (className) {
	            changed = true;
	            data[className] = value;
	          }
	        });
	      }
	      return changed;
	    }
	
	    function handleCSSClassChanges() {
	      forEach(postDigestElements, function(element) {
	        var data = postDigestQueue.get(element);
	        if (data) {
	          var existing = splitClasses(element.attr('class'));
	          var toAdd = '';
	          var toRemove = '';
	          forEach(data, function(status, className) {
	            var hasClass = !!existing[className];
	            if (status !== hasClass) {
	              if (status) {
	                toAdd += (toAdd.length ? ' ' : '') + className;
	              } else {
	                toRemove += (toRemove.length ? ' ' : '') + className;
	              }
	            }
	          });
	
	          forEach(element, function(elm) {
	            if (toAdd) {
	              jqLiteAddClass(elm, toAdd);
	            }
	            if (toRemove) {
	              jqLiteRemoveClass(elm, toRemove);
	            }
	          });
	          postDigestQueue.delete(element);
	        }
	      });
	      postDigestElements.length = 0;
	    }
	
	
	    function addRemoveClassesPostDigest(element, add, remove) {
	      var data = postDigestQueue.get(element) || {};
	
	      var classesAdded = updateData(data, add, true);
	      var classesRemoved = updateData(data, remove, false);
	
	      if (classesAdded || classesRemoved) {
	
	        postDigestQueue.set(element, data);
	        postDigestElements.push(element);
	
	        if (postDigestElements.length === 1) {
	          $rootScope.$$postDigest(handleCSSClassChanges);
	        }
	      }
	    }
	  }];
	};
	
	/**
	 * @ngdoc provider
	 * @name $animateProvider
	 *
	 * @description
	 * Default implementation of $animate that doesn't perform any animations, instead just
	 * synchronously performs DOM updates and resolves the returned runner promise.
	 *
	 * In order to enable animations the `ngAnimate` module has to be loaded.
	 *
	 * To see the functional implementation check out `src/ngAnimate/animate.js`.
	 */
	var $AnimateProvider = ['$provide', /** @this */ function($provide) {
	  var provider = this;
	  var classNameFilter = null;
	
	  this.$$registeredAnimations = Object.create(null);
	
	   /**
	   * @ngdoc method
	   * @name $animateProvider#register
	   *
	   * @description
	   * Registers a new injectable animation factory function. The factory function produces the
	   * animation object which contains callback functions for each event that is expected to be
	   * animated.
	   *
	   *   * `eventFn`: `function(element, ... , doneFunction, options)`
	   *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
	   *   on the type of animation additional arguments will be injected into the animation function. The
	   *   list below explains the function signatures for the different animation methods:
	   *
	   *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
	   *   - addClass: function(element, addedClasses, doneFunction, options)
	   *   - removeClass: function(element, removedClasses, doneFunction, options)
	   *   - enter, leave, move: function(element, doneFunction, options)
	   *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
	   *
	   *   Make sure to trigger the `doneFunction` once the animation is fully complete.
	   *
	   * ```js
	   *   return {
	   *     //enter, leave, move signature
	   *     eventFn : function(element, done, options) {
	   *       //code to run the animation
	   *       //once complete, then run done()
	   *       return function endFunction(wasCancelled) {
	   *         //code to cancel the animation
	   *       }
	   *     }
	   *   }
	   * ```
	   *
	   * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
	   * @param {Function} factory The factory function that will be executed to return the animation
	   *                           object.
	   */
	  this.register = function(name, factory) {
	    if (name && name.charAt(0) !== '.') {
	      throw $animateMinErr('notcsel', 'Expecting class selector starting with \'.\' got \'{0}\'.', name);
	    }
	
	    var key = name + '-animation';
	    provider.$$registeredAnimations[name.substr(1)] = key;
	    $provide.factory(key, factory);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $animateProvider#classNameFilter
	   *
	   * @description
	   * Sets and/or returns the CSS class regular expression that is checked when performing
	   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
	   * therefore enable $animate to attempt to perform an animation on any element that is triggered.
	   * When setting the `classNameFilter` value, animations will only be performed on elements
	   * that successfully match the filter expression. This in turn can boost performance
	   * for low-powered devices as well as applications containing a lot of structural operations.
	   * @param {RegExp=} expression The className expression which will be checked against all animations
	   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
	   */
	  this.classNameFilter = function(expression) {
	    if (arguments.length === 1) {
	      classNameFilter = (expression instanceof RegExp) ? expression : null;
	      if (classNameFilter) {
	        var reservedRegex = new RegExp('[(\\s|\\/)]' + NG_ANIMATE_CLASSNAME + '[(\\s|\\/)]');
	        if (reservedRegex.test(classNameFilter.toString())) {
	          classNameFilter = null;
	          throw $animateMinErr('nongcls', '$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);
	        }
	      }
	    }
	    return classNameFilter;
	  };
	
	  this.$get = ['$$animateQueue', function($$animateQueue) {
	    function domInsert(element, parentElement, afterElement) {
	      // if for some reason the previous element was removed
	      // from the dom sometime before this code runs then let's
	      // just stick to using the parent element as the anchor
	      if (afterElement) {
	        var afterNode = extractElementNode(afterElement);
	        if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
	          afterElement = null;
	        }
	      }
	      if (afterElement) {
	        afterElement.after(element);
	      } else {
	        parentElement.prepend(element);
	      }
	    }
	
	    /**
	     * @ngdoc service
	     * @name $animate
	     * @description The $animate service exposes a series of DOM utility methods that provide support
	     * for animation hooks. The default behavior is the application of DOM operations, however,
	     * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
	     * to ensure that animation runs with the triggered DOM operation.
	     *
	     * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
	     * included and only when it is active then the animation hooks that `$animate` triggers will be
	     * functional. Once active then all structural `ng-` directives will trigger animations as they perform
	     * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
	     * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
	     *
	     * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
	     *
	     * To learn more about enabling animation support, click here to visit the
	     * {@link ngAnimate ngAnimate module page}.
	     */
	    return {
	      // we don't call it directly since non-existant arguments may
	      // be interpreted as null within the sub enabled function
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#on
	       * @kind function
	       * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
	       *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
	       *    is fired with the following params:
	       *
	       * ```js
	       * $animate.on('enter', container,
	       *    function callback(element, phase) {
	       *      // cool we detected an enter animation within the container
	       *    }
	       * );
	       * ```
	       *
	       * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
	       * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
	       *     as well as among its children
	       * @param {Function} callback the callback function that will be fired when the listener is triggered
	       *
	       * The arguments present in the callback function are:
	       * * `element` - The captured DOM element that the animation was fired on.
	       * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
	       */
	      on: $$animateQueue.on,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#off
	       * @kind function
	       * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
	       * can be used in three different ways depending on the arguments:
	       *
	       * ```js
	       * // remove all the animation event listeners listening for `enter`
	       * $animate.off('enter');
	       *
	       * // remove listeners for all animation events from the container element
	       * $animate.off(container);
	       *
	       * // remove all the animation event listeners listening for `enter` on the given element and its children
	       * $animate.off('enter', container);
	       *
	       * // remove the event listener function provided by `callback` that is set
	       * // to listen for `enter` on the given `container` as well as its children
	       * $animate.off('enter', container, callback);
	       * ```
	       *
	       * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
	       * addClass, removeClass, etc...), or the container element. If it is the element, all other
	       * arguments are ignored.
	       * @param {DOMElement=} container the container element the event listener was placed on
	       * @param {Function=} callback the callback function that was registered as the listener
	       */
	      off: $$animateQueue.off,
	
	      /**
	       * @ngdoc method
	       * @name $animate#pin
	       * @kind function
	       * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
	       *    outside of the DOM structure of the Angular application. By doing so, any animation triggered via `$animate` can be issued on the
	       *    element despite being outside the realm of the application or within another application. Say for example if the application
	       *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
	       *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
	       *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
	       *
	       *    Note that this feature is only active when the `ngAnimate` module is used.
	       *
	       * @param {DOMElement} element the external element that will be pinned
	       * @param {DOMElement} parentElement the host parent element that will be associated with the external element
	       */
	      pin: $$animateQueue.pin,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enabled
	       * @kind function
	       * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
	       * function can be called in four ways:
	       *
	       * ```js
	       * // returns true or false
	       * $animate.enabled();
	       *
	       * // changes the enabled state for all animations
	       * $animate.enabled(false);
	       * $animate.enabled(true);
	       *
	       * // returns true or false if animations are enabled for an element
	       * $animate.enabled(element);
	       *
	       * // changes the enabled state for an element and its children
	       * $animate.enabled(element, true);
	       * $animate.enabled(element, false);
	       * ```
	       *
	       * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
	       * @param {boolean=} enabled whether or not the animations will be enabled for the element
	       *
	       * @return {boolean} whether or not animations are enabled
	       */
	      enabled: $$animateQueue.enabled,
	
	      /**
	       * @ngdoc method
	       * @name $animate#cancel
	       * @kind function
	       * @description Cancels the provided animation.
	       *
	       * @param {Promise} animationPromise The animation promise that is returned when an animation is started.
	       */
	      cancel: function(runner) {
	        if (runner.end) {
	          runner.end();
	        }
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enter
	       * @kind function
	       * @description Inserts the element into the DOM either after the `after` element (if provided) or
	       *   as the first child within the `parent` element and then triggers an animation.
	       *   A promise is returned that will be resolved during the next digest once the animation
	       *   has completed.
	       *
	       * @param {DOMElement} element the element which will be inserted into the DOM
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      enter: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'enter', prepareAnimateOptions(options));
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#move
	       * @kind function
	       * @description Inserts (moves) the element into its new position in the DOM either after
	       *   the `after` element (if provided) or as the first child within the `parent` element
	       *   and then triggers an animation. A promise is returned that will be resolved
	       *   during the next digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be moved into the new DOM position
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      move: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'move', prepareAnimateOptions(options));
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#leave
	       * @kind function
	       * @description Triggers an animation and then removes the element from the DOM.
	       * When the function is called a promise is returned that will be resolved during the next
	       * digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be removed from the DOM
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      leave: function(element, options) {
	        return $$animateQueue.push(element, 'leave', prepareAnimateOptions(options), function() {
	          element.remove();
	        });
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#addClass
	       * @kind function
	       *
	       * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
	       *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element already contains the CSS class or if the class is removed at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      addClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addclass, className);
	        return $$animateQueue.push(element, 'addClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#removeClass
	       * @kind function
	       *
	       * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
	       *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element does not contain the CSS class or if the class is added at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      removeClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.removeClass = mergeClasses(options.removeClass, className);
	        return $$animateQueue.push(element, 'removeClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#setClass
	       * @kind function
	       *
	       * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
	       *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
	       *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
	       *    passed. Note that class-based animations are treated differently compared to structural animations
	       *    (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *    depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      setClass: function(element, add, remove, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addClass, add);
	        options.removeClass = mergeClasses(options.removeClass, remove);
	        return $$animateQueue.push(element, 'setClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#animate
	       * @kind function
	       *
	       * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
	       * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
	       * on the provided styles. For example, if a transition animation is set for the given className, then the provided `from` and
	       * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
	       * style in `to`, the style in `from` is applied immediately, and no animation is run.
	       * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
	       * method (or as part of the `options` parameter):
	       *
	       * ```js
	       * ngModule.animation('.my-inline-animation', function() {
	       *   return {
	       *     animate : function(element, from, to, done, options) {
	       *       //animation
	       *       done();
	       *     }
	       *   }
	       * });
	       * ```
	       *
	       * @param {DOMElement} element the element which the CSS styles will be applied to
	       * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
	       * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
	       * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
	       *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
	       *    (Note that if no animation is detected then this value will not be applied to the element.)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      animate: function(element, from, to, className, options) {
	        options = prepareAnimateOptions(options);
	        options.from = options.from ? extend(options.from, from) : from;
	        options.to   = options.to   ? extend(options.to, to)     : to;
	
	        className = className || 'ng-inline-animate';
	        options.tempClasses = mergeClasses(options.tempClasses, className);
	        return $$animateQueue.push(element, 'animate', options);
	      }
	    };
	  }];
	}];
	
	var $$AnimateAsyncRunFactoryProvider = /** @this */ function() {
	  this.$get = ['$$rAF', function($$rAF) {
	    var waitQueue = [];
	
	    function waitForTick(fn) {
	      waitQueue.push(fn);
	      if (waitQueue.length > 1) return;
	      $$rAF(function() {
	        for (var i = 0; i < waitQueue.length; i++) {
	          waitQueue[i]();
	        }
	        waitQueue = [];
	      });
	    }
	
	    return function() {
	      var passed = false;
	      waitForTick(function() {
	        passed = true;
	      });
	      return function(callback) {
	        if (passed) {
	          callback();
	        } else {
	          waitForTick(callback);
	        }
	      };
	    };
	  }];
	};
	
	var $$AnimateRunnerFactoryProvider = /** @this */ function() {
	  this.$get = ['$q', '$sniffer', '$$animateAsyncRun', '$$isDocumentHidden', '$timeout',
	       function($q,   $sniffer,   $$animateAsyncRun,   $$isDocumentHidden,   $timeout) {
	
	    var INITIAL_STATE = 0;
	    var DONE_PENDING_STATE = 1;
	    var DONE_COMPLETE_STATE = 2;
	
	    AnimateRunner.chain = function(chain, callback) {
	      var index = 0;
	
	      next();
	      function next() {
	        if (index === chain.length) {
	          callback(true);
	          return;
	        }
	
	        chain[index](function(response) {
	          if (response === false) {
	            callback(false);
	            return;
	          }
	          index++;
	          next();
	        });
	      }
	    };
	
	    AnimateRunner.all = function(runners, callback) {
	      var count = 0;
	      var status = true;
	      forEach(runners, function(runner) {
	        runner.done(onProgress);
	      });
	
	      function onProgress(response) {
	        status = status && response;
	        if (++count === runners.length) {
	          callback(status);
	        }
	      }
	    };
	
	    function AnimateRunner(host) {
	      this.setHost(host);
	
	      var rafTick = $$animateAsyncRun();
	      var timeoutTick = function(fn) {
	        $timeout(fn, 0, false);
	      };
	
	      this._doneCallbacks = [];
	      this._tick = function(fn) {
	        if ($$isDocumentHidden()) {
	          timeoutTick(fn);
	        } else {
	          rafTick(fn);
	        }
	      };
	      this._state = 0;
	    }
	
	    AnimateRunner.prototype = {
	      setHost: function(host) {
	        this.host = host || {};
	      },
	
	      done: function(fn) {
	        if (this._state === DONE_COMPLETE_STATE) {
	          fn();
	        } else {
	          this._doneCallbacks.push(fn);
	        }
	      },
	
	      progress: noop,
	
	      getPromise: function() {
	        if (!this.promise) {
	          var self = this;
	          this.promise = $q(function(resolve, reject) {
	            self.done(function(status) {
	              if (status === false) {
	                reject();
	              } else {
	                resolve();
	              }
	            });
	          });
	        }
	        return this.promise;
	      },
	
	      then: function(resolveHandler, rejectHandler) {
	        return this.getPromise().then(resolveHandler, rejectHandler);
	      },
	
	      'catch': function(handler) {
	        return this.getPromise()['catch'](handler);
	      },
	
	      'finally': function(handler) {
	        return this.getPromise()['finally'](handler);
	      },
	
	      pause: function() {
	        if (this.host.pause) {
	          this.host.pause();
	        }
	      },
	
	      resume: function() {
	        if (this.host.resume) {
	          this.host.resume();
	        }
	      },
	
	      end: function() {
	        if (this.host.end) {
	          this.host.end();
	        }
	        this._resolve(true);
	      },
	
	      cancel: function() {
	        if (this.host.cancel) {
	          this.host.cancel();
	        }
	        this._resolve(false);
	      },
	
	      complete: function(response) {
	        var self = this;
	        if (self._state === INITIAL_STATE) {
	          self._state = DONE_PENDING_STATE;
	          self._tick(function() {
	            self._resolve(response);
	          });
	        }
	      },
	
	      _resolve: function(response) {
	        if (this._state !== DONE_COMPLETE_STATE) {
	          forEach(this._doneCallbacks, function(fn) {
	            fn(response);
	          });
	          this._doneCallbacks.length = 0;
	          this._state = DONE_COMPLETE_STATE;
	        }
	      }
	    };
	
	    return AnimateRunner;
	  }];
	};
	
	/* exported $CoreAnimateCssProvider */
	
	/**
	 * @ngdoc service
	 * @name $animateCss
	 * @kind object
	 * @this
	 *
	 * @description
	 * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
	 * then the `$animateCss` service will actually perform animations.
	 *
	 * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
	 */
	var $CoreAnimateCssProvider = function() {
	  this.$get = ['$$rAF', '$q', '$$AnimateRunner', function($$rAF, $q, $$AnimateRunner) {
	
	    return function(element, initialOptions) {
	      // all of the animation functions should create
	      // a copy of the options data, however, if a
	      // parent service has already created a copy then
	      // we should stick to using that
	      var options = initialOptions || {};
	      if (!options.$$prepared) {
	        options = copy(options);
	      }
	
	      // there is no point in applying the styles since
	      // there is no animation that goes on at all in
	      // this version of $animateCss.
	      if (options.cleanupStyles) {
	        options.from = options.to = null;
	      }
	
	      if (options.from) {
	        element.css(options.from);
	        options.from = null;
	      }
	
	      var closed, runner = new $$AnimateRunner();
	      return {
	        start: run,
	        end: run
	      };
	
	      function run() {
	        $$rAF(function() {
	          applyAnimationContents();
	          if (!closed) {
	            runner.complete();
	          }
	          closed = true;
	        });
	        return runner;
	      }
	
	      function applyAnimationContents() {
	        if (options.addClass) {
	          element.addClass(options.addClass);
	          options.addClass = null;
	        }
	        if (options.removeClass) {
	          element.removeClass(options.removeClass);
	          options.removeClass = null;
	        }
	        if (options.to) {
	          element.css(options.to);
	          options.to = null;
	        }
	      }
	    };
	  }];
	};
	
	/* global stripHash: true */
	
	/**
	 * ! This is a private undocumented service !
	 *
	 * @name $browser
	 * @requires $log
	 * @description
	 * This object has two goals:
	 *
	 * - hide all the global state in the browser caused by the window object
	 * - abstract away all the browser specific features and inconsistencies
	 *
	 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
	 * service, which can be used for convenient testing of the application without the interaction with
	 * the real browser apis.
	 */
	/**
	 * @param {object} window The global window object.
	 * @param {object} document jQuery wrapped document.
	 * @param {object} $log window.console or an object with the same interface.
	 * @param {object} $sniffer $sniffer service
	 */
	function Browser(window, document, $log, $sniffer) {
	  var self = this,
	      location = window.location,
	      history = window.history,
	      setTimeout = window.setTimeout,
	      clearTimeout = window.clearTimeout,
	      pendingDeferIds = {};
	
	  self.isMock = false;
	
	  var outstandingRequestCount = 0;
	  var outstandingRequestCallbacks = [];
	
	  // TODO(vojta): remove this temporary api
	  self.$$completeOutstandingRequest = completeOutstandingRequest;
	  self.$$incOutstandingRequestCount = function() { outstandingRequestCount++; };
	
	  /**
	   * Executes the `fn` function(supports currying) and decrements the `outstandingRequestCallbacks`
	   * counter. If the counter reaches 0, all the `outstandingRequestCallbacks` are executed.
	   */
	  function completeOutstandingRequest(fn) {
	    try {
	      fn.apply(null, sliceArgs(arguments, 1));
	    } finally {
	      outstandingRequestCount--;
	      if (outstandingRequestCount === 0) {
	        while (outstandingRequestCallbacks.length) {
	          try {
	            outstandingRequestCallbacks.pop()();
	          } catch (e) {
	            $log.error(e);
	          }
	        }
	      }
	    }
	  }
	
	  function getHash(url) {
	    var index = url.indexOf('#');
	    return index === -1 ? '' : url.substr(index);
	  }
	
	  /**
	   * @private
	   * Note: this method is used only by scenario runner
	   * TODO(vojta): prefix this method with $$ ?
	   * @param {function()} callback Function that will be called when no outstanding request
	   */
	  self.notifyWhenNoOutstandingRequests = function(callback) {
	    if (outstandingRequestCount === 0) {
	      callback();
	    } else {
	      outstandingRequestCallbacks.push(callback);
	    }
	  };
	
	  //////////////////////////////////////////////////////////////
	  // URL API
	  //////////////////////////////////////////////////////////////
	
	  var cachedState, lastHistoryState,
	      lastBrowserUrl = location.href,
	      baseElement = document.find('base'),
	      pendingLocation = null,
	      getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
	        try {
	          return history.state;
	        } catch (e) {
	          // MSIE can reportedly throw when there is no state (UNCONFIRMED).
	        }
	      };
	
	  cacheState();
	
	  /**
	   * @name $browser#url
	   *
	   * @description
	   * GETTER:
	   * Without any argument, this method just returns current value of location.href.
	   *
	   * SETTER:
	   * With at least one argument, this method sets url to new value.
	   * If html5 history api supported, pushState/replaceState is used, otherwise
	   * location.href/location.replace is used.
	   * Returns its own instance to allow chaining
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to change url.
	   *
	   * @param {string} url New url (when used as setter)
	   * @param {boolean=} replace Should new url replace current history record?
	   * @param {object=} state object to use with pushState/replaceState
	   */
	  self.url = function(url, replace, state) {
	    // In modern browsers `history.state` is `null` by default; treating it separately
	    // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
	    // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
	    if (isUndefined(state)) {
	      state = null;
	    }
	
	    // Android Browser BFCache causes location, history reference to become stale.
	    if (location !== window.location) location = window.location;
	    if (history !== window.history) history = window.history;
	
	    // setter
	    if (url) {
	      var sameState = lastHistoryState === state;
	
	      // Don't change anything if previous and current URLs and states match. This also prevents
	      // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
	      // See https://github.com/angular/angular.js/commit/ffb2701
	      if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
	        return self;
	      }
	      var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
	      lastBrowserUrl = url;
	      lastHistoryState = state;
	      // Don't use history API if only the hash changed
	      // due to a bug in IE10/IE11 which leads
	      // to not firing a `hashchange` nor `popstate` event
	      // in some cases (see #9143).
	      if ($sniffer.history && (!sameBase || !sameState)) {
	        history[replace ? 'replaceState' : 'pushState'](state, '', url);
	        cacheState();
	      } else {
	        if (!sameBase) {
	          pendingLocation = url;
	        }
	        if (replace) {
	          location.replace(url);
	        } else if (!sameBase) {
	          location.href = url;
	        } else {
	          location.hash = getHash(url);
	        }
	        if (location.href !== url) {
	          pendingLocation = url;
	        }
	      }
	      if (pendingLocation) {
	        pendingLocation = url;
	      }
	      return self;
	    // getter
	    } else {
	      // - pendingLocation is needed as browsers don't allow to read out
	      //   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
	      //   https://openradar.appspot.com/22186109).
	      // - the replacement is a workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=407172
	      return pendingLocation || location.href.replace(/%27/g,'\'');
	    }
	  };
	
	  /**
	   * @name $browser#state
	   *
	   * @description
	   * This method is a getter.
	   *
	   * Return history.state or null if history.state is undefined.
	   *
	   * @returns {object} state
	   */
	  self.state = function() {
	    return cachedState;
	  };
	
	  var urlChangeListeners = [],
	      urlChangeInit = false;
	
	  function cacheStateAndFireUrlChange() {
	    pendingLocation = null;
	    fireStateOrUrlChange();
	  }
	
	  // This variable should be used *only* inside the cacheState function.
	  var lastCachedState = null;
	  function cacheState() {
	    // This should be the only place in $browser where `history.state` is read.
	    cachedState = getCurrentState();
	    cachedState = isUndefined(cachedState) ? null : cachedState;
	
	    // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
	    if (equals(cachedState, lastCachedState)) {
	      cachedState = lastCachedState;
	    }
	
	    lastCachedState = cachedState;
	    lastHistoryState = cachedState;
	  }
	
	  function fireStateOrUrlChange() {
	    var prevLastHistoryState = lastHistoryState;
	    cacheState();
	
	    if (lastBrowserUrl === self.url() && prevLastHistoryState === cachedState) {
	      return;
	    }
	
	    lastBrowserUrl = self.url();
	    lastHistoryState = cachedState;
	    forEach(urlChangeListeners, function(listener) {
	      listener(self.url(), cachedState);
	    });
	  }
	
	  /**
	   * @name $browser#onUrlChange
	   *
	   * @description
	   * Register callback function that will be called, when url changes.
	   *
	   * It's only called when the url is changed from outside of angular:
	   * - user types different url into address bar
	   * - user clicks on history (forward/back) button
	   * - user clicks on a link
	   *
	   * It's not called when url is changed by $browser.url() method
	   *
	   * The listener gets called with new url as parameter.
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to monitor url changes in angular apps.
	   *
	   * @param {function(string)} listener Listener function to be called when url changes.
	   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
	   */
	  self.onUrlChange = function(callback) {
	    // TODO(vojta): refactor to use node's syntax for events
	    if (!urlChangeInit) {
	      // We listen on both (hashchange/popstate) when available, as some browsers don't
	      // fire popstate when user changes the address bar and don't fire hashchange when url
	      // changed by push/replaceState
	
	      // html5 history api - popstate event
	      if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
	      // hashchange event
	      jqLite(window).on('hashchange', cacheStateAndFireUrlChange);
	
	      urlChangeInit = true;
	    }
	
	    urlChangeListeners.push(callback);
	    return callback;
	  };
	
	  /**
	   * @private
	   * Remove popstate and hashchange handler from window.
	   *
	   * NOTE: this api is intended for use only by $rootScope.
	   */
	  self.$$applicationDestroyed = function() {
	    jqLite(window).off('hashchange popstate', cacheStateAndFireUrlChange);
	  };
	
	  /**
	   * Checks whether the url has changed outside of Angular.
	   * Needs to be exported to be able to check for changes that have been done in sync,
	   * as hashchange/popstate events fire in async.
	   */
	  self.$$checkUrlChange = fireStateOrUrlChange;
	
	  //////////////////////////////////////////////////////////////
	  // Misc API
	  //////////////////////////////////////////////////////////////
	
	  /**
	   * @name $browser#baseHref
	   *
	   * @description
	   * Returns current <base href>
	   * (always relative - without domain)
	   *
	   * @returns {string} The current base href
	   */
	  self.baseHref = function() {
	    var href = baseElement.attr('href');
	    return href ? href.replace(/^(https?:)?\/\/[^/]*/, '') : '';
	  };
	
	  /**
	   * @name $browser#defer
	   * @param {function()} fn A function, who's execution should be deferred.
	   * @param {number=} [delay=0] of milliseconds to defer the function execution.
	   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
	   *
	   * @description
	   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
	   *
	   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
	   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
	   * via `$browser.defer.flush()`.
	   *
	   */
	  self.defer = function(fn, delay) {
	    var timeoutId;
	    outstandingRequestCount++;
	    timeoutId = setTimeout(function() {
	      delete pendingDeferIds[timeoutId];
	      completeOutstandingRequest(fn);
	    }, delay || 0);
	    pendingDeferIds[timeoutId] = true;
	    return timeoutId;
	  };
	
	
	  /**
	   * @name $browser#defer.cancel
	   *
	   * @description
	   * Cancels a deferred task identified with `deferId`.
	   *
	   * @param {*} deferId Token returned by the `$browser.defer` function.
	   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	   *                    canceled.
	   */
	  self.defer.cancel = function(deferId) {
	    if (pendingDeferIds[deferId]) {
	      delete pendingDeferIds[deferId];
	      clearTimeout(deferId);
	      completeOutstandingRequest(noop);
	      return true;
	    }
	    return false;
	  };
	
	}
	
	/** @this */
	function $BrowserProvider() {
	  this.$get = ['$window', '$log', '$sniffer', '$document',
	      function($window, $log, $sniffer, $document) {
	        return new Browser($window, $document, $log, $sniffer);
	      }];
	}
	
	/**
	 * @ngdoc service
	 * @name $cacheFactory
	 * @this
	 *
	 * @description
	 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
	 * them.
	 *
	 * ```js
	 *
	 *  var cache = $cacheFactory('cacheId');
	 *  expect($cacheFactory.get('cacheId')).toBe(cache);
	 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
	 *
	 *  cache.put("key", "value");
	 *  cache.put("another key", "another value");
	 *
	 *  // We've specified no options on creation
	 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
	 *
	 * ```
	 *
	 *
	 * @param {string} cacheId Name or id of the newly created cache.
	 * @param {object=} options Options object that specifies the cache behavior. Properties:
	 *
	 *   - `{number=}` `capacity` — turns the cache into LRU cache.
	 *
	 * @returns {object} Newly created cache object with the following set of methods:
	 *
	 * - `{object}` `info()` — Returns id, size, and options of cache.
	 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
	 *   it.
	 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
	 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
	 * - `{void}` `removeAll()` — Removes all cached values.
	 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
	 *
	 * @example
	   <example module="cacheExampleApp" name="cache-factory">
	     <file name="index.html">
	       <div ng-controller="CacheController">
	         <input ng-model="newCacheKey" placeholder="Key">
	         <input ng-model="newCacheValue" placeholder="Value">
	         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>
	
	         <p ng-if="keys.length">Cached Values</p>
	         <div ng-repeat="key in keys">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="cache.get(key)"></b>
	         </div>
	
	         <p>Cache Info</p>
	         <div ng-repeat="(key, value) in cache.info()">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="value"></b>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('cacheExampleApp', []).
	         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
	           $scope.keys = [];
	           $scope.cache = $cacheFactory('cacheId');
	           $scope.put = function(key, value) {
	             if (angular.isUndefined($scope.cache.get(key))) {
	               $scope.keys.push(key);
	             }
	             $scope.cache.put(key, angular.isUndefined(value) ? null : value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       p {
	         margin: 10px 0 3px;
	       }
	     </file>
	   </example>
	 */
	function $CacheFactoryProvider() {
	
	  this.$get = function() {
	    var caches = {};
	
	    function cacheFactory(cacheId, options) {
	      if (cacheId in caches) {
	        throw minErr('$cacheFactory')('iid', 'CacheId \'{0}\' is already taken!', cacheId);
	      }
	
	      var size = 0,
	          stats = extend({}, options, {id: cacheId}),
	          data = createMap(),
	          capacity = (options && options.capacity) || Number.MAX_VALUE,
	          lruHash = createMap(),
	          freshEnd = null,
	          staleEnd = null;
	
	      /**
	       * @ngdoc type
	       * @name $cacheFactory.Cache
	       *
	       * @description
	       * A cache object used to store and retrieve data, primarily used by
	       * {@link $http $http} and the {@link ng.directive:script script} directive to cache
	       * templates and other data.
	       *
	       * ```js
	       *  angular.module('superCache')
	       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
	       *      return $cacheFactory('super-cache');
	       *    }]);
	       * ```
	       *
	       * Example test:
	       *
	       * ```js
	       *  it('should behave like a cache', inject(function(superCache) {
	       *    superCache.put('key', 'value');
	       *    superCache.put('another key', 'another value');
	       *
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 2
	       *    });
	       *
	       *    superCache.remove('another key');
	       *    expect(superCache.get('another key')).toBeUndefined();
	       *
	       *    superCache.removeAll();
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 0
	       *    });
	       *  }));
	       * ```
	       */
	      return (caches[cacheId] = {
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#put
	         * @kind function
	         *
	         * @description
	         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
	         * retrieved later, and incrementing the size of the cache if the key was not already
	         * present in the cache. If behaving like an LRU cache, it will also remove stale
	         * entries from the set.
	         *
	         * It will not insert undefined values into the cache.
	         *
	         * @param {string} key the key under which the cached data is stored.
	         * @param {*} value the value to store alongside the key. If it is undefined, the key
	         *    will not be stored.
	         * @returns {*} the value stored.
	         */
	        put: function(key, value) {
	          if (isUndefined(value)) return;
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key] || (lruHash[key] = {key: key});
	
	            refresh(lruEntry);
	          }
	
	          if (!(key in data)) size++;
	          data[key] = value;
	
	          if (size > capacity) {
	            this.remove(staleEnd.key);
	          }
	
	          return value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#get
	         * @kind function
	         *
	         * @description
	         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the data to be retrieved
	         * @returns {*} the value stored.
	         */
	        get: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            refresh(lruEntry);
	          }
	
	          return data[key];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#remove
	         * @kind function
	         *
	         * @description
	         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the entry to be removed
	         */
	        remove: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            if (lruEntry === freshEnd) freshEnd = lruEntry.p;
	            if (lruEntry === staleEnd) staleEnd = lruEntry.n;
	            link(lruEntry.n,lruEntry.p);
	
	            delete lruHash[key];
	          }
	
	          if (!(key in data)) return;
	
	          delete data[key];
	          size--;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#removeAll
	         * @kind function
	         *
	         * @description
	         * Clears the cache object of any entries.
	         */
	        removeAll: function() {
	          data = createMap();
	          size = 0;
	          lruHash = createMap();
	          freshEnd = staleEnd = null;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#destroy
	         * @kind function
	         *
	         * @description
	         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
	         * removing it from the {@link $cacheFactory $cacheFactory} set.
	         */
	        destroy: function() {
	          data = null;
	          stats = null;
	          lruHash = null;
	          delete caches[cacheId];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#info
	         * @kind function
	         *
	         * @description
	         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
	         *
	         * @returns {object} an object with the following properties:
	         *   <ul>
	         *     <li>**id**: the id of the cache instance</li>
	         *     <li>**size**: the number of entries kept in the cache instance</li>
	         *     <li>**...**: any additional properties from the options object when creating the
	         *       cache.</li>
	         *   </ul>
	         */
	        info: function() {
	          return extend({}, stats, {size: size});
	        }
	      });
	
	
	      /**
	       * makes the `entry` the freshEnd of the LRU linked list
	       */
	      function refresh(entry) {
	        if (entry !== freshEnd) {
	          if (!staleEnd) {
	            staleEnd = entry;
	          } else if (staleEnd === entry) {
	            staleEnd = entry.n;
	          }
	
	          link(entry.n, entry.p);
	          link(entry, freshEnd);
	          freshEnd = entry;
	          freshEnd.n = null;
	        }
	      }
	
	
	      /**
	       * bidirectionally links two entries of the LRU linked list
	       */
	      function link(nextEntry, prevEntry) {
	        if (nextEntry !== prevEntry) {
	          if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
	          if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
	        }
	      }
	    }
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#info
	   *
	   * @description
	   * Get information about all the caches that have been created
	   *
	   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
	   */
	    cacheFactory.info = function() {
	      var info = {};
	      forEach(caches, function(cache, cacheId) {
	        info[cacheId] = cache.info();
	      });
	      return info;
	    };
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#get
	   *
	   * @description
	   * Get access to a cache object by the `cacheId` used when it was created.
	   *
	   * @param {string} cacheId Name or id of a cache to access.
	   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
	   */
	    cacheFactory.get = function(cacheId) {
	      return caches[cacheId];
	    };
	
	
	    return cacheFactory;
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $templateCache
	 * @this
	 *
	 * @description
	 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
	 * can load templates directly into the cache in a `script` tag, or by consuming the
	 * `$templateCache` service directly.
	 *
	 * Adding via the `script` tag:
	 *
	 * ```html
	 *   <script type="text/ng-template" id="templateId.html">
	 *     <p>This is the content of the template</p>
	 *   </script>
	 * ```
	 *
	 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
	 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (IE,
	 * element with ng-app attribute), otherwise the template will be ignored.
	 *
	 * Adding via the `$templateCache` service:
	 *
	 * ```js
	 * var myApp = angular.module('myApp', []);
	 * myApp.run(function($templateCache) {
	 *   $templateCache.put('templateId.html', 'This is the content of the template');
	 * });
	 * ```
	 *
	 * To retrieve the template later, simply use it in your component:
	 * ```js
	 * myApp.component('myComponent', {
	 *    templateUrl: 'templateId.html'
	 * });
	 * ```
	 *
	 * or get it via the `$templateCache` service:
	 * ```js
	 * $templateCache.get('templateId.html')
	 * ```
	 *
	 * See {@link ng.$cacheFactory $cacheFactory}.
	 *
	 */
	function $TemplateCacheProvider() {
	  this.$get = ['$cacheFactory', function($cacheFactory) {
	    return $cacheFactory('templates');
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables like document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
	 *
	 * DOM-related variables:
	 *
	 * - "node" - DOM Node
	 * - "element" - DOM Element or Node
	 * - "$node" or "$element" - jqLite-wrapped node or element
	 *
	 *
	 * Compiler related stuff:
	 *
	 * - "linkFn" - linking fn of a single directive
	 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
	 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
	 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $compile
	 * @kind function
	 *
	 * @description
	 * Compiles an HTML string or DOM into a template and produces a template function, which
	 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
	 *
	 * The compilation is a process of walking the DOM tree and matching DOM elements to
	 * {@link ng.$compileProvider#directive directives}.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** This document is an in-depth reference of all directive options.
	 * For a gentle introduction to directives with examples of common use cases,
	 * see the {@link guide/directive directive guide}.
	 * </div>
	 *
	 * ## Comprehensive Directive API
	 *
	 * There are many different options for a directive.
	 *
	 * The difference resides in the return value of the factory function.
	 * You can either return a {@link $compile#directive-definition-object Directive Definition Object (see below)}
	 * that defines the directive properties, or just the `postLink` function (all other properties will have
	 * the default values).
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's recommended to use the "directive definition object" form.
	 * </div>
	 *
	 * Here's an example directive declared with a Directive Definition Object:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       {@link $compile#-priority- priority}: 0,
	 *       {@link $compile#-template- template}: '<div></div>', // or // function(tElement, tAttrs) { ... },
	 *       // or
	 *       // {@link $compile#-templateurl- templateUrl}: 'directive.html', // or // function(tElement, tAttrs) { ... },
	 *       {@link $compile#-transclude- transclude}: false,
	 *       {@link $compile#-restrict- restrict}: 'A',
	 *       {@link $compile#-templatenamespace- templateNamespace}: 'html',
	 *       {@link $compile#-scope- scope}: false,
	 *       {@link $compile#-controller- controller}: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
	 *       {@link $compile#-controlleras- controllerAs}: 'stringIdentifier',
	 *       {@link $compile#-bindtocontroller- bindToController}: false,
	 *       {@link $compile#-require- require}: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
	 *       {@link $compile#-multielement- multiElement}: false,
	 *       {@link $compile#-compile- compile}: function compile(tElement, tAttrs, transclude) {
	 *         return {
	 *            {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *            {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *         }
	 *         // or
	 *         // return function postLink( ... ) { ... }
	 *       },
	 *       // or
	 *       // {@link $compile#-link- link}: {
	 *       //  {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *       //  {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *       // }
	 *       // or
	 *       // {@link $compile#-link- link}: function postLink( ... ) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *   });
	 * ```
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Any unspecified options will use the default value. You can see the default values below.
	 * </div>
	 *
	 * Therefore the above can be simplified as:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       link: function postLink(scope, iElement, iAttrs) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *     // or
	 *     // return function postLink(scope, iElement, iAttrs) { ... }
	 *   });
	 * ```
	 *
	 * ### Life-cycle hooks
	 * Directive controllers can provide the following methods that are called by Angular at points in the life-cycle of the
	 * directive:
	 * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
	 *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
	 *   this element). This is a good place to put initialization code for your controller.
	 * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
	 *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
	 *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
	 *   component such as cloning the bound value to prevent accidental mutation of the outer value. Note that this will
	 *   also be called when your bindings are initialized.
	 * * `$doCheck()` - Called on each turn of the digest cycle. Provides an opportunity to detect and act on
	 *   changes. Any actions that you wish to take in response to the changes that you detect must be
	 *   invoked from this hook; implementing this has no effect on when `$onChanges` is called. For example, this hook
	 *   could be useful if you wish to perform a deep equality check, or to check a Date object, changes to which would not
	 *   be detected by Angular's change detector and thus not trigger `$onChanges`. This hook is invoked with no arguments;
	 *   if detecting changes, you must store the previous value(s) for comparison to the current values.
	 * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
	 *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
	 *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
	 *   components will have their `$onDestroy()` hook called before child components.
	 * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
	 *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
	 *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
	 *   they are waiting for their template to load asynchronously and their own compilation and linking has been
	 *   suspended until that occurs.
	 *
	 * #### Comparison with Angular 2 life-cycle hooks
	 * Angular 2 also uses life-cycle hooks for its components. While the Angular 1 life-cycle hooks are similar there are
	 * some differences that you should be aware of, especially when it comes to moving your code from Angular 1 to Angular 2:
	 *
	 * * Angular 1 hooks are prefixed with `$`, such as `$onInit`. Angular 2 hooks are prefixed with `ng`, such as `ngOnInit`.
	 * * Angular 1 hooks can be defined on the controller prototype or added to the controller inside its constructor.
	 *   In Angular 2 you can only define hooks on the prototype of the Component class.
	 * * Due to the differences in change-detection, you may get many more calls to `$doCheck` in Angular 1 than you would to
	 *   `ngDoCheck` in Angular 2
	 * * Changes to the model inside `$doCheck` will trigger new turns of the digest loop, which will cause the changes to be
	 *   propagated throughout the application.
	 *   Angular 2 does not allow the `ngDoCheck` hook to trigger a change outside of the component. It will either throw an
	 *   error or do nothing depending upon the state of `enableProdMode()`.
	 *
	 * #### Life-cycle hook examples
	 *
	 * This example shows how you can check for mutations to a Date object even though the identity of the object
	 * has not changed.
	 *
	 * <example name="doCheckDateExample" module="do-check-module">
	 *   <file name="app.js">
	 *     angular.module('do-check-module', [])
	 *       .component('app', {
	 *         template:
	 *           'Month: <input ng-model="$ctrl.month" ng-change="$ctrl.updateDate()">' +
	 *           'Date: {{ $ctrl.date }}' +
	 *           '<test date="$ctrl.date"></test>',
	 *         controller: function() {
	 *           this.date = new Date();
	 *           this.month = this.date.getMonth();
	 *           this.updateDate = function() {
	 *             this.date.setMonth(this.month);
	 *           };
	 *         }
	 *       })
	 *       .component('test', {
	 *         bindings: { date: '<' },
	 *         template:
	 *           '<pre>{{ $ctrl.log | json }}</pre>',
	 *         controller: function() {
	 *           var previousValue;
	 *           this.log = [];
	 *           this.$doCheck = function() {
	 *             var currentValue = this.date && this.date.valueOf();
	 *             if (previousValue !== currentValue) {
	 *               this.log.push('doCheck: date mutated: ' + this.date);
	 *               previousValue = currentValue;
	 *             }
	 *           };
	 *         }
	 *       });
	 *   </file>
	 *   <file name="index.html">
	 *     <app></app>
	 *   </file>
	 * </example>
	 *
	 * This example show how you might use `$doCheck` to trigger changes in your component's inputs even if the
	 * actual identity of the component doesn't change. (Be aware that cloning and deep equality checks on large
	 * arrays or objects can have a negative impact on your application performance)
	 *
	 * <example name="doCheckArrayExample" module="do-check-module">
	 *   <file name="index.html">
	 *     <div ng-init="items = []">
	 *       <button ng-click="items.push(items.length)">Add Item</button>
	 *       <button ng-click="items = []">Reset Items</button>
	 *       <pre>{{ items }}</pre>
	 *       <test items="items"></test>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *      angular.module('do-check-module', [])
	 *        .component('test', {
	 *          bindings: { items: '<' },
	 *          template:
	 *            '<pre>{{ $ctrl.log | json }}</pre>',
	 *          controller: function() {
	 *            this.log = [];
	 *
	 *            this.$doCheck = function() {
	 *              if (this.items_ref !== this.items) {
	 *                this.log.push('doCheck: items changed');
	 *                this.items_ref = this.items;
	 *              }
	 *              if (!angular.equals(this.items_clone, this.items)) {
	 *                this.log.push('doCheck: items mutated');
	 *                this.items_clone = angular.copy(this.items);
	 *              }
	 *            };
	 *          }
	 *        });
	 *   </file>
	 * </example>
	 *
	 *
	 * ### Directive Definition Object
	 *
	 * The directive definition object provides instructions to the {@link ng.$compile
	 * compiler}. The attributes are:
	 *
	 * #### `multiElement`
	 * When this property is set to true (default is `false`), the HTML compiler will collect DOM nodes between
	 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
	 * together as the directive elements. It is recommended that this feature be used on directives
	 * which are not strictly behavioral (such as {@link ngClick}), and which
	 * do not manipulate or replace child nodes (such as {@link ngInclude}).
	 *
	 * #### `priority`
	 * When there are multiple directives defined on a single DOM element, sometimes it
	 * is necessary to specify the order in which the directives are applied. The `priority` is used
	 * to sort the directives before their `compile` functions get called. Priority is defined as a
	 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
	 * are also run in priority order, but post-link functions are run in reverse order. The order
	 * of directives with the same priority is undefined. The default priority is `0`.
	 *
	 * #### `terminal`
	 * If set to true then the current `priority` will be the last set of directives
	 * which will execute (any directives at the current priority will still execute
	 * as the order of execution on same `priority` is undefined). Note that expressions
	 * and other directives used in the directive's template will also be excluded from execution.
	 *
	 * #### `scope`
	 * The scope property can be `false`, `true`, or an object:
	 *
	 * * **`false` (default):** No scope will be created for the directive. The directive will use its
	 * parent's scope.
	 *
	 * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
	 * the directive's element. If multiple directives on the same element request a new scope,
	 * only one new scope is created.
	 *
	 * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's template.
	 * The 'isolate' scope differs from normal scope in that it does not prototypically
	 * inherit from its parent scope. This is useful when creating reusable components, which should not
	 * accidentally read or modify data in the parent scope. Note that an isolate scope
	 * directive without a `template` or `templateUrl` will not apply the isolate scope
	 * to its children elements.
	 *
	 * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
	 * directive's element. These local properties are useful for aliasing values for templates. The keys in
	 * the object hash map to the name of the property on the isolate scope; the values define how the property
	 * is bound to the parent scope, via matching attributes on the directive's element:
	 *
	 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
	 *   always a string since DOM attributes are strings. If no `attr` name is specified then the
	 *   attribute name is assumed to be the same as the local name. Given `<my-component
	 *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
	 *   the directive's scope property `localName` will reflect the interpolated value of `hello
	 *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
	 *   scope. The `name` is read from the parent scope (not the directive's scope).
	 *
	 * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
	 *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
	 *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
	 *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
	 *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
	 *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
	 *   `localModel` and vice versa. Optional attributes should be marked as such with a question mark:
	 *   `=?` or `=?attr`. If the binding expression is non-assignable, or if the attribute isn't
	 *   optional and doesn't exist, an exception ({@link error/$compile/nonassign `$compile:nonassign`})
	 *   will be thrown upon discovering changes to the local value, since it will be impossible to sync
	 *   them back to the parent scope. By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
	 *   method is used for tracking changes, and the equality check is based on object identity.
	 *   However, if an object literal or an array literal is passed as the binding expression, the
	 *   equality check is done by value (using the {@link angular.equals} function). It's also possible
	 *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
	 *   `$watchCollection`}: use `=*` or `=*attr` (`=*?` or `=*?attr` if the attribute is optional).
	 *
	  * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
	 *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
	 *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
	 *   local name. You can also make the binding optional by adding `?`: `<?` or `<?attr`.
	 *
	 *   For example, given `<my-component my-attr="parentModel">` and directive definition of
	 *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
	 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
	 *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
	 *   two caveats:
	 *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
	 *     sets the same value. That means if your bound value is an object, changes to its properties
	 *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
	 *     2. one-way binding watches changes to the **identity** of the parent value. That means the
	 *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
	 *     to the value has changed. In most cases, this should not be of concern, but can be important
	 *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
	 *     If you now change a property of the object in your parent scope, the change will not be
	 *     propagated to the isolated scope, because the identity of the object on the parent scope
	 *     has not changed. Instead you must assign a new object.
	 *
	 *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
	 *   back to the parent. However, it does not make this completely impossible.
	 *
	 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
	 *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
	 *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
	 *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
	 *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
	 *   via an expression to the parent scope. This can be done by passing a map of local variable names
	 *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
	 *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
	 *
	 * In general it's possible to apply more than one directive to one element, but there might be limitations
	 * depending on the type of scope required by the directives. The following points will help explain these limitations.
	 * For simplicity only two directives are taken into account, but it is also applicable for several directives:
	 *
	 * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
	 * * **child scope** + **no scope** =>  Both directives will share one single child scope
	 * * **child scope** + **child scope** =>  Both directives will share one single child scope
	 * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
	 * its parent's scope
	 * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
	 * be applied to the same element.
	 * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
	 * cannot be applied to the same element.
	 *
	 *
	 * #### `bindToController`
	 * This property is used to bind scope properties directly to the controller. It can be either
	 * `true` or an object hash with the same format as the `scope` property.
	 *
	 * When an isolate scope is used for a directive (see above), `bindToController: true` will
	 * allow a component to have its properties bound to the controller, rather than to scope.
	 *
	 * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
	 * properties. You can access these bindings once they have been initialized by providing a controller method called
	 * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
	 * initialized.
	 *
	 * <div class="alert alert-warning">
	 * **Deprecation warning:** if `$compileProcvider.preAssignBindingsEnabled(true)` was called, bindings for non-ES6 class
	 * controllers are bound to `this` before the controller constructor is called but this use is now deprecated. Please
	 * place initialization code that relies upon bindings inside a `$onInit` method on the controller, instead.
	 * </div>
	 *
	 * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
	 * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
	 * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
	 * scope (useful for component directives).
	 *
	 * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
	 *
	 *
	 * #### `controller`
	 * Controller constructor function. The controller is instantiated before the
	 * pre-linking phase and can be accessed by other directives (see
	 * `require` attribute). This allows the directives to communicate with each other and augment
	 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
	 *
	 * * `$scope` - Current scope associated with the element
	 * * `$element` - Current element
	 * * `$attrs` - Current attributes object for the element
	 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
	 *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
	 *    * `scope`: (optional) override the scope.
	 *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
	 *    * `futureParentElement` (optional):
	 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
	 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
	 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
	 *          and when the `cloneLinkingFn` is passed,
	 *          as those elements need to created and cloned in a special way when they are defined outside their
	 *          usual containers (e.g. like `<svg>`).
	 *        * See also the `directive.templateNamespace` property.
	 *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
	 *      then the default transclusion is provided.
	 *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
	 *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
	 *
	 * #### `require`
	 * Require another directive and inject its controller as the fourth argument to the linking function. The
	 * `require` property can be a string, an array or an object:
	 * * a **string** containing the name of the directive to pass to the linking function
	 * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
	 * linking function will be an array of controllers in the same order as the names in the `require` property
	 * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
	 * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
	 * controllers.
	 *
	 * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
	 * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
	 * have been constructed but before `$onInit` is called.
	 * If the name of the required controller is the same as the local name (the key), the name can be
	 * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
	 * See the {@link $compileProvider#component} helper for an example of how this can be used.
	 * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
	 * raised (unless no link function is specified and the required controllers are not being bound to the directive
	 * controller, in which case error checking is skipped). The name can be prefixed with:
	 *
	 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
	 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
	 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
	 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
	 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
	 *   `null` to the `link` fn if not found.
	 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
	 *   `null` to the `link` fn if not found.
	 *
	 *
	 * #### `controllerAs`
	 * Identifier name for a reference to the controller in the directive's scope.
	 * This allows the controller to be referenced from the directive template. This is especially
	 * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
	 * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
	 * `controllerAs` reference might overwrite a property that already exists on the parent scope.
	 *
	 *
	 * #### `restrict`
	 * String of subset of `EACM` which restricts the directive to a specific directive
	 * declaration style. If omitted, the defaults (elements and attributes) are used.
	 *
	 * * `E` - Element name (default): `<my-directive></my-directive>`
	 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
	 * * `C` - Class: `<div class="my-directive: exp;"></div>`
	 * * `M` - Comment: `<!-- directive: my-directive exp -->`
	 *
	 *
	 * #### `templateNamespace`
	 * String representing the document type used by the markup in the template.
	 * AngularJS needs this information as those elements need to be created and cloned
	 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
	 *
	 * * `html` - All root nodes in the template are HTML. Root nodes may also be
	 *   top-level elements such as `<svg>` or `<math>`.
	 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
	 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
	 *
	 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
	 *
	 * #### `template`
	 * HTML markup that may:
	 * * Replace the contents of the directive's element (default).
	 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
	 * * Wrap the contents of the directive's element (if `transclude` is true).
	 *
	 * Value may be:
	 *
	 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
	 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
	 *   function api below) and returns a string value.
	 *
	 *
	 * #### `templateUrl`
	 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
	 *
	 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
	 * for later when the template has been resolved.  In the meantime it will continue to compile and link
	 * sibling and parent elements as though this element had not contained any directives.
	 *
	 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
	 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
	 * case when only one deeply nested directive has `templateUrl`.
	 *
	 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}
	 *
	 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
	 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
	 * a string value representing the url.  In either case, the template URL is passed through {@link
	 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
	 *
	 *
	 * #### `replace` ([*DEPRECATED*!], will be removed in next major release - i.e. v2.0)
	 * specify what the template should replace. Defaults to `false`.
	 *
	 * * `true` - the template will replace the directive's element.
	 * * `false` - the template will replace the contents of the directive's element.
	 *
	 * The replacement process migrates all of the attributes / classes from the old element to the new
	 * one. See the {@link guide/directive#template-expanding-directive
	 * Directives Guide} for an example.
	 *
	 * There are very few scenarios where element replacement is required for the application function,
	 * the main one being reusable custom components that are used within SVG contexts
	 * (because SVG doesn't work with custom elements in the DOM tree).
	 *
	 * #### `transclude`
	 * Extract the contents of the element where the directive appears and make it available to the directive.
	 * The contents are compiled and provided to the directive as a **transclusion function**. See the
	 * {@link $compile#transclusion Transclusion} section below.
	 *
	 *
	 * #### `compile`
	 *
	 * ```js
	 *   function compile(tElement, tAttrs, transclude) { ... }
	 * ```
	 *
	 * The compile function deals with transforming the template DOM. Since most directives do not do
	 * template transformation, it is not used often. The compile function takes the following arguments:
	 *
	 *   * `tElement` - template element - The element where the directive has been declared. It is
	 *     safe to do template transformation on the element and child elements only.
	 *
	 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
	 *     between all directive compile functions.
	 *
	 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
	 *
	 * <div class="alert alert-warning">
	 * **Note:** The template instance and the link instance may be different objects if the template has
	 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
	 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
	 * should be done in a linking function rather than in a compile function.
	 * </div>
	
	 * <div class="alert alert-warning">
	 * **Note:** The compile function cannot handle directives that recursively use themselves in their
	 * own templates or compile functions. Compiling these directives results in an infinite loop and
	 * stack overflow errors.
	 *
	 * This can be avoided by manually using $compile in the postLink function to imperatively compile
	 * a directive's template instead of relying on automatic template compilation via `template` or
	 * `templateUrl` declaration or manual compilation inside the compile function.
	 * </div>
	 *
	 * <div class="alert alert-danger">
	 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
	 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
	 *   to the link function instead.
	 * </div>
	
	 * A compile function can have a return value which can be either a function or an object.
	 *
	 * * returning a (post-link) function - is equivalent to registering the linking function via the
	 *   `link` property of the config object when the compile function is empty.
	 *
	 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
	 *   control when a linking function should be called during the linking phase. See info about
	 *   pre-linking and post-linking functions below.
	 *
	 *
	 * #### `link`
	 * This property is used only if the `compile` property is not defined.
	 *
	 * ```js
	 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
	 * ```
	 *
	 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
	 * executed after the template has been cloned. This is where most of the directive logic will be
	 * put.
	 *
	 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
	 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
	 *
	 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
	 *     manipulate the children of the element only in `postLink` function since the children have
	 *     already been linked.
	 *
	 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
	 *     between all directive linking functions.
	 *
	 *   * `controller` - the directive's required controller instance(s) - Instances are shared
	 *     among all directives, which allows the directives to use the controllers as a communication
	 *     channel. The exact value depends on the directive's `require` property:
	 *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
	 *       * `string`: the controller instance
	 *       * `array`: array of controller instances
	 *
	 *     If a required controller cannot be found, and it is optional, the instance is `null`,
	 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
	 *
	 *     Note that you can also require the directive's own controller - it will be made available like
	 *     any other controller.
	 *
	 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
	 *     This is the same as the `$transclude` parameter of directive controllers,
	 *     see {@link ng.$compile#-controller- the controller section for details}.
	 *     `function([scope], cloneLinkingFn, futureParentElement)`.
	 *
	 * #### Pre-linking function
	 *
	 * Executed before the child elements are linked. Not safe to do DOM transformation since the
	 * compiler linking function will fail to locate the correct elements for linking.
	 *
	 * #### Post-linking function
	 *
	 * Executed after the child elements are linked.
	 *
	 * Note that child elements that contain `templateUrl` directives will not have been compiled
	 * and linked since they are waiting for their template to load asynchronously and their own
	 * compilation and linking has been suspended until that occurs.
	 *
	 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
	 * for their async templates to be resolved.
	 *
	 *
	 * ### Transclusion
	 *
	 * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
	 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
	 * scope from where they were taken.
	 *
	 * Transclusion is used (often with {@link ngTransclude}) to insert the
	 * original contents of a directive's element into a specified place in the template of the directive.
	 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
	 * content has access to the properties on the scope from which it was taken, even if the directive
	 * has isolated scope.
	 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
	 *
	 * This makes it possible for the widget to have private state for its template, while the transcluded
	 * content has access to its originating scope.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
	 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
	 * Testing Transclusion Directives}.
	 * </div>
	 *
	 * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
	 * directive's element, the entire element or multiple parts of the element contents:
	 *
	 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
	 * * `'element'` - transclude the whole of the directive's element including any directives on this
	 *   element that defined at a lower priority than this directive. When used, the `template`
	 *   property is ignored.
	 * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
	 *
	 * **Mult-slot transclusion** is declared by providing an object for the `transclude` property.
	 *
	 * This object is a map where the keys are the name of the slot to fill and the value is an element selector
	 * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
	 * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
	 *
	 * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	 *
	 * If the element selector is prefixed with a `?` then that slot is optional.
	 *
	 * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
	 * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
	 *
	 * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
	 * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
	 * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
	 * injectable into the directive's controller.
	 *
	 *
	 * #### Transclusion Functions
	 *
	 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
	 * function** to the directive's `link` function and `controller`. This transclusion function is a special
	 * **linking function** that will return the compiled contents linked to a new transclusion scope.
	 *
	 * <div class="alert alert-info">
	 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
	 * ngTransclude will deal with it for us.
	 * </div>
	 *
	 * If you want to manually control the insertion and removal of the transcluded content in your directive
	 * then you must use this transclude function. When you call a transclude function it returns a a jqLite/JQuery
	 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
	 *
	 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
	 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
	 * content and the `scope` is the newly created transclusion scope, which the clone will be linked to.
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
	 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
	 * </div>
	 *
	 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
	 * attach function**:
	 *
	 * ```js
	 * var transcludedContent, transclusionScope;
	 *
	 * $transclude(function(clone, scope) {
	 *   element.append(clone);
	 *   transcludedContent = clone;
	 *   transclusionScope = scope;
	 * });
	 * ```
	 *
	 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
	 * associated transclusion scope:
	 *
	 * ```js
	 * transcludedContent.remove();
	 * transclusionScope.$destroy();
	 * ```
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
	 * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
	 * then you are also responsible for calling `$destroy` on the transclusion scope.
	 * </div>
	 *
	 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
	 * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
	 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
	 *
	 *
	 * #### Transclusion Scopes
	 *
	 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
	 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
	 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
	 * was taken.
	 *
	 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
	 * like this:
	 *
	 * ```html
	 * <div ng-app>
	 *   <div isolate>
	 *     <div transclusion>
	 *     </div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * The `$parent` scope hierarchy will look like this:
	 *
	   ```
	   - $rootScope
	     - isolate
	       - transclusion
	   ```
	 *
	 * but the scopes will inherit prototypically from different scopes to their `$parent`.
	 *
	   ```
	   - $rootScope
	     - transclusion
	   - isolate
	   ```
	 *
	 *
	 * ### Attributes
	 *
	 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
	 * `link()` or `compile()` functions. It has a variety of uses.
	 *
	 * * *Accessing normalized attribute names:* Directives like 'ngBind' can be expressed in many ways:
	 *   'ng:bind', `data-ng-bind`, or 'x-ng-bind'. The attributes object allows for normalized access
	 *   to the attributes.
	 *
	 * * *Directive inter-communication:* All directives share the same instance of the attributes
	 *   object which allows the directives to use the attributes object as inter directive
	 *   communication.
	 *
	 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
	 *   allowing other directives to read the interpolated value.
	 *
	 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
	 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
	 *   the only way to easily get the actual value because during the linking phase the interpolation
	 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
	 *
	 * ```js
	 * function linkingFn(scope, elm, attrs, ctrl) {
	 *   // get the attribute value
	 *   console.log(attrs.ngModel);
	 *
	 *   // change the attribute
	 *   attrs.$set('ngModel', 'new value');
	 *
	 *   // observe changes to interpolated attribute
	 *   attrs.$observe('ngModel', function(value) {
	 *     console.log('ngModel has changed value to ' + value);
	 *   });
	 * }
	 * ```
	 *
	 * ## Example
	 *
	 * <div class="alert alert-warning">
	 * **Note**: Typically directives are registered with `module.directive`. The example below is
	 * to illustrate how `$compile` works.
	 * </div>
	 *
	 <example module="compileExample" name="compile">
	   <file name="index.html">
	    <script>
	      angular.module('compileExample', [], function($compileProvider) {
	        // configure new 'compile' directive by passing a directive
	        // factory function. The factory function injects the '$compile'
	        $compileProvider.directive('compile', function($compile) {
	          // directive factory creates a link function
	          return function(scope, element, attrs) {
	            scope.$watch(
	              function(scope) {
	                 // watch the 'compile' expression for changes
	                return scope.$eval(attrs.compile);
	              },
	              function(value) {
	                // when the 'compile' expression changes
	                // assign it into the current DOM
	                element.html(value);
	
	                // compile the new DOM and link it to the current
	                // scope.
	                // NOTE: we only compile .childNodes so that
	                // we don't get into infinite loop compiling ourselves
	                $compile(element.contents())(scope);
	              }
	            );
	          };
	        });
	      })
	      .controller('GreeterController', ['$scope', function($scope) {
	        $scope.name = 'Angular';
	        $scope.html = 'Hello {{name}}';
	      }]);
	    </script>
	    <div ng-controller="GreeterController">
	      <input ng-model="name"> <br/>
	      <textarea ng-model="html"></textarea> <br/>
	      <div compile="html"></div>
	    </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should auto compile', function() {
	       var textarea = $('textarea');
	       var output = $('div[compile]');
	       // The initial state reads 'Hello Angular'.
	       expect(output.getText()).toBe('Hello Angular');
	       textarea.clear();
	       textarea.sendKeys('{{name}}!');
	       expect(output.getText()).toBe('Angular!');
	     });
	   </file>
	 </example>
	
	 *
	 *
	 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
	 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
	 *
	 * <div class="alert alert-danger">
	 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
	 *   e.g. will not use the right outer scope. Please pass the transclude function as a
	 *   `parentBoundTranscludeFn` to the link function instead.
	 * </div>
	 *
	 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
	 *                 root element(s), not their children)
	 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
	 * (a DOM element/tree) to a scope. Where:
	 *
	 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
	 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
	 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
	 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
	 *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
	 *
	 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
	 *      * `scope` - is the current scope with which the linking function is working with.
	 *
	 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
	 *  keys may be used to control linking behavior:
	 *
	 *      * `parentBoundTranscludeFn` - the transclude function made available to
	 *        directives; if given, it will be passed through to the link functions of
	 *        directives found in `element` during compilation.
	 *      * `transcludeControllers` - an object hash with keys that map controller names
	 *        to a hash with the key `instance`, which maps to the controller instance;
	 *        if given, it will make the controllers available to directives on the compileNode:
	 *        ```
	 *        {
	 *          parent: {
	 *            instance: parentControllerInstance
	 *          }
	 *        }
	 *        ```
	 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
	 *        the cloned elements; only needed for transcludes that are allowed to contain non html
	 *        elements (e.g. SVG elements). See also the directive.controller property.
	 *
	 * Calling the linking function returns the element of the template. It is either the original
	 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
	 *
	 * After linking the view is not updated until after a call to $digest which typically is done by
	 * Angular automatically.
	 *
	 * If you need access to the bound view, there are two ways to do it:
	 *
	 * - If you are not asking the linking function to clone the template, create the DOM element(s)
	 *   before you send them to the compiler and keep this reference around.
	 *   ```js
	 *     var element = $compile('<p>{{total}}</p>')(scope);
	 *   ```
	 *
	 * - if on the other hand, you need the element to be cloned, the view reference from the original
	 *   example would not point to the clone, but rather to the original template that was cloned. In
	 *   this case, you can access the clone via the cloneAttachFn:
	 *   ```js
	 *     var templateElement = angular.element('<p>{{total}}</p>'),
	 *         scope = ....;
	 *
	 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
	 *       //attach the clone to DOM document at the right place
	 *     });
	 *
	 *     //now we have reference to the cloned DOM via `clonedElement`
	 *   ```
	 *
	 *
	 * For information on how the compiler works, see the
	 * {@link guide/compiler Angular HTML Compiler} section of the Developer Guide.
	 *
	 * @knownIssue
	 *
	 * ### Double Compilation
	 *
	   Double compilation occurs when an already compiled part of the DOM gets
	   compiled again. This is an undesired effect and can lead to misbehaving directives, performance issues,
	   and memory leaks. Refer to the Compiler Guide {@link guide/compiler#double-compilation-and-how-to-avoid-it
	   section on double compilation} for an in-depth explanation and ways to avoid it.
	 *
	 */
	
	var $compileMinErr = minErr('$compile');
	
	function UNINITIALIZED_VALUE() {}
	var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();
	
	/**
	 * @ngdoc provider
	 * @name $compileProvider
	 *
	 * @description
	 */
	$CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
	/** @this */
	function $CompileProvider($provide, $$sanitizeUriProvider) {
	  var hasDirectives = {},
	      Suffix = 'Directive',
	      COMMENT_DIRECTIVE_REGEXP = /^\s*directive:\s*([\w-]+)\s+(.*)$/,
	      CLASS_DIRECTIVE_REGEXP = /(([\w-]+)(?::([^;]+))?;?)/,
	      ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
	      REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;
	
	  // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
	  // The assumption is that future DOM event attribute names will begin with
	  // 'on' and be composed of only English letters.
	  var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
	  var bindingCache = createMap();
	
	  function parseIsolateBindings(scope, directiveName, isController) {
	    var LOCAL_REGEXP = /^\s*([@&<]|=(\*?))(\??)\s*([\w$]*)\s*$/;
	
	    var bindings = createMap();
	
	    forEach(scope, function(definition, scopeName) {
	      if (definition in bindingCache) {
	        bindings[scopeName] = bindingCache[definition];
	        return;
	      }
	      var match = definition.match(LOCAL_REGEXP);
	
	      if (!match) {
	        throw $compileMinErr('iscp',
	            'Invalid {3} for directive \'{0}\'.' +
	            ' Definition: {... {1}: \'{2}\' ...}',
	            directiveName, scopeName, definition,
	            (isController ? 'controller bindings definition' :
	            'isolate scope definition'));
	      }
	
	      bindings[scopeName] = {
	        mode: match[1][0],
	        collection: match[2] === '*',
	        optional: match[3] === '?',
	        attrName: match[4] || scopeName
	      };
	      if (match[4]) {
	        bindingCache[definition] = bindings[scopeName];
	      }
	    });
	
	    return bindings;
	  }
	
	  function parseDirectiveBindings(directive, directiveName) {
	    var bindings = {
	      isolateScope: null,
	      bindToController: null
	    };
	    if (isObject(directive.scope)) {
	      if (directive.bindToController === true) {
	        bindings.bindToController = parseIsolateBindings(directive.scope,
	                                                         directiveName, true);
	        bindings.isolateScope = {};
	      } else {
	        bindings.isolateScope = parseIsolateBindings(directive.scope,
	                                                     directiveName, false);
	      }
	    }
	    if (isObject(directive.bindToController)) {
	      bindings.bindToController =
	          parseIsolateBindings(directive.bindToController, directiveName, true);
	    }
	    if (bindings.bindToController && !directive.controller) {
	      // There is no controller
	      throw $compileMinErr('noctrl',
	            'Cannot bind to controller without directive \'{0}\'s controller.',
	            directiveName);
	    }
	    return bindings;
	  }
	
	  function assertValidDirectiveName(name) {
	    var letter = name.charAt(0);
	    if (!letter || letter !== lowercase(letter)) {
	      throw $compileMinErr('baddir', 'Directive/Component name \'{0}\' is invalid. The first character must be a lowercase letter', name);
	    }
	    if (name !== name.trim()) {
	      throw $compileMinErr('baddir',
	            'Directive/Component name \'{0}\' is invalid. The name should not contain leading or trailing whitespaces',
	            name);
	    }
	  }
	
	  function getDirectiveRequire(directive) {
	    var require = directive.require || (directive.controller && directive.name);
	
	    if (!isArray(require) && isObject(require)) {
	      forEach(require, function(value, key) {
	        var match = value.match(REQUIRE_PREFIX_REGEXP);
	        var name = value.substring(match[0].length);
	        if (!name) require[key] = match[0] + key;
	      });
	    }
	
	    return require;
	  }
	
	  function getDirectiveRestrict(restrict, name) {
	    if (restrict && !(isString(restrict) && /[EACM]/.test(restrict))) {
	      throw $compileMinErr('badrestrict',
	          'Restrict property \'{0}\' of directive \'{1}\' is invalid',
	          restrict,
	          name);
	    }
	
	    return restrict || 'EA';
	  }
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#directive
	   * @kind function
	   *
	   * @description
	   * Register a new directive with the compiler.
	   *
	   * @param {string|Object} name Name of the directive in camel-case (i.e. <code>ngBind</code> which
	   *    will match as <code>ng-bind</code>), or an object map of directives where the keys are the
	   *    names and the values are the factories.
	   * @param {Function|Array} directiveFactory An injectable directive factory function. See the
	   *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
	   * @returns {ng.$compileProvider} Self for chaining.
	   */
	  this.directive = function registerDirective(name, directiveFactory) {
	    assertArg(name, 'name');
	    assertNotHasOwnProperty(name, 'directive');
	    if (isString(name)) {
	      assertValidDirectiveName(name);
	      assertArg(directiveFactory, 'directiveFactory');
	      if (!hasDirectives.hasOwnProperty(name)) {
	        hasDirectives[name] = [];
	        $provide.factory(name + Suffix, ['$injector', '$exceptionHandler',
	          function($injector, $exceptionHandler) {
	            var directives = [];
	            forEach(hasDirectives[name], function(directiveFactory, index) {
	              try {
	                var directive = $injector.invoke(directiveFactory);
	                if (isFunction(directive)) {
	                  directive = { compile: valueFn(directive) };
	                } else if (!directive.compile && directive.link) {
	                  directive.compile = valueFn(directive.link);
	                }
	                directive.priority = directive.priority || 0;
	                directive.index = index;
	                directive.name = directive.name || name;
	                directive.require = getDirectiveRequire(directive);
	                directive.restrict = getDirectiveRestrict(directive.restrict, name);
	                directive.$$moduleName = directiveFactory.$$moduleName;
	                directives.push(directive);
	              } catch (e) {
	                $exceptionHandler(e);
	              }
	            });
	            return directives;
	          }]);
	      }
	      hasDirectives[name].push(directiveFactory);
	    } else {
	      forEach(name, reverseParams(registerDirective));
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#component
	   * @module ng
	   * @param {string} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`)
	   * @param {Object} options Component definition object (a simplified
	   *    {@link ng.$compile#directive-definition-object directive definition object}),
	   *    with the following properties (all optional):
	   *
	   *    - `controller` – `{(string|function()=}` – controller constructor function that should be
	   *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
	   *      registered controller} if passed as a string. An empty `noop` function by default.
	   *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
	   *      If present, the controller will be published to scope under the `controllerAs` name.
	   *      If not present, this will default to be `$ctrl`.
	   *    - `template` – `{string=|function()=}` – html template as a string or a function that
	   *      returns an html template as a string which should be used as the contents of this component.
	   *      Empty string by default.
	   *
	   *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
	   *      template that should be used  as the contents of this component.
	   *
	   *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
	   *      Component properties are always bound to the component controller and not to the scope.
	   *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
	   *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
	   *      Disabled by default.
	   *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
	   *      this component's controller. The object keys specify the property names under which the required
	   *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
	   *    - `$...` – additional properties to attach to the directive factory function and the controller
	   *      constructor function. (This is used by the component router to annotate)
	   *
	   * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
	   * @description
	   * Register a **component definition** with the compiler. This is a shorthand for registering a special
	   * type of directive, which represents a self-contained UI component in your application. Such components
	   * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
	   *
	   * Component definitions are very simple and do not require as much configuration as defining general
	   * directives. Component definitions usually consist only of a template and a controller backing it.
	   *
	   * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
	   * `bindToController`. They always have **isolate scope** and are restricted to elements.
	   *
	   * Here are a few examples of how you would usually define components:
	   *
	   * ```js
	   *   var myMod = angular.module(...);
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     controller: function() {
	   *       this.name = 'shahar';
	   *     }
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     templateUrl: 'views/my-comp.html',
	   *     controller: 'MyCtrl',
	   *     controllerAs: 'ctrl',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   * ```
	   * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
	   *
	   * <br />
	   * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
	   */
	  this.component = function registerComponent(name, options) {
	    var controller = options.controller || function() {};
	
	    function factory($injector) {
	      function makeInjectable(fn) {
	        if (isFunction(fn) || isArray(fn)) {
	          return /** @this */ function(tElement, tAttrs) {
	            return $injector.invoke(fn, this, {$element: tElement, $attrs: tAttrs});
	          };
	        } else {
	          return fn;
	        }
	      }
	
	      var template = (!options.template && !options.templateUrl ? '' : options.template);
	      var ddo = {
	        controller: controller,
	        controllerAs: identifierForController(options.controller) || options.controllerAs || '$ctrl',
	        template: makeInjectable(template),
	        templateUrl: makeInjectable(options.templateUrl),
	        transclude: options.transclude,
	        scope: {},
	        bindToController: options.bindings || {},
	        restrict: 'E',
	        require: options.require
	      };
	
	      // Copy annotations (starting with $) over to the DDO
	      forEach(options, function(val, key) {
	        if (key.charAt(0) === '$') ddo[key] = val;
	      });
	
	      return ddo;
	    }
	
	    // TODO(pete) remove the following `forEach` before we release 1.6.0
	    // The component-router@0.2.0 looks for the annotations on the controller constructor
	    // Nothing in Angular looks for annotations on the factory function but we can't remove
	    // it from 1.5.x yet.
	
	    // Copy any annotation properties (starting with $) over to the factory and controller constructor functions
	    // These could be used by libraries such as the new component router
	    forEach(options, function(val, key) {
	      if (key.charAt(0) === '$') {
	        factory[key] = val;
	        // Don't try to copy over annotations to named controller
	        if (isFunction(controller)) controller[key] = val;
	      }
	    });
	
	    factory.$inject = ['$injector'];
	
	    return this.directive(name, factory);
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#aHrefSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.aHrefSanitizationWhitelist(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.aHrefSanitizationWhitelist();
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#imgSrcSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.imgSrcSanitizationWhitelist(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.imgSrcSanitizationWhitelist();
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#debugInfoEnabled
	   *
	   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
	   * current debugInfoEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable various debug runtime information in the compiler such as adding
	   * binding information and a reference to the current scope on to DOM elements.
	   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
	   * * `ng-binding` CSS class
	   * * `$binding` data property containing an array of the binding expressions
	   *
	   * You may want to disable this in production for a significant performance boost. See
	   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
	   *
	   * The default value is true.
	   */
	  var debugInfoEnabled = true;
	  this.debugInfoEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      debugInfoEnabled = enabled;
	      return this;
	    }
	    return debugInfoEnabled;
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#preAssignBindingsEnabled
	   *
	   * @param {boolean=} enabled update the preAssignBindingsEnabled state if provided, otherwise just return the
	   * current preAssignBindingsEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable whether directive controllers are assigned bindings before
	   * calling the controller's constructor.
	   * If enabled (true), the compiler assigns the value of each of the bindings to the
	   * properties of the controller object before the constructor of this object is called.
	   *
	   * If disabled (false), the compiler calls the constructor first before assigning bindings.
	   *
	   * The default value is false.
	   *
	   * @deprecated
	   * sinceVersion="1.6.0"
	   * removeVersion="1.7.0"
	   *
	   * This method and the option to assign the bindings before calling the controller's constructor
	   * will be removed in v1.7.0.
	   */
	  var preAssignBindingsEnabled = false;
	  this.preAssignBindingsEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      preAssignBindingsEnabled = enabled;
	      return this;
	    }
	    return preAssignBindingsEnabled;
	  };
	
	
	  var TTL = 10;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#onChangesTtl
	   * @description
	   *
	   * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
	   * assuming that the model is unstable.
	   *
	   * The current default is 10 iterations.
	   *
	   * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
	   * in several iterations of calls to these hooks. However if an application needs more than the default 10
	   * iterations to stabilize then you should investigate what is causing the model to continuously change during
	   * the `$onChanges` hook execution.
	   *
	   * Increasing the TTL could have performance implications, so you should not change it without proper justification.
	   *
	   * @param {number} limit The number of `$onChanges` hook iterations.
	   * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
	   */
	  this.onChangesTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	      return this;
	    }
	    return TTL;
	  };
	
	  var commentDirectivesEnabledConfig = true;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#commentDirectivesEnabled
	   * @description
	   *
	   * It indicates to the compiler
	   * whether or not directives on comments should be compiled.
	   * Defaults to `true`.
	   *
	   * Calling this function with false disables the compilation of directives
	   * on comments for the whole application.
	   * This results in a compilation performance gain,
	   * as the compiler doesn't have to check comments when looking for directives.
	   * This should however only be used if you are sure that no comment directives are used in
	   * the application (including any 3rd party directives).
	   *
	   * @param {boolean} enabled `false` if the compiler may ignore directives on comments
	   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
	   */
	  this.commentDirectivesEnabled = function(value) {
	    if (arguments.length) {
	      commentDirectivesEnabledConfig = value;
	      return this;
	    }
	    return commentDirectivesEnabledConfig;
	  };
	
	
	  var cssClassDirectivesEnabledConfig = true;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#cssClassDirectivesEnabled
	   * @description
	   *
	   * It indicates to the compiler
	   * whether or not directives on element classes should be compiled.
	   * Defaults to `true`.
	   *
	   * Calling this function with false disables the compilation of directives
	   * on element classes for the whole application.
	   * This results in a compilation performance gain,
	   * as the compiler doesn't have to check element classes when looking for directives.
	   * This should however only be used if you are sure that no class directives are used in
	   * the application (including any 3rd party directives).
	   *
	   * @param {boolean} enabled `false` if the compiler may ignore directives on element classes
	   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
	   */
	  this.cssClassDirectivesEnabled = function(value) {
	    if (arguments.length) {
	      cssClassDirectivesEnabledConfig = value;
	      return this;
	    }
	    return cssClassDirectivesEnabledConfig;
	  };
	
	  this.$get = [
	            '$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse',
	            '$controller', '$rootScope', '$sce', '$animate', '$$sanitizeUri',
	    function($injector,   $interpolate,   $exceptionHandler,   $templateRequest,   $parse,
	             $controller,   $rootScope,   $sce,   $animate,   $$sanitizeUri) {
	
	    var SIMPLE_ATTR_NAME = /^\w/;
	    var specialAttrHolder = window.document.createElement('div');
	
	
	    var commentDirectivesEnabled = commentDirectivesEnabledConfig;
	    var cssClassDirectivesEnabled = cssClassDirectivesEnabledConfig;
	
	
	    var onChangesTtl = TTL;
	    // The onChanges hooks should all be run together in a single digest
	    // When changes occur, the call to trigger their hooks will be added to this queue
	    var onChangesQueue;
	
	    // This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
	    function flushOnChangesQueue() {
	      try {
	        if (!(--onChangesTtl)) {
	          // We have hit the TTL limit so reset everything
	          onChangesQueue = undefined;
	          throw $compileMinErr('infchng', '{0} $onChanges() iterations reached. Aborting!\n', TTL);
	        }
	        // We must run this hook in an apply since the $$postDigest runs outside apply
	        $rootScope.$apply(function() {
	          var errors = [];
	          for (var i = 0, ii = onChangesQueue.length; i < ii; ++i) {
	            try {
	              onChangesQueue[i]();
	            } catch (e) {
	              errors.push(e);
	            }
	          }
	          // Reset the queue to trigger a new schedule next time there is a change
	          onChangesQueue = undefined;
	          if (errors.length) {
	            throw errors;
	          }
	        });
	      } finally {
	        onChangesTtl++;
	      }
	    }
	
	
	    function Attributes(element, attributesToCopy) {
	      if (attributesToCopy) {
	        var keys = Object.keys(attributesToCopy);
	        var i, l, key;
	
	        for (i = 0, l = keys.length; i < l; i++) {
	          key = keys[i];
	          this[key] = attributesToCopy[key];
	        }
	      } else {
	        this.$attr = {};
	      }
	
	      this.$$element = element;
	    }
	
	    Attributes.prototype = {
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$normalize
	       * @kind function
	       *
	       * @description
	       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
	       * `data-`) to its normalized, camelCase form.
	       *
	       * Also there is special case for Moz prefix starting with upper case letter.
	       *
	       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	       *
	       * @param {string} name Name to normalize
	       */
	      $normalize: directiveNormalize,
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$addClass
	       * @kind function
	       *
	       * @description
	       * Adds the CSS class value specified by the classVal parameter to the element. If animations
	       * are enabled then an animation will be triggered for the class addition.
	       *
	       * @param {string} classVal The className value that will be added to the element
	       */
	      $addClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.addClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$removeClass
	       * @kind function
	       *
	       * @description
	       * Removes the CSS class value specified by the classVal parameter from the element. If
	       * animations are enabled then an animation will be triggered for the class removal.
	       *
	       * @param {string} classVal The className value that will be removed from the element
	       */
	      $removeClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.removeClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$updateClass
	       * @kind function
	       *
	       * @description
	       * Adds and removes the appropriate CSS class values to the element based on the difference
	       * between the new and old CSS class values (specified as newClasses and oldClasses).
	       *
	       * @param {string} newClasses The current CSS className value
	       * @param {string} oldClasses The former CSS className value
	       */
	      $updateClass: function(newClasses, oldClasses) {
	        var toAdd = tokenDifference(newClasses, oldClasses);
	        if (toAdd && toAdd.length) {
	          $animate.addClass(this.$$element, toAdd);
	        }
	
	        var toRemove = tokenDifference(oldClasses, newClasses);
	        if (toRemove && toRemove.length) {
	          $animate.removeClass(this.$$element, toRemove);
	        }
	      },
	
	      /**
	       * Set a normalized attribute on the element in a way such that all directives
	       * can share the attribute. This function properly handles boolean attributes.
	       * @param {string} key Normalized key. (ie ngAttribute)
	       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
	       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
	       *     Defaults to true.
	       * @param {string=} attrName Optional none normalized name. Defaults to key.
	       */
	      $set: function(key, value, writeAttr, attrName) {
	        // TODO: decide whether or not to throw an error if "class"
	        //is set through this function since it may cause $updateClass to
	        //become unstable.
	
	        var node = this.$$element[0],
	            booleanKey = getBooleanAttrName(node, key),
	            aliasedKey = getAliasedAttrName(key),
	            observer = key,
	            nodeName;
	
	        if (booleanKey) {
	          this.$$element.prop(key, value);
	          attrName = booleanKey;
	        } else if (aliasedKey) {
	          this[aliasedKey] = value;
	          observer = aliasedKey;
	        }
	
	        this[key] = value;
	
	        // translate normalized key to actual key
	        if (attrName) {
	          this.$attr[key] = attrName;
	        } else {
	          attrName = this.$attr[key];
	          if (!attrName) {
	            this.$attr[key] = attrName = snake_case(key, '-');
	          }
	        }
	
	        nodeName = nodeName_(this.$$element);
	
	        if ((nodeName === 'a' && (key === 'href' || key === 'xlinkHref')) ||
	            (nodeName === 'img' && key === 'src')) {
	          // sanitize a[href] and img[src] values
	          this[key] = value = $$sanitizeUri(value, key === 'src');
	        } else if (nodeName === 'img' && key === 'srcset' && isDefined(value)) {
	          // sanitize img[srcset] values
	          var result = '';
	
	          // first check if there are spaces because it's not the same pattern
	          var trimmedSrcset = trim(value);
	          //                (   999x   ,|   999w   ,|   ,|,   )
	          var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
	          var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;
	
	          // split srcset into tuple of uri and descriptor except for the last item
	          var rawUris = trimmedSrcset.split(pattern);
	
	          // for each tuples
	          var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
	          for (var i = 0; i < nbrUrisWith2parts; i++) {
	            var innerIdx = i * 2;
	            // sanitize the uri
	            result += $$sanitizeUri(trim(rawUris[innerIdx]), true);
	            // add the descriptor
	            result += (' ' + trim(rawUris[innerIdx + 1]));
	          }
	
	          // split the last item into uri and descriptor
	          var lastTuple = trim(rawUris[i * 2]).split(/\s/);
	
	          // sanitize the last uri
	          result += $$sanitizeUri(trim(lastTuple[0]), true);
	
	          // and add the last descriptor if any
	          if (lastTuple.length === 2) {
	            result += (' ' + trim(lastTuple[1]));
	          }
	          this[key] = value = result;
	        }
	
	        if (writeAttr !== false) {
	          if (value === null || isUndefined(value)) {
	            this.$$element.removeAttr(attrName);
	          } else {
	            if (SIMPLE_ATTR_NAME.test(attrName)) {
	              this.$$element.attr(attrName, value);
	            } else {
	              setSpecialAttr(this.$$element[0], attrName, value);
	            }
	          }
	        }
	
	        // fire observers
	        var $$observers = this.$$observers;
	        if ($$observers) {
	          forEach($$observers[observer], function(fn) {
	            try {
	              fn(value);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          });
	        }
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$observe
	       * @kind function
	       *
	       * @description
	       * Observes an interpolated attribute.
	       *
	       * The observer function will be invoked once during the next `$digest` following
	       * compilation. The observer is then invoked whenever the interpolated value
	       * changes.
	       *
	       * @param {string} key Normalized key. (ie ngAttribute) .
	       * @param {function(interpolatedValue)} fn Function that will be called whenever
	                the interpolated value of the attribute changes.
	       *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
	       *        guide} for more info.
	       * @returns {function()} Returns a deregistration function for this observer.
	       */
	      $observe: function(key, fn) {
	        var attrs = this,
	            $$observers = (attrs.$$observers || (attrs.$$observers = createMap())),
	            listeners = ($$observers[key] || ($$observers[key] = []));
	
	        listeners.push(fn);
	        $rootScope.$evalAsync(function() {
	          if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) {
	            // no one registered attribute interpolation function, so lets call it manually
	            fn(attrs[key]);
	          }
	        });
	
	        return function() {
	          arrayRemove(listeners, fn);
	        };
	      }
	    };
	
	    function setSpecialAttr(element, attrName, value) {
	      // Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
	      // so we have to jump through some hoops to get such an attribute
	      // https://github.com/angular/angular.js/pull/13318
	      specialAttrHolder.innerHTML = '<span ' + attrName + '>';
	      var attributes = specialAttrHolder.firstChild.attributes;
	      var attribute = attributes[0];
	      // We have to remove the attribute from its container element before we can add it to the destination element
	      attributes.removeNamedItem(attribute.name);
	      attribute.value = value;
	      element.attributes.setNamedItem(attribute);
	    }
	
	    function safeAddClass($element, className) {
	      try {
	        $element.addClass(className);
	      } catch (e) {
	        // ignore, since it means that we are trying to set class on
	        // SVG element, where class name is read-only.
	      }
	    }
	
	
	    var startSymbol = $interpolate.startSymbol(),
	        endSymbol = $interpolate.endSymbol(),
	        denormalizeTemplate = (startSymbol === '{{' && endSymbol  === '}}')
	            ? identity
	            : function denormalizeTemplate(template) {
	              return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
	        },
	        NG_ATTR_BINDING = /^ngAttr[A-Z]/;
	    var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;
	
	    compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
	      var bindings = $element.data('$binding') || [];
	
	      if (isArray(binding)) {
	        bindings = bindings.concat(binding);
	      } else {
	        bindings.push(binding);
	      }
	
	      $element.data('$binding', bindings);
	    } : noop;
	
	    compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
	      safeAddClass($element, 'ng-binding');
	    } : noop;
	
	    compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
	      var dataName = isolated ? (noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope') : '$scope';
	      $element.data(dataName, scope);
	    } : noop;
	
	    compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
	      safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
	    } : noop;
	
	    compile.$$createComment = function(directiveName, comment) {
	      var content = '';
	      if (debugInfoEnabled) {
	        content = ' ' + (directiveName || '') + ': ';
	        if (comment) content += comment + ' ';
	      }
	      return window.document.createComment(content);
	    };
	
	    return compile;
	
	    //================================
	
	    function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective,
	                        previousCompileContext) {
	      if (!($compileNodes instanceof jqLite)) {
	        // jquery always rewraps, whereas we need to preserve the original selector so that we can
	        // modify it.
	        $compileNodes = jqLite($compileNodes);
	      }
	      var compositeLinkFn =
	              compileNodes($compileNodes, transcludeFn, $compileNodes,
	                           maxPriority, ignoreDirective, previousCompileContext);
	      compile.$$addScopeClass($compileNodes);
	      var namespace = null;
	      return function publicLinkFn(scope, cloneConnectFn, options) {
	        if (!$compileNodes) {
	          throw $compileMinErr('multilink', 'This element has already been linked.');
	        }
	        assertArg(scope, 'scope');
	
	        if (previousCompileContext && previousCompileContext.needsNewScope) {
	          // A parent directive did a replace and a directive on this element asked
	          // for transclusion, which caused us to lose a layer of element on which
	          // we could hold the new transclusion scope, so we will create it manually
	          // here.
	          scope = scope.$parent.$new();
	        }
	
	        options = options || {};
	        var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
	          transcludeControllers = options.transcludeControllers,
	          futureParentElement = options.futureParentElement;
	
	        // When `parentBoundTranscludeFn` is passed, it is a
	        // `controllersBoundTransclude` function (it was previously passed
	        // as `transclude` to directive.link) so we must unwrap it to get
	        // its `boundTranscludeFn`
	        if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
	          parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
	        }
	
	        if (!namespace) {
	          namespace = detectNamespaceForChildElements(futureParentElement);
	        }
	        var $linkNode;
	        if (namespace !== 'html') {
	          // When using a directive with replace:true and templateUrl the $compileNodes
	          // (or a child element inside of them)
	          // might change, so we need to recreate the namespace adapted compileNodes
	          // for call to the link function.
	          // Note: This will already clone the nodes...
	          $linkNode = jqLite(
	            wrapTemplate(namespace, jqLite('<div>').append($compileNodes).html())
	          );
	        } else if (cloneConnectFn) {
	          // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
	          // and sometimes changes the structure of the DOM.
	          $linkNode = JQLitePrototype.clone.call($compileNodes);
	        } else {
	          $linkNode = $compileNodes;
	        }
	
	        if (transcludeControllers) {
	          for (var controllerName in transcludeControllers) {
	            $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
	          }
	        }
	
	        compile.$$addScopeInfo($linkNode, scope);
	
	        if (cloneConnectFn) cloneConnectFn($linkNode, scope);
	        if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);
	
	        if (!cloneConnectFn) {
	          $compileNodes = compositeLinkFn = null;
	        }
	        return $linkNode;
	      };
	    }
	
	    function detectNamespaceForChildElements(parentElement) {
	      // TODO: Make this detect MathML as well...
	      var node = parentElement && parentElement[0];
	      if (!node) {
	        return 'html';
	      } else {
	        return nodeName_(node) !== 'foreignobject' && toString.call(node).match(/SVG/) ? 'svg' : 'html';
	      }
	    }
	
	    /**
	     * Compile function matches each node in nodeList against the directives. Once all directives
	     * for a particular node are collected their compile functions are executed. The compile
	     * functions return values - the linking functions - are combined into a composite linking
	     * function, which is the a linking function for the node.
	     *
	     * @param {NodeList} nodeList an array of nodes or NodeList to compile
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *        scope argument is auto-generated to the new child of the transcluded parent scope.
	     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
	     *        the rootElement must be set the jqLite collection of the compile root. This is
	     *        needed so that the jqLite collection items can be replaced with widgets.
	     * @param {number=} maxPriority Max directive priority.
	     * @returns {Function} A composite linking function of all of the matched directives or null.
	     */
	    function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective,
	                            previousCompileContext) {
	      var linkFns = [],
	          // `nodeList` can be either an element's `.childNodes` (live NodeList)
	          // or a jqLite/jQuery collection or an array
	          notLiveList = isArray(nodeList) || (nodeList instanceof jqLite),
	          attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;
	
	
	      for (var i = 0; i < nodeList.length; i++) {
	        attrs = new Attributes();
	
	        // Support: IE 11 only
	        // Workaround for #11781 and #14924
	        if (msie === 11) {
	          mergeConsecutiveTextNodes(nodeList, i, notLiveList);
	        }
	
	        // We must always refer to `nodeList[i]` hereafter,
	        // since the nodes can be replaced underneath us.
	        directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined,
	                                        ignoreDirective);
	
	        nodeLinkFn = (directives.length)
	            ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement,
	                                      null, [], [], previousCompileContext)
	            : null;
	
	        if (nodeLinkFn && nodeLinkFn.scope) {
	          compile.$$addScopeClass(attrs.$$element);
	        }
	
	        childLinkFn = (nodeLinkFn && nodeLinkFn.terminal ||
	                      !(childNodes = nodeList[i].childNodes) ||
	                      !childNodes.length)
	            ? null
	            : compileNodes(childNodes,
	                 nodeLinkFn ? (
	                  (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement)
	                     && nodeLinkFn.transclude) : transcludeFn);
	
	        if (nodeLinkFn || childLinkFn) {
	          linkFns.push(i, nodeLinkFn, childLinkFn);
	          linkFnFound = true;
	          nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
	        }
	
	        //use the previous context only for the first element in the virtual group
	        previousCompileContext = null;
	      }
	
	      // return a linking function if we have found anything, null otherwise
	      return linkFnFound ? compositeLinkFn : null;
	
	      function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
	        var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
	        var stableNodeList;
	
	
	        if (nodeLinkFnFound) {
	          // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
	          // offsets don't get screwed up
	          var nodeListLength = nodeList.length;
	          stableNodeList = new Array(nodeListLength);
	
	          // create a sparse array by only copying the elements which have a linkFn
	          for (i = 0; i < linkFns.length; i += 3) {
	            idx = linkFns[i];
	            stableNodeList[idx] = nodeList[idx];
	          }
	        } else {
	          stableNodeList = nodeList;
	        }
	
	        for (i = 0, ii = linkFns.length; i < ii;) {
	          node = stableNodeList[linkFns[i++]];
	          nodeLinkFn = linkFns[i++];
	          childLinkFn = linkFns[i++];
	
	          if (nodeLinkFn) {
	            if (nodeLinkFn.scope) {
	              childScope = scope.$new();
	              compile.$$addScopeInfo(jqLite(node), childScope);
	            } else {
	              childScope = scope;
	            }
	
	            if (nodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(
	                  scope, nodeLinkFn.transclude, parentBoundTranscludeFn);
	
	            } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
	              childBoundTranscludeFn = parentBoundTranscludeFn;
	
	            } else if (!parentBoundTranscludeFn && transcludeFn) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);
	
	            } else {
	              childBoundTranscludeFn = null;
	            }
	
	            nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);
	
	          } else if (childLinkFn) {
	            childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
	          }
	        }
	      }
	    }
	
	    function mergeConsecutiveTextNodes(nodeList, idx, notLiveList) {
	      var node = nodeList[idx];
	      var parent = node.parentNode;
	      var sibling;
	
	      if (node.nodeType !== NODE_TYPE_TEXT) {
	        return;
	      }
	
	      while (true) {
	        sibling = parent ? node.nextSibling : nodeList[idx + 1];
	        if (!sibling || sibling.nodeType !== NODE_TYPE_TEXT) {
	          break;
	        }
	
	        node.nodeValue = node.nodeValue + sibling.nodeValue;
	
	        if (sibling.parentNode) {
	          sibling.parentNode.removeChild(sibling);
	        }
	        if (notLiveList && sibling === nodeList[idx + 1]) {
	          nodeList.splice(idx + 1, 1);
	        }
	      }
	    }
	
	    function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
	      function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {
	
	        if (!transcludedScope) {
	          transcludedScope = scope.$new(false, containingScope);
	          transcludedScope.$$transcluded = true;
	        }
	
	        return transcludeFn(transcludedScope, cloneFn, {
	          parentBoundTranscludeFn: previousBoundTranscludeFn,
	          transcludeControllers: controllers,
	          futureParentElement: futureParentElement
	        });
	      }
	
	      // We need  to attach the transclusion slots onto the `boundTranscludeFn`
	      // so that they are available inside the `controllersBoundTransclude` function
	      var boundSlots = boundTranscludeFn.$$slots = createMap();
	      for (var slotName in transcludeFn.$$slots) {
	        if (transcludeFn.$$slots[slotName]) {
	          boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
	        } else {
	          boundSlots[slotName] = null;
	        }
	      }
	
	      return boundTranscludeFn;
	    }
	
	    /**
	     * Looks for directives on the given node and adds them to the directive collection which is
	     * sorted.
	     *
	     * @param node Node to search.
	     * @param directives An array to which the directives are added to. This array is sorted before
	     *        the function returns.
	     * @param attrs The shared attrs object which is used to populate the normalized attributes.
	     * @param {number=} maxPriority Max directive priority.
	     */
	    function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      var nodeType = node.nodeType,
	          attrsMap = attrs.$attr,
	          match,
	          nodeName,
	          className;
	
	      switch (nodeType) {
	        case NODE_TYPE_ELEMENT: /* Element */
	
	          nodeName = nodeName_(node);
	
	          // use the node name: <directive>
	          addDirective(directives,
	              directiveNormalize(nodeName), 'E', maxPriority, ignoreDirective);
	
	          // iterate over the attributes
	          for (var attr, name, nName, ngAttrName, value, isNgAttr, nAttrs = node.attributes,
	                   j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
	            var attrStartName = false;
	            var attrEndName = false;
	
	            attr = nAttrs[j];
	            name = attr.name;
	            value = attr.value;
	
	            // support ngAttr attribute binding
	            ngAttrName = directiveNormalize(name);
	            isNgAttr = NG_ATTR_BINDING.test(ngAttrName);
	            if (isNgAttr) {
	              name = name.replace(PREFIX_REGEXP, '')
	                .substr(8).replace(/_(.)/g, function(match, letter) {
	                  return letter.toUpperCase();
	                });
	            }
	
	            var multiElementMatch = ngAttrName.match(MULTI_ELEMENT_DIR_RE);
	            if (multiElementMatch && directiveIsMultiElement(multiElementMatch[1])) {
	              attrStartName = name;
	              attrEndName = name.substr(0, name.length - 5) + 'end';
	              name = name.substr(0, name.length - 6);
	            }
	
	            nName = directiveNormalize(name.toLowerCase());
	            attrsMap[nName] = name;
	            if (isNgAttr || !attrs.hasOwnProperty(nName)) {
	                attrs[nName] = value;
	                if (getBooleanAttrName(node, nName)) {
	                  attrs[nName] = true; // presence means true
	                }
	            }
	            addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
	            addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName,
	                          attrEndName);
	          }
	
	          if (nodeName === 'input' && node.getAttribute('type') === 'hidden') {
	            // Hidden input elements can have strange behaviour when navigating back to the page
	            // This tells the browser not to try to cache and reinstate previous values
	            node.setAttribute('autocomplete', 'off');
	          }
	
	          // use class as directive
	          if (!cssClassDirectivesEnabled) break;
	          className = node.className;
	          if (isObject(className)) {
	              // Maybe SVGAnimatedString
	              className = className.animVal;
	          }
	          if (isString(className) && className !== '') {
	            while ((match = CLASS_DIRECTIVE_REGEXP.exec(className))) {
	              nName = directiveNormalize(match[2]);
	              if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
	                attrs[nName] = trim(match[3]);
	              }
	              className = className.substr(match.index + match[0].length);
	            }
	          }
	          break;
	        case NODE_TYPE_TEXT: /* Text Node */
	          addTextInterpolateDirective(directives, node.nodeValue);
	          break;
	        case NODE_TYPE_COMMENT: /* Comment */
	          if (!commentDirectivesEnabled) break;
	          collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective);
	          break;
	      }
	
	      directives.sort(byPriority);
	      return directives;
	    }
	
	    function collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      // function created because of performance, try/catch disables
	      // the optimization of the whole function #14848
	      try {
	        var match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
	        if (match) {
	          var nName = directiveNormalize(match[1]);
	          if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
	            attrs[nName] = trim(match[2]);
	          }
	        }
	      } catch (e) {
	        // turns out that under some circumstances IE9 throws errors when one attempts to read
	        // comment's node value.
	        // Just ignore it and continue. (Can't seem to reproduce in test case.)
	      }
	    }
	
	    /**
	     * Given a node with a directive-start it collects all of the siblings until it finds
	     * directive-end.
	     * @param node
	     * @param attrStart
	     * @param attrEnd
	     * @returns {*}
	     */
	    function groupScan(node, attrStart, attrEnd) {
	      var nodes = [];
	      var depth = 0;
	      if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
	        do {
	          if (!node) {
	            throw $compileMinErr('uterdir',
	                      'Unterminated attribute, found \'{0}\' but no matching \'{1}\' found.',
	                      attrStart, attrEnd);
	          }
	          if (node.nodeType === NODE_TYPE_ELEMENT) {
	            if (node.hasAttribute(attrStart)) depth++;
	            if (node.hasAttribute(attrEnd)) depth--;
	          }
	          nodes.push(node);
	          node = node.nextSibling;
	        } while (depth > 0);
	      } else {
	        nodes.push(node);
	      }
	
	      return jqLite(nodes);
	    }
	
	    /**
	     * Wrapper for linking function which converts normal linking function into a grouped
	     * linking function.
	     * @param linkFn
	     * @param attrStart
	     * @param attrEnd
	     * @returns {Function}
	     */
	    function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
	      return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
	        element = groupScan(element[0], attrStart, attrEnd);
	        return linkFn(scope, element, attrs, controllers, transcludeFn);
	      };
	    }
	
	    /**
	     * A function generator that is used to support both eager and lazy compilation
	     * linking function.
	     * @param eager
	     * @param $compileNodes
	     * @param transcludeFn
	     * @param maxPriority
	     * @param ignoreDirective
	     * @param previousCompileContext
	     * @returns {Function}
	     */
	    function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
	      var compiled;
	
	      if (eager) {
	        return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	      }
	      return /** @this */ function lazyCompilation() {
	        if (!compiled) {
	          compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	
	          // Null out all of these references in order to make them eligible for garbage collection
	          // since this is a potentially long lived closure
	          $compileNodes = transcludeFn = previousCompileContext = null;
	        }
	        return compiled.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Once the directives have been collected, their compile functions are executed. This method
	     * is responsible for inlining directive templates as well as terminating the application
	     * of the directives if the terminal directive has been reached.
	     *
	     * @param {Array} directives Array of collected directives to execute their compile function.
	     *        this needs to be pre-sorted by priority order.
	     * @param {Node} compileNode The raw DOM node to apply the compile functions to
	     * @param {Object} templateAttrs The shared attribute function
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *                                                  scope argument is auto-generated to the new
	     *                                                  child of the transcluded parent scope.
	     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
	     *                              argument has the root jqLite array so that we can replace nodes
	     *                              on it.
	     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
	     *                                           compiling the transclusion.
	     * @param {Array.<Function>} preLinkFns
	     * @param {Array.<Function>} postLinkFns
	     * @param {Object} previousCompileContext Context used for previous compilation of the current
	     *                                        node
	     * @returns {Function} linkFn
	     */
	    function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn,
	                                   jqCollection, originalReplaceDirective, preLinkFns, postLinkFns,
	                                   previousCompileContext) {
	      previousCompileContext = previousCompileContext || {};
	
	      var terminalPriority = -Number.MAX_VALUE,
	          newScopeDirective = previousCompileContext.newScopeDirective,
	          controllerDirectives = previousCompileContext.controllerDirectives,
	          newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
	          templateDirective = previousCompileContext.templateDirective,
	          nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
	          hasTranscludeDirective = false,
	          hasTemplate = false,
	          hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
	          $compileNode = templateAttrs.$$element = jqLite(compileNode),
	          directive,
	          directiveName,
	          $template,
	          replaceDirective = originalReplaceDirective,
	          childTranscludeFn = transcludeFn,
	          linkFn,
	          didScanForMultipleTransclusion = false,
	          mightHaveMultipleTransclusionError = false,
	          directiveValue;
	
	      // executes all directives on the current element
	      for (var i = 0, ii = directives.length; i < ii; i++) {
	        directive = directives[i];
	        var attrStart = directive.$$start;
	        var attrEnd = directive.$$end;
	
	        // collect multiblock sections
	        if (attrStart) {
	          $compileNode = groupScan(compileNode, attrStart, attrEnd);
	        }
	        $template = undefined;
	
	        if (terminalPriority > directive.priority) {
	          break; // prevent further processing of directives
	        }
	
	        directiveValue = directive.scope;
	
	        if (directiveValue) {
	
	          // skip the check for directives with async templates, we'll check the derived sync
	          // directive when the template arrives
	          if (!directive.templateUrl) {
	            if (isObject(directiveValue)) {
	              // This directive is trying to add an isolated scope.
	              // Check that there is no scope of any kind already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective,
	                                directive, $compileNode);
	              newIsolateScopeDirective = directive;
	            } else {
	              // This directive is trying to add a child scope.
	              // Check that there is no isolated scope already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive,
	                                $compileNode);
	            }
	          }
	
	          newScopeDirective = newScopeDirective || directive;
	        }
	
	        directiveName = directive.name;
	
	        // If we encounter a condition that can result in transclusion on the directive,
	        // then scan ahead in the remaining directives for others that may cause a multiple
	        // transclusion error to be thrown during the compilation process.  If a matching directive
	        // is found, then we know that when we encounter a transcluded directive, we need to eagerly
	        // compile the `transclude` function rather than doing it lazily in order to throw
	        // exceptions at the correct time
	        if (!didScanForMultipleTransclusion && ((directive.replace && (directive.templateUrl || directive.template))
	            || (directive.transclude && !directive.$$tlb))) {
	                var candidateDirective;
	
	                for (var scanningIndex = i + 1; (candidateDirective = directives[scanningIndex++]);) {
	                    if ((candidateDirective.transclude && !candidateDirective.$$tlb)
	                        || (candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template))) {
	                        mightHaveMultipleTransclusionError = true;
	                        break;
	                    }
	                }
	
	                didScanForMultipleTransclusion = true;
	        }
	
	        if (!directive.templateUrl && directive.controller) {
	          controllerDirectives = controllerDirectives || createMap();
	          assertNoDuplicate('\'' + directiveName + '\' controller',
	              controllerDirectives[directiveName], directive, $compileNode);
	          controllerDirectives[directiveName] = directive;
	        }
	
	        directiveValue = directive.transclude;
	
	        if (directiveValue) {
	          hasTranscludeDirective = true;
	
	          // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
	          // This option should only be used by directives that know how to safely handle element transclusion,
	          // where the transcluded nodes are added or replaced after linking.
	          if (!directive.$$tlb) {
	            assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
	            nonTlbTranscludeDirective = directive;
	          }
	
	          if (directiveValue === 'element') {
	            hasElementTranscludeDirective = true;
	            terminalPriority = directive.priority;
	            $template = $compileNode;
	            $compileNode = templateAttrs.$$element =
	                jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
	            compileNode = $compileNode[0];
	            replaceWith(jqCollection, sliceArgs($template), compileNode);
	
	            // Support: Chrome < 50
	            // https://github.com/angular/angular.js/issues/14041
	
	            // In the versions of V8 prior to Chrome 50, the document fragment that is created
	            // in the `replaceWith` function is improperly garbage collected despite still
	            // being referenced by the `parentNode` property of all of the child nodes.  By adding
	            // a reference to the fragment via a different property, we can avoid that incorrect
	            // behavior.
	            // TODO: remove this line after Chrome 50 has been released
	            $template[0].$$parentNode = $template[0].parentNode;
	
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority,
	                                        replaceDirective && replaceDirective.name, {
	                                          // Don't pass in:
	                                          // - controllerDirectives - otherwise we'll create duplicates controllers
	                                          // - newIsolateScopeDirective or templateDirective - combining templates with
	                                          //   element transclusion doesn't make sense.
	                                          //
	                                          // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
	                                          // on the same element more than once.
	                                          nonTlbTranscludeDirective: nonTlbTranscludeDirective
	                                        });
	          } else {
	
	            var slots = createMap();
	
	            if (!isObject(directiveValue)) {
	              $template = jqLite(jqLiteClone(compileNode)).contents();
	            } else {
	
	              // We have transclusion slots,
	              // collect them up, compile them and store their transclusion functions
	              $template = [];
	
	              var slotMap = createMap();
	              var filledSlots = createMap();
	
	              // Parse the element selectors
	              forEach(directiveValue, function(elementSelector, slotName) {
	                // If an element selector starts with a ? then it is optional
	                var optional = (elementSelector.charAt(0) === '?');
	                elementSelector = optional ? elementSelector.substring(1) : elementSelector;
	
	                slotMap[elementSelector] = slotName;
	
	                // We explicitly assign `null` since this implies that a slot was defined but not filled.
	                // Later when calling boundTransclusion functions with a slot name we only error if the
	                // slot is `undefined`
	                slots[slotName] = null;
	
	                // filledSlots contains `true` for all slots that are either optional or have been
	                // filled. This is used to check that we have not missed any required slots
	                filledSlots[slotName] = optional;
	              });
	
	              // Add the matching elements into their slot
	              forEach($compileNode.contents(), function(node) {
	                var slotName = slotMap[directiveNormalize(nodeName_(node))];
	                if (slotName) {
	                  filledSlots[slotName] = true;
	                  slots[slotName] = slots[slotName] || [];
	                  slots[slotName].push(node);
	                } else {
	                  $template.push(node);
	                }
	              });
	
	              // Check for required slots that were not filled
	              forEach(filledSlots, function(filled, slotName) {
	                if (!filled) {
	                  throw $compileMinErr('reqslot', 'Required transclusion slot `{0}` was not filled.', slotName);
	                }
	              });
	
	              for (var slotName in slots) {
	                if (slots[slotName]) {
	                  // Only define a transclusion function if the slot was filled
	                  slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slots[slotName], transcludeFn);
	                }
	              }
	            }
	
	            $compileNode.empty(); // clear contents
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined,
	                undefined, { needsNewScope: directive.$$isolateScope || directive.$$newScope});
	            childTranscludeFn.$$slots = slots;
	          }
	        }
	
	        if (directive.template) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          directiveValue = (isFunction(directive.template))
	              ? directive.template($compileNode, templateAttrs)
	              : directive.template;
	
	          directiveValue = denormalizeTemplate(directiveValue);
	
	          if (directive.replace) {
	            replaceDirective = directive;
	            if (jqLiteIsTextNode(directiveValue)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  'Template for directive \'{0}\' must have exactly one root element. {1}',
	                  directiveName, '');
	            }
	
	            replaceWith(jqCollection, $compileNode, compileNode);
	
	            var newTemplateAttrs = {$attr: {}};
	
	            // combine directives from the original node and from the template:
	            // - take the array of directives for this element
	            // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
	            // - collect directives from the template and sort them by priority
	            // - combine directives as: processed + template + unprocessed
	            var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
	            var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));
	
	            if (newIsolateScopeDirective || newScopeDirective) {
	              // The original directive caused the current element to be replaced but this element
	              // also needs to have a new scope, so we need to tell the template directives
	              // that they would need to get their scope from further up, if they require transclusion
	              markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
	            }
	            directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
	            mergeTemplateAttributes(templateAttrs, newTemplateAttrs);
	
	            ii = directives.length;
	          } else {
	            $compileNode.html(directiveValue);
	          }
	        }
	
	        if (directive.templateUrl) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          if (directive.replace) {
	            replaceDirective = directive;
	          }
	
	          // eslint-disable-next-line no-func-assign
	          nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode,
	              templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
	                controllerDirectives: controllerDirectives,
	                newScopeDirective: (newScopeDirective !== directive) && newScopeDirective,
	                newIsolateScopeDirective: newIsolateScopeDirective,
	                templateDirective: templateDirective,
	                nonTlbTranscludeDirective: nonTlbTranscludeDirective
	              });
	          ii = directives.length;
	        } else if (directive.compile) {
	          try {
	            linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
	            var context = directive.$$originalDirective || directive;
	            if (isFunction(linkFn)) {
	              addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
	            } else if (linkFn) {
	              addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
	            }
	          } catch (e) {
	            $exceptionHandler(e, startingTag($compileNode));
	          }
	        }
	
	        if (directive.terminal) {
	          nodeLinkFn.terminal = true;
	          terminalPriority = Math.max(terminalPriority, directive.priority);
	        }
	
	      }
	
	      nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
	      nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
	      nodeLinkFn.templateOnThisElement = hasTemplate;
	      nodeLinkFn.transclude = childTranscludeFn;
	
	      previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;
	
	      // might be normal or delayed nodeLinkFn depending on if templateUrl is present
	      return nodeLinkFn;
	
	      ////////////////////
	
	      function addLinkFns(pre, post, attrStart, attrEnd) {
	        if (pre) {
	          if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
	          pre.require = directive.require;
	          pre.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            pre = cloneAndAnnotateFn(pre, {isolateScope: true});
	          }
	          preLinkFns.push(pre);
	        }
	        if (post) {
	          if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
	          post.require = directive.require;
	          post.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            post = cloneAndAnnotateFn(post, {isolateScope: true});
	          }
	          postLinkFns.push(post);
	        }
	      }
	
	      function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
	        var i, ii, linkFn, isolateScope, controllerScope, elementControllers, transcludeFn, $element,
	            attrs, scopeBindingInfo;
	
	        if (compileNode === linkNode) {
	          attrs = templateAttrs;
	          $element = templateAttrs.$$element;
	        } else {
	          $element = jqLite(linkNode);
	          attrs = new Attributes($element, templateAttrs);
	        }
	
	        controllerScope = scope;
	        if (newIsolateScopeDirective) {
	          isolateScope = scope.$new(true);
	        } else if (newScopeDirective) {
	          controllerScope = scope.$parent;
	        }
	
	        if (boundTranscludeFn) {
	          // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
	          // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
	          transcludeFn = controllersBoundTransclude;
	          transcludeFn.$$boundTransclude = boundTranscludeFn;
	          // expose the slots on the `$transclude` function
	          transcludeFn.isSlotFilled = function(slotName) {
	            return !!boundTranscludeFn.$$slots[slotName];
	          };
	        }
	
	        if (controllerDirectives) {
	          elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
	        }
	
	        if (newIsolateScopeDirective) {
	          // Initialize isolate scope bindings for new isolate scope directive.
	          compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective ||
	              templateDirective === newIsolateScopeDirective.$$originalDirective)));
	          compile.$$addScopeClass($element, true);
	          isolateScope.$$isolateBindings =
	              newIsolateScopeDirective.$$isolateBindings;
	          scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope,
	                                        isolateScope.$$isolateBindings,
	                                        newIsolateScopeDirective);
	          if (scopeBindingInfo.removeWatches) {
	            isolateScope.$on('$destroy', scopeBindingInfo.removeWatches);
	          }
	        }
	
	        // Initialize bindToController bindings
	        for (var name in elementControllers) {
	          var controllerDirective = controllerDirectives[name];
	          var controller = elementControllers[name];
	          var bindings = controllerDirective.$$bindings.bindToController;
	
	          if (preAssignBindingsEnabled) {
	            if (bindings) {
	              controller.bindingInfo =
	                initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	            } else {
	              controller.bindingInfo = {};
	            }
	
	            var controllerResult = controller();
	            if (controllerResult !== controller.instance) {
	              // If the controller constructor has a return value, overwrite the instance
	              // from setupControllers
	              controller.instance = controllerResult;
	              $element.data('$' + controllerDirective.name + 'Controller', controllerResult);
	              if (controller.bindingInfo.removeWatches) {
	                controller.bindingInfo.removeWatches();
	              }
	              controller.bindingInfo =
	                initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	            }
	          } else {
	            controller.instance = controller();
	            $element.data('$' + controllerDirective.name + 'Controller', controller.instance);
	            controller.bindingInfo =
	              initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	          }
	        }
	
	        // Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
	        forEach(controllerDirectives, function(controllerDirective, name) {
	          var require = controllerDirective.require;
	          if (controllerDirective.bindToController && !isArray(require) && isObject(require)) {
	            extend(elementControllers[name].instance, getControllers(name, require, $element, elementControllers));
	          }
	        });
	
	        // Handle the init and destroy lifecycle hooks on all controllers that have them
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$onChanges)) {
	            try {
	              controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$onInit)) {
	            try {
	              controllerInstance.$onInit();
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$doCheck)) {
	            controllerScope.$watch(function() { controllerInstance.$doCheck(); });
	            controllerInstance.$doCheck();
	          }
	          if (isFunction(controllerInstance.$onDestroy)) {
	            controllerScope.$on('$destroy', function callOnDestroyHook() {
	              controllerInstance.$onDestroy();
	            });
	          }
	        });
	
	        // PRELINKING
	        for (i = 0, ii = preLinkFns.length; i < ii; i++) {
	          linkFn = preLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // RECURSION
	        // We only pass the isolate scope, if the isolate directive has a template,
	        // otherwise the child elements do not belong to the isolate directive.
	        var scopeToChild = scope;
	        if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
	          scopeToChild = isolateScope;
	        }
	        if (childLinkFn) {
	          childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
	        }
	
	        // POSTLINKING
	        for (i = postLinkFns.length - 1; i >= 0; i--) {
	          linkFn = postLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // Trigger $postLink lifecycle hooks
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$postLink)) {
	            controllerInstance.$postLink();
	          }
	        });
	
	        // This is the function that is injected as `$transclude`.
	        // Note: all arguments are optional!
	        function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
	          var transcludeControllers;
	          // No scope passed in:
	          if (!isScope(scope)) {
	            slotName = futureParentElement;
	            futureParentElement = cloneAttachFn;
	            cloneAttachFn = scope;
	            scope = undefined;
	          }
	
	          if (hasElementTranscludeDirective) {
	            transcludeControllers = elementControllers;
	          }
	          if (!futureParentElement) {
	            futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
	          }
	          if (slotName) {
	            // slotTranscludeFn can be one of three things:
	            //  * a transclude function - a filled slot
	            //  * `null` - an optional slot that was not filled
	            //  * `undefined` - a slot that was not declared (i.e. invalid)
	            var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
	            if (slotTranscludeFn) {
	              return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	            } else if (isUndefined(slotTranscludeFn)) {
	              throw $compileMinErr('noslot',
	               'No parent directive that requires a transclusion with slot name "{0}". ' +
	               'Element: {1}',
	               slotName, startingTag($element));
	            }
	          } else {
	            return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	          }
	        }
	      }
	    }
	
	    function getControllers(directiveName, require, $element, elementControllers) {
	      var value;
	
	      if (isString(require)) {
	        var match = require.match(REQUIRE_PREFIX_REGEXP);
	        var name = require.substring(match[0].length);
	        var inheritType = match[1] || match[3];
	        var optional = match[2] === '?';
	
	        //If only parents then start at the parent element
	        if (inheritType === '^^') {
	          $element = $element.parent();
	        //Otherwise attempt getting the controller from elementControllers in case
	        //the element is transcluded (and has no data) and to avoid .data if possible
	        } else {
	          value = elementControllers && elementControllers[name];
	          value = value && value.instance;
	        }
	
	        if (!value) {
	          var dataName = '$' + name + 'Controller';
	          value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
	        }
	
	        if (!value && !optional) {
	          throw $compileMinErr('ctreq',
	              'Controller \'{0}\', required by directive \'{1}\', can\'t be found!',
	              name, directiveName);
	        }
	      } else if (isArray(require)) {
	        value = [];
	        for (var i = 0, ii = require.length; i < ii; i++) {
	          value[i] = getControllers(directiveName, require[i], $element, elementControllers);
	        }
	      } else if (isObject(require)) {
	        value = {};
	        forEach(require, function(controller, property) {
	          value[property] = getControllers(directiveName, controller, $element, elementControllers);
	        });
	      }
	
	      return value || null;
	    }
	
	    function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
	      var elementControllers = createMap();
	      for (var controllerKey in controllerDirectives) {
	        var directive = controllerDirectives[controllerKey];
	        var locals = {
	          $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
	          $element: $element,
	          $attrs: attrs,
	          $transclude: transcludeFn
	        };
	
	        var controller = directive.controller;
	        if (controller === '@') {
	          controller = attrs[directive.name];
	        }
	
	        var controllerInstance = $controller(controller, locals, true, directive.controllerAs);
	
	        // For directives with element transclusion the element is a comment.
	        // In this case .data will not attach any data.
	        // Instead, we save the controllers for the element in a local hash and attach to .data
	        // later, once we have the actual element.
	        elementControllers[directive.name] = controllerInstance;
	        $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
	      }
	      return elementControllers;
	    }
	
	    // Depending upon the context in which a directive finds itself it might need to have a new isolated
	    // or child scope created. For instance:
	    // * if the directive has been pulled into a template because another directive with a higher priority
	    // asked for element transclusion
	    // * if the directive itself asks for transclusion but it is at the root of a template and the original
	    // element was replaced. See https://github.com/angular/angular.js/issues/12936
	    function markDirectiveScope(directives, isolateScope, newScope) {
	      for (var j = 0, jj = directives.length; j < jj; j++) {
	        directives[j] = inherit(directives[j], {$$isolateScope: isolateScope, $$newScope: newScope});
	      }
	    }
	
	    /**
	     * looks up the directive and decorates it with exception handling and proper parameters. We
	     * call this the boundDirective.
	     *
	     * @param {string} name name of the directive to look up.
	     * @param {string} location The directive must be found in specific format.
	     *   String containing any of theses characters:
	     *
	     *   * `E`: element name
	     *   * `A': attribute
	     *   * `C`: class
	     *   * `M`: comment
	     * @returns {boolean} true if directive was added.
	     */
	    function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName,
	                          endAttrName) {
	      if (name === ignoreDirective) return null;
	      var match = null;
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if ((isUndefined(maxPriority) || maxPriority > directive.priority) &&
	               directive.restrict.indexOf(location) !== -1) {
	            if (startAttrName) {
	              directive = inherit(directive, {$$start: startAttrName, $$end: endAttrName});
	            }
	            if (!directive.$$bindings) {
	              var bindings = directive.$$bindings =
	                  parseDirectiveBindings(directive, directive.name);
	              if (isObject(bindings.isolateScope)) {
	                directive.$$isolateBindings = bindings.isolateScope;
	              }
	            }
	            tDirectives.push(directive);
	            match = directive;
	          }
	        }
	      }
	      return match;
	    }
	
	
	    /**
	     * looks up the directive and returns true if it is a multi-element directive,
	     * and therefore requires DOM nodes between -start and -end markers to be grouped
	     * together.
	     *
	     * @param {string} name name of the directive to look up.
	     * @returns true if directive was registered as multi-element.
	     */
	    function directiveIsMultiElement(name) {
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if (directive.multiElement) {
	            return true;
	          }
	        }
	      }
	      return false;
	    }
	
	    /**
	     * When the element is replaced with HTML template then the new attributes
	     * on the template need to be merged with the existing attributes in the DOM.
	     * The desired effect is to have both of the attributes present.
	     *
	     * @param {object} dst destination attributes (original DOM)
	     * @param {object} src source attributes (from the directive template)
	     */
	    function mergeTemplateAttributes(dst, src) {
	      var srcAttr = src.$attr,
	          dstAttr = dst.$attr;
	
	      // reapply the old attributes to the new element
	      forEach(dst, function(value, key) {
	        if (key.charAt(0) !== '$') {
	          if (src[key] && src[key] !== value) {
	            if (value.length) {
	              value += (key === 'style' ? ';' : ' ') + src[key];
	            } else {
	              value = src[key];
	            }
	          }
	          dst.$set(key, value, true, srcAttr[key]);
	        }
	      });
	
	      // copy the new attributes on the old attrs object
	      forEach(src, function(value, key) {
	        // Check if we already set this attribute in the loop above.
	        // `dst` will never contain hasOwnProperty as DOM parser won't let it.
	        // You will get an "InvalidCharacterError: DOM Exception 5" error if you
	        // have an attribute like "has-own-property" or "data-has-own-property", etc.
	        if (!dst.hasOwnProperty(key) && key.charAt(0) !== '$') {
	          dst[key] = value;
	
	          if (key !== 'class' && key !== 'style') {
	            dstAttr[key] = srcAttr[key];
	          }
	        }
	      });
	    }
	
	
	    function compileTemplateUrl(directives, $compileNode, tAttrs,
	        $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
	      var linkQueue = [],
	          afterTemplateNodeLinkFn,
	          afterTemplateChildLinkFn,
	          beforeTemplateCompileNode = $compileNode[0],
	          origAsyncDirective = directives.shift(),
	          derivedSyncDirective = inherit(origAsyncDirective, {
	            templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
	          }),
	          templateUrl = (isFunction(origAsyncDirective.templateUrl))
	              ? origAsyncDirective.templateUrl($compileNode, tAttrs)
	              : origAsyncDirective.templateUrl,
	          templateNamespace = origAsyncDirective.templateNamespace;
	
	      $compileNode.empty();
	
	      $templateRequest(templateUrl)
	        .then(function(content) {
	          var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;
	
	          content = denormalizeTemplate(content);
	
	          if (origAsyncDirective.replace) {
	            if (jqLiteIsTextNode(content)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  'Template for directive \'{0}\' must have exactly one root element. {1}',
	                  origAsyncDirective.name, templateUrl);
	            }
	
	            tempTemplateAttrs = {$attr: {}};
	            replaceWith($rootElement, $compileNode, compileNode);
	            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);
	
	            if (isObject(origAsyncDirective.scope)) {
	              // the original directive that caused the template to be loaded async required
	              // an isolate scope
	              markDirectiveScope(templateDirectives, true);
	            }
	            directives = templateDirectives.concat(directives);
	            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
	          } else {
	            compileNode = beforeTemplateCompileNode;
	            $compileNode.html(content);
	          }
	
	          directives.unshift(derivedSyncDirective);
	
	          afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs,
	              childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns,
	              previousCompileContext);
	          forEach($rootElement, function(node, i) {
	            if (node === compileNode) {
	              $rootElement[i] = $compileNode[0];
	            }
	          });
	          afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);
	
	          while (linkQueue.length) {
	            var scope = linkQueue.shift(),
	                beforeTemplateLinkNode = linkQueue.shift(),
	                linkRootElement = linkQueue.shift(),
	                boundTranscludeFn = linkQueue.shift(),
	                linkNode = $compileNode[0];
	
	            if (scope.$$destroyed) continue;
	
	            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
	              var oldClasses = beforeTemplateLinkNode.className;
	
	              if (!(previousCompileContext.hasElementTranscludeDirective &&
	                  origAsyncDirective.replace)) {
	                // it was cloned therefore we have to clone as well.
	                linkNode = jqLiteClone(compileNode);
	              }
	              replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);
	
	              // Copy in CSS classes from original node
	              safeAddClass(jqLite(linkNode), oldClasses);
	            }
	            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	            } else {
	              childBoundTranscludeFn = boundTranscludeFn;
	            }
	            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement,
	              childBoundTranscludeFn);
	          }
	          linkQueue = null;
	        }).catch(function(error) {
	          if (error instanceof Error) {
	            $exceptionHandler(error);
	          }
	        });
	
	      return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
	        var childBoundTranscludeFn = boundTranscludeFn;
	        if (scope.$$destroyed) return;
	        if (linkQueue) {
	          linkQueue.push(scope,
	                         node,
	                         rootElement,
	                         childBoundTranscludeFn);
	        } else {
	          if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	            childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	          }
	          afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
	        }
	      };
	    }
	
	
	    /**
	     * Sorting function for bound directives.
	     */
	    function byPriority(a, b) {
	      var diff = b.priority - a.priority;
	      if (diff !== 0) return diff;
	      if (a.name !== b.name) return (a.name < b.name) ? -1 : 1;
	      return a.index - b.index;
	    }
	
	    function assertNoDuplicate(what, previousDirective, directive, element) {
	
	      function wrapModuleNameIfDefined(moduleName) {
	        return moduleName ?
	          (' (module: ' + moduleName + ')') :
	          '';
	      }
	
	      if (previousDirective) {
	        throw $compileMinErr('multidir', 'Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}',
	            previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName),
	            directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
	      }
	    }
	
	
	    function addTextInterpolateDirective(directives, text) {
	      var interpolateFn = $interpolate(text, true);
	      if (interpolateFn) {
	        directives.push({
	          priority: 0,
	          compile: function textInterpolateCompileFn(templateNode) {
	            var templateNodeParent = templateNode.parent(),
	                hasCompileParent = !!templateNodeParent.length;
	
	            // When transcluding a template that has bindings in the root
	            // we don't have a parent and thus need to add the class during linking fn.
	            if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);
	
	            return function textInterpolateLinkFn(scope, node) {
	              var parent = node.parent();
	              if (!hasCompileParent) compile.$$addBindingClass(parent);
	              compile.$$addBindingInfo(parent, interpolateFn.expressions);
	              scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
	                node[0].nodeValue = value;
	              });
	            };
	          }
	        });
	      }
	    }
	
	
	    function wrapTemplate(type, template) {
	      type = lowercase(type || 'html');
	      switch (type) {
	      case 'svg':
	      case 'math':
	        var wrapper = window.document.createElement('div');
	        wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
	        return wrapper.childNodes[0].childNodes;
	      default:
	        return template;
	      }
	    }
	
	
	    function getTrustedContext(node, attrNormalizedName) {
	      if (attrNormalizedName === 'srcdoc') {
	        return $sce.HTML;
	      }
	      var tag = nodeName_(node);
	      // All tags with src attributes require a RESOURCE_URL value, except for
	      // img and various html5 media tags.
	      if (attrNormalizedName === 'src' || attrNormalizedName === 'ngSrc') {
	        if (['img', 'video', 'audio', 'source', 'track'].indexOf(tag) === -1) {
	          return $sce.RESOURCE_URL;
	        }
	      // maction[xlink:href] can source SVG.  It's not limited to <maction>.
	      } else if (attrNormalizedName === 'xlinkHref' ||
	          (tag === 'form' && attrNormalizedName === 'action') ||
	          // links can be stylesheets or imports, which can run script in the current origin
	          (tag === 'link' && attrNormalizedName === 'href')
	      ) {
	        return $sce.RESOURCE_URL;
	      }
	    }
	
	
	    function addAttrInterpolateDirective(node, directives, value, name, isNgAttr) {
	      var trustedContext = getTrustedContext(node, name);
	      var mustHaveExpression = !isNgAttr;
	      var allOrNothing = ALL_OR_NOTHING_ATTRS[name] || isNgAttr;
	
	      var interpolateFn = $interpolate(value, mustHaveExpression, trustedContext, allOrNothing);
	
	      // no interpolation found -> ignore
	      if (!interpolateFn) return;
	
	      if (name === 'multiple' && nodeName_(node) === 'select') {
	        throw $compileMinErr('selmulti',
	            'Binding to the \'multiple\' attribute is not supported. Element: {0}',
	            startingTag(node));
	      }
	
	      if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
	        throw $compileMinErr('nodomevents',
	            'Interpolations for HTML DOM event attributes are disallowed.  Please use the ' +
	                'ng- versions (such as ng-click instead of onclick) instead.');
	      }
	
	      directives.push({
	        priority: 100,
	        compile: function() {
	            return {
	              pre: function attrInterpolatePreLinkFn(scope, element, attr) {
	                var $$observers = (attr.$$observers || (attr.$$observers = createMap()));
	
	                // If the attribute has changed since last $interpolate()ed
	                var newValue = attr[name];
	                if (newValue !== value) {
	                  // we need to interpolate again since the attribute value has been updated
	                  // (e.g. by another directive's compile function)
	                  // ensure unset/empty values make interpolateFn falsy
	                  interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
	                  value = newValue;
	                }
	
	                // if attribute was updated so that there is no interpolation going on we don't want to
	                // register any observers
	                if (!interpolateFn) return;
	
	                // initialize attr object so that it's ready in case we need the value for isolate
	                // scope initialization, otherwise the value would not be available from isolate
	                // directive's linking fn during linking phase
	                attr[name] = interpolateFn(scope);
	
	                ($$observers[name] || ($$observers[name] = [])).$$inter = true;
	                (attr.$$observers && attr.$$observers[name].$$scope || scope).
	                  $watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
	                    //special case for class attribute addition + removal
	                    //so that class changes can tap into the animation
	                    //hooks provided by the $animate service. Be sure to
	                    //skip animations when the first digest occurs (when
	                    //both the new and the old values are the same) since
	                    //the CSS classes are the non-interpolated values
	                    if (name === 'class' && newValue !== oldValue) {
	                      attr.$updateClass(newValue, oldValue);
	                    } else {
	                      attr.$set(name, newValue);
	                    }
	                  });
	              }
	            };
	          }
	      });
	    }
	
	
	    /**
	     * This is a special jqLite.replaceWith, which can replace items which
	     * have no parents, provided that the containing jqLite collection is provided.
	     *
	     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
	     *                               in the root of the tree.
	     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
	     *                                  the shell, but replace its DOM node reference.
	     * @param {Node} newNode The new DOM node.
	     */
	    function replaceWith($rootElement, elementsToRemove, newNode) {
	      var firstElementToRemove = elementsToRemove[0],
	          removeCount = elementsToRemove.length,
	          parent = firstElementToRemove.parentNode,
	          i, ii;
	
	      if ($rootElement) {
	        for (i = 0, ii = $rootElement.length; i < ii; i++) {
	          if ($rootElement[i] === firstElementToRemove) {
	            $rootElement[i++] = newNode;
	            for (var j = i, j2 = j + removeCount - 1,
	                     jj = $rootElement.length;
	                 j < jj; j++, j2++) {
	              if (j2 < jj) {
	                $rootElement[j] = $rootElement[j2];
	              } else {
	                delete $rootElement[j];
	              }
	            }
	            $rootElement.length -= removeCount - 1;
	
	            // If the replaced element is also the jQuery .context then replace it
	            // .context is a deprecated jQuery api, so we should set it only when jQuery set it
	            // http://api.jquery.com/context/
	            if ($rootElement.context === firstElementToRemove) {
	              $rootElement.context = newNode;
	            }
	            break;
	          }
	        }
	      }
	
	      if (parent) {
	        parent.replaceChild(newNode, firstElementToRemove);
	      }
	
	      // Append all the `elementsToRemove` to a fragment. This will...
	      // - remove them from the DOM
	      // - allow them to still be traversed with .nextSibling
	      // - allow a single fragment.qSA to fetch all elements being removed
	      var fragment = window.document.createDocumentFragment();
	      for (i = 0; i < removeCount; i++) {
	        fragment.appendChild(elementsToRemove[i]);
	      }
	
	      if (jqLite.hasData(firstElementToRemove)) {
	        // Copy over user data (that includes Angular's $scope etc.). Don't copy private
	        // data here because there's no public interface in jQuery to do that and copying over
	        // event listeners (which is the main use of private data) wouldn't work anyway.
	        jqLite.data(newNode, jqLite.data(firstElementToRemove));
	
	        // Remove $destroy event listeners from `firstElementToRemove`
	        jqLite(firstElementToRemove).off('$destroy');
	      }
	
	      // Cleanup any data/listeners on the elements and children.
	      // This includes invoking the $destroy event on any elements with listeners.
	      jqLite.cleanData(fragment.querySelectorAll('*'));
	
	      // Update the jqLite collection to only contain the `newNode`
	      for (i = 1; i < removeCount; i++) {
	        delete elementsToRemove[i];
	      }
	      elementsToRemove[0] = newNode;
	      elementsToRemove.length = 1;
	    }
	
	
	    function cloneAndAnnotateFn(fn, annotation) {
	      return extend(function() { return fn.apply(null, arguments); }, fn, annotation);
	    }
	
	
	    function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
	      try {
	        linkFn(scope, $element, attrs, controllers, transcludeFn);
	      } catch (e) {
	        $exceptionHandler(e, startingTag($element));
	      }
	    }
	
	
	    // Set up $watches for isolate scope and controller bindings.
	    function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
	      var removeWatchCollection = [];
	      var initialChanges = {};
	      var changes;
	      forEach(bindings, function initializeBinding(definition, scopeName) {
	        var attrName = definition.attrName,
	        optional = definition.optional,
	        mode = definition.mode, // @, =, <, or &
	        lastValue,
	        parentGet, parentSet, compare, removeWatch;
	
	        switch (mode) {
	
	          case '@':
	            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
	              destination[scopeName] = attrs[attrName] = undefined;
	            }
	            removeWatch = attrs.$observe(attrName, function(value) {
	              if (isString(value) || isBoolean(value)) {
	                var oldValue = destination[scopeName];
	                recordChanges(scopeName, value, oldValue);
	                destination[scopeName] = value;
	              }
	            });
	            attrs.$$observers[attrName].$$scope = scope;
	            lastValue = attrs[attrName];
	            if (isString(lastValue)) {
	              // If the attribute has been provided then we trigger an interpolation to ensure
	              // the value is there for use in the link fn
	              destination[scopeName] = $interpolate(lastValue)(scope);
	            } else if (isBoolean(lastValue)) {
	              // If the attributes is one of the BOOLEAN_ATTR then Angular will have converted
	              // the value to boolean rather than a string, so we special case this situation
	              destination[scopeName] = lastValue;
	            }
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '=':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              attrs[attrName] = undefined;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            if (parentGet.literal) {
	              compare = equals;
	            } else {
	              compare = simpleCompare;
	            }
	            parentSet = parentGet.assign || function() {
	              // reset the change, or we will throw this exception on every $digest
	              lastValue = destination[scopeName] = parentGet(scope);
	              throw $compileMinErr('nonassign',
	                  'Expression \'{0}\' in attribute \'{1}\' used with directive \'{2}\' is non-assignable!',
	                  attrs[attrName], attrName, directive.name);
	            };
	            lastValue = destination[scopeName] = parentGet(scope);
	            var parentValueWatch = function parentValueWatch(parentValue) {
	              if (!compare(parentValue, destination[scopeName])) {
	                // we are out of sync and need to copy
	                if (!compare(parentValue, lastValue)) {
	                  // parent changed and it has precedence
	                  destination[scopeName] = parentValue;
	                } else {
	                  // if the parent can be assigned then do so
	                  parentSet(scope, parentValue = destination[scopeName]);
	                }
	              }
	              lastValue = parentValue;
	              return lastValue;
	            };
	            parentValueWatch.$stateful = true;
	            if (definition.collection) {
	              removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
	            } else {
	              removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
	            }
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '<':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              attrs[attrName] = undefined;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            var deepWatch = parentGet.literal;
	
	            var initialValue = destination[scopeName] = parentGet(scope);
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	
	            removeWatch = scope.$watch(parentGet, function parentValueWatchAction(newValue, oldValue) {
	              if (oldValue === newValue) {
	                if (oldValue === initialValue || (deepWatch && equals(oldValue, initialValue))) {
	                  return;
	                }
	                oldValue = initialValue;
	              }
	              recordChanges(scopeName, newValue, oldValue);
	              destination[scopeName] = newValue;
	            }, deepWatch);
	
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '&':
	            // Don't assign Object.prototype method to scope
	            parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;
	
	            // Don't assign noop to destination if expression is not valid
	            if (parentGet === noop && optional) break;
	
	            destination[scopeName] = function(locals) {
	              return parentGet(scope, locals);
	            };
	            break;
	        }
	      });
	
	      function recordChanges(key, currentValue, previousValue) {
	        if (isFunction(destination.$onChanges) && !simpleCompare(currentValue, previousValue)) {
	          // If we have not already scheduled the top level onChangesQueue handler then do so now
	          if (!onChangesQueue) {
	            scope.$$postDigest(flushOnChangesQueue);
	            onChangesQueue = [];
	          }
	          // If we have not already queued a trigger of onChanges for this controller then do so now
	          if (!changes) {
	            changes = {};
	            onChangesQueue.push(triggerOnChangesHook);
	          }
	          // If the has been a change on this property already then we need to reuse the previous value
	          if (changes[key]) {
	            previousValue = changes[key].previousValue;
	          }
	          // Store this change
	          changes[key] = new SimpleChange(previousValue, currentValue);
	        }
	      }
	
	      function triggerOnChangesHook() {
	        destination.$onChanges(changes);
	        // Now clear the changes so that we schedule onChanges when more changes arrive
	        changes = undefined;
	      }
	
	      return {
	        initialChanges: initialChanges,
	        removeWatches: removeWatchCollection.length && function removeWatches() {
	          for (var i = 0, ii = removeWatchCollection.length; i < ii; ++i) {
	            removeWatchCollection[i]();
	          }
	        }
	      };
	    }
	  }];
	}
	
	function SimpleChange(previous, current) {
	  this.previousValue = previous;
	  this.currentValue = current;
	}
	SimpleChange.prototype.isFirstChange = function() { return this.previousValue === _UNINITIALIZED_VALUE; };
	
	
	var PREFIX_REGEXP = /^((?:x|data)[:\-_])/i;
	var SPECIAL_CHARS_REGEXP = /[:\-_]+(.)/g;
	
	/**
	 * Converts all accepted directives format into proper directive name.
	 * @param name Name to normalize
	 */
	function directiveNormalize(name) {
	  return name
	    .replace(PREFIX_REGEXP, '')
	    .replace(SPECIAL_CHARS_REGEXP, fnCamelCaseReplace);
	}
	
	/**
	 * @ngdoc type
	 * @name $compile.directive.Attributes
	 *
	 * @description
	 * A shared object between directive compile / linking functions which contains normalized DOM
	 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
	 * needed since all of these are treated as equivalent in Angular:
	 *
	 * ```
	 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
	 * ```
	 */
	
	/**
	 * @ngdoc property
	 * @name $compile.directive.Attributes#$attr
	 *
	 * @description
	 * A map of DOM element attribute names to the normalized name. This is
	 * needed to do reverse lookup from normalized name back to actual name.
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $compile.directive.Attributes#$set
	 * @kind function
	 *
	 * @description
	 * Set DOM element attribute value.
	 *
	 *
	 * @param {string} name Normalized element attribute name of the property to modify. The name is
	 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
	 *          property to the original name.
	 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
	 */
	
	
	
	/**
	 * Closure compiler type information
	 */
	
	function nodesetLinkingFn(
	  /* angular.Scope */ scope,
	  /* NodeList */ nodeList,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function directiveLinkingFn(
	  /* nodesetLinkingFn */ nodesetLinkingFn,
	  /* angular.Scope */ scope,
	  /* Node */ node,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function tokenDifference(str1, str2) {
	  var values = '',
	      tokens1 = str1.split(/\s+/),
	      tokens2 = str2.split(/\s+/);
	
	  outer:
	  for (var i = 0; i < tokens1.length; i++) {
	    var token = tokens1[i];
	    for (var j = 0; j < tokens2.length; j++) {
	      if (token === tokens2[j]) continue outer;
	    }
	    values += (values.length > 0 ? ' ' : '') + token;
	  }
	  return values;
	}
	
	function removeComments(jqNodes) {
	  jqNodes = jqLite(jqNodes);
	  var i = jqNodes.length;
	
	  if (i <= 1) {
	    return jqNodes;
	  }
	
	  while (i--) {
	    var node = jqNodes[i];
	    if (node.nodeType === NODE_TYPE_COMMENT ||
	       (node.nodeType === NODE_TYPE_TEXT && node.nodeValue.trim() === '')) {
	         splice.call(jqNodes, i, 1);
	    }
	  }
	  return jqNodes;
	}
	
	var $controllerMinErr = minErr('$controller');
	
	
	var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
	function identifierForController(controller, ident) {
	  if (ident && isString(ident)) return ident;
	  if (isString(controller)) {
	    var match = CNTRL_REG.exec(controller);
	    if (match) return match[3];
	  }
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $controllerProvider
	 * @this
	 *
	 * @description
	 * The {@link ng.$controller $controller service} is used by Angular to create new
	 * controllers.
	 *
	 * This provider allows controller registration via the
	 * {@link ng.$controllerProvider#register register} method.
	 */
	function $ControllerProvider() {
	  var controllers = {},
	      globals = false;
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#has
	   * @param {string} name Controller name to check.
	   */
	  this.has = function(name) {
	    return controllers.hasOwnProperty(name);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#register
	   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
	   *    the names and the values are the constructors.
	   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
	   *    annotations in the array notation).
	   */
	  this.register = function(name, constructor) {
	    assertNotHasOwnProperty(name, 'controller');
	    if (isObject(name)) {
	      extend(controllers, name);
	    } else {
	      controllers[name] = constructor;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#allowGlobals
	   * @description If called, allows `$controller` to find controller constructors on `window`
	   *
	   * @deprecated
	   * sinceVersion="v1.3.0"
	   * removeVersion="v1.7.0"
	   * This method of finding controllers has been deprecated.
	   */
	  this.allowGlobals = function() {
	    globals = true;
	  };
	
	
	  this.$get = ['$injector', '$window', function($injector, $window) {
	
	    /**
	     * @ngdoc service
	     * @name $controller
	     * @requires $injector
	     *
	     * @param {Function|string} constructor If called with a function then it's considered to be the
	     *    controller constructor function. Otherwise it's considered to be a string which is used
	     *    to retrieve the controller constructor using the following steps:
	     *
	     *    * check if a controller with given name is registered via `$controllerProvider`
	     *    * check if evaluating the string on the current scope returns a constructor
	     *    * if $controllerProvider#allowGlobals, check `window[constructor]` on the global
	     *      `window` object (deprecated, not recommended)
	     *
	     *    The string can use the `controller as property` syntax, where the controller instance is published
	     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
	     *    to work correctly.
	     *
	     * @param {Object} locals Injection locals for Controller.
	     * @return {Object} Instance of given controller.
	     *
	     * @description
	     * `$controller` service is responsible for instantiating controllers.
	     *
	     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
	     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
	     */
	    return function $controller(expression, locals, later, ident) {
	      // PRIVATE API:
	      //   param `later` --- indicates that the controller's constructor is invoked at a later time.
	      //                     If true, $controller will allocate the object with the correct
	      //                     prototype chain, but will not invoke the controller until a returned
	      //                     callback is invoked.
	      //   param `ident` --- An optional label which overrides the label parsed from the controller
	      //                     expression, if any.
	      var instance, match, constructor, identifier;
	      later = later === true;
	      if (ident && isString(ident)) {
	        identifier = ident;
	      }
	
	      if (isString(expression)) {
	        match = expression.match(CNTRL_REG);
	        if (!match) {
	          throw $controllerMinErr('ctrlfmt',
	            'Badly formed controller string \'{0}\'. ' +
	            'Must match `__name__ as __id__` or `__name__`.', expression);
	        }
	        constructor = match[1];
	        identifier = identifier || match[3];
	        expression = controllers.hasOwnProperty(constructor)
	            ? controllers[constructor]
	            : getter(locals.$scope, constructor, true) ||
	                (globals ? getter($window, constructor, true) : undefined);
	
	        if (!expression) {
	          throw $controllerMinErr('ctrlreg',
	            'The controller with the name \'{0}\' is not registered.', constructor);
	        }
	
	        assertArgFn(expression, constructor, true);
	      }
	
	      if (later) {
	        // Instantiate controller later:
	        // This machinery is used to create an instance of the object before calling the
	        // controller's constructor itself.
	        //
	        // This allows properties to be added to the controller before the constructor is
	        // invoked. Primarily, this is used for isolate scope bindings in $compile.
	        //
	        // This feature is not intended for use by applications, and is thus not documented
	        // publicly.
	        // Object creation: http://jsperf.com/create-constructor/2
	        var controllerPrototype = (isArray(expression) ?
	          expression[expression.length - 1] : expression).prototype;
	        instance = Object.create(controllerPrototype || null);
	
	        if (identifier) {
	          addIdentifier(locals, identifier, instance, constructor || expression.name);
	        }
	
	        return extend(function $controllerInit() {
	          var result = $injector.invoke(expression, instance, locals, constructor);
	          if (result !== instance && (isObject(result) || isFunction(result))) {
	            instance = result;
	            if (identifier) {
	              // If result changed, re-assign controllerAs value to scope.
	              addIdentifier(locals, identifier, instance, constructor || expression.name);
	            }
	          }
	          return instance;
	        }, {
	          instance: instance,
	          identifier: identifier
	        });
	      }
	
	      instance = $injector.instantiate(expression, locals, constructor);
	
	      if (identifier) {
	        addIdentifier(locals, identifier, instance, constructor || expression.name);
	      }
	
	      return instance;
	    };
	
	    function addIdentifier(locals, identifier, instance, name) {
	      if (!(locals && isObject(locals.$scope))) {
	        throw minErr('$controller')('noscp',
	          'Cannot export controller \'{0}\' as \'{1}\'! No $scope object provided via `locals`.',
	          name, identifier);
	      }
	
	      locals.$scope[identifier] = instance;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $document
	 * @requires $window
	 * @this
	 *
	 * @description
	 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
	 *
	 * @example
	   <example module="documentExample" name="document">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <p>$document title: <b ng-bind="title"></b></p>
	         <p>window.document title: <b ng-bind="windowTitle"></b></p>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('documentExample', [])
	         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
	           $scope.title = $document[0].title;
	           $scope.windowTitle = angular.element(window.document)[0].title;
	         }]);
	     </file>
	   </example>
	 */
	function $DocumentProvider() {
	  this.$get = ['$window', function(window) {
	    return jqLite(window.document);
	  }];
	}
	
	
	/**
	 * @private
	 * @this
	 * Listens for document visibility change and makes the current status accessible.
	 */
	function $$IsDocumentHiddenProvider() {
	  this.$get = ['$document', '$rootScope', function($document, $rootScope) {
	    var doc = $document[0];
	    var hidden = doc && doc.hidden;
	
	    $document.on('visibilitychange', changeListener);
	
	    $rootScope.$on('$destroy', function() {
	      $document.off('visibilitychange', changeListener);
	    });
	
	    function changeListener() {
	      hidden = doc.hidden;
	    }
	
	    return function() {
	      return hidden;
	    };
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $exceptionHandler
	 * @requires ng.$log
	 * @this
	 *
	 * @description
	 * Any uncaught exception in angular expressions is delegated to this service.
	 * The default implementation simply delegates to `$log.error` which logs it into
	 * the browser console.
	 *
	 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
	 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
	 *
	 * ## Example:
	 *
	 * The example below will overwrite the default `$exceptionHandler` in order to (a) log uncaught
	 * errors to the backend for later inspection by the developers and (b) to use `$log.warn()` instead
	 * of `$log.error()`.
	 *
	 * ```js
	 *   angular.
	 *     module('exceptionOverwrite', []).
	 *     factory('$exceptionHandler', ['$log', 'logErrorsToBackend', function($log, logErrorsToBackend) {
	 *       return function myExceptionHandler(exception, cause) {
	 *         logErrorsToBackend(exception, cause);
	 *         $log.warn(exception, cause);
	 *       };
	 *     }]);
	 * ```
	 *
	 * <hr />
	 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
	 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
	 * (unless executed during a digest).
	 *
	 * If you wish, you can manually delegate exceptions, e.g.
	 * `try { ... } catch(e) { $exceptionHandler(e); }`
	 *
	 * @param {Error} exception Exception associated with the error.
	 * @param {string=} cause Optional information about the context in which
	 *       the error was thrown.
	 *
	 */
	function $ExceptionHandlerProvider() {
	  this.$get = ['$log', function($log) {
	    return function(exception, cause) {
	      $log.error.apply($log, arguments);
	    };
	  }];
	}
	
	var $$ForceReflowProvider = /** @this */ function() {
	  this.$get = ['$document', function($document) {
	    return function(domNode) {
	      //the line below will force the browser to perform a repaint so
	      //that all the animated elements within the animation frame will
	      //be properly updated and drawn on screen. This is required to
	      //ensure that the preparation animation is properly flushed so that
	      //the active state picks up from there. DO NOT REMOVE THIS LINE.
	      //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
	      //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
	      //WILL TAKE YEARS AWAY FROM YOUR LIFE.
	      if (domNode) {
	        if (!domNode.nodeType && domNode instanceof jqLite) {
	          domNode = domNode[0];
	        }
	      } else {
	        domNode = $document[0].body;
	      }
	      return domNode.offsetWidth + 1;
	    };
	  }];
	};
	
	var APPLICATION_JSON = 'application/json';
	var CONTENT_TYPE_APPLICATION_JSON = {'Content-Type': APPLICATION_JSON + ';charset=utf-8'};
	var JSON_START = /^\[|^\{(?!\{)/;
	var JSON_ENDS = {
	  '[': /]$/,
	  '{': /}$/
	};
	var JSON_PROTECTION_PREFIX = /^\)]\}',?\n/;
	var $httpMinErr = minErr('$http');
	
	function serializeValue(v) {
	  if (isObject(v)) {
	    return isDate(v) ? v.toISOString() : toJson(v);
	  }
	  return v;
	}
	
	
	/** @this */
	function $HttpParamSerializerProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializer
	   * @description
	   *
	   * Default {@link $http `$http`} params serializer that converts objects to strings
	   * according to the following rules:
	   *
	   * * `{'foo': 'bar'}` results in `foo=bar`
	   * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
	   * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
	   * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D` (stringified and encoded representation of an object)
	   *
	   * Note that serializer will sort the request parameters alphabetically.
	   * */
	
	  this.$get = function() {
	    return function ngParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      forEachSorted(params, function(value, key) {
	        if (value === null || isUndefined(value)) return;
	        if (isArray(value)) {
	          forEach(value, function(v) {
	            parts.push(encodeUriQuery(key)  + '=' + encodeUriQuery(serializeValue(v)));
	          });
	        } else {
	          parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(value)));
	        }
	      });
	
	      return parts.join('&');
	    };
	  };
	}
	
	/** @this */
	function $HttpParamSerializerJQLikeProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializerJQLike
	   *
	   * @description
	   *
	   * Alternative {@link $http `$http`} params serializer that follows
	   * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
	   * The serializer will also sort the params alphabetically.
	   *
	   * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
	   *
	   * ```js
	   * $http({
	   *   url: myUrl,
	   *   method: 'GET',
	   *   params: myParams,
	   *   paramSerializer: '$httpParamSerializerJQLike'
	   * });
	   * ```
	   *
	   * It is also possible to set it as the default `paramSerializer` in the
	   * {@link $httpProvider#defaults `$httpProvider`}.
	   *
	   * Additionally, you can inject the serializer and use it explicitly, for example to serialize
	   * form data for submission:
	   *
	   * ```js
	   * .controller(function($http, $httpParamSerializerJQLike) {
	   *   //...
	   *
	   *   $http({
	   *     url: myUrl,
	   *     method: 'POST',
	   *     data: $httpParamSerializerJQLike(myData),
	   *     headers: {
	   *       'Content-Type': 'application/x-www-form-urlencoded'
	   *     }
	   *   });
	   *
	   * });
	   * ```
	   *
	   * */
	  this.$get = function() {
	    return function jQueryLikeParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      serialize(params, '', true);
	      return parts.join('&');
	
	      function serialize(toSerialize, prefix, topLevel) {
	        if (toSerialize === null || isUndefined(toSerialize)) return;
	        if (isArray(toSerialize)) {
	          forEach(toSerialize, function(value, index) {
	            serialize(value, prefix + '[' + (isObject(value) ? index : '') + ']');
	          });
	        } else if (isObject(toSerialize) && !isDate(toSerialize)) {
	          forEachSorted(toSerialize, function(value, key) {
	            serialize(value, prefix +
	                (topLevel ? '' : '[') +
	                key +
	                (topLevel ? '' : ']'));
	          });
	        } else {
	          parts.push(encodeUriQuery(prefix) + '=' + encodeUriQuery(serializeValue(toSerialize)));
	        }
	      }
	    };
	  };
	}
	
	function defaultHttpResponseTransform(data, headers) {
	  if (isString(data)) {
	    // Strip json vulnerability protection prefix and trim whitespace
	    var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();
	
	    if (tempData) {
	      var contentType = headers('Content-Type');
	      if ((contentType && (contentType.indexOf(APPLICATION_JSON) === 0)) || isJsonLike(tempData)) {
	        try {
	          data = fromJson(tempData);
	        } catch (e) {
	          throw $httpMinErr('baddata', 'Data must be a valid JSON object. Received: "{0}". ' +
	          'Parse error: "{1}"', data, e);
	        }
	      }
	    }
	  }
	
	  return data;
	}
	
	function isJsonLike(str) {
	    var jsonStart = str.match(JSON_START);
	    return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
	}
	
	/**
	 * Parse headers into key value object
	 *
	 * @param {string} headers Raw headers as a string
	 * @returns {Object} Parsed headers as key value object
	 */
	function parseHeaders(headers) {
	  var parsed = createMap(), i;
	
	  function fillInParsed(key, val) {
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  }
	
	  if (isString(headers)) {
	    forEach(headers.split('\n'), function(line) {
	      i = line.indexOf(':');
	      fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
	    });
	  } else if (isObject(headers)) {
	    forEach(headers, function(headerVal, headerKey) {
	      fillInParsed(lowercase(headerKey), trim(headerVal));
	    });
	  }
	
	  return parsed;
	}
	
	
	/**
	 * Returns a function that provides access to parsed headers.
	 *
	 * Headers are lazy parsed when first requested.
	 * @see parseHeaders
	 *
	 * @param {(string|Object)} headers Headers to provide access to.
	 * @returns {function(string=)} Returns a getter function which if called with:
	 *
	 *   - if called with an argument returns a single header value or null
	 *   - if called with no arguments returns an object containing all headers.
	 */
	function headersGetter(headers) {
	  var headersObj;
	
	  return function(name) {
	    if (!headersObj) headersObj =  parseHeaders(headers);
	
	    if (name) {
	      var value = headersObj[lowercase(name)];
	      if (value === undefined) {
	        value = null;
	      }
	      return value;
	    }
	
	    return headersObj;
	  };
	}
	
	
	/**
	 * Chain all given functions
	 *
	 * This function is used for both request and response transforming
	 *
	 * @param {*} data Data to transform.
	 * @param {function(string=)} headers HTTP headers getter fn.
	 * @param {number} status HTTP status code of the response.
	 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
	 * @returns {*} Transformed data.
	 */
	function transformData(data, headers, status, fns) {
	  if (isFunction(fns)) {
	    return fns(data, headers, status);
	  }
	
	  forEach(fns, function(fn) {
	    data = fn(data, headers, status);
	  });
	
	  return data;
	}
	
	
	function isSuccess(status) {
	  return 200 <= status && status < 300;
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $httpProvider
	 * @this
	 *
	 * @description
	 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
	 * */
	function $HttpProvider() {
	  /**
	   * @ngdoc property
	   * @name $httpProvider#defaults
	   * @description
	   *
	   * Object containing default values for all {@link ng.$http $http} requests.
	   *
	   * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
	   * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
	   * by default. See {@link $http#caching $http Caching} for more information.
	   *
	   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
	   * Defaults value is `'XSRF-TOKEN'`.
	   *
	   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
	   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
	   *
	   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
	   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
	   * setting default headers.
	   *     - **`defaults.headers.common`**
	   *     - **`defaults.headers.post`**
	   *     - **`defaults.headers.put`**
	   *     - **`defaults.headers.patch`**
	   *
	   *
	   * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
	   *  used to the prepare string representation of request parameters (specified as an object).
	   *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
	   *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
	   *
	   * - **`defaults.jsonpCallbackParam`** - `{string}` - the name of the query parameter that passes the name of the
	   * callback in a JSONP request. The value of this parameter will be replaced with the expression generated by the
	   * {@link $jsonpCallbacks} service. Defaults to `'callback'`.
	   *
	   **/
	  var defaults = this.defaults = {
	    // transform incoming response data
	    transformResponse: [defaultHttpResponseTransform],
	
	    // transform outgoing request data
	    transformRequest: [function(d) {
	      return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
	    }],
	
	    // default headers
	    headers: {
	      common: {
	        'Accept': 'application/json, text/plain, */*'
	      },
	      post:   shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      put:    shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      patch:  shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
	    },
	
	    xsrfCookieName: 'XSRF-TOKEN',
	    xsrfHeaderName: 'X-XSRF-TOKEN',
	
	    paramSerializer: '$httpParamSerializer',
	
	    jsonpCallbackParam: 'callback'
	  };
	
	  var useApplyAsync = false;
	  /**
	   * @ngdoc method
	   * @name $httpProvider#useApplyAsync
	   * @description
	   *
	   * Configure $http service to combine processing of multiple http responses received at around
	   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
	   * significant performance improvement for bigger applications that make many HTTP requests
	   * concurrently (common during application bootstrap).
	   *
	   * Defaults to false. If no value is specified, returns the current configured value.
	   *
	   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
	   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
	   *    to load and share the same digest cycle.
	   *
	   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
	   *    otherwise, returns the current configured value.
	   **/
	  this.useApplyAsync = function(value) {
	    if (isDefined(value)) {
	      useApplyAsync = !!value;
	      return this;
	    }
	    return useApplyAsync;
	  };
	
	  /**
	   * @ngdoc property
	   * @name $httpProvider#interceptors
	   * @description
	   *
	   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
	   * pre-processing of request or postprocessing of responses.
	   *
	   * These service factories are ordered by request, i.e. they are applied in the same order as the
	   * array, on request, but reverse order, on response.
	   *
	   * {@link ng.$http#interceptors Interceptors detailed info}
	   **/
	  var interceptorFactories = this.interceptors = [];
	
	  this.$get = ['$browser', '$httpBackend', '$$cookieReader', '$cacheFactory', '$rootScope', '$q', '$injector', '$sce',
	      function($browser, $httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector, $sce) {
	
	    var defaultCache = $cacheFactory('$http');
	
	    /**
	     * Make sure that default param serializer is exposed as a function
	     */
	    defaults.paramSerializer = isString(defaults.paramSerializer) ?
	      $injector.get(defaults.paramSerializer) : defaults.paramSerializer;
	
	    /**
	     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
	     * The reversal is needed so that we can build up the interception chain around the
	     * server request.
	     */
	    var reversedInterceptors = [];
	
	    forEach(interceptorFactories, function(interceptorFactory) {
	      reversedInterceptors.unshift(isString(interceptorFactory)
	          ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
	    });
	
	    /**
	     * @ngdoc service
	     * @kind function
	     * @name $http
	     * @requires ng.$httpBackend
	     * @requires $cacheFactory
	     * @requires $rootScope
	     * @requires $q
	     * @requires $injector
	     *
	     * @description
	     * The `$http` service is a core Angular service that facilitates communication with the remote
	     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
	     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
	     *
	     * For unit testing applications that use `$http` service, see
	     * {@link ngMock.$httpBackend $httpBackend mock}.
	     *
	     * For a higher level of abstraction, please check out the {@link ngResource.$resource
	     * $resource} service.
	     *
	     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
	     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
	     * it is important to familiarize yourself with these APIs and the guarantees they provide.
	     *
	     *
	     * ## General usage
	     * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
	     * that is used to generate an HTTP request and returns  a {@link ng.$q promise}.
	     *
	     * ```js
	     *   // Simple GET request example:
	     *   $http({
	     *     method: 'GET',
	     *     url: '/someUrl'
	     *   }).then(function successCallback(response) {
	     *       // this callback will be called asynchronously
	     *       // when the response is available
	     *     }, function errorCallback(response) {
	     *       // called asynchronously if an error occurs
	     *       // or server returns response with an error status.
	     *     });
	     * ```
	     *
	     * The response object has these properties:
	     *
	     *   - **data** – `{string|Object}` – The response body transformed with the transform
	     *     functions.
	     *   - **status** – `{number}` – HTTP status code of the response.
	     *   - **headers** – `{function([headerName])}` – Header getter function.
	     *   - **config** – `{Object}` – The configuration object that was used to generate the request.
	     *   - **statusText** – `{string}` – HTTP status text of the response.
	     *
	     * A response status code between 200 and 299 is considered a success status and will result in
	     * the success callback being called. Any response status code outside of that range is
	     * considered an error status and will result in the error callback being called.
	     * Also, status codes less than -1 are normalized to zero. -1 usually means the request was
	     * aborted, e.g. using a `config.timeout`.
	     * Note that if the response is a redirect, XMLHttpRequest will transparently follow it, meaning
	     * that the outcome (success or error) will be determined by the final response status code.
	     *
	     *
	     * ## Shortcut methods
	     *
	     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
	     * request data must be passed in for POST/PUT requests. An optional config can be passed as the
	     * last argument.
	     *
	     * ```js
	     *   $http.get('/someUrl', config).then(successCallback, errorCallback);
	     *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
	     * ```
	     *
	     * Complete list of shortcut methods:
	     *
	     * - {@link ng.$http#get $http.get}
	     * - {@link ng.$http#head $http.head}
	     * - {@link ng.$http#post $http.post}
	     * - {@link ng.$http#put $http.put}
	     * - {@link ng.$http#delete $http.delete}
	     * - {@link ng.$http#jsonp $http.jsonp}
	     * - {@link ng.$http#patch $http.patch}
	     *
	     *
	     * ## Writing Unit Tests that use $http
	     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
	     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
	     * request using trained responses.
	     *
	     * ```
	     * $httpBackend.expectGET(...);
	     * $http.get(...);
	     * $httpBackend.flush();
	     * ```
	     *
	     * ## Setting HTTP Headers
	     *
	     * The $http service will automatically add certain HTTP headers to all requests. These defaults
	     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
	     * object, which currently contains this default configuration:
	     *
	     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
	     *   - <code>Accept: application/json, text/plain, \*&#65279;/&#65279;\*</code>
	     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
	     *   - `Content-Type: application/json`
	     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
	     *   - `Content-Type: application/json`
	     *
	     * To add or overwrite these defaults, simply add or remove a property from these configuration
	     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
	     * with the lowercased HTTP method name as the key, e.g.
	     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
	     *
	     * The defaults can also be set at runtime via the `$http.defaults` object in the same
	     * fashion. For example:
	     *
	     * ```
	     * module.run(function($http) {
	     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
	     * });
	     * ```
	     *
	     * In addition, you can supply a `headers` property in the config object passed when
	     * calling `$http(config)`, which overrides the defaults without changing them globally.
	     *
	     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
	     * Use the `headers` property, setting the desired header to `undefined`. For example:
	     *
	     * ```js
	     * var req = {
	     *  method: 'POST',
	     *  url: 'http://example.com',
	     *  headers: {
	     *    'Content-Type': undefined
	     *  },
	     *  data: { test: 'test' }
	     * }
	     *
	     * $http(req).then(function(){...}, function(){...});
	     * ```
	     *
	     * ## Transforming Requests and Responses
	     *
	     * Both requests and responses can be transformed using transformation functions: `transformRequest`
	     * and `transformResponse`. These properties can be a single function that returns
	     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
	     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
	     *
	     * <div class="alert alert-warning">
	     * **Note:** Angular does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
	     * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
	     * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
	     * function will be reflected on the scope and in any templates where the object is data-bound.
	     * To prevent this, transform functions should have no side-effects.
	     * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
	     * </div>
	     *
	     * ### Default Transformations
	     *
	     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
	     * `defaults.transformResponse` properties. If a request does not provide its own transformations
	     * then these will be applied.
	     *
	     * You can augment or replace the default transformations by modifying these properties by adding to or
	     * replacing the array.
	     *
	     * Angular provides the following default transformations:
	     *
	     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`):
	     *
	     * - If the `data` property of the request configuration object contains an object, serialize it
	     *   into JSON format.
	     *
	     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`):
	     *
	     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
	     *  - If JSON response is detected, deserialize it using a JSON parser.
	     *
	     *
	     * ### Overriding the Default Transformations Per Request
	     *
	     * If you wish to override the request/response transformations only for a single request then provide
	     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
	     * into `$http`.
	     *
	     * Note that if you provide these properties on the config object the default transformations will be
	     * overwritten. If you wish to augment the default transformations then you must include them in your
	     * local transformation array.
	     *
	     * The following code demonstrates adding a new response transformation to be run after the default response
	     * transformations have been run.
	     *
	     * ```js
	     * function appendTransform(defaults, transform) {
	     *
	     *   // We can't guarantee that the default transformation is an array
	     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
	     *
	     *   // Append the new transformation to the defaults
	     *   return defaults.concat(transform);
	     * }
	     *
	     * $http({
	     *   url: '...',
	     *   method: 'GET',
	     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
	     *     return doTransform(value);
	     *   })
	     * });
	     * ```
	     *
	     *
	     * ## Caching
	     *
	     * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
	     * set the config.cache value or the default cache value to TRUE or to a cache object (created
	     * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
	     * precedence over the default cache value.
	     *
	     * In order to:
	     *   * cache all responses - set the default cache value to TRUE or to a cache object
	     *   * cache a specific response - set config.cache value to TRUE or to a cache object
	     *
	     * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
	     * then the default `$cacheFactory("$http")` object is used.
	     *
	     * The default cache value can be set by updating the
	     * {@link ng.$http#defaults `$http.defaults.cache`} property or the
	     * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
	     *
	     * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
	     * the relevant cache object. The next time the same request is made, the response is returned
	     * from the cache without sending a request to the server.
	     *
	     * Take note that:
	     *
	     *   * Only GET and JSONP requests are cached.
	     *   * The cache key is the request URL including search parameters; headers are not considered.
	     *   * Cached responses are returned asynchronously, in the same way as responses from the server.
	     *   * If multiple identical requests are made using the same cache, which is not yet populated,
	     *     one request will be made to the server and remaining requests will return the same response.
	     *   * A cache-control header on the response does not affect if or how responses are cached.
	     *
	     *
	     * ## Interceptors
	     *
	     * Before you start creating interceptors, be sure to understand the
	     * {@link ng.$q $q and deferred/promise APIs}.
	     *
	     * For purposes of global error handling, authentication, or any kind of synchronous or
	     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
	     * able to intercept requests before they are handed to the server and
	     * responses before they are handed over to the application code that
	     * initiated these requests. The interceptors leverage the {@link ng.$q
	     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
	     *
	     * The interceptors are service factories that are registered with the `$httpProvider` by
	     * adding them to the `$httpProvider.interceptors` array. The factory is called and
	     * injected with dependencies (if specified) and returns the interceptor.
	     *
	     * There are two kinds of interceptors (and two kinds of rejection interceptors):
	     *
	     *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
	     *     modify the `config` object or create a new one. The function needs to return the `config`
	     *     object directly, or a promise containing the `config` or a new `config` object.
	     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *   * `response`: interceptors get called with http `response` object. The function is free to
	     *     modify the `response` object or create a new one. The function needs to return the `response`
	     *     object directly, or as a promise containing the `response` or a new `response` object.
	     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *
	     *
	     * ```js
	     *   // register the interceptor as a service
	     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
	     *     return {
	     *       // optional method
	     *       'request': function(config) {
	     *         // do something on success
	     *         return config;
	     *       },
	     *
	     *       // optional method
	     *      'requestError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       },
	     *
	     *
	     *
	     *       // optional method
	     *       'response': function(response) {
	     *         // do something on success
	     *         return response;
	     *       },
	     *
	     *       // optional method
	     *      'responseError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       }
	     *     };
	     *   });
	     *
	     *   $httpProvider.interceptors.push('myHttpInterceptor');
	     *
	     *
	     *   // alternatively, register the interceptor via an anonymous factory
	     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
	     *     return {
	     *      'request': function(config) {
	     *          // same as above
	     *       },
	     *
	     *       'response': function(response) {
	     *          // same as above
	     *       }
	     *     };
	     *   });
	     * ```
	     *
	     * ## Security Considerations
	     *
	     * When designing web applications, consider security threats from:
	     *
	     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
	     *
	     * Both server and the client must cooperate in order to eliminate these threats. Angular comes
	     * pre-configured with strategies that address these issues, but for this to work backend server
	     * cooperation is required.
	     *
	     * ### JSON Vulnerability Protection
	     *
	     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * allows third party website to turn your JSON resource URL into
	     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
	     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
	     * Angular will automatically strip the prefix before processing it as JSON.
	     *
	     * For example if your server needs to return:
	     * ```js
	     * ['one','two']
	     * ```
	     *
	     * which is vulnerable to attack, your server can return:
	     * ```js
	     * )]}',
	     * ['one','two']
	     * ```
	     *
	     * Angular will strip the prefix, before processing the JSON.
	     *
	     *
	     * ### Cross Site Request Forgery (XSRF) Protection
	     *
	     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
	     * which the attacker can trick an authenticated user into unknowingly executing actions on your
	     * website. Angular provides a mechanism to counter XSRF. When performing XHR requests, the
	     * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
	     * header (`X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read the
	     * cookie, your server can be assured that the XHR came from JavaScript running on your domain.
	     * The header will not be set for cross-domain requests.
	     *
	     * To take advantage of this, your server needs to set a token in a JavaScript readable session
	     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
	     * server can verify that the cookie matches `X-XSRF-TOKEN` HTTP header, and therefore be sure
	     * that only JavaScript running on your domain could have sent the request. The token must be
	     * unique for each user and must be verifiable by the server (to prevent the JavaScript from
	     * making up its own tokens). We recommend that the token is a digest of your site's
	     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
	     * for added security.
	     *
	     * The name of the headers can be specified using the xsrfHeaderName and xsrfCookieName
	     * properties of either $httpProvider.defaults at config-time, $http.defaults at run-time,
	     * or the per-request config object.
	     *
	     * In order to prevent collisions in environments where multiple Angular apps share the
	     * same domain or subdomain, we recommend that each application uses unique cookie name.
	     *
	     * @param {object} config Object describing the request to be made and how it should be
	     *    processed. The object has following properties:
	     *
	     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
	     *    - **url** – `{string|TrustedObject}` – Absolute or relative URL of the resource that is being requested;
	     *      or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
	     *      with the `paramSerializer` and appended as GET parameters.
	     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
	     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
	     *      HTTP headers to send to the server. If the return value of a function is null, the
	     *      header will not be sent. Functions accept a config object as an argument.
	     *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
	     *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
	     *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
	     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
	     *    - **transformRequest** –
	     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      request body and headers and returns its transformed (typically serialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **transformResponse** –
	     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      response body, headers and status and returns its transformed (typically deserialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
	     *      prepare the string representation of request parameters (specified as an object).
	     *      If specified as string, it is interpreted as function registered with the
	     *      {@link $injector $injector}, which means you can create your own serializer
	     *      by registering it as a {@link auto.$provide#service service}.
	     *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
	     *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
	     *    - **cache** – `{boolean|Object}` – A boolean value or object created with
	     *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
	     *      See {@link $http#caching $http Caching} for more information.
	     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
	     *      that should abort the request when resolved.
	     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
	     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
	     *      for more information.
	     *    - **responseType** - `{string}` - see
	     *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
	     *
	     * @returns {HttpPromise} Returns a {@link ng.$q `Promise}` that will be resolved to a response object
	     *                        when the request succeeds or fails.
	     *
	     *
	     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
	     *   requests. This is primarily meant to be used for debugging purposes.
	     *
	     *
	     * @example
	<example module="httpExample" name="http-service">
	<file name="index.html">
	  <div ng-controller="FetchController">
	    <select ng-model="method" aria-label="Request method">
	      <option>GET</option>
	      <option>JSONP</option>
	    </select>
	    <input type="text" ng-model="url" size="80" aria-label="URL" />
	    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
	    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
	    <button id="samplejsonpbtn"
	      ng-click="updateModel('JSONP',
	                    'https://angularjs.org/greet.php?name=Super%20Hero')">
	      Sample JSONP
	    </button>
	    <button id="invalidjsonpbtn"
	      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist')">
	        Invalid JSONP
	      </button>
	    <pre>http status code: {{status}}</pre>
	    <pre>http response data: {{data}}</pre>
	  </div>
	</file>
	<file name="script.js">
	  angular.module('httpExample', [])
	    .config(['$sceDelegateProvider', function($sceDelegateProvider) {
	      // We must whitelist the JSONP endpoint that we are using to show that we trust it
	      $sceDelegateProvider.resourceUrlWhitelist([
	        'self',
	        'https://angularjs.org/**'
	      ]);
	    }])
	    .controller('FetchController', ['$scope', '$http', '$templateCache',
	      function($scope, $http, $templateCache) {
	        $scope.method = 'GET';
	        $scope.url = 'http-hello.html';
	
	        $scope.fetch = function() {
	          $scope.code = null;
	          $scope.response = null;
	
	          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
	            then(function(response) {
	              $scope.status = response.status;
	              $scope.data = response.data;
	            }, function(response) {
	              $scope.data = response.data || 'Request failed';
	              $scope.status = response.status;
	          });
	        };
	
	        $scope.updateModel = function(method, url) {
	          $scope.method = method;
	          $scope.url = url;
	        };
	      }]);
	</file>
	<file name="http-hello.html">
	  Hello, $http!
	</file>
	<file name="protractor.js" type="protractor">
	  var status = element(by.binding('status'));
	  var data = element(by.binding('data'));
	  var fetchBtn = element(by.id('fetchbtn'));
	  var sampleGetBtn = element(by.id('samplegetbtn'));
	  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));
	
	  it('should make an xhr GET request', function() {
	    sampleGetBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('200');
	    expect(data.getText()).toMatch(/Hello, \$http!/);
	  });
	
	// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
	// it('should make a JSONP request to angularjs.org', function() {
	//   var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
	//   sampleJsonpBtn.click();
	//   fetchBtn.click();
	//   expect(status.getText()).toMatch('200');
	//   expect(data.getText()).toMatch(/Super Hero!/);
	// });
	
	  it('should make JSONP request to invalid URL and invoke the error handler',
	      function() {
	    invalidJsonpBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('0');
	    expect(data.getText()).toMatch('Request failed');
	  });
	</file>
	</example>
	     */
	    function $http(requestConfig) {
	
	      if (!isObject(requestConfig)) {
	        throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
	      }
	
	      if (!isString($sce.valueOf(requestConfig.url))) {
	        throw minErr('$http')('badreq', 'Http request configuration url must be a string or a $sce trusted object.  Received: {0}', requestConfig.url);
	      }
	
	      var config = extend({
	        method: 'get',
	        transformRequest: defaults.transformRequest,
	        transformResponse: defaults.transformResponse,
	        paramSerializer: defaults.paramSerializer,
	        jsonpCallbackParam: defaults.jsonpCallbackParam
	      }, requestConfig);
	
	      config.headers = mergeHeaders(requestConfig);
	      config.method = uppercase(config.method);
	      config.paramSerializer = isString(config.paramSerializer) ?
	          $injector.get(config.paramSerializer) : config.paramSerializer;
	
	      $browser.$$incOutstandingRequestCount();
	
	      var requestInterceptors = [];
	      var responseInterceptors = [];
	      var promise = $q.resolve(config);
	
	      // apply interceptors
	      forEach(reversedInterceptors, function(interceptor) {
	        if (interceptor.request || interceptor.requestError) {
	          requestInterceptors.unshift(interceptor.request, interceptor.requestError);
	        }
	        if (interceptor.response || interceptor.responseError) {
	          responseInterceptors.push(interceptor.response, interceptor.responseError);
	        }
	      });
	
	      promise = chainInterceptors(promise, requestInterceptors);
	      promise = promise.then(serverRequest);
	      promise = chainInterceptors(promise, responseInterceptors);
	      promise = promise.finally(completeOutstandingRequest);
	
	      return promise;
	
	
	      function chainInterceptors(promise, interceptors) {
	        for (var i = 0, ii = interceptors.length; i < ii;) {
	          var thenFn = interceptors[i++];
	          var rejectFn = interceptors[i++];
	
	          promise = promise.then(thenFn, rejectFn);
	        }
	
	        interceptors.length = 0;
	
	        return promise;
	      }
	
	      function completeOutstandingRequest() {
	        $browser.$$completeOutstandingRequest(noop);
	      }
	
	      function executeHeaderFns(headers, config) {
	        var headerContent, processedHeaders = {};
	
	        forEach(headers, function(headerFn, header) {
	          if (isFunction(headerFn)) {
	            headerContent = headerFn(config);
	            if (headerContent != null) {
	              processedHeaders[header] = headerContent;
	            }
	          } else {
	            processedHeaders[header] = headerFn;
	          }
	        });
	
	        return processedHeaders;
	      }
	
	      function mergeHeaders(config) {
	        var defHeaders = defaults.headers,
	            reqHeaders = extend({}, config.headers),
	            defHeaderName, lowercaseDefHeaderName, reqHeaderName;
	
	        defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);
	
	        // using for-in instead of forEach to avoid unnecessary iteration after header has been found
	        defaultHeadersIteration:
	        for (defHeaderName in defHeaders) {
	          lowercaseDefHeaderName = lowercase(defHeaderName);
	
	          for (reqHeaderName in reqHeaders) {
	            if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
	              continue defaultHeadersIteration;
	            }
	          }
	
	          reqHeaders[defHeaderName] = defHeaders[defHeaderName];
	        }
	
	        // execute if header value is a function for merged headers
	        return executeHeaderFns(reqHeaders, shallowCopy(config));
	      }
	
	      function serverRequest(config) {
	        var headers = config.headers;
	        var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);
	
	        // strip content-type if data is undefined
	        if (isUndefined(reqData)) {
	          forEach(headers, function(value, header) {
	            if (lowercase(header) === 'content-type') {
	              delete headers[header];
	            }
	          });
	        }
	
	        if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
	          config.withCredentials = defaults.withCredentials;
	        }
	
	        // send request
	        return sendReq(config, reqData).then(transformResponse, transformResponse);
	      }
	
	      function transformResponse(response) {
	        // make a copy since the response must be cacheable
	        var resp = extend({}, response);
	        resp.data = transformData(response.data, response.headers, response.status,
	                                  config.transformResponse);
	        return (isSuccess(response.status))
	          ? resp
	          : $q.reject(resp);
	      }
	    }
	
	    $http.pendingRequests = [];
	
	    /**
	     * @ngdoc method
	     * @name $http#get
	     *
	     * @description
	     * Shortcut method to perform `GET` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#delete
	     *
	     * @description
	     * Shortcut method to perform `DELETE` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#head
	     *
	     * @description
	     * Shortcut method to perform `HEAD` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#jsonp
	     *
	     * @description
	     * Shortcut method to perform `JSONP` request.
	     *
	     * Note that, since JSONP requests are sensitive because the response is given full access to the browser,
	     * the url must be declared, via {@link $sce} as a trusted resource URL.
	     * You can trust a URL by adding it to the whitelist via
	     * {@link $sceDelegateProvider#resourceUrlWhitelist  `$sceDelegateProvider.resourceUrlWhitelist`} or
	     * by explicitly trusting the URL via {@link $sce#trustAsResourceUrl `$sce.trustAsResourceUrl(url)`}.
	     *
	     * JSONP requests must specify a callback to be used in the response from the server. This callback
	     * is passed as a query parameter in the request. You must specify the name of this parameter by
	     * setting the `jsonpCallbackParam` property on the request config object.
	     *
	     * ```
	     * $http.jsonp('some/trusted/url', {jsonpCallbackParam: 'callback'})
	     * ```
	     *
	     * You can also specify a default callback parameter name in `$http.defaults.jsonpCallbackParam`.
	     * Initially this is set to `'callback'`.
	     *
	     * <div class="alert alert-danger">
	     * You can no longer use the `JSON_CALLBACK` string as a placeholder for specifying where the callback
	     * parameter value should go.
	     * </div>
	     *
	     * If you would like to customise where and how the callbacks are stored then try overriding
	     * or decorating the {@link $jsonpCallbacks} service.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	    createShortMethods('get', 'delete', 'head', 'jsonp');
	
	    /**
	     * @ngdoc method
	     * @name $http#post
	     *
	     * @description
	     * Shortcut method to perform `POST` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#put
	     *
	     * @description
	     * Shortcut method to perform `PUT` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	     /**
	      * @ngdoc method
	      * @name $http#patch
	      *
	      * @description
	      * Shortcut method to perform `PATCH` request.
	      *
	      * @param {string} url Relative or absolute URL specifying the destination of the request
	      * @param {*} data Request content
	      * @param {Object=} config Optional configuration object
	      * @returns {HttpPromise} Future object
	      */
	    createShortMethodsWithData('post', 'put', 'patch');
	
	        /**
	         * @ngdoc property
	         * @name $http#defaults
	         *
	         * @description
	         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
	         * default headers, withCredentials as well as request and response transformations.
	         *
	         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
	         */
	    $http.defaults = defaults;
	
	
	    return $http;
	
	
	    function createShortMethods(names) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url
	          }));
	        };
	      });
	    }
	
	
	    function createShortMethodsWithData(name) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, data, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url,
	            data: data
	          }));
	        };
	      });
	    }
	
	
	    /**
	     * Makes the request.
	     *
	     * !!! ACCESSES CLOSURE VARS:
	     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
	     */
	    function sendReq(config, reqData) {
	      var deferred = $q.defer(),
	          promise = deferred.promise,
	          cache,
	          cachedResp,
	          reqHeaders = config.headers,
	          isJsonp = lowercase(config.method) === 'jsonp',
	          url = config.url;
	
	      if (isJsonp) {
	        // JSONP is a pretty sensitive operation where we're allowing a script to have full access to
	        // our DOM and JS space.  So we require that the URL satisfies SCE.RESOURCE_URL.
	        url = $sce.getTrustedResourceUrl(url);
	      } else if (!isString(url)) {
	        // If it is not a string then the URL must be a $sce trusted object
	        url = $sce.valueOf(url);
	      }
	
	      url = buildUrl(url, config.paramSerializer(config.params));
	
	      if (isJsonp) {
	        // Check the url and add the JSONP callback placeholder
	        url = sanitizeJsonpCallbackParam(url, config.jsonpCallbackParam);
	      }
	
	      $http.pendingRequests.push(config);
	      promise.then(removePendingReq, removePendingReq);
	
	      if ((config.cache || defaults.cache) && config.cache !== false &&
	          (config.method === 'GET' || config.method === 'JSONP')) {
	        cache = isObject(config.cache) ? config.cache
	            : isObject(/** @type {?} */ (defaults).cache)
	              ? /** @type {?} */ (defaults).cache
	              : defaultCache;
	      }
	
	      if (cache) {
	        cachedResp = cache.get(url);
	        if (isDefined(cachedResp)) {
	          if (isPromiseLike(cachedResp)) {
	            // cached request has already been sent, but there is no response yet
	            cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
	          } else {
	            // serving from cache
	            if (isArray(cachedResp)) {
	              resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3]);
	            } else {
	              resolvePromise(cachedResp, 200, {}, 'OK');
	            }
	          }
	        } else {
	          // put the promise for the non-transformed response into cache as a placeholder
	          cache.put(url, promise);
	        }
	      }
	
	
	      // if we won't have the response in cache, set the xsrf headers and
	      // send the request to the backend
	      if (isUndefined(cachedResp)) {
	        var xsrfValue = urlIsSameOrigin(config.url)
	            ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName]
	            : undefined;
	        if (xsrfValue) {
	          reqHeaders[(config.xsrfHeaderName || defaults.xsrfHeaderName)] = xsrfValue;
	        }
	
	        $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout,
	            config.withCredentials, config.responseType,
	            createApplyHandlers(config.eventHandlers),
	            createApplyHandlers(config.uploadEventHandlers));
	      }
	
	      return promise;
	
	      function createApplyHandlers(eventHandlers) {
	        if (eventHandlers) {
	          var applyHandlers = {};
	          forEach(eventHandlers, function(eventHandler, key) {
	            applyHandlers[key] = function(event) {
	              if (useApplyAsync) {
	                $rootScope.$applyAsync(callEventHandler);
	              } else if ($rootScope.$$phase) {
	                callEventHandler();
	              } else {
	                $rootScope.$apply(callEventHandler);
	              }
	
	              function callEventHandler() {
	                eventHandler(event);
	              }
	            };
	          });
	          return applyHandlers;
	        }
	      }
	
	
	      /**
	       * Callback registered to $httpBackend():
	       *  - caches the response if desired
	       *  - resolves the raw $http promise
	       *  - calls $apply
	       */
	      function done(status, response, headersString, statusText) {
	        if (cache) {
	          if (isSuccess(status)) {
	            cache.put(url, [status, response, parseHeaders(headersString), statusText]);
	          } else {
	            // remove promise from the cache
	            cache.remove(url);
	          }
	        }
	
	        function resolveHttpPromise() {
	          resolvePromise(response, status, headersString, statusText);
	        }
	
	        if (useApplyAsync) {
	          $rootScope.$applyAsync(resolveHttpPromise);
	        } else {
	          resolveHttpPromise();
	          if (!$rootScope.$$phase) $rootScope.$apply();
	        }
	      }
	
	
	      /**
	       * Resolves the raw $http promise.
	       */
	      function resolvePromise(response, status, headers, statusText) {
	        //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
	        status = status >= -1 ? status : 0;
	
	        (isSuccess(status) ? deferred.resolve : deferred.reject)({
	          data: response,
	          status: status,
	          headers: headersGetter(headers),
	          config: config,
	          statusText: statusText
	        });
	      }
	
	      function resolvePromiseWithResult(result) {
	        resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText);
	      }
	
	      function removePendingReq() {
	        var idx = $http.pendingRequests.indexOf(config);
	        if (idx !== -1) $http.pendingRequests.splice(idx, 1);
	      }
	    }
	
	
	    function buildUrl(url, serializedParams) {
	      if (serializedParams.length > 0) {
	        url += ((url.indexOf('?') === -1) ? '?' : '&') + serializedParams;
	      }
	      return url;
	    }
	
	    function sanitizeJsonpCallbackParam(url, key) {
	      if (/[&?][^=]+=JSON_CALLBACK/.test(url)) {
	        // Throw if the url already contains a reference to JSON_CALLBACK
	        throw $httpMinErr('badjsonp', 'Illegal use of JSON_CALLBACK in url, "{0}"', url);
	      }
	
	      var callbackParamRegex = new RegExp('[&?]' + key + '=');
	      if (callbackParamRegex.test(url)) {
	        // Throw if the callback param was already provided
	        throw $httpMinErr('badjsonp', 'Illegal use of callback param, "{0}", in url, "{1}"', key, url);
	      }
	
	      // Add in the JSON_CALLBACK callback param value
	      url += ((url.indexOf('?') === -1) ? '?' : '&') + key + '=JSON_CALLBACK';
	
	      return url;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $xhrFactory
	 * @this
	 *
	 * @description
	 * Factory function used to create XMLHttpRequest objects.
	 *
	 * Replace or decorate this service to create your own custom XMLHttpRequest objects.
	 *
	 * ```
	 * angular.module('myApp', [])
	 * .factory('$xhrFactory', function() {
	 *   return function createXhr(method, url) {
	 *     return new window.XMLHttpRequest({mozSystem: true});
	 *   };
	 * });
	 * ```
	 *
	 * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
	 * @param {string} url URL of the request.
	 */
	function $xhrFactoryProvider() {
	  this.$get = function() {
	    return function createXhr() {
	      return new window.XMLHttpRequest();
	    };
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $httpBackend
	 * @requires $jsonpCallbacks
	 * @requires $document
	 * @requires $xhrFactory
	 * @this
	 *
	 * @description
	 * HTTP backend used by the {@link ng.$http service} that delegates to
	 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
	 *
	 * You should never need to use this service directly, instead use the higher-level abstractions:
	 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
	 *
	 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
	 * $httpBackend} which can be trained with responses.
	 */
	function $HttpBackendProvider() {
	  this.$get = ['$browser', '$jsonpCallbacks', '$document', '$xhrFactory', function($browser, $jsonpCallbacks, $document, $xhrFactory) {
	    return createHttpBackend($browser, $xhrFactory, $browser.defer, $jsonpCallbacks, $document[0]);
	  }];
	}
	
	function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
	  // TODO(vojta): fix the signature
	  return function(method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
	    url = url || $browser.url();
	
	    if (lowercase(method) === 'jsonp') {
	      var callbackPath = callbacks.createCallback(url);
	      var jsonpDone = jsonpReq(url, callbackPath, function(status, text) {
	        // jsonpReq only ever sets status to 200 (OK), 404 (ERROR) or -1 (WAITING)
	        var response = (status === 200) && callbacks.getResponse(callbackPath);
	        completeRequest(callback, status, response, '', text);
	        callbacks.removeCallback(callbackPath);
	      });
	    } else {
	
	      var xhr = createXhr(method, url);
	
	      xhr.open(method, url, true);
	      forEach(headers, function(value, key) {
	        if (isDefined(value)) {
	            xhr.setRequestHeader(key, value);
	        }
	      });
	
	      xhr.onload = function requestLoaded() {
	        var statusText = xhr.statusText || '';
	
	        // responseText is the old-school way of retrieving response (supported by IE9)
	        // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
	        var response = ('response' in xhr) ? xhr.response : xhr.responseText;
	
	        // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
	        var status = xhr.status === 1223 ? 204 : xhr.status;
	
	        // fix status code when it is 0 (0 status is undocumented).
	        // Occurs when accessing file resources or on Android 4.1 stock browser
	        // while retrieving files from application cache.
	        if (status === 0) {
	          status = response ? 200 : urlResolve(url).protocol === 'file' ? 404 : 0;
	        }
	
	        completeRequest(callback,
	            status,
	            response,
	            xhr.getAllResponseHeaders(),
	            statusText);
	      };
	
	      var requestError = function() {
	        // The response is always empty
	        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	        completeRequest(callback, -1, null, null, '');
	      };
	
	      xhr.onerror = requestError;
	      xhr.onabort = requestError;
	      xhr.ontimeout = requestError;
	
	      forEach(eventHandlers, function(value, key) {
	          xhr.addEventListener(key, value);
	      });
	
	      forEach(uploadEventHandlers, function(value, key) {
	        xhr.upload.addEventListener(key, value);
	      });
	
	      if (withCredentials) {
	        xhr.withCredentials = true;
	      }
	
	      if (responseType) {
	        try {
	          xhr.responseType = responseType;
	        } catch (e) {
	          // WebKit added support for the json responseType value on 09/03/2013
	          // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
	          // known to throw when setting the value "json" as the response type. Other older
	          // browsers implementing the responseType
	          //
	          // The json response type can be ignored if not supported, because JSON payloads are
	          // parsed on the client-side regardless.
	          if (responseType !== 'json') {
	            throw e;
	          }
	        }
	      }
	
	      xhr.send(isUndefined(post) ? null : post);
	    }
	
	    if (timeout > 0) {
	      var timeoutId = $browserDefer(timeoutRequest, timeout);
	    } else if (isPromiseLike(timeout)) {
	      timeout.then(timeoutRequest);
	    }
	
	
	    function timeoutRequest() {
	      if (jsonpDone) {
	        jsonpDone();
	      }
	      if (xhr) {
	        xhr.abort();
	      }
	    }
	
	    function completeRequest(callback, status, response, headersString, statusText) {
	      // cancel timeout and subsequent timeout promise resolution
	      if (isDefined(timeoutId)) {
	        $browserDefer.cancel(timeoutId);
	      }
	      jsonpDone = xhr = null;
	
	      callback(status, response, headersString, statusText);
	    }
	  };
	
	  function jsonpReq(url, callbackPath, done) {
	    url = url.replace('JSON_CALLBACK', callbackPath);
	    // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
	    // - fetches local scripts via XHR and evals them
	    // - adds and immediately removes script elements from the document
	    var script = rawDocument.createElement('script'), callback = null;
	    script.type = 'text/javascript';
	    script.src = url;
	    script.async = true;
	
	    callback = function(event) {
	      script.removeEventListener('load', callback);
	      script.removeEventListener('error', callback);
	      rawDocument.body.removeChild(script);
	      script = null;
	      var status = -1;
	      var text = 'unknown';
	
	      if (event) {
	        if (event.type === 'load' && !callbacks.wasCalled(callbackPath)) {
	          event = { type: 'error' };
	        }
	        text = event.type;
	        status = event.type === 'error' ? 404 : 200;
	      }
	
	      if (done) {
	        done(status, text);
	      }
	    };
	
	    script.addEventListener('load', callback);
	    script.addEventListener('error', callback);
	    rawDocument.body.appendChild(script);
	    return callback;
	  }
	}
	
	var $interpolateMinErr = angular.$interpolateMinErr = minErr('$interpolate');
	$interpolateMinErr.throwNoconcat = function(text) {
	  throw $interpolateMinErr('noconcat',
	      'Error while interpolating: {0}\nStrict Contextual Escaping disallows ' +
	      'interpolations that concatenate multiple expressions when a trusted value is ' +
	      'required.  See http://docs.angularjs.org/api/ng.$sce', text);
	};
	
	$interpolateMinErr.interr = function(text, err) {
	  return $interpolateMinErr('interr', 'Can\'t interpolate: {0}\n{1}', text, err.toString());
	};
	
	/**
	 * @ngdoc provider
	 * @name $interpolateProvider
	 * @this
	 *
	 * @description
	 *
	 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
	 *
	 * <div class="alert alert-danger">
	 * This feature is sometimes used to mix different markup languages, e.g. to wrap an Angular
	 * template within a Python Jinja template (or any other template language). Mixing templating
	 * languages is **very dangerous**. The embedding template language will not safely escape Angular
	 * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
	 * security bugs!
	 * </div>
	 *
	 * @example
	<example name="custom-interpolation-markup" module="customInterpolationApp">
	<file name="index.html">
	<script>
	  var customInterpolationApp = angular.module('customInterpolationApp', []);
	
	  customInterpolationApp.config(function($interpolateProvider) {
	    $interpolateProvider.startSymbol('//');
	    $interpolateProvider.endSymbol('//');
	  });
	
	
	  customInterpolationApp.controller('DemoController', function() {
	      this.label = "This binding is brought you by // interpolation symbols.";
	  });
	</script>
	<div ng-controller="DemoController as demo">
	    //demo.label//
	</div>
	</file>
	<file name="protractor.js" type="protractor">
	  it('should interpolate binding with custom symbols', function() {
	    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
	  });
	</file>
	</example>
	 */
	function $InterpolateProvider() {
	  var startSymbol = '{{';
	  var endSymbol = '}}';
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#startSymbol
	   * @description
	   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
	   *
	   * @param {string=} value new value to set the starting symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.startSymbol = function(value) {
	    if (value) {
	      startSymbol = value;
	      return this;
	    } else {
	      return startSymbol;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#endSymbol
	   * @description
	   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	   *
	   * @param {string=} value new value to set the ending symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.endSymbol = function(value) {
	    if (value) {
	      endSymbol = value;
	      return this;
	    } else {
	      return endSymbol;
	    }
	  };
	
	
	  this.$get = ['$parse', '$exceptionHandler', '$sce', function($parse, $exceptionHandler, $sce) {
	    var startSymbolLength = startSymbol.length,
	        endSymbolLength = endSymbol.length,
	        escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
	        escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');
	
	    function escape(ch) {
	      return '\\\\\\' + ch;
	    }
	
	    function unescapeText(text) {
	      return text.replace(escapedStartRegexp, startSymbol).
	        replace(escapedEndRegexp, endSymbol);
	    }
	
	    // TODO: this is the same as the constantWatchDelegate in parse.js
	    function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
	      var unwatch = scope.$watch(function constantInterpolateWatch(scope) {
	        unwatch();
	        return constantInterp(scope);
	      }, listener, objectEquality);
	      return unwatch;
	    }
	
	    /**
	     * @ngdoc service
	     * @name $interpolate
	     * @kind function
	     *
	     * @requires $parse
	     * @requires $sce
	     *
	     * @description
	     *
	     * Compiles a string with markup into an interpolation function. This service is used by the
	     * HTML {@link ng.$compile $compile} service for data binding. See
	     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
	     * interpolation markup.
	     *
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var exp = $interpolate('Hello {{name | uppercase}}!');
	     *   expect(exp({name:'Angular'})).toEqual('Hello ANGULAR!');
	     * ```
	     *
	     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
	     * `true`, the interpolation function will return `undefined` unless all embedded expressions
	     * evaluate to a value other than `undefined`.
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var context = {greeting: 'Hello', name: undefined };
	     *
	     *   // default "forgiving" mode
	     *   var exp = $interpolate('{{greeting}} {{name}}!');
	     *   expect(exp(context)).toEqual('Hello !');
	     *
	     *   // "allOrNothing" mode
	     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
	     *   expect(exp(context)).toBeUndefined();
	     *   context.name = 'Angular';
	     *   expect(exp(context)).toEqual('Hello Angular!');
	     * ```
	     *
	     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
	     *
	     * #### Escaped Interpolation
	     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
	     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
	     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
	     * or binding.
	     *
	     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
	     * degree, while also enabling code examples to work without relying on the
	     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
	     *
	     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
	     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
	     * interpolation start/end markers with their escaped counterparts.**
	     *
	     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
	     * output when the $interpolate service processes the text. So, for HTML elements interpolated
	     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
	     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
	     * this is typically useful only when user-data is used in rendering a template from the server, or
	     * when otherwise untrusted data is used by a directive.
	     *
	     * <example name="interpolation">
	     *  <file name="index.html">
	     *    <div ng-init="username='A user'">
	     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
	     *        </p>
	     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
	     *        application, but fails to accomplish their task, because the server has correctly
	     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
	     *        characters.</p>
	     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
	     *        from the database by an administrator.</p>
	     *    </div>
	     *  </file>
	     * </example>
	     *
	     * @knownIssue
	     * It is currently not possible for an interpolated expression to contain the interpolation end
	     * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
	     * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
	     *
	     * @knownIssue
	     * All directives and components must use the standard `{{` `}}` interpolation symbols
	     * in their templates. If you change the application interpolation symbols the {@link $compile}
	     * service will attempt to denormalize the standard symbols to the custom symbols.
	     * The denormalization process is not clever enough to know not to replace instances of the standard
	     * symbols where they would not normally be treated as interpolation symbols. For example in the following
	     * code snippet the closing braces of the literal object will get incorrectly denormalized:
	     *
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"}}">
	     * ```
	     *
	     * The workaround is to ensure that such instances are separated by whitespace:
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"} }">
	     * ```
	     *
	     * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
	     *
	     * @param {string} text The text with markup to interpolate.
	     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
	     *    embedded expression in order to return an interpolation function. Strings with no
	     *    embedded expression will return null for the interpolation function.
	     * @param {string=} trustedContext when provided, the returned function passes the interpolated
	     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
	     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
	     *    provides Strict Contextual Escaping for details.
	     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
	     *    unless all embedded expressions evaluate to a value other than `undefined`.
	     * @returns {function(context)} an interpolation function which is used to compute the
	     *    interpolated string. The function has these parameters:
	     *
	     * - `context`: evaluation context for all expressions embedded in the interpolated text
	     */
	    function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
	      // Provide a quick exit and simplified result function for text with no interpolation
	      if (!text.length || text.indexOf(startSymbol) === -1) {
	        var constantInterp;
	        if (!mustHaveExpression) {
	          var unescapedText = unescapeText(text);
	          constantInterp = valueFn(unescapedText);
	          constantInterp.exp = text;
	          constantInterp.expressions = [];
	          constantInterp.$$watchDelegate = constantWatchDelegate;
	        }
	        return constantInterp;
	      }
	
	      allOrNothing = !!allOrNothing;
	      var startIndex,
	          endIndex,
	          index = 0,
	          expressions = [],
	          parseFns = [],
	          textLength = text.length,
	          exp,
	          concat = [],
	          expressionPositions = [];
	
	      while (index < textLength) {
	        if (((startIndex = text.indexOf(startSymbol, index)) !== -1) &&
	             ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) !== -1)) {
	          if (index !== startIndex) {
	            concat.push(unescapeText(text.substring(index, startIndex)));
	          }
	          exp = text.substring(startIndex + startSymbolLength, endIndex);
	          expressions.push(exp);
	          parseFns.push($parse(exp, parseStringifyInterceptor));
	          index = endIndex + endSymbolLength;
	          expressionPositions.push(concat.length);
	          concat.push('');
	        } else {
	          // we did not find an interpolation, so we have to add the remainder to the separators array
	          if (index !== textLength) {
	            concat.push(unescapeText(text.substring(index)));
	          }
	          break;
	        }
	      }
	
	      // Concatenating expressions makes it hard to reason about whether some combination of
	      // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
	      // single expression be used for iframe[src], object[src], etc., we ensure that the value
	      // that's used is assigned or constructed by some JS code somewhere that is more testable or
	      // make it obvious that you bound the value to some user controlled value.  This helps reduce
	      // the load when auditing for XSS issues.
	      if (trustedContext && concat.length > 1) {
	          $interpolateMinErr.throwNoconcat(text);
	      }
	
	      if (!mustHaveExpression || expressions.length) {
	        var compute = function(values) {
	          for (var i = 0, ii = expressions.length; i < ii; i++) {
	            if (allOrNothing && isUndefined(values[i])) return;
	            concat[expressionPositions[i]] = values[i];
	          }
	          return concat.join('');
	        };
	
	        var getValue = function(value) {
	          return trustedContext ?
	            $sce.getTrusted(trustedContext, value) :
	            $sce.valueOf(value);
	        };
	
	        return extend(function interpolationFn(context) {
	            var i = 0;
	            var ii = expressions.length;
	            var values = new Array(ii);
	
	            try {
	              for (; i < ii; i++) {
	                values[i] = parseFns[i](context);
	              }
	
	              return compute(values);
	            } catch (err) {
	              $exceptionHandler($interpolateMinErr.interr(text, err));
	            }
	
	          }, {
	          // all of these properties are undocumented for now
	          exp: text, //just for compatibility with regular watchers created via $watch
	          expressions: expressions,
	          $$watchDelegate: function(scope, listener) {
	            var lastValue;
	            return scope.$watchGroup(parseFns, /** @this */ function interpolateFnWatcher(values, oldValues) {
	              var currValue = compute(values);
	              if (isFunction(listener)) {
	                listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
	              }
	              lastValue = currValue;
	            });
	          }
	        });
	      }
	
	      function parseStringifyInterceptor(value) {
	        try {
	          value = getValue(value);
	          return allOrNothing && !isDefined(value) ? value : stringify(value);
	        } catch (err) {
	          $exceptionHandler($interpolateMinErr.interr(text, err));
	        }
	      }
	    }
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#startSymbol
	     * @description
	     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
	     *
	     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} start symbol.
	     */
	    $interpolate.startSymbol = function() {
	      return startSymbol;
	    };
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#endSymbol
	     * @description
	     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	     *
	     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} end symbol.
	     */
	    $interpolate.endSymbol = function() {
	      return endSymbol;
	    };
	
	    return $interpolate;
	  }];
	}
	
	/** @this */
	function $IntervalProvider() {
	  this.$get = ['$rootScope', '$window', '$q', '$$q', '$browser',
	       function($rootScope,   $window,   $q,   $$q,   $browser) {
	    var intervals = {};
	
	
	     /**
	      * @ngdoc service
	      * @name $interval
	      *
	      * @description
	      * Angular's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
	      * milliseconds.
	      *
	      * The return value of registering an interval function is a promise. This promise will be
	      * notified upon each tick of the interval, and will be resolved after `count` iterations, or
	      * run indefinitely if `count` is not defined. The value of the notification will be the
	      * number of iterations that have run.
	      * To cancel an interval, call `$interval.cancel(promise)`.
	      *
	      * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
	      * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
	      * time.
	      *
	      * <div class="alert alert-warning">
	      * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
	      * with them.  In particular they are not automatically destroyed when a controller's scope or a
	      * directive's element are destroyed.
	      * You should take this into consideration and make sure to always cancel the interval at the
	      * appropriate moment.  See the example below for more details on how and when to do this.
	      * </div>
	      *
	      * @param {function()} fn A function that should be called repeatedly. If no additional arguments
	      *   are passed (see below), the function is called with the current iteration count.
	      * @param {number} delay Number of milliseconds between each function call.
	      * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
	      *   indefinitely.
	      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	      * @param {...*=} Pass additional parameters to the executed function.
	      * @returns {promise} A promise which will be notified on each iteration. It will resolve once all iterations of the interval complete.
	      *
	      * @example
	      * <example module="intervalExample" name="interval-service">
	      * <file name="index.html">
	      *   <script>
	      *     angular.module('intervalExample', [])
	      *       .controller('ExampleController', ['$scope', '$interval',
	      *         function($scope, $interval) {
	      *           $scope.format = 'M/d/yy h:mm:ss a';
	      *           $scope.blood_1 = 100;
	      *           $scope.blood_2 = 120;
	      *
	      *           var stop;
	      *           $scope.fight = function() {
	      *             // Don't start a new fight if we are already fighting
	      *             if ( angular.isDefined(stop) ) return;
	      *
	      *             stop = $interval(function() {
	      *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
	      *                 $scope.blood_1 = $scope.blood_1 - 3;
	      *                 $scope.blood_2 = $scope.blood_2 - 4;
	      *               } else {
	      *                 $scope.stopFight();
	      *               }
	      *             }, 100);
	      *           };
	      *
	      *           $scope.stopFight = function() {
	      *             if (angular.isDefined(stop)) {
	      *               $interval.cancel(stop);
	      *               stop = undefined;
	      *             }
	      *           };
	      *
	      *           $scope.resetFight = function() {
	      *             $scope.blood_1 = 100;
	      *             $scope.blood_2 = 120;
	      *           };
	      *
	      *           $scope.$on('$destroy', function() {
	      *             // Make sure that the interval is destroyed too
	      *             $scope.stopFight();
	      *           });
	      *         }])
	      *       // Register the 'myCurrentTime' directive factory method.
	      *       // We inject $interval and dateFilter service since the factory method is DI.
	      *       .directive('myCurrentTime', ['$interval', 'dateFilter',
	      *         function($interval, dateFilter) {
	      *           // return the directive link function. (compile function not needed)
	      *           return function(scope, element, attrs) {
	      *             var format,  // date format
	      *                 stopTime; // so that we can cancel the time updates
	      *
	      *             // used to update the UI
	      *             function updateTime() {
	      *               element.text(dateFilter(new Date(), format));
	      *             }
	      *
	      *             // watch the expression, and update the UI on change.
	      *             scope.$watch(attrs.myCurrentTime, function(value) {
	      *               format = value;
	      *               updateTime();
	      *             });
	      *
	      *             stopTime = $interval(updateTime, 1000);
	      *
	      *             // listen on DOM destroy (removal) event, and cancel the next UI update
	      *             // to prevent updating time after the DOM element was removed.
	      *             element.on('$destroy', function() {
	      *               $interval.cancel(stopTime);
	      *             });
	      *           }
	      *         }]);
	      *   </script>
	      *
	      *   <div>
	      *     <div ng-controller="ExampleController">
	      *       <label>Date format: <input ng-model="format"></label> <hr/>
	      *       Current time is: <span my-current-time="format"></span>
	      *       <hr/>
	      *       Blood 1 : <font color='red'>{{blood_1}}</font>
	      *       Blood 2 : <font color='red'>{{blood_2}}</font>
	      *       <button type="button" data-ng-click="fight()">Fight</button>
	      *       <button type="button" data-ng-click="stopFight()">StopFight</button>
	      *       <button type="button" data-ng-click="resetFight()">resetFight</button>
	      *     </div>
	      *   </div>
	      *
	      * </file>
	      * </example>
	      */
	    function interval(fn, delay, count, invokeApply) {
	      var hasParams = arguments.length > 4,
	          args = hasParams ? sliceArgs(arguments, 4) : [],
	          setInterval = $window.setInterval,
	          clearInterval = $window.clearInterval,
	          iteration = 0,
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise;
	
	      count = isDefined(count) ? count : 0;
	
	      promise.$$intervalId = setInterval(function tick() {
	        if (skipApply) {
	          $browser.defer(callback);
	        } else {
	          $rootScope.$evalAsync(callback);
	        }
	        deferred.notify(iteration++);
	
	        if (count > 0 && iteration >= count) {
	          deferred.resolve(iteration);
	          clearInterval(promise.$$intervalId);
	          delete intervals[promise.$$intervalId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	
	      }, delay);
	
	      intervals[promise.$$intervalId] = deferred;
	
	      return promise;
	
	      function callback() {
	        if (!hasParams) {
	          fn(iteration);
	        } else {
	          fn.apply(null, args);
	        }
	      }
	    }
	
	
	     /**
	      * @ngdoc method
	      * @name $interval#cancel
	      *
	      * @description
	      * Cancels a task associated with the `promise`.
	      *
	      * @param {Promise=} promise returned by the `$interval` function.
	      * @returns {boolean} Returns `true` if the task was successfully canceled.
	      */
	    interval.cancel = function(promise) {
	      if (promise && promise.$$intervalId in intervals) {
	        // Interval cancels should not report as unhandled promise.
	        intervals[promise.$$intervalId].promise.catch(noop);
	        intervals[promise.$$intervalId].reject('canceled');
	        $window.clearInterval(promise.$$intervalId);
	        delete intervals[promise.$$intervalId];
	        return true;
	      }
	      return false;
	    };
	
	    return interval;
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $jsonpCallbacks
	 * @requires $window
	 * @description
	 * This service handles the lifecycle of callbacks to handle JSONP requests.
	 * Override this service if you wish to customise where the callbacks are stored and
	 * how they vary compared to the requested url.
	 */
	var $jsonpCallbacksProvider = /** @this */ function() {
	  this.$get = function() {
	    var callbacks = angular.callbacks;
	    var callbackMap = {};
	
	    function createCallback(callbackId) {
	      var callback = function(data) {
	        callback.data = data;
	        callback.called = true;
	      };
	      callback.id = callbackId;
	      return callback;
	    }
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#createCallback
	       * @param {string} url the url of the JSONP request
	       * @returns {string} the callback path to send to the server as part of the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to create a callback and get hold of the path to the callback
	       * to pass to the server, which will be used to call the callback with its payload in the JSONP response.
	       */
	      createCallback: function(url) {
	        var callbackId = '_' + (callbacks.$$counter++).toString(36);
	        var callbackPath = 'angular.callbacks.' + callbackId;
	        var callback = createCallback(callbackId);
	        callbackMap[callbackPath] = callbacks[callbackId] = callback;
	        return callbackPath;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#wasCalled
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {boolean} whether the callback has been called, as a result of the JSONP response
	       * @description
	       * {@link $httpBackend} calls this method to find out whether the JSONP response actually called the
	       * callback that was passed in the request.
	       */
	      wasCalled: function(callbackPath) {
	        return callbackMap[callbackPath].called;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#getResponse
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {*} the data received from the response via the registered callback
	       * @description
	       * {@link $httpBackend} calls this method to get hold of the data that was provided to the callback
	       * in the JSONP response.
	       */
	      getResponse: function(callbackPath) {
	        return callbackMap[callbackPath].data;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#removeCallback
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to remove the callback after the JSONP request has
	       * completed or timed-out.
	       */
	      removeCallback: function(callbackPath) {
	        var callback = callbackMap[callbackPath];
	        delete callbacks[callback.id];
	        delete callbackMap[callbackPath];
	      }
	    };
	  };
	};
	
	/**
	 * @ngdoc service
	 * @name $locale
	 *
	 * @description
	 * $locale service provides localization rules for various Angular components. As of right now the
	 * only public api is:
	 *
	 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
	 */
	
	var PATH_MATCH = /^([^?#]*)(\?([^#]*))?(#(.*))?$/,
	    DEFAULT_PORTS = {'http': 80, 'https': 443, 'ftp': 21};
	var $locationMinErr = minErr('$location');
	
	
	/**
	 * Encode path using encodeUriSegment, ignoring forward slashes
	 *
	 * @param {string} path Path to encode
	 * @returns {string}
	 */
	function encodePath(path) {
	  var segments = path.split('/'),
	      i = segments.length;
	
	  while (i--) {
	    segments[i] = encodeUriSegment(segments[i]);
	  }
	
	  return segments.join('/');
	}
	
	function parseAbsoluteUrl(absoluteUrl, locationObj) {
	  var parsedUrl = urlResolve(absoluteUrl);
	
	  locationObj.$$protocol = parsedUrl.protocol;
	  locationObj.$$host = parsedUrl.hostname;
	  locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
	}
	
	var DOUBLE_SLASH_REGEX = /^\s*[\\/]{2,}/;
	function parseAppUrl(url, locationObj) {
	
	  if (DOUBLE_SLASH_REGEX.test(url)) {
	    throw $locationMinErr('badpath', 'Invalid url "{0}".', url);
	  }
	
	  var prefixed = (url.charAt(0) !== '/');
	  if (prefixed) {
	    url = '/' + url;
	  }
	  var match = urlResolve(url);
	  locationObj.$$path = decodeURIComponent(prefixed && match.pathname.charAt(0) === '/' ?
	      match.pathname.substring(1) : match.pathname);
	  locationObj.$$search = parseKeyValue(match.search);
	  locationObj.$$hash = decodeURIComponent(match.hash);
	
	  // make sure path starts with '/';
	  if (locationObj.$$path && locationObj.$$path.charAt(0) !== '/') {
	    locationObj.$$path = '/' + locationObj.$$path;
	  }
	}
	
	function startsWith(str, search) {
	  return str.slice(0, search.length) === search;
	}
	
	/**
	 *
	 * @param {string} base
	 * @param {string} url
	 * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
	 *                   the expected string.
	 */
	function stripBaseUrl(base, url) {
	  if (startsWith(url, base)) {
	    return url.substr(base.length);
	  }
	}
	
	
	function stripHash(url) {
	  var index = url.indexOf('#');
	  return index === -1 ? url : url.substr(0, index);
	}
	
	function trimEmptyHash(url) {
	  return url.replace(/(#.+)|#$/, '$1');
	}
	
	
	function stripFile(url) {
	  return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
	}
	
	/* return the server only (scheme://host:port) */
	function serverBase(url) {
	  return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
	}
	
	
	/**
	 * LocationHtml5Url represents a URL
	 * This object is exposed as $location service when HTML5 mode is enabled and supported
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} basePrefix URL path prefix
	 */
	function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
	  this.$$html5 = true;
	  basePrefix = basePrefix || '';
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given HTML5 (regular) URL string into properties
	   * @param {string} url HTML5 URL
	   * @private
	   */
	  this.$$parse = function(url) {
	    var pathUrl = stripBaseUrl(appBaseNoFile, url);
	    if (!isString(pathUrl)) {
	      throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url,
	          appBaseNoFile);
	    }
	
	    parseAppUrl(pathUrl, this);
	
	    if (!this.$$path) {
	      this.$$path = '/';
	    }
	
	    this.$$compose();
	  };
	
	  /**
	   * Compose url and update `absUrl` property
	   * @private
	   */
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    this.$$absUrl = appBaseNoFile + this.$$url.substr(1); // first char is always '/'
	
	    this.$$urlUpdatedByLocation = true;
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	    var appUrl, prevAppUrl;
	    var rewrittenUrl;
	
	
	    if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
	      prevAppUrl = appUrl;
	      if (basePrefix && isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) {
	        rewrittenUrl = appBaseNoFile + (stripBaseUrl('/', appUrl) || appUrl);
	      } else {
	        rewrittenUrl = appBase + prevAppUrl;
	      }
	    } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBaseNoFile + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents URL
	 * This object is exposed as $location service when developer doesn't opt into html5 mode.
	 * It also serves as the base class for html5 mode fallback on legacy browsers.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {
	
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given hashbang URL into properties
	   * @param {string} url Hashbang URL
	   * @private
	   */
	  this.$$parse = function(url) {
	    var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
	    var withoutHashUrl;
	
	    if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === '#') {
	
	      // The rest of the URL starts with a hash so we have
	      // got either a hashbang path or a plain hash fragment
	      withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
	      if (isUndefined(withoutHashUrl)) {
	        // There was no hashbang prefix so we just have a hash fragment
	        withoutHashUrl = withoutBaseUrl;
	      }
	
	    } else {
	      // There was no hashbang path nor hash fragment:
	      // If we are in HTML5 mode we use what is left as the path;
	      // Otherwise we ignore what is left
	      if (this.$$html5) {
	        withoutHashUrl = withoutBaseUrl;
	      } else {
	        withoutHashUrl = '';
	        if (isUndefined(withoutBaseUrl)) {
	          appBase = url;
	          /** @type {?} */ (this).replace();
	        }
	      }
	    }
	
	    parseAppUrl(withoutHashUrl, this);
	
	    this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);
	
	    this.$$compose();
	
	    /*
	     * In Windows, on an anchor node on documents loaded from
	     * the filesystem, the browser will return a pathname
	     * prefixed with the drive name ('/C:/path') when a
	     * pathname without a drive is set:
	     *  * a.setAttribute('href', '/foo')
	     *   * a.pathname === '/C:/foo' //true
	     *
	     * Inside of Angular, we're always using pathnames that
	     * do not include drive names for routing.
	     */
	    function removeWindowsDriveName(path, url, base) {
	      /*
	      Matches paths for file protocol on windows,
	      such as /C:/foo/bar, and captures only /foo/bar.
	      */
	      var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;
	
	      var firstPathSegmentMatch;
	
	      //Get the relative path from the input URL.
	      if (startsWith(url, base)) {
	        url = url.replace(base, '');
	      }
	
	      // The input URL intentionally contains a first path segment that ends with a colon.
	      if (windowsFilePathExp.exec(url)) {
	        return path;
	      }
	
	      firstPathSegmentMatch = windowsFilePathExp.exec(path);
	      return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
	    }
	  };
	
	  /**
	   * Compose hashbang URL and update `absUrl` property
	   * @private
	   */
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    this.$$absUrl = appBase + (this.$$url ? hashPrefix + this.$$url : '');
	
	    this.$$urlUpdatedByLocation = true;
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (stripHash(appBase) === stripHash(url)) {
	      this.$$parse(url);
	      return true;
	    }
	    return false;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents URL
	 * This object is exposed as $location service when html5 history api is enabled but the browser
	 * does not support it.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
	  this.$$html5 = true;
	  LocationHashbangUrl.apply(this, arguments);
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	
	    var rewrittenUrl;
	    var appUrl;
	
	    if (appBase === stripHash(url)) {
	      rewrittenUrl = url;
	    } else if ((appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBase + hashPrefix + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
	    this.$$absUrl = appBase + hashPrefix + this.$$url;
	
	    this.$$urlUpdatedByLocation = true;
	  };
	
	}
	
	
	var locationPrototype = {
	
	  /**
	   * Ensure absolute URL is initialized.
	   * @private
	   */
	  $$absUrl:'',
	
	  /**
	   * Are we in html5 mode?
	   * @private
	   */
	  $$html5: false,
	
	  /**
	   * Has any change been replacing?
	   * @private
	   */
	  $$replace: false,
	
	  /**
	   * @ngdoc method
	   * @name $location#absUrl
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return full URL representation with all segments encoded according to rules specified in
	   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var absUrl = $location.absUrl();
	   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @return {string} full URL
	   */
	  absUrl: locationGetter('$$absUrl'),
	
	  /**
	   * @ngdoc method
	   * @name $location#url
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return URL (e.g. `/path?a=b#hash`) when called without any parameter.
	   *
	   * Change path, search and hash, when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var url = $location.url();
	   * // => "/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @param {string=} url New URL without base prefix (e.g. `/path?a=b#hash`)
	   * @return {string} url
	   */
	  url: function(url) {
	    if (isUndefined(url)) {
	      return this.$$url;
	    }
	
	    var match = PATH_MATCH.exec(url);
	    if (match[1] || url === '') this.path(decodeURIComponent(match[1]));
	    if (match[2] || match[1] || url === '') this.search(match[3] || '');
	    this.hash(match[5] || '');
	
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#protocol
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return protocol of current URL.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var protocol = $location.protocol();
	   * // => "http"
	   * ```
	   *
	   * @return {string} protocol of current URL
	   */
	  protocol: locationGetter('$$protocol'),
	
	  /**
	   * @ngdoc method
	   * @name $location#host
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return host of current URL.
	   *
	   * Note: compared to the non-angular version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var host = $location.host();
	   * // => "example.com"
	   *
	   * // given URL http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
	   * host = $location.host();
	   * // => "example.com"
	   * host = location.host;
	   * // => "example.com:8080"
	   * ```
	   *
	   * @return {string} host of current URL.
	   */
	  host: locationGetter('$$host'),
	
	  /**
	   * @ngdoc method
	   * @name $location#port
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return port of current URL.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var port = $location.port();
	   * // => 80
	   * ```
	   *
	   * @return {Number} port
	   */
	  port: locationGetter('$$port'),
	
	  /**
	   * @ngdoc method
	   * @name $location#path
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return path of current URL when called without any parameter.
	   *
	   * Change path when called with parameter and return `$location`.
	   *
	   * Note: Path should always begin with forward slash (/), this method will add the forward slash
	   * if it is missing.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var path = $location.path();
	   * // => "/some/path"
	   * ```
	   *
	   * @param {(string|number)=} path New path
	   * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
	   */
	  path: locationGetterSetter('$$path', function(path) {
	    path = path !== null ? path.toString() : '';
	    return path.charAt(0) === '/' ? path : '/' + path;
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#search
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return search part (as object) of current URL when called without any parameter.
	   *
	   * Change search part when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var searchObject = $location.search();
	   * // => {foo: 'bar', baz: 'xoxo'}
	   *
	   * // set foo to 'yipee'
	   * $location.search('foo', 'yipee');
	   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
	   * ```
	   *
	   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
	   * hash object.
	   *
	   * When called with a single argument the method acts as a setter, setting the `search` component
	   * of `$location` to the specified value.
	   *
	   * If the argument is a hash object containing an array of values, these values will be encoded
	   * as duplicate search parameters in the URL.
	   *
	   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
	   * will override only a single search property.
	   *
	   * If `paramValue` is an array, it will override the property of the `search` component of
	   * `$location` specified via the first argument.
	   *
	   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
	   *
	   * If `paramValue` is `true`, the property specified via the first argument will be added with no
	   * value nor trailing equal sign.
	   *
	   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
	   * one or more arguments returns `$location` object itself.
	   */
	  search: function(search, paramValue) {
	    switch (arguments.length) {
	      case 0:
	        return this.$$search;
	      case 1:
	        if (isString(search) || isNumber(search)) {
	          search = search.toString();
	          this.$$search = parseKeyValue(search);
	        } else if (isObject(search)) {
	          search = copy(search, {});
	          // remove object undefined or null properties
	          forEach(search, function(value, key) {
	            if (value == null) delete search[key];
	          });
	
	          this.$$search = search;
	        } else {
	          throw $locationMinErr('isrcharg',
	              'The first argument of the `$location#search()` call must be a string or an object.');
	        }
	        break;
	      default:
	        if (isUndefined(paramValue) || paramValue === null) {
	          delete this.$$search[search];
	        } else {
	          this.$$search[search] = paramValue;
	        }
	    }
	
	    this.$$compose();
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#hash
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Returns the hash fragment when called without any parameters.
	   *
	   * Changes the hash fragment when called with a parameter and returns `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
	   * var hash = $location.hash();
	   * // => "hashValue"
	   * ```
	   *
	   * @param {(string|number)=} hash New hash fragment
	   * @return {string} hash
	   */
	  hash: locationGetterSetter('$$hash', function(hash) {
	    return hash !== null ? hash.toString() : '';
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#replace
	   *
	   * @description
	   * If called, all changes to $location during the current `$digest` will replace the current history
	   * record, instead of adding a new one.
	   */
	  replace: function() {
	    this.$$replace = true;
	    return this;
	  }
	};
	
	forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function(Location) {
	  Location.prototype = Object.create(locationPrototype);
	
	  /**
	   * @ngdoc method
	   * @name $location#state
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return the history state object when called without any parameter.
	   *
	   * Change the history state object when called with one parameter and return `$location`.
	   * The state object is later passed to `pushState` or `replaceState`.
	   *
	   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
	   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
	   * older browsers (like IE9 or Android < 4.0), don't use this method.
	   *
	   * @param {object=} state State object for pushState or replaceState
	   * @return {object} state
	   */
	  Location.prototype.state = function(state) {
	    if (!arguments.length) {
	      return this.$$state;
	    }
	
	    if (Location !== LocationHtml5Url || !this.$$html5) {
	      throw $locationMinErr('nostate', 'History API state support is available only ' +
	        'in HTML5 mode and only in browsers supporting HTML5 History API');
	    }
	    // The user might modify `stateObject` after invoking `$location.state(stateObject)`
	    // but we're changing the $$state reference to $browser.state() during the $digest
	    // so the modification window is narrow.
	    this.$$state = isUndefined(state) ? null : state;
	    this.$$urlUpdatedByLocation = true;
	
	    return this;
	  };
	});
	
	
	function locationGetter(property) {
	  return /** @this */ function() {
	    return this[property];
	  };
	}
	
	
	function locationGetterSetter(property, preprocess) {
	  return /** @this */ function(value) {
	    if (isUndefined(value)) {
	      return this[property];
	    }
	
	    this[property] = preprocess(value);
	    this.$$compose();
	
	    return this;
	  };
	}
	
	
	/**
	 * @ngdoc service
	 * @name $location
	 *
	 * @requires $rootElement
	 *
	 * @description
	 * The $location service parses the URL in the browser address bar (based on the
	 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
	 * available to your application. Changes to the URL in the address bar are reflected into
	 * $location service and changes to $location are reflected into the browser address bar.
	 *
	 * **The $location service:**
	 *
	 * - Exposes the current URL in the browser address bar, so you can
	 *   - Watch and observe the URL.
	 *   - Change the URL.
	 * - Synchronizes the URL with the browser when the user
	 *   - Changes the address bar.
	 *   - Clicks the back or forward button (or clicks a History link).
	 *   - Clicks on a link.
	 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
	 *
	 * For more information see {@link guide/$location Developer Guide: Using $location}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $locationProvider
	 * @this
	 *
	 * @description
	 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
	 */
	function $LocationProvider() {
	  var hashPrefix = '!',
	      html5Mode = {
	        enabled: false,
	        requireBase: true,
	        rewriteLinks: true
	      };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#hashPrefix
	   * @description
	   * The default value for the prefix is `'!'`.
	   * @param {string=} prefix Prefix for hash part (containing path and search)
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.hashPrefix = function(prefix) {
	    if (isDefined(prefix)) {
	      hashPrefix = prefix;
	      return this;
	    } else {
	      return hashPrefix;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#html5Mode
	   * @description
	   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
	   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
	   *   properties:
	   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
	   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
	   *     support `pushState`.
	   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
	   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
	   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
	   *     See the {@link guide/$location $location guide for more information}
	   *   - **rewriteLinks** - `{boolean|string}` - (default: `true`) When html5Mode is enabled,
	   *     enables/disables URL rewriting for relative links. If set to a string, URL rewriting will
	   *     only happen on links with an attribute that matches the given string. For example, if set
	   *     to `'internal-link'`, then the URL will only be rewritten for `<a internal-link>` links.
	   *     Note that [attribute name normalization](guide/directive#normalization) does not apply
	   *     here, so `'internalLink'` will **not** match `'internal-link'`.
	   *
	   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
	   */
	  this.html5Mode = function(mode) {
	    if (isBoolean(mode)) {
	      html5Mode.enabled = mode;
	      return this;
	    } else if (isObject(mode)) {
	
	      if (isBoolean(mode.enabled)) {
	        html5Mode.enabled = mode.enabled;
	      }
	
	      if (isBoolean(mode.requireBase)) {
	        html5Mode.requireBase = mode.requireBase;
	      }
	
	      if (isBoolean(mode.rewriteLinks) || isString(mode.rewriteLinks)) {
	        html5Mode.rewriteLinks = mode.rewriteLinks;
	      }
	
	      return this;
	    } else {
	      return html5Mode;
	    }
	  };
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeStart
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted before a URL will change.
	   *
	   * This change can be prevented by calling
	   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
	   * details about event object. Upon successful change
	   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeSuccess
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted after a URL was changed.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window',
	      function($rootScope, $browser, $sniffer, $rootElement, $window) {
	    var $location,
	        LocationMode,
	        baseHref = $browser.baseHref(), // if base[href] is undefined, it defaults to ''
	        initialUrl = $browser.url(),
	        appBase;
	
	    if (html5Mode.enabled) {
	      if (!baseHref && html5Mode.requireBase) {
	        throw $locationMinErr('nobase',
	          '$location in HTML5 mode requires a <base> tag to be present!');
	      }
	      appBase = serverBase(initialUrl) + (baseHref || '/');
	      LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
	    } else {
	      appBase = stripHash(initialUrl);
	      LocationMode = LocationHashbangUrl;
	    }
	    var appBaseNoFile = stripFile(appBase);
	
	    $location = new LocationMode(appBase, appBaseNoFile, '#' + hashPrefix);
	    $location.$$parseLinkUrl(initialUrl, initialUrl);
	
	    $location.$$state = $browser.state();
	
	    var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;
	
	    function setBrowserUrlWithFallback(url, replace, state) {
	      var oldUrl = $location.url();
	      var oldState = $location.$$state;
	      try {
	        $browser.url(url, replace, state);
	
	        // Make sure $location.state() returns referentially identical (not just deeply equal)
	        // state object; this makes possible quick checking if the state changed in the digest
	        // loop. Checking deep equality would be too expensive.
	        $location.$$state = $browser.state();
	      } catch (e) {
	        // Restore old values if pushState fails
	        $location.url(oldUrl);
	        $location.$$state = oldState;
	
	        throw e;
	      }
	    }
	
	    $rootElement.on('click', function(event) {
	      var rewriteLinks = html5Mode.rewriteLinks;
	      // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
	      // currently we open nice url link and redirect then
	
	      if (!rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which === 2 || event.button === 2) return;
	
	      var elm = jqLite(event.target);
	
	      // traverse the DOM up to find first A tag
	      while (nodeName_(elm[0]) !== 'a') {
	        // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
	        if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
	      }
	
	      if (isString(rewriteLinks) && isUndefined(elm.attr(rewriteLinks))) return;
	
	      var absHref = elm.prop('href');
	      // get the actual href attribute - see
	      // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
	      var relHref = elm.attr('href') || elm.attr('xlink:href');
	
	      if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
	        // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
	        // an animation.
	        absHref = urlResolve(absHref.animVal).href;
	      }
	
	      // Ignore when url is started with javascript: or mailto:
	      if (IGNORE_URI_REGEXP.test(absHref)) return;
	
	      if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
	        if ($location.$$parseLinkUrl(absHref, relHref)) {
	          // We do a preventDefault for all urls that are part of the angular application,
	          // in html5mode and also without, so that we are able to abort navigation without
	          // getting double entries in the location history.
	          event.preventDefault();
	          // update location manually
	          if ($location.absUrl() !== $browser.url()) {
	            $rootScope.$apply();
	            // hack to work around FF6 bug 684208 when scenario runner clicks on links
	            $window.angular['ff-684208-preventDefault'] = true;
	          }
	        }
	      }
	    });
	
	
	    // rewrite hashbang url <> html5 url
	    if (trimEmptyHash($location.absUrl()) !== trimEmptyHash(initialUrl)) {
	      $browser.url($location.absUrl(), true);
	    }
	
	    var initializing = true;
	
	    // update $location when $browser url changes
	    $browser.onUrlChange(function(newUrl, newState) {
	
	      if (!startsWith(newUrl, appBaseNoFile)) {
	        // If we are navigating outside of the app then force a reload
	        $window.location.href = newUrl;
	        return;
	      }
	
	      $rootScope.$evalAsync(function() {
	        var oldUrl = $location.absUrl();
	        var oldState = $location.$$state;
	        var defaultPrevented;
	        newUrl = trimEmptyHash(newUrl);
	        $location.$$parse(newUrl);
	        $location.$$state = newState;
	
	        defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	            newState, oldState).defaultPrevented;
	
	        // if the location was changed by a `$locationChangeStart` handler then stop
	        // processing this location change
	        if ($location.absUrl() !== newUrl) return;
	
	        if (defaultPrevented) {
	          $location.$$parse(oldUrl);
	          $location.$$state = oldState;
	          setBrowserUrlWithFallback(oldUrl, false, oldState);
	        } else {
	          initializing = false;
	          afterLocationChange(oldUrl, oldState);
	        }
	      });
	      if (!$rootScope.$$phase) $rootScope.$digest();
	    });
	
	    // update browser
	    $rootScope.$watch(function $locationWatch() {
	      if (initializing || $location.$$urlUpdatedByLocation) {
	        $location.$$urlUpdatedByLocation = false;
	
	        var oldUrl = trimEmptyHash($browser.url());
	        var newUrl = trimEmptyHash($location.absUrl());
	        var oldState = $browser.state();
	        var currentReplace = $location.$$replace;
	        var urlOrStateChanged = oldUrl !== newUrl ||
	          ($location.$$html5 && $sniffer.history && oldState !== $location.$$state);
	
	        if (initializing || urlOrStateChanged) {
	          initializing = false;
	
	          $rootScope.$evalAsync(function() {
	            var newUrl = $location.absUrl();
	            var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	                $location.$$state, oldState).defaultPrevented;
	
	            // if the location was changed by a `$locationChangeStart` handler then stop
	            // processing this location change
	            if ($location.absUrl() !== newUrl) return;
	
	            if (defaultPrevented) {
	              $location.$$parse(oldUrl);
	              $location.$$state = oldState;
	            } else {
	              if (urlOrStateChanged) {
	                setBrowserUrlWithFallback(newUrl, currentReplace,
	                                          oldState === $location.$$state ? null : $location.$$state);
	              }
	              afterLocationChange(oldUrl, oldState);
	            }
	          });
	        }
	      }
	
	      $location.$$replace = false;
	
	      // we don't need to return anything because $evalAsync will make the digest loop dirty when
	      // there is a change
	    });
	
	    return $location;
	
	    function afterLocationChange(oldUrl, oldState) {
	      $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl,
	        $location.$$state, oldState);
	    }
	}];
	}
	
	/**
	 * @ngdoc service
	 * @name $log
	 * @requires $window
	 *
	 * @description
	 * Simple service for logging. Default implementation safely writes the message
	 * into the browser's console (if present).
	 *
	 * The main purpose of this service is to simplify debugging and troubleshooting.
	 *
	 * The default is to log `debug` messages. You can use
	 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
	 *
	 * @example
	   <example module="logExample" name="log-service">
	     <file name="script.js">
	       angular.module('logExample', [])
	         .controller('LogController', ['$scope', '$log', function($scope, $log) {
	           $scope.$log = $log;
	           $scope.message = 'Hello World!';
	         }]);
	     </file>
	     <file name="index.html">
	       <div ng-controller="LogController">
	         <p>Reload this page with open console, enter text and hit the log button...</p>
	         <label>Message:
	         <input type="text" ng-model="message" /></label>
	         <button ng-click="$log.log(message)">log</button>
	         <button ng-click="$log.warn(message)">warn</button>
	         <button ng-click="$log.info(message)">info</button>
	         <button ng-click="$log.error(message)">error</button>
	         <button ng-click="$log.debug(message)">debug</button>
	       </div>
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc provider
	 * @name $logProvider
	 * @this
	 *
	 * @description
	 * Use the `$logProvider` to configure how the application logs messages
	 */
	function $LogProvider() {
	  var debug = true,
	      self = this;
	
	  /**
	   * @ngdoc method
	   * @name $logProvider#debugEnabled
	   * @description
	   * @param {boolean=} flag enable or disable debug level messages
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.debugEnabled = function(flag) {
	    if (isDefined(flag)) {
	      debug = flag;
	      return this;
	    } else {
	      return debug;
	    }
	  };
	
	  this.$get = ['$window', function($window) {
	    // Support: IE 9-11, Edge 12-14+
	    // IE/Edge display errors in such a way that it requires the user to click in 4 places
	    // to see the stack trace. There is no way to feature-detect it so there's a chance
	    // of the user agent sniffing to go wrong but since it's only about logging, this shouldn't
	    // break apps. Other browsers display errors in a sensible way and some of them map stack
	    // traces along source maps if available so it makes sense to let browsers display it
	    // as they want.
	    var formatStackTrace = msie || /\bEdge\//.test($window.navigator && $window.navigator.userAgent);
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $log#log
	       *
	       * @description
	       * Write a log message
	       */
	      log: consoleLog('log'),
	
	      /**
	       * @ngdoc method
	       * @name $log#info
	       *
	       * @description
	       * Write an information message
	       */
	      info: consoleLog('info'),
	
	      /**
	       * @ngdoc method
	       * @name $log#warn
	       *
	       * @description
	       * Write a warning message
	       */
	      warn: consoleLog('warn'),
	
	      /**
	       * @ngdoc method
	       * @name $log#error
	       *
	       * @description
	       * Write an error message
	       */
	      error: consoleLog('error'),
	
	      /**
	       * @ngdoc method
	       * @name $log#debug
	       *
	       * @description
	       * Write a debug message
	       */
	      debug: (function() {
	        var fn = consoleLog('debug');
	
	        return function() {
	          if (debug) {
	            fn.apply(self, arguments);
	          }
	        };
	      })()
	    };
	
	    function formatError(arg) {
	      if (arg instanceof Error) {
	        if (arg.stack && formatStackTrace) {
	          arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
	              ? 'Error: ' + arg.message + '\n' + arg.stack
	              : arg.stack;
	        } else if (arg.sourceURL) {
	          arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
	        }
	      }
	      return arg;
	    }
	
	    function consoleLog(type) {
	      var console = $window.console || {},
	          logFn = console[type] || console.log || noop,
	          hasApply = false;
	
	      // Note: reading logFn.apply throws an error in IE11 in IE8 document mode.
	      // The reason behind this is that console.log has type "object" in IE8...
	      try {
	        hasApply = !!logFn.apply;
	      } catch (e) { /* empty */ }
	
	      if (hasApply) {
	        return function() {
	          var args = [];
	          forEach(arguments, function(arg) {
	            args.push(formatError(arg));
	          });
	          return logFn.apply(console, args);
	        };
	      }
	
	      // we are IE which either doesn't have window.console => this is noop and we do nothing,
	      // or we are IE where console.log doesn't have apply so we log at least first 2 args
	      return function(arg1, arg2) {
	        logFn(arg1, arg2 == null ? '' : arg2);
	      };
	    }
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $parseMinErr = minErr('$parse');
	
	var objectValueOf = {}.constructor.prototype.valueOf;
	
	// Sandboxing Angular Expressions
	// ------------------------------
	// Angular expressions are no longer sandboxed. So it is now even easier to access arbitrary JS code by
	// various means such as obtaining a reference to native JS functions like the Function constructor.
	//
	// As an example, consider the following Angular expression:
	//
	//   {}.toString.constructor('alert("evil JS code")')
	//
	// It is important to realize that if you create an expression from a string that contains user provided
	// content then it is possible that your application contains a security vulnerability to an XSS style attack.
	//
	// See https://docs.angularjs.org/guide/security
	
	
	function getStringValue(name) {
	  // Property names must be strings. This means that non-string objects cannot be used
	  // as keys in an object. Any non-string object, including a number, is typecasted
	  // into a string via the toString method.
	  // -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
	  //
	  // So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
	  // to a string. It's not always possible. If `name` is an object and its `toString` method is
	  // 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
	  //
	  // TypeError: Cannot convert object to primitive value
	  //
	  // For performance reasons, we don't catch this error here and allow it to propagate up the call
	  // stack. Note that you'll get the same error in JavaScript if you try to access a property using
	  // such a 'broken' object as a key.
	  return name + '';
	}
	
	
	var OPERATORS = createMap();
	forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '), function(operator) { OPERATORS[operator] = true; });
	var ESCAPE = {'n':'\n', 'f':'\f', 'r':'\r', 't':'\t', 'v':'\v', '\'':'\'', '"':'"'};
	
	
	/////////////////////////////////////////
	
	
	/**
	 * @constructor
	 */
	var Lexer = function Lexer(options) {
	  this.options = options;
	};
	
	Lexer.prototype = {
	  constructor: Lexer,
	
	  lex: function(text) {
	    this.text = text;
	    this.index = 0;
	    this.tokens = [];
	
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      if (ch === '"' || ch === '\'') {
	        this.readString(ch);
	      } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
	        this.readNumber();
	      } else if (this.isIdentifierStart(this.peekMultichar())) {
	        this.readIdent();
	      } else if (this.is(ch, '(){}[].,;:?')) {
	        this.tokens.push({index: this.index, text: ch});
	        this.index++;
	      } else if (this.isWhitespace(ch)) {
	        this.index++;
	      } else {
	        var ch2 = ch + this.peek();
	        var ch3 = ch2 + this.peek(2);
	        var op1 = OPERATORS[ch];
	        var op2 = OPERATORS[ch2];
	        var op3 = OPERATORS[ch3];
	        if (op1 || op2 || op3) {
	          var token = op3 ? ch3 : (op2 ? ch2 : ch);
	          this.tokens.push({index: this.index, text: token, operator: true});
	          this.index += token.length;
	        } else {
	          this.throwError('Unexpected next character ', this.index, this.index + 1);
	        }
	      }
	    }
	    return this.tokens;
	  },
	
	  is: function(ch, chars) {
	    return chars.indexOf(ch) !== -1;
	  },
	
	  peek: function(i) {
	    var num = i || 1;
	    return (this.index + num < this.text.length) ? this.text.charAt(this.index + num) : false;
	  },
	
	  isNumber: function(ch) {
	    return ('0' <= ch && ch <= '9') && typeof ch === 'string';
	  },
	
	  isWhitespace: function(ch) {
	    // IE treats non-breaking space as \u00A0
	    return (ch === ' ' || ch === '\r' || ch === '\t' ||
	            ch === '\n' || ch === '\v' || ch === '\u00A0');
	  },
	
	  isIdentifierStart: function(ch) {
	    return this.options.isIdentifierStart ?
	        this.options.isIdentifierStart(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierStart(ch);
	  },
	
	  isValidIdentifierStart: function(ch) {
	    return ('a' <= ch && ch <= 'z' ||
	            'A' <= ch && ch <= 'Z' ||
	            '_' === ch || ch === '$');
	  },
	
	  isIdentifierContinue: function(ch) {
	    return this.options.isIdentifierContinue ?
	        this.options.isIdentifierContinue(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierContinue(ch);
	  },
	
	  isValidIdentifierContinue: function(ch, cp) {
	    return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
	  },
	
	  codePointAt: function(ch) {
	    if (ch.length === 1) return ch.charCodeAt(0);
	    // eslint-disable-next-line no-bitwise
	    return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
	  },
	
	  peekMultichar: function() {
	    var ch = this.text.charAt(this.index);
	    var peek = this.peek();
	    if (!peek) {
	      return ch;
	    }
	    var cp1 = ch.charCodeAt(0);
	    var cp2 = peek.charCodeAt(0);
	    if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) {
	      return ch + peek;
	    }
	    return ch;
	  },
	
	  isExpOperator: function(ch) {
	    return (ch === '-' || ch === '+' || this.isNumber(ch));
	  },
	
	  throwError: function(error, start, end) {
	    end = end || this.index;
	    var colStr = (isDefined(start)
	            ? 's ' + start +  '-' + this.index + ' [' + this.text.substring(start, end) + ']'
	            : ' ' + end);
	    throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].',
	        error, colStr, this.text);
	  },
	
	  readNumber: function() {
	    var number = '';
	    var start = this.index;
	    while (this.index < this.text.length) {
	      var ch = lowercase(this.text.charAt(this.index));
	      if (ch === '.' || this.isNumber(ch)) {
	        number += ch;
	      } else {
	        var peekCh = this.peek();
	        if (ch === 'e' && this.isExpOperator(peekCh)) {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            peekCh && this.isNumber(peekCh) &&
	            number.charAt(number.length - 1) === 'e') {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            (!peekCh || !this.isNumber(peekCh)) &&
	            number.charAt(number.length - 1) === 'e') {
	          this.throwError('Invalid exponent');
	        } else {
	          break;
	        }
	      }
	      this.index++;
	    }
	    this.tokens.push({
	      index: start,
	      text: number,
	      constant: true,
	      value: Number(number)
	    });
	  },
	
	  readIdent: function() {
	    var start = this.index;
	    this.index += this.peekMultichar().length;
	    while (this.index < this.text.length) {
	      var ch = this.peekMultichar();
	      if (!this.isIdentifierContinue(ch)) {
	        break;
	      }
	      this.index += ch.length;
	    }
	    this.tokens.push({
	      index: start,
	      text: this.text.slice(start, this.index),
	      identifier: true
	    });
	  },
	
	  readString: function(quote) {
	    var start = this.index;
	    this.index++;
	    var string = '';
	    var rawString = quote;
	    var escape = false;
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      rawString += ch;
	      if (escape) {
	        if (ch === 'u') {
	          var hex = this.text.substring(this.index + 1, this.index + 5);
	          if (!hex.match(/[\da-f]{4}/i)) {
	            this.throwError('Invalid unicode escape [\\u' + hex + ']');
	          }
	          this.index += 4;
	          string += String.fromCharCode(parseInt(hex, 16));
	        } else {
	          var rep = ESCAPE[ch];
	          string = string + (rep || ch);
	        }
	        escape = false;
	      } else if (ch === '\\') {
	        escape = true;
	      } else if (ch === quote) {
	        this.index++;
	        this.tokens.push({
	          index: start,
	          text: rawString,
	          constant: true,
	          value: string
	        });
	        return;
	      } else {
	        string += ch;
	      }
	      this.index++;
	    }
	    this.throwError('Unterminated quote', start);
	  }
	};
	
	var AST = function AST(lexer, options) {
	  this.lexer = lexer;
	  this.options = options;
	};
	
	AST.Program = 'Program';
	AST.ExpressionStatement = 'ExpressionStatement';
	AST.AssignmentExpression = 'AssignmentExpression';
	AST.ConditionalExpression = 'ConditionalExpression';
	AST.LogicalExpression = 'LogicalExpression';
	AST.BinaryExpression = 'BinaryExpression';
	AST.UnaryExpression = 'UnaryExpression';
	AST.CallExpression = 'CallExpression';
	AST.MemberExpression = 'MemberExpression';
	AST.Identifier = 'Identifier';
	AST.Literal = 'Literal';
	AST.ArrayExpression = 'ArrayExpression';
	AST.Property = 'Property';
	AST.ObjectExpression = 'ObjectExpression';
	AST.ThisExpression = 'ThisExpression';
	AST.LocalsExpression = 'LocalsExpression';
	
	// Internal use only
	AST.NGValueParameter = 'NGValueParameter';
	
	AST.prototype = {
	  ast: function(text) {
	    this.text = text;
	    this.tokens = this.lexer.lex(text);
	
	    var value = this.program();
	
	    if (this.tokens.length !== 0) {
	      this.throwError('is an unexpected token', this.tokens[0]);
	    }
	
	    return value;
	  },
	
	  program: function() {
	    var body = [];
	    while (true) {
	      if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']'))
	        body.push(this.expressionStatement());
	      if (!this.expect(';')) {
	        return { type: AST.Program, body: body};
	      }
	    }
	  },
	
	  expressionStatement: function() {
	    return { type: AST.ExpressionStatement, expression: this.filterChain() };
	  },
	
	  filterChain: function() {
	    var left = this.expression();
	    while (this.expect('|')) {
	      left = this.filter(left);
	    }
	    return left;
	  },
	
	  expression: function() {
	    return this.assignment();
	  },
	
	  assignment: function() {
	    var result = this.ternary();
	    if (this.expect('=')) {
	      if (!isAssignable(result)) {
	        throw $parseMinErr('lval', 'Trying to assign a value to a non l-value');
	      }
	
	      result = { type: AST.AssignmentExpression, left: result, right: this.assignment(), operator: '='};
	    }
	    return result;
	  },
	
	  ternary: function() {
	    var test = this.logicalOR();
	    var alternate;
	    var consequent;
	    if (this.expect('?')) {
	      alternate = this.expression();
	      if (this.consume(':')) {
	        consequent = this.expression();
	        return { type: AST.ConditionalExpression, test: test, alternate: alternate, consequent: consequent};
	      }
	    }
	    return test;
	  },
	
	  logicalOR: function() {
	    var left = this.logicalAND();
	    while (this.expect('||')) {
	      left = { type: AST.LogicalExpression, operator: '||', left: left, right: this.logicalAND() };
	    }
	    return left;
	  },
	
	  logicalAND: function() {
	    var left = this.equality();
	    while (this.expect('&&')) {
	      left = { type: AST.LogicalExpression, operator: '&&', left: left, right: this.equality()};
	    }
	    return left;
	  },
	
	  equality: function() {
	    var left = this.relational();
	    var token;
	    while ((token = this.expect('==','!=','===','!=='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.relational() };
	    }
	    return left;
	  },
	
	  relational: function() {
	    var left = this.additive();
	    var token;
	    while ((token = this.expect('<', '>', '<=', '>='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.additive() };
	    }
	    return left;
	  },
	
	  additive: function() {
	    var left = this.multiplicative();
	    var token;
	    while ((token = this.expect('+','-'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.multiplicative() };
	    }
	    return left;
	  },
	
	  multiplicative: function() {
	    var left = this.unary();
	    var token;
	    while ((token = this.expect('*','/','%'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.unary() };
	    }
	    return left;
	  },
	
	  unary: function() {
	    var token;
	    if ((token = this.expect('+', '-', '!'))) {
	      return { type: AST.UnaryExpression, operator: token.text, prefix: true, argument: this.unary() };
	    } else {
	      return this.primary();
	    }
	  },
	
	  primary: function() {
	    var primary;
	    if (this.expect('(')) {
	      primary = this.filterChain();
	      this.consume(')');
	    } else if (this.expect('[')) {
	      primary = this.arrayDeclaration();
	    } else if (this.expect('{')) {
	      primary = this.object();
	    } else if (this.selfReferential.hasOwnProperty(this.peek().text)) {
	      primary = copy(this.selfReferential[this.consume().text]);
	    } else if (this.options.literals.hasOwnProperty(this.peek().text)) {
	      primary = { type: AST.Literal, value: this.options.literals[this.consume().text]};
	    } else if (this.peek().identifier) {
	      primary = this.identifier();
	    } else if (this.peek().constant) {
	      primary = this.constant();
	    } else {
	      this.throwError('not a primary expression', this.peek());
	    }
	
	    var next;
	    while ((next = this.expect('(', '[', '.'))) {
	      if (next.text === '(') {
	        primary = {type: AST.CallExpression, callee: primary, arguments: this.parseArguments() };
	        this.consume(')');
	      } else if (next.text === '[') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.expression(), computed: true };
	        this.consume(']');
	      } else if (next.text === '.') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.identifier(), computed: false };
	      } else {
	        this.throwError('IMPOSSIBLE');
	      }
	    }
	    return primary;
	  },
	
	  filter: function(baseExpression) {
	    var args = [baseExpression];
	    var result = {type: AST.CallExpression, callee: this.identifier(), arguments: args, filter: true};
	
	    while (this.expect(':')) {
	      args.push(this.expression());
	    }
	
	    return result;
	  },
	
	  parseArguments: function() {
	    var args = [];
	    if (this.peekToken().text !== ')') {
	      do {
	        args.push(this.filterChain());
	      } while (this.expect(','));
	    }
	    return args;
	  },
	
	  identifier: function() {
	    var token = this.consume();
	    if (!token.identifier) {
	      this.throwError('is not a valid identifier', token);
	    }
	    return { type: AST.Identifier, name: token.text };
	  },
	
	  constant: function() {
	    // TODO check that it is a constant
	    return { type: AST.Literal, value: this.consume().value };
	  },
	
	  arrayDeclaration: function() {
	    var elements = [];
	    if (this.peekToken().text !== ']') {
	      do {
	        if (this.peek(']')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        elements.push(this.expression());
	      } while (this.expect(','));
	    }
	    this.consume(']');
	
	    return { type: AST.ArrayExpression, elements: elements };
	  },
	
	  object: function() {
	    var properties = [], property;
	    if (this.peekToken().text !== '}') {
	      do {
	        if (this.peek('}')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        property = {type: AST.Property, kind: 'init'};
	        if (this.peek().constant) {
	          property.key = this.constant();
	          property.computed = false;
	          this.consume(':');
	          property.value = this.expression();
	        } else if (this.peek().identifier) {
	          property.key = this.identifier();
	          property.computed = false;
	          if (this.peek(':')) {
	            this.consume(':');
	            property.value = this.expression();
	          } else {
	            property.value = property.key;
	          }
	        } else if (this.peek('[')) {
	          this.consume('[');
	          property.key = this.expression();
	          this.consume(']');
	          property.computed = true;
	          this.consume(':');
	          property.value = this.expression();
	        } else {
	          this.throwError('invalid key', this.peek());
	        }
	        properties.push(property);
	      } while (this.expect(','));
	    }
	    this.consume('}');
	
	    return {type: AST.ObjectExpression, properties: properties };
	  },
	
	  throwError: function(msg, token) {
	    throw $parseMinErr('syntax',
	        'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].',
	          token.text, msg, (token.index + 1), this.text, this.text.substring(token.index));
	  },
	
	  consume: function(e1) {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	
	    var token = this.expect(e1);
	    if (!token) {
	      this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
	    }
	    return token;
	  },
	
	  peekToken: function() {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	    return this.tokens[0];
	  },
	
	  peek: function(e1, e2, e3, e4) {
	    return this.peekAhead(0, e1, e2, e3, e4);
	  },
	
	  peekAhead: function(i, e1, e2, e3, e4) {
	    if (this.tokens.length > i) {
	      var token = this.tokens[i];
	      var t = token.text;
	      if (t === e1 || t === e2 || t === e3 || t === e4 ||
	          (!e1 && !e2 && !e3 && !e4)) {
	        return token;
	      }
	    }
	    return false;
	  },
	
	  expect: function(e1, e2, e3, e4) {
	    var token = this.peek(e1, e2, e3, e4);
	    if (token) {
	      this.tokens.shift();
	      return token;
	    }
	    return false;
	  },
	
	  selfReferential: {
	    'this': {type: AST.ThisExpression },
	    '$locals': {type: AST.LocalsExpression }
	  }
	};
	
	function ifDefined(v, d) {
	  return typeof v !== 'undefined' ? v : d;
	}
	
	function plusFn(l, r) {
	  if (typeof l === 'undefined') return r;
	  if (typeof r === 'undefined') return l;
	  return l + r;
	}
	
	function isStateless($filter, filterName) {
	  var fn = $filter(filterName);
	  return !fn.$stateful;
	}
	
	function findConstantAndWatchExpressions(ast, $filter) {
	  var allConstants;
	  var argsToWatch;
	  var isStatelessFilter;
	  switch (ast.type) {
	  case AST.Program:
	    allConstants = true;
	    forEach(ast.body, function(expr) {
	      findConstantAndWatchExpressions(expr.expression, $filter);
	      allConstants = allConstants && expr.expression.constant;
	    });
	    ast.constant = allConstants;
	    break;
	  case AST.Literal:
	    ast.constant = true;
	    ast.toWatch = [];
	    break;
	  case AST.UnaryExpression:
	    findConstantAndWatchExpressions(ast.argument, $filter);
	    ast.constant = ast.argument.constant;
	    ast.toWatch = ast.argument.toWatch;
	    break;
	  case AST.BinaryExpression:
	    findConstantAndWatchExpressions(ast.left, $filter);
	    findConstantAndWatchExpressions(ast.right, $filter);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
	    break;
	  case AST.LogicalExpression:
	    findConstantAndWatchExpressions(ast.left, $filter);
	    findConstantAndWatchExpressions(ast.right, $filter);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.ConditionalExpression:
	    findConstantAndWatchExpressions(ast.test, $filter);
	    findConstantAndWatchExpressions(ast.alternate, $filter);
	    findConstantAndWatchExpressions(ast.consequent, $filter);
	    ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.Identifier:
	    ast.constant = false;
	    ast.toWatch = [ast];
	    break;
	  case AST.MemberExpression:
	    findConstantAndWatchExpressions(ast.object, $filter);
	    if (ast.computed) {
	      findConstantAndWatchExpressions(ast.property, $filter);
	    }
	    ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
	    ast.toWatch = [ast];
	    break;
	  case AST.CallExpression:
	    isStatelessFilter = ast.filter ? isStateless($filter, ast.callee.name) : false;
	    allConstants = isStatelessFilter;
	    argsToWatch = [];
	    forEach(ast.arguments, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter);
	      allConstants = allConstants && expr.constant;
	      if (!expr.constant) {
	        argsToWatch.push.apply(argsToWatch, expr.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = isStatelessFilter ? argsToWatch : [ast];
	    break;
	  case AST.AssignmentExpression:
	    findConstantAndWatchExpressions(ast.left, $filter);
	    findConstantAndWatchExpressions(ast.right, $filter);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = [ast];
	    break;
	  case AST.ArrayExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.elements, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter);
	      allConstants = allConstants && expr.constant;
	      if (!expr.constant) {
	        argsToWatch.push.apply(argsToWatch, expr.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ObjectExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.properties, function(property) {
	      findConstantAndWatchExpressions(property.value, $filter);
	      allConstants = allConstants && property.value.constant && !property.computed;
	      if (!property.value.constant) {
	        argsToWatch.push.apply(argsToWatch, property.value.toWatch);
	      }
	      if (property.computed) {
	        findConstantAndWatchExpressions(property.key, $filter);
	        if (!property.key.constant) {
	          argsToWatch.push.apply(argsToWatch, property.key.toWatch);
	        }
	      }
	
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ThisExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  case AST.LocalsExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  }
	}
	
	function getInputs(body) {
	  if (body.length !== 1) return;
	  var lastExpression = body[0].expression;
	  var candidate = lastExpression.toWatch;
	  if (candidate.length !== 1) return candidate;
	  return candidate[0] !== lastExpression ? candidate : undefined;
	}
	
	function isAssignable(ast) {
	  return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
	}
	
	function assignableAST(ast) {
	  if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
	    return {type: AST.AssignmentExpression, left: ast.body[0].expression, right: {type: AST.NGValueParameter}, operator: '='};
	  }
	}
	
	function isLiteral(ast) {
	  return ast.body.length === 0 ||
	      ast.body.length === 1 && (
	      ast.body[0].expression.type === AST.Literal ||
	      ast.body[0].expression.type === AST.ArrayExpression ||
	      ast.body[0].expression.type === AST.ObjectExpression);
	}
	
	function isConstant(ast) {
	  return ast.constant;
	}
	
	function ASTCompiler($filter) {
	  this.$filter = $filter;
	}
	
	ASTCompiler.prototype = {
	  compile: function(ast) {
	    var self = this;
	    this.state = {
	      nextId: 0,
	      filters: {},
	      fn: {vars: [], body: [], own: {}},
	      assign: {vars: [], body: [], own: {}},
	      inputs: []
	    };
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var extra = '';
	    var assignable;
	    this.stage = 'assign';
	    if ((assignable = assignableAST(ast))) {
	      this.state.computing = 'assign';
	      var result = this.nextId();
	      this.recurse(assignable, result);
	      this.return_(result);
	      extra = 'fn.assign=' + this.generateFunction('assign', 's,v,l');
	    }
	    var toWatch = getInputs(ast.body);
	    self.stage = 'inputs';
	    forEach(toWatch, function(watch, key) {
	      var fnKey = 'fn' + key;
	      self.state[fnKey] = {vars: [], body: [], own: {}};
	      self.state.computing = fnKey;
	      var intoId = self.nextId();
	      self.recurse(watch, intoId);
	      self.return_(intoId);
	      self.state.inputs.push(fnKey);
	      watch.watchId = key;
	    });
	    this.state.computing = 'fn';
	    this.stage = 'main';
	    this.recurse(ast);
	    var fnString =
	      // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
	      // This is a workaround for this until we do a better job at only removing the prefix only when we should.
	      '"' + this.USE + ' ' + this.STRICT + '";\n' +
	      this.filterPrefix() +
	      'var fn=' + this.generateFunction('fn', 's,l,a,i') +
	      extra +
	      this.watchFns() +
	      'return fn;';
	
	    // eslint-disable-next-line no-new-func
	    var fn = (new Function('$filter',
	        'getStringValue',
	        'ifDefined',
	        'plus',
	        fnString))(
	          this.$filter,
	          getStringValue,
	          ifDefined,
	          plusFn);
	    this.state = this.stage = undefined;
	    return fn;
	  },
	
	  USE: 'use',
	
	  STRICT: 'strict',
	
	  watchFns: function() {
	    var result = [];
	    var fns = this.state.inputs;
	    var self = this;
	    forEach(fns, function(name) {
	      result.push('var ' + name + '=' + self.generateFunction(name, 's'));
	    });
	    if (fns.length) {
	      result.push('fn.inputs=[' + fns.join(',') + '];');
	    }
	    return result.join('');
	  },
	
	  generateFunction: function(name, params) {
	    return 'function(' + params + '){' +
	        this.varsPrefix(name) +
	        this.body(name) +
	        '};';
	  },
	
	  filterPrefix: function() {
	    var parts = [];
	    var self = this;
	    forEach(this.state.filters, function(id, filter) {
	      parts.push(id + '=$filter(' + self.escape(filter) + ')');
	    });
	    if (parts.length) return 'var ' + parts.join(',') + ';';
	    return '';
	  },
	
	  varsPrefix: function(section) {
	    return this.state[section].vars.length ? 'var ' + this.state[section].vars.join(',') + ';' : '';
	  },
	
	  body: function(section) {
	    return this.state[section].body.join('');
	  },
	
	  recurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var left, right, self = this, args, expression, computed;
	    recursionFn = recursionFn || noop;
	    if (!skipWatchIdCheck && isDefined(ast.watchId)) {
	      intoId = intoId || this.nextId();
	      this.if_('i',
	        this.lazyAssign(intoId, this.computedMember('i', ast.watchId)),
	        this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true)
	      );
	      return;
	    }
	    switch (ast.type) {
	    case AST.Program:
	      forEach(ast.body, function(expression, pos) {
	        self.recurse(expression.expression, undefined, undefined, function(expr) { right = expr; });
	        if (pos !== ast.body.length - 1) {
	          self.current().body.push(right, ';');
	        } else {
	          self.return_(right);
	        }
	      });
	      break;
	    case AST.Literal:
	      expression = this.escape(ast.value);
	      this.assign(intoId, expression);
	      recursionFn(intoId || expression);
	      break;
	    case AST.UnaryExpression:
	      this.recurse(ast.argument, undefined, undefined, function(expr) { right = expr; });
	      expression = ast.operator + '(' + this.ifDefined(right, 0) + ')';
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.BinaryExpression:
	      this.recurse(ast.left, undefined, undefined, function(expr) { left = expr; });
	      this.recurse(ast.right, undefined, undefined, function(expr) { right = expr; });
	      if (ast.operator === '+') {
	        expression = this.plus(left, right);
	      } else if (ast.operator === '-') {
	        expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
	      } else {
	        expression = '(' + left + ')' + ast.operator + '(' + right + ')';
	      }
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.LogicalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.left, intoId);
	      self.if_(ast.operator === '&&' ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.ConditionalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.test, intoId);
	      self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.Identifier:
	      intoId = intoId || this.nextId();
	      if (nameId) {
	        nameId.context = self.stage === 'inputs' ? 's' : this.assign(this.nextId(), this.getHasOwnProperty('l', ast.name) + '?l:s');
	        nameId.computed = false;
	        nameId.name = ast.name;
	      }
	      self.if_(self.stage === 'inputs' || self.not(self.getHasOwnProperty('l', ast.name)),
	        function() {
	          self.if_(self.stage === 'inputs' || 's', function() {
	            if (create && create !== 1) {
	              self.if_(
	                self.isNull(self.nonComputedMember('s', ast.name)),
	                self.lazyAssign(self.nonComputedMember('s', ast.name), '{}'));
	            }
	            self.assign(intoId, self.nonComputedMember('s', ast.name));
	          });
	        }, intoId && self.lazyAssign(intoId, self.nonComputedMember('l', ast.name))
	        );
	      recursionFn(intoId);
	      break;
	    case AST.MemberExpression:
	      left = nameId && (nameId.context = this.nextId()) || this.nextId();
	      intoId = intoId || this.nextId();
	      self.recurse(ast.object, left, undefined, function() {
	        self.if_(self.notNull(left), function() {
	          if (ast.computed) {
	            right = self.nextId();
	            self.recurse(ast.property, right);
	            self.getStringValue(right);
	            if (create && create !== 1) {
	              self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), '{}'));
	            }
	            expression = self.computedMember(left, right);
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = true;
	              nameId.name = right;
	            }
	          } else {
	            if (create && create !== 1) {
	              self.if_(self.isNull(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), '{}'));
	            }
	            expression = self.nonComputedMember(left, ast.property.name);
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = false;
	              nameId.name = ast.property.name;
	            }
	          }
	        }, function() {
	          self.assign(intoId, 'undefined');
	        });
	        recursionFn(intoId);
	      }, !!create);
	      break;
	    case AST.CallExpression:
	      intoId = intoId || this.nextId();
	      if (ast.filter) {
	        right = self.filter(ast.callee.name);
	        args = [];
	        forEach(ast.arguments, function(expr) {
	          var argument = self.nextId();
	          self.recurse(expr, argument);
	          args.push(argument);
	        });
	        expression = right + '(' + args.join(',') + ')';
	        self.assign(intoId, expression);
	        recursionFn(intoId);
	      } else {
	        right = self.nextId();
	        left = {};
	        args = [];
	        self.recurse(ast.callee, right, left, function() {
	          self.if_(self.notNull(right), function() {
	            forEach(ast.arguments, function(expr) {
	              self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
	                args.push(argument);
	              });
	            });
	            if (left.name) {
	              expression = self.member(left.context, left.name, left.computed) + '(' + args.join(',') + ')';
	            } else {
	              expression = right + '(' + args.join(',') + ')';
	            }
	            self.assign(intoId, expression);
	          }, function() {
	            self.assign(intoId, 'undefined');
	          });
	          recursionFn(intoId);
	        });
	      }
	      break;
	    case AST.AssignmentExpression:
	      right = this.nextId();
	      left = {};
	      this.recurse(ast.left, undefined, left, function() {
	        self.if_(self.notNull(left.context), function() {
	          self.recurse(ast.right, right);
	          expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
	          self.assign(intoId, expression);
	          recursionFn(intoId || expression);
	        });
	      }, 1);
	      break;
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
	          args.push(argument);
	        });
	      });
	      expression = '[' + args.join(',') + ']';
	      this.assign(intoId, expression);
	      recursionFn(intoId || expression);
	      break;
	    case AST.ObjectExpression:
	      args = [];
	      computed = false;
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          computed = true;
	        }
	      });
	      if (computed) {
	        intoId = intoId || this.nextId();
	        this.assign(intoId, '{}');
	        forEach(ast.properties, function(property) {
	          if (property.computed) {
	            left = self.nextId();
	            self.recurse(property.key, left);
	          } else {
	            left = property.key.type === AST.Identifier ?
	                       property.key.name :
	                       ('' + property.key.value);
	          }
	          right = self.nextId();
	          self.recurse(property.value, right);
	          self.assign(self.member(intoId, left, property.computed), right);
	        });
	      } else {
	        forEach(ast.properties, function(property) {
	          self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function(expr) {
	            args.push(self.escape(
	                property.key.type === AST.Identifier ? property.key.name :
	                  ('' + property.key.value)) +
	                ':' + expr);
	          });
	        });
	        expression = '{' + args.join(',') + '}';
	        this.assign(intoId, expression);
	      }
	      recursionFn(intoId || expression);
	      break;
	    case AST.ThisExpression:
	      this.assign(intoId, 's');
	      recursionFn(intoId || 's');
	      break;
	    case AST.LocalsExpression:
	      this.assign(intoId, 'l');
	      recursionFn(intoId || 'l');
	      break;
	    case AST.NGValueParameter:
	      this.assign(intoId, 'v');
	      recursionFn(intoId || 'v');
	      break;
	    }
	  },
	
	  getHasOwnProperty: function(element, property) {
	    var key = element + '.' + property;
	    var own = this.current().own;
	    if (!own.hasOwnProperty(key)) {
	      own[key] = this.nextId(false, element + '&&(' + this.escape(property) + ' in ' + element + ')');
	    }
	    return own[key];
	  },
	
	  assign: function(id, value) {
	    if (!id) return;
	    this.current().body.push(id, '=', value, ';');
	    return id;
	  },
	
	  filter: function(filterName) {
	    if (!this.state.filters.hasOwnProperty(filterName)) {
	      this.state.filters[filterName] = this.nextId(true);
	    }
	    return this.state.filters[filterName];
	  },
	
	  ifDefined: function(id, defaultValue) {
	    return 'ifDefined(' + id + ',' + this.escape(defaultValue) + ')';
	  },
	
	  plus: function(left, right) {
	    return 'plus(' + left + ',' + right + ')';
	  },
	
	  return_: function(id) {
	    this.current().body.push('return ', id, ';');
	  },
	
	  if_: function(test, alternate, consequent) {
	    if (test === true) {
	      alternate();
	    } else {
	      var body = this.current().body;
	      body.push('if(', test, '){');
	      alternate();
	      body.push('}');
	      if (consequent) {
	        body.push('else{');
	        consequent();
	        body.push('}');
	      }
	    }
	  },
	
	  not: function(expression) {
	    return '!(' + expression + ')';
	  },
	
	  isNull: function(expression) {
	    return expression + '==null';
	  },
	
	  notNull: function(expression) {
	    return expression + '!=null';
	  },
	
	  nonComputedMember: function(left, right) {
	    var SAFE_IDENTIFIER = /^[$_a-zA-Z][$_a-zA-Z0-9]*$/;
	    var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
	    if (SAFE_IDENTIFIER.test(right)) {
	      return left + '.' + right;
	    } else {
	      return left  + '["' + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + '"]';
	    }
	  },
	
	  computedMember: function(left, right) {
	    return left + '[' + right + ']';
	  },
	
	  member: function(left, right, computed) {
	    if (computed) return this.computedMember(left, right);
	    return this.nonComputedMember(left, right);
	  },
	
	  getStringValue: function(item) {
	    this.assign(item, 'getStringValue(' + item + ')');
	  },
	
	  lazyRecurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var self = this;
	    return function() {
	      self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
	    };
	  },
	
	  lazyAssign: function(id, value) {
	    var self = this;
	    return function() {
	      self.assign(id, value);
	    };
	  },
	
	  stringEscapeRegex: /[^ a-zA-Z0-9]/g,
	
	  stringEscapeFn: function(c) {
	    return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
	  },
	
	  escape: function(value) {
	    if (isString(value)) return '\'' + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + '\'';
	    if (isNumber(value)) return value.toString();
	    if (value === true) return 'true';
	    if (value === false) return 'false';
	    if (value === null) return 'null';
	    if (typeof value === 'undefined') return 'undefined';
	
	    throw $parseMinErr('esc', 'IMPOSSIBLE');
	  },
	
	  nextId: function(skip, init) {
	    var id = 'v' + (this.state.nextId++);
	    if (!skip) {
	      this.current().vars.push(id + (init ? '=' + init : ''));
	    }
	    return id;
	  },
	
	  current: function() {
	    return this.state[this.state.computing];
	  }
	};
	
	
	function ASTInterpreter($filter) {
	  this.$filter = $filter;
	}
	
	ASTInterpreter.prototype = {
	  compile: function(ast) {
	    var self = this;
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var assignable;
	    var assign;
	    if ((assignable = assignableAST(ast))) {
	      assign = this.recurse(assignable);
	    }
	    var toWatch = getInputs(ast.body);
	    var inputs;
	    if (toWatch) {
	      inputs = [];
	      forEach(toWatch, function(watch, key) {
	        var input = self.recurse(watch);
	        watch.input = input;
	        inputs.push(input);
	        watch.watchId = key;
	      });
	    }
	    var expressions = [];
	    forEach(ast.body, function(expression) {
	      expressions.push(self.recurse(expression.expression));
	    });
	    var fn = ast.body.length === 0 ? noop :
	             ast.body.length === 1 ? expressions[0] :
	             function(scope, locals) {
	               var lastValue;
	               forEach(expressions, function(exp) {
	                 lastValue = exp(scope, locals);
	               });
	               return lastValue;
	             };
	    if (assign) {
	      fn.assign = function(scope, value, locals) {
	        return assign(scope, locals, value);
	      };
	    }
	    if (inputs) {
	      fn.inputs = inputs;
	    }
	    return fn;
	  },
	
	  recurse: function(ast, context, create) {
	    var left, right, self = this, args;
	    if (ast.input) {
	      return this.inputs(ast.input, ast.watchId);
	    }
	    switch (ast.type) {
	    case AST.Literal:
	      return this.value(ast.value, context);
	    case AST.UnaryExpression:
	      right = this.recurse(ast.argument);
	      return this['unary' + ast.operator](right, context);
	    case AST.BinaryExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.LogicalExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.ConditionalExpression:
	      return this['ternary?:'](
	        this.recurse(ast.test),
	        this.recurse(ast.alternate),
	        this.recurse(ast.consequent),
	        context
	      );
	    case AST.Identifier:
	      return self.identifier(ast.name, context, create);
	    case AST.MemberExpression:
	      left = this.recurse(ast.object, false, !!create);
	      if (!ast.computed) {
	        right = ast.property.name;
	      }
	      if (ast.computed) right = this.recurse(ast.property);
	      return ast.computed ?
	        this.computedMember(left, right, context, create) :
	        this.nonComputedMember(left, right, context, create);
	    case AST.CallExpression:
	      args = [];
	      forEach(ast.arguments, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      if (ast.filter) right = this.$filter(ast.callee.name);
	      if (!ast.filter) right = this.recurse(ast.callee, true);
	      return ast.filter ?
	        function(scope, locals, assign, inputs) {
	          var values = [];
	          for (var i = 0; i < args.length; ++i) {
	            values.push(args[i](scope, locals, assign, inputs));
	          }
	          var value = right.apply(undefined, values, inputs);
	          return context ? {context: undefined, name: undefined, value: value} : value;
	        } :
	        function(scope, locals, assign, inputs) {
	          var rhs = right(scope, locals, assign, inputs);
	          var value;
	          if (rhs.value != null) {
	            var values = [];
	            for (var i = 0; i < args.length; ++i) {
	              values.push(args[i](scope, locals, assign, inputs));
	            }
	            value = rhs.value.apply(rhs.context, values);
	          }
	          return context ? {value: value} : value;
	        };
	    case AST.AssignmentExpression:
	      left = this.recurse(ast.left, true, 1);
	      right = this.recurse(ast.right);
	      return function(scope, locals, assign, inputs) {
	        var lhs = left(scope, locals, assign, inputs);
	        var rhs = right(scope, locals, assign, inputs);
	        lhs.context[lhs.name] = rhs;
	        return context ? {value: rhs} : rhs;
	      };
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = [];
	        for (var i = 0; i < args.length; ++i) {
	          value.push(args[i](scope, locals, assign, inputs));
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ObjectExpression:
	      args = [];
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          args.push({key: self.recurse(property.key),
	                     computed: true,
	                     value: self.recurse(property.value)
	          });
	        } else {
	          args.push({key: property.key.type === AST.Identifier ?
	                          property.key.name :
	                          ('' + property.key.value),
	                     computed: false,
	                     value: self.recurse(property.value)
	          });
	        }
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = {};
	        for (var i = 0; i < args.length; ++i) {
	          if (args[i].computed) {
	            value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
	          } else {
	            value[args[i].key] = args[i].value(scope, locals, assign, inputs);
	          }
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ThisExpression:
	      return function(scope) {
	        return context ? {value: scope} : scope;
	      };
	    case AST.LocalsExpression:
	      return function(scope, locals) {
	        return context ? {value: locals} : locals;
	      };
	    case AST.NGValueParameter:
	      return function(scope, locals, assign) {
	        return context ? {value: assign} : assign;
	      };
	    }
	  },
	
	  'unary+': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = +arg;
	      } else {
	        arg = 0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary-': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = -arg;
	      } else {
	        arg = -0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary!': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = !argument(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary+': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = plusFn(lhs, rhs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary-': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary*': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary/': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary%': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary===': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      // eslint-disable-next-line eqeqeq
	      var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      // eslint-disable-next-line eqeqeq
	      var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary&&': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary||': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'ternary?:': function(test, alternate, consequent, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  value: function(value, context) {
	    return function() { return context ? {context: undefined, name: undefined, value: value} : value; };
	  },
	  identifier: function(name, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var base = locals && (name in locals) ? locals : scope;
	      if (create && create !== 1 && base && base[name] == null) {
	        base[name] = {};
	      }
	      var value = base ? base[name] : undefined;
	      if (context) {
	        return {context: base, name: name, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  computedMember: function(left, right, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs;
	      var value;
	      if (lhs != null) {
	        rhs = right(scope, locals, assign, inputs);
	        rhs = getStringValue(rhs);
	        if (create && create !== 1) {
	          if (lhs && !(lhs[rhs])) {
	            lhs[rhs] = {};
	          }
	        }
	        value = lhs[rhs];
	      }
	      if (context) {
	        return {context: lhs, name: rhs, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  nonComputedMember: function(left, right, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      if (create && create !== 1) {
	        if (lhs && lhs[right] == null) {
	          lhs[right] = {};
	        }
	      }
	      var value = lhs != null ? lhs[right] : undefined;
	      if (context) {
	        return {context: lhs, name: right, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  inputs: function(input, watchId) {
	    return function(scope, value, locals, inputs) {
	      if (inputs) return inputs[watchId];
	      return input(scope, value, locals);
	    };
	  }
	};
	
	/**
	 * @constructor
	 */
	function Parser(lexer, $filter, options) {
	  this.ast = new AST(lexer, options);
	  this.astCompiler = options.csp ? new ASTInterpreter($filter) :
	                                   new ASTCompiler($filter);
	}
	
	Parser.prototype = {
	  constructor: Parser,
	
	  parse: function(text) {
	    var ast = this.ast.ast(text);
	    var fn = this.astCompiler.compile(ast);
	    fn.literal = isLiteral(ast);
	    fn.constant = isConstant(ast);
	    return fn;
	  }
	};
	
	function getValueOf(value) {
	  return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
	}
	
	///////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $parse
	 * @kind function
	 *
	 * @description
	 *
	 * Converts Angular {@link guide/expression expression} into a function.
	 *
	 * ```js
	 *   var getter = $parse('user.name');
	 *   var setter = getter.assign;
	 *   var context = {user:{name:'angular'}};
	 *   var locals = {user:{name:'local'}};
	 *
	 *   expect(getter(context)).toEqual('angular');
	 *   setter(context, 'newValue');
	 *   expect(context.user.name).toEqual('newValue');
	 *   expect(getter(context, locals)).toEqual('local');
	 * ```
	 *
	 *
	 * @param {string} expression String expression to compile.
	 * @returns {function(context, locals)} a function which represents the compiled expression:
	 *
	 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	 *      are evaluated against (typically a scope object).
	 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	 *      `context`.
	 *
	 *    The returned function also has the following properties:
	 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
	 *        literal.
	 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
	 *        constant literals.
	 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
	 *        set to a function to change its value on the given context.
	 *
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $parseProvider
	 * @this
	 *
	 * @description
	 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
	 *  service.
	 */
	function $ParseProvider() {
	  var cache = createMap();
	  var literals = {
	    'true': true,
	    'false': false,
	    'null': null,
	    'undefined': undefined
	  };
	  var identStart, identContinue;
	
	  /**
	   * @ngdoc method
	   * @name $parseProvider#addLiteral
	   * @description
	   *
	   * Configure $parse service to add literal values that will be present as literal at expressions.
	   *
	   * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
	   * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
	   *
	   **/
	  this.addLiteral = function(literalName, literalValue) {
	    literals[literalName] = literalValue;
	  };
	
	 /**
	  * @ngdoc method
	  * @name $parseProvider#setIdentifierFns
	  *
	  * @description
	  *
	  * Allows defining the set of characters that are allowed in Angular expressions. The function
	  * `identifierStart` will get called to know if a given character is a valid character to be the
	  * first character for an identifier. The function `identifierContinue` will get called to know if
	  * a given character is a valid character to be a follow-up identifier character. The functions
	  * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
	  * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
	  * mind that the `string` parameter can be two characters long depending on the character
	  * representation. It is expected for the function to return `true` or `false`, whether that
	  * character is allowed or not.
	  *
	  * Since this function will be called extensively, keep the implementation of these functions fast,
	  * as the performance of these functions have a direct impact on the expressions parsing speed.
	  *
	  * @param {function=} identifierStart The function that will decide whether the given character is
	  *   a valid identifier start character.
	  * @param {function=} identifierContinue The function that will decide whether the given character is
	  *   a valid identifier continue character.
	  */
	  this.setIdentifierFns = function(identifierStart, identifierContinue) {
	    identStart = identifierStart;
	    identContinue = identifierContinue;
	    return this;
	  };
	
	  this.$get = ['$filter', function($filter) {
	    var noUnsafeEval = csp().noUnsafeEval;
	    var $parseOptions = {
	          csp: noUnsafeEval,
	          literals: copy(literals),
	          isIdentifierStart: isFunction(identStart) && identStart,
	          isIdentifierContinue: isFunction(identContinue) && identContinue
	        };
	    return $parse;
	
	    function $parse(exp, interceptorFn) {
	      var parsedExpression, oneTime, cacheKey;
	
	      switch (typeof exp) {
	        case 'string':
	          exp = exp.trim();
	          cacheKey = exp;
	
	          parsedExpression = cache[cacheKey];
	
	          if (!parsedExpression) {
	            if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
	              oneTime = true;
	              exp = exp.substring(2);
	            }
	            var lexer = new Lexer($parseOptions);
	            var parser = new Parser(lexer, $filter, $parseOptions);
	            parsedExpression = parser.parse(exp);
	            if (parsedExpression.constant) {
	              parsedExpression.$$watchDelegate = constantWatchDelegate;
	            } else if (oneTime) {
	              parsedExpression.oneTime = true;
	              parsedExpression.$$watchDelegate = oneTimeWatchDelegate;
	            } else if (parsedExpression.inputs) {
	              parsedExpression.$$watchDelegate = inputsWatchDelegate;
	            }
	            cache[cacheKey] = parsedExpression;
	          }
	          return addInterceptor(parsedExpression, interceptorFn);
	
	        case 'function':
	          return addInterceptor(exp, interceptorFn);
	
	        default:
	          return addInterceptor(noop, interceptorFn);
	      }
	    }
	
	    function expressionInputDirtyCheck(newValue, oldValueOfValue, compareObjectIdentity) {
	
	      if (newValue == null || oldValueOfValue == null) { // null/undefined
	        return newValue === oldValueOfValue;
	      }
	
	      if (typeof newValue === 'object') {
	
	        // attempt to convert the value to a primitive type
	        // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
	        //             be cheaply dirty-checked
	        newValue = getValueOf(newValue);
	
	        if (typeof newValue === 'object' && !compareObjectIdentity) {
	          // objects/arrays are not supported - deep-watching them would be too expensive
	          return false;
	        }
	
	        // fall-through to the primitive equality check
	      }
	
	      //Primitive or NaN
	      // eslint-disable-next-line no-self-compare
	      return newValue === oldValueOfValue || (newValue !== newValue && oldValueOfValue !== oldValueOfValue);
	    }
	
	    function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var inputExpressions = parsedExpression.inputs;
	      var lastResult;
	
	      if (inputExpressions.length === 1) {
	        var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        inputExpressions = inputExpressions[0];
	        return scope.$watch(function expressionInputWatch(scope) {
	          var newInputValue = inputExpressions(scope);
	          if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf, parsedExpression.literal)) {
	            lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
	            oldInputValueOf = newInputValue && getValueOf(newInputValue);
	          }
	          return lastResult;
	        }, listener, objectEquality, prettyPrintExpression);
	      }
	
	      var oldInputValueOfValues = [];
	      var oldInputValues = [];
	      for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	        oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        oldInputValues[i] = null;
	      }
	
	      return scope.$watch(function expressionInputsWatch(scope) {
	        var changed = false;
	
	        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	          var newInputValue = inputExpressions[i](scope);
	          if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i], parsedExpression.literal))) {
	            oldInputValues[i] = newInputValue;
	            oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
	          }
	        }
	
	        if (changed) {
	          lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
	        }
	
	        return lastResult;
	      }, listener, objectEquality, prettyPrintExpression);
	    }
	
	    function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var isDone = parsedExpression.literal ? isAllDefined : isDefined;
	      var unwatch, lastValue;
	      if (parsedExpression.inputs) {
	        unwatch = inputsWatchDelegate(scope, oneTimeListener, objectEquality, parsedExpression, prettyPrintExpression);
	      } else {
	        unwatch = scope.$watch(oneTimeWatch, oneTimeListener, objectEquality);
	      }
	      return unwatch;
	
	      function oneTimeWatch(scope) {
	        return parsedExpression(scope);
	      }
	      function oneTimeListener(value, old, scope) {
	        lastValue = value;
	        if (isFunction(listener)) {
	          listener(value, old, scope);
	        }
	        if (isDone(value)) {
	          scope.$$postDigest(function() {
	            if (isDone(lastValue)) {
	              unwatch();
	            }
	          });
	        }
	      }
	    }
	
	    function isAllDefined(value) {
	      var allDefined = true;
	      forEach(value, function(val) {
	        if (!isDefined(val)) allDefined = false;
	      });
	      return allDefined;
	    }
	
	    function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch = scope.$watch(function constantWatch(scope) {
	        unwatch();
	        return parsedExpression(scope);
	      }, listener, objectEquality);
	      return unwatch;
	    }
	
	    function addInterceptor(parsedExpression, interceptorFn) {
	      if (!interceptorFn) return parsedExpression;
	      var watchDelegate = parsedExpression.$$watchDelegate;
	      var useInputs = false;
	
	      var isDone = parsedExpression.literal ? isAllDefined : isDefined;
	
	      function regularInterceptedExpression(scope, locals, assign, inputs) {
	        var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
	        return interceptorFn(value, scope, locals);
	      }
	
	      function oneTimeInterceptedExpression(scope, locals, assign, inputs) {
	        var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
	        var result = interceptorFn(value, scope, locals);
	        // we only return the interceptor's result if the
	        // initial value is defined (for bind-once)
	        return isDone(value) ? result : value;
	      }
	
	      var fn = parsedExpression.oneTime ? oneTimeInterceptedExpression : regularInterceptedExpression;
	
	      // Propogate the literal/oneTime attributes
	      fn.literal = parsedExpression.literal;
	      fn.oneTime = parsedExpression.oneTime;
	
	      // Propagate or create inputs / $$watchDelegates
	      useInputs = !parsedExpression.inputs;
	      if (watchDelegate && watchDelegate !== inputsWatchDelegate) {
	        fn.$$watchDelegate = watchDelegate;
	        fn.inputs = parsedExpression.inputs;
	      } else if (!interceptorFn.$stateful) {
	        // If there is an interceptor, but no watchDelegate then treat the interceptor like
	        // we treat filters - it is assumed to be a pure function unless flagged with $stateful
	        fn.$$watchDelegate = inputsWatchDelegate;
	        fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];
	      }
	
	      return fn;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $q
	 * @requires $rootScope
	 *
	 * @description
	 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
	 * when they are done processing.
	 *
	 * This is a [Promises/A+](https://promisesaplus.com/)-compliant implementation of promises/deferred
	 * objects inspired by [Kris Kowal's Q](https://github.com/kriskowal/q).
	 *
	 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
	 * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
	 *
	 * # $q constructor
	 *
	 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
	 * function as the first argument. This is similar to the native Promise implementation from ES6,
	 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
	 *
	 * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
	 * available yet.
	 *
	 * It can be used like so:
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
	 *     return $q(function(resolve, reject) {
	 *       setTimeout(function() {
	 *         if (okToGreet(name)) {
	 *           resolve('Hello, ' + name + '!');
	 *         } else {
	 *           reject('Greeting ' + name + ' is not allowed.');
	 *         }
	 *       }, 1000);
	 *     });
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   });
	 * ```
	 *
	 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
	 *
	 * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
	 *
	 * However, the more traditional CommonJS-style usage is still available, and documented below.
	 *
	 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
	 * interface for interacting with an object that represents the result of an action that is
	 * performed asynchronously, and may or may not be finished at any given point in time.
	 *
	 * From the perspective of dealing with error handling, deferred and promise APIs are to
	 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     var deferred = $q.defer();
	 *
	 *     setTimeout(function() {
	 *       deferred.notify('About to greet ' + name + '.');
	 *
	 *       if (okToGreet(name)) {
	 *         deferred.resolve('Hello, ' + name + '!');
	 *       } else {
	 *         deferred.reject('Greeting ' + name + ' is not allowed.');
	 *       }
	 *     }, 1000);
	 *
	 *     return deferred.promise;
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   }, function(update) {
	 *     alert('Got notification: ' + update);
	 *   });
	 * ```
	 *
	 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
	 * comes in the way of guarantees that promise and deferred APIs make, see
	 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
	 *
	 * Additionally the promise api allows for composition that is very hard to do with the
	 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
	 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
	 * section on serial or parallel joining of promises.
	 *
	 * # The Deferred API
	 *
	 * A new instance of deferred is constructed by calling `$q.defer()`.
	 *
	 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
	 * that can be used for signaling the successful or unsuccessful completion, as well as the status
	 * of the task.
	 *
	 * **Methods**
	 *
	 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
	 *   constructed via `$q.reject`, the promise will be rejected instead.
	 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
	 *   resolving it with a rejection constructed via `$q.reject`.
	 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
	 *   multiple times before the promise is either resolved or rejected.
	 *
	 * **Properties**
	 *
	 * - promise – `{Promise}` – promise object associated with this deferred.
	 *
	 *
	 * # The Promise API
	 *
	 * A new promise instance is created when a deferred instance is created and can be retrieved by
	 * calling `deferred.promise`.
	 *
	 * The purpose of the promise object is to allow for interested parties to get access to the result
	 * of the deferred task when it completes.
	 *
	 * **Methods**
	 *
	 * - `then(successCallback, [errorCallback], [notifyCallback])` – regardless of when the promise was or
	 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
	 *   as soon as the result is available. The callbacks are called with a single argument: the result
	 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
	 *   provide a progress indication, before the promise is resolved or rejected.
	 *
	 *   This method *returns a new promise* which is resolved or rejected via the return value of the
	 *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
	 *   with the value which is resolved in that promise using
	 *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
	 *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
	 *   resolved or rejected from the notifyCallback method. The errorCallback and notifyCallback
	 *   arguments are optional.
	 *
	 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
	 *
	 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
	 *   but to do so without modifying the final value. This is useful to release resources or do some
	 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
	 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
	 *   more information.
	 *
	 * # Chaining promises
	 *
	 * Because calling the `then` method of a promise returns a new derived promise, it is easily
	 * possible to create a chain of promises:
	 *
	 * ```js
	 *   promiseB = promiseA.then(function(result) {
	 *     return result + 1;
	 *   });
	 *
	 *   // promiseB will be resolved immediately after promiseA is resolved and its value
	 *   // will be the result of promiseA incremented by 1
	 * ```
	 *
	 * It is possible to create chains of any length and since a promise can be resolved with another
	 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
	 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
	 * $http's response interceptors.
	 *
	 *
	 * # Differences between Kris Kowal's Q and $q
	 *
	 *  There are two main differences:
	 *
	 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
	 *   mechanism in angular, which means faster propagation of resolution or rejection into your
	 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
	 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
	 *   all the important functionality needed for common async tasks.
	 *
	 * # Testing
	 *
	 *  ```js
	 *    it('should simulate promise', inject(function($q, $rootScope) {
	 *      var deferred = $q.defer();
	 *      var promise = deferred.promise;
	 *      var resolvedValue;
	 *
	 *      promise.then(function(value) { resolvedValue = value; });
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Simulate resolving of promise
	 *      deferred.resolve(123);
	 *      // Note that the 'then' function does not get called synchronously.
	 *      // This is because we want the promise API to always be async, whether or not
	 *      // it got called synchronously or asynchronously.
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Propagate promise resolution to 'then' functions using $apply().
	 *      $rootScope.$apply();
	 *      expect(resolvedValue).toEqual(123);
	 *    }));
	 *  ```
	 *
	 * @param {function(function, function)} resolver Function which is responsible for resolving or
	 *   rejecting the newly created promise. The first parameter is a function which resolves the
	 *   promise, the second parameter is a function which rejects the promise.
	 *
	 * @returns {Promise} The newly created promise.
	 */
	/**
	 * @ngdoc provider
	 * @name $qProvider
	 * @this
	 *
	 * @description
	 */
	function $QProvider() {
	  var errorOnUnhandledRejections = true;
	  this.$get = ['$rootScope', '$exceptionHandler', function($rootScope, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $rootScope.$evalAsync(callback);
	    }, $exceptionHandler, errorOnUnhandledRejections);
	  }];
	
	  /**
	   * @ngdoc method
	   * @name $qProvider#errorOnUnhandledRejections
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides whether to generate an error when a rejected promise is not handled.
	   * This feature is enabled by default.
	   *
	   * @param {boolean=} value Whether to generate an error when a rejected promise is not handled.
	   * @returns {boolean|ng.$qProvider} Current value when called without a new value or self for
	   *    chaining otherwise.
	   */
	  this.errorOnUnhandledRejections = function(value) {
	    if (isDefined(value)) {
	      errorOnUnhandledRejections = value;
	      return this;
	    } else {
	      return errorOnUnhandledRejections;
	    }
	  };
	}
	
	/** @this */
	function $$QProvider() {
	  var errorOnUnhandledRejections = true;
	  this.$get = ['$browser', '$exceptionHandler', function($browser, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $browser.defer(callback);
	    }, $exceptionHandler, errorOnUnhandledRejections);
	  }];
	
	  this.errorOnUnhandledRejections = function(value) {
	    if (isDefined(value)) {
	      errorOnUnhandledRejections = value;
	      return this;
	    } else {
	      return errorOnUnhandledRejections;
	    }
	  };
	}
	
	/**
	 * Constructs a promise manager.
	 *
	 * @param {function(function)} nextTick Function for executing functions in the next turn.
	 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
	 *     debugging purposes.
	 @ param {=boolean} errorOnUnhandledRejections Whether an error should be generated on unhandled
	 *     promises rejections.
	 * @returns {object} Promise manager.
	 */
	function qFactory(nextTick, exceptionHandler, errorOnUnhandledRejections) {
	  var $qMinErr = minErr('$q', TypeError);
	  var queueSize = 0;
	  var checkQueue = [];
	
	  /**
	   * @ngdoc method
	   * @name ng.$q#defer
	   * @kind function
	   *
	   * @description
	   * Creates a `Deferred` object which represents a task which will finish in the future.
	   *
	   * @returns {Deferred} Returns a new instance of deferred.
	   */
	  function defer() {
	    return new Deferred();
	  }
	
	  function Deferred() {
	    var promise = this.promise = new Promise();
	    //Non prototype methods necessary to support unbound execution :/
	    this.resolve = function(val) { resolvePromise(promise, val); };
	    this.reject = function(reason) { rejectPromise(promise, reason); };
	    this.notify = function(progress) { notifyPromise(promise, progress); };
	  }
	
	
	  function Promise() {
	    this.$$state = { status: 0 };
	  }
	
	  extend(Promise.prototype, {
	    then: function(onFulfilled, onRejected, progressBack) {
	      if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) {
	        return this;
	      }
	      var result = new Promise();
	
	      this.$$state.pending = this.$$state.pending || [];
	      this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
	      if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);
	
	      return result;
	    },
	
	    'catch': function(callback) {
	      return this.then(null, callback);
	    },
	
	    'finally': function(callback, progressBack) {
	      return this.then(function(value) {
	        return handleCallback(value, resolve, callback);
	      }, function(error) {
	        return handleCallback(error, reject, callback);
	      }, progressBack);
	    }
	  });
	
	  function processQueue(state) {
	    var fn, promise, pending;
	
	    pending = state.pending;
	    state.processScheduled = false;
	    state.pending = undefined;
	    try {
	      for (var i = 0, ii = pending.length; i < ii; ++i) {
	        state.pur = true;
	        promise = pending[i][0];
	        fn = pending[i][state.status];
	        try {
	          if (isFunction(fn)) {
	            resolvePromise(promise, fn(state.value));
	          } else if (state.status === 1) {
	            resolvePromise(promise, state.value);
	          } else {
	            rejectPromise(promise, state.value);
	          }
	        } catch (e) {
	          rejectPromise(promise, e);
	        }
	      }
	    } finally {
	      --queueSize;
	      if (errorOnUnhandledRejections && queueSize === 0) {
	        nextTick(processChecks);
	      }
	    }
	  }
	
	  function processChecks() {
	    // eslint-disable-next-line no-unmodified-loop-condition
	    while (!queueSize && checkQueue.length) {
	      var toCheck = checkQueue.shift();
	      if (!toCheck.pur) {
	        toCheck.pur = true;
	        var errorMessage = 'Possibly unhandled rejection: ' + toDebugString(toCheck.value);
	        if (toCheck.value instanceof Error) {
	          exceptionHandler(toCheck.value, errorMessage);
	        } else {
	          exceptionHandler(errorMessage);
	        }
	      }
	    }
	  }
	
	  function scheduleProcessQueue(state) {
	    if (errorOnUnhandledRejections && !state.pending && state.status === 2 && !state.pur) {
	      if (queueSize === 0 && checkQueue.length === 0) {
	        nextTick(processChecks);
	      }
	      checkQueue.push(state);
	    }
	    if (state.processScheduled || !state.pending) return;
	    state.processScheduled = true;
	    ++queueSize;
	    nextTick(function() { processQueue(state); });
	  }
	
	  function resolvePromise(promise, val) {
	    if (promise.$$state.status) return;
	    if (val === promise) {
	      $$reject(promise, $qMinErr(
	        'qcycle',
	        'Expected promise to be resolved with value other than itself \'{0}\'',
	        val));
	    } else {
	      $$resolve(promise, val);
	    }
	
	  }
	
	  function $$resolve(promise, val) {
	    var then;
	    var done = false;
	    try {
	      if (isObject(val) || isFunction(val)) then = val.then;
	      if (isFunction(then)) {
	        promise.$$state.status = -1;
	        then.call(val, doResolve, doReject, doNotify);
	      } else {
	        promise.$$state.value = val;
	        promise.$$state.status = 1;
	        scheduleProcessQueue(promise.$$state);
	      }
	    } catch (e) {
	      doReject(e);
	    }
	
	    function doResolve(val) {
	      if (done) return;
	      done = true;
	      $$resolve(promise, val);
	    }
	    function doReject(val) {
	      if (done) return;
	      done = true;
	      $$reject(promise, val);
	    }
	    function doNotify(progress) {
	      notifyPromise(promise, progress);
	    }
	  }
	
	  function rejectPromise(promise, reason) {
	    if (promise.$$state.status) return;
	    $$reject(promise, reason);
	  }
	
	  function $$reject(promise, reason) {
	    promise.$$state.value = reason;
	    promise.$$state.status = 2;
	    scheduleProcessQueue(promise.$$state);
	  }
	
	  function notifyPromise(promise, progress) {
	    var callbacks = promise.$$state.pending;
	
	    if ((promise.$$state.status <= 0) && callbacks && callbacks.length) {
	      nextTick(function() {
	        var callback, result;
	        for (var i = 0, ii = callbacks.length; i < ii; i++) {
	          result = callbacks[i][0];
	          callback = callbacks[i][3];
	          try {
	            notifyPromise(result, isFunction(callback) ? callback(progress) : progress);
	          } catch (e) {
	            exceptionHandler(e);
	          }
	        }
	      });
	    }
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#reject
	   * @kind function
	   *
	   * @description
	   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
	   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
	   * a promise chain, you don't need to worry about it.
	   *
	   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
	   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
	   * a promise error callback and you want to forward the error to the promise derived from the
	   * current promise, you have to "rethrow" the error by returning a rejection constructed via
	   * `reject`.
	   *
	   * ```js
	   *   promiseB = promiseA.then(function(result) {
	   *     // success: do something and resolve promiseB
	   *     //          with the old or a new result
	   *     return result;
	   *   }, function(reason) {
	   *     // error: handle the error if possible and
	   *     //        resolve promiseB with newPromiseOrValue,
	   *     //        otherwise forward the rejection to promiseB
	   *     if (canHandle(reason)) {
	   *      // handle the error and recover
	   *      return newPromiseOrValue;
	   *     }
	   *     return $q.reject(reason);
	   *   });
	   * ```
	   *
	   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
	   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
	   */
	  function reject(reason) {
	    var result = new Promise();
	    rejectPromise(result, reason);
	    return result;
	  }
	
	  function handleCallback(value, resolver, callback) {
	    var callbackOutput = null;
	    try {
	      if (isFunction(callback)) callbackOutput = callback();
	    } catch (e) {
	      return reject(e);
	    }
	    if (isPromiseLike(callbackOutput)) {
	      return callbackOutput.then(function() {
	        return resolver(value);
	      }, reject);
	    } else {
	      return resolver(value);
	    }
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#when
	   * @kind function
	   *
	   * @description
	   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
	   * This is useful when you are dealing with an object that might or might not be a promise, or if
	   * the promise comes from a source that can't be trusted.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	
	
	  function when(value, callback, errback, progressBack) {
	    var result = new Promise();
	    resolvePromise(result, value);
	    return result.then(callback, errback, progressBack);
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#resolve
	   * @kind function
	   *
	   * @description
	   * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	  var resolve = when;
	
	  /**
	   * @ngdoc method
	   * @name $q#all
	   * @kind function
	   *
	   * @description
	   * Combines multiple promises into a single promise that is resolved when all of the input
	   * promises are resolved.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
	   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
	   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
	   *   with the same rejection value.
	   */
	
	  function all(promises) {
	    var result = new Promise(),
	        counter = 0,
	        results = isArray(promises) ? [] : {};
	
	    forEach(promises, function(promise, key) {
	      counter++;
	      when(promise).then(function(value) {
	        results[key] = value;
	        if (!(--counter)) resolvePromise(result, results);
	      }, function(reason) {
	        rejectPromise(result, reason);
	      });
	    });
	
	    if (counter === 0) {
	      resolvePromise(result, results);
	    }
	
	    return result;
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#race
	   * @kind function
	   *
	   * @description
	   * Returns a promise that resolves or rejects as soon as one of those promises
	   * resolves or rejects, with the value or reason from that promise.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} a promise that resolves or rejects as soon as one of the `promises`
	   * resolves or rejects, with the value or reason from that promise.
	   */
	
	  function race(promises) {
	    var deferred = defer();
	
	    forEach(promises, function(promise) {
	      when(promise).then(deferred.resolve, deferred.reject);
	    });
	
	    return deferred.promise;
	  }
	
	  function $Q(resolver) {
	    if (!isFunction(resolver)) {
	      throw $qMinErr('norslvr', 'Expected resolverFn, got \'{0}\'', resolver);
	    }
	
	    var promise = new Promise();
	
	    function resolveFn(value) {
	      resolvePromise(promise, value);
	    }
	
	    function rejectFn(reason) {
	      rejectPromise(promise, reason);
	    }
	
	    resolver(resolveFn, rejectFn);
	
	    return promise;
	  }
	
	  // Let's make the instanceof operator work for promises, so that
	  // `new $q(fn) instanceof $q` would evaluate to true.
	  $Q.prototype = Promise.prototype;
	
	  $Q.defer = defer;
	  $Q.reject = reject;
	  $Q.when = when;
	  $Q.resolve = resolve;
	  $Q.all = all;
	  $Q.race = race;
	
	  return $Q;
	}
	
	/** @this */
	function $$RAFProvider() { //rAF
	  this.$get = ['$window', '$timeout', function($window, $timeout) {
	    var requestAnimationFrame = $window.requestAnimationFrame ||
	                                $window.webkitRequestAnimationFrame;
	
	    var cancelAnimationFrame = $window.cancelAnimationFrame ||
	                               $window.webkitCancelAnimationFrame ||
	                               $window.webkitCancelRequestAnimationFrame;
	
	    var rafSupported = !!requestAnimationFrame;
	    var raf = rafSupported
	      ? function(fn) {
	          var id = requestAnimationFrame(fn);
	          return function() {
	            cancelAnimationFrame(id);
	          };
	        }
	      : function(fn) {
	          var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
	          return function() {
	            $timeout.cancel(timer);
	          };
	        };
	
	    raf.supported = rafSupported;
	
	    return raf;
	  }];
	}
	
	/**
	 * DESIGN NOTES
	 *
	 * The design decisions behind the scope are heavily favored for speed and memory consumption.
	 *
	 * The typical use of scope is to watch the expressions, which most of the time return the same
	 * value as last time so we optimize the operation.
	 *
	 * Closures construction is expensive in terms of speed as well as memory:
	 *   - No closures, instead use prototypical inheritance for API
	 *   - Internal state needs to be stored on scope directly, which means that private state is
	 *     exposed as $$____ properties
	 *
	 * Loop operations are optimized by using while(count--) { ... }
	 *   - This means that in order to keep the same order of execution as addition we have to add
	 *     items to the array at the beginning (unshift) instead of at the end (push)
	 *
	 * Child scopes are created and removed often
	 *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
	 *
	 * There are fewer watches than observers. This is why you don't want the observer to be implemented
	 * in the same way as watch. Watch requires return of the initialization function which is expensive
	 * to construct.
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $rootScopeProvider
	 * @description
	 *
	 * Provider for the $rootScope service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $rootScopeProvider#digestTtl
	 * @description
	 *
	 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
	 * assuming that the model is unstable.
	 *
	 * The current default is 10 iterations.
	 *
	 * In complex applications it's possible that the dependencies between `$watch`s will result in
	 * several digest iterations. However if an application needs more than the default 10 digest
	 * iterations for its model to stabilize then you should investigate what is causing the model to
	 * continuously change during the digest.
	 *
	 * Increasing the TTL could have performance implications, so you should not change it without
	 * proper justification.
	 *
	 * @param {number} limit The number of digest iterations.
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $rootScope
	 * @this
	 *
	 * @description
	 *
	 * Every application has a single root {@link ng.$rootScope.Scope scope}.
	 * All other scopes are descendant scopes of the root scope. Scopes provide separation
	 * between the model and the view, via a mechanism for watching the model for changes.
	 * They also provide event emission/broadcast and subscription facility. See the
	 * {@link guide/scope developer guide on scopes}.
	 */
	function $RootScopeProvider() {
	  var TTL = 10;
	  var $rootScopeMinErr = minErr('$rootScope');
	  var lastDirtyWatch = null;
	  var applyAsyncId = null;
	
	  this.digestTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	    }
	    return TTL;
	  };
	
	  function createChildScopeClass(parent) {
	    function ChildScope() {
	      this.$$watchers = this.$$nextSibling =
	          this.$$childHead = this.$$childTail = null;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$id = nextUid();
	      this.$$ChildScope = null;
	    }
	    ChildScope.prototype = parent;
	    return ChildScope;
	  }
	
	  this.$get = ['$exceptionHandler', '$parse', '$browser',
	      function($exceptionHandler, $parse, $browser) {
	
	    function destroyChildScope($event) {
	        $event.currentScope.$$destroyed = true;
	    }
	
	    function cleanUpScope($scope) {
	
	      // Support: IE 9 only
	      if (msie === 9) {
	        // There is a memory leak in IE9 if all child scopes are not disconnected
	        // completely when a scope is destroyed. So this code will recurse up through
	        // all this scopes children
	        //
	        // See issue https://github.com/angular/angular.js/issues/10706
	        if ($scope.$$childHead) {
	          cleanUpScope($scope.$$childHead);
	        }
	        if ($scope.$$nextSibling) {
	          cleanUpScope($scope.$$nextSibling);
	        }
	      }
	
	      // The code below works around IE9 and V8's memory leaks
	      //
	      // See:
	      // - https://code.google.com/p/v8/issues/detail?id=2073#c26
	      // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
	      // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451
	
	      $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead =
	          $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
	    }
	
	    /**
	     * @ngdoc type
	     * @name $rootScope.Scope
	     *
	     * @description
	     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
	     * {@link auto.$injector $injector}. Child scopes are created using the
	     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
	     * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
	     * an in-depth introduction and usage examples.
	     *
	     *
	     * # Inheritance
	     * A scope can inherit from a parent scope, as in this example:
	     * ```js
	         var parent = $rootScope;
	         var child = parent.$new();
	
	         parent.salutation = "Hello";
	         expect(child.salutation).toEqual('Hello');
	
	         child.salutation = "Welcome";
	         expect(child.salutation).toEqual('Welcome');
	         expect(parent.salutation).toEqual('Hello');
	     * ```
	     *
	     * When interacting with `Scope` in tests, additional helper methods are available on the
	     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
	     * details.
	     *
	     *
	     * @param {Object.<string, function()>=} providers Map of service factory which need to be
	     *                                       provided for the current scope. Defaults to {@link ng}.
	     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
	     *                              append/override services provided by `providers`. This is handy
	     *                              when unit-testing and having the need to override a default
	     *                              service.
	     * @returns {Object} Newly created scope.
	     *
	     */
	    function Scope() {
	      this.$id = nextUid();
	      this.$$phase = this.$parent = this.$$watchers =
	                     this.$$nextSibling = this.$$prevSibling =
	                     this.$$childHead = this.$$childTail = null;
	      this.$root = this;
	      this.$$destroyed = false;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$$isolateBindings = null;
	    }
	
	    /**
	     * @ngdoc property
	     * @name $rootScope.Scope#$id
	     *
	     * @description
	     * Unique scope ID (monotonically increasing) useful for debugging.
	     */
	
	     /**
	      * @ngdoc property
	      * @name $rootScope.Scope#$parent
	      *
	      * @description
	      * Reference to the parent scope.
	      */
	
	      /**
	       * @ngdoc property
	       * @name $rootScope.Scope#$root
	       *
	       * @description
	       * Reference to the root scope.
	       */
	
	    Scope.prototype = {
	      constructor: Scope,
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$new
	       * @kind function
	       *
	       * @description
	       * Creates a new child {@link ng.$rootScope.Scope scope}.
	       *
	       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
	       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
	       *
	       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
	       * desired for the scope and its child scopes to be permanently detached from the parent and
	       * thus stop participating in model change detection and listener notification by invoking.
	       *
	       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
	       *         parent scope. The scope is isolated, as it can not see parent scope properties.
	       *         When creating widgets, it is useful for the widget to not accidentally read parent
	       *         state.
	       *
	       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
	       *                              of the newly created scope. Defaults to `this` scope if not provided.
	       *                              This is used when creating a transclude scope to correctly place it
	       *                              in the scope hierarchy while maintaining the correct prototypical
	       *                              inheritance.
	       *
	       * @returns {Object} The newly created child scope.
	       *
	       */
	      $new: function(isolate, parent) {
	        var child;
	
	        parent = parent || this;
	
	        if (isolate) {
	          child = new Scope();
	          child.$root = this.$root;
	        } else {
	          // Only create a child scope class if somebody asks for one,
	          // but cache it to allow the VM to optimize lookups.
	          if (!this.$$ChildScope) {
	            this.$$ChildScope = createChildScopeClass(this);
	          }
	          child = new this.$$ChildScope();
	        }
	        child.$parent = parent;
	        child.$$prevSibling = parent.$$childTail;
	        if (parent.$$childHead) {
	          parent.$$childTail.$$nextSibling = child;
	          parent.$$childTail = child;
	        } else {
	          parent.$$childHead = parent.$$childTail = child;
	        }
	
	        // When the new scope is not isolated or we inherit from `this`, and
	        // the parent scope is destroyed, the property `$$destroyed` is inherited
	        // prototypically. In all other cases, this property needs to be set
	        // when the parent scope is destroyed.
	        // The listener needs to be added after the parent is set
	        if (isolate || parent !== this) child.$on('$destroy', destroyChildScope);
	
	        return child;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watch
	       * @kind function
	       *
	       * @description
	       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
	       *
	       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
	       *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
	       *   its value when executed multiple times with the same input because it may be executed multiple
	       *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
	       *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).)
	       * - The `listener` is called only when the value from the current `watchExpression` and the
	       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
	       *   see below). Inequality is determined according to reference inequality,
	       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
	       *    via the `!==` Javascript operator, unless `objectEquality == true`
	       *   (see next point)
	       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
	       *   according to the {@link angular.equals} function. To save the value of the object for
	       *   later comparison, the {@link angular.copy} function is used. This therefore means that
	       *   watching complex objects will have adverse memory and performance implications.
	       * - This should not be used to watch for changes in objects that are
	       *   or contain [File](https://developer.mozilla.org/docs/Web/API/File) objects due to limitations with {@link angular.copy `angular.copy`}.
	       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
	       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
	       *   iteration limit is 10 to prevent an infinite loop deadlock.
	       *
	       *
	       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
	       * you can register a `watchExpression` function with no `listener`. (Be prepared for
	       * multiple calls to your `watchExpression` because it will execute multiple times in a
	       * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
	       *
	       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
	       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
	       * watcher. In rare cases, this is undesirable because the listener is called when the result
	       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
	       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
	       * listener was called due to initialization.
	       *
	       *
	       *
	       * # Example
	       * ```js
	           // let's assume that scope was dependency injected as the $rootScope
	           var scope = $rootScope;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	
	
	
	           // Using a function as a watchExpression
	           var food;
	           scope.foodCounter = 0;
	           expect(scope.foodCounter).toEqual(0);
	           scope.$watch(
	             // This function returns the value being watched. It is called for each turn of the $digest loop
	             function() { return food; },
	             // This is the change listener, called when the value returned from the above function changes
	             function(newValue, oldValue) {
	               if ( newValue !== oldValue ) {
	                 // Only increment the counter if the value changed
	                 scope.foodCounter = scope.foodCounter + 1;
	               }
	             }
	           );
	           // No digest has been run so the counter will be zero
	           expect(scope.foodCounter).toEqual(0);
	
	           // Run the digest but since food has not changed count will still be zero
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(0);
	
	           // Update food and run digest.  Now the counter will increment
	           food = 'cheeseburger';
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(1);
	
	       * ```
	       *
	       *
	       *
	       * @param {(function()|string)} watchExpression Expression that is evaluated on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
	       *    a call to the `listener`.
	       *
	       *    - `string`: Evaluated as {@link guide/expression expression}
	       *    - `function(scope)`: called with current `scope` as a parameter.
	       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
	       *    of `watchExpression` changes.
	       *
	       *    - `newVal` contains the current value of the `watchExpression`
	       *    - `oldVal` contains the previous value of the `watchExpression`
	       *    - `scope` refers to the current scope
	       * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
	       *     comparing for reference equality.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $watch: function(watchExp, listener, objectEquality, prettyPrintExpression) {
	        var get = $parse(watchExp);
	
	        if (get.$$watchDelegate) {
	          return get.$$watchDelegate(this, listener, objectEquality, get, watchExp);
	        }
	        var scope = this,
	            array = scope.$$watchers,
	            watcher = {
	              fn: listener,
	              last: initWatchVal,
	              get: get,
	              exp: prettyPrintExpression || watchExp,
	              eq: !!objectEquality
	            };
	
	        lastDirtyWatch = null;
	
	        if (!isFunction(listener)) {
	          watcher.fn = noop;
	        }
	
	        if (!array) {
	          array = scope.$$watchers = [];
	          array.$$digestWatchIndex = -1;
	        }
	        // we use unshift since we use a while loop in $digest for speed.
	        // the while loop reads in reverse order.
	        array.unshift(watcher);
	        array.$$digestWatchIndex++;
	        incrementWatchersCount(this, 1);
	
	        return function deregisterWatch() {
	          var index = arrayRemove(array, watcher);
	          if (index >= 0) {
	            incrementWatchersCount(scope, -1);
	            if (index < array.$$digestWatchIndex) {
	              array.$$digestWatchIndex--;
	            }
	          }
	          lastDirtyWatch = null;
	        };
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchGroup
	       * @kind function
	       *
	       * @description
	       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
	       * If any one expression in the collection changes the `listener` is executed.
	       *
	       * - The items in the `watchExpressions` array are observed via the standard `$watch` operation. Their return
	       *   values are examined for changes on every call to `$digest`.
	       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
	       *
	       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
	       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
	       *
	       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
	       *    expression in `watchExpressions` changes
	       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    The `scope` refers to the current scope.
	       * @returns {function()} Returns a de-registration function for all listeners.
	       */
	      $watchGroup: function(watchExpressions, listener) {
	        var oldValues = new Array(watchExpressions.length);
	        var newValues = new Array(watchExpressions.length);
	        var deregisterFns = [];
	        var self = this;
	        var changeReactionScheduled = false;
	        var firstRun = true;
	
	        if (!watchExpressions.length) {
	          // No expressions means we call the listener ASAP
	          var shouldCall = true;
	          self.$evalAsync(function() {
	            if (shouldCall) listener(newValues, newValues, self);
	          });
	          return function deregisterWatchGroup() {
	            shouldCall = false;
	          };
	        }
	
	        if (watchExpressions.length === 1) {
	          // Special case size of one
	          return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
	            newValues[0] = value;
	            oldValues[0] = oldValue;
	            listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
	          });
	        }
	
	        forEach(watchExpressions, function(expr, i) {
	          var unwatchFn = self.$watch(expr, function watchGroupSubAction(value, oldValue) {
	            newValues[i] = value;
	            oldValues[i] = oldValue;
	            if (!changeReactionScheduled) {
	              changeReactionScheduled = true;
	              self.$evalAsync(watchGroupAction);
	            }
	          });
	          deregisterFns.push(unwatchFn);
	        });
	
	        function watchGroupAction() {
	          changeReactionScheduled = false;
	
	          if (firstRun) {
	            firstRun = false;
	            listener(newValues, newValues, self);
	          } else {
	            listener(newValues, oldValues, self);
	          }
	        }
	
	        return function deregisterWatchGroup() {
	          while (deregisterFns.length) {
	            deregisterFns.shift()();
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchCollection
	       * @kind function
	       *
	       * @description
	       * Shallow watches the properties of an object and fires whenever any of the properties change
	       * (for arrays, this implies watching the array items; for object maps, this implies watching
	       * the properties). If a change is detected, the `listener` callback is fired.
	       *
	       * - The `obj` collection is observed via standard $watch operation and is examined on every
	       *   call to $digest() to see if any items have been added, removed, or moved.
	       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
	       *   adding, removing, and moving items belonging to an object or array.
	       *
	       *
	       * # Example
	       * ```js
	          $scope.names = ['igor', 'matias', 'misko', 'james'];
	          $scope.dataCount = 4;
	
	          $scope.$watchCollection('names', function(newNames, oldNames) {
	            $scope.dataCount = newNames.length;
	          });
	
	          expect($scope.dataCount).toEqual(4);
	          $scope.$digest();
	
	          //still at 4 ... no changes
	          expect($scope.dataCount).toEqual(4);
	
	          $scope.names.pop();
	          $scope.$digest();
	
	          //now there's been a change
	          expect($scope.dataCount).toEqual(3);
	       * ```
	       *
	       *
	       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
	       *    expression value should evaluate to an object or an array which is observed on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
	       *    collection will trigger a call to the `listener`.
	       *
	       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
	       *    when a change is detected.
	       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
	       *    - The `oldCollection` object is a copy of the former collection data.
	       *      Due to performance considerations, the`oldCollection` value is computed only if the
	       *      `listener` function declares two or more arguments.
	       *    - The `scope` argument refers to the current scope.
	       *
	       * @returns {function()} Returns a de-registration function for this listener. When the
	       *    de-registration function is executed, the internal watch operation is terminated.
	       */
	      $watchCollection: function(obj, listener) {
	        $watchCollectionInterceptor.$stateful = true;
	
	        var self = this;
	        // the current value, updated on each dirty-check run
	        var newValue;
	        // a shallow copy of the newValue from the last dirty-check run,
	        // updated to match newValue during dirty-check run
	        var oldValue;
	        // a shallow copy of the newValue from when the last change happened
	        var veryOldValue;
	        // only track veryOldValue if the listener is asking for it
	        var trackVeryOldValue = (listener.length > 1);
	        var changeDetected = 0;
	        var changeDetector = $parse(obj, $watchCollectionInterceptor);
	        var internalArray = [];
	        var internalObject = {};
	        var initRun = true;
	        var oldLength = 0;
	
	        function $watchCollectionInterceptor(_value) {
	          newValue = _value;
	          var newLength, key, bothNaN, newItem, oldItem;
	
	          // If the new value is undefined, then return undefined as the watch may be a one-time watch
	          if (isUndefined(newValue)) return;
	
	          if (!isObject(newValue)) { // if primitive
	            if (oldValue !== newValue) {
	              oldValue = newValue;
	              changeDetected++;
	            }
	          } else if (isArrayLike(newValue)) {
	            if (oldValue !== internalArray) {
	              // we are transitioning from something which was not an array into array.
	              oldValue = internalArray;
	              oldLength = oldValue.length = 0;
	              changeDetected++;
	            }
	
	            newLength = newValue.length;
	
	            if (oldLength !== newLength) {
	              // if lengths do not match we need to trigger change notification
	              changeDetected++;
	              oldValue.length = oldLength = newLength;
	            }
	            // copy the items to oldValue and look for changes.
	            for (var i = 0; i < newLength; i++) {
	              oldItem = oldValue[i];
	              newItem = newValue[i];
	
	              // eslint-disable-next-line no-self-compare
	              bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	              if (!bothNaN && (oldItem !== newItem)) {
	                changeDetected++;
	                oldValue[i] = newItem;
	              }
	            }
	          } else {
	            if (oldValue !== internalObject) {
	              // we are transitioning from something which was not an object into object.
	              oldValue = internalObject = {};
	              oldLength = 0;
	              changeDetected++;
	            }
	            // copy the items to oldValue and look for changes.
	            newLength = 0;
	            for (key in newValue) {
	              if (hasOwnProperty.call(newValue, key)) {
	                newLength++;
	                newItem = newValue[key];
	                oldItem = oldValue[key];
	
	                if (key in oldValue) {
	                  // eslint-disable-next-line no-self-compare
	                  bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	                  if (!bothNaN && (oldItem !== newItem)) {
	                    changeDetected++;
	                    oldValue[key] = newItem;
	                  }
	                } else {
	                  oldLength++;
	                  oldValue[key] = newItem;
	                  changeDetected++;
	                }
	              }
	            }
	            if (oldLength > newLength) {
	              // we used to have more keys, need to find them and destroy them.
	              changeDetected++;
	              for (key in oldValue) {
	                if (!hasOwnProperty.call(newValue, key)) {
	                  oldLength--;
	                  delete oldValue[key];
	                }
	              }
	            }
	          }
	          return changeDetected;
	        }
	
	        function $watchCollectionAction() {
	          if (initRun) {
	            initRun = false;
	            listener(newValue, newValue, self);
	          } else {
	            listener(newValue, veryOldValue, self);
	          }
	
	          // make a copy for the next time a collection is changed
	          if (trackVeryOldValue) {
	            if (!isObject(newValue)) {
	              //primitive
	              veryOldValue = newValue;
	            } else if (isArrayLike(newValue)) {
	              veryOldValue = new Array(newValue.length);
	              for (var i = 0; i < newValue.length; i++) {
	                veryOldValue[i] = newValue[i];
	              }
	            } else { // if object
	              veryOldValue = {};
	              for (var key in newValue) {
	                if (hasOwnProperty.call(newValue, key)) {
	                  veryOldValue[key] = newValue[key];
	                }
	              }
	            }
	          }
	        }
	
	        return this.$watch(changeDetector, $watchCollectionAction);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$digest
	       * @kind function
	       *
	       * @description
	       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
	       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
	       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
	       * until no more listeners are firing. This means that it is possible to get into an infinite
	       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
	       * iterations exceeds 10.
	       *
	       * Usually, you don't call `$digest()` directly in
	       * {@link ng.directive:ngController controllers} or in
	       * {@link ng.$compileProvider#directive directives}.
	       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
	       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
	       *
	       * If you want to be notified whenever `$digest()` is called,
	       * you can register a `watchExpression` function with
	       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
	       *
	       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
	       *
	       * # Example
	       * ```js
	           var scope = ...;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	       * ```
	       *
	       */
	      $digest: function() {
	        var watch, value, last, fn, get,
	            watchers,
	            dirty, ttl = TTL,
	            next, current, target = this,
	            watchLog = [],
	            logIdx, asyncTask;
	
	        beginPhase('$digest');
	        // Check for changes to browser url that happened in sync before the call to $digest
	        $browser.$$checkUrlChange();
	
	        if (this === $rootScope && applyAsyncId !== null) {
	          // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
	          // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
	          $browser.defer.cancel(applyAsyncId);
	          flushApplyAsync();
	        }
	
	        lastDirtyWatch = null;
	
	        do { // "while dirty" loop
	          dirty = false;
	          current = target;
	
	          // It's safe for asyncQueuePosition to be a local variable here because this loop can't
	          // be reentered recursively. Calling $digest from a function passed to $evalAsync would
	          // lead to a '$digest already in progress' error.
	          for (var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++) {
	            try {
	              asyncTask = asyncQueue[asyncQueuePosition];
	              fn = asyncTask.fn;
	              fn(asyncTask.scope, asyncTask.locals);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	            lastDirtyWatch = null;
	          }
	          asyncQueue.length = 0;
	
	          traverseScopesLoop:
	          do { // "traverse the scopes" loop
	            if ((watchers = current.$$watchers)) {
	              // process our watches
	              watchers.$$digestWatchIndex = watchers.length;
	              while (watchers.$$digestWatchIndex--) {
	                try {
	                  watch = watchers[watchers.$$digestWatchIndex];
	                  // Most common watches are on primitives, in which case we can short
	                  // circuit it with === operator, only when === fails do we use .equals
	                  if (watch) {
	                    get = watch.get;
	                    if ((value = get(current)) !== (last = watch.last) &&
	                        !(watch.eq
	                            ? equals(value, last)
	                            : (isNumberNaN(value) && isNumberNaN(last)))) {
	                      dirty = true;
	                      lastDirtyWatch = watch;
	                      watch.last = watch.eq ? copy(value, null) : value;
	                      fn = watch.fn;
	                      fn(value, ((last === initWatchVal) ? value : last), current);
	                      if (ttl < 5) {
	                        logIdx = 4 - ttl;
	                        if (!watchLog[logIdx]) watchLog[logIdx] = [];
	                        watchLog[logIdx].push({
	                          msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
	                          newVal: value,
	                          oldVal: last
	                        });
	                      }
	                    } else if (watch === lastDirtyWatch) {
	                      // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
	                      // have already been tested.
	                      dirty = false;
	                      break traverseScopesLoop;
	                    }
	                  }
	                } catch (e) {
	                  $exceptionHandler(e);
	                }
	              }
	            }
	
	            // Insanity Warning: scope depth-first traversal
	            // yes, this code is a bit crazy, but it works and we have tests to prove it!
	            // this piece should be kept in sync with the traversal in $broadcast
	            if (!(next = ((current.$$watchersCount && current.$$childHead) ||
	                (current !== target && current.$$nextSibling)))) {
	              while (current !== target && !(next = current.$$nextSibling)) {
	                current = current.$parent;
	              }
	            }
	          } while ((current = next));
	
	          // `break traverseScopesLoop;` takes us to here
	
	          if ((dirty || asyncQueue.length) && !(ttl--)) {
	            clearPhase();
	            throw $rootScopeMinErr('infdig',
	                '{0} $digest() iterations reached. Aborting!\n' +
	                'Watchers fired in the last 5 iterations: {1}',
	                TTL, watchLog);
	          }
	
	        } while (dirty || asyncQueue.length);
	
	        clearPhase();
	
	        // postDigestQueuePosition isn't local here because this loop can be reentered recursively.
	        while (postDigestQueuePosition < postDigestQueue.length) {
	          try {
	            postDigestQueue[postDigestQueuePosition++]();
	          } catch (e) {
	            $exceptionHandler(e);
	          }
	        }
	        postDigestQueue.length = postDigestQueuePosition = 0;
	
	        // Check for changes to browser url that happened during the $digest
	        // (for which no event is fired; e.g. via `history.pushState()`)
	        $browser.$$checkUrlChange();
	      },
	
	
	      /**
	       * @ngdoc event
	       * @name $rootScope.Scope#$destroy
	       * @eventType broadcast on scope being destroyed
	       *
	       * @description
	       * Broadcasted when a scope and its children are being destroyed.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$destroy
	       * @kind function
	       *
	       * @description
	       * Removes the current scope (and all of its children) from the parent scope. Removal implies
	       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
	       * propagate to the current scope and its children. Removal also implies that the current
	       * scope is eligible for garbage collection.
	       *
	       * The `$destroy()` is usually used by directives such as
	       * {@link ng.directive:ngRepeat ngRepeat} for managing the
	       * unrolling of the loop.
	       *
	       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
	       * Application code can register a `$destroy` event handler that will give it a chance to
	       * perform any necessary cleanup.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	      $destroy: function() {
	        // We can't destroy a scope that has been already destroyed.
	        if (this.$$destroyed) return;
	        var parent = this.$parent;
	
	        this.$broadcast('$destroy');
	        this.$$destroyed = true;
	
	        if (this === $rootScope) {
	          //Remove handlers attached to window when $rootScope is removed
	          $browser.$$applicationDestroyed();
	        }
	
	        incrementWatchersCount(this, -this.$$watchersCount);
	        for (var eventName in this.$$listenerCount) {
	          decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
	        }
	
	        // sever all the references to parent scopes (after this cleanup, the current scope should
	        // not be retained by any of our references and should be eligible for garbage collection)
	        if (parent && parent.$$childHead === this) parent.$$childHead = this.$$nextSibling;
	        if (parent && parent.$$childTail === this) parent.$$childTail = this.$$prevSibling;
	        if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
	        if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;
	
	        // Disable listeners, watchers and apply/digest methods
	        this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
	        this.$on = this.$watch = this.$watchGroup = function() { return noop; };
	        this.$$listeners = {};
	
	        // Disconnect the next sibling to prevent `cleanUpScope` destroying those too
	        this.$$nextSibling = null;
	        cleanUpScope(this);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$eval
	       * @kind function
	       *
	       * @description
	       * Executes the `expression` on the current scope and returns the result. Any exceptions in
	       * the expression are propagated (uncaught). This is useful when evaluating Angular
	       * expressions.
	       *
	       * # Example
	       * ```js
	           var scope = ng.$rootScope.Scope();
	           scope.a = 1;
	           scope.b = 2;
	
	           expect(scope.$eval('a+b')).toEqual(3);
	           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
	       * ```
	       *
	       * @param {(string|function())=} expression An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       * @returns {*} The result of evaluating the expression.
	       */
	      $eval: function(expr, locals) {
	        return $parse(expr)(this, locals);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$evalAsync
	       * @kind function
	       *
	       * @description
	       * Executes the expression on the current scope at a later point in time.
	       *
	       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
	       * that:
	       *
	       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
	       *     rendering).
	       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
	       *     `expression` execution.
	       *
	       * Any exceptions from the execution of the expression are forwarded to the
	       * {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
	       * will be scheduled. However, it is encouraged to always call code that changes the model
	       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
	       *
	       * @param {(string|function())=} expression An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       */
	      $evalAsync: function(expr, locals) {
	        // if we are outside of an $digest loop and this is the first time we are scheduling async
	        // task also schedule async auto-flush
	        if (!$rootScope.$$phase && !asyncQueue.length) {
	          $browser.defer(function() {
	            if (asyncQueue.length) {
	              $rootScope.$digest();
	            }
	          });
	        }
	
	        asyncQueue.push({scope: this, fn: $parse(expr), locals: locals});
	      },
	
	      $$postDigest: function(fn) {
	        postDigestQueue.push(fn);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$apply
	       * @kind function
	       *
	       * @description
	       * `$apply()` is used to execute an expression in angular from outside of the angular
	       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
	       * Because we are calling into the angular framework we need to perform proper scope life
	       * cycle of {@link ng.$exceptionHandler exception handling},
	       * {@link ng.$rootScope.Scope#$digest executing watches}.
	       *
	       * ## Life cycle
	       *
	       * # Pseudo-Code of `$apply()`
	       * ```js
	           function $apply(expr) {
	             try {
	               return $eval(expr);
	             } catch (e) {
	               $exceptionHandler(e);
	             } finally {
	               $root.$digest();
	             }
	           }
	       * ```
	       *
	       *
	       * Scope's `$apply()` method transitions through the following stages:
	       *
	       * 1. The {@link guide/expression expression} is executed using the
	       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
	       * 2. Any exceptions from the execution of the expression are forwarded to the
	       *    {@link ng.$exceptionHandler $exceptionHandler} service.
	       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
	       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
	       *
	       *
	       * @param {(string|function())=} exp An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       *
	       * @returns {*} The result of evaluating the expression.
	       */
	      $apply: function(expr) {
	        try {
	          beginPhase('$apply');
	          try {
	            return this.$eval(expr);
	          } finally {
	            clearPhase();
	          }
	        } catch (e) {
	          $exceptionHandler(e);
	        } finally {
	          try {
	            $rootScope.$digest();
	          } catch (e) {
	            $exceptionHandler(e);
	            // eslint-disable-next-line no-unsafe-finally
	            throw e;
	          }
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$applyAsync
	       * @kind function
	       *
	       * @description
	       * Schedule the invocation of $apply to occur at a later time. The actual time difference
	       * varies across browsers, but is typically around ~10 milliseconds.
	       *
	       * This can be used to queue up multiple expressions which need to be evaluated in the same
	       * digest.
	       *
	       * @param {(string|function())=} exp An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       */
	      $applyAsync: function(expr) {
	        var scope = this;
	        if (expr) {
	          applyAsyncQueue.push($applyAsyncExpression);
	        }
	        expr = $parse(expr);
	        scheduleApplyAsync();
	
	        function $applyAsyncExpression() {
	          scope.$eval(expr);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$on
	       * @kind function
	       *
	       * @description
	       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
	       * discussion of event life cycle.
	       *
	       * The event listener function format is: `function(event, args...)`. The `event` object
	       * passed into the listener has the following attributes:
	       *
	       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
	       *     `$broadcast`-ed.
	       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
	       *     event propagates through the scope hierarchy, this property is set to null.
	       *   - `name` - `{string}`: name of the event.
	       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
	       *     further event propagation (available only for events that were `$emit`-ed).
	       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
	       *     to true.
	       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
	       *
	       * @param {string} name Event name to listen on.
	       * @param {function(event, ...args)} listener Function to call when the event is emitted.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $on: function(name, listener) {
	        var namedListeners = this.$$listeners[name];
	        if (!namedListeners) {
	          this.$$listeners[name] = namedListeners = [];
	        }
	        namedListeners.push(listener);
	
	        var current = this;
	        do {
	          if (!current.$$listenerCount[name]) {
	            current.$$listenerCount[name] = 0;
	          }
	          current.$$listenerCount[name]++;
	        } while ((current = current.$parent));
	
	        var self = this;
	        return function() {
	          var indexOfListener = namedListeners.indexOf(listener);
	          if (indexOfListener !== -1) {
	            namedListeners[indexOfListener] = null;
	            decrementListenerCount(self, 1, name);
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$emit
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` upwards through the scope hierarchy notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$emit` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
	       * registered listeners along the way. The event will stop propagating if one of the listeners
	       * cancels it.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to emit.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
	       */
	      $emit: function(name, args) {
	        var empty = [],
	            namedListeners,
	            scope = this,
	            stopPropagation = false,
	            event = {
	              name: name,
	              targetScope: scope,
	              stopPropagation: function() {stopPropagation = true;},
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            },
	            listenerArgs = concat([event], arguments, 1),
	            i, length;
	
	        do {
	          namedListeners = scope.$$listeners[name] || empty;
	          event.currentScope = scope;
	          for (i = 0, length = namedListeners.length; i < length; i++) {
	
	            // if listeners were deregistered, defragment the array
	            if (!namedListeners[i]) {
	              namedListeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	            try {
	              //allow all listeners attached to the current scope to run
	              namedListeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          //if any listener on the current scope stops propagation, prevent bubbling
	          if (stopPropagation) {
	            event.currentScope = null;
	            return event;
	          }
	          //traverse upwards
	          scope = scope.$parent;
	        } while (scope);
	
	        event.currentScope = null;
	
	        return event;
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$broadcast
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$broadcast` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
	       * scope and calls all registered listeners along the way. The event cannot be canceled.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to broadcast.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
	       */
	      $broadcast: function(name, args) {
	        var target = this,
	            current = target,
	            next = target,
	            event = {
	              name: name,
	              targetScope: target,
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            };
	
	        if (!target.$$listenerCount[name]) return event;
	
	        var listenerArgs = concat([event], arguments, 1),
	            listeners, i, length;
	
	        //down while you can, then up and next sibling or up and next sibling until back at root
	        while ((current = next)) {
	          event.currentScope = current;
	          listeners = current.$$listeners[name] || [];
	          for (i = 0, length = listeners.length; i < length; i++) {
	            // if listeners were deregistered, defragment the array
	            if (!listeners[i]) {
	              listeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	
	            try {
	              listeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	
	          // Insanity Warning: scope depth-first traversal
	          // yes, this code is a bit crazy, but it works and we have tests to prove it!
	          // this piece should be kept in sync with the traversal in $digest
	          // (though it differs due to having the extra check for $$listenerCount)
	          if (!(next = ((current.$$listenerCount[name] && current.$$childHead) ||
	              (current !== target && current.$$nextSibling)))) {
	            while (current !== target && !(next = current.$$nextSibling)) {
	              current = current.$parent;
	            }
	          }
	        }
	
	        event.currentScope = null;
	        return event;
	      }
	    };
	
	    var $rootScope = new Scope();
	
	    //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
	    var asyncQueue = $rootScope.$$asyncQueue = [];
	    var postDigestQueue = $rootScope.$$postDigestQueue = [];
	    var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];
	
	    var postDigestQueuePosition = 0;
	
	    return $rootScope;
	
	
	    function beginPhase(phase) {
	      if ($rootScope.$$phase) {
	        throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
	      }
	
	      $rootScope.$$phase = phase;
	    }
	
	    function clearPhase() {
	      $rootScope.$$phase = null;
	    }
	
	    function incrementWatchersCount(current, count) {
	      do {
	        current.$$watchersCount += count;
	      } while ((current = current.$parent));
	    }
	
	    function decrementListenerCount(current, count, name) {
	      do {
	        current.$$listenerCount[name] -= count;
	
	        if (current.$$listenerCount[name] === 0) {
	          delete current.$$listenerCount[name];
	        }
	      } while ((current = current.$parent));
	    }
	
	    /**
	     * function used as an initial value for watchers.
	     * because it's unique we can easily tell it apart from other values
	     */
	    function initWatchVal() {}
	
	    function flushApplyAsync() {
	      while (applyAsyncQueue.length) {
	        try {
	          applyAsyncQueue.shift()();
	        } catch (e) {
	          $exceptionHandler(e);
	        }
	      }
	      applyAsyncId = null;
	    }
	
	    function scheduleApplyAsync() {
	      if (applyAsyncId === null) {
	        applyAsyncId = $browser.defer(function() {
	          $rootScope.$apply(flushApplyAsync);
	        });
	      }
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $rootElement
	 *
	 * @description
	 * The root element of Angular application. This is either the element where {@link
	 * ng.directive:ngApp ngApp} was declared or the element passed into
	 * {@link angular.bootstrap}. The element represents the root element of application. It is also the
	 * location where the application's {@link auto.$injector $injector} service gets
	 * published, and can be retrieved using `$rootElement.injector()`.
	 */
	
	
	// the implementation is in angular.bootstrap
	
	/**
	 * @this
	 * @description
	 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
	 */
	function $$SanitizeUriProvider() {
	  var aHrefSanitizationWhitelist = /^\s*(https?|ftp|mailto|tel|file):/,
	    imgSrcSanitizationWhitelist = /^\s*((https?|ftp|file|blob):|data:image\/)/;
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      aHrefSanitizationWhitelist = regexp;
	      return this;
	    }
	    return aHrefSanitizationWhitelist;
	  };
	
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      imgSrcSanitizationWhitelist = regexp;
	      return this;
	    }
	    return imgSrcSanitizationWhitelist;
	  };
	
	  this.$get = function() {
	    return function sanitizeUri(uri, isImage) {
	      var regex = isImage ? imgSrcSanitizationWhitelist : aHrefSanitizationWhitelist;
	      var normalizedVal;
	      normalizedVal = urlResolve(uri).href;
	      if (normalizedVal !== '' && !normalizedVal.match(regex)) {
	        return 'unsafe:' + normalizedVal;
	      }
	      return uri;
	    };
	  };
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* exported $SceProvider, $SceDelegateProvider */
	
	var $sceMinErr = minErr('$sce');
	
	var SCE_CONTEXTS = {
	  // HTML is used when there's HTML rendered (e.g. ng-bind-html, iframe srcdoc binding).
	  HTML: 'html',
	
	  // Style statements or stylesheets. Currently unused in AngularJS.
	  CSS: 'css',
	
	  // An URL used in a context where it does not refer to a resource that loads code. Currently
	  // unused in AngularJS.
	  URL: 'url',
	
	  // RESOURCE_URL is a subtype of URL used where the referred-to resource could be interpreted as
	  // code. (e.g. ng-include, script src binding, templateUrl)
	  RESOURCE_URL: 'resourceUrl',
	
	  // Script. Currently unused in AngularJS.
	  JS: 'js'
	};
	
	// Helper functions follow.
	
	var UNDERSCORE_LOWERCASE_REGEXP = /_([a-z])/g;
	
	function snakeToCamel(name) {
	  return name
	    .replace(UNDERSCORE_LOWERCASE_REGEXP, fnCamelCaseReplace);
	}
	
	function adjustMatcher(matcher) {
	  if (matcher === 'self') {
	    return matcher;
	  } else if (isString(matcher)) {
	    // Strings match exactly except for 2 wildcards - '*' and '**'.
	    // '*' matches any character except those from the set ':/.?&'.
	    // '**' matches any character (like .* in a RegExp).
	    // More than 2 *'s raises an error as it's ill defined.
	    if (matcher.indexOf('***') > -1) {
	      throw $sceMinErr('iwcard',
	          'Illegal sequence *** in string matcher.  String: {0}', matcher);
	    }
	    matcher = escapeForRegexp(matcher).
	                  replace(/\\\*\\\*/g, '.*').
	                  replace(/\\\*/g, '[^:/.?&;]*');
	    return new RegExp('^' + matcher + '$');
	  } else if (isRegExp(matcher)) {
	    // The only other type of matcher allowed is a Regexp.
	    // Match entire URL / disallow partial matches.
	    // Flags are reset (i.e. no global, ignoreCase or multiline)
	    return new RegExp('^' + matcher.source + '$');
	  } else {
	    throw $sceMinErr('imatcher',
	        'Matchers may only be "self", string patterns or RegExp objects');
	  }
	}
	
	
	function adjustMatchers(matchers) {
	  var adjustedMatchers = [];
	  if (isDefined(matchers)) {
	    forEach(matchers, function(matcher) {
	      adjustedMatchers.push(adjustMatcher(matcher));
	    });
	  }
	  return adjustedMatchers;
	}
	
	
	/**
	 * @ngdoc service
	 * @name $sceDelegate
	 * @kind function
	 *
	 * @description
	 *
	 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
	 * Contextual Escaping (SCE)} services to AngularJS.
	 *
	 * For an overview of this service and the functionnality it provides in AngularJS, see the main
	 * page for {@link ng.$sce SCE}. The current page is targeted for developers who need to alter how
	 * SCE works in their application, which shouldn't be needed in most cases.
	 *
	 * <div class="alert alert-danger">
	 * AngularJS strongly relies on contextual escaping for the security of bindings: disabling or
	 * modifying this might cause cross site scripting (XSS) vulnerabilities. For libraries owners,
	 * changes to this service will also influence users, so be extra careful and document your changes.
	 * </div>
	 *
	 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
	 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
	 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
	 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
	 * work because `$sce` delegates to `$sceDelegate` for these operations.
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
	 *
	 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
	 * can override it completely to change the behavior of `$sce`, the common case would
	 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
	 * your own whitelists and blacklists for trusting URLs used for loading AngularJS resources such as
	 * templates.  Refer {@link ng.$sceDelegateProvider#resourceUrlWhitelist
	 * $sceDelegateProvider.resourceUrlWhitelist} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $sceDelegateProvider
	 * @this
	 *
	 * @description
	 *
	 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
	 * $sceDelegate service}, used as a delegate for {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 *
	 * The `$sceDelegateProvider` allows one to get/set the whitelists and blacklists used to ensure
	 * that the URLs used for sourcing AngularJS templates and other script-running URLs are safe (all
	 * places that use the `$sce.RESOURCE_URL` context). See
	 * {@link ng.$sceDelegateProvider#resourceUrlWhitelist $sceDelegateProvider.resourceUrlWhitelist}
	 * and
	 * {@link ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist},
	 *
	 * For the general details about this service in Angular, read the main page for {@link ng.$sce
	 * Strict Contextual Escaping (SCE)}.
	 *
	 * **Example**:  Consider the following case. <a name="example"></a>
	 *
	 * - your app is hosted at url `http://myapp.example.com/`
	 * - but some of your templates are hosted on other domains you control such as
	 *   `http://srv01.assets.example.com/`, `http://srv02.assets.example.com/`, etc.
	 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
	 *
	 * Here is what a secure configuration for this scenario might look like:
	 *
	 * ```
	 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
	 *    $sceDelegateProvider.resourceUrlWhitelist([
	 *      // Allow same origin resource loads.
	 *      'self',
	 *      // Allow loading from our assets domain.  Notice the difference between * and **.
	 *      'http://srv*.assets.example.com/**'
	 *    ]);
	 *
	 *    // The blacklist overrides the whitelist so the open redirect here is blocked.
	 *    $sceDelegateProvider.resourceUrlBlacklist([
	 *      'http://myapp.example.com/clickThru**'
	 *    ]);
	 *  });
	 * ```
	 * Note that an empty whitelist will block every resource URL from being loaded, and will require
	 * you to manually mark each one as trusted with `$sce.trustAsResourceUrl`. However, templates
	 * requested by {@link ng.$templateRequest $templateRequest} that are present in
	 * {@link ng.$templateCache $templateCache} will not go through this check. If you have a mechanism
	 * to populate your templates in that cache at config time, then it is a good idea to remove 'self'
	 * from that whitelist. This helps to mitigate the security impact of certain types of issues, like
	 * for instance attacker-controlled `ng-includes`.
	 */
	
	function $SceDelegateProvider() {
	  this.SCE_CONTEXTS = SCE_CONTEXTS;
	
	  // Resource URLs can also be trusted by policy.
	  var resourceUrlWhitelist = ['self'],
	      resourceUrlBlacklist = [];
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlWhitelist
	   * @kind function
	   *
	   * @param {Array=} whitelist When provided, replaces the resourceUrlWhitelist with the value
	   *     provided.  This must be an array or null.  A snapshot of this array is used so further
	   *     changes to the array are ignored.
	   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *     allowed in this array.
	   *
	   * @return {Array} The currently set whitelist array.
	   *
	   * @description
	   * Sets/Gets the whitelist of trusted resource URLs.
	   *
	   * The **default value** when no whitelist has been explicitly set is `['self']` allowing only
	   * same origin resource requests.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** the default whitelist of 'self' is not recommended if your app shares its origin
	   * with other apps! It is a good idea to limit it to only your application's directory.
	   * </div>
	   */
	  this.resourceUrlWhitelist = function(value) {
	    if (arguments.length) {
	      resourceUrlWhitelist = adjustMatchers(value);
	    }
	    return resourceUrlWhitelist;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlBlacklist
	   * @kind function
	   *
	   * @param {Array=} blacklist When provided, replaces the resourceUrlBlacklist with the value
	   *     provided.  This must be an array or null.  A snapshot of this array is used so further
	   *     changes to the array are ignored.</p><p>
	   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *     allowed in this array.</p><p>
	   *     The typical usage for the blacklist is to **block
	   *     [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
	   *     these would otherwise be trusted but actually return content from the redirected domain.
	   *     </p><p>
	   *     Finally, **the blacklist overrides the whitelist** and has the final say.
	   *
	   * @return {Array} The currently set blacklist array.
	   *
	   * @description
	   * Sets/Gets the blacklist of trusted resource URLs.
	   *
	   * The **default value** when no whitelist has been explicitly set is the empty array (i.e. there
	   * is no blacklist.)
	   */
	
	  this.resourceUrlBlacklist = function(value) {
	    if (arguments.length) {
	      resourceUrlBlacklist = adjustMatchers(value);
	    }
	    return resourceUrlBlacklist;
	  };
	
	  this.$get = ['$injector', function($injector) {
	
	    var htmlSanitizer = function htmlSanitizer(html) {
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    };
	
	    if ($injector.has('$sanitize')) {
	      htmlSanitizer = $injector.get('$sanitize');
	    }
	
	
	    function matchUrl(matcher, parsedUrl) {
	      if (matcher === 'self') {
	        return urlIsSameOrigin(parsedUrl);
	      } else {
	        // definitely a regex.  See adjustMatchers()
	        return !!matcher.exec(parsedUrl.href);
	      }
	    }
	
	    function isResourceUrlAllowedByPolicy(url) {
	      var parsedUrl = urlResolve(url.toString());
	      var i, n, allowed = false;
	      // Ensure that at least one item from the whitelist allows this url.
	      for (i = 0, n = resourceUrlWhitelist.length; i < n; i++) {
	        if (matchUrl(resourceUrlWhitelist[i], parsedUrl)) {
	          allowed = true;
	          break;
	        }
	      }
	      if (allowed) {
	        // Ensure that no item from the blacklist blocked this url.
	        for (i = 0, n = resourceUrlBlacklist.length; i < n; i++) {
	          if (matchUrl(resourceUrlBlacklist[i], parsedUrl)) {
	            allowed = false;
	            break;
	          }
	        }
	      }
	      return allowed;
	    }
	
	    function generateHolderType(Base) {
	      var holderType = function TrustedValueHolderType(trustedValue) {
	        this.$$unwrapTrustedValue = function() {
	          return trustedValue;
	        };
	      };
	      if (Base) {
	        holderType.prototype = new Base();
	      }
	      holderType.prototype.valueOf = function sceValueOf() {
	        return this.$$unwrapTrustedValue();
	      };
	      holderType.prototype.toString = function sceToString() {
	        return this.$$unwrapTrustedValue().toString();
	      };
	      return holderType;
	    }
	
	    var trustedValueHolderBase = generateHolderType(),
	        byType = {};
	
	    byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.URL] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#trustAs
	     *
	     * @description
	     * Returns a trusted representation of the parameter for the specified context. This trusted
	     * object will later on be used as-is, without any security check, by bindings or directives
	     * that require this security context.
	     * For instance, marking a string as trusted for the `$sce.HTML` context will entirely bypass
	     * the potential `$sanitize` call in corresponding `$sce.HTML` bindings or directives, such as
	     * `ng-bind-html`. Note that in most cases you won't need to call this function: if you have the
	     * sanitizer loaded, passing the value itself will render all the HTML that does not pose a
	     * security risk.
	     *
	     * See {@link ng.$sceDelegate#getTrusted getTrusted} for the function that will consume those
	     * trusted values, and {@link ng.$sce $sce} for general documentation about strict contextual
	     * escaping.
	     *
	     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
	     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
	     *
	     * @param {*} value The value that should be considered trusted.
	     * @return {*} A trusted representation of value, that can be used in the given context.
	     */
	    function trustAs(type, trustedValue) {
	      var Constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      if (!Constructor) {
	        throw $sceMinErr('icontext',
	            'Attempted to trust a value in invalid context. Context: {0}; Value: {1}',
	            type, trustedValue);
	      }
	      if (trustedValue === null || isUndefined(trustedValue) || trustedValue === '') {
	        return trustedValue;
	      }
	      // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
	      // mutable objects, we ensure here that the value passed in is actually a string.
	      if (typeof trustedValue !== 'string') {
	        throw $sceMinErr('itype',
	            'Attempted to trust a non-string value in a content requiring a string: Context: {0}',
	            type);
	      }
	      return new Constructor(trustedValue);
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#valueOf
	     *
	     * @description
	     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
	     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
	     *
	     * If the passed parameter is not a value that had been returned by {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, it must be returned as-is.
	     *
	     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
	     *     call or anything else.
	     * @return {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
	     *     `value` unchanged.
	     */
	    function valueOf(maybeTrusted) {
	      if (maybeTrusted instanceof trustedValueHolderBase) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      } else {
	        return maybeTrusted;
	      }
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#getTrusted
	     *
	     * @description
	     * Takes any input, and either returns a value that's safe to use in the specified context, or
	     * throws an exception.
	     *
	     * In practice, there are several cases. When given a string, this function runs checks
	     * and sanitization to make it safe without prior assumptions. When given the result of a {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`} call, it returns the originally supplied
	     * value if that value's context is valid for this call's context. Finally, this function can
	     * also throw when there is no way to turn `maybeTrusted` in a safe value (e.g., no sanitization
	     * is available or possible.)
	     *
	     * @param {string} type The context in which this value is to be used (such as `$sce.HTML`).
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} call, or anything else (which will not be considered trusted.)
	     * @return {*} A version of the value that's safe to use in the given context, or throws an
	     *     exception if this is impossible.
	     */
	    function getTrusted(type, maybeTrusted) {
	      if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === '') {
	        return maybeTrusted;
	      }
	      var constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      // If maybeTrusted is a trusted class instance or subclass instance, then unwrap and return
	      // as-is.
	      if (constructor && maybeTrusted instanceof constructor) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      }
	      // Otherwise, if we get here, then we may either make it safe, or throw an exception. This
	      // depends on the context: some are sanitizatible (HTML), some use whitelists (RESOURCE_URL),
	      // some are impossible to do (JS). This step isn't implemented for CSS and URL, as AngularJS
	      // has no corresponding sinks.
	      if (type === SCE_CONTEXTS.RESOURCE_URL) {
	        // RESOURCE_URL uses a whitelist.
	        if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
	          return maybeTrusted;
	        } else {
	          throw $sceMinErr('insecurl',
	              'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}',
	              maybeTrusted.toString());
	        }
	      } else if (type === SCE_CONTEXTS.HTML) {
	        // htmlSanitizer throws its own error when no sanitizer is available.
	        return htmlSanitizer(maybeTrusted);
	      }
	      // Default error when the $sce service has no way to make the input safe.
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    }
	
	    return { trustAs: trustAs,
	             getTrusted: getTrusted,
	             valueOf: valueOf };
	  }];
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $sceProvider
	 * @this
	 *
	 * @description
	 *
	 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
	 * -   enable/disable Strict Contextual Escaping (SCE) in a module
	 * -   override the default implementation with a custom delegate
	 *
	 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 */
	
	/**
	 * @ngdoc service
	 * @name $sce
	 * @kind function
	 *
	 * @description
	 *
	 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
	 *
	 * # Strict Contextual Escaping
	 *
	 * Strict Contextual Escaping (SCE) is a mode in which AngularJS constrains bindings to only render
	 * trusted values. Its goal is to assist in writing code in a way that (a) is secure by default, and
	 * (b) makes auditing for security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
	 *
	 * ## Overview
	 *
	 * To systematically block XSS security bugs, AngularJS treats all values as untrusted by default in
	 * HTML or sensitive URL bindings. When binding untrusted values, AngularJS will automatically
	 * run security checks on them (sanitizations, whitelists, depending on context), or throw when it
	 * cannot guarantee the security of the result. That behavior depends strongly on contexts: HTML
	 * can be sanitized, but template URLs cannot, for instance.
	 *
	 * To illustrate this, consider the `ng-bind-html` directive. It renders its value directly as HTML:
	 * we call that the *context*. When given an untrusted input, AngularJS will attempt to sanitize it
	 * before rendering if a sanitizer is available, and throw otherwise. To bypass sanitization and
	 * render the input as-is, you will need to mark it as trusted for that context before attempting
	 * to bind it.
	 *
	 * As of version 1.2, AngularJS ships with SCE enabled by default.
	 *
	 * ## In practice
	 *
	 * Here's an example of a binding in a privileged context:
	 *
	 * ```
	 * <input ng-model="userHtml" aria-label="User input">
	 * <div ng-bind-html="userHtml"></div>
	 * ```
	 *
	 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
	 * disabled, this application allows the user to render arbitrary HTML into the DIV, which would
	 * be an XSS security bug. In a more realistic example, one may be rendering user comments, blog
	 * articles, etc. via bindings. (HTML is just one example of a context where rendering user
	 * controlled input creates security vulnerabilities.)
	 *
	 * For the case of HTML, you might use a library, either on the client side, or on the server side,
	 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
	 *
	 * How would you ensure that every place that used these types of bindings was bound to a value that
	 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
	 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
	 * properties/fields and forgot to update the binding to the sanitized value?
	 *
	 * To be secure by default, AngularJS makes sure bindings go through that sanitization, or
	 * any similar validation process, unless there's a good reason to trust the given value in this
	 * context.  That trust is formalized with a function call. This means that as a developer, you
	 * can assume all untrusted bindings are safe. Then, to audit your code for binding security issues,
	 * you just need to ensure the values you mark as trusted indeed are safe - because they were
	 * received from your server, sanitized by your library, etc. You can organize your codebase to
	 * help with this - perhaps allowing only the files in a specific directory to do this.
	 * Ensuring that the internal API exposed by that code doesn't markup arbitrary values as safe then
	 * becomes a more manageable task.
	 *
	 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
	 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
	 * build the trusted versions of your values.
	 *
	 * ## How does it work?
	 *
	 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
	 * $sce.getTrusted(context, value)} rather than to the value directly.  Think of this function as
	 * a way to enforce the required security context in your data sink. Directives use {@link
	 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs
	 * the {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals. Also,
	 * when binding without directives, AngularJS will understand the context of your bindings
	 * automatically.
	 *
	 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
	 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
	 * simplified):
	 *
	 * ```
	 * var ngBindHtmlDirective = ['$sce', function($sce) {
	 *   return function(scope, element, attr) {
	 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
	 *       element.html(value || '');
	 *     });
	 *   };
	 * }];
	 * ```
	 *
	 * ## Impact on loading templates
	 *
	 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
	 * `templateUrl`'s specified by {@link guide/directive directives}.
	 *
	 * By default, Angular only loads templates from the same domain and protocol as the application
	 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
	 * protocols, you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist
	 * them} or {@link ng.$sce#trustAsResourceUrl wrap it} into a trusted value.
	 *
	 * *Please note*:
	 * The browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy apply in addition to this and may further restrict whether the template is successfully
	 * loaded.  This means that without the right CORS policy, loading templates from a different domain
	 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
	 * browsers.
	 *
	 * ## This feels like too much overhead
	 *
	 * It's important to remember that SCE only applies to interpolation expressions.
	 *
	 * If your expressions are constant literals, they're automatically trusted and you don't need to
	 * call `$sce.trustAs` on them (e.g.
	 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works. The `$sceDelegate` will
	 * also use the `$sanitize` service if it is available when binding untrusted values to
	 * `$sce.HTML` context. AngularJS provides an implementation in `angular-sanitize.js`, and if you
	 * wish to use it, you will also need to depend on the {@link ngSanitize `ngSanitize`} module in
	 * your application.
	 *
	 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
	 * templates in `ng-include` from your application's domain without having to even know about SCE.
	 * It blocks loading templates from other domains or loading templates over http from an https
	 * served document.  You can change these by setting your own custom {@link
	 * ng.$sceDelegateProvider#resourceUrlWhitelist whitelists} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist blacklists} for matching such URLs.
	 *
	 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
	 * application that's secure and can be audited to verify that with much more ease than bolting
	 * security onto an application later.
	 *
	 * <a name="contexts"></a>
	 * ## What trusted context types are supported?
	 *
	 * | Context             | Notes          |
	 * |---------------------|----------------|
	 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered, and the {@link ngSanitize.$sanitize $sanitize} service is available (implemented by the {@link ngSanitize ngSanitize} module) this will sanitize the value instead of throwing an error. |
	 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently, no bindings require this context. Feel free to use it in your own directives. |
	 * | `$sce.URL`          | For URLs that are safe to follow as links.  Currently unused (`<a href=`, `<img src=`, and some others sanitize their urls and don't constitute an SCE context.) |
	 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG`, `VIDEO`, `AUDIO`, `SOURCE`, and `TRACK` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` does (it's not just the URL that matters, but also what is at the end of it), and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` are required. |
	 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently, no bindings require this context.  Feel free to use it in your own directives. |
	 *
	 *
	 * Be aware that `a[href]` and `img[src]` automatically sanitize their URLs and do not pass them
	 * through {@link ng.$sce#getTrusted $sce.getTrusted}. There's no CSS-, URL-, or JS-context bindings
	 * in AngularJS currently, so their corresponding `$sce.trustAs` functions aren't useful yet. This
	 * might evolve.
	 *
	 * ## Format of items in {@link ng.$sceDelegateProvider#resourceUrlWhitelist resourceUrlWhitelist}/{@link ng.$sceDelegateProvider#resourceUrlBlacklist Blacklist} <a name="resourceUrlPatternItem"></a>
	 *
	 *  Each element in these arrays must be one of the following:
	 *
	 *  - **'self'**
	 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
	 *      domain** as the application document using the **same protocol**.
	 *  - **String** (except the special value `'self'`)
	 *    - The string is matched against the full *normalized / absolute URL* of the resource
	 *      being tested (substring matches are not good enough.)
	 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
	 *      match themselves.
	 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
	 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
	 *      in a whitelist.
	 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
	 *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
	 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
	 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
	 *      http://foo.example.com/templates/**).
	 *  - **RegExp** (*see caveat below*)
	 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
	 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
	 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
	 *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
	 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
	 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
	 *      is highly recommended to use the string patterns and only fall back to regular expressions
	 *      as a last resort.
	 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
	 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
	 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
	 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
	 *    - If you are generating your JavaScript from some other templating engine (not
	 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
	 *      remember to escape your regular expression (and be aware that you might need more than
	 *      one level of escaping depending on your templating engine and the way you interpolated
	 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
	 *      enough before coding your own.  E.g. Ruby has
	 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
	 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
	 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
	 *      Closure library's [goog.string.regExpEscape(s)](
	 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
	 *
	 * ## Show me an example using SCE.
	 *
	 * <example module="mySceApp" deps="angular-sanitize.js" name="sce-service">
	 * <file name="index.html">
	 *   <div ng-controller="AppController as myCtrl">
	 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
	 *     <b>User comments</b><br>
	 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
	 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
	 *     exploit.
	 *     <div class="well">
	 *       <div ng-repeat="userComment in myCtrl.userComments">
	 *         <b>{{userComment.name}}</b>:
	 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
	 *         <br>
	 *       </div>
	 *     </div>
	 *   </div>
	 * </file>
	 *
	 * <file name="script.js">
	 *   angular.module('mySceApp', ['ngSanitize'])
	 *     .controller('AppController', ['$http', '$templateCache', '$sce',
	 *       function AppController($http, $templateCache, $sce) {
	 *         var self = this;
	 *         $http.get('test_data.json', {cache: $templateCache}).then(function(response) {
	 *           self.userComments = response.data;
	 *         });
	 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
	 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *             'sanitization.&quot;">Hover over this text.</span>');
	 *       }]);
	 * </file>
	 *
	 * <file name="test_data.json">
	 * [
	 *   { "name": "Alice",
	 *     "htmlComment":
	 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
	 *   },
	 *   { "name": "Bob",
	 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
	 *   }
	 * ]
	 * </file>
	 *
	 * <file name="protractor.js" type="protractor">
	 *   describe('SCE doc demo', function() {
	 *     it('should sanitize untrusted values', function() {
	 *       expect(element.all(by.css('.htmlComment')).first().getAttribute('innerHTML'))
	 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
	 *     });
	 *
	 *     it('should NOT sanitize explicitly trusted values', function() {
	 *       expect(element(by.id('explicitlyTrustedHtml')).getAttribute('innerHTML')).toBe(
	 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *           'sanitization.&quot;">Hover over this text.</span>');
	 *     });
	 *   });
	 * </file>
	 * </example>
	 *
	 *
	 *
	 * ## Can I disable SCE completely?
	 *
	 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
	 * for little coding overhead.  It will be much harder to take an SCE disabled application and
	 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
	 * for cases where you have a lot of existing code that was written before SCE was introduced and
	 * you're migrating them a module at a time. Also do note that this is an app-wide setting, so if
	 * you are writing a library, you will cause security bugs applications using it.
	 *
	 * That said, here's how you can completely disable SCE:
	 *
	 * ```
	 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
	 *   // Completely disable SCE.  For demonstration purposes only!
	 *   // Do not use in new projects or libraries.
	 *   $sceProvider.enabled(false);
	 * });
	 * ```
	 *
	 */
	
	function $SceProvider() {
	  var enabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $sceProvider#enabled
	   * @kind function
	   *
	   * @param {boolean=} value If provided, then enables/disables SCE application-wide.
	   * @return {boolean} True if SCE is enabled, false otherwise.
	   *
	   * @description
	   * Enables/disables SCE and returns the current value.
	   */
	  this.enabled = function(value) {
	    if (arguments.length) {
	      enabled = !!value;
	    }
	    return enabled;
	  };
	
	
	  /* Design notes on the default implementation for SCE.
	   *
	   * The API contract for the SCE delegate
	   * -------------------------------------
	   * The SCE delegate object must provide the following 3 methods:
	   *
	   * - trustAs(contextEnum, value)
	   *     This method is used to tell the SCE service that the provided value is OK to use in the
	   *     contexts specified by contextEnum.  It must return an object that will be accepted by
	   *     getTrusted() for a compatible contextEnum and return this value.
	   *
	   * - valueOf(value)
	   *     For values that were not produced by trustAs(), return them as is.  For values that were
	   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
	   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
	   *     such a value.
	   *
	   * - getTrusted(contextEnum, value)
	   *     This function should return the a value that is safe to use in the context specified by
	   *     contextEnum or throw and exception otherwise.
	   *
	   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
	   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
	   * instance, an implementation could maintain a registry of all trusted objects by context.  In
	   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
	   * return the same object passed in if it was found in the registry under a compatible context or
	   * throw an exception otherwise.  An implementation might only wrap values some of the time based
	   * on some criteria.  getTrusted() might return a value and not throw an exception for special
	   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
	   *
	   *
	   * A note on the inheritance model for SCE contexts
	   * ------------------------------------------------
	   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
	   * is purely an implementation details.
	   *
	   * The contract is simply this:
	   *
	   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
	   *     will also succeed.
	   *
	   * Inheritance happens to capture this in a natural way. In some future, we may not use
	   * inheritance anymore. That is OK because no code outside of sce.js and sceSpecs.js would need to
	   * be aware of this detail.
	   */
	
	  this.$get = ['$parse', '$sceDelegate', function(
	                $parse,   $sceDelegate) {
	    // Support: IE 9-11 only
	    // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
	    // the "expression(javascript expression)" syntax which is insecure.
	    if (enabled && msie < 8) {
	      throw $sceMinErr('iequirks',
	        'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' +
	        'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' +
	        'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
	    }
	
	    var sce = shallowCopy(SCE_CONTEXTS);
	
	    /**
	     * @ngdoc method
	     * @name $sce#isEnabled
	     * @kind function
	     *
	     * @return {Boolean} True if SCE is enabled, false otherwise.  If you want to set the value, you
	     *     have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
	     *
	     * @description
	     * Returns a boolean indicating if SCE is enabled.
	     */
	    sce.isEnabled = function() {
	      return enabled;
	    };
	    sce.trustAs = $sceDelegate.trustAs;
	    sce.getTrusted = $sceDelegate.getTrusted;
	    sce.valueOf = $sceDelegate.valueOf;
	
	    if (!enabled) {
	      sce.trustAs = sce.getTrusted = function(type, value) { return value; };
	      sce.valueOf = identity;
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAs
	     *
	     * @description
	     * Converts Angular {@link guide/expression expression} into a function.  This is like {@link
	     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
	     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
	     * *result*)}
	     *
	     * @param {string} type The SCE context in which this result will be used.
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	    sce.parseAs = function sceParseAs(type, expr) {
	      var parsed = $parse(expr);
	      if (parsed.literal && parsed.constant) {
	        return parsed;
	      } else {
	        return $parse(expr, function(value) {
	          return sce.getTrusted(type, value);
	        });
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAs
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}. As such, returns a
	     * wrapped object that represents your value, and the trust you have in its safety for the given
	     * context. AngularJS can then use that value as-is in bindings of the specified secure context.
	     * This is used in bindings for `ng-bind-html`, `ng-include`, and most `src` attribute
	     * interpolations. See {@link ng.$sce $sce} for strict contextual escaping.
	     *
	     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
	     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
	     *
	     * @param {*} value The value that that should be considered trusted.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in the context you specified.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsHtml(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.HTML` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.HTML` context (like `ng-bind-html`).
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsCss(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.CSS, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.CSS` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant
	     *     of your `value` in `$sce.CSS` context. This context is currently unused, so there are
	     *     almost no reasons to use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.URL` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.URL` context. That context is currently unused, so there are almost no reasons
	     *     to use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.RESOURCE_URL` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.RESOURCE_URL` context (template URLs in `ng-include`, most `src` attribute
	     *     bindings, ...)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsJs(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.JS` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.JS` context. That context is currently unused, so there are almost no reasons to
	     *     use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrusted
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
	     * takes any input, and either returns a value that's safe to use in the specified context,
	     * or throws an exception. This function is aware of trusted values created by the `trustAs`
	     * function and its shorthands, and when contexts are appropriate, returns the unwrapped value
	     * as-is. Finally, this function can also throw when there is no way to turn `maybeTrusted` in a
	     * safe value (e.g., no sanitization is available or possible.)
	     *
	     * @param {string} type The context in which this value is to be used.
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs
	     *     `$sce.trustAs`} call, or anything else (which will not be considered trusted.)
	     * @return {*} A version of the value that's safe to use in the given context, or throws an
	     *     exception if this is impossible.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedHtml(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.HTML, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedCss
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedCss(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.CSS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedJs
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedJs(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.JS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsCss(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsJs(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    // Shorthand delegations.
	    var parse = sce.parseAs,
	        getTrusted = sce.getTrusted,
	        trustAs = sce.trustAs;
	
	    forEach(SCE_CONTEXTS, function(enumValue, name) {
	      var lName = lowercase(name);
	      sce[snakeToCamel('parse_as_' + lName)] = function(expr) {
	        return parse(enumValue, expr);
	      };
	      sce[snakeToCamel('get_trusted_' + lName)] = function(value) {
	        return getTrusted(enumValue, value);
	      };
	      sce[snakeToCamel('trust_as_' + lName)] = function(value) {
	        return trustAs(enumValue, value);
	      };
	    });
	
	    return sce;
	  }];
	}
	
	/* exported $SnifferProvider */
	
	/**
	 * !!! This is an undocumented "private" service !!!
	 *
	 * @name $sniffer
	 * @requires $window
	 * @requires $document
	 * @this
	 *
	 * @property {boolean} history Does the browser support html5 history api ?
	 * @property {boolean} transitions Does the browser support CSS transition events ?
	 * @property {boolean} animations Does the browser support CSS animation events ?
	 *
	 * @description
	 * This is very simple implementation of testing browser's features.
	 */
	function $SnifferProvider() {
	  this.$get = ['$window', '$document', function($window, $document) {
	    var eventSupport = {},
	        // Chrome Packaged Apps are not allowed to access `history.pushState`.
	        // If not sandboxed, they can be detected by the presence of `chrome.app.runtime`
	        // (see https://developer.chrome.com/apps/api_index). If sandboxed, they can be detected by
	        // the presence of an extension runtime ID and the absence of other Chrome runtime APIs
	        // (see https://developer.chrome.com/apps/manifest/sandbox).
	        // (NW.js apps have access to Chrome APIs, but do support `history`.)
	        isNw = $window.nw && $window.nw.process,
	        isChromePackagedApp =
	            !isNw &&
	            $window.chrome &&
	            ($window.chrome.app && $window.chrome.app.runtime ||
	                !$window.chrome.app && $window.chrome.runtime && $window.chrome.runtime.id),
	        hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState,
	        android =
	          toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
	        boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
	        document = $document[0] || {},
	        bodyStyle = document.body && document.body.style,
	        transitions = false,
	        animations = false;
	
	    if (bodyStyle) {
	      // Support: Android <5, Blackberry Browser 10, default Chrome in Android 4.4.x
	      // Mentioned browsers need a -webkit- prefix for transitions & animations.
	      transitions = !!('transition' in bodyStyle || 'webkitTransition' in bodyStyle);
	      animations = !!('animation' in bodyStyle || 'webkitAnimation' in bodyStyle);
	    }
	
	
	    return {
	      // Android has history.pushState, but it does not update location correctly
	      // so let's not use the history API at all.
	      // http://code.google.com/p/android/issues/detail?id=17471
	      // https://github.com/angular/angular.js/issues/904
	
	      // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
	      // so let's not use the history API also
	      // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
	      history: !!(hasHistoryPushState && !(android < 4) && !boxee),
	      hasEvent: function(event) {
	        // Support: IE 9-11 only
	        // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
	        // it. In particular the event is not fired when backspace or delete key are pressed or
	        // when cut operation is performed.
	        // IE10+ implements 'input' event but it erroneously fires under various situations,
	        // e.g. when placeholder changes, or a form is focused.
	        if (event === 'input' && msie) return false;
	
	        if (isUndefined(eventSupport[event])) {
	          var divElm = document.createElement('div');
	          eventSupport[event] = 'on' + event in divElm;
	        }
	
	        return eventSupport[event];
	      },
	      csp: csp(),
	      transitions: transitions,
	      animations: animations,
	      android: android
	    };
	  }];
	}
	
	var $templateRequestMinErr = minErr('$compile');
	
	/**
	 * @ngdoc provider
	 * @name $templateRequestProvider
	 * @this
	 *
	 * @description
	 * Used to configure the options passed to the {@link $http} service when making a template request.
	 *
	 * For example, it can be used for specifying the "Accept" header that is sent to the server, when
	 * requesting a template.
	 */
	function $TemplateRequestProvider() {
	
	  var httpOptions;
	
	  /**
	   * @ngdoc method
	   * @name $templateRequestProvider#httpOptions
	   * @description
	   * The options to be passed to the {@link $http} service when making the request.
	   * You can use this to override options such as the "Accept" header for template requests.
	   *
	   * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
	   * options if not overridden here.
	   *
	   * @param {string=} value new value for the {@link $http} options.
	   * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
	   */
	  this.httpOptions = function(val) {
	    if (val) {
	      httpOptions = val;
	      return this;
	    }
	    return httpOptions;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $templateRequest
	   *
	   * @description
	   * The `$templateRequest` service runs security checks then downloads the provided template using
	   * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
	   * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
	   * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
	   * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
	   * when `tpl` is of type string and `$templateCache` has the matching entry.
	   *
	   * If you want to pass custom options to the `$http` service, such as setting the Accept header you
	   * can configure this via {@link $templateRequestProvider#httpOptions}.
	   *
	   * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
	   * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
	   *
	   * @return {Promise} a promise for the HTTP response data of the given URL.
	   *
	   * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
	   */
	  this.$get = ['$exceptionHandler', '$templateCache', '$http', '$q', '$sce',
	    function($exceptionHandler, $templateCache, $http, $q, $sce) {
	
	      function handleRequestFn(tpl, ignoreRequestError) {
	        handleRequestFn.totalPendingRequests++;
	
	        // We consider the template cache holds only trusted templates, so
	        // there's no need to go through whitelisting again for keys that already
	        // are included in there. This also makes Angular accept any script
	        // directive, no matter its name. However, we still need to unwrap trusted
	        // types.
	        if (!isString(tpl) || isUndefined($templateCache.get(tpl))) {
	          tpl = $sce.getTrustedResourceUrl(tpl);
	        }
	
	        var transformResponse = $http.defaults && $http.defaults.transformResponse;
	
	        if (isArray(transformResponse)) {
	          transformResponse = transformResponse.filter(function(transformer) {
	            return transformer !== defaultHttpResponseTransform;
	          });
	        } else if (transformResponse === defaultHttpResponseTransform) {
	          transformResponse = null;
	        }
	
	        return $http.get(tpl, extend({
	            cache: $templateCache,
	            transformResponse: transformResponse
	          }, httpOptions))
	          .finally(function() {
	            handleRequestFn.totalPendingRequests--;
	          })
	          .then(function(response) {
	            $templateCache.put(tpl, response.data);
	            return response.data;
	          }, handleError);
	
	        function handleError(resp) {
	          if (!ignoreRequestError) {
	            resp = $templateRequestMinErr('tpload',
	                'Failed to load template: {0} (HTTP status: {1} {2})',
	                tpl, resp.status, resp.statusText);
	
	            $exceptionHandler(resp);
	          }
	
	          return $q.reject(resp);
	        }
	      }
	
	      handleRequestFn.totalPendingRequests = 0;
	
	      return handleRequestFn;
	    }
	  ];
	}
	
	/** @this */
	function $$TestabilityProvider() {
	  this.$get = ['$rootScope', '$browser', '$location',
	       function($rootScope,   $browser,   $location) {
	
	    /**
	     * @name $testability
	     *
	     * @description
	     * The private $$testability service provides a collection of methods for use when debugging
	     * or by automated test and debugging tools.
	     */
	    var testability = {};
	
	    /**
	     * @name $$testability#findBindings
	     *
	     * @description
	     * Returns an array of elements that are bound (via ng-bind or {{}})
	     * to expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The binding expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression. Filters and whitespace are ignored.
	     */
	    testability.findBindings = function(element, expression, opt_exactMatch) {
	      var bindings = element.getElementsByClassName('ng-binding');
	      var matches = [];
	      forEach(bindings, function(binding) {
	        var dataBinding = angular.element(binding).data('$binding');
	        if (dataBinding) {
	          forEach(dataBinding, function(bindingName) {
	            if (opt_exactMatch) {
	              var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
	              if (matcher.test(bindingName)) {
	                matches.push(binding);
	              }
	            } else {
	              if (bindingName.indexOf(expression) !== -1) {
	                matches.push(binding);
	              }
	            }
	          });
	        }
	      });
	      return matches;
	    };
	
	    /**
	     * @name $$testability#findModels
	     *
	     * @description
	     * Returns an array of elements that are two-way found via ng-model to
	     * expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The model expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression.
	     */
	    testability.findModels = function(element, expression, opt_exactMatch) {
	      var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
	      for (var p = 0; p < prefixes.length; ++p) {
	        var attributeEquals = opt_exactMatch ? '=' : '*=';
	        var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
	        var elements = element.querySelectorAll(selector);
	        if (elements.length) {
	          return elements;
	        }
	      }
	    };
	
	    /**
	     * @name $$testability#getLocation
	     *
	     * @description
	     * Shortcut for getting the location in a browser agnostic way. Returns
	     *     the path, search, and hash. (e.g. /path?a=b#hash)
	     */
	    testability.getLocation = function() {
	      return $location.url();
	    };
	
	    /**
	     * @name $$testability#setLocation
	     *
	     * @description
	     * Shortcut for navigating to a location without doing a full page reload.
	     *
	     * @param {string} url The location url (path, search and hash,
	     *     e.g. /path?a=b#hash) to go to.
	     */
	    testability.setLocation = function(url) {
	      if (url !== $location.url()) {
	        $location.url(url);
	        $rootScope.$digest();
	      }
	    };
	
	    /**
	     * @name $$testability#whenStable
	     *
	     * @description
	     * Calls the callback when $timeout and $http requests are completed.
	     *
	     * @param {function} callback
	     */
	    testability.whenStable = function(callback) {
	      $browser.notifyWhenNoOutstandingRequests(callback);
	    };
	
	    return testability;
	  }];
	}
	
	/** @this */
	function $TimeoutProvider() {
	  this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler',
	       function($rootScope,   $browser,   $q,   $$q,   $exceptionHandler) {
	
	    var deferreds = {};
	
	
	     /**
	      * @ngdoc service
	      * @name $timeout
	      *
	      * @description
	      * Angular's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
	      * block and delegates any exceptions to
	      * {@link ng.$exceptionHandler $exceptionHandler} service.
	      *
	      * The return value of calling `$timeout` is a promise, which will be resolved when
	      * the delay has passed and the timeout function, if provided, is executed.
	      *
	      * To cancel a timeout request, call `$timeout.cancel(promise)`.
	      *
	      * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
	      * synchronously flush the queue of deferred functions.
	      *
	      * If you only want a promise that will be resolved after some specified delay
	      * then you can call `$timeout` without the `fn` function.
	      *
	      * @param {function()=} fn A function, whose execution should be delayed.
	      * @param {number=} [delay=0] Delay in milliseconds.
	      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	      * @param {...*=} Pass additional parameters to the executed function.
	      * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
	      *   will be resolved with the return value of the `fn` function.
	      *
	      */
	    function timeout(fn, delay, invokeApply) {
	      if (!isFunction(fn)) {
	        invokeApply = delay;
	        delay = fn;
	        fn = noop;
	      }
	
	      var args = sliceArgs(arguments, 3),
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise,
	          timeoutId;
	
	      timeoutId = $browser.defer(function() {
	        try {
	          deferred.resolve(fn.apply(null, args));
	        } catch (e) {
	          deferred.reject(e);
	          $exceptionHandler(e);
	        } finally {
	          delete deferreds[promise.$$timeoutId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	      }, delay);
	
	      promise.$$timeoutId = timeoutId;
	      deferreds[timeoutId] = deferred;
	
	      return promise;
	    }
	
	
	     /**
	      * @ngdoc method
	      * @name $timeout#cancel
	      *
	      * @description
	      * Cancels a task associated with the `promise`. As a result of this, the promise will be
	      * resolved with a rejection.
	      *
	      * @param {Promise=} promise Promise returned by the `$timeout` function.
	      * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	      *   canceled.
	      */
	    timeout.cancel = function(promise) {
	      if (promise && promise.$$timeoutId in deferreds) {
	        // Timeout cancels should not report an unhandled promise.
	        deferreds[promise.$$timeoutId].promise.catch(noop);
	        deferreds[promise.$$timeoutId].reject('canceled');
	        delete deferreds[promise.$$timeoutId];
	        return $browser.defer.cancel(promise.$$timeoutId);
	      }
	      return false;
	    };
	
	    return timeout;
	  }];
	}
	
	// NOTE:  The usage of window and document instead of $window and $document here is
	// deliberate.  This service depends on the specific behavior of anchor nodes created by the
	// browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
	// cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
	// doesn't know about mocked locations and resolves URLs to the real document - which is
	// exactly the behavior needed here.  There is little value is mocking these out for this
	// service.
	var urlParsingNode = window.document.createElement('a');
	var originUrl = urlResolve(window.location.href);
	
	
	/**
	 *
	 * Implementation Notes for non-IE browsers
	 * ----------------------------------------
	 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
	 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
	 * URL will be resolved into an absolute URL in the context of the application document.
	 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
	 * properties are all populated to reflect the normalized URL.  This approach has wide
	 * compatibility - Safari 1+, Mozilla 1+ etc.  See
	 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *
	 * Implementation Notes for IE
	 * ---------------------------
	 * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
	 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
	 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
	 * work around that by performing the parsing in a 2nd step by taking a previously normalized
	 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
	 * properties such as protocol, hostname, port, etc.
	 *
	 * References:
	 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
	 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *   http://url.spec.whatwg.org/#urlutils
	 *   https://github.com/angular/angular.js/pull/2902
	 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
	 *
	 * @kind function
	 * @param {string} url The URL to be parsed.
	 * @description Normalizes and parses a URL.
	 * @returns {object} Returns the normalized URL as a dictionary.
	 *
	 *   | member name   | Description    |
	 *   |---------------|----------------|
	 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
	 *   | protocol      | The protocol including the trailing colon                              |
	 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
	 *   | search        | The search params, minus the question mark                             |
	 *   | hash          | The hash string, minus the hash symbol
	 *   | hostname      | The hostname
	 *   | port          | The port, without ":"
	 *   | pathname      | The pathname, beginning with "/"
	 *
	 */
	function urlResolve(url) {
	  var href = url;
	
	  // Support: IE 9-11 only
	  if (msie) {
	    // Normalize before parse.  Refer Implementation Notes on why this is
	    // done in two steps on IE.
	    urlParsingNode.setAttribute('href', href);
	    href = urlParsingNode.href;
	  }
	
	  urlParsingNode.setAttribute('href', href);
	
	  // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	  return {
	    href: urlParsingNode.href,
	    protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	    host: urlParsingNode.host,
	    search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	    hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	    hostname: urlParsingNode.hostname,
	    port: urlParsingNode.port,
	    pathname: (urlParsingNode.pathname.charAt(0) === '/')
	      ? urlParsingNode.pathname
	      : '/' + urlParsingNode.pathname
	  };
	}
	
	/**
	 * Parse a request URL and determine whether this is a same-origin request as the application document.
	 *
	 * @param {string|object} requestUrl The url of the request as a string that will be resolved
	 * or a parsed URL object.
	 * @returns {boolean} Whether the request is for the same origin as the application document.
	 */
	function urlIsSameOrigin(requestUrl) {
	  var parsed = (isString(requestUrl)) ? urlResolve(requestUrl) : requestUrl;
	  return (parsed.protocol === originUrl.protocol &&
	          parsed.host === originUrl.host);
	}
	
	/**
	 * @ngdoc service
	 * @name $window
	 * @this
	 *
	 * @description
	 * A reference to the browser's `window` object. While `window`
	 * is globally available in JavaScript, it causes testability problems, because
	 * it is a global variable. In angular we always refer to it through the
	 * `$window` service, so it may be overridden, removed or mocked for testing.
	 *
	 * Expressions, like the one defined for the `ngClick` directive in the example
	 * below, are evaluated with respect to the current scope.  Therefore, there is
	 * no risk of inadvertently coding in a dependency on a global value in such an
	 * expression.
	 *
	 * @example
	   <example module="windowExample" name="window-service">
	     <file name="index.html">
	       <script>
	         angular.module('windowExample', [])
	           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
	             $scope.greeting = 'Hello, World!';
	             $scope.doGreeting = function(greeting) {
	               $window.alert(greeting);
	             };
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="text" ng-model="greeting" aria-label="greeting" />
	         <button ng-click="doGreeting(greeting)">ALERT</button>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	      it('should display the greeting in the input box', function() {
	       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
	       // If we click the button it will block the test runner
	       // element(':button').click();
	      });
	     </file>
	   </example>
	 */
	function $WindowProvider() {
	  this.$get = valueFn(window);
	}
	
	/**
	 * @name $$cookieReader
	 * @requires $document
	 *
	 * @description
	 * This is a private service for reading cookies used by $http and ngCookies
	 *
	 * @return {Object} a key/value map of the current cookies
	 */
	function $$CookieReader($document) {
	  var rawDocument = $document[0] || {};
	  var lastCookies = {};
	  var lastCookieString = '';
	
	  function safeGetCookie(rawDocument) {
	    try {
	      return rawDocument.cookie || '';
	    } catch (e) {
	      return '';
	    }
	  }
	
	  function safeDecodeURIComponent(str) {
	    try {
	      return decodeURIComponent(str);
	    } catch (e) {
	      return str;
	    }
	  }
	
	  return function() {
	    var cookieArray, cookie, i, index, name;
	    var currentCookieString = safeGetCookie(rawDocument);
	
	    if (currentCookieString !== lastCookieString) {
	      lastCookieString = currentCookieString;
	      cookieArray = lastCookieString.split('; ');
	      lastCookies = {};
	
	      for (i = 0; i < cookieArray.length; i++) {
	        cookie = cookieArray[i];
	        index = cookie.indexOf('=');
	        if (index > 0) { //ignore nameless cookies
	          name = safeDecodeURIComponent(cookie.substring(0, index));
	          // the first value that is seen for a cookie is the most
	          // specific one.  values for the same cookie name that
	          // follow are for less specific paths.
	          if (isUndefined(lastCookies[name])) {
	            lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
	          }
	        }
	      }
	    }
	    return lastCookies;
	  };
	}
	
	$$CookieReader.$inject = ['$document'];
	
	/** @this */
	function $$CookieReaderProvider() {
	  this.$get = $$CookieReader;
	}
	
	/* global currencyFilter: true,
	 dateFilter: true,
	 filterFilter: true,
	 jsonFilter: true,
	 limitToFilter: true,
	 lowercaseFilter: true,
	 numberFilter: true,
	 orderByFilter: true,
	 uppercaseFilter: true,
	 */
	
	/**
	 * @ngdoc provider
	 * @name $filterProvider
	 * @description
	 *
	 * Filters are just functions which transform input to an output. However filters need to be
	 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
	 * annotated with dependencies and is responsible for creating a filter function.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	 * (`myapp_subsection_filterx`).
	 * </div>
	 *
	 * ```js
	 *   // Filter registration
	 *   function MyModule($provide, $filterProvider) {
	 *     // create a service to demonstrate injection (not always needed)
	 *     $provide.value('greet', function(name){
	 *       return 'Hello ' + name + '!';
	 *     });
	 *
	 *     // register a filter factory which uses the
	 *     // greet service to demonstrate DI.
	 *     $filterProvider.register('greet', function(greet){
	 *       // return the filter function which uses the greet service
	 *       // to generate salutation
	 *       return function(text) {
	 *         // filters need to be forgiving so check input validity
	 *         return text && greet(text) || text;
	 *       };
	 *     });
	 *   }
	 * ```
	 *
	 * The filter function is registered with the `$injector` under the filter name suffix with
	 * `Filter`.
	 *
	 * ```js
	 *   it('should be the same instance', inject(
	 *     function($filterProvider) {
	 *       $filterProvider.register('reverse', function(){
	 *         return ...;
	 *       });
	 *     },
	 *     function($filter, reverseFilter) {
	 *       expect($filter('reverse')).toBe(reverseFilter);
	 *     });
	 * ```
	 *
	 *
	 * For more information about how angular filters work, and how to create your own filters, see
	 * {@link guide/filter Filters} in the Angular Developer Guide.
	 */
	
	/**
	 * @ngdoc service
	 * @name $filter
	 * @kind function
	 * @description
	 * Filters are used for formatting data displayed to the user.
	 *
	 * They can be used in view templates, controllers or services.Angular comes
	 * with a collection of [built-in filters](api/ng/filter), but it is easy to
	 * define your own as well.
	 *
	 * The general syntax in templates is as follows:
	 *
	 * ```html
	 * {{ expression [| filter_name[:parameter_value] ... ] }}
	 * ```
	 *
	 * @param {String} name Name of the filter function to retrieve
	 * @return {Function} the filter function
	 * @example
	   <example name="$filter" module="filterExample">
	     <file name="index.html">
	       <div ng-controller="MainCtrl">
	        <h3>{{ originalText }}</h3>
	        <h3>{{ filteredText }}</h3>
	       </div>
	     </file>
	
	     <file name="script.js">
	      angular.module('filterExample', [])
	      .controller('MainCtrl', function($scope, $filter) {
	        $scope.originalText = 'hello';
	        $scope.filteredText = $filter('uppercase')($scope.originalText);
	      });
	     </file>
	   </example>
	  */
	$FilterProvider.$inject = ['$provide'];
	/** @this */
	function $FilterProvider($provide) {
	  var suffix = 'Filter';
	
	  /**
	   * @ngdoc method
	   * @name $filterProvider#register
	   * @param {string|Object} name Name of the filter function, or an object map of filters where
	   *    the keys are the filter names and the values are the filter factories.
	   *
	   *    <div class="alert alert-warning">
	   *    **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	   *    (`myapp_subsection_filterx`).
	   *    </div>
	    * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
	   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
	   *    of the registered filter instances.
	   */
	  function register(name, factory) {
	    if (isObject(name)) {
	      var filters = {};
	      forEach(name, function(filter, key) {
	        filters[key] = register(key, filter);
	      });
	      return filters;
	    } else {
	      return $provide.factory(name + suffix, factory);
	    }
	  }
	  this.register = register;
	
	  this.$get = ['$injector', function($injector) {
	    return function(name) {
	      return $injector.get(name + suffix);
	    };
	  }];
	
	  ////////////////////////////////////////
	
	  /* global
	    currencyFilter: false,
	    dateFilter: false,
	    filterFilter: false,
	    jsonFilter: false,
	    limitToFilter: false,
	    lowercaseFilter: false,
	    numberFilter: false,
	    orderByFilter: false,
	    uppercaseFilter: false
	  */
	
	  register('currency', currencyFilter);
	  register('date', dateFilter);
	  register('filter', filterFilter);
	  register('json', jsonFilter);
	  register('limitTo', limitToFilter);
	  register('lowercase', lowercaseFilter);
	  register('number', numberFilter);
	  register('orderBy', orderByFilter);
	  register('uppercase', uppercaseFilter);
	}
	
	/**
	 * @ngdoc filter
	 * @name filter
	 * @kind function
	 *
	 * @description
	 * Selects a subset of items from `array` and returns it as a new array.
	 *
	 * @param {Array} array The source array.
	 * <div class="alert alert-info">
	 *   **Note**: If the array contains objects that reference themselves, filtering is not possible.
	 * </div>
	 * @param {string|Object|function()} expression The predicate to be used for selecting items from
	 *   `array`.
	 *
	 *   Can be one of:
	 *
	 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
	 *     objects with string properties in `array` that match this string will be returned. This also
	 *     applies to nested object properties.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *
	 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
	 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
	 *     which have property `name` containing "M" and property `phone` containing "1". A special
	 *     property name (`$` by default) can be used (e.g. as in `{$: "text"}`) to accept a match
	 *     against any property of the object or its nested object properties. That's equivalent to the
	 *     simple substring match with a `string` as described above. The special property name can be
	 *     overwritten, using the `anyPropertyKey` parameter.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
	 *     not containing "M".
	 *
	 *     Note that a named property will match properties on the same level only, while the special
	 *     `$` property will match properties on the same level or deeper. E.g. an array item like
	 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
	 *     **will** be matched by `{$: 'John'}`.
	 *
	 *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
	 *     The function is called for each element of the array, with the element, its index, and
	 *     the entire array itself as arguments.
	 *
	 *     The final result is an array of those elements that the predicate returned true for.
	 *
	 * @param {function(actual, expected)|true|false} [comparator] Comparator which is used in
	 *     determining if values retrieved using `expression` (when it is not a function) should be
	 *     considered a match based on the the expected value (from the filter expression) and actual
	 *     value (from the object in the array).
	 *
	 *   Can be one of:
	 *
	 *   - `function(actual, expected)`:
	 *     The function will be given the object value and the predicate value to compare and
	 *     should return true if both values should be considered equal.
	 *
	 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
	 *     This is essentially strict comparison of expected and actual.
	 *
	 *   - `false`: A short hand for a function which will look for a substring match in a case
	 *     insensitive way. Primitive values are converted to strings. Objects are not compared against
	 *     primitives, unless they have a custom `toString` method (e.g. `Date` objects).
	 *
	 *
	 *   Defaults to `false`.
	 *
	 * @param {string} [anyPropertyKey] The special property name that matches against any property.
	 *     By default `$`.
	 *
	 * @example
	   <example name="filter-filter">
	     <file name="index.html">
	       <div ng-init="friends = [{name:'John', phone:'555-1276'},
	                                {name:'Mary', phone:'800-BIG-MARY'},
	                                {name:'Mike', phone:'555-4321'},
	                                {name:'Adam', phone:'555-5678'},
	                                {name:'Julie', phone:'555-8765'},
	                                {name:'Juliette', phone:'555-5678'}]"></div>
	
	       <label>Search: <input ng-model="searchText"></label>
	       <table id="searchTextResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friend in friends | filter:searchText">
	           <td>{{friend.name}}</td>
	           <td>{{friend.phone}}</td>
	         </tr>
	       </table>
	       <hr>
	       <label>Any: <input ng-model="search.$"></label> <br>
	       <label>Name only <input ng-model="search.name"></label><br>
	       <label>Phone only <input ng-model="search.phone"></label><br>
	       <label>Equality <input type="checkbox" ng-model="strict"></label><br>
	       <table id="searchObjResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friendObj in friends | filter:search:strict">
	           <td>{{friendObj.name}}</td>
	           <td>{{friendObj.phone}}</td>
	         </tr>
	       </table>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var expectFriendNames = function(expectedNames, key) {
	         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
	           arr.forEach(function(wd, i) {
	             expect(wd.getText()).toMatch(expectedNames[i]);
	           });
	         });
	       };
	
	       it('should search across all fields when filtering with a string', function() {
	         var searchText = element(by.model('searchText'));
	         searchText.clear();
	         searchText.sendKeys('m');
	         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');
	
	         searchText.clear();
	         searchText.sendKeys('76');
	         expectFriendNames(['John', 'Julie'], 'friend');
	       });
	
	       it('should search in specific fields when filtering with a predicate object', function() {
	         var searchAny = element(by.model('search.$'));
	         searchAny.clear();
	         searchAny.sendKeys('i');
	         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
	       });
	       it('should use a equal comparison when comparator is true', function() {
	         var searchName = element(by.model('search.name'));
	         var strict = element(by.model('strict'));
	         searchName.clear();
	         searchName.sendKeys('Julie');
	         strict.click();
	         expectFriendNames(['Julie'], 'friendObj');
	       });
	     </file>
	   </example>
	 */
	
	function filterFilter() {
	  return function(array, expression, comparator, anyPropertyKey) {
	    if (!isArrayLike(array)) {
	      if (array == null) {
	        return array;
	      } else {
	        throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
	      }
	    }
	
	    anyPropertyKey = anyPropertyKey || '$';
	    var expressionType = getTypeForFilter(expression);
	    var predicateFn;
	    var matchAgainstAnyProp;
	
	    switch (expressionType) {
	      case 'function':
	        predicateFn = expression;
	        break;
	      case 'boolean':
	      case 'null':
	      case 'number':
	      case 'string':
	        matchAgainstAnyProp = true;
	        // falls through
	      case 'object':
	        predicateFn = createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	        break;
	      default:
	        return array;
	    }
	
	    return Array.prototype.filter.call(array, predicateFn);
	  };
	}
	
	// Helper functions for `filterFilter`
	function createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp) {
	  var shouldMatchPrimitives = isObject(expression) && (anyPropertyKey in expression);
	  var predicateFn;
	
	  if (comparator === true) {
	    comparator = equals;
	  } else if (!isFunction(comparator)) {
	    comparator = function(actual, expected) {
	      if (isUndefined(actual)) {
	        // No substring matching against `undefined`
	        return false;
	      }
	      if ((actual === null) || (expected === null)) {
	        // No substring matching against `null`; only match against `null`
	        return actual === expected;
	      }
	      if (isObject(expected) || (isObject(actual) && !hasCustomToString(actual))) {
	        // Should not compare primitives against objects, unless they have custom `toString` method
	        return false;
	      }
	
	      actual = lowercase('' + actual);
	      expected = lowercase('' + expected);
	      return actual.indexOf(expected) !== -1;
	    };
	  }
	
	  predicateFn = function(item) {
	    if (shouldMatchPrimitives && !isObject(item)) {
	      return deepCompare(item, expression[anyPropertyKey], comparator, anyPropertyKey, false);
	    }
	    return deepCompare(item, expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	  };
	
	  return predicateFn;
	}
	
	function deepCompare(actual, expected, comparator, anyPropertyKey, matchAgainstAnyProp, dontMatchWholeObject) {
	  var actualType = getTypeForFilter(actual);
	  var expectedType = getTypeForFilter(expected);
	
	  if ((expectedType === 'string') && (expected.charAt(0) === '!')) {
	    return !deepCompare(actual, expected.substring(1), comparator, anyPropertyKey, matchAgainstAnyProp);
	  } else if (isArray(actual)) {
	    // In case `actual` is an array, consider it a match
	    // if ANY of it's items matches `expected`
	    return actual.some(function(item) {
	      return deepCompare(item, expected, comparator, anyPropertyKey, matchAgainstAnyProp);
	    });
	  }
	
	  switch (actualType) {
	    case 'object':
	      var key;
	      if (matchAgainstAnyProp) {
	        for (key in actual) {
	          // Under certain, rare, circumstances, key may not be a string and `charAt` will be undefined
	          // See: https://github.com/angular/angular.js/issues/15644
	          if (key.charAt && (key.charAt(0) !== '$') &&
	              deepCompare(actual[key], expected, comparator, anyPropertyKey, true)) {
	            return true;
	          }
	        }
	        return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, anyPropertyKey, false);
	      } else if (expectedType === 'object') {
	        for (key in expected) {
	          var expectedVal = expected[key];
	          if (isFunction(expectedVal) || isUndefined(expectedVal)) {
	            continue;
	          }
	
	          var matchAnyProperty = key === anyPropertyKey;
	          var actualVal = matchAnyProperty ? actual : actual[key];
	          if (!deepCompare(actualVal, expectedVal, comparator, anyPropertyKey, matchAnyProperty, matchAnyProperty)) {
	            return false;
	          }
	        }
	        return true;
	      } else {
	        return comparator(actual, expected);
	      }
	    case 'function':
	      return false;
	    default:
	      return comparator(actual, expected);
	  }
	}
	
	// Used for easily differentiating between `null` and actual `object`
	function getTypeForFilter(val) {
	  return (val === null) ? 'null' : typeof val;
	}
	
	var MAX_DIGITS = 22;
	var DECIMAL_SEP = '.';
	var ZERO_CHAR = '0';
	
	/**
	 * @ngdoc filter
	 * @name currency
	 * @kind function
	 *
	 * @description
	 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
	 * symbol for current locale is used.
	 *
	 * @param {number} amount Input to filter.
	 * @param {string=} symbol Currency symbol or identifier to be displayed.
	 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
	 * @returns {string} Formatted number.
	 *
	 *
	 * @example
	   <example module="currencyExample" name="currency-filter">
	     <file name="index.html">
	       <script>
	         angular.module('currencyExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.amount = 1234.56;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="number" ng-model="amount" aria-label="amount"> <br>
	         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
	         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span><br>
	         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should init with 1234.56', function() {
	         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
	         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
	       });
	       it('should update', function() {
	         if (browser.params.browser === 'safari') {
	           // Safari does not understand the minus key. See
	           // https://github.com/angular/protractor/issues/481
	           return;
	         }
	         element(by.model('amount')).clear();
	         element(by.model('amount')).sendKeys('-1234');
	         expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
	         expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
	       });
	     </file>
	   </example>
	 */
	currencyFilter.$inject = ['$locale'];
	function currencyFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(amount, currencySymbol, fractionSize) {
	    if (isUndefined(currencySymbol)) {
	      currencySymbol = formats.CURRENCY_SYM;
	    }
	
	    if (isUndefined(fractionSize)) {
	      fractionSize = formats.PATTERNS[1].maxFrac;
	    }
	
	    // if null or undefined pass it through
	    return (amount == null)
	        ? amount
	        : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).
	            replace(/\u00A4/g, currencySymbol);
	  };
	}
	
	/**
	 * @ngdoc filter
	 * @name number
	 * @kind function
	 *
	 * @description
	 * Formats a number as text.
	 *
	 * If the input is null or undefined, it will just be returned.
	 * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
	 * If the input is not a number an empty string is returned.
	 *
	 *
	 * @param {number|string} number Number to format.
	 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
	 * If this is not provided then the fraction size is computed from the current locale's number
	 * formatting pattern. In the case of the default locale, it will be 3.
	 * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
	 *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
	 *                   include "," group separators after each third digit).
	 *
	 * @example
	   <example module="numberFilterExample" name="number-filter">
	     <file name="index.html">
	       <script>
	         angular.module('numberFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.val = 1234.56789;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter number: <input ng-model='val'></label><br>
	         Default formatting: <span id='number-default'>{{val | number}}</span><br>
	         No fractions: <span>{{val | number:0}}</span><br>
	         Negative number: <span>{{-val | number:4}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format numbers', function() {
	         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
	         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
	       });
	
	       it('should update', function() {
	         element(by.model('val')).clear();
	         element(by.model('val')).sendKeys('3374.333');
	         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
	         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
	      });
	     </file>
	   </example>
	 */
	numberFilter.$inject = ['$locale'];
	function numberFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(number, fractionSize) {
	
	    // if null or undefined pass it through
	    return (number == null)
	        ? number
	        : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP,
	                       fractionSize);
	  };
	}
	
	/**
	 * Parse a number (as a string) into three components that can be used
	 * for formatting the number.
	 *
	 * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
	 *
	 * @param  {string} numStr The number to parse
	 * @return {object} An object describing this number, containing the following keys:
	 *  - d : an array of digits containing leading zeros as necessary
	 *  - i : the number of the digits in `d` that are to the left of the decimal point
	 *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
	 *
	 */
	function parse(numStr) {
	  var exponent = 0, digits, numberOfIntegerDigits;
	  var i, j, zeros;
	
	  // Decimal point?
	  if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
	    numStr = numStr.replace(DECIMAL_SEP, '');
	  }
	
	  // Exponential form?
	  if ((i = numStr.search(/e/i)) > 0) {
	    // Work out the exponent.
	    if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
	    numberOfIntegerDigits += +numStr.slice(i + 1);
	    numStr = numStr.substring(0, i);
	  } else if (numberOfIntegerDigits < 0) {
	    // There was no decimal point or exponent so it is an integer.
	    numberOfIntegerDigits = numStr.length;
	  }
	
	  // Count the number of leading zeros.
	  for (i = 0; numStr.charAt(i) === ZERO_CHAR; i++) { /* empty */ }
	
	  if (i === (zeros = numStr.length)) {
	    // The digits are all zero.
	    digits = [0];
	    numberOfIntegerDigits = 1;
	  } else {
	    // Count the number of trailing zeros
	    zeros--;
	    while (numStr.charAt(zeros) === ZERO_CHAR) zeros--;
	
	    // Trailing zeros are insignificant so ignore them
	    numberOfIntegerDigits -= i;
	    digits = [];
	    // Convert string to array of digits without leading/trailing zeros.
	    for (j = 0; i <= zeros; i++, j++) {
	      digits[j] = +numStr.charAt(i);
	    }
	  }
	
	  // If the number overflows the maximum allowed digits then use an exponent.
	  if (numberOfIntegerDigits > MAX_DIGITS) {
	    digits = digits.splice(0, MAX_DIGITS - 1);
	    exponent = numberOfIntegerDigits - 1;
	    numberOfIntegerDigits = 1;
	  }
	
	  return { d: digits, e: exponent, i: numberOfIntegerDigits };
	}
	
	/**
	 * Round the parsed number to the specified number of decimal places
	 * This function changed the parsedNumber in-place
	 */
	function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
	    var digits = parsedNumber.d;
	    var fractionLen = digits.length - parsedNumber.i;
	
	    // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
	    fractionSize = (isUndefined(fractionSize)) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;
	
	    // The index of the digit to where rounding is to occur
	    var roundAt = fractionSize + parsedNumber.i;
	    var digit = digits[roundAt];
	
	    if (roundAt > 0) {
	      // Drop fractional digits beyond `roundAt`
	      digits.splice(Math.max(parsedNumber.i, roundAt));
	
	      // Set non-fractional digits beyond `roundAt` to 0
	      for (var j = roundAt; j < digits.length; j++) {
	        digits[j] = 0;
	      }
	    } else {
	      // We rounded to zero so reset the parsedNumber
	      fractionLen = Math.max(0, fractionLen);
	      parsedNumber.i = 1;
	      digits.length = Math.max(1, roundAt = fractionSize + 1);
	      digits[0] = 0;
	      for (var i = 1; i < roundAt; i++) digits[i] = 0;
	    }
	
	    if (digit >= 5) {
	      if (roundAt - 1 < 0) {
	        for (var k = 0; k > roundAt; k--) {
	          digits.unshift(0);
	          parsedNumber.i++;
	        }
	        digits.unshift(1);
	        parsedNumber.i++;
	      } else {
	        digits[roundAt - 1]++;
	      }
	    }
	
	    // Pad out with zeros to get the required fraction length
	    for (; fractionLen < Math.max(0, fractionSize); fractionLen++) digits.push(0);
	
	
	    // Do any carrying, e.g. a digit was rounded up to 10
	    var carry = digits.reduceRight(function(carry, d, i, digits) {
	      d = d + carry;
	      digits[i] = d % 10;
	      return Math.floor(d / 10);
	    }, 0);
	    if (carry) {
	      digits.unshift(carry);
	      parsedNumber.i++;
	    }
	}
	
	/**
	 * Format a number into a string
	 * @param  {number} number       The number to format
	 * @param  {{
	 *           minFrac, // the minimum number of digits required in the fraction part of the number
	 *           maxFrac, // the maximum number of digits required in the fraction part of the number
	 *           gSize,   // number of digits in each group of separated digits
	 *           lgSize,  // number of digits in the last group of digits before the decimal separator
	 *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
	 *           posPre,  // the string to go in front of a positive number
	 *           negSuf,  // the string to go after a negative number (e.g. `)`)
	 *           posSuf   // the string to go after a positive number
	 *         }} pattern
	 * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
	 * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
	 * @param  {[type]} fractionSize The size of the fractional part of the number
	 * @return {string}              The number formatted as a string
	 */
	function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {
	
	  if (!(isString(number) || isNumber(number)) || isNaN(number)) return '';
	
	  var isInfinity = !isFinite(number);
	  var isZero = false;
	  var numStr = Math.abs(number) + '',
	      formattedText = '',
	      parsedNumber;
	
	  if (isInfinity) {
	    formattedText = '\u221e';
	  } else {
	    parsedNumber = parse(numStr);
	
	    roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);
	
	    var digits = parsedNumber.d;
	    var integerLen = parsedNumber.i;
	    var exponent = parsedNumber.e;
	    var decimals = [];
	    isZero = digits.reduce(function(isZero, d) { return isZero && !d; }, true);
	
	    // pad zeros for small numbers
	    while (integerLen < 0) {
	      digits.unshift(0);
	      integerLen++;
	    }
	
	    // extract decimals digits
	    if (integerLen > 0) {
	      decimals = digits.splice(integerLen, digits.length);
	    } else {
	      decimals = digits;
	      digits = [0];
	    }
	
	    // format the integer digits with grouping separators
	    var groups = [];
	    if (digits.length >= pattern.lgSize) {
	      groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
	    }
	    while (digits.length > pattern.gSize) {
	      groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
	    }
	    if (digits.length) {
	      groups.unshift(digits.join(''));
	    }
	    formattedText = groups.join(groupSep);
	
	    // append the decimal digits
	    if (decimals.length) {
	      formattedText += decimalSep + decimals.join('');
	    }
	
	    if (exponent) {
	      formattedText += 'e+' + exponent;
	    }
	  }
	  if (number < 0 && !isZero) {
	    return pattern.negPre + formattedText + pattern.negSuf;
	  } else {
	    return pattern.posPre + formattedText + pattern.posSuf;
	  }
	}
	
	function padNumber(num, digits, trim, negWrap) {
	  var neg = '';
	  if (num < 0 || (negWrap && num <= 0)) {
	    if (negWrap) {
	      num = -num + 1;
	    } else {
	      num = -num;
	      neg = '-';
	    }
	  }
	  num = '' + num;
	  while (num.length < digits) num = ZERO_CHAR + num;
	  if (trim) {
	    num = num.substr(num.length - digits);
	  }
	  return neg + num;
	}
	
	
	function dateGetter(name, size, offset, trim, negWrap) {
	  offset = offset || 0;
	  return function(date) {
	    var value = date['get' + name]();
	    if (offset > 0 || value > -offset) {
	      value += offset;
	    }
	    if (value === 0 && offset === -12) value = 12;
	    return padNumber(value, size, trim, negWrap);
	  };
	}
	
	function dateStrGetter(name, shortForm, standAlone) {
	  return function(date, formats) {
	    var value = date['get' + name]();
	    var propPrefix = (standAlone ? 'STANDALONE' : '') + (shortForm ? 'SHORT' : '');
	    var get = uppercase(propPrefix + name);
	
	    return formats[get][value];
	  };
	}
	
	function timeZoneGetter(date, formats, offset) {
	  var zone = -1 * offset;
	  var paddedZone = (zone >= 0) ? '+' : '';
	
	  paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) +
	                padNumber(Math.abs(zone % 60), 2);
	
	  return paddedZone;
	}
	
	function getFirstThursdayOfYear(year) {
	    // 0 = index of January
	    var dayOfWeekOnFirst = (new Date(year, 0, 1)).getDay();
	    // 4 = index of Thursday (+1 to account for 1st = 5)
	    // 11 = index of *next* Thursday (+1 account for 1st = 12)
	    return new Date(year, 0, ((dayOfWeekOnFirst <= 4) ? 5 : 12) - dayOfWeekOnFirst);
	}
	
	function getThursdayThisWeek(datetime) {
	    return new Date(datetime.getFullYear(), datetime.getMonth(),
	      // 4 = index of Thursday
	      datetime.getDate() + (4 - datetime.getDay()));
	}
	
	function weekGetter(size) {
	   return function(date) {
	      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
	         thisThurs = getThursdayThisWeek(date);
	
	      var diff = +thisThurs - +firstThurs,
	         result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week
	
	      return padNumber(result, size);
	   };
	}
	
	function ampmGetter(date, formats) {
	  return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
	}
	
	function eraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
	}
	
	function longEraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
	}
	
	var DATE_FORMATS = {
	  yyyy: dateGetter('FullYear', 4, 0, false, true),
	    yy: dateGetter('FullYear', 2, 0, true, true),
	     y: dateGetter('FullYear', 1, 0, false, true),
	  MMMM: dateStrGetter('Month'),
	   MMM: dateStrGetter('Month', true),
	    MM: dateGetter('Month', 2, 1),
	     M: dateGetter('Month', 1, 1),
	  LLLL: dateStrGetter('Month', false, true),
	    dd: dateGetter('Date', 2),
	     d: dateGetter('Date', 1),
	    HH: dateGetter('Hours', 2),
	     H: dateGetter('Hours', 1),
	    hh: dateGetter('Hours', 2, -12),
	     h: dateGetter('Hours', 1, -12),
	    mm: dateGetter('Minutes', 2),
	     m: dateGetter('Minutes', 1),
	    ss: dateGetter('Seconds', 2),
	     s: dateGetter('Seconds', 1),
	     // while ISO 8601 requires fractions to be prefixed with `.` or `,`
	     // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
	   sss: dateGetter('Milliseconds', 3),
	  EEEE: dateStrGetter('Day'),
	   EEE: dateStrGetter('Day', true),
	     a: ampmGetter,
	     Z: timeZoneGetter,
	    ww: weekGetter(2),
	     w: weekGetter(1),
	     G: eraGetter,
	     GG: eraGetter,
	     GGG: eraGetter,
	     GGGG: longEraGetter
	};
	
	var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))([\s\S]*)/,
	    NUMBER_STRING = /^-?\d+$/;
	
	/**
	 * @ngdoc filter
	 * @name date
	 * @kind function
	 *
	 * @description
	 *   Formats `date` to a string based on the requested `format`.
	 *
	 *   `format` string can be composed of the following elements:
	 *
	 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
	 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
	 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
	 *   * `'MMMM'`: Month in year (January-December)
	 *   * `'MMM'`: Month in year (Jan-Dec)
	 *   * `'MM'`: Month in year, padded (01-12)
	 *   * `'M'`: Month in year (1-12)
	 *   * `'LLLL'`: Stand-alone month in year (January-December)
	 *   * `'dd'`: Day in month, padded (01-31)
	 *   * `'d'`: Day in month (1-31)
	 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
	 *   * `'EEE'`: Day in Week, (Sun-Sat)
	 *   * `'HH'`: Hour in day, padded (00-23)
	 *   * `'H'`: Hour in day (0-23)
	 *   * `'hh'`: Hour in AM/PM, padded (01-12)
	 *   * `'h'`: Hour in AM/PM, (1-12)
	 *   * `'mm'`: Minute in hour, padded (00-59)
	 *   * `'m'`: Minute in hour (0-59)
	 *   * `'ss'`: Second in minute, padded (00-59)
	 *   * `'s'`: Second in minute (0-59)
	 *   * `'sss'`: Millisecond in second, padded (000-999)
	 *   * `'a'`: AM/PM marker
	 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
	 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
	 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
	 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
	 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
	 *
	 *   `format` string can also be one of the following predefined
	 *   {@link guide/i18n localizable formats}:
	 *
	 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
	 *     (e.g. Sep 3, 2010 12:05:08 PM)
	 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
	 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
	 *     (e.g. Friday, September 3, 2010)
	 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
	 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
	 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
	 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
	 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
	 *
	 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
	 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
	 *   (e.g. `"h 'o''clock'"`).
	 *
	 *   Any other characters in the `format` string will be output as-is.
	 *
	 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
	 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
	 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
	 *    specified in the string input, the time is considered to be in the local timezone.
	 * @param {string=} format Formatting rules (see Description). If not specified,
	 *    `mediumDate` is used.
	 * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
	 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *    If not specified, the timezone of the browser will be used.
	 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
	 *
	 * @example
	   <example name="filter-date">
	     <file name="index.html">
	       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
	           <span>{{1288323623006 | date:'medium'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
	          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
	          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
	          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format date', function() {
	         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
	            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
	         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
	            toMatch(/2010-10-2\d \d{2}:\d{2}:\d{2} (-|\+)?\d{4}/);
	         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
	            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
	         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
	            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
	       });
	     </file>
	   </example>
	 */
	dateFilter.$inject = ['$locale'];
	function dateFilter($locale) {
	
	
	  var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
	                     // 1        2       3         4          5          6          7          8  9     10      11
	  function jsonStringToDate(string) {
	    var match;
	    if ((match = string.match(R_ISO8601_STR))) {
	      var date = new Date(0),
	          tzHour = 0,
	          tzMin  = 0,
	          dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
	          timeSetter = match[8] ? date.setUTCHours : date.setHours;
	
	      if (match[9]) {
	        tzHour = toInt(match[9] + match[10]);
	        tzMin = toInt(match[9] + match[11]);
	      }
	      dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
	      var h = toInt(match[4] || 0) - tzHour;
	      var m = toInt(match[5] || 0) - tzMin;
	      var s = toInt(match[6] || 0);
	      var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
	      timeSetter.call(date, h, m, s, ms);
	      return date;
	    }
	    return string;
	  }
	
	
	  return function(date, format, timezone) {
	    var text = '',
	        parts = [],
	        fn, match;
	
	    format = format || 'mediumDate';
	    format = $locale.DATETIME_FORMATS[format] || format;
	    if (isString(date)) {
	      date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
	    }
	
	    if (isNumber(date)) {
	      date = new Date(date);
	    }
	
	    if (!isDate(date) || !isFinite(date.getTime())) {
	      return date;
	    }
	
	    while (format) {
	      match = DATE_FORMATS_SPLIT.exec(format);
	      if (match) {
	        parts = concat(parts, match, 1);
	        format = parts.pop();
	      } else {
	        parts.push(format);
	        format = null;
	      }
	    }
	
	    var dateTimezoneOffset = date.getTimezoneOffset();
	    if (timezone) {
	      dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	      date = convertTimezoneToLocal(date, timezone, true);
	    }
	    forEach(parts, function(value) {
	      fn = DATE_FORMATS[value];
	      text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset)
	                 : value === '\'\'' ? '\'' : value.replace(/(^'|'$)/g, '').replace(/''/g, '\'');
	    });
	
	    return text;
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name json
	 * @kind function
	 *
	 * @description
	 *   Allows you to convert a JavaScript object into JSON string.
	 *
	 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
	 *   the binding is automatically converted to JSON.
	 *
	 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
	 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
	 * @returns {string} JSON string.
	 *
	 *
	 * @example
	   <example name="filter-json">
	     <file name="index.html">
	       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
	       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should jsonify filtered objects', function() {
	         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n {2}"name": ?"value"\n}/);
	         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n {4}"name": ?"value"\n}/);
	       });
	     </file>
	   </example>
	 *
	 */
	function jsonFilter() {
	  return function(object, spacing) {
	    if (isUndefined(spacing)) {
	        spacing = 2;
	    }
	    return toJson(object, spacing);
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name lowercase
	 * @kind function
	 * @description
	 * Converts string to lowercase.
	 * @see angular.lowercase
	 */
	var lowercaseFilter = valueFn(lowercase);
	
	
	/**
	 * @ngdoc filter
	 * @name uppercase
	 * @kind function
	 * @description
	 * Converts string to uppercase.
	 * @see angular.uppercase
	 */
	var uppercaseFilter = valueFn(uppercase);
	
	/**
	 * @ngdoc filter
	 * @name limitTo
	 * @kind function
	 *
	 * @description
	 * Creates a new array or string containing only a specified number of elements. The elements are
	 * taken from either the beginning or the end of the source array, string or number, as specified by
	 * the value and sign (positive or negative) of `limit`. Other array-like objects are also supported
	 * (e.g. array subclasses, NodeLists, jqLite/jQuery collections etc). If a number is used as input,
	 * it is converted to a string.
	 *
	 * @param {Array|ArrayLike|string|number} input - Array/array-like, string or number to be limited.
	 * @param {string|number} limit - The length of the returned array or string. If the `limit` number
	 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
	 *     If the number is negative, `limit` number  of items from the end of the source array/string
	 *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
	 *     the input will be returned unchanged.
	 * @param {(string|number)=} begin - Index at which to begin limitation. As a negative index,
	 *     `begin` indicates an offset from the end of `input`. Defaults to `0`.
	 * @returns {Array|string} A new sub-array or substring of length `limit` or less if the input had
	 *     less than `limit` elements.
	 *
	 * @example
	   <example module="limitToExample" name="limit-to-filter">
	     <file name="index.html">
	       <script>
	         angular.module('limitToExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.numbers = [1,2,3,4,5,6,7,8,9];
	             $scope.letters = "abcdefghi";
	             $scope.longNumber = 2345432342;
	             $scope.numLimit = 3;
	             $scope.letterLimit = 3;
	             $scope.longNumberLimit = 3;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>
	            Limit {{numbers}} to:
	            <input type="number" step="1" ng-model="numLimit">
	         </label>
	         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
	         <label>
	            Limit {{letters}} to:
	            <input type="number" step="1" ng-model="letterLimit">
	         </label>
	         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
	         <label>
	            Limit {{longNumber}} to:
	            <input type="number" step="1" ng-model="longNumberLimit">
	         </label>
	         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var numLimitInput = element(by.model('numLimit'));
	       var letterLimitInput = element(by.model('letterLimit'));
	       var longNumberLimitInput = element(by.model('longNumberLimit'));
	       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
	       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
	       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));
	
	       it('should limit the number array to first three items', function() {
	         expect(numLimitInput.getAttribute('value')).toBe('3');
	         expect(letterLimitInput.getAttribute('value')).toBe('3');
	         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abc');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
	       });
	
	       // There is a bug in safari and protractor that doesn't like the minus key
	       // it('should update the output when -3 is entered', function() {
	       //   numLimitInput.clear();
	       //   numLimitInput.sendKeys('-3');
	       //   letterLimitInput.clear();
	       //   letterLimitInput.sendKeys('-3');
	       //   longNumberLimitInput.clear();
	       //   longNumberLimitInput.sendKeys('-3');
	       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
	       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
	       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
	       // });
	
	       it('should not exceed the maximum size of input array', function() {
	         numLimitInput.clear();
	         numLimitInput.sendKeys('100');
	         letterLimitInput.clear();
	         letterLimitInput.sendKeys('100');
	         longNumberLimitInput.clear();
	         longNumberLimitInput.sendKeys('100');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
	       });
	     </file>
	   </example>
	*/
	function limitToFilter() {
	  return function(input, limit, begin) {
	    if (Math.abs(Number(limit)) === Infinity) {
	      limit = Number(limit);
	    } else {
	      limit = toInt(limit);
	    }
	    if (isNumberNaN(limit)) return input;
	
	    if (isNumber(input)) input = input.toString();
	    if (!isArrayLike(input)) return input;
	
	    begin = (!begin || isNaN(begin)) ? 0 : toInt(begin);
	    begin = (begin < 0) ? Math.max(0, input.length + begin) : begin;
	
	    if (limit >= 0) {
	      return sliceFn(input, begin, begin + limit);
	    } else {
	      if (begin === 0) {
	        return sliceFn(input, limit, input.length);
	      } else {
	        return sliceFn(input, Math.max(0, begin + limit), begin);
	      }
	    }
	  };
	}
	
	function sliceFn(input, begin, end) {
	  if (isString(input)) return input.slice(begin, end);
	
	  return slice.call(input, begin, end);
	}
	
	/**
	 * @ngdoc filter
	 * @name orderBy
	 * @kind function
	 *
	 * @description
	 * Returns an array containing the items from the specified `collection`, ordered by a `comparator`
	 * function based on the values computed using the `expression` predicate.
	 *
	 * For example, `[{id: 'foo'}, {id: 'bar'}] | orderBy:'id'` would result in
	 * `[{id: 'bar'}, {id: 'foo'}]`.
	 *
	 * The `collection` can be an Array or array-like object (e.g. NodeList, jQuery object, TypedArray,
	 * String, etc).
	 *
	 * The `expression` can be a single predicate, or a list of predicates each serving as a tie-breaker
	 * for the preceding one. The `expression` is evaluated against each item and the output is used
	 * for comparing with other items.
	 *
	 * You can change the sorting order by setting `reverse` to `true`. By default, items are sorted in
	 * ascending order.
	 *
	 * The comparison is done using the `comparator` function. If none is specified, a default, built-in
	 * comparator is used (see below for details - in a nutshell, it compares numbers numerically and
	 * strings alphabetically).
	 *
	 * ### Under the hood
	 *
	 * Ordering the specified `collection` happens in two phases:
	 *
	 * 1. All items are passed through the predicate (or predicates), and the returned values are saved
	 *    along with their type (`string`, `number` etc). For example, an item `{label: 'foo'}`, passed
	 *    through a predicate that extracts the value of the `label` property, would be transformed to:
	 *    ```
	 *    {
	 *      value: 'foo',
	 *      type: 'string',
	 *      index: ...
	 *    }
	 *    ```
	 * 2. The comparator function is used to sort the items, based on the derived values, types and
	 *    indices.
	 *
	 * If you use a custom comparator, it will be called with pairs of objects of the form
	 * `{value: ..., type: '...', index: ...}` and is expected to return `0` if the objects are equal
	 * (as far as the comparator is concerned), `-1` if the 1st one should be ranked higher than the
	 * second, or `1` otherwise.
	 *
	 * In order to ensure that the sorting will be deterministic across platforms, if none of the
	 * specified predicates can distinguish between two items, `orderBy` will automatically introduce a
	 * dummy predicate that returns the item's index as `value`.
	 * (If you are using a custom comparator, make sure it can handle this predicate as well.)
	 *
	 * Finally, in an attempt to simplify things, if a predicate returns an object as the extracted
	 * value for an item, `orderBy` will try to convert that object to a primitive value, before passing
	 * it to the comparator. The following rules govern the conversion:
	 *
	 * 1. If the object has a `valueOf()` method that returns a primitive, its return value will be
	 *    used instead.<br />
	 *    (If the object has a `valueOf()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 2. If the object has a custom `toString()` method (i.e. not the one inherited from `Object`) that
	 *    returns a primitive, its return value will be used instead.<br />
	 *    (If the object has a `toString()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 3. No conversion; the object itself is used.
	 *
	 * ### The default comparator
	 *
	 * The default, built-in comparator should be sufficient for most usecases. In short, it compares
	 * numbers numerically, strings alphabetically (and case-insensitively), for objects falls back to
	 * using their index in the original collection, and sorts values of different types by type.
	 *
	 * More specifically, it follows these steps to determine the relative order of items:
	 *
	 * 1. If the compared values are of different types, compare the types themselves alphabetically.
	 * 2. If both values are of type `string`, compare them alphabetically in a case- and
	 *    locale-insensitive way.
	 * 3. If both values are objects, compare their indices instead.
	 * 4. Otherwise, return:
	 *    -  `0`, if the values are equal (by strict equality comparison, i.e. using `===`).
	 *    - `-1`, if the 1st value is "less than" the 2nd value (compared using the `<` operator).
	 *    -  `1`, otherwise.
	 *
	 * **Note:** If you notice numbers not being sorted as expected, make sure they are actually being
	 *           saved as numbers and not strings.
	 * **Note:** For the purpose of sorting, `null` values are treated as the string `'null'` (i.e.
	 *           `type: 'string'`, `value: 'null'`). This may cause unexpected sort order relative to
	 *           other values.
	 *
	 * @param {Array|ArrayLike} collection - The collection (array or array-like object) to sort.
	 * @param {(Function|string|Array.<Function|string>)=} expression - A predicate (or list of
	 *    predicates) to be used by the comparator to determine the order of elements.
	 *
	 *    Can be one of:
	 *
	 *    - `Function`: A getter function. This function will be called with each item as argument and
	 *      the return value will be used for sorting.
	 *    - `string`: An Angular expression. This expression will be evaluated against each item and the
	 *      result will be used for sorting. For example, use `'label'` to sort by a property called
	 *      `label` or `'label.substring(0, 3)'` to sort by the first 3 characters of the `label`
	 *      property.<br />
	 *      (The result of a constant expression is interpreted as a property name to be used for
	 *      comparison. For example, use `'"special name"'` (note the extra pair of quotes) to sort by a
	 *      property called `special name`.)<br />
	 *      An expression can be optionally prefixed with `+` or `-` to control the sorting direction,
	 *      ascending or descending. For example, `'+label'` or `'-label'`. If no property is provided,
	 *      (e.g. `'+'` or `'-'`), the collection element itself is used in comparisons.
	 *    - `Array`: An array of function and/or string predicates. If a predicate cannot determine the
	 *      relative order of two items, the next predicate is used as a tie-breaker.
	 *
	 * **Note:** If the predicate is missing or empty then it defaults to `'+'`.
	 *
	 * @param {boolean=} reverse - If `true`, reverse the sorting order.
	 * @param {(Function)=} comparator - The comparator function used to determine the relative order of
	 *    value pairs. If omitted, the built-in comparator will be used.
	 *
	 * @returns {Array} - The sorted array.
	 *
	 *
	 * @example
	 * ### Ordering a table with `ngRepeat`
	 *
	 * The example below demonstrates a simple {@link ngRepeat ngRepeat}, where the data is sorted by
	 * age in descending order (expression is set to `'-age'`). The `comparator` is not set, which means
	 * it defaults to the built-in comparator.
	 *
	   <example name="orderBy-static" module="orderByExample1">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <table class="friends">
	           <tr>
	             <th>Name</th>
	             <th>Phone Number</th>
	             <th>Age</th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:'-age'">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample1', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var names = element.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by age in reverse order', function() {
	         expect(names.get(0).getText()).toBe('Adam');
	         expect(names.get(1).getText()).toBe('Julie');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('John');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Changing parameters dynamically
	 *
	 * All parameters can be changed dynamically. The next example shows how you can make the columns of
	 * a table sortable, by binding the `expression` and `reverse` parameters to scope properties.
	 *
	   <example name="orderBy-dynamic" module="orderByExample2">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="propertyName = null; reverse = false">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:propertyName:reverse">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample2', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = friends;
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using `orderBy` inside a controller
	 *
	 * It is also possible to call the `orderBy` filter manually, by injecting `orderByFilter`, and
	 * calling it with the desired parameters. (Alternatively, you could inject the `$filter` factory
	 * and retrieve the `orderBy` filter with `$filter('orderBy')`.)
	 *
	   <example name="orderBy-call-manually" module="orderByExample3">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="sortBy(null)">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample3', [])
	         .controller('ExampleController', ['$scope', 'orderByFilter', function($scope, orderBy) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = (propertyName !== null && $scope.propertyName === propertyName)
	                 ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	             $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using a custom comparator
	 *
	 * If you have very specific requirements about the way items are sorted, you can pass your own
	 * comparator function. For example, you might need to compare some strings in a locale-sensitive
	 * way. (When specifying a custom comparator, you also need to pass a value for the `reverse`
	 * argument - passing `false` retains the default sorting order, i.e. ascending.)
	 *
	   <example name="orderBy-custom-comparator" module="orderByExample4">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <div class="friends-container custom-comparator">
	           <h3>Locale-sensitive Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter':false:localeSensitiveComparator">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	         <div class="friends-container default-comparator">
	           <h3>Default Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter'">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample4', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   favoriteLetter: 'Ä'},
	             {name: 'Mary',   favoriteLetter: 'Ü'},
	             {name: 'Mike',   favoriteLetter: 'Ö'},
	             {name: 'Adam',   favoriteLetter: 'H'},
	             {name: 'Julie',  favoriteLetter: 'Z'}
	           ];
	
	           $scope.localeSensitiveComparator = function(v1, v2) {
	             // If we don't get strings, just compare by index
	             if (v1.type !== 'string' || v2.type !== 'string') {
	               return (v1.index < v2.index) ? -1 : 1;
	             }
	
	             // Compare strings alphabetically, taking locale into account
	             return v1.value.localeCompare(v2.value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends-container {
	         display: inline-block;
	         margin: 0 30px;
	       }
	
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var container = element(by.css('.custom-comparator'));
	       var names = container.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by favorite letter (in correct alphabetical order)', function() {
	         expect(names.get(0).getText()).toBe('John');
	         expect(names.get(1).getText()).toBe('Adam');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 *
	 */
	orderByFilter.$inject = ['$parse'];
	function orderByFilter($parse) {
	  return function(array, sortPredicate, reverseOrder, compareFn) {
	
	    if (array == null) return array;
	    if (!isArrayLike(array)) {
	      throw minErr('orderBy')('notarray', 'Expected array but received: {0}', array);
	    }
	
	    if (!isArray(sortPredicate)) { sortPredicate = [sortPredicate]; }
	    if (sortPredicate.length === 0) { sortPredicate = ['+']; }
	
	    var predicates = processPredicates(sortPredicate);
	
	    var descending = reverseOrder ? -1 : 1;
	
	    // Define the `compare()` function. Use a default comparator if none is specified.
	    var compare = isFunction(compareFn) ? compareFn : defaultCompare;
	
	    // The next three lines are a version of a Swartzian Transform idiom from Perl
	    // (sometimes called the Decorate-Sort-Undecorate idiom)
	    // See https://en.wikipedia.org/wiki/Schwartzian_transform
	    var compareValues = Array.prototype.map.call(array, getComparisonObject);
	    compareValues.sort(doComparison);
	    array = compareValues.map(function(item) { return item.value; });
	
	    return array;
	
	    function getComparisonObject(value, index) {
	      // NOTE: We are adding an extra `tieBreaker` value based on the element's index.
	      // This will be used to keep the sort stable when none of the input predicates can
	      // distinguish between two elements.
	      return {
	        value: value,
	        tieBreaker: {value: index, type: 'number', index: index},
	        predicateValues: predicates.map(function(predicate) {
	          return getPredicateValue(predicate.get(value), index);
	        })
	      };
	    }
	
	    function doComparison(v1, v2) {
	      for (var i = 0, ii = predicates.length; i < ii; i++) {
	        var result = compare(v1.predicateValues[i], v2.predicateValues[i]);
	        if (result) {
	          return result * predicates[i].descending * descending;
	        }
	      }
	
	      return compare(v1.tieBreaker, v2.tieBreaker) * descending;
	    }
	  };
	
	  function processPredicates(sortPredicates) {
	    return sortPredicates.map(function(predicate) {
	      var descending = 1, get = identity;
	
	      if (isFunction(predicate)) {
	        get = predicate;
	      } else if (isString(predicate)) {
	        if ((predicate.charAt(0) === '+' || predicate.charAt(0) === '-')) {
	          descending = predicate.charAt(0) === '-' ? -1 : 1;
	          predicate = predicate.substring(1);
	        }
	        if (predicate !== '') {
	          get = $parse(predicate);
	          if (get.constant) {
	            var key = get();
	            get = function(value) { return value[key]; };
	          }
	        }
	      }
	      return {get: get, descending: descending};
	    });
	  }
	
	  function isPrimitive(value) {
	    switch (typeof value) {
	      case 'number': /* falls through */
	      case 'boolean': /* falls through */
	      case 'string':
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function objectValue(value) {
	    // If `valueOf` is a valid function use that
	    if (isFunction(value.valueOf)) {
	      value = value.valueOf();
	      if (isPrimitive(value)) return value;
	    }
	    // If `toString` is a valid function and not the one from `Object.prototype` use that
	    if (hasCustomToString(value)) {
	      value = value.toString();
	      if (isPrimitive(value)) return value;
	    }
	
	    return value;
	  }
	
	  function getPredicateValue(value, index) {
	    var type = typeof value;
	    if (value === null) {
	      type = 'string';
	      value = 'null';
	    } else if (type === 'object') {
	      value = objectValue(value);
	    }
	    return {value: value, type: type, index: index};
	  }
	
	  function defaultCompare(v1, v2) {
	    var result = 0;
	    var type1 = v1.type;
	    var type2 = v2.type;
	
	    if (type1 === type2) {
	      var value1 = v1.value;
	      var value2 = v2.value;
	
	      if (type1 === 'string') {
	        // Compare strings case-insensitively
	        value1 = value1.toLowerCase();
	        value2 = value2.toLowerCase();
	      } else if (type1 === 'object') {
	        // For basic objects, use the position of the object
	        // in the collection instead of the value
	        if (isObject(value1)) value1 = v1.index;
	        if (isObject(value2)) value2 = v2.index;
	      }
	
	      if (value1 !== value2) {
	        result = value1 < value2 ? -1 : 1;
	      }
	    } else {
	      result = type1 < type2 ? -1 : 1;
	    }
	
	    return result;
	  }
	}
	
	function ngDirective(directive) {
	  if (isFunction(directive)) {
	    directive = {
	      link: directive
	    };
	  }
	  directive.restrict = directive.restrict || 'AC';
	  return valueFn(directive);
	}
	
	/**
	 * @ngdoc directive
	 * @name a
	 * @restrict E
	 *
	 * @description
	 * Modifies the default behavior of the html a tag so that the default action is prevented when
	 * the href attribute is empty.
	 *
	 * For dynamically creating `href` attributes for a tags, see the {@link ng.ngHref `ngHref`} directive.
	 */
	var htmlAnchorDirective = valueFn({
	  restrict: 'E',
	  compile: function(element, attr) {
	    if (!attr.href && !attr.xlinkHref) {
	      return function(scope, element) {
	        // If the linked element is not an anchor tag anymore, do nothing
	        if (element[0].nodeName.toLowerCase() !== 'a') return;
	
	        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	        var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ?
	                   'xlink:href' : 'href';
	        element.on('click', function(event) {
	          // if we have no href url, then don't navigate anywhere.
	          if (!element.attr(href)) {
	            event.preventDefault();
	          }
	        });
	      };
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngHref
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in an href attribute will
	 * make the link go to the wrong URL if the user clicks it before
	 * Angular has a chance to replace the `{{hash}}` markup with its
	 * value. Until Angular replaces the markup the link will be broken
	 * and will most likely return a 404 error. The `ngHref` directive
	 * solves this problem.
	 *
	 * The wrong way to write it:
	 * ```html
	 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * @element A
	 * @param {template} ngHref any string which can contain `{{}}` markup.
	 *
	 * @example
	 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
	 * in links and their different behaviors:
	    <example name="ng-href">
	      <file name="index.html">
	        <input ng-model="value" /><br />
	        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
	        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
	        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
	        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
	        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
	        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should execute ng-click but not reload when href without value', function() {
	          element(by.id('link-1')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
	          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when href empty string', function() {
	          element(by.id('link-2')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
	          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click and change url when ng-href specified', function() {
	          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);
	
	          element(by.id('link-3')).click();
	
	          // At this point, we navigate away from an Angular page, so we need
	          // to use browser.driver to get the base webdriver.
	
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/123$/);
	            });
	          }, 5000, 'page should navigate to /123');
	        });
	
	        it('should execute ng-click but not reload when href empty string and name specified', function() {
	          element(by.id('link-4')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
	          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when no href but name specified', function() {
	          element(by.id('link-5')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
	          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
	        });
	
	        it('should only change url when only ng-href', function() {
	          element(by.model('value')).clear();
	          element(by.model('value')).sendKeys('6');
	          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);
	
	          element(by.id('link-6')).click();
	
	          // At this point, we navigate away from an Angular page, so we need
	          // to use browser.driver to get the base webdriver.
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/6$/);
	            });
	          }, 5000, 'page should navigate to /6');
	        });
	      </file>
	    </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrc
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in a `src` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until Angular replaces the expression inside
	 * `{{hash}}`. The `ngSrc` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrc any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrcset
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in a `srcset` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until Angular replaces the expression inside
	 * `{{hash}}`. The `ngSrcset` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrcset any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngDisabled
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * This directive sets the `disabled` attribute on the element (typically a form control,
	 * e.g. `input`, `button`, `select` etc.) if the
	 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `disabled`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-disabled">
	      <file name="index.html">
	        <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
	        <button ng-model="button" ng-disabled="checked">Button</button>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle button', function() {
	          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
	 *     then the `disabled` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngChecked
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
	 *
	 * Note that this directive should not be used together with {@link ngModel `ngModel`},
	 * as this can lead to unexpected behavior.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `checked`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-checked">
	      <file name="index.html">
	        <label>Check me to check both: <input type="checkbox" ng-model="master"></label><br/>
	        <input id="checkSlave" type="checkbox" ng-checked="master" aria-label="Slave input">
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should check both checkBoxes', function() {
	          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeFalsy();
	          element(by.model('master')).click();
	          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
	 *     then the `checked` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngReadonly
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `readonly` attribute on the element, if the expression inside `ngReadonly` is truthy.
	 * Note that `readonly` applies only to `input` elements with specific types. [See the input docs on
	 * MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-readonly) for more information.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `readonly`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-readonly">
	      <file name="index.html">
	        <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
	        <input type="text" ng-readonly="checked" value="I'm Angular" aria-label="Readonly field" />
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle readonly attr', function() {
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
	 *     then special attribute "readonly" will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSelected
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `selected`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * <div class="alert alert-warning">
	 *   **Note:** `ngSelected` does not interact with the `select` and `ngModel` directives, it only
	 *   sets the `selected` attribute on the element. If you are using `ngModel` on the select, you
	 *   should not use `ngSelected` on the options, as `ngModel` will set the select value and
	 *   selected options.
	 * </div>
	 *
	 * @example
	    <example name="ng-selected">
	      <file name="index.html">
	        <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
	        <select aria-label="ngSelected demo">
	          <option>Hello!</option>
	          <option id="greet" ng-selected="selected">Greetings!</option>
	        </select>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should select Greetings!', function() {
	          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
	          element(by.model('selected')).click();
	          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element OPTION
	 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
	 *     then special attribute "selected" will be set on the element
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngOpen
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `open`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * ## A note about browser compatibility
	 *
	 * Edge, Firefox, and Internet Explorer do not support the `details` element, it is
	 * recommended to use {@link ng.ngShow} and {@link ng.ngHide} instead.
	 *
	 * @example
	     <example name="ng-open">
	       <file name="index.html">
	         <label>Check me check multiple: <input type="checkbox" ng-model="open"></label><br/>
	         <details id="details" ng-open="open">
	            <summary>Show/Hide me</summary>
	         </details>
	       </file>
	       <file name="protractor.js" type="protractor">
	         it('should toggle open', function() {
	           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
	           element(by.model('open')).click();
	           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
	         });
	       </file>
	     </example>
	 *
	 * @element DETAILS
	 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
	 *     then special attribute "open" will be set on the element
	 */
	
	var ngAttributeAliasDirectives = {};
	
	// boolean attrs are evaluated
	forEach(BOOLEAN_ATTR, function(propName, attrName) {
	  // binding to multiple is not supported
	  if (propName === 'multiple') return;
	
	  function defaultLinkFn(scope, element, attr) {
	    scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
	      attr.$set(attrName, !!value);
	    });
	  }
	
	  var normalized = directiveNormalize('ng-' + attrName);
	  var linkFn = defaultLinkFn;
	
	  if (propName === 'checked') {
	    linkFn = function(scope, element, attr) {
	      // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
	      if (attr.ngModel !== attr[normalized]) {
	        defaultLinkFn(scope, element, attr);
	      }
	    };
	  }
	
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      restrict: 'A',
	      priority: 100,
	      link: linkFn
	    };
	  };
	});
	
	// aliased input attrs are evaluated
	forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
	  ngAttributeAliasDirectives[ngAttr] = function() {
	    return {
	      priority: 100,
	      link: function(scope, element, attr) {
	        //special case ngPattern when a literal regular expression value
	        //is used as the expression (this way we don't have to watch anything).
	        if (ngAttr === 'ngPattern' && attr.ngPattern.charAt(0) === '/') {
	          var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
	          if (match) {
	            attr.$set('ngPattern', new RegExp(match[1], match[2]));
	            return;
	          }
	        }
	
	        scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
	          attr.$set(ngAttr, value);
	        });
	      }
	    };
	  };
	});
	
	// ng-src, ng-srcset, ng-href are interpolated
	forEach(['src', 'srcset', 'href'], function(attrName) {
	  var normalized = directiveNormalize('ng-' + attrName);
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      priority: 99, // it needs to run after the attributes are interpolated
	      link: function(scope, element, attr) {
	        var propName = attrName,
	            name = attrName;
	
	        if (attrName === 'href' &&
	            toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
	          name = 'xlinkHref';
	          attr.$attr[name] = 'xlink:href';
	          propName = null;
	        }
	
	        attr.$observe(normalized, function(value) {
	          if (!value) {
	            if (attrName === 'href') {
	              attr.$set(name, null);
	            }
	            return;
	          }
	
	          attr.$set(name, value);
	
	          // Support: IE 9-11 only
	          // On IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
	          // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
	          // to set the property as well to achieve the desired effect.
	          // We use attr[attrName] value since $set can sanitize the url.
	          if (msie && propName) element.prop(propName, attr[name]);
	        });
	      }
	    };
	  };
	});
	
	/* global -nullFormCtrl, -PENDING_CLASS, -SUBMITTED_CLASS
	 */
	var nullFormCtrl = {
	  $addControl: noop,
	  $$renameControl: nullFormRenameControl,
	  $removeControl: noop,
	  $setValidity: noop,
	  $setDirty: noop,
	  $setPristine: noop,
	  $setSubmitted: noop
	},
	PENDING_CLASS = 'ng-pending',
	SUBMITTED_CLASS = 'ng-submitted';
	
	function nullFormRenameControl(control, name) {
	  control.$name = name;
	}
	
	/**
	 * @ngdoc type
	 * @name form.FormController
	 *
	 * @property {boolean} $pristine True if user has not interacted with the form yet.
	 * @property {boolean} $dirty True if user has already interacted with the form.
	 * @property {boolean} $valid True if all of the containing forms and controls are valid.
	 * @property {boolean} $invalid True if at least one containing control or form is invalid.
	 * @property {boolean} $pending True if at least one containing control or form is pending.
	 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
	 *
	 * @property {Object} $error Is an object hash, containing references to controls or
	 *  forms with failing validators, where:
	 *
	 *  - keys are validation tokens (error names),
	 *  - values are arrays of controls or forms that have a failing validator for given error name.
	 *
	 *  Built-in validation tokens:
	 *
	 *  - `email`
	 *  - `max`
	 *  - `maxlength`
	 *  - `min`
	 *  - `minlength`
	 *  - `number`
	 *  - `pattern`
	 *  - `required`
	 *  - `url`
	 *  - `date`
	 *  - `datetimelocal`
	 *  - `time`
	 *  - `week`
	 *  - `month`
	 *
	 * @description
	 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
	 * such as being valid/invalid or dirty/pristine.
	 *
	 * Each {@link ng.directive:form form} directive creates an instance
	 * of `FormController`.
	 *
	 */
	//asks for $scope to fool the BC controller module
	FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
	function FormController($element, $attrs, $scope, $animate, $interpolate) {
	  this.$$controls = [];
	
	  // init state
	  this.$error = {};
	  this.$$success = {};
	  this.$pending = undefined;
	  this.$name = $interpolate($attrs.name || $attrs.ngForm || '')($scope);
	  this.$dirty = false;
	  this.$pristine = true;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$submitted = false;
	  this.$$parentForm = nullFormCtrl;
	
	  this.$$element = $element;
	  this.$$animate = $animate;
	
	  setupValidity(this);
	}
	
	FormController.prototype = {
	  /**
	   * @ngdoc method
	   * @name form.FormController#$rollbackViewValue
	   *
	   * @description
	   * Rollback all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is typically needed by the reset button of
	   * a form that uses `ng-model-options` to pend updates.
	   */
	  $rollbackViewValue: function() {
	    forEach(this.$$controls, function(control) {
	      control.$rollbackViewValue();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$commitViewValue
	   *
	   * @description
	   * Commit all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  $commitViewValue: function() {
	    forEach(this.$$controls, function(control) {
	      control.$commitViewValue();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$addControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Register a control with the form. Input elements using ngModelController do this automatically
	   * when they are linked.
	   *
	   * Note that the current state of the control will not be reflected on the new parent form. This
	   * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
	   * state.
	   *
	   * However, if the method is used programmatically, for example by adding dynamically created controls,
	   * or controls that have been previously removed without destroying their corresponding DOM element,
	   * it's the developers responsibility to make sure the current state propagates to the parent form.
	   *
	   * For example, if an input control is added that is already `$dirty` and has `$error` properties,
	   * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
	   */
	  $addControl: function(control) {
	    // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
	    // and not added to the scope.  Now we throw an error.
	    assertNotHasOwnProperty(control.$name, 'input');
	    this.$$controls.push(control);
	
	    if (control.$name) {
	      this[control.$name] = control;
	    }
	
	    control.$$parentForm = this;
	  },
	
	  // Private API: rename a form control
	  $$renameControl: function(control, newName) {
	    var oldName = control.$name;
	
	    if (this[oldName] === control) {
	      delete this[oldName];
	    }
	    this[newName] = control;
	    control.$name = newName;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$removeControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Deregister a control from the form.
	   *
	   * Input elements using ngModelController do this automatically when they are destroyed.
	   *
	   * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
	   * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
	   * different from case to case. For example, removing the only `$dirty` control from a form may or
	   * may not mean that the form is still `$dirty`.
	   */
	  $removeControl: function(control) {
	    if (control.$name && this[control.$name] === control) {
	      delete this[control.$name];
	    }
	    forEach(this.$pending, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	    forEach(this.$error, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	    forEach(this.$$success, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	
	    arrayRemove(this.$$controls, control);
	    control.$$parentForm = nullFormCtrl;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setDirty
	   *
	   * @description
	   * Sets the form to a dirty state.
	   *
	   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
	   * state (ng-dirty class). This method will also propagate to parent forms.
	   */
	  $setDirty: function() {
	    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
	    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
	    this.$dirty = true;
	    this.$pristine = false;
	    this.$$parentForm.$setDirty();
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setPristine
	   *
	   * @description
	   * Sets the form to its pristine state.
	   *
	   * This method sets the form's `$pristine` state to true, the `$dirty` state to false, removes
	   * the `ng-dirty` class and adds the `ng-pristine` class. Additionally, it sets the `$submitted`
	   * state to false.
	   *
	   * This method will also propagate to all the controls contained in this form.
	   *
	   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
	   * saving or resetting it.
	   */
	  $setPristine: function() {
	    this.$$animate.setClass(this.$$element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
	    this.$dirty = false;
	    this.$pristine = true;
	    this.$submitted = false;
	    forEach(this.$$controls, function(control) {
	      control.$setPristine();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setUntouched
	   *
	   * @description
	   * Sets the form to its untouched state.
	   *
	   * This method can be called to remove the 'ng-touched' class and set the form controls to their
	   * untouched state (ng-untouched class).
	   *
	   * Setting a form controls back to their untouched state is often useful when setting the form
	   * back to its pristine state.
	   */
	  $setUntouched: function() {
	    forEach(this.$$controls, function(control) {
	      control.$setUntouched();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setSubmitted
	   *
	   * @description
	   * Sets the form to its submitted state.
	   */
	  $setSubmitted: function() {
	    this.$$animate.addClass(this.$$element, SUBMITTED_CLASS);
	    this.$submitted = true;
	    this.$$parentForm.$setSubmitted();
	  }
	};
	
	/**
	 * @ngdoc method
	 * @name form.FormController#$setValidity
	 *
	 * @description
	 * Sets the validity of a form control.
	 *
	 * This method will also propagate to parent forms.
	 */
	addSetValidityMethod({
	  clazz: FormController,
	  set: function(object, property, controller) {
	    var list = object[property];
	    if (!list) {
	      object[property] = [controller];
	    } else {
	      var index = list.indexOf(controller);
	      if (index === -1) {
	        list.push(controller);
	      }
	    }
	  },
	  unset: function(object, property, controller) {
	    var list = object[property];
	    if (!list) {
	      return;
	    }
	    arrayRemove(list, controller);
	    if (list.length === 0) {
	      delete object[property];
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngForm
	 * @restrict EAC
	 *
	 * @description
	 * Nestable alias of {@link ng.directive:form `form`} directive. HTML
	 * does not allow nesting of form elements. It is useful to nest forms, for example if the validity of a
	 * sub-group of controls needs to be determined.
	 *
	 * Note: the purpose of `ngForm` is to group controls,
	 * but not to be a replacement for the `<form>` tag with all of its capabilities
	 * (e.g. posting to the server, ...).
	 *
	 * @param {string=} ngForm|name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 *
	 */
	
	 /**
	 * @ngdoc directive
	 * @name form
	 * @restrict E
	 *
	 * @description
	 * Directive that instantiates
	 * {@link form.FormController FormController}.
	 *
	 * If the `name` attribute is specified, the form controller is published onto the current scope under
	 * this name.
	 *
	 * # Alias: {@link ng.directive:ngForm `ngForm`}
	 *
	 * In Angular, forms can be nested. This means that the outer form is valid when all of the child
	 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
	 * Angular provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
	 * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
	 * of controls needs to be determined.
	 *
	 * # CSS classes
	 *  - `ng-valid` is set if the form is valid.
	 *  - `ng-invalid` is set if the form is invalid.
	 *  - `ng-pending` is set if the form is pending.
	 *  - `ng-pristine` is set if the form is pristine.
	 *  - `ng-dirty` is set if the form is dirty.
	 *  - `ng-submitted` is set if the form was submitted.
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 *
	 * # Submitting a form and preventing the default action
	 *
	 * Since the role of forms in client-side Angular applications is different than in classical
	 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
	 * page reload that sends the data to the server. Instead some javascript logic should be triggered
	 * to handle the form submission in an application-specific way.
	 *
	 * For this reason, Angular prevents the default action (form submission to the server) unless the
	 * `<form>` element has an `action` attribute specified.
	 *
	 * You can use one of the following two ways to specify what javascript method should be called when
	 * a form is submitted:
	 *
	 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
	 * - {@link ng.directive:ngClick ngClick} directive on the first
	  *  button or input field of type submit (input[type=submit])
	 *
	 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
	 * or {@link ng.directive:ngClick ngClick} directives.
	 * This is because of the following form submission rules in the HTML specification:
	 *
	 * - If a form has only one input field then hitting enter in this field triggers form submit
	 * (`ngSubmit`)
	 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
	 * doesn't trigger submit
	 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
	 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
	 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
	 *
	 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
	 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * ## Animation Hooks
	 *
	 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
	 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
	 * other validations that are performed within the form. Animations in ngForm are similar to how
	 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
	 * as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style a form element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-form {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-form.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	    <example name="ng-form" deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
	      <file name="index.html">
	       <script>
	         angular.module('formExample', [])
	           .controller('FormController', ['$scope', function($scope) {
	             $scope.userType = 'guest';
	           }]);
	       </script>
	       <style>
	        .my-form {
	          transition:all linear 0.5s;
	          background: transparent;
	        }
	        .my-form.ng-invalid {
	          background: red;
	        }
	       </style>
	       <form name="myForm" ng-controller="FormController" class="my-form">
	         userType: <input name="input" ng-model="userType" required>
	         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
	         <code>userType = {{userType}}</code><br>
	         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
	         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
	         <code>myForm.$valid = {{myForm.$valid}}</code><br>
	         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should initialize to model', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	
	          expect(userType.getText()).toContain('guest');
	          expect(valid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var userInput = element(by.model('userType'));
	
	          userInput.clear();
	          userInput.sendKeys('');
	
	          expect(userType.getText()).toEqual('userType =');
	          expect(valid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 *
	 * @param {string=} name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 */
	var formDirectiveFactory = function(isNgForm) {
	  return ['$timeout', '$parse', function($timeout, $parse) {
	    var formDirective = {
	      name: 'form',
	      restrict: isNgForm ? 'EAC' : 'E',
	      require: ['form', '^^?form'], //first is the form's own ctrl, second is an optional parent form
	      controller: FormController,
	      compile: function ngFormCompile(formElement, attr) {
	        // Setup initial state of the control
	        formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);
	
	        var nameAttr = attr.name ? 'name' : (isNgForm && attr.ngForm ? 'ngForm' : false);
	
	        return {
	          pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
	            var controller = ctrls[0];
	
	            // if `action` attr is not present on the form, prevent the default action (submission)
	            if (!('action' in attr)) {
	              // we can't use jq events because if a form is destroyed during submission the default
	              // action is not prevented. see #1238
	              //
	              // IE 9 is not affected because it doesn't fire a submit event and try to do a full
	              // page reload if the form was destroyed by submission of the form via a click handler
	              // on a button in the form. Looks like an IE9 specific bug.
	              var handleFormSubmission = function(event) {
	                scope.$apply(function() {
	                  controller.$commitViewValue();
	                  controller.$setSubmitted();
	                });
	
	                event.preventDefault();
	              };
	
	              formElement[0].addEventListener('submit', handleFormSubmission);
	
	              // unregister the preventDefault listener so that we don't not leak memory but in a
	              // way that will achieve the prevention of the default action.
	              formElement.on('$destroy', function() {
	                $timeout(function() {
	                  formElement[0].removeEventListener('submit', handleFormSubmission);
	                }, 0, false);
	              });
	            }
	
	            var parentFormCtrl = ctrls[1] || controller.$$parentForm;
	            parentFormCtrl.$addControl(controller);
	
	            var setter = nameAttr ? getSetter(controller.$name) : noop;
	
	            if (nameAttr) {
	              setter(scope, controller);
	              attr.$observe(nameAttr, function(newValue) {
	                if (controller.$name === newValue) return;
	                setter(scope, undefined);
	                controller.$$parentForm.$$renameControl(controller, newValue);
	                setter = getSetter(controller.$name);
	                setter(scope, controller);
	              });
	            }
	            formElement.on('$destroy', function() {
	              controller.$$parentForm.$removeControl(controller);
	              setter(scope, undefined);
	              extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
	            });
	          }
	        };
	      }
	    };
	
	    return formDirective;
	
	    function getSetter(expression) {
	      if (expression === '') {
	        //create an assignable expression, so forms with an empty name can be renamed later
	        return $parse('this[""]').assign;
	      }
	      return $parse(expression).assign || noop;
	    }
	  }];
	};
	
	var formDirective = formDirectiveFactory();
	var ngFormDirective = formDirectiveFactory(true);
	
	
	
	// helper methods
	function setupValidity(instance) {
	  instance.$$classCache = {};
	  instance.$$classCache[INVALID_CLASS] = !(instance.$$classCache[VALID_CLASS] = instance.$$element.hasClass(VALID_CLASS));
	}
	function addSetValidityMethod(context) {
	  var clazz = context.clazz,
	      set = context.set,
	      unset = context.unset;
	
	  clazz.prototype.$setValidity = function(validationErrorKey, state, controller) {
	    if (isUndefined(state)) {
	      createAndSet(this, '$pending', validationErrorKey, controller);
	    } else {
	      unsetAndCleanup(this, '$pending', validationErrorKey, controller);
	    }
	    if (!isBoolean(state)) {
	      unset(this.$error, validationErrorKey, controller);
	      unset(this.$$success, validationErrorKey, controller);
	    } else {
	      if (state) {
	        unset(this.$error, validationErrorKey, controller);
	        set(this.$$success, validationErrorKey, controller);
	      } else {
	        set(this.$error, validationErrorKey, controller);
	        unset(this.$$success, validationErrorKey, controller);
	      }
	    }
	    if (this.$pending) {
	      cachedToggleClass(this, PENDING_CLASS, true);
	      this.$valid = this.$invalid = undefined;
	      toggleValidationCss(this, '', null);
	    } else {
	      cachedToggleClass(this, PENDING_CLASS, false);
	      this.$valid = isObjectEmpty(this.$error);
	      this.$invalid = !this.$valid;
	      toggleValidationCss(this, '', this.$valid);
	    }
	
	    // re-read the state as the set/unset methods could have
	    // combined state in this.$error[validationError] (used for forms),
	    // where setting/unsetting only increments/decrements the value,
	    // and does not replace it.
	    var combinedState;
	    if (this.$pending && this.$pending[validationErrorKey]) {
	      combinedState = undefined;
	    } else if (this.$error[validationErrorKey]) {
	      combinedState = false;
	    } else if (this.$$success[validationErrorKey]) {
	      combinedState = true;
	    } else {
	      combinedState = null;
	    }
	
	    toggleValidationCss(this, validationErrorKey, combinedState);
	    this.$$parentForm.$setValidity(validationErrorKey, combinedState, this);
	  };
	
	  function createAndSet(ctrl, name, value, controller) {
	    if (!ctrl[name]) {
	      ctrl[name] = {};
	    }
	    set(ctrl[name], value, controller);
	  }
	
	  function unsetAndCleanup(ctrl, name, value, controller) {
	    if (ctrl[name]) {
	      unset(ctrl[name], value, controller);
	    }
	    if (isObjectEmpty(ctrl[name])) {
	      ctrl[name] = undefined;
	    }
	  }
	
	  function cachedToggleClass(ctrl, className, switchValue) {
	    if (switchValue && !ctrl.$$classCache[className]) {
	      ctrl.$$animate.addClass(ctrl.$$element, className);
	      ctrl.$$classCache[className] = true;
	    } else if (!switchValue && ctrl.$$classCache[className]) {
	      ctrl.$$animate.removeClass(ctrl.$$element, className);
	      ctrl.$$classCache[className] = false;
	    }
	  }
	
	  function toggleValidationCss(ctrl, validationErrorKey, isValid) {
	    validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';
	
	    cachedToggleClass(ctrl, VALID_CLASS + validationErrorKey, isValid === true);
	    cachedToggleClass(ctrl, INVALID_CLASS + validationErrorKey, isValid === false);
	  }
	}
	
	function isObjectEmpty(obj) {
	  if (obj) {
	    for (var prop in obj) {
	      if (obj.hasOwnProperty(prop)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/* global
	  VALID_CLASS: false,
	  INVALID_CLASS: false,
	  PRISTINE_CLASS: false,
	  DIRTY_CLASS: false,
	  ngModelMinErr: false
	*/
	
	// Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
	var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
	// See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
	// Note: We are being more lenient, because browsers are too.
	//   1. Scheme
	//   2. Slashes
	//   3. Username
	//   4. Password
	//   5. Hostname
	//   6. Port
	//   7. Path
	//   8. Query
	//   9. Fragment
	//                 1111111111111111 222   333333    44444        55555555555555555555555     666     77777777     8888888     999
	var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
	// eslint-disable-next-line max-len
	var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
	var NUMBER_REGEXP = /^\s*(-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
	var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
	var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
	var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
	var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	
	var PARTIAL_VALIDATION_EVENTS = 'keydown wheel mousedown';
	var PARTIAL_VALIDATION_TYPES = createMap();
	forEach('date,datetime-local,month,time,week'.split(','), function(type) {
	  PARTIAL_VALIDATION_TYPES[type] = true;
	});
	
	var inputType = {
	
	  /**
	   * @ngdoc input
	   * @name input[text]
	   *
	   * @description
	   * Standard HTML text input with angular data binding, inherited by most of the `input` elements.
	   *
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Adds `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	   *    This parameter is ignored for input[type=password] controls, which will never trim the
	   *    input.
	   *
	   * @example
	      <example name="text-input-directive" module="textInputExample">
	        <file name="index.html">
	         <script>
	           angular.module('textInputExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 text: 'guest',
	                 word: /^\s*\w*\s*$/
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Single word:
	             <input type="text" name="input" ng-model="example.text"
	                    ng-pattern="example.word" required ng-trim="false">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.pattern">
	               Single word only!</span>
	           </div>
	           <code>text = {{example.text}}</code><br/>
	           <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
	           <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
	           <code>myForm.$valid = {{myForm.$valid}}</code><br/>
	           <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('example.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('guest');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if multi word', function() {
	            input.clear();
	            input.sendKeys('hello world');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'text': textInputType,
	
	    /**
	     * @ngdoc input
	     * @name input[date]
	     *
	     * @description
	     * Input with date validation and transformation. In browsers that do not yet support
	     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
	     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
	     * modern browsers do not yet support this input type, it is important to provide cues to users on the
	     * expected input format via a placeholder or label.
	     *
	     * The model must always be a Date object, otherwise Angular will throw an error.
	     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	     *
	     * The timezone to be used to read/write the `Date` instance in the model can be defined using
	     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	     *
	     * @param {string} ngModel Assignable angular expression to data-bind to.
	     * @param {string=} name Property name of the form under which the control is published.
	     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
	     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
	     *   constraint validation.
	     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
	     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
	     *   constraint validation.
	     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
	     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
	     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	     * @param {string=} required Sets `required` validation error key if the value is not entered.
	     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	     *    `required` when you want to data-bind to the `required` attribute.
	     * @param {string=} ngChange Angular expression to be executed when input changes due to user
	     *    interaction with the input element.
	     *
	     * @example
	     <example name="date-input-directive" module="dateInputExample">
	     <file name="index.html">
	       <script>
	          angular.module('dateInputExample', [])
	            .controller('DateController', ['$scope', function($scope) {
	              $scope.example = {
	                value: new Date(2013, 9, 22)
	              };
	            }]);
	       </script>
	       <form name="myForm" ng-controller="DateController as dateCtrl">
	          <label for="exampleInput">Pick a date in 2013:</label>
	          <input type="date" id="exampleInput" name="input" ng-model="example.value"
	              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
	          <div role="alert">
	            <span class="error" ng-show="myForm.input.$error.required">
	                Required!</span>
	            <span class="error" ng-show="myForm.input.$error.date">
	                Not a valid date!</span>
	           </div>
	           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	       </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
	        var valid = element(by.binding('myForm.input.$valid'));
	
	        // currently protractor/webdriver does not support
	        // sending keys to all known HTML5 input controls
	        // for various browsers (see https://github.com/angular/protractor/issues/562).
	        function setInput(val) {
	          // set the value of the element and force validation.
	          var scr = "var ipt = document.getElementById('exampleInput'); " +
	          "ipt.value = '" + val + "';" +
	          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	          browser.executeScript(scr);
	        }
	
	        it('should initialize to model', function() {
	          expect(value.getText()).toContain('2013-10-22');
	          expect(valid.getText()).toContain('myForm.input.$valid = true');
	        });
	
	        it('should be invalid if empty', function() {
	          setInput('');
	          expect(value.getText()).toEqual('value =');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	
	        it('should be invalid if over max', function() {
	          setInput('2015-01-01');
	          expect(value.getText()).toContain('');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	     </file>
	     </example>
	     */
	  'date': createDateInputType('date', DATE_REGEXP,
	         createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']),
	         'yyyy-MM-dd'),
	
	   /**
	    * @ngdoc input
	    * @name input[datetime-local]
	    *
	    * @description
	    * Input with datetime validation and transformation. In browsers that do not yet support
	    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
	    *
	    * The model must always be a Date object, otherwise Angular will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable angular expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `min` will also add native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `max` will also add native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange Angular expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="datetimelocal-input-directive" module="dateExample">
	    <file name="index.html">
	      <script>
	        angular.module('dateExample', [])
	          .controller('DateController', ['$scope', function($scope) {
	            $scope.example = {
	              value: new Date(2010, 11, 28, 14, 57)
	            };
	          }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a date between in 2013:</label>
	        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.datetimelocal">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2010-12-28T14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01-01T23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP,
	      createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']),
	      'yyyy-MM-ddTHH:mm:ss.sss'),
	
	  /**
	   * @ngdoc input
	   * @name input[time]
	   *
	   * @description
	   * Input with time validation and transformation. In browsers that do not yet support
	   * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
	   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
	   *
	   * The model must always be a Date object, otherwise Angular will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
	   *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
	   *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="time-input-directive" module="timeExample">
	   <file name="index.html">
	     <script>
	      angular.module('timeExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(1970, 0, 1, 14, 57, 0)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a time between 8am and 5pm:</label>
	        <input type="time" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.time">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'time': createDateInputType('time', TIME_REGEXP,
	      createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']),
	     'HH:mm:ss.sss'),
	
	   /**
	    * @ngdoc input
	    * @name input[week]
	    *
	    * @description
	    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
	    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * week format (yyyy-W##), for example: `2013-W02`.
	    *
	    * The model must always be a Date object, otherwise Angular will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable angular expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
	    *   native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
	    *   native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange Angular expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="week-input-directive" module="weekExample">
	    <file name="index.html">
	      <script>
	      angular.module('weekExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 0, 3)
	          };
	        }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label>Pick a date between in 2013:
	          <input id="exampleInput" type="week" name="input" ng-model="example.value"
	                 placeholder="YYYY-W##" min="2012-W32"
	                 max="2013-W52" required />
	        </label>
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.week">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-Www"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-W01');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-W01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),
	
	  /**
	   * @ngdoc input
	   * @name input[month]
	   *
	   * @description
	   * Input with month validation and transformation. In browsers that do not yet support
	   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * month format (yyyy-MM), for example: `2009-01`.
	   *
	   * The model must always be a Date object, otherwise Angular will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   * If the model is not set to the first of the month, the next view to model update will set it
	   * to the first of the month.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	   *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	   *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="month-input-directive" module="monthExample">
	   <file name="index.html">
	     <script>
	      angular.module('monthExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 9, 1)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	       <label for="exampleInput">Pick a month in 2013:</label>
	       <input id="exampleInput" type="month" name="input" ng-model="example.value"
	          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
	       <div role="alert">
	         <span class="error" ng-show="myForm.input.$error.required">
	            Required!</span>
	         <span class="error" ng-show="myForm.input.$error.month">
	            Not a valid month!</span>
	       </div>
	       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
	       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-10');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'month': createDateInputType('month', MONTH_REGEXP,
	     createDateParser(MONTH_REGEXP, ['yyyy', 'MM']),
	     'yyyy-MM'),
	
	  /**
	   * @ngdoc input
	   * @name input[number]
	   *
	   * @description
	   * Text input with number validation and transformation. Sets the `number` validation
	   * error if not a valid number.
	   *
	   * <div class="alert alert-warning">
	   * The model must always be of type `number` otherwise Angular will throw an error.
	   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
	   * error docs for more information and an example of how to convert your model if necessary.
	   * </div>
	   *
	   * ## Issues with HTML5 constraint validation
	   *
	   * In browsers that follow the
	   * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
	   * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
	   * If a non-number is entered in the input, the browser will report the value as an empty string,
	   * which means the view / model values in `ngModel` and subsequently the scope value
	   * will also be an empty string.
	   *
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *    Can be interpolated.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *    Can be interpolated.
	   * @param {string=} ngMin Like `min`, sets the `min` validation error key if the value entered is less than `ngMin`,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} ngMax Like `max`, sets the `max` validation error key if the value entered is greater than `ngMax`,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} step Sets the `step` validation error key if the value entered does not fit the `step` constraint.
	   *    Can be interpolated.
	   * @param {string=} ngStep Like `step`, sets the `step` validation error key if the value entered does not fit the `ngStep` constraint,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="number-input-directive" module="numberExample">
	        <file name="index.html">
	         <script>
	           angular.module('numberExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 value: 12
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Number:
	             <input type="number" name="input" ng-model="example.value"
	                    min="0" max="99" required>
	          </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.number">
	               Not valid number!</span>
	           </div>
	           <tt>value = {{example.value}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var value = element(by.binding('example.value'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.value'));
	
	          it('should initialize to model', function() {
	            expect(value.getText()).toContain('12');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if over max', function() {
	            input.clear();
	            input.sendKeys('123');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'number': numberInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[url]
	   *
	   * @description
	   * Text input with URL validation. Sets the `url` validation error key if the content is not a
	   * valid URL.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
	   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
	   * the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="url-input-directive" module="urlExample">
	        <file name="index.html">
	         <script>
	           angular.module('urlExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.url = {
	                 text: 'http://google.com'
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>URL:
	             <input type="url" name="input" ng-model="url.text" required>
	           <label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.url">
	               Not valid url!</span>
	           </div>
	           <tt>text = {{url.text}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('url.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('url.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('http://google.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not url', function() {
	            input.clear();
	            input.sendKeys('box');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'url': urlInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[email]
	   *
	   * @description
	   * Text input with email validation. Sets the `email` validation error key if not a valid email
	   * address.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
	   * used in Chromium. If you need stricter validation (e.g. requiring a top-level domain), you can
	   * use `ng-pattern` or modify the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="email-input-directive" module="emailExample">
	        <file name="index.html">
	         <script>
	           angular.module('emailExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.email = {
	                 text: 'me@example.com'
	               };
	             }]);
	         </script>
	           <form name="myForm" ng-controller="ExampleController">
	             <label>Email:
	               <input type="email" name="input" ng-model="email.text" required>
	             </label>
	             <div role="alert">
	               <span class="error" ng-show="myForm.input.$error.required">
	                 Required!</span>
	               <span class="error" ng-show="myForm.input.$error.email">
	                 Not valid email!</span>
	             </div>
	             <tt>text = {{email.text}}</tt><br/>
	             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
	           </form>
	         </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('email.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('email.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('me@example.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not email', function() {
	            input.clear();
	            input.sendKeys('xxx');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'email': emailInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[radio]
	   *
	   * @description
	   * HTML radio button.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string} value The value to which the `ngModel` expression should be set when selected.
	   *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
	   *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {string} ngValue Angular expression to which `ngModel` will be be set when the radio
	   *    is selected. Should be used instead of the `value` attribute if you need
	   *    a non-string `ngModel` (`boolean`, `array`, ...).
	   *
	   * @example
	      <example name="radio-input-directive" module="radioExample">
	        <file name="index.html">
	         <script>
	           angular.module('radioExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.color = {
	                 name: 'blue'
	               };
	               $scope.specialValue = {
	                 "id": "12345",
	                 "value": "green"
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>
	             <input type="radio" ng-model="color.name" value="red">
	             Red
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" ng-value="specialValue">
	             Green
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" value="blue">
	             Blue
	           </label><br/>
	           <tt>color = {{color.name | json}}</tt><br/>
	          </form>
	          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var inputs = element.all(by.model('color.name'));
	            var color = element(by.binding('color.name'));
	
	            expect(color.getText()).toContain('blue');
	
	            inputs.get(0).click();
	            expect(color.getText()).toContain('red');
	
	            inputs.get(1).click();
	            expect(color.getText()).toContain('green');
	          });
	        </file>
	      </example>
	   */
	  'radio': radioInputType,
	
	  /**
	   * @ngdoc input
	   * @name input[range]
	   *
	   * @description
	   * Native range input with validation and transformation.
	   *
	   * The model for the range input must always be a `Number`.
	   *
	   * IE9 and other browsers that do not support the `range` type fall back
	   * to a text input without any default values for `min`, `max` and `step`. Model binding,
	   * validation and number parsing are nevertheless supported.
	   *
	   * Browsers that support range (latest Chrome, Safari, Firefox, Edge) treat `input[range]`
	   * in a way that never allows the input to hold an invalid value. That means:
	   * - any non-numerical value is set to `(max + min) / 2`.
	   * - any numerical value that is less than the current min val, or greater than the current max val
	   * is set to the min / max val respectively.
	   * - additionally, the current `step` is respected, so the nearest value that satisfies a step
	   * is used.
	   *
	   * See the [HTML Spec on input[type=range]](https://www.w3.org/TR/html5/forms.html#range-state-(type=range))
	   * for more info.
	   *
	   * This has the following consequences for Angular:
	   *
	   * Since the element value should always reflect the current model value, a range input
	   * will set the bound ngModel expression to the value that the browser has set for the
	   * input element. For example, in the following input `<input type="range" ng-model="model.value">`,
	   * if the application sets `model.value = null`, the browser will set the input to `'50'`.
	   * Angular will then set the model to `50`, to prevent input and model value being out of sync.
	   *
	   * That means the model for range will immediately be set to `50` after `ngModel` has been
	   * initialized. It also means a range input can never have the required error.
	   *
	   * This does not only affect changes to the model value, but also to the values of the `min`,
	   * `max`, and `step` attributes. When these change in a way that will cause the browser to modify
	   * the input value, Angular will also update the model value.
	   *
	   * Automatic value adjustment also means that a range input element can never have the `required`,
	   * `min`, or `max` errors.
	   *
	   * However, `step` is currently only fully implemented by Firefox. Other browsers have problems
	   * when the step value changes dynamically - they do not adjust the element value correctly, but
	   * instead may set the `stepMismatch` error. If that's the case, the Angular will set the `step`
	   * error on the input, and set the model to `undefined`.
	   *
	   * Note that `input[range]` is not compatible with`ngMax`, `ngMin`, and `ngStep`, because they do
	   * not set the `min` and `max` attributes, which means that the browser won't automatically adjust
	   * the input value based on their values, and will always assume min = 0, max = 100, and step = 1.
	   *
	   * @param {string}  ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation to ensure that the value entered is greater
	   *                  than `min`. Can be interpolated.
	   * @param {string=} max Sets the `max` validation to ensure that the value entered is less than `max`.
	   *                  Can be interpolated.
	   * @param {string=} step Sets the `step` validation to ensure that the value entered matches the `step`
	   *                  Can be interpolated.
	   * @param {string=} ngChange Angular expression to be executed when the ngModel value changes due
	   *                  to user interaction with the input element.
	   * @param {expression=} ngChecked If the expression is truthy, then the `checked` attribute will be set on the
	   *                      element. **Note** : `ngChecked` should not be used alongside `ngModel`.
	   *                      Checkout {@link ng.directive:ngChecked ngChecked} for usage.
	   *
	   * @example
	      <example name="range-input-directive" module="rangeExample">
	        <file name="index.html">
	          <script>
	            angular.module('rangeExample', [])
	              .controller('ExampleController', ['$scope', function($scope) {
	                $scope.value = 75;
	                $scope.min = 10;
	                $scope.max = 90;
	              }]);
	          </script>
	          <form name="myForm" ng-controller="ExampleController">
	
	            Model as range: <input type="range" name="range" ng-model="value" min="{{min}}"  max="{{max}}">
	            <hr>
	            Model as number: <input type="number" ng-model="value"><br>
	            Min: <input type="number" ng-model="min"><br>
	            Max: <input type="number" ng-model="max"><br>
	            value = <code>{{value}}</code><br/>
	            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
	            myForm.range.$error = <code>{{myForm.range.$error}}</code>
	          </form>
	        </file>
	      </example>
	
	   * ## Range Input with ngMin & ngMax attributes
	
	   * @example
	      <example name="range-input-directive-ng" module="rangeExample">
	        <file name="index.html">
	          <script>
	            angular.module('rangeExample', [])
	              .controller('ExampleController', ['$scope', function($scope) {
	                $scope.value = 75;
	                $scope.min = 10;
	                $scope.max = 90;
	              }]);
	          </script>
	          <form name="myForm" ng-controller="ExampleController">
	            Model as range: <input type="range" name="range" ng-model="value" ng-min="min" ng-max="max">
	            <hr>
	            Model as number: <input type="number" ng-model="value"><br>
	            Min: <input type="number" ng-model="min"><br>
	            Max: <input type="number" ng-model="max"><br>
	            value = <code>{{value}}</code><br/>
	            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
	            myForm.range.$error = <code>{{myForm.range.$error}}</code>
	          </form>
	        </file>
	      </example>
	
	   */
	  'range': rangeInputType,
	
	  /**
	   * @ngdoc input
	   * @name input[checkbox]
	   *
	   * @description
	   * HTML checkbox.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
	   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="checkbox-input-directive" module="checkboxExample">
	        <file name="index.html">
	         <script>
	           angular.module('checkboxExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.checkboxModel = {
	                value1 : true,
	                value2 : 'YES'
	              };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Value1:
	             <input type="checkbox" ng-model="checkboxModel.value1">
	           </label><br/>
	           <label>Value2:
	             <input type="checkbox" ng-model="checkboxModel.value2"
	                    ng-true-value="'YES'" ng-false-value="'NO'">
	            </label><br/>
	           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
	           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var value1 = element(by.binding('checkboxModel.value1'));
	            var value2 = element(by.binding('checkboxModel.value2'));
	
	            expect(value1.getText()).toContain('true');
	            expect(value2.getText()).toContain('YES');
	
	            element(by.model('checkboxModel.value1')).click();
	            element(by.model('checkboxModel.value2')).click();
	
	            expect(value1.getText()).toContain('false');
	            expect(value2.getText()).toContain('NO');
	          });
	        </file>
	      </example>
	   */
	  'checkbox': checkboxInputType,
	
	  'hidden': noop,
	  'button': noop,
	  'submit': noop,
	  'reset': noop,
	  'file': noop
	};
	
	function stringBasedInputType(ctrl) {
	  ctrl.$formatters.push(function(value) {
	    return ctrl.$isEmpty(value) ? value : value.toString();
	  });
	}
	
	function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	}
	
	function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  var type = lowercase(element[0].type);
	
	  // In composition mode, users are still inputting intermediate text buffer,
	  // hold the listener until composition is done.
	  // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
	  if (!$sniffer.android) {
	    var composing = false;
	
	    element.on('compositionstart', function() {
	      composing = true;
	    });
	
	    element.on('compositionend', function() {
	      composing = false;
	      listener();
	    });
	  }
	
	  var timeout;
	
	  var listener = function(ev) {
	    if (timeout) {
	      $browser.defer.cancel(timeout);
	      timeout = null;
	    }
	    if (composing) return;
	    var value = element.val(),
	        event = ev && ev.type;
	
	    // By default we will trim the value
	    // If the attribute ng-trim exists we will avoid trimming
	    // If input type is 'password', the value is never trimmed
	    if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
	      value = trim(value);
	    }
	
	    // If a control is suffering from bad input (due to native validators), browsers discard its
	    // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
	    // control's value is the same empty value twice in a row.
	    if (ctrl.$viewValue !== value || (value === '' && ctrl.$$hasNativeValidators)) {
	      ctrl.$setViewValue(value, event);
	    }
	  };
	
	  // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
	  // input event on backspace, delete or cut
	  if ($sniffer.hasEvent('input')) {
	    element.on('input', listener);
	  } else {
	    var deferListener = function(ev, input, origValue) {
	      if (!timeout) {
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (!input || input.value !== origValue) {
	            listener(ev);
	          }
	        });
	      }
	    };
	
	    element.on('keydown', /** @this */ function(event) {
	      var key = event.keyCode;
	
	      // ignore
	      //    command            modifiers                   arrows
	      if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;
	
	      deferListener(event, this, this.value);
	    });
	
	    // if user modifies input value using context menu in IE, we need "paste" and "cut" events to catch it
	    if ($sniffer.hasEvent('paste')) {
	      element.on('paste cut', deferListener);
	    }
	  }
	
	  // if user paste into input using mouse on older browser
	  // or form autocomplete on newer browser, we need "change" event to catch it
	  element.on('change', listener);
	
	  // Some native input types (date-family) have the ability to change validity without
	  // firing any input/change events.
	  // For these event types, when native validators are present and the browser supports the type,
	  // check for validity changes on various DOM events.
	  if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) {
	    element.on(PARTIAL_VALIDATION_EVENTS, /** @this */ function(ev) {
	      if (!timeout) {
	        var validity = this[VALIDITY_STATE_PROPERTY];
	        var origBadInput = validity.badInput;
	        var origTypeMismatch = validity.typeMismatch;
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) {
	            listener(ev);
	          }
	        });
	      }
	    });
	  }
	
	  ctrl.$render = function() {
	    // Workaround for Firefox validation #12102.
	    var value = ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
	    if (element.val() !== value) {
	      element.val(value);
	    }
	  };
	}
	
	function weekParser(isoWeek, existingDate) {
	  if (isDate(isoWeek)) {
	    return isoWeek;
	  }
	
	  if (isString(isoWeek)) {
	    WEEK_REGEXP.lastIndex = 0;
	    var parts = WEEK_REGEXP.exec(isoWeek);
	    if (parts) {
	      var year = +parts[1],
	          week = +parts[2],
	          hours = 0,
	          minutes = 0,
	          seconds = 0,
	          milliseconds = 0,
	          firstThurs = getFirstThursdayOfYear(year),
	          addDays = (week - 1) * 7;
	
	      if (existingDate) {
	        hours = existingDate.getHours();
	        minutes = existingDate.getMinutes();
	        seconds = existingDate.getSeconds();
	        milliseconds = existingDate.getMilliseconds();
	      }
	
	      return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
	    }
	  }
	
	  return NaN;
	}
	
	function createDateParser(regexp, mapping) {
	  return function(iso, date) {
	    var parts, map;
	
	    if (isDate(iso)) {
	      return iso;
	    }
	
	    if (isString(iso)) {
	      // When a date is JSON'ified to wraps itself inside of an extra
	      // set of double quotes. This makes the date parsing code unable
	      // to match the date string and parse it as a date.
	      if (iso.charAt(0) === '"' && iso.charAt(iso.length - 1) === '"') {
	        iso = iso.substring(1, iso.length - 1);
	      }
	      if (ISO_DATE_REGEXP.test(iso)) {
	        return new Date(iso);
	      }
	      regexp.lastIndex = 0;
	      parts = regexp.exec(iso);
	
	      if (parts) {
	        parts.shift();
	        if (date) {
	          map = {
	            yyyy: date.getFullYear(),
	            MM: date.getMonth() + 1,
	            dd: date.getDate(),
	            HH: date.getHours(),
	            mm: date.getMinutes(),
	            ss: date.getSeconds(),
	            sss: date.getMilliseconds() / 1000
	          };
	        } else {
	          map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
	        }
	
	        forEach(parts, function(part, index) {
	          if (index < mapping.length) {
	            map[mapping[index]] = +part;
	          }
	        });
	        return new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
	      }
	    }
	
	    return NaN;
	  };
	}
	
	function createDateInputType(type, regexp, parseDate, format) {
	  return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter) {
	    badInputChecker(scope, element, attr, ctrl);
	    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	    var timezone = ctrl && ctrl.$options.getOption('timezone');
	    var previousDate;
	
	    ctrl.$$parserName = type;
	    ctrl.$parsers.push(function(value) {
	      if (ctrl.$isEmpty(value)) return null;
	      if (regexp.test(value)) {
	        // Note: We cannot read ctrl.$modelValue, as there might be a different
	        // parser/formatter in the processing chain so that the model
	        // contains some different data format!
	        var parsedDate = parseDate(value, previousDate);
	        if (timezone) {
	          parsedDate = convertTimezoneToLocal(parsedDate, timezone);
	        }
	        return parsedDate;
	      }
	      return undefined;
	    });
	
	    ctrl.$formatters.push(function(value) {
	      if (value && !isDate(value)) {
	        throw ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
	      }
	      if (isValidDate(value)) {
	        previousDate = value;
	        if (previousDate && timezone) {
	          previousDate = convertTimezoneToLocal(previousDate, timezone, true);
	        }
	        return $filter('date')(value, format, timezone);
	      } else {
	        previousDate = null;
	        return '';
	      }
	    });
	
	    if (isDefined(attr.min) || attr.ngMin) {
	      var minVal;
	      ctrl.$validators.min = function(value) {
	        return !isValidDate(value) || isUndefined(minVal) || parseDate(value) >= minVal;
	      };
	      attr.$observe('min', function(val) {
	        minVal = parseObservedDateValue(val);
	        ctrl.$validate();
	      });
	    }
	
	    if (isDefined(attr.max) || attr.ngMax) {
	      var maxVal;
	      ctrl.$validators.max = function(value) {
	        return !isValidDate(value) || isUndefined(maxVal) || parseDate(value) <= maxVal;
	      };
	      attr.$observe('max', function(val) {
	        maxVal = parseObservedDateValue(val);
	        ctrl.$validate();
	      });
	    }
	
	    function isValidDate(value) {
	      // Invalid Date: getTime() returns NaN
	      return value && !(value.getTime && value.getTime() !== value.getTime());
	    }
	
	    function parseObservedDateValue(val) {
	      return isDefined(val) && !isDate(val) ? parseDate(val) || undefined : val;
	    }
	  };
	}
	
	function badInputChecker(scope, element, attr, ctrl) {
	  var node = element[0];
	  var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
	  if (nativeValidation) {
	    ctrl.$parsers.push(function(value) {
	      var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
	      return validity.badInput || validity.typeMismatch ? undefined : value;
	    });
	  }
	}
	
	function numberFormatterParser(ctrl) {
	  ctrl.$$parserName = 'number';
	  ctrl.$parsers.push(function(value) {
	    if (ctrl.$isEmpty(value))      return null;
	    if (NUMBER_REGEXP.test(value)) return parseFloat(value);
	    return undefined;
	  });
	
	  ctrl.$formatters.push(function(value) {
	    if (!ctrl.$isEmpty(value)) {
	      if (!isNumber(value)) {
	        throw ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
	      }
	      value = value.toString();
	    }
	    return value;
	  });
	}
	
	function parseNumberAttrVal(val) {
	  if (isDefined(val) && !isNumber(val)) {
	    val = parseFloat(val);
	  }
	  return !isNumberNaN(val) ? val : undefined;
	}
	
	function isNumberInteger(num) {
	  // See http://stackoverflow.com/questions/14636536/how-to-check-if-a-variable-is-an-integer-in-javascript#14794066
	  // (minus the assumption that `num` is a number)
	
	  // eslint-disable-next-line no-bitwise
	  return (num | 0) === num;
	}
	
	function countDecimals(num) {
	  var numString = num.toString();
	  var decimalSymbolIndex = numString.indexOf('.');
	
	  if (decimalSymbolIndex === -1) {
	    if (-1 < num && num < 1) {
	      // It may be in the exponential notation format (`1e-X`)
	      var match = /e-(\d+)$/.exec(numString);
	
	      if (match) {
	        return Number(match[1]);
	      }
	    }
	
	    return 0;
	  }
	
	  return numString.length - decimalSymbolIndex - 1;
	}
	
	function isValidForStep(viewValue, stepBase, step) {
	  // At this point `stepBase` and `step` are expected to be non-NaN values
	  // and `viewValue` is expected to be a valid stringified number.
	  var value = Number(viewValue);
	
	  var isNonIntegerValue = !isNumberInteger(value);
	  var isNonIntegerStepBase = !isNumberInteger(stepBase);
	  var isNonIntegerStep = !isNumberInteger(step);
	
	  // Due to limitations in Floating Point Arithmetic (e.g. `0.3 - 0.2 !== 0.1` or
	  // `0.5 % 0.1 !== 0`), we need to convert all numbers to integers.
	  if (isNonIntegerValue || isNonIntegerStepBase || isNonIntegerStep) {
	    var valueDecimals = isNonIntegerValue ? countDecimals(value) : 0;
	    var stepBaseDecimals = isNonIntegerStepBase ? countDecimals(stepBase) : 0;
	    var stepDecimals = isNonIntegerStep ? countDecimals(step) : 0;
	
	    var decimalCount = Math.max(valueDecimals, stepBaseDecimals, stepDecimals);
	    var multiplier = Math.pow(10, decimalCount);
	
	    value = value * multiplier;
	    stepBase = stepBase * multiplier;
	    step = step * multiplier;
	
	    if (isNonIntegerValue) value = Math.round(value);
	    if (isNonIntegerStepBase) stepBase = Math.round(stepBase);
	    if (isNonIntegerStep) step = Math.round(step);
	  }
	
	  return (value - stepBase) % step === 0;
	}
	
	function numberInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  badInputChecker(scope, element, attr, ctrl);
	  numberFormatterParser(ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  var minVal;
	  var maxVal;
	
	  if (isDefined(attr.min) || attr.ngMin) {
	    ctrl.$validators.min = function(value) {
	      return ctrl.$isEmpty(value) || isUndefined(minVal) || value >= minVal;
	    };
	
	    attr.$observe('min', function(val) {
	      minVal = parseNumberAttrVal(val);
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	
	  if (isDefined(attr.max) || attr.ngMax) {
	    ctrl.$validators.max = function(value) {
	      return ctrl.$isEmpty(value) || isUndefined(maxVal) || value <= maxVal;
	    };
	
	    attr.$observe('max', function(val) {
	      maxVal = parseNumberAttrVal(val);
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	
	  if (isDefined(attr.step) || attr.ngStep) {
	    var stepVal;
	    ctrl.$validators.step = function(modelValue, viewValue) {
	      return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) ||
	             isValidForStep(viewValue, minVal || 0, stepVal);
	    };
	
	    attr.$observe('step', function(val) {
	      stepVal = parseNumberAttrVal(val);
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	}
	
	function rangeInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  badInputChecker(scope, element, attr, ctrl);
	  numberFormatterParser(ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  var supportsRange = ctrl.$$hasNativeValidators && element[0].type === 'range',
	      minVal = supportsRange ? 0 : undefined,
	      maxVal = supportsRange ? 100 : undefined,
	      stepVal = supportsRange ? 1 : undefined,
	      validity = element[0].validity,
	      hasMinAttr = isDefined(attr.min),
	      hasMaxAttr = isDefined(attr.max),
	      hasStepAttr = isDefined(attr.step);
	
	  var originalRender = ctrl.$render;
	
	  ctrl.$render = supportsRange && isDefined(validity.rangeUnderflow) && isDefined(validity.rangeOverflow) ?
	    //Browsers that implement range will set these values automatically, but reading the adjusted values after
	    //$render would cause the min / max validators to be applied with the wrong value
	    function rangeRender() {
	      originalRender();
	      ctrl.$setViewValue(element.val());
	    } :
	    originalRender;
	
	  if (hasMinAttr) {
	    ctrl.$validators.min = supportsRange ?
	      // Since all browsers set the input to a valid value, we don't need to check validity
	      function noopMinValidator() { return true; } :
	      // non-support browsers validate the min val
	      function minValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(minVal) || viewValue >= minVal;
	      };
	
	    setInitialValueAndObserver('min', minChange);
	  }
	
	  if (hasMaxAttr) {
	    ctrl.$validators.max = supportsRange ?
	      // Since all browsers set the input to a valid value, we don't need to check validity
	      function noopMaxValidator() { return true; } :
	      // non-support browsers validate the max val
	      function maxValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(maxVal) || viewValue <= maxVal;
	      };
	
	    setInitialValueAndObserver('max', maxChange);
	  }
	
	  if (hasStepAttr) {
	    ctrl.$validators.step = supportsRange ?
	      function nativeStepValidator() {
	        // Currently, only FF implements the spec on step change correctly (i.e. adjusting the
	        // input element value to a valid value). It's possible that other browsers set the stepMismatch
	        // validity error instead, so we can at least report an error in that case.
	        return !validity.stepMismatch;
	      } :
	      // ngStep doesn't set the setp attr, so the browser doesn't adjust the input value as setting step would
	      function stepValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) ||
	               isValidForStep(viewValue, minVal || 0, stepVal);
	      };
	
	    setInitialValueAndObserver('step', stepChange);
	  }
	
	  function setInitialValueAndObserver(htmlAttrName, changeFn) {
	    // interpolated attributes set the attribute value only after a digest, but we need the
	    // attribute value when the input is first rendered, so that the browser can adjust the
	    // input value based on the min/max value
	    element.attr(htmlAttrName, attr[htmlAttrName]);
	    attr.$observe(htmlAttrName, changeFn);
	  }
	
	  function minChange(val) {
	    minVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    if (supportsRange) {
	      var elVal = element.val();
	      // IE11 doesn't set the el val correctly if the minVal is greater than the element value
	      if (minVal > elVal) {
	        elVal = minVal;
	        element.val(elVal);
	      }
	      ctrl.$setViewValue(elVal);
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	
	  function maxChange(val) {
	    maxVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    if (supportsRange) {
	      var elVal = element.val();
	      // IE11 doesn't set the el val correctly if the maxVal is less than the element value
	      if (maxVal < elVal) {
	        element.val(maxVal);
	        // IE11 and Chrome don't set the value to the minVal when max < min
	        elVal = maxVal < minVal ? minVal : maxVal;
	      }
	      ctrl.$setViewValue(elVal);
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	
	  function stepChange(val) {
	    stepVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    // Some browsers don't adjust the input value correctly, but set the stepMismatch error
	    if (supportsRange && ctrl.$viewValue !== element.val()) {
	      ctrl.$setViewValue(element.val());
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	}
	
	function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$$parserName = 'url';
	  ctrl.$validators.url = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
	  };
	}
	
	function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$$parserName = 'email';
	  ctrl.$validators.email = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
	  };
	}
	
	function radioInputType(scope, element, attr, ctrl) {
	  var doTrim = !attr.ngTrim || trim(attr.ngTrim) !== 'false';
	  // make the name unique, if not defined
	  if (isUndefined(attr.name)) {
	    element.attr('name', nextUid());
	  }
	
	  var listener = function(ev) {
	    var value;
	    if (element[0].checked) {
	      value = attr.value;
	      if (doTrim) {
	        value = trim(value);
	      }
	      ctrl.$setViewValue(value, ev && ev.type);
	    }
	  };
	
	  element.on('click', listener);
	
	  ctrl.$render = function() {
	    var value = attr.value;
	    if (doTrim) {
	      value = trim(value);
	    }
	    element[0].checked = (value === ctrl.$viewValue);
	  };
	
	  attr.$observe('value', ctrl.$render);
	}
	
	function parseConstantExpr($parse, context, name, expression, fallback) {
	  var parseFn;
	  if (isDefined(expression)) {
	    parseFn = $parse(expression);
	    if (!parseFn.constant) {
	      throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' +
	                                   '`{1}`.', name, expression);
	    }
	    return parseFn(context);
	  }
	  return fallback;
	}
	
	function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	  var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
	  var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);
	
	  var listener = function(ev) {
	    ctrl.$setViewValue(element[0].checked, ev && ev.type);
	  };
	
	  element.on('click', listener);
	
	  ctrl.$render = function() {
	    element[0].checked = ctrl.$viewValue;
	  };
	
	  // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
	  // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
	  // it to a boolean.
	  ctrl.$isEmpty = function(value) {
	    return value === false;
	  };
	
	  ctrl.$formatters.push(function(value) {
	    return equals(value, trueValue);
	  });
	
	  ctrl.$parsers.push(function(value) {
	    return value ? trueValue : falseValue;
	  });
	}
	
	
	/**
	 * @ngdoc directive
	 * @name textarea
	 * @restrict E
	 *
	 * @description
	 * HTML textarea element control with angular data-binding. The data-binding and validation
	 * properties of this element are exactly the same as those of the
	 * {@link ng.directive:input input element}.
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange Angular expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	 *
	 * @knownIssue
	 *
	 * When specifying the `placeholder` attribute of `<textarea>`, Internet Explorer will temporarily
	 * insert the placeholder value as the textarea's content. If the placeholder value contains
	 * interpolation (`{{ ... }}`), an error will be logged in the console when Angular tries to update
	 * the value of the by-then-removed text node. This doesn't affect the functionality of the
	 * textarea, but can be undesirable.
	 *
	 * You can work around this Internet Explorer issue by using `ng-attr-placeholder` instead of
	 * `placeholder` on textareas, whenever you need interpolation in the placeholder value. You can
	 * find more details on `ngAttr` in the
	 * [Interpolation](guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes) section of the
	 * Developer Guide.
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name input
	 * @restrict E
	 *
	 * @description
	 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
	 * input state control, and validation.
	 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Not every feature offered is available for all input types.
	 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
	 * </div>
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {boolean=} ngRequired Sets `required` attribute if set to true
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    value does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange Angular expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	 *    This parameter is ignored for input[type=password] controls, which will never trim the
	 *    input.
	 *
	 * @example
	    <example name="input-directive" module="inputExample">
	      <file name="index.html">
	       <script>
	          angular.module('inputExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.user = {name: 'guest', last: 'visitor'};
	            }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <form name="myForm">
	           <label>
	              User name:
	              <input type="text" name="userName" ng-model="user.name" required>
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.userName.$error.required">
	              Required!</span>
	           </div>
	           <label>
	              Last name:
	              <input type="text" name="lastName" ng-model="user.last"
	              ng-minlength="3" ng-maxlength="10">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.lastName.$error.minlength">
	               Too short!</span>
	             <span class="error" ng-show="myForm.lastName.$error.maxlength">
	               Too long!</span>
	           </div>
	         </form>
	         <hr>
	         <tt>user = {{user}}</tt><br/>
	         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
	         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
	         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
	         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
	         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
	         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
	       </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var user = element(by.exactBinding('user'));
	        var userNameValid = element(by.binding('myForm.userName.$valid'));
	        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
	        var lastNameError = element(by.binding('myForm.lastName.$error'));
	        var formValid = element(by.binding('myForm.$valid'));
	        var userNameInput = element(by.model('user.name'));
	        var userLastInput = element(by.model('user.last'));
	
	        it('should initialize to model', function() {
	          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
	          expect(userNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty when required', function() {
	          userNameInput.clear();
	          userNameInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"last":"visitor"}');
	          expect(userNameValid.getText()).toContain('false');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be valid if empty when min length is set', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"name":"guest","last":""}');
	          expect(lastNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if less than required min length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('xx');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('minlength');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be invalid if longer than max length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('some ridiculously long name');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('maxlength');
	          expect(formValid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 */
	var inputDirective = ['$browser', '$sniffer', '$filter', '$parse',
	    function($browser, $sniffer, $filter, $parse) {
	  return {
	    restrict: 'E',
	    require: ['?ngModel'],
	    link: {
	      pre: function(scope, element, attr, ctrls) {
	        if (ctrls[0]) {
	          (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer,
	                                                              $browser, $filter, $parse);
	        }
	      }
	    }
	  };
	}];
	
	
	
	var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
	/**
	 * @ngdoc directive
	 * @name ngValue
	 *
	 * @description
	 * Binds the given expression to the value of the element.
	 *
	 * It is mainly used on {@link input[radio] `input[radio]`} and option elements,
	 * so that when the element is selected, the {@link ngModel `ngModel`} of that element (or its
	 * {@link select `select`} parent element) is set to the bound value. It is especially useful
	 * for dynamically generated lists using {@link ngRepeat `ngRepeat`}, as shown below.
	 *
	 * It can also be used to achieve one-way binding of a given expression to an input element
	 * such as an `input[text]` or a `textarea`, when that element does not use ngModel.
	 *
	 * @element input
	 * @param {string=} ngValue angular expression, whose value will be bound to the `value` attribute
	 * and `value` property of the element.
	 *
	 * @example
	    <example name="ngValue-directive" module="valueExample">
	      <file name="index.html">
	       <script>
	          angular.module('valueExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.names = ['pizza', 'unicorns', 'robots'];
	              $scope.my = { favorite: 'unicorns' };
	            }]);
	       </script>
	        <form ng-controller="ExampleController">
	          <h2>Which is your favorite?</h2>
	            <label ng-repeat="name in names" for="{{name}}">
	              {{name}}
	              <input type="radio"
	                     ng-model="my.favorite"
	                     ng-value="name"
	                     id="{{name}}"
	                     name="favorite">
	            </label>
	          <div>You chose {{my.favorite}}</div>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var favorite = element(by.binding('my.favorite'));
	
	        it('should initialize to model', function() {
	          expect(favorite.getText()).toContain('unicorns');
	        });
	        it('should bind the values to the inputs', function() {
	          element.all(by.model('my.favorite')).get(0).click();
	          expect(favorite.getText()).toContain('pizza');
	        });
	      </file>
	    </example>
	 */
	var ngValueDirective = function() {
	  /**
	   *  inputs use the value attribute as their default value if the value property is not set.
	   *  Once the value property has been set (by adding input), it will not react to changes to
	   *  the value attribute anymore. Setting both attribute and property fixes this behavior, and
	   *  makes it possible to use ngValue as a sort of one-way bind.
	   */
	  function updateElementValue(element, attr, value) {
	    // Support: IE9 only
	    // In IE9 values are converted to string (e.g. `input.value = null` results in `input.value === 'null'`).
	    var propValue = isDefined(value) ? value : (msie === 9) ? '' : null;
	    element.prop('value', propValue);
	    attr.$set('value', value);
	  }
	
	  return {
	    restrict: 'A',
	    priority: 100,
	    compile: function(tpl, tplAttr) {
	      if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
	        return function ngValueConstantLink(scope, elm, attr) {
	          var value = scope.$eval(attr.ngValue);
	          updateElementValue(elm, attr, value);
	        };
	      } else {
	        return function ngValueLink(scope, elm, attr) {
	          scope.$watch(attr.ngValue, function valueWatchAction(value) {
	            updateElementValue(elm, attr, value);
	          });
	        };
	      }
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngBind
	 * @restrict AC
	 *
	 * @description
	 * The `ngBind` attribute tells Angular to replace the text content of the specified HTML element
	 * with the value of a given expression, and to update the text content when the value of that
	 * expression changes.
	 *
	 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
	 * `{{ expression }}` which is similar but less verbose.
	 *
	 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
	 * displayed by the browser in its raw state before Angular compiles it. Since `ngBind` is an
	 * element attribute, it makes the bindings invisible to the user while the page is loading.
	 *
	 * An alternative solution to this problem would be using the
	 * {@link ng.directive:ngCloak ngCloak} directive.
	 *
	 *
	 * @element ANY
	 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
	   <example module="bindExample" name="ng-bind">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.name = 'Whirled';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter name: <input type="text" ng-model="name"></label><br>
	         Hello <span ng-bind="name"></span>!
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var nameInput = element(by.model('name'));
	
	         expect(element(by.binding('name')).getText()).toBe('Whirled');
	         nameInput.clear();
	         nameInput.sendKeys('world');
	         expect(element(by.binding('name')).getText()).toBe('world');
	       });
	     </file>
	   </example>
	 */
	var ngBindDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'AC',
	    compile: function ngBindCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBind);
	        element = element[0];
	        scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
	          element.textContent = stringify(value);
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindTemplate
	 *
	 * @description
	 * The `ngBindTemplate` directive specifies that the element
	 * text content should be replaced with the interpolation of the template
	 * in the `ngBindTemplate` attribute.
	 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
	 * expressions. This directive is needed since some HTML elements
	 * (such as TITLE and OPTION) cannot contain SPAN elements.
	 *
	 * @element ANY
	 * @param {string} ngBindTemplate template of form
	 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
	 *
	 * @example
	 * Try it here: enter text in text box and watch the greeting change.
	   <example module="bindExample" name="ng-bind-template">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.salutation = 'Hello';
	             $scope.name = 'World';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	        <label>Salutation: <input type="text" ng-model="salutation"></label><br>
	        <label>Name: <input type="text" ng-model="name"></label><br>
	        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var salutationElem = element(by.binding('salutation'));
	         var salutationInput = element(by.model('salutation'));
	         var nameInput = element(by.model('name'));
	
	         expect(salutationElem.getText()).toBe('Hello World!');
	
	         salutationInput.clear();
	         salutationInput.sendKeys('Greetings');
	         nameInput.clear();
	         nameInput.sendKeys('user');
	
	         expect(salutationElem.getText()).toBe('Greetings user!');
	       });
	     </file>
	   </example>
	 */
	var ngBindTemplateDirective = ['$interpolate', '$compile', function($interpolate, $compile) {
	  return {
	    compile: function ngBindTemplateCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindTemplateLink(scope, element, attr) {
	        var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
	        $compile.$$addBindingInfo(element, interpolateFn.expressions);
	        element = element[0];
	        attr.$observe('ngBindTemplate', function(value) {
	          element.textContent = isUndefined(value) ? '' : value;
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindHtml
	 *
	 * @description
	 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
	 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
	 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
	 * ngSanitize} in your module's dependencies (not in core Angular). In order to use {@link ngSanitize}
	 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
	 *
	 * You may also bypass sanitization for values you know are safe. To do so, bind to
	 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
	 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
	 *
	 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
	 * will have an exception (instead of an exploit.)
	 *
	 * @element ANY
	 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	
	   <example module="bindHtmlExample" deps="angular-sanitize.js" name="ng-bind-html">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	        <p ng-bind-html="myHTML"></p>
	       </div>
	     </file>
	
	     <file name="script.js">
	       angular.module('bindHtmlExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.myHTML =
	              'I am an <code>HTML</code>string with ' +
	              '<a href="#">links!</a> and other <em>stuff</em>';
	         }]);
	     </file>
	
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind-html', function() {
	         expect(element(by.binding('myHTML')).getText()).toBe(
	             'I am an HTMLstring with links! and other stuff');
	       });
	     </file>
	   </example>
	 */
	var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function($sce, $parse, $compile) {
	  return {
	    restrict: 'A',
	    compile: function ngBindHtmlCompile(tElement, tAttrs) {
	      var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
	      var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
	        // Unwrap the value to compare the actual inner safe value, not the wrapper object.
	        return $sce.valueOf(val);
	      });
	      $compile.$$addBindingClass(tElement);
	
	      return function ngBindHtmlLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBindHtml);
	
	        scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
	          // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
	          var value = ngBindHtmlGetter(scope);
	          element.html($sce.getTrustedHtml(value) || '');
	        });
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngChange
	 *
	 * @description
	 * Evaluate the given expression when the user changes the input.
	 * The expression is evaluated immediately, unlike the JavaScript onchange event
	 * which only triggers at the end of a change (usually, when the user leaves the
	 * form element or presses the return key).
	 *
	 * The `ngChange` expression is only evaluated when a change in the input value causes
	 * a new value to be committed to the model.
	 *
	 * It will not be evaluated:
	 * * if the value returned from the `$parsers` transformation pipeline has not changed
	 * * if the input has continued to be invalid since the model will stay `null`
	 * * if the model is changed programmatically and not by a change to the input value
	 *
	 *
	 * Note, this directive requires `ngModel` to be present.
	 *
	 * @element input
	 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
	 * in input value.
	 *
	 * @example
	 * <example name="ngChange-directive" module="changeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('changeExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.counter = 0;
	 *           $scope.change = function() {
	 *             $scope.counter++;
	 *           };
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
	 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
	 *       <label for="ng-change-example2">Confirmed</label><br />
	 *       <tt>debug = {{confirmed}}</tt><br/>
	 *       <tt>counter = {{counter}}</tt><br/>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var counter = element(by.binding('counter'));
	 *     var debug = element(by.binding('confirmed'));
	 *
	 *     it('should evaluate the expression if changing from view', function() {
	 *       expect(counter.getText()).toContain('0');
	 *
	 *       element(by.id('ng-change-example1')).click();
	 *
	 *       expect(counter.getText()).toContain('1');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *
	 *     it('should not evaluate the expression if changing from model', function() {
	 *       element(by.id('ng-change-example2')).click();
	
	 *       expect(counter.getText()).toContain('0');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *   </file>
	 * </example>
	 */
	var ngChangeDirective = valueFn({
	  restrict: 'A',
	  require: 'ngModel',
	  link: function(scope, element, attr, ctrl) {
	    ctrl.$viewChangeListeners.push(function() {
	      scope.$eval(attr.ngChange);
	    });
	  }
	});
	
	/* exported
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective
	*/
	
	function classDirective(name, selector) {
	  name = 'ngClass' + name;
	  var indexWatchExpression;
	
	  return ['$parse', function($parse) {
	    return {
	      restrict: 'AC',
	      link: function(scope, element, attr) {
	        var classCounts = element.data('$classCounts');
	        var oldModulo = true;
	        var oldClassString;
	
	        if (!classCounts) {
	          // Use createMap() to prevent class assumptions involving property
	          // names in Object.prototype
	          classCounts = createMap();
	          element.data('$classCounts', classCounts);
	        }
	
	        if (name !== 'ngClass') {
	          if (!indexWatchExpression) {
	            indexWatchExpression = $parse('$index', function moduloTwo($index) {
	              // eslint-disable-next-line no-bitwise
	              return $index & 1;
	            });
	          }
	
	          scope.$watch(indexWatchExpression, ngClassIndexWatchAction);
	        }
	
	        scope.$watch($parse(attr[name], toClassString), ngClassWatchAction);
	
	        function addClasses(classString) {
	          classString = digestClassCounts(split(classString), 1);
	          attr.$addClass(classString);
	        }
	
	        function removeClasses(classString) {
	          classString = digestClassCounts(split(classString), -1);
	          attr.$removeClass(classString);
	        }
	
	        function updateClasses(oldClassString, newClassString) {
	          var oldClassArray = split(oldClassString);
	          var newClassArray = split(newClassString);
	
	          var toRemoveArray = arrayDifference(oldClassArray, newClassArray);
	          var toAddArray = arrayDifference(newClassArray, oldClassArray);
	
	          var toRemoveString = digestClassCounts(toRemoveArray, -1);
	          var toAddString = digestClassCounts(toAddArray, 1);
	
	          attr.$addClass(toAddString);
	          attr.$removeClass(toRemoveString);
	        }
	
	        function digestClassCounts(classArray, count) {
	          var classesToUpdate = [];
	
	          forEach(classArray, function(className) {
	            if (count > 0 || classCounts[className]) {
	              classCounts[className] = (classCounts[className] || 0) + count;
	              if (classCounts[className] === +(count > 0)) {
	                classesToUpdate.push(className);
	              }
	            }
	          });
	
	          return classesToUpdate.join(' ');
	        }
	
	        function ngClassIndexWatchAction(newModulo) {
	          // This watch-action should run before the `ngClassWatchAction()`, thus it
	          // adds/removes `oldClassString`. If the `ngClass` expression has changed as well, the
	          // `ngClassWatchAction()` will update the classes.
	          if (newModulo === selector) {
	            addClasses(oldClassString);
	          } else {
	            removeClasses(oldClassString);
	          }
	
	          oldModulo = newModulo;
	        }
	
	        function ngClassWatchAction(newClassString) {
	          // When using a one-time binding the newClassString will return
	          // the pre-interceptor value until the one-time is complete
	          if (!isString(newClassString)) {
	            newClassString = toClassString(newClassString);
	          }
	
	          if (oldModulo === selector) {
	            updateClasses(oldClassString, newClassString);
	          }
	
	          oldClassString = newClassString;
	        }
	      }
	    };
	  }];
	
	  // Helpers
	  function arrayDifference(tokens1, tokens2) {
	    if (!tokens1 || !tokens1.length) return [];
	    if (!tokens2 || !tokens2.length) return tokens1;
	
	    var values = [];
	
	    outer:
	    for (var i = 0; i < tokens1.length; i++) {
	      var token = tokens1[i];
	      for (var j = 0; j < tokens2.length; j++) {
	        if (token === tokens2[j]) continue outer;
	      }
	      values.push(token);
	    }
	
	    return values;
	  }
	
	  function split(classString) {
	    return classString && classString.split(' ');
	  }
	
	  function toClassString(classValue) {
	    var classString = classValue;
	
	    if (isArray(classValue)) {
	      classString = classValue.map(toClassString).join(' ');
	    } else if (isObject(classValue)) {
	      classString = Object.keys(classValue).
	        filter(function(key) { return classValue[key]; }).
	        join(' ');
	    }
	
	    return classString;
	  }
	}
	
	/**
	 * @ngdoc directive
	 * @name ngClass
	 * @restrict AC
	 *
	 * @description
	 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
	 * an expression that represents all classes to be added.
	 *
	 * The directive operates in three different ways, depending on which of three types the expression
	 * evaluates to:
	 *
	 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
	 * names.
	 *
	 * 2. If the expression evaluates to an object, then for each key-value pair of the
	 * object with a truthy value the corresponding key is used as a class name.
	 *
	 * 3. If the expression evaluates to an array, each element of the array should either be a string as in
	 * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
	 * to give you more control over what CSS classes appear. See the code below for an example of this.
	 *
	 *
	 * The directive won't add duplicate classes if a particular class was already set.
	 *
	 * When the expression changes, the previously added classes are removed and only then are the
	 * new classes added.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `class`
	 * attribute, when using the `ngClass` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	 *
	 * @element ANY
	 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class
	 *   names, an array, or a map of class names to boolean values. In the case of a map, the
	 *   names of the properties whose values are truthy will be added as css classes to the
	 *   element.
	 *
	 * @example Example that demonstrates basic bindings via ngClass directive.
	   <example name="ng-class">
	     <file name="index.html">
	       <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
	       <label>
	          <input type="checkbox" ng-model="deleted">
	          deleted (apply "strike" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="important">
	          important (apply "bold" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="error">
	          error (apply "has-error" class)
	       </label>
	       <hr>
	       <p ng-class="style">Using String Syntax</p>
	       <input type="text" ng-model="style"
	              placeholder="Type: bold strike red" aria-label="Type: bold strike red">
	       <hr>
	       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
	       <input ng-model="style1"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
	       <input ng-model="style2"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
	       <input ng-model="style3"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
	       <hr>
	       <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
	       <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
	       <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
	     </file>
	     <file name="style.css">
	       .strike {
	           text-decoration: line-through;
	       }
	       .bold {
	           font-weight: bold;
	       }
	       .red {
	           color: red;
	       }
	       .has-error {
	           color: red;
	           background-color: yellow;
	       }
	       .orange {
	           color: orange;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var ps = element.all(by.css('p'));
	
	       it('should let you toggle the class', function() {
	
	         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
	         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);
	
	         element(by.model('important')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/bold/);
	
	         element(by.model('error')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
	       });
	
	       it('should let you toggle string example', function() {
	         expect(ps.get(1).getAttribute('class')).toBe('');
	         element(by.model('style')).clear();
	         element(by.model('style')).sendKeys('red');
	         expect(ps.get(1).getAttribute('class')).toBe('red');
	       });
	
	       it('array example should have 3 classes', function() {
	         expect(ps.get(2).getAttribute('class')).toBe('');
	         element(by.model('style1')).sendKeys('bold');
	         element(by.model('style2')).sendKeys('strike');
	         element(by.model('style3')).sendKeys('red');
	         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
	       });
	
	       it('array with map example should have 2 classes', function() {
	         expect(ps.last().getAttribute('class')).toBe('');
	         element(by.model('style4')).sendKeys('bold');
	         element(by.model('warning')).click();
	         expect(ps.last().getAttribute('class')).toBe('bold orange');
	       });
	     </file>
	   </example>
	
	   ## Animations
	
	   The example below demonstrates how to perform animations using ngClass.
	
	   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class">
	     <file name="index.html">
	      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
	      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
	      <br>
	      <span class="base-class" ng-class="myVar">Sample Text</span>
	     </file>
	     <file name="style.css">
	       .base-class {
	         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	       }
	
	       .base-class.my-class {
	         color: red;
	         font-size:3em;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class', function() {
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	
	         element(by.id('setbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).
	           toMatch(/my-class/);
	
	         element(by.id('clearbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	       });
	     </file>
	   </example>
	
	
	   ## ngClass and pre-existing CSS3 Transitions/Animations
	   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
	   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
	   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
	   to view the step by step details of {@link $animate#addClass $animate.addClass} and
	   {@link $animate#removeClass $animate.removeClass}.
	 */
	var ngClassDirective = classDirective('', true);
	
	/**
	 * @ngdoc directive
	 * @name ngClassOdd
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @element ANY
	 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example name="ng-class-odd">
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}}
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassOddDirective = classDirective('Odd', 0);
	
	/**
	 * @ngdoc directive
	 * @name ngClassEven
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @element ANY
	 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
	 *   result of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example name="ng-class-even">
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}} &nbsp; &nbsp; &nbsp;
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassEvenDirective = classDirective('Even', 1);
	
	/**
	 * @ngdoc directive
	 * @name ngCloak
	 * @restrict AC
	 *
	 * @description
	 * The `ngCloak` directive is used to prevent the Angular html template from being briefly
	 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
	 * directive to avoid the undesirable flicker effect caused by the html template display.
	 *
	 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
	 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
	 * of the browser view.
	 *
	 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
	 * `angular.min.js`.
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```css
	 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
	 *   display: none !important;
	 * }
	 * ```
	 *
	 * When this css rule is loaded by the browser, all html elements (including their children) that
	 * are tagged with the `ngCloak` directive are hidden. When Angular encounters this directive
	 * during the compilation of the template it deletes the `ngCloak` element attribute, making
	 * the compiled element visible.
	 *
	 * For the best result, the `angular.js` script must be loaded in the head section of the html
	 * document; alternatively, the css rule above must be included in the external stylesheet of the
	 * application.
	 *
	 * @element ANY
	 *
	 * @example
	   <example name="ng-cloak">
	     <file name="index.html">
	        <div id="template1" ng-cloak>{{ 'hello' }}</div>
	        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should remove the template directive and css class', function() {
	         expect($('#template1').getAttribute('ng-cloak')).
	           toBeNull();
	         expect($('#template2').getAttribute('ng-cloak')).
	           toBeNull();
	       });
	     </file>
	   </example>
	 *
	 */
	var ngCloakDirective = ngDirective({
	  compile: function(element, attr) {
	    attr.$set('ngCloak', undefined);
	    element.removeClass('ng-cloak');
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngController
	 *
	 * @description
	 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
	 * supports the principles behind the Model-View-Controller design pattern.
	 *
	 * MVC components in angular:
	 *
	 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
	 *   are accessed through bindings.
	 * * View — The template (HTML with data bindings) that is rendered into the View.
	 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
	 *   logic behind the application to decorate the scope with functions and values
	 *
	 * Note that you can also attach controllers to the DOM by declaring it in a route definition
	 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
	 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
	 * and executed twice.
	 *
	 * @element ANY
	 * @scope
	 * @priority 500
	 * @param {expression} ngController Name of a constructor function registered with the current
	 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
	 * that on the current scope evaluates to a constructor function.
	 *
	 * The controller instance can be published into a scope property by specifying
	 * `ng-controller="as propertyName"`.
	 *
	 * If the current `$controllerProvider` is configured to use globals (via
	 * {@link ng.$controllerProvider#allowGlobals `$controllerProvider.allowGlobals()` }), this may
	 * also be the name of a globally accessible constructor function (deprecated, not recommended).
	 *
	 * @example
	 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
	 * greeting are methods declared on the controller (see source tab). These methods can
	 * easily be called from the angular markup. Any changes to the data are automatically reflected
	 * in the View without the need for a manual update.
	 *
	 * Two different declaration styles are included below:
	 *
	 * * one binds methods and properties directly onto the controller using `this`:
	 * `ng-controller="SettingsController1 as settings"`
	 * * one injects `$scope` into the controller:
	 * `ng-controller="SettingsController2"`
	 *
	 * The second option is more common in the Angular community, and is generally used in boilerplates
	 * and in this guide. However, there are advantages to binding properties directly to the controller
	 * and avoiding scope.
	 *
	 * * Using `controller as` makes it obvious which controller you are accessing in the template when
	 * multiple controllers apply to an element.
	 * * If you are writing your controllers as classes you have easier access to the properties and
	 * methods, which will appear on the scope, from inside the controller code.
	 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
	 * inheritance masking primitives.
	 *
	 * This example demonstrates the `controller as` syntax.
	 *
	 * <example name="ngControllerAs" module="controllerAsExample">
	 *   <file name="index.html">
	 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
	 *      <label>Name: <input type="text" ng-model="settings.name"/></label>
	 *      <button ng-click="settings.greet()">greet</button><br/>
	 *      Contact:
	 *      <ul>
	 *        <li ng-repeat="contact in settings.contacts">
	 *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
	 *             <option>phone</option>
	 *             <option>email</option>
	 *          </select>
	 *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *          <button ng-click="settings.clearContact(contact)">clear</button>
	 *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
	 *        </li>
	 *        <li><button ng-click="settings.addContact()">add</button></li>
	 *     </ul>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('controllerAsExample', [])
	 *      .controller('SettingsController1', SettingsController1);
	 *
	 *    function SettingsController1() {
	 *      this.name = 'John Smith';
	 *      this.contacts = [
	 *        {type: 'phone', value: '408 555 1212'},
	 *        {type: 'email', value: 'john.smith@example.org'}
	 *      ];
	 *    }
	 *
	 *    SettingsController1.prototype.greet = function() {
	 *      alert(this.name);
	 *    };
	 *
	 *    SettingsController1.prototype.addContact = function() {
	 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
	 *    };
	 *
	 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
	 *     var index = this.contacts.indexOf(contactToRemove);
	 *      this.contacts.splice(index, 1);
	 *    };
	 *
	 *    SettingsController1.prototype.clearContact = function(contact) {
	 *      contact.type = 'phone';
	 *      contact.value = '';
	 *    };
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should check controller as', function() {
	 *       var container = element(by.id('ctrl-as-exmpl'));
	 *         expect(container.element(by.model('settings.name'))
	 *           .getAttribute('value')).toBe('John Smith');
	 *
	 *       var firstRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(0));
	 *       var secondRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(1));
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('408 555 1212');
	 *
	 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('john.smith@example.org');
	 *
	 *       firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('');
	 *
	 *       container.element(by.buttonText('add')).click();
	 *
	 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
	 *           .element(by.model('contact.value'))
	 *           .getAttribute('value'))
	 *           .toBe('yourname@example.org');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * This example demonstrates the "attach to `$scope`" style of controller.
	 *
	 * <example name="ngController" module="controllerExample">
	 *  <file name="index.html">
	 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
	 *     <label>Name: <input type="text" ng-model="name"/></label>
	 *     <button ng-click="greet()">greet</button><br/>
	 *     Contact:
	 *     <ul>
	 *       <li ng-repeat="contact in contacts">
	 *         <select ng-model="contact.type" id="select_{{$index}}">
	 *            <option>phone</option>
	 *            <option>email</option>
	 *         </select>
	 *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *         <button ng-click="clearContact(contact)">clear</button>
	 *         <button ng-click="removeContact(contact)">X</button>
	 *       </li>
	 *       <li>[ <button ng-click="addContact()">add</button> ]</li>
	 *    </ul>
	 *   </div>
	 *  </file>
	 *  <file name="app.js">
	 *   angular.module('controllerExample', [])
	 *     .controller('SettingsController2', ['$scope', SettingsController2]);
	 *
	 *   function SettingsController2($scope) {
	 *     $scope.name = 'John Smith';
	 *     $scope.contacts = [
	 *       {type:'phone', value:'408 555 1212'},
	 *       {type:'email', value:'john.smith@example.org'}
	 *     ];
	 *
	 *     $scope.greet = function() {
	 *       alert($scope.name);
	 *     };
	 *
	 *     $scope.addContact = function() {
	 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
	 *     };
	 *
	 *     $scope.removeContact = function(contactToRemove) {
	 *       var index = $scope.contacts.indexOf(contactToRemove);
	 *       $scope.contacts.splice(index, 1);
	 *     };
	 *
	 *     $scope.clearContact = function(contact) {
	 *       contact.type = 'phone';
	 *       contact.value = '';
	 *     };
	 *   }
	 *  </file>
	 *  <file name="protractor.js" type="protractor">
	 *    it('should check controller', function() {
	 *      var container = element(by.id('ctrl-exmpl'));
	 *
	 *      expect(container.element(by.model('name'))
	 *          .getAttribute('value')).toBe('John Smith');
	 *
	 *      var firstRepeat =
	 *          container.element(by.repeater('contact in contacts').row(0));
	 *      var secondRepeat =
	 *          container.element(by.repeater('contact in contacts').row(1));
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('408 555 1212');
	 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('john.smith@example.org');
	 *
	 *      firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('');
	 *
	 *      container.element(by.buttonText('add')).click();
	 *
	 *      expect(container.element(by.repeater('contact in contacts').row(2))
	 *          .element(by.model('contact.value'))
	 *          .getAttribute('value'))
	 *          .toBe('yourname@example.org');
	 *    });
	 *  </file>
	 *</example>
	
	 */
	var ngControllerDirective = [function() {
	  return {
	    restrict: 'A',
	    scope: true,
	    controller: '@',
	    priority: 500
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngCsp
	 *
	 * @restrict A
	 * @element ANY
	 * @description
	 *
	 * Angular has some features that can conflict with certain restrictions that are applied when using
	 * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
	 *
	 * If you intend to implement CSP with these rules then you must tell Angular not to use these
	 * features.
	 *
	 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
	 *
	 *
	 * The following default rules in CSP affect Angular:
	 *
	 * * The use of `eval()`, `Function(string)` and similar functions to dynamically create and execute
	 * code from strings is forbidden. Angular makes use of this in the {@link $parse} service to
	 * provide a 30% increase in the speed of evaluating Angular expressions. (This CSP rule can be
	 * disabled with the CSP keyword `unsafe-eval`, but it is generally not recommended as it would
	 * weaken the protections offered by CSP.)
	 *
	 * * The use of inline resources, such as inline `<script>` and `<style>` elements, are forbidden.
	 * This prevents apps from injecting custom styles directly into the document. Angular makes use of
	 * this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}). To make these
	 * directives work when a CSP rule is blocking inline styles, you must link to the `angular-csp.css`
	 * in your HTML manually. (This CSP rule can be disabled with the CSP keyword `unsafe-inline`, but
	 * it is generally not recommended as it would weaken the protections offered by CSP.)
	 *
	 * If you do not provide `ngCsp` then Angular tries to autodetect if CSP is blocking dynamic code
	 * creation from strings (e.g., `unsafe-eval` not specified in CSP header) and automatically
	 * deactivates this feature in the {@link $parse} service. This autodetection, however, triggers a
	 * CSP error to be logged in the console:
	 *
	 * ```
	 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
	 * script in the following Content Security Policy directive: "default-src 'self'". Note that
	 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
	 * ```
	 *
	 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
	 * directive on an element of the HTML document that appears before the `<script>` tag that loads
	 * the `angular.js` file.
	 *
	 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
	 *
	 * You can specify which of the CSP related Angular features should be deactivated by providing
	 * a value for the `ng-csp` attribute. The options are as follows:
	 *
	 * * no-inline-style: this stops Angular from injecting CSS styles into the DOM
	 *
	 * * no-unsafe-eval: this stops Angular from optimizing $parse with unsafe eval of strings
	 *
	 * You can use these values in the following combinations:
	 *
	 *
	 * * No declaration means that Angular will assume that you can do inline styles, but it will do
	 * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous
	 * versions of Angular.
	 *
	 * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell Angular to deactivate both inline
	 * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous
	 * versions of Angular.
	 *
	 * * Specifying only `no-unsafe-eval` tells Angular that we must not use eval, but that we can
	 * inject inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
	 *
	 * * Specifying only `no-inline-style` tells Angular that we must not inject styles, but that we can
	 * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
	 *
	 * * Specifying both `no-unsafe-eval` and `no-inline-style` tells Angular that we must not inject
	 * styles nor use eval, which is the same as an empty: ng-csp.
	 * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
	 *
	 * @example
	 * This example shows how to apply the `ngCsp` directive to the `html` tag.
	   ```html
	     <!doctype html>
	     <html ng-app ng-csp>
	     ...
	     ...
	     </html>
	   ```
	  * @example
	      <!-- Note: the `.csp` suffix in the example name triggers CSP mode in our http server! -->
	      <example name="example.csp" module="cspExample" ng-csp="true">
	        <file name="index.html">
	          <div ng-controller="MainController as ctrl">
	            <div>
	              <button ng-click="ctrl.inc()" id="inc">Increment</button>
	              <span id="counter">
	                {{ctrl.counter}}
	              </span>
	            </div>
	
	            <div>
	              <button ng-click="ctrl.evil()" id="evil">Evil</button>
	              <span id="evilError">
	                {{ctrl.evilError}}
	              </span>
	            </div>
	          </div>
	        </file>
	        <file name="script.js">
	           angular.module('cspExample', [])
	             .controller('MainController', function MainController() {
	                this.counter = 0;
	                this.inc = function() {
	                  this.counter++;
	                };
	                this.evil = function() {
	                  try {
	                    eval('1+2'); // eslint-disable-line no-eval
	                  } catch (e) {
	                    this.evilError = e.message;
	                  }
	                };
	              });
	        </file>
	        <file name="protractor.js" type="protractor">
	          var util, webdriver;
	
	          var incBtn = element(by.id('inc'));
	          var counter = element(by.id('counter'));
	          var evilBtn = element(by.id('evil'));
	          var evilError = element(by.id('evilError'));
	
	          function getAndClearSevereErrors() {
	            return browser.manage().logs().get('browser').then(function(browserLog) {
	              return browserLog.filter(function(logEntry) {
	                return logEntry.level.value > webdriver.logging.Level.WARNING.value;
	              });
	            });
	          }
	
	          function clearErrors() {
	            getAndClearSevereErrors();
	          }
	
	          function expectNoErrors() {
	            getAndClearSevereErrors().then(function(filteredLog) {
	              expect(filteredLog.length).toEqual(0);
	              if (filteredLog.length) {
	                console.log('browser console errors: ' + util.inspect(filteredLog));
	              }
	            });
	          }
	
	          function expectError(regex) {
	            getAndClearSevereErrors().then(function(filteredLog) {
	              var found = false;
	              filteredLog.forEach(function(log) {
	                if (log.message.match(regex)) {
	                  found = true;
	                }
	              });
	              if (!found) {
	                throw new Error('expected an error that matches ' + regex);
	              }
	            });
	          }
	
	          beforeEach(function() {
	            util = require('util');
	            webdriver = require('selenium-webdriver');
	          });
	
	          // For now, we only test on Chrome,
	          // as Safari does not load the page with Protractor's injected scripts,
	          // and Firefox webdriver always disables content security policy (#6358)
	          if (browser.params.browser !== 'chrome') {
	            return;
	          }
	
	          it('should not report errors when the page is loaded', function() {
	            // clear errors so we are not dependent on previous tests
	            clearErrors();
	            // Need to reload the page as the page is already loaded when
	            // we come here
	            browser.driver.getCurrentUrl().then(function(url) {
	              browser.get(url);
	            });
	            expectNoErrors();
	          });
	
	          it('should evaluate expressions', function() {
	            expect(counter.getText()).toEqual('0');
	            incBtn.click();
	            expect(counter.getText()).toEqual('1');
	            expectNoErrors();
	          });
	
	          it('should throw and report an error when using "eval"', function() {
	            evilBtn.click();
	            expect(evilError.getText()).toMatch(/Content Security Policy/);
	            expectError(/Content Security Policy/);
	          });
	        </file>
	      </example>
	  */
	
	// `ngCsp` is not implemented as a proper directive any more, because we need it be processed while
	// we bootstrap the app (before `$parse` is instantiated). For this reason, we just have the `csp()`
	// fn that looks for the `ng-csp` attribute anywhere in the current doc.
	
	/**
	 * @ngdoc directive
	 * @name ngClick
	 *
	 * @description
	 * The ngClick directive allows you to specify custom behavior when
	 * an element is clicked.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
	 * click. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-click">
	     <file name="index.html">
	      <button ng-click="count = count + 1" ng-init="count=0">
	        Increment
	      </button>
	      <span>
	        count: {{count}}
	      </span>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-click', function() {
	         expect(element(by.binding('count')).getText()).toMatch('0');
	         element(by.css('button')).click();
	         expect(element(by.binding('count')).getText()).toMatch('1');
	       });
	     </file>
	   </example>
	 */
	/*
	 * A collection of directives that allows creation of custom event handlers that are defined as
	 * angular expressions and are compiled and executed within the current scope.
	 */
	var ngEventDirectives = {};
	
	// For events that might fire synchronously during DOM manipulation
	// we need to execute their event handlers asynchronously using $evalAsync,
	// so that they are not executed in an inconsistent state.
	var forceAsyncEvents = {
	  'blur': true,
	  'focus': true
	};
	forEach(
	  'click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '),
	  function(eventName) {
	    var directiveName = directiveNormalize('ng-' + eventName);
	    ngEventDirectives[directiveName] = ['$parse', '$rootScope', function($parse, $rootScope) {
	      return {
	        restrict: 'A',
	        compile: function($element, attr) {
	          // NOTE:
	          // We expose the powerful `$event` object on the scope that provides access to the Window,
	          // etc. This is OK, because expressions are not sandboxed any more (and the expression
	          // sandbox was never meant to be a security feature anyway).
	          var fn = $parse(attr[directiveName]);
	          return function ngEventHandler(scope, element) {
	            element.on(eventName, function(event) {
	              var callback = function() {
	                fn(scope, {$event: event});
	              };
	              if (forceAsyncEvents[eventName] && $rootScope.$$phase) {
	                scope.$evalAsync(callback);
	              } else {
	                scope.$apply(callback);
	              }
	            });
	          };
	        }
	      };
	    }];
	  }
	);
	
	/**
	 * @ngdoc directive
	 * @name ngDblclick
	 *
	 * @description
	 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
	 * a dblclick. (The Event object is available as `$event`)
	 *
	 * @example
	   <example name="ng-dblclick">
	     <file name="index.html">
	      <button ng-dblclick="count = count + 1" ng-init="count=0">
	        Increment (on double click)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousedown
	 *
	 * @description
	 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
	 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mousedown">
	     <file name="index.html">
	      <button ng-mousedown="count = count + 1" ng-init="count=0">
	        Increment (on mouse down)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseup
	 *
	 * @description
	 * Specify custom behavior on mouseup event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
	 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseup">
	     <file name="index.html">
	      <button ng-mouseup="count = count + 1" ng-init="count=0">
	        Increment (on mouse up)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngMouseover
	 *
	 * @description
	 * Specify custom behavior on mouseover event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
	 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseover">
	     <file name="index.html">
	      <button ng-mouseover="count = count + 1" ng-init="count=0">
	        Increment (when mouse is over)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseenter
	 *
	 * @description
	 * Specify custom behavior on mouseenter event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
	 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseenter">
	     <file name="index.html">
	      <button ng-mouseenter="count = count + 1" ng-init="count=0">
	        Increment (when mouse enters)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseleave
	 *
	 * @description
	 * Specify custom behavior on mouseleave event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
	 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseleave">
	     <file name="index.html">
	      <button ng-mouseleave="count = count + 1" ng-init="count=0">
	        Increment (when mouse leaves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousemove
	 *
	 * @description
	 * Specify custom behavior on mousemove event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
	 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mousemove">
	     <file name="index.html">
	      <button ng-mousemove="count = count + 1" ng-init="count=0">
	        Increment (when mouse moves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeydown
	 *
	 * @description
	 * Specify custom behavior on keydown event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
	 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keydown">
	     <file name="index.html">
	      <input ng-keydown="count = count + 1" ng-init="count=0">
	      key down count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeyup
	 *
	 * @description
	 * Specify custom behavior on keyup event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
	 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keyup">
	     <file name="index.html">
	       <p>Typing in the input box below updates the key count</p>
	       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}
	
	       <p>Typing in the input box below updates the keycode</p>
	       <input ng-keyup="event=$event">
	       <p>event keyCode: {{ event.keyCode }}</p>
	       <p>event altKey: {{ event.altKey }}</p>
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeypress
	 *
	 * @description
	 * Specify custom behavior on keypress event.
	 *
	 * @element ANY
	 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
	 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
	 * and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keypress">
	     <file name="index.html">
	      <input ng-keypress="count = count + 1" ng-init="count=0">
	      key press count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSubmit
	 *
	 * @description
	 * Enables binding angular expressions to onsubmit events.
	 *
	 * Additionally it prevents the default action (which for form means sending the request to the
	 * server and reloading the current page), but only if the form does not contain `action`,
	 * `data-action`, or `x-action` attributes.
	 *
	 * <div class="alert alert-warning">
	 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
	 * `ngSubmit` handlers together. See the
	 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
	 * for a detailed discussion of when `ngSubmit` may be triggered.
	 * </div>
	 *
	 * @element form
	 * @priority 0
	 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
	 * ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example module="submitExample" name="ng-submit">
	     <file name="index.html">
	      <script>
	        angular.module('submitExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.list = [];
	            $scope.text = 'hello';
	            $scope.submit = function() {
	              if ($scope.text) {
	                $scope.list.push(this.text);
	                $scope.text = '';
	              }
	            };
	          }]);
	      </script>
	      <form ng-submit="submit()" ng-controller="ExampleController">
	        Enter text and hit enter:
	        <input type="text" ng-model="text" name="text" />
	        <input type="submit" id="submit" value="Submit" />
	        <pre>list={{list}}</pre>
	      </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-submit', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	         expect(element(by.model('text')).getAttribute('value')).toBe('');
	       });
	       it('should ignore empty strings', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	        });
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngFocus
	 *
	 * @description
	 * Specify custom behavior on focus event.
	 *
	 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
	 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngBlur
	 *
	 * @description
	 * Specify custom behavior on blur event.
	 *
	 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
	 * an element has lost focus.
	 *
	 * Note: As the `blur` event is executed synchronously also during DOM manipulations
	 * (e.g. removing a focussed input),
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
	 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCopy
	 *
	 * @description
	 * Specify custom behavior on copy event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
	 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-copy">
	     <file name="index.html">
	      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
	      copied: {{copied}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCut
	 *
	 * @description
	 * Specify custom behavior on cut event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
	 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-cut">
	     <file name="index.html">
	      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
	      cut: {{cut}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngPaste
	 *
	 * @description
	 * Specify custom behavior on paste event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
	 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-paste">
	     <file name="index.html">
	      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
	      pasted: {{paste}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngIf
	 * @restrict A
	 * @multiElement
	 *
	 * @description
	 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
	 * {expression}. If the expression assigned to `ngIf` evaluates to a false
	 * value then the element is removed from the DOM, otherwise a clone of the
	 * element is reinserted into the DOM.
	 *
	 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
	 * element in the DOM rather than changing its visibility via the `display` css property.  A common
	 * case when this difference is significant is when using css selectors that rely on an element's
	 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
	 *
	 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
	 * is created when the element is restored.  The scope created within `ngIf` inherits from
	 * its parent scope using
	 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
	 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
	 * a javascript primitive defined in the parent scope. In this case any modifications made to the
	 * variable within the child scope will override (hide) the value in the parent scope.
	 *
	 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
	 * is if an element's class attribute is directly modified after it's compiled, using something like
	 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
	 * the added class will be lost because the original compiled state is used to regenerate the element.
	 *
	 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
	 * and `leave` effects.
	 *
	 * @animations
	 * | Animation                        | Occurs                               |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
	 * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
	 *
	 * @element ANY
	 * @scope
	 * @priority 600
	 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
	 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
	 *     element is added to the DOM tree.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-if">
	    <file name="index.html">
	      <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
	      Show when checked:
	      <span ng-if="checked" class="animate-if">
	        This is removed when the checkbox is unchecked.
	      </span>
	    </file>
	    <file name="animations.css">
	      .animate-if {
	        background:white;
	        border:1px solid black;
	        padding:10px;
	      }
	
	      .animate-if.ng-enter, .animate-if.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	      }
	
	      .animate-if.ng-enter,
	      .animate-if.ng-leave.ng-leave-active {
	        opacity:0;
	      }
	
	      .animate-if.ng-leave,
	      .animate-if.ng-enter.ng-enter-active {
	        opacity:1;
	      }
	    </file>
	  </example>
	 */
	var ngIfDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    multiElement: true,
	    transclude: 'element',
	    priority: 600,
	    terminal: true,
	    restrict: 'A',
	    $$tlb: true,
	    link: function($scope, $element, $attr, ctrl, $transclude) {
	        var block, childScope, previousElements;
	        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {
	
	          if (value) {
	            if (!childScope) {
	              $transclude(function(clone, newScope) {
	                childScope = newScope;
	                clone[clone.length++] = $compile.$$createComment('end ngIf', $attr.ngIf);
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block = {
	                  clone: clone
	                };
	                $animate.enter(clone, $element.parent(), $element);
	              });
	            }
	          } else {
	            if (previousElements) {
	              previousElements.remove();
	              previousElements = null;
	            }
	            if (childScope) {
	              childScope.$destroy();
	              childScope = null;
	            }
	            if (block) {
	              previousElements = getBlockNodes(block.clone);
	              $animate.leave(previousElements).done(function(response) {
	                if (response !== false) previousElements = null;
	              });
	              block = null;
	            }
	          }
	        });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngInclude
	 * @restrict ECA
	 *
	 * @description
	 * Fetches, compiles and includes an external HTML fragment.
	 *
	 * By default, the template URL is restricted to the same domain and protocol as the
	 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
	 * you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist them} or
	 * {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to Angular's {@link
	 * ng.$sce Strict Contextual Escaping}.
	 *
	 * In addition, the browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy may further restrict whether the template is successfully loaded.
	 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
	 * access on some browsers.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
	 * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
	 *
	 * The enter and leave animation occur concurrently.
	 *
	 * @scope
	 * @priority 400
	 *
	 * @param {string} ngInclude|src angular expression evaluating to URL. If the source is a string constant,
	 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
	 * @param {string=} onload Expression to evaluate when a new partial is loaded.
	 *                  <div class="alert alert-warning">
	 *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
	 *                  a function with the name on the window element, which will usually throw a
	 *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
	 *                  different form that {@link guide/directive#normalization matches} `onload`.
	 *                  </div>
	   *
	 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
	 *                  $anchorScroll} to scroll the viewport after the content is loaded.
	 *
	 *                  - If the attribute is not set, disable scrolling.
	 *                  - If the attribute is set without value, enable scrolling.
	 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
	 *
	 * @example
	  <example module="includeExample" deps="angular-animate.js" animations="true" name="ng-include">
	    <file name="index.html">
	     <div ng-controller="ExampleController">
	       <select ng-model="template" ng-options="t.name for t in templates">
	        <option value="">(blank)</option>
	       </select>
	       url of the template: <code>{{template.url}}</code>
	       <hr/>
	       <div class="slide-animate-container">
	         <div class="slide-animate" ng-include="template.url"></div>
	       </div>
	     </div>
	    </file>
	    <file name="script.js">
	      angular.module('includeExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.templates =
	            [{ name: 'template1.html', url: 'template1.html'},
	             { name: 'template2.html', url: 'template2.html'}];
	          $scope.template = $scope.templates[0];
	        }]);
	     </file>
	    <file name="template1.html">
	      Content of template1.html
	    </file>
	    <file name="template2.html">
	      Content of template2.html
	    </file>
	    <file name="animations.css">
	      .slide-animate-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .slide-animate {
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter, .slide-animate.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	        display:block;
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter {
	        top:-50px;
	      }
	      .slide-animate.ng-enter.ng-enter-active {
	        top:0;
	      }
	
	      .slide-animate.ng-leave {
	        top:0;
	      }
	      .slide-animate.ng-leave.ng-leave-active {
	        top:50px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var templateSelect = element(by.model('template'));
	      var includeElem = element(by.css('[ng-include]'));
	
	      it('should load template1.html', function() {
	        expect(includeElem.getText()).toMatch(/Content of template1.html/);
	      });
	
	      it('should load template2.html', function() {
	        if (browser.params.browser === 'firefox') {
	          // Firefox can't handle using selects
	          // See https://github.com/angular/protractor/issues/480
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(2).click();
	        expect(includeElem.getText()).toMatch(/Content of template2.html/);
	      });
	
	      it('should change to blank', function() {
	        if (browser.params.browser === 'firefox') {
	          // Firefox can't handle using selects
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(0).click();
	        expect(includeElem.isPresent()).toBe(false);
	      });
	    </file>
	  </example>
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentRequested
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted every time the ngInclude content is requested.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentLoaded
	 * @eventType emit on the current ngInclude scope
	 * @description
	 * Emitted every time the ngInclude content is reloaded.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentError
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate',
	                  function($templateRequest,   $anchorScroll,   $animate) {
	  return {
	    restrict: 'ECA',
	    priority: 400,
	    terminal: true,
	    transclude: 'element',
	    controller: angular.noop,
	    compile: function(element, attr) {
	      var srcExp = attr.ngInclude || attr.src,
	          onloadExp = attr.onload || '',
	          autoScrollExp = attr.autoscroll;
	
	      return function(scope, $element, $attr, ctrl, $transclude) {
	        var changeCounter = 0,
	            currentScope,
	            previousElement,
	            currentElement;
	
	        var cleanupLastIncludeContent = function() {
	          if (previousElement) {
	            previousElement.remove();
	            previousElement = null;
	          }
	          if (currentScope) {
	            currentScope.$destroy();
	            currentScope = null;
	          }
	          if (currentElement) {
	            $animate.leave(currentElement).done(function(response) {
	              if (response !== false) previousElement = null;
	            });
	            previousElement = currentElement;
	            currentElement = null;
	          }
	        };
	
	        scope.$watch(srcExp, function ngIncludeWatchAction(src) {
	          var afterAnimation = function(response) {
	            if (response !== false && isDefined(autoScrollExp) &&
	              (!autoScrollExp || scope.$eval(autoScrollExp))) {
	                $anchorScroll();
	            }
	          };
	          var thisChangeId = ++changeCounter;
	
	          if (src) {
	            //set the 2nd param to true to ignore the template request error so that the inner
	            //contents and scope can be cleaned up.
	            $templateRequest(src, true).then(function(response) {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId !== changeCounter) return;
	              var newScope = scope.$new();
	              ctrl.template = response;
	
	              // Note: This will also link all children of ng-include that were contained in the original
	              // html. If that content contains controllers, ... they could pollute/change the scope.
	              // However, using ng-include on an element with additional content does not make sense...
	              // Note: We can't remove them in the cloneAttchFn of $transclude as that
	              // function is called before linking the content, which would apply child
	              // directives to non existing elements.
	              var clone = $transclude(newScope, function(clone) {
	                cleanupLastIncludeContent();
	                $animate.enter(clone, null, $element).done(afterAnimation);
	              });
	
	              currentScope = newScope;
	              currentElement = clone;
	
	              currentScope.$emit('$includeContentLoaded', src);
	              scope.$eval(onloadExp);
	            }, function() {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId === changeCounter) {
	                cleanupLastIncludeContent();
	                scope.$emit('$includeContentError', src);
	              }
	            });
	            scope.$emit('$includeContentRequested', src);
	          } else {
	            cleanupLastIncludeContent();
	            ctrl.template = null;
	          }
	        });
	      };
	    }
	  };
	}];
	
	// This directive is called during the $transclude call of the first `ngInclude` directive.
	// It will replace and compile the content of the element with the loaded template.
	// We need this directive so that the element content is already filled when
	// the link function of another directive on the same element as ngInclude
	// is called.
	var ngIncludeFillContentDirective = ['$compile',
	  function($compile) {
	    return {
	      restrict: 'ECA',
	      priority: -400,
	      require: 'ngInclude',
	      link: function(scope, $element, $attr, ctrl) {
	        if (toString.call($element[0]).match(/SVG/)) {
	          // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
	          // support innerHTML, so detect this here and try to generate the contents
	          // specially.
	          $element.empty();
	          $compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope,
	              function namespaceAdaptedClone(clone) {
	            $element.append(clone);
	          }, {futureParentElement: $element});
	          return;
	        }
	
	        $element.html(ctrl.template);
	        $compile($element.contents())(scope);
	      }
	    };
	  }];
	
	/**
	 * @ngdoc directive
	 * @name ngInit
	 * @restrict AC
	 *
	 * @description
	 * The `ngInit` directive allows you to evaluate an expression in the
	 * current scope.
	 *
	 * <div class="alert alert-danger">
	 * This directive can be abused to add unnecessary amounts of logic into your templates.
	 * There are only a few appropriate uses of `ngInit`, such as for aliasing special properties of
	 * {@link ng.directive:ngRepeat `ngRepeat`}, as seen in the demo below; and for injecting data via
	 * server side scripting. Besides these few cases, you should use {@link guide/controller controllers}
	 * rather than `ngInit` to initialize values on a scope.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
	 * sure you have parentheses to ensure correct operator precedence:
	 * <pre class="prettyprint">
	 * `<div ng-init="test1 = ($index | toString)"></div>`
	 * </pre>
	 * </div>
	 *
	 * @priority 450
	 *
	 * @element ANY
	 * @param {expression} ngInit {@link guide/expression Expression} to eval.
	 *
	 * @example
	   <example module="initExample" name="ng-init">
	     <file name="index.html">
	   <script>
	     angular.module('initExample', [])
	       .controller('ExampleController', ['$scope', function($scope) {
	         $scope.list = [['a', 'b'], ['c', 'd']];
	       }]);
	   </script>
	   <div ng-controller="ExampleController">
	     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
	       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
	          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
	       </div>
	     </div>
	   </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should alias index positions', function() {
	         var elements = element.all(by.css('.example-init'));
	         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
	         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
	         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
	         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
	       });
	     </file>
	   </example>
	 */
	var ngInitDirective = ngDirective({
	  priority: 450,
	  compile: function() {
	    return {
	      pre: function(scope, element, attrs) {
	        scope.$eval(attrs.ngInit);
	      }
	    };
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngList
	 *
	 * @description
	 * Text input that converts between a delimited string and an array of strings. The default
	 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
	 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
	 *
	 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
	 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
	 *   list item is respected. This implies that the user of the directive is responsible for
	 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
	 *   tab or newline character.
	 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
	 *   when joining the list items back together) and whitespace around each list item is stripped
	 *   before it is added to the model.
	 *
	 * ### Example with Validation
	 *
	 * <example name="ngList-directive" module="listExample">
	 *   <file name="app.js">
	 *      angular.module('listExample', [])
	 *        .controller('ExampleController', ['$scope', function($scope) {
	 *          $scope.names = ['morpheus', 'neo', 'trinity'];
	 *        }]);
	 *   </file>
	 *   <file name="index.html">
	 *    <form name="myForm" ng-controller="ExampleController">
	 *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
	 *      <span role="alert">
	 *        <span class="error" ng-show="myForm.namesInput.$error.required">
	 *        Required!</span>
	 *      </span>
	 *      <br>
	 *      <tt>names = {{names}}</tt><br/>
	 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
	 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
	 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	 *     </form>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var listInput = element(by.model('names'));
	 *     var names = element(by.exactBinding('names'));
	 *     var valid = element(by.binding('myForm.namesInput.$valid'));
	 *     var error = element(by.css('span.error'));
	 *
	 *     it('should initialize to model', function() {
	 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
	 *       expect(valid.getText()).toContain('true');
	 *       expect(error.getCssValue('display')).toBe('none');
	 *     });
	 *
	 *     it('should be invalid if empty', function() {
	 *       listInput.clear();
	 *       listInput.sendKeys('');
	 *
	 *       expect(names.getText()).toContain('');
	 *       expect(valid.getText()).toContain('false');
	 *       expect(error.getCssValue('display')).not.toBe('none');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * ### Example - splitting on newline
	 * <example name="ngList-directive-newlines">
	 *   <file name="index.html">
	 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
	 *    <pre>{{ list | json }}</pre>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it("should split the text by newlines", function() {
	 *       var listInput = element(by.model('list'));
	 *       var output = element(by.binding('list | json'));
	 *       listInput.sendKeys('abc\ndef\nghi');
	 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * @element input
	 * @param {string=} ngList optional delimiter that should be used to split the value.
	 */
	var ngListDirective = function() {
	  return {
	    restrict: 'A',
	    priority: 100,
	    require: 'ngModel',
	    link: function(scope, element, attr, ctrl) {
	      var ngList = attr.ngList || ', ';
	      var trimValues = attr.ngTrim !== 'false';
	      var separator = trimValues ? trim(ngList) : ngList;
	
	      var parse = function(viewValue) {
	        // If the viewValue is invalid (say required but empty) it will be `undefined`
	        if (isUndefined(viewValue)) return;
	
	        var list = [];
	
	        if (viewValue) {
	          forEach(viewValue.split(separator), function(value) {
	            if (value) list.push(trimValues ? trim(value) : value);
	          });
	        }
	
	        return list;
	      };
	
	      ctrl.$parsers.push(parse);
	      ctrl.$formatters.push(function(value) {
	        if (isArray(value)) {
	          return value.join(ngList);
	        }
	
	        return undefined;
	      });
	
	      // Override the standard $isEmpty because an empty array means the input is empty.
	      ctrl.$isEmpty = function(value) {
	        return !value || !value.length;
	      };
	    }
	  };
	};
	
	/* global VALID_CLASS: true,
	  INVALID_CLASS: true,
	  PRISTINE_CLASS: true,
	  DIRTY_CLASS: true,
	  UNTOUCHED_CLASS: true,
	  TOUCHED_CLASS: true,
	  PENDING_CLASS: true,
	  addSetValidityMethod: true,
	  setupValidity: true,
	  defaultModelOptions: false
	*/
	
	
	var VALID_CLASS = 'ng-valid',
	    INVALID_CLASS = 'ng-invalid',
	    PRISTINE_CLASS = 'ng-pristine',
	    DIRTY_CLASS = 'ng-dirty',
	    UNTOUCHED_CLASS = 'ng-untouched',
	    TOUCHED_CLASS = 'ng-touched',
	    EMPTY_CLASS = 'ng-empty',
	    NOT_EMPTY_CLASS = 'ng-not-empty';
	
	var ngModelMinErr = minErr('ngModel');
	
	/**
	 * @ngdoc type
	 * @name ngModel.NgModelController
	 *
	 * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
	 * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
	 * is set.
	 *
	 * @property {*} $modelValue The value in the model that the control is bound to.
	 *
	 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
	 *  the control updates the ngModelController with a new {@link ngModel.NgModelController#$viewValue
	    `$viewValue`} from the DOM, usually via user input.
	    See {@link ngModel.NgModelController#$setViewValue `$setViewValue()`} for a detailed lifecycle explanation.
	    Note that the `$parsers` are not called when the bound ngModel expression changes programmatically.
	
	  The functions are called in array order, each passing
	    its return value through to the next. The last return value is forwarded to the
	    {@link ngModel.NgModelController#$validators `$validators`} collection.
	
	  Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
	    `$viewValue`}.
	
	  Returning `undefined` from a parser means a parse error occurred. In that case,
	    no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
	    will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
	    is set to `true`. The parse error is stored in `ngModel.$error.parse`.
	
	  This simple example shows a parser that would convert text input value to lowercase:
	 * ```js
	 * function parse(value) {
	 *   if (value) {
	 *     return value.toLowerCase();
	 *   }
	 * }
	 * ngModelController.$parsers.push(parse);
	 * ```
	
	 *
	 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
	    the bound ngModel expression changes programmatically. The `$formatters` are not called when the
	    value of the control is changed by user interaction.
	
	  Formatters are used to format / convert the {@link ngModel.NgModelController#$modelValue
	    `$modelValue`} for display in the control.
	
	  The functions are called in reverse array order, each passing the value through to the
	    next. The last return value is used as the actual DOM value.
	
	  This simple example shows a formatter that would convert the model value to uppercase:
	
	 * ```js
	 * function format(value) {
	 *   if (value) {
	 *     return value.toUpperCase();
	 *   }
	 * }
	 * ngModel.$formatters.push(format);
	 * ```
	 *
	 * @property {Object.<string, function>} $validators A collection of validators that are applied
	 *      whenever the model value changes. The key value within the object refers to the name of the
	 *      validator while the function refers to the validation operation. The validation operation is
	 *      provided with the model value as an argument and must return a true or false value depending
	 *      on the response of that validation.
	 *
	 * ```js
	 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *   return /[0-9]+/.test(value) &&
	 *          /[a-z]+/.test(value) &&
	 *          /[A-Z]+/.test(value) &&
	 *          /\W+/.test(value);
	 * };
	 * ```
	 *
	 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
	 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
	 *      is expected to return a promise when it is run during the model validation process. Once the promise
	 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
	 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
	 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
	 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
	 *      will only run once all synchronous validators have passed.
	 *
	 * Please note that if $http is used then it is important that the server returns a success HTTP response code
	 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
	 *
	 * ```js
	 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *
	 *   // Lookup user by username
	 *   return $http.get('/api/users/' + value).
	 *      then(function resolved() {
	 *        //username exists, this means validation fails
	 *        return $q.reject('exists');
	 *      }, function rejected() {
	 *        //username does not exist, therefore this validation passes
	 *        return true;
	 *      });
	 * };
	 * ```
	 *
	 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever the
	 *     view value has changed. It is called with no arguments, and its return value is ignored.
	 *     This can be used in place of additional $watches against the model value.
	 *
	 * @property {Object} $error An object hash with all failing validator ids as keys.
	 * @property {Object} $pending An object hash with all pending validator ids as keys.
	 *
	 * @property {boolean} $untouched True if control has not lost focus yet.
	 * @property {boolean} $touched True if control has lost focus.
	 * @property {boolean} $pristine True if user has not interacted with the control yet.
	 * @property {boolean} $dirty True if user has already interacted with the control.
	 * @property {boolean} $valid True if there is no error.
	 * @property {boolean} $invalid True if at least one error on the control.
	 * @property {string} $name The name attribute of the control.
	 *
	 * @description
	 *
	 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
	 * The controller contains services for data-binding, validation, CSS updates, and value formatting
	 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
	 * listening to DOM events.
	 * Such DOM related logic should be provided by other directives which make use of
	 * `NgModelController` for data-binding to control elements.
	 * Angular provides this DOM logic for most {@link input `input`} elements.
	 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
	 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
	 *
	 * @example
	 * ### Custom Control Example
	 * This example shows how to use `NgModelController` with a custom control to achieve
	 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
	 * collaborate together to achieve the desired result.
	 *
	 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
	 * contents be edited in place by the user.
	 *
	 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
	 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
	 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
	 * that content using the `$sce` service.
	 *
	 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
	    <file name="style.css">
	      [contenteditable] {
	        border: 1px solid black;
	        background-color: white;
	        min-height: 20px;
	      }
	
	      .ng-invalid {
	        border: 1px solid red;
	      }
	
	    </file>
	    <file name="script.js">
	      angular.module('customControl', ['ngSanitize']).
	        directive('contenteditable', ['$sce', function($sce) {
	          return {
	            restrict: 'A', // only activate on element attribute
	            require: '?ngModel', // get a hold of NgModelController
	            link: function(scope, element, attrs, ngModel) {
	              if (!ngModel) return; // do nothing if no ng-model
	
	              // Specify how UI should be updated
	              ngModel.$render = function() {
	                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
	              };
	
	              // Listen for change events to enable binding
	              element.on('blur keyup change', function() {
	                scope.$evalAsync(read);
	              });
	              read(); // initialize
	
	              // Write data to the model
	              function read() {
	                var html = element.html();
	                // When we clear the content editable the browser leaves a <br> behind
	                // If strip-br attribute is provided then we strip this out
	                if (attrs.stripBr && html === '<br>') {
	                  html = '';
	                }
	                ngModel.$setViewValue(html);
	              }
	            }
	          };
	        }]);
	    </file>
	    <file name="index.html">
	      <form name="myForm">
	       <div contenteditable
	            name="myWidget" ng-model="userContent"
	            strip-br="true"
	            required>Change me!</div>
	        <span ng-show="myForm.myWidget.$error.required">Required!</span>
	       <hr>
	       <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	    it('should data-bind and become invalid', function() {
	      if (browser.params.browser === 'safari' || browser.params.browser === 'firefox') {
	        // SafariDriver can't handle contenteditable
	        // and Firefox driver can't clear contenteditables very well
	        return;
	      }
	      var contentEditable = element(by.css('[contenteditable]'));
	      var content = 'Change me!';
	
	      expect(contentEditable.getText()).toEqual(content);
	
	      contentEditable.clear();
	      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
	      expect(contentEditable.getText()).toEqual('');
	      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
	    });
	    </file>
	 * </example>
	 *
	 *
	 */
	NgModelController.$inject = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$q', '$interpolate'];
	function NgModelController($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $q, $interpolate) {
	  this.$viewValue = Number.NaN;
	  this.$modelValue = Number.NaN;
	  this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
	  this.$validators = {};
	  this.$asyncValidators = {};
	  this.$parsers = [];
	  this.$formatters = [];
	  this.$viewChangeListeners = [];
	  this.$untouched = true;
	  this.$touched = false;
	  this.$pristine = true;
	  this.$dirty = false;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$error = {}; // keep invalid keys here
	  this.$$success = {}; // keep valid keys here
	  this.$pending = undefined; // keep pending keys here
	  this.$name = $interpolate($attr.name || '', false)($scope);
	  this.$$parentForm = nullFormCtrl;
	  this.$options = defaultModelOptions;
	
	  this.$$parsedNgModel = $parse($attr.ngModel);
	  this.$$parsedNgModelAssign = this.$$parsedNgModel.assign;
	  this.$$ngModelGet = this.$$parsedNgModel;
	  this.$$ngModelSet = this.$$parsedNgModelAssign;
	  this.$$pendingDebounce = null;
	  this.$$parserValid = undefined;
	
	  this.$$currentValidationRunId = 0;
	
	  // https://github.com/angular/angular.js/issues/15833
	  // Prevent `$$scope` from being iterated over by `copy` when NgModelController is deep watched
	  Object.defineProperty(this, '$$scope', {value: $scope});
	  this.$$attr = $attr;
	  this.$$element = $element;
	  this.$$animate = $animate;
	  this.$$timeout = $timeout;
	  this.$$parse = $parse;
	  this.$$q = $q;
	  this.$$exceptionHandler = $exceptionHandler;
	
	  setupValidity(this);
	  setupModelWatcher(this);
	}
	
	NgModelController.prototype = {
	  $$initGetterSetters: function() {
	    if (this.$options.getOption('getterSetter')) {
	      var invokeModelGetter = this.$$parse(this.$$attr.ngModel + '()'),
	          invokeModelSetter = this.$$parse(this.$$attr.ngModel + '($$$p)');
	
	      this.$$ngModelGet = function($scope) {
	        var modelValue = this.$$parsedNgModel($scope);
	        if (isFunction(modelValue)) {
	          modelValue = invokeModelGetter($scope);
	        }
	        return modelValue;
	      };
	      this.$$ngModelSet = function($scope, newValue) {
	        if (isFunction(this.$$parsedNgModel($scope))) {
	          invokeModelSetter($scope, {$$$p: newValue});
	        } else {
	          this.$$parsedNgModelAssign($scope, newValue);
	        }
	      };
	    } else if (!this.$$parsedNgModel.assign) {
	      throw ngModelMinErr('nonassign', 'Expression \'{0}\' is non-assignable. Element: {1}',
	          this.$$attr.ngModel, startingTag(this.$$element));
	    }
	  },
	
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$render
	   *
	   * @description
	   * Called when the view needs to be updated. It is expected that the user of the ng-model
	   * directive will implement this method.
	   *
	   * The `$render()` method is invoked in the following situations:
	   *
	   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
	   *   committed value then `$render()` is called to update the input control.
	   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
	   *   the `$viewValue` are different from last time.
	   *
	   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
	   * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
	   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
	   * invoked if you only change a property on the objects.
	   */
	  $render: noop,
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$isEmpty
	   *
	   * @description
	   * This is called when we need to determine if the value of an input is empty.
	   *
	   * For instance, the required directive does this to work out if the input has data or not.
	   *
	   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
	   *
	   * You can override this for input directives whose concept of being empty is different from the
	   * default. The `checkboxInputType` directive does this because in its case a value of `false`
	   * implies empty.
	   *
	   * @param {*} value The value of the input to check for emptiness.
	   * @returns {boolean} True if `value` is "empty".
	   */
	  $isEmpty: function(value) {
	    // eslint-disable-next-line no-self-compare
	    return isUndefined(value) || value === '' || value === null || value !== value;
	  },
	
	  $$updateEmptyClasses: function(value) {
	    if (this.$isEmpty(value)) {
	      this.$$animate.removeClass(this.$$element, NOT_EMPTY_CLASS);
	      this.$$animate.addClass(this.$$element, EMPTY_CLASS);
	    } else {
	      this.$$animate.removeClass(this.$$element, EMPTY_CLASS);
	      this.$$animate.addClass(this.$$element, NOT_EMPTY_CLASS);
	    }
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setPristine
	   *
	   * @description
	   * Sets the control to its pristine state.
	   *
	   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
	   * state (`ng-pristine` class). A model is considered to be pristine when the control
	   * has not been changed from when first compiled.
	   */
	  $setPristine: function() {
	    this.$dirty = false;
	    this.$pristine = true;
	    this.$$animate.removeClass(this.$$element, DIRTY_CLASS);
	    this.$$animate.addClass(this.$$element, PRISTINE_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setDirty
	   *
	   * @description
	   * Sets the control to its dirty state.
	   *
	   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
	   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
	   * from when first compiled.
	   */
	  $setDirty: function() {
	    this.$dirty = true;
	    this.$pristine = false;
	    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
	    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
	    this.$$parentForm.$setDirty();
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setUntouched
	   *
	   * @description
	   * Sets the control to its untouched state.
	   *
	   * This method can be called to remove the `ng-touched` class and set the control to its
	   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
	   * by default, however this function can be used to restore that state if the model has
	   * already been touched by the user.
	   */
	  $setUntouched: function() {
	    this.$touched = false;
	    this.$untouched = true;
	    this.$$animate.setClass(this.$$element, UNTOUCHED_CLASS, TOUCHED_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setTouched
	   *
	   * @description
	   * Sets the control to its touched state.
	   *
	   * This method can be called to remove the `ng-untouched` class and set the control to its
	   * touched state (`ng-touched` class). A model is considered to be touched when the user has
	   * first focused the control element and then shifted focus away from the control (blur event).
	   */
	  $setTouched: function() {
	    this.$touched = true;
	    this.$untouched = false;
	    this.$$animate.setClass(this.$$element, TOUCHED_CLASS, UNTOUCHED_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$rollbackViewValue
	   *
	   * @description
	   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
	   * which may be caused by a pending debounced event or because the input is waiting for some
	   * future event.
	   *
	   * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
	   * depend on special events such as `blur`, there can be a period when the `$viewValue` is out of
	   * sync with the ngModel's `$modelValue`.
	   *
	   * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
	   * and reset the input to the last committed view value.
	   *
	   * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
	   * programmatically before these debounced/future events have resolved/occurred, because Angular's
	   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
	   *
	   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
	   * input which may have such events pending. This is important in order to make sure that the
	   * input field will be updated with the new model value and any pending operations are cancelled.
	   *
	   * <example name="ng-model-cancel-update" module="cancel-update-example">
	   *   <file name="app.js">
	   *     angular.module('cancel-update-example', [])
	   *
	   *     .controller('CancelUpdateController', ['$scope', function($scope) {
	   *       $scope.model = {value1: '', value2: ''};
	   *
	   *       $scope.setEmpty = function(e, value, rollback) {
	   *         if (e.keyCode === 27) {
	   *           e.preventDefault();
	   *           if (rollback) {
	   *             $scope.myForm[value].$rollbackViewValue();
	   *           }
	   *           $scope.model[value] = '';
	   *         }
	   *       };
	   *     }]);
	   *   </file>
	   *   <file name="index.html">
	   *     <div ng-controller="CancelUpdateController">
	   *       <p>Both of these inputs are only updated if they are blurred. Hitting escape should
	   *       empty them. Follow these steps and observe the difference:</p>
	   *       <ol>
	   *         <li>Type something in the input. You will see that the model is not yet updated</li>
	   *         <li>Press the Escape key.
	   *           <ol>
	   *             <li> In the first example, nothing happens, because the model is already '', and no
	   *             update is detected. If you blur the input, the model will be set to the current view.
	   *             </li>
	   *             <li> In the second example, the pending update is cancelled, and the input is set back
	   *             to the last committed view value (''). Blurring the input does nothing.
	   *             </li>
	   *           </ol>
	   *         </li>
	   *       </ol>
	   *
	   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
	   *         <div>
	   *           <p id="inputDescription1">Without $rollbackViewValue():</p>
	   *           <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
	   *                  ng-keydown="setEmpty($event, 'value1')">
	   *           value1: "{{ model.value1 }}"
	   *         </div>
	   *
	   *         <div>
	   *           <p id="inputDescription2">With $rollbackViewValue():</p>
	   *           <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
	   *                  ng-keydown="setEmpty($event, 'value2', true)">
	   *           value2: "{{ model.value2 }}"
	   *         </div>
	   *       </form>
	   *     </div>
	   *   </file>
	       <file name="style.css">
	          div {
	            display: table-cell;
	          }
	          div:nth-child(1) {
	            padding-right: 30px;
	          }
	
	        </file>
	   * </example>
	   */
	  $rollbackViewValue: function() {
	    this.$$timeout.cancel(this.$$pendingDebounce);
	    this.$viewValue = this.$$lastCommittedViewValue;
	    this.$render();
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$validate
	   *
	   * @description
	   * Runs each of the registered validators (first synchronous validators and then
	   * asynchronous validators).
	   * If the validity changes to invalid, the model will be set to `undefined`,
	   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
	   * If the validity changes to valid, it will set the model to the last available valid
	   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
	   */
	  $validate: function() {
	    // ignore $validate before model is initialized
	    if (isNumberNaN(this.$modelValue)) {
	      return;
	    }
	
	    var viewValue = this.$$lastCommittedViewValue;
	    // Note: we use the $$rawModelValue as $modelValue might have been
	    // set to undefined during a view -> model update that found validation
	    // errors. We can't parse the view here, since that could change
	    // the model although neither viewValue nor the model on the scope changed
	    var modelValue = this.$$rawModelValue;
	
	    var prevValid = this.$valid;
	    var prevModelValue = this.$modelValue;
	
	    var allowInvalid = this.$options.getOption('allowInvalid');
	
	    var that = this;
	    this.$$runValidators(modelValue, viewValue, function(allValid) {
	      // If there was no change in validity, don't update the model
	      // This prevents changing an invalid modelValue to undefined
	      if (!allowInvalid && prevValid !== allValid) {
	        // Note: Don't check this.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        that.$modelValue = allValid ? modelValue : undefined;
	
	        if (that.$modelValue !== prevModelValue) {
	          that.$$writeModelToScope();
	        }
	      }
	    });
	  },
	
	  $$runValidators: function(modelValue, viewValue, doneCallback) {
	    this.$$currentValidationRunId++;
	    var localValidationRunId = this.$$currentValidationRunId;
	    var that = this;
	
	    // check parser error
	    if (!processParseErrors()) {
	      validationDone(false);
	      return;
	    }
	    if (!processSyncValidators()) {
	      validationDone(false);
	      return;
	    }
	    processAsyncValidators();
	
	    function processParseErrors() {
	      var errorKey = that.$$parserName || 'parse';
	      if (isUndefined(that.$$parserValid)) {
	        setValidity(errorKey, null);
	      } else {
	        if (!that.$$parserValid) {
	          forEach(that.$validators, function(v, name) {
	            setValidity(name, null);
	          });
	          forEach(that.$asyncValidators, function(v, name) {
	            setValidity(name, null);
	          });
	        }
	        // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
	        setValidity(errorKey, that.$$parserValid);
	        return that.$$parserValid;
	      }
	      return true;
	    }
	
	    function processSyncValidators() {
	      var syncValidatorsValid = true;
	      forEach(that.$validators, function(validator, name) {
	        var result = Boolean(validator(modelValue, viewValue));
	        syncValidatorsValid = syncValidatorsValid && result;
	        setValidity(name, result);
	      });
	      if (!syncValidatorsValid) {
	        forEach(that.$asyncValidators, function(v, name) {
	          setValidity(name, null);
	        });
	        return false;
	      }
	      return true;
	    }
	
	    function processAsyncValidators() {
	      var validatorPromises = [];
	      var allValid = true;
	      forEach(that.$asyncValidators, function(validator, name) {
	        var promise = validator(modelValue, viewValue);
	        if (!isPromiseLike(promise)) {
	          throw ngModelMinErr('nopromise',
	            'Expected asynchronous validator to return a promise but got \'{0}\' instead.', promise);
	        }
	        setValidity(name, undefined);
	        validatorPromises.push(promise.then(function() {
	          setValidity(name, true);
	        }, function() {
	          allValid = false;
	          setValidity(name, false);
	        }));
	      });
	      if (!validatorPromises.length) {
	        validationDone(true);
	      } else {
	        that.$$q.all(validatorPromises).then(function() {
	          validationDone(allValid);
	        }, noop);
	      }
	    }
	
	    function setValidity(name, isValid) {
	      if (localValidationRunId === that.$$currentValidationRunId) {
	        that.$setValidity(name, isValid);
	      }
	    }
	
	    function validationDone(allValid) {
	      if (localValidationRunId === that.$$currentValidationRunId) {
	
	        doneCallback(allValid);
	      }
	    }
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$commitViewValue
	   *
	   * @description
	   * Commit a pending update to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  $commitViewValue: function() {
	    var viewValue = this.$viewValue;
	
	    this.$$timeout.cancel(this.$$pendingDebounce);
	
	    // If the view value has not changed then we should just exit, except in the case where there is
	    // a native validator on the element. In this case the validation state may have changed even though
	    // the viewValue has stayed empty.
	    if (this.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !this.$$hasNativeValidators)) {
	      return;
	    }
	    this.$$updateEmptyClasses(viewValue);
	    this.$$lastCommittedViewValue = viewValue;
	
	    // change to dirty
	    if (this.$pristine) {
	      this.$setDirty();
	    }
	    this.$$parseAndValidate();
	  },
	
	  $$parseAndValidate: function() {
	    var viewValue = this.$$lastCommittedViewValue;
	    var modelValue = viewValue;
	    var that = this;
	
	    this.$$parserValid = isUndefined(modelValue) ? undefined : true;
	
	    if (this.$$parserValid) {
	      for (var i = 0; i < this.$parsers.length; i++) {
	        modelValue = this.$parsers[i](modelValue);
	        if (isUndefined(modelValue)) {
	          this.$$parserValid = false;
	          break;
	        }
	      }
	    }
	    if (isNumberNaN(this.$modelValue)) {
	      // this.$modelValue has not been touched yet...
	      this.$modelValue = this.$$ngModelGet(this.$$scope);
	    }
	    var prevModelValue = this.$modelValue;
	    var allowInvalid = this.$options.getOption('allowInvalid');
	    this.$$rawModelValue = modelValue;
	
	    if (allowInvalid) {
	      this.$modelValue = modelValue;
	      writeToModelIfNeeded();
	    }
	
	    // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
	    // This can happen if e.g. $setViewValue is called from inside a parser
	    this.$$runValidators(modelValue, this.$$lastCommittedViewValue, function(allValid) {
	      if (!allowInvalid) {
	        // Note: Don't check this.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        that.$modelValue = allValid ? modelValue : undefined;
	        writeToModelIfNeeded();
	      }
	    });
	
	    function writeToModelIfNeeded() {
	      if (that.$modelValue !== prevModelValue) {
	        that.$$writeModelToScope();
	      }
	    }
	  },
	
	  $$writeModelToScope: function() {
	    this.$$ngModelSet(this.$$scope, this.$modelValue);
	    forEach(this.$viewChangeListeners, function(listener) {
	      try {
	        listener();
	      } catch (e) {
	        // eslint-disable-next-line no-invalid-this
	        this.$$exceptionHandler(e);
	      }
	    }, this);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setViewValue
	   *
	   * @description
	   * Update the view value.
	   *
	   * This method should be called when a control wants to change the view value; typically,
	   * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
	   * directive calls it when the value of the input changes and {@link ng.directive:select select}
	   * calls it when an option is selected.
	   *
	   * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
	   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
	   * value is sent directly for processing through the `$parsers` pipeline. After this, the `$validators` and
	   * `$asyncValidators` are called and the value is applied to `$modelValue`.
	   * Finally, the value is set to the **expression** specified in the `ng-model` attribute and
	   * all the registered change listeners, in the `$viewChangeListeners` list are called.
	   *
	   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
	   * and the `default` trigger is not listed, all those actions will remain pending until one of the
	   * `updateOn` events is triggered on the DOM element.
	   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
	   * directive is used with a custom debounce for this particular event.
	   * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
	   * is specified, once the timer runs out.
	   *
	   * When used with standard inputs, the view value will always be a string (which is in some cases
	   * parsed into another type, such as a `Date` object for `input[date]`.)
	   * However, custom controls might also pass objects to this method. In this case, we should make
	   * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
	   * perform a deep watch of objects, it only looks for a change of identity. If you only change
	   * the property of the object then ngModel will not realize that the object has changed and
	   * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
	   * not change properties of the copy once it has been passed to `$setViewValue`.
	   * Otherwise you may cause the model value on the scope to change incorrectly.
	   *
	   * <div class="alert alert-info">
	   * In any case, the value passed to the method should always reflect the current value
	   * of the control. For example, if you are calling `$setViewValue` for an input element,
	   * you should pass the input DOM value. Otherwise, the control and the scope model become
	   * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
	   * the control's DOM value in any way. If we want to change the control's DOM value
	   * programmatically, we should update the `ngModel` scope expression. Its new value will be
	   * picked up by the model controller, which will run it through the `$formatters`, `$render` it
	   * to update the DOM, and finally call `$validate` on it.
	   * </div>
	   *
	   * @param {*} value value from the view.
	   * @param {string} trigger Event that triggered the update.
	   */
	  $setViewValue: function(value, trigger) {
	    this.$viewValue = value;
	    if (this.$options.getOption('updateOnDefault')) {
	      this.$$debounceViewValueCommit(trigger);
	    }
	  },
	
	  $$debounceViewValueCommit: function(trigger) {
	    var debounceDelay = this.$options.getOption('debounce');
	
	    if (isNumber(debounceDelay[trigger])) {
	      debounceDelay = debounceDelay[trigger];
	    } else if (isNumber(debounceDelay['default'])) {
	      debounceDelay = debounceDelay['default'];
	    }
	
	    this.$$timeout.cancel(this.$$pendingDebounce);
	    var that = this;
	    if (debounceDelay > 0) { // this fails if debounceDelay is an object
	      this.$$pendingDebounce = this.$$timeout(function() {
	        that.$commitViewValue();
	      }, debounceDelay);
	    } else if (this.$$scope.$root.$$phase) {
	      this.$commitViewValue();
	    } else {
	      this.$$scope.$apply(function() {
	        that.$commitViewValue();
	      });
	    }
	  },
	
	  /**
	   * @ngdoc method
	   *
	   * @name ngModel.NgModelController#$overrideModelOptions
	   *
	   * @description
	   *
	   * Override the current model options settings programmatically.
	   *
	   * The previous `ModelOptions` value will not be modified. Instead, a
	   * new `ModelOptions` object will inherit from the previous one overriding
	   * or inheriting settings that are defined in the given parameter.
	   *
	   * See {@link ngModelOptions} for information about what options can be specified
	   * and how model option inheritance works.
	   *
	   * @param {Object} options a hash of settings to override the previous options
	   *
	   */
	  $overrideModelOptions: function(options) {
	    this.$options = this.$options.createChild(options);
	  }
	};
	
	function setupModelWatcher(ctrl) {
	  // model -> value
	  // Note: we cannot use a normal scope.$watch as we want to detect the following:
	  // 1. scope value is 'a'
	  // 2. user enters 'b'
	  // 3. ng-change kicks in and reverts scope value to 'a'
	  //    -> scope value did not change since the last digest as
	  //       ng-change executes in apply phase
	  // 4. view should be changed back to 'a'
	  ctrl.$$scope.$watch(function ngModelWatch(scope) {
	    var modelValue = ctrl.$$ngModelGet(scope);
	
	    // if scope model value and ngModel value are out of sync
	    // TODO(perf): why not move this to the action fn?
	    if (modelValue !== ctrl.$modelValue &&
	       // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
	        // eslint-disable-next-line no-self-compare
	       (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)
	    ) {
	      ctrl.$modelValue = ctrl.$$rawModelValue = modelValue;
	      ctrl.$$parserValid = undefined;
	
	      var formatters = ctrl.$formatters,
	          idx = formatters.length;
	
	      var viewValue = modelValue;
	      while (idx--) {
	        viewValue = formatters[idx](viewValue);
	      }
	      if (ctrl.$viewValue !== viewValue) {
	        ctrl.$$updateEmptyClasses(viewValue);
	        ctrl.$viewValue = ctrl.$$lastCommittedViewValue = viewValue;
	        ctrl.$render();
	
	        // It is possible that model and view value have been updated during render
	        ctrl.$$runValidators(ctrl.$modelValue, ctrl.$viewValue, noop);
	      }
	    }
	
	    return modelValue;
	  });
	}
	
	/**
	 * @ngdoc method
	 * @name ngModel.NgModelController#$setValidity
	 *
	 * @description
	 * Change the validity state, and notify the form.
	 *
	 * This method can be called within $parsers/$formatters or a custom validation implementation.
	 * However, in most cases it should be sufficient to use the `ngModel.$validators` and
	 * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
	 *
	 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
	 *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
	 *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
	 *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
	 *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
	 *        class and can be bound to as  `{{someForm.someControl.$error.myError}}` .
	 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
	 *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	 *                          Skipped is used by Angular when validators do not run because of parse errors and
	 *                          when `$asyncValidators` do not run because any of the `$validators` failed.
	 */
	addSetValidityMethod({
	  clazz: NgModelController,
	  set: function(object, property) {
	    object[property] = true;
	  },
	  unset: function(object, property) {
	    delete object[property];
	  }
	});
	
	
	/**
	 * @ngdoc directive
	 * @name ngModel
	 *
	 * @element input
	 * @priority 1
	 *
	 * @description
	 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
	 * property on the scope using {@link ngModel.NgModelController NgModelController},
	 * which is created and exposed by this directive.
	 *
	 * `ngModel` is responsible for:
	 *
	 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
	 *   require.
	 * - Providing validation behavior (i.e. required, number, email, url).
	 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
	 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
	 *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
	 * - Registering the control with its parent {@link ng.directive:form form}.
	 *
	 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
	 * current scope. If the property doesn't already exist on this scope, it will be created
	 * implicitly and added to the scope.
	 *
	 * For best practices on using `ngModel`, see:
	 *
	 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
	 *
	 * For basic examples, how to use `ngModel`, see:
	 *
	 *  - {@link ng.directive:input input}
	 *    - {@link input[text] text}
	 *    - {@link input[checkbox] checkbox}
	 *    - {@link input[radio] radio}
	 *    - {@link input[number] number}
	 *    - {@link input[email] email}
	 *    - {@link input[url] url}
	 *    - {@link input[date] date}
	 *    - {@link input[datetime-local] datetime-local}
	 *    - {@link input[time] time}
	 *    - {@link input[month] month}
	 *    - {@link input[week] week}
	 *  - {@link ng.directive:select select}
	 *  - {@link ng.directive:textarea textarea}
	 *
	 * # Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
	 * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
	 *
	 * The model must be assigned an entirely new object or collection before a re-rendering will occur.
	 *
	 * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
	 * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
	 * if the select is given the `multiple` attribute.
	 *
	 * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
	 * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
	 * not trigger a re-rendering of the model.
	 *
	 * # CSS classes
	 * The following CSS classes are added and removed on the associated input/select/textarea element
	 * depending on the validity of the model.
	 *
	 *  - `ng-valid`: the model is valid
	 *  - `ng-invalid`: the model is invalid
	 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
	 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
	 *  - `ng-pristine`: the control hasn't been interacted with yet
	 *  - `ng-dirty`: the control has been interacted with
	 *  - `ng-touched`: the control has been blurred
	 *  - `ng-untouched`: the control hasn't been blurred
	 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
	 *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
	 *     by the {@link ngModel.NgModelController#$isEmpty} method
	 *  - `ng-not-empty`: the view contains a non-empty value
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 * ## Animation Hooks
	 *
	 * Animations within models are triggered when any of the associated CSS classes are added and removed
	 * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
	 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
	 * The animations that are triggered within ngModel are similar to how they work in ngClass and
	 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style an input element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-input {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-input.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample" name="ng-model">
	     <file name="index.html">
	       <script>
	        angular.module('inputExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.val = '1';
	          }]);
	       </script>
	       <style>
	         .my-input {
	           transition:all linear 0.5s;
	           background: transparent;
	         }
	         .my-input.ng-invalid {
	           color:white;
	           background: red;
	         }
	       </style>
	       <p id="inputDescription">
	        Update input to see transitions when valid/invalid.
	        Integer is a valid value.
	       </p>
	       <form name="testForm" ng-controller="ExampleController">
	         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
	                aria-describedby="inputDescription" />
	       </form>
	     </file>
	 * </example>
	 *
	 * ## Binding to a getter/setter
	 *
	 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
	 * function that returns a representation of the model when called with zero arguments, and sets
	 * the internal state of a model when called with an argument. It's sometimes useful to use this
	 * for models that have an internal representation that's different from what the model exposes
	 * to the view.
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's best to keep getters fast because Angular is likely to call them more
	 * frequently than other parts of your code.
	 * </div>
	 *
	 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
	 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
	 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
	 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
	 *
	 * The following example shows how to use `ngModel` with a getter/setter:
	 *
	 * @example
	 * <example name="ngModel-getter-setter" module="getterSetterExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <form name="userForm">
	           <label>Name:
	             <input type="text" name="userName"
	                    ng-model="user.name"
	                    ng-model-options="{ getterSetter: true }" />
	           </label>
	         </form>
	         <pre>user.name = <span ng-bind="user.name()"></span></pre>
	       </div>
	     </file>
	     <file name="app.js">
	       angular.module('getterSetterExample', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var _name = 'Brian';
	           $scope.user = {
	             name: function(newName) {
	              // Note that newName can be undefined for two reasons:
	              // 1. Because it is called as a getter and thus called with no arguments
	              // 2. Because the property should actually be set to undefined. This happens e.g. if the
	              //    input is invalid
	              return arguments.length ? (_name = newName) : _name;
	             }
	           };
	         }]);
	     </file>
	 * </example>
	 */
	var ngModelDirective = ['$rootScope', function($rootScope) {
	  return {
	    restrict: 'A',
	    require: ['ngModel', '^?form', '^?ngModelOptions'],
	    controller: NgModelController,
	    // Prelink needs to run before any input directive
	    // so that we can set the NgModelOptions in NgModelController
	    // before anyone else uses it.
	    priority: 1,
	    compile: function ngModelCompile(element) {
	      // Setup initial state of the control
	      element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);
	
	      return {
	        pre: function ngModelPreLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0],
	              formCtrl = ctrls[1] || modelCtrl.$$parentForm,
	              optionsCtrl = ctrls[2];
	
	          if (optionsCtrl) {
	            modelCtrl.$options = optionsCtrl.$options;
	          }
	
	          modelCtrl.$$initGetterSetters();
	
	          // notify others, especially parent forms
	          formCtrl.$addControl(modelCtrl);
	
	          attr.$observe('name', function(newValue) {
	            if (modelCtrl.$name !== newValue) {
	              modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
	            }
	          });
	
	          scope.$on('$destroy', function() {
	            modelCtrl.$$parentForm.$removeControl(modelCtrl);
	          });
	        },
	        post: function ngModelPostLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0];
	          if (modelCtrl.$options.getOption('updateOn')) {
	            element.on(modelCtrl.$options.getOption('updateOn'), function(ev) {
	              modelCtrl.$$debounceViewValueCommit(ev && ev.type);
	            });
	          }
	
	          function setTouched() {
	            modelCtrl.$setTouched();
	          }
	
	          element.on('blur', function() {
	            if (modelCtrl.$touched) return;
	
	            if ($rootScope.$$phase) {
	              scope.$evalAsync(setTouched);
	            } else {
	              scope.$apply(setTouched);
	            }
	          });
	        }
	      };
	    }
	  };
	}];
	
	/* exported defaultModelOptions */
	var defaultModelOptions;
	var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;
	
	/**
	 * @ngdoc type
	 * @name ModelOptions
	 * @description
	 * A container for the options set by the {@link ngModelOptions} directive
	 */
	function ModelOptions(options) {
	  this.$$options = options;
	}
	
	ModelOptions.prototype = {
	
	  /**
	   * @ngdoc method
	   * @name ModelOptions#getOption
	   * @param {string} name the name of the option to retrieve
	   * @returns {*} the value of the option
	   * @description
	   * Returns the value of the given option
	   */
	  getOption: function(name) {
	    return this.$$options[name];
	  },
	
	  /**
	   * @ngdoc method
	   * @name ModelOptions#createChild
	   * @param {Object} options a hash of options for the new child that will override the parent's options
	   * @return {ModelOptions} a new `ModelOptions` object initialized with the given options.
	   */
	  createChild: function(options) {
	    var inheritAll = false;
	
	    // make a shallow copy
	    options = extend({}, options);
	
	    // Inherit options from the parent if specified by the value `"$inherit"`
	    forEach(options, /* @this */ function(option, key) {
	      if (option === '$inherit') {
	        if (key === '*') {
	          inheritAll = true;
	        } else {
	          options[key] = this.$$options[key];
	          // `updateOn` is special so we must also inherit the `updateOnDefault` option
	          if (key === 'updateOn') {
	            options.updateOnDefault = this.$$options.updateOnDefault;
	          }
	        }
	      } else {
	        if (key === 'updateOn') {
	          // If the `updateOn` property contains the `default` event then we have to remove
	          // it from the event list and set the `updateOnDefault` flag.
	          options.updateOnDefault = false;
	          options[key] = trim(option.replace(DEFAULT_REGEXP, function() {
	            options.updateOnDefault = true;
	            return ' ';
	          }));
	        }
	      }
	    }, this);
	
	    if (inheritAll) {
	      // We have a property of the form: `"*": "$inherit"`
	      delete options['*'];
	      defaults(options, this.$$options);
	    }
	
	    // Finally add in any missing defaults
	    defaults(options, defaultModelOptions.$$options);
	
	    return new ModelOptions(options);
	  }
	};
	
	
	defaultModelOptions = new ModelOptions({
	  updateOn: '',
	  updateOnDefault: true,
	  debounce: 0,
	  getterSetter: false,
	  allowInvalid: false,
	  timezone: null
	});
	
	
	/**
	 * @ngdoc directive
	 * @name ngModelOptions
	 *
	 * @description
	 * This directive allows you to modify the behaviour of {@link ngModel} directives within your
	 * application. You can specify an `ngModelOptions` directive on any element. All {@link ngModel}
	 * directives will use the options of their nearest `ngModelOptions` ancestor.
	 *
	 * The `ngModelOptions` settings are found by evaluating the value of the attribute directive as
	 * an Angular expression. This expression should evaluate to an object, whose properties contain
	 * the settings. For example: `<div "ng-model-options"="{ debounce: 100 }"`.
	 *
	 * ## Inheriting Options
	 *
	 * You can specify that an `ngModelOptions` setting should be inherited from a parent `ngModelOptions`
	 * directive by giving it the value of `"$inherit"`.
	 * Then it will inherit that setting from the first `ngModelOptions` directive found by traversing up the
	 * DOM tree. If there is no ancestor element containing an `ngModelOptions` directive then default settings
	 * will be used.
	 *
	 * For example given the following fragment of HTML
	 *
	 *
	 * ```html
	 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
	 *   <form ng-model-options="{ updateOn: 'blur', allowInvalid: '$inherit' }">
	 *     <input ng-model-options="{ updateOn: 'default', allowInvalid: '$inherit' }" />
	 *   </form>
	 * </div>
	 * ```
	 *
	 * the `input` element will have the following settings
	 *
	 * ```js
	 * { allowInvalid: true, updateOn: 'default', debounce: 0 }
	 * ```
	 *
	 * Notice that the `debounce` setting was not inherited and used the default value instead.
	 *
	 * You can specify that all undefined settings are automatically inherited from an ancestor by
	 * including a property with key of `"*"` and value of `"$inherit"`.
	 *
	 * For example given the following fragment of HTML
	 *
	 *
	 * ```html
	 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
	 *   <form ng-model-options="{ updateOn: 'blur', "*": '$inherit' }">
	 *     <input ng-model-options="{ updateOn: 'default', "*": '$inherit' }" />
	 *   </form>
	 * </div>
	 * ```
	 *
	 * the `input` element will have the following settings
	 *
	 * ```js
	 * { allowInvalid: true, updateOn: 'default', debounce: 200 }
	 * ```
	 *
	 * Notice that the `debounce` setting now inherits the value from the outer `<div>` element.
	 *
	 * If you are creating a reusable component then you should be careful when using `"*": "$inherit"`
	 * since you may inadvertently inherit a setting in the future that changes the behavior of your component.
	 *
	 *
	 * ## Triggering and debouncing model updates
	 *
	 * The `updateOn` and `debounce` properties allow you to specify a custom list of events that will
	 * trigger a model update and/or a debouncing delay so that the actual update only takes place when
	 * a timer expires; this timer will be reset after another change takes place.
	 *
	 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
	 * be different from the value in the actual model. This means that if you update the model you
	 * should also invoke {@link ngModel.NgModelController#$rollbackViewValue} on the relevant input field in
	 * order to make sure it is synchronized with the model and that any debounced action is canceled.
	 *
	 * The easiest way to reference the control's {@link ngModel.NgModelController#$rollbackViewValue}
	 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
	 * important because `form` controllers are published to the related scope under the name in their
	 * `name` attribute.
	 *
	 * Any pending changes will take place immediately when an enclosing form is submitted via the
	 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * The following example shows how to override immediate updates. Changes on the inputs within the
	 * form will update the model only when the control loses focus (blur event). If `escape` key is
	 * pressed while the input field is focused, the value is reset to the value in the current model.
	 *
	 * <example name="ngModelOptions-directive-blur" module="optionsExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         <label>
	 *           Name:
	 *           <input type="text" name="userName"
	 *                  ng-model="user.name"
	 *                  ng-model-options="{ updateOn: 'blur' }"
	 *                  ng-keyup="cancel($event)" />
	 *         </label><br />
	 *         <label>
	 *           Other data:
	 *           <input type="text" ng-model="user.data" />
	 *         </label><br />
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('optionsExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.user = { name: 'say', data: '' };
	 *
	 *         $scope.cancel = function(e) {
	 *           if (e.keyCode === 27) {
	 *             $scope.userForm.userName.$rollbackViewValue();
	 *           }
	 *         };
	 *       }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var model = element(by.binding('user.name'));
	 *     var input = element(by.model('user.name'));
	 *     var other = element(by.model('user.data'));
	 *
	 *     it('should allow custom events', function() {
	 *       input.sendKeys(' hello');
	 *       input.click();
	 *       expect(model.getText()).toEqual('say');
	 *       other.click();
	 *       expect(model.getText()).toEqual('say hello');
	 *     });
	 *
	 *     it('should $rollbackViewValue when model changes', function() {
	 *       input.sendKeys(' hello');
	 *       expect(input.getAttribute('value')).toEqual('say hello');
	 *       input.sendKeys(protractor.Key.ESCAPE);
	 *       expect(input.getAttribute('value')).toEqual('say');
	 *       other.click();
	 *       expect(model.getText()).toEqual('say');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * The next example shows how to debounce model changes. Model will be updated only 1 sec after last change.
	 * If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
	 *
	 * <example name="ngModelOptions-directive-debounce" module="optionsExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         Name:
	 *         <input type="text" name="userName"
	 *                ng-model="user.name"
	 *                ng-model-options="{ debounce: 1000 }" />
	 *         <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button><br />
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('optionsExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.user = { name: 'say' };
	 *       }]);
	 *   </file>
	 * </example>
	 *
	 * ## Model updates and validation
	 *
	 * The default behaviour in `ngModel` is that the model value is set to `undefined` when the
	 * validation determines that the value is invalid. By setting the `allowInvalid` property to true,
	 * the model will still be updated even if the value is invalid.
	 *
	 *
	 * ## Connecting to the scope
	 *
	 * By setting the `getterSetter` property to true you are telling ngModel that the `ngModel` expression
	 * on the scope refers to a "getter/setter" function rather than the value itself.
	 *
	 * The following example shows how to bind to getter/setters:
	 *
	 * <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         <label>
	 *           Name:
	 *           <input type="text" name="userName"
	 *                  ng-model="user.name"
	 *                  ng-model-options="{ getterSetter: true }" />
	 *         </label>
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name()"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('getterSetterExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         var _name = 'Brian';
	 *         $scope.user = {
	 *           name: function(newName) {
	 *             return angular.isDefined(newName) ? (_name = newName) : _name;
	 *           }
	 *         };
	 *       }]);
	 *   </file>
	 * </example>
	 *
	 *
	 * ## Specifying timezones
	 *
	 * You can specify the timezone that date/time input directives expect by providing its name in the
	 * `timezone` property.
	 *
	 * @param {Object} ngModelOptions options to apply to {@link ngModel} directives on this element and
	 *   and its descendents. Valid keys are:
	 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
	 *     events using an space delimited list. There is a special event called `default` that
	 *     matches the default events belonging to the control.
	 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
	 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
	 *     custom value for each event. For example:
	 *     ```
	 *     ng-model-options="{
	 *       updateOn: 'default blur',
	 *       debounce: { 'default': 500, 'blur': 0 }
	 *     }"
	 *     ```
	 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
	 *     not validate correctly instead of the default behavior of setting the model to undefined.
	 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
	 *     `ngModel` as getters/setters.
	 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
	 *     `<input type="date" />`, `<input type="time" />`, ... . It understands UTC/GMT and the
	 *     continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *     If not specified, the timezone of the browser will be used.
	 *
	 */
	var ngModelOptionsDirective = function() {
	  NgModelOptionsController.$inject = ['$attrs', '$scope'];
	  function NgModelOptionsController($attrs, $scope) {
	    this.$$attrs = $attrs;
	    this.$$scope = $scope;
	  }
	  NgModelOptionsController.prototype = {
	    $onInit: function() {
	      var parentOptions = this.parentCtrl ? this.parentCtrl.$options : defaultModelOptions;
	      var modelOptionsDefinition = this.$$scope.$eval(this.$$attrs.ngModelOptions);
	
	      this.$options = parentOptions.createChild(modelOptionsDefinition);
	    }
	  };
	
	  return {
	    restrict: 'A',
	    // ngModelOptions needs to run before ngModel and input directives
	    priority: 10,
	    require: {parentCtrl: '?^^ngModelOptions'},
	    bindToController: true,
	    controller: NgModelOptionsController
	  };
	};
	
	
	// shallow copy over values from `src` that are not already specified on `dst`
	function defaults(dst, src) {
	  forEach(src, function(value, key) {
	    if (!isDefined(dst[key])) {
	      dst[key] = value;
	    }
	  });
	}
	
	/**
	 * @ngdoc directive
	 * @name ngNonBindable
	 * @restrict AC
	 * @priority 1000
	 *
	 * @description
	 * The `ngNonBindable` directive tells Angular not to compile or bind the contents of the current
	 * DOM element. This is useful if the element contains what appears to be Angular directives and
	 * bindings but which should be ignored by Angular. This could be the case if you have a site that
	 * displays snippets of code, for instance.
	 *
	 * @element ANY
	 *
	 * @example
	 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
	 * but the one wrapped in `ngNonBindable` is left alone.
	 *
	 * @example
	    <example name="ng-non-bindable">
	      <file name="index.html">
	        <div>Normal: {{1 + 2}}</div>
	        <div ng-non-bindable>Ignored: {{1 + 2}}</div>
	      </file>
	      <file name="protractor.js" type="protractor">
	       it('should check ng-non-bindable', function() {
	         expect(element(by.binding('1 + 2')).getText()).toContain('3');
	         expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
	       });
	      </file>
	    </example>
	 */
	var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });
	
	/* exported ngOptionsDirective */
	
	/* global jqLiteRemove */
	
	var ngOptionsMinErr = minErr('ngOptions');
	
	/**
	 * @ngdoc directive
	 * @name ngOptions
	 * @restrict A
	 *
	 * @description
	 *
	 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
	 * elements for the `<select>` element using the array or object obtained by evaluating the
	 * `ngOptions` comprehension expression.
	 *
	 * In many cases, {@link ng.directive:ngRepeat ngRepeat} can be used on `<option>` elements instead of
	 * `ngOptions` to achieve a similar result. However, `ngOptions` provides some benefits:
	 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression
	 * - reduced memory consumption by not creating a new scope for each repeated instance
	 * - increased render speed by creating the options in a documentFragment instead of individually
	 *
	 * When an item in the `<select>` menu is selected, the array element or object property
	 * represented by the selected option will be bound to the model identified by the `ngModel`
	 * directive.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding the select to a model that is an object or a collection.
	 *
	 * One issue occurs if you want to preselect an option. For example, if you set
	 * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
	 * because the objects are not identical. So by default, you should always reference the item in your collection
	 * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
	 *
	 * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
	 * of the item not by reference, but by the result of the `track by` expression. For example, if your
	 * collection items have an id property, you would `track by item.id`.
	 *
	 * A different issue with objects or collections is that ngModel won't detect if an object property or
	 * a collection item changes. For that reason, `ngOptions` additionally watches the model using
	 * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
	 * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
	 * has not changed identity, but only a property on the object or an item in the collection changes.
	 *
	 * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
	 * if the model is an array). This means that changing a property deeper than the first level inside the
	 * object/collection will not trigger a re-rendering.
	 *
	 * ## `select` **`as`**
	 *
	 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
	 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
	 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
	 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
	 *
	 *
	 * ### `select` **`as`** and **`track by`**
	 *
	 * <div class="alert alert-warning">
	 * Be careful when using `select` **`as`** and **`track by`** in the same expression.
	 * </div>
	 *
	 * Given this array of items on the $scope:
	 *
	 * ```js
	 * $scope.items = [{
	 *   id: 1,
	 *   label: 'aLabel',
	 *   subItem: { name: 'aSubItem' }
	 * }, {
	 *   id: 2,
	 *   label: 'bLabel',
	 *   subItem: { name: 'bSubItem' }
	 * }];
	 * ```
	 *
	 * This will work:
	 *
	 * ```html
	 * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0];
	 * ```
	 *
	 * but this will not work:
	 *
	 * ```html
	 * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0].subItem;
	 * ```
	 *
	 * In both examples, the **`track by`** expression is applied successfully to each `item` in the
	 * `items` array. Because the selected option has been set programmatically in the controller, the
	 * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
	 * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
	 * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
	 * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
	 * is not matched against any `<option>` and the `<select>` appears as having no selected value.
	 *
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {comprehension_expression} ngOptions in one of the following forms:
	 *
	 *   * for array data sources:
	 *     * `label` **`for`** `value` **`in`** `array`
	 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
	 *        (for including a filter with `track by`)
	 *   * for object data sources:
	 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`group by`** `group`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`disable when`** `disable`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *
	 * Where:
	 *
	 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
	 *   * `value`: local variable which will refer to each item in the `array` or each property value
	 *      of `object` during iteration.
	 *   * `key`: local variable which will refer to a property name in `object` during iteration.
	 *   * `label`: The result of this expression will be the label for `<option>` element. The
	 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
	 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
	 *      element. If not specified, `select` expression will default to `value`.
	 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
	 *      DOM element.
	 *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
	 *      element. Return `true` to disable.
	 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
	 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
	 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
	 *      even when the options are recreated (e.g. reloaded from the server).
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required The control is considered valid only if value is entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
	 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
	 *
	 * @example
	    <example module="selectExample" name="select">
	      <file name="index.html">
	        <script>
	        angular.module('selectExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.colors = [
	              {name:'black', shade:'dark'},
	              {name:'white', shade:'light', notAnOption: true},
	              {name:'red', shade:'dark'},
	              {name:'blue', shade:'dark', notAnOption: true},
	              {name:'yellow', shade:'light', notAnOption: false}
	            ];
	            $scope.myColor = $scope.colors[2]; // red
	          }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <ul>
	            <li ng-repeat="color in colors">
	              <label>Name: <input ng-model="color.name"></label>
	              <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
	              <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
	            </li>
	            <li>
	              <button ng-click="colors.push({})">add</button>
	            </li>
	          </ul>
	          <hr/>
	          <label>Color (null not allowed):
	            <select ng-model="myColor" ng-options="color.name for color in colors"></select>
	          </label><br/>
	          <label>Color (null allowed):
	          <span  class="nullable">
	            <select ng-model="myColor" ng-options="color.name for color in colors">
	              <option value="">-- choose color --</option>
	            </select>
	          </span></label><br/>
	
	          <label>Color grouped by shade:
	            <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
	            </select>
	          </label><br/>
	
	          <label>Color grouped by shade, with some disabled:
	            <select ng-model="myColor"
	                  ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
	            </select>
	          </label><br/>
	
	
	
	          Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
	          <br/>
	          <hr/>
	          Currently selected: {{ {selected_color:myColor} }}
	          <div style="border:solid 1px black; height:20px"
	               ng-style="{'background-color':myColor.name}">
	          </div>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	         it('should check ng-options', function() {
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
	           element.all(by.model('myColor')).first().click();
	           element.all(by.css('select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
	           element(by.css('.nullable select[ng-model="myColor"]')).click();
	           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
	         });
	      </file>
	    </example>
	 */
	
	/* eslint-disable max-len */
	//                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555000000000666666666666600000007777777777777000000000000000888888888800000000000000000009999999999
	var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([$\w][$\w]*)|(?:\(\s*([$\w][$\w]*)\s*,\s*([$\w][$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
	                        // 1: value expression (valueFn)
	                        // 2: label expression (displayFn)
	                        // 3: group by expression (groupByFn)
	                        // 4: disable when expression (disableWhenFn)
	                        // 5: array item variable name
	                        // 6: object item key variable name
	                        // 7: object item value variable name
	                        // 8: collection expression
	                        // 9: track by expression
	/* eslint-enable */
	
	
	var ngOptionsDirective = ['$compile', '$document', '$parse', function($compile, $document, $parse) {
	
	  function parseOptionsExpression(optionsExp, selectElement, scope) {
	
	    var match = optionsExp.match(NG_OPTIONS_REGEXP);
	    if (!(match)) {
	      throw ngOptionsMinErr('iexp',
	        'Expected expression in form of ' +
	        '\'_select_ (as _label_)? for (_key_,)?_value_ in _collection_\'' +
	        ' but got \'{0}\'. Element: {1}',
	        optionsExp, startingTag(selectElement));
	    }
	
	    // Extract the parts from the ngOptions expression
	
	    // The variable name for the value of the item in the collection
	    var valueName = match[5] || match[7];
	    // The variable name for the key of the item in the collection
	    var keyName = match[6];
	
	    // An expression that generates the viewValue for an option if there is a label expression
	    var selectAs = / as /.test(match[0]) && match[1];
	    // An expression that is used to track the id of each object in the options collection
	    var trackBy = match[9];
	    // An expression that generates the viewValue for an option if there is no label expression
	    var valueFn = $parse(match[2] ? match[1] : valueName);
	    var selectAsFn = selectAs && $parse(selectAs);
	    var viewValueFn = selectAsFn || valueFn;
	    var trackByFn = trackBy && $parse(trackBy);
	
	    // Get the value by which we are going to track the option
	    // if we have a trackFn then use that (passing scope and locals)
	    // otherwise just hash the given viewValue
	    var getTrackByValueFn = trackBy ?
	                              function(value, locals) { return trackByFn(scope, locals); } :
	                              function getHashOfValue(value) { return hashKey(value); };
	    var getTrackByValue = function(value, key) {
	      return getTrackByValueFn(value, getLocals(value, key));
	    };
	
	    var displayFn = $parse(match[2] || match[1]);
	    var groupByFn = $parse(match[3] || '');
	    var disableWhenFn = $parse(match[4] || '');
	    var valuesFn = $parse(match[8]);
	
	    var locals = {};
	    var getLocals = keyName ? function(value, key) {
	      locals[keyName] = key;
	      locals[valueName] = value;
	      return locals;
	    } : function(value) {
	      locals[valueName] = value;
	      return locals;
	    };
	
	
	    function Option(selectValue, viewValue, label, group, disabled) {
	      this.selectValue = selectValue;
	      this.viewValue = viewValue;
	      this.label = label;
	      this.group = group;
	      this.disabled = disabled;
	    }
	
	    function getOptionValuesKeys(optionValues) {
	      var optionValuesKeys;
	
	      if (!keyName && isArrayLike(optionValues)) {
	        optionValuesKeys = optionValues;
	      } else {
	        // if object, extract keys, in enumeration order, unsorted
	        optionValuesKeys = [];
	        for (var itemKey in optionValues) {
	          if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
	            optionValuesKeys.push(itemKey);
	          }
	        }
	      }
	      return optionValuesKeys;
	    }
	
	    return {
	      trackBy: trackBy,
	      getTrackByValue: getTrackByValue,
	      getWatchables: $parse(valuesFn, function(optionValues) {
	        // Create a collection of things that we would like to watch (watchedArray)
	        // so that they can all be watched using a single $watchCollection
	        // that only runs the handler once if anything changes
	        var watchedArray = [];
	        optionValues = optionValues || [];
	
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	
	          var locals = getLocals(value, key);
	          var selectValue = getTrackByValueFn(value, locals);
	          watchedArray.push(selectValue);
	
	          // Only need to watch the displayFn if there is a specific label expression
	          if (match[2] || match[1]) {
	            var label = displayFn(scope, locals);
	            watchedArray.push(label);
	          }
	
	          // Only need to watch the disableWhenFn if there is a specific disable expression
	          if (match[4]) {
	            var disableWhen = disableWhenFn(scope, locals);
	            watchedArray.push(disableWhen);
	          }
	        }
	        return watchedArray;
	      }),
	
	      getOptions: function() {
	
	        var optionItems = [];
	        var selectValueMap = {};
	
	        // The option values were already computed in the `getWatchables` fn,
	        // which must have been called to trigger `getOptions`
	        var optionValues = valuesFn(scope) || [];
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	          var locals = getLocals(value, key);
	          var viewValue = viewValueFn(scope, locals);
	          var selectValue = getTrackByValueFn(viewValue, locals);
	          var label = displayFn(scope, locals);
	          var group = groupByFn(scope, locals);
	          var disabled = disableWhenFn(scope, locals);
	          var optionItem = new Option(selectValue, viewValue, label, group, disabled);
	
	          optionItems.push(optionItem);
	          selectValueMap[selectValue] = optionItem;
	        }
	
	        return {
	          items: optionItems,
	          selectValueMap: selectValueMap,
	          getOptionFromViewValue: function(value) {
	            return selectValueMap[getTrackByValue(value)];
	          },
	          getViewValueFromOption: function(option) {
	            // If the viewValue could be an object that may be mutated by the application,
	            // we need to make a copy and not return the reference to the value on the option.
	            return trackBy ? copy(option.viewValue) : option.viewValue;
	          }
	        };
	      }
	    };
	  }
	
	
	  // we can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  var optionTemplate = window.document.createElement('option'),
	      optGroupTemplate = window.document.createElement('optgroup');
	
	    function ngOptionsPostLink(scope, selectElement, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	      var multiple = attr.multiple;
	
	      // The emptyOption allows the application developer to provide their own custom "empty"
	      // option when the viewValue does not match any of the option values.
	      for (var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++) {
	        if (children[i].value === '') {
	          selectCtrl.hasEmptyOption = true;
	          selectCtrl.emptyOption = children.eq(i);
	          break;
	        }
	      }
	
	      var providedEmptyOption = !!selectCtrl.emptyOption;
	
	      var unknownOption = jqLite(optionTemplate.cloneNode(false));
	      unknownOption.val('?');
	
	      var options;
	      var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
	      // This stores the newly created options before they are appended to the select.
	      // Since the contents are removed from the fragment when it is appended,
	      // we only need to create it once.
	      var listFragment = $document[0].createDocumentFragment();
	
	      // Overwrite the implementation. ngOptions doesn't use hashes
	      selectCtrl.generateUnknownOptionValue = function(val) {
	        return '?';
	      };
	
	      // Update the controller methods for multiple selectable options
	      if (!multiple) {
	
	        selectCtrl.writeValue = function writeNgOptionsValue(value) {
	          var selectedOption = options.selectValueMap[selectElement.val()];
	          var option = options.getOptionFromViewValue(value);
	
	          // Make sure to remove the selected attribute from the previously selected option
	          // Otherwise, screen readers might get confused
	          if (selectedOption) selectedOption.element.removeAttribute('selected');
	
	          if (option) {
	            // Don't update the option when it is already selected.
	            // For example, the browser will select the first option by default. In that case,
	            // most properties are set automatically - except the `selected` attribute, which we
	            // set always
	
	            if (selectElement[0].value !== option.selectValue) {
	              selectCtrl.removeUnknownOption();
	              selectCtrl.unselectEmptyOption();
	
	              selectElement[0].value = option.selectValue;
	              option.element.selected = true;
	            }
	
	            option.element.setAttribute('selected', 'selected');
	          } else {
	
	            if (providedEmptyOption) {
	              selectCtrl.selectEmptyOption();
	            } else if (selectCtrl.unknownOption.parent().length) {
	              selectCtrl.updateUnknownOption(value);
	            } else {
	              selectCtrl.renderUnknownOption(value);
	            }
	          }
	        };
	
	        selectCtrl.readValue = function readNgOptionsValue() {
	
	          var selectedOption = options.selectValueMap[selectElement.val()];
	
	          if (selectedOption && !selectedOption.disabled) {
	            selectCtrl.unselectEmptyOption();
	            selectCtrl.removeUnknownOption();
	            return options.getViewValueFromOption(selectedOption);
	          }
	          return null;
	        };
	
	        // If we are using `track by` then we must watch the tracked value on the model
	        // since ngModel only watches for object identity change
	        // FIXME: When a user selects an option, this watch will fire needlessly
	        if (ngOptions.trackBy) {
	          scope.$watch(
	            function() { return ngOptions.getTrackByValue(ngModelCtrl.$viewValue); },
	            function() { ngModelCtrl.$render(); }
	          );
	        }
	
	      } else {
	
	        selectCtrl.writeValue = function writeNgOptionsMultiple(values) {
	          // Only set `<option>.selected` if necessary, in order to prevent some browsers from
	          // scrolling to `<option>` elements that are outside the `<select>` element's viewport.
	
	          var selectedOptions = values && values.map(getAndUpdateSelectedOption) || [];
	
	          options.items.forEach(function(option) {
	            if (option.element.selected && !includes(selectedOptions, option)) {
	              option.element.selected = false;
	            }
	          });
	        };
	
	
	        selectCtrl.readValue = function readNgOptionsMultiple() {
	          var selectedValues = selectElement.val() || [],
	              selections = [];
	
	          forEach(selectedValues, function(value) {
	            var option = options.selectValueMap[value];
	            if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
	          });
	
	          return selections;
	        };
	
	        // If we are using `track by` then we must watch these tracked values on the model
	        // since ngModel only watches for object identity change
	        if (ngOptions.trackBy) {
	
	          scope.$watchCollection(function() {
	            if (isArray(ngModelCtrl.$viewValue)) {
	              return ngModelCtrl.$viewValue.map(function(value) {
	                return ngOptions.getTrackByValue(value);
	              });
	            }
	          }, function() {
	            ngModelCtrl.$render();
	          });
	
	        }
	      }
	
	      if (providedEmptyOption) {
	
	        // we need to remove it before calling selectElement.empty() because otherwise IE will
	        // remove the label from the element. wtf?
	        selectCtrl.emptyOption.remove();
	
	        // compile the element since there might be bindings in it
	        $compile(selectCtrl.emptyOption)(scope);
	
	        if (selectCtrl.emptyOption[0].nodeType === NODE_TYPE_COMMENT) {
	          // This means the empty option has currently no actual DOM node, probably because
	          // it has been modified by a transclusion directive.
	          selectCtrl.hasEmptyOption = false;
	
	          // Redefine the registerOption function, which will catch
	          // options that are added by ngIf etc. (rendering of the node is async because of
	          // lazy transclusion)
	          selectCtrl.registerOption = function(optionScope, optionEl) {
	            if (optionEl.val() === '') {
	              selectCtrl.hasEmptyOption = true;
	              selectCtrl.emptyOption = optionEl;
	              selectCtrl.emptyOption.removeClass('ng-scope');
	              // This ensures the new empty option is selected if previously no option was selected
	              ngModelCtrl.$render();
	
	              optionEl.on('$destroy', function() {
	                selectCtrl.hasEmptyOption = false;
	                selectCtrl.emptyOption = undefined;
	              });
	            }
	          };
	
	        } else {
	          // remove the class, which is added automatically because we recompile the element and it
	          // becomes the compilation root
	          selectCtrl.emptyOption.removeClass('ng-scope');
	        }
	
	      }
	
	      selectElement.empty();
	
	      // We need to do this here to ensure that the options object is defined
	      // when we first hit it in writeNgOptionsValue
	      updateOptions();
	
	      // We will re-render the option elements if the option values or labels change
	      scope.$watchCollection(ngOptions.getWatchables, updateOptions);
	
	      // ------------------------------------------------------------------ //
	
	      function addOptionElement(option, parent) {
	        var optionElement = optionTemplate.cloneNode(false);
	        parent.appendChild(optionElement);
	        updateOptionElement(option, optionElement);
	      }
	
	      function getAndUpdateSelectedOption(viewValue) {
	        var option = options.getOptionFromViewValue(viewValue);
	        var element = option && option.element;
	
	        if (element && !element.selected) element.selected = true;
	
	        return option;
	      }
	
	      function updateOptionElement(option, element) {
	        option.element = element;
	        element.disabled = option.disabled;
	        // NOTE: The label must be set before the value, otherwise IE10/11/EDGE create unresponsive
	        // selects in certain circumstances when multiple selects are next to each other and display
	        // the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
	        // See https://github.com/angular/angular.js/issues/11314 for more info.
	        // This is unfortunately untestable with unit / e2e tests
	        if (option.label !== element.label) {
	          element.label = option.label;
	          element.textContent = option.label;
	        }
	        element.value = option.selectValue;
	      }
	
	      function updateOptions() {
	        var previousValue = options && selectCtrl.readValue();
	
	        // We must remove all current options, but cannot simply set innerHTML = null
	        // since the providedEmptyOption might have an ngIf on it that inserts comments which we
	        // must preserve.
	        // Instead, iterate over the current option elements and remove them or their optgroup
	        // parents
	        if (options) {
	
	          for (var i = options.items.length - 1; i >= 0; i--) {
	            var option = options.items[i];
	            if (isDefined(option.group)) {
	              jqLiteRemove(option.element.parentNode);
	            } else {
	              jqLiteRemove(option.element);
	            }
	          }
	        }
	
	        options = ngOptions.getOptions();
	
	        var groupElementMap = {};
	
	        // Ensure that the empty option is always there if it was explicitly provided
	        if (providedEmptyOption) {
	          selectElement.prepend(selectCtrl.emptyOption);
	        }
	
	        options.items.forEach(function addOption(option) {
	          var groupElement;
	
	          if (isDefined(option.group)) {
	
	            // This option is to live in a group
	            // See if we have already created this group
	            groupElement = groupElementMap[option.group];
	
	            if (!groupElement) {
	
	              groupElement = optGroupTemplate.cloneNode(false);
	              listFragment.appendChild(groupElement);
	
	              // Update the label on the group element
	              // "null" is special cased because of Safari
	              groupElement.label = option.group === null ? 'null' : option.group;
	
	              // Store it for use later
	              groupElementMap[option.group] = groupElement;
	            }
	
	            addOptionElement(option, groupElement);
	
	          } else {
	
	            // This option is not in a group
	            addOptionElement(option, listFragment);
	          }
	        });
	
	        selectElement[0].appendChild(listFragment);
	
	        ngModelCtrl.$render();
	
	        // Check to see if the value has changed due to the update to the options
	        if (!ngModelCtrl.$isEmpty(previousValue)) {
	          var nextValue = selectCtrl.readValue();
	          var isNotPrimitive = ngOptions.trackBy || multiple;
	          if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
	            ngModelCtrl.$setViewValue(nextValue);
	            ngModelCtrl.$render();
	          }
	        }
	
	      }
	  }
	
	  return {
	    restrict: 'A',
	    terminal: true,
	    require: ['select', 'ngModel'],
	    link: {
	      pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
	        // Deactivate the SelectController.register method to prevent
	        // option directives from accidentally registering themselves
	        // (and unwanted $destroy handlers etc.)
	        ctrls[0].registerOption = noop;
	      },
	      post: ngOptionsPostLink
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngPluralize
	 * @restrict EA
	 *
	 * @description
	 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
	 * These rules are bundled with angular.js, but can be overridden
	 * (see {@link guide/i18n Angular i18n} dev guide). You configure ngPluralize directive
	 * by specifying the mappings between
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * and the strings to be displayed.
	 *
	 * # Plural categories and explicit number rules
	 * There are two
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * in Angular's default en-US locale: "one" and "other".
	 *
	 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
	 * any number that is not 1), an explicit number rule can only match one number. For example, the
	 * explicit number rule for "3" matches the number 3. There are examples of plural categories
	 * and explicit number rules throughout the rest of this documentation.
	 *
	 * # Configuring ngPluralize
	 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
	 * You can also provide an optional attribute, `offset`.
	 *
	 * The value of the `count` attribute can be either a string or an {@link guide/expression
	 * Angular expression}; these are evaluated on the current scope for its bound value.
	 *
	 * The `when` attribute specifies the mappings between plural categories and the actual
	 * string to be displayed. The value of the attribute should be a JSON object.
	 *
	 * The following example shows how to configure ngPluralize:
	 *
	 * ```html
	 * <ng-pluralize count="personCount"
	                 when="{'0': 'Nobody is viewing.',
	 *                      'one': '1 person is viewing.',
	 *                      'other': '{} people are viewing.'}">
	 * </ng-pluralize>
	 *```
	 *
	 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
	 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
	 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
	 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
	 * show "a dozen people are viewing".
	 *
	 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
	 * into pluralized strings. In the previous example, Angular will replace `{}` with
	 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
	 * for <span ng-non-bindable>{{numberExpression}}</span>.
	 *
	 * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
	 * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
	 *
	 * # Configuring ngPluralize with offset
	 * The `offset` attribute allows further customization of pluralized text, which can result in
	 * a better user experience. For example, instead of the message "4 people are viewing this document",
	 * you might display "John, Kate and 2 others are viewing this document".
	 * The offset attribute allows you to offset a number by any desired value.
	 * Let's take a look at an example:
	 *
	 * ```html
	 * <ng-pluralize count="personCount" offset=2
	 *               when="{'0': 'Nobody is viewing.',
	 *                      '1': '{{person1}} is viewing.',
	 *                      '2': '{{person1}} and {{person2}} are viewing.',
	 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
	 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	 * </ng-pluralize>
	 * ```
	 *
	 * Notice that we are still using two plural categories(one, other), but we added
	 * three explicit number rules 0, 1 and 2.
	 * When one person, perhaps John, views the document, "John is viewing" will be shown.
	 * When three people view the document, no explicit number rule is found, so
	 * an offset of 2 is taken off 3, and Angular uses 1 to decide the plural category.
	 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
	 * is shown.
	 *
	 * Note that when you specify offsets, you must provide explicit number rules for
	 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
	 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
	 * plural categories "one" and "other".
	 *
	 * @param {string|expression} count The variable to be bound to.
	 * @param {string} when The mapping between plural category to its corresponding strings.
	 * @param {number=} offset Offset to deduct from the total number.
	 *
	 * @example
	    <example module="pluralizeExample" name="ng-pluralize">
	      <file name="index.html">
	        <script>
	          angular.module('pluralizeExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.person1 = 'Igor';
	              $scope.person2 = 'Misko';
	              $scope.personCount = 1;
	            }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
	          <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
	          <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>
	
	          <!--- Example with simple pluralization rules for en locale --->
	          Without Offset:
	          <ng-pluralize count="personCount"
	                        when="{'0': 'Nobody is viewing.',
	                               'one': '1 person is viewing.',
	                               'other': '{} people are viewing.'}">
	          </ng-pluralize><br>
	
	          <!--- Example with offset --->
	          With Offset(2):
	          <ng-pluralize count="personCount" offset=2
	                        when="{'0': 'Nobody is viewing.',
	                               '1': '{{person1}} is viewing.',
	                               '2': '{{person1}} and {{person2}} are viewing.',
	                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
	                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	          </ng-pluralize>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should show correct pluralized string', function() {
	          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var countInput = element(by.model('personCount'));
	
	          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
	          expect(withOffset.getText()).toEqual('Igor is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('0');
	
	          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
	          expect(withOffset.getText()).toEqual('Nobody is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('2');
	
	          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('3');
	
	          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('4');
	
	          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
	        });
	        it('should show data-bound names', function() {
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var personCount = element(by.model('personCount'));
	          var person1 = element(by.model('person1'));
	          var person2 = element(by.model('person2'));
	          personCount.clear();
	          personCount.sendKeys('4');
	          person1.clear();
	          person1.sendKeys('Di');
	          person2.clear();
	          person2.sendKeys('Vojta');
	          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
	        });
	      </file>
	    </example>
	 */
	var ngPluralizeDirective = ['$locale', '$interpolate', '$log', function($locale, $interpolate, $log) {
	  var BRACE = /{}/g,
	      IS_WHEN = /^when(Minus)?(.+)$/;
	
	  return {
	    link: function(scope, element, attr) {
	      var numberExp = attr.count,
	          whenExp = attr.$attr.when && element.attr(attr.$attr.when), // we have {{}} in attrs
	          offset = attr.offset || 0,
	          whens = scope.$eval(whenExp) || {},
	          whensExpFns = {},
	          startSymbol = $interpolate.startSymbol(),
	          endSymbol = $interpolate.endSymbol(),
	          braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
	          watchRemover = angular.noop,
	          lastCount;
	
	      forEach(attr, function(expression, attributeName) {
	        var tmpMatch = IS_WHEN.exec(attributeName);
	        if (tmpMatch) {
	          var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
	          whens[whenKey] = element.attr(attr.$attr[attributeName]);
	        }
	      });
	      forEach(whens, function(expression, key) {
	        whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));
	
	      });
	
	      scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
	        var count = parseFloat(newVal);
	        var countIsNaN = isNumberNaN(count);
	
	        if (!countIsNaN && !(count in whens)) {
	          // If an explicit number rule such as 1, 2, 3... is defined, just use it.
	          // Otherwise, check it against pluralization rules in $locale service.
	          count = $locale.pluralCat(count - offset);
	        }
	
	        // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
	        // In JS `NaN !== NaN`, so we have to explicitly check.
	        if ((count !== lastCount) && !(countIsNaN && isNumberNaN(lastCount))) {
	          watchRemover();
	          var whenExpFn = whensExpFns[count];
	          if (isUndefined(whenExpFn)) {
	            if (newVal != null) {
	              $log.debug('ngPluralize: no rule defined for \'' + count + '\' in ' + whenExp);
	            }
	            watchRemover = noop;
	            updateElementText();
	          } else {
	            watchRemover = scope.$watch(whenExpFn, updateElementText);
	          }
	          lastCount = count;
	        }
	      });
	
	      function updateElementText(newText) {
	        element.text(newText || '');
	      }
	    }
	  };
	}];
	
	/* exported ngRepeatDirective */
	
	/**
	 * @ngdoc directive
	 * @name ngRepeat
	 * @multiElement
	 * @restrict A
	 *
	 * @description
	 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
	 * instance gets its own scope, where the given loop variable is set to the current collection item,
	 * and `$index` is set to the item index or key.
	 *
	 * Special properties are exposed on the local scope of each template instance, including:
	 *
	 * | Variable  | Type            | Details                                                                     |
	 * |-----------|-----------------|-----------------------------------------------------------------------------|
	 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
	 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
	 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
	 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
	 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
	 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
	 *
	 * <div class="alert alert-info">
	 *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
	 *   This may be useful when, for instance, nesting ngRepeats.
	 * </div>
	 *
	 *
	 * # Iterating over object properties
	 *
	 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
	 * syntax:
	 *
	 * ```js
	 * <div ng-repeat="(key, value) in myObj"> ... </div>
	 * ```
	 *
	 * However, there are a few limitations compared to array iteration:
	 *
	 * - The JavaScript specification does not define the order of keys
	 *   returned for an object, so Angular relies on the order returned by the browser
	 *   when running `for key in myObj`. Browsers generally follow the strategy of providing
	 *   keys in the order in which they were defined, although there are exceptions when keys are deleted
	 *   and reinstated. See the
	 *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
	 *
	 * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
	 *   it's a prefix used by Angular for public (`$`) and private (`$$`) properties.
	 *
	 * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
	 *   objects, and will throw an error if used with one.
	 *
	 * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
	 * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
	 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
	 * or implement a `$watch` on the object yourself.
	 *
	 *
	 * # Tracking and Duplicates
	 *
	 * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
	 * the collection. When a change happens, `ngRepeat` then makes the corresponding changes to the DOM:
	 *
	 * * When an item is added, a new instance of the template is added to the DOM.
	 * * When an item is removed, its template instance is removed from the DOM.
	 * * When items are reordered, their respective templates are reordered in the DOM.
	 *
	 * To minimize creation of DOM elements, `ngRepeat` uses a function
	 * to "keep track" of all items in the collection and their corresponding DOM elements.
	 * For example, if an item is added to the collection, `ngRepeat` will know that all other items
	 * already have DOM elements, and will not re-render them.
	 *
	 * The default tracking function (which tracks items by their identity) does not allow
	 * duplicate items in arrays. This is because when there are duplicates, it is not possible
	 * to maintain a one-to-one mapping between collection items and DOM elements.
	 *
	 * If you do need to repeat duplicate items, you can substitute the default tracking behavior
	 * with your own using the `track by` expression.
	 *
	 * For example, you may track items by the index of each item in the collection, using the
	 * special scope property `$index`:
	 * ```html
	 *    <div ng-repeat="n in [42, 42, 43, 43] track by $index">
	 *      {{n}}
	 *    </div>
	 * ```
	 *
	 * You may also use arbitrary expressions in `track by`, including references to custom functions
	 * on the scope:
	 * ```html
	 *    <div ng-repeat="n in [42, 42, 43, 43] track by myTrackingFunction(n)">
	 *      {{n}}
	 *    </div>
	 * ```
	 *
	 * <div class="alert alert-success">
	 * If you are working with objects that have a unique identifier property, you should track
	 * by this identifier instead of the object instance. Should you reload your data later, `ngRepeat`
	 * will not have to rebuild the DOM elements for items it has already rendered, even if the
	 * JavaScript objects in the collection have been substituted for new ones. For large collections,
	 * this significantly improves rendering performance. If you don't have a unique identifier,
	 * `track by $index` can also provide a performance boost.
	 * </div>
	 *
	 * ```html
	 *    <div ng-repeat="model in collection track by model.id">
	 *      {{model.name}}
	 *    </div>
	 * ```
	 *
	 * <br />
	 * <div class="alert alert-warning">
	 * Avoid using `track by $index` when the repeated template contains
	 * {@link guide/expression#one-time-binding one-time bindings}. In such cases, the `nth` DOM
	 * element will always be matched with the `nth` item of the array, so the bindings on that element
	 * will not be updated even when the corresponding item changes, essentially causing the view to get
	 * out-of-sync with the underlying data.
	 * </div>
	 *
	 * When no `track by` expression is provided, it is equivalent to tracking by the built-in
	 * `$id` function, which tracks items by their identity:
	 * ```html
	 *    <div ng-repeat="obj in collection track by $id(obj)">
	 *      {{obj.prop}}
	 *    </div>
	 * ```
	 *
	 * <br />
	 * <div class="alert alert-warning">
	 * **Note:** `track by` must always be the last expression:
	 * </div>
	 * ```
	 *    <div ng-repeat="model in collection | orderBy: 'id' as filtered_result track by model.id">
	 *      {{model.name}}
	 *    </div>
	 * ```
	 *
	 *
	 * # Special repeat start and end points
	 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
	 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
	 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
	 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
	 *
	 * The example below makes use of this feature:
	 * ```html
	 *   <header ng-repeat-start="item in items">
	 *     Header {{ item }}
	 *   </header>
	 *   <div class="body">
	 *     Body {{ item }}
	 *   </div>
	 *   <footer ng-repeat-end>
	 *     Footer {{ item }}
	 *   </footer>
	 * ```
	 *
	 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
	 * ```html
	 *   <header>
	 *     Header A
	 *   </header>
	 *   <div class="body">
	 *     Body A
	 *   </div>
	 *   <footer>
	 *     Footer A
	 *   </footer>
	 *   <header>
	 *     Header B
	 *   </header>
	 *   <div class="body">
	 *     Body B
	 *   </div>
	 *   <footer>
	 *     Footer B
	 *   </footer>
	 * ```
	 *
	 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
	 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
	 * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
	 * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
	 *
	 * See the example below for defining CSS animations with ngRepeat.
	 *
	 * @element ANY
	 * @scope
	 * @priority 1000
	 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
	 *   formats are currently supported:
	 *
	 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
	 *     is a scope expression giving the collection to enumerate.
	 *
	 *     For example: `album in artist.albums`.
	 *
	 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
	 *     and `expression` is the scope expression giving the collection to enumerate.
	 *
	 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
	 *
	 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
	 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
	 *     is specified, ng-repeat associates elements by identity. It is an error to have
	 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
	 *     mapped to the same DOM element, which is not possible.)
	 *
	 *     Note that the tracking expression must come last, after any filters, and the alias expression.
	 *
	 *     For example: `item in items` is equivalent to `item in items track by $id(item)`. This implies that the DOM elements
	 *     will be associated by item identity in the array.
	 *
	 *     For example: `item in items track by $id(item)`. A built in `$id()` function can be used to assign a unique
	 *     `$$hashKey` property to each item in the array. This property is then used as a key to associated DOM elements
	 *     with the corresponding item in the array by identity. Moving the same object in array would move the DOM
	 *     element in the same way in the DOM.
	 *
	 *     For example: `item in items track by item.id` is a typical pattern when the items come from the database. In this
	 *     case the object identity does not matter. Two objects are considered equivalent as long as their `id`
	 *     property is same.
	 *
	 *     For example: `item in items | filter:searchText track by item.id` is a pattern that might be used to apply a filter
	 *     to items in conjunction with a tracking expression.
	 *
	 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
	 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
	 *     when a filter is active on the repeater, but the filtered result set is empty.
	 *
	 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
	 *     the items have been processed through the filter.
	 *
	 *     Please note that `as [variable name] is not an operator but rather a part of ngRepeat micro-syntax so it can be used only at the end
	 *     (and not as operator, inside an expression).
	 *
	 *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results` .
	 *
	 * @example
	 * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
	 * results by name or by age. New (entering) and removed (leaving) items are animated.
	  <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true" name="ng-repeat">
	    <file name="index.html">
	      <div ng-controller="repeatController">
	        I have {{friends.length}} friends. They are:
	        <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results">
	            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
	          </li>
	          <li class="animate-repeat" ng-if="results.length === 0">
	            <strong>No results found...</strong>
	          </li>
	        </ul>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
	        $scope.friends = [
	          {name:'John', age:25, gender:'boy'},
	          {name:'Jessie', age:30, gender:'girl'},
	          {name:'Johanna', age:28, gender:'girl'},
	          {name:'Joy', age:15, gender:'girl'},
	          {name:'Mary', age:28, gender:'girl'},
	          {name:'Peter', age:95, gender:'boy'},
	          {name:'Sebastian', age:50, gender:'boy'},
	          {name:'Erika', age:27, gender:'girl'},
	          {name:'Patrick', age:40, gender:'boy'},
	          {name:'Samantha', age:60, gender:'girl'}
	        ];
	      });
	    </file>
	    <file name="animations.css">
	      .example-animate-container {
	        background:white;
	        border:1px solid black;
	        list-style:none;
	        margin:0;
	        padding:0 10px;
	      }
	
	      .animate-repeat {
	        line-height:30px;
	        list-style:none;
	        box-sizing:border-box;
	      }
	
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter,
	      .animate-repeat.ng-leave {
	        transition:all linear 0.5s;
	      }
	
	      .animate-repeat.ng-leave.ng-leave-active,
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter {
	        opacity:0;
	        max-height:0;
	      }
	
	      .animate-repeat.ng-leave,
	      .animate-repeat.ng-move.ng-move-active,
	      .animate-repeat.ng-enter.ng-enter-active {
	        opacity:1;
	        max-height:30px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var friends = element.all(by.repeater('friend in friends'));
	
	      it('should render initial data set', function() {
	        expect(friends.count()).toBe(10);
	        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
	        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
	        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
	        expect(element(by.binding('friends.length')).getText())
	            .toMatch("I have 10 friends. They are:");
	      });
	
	       it('should update repeater when filter predicate changes', function() {
	         expect(friends.count()).toBe(10);
	
	         element(by.model('q')).sendKeys('ma');
	
	         expect(friends.count()).toBe(2);
	         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
	         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
	       });
	      </file>
	    </example>
	 */
	var ngRepeatDirective = ['$parse', '$animate', '$compile', function($parse, $animate, $compile) {
	  var NG_REMOVED = '$$NG_REMOVED';
	  var ngRepeatMinErr = minErr('ngRepeat');
	
	  var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
	    // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
	    scope[valueIdentifier] = value;
	    if (keyIdentifier) scope[keyIdentifier] = key;
	    scope.$index = index;
	    scope.$first = (index === 0);
	    scope.$last = (index === (arrayLength - 1));
	    scope.$middle = !(scope.$first || scope.$last);
	    // eslint-disable-next-line no-bitwise
	    scope.$odd = !(scope.$even = (index & 1) === 0);
	  };
	
	  var getBlockStart = function(block) {
	    return block.clone[0];
	  };
	
	  var getBlockEnd = function(block) {
	    return block.clone[block.clone.length - 1];
	  };
	
	
	  return {
	    restrict: 'A',
	    multiElement: true,
	    transclude: 'element',
	    priority: 1000,
	    terminal: true,
	    $$tlb: true,
	    compile: function ngRepeatCompile($element, $attr) {
	      var expression = $attr.ngRepeat;
	      var ngRepeatEndComment = $compile.$$createComment('end ngRepeat', expression);
	
	      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iexp', 'Expected expression in form of \'_item_ in _collection_[ track by _id_]\' but got \'{0}\'.',
	            expression);
	      }
	
	      var lhs = match[1];
	      var rhs = match[2];
	      var aliasAs = match[3];
	      var trackByExp = match[4];
	
	      match = lhs.match(/^(?:(\s*[$\w]+)|\(\s*([$\w]+)\s*,\s*([$\w]+)\s*\))$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iidexp', '\'_item_\' in \'_item_ in _collection_\' should be an identifier or \'(_key_, _value_)\' expression, but got \'{0}\'.',
	            lhs);
	      }
	      var valueIdentifier = match[3] || match[1];
	      var keyIdentifier = match[2];
	
	      if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) ||
	          /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
	        throw ngRepeatMinErr('badident', 'alias \'{0}\' is invalid --- must be a valid JS identifier which is not a reserved name.',
	          aliasAs);
	      }
	
	      var trackByExpGetter, trackByIdExpFn, trackByIdArrayFn, trackByIdObjFn;
	      var hashFnLocals = {$id: hashKey};
	
	      if (trackByExp) {
	        trackByExpGetter = $parse(trackByExp);
	      } else {
	        trackByIdArrayFn = function(key, value) {
	          return hashKey(value);
	        };
	        trackByIdObjFn = function(key) {
	          return key;
	        };
	      }
	
	      return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {
	
	        if (trackByExpGetter) {
	          trackByIdExpFn = function(key, value, index) {
	            // assign key, value, and $index to the locals so that they can be used in hash functions
	            if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
	            hashFnLocals[valueIdentifier] = value;
	            hashFnLocals.$index = index;
	            return trackByExpGetter($scope, hashFnLocals);
	          };
	        }
	
	        // Store a list of elements from previous run. This is a hash where key is the item from the
	        // iterator, and the value is objects with following properties.
	        //   - scope: bound scope
	        //   - element: previous element.
	        //   - index: position
	        //
	        // We are using no-proto object so that we don't need to guard against inherited props via
	        // hasOwnProperty.
	        var lastBlockMap = createMap();
	
	        //watch props
	        $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
	          var index, length,
	              previousNode = $element[0],     // node that cloned nodes should be inserted after
	                                              // initialized to the comment node anchor
	              nextNode,
	              // Same as lastBlockMap but it has the current state. It will become the
	              // lastBlockMap on the next iteration.
	              nextBlockMap = createMap(),
	              collectionLength,
	              key, value, // key/value of iteration
	              trackById,
	              trackByIdFn,
	              collectionKeys,
	              block,       // last object information {scope, element, id}
	              nextBlockOrder,
	              elementsToRemove;
	
	          if (aliasAs) {
	            $scope[aliasAs] = collection;
	          }
	
	          if (isArrayLike(collection)) {
	            collectionKeys = collection;
	            trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
	          } else {
	            trackByIdFn = trackByIdExpFn || trackByIdObjFn;
	            // if object, extract keys, in enumeration order, unsorted
	            collectionKeys = [];
	            for (var itemKey in collection) {
	              if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== '$') {
	                collectionKeys.push(itemKey);
	              }
	            }
	          }
	
	          collectionLength = collectionKeys.length;
	          nextBlockOrder = new Array(collectionLength);
	
	          // locate existing items
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            trackById = trackByIdFn(key, value, index);
	            if (lastBlockMap[trackById]) {
	              // found previously seen block
	              block = lastBlockMap[trackById];
	              delete lastBlockMap[trackById];
	              nextBlockMap[trackById] = block;
	              nextBlockOrder[index] = block;
	            } else if (nextBlockMap[trackById]) {
	              // if collision detected. restore lastBlockMap and throw an error
	              forEach(nextBlockOrder, function(block) {
	                if (block && block.scope) lastBlockMap[block.id] = block;
	              });
	              throw ngRepeatMinErr('dupes',
	                  'Duplicates in a repeater are not allowed. Use \'track by\' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}',
	                  expression, trackById, value);
	            } else {
	              // new never before seen block
	              nextBlockOrder[index] = {id: trackById, scope: undefined, clone: undefined};
	              nextBlockMap[trackById] = true;
	            }
	          }
	
	          // remove leftover items
	          for (var blockKey in lastBlockMap) {
	            block = lastBlockMap[blockKey];
	            elementsToRemove = getBlockNodes(block.clone);
	            $animate.leave(elementsToRemove);
	            if (elementsToRemove[0].parentNode) {
	              // if the element was not removed yet because of pending animation, mark it as deleted
	              // so that we can ignore it later
	              for (index = 0, length = elementsToRemove.length; index < length; index++) {
	                elementsToRemove[index][NG_REMOVED] = true;
	              }
	            }
	            block.scope.$destroy();
	          }
	
	          // we are not using forEach for perf reasons (trying to avoid #call)
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            block = nextBlockOrder[index];
	
	            if (block.scope) {
	              // if we have already seen this object, then we need to reuse the
	              // associated scope/element
	
	              nextNode = previousNode;
	
	              // skip nodes that are already pending removal via leave animation
	              do {
	                nextNode = nextNode.nextSibling;
	              } while (nextNode && nextNode[NG_REMOVED]);
	
	              if (getBlockStart(block) !== nextNode) {
	                // existing item which got moved
	                $animate.move(getBlockNodes(block.clone), null, previousNode);
	              }
	              previousNode = getBlockEnd(block);
	              updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	            } else {
	              // new item which we don't know about
	              $transclude(function ngRepeatTransclude(clone, scope) {
	                block.scope = scope;
	                // http://jsperf.com/clone-vs-createcomment
	                var endNode = ngRepeatEndComment.cloneNode(false);
	                clone[clone.length++] = endNode;
	
	                $animate.enter(clone, null, previousNode);
	                previousNode = endNode;
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block.clone = clone;
	                nextBlockMap[block.id] = block;
	                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	              });
	            }
	          }
	          lastBlockMap = nextBlockMap;
	        });
	      };
	    }
	  };
	}];
	
	var NG_HIDE_CLASS = 'ng-hide';
	var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
	/**
	 * @ngdoc directive
	 * @name ngShow
	 * @multiElement
	 *
	 * @description
	 * The `ngShow` directive shows or hides the given HTML element based on the expression provided to
	 * the `ngShow` attribute.
	 *
	 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
	 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
	 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
	 * {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is visible) -->
	 * <div ng-show="myValue"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is hidden) -->
	 * <div ng-show="myValue" class="ng-hide"></div>
	 * ```
	 *
	 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added
	 * to the class attribute on the element causing it to become hidden. When truthy, the `.ng-hide`
	 * CSS class is removed from the element causing the element not to appear hidden.
	 *
	 * ## Why is `!important` used?
	 *
	 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
	 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
	 * simple as changing the display style on a HTML list item would make hidden elements appear
	 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using `!important`, the show and hide behavior will work as expected despite any clash between
	 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
	 * developer chooses to override the styling to change how to hide an element then it is just a
	 * matter of using `!important` in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
	 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
	 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
	 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; These are just alternative ways of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override anything in CSS and the animations will work around the
	 * display style.
	 *
	 * ## A note about animations with `ngShow`
	 *
	 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
	 * directive expression is true and false. This system works like the animation system present with
	 * `ngClass` except that you must also include the `!important` flag to override the display
	 * property so that the elements are not actually hidden during the animation.
	 *
	 * ```css
	 * /&#42; A working example can be found at the bottom of this page. &#42;/
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: all 0.5s linear;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
	 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
	 *
	 * @animations
	 * | Animation                                           | Occurs                                                                                                        |
	 * |-----------------------------------------------------|---------------------------------------------------------------------------------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden. |
	 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngShow` expression evaluates to a truthy value and just before contents are set to visible.        |
	 *
	 * @element ANY
	 * @param {expression} ngShow If the {@link guide/expression expression} is truthy/falsy then the
	 *                            element is shown/hidden respectively.
	 *
	 * @example
	 * A simple example, animating the element's opacity:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-simple">
	    <file name="index.html">
	      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
	      <div class="check-element animate-show-hide" ng-show="checked">
	        I show up when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      .animate-show-hide.ng-hide {
	        opacity: 0;
	      }
	
	      .animate-show-hide.ng-hide-add,
	      .animate-show-hide.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngShow', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(false);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(true);
	      });
	    </file>
	  </example>
	 *
	 * <hr />
	 * @example
	 * A more complex example, featuring different show/hide animations:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-complex">
	    <file name="index.html">
	      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
	      <div class="check-element funky-show-hide" ng-show="checked">
	        I show up when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      body {
	        overflow: hidden;
	        perspective: 1000px;
	      }
	
	      .funky-show-hide.ng-hide-add {
	        transform: rotateZ(0);
	        transform-origin: right;
	        transition: all 0.5s ease-in-out;
	      }
	
	      .funky-show-hide.ng-hide-add.ng-hide-add-active {
	        transform: rotateZ(-135deg);
	      }
	
	      .funky-show-hide.ng-hide-remove {
	        transform: rotateY(90deg);
	        transform-origin: left;
	        transition: all 0.5s ease;
	      }
	
	      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
	        transform: rotateY(0);
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngShow', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(false);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(true);
	      });
	    </file>
	  </example>
	 */
	var ngShowDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
	        // we're adding a temporary, animation-specific class for ng-hide since this way
	        // we can control when the element is actually displayed on screen without having
	        // to have a global/greedy CSS selector that breaks when other animations are run.
	        // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
	        $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngHide
	 * @multiElement
	 *
	 * @description
	 * The `ngHide` directive shows or hides the given HTML element based on the expression provided to
	 * the `ngHide` attribute.
	 *
	 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
	 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
	 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
	 * {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is hidden) -->
	 * <div ng-hide="myValue" class="ng-hide"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is visible) -->
	 * <div ng-hide="myValue"></div>
	 * ```
	 *
	 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added
	 * to the class attribute on the element causing it to become hidden. When falsy, the `.ng-hide`
	 * CSS class is removed from the element causing the element not to appear hidden.
	 *
	 * ## Why is `!important` used?
	 *
	 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
	 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
	 * simple as changing the display style on a HTML list item would make hidden elements appear
	 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using `!important`, the show and hide behavior will work as expected despite any clash between
	 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
	 * developer chooses to override the styling to change how to hide an element then it is just a
	 * matter of using `!important` in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
	 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
	 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
	 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; These are just alternative ways of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override in CSS anything and the animations will work around the
	 * display style.
	 *
	 * ## A note about animations with `ngHide`
	 *
	 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
	 * directive expression is true and false. This system works like the animation system present with
	 * `ngClass` except that you must also include the `!important` flag to override the display
	 * property so that the elements are not actually hidden during the animation.
	 *
	 * ```css
	 * /&#42; A working example can be found at the bottom of this page. &#42;/
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: all 0.5s linear;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
	 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
	 *
	 * @animations
	 * | Animation                                           | Occurs                                                                                                     |
	 * |-----------------------------------------------------|------------------------------------------------------------------------------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden.  |
	 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible. |
	 *
	 *
	 * @element ANY
	 * @param {expression} ngHide If the {@link guide/expression expression} is truthy/falsy then the
	 *                            element is hidden/shown respectively.
	 *
	 * @example
	 * A simple example, animating the element's opacity:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-simple">
	    <file name="index.html">
	      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
	      <div class="check-element animate-show-hide" ng-hide="checked">
	        I hide when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      .animate-show-hide.ng-hide {
	        opacity: 0;
	      }
	
	      .animate-show-hide.ng-hide-add,
	      .animate-show-hide.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngHide', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(true);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(false);
	      });
	    </file>
	  </example>
	 *
	 * <hr />
	 * @example
	 * A more complex example, featuring different show/hide animations:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-complex">
	    <file name="index.html">
	      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
	      <div class="check-element funky-show-hide" ng-hide="checked">
	        I hide when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      body {
	        overflow: hidden;
	        perspective: 1000px;
	      }
	
	      .funky-show-hide.ng-hide-add {
	        transform: rotateZ(0);
	        transform-origin: right;
	        transition: all 0.5s ease-in-out;
	      }
	
	      .funky-show-hide.ng-hide-add.ng-hide-add-active {
	        transform: rotateZ(-135deg);
	      }
	
	      .funky-show-hide.ng-hide-remove {
	        transform: rotateY(90deg);
	        transform-origin: left;
	        transition: all 0.5s ease;
	      }
	
	      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
	        transform: rotateY(0);
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngHide', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(true);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(false);
	      });
	    </file>
	  </example>
	 */
	var ngHideDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
	        // The comment inside of the ngShowDirective explains why we add and
	        // remove a temporary class for the show/hide animation
	        $animate[value ? 'addClass' : 'removeClass'](element,NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngStyle
	 * @restrict AC
	 *
	 * @description
	 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `style`
	 * attribute, when using the `ngStyle` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @element ANY
	 * @param {expression} ngStyle
	 *
	 * {@link guide/expression Expression} which evals to an
	 * object whose keys are CSS style names and values are corresponding values for those CSS
	 * keys.
	 *
	 * Since some CSS style names are not valid keys for an object, they must be quoted.
	 * See the 'background-color' style in the example below.
	 *
	 * @example
	   <example name="ng-style">
	     <file name="index.html">
	        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
	        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
	        <input type="button" value="clear" ng-click="myStyle={}">
	        <br/>
	        <span ng-style="myStyle">Sample Text</span>
	        <pre>myStyle={{myStyle}}</pre>
	     </file>
	     <file name="style.css">
	       span {
	         color: black;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var colorSpan = element(by.css('span'));
	
	       it('should check ng-style', function() {
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	         element(by.css('input[value=\'set color\']')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(255, 0, 0, 1)');
	         element(by.css('input[value=clear]')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	       });
	     </file>
	   </example>
	 */
	var ngStyleDirective = ngDirective(function(scope, element, attr) {
	  scope.$watch(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
	    if (oldStyles && (newStyles !== oldStyles)) {
	      forEach(oldStyles, function(val, style) { element.css(style, '');});
	    }
	    if (newStyles) element.css(newStyles);
	  }, true);
	});
	
	/**
	 * @ngdoc directive
	 * @name ngSwitch
	 * @restrict EA
	 *
	 * @description
	 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
	 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
	 * as specified in the template.
	 *
	 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
	 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
	 * matches the value obtained from the evaluated expression. In other words, you define a container element
	 * (where you place the directive), place an expression on the **`on="..."` attribute**
	 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
	 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
	 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
	 * attribute is displayed.
	 *
	 * <div class="alert alert-info">
	 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
	 * as literal string values to match against.
	 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
	 * value of the expression `$scope.someVal`.
	 * </div>
	
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
	 * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
	 *
	 * @usage
	 *
	 * ```
	 * <ANY ng-switch="expression">
	 *   <ANY ng-switch-when="matchValue1">...</ANY>
	 *   <ANY ng-switch-when="matchValue2">...</ANY>
	 *   <ANY ng-switch-default>...</ANY>
	 * </ANY>
	 * ```
	 *
	 *
	 * @scope
	 * @priority 1200
	 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
	 * On child elements add:
	 *
	 * * `ngSwitchWhen`: the case statement to match against. If match then this
	 *   case will be displayed. If the same match appears multiple times, all the
	 *   elements will be displayed. It is possible to associate multiple values to
	 *   the same `ngSwitchWhen` by defining the optional attribute
	 *   `ngSwitchWhenSeparator`. The separator will be used to split the value of
	 *   the `ngSwitchWhen` attribute into multiple tokens, and the element will show
	 *   if any of the `ngSwitch` evaluates to any of these tokens.
	 * * `ngSwitchDefault`: the default case when no other case match. If there
	 *   are multiple default cases, all of them will be displayed when no other
	 *   case match.
	 *
	 *
	 * @example
	  <example module="switchExample" deps="angular-animate.js" animations="true" name="ng-switch">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <select ng-model="selection" ng-options="item for item in items">
	        </select>
	        <code>selection={{selection}}</code>
	        <hr/>
	        <div class="animate-switch-container"
	          ng-switch on="selection">
	            <div class="animate-switch" ng-switch-when="settings|options" ng-switch-when-separator="|">Settings Div</div>
	            <div class="animate-switch" ng-switch-when="home">Home Span</div>
	            <div class="animate-switch" ng-switch-default>default</div>
	        </div>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('switchExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.items = ['settings', 'home', 'options', 'other'];
	          $scope.selection = $scope.items[0];
	        }]);
	    </file>
	    <file name="animations.css">
	      .animate-switch-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .animate-switch {
	        padding:10px;
	      }
	
	      .animate-switch.ng-animate {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	      }
	
	      .animate-switch.ng-leave.ng-leave-active,
	      .animate-switch.ng-enter {
	        top:-50px;
	      }
	      .animate-switch.ng-leave,
	      .animate-switch.ng-enter.ng-enter-active {
	        top:0;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var switchElem = element(by.css('[ng-switch]'));
	      var select = element(by.model('selection'));
	
	      it('should start in settings', function() {
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should change to home', function() {
	        select.all(by.css('option')).get(1).click();
	        expect(switchElem.getText()).toMatch(/Home Span/);
	      });
	      it('should change to settings via "options"', function() {
	        select.all(by.css('option')).get(2).click();
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should select default', function() {
	        select.all(by.css('option')).get(3).click();
	        expect(switchElem.getText()).toMatch(/default/);
	      });
	    </file>
	  </example>
	 */
	var ngSwitchDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    require: 'ngSwitch',
	
	    // asks for $scope to fool the BC controller module
	    controller: ['$scope', function NgSwitchController() {
	     this.cases = {};
	    }],
	    link: function(scope, element, attr, ngSwitchController) {
	      var watchExpr = attr.ngSwitch || attr.on,
	          selectedTranscludes = [],
	          selectedElements = [],
	          previousLeaveAnimations = [],
	          selectedScopes = [];
	
	      var spliceFactory = function(array, index) {
	          return function(response) {
	            if (response !== false) array.splice(index, 1);
	          };
	      };
	
	      scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
	        var i, ii;
	
	        // Start with the last, in case the array is modified during the loop
	        while (previousLeaveAnimations.length) {
	          $animate.cancel(previousLeaveAnimations.pop());
	        }
	
	        for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
	          var selected = getBlockNodes(selectedElements[i].clone);
	          selectedScopes[i].$destroy();
	          var runner = previousLeaveAnimations[i] = $animate.leave(selected);
	          runner.done(spliceFactory(previousLeaveAnimations, i));
	        }
	
	        selectedElements.length = 0;
	        selectedScopes.length = 0;
	
	        if ((selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?'])) {
	          forEach(selectedTranscludes, function(selectedTransclude) {
	            selectedTransclude.transclude(function(caseElement, selectedScope) {
	              selectedScopes.push(selectedScope);
	              var anchor = selectedTransclude.element;
	              caseElement[caseElement.length++] = $compile.$$createComment('end ngSwitchWhen');
	              var block = { clone: caseElement };
	
	              selectedElements.push(block);
	              $animate.enter(caseElement, anchor.parent(), anchor);
	            });
	          });
	        }
	      });
	    }
	  };
	}];
	
	var ngSwitchWhenDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attrs, ctrl, $transclude) {
	
	    var cases = attrs.ngSwitchWhen.split(attrs.ngSwitchWhenSeparator).sort().filter(
	      // Filter duplicate cases
	      function(element, index, array) { return array[index - 1] !== element; }
	    );
	
	    forEach(cases, function(whenCase) {
	      ctrl.cases['!' + whenCase] = (ctrl.cases['!' + whenCase] || []);
	      ctrl.cases['!' + whenCase].push({ transclude: $transclude, element: element });
	    });
	  }
	});
	
	var ngSwitchDefaultDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attr, ctrl, $transclude) {
	    ctrl.cases['?'] = (ctrl.cases['?'] || []);
	    ctrl.cases['?'].push({ transclude: $transclude, element: element });
	   }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngTransclude
	 * @restrict EAC
	 *
	 * @description
	 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
	 *
	 * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
	 * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
	 *
	 * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
	 * content of this element will be removed before the transcluded content is inserted.
	 * If the transcluded content is empty (or only whitespace), the existing content is left intact. This lets you provide fallback
	 * content in the case that no transcluded content is provided.
	 *
	 * @element ANY
	 *
	 * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
	 *                                               or its value is the same as the name of the attribute then the default slot is used.
	 *
	 * @example
	 * ### Basic transclusion
	 * This example demonstrates basic transclusion of content into a component directive.
	 * <example name="simpleTranscludeExample" module="transcludeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('transcludeExample', [])
	 *        .directive('pane', function(){
	 *           return {
	 *             restrict: 'E',
	 *             transclude: true,
	 *             scope: { title:'@' },
	 *             template: '<div style="border: 1px solid black;">' +
	 *                         '<div style="background-color: gray">{{title}}</div>' +
	 *                         '<ng-transclude></ng-transclude>' +
	 *                       '</div>'
	 *           };
	 *       })
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.title = 'Lorem Ipsum';
	 *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *       }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input ng-model="title" aria-label="title"> <br/>
	 *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *       <pane title="{{title}}"><span>{{text}}</span></pane>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *      });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### Transclude fallback content
	 * This example shows how to use `NgTransclude` with fallback content, that
	 * is displayed if no transcluded content is provided.
	 *
	 * <example module="transcludeFallbackContentExample" name="ng-transclude">
	 * <file name="index.html">
	 * <script>
	 * angular.module('transcludeFallbackContentExample', [])
	 * .directive('myButton', function(){
	 *             return {
	 *               restrict: 'E',
	 *               transclude: true,
	 *               scope: true,
	 *               template: '<button style="cursor: pointer;">' +
	 *                           '<ng-transclude>' +
	 *                             '<b style="color: red;">Button1</b>' +
	 *                           '</ng-transclude>' +
	 *                         '</button>'
	 *             };
	 *         });
	 * </script>
	 * <!-- fallback button content -->
	 * <my-button id="fallback"></my-button>
	 * <!-- modified button content -->
	 * <my-button id="modified">
	 *   <i style="color: green;">Button2</i>
	 * </my-button>
	 * </file>
	 * <file name="protractor.js" type="protractor">
	 * it('should have different transclude element content', function() {
	 *          expect(element(by.id('fallback')).getText()).toBe('Button1');
	 *          expect(element(by.id('modified')).getText()).toBe('Button2');
	 *        });
	 * </file>
	 * </example>
	 *
	 * @example
	 * ### Multi-slot transclusion
	 * This example demonstrates using multi-slot transclusion in a component directive.
	 * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
	 *   <file name="index.html">
	 *    <style>
	 *      .title, .footer {
	 *        background-color: gray
	 *      }
	 *    </style>
	 *    <div ng-controller="ExampleController">
	 *      <input ng-model="title" aria-label="title"> <br/>
	 *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *      <pane>
	 *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
	 *        <pane-body><p>{{text}}</p></pane-body>
	 *      </pane>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('multiSlotTranscludeExample', [])
	 *     .directive('pane', function() {
	 *        return {
	 *          restrict: 'E',
	 *          transclude: {
	 *            'title': '?paneTitle',
	 *            'body': 'paneBody',
	 *            'footer': '?paneFooter'
	 *          },
	 *          template: '<div style="border: 1px solid black;">' +
	 *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
	 *                      '<div ng-transclude="body"></div>' +
	 *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
	 *                    '</div>'
	 *        };
	 *    })
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.title = 'Lorem Ipsum';
	 *      $scope.link = 'https://google.com';
	 *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *    }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded the title and the body', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
	 *      });
	 *   </file>
	 * </example>
	 */
	var ngTranscludeMinErr = minErr('ngTransclude');
	var ngTranscludeDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'EAC',
	    terminal: true,
	    compile: function ngTranscludeCompile(tElement) {
	
	      // Remove and cache any original content to act as a fallback
	      var fallbackLinkFn = $compile(tElement.contents());
	      tElement.empty();
	
	      return function ngTranscludePostLink($scope, $element, $attrs, controller, $transclude) {
	
	        if (!$transclude) {
	          throw ngTranscludeMinErr('orphan',
	          'Illegal use of ngTransclude directive in the template! ' +
	          'No parent directive that requires a transclusion found. ' +
	          'Element: {0}',
	          startingTag($element));
	        }
	
	
	        // If the attribute is of the form: `ng-transclude="ng-transclude"` then treat it like the default
	        if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) {
	          $attrs.ngTransclude = '';
	        }
	        var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;
	
	        // If the slot is required and no transclusion content is provided then this call will throw an error
	        $transclude(ngTranscludeCloneAttachFn, null, slotName);
	
	        // If the slot is optional and no transclusion content is provided then use the fallback content
	        if (slotName && !$transclude.isSlotFilled(slotName)) {
	          useFallbackContent();
	        }
	
	        function ngTranscludeCloneAttachFn(clone, transcludedScope) {
	          if (clone.length && notWhitespace(clone)) {
	            $element.append(clone);
	          } else {
	            useFallbackContent();
	            // There is nothing linked against the transcluded scope since no content was available,
	            // so it should be safe to clean up the generated scope.
	            transcludedScope.$destroy();
	          }
	        }
	
	        function useFallbackContent() {
	          // Since this is the fallback content rather than the transcluded content,
	          // we link against the scope of this directive rather than the transcluded scope
	          fallbackLinkFn($scope, function(clone) {
	            $element.append(clone);
	          });
	        }
	
	        function notWhitespace(nodes) {
	          for (var i = 0, ii = nodes.length; i < ii; i++) {
	            var node = nodes[i];
	            if (node.nodeType !== NODE_TYPE_TEXT || node.nodeValue.trim()) {
	              return true;
	            }
	          }
	        }
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name script
	 * @restrict E
	 *
	 * @description
	 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
	 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
	 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
	 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
	 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
	 *
	 * @param {string} type Must be set to `'text/ng-template'`.
	 * @param {string} id Cache name of the template.
	 *
	 * @example
	  <example  name="script-tag">
	    <file name="index.html">
	      <script type="text/ng-template" id="/tpl.html">
	        Content of the template.
	      </script>
	
	      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
	      <div id="tpl-content" ng-include src="currentTpl"></div>
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should load template defined inside script tag', function() {
	        element(by.css('#tpl-link')).click();
	        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
	      });
	    </file>
	  </example>
	 */
	var scriptDirective = ['$templateCache', function($templateCache) {
	  return {
	    restrict: 'E',
	    terminal: true,
	    compile: function(element, attr) {
	      if (attr.type === 'text/ng-template') {
	        var templateUrl = attr.id,
	            text = element[0].text;
	
	        $templateCache.put(templateUrl, text);
	      }
	    }
	  };
	}];
	
	/* exported selectDirective, optionDirective */
	
	var noopNgModelController = { $setViewValue: noop, $render: noop };
	
	function setOptionSelectedStatus(optionEl, value) {
	  optionEl.prop('selected', value); // needed for IE
	  /**
	   * When unselecting an option, setting the property to null / false should be enough
	   * However, screenreaders might react to the selected attribute instead, see
	   * https://github.com/angular/angular.js/issues/14419
	   * Note: "selected" is a boolean attr and will be removed when the "value" arg in attr() is false
	   * or null
	   */
	  optionEl.attr('selected', value);
	}
	
	/**
	 * @ngdoc type
	 * @name  select.SelectController
	 * @description
	 * The controller for the `<select>` directive. This provides support for reading
	 * and writing the selected value(s) of the control and also coordinates dynamically
	 * added `<option>` elements, perhaps by an `ngRepeat` directive.
	 */
	var SelectController =
	        ['$element', '$scope', /** @this */ function($element, $scope) {
	
	  var self = this,
	      optionsMap = new NgMap();
	
	  self.selectValueMap = {}; // Keys are the hashed values, values the original values
	
	  // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
	  self.ngModelCtrl = noopNgModelController;
	  self.multiple = false;
	
	  // The "unknown" option is one that is prepended to the list if the viewValue
	  // does not match any of the options. When it is rendered the value of the unknown
	  // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
	  //
	  // We can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  self.unknownOption = jqLite(window.document.createElement('option'));
	
	  // The empty option is an option with the value '' that te application developer can
	  // provide inside the select. When the model changes to a value that doesn't match an option,
	  // it is selected - so if an empty option is provided, no unknown option is generated.
	  // However, the empty option is not removed when the model matches an option. It is always selectable
	  // and indicates that a "null" selection has been made.
	  self.hasEmptyOption = false;
	  self.emptyOption = undefined;
	
	  self.renderUnknownOption = function(val) {
	    var unknownVal = self.generateUnknownOptionValue(val);
	    self.unknownOption.val(unknownVal);
	    $element.prepend(self.unknownOption);
	    setOptionSelectedStatus(self.unknownOption, true);
	    $element.val(unknownVal);
	  };
	
	  self.updateUnknownOption = function(val) {
	    var unknownVal = self.generateUnknownOptionValue(val);
	    self.unknownOption.val(unknownVal);
	    setOptionSelectedStatus(self.unknownOption, true);
	    $element.val(unknownVal);
	  };
	
	  self.generateUnknownOptionValue = function(val) {
	    return '? ' + hashKey(val) + ' ?';
	  };
	
	  self.removeUnknownOption = function() {
	    if (self.unknownOption.parent()) self.unknownOption.remove();
	  };
	
	  self.selectEmptyOption = function() {
	    if (self.emptyOption) {
	      $element.val('');
	      setOptionSelectedStatus(self.emptyOption, true);
	    }
	  };
	
	  self.unselectEmptyOption = function() {
	    if (self.hasEmptyOption) {
	      self.emptyOption.removeAttr('selected');
	    }
	  };
	
	  $scope.$on('$destroy', function() {
	    // disable unknown option so that we don't do work when the whole select is being destroyed
	    self.renderUnknownOption = noop;
	  });
	
	  // Read the value of the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.readValue = function readSingleValue() {
	    var val = $element.val();
	    // ngValue added option values are stored in the selectValueMap, normal interpolations are not
	    var realVal = val in self.selectValueMap ? self.selectValueMap[val] : val;
	
	    if (self.hasOption(realVal)) {
	      return realVal;
	    }
	
	    return null;
	  };
	
	
	  // Write the value to the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.writeValue = function writeSingleValue(value) {
	    // Make sure to remove the selected attribute from the previously selected option
	    // Otherwise, screen readers might get confused
	    var currentlySelectedOption = $element[0].options[$element[0].selectedIndex];
	    if (currentlySelectedOption) setOptionSelectedStatus(jqLite(currentlySelectedOption), false);
	
	    if (self.hasOption(value)) {
	      self.removeUnknownOption();
	
	      var hashedVal = hashKey(value);
	      $element.val(hashedVal in self.selectValueMap ? hashedVal : value);
	
	      // Set selected attribute and property on selected option for screen readers
	      var selectedOption = $element[0].options[$element[0].selectedIndex];
	      setOptionSelectedStatus(jqLite(selectedOption), true);
	    } else {
	      if (value == null && self.emptyOption) {
	        self.removeUnknownOption();
	        self.selectEmptyOption();
	      } else if (self.unknownOption.parent().length) {
	        self.updateUnknownOption(value);
	      } else {
	        self.renderUnknownOption(value);
	      }
	    }
	  };
	
	
	  // Tell the select control that an option, with the given value, has been added
	  self.addOption = function(value, element) {
	    // Skip comment nodes, as they only pollute the `optionsMap`
	    if (element[0].nodeType === NODE_TYPE_COMMENT) return;
	
	    assertNotHasOwnProperty(value, '"option value"');
	    if (value === '') {
	      self.hasEmptyOption = true;
	      self.emptyOption = element;
	    }
	    var count = optionsMap.get(value) || 0;
	    optionsMap.set(value, count + 1);
	    // Only render at the end of a digest. This improves render performance when many options
	    // are added during a digest and ensures all relevant options are correctly marked as selected
	    scheduleRender();
	  };
	
	  // Tell the select control that an option, with the given value, has been removed
	  self.removeOption = function(value) {
	    var count = optionsMap.get(value);
	    if (count) {
	      if (count === 1) {
	        optionsMap.delete(value);
	        if (value === '') {
	          self.hasEmptyOption = false;
	          self.emptyOption = undefined;
	        }
	      } else {
	        optionsMap.set(value, count - 1);
	      }
	    }
	  };
	
	  // Check whether the select control has an option matching the given value
	  self.hasOption = function(value) {
	    return !!optionsMap.get(value);
	  };
	
	
	  var renderScheduled = false;
	  function scheduleRender() {
	    if (renderScheduled) return;
	    renderScheduled = true;
	    $scope.$$postDigest(function() {
	      renderScheduled = false;
	      self.ngModelCtrl.$render();
	    });
	  }
	
	  var updateScheduled = false;
	  function scheduleViewValueUpdate(renderAfter) {
	    if (updateScheduled) return;
	
	    updateScheduled = true;
	
	    $scope.$$postDigest(function() {
	      if ($scope.$$destroyed) return;
	
	      updateScheduled = false;
	      self.ngModelCtrl.$setViewValue(self.readValue());
	      if (renderAfter) self.ngModelCtrl.$render();
	    });
	  }
	
	
	  self.registerOption = function(optionScope, optionElement, optionAttrs, interpolateValueFn, interpolateTextFn) {
	
	    if (optionAttrs.$attr.ngValue) {
	      // The value attribute is set by ngValue
	      var oldVal, hashedVal = NaN;
	      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	
	        var removal;
	        var previouslySelected = optionElement.prop('selected');
	
	        if (isDefined(hashedVal)) {
	          self.removeOption(oldVal);
	          delete self.selectValueMap[hashedVal];
	          removal = true;
	        }
	
	        hashedVal = hashKey(newVal);
	        oldVal = newVal;
	        self.selectValueMap[hashedVal] = newVal;
	        self.addOption(newVal, optionElement);
	        // Set the attribute directly instead of using optionAttrs.$set - this stops the observer
	        // from firing a second time. Other $observers on value will also get the result of the
	        // ngValue expression, not the hashed value
	        optionElement.attr('value', hashedVal);
	
	        if (removal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	
	      });
	    } else if (interpolateValueFn) {
	      // The value attribute is interpolated
	      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	        // This method is overwritten in ngOptions and has side-effects!
	        self.readValue();
	
	        var removal;
	        var previouslySelected = optionElement.prop('selected');
	
	        if (isDefined(oldVal)) {
	          self.removeOption(oldVal);
	          removal = true;
	        }
	        oldVal = newVal;
	        self.addOption(newVal, optionElement);
	
	        if (removal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	      });
	    } else if (interpolateTextFn) {
	      // The text content is interpolated
	      optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
	        optionAttrs.$set('value', newVal);
	        var previouslySelected = optionElement.prop('selected');
	        if (oldVal !== newVal) {
	          self.removeOption(oldVal);
	        }
	        self.addOption(newVal, optionElement);
	
	        if (oldVal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	      });
	    } else {
	      // The value attribute is static
	      self.addOption(optionAttrs.value, optionElement);
	    }
	
	
	    optionAttrs.$observe('disabled', function(newVal) {
	
	      // Since model updates will also select disabled options (like ngOptions),
	      // we only have to handle options becoming disabled, not enabled
	
	      if (newVal === 'true' || newVal && optionElement.prop('selected')) {
	        if (self.multiple) {
	          scheduleViewValueUpdate(true);
	        } else {
	          self.ngModelCtrl.$setViewValue(null);
	          self.ngModelCtrl.$render();
	        }
	      }
	    });
	
	    optionElement.on('$destroy', function() {
	      var currentValue = self.readValue();
	      var removeValue = optionAttrs.value;
	
	      self.removeOption(removeValue);
	      scheduleRender();
	
	      if (self.multiple && currentValue && currentValue.indexOf(removeValue) !== -1 ||
	          currentValue === removeValue
	      ) {
	        // When multiple (selected) options are destroyed at the same time, we don't want
	        // to run a model update for each of them. Instead, run a single update in the $$postDigest
	        scheduleViewValueUpdate(true);
	      }
	    });
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name select
	 * @restrict E
	 *
	 * @description
	 * HTML `select` element with angular data-binding.
	 *
	 * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
	 * between the scope and the `<select>` control (including setting default values).
	 * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
	 * {@link ngOptions `ngOptions`} directives.
	 *
	 * When an item in the `<select>` menu is selected, the value of the selected option will be bound
	 * to the model identified by the `ngModel` directive. With static or repeated options, this is
	 * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
	 * Value and textContent can be interpolated.
	 *
	 * ## Matching model and option values
	 *
	 * In general, the match between the model and an option is evaluated by strictly comparing the model
	 * value against the value of the available options.
	 *
	 * If you are setting the option value with the option's `value` attribute, or textContent, the
	 * value will always be a `string` which means that the model value must also be a string.
	 * Otherwise the `select` directive cannot match them correctly.
	 *
	 * To bind the model to a non-string value, you can use one of the following strategies:
	 * - the {@link ng.ngOptions `ngOptions`} directive
	 *   ({@link ng.select#using-select-with-ngoptions-and-setting-a-default-value})
	 * - the {@link ng.ngValue `ngValue`} directive, which allows arbitrary expressions to be
	 *   option values ({@link ng.select#using-ngvalue-to-bind-the-model-to-an-array-of-objects Example})
	 * - model $parsers / $formatters to convert the string value
	 *   ({@link ng.select#binding-select-to-a-non-string-value-via-ngmodel-parsing-formatting Example})
	 *
	 * If the viewValue of `ngModel` does not match any of the options, then the control
	 * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Choosing between `ngRepeat` and `ngOptions`
	 *
	 * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
	 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits:
	 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression
	 * - reduced memory consumption by not creating a new scope for each repeated instance
	 * - increased render speed by creating the options in a documentFragment instead of individually
	 *
	 * Specifically, select with repeated options slows down significantly starting at 2000 options in
	 * Chrome and Internet Explorer / Edge.
	 *
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} multiple Allows multiple options to be selected. The selected values will be
	 *     bound to the model as an array.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds required attribute and required validation constraint to
	 * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
	 * when you want to data-bind to the required attribute.
	 * @param {string=} ngChange Angular expression to be executed when selected option(s) changes due to user
	 *    interaction with the select element.
	 * @param {string=} ngOptions sets the options that the select is populated with and defines what is
	 * set on the model on selection. See {@link ngOptions `ngOptions`}.
	 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
	 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
	 *
	 * @example
	 * ### Simple `select` elements with static options
	 *
	 * <example name="static-select" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="singleSelect"> Single select: </label><br>
	 *     <select name="singleSelect" ng-model="data.singleSelect">
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *
	 *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
	 *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
	 *       <option value="">---Please select---</option> <!-- not selected / blank option -->
	 *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *     <tt>singleSelect = {{data.singleSelect}}</tt>
	 *
	 *     <hr>
	 *     <label for="multipleSelect"> Multiple select: </label><br>
	 *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *       <option value="option-3">Option 3</option>
	 *     </select><br>
	 *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       singleSelect: null,
	 *       multipleSelect: [],
	 *       option1: 'option-1'
	 *      };
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.data.singleSelect = 'nonsense';
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * ### Using `ngRepeat` to generate `select` options
	 * <example name="select-ngrepeat" module="ngrepeatSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="repeatSelect"> Repeat select: </label>
	 *     <select name="repeatSelect" id="repeatSelect" ng-model="data.model">
	 *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <tt>model = {{data.model}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngrepeatSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       model: null,
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ]
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * ### Using `ngValue` to bind the model to an array of objects
	 * <example name="select-ngvalue" module="ngvalueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="ngvalueselect"> ngvalue select: </label>
	 *     <select size="6" name="ngvalueselect" ng-model="data.model" multiple>
	 *       <option ng-repeat="option in data.availableOptions" ng-value="option.value">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <pre>model = {{data.model | json}}</pre><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngvalueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       model: null,
	 *       availableOptions: [
	           {value: 'myString', name: 'string'},
	           {value: 1, name: 'integer'},
	           {value: true, name: 'boolean'},
	           {value: null, name: 'null'},
	           {value: {prop: 'value'}, name: 'object'},
	           {value: ['a'], name: 'array'}
	 *       ]
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * ### Using `select` with `ngOptions` and setting a default value
	 * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
	 *
	 * <example name="select-with-default-values" module="defaultValueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="mySelect">Make a choice:</label>
	 *     <select name="mySelect" id="mySelect"
	 *       ng-options="option.name for option in data.availableOptions track by option.id"
	 *       ng-model="data.selectedOption"></select>
	 *   </form>
	 *   <hr>
	 *   <tt>option = {{data.selectedOption}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('defaultValueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ],
	 *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
	 *       };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 *
	 * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
	 *
	 * <example name="select-with-non-string-options" module="nonStringSelect">
	 *   <file name="index.html">
	 *     <select ng-model="model.id" convert-to-number>
	 *       <option value="0">Zero</option>
	 *       <option value="1">One</option>
	 *       <option value="2">Two</option>
	 *     </select>
	 *     {{ model }}
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('nonStringSelect', [])
	 *       .run(function($rootScope) {
	 *         $rootScope.model = { id: 2 };
	 *       })
	 *       .directive('convertToNumber', function() {
	 *         return {
	 *           require: 'ngModel',
	 *           link: function(scope, element, attrs, ngModel) {
	 *             ngModel.$parsers.push(function(val) {
	 *               return parseInt(val, 10);
	 *             });
	 *             ngModel.$formatters.push(function(val) {
	 *               return '' + val;
	 *             });
	 *           }
	 *         };
	 *       });
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should initialize to model', function() {
	 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
	 *     });
	 *   </file>
	 * </example>
	 *
	 */
	var selectDirective = function() {
	
	  return {
	    restrict: 'E',
	    require: ['select', '?ngModel'],
	    controller: SelectController,
	    priority: 1,
	    link: {
	      pre: selectPreLink,
	      post: selectPostLink
	    }
	  };
	
	  function selectPreLink(scope, element, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	
	      // if ngModel is not defined, we don't need to do anything but set the registerOption
	      // function to noop, so options don't get added internally
	      if (!ngModelCtrl) {
	        selectCtrl.registerOption = noop;
	        return;
	      }
	
	
	      selectCtrl.ngModelCtrl = ngModelCtrl;
	
	      // When the selected item(s) changes we delegate getting the value of the select control
	      // to the `readValue` method, which can be changed if the select can have multiple
	      // selected values or if the options are being generated by `ngOptions`
	      element.on('change', function() {
	        selectCtrl.removeUnknownOption();
	        scope.$apply(function() {
	          ngModelCtrl.$setViewValue(selectCtrl.readValue());
	        });
	      });
	
	      // If the select allows multiple values then we need to modify how we read and write
	      // values from and to the control; also what it means for the value to be empty and
	      // we have to add an extra watch since ngModel doesn't work well with arrays - it
	      // doesn't trigger rendering if only an item in the array changes.
	      if (attr.multiple) {
	        selectCtrl.multiple = true;
	
	        // Read value now needs to check each option to see if it is selected
	        selectCtrl.readValue = function readMultipleValue() {
	          var array = [];
	          forEach(element.find('option'), function(option) {
	            if (option.selected && !option.disabled) {
	              var val = option.value;
	              array.push(val in selectCtrl.selectValueMap ? selectCtrl.selectValueMap[val] : val);
	            }
	          });
	          return array;
	        };
	
	        // Write value now needs to set the selected property of each matching option
	        selectCtrl.writeValue = function writeMultipleValue(value) {
	          forEach(element.find('option'), function(option) {
	            var shouldBeSelected = !!value && (includes(value, option.value) ||
	                                               includes(value, selectCtrl.selectValueMap[option.value]));
	            var currentlySelected = option.selected;
	
	            // IE and Edge, adding options to the selection via shift+click/UP/DOWN,
	            // will de-select already selected options if "selected" on those options was set
	            // more than once (i.e. when the options were already selected)
	            // So we only modify the selected property if neccessary.
	            // Note: this behavior cannot be replicated via unit tests because it only shows in the
	            // actual user interface.
	            if (shouldBeSelected !== currentlySelected) {
	              setOptionSelectedStatus(jqLite(option), shouldBeSelected);
	            }
	
	          });
	        };
	
	        // we have to do it on each watch since ngModel watches reference, but
	        // we need to work of an array, so we need to see if anything was inserted/removed
	        var lastView, lastViewRef = NaN;
	        scope.$watch(function selectMultipleWatch() {
	          if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
	            lastView = shallowCopy(ngModelCtrl.$viewValue);
	            ngModelCtrl.$render();
	          }
	          lastViewRef = ngModelCtrl.$viewValue;
	        });
	
	        // If we are a multiple select then value is now a collection
	        // so the meaning of $isEmpty changes
	        ngModelCtrl.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	
	      }
	    }
	
	    function selectPostLink(scope, element, attrs, ctrls) {
	      // if ngModel is not defined, we don't need to do anything
	      var ngModelCtrl = ctrls[1];
	      if (!ngModelCtrl) return;
	
	      var selectCtrl = ctrls[0];
	
	      // We delegate rendering to the `writeValue` method, which can be changed
	      // if the select can have multiple selected values or if the options are being
	      // generated by `ngOptions`.
	      // This must be done in the postLink fn to prevent $render to be called before
	      // all nodes have been linked correctly.
	      ngModelCtrl.$render = function() {
	        selectCtrl.writeValue(ngModelCtrl.$viewValue);
	      };
	    }
	};
	
	
	// The option directive is purely designed to communicate the existence (or lack of)
	// of dynamically created (and destroyed) option elements to their containing select
	// directive via its controller.
	var optionDirective = ['$interpolate', function($interpolate) {
	  return {
	    restrict: 'E',
	    priority: 100,
	    compile: function(element, attr) {
	      var interpolateValueFn, interpolateTextFn;
	
	      if (isDefined(attr.ngValue)) {
	        // Will be handled by registerOption
	      } else if (isDefined(attr.value)) {
	        // If the value attribute is defined, check if it contains an interpolation
	        interpolateValueFn = $interpolate(attr.value, true);
	      } else {
	        // If the value attribute is not defined then we fall back to the
	        // text content of the option element, which may be interpolated
	        interpolateTextFn = $interpolate(element.text(), true);
	        if (!interpolateTextFn) {
	          attr.$set('value', element.text());
	        }
	      }
	
	      return function(scope, element, attr) {
	        // This is an optimization over using ^^ since we don't want to have to search
	        // all the way to the root of the DOM for every single option element
	        var selectCtrlName = '$selectController',
	            parent = element.parent(),
	            selectCtrl = parent.data(selectCtrlName) ||
	              parent.parent().data(selectCtrlName); // in case we are in optgroup
	
	        if (selectCtrl) {
	          selectCtrl.registerOption(scope, element, attr, interpolateValueFn, interpolateTextFn);
	        }
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngRequired
	 * @restrict A
	 *
	 * @description
	 *
	 * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
	 * applied to custom controls.
	 *
	 * The directive sets the `required` attribute on the element if the Angular expression inside
	 * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
	 * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
	 * for more info.
	 *
	 * The validator will set the `required` error key to true if the `required` attribute is set and
	 * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
	 * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
	 * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
	 * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
	 *
	 * @example
	 * <example name="ngRequiredDirective" module="ngRequiredExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngRequiredExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.required = true;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="required">Toggle required: </label>
	 *         <input type="checkbox" ng-model="required" id="required" />
	 *         <br>
	 *         <label for="input">This input must be filled if `required` is true: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
	 *         <hr>
	 *         required error set? = <code>{{form.input.$error.required}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var required = element(by.binding('form.input.$error.required'));
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should set the required error', function() {
	         expect(required.getText()).toContain('true');
	
	         input.sendKeys('123');
	         expect(required.getText()).not.toContain('true');
	         expect(model.getText()).toContain('123');
	       });
	 *   </file>
	 * </example>
	 */
	var requiredDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	      attr.required = true; // force truthy in case we are on non input element
	
	      ctrl.$validators.required = function(modelValue, viewValue) {
	        return !attr.required || !ctrl.$isEmpty(viewValue);
	      };
	
	      attr.$observe('required', function() {
	        ctrl.$validate();
	      });
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngPattern
	 *
	 * @description
	 *
	 * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * does not match a RegExp which is obtained by evaluating the Angular expression given in the
	 * `ngPattern` attribute value:
	 * * If the expression evaluates to a RegExp object, then this is used directly.
	 * * If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
	 * in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
	 *
	 * <div class="alert alert-info">
	 * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 * start at the index of the last search's match, thus not taking the whole input value into
	 * account.
	 * </div>
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
	 *     not available.
	 *   </li>
	 *   <li>
	 *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngPatternDirective" module="ngPatternExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngPatternExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.regex = '\\d+';
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="regex">Set a pattern (regex string): </label>
	 *         <input type="text" ng-model="regex" id="regex" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current pattern: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default pattern', function() {
	         input.sendKeys('aaa');
	         expect(model.getText()).not.toContain('aaa');
	
	         input.clear().then(function() {
	           input.sendKeys('123');
	           expect(model.getText()).toContain('123');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var patternDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var regexp, patternExp = attr.ngPattern || attr.pattern;
	      attr.$observe('pattern', function(regex) {
	        if (isString(regex) && regex.length > 0) {
	          regex = new RegExp('^' + regex + '$');
	        }
	
	        if (regex && !regex.test) {
	          throw minErr('ngPattern')('noregexp',
	            'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp,
	            regex, startingTag(elm));
	        }
	
	        regexp = regex || undefined;
	        ctrl.$validate();
	      });
	
	      ctrl.$validators.pattern = function(modelValue, viewValue) {
	        // HTML5 pattern constraint validates the input value, so we validate the viewValue
	        return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
	      };
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngMaxlength
	 *
	 * @description
	 *
	 * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is longer than the integer obtained by evaluating the Angular expression given in the
	 * `ngMaxlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMaxlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.maxlength = 5;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="maxlength">Set a maxlength: </label>
	 *         <input type="number" ng-model="maxlength" id="maxlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current maxlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default maxlength', function() {
	         input.sendKeys('abcdef');
	         expect(model.getText()).not.toContain('abcdef');
	
	         input.clear().then(function() {
	           input.sendKeys('abcde');
	           expect(model.getText()).toContain('abcde');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var maxlengthDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var maxlength = -1;
	      attr.$observe('maxlength', function(value) {
	        var intVal = toInt(value);
	        maxlength = isNumberNaN(intVal) ? -1 : intVal;
	        ctrl.$validate();
	      });
	      ctrl.$validators.maxlength = function(modelValue, viewValue) {
	        return (maxlength < 0) || ctrl.$isEmpty(viewValue) || (viewValue.length <= maxlength);
	      };
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngMinlength
	 *
	 * @description
	 *
	 * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is shorter than the integer obtained by evaluating the Angular expression given in the
	 * `ngMinlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMinlength` value must be an expression, while the `minlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMinlengthDirective" module="ngMinlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMinlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.minlength = 3;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="minlength">Set a minlength: </label>
	 *         <input type="number" ng-model="minlength" id="minlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current minlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default minlength', function() {
	         input.sendKeys('ab');
	         expect(model.getText()).not.toContain('ab');
	
	         input.sendKeys('abc');
	         expect(model.getText()).toContain('abc');
	       });
	 *   </file>
	 * </example>
	 */
	var minlengthDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var minlength = 0;
	      attr.$observe('minlength', function(value) {
	        minlength = toInt(value) || 0;
	        ctrl.$validate();
	      });
	      ctrl.$validators.minlength = function(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || viewValue.length >= minlength;
	      };
	    }
	  };
	};
	
	if (window.angular.bootstrap) {
	  // AngularJS is already loaded, so we can return here...
	  if (window.console) {
	    console.log('WARNING: Tried to load angular more than once.');
	  }
	  return;
	}
	
	// try to bind to jquery now so that one can write jqLite(fn)
	// but we will rebind on bootstrap again.
	bindJQuery();
	
	publishExternalAPI(angular);
	
	angular.module("ngLocale", [], ["$provide", function($provide) {
	var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
	function getDecimals(n) {
	  n = n + '';
	  var i = n.indexOf('.');
	  return (i == -1) ? 0 : n.length - i - 1;
	}
	
	function getVF(n, opt_precision) {
	  var v = opt_precision;
	
	  if (undefined === v) {
	    v = Math.min(getDecimals(n), 3);
	  }
	
	  var base = Math.pow(10, v);
	  var f = ((n * base) | 0) % base;
	  return {v: v, f: f};
	}
	
	$provide.value("$locale", {
	  "DATETIME_FORMATS": {
	    "AMPMS": [
	      "AM",
	      "PM"
	    ],
	    "DAY": [
	      "Sunday",
	      "Monday",
	      "Tuesday",
	      "Wednesday",
	      "Thursday",
	      "Friday",
	      "Saturday"
	    ],
	    "ERANAMES": [
	      "Before Christ",
	      "Anno Domini"
	    ],
	    "ERAS": [
	      "BC",
	      "AD"
	    ],
	    "FIRSTDAYOFWEEK": 6,
	    "MONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "SHORTDAY": [
	      "Sun",
	      "Mon",
	      "Tue",
	      "Wed",
	      "Thu",
	      "Fri",
	      "Sat"
	    ],
	    "SHORTMONTH": [
	      "Jan",
	      "Feb",
	      "Mar",
	      "Apr",
	      "May",
	      "Jun",
	      "Jul",
	      "Aug",
	      "Sep",
	      "Oct",
	      "Nov",
	      "Dec"
	    ],
	    "STANDALONEMONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "WEEKENDRANGE": [
	      5,
	      6
	    ],
	    "fullDate": "EEEE, MMMM d, y",
	    "longDate": "MMMM d, y",
	    "medium": "MMM d, y h:mm:ss a",
	    "mediumDate": "MMM d, y",
	    "mediumTime": "h:mm:ss a",
	    "short": "M/d/yy h:mm a",
	    "shortDate": "M/d/yy",
	    "shortTime": "h:mm a"
	  },
	  "NUMBER_FORMATS": {
	    "CURRENCY_SYM": "$",
	    "DECIMAL_SEP": ".",
	    "GROUP_SEP": ",",
	    "PATTERNS": [
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 3,
	        "minFrac": 0,
	        "minInt": 1,
	        "negPre": "-",
	        "negSuf": "",
	        "posPre": "",
	        "posSuf": ""
	      },
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 2,
	        "minFrac": 2,
	        "minInt": 1,
	        "negPre": "-\u00a4",
	        "negSuf": "",
	        "posPre": "\u00a4",
	        "posSuf": ""
	      }
	    ]
	  },
	  "id": "en-us",
	  "localeID": "en_US",
	  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v == 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
	});
	}]);
	
	  jqLite(function() {
	    angularInit(window.document, bootstrap);
	  });
	
	})(window);
	
	!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend('<style type="text/css">@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}</style>');

/***/ }),

/***/ 40:
/***/ (function(module, exports) {

	/**
	 * @license Angulartics
	 * (c) 2013 Luis Farzati http://luisfarzati.github.io/angulartics
	 * License: MIT
	 */
	(function(angular, analytics) {
	'use strict';
	
	var angulartics = window.angulartics || (window.angulartics = {});
	angulartics.waitForVendorCount = 0;
	angulartics.waitForVendorApi = function (objectName, delay, containsField, registerFn, onTimeout) {
	  if (!onTimeout) { angulartics.waitForVendorCount++; }
	  if (!registerFn) { registerFn = containsField; containsField = undefined; }
	  if (!Object.prototype.hasOwnProperty.call(window, objectName) || (containsField !== undefined && window[objectName][containsField] === undefined)) {
	    setTimeout(function () { angulartics.waitForVendorApi(objectName, delay, containsField, registerFn, true); }, delay);
	  }
	  else {
	    angulartics.waitForVendorCount--;
	    registerFn(window[objectName]);
	  }
	};
	
	/**
	 * @ngdoc overview
	 * @name angulartics
	 */
	angular.module('angulartics', [])
	.provider('$analytics', $analytics)
	.run(['$rootScope', '$window', '$analytics', '$injector', $analyticsRun])
	.directive('analyticsOn', ['$analytics', analyticsOn]);
	
	function $analytics() {
	  var settings = {
	    pageTracking: {
	      autoTrackFirstPage: true,
	      autoTrackVirtualPages: true,
	      trackRelativePath: false,
	      autoBasePath: false,
	      basePath: '',
	      excludedRoutes: []
	    },
	    eventTracking: {},
	    bufferFlushDelay: 1000, // Support only one configuration for buffer flush delay to simplify buffering
	    developerMode: false // Prevent sending data in local/development environment
	  };
	
	  // List of known handlers that plugins can register themselves for
	  var knownHandlers = [
	    'pageTrack',
	    'eventTrack',
	    'exceptionTrack',
	    'setAlias',
	    'setUsername',
	    'setUserProperties',
	    'setUserPropertiesOnce',
	    'setSuperProperties',
	    'setSuperPropertiesOnce',
	    'userTimings'
	  ];
	  // Cache and handler properties will match values in 'knownHandlers' as the buffering functons are installed.
	  var cache = {};
	  var handlers = {};
	
	  // General buffering handler
	  function bufferedHandler(handlerName){
	    return function(){
	      if(angulartics.waitForVendorCount){
	        if(!cache[handlerName]){ cache[handlerName] = []; }
	        cache[handlerName].push(arguments);
	      }
	    };
	  }
	
	  // As handlers are installed by plugins, they get pushed into a list and invoked in order.
	  function updateHandlers(handlerName, fn){
	    if(!handlers[handlerName]){
	      handlers[handlerName] = [];
	    }
	    handlers[handlerName].push(fn);
	    return function(){
	      var handlerArgs = arguments;
	      angular.forEach(handlers[handlerName], function(handler){
	        handler.apply(this, handlerArgs);
	      }, this);
	    };
	  }
	
	  // The api (returned by this provider) gets populated with handlers below.
	  var api = {
	    settings: settings
	  };
	
	  // Will run setTimeout if delay is > 0
	  // Runs immediately if no delay to make sure cache/buffer is flushed before anything else.
	  // Plugins should take care to register handlers by order of precedence.
	  function onTimeout(fn, delay){
	    if(delay){
	      setTimeout(fn, delay);
	    } else {
	      fn();
	    }
	  }
	
	  var provider = {
	    $get: function() { return api; },
	    api: api,
	    settings: settings,
	    virtualPageviews: function (value) { this.settings.pageTracking.autoTrackVirtualPages = value; },
	    excludeRoutes: function(routes) { this.settings.pageTracking.excludedRoutes = routes; },
	    firstPageview: function (value) { this.settings.pageTracking.autoTrackFirstPage = value; },
	    withBase: function (value) {
	      this.settings.pageTracking.basePath = (value) ? angular.element(document).find('base').attr('href') : '';
	    },
	    withAutoBase: function (value) { this.settings.pageTracking.autoBasePath = value; },
	    developerMode: function(value) { this.settings.developerMode = value; }
	  };
	
	  // General function to register plugin handlers. Flushes buffers immediately upon registration according to the specified delay.
	  function register(handlerName, fn){
	    api[handlerName] = updateHandlers(handlerName, fn);
	    var handlerSettings = settings[handlerName];
	    var handlerDelay = (handlerSettings) ? handlerSettings.bufferFlushDelay : null;
	    var delay = (handlerDelay !== null) ? handlerDelay : settings.bufferFlushDelay;
	    angular.forEach(cache[handlerName], function (args, index) {
	      onTimeout(function () { fn.apply(this, args); }, index * delay);
	    });
	  }
	
	  function capitalize(input) {
	      return input.replace(/^./, function (match) {
	          return match.toUpperCase();
	      });
	  }
	
	  // Adds to the provider a 'register#{handlerName}' function that manages multiple plugins and buffer flushing.
	  function installHandlerRegisterFunction(handlerName){
	    var registerName = 'register'+capitalize(handlerName);
	    provider[registerName] = function(fn){
	      register(handlerName, fn);
	    };
	    api[handlerName] = updateHandlers(handlerName, bufferedHandler(handlerName));
	  }
	
	  // Set up register functions for each known handler
	  angular.forEach(knownHandlers, installHandlerRegisterFunction);
	  return provider;
	}
	
	function $analyticsRun($rootScope, $window, $analytics, $injector) {
	  function matchesExcludedRoute(url) {
	    for (var i = 0; i < $analytics.settings.pageTracking.excludedRoutes.length; i++) {
	      var excludedRoute = $analytics.settings.pageTracking.excludedRoutes[i];
	      if ((excludedRoute instanceof RegExp && excludedRoute.test(url)) || url.indexOf(excludedRoute) > -1) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  function pageTrack(url, $location) {
	    if (!matchesExcludedRoute(url)) {
	      $analytics.pageTrack(url, $location);
	    }
	  }
	
	  if ($analytics.settings.pageTracking.autoTrackFirstPage) {
	    $injector.invoke(['$location', function ($location) {
	      /* Only track the 'first page' if there are no routes or states on the page */
	      var noRoutesOrStates = true;
	      if ($injector.has('$route')) {
	         var $route = $injector.get('$route');
	         for (var route in $route.routes) {
	           noRoutesOrStates = false;
	           break;
	         }
	      } else if ($injector.has('$state')) {
	        var $state = $injector.get('$state');
	        for (var state in $state.get()) {
	          noRoutesOrStates = false;
	          break;
	        }
	      }
	      if (noRoutesOrStates) {
	        if ($analytics.settings.pageTracking.autoBasePath) {
	          $analytics.settings.pageTracking.basePath = $window.location.pathname;
	        }
	        if ($analytics.settings.pageTracking.trackRelativePath) {
	          var url = $analytics.settings.pageTracking.basePath + $location.url();
	          pageTrack(url, $location);
	        } else {
	          pageTrack($location.absUrl(), $location);
	        }
	      }
	    }]);
	  }
	
	  if ($analytics.settings.pageTracking.autoTrackVirtualPages) {
	    $injector.invoke(['$location', function ($location) {
	      if ($analytics.settings.pageTracking.autoBasePath) {
	        /* Add the full route to the base. */
	        $analytics.settings.pageTracking.basePath = $window.location.pathname + "#";
	      }
	      var noRoutesOrStates = true;
	      if ($injector.has('$route')) {
	        var $route = $injector.get('$route');
	        for (var route in $route.routes) {
	          noRoutesOrStates = false;
	          break;
	        }
	        $rootScope.$on('$routeChangeSuccess', function (event, current) {
	          if (current && (current.$$route||current).redirectTo) return;
	          var url = $analytics.settings.pageTracking.basePath + $location.url();
	          pageTrack(url, $location);
	        });
	      }
	      if ($injector.has('$state')) {
	        noRoutesOrStates = false;
	        $rootScope.$on('$stateChangeSuccess', function (event, current) {
	          var url = $analytics.settings.pageTracking.basePath + $location.url();
	          pageTrack(url, $location);
	        });
	      }
	      if (noRoutesOrStates) {
	        $rootScope.$on('$locationChangeSuccess', function (event, current) {
	          if (current && (current.$$route || current).redirectTo) return;
	          if ($analytics.settings.pageTracking.trackRelativePath) {
	            var url = $analytics.settings.pageTracking.basePath + $location.url();
	            pageTrack(url, $location);
	          } else {
	            pageTrack($location.absUrl(), $location);
	          }
	        });
	      }
	    }]);
	  }
	  if ($analytics.settings.developerMode) {
	    angular.forEach($analytics, function(attr, name) {
	      if (typeof attr === 'function') {
	        $analytics[name] = function(){};
	      }
	    });
	  }
	}
	
	function analyticsOn($analytics) {
	  return {
	    restrict: 'A',
	    link: function ($scope, $element, $attrs) {
	      var eventType = $attrs.analyticsOn || 'click';
	      var trackingData = {};
	
	      angular.forEach($attrs.$attr, function(attr, name) {
	        if (isProperty(name)) {
	          trackingData[propertyName(name)] = $attrs[name];
	          $attrs.$observe(name, function(value){
	            trackingData[propertyName(name)] = value;
	          });
	        }
	      });
	
	      angular.element($element[0]).bind(eventType, function ($event) {
	        var eventName = $attrs.analyticsEvent || inferEventName($element[0]);
	        trackingData.eventType = $event.type;
	
	        if($attrs.analyticsIf){
	          if(! $scope.$eval($attrs.analyticsIf)){
	            return; // Cancel this event if we don't pass the analytics-if condition
	          }
	        }
	        // Allow components to pass through an expression that gets merged on to the event properties
	        // eg. analytics-properites='myComponentScope.someConfigExpression.$analyticsProperties'
	        if($attrs.analyticsProperties){
	          angular.extend(trackingData, $scope.$eval($attrs.analyticsProperties));
	        }
	        $analytics.eventTrack(eventName, trackingData);
	      });
	    }
	  };
	}
	
	function isCommand(element) {
	  return ['a:','button:','button:button','button:submit','input:button','input:submit'].indexOf(
	    element.tagName.toLowerCase()+':'+(element.type||'')) >= 0;
	}
	
	function inferEventType(element) {
	  if (isCommand(element)) return 'click';
	  return 'click';
	}
	
	function inferEventName(element) {
	  if (isCommand(element)) return element.innerText || element.value;
	  return element.id || element.name || element.tagName;
	}
	
	function isProperty(name) {
	  return name.substr(0, 9) === 'analytics' && ['On', 'Event', 'If', 'Properties', 'EventType'].indexOf(name.substr(9)) === -1;
	}
	
	function propertyName(name) {
	  var s = name.slice(9); // slice off the 'analytics' prefix
	  if (typeof s !== 'undefined' && s!==null && s.length > 0) {
	    return s.substring(0, 1).toLowerCase() + s.substring(1);
	  }
	  else {
	    return s;
	  }
	}
	})(angular);


/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(40);
	module.exports = 'angulartics';


/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./de": 14,
		"./de.js": 14,
		"./en-gb": 15,
		"./en-gb.js": 15,
		"./es": 16,
		"./es.js": 16,
		"./fr": 17,
		"./fr.js": 17,
		"./it": 18,
		"./it.js": 18,
		"./ja": 19,
		"./ja.js": 19,
		"./ko": 20,
		"./ko.js": 20,
		"./pt": 21,
		"./pt.js": 21,
		"./ru": 22,
		"./ru.js": 22,
		"./tr": 23,
		"./tr.js": 23,
		"./zh-cn": 24,
		"./zh-cn.js": 24
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 42;


/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/**
	 * @license
	 * lodash 3.10.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern -d -o ./index.js`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '3.10.1';
	
	  /** Used to compose bitmasks for wrapper metadata. */
	  var BIND_FLAG = 1,
	      BIND_KEY_FLAG = 2,
	      CURRY_BOUND_FLAG = 4,
	      CURRY_FLAG = 8,
	      CURRY_RIGHT_FLAG = 16,
	      PARTIAL_FLAG = 32,
	      PARTIAL_RIGHT_FLAG = 64,
	      ARY_FLAG = 128,
	      REARG_FLAG = 256;
	
	  /** Used as default options for `_.trunc`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect when a function becomes hot. */
	  var HOT_COUNT = 150,
	      HOT_SPAN = 16;
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2;
	
	  /** Used as the `TypeError` message for "Functions" methods. */
	  var FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      objectTag = '[object Object]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      weakMapTag = '[object WeakMap]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
	      reUnescapedHtml = /[&<>"'`]/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
	
	  /**
	   * Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns)
	   * and those outlined by [`EscapeRegExpPattern`](http://ecma-international.org/ecma-262/6.0/#sec-escaperegexppattern).
	   */
	  var reRegExpChars = /^[:!,]|[\\^$.*+?()[\]{}|\/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g,
	      reHasRegExpChars = RegExp(reRegExpChars.source);
	
	  /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
	  var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect hexadecimal string values. */
	  var reHasHexPrefix = /^0[xX]/;
	
	  /** Used to detect host constructors (Safari > 5). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^\d+$/;
	
	  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
	  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to match words to create compound words. */
	  var reWords = (function() {
	    var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
	        lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';
	
	    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
	  }());
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'ArrayBuffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Math', 'Number',
	    'Object', 'RegExp', 'Set', 'String', '_', 'clearTimeout', 'isFinite',
	    'parseFloat', 'parseInt', 'setTimeout', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
	  cloneableTags[dateTag] = cloneableTags[float32Tag] =
	  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
	  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[stringTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[mapTag] = cloneableTags[setTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map latin-1 supplementary letters to basic latin letters. */
	  var deburredLetters = {
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;',
	    '`': '&#96;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'",
	    '&#96;': '`'
	  };
	
	  /** Used to determine if values are of the language type `Object`. */
	  var objectTypes = {
	    'function': true,
	    'object': true
	  };
	
	  /** Used to escape characters for inclusion in compiled regexes. */
	  var regexpEscapes = {
	    '0': 'x30', '1': 'x31', '2': 'x32', '3': 'x33', '4': 'x34',
	    '5': 'x35', '6': 'x36', '7': 'x37', '8': 'x38', '9': 'x39',
	    'A': 'x41', 'B': 'x42', 'C': 'x43', 'D': 'x44', 'E': 'x45', 'F': 'x46',
	    'a': 'x61', 'b': 'x62', 'c': 'x63', 'd': 'x64', 'e': 'x65', 'f': 'x66',
	    'n': 'x6e', 'r': 'x72', 't': 'x74', 'u': 'x75', 'v': 'x76', 'x': 'x78'
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Detect free variable `exports`. */
	  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = objectTypes[typeof self] && self && self.Object && self;
	
	  /** Detect free variable `window`. */
	  var freeWindow = objectTypes[typeof window] && window && window.Object && window;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;
	
	  /**
	   * Used as a reference to the global object.
	   *
	   * The `this` value is used if it's the global object to avoid Greasemonkey's
	   * restricted `window` object, otherwise the `window` object is used.
	   */
	  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * The base implementation of `compareAscending` which compares values and
	   * sorts them in ascending order without guaranteeing a stable sort.
	   *
	   * @private
	   * @param {*} value The value to compare.
	   * @param {*} other The other value to compare.
	   * @returns {number} Returns the sort order indicator for `value`.
	   */
	  function baseCompareAscending(value, other) {
	    if (value !== other) {
	      var valIsNull = value === null,
	          valIsUndef = value === undefined,
	          valIsReflexive = value === value;
	
	      var othIsNull = other === null,
	          othIsUndef = other === undefined,
	          othIsReflexive = other === other;
	
	      if ((value > other && !othIsNull) || !valIsReflexive ||
	          (valIsNull && !othIsUndef && othIsReflexive) ||
	          (valIsUndef && othIsReflexive)) {
	        return 1;
	      }
	      if ((value < other && !valIsNull) || !othIsReflexive ||
	          (othIsNull && !valIsUndef && valIsReflexive) ||
	          (othIsUndef && valIsReflexive)) {
	        return -1;
	      }
	    }
	    return 0;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromRight) {
	    var length = array.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without support for binary searches.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    if (value !== value) {
	      return indexOfNaN(array, fromIndex);
	    }
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isFunction` without support for environments
	   * with incorrect `typeof` results.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	   */
	  function baseIsFunction(value) {
	    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
	    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
	    return typeof value == 'function' || false;
	  }
	
	  /**
	   * Converts `value` to a string if it's not one. An empty string is returned
	   * for `null` or `undefined` values.
	   *
	   * @private
	   * @param {*} value The value to process.
	   * @returns {string} Returns the string.
	   */
	  function baseToString(value) {
	    return value == null ? '' : (value + '');
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the first character not found in `chars`.
	   */
	  function charsLeftIndex(string, chars) {
	    var index = -1,
	        length = string.length;
	
	    while (++index < length && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the last character not found in `chars`.
	   */
	  function charsRightIndex(string, chars) {
	    var index = string.length;
	
	    while (index-- && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.sortBy` to compare transformed elements of a collection and stable
	   * sort them in ascending order.
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareAscending(object, other) {
	    return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
	  }
	
	  /**
	   * Used by `_.sortByOrder` to compare multiple properties of a value to another
	   * and stable sort them.
	   *
	   * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
	   * a value is sorted in ascending order if its corresponding order is "asc", and
	   * descending if "desc".
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @param {boolean[]} orders The order to sort by for each property.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareMultiple(object, other, orders) {
	    var index = -1,
	        objCriteria = object.criteria,
	        othCriteria = other.criteria,
	        length = objCriteria.length,
	        ordersLength = orders.length;
	
	    while (++index < length) {
	      var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
	      if (result) {
	        if (index >= ordersLength) {
	          return result;
	        }
	        var order = orders[index];
	        return result * ((order === 'asc' || order === true) ? 1 : -1);
	      }
	    }
	    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	    // that causes it, under certain circumstances, to provide the same value for
	    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	    // for more details.
	    //
	    // This also ensures a stable sort in V8 and other engines.
	    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
	    return object.index - other.index;
	  }
	
	  /**
	   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  function deburrLetter(letter) {
	    return deburredLetters[letter];
	  }
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeHtmlChar(chr) {
	    return htmlEscapes[chr];
	  }
	
	  /**
	   * Used by `_.escapeRegExp` to escape characters for inclusion in compiled regexes.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @param {string} leadingChar The capture group for a leading character.
	   * @param {string} whitespaceChar The capture group for a whitespace character.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeRegExpChar(chr, leadingChar, whitespaceChar) {
	    if (leadingChar) {
	      chr = regexpEscapes[chr];
	    } else if (whitespaceChar) {
	      chr = stringEscapes[chr];
	    }
	    return '\\' + chr;
	  }
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the index at which the first occurrence of `NaN` is found in `array`.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	   */
	  function indexOfNaN(array, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 0 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var other = array[index];
	      if (other !== other) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * Checks if `value` is object-like.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	   */
	  function isObjectLike(value) {
	    return !!value && typeof value == 'object';
	  }
	
	  /**
	   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
	   * character code is whitespace.
	   *
	   * @private
	   * @param {number} charCode The character code to inspect.
	   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
	   */
	  function isSpace(charCode) {
	    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) || charCode == 32 || charCode == 160) || charCode == 5760 || charCode == 6158 ||
	      (charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279)));
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      if (array[index] === placeholder) {
	        array[index] = PLACEHOLDER;
	        result[++resIndex] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * An implementation of `_.uniq` optimized for sorted arrays without support
	   * for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} [iteratee] The function invoked per iteration.
	   * @returns {Array} Returns the new duplicate-value-free array.
	   */
	  function sortedUniq(array, iteratee) {
	    var seen,
	        index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index],
	          computed = iteratee ? iteratee(value, index, array) : value;
	
	      if (!index || seen !== computed) {
	        seen = computed;
	        result[++resIndex] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the first non-whitespace character.
	   */
	  function trimmedLeftIndex(string) {
	    var index = -1,
	        length = string.length;
	
	    while (++index < length && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedRightIndex(string) {
	    var index = string.length;
	
	    while (index-- && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  function unescapeHtmlChar(chr) {
	    return htmlUnescapes[chr];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the given `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @category Utility
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // using `context` to mock `Date#getTime` use in `_.now`
	   * var mock = _.runInContext({
	   *   'Date': function() {
	   *     return { 'getTime': getTimeMock };
	   *   }
	   * });
	   *
	   * // or creating a suped-up `defer` in Node.js
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  function runInContext(context) {
	    // Avoid issues with some ES3 environments that attempt to use values, named
	    // after built-in constructors like `Object`, for the creation of literals.
	    // ES5 clears this up by stating that literals must use built-in constructors.
	    // See https://es5.github.io/#x11.1.5 for more details.
	    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;
	
	    /** Native constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Number = context.Number,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for native method references. */
	    var arrayProto = Array.prototype,
	        objectProto = Object.prototype,
	        stringProto = String.prototype;
	
	    /** Used to resolve the decompiled source of functions. */
	    var fnToString = Function.prototype.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /**
	     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var objToString = objectProto.toString;
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Native method references. */
	    var ArrayBuffer = context.ArrayBuffer,
	        clearTimeout = context.clearTimeout,
	        parseFloat = context.parseFloat,
	        pow = Math.pow,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        Set = getNative(context, 'Set'),
	        setTimeout = context.setTimeout,
	        splice = arrayProto.splice,
	        Uint8Array = context.Uint8Array,
	        WeakMap = getNative(context, 'WeakMap');
	
	    /* Native method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeCreate = getNative(Object, 'create'),
	        nativeFloor = Math.floor,
	        nativeIsArray = getNative(Array, 'isArray'),
	        nativeIsFinite = context.isFinite,
	        nativeKeys = getNative(Object, 'keys'),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = getNative(Date, 'now'),
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random;
	
	    /** Used as references for `-Infinity` and `Infinity`. */
	    var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY,
	        POSITIVE_INFINITY = Number.POSITIVE_INFINITY;
	
	    /** Used as references for the maximum length and index of an array. */
	    var MAX_ARRAY_LENGTH = 4294967295,
	        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	    /**
	     * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	     * of an array-like value.
	     */
	    var MAX_SAFE_INTEGER = 9007199254740991;
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
	     * Methods that operate on and return arrays, collections, and functions can
	     * be chained together. Methods that retrieve a single value or may return a
	     * primitive value will automatically end the chain returning the unwrapped
	     * value. Explicit chaining may be enabled using `_.chain`. The execution of
	     * chained methods is lazy, that is, execution is deferred until `_#value`
	     * is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
	     * fusion is an optimization strategy which merge iteratee calls; this can help
	     * to avoid the creation of intermediate data structures and greatly reduce the
	     * number of iteratee executions.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
	     * `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
	     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
	     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
	     * and `where`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
	     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
	     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
	     * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
	     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
	     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
	     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
	     * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
	     * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
	     * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
	     * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
	     * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
	     * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
	     * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
	     * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
	     * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
	     * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
	     * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
	     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
	     * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
	     * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
	     * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
	     * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
	     * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
	     * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
	     * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
	     * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
	     * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
	     * `unescape`, `uniqueId`, `value`, and `words`
	     *
	     * The wrapper method `sample` will return a wrapped value when `n` is provided,
	     * otherwise an unwrapped value is returned.
	     *
	     * @name _
	     * @constructor
	     * @category Chain
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // returns an unwrapped value
	     * wrapped.reduce(function(total, n) {
	     *   return total + n;
	     * });
	     * // => 6
	     *
	     * // returns a wrapped value
	     * var squares = wrapped.map(function(n) {
	     *   return n * n;
	     * });
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The function whose prototype all chaining wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
	     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
	     */
	    function LodashWrapper(value, chainAll, actions) {
	      this.__wrapped__ = value;
	      this.__actions__ = actions || [];
	      this.__chain__ = !!chainAll;
	    }
	
	    /**
	     * An object environment feature flags.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    var support = lodash.support = {};
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB). Change the following template settings to use
	     * alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type string
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type Object
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type Function
	         */
	        '_': lodash
	      }
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = POSITIVE_INFINITY;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = arrayCopy(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = arrayCopy(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = arrayCopy(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || arrLength < LARGE_ARRAY_SIZE || (arrLength == length && takeCount == length)) {
	        return baseWrapperValue((isRight && isArr) ? array.reverse() : array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a cache object to store key/value pairs.
	     *
	     * @private
	     * @static
	     * @name Cache
	     * @memberOf _.memoize
	     */
	    function MapCache() {
	      this.__data__ = {};
	    }
	
	    /**
	     * Removes `key` and its value from the cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
	     */
	    function mapDelete(key) {
	      return this.has(key) && delete this.__data__[key];
	    }
	
	    /**
	     * Gets the cached value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the cached value.
	     */
	    function mapGet(key) {
	      return key == '__proto__' ? undefined : this.__data__[key];
	    }
	
	    /**
	     * Checks if a cached value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapHas(key) {
	      return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
	    }
	
	    /**
	     * Sets `value` to `key` of the cache.
	     *
	     * @private
	     * @name set
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to cache.
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache object.
	     */
	    function mapSet(key, value) {
	      if (key != '__proto__') {
	        this.__data__[key] = value;
	      }
	      return this;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates a cache object to store unique values.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var length = values ? values.length : 0;
	
	      this.data = { 'hash': nativeCreate(null), 'set': new Set };
	      while (length--) {
	        this.push(values[length]);
	      }
	    }
	
	    /**
	     * Checks if `value` is in `cache` mimicking the return signature of
	     * `_.indexOf` by returning `0` if the value is found, else `-1`.
	     *
	     * @private
	     * @param {Object} cache The cache to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `0` if `value` is found, else `-1`.
	     */
	    function cacheIndexOf(cache, value) {
	      var data = cache.data,
	          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];
	
	      return result ? 0 : -1;
	    }
	
	    /**
	     * Adds `value` to the cache.
	     *
	     * @private
	     * @name push
	     * @memberOf SetCache
	     * @param {*} value The value to cache.
	     */
	    function cachePush(value) {
	      var data = this.data;
	      if (typeof value == 'string' || isObject(value)) {
	        data.set.add(value);
	      } else {
	        data.hash[value] = true;
	      }
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a new array joining `array` with `other`.
	     *
	     * @private
	     * @param {Array} array The array to join.
	     * @param {Array} other The other array to join.
	     * @returns {Array} Returns the new concatenated array.
	     */
	    function arrayConcat(array, other) {
	      var index = -1,
	          length = array.length,
	          othIndex = -1,
	          othLength = other.length,
	          result = Array(length + othLength);
	
	      while (++index < length) {
	        result[index] = array[index];
	      }
	      while (++othIndex < othLength) {
	        result[index++] = other[othIndex];
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayCopy(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.forEach` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEach(array, iteratee) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (iteratee(array[index], index, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.forEachRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEachRight(array, iteratee) {
	      var length = array.length;
	
	      while (length--) {
	        if (iteratee(array[length], length, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.every` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     */
	    function arrayEvery(array, predicate) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (!predicate(array[index], index, array)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * A specialized version of `baseExtremum` for arrays which invokes `iteratee`
	     * with one argument: (value).
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function arrayExtremum(array, iteratee, comparator, exValue) {
	      var index = -1,
	          length = array.length,
	          computed = exValue,
	          result = computed;
	
	      while (++index < length) {
	        var value = array[index],
	            current = +iteratee(value);
	
	        if (comparator(current, computed)) {
	          computed = current;
	          result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.filter` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function arrayFilter(array, predicate) {
	      var index = -1,
	          length = array.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.map` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function arrayMap(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = iteratee(array[index], index, array);
	      }
	      return result;
	    }
	
	    /**
	     * Appends the elements of `values` to `array`.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to append.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayPush(array, values) {
	      var index = -1,
	          length = values.length,
	          offset = array.length;
	
	      while (++index < length) {
	        array[offset + index] = values[index];
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.reduce` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the first element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduce(array, iteratee, accumulator, initFromArray) {
	      var index = -1,
	          length = array.length;
	
	      if (initFromArray && length) {
	        accumulator = array[++index];
	      }
	      while (++index < length) {
	        accumulator = iteratee(accumulator, array[index], index, array);
	      }
	      return accumulator;
	    }
	
	    /**
	     * A specialized version of `_.reduceRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the last element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
	      var length = array.length;
	      if (initFromArray && length) {
	        accumulator = array[--length];
	      }
	      while (length--) {
	        accumulator = iteratee(accumulator, array[length], length, array);
	      }
	      return accumulator;
	    }
	
	    /**
	     * A specialized version of `_.some` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function arraySome(array, predicate) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (predicate(array[index], index, array)) {
	          return true;
	        }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `_.sum` for arrays without support for callback
	     * shorthands and `this` binding..
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function arraySum(array, iteratee) {
	      var length = array.length,
	          result = 0;
	
	      while (length--) {
	        result += +iteratee(array[length]) || 0;
	      }
	      return result;
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assign` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : objectValue;
	    }
	
	    /**
	     * Used by `_.template` to customize its `_.assign` use.
	     *
	     * **Note:** This function is like `assignDefaults` except that it ignores
	     * inherited property values when checking if a property is `undefined`.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @param {string} key The key associated with the object and source values.
	     * @param {Object} object The destination object.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignOwnDefaults(objectValue, sourceValue, key, object) {
	      return (objectValue === undefined || !hasOwnProperty.call(object, key))
	        ? sourceValue
	        : objectValue;
	    }
	
	    /**
	     * A specialized version of `_.assign` for customizing assigned values without
	     * support for argument juggling, multiple sources, and `this` binding `customizer`
	     * functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     */
	    function assignWith(object, source, customizer) {
	      var index = -1,
	          props = keys(source),
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key],
	            result = customizer(value, source[key], key, object, source);
	
	        if ((result === result ? (result !== value) : (value === value)) ||
	            (value === undefined && !(key in object))) {
	          object[key] = result;
	        }
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for argument juggling,
	     * multiple sources, and `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return source == null
	        ? object
	        : baseCopy(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.at` without support for string collections
	     * and individual key arguments.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {number[]|string[]} props The property names or indexes of elements to pick.
	     * @returns {Array} Returns the new array of picked elements.
	     */
	    function baseAt(collection, props) {
	      var index = -1,
	          isNil = collection == null,
	          isArr = !isNil && isArrayLike(collection),
	          length = isArr ? collection.length : 0,
	          propsLength = props.length,
	          result = Array(propsLength);
	
	      while(++index < propsLength) {
	        var key = props[index];
	        if (isArr) {
	          result[index] = isIndex(key, length) ? collection[key] : undefined;
	        } else {
	          result[index] = isNil ? undefined : collection[key];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property names to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @returns {Object} Returns `object`.
	     */
	    function baseCopy(source, props, object) {
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	        object[key] = source[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `_.callback` which supports specifying the
	     * number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function baseCallback(func, thisArg, argCount) {
	      var type = typeof func;
	      if (type == 'function') {
	        return thisArg === undefined
	          ? func
	          : bindCallback(func, thisArg, argCount);
	      }
	      if (func == null) {
	        return identity;
	      }
	      if (type == 'object') {
	        return baseMatches(func);
	      }
	      return thisArg === undefined
	        ? property(func)
	        : baseMatchesProperty(func, thisArg);
	    }
	
	    /**
	     * The base implementation of `_.clone` without support for argument juggling
	     * and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The object `value` belongs to.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates clones with source counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
	      var result;
	      if (customizer) {
	        result = object ? customizer(value, key, object) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return arrayCopy(value, result);
	        }
	      } else {
	        var tag = objToString.call(value),
	            isFunc = tag == funcTag;
	
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = initCloneObject(isFunc ? {} : value);
	          if (!isDeep) {
	            return baseAssign(result, value);
	          }
	        } else {
	          return cloneableTags[tag]
	            ? initCloneByTag(value, tag, isDeep)
	            : (object ? value : {});
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == value) {
	          return stackB[length];
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate it with its clone.
	      stackA.push(value);
	      stackB.push(result);
	
	      // Recursively populate clone (susceptible to call stack limits).
	      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
	        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} prototype The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(prototype) {
	        if (isObject(prototype)) {
	          object.prototype = prototype;
	          var result = new object;
	          object.prototype = undefined;
	        }
	        return result || {};
	      };
	    }());
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts an index
	     * of where to slice the arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Object} args The arguments provide to `func`.
	     * @returns {number} Returns the timer id.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of `_.difference` which accepts a single array
	     * of values to exclude.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values) {
	      var length = array ? array.length : 0,
	          result = [];
	
	      if (!length) {
	        return result;
	      }
	      var index = -1,
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
	          valuesLength = values.length;
	
	      if (cache) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	        values = cache;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index];
	
	        if (isCommon && value === value) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === value) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (indexOf(values, value, 0) < 0) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * Gets the extremum value of `collection` invoking `iteratee` for each value
	     * in `collection` to generate the criterion by which the value is ranked.
	     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(collection, iteratee, comparator, exValue) {
	      var computed = exValue,
	          result = computed;
	
	      baseEach(collection, function(value, index, collection) {
	        var current = +iteratee(value, index, collection);
	        if (comparator(current, computed) || (current === exValue && current === result)) {
	          computed = current;
	          result = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : (end >>> 0);
	      start >>>= 0;
	
	      while (start < length) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
	     * without support for callback shorthands and `this` binding, which iterates
	     * over `collection` using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @param {boolean} [retKey] Specify returning the key of the found element
	     *  instead of the element itself.
	     * @returns {*} Returns the found element or its key, else `undefined`.
	     */
	    function baseFind(collection, predicate, eachFunc, retKey) {
	      var result;
	      eachFunc(collection, function(value, key, collection) {
	        if (predicate(value, key, collection)) {
	          result = retKey ? key : value;
	          return false;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with added support for restricting
	     * flattening and specifying the start index.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, isDeep, isStrict, result) {
	      result || (result = []);
	
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index];
	        if (isObjectLike(value) && isArrayLike(value) &&
	            (isStrict || isArray(value) || isArguments(value))) {
	          if (isDeep) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, isDeep, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForIn` and `baseForOwn` which iterates
	     * over `object` properties returned by `keysFunc` invoking `iteratee` for
	     * each property. Iteratee functions may exit iteration early by explicitly
	     * returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forIn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForIn(object, iteratee) {
	      return baseFor(object, iteratee, keysIn);
	    }
	
	    /**
	     * The base implementation of `_.forOwn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from those provided.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the new array of filtered property names.
	     */
	    function baseFunctions(object, props) {
	      var index = -1,
	          length = props.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var key = props[index];
	        if (isFunction(object[key])) {
	          result[++resIndex] = key;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `get` without support for string paths
	     * and default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path of the property to get.
	     * @param {string} [pathKey] The key representation of path.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path, pathKey) {
	      if (object == null) {
	        return;
	      }
	      if (pathKey !== undefined && pathKey in toObject(object)) {
	        path = [pathKey];
	      }
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[path[index++]];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` without support for `this` binding
	     * `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = arrayTag,
	          othTag = arrayTag;
	
	      if (!objIsArr) {
	        objTag = objToString.call(object);
	        if (objTag == argsTag) {
	          objTag = objectTag;
	        } else if (objTag != objectTag) {
	          objIsArr = isTypedArray(object);
	        }
	      }
	      if (!othIsArr) {
	        othTag = objToString.call(other);
	        if (othTag == argsTag) {
	          othTag = objectTag;
	        } else if (othTag != objectTag) {
	          othIsArr = isTypedArray(other);
	        }
	      }
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && !(objIsArr || objIsObj)) {
	        return equalByTag(object, other, objTag);
	      }
	      if (!isLoose) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      // For more information on detecting circular references see https://es5.github.io/#JO.
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == object) {
	          return stackB[length] == other;
	        }
	      }
	      // Add `object` and `other` to the stack of traversed objects.
	      stackA.push(object);
	      stackB.push(other);
	
	      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
	
	      stackA.pop();
	      stackB.pop();
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} matchData The propery names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = toObject(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var result = customizer ? customizer(objValue, srcValue, key) : undefined;
	          if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which does not clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        var key = matchData[0][0],
	            value = matchData[0][1];
	
	        return function(object) {
	          if (object == null) {
	            return false;
	          }
	          return object[key] === value && (value !== undefined || (key in toObject(object)));
	        };
	      }
	      return function(object) {
	        return baseIsMatch(object, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to compare.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      var isArr = isArray(path),
	          isCommon = isKey(path) && isStrictComparable(srcValue),
	          pathKey = (path + '');
	
	      path = toPath(path);
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        var key = pathKey;
	        object = toObject(object);
	        if ((isArr || !isCommon) && !(key in object)) {
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          if (object == null) {
	            return false;
	          }
	          key = last(path);
	          object = toObject(object);
	        }
	        return object[key] === srcValue
	          ? (srcValue !== undefined || (key in object))
	          : baseIsEqual(srcValue, object[key], undefined, true);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for argument juggling,
	     * multiple sources, and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {Object} Returns `object`.
	     */
	    function baseMerge(object, source, customizer, stackA, stackB) {
	      if (!isObject(object)) {
	        return object;
	      }
	      var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
	          props = isSrcArr ? undefined : keys(source);
	
	      arrayEach(props || source, function(srcValue, key) {
	        if (props) {
	          key = srcValue;
	          srcValue = source[key];
	        }
	        if (isObjectLike(srcValue)) {
	          stackA || (stackA = []);
	          stackB || (stackB = []);
	          baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
	        }
	        else {
	          var value = object[key],
	              result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	              isCommon = result === undefined;
	
	          if (isCommon) {
	            result = srcValue;
	          }
	          if ((result !== undefined || (isSrcArr && !(key in object))) &&
	              (isCommon || (result === result ? (result !== value) : (value === value)))) {
	            object[key] = result;
	          }
	        }
	      });
	      return object;
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
	      var length = stackA.length,
	          srcValue = source[key];
	
	      while (length--) {
	        if (stackA[length] == srcValue) {
	          object[key] = stackB[length];
	          return;
	        }
	      }
	      var value = object[key],
	          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	          isCommon = result === undefined;
	
	      if (isCommon) {
	        result = srcValue;
	        if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
	          result = isArray(value)
	            ? value
	            : (isArrayLike(value) ? arrayCopy(value) : []);
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          result = isArguments(value)
	            ? toPlainObject(value)
	            : (isPlainObject(value) ? value : {});
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate
	      // it with its merged value.
	      stackA.push(srcValue);
	      stackB.push(result);
	
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
	      } else if (result === result ? (result !== value) : (value === value)) {
	        object[key] = result;
	      }
	    }
	
	    /**
	     * The base implementation of `_.property` without support for deep paths.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function baseProperty(key) {
	      return function(object) {
	        return object == null ? undefined : object[key];
	      };
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function basePropertyDeep(path) {
	      var pathKey = (path + '');
	      path = toPath(path);
	      return function(object) {
	        return baseGet(object, path, pathKey);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * index arguments and capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0;
	      while (length--) {
	        var index = indexes[length];
	        if (index != previous && isIndex(index)) {
	          var previous = index;
	          splice.call(array, index, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for argument juggling
	     * and returning floating-point numbers.
	     *
	     * @private
	     * @param {number} min The minimum possible value.
	     * @param {number} max The maximum possible value.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(min, max) {
	      return min + nativeFloor(nativeRandom() * (max - min + 1));
	    }
	
	    /**
	     * The base implementation of `_.reduce` and `_.reduceRight` without support
	     * for callback shorthands and `this` binding, which iterates over `collection`
	     * using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} accumulator The initial value.
	     * @param {boolean} initFromCollection Specify using the first or last element
	     *  of `collection` as the initial value.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @returns {*} Returns the accumulated value.
	     */
	    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
	      eachFunc(collection, function(value, index, collection) {
	        accumulator = initFromCollection
	          ? (initFromCollection = false, value)
	          : iteratee(accumulator, value, index, collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop detection.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortBy` which uses `comparer` to define
	     * the sort order of `array` and replaces criteria objects with their
	     * corresponding values.
	     *
	     * @private
	     * @param {Array} array The array to sort.
	     * @param {Function} comparer The function to define sort order.
	     * @returns {Array} Returns `array`.
	     */
	    function baseSortBy(array, comparer) {
	      var length = array.length;
	
	      array.sort(comparer);
	      while (length--) {
	        array[length] = array[length].value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.sortByOrder` without param guards.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseSortByOrder(collection, iteratees, orders) {
	      var callback = getCallback(),
	          index = -1;
	
	      iteratees = arrayMap(iteratees, function(iteratee) { return callback(iteratee); });
	
	      var result = baseMap(collection, function(value) {
	        var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.sum` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function baseSum(collection, iteratee) {
	      var result = 0;
	      baseEach(collection, function(value, index, collection) {
	        result += +iteratee(value, index, collection) || 0;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.uniq` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The function invoked per iteration.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     */
	    function baseUniq(array, iteratee) {
	      var index = -1,
	          indexOf = getIndexOf(),
	          length = array.length,
	          isCommon = indexOf == baseIndexOf,
	          isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
	          seen = isLarge ? createCache() : null,
	          result = [];
	
	      if (seen) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	      } else {
	        isLarge = false;
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value, index, array) : value;
	
	        if (isCommon && value === value) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (indexOf(seen, computed, 0) < 0) {
	          if (iteratee || isLarge) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.values` and `_.valuesIn` which creates an
	     * array of `object` property values corresponding to the property names
	     * of `props`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} props The property names to get values for.
	     * @returns {Object} Returns the array of property values.
	     */
	    function baseValues(object, props) {
	      var index = -1,
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = object[props[index]];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
	     * and `_.takeWhile` without support for callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to peform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      var index = -1,
	          length = actions.length;
	
	      while (++index < length) {
	        var action = actions[index];
	        result = action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }
	      return result;
	    }
	
	    /**
	     * Performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndex(array, value, retHighest) {
	      var low = 0,
	          high = array ? array.length : low;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return binaryIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * This function is like `binaryIndex` except that it invokes `iteratee` for
	     * `value` and each element of `array` to compute their sort ranking. The
	     * iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array ? array.length : 0,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsUndef = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            isDef = computed !== undefined,
	            isReflexive = computed === computed;
	
	        if (valIsNaN) {
	          var setLow = isReflexive || retHighest;
	        } else if (valIsNull) {
	          setLow = isReflexive && isDef && (retHighest || computed != null);
	        } else if (valIsUndef) {
	          setLow = isReflexive && (retHighest || isDef);
	        } else if (computed == null) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * A specialized version of `baseCallback` which only supports `this` binding
	     * and specifying the number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function bindCallback(func, thisArg, argCount) {
	      if (typeof func != 'function') {
	        return identity;
	      }
	      if (thisArg === undefined) {
	        return func;
	      }
	      switch (argCount) {
	        case 1: return function(value) {
	          return func.call(thisArg, value);
	        };
	        case 3: return function(value, index, collection) {
	          return func.call(thisArg, value, index, collection);
	        };
	        case 4: return function(accumulator, value, index, collection) {
	          return func.call(thisArg, accumulator, value, index, collection);
	        };
	        case 5: return function(value, other, key, object, source) {
	          return func.call(thisArg, value, other, key, object, source);
	        };
	      }
	      return function() {
	        return func.apply(thisArg, arguments);
	      };
	    }
	
	    /**
	     * Creates a clone of the given array buffer.
	     *
	     * @private
	     * @param {ArrayBuffer} buffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function bufferClone(buffer) {
	      var result = new ArrayBuffer(buffer.byteLength),
	          view = new Uint8Array(result);
	
	      view.set(new Uint8Array(buffer));
	      return result;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders) {
	      var holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          leftIndex = -1,
	          leftLength = partials.length,
	          result = Array(leftLength + argsLength);
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        result[holders[argsIndex]] = args[argsIndex];
	      }
	      while (argsLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders) {
	      var holdersIndex = -1,
	          holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          rightIndex = -1,
	          rightLength = partials.length,
	          result = Array(argsLength + rightLength);
	
	      while (++argsIndex < argsLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        result[offset + holders[holdersIndex]] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
	     *
	     * @private
	     * @param {Function} setter The function to set keys and values of the accumulator object.
	     * @param {Function} [initializer] The function to initialize the accumulator object.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee, thisArg) {
	        var result = initializer ? initializer() : {};
	        iteratee = getCallback(iteratee, thisArg, 3);
	
	        if (isArray(collection)) {
	          var index = -1,
	              length = collection.length;
	
	          while (++index < length) {
	            var value = collection[index];
	            setter(result, value, iteratee(value, index, collection), collection);
	          }
	        } else {
	          baseEach(collection, function(value, key, collection) {
	            setter(result, value, iteratee(value, key, collection), collection);
	          });
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return restParam(function(object, sources) {
	        var index = -1,
	            length = object == null ? 0 : sources.length,
	            customizer = length > 2 ? sources[length - 2] : undefined,
	            guard = length > 2 ? sources[2] : undefined,
	            thisArg = length > 1 ? sources[length - 1] : undefined;
	
	        if (typeof customizer == 'function') {
	          customizer = bindCallback(customizer, thisArg, 5);
	          length -= 2;
	        } else {
	          customizer = typeof thisArg == 'function' ? thisArg : undefined;
	          length -= (customizer ? 1 : 0);
	        }
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        var length = collection ? getLength(collection) : 0;
	        if (!isLength(length)) {
	          return eachFunc(collection, iteratee);
	        }
	        var index = fromRight ? length : -1,
	            iterable = toObject(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var iterable = toObject(object),
	            props = keysFunc(object),
	            length = props.length,
	            index = fromRight ? length : -1;
	
	        while ((fromRight ? index-- : ++index < length)) {
	          var key = props[index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with the `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createBindWrapper(func, thisArg) {
	      var Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(thisArg, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `Set` cache object to optimize linear searches of large arrays.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	     */
	    function createCache(values) {
	      return (nativeCreate && Set) ? new SetCache(values) : null;
	    }
	
	    /**
	     * Creates a function that produces compound words out of the words in a
	     * given string.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        var index = -1,
	            array = words(deburr(string)),
	            length = array.length,
	            result = '';
	
	        while (++index < length) {
	          result = callback(result, array[index], index);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtorWrapper(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors.
	        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a `_.curry` or `_.curryRight` function.
	     *
	     * @private
	     * @param {boolean} flag The curry bit flag.
	     * @returns {Function} Returns the new curry function.
	     */
	    function createCurry(flag) {
	      function curryFunc(func, arity, guard) {
	        if (guard && isIterateeCall(func, arity, guard)) {
	          arity = undefined;
	        }
	        var result = createWrapper(func, flag, undefined, undefined, undefined, undefined, undefined, arity);
	        result.placeholder = curryFunc.placeholder;
	        return result;
	      }
	      return curryFunc;
	    }
	
	    /**
	     * Creates a `_.defaults` or `_.defaultsDeep` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Function} Returns the new defaults function.
	     */
	    function createDefaults(assigner, customizer) {
	      return restParam(function(args) {
	        var object = args[0];
	        if (object == null) {
	          return object;
	        }
	        args.push(customizer);
	        return assigner.apply(undefined, args);
	      });
	    }
	
	    /**
	     * Creates a `_.max` or `_.min` function.
	     *
	     * @private
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {Function} Returns the new extremum function.
	     */
	    function createExtremum(comparator, exValue) {
	      return function(collection, iteratee, thisArg) {
	        if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	          iteratee = undefined;
	        }
	        iteratee = getCallback(iteratee, thisArg, 3);
	        if (iteratee.length == 1) {
	          collection = isArray(collection) ? collection : toIterable(collection);
	          var result = arrayExtremum(collection, iteratee, comparator, exValue);
	          if (!(collection.length && result === exValue)) {
	            return result;
	          }
	        }
	        return baseExtremum(collection, iteratee, comparator, exValue);
	      };
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(eachFunc, fromRight) {
	      return function(collection, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        if (isArray(collection)) {
	          var index = baseFindIndex(collection, predicate, fromRight);
	          return index > -1 ? collection[index] : undefined;
	        }
	        return baseFind(collection, predicate, eachFunc);
	      };
	    }
	
	    /**
	     * Creates a `_.findIndex` or `_.findLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindIndex(fromRight) {
	      return function(array, predicate, thisArg) {
	        if (!(array && array.length)) {
	          return -1;
	        }
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFindIndex(array, predicate, fromRight);
	      };
	    }
	
	    /**
	     * Creates a `_.findKey` or `_.findLastKey` function.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindKey(objectFunc) {
	      return function(object, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFind(object, predicate, objectFunc, true);
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return function() {
	        var wrapper,
	            length = arguments.length,
	            index = fromRight ? length : -1,
	            leftIndex = 0,
	            funcs = Array(length);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          var func = funcs[leftIndex++] = arguments[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
	            wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? -1 : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      };
	    }
	
	    /**
	     * Creates a function for `_.forEach` or `_.forEachRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForEach(arrayFunc, eachFunc) {
	      return function(collection, iteratee, thisArg) {
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee)
	          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
	      };
	    }
	
	    /**
	     * Creates a function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForIn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee, keysIn);
	      };
	    }
	
	    /**
	     * Creates a function for `_.forOwn` or `_.forOwnRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForOwn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee);
	      };
	    }
	
	    /**
	     * Creates a function for `_.mapKeys` or `_.mapValues`.
	     *
	     * @private
	     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
	     * @returns {Function} Returns the new map function.
	     */
	    function createObjectMapper(isMapKeys) {
	      return function(object, iteratee, thisArg) {
	        var result = {};
	        iteratee = getCallback(iteratee, thisArg, 3);
	
	        baseForOwn(object, function(value, key, object) {
	          var mapped = iteratee(value, key, object);
	          key = isMapKeys ? mapped : key;
	          value = isMapKeys ? value : mapped;
	          result[key] = value;
	        });
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function for `_.padLeft` or `_.padRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify padding from the right.
	     * @returns {Function} Returns the new pad function.
	     */
	    function createPadDir(fromRight) {
	      return function(string, length, chars) {
	        string = baseToString(string);
	        return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
	      };
	    }
	
	    /**
	     * Creates a `_.partial` or `_.partialRight` function.
	     *
	     * @private
	     * @param {boolean} flag The partial bit flag.
	     * @returns {Function} Returns the new partial function.
	     */
	    function createPartial(flag) {
	      var partialFunc = restParam(function(func, partials) {
	        var holders = replaceHolders(partials, partialFunc.placeholder);
	        return createWrapper(func, flag, undefined, partials, holders);
	      });
	      return partialFunc;
	    }
	
	    /**
	     * Creates a function for `_.reduce` or `_.reduceRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createReduce(arrayFunc, eachFunc) {
	      return function(collection, iteratee, accumulator, thisArg) {
	        var initFromArray = arguments.length < 3;
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
	          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with optional `this`
	     * binding of, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & ARY_FLAG,
	          isBind = bitmask & BIND_FLAG,
	          isBindKey = bitmask & BIND_KEY_FLAG,
	          isCurry = bitmask & CURRY_FLAG,
	          isCurryBound = bitmask & CURRY_BOUND_FLAG,
	          isCurryRight = bitmask & CURRY_RIGHT_FLAG,
	          Ctor = isBindKey ? undefined : createCtorWrapper(func);
	
	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it to other functions.
	        var length = arguments.length,
	            index = length,
	            args = Array(length);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight);
	        }
	        if (isCurry || isCurryRight) {
	          var placeholder = wrapper.placeholder,
	              argsHolders = replaceHolders(args, placeholder);
	
	          length -= argsHolders.length;
	          if (length < arity) {
	            var newArgPos = argPos ? arrayCopy(argPos) : undefined,
	                newArity = nativeMax(arity - length, 0),
	                newsHolders = isCurry ? argsHolders : undefined,
	                newHoldersRight = isCurry ? undefined : argsHolders,
	                newPartials = isCurry ? args : undefined,
	                newPartialsRight = isCurry ? undefined : args;
	
	            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	            if (!isCurryBound) {
	              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	            }
	            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
	                result = createHybridWrapper.apply(undefined, newData);
	
	            if (isLaziable(func)) {
	              setData(result, newData);
	            }
	            result.placeholder = placeholder;
	            return result;
	          }
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        if (argPos) {
	          args = reorder(args, argPos);
	        }
	        if (isAry && ary < args.length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtorWrapper(func);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates the padding required for `string` based on the given `length`.
	     * The `chars` string is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {string} string The string to create padding for.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the pad for `string`.
	     */
	    function createPadding(string, length, chars) {
	      var strLength = string.length;
	      length = +length;
	
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return '';
	      }
	      var padLength = length - strLength;
	      chars = chars == null ? ' ' : (chars + '');
	      return repeat(chars, nativeCeil(padLength / chars.length)).slice(0, padLength);
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with the optional `this`
	     * binding of `thisArg` and the `partials` prepended to those provided to
	     * the wrapper.
	     *
	     * @private
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to the new function.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createPartialWrapper(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it `func`.
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength);
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.ceil`, `_.floor`, or `_.round` function.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        precision = precision === undefined ? 0 : (+precision || 0);
	        if (precision) {
	          precision = pow(10, precision);
	          return func(number * precision) / precision;
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {Function} Returns the new index function.
	     */
	    function createSortedIndex(retHighest) {
	      return function(array, value, iteratee, thisArg) {
	        var callback = getCallback(iteratee);
	        return (iteratee == null && callback === baseCallback)
	          ? binaryIndex(array, value, retHighest)
	          : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - `_.bind`
	     *     2 - `_.bindKey`
	     *     4 - `_.curry` or `_.curryRight` of a bound function
	     *     8 - `_.curry`
	     *    16 - `_.curryRight`
	     *    32 - `_.partial`
	     *    64 - `_.partialRight`
	     *   128 - `_.rearg`
	     *   256 - `_.ary`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      length -= (holders ? holders.length : 0);
	      if (bitmask & PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func),
	          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];
	
	      if (data) {
	        mergeData(newData, data);
	        bitmask = newData[1];
	        arity = newData[9];
	      }
	      newData[9] = arity == null
	        ? (isBindKey ? 0 : func.length)
	        : (nativeMax(arity - length, 0) || 0);
	
	      if (bitmask == BIND_FLAG) {
	        var result = createBindWrapper(newData[0], newData[2]);
	      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
	        result = createPartialWrapper.apply(undefined, newData);
	      } else {
	        result = createHybridWrapper.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setter(result, newData);
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing arrays.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var index = -1,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
	        return false;
	      }
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index],
	            result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
	
	        if (result !== undefined) {
	          if (result) {
	            continue;
	          }
	          return false;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (isLoose) {
	          if (!arraySome(other, function(othValue) {
	                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
	              })) {
	            return false;
	          }
	        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag) {
	      switch (tag) {
	        case boolTag:
	        case dateTag:
	          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	          return +object == +other;
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case numberTag:
	          // Treat `NaN` vs. `NaN` as equal.
	          return (object != +object)
	            ? other != +other
	            : object == +other;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings primitives and string
	          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	          return object == (other + '');
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objProps = keys(object),
	          objLength = objProps.length,
	          othProps = keys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isLoose) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      var skipCtor = isLoose;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key],
	            result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;
	
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
	          return false;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (!skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Gets the appropriate "callback" function. If the `_.callback` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseCallback` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getCallback(func, thisArg, argCount) {
	      var result = lodash.callback || callback;
	      result = result === callback ? baseCallback : result;
	      return argCount ? result(func, thisArg, argCount) : result;
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = func.name,
	          array = realNames[result],
	          length = array ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseIndexOf` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function|number} Returns the chosen function or its result.
	     */
	    function getIndexOf(collection, target, fromIndex) {
	      var result = lodash.indexOf || indexOf;
	      result = result === indexOf ? baseIndexOf : result;
	      return collection ? result(collection, target, fromIndex) : result;
	    }
	
	    /**
	     * Gets the "length" property value of `object`.
	     *
	     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	     * that affects Safari on at least iOS 8.1-8.3 ARM64.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {*} Returns the "length" value.
	     */
	    var getLength = baseProperty('length');
	
	    /**
	     * Gets the propery names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = pairs(object),
	          length = result.length;
	
	      while (length--) {
	        result[length][2] = isStrictComparable(result[length][1]);
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = object == null ? undefined : object[key];
	      return isNative(value) ? value : undefined;
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add array properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      var Ctor = object.constructor;
	      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
	        Ctor = Object;
	      }
	      return new Ctor;
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return bufferClone(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          var buffer = object.buffer;
	          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          var result = new Ctor(object.source, reFlags.exec(object));
	          result.lastIndex = object.lastIndex;
	      }
	      return result;
	    }
	
	    /**
	     * Invokes the method at `path` on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function invokePath(object, path, args) {
	      if (object != null && !isKey(path, object)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        path = last(path);
	      }
	      var func = object == null ? object : object[path];
	      return func == null ? undefined : func.apply(object, args);
	    }
	
	    /**
	     * Checks if `value` is array-like.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(getLength(value));
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return value > -1 && value % 1 == 0 && value < length;
	    }
	
	    /**
	     * Checks if the provided arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	          ? (isArrayLike(object) && isIndex(index, object.length))
	          : (type == 'string' && index in object)) {
	        var other = object[index];
	        return value === value ? (value === other) : (other !== other);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      var type = typeof value;
	      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
	        return true;
	      }
	      if (isArray(value)) {
	        return false;
	      }
	      var result = !reIsDeepProp.test(value);
	      return result || (object != null && value in toObject(object));
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func);
	      if (!(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      var other = lodash[funcName];
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     */
	    function isLength(value) {
	      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers required to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
	     * augment function arguments, making the order in which they are executed important,
	     * preventing the merging of metadata. However, we make an exception for a safe
	     * common case where curried functions have `_.ary` and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < ARY_FLAG;
	
	      var isCombo =
	        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
	        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
	        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = arrayCopy(value);
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function mergeDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : merge(objectValue, sourceValue, mergeDefaults);
	    }
	
	    /**
	     * A specialized version of `_.pick` which picks `object` properties specified
	     * by `props`.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property names to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByArray(object, props) {
	      object = toObject(object);
	
	      var index = -1,
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index];
	        if (key in object) {
	          result[key] = object[key];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.pick` which picks `object` properties `predicate`
	     * returns truthy for.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByCallback(object, predicate) {
	      var result = {};
	      baseForIn(object, function(value, key, object) {
	        if (predicate(value, key, object)) {
	          result[key] = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = arrayCopy(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity function
	     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = (function() {
	      var count = 0,
	          lastCalled = 0;
	
	      return function(key, value) {
	        var stamp = now(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return key;
	          }
	        } else {
	          count = 0;
	        }
	        return baseSetData(key, value);
	      };
	    }());
	
	    /**
	     * A fallback implementation of `Object.keys` which creates an array of the
	     * own enumerable property names of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function shimKeys(object) {
	      var props = keysIn(object),
	          propsLength = props.length,
	          length = propsLength && object.length;
	
	      var allowIndexes = !!length && isLength(length) &&
	        (isArray(object) || isArguments(object));
	
	      var index = -1,
	          result = [];
	
	      while (++index < propsLength) {
	        var key = props[index];
	        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to an array-like object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array|Object} Returns the array-like object.
	     */
	    function toIterable(value) {
	      if (value == null) {
	        return [];
	      }
	      if (!isArrayLike(value)) {
	        return values(value);
	      }
	      return isObject(value) ? value : Object(value);
	    }
	
	    /**
	     * Converts `value` to an object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Object} Returns the object.
	     */
	    function toObject(value) {
	      return isObject(value) ? value : Object(value);
	    }
	
	    /**
	     * Converts `value` to property path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array} Returns the property path array.
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return value;
	      }
	      var result = [];
	      baseToString(value).replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      return wrapper instanceof LazyWrapper
	        ? wrapper.clone()
	        : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `collection` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new array containing chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if (guard ? isIterateeCall(array, size, guard) : size == null) {
	        size = 1;
	      } else {
	        size = nativeMax(nativeFloor(size) || 1, 1);
	      }
	      var index = 0,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[++resIndex] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of unique `array` values not included in the other
	     * provided arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The arrays of values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.difference([1, 2, 3], [4, 2]);
	     * // => [1, 3]
	     */
	    var difference = restParam(function(array, values) {
	      return (isObjectLike(array) && isArrayLike(array))
	        ? baseDifference(array, baseFlatten(values, false, true))
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that match the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [1]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active', false), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8], '*', 1, 2);
	     * // => [4, '*', 8]
	     */
	    function fill(array, value, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(chr) {
	     *   return chr.user == 'barney';
	     * });
	     * // => 0
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findIndex(users, 'active', false);
	     * // => 0
	     *
	     * // using the `_.property` callback shorthand
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    var findIndex = createFindIndex();
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(chr) {
	     *   return chr.user == 'pebbles';
	     * });
	     * // => 2
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastIndex(users, 'active', false);
	     * // => 2
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    var findLastIndex = createFindIndex(true);
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias head
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.first([1, 2, 3]);
	     * // => 1
	     *
	     * _.first([]);
	     * // => undefined
	     */
	    function first(array) {
	      return array ? array[0] : undefined;
	    }
	
	    /**
	     * Flattens a nested array. If `isDeep` is `true` the array is recursively
	     * flattened, otherwise it is only flattened a single level.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, [4]]
	     *
	     * // using `isDeep`
	     * _.flatten([1, [2, 3, [4]]], true);
	     * // => [1, 2, 3, 4]
	     */
	    function flatten(array, isDeep, guard) {
	      var length = array ? array.length : 0;
	      if (guard && isIterateeCall(array, isDeep, guard)) {
	        isDeep = false;
	      }
	      return length ? baseFlatten(array, isDeep) : [];
	    }
	
	    /**
	     * Recursively flattens a nested array.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to recursively flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, 4]
	     */
	    function flattenDeep(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, true) : [];
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
	     * performs a faster binary search.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
	     *  to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // using `fromIndex`
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     *
	     * // performing a binary search
	     * _.indexOf([1, 1, 2, 2], 2, true);
	     * // => 2
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      if (typeof fromIndex == 'number') {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
	      } else if (fromIndex) {
	        var index = binaryIndex(array, value);
	        if (index < length &&
	            (value === value ? (value === array[index]) : (array[index] !== array[index]))) {
	          return index;
	        }
	        return -1;
	      }
	      return baseIndexOf(array, value, fromIndex || 0);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      return dropRight(array, 1);
	    }
	
	    /**
	     * Creates an array of unique values that are included in all of the provided
	     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of shared values.
	     * @example
	     * _.intersection([1, 2], [4, 2], [2, 1]);
	     * // => [2]
	     */
	    var intersection = restParam(function(arrays) {
	      var othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(length),
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          result = [];
	
	      while (othIndex--) {
	        var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
	        caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
	      }
	      var array = arrays[0],
	          index = -1,
	          length = array ? array.length : 0,
	          seen = caches[0];
	
	      outer:
	      while (++index < length) {
	        value = array[index];
	        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
	          var othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(value);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    });
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array ? array.length : 0;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
	     *  or `true` to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // using `fromIndex`
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     *
	     * // performing a binary search
	     * _.lastIndexOf([1, 1, 2, 2], 2, true);
	     * // => 3
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (typeof fromIndex == 'number') {
	        index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
	      } else if (fromIndex) {
	        index = binaryIndex(array, value, true) - 1;
	        var other = array[index];
	        if (value === value ? (value === other) : (other !== other)) {
	          return index;
	        }
	        return -1;
	      }
	      if (value !== value) {
	        return indexOfNaN(array, index, true);
	      }
	      while (index--) {
	        if (array[index] === value) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Removes all provided values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3, 1, 2, 3];
	     *
	     * _.pull(array, 2, 3);
	     * console.log(array);
	     * // => [1, 1]
	     */
	    function pull() {
	      var args = arguments,
	          array = args[0];
	
	      if (!(array && array.length)) {
	        return array;
	      }
	      var index = 0,
	          indexOf = getIndexOf(),
	          length = args.length;
	
	      while (++index < length) {
	        var fromIndex = 0,
	            value = args[index];
	
	        while ((fromIndex = indexOf(array, value, fromIndex)) > -1) {
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to the given indexes and returns
	     * an array of the removed elements. Indexes may be specified as an array of
	     * indexes or as individual arguments.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [5, 10, 15, 20];
	     * var evens = _.pullAt(array, 1, 3);
	     *
	     * console.log(array);
	     * // => [5, 15]
	     *
	     * console.log(evens);
	     * // => [10, 20]
	     */
	    var pullAt = restParam(function(array, indexes) {
	      indexes = baseFlatten(indexes);
	
	      var result = baseAt(array, indexes);
	      basePullAt(array, indexes.sort(baseCompareAscending));
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate, thisArg) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getCallback(predicate, thisArg, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias tail
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.rest([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function rest(array) {
	      return drop(array, 1);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of `Array#slice` to support node
	     * lists in IE < 9 and to ensure dense arrays are returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value` should
	     * be inserted into `array` in order to maintain its sort order. If an iteratee
	     * function is provided it is invoked for `value` and each element of `array`
	     * to compute their sort ranking. The iteratee is bound to `thisArg` and
	     * invoked with one argument; (value).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     *
	     * _.sortedIndex([4, 4, 5, 5], 5);
	     * // => 2
	     *
	     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
	     *
	     * // using an iteratee function
	     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
	     *   return this.data[word];
	     * }, dict);
	     * // => 1
	     *
	     * // using the `_.property` callback shorthand
	     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
	     * // => 1
	     */
	    var sortedIndex = createSortedIndex();
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 4, 5, 5], 5);
	     * // => 4
	     */
	    var sortedLastIndex = createSortedIndex(true);
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
	     * and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [2, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [1, 2]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false},
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active', false), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all of the provided arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([1, 2], [4, 2], [2, 1]);
	     * // => [1, 2, 4]
	     */
	    var union = restParam(function(arrays) {
	      return baseUniq(baseFlatten(arrays, false, true));
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurence of each element
	     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
	     * for sorted arrays. If an iteratee function is provided it is invoked for
	     * each element in the array to generate the criterion by which uniqueness
	     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, array).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias unique
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {boolean} [isSorted] Specify the array is sorted.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     *
	     * // using `isSorted`
	     * _.uniq([1, 1, 2], true);
	     * // => [1, 2]
	     *
	     * // using an iteratee function
	     * _.uniq([1, 2.5, 1.5, 2], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => [1, 2.5]
	     *
	     * // using the `_.property` callback shorthand
	     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniq(array, isSorted, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (isSorted != null && typeof isSorted != 'boolean') {
	        thisArg = iteratee;
	        iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
	        isSorted = false;
	      }
	      var callback = getCallback();
	      if (!(iteratee == null && callback === baseCallback)) {
	        iteratee = callback(iteratee, thisArg, 3);
	      }
	      return (isSorted && getIndexOf() == baseIndexOf)
	        ? sortedUniq(array, iteratee)
	        : baseUniq(array, iteratee);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['fred', 'barney'], [30, 40], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var index = -1,
	          length = 0;
	
	      array = arrayFilter(array, function(group) {
	        if (isArrayLike(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = arrayMap(array, baseProperty(index));
	      }
	      return result;
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts an iteratee to specify
	     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee] The function to combine regrouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      iteratee = bindCallback(iteratee, thisArg, 4);
	      return arrayMap(result, function(group) {
	        return arrayReduce(group, iteratee, undefined, true);
	      });
	    }
	
	    /**
	     * Creates an array excluding all provided values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to filter.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.without([1, 2, 1, 3], 1, 2);
	     * // => [3]
	     */
	    var without = restParam(function(array, values) {
	      return isArrayLike(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the provided arrays.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of values.
	     * @example
	     *
	     * _.xor([1, 2], [4, 2]);
	     * // => [1, 4]
	     */
	    function xor() {
	      var index = -1,
	          length = arguments.length;
	
	      while (++index < length) {
	        var array = arguments[index];
	        if (isArrayLike(array)) {
	          var result = result
	            ? arrayPush(baseDifference(result, array), baseDifference(array, result))
	            : array;
	        }
	      }
	      return result ? baseUniq(result) : [];
	    }
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the first
	     * elements of the given arrays, the second of which contains the second elements
	     * of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     */
	    var zip = restParam(unzip);
	
	    /**
	     * The inverse of `_.pairs`; this method returns an object composed from arrays
	     * of property names and values. Provide either a single two dimensional array,
	     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
	     * and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @alias object
	     * @category Array
	     * @param {Array} props The property names.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject([['fred', 30], ['barney', 40]]);
	     * // => { 'fred': 30, 'barney': 40 }
	     *
	     * _.zipObject(['fred', 'barney'], [30, 40]);
	     * // => { 'fred': 30, 'barney': 40 }
	     */
	    function zipObject(props, values) {
	      var index = -1,
	          length = props ? props.length : 0,
	          result = {};
	
	      if (length && !values && !isArray(props[0])) {
	        values = [];
	      }
	      while (++index < length) {
	        var key = props[index];
	        if (values) {
	          result[key] = values[index];
	        } else if (key) {
	          result[key[0]] = key[1];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an iteratee to specify
	     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee] The function to combine grouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
	     * // => [111, 222]
	     */
	    var zipWith = restParam(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 2 ? arrays[length - 2] : undefined,
	          thisArg = length > 1 ? arrays[length - 1] : undefined;
	
	      if (length > 2 && typeof iteratee == 'function') {
	        length -= 2;
	      } else {
	        iteratee = (length > 1 && typeof thisArg == 'function') ? (--length, thisArg) : undefined;
	        thisArg = undefined;
	      }
	      arrays.length = length;
	      return unzipWith(arrays, iteratee, thisArg);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object that wraps `value` with explicit method
	     * chaining enabled.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _.chain(users)
	     *   .sortBy('age')
	     *   .map(function(chr) {
	     *     return chr.user + ' is ' + chr.age;
	     *   })
	     *   .first()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor is
	     * bound to `thisArg` and invoked with one argument; (value). The purpose of
	     * this method is to "tap into" a method chain in order to perform operations
	     * on intermediate results within the chain.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor, thisArg) {
	      interceptor.call(thisArg, value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor, thisArg) {
	      return interceptor.call(thisArg, value);
	    }
	
	    /**
	     * Enables explicit method chaining on the wrapper object.
	     *
	     * @name chain
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // without explicit chaining
	     * _(users).first();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // with explicit chaining
	     * _(users).chain()
	     *   .first()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chained sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Creates a new array joining a wrapped array with any additional arrays
	     * and/or values.
	     *
	     * @name concat
	     * @memberOf _
	     * @category Chain
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var wrapped = _(array).concat(2, [3], [[4]]);
	     *
	     * console.log(wrapped.value());
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    var wrapperConcat = restParam(function(values) {
	      values = baseFlatten(values);
	      return this.thru(function(array) {
	        return arrayConcat(isArray(array) ? array : [toObject(array)], values);
	      });
	    });
	
	    /**
	     * Creates a clone of the chained sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).map(function(value) {
	     *   return Math.pow(value, 2);
	     * });
	     *
	     * var other = [3, 4];
	     * var otherWrapped = wrapped.plant(other);
	     *
	     * otherWrapped.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * Reverses the wrapped array so the first element becomes the last, the
	     * second element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	
	      var interceptor = function(value) {
	        return (wrapped && wrapped.__dir__ < 0) ? value : value.reverse();
	      };
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(interceptor);
	    }
	
	    /**
	     * Produces the result of coercing the unwrapped value to a string.
	     *
	     * @name toString
	     * @memberOf _
	     * @category Chain
	     * @returns {string} Returns the coerced string value.
	     * @example
	     *
	     * _([1, 2, 3]).toString();
	     * // => '1,2,3'
	     */
	    function wrapperToString() {
	      return (this.value() + '');
	    }
	
	    /**
	     * Executes the chained sequence to extract the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @alias run, toJSON, valueOf
	     * @category Chain
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements corresponding to the given keys, or indexes,
	     * of `collection`. Keys may be specified as individual arguments or as arrays
	     * of keys.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(number|number[]|string|string[])} [props] The property names
	     *  or indexes of elements to pick, specified individually or in arrays.
	     * @returns {Array} Returns the new array of picked elements.
	     * @example
	     *
	     * _.at(['a', 'b', 'c'], [0, 2]);
	     * // => ['a', 'c']
	     *
	     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
	     * // => ['barney', 'pebbles']
	     */
	    var at = restParam(function(collection, props) {
	      return baseAt(collection, baseFlatten(props));
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the number of times the key was returned by `iteratee`.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * The predicate is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias all
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': false },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.every(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias select
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.filter([4, 5, 6], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 6]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.filter(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.filter(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function filter(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, predicate);
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias detect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.result(_.find(users, function(chr) {
	     *   return chr.age < 40;
	     * }), 'user');
	     * // => 'barney'
	     *
	     * // using the `_.matches` callback shorthand
	     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.result(_.find(users, 'active', false), 'user');
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.result(_.find(users, 'active'), 'user');
	     * // => 'barney'
	     */
	    var find = createFind(baseEach);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(baseEachRight, true);
	
	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning the first element that has equivalent property
	     * values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
	     * // => 'barney'
	     *
	     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
	     * // => 'fred'
	     */
	    function findWhere(collection, source) {
	      return find(collection, baseMatches(source));
	    }
	
	    /**
	     * Iterates over elements of `collection` invoking `iteratee` for each element.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection). Iteratee functions may exit iteration early
	     * by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length" property
	     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
	     * may be used for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @alias each
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEach(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from left to right and returns the array
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
	     *   console.log(n, key);
	     * });
	     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
	     */
	    var forEach = createForEach(arrayEach, baseEach);
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEachRight(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from right to left and returns the array
	     */
	    var forEachRight = createForEach(arrayEachRight, baseEachRight);
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is an array of the elements responsible for generating the key.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * // using the `_.property` callback shorthand
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        result[key] = [value];
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @alias contains, include
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {*} target The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
	     * // => true
	     *
	     * _.includes('pebbles', 'eb');
	     * // => true
	     */
	    function includes(collection, target, fromIndex, guard) {
	      var length = collection ? getLength(collection) : 0;
	      if (!isLength(length)) {
	        collection = values(collection);
	        length = collection.length;
	      }
	      if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
	        fromIndex = 0;
	      } else {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
	      }
	      return (typeof collection == 'string' || !isArray(collection) && isString(collection))
	        ? (fromIndex <= length && collection.indexOf(target, fromIndex) > -1)
	        : (!!length && getIndexOf(collection, target, fromIndex) > -1);
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the last element responsible for generating the key. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var keyData = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.indexBy(keyData, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return String.fromCharCode(object.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return this.fromCharCode(object.code);
	     * }, String);
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     */
	    var indexBy = createAggregator(function(result, value, key) {
	      result[key] = value;
	    });
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `methodName` is a function it is
	     * invoked for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invoke([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invoke = restParam(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          isProp = isKey(path),
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
	        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` through
	     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
	     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
	     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
	     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
	     * `sum`, `uniq`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @alias collect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function timesThree(n) {
	     *   return n * 3;
	     * }
	     *
	     * _.map([1, 2], timesThree);
	     * // => [3, 6]
	     *
	     * _.map({ 'a': 1, 'b': 2 }, timesThree);
	     * // => [3, 6] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee, thisArg) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return func(collection, iteratee);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, while the second of which
	     * contains elements `predicate` returns falsey for. The predicate is bound
	     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * _.partition([1, 2, 3], function(n) {
	     *   return n % 2;
	     * });
	     * // => [[1, 3], [2]]
	     *
	     * _.partition([1.2, 2.3, 3.4], function(n) {
	     *   return this.floor(n) % 2;
	     * }, Math);
	     * // => [[1.2, 3.4], [2.3]]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * var mapper = function(array) {
	     *   return _.pluck(array, 'user');
	     * };
	     *
	     * // using the `_.matches` callback shorthand
	     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
	     * // => [['pebbles'], ['barney', 'fred']]
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.map(_.partition(users, 'active', false), mapper);
	     * // => [['barney', 'pebbles'], ['fred']]
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(_.partition(users, 'active'), mapper);
	     * // => [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Gets the property value of `path` from all elements in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|string} path The path of the property to pluck.
	     * @returns {Array} Returns the property values.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.pluck(users, 'user');
	     * // => ['barney', 'fred']
	     *
	     * var userIndex = _.indexBy(users, 'user');
	     * _.pluck(userIndex, 'age');
	     * // => [36, 40] (iteration order is not guaranteed)
	     */
	    function pluck(collection, path) {
	      return map(collection, property(path));
	    }
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` through `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not provided the first element of `collection` is used as the initial
	     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
	     * and `sortByOrder`
	     *
	     * @static
	     * @memberOf _
	     * @alias foldl, inject
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.reduce([1, 2], function(total, n) {
	     *   return total + n;
	     * });
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     *   return result;
	     * }, {});
	     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
	     */
	    var reduce = createReduce(arrayReduce, baseEach);
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias foldr
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    var reduceRight = createReduce(arrayReduceRight, baseEachRight);
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.reject([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [1, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.reject(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.reject(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function reject(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, function(value, index, collection) {
	        return !predicate(value, index, collection);
	      });
	    }
	
	    /**
	     * Gets a random element or `n` random elements from a collection.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to sample.
	     * @param {number} [n] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {*} Returns the random sample(s).
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     *
	     * _.sample([1, 2, 3, 4], 2);
	     * // => [3, 1]
	     */
	    function sample(collection, n, guard) {
	      if (guard ? isIterateeCall(collection, n, guard) : n == null) {
	        collection = toIterable(collection);
	        var length = collection.length;
	        return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
	      }
	      var index = -1,
	          result = toArray(collection),
	          length = result.length,
	          lastIndex = length - 1;
	
	      n = nativeMin(n < 0 ? 0 : (+n || 0), length);
	      while (++index < n) {
	        var rand = baseRandom(index, lastIndex),
	            value = result[rand];
	
	        result[rand] = result[index];
	        result[index] = value;
	      }
	      result.length = n;
	      return result;
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      return sample(collection, POSITIVE_INFINITY);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the size of `collection`.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      var length = collection ? getLength(collection) : 0;
	      return isLength(length) ? length : keys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * The function returns as soon as it finds a passing value and does not iterate
	     * over the entire collection. The predicate is bound to `thisArg` and invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias any
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.some(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection through `iteratee`. This method performs
	     * a stable sort, that is, it preserves the original sort order of equal elements.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return Math.sin(n);
	     * });
	     * // => [3, 1, 2]
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return this.sin(n);
	     * }, Math);
	     * // => [3, 1, 2]
	     *
	     * var users = [
	     *   { 'user': 'fred' },
	     *   { 'user': 'pebbles' },
	     *   { 'user': 'barney' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.sortBy(users, 'user'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function sortBy(collection, iteratee, thisArg) {
	      if (collection == null) {
	        return [];
	      }
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      var index = -1;
	      iteratee = getCallback(iteratee, thisArg, 3);
	
	      var result = baseMap(collection, function(value, key, collection) {
	        return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
	      });
	      return baseSortBy(result, compareAscending);
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it can sort by multiple iteratees
	     * or property names.
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
	     *  The iteratees to sort by, specified as individual values or arrays of values.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
	     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
	     *
	     * _.map(_.sortByAll(users, 'user', function(chr) {
	     *   return Math.floor(chr.age / 10);
	     * }), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    var sortByAll = restParam(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var guard = iteratees[2];
	      if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) {
	        iteratees.length = 1;
	      }
	      return baseSortByOrder(collection, baseFlatten(iteratees), []);
	    });
	
	    /**
	     * This method is like `_.sortByAll` except that it allows specifying the
	     * sort orders of the iteratees to sort by. If `orders` is unspecified, all
	     * values are sorted in ascending order. Otherwise, a value is sorted in
	     * ascending order if its corresponding order is "asc", and descending if "desc".
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // sort by `user` in ascending order and by `age` in descending order
	     * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    function sortByOrder(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (guard && isIterateeCall(iteratees, orders, guard)) {
	        orders = undefined;
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseSortByOrder(collection, iteratees, orders);
	    }
	
	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning an array of all elements that have equivalent
	     * property values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
	     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
	     * ];
	     *
	     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
	     * // => ['fred']
	     */
	    function where(collection, source) {
	      return filter(collection, baseMatches(source));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the number of milliseconds that have elapsed since the Unix epoch
	     * (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @category Date
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => logs the number of milliseconds it took for the deferred function to be invoked
	     */
	    var now = nativeNow || function() {
	      return new Date().getTime();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it is called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => logs 'done saving!' after the two async saves have completed
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      n = nativeIsFinite(n = +n) ? n : 0;
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that accepts up to `n` arguments ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      if (guard && isIterateeCall(func, n, guard)) {
	        n = undefined;
	      }
	      n = (func && n == null) ? func.length : nativeMax(+n || 0, 0);
	      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it is called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery('#add').on('click', _.before(5, addContactToList));
	     * // => allows adding up to 4 contacts to the list
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and prepends any additional `_.bind` arguments to those provided to the
	     * bound function.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind` this method does not set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var greet = function(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * };
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // using placeholders
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = restParam(function(func, thisArg, partials) {
	      var bitmask = BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bind.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method. Method names may be specified as individual arguments or as arrays
	     * of method names. If no method names are provided all enumerable function
	     * properties, own and inherited, of `object` are bound.
	     *
	     * **Note:** This method does not set the "length" property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} [methodNames] The object method names to bind,
	     *  specified as individual method names or arrays of method names.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'onClick': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view);
	     * jQuery('#docs').on('click', view.onClick);
	     * // => logs 'clicked docs' when the element is clicked
	     */
	    var bindAll = restParam(function(object, methodNames) {
	      methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);
	
	      var index = -1,
	          length = methodNames.length;
	
	      while (++index < length) {
	        var key = methodNames[index];
	        object[key] = createWrapper(object[key], BIND_FLAG, object);
	      }
	      return object;
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` and prepends
	     * any additional `_.bindKey` arguments to those provided to the bound function.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist.
	     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object the method belongs to.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // using placeholders
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = restParam(function(object, key, partials) {
	      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bindKey.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts one or more arguments of `func` that when
	     * called either invokes `func` returning its result, if all `func` arguments
	     * have been provided, or returns a function that accepts one or more of the
	     * remaining `func` arguments, and so on. The arity of `func` may be specified
	     * if `func.length` is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    var curry = createCurry(CURRY_FLAG);
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    var curryRight = createCurry(CURRY_RIGHT_FLAG);
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed invocations. Provide an options object to indicate that `func`
	     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
	     * Subsequent calls to the debounced function return the result of the last
	     * `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the debounced function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=false] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
	     *  delayed before it is invoked.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // avoid costly calculations while the window size is in flux
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
	     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // ensure `batchLog` is invoked once after 1 second of debounced calls
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', _.debounce(batchLog, 250, {
	     *   'maxWait': 1000
	     * }));
	     *
	     * // cancel a debounced call
	     * var todoChanges = _.debounce(batchLog, 1000);
	     * Object.observe(models.todo, todoChanges);
	     *
	     * Object.observe(models, function(changes) {
	     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
	     *     todoChanges.cancel();
	     *   }
	     * }, ['delete']);
	     *
	     * // ...at some point `models.todo` is changed
	     * models.todo.completed = true;
	     *
	     * // ...before 1 second has passed `models.todo` is deleted
	     * // which cancels the debounced `todoChanges` call
	     * delete models.todo;
	     */
	    function debounce(func, wait, options) {
	      var args,
	          maxTimeoutId,
	          result,
	          stamp,
	          thisArg,
	          timeoutId,
	          trailingCall,
	          lastCalled = 0,
	          maxWait = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = wait < 0 ? 0 : (+wait || 0);
	      if (options === true) {
	        var leading = true;
	        trailing = false;
	      } else if (isObject(options)) {
	        leading = !!options.leading;
	        maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function cancel() {
	        if (timeoutId) {
	          clearTimeout(timeoutId);
	        }
	        if (maxTimeoutId) {
	          clearTimeout(maxTimeoutId);
	        }
	        lastCalled = 0;
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	      }
	
	      function complete(isCalled, id) {
	        if (id) {
	          clearTimeout(id);
	        }
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	        if (isCalled) {
	          lastCalled = now();
	          result = func.apply(thisArg, args);
	          if (!timeoutId && !maxTimeoutId) {
	            args = thisArg = undefined;
	          }
	        }
	      }
	
	      function delayed() {
	        var remaining = wait - (now() - stamp);
	        if (remaining <= 0 || remaining > wait) {
	          complete(trailingCall, maxTimeoutId);
	        } else {
	          timeoutId = setTimeout(delayed, remaining);
	        }
	      }
	
	      function maxDelayed() {
	        complete(trailing, timeoutId);
	      }
	
	      function debounced() {
	        args = arguments;
	        stamp = now();
	        thisArg = this;
	        trailingCall = trailing && (timeoutId || !leading);
	
	        if (maxWait === false) {
	          var leadingCall = leading && !timeoutId;
	        } else {
	          if (!maxTimeoutId && !leading) {
	            lastCalled = stamp;
	          }
	          var remaining = maxWait - (stamp - lastCalled),
	              isCalled = remaining <= 0 || remaining > maxWait;
	
	          if (isCalled) {
	            if (maxTimeoutId) {
	              maxTimeoutId = clearTimeout(maxTimeoutId);
	            }
	            lastCalled = stamp;
	            result = func.apply(thisArg, args);
	          }
	          else if (!maxTimeoutId) {
	            maxTimeoutId = setTimeout(maxDelayed, remaining);
	          }
	        }
	        if (isCalled && timeoutId) {
	          timeoutId = clearTimeout(timeoutId);
	        }
	        else if (!timeoutId && wait !== maxWait) {
	          timeoutId = setTimeout(delayed, wait);
	        }
	        if (leadingCall) {
	          isCalled = true;
	          result = func.apply(thisArg, args);
	        }
	        if (isCalled && !timeoutId && !maxTimeoutId) {
	          args = thisArg = undefined;
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // logs 'deferred' after one or more milliseconds
	     */
	    var defer = restParam(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => logs 'later' after one second
	     */
	    var delay = restParam(function(func, wait, args) {
	      return baseDelay(func, wait, args);
	    });
	
	    /**
	     * Creates a function that returns the result of invoking the provided
	     * functions with the `this` binding of the created function, where each
	     * successive invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow(_.add, square);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the provided functions from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias backflow, compose
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight(square, _.add);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is coerced to a string and used as the
	     * cache key. The `func` is invoked with the `this` binding of the memoized
	     * function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoizing function.
	     * @example
	     *
	     * var upperCase = _.memoize(function(string) {
	     *   return string.toUpperCase();
	     * });
	     *
	     * upperCase('fred');
	     * // => 'FRED'
	     *
	     * // modifying the result cache
	     * upperCase.cache.set('fred', 'BARNEY');
	     * upperCase('fred');
	     * // => 'BARNEY'
	     *
	     * // replacing `_.memoize.Cache`
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'barney' };
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'fred' }
	     *
	     * _.memoize.Cache = WeakMap;
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'barney' }
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result);
	        return result;
	      };
	      memoized.cache = new memoize.Cache;
	      return memoized;
	    }
	
	    /**
	     * Creates a function that runs each argument through a corresponding
	     * transform function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms] The functions to transform
	     * arguments, specified as individual functions or arrays of functions.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var modded = _.modArgs(function(x, y) {
	     *   return [x, y];
	     * }, square, doubled);
	     *
	     * modded(1, 2);
	     * // => [1, 4]
	     *
	     * modded(5, 10);
	     * // => [25, 20]
	     */
	    var modArgs = restParam(function(func, transforms) {
	      transforms = baseFlatten(transforms);
	      if (typeof func != 'function' || !arrayEvery(transforms, baseIsFunction)) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = transforms.length;
	      return restParam(function(args) {
	        var index = nativeMin(args.length, length);
	        while (index--) {
	          args[index] = transforms[index](args[index]);
	        }
	        return func.apply(this, args);
	      });
	    });
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        return !predicate.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first call. The `func` is invoked
	     * with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // `initialize` invokes `createApplication` once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with `partial` arguments prepended
	     * to those provided to the new function. This method is like `_.bind` except
	     * it does **not** alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // using placeholders
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = createPartial(PARTIAL_FLAG);
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to those provided to the new function.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // using placeholders
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = createPartial(PARTIAL_RIGHT_FLAG);
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified indexes where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, 2, 0, 1);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     *
	     * var map = _.rearg(_.map, [1, 0]);
	     * map(function(n) {
	     *   return n * 3;
	     * }, [1, 2, 3]);
	     * // => [3, 6, 9]
	     */
	    var rearg = restParam(function(func, indexes) {
	      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as an array.
	     *
	     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.restParam(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function restParam(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            rest = Array(length);
	
	        while (++index < length) {
	          rest[index] = args[start + index];
	        }
	        switch (start) {
	          case 0: return func.call(this, rest);
	          case 1: return func.call(this, args[0], rest);
	          case 2: return func.call(this, args[0], args[1], rest);
	        }
	        var otherArgs = Array(start + 1);
	        index = -1;
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = rest;
	        return func.apply(this, otherArgs);
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the created
	     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
	     *
	     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * // with a Promise
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function(array) {
	        return func.apply(this, array);
	      };
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed invocations. Provide an options object to indicate
	     * that `func` should be invoked on the leading and/or trailing edge of the
	     * `wait` timeout. Subsequent calls to the throttled function return the
	     * result of the last `func` call.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the throttled function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=true] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // avoid excessively updating the position while scrolling
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
	     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
	     *   'trailing': false
	     * }));
	     *
	     * // cancel a trailing throttled call
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (options === false) {
	        leading = false;
	      } else if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
	    }
	
	    /**
	     * Creates a function that provides `value` to the wrapper function as its
	     * first argument. Any additional arguments provided to the function are
	     * appended to those provided to the wrapper function. The wrapper is invoked
	     * with the `this` binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} wrapper The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      wrapper = wrapper == null ? identity : wrapper;
	      return createWrapper(wrapper, PARTIAL_FLAG, undefined, [value], []);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
	     * otherwise they are assigned by reference. If `customizer` is provided it is
	     * invoked to produce the cloned values. If `customizer` returns `undefined`
	     * cloning is handled by the method instead. The `customizer` is bound to
	     * `thisArg` and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var shallow = _.clone(users);
	     * shallow[0] === users[0];
	     * // => true
	     *
	     * var deep = _.clone(users, true);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.clone(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 0
	     */
	    function clone(value, isDeep, customizer, thisArg) {
	      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
	        isDeep = false;
	      }
	      else if (typeof isDeep == 'function') {
	        thisArg = customizer;
	        customizer = isDeep;
	        isDeep = false;
	      }
	      return typeof customizer == 'function'
	        ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, isDeep);
	    }
	
	    /**
	     * Creates a deep clone of `value`. If `customizer` is provided it is invoked
	     * to produce the cloned values. If `customizer` returns `undefined` cloning
	     * is handled by the method instead. The `customizer` is bound to `thisArg`
	     * and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the deep cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var deep = _.cloneDeep(users);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.cloneDeep(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 20
	     */
	    function cloneDeep(value, customizer, thisArg) {
	      return typeof customizer == 'function'
	        ? baseClone(value, true, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, true);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    function gt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    function gte(value, other) {
	      return value >= other;
	    }
	
	    /**
	     * Checks if `value` is classified as an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    function isArguments(value) {
	      return isObjectLike(value) && isArrayLike(value) &&
	        hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	    }
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(function() { return arguments; }());
	     * // => false
	     */
	    var isArray = nativeIsArray || function(value) {
	      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	    };
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    function isDate(value) {
	      return isObjectLike(value) && objToString.call(value) == dateTag;
	    }
	
	    /**
	     * Checks if `value` is a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is empty. A value is considered empty unless it is an
	     * `arguments` object, array, string, or jQuery-like collection with a length
	     * greater than `0` or an object with own enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Array|Object|string} value The value to inspect.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
	          (isObjectLike(value) && isFunction(value.splice)))) {
	        return !value.length;
	      }
	      return !keys(value).length;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent. If `customizer` is provided it is invoked to compare values.
	     * If `customizer` returns `undefined` comparisons are handled by the method
	     * instead. The `customizer` is bound to `thisArg` and invoked with three
	     * arguments: (value, other [, index|key]).
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. Functions and DOM nodes
	     * are **not** supported. Provide a customizer function to extend support
	     * for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @alias eq
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'fred' };
	     *
	     * object == other;
	     * // => false
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * // using a customizer callback
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqual(array, other, function(value, other) {
	     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
	     *     return true;
	     *   }
	     * });
	     * // => true
	     */
	    function isEqual(value, other, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on [`Number.isFinite`](http://ecma-international.org/ecma-262/6.0/#sec-number.isfinite).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(10);
	     * // => true
	     *
	     * _.isFinite('10');
	     * // => false
	     *
	     * _.isFinite(true);
	     * // => false
	     *
	     * _.isFinite(Object(10));
	     * // => false
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in older versions of Chrome and Safari which return 'function' for regexes
	      // and Safari 8 equivalents which return 'object' for typed array constructors.
	      return isObject(value) && objToString.call(value) == funcTag;
	    }
	
	    /**
	     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(1);
	     * // => false
	     */
	    function isObject(value) {
	      // Avoid a V8 JIT bug in Chrome 19-20.
	      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	      var type = typeof value;
	      return !!value && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Performs a deep comparison between `object` and `source` to determine if
	     * `object` contains equivalent property values. If `customizer` is provided
	     * it is invoked to compare values. If `customizer` returns `undefined`
	     * comparisons are handled by the method instead. The `customizer` is bound
	     * to `thisArg` and invoked with three arguments: (value, other, index|key).
	     *
	     * **Note:** This method supports comparing properties of arrays, booleans,
	     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
	     * and DOM nodes are **not** supported. Provide a customizer function to extend
	     * support for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.isMatch(object, { 'age': 40 });
	     * // => true
	     *
	     * _.isMatch(object, { 'age': 36 });
	     * // => false
	     *
	     * // using a customizer callback
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatch(object, source, function(value, other) {
	     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
	     * });
	     * // => true
	     */
	    function isMatch(object, source, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      return baseIsMatch(object, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
	     * which returns `true` for `undefined` and other non-numeric values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a native function.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (value == null) {
	        return false;
	      }
	      if (isFunction(value)) {
	        return reIsNative.test(fnToString.call(value));
	      }
	      return isObjectLike(value) && reIsHostCtor.test(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
	     * as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isNumber(8.4);
	     * // => true
	     *
	     * _.isNumber(NaN);
	     * // => true
	     *
	     * _.isNumber('8.4');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * **Note:** This method assumes objects created by the `Object` constructor
	     * have no inherited enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      var Ctor;
	
	      // Exit early for non `Object` objects.
	      if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
	          (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	        return false;
	      }
	      // IE < 9 iterates inherited properties before own properties. If the first
	      // iterated property is an object's own property then there are no inherited
	      // enumerable properties.
	      var result;
	      // In most environments an object's own properties are iterated before
	      // its inherited properties. If the last iterated property is an object's
	      // own property then there are no inherited enumerable properties.
	      baseForIn(value, function(subValue, key) {
	        result = key;
	      });
	      return result === undefined || hasOwnProperty.call(value, result);
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    function isRegExp(value) {
	      return isObject(value) && objToString.call(value) == regexpTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    function isTypedArray(value) {
	      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
	    }
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    function lt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    function lte(value, other) {
	      return value <= other;
	    }
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * (function() {
	     *   return _.toArray(arguments).slice(1);
	     * }(1, 2, 3));
	     * // => [2, 3]
	     */
	    function toArray(value) {
	      var length = value ? getLength(value) : 0;
	      if (!isLength(length)) {
	        return values(value);
	      }
	      if (!length) {
	        return [];
	      }
	      return arrayCopy(value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable
	     * properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return baseCopy(value, keysIn(value));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Recursively merges own enumerable properties of the source object(s), that
	     * don't resolve to `undefined` into the destination object. Subsequent sources
	     * overwrite property assignments of previous sources. If `customizer` is
	     * provided it is invoked to produce the merged values of the destination and
	     * source properties. If `customizer` returns `undefined` merging is handled
	     * by the method instead. The `customizer` is bound to `thisArg` and invoked
	     * with five arguments: (objectValue, sourceValue, key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var users = {
	     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	     * };
	     *
	     * var ages = {
	     *   'data': [{ 'age': 36 }, { 'age': 40 }]
	     * };
	     *
	     * _.merge(users, ages);
	     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	     *
	     * // using a customizer callback
	     * var object = {
	     *   'fruits': ['apple'],
	     *   'vegetables': ['beet']
	     * };
	     *
	     * var other = {
	     *   'fruits': ['banana'],
	     *   'vegetables': ['carrot']
	     * };
	     *
	     * _.merge(object, other, function(a, b) {
	     *   if (_.isArray(a)) {
	     *     return a.concat(b);
	     *   }
	     * });
	     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	     */
	    var merge = createAssigner(baseMerge);
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object. Subsequent sources overwrite property assignments of previous sources.
	     * If `customizer` is provided it is invoked to produce the assigned values.
	     * The `customizer` is bound to `thisArg` and invoked with five arguments:
	     * (objectValue, sourceValue, key, object, source).
	     *
	     * **Note:** This method mutates `object` and is based on
	     * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
	     *
	     * @static
	     * @memberOf _
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using a customizer callback
	     * var defaults = _.partialRight(_.assign, function(value, other) {
	     *   return _.isUndefined(value) ? other : value;
	     * });
	     *
	     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var assign = createAssigner(function(object, source, customizer) {
	      return customizer
	        ? assignWith(object, source, customizer)
	        : baseAssign(object, source);
	    });
	
	    /**
	     * Creates an object that inherits from the given `prototype` object. If a
	     * `properties` object is provided its own enumerable properties are assigned
	     * to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties, guard) {
	      var result = baseCreate(prototype);
	      if (guard && isIterateeCall(prototype, properties, guard)) {
	        properties = undefined;
	      }
	      return properties ? baseAssign(result, properties) : result;
	    }
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object for all destination properties that resolve to `undefined`. Once a
	     * property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var defaults = createDefaults(assign, assignDefaults);
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
	     * // => { 'user': { 'name': 'barney', 'age': 36 } }
	     *
	     */
	    var defaultsDeep = createDefaults(merge, mergeDefaults);
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    var findKey = createFindKey(baseForOwn);
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => returns `pebbles` assuming `_.findKey` returns `barney`
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    var findLastKey = createFindKey(baseForOwnRight);
	
	    /**
	     * Iterates over own and inherited enumerable properties of an object invoking
	     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
	     */
	    var forIn = createForIn(baseFor);
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
	     */
	    var forInRight = createForIn(baseForRight);
	
	    /**
	     * Iterates over own enumerable properties of an object invoking `iteratee`
	     * for each property. The `iteratee` is bound to `thisArg` and invoked with
	     * three arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a' and 'b' (iteration order is not guaranteed)
	     */
	    var forOwn = createForOwn(baseForOwn);
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
	     */
	    var forOwnRight = createForOwn(baseForOwnRight);
	
	    /**
	     * Creates an array of function property names from all enumerable properties,
	     * own and inherited, of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @alias methods
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the new array of property names.
	     * @example
	     *
	     * _.functions(_);
	     * // => ['after', 'ary', 'assign', ...]
	     */
	    function functions(object) {
	      return baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the property value at `path` of `object`. If the resolved value is
	     * `undefined` the `defaultValue` is used in its place.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': { 'c': 3 } } };
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b.c');
	     * // => true
	     *
	     * _.has(object, ['a', 'b', 'c']);
	     * // => true
	     */
	    function has(object, path) {
	      if (object == null) {
	        return false;
	      }
	      var result = hasOwnProperty.call(object, path);
	      if (!result && !isKey(path)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        if (object == null) {
	          return false;
	        }
	        path = last(path);
	        result = hasOwnProperty.call(object, path);
	      }
	      return result || (isLength(object.length) && isIndex(path, object.length) &&
	        (isArray(object) || isArguments(object)));
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite property
	     * assignments of previous values unless `multiValue` is `true`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {boolean} [multiValue] Allow multiple values per key.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     *
	     * // with `multiValue`
	     * _.invert(object, true);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function invert(object, multiValue, guard) {
	      if (guard && isIterateeCall(object, multiValue, guard)) {
	        multiValue = undefined;
	      }
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key];
	
	        if (multiValue) {
	          if (hasOwnProperty.call(result, value)) {
	            result[value].push(key);
	          } else {
	            result[value] = [key];
	          }
	        }
	        else {
	          result[value] = key;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    var keys = !nativeKeys ? shimKeys : function(object) {
	      var Ctor = object == null ? undefined : object.constructor;
	      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	          (typeof object != 'function' && isArrayLike(object))) {
	        return shimKeys(object);
	      }
	      return isObject(object) ? nativeKeys(object) : [];
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      if (object == null) {
	        return [];
	      }
	      if (!isObject(object)) {
	        object = Object(object);
	      }
	      var length = object.length;
	      length = (length && isLength(length) &&
	        (isArray(object) || isArguments(object)) && length) || 0;
	
	      var Ctor = object.constructor,
	          index = -1,
	          isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	          result = Array(length),
	          skipIndexes = length > 0;
	
	      while (++index < length) {
	        result[index] = (index + '');
	      }
	      for (var key in object) {
	        if (!(skipIndexes && isIndex(key, length)) &&
	            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * property of `object` through `iteratee`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    var mapKeys = createObjectMapper(true);
	
	    /**
	     * Creates an object with the same keys as `object` and values generated by
	     * running each own enumerable property of `object` through `iteratee`. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, key, object).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
	     *   return n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * // using the `_.property` callback shorthand
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    var mapValues = createObjectMapper();
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable properties of `object` that are not omitted.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to omit, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.omit(object, 'age');
	     * // => { 'user': 'fred' }
	     *
	     * _.omit(object, _.isNumber);
	     * // => { 'user': 'fred' }
	     */
	    var omit = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      if (typeof props[0] != 'function') {
	        var props = arrayMap(baseFlatten(props), String);
	        return pickByArray(object, baseDifference(keysIn(object), props));
	      }
	      var predicate = bindCallback(props[0], props[1], 3);
	      return pickByCallback(object, function(value, key, object) {
	        return !predicate(value, key, object);
	      });
	    });
	
	    /**
	     * Creates a two dimensional array of the key-value pairs for `object`,
	     * e.g. `[[key1, value1], [key2, value2]]`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the new array of key-value pairs.
	     * @example
	     *
	     * _.pairs({ 'barney': 36, 'fred': 40 });
	     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
	     */
	    function pairs(object) {
	      object = toObject(object);
	
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        var key = props[index];
	        result[index] = [key, object[key]];
	      }
	      return result;
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties. Property
	     * names may be specified as individual arguments or as arrays of property
	     * names. If `predicate` is provided it is invoked for each property of `object`
	     * picking the properties `predicate` returns truthy for. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to pick, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.pick(object, 'user');
	     * // => { 'user': 'fred' }
	     *
	     * _.pick(object, _.isString);
	     * // => { 'user': 'fred' }
	     */
	    var pick = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      return typeof props[0] == 'function'
	        ? pickByCallback(object, bindCallback(props[0], props[1], 3))
	        : pickByArray(object, baseFlatten(props));
	    });
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a function
	     * it is invoked with the `this` binding of its parent object and its result
	     * is returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a.b.c', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a.b.c', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      var result = object == null ? undefined : object[path];
	      if (result === undefined) {
	        if (object != null && !isKey(path, object)) {
	          path = toPath(path);
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          result = object == null ? undefined : object[last(path)];
	        }
	        result = result === undefined ? defaultValue : result;
	      }
	      return isFunction(result) ? result.call(object) : result;
	    }
	
	    /**
	     * Sets the property value of `path` on `object`. If a portion of `path`
	     * does not exist it is created.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to augment.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, 'x[0].y.z', 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      if (object == null) {
	        return object;
	      }
	      var pathKey = (path + '');
	      path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = path[index];
	        if (isObject(nested)) {
	          if (index == lastIndex) {
	            nested[key] = value;
	          } else if (nested[key] == null) {
	            nested[key] = isIndex(path[index + 1]) ? [] : {};
	          }
	        }
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own enumerable
	     * properties through `iteratee`, with each invocation potentially mutating
	     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
	     * with four arguments: (accumulator, value, key, object). Iteratee functions
	     * may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Array|Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     */
	    function transform(object, iteratee, accumulator, thisArg) {
	      var isArr = isArray(object) || isTypedArray(object);
	      iteratee = getCallback(iteratee, thisArg, 4);
	
	      if (accumulator == null) {
	        if (isArr || isObject(object)) {
	          var Ctor = object.constructor;
	          if (isArr) {
	            accumulator = isArray(object) ? new Ctor : [];
	          } else {
	            accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
	          }
	        } else {
	          accumulator = {};
	        }
	      }
	      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Creates an array of the own enumerable property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property values
	     * of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Checks if `n` is between `start` and up to but not including, `end`. If
	     * `end` is not specified it is set to `start` with `start` then set to `0`.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} n The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     */
	    function inRange(value, start, end) {
	      start = +start || 0;
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      return value >= nativeMin(start, end) && value < nativeMax(start, end);
	    }
	
	    /**
	     * Produces a random number between `min` and `max` (inclusive). If only one
	     * argument is provided a number between `0` and the given number is returned.
	     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
	     * number is returned instead of an integer.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} [min=0] The minimum possible value.
	     * @param {number} [max=1] The maximum possible value.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(min, max, floating) {
	      if (floating && isIterateeCall(min, max, floating)) {
	        max = floating = undefined;
	      }
	      var noMin = min == null,
	          noMax = max == null;
	
	      if (floating == null) {
	        if (noMax && typeof min == 'boolean') {
	          floating = min;
	          min = 1;
	        }
	        else if (typeof max == 'boolean') {
	          floating = max;
	          noMax = true;
	        }
	      }
	      if (noMin && noMax) {
	        max = 1;
	        noMax = false;
	      }
	      min = +min || 0;
	      if (noMax) {
	        max = min;
	        min = 0;
	      } else {
	        max = +max || 0;
	      }
	      if (floating || min % 1 || max % 1) {
	        var rand = nativeRandom();
	        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1)))), max);
	      }
	      return baseRandom(min, max);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__foo_bar__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? (word.charAt(0).toUpperCase() + word.slice(1)) : word);
	    });
	
	    /**
	     * Capitalizes the first character of `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('fred');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      string = baseToString(string);
	      return string && (string.charAt(0).toUpperCase() + string.slice(1));
	    }
	
	    /**
	     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = baseToString(string);
	      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search from.
	     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = baseToString(string);
	      target = (target + '');
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : nativeMin(position < 0 ? 0 : (+position || 0), length);
	
	      position -= target.length;
	      return position >= 0 && string.indexOf(target, position) == position;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
	     * their corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional characters
	     * use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value.
	     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * Backticks are escaped because in Internet Explorer < 9, they can break out
	     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
	     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
	     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
	     * for more details.
	     *
	     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
	     * to reduce XSS vectors.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      // Reset `lastIndex` because in IE < 9 `String#replace` does not.
	      string = baseToString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
	     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
	     */
	    function escapeRegExp(string) {
	      string = baseToString(string);
	      return (string && reHasRegExpChars.test(string))
	        ? string.replace(reRegExpChars, escapeRegExpChar)
	        : (string || '(?:)');
	    }
	
	    /**
	     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__foo_bar__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = baseToString(string);
	      length = +length;
	
	      var strLength = string.length;
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return string;
	      }
	      var mid = (length - strLength) / 2,
	          leftLength = nativeFloor(mid),
	          rightLength = nativeCeil(mid);
	
	      chars = createPadding('', rightLength, chars);
	      return chars.slice(0, leftLength) + string + chars;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padLeft('abc', 6);
	     * // => '   abc'
	     *
	     * _.padLeft('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padLeft('abc', 3);
	     * // => 'abc'
	     */
	    var padLeft = createPadDir();
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padRight('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padRight('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padRight('abc', 3);
	     * // => 'abc'
	     */
	    var padRight = createPadDir(true);
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
	     * in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
	     * of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
	      // Chrome fails to trim leading <BOM> whitespace characters.
	      // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
	      if (guard ? isIterateeCall(string, radix, guard) : radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      string = trim(string);
	      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=0] The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n) {
	      var result = '';
	      string = baseToString(string);
	      n = +n;
	      if (n < 1 || !string || !nativeIsFinite(n)) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        string += string;
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--foo-bar');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__foo_bar__');
	     * // => 'Foo Bar'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = baseToString(string);
	      position = position == null
	        ? 0
	        : nativeMin(position < 0 ? 0 : (+position || 0), string.length);
	
	      return string.lastIndexOf(target, position) == position;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is provided it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options] The options object.
	     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
	     * @param {Object} [options.imports] An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
	     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
	     * @param {string} [options.variable] The data object variable name.
	     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // using the "interpolate" delimiter to create a compiled template
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // using the HTML "escape" delimiter to escape data property values
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the internal `print` function in "evaluate" delimiters
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // using custom template delimiters
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // using backslashes to treat delimiters as plain text
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // using the `imports` option to import `jQuery` as `jq`
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the `sourceURL` option to specify a custom sourceURL for the template
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
	     *
	     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // using the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and a stack trace
	     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, otherOptions) {
	      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (otherOptions && isIterateeCall(string, options, otherOptions)) {
	        options = otherOptions = undefined;
	      }
	      string = baseToString(string);
	      options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);
	
	      var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products requires returning the `match`
	        // string in order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
	      }
	      chars = (chars + '');
	      return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimLeft('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimLeft('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimLeft(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string));
	      }
	      return string.slice(charsLeftIndex(string, (chars + '')));
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimRight('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimRight('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimRight(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(0, trimmedRightIndex(string) + 1);
	      }
	      return string.slice(0, charsRightIndex(string, (chars + '')) + 1);
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object|number} [options] The options object or maximum string length.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.trunc('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', 24);
	     * // => 'hi-diddly-ho there, n...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function trunc(string, options, guard) {
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (options != null) {
	        if (isObject(options)) {
	          var separator = 'separator' in options ? options.separator : separator;
	          length = 'length' in options ? (+options.length || 0) : length;
	          omission = 'omission' in options ? baseToString(options.omission) : omission;
	        } else {
	          length = +options || 0;
	        }
	      }
	      string = baseToString(string);
	      if (length >= string.length) {
	        return string;
	      }
	      var end = length - omission.length;
	      if (end < 1) {
	        return omission;
	      }
	      var result = string.slice(0, end);
	      if (separator == null) {
	        return result + omission;
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              newEnd,
	              substring = string.slice(0, end);
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            newEnd = match.index;
	          }
	          result = result.slice(0, newEnd == null ? end : newEnd);
	        }
	      } else if (string.indexOf(separator, end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
	     * corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
	     * entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = baseToString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      if (guard && isIterateeCall(string, pattern, guard)) {
	        pattern = undefined;
	      }
	      string = baseToString(string);
	      return string.match(pattern || reWords) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function} func The function to attempt.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // avoid throwing errors for invalid selectors
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = restParam(function(func, args) {
	      try {
	        return func.apply(undefined, args);
	      } catch(e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and arguments of the created function. If `func` is a property name the
	     * created callback returns the property value for a given element. If `func`
	     * is an object the created callback returns `true` for elements that contain
	     * the equivalent object properties, otherwise it returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias iteratee
	     * @category Utility
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // wrap to create custom callback shorthands
	     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
	     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
	     *   if (!match) {
	     *     return callback(func, thisArg);
	     *   }
	     *   return function(object) {
	     *     return match[2] == 'gt'
	     *       ? object[match[1]] > match[3]
	     *       : object[match[1]] < match[3];
	     *   };
	     * });
	     *
	     * _.filter(users, 'age__gt36');
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     */
	    function callback(func, thisArg, guard) {
	      if (guard && isIterateeCall(func, thisArg, guard)) {
	        thisArg = undefined;
	      }
	      return isObjectLike(func)
	        ? matches(func)
	        : baseCallback(func, thisArg);
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var getter = _.constant(object);
	     *
	     * getter() === object;
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * This method returns the first argument provided to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.identity(object) === object;
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that performs a deep comparison between a given object
	     * and `source`, returning `true` if the given object has equivalent property
	     * values, else `false`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
	     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that compares the property value of `path` on a given
	     * object to `value`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * _.find(users, _.matchesProperty('user', 'fred'));
	     * // => { 'user': 'fred' }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, true));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` on a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': _.constant(2) } } },
	     *   { 'a': { 'b': { 'c': _.constant(1) } } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    var method = restParam(function(path, args) {
	      return function(object) {
	        return invokePath(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path on `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = restParam(function(object, args) {
	      return function(path) {
	        return invokePath(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable function properties of a source object to the
	     * destination object. If `object` is a function then methods are added to
	     * its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.chain=true] Specify whether the functions added
	     *  are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      if (options == null) {
	        var isObj = isObject(source),
	            props = isObj ? keys(source) : undefined,
	            methodNames = (props && props.length) ? baseFunctions(source, props) : undefined;
	
	        if (!(methodNames ? methodNames.length : isObj)) {
	          methodNames = false;
	          options = source;
	          source = object;
	          object = this;
	        }
	      }
	      if (!methodNames) {
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = true,
	          index = -1,
	          isFunc = isFunction(object),
	          length = methodNames.length;
	
	      if (options === false) {
	        chain = false;
	      } else if (isObject(options) && 'chain' in options) {
	        chain = options.chain;
	      }
	      while (++index < length) {
	        var methodName = methodNames[index],
	            func = source[methodName];
	
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = (function(func) {
	            return function() {
	              var chainAll = this.__chain__;
	              if (chain || chainAll) {
	                var result = object(this.__wrapped__),
	                    actions = result.__actions__ = arrayCopy(this.__actions__);
	
	                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	                result.__chain__ = chainAll;
	                return result;
	              }
	              return func.apply(object, arrayPush([this.value()], arguments));
	            };
	          }(func));
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      root._ = oldDash;
	      return this;
	    }
	
	    /**
	     * A no-operation function that returns `undefined` regardless of the
	     * arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.noop(object) === undefined;
	     * // => true
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that returns the property value at `path` on a
	     * given object.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': 2 } } },
	     *   { 'a': { 'b': { 'c': 1 } } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the property value at a given path on `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return baseGet(object, toPath(path), path + '');
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. If `end` is not specified it is
	     * set to `start` with `start` then set to `0`. If `end` is less than `start`
	     * a zero-length range is created unless a negative `step` is specified.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the new array of numbers.
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    function range(start, end, step) {
	      if (step && isIterateeCall(start, end, step)) {
	        end = step = undefined;
	      }
	      start = +start || 0;
	      step = step == null ? 1 : (+step || 0);
	
	      if (end == null) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
	      // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * Invokes the iteratee function `n` times, returning an array of the results
	     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
	     * one argument; (index).
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
	     * // => [3, 6, 4]
	     *
	     * _.times(3, function(n) {
	     *   mage.castSpell(n);
	     * });
	     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
	     *
	     * _.times(3, function(n) {
	     *   this.cast(n);
	     * }, mage);
	     * // => also invokes `mage.castSpell(n)` three times
	     */
	    function times(n, iteratee, thisArg) {
	      n = nativeFloor(n);
	
	      // Exit early to avoid a JSC JIT bug in Safari 8
	      // where `Array(0)` is treated as `Array(1)`.
	      if (n < 1 || !nativeIsFinite(n)) {
	        return [];
	      }
	      var index = -1,
	          result = Array(nativeMin(n, MAX_ARRAY_LENGTH));
	
	      iteratee = bindCallback(iteratee, thisArg, 1);
	      while (++index < n) {
	        if (index < MAX_ARRAY_LENGTH) {
	          result[index] = iteratee(index);
	        } else {
	          iteratee(index);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {string} [prefix] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return baseToString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} augend The first number to add.
	     * @param {number} addend The second number to add.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    function add(augend, addend) {
	      return (+augend || 0) + (+addend || 0);
	    }
	
	    /**
	     * Calculates `n` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Calculates `n` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Gets the maximum value of `collection`. If `collection` is empty or falsey
	     * `-Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => -Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.max(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.max(users, 'age');
	     * // => { 'user': 'fred', 'age': 40 }
	     */
	    var max = createExtremum(gt, NEGATIVE_INFINITY);
	
	    /**
	     * Gets the minimum value of `collection`. If `collection` is empty or falsey
	     * `Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.min(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.min(users, 'age');
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var min = createExtremum(lt, POSITIVE_INFINITY);
	
	    /**
	     * Calculates `n` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Gets the sum of the values in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 6]);
	     * // => 10
	     *
	     * _.sum({ 'a': 4, 'b': 6 });
	     * // => 10
	     *
	     * var objects = [
	     *   { 'n': 4 },
	     *   { 'n': 6 }
	     * ];
	     *
	     * _.sum(objects, function(object) {
	     *   return object.n;
	     * });
	     * // => 10
	     *
	     * // using the `_.property` callback shorthand
	     * _.sum(objects, 'n');
	     * // => 10
	     */
	    function sum(collection, iteratee, thisArg) {
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return iteratee.length == 1
	        ? arraySum(isArray(collection) ? collection : toIterable(collection), iteratee)
	        : baseSum(collection, iteratee);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    // Add functions to the `Map` cache.
	    MapCache.prototype['delete'] = mapDelete;
	    MapCache.prototype.get = mapGet;
	    MapCache.prototype.has = mapHas;
	    MapCache.prototype.set = mapSet;
	
	    // Add functions to the `Set` cache.
	    SetCache.prototype.push = cachePush;
	
	    // Assign cache to `_.memoize`.
	    memoize.Cache = MapCache;
	
	    // Add functions that return wrapped values when chaining.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.callback = callback;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.functions = functions;
	    lodash.groupBy = groupBy;
	    lodash.indexBy = indexBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.invert = invert;
	    lodash.invoke = invoke;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.modArgs = modArgs;
	    lodash.negate = negate;
	    lodash.omit = omit;
	    lodash.once = once;
	    lodash.pairs = pairs;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pluck = pluck;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.restParam = restParam;
	    lodash.set = set;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortByAll = sortByAll;
	    lodash.sortByOrder = sortByOrder;
	    lodash.spread = spread;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.times = times;
	    lodash.toArray = toArray;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.union = union;
	    lodash.uniq = uniq;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.where = where;
	    lodash.without = without;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.backflow = flowRight;
	    lodash.collect = map;
	    lodash.compose = flowRight;
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.extend = assign;
	    lodash.iteratee = callback;
	    lodash.methods = functions;
	    lodash.object = zipObject;
	    lodash.select = filter;
	    lodash.tail = rest;
	    lodash.unique = uniq;
	
	    // Add functions to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add functions that return unwrapped values when chaining.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.deburr = deburr;
	    lodash.endsWith = endsWith;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.findWhere = findWhere;
	    lodash.first = first;
	    lodash.floor = floor;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isBoolean = isBoolean;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isMatch = isMatch;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isString = isString;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.min = min;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padLeft = padLeft;
	    lodash.padRight = padRight;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.sum = sum;
	    lodash.template = template;
	    lodash.trim = trim;
	    lodash.trimLeft = trimLeft;
	    lodash.trimRight = trimRight;
	    lodash.trunc = trunc;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.words = words;
	
	    // Add aliases.
	    lodash.all = every;
	    lodash.any = some;
	    lodash.contains = includes;
	    lodash.eq = isEqual;
	    lodash.detect = find;
	    lodash.foldl = reduce;
	    lodash.foldr = reduceRight;
	    lodash.head = first;
	    lodash.include = includes;
	    lodash.inject = reduce;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!lodash.prototype[methodName]) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), false);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add functions capable of returning wrapped and unwrapped values when chaining.
	    lodash.sample = sample;
	
	    lodash.prototype.sample = function(n) {
	      if (!this.__chain__ && n == null) {
	        return sample(this.value());
	      }
	      return this.thru(function(value) {
	        return sample(value, n);
	      });
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type string
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        var filtered = this.__filtered__;
	        if (filtered && !index) {
	          return new LazyWrapper(this);
	        }
	        n = n == null ? 1 : nativeMax(nativeFloor(n) || 0, 0);
	
	        var result = this.clone();
	        if (filtered) {
	          result.__takeCount__ = nativeMin(result.__takeCount__, n);
	        } else {
	          result.__views__.push({ 'size': n, 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type != LAZY_MAP_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
	        var result = this.clone();
	        result.__iteratees__.push({ 'iteratee': getCallback(iteratee, thisArg, 1), 'type': type });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.first` and `_.last`.
	    arrayEach(['first', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
	    arrayEach(['initial', 'rest'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
	    arrayEach(['pluck', 'where'], function(methodName, index) {
	      var operationName = index ? 'filter' : 'map',
	          createCallback = index ? baseMatches : property;
	
	      LazyWrapper.prototype[methodName] = function(value) {
	        return this[operationName](createCallback(value));
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.reject = function(predicate, thisArg) {
	      predicate = getCallback(predicate, thisArg, 1);
	      return this.filter(function(value) {
	        return !predicate(value);
	      });
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = start == null ? 0 : (+start || 0);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = (+end || 0);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate, thisArg) {
	      return this.reverse().takeWhile(predicate, thisArg).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(POSITIVE_INFINITY);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName),
	          retUnwrapped = /^(?:first|last)$/.test(methodName),
	          lodashFunc = lodash[retUnwrapped ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName];
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var args = retUnwrapped ? [1] : arguments,
	            chainAll = this.__chain__,
	            value = this.__wrapped__,
	            isHybrid = !!this.__actions__.length,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var interceptor = function(value) {
	          return (retUnwrapped && chainAll)
	            ? lodashFunc(value, 1)[0]
	            : lodashFunc.apply(undefined, arrayPush([value], args));
	        };
	
	        var action = { 'func': thru, 'args': [interceptor], 'thisArg': undefined },
	            onlyLazy = isLazy && !isHybrid;
	
	        if (retUnwrapped && !chainAll) {
	          if (onlyLazy) {
	            value = value.clone();
	            value.__actions__.push(action);
	            return func.call(value);
	          }
	          return lodashFunc.call(undefined, this.value())[0];
	        }
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push(action);
	          return new LodashWrapper(result, chainAll);
	        }
	        return this.thru(interceptor);
	      };
	    });
	
	    // Add `Array` and `String` methods to `lodash.prototype`.
	    arrayEach(['join', 'pop', 'push', 'replace', 'shift', 'sort', 'splice', 'split', 'unshift'], function(methodName) {
	      var func = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          return func.apply(this.value(), args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(value, args);
	        });
	      };
	    });
	
	    // Map minified function names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name,
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': undefined }];
	
	    // Add functions to the lazy wrapper.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chaining functions to the `lodash` wrapper.
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.concat = wrapperConcat;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toString = wrapperToString;
	    lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add function aliases to the `lodash` wrapper.
	    lodash.prototype.collect = lodash.prototype.map;
	    lodash.prototype.head = lodash.prototype.first;
	    lodash.prototype.select = lodash.prototype.filter;
	    lodash.prototype.tail = lodash.prototype.rest;
	
	    return lodash;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers like r.js check for condition patterns like the following:
	  if (true) {
	    // Expose lodash to the global object when an AMD loader is present to avoid
	    // errors in cases where lodash is loaded by a script tag and not intended
	    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
	    // more details.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
	  else if (freeExports && freeModule) {
	    // Export for Node.js or RingoJS.
	    if (moduleExports) {
	      (freeModule.exports = _)._ = _;
	    }
	    // Export for Rhino with CommonJS support.
	    else {
	      freeExports._ = _;
	    }
	  }
	  else {
	    // Export for a browser or Rhino.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)(module), (function() { return this; }())))

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.6.4
	 * (c) 2010-2017 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/**
	 * @ngdoc module
	 * @name ngCookies
	 * @description
	 *
	 * # ngCookies
	 *
	 * The `ngCookies` module provides a convenient wrapper for reading and writing browser cookies.
	 *
	 *
	 * <div doc-module-components="ngCookies"></div>
	 *
	 * See {@link ngCookies.$cookies `$cookies`} for usage.
	 */
	
	
	angular.module('ngCookies', ['ng']).
	  info({ angularVersion: '1.6.4' }).
	  /**
	   * @ngdoc provider
	   * @name $cookiesProvider
	   * @description
	   * Use `$cookiesProvider` to change the default behavior of the {@link ngCookies.$cookies $cookies} service.
	   * */
	   provider('$cookies', [/** @this */function $CookiesProvider() {
	    /**
	     * @ngdoc property
	     * @name $cookiesProvider#defaults
	     * @description
	     *
	     * Object containing default options to pass when setting cookies.
	     *
	     * The object may have following properties:
	     *
	     * - **path** - `{string}` - The cookie will be available only for this path and its
	     *   sub-paths. By default, this is the URL that appears in your `<base>` tag.
	     * - **domain** - `{string}` - The cookie will be available only for this domain and
	     *   its sub-domains. For security reasons the user agent will not accept the cookie
	     *   if the current domain is not a sub-domain of this domain or equal to it.
	     * - **expires** - `{string|Date}` - String of the form "Wdy, DD Mon YYYY HH:MM:SS GMT"
	     *   or a Date object indicating the exact date/time this cookie will expire.
	     * - **secure** - `{boolean}` - If `true`, then the cookie will only be available through a
	     *   secured connection.
	     *
	     * Note: By default, the address that appears in your `<base>` tag will be used as the path.
	     * This is important so that cookies will be visible for all routes when html5mode is enabled.
	     *
	     * @example
	     *
	     * ```js
	     * angular.module('cookiesProviderExample', ['ngCookies'])
	     *   .config(['$cookiesProvider', function($cookiesProvider) {
	     *     // Setting default options
	     *     $cookiesProvider.defaults.domain = 'foo.com';
	     *     $cookiesProvider.defaults.secure = true;
	     *   }]);
	     * ```
	     **/
	    var defaults = this.defaults = {};
	
	    function calcOptions(options) {
	      return options ? angular.extend({}, defaults, options) : defaults;
	    }
	
	    /**
	     * @ngdoc service
	     * @name $cookies
	     *
	     * @description
	     * Provides read/write access to browser's cookies.
	     *
	     * <div class="alert alert-info">
	     * Up until Angular 1.3, `$cookies` exposed properties that represented the
	     * current browser cookie values. In version 1.4, this behavior has changed, and
	     * `$cookies` now provides a standard api of getters, setters etc.
	     * </div>
	     *
	     * Requires the {@link ngCookies `ngCookies`} module to be installed.
	     *
	     * @example
	     *
	     * ```js
	     * angular.module('cookiesExample', ['ngCookies'])
	     *   .controller('ExampleController', ['$cookies', function($cookies) {
	     *     // Retrieving a cookie
	     *     var favoriteCookie = $cookies.get('myFavorite');
	     *     // Setting a cookie
	     *     $cookies.put('myFavorite', 'oatmeal');
	     *   }]);
	     * ```
	     */
	    this.$get = ['$$cookieReader', '$$cookieWriter', function($$cookieReader, $$cookieWriter) {
	      return {
	        /**
	         * @ngdoc method
	         * @name $cookies#get
	         *
	         * @description
	         * Returns the value of given cookie key
	         *
	         * @param {string} key Id to use for lookup.
	         * @returns {string} Raw cookie value.
	         */
	        get: function(key) {
	          return $$cookieReader()[key];
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#getObject
	         *
	         * @description
	         * Returns the deserialized value of given cookie key
	         *
	         * @param {string} key Id to use for lookup.
	         * @returns {Object} Deserialized cookie value.
	         */
	        getObject: function(key) {
	          var value = this.get(key);
	          return value ? angular.fromJson(value) : value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#getAll
	         *
	         * @description
	         * Returns a key value object with all the cookies
	         *
	         * @returns {Object} All cookies
	         */
	        getAll: function() {
	          return $$cookieReader();
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#put
	         *
	         * @description
	         * Sets a value for given cookie key
	         *
	         * @param {string} key Id for the `value`.
	         * @param {string} value Raw value to be stored.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        put: function(key, value, options) {
	          $$cookieWriter(key, value, calcOptions(options));
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#putObject
	         *
	         * @description
	         * Serializes and sets a value for given cookie key
	         *
	         * @param {string} key Id for the `value`.
	         * @param {Object} value Value to be stored.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        putObject: function(key, value, options) {
	          this.put(key, angular.toJson(value), options);
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#remove
	         *
	         * @description
	         * Remove given cookie
	         *
	         * @param {string} key Id of the key-value pair to delete.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        remove: function(key, options) {
	          $$cookieWriter(key, undefined, calcOptions(options));
	        }
	      };
	    }];
	  }]);
	
	angular.module('ngCookies').
	/**
	 * @ngdoc service
	 * @name $cookieStore
	 * @deprecated
	 * sinceVersion="v1.4.0"
	 * Please use the {@link ngCookies.$cookies `$cookies`} service instead.
	 *
	 * @requires $cookies
	 *
	 * @description
	 * Provides a key-value (string-object) storage, that is backed by session cookies.
	 * Objects put or retrieved from this storage are automatically serialized or
	 * deserialized by angular's toJson/fromJson.
	 *
	 * Requires the {@link ngCookies `ngCookies`} module to be installed.
	 *
	 * @example
	 *
	 * ```js
	 * angular.module('cookieStoreExample', ['ngCookies'])
	 *   .controller('ExampleController', ['$cookieStore', function($cookieStore) {
	 *     // Put cookie
	 *     $cookieStore.put('myFavorite','oatmeal');
	 *     // Get cookie
	 *     var favoriteCookie = $cookieStore.get('myFavorite');
	 *     // Removing a cookie
	 *     $cookieStore.remove('myFavorite');
	 *   }]);
	 * ```
	 */
	 factory('$cookieStore', ['$cookies', function($cookies) {
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $cookieStore#get
	       *
	       * @description
	       * Returns the value of given cookie key
	       *
	       * @param {string} key Id to use for lookup.
	       * @returns {Object} Deserialized cookie value, undefined if the cookie does not exist.
	       */
	      get: function(key) {
	        return $cookies.getObject(key);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $cookieStore#put
	       *
	       * @description
	       * Sets a value for given cookie key
	       *
	       * @param {string} key Id for the `value`.
	       * @param {Object} value Value to be stored.
	       */
	      put: function(key, value) {
	        $cookies.putObject(key, value);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $cookieStore#remove
	       *
	       * @description
	       * Remove given cookie
	       *
	       * @param {string} key Id of the key-value pair to delete.
	       */
	      remove: function(key) {
	        $cookies.remove(key);
	      }
	    };
	
	  }]);
	
	/**
	 * @name $$cookieWriter
	 * @requires $document
	 *
	 * @description
	 * This is a private service for writing cookies
	 *
	 * @param {string} name Cookie name
	 * @param {string=} value Cookie value (if undefined, cookie will be deleted)
	 * @param {Object=} options Object with options that need to be stored for the cookie.
	 */
	function $$CookieWriter($document, $log, $browser) {
	  var cookiePath = $browser.baseHref();
	  var rawDocument = $document[0];
	
	  function buildCookieString(name, value, options) {
	    var path, expires;
	    options = options || {};
	    expires = options.expires;
	    path = angular.isDefined(options.path) ? options.path : cookiePath;
	    if (angular.isUndefined(value)) {
	      expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
	      value = '';
	    }
	    if (angular.isString(expires)) {
	      expires = new Date(expires);
	    }
	
	    var str = encodeURIComponent(name) + '=' + encodeURIComponent(value);
	    str += path ? ';path=' + path : '';
	    str += options.domain ? ';domain=' + options.domain : '';
	    str += expires ? ';expires=' + expires.toUTCString() : '';
	    str += options.secure ? ';secure' : '';
	
	    // per http://www.ietf.org/rfc/rfc2109.txt browser must allow at minimum:
	    // - 300 cookies
	    // - 20 cookies per unique domain
	    // - 4096 bytes per cookie
	    var cookieLength = str.length + 1;
	    if (cookieLength > 4096) {
	      $log.warn('Cookie \'' + name +
	        '\' possibly not set or overflowed because it was too large (' +
	        cookieLength + ' > 4096 bytes)!');
	    }
	
	    return str;
	  }
	
	  return function(name, value, options) {
	    rawDocument.cookie = buildCookieString(name, value, options);
	  };
	}
	
	$$CookieWriter.$inject = ['$document', '$log', '$browser'];
	
	angular.module('ngCookies').provider('$$cookieWriter', /** @this */ function $$CookieWriterProvider() {
	  this.$get = $$CookieWriter;
	});
	
	
	})(window, window.angular);


/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(87);
	module.exports = 'ngCookies';


/***/ }),

/***/ 89:
/***/ (function(module, exports) {

	angular.module('md.data.table', ['md.table.templates']);
	
	angular.module('md.data.table').directive('mdColumnHeader', mdColumnHeader);
	
	function mdColumnHeader($compile, $interpolate, $timeout) {
	  'use strict';
	  
	  function postLink(scope, element, attrs, ctrls) {
	    var tableCtrl = ctrls[0];
	    var headCtrl = ctrls[1];
	    var template = angular.element('<div></div>');
	    
	    template.text($interpolate.startSymbol() + 'name' + $interpolate.endSymbol());
	    
	    if(attrs.unit) {
	      template.text(template.text() + ' (' + $interpolate.startSymbol() + 'unit' + $interpolate.endSymbol() + ')');
	    }
	    
	    if(angular.isDefined(attrs.trim)) {
	      template.contents().wrap('<div></div>');
	    }
	    
	    if(attrs.orderBy) {
	      var sortIcon = angular.element('<md-icon></md-icon>');
	      
	      var isActive = function () {
	        return headCtrl.order === scope.order || headCtrl.order === '-' + scope.order;
	      };
	      
	      var setOrder = function () {
	        
	        if(isActive()) {
	          scope.$apply(headCtrl.order = headCtrl.order === scope.order ? '-' + scope.order : scope.order);
	        } else {
	          scope.$apply(headCtrl.order = angular.isDefined(attrs.descendFirst) ? '-' + scope.order : scope.order);
	        }
	        
	        if(headCtrl.pullTrigger) {
	          $timeout(headCtrl.pullTrigger);
	        }
	      };
	      
	      scope.getDirection = function () {
	        if(isActive()) {
	          return headCtrl.order[0] === '-' ? 'down' : 'up';
	        }
	        return angular.isDefined(attrs.descendFirst) ? 'down' : 'up';
	      };
	      
	      sortIcon.attr('md-svg-icon', 'templates.arrow.html');
	      sortIcon.attr('ng-class', 'getDirection()');
	      
	      if(angular.isDefined(attrs.numeric)) {
	        template.prepend(sortIcon);
	      } else {
	        template.append(sortIcon);
	      }
	      
	      element.on('click', setOrder);
	      
	      scope.$watch(isActive, function (active) {
	        if(active) { element.addClass('md-active'); } else { element.removeClass('md-active'); }
	      });
	    }
	    
	    element.append($compile(template)(scope));
	    
	    if(headCtrl.isSignificant(element.parent())) {
	      tableCtrl.setColumn(attrs);
	      
	      if(attrs.ngRepeat) {
	        if(scope.$parent.$last) {
	          tableCtrl.isReady.head.resolve();
	        }
	      } else if(tableCtrl.isLastChild(element.parent().children(), element[0])) {
	        tableCtrl.isReady.head.resolve();
	      }
	    }
	  }
	
	  return {
	    link: postLink,
	    require: ['^^mdDataTable', '^mdTableHead'],
	    scope: {
	      name: '@',
	      order: '@orderBy',
	      unit: '@'
	    }
	  };
	}
	
	mdColumnHeader.$inject = ['$compile', '$interpolate', '$timeout'];
	
	angular.module('md.data.table').directive('mdDataTable', mdDataTable);
	
	function mdDataTable($mdTable) {
	  'use strict';
	  
	  function compile(tElement, tAttrs) {
	    var head = tElement.find('thead');
	    var foot = tElement.find('tfoot');
	    
	    // make sure the table has a head element
	    if(!head.length) {
	      head = tElement.find('tbody').eq(0);
	      
	      if(head.children().find('th').length) {
	        head.replaceWith('<thead>' + head.html() + '</thead>');
	      } else {
	        throw new Error('mdDataTable', 'Expecting <thead></thead> element.');
	      }
	      
	      head = tElement.find('thead');
	    }
	    
	    var rows = tElement.find('tbody').find('tr');
	    
	    head.attr('md-table-head', '');
	    rows.attr('md-table-row', '');
	    rows.find('td').attr('md-table-cell', '');
	    
	    if(foot.length) {
	      foot.attr('md-table-foot', '');
	      
	      if(tAttrs.mdRowSelect) {
	        foot.find('tr').prepend('<td></td>');
	      }
	    }
	    
	    var ngRepeat = $mdTable.getAttr(rows, 'ngRepeat');
	    
	    if(tAttrs.mdRowSelect && ngRepeat) {
	      rows.attr('md-select-row', '');
	    }
	    
	    if(tAttrs.mdRowSelect && !ngRepeat) {
	      console.warn('Please use ngRepeat to enable row selection.');
	    }
	    
	    if(head.attr('md-order') && !ngRepeat) {
	      console.warn('Column ordering without ngRepeat is not supported.');
	    }
	  }
	  
	  function Controller($attrs, $element, $q, $scope) {
	    var self = this;
	    
	    self.columns = [];
	    self.classes = [];
	    self.isReady = {
	      body: $q.defer(),
	      head: $q.defer()
	    };
	    
	    if($attrs.mdRowSelect) {
	      self.columns.push({ isNumeric: false });
	      
	      if(!angular.isArray(self.selectedItems)) {
	        self.selectedItems = [];
	        // log warning for developer
	        console.warn('md-row-select="' + $attrs.mdRowSelect + '" : ' +
	        $attrs.mdRowSelect + ' is not defined as an array in your controller, ' +
	        'i.e. ' + $attrs.mdRowSelect + ' = [], two-way data binding will fail.');
	      }
	    }
	    
	    if($attrs.mdProgress) {
	      $scope.$watch('$mdDataTableCtrl.progress', function () {
	        var deferred = self.defer();
	        $q.when(self.progress)['finally'](deferred.resolve);
	      });
	    }
	    
	    // support theming
	    ['md-primary', 'md-hue-1', 'md-hue-2', 'md-hue-3'].forEach(function(mdClass) {
	      if($element.hasClass(mdClass)) {
	        self.classes.push(mdClass);
	      }
	    });
	    
	    self.defer = function () {
	      if(self.deferred) {
	        self.deferred.reject('cancel');
	      } else if(self.showProgress) {
	        self.showProgress();
	      }
	      
	      self.deferred = $q.defer();
	      self.deferred.promise.then(self.resolve);
	      
	      return self.deferred;
	    };
	    
	    self.resolve = function () {
	      self.deferred = undefined;
	      
	      if(self.hideProgress) {
	        self.hideProgress();
	      }
	    };
	    
	    self.isLastChild = function (siblings, child) {
	      return Array.prototype.indexOf.call(siblings, child) === siblings.length - 1;
	    };
	    
	    self.isReady.body.promise.then(function (ngRepeat) {
	      if($attrs.mdRowSelect && ngRepeat) {
	        self.listener = $scope.$parent.$watch(ngRepeat.items, function (newValue, oldeValue) {
	          if(newValue !== oldeValue) {
	            self.selectedItems.splice(0);
	          }
	        });
	      }
	    });
	    
	    self.setColumn = function (column) {
	      self.columns.push({
	        isNumeric: angular.isDefined(column.numeric),
	        unit: column.unit
	      });
	    };
	  }
	  
	  Controller.$inject = ['$attrs', '$element', '$q', '$scope'];
	  
	  return {
	    bindToController: {
	      progress: '=mdProgress',
	      selectedItems: '=mdRowSelect'
	    },
	    compile: compile,
	    controller: Controller,
	    controllerAs: '$mdDataTableCtrl',
	    restrict: 'A',
	    scope: {}
	  };
	}
	
	mdDataTable.$inject = ['$mdTable'];
	
	
	angular.module('md.data.table').directive('mdTableCell', mdTableCell);
	
	function mdTableCell() {
	  'use strict';
	  
	  function postLink(scope, element) {
	    var select = element.find('md-select');
	    
	    if(select.length) {
	      
	      select.on('click', function (event) {
	        event.stopPropagation();
	      });
	      
	      element.addClass('clickable').on('click', function (event) {
	        event.stopPropagation();
	        select[0].click();
	      });
	    }
	  }
	  
	  function compile(tElement) {
	    tElement.find('md-select').attr('md-container-class', 'md-table-select');
	    return postLink;
	  }
	  
	  return {
	    compile: compile
	  };
	}
	
	angular.module('md.data.table').directive('mdTableFoot', mdTableFoot);
	
	function mdTableFoot() {
	  'use strict';
	
	  function postLink(scope, element, attrs, tableCtrl) {
	    var cells = element.find('td');
	    
	    tableCtrl.columns.forEach(function(column, index) {
	      if(column.isNumeric) {
	        cells.eq(index).addClass('numeric');
	      }
	    });
	    
	    if(cells.length < tableCtrl.columns.length) {
	      element.find('tr').append('<td colspan="' + (tableCtrl.columns.length - cells.length) + '"></td>');
	    }
	  }
	  
	  return {
	    require: '^mdDataTable',
	    link: postLink
	  };
	}
	
	angular.module('md.data.table').directive('mdTableHead', mdTableHead);
	
	function mdTableHead($mdTable, $q) {
	  'use strict';
	
	  function compile(tElement) {
	    tElement.find('th').attr('md-column-header', '');
	    
	    // enable row selection
	    if(tElement.parent().attr('md-row-select')) {
	      var ngRepeat = $mdTable.getAttr(tElement.parent().find('tbody').find('tr'), 'ngRepeat');
	      
	      if(ngRepeat) {
	        tElement.find('tr').prepend(angular.element('<th md-select-all="' + $mdTable.parse(ngRepeat).items + '"></th>'));
	      }
	    }
	    
	    tElement.after('<thead md-table-progress></thead>');
	    
	    return postLink;
	  }
	  
	  function Controller($element, $scope) {
	    var rows = $element.find('tr');
	    
	    if(!$scope.sigRow || parseInt($scope.sigRow, 10) === isNaN() || $scope.sigRow < 0) {
	      $scope.sigRow = rows.length - 1;
	    }
	    
	    // when tables headers have multiple rows we need a significant row
	    // to append the checkbox to and to controll the text alignment for
	    // numeric columns
	    this.isSignificant = function (row) {
	      return row.prop('rowIndex') === $scope.sigRow;
	    };
	  }
	  
	  function postLink(scope, element, attrs, tableCtrl) {
	    var controller = element.data('$mdTableHeadController');
	    
	    // table progress
	    if(angular.isFunction(scope.trigger)) {
	      controller.pullTrigger = function () {
	        var deferred = tableCtrl.defer();
	        $q.when(scope.trigger(controller.order))['finally'](deferred.resolve);
	      };
	    }
	  }
	  
	  Controller.$inject = ['$element', '$scope'];
	  
	  return {
	    bindToController: {
	      order: '=mdOrder'
	    },
	    compile: compile,
	    controller: Controller,
	    controllerAs: '$mdDataTableHeadCtrl',
	    require: '^mdDataTable',
	    scope: {
	      trigger: '=?mdTrigger',
	      sigRow: '=?'
	    }
	  };
	}
	
	mdTableHead.$inject = ['$mdTable', '$q'];
	
	angular.module('md.data.table').directive('mdDataTablePagination', mdDataTablePagination);
	
	function mdDataTablePagination($q) {
	  'use strict';
	
	  function postLink(scope, element, attrs) {
	    scope.paginationLabel = {
	      text: 'Rows per page:',
	      of: 'of'
	    };
	    
	    if(angular.isObject(scope.label)) {
	      angular.extend(scope.paginationLabel, scope.label);
	    }
	    
	    // table progress
	    if(angular.isFunction(scope.trigger)) {
	      
	      // the pagination directive is outside the table directive so we need
	      // to locate the controller
	      var findTable = function(element, callback) { 
	        while(element.localName !== 'md-data-table-container' && element.previousElementSibling) {
	          element = element.previousElementSibling;
	        }
	        // Allow for intermediate elements between md-data-table-container and md-data-table
	        element = element.querySelector('[md-data-table]');
	        callback(angular.element(element));
	      };
	      
	      var setTrigger = function(table) {
	        var tableCtrl;
	        if(table) {
	          tableCtrl = table.controller('mdDataTable');
	        } 
	        
	        if(!tableCtrl) {
	          return console.warn('Table Pagination: Could not locate your table directive, your ' + attrs.mdTrigger + ' function will not work.');
	        }
	        
	        scope.pullTrigger = function () {
	          var deferred = tableCtrl.defer();
	          $q.when(scope.trigger(scope.page, scope.limit))['finally'](deferred.resolve);
	        };
	      };
	      
	      findTable(element.prop('previousElementSibling'), setTrigger);
	    }
	  }
	  
	  function Controller($scope, $timeout) {
	    var min = 1;
	    
	    $scope.hasNext = function () {
	      return (($scope.page * $scope.limit) < $scope.total);
	    };
	    
	    $scope.hasPrevious = function () {
	      return ($scope.page > 1);
	    };
	    
	    $scope.next = function () {
	      $scope.page++;
	      
	      if($scope.pullTrigger) {
	        $timeout($scope.pullTrigger);
	      }
	      
	      min = $scope.min();
	    };
	    
	    $scope.last = function () {
	      $scope.page = Math.ceil($scope.total / $scope.limit);
	      
	      if($scope.pullTrigger) {
	        $timeout($scope.pullTrigger);
	      }
	      
	      min = $scope.min();
	    };
	    
	    $scope.min = function () {
	      return ((($scope.page - 1) * $scope.limit) + 1);
	    };
	    
	    $scope.max = function () {
	      return $scope.hasNext() ? $scope.page * $scope.limit : $scope.total;
	    };
	    
	    $scope.onSelect = function () {
	      $scope.page = Math.floor(min / $scope.limit) + 1;
	      
	      if($scope.pullTrigger) {
	        $timeout($scope.pullTrigger);
	      }
	      
	      min = $scope.min();
	      while((min > $scope.total) && $scope.hasPrevious()) {
	        $scope.previous();
	      }
	    };
	    
	    $scope.previous = function () {
	      $scope.page--;
	      
	      if($scope.pullTrigger) {
	        $timeout($scope.pullTrigger);
	      }
	      
	      min = $scope.min();
	    };
	    
	    $scope.first = function () {
	      $scope.page = 1;
	      
	      if($scope.pullTrigger) {
	        $timeout($scope.pullTrigger);
	      }
	      
	      min = $scope.min();
	    };
	  }
	  
	  Controller.$inject = ['$scope', '$timeout'];
	
	  return {
	    controller: Controller,
	    scope: {
	      label: '=mdLabel',
	      limit: '=mdLimit',
	      page: '=mdPage',
	      rowSelect: '=mdRowSelect',
	      total: '@mdTotal',
	      trigger: '=mdTrigger'
	    },
	    templateUrl: 'templates.md-data-table-pagination.html',
	    link: postLink
	  };
	}
	
	mdDataTablePagination.$inject = ['$q'];
	
	angular.module('md.data.table').directive('mdTableProgress', mdTableProgress);
	
	function mdTableProgress() {
	  'use strict';
	  
	  function postLink(scope, element, attrs, tableCtrl) {
	    
	    scope.getColumnCount = function () {
	      return tableCtrl.columns.length;
	    };
	    
	    tableCtrl.hideProgress = function () {
	      scope.showProgress = false;
	    };
	    
	    tableCtrl.showProgress = function () {
	      scope.showProgress = true;
	    };
	  }
	  
	  return {
	    link: postLink,
	    require: '^mdDataTable',
	    replace: true,
	    templateUrl: 'templates.md-data-table-progress.html'
	  };
	}
	
	
	angular.module('md.data.table').directive('mdTableRow', mdTableRow);
	
	function mdTableRow($mdTable, $timeout) {
	  'use strict';
	
	  function postLink(scope, element, attrs, tableCtrl) {
	    
	    if(angular.isDefined(attrs.mdSelectRow)) {
	      scope.mdClasses = tableCtrl.classes;
	      
	      scope.isDisabled = function() {
	        return scope.$eval(attrs.mdDisableSelect);
	      };
	      
	      scope.isSelected = function (item) {
	        return tableCtrl.selectedItems.indexOf(item) !== -1;
	      };
	      
	      scope.toggleRow = function (item, event) {
	        event.stopPropagation();
	        
	        if(scope.isDisabled()) {
	          return;
	        }
	        
	        if(scope.isSelected(item)) {
	          tableCtrl.selectedItems.splice(tableCtrl.selectedItems.indexOf(item), 1);
	        } else {
	          tableCtrl.selectedItems.push(item);
	        }
	      };
	    }
	    
	    if(attrs.ngRepeat) {
	      if(scope.$last) {
	        tableCtrl.isReady.body.resolve($mdTable.parse(attrs.ngRepeat));
	      }
	    } else if(tableCtrl.isLastChild(element.parent().children(), element[0])) {
	      tableCtrl.isReady.body.resolve();
	    }
	    
	    tableCtrl.isReady.head.promise.then(function () {
	      tableCtrl.columns.forEach(function (column, index) {
	        if(column.isNumeric) {
	          var cell = element.children().eq(index);
	          
	          cell.addClass('numeric');
	          
	          if(angular.isDefined(cell.attr('show-unit'))) {
	            $timeout(function () {
	              cell.text(cell.text() + tableCtrl.columns[index].unit);
	            });
	          }
	        }
	      });
	    });
	  }
	  
	  return {
	    link: postLink,
	    require: '^^mdDataTable'
	  };
	}
	
	mdTableRow.$inject = ['$mdTable', '$timeout'];
	
	angular.module('md.data.table').factory('$mdTable', mdTableService);
	
	function mdTableService() {
	  'use strict';
	  
	  var cache = {};
	  
	  function Repeat(ngRepeat) {
	    this._tokens = ngRepeat.split(/\s+/);
	    this._iterator = 0;
	    
	    this.item = this.current();
	    while(this.hasNext() && this.getNext() !== 'in') {
	      this.item += this.current();
	    }
	    
	    this.items = this.getNext();
	    while(this.hasNext() && ['|', 'track'].indexOf(this.getNext()) === -1) {
	      this.items += this.current();
	    }
	  }
	  
	  Repeat.prototype.current = function () {
	    return this._tokens[this._iterator];
	  };
	  
	  Repeat.prototype.getNext = function() {
	    return this._tokens[++this._iterator];
	  };
	  
	  Repeat.prototype.getValue = function() {
	    return this._tokens.join(' ');
	  };
	  
	  Repeat.prototype.hasNext = function () {
	    return this._iterator < this._tokens.length - 1;
	  };
	  
	  /**
	   * Get the value of an atribute given its normalized name.
	   *
	   * @param {jqLite} element - A jqLite element.
	   * @param {string} attr - The normalized name of the attribute.
	   * @returns {string} - The value of the attribute.
	   */
	  function getAttr(element, attr) {
	    var attrs = element.prop('attributes');
	    
	    for(var i = 0; i < attrs.length; i++) {
	      if(normalize(attrs.item(i).name) === attr) {
	        return attrs.item(i).value;
	      }
	    }
	    
	    return '';
	  }
	  
	  /**
	   * Normalizes an attribute's name.
	   *
	   * @param {string} attr - The original name of the attribute.
	   * @returns {string} - The normalized name of the attribute.
	   */
	  function normalize(attr) {
	    var tokens = attr.replace(/^((?:x|data)[\:\-_])/i, '').split(/[\:\-_]/);
	    var normal = tokens.shift();
	    
	    tokens.forEach(function (token) {
	      normal += token.charAt(0).toUpperCase() + token.slice(1);
	    });
	    
	    return normal;
	  }
	  
	  function parse(ngRepeat) {
	    if(!cache.hasOwnProperty(ngRepeat)) {
	      return (cache[ngRepeat] = new Repeat(ngRepeat));
	    }
	    
	    return cache[ngRepeat];
	  }
	  
	  return {
	    getAttr: getAttr,
	    normalize: normalize,
	    parse: parse
	  };
	  
	}
	
	angular.module('md.data.table').directive('mdSelectAll', mdSelectAll);
	
	function mdSelectAll() {
	  'use strict';
	  
	  function template(tElement) {
	    var checkbox = angular.element('<md-checkbox></md-checkbox>');
	    
	    checkbox.attr('aria-label', 'Select All');
	    checkbox.attr('ng-click', 'toggleAll()');
	    checkbox.attr('ng-class', 'mdClasses');
	    checkbox.attr('ng-checked', 'allSelected()');
	    checkbox.attr('ng-disabled', '!getCount()');
	    
	    tElement.append(checkbox);
	  }
	  
	  function postLink(scope, element, attrs, tableCtrl) {
	    var count = 0;
	    
	    var getSelectableItems = function() {
	      return scope.items.filter(function (item) {
	        return !tableCtrl.isDisabled(item);
	      });
	    };
	    
	    tableCtrl.isReady.body.promise.then(function () {
	      scope.mdClasses = tableCtrl.classes;
	      
	      scope.getCount = function() {
	        return (count = scope.items.reduce(function(sum, item) {
	          return tableCtrl.isDisabled(item) ? sum : ++sum;
	        }, 0));
	      };
	      
	      scope.allSelected = function () {
	        return count && count === tableCtrl.selectedItems.length;
	      };
	      
	      scope.toggleAll = function () {
	        var selectableItems = getSelectableItems(scope.items);
	        
	        if(selectableItems.length === tableCtrl.selectedItems.length) {
	          tableCtrl.selectedItems.splice(0);
	        } else {
	          tableCtrl.selectedItems = selectableItems;
	        }
	      };
	    });
	  }
	  
	  return {
	    link: postLink,
	    require: '^^mdDataTable',
	    scope: {
	      items: '=mdSelectAll'
	    },
	    template: template
	  };
	}
	
	
	angular.module('md.data.table').directive('mdSelectRow', mdSelectRow);
	
	function mdSelectRow($mdTable) {
	  'use strict';
	  
	  function template(tElement, tAttrs) {
	    var ngRepeat = $mdTable.parse(tAttrs.ngRepeat);
	    var checkbox = angular.element('<md-checkbox></md-checkbox>');
	    
	    checkbox.attr('aria-label', 'Select Row');
	    checkbox.attr('ng-click', 'toggleRow(' + ngRepeat.item + ', $event)');
	    checkbox.attr('ng-class', 'mdClasses');
	    checkbox.attr('ng-checked', 'isSelected(' + ngRepeat.item + ')');
	    
	    if(tAttrs.mdDisableSelect) {
	      checkbox.attr('ng-disabled', 'isDisabled()');
	    }
	    
	    tElement.prepend(angular.element('<td></td>').append(checkbox));
	    
	    if(angular.isDefined(tAttrs.mdAutoSelect)) {
	      tAttrs.$set('ngClick', 'toggleRow(' + ngRepeat.item + ', $event)');
	    }
	    
	    tAttrs.$set('ngClass', '{\'md-selected\': isSelected(' + ngRepeat.item + ')}');
	  }
	  
	  function postLink(scope, element, attrs, tableCtrl) {
	    var model = {};
	    var ngRepeat = $mdTable.parse(attrs.ngRepeat);
	    
	    if(!angular.isFunction(scope.isDisabled)) {
	      scope.isDisabled = function () { return false; };
	    }
	    
	    tableCtrl.isDisabled = function (item) {
	      model[ngRepeat.item] = item;
	      return scope.isDisabled(model);
	    };
	  }
	  
	  return {
	    link: postLink,
	    priority: 1001,
	    require: '^^mdDataTable',
	    scope: {
	      isDisabled: '&?mdDisableSelect'
	    },
	    template: template
	  };
	}
	
	mdSelectRow.$inject = ['$mdTable'];
	
	
	angular.module('md.table.templates', ['templates.arrow.html', 'templates.navigate-before.html', 'templates.navigate-first.html', 'templates.navigate-last.html', 'templates.navigate-next.html', 'templates.md-data-table-pagination.html', 'templates.md-data-table-progress.html']);
	
	angular.module('templates.arrow.html', []).run(['$templateCache', function($templateCache) {
	  'use strict';
	  $templateCache.put('templates.arrow.html',
	    '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M3,9 L4.06,10.06 L8.25,5.87 L8.25,15 L9.75,15 L9.75,5.87 L13.94,10.06 L15,9 L9,3 L3,9 L3,9 Z"/></svg>');
	}]);
	
	angular.module('templates.navigate-before.html', []).run(['$templateCache', function($templateCache) {
	  'use strict';
	  $templateCache.put('templates.navigate-before.html',
	    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>\n' +
	    '');
	}]);
	
	angular.module('templates.navigate-first.html', []).run(['$templateCache', function($templateCache) {
	  'use strict';
	  $templateCache.put('templates.navigate-first.html',
	    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7 6 v12 h2 v-12 h-2z M17.41 7.41L16 6l-6 6 6 6 1.41-1.41L12.83 12z"/></svg>\n' +
	    '');
	}]);
	
	angular.module('templates.navigate-last.html', []).run(['$templateCache', function($templateCache) {
	  'use strict';
	  $templateCache.put('templates.navigate-last.html',
	    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M15 6 v12 h2 v-12 h-2z M8 6L6.59 7.41 11.17 12l-4.58 4.59L8 18l6-6z"/></svg>\n' +
	    '');
	}]);
	
	angular.module('templates.navigate-next.html', []).run(['$templateCache', function($templateCache) {
	  'use strict';
	  $templateCache.put('templates.navigate-next.html',
	    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>\n' +
	    '');
	}]);
	
	angular.module('templates.md-data-table-pagination.html', []).run(['$templateCache', function($templateCache) {
	  'use strict';
	  $templateCache.put('templates.md-data-table-pagination.html',
	    '<div>\n' +
	    '  <span class="label">{{paginationLabel.text}}</span>\n' +
	    '  <md-select ng-model="limit" md-container-class="md-pagination-select" ng-change="onSelect()" aria-label="Row Count" placeholder="{{rowSelect ? rowSelect[0] : 5}}">\n' +
	    '    <md-option ng-repeat="rows in rowSelect ? rowSelect : [5, 10, 15]" ng-value="rows">{{rows}}</md-option>\n' +
	    '  </md-select>\n' +
	    '  <span>{{min()}} - {{max()}} {{paginationLabel.of}} {{total}}</span>\n' +
	    '</div>\n' +
	    '<div>\n' +
	    '  <md-button type="button" ng-click="first()" ng-disabled="!hasPrevious()" aria-label="First">\n' +
	    '    <md-icon md-svg-icon="templates.navigate-first.html"></md-icon>\n' +
	    '  </md-button>\n' +
	    '  <md-button type="button" ng-click="previous()" ng-disabled="!hasPrevious()" aria-label="Previous">\n' +
	    '    <md-icon md-svg-icon="templates.navigate-before.html"></md-icon>\n' +
	    '  </md-button>\n' +
	    '  <md-button type="button" ng-click="next()" ng-disabled="!hasNext()" aria-label="Next">\n' +
	    '    <md-icon md-svg-icon="templates.navigate-next.html"></md-icon>\n' +
	    '  </md-button>\n' +
	    '  <md-button type="button" ng-click="last()" ng-disabled="!hasNext()" aria-label="Last">\n' +
	    '    <md-icon md-svg-icon="templates.navigate-last.html"></md-icon>\n' +
	    '  </md-button>\n' +
	    '</div>\n' +
	    '');
	}]);
	
	angular.module('templates.md-data-table-progress.html', []).run(['$templateCache', function($templateCache) {
	  'use strict';
	  $templateCache.put('templates.md-data-table-progress.html',
	    '<thead ng-if="showProgress">\n' +
	    '  <tr>\n' +
	    '    <th colspan="{{getColumnCount()}}">\n' +
	    '      <md-progress-linear md-mode="indeterminate"></md-progress-linear>\n' +
	    '    </th>\n' +
	    '  </tr>\n' +
	    '</thead>');
	}]);


/***/ }),

/***/ 90:
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.6.4
	 * (c) 2010-2017 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	var forEach;
	var isArray;
	var isString;
	var jqLite;
	
	/**
	 * @ngdoc module
	 * @name ngMessages
	 * @description
	 *
	 * The `ngMessages` module provides enhanced support for displaying messages within templates
	 * (typically within forms or when rendering message objects that return key/value data).
	 * Instead of relying on JavaScript code and/or complex ng-if statements within your form template to
	 * show and hide error messages specific to the state of an input field, the `ngMessages` and
	 * `ngMessage` directives are designed to handle the complexity, inheritance and priority
	 * sequencing based on the order of how the messages are defined in the template.
	 *
	 * Currently, the ngMessages module only contains the code for the `ngMessages`, `ngMessagesInclude`
	 * `ngMessage` and `ngMessageExp` directives.
	 *
	 * # Usage
	 * The `ngMessages` directive allows keys in a key/value collection to be associated with a child element
	 * (or 'message') that will show or hide based on the truthiness of that key's value in the collection. A common use
	 * case for `ngMessages` is to display error messages for inputs using the `$error` object exposed by the
	 * {@link ngModel ngModel} directive.
	 *
	 * The child elements of the `ngMessages` directive are matched to the collection keys by a `ngMessage` or
	 * `ngMessageExp` directive. The value of these attributes must match a key in the collection that is provided by
	 * the `ngMessages` directive.
	 *
	 * Consider the following example, which illustrates a typical use case of `ngMessages`. Within the form `myForm` we
	 * have a text input named `myField` which is bound to the scope variable `field` using the {@link ngModel ngModel}
	 * directive.
	 *
	 * The `myField` field is a required input of type `email` with a maximum length of 15 characters.
	 *
	 * ```html
	 * <form name="myForm">
	 *   <label>
	 *     Enter text:
	 *     <input type="email" ng-model="field" name="myField" required maxlength="15" />
	 *   </label>
	 *   <div ng-messages="myForm.myField.$error" role="alert">
	 *     <div ng-message="required">Please enter a value for this field.</div>
	 *     <div ng-message="email">This field must be a valid email address.</div>
	 *     <div ng-message="maxlength">This field can be at most 15 characters long.</div>
	 *   </div>
	 * </form>
	 * ```
	 *
	 * In order to show error messages corresponding to `myField` we first create an element with an `ngMessages` attribute
	 * set to the `$error` object owned by the `myField` input in our `myForm` form.
	 *
	 * Within this element we then create separate elements for each of the possible errors that `myField` could have.
	 * The `ngMessage` attribute is used to declare which element(s) will appear for which error - for example,
	 * setting `ng-message="required"` specifies that this particular element should be displayed when there
	 * is no value present for the required field `myField` (because the key `required` will be `true` in the object
	 * `myForm.myField.$error`).
	 *
	 * ### Message order
	 *
	 * By default, `ngMessages` will only display one message for a particular key/value collection at any time. If more
	 * than one message (or error) key is currently true, then which message is shown is determined by the order of messages
	 * in the HTML template code (messages declared first are prioritised). This mechanism means the developer does not have
	 * to prioritize messages using custom JavaScript code.
	 *
	 * Given the following error object for our example (which informs us that the field `myField` currently has both the
	 * `required` and `email` errors):
	 *
	 * ```javascript
	 * <!-- keep in mind that ngModel automatically sets these error flags -->
	 * myField.$error = { required : true, email: true, maxlength: false };
	 * ```
	 * The `required` message will be displayed to the user since it appears before the `email` message in the DOM.
	 * Once the user types a single character, the `required` message will disappear (since the field now has a value)
	 * but the `email` message will be visible because it is still applicable.
	 *
	 * ### Displaying multiple messages at the same time
	 *
	 * While `ngMessages` will by default only display one error element at a time, the `ng-messages-multiple` attribute can
	 * be applied to the `ngMessages` container element to cause it to display all applicable error messages at once:
	 *
	 * ```html
	 * <!-- attribute-style usage -->
	 * <div ng-messages="myForm.myField.$error" ng-messages-multiple>...</div>
	 *
	 * <!-- element-style usage -->
	 * <ng-messages for="myForm.myField.$error" multiple>...</ng-messages>
	 * ```
	 *
	 * ## Reusing and Overriding Messages
	 * In addition to prioritization, ngMessages also allows for including messages from a remote or an inline
	 * template. This allows for generic collection of messages to be reused across multiple parts of an
	 * application.
	 *
	 * ```html
	 * <script type="text/ng-template" id="error-messages">
	 *   <div ng-message="required">This field is required</div>
	 *   <div ng-message="minlength">This field is too short</div>
	 * </script>
	 *
	 * <div ng-messages="myForm.myField.$error" role="alert">
	 *   <div ng-messages-include="error-messages"></div>
	 * </div>
	 * ```
	 *
	 * However, including generic messages may not be useful enough to match all input fields, therefore,
	 * `ngMessages` provides the ability to override messages defined in the remote template by redefining
	 * them within the directive container.
	 *
	 * ```html
	 * <!-- a generic template of error messages known as "my-custom-messages" -->
	 * <script type="text/ng-template" id="my-custom-messages">
	 *   <div ng-message="required">This field is required</div>
	 *   <div ng-message="minlength">This field is too short</div>
	 * </script>
	 *
	 * <form name="myForm">
	 *   <label>
	 *     Email address
	 *     <input type="email"
	 *            id="email"
	 *            name="myEmail"
	 *            ng-model="email"
	 *            minlength="5"
	 *            required />
	 *   </label>
	 *   <!-- any ng-message elements that appear BEFORE the ng-messages-include will
	 *        override the messages present in the ng-messages-include template -->
	 *   <div ng-messages="myForm.myEmail.$error" role="alert">
	 *     <!-- this required message has overridden the template message -->
	 *     <div ng-message="required">You did not enter your email address</div>
	 *
	 *     <!-- this is a brand new message and will appear last in the prioritization -->
	 *     <div ng-message="email">Your email address is invalid</div>
	 *
	 *     <!-- and here are the generic error messages -->
	 *     <div ng-messages-include="my-custom-messages"></div>
	 *   </div>
	 * </form>
	 * ```
	 *
	 * In the example HTML code above the message that is set on required will override the corresponding
	 * required message defined within the remote template. Therefore, with particular input fields (such
	 * email addresses, date fields, autocomplete inputs, etc...), specialized error messages can be applied
	 * while more generic messages can be used to handle other, more general input errors.
	 *
	 * ## Dynamic Messaging
	 * ngMessages also supports using expressions to dynamically change key values. Using arrays and
	 * repeaters to list messages is also supported. This means that the code below will be able to
	 * fully adapt itself and display the appropriate message when any of the expression data changes:
	 *
	 * ```html
	 * <form name="myForm">
	 *   <label>
	 *     Email address
	 *     <input type="email"
	 *            name="myEmail"
	 *            ng-model="email"
	 *            minlength="5"
	 *            required />
	 *   </label>
	 *   <div ng-messages="myForm.myEmail.$error" role="alert">
	 *     <div ng-message="required">You did not enter your email address</div>
	 *     <div ng-repeat="errorMessage in errorMessages">
	 *       <!-- use ng-message-exp for a message whose key is given by an expression -->
	 *       <div ng-message-exp="errorMessage.type">{{ errorMessage.text }}</div>
	 *     </div>
	 *   </div>
	 * </form>
	 * ```
	 *
	 * The `errorMessage.type` expression can be a string value or it can be an array so
	 * that multiple errors can be associated with a single error message:
	 *
	 * ```html
	 *   <label>
	 *     Email address
	 *     <input type="email"
	 *            ng-model="data.email"
	 *            name="myEmail"
	 *            ng-minlength="5"
	 *            ng-maxlength="100"
	 *            required />
	 *   </label>
	 *   <div ng-messages="myForm.myEmail.$error" role="alert">
	 *     <div ng-message-exp="'required'">You did not enter your email address</div>
	 *     <div ng-message-exp="['minlength', 'maxlength']">
	 *       Your email must be between 5 and 100 characters long
	 *     </div>
	 *   </div>
	 * ```
	 *
	 * Feel free to use other structural directives such as ng-if and ng-switch to further control
	 * what messages are active and when. Be careful, if you place ng-message on the same element
	 * as these structural directives, Angular may not be able to determine if a message is active
	 * or not. Therefore it is best to place the ng-message on a child element of the structural
	 * directive.
	 *
	 * ```html
	 * <div ng-messages="myForm.myEmail.$error" role="alert">
	 *   <div ng-if="showRequiredError">
	 *     <div ng-message="required">Please enter something</div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * ## Animations
	 * If the `ngAnimate` module is active within the application then the `ngMessages`, `ngMessage` and
	 * `ngMessageExp` directives will trigger animations whenever any messages are added and removed from
	 * the DOM by the `ngMessages` directive.
	 *
	 * Whenever the `ngMessages` directive contains one or more visible messages then the `.ng-active` CSS
	 * class will be added to the element. The `.ng-inactive` CSS class will be applied when there are no
	 * messages present. Therefore, CSS transitions and keyframes as well as JavaScript animations can
	 * hook into the animations whenever these classes are added/removed.
	 *
	 * Let's say that our HTML code for our messages container looks like so:
	 *
	 * ```html
	 * <div ng-messages="myMessages" class="my-messages" role="alert">
	 *   <div ng-message="alert" class="some-message">...</div>
	 *   <div ng-message="fail" class="some-message">...</div>
	 * </div>
	 * ```
	 *
	 * Then the CSS animation code for the message container looks like so:
	 *
	 * ```css
	 * .my-messages {
	 *   transition:1s linear all;
	 * }
	 * .my-messages.ng-active {
	 *   // messages are visible
	 * }
	 * .my-messages.ng-inactive {
	 *   // messages are hidden
	 * }
	 * ```
	 *
	 * Whenever an inner message is attached (becomes visible) or removed (becomes hidden) then the enter
	 * and leave animation is triggered for each particular element bound to the `ngMessage` directive.
	 *
	 * Therefore, the CSS code for the inner messages looks like so:
	 *
	 * ```css
	 * .some-message {
	 *   transition:1s linear all;
	 * }
	 *
	 * .some-message.ng-enter {}
	 * .some-message.ng-enter.ng-enter-active {}
	 *
	 * .some-message.ng-leave {}
	 * .some-message.ng-leave.ng-leave-active {}
	 * ```
	 *
	 * {@link ngAnimate Click here} to learn how to use JavaScript animations or to learn more about ngAnimate.
	 */
	angular.module('ngMessages', [], function initAngularHelpers() {
	  // Access helpers from angular core.
	  // Do it inside a `config` block to ensure `window.angular` is available.
	  forEach = angular.forEach;
	  isArray = angular.isArray;
	  isString = angular.isString;
	  jqLite = angular.element;
	})
	  .info({ angularVersion: '1.6.4' })
	
	  /**
	   * @ngdoc directive
	   * @module ngMessages
	   * @name ngMessages
	   * @restrict AE
	   *
	   * @description
	   * `ngMessages` is a directive that is designed to show and hide messages based on the state
	   * of a key/value object that it listens on. The directive itself complements error message
	   * reporting with the `ngModel` $error object (which stores a key/value state of validation errors).
	   *
	   * `ngMessages` manages the state of internal messages within its container element. The internal
	   * messages use the `ngMessage` directive and will be inserted/removed from the page depending
	   * on if they're present within the key/value object. By default, only one message will be displayed
	   * at a time and this depends on the prioritization of the messages within the template. (This can
	   * be changed by using the `ng-messages-multiple` or `multiple` attribute on the directive container.)
	   *
	   * A remote template can also be used to promote message reusability and messages can also be
	   * overridden.
	   *
	   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression" role="alert">
	   *   <ANY ng-message="stringValue">...</ANY>
	   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
	   *   <ANY ng-message-exp="expressionValue">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression" role="alert">
	   *   <ng-message when="stringValue">...</ng-message>
	   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
	   *   <ng-message when-exp="expressionValue">...</ng-message>
	   * </ng-messages>
	   * ```
	   *
	   * @param {string} ngMessages an angular expression evaluating to a key/value object
	   *                 (this is typically the $error object on an ngModel instance).
	   * @param {string=} ngMessagesMultiple|multiple when set, all messages will be displayed with true
	   *
	   * @example
	   * <example name="ngMessages-directive" module="ngMessagesExample"
	   *          deps="angular-messages.js"
	   *          animations="true" fixBase="true">
	   *   <file name="index.html">
	   *     <form name="myForm">
	   *       <label>
	   *         Enter your name:
	   *         <input type="text"
	   *                name="myName"
	   *                ng-model="name"
	   *                ng-minlength="5"
	   *                ng-maxlength="20"
	   *                required />
	   *       </label>
	   *       <pre>myForm.myName.$error = {{ myForm.myName.$error | json }}</pre>
	   *
	   *       <div ng-messages="myForm.myName.$error" style="color:maroon" role="alert">
	   *         <div ng-message="required">You did not enter a field</div>
	   *         <div ng-message="minlength">Your field is too short</div>
	   *         <div ng-message="maxlength">Your field is too long</div>
	   *       </div>
	   *     </form>
	   *   </file>
	   *   <file name="script.js">
	   *     angular.module('ngMessagesExample', ['ngMessages']);
	   *   </file>
	   * </example>
	   */
	  .directive('ngMessages', ['$animate', function($animate) {
	    var ACTIVE_CLASS = 'ng-active';
	    var INACTIVE_CLASS = 'ng-inactive';
	
	    return {
	      require: 'ngMessages',
	      restrict: 'AE',
	      controller: ['$element', '$scope', '$attrs', function NgMessagesCtrl($element, $scope, $attrs) {
	        var ctrl = this;
	        var latestKey = 0;
	        var nextAttachId = 0;
	
	        this.getAttachId = function getAttachId() { return nextAttachId++; };
	
	        var messages = this.messages = {};
	        var renderLater, cachedCollection;
	
	        this.render = function(collection) {
	          collection = collection || {};
	
	          renderLater = false;
	          cachedCollection = collection;
	
	          // this is true if the attribute is empty or if the attribute value is truthy
	          var multiple = isAttrTruthy($scope, $attrs.ngMessagesMultiple) ||
	                         isAttrTruthy($scope, $attrs.multiple);
	
	          var unmatchedMessages = [];
	          var matchedKeys = {};
	          var messageItem = ctrl.head;
	          var messageFound = false;
	          var totalMessages = 0;
	
	          // we use != instead of !== to allow for both undefined and null values
	          while (messageItem != null) {
	            totalMessages++;
	            var messageCtrl = messageItem.message;
	
	            var messageUsed = false;
	            if (!messageFound) {
	              forEach(collection, function(value, key) {
	                if (!messageUsed && truthy(value) && messageCtrl.test(key)) {
	                  // this is to prevent the same error name from showing up twice
	                  if (matchedKeys[key]) return;
	                  matchedKeys[key] = true;
	
	                  messageUsed = true;
	                  messageCtrl.attach();
	                }
	              });
	            }
	
	            if (messageUsed) {
	              // unless we want to display multiple messages then we should
	              // set a flag here to avoid displaying the next message in the list
	              messageFound = !multiple;
	            } else {
	              unmatchedMessages.push(messageCtrl);
	            }
	
	            messageItem = messageItem.next;
	          }
	
	          forEach(unmatchedMessages, function(messageCtrl) {
	            messageCtrl.detach();
	          });
	
	          if (unmatchedMessages.length !== totalMessages) {
	            $animate.setClass($element, ACTIVE_CLASS, INACTIVE_CLASS);
	          } else {
	            $animate.setClass($element, INACTIVE_CLASS, ACTIVE_CLASS);
	          }
	        };
	
	        $scope.$watchCollection($attrs.ngMessages || $attrs['for'], ctrl.render);
	
	        // If the element is destroyed, proactively destroy all the currently visible messages
	        $element.on('$destroy', function() {
	          forEach(messages, function(item) {
	            item.message.detach();
	          });
	        });
	
	        this.reRender = function() {
	          if (!renderLater) {
	            renderLater = true;
	            $scope.$evalAsync(function() {
	              if (renderLater && cachedCollection) {
	                ctrl.render(cachedCollection);
	              }
	            });
	          }
	        };
	
	        this.register = function(comment, messageCtrl) {
	          var nextKey = latestKey.toString();
	          messages[nextKey] = {
	            message: messageCtrl
	          };
	          insertMessageNode($element[0], comment, nextKey);
	          comment.$$ngMessageNode = nextKey;
	          latestKey++;
	
	          ctrl.reRender();
	        };
	
	        this.deregister = function(comment) {
	          var key = comment.$$ngMessageNode;
	          delete comment.$$ngMessageNode;
	          removeMessageNode($element[0], comment, key);
	          delete messages[key];
	          ctrl.reRender();
	        };
	
	        function findPreviousMessage(parent, comment) {
	          var prevNode = comment;
	          var parentLookup = [];
	
	          while (prevNode && prevNode !== parent) {
	            var prevKey = prevNode.$$ngMessageNode;
	            if (prevKey && prevKey.length) {
	              return messages[prevKey];
	            }
	
	            // dive deeper into the DOM and examine its children for any ngMessage
	            // comments that may be in an element that appears deeper in the list
	            if (prevNode.childNodes.length && parentLookup.indexOf(prevNode) === -1) {
	              parentLookup.push(prevNode);
	              prevNode = prevNode.childNodes[prevNode.childNodes.length - 1];
	            } else if (prevNode.previousSibling) {
	              prevNode = prevNode.previousSibling;
	            } else {
	              prevNode = prevNode.parentNode;
	              parentLookup.push(prevNode);
	            }
	          }
	        }
	
	        function insertMessageNode(parent, comment, key) {
	          var messageNode = messages[key];
	          if (!ctrl.head) {
	            ctrl.head = messageNode;
	          } else {
	            var match = findPreviousMessage(parent, comment);
	            if (match) {
	              messageNode.next = match.next;
	              match.next = messageNode;
	            } else {
	              messageNode.next = ctrl.head;
	              ctrl.head = messageNode;
	            }
	          }
	        }
	
	        function removeMessageNode(parent, comment, key) {
	          var messageNode = messages[key];
	
	          var match = findPreviousMessage(parent, comment);
	          if (match) {
	            match.next = messageNode.next;
	          } else {
	            ctrl.head = messageNode.next;
	          }
	        }
	      }]
	    };
	
	    function isAttrTruthy(scope, attr) {
	     return (isString(attr) && attr.length === 0) || //empty attribute
	            truthy(scope.$eval(attr));
	    }
	
	    function truthy(val) {
	      return isString(val) ? val.length : !!val;
	    }
	  }])
	
	  /**
	   * @ngdoc directive
	   * @name ngMessagesInclude
	   * @restrict AE
	   * @scope
	   *
	   * @description
	   * `ngMessagesInclude` is a directive with the purpose to import existing ngMessage template
	   * code from a remote template and place the downloaded template code into the exact spot
	   * that the ngMessagesInclude directive is placed within the ngMessages container. This allows
	   * for a series of pre-defined messages to be reused and also allows for the developer to
	   * determine what messages are overridden due to the placement of the ngMessagesInclude directive.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression" role="alert">
	   *   <ANY ng-messages-include="remoteTplString">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression" role="alert">
	   *   <ng-messages-include src="expressionValue1">...</ng-messages-include>
	   * </ng-messages>
	   * ```
	   *
	   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
	   *
	   * @param {string} ngMessagesInclude|src a string value corresponding to the remote template.
	   */
	  .directive('ngMessagesInclude',
	    ['$templateRequest', '$document', '$compile', function($templateRequest, $document, $compile) {
	
	    return {
	      restrict: 'AE',
	      require: '^^ngMessages', // we only require this for validation sake
	      link: function($scope, element, attrs) {
	        var src = attrs.ngMessagesInclude || attrs.src;
	        $templateRequest(src).then(function(html) {
	          if ($scope.$$destroyed) return;
	
	          if (isString(html) && !html.trim()) {
	            // Empty template - nothing to compile
	            replaceElementWithMarker(element, src);
	          } else {
	            // Non-empty template - compile and link
	            $compile(html)($scope, function(contents) {
	              element.after(contents);
	              replaceElementWithMarker(element, src);
	            });
	          }
	        });
	      }
	    };
	
	    // Helpers
	    function replaceElementWithMarker(element, src) {
	      // A comment marker is placed for debugging purposes
	      var comment = $compile.$$createComment ?
	          $compile.$$createComment('ngMessagesInclude', src) :
	          $document[0].createComment(' ngMessagesInclude: ' + src + ' ');
	      var marker = jqLite(comment);
	      element.after(marker);
	
	      // Don't pollute the DOM anymore by keeping an empty directive element
	      element.remove();
	    }
	  }])
	
	  /**
	   * @ngdoc directive
	   * @name ngMessage
	   * @restrict AE
	   * @scope
	   *
	   * @description
	   * `ngMessage` is a directive with the purpose to show and hide a particular message.
	   * For `ngMessage` to operate, a parent `ngMessages` directive on a parent DOM element
	   * must be situated since it determines which messages are visible based on the state
	   * of the provided key/value map that `ngMessages` listens on.
	   *
	   * More information about using `ngMessage` can be found in the
	   * {@link module:ngMessages `ngMessages` module documentation}.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression" role="alert">
	   *   <ANY ng-message="stringValue">...</ANY>
	   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression" role="alert">
	   *   <ng-message when="stringValue">...</ng-message>
	   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
	   * </ng-messages>
	   * ```
	   *
	   * @param {expression} ngMessage|when a string value corresponding to the message key.
	   */
	  .directive('ngMessage', ngMessageDirectiveFactory())
	
	
	  /**
	   * @ngdoc directive
	   * @name ngMessageExp
	   * @restrict AE
	   * @priority 1
	   * @scope
	   *
	   * @description
	   * `ngMessageExp` is the same as {@link directive:ngMessage `ngMessage`}, but instead of a static
	   * value, it accepts an expression to be evaluated for the message key.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression">
	   *   <ANY ng-message-exp="expressionValue">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression">
	   *   <ng-message when-exp="expressionValue">...</ng-message>
	   * </ng-messages>
	   * ```
	   *
	   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
	   *
	   * @param {expression} ngMessageExp|whenExp an expression value corresponding to the message key.
	   */
	  .directive('ngMessageExp', ngMessageDirectiveFactory());
	
	function ngMessageDirectiveFactory() {
	  return ['$animate', function($animate) {
	    return {
	      restrict: 'AE',
	      transclude: 'element',
	      priority: 1, // must run before ngBind, otherwise the text is set on the comment
	      terminal: true,
	      require: '^^ngMessages',
	      link: function(scope, element, attrs, ngMessagesCtrl, $transclude) {
	        var commentNode = element[0];
	
	        var records;
	        var staticExp = attrs.ngMessage || attrs.when;
	        var dynamicExp = attrs.ngMessageExp || attrs.whenExp;
	        var assignRecords = function(items) {
	          records = items
	              ? (isArray(items)
	                  ? items
	                  : items.split(/[\s,]+/))
	              : null;
	          ngMessagesCtrl.reRender();
	        };
	
	        if (dynamicExp) {
	          assignRecords(scope.$eval(dynamicExp));
	          scope.$watchCollection(dynamicExp, assignRecords);
	        } else {
	          assignRecords(staticExp);
	        }
	
	        var currentElement, messageCtrl;
	        ngMessagesCtrl.register(commentNode, messageCtrl = {
	          test: function(name) {
	            return contains(records, name);
	          },
	          attach: function() {
	            if (!currentElement) {
	              $transclude(function(elm, newScope) {
	                $animate.enter(elm, null, element);
	                currentElement = elm;
	
	                // Each time we attach this node to a message we get a new id that we can match
	                // when we are destroying the node later.
	                var $$attachId = currentElement.$$attachId = ngMessagesCtrl.getAttachId();
	
	                // in the event that the element or a parent element is destroyed
	                // by another structural directive then it's time
	                // to deregister the message from the controller
	                currentElement.on('$destroy', function() {
	                  if (currentElement && currentElement.$$attachId === $$attachId) {
	                    ngMessagesCtrl.deregister(commentNode);
	                    messageCtrl.detach();
	                  }
	                  newScope.$destroy();
	                });
	              });
	            }
	          },
	          detach: function() {
	            if (currentElement) {
	              var elm = currentElement;
	              currentElement = null;
	              $animate.leave(elm);
	            }
	          }
	        });
	      }
	    };
	  }];
	
	  function contains(collection, key) {
	    if (collection) {
	      return isArray(collection)
	          ? collection.indexOf(key) >= 0
	          : collection.hasOwnProperty(key);
	    }
	  }
	}
	
	
	})(window, window.angular);


/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(90);
	module.exports = 'ngMessages';


/***/ }),

/***/ 92:
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.6.4
	 * (c) 2010-2017 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $sanitizeMinErr = angular.$$minErr('$sanitize');
	var bind;
	var extend;
	var forEach;
	var isDefined;
	var lowercase;
	var noop;
	var nodeContains;
	var htmlParser;
	var htmlSanitizeWriter;
	
	/**
	 * @ngdoc module
	 * @name ngSanitize
	 * @description
	 *
	 * # ngSanitize
	 *
	 * The `ngSanitize` module provides functionality to sanitize HTML.
	 *
	 *
	 * <div doc-module-components="ngSanitize"></div>
	 *
	 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
	 */
	
	/**
	 * @ngdoc service
	 * @name $sanitize
	 * @kind function
	 *
	 * @description
	 *   Sanitizes an html string by stripping all potentially dangerous tokens.
	 *
	 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a whitelist) are
	 *   then serialized back to properly escaped html string. This means that no unsafe input can make
	 *   it into the returned string.
	 *
	 *   The whitelist for URL sanitization of attribute values is configured using the functions
	 *   `aHrefSanitizationWhitelist` and `imgSrcSanitizationWhitelist` of {@link ng.$compileProvider
	 *   `$compileProvider`}.
	 *
	 *   The input may also contain SVG markup if this is enabled via {@link $sanitizeProvider}.
	 *
	 * @param {string} html HTML input.
	 * @returns {string} Sanitized HTML.
	 *
	 * @example
	   <example module="sanitizeExample" deps="angular-sanitize.js" name="sanitize-service">
	   <file name="index.html">
	     <script>
	         angular.module('sanitizeExample', ['ngSanitize'])
	           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
	             $scope.snippet =
	               '<p style="color:blue">an html\n' +
	               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
	               'snippet</p>';
	             $scope.deliberatelyTrustDangerousSnippet = function() {
	               return $sce.trustAsHtml($scope.snippet);
	             };
	           }]);
	     </script>
	     <div ng-controller="ExampleController">
	        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <td>Directive</td>
	           <td>How</td>
	           <td>Source</td>
	           <td>Rendered</td>
	         </tr>
	         <tr id="bind-html-with-sanitize">
	           <td>ng-bind-html</td>
	           <td>Automatically uses $sanitize</td>
	           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind-html="snippet"></div></td>
	         </tr>
	         <tr id="bind-html-with-trust">
	           <td>ng-bind-html</td>
	           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
	           <td>
	           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
	&lt;/div&gt;</pre>
	           </td>
	           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
	         </tr>
	         <tr id="bind-default">
	           <td>ng-bind</td>
	           <td>Automatically escapes</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	       </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should sanitize the html snippet by default', function() {
	       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
	         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
	     });
	
	     it('should inline raw snippet if bound to a trusted value', function() {
	       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).
	         toBe("<p style=\"color:blue\">an html\n" +
	              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
	              "snippet</p>");
	     });
	
	     it('should escape snippet without any filter', function() {
	       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).
	         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
	              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
	              "snippet&lt;/p&gt;");
	     });
	
	     it('should update', function() {
	       element(by.model('snippet')).clear();
	       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
	         toBe('new <b>text</b>');
	       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).toBe(
	         'new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).toBe(
	         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
	     });
	   </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $sanitizeProvider
	 * @this
	 *
	 * @description
	 * Creates and configures {@link $sanitize} instance.
	 */
	function $SanitizeProvider() {
	  var svgEnabled = false;
	
	  this.$get = ['$$sanitizeUri', function($$sanitizeUri) {
	    if (svgEnabled) {
	      extend(validElements, svgElements);
	    }
	    return function(html) {
	      var buf = [];
	      htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
	        return !/^unsafe:/.test($$sanitizeUri(uri, isImage));
	      }));
	      return buf.join('');
	    };
	  }];
	
	
	  /**
	   * @ngdoc method
	   * @name $sanitizeProvider#enableSvg
	   * @kind function
	   *
	   * @description
	   * Enables a subset of svg to be supported by the sanitizer.
	   *
	   * <div class="alert alert-warning">
	   *   <p>By enabling this setting without taking other precautions, you might expose your
	   *   application to click-hijacking attacks. In these attacks, sanitized svg elements could be positioned
	   *   outside of the containing element and be rendered over other elements on the page (e.g. a login
	   *   link). Such behavior can then result in phishing incidents.</p>
	   *
	   *   <p>To protect against these, explicitly setup `overflow: hidden` css rule for all potential svg
	   *   tags within the sanitized content:</p>
	   *
	   *   <br>
	   *
	   *   <pre><code>
	   *   .rootOfTheIncludedContent svg {
	   *     overflow: hidden !important;
	   *   }
	   *   </code></pre>
	   * </div>
	   *
	   * @param {boolean=} flag Enable or disable SVG support in the sanitizer.
	   * @returns {boolean|ng.$sanitizeProvider} Returns the currently configured value if called
	   *    without an argument or self for chaining otherwise.
	   */
	  this.enableSvg = function(enableSvg) {
	    if (isDefined(enableSvg)) {
	      svgEnabled = enableSvg;
	      return this;
	    } else {
	      return svgEnabled;
	    }
	  };
	
	  //////////////////////////////////////////////////////////////////////////////////////////////////
	  // Private stuff
	  //////////////////////////////////////////////////////////////////////////////////////////////////
	
	  bind = angular.bind;
	  extend = angular.extend;
	  forEach = angular.forEach;
	  isDefined = angular.isDefined;
	  lowercase = angular.lowercase;
	  noop = angular.noop;
	
	  htmlParser = htmlParserImpl;
	  htmlSanitizeWriter = htmlSanitizeWriterImpl;
	
	  nodeContains = window.Node.prototype.contains || /** @this */ function(arg) {
	    // eslint-disable-next-line no-bitwise
	    return !!(this.compareDocumentPosition(arg) & 16);
	  };
	
	  // Regular Expressions for parsing tags and attributes
	  var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
	    // Match everything outside of normal chars and " (quote character)
	    NON_ALPHANUMERIC_REGEXP = /([^#-~ |!])/g;
	
	
	  // Good source of info about elements and attributes
	  // http://dev.w3.org/html5/spec/Overview.html#semantics
	  // http://simon.html5.org/html-elements
	
	  // Safe Void Elements - HTML5
	  // http://dev.w3.org/html5/spec/Overview.html#void-elements
	  var voidElements = toMap('area,br,col,hr,img,wbr');
	
	  // Elements that you can, intentionally, leave open (and which close themselves)
	  // http://dev.w3.org/html5/spec/Overview.html#optional-tags
	  var optionalEndTagBlockElements = toMap('colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr'),
	      optionalEndTagInlineElements = toMap('rp,rt'),
	      optionalEndTagElements = extend({},
	                                              optionalEndTagInlineElements,
	                                              optionalEndTagBlockElements);
	
	  // Safe Block Elements - HTML5
	  var blockElements = extend({}, optionalEndTagBlockElements, toMap('address,article,' +
	          'aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,' +
	          'h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,section,table,ul'));
	
	  // Inline Elements - HTML5
	  var inlineElements = extend({}, optionalEndTagInlineElements, toMap('a,abbr,acronym,b,' +
	          'bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s,' +
	          'samp,small,span,strike,strong,sub,sup,time,tt,u,var'));
	
	  // SVG Elements
	  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
	  // Note: the elements animate,animateColor,animateMotion,animateTransform,set are intentionally omitted.
	  // They can potentially allow for arbitrary javascript to be executed. See #11290
	  var svgElements = toMap('circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,' +
	          'hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,' +
	          'radialGradient,rect,stop,svg,switch,text,title,tspan');
	
	  // Blocked Elements (will be stripped)
	  var blockedElements = toMap('script,style');
	
	  var validElements = extend({},
	                                     voidElements,
	                                     blockElements,
	                                     inlineElements,
	                                     optionalEndTagElements);
	
	  //Attributes that have href and hence need to be sanitized
	  var uriAttrs = toMap('background,cite,href,longdesc,src,xlink:href');
	
	  var htmlAttrs = toMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' +
	      'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' +
	      'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' +
	      'scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,' +
	      'valign,value,vspace,width');
	
	  // SVG attributes (without "id" and "name" attributes)
	  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
	  var svgAttrs = toMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' +
	      'baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,' +
	      'cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,' +
	      'font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,' +
	      'height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,' +
	      'marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,' +
	      'max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,' +
	      'path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,' +
	      'requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,' +
	      'stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,' +
	      'stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,' +
	      'stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,' +
	      'underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,' +
	      'width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,' +
	      'xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan', true);
	
	  var validAttrs = extend({},
	                                  uriAttrs,
	                                  svgAttrs,
	                                  htmlAttrs);
	
	  function toMap(str, lowercaseKeys) {
	    var obj = {}, items = str.split(','), i;
	    for (i = 0; i < items.length; i++) {
	      obj[lowercaseKeys ? lowercase(items[i]) : items[i]] = true;
	    }
	    return obj;
	  }
	
	  var inertBodyElement;
	  (function(window) {
	    var doc;
	    if (window.document && window.document.implementation) {
	      doc = window.document.implementation.createHTMLDocument('inert');
	    } else {
	      throw $sanitizeMinErr('noinert', 'Can\'t create an inert html document');
	    }
	    var docElement = doc.documentElement || doc.getDocumentElement();
	    var bodyElements = docElement.getElementsByTagName('body');
	
	    // usually there should be only one body element in the document, but IE doesn't have any, so we need to create one
	    if (bodyElements.length === 1) {
	      inertBodyElement = bodyElements[0];
	    } else {
	      var html = doc.createElement('html');
	      inertBodyElement = doc.createElement('body');
	      html.appendChild(inertBodyElement);
	      doc.appendChild(html);
	    }
	  })(window);
	
	  /**
	   * @example
	   * htmlParser(htmlString, {
	   *     start: function(tag, attrs) {},
	   *     end: function(tag) {},
	   *     chars: function(text) {},
	   *     comment: function(text) {}
	   * });
	   *
	   * @param {string} html string
	   * @param {object} handler
	   */
	  function htmlParserImpl(html, handler) {
	    if (html === null || html === undefined) {
	      html = '';
	    } else if (typeof html !== 'string') {
	      html = '' + html;
	    }
	    inertBodyElement.innerHTML = html;
	
	    //mXSS protection
	    var mXSSAttempts = 5;
	    do {
	      if (mXSSAttempts === 0) {
	        throw $sanitizeMinErr('uinput', 'Failed to sanitize html because the input is unstable');
	      }
	      mXSSAttempts--;
	
	      // strip custom-namespaced attributes on IE<=11
	      if (window.document.documentMode) {
	        stripCustomNsAttrs(inertBodyElement);
	      }
	      html = inertBodyElement.innerHTML; //trigger mXSS
	      inertBodyElement.innerHTML = html;
	    } while (html !== inertBodyElement.innerHTML);
	
	    var node = inertBodyElement.firstChild;
	    while (node) {
	      switch (node.nodeType) {
	        case 1: // ELEMENT_NODE
	          handler.start(node.nodeName.toLowerCase(), attrToMap(node.attributes));
	          break;
	        case 3: // TEXT NODE
	          handler.chars(node.textContent);
	          break;
	      }
	
	      var nextNode;
	      if (!(nextNode = node.firstChild)) {
	        if (node.nodeType === 1) {
	          handler.end(node.nodeName.toLowerCase());
	        }
	        nextNode = getNonDescendant('nextSibling', node);
	        if (!nextNode) {
	          while (nextNode == null) {
	            node = getNonDescendant('parentNode', node);
	            if (node === inertBodyElement) break;
	            nextNode = getNonDescendant('nextSibling', node);
	            if (node.nodeType === 1) {
	              handler.end(node.nodeName.toLowerCase());
	            }
	          }
	        }
	      }
	      node = nextNode;
	    }
	
	    while ((node = inertBodyElement.firstChild)) {
	      inertBodyElement.removeChild(node);
	    }
	  }
	
	  function attrToMap(attrs) {
	    var map = {};
	    for (var i = 0, ii = attrs.length; i < ii; i++) {
	      var attr = attrs[i];
	      map[attr.name] = attr.value;
	    }
	    return map;
	  }
	
	
	  /**
	   * Escapes all potentially dangerous characters, so that the
	   * resulting string can be safely inserted into attribute or
	   * element text.
	   * @param value
	   * @returns {string} escaped text
	   */
	  function encodeEntities(value) {
	    return value.
	      replace(/&/g, '&amp;').
	      replace(SURROGATE_PAIR_REGEXP, function(value) {
	        var hi = value.charCodeAt(0);
	        var low = value.charCodeAt(1);
	        return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
	      }).
	      replace(NON_ALPHANUMERIC_REGEXP, function(value) {
	        return '&#' + value.charCodeAt(0) + ';';
	      }).
	      replace(/</g, '&lt;').
	      replace(/>/g, '&gt;');
	  }
	
	  /**
	   * create an HTML/XML writer which writes to buffer
	   * @param {Array} buf use buf.join('') to get out sanitized html string
	   * @returns {object} in the form of {
	   *     start: function(tag, attrs) {},
	   *     end: function(tag) {},
	   *     chars: function(text) {},
	   *     comment: function(text) {}
	   * }
	   */
	  function htmlSanitizeWriterImpl(buf, uriValidator) {
	    var ignoreCurrentElement = false;
	    var out = bind(buf, buf.push);
	    return {
	      start: function(tag, attrs) {
	        tag = lowercase(tag);
	        if (!ignoreCurrentElement && blockedElements[tag]) {
	          ignoreCurrentElement = tag;
	        }
	        if (!ignoreCurrentElement && validElements[tag] === true) {
	          out('<');
	          out(tag);
	          forEach(attrs, function(value, key) {
	            var lkey = lowercase(key);
	            var isImage = (tag === 'img' && lkey === 'src') || (lkey === 'background');
	            if (validAttrs[lkey] === true &&
	              (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
	              out(' ');
	              out(key);
	              out('="');
	              out(encodeEntities(value));
	              out('"');
	            }
	          });
	          out('>');
	        }
	      },
	      end: function(tag) {
	        tag = lowercase(tag);
	        if (!ignoreCurrentElement && validElements[tag] === true && voidElements[tag] !== true) {
	          out('</');
	          out(tag);
	          out('>');
	        }
	        // eslint-disable-next-line eqeqeq
	        if (tag == ignoreCurrentElement) {
	          ignoreCurrentElement = false;
	        }
	      },
	      chars: function(chars) {
	        if (!ignoreCurrentElement) {
	          out(encodeEntities(chars));
	        }
	      }
	    };
	  }
	
	
	  /**
	   * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1' attribute to declare
	   * ns1 namespace and prefixes the attribute with 'ns1' (e.g. 'ns1:xlink:foo'). This is undesirable since we don't want
	   * to allow any of these custom attributes. This method strips them all.
	   *
	   * @param node Root element to process
	   */
	  function stripCustomNsAttrs(node) {
	    while (node) {
	      if (node.nodeType === window.Node.ELEMENT_NODE) {
	        var attrs = node.attributes;
	        for (var i = 0, l = attrs.length; i < l; i++) {
	          var attrNode = attrs[i];
	          var attrName = attrNode.name.toLowerCase();
	          if (attrName === 'xmlns:ns1' || attrName.lastIndexOf('ns1:', 0) === 0) {
	            node.removeAttributeNode(attrNode);
	            i--;
	            l--;
	          }
	        }
	      }
	
	      var nextNode = node.firstChild;
	      if (nextNode) {
	        stripCustomNsAttrs(nextNode);
	      }
	
	      node = getNonDescendant('nextSibling', node);
	    }
	  }
	
	  function getNonDescendant(propName, node) {
	    // An element is clobbered if its `propName` property points to one of its descendants
	    var nextNode = node[propName];
	    if (nextNode && nodeContains.call(node, nextNode)) {
	      throw $sanitizeMinErr('elclob', 'Failed to sanitize html because the element is clobbered: {0}', node.outerHTML || node.outerText);
	    }
	    return nextNode;
	  }
	}
	
	function sanitizeText(chars) {
	  var buf = [];
	  var writer = htmlSanitizeWriter(buf, noop);
	  writer.chars(chars);
	  return buf.join('');
	}
	
	
	// define ngSanitize module and register $sanitize service
	angular.module('ngSanitize', [])
	  .provider('$sanitize', $SanitizeProvider)
	  .info({ angularVersion: '1.6.4' });
	
	/**
	 * @ngdoc filter
	 * @name linky
	 * @kind function
	 *
	 * @description
	 * Finds links in text input and turns them into html links. Supports `http/https/ftp/mailto` and
	 * plain email address links.
	 *
	 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
	 *
	 * @param {string} text Input text.
	 * @param {string} target Window (`_blank|_self|_parent|_top`) or named frame to open links in.
	 * @param {object|function(url)} [attributes] Add custom attributes to the link element.
	 *
	 *    Can be one of:
	 *
	 *    - `object`: A map of attributes
	 *    - `function`: Takes the url as a parameter and returns a map of attributes
	 *
	 *    If the map of attributes contains a value for `target`, it overrides the value of
	 *    the target parameter.
	 *
	 *
	 * @returns {string} Html-linkified and {@link $sanitize sanitized} text.
	 *
	 * @usage
	   <span ng-bind-html="linky_expression | linky"></span>
	 *
	 * @example
	   <example module="linkyExample" deps="angular-sanitize.js" name="linky-filter">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <th>Filter</th>
	           <th>Source</th>
	           <th>Rendered</th>
	         </tr>
	         <tr id="linky-filter">
	           <td>linky filter</td>
	           <td>
	             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
	           </td>
	           <td>
	             <div ng-bind-html="snippet | linky"></div>
	           </td>
	         </tr>
	         <tr id="linky-target">
	          <td>linky target</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithSingleURL | linky:'_blank'"></div>
	          </td>
	         </tr>
	         <tr id="linky-custom-attributes">
	          <td>linky custom attributes</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"></div>
	          </td>
	         </tr>
	         <tr id="escaped-html">
	           <td>no filter</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	     </file>
	     <file name="script.js">
	       angular.module('linkyExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.snippet =
	             'Pretty text with some links:\n' +
	             'http://angularjs.org/,\n' +
	             'mailto:us@somewhere.org,\n' +
	             'another@somewhere.org,\n' +
	             'and one more: ftp://127.0.0.1/.';
	           $scope.snippetWithSingleURL = 'http://angularjs.org/';
	         }]);
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should linkify the snippet with urls', function() {
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
	       });
	
	       it('should not linkify snippet without the linky filter', function() {
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
	       });
	
	       it('should update', function() {
	         element(by.model('snippet')).clear();
	         element(by.model('snippet')).sendKeys('new http://link.');
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('new http://link.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
	             .toBe('new http://link.');
	       });
	
	       it('should work with the target property', function() {
	        expect(element(by.id('linky-target')).
	            element(by.binding("snippetWithSingleURL | linky:'_blank'")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
	       });
	
	       it('should optionally add custom attributes', function() {
	        expect(element(by.id('linky-custom-attributes')).
	            element(by.binding("snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-custom-attributes a')).getAttribute('rel')).toEqual('nofollow');
	       });
	     </file>
	   </example>
	 */
	angular.module('ngSanitize').filter('linky', ['$sanitize', function($sanitize) {
	  var LINKY_URL_REGEXP =
	        /((ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,
	      MAILTO_REGEXP = /^mailto:/i;
	
	  var linkyMinErr = angular.$$minErr('linky');
	  var isDefined = angular.isDefined;
	  var isFunction = angular.isFunction;
	  var isObject = angular.isObject;
	  var isString = angular.isString;
	
	  return function(text, target, attributes) {
	    if (text == null || text === '') return text;
	    if (!isString(text)) throw linkyMinErr('notstring', 'Expected string but received: {0}', text);
	
	    var attributesFn =
	      isFunction(attributes) ? attributes :
	      isObject(attributes) ? function getAttributesObject() {return attributes;} :
	      function getEmptyAttributesObject() {return {};};
	
	    var match;
	    var raw = text;
	    var html = [];
	    var url;
	    var i;
	    while ((match = raw.match(LINKY_URL_REGEXP))) {
	      // We can not end in these as they are sometimes found at the end of the sentence
	      url = match[0];
	      // if we did not match ftp/http/www/mailto then assume mailto
	      if (!match[2] && !match[4]) {
	        url = (match[3] ? 'http://' : 'mailto:') + url;
	      }
	      i = match.index;
	      addText(raw.substr(0, i));
	      addLink(url, match[0].replace(MAILTO_REGEXP, ''));
	      raw = raw.substring(i + match[0].length);
	    }
	    addText(raw);
	    return $sanitize(html.join(''));
	
	    function addText(text) {
	      if (!text) {
	        return;
	      }
	      html.push(sanitizeText(text));
	    }
	
	    function addLink(url, text) {
	      var key, linkAttributes = attributesFn(url);
	      html.push('<a ');
	
	      for (key in linkAttributes) {
	        html.push(key + '="' + linkAttributes[key] + '" ');
	      }
	
	      if (isDefined(target) && !('target' in linkAttributes)) {
	        html.push('target="',
	                  target,
	                  '" ');
	      }
	      html.push('href="',
	                url.replace(/"/g, '&quot;'),
	                '">');
	      addText(text);
	      html.push('</a>');
	    }
	  };
	}]);
	
	
	})(window, window.angular);


/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(92);
	module.exports = 'ngSanitize';


/***/ }),

/***/ 94:
/***/ (function(module, exports) {

	(function(window, angular, undefined) {'use strict';
	
	/**
	 * @ngdoc overview
	 * @name angulartics.google.analytics
	 * Enables analytics support for Google Analytics (http://google.com/analytics)
	 */
	angular.module('angulartics.google.analytics', ['angulartics'])
	.config(['$analyticsProvider', function ($analyticsProvider) {
	
	  // GA already supports buffered invocations so we don't need
	  // to wrap these inside angulartics.waitForVendorApi
	
	  $analyticsProvider.settings.pageTracking.trackRelativePath = true;
	
	  // Set the default settings for this module
	  $analyticsProvider.settings.ga = {
	    // array of additional account names (only works for analyticsjs)
	    additionalAccountNames: undefined,
	    userId: null
	  };
	
	  function setDimensionsAndMetrics(properties) {
	    if (window.ga) {
	      // add custom dimensions and metrics
	      for(var idx = 1; idx<=200;idx++) {
	        if (properties['dimension' +idx.toString()]) {
	          ga('set', 'dimension' +idx.toString(), properties['dimension' +idx.toString()]);
	        }
	        if (properties['metric' +idx.toString()]) {
	          ga('set', 'metric' +idx.toString(), properties['metric' +idx.toString()]);
	        }
	      }
	    }
	  }
	
	  $analyticsProvider.registerPageTrack(function (path) {
	    if (window._gaq) {
	      _gaq.push(['_trackPageview', path]);
	      angular.forEach($analyticsProvider.settings.ga.additionalAccountNames, function (accountName){
	        _gaq.push([accountName + '._trackPageview', path]);
	      });
	    }
	    if (window.ga) {
	      if ($analyticsProvider.settings.ga.userId) {
	        ga('set', '&uid', $analyticsProvider.settings.ga.userId);
	      }
	      ga('send', 'pageview', path);
	      angular.forEach($analyticsProvider.settings.ga.additionalAccountNames, function (accountName){
	        ga(accountName +'.send', 'pageview', path);
	      });
	    }
	  });
	
	  /**
	   * Track Event in GA
	   * @name eventTrack
	   *
	   * @param {string} action Required 'action' (string) associated with the event
	   * @param {object} properties Comprised of the mandatory field 'category' (string) and optional  fields 'label' (string), 'value' (integer) and 'noninteraction' (boolean)
	   *
	   * @link https://developers.google.com/analytics/devguides/collection/gajs/eventTrackerGuide#SettingUpEventTracking
	   *
	   * @link https://developers.google.com/analytics/devguides/collection/analyticsjs/events
	   */
	  $analyticsProvider.registerEventTrack(function (action, properties) {
	
	    // Google Analytics requires an Event Category
	    if (!properties || !properties.category) {
	      properties = properties || {};
	      properties.category = 'Event';
	    }
	    // GA requires that eventValue be an integer, see:
	    // https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#eventValue
	    // https://github.com/luisfarzati/angulartics/issues/81
	    if (properties.value) {
	      var parsed = parseInt(properties.value, 10);
	      properties.value = isNaN(parsed) ? 0 : parsed;
	    }
	
	    if (window.ga) {
	
	      var eventOptions = {
	        eventCategory: properties.category,
	        eventAction: action,
	        eventLabel: properties.label,
	        eventValue: properties.value,
	        nonInteraction: properties.noninteraction,
	        page: properties.page || window.location.hash.substring(1) || window.location.pathname,
	        userId: $analyticsProvider.settings.ga.userId
	      };
	
	      // add custom dimensions and metrics
	      setDimensionsAndMetrics(properties);
	
	      if ($analyticsProvider.settings.ga.transport) {
	        ga('send', 'event', eventOptions, { transport: $analyticsProvider.settings.ga.transport});
	      }
	      else {
	        ga('send', 'event', eventOptions);
	      }
	
	      angular.forEach($analyticsProvider.settings.ga.additionalAccountNames, function (accountName){
	        ga(accountName +'.send', 'event', eventOptions);
	      });
	    }
	
	    else if (window._gaq) {
	      _gaq.push(['_trackEvent', properties.category, action, properties.label, properties.value, properties.noninteraction]);
	    }
	
	  });
	
	  /**
	   * Exception Track Event in GA
	   * @name exceptionTrack
	   *
	   * @param {object} properties Comprised of the mandatory fields 'appId' (string), 'appName' (string) and 'appVersion' (string) and 
	   * optional  fields 'fatal' (boolean) and 'description' (string)
	   *
	   * @https://developers.google.com/analytics/devguides/collection/analyticsjs/exceptions
	   *
	   * @link https://developers.google.com/analytics/devguides/collection/analyticsjs/events
	   */
	  $analyticsProvider.registerExceptionTrack(function (properties) {
	    if (!properties || !properties.appId || !properties.appName || !properties.appVersion) {
	        console.error('Must be setted appId, appName and appVersion.');
	        return;
	    }
	
	    if(properties.fatal === undefined) {
	        console.log('No "fatal" provided, sending with fatal=true');
	        properties.exFatal = true;
	    }
	
	    properties.exDescription = properties.description;
	
	    ga('send', 'exception', properties);
	  });
	
	  $analyticsProvider.registerSetUsername(function (userId) {
	    $analyticsProvider.settings.ga.userId = userId;
	  });
	
	  $analyticsProvider.registerSetUserProperties(function (properties) {
	    // add custom dimensions and metrics
	    setDimensionsAndMetrics(properties);
	  });
	
	  /**
	   * User Timings Event in GA
	   * @name userTimings
	   *
	   * @param {object} properties Comprised of the mandatory fields:
	   *     'timingCategory' (string),
	   *     'timingVar' (string),
	   *     'timingValue' (number)
	   * Properties can also have the optional fields:
	   *     'timingLabel' (string)
	   *
	   * @link https://developers.google.com/analytics/devguides/collection/analyticsjs/user-timings
	   */
	  $analyticsProvider.registerUserTimings(function (properties) {
	    if (!properties || !properties.timingCategory || !properties.timingVar || !properties.timingValue) {
	      console.error('Properties timingCategory, timingVar, and timingValue are required to be set.');
	      return;
	    }
	
	    if(window.ga) {
	      ga('send', 'timing', properties);
	    }
	  });
	
	}]);
	})(window, window.angular);


/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(94)
	module.exports = 'angulartics.google.analytics'


/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, "md-card>md-data-table-container:first-child,md-card>md-data-table-toolbar:first-child{border-top-left-radius:2px;border-top-right-radius:2px}md-card>md-data-table-container:last-child,md-card>md-data-table-pagination:last-child,md-card>md-data-table-toolbar:last-child{border-bottom-left-radius:2px;border-bottom-right-radius:2px}md-data-table-toolbar{display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-ms-flex-align:center;align-items:center;padding:0 24px;height:64px;background-color:#fff;box-sizing:border-box}md-data-table-toolbar>.md-title{font-size:20px}md-data-table-toolbar>.md-button:first-child{margin-left:-6px}md-data-table-toolbar>.md-button:last-child{margin-right:-6px}md-data-table-container~md-data-table-toolbar{height:56px;border-top:1px solid rgba(0,0,0,.12);font-size:12px;font-weight:500;color:rgba(0,0,0,.54)}md-data-table-container~md-data-table-toolbar>:not(:first-child){margin-left:16px}md-data-table-container~md-data-table-toolbar>:not(:last-child){margin-right:16px}table[md-data-table]:not([md-row-select])>thead:not([md-table-progress])>tr>th[trim]:first-child>div{right:28px;left:24px}table[md-data-table]:not([md-row-select])>thead:not([md-table-progress])>tr>th[trim]:nth-child(n+2):nth-last-child(n+2)>div{right:28px;left:28px}table[md-data-table][md-row-select]>thead:not([md-table-progress])>tr>th[trim]:nth-child(2)>div{right:28px;left:0}table[md-data-table][md-row-select]>thead:not([md-table-progress])>tr>th[trim]:nth-child(n+3):nth-last-child(n+2)>div{right:28px;left:28px}table[md-data-table]>thead:not([md-table-progress])>tr>th{font-size:12px;color:rgba(0,0,0,.54);white-space:nowrap}table[md-data-table]>thead:not([md-table-progress])>tr>th>div{display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-ms-flex-align:center;align-items:center;height:56px;line-height:18px}table[md-data-table]>thead:not([md-table-progress])>tr>th[numeric]>div{-webkit-justify-content:flex-end;-ms-flex-pack:end;justify-content:flex-end}table[md-data-table]>thead:not([md-table-progress])>tr>th[trim]{position:relative;min-width:60px}table[md-data-table]>thead:not([md-table-progress])>tr>th[trim][numeric]:hover>div{left:0!important}table[md-data-table]>thead:not([md-table-progress])>tr>th[trim]:not([numeric]):hover>div{right:0!important}table[md-data-table]>thead:not([md-table-progress])>tr>th[trim]:last-child>div{right:24px;left:24px}table[md-data-table]>thead:not([md-table-progress])>tr>th[trim]>div{position:absolute;top:0;bottom:0;transition:left .35s ease,right .35s ease}table[md-data-table]>thead:not([md-table-progress])>tr>th[trim]>div>div{-webkit-flex:0 1 auto;-ms-flex:0 1 auto;flex:0 1 auto;overflow:hidden;text-overflow:ellipsis}table[md-data-table]>thead:not([md-table-progress])[md-order]>tr>th[order-by]{transition:color .25s}table[md-data-table]>thead:not([md-table-progress])[md-order]>tr>th[order-by]:not(.md-active):not(:hover)>div>md-icon{fill:transparent}table[md-data-table]>thead:not([md-table-progress])[md-order]>tr>th[order-by].md-active{color:rgba(0,0,0,.87)}table[md-data-table]>thead:not([md-table-progress])[md-order]>tr>th[order-by].md-active>div>md-icon{fill:rgba(0,0,0,.87)}table[md-data-table]>thead:not([md-table-progress])[md-order]>tr>th[order-by]:hover{color:rgba(0,0,0,.87);cursor:pointer}table[md-data-table]>thead:not([md-table-progress])[md-order]>tr>th[order-by]:not(.md-active):hover>div>md-icon{fill:rgba(0,0,0,.26)}table[md-data-table]>thead:not([md-table-progress])[md-order]>tr>th[order-by]>div>md-icon{-webkit-flex:0 0 auto;-ms-flex:0 0 auto;flex:0 0 auto;height:18px;width:18px;margin:0 4px;transition:fill .25s,-webkit-transform .25s;transition:fill .25s,transform .25s}table[md-data-table]>thead:not([md-table-progress])[md-order]>tr>th[order-by]>div>md-icon.down{-webkit-transform:rotate(180deg);transform:rotate(180deg)}table[md-data-table]>thead:not([md-table-progress])[md-order]>tr>th[order-by]>div>md-icon.up{-webkit-transform:rotate(0deg);transform:rotate(0deg)}table[md-data-table]>tbody>tr{height:48px;transition:background-color .2s}table[md-data-table]>tbody>tr[md-auto-select]:focus{outline:none}table[md-data-table]>tbody>tr:hover{background-color:#eee!important}table[md-data-table]>tbody>tr[ng-repeat].ng-leave{display:none}table[md-data-table]>tbody>tr.md-selected{background-color:#f5f5f5}table[md-data-table]>tbody>tr>td{font-size:13px;color:rgba(0,0,0,.87);border-top:1px solid rgba(0,0,0,.12)}table[md-data-table]>tbody>tr>td.clickable{cursor:pointer}table[md-data-table]>tbody>tr>td.numeric{text-align:right}table[md-data-table]>tbody>tr>td.numeric md-select{-webkit-justify-content:flex-end;-ms-flex-pack:end;justify-content:flex-end}table[md-data-table]>tbody>tr>td:not(.numeric) md-select>md-select-label{-webkit-flex:1 0 auto;-ms-flex:1 0 auto;flex:1 0 auto}table[md-data-table]>tbody>tr>td>md-select{-webkit-flex:0 0 auto;-ms-flex:0 0 auto;flex:0 0 auto;padding:0;margin:0}table[md-data-table]>tbody>tr>td>md-select>md-select-value{padding:0;min-width:0;min-height:0;border-bottom:0!important}table[md-data-table]>tbody>tr>td>md-select>md-select-value>span:first-child{-webkit-flex:1 0 auto;-ms-flex:1 0 auto;flex:1 0 auto;max-width:none;-webkit-transform:none;transform:none}table[md-data-table]>tbody>tr>td>md-select>md-select-value>.md-select-icon{-webkit-align-items:center;-ms-flex-align:center;align-items:center;margin:0;color:rgba(0,0,0,.54)!important;text-align:center;-webkit-transform:none;transform:none}table[md-data-table]>tbody>tr>td>md-select>md-select-value>.md-select-icon:after{-webkit-transform:scaleY(.4) scaleX(.8);transform:scaleY(.4) scaleX(.8)}table[md-data-table]>tfoot>tr{height:48px}table[md-data-table]>tfoot>tr>td{font-size:13px;color:rgba(0,0,0,.87);border-top:1px solid rgba(0,0,0,.12);white-space:nowrap}table[md-data-table]>tfoot>tr>td.numeric{text-align:right}md-data-table-pagination{display:-webkit-flex;display:-ms-flexbox;display:flex}@media (max-width:600px){md-data-table-pagination{-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-align-items:stretch;-ms-flex-align:stretch;align-items:stretch}}md-data-table-pagination>div{display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-justify-content:flex-end;-ms-flex-pack:end;justify-content:flex-end;min-height:56px;font-size:12px;font-weight:500;color:rgba(0,0,0,.54);border-top:1px solid rgba(0,0,0,.12);box-sizing:border-box}@media (min-width:601px){md-data-table-pagination>div:first-child{-webkit-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto}}md-data-table-pagination>div:first-child > .label{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin:0 32px 0 24px}md-data-table-pagination>div:first-child > md-select{-webkit-flex:0 0 auto;-ms-flex:0 0 auto;flex:0 0 auto;padding:0;margin:0 32px 0 0}md-data-table-pagination>div:first-child > md-select > md-select-value{padding:0;min-width:0;min-height:0;border-bottom:0!important}md-data-table-pagination>div:first-child > md-select > md-select-value > span:first-child{-webkit-flex:1 0 auto;-ms-flex:1 0 auto;flex:1 0 auto;max-width:none;color:rgba(0,0,0,.54)!important;-webkit-transform:none;transform:none}md-data-table-pagination>div:first-child > md-select > md-select-value > .md-select-icon{-webkit-align-items:center;-ms-flex-align:center;align-items:center;margin:0;color:rgba(0,0,0,.54)!important;text-align:center;-webkit-transform:none;transform:none}md-data-table-pagination>div:first-child > md-select > md-select-value > .md-select-icon:after{top:1px;-webkit-transform:scaleY(.5) scaleX(1);transform:scaleY(.5) scaleX(1)}md-data-table-pagination>div:first-child > span:last-child{-webkit-flex:0 0 auto;-ms-flex:0 0 auto;flex:0 0 auto}@media (min-width:601px){md-data-table-pagination>div:first-child > span:last-child{margin-right:32px}}@media (max-width:600px){md-data-table-pagination>div:first-child > span:last-child{margin-right:24px}}md-data-table-pagination>div:nth-child(2),md-data-table-pagination>div:nth-child(2) .md-button{-webkit-flex:0 0 auto;-ms-flex:0 0 auto;flex:0 0 auto}md-data-table-pagination>div:nth-child(2) .md-button{display:-webkit-flex;display:-ms-flexbox;display:flex;padding:0;min-height:24px;min-width:24px}md-data-table-pagination>div:nth-child(2) .md-button:not(:last-of-type){margin:0 24px 0 0}md-data-table-pagination>div:nth-child(2) .md-button:last-of-type{margin:0 18px 0 0}.md-select-menu-container.md-pagination-select{margin-top:-2px;margin-left:-2px}.md-select-menu-container.md-pagination-select md-content{padding:0}.md-select-menu-container.md-pagination-select md-content md-option .md-text{font-size:12px;font-weight:500}@-webkit-keyframes md-table-progress-enter{0%{opacity:0}to{opacity:1}}@keyframes md-table-progress-enter{0%{opacity:0}to{opacity:1}}@-webkit-keyframes md-table-progress-leave{0%{opacity:1}to{opacity:0}}@keyframes md-table-progress-leave{0%{opacity:1}to{opacity:0}}table[md-data-table]>thead[md-table-progress].ng-enter{-webkit-animation:md-table-progress-enter 1s;animation:md-table-progress-enter 1s}table[md-data-table]>thead[md-table-progress].ng-leave{-webkit-animation:md-table-progress-leave 1s .5s;animation:md-table-progress-leave 1s .5s}table[md-data-table]>thead[md-table-progress] tr>th{padding:0}table[md-data-table]>thead[md-table-progress] tr>th>md-progress-linear{height:0;top:-3px}table[md-data-table]>thead[md-table-progress] tr>th>md-progress-linear>.md-container{height:3px;top:0;transition:none}table[md-data-table]>thead[md-table-progress] tr>th>md-progress-linear>.md-container>.md-bar{height:3px}md-data-table-container{display:block;max-width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.md-select-menu-container.md-table-select{margin-top:-2px;margin-left:-2px}.md-select-menu-container.md-table-select md-content{padding:0}.md-select-menu-container.md-table-select md-content md-option .md-text{font-size:13px}table[md-data-table]{width:100%;border-spacing:0;background-color:#fff;overflow:hidden}table[md-data-table]:not([md-row-select])>tbody>tr>td:first-child,table[md-data-table]:not([md-row-select])>tfoot>tr>td:first-child,table[md-data-table]:not([md-row-select])>thead:not([md-table-progress])>tr>th:first-child{padding:0 28px 0 24px}table[md-data-table]:not([md-row-select])>tbody>tr>td:nth-child(n+2):nth-last-child(n+2),table[md-data-table]:not([md-row-select])>tfoot>tr>td:nth-child(n+2):nth-last-child(n+2),table[md-data-table]:not([md-row-select])>thead:not([md-table-progress])>tr>th:nth-child(n+2):nth-last-child(n+2){padding:0 28px}table[md-data-table][md-row-select]>tbody>tr>td:first-child,table[md-data-table][md-row-select]>tfoot>tr>td:first-child,table[md-data-table][md-row-select]>thead:not([md-table-progress])>tr>th:first-child{width:18px;padding:0 24px}table[md-data-table][md-row-select]>tbody>tr>td:nth-child(2),table[md-data-table][md-row-select]>tfoot>tr>td:nth-child(2),table[md-data-table][md-row-select]>thead:not([md-table-progress])>tr>th:nth-child(2){padding:0 28px 0 0}table[md-data-table][md-row-select]>tbody>tr>td:nth-child(n+3):nth-last-child(n+2),table[md-data-table][md-row-select]>tfoot>tr>td:nth-child(n+3):nth-last-child(n+2),table[md-data-table][md-row-select]>thead:not([md-table-progress])>tr>th:nth-child(n+3):nth-last-child(n+2){padding:0 28px}table[md-data-table]>tbody>tr>td,table[md-data-table]>tfoot>tr>td,table[md-data-table]>thead:not([md-table-progress])>tr>th{text-align:left}table[md-data-table]>tbody>tr>td:last-child,table[md-data-table]>tfoot>tr>td:last-child,table[md-data-table]>thead:not([md-table-progress])>tr>th:last-child{padding:0 24px 0 28px}table[md-data-table]>tbody>tr>td:focus,table[md-data-table]>tfoot>tr>td:focus,table[md-data-table]>thead:not([md-table-progress])>tr>th:focus{outline:none}table[md-data-table]>tbody>tr>td>md-checkbox,table[md-data-table]>tfoot>tr>td>md-checkbox,table[md-data-table]>thead:not([md-table-progress])>tr>th>md-checkbox{margin:0}", ""]);
	
	// exports


/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * AngularJS Material Design\n * https://github.com/angular/material\n * @license MIT\n * v1.1.4\n */body,html{height:100%;position:relative}body{margin:0;padding:0}[tabindex=\"-1\"]:focus{outline:none}.inset{padding:10px}a.md-no-style,button.md-no-style{font-weight:400;background-color:inherit;text-align:left;border:none;padding:0;margin:0}button,input,select,textarea{vertical-align:baseline}button,html input[type=button],input[type=reset],input[type=submit]{cursor:pointer;-webkit-appearance:button}button[disabled],html input[type=button][disabled],input[type=reset][disabled],input[type=submit][disabled]{cursor:default}textarea{vertical-align:top;overflow:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box;-webkit-box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}input:-webkit-autofill{text-shadow:none}.md-visually-hidden{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;text-transform:none;width:1px}.md-shadow{position:absolute;top:0;left:0;bottom:0;right:0;border-radius:inherit;pointer-events:none}.md-shadow-bottom-z-1{box-shadow:0 2px 5px 0 rgba(0,0,0,.26)}.md-shadow-bottom-z-2{box-shadow:0 4px 8px 0 rgba(0,0,0,.4)}.md-shadow-animated.md-shadow{-webkit-transition:box-shadow .28s cubic-bezier(.4,0,.2,1);transition:box-shadow .28s cubic-bezier(.4,0,.2,1)}.md-ripple-container{pointer-events:none;position:absolute;overflow:hidden;left:0;top:0;width:100%;height:100%;-webkit-transition:all .55s cubic-bezier(.25,.8,.25,1);transition:all .55s cubic-bezier(.25,.8,.25,1)}.md-ripple{position:absolute;-webkit-transform:translate(-50%,-50%) scale(0);transform:translate(-50%,-50%) scale(0);-webkit-transform-origin:50% 50%;transform-origin:50% 50%;opacity:0;border-radius:50%}.md-ripple.md-ripple-placed{-webkit-transition:margin .9s cubic-bezier(.25,.8,.25,1),border .9s cubic-bezier(.25,.8,.25,1),width .9s cubic-bezier(.25,.8,.25,1),height .9s cubic-bezier(.25,.8,.25,1),opacity .9s cubic-bezier(.25,.8,.25,1),-webkit-transform .9s cubic-bezier(.25,.8,.25,1);transition:margin .9s cubic-bezier(.25,.8,.25,1),border .9s cubic-bezier(.25,.8,.25,1),width .9s cubic-bezier(.25,.8,.25,1),height .9s cubic-bezier(.25,.8,.25,1),opacity .9s cubic-bezier(.25,.8,.25,1),-webkit-transform .9s cubic-bezier(.25,.8,.25,1);transition:margin .9s cubic-bezier(.25,.8,.25,1),border .9s cubic-bezier(.25,.8,.25,1),width .9s cubic-bezier(.25,.8,.25,1),height .9s cubic-bezier(.25,.8,.25,1),opacity .9s cubic-bezier(.25,.8,.25,1),transform .9s cubic-bezier(.25,.8,.25,1);transition:margin .9s cubic-bezier(.25,.8,.25,1),border .9s cubic-bezier(.25,.8,.25,1),width .9s cubic-bezier(.25,.8,.25,1),height .9s cubic-bezier(.25,.8,.25,1),opacity .9s cubic-bezier(.25,.8,.25,1),transform .9s cubic-bezier(.25,.8,.25,1),-webkit-transform .9s cubic-bezier(.25,.8,.25,1)}.md-ripple.md-ripple-scaled{-webkit-transform:translate(-50%,-50%) scale(1);transform:translate(-50%,-50%) scale(1)}.md-ripple.md-ripple-active,.md-ripple.md-ripple-full,.md-ripple.md-ripple-visible{opacity:.2}.md-ripple.md-ripple-remove{-webkit-animation:md-remove-ripple .9s cubic-bezier(.25,.8,.25,1);animation:md-remove-ripple .9s cubic-bezier(.25,.8,.25,1)}@-webkit-keyframes md-remove-ripple{0%{opacity:.15}to{opacity:0}}@keyframes md-remove-ripple{0%{opacity:.15}to{opacity:0}}.md-padding{padding:8px}.md-margin{margin:8px}.md-scroll-mask{position:absolute;background-color:transparent;top:0;right:0;bottom:0;left:0;z-index:50}.md-scroll-mask>.md-scroll-mask-bar{display:block;position:absolute;background-color:#fafafa;right:0;top:0;bottom:0;z-index:65;box-shadow:inset 0 0 1px rgba(0,0,0,.3)}.md-no-momentum{-webkit-overflow-scrolling:auto}.md-no-flicker{-webkit-filter:blur(0)}@media (min-width:960px){.md-padding{padding:16px}}body[dir=ltr],body[dir=rtl],html[dir=ltr],html[dir=rtl]{unicode-bidi:embed}bdo[dir=rtl]{direction:rtl}bdo[dir=ltr],bdo[dir=rtl]{unicode-bidi:bidi-override}bdo[dir=ltr]{direction:ltr}body,html{-webkit-tap-highlight-color:transparent;-webkit-touch-callout:none;min-height:100%;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.md-display-4{font-size:112px;font-weight:300;letter-spacing:-.01em;line-height:112px}.md-display-3{font-size:56px;font-weight:400;letter-spacing:-.005em;line-height:56px}.md-display-2{font-size:45px;font-weight:400;line-height:64px}.md-display-1{font-size:34px;font-weight:400;line-height:40px}.md-headline{font-size:24px;font-weight:400;line-height:32px}.md-title{font-size:20px;font-weight:500;letter-spacing:.005em}.md-subhead{font-size:16px;line-height:24px}.md-body-1,.md-subhead{font-weight:400;letter-spacing:.01em}.md-body-1{font-size:14px;line-height:20px}.md-body-2{font-size:14px;font-weight:500;letter-spacing:.01em;line-height:24px}.md-caption{font-size:12px;letter-spacing:.02em}.md-button{letter-spacing:.01em}button,html,input,select,textarea{font-family:Roboto,Helvetica Neue,sans-serif}button,input,select,textarea{font-size:100%}.md-panel-outer-wrapper{height:100%;left:0;position:absolute;top:0;width:100%}._md-panel-hidden{display:none}._md-panel-offscreen{left:-9999px}._md-panel-fullscreen{border-radius:0;left:0;min-height:100%;min-width:100%;position:fixed;top:0}._md-panel-shown .md-panel{opacity:1;-webkit-transition:none;transition:none}.md-panel{opacity:0;position:fixed}.md-panel._md-panel-shown{opacity:1;-webkit-transition:none;transition:none}.md-panel._md-panel-animate-enter{opacity:1;-webkit-transition:all .3s cubic-bezier(0,0,.2,1);transition:all .3s cubic-bezier(0,0,.2,1)}.md-panel._md-panel-animate-leave{opacity:1;-webkit-transition:all .3s cubic-bezier(.4,0,1,1);transition:all .3s cubic-bezier(.4,0,1,1)}.md-panel._md-panel-animate-fade-out,.md-panel._md-panel-animate-scale-out{opacity:0}.md-panel._md-panel-backdrop{height:100%;position:absolute;width:100%}.md-panel._md-opaque-enter{opacity:.48;-webkit-transition:opacity .3s cubic-bezier(0,0,.2,1);transition:opacity .3s cubic-bezier(0,0,.2,1)}.md-panel._md-opaque-leave{-webkit-transition:opacity .3s cubic-bezier(.4,0,1,1);transition:opacity .3s cubic-bezier(.4,0,1,1)}md-autocomplete{border-radius:2px;display:block;height:40px;position:relative;overflow:visible;min-width:190px}md-autocomplete[disabled] input{cursor:default}md-autocomplete[md-floating-label]{border-radius:0;background:transparent;height:auto}md-autocomplete[md-floating-label] md-input-container{padding-bottom:0}md-autocomplete[md-floating-label] md-autocomplete-wrap{height:auto}md-autocomplete[md-floating-label] .md-show-clear-button button{display:block;position:absolute;right:0;top:20px;width:30px;height:30px}md-autocomplete[md-floating-label] .md-show-clear-button input{padding-right:30px}[dir=rtl] md-autocomplete[md-floating-label] .md-show-clear-button input{padding-right:0;padding-left:30px}md-autocomplete md-autocomplete-wrap{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;flex-direction:row;box-sizing:border-box;position:relative;overflow:visible;height:40px}md-autocomplete md-autocomplete-wrap.md-menu-showing{z-index:51}md-autocomplete md-autocomplete-wrap input,md-autocomplete md-autocomplete-wrap md-input-container{-webkit-box-flex:1;-webkit-flex:1 1 0%;flex:1 1 0%;box-sizing:border-box;min-width:0}md-autocomplete md-autocomplete-wrap md-progress-linear{position:absolute;bottom:-2px;left:0}md-autocomplete md-autocomplete-wrap md-progress-linear.md-inline{bottom:40px;right:2px;left:2px;width:auto}md-autocomplete md-autocomplete-wrap md-progress-linear .md-mode-indeterminate{position:absolute;top:0;left:0;width:100%;height:3px;-webkit-transition:none;transition:none}md-autocomplete md-autocomplete-wrap md-progress-linear .md-mode-indeterminate .md-container{-webkit-transition:none;transition:none;height:3px}md-autocomplete md-autocomplete-wrap md-progress-linear .md-mode-indeterminate.ng-enter{-webkit-transition:opacity .15s linear;transition:opacity .15s linear}md-autocomplete md-autocomplete-wrap md-progress-linear .md-mode-indeterminate.ng-enter.ng-enter-active{opacity:1}md-autocomplete md-autocomplete-wrap md-progress-linear .md-mode-indeterminate.ng-leave{-webkit-transition:opacity .15s linear;transition:opacity .15s linear}md-autocomplete md-autocomplete-wrap md-progress-linear .md-mode-indeterminate.ng-leave.ng-leave-active{opacity:0}md-autocomplete input:not(.md-input){font-size:14px;box-sizing:border-box;border:none;box-shadow:none;outline:none;background:transparent;width:100%;padding:0 15px;line-height:40px;height:40px}md-autocomplete input:not(.md-input)::-ms-clear{display:none}md-autocomplete .md-show-clear-button button{position:relative;line-height:20px;text-align:center;width:30px;height:30px;cursor:pointer;border:none;border-radius:50%;padding:0;font-size:12px;background:transparent;margin:auto 5px}md-autocomplete .md-show-clear-button button:after{content:\"\";position:absolute;top:-6px;right:-6px;bottom:-6px;left:-6px;border-radius:50%;-webkit-transform:scale(0);transform:scale(0);opacity:0;-webkit-transition:all .4s cubic-bezier(.25,.8,.25,1);transition:all .4s cubic-bezier(.25,.8,.25,1)}md-autocomplete .md-show-clear-button button:focus{outline:none}md-autocomplete .md-show-clear-button button:focus:after{-webkit-transform:scale(1);transform:scale(1);opacity:1}md-autocomplete .md-show-clear-button button md-icon{position:absolute;top:50%;left:50%;-webkit-transform:translate3d(-50%,-50%,0) scale(.9);transform:translate3d(-50%,-50%,0) scale(.9)}md-autocomplete .md-show-clear-button button md-icon path{stroke-width:0}md-autocomplete .md-show-clear-button button.ng-enter{-webkit-transform:scale(0);transform:scale(0);-webkit-transition:-webkit-transform .15s ease-out;transition:-webkit-transform .15s ease-out;transition:transform .15s ease-out;transition:transform .15s ease-out,-webkit-transform .15s ease-out}md-autocomplete .md-show-clear-button button.ng-enter.ng-enter-active{-webkit-transform:scale(1);transform:scale(1)}md-autocomplete .md-show-clear-button button.ng-leave{-webkit-transition:-webkit-transform .15s ease-out;transition:-webkit-transform .15s ease-out;transition:transform .15s ease-out;transition:transform .15s ease-out,-webkit-transform .15s ease-out}md-autocomplete .md-show-clear-button button.ng-leave.ng-leave-active{-webkit-transform:scale(0);transform:scale(0)}@media screen and (-ms-high-contrast:active){md-autocomplete input{border:1px solid #fff}md-autocomplete li:focus{color:#fff}}.md-virtual-repeat-container.md-autocomplete-suggestions-container{position:absolute;box-shadow:0 2px 5px rgba(0,0,0,.25);z-index:100;height:100%}.md-virtual-repeat-container.md-not-found{height:48px}.md-autocomplete-suggestions{margin:0;list-style:none;padding:0}.md-autocomplete-suggestions li{font-size:14px;overflow:hidden;padding:0 15px;line-height:48px;height:48px;-webkit-transition:background .15s linear;transition:background .15s linear;margin:0;white-space:nowrap;text-overflow:ellipsis}.md-autocomplete-suggestions li:focus{outline:none}.md-autocomplete-suggestions li:not(.md-not-found-wrapper){cursor:pointer}@media screen and (-ms-high-contrast:active){.md-autocomplete-suggestions,md-autocomplete{border:1px solid #fff}}md-backdrop{-webkit-transition:opacity .45s;transition:opacity .45s;position:absolute;top:0;bottom:0;left:0;right:0;z-index:50}md-backdrop.md-menu-backdrop{position:fixed!important;z-index:99}md-backdrop.md-select-backdrop{z-index:81;-webkit-transition-duration:0;transition-duration:0}md-backdrop.md-dialog-backdrop{z-index:79}md-backdrop.md-bottom-sheet-backdrop{z-index:69}md-backdrop.md-sidenav-backdrop{z-index:59}md-backdrop.md-click-catcher{position:absolute}md-backdrop.md-opaque{opacity:.48}md-backdrop.md-opaque.ng-enter{opacity:0}md-backdrop.md-opaque.ng-enter.md-opaque.ng-enter-active{opacity:.48}md-backdrop.md-opaque.ng-leave{opacity:.48;-webkit-transition:opacity .4s;transition:opacity .4s}md-backdrop.md-opaque.ng-leave.md-opaque.ng-leave-active{opacity:0}md-bottom-sheet{position:absolute;left:0;right:0;bottom:0;padding:8px 16px 88px;z-index:70;border-top-width:1px;border-top-style:solid;-webkit-transform:translate3d(0,80px,0);transform:translate3d(0,80px,0);-webkit-transition:all .4s cubic-bezier(.25,.8,.25,1);transition:all .4s cubic-bezier(.25,.8,.25,1);-webkit-transition-property:-webkit-transform;transition-property:-webkit-transform;transition-property:transform;transition-property:transform,-webkit-transform}md-bottom-sheet.md-has-header{padding-top:0}md-bottom-sheet.ng-enter{opacity:0;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}md-bottom-sheet.ng-enter-active{opacity:1;display:block;-webkit-transform:translate3d(0,80px,0)!important;transform:translate3d(0,80px,0)!important}md-bottom-sheet.ng-leave-active{-webkit-transform:translate3d(0,100%,0)!important;transform:translate3d(0,100%,0)!important;-webkit-transition:all .3s cubic-bezier(.55,0,.55,.2);transition:all .3s cubic-bezier(.55,0,.55,.2)}md-bottom-sheet .md-subheader{background-color:transparent;font-family:Roboto,Helvetica Neue,sans-serif;line-height:56px;padding:0;white-space:nowrap}md-bottom-sheet md-inline-icon{display:inline-block;height:24px;width:24px;fill:#444}md-bottom-sheet md-list-item{display:-webkit-box;display:-webkit-flex;display:flex;outline:none}md-bottom-sheet md-list-item:hover{cursor:pointer}md-bottom-sheet.md-list md-list-item{padding:0;-webkit-box-align:center;-webkit-align-items:center;align-items:center;height:48px}md-bottom-sheet.md-grid{padding-left:24px;padding-right:24px;padding-top:0}md-bottom-sheet.md-grid md-list{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-orient:horizontal;-webkit-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;flex-wrap:wrap}md-bottom-sheet.md-grid md-list,md-bottom-sheet.md-grid md-list-item{-webkit-box-direction:normal;-webkit-transition:all .5s;transition:all .5s;-webkit-box-align:center;-webkit-align-items:center;align-items:center}md-bottom-sheet.md-grid md-list-item{-webkit-box-orient:vertical;-webkit-flex-direction:column;flex-direction:column;height:96px;margin-top:8px;margin-bottom:8px}@media (max-width:960px){md-bottom-sheet.md-grid md-list-item{-webkit-box-flex:1;-webkit-flex:1 1 33.33333%;flex:1 1 33.33333%;max-width:33.33333%}md-bottom-sheet.md-grid md-list-item:nth-of-type(3n+1){-webkit-box-align:start;-webkit-align-items:flex-start;align-items:flex-start}md-bottom-sheet.md-grid md-list-item:nth-of-type(3n){-webkit-box-align:end;-webkit-align-items:flex-end;align-items:flex-end}}@media (min-width:960px) and (max-width:1279px){md-bottom-sheet.md-grid md-list-item{-webkit-box-flex:1;-webkit-flex:1 1 25%;flex:1 1 25%;max-width:25%}}@media (min-width:1280px) and (max-width:1919px){md-bottom-sheet.md-grid md-list-item{-webkit-box-flex:1;-webkit-flex:1 1 16.66667%;flex:1 1 16.66667%;max-width:16.66667%}}@media (min-width:1920px){md-bottom-sheet.md-grid md-list-item{-webkit-box-flex:1;-webkit-flex:1 1 14.28571%;flex:1 1 14.28571%;max-width:14.28571%}}md-bottom-sheet.md-grid md-list-item:before{display:none}md-bottom-sheet.md-grid md-list-item .md-list-item-content{width:48px;padding-bottom:16px}md-bottom-sheet.md-grid md-list-item .md-grid-item-content,md-bottom-sheet.md-grid md-list-item .md-list-item-content{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column;-webkit-box-align:center;-webkit-align-items:center;align-items:center}md-bottom-sheet.md-grid md-list-item .md-grid-item-content{border:1px solid transparent;width:80px}md-bottom-sheet.md-grid md-list-item .md-grid-text{font-weight:400;line-height:16px;font-size:13px;margin:0;white-space:nowrap;width:64px;text-align:center;text-transform:none;padding-top:8px}@media screen and (-ms-high-contrast:active){md-bottom-sheet{border:1px solid #fff}}button.md-button::-moz-focus-inner{border:0}.md-button{display:inline-block;position:relative;cursor:pointer;min-height:36px;min-width:88px;line-height:36px;vertical-align:middle;-webkit-box-align:center;-webkit-align-items:center;align-items:center;text-align:center;border-radius:2px;box-sizing:border-box;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;outline:none;border:0;padding:0 6px;margin:6px 8px;background:transparent;color:currentColor;white-space:nowrap;text-transform:uppercase;font-weight:500;font-size:14px;font-style:inherit;font-variant:inherit;font-family:inherit;text-decoration:none;overflow:hidden;-webkit-transition:box-shadow .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1);transition:box-shadow .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1)}.md-dense :not(.md-dense-disabled) .md-button:not(.md-dense-disabled),.md-dense>.md-button:not(.md-dense-disabled){min-height:32px;line-height:32px;font-size:13px}.md-button:focus{outline:none}.md-button:focus,.md-button:hover{text-decoration:none}.md-button.ng-hide,.md-button.ng-leave{-webkit-transition:none;transition:none}.md-button.md-cornered{border-radius:0}.md-button.md-icon{padding:0;background:none}.md-button.md-raised:not([disabled]){box-shadow:0 2px 5px 0 rgba(0,0,0,.26)}.md-button.md-icon-button{margin:0 6px;height:40px;min-width:0;line-height:24px;padding:8px;width:40px;border-radius:50%}.md-button.md-icon-button .md-ripple-container{border-radius:50%;background-clip:padding-box;overflow:hidden;-webkit-mask-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAA5JREFUeNpiYGBgAAgwAAAEAAGbA+oJAAAAAElFTkSuQmCC\")}.md-button.md-fab{z-index:20;line-height:56px;min-width:0;width:56px;height:56px;vertical-align:middle;box-shadow:0 2px 5px 0 rgba(0,0,0,.26);border-radius:50%;background-clip:padding-box;overflow:hidden;-webkit-transition:all .3s cubic-bezier(.55,0,.55,.2);transition:all .3s cubic-bezier(.55,0,.55,.2);-webkit-transition-property:background-color,box-shadow,-webkit-transform;transition-property:background-color,box-shadow,-webkit-transform;transition-property:background-color,box-shadow,transform;transition-property:background-color,box-shadow,transform,-webkit-transform}.md-button.md-fab.md-fab-bottom-right{top:auto;right:20px;bottom:20px;left:auto;position:absolute}.md-button.md-fab.md-fab-bottom-left{top:auto;right:auto;bottom:20px;left:20px;position:absolute}.md-button.md-fab.md-fab-top-right{top:20px;right:20px;bottom:auto;left:auto;position:absolute}.md-button.md-fab.md-fab-top-left{top:20px;right:auto;bottom:auto;left:20px;position:absolute}.md-button.md-fab .md-ripple-container{border-radius:50%;background-clip:padding-box;overflow:hidden;-webkit-mask-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAA5JREFUeNpiYGBgAAgwAAAEAAGbA+oJAAAAAElFTkSuQmCC\")}.md-button.md-fab.md-mini{line-height:40px;width:40px;height:40px}.md-button.md-fab.ng-hide,.md-button.md-fab.ng-leave{-webkit-transition:none;transition:none}.md-button:not([disabled]).md-fab.md-focused,.md-button:not([disabled]).md-raised.md-focused{box-shadow:0 2px 5px 0 rgba(0,0,0,.26)}.md-button:not([disabled]).md-fab:active,.md-button:not([disabled]).md-raised:active{box-shadow:0 4px 8px 0 rgba(0,0,0,.4)}.md-button .md-ripple-container{border-radius:2px;background-clip:padding-box;overflow:hidden;-webkit-mask-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAA5JREFUeNpiYGBgAAgwAAAEAAGbA+oJAAAAAElFTkSuQmCC\")}.md-button.md-icon-button md-icon,button.md-button.md-fab md-icon{display:block}.md-toast-open-top .md-button.md-fab-top-left,.md-toast-open-top .md-button.md-fab-top-right{-webkit-transition:all .4s cubic-bezier(.25,.8,.25,1);transition:all .4s cubic-bezier(.25,.8,.25,1);-webkit-transform:translate3d(0,42px,0);transform:translate3d(0,42px,0)}.md-toast-open-top .md-button.md-fab-top-left:not([disabled]).md-focused,.md-toast-open-top .md-button.md-fab-top-left:not([disabled]):hover,.md-toast-open-top .md-button.md-fab-top-right:not([disabled]).md-focused,.md-toast-open-top .md-button.md-fab-top-right:not([disabled]):hover{-webkit-transform:translate3d(0,41px,0);transform:translate3d(0,41px,0)}.md-toast-open-bottom .md-button.md-fab-bottom-left,.md-toast-open-bottom .md-button.md-fab-bottom-right{-webkit-transition:all .4s cubic-bezier(.25,.8,.25,1);transition:all .4s cubic-bezier(.25,.8,.25,1);-webkit-transform:translate3d(0,-42px,0);transform:translate3d(0,-42px,0)}.md-toast-open-bottom .md-button.md-fab-bottom-left:not([disabled]).md-focused,.md-toast-open-bottom .md-button.md-fab-bottom-left:not([disabled]):hover,.md-toast-open-bottom .md-button.md-fab-bottom-right:not([disabled]).md-focused,.md-toast-open-bottom .md-button.md-fab-bottom-right:not([disabled]):hover{-webkit-transform:translate3d(0,-43px,0);transform:translate3d(0,-43px,0)}.md-button-group{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-flex:1;-webkit-flex:1;flex:1;width:100%}.md-button-group>.md-button{-webkit-box-flex:1;-webkit-flex:1;flex:1;display:block;overflow:hidden;width:0;border-width:1px 0 1px 1px;border-radius:0;text-align:center;text-overflow:ellipsis;white-space:nowrap}.md-button-group>.md-button:first-child{border-radius:2px 0 0 2px}.md-button-group>.md-button:last-child{border-right-width:1px;border-radius:0 2px 2px 0}@media screen and (-ms-high-contrast:active){.md-button.md-fab,.md-button.md-raised{border:1px solid #fff}}md-card{box-sizing:border-box;-webkit-box-orient:vertical;-webkit-flex-direction:column;flex-direction:column;margin:8px;box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12)}md-card,md-card md-card-header{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-direction:normal}md-card md-card-header{padding:16px;-webkit-box-orient:horizontal;-webkit-flex-direction:row;flex-direction:row}md-card md-card-header:first-child md-card-avatar{margin-right:12px}[dir=rtl] md-card md-card-header:first-child md-card-avatar{margin-right:auto;margin-left:12px}md-card md-card-header:last-child md-card-avatar{margin-left:12px}[dir=rtl] md-card md-card-header:last-child md-card-avatar{margin-left:auto;margin-right:12px}md-card md-card-header md-card-avatar{width:40px;height:40px}md-card md-card-header md-card-avatar .md-user-avatar,md-card md-card-header md-card-avatar md-icon{border-radius:50%}md-card md-card-header md-card-avatar md-icon{padding:8px}md-card md-card-header md-card-avatar md-icon>svg{height:inherit;width:inherit}md-card md-card-header md-card-avatar+md-card-header-text{max-height:40px}md-card md-card-header md-card-avatar+md-card-header-text .md-title{font-size:14px}md-card md-card-header md-card-header-text{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-flex:1;-webkit-flex:1;flex:1;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column}md-card md-card-header md-card-header-text .md-subhead{font-size:14px}md-card>img,md-card>md-card-header img,md-card md-card-title-media img{box-sizing:border-box;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-flex:0;-webkit-flex:0 0 auto;flex:0 0 auto;width:100%;height:auto}md-card md-card-title{padding:24px 16px 16px;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-flex:1;-webkit-flex:1 1 auto;flex:1 1 auto;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;flex-direction:row}md-card md-card-title+md-card-content{padding-top:0}md-card md-card-title md-card-title-text{-webkit-box-flex:1;-webkit-flex:1;flex:1;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column;display:-webkit-box;display:-webkit-flex;display:flex}md-card md-card-title md-card-title-text .md-subhead{padding-top:0;font-size:14px}md-card md-card-title md-card-title-text:only-child .md-subhead{padding-top:12px}md-card md-card-title md-card-title-media{margin-top:-8px}md-card md-card-title md-card-title-media .md-media-sm{height:80px;width:80px}md-card md-card-title md-card-title-media .md-media-md{height:112px;width:112px}md-card md-card-title md-card-title-media .md-media-lg{height:152px;width:152px}md-card md-card-content{display:block;padding:16px}md-card md-card-content>p:first-child{margin-top:0}md-card md-card-content>p:last-child{margin-bottom:0}md-card md-card-content .md-media-xl{height:240px;width:240px}md-card .md-actions,md-card md-card-actions{margin:8px}md-card .md-actions.layout-column .md-button:not(.md-icon-button),md-card md-card-actions.layout-column .md-button:not(.md-icon-button){margin:2px 0}md-card .md-actions.layout-column .md-button:not(.md-icon-button):first-of-type,md-card md-card-actions.layout-column .md-button:not(.md-icon-button):first-of-type{margin-top:0}md-card .md-actions.layout-column .md-button:not(.md-icon-button):last-of-type,md-card md-card-actions.layout-column .md-button:not(.md-icon-button):last-of-type{margin-bottom:0}md-card .md-actions.layout-column .md-button.md-icon-button,md-card md-card-actions.layout-column .md-button.md-icon-button{margin-top:6px;margin-bottom:6px}md-card .md-actions md-card-icon-actions,md-card md-card-actions md-card-icon-actions{-webkit-box-flex:1;-webkit-flex:1;flex:1;-webkit-box-pack:start;-webkit-justify-content:flex-start;justify-content:flex-start;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;flex-direction:row}md-card .md-actions:not(.layout-column) .md-button:not(.md-icon-button),md-card md-card-actions:not(.layout-column) .md-button:not(.md-icon-button){margin:0 4px}md-card .md-actions:not(.layout-column) .md-button:not(.md-icon-button):first-of-type,md-card md-card-actions:not(.layout-column) .md-button:not(.md-icon-button):first-of-type{margin-left:0}[dir=rtl] md-card .md-actions:not(.layout-column) .md-button:not(.md-icon-button):first-of-type,[dir=rtl] md-card md-card-actions:not(.layout-column) .md-button:not(.md-icon-button):first-of-type{margin-left:auto;margin-right:0}md-card .md-actions:not(.layout-column) .md-button:not(.md-icon-button):last-of-type,md-card md-card-actions:not(.layout-column) .md-button:not(.md-icon-button):last-of-type{margin-right:0}[dir=rtl] md-card .md-actions:not(.layout-column) .md-button:not(.md-icon-button):last-of-type,[dir=rtl] md-card md-card-actions:not(.layout-column) .md-button:not(.md-icon-button):last-of-type{margin-right:auto;margin-left:0}md-card .md-actions:not(.layout-column) .md-button.md-icon-button,md-card md-card-actions:not(.layout-column) .md-button.md-icon-button{margin-left:6px;margin-right:6px}md-card .md-actions:not(.layout-column) .md-button.md-icon-button:first-of-type,md-card md-card-actions:not(.layout-column) .md-button.md-icon-button:first-of-type{margin-left:12px}[dir=rtl] md-card .md-actions:not(.layout-column) .md-button.md-icon-button:first-of-type,[dir=rtl] md-card md-card-actions:not(.layout-column) .md-button.md-icon-button:first-of-type{margin-left:auto;margin-right:12px}md-card .md-actions:not(.layout-column) .md-button.md-icon-button:last-of-type,md-card md-card-actions:not(.layout-column) .md-button.md-icon-button:last-of-type{margin-right:12px}[dir=rtl] md-card .md-actions:not(.layout-column) .md-button.md-icon-button:last-of-type,[dir=rtl] md-card md-card-actions:not(.layout-column) .md-button.md-icon-button:last-of-type{margin-right:auto;margin-left:12px}md-card .md-actions:not(.layout-column) .md-button+md-card-icon-actions,md-card md-card-actions:not(.layout-column) .md-button+md-card-icon-actions{-webkit-box-flex:1;-webkit-flex:1;flex:1;-webkit-box-pack:end;-webkit-justify-content:flex-end;justify-content:flex-end;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;flex-direction:row}md-card md-card-footer{margin-top:auto;padding:16px}@media screen and (-ms-high-contrast:active){md-card{border:1px solid #fff}}.md-image-no-fill>img{width:auto;height:auto}.md-inline-form md-checkbox{margin:19px 0 18px}md-checkbox{box-sizing:border-box;display:inline-block;margin-bottom:16px;white-space:nowrap;cursor:pointer;outline:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;position:relative;min-width:20px;min-height:20px;margin-left:0;margin-right:16px}[dir=rtl] md-checkbox{margin-left:16px;margin-right:0}md-checkbox:last-of-type{margin-left:0;margin-right:0}md-checkbox.md-focused:not([disabled]) .md-container:before{left:-8px;top:-8px;right:-8px;bottom:-8px}md-checkbox.md-focused:not([disabled]):not(.md-checked) .md-container:before{background-color:rgba(0,0,0,.12)}md-checkbox.md-align-top-left>div.md-container{top:12px}md-checkbox .md-container{position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);box-sizing:border-box;display:inline-block;width:20px;height:20px;left:0;right:auto}[dir=rtl] md-checkbox .md-container{left:auto;right:0}md-checkbox .md-container:before{box-sizing:border-box;background-color:transparent;border-radius:50%;content:\"\";position:absolute;display:block;height:auto;left:0;top:0;right:0;bottom:0;-webkit-transition:all .5s;transition:all .5s;width:auto}md-checkbox .md-container:after{box-sizing:border-box;content:\"\";position:absolute;top:-10px;right:-10px;bottom:-10px;left:-10px}md-checkbox .md-container .md-ripple-container{position:absolute;display:block;width:auto;height:auto;left:-15px;top:-15px;right:-15px;bottom:-15px}md-checkbox .md-icon{box-sizing:border-box;-webkit-transition:.24s;transition:.24s;position:absolute;top:0;left:0;width:20px;height:20px;border-width:2px;border-style:solid;border-radius:2px}md-checkbox.md-checked .md-icon{border-color:transparent}md-checkbox.md-checked .md-icon:after{box-sizing:border-box;-webkit-transform:rotate(45deg);transform:rotate(45deg);position:absolute;left:4.66667px;top:.22222px;display:table;width:6.66667px;height:13.33333px;border-width:2px;border-style:solid;border-top:0;border-left:0;content:\"\"}md-checkbox[disabled]{cursor:default}md-checkbox.md-indeterminate .md-icon:after{box-sizing:border-box;position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);display:table;width:12px;height:2px;border-width:2px;border-style:solid;border-top:0;border-left:0;content:\"\"}md-checkbox .md-label{box-sizing:border-box;position:relative;display:inline-block;vertical-align:middle;white-space:normal;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text;margin-left:30px;margin-right:0}[dir=rtl] md-checkbox .md-label{margin-left:0;margin-right:30px}.md-contact-chips .md-chips md-chip{padding:0 25px 0 0}[dir=rtl] .md-contact-chips .md-chips md-chip{padding:0 0 0 25px}.md-contact-chips .md-chips md-chip .md-contact-avatar{float:left}[dir=rtl] .md-contact-chips .md-chips md-chip .md-contact-avatar{float:right}.md-contact-chips .md-chips md-chip .md-contact-avatar img{height:32px;border-radius:16px}.md-contact-chips .md-chips md-chip .md-contact-name{display:inline-block;height:32px;margin-left:8px}[dir=rtl] .md-contact-chips .md-chips md-chip .md-contact-name{margin-left:auto;margin-right:8px}.md-contact-suggestion{height:56px}.md-contact-suggestion img{height:40px;border-radius:20px;margin-top:8px}.md-contact-suggestion .md-contact-name{margin-left:8px;width:120px}[dir=rtl] .md-contact-suggestion .md-contact-name{margin-left:auto;margin-right:8px}.md-contact-suggestion .md-contact-email,.md-contact-suggestion .md-contact-name{display:inline-block;overflow:hidden;text-overflow:ellipsis}.md-contact-chips-suggestions li{height:100%}.md-chips{display:block;font-family:Roboto,Helvetica Neue,sans-serif;font-size:16px;padding:0 0 8px 3px;vertical-align:middle}.md-chips:after{content:\"\";display:table;clear:both}[dir=rtl] .md-chips{padding:0 3px 8px 0}.md-chips.md-readonly .md-chip-input-container{min-height:32px}.md-chips:not(.md-readonly){cursor:text}.md-chips.md-removable md-chip{padding-right:22px}[dir=rtl] .md-chips.md-removable md-chip{padding-right:0;padding-left:22px}.md-chips.md-removable md-chip .md-chip-content{padding-right:4px}[dir=rtl] .md-chips.md-removable md-chip .md-chip-content{padding-right:0;padding-left:4px}.md-chips md-chip{cursor:default;border-radius:16px;display:block;height:32px;line-height:32px;margin:8px 8px 0 0;padding:0 12px;float:left;box-sizing:border-box;max-width:100%;position:relative}[dir=rtl] .md-chips md-chip{margin:8px 0 0 8px;float:right}.md-chips md-chip .md-chip-content{display:block;float:left;white-space:nowrap;max-width:100%;overflow:hidden;text-overflow:ellipsis}[dir=rtl] .md-chips md-chip .md-chip-content{float:right}.md-chips md-chip .md-chip-content:focus{outline:none}.md-chips md-chip._md-chip-content-edit-is-enabled{-webkit-user-select:none;-moz-user-select:none;-khtml-user-select:none;-ms-user-select:none}.md-chips md-chip .md-chip-remove-container{position:absolute;right:0;line-height:22px}[dir=rtl] .md-chips md-chip .md-chip-remove-container{right:auto;left:0}.md-chips md-chip .md-chip-remove{text-align:center;width:32px;height:32px;min-width:0;padding:0;background:transparent;border:none;box-shadow:none;margin:0;position:relative}.md-chips md-chip .md-chip-remove md-icon{height:18px;width:18px;position:absolute;top:50%;left:50%;-webkit-transform:translate3d(-50%,-50%,0);transform:translate3d(-50%,-50%,0)}.md-chips .md-chip-input-container{display:block;line-height:32px;margin:8px 8px 0 0;padding:0;float:left}[dir=rtl] .md-chips .md-chip-input-container{margin:8px 0 0 8px;float:right}.md-chips .md-chip-input-container input:not([type]),.md-chips .md-chip-input-container input[type=email],.md-chips .md-chip-input-container input[type=number],.md-chips .md-chip-input-container input[type=tel],.md-chips .md-chip-input-container input[type=text],.md-chips .md-chip-input-container input[type=url]{border:0;height:32px;line-height:32px;padding:0}.md-chips .md-chip-input-container input:not([type]):focus,.md-chips .md-chip-input-container input[type=email]:focus,.md-chips .md-chip-input-container input[type=number]:focus,.md-chips .md-chip-input-container input[type=tel]:focus,.md-chips .md-chip-input-container input[type=text]:focus,.md-chips .md-chip-input-container input[type=url]:focus{outline:none}.md-chips .md-chip-input-container md-autocomplete,.md-chips .md-chip-input-container md-autocomplete-wrap{background:transparent}.md-chips .md-chip-input-container md-autocomplete md-autocomplete-wrap{box-shadow:none}.md-chips .md-chip-input-container input{border:0;height:32px;line-height:32px;padding:0}.md-chips .md-chip-input-container input:focus{outline:none}.md-chips .md-chip-input-container md-autocomplete,.md-chips .md-chip-input-container md-autocomplete-wrap{height:32px}.md-chips .md-chip-input-container md-autocomplete{box-shadow:none}.md-chips .md-chip-input-container md-autocomplete input{position:relative}.md-chips .md-chip-input-container:not(:first-child){margin:8px 8px 0 0}[dir=rtl] .md-chips .md-chip-input-container:not(:first-child){margin:8px 0 0 8px}.md-chips .md-chip-input-container input{background:transparent;border-width:0}.md-chips md-autocomplete button{display:none}@media screen and (-ms-high-contrast:active){.md-chip-input-container,md-chip{border:1px solid #fff}.md-chip-input-container md-autocomplete{border:none}}md-content{display:block;position:relative;overflow:auto;-webkit-overflow-scrolling:touch}md-content[md-scroll-y]{overflow-y:auto;overflow-x:hidden}md-content[md-scroll-x]{overflow-x:auto;overflow-y:hidden}@media print{md-content{overflow:visible!important}}md-calendar{font-size:13px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.md-calendar-scroll-mask{display:inline-block;overflow:hidden;height:308px}.md-calendar-scroll-mask .md-virtual-repeat-scroller{overflow-y:scroll;-webkit-overflow-scrolling:touch}.md-calendar-scroll-mask .md-virtual-repeat-scroller::-webkit-scrollbar{display:none}.md-calendar-scroll-mask .md-virtual-repeat-offsetter{width:100%}.md-calendar-scroll-container{box-shadow:inset -3px 3px 6px rgba(0,0,0,.2);display:inline-block;height:308px;width:346px}.md-calendar-date{height:44px;width:44px;text-align:center;padding:0;border:none;box-sizing:content-box}.md-calendar-date:first-child{padding-left:16px}[dir=rtl] .md-calendar-date:first-child{padding-left:0;padding-right:16px}.md-calendar-date:last-child{padding-right:16px}[dir=rtl] .md-calendar-date:last-child{padding-right:0;padding-left:16px}.md-calendar-date.md-calendar-date-disabled{cursor:default}.md-calendar-date-selection-indicator{-webkit-transition:background-color,color .4s cubic-bezier(.25,.8,.25,1);transition:background-color,color .4s cubic-bezier(.25,.8,.25,1);border-radius:50%;display:inline-block;width:40px;height:40px;line-height:40px}.md-calendar-date:not(.md-disabled) .md-calendar-date-selection-indicator{cursor:pointer}.md-calendar-month-label{height:44px;font-size:14px;font-weight:500;padding:0 0 0 24px}[dir=rtl] .md-calendar-month-label{padding:0 24px 0 0}md-calendar-month .md-calendar-month-label:not(.md-calendar-month-label-disabled){cursor:pointer}.md-calendar-month-label md-icon{-webkit-transform:rotate(180deg);transform:rotate(180deg)}[dir=rtl] .md-calendar-month-label md-icon{-webkit-transform:none;transform:none}.md-calendar-month-label span{vertical-align:middle}.md-calendar-day-header{table-layout:fixed;border-spacing:0;border-collapse:collapse}.md-calendar-day-header th{height:40px;width:44px;text-align:center;padding:0;border:none;box-sizing:content-box;font-weight:400}.md-calendar-day-header th:first-child{padding-left:16px}[dir=rtl] .md-calendar-day-header th:first-child{padding-left:0;padding-right:16px}.md-calendar-day-header th:last-child{padding-right:16px}[dir=rtl] .md-calendar-day-header th:last-child{padding-right:0;padding-left:16px}.md-calendar{table-layout:fixed;border-spacing:0;border-collapse:collapse}.md-calendar tr:last-child td{border-bottom-width:1px;border-bottom-style:solid}.md-calendar:first-child{border-top:1px solid transparent}.md-calendar tbody,.md-calendar td,.md-calendar tr{vertical-align:middle;box-sizing:content-box}md-datepicker{white-space:nowrap;overflow:hidden;vertical-align:middle}.md-inline-form md-datepicker{margin-top:12px}.md-datepicker-button{display:inline-block;box-sizing:border-box;background:none;vertical-align:middle;position:relative}.md-datepicker-button:before{top:0;left:0;bottom:0;right:0;position:absolute;content:\"\";speak:none}.md-datepicker-input{font-size:14px;box-sizing:border-box;border:none;box-shadow:none;outline:none;background:transparent;min-width:120px;max-width:328px;padding:0 0 5px}.md-datepicker-input::-ms-clear{display:none}._md-datepicker-floating-label>md-datepicker{overflow:visible}._md-datepicker-floating-label>md-datepicker .md-datepicker-input-container{border:none}._md-datepicker-floating-label>md-datepicker .md-datepicker-button{float:left;margin-top:-12px;top:9.5px}[dir=rtl] ._md-datepicker-floating-label>md-datepicker .md-datepicker-button{float:right}._md-datepicker-floating-label .md-input{float:none}._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore){right:18px;left:auto;width:calc(100% - 84px)}[dir=rtl] ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore){right:auto;left:18px}._md-datepicker-floating-label._md-datepicker-has-calendar-icon .md-input-message-animation{margin-left:64px}[dir=rtl] ._md-datepicker-floating-label._md-datepicker-has-calendar-icon .md-input-message-animation{margin-left:auto;margin-right:64px}._md-datepicker-has-triangle-icon{padding-right:18px;margin-right:-18px}[dir=rtl] ._md-datepicker-has-triangle-icon{padding-right:0;padding-left:18px;margin-right:auto;margin-left:-18px}.md-datepicker-input-container{position:relative;border-bottom-width:1px;border-bottom-style:solid;display:inline-block;width:auto}.md-icon-button+.md-datepicker-input-container{margin-left:12px}[dir=rtl] .md-icon-button+.md-datepicker-input-container{margin-left:auto;margin-right:12px}.md-datepicker-input-container.md-datepicker-focused{border-bottom-width:2px}.md-datepicker-is-showing .md-scroll-mask{z-index:99}.md-datepicker-calendar-pane{position:absolute;top:0;left:-100%;z-index:100;border-width:1px;border-style:solid;background:transparent;-webkit-transform:scale(0);transform:scale(0);-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transition:-webkit-transform .2s cubic-bezier(.25,.8,.25,1);transition:-webkit-transform .2s cubic-bezier(.25,.8,.25,1);transition:transform .2s cubic-bezier(.25,.8,.25,1);transition:transform .2s cubic-bezier(.25,.8,.25,1),-webkit-transform .2s cubic-bezier(.25,.8,.25,1)}.md-datepicker-calendar-pane.md-pane-open{-webkit-transform:scale(1);transform:scale(1)}.md-datepicker-input-mask{height:40px;width:340px;position:relative;overflow:hidden;background:transparent;pointer-events:none;cursor:text}.md-datepicker-calendar{opacity:0;-webkit-transition:opacity .2s cubic-bezier(.5,0,.25,1);transition:opacity .2s cubic-bezier(.5,0,.25,1)}.md-pane-open .md-datepicker-calendar{opacity:1}.md-datepicker-calendar md-calendar:focus{outline:none}.md-datepicker-expand-triangle{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top:5px solid}.md-datepicker-triangle-button{position:absolute;right:0;bottom:-2.5px;-webkit-transform:translateX(45%);transform:translateX(45%)}[dir=rtl] .md-datepicker-triangle-button{right:auto;left:0;-webkit-transform:translateX(-45%);transform:translateX(-45%)}.md-datepicker-triangle-button.md-button.md-icon-button{height:36px;width:36px;position:absolute;padding:8px}md-datepicker[disabled] .md-datepicker-input-container{border-bottom-color:transparent}md-datepicker[disabled] .md-datepicker-triangle-button{display:none}.md-datepicker-open{overflow:hidden}.md-datepicker-open .md-datepicker-input-container,.md-datepicker-open input.md-input{border-bottom-color:transparent}.md-datepicker-open .md-datepicker-triangle-button,.md-datepicker-open.md-input-has-placeholder>label,.md-datepicker-open.md-input-has-value>label,.md-datepicker-pos-adjusted .md-datepicker-input-mask{display:none}.md-datepicker-calendar-pane .md-calendar{-webkit-transform:translateY(-85px);transform:translateY(-85px);-webkit-transition:-webkit-transform .65s cubic-bezier(.25,.8,.25,1);transition:-webkit-transform .65s cubic-bezier(.25,.8,.25,1);transition:transform .65s cubic-bezier(.25,.8,.25,1);transition:transform .65s cubic-bezier(.25,.8,.25,1),-webkit-transform .65s cubic-bezier(.25,.8,.25,1);-webkit-transition-delay:.125s;transition-delay:.125s}.md-datepicker-calendar-pane.md-pane-open .md-calendar{-webkit-transform:translateY(0);transform:translateY(0)}.md-dialog-is-showing{max-height:100%}.md-dialog-container{-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;align-items:center;position:absolute;top:0;left:0;width:100%;height:100%;z-index:80;overflow:hidden}.md-dialog-container,md-dialog{display:-webkit-box;display:-webkit-flex;display:flex}md-dialog{opacity:0;min-width:240px;max-width:80%;max-height:80%;position:relative;overflow:auto;box-shadow:0 7px 8px -4px rgba(0,0,0,.2),0 13px 19px 2px rgba(0,0,0,.14),0 5px 24px 4px rgba(0,0,0,.12);-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column}md-dialog.md-transition-in{opacity:1;-webkit-transform:translate(0) scale(1);transform:translate(0) scale(1)}md-dialog.md-transition-in,md-dialog.md-transition-out{-webkit-transition:all .4s cubic-bezier(.25,.8,.25,1);transition:all .4s cubic-bezier(.25,.8,.25,1)}md-dialog.md-transition-out{opacity:0;-webkit-transform:translateY(100%) scale(.2);transform:translateY(100%) scale(.2)}md-dialog>form{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column;overflow:auto}md-dialog .md-dialog-content{padding:24px}md-dialog md-dialog-content{-webkit-box-ordinal-group:2;-webkit-order:1;order:1;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column;overflow:auto;-webkit-overflow-scrolling:touch}md-dialog md-dialog-content:not([layout=row])>:first-child:not(.md-subheader){margin-top:0}md-dialog md-dialog-content:focus{outline:none}md-dialog md-dialog-content .md-subheader{margin:0}md-dialog md-dialog-content .md-dialog-content-body{width:100%}md-dialog md-dialog-content .md-prompt-input-container{width:100%;box-sizing:border-box}md-dialog .md-actions,md-dialog md-dialog-actions{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-ordinal-group:3;-webkit-order:2;order:2;box-sizing:border-box;-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-box-pack:end;-webkit-justify-content:flex-end;justify-content:flex-end;margin-bottom:0;padding-right:8px;padding-left:16px;min-height:52px;overflow:hidden}[dir=rtl] md-dialog .md-actions,[dir=rtl] md-dialog md-dialog-actions{padding-right:16px;padding-left:8px}md-dialog .md-actions .md-button,md-dialog md-dialog-actions .md-button{margin:8px 0 8px 8px}[dir=rtl] md-dialog .md-actions .md-button,[dir=rtl] md-dialog md-dialog-actions .md-button{margin-left:0;margin-right:8px}md-dialog.md-content-overflow .md-actions,md-dialog.md-content-overflow md-dialog-actions{border-top-width:1px;border-top-style:solid}@media screen and (-ms-high-contrast:active){md-dialog{border:1px solid #fff}}@media (max-width:959px){md-dialog.md-dialog-fullscreen{min-height:100%;min-width:100%;border-radius:0}}md-divider{display:block;border-top-width:1px;border-top-style:solid;margin:0}md-divider[md-inset]{margin-left:80px}[dir=rtl] md-divider[md-inset]{margin-left:auto;margin-right:80px}.layout-gt-lg-row>md-divider,.layout-gt-md-row>md-divider,.layout-gt-sm-row>md-divider,.layout-gt-xs-row>md-divider,.layout-lg-row>md-divider,.layout-md-row>md-divider,.layout-row>md-divider,.layout-sm-row>md-divider,.layout-xl-row>md-divider,.layout-xs-row>md-divider{border-top-width:0;border-right-width:1px;border-right-style:solid}md-fab-speed-dial{position:relative;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:center;-webkit-align-items:center;align-items:center;z-index:20}md-fab-speed-dial.md-fab-bottom-right{top:auto;right:20px;bottom:20px;left:auto;position:absolute}md-fab-speed-dial.md-fab-bottom-left{top:auto;right:auto;bottom:20px;left:20px;position:absolute}md-fab-speed-dial.md-fab-top-right{top:20px;right:20px;bottom:auto;left:auto;position:absolute}md-fab-speed-dial.md-fab-top-left{top:20px;right:auto;bottom:auto;left:20px;position:absolute}md-fab-speed-dial:not(.md-hover-full){pointer-events:none}md-fab-speed-dial:not(.md-hover-full) .md-fab-action-item,md-fab-speed-dial:not(.md-hover-full).md-is-open,md-fab-speed-dial:not(.md-hover-full) md-fab-trigger{pointer-events:auto}md-fab-speed-dial ._md-css-variables{z-index:20}md-fab-speed-dial.md-is-open .md-fab-action-item{-webkit-box-align:center;-webkit-align-items:center;align-items:center}md-fab-speed-dial md-fab-actions{display:-webkit-box;display:-webkit-flex;display:flex;height:auto}md-fab-speed-dial md-fab-actions .md-fab-action-item{-webkit-transition:all .3s cubic-bezier(.55,0,.55,.2);transition:all .3s cubic-bezier(.55,0,.55,.2)}md-fab-speed-dial.md-down{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column}md-fab-speed-dial.md-down md-fab-trigger{-webkit-box-ordinal-group:2;-webkit-order:1;order:1}md-fab-speed-dial.md-down md-fab-actions{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column;-webkit-box-ordinal-group:3;-webkit-order:2;order:2}md-fab-speed-dial.md-up{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column}md-fab-speed-dial.md-up md-fab-trigger{-webkit-box-ordinal-group:3;-webkit-order:2;order:2}md-fab-speed-dial.md-up md-fab-actions{-webkit-box-orient:vertical;-webkit-box-direction:reverse;-webkit-flex-direction:column-reverse;flex-direction:column-reverse;-webkit-box-ordinal-group:2;-webkit-order:1;order:1}md-fab-speed-dial.md-left{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;flex-direction:row}md-fab-speed-dial.md-left md-fab-trigger{-webkit-box-ordinal-group:3;-webkit-order:2;order:2}md-fab-speed-dial.md-left md-fab-actions{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-webkit-flex-direction:row-reverse;flex-direction:row-reverse;-webkit-box-ordinal-group:2;-webkit-order:1;order:1}md-fab-speed-dial.md-left md-fab-actions .md-fab-action-item{-webkit-transition:all .3s cubic-bezier(.55,0,.55,.2);transition:all .3s cubic-bezier(.55,0,.55,.2)}md-fab-speed-dial.md-right{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;flex-direction:row}md-fab-speed-dial.md-right md-fab-trigger{-webkit-box-ordinal-group:2;-webkit-order:1;order:1}md-fab-speed-dial.md-right md-fab-actions{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;flex-direction:row;-webkit-box-ordinal-group:3;-webkit-order:2;order:2}md-fab-speed-dial.md-right md-fab-actions .md-fab-action-item{-webkit-transition:all .3s cubic-bezier(.55,0,.55,.2);transition:all .3s cubic-bezier(.55,0,.55,.2)}md-fab-speed-dial.md-fling-remove .md-fab-action-item>*,md-fab-speed-dial.md-scale-remove .md-fab-action-item>*{visibility:hidden}md-fab-speed-dial.md-fling .md-fab-action-item{opacity:1}md-fab-speed-dial.md-fling.md-animations-waiting .md-fab-action-item{opacity:0;-webkit-transition-duration:0s;transition-duration:0s}md-fab-speed-dial.md-scale .md-fab-action-item{-webkit-transform:scale(0);transform:scale(0);-webkit-transition:all .3s cubic-bezier(.55,0,.55,.2);transition:all .3s cubic-bezier(.55,0,.55,.2);-webkit-transition-duration:.14286s;transition-duration:.14286s}md-fab-toolbar{display:block}md-fab-toolbar.md-fab-bottom-right{top:auto;right:20px;bottom:20px;left:auto;position:absolute}md-fab-toolbar.md-fab-bottom-left{top:auto;right:auto;bottom:20px;left:20px;position:absolute}md-fab-toolbar.md-fab-top-right{top:20px;right:20px;bottom:auto;left:auto;position:absolute}md-fab-toolbar.md-fab-top-left{top:20px;right:auto;bottom:auto;left:20px;position:absolute}md-fab-toolbar .md-fab-toolbar-wrapper{display:block;position:relative;overflow:hidden;height:68px}md-fab-toolbar md-fab-trigger{position:absolute;z-index:20}md-fab-toolbar md-fab-trigger button{overflow:visible!important}md-fab-toolbar md-fab-trigger .md-fab-toolbar-background{display:block;position:absolute;z-index:21;opacity:1;-webkit-transition:all .3s cubic-bezier(.55,0,.55,.2);transition:all .3s cubic-bezier(.55,0,.55,.2)}md-fab-toolbar md-fab-trigger md-icon{position:relative;z-index:22;opacity:1;-webkit-transition:all .2s ease-in;transition:all .2s ease-in}md-fab-toolbar.md-left md-fab-trigger{right:0}[dir=rtl] md-fab-toolbar.md-left md-fab-trigger{right:auto;left:0}md-fab-toolbar.md-left .md-toolbar-tools{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-webkit-flex-direction:row-reverse;flex-direction:row-reverse}md-fab-toolbar.md-left .md-toolbar-tools>.md-button:first-child{margin-right:.6rem}[dir=rtl] md-fab-toolbar.md-left .md-toolbar-tools>.md-button:first-child{margin-right:auto;margin-left:.6rem}md-fab-toolbar.md-left .md-toolbar-tools>.md-button:first-child{margin-left:-.8rem}[dir=rtl] md-fab-toolbar.md-left .md-toolbar-tools>.md-button:first-child{margin-left:auto;margin-right:-.8rem}md-fab-toolbar.md-left .md-toolbar-tools>.md-button:last-child{margin-right:8px}[dir=rtl] md-fab-toolbar.md-left .md-toolbar-tools>.md-button:last-child{margin-right:auto;margin-left:8px}md-fab-toolbar.md-right md-fab-trigger{left:0}[dir=rtl] md-fab-toolbar.md-right md-fab-trigger{left:auto;right:0}md-fab-toolbar.md-right .md-toolbar-tools{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;flex-direction:row}md-fab-toolbar md-toolbar{background-color:transparent!important;pointer-events:none;z-index:23}md-fab-toolbar md-toolbar .md-toolbar-tools{padding:0 20px;margin-top:3px}md-fab-toolbar md-toolbar .md-fab-action-item{opacity:0;-webkit-transform:scale(0);transform:scale(0);-webkit-transition:all .3s cubic-bezier(.55,0,.55,.2);transition:all .3s cubic-bezier(.55,0,.55,.2);-webkit-transition-duration:.15s;transition-duration:.15s}md-fab-toolbar.md-is-open md-fab-trigger>button{box-shadow:none}md-fab-toolbar.md-is-open md-fab-trigger>button md-icon{opacity:0}md-fab-toolbar.md-is-open .md-fab-action-item{opacity:1;-webkit-transform:scale(1);transform:scale(1)}md-grid-list{display:block;position:relative}md-grid-list,md-grid-list md-grid-tile,md-grid-list md-grid-tile-footer,md-grid-list md-grid-tile-header,md-grid-list md-grid-tile>figure{box-sizing:border-box}md-grid-list md-grid-tile{display:block;position:absolute}md-grid-list md-grid-tile figure{-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center;height:100%;top:0;bottom:0;padding:0;margin:0}md-grid-list md-grid-tile figure,md-grid-list md-grid-tile md-grid-tile-footer,md-grid-list md-grid-tile md-grid-tile-header{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:center;-webkit-align-items:center;align-items:center;position:absolute;right:0;left:0}md-grid-list md-grid-tile md-grid-tile-footer,md-grid-list md-grid-tile md-grid-tile-header{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;flex-direction:row;height:48px;color:#fff;background:rgba(0,0,0,.18);overflow:hidden}md-grid-list md-grid-tile md-grid-tile-footer h3,md-grid-list md-grid-tile md-grid-tile-footer h4,md-grid-list md-grid-tile md-grid-tile-header h3,md-grid-list md-grid-tile md-grid-tile-header h4{font-weight:400;margin:0 0 0 16px}md-grid-list md-grid-tile md-grid-tile-footer h3,md-grid-list md-grid-tile md-grid-tile-header h3{font-size:14px}md-grid-list md-grid-tile md-grid-tile-footer h4,md-grid-list md-grid-tile md-grid-tile-header h4{font-size:12px}md-grid-list md-grid-tile md-grid-tile-header{top:0}md-grid-list md-grid-tile md-grid-tile-footer{bottom:0}@media screen and (-ms-high-contrast:active){md-grid-tile{border:1px solid #fff}md-grid-tile-footer{border-top:1px solid #fff}}md-icon{margin:auto;background-repeat:no-repeat;display:inline-block;vertical-align:middle;fill:currentColor;height:24px;width:24px;min-height:24px;min-width:24px}md-icon svg{pointer-events:none;display:block}md-icon[md-font-icon]{line-height:24px;width:auto}md-input-container{display:inline-block;position:relative;padding:2px;margin:18px 0;vertical-align:middle}md-input-container:after{content:\"\";display:table;clear:both}md-input-container.md-block{display:block}md-input-container .md-errors-spacer{float:right;min-height:24px;min-width:1px}[dir=rtl] md-input-container .md-errors-spacer{float:left}md-input-container>md-icon{position:absolute;top:8px;left:2px;right:auto}[dir=rtl] md-input-container>md-icon{left:auto;right:2px}md-input-container input[type=color],md-input-container input[type=date],md-input-container input[type=datetime-local],md-input-container input[type=datetime],md-input-container input[type=email],md-input-container input[type=month],md-input-container input[type=number],md-input-container input[type=password],md-input-container input[type=search],md-input-container input[type=tel],md-input-container input[type=text],md-input-container input[type=time],md-input-container input[type=url],md-input-container input[type=week],md-input-container textarea{-moz-appearance:none;-webkit-appearance:none}md-input-container input[type=date],md-input-container input[type=datetime-local],md-input-container input[type=month],md-input-container input[type=time],md-input-container input[type=week]{min-height:26px}md-input-container textarea{resize:none;overflow:hidden}md-input-container textarea.md-input{min-height:26px;-ms-flex-preferred-size:auto}md-input-container textarea[md-no-autogrow]{height:auto;overflow:auto}md-input-container label:not(.md-container-ignore){position:absolute;bottom:100%;left:0;right:auto}[dir=rtl] md-input-container label:not(.md-container-ignore){left:auto;right:0}md-input-container label:not(.md-container-ignore).md-required:after{content:\" *\";font-size:13px;vertical-align:top}md-input-container .md-placeholder,md-input-container label:not(.md-no-float):not(.md-container-ignore){overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:100%;-webkit-box-ordinal-group:2;-webkit-order:1;order:1;pointer-events:none;-webkit-font-smoothing:antialiased;padding-left:3px;padding-right:0;z-index:1;-webkit-transform:translate3d(0,28px,0) scale(1);transform:translate3d(0,28px,0) scale(1);-webkit-transition:-webkit-transform .4s cubic-bezier(.25,.8,.25,1);transition:-webkit-transform .4s cubic-bezier(.25,.8,.25,1);transition:transform .4s cubic-bezier(.25,.8,.25,1);transition:transform .4s cubic-bezier(.25,.8,.25,1),-webkit-transform .4s cubic-bezier(.25,.8,.25,1);max-width:100%;-webkit-transform-origin:left top;transform-origin:left top}[dir=rtl] md-input-container .md-placeholder,[dir=rtl] md-input-container label:not(.md-no-float):not(.md-container-ignore){padding-left:0;padding-right:3px;-webkit-transform-origin:right top;transform-origin:right top}md-input-container .md-placeholder{position:absolute;top:0;opacity:0;-webkit-transition-property:opacity,-webkit-transform;transition-property:opacity,-webkit-transform;transition-property:opacity,transform;transition-property:opacity,transform,-webkit-transform;-webkit-transform:translate3d(0,30px,0);transform:translate3d(0,30px,0)}md-input-container.md-input-focused .md-placeholder{opacity:1;-webkit-transform:translate3d(0,24px,0);transform:translate3d(0,24px,0)}md-input-container.md-input-has-value .md-placeholder{-webkit-transition:none;transition:none;opacity:0}md-input-container:not(.md-input-has-value) input:not(:focus),md-input-container:not(.md-input-has-value) input:not(:focus)::-webkit-datetime-edit-ampm-field,md-input-container:not(.md-input-has-value) input:not(:focus)::-webkit-datetime-edit-day-field,md-input-container:not(.md-input-has-value) input:not(:focus)::-webkit-datetime-edit-hour-field,md-input-container:not(.md-input-has-value) input:not(:focus)::-webkit-datetime-edit-millisecond-field,md-input-container:not(.md-input-has-value) input:not(:focus)::-webkit-datetime-edit-minute-field,md-input-container:not(.md-input-has-value) input:not(:focus)::-webkit-datetime-edit-month-field,md-input-container:not(.md-input-has-value) input:not(:focus)::-webkit-datetime-edit-second-field,md-input-container:not(.md-input-has-value) input:not(:focus)::-webkit-datetime-edit-text,md-input-container:not(.md-input-has-value) input:not(:focus)::-webkit-datetime-edit-week-field,md-input-container:not(.md-input-has-value) input:not(:focus)::-webkit-datetime-edit-year-field{color:transparent}md-input-container .md-input{-webkit-box-ordinal-group:3;-webkit-order:2;order:2;display:block;margin-top:0;background:none;padding:2px 2px 1px;border-width:0 0 1px;line-height:26px;height:30px;-ms-flex-preferred-size:26px;border-radius:0;border-style:solid;width:100%;box-sizing:border-box;float:left}[dir=rtl] md-input-container .md-input{float:right}md-input-container .md-input:focus{outline:none}md-input-container .md-input:invalid{outline:none;box-shadow:none}md-input-container .md-input.md-no-flex{-webkit-box-flex:0!important;-webkit-flex:none!important;flex:none!important}md-input-container .md-char-counter{text-align:right;padding-right:2px;padding-left:0}[dir=rtl] md-input-container .md-char-counter{text-align:left;padding-right:0;padding-left:2px}md-input-container .md-input-messages-animation{position:relative;-webkit-box-ordinal-group:5;-webkit-order:4;order:4;overflow:hidden;clear:left}[dir=rtl] md-input-container .md-input-messages-animation{clear:right}md-input-container .md-input-messages-animation.ng-enter .md-input-message-animation{opacity:0;margin-top:-100px}md-input-container .md-char-counter,md-input-container .md-input-message-animation{font-size:12px;line-height:14px;overflow:hidden;-webkit-transition:all .3s cubic-bezier(.55,0,.55,.2);transition:all .3s cubic-bezier(.55,0,.55,.2);opacity:1;margin-top:0;padding-top:5px}md-input-container .md-char-counter:not(.md-char-counter),md-input-container .md-input-message-animation:not(.md-char-counter){padding-right:5px;padding-left:0}[dir=rtl] md-input-container .md-char-counter:not(.md-char-counter),[dir=rtl] md-input-container .md-input-message-animation:not(.md-char-counter){padding-right:0;padding-left:5px}md-input-container .md-input-message-animation.ng-enter,md-input-container .md-input-message-animation:not(.ng-animate),md-input-container:not(.md-input-invalid) .md-auto-hide .md-input-message-animation{opacity:0;margin-top:-100px}md-input-container.md-input-focused label:not(.md-no-float),md-input-container.md-input-has-placeholder label:not(.md-no-float),md-input-container.md-input-has-value label:not(.md-no-float){-webkit-transform:translate3d(0,6px,0) scale(.75);transform:translate3d(0,6px,0) scale(.75);-webkit-transition:width .4s cubic-bezier(.25,.8,.25,1),-webkit-transform .4s cubic-bezier(.25,.8,.25,1);transition:width .4s cubic-bezier(.25,.8,.25,1),-webkit-transform .4s cubic-bezier(.25,.8,.25,1);transition:transform .4s cubic-bezier(.25,.8,.25,1),width .4s cubic-bezier(.25,.8,.25,1);transition:transform .4s cubic-bezier(.25,.8,.25,1),width .4s cubic-bezier(.25,.8,.25,1),-webkit-transform .4s cubic-bezier(.25,.8,.25,1)}md-input-container.md-input-has-value label{-webkit-transition:none;transition:none}md-input-container.md-input-focused .md-input,md-input-container.md-input-resized .md-input,md-input-container .md-input.ng-invalid.ng-dirty{padding-bottom:0;border-width:0 0 2px}[disabled] md-input-container .md-input,md-input-container .md-input[disabled]{background-position:bottom -1px left 0;background-size:4px 1px;background-repeat:repeat-x}md-input-container.md-icon-float{-webkit-transition:margin-top .4s cubic-bezier(.25,.8,.25,1);transition:margin-top .4s cubic-bezier(.25,.8,.25,1)}md-input-container.md-icon-float>label{pointer-events:none;position:absolute}md-input-container.md-icon-float>md-icon{top:8px;left:2px;right:auto}[dir=rtl] md-input-container.md-icon-float>md-icon{left:auto;right:2px}md-input-container.md-icon-left>label .md-placeholder,md-input-container.md-icon-left>label:not(.md-no-float):not(.md-container-ignore),md-input-container.md-icon-right>label .md-placeholder,md-input-container.md-icon-right>label:not(.md-no-float):not(.md-container-ignore){width:calc(100% - 36px - 18px)}md-input-container.md-icon-left{padding-left:36px;padding-right:0}[dir=rtl] md-input-container.md-icon-left{padding-left:0;padding-right:36px}md-input-container.md-icon-left>label{left:36px;right:auto}[dir=rtl] md-input-container.md-icon-left>label{left:auto;right:36px}md-input-container.md-icon-right{padding-left:0;padding-right:36px}[dir=rtl] md-input-container.md-icon-right{padding-left:36px;padding-right:0}md-input-container.md-icon-right>md-icon:last-of-type{margin:0;right:2px;left:auto}[dir=rtl] md-input-container.md-icon-right>md-icon:last-of-type{right:auto;left:2px}md-input-container.md-icon-left.md-icon-right{padding-left:36px;padding-right:36px}md-input-container.md-icon-left.md-icon-right>label .md-placeholder,md-input-container.md-icon-left.md-icon-right>label:not(.md-no-float):not(.md-container-ignore){width:calc(100% - 72px)}.md-resize-wrapper{position:relative}.md-resize-wrapper:after{content:\"\";display:table;clear:both}.md-resize-handle{position:absolute;bottom:-5px;left:0;height:10px;background:transparent;width:100%;cursor:ns-resize}@media screen and (-ms-high-contrast:active){md-input-container.md-default-theme>md-icon{fill:#fff}}md-list{display:block;padding:8px 0}md-list .md-subheader{font-size:14px;font-weight:500;letter-spacing:.01em;line-height:1.2em}md-list.md-dense md-list-item,md-list.md-dense md-list-item .md-list-item-inner{min-height:48px}md-list.md-dense md-list-item .md-list-item-inner:before,md-list.md-dense md-list-item:before{content:\"\";min-height:48px;visibility:hidden;display:inline-block}md-list.md-dense md-list-item .md-list-item-inner md-icon:first-child,md-list.md-dense md-list-item md-icon:first-child{width:20px;height:20px}md-list.md-dense md-list-item .md-list-item-inner>md-icon:first-child:not(.md-avatar-icon),md-list.md-dense md-list-item>md-icon:first-child:not(.md-avatar-icon){margin-right:36px}[dir=rtl] md-list.md-dense md-list-item .md-list-item-inner>md-icon:first-child:not(.md-avatar-icon),[dir=rtl] md-list.md-dense md-list-item>md-icon:first-child:not(.md-avatar-icon){margin-right:auto;margin-left:36px}md-list.md-dense md-list-item .md-avatar,md-list.md-dense md-list-item .md-avatar-icon,md-list.md-dense md-list-item .md-list-item-inner .md-avatar,md-list.md-dense md-list-item .md-list-item-inner .md-avatar-icon{margin-right:20px}[dir=rtl] md-list.md-dense md-list-item .md-avatar,[dir=rtl] md-list.md-dense md-list-item .md-avatar-icon,[dir=rtl] md-list.md-dense md-list-item .md-list-item-inner .md-avatar,[dir=rtl] md-list.md-dense md-list-item .md-list-item-inner .md-avatar-icon{margin-right:auto;margin-left:20px}md-list.md-dense md-list-item .md-avatar,md-list.md-dense md-list-item .md-list-item-inner .md-avatar{-webkit-box-flex:0;-webkit-flex:none;flex:none;width:36px;height:36px}md-list.md-dense md-list-item.md-2-line .md-list-item-text.md-offset,md-list.md-dense md-list-item.md-2-line>.md-no-style .md-list-item-text.md-offset,md-list.md-dense md-list-item.md-3-line .md-list-item-text.md-offset,md-list.md-dense md-list-item.md-3-line>.md-no-style .md-list-item-text.md-offset{margin-left:56px}[dir=rtl] md-list.md-dense md-list-item.md-2-line .md-list-item-text.md-offset,[dir=rtl] md-list.md-dense md-list-item.md-2-line>.md-no-style .md-list-item-text.md-offset,[dir=rtl] md-list.md-dense md-list-item.md-3-line .md-list-item-text.md-offset,[dir=rtl] md-list.md-dense md-list-item.md-3-line>.md-no-style .md-list-item-text.md-offset{margin-left:auto;margin-right:56px}md-list.md-dense md-list-item.md-2-line .md-list-item-text h3,md-list.md-dense md-list-item.md-2-line .md-list-item-text h4,md-list.md-dense md-list-item.md-2-line .md-list-item-text p,md-list.md-dense md-list-item.md-2-line>.md-no-style .md-list-item-text h3,md-list.md-dense md-list-item.md-2-line>.md-no-style .md-list-item-text h4,md-list.md-dense md-list-item.md-2-line>.md-no-style .md-list-item-text p,md-list.md-dense md-list-item.md-3-line .md-list-item-text h3,md-list.md-dense md-list-item.md-3-line .md-list-item-text h4,md-list.md-dense md-list-item.md-3-line .md-list-item-text p,md-list.md-dense md-list-item.md-3-line>.md-no-style .md-list-item-text h3,md-list.md-dense md-list-item.md-3-line>.md-no-style .md-list-item-text h4,md-list.md-dense md-list-item.md-3-line>.md-no-style .md-list-item-text p{line-height:1.05;font-size:12px}md-list.md-dense md-list-item.md-2-line .md-list-item-text h3,md-list.md-dense md-list-item.md-2-line>.md-no-style .md-list-item-text h3,md-list.md-dense md-list-item.md-3-line .md-list-item-text h3,md-list.md-dense md-list-item.md-3-line>.md-no-style .md-list-item-text h3{font-size:13px}md-list.md-dense md-list-item.md-2-line,md-list.md-dense md-list-item.md-2-line>.md-no-style{min-height:60px}md-list.md-dense md-list-item.md-2-line:before,md-list.md-dense md-list-item.md-2-line>.md-no-style:before{content:\"\";min-height:60px;visibility:hidden;display:inline-block}md-list.md-dense md-list-item.md-2-line .md-avatar-icon,md-list.md-dense md-list-item.md-2-line>.md-avatar,md-list.md-dense md-list-item.md-2-line>.md-no-style .md-avatar-icon,md-list.md-dense md-list-item.md-2-line>.md-no-style>.md-avatar{margin-top:12px}md-list.md-dense md-list-item.md-3-line,md-list.md-dense md-list-item.md-3-line>.md-no-style{min-height:76px}md-list.md-dense md-list-item.md-3-line:before,md-list.md-dense md-list-item.md-3-line>.md-no-style:before{content:\"\";min-height:76px;visibility:hidden;display:inline-block}md-list.md-dense md-list-item.md-3-line>.md-avatar,md-list.md-dense md-list-item.md-3-line>.md-no-style>.md-avatar,md-list.md-dense md-list-item.md-3-line>.md-no-style>md-icon:first-child,md-list.md-dense md-list-item.md-3-line>md-icon:first-child{margin-top:16px}md-list-item{position:relative}md-list-item.md-proxy-focus.md-focused .md-no-style{-webkit-transition:background-color .15s linear;transition:background-color .15s linear}md-list-item._md-button-wrap{position:relative}md-list-item._md-button-wrap>div.md-button:first-child{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-box-pack:start;-webkit-justify-content:flex-start;justify-content:flex-start;padding:0 16px;margin:0;font-weight:400;text-align:left;border:medium none}[dir=rtl] md-list-item._md-button-wrap>div.md-button:first-child{text-align:right}md-list-item._md-button-wrap>div.md-button:first-child>.md-button:first-child{position:absolute;top:0;left:0;height:100%;margin:0;padding:0}md-list-item._md-button-wrap>div.md-button:first-child .md-list-item-inner{width:100%;min-height:inherit}md-list-item.md-no-proxy,md-list-item .md-no-style{position:relative;padding:0 16px;-webkit-box-flex:1;-webkit-flex:1 1 auto;flex:1 1 auto}md-list-item.md-no-proxy.md-button,md-list-item .md-no-style.md-button{font-size:inherit;height:inherit;text-align:left;text-transform:none;width:100%;white-space:normal;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:inherit;flex-direction:inherit;-webkit-box-align:inherit;-webkit-align-items:inherit;align-items:inherit;border-radius:0;margin:0}[dir=rtl] md-list-item.md-no-proxy.md-button,[dir=rtl] md-list-item .md-no-style.md-button{text-align:right}md-list-item.md-no-proxy.md-button>.md-ripple-container,md-list-item .md-no-style.md-button>.md-ripple-container{border-radius:0}md-list-item.md-no-proxy:focus,md-list-item .md-no-style:focus{outline:none}md-list-item.md-clickable:hover{cursor:pointer}md-list-item md-divider{position:absolute;bottom:0;left:0;width:100%}[dir=rtl] md-list-item md-divider{left:auto;right:0}md-list-item md-divider[md-inset]{left:72px;width:calc(100% - 72px);margin:0!important}[dir=rtl] md-list-item md-divider[md-inset]{left:auto;right:72px}md-list-item,md-list-item .md-list-item-inner{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-pack:start;-webkit-justify-content:flex-start;justify-content:flex-start;-webkit-box-align:center;-webkit-align-items:center;align-items:center;min-height:48px;height:auto}md-list-item .md-list-item-inner:before,md-list-item:before{content:\"\";min-height:48px;visibility:hidden;display:inline-block}md-list-item .md-list-item-inner>div.md-primary>md-icon:not(.md-avatar-icon),md-list-item .md-list-item-inner>div.md-secondary>md-icon:not(.md-avatar-icon),md-list-item .md-list-item-inner>md-icon.md-secondary:not(.md-avatar-icon),md-list-item .md-list-item-inner>md-icon:first-child:not(.md-avatar-icon),md-list-item>div.md-primary>md-icon:not(.md-avatar-icon),md-list-item>div.md-secondary>md-icon:not(.md-avatar-icon),md-list-item>md-icon.md-secondary:not(.md-avatar-icon),md-list-item>md-icon:first-child:not(.md-avatar-icon){width:24px;margin-top:16px;margin-bottom:12px;box-sizing:content-box}md-list-item .md-list-item-inner>div.md-primary>md-checkbox,md-list-item .md-list-item-inner>div.md-secondary>md-checkbox,md-list-item .md-list-item-inner>md-checkbox,md-list-item .md-list-item-inner md-checkbox.md-secondary,md-list-item>div.md-primary>md-checkbox,md-list-item>div.md-secondary>md-checkbox,md-list-item>md-checkbox,md-list-item md-checkbox.md-secondary{-webkit-align-self:center;-ms-grid-row-align:center;align-self:center}md-list-item .md-list-item-inner>div.md-primary>md-checkbox .md-label,md-list-item .md-list-item-inner>div.md-secondary>md-checkbox .md-label,md-list-item .md-list-item-inner>md-checkbox .md-label,md-list-item .md-list-item-inner md-checkbox.md-secondary .md-label,md-list-item>div.md-primary>md-checkbox .md-label,md-list-item>div.md-secondary>md-checkbox .md-label,md-list-item>md-checkbox .md-label,md-list-item md-checkbox.md-secondary .md-label{display:none}md-list-item .md-list-item-inner>md-icon:first-child:not(.md-avatar-icon),md-list-item>md-icon:first-child:not(.md-avatar-icon){margin-right:32px}[dir=rtl] md-list-item .md-list-item-inner>md-icon:first-child:not(.md-avatar-icon),[dir=rtl] md-list-item>md-icon:first-child:not(.md-avatar-icon){margin-right:auto;margin-left:32px}md-list-item .md-avatar,md-list-item .md-avatar-icon,md-list-item .md-list-item-inner .md-avatar,md-list-item .md-list-item-inner .md-avatar-icon{margin-top:8px;margin-bottom:8px;margin-right:16px;border-radius:50%;box-sizing:content-box}[dir=rtl] md-list-item .md-avatar,[dir=rtl] md-list-item .md-avatar-icon,[dir=rtl] md-list-item .md-list-item-inner .md-avatar,[dir=rtl] md-list-item .md-list-item-inner .md-avatar-icon{margin-right:auto;margin-left:16px}md-list-item .md-avatar,md-list-item .md-list-item-inner .md-avatar{-webkit-box-flex:0;-webkit-flex:none;flex:none;width:40px;height:40px}md-list-item .md-avatar-icon,md-list-item .md-list-item-inner .md-avatar-icon{padding:8px}md-list-item .md-avatar-icon svg,md-list-item .md-list-item-inner .md-avatar-icon svg{width:24px;height:24px}md-list-item .md-list-item-inner>md-checkbox,md-list-item>md-checkbox{width:24px;margin-left:3px;margin-right:29px;margin-top:16px}[dir=rtl] md-list-item .md-list-item-inner>md-checkbox,[dir=rtl] md-list-item>md-checkbox{margin-left:29px;margin-right:3px}md-list-item .md-list-item-inner .md-secondary-container,md-list-item .md-secondary-container{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-flex-shrink:0;flex-shrink:0;margin:auto;margin-right:0;margin-left:auto}[dir=rtl] md-list-item .md-list-item-inner .md-secondary-container,[dir=rtl] md-list-item .md-secondary-container{margin-right:auto;margin-left:0}md-list-item .md-list-item-inner .md-secondary-container .md-button:last-of-type,md-list-item .md-list-item-inner .md-secondary-container .md-icon-button:last-of-type,md-list-item .md-secondary-container .md-button:last-of-type,md-list-item .md-secondary-container .md-icon-button:last-of-type{margin-right:0}[dir=rtl] md-list-item .md-list-item-inner .md-secondary-container .md-button:last-of-type,[dir=rtl] md-list-item .md-list-item-inner .md-secondary-container .md-icon-button:last-of-type,[dir=rtl] md-list-item .md-secondary-container .md-button:last-of-type,[dir=rtl] md-list-item .md-secondary-container .md-icon-button:last-of-type{margin-right:auto;margin-left:0}md-list-item .md-list-item-inner .md-secondary-container md-checkbox,md-list-item .md-secondary-container md-checkbox{margin-top:0;margin-bottom:0}md-list-item .md-list-item-inner .md-secondary-container md-checkbox:last-child,md-list-item .md-secondary-container md-checkbox:last-child{width:24px;margin-right:0}[dir=rtl] md-list-item .md-list-item-inner .md-secondary-container md-checkbox:last-child,[dir=rtl] md-list-item .md-secondary-container md-checkbox:last-child{margin-right:auto;margin-left:0}md-list-item .md-list-item-inner .md-secondary-container md-switch,md-list-item .md-secondary-container md-switch{margin-top:0;margin-bottom:0;margin-right:-6px}[dir=rtl] md-list-item .md-list-item-inner .md-secondary-container md-switch,[dir=rtl] md-list-item .md-secondary-container md-switch{margin-right:auto;margin-left:-6px}md-list-item .md-list-item-inner>.md-list-item-inner>p,md-list-item .md-list-item-inner>p,md-list-item>.md-list-item-inner>p,md-list-item>p{-webkit-box-flex:1;-webkit-flex:1 1 auto;flex:1 1 auto;margin:0}md-list-item.md-2-line,md-list-item.md-2-line>.md-no-style,md-list-item.md-3-line,md-list-item.md-3-line>.md-no-style{-webkit-box-align:start;-webkit-align-items:flex-start;align-items:flex-start;-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center}md-list-item.md-2-line.md-long-text,md-list-item.md-2-line>.md-no-style.md-long-text,md-list-item.md-3-line.md-long-text,md-list-item.md-3-line>.md-no-style.md-long-text{margin-top:8px;margin-bottom:8px}md-list-item.md-2-line .md-list-item-text,md-list-item.md-2-line>.md-no-style .md-list-item-text,md-list-item.md-3-line .md-list-item-text,md-list-item.md-3-line>.md-no-style .md-list-item-text{-webkit-box-flex:1;-webkit-flex:1 1 auto;flex:1 1 auto;margin:auto;text-overflow:ellipsis;overflow:hidden}md-list-item.md-2-line .md-list-item-text.md-offset,md-list-item.md-2-line>.md-no-style .md-list-item-text.md-offset,md-list-item.md-3-line .md-list-item-text.md-offset,md-list-item.md-3-line>.md-no-style .md-list-item-text.md-offset{margin-left:56px}[dir=rtl] md-list-item.md-2-line .md-list-item-text.md-offset,[dir=rtl] md-list-item.md-2-line>.md-no-style .md-list-item-text.md-offset,[dir=rtl] md-list-item.md-3-line .md-list-item-text.md-offset,[dir=rtl] md-list-item.md-3-line>.md-no-style .md-list-item-text.md-offset{margin-left:auto;margin-right:56px}md-list-item.md-2-line .md-list-item-text h3,md-list-item.md-2-line>.md-no-style .md-list-item-text h3,md-list-item.md-3-line .md-list-item-text h3,md-list-item.md-3-line>.md-no-style .md-list-item-text h3{font-size:16px;font-weight:400;letter-spacing:.01em;margin:0;line-height:1.2em;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}md-list-item.md-2-line .md-list-item-text h4,md-list-item.md-2-line>.md-no-style .md-list-item-text h4,md-list-item.md-3-line .md-list-item-text h4,md-list-item.md-3-line>.md-no-style .md-list-item-text h4{font-size:14px;letter-spacing:.01em;margin:3px 0 1px;font-weight:400;line-height:1.2em;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}md-list-item.md-2-line .md-list-item-text p,md-list-item.md-2-line>.md-no-style .md-list-item-text p,md-list-item.md-3-line .md-list-item-text p,md-list-item.md-3-line>.md-no-style .md-list-item-text p{font-size:14px;font-weight:500;letter-spacing:.01em;margin:0;line-height:1.6em}md-list-item.md-2-line,md-list-item.md-2-line>.md-no-style{height:auto;min-height:72px}md-list-item.md-2-line:before,md-list-item.md-2-line>.md-no-style:before{content:\"\";min-height:72px;visibility:hidden;display:inline-block}md-list-item.md-2-line .md-avatar-icon,md-list-item.md-2-line>.md-avatar,md-list-item.md-2-line>.md-no-style .md-avatar-icon,md-list-item.md-2-line>.md-no-style>.md-avatar{margin-top:12px}md-list-item.md-2-line>.md-no-style>md-icon:first-child,md-list-item.md-2-line>md-icon:first-child{-webkit-align-self:flex-start;align-self:flex-start}md-list-item.md-2-line .md-list-item-text,md-list-item.md-2-line>.md-no-style .md-list-item-text{-webkit-box-flex:1;-webkit-flex:1 1 auto;flex:1 1 auto}md-list-item.md-3-line,md-list-item.md-3-line>.md-no-style{height:auto;min-height:88px}md-list-item.md-3-line:before,md-list-item.md-3-line>.md-no-style:before{content:\"\";min-height:88px;visibility:hidden;display:inline-block}md-list-item.md-3-line>.md-avatar,md-list-item.md-3-line>.md-no-style>.md-avatar,md-list-item.md-3-line>.md-no-style>md-icon:first-child,md-list-item.md-3-line>md-icon:first-child{margin-top:16px}.md-open-menu-container{position:fixed;left:0;top:0;z-index:100;opacity:0;border-radius:2px}.md-open-menu-container md-menu-divider{margin-top:4px;margin-bottom:4px;height:1px;min-height:1px;max-height:1px;width:100%}.md-open-menu-container md-menu-content>*{opacity:0}.md-open-menu-container:not(.md-clickable){pointer-events:none}.md-open-menu-container.md-active{opacity:1;-webkit-transition:all .4s cubic-bezier(.25,.8,.25,1);transition:all .4s cubic-bezier(.25,.8,.25,1);-webkit-transition-duration:.2s;transition-duration:.2s}.md-open-menu-container.md-active>md-menu-content>*{opacity:1;-webkit-transition:all .3s cubic-bezier(.55,0,.55,.2);transition:all .3s cubic-bezier(.55,0,.55,.2);-webkit-transition-duration:.2s;transition-duration:.2s;-webkit-transition-delay:.1s;transition-delay:.1s}.md-open-menu-container.md-leave{opacity:0;-webkit-transition:all .3s cubic-bezier(.55,0,.55,.2);transition:all .3s cubic-bezier(.55,0,.55,.2);-webkit-transition-duration:.25s;transition-duration:.25s}md-menu-content{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column;padding:8px 0;max-height:304px;overflow-y:auto}md-menu-content.md-dense{max-height:208px}md-menu-content.md-dense md-menu-item{height:32px;min-height:0}md-menu-item{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;flex-direction:row;min-height:48px;height:48px;-webkit-align-content:center;align-content:center;-webkit-box-pack:start;-webkit-justify-content:flex-start;justify-content:flex-start}md-menu-item>*{width:100%;margin:auto 0;padding-left:16px;padding-right:16px}md-menu-item>a.md-button{padding-top:5px}md-menu-item>.md-button{text-align:left;display:inline-block;border-radius:0;margin:auto 0;font-size:15px;text-transform:none;font-weight:400;height:100%;padding-left:16px;padding-right:16px;width:100%}md-menu-item>.md-button::-moz-focus-inner{padding:0;border:0}[dir=rtl] md-menu-item>.md-button{text-align:right}md-menu-item>.md-button md-icon{margin:auto 16px auto 0}[dir=rtl] md-menu-item>.md-button md-icon{margin:auto 0 auto 16px}md-menu-item>.md-button p{display:inline-block;margin:auto}md-menu-item>.md-button span{margin-top:auto;margin-bottom:auto}md-menu-item>.md-button .md-ripple-container{border-radius:inherit}md-toolbar .md-menu{height:auto;margin:auto;padding:0}@media (max-width:959px){md-menu-content{min-width:112px}md-menu-content[width=\"3\"]{min-width:168px}md-menu-content[width=\"4\"]{min-width:224px}md-menu-content[width=\"5\"]{min-width:280px}md-menu-content[width=\"6\"]{min-width:336px}md-menu-content[width=\"7\"]{min-width:392px}}@media (min-width:960px){md-menu-content{min-width:96px}md-menu-content[width=\"3\"]{min-width:192px}md-menu-content[width=\"4\"]{min-width:256px}md-menu-content[width=\"5\"]{min-width:320px}md-menu-content[width=\"6\"]{min-width:384px}md-menu-content[width=\"7\"]{min-width:448px}}md-toolbar.md-menu-toolbar h2.md-toolbar-tools{line-height:1rem;height:auto;padding:28px;padding-bottom:12px}md-toolbar.md-has-open-menu{position:relative;z-index:100}md-menu-bar{padding:0 20px;display:block;position:relative;z-index:2}md-menu-bar .md-menu{display:inline-block;padding:0;position:relative}md-menu-bar button{font-size:14px;padding:0 10px;margin:0;border:0;background-color:transparent;height:40px}md-menu-bar md-backdrop.md-menu-backdrop{z-index:-2}md-menu-content.md-menu-bar-menu.md-dense{max-height:none;padding:16px 0}md-menu-content.md-menu-bar-menu.md-dense md-menu-item.md-indent{position:relative}md-menu-content.md-menu-bar-menu.md-dense md-menu-item.md-indent>md-icon{position:absolute;padding:0;width:24px;top:6px;left:24px}[dir=rtl] md-menu-content.md-menu-bar-menu.md-dense md-menu-item.md-indent>md-icon{left:auto;right:24px}md-menu-content.md-menu-bar-menu.md-dense md-menu-item.md-indent .md-menu>.md-button,md-menu-content.md-menu-bar-menu.md-dense md-menu-item.md-indent>.md-button{padding:0 32px 0 64px}[dir=rtl] md-menu-content.md-menu-bar-menu.md-dense md-menu-item.md-indent .md-menu>.md-button,[dir=rtl] md-menu-content.md-menu-bar-menu.md-dense md-menu-item.md-indent>.md-button{padding:0 64px 0 32px}md-menu-content.md-menu-bar-menu.md-dense .md-button{min-height:0;height:32px}md-menu-content.md-menu-bar-menu.md-dense .md-button span{float:left}[dir=rtl] md-menu-content.md-menu-bar-menu.md-dense .md-button span{float:right}md-menu-content.md-menu-bar-menu.md-dense .md-button span.md-alt-text{float:right;margin:0 8px}[dir=rtl] md-menu-content.md-menu-bar-menu.md-dense .md-button span.md-alt-text{float:left}md-menu-content.md-menu-bar-menu.md-dense md-menu-divider{margin:8px 0}md-menu-content.md-menu-bar-menu.md-dense .md-menu>.md-button,md-menu-content.md-menu-bar-menu.md-dense md-menu-item>.md-button{text-align:left}[dir=rtl] md-menu-content.md-menu-bar-menu.md-dense .md-menu>.md-button,[dir=rtl] md-menu-content.md-menu-bar-menu.md-dense md-menu-item>.md-button{text-align:right}md-menu-content.md-menu-bar-menu.md-dense .md-menu{padding:0}md-menu-content.md-menu-bar-menu.md-dense .md-menu>.md-button{position:relative;margin:0;width:100%;text-transform:none;font-weight:400;border-radius:0;padding-left:16px}[dir=rtl] md-menu-content.md-menu-bar-menu.md-dense .md-menu>.md-button{padding-left:0;padding-right:16px}md-menu-content.md-menu-bar-menu.md-dense .md-menu>.md-button:after{display:block;content:\"\\25BC\";position:absolute;top:0;speak:none;-webkit-transform:rotate(270deg) scaleY(.45) scaleX(.9);transform:rotate(270deg) scaleY(.45) scaleX(.9);right:28px}[dir=rtl] md-menu-content.md-menu-bar-menu.md-dense .md-menu>.md-button:after{-webkit-transform:rotate(90deg) scaleY(.45) scaleX(.9);transform:rotate(90deg) scaleY(.45) scaleX(.9);right:auto;left:28px}.md-nav-bar{border-style:solid;border-width:0 0 1px;height:48px;position:relative}._md-nav-bar-list{outline:none;list-style:none;margin:0;padding:0;box-sizing:border-box;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;flex-direction:row}.md-nav-item:first-of-type{margin-left:8px}.md-button._md-nav-button{line-height:24px;margin:0 4px;padding:12px 16px;-webkit-transition:background-color .35s cubic-bezier(.35,0,.25,1);transition:background-color .35s cubic-bezier(.35,0,.25,1)}.md-button._md-nav-button:focus{outline:none}.md-button._md-nav-button:hover{background-color:inherit}md-nav-ink-bar{bottom:0;height:2px;left:auto;position:absolute;right:auto;background-color:#000}md-nav-ink-bar._md-left{-webkit-transition:left .125s cubic-bezier(.35,0,.25,1),right .25s cubic-bezier(.35,0,.25,1);transition:left .125s cubic-bezier(.35,0,.25,1),right .25s cubic-bezier(.35,0,.25,1)}md-nav-ink-bar._md-right{-webkit-transition:left .25s cubic-bezier(.35,0,.25,1),right .125s cubic-bezier(.35,0,.25,1);transition:left .25s cubic-bezier(.35,0,.25,1),right .125s cubic-bezier(.35,0,.25,1)}md-nav-ink-bar.ng-animate{-webkit-transition:none;transition:none}md-nav-extra-content{min-height:48px;padding-right:12px}@-webkit-keyframes indeterminate-rotate{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes indeterminate-rotate{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}md-progress-circular{position:relative;display:block}md-progress-circular._md-progress-circular-disabled{visibility:hidden}md-progress-circular.md-mode-indeterminate svg{-webkit-animation:indeterminate-rotate 1568.63ms linear infinite;animation:indeterminate-rotate 1568.63ms linear infinite}md-progress-circular svg{position:absolute;overflow:visible;top:0;left:0}md-progress-linear{display:block;position:relative;width:100%;height:5px;padding-top:0!important;margin-bottom:0!important}md-progress-linear._md-progress-linear-disabled{visibility:hidden}md-progress-linear .md-container{display:block;position:relative;overflow:hidden;width:100%;height:5px;-webkit-transform:translate(0) scale(1);transform:translate(0) scale(1)}md-progress-linear .md-container .md-bar{position:absolute;left:0;top:0;bottom:0;width:100%;height:5px}md-progress-linear .md-container .md-dashed:before{content:\"\";display:none;position:absolute;margin-top:0;height:5px;width:100%;background-color:transparent;background-size:10px 10px!important;background-position:0 -23px}md-progress-linear .md-container .md-bar1,md-progress-linear .md-container .md-bar2{-webkit-transition:-webkit-transform .2s linear;transition:-webkit-transform .2s linear;transition:transform .2s linear;transition:transform .2s linear,-webkit-transform .2s linear}md-progress-linear .md-container.md-mode-query .md-bar1{display:none}md-progress-linear .md-container.md-mode-query .md-bar2{-webkit-transition:all .2s linear;transition:all .2s linear;-webkit-animation:query .8s infinite cubic-bezier(.39,.575,.565,1);animation:query .8s infinite cubic-bezier(.39,.575,.565,1)}md-progress-linear .md-container.md-mode-determinate .md-bar1{display:none}md-progress-linear .md-container.md-mode-indeterminate .md-bar1{-webkit-animation:md-progress-linear-indeterminate-scale-1 4s infinite,md-progress-linear-indeterminate-1 4s infinite;animation:md-progress-linear-indeterminate-scale-1 4s infinite,md-progress-linear-indeterminate-1 4s infinite}md-progress-linear .md-container.md-mode-indeterminate .md-bar2{-webkit-animation:md-progress-linear-indeterminate-scale-2 4s infinite,md-progress-linear-indeterminate-2 4s infinite;animation:md-progress-linear-indeterminate-scale-2 4s infinite,md-progress-linear-indeterminate-2 4s infinite}md-progress-linear .md-container.ng-hide ._md-progress-linear-disabled md-progress-linear .md-container{-webkit-animation:none;animation:none}md-progress-linear .md-container.ng-hide ._md-progress-linear-disabled md-progress-linear .md-container .md-bar1,md-progress-linear .md-container.ng-hide ._md-progress-linear-disabled md-progress-linear .md-container .md-bar2{-webkit-animation-name:none;animation-name:none}md-progress-linear .md-container.md-mode-buffer{background-color:transparent!important;-webkit-transition:all .2s linear;transition:all .2s linear}md-progress-linear .md-container.md-mode-buffer .md-dashed:before{display:block;-webkit-animation:buffer 3s infinite linear;animation:buffer 3s infinite linear}@-webkit-keyframes query{0%{opacity:1;-webkit-transform:translateX(35%) scaleX(.3);transform:translateX(35%) scaleX(.3)}to{opacity:0;-webkit-transform:translateX(-50%) scaleX(0);transform:translateX(-50%) scaleX(0)}}@keyframes query{0%{opacity:1;-webkit-transform:translateX(35%) scaleX(.3);transform:translateX(35%) scaleX(.3)}to{opacity:0;-webkit-transform:translateX(-50%) scaleX(0);transform:translateX(-50%) scaleX(0)}}@-webkit-keyframes buffer{0%{opacity:1;background-position:0 -23px}50%{opacity:0}to{opacity:1;background-position:-200px -23px}}@keyframes buffer{0%{opacity:1;background-position:0 -23px}50%{opacity:0}to{opacity:1;background-position:-200px -23px}}@-webkit-keyframes md-progress-linear-indeterminate-scale-1{0%{-webkit-transform:scaleX(.1);transform:scaleX(.1);-webkit-animation-timing-function:linear;animation-timing-function:linear}36.6%{-webkit-transform:scaleX(.1);transform:scaleX(.1);-webkit-animation-timing-function:cubic-bezier(.33473,.12482,.78584,1);animation-timing-function:cubic-bezier(.33473,.12482,.78584,1)}69.15%{-webkit-transform:scaleX(.83);transform:scaleX(.83);-webkit-animation-timing-function:cubic-bezier(.22573,0,.23365,1.37098);animation-timing-function:cubic-bezier(.22573,0,.23365,1.37098)}to{-webkit-transform:scaleX(.1);transform:scaleX(.1)}}@keyframes md-progress-linear-indeterminate-scale-1{0%{-webkit-transform:scaleX(.1);transform:scaleX(.1);-webkit-animation-timing-function:linear;animation-timing-function:linear}36.6%{-webkit-transform:scaleX(.1);transform:scaleX(.1);-webkit-animation-timing-function:cubic-bezier(.33473,.12482,.78584,1);animation-timing-function:cubic-bezier(.33473,.12482,.78584,1)}69.15%{-webkit-transform:scaleX(.83);transform:scaleX(.83);-webkit-animation-timing-function:cubic-bezier(.22573,0,.23365,1.37098);animation-timing-function:cubic-bezier(.22573,0,.23365,1.37098)}to{-webkit-transform:scaleX(.1);transform:scaleX(.1)}}@-webkit-keyframes md-progress-linear-indeterminate-1{0%{left:-105.16667%;-webkit-animation-timing-function:linear;animation-timing-function:linear}20%{left:-105.16667%;-webkit-animation-timing-function:cubic-bezier(.5,0,.70173,.49582);animation-timing-function:cubic-bezier(.5,0,.70173,.49582)}69.15%{left:21.5%;-webkit-animation-timing-function:cubic-bezier(.30244,.38135,.55,.95635);animation-timing-function:cubic-bezier(.30244,.38135,.55,.95635)}to{left:95.44444%}}@keyframes md-progress-linear-indeterminate-1{0%{left:-105.16667%;-webkit-animation-timing-function:linear;animation-timing-function:linear}20%{left:-105.16667%;-webkit-animation-timing-function:cubic-bezier(.5,0,.70173,.49582);animation-timing-function:cubic-bezier(.5,0,.70173,.49582)}69.15%{left:21.5%;-webkit-animation-timing-function:cubic-bezier(.30244,.38135,.55,.95635);animation-timing-function:cubic-bezier(.30244,.38135,.55,.95635)}to{left:95.44444%}}@-webkit-keyframes md-progress-linear-indeterminate-scale-2{0%{-webkit-transform:scaleX(.1);transform:scaleX(.1);-webkit-animation-timing-function:cubic-bezier(.20503,.05705,.57661,.45397);animation-timing-function:cubic-bezier(.20503,.05705,.57661,.45397)}19.15%{-webkit-transform:scaleX(.57);transform:scaleX(.57);-webkit-animation-timing-function:cubic-bezier(.15231,.19643,.64837,1.00432);animation-timing-function:cubic-bezier(.15231,.19643,.64837,1.00432)}44.15%{-webkit-transform:scaleX(.91);transform:scaleX(.91);-webkit-animation-timing-function:cubic-bezier(.25776,-.00316,.21176,1.38179);animation-timing-function:cubic-bezier(.25776,-.00316,.21176,1.38179)}to{-webkit-transform:scaleX(.1);transform:scaleX(.1)}}@keyframes md-progress-linear-indeterminate-scale-2{0%{-webkit-transform:scaleX(.1);transform:scaleX(.1);-webkit-animation-timing-function:cubic-bezier(.20503,.05705,.57661,.45397);animation-timing-function:cubic-bezier(.20503,.05705,.57661,.45397)}19.15%{-webkit-transform:scaleX(.57);transform:scaleX(.57);-webkit-animation-timing-function:cubic-bezier(.15231,.19643,.64837,1.00432);animation-timing-function:cubic-bezier(.15231,.19643,.64837,1.00432)}44.15%{-webkit-transform:scaleX(.91);transform:scaleX(.91);-webkit-animation-timing-function:cubic-bezier(.25776,-.00316,.21176,1.38179);animation-timing-function:cubic-bezier(.25776,-.00316,.21176,1.38179)}to{-webkit-transform:scaleX(.1);transform:scaleX(.1)}}@-webkit-keyframes md-progress-linear-indeterminate-2{0%{left:-54.88889%;-webkit-animation-timing-function:cubic-bezier(.15,0,.51506,.40968);animation-timing-function:cubic-bezier(.15,0,.51506,.40968)}25%{left:-17.25%;-webkit-animation-timing-function:cubic-bezier(.31033,.28406,.8,.73372);animation-timing-function:cubic-bezier(.31033,.28406,.8,.73372)}48.35%{left:29.5%;-webkit-animation-timing-function:cubic-bezier(.4,.62703,.6,.90203);animation-timing-function:cubic-bezier(.4,.62703,.6,.90203)}to{left:117.38889%}}@keyframes md-progress-linear-indeterminate-2{0%{left:-54.88889%;-webkit-animation-timing-function:cubic-bezier(.15,0,.51506,.40968);animation-timing-function:cubic-bezier(.15,0,.51506,.40968)}25%{left:-17.25%;-webkit-animation-timing-function:cubic-bezier(.31033,.28406,.8,.73372);animation-timing-function:cubic-bezier(.31033,.28406,.8,.73372)}48.35%{left:29.5%;-webkit-animation-timing-function:cubic-bezier(.4,.62703,.6,.90203);animation-timing-function:cubic-bezier(.4,.62703,.6,.90203)}to{left:117.38889%}}md-radio-button{box-sizing:border-box;display:block;margin-bottom:16px;white-space:nowrap;cursor:pointer;position:relative}md-radio-button[disabled],md-radio-button[disabled] .md-container{cursor:default}md-radio-button .md-container{position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);box-sizing:border-box;display:inline-block;width:20px;height:20px;cursor:pointer;left:0;right:auto}[dir=rtl] md-radio-button .md-container{left:auto;right:0}md-radio-button .md-container .md-ripple-container{position:absolute;display:block;width:auto;height:auto;left:-15px;top:-15px;right:-15px;bottom:-15px}md-radio-button .md-container:before{box-sizing:border-box;background-color:transparent;border-radius:50%;content:\"\";position:absolute;display:block;height:auto;left:0;top:0;right:0;bottom:0;-webkit-transition:all .5s;transition:all .5s;width:auto}md-radio-button.md-align-top-left>div.md-container{top:12px}md-radio-button .md-off{border-style:solid;border-width:2px;-webkit-transition:border-color .28s ease;transition:border-color .28s ease}md-radio-button .md-off,md-radio-button .md-on{box-sizing:border-box;position:absolute;top:0;left:0;width:20px;height:20px;border-radius:50%}md-radio-button .md-on{-webkit-transition:-webkit-transform .28s ease;transition:-webkit-transform .28s ease;transition:transform .28s ease;transition:transform .28s ease,-webkit-transform .28s ease;-webkit-transform:scale(0);transform:scale(0)}md-radio-button.md-checked .md-on{-webkit-transform:scale(.5);transform:scale(.5)}md-radio-button .md-label{box-sizing:border-box;position:relative;display:inline-block;margin-left:30px;margin-right:0;vertical-align:middle;white-space:normal;pointer-events:none;width:auto}[dir=rtl] md-radio-button .md-label{margin-left:0;margin-right:30px}md-radio-group.layout-column md-radio-button,md-radio-group.layout-gt-lg-column md-radio-button,md-radio-group.layout-gt-md-column md-radio-button,md-radio-group.layout-gt-sm-column md-radio-button,md-radio-group.layout-gt-xs-column md-radio-button,md-radio-group.layout-lg-column md-radio-button,md-radio-group.layout-md-column md-radio-button,md-radio-group.layout-sm-column md-radio-button,md-radio-group.layout-xl-column md-radio-button,md-radio-group.layout-xs-column md-radio-button{margin-bottom:16px}md-radio-group.layout-gt-lg-row md-radio-button,md-radio-group.layout-gt-md-row md-radio-button,md-radio-group.layout-gt-sm-row md-radio-button,md-radio-group.layout-gt-xs-row md-radio-button,md-radio-group.layout-lg-row md-radio-button,md-radio-group.layout-md-row md-radio-button,md-radio-group.layout-row md-radio-button,md-radio-group.layout-sm-row md-radio-button,md-radio-group.layout-xl-row md-radio-button,md-radio-group.layout-xs-row md-radio-button{margin:0 16px 0 0}[dir=rtl] md-radio-group.layout-gt-lg-row md-radio-button,[dir=rtl] md-radio-group.layout-gt-md-row md-radio-button,[dir=rtl] md-radio-group.layout-gt-sm-row md-radio-button,[dir=rtl] md-radio-group.layout-gt-xs-row md-radio-button,[dir=rtl] md-radio-group.layout-lg-row md-radio-button,[dir=rtl] md-radio-group.layout-md-row md-radio-button,[dir=rtl] md-radio-group.layout-row md-radio-button,[dir=rtl] md-radio-group.layout-sm-row md-radio-button,[dir=rtl] md-radio-group.layout-xl-row md-radio-button,[dir=rtl] md-radio-group.layout-xs-row md-radio-button{margin-left:16px;margin-right:0}md-radio-group.layout-gt-lg-row md-radio-button:last-of-type,md-radio-group.layout-gt-md-row md-radio-button:last-of-type,md-radio-group.layout-gt-sm-row md-radio-button:last-of-type,md-radio-group.layout-gt-xs-row md-radio-button:last-of-type,md-radio-group.layout-lg-row md-radio-button:last-of-type,md-radio-group.layout-md-row md-radio-button:last-of-type,md-radio-group.layout-row md-radio-button:last-of-type,md-radio-group.layout-sm-row md-radio-button:last-of-type,md-radio-group.layout-xl-row md-radio-button:last-of-type,md-radio-group.layout-xs-row md-radio-button:last-of-type{margin-left:0;margin-right:0}md-radio-group:focus{outline:none}md-radio-group.md-focused .md-checked .md-container:before{left:-8px;top:-8px;right:-8px;bottom:-8px}md-radio-group[disabled] md-radio-button,md-radio-group[disabled] md-radio-button .md-container{cursor:default}.md-inline-form md-radio-group{margin:18px 0 19px}.md-inline-form md-radio-group md-radio-button{display:inline-block;height:30px;padding:2px;box-sizing:border-box;margin-top:0;margin-bottom:0}@media screen and (-ms-high-contrast:active){md-radio-button.md-default-theme .md-on{background-color:#fff}}md-sidenav{box-sizing:border-box;position:absolute;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column;z-index:60;width:320px;max-width:320px;bottom:0;overflow:auto;-webkit-overflow-scrolling:touch}md-sidenav ul{list-style:none}md-sidenav.md-closed{display:none}md-sidenav.md-closed-add,md-sidenav.md-closed-remove{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-transition:all .2s ease-in;transition:all .2s ease-in}md-sidenav.md-closed-add.md-closed-add-active,md-sidenav.md-closed-remove.md-closed-remove-active{-webkit-transition:all .4s cubic-bezier(.25,.8,.25,1);transition:all .4s cubic-bezier(.25,.8,.25,1)}md-sidenav.md-closed.md-locked-open-add,md-sidenav.md-locked-open,md-sidenav.md-locked-open-add,md-sidenav.md-locked-open-remove,md-sidenav.md-locked-open-remove.md-closed,md-sidenav.md-locked-open.md-closed,md-sidenav.md-locked-open.md-closed.md-sidenav-left,md-sidenav.md-locked-open.md-closed.md-sidenav-right{position:static;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-transform:translateZ(0);transform:translateZ(0)}md-sidenav.md-closed.md-locked-open-add:not(.md-locked-open-add-active){width:0!important;min-width:0!important}md-sidenav.md-closed.md-locked-open-add-active,md-sidenav.md-closed.md-locked-open-add:not(.md-locked-open-add-active),md-sidenav.md-locked-open-remove-active{-webkit-transition:width .3s cubic-bezier(.55,0,.55,.2),min-width .3s cubic-bezier(.55,0,.55,.2);transition:width .3s cubic-bezier(.55,0,.55,.2),min-width .3s cubic-bezier(.55,0,.55,.2)}md-sidenav.md-locked-open-remove-active{width:0!important;min-width:0!important}.md-sidenav-backdrop.md-locked-open{display:none}.md-sidenav-left,md-sidenav{left:0;top:0;-webkit-transform:translateZ(0);transform:translateZ(0)}.md-sidenav-left.md-closed,md-sidenav.md-closed{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}.md-sidenav-right{left:100%;top:0;-webkit-transform:translate(-100%);transform:translate(-100%)}.md-sidenav-right.md-closed{-webkit-transform:translate(0);transform:translate(0)}@media (min-width:600px){md-sidenav{max-width:400px}}@media (max-width:456px){md-sidenav{width:calc(100% - 56px);min-width:calc(100% - 56px);max-width:calc(100% - 56px)}}@media screen and (-ms-high-contrast:active){.md-sidenav-left,md-sidenav{border-right:1px solid #fff}.md-sidenav-right{border-left:1px solid #fff}}md-input-container:not([md-no-float]) .md-select-placeholder span:first-child{-webkit-transition:-webkit-transform .4s cubic-bezier(.25,.8,.25,1);transition:-webkit-transform .4s cubic-bezier(.25,.8,.25,1);transition:transform .4s cubic-bezier(.25,.8,.25,1);transition:transform .4s cubic-bezier(.25,.8,.25,1),-webkit-transform .4s cubic-bezier(.25,.8,.25,1);-webkit-transform-origin:left top;transform-origin:left top}[dir=rtl] md-input-container:not([md-no-float]) .md-select-placeholder span:first-child{-webkit-transform-origin:right top;transform-origin:right top}md-input-container.md-input-focused:not([md-no-float]) .md-select-placeholder span:first-child{-webkit-transform:translateY(-22px) translateX(-2px) scale(.75);transform:translateY(-22px) translateX(-2px) scale(.75)}.md-select-menu-container{position:fixed;left:0;top:0;z-index:90;opacity:0;display:none;-webkit-transform:translateY(-1px);transform:translateY(-1px)}.md-select-menu-container:not(.md-clickable){pointer-events:none}.md-select-menu-container md-progress-circular{display:table;margin:24px auto!important}.md-select-menu-container.md-active{display:block;opacity:1}.md-select-menu-container.md-active md-select-menu{-webkit-transition:all .4s cubic-bezier(.25,.8,.25,1);transition:all .4s cubic-bezier(.25,.8,.25,1);-webkit-transition-duration:.15s;transition-duration:.15s}.md-select-menu-container.md-active md-select-menu>*{opacity:1;-webkit-transition:all .3s cubic-bezier(.55,0,.55,.2);transition:all .3s cubic-bezier(.55,0,.55,.2);-webkit-transition-duration:.15s;transition-duration:.15s;-webkit-transition-delay:.1s;transition-delay:.1s}.md-select-menu-container.md-leave{opacity:0;-webkit-transition:all .3s cubic-bezier(.55,0,.55,.2);transition:all .3s cubic-bezier(.55,0,.55,.2);-webkit-transition-duration:.25s;transition-duration:.25s}md-input-container>md-select{margin:0;-webkit-box-ordinal-group:3;-webkit-order:2;order:2}md-input-container:not(.md-input-has-value) md-select.ng-required:not(.md-no-asterisk) .md-select-value span:first-child:after,md-input-container:not(.md-input-has-value) md-select[required]:not(.md-no-asterisk) .md-select-value span:first-child:after{content:\" *\";font-size:13px;vertical-align:top}md-input-container.md-input-invalid md-select .md-select-value{border-bottom-style:solid;padding-bottom:1px}md-select{display:-webkit-box;display:-webkit-flex;display:flex;margin:20px 0 26px}md-select.ng-required.ng-invalid:not(.md-no-asterisk) .md-select-value span:first-child:after,md-select[required].ng-invalid:not(.md-no-asterisk) .md-select-value span:first-child:after{content:\" *\";font-size:13px;vertical-align:top}md-select[disabled] .md-select-value{background-position:0 bottom;background-size:4px 1px;background-repeat:repeat-x;margin-bottom:-1px}md-select:focus{outline:none}md-select[disabled]:hover{cursor:default}md-select:not([disabled]):hover{cursor:pointer}md-select:not([disabled]).ng-invalid.ng-touched .md-select-value{border-bottom-style:solid;padding-bottom:1px}md-select:not([disabled]):focus .md-select-value{border-bottom-width:2px;border-bottom-style:solid;padding-bottom:0}md-select:not([disabled]):focus.ng-invalid.ng-touched .md-select-value{padding-bottom:0}md-input-container.md-input-has-value .md-select-value>span:not(.md-select-icon){-webkit-transform:translate3d(0,1px,0);transform:translate3d(0,1px,0)}.md-select-value{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:center;-webkit-align-items:center;align-items:center;padding:2px 2px 1px;border-bottom-width:1px;border-bottom-style:solid;background-color:transparent;position:relative;box-sizing:content-box;min-width:64px;min-height:26px;-webkit-box-flex:1;-webkit-flex-grow:1;flex-grow:1}.md-select-value>span:not(.md-select-icon){max-width:100%;-webkit-box-flex:1;-webkit-flex:1 1 auto;flex:1 1 auto;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.md-select-value>span:not(.md-select-icon) .md-text{display:inline}.md-select-value .md-select-icon{display:block;-webkit-box-align:end;-webkit-align-items:flex-end;align-items:flex-end;text-align:end;width:24px;margin:0 4px;-webkit-transform:translate3d(0,-2px,0);transform:translate3d(0,-2px,0);font-size:1.2rem}.md-select-value .md-select-icon:after{display:block;content:\"\\25BC\";position:relative;top:2px;speak:none;font-size:13px;-webkit-transform:scaleY(.5) scaleX(1);transform:scaleY(.5) scaleX(1)}.md-select-value.md-select-placeholder{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-ordinal-group:2;-webkit-order:1;order:1;pointer-events:none;-webkit-font-smoothing:antialiased;padding-left:2px;z-index:1}md-select-menu{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column;box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12);max-height:256px;min-height:48px;overflow-y:hidden;-webkit-transform-origin:left top;transform-origin:left top;-webkit-transform:scale(1);transform:scale(1)}md-select-menu.md-reverse{-webkit-box-orient:vertical;-webkit-box-direction:reverse;-webkit-flex-direction:column-reverse;flex-direction:column-reverse}md-select-menu:not(.md-overflow) md-content{padding-top:8px;padding-bottom:8px}[dir=rtl] md-select-menu{-webkit-transform-origin:right top;transform-origin:right top}md-select-menu md-content{min-width:136px;min-height:48px;max-height:256px;overflow-y:auto}md-select-menu>*{opacity:0}md-option{cursor:pointer;position:relative;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:center;-webkit-align-items:center;align-items:center;width:auto;-webkit-transition:background .15s linear;transition:background .15s linear;padding:0 16px;height:48px}md-option[disabled]{cursor:default}md-option:focus{outline:none}md-option .md-text{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:auto;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}md-optgroup{display:block}md-optgroup label{display:block;font-size:14px;text-transform:uppercase;padding:16px;font-weight:500}md-optgroup md-option{padding-left:32px;padding-right:32px}@media screen and (-ms-high-contrast:active){.md-select-backdrop{background-color:transparent}md-select-menu{border:1px solid #fff}}md-select-menu[multiple] md-option.md-checkbox-enabled{padding-left:40px;padding-right:16px}[dir=rtl] md-select-menu[multiple] md-option.md-checkbox-enabled{padding-left:16px;padding-right:40px}md-select-menu[multiple] md-option.md-checkbox-enabled .md-container{position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);box-sizing:border-box;display:inline-block;width:20px;height:20px;left:0;right:auto}[dir=rtl] md-select-menu[multiple] md-option.md-checkbox-enabled .md-container{left:auto;right:0}md-select-menu[multiple] md-option.md-checkbox-enabled .md-container:before{box-sizing:border-box;background-color:transparent;border-radius:50%;content:\"\";position:absolute;display:block;height:auto;left:0;top:0;right:0;bottom:0;-webkit-transition:all .5s;transition:all .5s;width:auto}md-select-menu[multiple] md-option.md-checkbox-enabled .md-container:after{box-sizing:border-box;content:\"\";position:absolute;top:-10px;right:-10px;bottom:-10px;left:-10px}md-select-menu[multiple] md-option.md-checkbox-enabled .md-container .md-ripple-container{position:absolute;display:block;width:auto;height:auto;left:-15px;top:-15px;right:-15px;bottom:-15px}md-select-menu[multiple] md-option.md-checkbox-enabled .md-icon{box-sizing:border-box;-webkit-transition:.24s;transition:.24s;position:absolute;top:0;left:0;width:20px;height:20px;border-width:2px;border-style:solid;border-radius:2px}md-select-menu[multiple] md-option.md-checkbox-enabled[selected] .md-icon{border-color:transparent}md-select-menu[multiple] md-option.md-checkbox-enabled[selected] .md-icon:after{box-sizing:border-box;-webkit-transform:rotate(45deg);transform:rotate(45deg);position:absolute;left:4.66667px;top:.22222px;display:table;width:6.66667px;height:13.33333px;border-width:2px;border-style:solid;border-top:0;border-left:0;content:\"\"}md-select-menu[multiple] md-option.md-checkbox-enabled[disabled]{cursor:default}md-select-menu[multiple] md-option.md-checkbox-enabled.md-indeterminate .md-icon:after{box-sizing:border-box;position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);display:table;width:12px;height:2px;border-width:2px;border-style:solid;border-top:0;border-left:0;content:\"\"}md-select-menu[multiple] md-option.md-checkbox-enabled .md-container{margin-left:10.66667px;margin-right:auto}[dir=rtl] md-select-menu[multiple] md-option.md-checkbox-enabled .md-container{margin-left:auto;margin-right:10.66667px}@-webkit-keyframes sliderFocusThumb{0%{-webkit-transform:scale(.7);transform:scale(.7)}30%{-webkit-transform:scale(1);transform:scale(1)}to{-webkit-transform:scale(.7);transform:scale(.7)}}@keyframes sliderFocusThumb{0%{-webkit-transform:scale(.7);transform:scale(.7)}30%{-webkit-transform:scale(1);transform:scale(1)}to{-webkit-transform:scale(.7);transform:scale(.7)}}@-webkit-keyframes sliderDiscreteFocusThumb{0%{-webkit-transform:scale(.7);transform:scale(.7)}50%{-webkit-transform:scale(.8);transform:scale(.8)}to{-webkit-transform:scale(0);transform:scale(0)}}@keyframes sliderDiscreteFocusThumb{0%{-webkit-transform:scale(.7);transform:scale(.7)}50%{-webkit-transform:scale(.8);transform:scale(.8)}to{-webkit-transform:scale(0);transform:scale(0)}}@-webkit-keyframes sliderDiscreteFocusRing{0%{-webkit-transform:scale(.7);transform:scale(.7);opacity:0}50%{-webkit-transform:scale(1);transform:scale(1);opacity:1}to{-webkit-transform:scale(0);transform:scale(0)}}@keyframes sliderDiscreteFocusRing{0%{-webkit-transform:scale(.7);transform:scale(.7);opacity:0}50%{-webkit-transform:scale(1);transform:scale(1);opacity:1}to{-webkit-transform:scale(0);transform:scale(0)}}md-slider{height:48px;min-width:128px;position:relative;margin-left:4px;margin-right:4px;padding:0;display:block;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;flex-direction:row}md-slider *,md-slider :after{box-sizing:border-box}md-slider .md-slider-wrapper{outline:none;width:100%;height:100%}md-slider .md-slider-content{position:relative}md-slider .md-track-container{width:100%;position:absolute;top:23px;height:2px}md-slider .md-track{position:absolute;left:0;right:0;height:100%}md-slider .md-track-fill{-webkit-transition:all .4s cubic-bezier(.25,.8,.25,1);transition:all .4s cubic-bezier(.25,.8,.25,1);-webkit-transition-property:width,height;transition-property:width,height}md-slider .md-track-ticks{position:absolute;left:0;right:0;height:100%}md-slider .md-track-ticks canvas{width:100%;height:100%}md-slider .md-thumb-container{position:absolute;left:0;top:50%;-webkit-transform:translate3d(-50%,-50%,0);transform:translate3d(-50%,-50%,0);-webkit-transition:all .4s cubic-bezier(.25,.8,.25,1);transition:all .4s cubic-bezier(.25,.8,.25,1);-webkit-transition-property:left,right,bottom;transition-property:left,right,bottom}[dir=rtl] md-slider .md-thumb-container{left:auto;right:0}md-slider .md-thumb{z-index:1;position:absolute;left:-10px;top:14px;width:20px;height:20px;border-radius:20px;-webkit-transform:scale(.7);transform:scale(.7);-webkit-transition:all .4s cubic-bezier(.25,.8,.25,1);transition:all .4s cubic-bezier(.25,.8,.25,1)}[dir=rtl] md-slider .md-thumb{left:auto;right:-10px}md-slider .md-thumb:after{content:\"\";position:absolute;width:20px;height:20px;border-radius:20px;border-width:3px;border-style:solid;-webkit-transition:inherit;transition:inherit}md-slider .md-sign{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center;position:absolute;left:-14px;top:-17px;width:28px;height:28px;border-radius:28px;-webkit-transform:scale(.4) translate3d(0,67.5px,0);transform:scale(.4) translate3d(0,67.5px,0);-webkit-transition:all .3s cubic-bezier(.35,0,.25,1);transition:all .3s cubic-bezier(.35,0,.25,1)}md-slider .md-sign:after{position:absolute;content:\"\";left:0;border-radius:16px;top:19px;border-left:14px solid transparent;border-right:14px solid transparent;border-top-width:16px;border-top-style:solid;opacity:0;-webkit-transform:translate3d(0,-8px,0);transform:translate3d(0,-8px,0);-webkit-transition:all .2s cubic-bezier(.35,0,.25,1);transition:all .2s cubic-bezier(.35,0,.25,1)}[dir=rtl] md-slider .md-sign:after{left:auto;right:0}md-slider .md-sign .md-thumb-text{z-index:1;font-size:12px;font-weight:700}md-slider .md-focus-ring{position:absolute;left:-17px;top:7px;width:34px;height:34px;border-radius:34px;-webkit-transform:scale(.7);transform:scale(.7);opacity:0;-webkit-transition:all .35s cubic-bezier(.35,0,.25,1);transition:all .35s cubic-bezier(.35,0,.25,1)}[dir=rtl] md-slider .md-focus-ring{left:auto;right:-17px}md-slider .md-disabled-thumb{position:absolute;left:-14px;top:10px;width:28px;height:28px;border-radius:28px;-webkit-transform:scale(.5);transform:scale(.5);border-width:4px;border-style:solid;display:none}[dir=rtl] md-slider .md-disabled-thumb{left:auto;right:-14px}md-slider.md-min .md-sign{opacity:0}md-slider:focus{outline:none}md-slider.md-dragging .md-thumb-container,md-slider.md-dragging .md-track-fill{-webkit-transition:none;transition:none}md-slider:not([md-discrete]) .md-sign,md-slider:not([md-discrete]) .md-track-ticks{display:none}md-slider:not([md-discrete]):not([disabled]) .md-slider-wrapper .md-thumb:hover{-webkit-transform:scale(.8);transform:scale(.8)}md-slider:not([md-discrete]):not([disabled]) .md-slider-wrapper.md-focused .md-focus-ring{-webkit-transform:scale(1);transform:scale(1);opacity:1}md-slider:not([md-discrete]):not([disabled]) .md-slider-wrapper.md-focused .md-thumb{-webkit-animation:sliderFocusThumb .7s cubic-bezier(.35,0,.25,1);animation:sliderFocusThumb .7s cubic-bezier(.35,0,.25,1)}md-slider:not([md-discrete]):not([disabled]).md-active .md-slider-wrapper .md-thumb{-webkit-transform:scale(1);transform:scale(1)}md-slider[md-discrete]:not([disabled]) .md-slider-wrapper.md-focused .md-focus-ring{-webkit-transform:scale(0);transform:scale(0);-webkit-animation:sliderDiscreteFocusRing .5s cubic-bezier(.35,0,.25,1);animation:sliderDiscreteFocusRing .5s cubic-bezier(.35,0,.25,1)}md-slider[md-discrete]:not([disabled]) .md-slider-wrapper.md-focused .md-thumb{-webkit-animation:sliderDiscreteFocusThumb .5s cubic-bezier(.35,0,.25,1);animation:sliderDiscreteFocusThumb .5s cubic-bezier(.35,0,.25,1)}md-slider[md-discrete]:not([disabled]).md-active .md-thumb,md-slider[md-discrete]:not([disabled]) .md-slider-wrapper.md-focused .md-thumb{-webkit-transform:scale(0);transform:scale(0)}md-slider[md-discrete]:not([disabled]).md-active .md-sign,md-slider[md-discrete]:not([disabled]).md-active .md-sign:after,md-slider[md-discrete]:not([disabled]) .md-slider-wrapper.md-focused .md-sign,md-slider[md-discrete]:not([disabled]) .md-slider-wrapper.md-focused .md-sign:after{opacity:1;-webkit-transform:translateZ(0) scale(1);transform:translateZ(0) scale(1)}md-slider[md-discrete][disabled][readonly] .md-thumb{-webkit-transform:scale(0);transform:scale(0)}md-slider[md-discrete][disabled][readonly] .md-sign,md-slider[md-discrete][disabled][readonly] .md-sign:after{opacity:1;-webkit-transform:translateZ(0) scale(1);transform:translateZ(0) scale(1)}md-slider[disabled] .md-track-fill{display:none}md-slider[disabled] .md-track-ticks,md-slider[disabled]:not([readonly]) .md-sign{opacity:0}md-slider[disabled] .md-thumb{-webkit-transform:scale(.5);transform:scale(.5)}md-slider[disabled] .md-disabled-thumb{display:block}md-slider[md-vertical]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column;min-height:128px;min-width:0}md-slider[md-vertical] .md-slider-wrapper{-webkit-box-flex:1;-webkit-flex:1;flex:1;padding-top:12px;padding-bottom:12px;width:48px;-webkit-align-self:center;align-self:center;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center}md-slider[md-vertical] .md-track-container{height:100%;width:2px;top:0;left:calc(50% - 1px)}md-slider[md-vertical] .md-thumb-container{top:auto;margin-bottom:23px;left:calc(50% - 1px);bottom:0}md-slider[md-vertical] .md-thumb-container .md-thumb:after{left:1px}md-slider[md-vertical] .md-thumb-container .md-focus-ring{left:-16px}md-slider[md-vertical] .md-track-fill{bottom:0}md-slider[md-vertical][md-discrete] .md-sign{left:-40px;top:9.5px;-webkit-transform:scale(.4) translate3d(67.5px,0,0);transform:scale(.4) translate3d(67.5px,0,0)}md-slider[md-vertical][md-discrete] .md-sign:after{top:9.5px;left:19px;border-top:14px solid transparent;border-right:0;border-bottom:14px solid transparent;border-left-width:16px;border-left-style:solid;opacity:0;-webkit-transform:translate3d(0,-8px,0);transform:translate3d(0,-8px,0);-webkit-transition:all .2s ease-in-out;transition:all .2s ease-in-out}md-slider[md-vertical][md-discrete] .md-sign .md-thumb-text{z-index:1;font-size:12px;font-weight:700}md-slider[md-vertical][md-discrete].md-active .md-sign:after,md-slider[md-vertical][md-discrete] .md-focused .md-sign:after,md-slider[md-vertical][md-discrete][disabled][readonly] .md-sign:after{top:0}md-slider[md-vertical][disabled][readonly] .md-thumb{-webkit-transform:scale(0);transform:scale(0)}md-slider[md-vertical][disabled][readonly] .md-sign,md-slider[md-vertical][disabled][readonly] .md-sign:after{opacity:1;-webkit-transform:translateZ(0) scale(1);transform:translateZ(0) scale(1)}md-slider[md-invert]:not([md-vertical]) .md-track-fill{left:auto;right:0}[dir=rtl] md-slider[md-invert]:not([md-vertical]) .md-track-fill{left:0;right:auto}md-slider[md-invert][md-vertical] .md-track-fill{bottom:auto;top:0}md-slider-container{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;flex-direction:row}md-slider-container>:first-child:not(md-slider),md-slider-container>:last-child:not(md-slider){min-width:25px;max-width:42px;height:25px;-webkit-transition:all .4s cubic-bezier(.25,.8,.25,1);transition:all .4s cubic-bezier(.25,.8,.25,1);-webkit-transition-property:color,max-width;transition-property:color,max-width}md-slider-container>:first-child:not(md-slider){margin-right:16px}[dir=rtl] md-slider-container>:first-child:not(md-slider){margin-right:auto;margin-left:16px}md-slider-container>:last-child:not(md-slider){margin-left:16px}[dir=rtl] md-slider-container>:last-child:not(md-slider){margin-left:auto;margin-right:16px}md-slider-container[md-vertical]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column}md-slider-container[md-vertical]>:first-child:not(md-slider),md-slider-container[md-vertical]>:last-child:not(md-slider){margin-right:0;margin-left:0;text-align:center}md-slider-container md-input-container input[type=number]{text-align:center;padding-left:15px;height:50px;margin-top:-25px}[dir=rtl] md-slider-container md-input-container input[type=number]{padding-left:0;padding-right:15px}@media screen and (-ms-high-contrast:active){md-slider.md-default-theme .md-track{border-bottom:1px solid #fff}}.md-sticky-clone{z-index:2;top:0;left:0;right:0;position:absolute!important;-webkit-transform:translate3d(-9999px,-9999px,0);transform:translate3d(-9999px,-9999px,0)}.md-sticky-clone[sticky-state=active]{-webkit-transform:translateZ(0);transform:translateZ(0)}.md-sticky-clone[sticky-state=active]:not(.md-sticky-no-effect) .md-subheader-inner{-webkit-animation:subheaderStickyHoverIn .3s ease-out both;animation:subheaderStickyHoverIn .3s ease-out both}@-webkit-keyframes subheaderStickyHoverIn{0%{box-shadow:0 0 0 0 transparent}to{box-shadow:0 2px 4px 0 rgba(0,0,0,.16)}}@keyframes subheaderStickyHoverIn{0%{box-shadow:0 0 0 0 transparent}to{box-shadow:0 2px 4px 0 rgba(0,0,0,.16)}}@-webkit-keyframes subheaderStickyHoverOut{0%{box-shadow:0 2px 4px 0 rgba(0,0,0,.16)}to{box-shadow:0 0 0 0 transparent}}@keyframes subheaderStickyHoverOut{0%{box-shadow:0 2px 4px 0 rgba(0,0,0,.16)}to{box-shadow:0 0 0 0 transparent}}.md-subheader-wrapper:not(.md-sticky-no-effect){-webkit-transition:margin .2s ease-out;transition:margin .2s ease-out}.md-subheader-wrapper:not(.md-sticky-no-effect) .md-subheader{margin:0}.md-subheader-wrapper:not(.md-sticky-no-effect).md-sticky-clone{z-index:2}.md-subheader-wrapper:not(.md-sticky-no-effect)[sticky-state=active]{margin-top:-2px}.md-subheader-wrapper:not(.md-sticky-no-effect):not(.md-sticky-clone)[sticky-prev-state=active] .md-subheader-inner:after{-webkit-animation:subheaderStickyHoverOut .3s ease-out both;animation:subheaderStickyHoverOut .3s ease-out both}.md-subheader{display:block;font-size:14px;font-weight:500;line-height:1em;margin:0;position:relative}.md-subheader .md-subheader-inner{display:block;padding:16px}.md-subheader .md-subheader-content{display:block;z-index:1;position:relative}.md-inline-form md-switch{margin-top:18px;margin-bottom:19px}md-switch{margin:16px 0;white-space:nowrap;cursor:pointer;outline:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;height:30px;line-height:28px;-webkit-box-align:center;-webkit-align-items:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:flex;margin-left:inherit;margin-right:16px}[dir=rtl] md-switch{margin-left:16px;margin-right:inherit}md-switch:last-of-type{margin-left:inherit;margin-right:0}[dir=rtl] md-switch:last-of-type{margin-left:0;margin-right:inherit}md-switch[disabled],md-switch[disabled] .md-container{cursor:default}md-switch .md-container{cursor:-webkit-grab;cursor:grab;width:36px;height:24px;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;margin-right:8px;float:left}[dir=rtl] md-switch .md-container,md-switch.md-inverted .md-container{margin-right:0;margin-left:8px}[dir=rtl] md-switch.md-inverted .md-container{margin-right:8px;margin-left:0}md-switch:not([disabled]) .md-dragging,md-switch:not([disabled]).md-dragging .md-container{cursor:-webkit-grabbing;cursor:grabbing}md-switch.md-focused:not([disabled]) .md-thumb:before{left:-8px;top:-8px;right:-8px;bottom:-8px}md-switch.md-focused:not([disabled]):not(.md-checked) .md-thumb:before{background-color:rgba(0,0,0,.12)}md-switch .md-label{border-color:transparent;border-width:0;float:left}md-switch .md-bar{left:1px;width:34px;top:5px;height:14px;border-radius:8px;position:absolute}md-switch .md-thumb-container{top:2px;left:0;width:16px;position:absolute;-webkit-transform:translateZ(0);transform:translateZ(0);z-index:1}md-switch.md-checked .md-thumb-container{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}md-switch .md-thumb{margin:0;outline:none;height:20px;width:20px;box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12)}md-switch .md-thumb,md-switch .md-thumb:before{position:absolute;left:0;top:0;border-radius:50%}md-switch .md-thumb:before{background-color:transparent;content:\"\";display:block;height:auto;right:0;bottom:0;-webkit-transition:all .5s;transition:all .5s;width:auto}md-switch .md-thumb .md-ripple-container{position:absolute;display:block;width:auto;height:auto;left:-20px;top:-20px;right:-20px;bottom:-20px}md-switch:not(.md-dragging) .md-bar,md-switch:not(.md-dragging) .md-thumb,md-switch:not(.md-dragging) .md-thumb-container{-webkit-transition:all .08s linear;transition:all .08s linear;-webkit-transition-property:background-color,-webkit-transform;transition-property:background-color,-webkit-transform;transition-property:transform,background-color;transition-property:transform,background-color,-webkit-transform}md-switch:not(.md-dragging) .md-bar,md-switch:not(.md-dragging) .md-thumb{-webkit-transition-delay:.05s;transition-delay:.05s}@media screen and (-ms-high-contrast:active){md-switch.md-default-theme .md-bar{background-color:#666}md-switch.md-default-theme.md-checked .md-bar{background-color:#9e9e9e}md-switch.md-default-theme .md-thumb{background-color:#fff}}@-webkit-keyframes md-tab-content-hide{0%{opacity:1}50%{opacity:1}to{opacity:0}}@keyframes md-tab-content-hide{0%{opacity:1}50%{opacity:1}to{opacity:0}}md-tab-data{position:absolute;top:0;left:0;right:0;bottom:0;z-index:-1;opacity:0}md-tabs{display:block;margin:0;border-radius:2px;overflow:hidden;position:relative;-webkit-flex-shrink:0;flex-shrink:0}md-tabs:not(.md-no-tab-content):not(.md-dynamic-height){min-height:248px}md-tabs[md-align-tabs=bottom]{padding-bottom:48px}md-tabs[md-align-tabs=bottom] md-tabs-wrapper{position:absolute;bottom:0;left:0;right:0;height:48px;z-index:2}md-tabs[md-align-tabs=bottom] md-tabs-content-wrapper{top:0;bottom:48px}md-tabs.md-dynamic-height md-tabs-content-wrapper{min-height:0;position:relative;top:auto;left:auto;right:auto;bottom:auto;overflow:visible}md-tabs.md-dynamic-height md-tab-content.md-active{position:relative}md-tabs[md-border-bottom] md-tabs-wrapper{border-width:0 0 1px;border-style:solid}md-tabs[md-border-bottom]:not(.md-dynamic-height) md-tabs-content-wrapper{top:49px}md-tabs-wrapper{display:block;position:relative;-webkit-transform:translateZ(0);transform:translateZ(0)}md-tabs-wrapper md-next-button,md-tabs-wrapper md-prev-button{height:100%;width:32px;position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);line-height:1em;z-index:2;cursor:pointer;font-size:16px;background:transparent no-repeat 50%;-webkit-transition:all .5s cubic-bezier(.35,0,.25,1);transition:all .5s cubic-bezier(.35,0,.25,1)}md-tabs-wrapper md-next-button:focus,md-tabs-wrapper md-prev-button:focus{outline:none}md-tabs-wrapper md-next-button.md-disabled,md-tabs-wrapper md-prev-button.md-disabled{opacity:.25;cursor:default}md-tabs-wrapper md-next-button.ng-leave,md-tabs-wrapper md-prev-button.ng-leave{-webkit-transition:none;transition:none}md-tabs-wrapper md-next-button md-icon,md-tabs-wrapper md-prev-button md-icon{position:absolute;top:50%;left:50%;-webkit-transform:translate3d(-50%,-50%,0);transform:translate3d(-50%,-50%,0)}md-tabs-wrapper md-prev-button{left:0;background-image:url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4gPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE3LjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPiA8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPiA8c3ZnIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSIyNHB4IiBoZWlnaHQ9IjI0cHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMjQgMjQiIHhtbDpzcGFjZT0icHJlc2VydmUiPiA8ZyBpZD0iSGVhZGVyIj4gPGc+IDxyZWN0IHg9Ii02MTgiIHk9Ii0xMjA4IiBmaWxsPSJub25lIiB3aWR0aD0iMTQwMCIgaGVpZ2h0PSIzNjAwIi8+IDwvZz4gPC9nPiA8ZyBpZD0iTGFiZWwiPiA8L2c+IDxnIGlkPSJJY29uIj4gPGc+IDxwb2x5Z29uIHBvaW50cz0iMTUuNCw3LjQgMTQsNiA4LDEyIDE0LDE4IDE1LjQsMTYuNiAxMC44LDEyIAkJIiBzdHlsZT0iZmlsbDp3aGl0ZTsiLz4gPHJlY3QgZmlsbD0ibm9uZSIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ii8+IDwvZz4gPC9nPiA8ZyBpZD0iR3JpZCIgZGlzcGxheT0ibm9uZSI+IDxnIGRpc3BsYXk9ImlubGluZSI+IDwvZz4gPC9nPiA8L3N2Zz4NCg==\")}[dir=rtl] md-tabs-wrapper md-prev-button{left:auto;right:0}md-tabs-wrapper md-next-button{right:0;background-image:url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4gPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE3LjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPiA8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPiA8c3ZnIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSIyNHB4IiBoZWlnaHQ9IjI0cHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMjQgMjQiIHhtbDpzcGFjZT0icHJlc2VydmUiPiA8ZyBpZD0iSGVhZGVyIj4gPGc+IDxyZWN0IHg9Ii02MTgiIHk9Ii0xMzM2IiBmaWxsPSJub25lIiB3aWR0aD0iMTQwMCIgaGVpZ2h0PSIzNjAwIi8+IDwvZz4gPC9nPiA8ZyBpZD0iTGFiZWwiPiA8L2c+IDxnIGlkPSJJY29uIj4gPGc+IDxwb2x5Z29uIHBvaW50cz0iMTAsNiA4LjYsNy40IDEzLjIsMTIgOC42LDE2LjYgMTAsMTggMTYsMTIgCQkiIHN0eWxlPSJmaWxsOndoaXRlOyIvPiA8cmVjdCBmaWxsPSJub25lIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz4gPC9nPiA8L2c+IDxnIGlkPSJHcmlkIiBkaXNwbGF5PSJub25lIj4gPGcgZGlzcGxheT0iaW5saW5lIj4gPC9nPiA8L2c+IDwvc3ZnPg0K\")}[dir=rtl] md-tabs-wrapper md-next-button{right:auto;left:0}md-tabs-wrapper md-next-button md-icon{-webkit-transform:translate3d(-50%,-50%,0) rotate(180deg);transform:translate3d(-50%,-50%,0) rotate(180deg)}md-tabs-wrapper.md-stretch-tabs md-pagination-wrapper{width:100%;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;flex-direction:row}md-tabs-wrapper.md-stretch-tabs md-pagination-wrapper md-tab-item{-webkit-box-flex:1;-webkit-flex-grow:1;flex-grow:1}md-tabs-canvas{position:relative;overflow:hidden;display:block;height:48px}md-tabs-canvas:after{content:\"\";display:table;clear:both}md-tabs-canvas .md-dummy-wrapper{position:absolute;top:0;left:0}[dir=rtl] md-tabs-canvas .md-dummy-wrapper{left:auto;right:0}md-tabs-canvas.md-paginated{margin:0 32px}md-tabs-canvas.md-center-tabs{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column;text-align:center}md-tabs-canvas.md-center-tabs .md-tab{float:none;display:inline-block}md-pagination-wrapper{height:48px;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-transition:-webkit-transform .5s cubic-bezier(.35,0,.25,1);transition:-webkit-transform .5s cubic-bezier(.35,0,.25,1);transition:transform .5s cubic-bezier(.35,0,.25,1);transition:transform .5s cubic-bezier(.35,0,.25,1),-webkit-transform .5s cubic-bezier(.35,0,.25,1);position:absolute;left:0;-webkit-transform:translateZ(0);transform:translateZ(0)}md-pagination-wrapper:after{content:\"\";display:table;clear:both}[dir=rtl] md-pagination-wrapper{left:auto;right:0}md-pagination-wrapper.md-center-tabs{position:relative;-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center}md-tabs-content-wrapper{display:block;top:48px;overflow:hidden}md-tab-content,md-tabs-content-wrapper{position:absolute;left:0;right:0;bottom:0}md-tab-content{display:-webkit-box;display:-webkit-flex;display:flex;top:0;-webkit-transition:-webkit-transform .5s cubic-bezier(.35,0,.25,1);transition:-webkit-transform .5s cubic-bezier(.35,0,.25,1);transition:transform .5s cubic-bezier(.35,0,.25,1);transition:transform .5s cubic-bezier(.35,0,.25,1),-webkit-transform .5s cubic-bezier(.35,0,.25,1);overflow:auto;-webkit-transform:translateZ(0);transform:translateZ(0)}md-tab-content.md-no-scroll{bottom:auto;overflow:hidden}md-tab-content.md-no-transition,md-tab-content.ng-leave{-webkit-transition:none;transition:none}md-tab-content.md-left:not(.md-active){-webkit-transform:translateX(-100%);transform:translateX(-100%);-webkit-animation:1s md-tab-content-hide;animation:1s md-tab-content-hide;opacity:0}[dir=rtl] md-tab-content.md-left:not(.md-active){-webkit-transform:translateX(100%);transform:translateX(100%)}md-tab-content.md-left:not(.md-active) *{-webkit-transition:visibility 0s linear;transition:visibility 0s linear;-webkit-transition-delay:.5s;transition-delay:.5s;visibility:hidden}md-tab-content.md-right:not(.md-active){-webkit-transform:translateX(100%);transform:translateX(100%);-webkit-animation:1s md-tab-content-hide;animation:1s md-tab-content-hide;opacity:0}[dir=rtl] md-tab-content.md-right:not(.md-active){-webkit-transform:translateX(-100%);transform:translateX(-100%)}md-tab-content.md-right:not(.md-active) *{-webkit-transition:visibility 0s linear;transition:visibility 0s linear;-webkit-transition-delay:.5s;transition-delay:.5s;visibility:hidden}md-tab-content>div{-webkit-box-flex:1;-webkit-flex:1 0 100%;flex:1 0 100%;min-width:0}md-tab-content>div.ng-leave{-webkit-animation:1s md-tab-content-hide;animation:1s md-tab-content-hide}md-ink-bar{position:absolute;left:auto;right:auto;bottom:0;height:2px}md-ink-bar.md-left{-webkit-transition:left .125s cubic-bezier(.35,0,.25,1),right .25s cubic-bezier(.35,0,.25,1);transition:left .125s cubic-bezier(.35,0,.25,1),right .25s cubic-bezier(.35,0,.25,1)}md-ink-bar.md-right{-webkit-transition:left .25s cubic-bezier(.35,0,.25,1),right .125s cubic-bezier(.35,0,.25,1);transition:left .25s cubic-bezier(.35,0,.25,1),right .125s cubic-bezier(.35,0,.25,1)}md-tab{position:absolute;z-index:-1;left:-9999px}.md-tab{font-size:14px;text-align:center;line-height:24px;padding:12px 24px;-webkit-transition:background-color .35s cubic-bezier(.35,0,.25,1);transition:background-color .35s cubic-bezier(.35,0,.25,1);cursor:pointer;white-space:nowrap;position:relative;text-transform:uppercase;float:left;font-weight:500;box-sizing:border-box;overflow:hidden;text-overflow:ellipsis}[dir=rtl] .md-tab{float:right}.md-tab.md-focused{box-shadow:none;outline:none}.md-tab.md-active{cursor:default}.md-tab.md-disabled{pointer-events:none;touch-action:pan-y;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-user-drag:none;opacity:.5;cursor:default}.md-tab.ng-leave{-webkit-transition:none;transition:none}md-toolbar+md-tabs{border-top-left-radius:0;border-top-right-radius:0}.md-toast-text{padding:0 6px}md-toast{position:absolute;z-index:105;box-sizing:border-box;cursor:default;padding:8px;opacity:1}md-toast,md-toast .md-toast-content{overflow:hidden;-webkit-transition:all .4s cubic-bezier(.25,.8,.25,1);transition:all .4s cubic-bezier(.25,.8,.25,1)}md-toast .md-toast-content{display:-webkit-box;display:-webkit-flex;display:flex;direction:row;-webkit-box-align:center;-webkit-align-items:center;align-items:center;max-height:168px;max-width:100%;min-height:48px;padding:0 18px;box-shadow:0 2px 5px 0 rgba(0,0,0,.26);border-radius:2px;font-size:14px;-webkit-transform:translateZ(0) rotate(0deg);transform:translateZ(0) rotate(0deg);-webkit-box-pack:start;-webkit-justify-content:flex-start;justify-content:flex-start}md-toast .md-toast-content:before{content:\"\";min-height:48px;visibility:hidden;display:inline-block}[dir=rtl] md-toast .md-toast-content{-webkit-box-pack:end;-webkit-justify-content:flex-end;justify-content:flex-end}md-toast .md-toast-content span{-webkit-box-flex:1;-webkit-flex:1 1 0%;flex:1 1 0%;box-sizing:border-box;min-width:0}md-toast.md-capsule,md-toast.md-capsule .md-toast-content{border-radius:24px}md-toast.ng-leave-active .md-toast-content{-webkit-transition:all .3s cubic-bezier(.55,0,.55,.2);transition:all .3s cubic-bezier(.55,0,.55,.2)}md-toast.md-swipedown .md-toast-content,md-toast.md-swipeleft .md-toast-content,md-toast.md-swiperight .md-toast-content,md-toast.md-swipeup .md-toast-content{-webkit-transition:all .4s cubic-bezier(.25,.8,.25,1);transition:all .4s cubic-bezier(.25,.8,.25,1)}md-toast.ng-enter{opacity:0}md-toast.ng-enter .md-toast-content{-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}md-toast.ng-enter.md-top .md-toast-content{-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}md-toast.ng-enter.ng-enter-active{opacity:1}md-toast.ng-enter.ng-enter-active .md-toast-content{-webkit-transform:translateZ(0);transform:translateZ(0)}md-toast.ng-leave.ng-leave-active .md-toast-content{opacity:0;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}md-toast.ng-leave.ng-leave-active.md-swipeup .md-toast-content{-webkit-transform:translate3d(0,-50%,0);transform:translate3d(0,-50%,0)}md-toast.ng-leave.ng-leave-active.md-swipedown .md-toast-content{-webkit-transform:translate3d(0,50%,0);transform:translate3d(0,50%,0)}md-toast.ng-leave.ng-leave-active.md-top .md-toast-content{-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}md-toast .md-action{line-height:19px;margin-left:24px;margin-right:0;cursor:pointer;text-transform:uppercase;float:right}md-toast .md-button{min-width:0;margin-right:0;margin-left:12px}[dir=rtl] md-toast .md-button{margin-right:12px;margin-left:0}@media (max-width:959px){md-toast{left:0;right:0;width:100%;max-width:100%;min-width:0;border-radius:0;bottom:0;padding:0}md-toast.ng-leave.ng-leave-active.md-swipeup .md-toast-content{-webkit-transform:translate3d(0,-50%,0);transform:translate3d(0,-50%,0)}md-toast.ng-leave.ng-leave-active.md-swipedown .md-toast-content{-webkit-transform:translate3d(0,50%,0);transform:translate3d(0,50%,0)}}@media (min-width:960px){md-toast{min-width:304px}md-toast.md-bottom{bottom:0}md-toast.md-left{left:0}md-toast.md-right{right:0}md-toast.md-top{top:0}md-toast._md-start{left:0}[dir=rtl] md-toast._md-start{left:auto;right:0}md-toast._md-end{right:0}[dir=rtl] md-toast._md-end{right:auto;left:0}md-toast.ng-leave.ng-leave-active.md-swipeleft .md-toast-content{-webkit-transform:translate3d(-50%,0,0);transform:translate3d(-50%,0,0)}md-toast.ng-leave.ng-leave-active.md-swiperight .md-toast-content{-webkit-transform:translate3d(50%,0,0);transform:translate3d(50%,0,0)}}@media (min-width:1920px){md-toast .md-toast-content{max-width:568px}}@media screen and (-ms-high-contrast:active){md-toast{border:1px solid #fff}}.md-toast-animating{overflow:hidden!important}md-toolbar{box-sizing:border-box;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column;position:relative;z-index:2;font-size:20px;min-height:64px;width:100%}md-toolbar._md-toolbar-transitions{-webkit-transition-duration:.5s;transition-duration:.5s;-webkit-transition-timing-function:cubic-bezier(.35,0,.25,1);transition-timing-function:cubic-bezier(.35,0,.25,1);-webkit-transition-property:background-color,fill,color;transition-property:background-color,fill,color}md-toolbar.md-whiteframe-z1-add,md-toolbar.md-whiteframe-z1-remove{-webkit-transition:box-shadow .5s linear;transition:box-shadow .5s linear}md-toolbar md-toolbar-filler{width:72px}md-toolbar *,md-toolbar :after,md-toolbar :before{box-sizing:border-box}md-toolbar.ng-animate{-webkit-transition:none;transition:none}md-toolbar.md-tall{height:128px;min-height:128px;max-height:128px}md-toolbar.md-medium-tall{height:88px;min-height:88px;max-height:88px}md-toolbar.md-medium-tall .md-toolbar-tools{height:48px;min-height:48px;max-height:48px}md-toolbar>.md-indent{margin-left:64px}[dir=rtl] md-toolbar>.md-indent{margin-left:auto;margin-right:64px}md-toolbar~md-content>md-list{padding:0}md-toolbar~md-content>md-list md-list-item:last-child md-divider{display:none}.md-toolbar-tools{font-size:20px;letter-spacing:.005em;box-sizing:border-box;font-weight:400;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;flex-direction:row;width:100%;height:64px;max-height:64px;padding:0 16px;margin:0}.md-toolbar-tools h1,.md-toolbar-tools h2,.md-toolbar-tools h3{font-size:inherit;font-weight:inherit;margin:inherit}.md-toolbar-tools a{color:inherit;text-decoration:none}.md-toolbar-tools .fill-height{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:center;-webkit-align-items:center;align-items:center}.md-toolbar-tools md-checkbox{margin:inherit}.md-toolbar-tools .md-button{margin-top:0;margin-bottom:0}.md-toolbar-tools .md-button,.md-toolbar-tools .md-button.md-icon-button md-icon{-webkit-transition-duration:.5s;transition-duration:.5s;-webkit-transition-timing-function:cubic-bezier(.35,0,.25,1);transition-timing-function:cubic-bezier(.35,0,.25,1);-webkit-transition-property:background-color,fill,color;transition-property:background-color,fill,color}.md-toolbar-tools .md-button.md-icon-button md-icon.ng-animate,.md-toolbar-tools .md-button.ng-animate{-webkit-transition:none;transition:none}.md-toolbar-tools>.md-button:first-child{margin-left:-8px}[dir=rtl] .md-toolbar-tools>.md-button:first-child{margin-left:auto;margin-right:-8px}.md-toolbar-tools>.md-button:last-child{margin-right:-8px}[dir=rtl] .md-toolbar-tools>.md-button:last-child{margin-right:auto;margin-left:-8px}.md-toolbar-tools>md-menu:last-child{margin-right:-8px}[dir=rtl] .md-toolbar-tools>md-menu:last-child{margin-right:auto;margin-left:-8px}.md-toolbar-tools>md-menu:last-child>.md-button{margin-right:0}[dir=rtl] .md-toolbar-tools>md-menu:last-child>.md-button{margin-right:auto;margin-left:0}@media screen and (-ms-high-contrast:active){.md-toolbar-tools{border-bottom:1px solid #fff}}@media (min-width:0) and (max-width:959px) and (orientation:portrait){md-toolbar{min-height:56px}.md-toolbar-tools{height:56px;max-height:56px}}@media (min-width:0) and (max-width:959px) and (orientation:landscape){md-toolbar{min-height:48px}.md-toolbar-tools{height:48px;max-height:48px}}.md-tooltip{pointer-events:none;border-radius:4px;overflow:hidden;opacity:0;font-weight:500;font-size:14px;white-space:nowrap;text-overflow:ellipsis;height:32px;line-height:32px;padding-right:16px;padding-left:16px}.md-tooltip.md-origin-top{-webkit-transform-origin:center bottom;transform-origin:center bottom;margin-top:-24px}.md-tooltip.md-origin-right{-webkit-transform-origin:left center;transform-origin:left center;margin-left:24px}.md-tooltip.md-origin-bottom{-webkit-transform-origin:center top;transform-origin:center top;margin-top:24px}.md-tooltip.md-origin-left{-webkit-transform-origin:right center;transform-origin:right center;margin-left:-24px}@media (min-width:960px){.md-tooltip{font-size:10px;height:22px;line-height:22px;padding-right:8px;padding-left:8px}.md-tooltip.md-origin-top{margin-top:-14px}.md-tooltip.md-origin-right{margin-left:14px}.md-tooltip.md-origin-bottom{margin-top:14px}.md-tooltip.md-origin-left{margin-left:-14px}}.md-tooltip.md-show-add{-webkit-transform:scale(0);transform:scale(0)}.md-tooltip.md-show{-webkit-transition:all .4s cubic-bezier(.25,.8,.25,1);transition:all .4s cubic-bezier(.25,.8,.25,1);-webkit-transition-duration:.15s;transition-duration:.15s;-webkit-transform:scale(1);transform:scale(1);opacity:.9}.md-tooltip.md-hide{-webkit-transition:all .3s cubic-bezier(.55,0,.55,.2);transition:all .3s cubic-bezier(.55,0,.55,.2);-webkit-transition-duration:.15s;transition-duration:.15s;-webkit-transform:scale(0);transform:scale(0);opacity:0}.md-truncate{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.md-truncate.md-clip{text-overflow:clip}.md-truncate.flex{width:0}.md-virtual-repeat-container{box-sizing:border-box;display:block;margin:0;overflow:hidden;padding:0;position:relative}.md-virtual-repeat-container .md-virtual-repeat-scroller{bottom:0;box-sizing:border-box;left:0;margin:0;overflow-x:hidden;padding:0;position:absolute;right:0;top:0;-webkit-overflow-scrolling:touch}.md-virtual-repeat-container .md-virtual-repeat-sizer{box-sizing:border-box;height:1px;display:block;margin:0;padding:0;width:1px}.md-virtual-repeat-container .md-virtual-repeat-offsetter{box-sizing:border-box;left:0;margin:0;padding:0;position:absolute;right:0;top:0}.md-virtual-repeat-container.md-orient-horizontal .md-virtual-repeat-scroller{overflow-x:auto;overflow-y:hidden}.md-virtual-repeat-container.md-orient-horizontal .md-virtual-repeat-offsetter{bottom:16px;right:auto;white-space:nowrap}[dir=rtl] .md-virtual-repeat-container.md-orient-horizontal .md-virtual-repeat-offsetter{right:auto;left:auto}.md-whiteframe-1dp,.md-whiteframe-z1{box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12)}.md-whiteframe-2dp{box-shadow:0 1px 5px 0 rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.12)}.md-whiteframe-3dp{box-shadow:0 1px 8px 0 rgba(0,0,0,.2),0 3px 4px 0 rgba(0,0,0,.14),0 3px 3px -2px rgba(0,0,0,.12)}.md-whiteframe-4dp,.md-whiteframe-z2{box-shadow:0 2px 4px -1px rgba(0,0,0,.2),0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12)}.md-whiteframe-5dp{box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 5px 8px 0 rgba(0,0,0,.14),0 1px 14px 0 rgba(0,0,0,.12)}.md-whiteframe-6dp{box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12)}.md-whiteframe-7dp,.md-whiteframe-z3{box-shadow:0 4px 5px -2px rgba(0,0,0,.2),0 7px 10px 1px rgba(0,0,0,.14),0 2px 16px 1px rgba(0,0,0,.12)}.md-whiteframe-8dp{box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)}.md-whiteframe-9dp{box-shadow:0 5px 6px -3px rgba(0,0,0,.2),0 9px 12px 1px rgba(0,0,0,.14),0 3px 16px 2px rgba(0,0,0,.12)}.md-whiteframe-10dp,.md-whiteframe-z4{box-shadow:0 6px 6px -3px rgba(0,0,0,.2),0 10px 14px 1px rgba(0,0,0,.14),0 4px 18px 3px rgba(0,0,0,.12)}.md-whiteframe-11dp{box-shadow:0 6px 7px -4px rgba(0,0,0,.2),0 11px 15px 1px rgba(0,0,0,.14),0 4px 20px 3px rgba(0,0,0,.12)}.md-whiteframe-12dp{box-shadow:0 7px 8px -4px rgba(0,0,0,.2),0 12px 17px 2px rgba(0,0,0,.14),0 5px 22px 4px rgba(0,0,0,.12)}.md-whiteframe-13dp,.md-whiteframe-z5{box-shadow:0 7px 8px -4px rgba(0,0,0,.2),0 13px 19px 2px rgba(0,0,0,.14),0 5px 24px 4px rgba(0,0,0,.12)}.md-whiteframe-14dp{box-shadow:0 7px 9px -4px rgba(0,0,0,.2),0 14px 21px 2px rgba(0,0,0,.14),0 5px 26px 4px rgba(0,0,0,.12)}.md-whiteframe-15dp{box-shadow:0 8px 9px -5px rgba(0,0,0,.2),0 15px 22px 2px rgba(0,0,0,.14),0 6px 28px 5px rgba(0,0,0,.12)}.md-whiteframe-16dp{box-shadow:0 8px 10px -5px rgba(0,0,0,.2),0 16px 24px 2px rgba(0,0,0,.14),0 6px 30px 5px rgba(0,0,0,.12)}.md-whiteframe-17dp{box-shadow:0 8px 11px -5px rgba(0,0,0,.2),0 17px 26px 2px rgba(0,0,0,.14),0 6px 32px 5px rgba(0,0,0,.12)}.md-whiteframe-18dp{box-shadow:0 9px 11px -5px rgba(0,0,0,.2),0 18px 28px 2px rgba(0,0,0,.14),0 7px 34px 6px rgba(0,0,0,.12)}.md-whiteframe-19dp{box-shadow:0 9px 12px -6px rgba(0,0,0,.2),0 19px 29px 2px rgba(0,0,0,.14),0 7px 36px 6px rgba(0,0,0,.12)}.md-whiteframe-20dp{box-shadow:0 10px 13px -6px rgba(0,0,0,.2),0 20px 31px 3px rgba(0,0,0,.14),0 8px 38px 7px rgba(0,0,0,.12)}.md-whiteframe-21dp{box-shadow:0 10px 13px -6px rgba(0,0,0,.2),0 21px 33px 3px rgba(0,0,0,.14),0 8px 40px 7px rgba(0,0,0,.12)}.md-whiteframe-22dp{box-shadow:0 10px 14px -6px rgba(0,0,0,.2),0 22px 35px 3px rgba(0,0,0,.14),0 8px 42px 7px rgba(0,0,0,.12)}.md-whiteframe-23dp{box-shadow:0 11px 14px -7px rgba(0,0,0,.2),0 23px 36px 3px rgba(0,0,0,.14),0 9px 44px 8px rgba(0,0,0,.12)}.md-whiteframe-24dp{box-shadow:0 11px 15px -7px rgba(0,0,0,.2),0 24px 38px 3px rgba(0,0,0,.14),0 9px 46px 8px rgba(0,0,0,.12)}@media screen and (-ms-high-contrast:active){md-whiteframe{border:1px solid #fff}}@media print{[md-whiteframe],md-whiteframe{background-color:#fff}}.ng-cloak,.x-ng-cloak,[data-ng-cloak],[ng-cloak],[ng\\:cloak],[x-ng-cloak]{display:none!important}@-moz-document url-prefix(){.layout-fill{margin:0;width:100%;min-height:100%;height:100%}}.flex-order{-webkit-box-ordinal-group:1;-webkit-order:0;order:0}.flex-order--20{-webkit-box-ordinal-group:-19;-webkit-order:-20;order:-20}.flex-order--19{-webkit-box-ordinal-group:-18;-webkit-order:-19;order:-19}.flex-order--18{-webkit-box-ordinal-group:-17;-webkit-order:-18;order:-18}.flex-order--17{-webkit-box-ordinal-group:-16;-webkit-order:-17;order:-17}.flex-order--16{-webkit-box-ordinal-group:-15;-webkit-order:-16;order:-16}.flex-order--15{-webkit-box-ordinal-group:-14;-webkit-order:-15;order:-15}.flex-order--14{-webkit-box-ordinal-group:-13;-webkit-order:-14;order:-14}.flex-order--13{-webkit-box-ordinal-group:-12;-webkit-order:-13;order:-13}.flex-order--12{-webkit-box-ordinal-group:-11;-webkit-order:-12;order:-12}.flex-order--11{-webkit-box-ordinal-group:-10;-webkit-order:-11;order:-11}.flex-order--10{-webkit-box-ordinal-group:-9;-webkit-order:-10;order:-10}.flex-order--9{-webkit-box-ordinal-group:-8;-webkit-order:-9;order:-9}.flex-order--8{-webkit-box-ordinal-group:-7;-webkit-order:-8;order:-8}.flex-order--7{-webkit-box-ordinal-group:-6;-webkit-order:-7;order:-7}.flex-order--6{-webkit-box-ordinal-group:-5;-webkit-order:-6;order:-6}.flex-order--5{-webkit-box-ordinal-group:-4;-webkit-order:-5;order:-5}.flex-order--4{-webkit-box-ordinal-group:-3;-webkit-order:-4;order:-4}.flex-order--3{-webkit-box-ordinal-group:-2;-webkit-order:-3;order:-3}.flex-order--2{-webkit-box-ordinal-group:-1;-webkit-order:-2;order:-2}.flex-order--1{-webkit-box-ordinal-group:0;-webkit-order:-1;order:-1}.flex-order-0{-webkit-box-ordinal-group:1;-webkit-order:0;order:0}.flex-order-1{-webkit-box-ordinal-group:2;-webkit-order:1;order:1}.flex-order-2{-webkit-box-ordinal-group:3;-webkit-order:2;order:2}.flex-order-3{-webkit-box-ordinal-group:4;-webkit-order:3;order:3}.flex-order-4{-webkit-box-ordinal-group:5;-webkit-order:4;order:4}.flex-order-5{-webkit-box-ordinal-group:6;-webkit-order:5;order:5}.flex-order-6{-webkit-box-ordinal-group:7;-webkit-order:6;order:6}.flex-order-7{-webkit-box-ordinal-group:8;-webkit-order:7;order:7}.flex-order-8{-webkit-box-ordinal-group:9;-webkit-order:8;order:8}.flex-order-9{-webkit-box-ordinal-group:10;-webkit-order:9;order:9}.flex-order-10{-webkit-box-ordinal-group:11;-webkit-order:10;order:10}.flex-order-11{-webkit-box-ordinal-group:12;-webkit-order:11;order:11}.flex-order-12{-webkit-box-ordinal-group:13;-webkit-order:12;order:12}.flex-order-13{-webkit-box-ordinal-group:14;-webkit-order:13;order:13}.flex-order-14{-webkit-box-ordinal-group:15;-webkit-order:14;order:14}.flex-order-15{-webkit-box-ordinal-group:16;-webkit-order:15;order:15}.flex-order-16{-webkit-box-ordinal-group:17;-webkit-order:16;order:16}.flex-order-17{-webkit-box-ordinal-group:18;-webkit-order:17;order:17}.flex-order-18{-webkit-box-ordinal-group:19;-webkit-order:18;order:18}.flex-order-19{-webkit-box-ordinal-group:20;-webkit-order:19;order:19}.flex-order-20{-webkit-box-ordinal-group:21;-webkit-order:20;order:20}.flex-offset-0,.offset-0{margin-left:0}[dir=rtl] .flex-offset-0,[dir=rtl] .offset-0{margin-left:auto;margin-right:0}.flex-offset-5,.offset-5{margin-left:5%}[dir=rtl] .flex-offset-5,[dir=rtl] .offset-5{margin-left:auto;margin-right:5%}.flex-offset-10,.offset-10{margin-left:10%}[dir=rtl] .flex-offset-10,[dir=rtl] .offset-10{margin-left:auto;margin-right:10%}.flex-offset-15,.offset-15{margin-left:15%}[dir=rtl] .flex-offset-15,[dir=rtl] .offset-15{margin-left:auto;margin-right:15%}.flex-offset-20,.offset-20{margin-left:20%}[dir=rtl] .flex-offset-20,[dir=rtl] .offset-20{margin-left:auto;margin-right:20%}.flex-offset-25,.offset-25{margin-left:25%}[dir=rtl] .flex-offset-25,[dir=rtl] .offset-25{margin-left:auto;margin-right:25%}.flex-offset-30,.offset-30{margin-left:30%}[dir=rtl] .flex-offset-30,[dir=rtl] .offset-30{margin-left:auto;margin-right:30%}.flex-offset-35,.offset-35{margin-left:35%}[dir=rtl] .flex-offset-35,[dir=rtl] .offset-35{margin-left:auto;margin-right:35%}.flex-offset-40,.offset-40{margin-left:40%}[dir=rtl] .flex-offset-40,[dir=rtl] .offset-40{margin-left:auto;margin-right:40%}.flex-offset-45,.offset-45{margin-left:45%}[dir=rtl] .flex-offset-45,[dir=rtl] .offset-45{margin-left:auto;margin-right:45%}.flex-offset-50,.offset-50{margin-left:50%}[dir=rtl] .flex-offset-50,[dir=rtl] .offset-50{margin-left:auto;margin-right:50%}.flex-offset-55,.offset-55{margin-left:55%}[dir=rtl] .flex-offset-55,[dir=rtl] .offset-55{margin-left:auto;margin-right:55%}.flex-offset-60,.offset-60{margin-left:60%}[dir=rtl] .flex-offset-60,[dir=rtl] .offset-60{margin-left:auto;margin-right:60%}.flex-offset-65,.offset-65{margin-left:65%}[dir=rtl] .flex-offset-65,[dir=rtl] .offset-65{margin-left:auto;margin-right:65%}.flex-offset-70,.offset-70{margin-left:70%}[dir=rtl] .flex-offset-70,[dir=rtl] .offset-70{margin-left:auto;margin-right:70%}.flex-offset-75,.offset-75{margin-left:75%}[dir=rtl] .flex-offset-75,[dir=rtl] .offset-75{margin-left:auto;margin-right:75%}.flex-offset-80,.offset-80{margin-left:80%}[dir=rtl] .flex-offset-80,[dir=rtl] .offset-80{margin-left:auto;margin-right:80%}.flex-offset-85,.offset-85{margin-left:85%}[dir=rtl] .flex-offset-85,[dir=rtl] .offset-85{margin-left:auto;margin-right:85%}.flex-offset-90,.offset-90{margin-left:90%}[dir=rtl] .flex-offset-90,[dir=rtl] .offset-90{margin-left:auto;margin-right:90%}.flex-offset-95,.offset-95{margin-left:95%}[dir=rtl] .flex-offset-95,[dir=rtl] .offset-95{margin-left:auto;margin-right:95%}.flex-offset-33,.offset-33{margin-left:33.33333%}.flex-offset-66,.offset-66{margin-left:66.66667%}[dir=rtl] .flex-offset-66,[dir=rtl] .offset-66{margin-left:auto;margin-right:66.66667%}.layout-align,.layout-align-start-stretch{-webkit-align-content:stretch;align-content:stretch;-webkit-box-align:stretch;-webkit-align-items:stretch;align-items:stretch}.layout-align,.layout-align-start,.layout-align-start-center,.layout-align-start-end,.layout-align-start-start,.layout-align-start-stretch{-webkit-box-pack:start;-webkit-justify-content:flex-start;justify-content:flex-start}.layout-align-center,.layout-align-center-center,.layout-align-center-end,.layout-align-center-start,.layout-align-center-stretch{-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center}.layout-align-end,.layout-align-end-center,.layout-align-end-end,.layout-align-end-start,.layout-align-end-stretch{-webkit-box-pack:end;-webkit-justify-content:flex-end;justify-content:flex-end}.layout-align-space-around,.layout-align-space-around-center,.layout-align-space-around-end,.layout-align-space-around-start,.layout-align-space-around-stretch{-webkit-justify-content:space-around;justify-content:space-around}.layout-align-space-between,.layout-align-space-between-center,.layout-align-space-between-end,.layout-align-space-between-start,.layout-align-space-between-stretch{-webkit-box-pack:justify;-webkit-justify-content:space-between;justify-content:space-between}.layout-align-center-start,.layout-align-end-start,.layout-align-space-around-start,.layout-align-space-between-start,.layout-align-start-start{-webkit-box-align:start;-webkit-align-items:flex-start;align-items:flex-start;-webkit-align-content:flex-start;align-content:flex-start}.layout-align-center-center,.layout-align-end-center,.layout-align-space-around-center,.layout-align-space-between-center,.layout-align-start-center{-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-align-content:center;align-content:center;max-width:100%}.layout-align-center-center>*,.layout-align-end-center>*,.layout-align-space-around-center>*,.layout-align-space-between-center>*,.layout-align-start-center>*{max-width:100%;box-sizing:border-box}.layout-align-center-end,.layout-align-end-end,.layout-align-space-around-end,.layout-align-space-between-end,.layout-align-start-end{-webkit-box-align:end;-webkit-align-items:flex-end;align-items:flex-end;-webkit-align-content:flex-end;align-content:flex-end}.layout-align-center-stretch,.layout-align-end-stretch,.layout-align-space-around-stretch,.layout-align-space-between-stretch,.layout-align-start-stretch{-webkit-box-align:stretch;-webkit-align-items:stretch;align-items:stretch;-webkit-align-content:stretch;align-content:stretch}.flex{-webkit-flex:1;flex:1}.flex,.flex-grow{-webkit-box-flex:1;box-sizing:border-box}.flex-grow{-webkit-flex:1 1 100%;flex:1 1 100%}.flex-initial{-webkit-box-flex:0;-webkit-flex:0 1 auto;flex:0 1 auto;box-sizing:border-box}.flex-auto{-webkit-box-flex:1;-webkit-flex:1 1 auto;flex:1 1 auto;box-sizing:border-box}.flex-none{-webkit-box-flex:0;-webkit-flex:0 0 auto;flex:0 0 auto;box-sizing:border-box}.flex-noshrink{-webkit-box-flex:1;-webkit-flex:1 0 auto;flex:1 0 auto;box-sizing:border-box}.flex-nogrow{-webkit-box-flex:0;-webkit-flex:0 1 auto;flex:0 1 auto;box-sizing:border-box}.flex-0,.layout-row>.flex-0{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:0;max-height:100%;box-sizing:border-box}.layout-row>.flex-0{min-width:0}.layout-column>.flex-0{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;max-height:0%;box-sizing:border-box;min-height:0}.flex-5,.layout-row>.flex-5{max-width:5%;max-height:100%}.flex-5,.layout-column>.flex-5,.layout-row>.flex-5{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-5{max-width:100%;max-height:5%}.flex-10,.layout-row>.flex-10{max-width:10%;max-height:100%}.flex-10,.layout-column>.flex-10,.layout-row>.flex-10{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-10{max-width:100%;max-height:10%}.flex-15,.layout-row>.flex-15{max-width:15%;max-height:100%}.flex-15,.layout-column>.flex-15,.layout-row>.flex-15{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-15{max-width:100%;max-height:15%}.flex-20,.layout-row>.flex-20{max-width:20%;max-height:100%}.flex-20,.layout-column>.flex-20,.layout-row>.flex-20{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-20{max-width:100%;max-height:20%}.flex-25,.layout-row>.flex-25{max-width:25%;max-height:100%}.flex-25,.layout-column>.flex-25,.layout-row>.flex-25{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-25{max-width:100%;max-height:25%}.flex-30,.layout-row>.flex-30{max-width:30%;max-height:100%}.flex-30,.layout-column>.flex-30,.layout-row>.flex-30{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-30{max-width:100%;max-height:30%}.flex-35,.layout-row>.flex-35{max-width:35%;max-height:100%}.flex-35,.layout-column>.flex-35,.layout-row>.flex-35{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-35{max-width:100%;max-height:35%}.flex-40,.layout-row>.flex-40{max-width:40%;max-height:100%}.flex-40,.layout-column>.flex-40,.layout-row>.flex-40{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-40{max-width:100%;max-height:40%}.flex-45,.layout-row>.flex-45{max-width:45%;max-height:100%}.flex-45,.layout-column>.flex-45,.layout-row>.flex-45{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-45{max-width:100%;max-height:45%}.flex-50,.layout-row>.flex-50{max-width:50%;max-height:100%}.flex-50,.layout-column>.flex-50,.layout-row>.flex-50{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-50{max-width:100%;max-height:50%}.flex-55,.layout-row>.flex-55{max-width:55%;max-height:100%}.flex-55,.layout-column>.flex-55,.layout-row>.flex-55{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-55{max-width:100%;max-height:55%}.flex-60,.layout-row>.flex-60{max-width:60%;max-height:100%}.flex-60,.layout-column>.flex-60,.layout-row>.flex-60{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-60{max-width:100%;max-height:60%}.flex-65,.layout-row>.flex-65{max-width:65%;max-height:100%}.flex-65,.layout-column>.flex-65,.layout-row>.flex-65{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-65{max-width:100%;max-height:65%}.flex-70,.layout-row>.flex-70{max-width:70%;max-height:100%}.flex-70,.layout-column>.flex-70,.layout-row>.flex-70{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-70{max-width:100%;max-height:70%}.flex-75,.layout-row>.flex-75{max-width:75%;max-height:100%}.flex-75,.layout-column>.flex-75,.layout-row>.flex-75{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-75{max-width:100%;max-height:75%}.flex-80,.layout-row>.flex-80{max-width:80%;max-height:100%}.flex-80,.layout-column>.flex-80,.layout-row>.flex-80{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-80{max-width:100%;max-height:80%}.flex-85,.layout-row>.flex-85{max-width:85%;max-height:100%}.flex-85,.layout-column>.flex-85,.layout-row>.flex-85{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-85{max-width:100%;max-height:85%}.flex-90,.layout-row>.flex-90{max-width:90%;max-height:100%}.flex-90,.layout-column>.flex-90,.layout-row>.flex-90{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-90{max-width:100%;max-height:90%}.flex-95,.layout-row>.flex-95{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:95%;max-height:100%;box-sizing:border-box}.layout-column>.flex-95{max-height:95%}.flex-100,.layout-column>.flex-95{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;box-sizing:border-box}.flex-100{max-height:100%}.layout-column>.flex-100,.layout-row>.flex-100{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;max-height:100%;box-sizing:border-box}.layout-row>.flex-33{-webkit-flex:1 1 33.33%;flex:1 1 33.33%}.layout-row>.flex-66{-webkit-flex:1 1 66.66%;flex:1 1 66.66%}.layout-column>.flex-33{-webkit-flex:1 1 33.33%;flex:1 1 33.33%}.layout-column>.flex-66{-webkit-flex:1 1 66.66%;flex:1 1 66.66%}.layout-row>.flex-33{max-width:33.33%}.layout-row>.flex-33,.layout-row>.flex-66{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-height:100%;box-sizing:border-box}.layout-row>.flex-66{max-width:66.66%}.layout-row>.flex{min-width:0}.layout-column>.flex-33{max-height:33.33%}.layout-column>.flex-33,.layout-column>.flex-66{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;box-sizing:border-box}.layout-column>.flex-66{max-height:66.66%}.layout-column>.flex{min-height:0}.layout,.layout-column,.layout-row{box-sizing:border-box;display:-webkit-box;display:-webkit-flex;display:flex}.layout-column{-webkit-box-orient:vertical;-webkit-flex-direction:column;flex-direction:column}.layout-column,.layout-row{-webkit-box-direction:normal}.layout-row{-webkit-box-orient:horizontal;-webkit-flex-direction:row;flex-direction:row}.layout-padding-sm>*,.layout-padding>.flex-sm{padding:4px}.layout-padding,.layout-padding-gt-sm,.layout-padding-gt-sm>*,.layout-padding-md,.layout-padding-md>*,.layout-padding>*,.layout-padding>.flex,.layout-padding>.flex-gt-sm,.layout-padding>.flex-md{padding:8px}.layout-padding-gt-lg>*,.layout-padding-gt-md>*,.layout-padding-lg>*,.layout-padding>.flex-gt-lg,.layout-padding>.flex-gt-md,.layout-padding>.flex-lg{padding:16px}.layout-margin-sm>*,.layout-margin>.flex-sm{margin:4px}.layout-margin,.layout-margin-gt-sm,.layout-margin-gt-sm>*,.layout-margin-md,.layout-margin-md>*,.layout-margin>*,.layout-margin>.flex,.layout-margin>.flex-gt-sm,.layout-margin>.flex-md{margin:8px}.layout-margin-gt-lg>*,.layout-margin-gt-md>*,.layout-margin-lg>*,.layout-margin>.flex-gt-lg,.layout-margin>.flex-gt-md,.layout-margin>.flex-lg{margin:16px}.layout-wrap{-webkit-flex-wrap:wrap;flex-wrap:wrap}.layout-nowrap{-webkit-flex-wrap:nowrap;flex-wrap:nowrap}.layout-fill{margin:0;width:100%;min-height:100%;height:100%}@media (max-width:599px){.hide-xs:not(.show-xs):not(.show),.hide:not(.show-xs):not(.show){display:none}.flex-order-xs--20{-webkit-box-ordinal-group:-19;-webkit-order:-20;order:-20}.flex-order-xs--19{-webkit-box-ordinal-group:-18;-webkit-order:-19;order:-19}.flex-order-xs--18{-webkit-box-ordinal-group:-17;-webkit-order:-18;order:-18}.flex-order-xs--17{-webkit-box-ordinal-group:-16;-webkit-order:-17;order:-17}.flex-order-xs--16{-webkit-box-ordinal-group:-15;-webkit-order:-16;order:-16}.flex-order-xs--15{-webkit-box-ordinal-group:-14;-webkit-order:-15;order:-15}.flex-order-xs--14{-webkit-box-ordinal-group:-13;-webkit-order:-14;order:-14}.flex-order-xs--13{-webkit-box-ordinal-group:-12;-webkit-order:-13;order:-13}.flex-order-xs--12{-webkit-box-ordinal-group:-11;-webkit-order:-12;order:-12}.flex-order-xs--11{-webkit-box-ordinal-group:-10;-webkit-order:-11;order:-11}.flex-order-xs--10{-webkit-box-ordinal-group:-9;-webkit-order:-10;order:-10}.flex-order-xs--9{-webkit-box-ordinal-group:-8;-webkit-order:-9;order:-9}.flex-order-xs--8{-webkit-box-ordinal-group:-7;-webkit-order:-8;order:-8}.flex-order-xs--7{-webkit-box-ordinal-group:-6;-webkit-order:-7;order:-7}.flex-order-xs--6{-webkit-box-ordinal-group:-5;-webkit-order:-6;order:-6}.flex-order-xs--5{-webkit-box-ordinal-group:-4;-webkit-order:-5;order:-5}.flex-order-xs--4{-webkit-box-ordinal-group:-3;-webkit-order:-4;order:-4}.flex-order-xs--3{-webkit-box-ordinal-group:-2;-webkit-order:-3;order:-3}.flex-order-xs--2{-webkit-box-ordinal-group:-1;-webkit-order:-2;order:-2}.flex-order-xs--1{-webkit-box-ordinal-group:0;-webkit-order:-1;order:-1}.flex-order-xs-0{-webkit-box-ordinal-group:1;-webkit-order:0;order:0}.flex-order-xs-1{-webkit-box-ordinal-group:2;-webkit-order:1;order:1}.flex-order-xs-2{-webkit-box-ordinal-group:3;-webkit-order:2;order:2}.flex-order-xs-3{-webkit-box-ordinal-group:4;-webkit-order:3;order:3}.flex-order-xs-4{-webkit-box-ordinal-group:5;-webkit-order:4;order:4}.flex-order-xs-5{-webkit-box-ordinal-group:6;-webkit-order:5;order:5}.flex-order-xs-6{-webkit-box-ordinal-group:7;-webkit-order:6;order:6}.flex-order-xs-7{-webkit-box-ordinal-group:8;-webkit-order:7;order:7}.flex-order-xs-8{-webkit-box-ordinal-group:9;-webkit-order:8;order:8}.flex-order-xs-9{-webkit-box-ordinal-group:10;-webkit-order:9;order:9}.flex-order-xs-10{-webkit-box-ordinal-group:11;-webkit-order:10;order:10}.flex-order-xs-11{-webkit-box-ordinal-group:12;-webkit-order:11;order:11}.flex-order-xs-12{-webkit-box-ordinal-group:13;-webkit-order:12;order:12}.flex-order-xs-13{-webkit-box-ordinal-group:14;-webkit-order:13;order:13}.flex-order-xs-14{-webkit-box-ordinal-group:15;-webkit-order:14;order:14}.flex-order-xs-15{-webkit-box-ordinal-group:16;-webkit-order:15;order:15}.flex-order-xs-16{-webkit-box-ordinal-group:17;-webkit-order:16;order:16}.flex-order-xs-17{-webkit-box-ordinal-group:18;-webkit-order:17;order:17}.flex-order-xs-18{-webkit-box-ordinal-group:19;-webkit-order:18;order:18}.flex-order-xs-19{-webkit-box-ordinal-group:20;-webkit-order:19;order:19}.flex-order-xs-20{-webkit-box-ordinal-group:21;-webkit-order:20;order:20}.flex-offset-xs-0,.offset-xs-0{margin-left:0}[dir=rtl] .flex-offset-xs-0,[dir=rtl] .offset-xs-0{margin-left:auto;margin-right:0}.flex-offset-xs-5,.offset-xs-5{margin-left:5%}[dir=rtl] .flex-offset-xs-5,[dir=rtl] .offset-xs-5{margin-left:auto;margin-right:5%}.flex-offset-xs-10,.offset-xs-10{margin-left:10%}[dir=rtl] .flex-offset-xs-10,[dir=rtl] .offset-xs-10{margin-left:auto;margin-right:10%}.flex-offset-xs-15,.offset-xs-15{margin-left:15%}[dir=rtl] .flex-offset-xs-15,[dir=rtl] .offset-xs-15{margin-left:auto;margin-right:15%}.flex-offset-xs-20,.offset-xs-20{margin-left:20%}[dir=rtl] .flex-offset-xs-20,[dir=rtl] .offset-xs-20{margin-left:auto;margin-right:20%}.flex-offset-xs-25,.offset-xs-25{margin-left:25%}[dir=rtl] .flex-offset-xs-25,[dir=rtl] .offset-xs-25{margin-left:auto;margin-right:25%}.flex-offset-xs-30,.offset-xs-30{margin-left:30%}[dir=rtl] .flex-offset-xs-30,[dir=rtl] .offset-xs-30{margin-left:auto;margin-right:30%}.flex-offset-xs-35,.offset-xs-35{margin-left:35%}[dir=rtl] .flex-offset-xs-35,[dir=rtl] .offset-xs-35{margin-left:auto;margin-right:35%}.flex-offset-xs-40,.offset-xs-40{margin-left:40%}[dir=rtl] .flex-offset-xs-40,[dir=rtl] .offset-xs-40{margin-left:auto;margin-right:40%}.flex-offset-xs-45,.offset-xs-45{margin-left:45%}[dir=rtl] .flex-offset-xs-45,[dir=rtl] .offset-xs-45{margin-left:auto;margin-right:45%}.flex-offset-xs-50,.offset-xs-50{margin-left:50%}[dir=rtl] .flex-offset-xs-50,[dir=rtl] .offset-xs-50{margin-left:auto;margin-right:50%}.flex-offset-xs-55,.offset-xs-55{margin-left:55%}[dir=rtl] .flex-offset-xs-55,[dir=rtl] .offset-xs-55{margin-left:auto;margin-right:55%}.flex-offset-xs-60,.offset-xs-60{margin-left:60%}[dir=rtl] .flex-offset-xs-60,[dir=rtl] .offset-xs-60{margin-left:auto;margin-right:60%}.flex-offset-xs-65,.offset-xs-65{margin-left:65%}[dir=rtl] .flex-offset-xs-65,[dir=rtl] .offset-xs-65{margin-left:auto;margin-right:65%}.flex-offset-xs-70,.offset-xs-70{margin-left:70%}[dir=rtl] .flex-offset-xs-70,[dir=rtl] .offset-xs-70{margin-left:auto;margin-right:70%}.flex-offset-xs-75,.offset-xs-75{margin-left:75%}[dir=rtl] .flex-offset-xs-75,[dir=rtl] .offset-xs-75{margin-left:auto;margin-right:75%}.flex-offset-xs-80,.offset-xs-80{margin-left:80%}[dir=rtl] .flex-offset-xs-80,[dir=rtl] .offset-xs-80{margin-left:auto;margin-right:80%}.flex-offset-xs-85,.offset-xs-85{margin-left:85%}[dir=rtl] .flex-offset-xs-85,[dir=rtl] .offset-xs-85{margin-left:auto;margin-right:85%}.flex-offset-xs-90,.offset-xs-90{margin-left:90%}[dir=rtl] .flex-offset-xs-90,[dir=rtl] .offset-xs-90{margin-left:auto;margin-right:90%}.flex-offset-xs-95,.offset-xs-95{margin-left:95%}[dir=rtl] .flex-offset-xs-95,[dir=rtl] .offset-xs-95{margin-left:auto;margin-right:95%}.flex-offset-xs-33,.offset-xs-33{margin-left:33.33333%}.flex-offset-xs-66,.offset-xs-66{margin-left:66.66667%}[dir=rtl] .flex-offset-xs-66,[dir=rtl] .offset-xs-66{margin-left:auto;margin-right:66.66667%}.layout-align-xs,.layout-align-xs-start-stretch{-webkit-align-content:stretch;align-content:stretch;-webkit-box-align:stretch;-webkit-align-items:stretch;align-items:stretch}.layout-align-xs,.layout-align-xs-start,.layout-align-xs-start-center,.layout-align-xs-start-end,.layout-align-xs-start-start,.layout-align-xs-start-stretch{-webkit-box-pack:start;-webkit-justify-content:flex-start;justify-content:flex-start}.layout-align-xs-center,.layout-align-xs-center-center,.layout-align-xs-center-end,.layout-align-xs-center-start,.layout-align-xs-center-stretch{-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center}.layout-align-xs-end,.layout-align-xs-end-center,.layout-align-xs-end-end,.layout-align-xs-end-start,.layout-align-xs-end-stretch{-webkit-box-pack:end;-webkit-justify-content:flex-end;justify-content:flex-end}.layout-align-xs-space-around,.layout-align-xs-space-around-center,.layout-align-xs-space-around-end,.layout-align-xs-space-around-start,.layout-align-xs-space-around-stretch{-webkit-justify-content:space-around;justify-content:space-around}.layout-align-xs-space-between,.layout-align-xs-space-between-center,.layout-align-xs-space-between-end,.layout-align-xs-space-between-start,.layout-align-xs-space-between-stretch{-webkit-box-pack:justify;-webkit-justify-content:space-between;justify-content:space-between}.layout-align-xs-center-start,.layout-align-xs-end-start,.layout-align-xs-space-around-start,.layout-align-xs-space-between-start,.layout-align-xs-start-start{-webkit-box-align:start;-webkit-align-items:flex-start;align-items:flex-start;-webkit-align-content:flex-start;align-content:flex-start}.layout-align-xs-center-center,.layout-align-xs-end-center,.layout-align-xs-space-around-center,.layout-align-xs-space-between-center,.layout-align-xs-start-center{-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-align-content:center;align-content:center;max-width:100%}.layout-align-xs-center-center>*,.layout-align-xs-end-center>*,.layout-align-xs-space-around-center>*,.layout-align-xs-space-between-center>*,.layout-align-xs-start-center>*{max-width:100%;box-sizing:border-box}.layout-align-xs-center-end,.layout-align-xs-end-end,.layout-align-xs-space-around-end,.layout-align-xs-space-between-end,.layout-align-xs-start-end{-webkit-box-align:end;-webkit-align-items:flex-end;align-items:flex-end;-webkit-align-content:flex-end;align-content:flex-end}.layout-align-xs-center-stretch,.layout-align-xs-end-stretch,.layout-align-xs-space-around-stretch,.layout-align-xs-space-between-stretch,.layout-align-xs-start-stretch{-webkit-box-align:stretch;-webkit-align-items:stretch;align-items:stretch;-webkit-align-content:stretch;align-content:stretch}.flex-xs{-webkit-flex:1;flex:1}.flex-xs,.flex-xs-grow{-webkit-box-flex:1;box-sizing:border-box}.flex-xs-grow{-webkit-flex:1 1 100%;flex:1 1 100%}.flex-xs-initial{-webkit-box-flex:0;-webkit-flex:0 1 auto;flex:0 1 auto;box-sizing:border-box}.flex-xs-auto{-webkit-box-flex:1;-webkit-flex:1 1 auto;flex:1 1 auto;box-sizing:border-box}.flex-xs-none{-webkit-box-flex:0;-webkit-flex:0 0 auto;flex:0 0 auto;box-sizing:border-box}.flex-xs-noshrink{-webkit-box-flex:1;-webkit-flex:1 0 auto;flex:1 0 auto;box-sizing:border-box}.flex-xs-nogrow{-webkit-box-flex:0;-webkit-flex:0 1 auto;flex:0 1 auto;box-sizing:border-box}.flex-xs-0,.layout-row>.flex-xs-0{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:0;max-height:100%;box-sizing:border-box}.layout-row>.flex-xs-0{min-width:0}.layout-column>.flex-xs-0{max-width:100%;max-height:0%}.layout-column>.flex-xs-0,.layout-xs-row>.flex-xs-0{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xs-row>.flex-xs-0{max-width:0;max-height:100%;min-width:0}.layout-xs-column>.flex-xs-0{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;max-height:0%;box-sizing:border-box;min-height:0}.flex-xs-5,.layout-row>.flex-xs-5{max-width:5%;max-height:100%}.flex-xs-5,.layout-column>.flex-xs-5,.layout-row>.flex-xs-5{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xs-5{max-width:100%;max-height:5%}.layout-xs-row>.flex-xs-5{max-width:5%;max-height:100%}.layout-xs-column>.flex-xs-5,.layout-xs-row>.flex-xs-5{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xs-column>.flex-xs-5{max-width:100%;max-height:5%}.flex-xs-10,.layout-row>.flex-xs-10{max-width:10%;max-height:100%}.flex-xs-10,.layout-column>.flex-xs-10,.layout-row>.flex-xs-10{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xs-10{max-width:100%;max-height:10%}.layout-xs-row>.flex-xs-10{max-width:10%;max-height:100%}.layout-xs-column>.flex-xs-10,.layout-xs-row>.flex-xs-10{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xs-column>.flex-xs-10{max-width:100%;max-height:10%}.flex-xs-15,.layout-row>.flex-xs-15{max-width:15%;max-height:100%}.flex-xs-15,.layout-column>.flex-xs-15,.layout-row>.flex-xs-15{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xs-15{max-width:100%;max-height:15%}.layout-xs-row>.flex-xs-15{max-width:15%;max-height:100%}.layout-xs-column>.flex-xs-15,.layout-xs-row>.flex-xs-15{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xs-column>.flex-xs-15{max-width:100%;max-height:15%}.flex-xs-20,.layout-row>.flex-xs-20{max-width:20%;max-height:100%}.flex-xs-20,.layout-column>.flex-xs-20,.layout-row>.flex-xs-20{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xs-20{max-width:100%;max-height:20%}.layout-xs-row>.flex-xs-20{max-width:20%;max-height:100%}.layout-xs-column>.flex-xs-20,.layout-xs-row>.flex-xs-20{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xs-column>.flex-xs-20{max-width:100%;max-height:20%}.flex-xs-25,.layout-row>.flex-xs-25{max-width:25%;max-height:100%}.flex-xs-25,.layout-column>.flex-xs-25,.layout-row>.flex-xs-25{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xs-25{max-width:100%;max-height:25%}.layout-xs-row>.flex-xs-25{max-width:25%;max-height:100%}.layout-xs-column>.flex-xs-25,.layout-xs-row>.flex-xs-25{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xs-column>.flex-xs-25{max-width:100%;max-height:25%}.flex-xs-30,.layout-row>.flex-xs-30{max-width:30%;max-height:100%}.flex-xs-30,.layout-column>.flex-xs-30,.layout-row>.flex-xs-30{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xs-30{max-width:100%;max-height:30%}.layout-xs-row>.flex-xs-30{max-width:30%;max-height:100%}.layout-xs-column>.flex-xs-30,.layout-xs-row>.flex-xs-30{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xs-column>.flex-xs-30{max-width:100%;max-height:30%}.flex-xs-35,.layout-row>.flex-xs-35{max-width:35%;max-height:100%}.flex-xs-35,.layout-column>.flex-xs-35,.layout-row>.flex-xs-35{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xs-35{max-width:100%;max-height:35%}.layout-xs-row>.flex-xs-35{max-width:35%;max-height:100%}.layout-xs-column>.flex-xs-35,.layout-xs-row>.flex-xs-35{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xs-column>.flex-xs-35{max-width:100%;max-height:35%}.flex-xs-40,.layout-row>.flex-xs-40{max-width:40%;max-height:100%}.flex-xs-40,.layout-column>.flex-xs-40,.layout-row>.flex-xs-40{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xs-40{max-width:100%;max-height:40%}.layout-xs-row>.flex-xs-40{max-width:40%;max-height:100%}.layout-xs-column>.flex-xs-40,.layout-xs-row>.flex-xs-40{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xs-column>.flex-xs-40{max-width:100%;max-height:40%}.flex-xs-45,.layout-row>.flex-xs-45{max-width:45%;max-height:100%}.flex-xs-45,.layout-column>.flex-xs-45,.layout-row>.flex-xs-45{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xs-45{max-width:100%;max-height:45%}.layout-xs-row>.flex-xs-45{max-width:45%;max-height:100%}.layout-xs-column>.flex-xs-45,.layout-xs-row>.flex-xs-45{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xs-column>.flex-xs-45{max-width:100%;max-height:45%}.flex-xs-50,.layout-row>.flex-xs-50{max-width:50%;max-height:100%}.flex-xs-50,.layout-column>.flex-xs-50,.layout-row>.flex-xs-50{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xs-50{max-width:100%;max-height:50%}.layout-xs-row>.flex-xs-50{max-width:50%;max-height:100%}.layout-xs-column>.flex-xs-50,.layout-xs-row>.flex-xs-50{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xs-column>.flex-xs-50{max-width:100%;max-height:50%}.flex-xs-55,.layout-row>.flex-xs-55{max-width:55%;max-height:100%}.flex-xs-55,.layout-column>.flex-xs-55,.layout-row>.flex-xs-55{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xs-55{max-width:100%;max-height:55%}.layout-xs-row>.flex-xs-55{max-width:55%;max-height:100%}.layout-xs-column>.flex-xs-55,.layout-xs-row>.flex-xs-55{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xs-column>.flex-xs-55{max-width:100%;max-height:55%}.flex-xs-60,.layout-row>.flex-xs-60{max-width:60%;max-height:100%}.flex-xs-60,.layout-column>.flex-xs-60,.layout-row>.flex-xs-60{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xs-60{max-width:100%;max-height:60%}.layout-xs-row>.flex-xs-60{max-width:60%;max-height:100%}.layout-xs-column>.flex-xs-60,.layout-xs-row>.flex-xs-60{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xs-column>.flex-xs-60{max-width:100%;max-height:60%}.flex-xs-65,.layout-row>.flex-xs-65{max-width:65%;max-height:100%}.flex-xs-65,.layout-column>.flex-xs-65,.layout-row>.flex-xs-65{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xs-65{max-width:100%;max-height:65%}.layout-xs-row>.flex-xs-65{max-width:65%;max-height:100%}.layout-xs-column>.flex-xs-65,.layout-xs-row>.flex-xs-65{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xs-column>.flex-xs-65{max-width:100%;max-height:65%}.flex-xs-70,.layout-row>.flex-xs-70{max-width:70%;max-height:100%}.flex-xs-70,.layout-column>.flex-xs-70,.layout-row>.flex-xs-70{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xs-70{max-width:100%;max-height:70%}.layout-xs-row>.flex-xs-70{max-width:70%;max-height:100%}.layout-xs-column>.flex-xs-70,.layout-xs-row>.flex-xs-70{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xs-column>.flex-xs-70{max-width:100%;max-height:70%}.flex-xs-75,.layout-row>.flex-xs-75{max-width:75%;max-height:100%}.flex-xs-75,.layout-column>.flex-xs-75,.layout-row>.flex-xs-75{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xs-75{max-width:100%;max-height:75%}.layout-xs-row>.flex-xs-75{max-width:75%;max-height:100%}.layout-xs-column>.flex-xs-75,.layout-xs-row>.flex-xs-75{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xs-column>.flex-xs-75{max-width:100%;max-height:75%}.flex-xs-80,.layout-row>.flex-xs-80{max-width:80%;max-height:100%}.flex-xs-80,.layout-column>.flex-xs-80,.layout-row>.flex-xs-80{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xs-80{max-width:100%;max-height:80%}.layout-xs-row>.flex-xs-80{max-width:80%;max-height:100%}.layout-xs-column>.flex-xs-80,.layout-xs-row>.flex-xs-80{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xs-column>.flex-xs-80{max-width:100%;max-height:80%}.flex-xs-85,.layout-row>.flex-xs-85{max-width:85%;max-height:100%}.flex-xs-85,.layout-column>.flex-xs-85,.layout-row>.flex-xs-85{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xs-85{max-width:100%;max-height:85%}.layout-xs-row>.flex-xs-85{max-width:85%;max-height:100%}.layout-xs-column>.flex-xs-85,.layout-xs-row>.flex-xs-85{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xs-column>.flex-xs-85{max-width:100%;max-height:85%}.flex-xs-90,.layout-row>.flex-xs-90{max-width:90%;max-height:100%}.flex-xs-90,.layout-column>.flex-xs-90,.layout-row>.flex-xs-90{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xs-90{max-width:100%;max-height:90%}.layout-xs-row>.flex-xs-90{max-width:90%;max-height:100%}.layout-xs-column>.flex-xs-90,.layout-xs-row>.flex-xs-90{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xs-column>.flex-xs-90{max-width:100%;max-height:90%}.flex-xs-95,.layout-row>.flex-xs-95{max-width:95%;max-height:100%}.flex-xs-95,.layout-column>.flex-xs-95,.layout-row>.flex-xs-95{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xs-95{max-width:100%;max-height:95%}.layout-xs-row>.flex-xs-95{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:95%;max-height:100%;box-sizing:border-box}.layout-xs-column>.flex-xs-95{max-height:95%}.flex-xs-100,.layout-xs-column>.flex-xs-95{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;box-sizing:border-box}.flex-xs-100{max-height:100%}.layout-column>.flex-xs-100,.layout-row>.flex-xs-100,.layout-xs-column>.flex-xs-100,.layout-xs-row>.flex-xs-100{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;max-height:100%;box-sizing:border-box}.layout-row>.flex-xs-33{-webkit-flex:1 1 33.33%;flex:1 1 33.33%;max-width:33.33%}.layout-row>.flex-xs-33,.layout-row>.flex-xs-66{-webkit-box-flex:1;max-height:100%;box-sizing:border-box}.layout-row>.flex-xs-66{-webkit-flex:1 1 66.66%;flex:1 1 66.66%;max-width:66.66%}.layout-column>.flex-xs-33{-webkit-flex:1 1 33.33%;flex:1 1 33.33%;max-height:33.33%}.layout-column>.flex-xs-33,.layout-column>.flex-xs-66{-webkit-box-flex:1;max-width:100%;box-sizing:border-box}.layout-column>.flex-xs-66{-webkit-flex:1 1 66.66%;flex:1 1 66.66%;max-height:66.66%}.layout-xs-row>.flex-xs-33{max-width:33.33%}.layout-xs-row>.flex-xs-33,.layout-xs-row>.flex-xs-66{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-height:100%;box-sizing:border-box}.layout-xs-row>.flex-xs-66{max-width:66.66%}.layout-xs-row>.flex{min-width:0}.layout-xs-column>.flex-xs-33{max-height:33.33%}.layout-xs-column>.flex-xs-33,.layout-xs-column>.flex-xs-66{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;box-sizing:border-box}.layout-xs-column>.flex-xs-66{max-height:66.66%}.layout-xs-column>.flex{min-height:0}.layout-xs,.layout-xs-column,.layout-xs-row{box-sizing:border-box;display:-webkit-box;display:-webkit-flex;display:flex}.layout-xs-column{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column}.layout-xs-row{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;flex-direction:row}}@media (min-width:600px){.flex-order-gt-xs--20{-webkit-box-ordinal-group:-19;-webkit-order:-20;order:-20}.flex-order-gt-xs--19{-webkit-box-ordinal-group:-18;-webkit-order:-19;order:-19}.flex-order-gt-xs--18{-webkit-box-ordinal-group:-17;-webkit-order:-18;order:-18}.flex-order-gt-xs--17{-webkit-box-ordinal-group:-16;-webkit-order:-17;order:-17}.flex-order-gt-xs--16{-webkit-box-ordinal-group:-15;-webkit-order:-16;order:-16}.flex-order-gt-xs--15{-webkit-box-ordinal-group:-14;-webkit-order:-15;order:-15}.flex-order-gt-xs--14{-webkit-box-ordinal-group:-13;-webkit-order:-14;order:-14}.flex-order-gt-xs--13{-webkit-box-ordinal-group:-12;-webkit-order:-13;order:-13}.flex-order-gt-xs--12{-webkit-box-ordinal-group:-11;-webkit-order:-12;order:-12}.flex-order-gt-xs--11{-webkit-box-ordinal-group:-10;-webkit-order:-11;order:-11}.flex-order-gt-xs--10{-webkit-box-ordinal-group:-9;-webkit-order:-10;order:-10}.flex-order-gt-xs--9{-webkit-box-ordinal-group:-8;-webkit-order:-9;order:-9}.flex-order-gt-xs--8{-webkit-box-ordinal-group:-7;-webkit-order:-8;order:-8}.flex-order-gt-xs--7{-webkit-box-ordinal-group:-6;-webkit-order:-7;order:-7}.flex-order-gt-xs--6{-webkit-box-ordinal-group:-5;-webkit-order:-6;order:-6}.flex-order-gt-xs--5{-webkit-box-ordinal-group:-4;-webkit-order:-5;order:-5}.flex-order-gt-xs--4{-webkit-box-ordinal-group:-3;-webkit-order:-4;order:-4}.flex-order-gt-xs--3{-webkit-box-ordinal-group:-2;-webkit-order:-3;order:-3}.flex-order-gt-xs--2{-webkit-box-ordinal-group:-1;-webkit-order:-2;order:-2}.flex-order-gt-xs--1{-webkit-box-ordinal-group:0;-webkit-order:-1;order:-1}.flex-order-gt-xs-0{-webkit-box-ordinal-group:1;-webkit-order:0;order:0}.flex-order-gt-xs-1{-webkit-box-ordinal-group:2;-webkit-order:1;order:1}.flex-order-gt-xs-2{-webkit-box-ordinal-group:3;-webkit-order:2;order:2}.flex-order-gt-xs-3{-webkit-box-ordinal-group:4;-webkit-order:3;order:3}.flex-order-gt-xs-4{-webkit-box-ordinal-group:5;-webkit-order:4;order:4}.flex-order-gt-xs-5{-webkit-box-ordinal-group:6;-webkit-order:5;order:5}.flex-order-gt-xs-6{-webkit-box-ordinal-group:7;-webkit-order:6;order:6}.flex-order-gt-xs-7{-webkit-box-ordinal-group:8;-webkit-order:7;order:7}.flex-order-gt-xs-8{-webkit-box-ordinal-group:9;-webkit-order:8;order:8}.flex-order-gt-xs-9{-webkit-box-ordinal-group:10;-webkit-order:9;order:9}.flex-order-gt-xs-10{-webkit-box-ordinal-group:11;-webkit-order:10;order:10}.flex-order-gt-xs-11{-webkit-box-ordinal-group:12;-webkit-order:11;order:11}.flex-order-gt-xs-12{-webkit-box-ordinal-group:13;-webkit-order:12;order:12}.flex-order-gt-xs-13{-webkit-box-ordinal-group:14;-webkit-order:13;order:13}.flex-order-gt-xs-14{-webkit-box-ordinal-group:15;-webkit-order:14;order:14}.flex-order-gt-xs-15{-webkit-box-ordinal-group:16;-webkit-order:15;order:15}.flex-order-gt-xs-16{-webkit-box-ordinal-group:17;-webkit-order:16;order:16}.flex-order-gt-xs-17{-webkit-box-ordinal-group:18;-webkit-order:17;order:17}.flex-order-gt-xs-18{-webkit-box-ordinal-group:19;-webkit-order:18;order:18}.flex-order-gt-xs-19{-webkit-box-ordinal-group:20;-webkit-order:19;order:19}.flex-order-gt-xs-20{-webkit-box-ordinal-group:21;-webkit-order:20;order:20}.flex-offset-gt-xs-0,.offset-gt-xs-0{margin-left:0}[dir=rtl] .flex-offset-gt-xs-0,[dir=rtl] .offset-gt-xs-0{margin-left:auto;margin-right:0}.flex-offset-gt-xs-5,.offset-gt-xs-5{margin-left:5%}[dir=rtl] .flex-offset-gt-xs-5,[dir=rtl] .offset-gt-xs-5{margin-left:auto;margin-right:5%}.flex-offset-gt-xs-10,.offset-gt-xs-10{margin-left:10%}[dir=rtl] .flex-offset-gt-xs-10,[dir=rtl] .offset-gt-xs-10{margin-left:auto;margin-right:10%}.flex-offset-gt-xs-15,.offset-gt-xs-15{margin-left:15%}[dir=rtl] .flex-offset-gt-xs-15,[dir=rtl] .offset-gt-xs-15{margin-left:auto;margin-right:15%}.flex-offset-gt-xs-20,.offset-gt-xs-20{margin-left:20%}[dir=rtl] .flex-offset-gt-xs-20,[dir=rtl] .offset-gt-xs-20{margin-left:auto;margin-right:20%}.flex-offset-gt-xs-25,.offset-gt-xs-25{margin-left:25%}[dir=rtl] .flex-offset-gt-xs-25,[dir=rtl] .offset-gt-xs-25{margin-left:auto;margin-right:25%}.flex-offset-gt-xs-30,.offset-gt-xs-30{margin-left:30%}[dir=rtl] .flex-offset-gt-xs-30,[dir=rtl] .offset-gt-xs-30{margin-left:auto;margin-right:30%}.flex-offset-gt-xs-35,.offset-gt-xs-35{margin-left:35%}[dir=rtl] .flex-offset-gt-xs-35,[dir=rtl] .offset-gt-xs-35{margin-left:auto;margin-right:35%}.flex-offset-gt-xs-40,.offset-gt-xs-40{margin-left:40%}[dir=rtl] .flex-offset-gt-xs-40,[dir=rtl] .offset-gt-xs-40{margin-left:auto;margin-right:40%}.flex-offset-gt-xs-45,.offset-gt-xs-45{margin-left:45%}[dir=rtl] .flex-offset-gt-xs-45,[dir=rtl] .offset-gt-xs-45{margin-left:auto;margin-right:45%}.flex-offset-gt-xs-50,.offset-gt-xs-50{margin-left:50%}[dir=rtl] .flex-offset-gt-xs-50,[dir=rtl] .offset-gt-xs-50{margin-left:auto;margin-right:50%}.flex-offset-gt-xs-55,.offset-gt-xs-55{margin-left:55%}[dir=rtl] .flex-offset-gt-xs-55,[dir=rtl] .offset-gt-xs-55{margin-left:auto;margin-right:55%}.flex-offset-gt-xs-60,.offset-gt-xs-60{margin-left:60%}[dir=rtl] .flex-offset-gt-xs-60,[dir=rtl] .offset-gt-xs-60{margin-left:auto;margin-right:60%}.flex-offset-gt-xs-65,.offset-gt-xs-65{margin-left:65%}[dir=rtl] .flex-offset-gt-xs-65,[dir=rtl] .offset-gt-xs-65{margin-left:auto;margin-right:65%}.flex-offset-gt-xs-70,.offset-gt-xs-70{margin-left:70%}[dir=rtl] .flex-offset-gt-xs-70,[dir=rtl] .offset-gt-xs-70{margin-left:auto;margin-right:70%}.flex-offset-gt-xs-75,.offset-gt-xs-75{margin-left:75%}[dir=rtl] .flex-offset-gt-xs-75,[dir=rtl] .offset-gt-xs-75{margin-left:auto;margin-right:75%}.flex-offset-gt-xs-80,.offset-gt-xs-80{margin-left:80%}[dir=rtl] .flex-offset-gt-xs-80,[dir=rtl] .offset-gt-xs-80{margin-left:auto;margin-right:80%}.flex-offset-gt-xs-85,.offset-gt-xs-85{margin-left:85%}[dir=rtl] .flex-offset-gt-xs-85,[dir=rtl] .offset-gt-xs-85{margin-left:auto;margin-right:85%}.flex-offset-gt-xs-90,.offset-gt-xs-90{margin-left:90%}[dir=rtl] .flex-offset-gt-xs-90,[dir=rtl] .offset-gt-xs-90{margin-left:auto;margin-right:90%}.flex-offset-gt-xs-95,.offset-gt-xs-95{margin-left:95%}[dir=rtl] .flex-offset-gt-xs-95,[dir=rtl] .offset-gt-xs-95{margin-left:auto;margin-right:95%}.flex-offset-gt-xs-33,.offset-gt-xs-33{margin-left:33.33333%}.flex-offset-gt-xs-66,.offset-gt-xs-66{margin-left:66.66667%}[dir=rtl] .flex-offset-gt-xs-66,[dir=rtl] .offset-gt-xs-66{margin-left:auto;margin-right:66.66667%}.layout-align-gt-xs,.layout-align-gt-xs-start-stretch{-webkit-align-content:stretch;align-content:stretch;-webkit-box-align:stretch;-webkit-align-items:stretch;align-items:stretch}.layout-align-gt-xs,.layout-align-gt-xs-start,.layout-align-gt-xs-start-center,.layout-align-gt-xs-start-end,.layout-align-gt-xs-start-start,.layout-align-gt-xs-start-stretch{-webkit-box-pack:start;-webkit-justify-content:flex-start;justify-content:flex-start}.layout-align-gt-xs-center,.layout-align-gt-xs-center-center,.layout-align-gt-xs-center-end,.layout-align-gt-xs-center-start,.layout-align-gt-xs-center-stretch{-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center}.layout-align-gt-xs-end,.layout-align-gt-xs-end-center,.layout-align-gt-xs-end-end,.layout-align-gt-xs-end-start,.layout-align-gt-xs-end-stretch{-webkit-box-pack:end;-webkit-justify-content:flex-end;justify-content:flex-end}.layout-align-gt-xs-space-around,.layout-align-gt-xs-space-around-center,.layout-align-gt-xs-space-around-end,.layout-align-gt-xs-space-around-start,.layout-align-gt-xs-space-around-stretch{-webkit-justify-content:space-around;justify-content:space-around}.layout-align-gt-xs-space-between,.layout-align-gt-xs-space-between-center,.layout-align-gt-xs-space-between-end,.layout-align-gt-xs-space-between-start,.layout-align-gt-xs-space-between-stretch{-webkit-box-pack:justify;-webkit-justify-content:space-between;justify-content:space-between}.layout-align-gt-xs-center-start,.layout-align-gt-xs-end-start,.layout-align-gt-xs-space-around-start,.layout-align-gt-xs-space-between-start,.layout-align-gt-xs-start-start{-webkit-box-align:start;-webkit-align-items:flex-start;align-items:flex-start;-webkit-align-content:flex-start;align-content:flex-start}.layout-align-gt-xs-center-center,.layout-align-gt-xs-end-center,.layout-align-gt-xs-space-around-center,.layout-align-gt-xs-space-between-center,.layout-align-gt-xs-start-center{-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-align-content:center;align-content:center;max-width:100%}.layout-align-gt-xs-center-center>*,.layout-align-gt-xs-end-center>*,.layout-align-gt-xs-space-around-center>*,.layout-align-gt-xs-space-between-center>*,.layout-align-gt-xs-start-center>*{max-width:100%;box-sizing:border-box}.layout-align-gt-xs-center-end,.layout-align-gt-xs-end-end,.layout-align-gt-xs-space-around-end,.layout-align-gt-xs-space-between-end,.layout-align-gt-xs-start-end{-webkit-box-align:end;-webkit-align-items:flex-end;align-items:flex-end;-webkit-align-content:flex-end;align-content:flex-end}.layout-align-gt-xs-center-stretch,.layout-align-gt-xs-end-stretch,.layout-align-gt-xs-space-around-stretch,.layout-align-gt-xs-space-between-stretch,.layout-align-gt-xs-start-stretch{-webkit-box-align:stretch;-webkit-align-items:stretch;align-items:stretch;-webkit-align-content:stretch;align-content:stretch}.flex-gt-xs{-webkit-flex:1;flex:1}.flex-gt-xs,.flex-gt-xs-grow{-webkit-box-flex:1;box-sizing:border-box}.flex-gt-xs-grow{-webkit-flex:1 1 100%;flex:1 1 100%}.flex-gt-xs-initial{-webkit-box-flex:0;-webkit-flex:0 1 auto;flex:0 1 auto;box-sizing:border-box}.flex-gt-xs-auto{-webkit-box-flex:1;-webkit-flex:1 1 auto;flex:1 1 auto;box-sizing:border-box}.flex-gt-xs-none{-webkit-box-flex:0;-webkit-flex:0 0 auto;flex:0 0 auto;box-sizing:border-box}.flex-gt-xs-noshrink{-webkit-box-flex:1;-webkit-flex:1 0 auto;flex:1 0 auto;box-sizing:border-box}.flex-gt-xs-nogrow{-webkit-box-flex:0;-webkit-flex:0 1 auto;flex:0 1 auto;box-sizing:border-box}.flex-gt-xs-0,.layout-row>.flex-gt-xs-0{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:0;max-height:100%;box-sizing:border-box}.layout-row>.flex-gt-xs-0{min-width:0}.layout-column>.flex-gt-xs-0{max-width:100%;max-height:0%}.layout-column>.flex-gt-xs-0,.layout-gt-xs-row>.flex-gt-xs-0{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-xs-row>.flex-gt-xs-0{max-width:0;max-height:100%;min-width:0}.layout-gt-xs-column>.flex-gt-xs-0{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;max-height:0%;box-sizing:border-box;min-height:0}.flex-gt-xs-5,.layout-row>.flex-gt-xs-5{max-width:5%;max-height:100%}.flex-gt-xs-5,.layout-column>.flex-gt-xs-5,.layout-row>.flex-gt-xs-5{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-xs-5{max-width:100%;max-height:5%}.layout-gt-xs-row>.flex-gt-xs-5{max-width:5%;max-height:100%}.layout-gt-xs-column>.flex-gt-xs-5,.layout-gt-xs-row>.flex-gt-xs-5{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-xs-column>.flex-gt-xs-5{max-width:100%;max-height:5%}.flex-gt-xs-10,.layout-row>.flex-gt-xs-10{max-width:10%;max-height:100%}.flex-gt-xs-10,.layout-column>.flex-gt-xs-10,.layout-row>.flex-gt-xs-10{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-xs-10{max-width:100%;max-height:10%}.layout-gt-xs-row>.flex-gt-xs-10{max-width:10%;max-height:100%}.layout-gt-xs-column>.flex-gt-xs-10,.layout-gt-xs-row>.flex-gt-xs-10{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-xs-column>.flex-gt-xs-10{max-width:100%;max-height:10%}.flex-gt-xs-15,.layout-row>.flex-gt-xs-15{max-width:15%;max-height:100%}.flex-gt-xs-15,.layout-column>.flex-gt-xs-15,.layout-row>.flex-gt-xs-15{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-xs-15{max-width:100%;max-height:15%}.layout-gt-xs-row>.flex-gt-xs-15{max-width:15%;max-height:100%}.layout-gt-xs-column>.flex-gt-xs-15,.layout-gt-xs-row>.flex-gt-xs-15{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-xs-column>.flex-gt-xs-15{max-width:100%;max-height:15%}.flex-gt-xs-20,.layout-row>.flex-gt-xs-20{max-width:20%;max-height:100%}.flex-gt-xs-20,.layout-column>.flex-gt-xs-20,.layout-row>.flex-gt-xs-20{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-xs-20{max-width:100%;max-height:20%}.layout-gt-xs-row>.flex-gt-xs-20{max-width:20%;max-height:100%}.layout-gt-xs-column>.flex-gt-xs-20,.layout-gt-xs-row>.flex-gt-xs-20{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-xs-column>.flex-gt-xs-20{max-width:100%;max-height:20%}.flex-gt-xs-25,.layout-row>.flex-gt-xs-25{max-width:25%;max-height:100%}.flex-gt-xs-25,.layout-column>.flex-gt-xs-25,.layout-row>.flex-gt-xs-25{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-xs-25{max-width:100%;max-height:25%}.layout-gt-xs-row>.flex-gt-xs-25{max-width:25%;max-height:100%}.layout-gt-xs-column>.flex-gt-xs-25,.layout-gt-xs-row>.flex-gt-xs-25{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-xs-column>.flex-gt-xs-25{max-width:100%;max-height:25%}.flex-gt-xs-30,.layout-row>.flex-gt-xs-30{max-width:30%;max-height:100%}.flex-gt-xs-30,.layout-column>.flex-gt-xs-30,.layout-row>.flex-gt-xs-30{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-xs-30{max-width:100%;max-height:30%}.layout-gt-xs-row>.flex-gt-xs-30{max-width:30%;max-height:100%}.layout-gt-xs-column>.flex-gt-xs-30,.layout-gt-xs-row>.flex-gt-xs-30{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-xs-column>.flex-gt-xs-30{max-width:100%;max-height:30%}.flex-gt-xs-35,.layout-row>.flex-gt-xs-35{max-width:35%;max-height:100%}.flex-gt-xs-35,.layout-column>.flex-gt-xs-35,.layout-row>.flex-gt-xs-35{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-xs-35{max-width:100%;max-height:35%}.layout-gt-xs-row>.flex-gt-xs-35{max-width:35%;max-height:100%}.layout-gt-xs-column>.flex-gt-xs-35,.layout-gt-xs-row>.flex-gt-xs-35{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-xs-column>.flex-gt-xs-35{max-width:100%;max-height:35%}.flex-gt-xs-40,.layout-row>.flex-gt-xs-40{max-width:40%;max-height:100%}.flex-gt-xs-40,.layout-column>.flex-gt-xs-40,.layout-row>.flex-gt-xs-40{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-xs-40{max-width:100%;max-height:40%}.layout-gt-xs-row>.flex-gt-xs-40{max-width:40%;max-height:100%}.layout-gt-xs-column>.flex-gt-xs-40,.layout-gt-xs-row>.flex-gt-xs-40{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-xs-column>.flex-gt-xs-40{max-width:100%;max-height:40%}.flex-gt-xs-45,.layout-row>.flex-gt-xs-45{max-width:45%;max-height:100%}.flex-gt-xs-45,.layout-column>.flex-gt-xs-45,.layout-row>.flex-gt-xs-45{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-xs-45{max-width:100%;max-height:45%}.layout-gt-xs-row>.flex-gt-xs-45{max-width:45%;max-height:100%}.layout-gt-xs-column>.flex-gt-xs-45,.layout-gt-xs-row>.flex-gt-xs-45{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-xs-column>.flex-gt-xs-45{max-width:100%;max-height:45%}.flex-gt-xs-50,.layout-row>.flex-gt-xs-50{max-width:50%;max-height:100%}.flex-gt-xs-50,.layout-column>.flex-gt-xs-50,.layout-row>.flex-gt-xs-50{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-xs-50{max-width:100%;max-height:50%}.layout-gt-xs-row>.flex-gt-xs-50{max-width:50%;max-height:100%}.layout-gt-xs-column>.flex-gt-xs-50,.layout-gt-xs-row>.flex-gt-xs-50{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-xs-column>.flex-gt-xs-50{max-width:100%;max-height:50%}.flex-gt-xs-55,.layout-row>.flex-gt-xs-55{max-width:55%;max-height:100%}.flex-gt-xs-55,.layout-column>.flex-gt-xs-55,.layout-row>.flex-gt-xs-55{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-xs-55{max-width:100%;max-height:55%}.layout-gt-xs-row>.flex-gt-xs-55{max-width:55%;max-height:100%}.layout-gt-xs-column>.flex-gt-xs-55,.layout-gt-xs-row>.flex-gt-xs-55{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-xs-column>.flex-gt-xs-55{max-width:100%;max-height:55%}.flex-gt-xs-60,.layout-row>.flex-gt-xs-60{max-width:60%;max-height:100%}.flex-gt-xs-60,.layout-column>.flex-gt-xs-60,.layout-row>.flex-gt-xs-60{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-xs-60{max-width:100%;max-height:60%}.layout-gt-xs-row>.flex-gt-xs-60{max-width:60%;max-height:100%}.layout-gt-xs-column>.flex-gt-xs-60,.layout-gt-xs-row>.flex-gt-xs-60{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-xs-column>.flex-gt-xs-60{max-width:100%;max-height:60%}.flex-gt-xs-65,.layout-row>.flex-gt-xs-65{max-width:65%;max-height:100%}.flex-gt-xs-65,.layout-column>.flex-gt-xs-65,.layout-row>.flex-gt-xs-65{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-xs-65{max-width:100%;max-height:65%}.layout-gt-xs-row>.flex-gt-xs-65{max-width:65%;max-height:100%}.layout-gt-xs-column>.flex-gt-xs-65,.layout-gt-xs-row>.flex-gt-xs-65{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-xs-column>.flex-gt-xs-65{max-width:100%;max-height:65%}.flex-gt-xs-70,.layout-row>.flex-gt-xs-70{max-width:70%;max-height:100%}.flex-gt-xs-70,.layout-column>.flex-gt-xs-70,.layout-row>.flex-gt-xs-70{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-xs-70{max-width:100%;max-height:70%}.layout-gt-xs-row>.flex-gt-xs-70{max-width:70%;max-height:100%}.layout-gt-xs-column>.flex-gt-xs-70,.layout-gt-xs-row>.flex-gt-xs-70{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-xs-column>.flex-gt-xs-70{max-width:100%;max-height:70%}.flex-gt-xs-75,.layout-row>.flex-gt-xs-75{max-width:75%;max-height:100%}.flex-gt-xs-75,.layout-column>.flex-gt-xs-75,.layout-row>.flex-gt-xs-75{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-xs-75{max-width:100%;max-height:75%}.layout-gt-xs-row>.flex-gt-xs-75{max-width:75%;max-height:100%}.layout-gt-xs-column>.flex-gt-xs-75,.layout-gt-xs-row>.flex-gt-xs-75{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-xs-column>.flex-gt-xs-75{max-width:100%;max-height:75%}.flex-gt-xs-80,.layout-row>.flex-gt-xs-80{max-width:80%;max-height:100%}.flex-gt-xs-80,.layout-column>.flex-gt-xs-80,.layout-row>.flex-gt-xs-80{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-xs-80{max-width:100%;max-height:80%}.layout-gt-xs-row>.flex-gt-xs-80{max-width:80%;max-height:100%}.layout-gt-xs-column>.flex-gt-xs-80,.layout-gt-xs-row>.flex-gt-xs-80{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-xs-column>.flex-gt-xs-80{max-width:100%;max-height:80%}.flex-gt-xs-85,.layout-row>.flex-gt-xs-85{max-width:85%;max-height:100%}.flex-gt-xs-85,.layout-column>.flex-gt-xs-85,.layout-row>.flex-gt-xs-85{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-xs-85{max-width:100%;max-height:85%}.layout-gt-xs-row>.flex-gt-xs-85{max-width:85%;max-height:100%}.layout-gt-xs-column>.flex-gt-xs-85,.layout-gt-xs-row>.flex-gt-xs-85{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-xs-column>.flex-gt-xs-85{max-width:100%;max-height:85%}.flex-gt-xs-90,.layout-row>.flex-gt-xs-90{max-width:90%;max-height:100%}.flex-gt-xs-90,.layout-column>.flex-gt-xs-90,.layout-row>.flex-gt-xs-90{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-xs-90{max-width:100%;max-height:90%}.layout-gt-xs-row>.flex-gt-xs-90{max-width:90%;max-height:100%}.layout-gt-xs-column>.flex-gt-xs-90,.layout-gt-xs-row>.flex-gt-xs-90{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-xs-column>.flex-gt-xs-90{max-width:100%;max-height:90%}.flex-gt-xs-95,.layout-row>.flex-gt-xs-95{max-width:95%;max-height:100%}.flex-gt-xs-95,.layout-column>.flex-gt-xs-95,.layout-row>.flex-gt-xs-95{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-xs-95{max-width:100%;max-height:95%}.layout-gt-xs-row>.flex-gt-xs-95{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:95%;max-height:100%;box-sizing:border-box}.layout-gt-xs-column>.flex-gt-xs-95{max-height:95%}.flex-gt-xs-100,.layout-gt-xs-column>.flex-gt-xs-95{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;box-sizing:border-box}.flex-gt-xs-100{max-height:100%}.layout-column>.flex-gt-xs-100,.layout-gt-xs-column>.flex-gt-xs-100,.layout-gt-xs-row>.flex-gt-xs-100,.layout-row>.flex-gt-xs-100{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;max-height:100%;box-sizing:border-box}.layout-row>.flex-gt-xs-33{-webkit-flex:1 1 33.33%;flex:1 1 33.33%;max-width:33.33%}.layout-row>.flex-gt-xs-33,.layout-row>.flex-gt-xs-66{-webkit-box-flex:1;max-height:100%;box-sizing:border-box}.layout-row>.flex-gt-xs-66{-webkit-flex:1 1 66.66%;flex:1 1 66.66%;max-width:66.66%}.layout-column>.flex-gt-xs-33{-webkit-box-flex:1;-webkit-flex:1 1 33.33%;flex:1 1 33.33%;max-width:100%;max-height:33.33%;box-sizing:border-box}.layout-column>.flex-gt-xs-66{-webkit-box-flex:1;-webkit-flex:1 1 66.66%;flex:1 1 66.66%;max-width:100%;max-height:66.66%;box-sizing:border-box}.layout-gt-xs-row>.flex-gt-xs-33{max-width:33.33%}.layout-gt-xs-row>.flex-gt-xs-33,.layout-gt-xs-row>.flex-gt-xs-66{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-height:100%;box-sizing:border-box}.layout-gt-xs-row>.flex-gt-xs-66{max-width:66.66%}.layout-gt-xs-row>.flex{min-width:0}.layout-gt-xs-column>.flex-gt-xs-33{max-height:33.33%}.layout-gt-xs-column>.flex-gt-xs-33,.layout-gt-xs-column>.flex-gt-xs-66{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;box-sizing:border-box}.layout-gt-xs-column>.flex-gt-xs-66{max-height:66.66%}.layout-gt-xs-column>.flex{min-height:0}.layout-gt-xs,.layout-gt-xs-column,.layout-gt-xs-row{box-sizing:border-box;display:-webkit-box;display:-webkit-flex;display:flex}.layout-gt-xs-column{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column}.layout-gt-xs-row{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;flex-direction:row}}@media (min-width:600px) and (max-width:959px){.hide-gt-xs:not(.show-gt-xs):not(.show-sm):not(.show),.hide-sm:not(.show-gt-xs):not(.show-sm):not(.show),.hide:not(.show-gt-xs):not(.show-sm):not(.show){display:none}.flex-order-sm--20{-webkit-box-ordinal-group:-19;-webkit-order:-20;order:-20}.flex-order-sm--19{-webkit-box-ordinal-group:-18;-webkit-order:-19;order:-19}.flex-order-sm--18{-webkit-box-ordinal-group:-17;-webkit-order:-18;order:-18}.flex-order-sm--17{-webkit-box-ordinal-group:-16;-webkit-order:-17;order:-17}.flex-order-sm--16{-webkit-box-ordinal-group:-15;-webkit-order:-16;order:-16}.flex-order-sm--15{-webkit-box-ordinal-group:-14;-webkit-order:-15;order:-15}.flex-order-sm--14{-webkit-box-ordinal-group:-13;-webkit-order:-14;order:-14}.flex-order-sm--13{-webkit-box-ordinal-group:-12;-webkit-order:-13;order:-13}.flex-order-sm--12{-webkit-box-ordinal-group:-11;-webkit-order:-12;order:-12}.flex-order-sm--11{-webkit-box-ordinal-group:-10;-webkit-order:-11;order:-11}.flex-order-sm--10{-webkit-box-ordinal-group:-9;-webkit-order:-10;order:-10}.flex-order-sm--9{-webkit-box-ordinal-group:-8;-webkit-order:-9;order:-9}.flex-order-sm--8{-webkit-box-ordinal-group:-7;-webkit-order:-8;order:-8}.flex-order-sm--7{-webkit-box-ordinal-group:-6;-webkit-order:-7;order:-7}.flex-order-sm--6{-webkit-box-ordinal-group:-5;-webkit-order:-6;order:-6}.flex-order-sm--5{-webkit-box-ordinal-group:-4;-webkit-order:-5;order:-5}.flex-order-sm--4{-webkit-box-ordinal-group:-3;-webkit-order:-4;order:-4}.flex-order-sm--3{-webkit-box-ordinal-group:-2;-webkit-order:-3;order:-3}.flex-order-sm--2{-webkit-box-ordinal-group:-1;-webkit-order:-2;order:-2}.flex-order-sm--1{-webkit-box-ordinal-group:0;-webkit-order:-1;order:-1}.flex-order-sm-0{-webkit-box-ordinal-group:1;-webkit-order:0;order:0}.flex-order-sm-1{-webkit-box-ordinal-group:2;-webkit-order:1;order:1}.flex-order-sm-2{-webkit-box-ordinal-group:3;-webkit-order:2;order:2}.flex-order-sm-3{-webkit-box-ordinal-group:4;-webkit-order:3;order:3}.flex-order-sm-4{-webkit-box-ordinal-group:5;-webkit-order:4;order:4}.flex-order-sm-5{-webkit-box-ordinal-group:6;-webkit-order:5;order:5}.flex-order-sm-6{-webkit-box-ordinal-group:7;-webkit-order:6;order:6}.flex-order-sm-7{-webkit-box-ordinal-group:8;-webkit-order:7;order:7}.flex-order-sm-8{-webkit-box-ordinal-group:9;-webkit-order:8;order:8}.flex-order-sm-9{-webkit-box-ordinal-group:10;-webkit-order:9;order:9}.flex-order-sm-10{-webkit-box-ordinal-group:11;-webkit-order:10;order:10}.flex-order-sm-11{-webkit-box-ordinal-group:12;-webkit-order:11;order:11}.flex-order-sm-12{-webkit-box-ordinal-group:13;-webkit-order:12;order:12}.flex-order-sm-13{-webkit-box-ordinal-group:14;-webkit-order:13;order:13}.flex-order-sm-14{-webkit-box-ordinal-group:15;-webkit-order:14;order:14}.flex-order-sm-15{-webkit-box-ordinal-group:16;-webkit-order:15;order:15}.flex-order-sm-16{-webkit-box-ordinal-group:17;-webkit-order:16;order:16}.flex-order-sm-17{-webkit-box-ordinal-group:18;-webkit-order:17;order:17}.flex-order-sm-18{-webkit-box-ordinal-group:19;-webkit-order:18;order:18}.flex-order-sm-19{-webkit-box-ordinal-group:20;-webkit-order:19;order:19}.flex-order-sm-20{-webkit-box-ordinal-group:21;-webkit-order:20;order:20}.flex-offset-sm-0,.offset-sm-0{margin-left:0}[dir=rtl] .flex-offset-sm-0,[dir=rtl] .offset-sm-0{margin-left:auto;margin-right:0}.flex-offset-sm-5,.offset-sm-5{margin-left:5%}[dir=rtl] .flex-offset-sm-5,[dir=rtl] .offset-sm-5{margin-left:auto;margin-right:5%}.flex-offset-sm-10,.offset-sm-10{margin-left:10%}[dir=rtl] .flex-offset-sm-10,[dir=rtl] .offset-sm-10{margin-left:auto;margin-right:10%}.flex-offset-sm-15,.offset-sm-15{margin-left:15%}[dir=rtl] .flex-offset-sm-15,[dir=rtl] .offset-sm-15{margin-left:auto;margin-right:15%}.flex-offset-sm-20,.offset-sm-20{margin-left:20%}[dir=rtl] .flex-offset-sm-20,[dir=rtl] .offset-sm-20{margin-left:auto;margin-right:20%}.flex-offset-sm-25,.offset-sm-25{margin-left:25%}[dir=rtl] .flex-offset-sm-25,[dir=rtl] .offset-sm-25{margin-left:auto;margin-right:25%}.flex-offset-sm-30,.offset-sm-30{margin-left:30%}[dir=rtl] .flex-offset-sm-30,[dir=rtl] .offset-sm-30{margin-left:auto;margin-right:30%}.flex-offset-sm-35,.offset-sm-35{margin-left:35%}[dir=rtl] .flex-offset-sm-35,[dir=rtl] .offset-sm-35{margin-left:auto;margin-right:35%}.flex-offset-sm-40,.offset-sm-40{margin-left:40%}[dir=rtl] .flex-offset-sm-40,[dir=rtl] .offset-sm-40{margin-left:auto;margin-right:40%}.flex-offset-sm-45,.offset-sm-45{margin-left:45%}[dir=rtl] .flex-offset-sm-45,[dir=rtl] .offset-sm-45{margin-left:auto;margin-right:45%}.flex-offset-sm-50,.offset-sm-50{margin-left:50%}[dir=rtl] .flex-offset-sm-50,[dir=rtl] .offset-sm-50{margin-left:auto;margin-right:50%}.flex-offset-sm-55,.offset-sm-55{margin-left:55%}[dir=rtl] .flex-offset-sm-55,[dir=rtl] .offset-sm-55{margin-left:auto;margin-right:55%}.flex-offset-sm-60,.offset-sm-60{margin-left:60%}[dir=rtl] .flex-offset-sm-60,[dir=rtl] .offset-sm-60{margin-left:auto;margin-right:60%}.flex-offset-sm-65,.offset-sm-65{margin-left:65%}[dir=rtl] .flex-offset-sm-65,[dir=rtl] .offset-sm-65{margin-left:auto;margin-right:65%}.flex-offset-sm-70,.offset-sm-70{margin-left:70%}[dir=rtl] .flex-offset-sm-70,[dir=rtl] .offset-sm-70{margin-left:auto;margin-right:70%}.flex-offset-sm-75,.offset-sm-75{margin-left:75%}[dir=rtl] .flex-offset-sm-75,[dir=rtl] .offset-sm-75{margin-left:auto;margin-right:75%}.flex-offset-sm-80,.offset-sm-80{margin-left:80%}[dir=rtl] .flex-offset-sm-80,[dir=rtl] .offset-sm-80{margin-left:auto;margin-right:80%}.flex-offset-sm-85,.offset-sm-85{margin-left:85%}[dir=rtl] .flex-offset-sm-85,[dir=rtl] .offset-sm-85{margin-left:auto;margin-right:85%}.flex-offset-sm-90,.offset-sm-90{margin-left:90%}[dir=rtl] .flex-offset-sm-90,[dir=rtl] .offset-sm-90{margin-left:auto;margin-right:90%}.flex-offset-sm-95,.offset-sm-95{margin-left:95%}[dir=rtl] .flex-offset-sm-95,[dir=rtl] .offset-sm-95{margin-left:auto;margin-right:95%}.flex-offset-sm-33,.offset-sm-33{margin-left:33.33333%}.flex-offset-sm-66,.offset-sm-66{margin-left:66.66667%}[dir=rtl] .flex-offset-sm-66,[dir=rtl] .offset-sm-66{margin-left:auto;margin-right:66.66667%}.layout-align-sm,.layout-align-sm-start-stretch{-webkit-align-content:stretch;align-content:stretch;-webkit-box-align:stretch;-webkit-align-items:stretch;align-items:stretch}.layout-align-sm,.layout-align-sm-start,.layout-align-sm-start-center,.layout-align-sm-start-end,.layout-align-sm-start-start,.layout-align-sm-start-stretch{-webkit-box-pack:start;-webkit-justify-content:flex-start;justify-content:flex-start}.layout-align-sm-center,.layout-align-sm-center-center,.layout-align-sm-center-end,.layout-align-sm-center-start,.layout-align-sm-center-stretch{-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center}.layout-align-sm-end,.layout-align-sm-end-center,.layout-align-sm-end-end,.layout-align-sm-end-start,.layout-align-sm-end-stretch{-webkit-box-pack:end;-webkit-justify-content:flex-end;justify-content:flex-end}.layout-align-sm-space-around,.layout-align-sm-space-around-center,.layout-align-sm-space-around-end,.layout-align-sm-space-around-start,.layout-align-sm-space-around-stretch{-webkit-justify-content:space-around;justify-content:space-around}.layout-align-sm-space-between,.layout-align-sm-space-between-center,.layout-align-sm-space-between-end,.layout-align-sm-space-between-start,.layout-align-sm-space-between-stretch{-webkit-box-pack:justify;-webkit-justify-content:space-between;justify-content:space-between}.layout-align-sm-center-start,.layout-align-sm-end-start,.layout-align-sm-space-around-start,.layout-align-sm-space-between-start,.layout-align-sm-start-start{-webkit-box-align:start;-webkit-align-items:flex-start;align-items:flex-start;-webkit-align-content:flex-start;align-content:flex-start}.layout-align-sm-center-center,.layout-align-sm-end-center,.layout-align-sm-space-around-center,.layout-align-sm-space-between-center,.layout-align-sm-start-center{-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-align-content:center;align-content:center;max-width:100%}.layout-align-sm-center-center>*,.layout-align-sm-end-center>*,.layout-align-sm-space-around-center>*,.layout-align-sm-space-between-center>*,.layout-align-sm-start-center>*{max-width:100%;box-sizing:border-box}.layout-align-sm-center-end,.layout-align-sm-end-end,.layout-align-sm-space-around-end,.layout-align-sm-space-between-end,.layout-align-sm-start-end{-webkit-box-align:end;-webkit-align-items:flex-end;align-items:flex-end;-webkit-align-content:flex-end;align-content:flex-end}.layout-align-sm-center-stretch,.layout-align-sm-end-stretch,.layout-align-sm-space-around-stretch,.layout-align-sm-space-between-stretch,.layout-align-sm-start-stretch{-webkit-box-align:stretch;-webkit-align-items:stretch;align-items:stretch;-webkit-align-content:stretch;align-content:stretch}.flex-sm{-webkit-flex:1;flex:1}.flex-sm,.flex-sm-grow{-webkit-box-flex:1;box-sizing:border-box}.flex-sm-grow{-webkit-flex:1 1 100%;flex:1 1 100%}.flex-sm-initial{-webkit-box-flex:0;-webkit-flex:0 1 auto;flex:0 1 auto;box-sizing:border-box}.flex-sm-auto{-webkit-box-flex:1;-webkit-flex:1 1 auto;flex:1 1 auto;box-sizing:border-box}.flex-sm-none{-webkit-box-flex:0;-webkit-flex:0 0 auto;flex:0 0 auto;box-sizing:border-box}.flex-sm-noshrink{-webkit-box-flex:1;-webkit-flex:1 0 auto;flex:1 0 auto;box-sizing:border-box}.flex-sm-nogrow{-webkit-box-flex:0;-webkit-flex:0 1 auto;flex:0 1 auto;box-sizing:border-box}.flex-sm-0,.layout-row>.flex-sm-0{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:0;max-height:100%;box-sizing:border-box}.layout-row>.flex-sm-0{min-width:0}.layout-column>.flex-sm-0{max-width:100%;max-height:0%}.layout-column>.flex-sm-0,.layout-sm-row>.flex-sm-0{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-sm-row>.flex-sm-0{max-width:0;max-height:100%;min-width:0}.layout-sm-column>.flex-sm-0{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;max-height:0%;box-sizing:border-box;min-height:0}.flex-sm-5,.layout-row>.flex-sm-5{max-width:5%;max-height:100%}.flex-sm-5,.layout-column>.flex-sm-5,.layout-row>.flex-sm-5{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-sm-5{max-width:100%;max-height:5%}.layout-sm-row>.flex-sm-5{max-width:5%;max-height:100%}.layout-sm-column>.flex-sm-5,.layout-sm-row>.flex-sm-5{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-sm-column>.flex-sm-5{max-width:100%;max-height:5%}.flex-sm-10,.layout-row>.flex-sm-10{max-width:10%;max-height:100%}.flex-sm-10,.layout-column>.flex-sm-10,.layout-row>.flex-sm-10{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-sm-10{max-width:100%;max-height:10%}.layout-sm-row>.flex-sm-10{max-width:10%;max-height:100%}.layout-sm-column>.flex-sm-10,.layout-sm-row>.flex-sm-10{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-sm-column>.flex-sm-10{max-width:100%;max-height:10%}.flex-sm-15,.layout-row>.flex-sm-15{max-width:15%;max-height:100%}.flex-sm-15,.layout-column>.flex-sm-15,.layout-row>.flex-sm-15{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-sm-15{max-width:100%;max-height:15%}.layout-sm-row>.flex-sm-15{max-width:15%;max-height:100%}.layout-sm-column>.flex-sm-15,.layout-sm-row>.flex-sm-15{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-sm-column>.flex-sm-15{max-width:100%;max-height:15%}.flex-sm-20,.layout-row>.flex-sm-20{max-width:20%;max-height:100%}.flex-sm-20,.layout-column>.flex-sm-20,.layout-row>.flex-sm-20{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-sm-20{max-width:100%;max-height:20%}.layout-sm-row>.flex-sm-20{max-width:20%;max-height:100%}.layout-sm-column>.flex-sm-20,.layout-sm-row>.flex-sm-20{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-sm-column>.flex-sm-20{max-width:100%;max-height:20%}.flex-sm-25,.layout-row>.flex-sm-25{max-width:25%;max-height:100%}.flex-sm-25,.layout-column>.flex-sm-25,.layout-row>.flex-sm-25{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-sm-25{max-width:100%;max-height:25%}.layout-sm-row>.flex-sm-25{max-width:25%;max-height:100%}.layout-sm-column>.flex-sm-25,.layout-sm-row>.flex-sm-25{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-sm-column>.flex-sm-25{max-width:100%;max-height:25%}.flex-sm-30,.layout-row>.flex-sm-30{max-width:30%;max-height:100%}.flex-sm-30,.layout-column>.flex-sm-30,.layout-row>.flex-sm-30{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-sm-30{max-width:100%;max-height:30%}.layout-sm-row>.flex-sm-30{max-width:30%;max-height:100%}.layout-sm-column>.flex-sm-30,.layout-sm-row>.flex-sm-30{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-sm-column>.flex-sm-30{max-width:100%;max-height:30%}.flex-sm-35,.layout-row>.flex-sm-35{max-width:35%;max-height:100%}.flex-sm-35,.layout-column>.flex-sm-35,.layout-row>.flex-sm-35{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-sm-35{max-width:100%;max-height:35%}.layout-sm-row>.flex-sm-35{max-width:35%;max-height:100%}.layout-sm-column>.flex-sm-35,.layout-sm-row>.flex-sm-35{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-sm-column>.flex-sm-35{max-width:100%;max-height:35%}.flex-sm-40,.layout-row>.flex-sm-40{max-width:40%;max-height:100%}.flex-sm-40,.layout-column>.flex-sm-40,.layout-row>.flex-sm-40{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-sm-40{max-width:100%;max-height:40%}.layout-sm-row>.flex-sm-40{max-width:40%;max-height:100%}.layout-sm-column>.flex-sm-40,.layout-sm-row>.flex-sm-40{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-sm-column>.flex-sm-40{max-width:100%;max-height:40%}.flex-sm-45,.layout-row>.flex-sm-45{max-width:45%;max-height:100%}.flex-sm-45,.layout-column>.flex-sm-45,.layout-row>.flex-sm-45{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-sm-45{max-width:100%;max-height:45%}.layout-sm-row>.flex-sm-45{max-width:45%;max-height:100%}.layout-sm-column>.flex-sm-45,.layout-sm-row>.flex-sm-45{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-sm-column>.flex-sm-45{max-width:100%;max-height:45%}.flex-sm-50,.layout-row>.flex-sm-50{max-width:50%;max-height:100%}.flex-sm-50,.layout-column>.flex-sm-50,.layout-row>.flex-sm-50{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-sm-50{max-width:100%;max-height:50%}.layout-sm-row>.flex-sm-50{max-width:50%;max-height:100%}.layout-sm-column>.flex-sm-50,.layout-sm-row>.flex-sm-50{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-sm-column>.flex-sm-50{max-width:100%;max-height:50%}.flex-sm-55,.layout-row>.flex-sm-55{max-width:55%;max-height:100%}.flex-sm-55,.layout-column>.flex-sm-55,.layout-row>.flex-sm-55{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-sm-55{max-width:100%;max-height:55%}.layout-sm-row>.flex-sm-55{max-width:55%;max-height:100%}.layout-sm-column>.flex-sm-55,.layout-sm-row>.flex-sm-55{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-sm-column>.flex-sm-55{max-width:100%;max-height:55%}.flex-sm-60,.layout-row>.flex-sm-60{max-width:60%;max-height:100%}.flex-sm-60,.layout-column>.flex-sm-60,.layout-row>.flex-sm-60{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-sm-60{max-width:100%;max-height:60%}.layout-sm-row>.flex-sm-60{max-width:60%;max-height:100%}.layout-sm-column>.flex-sm-60,.layout-sm-row>.flex-sm-60{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-sm-column>.flex-sm-60{max-width:100%;max-height:60%}.flex-sm-65,.layout-row>.flex-sm-65{max-width:65%;max-height:100%}.flex-sm-65,.layout-column>.flex-sm-65,.layout-row>.flex-sm-65{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-sm-65{max-width:100%;max-height:65%}.layout-sm-row>.flex-sm-65{max-width:65%;max-height:100%}.layout-sm-column>.flex-sm-65,.layout-sm-row>.flex-sm-65{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-sm-column>.flex-sm-65{max-width:100%;max-height:65%}.flex-sm-70,.layout-row>.flex-sm-70{max-width:70%;max-height:100%}.flex-sm-70,.layout-column>.flex-sm-70,.layout-row>.flex-sm-70{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-sm-70{max-width:100%;max-height:70%}.layout-sm-row>.flex-sm-70{max-width:70%;max-height:100%}.layout-sm-column>.flex-sm-70,.layout-sm-row>.flex-sm-70{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-sm-column>.flex-sm-70{max-width:100%;max-height:70%}.flex-sm-75,.layout-row>.flex-sm-75{max-width:75%;max-height:100%}.flex-sm-75,.layout-column>.flex-sm-75,.layout-row>.flex-sm-75{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-sm-75{max-width:100%;max-height:75%}.layout-sm-row>.flex-sm-75{max-width:75%;max-height:100%}.layout-sm-column>.flex-sm-75,.layout-sm-row>.flex-sm-75{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-sm-column>.flex-sm-75{max-width:100%;max-height:75%}.flex-sm-80,.layout-row>.flex-sm-80{max-width:80%;max-height:100%}.flex-sm-80,.layout-column>.flex-sm-80,.layout-row>.flex-sm-80{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-sm-80{max-width:100%;max-height:80%}.layout-sm-row>.flex-sm-80{max-width:80%;max-height:100%}.layout-sm-column>.flex-sm-80,.layout-sm-row>.flex-sm-80{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-sm-column>.flex-sm-80{max-width:100%;max-height:80%}.flex-sm-85,.layout-row>.flex-sm-85{max-width:85%;max-height:100%}.flex-sm-85,.layout-column>.flex-sm-85,.layout-row>.flex-sm-85{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-sm-85{max-width:100%;max-height:85%}.layout-sm-row>.flex-sm-85{max-width:85%;max-height:100%}.layout-sm-column>.flex-sm-85,.layout-sm-row>.flex-sm-85{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-sm-column>.flex-sm-85{max-width:100%;max-height:85%}.flex-sm-90,.layout-row>.flex-sm-90{max-width:90%;max-height:100%}.flex-sm-90,.layout-column>.flex-sm-90,.layout-row>.flex-sm-90{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-sm-90{max-width:100%;max-height:90%}.layout-sm-row>.flex-sm-90{max-width:90%;max-height:100%}.layout-sm-column>.flex-sm-90,.layout-sm-row>.flex-sm-90{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-sm-column>.flex-sm-90{max-width:100%;max-height:90%}.flex-sm-95,.layout-row>.flex-sm-95{max-width:95%;max-height:100%}.flex-sm-95,.layout-column>.flex-sm-95,.layout-row>.flex-sm-95{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-sm-95{max-width:100%;max-height:95%}.layout-sm-row>.flex-sm-95{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:95%;max-height:100%;box-sizing:border-box}.layout-sm-column>.flex-sm-95{max-height:95%}.flex-sm-100,.layout-sm-column>.flex-sm-95{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;box-sizing:border-box}.flex-sm-100{max-height:100%}.layout-column>.flex-sm-100,.layout-row>.flex-sm-100,.layout-sm-column>.flex-sm-100,.layout-sm-row>.flex-sm-100{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;max-height:100%;box-sizing:border-box}.layout-row>.flex-sm-33{-webkit-flex:1 1 33.33%;flex:1 1 33.33%;max-width:33.33%}.layout-row>.flex-sm-33,.layout-row>.flex-sm-66{-webkit-box-flex:1;max-height:100%;box-sizing:border-box}.layout-row>.flex-sm-66{-webkit-flex:1 1 66.66%;flex:1 1 66.66%;max-width:66.66%}.layout-column>.flex-sm-33{-webkit-flex:1 1 33.33%;flex:1 1 33.33%;max-height:33.33%}.layout-column>.flex-sm-33,.layout-column>.flex-sm-66{-webkit-box-flex:1;max-width:100%;box-sizing:border-box}.layout-column>.flex-sm-66{-webkit-flex:1 1 66.66%;flex:1 1 66.66%;max-height:66.66%}.layout-sm-row>.flex-sm-33{max-width:33.33%}.layout-sm-row>.flex-sm-33,.layout-sm-row>.flex-sm-66{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-height:100%;box-sizing:border-box}.layout-sm-row>.flex-sm-66{max-width:66.66%}.layout-sm-row>.flex{min-width:0}.layout-sm-column>.flex-sm-33{max-height:33.33%}.layout-sm-column>.flex-sm-33,.layout-sm-column>.flex-sm-66{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;box-sizing:border-box}.layout-sm-column>.flex-sm-66{max-height:66.66%}.layout-sm-column>.flex{min-height:0}.layout-sm,.layout-sm-column,.layout-sm-row{box-sizing:border-box;display:-webkit-box;display:-webkit-flex;display:flex}.layout-sm-column{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column}.layout-sm-row{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;flex-direction:row}}@media (min-width:960px){.flex-order-gt-sm--20{-webkit-box-ordinal-group:-19;-webkit-order:-20;order:-20}.flex-order-gt-sm--19{-webkit-box-ordinal-group:-18;-webkit-order:-19;order:-19}.flex-order-gt-sm--18{-webkit-box-ordinal-group:-17;-webkit-order:-18;order:-18}.flex-order-gt-sm--17{-webkit-box-ordinal-group:-16;-webkit-order:-17;order:-17}.flex-order-gt-sm--16{-webkit-box-ordinal-group:-15;-webkit-order:-16;order:-16}.flex-order-gt-sm--15{-webkit-box-ordinal-group:-14;-webkit-order:-15;order:-15}.flex-order-gt-sm--14{-webkit-box-ordinal-group:-13;-webkit-order:-14;order:-14}.flex-order-gt-sm--13{-webkit-box-ordinal-group:-12;-webkit-order:-13;order:-13}.flex-order-gt-sm--12{-webkit-box-ordinal-group:-11;-webkit-order:-12;order:-12}.flex-order-gt-sm--11{-webkit-box-ordinal-group:-10;-webkit-order:-11;order:-11}.flex-order-gt-sm--10{-webkit-box-ordinal-group:-9;-webkit-order:-10;order:-10}.flex-order-gt-sm--9{-webkit-box-ordinal-group:-8;-webkit-order:-9;order:-9}.flex-order-gt-sm--8{-webkit-box-ordinal-group:-7;-webkit-order:-8;order:-8}.flex-order-gt-sm--7{-webkit-box-ordinal-group:-6;-webkit-order:-7;order:-7}.flex-order-gt-sm--6{-webkit-box-ordinal-group:-5;-webkit-order:-6;order:-6}.flex-order-gt-sm--5{-webkit-box-ordinal-group:-4;-webkit-order:-5;order:-5}.flex-order-gt-sm--4{-webkit-box-ordinal-group:-3;-webkit-order:-4;order:-4}.flex-order-gt-sm--3{-webkit-box-ordinal-group:-2;-webkit-order:-3;order:-3}.flex-order-gt-sm--2{-webkit-box-ordinal-group:-1;-webkit-order:-2;order:-2}.flex-order-gt-sm--1{-webkit-box-ordinal-group:0;-webkit-order:-1;order:-1}.flex-order-gt-sm-0{-webkit-box-ordinal-group:1;-webkit-order:0;order:0}.flex-order-gt-sm-1{-webkit-box-ordinal-group:2;-webkit-order:1;order:1}.flex-order-gt-sm-2{-webkit-box-ordinal-group:3;-webkit-order:2;order:2}.flex-order-gt-sm-3{-webkit-box-ordinal-group:4;-webkit-order:3;order:3}.flex-order-gt-sm-4{-webkit-box-ordinal-group:5;-webkit-order:4;order:4}.flex-order-gt-sm-5{-webkit-box-ordinal-group:6;-webkit-order:5;order:5}.flex-order-gt-sm-6{-webkit-box-ordinal-group:7;-webkit-order:6;order:6}.flex-order-gt-sm-7{-webkit-box-ordinal-group:8;-webkit-order:7;order:7}.flex-order-gt-sm-8{-webkit-box-ordinal-group:9;-webkit-order:8;order:8}.flex-order-gt-sm-9{-webkit-box-ordinal-group:10;-webkit-order:9;order:9}.flex-order-gt-sm-10{-webkit-box-ordinal-group:11;-webkit-order:10;order:10}.flex-order-gt-sm-11{-webkit-box-ordinal-group:12;-webkit-order:11;order:11}.flex-order-gt-sm-12{-webkit-box-ordinal-group:13;-webkit-order:12;order:12}.flex-order-gt-sm-13{-webkit-box-ordinal-group:14;-webkit-order:13;order:13}.flex-order-gt-sm-14{-webkit-box-ordinal-group:15;-webkit-order:14;order:14}.flex-order-gt-sm-15{-webkit-box-ordinal-group:16;-webkit-order:15;order:15}.flex-order-gt-sm-16{-webkit-box-ordinal-group:17;-webkit-order:16;order:16}.flex-order-gt-sm-17{-webkit-box-ordinal-group:18;-webkit-order:17;order:17}.flex-order-gt-sm-18{-webkit-box-ordinal-group:19;-webkit-order:18;order:18}.flex-order-gt-sm-19{-webkit-box-ordinal-group:20;-webkit-order:19;order:19}.flex-order-gt-sm-20{-webkit-box-ordinal-group:21;-webkit-order:20;order:20}.flex-offset-gt-sm-0,.offset-gt-sm-0{margin-left:0}[dir=rtl] .flex-offset-gt-sm-0,[dir=rtl] .offset-gt-sm-0{margin-left:auto;margin-right:0}.flex-offset-gt-sm-5,.offset-gt-sm-5{margin-left:5%}[dir=rtl] .flex-offset-gt-sm-5,[dir=rtl] .offset-gt-sm-5{margin-left:auto;margin-right:5%}.flex-offset-gt-sm-10,.offset-gt-sm-10{margin-left:10%}[dir=rtl] .flex-offset-gt-sm-10,[dir=rtl] .offset-gt-sm-10{margin-left:auto;margin-right:10%}.flex-offset-gt-sm-15,.offset-gt-sm-15{margin-left:15%}[dir=rtl] .flex-offset-gt-sm-15,[dir=rtl] .offset-gt-sm-15{margin-left:auto;margin-right:15%}.flex-offset-gt-sm-20,.offset-gt-sm-20{margin-left:20%}[dir=rtl] .flex-offset-gt-sm-20,[dir=rtl] .offset-gt-sm-20{margin-left:auto;margin-right:20%}.flex-offset-gt-sm-25,.offset-gt-sm-25{margin-left:25%}[dir=rtl] .flex-offset-gt-sm-25,[dir=rtl] .offset-gt-sm-25{margin-left:auto;margin-right:25%}.flex-offset-gt-sm-30,.offset-gt-sm-30{margin-left:30%}[dir=rtl] .flex-offset-gt-sm-30,[dir=rtl] .offset-gt-sm-30{margin-left:auto;margin-right:30%}.flex-offset-gt-sm-35,.offset-gt-sm-35{margin-left:35%}[dir=rtl] .flex-offset-gt-sm-35,[dir=rtl] .offset-gt-sm-35{margin-left:auto;margin-right:35%}.flex-offset-gt-sm-40,.offset-gt-sm-40{margin-left:40%}[dir=rtl] .flex-offset-gt-sm-40,[dir=rtl] .offset-gt-sm-40{margin-left:auto;margin-right:40%}.flex-offset-gt-sm-45,.offset-gt-sm-45{margin-left:45%}[dir=rtl] .flex-offset-gt-sm-45,[dir=rtl] .offset-gt-sm-45{margin-left:auto;margin-right:45%}.flex-offset-gt-sm-50,.offset-gt-sm-50{margin-left:50%}[dir=rtl] .flex-offset-gt-sm-50,[dir=rtl] .offset-gt-sm-50{margin-left:auto;margin-right:50%}.flex-offset-gt-sm-55,.offset-gt-sm-55{margin-left:55%}[dir=rtl] .flex-offset-gt-sm-55,[dir=rtl] .offset-gt-sm-55{margin-left:auto;margin-right:55%}.flex-offset-gt-sm-60,.offset-gt-sm-60{margin-left:60%}[dir=rtl] .flex-offset-gt-sm-60,[dir=rtl] .offset-gt-sm-60{margin-left:auto;margin-right:60%}.flex-offset-gt-sm-65,.offset-gt-sm-65{margin-left:65%}[dir=rtl] .flex-offset-gt-sm-65,[dir=rtl] .offset-gt-sm-65{margin-left:auto;margin-right:65%}.flex-offset-gt-sm-70,.offset-gt-sm-70{margin-left:70%}[dir=rtl] .flex-offset-gt-sm-70,[dir=rtl] .offset-gt-sm-70{margin-left:auto;margin-right:70%}.flex-offset-gt-sm-75,.offset-gt-sm-75{margin-left:75%}[dir=rtl] .flex-offset-gt-sm-75,[dir=rtl] .offset-gt-sm-75{margin-left:auto;margin-right:75%}.flex-offset-gt-sm-80,.offset-gt-sm-80{margin-left:80%}[dir=rtl] .flex-offset-gt-sm-80,[dir=rtl] .offset-gt-sm-80{margin-left:auto;margin-right:80%}.flex-offset-gt-sm-85,.offset-gt-sm-85{margin-left:85%}[dir=rtl] .flex-offset-gt-sm-85,[dir=rtl] .offset-gt-sm-85{margin-left:auto;margin-right:85%}.flex-offset-gt-sm-90,.offset-gt-sm-90{margin-left:90%}[dir=rtl] .flex-offset-gt-sm-90,[dir=rtl] .offset-gt-sm-90{margin-left:auto;margin-right:90%}.flex-offset-gt-sm-95,.offset-gt-sm-95{margin-left:95%}[dir=rtl] .flex-offset-gt-sm-95,[dir=rtl] .offset-gt-sm-95{margin-left:auto;margin-right:95%}.flex-offset-gt-sm-33,.offset-gt-sm-33{margin-left:33.33333%}.flex-offset-gt-sm-66,.offset-gt-sm-66{margin-left:66.66667%}[dir=rtl] .flex-offset-gt-sm-66,[dir=rtl] .offset-gt-sm-66{margin-left:auto;margin-right:66.66667%}.layout-align-gt-sm,.layout-align-gt-sm-start-stretch{-webkit-align-content:stretch;align-content:stretch;-webkit-box-align:stretch;-webkit-align-items:stretch;align-items:stretch}.layout-align-gt-sm,.layout-align-gt-sm-start,.layout-align-gt-sm-start-center,.layout-align-gt-sm-start-end,.layout-align-gt-sm-start-start,.layout-align-gt-sm-start-stretch{-webkit-box-pack:start;-webkit-justify-content:flex-start;justify-content:flex-start}.layout-align-gt-sm-center,.layout-align-gt-sm-center-center,.layout-align-gt-sm-center-end,.layout-align-gt-sm-center-start,.layout-align-gt-sm-center-stretch{-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center}.layout-align-gt-sm-end,.layout-align-gt-sm-end-center,.layout-align-gt-sm-end-end,.layout-align-gt-sm-end-start,.layout-align-gt-sm-end-stretch{-webkit-box-pack:end;-webkit-justify-content:flex-end;justify-content:flex-end}.layout-align-gt-sm-space-around,.layout-align-gt-sm-space-around-center,.layout-align-gt-sm-space-around-end,.layout-align-gt-sm-space-around-start,.layout-align-gt-sm-space-around-stretch{-webkit-justify-content:space-around;justify-content:space-around}.layout-align-gt-sm-space-between,.layout-align-gt-sm-space-between-center,.layout-align-gt-sm-space-between-end,.layout-align-gt-sm-space-between-start,.layout-align-gt-sm-space-between-stretch{-webkit-box-pack:justify;-webkit-justify-content:space-between;justify-content:space-between}.layout-align-gt-sm-center-start,.layout-align-gt-sm-end-start,.layout-align-gt-sm-space-around-start,.layout-align-gt-sm-space-between-start,.layout-align-gt-sm-start-start{-webkit-box-align:start;-webkit-align-items:flex-start;align-items:flex-start;-webkit-align-content:flex-start;align-content:flex-start}.layout-align-gt-sm-center-center,.layout-align-gt-sm-end-center,.layout-align-gt-sm-space-around-center,.layout-align-gt-sm-space-between-center,.layout-align-gt-sm-start-center{-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-align-content:center;align-content:center;max-width:100%}.layout-align-gt-sm-center-center>*,.layout-align-gt-sm-end-center>*,.layout-align-gt-sm-space-around-center>*,.layout-align-gt-sm-space-between-center>*,.layout-align-gt-sm-start-center>*{max-width:100%;box-sizing:border-box}.layout-align-gt-sm-center-end,.layout-align-gt-sm-end-end,.layout-align-gt-sm-space-around-end,.layout-align-gt-sm-space-between-end,.layout-align-gt-sm-start-end{-webkit-box-align:end;-webkit-align-items:flex-end;align-items:flex-end;-webkit-align-content:flex-end;align-content:flex-end}.layout-align-gt-sm-center-stretch,.layout-align-gt-sm-end-stretch,.layout-align-gt-sm-space-around-stretch,.layout-align-gt-sm-space-between-stretch,.layout-align-gt-sm-start-stretch{-webkit-box-align:stretch;-webkit-align-items:stretch;align-items:stretch;-webkit-align-content:stretch;align-content:stretch}.flex-gt-sm{-webkit-flex:1;flex:1}.flex-gt-sm,.flex-gt-sm-grow{-webkit-box-flex:1;box-sizing:border-box}.flex-gt-sm-grow{-webkit-flex:1 1 100%;flex:1 1 100%}.flex-gt-sm-initial{-webkit-box-flex:0;-webkit-flex:0 1 auto;flex:0 1 auto;box-sizing:border-box}.flex-gt-sm-auto{-webkit-box-flex:1;-webkit-flex:1 1 auto;flex:1 1 auto;box-sizing:border-box}.flex-gt-sm-none{-webkit-box-flex:0;-webkit-flex:0 0 auto;flex:0 0 auto;box-sizing:border-box}.flex-gt-sm-noshrink{-webkit-box-flex:1;-webkit-flex:1 0 auto;flex:1 0 auto;box-sizing:border-box}.flex-gt-sm-nogrow{-webkit-box-flex:0;-webkit-flex:0 1 auto;flex:0 1 auto;box-sizing:border-box}.flex-gt-sm-0,.layout-row>.flex-gt-sm-0{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:0;max-height:100%;box-sizing:border-box}.layout-row>.flex-gt-sm-0{min-width:0}.layout-column>.flex-gt-sm-0{max-width:100%;max-height:0%}.layout-column>.flex-gt-sm-0,.layout-gt-sm-row>.flex-gt-sm-0{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-sm-row>.flex-gt-sm-0{max-width:0;max-height:100%;min-width:0}.layout-gt-sm-column>.flex-gt-sm-0{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;max-height:0%;box-sizing:border-box;min-height:0}.flex-gt-sm-5,.layout-row>.flex-gt-sm-5{max-width:5%;max-height:100%}.flex-gt-sm-5,.layout-column>.flex-gt-sm-5,.layout-row>.flex-gt-sm-5{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-sm-5{max-width:100%;max-height:5%}.layout-gt-sm-row>.flex-gt-sm-5{max-width:5%;max-height:100%}.layout-gt-sm-column>.flex-gt-sm-5,.layout-gt-sm-row>.flex-gt-sm-5{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-sm-column>.flex-gt-sm-5{max-width:100%;max-height:5%}.flex-gt-sm-10,.layout-row>.flex-gt-sm-10{max-width:10%;max-height:100%}.flex-gt-sm-10,.layout-column>.flex-gt-sm-10,.layout-row>.flex-gt-sm-10{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-sm-10{max-width:100%;max-height:10%}.layout-gt-sm-row>.flex-gt-sm-10{max-width:10%;max-height:100%}.layout-gt-sm-column>.flex-gt-sm-10,.layout-gt-sm-row>.flex-gt-sm-10{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-sm-column>.flex-gt-sm-10{max-width:100%;max-height:10%}.flex-gt-sm-15,.layout-row>.flex-gt-sm-15{max-width:15%;max-height:100%}.flex-gt-sm-15,.layout-column>.flex-gt-sm-15,.layout-row>.flex-gt-sm-15{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-sm-15{max-width:100%;max-height:15%}.layout-gt-sm-row>.flex-gt-sm-15{max-width:15%;max-height:100%}.layout-gt-sm-column>.flex-gt-sm-15,.layout-gt-sm-row>.flex-gt-sm-15{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-sm-column>.flex-gt-sm-15{max-width:100%;max-height:15%}.flex-gt-sm-20,.layout-row>.flex-gt-sm-20{max-width:20%;max-height:100%}.flex-gt-sm-20,.layout-column>.flex-gt-sm-20,.layout-row>.flex-gt-sm-20{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-sm-20{max-width:100%;max-height:20%}.layout-gt-sm-row>.flex-gt-sm-20{max-width:20%;max-height:100%}.layout-gt-sm-column>.flex-gt-sm-20,.layout-gt-sm-row>.flex-gt-sm-20{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-sm-column>.flex-gt-sm-20{max-width:100%;max-height:20%}.flex-gt-sm-25,.layout-row>.flex-gt-sm-25{max-width:25%;max-height:100%}.flex-gt-sm-25,.layout-column>.flex-gt-sm-25,.layout-row>.flex-gt-sm-25{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-sm-25{max-width:100%;max-height:25%}.layout-gt-sm-row>.flex-gt-sm-25{max-width:25%;max-height:100%}.layout-gt-sm-column>.flex-gt-sm-25,.layout-gt-sm-row>.flex-gt-sm-25{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-sm-column>.flex-gt-sm-25{max-width:100%;max-height:25%}.flex-gt-sm-30,.layout-row>.flex-gt-sm-30{max-width:30%;max-height:100%}.flex-gt-sm-30,.layout-column>.flex-gt-sm-30,.layout-row>.flex-gt-sm-30{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-sm-30{max-width:100%;max-height:30%}.layout-gt-sm-row>.flex-gt-sm-30{max-width:30%;max-height:100%}.layout-gt-sm-column>.flex-gt-sm-30,.layout-gt-sm-row>.flex-gt-sm-30{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-sm-column>.flex-gt-sm-30{max-width:100%;max-height:30%}.flex-gt-sm-35,.layout-row>.flex-gt-sm-35{max-width:35%;max-height:100%}.flex-gt-sm-35,.layout-column>.flex-gt-sm-35,.layout-row>.flex-gt-sm-35{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-sm-35{max-width:100%;max-height:35%}.layout-gt-sm-row>.flex-gt-sm-35{max-width:35%;max-height:100%}.layout-gt-sm-column>.flex-gt-sm-35,.layout-gt-sm-row>.flex-gt-sm-35{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-sm-column>.flex-gt-sm-35{max-width:100%;max-height:35%}.flex-gt-sm-40,.layout-row>.flex-gt-sm-40{max-width:40%;max-height:100%}.flex-gt-sm-40,.layout-column>.flex-gt-sm-40,.layout-row>.flex-gt-sm-40{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-sm-40{max-width:100%;max-height:40%}.layout-gt-sm-row>.flex-gt-sm-40{max-width:40%;max-height:100%}.layout-gt-sm-column>.flex-gt-sm-40,.layout-gt-sm-row>.flex-gt-sm-40{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-sm-column>.flex-gt-sm-40{max-width:100%;max-height:40%}.flex-gt-sm-45,.layout-row>.flex-gt-sm-45{max-width:45%;max-height:100%}.flex-gt-sm-45,.layout-column>.flex-gt-sm-45,.layout-row>.flex-gt-sm-45{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-sm-45{max-width:100%;max-height:45%}.layout-gt-sm-row>.flex-gt-sm-45{max-width:45%;max-height:100%}.layout-gt-sm-column>.flex-gt-sm-45,.layout-gt-sm-row>.flex-gt-sm-45{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-sm-column>.flex-gt-sm-45{max-width:100%;max-height:45%}.flex-gt-sm-50,.layout-row>.flex-gt-sm-50{max-width:50%;max-height:100%}.flex-gt-sm-50,.layout-column>.flex-gt-sm-50,.layout-row>.flex-gt-sm-50{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-sm-50{max-width:100%;max-height:50%}.layout-gt-sm-row>.flex-gt-sm-50{max-width:50%;max-height:100%}.layout-gt-sm-column>.flex-gt-sm-50,.layout-gt-sm-row>.flex-gt-sm-50{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-sm-column>.flex-gt-sm-50{max-width:100%;max-height:50%}.flex-gt-sm-55,.layout-row>.flex-gt-sm-55{max-width:55%;max-height:100%}.flex-gt-sm-55,.layout-column>.flex-gt-sm-55,.layout-row>.flex-gt-sm-55{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-sm-55{max-width:100%;max-height:55%}.layout-gt-sm-row>.flex-gt-sm-55{max-width:55%;max-height:100%}.layout-gt-sm-column>.flex-gt-sm-55,.layout-gt-sm-row>.flex-gt-sm-55{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-sm-column>.flex-gt-sm-55{max-width:100%;max-height:55%}.flex-gt-sm-60,.layout-row>.flex-gt-sm-60{max-width:60%;max-height:100%}.flex-gt-sm-60,.layout-column>.flex-gt-sm-60,.layout-row>.flex-gt-sm-60{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-sm-60{max-width:100%;max-height:60%}.layout-gt-sm-row>.flex-gt-sm-60{max-width:60%;max-height:100%}.layout-gt-sm-column>.flex-gt-sm-60,.layout-gt-sm-row>.flex-gt-sm-60{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-sm-column>.flex-gt-sm-60{max-width:100%;max-height:60%}.flex-gt-sm-65,.layout-row>.flex-gt-sm-65{max-width:65%;max-height:100%}.flex-gt-sm-65,.layout-column>.flex-gt-sm-65,.layout-row>.flex-gt-sm-65{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-sm-65{max-width:100%;max-height:65%}.layout-gt-sm-row>.flex-gt-sm-65{max-width:65%;max-height:100%}.layout-gt-sm-column>.flex-gt-sm-65,.layout-gt-sm-row>.flex-gt-sm-65{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-sm-column>.flex-gt-sm-65{max-width:100%;max-height:65%}.flex-gt-sm-70,.layout-row>.flex-gt-sm-70{max-width:70%;max-height:100%}.flex-gt-sm-70,.layout-column>.flex-gt-sm-70,.layout-row>.flex-gt-sm-70{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-sm-70{max-width:100%;max-height:70%}.layout-gt-sm-row>.flex-gt-sm-70{max-width:70%;max-height:100%}.layout-gt-sm-column>.flex-gt-sm-70,.layout-gt-sm-row>.flex-gt-sm-70{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-sm-column>.flex-gt-sm-70{max-width:100%;max-height:70%}.flex-gt-sm-75,.layout-row>.flex-gt-sm-75{max-width:75%;max-height:100%}.flex-gt-sm-75,.layout-column>.flex-gt-sm-75,.layout-row>.flex-gt-sm-75{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-sm-75{max-width:100%;max-height:75%}.layout-gt-sm-row>.flex-gt-sm-75{max-width:75%;max-height:100%}.layout-gt-sm-column>.flex-gt-sm-75,.layout-gt-sm-row>.flex-gt-sm-75{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-sm-column>.flex-gt-sm-75{max-width:100%;max-height:75%}.flex-gt-sm-80,.layout-row>.flex-gt-sm-80{max-width:80%;max-height:100%}.flex-gt-sm-80,.layout-column>.flex-gt-sm-80,.layout-row>.flex-gt-sm-80{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-sm-80{max-width:100%;max-height:80%}.layout-gt-sm-row>.flex-gt-sm-80{max-width:80%;max-height:100%}.layout-gt-sm-column>.flex-gt-sm-80,.layout-gt-sm-row>.flex-gt-sm-80{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-sm-column>.flex-gt-sm-80{max-width:100%;max-height:80%}.flex-gt-sm-85,.layout-row>.flex-gt-sm-85{max-width:85%;max-height:100%}.flex-gt-sm-85,.layout-column>.flex-gt-sm-85,.layout-row>.flex-gt-sm-85{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-sm-85{max-width:100%;max-height:85%}.layout-gt-sm-row>.flex-gt-sm-85{max-width:85%;max-height:100%}.layout-gt-sm-column>.flex-gt-sm-85,.layout-gt-sm-row>.flex-gt-sm-85{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-sm-column>.flex-gt-sm-85{max-width:100%;max-height:85%}.flex-gt-sm-90,.layout-row>.flex-gt-sm-90{max-width:90%;max-height:100%}.flex-gt-sm-90,.layout-column>.flex-gt-sm-90,.layout-row>.flex-gt-sm-90{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-sm-90{max-width:100%;max-height:90%}.layout-gt-sm-row>.flex-gt-sm-90{max-width:90%;max-height:100%}.layout-gt-sm-column>.flex-gt-sm-90,.layout-gt-sm-row>.flex-gt-sm-90{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-sm-column>.flex-gt-sm-90{max-width:100%;max-height:90%}.flex-gt-sm-95,.layout-row>.flex-gt-sm-95{max-width:95%;max-height:100%}.flex-gt-sm-95,.layout-column>.flex-gt-sm-95,.layout-row>.flex-gt-sm-95{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-sm-95{max-width:100%;max-height:95%}.layout-gt-sm-row>.flex-gt-sm-95{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:95%;max-height:100%;box-sizing:border-box}.layout-gt-sm-column>.flex-gt-sm-95{max-height:95%}.flex-gt-sm-100,.layout-gt-sm-column>.flex-gt-sm-95{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;box-sizing:border-box}.flex-gt-sm-100{max-height:100%}.layout-column>.flex-gt-sm-100,.layout-gt-sm-column>.flex-gt-sm-100,.layout-gt-sm-row>.flex-gt-sm-100,.layout-row>.flex-gt-sm-100{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;max-height:100%;box-sizing:border-box}.layout-row>.flex-gt-sm-33{-webkit-flex:1 1 33.33%;flex:1 1 33.33%;max-width:33.33%}.layout-row>.flex-gt-sm-33,.layout-row>.flex-gt-sm-66{-webkit-box-flex:1;max-height:100%;box-sizing:border-box}.layout-row>.flex-gt-sm-66{-webkit-flex:1 1 66.66%;flex:1 1 66.66%;max-width:66.66%}.layout-column>.flex-gt-sm-33{-webkit-box-flex:1;-webkit-flex:1 1 33.33%;flex:1 1 33.33%;max-width:100%;max-height:33.33%;box-sizing:border-box}.layout-column>.flex-gt-sm-66{-webkit-box-flex:1;-webkit-flex:1 1 66.66%;flex:1 1 66.66%;max-width:100%;max-height:66.66%;box-sizing:border-box}.layout-gt-sm-row>.flex-gt-sm-33{max-width:33.33%}.layout-gt-sm-row>.flex-gt-sm-33,.layout-gt-sm-row>.flex-gt-sm-66{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-height:100%;box-sizing:border-box}.layout-gt-sm-row>.flex-gt-sm-66{max-width:66.66%}.layout-gt-sm-row>.flex{min-width:0}.layout-gt-sm-column>.flex-gt-sm-33{max-height:33.33%}.layout-gt-sm-column>.flex-gt-sm-33,.layout-gt-sm-column>.flex-gt-sm-66{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;box-sizing:border-box}.layout-gt-sm-column>.flex-gt-sm-66{max-height:66.66%}.layout-gt-sm-column>.flex{min-height:0}.layout-gt-sm,.layout-gt-sm-column,.layout-gt-sm-row{box-sizing:border-box;display:-webkit-box;display:-webkit-flex;display:flex}.layout-gt-sm-column{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column}.layout-gt-sm-row{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;flex-direction:row}}@media (min-width:960px) and (max-width:1279px){.hide-gt-sm:not(.show-gt-xs):not(.show-gt-sm):not(.show-md):not(.show),.hide-gt-xs:not(.show-gt-xs):not(.show-gt-sm):not(.show-md):not(.show),.hide-md:not(.show-md):not(.show-gt-sm):not(.show-gt-xs):not(.show),.hide:not(.show-gt-xs):not(.show-gt-sm):not(.show-md):not(.show){display:none}.flex-order-md--20{-webkit-box-ordinal-group:-19;-webkit-order:-20;order:-20}.flex-order-md--19{-webkit-box-ordinal-group:-18;-webkit-order:-19;order:-19}.flex-order-md--18{-webkit-box-ordinal-group:-17;-webkit-order:-18;order:-18}.flex-order-md--17{-webkit-box-ordinal-group:-16;-webkit-order:-17;order:-17}.flex-order-md--16{-webkit-box-ordinal-group:-15;-webkit-order:-16;order:-16}.flex-order-md--15{-webkit-box-ordinal-group:-14;-webkit-order:-15;order:-15}.flex-order-md--14{-webkit-box-ordinal-group:-13;-webkit-order:-14;order:-14}.flex-order-md--13{-webkit-box-ordinal-group:-12;-webkit-order:-13;order:-13}.flex-order-md--12{-webkit-box-ordinal-group:-11;-webkit-order:-12;order:-12}.flex-order-md--11{-webkit-box-ordinal-group:-10;-webkit-order:-11;order:-11}.flex-order-md--10{-webkit-box-ordinal-group:-9;-webkit-order:-10;order:-10}.flex-order-md--9{-webkit-box-ordinal-group:-8;-webkit-order:-9;order:-9}.flex-order-md--8{-webkit-box-ordinal-group:-7;-webkit-order:-8;order:-8}.flex-order-md--7{-webkit-box-ordinal-group:-6;-webkit-order:-7;order:-7}.flex-order-md--6{-webkit-box-ordinal-group:-5;-webkit-order:-6;order:-6}.flex-order-md--5{-webkit-box-ordinal-group:-4;-webkit-order:-5;order:-5}.flex-order-md--4{-webkit-box-ordinal-group:-3;-webkit-order:-4;order:-4}.flex-order-md--3{-webkit-box-ordinal-group:-2;-webkit-order:-3;order:-3}.flex-order-md--2{-webkit-box-ordinal-group:-1;-webkit-order:-2;order:-2}.flex-order-md--1{-webkit-box-ordinal-group:0;-webkit-order:-1;order:-1}.flex-order-md-0{-webkit-box-ordinal-group:1;-webkit-order:0;order:0}.flex-order-md-1{-webkit-box-ordinal-group:2;-webkit-order:1;order:1}.flex-order-md-2{-webkit-box-ordinal-group:3;-webkit-order:2;order:2}.flex-order-md-3{-webkit-box-ordinal-group:4;-webkit-order:3;order:3}.flex-order-md-4{-webkit-box-ordinal-group:5;-webkit-order:4;order:4}.flex-order-md-5{-webkit-box-ordinal-group:6;-webkit-order:5;order:5}.flex-order-md-6{-webkit-box-ordinal-group:7;-webkit-order:6;order:6}.flex-order-md-7{-webkit-box-ordinal-group:8;-webkit-order:7;order:7}.flex-order-md-8{-webkit-box-ordinal-group:9;-webkit-order:8;order:8}.flex-order-md-9{-webkit-box-ordinal-group:10;-webkit-order:9;order:9}.flex-order-md-10{-webkit-box-ordinal-group:11;-webkit-order:10;order:10}.flex-order-md-11{-webkit-box-ordinal-group:12;-webkit-order:11;order:11}.flex-order-md-12{-webkit-box-ordinal-group:13;-webkit-order:12;order:12}.flex-order-md-13{-webkit-box-ordinal-group:14;-webkit-order:13;order:13}.flex-order-md-14{-webkit-box-ordinal-group:15;-webkit-order:14;order:14}.flex-order-md-15{-webkit-box-ordinal-group:16;-webkit-order:15;order:15}.flex-order-md-16{-webkit-box-ordinal-group:17;-webkit-order:16;order:16}.flex-order-md-17{-webkit-box-ordinal-group:18;-webkit-order:17;order:17}.flex-order-md-18{-webkit-box-ordinal-group:19;-webkit-order:18;order:18}.flex-order-md-19{-webkit-box-ordinal-group:20;-webkit-order:19;order:19}.flex-order-md-20{-webkit-box-ordinal-group:21;-webkit-order:20;order:20}.flex-offset-md-0,.offset-md-0{margin-left:0}[dir=rtl] .flex-offset-md-0,[dir=rtl] .offset-md-0{margin-left:auto;margin-right:0}.flex-offset-md-5,.offset-md-5{margin-left:5%}[dir=rtl] .flex-offset-md-5,[dir=rtl] .offset-md-5{margin-left:auto;margin-right:5%}.flex-offset-md-10,.offset-md-10{margin-left:10%}[dir=rtl] .flex-offset-md-10,[dir=rtl] .offset-md-10{margin-left:auto;margin-right:10%}.flex-offset-md-15,.offset-md-15{margin-left:15%}[dir=rtl] .flex-offset-md-15,[dir=rtl] .offset-md-15{margin-left:auto;margin-right:15%}.flex-offset-md-20,.offset-md-20{margin-left:20%}[dir=rtl] .flex-offset-md-20,[dir=rtl] .offset-md-20{margin-left:auto;margin-right:20%}.flex-offset-md-25,.offset-md-25{margin-left:25%}[dir=rtl] .flex-offset-md-25,[dir=rtl] .offset-md-25{margin-left:auto;margin-right:25%}.flex-offset-md-30,.offset-md-30{margin-left:30%}[dir=rtl] .flex-offset-md-30,[dir=rtl] .offset-md-30{margin-left:auto;margin-right:30%}.flex-offset-md-35,.offset-md-35{margin-left:35%}[dir=rtl] .flex-offset-md-35,[dir=rtl] .offset-md-35{margin-left:auto;margin-right:35%}.flex-offset-md-40,.offset-md-40{margin-left:40%}[dir=rtl] .flex-offset-md-40,[dir=rtl] .offset-md-40{margin-left:auto;margin-right:40%}.flex-offset-md-45,.offset-md-45{margin-left:45%}[dir=rtl] .flex-offset-md-45,[dir=rtl] .offset-md-45{margin-left:auto;margin-right:45%}.flex-offset-md-50,.offset-md-50{margin-left:50%}[dir=rtl] .flex-offset-md-50,[dir=rtl] .offset-md-50{margin-left:auto;margin-right:50%}.flex-offset-md-55,.offset-md-55{margin-left:55%}[dir=rtl] .flex-offset-md-55,[dir=rtl] .offset-md-55{margin-left:auto;margin-right:55%}.flex-offset-md-60,.offset-md-60{margin-left:60%}[dir=rtl] .flex-offset-md-60,[dir=rtl] .offset-md-60{margin-left:auto;margin-right:60%}.flex-offset-md-65,.offset-md-65{margin-left:65%}[dir=rtl] .flex-offset-md-65,[dir=rtl] .offset-md-65{margin-left:auto;margin-right:65%}.flex-offset-md-70,.offset-md-70{margin-left:70%}[dir=rtl] .flex-offset-md-70,[dir=rtl] .offset-md-70{margin-left:auto;margin-right:70%}.flex-offset-md-75,.offset-md-75{margin-left:75%}[dir=rtl] .flex-offset-md-75,[dir=rtl] .offset-md-75{margin-left:auto;margin-right:75%}.flex-offset-md-80,.offset-md-80{margin-left:80%}[dir=rtl] .flex-offset-md-80,[dir=rtl] .offset-md-80{margin-left:auto;margin-right:80%}.flex-offset-md-85,.offset-md-85{margin-left:85%}[dir=rtl] .flex-offset-md-85,[dir=rtl] .offset-md-85{margin-left:auto;margin-right:85%}.flex-offset-md-90,.offset-md-90{margin-left:90%}[dir=rtl] .flex-offset-md-90,[dir=rtl] .offset-md-90{margin-left:auto;margin-right:90%}.flex-offset-md-95,.offset-md-95{margin-left:95%}[dir=rtl] .flex-offset-md-95,[dir=rtl] .offset-md-95{margin-left:auto;margin-right:95%}.flex-offset-md-33,.offset-md-33{margin-left:33.33333%}.flex-offset-md-66,.offset-md-66{margin-left:66.66667%}[dir=rtl] .flex-offset-md-66,[dir=rtl] .offset-md-66{margin-left:auto;margin-right:66.66667%}.layout-align-md,.layout-align-md-start-stretch{-webkit-align-content:stretch;align-content:stretch;-webkit-box-align:stretch;-webkit-align-items:stretch;align-items:stretch}.layout-align-md,.layout-align-md-start,.layout-align-md-start-center,.layout-align-md-start-end,.layout-align-md-start-start,.layout-align-md-start-stretch{-webkit-box-pack:start;-webkit-justify-content:flex-start;justify-content:flex-start}.layout-align-md-center,.layout-align-md-center-center,.layout-align-md-center-end,.layout-align-md-center-start,.layout-align-md-center-stretch{-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center}.layout-align-md-end,.layout-align-md-end-center,.layout-align-md-end-end,.layout-align-md-end-start,.layout-align-md-end-stretch{-webkit-box-pack:end;-webkit-justify-content:flex-end;justify-content:flex-end}.layout-align-md-space-around,.layout-align-md-space-around-center,.layout-align-md-space-around-end,.layout-align-md-space-around-start,.layout-align-md-space-around-stretch{-webkit-justify-content:space-around;justify-content:space-around}.layout-align-md-space-between,.layout-align-md-space-between-center,.layout-align-md-space-between-end,.layout-align-md-space-between-start,.layout-align-md-space-between-stretch{-webkit-box-pack:justify;-webkit-justify-content:space-between;justify-content:space-between}.layout-align-md-center-start,.layout-align-md-end-start,.layout-align-md-space-around-start,.layout-align-md-space-between-start,.layout-align-md-start-start{-webkit-box-align:start;-webkit-align-items:flex-start;align-items:flex-start;-webkit-align-content:flex-start;align-content:flex-start}.layout-align-md-center-center,.layout-align-md-end-center,.layout-align-md-space-around-center,.layout-align-md-space-between-center,.layout-align-md-start-center{-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-align-content:center;align-content:center;max-width:100%}.layout-align-md-center-center>*,.layout-align-md-end-center>*,.layout-align-md-space-around-center>*,.layout-align-md-space-between-center>*,.layout-align-md-start-center>*{max-width:100%;box-sizing:border-box}.layout-align-md-center-end,.layout-align-md-end-end,.layout-align-md-space-around-end,.layout-align-md-space-between-end,.layout-align-md-start-end{-webkit-box-align:end;-webkit-align-items:flex-end;align-items:flex-end;-webkit-align-content:flex-end;align-content:flex-end}.layout-align-md-center-stretch,.layout-align-md-end-stretch,.layout-align-md-space-around-stretch,.layout-align-md-space-between-stretch,.layout-align-md-start-stretch{-webkit-box-align:stretch;-webkit-align-items:stretch;align-items:stretch;-webkit-align-content:stretch;align-content:stretch}.flex-md{-webkit-flex:1;flex:1}.flex-md,.flex-md-grow{-webkit-box-flex:1;box-sizing:border-box}.flex-md-grow{-webkit-flex:1 1 100%;flex:1 1 100%}.flex-md-initial{-webkit-box-flex:0;-webkit-flex:0 1 auto;flex:0 1 auto;box-sizing:border-box}.flex-md-auto{-webkit-box-flex:1;-webkit-flex:1 1 auto;flex:1 1 auto;box-sizing:border-box}.flex-md-none{-webkit-box-flex:0;-webkit-flex:0 0 auto;flex:0 0 auto;box-sizing:border-box}.flex-md-noshrink{-webkit-box-flex:1;-webkit-flex:1 0 auto;flex:1 0 auto;box-sizing:border-box}.flex-md-nogrow{-webkit-box-flex:0;-webkit-flex:0 1 auto;flex:0 1 auto;box-sizing:border-box}.flex-md-0,.layout-row>.flex-md-0{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:0;max-height:100%;box-sizing:border-box}.layout-row>.flex-md-0{min-width:0}.layout-column>.flex-md-0{max-width:100%;max-height:0%}.layout-column>.flex-md-0,.layout-md-row>.flex-md-0{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-md-row>.flex-md-0{max-width:0;max-height:100%;min-width:0}.layout-md-column>.flex-md-0{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;max-height:0%;box-sizing:border-box;min-height:0}.flex-md-5,.layout-row>.flex-md-5{max-width:5%;max-height:100%}.flex-md-5,.layout-column>.flex-md-5,.layout-row>.flex-md-5{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-md-5{max-width:100%;max-height:5%}.layout-md-row>.flex-md-5{max-width:5%;max-height:100%}.layout-md-column>.flex-md-5,.layout-md-row>.flex-md-5{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-md-column>.flex-md-5{max-width:100%;max-height:5%}.flex-md-10,.layout-row>.flex-md-10{max-width:10%;max-height:100%}.flex-md-10,.layout-column>.flex-md-10,.layout-row>.flex-md-10{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-md-10{max-width:100%;max-height:10%}.layout-md-row>.flex-md-10{max-width:10%;max-height:100%}.layout-md-column>.flex-md-10,.layout-md-row>.flex-md-10{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-md-column>.flex-md-10{max-width:100%;max-height:10%}.flex-md-15,.layout-row>.flex-md-15{max-width:15%;max-height:100%}.flex-md-15,.layout-column>.flex-md-15,.layout-row>.flex-md-15{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-md-15{max-width:100%;max-height:15%}.layout-md-row>.flex-md-15{max-width:15%;max-height:100%}.layout-md-column>.flex-md-15,.layout-md-row>.flex-md-15{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-md-column>.flex-md-15{max-width:100%;max-height:15%}.flex-md-20,.layout-row>.flex-md-20{max-width:20%;max-height:100%}.flex-md-20,.layout-column>.flex-md-20,.layout-row>.flex-md-20{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-md-20{max-width:100%;max-height:20%}.layout-md-row>.flex-md-20{max-width:20%;max-height:100%}.layout-md-column>.flex-md-20,.layout-md-row>.flex-md-20{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-md-column>.flex-md-20{max-width:100%;max-height:20%}.flex-md-25,.layout-row>.flex-md-25{max-width:25%;max-height:100%}.flex-md-25,.layout-column>.flex-md-25,.layout-row>.flex-md-25{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-md-25{max-width:100%;max-height:25%}.layout-md-row>.flex-md-25{max-width:25%;max-height:100%}.layout-md-column>.flex-md-25,.layout-md-row>.flex-md-25{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-md-column>.flex-md-25{max-width:100%;max-height:25%}.flex-md-30,.layout-row>.flex-md-30{max-width:30%;max-height:100%}.flex-md-30,.layout-column>.flex-md-30,.layout-row>.flex-md-30{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-md-30{max-width:100%;max-height:30%}.layout-md-row>.flex-md-30{max-width:30%;max-height:100%}.layout-md-column>.flex-md-30,.layout-md-row>.flex-md-30{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-md-column>.flex-md-30{max-width:100%;max-height:30%}.flex-md-35,.layout-row>.flex-md-35{max-width:35%;max-height:100%}.flex-md-35,.layout-column>.flex-md-35,.layout-row>.flex-md-35{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-md-35{max-width:100%;max-height:35%}.layout-md-row>.flex-md-35{max-width:35%;max-height:100%}.layout-md-column>.flex-md-35,.layout-md-row>.flex-md-35{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-md-column>.flex-md-35{max-width:100%;max-height:35%}.flex-md-40,.layout-row>.flex-md-40{max-width:40%;max-height:100%}.flex-md-40,.layout-column>.flex-md-40,.layout-row>.flex-md-40{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-md-40{max-width:100%;max-height:40%}.layout-md-row>.flex-md-40{max-width:40%;max-height:100%}.layout-md-column>.flex-md-40,.layout-md-row>.flex-md-40{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-md-column>.flex-md-40{max-width:100%;max-height:40%}.flex-md-45,.layout-row>.flex-md-45{max-width:45%;max-height:100%}.flex-md-45,.layout-column>.flex-md-45,.layout-row>.flex-md-45{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-md-45{max-width:100%;max-height:45%}.layout-md-row>.flex-md-45{max-width:45%;max-height:100%}.layout-md-column>.flex-md-45,.layout-md-row>.flex-md-45{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-md-column>.flex-md-45{max-width:100%;max-height:45%}.flex-md-50,.layout-row>.flex-md-50{max-width:50%;max-height:100%}.flex-md-50,.layout-column>.flex-md-50,.layout-row>.flex-md-50{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-md-50{max-width:100%;max-height:50%}.layout-md-row>.flex-md-50{max-width:50%;max-height:100%}.layout-md-column>.flex-md-50,.layout-md-row>.flex-md-50{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-md-column>.flex-md-50{max-width:100%;max-height:50%}.flex-md-55,.layout-row>.flex-md-55{max-width:55%;max-height:100%}.flex-md-55,.layout-column>.flex-md-55,.layout-row>.flex-md-55{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-md-55{max-width:100%;max-height:55%}.layout-md-row>.flex-md-55{max-width:55%;max-height:100%}.layout-md-column>.flex-md-55,.layout-md-row>.flex-md-55{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-md-column>.flex-md-55{max-width:100%;max-height:55%}.flex-md-60,.layout-row>.flex-md-60{max-width:60%;max-height:100%}.flex-md-60,.layout-column>.flex-md-60,.layout-row>.flex-md-60{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-md-60{max-width:100%;max-height:60%}.layout-md-row>.flex-md-60{max-width:60%;max-height:100%}.layout-md-column>.flex-md-60,.layout-md-row>.flex-md-60{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-md-column>.flex-md-60{max-width:100%;max-height:60%}.flex-md-65,.layout-row>.flex-md-65{max-width:65%;max-height:100%}.flex-md-65,.layout-column>.flex-md-65,.layout-row>.flex-md-65{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-md-65{max-width:100%;max-height:65%}.layout-md-row>.flex-md-65{max-width:65%;max-height:100%}.layout-md-column>.flex-md-65,.layout-md-row>.flex-md-65{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-md-column>.flex-md-65{max-width:100%;max-height:65%}.flex-md-70,.layout-row>.flex-md-70{max-width:70%;max-height:100%}.flex-md-70,.layout-column>.flex-md-70,.layout-row>.flex-md-70{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-md-70{max-width:100%;max-height:70%}.layout-md-row>.flex-md-70{max-width:70%;max-height:100%}.layout-md-column>.flex-md-70,.layout-md-row>.flex-md-70{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-md-column>.flex-md-70{max-width:100%;max-height:70%}.flex-md-75,.layout-row>.flex-md-75{max-width:75%;max-height:100%}.flex-md-75,.layout-column>.flex-md-75,.layout-row>.flex-md-75{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-md-75{max-width:100%;max-height:75%}.layout-md-row>.flex-md-75{max-width:75%;max-height:100%}.layout-md-column>.flex-md-75,.layout-md-row>.flex-md-75{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-md-column>.flex-md-75{max-width:100%;max-height:75%}.flex-md-80,.layout-row>.flex-md-80{max-width:80%;max-height:100%}.flex-md-80,.layout-column>.flex-md-80,.layout-row>.flex-md-80{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-md-80{max-width:100%;max-height:80%}.layout-md-row>.flex-md-80{max-width:80%;max-height:100%}.layout-md-column>.flex-md-80,.layout-md-row>.flex-md-80{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-md-column>.flex-md-80{max-width:100%;max-height:80%}.flex-md-85,.layout-row>.flex-md-85{max-width:85%;max-height:100%}.flex-md-85,.layout-column>.flex-md-85,.layout-row>.flex-md-85{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-md-85{max-width:100%;max-height:85%}.layout-md-row>.flex-md-85{max-width:85%;max-height:100%}.layout-md-column>.flex-md-85,.layout-md-row>.flex-md-85{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-md-column>.flex-md-85{max-width:100%;max-height:85%}.flex-md-90,.layout-row>.flex-md-90{max-width:90%;max-height:100%}.flex-md-90,.layout-column>.flex-md-90,.layout-row>.flex-md-90{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-md-90{max-width:100%;max-height:90%}.layout-md-row>.flex-md-90{max-width:90%;max-height:100%}.layout-md-column>.flex-md-90,.layout-md-row>.flex-md-90{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-md-column>.flex-md-90{max-width:100%;max-height:90%}.flex-md-95,.layout-row>.flex-md-95{max-width:95%;max-height:100%}.flex-md-95,.layout-column>.flex-md-95,.layout-row>.flex-md-95{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-md-95{max-width:100%;max-height:95%}.layout-md-row>.flex-md-95{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:95%;max-height:100%;box-sizing:border-box}.layout-md-column>.flex-md-95{max-height:95%}.flex-md-100,.layout-md-column>.flex-md-95{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;box-sizing:border-box}.flex-md-100{max-height:100%}.layout-column>.flex-md-100,.layout-md-column>.flex-md-100,.layout-md-row>.flex-md-100,.layout-row>.flex-md-100{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;max-height:100%;box-sizing:border-box}.layout-row>.flex-md-33{-webkit-flex:1 1 33.33%;flex:1 1 33.33%;max-width:33.33%}.layout-row>.flex-md-33,.layout-row>.flex-md-66{-webkit-box-flex:1;max-height:100%;box-sizing:border-box}.layout-row>.flex-md-66{-webkit-flex:1 1 66.66%;flex:1 1 66.66%;max-width:66.66%}.layout-column>.flex-md-33{-webkit-flex:1 1 33.33%;flex:1 1 33.33%;max-height:33.33%}.layout-column>.flex-md-33,.layout-column>.flex-md-66{-webkit-box-flex:1;max-width:100%;box-sizing:border-box}.layout-column>.flex-md-66{-webkit-flex:1 1 66.66%;flex:1 1 66.66%;max-height:66.66%}.layout-md-row>.flex-md-33{max-width:33.33%}.layout-md-row>.flex-md-33,.layout-md-row>.flex-md-66{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-height:100%;box-sizing:border-box}.layout-md-row>.flex-md-66{max-width:66.66%}.layout-md-row>.flex{min-width:0}.layout-md-column>.flex-md-33{max-height:33.33%}.layout-md-column>.flex-md-33,.layout-md-column>.flex-md-66{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;box-sizing:border-box}.layout-md-column>.flex-md-66{max-height:66.66%}.layout-md-column>.flex{min-height:0}.layout-md,.layout-md-column,.layout-md-row{box-sizing:border-box;display:-webkit-box;display:-webkit-flex;display:flex}.layout-md-column{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column}.layout-md-row{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;flex-direction:row}}@media (min-width:1280px){.flex-order-gt-md--20{-webkit-box-ordinal-group:-19;-webkit-order:-20;order:-20}.flex-order-gt-md--19{-webkit-box-ordinal-group:-18;-webkit-order:-19;order:-19}.flex-order-gt-md--18{-webkit-box-ordinal-group:-17;-webkit-order:-18;order:-18}.flex-order-gt-md--17{-webkit-box-ordinal-group:-16;-webkit-order:-17;order:-17}.flex-order-gt-md--16{-webkit-box-ordinal-group:-15;-webkit-order:-16;order:-16}.flex-order-gt-md--15{-webkit-box-ordinal-group:-14;-webkit-order:-15;order:-15}.flex-order-gt-md--14{-webkit-box-ordinal-group:-13;-webkit-order:-14;order:-14}.flex-order-gt-md--13{-webkit-box-ordinal-group:-12;-webkit-order:-13;order:-13}.flex-order-gt-md--12{-webkit-box-ordinal-group:-11;-webkit-order:-12;order:-12}.flex-order-gt-md--11{-webkit-box-ordinal-group:-10;-webkit-order:-11;order:-11}.flex-order-gt-md--10{-webkit-box-ordinal-group:-9;-webkit-order:-10;order:-10}.flex-order-gt-md--9{-webkit-box-ordinal-group:-8;-webkit-order:-9;order:-9}.flex-order-gt-md--8{-webkit-box-ordinal-group:-7;-webkit-order:-8;order:-8}.flex-order-gt-md--7{-webkit-box-ordinal-group:-6;-webkit-order:-7;order:-7}.flex-order-gt-md--6{-webkit-box-ordinal-group:-5;-webkit-order:-6;order:-6}.flex-order-gt-md--5{-webkit-box-ordinal-group:-4;-webkit-order:-5;order:-5}.flex-order-gt-md--4{-webkit-box-ordinal-group:-3;-webkit-order:-4;order:-4}.flex-order-gt-md--3{-webkit-box-ordinal-group:-2;-webkit-order:-3;order:-3}.flex-order-gt-md--2{-webkit-box-ordinal-group:-1;-webkit-order:-2;order:-2}.flex-order-gt-md--1{-webkit-box-ordinal-group:0;-webkit-order:-1;order:-1}.flex-order-gt-md-0{-webkit-box-ordinal-group:1;-webkit-order:0;order:0}.flex-order-gt-md-1{-webkit-box-ordinal-group:2;-webkit-order:1;order:1}.flex-order-gt-md-2{-webkit-box-ordinal-group:3;-webkit-order:2;order:2}.flex-order-gt-md-3{-webkit-box-ordinal-group:4;-webkit-order:3;order:3}.flex-order-gt-md-4{-webkit-box-ordinal-group:5;-webkit-order:4;order:4}.flex-order-gt-md-5{-webkit-box-ordinal-group:6;-webkit-order:5;order:5}.flex-order-gt-md-6{-webkit-box-ordinal-group:7;-webkit-order:6;order:6}.flex-order-gt-md-7{-webkit-box-ordinal-group:8;-webkit-order:7;order:7}.flex-order-gt-md-8{-webkit-box-ordinal-group:9;-webkit-order:8;order:8}.flex-order-gt-md-9{-webkit-box-ordinal-group:10;-webkit-order:9;order:9}.flex-order-gt-md-10{-webkit-box-ordinal-group:11;-webkit-order:10;order:10}.flex-order-gt-md-11{-webkit-box-ordinal-group:12;-webkit-order:11;order:11}.flex-order-gt-md-12{-webkit-box-ordinal-group:13;-webkit-order:12;order:12}.flex-order-gt-md-13{-webkit-box-ordinal-group:14;-webkit-order:13;order:13}.flex-order-gt-md-14{-webkit-box-ordinal-group:15;-webkit-order:14;order:14}.flex-order-gt-md-15{-webkit-box-ordinal-group:16;-webkit-order:15;order:15}.flex-order-gt-md-16{-webkit-box-ordinal-group:17;-webkit-order:16;order:16}.flex-order-gt-md-17{-webkit-box-ordinal-group:18;-webkit-order:17;order:17}.flex-order-gt-md-18{-webkit-box-ordinal-group:19;-webkit-order:18;order:18}.flex-order-gt-md-19{-webkit-box-ordinal-group:20;-webkit-order:19;order:19}.flex-order-gt-md-20{-webkit-box-ordinal-group:21;-webkit-order:20;order:20}.flex-offset-gt-md-0,.offset-gt-md-0{margin-left:0}[dir=rtl] .flex-offset-gt-md-0,[dir=rtl] .offset-gt-md-0{margin-left:auto;margin-right:0}.flex-offset-gt-md-5,.offset-gt-md-5{margin-left:5%}[dir=rtl] .flex-offset-gt-md-5,[dir=rtl] .offset-gt-md-5{margin-left:auto;margin-right:5%}.flex-offset-gt-md-10,.offset-gt-md-10{margin-left:10%}[dir=rtl] .flex-offset-gt-md-10,[dir=rtl] .offset-gt-md-10{margin-left:auto;margin-right:10%}.flex-offset-gt-md-15,.offset-gt-md-15{margin-left:15%}[dir=rtl] .flex-offset-gt-md-15,[dir=rtl] .offset-gt-md-15{margin-left:auto;margin-right:15%}.flex-offset-gt-md-20,.offset-gt-md-20{margin-left:20%}[dir=rtl] .flex-offset-gt-md-20,[dir=rtl] .offset-gt-md-20{margin-left:auto;margin-right:20%}.flex-offset-gt-md-25,.offset-gt-md-25{margin-left:25%}[dir=rtl] .flex-offset-gt-md-25,[dir=rtl] .offset-gt-md-25{margin-left:auto;margin-right:25%}.flex-offset-gt-md-30,.offset-gt-md-30{margin-left:30%}[dir=rtl] .flex-offset-gt-md-30,[dir=rtl] .offset-gt-md-30{margin-left:auto;margin-right:30%}.flex-offset-gt-md-35,.offset-gt-md-35{margin-left:35%}[dir=rtl] .flex-offset-gt-md-35,[dir=rtl] .offset-gt-md-35{margin-left:auto;margin-right:35%}.flex-offset-gt-md-40,.offset-gt-md-40{margin-left:40%}[dir=rtl] .flex-offset-gt-md-40,[dir=rtl] .offset-gt-md-40{margin-left:auto;margin-right:40%}.flex-offset-gt-md-45,.offset-gt-md-45{margin-left:45%}[dir=rtl] .flex-offset-gt-md-45,[dir=rtl] .offset-gt-md-45{margin-left:auto;margin-right:45%}.flex-offset-gt-md-50,.offset-gt-md-50{margin-left:50%}[dir=rtl] .flex-offset-gt-md-50,[dir=rtl] .offset-gt-md-50{margin-left:auto;margin-right:50%}.flex-offset-gt-md-55,.offset-gt-md-55{margin-left:55%}[dir=rtl] .flex-offset-gt-md-55,[dir=rtl] .offset-gt-md-55{margin-left:auto;margin-right:55%}.flex-offset-gt-md-60,.offset-gt-md-60{margin-left:60%}[dir=rtl] .flex-offset-gt-md-60,[dir=rtl] .offset-gt-md-60{margin-left:auto;margin-right:60%}.flex-offset-gt-md-65,.offset-gt-md-65{margin-left:65%}[dir=rtl] .flex-offset-gt-md-65,[dir=rtl] .offset-gt-md-65{margin-left:auto;margin-right:65%}.flex-offset-gt-md-70,.offset-gt-md-70{margin-left:70%}[dir=rtl] .flex-offset-gt-md-70,[dir=rtl] .offset-gt-md-70{margin-left:auto;margin-right:70%}.flex-offset-gt-md-75,.offset-gt-md-75{margin-left:75%}[dir=rtl] .flex-offset-gt-md-75,[dir=rtl] .offset-gt-md-75{margin-left:auto;margin-right:75%}.flex-offset-gt-md-80,.offset-gt-md-80{margin-left:80%}[dir=rtl] .flex-offset-gt-md-80,[dir=rtl] .offset-gt-md-80{margin-left:auto;margin-right:80%}.flex-offset-gt-md-85,.offset-gt-md-85{margin-left:85%}[dir=rtl] .flex-offset-gt-md-85,[dir=rtl] .offset-gt-md-85{margin-left:auto;margin-right:85%}.flex-offset-gt-md-90,.offset-gt-md-90{margin-left:90%}[dir=rtl] .flex-offset-gt-md-90,[dir=rtl] .offset-gt-md-90{margin-left:auto;margin-right:90%}.flex-offset-gt-md-95,.offset-gt-md-95{margin-left:95%}[dir=rtl] .flex-offset-gt-md-95,[dir=rtl] .offset-gt-md-95{margin-left:auto;margin-right:95%}.flex-offset-gt-md-33,.offset-gt-md-33{margin-left:33.33333%}.flex-offset-gt-md-66,.offset-gt-md-66{margin-left:66.66667%}[dir=rtl] .flex-offset-gt-md-66,[dir=rtl] .offset-gt-md-66{margin-left:auto;margin-right:66.66667%}.layout-align-gt-md,.layout-align-gt-md-start-stretch{-webkit-align-content:stretch;align-content:stretch;-webkit-box-align:stretch;-webkit-align-items:stretch;align-items:stretch}.layout-align-gt-md,.layout-align-gt-md-start,.layout-align-gt-md-start-center,.layout-align-gt-md-start-end,.layout-align-gt-md-start-start,.layout-align-gt-md-start-stretch{-webkit-box-pack:start;-webkit-justify-content:flex-start;justify-content:flex-start}.layout-align-gt-md-center,.layout-align-gt-md-center-center,.layout-align-gt-md-center-end,.layout-align-gt-md-center-start,.layout-align-gt-md-center-stretch{-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center}.layout-align-gt-md-end,.layout-align-gt-md-end-center,.layout-align-gt-md-end-end,.layout-align-gt-md-end-start,.layout-align-gt-md-end-stretch{-webkit-box-pack:end;-webkit-justify-content:flex-end;justify-content:flex-end}.layout-align-gt-md-space-around,.layout-align-gt-md-space-around-center,.layout-align-gt-md-space-around-end,.layout-align-gt-md-space-around-start,.layout-align-gt-md-space-around-stretch{-webkit-justify-content:space-around;justify-content:space-around}.layout-align-gt-md-space-between,.layout-align-gt-md-space-between-center,.layout-align-gt-md-space-between-end,.layout-align-gt-md-space-between-start,.layout-align-gt-md-space-between-stretch{-webkit-box-pack:justify;-webkit-justify-content:space-between;justify-content:space-between}.layout-align-gt-md-center-start,.layout-align-gt-md-end-start,.layout-align-gt-md-space-around-start,.layout-align-gt-md-space-between-start,.layout-align-gt-md-start-start{-webkit-box-align:start;-webkit-align-items:flex-start;align-items:flex-start;-webkit-align-content:flex-start;align-content:flex-start}.layout-align-gt-md-center-center,.layout-align-gt-md-end-center,.layout-align-gt-md-space-around-center,.layout-align-gt-md-space-between-center,.layout-align-gt-md-start-center{-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-align-content:center;align-content:center;max-width:100%}.layout-align-gt-md-center-center>*,.layout-align-gt-md-end-center>*,.layout-align-gt-md-space-around-center>*,.layout-align-gt-md-space-between-center>*,.layout-align-gt-md-start-center>*{max-width:100%;box-sizing:border-box}.layout-align-gt-md-center-end,.layout-align-gt-md-end-end,.layout-align-gt-md-space-around-end,.layout-align-gt-md-space-between-end,.layout-align-gt-md-start-end{-webkit-box-align:end;-webkit-align-items:flex-end;align-items:flex-end;-webkit-align-content:flex-end;align-content:flex-end}.layout-align-gt-md-center-stretch,.layout-align-gt-md-end-stretch,.layout-align-gt-md-space-around-stretch,.layout-align-gt-md-space-between-stretch,.layout-align-gt-md-start-stretch{-webkit-box-align:stretch;-webkit-align-items:stretch;align-items:stretch;-webkit-align-content:stretch;align-content:stretch}.flex-gt-md{-webkit-flex:1;flex:1}.flex-gt-md,.flex-gt-md-grow{-webkit-box-flex:1;box-sizing:border-box}.flex-gt-md-grow{-webkit-flex:1 1 100%;flex:1 1 100%}.flex-gt-md-initial{-webkit-box-flex:0;-webkit-flex:0 1 auto;flex:0 1 auto;box-sizing:border-box}.flex-gt-md-auto{-webkit-box-flex:1;-webkit-flex:1 1 auto;flex:1 1 auto;box-sizing:border-box}.flex-gt-md-none{-webkit-box-flex:0;-webkit-flex:0 0 auto;flex:0 0 auto;box-sizing:border-box}.flex-gt-md-noshrink{-webkit-box-flex:1;-webkit-flex:1 0 auto;flex:1 0 auto;box-sizing:border-box}.flex-gt-md-nogrow{-webkit-box-flex:0;-webkit-flex:0 1 auto;flex:0 1 auto;box-sizing:border-box}.flex-gt-md-0,.layout-row>.flex-gt-md-0{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:0;max-height:100%;box-sizing:border-box}.layout-row>.flex-gt-md-0{min-width:0}.layout-column>.flex-gt-md-0{max-width:100%;max-height:0%}.layout-column>.flex-gt-md-0,.layout-gt-md-row>.flex-gt-md-0{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-md-row>.flex-gt-md-0{max-width:0;max-height:100%;min-width:0}.layout-gt-md-column>.flex-gt-md-0{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;max-height:0%;box-sizing:border-box;min-height:0}.flex-gt-md-5,.layout-row>.flex-gt-md-5{max-width:5%;max-height:100%}.flex-gt-md-5,.layout-column>.flex-gt-md-5,.layout-row>.flex-gt-md-5{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-md-5{max-width:100%;max-height:5%}.layout-gt-md-row>.flex-gt-md-5{max-width:5%;max-height:100%}.layout-gt-md-column>.flex-gt-md-5,.layout-gt-md-row>.flex-gt-md-5{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-md-column>.flex-gt-md-5{max-width:100%;max-height:5%}.flex-gt-md-10,.layout-row>.flex-gt-md-10{max-width:10%;max-height:100%}.flex-gt-md-10,.layout-column>.flex-gt-md-10,.layout-row>.flex-gt-md-10{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-md-10{max-width:100%;max-height:10%}.layout-gt-md-row>.flex-gt-md-10{max-width:10%;max-height:100%}.layout-gt-md-column>.flex-gt-md-10,.layout-gt-md-row>.flex-gt-md-10{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-md-column>.flex-gt-md-10{max-width:100%;max-height:10%}.flex-gt-md-15,.layout-row>.flex-gt-md-15{max-width:15%;max-height:100%}.flex-gt-md-15,.layout-column>.flex-gt-md-15,.layout-row>.flex-gt-md-15{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-md-15{max-width:100%;max-height:15%}.layout-gt-md-row>.flex-gt-md-15{max-width:15%;max-height:100%}.layout-gt-md-column>.flex-gt-md-15,.layout-gt-md-row>.flex-gt-md-15{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-md-column>.flex-gt-md-15{max-width:100%;max-height:15%}.flex-gt-md-20,.layout-row>.flex-gt-md-20{max-width:20%;max-height:100%}.flex-gt-md-20,.layout-column>.flex-gt-md-20,.layout-row>.flex-gt-md-20{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-md-20{max-width:100%;max-height:20%}.layout-gt-md-row>.flex-gt-md-20{max-width:20%;max-height:100%}.layout-gt-md-column>.flex-gt-md-20,.layout-gt-md-row>.flex-gt-md-20{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-md-column>.flex-gt-md-20{max-width:100%;max-height:20%}.flex-gt-md-25,.layout-row>.flex-gt-md-25{max-width:25%;max-height:100%}.flex-gt-md-25,.layout-column>.flex-gt-md-25,.layout-row>.flex-gt-md-25{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-md-25{max-width:100%;max-height:25%}.layout-gt-md-row>.flex-gt-md-25{max-width:25%;max-height:100%}.layout-gt-md-column>.flex-gt-md-25,.layout-gt-md-row>.flex-gt-md-25{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-md-column>.flex-gt-md-25{max-width:100%;max-height:25%}.flex-gt-md-30,.layout-row>.flex-gt-md-30{max-width:30%;max-height:100%}.flex-gt-md-30,.layout-column>.flex-gt-md-30,.layout-row>.flex-gt-md-30{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-md-30{max-width:100%;max-height:30%}.layout-gt-md-row>.flex-gt-md-30{max-width:30%;max-height:100%}.layout-gt-md-column>.flex-gt-md-30,.layout-gt-md-row>.flex-gt-md-30{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-md-column>.flex-gt-md-30{max-width:100%;max-height:30%}.flex-gt-md-35,.layout-row>.flex-gt-md-35{max-width:35%;max-height:100%}.flex-gt-md-35,.layout-column>.flex-gt-md-35,.layout-row>.flex-gt-md-35{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-md-35{max-width:100%;max-height:35%}.layout-gt-md-row>.flex-gt-md-35{max-width:35%;max-height:100%}.layout-gt-md-column>.flex-gt-md-35,.layout-gt-md-row>.flex-gt-md-35{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-md-column>.flex-gt-md-35{max-width:100%;max-height:35%}.flex-gt-md-40,.layout-row>.flex-gt-md-40{max-width:40%;max-height:100%}.flex-gt-md-40,.layout-column>.flex-gt-md-40,.layout-row>.flex-gt-md-40{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-md-40{max-width:100%;max-height:40%}.layout-gt-md-row>.flex-gt-md-40{max-width:40%;max-height:100%}.layout-gt-md-column>.flex-gt-md-40,.layout-gt-md-row>.flex-gt-md-40{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-md-column>.flex-gt-md-40{max-width:100%;max-height:40%}.flex-gt-md-45,.layout-row>.flex-gt-md-45{max-width:45%;max-height:100%}.flex-gt-md-45,.layout-column>.flex-gt-md-45,.layout-row>.flex-gt-md-45{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-md-45{max-width:100%;max-height:45%}.layout-gt-md-row>.flex-gt-md-45{max-width:45%;max-height:100%}.layout-gt-md-column>.flex-gt-md-45,.layout-gt-md-row>.flex-gt-md-45{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-md-column>.flex-gt-md-45{max-width:100%;max-height:45%}.flex-gt-md-50,.layout-row>.flex-gt-md-50{max-width:50%;max-height:100%}.flex-gt-md-50,.layout-column>.flex-gt-md-50,.layout-row>.flex-gt-md-50{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-md-50{max-width:100%;max-height:50%}.layout-gt-md-row>.flex-gt-md-50{max-width:50%;max-height:100%}.layout-gt-md-column>.flex-gt-md-50,.layout-gt-md-row>.flex-gt-md-50{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-md-column>.flex-gt-md-50{max-width:100%;max-height:50%}.flex-gt-md-55,.layout-row>.flex-gt-md-55{max-width:55%;max-height:100%}.flex-gt-md-55,.layout-column>.flex-gt-md-55,.layout-row>.flex-gt-md-55{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-md-55{max-width:100%;max-height:55%}.layout-gt-md-row>.flex-gt-md-55{max-width:55%;max-height:100%}.layout-gt-md-column>.flex-gt-md-55,.layout-gt-md-row>.flex-gt-md-55{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-md-column>.flex-gt-md-55{max-width:100%;max-height:55%}.flex-gt-md-60,.layout-row>.flex-gt-md-60{max-width:60%;max-height:100%}.flex-gt-md-60,.layout-column>.flex-gt-md-60,.layout-row>.flex-gt-md-60{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-md-60{max-width:100%;max-height:60%}.layout-gt-md-row>.flex-gt-md-60{max-width:60%;max-height:100%}.layout-gt-md-column>.flex-gt-md-60,.layout-gt-md-row>.flex-gt-md-60{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-md-column>.flex-gt-md-60{max-width:100%;max-height:60%}.flex-gt-md-65,.layout-row>.flex-gt-md-65{max-width:65%;max-height:100%}.flex-gt-md-65,.layout-column>.flex-gt-md-65,.layout-row>.flex-gt-md-65{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-md-65{max-width:100%;max-height:65%}.layout-gt-md-row>.flex-gt-md-65{max-width:65%;max-height:100%}.layout-gt-md-column>.flex-gt-md-65,.layout-gt-md-row>.flex-gt-md-65{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-md-column>.flex-gt-md-65{max-width:100%;max-height:65%}.flex-gt-md-70,.layout-row>.flex-gt-md-70{max-width:70%;max-height:100%}.flex-gt-md-70,.layout-column>.flex-gt-md-70,.layout-row>.flex-gt-md-70{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-md-70{max-width:100%;max-height:70%}.layout-gt-md-row>.flex-gt-md-70{max-width:70%;max-height:100%}.layout-gt-md-column>.flex-gt-md-70,.layout-gt-md-row>.flex-gt-md-70{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-md-column>.flex-gt-md-70{max-width:100%;max-height:70%}.flex-gt-md-75,.layout-row>.flex-gt-md-75{max-width:75%;max-height:100%}.flex-gt-md-75,.layout-column>.flex-gt-md-75,.layout-row>.flex-gt-md-75{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-md-75{max-width:100%;max-height:75%}.layout-gt-md-row>.flex-gt-md-75{max-width:75%;max-height:100%}.layout-gt-md-column>.flex-gt-md-75,.layout-gt-md-row>.flex-gt-md-75{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-md-column>.flex-gt-md-75{max-width:100%;max-height:75%}.flex-gt-md-80,.layout-row>.flex-gt-md-80{max-width:80%;max-height:100%}.flex-gt-md-80,.layout-column>.flex-gt-md-80,.layout-row>.flex-gt-md-80{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-md-80{max-width:100%;max-height:80%}.layout-gt-md-row>.flex-gt-md-80{max-width:80%;max-height:100%}.layout-gt-md-column>.flex-gt-md-80,.layout-gt-md-row>.flex-gt-md-80{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-md-column>.flex-gt-md-80{max-width:100%;max-height:80%}.flex-gt-md-85,.layout-row>.flex-gt-md-85{max-width:85%;max-height:100%}.flex-gt-md-85,.layout-column>.flex-gt-md-85,.layout-row>.flex-gt-md-85{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-md-85{max-width:100%;max-height:85%}.layout-gt-md-row>.flex-gt-md-85{max-width:85%;max-height:100%}.layout-gt-md-column>.flex-gt-md-85,.layout-gt-md-row>.flex-gt-md-85{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-md-column>.flex-gt-md-85{max-width:100%;max-height:85%}.flex-gt-md-90,.layout-row>.flex-gt-md-90{max-width:90%;max-height:100%}.flex-gt-md-90,.layout-column>.flex-gt-md-90,.layout-row>.flex-gt-md-90{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-md-90{max-width:100%;max-height:90%}.layout-gt-md-row>.flex-gt-md-90{max-width:90%;max-height:100%}.layout-gt-md-column>.flex-gt-md-90,.layout-gt-md-row>.flex-gt-md-90{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-md-column>.flex-gt-md-90{max-width:100%;max-height:90%}.flex-gt-md-95,.layout-row>.flex-gt-md-95{max-width:95%;max-height:100%}.flex-gt-md-95,.layout-column>.flex-gt-md-95,.layout-row>.flex-gt-md-95{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-md-95{max-width:100%;max-height:95%}.layout-gt-md-row>.flex-gt-md-95{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:95%;max-height:100%;box-sizing:border-box}.layout-gt-md-column>.flex-gt-md-95{max-height:95%}.flex-gt-md-100,.layout-gt-md-column>.flex-gt-md-95{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;box-sizing:border-box}.flex-gt-md-100{max-height:100%}.layout-column>.flex-gt-md-100,.layout-gt-md-column>.flex-gt-md-100,.layout-gt-md-row>.flex-gt-md-100,.layout-row>.flex-gt-md-100{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;max-height:100%;box-sizing:border-box}.layout-row>.flex-gt-md-33{-webkit-flex:1 1 33.33%;flex:1 1 33.33%;max-width:33.33%}.layout-row>.flex-gt-md-33,.layout-row>.flex-gt-md-66{-webkit-box-flex:1;max-height:100%;box-sizing:border-box}.layout-row>.flex-gt-md-66{-webkit-flex:1 1 66.66%;flex:1 1 66.66%;max-width:66.66%}.layout-column>.flex-gt-md-33{-webkit-box-flex:1;-webkit-flex:1 1 33.33%;flex:1 1 33.33%;max-width:100%;max-height:33.33%;box-sizing:border-box}.layout-column>.flex-gt-md-66{-webkit-box-flex:1;-webkit-flex:1 1 66.66%;flex:1 1 66.66%;max-width:100%;max-height:66.66%;box-sizing:border-box}.layout-gt-md-row>.flex-gt-md-33{max-width:33.33%}.layout-gt-md-row>.flex-gt-md-33,.layout-gt-md-row>.flex-gt-md-66{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-height:100%;box-sizing:border-box}.layout-gt-md-row>.flex-gt-md-66{max-width:66.66%}.layout-gt-md-row>.flex{min-width:0}.layout-gt-md-column>.flex-gt-md-33{max-height:33.33%}.layout-gt-md-column>.flex-gt-md-33,.layout-gt-md-column>.flex-gt-md-66{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;box-sizing:border-box}.layout-gt-md-column>.flex-gt-md-66{max-height:66.66%}.layout-gt-md-column>.flex{min-height:0}.layout-gt-md,.layout-gt-md-column,.layout-gt-md-row{box-sizing:border-box;display:-webkit-box;display:-webkit-flex;display:flex}.layout-gt-md-column{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column}.layout-gt-md-row{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;flex-direction:row}}@media (min-width:1280px) and (max-width:1919px){.hide-gt-md:not(.show-gt-xs):not(.show-gt-sm):not(.show-gt-md):not(.show-lg):not(.show),.hide-gt-sm:not(.show-gt-xs):not(.show-gt-sm):not(.show-gt-md):not(.show-lg):not(.show),.hide-gt-xs:not(.show-gt-xs):not(.show-gt-sm):not(.show-gt-md):not(.show-lg):not(.show),.hide-lg:not(.show-lg):not(.show-gt-md):not(.show-gt-sm):not(.show-gt-xs):not(.show),.hide:not(.show-gt-xs):not(.show-gt-sm):not(.show-gt-md):not(.show-lg):not(.show){display:none}.flex-order-lg--20{-webkit-box-ordinal-group:-19;-webkit-order:-20;order:-20}.flex-order-lg--19{-webkit-box-ordinal-group:-18;-webkit-order:-19;order:-19}.flex-order-lg--18{-webkit-box-ordinal-group:-17;-webkit-order:-18;order:-18}.flex-order-lg--17{-webkit-box-ordinal-group:-16;-webkit-order:-17;order:-17}.flex-order-lg--16{-webkit-box-ordinal-group:-15;-webkit-order:-16;order:-16}.flex-order-lg--15{-webkit-box-ordinal-group:-14;-webkit-order:-15;order:-15}.flex-order-lg--14{-webkit-box-ordinal-group:-13;-webkit-order:-14;order:-14}.flex-order-lg--13{-webkit-box-ordinal-group:-12;-webkit-order:-13;order:-13}.flex-order-lg--12{-webkit-box-ordinal-group:-11;-webkit-order:-12;order:-12}.flex-order-lg--11{-webkit-box-ordinal-group:-10;-webkit-order:-11;order:-11}.flex-order-lg--10{-webkit-box-ordinal-group:-9;-webkit-order:-10;order:-10}.flex-order-lg--9{-webkit-box-ordinal-group:-8;-webkit-order:-9;order:-9}.flex-order-lg--8{-webkit-box-ordinal-group:-7;-webkit-order:-8;order:-8}.flex-order-lg--7{-webkit-box-ordinal-group:-6;-webkit-order:-7;order:-7}.flex-order-lg--6{-webkit-box-ordinal-group:-5;-webkit-order:-6;order:-6}.flex-order-lg--5{-webkit-box-ordinal-group:-4;-webkit-order:-5;order:-5}.flex-order-lg--4{-webkit-box-ordinal-group:-3;-webkit-order:-4;order:-4}.flex-order-lg--3{-webkit-box-ordinal-group:-2;-webkit-order:-3;order:-3}.flex-order-lg--2{-webkit-box-ordinal-group:-1;-webkit-order:-2;order:-2}.flex-order-lg--1{-webkit-box-ordinal-group:0;-webkit-order:-1;order:-1}.flex-order-lg-0{-webkit-box-ordinal-group:1;-webkit-order:0;order:0}.flex-order-lg-1{-webkit-box-ordinal-group:2;-webkit-order:1;order:1}.flex-order-lg-2{-webkit-box-ordinal-group:3;-webkit-order:2;order:2}.flex-order-lg-3{-webkit-box-ordinal-group:4;-webkit-order:3;order:3}.flex-order-lg-4{-webkit-box-ordinal-group:5;-webkit-order:4;order:4}.flex-order-lg-5{-webkit-box-ordinal-group:6;-webkit-order:5;order:5}.flex-order-lg-6{-webkit-box-ordinal-group:7;-webkit-order:6;order:6}.flex-order-lg-7{-webkit-box-ordinal-group:8;-webkit-order:7;order:7}.flex-order-lg-8{-webkit-box-ordinal-group:9;-webkit-order:8;order:8}.flex-order-lg-9{-webkit-box-ordinal-group:10;-webkit-order:9;order:9}.flex-order-lg-10{-webkit-box-ordinal-group:11;-webkit-order:10;order:10}.flex-order-lg-11{-webkit-box-ordinal-group:12;-webkit-order:11;order:11}.flex-order-lg-12{-webkit-box-ordinal-group:13;-webkit-order:12;order:12}.flex-order-lg-13{-webkit-box-ordinal-group:14;-webkit-order:13;order:13}.flex-order-lg-14{-webkit-box-ordinal-group:15;-webkit-order:14;order:14}.flex-order-lg-15{-webkit-box-ordinal-group:16;-webkit-order:15;order:15}.flex-order-lg-16{-webkit-box-ordinal-group:17;-webkit-order:16;order:16}.flex-order-lg-17{-webkit-box-ordinal-group:18;-webkit-order:17;order:17}.flex-order-lg-18{-webkit-box-ordinal-group:19;-webkit-order:18;order:18}.flex-order-lg-19{-webkit-box-ordinal-group:20;-webkit-order:19;order:19}.flex-order-lg-20{-webkit-box-ordinal-group:21;-webkit-order:20;order:20}.flex-offset-lg-0,.offset-lg-0{margin-left:0}[dir=rtl] .flex-offset-lg-0,[dir=rtl] .offset-lg-0{margin-left:auto;margin-right:0}.flex-offset-lg-5,.offset-lg-5{margin-left:5%}[dir=rtl] .flex-offset-lg-5,[dir=rtl] .offset-lg-5{margin-left:auto;margin-right:5%}.flex-offset-lg-10,.offset-lg-10{margin-left:10%}[dir=rtl] .flex-offset-lg-10,[dir=rtl] .offset-lg-10{margin-left:auto;margin-right:10%}.flex-offset-lg-15,.offset-lg-15{margin-left:15%}[dir=rtl] .flex-offset-lg-15,[dir=rtl] .offset-lg-15{margin-left:auto;margin-right:15%}.flex-offset-lg-20,.offset-lg-20{margin-left:20%}[dir=rtl] .flex-offset-lg-20,[dir=rtl] .offset-lg-20{margin-left:auto;margin-right:20%}.flex-offset-lg-25,.offset-lg-25{margin-left:25%}[dir=rtl] .flex-offset-lg-25,[dir=rtl] .offset-lg-25{margin-left:auto;margin-right:25%}.flex-offset-lg-30,.offset-lg-30{margin-left:30%}[dir=rtl] .flex-offset-lg-30,[dir=rtl] .offset-lg-30{margin-left:auto;margin-right:30%}.flex-offset-lg-35,.offset-lg-35{margin-left:35%}[dir=rtl] .flex-offset-lg-35,[dir=rtl] .offset-lg-35{margin-left:auto;margin-right:35%}.flex-offset-lg-40,.offset-lg-40{margin-left:40%}[dir=rtl] .flex-offset-lg-40,[dir=rtl] .offset-lg-40{margin-left:auto;margin-right:40%}.flex-offset-lg-45,.offset-lg-45{margin-left:45%}[dir=rtl] .flex-offset-lg-45,[dir=rtl] .offset-lg-45{margin-left:auto;margin-right:45%}.flex-offset-lg-50,.offset-lg-50{margin-left:50%}[dir=rtl] .flex-offset-lg-50,[dir=rtl] .offset-lg-50{margin-left:auto;margin-right:50%}.flex-offset-lg-55,.offset-lg-55{margin-left:55%}[dir=rtl] .flex-offset-lg-55,[dir=rtl] .offset-lg-55{margin-left:auto;margin-right:55%}.flex-offset-lg-60,.offset-lg-60{margin-left:60%}[dir=rtl] .flex-offset-lg-60,[dir=rtl] .offset-lg-60{margin-left:auto;margin-right:60%}.flex-offset-lg-65,.offset-lg-65{margin-left:65%}[dir=rtl] .flex-offset-lg-65,[dir=rtl] .offset-lg-65{margin-left:auto;margin-right:65%}.flex-offset-lg-70,.offset-lg-70{margin-left:70%}[dir=rtl] .flex-offset-lg-70,[dir=rtl] .offset-lg-70{margin-left:auto;margin-right:70%}.flex-offset-lg-75,.offset-lg-75{margin-left:75%}[dir=rtl] .flex-offset-lg-75,[dir=rtl] .offset-lg-75{margin-left:auto;margin-right:75%}.flex-offset-lg-80,.offset-lg-80{margin-left:80%}[dir=rtl] .flex-offset-lg-80,[dir=rtl] .offset-lg-80{margin-left:auto;margin-right:80%}.flex-offset-lg-85,.offset-lg-85{margin-left:85%}[dir=rtl] .flex-offset-lg-85,[dir=rtl] .offset-lg-85{margin-left:auto;margin-right:85%}.flex-offset-lg-90,.offset-lg-90{margin-left:90%}[dir=rtl] .flex-offset-lg-90,[dir=rtl] .offset-lg-90{margin-left:auto;margin-right:90%}.flex-offset-lg-95,.offset-lg-95{margin-left:95%}[dir=rtl] .flex-offset-lg-95,[dir=rtl] .offset-lg-95{margin-left:auto;margin-right:95%}.flex-offset-lg-33,.offset-lg-33{margin-left:33.33333%}.flex-offset-lg-66,.offset-lg-66{margin-left:66.66667%}[dir=rtl] .flex-offset-lg-66,[dir=rtl] .offset-lg-66{margin-left:auto;margin-right:66.66667%}.layout-align-lg,.layout-align-lg-start-stretch{-webkit-align-content:stretch;align-content:stretch;-webkit-box-align:stretch;-webkit-align-items:stretch;align-items:stretch}.layout-align-lg,.layout-align-lg-start,.layout-align-lg-start-center,.layout-align-lg-start-end,.layout-align-lg-start-start,.layout-align-lg-start-stretch{-webkit-box-pack:start;-webkit-justify-content:flex-start;justify-content:flex-start}.layout-align-lg-center,.layout-align-lg-center-center,.layout-align-lg-center-end,.layout-align-lg-center-start,.layout-align-lg-center-stretch{-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center}.layout-align-lg-end,.layout-align-lg-end-center,.layout-align-lg-end-end,.layout-align-lg-end-start,.layout-align-lg-end-stretch{-webkit-box-pack:end;-webkit-justify-content:flex-end;justify-content:flex-end}.layout-align-lg-space-around,.layout-align-lg-space-around-center,.layout-align-lg-space-around-end,.layout-align-lg-space-around-start,.layout-align-lg-space-around-stretch{-webkit-justify-content:space-around;justify-content:space-around}.layout-align-lg-space-between,.layout-align-lg-space-between-center,.layout-align-lg-space-between-end,.layout-align-lg-space-between-start,.layout-align-lg-space-between-stretch{-webkit-box-pack:justify;-webkit-justify-content:space-between;justify-content:space-between}.layout-align-lg-center-start,.layout-align-lg-end-start,.layout-align-lg-space-around-start,.layout-align-lg-space-between-start,.layout-align-lg-start-start{-webkit-box-align:start;-webkit-align-items:flex-start;align-items:flex-start;-webkit-align-content:flex-start;align-content:flex-start}.layout-align-lg-center-center,.layout-align-lg-end-center,.layout-align-lg-space-around-center,.layout-align-lg-space-between-center,.layout-align-lg-start-center{-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-align-content:center;align-content:center;max-width:100%}.layout-align-lg-center-center>*,.layout-align-lg-end-center>*,.layout-align-lg-space-around-center>*,.layout-align-lg-space-between-center>*,.layout-align-lg-start-center>*{max-width:100%;box-sizing:border-box}.layout-align-lg-center-end,.layout-align-lg-end-end,.layout-align-lg-space-around-end,.layout-align-lg-space-between-end,.layout-align-lg-start-end{-webkit-box-align:end;-webkit-align-items:flex-end;align-items:flex-end;-webkit-align-content:flex-end;align-content:flex-end}.layout-align-lg-center-stretch,.layout-align-lg-end-stretch,.layout-align-lg-space-around-stretch,.layout-align-lg-space-between-stretch,.layout-align-lg-start-stretch{-webkit-box-align:stretch;-webkit-align-items:stretch;align-items:stretch;-webkit-align-content:stretch;align-content:stretch}.flex-lg{-webkit-flex:1;flex:1}.flex-lg,.flex-lg-grow{-webkit-box-flex:1;box-sizing:border-box}.flex-lg-grow{-webkit-flex:1 1 100%;flex:1 1 100%}.flex-lg-initial{-webkit-box-flex:0;-webkit-flex:0 1 auto;flex:0 1 auto;box-sizing:border-box}.flex-lg-auto{-webkit-box-flex:1;-webkit-flex:1 1 auto;flex:1 1 auto;box-sizing:border-box}.flex-lg-none{-webkit-box-flex:0;-webkit-flex:0 0 auto;flex:0 0 auto;box-sizing:border-box}.flex-lg-noshrink{-webkit-box-flex:1;-webkit-flex:1 0 auto;flex:1 0 auto;box-sizing:border-box}.flex-lg-nogrow{-webkit-box-flex:0;-webkit-flex:0 1 auto;flex:0 1 auto;box-sizing:border-box}.flex-lg-0,.layout-row>.flex-lg-0{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:0;max-height:100%;box-sizing:border-box}.layout-row>.flex-lg-0{min-width:0}.layout-column>.flex-lg-0{max-width:100%;max-height:0%}.layout-column>.flex-lg-0,.layout-lg-row>.flex-lg-0{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-lg-row>.flex-lg-0{max-width:0;max-height:100%;min-width:0}.layout-lg-column>.flex-lg-0{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;max-height:0%;box-sizing:border-box;min-height:0}.flex-lg-5,.layout-row>.flex-lg-5{max-width:5%;max-height:100%}.flex-lg-5,.layout-column>.flex-lg-5,.layout-row>.flex-lg-5{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-lg-5{max-width:100%;max-height:5%}.layout-lg-row>.flex-lg-5{max-width:5%;max-height:100%}.layout-lg-column>.flex-lg-5,.layout-lg-row>.flex-lg-5{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-lg-column>.flex-lg-5{max-width:100%;max-height:5%}.flex-lg-10,.layout-row>.flex-lg-10{max-width:10%;max-height:100%}.flex-lg-10,.layout-column>.flex-lg-10,.layout-row>.flex-lg-10{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-lg-10{max-width:100%;max-height:10%}.layout-lg-row>.flex-lg-10{max-width:10%;max-height:100%}.layout-lg-column>.flex-lg-10,.layout-lg-row>.flex-lg-10{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-lg-column>.flex-lg-10{max-width:100%;max-height:10%}.flex-lg-15,.layout-row>.flex-lg-15{max-width:15%;max-height:100%}.flex-lg-15,.layout-column>.flex-lg-15,.layout-row>.flex-lg-15{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-lg-15{max-width:100%;max-height:15%}.layout-lg-row>.flex-lg-15{max-width:15%;max-height:100%}.layout-lg-column>.flex-lg-15,.layout-lg-row>.flex-lg-15{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-lg-column>.flex-lg-15{max-width:100%;max-height:15%}.flex-lg-20,.layout-row>.flex-lg-20{max-width:20%;max-height:100%}.flex-lg-20,.layout-column>.flex-lg-20,.layout-row>.flex-lg-20{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-lg-20{max-width:100%;max-height:20%}.layout-lg-row>.flex-lg-20{max-width:20%;max-height:100%}.layout-lg-column>.flex-lg-20,.layout-lg-row>.flex-lg-20{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-lg-column>.flex-lg-20{max-width:100%;max-height:20%}.flex-lg-25,.layout-row>.flex-lg-25{max-width:25%;max-height:100%}.flex-lg-25,.layout-column>.flex-lg-25,.layout-row>.flex-lg-25{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-lg-25{max-width:100%;max-height:25%}.layout-lg-row>.flex-lg-25{max-width:25%;max-height:100%}.layout-lg-column>.flex-lg-25,.layout-lg-row>.flex-lg-25{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-lg-column>.flex-lg-25{max-width:100%;max-height:25%}.flex-lg-30,.layout-row>.flex-lg-30{max-width:30%;max-height:100%}.flex-lg-30,.layout-column>.flex-lg-30,.layout-row>.flex-lg-30{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-lg-30{max-width:100%;max-height:30%}.layout-lg-row>.flex-lg-30{max-width:30%;max-height:100%}.layout-lg-column>.flex-lg-30,.layout-lg-row>.flex-lg-30{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-lg-column>.flex-lg-30{max-width:100%;max-height:30%}.flex-lg-35,.layout-row>.flex-lg-35{max-width:35%;max-height:100%}.flex-lg-35,.layout-column>.flex-lg-35,.layout-row>.flex-lg-35{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-lg-35{max-width:100%;max-height:35%}.layout-lg-row>.flex-lg-35{max-width:35%;max-height:100%}.layout-lg-column>.flex-lg-35,.layout-lg-row>.flex-lg-35{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-lg-column>.flex-lg-35{max-width:100%;max-height:35%}.flex-lg-40,.layout-row>.flex-lg-40{max-width:40%;max-height:100%}.flex-lg-40,.layout-column>.flex-lg-40,.layout-row>.flex-lg-40{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-lg-40{max-width:100%;max-height:40%}.layout-lg-row>.flex-lg-40{max-width:40%;max-height:100%}.layout-lg-column>.flex-lg-40,.layout-lg-row>.flex-lg-40{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-lg-column>.flex-lg-40{max-width:100%;max-height:40%}.flex-lg-45,.layout-row>.flex-lg-45{max-width:45%;max-height:100%}.flex-lg-45,.layout-column>.flex-lg-45,.layout-row>.flex-lg-45{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-lg-45{max-width:100%;max-height:45%}.layout-lg-row>.flex-lg-45{max-width:45%;max-height:100%}.layout-lg-column>.flex-lg-45,.layout-lg-row>.flex-lg-45{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-lg-column>.flex-lg-45{max-width:100%;max-height:45%}.flex-lg-50,.layout-row>.flex-lg-50{max-width:50%;max-height:100%}.flex-lg-50,.layout-column>.flex-lg-50,.layout-row>.flex-lg-50{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-lg-50{max-width:100%;max-height:50%}.layout-lg-row>.flex-lg-50{max-width:50%;max-height:100%}.layout-lg-column>.flex-lg-50,.layout-lg-row>.flex-lg-50{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-lg-column>.flex-lg-50{max-width:100%;max-height:50%}.flex-lg-55,.layout-row>.flex-lg-55{max-width:55%;max-height:100%}.flex-lg-55,.layout-column>.flex-lg-55,.layout-row>.flex-lg-55{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-lg-55{max-width:100%;max-height:55%}.layout-lg-row>.flex-lg-55{max-width:55%;max-height:100%}.layout-lg-column>.flex-lg-55,.layout-lg-row>.flex-lg-55{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-lg-column>.flex-lg-55{max-width:100%;max-height:55%}.flex-lg-60,.layout-row>.flex-lg-60{max-width:60%;max-height:100%}.flex-lg-60,.layout-column>.flex-lg-60,.layout-row>.flex-lg-60{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-lg-60{max-width:100%;max-height:60%}.layout-lg-row>.flex-lg-60{max-width:60%;max-height:100%}.layout-lg-column>.flex-lg-60,.layout-lg-row>.flex-lg-60{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-lg-column>.flex-lg-60{max-width:100%;max-height:60%}.flex-lg-65,.layout-row>.flex-lg-65{max-width:65%;max-height:100%}.flex-lg-65,.layout-column>.flex-lg-65,.layout-row>.flex-lg-65{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-lg-65{max-width:100%;max-height:65%}.layout-lg-row>.flex-lg-65{max-width:65%;max-height:100%}.layout-lg-column>.flex-lg-65,.layout-lg-row>.flex-lg-65{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-lg-column>.flex-lg-65{max-width:100%;max-height:65%}.flex-lg-70,.layout-row>.flex-lg-70{max-width:70%;max-height:100%}.flex-lg-70,.layout-column>.flex-lg-70,.layout-row>.flex-lg-70{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-lg-70{max-width:100%;max-height:70%}.layout-lg-row>.flex-lg-70{max-width:70%;max-height:100%}.layout-lg-column>.flex-lg-70,.layout-lg-row>.flex-lg-70{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-lg-column>.flex-lg-70{max-width:100%;max-height:70%}.flex-lg-75,.layout-row>.flex-lg-75{max-width:75%;max-height:100%}.flex-lg-75,.layout-column>.flex-lg-75,.layout-row>.flex-lg-75{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-lg-75{max-width:100%;max-height:75%}.layout-lg-row>.flex-lg-75{max-width:75%;max-height:100%}.layout-lg-column>.flex-lg-75,.layout-lg-row>.flex-lg-75{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-lg-column>.flex-lg-75{max-width:100%;max-height:75%}.flex-lg-80,.layout-row>.flex-lg-80{max-width:80%;max-height:100%}.flex-lg-80,.layout-column>.flex-lg-80,.layout-row>.flex-lg-80{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-lg-80{max-width:100%;max-height:80%}.layout-lg-row>.flex-lg-80{max-width:80%;max-height:100%}.layout-lg-column>.flex-lg-80,.layout-lg-row>.flex-lg-80{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-lg-column>.flex-lg-80{max-width:100%;max-height:80%}.flex-lg-85,.layout-row>.flex-lg-85{max-width:85%;max-height:100%}.flex-lg-85,.layout-column>.flex-lg-85,.layout-row>.flex-lg-85{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-lg-85{max-width:100%;max-height:85%}.layout-lg-row>.flex-lg-85{max-width:85%;max-height:100%}.layout-lg-column>.flex-lg-85,.layout-lg-row>.flex-lg-85{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-lg-column>.flex-lg-85{max-width:100%;max-height:85%}.flex-lg-90,.layout-row>.flex-lg-90{max-width:90%;max-height:100%}.flex-lg-90,.layout-column>.flex-lg-90,.layout-row>.flex-lg-90{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-lg-90{max-width:100%;max-height:90%}.layout-lg-row>.flex-lg-90{max-width:90%;max-height:100%}.layout-lg-column>.flex-lg-90,.layout-lg-row>.flex-lg-90{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-lg-column>.flex-lg-90{max-width:100%;max-height:90%}.flex-lg-95,.layout-row>.flex-lg-95{max-width:95%;max-height:100%}.flex-lg-95,.layout-column>.flex-lg-95,.layout-row>.flex-lg-95{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-lg-95{max-width:100%;max-height:95%}.layout-lg-row>.flex-lg-95{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:95%;max-height:100%;box-sizing:border-box}.layout-lg-column>.flex-lg-95{max-height:95%}.flex-lg-100,.layout-lg-column>.flex-lg-95{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;box-sizing:border-box}.flex-lg-100{max-height:100%}.layout-column>.flex-lg-100,.layout-lg-column>.flex-lg-100,.layout-lg-row>.flex-lg-100,.layout-row>.flex-lg-100{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;max-height:100%;box-sizing:border-box}.layout-row>.flex-lg-33{-webkit-flex:1 1 33.33%;flex:1 1 33.33%;max-width:33.33%}.layout-row>.flex-lg-33,.layout-row>.flex-lg-66{-webkit-box-flex:1;max-height:100%;box-sizing:border-box}.layout-row>.flex-lg-66{-webkit-flex:1 1 66.66%;flex:1 1 66.66%;max-width:66.66%}.layout-column>.flex-lg-33{-webkit-flex:1 1 33.33%;flex:1 1 33.33%;max-height:33.33%}.layout-column>.flex-lg-33,.layout-column>.flex-lg-66{-webkit-box-flex:1;max-width:100%;box-sizing:border-box}.layout-column>.flex-lg-66{-webkit-flex:1 1 66.66%;flex:1 1 66.66%;max-height:66.66%}.layout-lg-row>.flex-lg-33{max-width:33.33%}.layout-lg-row>.flex-lg-33,.layout-lg-row>.flex-lg-66{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-height:100%;box-sizing:border-box}.layout-lg-row>.flex-lg-66{max-width:66.66%}.layout-lg-row>.flex{min-width:0}.layout-lg-column>.flex-lg-33{max-height:33.33%}.layout-lg-column>.flex-lg-33,.layout-lg-column>.flex-lg-66{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;box-sizing:border-box}.layout-lg-column>.flex-lg-66{max-height:66.66%}.layout-lg-column>.flex{min-height:0}.layout-lg,.layout-lg-column,.layout-lg-row{box-sizing:border-box;display:-webkit-box;display:-webkit-flex;display:flex}.layout-lg-column{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column}.layout-lg-row{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;flex-direction:row}}@media (min-width:1920px){.flex-order-gt-lg--20{-webkit-box-ordinal-group:-19;-webkit-order:-20;order:-20}.flex-order-gt-lg--19{-webkit-box-ordinal-group:-18;-webkit-order:-19;order:-19}.flex-order-gt-lg--18{-webkit-box-ordinal-group:-17;-webkit-order:-18;order:-18}.flex-order-gt-lg--17{-webkit-box-ordinal-group:-16;-webkit-order:-17;order:-17}.flex-order-gt-lg--16{-webkit-box-ordinal-group:-15;-webkit-order:-16;order:-16}.flex-order-gt-lg--15{-webkit-box-ordinal-group:-14;-webkit-order:-15;order:-15}.flex-order-gt-lg--14{-webkit-box-ordinal-group:-13;-webkit-order:-14;order:-14}.flex-order-gt-lg--13{-webkit-box-ordinal-group:-12;-webkit-order:-13;order:-13}.flex-order-gt-lg--12{-webkit-box-ordinal-group:-11;-webkit-order:-12;order:-12}.flex-order-gt-lg--11{-webkit-box-ordinal-group:-10;-webkit-order:-11;order:-11}.flex-order-gt-lg--10{-webkit-box-ordinal-group:-9;-webkit-order:-10;order:-10}.flex-order-gt-lg--9{-webkit-box-ordinal-group:-8;-webkit-order:-9;order:-9}.flex-order-gt-lg--8{-webkit-box-ordinal-group:-7;-webkit-order:-8;order:-8}.flex-order-gt-lg--7{-webkit-box-ordinal-group:-6;-webkit-order:-7;order:-7}.flex-order-gt-lg--6{-webkit-box-ordinal-group:-5;-webkit-order:-6;order:-6}.flex-order-gt-lg--5{-webkit-box-ordinal-group:-4;-webkit-order:-5;order:-5}.flex-order-gt-lg--4{-webkit-box-ordinal-group:-3;-webkit-order:-4;order:-4}.flex-order-gt-lg--3{-webkit-box-ordinal-group:-2;-webkit-order:-3;order:-3}.flex-order-gt-lg--2{-webkit-box-ordinal-group:-1;-webkit-order:-2;order:-2}.flex-order-gt-lg--1{-webkit-box-ordinal-group:0;-webkit-order:-1;order:-1}.flex-order-gt-lg-0{-webkit-box-ordinal-group:1;-webkit-order:0;order:0}.flex-order-gt-lg-1{-webkit-box-ordinal-group:2;-webkit-order:1;order:1}.flex-order-gt-lg-2{-webkit-box-ordinal-group:3;-webkit-order:2;order:2}.flex-order-gt-lg-3{-webkit-box-ordinal-group:4;-webkit-order:3;order:3}.flex-order-gt-lg-4{-webkit-box-ordinal-group:5;-webkit-order:4;order:4}.flex-order-gt-lg-5{-webkit-box-ordinal-group:6;-webkit-order:5;order:5}.flex-order-gt-lg-6{-webkit-box-ordinal-group:7;-webkit-order:6;order:6}.flex-order-gt-lg-7{-webkit-box-ordinal-group:8;-webkit-order:7;order:7}.flex-order-gt-lg-8{-webkit-box-ordinal-group:9;-webkit-order:8;order:8}.flex-order-gt-lg-9{-webkit-box-ordinal-group:10;-webkit-order:9;order:9}.flex-order-gt-lg-10{-webkit-box-ordinal-group:11;-webkit-order:10;order:10}.flex-order-gt-lg-11{-webkit-box-ordinal-group:12;-webkit-order:11;order:11}.flex-order-gt-lg-12{-webkit-box-ordinal-group:13;-webkit-order:12;order:12}.flex-order-gt-lg-13{-webkit-box-ordinal-group:14;-webkit-order:13;order:13}.flex-order-gt-lg-14{-webkit-box-ordinal-group:15;-webkit-order:14;order:14}.flex-order-gt-lg-15{-webkit-box-ordinal-group:16;-webkit-order:15;order:15}.flex-order-gt-lg-16{-webkit-box-ordinal-group:17;-webkit-order:16;order:16}.flex-order-gt-lg-17{-webkit-box-ordinal-group:18;-webkit-order:17;order:17}.flex-order-gt-lg-18{-webkit-box-ordinal-group:19;-webkit-order:18;order:18}.flex-order-gt-lg-19{-webkit-box-ordinal-group:20;-webkit-order:19;order:19}.flex-order-gt-lg-20{-webkit-box-ordinal-group:21;-webkit-order:20;order:20}.flex-offset-gt-lg-0,.offset-gt-lg-0{margin-left:0}[dir=rtl] .flex-offset-gt-lg-0,[dir=rtl] .offset-gt-lg-0{margin-left:auto;margin-right:0}.flex-offset-gt-lg-5,.offset-gt-lg-5{margin-left:5%}[dir=rtl] .flex-offset-gt-lg-5,[dir=rtl] .offset-gt-lg-5{margin-left:auto;margin-right:5%}.flex-offset-gt-lg-10,.offset-gt-lg-10{margin-left:10%}[dir=rtl] .flex-offset-gt-lg-10,[dir=rtl] .offset-gt-lg-10{margin-left:auto;margin-right:10%}.flex-offset-gt-lg-15,.offset-gt-lg-15{margin-left:15%}[dir=rtl] .flex-offset-gt-lg-15,[dir=rtl] .offset-gt-lg-15{margin-left:auto;margin-right:15%}.flex-offset-gt-lg-20,.offset-gt-lg-20{margin-left:20%}[dir=rtl] .flex-offset-gt-lg-20,[dir=rtl] .offset-gt-lg-20{margin-left:auto;margin-right:20%}.flex-offset-gt-lg-25,.offset-gt-lg-25{margin-left:25%}[dir=rtl] .flex-offset-gt-lg-25,[dir=rtl] .offset-gt-lg-25{margin-left:auto;margin-right:25%}.flex-offset-gt-lg-30,.offset-gt-lg-30{margin-left:30%}[dir=rtl] .flex-offset-gt-lg-30,[dir=rtl] .offset-gt-lg-30{margin-left:auto;margin-right:30%}.flex-offset-gt-lg-35,.offset-gt-lg-35{margin-left:35%}[dir=rtl] .flex-offset-gt-lg-35,[dir=rtl] .offset-gt-lg-35{margin-left:auto;margin-right:35%}.flex-offset-gt-lg-40,.offset-gt-lg-40{margin-left:40%}[dir=rtl] .flex-offset-gt-lg-40,[dir=rtl] .offset-gt-lg-40{margin-left:auto;margin-right:40%}.flex-offset-gt-lg-45,.offset-gt-lg-45{margin-left:45%}[dir=rtl] .flex-offset-gt-lg-45,[dir=rtl] .offset-gt-lg-45{margin-left:auto;margin-right:45%}.flex-offset-gt-lg-50,.offset-gt-lg-50{margin-left:50%}[dir=rtl] .flex-offset-gt-lg-50,[dir=rtl] .offset-gt-lg-50{margin-left:auto;margin-right:50%}.flex-offset-gt-lg-55,.offset-gt-lg-55{margin-left:55%}[dir=rtl] .flex-offset-gt-lg-55,[dir=rtl] .offset-gt-lg-55{margin-left:auto;margin-right:55%}.flex-offset-gt-lg-60,.offset-gt-lg-60{margin-left:60%}[dir=rtl] .flex-offset-gt-lg-60,[dir=rtl] .offset-gt-lg-60{margin-left:auto;margin-right:60%}.flex-offset-gt-lg-65,.offset-gt-lg-65{margin-left:65%}[dir=rtl] .flex-offset-gt-lg-65,[dir=rtl] .offset-gt-lg-65{margin-left:auto;margin-right:65%}.flex-offset-gt-lg-70,.offset-gt-lg-70{margin-left:70%}[dir=rtl] .flex-offset-gt-lg-70,[dir=rtl] .offset-gt-lg-70{margin-left:auto;margin-right:70%}.flex-offset-gt-lg-75,.offset-gt-lg-75{margin-left:75%}[dir=rtl] .flex-offset-gt-lg-75,[dir=rtl] .offset-gt-lg-75{margin-left:auto;margin-right:75%}.flex-offset-gt-lg-80,.offset-gt-lg-80{margin-left:80%}[dir=rtl] .flex-offset-gt-lg-80,[dir=rtl] .offset-gt-lg-80{margin-left:auto;margin-right:80%}.flex-offset-gt-lg-85,.offset-gt-lg-85{margin-left:85%}[dir=rtl] .flex-offset-gt-lg-85,[dir=rtl] .offset-gt-lg-85{margin-left:auto;margin-right:85%}.flex-offset-gt-lg-90,.offset-gt-lg-90{margin-left:90%}[dir=rtl] .flex-offset-gt-lg-90,[dir=rtl] .offset-gt-lg-90{margin-left:auto;margin-right:90%}.flex-offset-gt-lg-95,.offset-gt-lg-95{margin-left:95%}[dir=rtl] .flex-offset-gt-lg-95,[dir=rtl] .offset-gt-lg-95{margin-left:auto;margin-right:95%}.flex-offset-gt-lg-33,.offset-gt-lg-33{margin-left:33.33333%}.flex-offset-gt-lg-66,.offset-gt-lg-66{margin-left:66.66667%}[dir=rtl] .flex-offset-gt-lg-66,[dir=rtl] .offset-gt-lg-66{margin-left:auto;margin-right:66.66667%}.layout-align-gt-lg,.layout-align-gt-lg-start-stretch{-webkit-align-content:stretch;align-content:stretch;-webkit-box-align:stretch;-webkit-align-items:stretch;align-items:stretch}.layout-align-gt-lg,.layout-align-gt-lg-start,.layout-align-gt-lg-start-center,.layout-align-gt-lg-start-end,.layout-align-gt-lg-start-start,.layout-align-gt-lg-start-stretch{-webkit-box-pack:start;-webkit-justify-content:flex-start;justify-content:flex-start}.layout-align-gt-lg-center,.layout-align-gt-lg-center-center,.layout-align-gt-lg-center-end,.layout-align-gt-lg-center-start,.layout-align-gt-lg-center-stretch{-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center}.layout-align-gt-lg-end,.layout-align-gt-lg-end-center,.layout-align-gt-lg-end-end,.layout-align-gt-lg-end-start,.layout-align-gt-lg-end-stretch{-webkit-box-pack:end;-webkit-justify-content:flex-end;justify-content:flex-end}.layout-align-gt-lg-space-around,.layout-align-gt-lg-space-around-center,.layout-align-gt-lg-space-around-end,.layout-align-gt-lg-space-around-start,.layout-align-gt-lg-space-around-stretch{-webkit-justify-content:space-around;justify-content:space-around}.layout-align-gt-lg-space-between,.layout-align-gt-lg-space-between-center,.layout-align-gt-lg-space-between-end,.layout-align-gt-lg-space-between-start,.layout-align-gt-lg-space-between-stretch{-webkit-box-pack:justify;-webkit-justify-content:space-between;justify-content:space-between}.layout-align-gt-lg-center-start,.layout-align-gt-lg-end-start,.layout-align-gt-lg-space-around-start,.layout-align-gt-lg-space-between-start,.layout-align-gt-lg-start-start{-webkit-box-align:start;-webkit-align-items:flex-start;align-items:flex-start;-webkit-align-content:flex-start;align-content:flex-start}.layout-align-gt-lg-center-center,.layout-align-gt-lg-end-center,.layout-align-gt-lg-space-around-center,.layout-align-gt-lg-space-between-center,.layout-align-gt-lg-start-center{-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-align-content:center;align-content:center;max-width:100%}.layout-align-gt-lg-center-center>*,.layout-align-gt-lg-end-center>*,.layout-align-gt-lg-space-around-center>*,.layout-align-gt-lg-space-between-center>*,.layout-align-gt-lg-start-center>*{max-width:100%;box-sizing:border-box}.layout-align-gt-lg-center-end,.layout-align-gt-lg-end-end,.layout-align-gt-lg-space-around-end,.layout-align-gt-lg-space-between-end,.layout-align-gt-lg-start-end{-webkit-box-align:end;-webkit-align-items:flex-end;align-items:flex-end;-webkit-align-content:flex-end;align-content:flex-end}.layout-align-gt-lg-center-stretch,.layout-align-gt-lg-end-stretch,.layout-align-gt-lg-space-around-stretch,.layout-align-gt-lg-space-between-stretch,.layout-align-gt-lg-start-stretch{-webkit-box-align:stretch;-webkit-align-items:stretch;align-items:stretch;-webkit-align-content:stretch;align-content:stretch}.flex-gt-lg{-webkit-flex:1;flex:1}.flex-gt-lg,.flex-gt-lg-grow{-webkit-box-flex:1;box-sizing:border-box}.flex-gt-lg-grow{-webkit-flex:1 1 100%;flex:1 1 100%}.flex-gt-lg-initial{-webkit-box-flex:0;-webkit-flex:0 1 auto;flex:0 1 auto;box-sizing:border-box}.flex-gt-lg-auto{-webkit-box-flex:1;-webkit-flex:1 1 auto;flex:1 1 auto;box-sizing:border-box}.flex-gt-lg-none{-webkit-box-flex:0;-webkit-flex:0 0 auto;flex:0 0 auto;box-sizing:border-box}.flex-gt-lg-noshrink{-webkit-box-flex:1;-webkit-flex:1 0 auto;flex:1 0 auto;box-sizing:border-box}.flex-gt-lg-nogrow{-webkit-box-flex:0;-webkit-flex:0 1 auto;flex:0 1 auto;box-sizing:border-box}.flex-gt-lg-0,.layout-row>.flex-gt-lg-0{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:0;max-height:100%;box-sizing:border-box}.layout-row>.flex-gt-lg-0{min-width:0}.layout-column>.flex-gt-lg-0{max-width:100%;max-height:0%}.layout-column>.flex-gt-lg-0,.layout-gt-lg-row>.flex-gt-lg-0{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-lg-row>.flex-gt-lg-0{max-width:0;max-height:100%;min-width:0}.layout-gt-lg-column>.flex-gt-lg-0{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;max-height:0%;box-sizing:border-box;min-height:0}.flex-gt-lg-5,.layout-row>.flex-gt-lg-5{max-width:5%;max-height:100%}.flex-gt-lg-5,.layout-column>.flex-gt-lg-5,.layout-row>.flex-gt-lg-5{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-lg-5{max-width:100%;max-height:5%}.layout-gt-lg-row>.flex-gt-lg-5{max-width:5%;max-height:100%}.layout-gt-lg-column>.flex-gt-lg-5,.layout-gt-lg-row>.flex-gt-lg-5{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-lg-column>.flex-gt-lg-5{max-width:100%;max-height:5%}.flex-gt-lg-10,.layout-row>.flex-gt-lg-10{max-width:10%;max-height:100%}.flex-gt-lg-10,.layout-column>.flex-gt-lg-10,.layout-row>.flex-gt-lg-10{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-lg-10{max-width:100%;max-height:10%}.layout-gt-lg-row>.flex-gt-lg-10{max-width:10%;max-height:100%}.layout-gt-lg-column>.flex-gt-lg-10,.layout-gt-lg-row>.flex-gt-lg-10{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-lg-column>.flex-gt-lg-10{max-width:100%;max-height:10%}.flex-gt-lg-15,.layout-row>.flex-gt-lg-15{max-width:15%;max-height:100%}.flex-gt-lg-15,.layout-column>.flex-gt-lg-15,.layout-row>.flex-gt-lg-15{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-lg-15{max-width:100%;max-height:15%}.layout-gt-lg-row>.flex-gt-lg-15{max-width:15%;max-height:100%}.layout-gt-lg-column>.flex-gt-lg-15,.layout-gt-lg-row>.flex-gt-lg-15{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-lg-column>.flex-gt-lg-15{max-width:100%;max-height:15%}.flex-gt-lg-20,.layout-row>.flex-gt-lg-20{max-width:20%;max-height:100%}.flex-gt-lg-20,.layout-column>.flex-gt-lg-20,.layout-row>.flex-gt-lg-20{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-lg-20{max-width:100%;max-height:20%}.layout-gt-lg-row>.flex-gt-lg-20{max-width:20%;max-height:100%}.layout-gt-lg-column>.flex-gt-lg-20,.layout-gt-lg-row>.flex-gt-lg-20{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-lg-column>.flex-gt-lg-20{max-width:100%;max-height:20%}.flex-gt-lg-25,.layout-row>.flex-gt-lg-25{max-width:25%;max-height:100%}.flex-gt-lg-25,.layout-column>.flex-gt-lg-25,.layout-row>.flex-gt-lg-25{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-lg-25{max-width:100%;max-height:25%}.layout-gt-lg-row>.flex-gt-lg-25{max-width:25%;max-height:100%}.layout-gt-lg-column>.flex-gt-lg-25,.layout-gt-lg-row>.flex-gt-lg-25{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-lg-column>.flex-gt-lg-25{max-width:100%;max-height:25%}.flex-gt-lg-30,.layout-row>.flex-gt-lg-30{max-width:30%;max-height:100%}.flex-gt-lg-30,.layout-column>.flex-gt-lg-30,.layout-row>.flex-gt-lg-30{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-lg-30{max-width:100%;max-height:30%}.layout-gt-lg-row>.flex-gt-lg-30{max-width:30%;max-height:100%}.layout-gt-lg-column>.flex-gt-lg-30,.layout-gt-lg-row>.flex-gt-lg-30{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-lg-column>.flex-gt-lg-30{max-width:100%;max-height:30%}.flex-gt-lg-35,.layout-row>.flex-gt-lg-35{max-width:35%;max-height:100%}.flex-gt-lg-35,.layout-column>.flex-gt-lg-35,.layout-row>.flex-gt-lg-35{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-lg-35{max-width:100%;max-height:35%}.layout-gt-lg-row>.flex-gt-lg-35{max-width:35%;max-height:100%}.layout-gt-lg-column>.flex-gt-lg-35,.layout-gt-lg-row>.flex-gt-lg-35{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-lg-column>.flex-gt-lg-35{max-width:100%;max-height:35%}.flex-gt-lg-40,.layout-row>.flex-gt-lg-40{max-width:40%;max-height:100%}.flex-gt-lg-40,.layout-column>.flex-gt-lg-40,.layout-row>.flex-gt-lg-40{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-lg-40{max-width:100%;max-height:40%}.layout-gt-lg-row>.flex-gt-lg-40{max-width:40%;max-height:100%}.layout-gt-lg-column>.flex-gt-lg-40,.layout-gt-lg-row>.flex-gt-lg-40{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-lg-column>.flex-gt-lg-40{max-width:100%;max-height:40%}.flex-gt-lg-45,.layout-row>.flex-gt-lg-45{max-width:45%;max-height:100%}.flex-gt-lg-45,.layout-column>.flex-gt-lg-45,.layout-row>.flex-gt-lg-45{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-lg-45{max-width:100%;max-height:45%}.layout-gt-lg-row>.flex-gt-lg-45{max-width:45%;max-height:100%}.layout-gt-lg-column>.flex-gt-lg-45,.layout-gt-lg-row>.flex-gt-lg-45{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-lg-column>.flex-gt-lg-45{max-width:100%;max-height:45%}.flex-gt-lg-50,.layout-row>.flex-gt-lg-50{max-width:50%;max-height:100%}.flex-gt-lg-50,.layout-column>.flex-gt-lg-50,.layout-row>.flex-gt-lg-50{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-lg-50{max-width:100%;max-height:50%}.layout-gt-lg-row>.flex-gt-lg-50{max-width:50%;max-height:100%}.layout-gt-lg-column>.flex-gt-lg-50,.layout-gt-lg-row>.flex-gt-lg-50{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-lg-column>.flex-gt-lg-50{max-width:100%;max-height:50%}.flex-gt-lg-55,.layout-row>.flex-gt-lg-55{max-width:55%;max-height:100%}.flex-gt-lg-55,.layout-column>.flex-gt-lg-55,.layout-row>.flex-gt-lg-55{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-lg-55{max-width:100%;max-height:55%}.layout-gt-lg-row>.flex-gt-lg-55{max-width:55%;max-height:100%}.layout-gt-lg-column>.flex-gt-lg-55,.layout-gt-lg-row>.flex-gt-lg-55{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-lg-column>.flex-gt-lg-55{max-width:100%;max-height:55%}.flex-gt-lg-60,.layout-row>.flex-gt-lg-60{max-width:60%;max-height:100%}.flex-gt-lg-60,.layout-column>.flex-gt-lg-60,.layout-row>.flex-gt-lg-60{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-lg-60{max-width:100%;max-height:60%}.layout-gt-lg-row>.flex-gt-lg-60{max-width:60%;max-height:100%}.layout-gt-lg-column>.flex-gt-lg-60,.layout-gt-lg-row>.flex-gt-lg-60{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-lg-column>.flex-gt-lg-60{max-width:100%;max-height:60%}.flex-gt-lg-65,.layout-row>.flex-gt-lg-65{max-width:65%;max-height:100%}.flex-gt-lg-65,.layout-column>.flex-gt-lg-65,.layout-row>.flex-gt-lg-65{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-lg-65{max-width:100%;max-height:65%}.layout-gt-lg-row>.flex-gt-lg-65{max-width:65%;max-height:100%}.layout-gt-lg-column>.flex-gt-lg-65,.layout-gt-lg-row>.flex-gt-lg-65{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-lg-column>.flex-gt-lg-65{max-width:100%;max-height:65%}.flex-gt-lg-70,.layout-row>.flex-gt-lg-70{max-width:70%;max-height:100%}.flex-gt-lg-70,.layout-column>.flex-gt-lg-70,.layout-row>.flex-gt-lg-70{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-lg-70{max-width:100%;max-height:70%}.layout-gt-lg-row>.flex-gt-lg-70{max-width:70%;max-height:100%}.layout-gt-lg-column>.flex-gt-lg-70,.layout-gt-lg-row>.flex-gt-lg-70{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-lg-column>.flex-gt-lg-70{max-width:100%;max-height:70%}.flex-gt-lg-75,.layout-row>.flex-gt-lg-75{max-width:75%;max-height:100%}.flex-gt-lg-75,.layout-column>.flex-gt-lg-75,.layout-row>.flex-gt-lg-75{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-lg-75{max-width:100%;max-height:75%}.layout-gt-lg-row>.flex-gt-lg-75{max-width:75%;max-height:100%}.layout-gt-lg-column>.flex-gt-lg-75,.layout-gt-lg-row>.flex-gt-lg-75{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-lg-column>.flex-gt-lg-75{max-width:100%;max-height:75%}.flex-gt-lg-80,.layout-row>.flex-gt-lg-80{max-width:80%;max-height:100%}.flex-gt-lg-80,.layout-column>.flex-gt-lg-80,.layout-row>.flex-gt-lg-80{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-lg-80{max-width:100%;max-height:80%}.layout-gt-lg-row>.flex-gt-lg-80{max-width:80%;max-height:100%}.layout-gt-lg-column>.flex-gt-lg-80,.layout-gt-lg-row>.flex-gt-lg-80{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-lg-column>.flex-gt-lg-80{max-width:100%;max-height:80%}.flex-gt-lg-85,.layout-row>.flex-gt-lg-85{max-width:85%;max-height:100%}.flex-gt-lg-85,.layout-column>.flex-gt-lg-85,.layout-row>.flex-gt-lg-85{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-lg-85{max-width:100%;max-height:85%}.layout-gt-lg-row>.flex-gt-lg-85{max-width:85%;max-height:100%}.layout-gt-lg-column>.flex-gt-lg-85,.layout-gt-lg-row>.flex-gt-lg-85{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-lg-column>.flex-gt-lg-85{max-width:100%;max-height:85%}.flex-gt-lg-90,.layout-row>.flex-gt-lg-90{max-width:90%;max-height:100%}.flex-gt-lg-90,.layout-column>.flex-gt-lg-90,.layout-row>.flex-gt-lg-90{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-lg-90{max-width:100%;max-height:90%}.layout-gt-lg-row>.flex-gt-lg-90{max-width:90%;max-height:100%}.layout-gt-lg-column>.flex-gt-lg-90,.layout-gt-lg-row>.flex-gt-lg-90{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-gt-lg-column>.flex-gt-lg-90{max-width:100%;max-height:90%}.flex-gt-lg-95,.layout-row>.flex-gt-lg-95{max-width:95%;max-height:100%}.flex-gt-lg-95,.layout-column>.flex-gt-lg-95,.layout-row>.flex-gt-lg-95{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-gt-lg-95{max-width:100%;max-height:95%}.layout-gt-lg-row>.flex-gt-lg-95{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:95%;max-height:100%;box-sizing:border-box}.layout-gt-lg-column>.flex-gt-lg-95{max-height:95%}.flex-gt-lg-100,.layout-gt-lg-column>.flex-gt-lg-95{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;box-sizing:border-box}.flex-gt-lg-100{max-height:100%}.layout-column>.flex-gt-lg-100,.layout-gt-lg-column>.flex-gt-lg-100,.layout-gt-lg-row>.flex-gt-lg-100,.layout-row>.flex-gt-lg-100{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;max-height:100%;box-sizing:border-box}.layout-row>.flex-gt-lg-33{-webkit-flex:1 1 33.33%;flex:1 1 33.33%;max-width:33.33%}.layout-row>.flex-gt-lg-33,.layout-row>.flex-gt-lg-66{-webkit-box-flex:1;max-height:100%;box-sizing:border-box}.layout-row>.flex-gt-lg-66{-webkit-flex:1 1 66.66%;flex:1 1 66.66%;max-width:66.66%}.layout-column>.flex-gt-lg-33{-webkit-box-flex:1;-webkit-flex:1 1 33.33%;flex:1 1 33.33%;max-width:100%;max-height:33.33%;box-sizing:border-box}.layout-column>.flex-gt-lg-66{-webkit-box-flex:1;-webkit-flex:1 1 66.66%;flex:1 1 66.66%;max-width:100%;max-height:66.66%;box-sizing:border-box}.layout-gt-lg-row>.flex-gt-lg-33{max-width:33.33%}.layout-gt-lg-row>.flex-gt-lg-33,.layout-gt-lg-row>.flex-gt-lg-66{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-height:100%;box-sizing:border-box}.layout-gt-lg-row>.flex-gt-lg-66{max-width:66.66%}.layout-gt-lg-row>.flex{min-width:0}.layout-gt-lg-column>.flex-gt-lg-33{max-height:33.33%}.layout-gt-lg-column>.flex-gt-lg-33,.layout-gt-lg-column>.flex-gt-lg-66{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;box-sizing:border-box}.layout-gt-lg-column>.flex-gt-lg-66{max-height:66.66%}.layout-gt-lg-column>.flex{min-height:0}.layout-gt-lg,.layout-gt-lg-column,.layout-gt-lg-row{box-sizing:border-box;display:-webkit-box;display:-webkit-flex;display:flex}.layout-gt-lg-column{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column}.layout-gt-lg-row{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;flex-direction:row}.flex-order-xl--20{-webkit-box-ordinal-group:-19;-webkit-order:-20;order:-20}.flex-order-xl--19{-webkit-box-ordinal-group:-18;-webkit-order:-19;order:-19}.flex-order-xl--18{-webkit-box-ordinal-group:-17;-webkit-order:-18;order:-18}.flex-order-xl--17{-webkit-box-ordinal-group:-16;-webkit-order:-17;order:-17}.flex-order-xl--16{-webkit-box-ordinal-group:-15;-webkit-order:-16;order:-16}.flex-order-xl--15{-webkit-box-ordinal-group:-14;-webkit-order:-15;order:-15}.flex-order-xl--14{-webkit-box-ordinal-group:-13;-webkit-order:-14;order:-14}.flex-order-xl--13{-webkit-box-ordinal-group:-12;-webkit-order:-13;order:-13}.flex-order-xl--12{-webkit-box-ordinal-group:-11;-webkit-order:-12;order:-12}.flex-order-xl--11{-webkit-box-ordinal-group:-10;-webkit-order:-11;order:-11}.flex-order-xl--10{-webkit-box-ordinal-group:-9;-webkit-order:-10;order:-10}.flex-order-xl--9{-webkit-box-ordinal-group:-8;-webkit-order:-9;order:-9}.flex-order-xl--8{-webkit-box-ordinal-group:-7;-webkit-order:-8;order:-8}.flex-order-xl--7{-webkit-box-ordinal-group:-6;-webkit-order:-7;order:-7}.flex-order-xl--6{-webkit-box-ordinal-group:-5;-webkit-order:-6;order:-6}.flex-order-xl--5{-webkit-box-ordinal-group:-4;-webkit-order:-5;order:-5}.flex-order-xl--4{-webkit-box-ordinal-group:-3;-webkit-order:-4;order:-4}.flex-order-xl--3{-webkit-box-ordinal-group:-2;-webkit-order:-3;order:-3}.flex-order-xl--2{-webkit-box-ordinal-group:-1;-webkit-order:-2;order:-2}.flex-order-xl--1{-webkit-box-ordinal-group:0;-webkit-order:-1;order:-1}.flex-order-xl-0{-webkit-box-ordinal-group:1;-webkit-order:0;order:0}.flex-order-xl-1{-webkit-box-ordinal-group:2;-webkit-order:1;order:1}.flex-order-xl-2{-webkit-box-ordinal-group:3;-webkit-order:2;order:2}.flex-order-xl-3{-webkit-box-ordinal-group:4;-webkit-order:3;order:3}.flex-order-xl-4{-webkit-box-ordinal-group:5;-webkit-order:4;order:4}.flex-order-xl-5{-webkit-box-ordinal-group:6;-webkit-order:5;order:5}.flex-order-xl-6{-webkit-box-ordinal-group:7;-webkit-order:6;order:6}.flex-order-xl-7{-webkit-box-ordinal-group:8;-webkit-order:7;order:7}.flex-order-xl-8{-webkit-box-ordinal-group:9;-webkit-order:8;order:8}.flex-order-xl-9{-webkit-box-ordinal-group:10;-webkit-order:9;order:9}.flex-order-xl-10{-webkit-box-ordinal-group:11;-webkit-order:10;order:10}.flex-order-xl-11{-webkit-box-ordinal-group:12;-webkit-order:11;order:11}.flex-order-xl-12{-webkit-box-ordinal-group:13;-webkit-order:12;order:12}.flex-order-xl-13{-webkit-box-ordinal-group:14;-webkit-order:13;order:13}.flex-order-xl-14{-webkit-box-ordinal-group:15;-webkit-order:14;order:14}.flex-order-xl-15{-webkit-box-ordinal-group:16;-webkit-order:15;order:15}.flex-order-xl-16{-webkit-box-ordinal-group:17;-webkit-order:16;order:16}.flex-order-xl-17{-webkit-box-ordinal-group:18;-webkit-order:17;order:17}.flex-order-xl-18{-webkit-box-ordinal-group:19;-webkit-order:18;order:18}.flex-order-xl-19{-webkit-box-ordinal-group:20;-webkit-order:19;order:19}.flex-order-xl-20{-webkit-box-ordinal-group:21;-webkit-order:20;order:20}.flex-offset-xl-0,.offset-xl-0{margin-left:0}[dir=rtl] .flex-offset-xl-0,[dir=rtl] .offset-xl-0{margin-left:auto;margin-right:0}.flex-offset-xl-5,.offset-xl-5{margin-left:5%}[dir=rtl] .flex-offset-xl-5,[dir=rtl] .offset-xl-5{margin-left:auto;margin-right:5%}.flex-offset-xl-10,.offset-xl-10{margin-left:10%}[dir=rtl] .flex-offset-xl-10,[dir=rtl] .offset-xl-10{margin-left:auto;margin-right:10%}.flex-offset-xl-15,.offset-xl-15{margin-left:15%}[dir=rtl] .flex-offset-xl-15,[dir=rtl] .offset-xl-15{margin-left:auto;margin-right:15%}.flex-offset-xl-20,.offset-xl-20{margin-left:20%}[dir=rtl] .flex-offset-xl-20,[dir=rtl] .offset-xl-20{margin-left:auto;margin-right:20%}.flex-offset-xl-25,.offset-xl-25{margin-left:25%}[dir=rtl] .flex-offset-xl-25,[dir=rtl] .offset-xl-25{margin-left:auto;margin-right:25%}.flex-offset-xl-30,.offset-xl-30{margin-left:30%}[dir=rtl] .flex-offset-xl-30,[dir=rtl] .offset-xl-30{margin-left:auto;margin-right:30%}.flex-offset-xl-35,.offset-xl-35{margin-left:35%}[dir=rtl] .flex-offset-xl-35,[dir=rtl] .offset-xl-35{margin-left:auto;margin-right:35%}.flex-offset-xl-40,.offset-xl-40{margin-left:40%}[dir=rtl] .flex-offset-xl-40,[dir=rtl] .offset-xl-40{margin-left:auto;margin-right:40%}.flex-offset-xl-45,.offset-xl-45{margin-left:45%}[dir=rtl] .flex-offset-xl-45,[dir=rtl] .offset-xl-45{margin-left:auto;margin-right:45%}.flex-offset-xl-50,.offset-xl-50{margin-left:50%}[dir=rtl] .flex-offset-xl-50,[dir=rtl] .offset-xl-50{margin-left:auto;margin-right:50%}.flex-offset-xl-55,.offset-xl-55{margin-left:55%}[dir=rtl] .flex-offset-xl-55,[dir=rtl] .offset-xl-55{margin-left:auto;margin-right:55%}.flex-offset-xl-60,.offset-xl-60{margin-left:60%}[dir=rtl] .flex-offset-xl-60,[dir=rtl] .offset-xl-60{margin-left:auto;margin-right:60%}.flex-offset-xl-65,.offset-xl-65{margin-left:65%}[dir=rtl] .flex-offset-xl-65,[dir=rtl] .offset-xl-65{margin-left:auto;margin-right:65%}.flex-offset-xl-70,.offset-xl-70{margin-left:70%}[dir=rtl] .flex-offset-xl-70,[dir=rtl] .offset-xl-70{margin-left:auto;margin-right:70%}.flex-offset-xl-75,.offset-xl-75{margin-left:75%}[dir=rtl] .flex-offset-xl-75,[dir=rtl] .offset-xl-75{margin-left:auto;margin-right:75%}.flex-offset-xl-80,.offset-xl-80{margin-left:80%}[dir=rtl] .flex-offset-xl-80,[dir=rtl] .offset-xl-80{margin-left:auto;margin-right:80%}.flex-offset-xl-85,.offset-xl-85{margin-left:85%}[dir=rtl] .flex-offset-xl-85,[dir=rtl] .offset-xl-85{margin-left:auto;margin-right:85%}.flex-offset-xl-90,.offset-xl-90{margin-left:90%}[dir=rtl] .flex-offset-xl-90,[dir=rtl] .offset-xl-90{margin-left:auto;margin-right:90%}.flex-offset-xl-95,.offset-xl-95{margin-left:95%}[dir=rtl] .flex-offset-xl-95,[dir=rtl] .offset-xl-95{margin-left:auto;margin-right:95%}.flex-offset-xl-33,.offset-xl-33{margin-left:33.33333%}.flex-offset-xl-66,.offset-xl-66{margin-left:66.66667%}[dir=rtl] .flex-offset-xl-66,[dir=rtl] .offset-xl-66{margin-left:auto;margin-right:66.66667%}.layout-align-xl,.layout-align-xl-start-stretch{-webkit-align-content:stretch;align-content:stretch;-webkit-box-align:stretch;-webkit-align-items:stretch;align-items:stretch}.layout-align-xl,.layout-align-xl-start,.layout-align-xl-start-center,.layout-align-xl-start-end,.layout-align-xl-start-start,.layout-align-xl-start-stretch{-webkit-box-pack:start;-webkit-justify-content:flex-start;justify-content:flex-start}.layout-align-xl-center,.layout-align-xl-center-center,.layout-align-xl-center-end,.layout-align-xl-center-start,.layout-align-xl-center-stretch{-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center}.layout-align-xl-end,.layout-align-xl-end-center,.layout-align-xl-end-end,.layout-align-xl-end-start,.layout-align-xl-end-stretch{-webkit-box-pack:end;-webkit-justify-content:flex-end;justify-content:flex-end}.layout-align-xl-space-around,.layout-align-xl-space-around-center,.layout-align-xl-space-around-end,.layout-align-xl-space-around-start,.layout-align-xl-space-around-stretch{-webkit-justify-content:space-around;justify-content:space-around}.layout-align-xl-space-between,.layout-align-xl-space-between-center,.layout-align-xl-space-between-end,.layout-align-xl-space-between-start,.layout-align-xl-space-between-stretch{-webkit-box-pack:justify;-webkit-justify-content:space-between;justify-content:space-between}.layout-align-xl-center-start,.layout-align-xl-end-start,.layout-align-xl-space-around-start,.layout-align-xl-space-between-start,.layout-align-xl-start-start{-webkit-box-align:start;-webkit-align-items:flex-start;align-items:flex-start;-webkit-align-content:flex-start;align-content:flex-start}.layout-align-xl-center-center,.layout-align-xl-end-center,.layout-align-xl-space-around-center,.layout-align-xl-space-between-center,.layout-align-xl-start-center{-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-align-content:center;align-content:center;max-width:100%}.layout-align-xl-center-center>*,.layout-align-xl-end-center>*,.layout-align-xl-space-around-center>*,.layout-align-xl-space-between-center>*,.layout-align-xl-start-center>*{max-width:100%;box-sizing:border-box}.layout-align-xl-center-end,.layout-align-xl-end-end,.layout-align-xl-space-around-end,.layout-align-xl-space-between-end,.layout-align-xl-start-end{-webkit-box-align:end;-webkit-align-items:flex-end;align-items:flex-end;-webkit-align-content:flex-end;align-content:flex-end}.layout-align-xl-center-stretch,.layout-align-xl-end-stretch,.layout-align-xl-space-around-stretch,.layout-align-xl-space-between-stretch,.layout-align-xl-start-stretch{-webkit-box-align:stretch;-webkit-align-items:stretch;align-items:stretch;-webkit-align-content:stretch;align-content:stretch}.flex-xl{-webkit-flex:1;flex:1}.flex-xl,.flex-xl-grow{-webkit-box-flex:1;box-sizing:border-box}.flex-xl-grow{-webkit-flex:1 1 100%;flex:1 1 100%}.flex-xl-initial{-webkit-box-flex:0;-webkit-flex:0 1 auto;flex:0 1 auto;box-sizing:border-box}.flex-xl-auto{-webkit-box-flex:1;-webkit-flex:1 1 auto;flex:1 1 auto;box-sizing:border-box}.flex-xl-none{-webkit-box-flex:0;-webkit-flex:0 0 auto;flex:0 0 auto;box-sizing:border-box}.flex-xl-noshrink{-webkit-box-flex:1;-webkit-flex:1 0 auto;flex:1 0 auto;box-sizing:border-box}.flex-xl-nogrow{-webkit-box-flex:0;-webkit-flex:0 1 auto;flex:0 1 auto;box-sizing:border-box}.flex-xl-0,.layout-row>.flex-xl-0{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:0;max-height:100%;box-sizing:border-box}.layout-row>.flex-xl-0{min-width:0}.layout-column>.flex-xl-0{max-width:100%;max-height:0%}.layout-column>.flex-xl-0,.layout-xl-row>.flex-xl-0{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xl-row>.flex-xl-0{max-width:0;max-height:100%;min-width:0}.layout-xl-column>.flex-xl-0{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;max-height:0%;box-sizing:border-box;min-height:0}.flex-xl-5,.layout-row>.flex-xl-5{max-width:5%;max-height:100%}.flex-xl-5,.layout-column>.flex-xl-5,.layout-row>.flex-xl-5{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xl-5{max-width:100%;max-height:5%}.layout-xl-row>.flex-xl-5{max-width:5%;max-height:100%}.layout-xl-column>.flex-xl-5,.layout-xl-row>.flex-xl-5{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xl-column>.flex-xl-5{max-width:100%;max-height:5%}.flex-xl-10,.layout-row>.flex-xl-10{max-width:10%;max-height:100%}.flex-xl-10,.layout-column>.flex-xl-10,.layout-row>.flex-xl-10{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xl-10{max-width:100%;max-height:10%}.layout-xl-row>.flex-xl-10{max-width:10%;max-height:100%}.layout-xl-column>.flex-xl-10,.layout-xl-row>.flex-xl-10{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xl-column>.flex-xl-10{max-width:100%;max-height:10%}.flex-xl-15,.layout-row>.flex-xl-15{max-width:15%;max-height:100%}.flex-xl-15,.layout-column>.flex-xl-15,.layout-row>.flex-xl-15{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xl-15{max-width:100%;max-height:15%}.layout-xl-row>.flex-xl-15{max-width:15%;max-height:100%}.layout-xl-column>.flex-xl-15,.layout-xl-row>.flex-xl-15{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xl-column>.flex-xl-15{max-width:100%;max-height:15%}.flex-xl-20,.layout-row>.flex-xl-20{max-width:20%;max-height:100%}.flex-xl-20,.layout-column>.flex-xl-20,.layout-row>.flex-xl-20{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xl-20{max-width:100%;max-height:20%}.layout-xl-row>.flex-xl-20{max-width:20%;max-height:100%}.layout-xl-column>.flex-xl-20,.layout-xl-row>.flex-xl-20{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xl-column>.flex-xl-20{max-width:100%;max-height:20%}.flex-xl-25,.layout-row>.flex-xl-25{max-width:25%;max-height:100%}.flex-xl-25,.layout-column>.flex-xl-25,.layout-row>.flex-xl-25{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xl-25{max-width:100%;max-height:25%}.layout-xl-row>.flex-xl-25{max-width:25%;max-height:100%}.layout-xl-column>.flex-xl-25,.layout-xl-row>.flex-xl-25{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xl-column>.flex-xl-25{max-width:100%;max-height:25%}.flex-xl-30,.layout-row>.flex-xl-30{max-width:30%;max-height:100%}.flex-xl-30,.layout-column>.flex-xl-30,.layout-row>.flex-xl-30{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xl-30{max-width:100%;max-height:30%}.layout-xl-row>.flex-xl-30{max-width:30%;max-height:100%}.layout-xl-column>.flex-xl-30,.layout-xl-row>.flex-xl-30{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xl-column>.flex-xl-30{max-width:100%;max-height:30%}.flex-xl-35,.layout-row>.flex-xl-35{max-width:35%;max-height:100%}.flex-xl-35,.layout-column>.flex-xl-35,.layout-row>.flex-xl-35{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xl-35{max-width:100%;max-height:35%}.layout-xl-row>.flex-xl-35{max-width:35%;max-height:100%}.layout-xl-column>.flex-xl-35,.layout-xl-row>.flex-xl-35{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xl-column>.flex-xl-35{max-width:100%;max-height:35%}.flex-xl-40,.layout-row>.flex-xl-40{max-width:40%;max-height:100%}.flex-xl-40,.layout-column>.flex-xl-40,.layout-row>.flex-xl-40{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xl-40{max-width:100%;max-height:40%}.layout-xl-row>.flex-xl-40{max-width:40%;max-height:100%}.layout-xl-column>.flex-xl-40,.layout-xl-row>.flex-xl-40{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xl-column>.flex-xl-40{max-width:100%;max-height:40%}.flex-xl-45,.layout-row>.flex-xl-45{max-width:45%;max-height:100%}.flex-xl-45,.layout-column>.flex-xl-45,.layout-row>.flex-xl-45{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xl-45{max-width:100%;max-height:45%}.layout-xl-row>.flex-xl-45{max-width:45%;max-height:100%}.layout-xl-column>.flex-xl-45,.layout-xl-row>.flex-xl-45{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xl-column>.flex-xl-45{max-width:100%;max-height:45%}.flex-xl-50,.layout-row>.flex-xl-50{max-width:50%;max-height:100%}.flex-xl-50,.layout-column>.flex-xl-50,.layout-row>.flex-xl-50{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xl-50{max-width:100%;max-height:50%}.layout-xl-row>.flex-xl-50{max-width:50%;max-height:100%}.layout-xl-column>.flex-xl-50,.layout-xl-row>.flex-xl-50{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xl-column>.flex-xl-50{max-width:100%;max-height:50%}.flex-xl-55,.layout-row>.flex-xl-55{max-width:55%;max-height:100%}.flex-xl-55,.layout-column>.flex-xl-55,.layout-row>.flex-xl-55{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xl-55{max-width:100%;max-height:55%}.layout-xl-row>.flex-xl-55{max-width:55%;max-height:100%}.layout-xl-column>.flex-xl-55,.layout-xl-row>.flex-xl-55{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xl-column>.flex-xl-55{max-width:100%;max-height:55%}.flex-xl-60,.layout-row>.flex-xl-60{max-width:60%;max-height:100%}.flex-xl-60,.layout-column>.flex-xl-60,.layout-row>.flex-xl-60{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xl-60{max-width:100%;max-height:60%}.layout-xl-row>.flex-xl-60{max-width:60%;max-height:100%}.layout-xl-column>.flex-xl-60,.layout-xl-row>.flex-xl-60{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xl-column>.flex-xl-60{max-width:100%;max-height:60%}.flex-xl-65,.layout-row>.flex-xl-65{max-width:65%;max-height:100%}.flex-xl-65,.layout-column>.flex-xl-65,.layout-row>.flex-xl-65{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xl-65{max-width:100%;max-height:65%}.layout-xl-row>.flex-xl-65{max-width:65%;max-height:100%}.layout-xl-column>.flex-xl-65,.layout-xl-row>.flex-xl-65{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xl-column>.flex-xl-65{max-width:100%;max-height:65%}.flex-xl-70,.layout-row>.flex-xl-70{max-width:70%;max-height:100%}.flex-xl-70,.layout-column>.flex-xl-70,.layout-row>.flex-xl-70{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xl-70{max-width:100%;max-height:70%}.layout-xl-row>.flex-xl-70{max-width:70%;max-height:100%}.layout-xl-column>.flex-xl-70,.layout-xl-row>.flex-xl-70{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xl-column>.flex-xl-70{max-width:100%;max-height:70%}.flex-xl-75,.layout-row>.flex-xl-75{max-width:75%;max-height:100%}.flex-xl-75,.layout-column>.flex-xl-75,.layout-row>.flex-xl-75{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xl-75{max-width:100%;max-height:75%}.layout-xl-row>.flex-xl-75{max-width:75%;max-height:100%}.layout-xl-column>.flex-xl-75,.layout-xl-row>.flex-xl-75{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xl-column>.flex-xl-75{max-width:100%;max-height:75%}.flex-xl-80,.layout-row>.flex-xl-80{max-width:80%;max-height:100%}.flex-xl-80,.layout-column>.flex-xl-80,.layout-row>.flex-xl-80{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xl-80{max-width:100%;max-height:80%}.layout-xl-row>.flex-xl-80{max-width:80%;max-height:100%}.layout-xl-column>.flex-xl-80,.layout-xl-row>.flex-xl-80{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xl-column>.flex-xl-80{max-width:100%;max-height:80%}.flex-xl-85,.layout-row>.flex-xl-85{max-width:85%;max-height:100%}.flex-xl-85,.layout-column>.flex-xl-85,.layout-row>.flex-xl-85{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xl-85{max-width:100%;max-height:85%}.layout-xl-row>.flex-xl-85{max-width:85%;max-height:100%}.layout-xl-column>.flex-xl-85,.layout-xl-row>.flex-xl-85{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xl-column>.flex-xl-85{max-width:100%;max-height:85%}.flex-xl-90,.layout-row>.flex-xl-90{max-width:90%;max-height:100%}.flex-xl-90,.layout-column>.flex-xl-90,.layout-row>.flex-xl-90{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xl-90{max-width:100%;max-height:90%}.layout-xl-row>.flex-xl-90{max-width:90%;max-height:100%}.layout-xl-column>.flex-xl-90,.layout-xl-row>.flex-xl-90{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-xl-column>.flex-xl-90{max-width:100%;max-height:90%}.flex-xl-95,.layout-row>.flex-xl-95{max-width:95%;max-height:100%}.flex-xl-95,.layout-column>.flex-xl-95,.layout-row>.flex-xl-95{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;box-sizing:border-box}.layout-column>.flex-xl-95{max-width:100%;max-height:95%}.layout-xl-row>.flex-xl-95{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:95%;max-height:100%;box-sizing:border-box}.layout-xl-column>.flex-xl-95{max-height:95%}.flex-xl-100,.layout-xl-column>.flex-xl-95{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;box-sizing:border-box}.flex-xl-100{max-height:100%}.layout-column>.flex-xl-100,.layout-row>.flex-xl-100,.layout-xl-column>.flex-xl-100,.layout-xl-row>.flex-xl-100{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;max-height:100%;box-sizing:border-box}.layout-row>.flex-xl-33{-webkit-flex:1 1 33.33%;flex:1 1 33.33%;max-width:33.33%}.layout-row>.flex-xl-33,.layout-row>.flex-xl-66{-webkit-box-flex:1;max-height:100%;box-sizing:border-box}.layout-row>.flex-xl-66{-webkit-flex:1 1 66.66%;flex:1 1 66.66%;max-width:66.66%}.layout-column>.flex-xl-33{-webkit-flex:1 1 33.33%;flex:1 1 33.33%;max-height:33.33%}.layout-column>.flex-xl-33,.layout-column>.flex-xl-66{-webkit-box-flex:1;max-width:100%;box-sizing:border-box}.layout-column>.flex-xl-66{-webkit-flex:1 1 66.66%;flex:1 1 66.66%;max-height:66.66%}.layout-xl-row>.flex-xl-33{max-width:33.33%}.layout-xl-row>.flex-xl-33,.layout-xl-row>.flex-xl-66{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-height:100%;box-sizing:border-box}.layout-xl-row>.flex-xl-66{max-width:66.66%}.layout-xl-row>.flex{min-width:0}.layout-xl-column>.flex-xl-33{max-height:33.33%}.layout-xl-column>.flex-xl-33,.layout-xl-column>.flex-xl-66{-webkit-box-flex:1;-webkit-flex:1 1 100%;flex:1 1 100%;max-width:100%;box-sizing:border-box}.layout-xl-column>.flex-xl-66{max-height:66.66%}.layout-xl-column>.flex{min-height:0}.layout-xl,.layout-xl-column,.layout-xl-row{box-sizing:border-box;display:-webkit-box;display:-webkit-flex;display:flex}.layout-xl-column{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column}.layout-xl-row{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;flex-direction:row}.hide-gt-lg:not(.show-gt-xs):not(.show-gt-sm):not(.show-gt-md):not(.show-gt-lg):not(.show-xl):not(.show),.hide-gt-md:not(.show-gt-xs):not(.show-gt-sm):not(.show-gt-md):not(.show-gt-lg):not(.show-xl):not(.show),.hide-gt-sm:not(.show-gt-xs):not(.show-gt-sm):not(.show-gt-md):not(.show-gt-lg):not(.show-xl):not(.show),.hide-gt-xs:not(.show-gt-xs):not(.show-gt-sm):not(.show-gt-md):not(.show-gt-lg):not(.show-xl):not(.show),.hide-xl:not(.show-xl):not(.show-gt-lg):not(.show-gt-md):not(.show-gt-sm):not(.show-gt-xs):not(.show),.hide:not(.show-gt-xs):not(.show-gt-sm):not(.show-gt-md):not(.show-gt-lg):not(.show-xl):not(.show){display:none}}@media print{.hide-print:not(.show-print):not(.show){display:none!important}}", ""]);
	
	// exports


/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(146);
	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n *  Font Awesome 4.6.3 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */@font-face{font-family:FontAwesome;src:url(" + escape(__webpack_require__(149)) + ");src:url(" + escape(__webpack_require__(148)) + "?#iefix&v=4.6.3) format(\"embedded-opentype\"),url(" + escape(__webpack_require__(152)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(153)) + ") format(\"woff\"),url(" + escape(__webpack_require__(151)) + ") format(\"truetype\"),url(" + escape(__webpack_require__(150)) + "#fontawesomeregular) format(\"svg\");font-weight:400;font-style:normal}.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-lg{font-size:1.33333333em;line-height:.75em;vertical-align:-15%}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-fw{width:1.28571429em;text-align:center}.fa-ul{padding-left:0;margin-left:2.14285714em;list-style-type:none}.fa-ul>li{position:relative}.fa-li{position:absolute;left:-2.14285714em;width:2.14285714em;top:.14285714em;text-align:center}.fa-li.fa-lg{left:-1.85714286em}.fa-border{padding:.2em .25em .15em;border:.08em solid #eee;border-radius:.1em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left{margin-right:.3em}.fa.fa-pull-right{margin-left:.3em}.pull-right{float:right}.pull-left{float:left}.fa.pull-left{margin-right:.3em}.fa.pull-right{margin-left:.3em}.fa-spin{-webkit-animation:fa-spin 2s infinite linear;animation:fa-spin 2s infinite linear}.fa-pulse{-webkit-animation:fa-spin 1s infinite steps(8);animation:fa-spin 1s infinite steps(8)}@-webkit-keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}.fa-rotate-90{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg)}.fa-rotate-180{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg)}.fa-rotate-270{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";-webkit-transform:rotate(270deg);-ms-transform:rotate(270deg);transform:rotate(270deg)}.fa-flip-horizontal{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";-webkit-transform:scaleX(-1);-ms-transform:scaleX(-1);transform:scaleX(-1)}.fa-flip-vertical{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";-webkit-transform:scaleY(-1);-ms-transform:scaleY(-1);transform:scaleY(-1)}:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270{filter:none}.fa-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.fa-stack-1x,.fa-stack-2x{position:absolute;left:0;width:100%;text-align:center}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}.fa-glass:before{content:\"\\F000\"}.fa-music:before{content:\"\\F001\"}.fa-search:before{content:\"\\F002\"}.fa-envelope-o:before{content:\"\\F003\"}.fa-heart:before{content:\"\\F004\"}.fa-star:before{content:\"\\F005\"}.fa-star-o:before{content:\"\\F006\"}.fa-user:before{content:\"\\F007\"}.fa-film:before{content:\"\\F008\"}.fa-th-large:before{content:\"\\F009\"}.fa-th:before{content:\"\\F00A\"}.fa-th-list:before{content:\"\\F00B\"}.fa-check:before{content:\"\\F00C\"}.fa-close:before,.fa-remove:before,.fa-times:before{content:\"\\F00D\"}.fa-search-plus:before{content:\"\\F00E\"}.fa-search-minus:before{content:\"\\F010\"}.fa-power-off:before{content:\"\\F011\"}.fa-signal:before{content:\"\\F012\"}.fa-cog:before,.fa-gear:before{content:\"\\F013\"}.fa-trash-o:before{content:\"\\F014\"}.fa-home:before{content:\"\\F015\"}.fa-file-o:before{content:\"\\F016\"}.fa-clock-o:before{content:\"\\F017\"}.fa-road:before{content:\"\\F018\"}.fa-download:before{content:\"\\F019\"}.fa-arrow-circle-o-down:before{content:\"\\F01A\"}.fa-arrow-circle-o-up:before{content:\"\\F01B\"}.fa-inbox:before{content:\"\\F01C\"}.fa-play-circle-o:before{content:\"\\F01D\"}.fa-repeat:before,.fa-rotate-right:before{content:\"\\F01E\"}.fa-refresh:before{content:\"\\F021\"}.fa-list-alt:before{content:\"\\F022\"}.fa-lock:before{content:\"\\F023\"}.fa-flag:before{content:\"\\F024\"}.fa-headphones:before{content:\"\\F025\"}.fa-volume-off:before{content:\"\\F026\"}.fa-volume-down:before{content:\"\\F027\"}.fa-volume-up:before{content:\"\\F028\"}.fa-qrcode:before{content:\"\\F029\"}.fa-barcode:before{content:\"\\F02A\"}.fa-tag:before{content:\"\\F02B\"}.fa-tags:before{content:\"\\F02C\"}.fa-book:before{content:\"\\F02D\"}.fa-bookmark:before{content:\"\\F02E\"}.fa-print:before{content:\"\\F02F\"}.fa-camera:before{content:\"\\F030\"}.fa-font:before{content:\"\\F031\"}.fa-bold:before{content:\"\\F032\"}.fa-italic:before{content:\"\\F033\"}.fa-text-height:before{content:\"\\F034\"}.fa-text-width:before{content:\"\\F035\"}.fa-align-left:before{content:\"\\F036\"}.fa-align-center:before{content:\"\\F037\"}.fa-align-right:before{content:\"\\F038\"}.fa-align-justify:before{content:\"\\F039\"}.fa-list:before{content:\"\\F03A\"}.fa-dedent:before,.fa-outdent:before{content:\"\\F03B\"}.fa-indent:before{content:\"\\F03C\"}.fa-video-camera:before{content:\"\\F03D\"}.fa-image:before,.fa-photo:before,.fa-picture-o:before{content:\"\\F03E\"}.fa-pencil:before{content:\"\\F040\"}.fa-map-marker:before{content:\"\\F041\"}.fa-adjust:before{content:\"\\F042\"}.fa-tint:before{content:\"\\F043\"}.fa-edit:before,.fa-pencil-square-o:before{content:\"\\F044\"}.fa-share-square-o:before{content:\"\\F045\"}.fa-check-square-o:before{content:\"\\F046\"}.fa-arrows:before{content:\"\\F047\"}.fa-step-backward:before{content:\"\\F048\"}.fa-fast-backward:before{content:\"\\F049\"}.fa-backward:before{content:\"\\F04A\"}.fa-play:before{content:\"\\F04B\"}.fa-pause:before{content:\"\\F04C\"}.fa-stop:before{content:\"\\F04D\"}.fa-forward:before{content:\"\\F04E\"}.fa-fast-forward:before{content:\"\\F050\"}.fa-step-forward:before{content:\"\\F051\"}.fa-eject:before{content:\"\\F052\"}.fa-chevron-left:before{content:\"\\F053\"}.fa-chevron-right:before{content:\"\\F054\"}.fa-plus-circle:before{content:\"\\F055\"}.fa-minus-circle:before{content:\"\\F056\"}.fa-times-circle:before{content:\"\\F057\"}.fa-check-circle:before{content:\"\\F058\"}.fa-question-circle:before{content:\"\\F059\"}.fa-info-circle:before{content:\"\\F05A\"}.fa-crosshairs:before{content:\"\\F05B\"}.fa-times-circle-o:before{content:\"\\F05C\"}.fa-check-circle-o:before{content:\"\\F05D\"}.fa-ban:before{content:\"\\F05E\"}.fa-arrow-left:before{content:\"\\F060\"}.fa-arrow-right:before{content:\"\\F061\"}.fa-arrow-up:before{content:\"\\F062\"}.fa-arrow-down:before{content:\"\\F063\"}.fa-mail-forward:before,.fa-share:before{content:\"\\F064\"}.fa-expand:before{content:\"\\F065\"}.fa-compress:before{content:\"\\F066\"}.fa-plus:before{content:\"\\F067\"}.fa-minus:before{content:\"\\F068\"}.fa-asterisk:before{content:\"\\F069\"}.fa-exclamation-circle:before{content:\"\\F06A\"}.fa-gift:before{content:\"\\F06B\"}.fa-leaf:before{content:\"\\F06C\"}.fa-fire:before{content:\"\\F06D\"}.fa-eye:before{content:\"\\F06E\"}.fa-eye-slash:before{content:\"\\F070\"}.fa-exclamation-triangle:before,.fa-warning:before{content:\"\\F071\"}.fa-plane:before{content:\"\\F072\"}.fa-calendar:before{content:\"\\F073\"}.fa-random:before{content:\"\\F074\"}.fa-comment:before{content:\"\\F075\"}.fa-magnet:before{content:\"\\F076\"}.fa-chevron-up:before{content:\"\\F077\"}.fa-chevron-down:before{content:\"\\F078\"}.fa-retweet:before{content:\"\\F079\"}.fa-shopping-cart:before{content:\"\\F07A\"}.fa-folder:before{content:\"\\F07B\"}.fa-folder-open:before{content:\"\\F07C\"}.fa-arrows-v:before{content:\"\\F07D\"}.fa-arrows-h:before{content:\"\\F07E\"}.fa-bar-chart-o:before,.fa-bar-chart:before{content:\"\\F080\"}.fa-twitter-square:before{content:\"\\F081\"}.fa-facebook-square:before{content:\"\\F082\"}.fa-camera-retro:before{content:\"\\F083\"}.fa-key:before{content:\"\\F084\"}.fa-cogs:before,.fa-gears:before{content:\"\\F085\"}.fa-comments:before{content:\"\\F086\"}.fa-thumbs-o-up:before{content:\"\\F087\"}.fa-thumbs-o-down:before{content:\"\\F088\"}.fa-star-half:before{content:\"\\F089\"}.fa-heart-o:before{content:\"\\F08A\"}.fa-sign-out:before{content:\"\\F08B\"}.fa-linkedin-square:before{content:\"\\F08C\"}.fa-thumb-tack:before{content:\"\\F08D\"}.fa-external-link:before{content:\"\\F08E\"}.fa-sign-in:before{content:\"\\F090\"}.fa-trophy:before{content:\"\\F091\"}.fa-github-square:before{content:\"\\F092\"}.fa-upload:before{content:\"\\F093\"}.fa-lemon-o:before{content:\"\\F094\"}.fa-phone:before{content:\"\\F095\"}.fa-square-o:before{content:\"\\F096\"}.fa-bookmark-o:before{content:\"\\F097\"}.fa-phone-square:before{content:\"\\F098\"}.fa-twitter:before{content:\"\\F099\"}.fa-facebook-f:before,.fa-facebook:before{content:\"\\F09A\"}.fa-github:before{content:\"\\F09B\"}.fa-unlock:before{content:\"\\F09C\"}.fa-credit-card:before{content:\"\\F09D\"}.fa-feed:before,.fa-rss:before{content:\"\\F09E\"}.fa-hdd-o:before{content:\"\\F0A0\"}.fa-bullhorn:before{content:\"\\F0A1\"}.fa-bell:before{content:\"\\F0F3\"}.fa-certificate:before{content:\"\\F0A3\"}.fa-hand-o-right:before{content:\"\\F0A4\"}.fa-hand-o-left:before{content:\"\\F0A5\"}.fa-hand-o-up:before{content:\"\\F0A6\"}.fa-hand-o-down:before{content:\"\\F0A7\"}.fa-arrow-circle-left:before{content:\"\\F0A8\"}.fa-arrow-circle-right:before{content:\"\\F0A9\"}.fa-arrow-circle-up:before{content:\"\\F0AA\"}.fa-arrow-circle-down:before{content:\"\\F0AB\"}.fa-globe:before{content:\"\\F0AC\"}.fa-wrench:before{content:\"\\F0AD\"}.fa-tasks:before{content:\"\\F0AE\"}.fa-filter:before{content:\"\\F0B0\"}.fa-briefcase:before{content:\"\\F0B1\"}.fa-arrows-alt:before{content:\"\\F0B2\"}.fa-group:before,.fa-users:before{content:\"\\F0C0\"}.fa-chain:before,.fa-link:before{content:\"\\F0C1\"}.fa-cloud:before{content:\"\\F0C2\"}.fa-flask:before{content:\"\\F0C3\"}.fa-cut:before,.fa-scissors:before{content:\"\\F0C4\"}.fa-copy:before,.fa-files-o:before{content:\"\\F0C5\"}.fa-paperclip:before{content:\"\\F0C6\"}.fa-floppy-o:before,.fa-save:before{content:\"\\F0C7\"}.fa-square:before{content:\"\\F0C8\"}.fa-bars:before,.fa-navicon:before,.fa-reorder:before{content:\"\\F0C9\"}.fa-list-ul:before{content:\"\\F0CA\"}.fa-list-ol:before{content:\"\\F0CB\"}.fa-strikethrough:before{content:\"\\F0CC\"}.fa-underline:before{content:\"\\F0CD\"}.fa-table:before{content:\"\\F0CE\"}.fa-magic:before{content:\"\\F0D0\"}.fa-truck:before{content:\"\\F0D1\"}.fa-pinterest:before{content:\"\\F0D2\"}.fa-pinterest-square:before{content:\"\\F0D3\"}.fa-google-plus-square:before{content:\"\\F0D4\"}.fa-google-plus:before{content:\"\\F0D5\"}.fa-money:before{content:\"\\F0D6\"}.fa-caret-down:before{content:\"\\F0D7\"}.fa-caret-up:before{content:\"\\F0D8\"}.fa-caret-left:before{content:\"\\F0D9\"}.fa-caret-right:before{content:\"\\F0DA\"}.fa-columns:before{content:\"\\F0DB\"}.fa-sort:before,.fa-unsorted:before{content:\"\\F0DC\"}.fa-sort-desc:before,.fa-sort-down:before{content:\"\\F0DD\"}.fa-sort-asc:before,.fa-sort-up:before{content:\"\\F0DE\"}.fa-envelope:before{content:\"\\F0E0\"}.fa-linkedin:before{content:\"\\F0E1\"}.fa-rotate-left:before,.fa-undo:before{content:\"\\F0E2\"}.fa-gavel:before,.fa-legal:before{content:\"\\F0E3\"}.fa-dashboard:before,.fa-tachometer:before{content:\"\\F0E4\"}.fa-comment-o:before{content:\"\\F0E5\"}.fa-comments-o:before{content:\"\\F0E6\"}.fa-bolt:before,.fa-flash:before{content:\"\\F0E7\"}.fa-sitemap:before{content:\"\\F0E8\"}.fa-umbrella:before{content:\"\\F0E9\"}.fa-clipboard:before,.fa-paste:before{content:\"\\F0EA\"}.fa-lightbulb-o:before{content:\"\\F0EB\"}.fa-exchange:before{content:\"\\F0EC\"}.fa-cloud-download:before{content:\"\\F0ED\"}.fa-cloud-upload:before{content:\"\\F0EE\"}.fa-user-md:before{content:\"\\F0F0\"}.fa-stethoscope:before{content:\"\\F0F1\"}.fa-suitcase:before{content:\"\\F0F2\"}.fa-bell-o:before{content:\"\\F0A2\"}.fa-coffee:before{content:\"\\F0F4\"}.fa-cutlery:before{content:\"\\F0F5\"}.fa-file-text-o:before{content:\"\\F0F6\"}.fa-building-o:before{content:\"\\F0F7\"}.fa-hospital-o:before{content:\"\\F0F8\"}.fa-ambulance:before{content:\"\\F0F9\"}.fa-medkit:before{content:\"\\F0FA\"}.fa-fighter-jet:before{content:\"\\F0FB\"}.fa-beer:before{content:\"\\F0FC\"}.fa-h-square:before{content:\"\\F0FD\"}.fa-plus-square:before{content:\"\\F0FE\"}.fa-angle-double-left:before{content:\"\\F100\"}.fa-angle-double-right:before{content:\"\\F101\"}.fa-angle-double-up:before{content:\"\\F102\"}.fa-angle-double-down:before{content:\"\\F103\"}.fa-angle-left:before{content:\"\\F104\"}.fa-angle-right:before{content:\"\\F105\"}.fa-angle-up:before{content:\"\\F106\"}.fa-angle-down:before{content:\"\\F107\"}.fa-desktop:before{content:\"\\F108\"}.fa-laptop:before{content:\"\\F109\"}.fa-tablet:before{content:\"\\F10A\"}.fa-mobile-phone:before,.fa-mobile:before{content:\"\\F10B\"}.fa-circle-o:before{content:\"\\F10C\"}.fa-quote-left:before{content:\"\\F10D\"}.fa-quote-right:before{content:\"\\F10E\"}.fa-spinner:before{content:\"\\F110\"}.fa-circle:before{content:\"\\F111\"}.fa-mail-reply:before,.fa-reply:before{content:\"\\F112\"}.fa-github-alt:before{content:\"\\F113\"}.fa-folder-o:before{content:\"\\F114\"}.fa-folder-open-o:before{content:\"\\F115\"}.fa-smile-o:before{content:\"\\F118\"}.fa-frown-o:before{content:\"\\F119\"}.fa-meh-o:before{content:\"\\F11A\"}.fa-gamepad:before{content:\"\\F11B\"}.fa-keyboard-o:before{content:\"\\F11C\"}.fa-flag-o:before{content:\"\\F11D\"}.fa-flag-checkered:before{content:\"\\F11E\"}.fa-terminal:before{content:\"\\F120\"}.fa-code:before{content:\"\\F121\"}.fa-mail-reply-all:before,.fa-reply-all:before{content:\"\\F122\"}.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before{content:\"\\F123\"}.fa-location-arrow:before{content:\"\\F124\"}.fa-crop:before{content:\"\\F125\"}.fa-code-fork:before{content:\"\\F126\"}.fa-chain-broken:before,.fa-unlink:before{content:\"\\F127\"}.fa-question:before{content:\"\\F128\"}.fa-info:before{content:\"\\F129\"}.fa-exclamation:before{content:\"\\F12A\"}.fa-superscript:before{content:\"\\F12B\"}.fa-subscript:before{content:\"\\F12C\"}.fa-eraser:before{content:\"\\F12D\"}.fa-puzzle-piece:before{content:\"\\F12E\"}.fa-microphone:before{content:\"\\F130\"}.fa-microphone-slash:before{content:\"\\F131\"}.fa-shield:before{content:\"\\F132\"}.fa-calendar-o:before{content:\"\\F133\"}.fa-fire-extinguisher:before{content:\"\\F134\"}.fa-rocket:before{content:\"\\F135\"}.fa-maxcdn:before{content:\"\\F136\"}.fa-chevron-circle-left:before{content:\"\\F137\"}.fa-chevron-circle-right:before{content:\"\\F138\"}.fa-chevron-circle-up:before{content:\"\\F139\"}.fa-chevron-circle-down:before{content:\"\\F13A\"}.fa-html5:before{content:\"\\F13B\"}.fa-css3:before{content:\"\\F13C\"}.fa-anchor:before{content:\"\\F13D\"}.fa-unlock-alt:before{content:\"\\F13E\"}.fa-bullseye:before{content:\"\\F140\"}.fa-ellipsis-h:before{content:\"\\F141\"}.fa-ellipsis-v:before{content:\"\\F142\"}.fa-rss-square:before{content:\"\\F143\"}.fa-play-circle:before{content:\"\\F144\"}.fa-ticket:before{content:\"\\F145\"}.fa-minus-square:before{content:\"\\F146\"}.fa-minus-square-o:before{content:\"\\F147\"}.fa-level-up:before{content:\"\\F148\"}.fa-level-down:before{content:\"\\F149\"}.fa-check-square:before{content:\"\\F14A\"}.fa-pencil-square:before{content:\"\\F14B\"}.fa-external-link-square:before{content:\"\\F14C\"}.fa-share-square:before{content:\"\\F14D\"}.fa-compass:before{content:\"\\F14E\"}.fa-caret-square-o-down:before,.fa-toggle-down:before{content:\"\\F150\"}.fa-caret-square-o-up:before,.fa-toggle-up:before{content:\"\\F151\"}.fa-caret-square-o-right:before,.fa-toggle-right:before{content:\"\\F152\"}.fa-eur:before,.fa-euro:before{content:\"\\F153\"}.fa-gbp:before{content:\"\\F154\"}.fa-dollar:before,.fa-usd:before{content:\"\\F155\"}.fa-inr:before,.fa-rupee:before{content:\"\\F156\"}.fa-cny:before,.fa-jpy:before,.fa-rmb:before,.fa-yen:before{content:\"\\F157\"}.fa-rouble:before,.fa-rub:before,.fa-ruble:before{content:\"\\F158\"}.fa-krw:before,.fa-won:before{content:\"\\F159\"}.fa-bitcoin:before,.fa-btc:before{content:\"\\F15A\"}.fa-file:before{content:\"\\F15B\"}.fa-file-text:before{content:\"\\F15C\"}.fa-sort-alpha-asc:before{content:\"\\F15D\"}.fa-sort-alpha-desc:before{content:\"\\F15E\"}.fa-sort-amount-asc:before{content:\"\\F160\"}.fa-sort-amount-desc:before{content:\"\\F161\"}.fa-sort-numeric-asc:before{content:\"\\F162\"}.fa-sort-numeric-desc:before{content:\"\\F163\"}.fa-thumbs-up:before{content:\"\\F164\"}.fa-thumbs-down:before{content:\"\\F165\"}.fa-youtube-square:before{content:\"\\F166\"}.fa-youtube:before{content:\"\\F167\"}.fa-xing:before{content:\"\\F168\"}.fa-xing-square:before{content:\"\\F169\"}.fa-youtube-play:before{content:\"\\F16A\"}.fa-dropbox:before{content:\"\\F16B\"}.fa-stack-overflow:before{content:\"\\F16C\"}.fa-instagram:before{content:\"\\F16D\"}.fa-flickr:before{content:\"\\F16E\"}.fa-adn:before{content:\"\\F170\"}.fa-bitbucket:before{content:\"\\F171\"}.fa-bitbucket-square:before{content:\"\\F172\"}.fa-tumblr:before{content:\"\\F173\"}.fa-tumblr-square:before{content:\"\\F174\"}.fa-long-arrow-down:before{content:\"\\F175\"}.fa-long-arrow-up:before{content:\"\\F176\"}.fa-long-arrow-left:before{content:\"\\F177\"}.fa-long-arrow-right:before{content:\"\\F178\"}.fa-apple:before{content:\"\\F179\"}.fa-windows:before{content:\"\\F17A\"}.fa-android:before{content:\"\\F17B\"}.fa-linux:before{content:\"\\F17C\"}.fa-dribbble:before{content:\"\\F17D\"}.fa-skype:before{content:\"\\F17E\"}.fa-foursquare:before{content:\"\\F180\"}.fa-trello:before{content:\"\\F181\"}.fa-female:before{content:\"\\F182\"}.fa-male:before{content:\"\\F183\"}.fa-gittip:before,.fa-gratipay:before{content:\"\\F184\"}.fa-sun-o:before{content:\"\\F185\"}.fa-moon-o:before{content:\"\\F186\"}.fa-archive:before{content:\"\\F187\"}.fa-bug:before{content:\"\\F188\"}.fa-vk:before{content:\"\\F189\"}.fa-weibo:before{content:\"\\F18A\"}.fa-renren:before{content:\"\\F18B\"}.fa-pagelines:before{content:\"\\F18C\"}.fa-stack-exchange:before{content:\"\\F18D\"}.fa-arrow-circle-o-right:before{content:\"\\F18E\"}.fa-arrow-circle-o-left:before{content:\"\\F190\"}.fa-caret-square-o-left:before,.fa-toggle-left:before{content:\"\\F191\"}.fa-dot-circle-o:before{content:\"\\F192\"}.fa-wheelchair:before{content:\"\\F193\"}.fa-vimeo-square:before{content:\"\\F194\"}.fa-try:before,.fa-turkish-lira:before{content:\"\\F195\"}.fa-plus-square-o:before{content:\"\\F196\"}.fa-space-shuttle:before{content:\"\\F197\"}.fa-slack:before{content:\"\\F198\"}.fa-envelope-square:before{content:\"\\F199\"}.fa-wordpress:before{content:\"\\F19A\"}.fa-openid:before{content:\"\\F19B\"}.fa-bank:before,.fa-institution:before,.fa-university:before{content:\"\\F19C\"}.fa-graduation-cap:before,.fa-mortar-board:before{content:\"\\F19D\"}.fa-yahoo:before{content:\"\\F19E\"}.fa-google:before{content:\"\\F1A0\"}.fa-reddit:before{content:\"\\F1A1\"}.fa-reddit-square:before{content:\"\\F1A2\"}.fa-stumbleupon-circle:before{content:\"\\F1A3\"}.fa-stumbleupon:before{content:\"\\F1A4\"}.fa-delicious:before{content:\"\\F1A5\"}.fa-digg:before{content:\"\\F1A6\"}.fa-pied-piper-pp:before{content:\"\\F1A7\"}.fa-pied-piper-alt:before{content:\"\\F1A8\"}.fa-drupal:before{content:\"\\F1A9\"}.fa-joomla:before{content:\"\\F1AA\"}.fa-language:before{content:\"\\F1AB\"}.fa-fax:before{content:\"\\F1AC\"}.fa-building:before{content:\"\\F1AD\"}.fa-child:before{content:\"\\F1AE\"}.fa-paw:before{content:\"\\F1B0\"}.fa-spoon:before{content:\"\\F1B1\"}.fa-cube:before{content:\"\\F1B2\"}.fa-cubes:before{content:\"\\F1B3\"}.fa-behance:before{content:\"\\F1B4\"}.fa-behance-square:before{content:\"\\F1B5\"}.fa-steam:before{content:\"\\F1B6\"}.fa-steam-square:before{content:\"\\F1B7\"}.fa-recycle:before{content:\"\\F1B8\"}.fa-automobile:before,.fa-car:before{content:\"\\F1B9\"}.fa-cab:before,.fa-taxi:before{content:\"\\F1BA\"}.fa-tree:before{content:\"\\F1BB\"}.fa-spotify:before{content:\"\\F1BC\"}.fa-deviantart:before{content:\"\\F1BD\"}.fa-soundcloud:before{content:\"\\F1BE\"}.fa-database:before{content:\"\\F1C0\"}.fa-file-pdf-o:before{content:\"\\F1C1\"}.fa-file-word-o:before{content:\"\\F1C2\"}.fa-file-excel-o:before{content:\"\\F1C3\"}.fa-file-powerpoint-o:before{content:\"\\F1C4\"}.fa-file-image-o:before,.fa-file-photo-o:before,.fa-file-picture-o:before{content:\"\\F1C5\"}.fa-file-archive-o:before,.fa-file-zip-o:before{content:\"\\F1C6\"}.fa-file-audio-o:before,.fa-file-sound-o:before{content:\"\\F1C7\"}.fa-file-movie-o:before,.fa-file-video-o:before{content:\"\\F1C8\"}.fa-file-code-o:before{content:\"\\F1C9\"}.fa-vine:before{content:\"\\F1CA\"}.fa-codepen:before{content:\"\\F1CB\"}.fa-jsfiddle:before{content:\"\\F1CC\"}.fa-life-bouy:before,.fa-life-buoy:before,.fa-life-ring:before,.fa-life-saver:before,.fa-support:before{content:\"\\F1CD\"}.fa-circle-o-notch:before{content:\"\\F1CE\"}.fa-ra:before,.fa-rebel:before,.fa-resistance:before{content:\"\\F1D0\"}.fa-empire:before,.fa-ge:before{content:\"\\F1D1\"}.fa-git-square:before{content:\"\\F1D2\"}.fa-git:before{content:\"\\F1D3\"}.fa-hacker-news:before,.fa-y-combinator-square:before,.fa-yc-square:before{content:\"\\F1D4\"}.fa-tencent-weibo:before{content:\"\\F1D5\"}.fa-qq:before{content:\"\\F1D6\"}.fa-wechat:before,.fa-weixin:before{content:\"\\F1D7\"}.fa-paper-plane:before,.fa-send:before{content:\"\\F1D8\"}.fa-paper-plane-o:before,.fa-send-o:before{content:\"\\F1D9\"}.fa-history:before{content:\"\\F1DA\"}.fa-circle-thin:before{content:\"\\F1DB\"}.fa-header:before{content:\"\\F1DC\"}.fa-paragraph:before{content:\"\\F1DD\"}.fa-sliders:before{content:\"\\F1DE\"}.fa-share-alt:before{content:\"\\F1E0\"}.fa-share-alt-square:before{content:\"\\F1E1\"}.fa-bomb:before{content:\"\\F1E2\"}.fa-futbol-o:before,.fa-soccer-ball-o:before{content:\"\\F1E3\"}.fa-tty:before{content:\"\\F1E4\"}.fa-binoculars:before{content:\"\\F1E5\"}.fa-plug:before{content:\"\\F1E6\"}.fa-slideshare:before{content:\"\\F1E7\"}.fa-twitch:before{content:\"\\F1E8\"}.fa-yelp:before{content:\"\\F1E9\"}.fa-newspaper-o:before{content:\"\\F1EA\"}.fa-wifi:before{content:\"\\F1EB\"}.fa-calculator:before{content:\"\\F1EC\"}.fa-paypal:before{content:\"\\F1ED\"}.fa-google-wallet:before{content:\"\\F1EE\"}.fa-cc-visa:before{content:\"\\F1F0\"}.fa-cc-mastercard:before{content:\"\\F1F1\"}.fa-cc-discover:before{content:\"\\F1F2\"}.fa-cc-amex:before{content:\"\\F1F3\"}.fa-cc-paypal:before{content:\"\\F1F4\"}.fa-cc-stripe:before{content:\"\\F1F5\"}.fa-bell-slash:before{content:\"\\F1F6\"}.fa-bell-slash-o:before{content:\"\\F1F7\"}.fa-trash:before{content:\"\\F1F8\"}.fa-copyright:before{content:\"\\F1F9\"}.fa-at:before{content:\"\\F1FA\"}.fa-eyedropper:before{content:\"\\F1FB\"}.fa-paint-brush:before{content:\"\\F1FC\"}.fa-birthday-cake:before{content:\"\\F1FD\"}.fa-area-chart:before{content:\"\\F1FE\"}.fa-pie-chart:before{content:\"\\F200\"}.fa-line-chart:before{content:\"\\F201\"}.fa-lastfm:before{content:\"\\F202\"}.fa-lastfm-square:before{content:\"\\F203\"}.fa-toggle-off:before{content:\"\\F204\"}.fa-toggle-on:before{content:\"\\F205\"}.fa-bicycle:before{content:\"\\F206\"}.fa-bus:before{content:\"\\F207\"}.fa-ioxhost:before{content:\"\\F208\"}.fa-angellist:before{content:\"\\F209\"}.fa-cc:before{content:\"\\F20A\"}.fa-ils:before,.fa-shekel:before,.fa-sheqel:before{content:\"\\F20B\"}.fa-meanpath:before{content:\"\\F20C\"}.fa-buysellads:before{content:\"\\F20D\"}.fa-connectdevelop:before{content:\"\\F20E\"}.fa-dashcube:before{content:\"\\F210\"}.fa-forumbee:before{content:\"\\F211\"}.fa-leanpub:before{content:\"\\F212\"}.fa-sellsy:before{content:\"\\F213\"}.fa-shirtsinbulk:before{content:\"\\F214\"}.fa-simplybuilt:before{content:\"\\F215\"}.fa-skyatlas:before{content:\"\\F216\"}.fa-cart-plus:before{content:\"\\F217\"}.fa-cart-arrow-down:before{content:\"\\F218\"}.fa-diamond:before{content:\"\\F219\"}.fa-ship:before{content:\"\\F21A\"}.fa-user-secret:before{content:\"\\F21B\"}.fa-motorcycle:before{content:\"\\F21C\"}.fa-street-view:before{content:\"\\F21D\"}.fa-heartbeat:before{content:\"\\F21E\"}.fa-venus:before{content:\"\\F221\"}.fa-mars:before{content:\"\\F222\"}.fa-mercury:before{content:\"\\F223\"}.fa-intersex:before,.fa-transgender:before{content:\"\\F224\"}.fa-transgender-alt:before{content:\"\\F225\"}.fa-venus-double:before{content:\"\\F226\"}.fa-mars-double:before{content:\"\\F227\"}.fa-venus-mars:before{content:\"\\F228\"}.fa-mars-stroke:before{content:\"\\F229\"}.fa-mars-stroke-v:before{content:\"\\F22A\"}.fa-mars-stroke-h:before{content:\"\\F22B\"}.fa-neuter:before{content:\"\\F22C\"}.fa-genderless:before{content:\"\\F22D\"}.fa-facebook-official:before{content:\"\\F230\"}.fa-pinterest-p:before{content:\"\\F231\"}.fa-whatsapp:before{content:\"\\F232\"}.fa-server:before{content:\"\\F233\"}.fa-user-plus:before{content:\"\\F234\"}.fa-user-times:before{content:\"\\F235\"}.fa-bed:before,.fa-hotel:before{content:\"\\F236\"}.fa-viacoin:before{content:\"\\F237\"}.fa-train:before{content:\"\\F238\"}.fa-subway:before{content:\"\\F239\"}.fa-medium:before{content:\"\\F23A\"}.fa-y-combinator:before,.fa-yc:before{content:\"\\F23B\"}.fa-optin-monster:before{content:\"\\F23C\"}.fa-opencart:before{content:\"\\F23D\"}.fa-expeditedssl:before{content:\"\\F23E\"}.fa-battery-4:before,.fa-battery-full:before{content:\"\\F240\"}.fa-battery-3:before,.fa-battery-three-quarters:before{content:\"\\F241\"}.fa-battery-2:before,.fa-battery-half:before{content:\"\\F242\"}.fa-battery-1:before,.fa-battery-quarter:before{content:\"\\F243\"}.fa-battery-0:before,.fa-battery-empty:before{content:\"\\F244\"}.fa-mouse-pointer:before{content:\"\\F245\"}.fa-i-cursor:before{content:\"\\F246\"}.fa-object-group:before{content:\"\\F247\"}.fa-object-ungroup:before{content:\"\\F248\"}.fa-sticky-note:before{content:\"\\F249\"}.fa-sticky-note-o:before{content:\"\\F24A\"}.fa-cc-jcb:before{content:\"\\F24B\"}.fa-cc-diners-club:before{content:\"\\F24C\"}.fa-clone:before{content:\"\\F24D\"}.fa-balance-scale:before{content:\"\\F24E\"}.fa-hourglass-o:before{content:\"\\F250\"}.fa-hourglass-1:before,.fa-hourglass-start:before{content:\"\\F251\"}.fa-hourglass-2:before,.fa-hourglass-half:before{content:\"\\F252\"}.fa-hourglass-3:before,.fa-hourglass-end:before{content:\"\\F253\"}.fa-hourglass:before{content:\"\\F254\"}.fa-hand-grab-o:before,.fa-hand-rock-o:before{content:\"\\F255\"}.fa-hand-paper-o:before,.fa-hand-stop-o:before{content:\"\\F256\"}.fa-hand-scissors-o:before{content:\"\\F257\"}.fa-hand-lizard-o:before{content:\"\\F258\"}.fa-hand-spock-o:before{content:\"\\F259\"}.fa-hand-pointer-o:before{content:\"\\F25A\"}.fa-hand-peace-o:before{content:\"\\F25B\"}.fa-trademark:before{content:\"\\F25C\"}.fa-registered:before{content:\"\\F25D\"}.fa-creative-commons:before{content:\"\\F25E\"}.fa-gg:before{content:\"\\F260\"}.fa-gg-circle:before{content:\"\\F261\"}.fa-tripadvisor:before{content:\"\\F262\"}.fa-odnoklassniki:before{content:\"\\F263\"}.fa-odnoklassniki-square:before{content:\"\\F264\"}.fa-get-pocket:before{content:\"\\F265\"}.fa-wikipedia-w:before{content:\"\\F266\"}.fa-safari:before{content:\"\\F267\"}.fa-chrome:before{content:\"\\F268\"}.fa-firefox:before{content:\"\\F269\"}.fa-opera:before{content:\"\\F26A\"}.fa-internet-explorer:before{content:\"\\F26B\"}.fa-television:before,.fa-tv:before{content:\"\\F26C\"}.fa-contao:before{content:\"\\F26D\"}.fa-500px:before{content:\"\\F26E\"}.fa-amazon:before{content:\"\\F270\"}.fa-calendar-plus-o:before{content:\"\\F271\"}.fa-calendar-minus-o:before{content:\"\\F272\"}.fa-calendar-times-o:before{content:\"\\F273\"}.fa-calendar-check-o:before{content:\"\\F274\"}.fa-industry:before{content:\"\\F275\"}.fa-map-pin:before{content:\"\\F276\"}.fa-map-signs:before{content:\"\\F277\"}.fa-map-o:before{content:\"\\F278\"}.fa-map:before{content:\"\\F279\"}.fa-commenting:before{content:\"\\F27A\"}.fa-commenting-o:before{content:\"\\F27B\"}.fa-houzz:before{content:\"\\F27C\"}.fa-vimeo:before{content:\"\\F27D\"}.fa-black-tie:before{content:\"\\F27E\"}.fa-fonticons:before{content:\"\\F280\"}.fa-reddit-alien:before{content:\"\\F281\"}.fa-edge:before{content:\"\\F282\"}.fa-credit-card-alt:before{content:\"\\F283\"}.fa-codiepie:before{content:\"\\F284\"}.fa-modx:before{content:\"\\F285\"}.fa-fort-awesome:before{content:\"\\F286\"}.fa-usb:before{content:\"\\F287\"}.fa-product-hunt:before{content:\"\\F288\"}.fa-mixcloud:before{content:\"\\F289\"}.fa-scribd:before{content:\"\\F28A\"}.fa-pause-circle:before{content:\"\\F28B\"}.fa-pause-circle-o:before{content:\"\\F28C\"}.fa-stop-circle:before{content:\"\\F28D\"}.fa-stop-circle-o:before{content:\"\\F28E\"}.fa-shopping-bag:before{content:\"\\F290\"}.fa-shopping-basket:before{content:\"\\F291\"}.fa-hashtag:before{content:\"\\F292\"}.fa-bluetooth:before{content:\"\\F293\"}.fa-bluetooth-b:before{content:\"\\F294\"}.fa-percent:before{content:\"\\F295\"}.fa-gitlab:before{content:\"\\F296\"}.fa-wpbeginner:before{content:\"\\F297\"}.fa-wpforms:before{content:\"\\F298\"}.fa-envira:before{content:\"\\F299\"}.fa-universal-access:before{content:\"\\F29A\"}.fa-wheelchair-alt:before{content:\"\\F29B\"}.fa-question-circle-o:before{content:\"\\F29C\"}.fa-blind:before{content:\"\\F29D\"}.fa-audio-description:before{content:\"\\F29E\"}.fa-volume-control-phone:before{content:\"\\F2A0\"}.fa-braille:before{content:\"\\F2A1\"}.fa-assistive-listening-systems:before{content:\"\\F2A2\"}.fa-american-sign-language-interpreting:before,.fa-asl-interpreting:before{content:\"\\F2A3\"}.fa-deaf:before,.fa-deafness:before,.fa-hard-of-hearing:before{content:\"\\F2A4\"}.fa-glide:before{content:\"\\F2A5\"}.fa-glide-g:before{content:\"\\F2A6\"}.fa-sign-language:before,.fa-signing:before{content:\"\\F2A7\"}.fa-low-vision:before{content:\"\\F2A8\"}.fa-viadeo:before{content:\"\\F2A9\"}.fa-viadeo-square:before{content:\"\\F2AA\"}.fa-snapchat:before{content:\"\\F2AB\"}.fa-snapchat-ghost:before{content:\"\\F2AC\"}.fa-snapchat-square:before{content:\"\\F2AD\"}.fa-pied-piper:before{content:\"\\F2AE\"}.fa-first-order:before{content:\"\\F2B0\"}.fa-yoast:before{content:\"\\F2B1\"}.fa-themeisle:before{content:\"\\F2B2\"}.fa-google-plus-circle:before,.fa-google-plus-official:before{content:\"\\F2B3\"}.fa-fa:before,.fa-font-awesome:before{content:\"\\F2B4\"}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}", ""]);
	
	// exports


/***/ }),

/***/ 146:
/***/ (function(module, exports) {

	module.exports = function escape(url) {
	    if (typeof url !== 'string') {
	        return url
	    }
	    // If url is already wrapped in quotes, remove them
	    if (/^['"].*['"]$/.test(url)) {
	        url = url.slice(1, -1);
	    }
	    // Should url be wrapped?
	    // See https://drafts.csswg.org/css-values-3/#urls
	    if (/["'() \t\n]/.test(url)) {
	        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
	    }
	
	    return url
	}


/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["XRegExp"] = __webpack_require__(580);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 148:
/***/ (function(module, exports) {

	module.exports = "https://cdn.printos.com/fonts/font-awesome/4.6.3/fontawesome-webfont.eot";

/***/ }),

/***/ 149:
/***/ (function(module, exports) {

	module.exports = "https://cdn.printos.com/fonts/font-awesome/4.6.3/fontawesome-webfont.eot";

/***/ }),

/***/ 150:
/***/ (function(module, exports) {

	module.exports = "https://cdn.printos.com/fonts/font-awesome/4.6.3/fontawesome-webfont.svg";

/***/ }),

/***/ 151:
/***/ (function(module, exports) {

	module.exports = "https://cdn.printos.com/fonts/font-awesome/4.6.3/fontawesome-webfont.ttf";

/***/ }),

/***/ 152:
/***/ (function(module, exports) {

	module.exports = "https://cdn.printos.com/fonts/font-awesome/4.6.3/fontawesome-webfont.woff2";

/***/ }),

/***/ 153:
/***/ (function(module, exports) {

	module.exports = "https://cdn.printos.com/fonts/font-awesome/4.6.3/fontawesome-webfont.woff";

/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
	//! version : 0.5.25
	//! Copyright (c) JS Foundation and other contributors
	//! license : MIT
	//! github.com/moment/moment-timezone
	
	(function (root, factory) {
		"use strict";
	
		/*global define*/
		if (typeof module === 'object' && module.exports) {
			module.exports = factory(__webpack_require__(3)); // Node
		} else if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
		} else {
			factory(root.moment);                        // Browser
		}
	}(this, function (moment) {
		"use strict";
	
		// Do not load moment-timezone a second time.
		// if (moment.tz !== undefined) {
		// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
		// 	return moment;
		// }
	
		var VERSION = "0.5.25",
			zones = {},
			links = {},
			names = {},
			guesses = {},
			cachedGuess;
	
		if (!moment || typeof moment.version !== 'string') {
			logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
		}
	
		var momentVersion = moment.version.split('.'),
			major = +momentVersion[0],
			minor = +momentVersion[1];
	
		// Moment.js version check
		if (major < 2 || (major === 2 && minor < 6)) {
			logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
		}
	
		/************************************
			Unpacking
		************************************/
	
		function charCodeToInt(charCode) {
			if (charCode > 96) {
				return charCode - 87;
			} else if (charCode > 64) {
				return charCode - 29;
			}
			return charCode - 48;
		}
	
		function unpackBase60(string) {
			var i = 0,
				parts = string.split('.'),
				whole = parts[0],
				fractional = parts[1] || '',
				multiplier = 1,
				num,
				out = 0,
				sign = 1;
	
			// handle negative numbers
			if (string.charCodeAt(0) === 45) {
				i = 1;
				sign = -1;
			}
	
			// handle digits before the decimal
			for (i; i < whole.length; i++) {
				num = charCodeToInt(whole.charCodeAt(i));
				out = 60 * out + num;
			}
	
			// handle digits after the decimal
			for (i = 0; i < fractional.length; i++) {
				multiplier = multiplier / 60;
				num = charCodeToInt(fractional.charCodeAt(i));
				out += num * multiplier;
			}
	
			return out * sign;
		}
	
		function arrayToInt (array) {
			for (var i = 0; i < array.length; i++) {
				array[i] = unpackBase60(array[i]);
			}
		}
	
		function intToUntil (array, length) {
			for (var i = 0; i < length; i++) {
				array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
			}
	
			array[length - 1] = Infinity;
		}
	
		function mapIndices (source, indices) {
			var out = [], i;
	
			for (i = 0; i < indices.length; i++) {
				out[i] = source[indices[i]];
			}
	
			return out;
		}
	
		function unpack (string) {
			var data = string.split('|'),
				offsets = data[2].split(' '),
				indices = data[3].split(''),
				untils  = data[4].split(' ');
	
			arrayToInt(offsets);
			arrayToInt(indices);
			arrayToInt(untils);
	
			intToUntil(untils, indices.length);
	
			return {
				name       : data[0],
				abbrs      : mapIndices(data[1].split(' '), indices),
				offsets    : mapIndices(offsets, indices),
				untils     : untils,
				population : data[5] | 0
			};
		}
	
		/************************************
			Zone object
		************************************/
	
		function Zone (packedString) {
			if (packedString) {
				this._set(unpack(packedString));
			}
		}
	
		Zone.prototype = {
			_set : function (unpacked) {
				this.name       = unpacked.name;
				this.abbrs      = unpacked.abbrs;
				this.untils     = unpacked.untils;
				this.offsets    = unpacked.offsets;
				this.population = unpacked.population;
			},
	
			_index : function (timestamp) {
				var target = +timestamp,
					untils = this.untils,
					i;
	
				for (i = 0; i < untils.length; i++) {
					if (target < untils[i]) {
						return i;
					}
				}
			},
	
			parse : function (timestamp) {
				var target  = +timestamp,
					offsets = this.offsets,
					untils  = this.untils,
					max     = untils.length - 1,
					offset, offsetNext, offsetPrev, i;
	
				for (i = 0; i < max; i++) {
					offset     = offsets[i];
					offsetNext = offsets[i + 1];
					offsetPrev = offsets[i ? i - 1 : i];
	
					if (offset < offsetNext && tz.moveAmbiguousForward) {
						offset = offsetNext;
					} else if (offset > offsetPrev && tz.moveInvalidForward) {
						offset = offsetPrev;
					}
	
					if (target < untils[i] - (offset * 60000)) {
						return offsets[i];
					}
				}
	
				return offsets[max];
			},
	
			abbr : function (mom) {
				return this.abbrs[this._index(mom)];
			},
	
			offset : function (mom) {
				logError("zone.offset has been deprecated in favor of zone.utcOffset");
				return this.offsets[this._index(mom)];
			},
	
			utcOffset : function (mom) {
				return this.offsets[this._index(mom)];
			}
		};
	
		/************************************
			Current Timezone
		************************************/
	
		function OffsetAt(at) {
			var timeString = at.toTimeString();
			var abbr = timeString.match(/\([a-z ]+\)/i);
			if (abbr && abbr[0]) {
				// 17:56:31 GMT-0600 (CST)
				// 17:56:31 GMT-0600 (Central Standard Time)
				abbr = abbr[0].match(/[A-Z]/g);
				abbr = abbr ? abbr.join('') : undefined;
			} else {
				// 17:56:31 CST
				// 17:56:31 GMT+0800 (台北標準時間)
				abbr = timeString.match(/[A-Z]{3,5}/g);
				abbr = abbr ? abbr[0] : undefined;
			}
	
			if (abbr === 'GMT') {
				abbr = undefined;
			}
	
			this.at = +at;
			this.abbr = abbr;
			this.offset = at.getTimezoneOffset();
		}
	
		function ZoneScore(zone) {
			this.zone = zone;
			this.offsetScore = 0;
			this.abbrScore = 0;
		}
	
		ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
			this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
			if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
				this.abbrScore++;
			}
		};
	
		function findChange(low, high) {
			var mid, diff;
	
			while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
				mid = new OffsetAt(new Date(low.at + diff));
				if (mid.offset === low.offset) {
					low = mid;
				} else {
					high = mid;
				}
			}
	
			return low;
		}
	
		function userOffsets() {
			var startYear = new Date().getFullYear() - 2,
				last = new OffsetAt(new Date(startYear, 0, 1)),
				offsets = [last],
				change, next, i;
	
			for (i = 1; i < 48; i++) {
				next = new OffsetAt(new Date(startYear, i, 1));
				if (next.offset !== last.offset) {
					change = findChange(last, next);
					offsets.push(change);
					offsets.push(new OffsetAt(new Date(change.at + 6e4)));
				}
				last = next;
			}
	
			for (i = 0; i < 4; i++) {
				offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
				offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
			}
	
			return offsets;
		}
	
		function sortZoneScores (a, b) {
			if (a.offsetScore !== b.offsetScore) {
				return a.offsetScore - b.offsetScore;
			}
			if (a.abbrScore !== b.abbrScore) {
				return a.abbrScore - b.abbrScore;
			}
			return b.zone.population - a.zone.population;
		}
	
		function addToGuesses (name, offsets) {
			var i, offset;
			arrayToInt(offsets);
			for (i = 0; i < offsets.length; i++) {
				offset = offsets[i];
				guesses[offset] = guesses[offset] || {};
				guesses[offset][name] = true;
			}
		}
	
		function guessesForUserOffsets (offsets) {
			var offsetsLength = offsets.length,
				filteredGuesses = {},
				out = [],
				i, j, guessesOffset;
	
			for (i = 0; i < offsetsLength; i++) {
				guessesOffset = guesses[offsets[i].offset] || {};
				for (j in guessesOffset) {
					if (guessesOffset.hasOwnProperty(j)) {
						filteredGuesses[j] = true;
					}
				}
			}
	
			for (i in filteredGuesses) {
				if (filteredGuesses.hasOwnProperty(i)) {
					out.push(names[i]);
				}
			}
	
			return out;
		}
	
		function rebuildGuess () {
	
			// use Intl API when available and returning valid time zone
			try {
				var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
				if (intlName && intlName.length > 3) {
					var name = names[normalizeName(intlName)];
					if (name) {
						return name;
					}
					logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
				}
			} catch (e) {
				// Intl unavailable, fall back to manual guessing.
			}
	
			var offsets = userOffsets(),
				offsetsLength = offsets.length,
				guesses = guessesForUserOffsets(offsets),
				zoneScores = [],
				zoneScore, i, j;
	
			for (i = 0; i < guesses.length; i++) {
				zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
				for (j = 0; j < offsetsLength; j++) {
					zoneScore.scoreOffsetAt(offsets[j]);
				}
				zoneScores.push(zoneScore);
			}
	
			zoneScores.sort(sortZoneScores);
	
			return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
		}
	
		function guess (ignoreCache) {
			if (!cachedGuess || ignoreCache) {
				cachedGuess = rebuildGuess();
			}
			return cachedGuess;
		}
	
		/************************************
			Global Methods
		************************************/
	
		function normalizeName (name) {
			return (name || '').toLowerCase().replace(/\//g, '_');
		}
	
		function addZone (packed) {
			var i, name, split, normalized;
	
			if (typeof packed === "string") {
				packed = [packed];
			}
	
			for (i = 0; i < packed.length; i++) {
				split = packed[i].split('|');
				name = split[0];
				normalized = normalizeName(name);
				zones[normalized] = packed[i];
				names[normalized] = name;
				addToGuesses(normalized, split[2].split(' '));
			}
		}
	
		function getZone (name, caller) {
			
			name = normalizeName(name);
	
			var zone = zones[name];
			var link;
	
			if (zone instanceof Zone) {
				return zone;
			}
	
			if (typeof zone === 'string') {
				zone = new Zone(zone);
				zones[name] = zone;
				return zone;
			}
	
			// Pass getZone to prevent recursion more than 1 level deep
			if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
				zone = zones[name] = new Zone();
				zone._set(link);
				zone.name = names[name];
				return zone;
			}
	
			return null;
		}
	
		function getNames () {
			var i, out = [];
	
			for (i in names) {
				if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
					out.push(names[i]);
				}
			}
	
			return out.sort();
		}
	
		function addLink (aliases) {
			var i, alias, normal0, normal1;
	
			if (typeof aliases === "string") {
				aliases = [aliases];
			}
	
			for (i = 0; i < aliases.length; i++) {
				alias = aliases[i].split('|');
	
				normal0 = normalizeName(alias[0]);
				normal1 = normalizeName(alias[1]);
	
				links[normal0] = normal1;
				names[normal0] = alias[0];
	
				links[normal1] = normal0;
				names[normal1] = alias[1];
			}
		}
	
		function loadData (data) {
			addZone(data.zones);
			addLink(data.links);
			tz.dataVersion = data.version;
		}
	
		function zoneExists (name) {
			if (!zoneExists.didShowError) {
				zoneExists.didShowError = true;
					logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
			}
			return !!getZone(name);
		}
	
		function needsOffset (m) {
			var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
			return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
		}
	
		function logError (message) {
			if (typeof console !== 'undefined' && typeof console.error === 'function') {
				console.error(message);
			}
		}
	
		/************************************
			moment.tz namespace
		************************************/
	
		function tz (input) {
			var args = Array.prototype.slice.call(arguments, 0, -1),
				name = arguments[arguments.length - 1],
				zone = getZone(name),
				out  = moment.utc.apply(null, args);
	
			if (zone && !moment.isMoment(input) && needsOffset(out)) {
				out.add(zone.parse(out), 'minutes');
			}
	
			out.tz(name);
	
			return out;
		}
	
		tz.version      = VERSION;
		tz.dataVersion  = '';
		tz._zones       = zones;
		tz._links       = links;
		tz._names       = names;
		tz.add          = addZone;
		tz.link         = addLink;
		tz.load         = loadData;
		tz.zone         = getZone;
		tz.zoneExists   = zoneExists; // deprecated in 0.1.0
		tz.guess        = guess;
		tz.names        = getNames;
		tz.Zone         = Zone;
		tz.unpack       = unpack;
		tz.unpackBase60 = unpackBase60;
		tz.needsOffset  = needsOffset;
		tz.moveInvalidForward   = true;
		tz.moveAmbiguousForward = false;
	
		/************************************
			Interface with Moment.js
		************************************/
	
		var fn = moment.fn;
	
		moment.tz = tz;
	
		moment.defaultZone = null;
	
		moment.updateOffset = function (mom, keepTime) {
			var zone = moment.defaultZone,
				offset;
	
			if (mom._z === undefined) {
				if (zone && needsOffset(mom) && !mom._isUTC) {
					mom._d = moment.utc(mom._a)._d;
					mom.utc().add(zone.parse(mom), 'minutes');
				}
				mom._z = zone;
			}
			if (mom._z) {
				offset = mom._z.utcOffset(mom);
				if (Math.abs(offset) < 16) {
					offset = offset / 60;
				}
				if (mom.utcOffset !== undefined) {
					var z = mom._z;
					mom.utcOffset(-offset, keepTime);
					mom._z = z;
				} else {
					mom.zone(offset, keepTime);
				}
			}
		};
	
		fn.tz = function (name, keepTime) {
			if (name) {
				if (typeof name !== 'string') {
					throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
				}
				this._z = getZone(name);
				if (this._z) {
					moment.updateOffset(this, keepTime);
				} else {
					logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
				}
				return this;
			}
			if (this._z) { return this._z.name; }
		};
	
		function abbrWrap (old) {
			return function () {
				if (this._z) { return this._z.abbr(this); }
				return old.call(this);
			};
		}
	
		function resetZoneWrap (old) {
			return function () {
				this._z = null;
				return old.apply(this, arguments);
			};
		}
	
		function resetZoneWrap2 (old) {
			return function () {
				if (arguments.length > 0) this._z = null;
				return old.apply(this, arguments);
			};
		}
	
		fn.zoneName  = abbrWrap(fn.zoneName);
		fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
		fn.utc       = resetZoneWrap(fn.utc);
		fn.local     = resetZoneWrap(fn.local);
		fn.utcOffset = resetZoneWrap2(fn.utcOffset);
		
		moment.tz.setDefault = function(name) {
			if (major < 2 || (major === 2 && minor < 9)) {
				logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
			}
			moment.defaultZone = name ? getZone(name) : null;
			return moment;
		};
	
		// Cloning a moment should include the _z property.
		var momentProperties = moment.momentProperties;
		if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
			// moment 2.8.1+
			momentProperties.push('_z');
			momentProperties.push('_a');
		} else if (momentProperties) {
			// moment 2.7.0
			momentProperties._z = null;
		}
	
		loadData({
			"version": "2019a",
			"zones": [
				"Africa/Abidjan|GMT|0|0||48e5",
				"Africa/Nairobi|EAT|-30|0||47e5",
				"Africa/Algiers|CET|-10|0||26e5",
				"Africa/Lagos|WAT|-10|0||17e6",
				"Africa/Maputo|CAT|-20|0||26e5",
				"Africa/Cairo|EET EEST|-20 -30|01010|1M2m0 gL0 e10 mn0|15e6",
				"Africa/Casablanca|+00 +01|0 -10|01010101010101010101010101010101|1LHC0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00|32e5",
				"Europe/Paris|CET CEST|-10 -20|01010101010101010101010|1LHB0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00|11e6",
				"Africa/Johannesburg|SAST|-20|0||84e5",
				"Africa/Khartoum|EAT CAT|-30 -20|01|1Usl0|51e5",
				"Africa/Sao_Tome|GMT WAT|0 -10|010|1UQN0 2q00",
				"Africa/Tripoli|EET|-20|0||11e5",
				"Africa/Windhoek|CAT WAT|-20 -10|010101010|1LKo0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4",
				"America/Adak|HST HDT|a0 90|01010101010101010101010|1Lzo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326",
				"America/Anchorage|AKST AKDT|90 80|01010101010101010101010|1Lzn0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4",
				"America/Santo_Domingo|AST|40|0||29e5",
				"America/Fortaleza|-03|30|0||34e5",
				"America/Asuncion|-03 -04|30 40|01010101010101010101010|1LEP0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0|28e5",
				"America/Panama|EST|50|0||15e5",
				"America/Mexico_City|CST CDT|60 50|01010101010101010101010|1LKw0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0|20e6",
				"America/Managua|CST|60|0||22e5",
				"America/La_Paz|-04|40|0||19e5",
				"America/Lima|-05|50|0||11e6",
				"America/Denver|MST MDT|70 60|01010101010101010101010|1Lzl0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5",
				"America/Campo_Grande|-03 -04|30 40|01010101010101010101010|1LqP0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 IL0 1EN0 FX0 1HB0|77e4",
				"America/Cancun|CST CDT EST|60 50 50|0102|1LKw0 1lb0 Dd0|63e4",
				"America/Caracas|-0430 -04|4u 40|01|1QMT0|29e5",
				"America/Chicago|CST CDT|60 50|01010101010101010101010|1Lzk0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
				"America/Chihuahua|MST MDT|70 60|01010101010101010101010|1LKx0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0|81e4",
				"America/Phoenix|MST|70|0||42e5",
				"America/Los_Angeles|PST PDT|80 70|01010101010101010101010|1Lzm0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6",
				"America/New_York|EST EDT|50 40|01010101010101010101010|1Lzj0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6",
				"America/Fort_Nelson|PST PDT MST|80 70 70|0102|1Lzm0 1zb0 Op0|39e2",
				"America/Halifax|AST ADT|40 30|01010101010101010101010|1Lzi0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4",
				"America/Godthab|-03 -02|30 20|01010101010101010101010|1LHB0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00|17e3",
				"America/Grand_Turk|EST EDT AST|50 40 40|0101210101010101010|1Lzj0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2",
				"America/Havana|CST CDT|50 40|01010101010101010101010|1Lzh0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5",
				"America/Metlakatla|PST AKST AKDT|80 90 80|012121201212121212121|1PAa0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
				"America/Miquelon|-03 -02|30 20|01010101010101010101010|1Lzh0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2",
				"America/Montevideo|-02 -03|20 30|0101|1Lzg0 1o10 11z0|17e5",
				"America/Noronha|-02|20|0||30e2",
				"America/Port-au-Prince|EST EDT|50 40|010101010101010101010|1Lzj0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
				"Antarctica/Palmer|-03 -04|30 40|01010|1LSP0 Rd0 46n0 Ap0|40",
				"America/Santiago|-03 -04|30 40|010101010101010101010|1LSP0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0|62e5",
				"America/Sao_Paulo|-02 -03|20 30|01010101010101010101010|1LqO0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 IL0 1EN0 FX0 1HB0|20e6",
				"Atlantic/Azores|-01 +00|10 0|01010101010101010101010|1LHB0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00|25e4",
				"America/St_Johns|NST NDT|3u 2u|01010101010101010101010|1Lzhu 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
				"Antarctica/Casey|+08 +11|-80 -b0|010|1RWg0 3m10|10",
				"Asia/Bangkok|+07|-70|0||15e6",
				"Pacific/Port_Moresby|+10|-a0|0||25e4",
				"Pacific/Guadalcanal|+11|-b0|0||11e4",
				"Asia/Tashkent|+05|-50|0||23e5",
				"Pacific/Auckland|NZDT NZST|-d0 -c0|01010101010101010101010|1LKe0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00|14e5",
				"Asia/Baghdad|+03|-30|0||66e5",
				"Antarctica/Troll|+00 +02|0 -20|01010101010101010101010|1LHB0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00|40",
				"Asia/Dhaka|+06|-60|0||16e6",
				"Asia/Amman|EET EEST|-20 -30|01010101010101010101010|1LGK0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|25e5",
				"Asia/Kamchatka|+12|-c0|0||18e4",
				"Asia/Baku|+04 +05|-40 -50|01010|1LHA0 1o00 11A0 1o00|27e5",
				"Asia/Barnaul|+07 +06|-70 -60|010|1N7v0 3rd0",
				"Asia/Beirut|EET EEST|-20 -30|01010101010101010101010|1LHy0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0|22e5",
				"Asia/Kuala_Lumpur|+08|-80|0||71e5",
				"Asia/Kolkata|IST|-5u|0||15e6",
				"Asia/Chita|+10 +08 +09|-a0 -80 -90|012|1N7s0 3re0|33e4",
				"Asia/Ulaanbaatar|+08 +09|-80 -90|01010|1O8G0 1cJ0 1cP0 1cJ0|12e5",
				"Asia/Shanghai|CST|-80|0||23e6",
				"Asia/Colombo|+0530|-5u|0||22e5",
				"Asia/Damascus|EET EEST|-20 -30|01010101010101010101010|1LGK0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|26e5",
				"Asia/Dili|+09|-90|0||19e4",
				"Asia/Dubai|+04|-40|0||39e5",
				"Asia/Famagusta|EET EEST +03|-20 -30 -30|0101012010101010101010|1LHB0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00",
				"Asia/Gaza|EET EEST|-20 -30|01010101010101010101010|1LGK0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0|18e5",
				"Asia/Hong_Kong|HKT|-80|0||73e5",
				"Asia/Hovd|+07 +08|-70 -80|01010|1O8H0 1cJ0 1cP0 1cJ0|81e3",
				"Asia/Irkutsk|+09 +08|-90 -80|01|1N7t0|60e4",
				"Europe/Istanbul|EET EEST +03|-20 -30 -30|0101012|1LI10 1nA0 11A0 1tA0 U00 15w0|13e6",
				"Asia/Jakarta|WIB|-70|0||31e6",
				"Asia/Jayapura|WIT|-90|0||26e4",
				"Asia/Jerusalem|IST IDT|-20 -30|01010101010101010101010|1LGM0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0|81e4",
				"Asia/Kabul|+0430|-4u|0||46e5",
				"Asia/Karachi|PKT|-50|0||24e6",
				"Asia/Kathmandu|+0545|-5J|0||12e5",
				"Asia/Yakutsk|+10 +09|-a0 -90|01|1N7s0|28e4",
				"Asia/Krasnoyarsk|+08 +07|-80 -70|01|1N7u0|10e5",
				"Asia/Magadan|+12 +10 +11|-c0 -a0 -b0|012|1N7q0 3Cq0|95e3",
				"Asia/Makassar|WITA|-80|0||15e5",
				"Asia/Manila|PST|-80|0||24e6",
				"Europe/Athens|EET EEST|-20 -30|01010101010101010101010|1LHB0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00|35e5",
				"Asia/Novosibirsk|+07 +06|-70 -60|010|1N7v0 4eN0|15e5",
				"Asia/Omsk|+07 +06|-70 -60|01|1N7v0|12e5",
				"Asia/Pyongyang|KST KST|-90 -8u|010|1P4D0 6BA0|29e5",
				"Asia/Qyzylorda|+06 +05|-60 -50|01|1Xei0|73e4",
				"Asia/Rangoon|+0630|-6u|0||48e5",
				"Asia/Sakhalin|+11 +10|-b0 -a0|010|1N7r0 3rd0|58e4",
				"Asia/Seoul|KST|-90|0||23e6",
				"Asia/Srednekolymsk|+12 +11|-c0 -b0|01|1N7q0|35e2",
				"Asia/Tehran|+0330 +0430|-3u -4u|01010101010101010101010|1LEku 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6",
				"Asia/Tokyo|JST|-90|0||38e6",
				"Asia/Tomsk|+07 +06|-70 -60|010|1N7v0 3Qp0|10e5",
				"Asia/Vladivostok|+11 +10|-b0 -a0|01|1N7r0|60e4",
				"Asia/Yekaterinburg|+06 +05|-60 -50|01|1N7w0|14e5",
				"Europe/Lisbon|WET WEST|0 -10|01010101010101010101010|1LHB0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00|27e5",
				"Atlantic/Cape_Verde|-01|10|0||50e4",
				"Australia/Sydney|AEDT AEST|-b0 -a0|01010101010101010101010|1LKg0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0|40e5",
				"Australia/Adelaide|ACDT ACST|-au -9u|01010101010101010101010|1LKgu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0|11e5",
				"Australia/Brisbane|AEST|-a0|0||20e5",
				"Australia/Darwin|ACST|-9u|0||12e4",
				"Australia/Eucla|+0845|-8J|0||368",
				"Australia/Lord_Howe|+11 +1030|-b0 -au|01010101010101010101010|1LKf0 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu|347",
				"Australia/Perth|AWST|-80|0||18e5",
				"Pacific/Easter|-05 -06|50 60|010101010101010101010|1LSP0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0|30e2",
				"Europe/Dublin|GMT IST|0 -10|01010101010101010101010|1LHB0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00|12e5",
				"Etc/GMT-1|+01|-10|0|",
				"Pacific/Fakaofo|+13|-d0|0||483",
				"Pacific/Kiritimati|+14|-e0|0||51e2",
				"Etc/GMT-2|+02|-20|0|",
				"Pacific/Tahiti|-10|a0|0||18e4",
				"Pacific/Niue|-11|b0|0||12e2",
				"Etc/GMT+12|-12|c0|0|",
				"Pacific/Galapagos|-06|60|0||25e3",
				"Etc/GMT+7|-07|70|0|",
				"Pacific/Pitcairn|-08|80|0||56",
				"Pacific/Gambier|-09|90|0||125",
				"Etc/UTC|UTC|0|0|",
				"Europe/Ulyanovsk|+04 +03|-40 -30|010|1N7y0 3rd0|13e5",
				"Europe/London|GMT BST|0 -10|01010101010101010101010|1LHB0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00|10e6",
				"Europe/Chisinau|EET EEST|-20 -30|01010101010101010101010|1LHA0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00|67e4",
				"Europe/Kaliningrad|+03 EET|-30 -20|01|1N7z0|44e4",
				"Europe/Kirov|+04 +03|-40 -30|01|1N7y0|48e4",
				"Europe/Moscow|MSK MSK|-40 -30|01|1N7y0|16e6",
				"Europe/Saratov|+04 +03|-40 -30|010|1N7y0 5810",
				"Europe/Simferopol|EET MSK MSK|-20 -40 -30|012|1LHA0 1nW0|33e4",
				"Europe/Volgograd|+04 +03|-40 -30|010|1N7y0 9Jd0|10e5",
				"Pacific/Honolulu|HST|a0|0||37e4",
				"MET|MET MEST|-10 -20|01010101010101010101010|1LHB0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00",
				"Pacific/Chatham|+1345 +1245|-dJ -cJ|01010101010101010101010|1LKe0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00|600",
				"Pacific/Apia|+14 +13|-e0 -d0|01010101010101010101010|1LKe0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00|37e3",
				"Pacific/Bougainville|+10 +11|-a0 -b0|01|1NwE0|18e4",
				"Pacific/Fiji|+13 +12|-d0 -c0|01010101010101010101010|1Lfp0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0|88e4",
				"Pacific/Guam|ChST|-a0|0||17e4",
				"Pacific/Marquesas|-0930|9u|0||86e2",
				"Pacific/Pago_Pago|SST|b0|0||37e2",
				"Pacific/Norfolk|+1130 +11|-bu -b0|01|1PoCu|25e4",
				"Pacific/Tongatapu|+13 +14|-d0 -e0|010|1S4d0 s00|75e3"
			],
			"links": [
				"Africa/Abidjan|Africa/Accra",
				"Africa/Abidjan|Africa/Bamako",
				"Africa/Abidjan|Africa/Banjul",
				"Africa/Abidjan|Africa/Bissau",
				"Africa/Abidjan|Africa/Conakry",
				"Africa/Abidjan|Africa/Dakar",
				"Africa/Abidjan|Africa/Freetown",
				"Africa/Abidjan|Africa/Lome",
				"Africa/Abidjan|Africa/Monrovia",
				"Africa/Abidjan|Africa/Nouakchott",
				"Africa/Abidjan|Africa/Ouagadougou",
				"Africa/Abidjan|Africa/Timbuktu",
				"Africa/Abidjan|America/Danmarkshavn",
				"Africa/Abidjan|Atlantic/Reykjavik",
				"Africa/Abidjan|Atlantic/St_Helena",
				"Africa/Abidjan|Etc/GMT",
				"Africa/Abidjan|Etc/GMT+0",
				"Africa/Abidjan|Etc/GMT-0",
				"Africa/Abidjan|Etc/GMT0",
				"Africa/Abidjan|Etc/Greenwich",
				"Africa/Abidjan|GMT",
				"Africa/Abidjan|GMT+0",
				"Africa/Abidjan|GMT-0",
				"Africa/Abidjan|GMT0",
				"Africa/Abidjan|Greenwich",
				"Africa/Abidjan|Iceland",
				"Africa/Algiers|Africa/Tunis",
				"Africa/Cairo|Egypt",
				"Africa/Casablanca|Africa/El_Aaiun",
				"Africa/Johannesburg|Africa/Maseru",
				"Africa/Johannesburg|Africa/Mbabane",
				"Africa/Lagos|Africa/Bangui",
				"Africa/Lagos|Africa/Brazzaville",
				"Africa/Lagos|Africa/Douala",
				"Africa/Lagos|Africa/Kinshasa",
				"Africa/Lagos|Africa/Libreville",
				"Africa/Lagos|Africa/Luanda",
				"Africa/Lagos|Africa/Malabo",
				"Africa/Lagos|Africa/Ndjamena",
				"Africa/Lagos|Africa/Niamey",
				"Africa/Lagos|Africa/Porto-Novo",
				"Africa/Maputo|Africa/Blantyre",
				"Africa/Maputo|Africa/Bujumbura",
				"Africa/Maputo|Africa/Gaborone",
				"Africa/Maputo|Africa/Harare",
				"Africa/Maputo|Africa/Kigali",
				"Africa/Maputo|Africa/Lubumbashi",
				"Africa/Maputo|Africa/Lusaka",
				"Africa/Nairobi|Africa/Addis_Ababa",
				"Africa/Nairobi|Africa/Asmara",
				"Africa/Nairobi|Africa/Asmera",
				"Africa/Nairobi|Africa/Dar_es_Salaam",
				"Africa/Nairobi|Africa/Djibouti",
				"Africa/Nairobi|Africa/Juba",
				"Africa/Nairobi|Africa/Kampala",
				"Africa/Nairobi|Africa/Mogadishu",
				"Africa/Nairobi|Indian/Antananarivo",
				"Africa/Nairobi|Indian/Comoro",
				"Africa/Nairobi|Indian/Mayotte",
				"Africa/Tripoli|Libya",
				"America/Adak|America/Atka",
				"America/Adak|US/Aleutian",
				"America/Anchorage|America/Juneau",
				"America/Anchorage|America/Nome",
				"America/Anchorage|America/Sitka",
				"America/Anchorage|America/Yakutat",
				"America/Anchorage|US/Alaska",
				"America/Campo_Grande|America/Cuiaba",
				"America/Chicago|America/Indiana/Knox",
				"America/Chicago|America/Indiana/Tell_City",
				"America/Chicago|America/Knox_IN",
				"America/Chicago|America/Matamoros",
				"America/Chicago|America/Menominee",
				"America/Chicago|America/North_Dakota/Beulah",
				"America/Chicago|America/North_Dakota/Center",
				"America/Chicago|America/North_Dakota/New_Salem",
				"America/Chicago|America/Rainy_River",
				"America/Chicago|America/Rankin_Inlet",
				"America/Chicago|America/Resolute",
				"America/Chicago|America/Winnipeg",
				"America/Chicago|CST6CDT",
				"America/Chicago|Canada/Central",
				"America/Chicago|US/Central",
				"America/Chicago|US/Indiana-Starke",
				"America/Chihuahua|America/Mazatlan",
				"America/Chihuahua|Mexico/BajaSur",
				"America/Denver|America/Boise",
				"America/Denver|America/Cambridge_Bay",
				"America/Denver|America/Edmonton",
				"America/Denver|America/Inuvik",
				"America/Denver|America/Ojinaga",
				"America/Denver|America/Shiprock",
				"America/Denver|America/Yellowknife",
				"America/Denver|Canada/Mountain",
				"America/Denver|MST7MDT",
				"America/Denver|Navajo",
				"America/Denver|US/Mountain",
				"America/Fortaleza|America/Araguaina",
				"America/Fortaleza|America/Argentina/Buenos_Aires",
				"America/Fortaleza|America/Argentina/Catamarca",
				"America/Fortaleza|America/Argentina/ComodRivadavia",
				"America/Fortaleza|America/Argentina/Cordoba",
				"America/Fortaleza|America/Argentina/Jujuy",
				"America/Fortaleza|America/Argentina/La_Rioja",
				"America/Fortaleza|America/Argentina/Mendoza",
				"America/Fortaleza|America/Argentina/Rio_Gallegos",
				"America/Fortaleza|America/Argentina/Salta",
				"America/Fortaleza|America/Argentina/San_Juan",
				"America/Fortaleza|America/Argentina/San_Luis",
				"America/Fortaleza|America/Argentina/Tucuman",
				"America/Fortaleza|America/Argentina/Ushuaia",
				"America/Fortaleza|America/Bahia",
				"America/Fortaleza|America/Belem",
				"America/Fortaleza|America/Buenos_Aires",
				"America/Fortaleza|America/Catamarca",
				"America/Fortaleza|America/Cayenne",
				"America/Fortaleza|America/Cordoba",
				"America/Fortaleza|America/Jujuy",
				"America/Fortaleza|America/Maceio",
				"America/Fortaleza|America/Mendoza",
				"America/Fortaleza|America/Paramaribo",
				"America/Fortaleza|America/Recife",
				"America/Fortaleza|America/Rosario",
				"America/Fortaleza|America/Santarem",
				"America/Fortaleza|Antarctica/Rothera",
				"America/Fortaleza|Atlantic/Stanley",
				"America/Fortaleza|Etc/GMT+3",
				"America/Halifax|America/Glace_Bay",
				"America/Halifax|America/Goose_Bay",
				"America/Halifax|America/Moncton",
				"America/Halifax|America/Thule",
				"America/Halifax|Atlantic/Bermuda",
				"America/Halifax|Canada/Atlantic",
				"America/Havana|Cuba",
				"America/La_Paz|America/Boa_Vista",
				"America/La_Paz|America/Guyana",
				"America/La_Paz|America/Manaus",
				"America/La_Paz|America/Porto_Velho",
				"America/La_Paz|Brazil/West",
				"America/La_Paz|Etc/GMT+4",
				"America/Lima|America/Bogota",
				"America/Lima|America/Eirunepe",
				"America/Lima|America/Guayaquil",
				"America/Lima|America/Porto_Acre",
				"America/Lima|America/Rio_Branco",
				"America/Lima|Brazil/Acre",
				"America/Lima|Etc/GMT+5",
				"America/Los_Angeles|America/Dawson",
				"America/Los_Angeles|America/Ensenada",
				"America/Los_Angeles|America/Santa_Isabel",
				"America/Los_Angeles|America/Tijuana",
				"America/Los_Angeles|America/Vancouver",
				"America/Los_Angeles|America/Whitehorse",
				"America/Los_Angeles|Canada/Pacific",
				"America/Los_Angeles|Canada/Yukon",
				"America/Los_Angeles|Mexico/BajaNorte",
				"America/Los_Angeles|PST8PDT",
				"America/Los_Angeles|US/Pacific",
				"America/Los_Angeles|US/Pacific-New",
				"America/Managua|America/Belize",
				"America/Managua|America/Costa_Rica",
				"America/Managua|America/El_Salvador",
				"America/Managua|America/Guatemala",
				"America/Managua|America/Regina",
				"America/Managua|America/Swift_Current",
				"America/Managua|America/Tegucigalpa",
				"America/Managua|Canada/Saskatchewan",
				"America/Mexico_City|America/Bahia_Banderas",
				"America/Mexico_City|America/Merida",
				"America/Mexico_City|America/Monterrey",
				"America/Mexico_City|Mexico/General",
				"America/New_York|America/Detroit",
				"America/New_York|America/Fort_Wayne",
				"America/New_York|America/Indiana/Indianapolis",
				"America/New_York|America/Indiana/Marengo",
				"America/New_York|America/Indiana/Petersburg",
				"America/New_York|America/Indiana/Vevay",
				"America/New_York|America/Indiana/Vincennes",
				"America/New_York|America/Indiana/Winamac",
				"America/New_York|America/Indianapolis",
				"America/New_York|America/Iqaluit",
				"America/New_York|America/Kentucky/Louisville",
				"America/New_York|America/Kentucky/Monticello",
				"America/New_York|America/Louisville",
				"America/New_York|America/Montreal",
				"America/New_York|America/Nassau",
				"America/New_York|America/Nipigon",
				"America/New_York|America/Pangnirtung",
				"America/New_York|America/Thunder_Bay",
				"America/New_York|America/Toronto",
				"America/New_York|Canada/Eastern",
				"America/New_York|EST5EDT",
				"America/New_York|US/East-Indiana",
				"America/New_York|US/Eastern",
				"America/New_York|US/Michigan",
				"America/Noronha|Atlantic/South_Georgia",
				"America/Noronha|Brazil/DeNoronha",
				"America/Noronha|Etc/GMT+2",
				"America/Panama|America/Atikokan",
				"America/Panama|America/Cayman",
				"America/Panama|America/Coral_Harbour",
				"America/Panama|America/Jamaica",
				"America/Panama|EST",
				"America/Panama|Jamaica",
				"America/Phoenix|America/Creston",
				"America/Phoenix|America/Dawson_Creek",
				"America/Phoenix|America/Hermosillo",
				"America/Phoenix|MST",
				"America/Phoenix|US/Arizona",
				"America/Santiago|Chile/Continental",
				"America/Santo_Domingo|America/Anguilla",
				"America/Santo_Domingo|America/Antigua",
				"America/Santo_Domingo|America/Aruba",
				"America/Santo_Domingo|America/Barbados",
				"America/Santo_Domingo|America/Blanc-Sablon",
				"America/Santo_Domingo|America/Curacao",
				"America/Santo_Domingo|America/Dominica",
				"America/Santo_Domingo|America/Grenada",
				"America/Santo_Domingo|America/Guadeloupe",
				"America/Santo_Domingo|America/Kralendijk",
				"America/Santo_Domingo|America/Lower_Princes",
				"America/Santo_Domingo|America/Marigot",
				"America/Santo_Domingo|America/Martinique",
				"America/Santo_Domingo|America/Montserrat",
				"America/Santo_Domingo|America/Port_of_Spain",
				"America/Santo_Domingo|America/Puerto_Rico",
				"America/Santo_Domingo|America/St_Barthelemy",
				"America/Santo_Domingo|America/St_Kitts",
				"America/Santo_Domingo|America/St_Lucia",
				"America/Santo_Domingo|America/St_Thomas",
				"America/Santo_Domingo|America/St_Vincent",
				"America/Santo_Domingo|America/Tortola",
				"America/Santo_Domingo|America/Virgin",
				"America/Sao_Paulo|Brazil/East",
				"America/St_Johns|Canada/Newfoundland",
				"Antarctica/Palmer|America/Punta_Arenas",
				"Asia/Baghdad|Antarctica/Syowa",
				"Asia/Baghdad|Asia/Aden",
				"Asia/Baghdad|Asia/Bahrain",
				"Asia/Baghdad|Asia/Kuwait",
				"Asia/Baghdad|Asia/Qatar",
				"Asia/Baghdad|Asia/Riyadh",
				"Asia/Baghdad|Etc/GMT-3",
				"Asia/Baghdad|Europe/Minsk",
				"Asia/Bangkok|Antarctica/Davis",
				"Asia/Bangkok|Asia/Ho_Chi_Minh",
				"Asia/Bangkok|Asia/Novokuznetsk",
				"Asia/Bangkok|Asia/Phnom_Penh",
				"Asia/Bangkok|Asia/Saigon",
				"Asia/Bangkok|Asia/Vientiane",
				"Asia/Bangkok|Etc/GMT-7",
				"Asia/Bangkok|Indian/Christmas",
				"Asia/Dhaka|Antarctica/Vostok",
				"Asia/Dhaka|Asia/Almaty",
				"Asia/Dhaka|Asia/Bishkek",
				"Asia/Dhaka|Asia/Dacca",
				"Asia/Dhaka|Asia/Kashgar",
				"Asia/Dhaka|Asia/Qostanay",
				"Asia/Dhaka|Asia/Thimbu",
				"Asia/Dhaka|Asia/Thimphu",
				"Asia/Dhaka|Asia/Urumqi",
				"Asia/Dhaka|Etc/GMT-6",
				"Asia/Dhaka|Indian/Chagos",
				"Asia/Dili|Etc/GMT-9",
				"Asia/Dili|Pacific/Palau",
				"Asia/Dubai|Asia/Muscat",
				"Asia/Dubai|Asia/Tbilisi",
				"Asia/Dubai|Asia/Yerevan",
				"Asia/Dubai|Etc/GMT-4",
				"Asia/Dubai|Europe/Samara",
				"Asia/Dubai|Indian/Mahe",
				"Asia/Dubai|Indian/Mauritius",
				"Asia/Dubai|Indian/Reunion",
				"Asia/Gaza|Asia/Hebron",
				"Asia/Hong_Kong|Hongkong",
				"Asia/Jakarta|Asia/Pontianak",
				"Asia/Jerusalem|Asia/Tel_Aviv",
				"Asia/Jerusalem|Israel",
				"Asia/Kamchatka|Asia/Anadyr",
				"Asia/Kamchatka|Etc/GMT-12",
				"Asia/Kamchatka|Kwajalein",
				"Asia/Kamchatka|Pacific/Funafuti",
				"Asia/Kamchatka|Pacific/Kwajalein",
				"Asia/Kamchatka|Pacific/Majuro",
				"Asia/Kamchatka|Pacific/Nauru",
				"Asia/Kamchatka|Pacific/Tarawa",
				"Asia/Kamchatka|Pacific/Wake",
				"Asia/Kamchatka|Pacific/Wallis",
				"Asia/Kathmandu|Asia/Katmandu",
				"Asia/Kolkata|Asia/Calcutta",
				"Asia/Kuala_Lumpur|Asia/Brunei",
				"Asia/Kuala_Lumpur|Asia/Kuching",
				"Asia/Kuala_Lumpur|Asia/Singapore",
				"Asia/Kuala_Lumpur|Etc/GMT-8",
				"Asia/Kuala_Lumpur|Singapore",
				"Asia/Makassar|Asia/Ujung_Pandang",
				"Asia/Rangoon|Asia/Yangon",
				"Asia/Rangoon|Indian/Cocos",
				"Asia/Seoul|ROK",
				"Asia/Shanghai|Asia/Chongqing",
				"Asia/Shanghai|Asia/Chungking",
				"Asia/Shanghai|Asia/Harbin",
				"Asia/Shanghai|Asia/Macao",
				"Asia/Shanghai|Asia/Macau",
				"Asia/Shanghai|Asia/Taipei",
				"Asia/Shanghai|PRC",
				"Asia/Shanghai|ROC",
				"Asia/Tashkent|Antarctica/Mawson",
				"Asia/Tashkent|Asia/Aqtau",
				"Asia/Tashkent|Asia/Aqtobe",
				"Asia/Tashkent|Asia/Ashgabat",
				"Asia/Tashkent|Asia/Ashkhabad",
				"Asia/Tashkent|Asia/Atyrau",
				"Asia/Tashkent|Asia/Dushanbe",
				"Asia/Tashkent|Asia/Oral",
				"Asia/Tashkent|Asia/Samarkand",
				"Asia/Tashkent|Etc/GMT-5",
				"Asia/Tashkent|Indian/Kerguelen",
				"Asia/Tashkent|Indian/Maldives",
				"Asia/Tehran|Iran",
				"Asia/Tokyo|Japan",
				"Asia/Ulaanbaatar|Asia/Choibalsan",
				"Asia/Ulaanbaatar|Asia/Ulan_Bator",
				"Asia/Vladivostok|Asia/Ust-Nera",
				"Asia/Yakutsk|Asia/Khandyga",
				"Atlantic/Azores|America/Scoresbysund",
				"Atlantic/Cape_Verde|Etc/GMT+1",
				"Australia/Adelaide|Australia/Broken_Hill",
				"Australia/Adelaide|Australia/South",
				"Australia/Adelaide|Australia/Yancowinna",
				"Australia/Brisbane|Australia/Lindeman",
				"Australia/Brisbane|Australia/Queensland",
				"Australia/Darwin|Australia/North",
				"Australia/Lord_Howe|Australia/LHI",
				"Australia/Perth|Australia/West",
				"Australia/Sydney|Australia/ACT",
				"Australia/Sydney|Australia/Canberra",
				"Australia/Sydney|Australia/Currie",
				"Australia/Sydney|Australia/Hobart",
				"Australia/Sydney|Australia/Melbourne",
				"Australia/Sydney|Australia/NSW",
				"Australia/Sydney|Australia/Tasmania",
				"Australia/Sydney|Australia/Victoria",
				"Etc/UTC|Etc/UCT",
				"Etc/UTC|Etc/Universal",
				"Etc/UTC|Etc/Zulu",
				"Etc/UTC|UCT",
				"Etc/UTC|UTC",
				"Etc/UTC|Universal",
				"Etc/UTC|Zulu",
				"Europe/Athens|Asia/Nicosia",
				"Europe/Athens|EET",
				"Europe/Athens|Europe/Bucharest",
				"Europe/Athens|Europe/Helsinki",
				"Europe/Athens|Europe/Kiev",
				"Europe/Athens|Europe/Mariehamn",
				"Europe/Athens|Europe/Nicosia",
				"Europe/Athens|Europe/Riga",
				"Europe/Athens|Europe/Sofia",
				"Europe/Athens|Europe/Tallinn",
				"Europe/Athens|Europe/Uzhgorod",
				"Europe/Athens|Europe/Vilnius",
				"Europe/Athens|Europe/Zaporozhye",
				"Europe/Chisinau|Europe/Tiraspol",
				"Europe/Dublin|Eire",
				"Europe/Istanbul|Asia/Istanbul",
				"Europe/Istanbul|Turkey",
				"Europe/Lisbon|Atlantic/Canary",
				"Europe/Lisbon|Atlantic/Faeroe",
				"Europe/Lisbon|Atlantic/Faroe",
				"Europe/Lisbon|Atlantic/Madeira",
				"Europe/Lisbon|Portugal",
				"Europe/Lisbon|WET",
				"Europe/London|Europe/Belfast",
				"Europe/London|Europe/Guernsey",
				"Europe/London|Europe/Isle_of_Man",
				"Europe/London|Europe/Jersey",
				"Europe/London|GB",
				"Europe/London|GB-Eire",
				"Europe/Moscow|W-SU",
				"Europe/Paris|Africa/Ceuta",
				"Europe/Paris|Arctic/Longyearbyen",
				"Europe/Paris|Atlantic/Jan_Mayen",
				"Europe/Paris|CET",
				"Europe/Paris|Europe/Amsterdam",
				"Europe/Paris|Europe/Andorra",
				"Europe/Paris|Europe/Belgrade",
				"Europe/Paris|Europe/Berlin",
				"Europe/Paris|Europe/Bratislava",
				"Europe/Paris|Europe/Brussels",
				"Europe/Paris|Europe/Budapest",
				"Europe/Paris|Europe/Busingen",
				"Europe/Paris|Europe/Copenhagen",
				"Europe/Paris|Europe/Gibraltar",
				"Europe/Paris|Europe/Ljubljana",
				"Europe/Paris|Europe/Luxembourg",
				"Europe/Paris|Europe/Madrid",
				"Europe/Paris|Europe/Malta",
				"Europe/Paris|Europe/Monaco",
				"Europe/Paris|Europe/Oslo",
				"Europe/Paris|Europe/Podgorica",
				"Europe/Paris|Europe/Prague",
				"Europe/Paris|Europe/Rome",
				"Europe/Paris|Europe/San_Marino",
				"Europe/Paris|Europe/Sarajevo",
				"Europe/Paris|Europe/Skopje",
				"Europe/Paris|Europe/Stockholm",
				"Europe/Paris|Europe/Tirane",
				"Europe/Paris|Europe/Vaduz",
				"Europe/Paris|Europe/Vatican",
				"Europe/Paris|Europe/Vienna",
				"Europe/Paris|Europe/Warsaw",
				"Europe/Paris|Europe/Zagreb",
				"Europe/Paris|Europe/Zurich",
				"Europe/Paris|Poland",
				"Europe/Ulyanovsk|Europe/Astrakhan",
				"Pacific/Auckland|Antarctica/McMurdo",
				"Pacific/Auckland|Antarctica/South_Pole",
				"Pacific/Auckland|NZ",
				"Pacific/Chatham|NZ-CHAT",
				"Pacific/Easter|Chile/EasterIsland",
				"Pacific/Fakaofo|Etc/GMT-13",
				"Pacific/Fakaofo|Pacific/Enderbury",
				"Pacific/Galapagos|Etc/GMT+6",
				"Pacific/Gambier|Etc/GMT+9",
				"Pacific/Guadalcanal|Antarctica/Macquarie",
				"Pacific/Guadalcanal|Etc/GMT-11",
				"Pacific/Guadalcanal|Pacific/Efate",
				"Pacific/Guadalcanal|Pacific/Kosrae",
				"Pacific/Guadalcanal|Pacific/Noumea",
				"Pacific/Guadalcanal|Pacific/Pohnpei",
				"Pacific/Guadalcanal|Pacific/Ponape",
				"Pacific/Guam|Pacific/Saipan",
				"Pacific/Honolulu|HST",
				"Pacific/Honolulu|Pacific/Johnston",
				"Pacific/Honolulu|US/Hawaii",
				"Pacific/Kiritimati|Etc/GMT-14",
				"Pacific/Niue|Etc/GMT+11",
				"Pacific/Pago_Pago|Pacific/Midway",
				"Pacific/Pago_Pago|Pacific/Samoa",
				"Pacific/Pago_Pago|US/Samoa",
				"Pacific/Pitcairn|Etc/GMT+8",
				"Pacific/Port_Moresby|Antarctica/DumontDUrville",
				"Pacific/Port_Moresby|Etc/GMT-10",
				"Pacific/Port_Moresby|Pacific/Chuuk",
				"Pacific/Port_Moresby|Pacific/Truk",
				"Pacific/Port_Moresby|Pacific/Yap",
				"Pacific/Tahiti|Etc/GMT+10",
				"Pacific/Tahiti|Pacific/Rarotonga"
			]
		});
	
	
		return moment;
	}));


/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(147);

/***/ }),

/***/ 518:
/***/ (function(module, exports) {

	/**!
	 * AngularJS file upload directives and services. Supoorts: file upload/drop/paste, resume, cancel/abort,
	 * progress, resize, thumbnail, preview, validation and CORS
	 * FileAPI Flash shim for old browsers not supporting FormData
	 * @author  Danial  <danial.farid@gmail.com>
	 * @version 11.0.2
	 */
	
	(function () {
	  /** @namespace FileAPI.noContentTimeout */
	
	  function patchXHR(fnName, newFn) {
	    window.XMLHttpRequest.prototype[fnName] = newFn(window.XMLHttpRequest.prototype[fnName]);
	  }
	
	  function redefineProp(xhr, prop, fn) {
	    try {
	      Object.defineProperty(xhr, prop, {get: fn});
	    } catch (e) {/*ignore*/
	    }
	  }
	
	  if (!window.FileAPI) {
	    window.FileAPI = {};
	  }
	
	  if (!window.XMLHttpRequest) {
	    throw 'AJAX is not supported. XMLHttpRequest is not defined.';
	  }
	
	  FileAPI.shouldLoad = !window.FormData || FileAPI.forceLoad;
	  if (FileAPI.shouldLoad) {
	    var initializeUploadListener = function (xhr) {
	      if (!xhr.__listeners) {
	        if (!xhr.upload) xhr.upload = {};
	        xhr.__listeners = [];
	        var origAddEventListener = xhr.upload.addEventListener;
	        xhr.upload.addEventListener = function (t, fn) {
	          xhr.__listeners[t] = fn;
	          if (origAddEventListener) origAddEventListener.apply(this, arguments);
	        };
	      }
	    };
	
	    patchXHR('open', function (orig) {
	      return function (m, url, b) {
	        initializeUploadListener(this);
	        this.__url = url;
	        try {
	          orig.apply(this, [m, url, b]);
	        } catch (e) {
	          if (e.message.indexOf('Access is denied') > -1) {
	            this.__origError = e;
	            orig.apply(this, [m, '_fix_for_ie_crossdomain__', b]);
	          }
	        }
	      };
	    });
	
	    patchXHR('getResponseHeader', function (orig) {
	      return function (h) {
	        return this.__fileApiXHR && this.__fileApiXHR.getResponseHeader ? this.__fileApiXHR.getResponseHeader(h) : (orig == null ? null : orig.apply(this, [h]));
	      };
	    });
	
	    patchXHR('getAllResponseHeaders', function (orig) {
	      return function () {
	        return this.__fileApiXHR && this.__fileApiXHR.getAllResponseHeaders ? this.__fileApiXHR.getAllResponseHeaders() : (orig == null ? null : orig.apply(this));
	      };
	    });
	
	    patchXHR('abort', function (orig) {
	      return function () {
	        return this.__fileApiXHR && this.__fileApiXHR.abort ? this.__fileApiXHR.abort() : (orig == null ? null : orig.apply(this));
	      };
	    });
	
	    patchXHR('setRequestHeader', function (orig) {
	      return function (header, value) {
	        if (header === '__setXHR_') {
	          initializeUploadListener(this);
	          var val = value(this);
	          // fix for angular < 1.2.0
	          if (val instanceof Function) {
	            val(this);
	          }
	        } else {
	          this.__requestHeaders = this.__requestHeaders || {};
	          this.__requestHeaders[header] = value;
	          orig.apply(this, arguments);
	        }
	      };
	    });
	
	    patchXHR('send', function (orig) {
	      return function () {
	        var xhr = this;
	        if (arguments[0] && arguments[0].__isFileAPIShim) {
	          var formData = arguments[0];
	          var config = {
	            url: xhr.__url,
	            jsonp: false, //removes the callback form param
	            cache: true, //removes the ?fileapiXXX in the url
	            complete: function (err, fileApiXHR) {
	              if (err && angular.isString(err) && err.indexOf('#2174') !== -1) {
	                // this error seems to be fine the file is being uploaded properly.
	                err = null;
	              }
	              xhr.__completed = true;
	              if (!err && xhr.__listeners.load)
	                xhr.__listeners.load({
	                  type: 'load',
	                  loaded: xhr.__loaded,
	                  total: xhr.__total,
	                  target: xhr,
	                  lengthComputable: true
	                });
	              if (!err && xhr.__listeners.loadend)
	                xhr.__listeners.loadend({
	                  type: 'loadend',
	                  loaded: xhr.__loaded,
	                  total: xhr.__total,
	                  target: xhr,
	                  lengthComputable: true
	                });
	              if (err === 'abort' && xhr.__listeners.abort)
	                xhr.__listeners.abort({
	                  type: 'abort',
	                  loaded: xhr.__loaded,
	                  total: xhr.__total,
	                  target: xhr,
	                  lengthComputable: true
	                });
	              if (fileApiXHR.status !== undefined) redefineProp(xhr, 'status', function () {
	                return (fileApiXHR.status === 0 && err && err !== 'abort') ? 500 : fileApiXHR.status;
	              });
	              if (fileApiXHR.statusText !== undefined) redefineProp(xhr, 'statusText', function () {
	                return fileApiXHR.statusText;
	              });
	              redefineProp(xhr, 'readyState', function () {
	                return 4;
	              });
	              if (fileApiXHR.response !== undefined) redefineProp(xhr, 'response', function () {
	                return fileApiXHR.response;
	              });
	              var resp = fileApiXHR.responseText || (err && fileApiXHR.status === 0 && err !== 'abort' ? err : undefined);
	              redefineProp(xhr, 'responseText', function () {
	                return resp;
	              });
	              redefineProp(xhr, 'response', function () {
	                return resp;
	              });
	              if (err) redefineProp(xhr, 'err', function () {
	                return err;
	              });
	              xhr.__fileApiXHR = fileApiXHR;
	              if (xhr.onreadystatechange) xhr.onreadystatechange();
	              if (xhr.onload) xhr.onload();
	            },
	            progress: function (e) {
	              e.target = xhr;
	              if (xhr.__listeners.progress) xhr.__listeners.progress(e);
	              xhr.__total = e.total;
	              xhr.__loaded = e.loaded;
	              if (e.total === e.loaded) {
	                // fix flash issue that doesn't call complete if there is no response text from the server
	                var _this = this;
	                setTimeout(function () {
	                  if (!xhr.__completed) {
	                    xhr.getAllResponseHeaders = function () {
	                    };
	                    _this.complete(null, {status: 204, statusText: 'No Content'});
	                  }
	                }, FileAPI.noContentTimeout || 10000);
	              }
	            },
	            headers: xhr.__requestHeaders
	          };
	          config.data = {};
	          config.files = {};
	          for (var i = 0; i < formData.data.length; i++) {
	            var item = formData.data[i];
	            if (item.val != null && item.val.name != null && item.val.size != null && item.val.type != null) {
	              config.files[item.key] = item.val;
	            } else {
	              config.data[item.key] = item.val;
	            }
	          }
	
	          setTimeout(function () {
	            if (!FileAPI.hasFlash) {
	              throw 'Adode Flash Player need to be installed. To check ahead use "FileAPI.hasFlash"';
	            }
	            xhr.__fileApiXHR = FileAPI.upload(config);
	          }, 1);
	        } else {
	          if (this.__origError) {
	            throw this.__origError;
	          }
	          orig.apply(xhr, arguments);
	        }
	      };
	    });
	    window.XMLHttpRequest.__isFileAPIShim = true;
	    window.FormData = FormData = function () {
	      return {
	        append: function (key, val, name) {
	          if (val.__isFileAPIBlobShim) {
	            val = val.data[0];
	          }
	          this.data.push({
	            key: key,
	            val: val,
	            name: name
	          });
	        },
	        data: [],
	        __isFileAPIShim: true
	      };
	    };
	
	    window.Blob = Blob = function (b) {
	      return {
	        data: b,
	        __isFileAPIBlobShim: true
	      };
	    };
	  }
	
	})();
	
	(function () {
	  /** @namespace FileAPI.forceLoad */
	  /** @namespace window.FileAPI.jsUrl */
	  /** @namespace window.FileAPI.jsPath */
	
	  function isInputTypeFile(elem) {
	    return elem[0].tagName.toLowerCase() === 'input' && elem.attr('type') && elem.attr('type').toLowerCase() === 'file';
	  }
	
	  function hasFlash() {
	    try {
	      var fo = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
	      if (fo) return true;
	    } catch (e) {
	      if (navigator.mimeTypes['application/x-shockwave-flash'] !== undefined) return true;
	    }
	    return false;
	  }
	
	  function getOffset(obj) {
	    var left = 0, top = 0;
	
	    if (window.jQuery) {
	      return jQuery(obj).offset();
	    }
	
	    if (obj.offsetParent) {
	      do {
	        left += (obj.offsetLeft - obj.scrollLeft);
	        top += (obj.offsetTop - obj.scrollTop);
	        obj = obj.offsetParent;
	      } while (obj);
	    }
	    return {
	      left: left,
	      top: top
	    };
	  }
	
	  if (FileAPI.shouldLoad) {
	    FileAPI.hasFlash = hasFlash();
	
	    //load FileAPI
	    if (FileAPI.forceLoad) {
	      FileAPI.html5 = false;
	    }
	
	    if (!FileAPI.upload) {
	      var jsUrl, basePath, script = document.createElement('script'), allScripts = document.getElementsByTagName('script'), i, index, src;
	      if (window.FileAPI.jsUrl) {
	        jsUrl = window.FileAPI.jsUrl;
	      } else if (window.FileAPI.jsPath) {
	        basePath = window.FileAPI.jsPath;
	      } else {
	        for (i = 0; i < allScripts.length; i++) {
	          src = allScripts[i].src;
	          index = src.search(/\/ng\-file\-upload[\-a-zA-z0-9\.]*\.js/);
	          if (index > -1) {
	            basePath = src.substring(0, index + 1);
	            break;
	          }
	        }
	      }
	
	      if (FileAPI.staticPath == null) FileAPI.staticPath = basePath;
	      script.setAttribute('src', jsUrl || basePath + 'FileAPI.min.js');
	      document.getElementsByTagName('head')[0].appendChild(script);
	    }
	
	    FileAPI.ngfFixIE = function (elem, fileElem, changeFn) {
	      if (!hasFlash()) {
	        throw 'Adode Flash Player need to be installed. To check ahead use "FileAPI.hasFlash"';
	      }
	      var fixInputStyle = function () {
	        var label = fileElem.parent();
	        if (elem.attr('disabled')) {
	          if (label) label.removeClass('js-fileapi-wrapper');
	        } else {
	          if (!fileElem.attr('__ngf_flash_')) {
	            fileElem.unbind('change');
	            fileElem.unbind('click');
	            fileElem.bind('change', function (evt) {
	              fileApiChangeFn.apply(this, [evt]);
	              changeFn.apply(this, [evt]);
	            });
	            fileElem.attr('__ngf_flash_', 'true');
	          }
	          label.addClass('js-fileapi-wrapper');
	          if (!isInputTypeFile(elem)) {
	            label.css('position', 'absolute')
	              .css('top', getOffset(elem[0]).top + 'px').css('left', getOffset(elem[0]).left + 'px')
	              .css('width', elem[0].offsetWidth + 'px').css('height', elem[0].offsetHeight + 'px')
	              .css('filter', 'alpha(opacity=0)').css('display', elem.css('display'))
	              .css('overflow', 'hidden').css('z-index', '900000')
	              .css('visibility', 'visible');
	            fileElem.css('width', elem[0].offsetWidth + 'px').css('height', elem[0].offsetHeight + 'px')
	              .css('position', 'absolute').css('top', '0px').css('left', '0px');
	          }
	        }
	      };
	
	      elem.bind('mouseenter', fixInputStyle);
	
	      var fileApiChangeFn = function (evt) {
	        var files = FileAPI.getFiles(evt);
	        //just a double check for #233
	        for (var i = 0; i < files.length; i++) {
	          if (files[i].size === undefined) files[i].size = 0;
	          if (files[i].name === undefined) files[i].name = 'file';
	          if (files[i].type === undefined) files[i].type = 'undefined';
	        }
	        if (!evt.target) {
	          evt.target = {};
	        }
	        evt.target.files = files;
	        // if evt.target.files is not writable use helper field
	        if (evt.target.files !== files) {
	          evt.__files_ = files;
	        }
	        (evt.__files_ || evt.target.files).item = function (i) {
	          return (evt.__files_ || evt.target.files)[i] || null;
	        };
	      };
	    };
	
	    FileAPI.disableFileInput = function (elem, disable) {
	      if (disable) {
	        elem.removeClass('js-fileapi-wrapper');
	      } else {
	        elem.addClass('js-fileapi-wrapper');
	      }
	    };
	  }
	})();
	
	if (!window.FileReader) {
	  window.FileReader = function () {
	    var _this = this, loadStarted = false;
	    this.listeners = {};
	    this.addEventListener = function (type, fn) {
	      _this.listeners[type] = _this.listeners[type] || [];
	      _this.listeners[type].push(fn);
	    };
	    this.removeEventListener = function (type, fn) {
	      if (_this.listeners[type]) _this.listeners[type].splice(_this.listeners[type].indexOf(fn), 1);
	    };
	    this.dispatchEvent = function (evt) {
	      var list = _this.listeners[evt.type];
	      if (list) {
	        for (var i = 0; i < list.length; i++) {
	          list[i].call(_this, evt);
	        }
	      }
	    };
	    this.onabort = this.onerror = this.onload = this.onloadstart = this.onloadend = this.onprogress = null;
	
	    var constructEvent = function (type, evt) {
	      var e = {type: type, target: _this, loaded: evt.loaded, total: evt.total, error: evt.error};
	      if (evt.result != null) e.target.result = evt.result;
	      return e;
	    };
	    var listener = function (evt) {
	      if (!loadStarted) {
	        loadStarted = true;
	        if (_this.onloadstart) _this.onloadstart(constructEvent('loadstart', evt));
	      }
	      var e;
	      if (evt.type === 'load') {
	        if (_this.onloadend) _this.onloadend(constructEvent('loadend', evt));
	        e = constructEvent('load', evt);
	        if (_this.onload) _this.onload(e);
	        _this.dispatchEvent(e);
	      } else if (evt.type === 'progress') {
	        e = constructEvent('progress', evt);
	        if (_this.onprogress) _this.onprogress(e);
	        _this.dispatchEvent(e);
	      } else {
	        e = constructEvent('error', evt);
	        if (_this.onerror) _this.onerror(e);
	        _this.dispatchEvent(e);
	      }
	    };
	    this.readAsDataURL = function (file) {
	      FileAPI.readAsDataURL(file, listener);
	    };
	    this.readAsText = function (file) {
	      FileAPI.readAsText(file, listener);
	    };
	  };
	}
	
	/**!
	 * AngularJS file upload directives and services. Supoorts: file upload/drop/paste, resume, cancel/abort,
	 * progress, resize, thumbnail, preview, validation and CORS
	 * @author  Danial  <danial.farid@gmail.com>
	 * @version 11.0.2
	 */
	
	if (window.XMLHttpRequest && !(window.FileAPI && FileAPI.shouldLoad)) {
	  window.XMLHttpRequest.prototype.setRequestHeader = (function (orig) {
	    return function (header, value) {
	      if (header === '__setXHR_') {
	        var val = value(this);
	        // fix for angular < 1.2.0
	        if (val instanceof Function) {
	          val(this);
	        }
	      } else {
	        orig.apply(this, arguments);
	      }
	    };
	  })(window.XMLHttpRequest.prototype.setRequestHeader);
	}
	
	var ngFileUpload = angular.module('ngFileUpload', []);
	
	ngFileUpload.version = '11.0.2';
	
	ngFileUpload.service('UploadBase', ['$http', '$q', '$timeout', function ($http, $q, $timeout) {
	  var upload = this;
	
	  this.isResumeSupported = function () {
	    return window.Blob && (window.Blob instanceof Function) && new window.Blob().slice;
	  };
	
	  var resumeSupported = this.isResumeSupported();
	
	  function sendHttp(config) {
	    config.method = config.method || 'POST';
	    config.headers = config.headers || {};
	
	    var deferred = config._deferred = config._deferred || $q.defer();
	    var promise = deferred.promise;
	
	    function notifyProgress(e) {
	      if (deferred.notify) {
	        deferred.notify(e);
	      }
	      if (promise.progressFunc) {
	        $timeout(function () {
	          promise.progressFunc(e);
	        });
	      }
	    }
	
	    function getNotifyEvent(n) {
	      if (config._start != null && resumeSupported) {
	        return {
	          loaded: n.loaded + config._start, total: config._file.size, type: n.type, config: config,
	          lengthComputable: true, target: n.target
	        };
	      } else {
	        return n;
	      }
	    }
	
	    if (!config.disableProgress) {
	      config.headers.__setXHR_ = function () {
	        return function (xhr) {
	          if (!xhr || !(xhr instanceof XMLHttpRequest)) return;
	          config.__XHR = xhr;
	          if (config.xhrFn) config.xhrFn(xhr);
	          xhr.upload.addEventListener('progress', function (e) {
	            e.config = config;
	            notifyProgress(getNotifyEvent(e));
	          }, false);
	          //fix for firefox not firing upload progress end, also IE8-9
	          xhr.upload.addEventListener('load', function (e) {
	            if (e.lengthComputable) {
	              e.config = config;
	              notifyProgress(getNotifyEvent(e));
	            }
	          }, false);
	        };
	      };
	    }
	
	    function uploadWithAngular() {
	      $http(config).then(function (r) {
	        if (resumeSupported && config._chunkSize && !config._finished) {
	          notifyProgress({loaded: config._end, total: config._file.size, config: config, type: 'progress'});
	          upload.upload(config, true);
	        } else {
	          if (config._finished) delete config._finished;
	          deferred.resolve(r);
	        }
	      }, function (e) {
	        deferred.reject(e);
	      }, function (n) {
	        deferred.notify(n);
	      });
	    }
	
	    if (!resumeSupported) {
	      uploadWithAngular();
	    } else if (config._chunkSize && config._end && !config._finished) {
	      config._start = config._end;
	      config._end += config._chunkSize;
	      uploadWithAngular();
	    } else if (config.resumeSizeUrl) {
	      $http.get(config.resumeSizeUrl).then(function (resp) {
	        if (config.resumeSizeResponseReader) {
	          config._start = config.resumeSizeResponseReader(resp.data);
	        } else {
	          config._start = parseInt((resp.data.size == null ? resp.data : resp.data.size).toString());
	        }
	        if (config._chunkSize) {
	          config._end = config._start + config._chunkSize;
	        }
	        uploadWithAngular();
	      }, function (e) {
	        throw e;
	      });
	    } else if (config.resumeSize) {
	      config.resumeSize().then(function (size) {
	        config._start = size;
	        uploadWithAngular();
	      }, function (e) {
	        throw e;
	      });
	    } else {
	      uploadWithAngular();
	    }
	
	
	    promise.success = function (fn) {
	      promise.then(function (response) {
	        fn(response.data, response.status, response.headers, config);
	      });
	      return promise;
	    };
	
	    promise.error = function (fn) {
	      promise.then(null, function (response) {
	        fn(response.data, response.status, response.headers, config);
	      });
	      return promise;
	    };
	
	    promise.progress = function (fn) {
	      promise.progressFunc = fn;
	      promise.then(null, null, function (n) {
	        fn(n);
	      });
	      return promise;
	    };
	    promise.abort = promise.pause = function () {
	      if (config.__XHR) {
	        $timeout(function () {
	          config.__XHR.abort();
	        });
	      }
	      return promise;
	    };
	    promise.xhr = function (fn) {
	      config.xhrFn = (function (origXhrFn) {
	        return function () {
	          if (origXhrFn) origXhrFn.apply(promise, arguments);
	          fn.apply(promise, arguments);
	        };
	      })(config.xhrFn);
	      return promise;
	    };
	
	    return promise;
	  }
	
	  this.rename = function (file, name) {
	    file.ngfName = name;
	    return file;
	  };
	
	  this.jsonBlob = function (val) {
	    if (val != null && !angular.isString(val)) {
	      val = JSON.stringify(val);
	    }
	    var blob = new window.Blob([val], {type: 'application/json'});
	    blob._ngfBlob = true;
	    return blob;
	  };
	
	  this.json = function (val) {
	    return angular.toJson(val);
	  };
	
	  function copy(obj) {
	    var clone = {};
	    for (var key in obj) {
	      if (obj.hasOwnProperty(key)) {
	        clone[key] = obj[key];
	      }
	    }
	    return clone;
	  }
	
	  this.upload = function (config, internal) {
	    function isFile(file) {
	      return file != null && (file instanceof window.Blob || (file.flashId && file.name && file.size));
	    }
	
	    function toResumeFile(file, formData) {
	      if (file._ngfBlob) return file;
	      config._file = config._file || file;
	      if (config._start != null && resumeSupported) {
	        if (config._end && config._end >= file.size) {
	          config._finished = true;
	          config._end = file.size;
	        }
	        var slice = file.slice(config._start, config._end || file.size);
	        slice.name = file.name;
	        slice.ngfName = file.ngfName;
	        if (config._chunkSize) {
	          formData.append('_chunkSize', config._chunkSize);
	          formData.append('_currentChunkSize', config._end - config._start);
	          formData.append('_chunkNumber', Math.floor(config._start / config._chunkSize));
	          formData.append('_totalSize', config._file.size);
	        }
	        return slice;
	      }
	      return file;
	    }
	
	    function addFieldToFormData(formData, val, key) {
	      if (val !== undefined) {
	        if (angular.isDate(val)) {
	          val = val.toISOString();
	        }
	        if (angular.isString(val)) {
	          formData.append(key, val);
	        } else if (isFile(val)) {
	          var file = toResumeFile(val, formData);
	          var split = key.split(',');
	          if (split[1]) {
	            file.ngfName = split[1].replace(/^\s+|\s+$/g, '');
	            key = split[0];
	          }
	          config._fileKey = config._fileKey || key;
	          formData.append(key, file, file.ngfName || file.name);
	        } else {
	          if (angular.isObject(val)) {
	            if (val.$$ngfCircularDetection) throw 'ngFileUpload: Circular reference in config.data. Make sure specified data for Upload.upload() has no circular reference: ' + key;
	
	            val.$$ngfCircularDetection = true;
	            try {
	              for (var k in val) {
	                if (val.hasOwnProperty(k) && k !== '$$ngfCircularDetection') {
	                  var objectKey = config.objectKey == null ? '[i]' : config.objectKey;
	                  if (val.length && parseInt(k) > -1) {
	                    objectKey = config.arrayKey == null ? objectKey : config.arrayKey;
	                  }
	                  addFieldToFormData(formData, val[k], key + objectKey.replace(/[ik]/g, k));
	                }
	              }
	            } finally {
	              delete val.$$ngfCircularDetection;
	            }
	          } else {
	            formData.append(key, val);
	          }
	        }
	      }
	    }
	
	    function digestConfig() {
	      config._chunkSize = upload.translateScalars(config.resumeChunkSize);
	      config._chunkSize = config._chunkSize ? parseInt(config._chunkSize.toString()) : null;
	
	      config.headers = config.headers || {};
	      config.headers['Content-Type'] = undefined;
	      config.transformRequest = config.transformRequest ?
	        (angular.isArray(config.transformRequest) ?
	          config.transformRequest : [config.transformRequest]) : [];
	      config.transformRequest.push(function (data) {
	        var formData = new window.FormData(), key;
	        data = data || config.fields || {};
	        if (config.file) {
	          data.file = config.file;
	        }
	        for (key in data) {
	          if (data.hasOwnProperty(key)) {
	            var val = data[key];
	            if (config.formDataAppender) {
	              config.formDataAppender(formData, key, val);
	            } else {
	              addFieldToFormData(formData, val, key);
	            }
	          }
	        }
	
	        return formData;
	      });
	    }
	
	    if (!internal) config = copy(config);
	    if (!config._isDigested) {
	      config._isDigested = true;
	      digestConfig();
	    }
	
	    return sendHttp(config);
	  };
	
	  this.http = function (config) {
	    config = copy(config);
	    config.transformRequest = config.transformRequest || function (data) {
	        if ((window.ArrayBuffer && data instanceof window.ArrayBuffer) || data instanceof window.Blob) {
	          return data;
	        }
	        return $http.defaults.transformRequest[0].apply(this, arguments);
	      };
	    config._chunkSize = upload.translateScalars(config.resumeChunkSize);
	    config._chunkSize = config._chunkSize ? parseInt(config._chunkSize.toString()) : null;
	
	    return sendHttp(config);
	  };
	
	  this.translateScalars = function (str) {
	    if (angular.isString(str)) {
	      if (str.search(/kb/i) === str.length - 2) {
	        return parseFloat(str.substring(0, str.length - 2) * 1000);
	      } else if (str.search(/mb/i) === str.length - 2) {
	        return parseFloat(str.substring(0, str.length - 2) * 1000000);
	      } else if (str.search(/gb/i) === str.length - 2) {
	        return parseFloat(str.substring(0, str.length - 2) * 1000000000);
	      } else if (str.search(/b/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1));
	      } else if (str.search(/s/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1));
	      } else if (str.search(/m/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1) * 60);
	      } else if (str.search(/h/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1) * 3600);
	      }
	    }
	    return str;
	  };
	
	  this.setDefaults = function (defaults) {
	    this.defaults = defaults || {};
	  };
	
	  this.defaults = {};
	  this.version = ngFileUpload.version;
	}
	
	]);
	
	ngFileUpload.service('Upload', ['$parse', '$timeout', '$compile', '$q', 'UploadExif', function ($parse, $timeout, $compile, $q, UploadExif) {
	  var upload = UploadExif;
	  upload.getAttrWithDefaults = function (attr, name) {
	    if (attr[name] != null) return attr[name];
	    var def = upload.defaults[name];
	    return (def == null ? def : (angular.isString(def) ? def : JSON.stringify(def)));
	  };
	
	  upload.attrGetter = function (name, attr, scope, params) {
	    var attrVal = this.getAttrWithDefaults(attr, name);
	    if (scope) {
	      try {
	        if (params) {
	          return $parse(attrVal)(scope, params);
	        } else {
	          return $parse(attrVal)(scope);
	        }
	      } catch (e) {
	        // hangle string value without single qoute
	        if (name.search(/min|max|pattern/i)) {
	          return attrVal;
	        } else {
	          throw e;
	        }
	      }
	    } else {
	      return attrVal;
	    }
	  };
	
	  upload.shouldUpdateOn = function (type, attr, scope) {
	    var modelOptions = upload.attrGetter('ngModelOptions', attr, scope);
	    if (modelOptions && modelOptions.updateOn) {
	      return modelOptions.updateOn.split(' ').indexOf(type) > -1;
	    }
	    return true;
	  };
	
	  upload.emptyPromise = function () {
	    var d = $q.defer();
	    var args = arguments;
	    $timeout(function () {
	      d.resolve.apply(d, args);
	    });
	    return d.promise;
	  };
	
	  upload.happyPromise = function (promise, data) {
	    var d = $q.defer();
	    promise.then(function (result) {
	      d.resolve(result);
	    }, function (error) {
	      $timeout(function () {
	        throw error;
	      });
	      d.resolve(data);
	    });
	    return d.promise;
	  };
	
	  function applyExifRotations(files, attr, scope) {
	    var promises = [upload.emptyPromise()];
	    angular.forEach(files, function (f, i) {
	      if (f.type.indexOf('image/jpeg') === 0 && upload.attrGetter('ngfFixOrientation', attr, scope, {$file: f})) {
	        promises.push(upload.happyPromise(upload.applyExifRotation(f), f).then(function (fixedFile) {
	          files.splice(i, 1, fixedFile);
	        }));
	      }
	    });
	    return $q.all(promises);
	  }
	
	  function resize(files, attr, scope) {
	    var param = upload.attrGetter('ngfResize', attr, scope);
	    if (!param || !angular.isObject(param) || !upload.isResizeSupported() || !files.length) return upload.emptyPromise();
	    var promises = [upload.emptyPromise()];
	    angular.forEach(files, function (f, i) {
	      if (f.type.indexOf('image') === 0) {
	        if (param.pattern && !upload.validatePattern(f, param.pattern)) return;
	        var promise = upload.resize(f, param.width, param.height, param.quality,
	          param.type, param.ratio, param.centerCrop, function(width, height) {
	            return upload.attrGetter('ngfResizeIf', attr, scope,
	              {$width: width, $height: height, $file: f});
	          });
	        promises.push(promise);
	        promise.then(function (resizedFile) {
	          files.splice(i, 1, resizedFile);
	        }, function (e) {
	          f.$error = 'resize';
	          f.$errorParam = (e ? (e.message ? e.message : e) + ': ' : '') + (f && f.name);
	        });
	      }
	    });
	    return $q.all(promises);
	  }
	
	  function handleKeep(files, prevFiles, attr, scope) {
	    var dupFiles = [];
	    var keep = upload.attrGetter('ngfKeep', attr, scope);
	    if (keep) {
	      var hasNew = false;
	
	      if (keep === 'distinct' || upload.attrGetter('ngfKeepDistinct', attr, scope) === true) {
	        var len = prevFiles.length;
	        if (files) {
	          for (var i = 0; i < files.length; i++) {
	            for (var j = 0; j < len; j++) {
	              if (files[i].name === prevFiles[j].name) {
	                dupFiles.push(files[i]);
	                break;
	              }
	            }
	            if (j === len) {
	              prevFiles.push(files[i]);
	              hasNew = true;
	            }
	          }
	        }
	        files = prevFiles;
	      } else {
	        files = prevFiles.concat(files || []);
	      }
	    }
	    return {files: files, dupFiles: dupFiles, keep: keep};
	  }
	
	  upload.updateModel = function (ngModel, attr, scope, fileChange, files, evt, noDelay) {
	    function update(files, invalidFiles, newFiles, dupFiles, isSingleModel) {
	      var file = files && files.length ? files[0] : null;
	
	      if (ngModel) {
	        upload.applyModelValidation(ngModel, files);
	        ngModel.$setViewValue(isSingleModel ? file : files);
	      }
	
	      if (fileChange) {
	        $parse(fileChange)(scope, {
	          $files: files,
	          $file: file,
	          $newFiles: newFiles,
	          $duplicateFiles: dupFiles,
	          $invalidFiles: invalidFiles,
	          $event: evt
	        });
	      }
	
	      var invalidModel = upload.attrGetter('ngfModelInvalid', attr);
	      if (invalidModel) {
	        $timeout(function () {
	          $parse(invalidModel).assign(scope, invalidFiles);
	        });
	      }
	      $timeout(function () {
	        // scope apply changes
	      });
	    }
	
	    var newFiles = files;
	    var prevFiles = ngModel && ngModel.$modelValue && (angular.isArray(ngModel.$modelValue) ?
	        ngModel.$modelValue : [ngModel.$modelValue]);
	    prevFiles = (prevFiles || attr.$$ngfPrevFiles || []).slice(0);
	    var keepResult = handleKeep(files, prevFiles, attr, scope);
	    files = keepResult.files;
	    var dupFiles = keepResult.dupFiles;
	    var isSingleModel = !upload.attrGetter('ngfMultiple', attr, scope) && !upload.attrGetter('multiple', attr) && !keepResult.keep;
	
	    attr.$$ngfPrevFiles = files;
	
	    if (keepResult.keep && (!newFiles || !newFiles.length)) return;
	
	    upload.attrGetter('ngfBeforeModelChange', attr, scope, {$files: files,
	      $file: files && files.length ? files[0] : null,
	      $duplicateFiles: dupFiles,
	      $event: evt});
	
	    upload.validate(newFiles, ngModel, attr, scope).then(function () {
	      if (noDelay) {
	        update(files, [], newFiles, dupFiles, isSingleModel);
	      } else {
	        var options = upload.attrGetter('ngModelOptions', attr, scope);
	        if (!options || !options.allowInvalid) {
	          var valids = [], invalids = [];
	          angular.forEach(files, function (file) {
	            if (file.$error) {
	              invalids.push(file);
	            } else {
	              valids.push(file);
	            }
	          });
	          files = valids;
	        }
	        var fixOrientation = upload.emptyPromise(files);
	        if (upload.attrGetter('ngfFixOrientation', attr, scope) && upload.isExifSupported()) {
	          fixOrientation = applyExifRotations(files, attr, scope);
	        }
	        fixOrientation.then(function () {
	          resize(files, attr, scope).then(function () {
	            $timeout(function () {
	              update(files, invalids, newFiles, dupFiles, isSingleModel);
	            }, options && options.debounce ? options.debounce.change || options.debounce : 0);
	          }, function (e) {
	            throw 'Could not resize files ' + e;
	          });
	        });
	      }
	    });
	
	    // cleaning object url memories
	    var l = prevFiles.length;
	    while (l--) {
	      var prevFile = prevFiles[l];
	      if (window.URL && prevFile.blobUrl) {
	        URL.revokeObjectURL(prevFile.blobUrl);
	        delete prevFile.blobUrl;
	      }
	    }
	  };
	
	  return upload;
	}]);
	
	ngFileUpload.directive('ngfSelect', ['$parse', '$timeout', '$compile', 'Upload', function ($parse, $timeout, $compile, Upload) {
	  var generatedElems = [];
	
	  function isDelayedClickSupported(ua) {
	    // fix for android native browser < 4.4 and safari windows
	    var m = ua.match(/Android[^\d]*(\d+)\.(\d+)/);
	    if (m && m.length > 2) {
	      var v = Upload.defaults.androidFixMinorVersion || 4;
	      return parseInt(m[1]) < 4 || (parseInt(m[1]) === v && parseInt(m[2]) < v);
	    }
	
	    // safari on windows
	    return ua.indexOf('Chrome') === -1 && /.*Windows.*Safari.*/.test(ua);
	  }
	
	  function linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile, upload) {
	    /** @namespace attr.ngfSelect */
	    /** @namespace attr.ngfChange */
	    /** @namespace attr.ngModel */
	    /** @namespace attr.ngModelOptions */
	    /** @namespace attr.ngfMultiple */
	    /** @namespace attr.ngfCapture */
	    /** @namespace attr.ngfValidate */
	    /** @namespace attr.ngfKeep */
	    var attrGetter = function (name, scope) {
	      return upload.attrGetter(name, attr, scope);
	    };
	
	    function isInputTypeFile() {
	      return elem[0].tagName.toLowerCase() === 'input' && attr.type && attr.type.toLowerCase() === 'file';
	    }
	
	    function fileChangeAttr() {
	      return attrGetter('ngfChange') || attrGetter('ngfSelect');
	    }
	
	    function changeFn(evt) {
	      if (upload.shouldUpdateOn('change', attr, scope)) {
	        var fileList = evt.__files_ || (evt.target && evt.target.files), files = [];
	        for (var i = 0; i < fileList.length; i++) {
	          files.push(fileList[i]);
	        }
	        upload.updateModel(ngModel, attr, scope, fileChangeAttr(),
	          files.length ? files : null, evt);
	      }
	    }
	
	    upload.registerModelChangeValidator(ngModel, attr, scope);
	
	    var unwatches = [];
	    unwatches.push(scope.$watch(attrGetter('ngfMultiple'), function () {
	      fileElem.attr('multiple', attrGetter('ngfMultiple', scope));
	    }));
	    unwatches.push(scope.$watch(attrGetter('ngfCapture'), function () {
	      fileElem.attr('capture', attrGetter('ngfCapture', scope));
	    }));
	    unwatches.push(scope.$watch(attrGetter('ngfAccept'), function () {
	      fileElem.attr('accept', attrGetter('ngfAccept', scope));
	    }));
	    attr.$observe('accept', function () {
	      fileElem.attr('accept', attrGetter('accept'));
	    });
	    unwatches.push(function () {
	      if (attr.$$observers) delete attr.$$observers.accept;
	    });
	    function bindAttrToFileInput(fileElem) {
	      if (elem !== fileElem) {
	        for (var i = 0; i < elem[0].attributes.length; i++) {
	          var attribute = elem[0].attributes[i];
	          if (attribute.name !== 'type' && attribute.name !== 'class' && attribute.name !== 'style') {
	            if (attribute.value == null || attribute.value === '') {
	              if (attribute.name === 'required') attribute.value = 'required';
	              if (attribute.name === 'multiple') attribute.value = 'multiple';
	            }
	            fileElem.attr(attribute.name, attribute.name === 'id' ? 'ngf-' + attribute.value : attribute.value);
	          }
	        }
	      }
	    }
	
	    function createFileInput() {
	      if (isInputTypeFile()) {
	        return elem;
	      }
	
	      var fileElem = angular.element('<input type="file">');
	
	      bindAttrToFileInput(fileElem);
	
	      var label = angular.element('<label>upload</label>');
	      label.css('visibility', 'hidden').css('position', 'absolute').css('overflow', 'hidden')
	        .css('width', '0px').css('height', '0px').css('border', 'none')
	        .css('margin', '0px').css('padding', '0px').attr('tabindex', '-1');
	      generatedElems.push({el: elem, ref: label});
	
	      document.body.appendChild(label.append(fileElem)[0]);
	
	      return fileElem;
	    }
	
	    var initialTouchStartY = 0;
	
	    function clickHandler(evt) {
	      if (elem.attr('disabled') || attrGetter('ngfSelectDisabled', scope)) return false;
	
	      var r = handleTouch(evt);
	      if (r != null) return r;
	
	      resetModel(evt);
	
	      // fix for md when the element is removed from the DOM and added back #460
	      try {
	        if (!isInputTypeFile() && !document.body.contains(fileElem[0])) {
	          generatedElems.push({el: elem, ref: fileElem.parent()});
	          document.body.appendChild(fileElem[0].parent());
	          fileElem.bind('change', changeFn);
	        }
	      } catch(e){/*ignore*/}
	
	      if (isDelayedClickSupported(navigator.userAgent)) {
	        setTimeout(function () {
	          fileElem[0].click();
	        }, 0);
	      } else {
	        fileElem[0].click();
	      }
	
	      return false;
	    }
	
	    function handleTouch(evt) {
	      var touches = evt.changedTouches || (evt.originalEvent && evt.originalEvent.changedTouches);
	      if (evt.type === 'touchstart') {
	        initialTouchStartY = touches ? touches[0].clientY : 0;
	        return true; // don't block event default
	      } else {
	        evt.stopPropagation();
	        evt.preventDefault();
	
	        // prevent scroll from triggering event
	        if (evt.type === 'touchend') {
	          var currentLocation = touches ? touches[0].clientY : 0;
	          if (Math.abs(currentLocation - initialTouchStartY) > 20) return false;
	        }
	      }
	    }
	
	    var fileElem = elem;
	
	    function resetModel(evt) {
	      if (upload.shouldUpdateOn('click', attr, scope) && fileElem.val()) {
	        fileElem.val(null);
	        upload.updateModel(ngModel, attr, scope, fileChangeAttr(), null, evt, true);
	      }
	    }
	
	    if (!isInputTypeFile()) {
	      fileElem = createFileInput();
	    }
	    fileElem.bind('change', changeFn);
	
	    if (!isInputTypeFile()) {
	      elem.bind('click touchstart touchend', clickHandler);
	    } else {
	      elem.bind('click', resetModel);
	    }
	
	    function ie10SameFileSelectFix(evt) {
	      if (fileElem && !fileElem.attr('__ngf_ie10_Fix_')) {
	        if (!fileElem[0].parentNode) {
	          fileElem = null;
	          return;
	        }
	        evt.preventDefault();
	        evt.stopPropagation();
	        fileElem.unbind('click');
	        var clone = fileElem.clone();
	        fileElem.replaceWith(clone);
	        fileElem = clone;
	        fileElem.attr('__ngf_ie10_Fix_', 'true');
	        fileElem.bind('change', changeFn);
	        fileElem.bind('click', ie10SameFileSelectFix);
	        fileElem[0].click();
	        return false;
	      } else {
	        fileElem.removeAttr('__ngf_ie10_Fix_');
	      }
	    }
	
	    if (navigator.appVersion.indexOf('MSIE 10') !== -1) {
	      fileElem.bind('click', ie10SameFileSelectFix);
	    }
	
	    if (ngModel) ngModel.$formatters.push(function (val) {
	      if (val == null || val.length === 0) {
	        if (fileElem.val()) {
	          fileElem.val(null);
	        }
	      }
	      return val;
	    });
	
	    scope.$on('$destroy', function () {
	      if (!isInputTypeFile()) fileElem.parent().remove();
	      angular.forEach(unwatches, function (unwatch) {
	        unwatch();
	      });
	    });
	
	    $timeout(function () {
	      for (var i = 0; i < generatedElems.length; i++) {
	        var g = generatedElems[i];
	        if (!document.body.contains(g.el[0])) {
	          generatedElems.splice(i, 1);
	          g.ref.remove();
	        }
	      }
	    });
	
	    if (window.FileAPI && window.FileAPI.ngfFixIE) {
	      window.FileAPI.ngfFixIE(elem, fileElem, changeFn);
	    }
	  }
	
	  return {
	    restrict: 'AEC',
	    require: '?ngModel',
	    link: function (scope, elem, attr, ngModel) {
	      linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile, Upload);
	    }
	  };
	}]);
	
	(function () {
	
	  ngFileUpload.service('UploadDataUrl', ['UploadBase', '$timeout', '$q', function (UploadBase, $timeout, $q) {
	    var upload = UploadBase;
	    upload.base64DataUrl = function (file) {
	      if (angular.isArray(file)) {
	        var d = $q.defer(), count = 0;
	        angular.forEach(file, function (f) {
	          upload.dataUrl(f, true)['finally'](function () {
	            count++;
	            if (count === file.length) {
	              var urls = [];
	              angular.forEach(file, function (ff) {
	                urls.push(ff.$ngfDataUrl);
	              });
	              d.resolve(urls, file);
	            }
	          });
	        });
	        return d.promise;
	      } else {
	        return upload.dataUrl(file, true);
	      }
	    };
	    upload.dataUrl = function (file, disallowObjectUrl) {
	      if (!file) return upload.emptyPromise(file, file);
	      if ((disallowObjectUrl && file.$ngfDataUrl != null) || (!disallowObjectUrl && file.$ngfBlobUrl != null)) {
	        return upload.emptyPromise(disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl, file);
	      }
	      var p = disallowObjectUrl ? file.$$ngfDataUrlPromise : file.$$ngfBlobUrlPromise;
	      if (p) return p;
	
	      var deferred = $q.defer();
	      $timeout(function () {
	        if (window.FileReader && file &&
	          (!window.FileAPI || navigator.userAgent.indexOf('MSIE 8') === -1 || file.size < 20000) &&
	          (!window.FileAPI || navigator.userAgent.indexOf('MSIE 9') === -1 || file.size < 4000000)) {
	          //prefer URL.createObjectURL for handling refrences to files of all sizes
	          //since it doesn´t build a large string in memory
	          var URL = window.URL || window.webkitURL;
	          if (URL && URL.createObjectURL && !disallowObjectUrl) {
	            var url;
	            try {
	              url = URL.createObjectURL(file);
	            } catch (e) {
	              $timeout(function () {
	                file.$ngfBlobUrl = '';
	                deferred.reject();
	              });
	              return;
	            }
	            $timeout(function () {
	              file.$ngfBlobUrl = url;
	              if (url) deferred.resolve(url, file);
	            });
	          } else {
	            var fileReader = new FileReader();
	            fileReader.onload = function (e) {
	              $timeout(function () {
	                file.$ngfDataUrl = e.target.result;
	                deferred.resolve(e.target.result, file);
	              });
	            };
	            fileReader.onerror = function () {
	              $timeout(function () {
	                file.$ngfDataUrl = '';
	                deferred.reject();
	              });
	            };
	            fileReader.readAsDataURL(file);
	          }
	        } else {
	          $timeout(function () {
	            file[disallowObjectUrl ? 'dataUrl' : 'blobUrl'] = '';
	            deferred.reject();
	          });
	        }
	      });
	
	      if (disallowObjectUrl) {
	        p = file.$$ngfDataUrlPromise = deferred.promise;
	      } else {
	        p = file.$$ngfBlobUrlPromise = deferred.promise;
	      }
	      p['finally'](function () {
	        delete file[disallowObjectUrl ? '$$ngfDataUrlPromise' : '$$ngfBlobUrlPromise'];
	      });
	      return p;
	    };
	    return upload;
	  }]);
	
	  function getTagType(el) {
	    if (el.tagName.toLowerCase() === 'img') return 'image';
	    if (el.tagName.toLowerCase() === 'audio') return 'audio';
	    if (el.tagName.toLowerCase() === 'video') return 'video';
	    return /./;
	  }
	
	  function linkFileDirective(Upload, $timeout, scope, elem, attr, directiveName, resizeParams, isBackground) {
	    function constructDataUrl(file) {
	      var disallowObjectUrl = Upload.attrGetter('ngfNoObjectUrl', attr, scope);
	      Upload.dataUrl(file, disallowObjectUrl)['finally'](function () {
	        $timeout(function () {
	          var src = (disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl) || file.$ngfDataUrl;
	          if (isBackground) {
	            elem.css('background-image', 'url(\'' + (src || '') + '\')');
	          } else {
	            elem.attr('src', src);
	          }
	          if (src) {
	            elem.removeClass('ng-hide');
	          } else {
	            elem.addClass('ng-hide');
	          }
	        });
	      });
	    }
	
	    $timeout(function () {
	      var unwatch = scope.$watch(attr[directiveName], function (file) {
	        var size = resizeParams;
	        if (directiveName === 'ngfThumbnail') {
	          if (!size) {
	            size = {width: elem[0].clientWidth, height: elem[0].clientHeight};
	          }
	          if (size.width === 0 && window.getComputedStyle) {
	            var style = getComputedStyle(elem[0]);
	            size = {
	              width: parseInt(style.width.slice(0, -2)),
	              height: parseInt(style.height.slice(0, -2))
	            };
	          }
	        }
	
	        if (angular.isString(file)) {
	          elem.removeClass('ng-hide');
	          if (isBackground) {
	            return elem.css('background-image', 'url(\'' + file + '\')');
	          } else {
	            return elem.attr('src', file);
	          }
	        }
	        if (file && file.type && file.type.search(getTagType(elem[0])) === 0 &&
	          (!isBackground || file.type.indexOf('image') === 0)) {
	          if (size && Upload.isResizeSupported()) {
	            Upload.resize(file, size.width, size.height, size.quality).then(
	              function (f) {
	                constructDataUrl(f);
	              }, function (e) {
	                throw e;
	              }
	            );
	          } else {
	            constructDataUrl(file);
	          }
	        } else {
	          elem.addClass('ng-hide');
	        }
	      });
	
	      scope.$on('$destroy', function () {
	        unwatch();
	      });
	    });
	  }
	
	
	  /** @namespace attr.ngfSrc */
	  /** @namespace attr.ngfNoObjectUrl */
	  ngFileUpload.directive('ngfSrc', ['Upload', '$timeout', function (Upload, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function (scope, elem, attr) {
	        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfSrc',
	          Upload.attrGetter('ngfResize', attr, scope), false);
	      }
	    };
	  }]);
	
	  /** @namespace attr.ngfBackground */
	  /** @namespace attr.ngfNoObjectUrl */
	  ngFileUpload.directive('ngfBackground', ['Upload', '$timeout', function (Upload, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function (scope, elem, attr) {
	        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfBackground',
	          Upload.attrGetter('ngfResize', attr, scope), true);
	      }
	    };
	  }]);
	
	  /** @namespace attr.ngfThumbnail */
	  /** @namespace attr.ngfAsBackground */
	  /** @namespace attr.ngfSize */
	  /** @namespace attr.ngfNoObjectUrl */
	  ngFileUpload.directive('ngfThumbnail', ['Upload', '$timeout', function (Upload, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function (scope, elem, attr) {
	        var size = Upload.attrGetter('ngfSize', attr, scope);
	        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfThumbnail', size,
	          Upload.attrGetter('ngfAsBackground', attr, scope));
	      }
	    };
	  }]);
	
	  ngFileUpload.config(['$compileProvider', function ($compileProvider) {
	    if ($compileProvider.imgSrcSanitizationWhitelist) $compileProvider.imgSrcSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|local|file|data|blob):/);
	    if ($compileProvider.aHrefSanitizationWhitelist) $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|local|file|data|blob):/);
	  }]);
	
	  ngFileUpload.filter('ngfDataUrl', ['UploadDataUrl', '$sce', function (UploadDataUrl, $sce) {
	    return function (file, disallowObjectUrl, trustedUrl) {
	      if (angular.isString(file)) {
	        return $sce.trustAsResourceUrl(file);
	      }
	      var src = file && ((disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl) || file.$ngfDataUrl);
	      if (file && !src) {
	        if (!file.$ngfDataUrlFilterInProgress && angular.isObject(file)) {
	          file.$ngfDataUrlFilterInProgress = true;
	          UploadDataUrl.dataUrl(file, disallowObjectUrl);
	        }
	        return '';
	      }
	      if (file) delete file.$ngfDataUrlFilterInProgress;
	      return (file && src ? (trustedUrl ? $sce.trustAsResourceUrl(src) : src) : file) || '';
	    };
	  }]);
	
	})();
	
	ngFileUpload.service('UploadValidate', ['UploadDataUrl', '$q', '$timeout', function (UploadDataUrl, $q, $timeout) {
	  var upload = UploadDataUrl;
	
	  function globStringToRegex(str) {
	    var regexp = '', excludes = [];
	    if (str.length > 2 && str[0] === '/' && str[str.length - 1] === '/') {
	      regexp = str.substring(1, str.length - 1);
	    } else {
	      var split = str.split(',');
	      if (split.length > 1) {
	        for (var i = 0; i < split.length; i++) {
	          var r = globStringToRegex(split[i]);
	          if (r.regexp) {
	            regexp += '(' + r.regexp + ')';
	            if (i < split.length - 1) {
	              regexp += '|';
	            }
	          } else {
	            excludes = excludes.concat(r.excludes);
	          }
	        }
	      } else {
	        if (str.indexOf('!') === 0) {
	          excludes.push('^((?!' + globStringToRegex(str.substring(1)).regexp + ').)*$');
	        } else {
	          if (str.indexOf('.') === 0) {
	            str = '*' + str;
	          }
	          regexp = '^' + str.replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\-]', 'g'), '\\$&') + '$';
	          regexp = regexp.replace(/\\\*/g, '.*').replace(/\\\?/g, '.');
	        }
	      }
	    }
	    return {regexp: regexp, excludes: excludes};
	  }
	
	  upload.validatePattern = function (file, val) {
	    if (!val) {
	      return true;
	    }
	    var pattern = globStringToRegex(val), valid = true;
	    if (pattern.regexp && pattern.regexp.length) {
	      var regexp = new RegExp(pattern.regexp, 'i');
	      valid = (file.type != null && regexp.test(file.type)) ||
	        (file.name != null && regexp.test(file.name));
	    }
	    var len = pattern.excludes.length;
	    while (len--) {
	      var exclude = new RegExp(pattern.excludes[len], 'i');
	      valid = valid && (file.type == null || exclude.test(file.type)) &&
	        (file.name == null || exclude.test(file.name));
	    }
	    return valid;
	  };
	
	  upload.ratioToFloat = function (val) {
	    var r = val.toString(), xIndex = r.search(/[x:]/i);
	    if (xIndex > -1) {
	      r = parseFloat(r.substring(0, xIndex)) / parseFloat(r.substring(xIndex + 1));
	    } else {
	      r = parseFloat(r);
	    }
	    return r;
	  };
	
	  upload.registerModelChangeValidator = function (ngModel, attr, scope) {
	    if (ngModel) {
	      ngModel.$formatters.push(function (files) {
	        if (ngModel.$dirty) {
	          upload.validate(files, ngModel, attr, scope).then(function () {
	            upload.applyModelValidation(ngModel, files);
	          });
	        }
	      });
	    }
	  };
	
	  function markModelAsDirty(ngModel, files) {
	    if (files != null && !ngModel.$dirty) {
	      if (ngModel.$setDirty) {
	        ngModel.$setDirty();
	      } else {
	        ngModel.$dirty = true;
	      }
	    }
	  }
	
	  upload.applyModelValidation = function (ngModel, files) {
	    markModelAsDirty(ngModel, files);
	    angular.forEach(ngModel.$ngfValidations, function (validation) {
	      ngModel.$setValidity(validation.name, validation.valid);
	    });
	  };
	
	  upload.validate = function (files, ngModel, attr, scope) {
	    ngModel = ngModel || {};
	    ngModel.$ngfValidations = ngModel.$ngfValidations || [];
	
	    angular.forEach(ngModel.$ngfValidations, function (v) {
	      v.valid = true;
	    });
	
	    var attrGetter = function (name, params) {
	      return upload.attrGetter(name, attr, scope, params);
	    };
	
	    if (files == null || files.length === 0) {
	      return upload.emptyPromise(ngModel);
	    }
	
	    files = files.length === undefined ? [files] : files.slice(0);
	
	    function validateSync(name, validatorVal, fn) {
	      if (files) {
	        var dName = 'ngf' + name[0].toUpperCase() + name.substr(1);
	        var i = files.length, valid = null;
	        while (i--) {
	          var file = files[i];
	          if (file) {
	            var val = attrGetter(dName, {$file: file});
	            if (val == null) {
	              val = validatorVal(attrGetter('ngfValidate') || {});
	              valid = valid == null ? true : valid;
	            }
	            if (val != null) {
	              if (!fn(file, val)) {
	                file.$error = name;
	                file.$errorParam = val;
	                files.splice(i, 1);
	                valid = false;
	              }
	            }
	          }
	        }
	        if (valid !== null) {
	          ngModel.$ngfValidations.push({name: name, valid: valid});
	        }
	      }
	    }
	
	    validateSync('pattern', function (cons) {
	      return cons.pattern;
	    }, upload.validatePattern);
	    validateSync('minSize', function (cons) {
	      return cons.size && cons.size.min;
	    }, function (file, val) {
	      return file.size >= upload.translateScalars(val);
	    });
	    validateSync('maxSize', function (cons) {
	      return cons.size && cons.size.max;
	    }, function (file, val) {
	      return file.size <= upload.translateScalars(val);
	    });
	    var totalSize = 0;
	    validateSync('maxTotalSize', function (cons) {
	      return cons.maxTotalSize && cons.maxTotalSize;
	    }, function (file, val) {
	      totalSize += file.size;
	      if (totalSize > upload.translateScalars(val)) {
	        files.splice(0, files.length);
	        return false;
	      }
	      return true;
	    });
	
	    validateSync('validateFn', function () {
	      return null;
	    }, function (file, r) {
	      return r === true || r === null || r === '';
	    });
	
	    if (!files.length) {
	      return upload.emptyPromise(ngModel, ngModel.$ngfValidations);
	    }
	
	    function validateAsync(name, validatorVal, type, asyncFn, fn, addDimensions, addDuration) {
	      function resolveResult(defer, file, val) {
	        if (val != null) {
	          asyncFn(file, val).then(function (d) {
	            if (!fn(d, val)) {
	              file.$error = name;
	              file.$errorParam = val;
	              defer.reject();
	            } else {
	              defer.resolve();
	            }
	          }, function () {
	            if (attrGetter('ngfValidateForce', {$file: file})) {
	              file.$error = name;
	              file.$errorParam = val;
	              defer.reject();
	            } else {
	              defer.resolve();
	            }
	          });
	        } else {
	          defer.resolve();
	        }
	      }
	
	      var promises = [upload.emptyPromise()];
	      if (files) {
	        var dName = 'ngf' + name[0].toUpperCase() + name.substr(1);
	        files = files.length === undefined ? [files] : files;
	        angular.forEach(files, function (file) {
	          var defer = $q.defer();
	          promises.push(defer.promise);
	          if (type && (file.type == null || file.type.search(type) !== 0)) {
	            defer.resolve();
	            return;
	          }
	          if (addDimensions && attrGetter(dName) != null) {
	            upload.imageDimensions(file).then(function (d) {
	              resolveResult(defer, file,
	                attrGetter(dName, {$file: file, $width: d.width, $height: d.height}));
	            }, function () {
	              defer.reject();
	            });
	          } else if (addDuration && attrGetter(dName) != null) {
	            upload.mediaDuration(file).then(function (d) {
	              resolveResult(defer, file,
	                attrGetter(dName, {$file: file, $duration: d}));
	            }, function () {
	              defer.reject();
	            });
	          } else {
	            var val = attrGetter(dName, {$file: file});
	            if (val == null && validatorVal != null) {
	              val = validatorVal(attrGetter('ngfValidate', {'$file': file}) || {});
	            }
	            resolveResult(defer, file, val);
	          }
	        });
	        return $q.all(promises).then(function () {
	          ngModel.$ngfValidations.push({name: name, valid: true});
	        }, function () {
	          ngModel.$ngfValidations.push({name: name, valid: false});
	        });
	      }
	    }
	
	    var deffer = $q.defer();
	    var promises = [];
	
	    promises.push(upload.happyPromise(validateAsync('maxHeight', function (cons) {
	      return cons.height && cons.height.max;
	    }, /image/, this.imageDimensions, function (d, val) {
	      return d.height <= val;
	    })));
	    promises.push(upload.happyPromise(validateAsync('minHeight', function (cons) {
	      return cons.height && cons.height.min;
	    }, /image/, this.imageDimensions, function (d, val) {
	      return d.height >= val;
	    })));
	    promises.push(upload.happyPromise(validateAsync('maxWidth', function (cons) {
	      return cons.width && cons.width.max;
	    }, /image/, this.imageDimensions, function (d, val) {
	      return d.width <= val;
	    })));
	    promises.push(upload.happyPromise(validateAsync('minWidth', function (cons) {
	      return cons.width && cons.width.min;
	    }, /image/, this.imageDimensions, function (d, val) {
	      return d.width >= val;
	    })));
	    promises.push(upload.happyPromise(validateAsync('dimensions', null, /image/,
	      function (file, val) {
	        return upload.emptyPromise(val);
	      }, function (r) {
	        return r;
	      }, true)));
	    promises.push(upload.happyPromise(validateAsync('ratio', function (cons) {
	      return cons.ratio;
	    }, /image/, this.imageDimensions, function (d, val) {
	      var split = val.toString().split(','), valid = false;
	      for (var i = 0; i < split.length; i++) {
	        if (Math.abs((d.width / d.height) - upload.ratioToFloat(split[i])) < 0.0001) {
	          valid = true;
	        }
	      }
	      return valid;
	    })));
	    promises.push(upload.happyPromise(validateAsync('maxRatio', function (cons) {
	      return cons.ratio;
	    }, /image/, this.imageDimensions, function (d, val) {
	      return (d.width / d.height) - upload.ratioToFloat(val) < 0.0001;
	    })));
	    promises.push(upload.happyPromise(validateAsync('minRatio', function (cons) {
	      return cons.ratio;
	    }, /image/, this.imageDimensions, function (d, val) {
	      return (d.width / d.height) - upload.ratioToFloat(val) > -0.0001;
	    })));
	    promises.push(upload.happyPromise(validateAsync('maxDuration', function (cons) {
	      return cons.duration && cons.duration.max;
	    }, /audio|video/, this.mediaDuration, function (d, val) {
	      return d <= upload.translateScalars(val);
	    })));
	    promises.push(upload.happyPromise(validateAsync('minDuration', function (cons) {
	      return cons.duration && cons.duration.min;
	    }, /audio|video/, this.mediaDuration, function (d, val) {
	      return d >= upload.translateScalars(val);
	    })));
	    promises.push(upload.happyPromise(validateAsync('duration', null, /audio|video/,
	      function (file, val) {
	        return upload.emptyPromise(val);
	      }, function (r) {
	        return r;
	      }, false, true)));
	
	    promises.push(upload.happyPromise(validateAsync('validateAsyncFn', function () {
	      return null;
	    }, null, function (file, val) {
	      return val;
	    }, function (r) {
	      return r === true || r === null || r === '';
	    })));
	
	    return $q.all(promises).then(function () {
	      deffer.resolve(ngModel, ngModel.$ngfValidations);
	    });
	  };
	
	  upload.imageDimensions = function (file) {
	    if (file.$ngfWidth && file.$ngfHeight) {
	      var d = $q.defer();
	      $timeout(function () {
	        d.resolve({width: file.$ngfWidth, height: file.$ngfHeight});
	      });
	      return d.promise;
	    }
	    if (file.$ngfDimensionPromise) return file.$ngfDimensionPromise;
	
	    var deferred = $q.defer();
	    $timeout(function () {
	      if (file.type.indexOf('image') !== 0) {
	        deferred.reject('not image');
	        return;
	      }
	      upload.dataUrl(file).then(function (dataUrl) {
	        var img = angular.element('<img>').attr('src', dataUrl).css('visibility', 'hidden').css('position', 'fixed');
	
	        function success() {
	          var width = img[0].clientWidth;
	          var height = img[0].clientHeight;
	          img.remove();
	          file.$ngfWidth = width;
	          file.$ngfHeight = height;
	          deferred.resolve({width: width, height: height});
	        }
	
	        function error() {
	          img.remove();
	          deferred.reject('load error');
	        }
	
	        img.on('load', success);
	        img.on('error', error);
	        var count = 0;
	
	        function checkLoadError() {
	          $timeout(function () {
	            if (img[0].parentNode) {
	              if (img[0].clientWidth) {
	                success();
	              } else if (count > 10) {
	                error();
	              } else {
	                checkLoadError();
	              }
	            }
	          }, 1000);
	        }
	
	        checkLoadError();
	
	        angular.element(document.getElementsByTagName('body')[0]).append(img);
	      }, function () {
	        deferred.reject('load error');
	      });
	    });
	
	    file.$ngfDimensionPromise = deferred.promise;
	    file.$ngfDimensionPromise['finally'](function () {
	      delete file.$ngfDimensionPromise;
	    });
	    return file.$ngfDimensionPromise;
	  };
	
	  upload.mediaDuration = function (file) {
	    if (file.$ngfDuration) {
	      var d = $q.defer();
	      $timeout(function () {
	        d.resolve(file.$ngfDuration);
	      });
	      return d.promise;
	    }
	    if (file.$ngfDurationPromise) return file.$ngfDurationPromise;
	
	    var deferred = $q.defer();
	    $timeout(function () {
	      if (file.type.indexOf('audio') !== 0 && file.type.indexOf('video') !== 0) {
	        deferred.reject('not media');
	        return;
	      }
	      upload.dataUrl(file).then(function (dataUrl) {
	        var el = angular.element(file.type.indexOf('audio') === 0 ? '<audio>' : '<video>')
	          .attr('src', dataUrl).css('visibility', 'none').css('position', 'fixed');
	
	        function success() {
	          var duration = el[0].duration;
	          file.$ngfDuration = duration;
	          el.remove();
	          deferred.resolve(duration);
	        }
	
	        function error() {
	          el.remove();
	          deferred.reject('load error');
	        }
	
	        el.on('loadedmetadata', success);
	        el.on('error', error);
	        var count = 0;
	
	        function checkLoadError() {
	          $timeout(function () {
	            if (el[0].parentNode) {
	              if (el[0].duration) {
	                success();
	              } else if (count > 10) {
	                error();
	              } else {
	                checkLoadError();
	              }
	            }
	          }, 1000);
	        }
	
	        checkLoadError();
	
	        angular.element(document.body).append(el);
	      }, function () {
	        deferred.reject('load error');
	      });
	    });
	
	    file.$ngfDurationPromise = deferred.promise;
	    file.$ngfDurationPromise['finally'](function () {
	      delete file.$ngfDurationPromise;
	    });
	    return file.$ngfDurationPromise;
	  };
	  return upload;
	}
	]);
	
	ngFileUpload.service('UploadResize', ['UploadValidate', '$q', function (UploadValidate, $q) {
	  var upload = UploadValidate;
	
	  /**
	   * Conserve aspect ratio of the original region. Useful when shrinking/enlarging
	   * images to fit into a certain area.
	   * Source:  http://stackoverflow.com/a/14731922
	   *
	   * @param {Number} srcWidth Source area width
	   * @param {Number} srcHeight Source area height
	   * @param {Number} maxWidth Nestable area maximum available width
	   * @param {Number} maxHeight Nestable area maximum available height
	   * @return {Object} { width, height }
	   */
	  var calculateAspectRatioFit = function (srcWidth, srcHeight, maxWidth, maxHeight, centerCrop) {
	    var ratio = centerCrop ? Math.max(maxWidth / srcWidth, maxHeight / srcHeight) :
	      Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
	    return {
	      width: srcWidth * ratio, height: srcHeight * ratio,
	      marginX: srcWidth * ratio - maxWidth, marginY: srcHeight * ratio - maxHeight
	    };
	  };
	
	  // Extracted from https://github.com/romelgomez/angular-firebase-image-upload/blob/master/app/scripts/fileUpload.js#L89
	  var resize = function (imagen, width, height, quality, type, ratio, centerCrop, resizeIf) {
	    var deferred = $q.defer();
	    var canvasElement = document.createElement('canvas');
	    var imageElement = document.createElement('img');
	
	    imageElement.onload = function () {
	      if (resizeIf != null && resizeIf(imageElement.width, imageElement.height) === false) {
	        deferred.reject('resizeIf');
	        return;
	      }
	      try {
	        if (ratio) {
	          var ratioFloat = upload.ratioToFloat(ratio);
	          var imgRatio = imageElement.width / imageElement.height;
	          if (imgRatio < ratioFloat) {
	            width = imageElement.width;
	            height = width / ratioFloat;
	          } else {
	            height = imageElement.height;
	            width = height * ratioFloat;
	          }
	        }
	        if (!width) {
	          width = imageElement.width;
	        }
	        if (!height) {
	          height = imageElement.height;
	        }
	        var dimensions = calculateAspectRatioFit(imageElement.width, imageElement.height, width, height, centerCrop);
	        canvasElement.width = Math.min(dimensions.width, width);
	        canvasElement.height = Math.min(dimensions.height, height);
	        var context = canvasElement.getContext('2d');
	        context.drawImage(imageElement,
	          Math.min(0, -dimensions.marginX / 2), Math.min(0, -dimensions.marginY / 2),
	          dimensions.width, dimensions.height);
	        deferred.resolve(canvasElement.toDataURL(type || 'image/WebP', quality || 0.934));
	      } catch (e) {
	        deferred.reject(e);
	      }
	    };
	    imageElement.onerror = function () {
	      deferred.reject();
	    };
	    imageElement.src = imagen;
	    return deferred.promise;
	  };
	
	  upload.dataUrltoBlob = function (dataurl, name) {
	    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
	      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
	    while (n--) {
	      u8arr[n] = bstr.charCodeAt(n);
	    }
	    var blob = new window.Blob([u8arr], {type: mime});
	    blob.name = name;
	    return blob;
	  };
	
	  upload.isResizeSupported = function () {
	    var elem = document.createElement('canvas');
	    return window.atob && elem.getContext && elem.getContext('2d');
	  };
	
	  if (upload.isResizeSupported()) {
	    // add name getter to the blob constructor prototype
	    Object.defineProperty(window.Blob.prototype, 'name', {
	      get: function () {
	        return this.$ngfName;
	      },
	      set: function (v) {
	        this.$ngfName = v;
	      },
	      configurable: true
	    });
	  }
	
	  upload.resize = function (file, width, height, quality, type, ratio, centerCrop, resizeIf) {
	    if (file.type.indexOf('image') !== 0) return upload.emptyPromise(file);
	
	    var deferred = $q.defer();
	    upload.dataUrl(file, true).then(function (url) {
	      resize(url, width, height, quality, type || file.type, ratio, centerCrop, resizeIf)
	        .then(function (dataUrl) {
	          deferred.resolve(upload.dataUrltoBlob(dataUrl, file.name));
	        }, function (r) {
	          if (r === 'resizeIf') {
	            deferred.resolve(file);
	          }
	          deferred.reject();
	        });
	    }, function () {
	      deferred.reject();
	    });
	    return deferred.promise;
	  };
	
	  return upload;
	}]);
	
	(function () {
	  ngFileUpload.directive('ngfDrop', ['$parse', '$timeout', '$location', 'Upload', '$http', '$q',
	    function ($parse, $timeout, $location, Upload, $http, $q) {
	      return {
	        restrict: 'AEC',
	        require: '?ngModel',
	        link: function (scope, elem, attr, ngModel) {
	          linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $location, Upload, $http, $q);
	        }
	      };
	    }]);
	
	  ngFileUpload.directive('ngfNoFileDrop', function () {
	    return function (scope, elem) {
	      if (dropAvailable()) elem.css('display', 'none');
	    };
	  });
	
	  ngFileUpload.directive('ngfDropAvailable', ['$parse', '$timeout', 'Upload', function ($parse, $timeout, Upload) {
	    return function (scope, elem, attr) {
	      if (dropAvailable()) {
	        var model = $parse(Upload.attrGetter('ngfDropAvailable', attr));
	        $timeout(function () {
	          model(scope);
	          if (model.assign) {
	            model.assign(scope, true);
	          }
	        });
	      }
	    };
	  }]);
	
	  function linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $location, upload, $http, $q) {
	    var available = dropAvailable();
	
	    var attrGetter = function (name, scope, params) {
	      return upload.attrGetter(name, attr, scope, params);
	    };
	
	    if (attrGetter('dropAvailable')) {
	      $timeout(function () {
	        if (scope[attrGetter('dropAvailable')]) {
	          scope[attrGetter('dropAvailable')].value = available;
	        } else {
	          scope[attrGetter('dropAvailable')] = available;
	        }
	      });
	    }
	    if (!available) {
	      if (attrGetter('ngfHideOnDropNotAvailable', scope) === true) {
	        elem.css('display', 'none');
	      }
	      return;
	    }
	
	    function isDisabled() {
	      return elem.attr('disabled') || attrGetter('ngfDropDisabled', scope);
	    }
	
	    if (attrGetter('ngfSelect') == null) {
	      upload.registerModelChangeValidator(ngModel, attr, scope);
	    }
	
	    var leaveTimeout = null;
	    var stopPropagation = $parse(attrGetter('ngfStopPropagation'));
	    var dragOverDelay = 1;
	    var actualDragOverClass;
	
	    elem[0].addEventListener('dragover', function (evt) {
	      if (isDisabled()) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	      // handling dragover events from the Chrome download bar
	      if (navigator.userAgent.indexOf('Chrome') > -1) {
	        var b = evt.dataTransfer.effectAllowed;
	        evt.dataTransfer.dropEffect = ('move' === b || 'linkMove' === b) ? 'move' : 'copy';
	      }
	      $timeout.cancel(leaveTimeout);
	      if (!actualDragOverClass) {
	        actualDragOverClass = 'C';
	        calculateDragOverClass(scope, attr, evt, function (clazz) {
	          actualDragOverClass = clazz;
	          elem.addClass(actualDragOverClass);
	          attrGetter('ngfDrag', scope, {$isDragging: true, $class: actualDragOverClass, $event: evt});
	        });
	      }
	    }, false);
	    elem[0].addEventListener('dragenter', function (evt) {
	      if (isDisabled()) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	    }, false);
	    elem[0].addEventListener('dragleave', function (evt) {
	      if (isDisabled()) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	      leaveTimeout = $timeout(function () {
	        if (actualDragOverClass) elem.removeClass(actualDragOverClass);
	        actualDragOverClass = null;
	        attrGetter('ngfDrag', scope, {$isDragging: false, $event: evt});
	      }, dragOverDelay || 100);
	    }, false);
	    elem[0].addEventListener('drop', function (evt) {
	      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	      if (actualDragOverClass) elem.removeClass(actualDragOverClass);
	      actualDragOverClass = null;
	      var html;
	      try {
	        html = (evt.dataTransfer && evt.dataTransfer.getData && evt.dataTransfer.getData('text/html'));
	      } catch (e) {/* Fix IE11 that throw error calling getData */
	      }
	      if (upload.shouldUpdateOn('dropUrl', attr, scope) && html) {
	        extractUrlAndUpdateModel(html, evt);
	      } else {
	        extractFiles(evt, function (files) {
	            upload.updateModel(ngModel, attr, scope, attrGetter('ngfChange') || attrGetter('ngfDrop'), files, evt);
	          }, attrGetter('ngfAllowDir', scope) !== false,
	          attrGetter('multiple') || attrGetter('ngfMultiple', scope));
	      }
	    }, false);
	    elem[0].addEventListener('paste', function (evt) {
	      if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 &&
	        attrGetter('ngfEnableFirefoxPaste', scope)) {
	        evt.preventDefault();
	      }
	      if (isDisabled() || !upload.shouldUpdateOn('paste', attr, scope)) return;
	      var files = [];
	      var clipboard = evt.clipboardData || evt.originalEvent.clipboardData;
	      if (clipboard && clipboard.items) {
	        for (var k = 0; k < clipboard.items.length; k++) {
	          if (clipboard.items[k].type.indexOf('image') !== -1) {
	            files.push(clipboard.items[k].getAsFile());
	          }
	        }
	      }
	      if (files.length) {
	        upload.updateModel(ngModel, attr, scope, attrGetter('ngfChange') || attrGetter('ngfDrop'), files, evt);
	      } else {
	        var html;
	        try {
	          html = (clipboard && clipboard.getData && clipboard.getData('text/html'));
	        } catch (e) {/* Fix IE11 that throw error calling getData */
	        }
	        if (upload.shouldUpdateOn('pasteUrl', attr, scope) && html) {
	          extractUrlAndUpdateModel(html, evt);
	        }
	      }
	    }, false);
	
	    if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 &&
	      attrGetter('ngfEnableFirefoxPaste', scope)) {
	      elem.attr('contenteditable', true);
	      elem.on('keypress', function (e) {
	        if (!e.metaKey && !e.ctrlKey) {
	          e.preventDefault();
	        }
	      });
	    }
	
	    function extractUrlAndUpdateModel(html, evt) {
	      var urls = [];
	      html.replace(/<(img src|img [^>]* src) *=\"([^\"]*)\"/gi, function (m, n, src) {
	        urls.push(src);
	      });
	      var promises = [], files = [];
	      if (urls.length) {
	        angular.forEach(urls, function (url) {
	          promises.push($http({url: url, method: 'get', responseType: 'arraybuffer'}).then(function (resp) {
	            var arrayBufferView = new Uint8Array(resp.data);
	            var type = resp.headers('content-type') || 'image/WebP';
	            var blob = new window.Blob([arrayBufferView], {type: type});
	            files.push(blob);
	            //var split = type.split('[/;]');
	            //blob.name = url.substring(0, 150).replace(/\W+/g, '') + '.' + (split.length > 1 ? split[1] : 'jpg');
	          }));
	        });
	        $q.all(promises).then(function () {
	          upload.updateModel(ngModel, attr, scope, attrGetter('ngfChange') || attrGetter('ngfDrop'), files, evt);
	        });
	      }
	    }
	
	    function calculateDragOverClass(scope, attr, evt, callback) {
	      var obj = attrGetter('ngfDragOverClass', scope, {$event: evt}), dClass = 'dragover';
	      if (angular.isString(obj)) {
	        dClass = obj;
	      } else if (obj) {
	        if (obj.delay) dragOverDelay = obj.delay;
	        if (obj.accept || obj.reject) {
	          var items = evt.dataTransfer.items;
	          if (items == null || !items.length) {
	            dClass = obj.accept;
	          } else {
	            var pattern = obj.pattern || attrGetter('ngfPattern', scope, {$event: evt});
	            var len = items.length;
	            while (len--) {
	              if (!upload.validatePattern(items[len], pattern)) {
	                dClass = obj.reject;
	                break;
	              } else {
	                dClass = obj.accept;
	              }
	            }
	          }
	        }
	      }
	      callback(dClass);
	    }
	
	    function extractFiles(evt, callback, allowDir, multiple) {
	      var files = [], processing = 0;
	
	      function traverseFileTree(files, entry, path) {
	        if (entry != null) {
	          if (entry.isDirectory) {
	            var filePath = (path || '') + entry.name;
	            files.push({name: entry.name, type: 'directory', path: filePath});
	            var dirReader = entry.createReader();
	            var entries = [];
	            processing++;
	            var readEntries = function () {
	              dirReader.readEntries(function (results) {
	                try {
	                  if (!results.length) {
	                    for (var i = 0; i < entries.length; i++) {
	                      traverseFileTree(files, entries[i], (path ? path : '') + entry.name + '/');
	                    }
	                    processing--;
	                  } else {
	                    entries = entries.concat(Array.prototype.slice.call(results || [], 0));
	                    readEntries();
	                  }
	                } catch (e) {
	                  processing--;
	                  console.error(e);
	                }
	              }, function () {
	                processing--;
	              });
	            };
	            readEntries();
	          } else {
	            processing++;
	            entry.file(function (file) {
	              try {
	                processing--;
	                file.path = (path ? path : '') + file.name;
	                files.push(file);
	              } catch (e) {
	                processing--;
	                console.error(e);
	              }
	            }, function () {
	              processing--;
	            });
	          }
	        }
	      }
	
	      var items = evt.dataTransfer.items;
	
	      if (items && items.length > 0 && $location.protocol() !== 'file') {
	        for (var i = 0; i < items.length; i++) {
	          if (items[i].webkitGetAsEntry && items[i].webkitGetAsEntry() && items[i].webkitGetAsEntry().isDirectory) {
	            var entry = items[i].webkitGetAsEntry();
	            if (entry.isDirectory && !allowDir) {
	              continue;
	            }
	            if (entry != null) {
	              traverseFileTree(files, entry);
	            }
	          } else {
	            var f = items[i].getAsFile();
	            if (f != null) files.push(f);
	          }
	          if (!multiple && files.length > 0) break;
	        }
	      } else {
	        var fileList = evt.dataTransfer.files;
	        if (fileList != null) {
	          for (var j = 0; j < fileList.length; j++) {
	            var file = fileList.item(j);
	            if (file.type || file.size > 0) {
	              files.push(file);
	            }
	            if (!multiple && files.length > 0) {
	              break;
	            }
	          }
	        }
	      }
	      var delays = 0;
	      (function waitForProcess(delay) {
	        $timeout(function () {
	          if (!processing) {
	            if (!multiple && files.length > 1) {
	              i = 0;
	              while (files[i].type === 'directory') i++;
	              files = [files[i]];
	            }
	            callback(files);
	          } else {
	            if (delays++ * 10 < 20 * 1000) {
	              waitForProcess(10);
	            }
	          }
	        }, delay || 0);
	      })();
	    }
	  }
	
	  function dropAvailable() {
	    var div = document.createElement('div');
	    return ('draggable' in div) && ('ondrop' in div) && !/Edge\/12./i.test(navigator.userAgent);
	  }
	
	})();
	
	// customized version of https://github.com/exif-js/exif-js
	ngFileUpload.service('UploadExif', ['UploadResize', '$q', function (UploadResize, $q) {
	  var upload = UploadResize;
	
	  function findEXIFinJPEG(file) {
	    var dataView = new DataView(file);
	
	    if ((dataView.getUint8(0) !== 0xFF) || (dataView.getUint8(1) !== 0xD8)) {
	      return 'Not a valid JPEG';
	    }
	
	    var offset = 2,
	      length = file.byteLength,
	      marker;
	
	    while (offset < length) {
	      if (dataView.getUint8(offset) !== 0xFF) {
	        return 'Not a valid marker at offset ' + offset + ', found: ' + dataView.getUint8(offset);
	      }
	
	      marker = dataView.getUint8(offset + 1);
	      if (marker === 225) {
	        return readEXIFData(dataView, offset + 4, dataView.getUint16(offset + 2) - 2);
	      } else {
	        offset += 2 + dataView.getUint16(offset + 2);
	      }
	    }
	  }
	
	  function readOrientation(file, tiffStart, dirStart, bigEnd) {
	    var entries = file.getUint16(dirStart, !bigEnd),
	      entryOffset, i;
	
	    for (i = 0; i < entries; i++) {
	      entryOffset = dirStart + i * 12 + 2;
	      var val = file.getUint16(entryOffset, !bigEnd);
	      if (0x0112 === val) {
	        return readTagValue(file, entryOffset, tiffStart, bigEnd);
	      }
	    }
	    return null;
	  }
	
	  function readTagValue(file, entryOffset, tiffStart, bigEnd) {
	    var numValues = file.getUint32(entryOffset + 4, !bigEnd),
	      valueOffset = file.getUint32(entryOffset + 8, !bigEnd) + tiffStart, offset, vals, n;
	
	    if (numValues === 1) {
	      return file.getUint16(entryOffset + 8, !bigEnd);
	    } else {
	      offset = numValues > 2 ? valueOffset : (entryOffset + 8);
	      vals = [];
	      for (n = 0; n < numValues; n++) {
	        vals[n] = file.getUint16(offset + 2 * n, !bigEnd);
	      }
	      return vals;
	    }
	  }
	
	  function getStringFromDB(buffer, start, length) {
	    var outstr = '';
	    for (var n = start; n < start + length; n++) {
	      outstr += String.fromCharCode(buffer.getUint8(n));
	    }
	    return outstr;
	  }
	
	  function readEXIFData(file, start) {
	    if (getStringFromDB(file, start, 4) !== 'Exif') {
	      return 'Not valid EXIF data! ' + getStringFromDB(file, start, 4);
	    }
	
	    var bigEnd,
	      tiffOffset = start + 6;
	
	    // test for TIFF validity and endianness
	    if (file.getUint16(tiffOffset) === 0x4949) {
	      bigEnd = false;
	    } else if (file.getUint16(tiffOffset) === 0x4D4D) {
	      bigEnd = true;
	    } else {
	      return 'Not valid TIFF data! (no 0x4949 or 0x4D4D)';
	    }
	
	    if (file.getUint16(tiffOffset + 2, !bigEnd) !== 0x002A) {
	      return 'Not valid TIFF data! (no 0x002A)';
	    }
	
	    var firstIFDOffset = file.getUint32(tiffOffset + 4, !bigEnd);
	
	    if (firstIFDOffset < 0x00000008) {
	      return 'Not valid TIFF data! (First offset less than 8)', file.getUint32(tiffOffset + 4, !bigEnd);
	    }
	
	    return readOrientation(file, tiffOffset, tiffOffset + firstIFDOffset, bigEnd);
	
	  }
	
	  upload.isExifSupported = function () {
	    return window.FileReader && new FileReader().readAsArrayBuffer && upload.isResizeSupported();
	  };
	
	  upload.orientation = function (file) {
	    if (file.$ngfOrientation != null) {
	      return upload.emptyPromise(file.$ngfOrientation);
	    }
	    var defer = $q.defer();
	    var fileReader = new FileReader();
	    fileReader.onload = function (e) {
	      var orientation;
	      try {
	        orientation = findEXIFinJPEG(e.target.result);
	      } catch (e) {
	        defer.reject(e);
	        return;
	      }
	      if (angular.isString(orientation)) {
	        defer.resolve(1);
	      } else {
	        file.$ngfOrientation = orientation;
	        defer.resolve(orientation);
	      }
	    };
	    fileReader.onerror = function (e) {
	      defer.reject(e);
	    };
	
	    fileReader.readAsArrayBuffer(file);
	    return defer.promise;
	  };
	
	
	  function applyTransform(ctx, orientation, width, height) {
	    switch (orientation) {
	      case 2:
	        return ctx.transform(-1, 0, 0, 1, width, 0);
	      case 3:
	        return ctx.transform(-1, 0, 0, -1, width, height);
	      case 4:
	        return ctx.transform(1, 0, 0, -1, 0, height);
	      case 5:
	        return ctx.transform(0, 1, 1, 0, 0, 0);
	      case 6:
	        return ctx.transform(0, 1, -1, 0, height, 0);
	      case 7:
	        return ctx.transform(0, -1, -1, 0, height, width);
	      case 8:
	        return ctx.transform(0, -1, 1, 0, 0, width);
	    }
	  }
	
	  upload.applyExifRotation = function (file) {
	    if (file.type.indexOf('image/jpeg') !== 0) {
	      return upload.emptyPromise(file);
	    }
	
	    var deferred = $q.defer();
	    upload.orientation(file).then(function (orientation) {
	      if (!orientation || orientation < 2 || orientation > 8) {
	        deferred.resolve(file);
	      }
	      upload.dataUrl(file, true).then(function (url) {
	        var canvas = document.createElement('canvas');
	        var img = document.createElement('img');
	
	        img.onload = function () {
	          try {
	            canvas.width = orientation > 4 ? img.height : img.width;
	            canvas.height = orientation > 4 ? img.width : img.height;
	            var ctx = canvas.getContext('2d');
	            applyTransform(ctx, orientation, img.width, img.height);
	            ctx.drawImage(img, 0, 0);
	            var dataUrl = canvas.toDataURL(file.type || 'image/WebP', 0.934);
	            dataUrl = restoreExif(url, dataUrl);
	            var blob = upload.dataUrltoBlob(dataUrl, file.name);
	            deferred.resolve(blob);
	          } catch (e) {
	            deferred.reject(e);
	          }
	        };
	        img.onerror = function () {
	          deferred.reject();
	        };
	        img.src = url;
	      }, function (e) {
	        deferred.reject(e);
	      });
	    }, function (e) {
	      deferred.reject(e);
	    });
	    return deferred.promise;
	  };
	
	  function restoreExif(orig, resized) {
	
	    var ExifRestorer = {};
	
	    ExifRestorer.KEY_STR = 'ABCDEFGHIJKLMNOP' +
	      'QRSTUVWXYZabcdef' +
	      'ghijklmnopqrstuv' +
	      'wxyz0123456789+/' +
	      '=';
	
	    ExifRestorer.encode64 = function (input) {
	      var output = '',
	        chr1, chr2, chr3 = '',
	        enc1, enc2, enc3, enc4 = '',
	        i = 0;
	
	      do {
	        chr1 = input[i++];
	        chr2 = input[i++];
	        chr3 = input[i++];
	
	        enc1 = chr1 >> 2;
	        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
	        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
	        enc4 = chr3 & 63;
	
	        if (isNaN(chr2)) {
	          enc3 = enc4 = 64;
	        } else if (isNaN(chr3)) {
	          enc4 = 64;
	        }
	
	        output = output +
	          this.KEY_STR.charAt(enc1) +
	          this.KEY_STR.charAt(enc2) +
	          this.KEY_STR.charAt(enc3) +
	          this.KEY_STR.charAt(enc4);
	        chr1 = chr2 = chr3 = '';
	        enc1 = enc2 = enc3 = enc4 = '';
	      } while (i < input.length);
	
	      return output;
	    };
	
	    ExifRestorer.restore = function (origFileBase64, resizedFileBase64) {
	      if (!origFileBase64.match('data:image/jpeg;base64,')) {
	        return resizedFileBase64;
	      }
	
	      var rawImage = this.decode64(origFileBase64.replace('data:image/jpeg;base64,', ''));
	      var segments = this.slice2Segments(rawImage);
	
	      var image = this.exifManipulation(resizedFileBase64, segments);
	
	      return 'data:image/jpeg;base64,' + this.encode64(image);
	    };
	
	
	    ExifRestorer.exifManipulation = function (resizedFileBase64, segments) {
	      var exifArray = this.getExifArray(segments),
	        newImageArray = this.insertExif(resizedFileBase64, exifArray);
	      return new Uint8Array(newImageArray);
	    };
	
	
	    ExifRestorer.getExifArray = function (segments) {
	      var seg;
	      for (var x = 0; x < segments.length; x++) {
	        seg = segments[x];
	        if (seg[0] === 255 & seg[1] === 225) //(ff e1)
	        {
	          return seg;
	        }
	      }
	      return [];
	    };
	
	
	    ExifRestorer.insertExif = function (resizedFileBase64, exifArray) {
	      var imageData = resizedFileBase64.replace('data:image/jpeg;base64,', ''),
	        buf = this.decode64(imageData),
	        separatePoint = buf.indexOf(255, 3),
	        mae = buf.slice(0, separatePoint),
	        ato = buf.slice(separatePoint),
	        array = mae;
	
	      array = array.concat(exifArray);
	      array = array.concat(ato);
	      return array;
	    };
	
	
	    ExifRestorer.slice2Segments = function (rawImageArray) {
	      var head = 0,
	        segments = [];
	
	      while (1) {
	        if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 218) {
	          break;
	        }
	        if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 216) {
	          head += 2;
	        }
	        else {
	          var length = rawImageArray[head + 2] * 256 + rawImageArray[head + 3],
	            endPoint = head + length + 2,
	            seg = rawImageArray.slice(head, endPoint);
	          segments.push(seg);
	          head = endPoint;
	        }
	        if (head > rawImageArray.length) {
	          break;
	        }
	      }
	
	      return segments;
	    };
	
	
	    ExifRestorer.decode64 = function (input) {
	      var chr1, chr2, chr3 = '',
	        enc1, enc2, enc3, enc4 = '',
	        i = 0,
	        buf = [];
	
	      // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
	      var base64test = /[^A-Za-z0-9\+\/\=]/g;
	      if (base64test.exec(input)) {
	        console.log('There were invalid base64 characters in the input text.\n' +
	          'Valid base64 characters are A-Z, a-z, 0-9, '+', '/',and "="\n' +
	          'Expect errors in decoding.');
	      }
	      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
	
	      do {
	        enc1 = this.KEY_STR.indexOf(input.charAt(i++));
	        enc2 = this.KEY_STR.indexOf(input.charAt(i++));
	        enc3 = this.KEY_STR.indexOf(input.charAt(i++));
	        enc4 = this.KEY_STR.indexOf(input.charAt(i++));
	
	        chr1 = (enc1 << 2) | (enc2 >> 4);
	        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
	        chr3 = ((enc3 & 3) << 6) | enc4;
	
	        buf.push(chr1);
	
	        if (enc3 !== 64) {
	          buf.push(chr2);
	        }
	        if (enc4 !== 64) {
	          buf.push(chr3);
	        }
	
	        chr1 = chr2 = chr3 = '';
	        enc1 = enc2 = enc3 = enc4 = '';
	
	      } while (i < input.length);
	
	      return buf;
	    };
	
	    return ExifRestorer.restore(orig, resized);  //<= EXIF
	  }
	
	  return upload;
	}]);
	


/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(518);
	module.exports = 'ngFileUpload';

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(96);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./md-data-table.css", function() {
				var newContent = require("!!../../css-loader/index.js!./md-data-table.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(97);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../css-loader/index.js!./angular-material.css", function() {
				var newContent = require("!!../css-loader/index.js!./angular-material.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(98);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./font-awesome.css", function() {
				var newContent = require("!!../../css-loader/index.js!./font-awesome.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 570:
/***/ (function(module, exports) {

	/**
	 * UI-Router Extras: Sticky states, Future States, Deep State Redirect, Transition promise
	 * Module: core
	 * @version 0.1.3
	 * @link http://christopherthielen.github.io/ui-router-extras/
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	(function(angular, undefined){
	"use strict";
	var mod_core = angular.module("ct.ui.router.extras.core", [ "ui.router" ]);
	
	var internalStates = {}, stateRegisteredCallbacks = [];
	mod_core.config([ '$stateProvider', '$injector', function ($stateProvider, $injector) {
	  // Decorate any state attribute in order to get access to the internal state representation.
	  $stateProvider.decorator('parent', function (state, parentFn) {
	    // Capture each internal UI-Router state representations as opposed to the user-defined state object.
	    // The internal state is, e.g., the state returned by $state.$current as opposed to $state.current
	    internalStates[state.self.name] = state;
	    // Add an accessor for the internal state from the user defined state
	    state.self.$$state = function () {
	      return internalStates[state.self.name];
	    };
	
	    angular.forEach(stateRegisteredCallbacks, function(callback) { callback(state); });
	    return parentFn(state);
	  });
	}]);
	
	var DEBUG = false;
	
	var forEach = angular.forEach;
	var extend = angular.extend;
	var isArray = angular.isArray;
	
	var map = function (collection, callback) {
	  "use strict";
	  var result = [];
	  forEach(collection, function (item, index) {
	    result.push(callback(item, index));
	  });
	  return result;
	};
	
	var keys = function (collection) {
	  "use strict";
	  return map(collection, function (collection, key) {
	    return key;
	  });
	};
	
	var filter = function (collection, callback) {
	  "use strict";
	  var result = [];
	  forEach(collection, function (item, index) {
	    if (callback(item, index)) {
	      result.push(item);
	    }
	  });
	  return result;
	};
	
	var filterObj = function (collection, callback) {
	  "use strict";
	  var result = {};
	  forEach(collection, function (item, index) {
	    if (callback(item, index)) {
	      result[index] = item;
	    }
	  });
	  return result;
	};
	
	// Duplicates code in UI-Router common.js
	function ancestors(first, second) {
	  var path = [];
	
	  for (var n in first.path) {
	    if (first.path[n] !== second.path[n]) break;
	    path.push(first.path[n]);
	  }
	  return path;
	}
	
	// Duplicates code in UI-Router common.js
	function objectKeys(object) {
	  if (Object.keys) {
	    return Object.keys(object);
	  }
	  var result = [];
	
	  angular.forEach(object, function (val, key) {
	    result.push(key);
	  });
	  return result;
	}
	
	/**
	 * like objectKeys, but includes keys from prototype chain.
	 * @param object the object whose prototypal keys will be returned
	 * @param ignoreKeys an array of keys to ignore
	 */
	// Duplicates code in UI-Router common.js
	function protoKeys(object, ignoreKeys) {
	  var result = [];
	  for (var key in object) {
	    if (!ignoreKeys || ignoreKeys.indexOf(key) === -1)
	      result.push(key);
	  }
	  return result;
	}
	
	// Duplicates code in UI-Router common.js
	function arraySearch(array, value) {
	  if (Array.prototype.indexOf) {
	    return array.indexOf(value, Number(arguments[2]) || 0);
	  }
	  var len = array.length >>> 0, from = Number(arguments[2]) || 0;
	  from = (from < 0) ? Math.ceil(from) : Math.floor(from);
	
	  if (from < 0) from += len;
	
	  for (; from < len; from++) {
	    if (from in array && array[from] === value) return from;
	  }
	  return -1;
	}
	
	// Duplicates code in UI-Router common.js
	// Added compatibility code  (isArray check) to support both 0.2.x and 0.3.x series of UI-Router.
	function inheritParams(currentParams, newParams, $current, $to) {
	  var parents = ancestors($current, $to), parentParams, inherited = {}, inheritList = [];
	
	  for (var i in parents) {
	    if (!parents[i].params) continue;
	    // This test allows compatibility with 0.2.x and 0.3.x (optional and object params)
	    parentParams = isArray(parents[i].params) ? parents[i].params : objectKeys(parents[i].params);
	    if (!parentParams.length) continue;
	
	    for (var j in parentParams) {
	      if (arraySearch(inheritList, parentParams[j]) >= 0) continue;
	      inheritList.push(parentParams[j]);
	      inherited[parentParams[j]] = currentParams[parentParams[j]];
	    }
	  }
	  return extend({}, inherited, newParams);
	}
	
	function inherit(parent, extra) {
	  return extend(new (extend(function () { }, {prototype: parent}))(), extra);
	}
	
	function onStateRegistered(callback) { stateRegisteredCallbacks.push(callback); }
	
	mod_core.provider("uirextras_core", function() {
	  var core = {
	    internalStates: internalStates,
	    onStateRegistered: onStateRegistered,
	    forEach: forEach,
	    extend: extend,
	    isArray: isArray,
	    map: map,
	    keys: keys,
	    filter: filter,
	    filterObj: filterObj,
	    ancestors: ancestors,
	    objectKeys: objectKeys,
	    protoKeys: protoKeys,
	    arraySearch: arraySearch,
	    inheritParams: inheritParams,
	    inherit: inherit
	  };
	
	  angular.extend(this, core);
	
	  this.$get = function() {
	    return core;
	  };
	});
	
	
	})(angular);

/***/ }),

/***/ 571:
/***/ (function(module, exports) {

	/**
	 * UI-Router Extras: Sticky states, Future States, Deep State Redirect, Transition promise
	 * Module: future
	 * @version 0.1.3
	 * @link http://christopherthielen.github.io/ui-router-extras/
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	(function(angular, undefined){
	"use strict";
	(function(angular, undefined) {
	  var app = angular.module('ct.ui.router.extras.future', [ 'ct.ui.router.extras.core' ]);
	
	  _futureStateProvider.$inject = [ '$stateProvider', '$urlRouterProvider', '$urlMatcherFactoryProvider', 'uirextras_coreProvider' ];
	  function _futureStateProvider($stateProvider, $urlRouterProvider, $urlMatcherFactory, uirextras_coreProvider) {
	    var core = uirextras_coreProvider;
	    var internalStates = core.internalStates;
	    var stateFactories = {}, futureStates = {};
	    var lazyloadInProgress = false, resolveFunctions = [], initPromise, initDone = false;
	    var provider = this;
	
	    // This function registers a promiseFn, to be resolved before the url/state matching code
	    // will reject a route.  The promiseFn is injected/executed using the runtime $injector.
	    // The function should return a promise.
	    // When all registered promises are resolved, then the route is re-sync'ed.
	
	    // Example: function($http) {
	    //  return $http.get('//server.com/api/DynamicFutureStates').then(function(data) {
	    //    angular.forEach(data.futureStates, function(fstate) { $futureStateProvider.futureState(fstate); });
	    //  };
	    // }
	    this.addResolve = function (promiseFn) {
	      resolveFunctions.push(promiseFn);
	    };
	
	    // Register a state factory function for a particular future-state type.  This factory, given a future-state object,
	    // should create a ui-router state.
	    // The factory function is injected/executed using the runtime $injector.  The future-state is injected as 'futureState'.
	
	    // Example:
	    //    $futureStateProvider.stateFactory('test', function(futureState) {
	    //      return {
	    //        name: futureState.stateName,
	    //        url: futureState.urlFragment,
	    //        template: '<h3>Future State Template</h3>',
	    //        controller: function() {
	    //          console.log("Entered state " + futureState.stateName);
	    //        }
	    //      }
	    //    });
	    this.stateFactory = function (futureStateType, factory) {
	      stateFactories[futureStateType] = factory;
	    };
	
	    this.futureState = function (futureState) {
	      if (futureState.stateName)  // backwards compat for now
	        futureState.name = futureState.stateName;
	      if (futureState.urlPrefix)  // backwards compat for now
	        futureState.url = "^" + futureState.urlPrefix;
	
	      futureStates[futureState.name] = futureState;
	      var parentMatcher,  parentName = futureState.name.split(/\./).slice(0, -1).join("."),
	        realParent = findState(futureState.parent || parentName);
	      if (realParent) {
	        parentMatcher = realParent.url || realParent.navigable && realParent.navigable.url;
	      } else if (parentName === "") {
	        parentMatcher = $urlMatcherFactory.compile("");
	      } else {
	        var futureParent = findState((futureState.parent || parentName), true);
	        if (!futureParent) throw new Error("Couldn't determine parent state of future state. FutureState:" + angular.toJson(futureState));
	        var pattern;
	        if (futureParent.urlMatcher) {
	          pattern = futureParent.urlMatcher.source.replace(/\*rest$/, "");
	        }
	        else {
	          // if the futureParent doesn't have a urlMatcher, then we are still
	          // starting from the beginning of the path
	          pattern = "";
	        }
	        parentMatcher = $urlMatcherFactory.compile(pattern);
	        futureState.parentFutureState = futureParent;
	      }
	      if (futureState.url) {
	        futureState.urlMatcher = futureState.url.charAt(0) === "^" ?
	          $urlMatcherFactory.compile(futureState.url.substring(1) + "*rest") :
	          parentMatcher.concat(futureState.url + "*rest");
	      }
	    };
	
	    this.get = function () {
	      return angular.extend({}, futureStates);
	    };
	
	    function findState(stateOrName, findFutureState) {
	      var statename = angular.isObject(stateOrName) ? stateOrName.name : stateOrName;
	      return !findFutureState ? internalStates[statename] : futureStates[statename];
	    }
	
	    /* options is an object with at least a name or url attribute */
	    function findFutureState($state, options) {
	      if (options.name) {
	        var nameComponents = options.name.split(/\./);
	        if (options.name.charAt(0) === '.')
	          nameComponents[0] = $state.current.name;
	        while (nameComponents.length) {
	          var stateName = nameComponents.join(".");
	          if ($state.get(stateName, { relative: $state.current }))
	            return null; // State is already defined; nothing to do
	          if (futureStates[stateName])
	            return futureStates[stateName];
	          nameComponents.pop();
	        }
	      }
	
	      if (options.url) {
	        var matches = [];
	        for(var future in futureStates) {
	          var matcher = futureStates[future].urlMatcher;
	          if (matcher && matcher.exec(options.url)) {
	            matches.push(futureStates[future]);
	          }
	        }
	        // Find most specific by ignoring matching parents from matches
	        var copy = matches.slice(0);
	        for (var i = matches.length - 1; i >= 0; i--) {
	          for (var j = 0; j < copy.length; j++) {
	            if (matches[i] === copy[j].parentFutureState) matches.splice(i, 1);
	          }
	        }
	        return matches[0];
	      }
	    }
	
	    function lazyLoadState($injector, futureState) {
	      lazyloadInProgress = true;
	      var $q = $injector.get("$q");
	      if (!futureState) {
	        var deferred = $q.defer();
	        deferred.reject("No lazyState passed in " + futureState);
	        return deferred.promise;
	      }
	
	      var parentPromises = $q.when([]), parentFuture = futureState.parentFutureState;
	      if (parentFuture && futureStates[parentFuture.name]) {
	        parentPromises = lazyLoadState($injector, futureStates[parentFuture.name]);
	      }
	
	      var type = futureState.type;
	      var factory = stateFactories[type];
	      if (!factory) throw Error("No state factory for futureState.type: " + (futureState && futureState.type));
	
	      var failedLoadPolicy = factory.$options && factory.$options.failedLazyLoadPolicy || "remove";
	      function deregisterFutureState() { delete(futureStates[futureState.name]); }
	      function errorHandler(err) {
	        if (failedLoadPolicy === "remove") deregisterFutureState();
	        return $q.reject(err);
	      }
	
	      return parentPromises.then(function(array) {
	        var factoryPromise = $injector.invoke(factory, factory, { futureState: futureState });
	
	        return factoryPromise.then(function(fullState) {
	          deregisterFutureState(); // Success; remove future state
	          if (fullState) { array.push(fullState); } // Pass a chain of realized states back
	          return array;
	        });
	      }).catch(errorHandler)
	    }
	
	    var otherwiseFunc = [ '$log', '$location',
	      function otherwiseFunc($log, $location) {
	        //$log.debug("Unable to map " + $location.path());
	      }];
	
	    function futureState_otherwise($injector, $location) {
	      var resyncing = false;
	
	      var lazyLoadMissingState =
	        ['$rootScope', '$urlRouter', '$state',
	          function lazyLoadMissingState($rootScope, $urlRouter, $state) {
	            function resync() {
	              resyncing = true; $urlRouter.sync(); resyncing = false;
	            }
	            if (!initDone) {
	              // Asynchronously load state definitions, then resync URL
	              initPromise().then(resync);
	              initDone = true;
	              return;
	            }
	
	            var futureState = findFutureState($state, { url: $location.path() });
	            if (!futureState) {
	              return $injector.invoke(otherwiseFunc);
	            }
	
	            // Config loaded.  Asynchronously lazy-load state definition from URL fragment, if mapped.
	            lazyLoadState($injector, futureState).then(function lazyLoadedStateCallback(states) {
	              states.forEach(function (state) {
	                if (state && (!$state.get(state) || (state.name && !$state.get(state.name))))
	                  $stateProvider.state(state);
	              });
	              lazyloadInProgress = false;
	              resync();
	            }, function lazyLoadStateAborted() {
	              lazyloadInProgress = false;
	              resync();
	            });
	          }];
	      if (lazyloadInProgress) return;
	
	      var nextFn = resyncing ? otherwiseFunc : lazyLoadMissingState;
	      return $injector.invoke(nextFn);
	    }
	
	    $urlRouterProvider.otherwise(futureState_otherwise);
	
	    $urlRouterProvider.otherwise = function(rule) {
	      if (angular.isString(rule)) {
	        var redirect = rule;
	        rule = function () { return redirect; };
	      }
	      else if (!angular.isFunction(rule)) throw new Error("'rule' must be a function");
	      otherwiseFunc = ['$injector', '$location', rule];
	      return $urlRouterProvider;
	    };
	
	    var serviceObject = {
	      getResolvePromise: function () {
	        return initPromise();
	      }
	    };
	
	    // Used in .run() block to init
	    this.$get = [ '$injector', '$state', '$q', '$rootScope', '$urlRouter', '$timeout', '$log',
	      function futureStateProvider_get($injector, $state, $q, $rootScope, $urlRouter, $timeout, $log) {
	        function init() {
	          $rootScope.$on("$stateNotFound", function futureState_notFound(event, unfoundState, fromState, fromParams) {
	            if (lazyloadInProgress) return;
	            //$log.debug("event, unfoundState, fromState, fromParams", event, unfoundState, fromState, fromParams);
	
	            var futureState = findFutureState($state, { name: unfoundState.to });
	            if (!futureState) return;
	
	            event.preventDefault();
	            var promise = lazyLoadState($injector, futureState);
	            promise.then(function (states) {
	              states.forEach(function (state) {
	                if (state && (!$state.get(state) || (state.name && !$state.get(state.name))))
	                  $stateProvider.state(state);
	              });
	              $state.go(unfoundState.to, unfoundState.toParams, unfoundState.options);
	              lazyloadInProgress = false;
	            }, function (error) {
	              console.log("failed to lazy load state ", error);
	              if (fromState.name) $state.go(fromState, fromParams);
	              lazyloadInProgress = false;
	            });
	          });
	
	          // Do this better.  Want to load remote config once, before everything else
	          if (!initPromise) {
	            var promises = [];
	            angular.forEach(resolveFunctions, function (promiseFn) {
	              promises.push($injector.invoke(promiseFn));
	            });
	            initPromise = function () {
	              return $q.all(promises);
	            };
	          }
	
	          // TODO: analyze this. I'm calling $urlRouter.sync() in two places for retry-initial-transition.
	          // TODO: I should only need to do this once.  Pick the better place and remove the extra resync.
	          initPromise().then(function retryInitialState() {
	            $timeout(function () {
	              if ($state.transition) {
	                $state.transition.then(retryInitialState, retryInitialState);
	              } else {
	                $urlRouter.sync();
	              }
	            });
	          });
	        }
	
	        init();
	
	        serviceObject.state = $stateProvider.state;
	        serviceObject.futureState = provider.futureState;
	        serviceObject.get = provider.get;
	
	        return serviceObject;
	      }
	    ];
	  }
	
	  app.provider('$futureState', _futureStateProvider);
	
	  var statesAddedQueue = {
	    state: function(state) {
	      if (statesAddedQueue.$rootScope)
	        statesAddedQueue.$rootScope.$broadcast("$stateAdded", state);
	    },
	    itsNowRuntimeOhWhatAHappyDay: function($rootScope) {
	      statesAddedQueue.$rootScope = $rootScope;
	    },
	    $rootScope: undefined
	  };
	
	  app.config([ '$stateProvider', function($stateProvider) {
	    // decorate $stateProvider.state so we can broadcast when a real state was added
	    var realStateFn = $stateProvider.state;
	    $stateProvider.state = function state_announce() {
	      var val = realStateFn.apply($stateProvider, arguments);
	
	      var state = angular.isObject(arguments[0]) ? arguments[0] : arguments[1];
	      statesAddedQueue.state(state);
	      return val;
	    };
	  }]);
	
	  // inject $futureState so the service gets initialized via $get();
	  app.run(['$futureState', function ($futureState, $rootScope) {
	    statesAddedQueue.itsNowRuntimeOhWhatAHappyDay($rootScope);
	  } ]);
	
	})(angular);
	
	})(angular);

/***/ }),

/***/ 573:
/***/ (function(module, exports) {

	/*!
	 * XRegExp.build 3.1.0
	 * <xregexp.com>
	 * Steven Levithan (c) 2012-2016 MIT License
	 * Inspired by Lea Verou's RegExp.create <lea.verou.me>
	 */
	
	module.exports = function(XRegExp) {
	    'use strict';
	
	    var REGEX_DATA = 'xregexp',
	        subParts = /(\()(?!\?)|\\([1-9]\d*)|\\[\s\S]|\[(?:[^\\\]]|\\[\s\S])*]/g,
	        parts = XRegExp.union([/\({{([\w$]+)}}\)|{{([\w$]+)}}/, subParts], 'g');
	
	/**
	 * Strips a leading `^` and trailing unescaped `$`, if both are present.
	 *
	 * @private
	 * @param {String} pattern Pattern to process.
	 * @returns {String} Pattern with edge anchors removed.
	 */
	    function deanchor(pattern) {
	        // Allow any number of empty noncapturing groups before/after anchors, because regexes
	        // built/generated by XRegExp sometimes include them
	        var leadingAnchor = /^(?:\(\?:\))*\^/,
	            trailingAnchor = /\$(?:\(\?:\))*$/;
	
	        if (
	            leadingAnchor.test(pattern) &&
	            trailingAnchor.test(pattern) &&
	            // Ensure that the trailing `$` isn't escaped
	            trailingAnchor.test(pattern.replace(/\\[\s\S]/g, ''))
	        ) {
	            return pattern.replace(leadingAnchor, '').replace(trailingAnchor, '');
	        }
	
	        return pattern;
	    }
	
	/**
	 * Converts the provided value to an XRegExp. Native RegExp flags are not preserved.
	 *
	 * @private
	 * @param {String|RegExp} value Value to convert.
	 * @returns {RegExp} XRegExp object with XRegExp syntax applied.
	 */
	    function asXRegExp(value) {
	        return XRegExp.isRegExp(value) ?
	            (value[REGEX_DATA] && value[REGEX_DATA].captureNames ?
	                // Don't recompile, to preserve capture names
	                value :
	                // Recompile as XRegExp
	                XRegExp(value.source)
	            ) :
	            // Compile string as XRegExp
	            XRegExp(value);
	    }
	
	/**
	 * Builds regexes using named subpatterns, for readability and pattern reuse. Backreferences in the
	 * outer pattern and provided subpatterns are automatically renumbered to work correctly. Native
	 * flags used by provided subpatterns are ignored in favor of the `flags` argument.
	 *
	 * @memberOf XRegExp
	 * @param {String} pattern XRegExp pattern using `{{name}}` for embedded subpatterns. Allows
	 *   `({{name}})` as shorthand for `(?<name>{{name}})`. Patterns cannot be embedded within
	 *   character classes.
	 * @param {Object} subs Lookup object for named subpatterns. Values can be strings or regexes. A
	 *   leading `^` and trailing unescaped `$` are stripped from subpatterns, if both are present.
	 * @param {String} [flags] Any combination of XRegExp flags.
	 * @returns {RegExp} Regex with interpolated subpatterns.
	 * @example
	 *
	 * var time = XRegExp.build('(?x)^ {{hours}} ({{minutes}}) $', {
	 *   hours: XRegExp.build('{{h12}} : | {{h24}}', {
	 *     h12: /1[0-2]|0?[1-9]/,
	 *     h24: /2[0-3]|[01][0-9]/
	 *   }, 'x'),
	 *   minutes: /^[0-5][0-9]$/
	 * });
	 * time.test('10:59'); // -> true
	 * XRegExp.exec('10:59', time).minutes; // -> '59'
	 */
	    XRegExp.build = function(pattern, subs, flags) {
	        var inlineFlags = /^\(\?([\w$]+)\)/.exec(pattern),
	            data = {},
	            numCaps = 0, // 'Caps' is short for captures
	            numPriorCaps,
	            numOuterCaps = 0,
	            outerCapsMap = [0],
	            outerCapNames,
	            sub,
	            p;
	
	        // Add flags within a leading mode modifier to the overall pattern's flags
	        if (inlineFlags) {
	            flags = flags || '';
	            inlineFlags[1].replace(/./g, function(flag) {
	                // Don't add duplicates
	                flags += (flags.indexOf(flag) > -1 ? '' : flag);
	            });
	        }
	
	        for (p in subs) {
	            if (subs.hasOwnProperty(p)) {
	                // Passing to XRegExp enables extended syntax and ensures independent validity,
	                // lest an unescaped `(`, `)`, `[`, or trailing `\` breaks the `(?:)` wrapper. For
	                // subpatterns provided as native regexes, it dies on octals and adds the property
	                // used to hold extended regex instance data, for simplicity
	                sub = asXRegExp(subs[p]);
	                data[p] = {
	                    // Deanchoring allows embedding independently useful anchored regexes. If you
	                    // really need to keep your anchors, double them (i.e., `^^...$$`)
	                    pattern: deanchor(sub.source),
	                    names: sub[REGEX_DATA].captureNames || []
	                };
	            }
	        }
	
	        // Passing to XRegExp dies on octals and ensures the outer pattern is independently valid;
	        // helps keep this simple. Named captures will be put back
	        pattern = asXRegExp(pattern);
	        outerCapNames = pattern[REGEX_DATA].captureNames || [];
	        pattern = pattern.source.replace(parts, function($0, $1, $2, $3, $4) {
	            var subName = $1 || $2,
	                capName,
	                intro,
	                localCapIndex;
	            // Named subpattern
	            if (subName) {
	                if (!data.hasOwnProperty(subName)) {
	                    throw new ReferenceError('Undefined property ' + $0);
	                }
	                // Named subpattern was wrapped in a capturing group
	                if ($1) {
	                    capName = outerCapNames[numOuterCaps];
	                    outerCapsMap[++numOuterCaps] = ++numCaps;
	                    // If it's a named group, preserve the name. Otherwise, use the subpattern name
	                    // as the capture name
	                    intro = '(?<' + (capName || subName) + '>';
	                } else {
	                    intro = '(?:';
	                }
	                numPriorCaps = numCaps;
	                return intro + data[subName].pattern.replace(subParts, function(match, paren, backref) {
	                    // Capturing group
	                    if (paren) {
	                        capName = data[subName].names[numCaps - numPriorCaps];
	                        ++numCaps;
	                        // If the current capture has a name, preserve the name
	                        if (capName) {
	                            return '(?<' + capName + '>';
	                        }
	                    // Backreference
	                    } else if (backref) {
	                        localCapIndex = +backref - 1;
	                        // Rewrite the backreference
	                        return data[subName].names[localCapIndex] ?
	                            // Need to preserve the backreference name in case using flag `n`
	                            '\\k<' + data[subName].names[localCapIndex] + '>' :
	                            '\\' + (+backref + numPriorCaps);
	                    }
	                    return match;
	                }) + ')';
	            }
	            // Capturing group
	            if ($3) {
	                capName = outerCapNames[numOuterCaps];
	                outerCapsMap[++numOuterCaps] = ++numCaps;
	                // If the current capture has a name, preserve the name
	                if (capName) {
	                    return '(?<' + capName + '>';
	                }
	            // Backreference
	            } else if ($4) {
	                localCapIndex = +$4 - 1;
	                // Rewrite the backreference
	                return outerCapNames[localCapIndex] ?
	                    // Need to preserve the backreference name in case using flag `n`
	                    '\\k<' + outerCapNames[localCapIndex] + '>' :
	                    '\\' + outerCapsMap[+$4];
	            }
	            return $0;
	        });
	
	        return XRegExp(pattern, flags);
	    };
	
	};


/***/ }),

/***/ 574:
/***/ (function(module, exports) {

	/*!
	 * XRegExp.matchRecursive 3.1.0
	 * <xregexp.com>
	 * Steven Levithan (c) 2009-2016 MIT License
	 */
	
	module.exports = function(XRegExp) {
	    'use strict';
	
	/**
	 * Returns a match detail object composed of the provided values.
	 *
	 * @private
	 */
	    function row(name, value, start, end) {
	        return {
	            name: name,
	            value: value,
	            start: start,
	            end: end
	        };
	    }
	
	/**
	 * Returns an array of match strings between outermost left and right delimiters, or an array of
	 * objects with detailed match parts and position data. An error is thrown if delimiters are
	 * unbalanced within the data.
	 *
	 * @memberOf XRegExp
	 * @param {String} str String to search.
	 * @param {String} left Left delimiter as an XRegExp pattern.
	 * @param {String} right Right delimiter as an XRegExp pattern.
	 * @param {String} [flags] Any native or XRegExp flags, used for the left and right delimiters.
	 * @param {Object} [options] Lets you specify `valueNames` and `escapeChar` options.
	 * @returns {Array} Array of matches, or an empty array.
	 * @example
	 *
	 * // Basic usage
	 * var str = '(t((e))s)t()(ing)';
	 * XRegExp.matchRecursive(str, '\\(', '\\)', 'g');
	 * // -> ['t((e))s', '', 'ing']
	 *
	 * // Extended information mode with valueNames
	 * str = 'Here is <div> <div>an</div></div> example';
	 * XRegExp.matchRecursive(str, '<div\\s*>', '</div>', 'gi', {
	 *   valueNames: ['between', 'left', 'match', 'right']
	 * });
	 * // -> [
	 * // {name: 'between', value: 'Here is ',       start: 0,  end: 8},
	 * // {name: 'left',    value: '<div>',          start: 8,  end: 13},
	 * // {name: 'match',   value: ' <div>an</div>', start: 13, end: 27},
	 * // {name: 'right',   value: '</div>',         start: 27, end: 33},
	 * // {name: 'between', value: ' example',       start: 33, end: 41}
	 * // ]
	 *
	 * // Omitting unneeded parts with null valueNames, and using escapeChar
	 * str = '...{1}.\\{{function(x,y){return {y:x}}}';
	 * XRegExp.matchRecursive(str, '{', '}', 'g', {
	 *   valueNames: ['literal', null, 'value', null],
	 *   escapeChar: '\\'
	 * });
	 * // -> [
	 * // {name: 'literal', value: '...',  start: 0, end: 3},
	 * // {name: 'value',   value: '1',    start: 4, end: 5},
	 * // {name: 'literal', value: '.\\{', start: 6, end: 9},
	 * // {name: 'value',   value: 'function(x,y){return {y:x}}', start: 10, end: 37}
	 * // ]
	 *
	 * // Sticky mode via flag y
	 * str = '<1><<<2>>><3>4<5>';
	 * XRegExp.matchRecursive(str, '<', '>', 'gy');
	 * // -> ['1', '<<2>>', '3']
	 */
	    XRegExp.matchRecursive = function(str, left, right, flags, options) {
	        flags = flags || '';
	        options = options || {};
	        var global = flags.indexOf('g') > -1,
	            sticky = flags.indexOf('y') > -1,
	            // Flag `y` is controlled internally
	            basicFlags = flags.replace(/y/g, ''),
	            escapeChar = options.escapeChar,
	            vN = options.valueNames,
	            output = [],
	            openTokens = 0,
	            delimStart = 0,
	            delimEnd = 0,
	            lastOuterEnd = 0,
	            outerStart,
	            innerStart,
	            leftMatch,
	            rightMatch,
	            esc;
	        left = XRegExp(left, basicFlags);
	        right = XRegExp(right, basicFlags);
	
	        if (escapeChar) {
	            if (escapeChar.length > 1) {
	                throw new Error('Cannot use more than one escape character');
	            }
	            escapeChar = XRegExp.escape(escapeChar);
	            // Using `XRegExp.union` safely rewrites backreferences in `left` and `right`
	            esc = new RegExp(
	                '(?:' + escapeChar + '[\\S\\s]|(?:(?!' +
	                    XRegExp.union([left, right]).source +
	                    ')[^' + escapeChar + '])+)+',
	                // Flags `gy` not needed here
	                flags.replace(/[^imu]+/g, '')
	            );
	        }
	
	        while (true) {
	            // If using an escape character, advance to the delimiter's next starting position,
	            // skipping any escaped characters in between
	            if (escapeChar) {
	                delimEnd += (XRegExp.exec(str, esc, delimEnd, 'sticky') || [''])[0].length;
	            }
	            leftMatch = XRegExp.exec(str, left, delimEnd);
	            rightMatch = XRegExp.exec(str, right, delimEnd);
	            // Keep the leftmost match only
	            if (leftMatch && rightMatch) {
	                if (leftMatch.index <= rightMatch.index) {
	                    rightMatch = null;
	                } else {
	                    leftMatch = null;
	                }
	            }
	            // Paths (LM: leftMatch, RM: rightMatch, OT: openTokens):
	            // LM | RM | OT | Result
	            // 1  | 0  | 1  | loop
	            // 1  | 0  | 0  | loop
	            // 0  | 1  | 1  | loop
	            // 0  | 1  | 0  | throw
	            // 0  | 0  | 1  | throw
	            // 0  | 0  | 0  | break
	            // The paths above don't include the sticky mode special case. The loop ends after the
	            // first completed match if not `global`.
	            if (leftMatch || rightMatch) {
	                delimStart = (leftMatch || rightMatch).index;
	                delimEnd = delimStart + (leftMatch || rightMatch)[0].length;
	            } else if (!openTokens) {
	                break;
	            }
	            if (sticky && !openTokens && delimStart > lastOuterEnd) {
	                break;
	            }
	            if (leftMatch) {
	                if (!openTokens) {
	                    outerStart = delimStart;
	                    innerStart = delimEnd;
	                }
	                ++openTokens;
	            } else if (rightMatch && openTokens) {
	                if (!--openTokens) {
	                    if (vN) {
	                        if (vN[0] && outerStart > lastOuterEnd) {
	                            output.push(row(vN[0], str.slice(lastOuterEnd, outerStart), lastOuterEnd, outerStart));
	                        }
	                        if (vN[1]) {
	                            output.push(row(vN[1], str.slice(outerStart, innerStart), outerStart, innerStart));
	                        }
	                        if (vN[2]) {
	                            output.push(row(vN[2], str.slice(innerStart, delimStart), innerStart, delimStart));
	                        }
	                        if (vN[3]) {
	                            output.push(row(vN[3], str.slice(delimStart, delimEnd), delimStart, delimEnd));
	                        }
	                    } else {
	                        output.push(str.slice(innerStart, delimStart));
	                    }
	                    lastOuterEnd = delimEnd;
	                    if (!global) {
	                        break;
	                    }
	                }
	            } else {
	                throw new Error('Unbalanced delimiter found in string');
	            }
	            // If the delimiter matched an empty string, avoid an infinite loop
	            if (delimStart === delimEnd) {
	                ++delimEnd;
	            }
	        }
	
	        if (global && !sticky && vN && vN[0] && str.length > lastOuterEnd) {
	            output.push(row(vN[0], str.slice(lastOuterEnd), lastOuterEnd, str.length));
	        }
	
	        return output;
	    };
	
	};


/***/ }),

/***/ 575:
/***/ (function(module, exports) {

	/*!
	 * XRegExp Unicode Base 3.1.0
	 * <xregexp.com>
	 * Steven Levithan (c) 2008-2016 MIT License
	 */
	
	/**
	 * Adds base support for Unicode matching:
	 * - Adds syntax `\p{..}` for matching Unicode tokens. Tokens can be inverted using `\P{..}` or
	 *   `\p{^..}`. Token names ignore case, spaces, hyphens, and underscores. You can omit the braces
	 *   for token names that are a single letter (e.g. `\pL` or `PL`).
	 * - Adds flag A (astral), which enables 21-bit Unicode support.
	 * - Adds the `XRegExp.addUnicodeData` method used by other addons to provide character data.
	 *
	 * Unicode Base relies on externally provided Unicode character data. Official addons are available
	 * to provide data for Unicode categories, scripts, blocks, and properties.
	 *
	 * @requires XRegExp
	 */
	module.exports = function(XRegExp) {
	    'use strict';
	
	// Storage for Unicode data
	    var unicode = {};
	
	/* ==============================
	 * Private functions
	 * ============================== */
	
	// Generates a token lookup name: lowercase, with hyphens, spaces, and underscores removed
	    function normalize(name) {
	        return name.replace(/[- _]+/g, '').toLowerCase();
	    }
	
	// Adds leading zeros if shorter than four characters
	    function pad4(str) {
	        while (str.length < 4) {
	            str = '0' + str;
	        }
	        return str;
	    }
	
	// Converts a hexadecimal number to decimal
	    function dec(hex) {
	        return parseInt(hex, 16);
	    }
	
	// Converts a decimal number to hexadecimal
	    function hex(dec) {
	        return parseInt(dec, 10).toString(16);
	    }
	
	// Gets the decimal code of a literal code unit, \xHH, \uHHHH, or a backslash-escaped literal
	    function charCode(chr) {
	        var esc = /^\\[xu](.+)/.exec(chr);
	        return esc ?
	            dec(esc[1]) :
	            chr.charCodeAt(chr.charAt(0) === '\\' ? 1 : 0);
	    }
	
	// Inverts a list of ordered BMP characters and ranges
	    function invertBmp(range) {
	        var output = '',
	            lastEnd = -1,
	            start;
	        XRegExp.forEach(range, /(\\x..|\\u....|\\?[\s\S])(?:-(\\x..|\\u....|\\?[\s\S]))?/, function(m) {
	            start = charCode(m[1]);
	            if (start > (lastEnd + 1)) {
	                output += '\\u' + pad4(hex(lastEnd + 1));
	                if (start > (lastEnd + 2)) {
	                    output += '-\\u' + pad4(hex(start - 1));
	                }
	            }
	            lastEnd = charCode(m[2] || m[1]);
	        });
	        if (lastEnd < 0xFFFF) {
	            output += '\\u' + pad4(hex(lastEnd + 1));
	            if (lastEnd < 0xFFFE) {
	                output += '-\\uFFFF';
	            }
	        }
	        return output;
	    }
	
	// Generates an inverted BMP range on first use
	    function cacheInvertedBmp(slug) {
	        var prop = 'b!';
	        return unicode[slug][prop] || (
	            unicode[slug][prop] = invertBmp(unicode[slug].bmp)
	        );
	    }
	
	// Combines and optionally negates BMP and astral data
	    function buildAstral(slug, isNegated) {
	        var item = unicode[slug],
	            combined = '';
	        if (item.bmp && !item.isBmpLast) {
	            combined = '[' + item.bmp + ']' + (item.astral ? '|' : '');
	        }
	        if (item.astral) {
	            combined += item.astral;
	        }
	        if (item.isBmpLast && item.bmp) {
	            combined += (item.astral ? '|' : '') + '[' + item.bmp + ']';
	        }
	        // Astral Unicode tokens always match a code point, never a code unit
	        return isNegated ?
	            '(?:(?!' + combined + ')(?:[\uD800-\uDBFF][\uDC00-\uDFFF]|[\0-\uFFFF]))' :
	            '(?:' + combined + ')';
	    }
	
	// Builds a complete astral pattern on first use
	    function cacheAstral(slug, isNegated) {
	        var prop = isNegated ? 'a!' : 'a=';
	        return unicode[slug][prop] || (
	            unicode[slug][prop] = buildAstral(slug, isNegated)
	        );
	    }
	
	/* ==============================
	 * Core functionality
	 * ============================== */
	
	/*
	 * Add Unicode token syntax: \p{..}, \P{..}, \p{^..}. Also add astral mode (flag A).
	 */
	    XRegExp.addToken(
	        // Use `*` instead of `+` to avoid capturing `^` as the token name in `\p{^}`
	        /\\([pP])(?:{(\^?)([^}]*)}|([A-Za-z]))/,
	        function(match, scope, flags) {
	            var ERR_DOUBLE_NEG = 'Invalid double negation ',
	                ERR_UNKNOWN_NAME = 'Unknown Unicode token ',
	                ERR_UNKNOWN_REF = 'Unicode token missing data ',
	                ERR_ASTRAL_ONLY = 'Astral mode required for Unicode token ',
	                ERR_ASTRAL_IN_CLASS = 'Astral mode does not support Unicode tokens within character classes',
	                // Negated via \P{..} or \p{^..}
	                isNegated = match[1] === 'P' || !!match[2],
	                // Switch from BMP (0-FFFF) to astral (0-10FFFF) mode via flag A
	                isAstralMode = flags.indexOf('A') > -1,
	                // Token lookup name. Check `[4]` first to avoid passing `undefined` via `\p{}`
	                slug = normalize(match[4] || match[3]),
	                // Token data object
	                item = unicode[slug];
	
	            if (match[1] === 'P' && match[2]) {
	                throw new SyntaxError(ERR_DOUBLE_NEG + match[0]);
	            }
	            if (!unicode.hasOwnProperty(slug)) {
	                throw new SyntaxError(ERR_UNKNOWN_NAME + match[0]);
	            }
	
	            // Switch to the negated form of the referenced Unicode token
	            if (item.inverseOf) {
	                slug = normalize(item.inverseOf);
	                if (!unicode.hasOwnProperty(slug)) {
	                    throw new ReferenceError(ERR_UNKNOWN_REF + match[0] + ' -> ' + item.inverseOf);
	                }
	                item = unicode[slug];
	                isNegated = !isNegated;
	            }
	
	            if (!(item.bmp || isAstralMode)) {
	                throw new SyntaxError(ERR_ASTRAL_ONLY + match[0]);
	            }
	            if (isAstralMode) {
	                if (scope === 'class') {
	                    throw new SyntaxError(ERR_ASTRAL_IN_CLASS);
	                }
	
	                return cacheAstral(slug, isNegated);
	            }
	
	            return scope === 'class' ?
	                (isNegated ? cacheInvertedBmp(slug) : item.bmp) :
	                (isNegated ? '[^' : '[') + item.bmp + ']';
	        },
	        {
	            scope: 'all',
	            optionalFlags: 'A',
	            leadChar: '\\'
	        }
	    );
	
	/**
	 * Adds to the list of Unicode tokens that XRegExp regexes can match via `\p` or `\P`.
	 *
	 * @memberOf XRegExp
	 * @param {Array} data Objects with named character ranges. Each object may have properties `name`,
	 *   `alias`, `isBmpLast`, `inverseOf`, `bmp`, and `astral`. All but `name` are optional, although
	 *   one of `bmp` or `astral` is required (unless `inverseOf` is set). If `astral` is absent, the
	 *   `bmp` data is used for BMP and astral modes. If `bmp` is absent, the name errors in BMP mode
	 *   but works in astral mode. If both `bmp` and `astral` are provided, the `bmp` data only is used
	 *   in BMP mode, and the combination of `bmp` and `astral` data is used in astral mode.
	 *   `isBmpLast` is needed when a token matches orphan high surrogates *and* uses surrogate pairs
	 *   to match astral code points. The `bmp` and `astral` data should be a combination of literal
	 *   characters and `\xHH` or `\uHHHH` escape sequences, with hyphens to create ranges. Any regex
	 *   metacharacters in the data should be escaped, apart from range-creating hyphens. The `astral`
	 *   data can additionally use character classes and alternation, and should use surrogate pairs to
	 *   represent astral code points. `inverseOf` can be used to avoid duplicating character data if a
	 *   Unicode token is defined as the exact inverse of another token.
	 * @example
	 *
	 * // Basic use
	 * XRegExp.addUnicodeData([{
	 *   name: 'XDigit',
	 *   alias: 'Hexadecimal',
	 *   bmp: '0-9A-Fa-f'
	 * }]);
	 * XRegExp('\\p{XDigit}:\\p{Hexadecimal}+').test('0:3D'); // -> true
	 */
	    XRegExp.addUnicodeData = function(data) {
	        var ERR_NO_NAME = 'Unicode token requires name',
	            ERR_NO_DATA = 'Unicode token has no character data ',
	            item,
	            i;
	
	        for (i = 0; i < data.length; ++i) {
	            item = data[i];
	            if (!item.name) {
	                throw new Error(ERR_NO_NAME);
	            }
	            if (!(item.inverseOf || item.bmp || item.astral)) {
	                throw new Error(ERR_NO_DATA + item.name);
	            }
	            unicode[normalize(item.name)] = item;
	            if (item.alias) {
	                unicode[normalize(item.alias)] = item;
	            }
	        }
	
	        // Reset the pattern cache used by the `XRegExp` constructor, since the same pattern and
	        // flags might now produce different results
	        XRegExp.cache.flush('patterns');
	    };
	
	};


/***/ }),

/***/ 576:
/***/ (function(module, exports) {

	/*!
	 * XRegExp Unicode Blocks 3.1.0
	 * <xregexp.com>
	 * Steven Levithan (c) 2010-2016 MIT License
	 * Unicode data by Mathias Bynens <mathiasbynens.be>
	 */
	
	/**
	 * Adds support for all Unicode blocks. Block names use the prefix 'In'. E.g., `\p{InBasicLatin}`.
	 * Token names are case insensitive, and any spaces, hyphens, and underscores are ignored.
	 *
	 * Uses Unicode 8.0.0.
	 *
	 * @requires XRegExp, Unicode Base
	 */
	module.exports = function(XRegExp) {
	    'use strict';
	
	    if (!XRegExp.addUnicodeData) {
	        throw new ReferenceError('Unicode Base must be loaded before Unicode Blocks');
	    }
	
	    XRegExp.addUnicodeData([
	        {
	            name: 'InAegean_Numbers',
	            astral: '\uD800[\uDD00-\uDD3F]'
	        },
	        {
	            name: 'InAhom',
	            astral: '\uD805[\uDF00-\uDF3F]'
	        },
	        {
	            name: 'InAlchemical_Symbols',
	            astral: '\uD83D[\uDF00-\uDF7F]'
	        },
	        {
	            name: 'InAlphabetic_Presentation_Forms',
	            bmp: '\uFB00-\uFB4F'
	        },
	        {
	            name: 'InAnatolian_Hieroglyphs',
	            astral: '\uD811[\uDC00-\uDE7F]'
	        },
	        {
	            name: 'InAncient_Greek_Musical_Notation',
	            astral: '\uD834[\uDE00-\uDE4F]'
	        },
	        {
	            name: 'InAncient_Greek_Numbers',
	            astral: '\uD800[\uDD40-\uDD8F]'
	        },
	        {
	            name: 'InAncient_Symbols',
	            astral: '\uD800[\uDD90-\uDDCF]'
	        },
	        {
	            name: 'InArabic',
	            bmp: '\u0600-\u06FF'
	        },
	        {
	            name: 'InArabic_Extended_A',
	            bmp: '\u08A0-\u08FF'
	        },
	        {
	            name: 'InArabic_Mathematical_Alphabetic_Symbols',
	            astral: '\uD83B[\uDE00-\uDEFF]'
	        },
	        {
	            name: 'InArabic_Presentation_Forms_A',
	            bmp: '\uFB50-\uFDFF'
	        },
	        {
	            name: 'InArabic_Presentation_Forms_B',
	            bmp: '\uFE70-\uFEFF'
	        },
	        {
	            name: 'InArabic_Supplement',
	            bmp: '\u0750-\u077F'
	        },
	        {
	            name: 'InArmenian',
	            bmp: '\u0530-\u058F'
	        },
	        {
	            name: 'InArrows',
	            bmp: '\u2190-\u21FF'
	        },
	        {
	            name: 'InAvestan',
	            astral: '\uD802[\uDF00-\uDF3F]'
	        },
	        {
	            name: 'InBalinese',
	            bmp: '\u1B00-\u1B7F'
	        },
	        {
	            name: 'InBamum',
	            bmp: '\uA6A0-\uA6FF'
	        },
	        {
	            name: 'InBamum_Supplement',
	            astral: '\uD81A[\uDC00-\uDE3F]'
	        },
	        {
	            name: 'InBasic_Latin',
	            bmp: '\0-\x7F'
	        },
	        {
	            name: 'InBassa_Vah',
	            astral: '\uD81A[\uDED0-\uDEFF]'
	        },
	        {
	            name: 'InBatak',
	            bmp: '\u1BC0-\u1BFF'
	        },
	        {
	            name: 'InBengali',
	            bmp: '\u0980-\u09FF'
	        },
	        {
	            name: 'InBlock_Elements',
	            bmp: '\u2580-\u259F'
	        },
	        {
	            name: 'InBopomofo',
	            bmp: '\u3100-\u312F'
	        },
	        {
	            name: 'InBopomofo_Extended',
	            bmp: '\u31A0-\u31BF'
	        },
	        {
	            name: 'InBox_Drawing',
	            bmp: '\u2500-\u257F'
	        },
	        {
	            name: 'InBrahmi',
	            astral: '\uD804[\uDC00-\uDC7F]'
	        },
	        {
	            name: 'InBraille_Patterns',
	            bmp: '\u2800-\u28FF'
	        },
	        {
	            name: 'InBuginese',
	            bmp: '\u1A00-\u1A1F'
	        },
	        {
	            name: 'InBuhid',
	            bmp: '\u1740-\u175F'
	        },
	        {
	            name: 'InByzantine_Musical_Symbols',
	            astral: '\uD834[\uDC00-\uDCFF]'
	        },
	        {
	            name: 'InCJK_Compatibility',
	            bmp: '\u3300-\u33FF'
	        },
	        {
	            name: 'InCJK_Compatibility_Forms',
	            bmp: '\uFE30-\uFE4F'
	        },
	        {
	            name: 'InCJK_Compatibility_Ideographs',
	            bmp: '\uF900-\uFAFF'
	        },
	        {
	            name: 'InCJK_Compatibility_Ideographs_Supplement',
	            astral: '\uD87E[\uDC00-\uDE1F]'
	        },
	        {
	            name: 'InCJK_Radicals_Supplement',
	            bmp: '\u2E80-\u2EFF'
	        },
	        {
	            name: 'InCJK_Strokes',
	            bmp: '\u31C0-\u31EF'
	        },
	        {
	            name: 'InCJK_Symbols_and_Punctuation',
	            bmp: '\u3000-\u303F'
	        },
	        {
	            name: 'InCJK_Unified_Ideographs',
	            bmp: '\u4E00-\u9FFF'
	        },
	        {
	            name: 'InCJK_Unified_Ideographs_Extension_A',
	            bmp: '\u3400-\u4DBF'
	        },
	        {
	            name: 'InCJK_Unified_Ideographs_Extension_B',
	            astral: '[\uD840-\uD868][\uDC00-\uDFFF]|\uD869[\uDC00-\uDEDF]'
	        },
	        {
	            name: 'InCJK_Unified_Ideographs_Extension_C',
	            astral: '\uD86D[\uDC00-\uDF3F]|[\uD86A-\uD86C][\uDC00-\uDFFF]|\uD869[\uDF00-\uDFFF]'
	        },
	        {
	            name: 'InCJK_Unified_Ideographs_Extension_D',
	            astral: '\uD86D[\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1F]'
	        },
	        {
	            name: 'InCJK_Unified_Ideographs_Extension_E',
	            astral: '[\uD86F-\uD872][\uDC00-\uDFFF]|\uD873[\uDC00-\uDEAF]|\uD86E[\uDC20-\uDFFF]'
	        },
	        {
	            name: 'InCarian',
	            astral: '\uD800[\uDEA0-\uDEDF]'
	        },
	        {
	            name: 'InCaucasian_Albanian',
	            astral: '\uD801[\uDD30-\uDD6F]'
	        },
	        {
	            name: 'InChakma',
	            astral: '\uD804[\uDD00-\uDD4F]'
	        },
	        {
	            name: 'InCham',
	            bmp: '\uAA00-\uAA5F'
	        },
	        {
	            name: 'InCherokee',
	            bmp: '\u13A0-\u13FF'
	        },
	        {
	            name: 'InCherokee_Supplement',
	            bmp: '\uAB70-\uABBF'
	        },
	        {
	            name: 'InCombining_Diacritical_Marks',
	            bmp: '\u0300-\u036F'
	        },
	        {
	            name: 'InCombining_Diacritical_Marks_Extended',
	            bmp: '\u1AB0-\u1AFF'
	        },
	        {
	            name: 'InCombining_Diacritical_Marks_Supplement',
	            bmp: '\u1DC0-\u1DFF'
	        },
	        {
	            name: 'InCombining_Diacritical_Marks_for_Symbols',
	            bmp: '\u20D0-\u20FF'
	        },
	        {
	            name: 'InCombining_Half_Marks',
	            bmp: '\uFE20-\uFE2F'
	        },
	        {
	            name: 'InCommon_Indic_Number_Forms',
	            bmp: '\uA830-\uA83F'
	        },
	        {
	            name: 'InControl_Pictures',
	            bmp: '\u2400-\u243F'
	        },
	        {
	            name: 'InCoptic',
	            bmp: '\u2C80-\u2CFF'
	        },
	        {
	            name: 'InCoptic_Epact_Numbers',
	            astral: '\uD800[\uDEE0-\uDEFF]'
	        },
	        {
	            name: 'InCounting_Rod_Numerals',
	            astral: '\uD834[\uDF60-\uDF7F]'
	        },
	        {
	            name: 'InCuneiform',
	            astral: '\uD808[\uDC00-\uDFFF]'
	        },
	        {
	            name: 'InCuneiform_Numbers_and_Punctuation',
	            astral: '\uD809[\uDC00-\uDC7F]'
	        },
	        {
	            name: 'InCurrency_Symbols',
	            bmp: '\u20A0-\u20CF'
	        },
	        {
	            name: 'InCypriot_Syllabary',
	            astral: '\uD802[\uDC00-\uDC3F]'
	        },
	        {
	            name: 'InCyrillic',
	            bmp: '\u0400-\u04FF'
	        },
	        {
	            name: 'InCyrillic_Extended_A',
	            bmp: '\u2DE0-\u2DFF'
	        },
	        {
	            name: 'InCyrillic_Extended_B',
	            bmp: '\uA640-\uA69F'
	        },
	        {
	            name: 'InCyrillic_Supplement',
	            bmp: '\u0500-\u052F'
	        },
	        {
	            name: 'InDeseret',
	            astral: '\uD801[\uDC00-\uDC4F]'
	        },
	        {
	            name: 'InDevanagari',
	            bmp: '\u0900-\u097F'
	        },
	        {
	            name: 'InDevanagari_Extended',
	            bmp: '\uA8E0-\uA8FF'
	        },
	        {
	            name: 'InDingbats',
	            bmp: '\u2700-\u27BF'
	        },
	        {
	            name: 'InDomino_Tiles',
	            astral: '\uD83C[\uDC30-\uDC9F]'
	        },
	        {
	            name: 'InDuployan',
	            astral: '\uD82F[\uDC00-\uDC9F]'
	        },
	        {
	            name: 'InEarly_Dynastic_Cuneiform',
	            astral: '\uD809[\uDC80-\uDD4F]'
	        },
	        {
	            name: 'InEgyptian_Hieroglyphs',
	            astral: '\uD80C[\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F]'
	        },
	        {
	            name: 'InElbasan',
	            astral: '\uD801[\uDD00-\uDD2F]'
	        },
	        {
	            name: 'InEmoticons',
	            astral: '\uD83D[\uDE00-\uDE4F]'
	        },
	        {
	            name: 'InEnclosed_Alphanumeric_Supplement',
	            astral: '\uD83C[\uDD00-\uDDFF]'
	        },
	        {
	            name: 'InEnclosed_Alphanumerics',
	            bmp: '\u2460-\u24FF'
	        },
	        {
	            name: 'InEnclosed_CJK_Letters_and_Months',
	            bmp: '\u3200-\u32FF'
	        },
	        {
	            name: 'InEnclosed_Ideographic_Supplement',
	            astral: '\uD83C[\uDE00-\uDEFF]'
	        },
	        {
	            name: 'InEthiopic',
	            bmp: '\u1200-\u137F'
	        },
	        {
	            name: 'InEthiopic_Extended',
	            bmp: '\u2D80-\u2DDF'
	        },
	        {
	            name: 'InEthiopic_Extended_A',
	            bmp: '\uAB00-\uAB2F'
	        },
	        {
	            name: 'InEthiopic_Supplement',
	            bmp: '\u1380-\u139F'
	        },
	        {
	            name: 'InGeneral_Punctuation',
	            bmp: '\u2000-\u206F'
	        },
	        {
	            name: 'InGeometric_Shapes',
	            bmp: '\u25A0-\u25FF'
	        },
	        {
	            name: 'InGeometric_Shapes_Extended',
	            astral: '\uD83D[\uDF80-\uDFFF]'
	        },
	        {
	            name: 'InGeorgian',
	            bmp: '\u10A0-\u10FF'
	        },
	        {
	            name: 'InGeorgian_Supplement',
	            bmp: '\u2D00-\u2D2F'
	        },
	        {
	            name: 'InGlagolitic',
	            bmp: '\u2C00-\u2C5F'
	        },
	        {
	            name: 'InGothic',
	            astral: '\uD800[\uDF30-\uDF4F]'
	        },
	        {
	            name: 'InGrantha',
	            astral: '\uD804[\uDF00-\uDF7F]'
	        },
	        {
	            name: 'InGreek_Extended',
	            bmp: '\u1F00-\u1FFF'
	        },
	        {
	            name: 'InGreek_and_Coptic',
	            bmp: '\u0370-\u03FF'
	        },
	        {
	            name: 'InGujarati',
	            bmp: '\u0A80-\u0AFF'
	        },
	        {
	            name: 'InGurmukhi',
	            bmp: '\u0A00-\u0A7F'
	        },
	        {
	            name: 'InHalfwidth_and_Fullwidth_Forms',
	            bmp: '\uFF00-\uFFEF'
	        },
	        {
	            name: 'InHangul_Compatibility_Jamo',
	            bmp: '\u3130-\u318F'
	        },
	        {
	            name: 'InHangul_Jamo',
	            bmp: '\u1100-\u11FF'
	        },
	        {
	            name: 'InHangul_Jamo_Extended_A',
	            bmp: '\uA960-\uA97F'
	        },
	        {
	            name: 'InHangul_Jamo_Extended_B',
	            bmp: '\uD7B0-\uD7FF'
	        },
	        {
	            name: 'InHangul_Syllables',
	            bmp: '\uAC00-\uD7AF'
	        },
	        {
	            name: 'InHanunoo',
	            bmp: '\u1720-\u173F'
	        },
	        {
	            name: 'InHatran',
	            astral: '\uD802[\uDCE0-\uDCFF]'
	        },
	        {
	            name: 'InHebrew',
	            bmp: '\u0590-\u05FF'
	        },
	        {
	            name: 'InHigh_Private_Use_Surrogates',
	            bmp: '\uDB80-\uDBFF'
	        },
	        {
	            name: 'InHigh_Surrogates',
	            bmp: '\uD800-\uDB7F'
	        },
	        {
	            name: 'InHiragana',
	            bmp: '\u3040-\u309F'
	        },
	        {
	            name: 'InIPA_Extensions',
	            bmp: '\u0250-\u02AF'
	        },
	        {
	            name: 'InIdeographic_Description_Characters',
	            bmp: '\u2FF0-\u2FFF'
	        },
	        {
	            name: 'InImperial_Aramaic',
	            astral: '\uD802[\uDC40-\uDC5F]'
	        },
	        {
	            name: 'InInscriptional_Pahlavi',
	            astral: '\uD802[\uDF60-\uDF7F]'
	        },
	        {
	            name: 'InInscriptional_Parthian',
	            astral: '\uD802[\uDF40-\uDF5F]'
	        },
	        {
	            name: 'InJavanese',
	            bmp: '\uA980-\uA9DF'
	        },
	        {
	            name: 'InKaithi',
	            astral: '\uD804[\uDC80-\uDCCF]'
	        },
	        {
	            name: 'InKana_Supplement',
	            astral: '\uD82C[\uDC00-\uDCFF]'
	        },
	        {
	            name: 'InKanbun',
	            bmp: '\u3190-\u319F'
	        },
	        {
	            name: 'InKangxi_Radicals',
	            bmp: '\u2F00-\u2FDF'
	        },
	        {
	            name: 'InKannada',
	            bmp: '\u0C80-\u0CFF'
	        },
	        {
	            name: 'InKatakana',
	            bmp: '\u30A0-\u30FF'
	        },
	        {
	            name: 'InKatakana_Phonetic_Extensions',
	            bmp: '\u31F0-\u31FF'
	        },
	        {
	            name: 'InKayah_Li',
	            bmp: '\uA900-\uA92F'
	        },
	        {
	            name: 'InKharoshthi',
	            astral: '\uD802[\uDE00-\uDE5F]'
	        },
	        {
	            name: 'InKhmer',
	            bmp: '\u1780-\u17FF'
	        },
	        {
	            name: 'InKhmer_Symbols',
	            bmp: '\u19E0-\u19FF'
	        },
	        {
	            name: 'InKhojki',
	            astral: '\uD804[\uDE00-\uDE4F]'
	        },
	        {
	            name: 'InKhudawadi',
	            astral: '\uD804[\uDEB0-\uDEFF]'
	        },
	        {
	            name: 'InLao',
	            bmp: '\u0E80-\u0EFF'
	        },
	        {
	            name: 'InLatin_Extended_Additional',
	            bmp: '\u1E00-\u1EFF'
	        },
	        {
	            name: 'InLatin_Extended_A',
	            bmp: '\u0100-\u017F'
	        },
	        {
	            name: 'InLatin_Extended_B',
	            bmp: '\u0180-\u024F'
	        },
	        {
	            name: 'InLatin_Extended_C',
	            bmp: '\u2C60-\u2C7F'
	        },
	        {
	            name: 'InLatin_Extended_D',
	            bmp: '\uA720-\uA7FF'
	        },
	        {
	            name: 'InLatin_Extended_E',
	            bmp: '\uAB30-\uAB6F'
	        },
	        {
	            name: 'InLatin_1_Supplement',
	            bmp: '\x80-\xFF'
	        },
	        {
	            name: 'InLepcha',
	            bmp: '\u1C00-\u1C4F'
	        },
	        {
	            name: 'InLetterlike_Symbols',
	            bmp: '\u2100-\u214F'
	        },
	        {
	            name: 'InLimbu',
	            bmp: '\u1900-\u194F'
	        },
	        {
	            name: 'InLinear_A',
	            astral: '\uD801[\uDE00-\uDF7F]'
	        },
	        {
	            name: 'InLinear_B_Ideograms',
	            astral: '\uD800[\uDC80-\uDCFF]'
	        },
	        {
	            name: 'InLinear_B_Syllabary',
	            astral: '\uD800[\uDC00-\uDC7F]'
	        },
	        {
	            name: 'InLisu',
	            bmp: '\uA4D0-\uA4FF'
	        },
	        {
	            name: 'InLow_Surrogates',
	            bmp: '\uDC00-\uDFFF'
	        },
	        {
	            name: 'InLycian',
	            astral: '\uD800[\uDE80-\uDE9F]'
	        },
	        {
	            name: 'InLydian',
	            astral: '\uD802[\uDD20-\uDD3F]'
	        },
	        {
	            name: 'InMahajani',
	            astral: '\uD804[\uDD50-\uDD7F]'
	        },
	        {
	            name: 'InMahjong_Tiles',
	            astral: '\uD83C[\uDC00-\uDC2F]'
	        },
	        {
	            name: 'InMalayalam',
	            bmp: '\u0D00-\u0D7F'
	        },
	        {
	            name: 'InMandaic',
	            bmp: '\u0840-\u085F'
	        },
	        {
	            name: 'InManichaean',
	            astral: '\uD802[\uDEC0-\uDEFF]'
	        },
	        {
	            name: 'InMathematical_Alphanumeric_Symbols',
	            astral: '\uD835[\uDC00-\uDFFF]'
	        },
	        {
	            name: 'InMathematical_Operators',
	            bmp: '\u2200-\u22FF'
	        },
	        {
	            name: 'InMeetei_Mayek',
	            bmp: '\uABC0-\uABFF'
	        },
	        {
	            name: 'InMeetei_Mayek_Extensions',
	            bmp: '\uAAE0-\uAAFF'
	        },
	        {
	            name: 'InMende_Kikakui',
	            astral: '\uD83A[\uDC00-\uDCDF]'
	        },
	        {
	            name: 'InMeroitic_Cursive',
	            astral: '\uD802[\uDDA0-\uDDFF]'
	        },
	        {
	            name: 'InMeroitic_Hieroglyphs',
	            astral: '\uD802[\uDD80-\uDD9F]'
	        },
	        {
	            name: 'InMiao',
	            astral: '\uD81B[\uDF00-\uDF9F]'
	        },
	        {
	            name: 'InMiscellaneous_Mathematical_Symbols_A',
	            bmp: '\u27C0-\u27EF'
	        },
	        {
	            name: 'InMiscellaneous_Mathematical_Symbols_B',
	            bmp: '\u2980-\u29FF'
	        },
	        {
	            name: 'InMiscellaneous_Symbols',
	            bmp: '\u2600-\u26FF'
	        },
	        {
	            name: 'InMiscellaneous_Symbols_and_Arrows',
	            bmp: '\u2B00-\u2BFF'
	        },
	        {
	            name: 'InMiscellaneous_Symbols_and_Pictographs',
	            astral: '\uD83D[\uDC00-\uDDFF]|\uD83C[\uDF00-\uDFFF]'
	        },
	        {
	            name: 'InMiscellaneous_Technical',
	            bmp: '\u2300-\u23FF'
	        },
	        {
	            name: 'InModi',
	            astral: '\uD805[\uDE00-\uDE5F]'
	        },
	        {
	            name: 'InModifier_Tone_Letters',
	            bmp: '\uA700-\uA71F'
	        },
	        {
	            name: 'InMongolian',
	            bmp: '\u1800-\u18AF'
	        },
	        {
	            name: 'InMro',
	            astral: '\uD81A[\uDE40-\uDE6F]'
	        },
	        {
	            name: 'InMultani',
	            astral: '\uD804[\uDE80-\uDEAF]'
	        },
	        {
	            name: 'InMusical_Symbols',
	            astral: '\uD834[\uDD00-\uDDFF]'
	        },
	        {
	            name: 'InMyanmar',
	            bmp: '\u1000-\u109F'
	        },
	        {
	            name: 'InMyanmar_Extended_A',
	            bmp: '\uAA60-\uAA7F'
	        },
	        {
	            name: 'InMyanmar_Extended_B',
	            bmp: '\uA9E0-\uA9FF'
	        },
	        {
	            name: 'InNKo',
	            bmp: '\u07C0-\u07FF'
	        },
	        {
	            name: 'InNabataean',
	            astral: '\uD802[\uDC80-\uDCAF]'
	        },
	        {
	            name: 'InNew_Tai_Lue',
	            bmp: '\u1980-\u19DF'
	        },
	        {
	            name: 'InNumber_Forms',
	            bmp: '\u2150-\u218F'
	        },
	        {
	            name: 'InOgham',
	            bmp: '\u1680-\u169F'
	        },
	        {
	            name: 'InOl_Chiki',
	            bmp: '\u1C50-\u1C7F'
	        },
	        {
	            name: 'InOld_Hungarian',
	            astral: '\uD803[\uDC80-\uDCFF]'
	        },
	        {
	            name: 'InOld_Italic',
	            astral: '\uD800[\uDF00-\uDF2F]'
	        },
	        {
	            name: 'InOld_North_Arabian',
	            astral: '\uD802[\uDE80-\uDE9F]'
	        },
	        {
	            name: 'InOld_Permic',
	            astral: '\uD800[\uDF50-\uDF7F]'
	        },
	        {
	            name: 'InOld_Persian',
	            astral: '\uD800[\uDFA0-\uDFDF]'
	        },
	        {
	            name: 'InOld_South_Arabian',
	            astral: '\uD802[\uDE60-\uDE7F]'
	        },
	        {
	            name: 'InOld_Turkic',
	            astral: '\uD803[\uDC00-\uDC4F]'
	        },
	        {
	            name: 'InOptical_Character_Recognition',
	            bmp: '\u2440-\u245F'
	        },
	        {
	            name: 'InOriya',
	            bmp: '\u0B00-\u0B7F'
	        },
	        {
	            name: 'InOrnamental_Dingbats',
	            astral: '\uD83D[\uDE50-\uDE7F]'
	        },
	        {
	            name: 'InOsmanya',
	            astral: '\uD801[\uDC80-\uDCAF]'
	        },
	        {
	            name: 'InPahawh_Hmong',
	            astral: '\uD81A[\uDF00-\uDF8F]'
	        },
	        {
	            name: 'InPalmyrene',
	            astral: '\uD802[\uDC60-\uDC7F]'
	        },
	        {
	            name: 'InPau_Cin_Hau',
	            astral: '\uD806[\uDEC0-\uDEFF]'
	        },
	        {
	            name: 'InPhags_pa',
	            bmp: '\uA840-\uA87F'
	        },
	        {
	            name: 'InPhaistos_Disc',
	            astral: '\uD800[\uDDD0-\uDDFF]'
	        },
	        {
	            name: 'InPhoenician',
	            astral: '\uD802[\uDD00-\uDD1F]'
	        },
	        {
	            name: 'InPhonetic_Extensions',
	            bmp: '\u1D00-\u1D7F'
	        },
	        {
	            name: 'InPhonetic_Extensions_Supplement',
	            bmp: '\u1D80-\u1DBF'
	        },
	        {
	            name: 'InPlaying_Cards',
	            astral: '\uD83C[\uDCA0-\uDCFF]'
	        },
	        {
	            name: 'InPrivate_Use_Area',
	            bmp: '\uE000-\uF8FF'
	        },
	        {
	            name: 'InPsalter_Pahlavi',
	            astral: '\uD802[\uDF80-\uDFAF]'
	        },
	        {
	            name: 'InRejang',
	            bmp: '\uA930-\uA95F'
	        },
	        {
	            name: 'InRumi_Numeral_Symbols',
	            astral: '\uD803[\uDE60-\uDE7F]'
	        },
	        {
	            name: 'InRunic',
	            bmp: '\u16A0-\u16FF'
	        },
	        {
	            name: 'InSamaritan',
	            bmp: '\u0800-\u083F'
	        },
	        {
	            name: 'InSaurashtra',
	            bmp: '\uA880-\uA8DF'
	        },
	        {
	            name: 'InSharada',
	            astral: '\uD804[\uDD80-\uDDDF]'
	        },
	        {
	            name: 'InShavian',
	            astral: '\uD801[\uDC50-\uDC7F]'
	        },
	        {
	            name: 'InShorthand_Format_Controls',
	            astral: '\uD82F[\uDCA0-\uDCAF]'
	        },
	        {
	            name: 'InSiddham',
	            astral: '\uD805[\uDD80-\uDDFF]'
	        },
	        {
	            name: 'InSinhala',
	            bmp: '\u0D80-\u0DFF'
	        },
	        {
	            name: 'InSinhala_Archaic_Numbers',
	            astral: '\uD804[\uDDE0-\uDDFF]'
	        },
	        {
	            name: 'InSmall_Form_Variants',
	            bmp: '\uFE50-\uFE6F'
	        },
	        {
	            name: 'InSora_Sompeng',
	            astral: '\uD804[\uDCD0-\uDCFF]'
	        },
	        {
	            name: 'InSpacing_Modifier_Letters',
	            bmp: '\u02B0-\u02FF'
	        },
	        {
	            name: 'InSpecials',
	            bmp: '\uFFF0-\uFFFF'
	        },
	        {
	            name: 'InSundanese',
	            bmp: '\u1B80-\u1BBF'
	        },
	        {
	            name: 'InSundanese_Supplement',
	            bmp: '\u1CC0-\u1CCF'
	        },
	        {
	            name: 'InSuperscripts_and_Subscripts',
	            bmp: '\u2070-\u209F'
	        },
	        {
	            name: 'InSupplemental_Arrows_A',
	            bmp: '\u27F0-\u27FF'
	        },
	        {
	            name: 'InSupplemental_Arrows_B',
	            bmp: '\u2900-\u297F'
	        },
	        {
	            name: 'InSupplemental_Arrows_C',
	            astral: '\uD83E[\uDC00-\uDCFF]'
	        },
	        {
	            name: 'InSupplemental_Mathematical_Operators',
	            bmp: '\u2A00-\u2AFF'
	        },
	        {
	            name: 'InSupplemental_Punctuation',
	            bmp: '\u2E00-\u2E7F'
	        },
	        {
	            name: 'InSupplemental_Symbols_and_Pictographs',
	            astral: '\uD83E[\uDD00-\uDDFF]'
	        },
	        {
	            name: 'InSupplementary_Private_Use_Area_A',
	            astral: '[\uDB80-\uDBBF][\uDC00-\uDFFF]'
	        },
	        {
	            name: 'InSupplementary_Private_Use_Area_B',
	            astral: '[\uDBC0-\uDBFF][\uDC00-\uDFFF]'
	        },
	        {
	            name: 'InSutton_SignWriting',
	            astral: '\uD836[\uDC00-\uDEAF]'
	        },
	        {
	            name: 'InSyloti_Nagri',
	            bmp: '\uA800-\uA82F'
	        },
	        {
	            name: 'InSyriac',
	            bmp: '\u0700-\u074F'
	        },
	        {
	            name: 'InTagalog',
	            bmp: '\u1700-\u171F'
	        },
	        {
	            name: 'InTagbanwa',
	            bmp: '\u1760-\u177F'
	        },
	        {
	            name: 'InTags',
	            astral: '\uDB40[\uDC00-\uDC7F]'
	        },
	        {
	            name: 'InTai_Le',
	            bmp: '\u1950-\u197F'
	        },
	        {
	            name: 'InTai_Tham',
	            bmp: '\u1A20-\u1AAF'
	        },
	        {
	            name: 'InTai_Viet',
	            bmp: '\uAA80-\uAADF'
	        },
	        {
	            name: 'InTai_Xuan_Jing_Symbols',
	            astral: '\uD834[\uDF00-\uDF5F]'
	        },
	        {
	            name: 'InTakri',
	            astral: '\uD805[\uDE80-\uDECF]'
	        },
	        {
	            name: 'InTamil',
	            bmp: '\u0B80-\u0BFF'
	        },
	        {
	            name: 'InTelugu',
	            bmp: '\u0C00-\u0C7F'
	        },
	        {
	            name: 'InThaana',
	            bmp: '\u0780-\u07BF'
	        },
	        {
	            name: 'InThai',
	            bmp: '\u0E00-\u0E7F'
	        },
	        {
	            name: 'InTibetan',
	            bmp: '\u0F00-\u0FFF'
	        },
	        {
	            name: 'InTifinagh',
	            bmp: '\u2D30-\u2D7F'
	        },
	        {
	            name: 'InTirhuta',
	            astral: '\uD805[\uDC80-\uDCDF]'
	        },
	        {
	            name: 'InTransport_and_Map_Symbols',
	            astral: '\uD83D[\uDE80-\uDEFF]'
	        },
	        {
	            name: 'InUgaritic',
	            astral: '\uD800[\uDF80-\uDF9F]'
	        },
	        {
	            name: 'InUnified_Canadian_Aboriginal_Syllabics',
	            bmp: '\u1400-\u167F'
	        },
	        {
	            name: 'InUnified_Canadian_Aboriginal_Syllabics_Extended',
	            bmp: '\u18B0-\u18FF'
	        },
	        {
	            name: 'InVai',
	            bmp: '\uA500-\uA63F'
	        },
	        {
	            name: 'InVariation_Selectors',
	            bmp: '\uFE00-\uFE0F'
	        },
	        {
	            name: 'InVariation_Selectors_Supplement',
	            astral: '\uDB40[\uDD00-\uDDEF]'
	        },
	        {
	            name: 'InVedic_Extensions',
	            bmp: '\u1CD0-\u1CFF'
	        },
	        {
	            name: 'InVertical_Forms',
	            bmp: '\uFE10-\uFE1F'
	        },
	        {
	            name: 'InWarang_Citi',
	            astral: '\uD806[\uDCA0-\uDCFF]'
	        },
	        {
	            name: 'InYi_Radicals',
	            bmp: '\uA490-\uA4CF'
	        },
	        {
	            name: 'InYi_Syllables',
	            bmp: '\uA000-\uA48F'
	        },
	        {
	            name: 'InYijing_Hexagram_Symbols',
	            bmp: '\u4DC0-\u4DFF'
	        }
	    ]);
	
	};


/***/ }),

/***/ 577:
/***/ (function(module, exports) {

	/*!
	 * XRegExp Unicode Categories 3.1.0
	 * <xregexp.com>
	 * Steven Levithan (c) 2010-2016 MIT License
	 * Unicode data by Mathias Bynens <mathiasbynens.be>
	 */
	
	/**
	 * Adds support for Unicode's general categories. E.g., `\p{Lu}` or `\p{Uppercase Letter}`. See
	 * category descriptions in UAX #44 <http://unicode.org/reports/tr44/#GC_Values_Table>. Token names
	 * are case insensitive, and any spaces, hyphens, and underscores are ignored.
	 *
	 * Uses Unicode 8.0.0.
	 *
	 * @requires XRegExp, Unicode Base
	 */
	module.exports = function(XRegExp) {
	    'use strict';
	
	    if (!XRegExp.addUnicodeData) {
	        throw new ReferenceError('Unicode Base must be loaded before Unicode Categories');
	    }
	
	    XRegExp.addUnicodeData([
	        {
	            name: 'C',
	            alias: 'Other',
	            isBmpLast: true,
	            bmp: '\0-\x1F\x7F-\x9F\xAD\u0378\u0379\u0380-\u0383\u038B\u038D\u03A2\u0530\u0557\u0558\u0560\u0588\u058B\u058C\u0590\u05C8-\u05CF\u05EB-\u05EF\u05F5-\u0605\u061C\u061D\u06DD\u070E\u070F\u074B\u074C\u07B2-\u07BF\u07FB-\u07FF\u082E\u082F\u083F\u085C\u085D\u085F-\u089F\u08B5-\u08E2\u0984\u098D\u098E\u0991\u0992\u09A9\u09B1\u09B3-\u09B5\u09BA\u09BB\u09C5\u09C6\u09C9\u09CA\u09CF-\u09D6\u09D8-\u09DB\u09DE\u09E4\u09E5\u09FC-\u0A00\u0A04\u0A0B-\u0A0E\u0A11\u0A12\u0A29\u0A31\u0A34\u0A37\u0A3A\u0A3B\u0A3D\u0A43-\u0A46\u0A49\u0A4A\u0A4E-\u0A50\u0A52-\u0A58\u0A5D\u0A5F-\u0A65\u0A76-\u0A80\u0A84\u0A8E\u0A92\u0AA9\u0AB1\u0AB4\u0ABA\u0ABB\u0AC6\u0ACA\u0ACE\u0ACF\u0AD1-\u0ADF\u0AE4\u0AE5\u0AF2-\u0AF8\u0AFA-\u0B00\u0B04\u0B0D\u0B0E\u0B11\u0B12\u0B29\u0B31\u0B34\u0B3A\u0B3B\u0B45\u0B46\u0B49\u0B4A\u0B4E-\u0B55\u0B58-\u0B5B\u0B5E\u0B64\u0B65\u0B78-\u0B81\u0B84\u0B8B-\u0B8D\u0B91\u0B96-\u0B98\u0B9B\u0B9D\u0BA0-\u0BA2\u0BA5-\u0BA7\u0BAB-\u0BAD\u0BBA-\u0BBD\u0BC3-\u0BC5\u0BC9\u0BCE\u0BCF\u0BD1-\u0BD6\u0BD8-\u0BE5\u0BFB-\u0BFF\u0C04\u0C0D\u0C11\u0C29\u0C3A-\u0C3C\u0C45\u0C49\u0C4E-\u0C54\u0C57\u0C5B-\u0C5F\u0C64\u0C65\u0C70-\u0C77\u0C80\u0C84\u0C8D\u0C91\u0CA9\u0CB4\u0CBA\u0CBB\u0CC5\u0CC9\u0CCE-\u0CD4\u0CD7-\u0CDD\u0CDF\u0CE4\u0CE5\u0CF0\u0CF3-\u0D00\u0D04\u0D0D\u0D11\u0D3B\u0D3C\u0D45\u0D49\u0D4F-\u0D56\u0D58-\u0D5E\u0D64\u0D65\u0D76-\u0D78\u0D80\u0D81\u0D84\u0D97-\u0D99\u0DB2\u0DBC\u0DBE\u0DBF\u0DC7-\u0DC9\u0DCB-\u0DCE\u0DD5\u0DD7\u0DE0-\u0DE5\u0DF0\u0DF1\u0DF5-\u0E00\u0E3B-\u0E3E\u0E5C-\u0E80\u0E83\u0E85\u0E86\u0E89\u0E8B\u0E8C\u0E8E-\u0E93\u0E98\u0EA0\u0EA4\u0EA6\u0EA8\u0EA9\u0EAC\u0EBA\u0EBE\u0EBF\u0EC5\u0EC7\u0ECE\u0ECF\u0EDA\u0EDB\u0EE0-\u0EFF\u0F48\u0F6D-\u0F70\u0F98\u0FBD\u0FCD\u0FDB-\u0FFF\u10C6\u10C8-\u10CC\u10CE\u10CF\u1249\u124E\u124F\u1257\u1259\u125E\u125F\u1289\u128E\u128F\u12B1\u12B6\u12B7\u12BF\u12C1\u12C6\u12C7\u12D7\u1311\u1316\u1317\u135B\u135C\u137D-\u137F\u139A-\u139F\u13F6\u13F7\u13FE\u13FF\u169D-\u169F\u16F9-\u16FF\u170D\u1715-\u171F\u1737-\u173F\u1754-\u175F\u176D\u1771\u1774-\u177F\u17DE\u17DF\u17EA-\u17EF\u17FA-\u17FF\u180E\u180F\u181A-\u181F\u1878-\u187F\u18AB-\u18AF\u18F6-\u18FF\u191F\u192C-\u192F\u193C-\u193F\u1941-\u1943\u196E\u196F\u1975-\u197F\u19AC-\u19AF\u19CA-\u19CF\u19DB-\u19DD\u1A1C\u1A1D\u1A5F\u1A7D\u1A7E\u1A8A-\u1A8F\u1A9A-\u1A9F\u1AAE\u1AAF\u1ABF-\u1AFF\u1B4C-\u1B4F\u1B7D-\u1B7F\u1BF4-\u1BFB\u1C38-\u1C3A\u1C4A-\u1C4C\u1C80-\u1CBF\u1CC8-\u1CCF\u1CF7\u1CFA-\u1CFF\u1DF6-\u1DFB\u1F16\u1F17\u1F1E\u1F1F\u1F46\u1F47\u1F4E\u1F4F\u1F58\u1F5A\u1F5C\u1F5E\u1F7E\u1F7F\u1FB5\u1FC5\u1FD4\u1FD5\u1FDC\u1FF0\u1FF1\u1FF5\u1FFF\u200B-\u200F\u202A-\u202E\u2060-\u206F\u2072\u2073\u208F\u209D-\u209F\u20BF-\u20CF\u20F1-\u20FF\u218C-\u218F\u23FB-\u23FF\u2427-\u243F\u244B-\u245F\u2B74\u2B75\u2B96\u2B97\u2BBA-\u2BBC\u2BC9\u2BD2-\u2BEB\u2BF0-\u2BFF\u2C2F\u2C5F\u2CF4-\u2CF8\u2D26\u2D28-\u2D2C\u2D2E\u2D2F\u2D68-\u2D6E\u2D71-\u2D7E\u2D97-\u2D9F\u2DA7\u2DAF\u2DB7\u2DBF\u2DC7\u2DCF\u2DD7\u2DDF\u2E43-\u2E7F\u2E9A\u2EF4-\u2EFF\u2FD6-\u2FEF\u2FFC-\u2FFF\u3040\u3097\u3098\u3100-\u3104\u312E-\u3130\u318F\u31BB-\u31BF\u31E4-\u31EF\u321F\u32FF\u4DB6-\u4DBF\u9FD6-\u9FFF\uA48D-\uA48F\uA4C7-\uA4CF\uA62C-\uA63F\uA6F8-\uA6FF\uA7AE\uA7AF\uA7B8-\uA7F6\uA82C-\uA82F\uA83A-\uA83F\uA878-\uA87F\uA8C5-\uA8CD\uA8DA-\uA8DF\uA8FE\uA8FF\uA954-\uA95E\uA97D-\uA97F\uA9CE\uA9DA-\uA9DD\uA9FF\uAA37-\uAA3F\uAA4E\uAA4F\uAA5A\uAA5B\uAAC3-\uAADA\uAAF7-\uAB00\uAB07\uAB08\uAB0F\uAB10\uAB17-\uAB1F\uAB27\uAB2F\uAB66-\uAB6F\uABEE\uABEF\uABFA-\uABFF\uD7A4-\uD7AF\uD7C7-\uD7CA\uD7FC-\uF8FF\uFA6E\uFA6F\uFADA-\uFAFF\uFB07-\uFB12\uFB18-\uFB1C\uFB37\uFB3D\uFB3F\uFB42\uFB45\uFBC2-\uFBD2\uFD40-\uFD4F\uFD90\uFD91\uFDC8-\uFDEF\uFDFE\uFDFF\uFE1A-\uFE1F\uFE53\uFE67\uFE6C-\uFE6F\uFE75\uFEFD-\uFF00\uFFBF-\uFFC1\uFFC8\uFFC9\uFFD0\uFFD1\uFFD8\uFFD9\uFFDD-\uFFDF\uFFE7\uFFEF-\uFFFB\uFFFE\uFFFF',
	            astral: '\uD834[\uDCF6-\uDCFF\uDD27\uDD28\uDD73-\uDD7A\uDDE9-\uDDFF\uDE46-\uDEFF\uDF57-\uDF5F\uDF72-\uDFFF]|\uD836[\uDE8C-\uDE9A\uDEA0\uDEB0-\uDFFF]|\uD83C[\uDC2C-\uDC2F\uDC94-\uDC9F\uDCAF\uDCB0\uDCC0\uDCD0\uDCF6-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD6F\uDD9B-\uDDE5\uDE03-\uDE0F\uDE3B-\uDE3F\uDE49-\uDE4F\uDE52-\uDEFF]|\uD81A[\uDE39-\uDE3F\uDE5F\uDE6A-\uDE6D\uDE70-\uDECF\uDEEE\uDEEF\uDEF6-\uDEFF\uDF46-\uDF4F\uDF5A\uDF62\uDF78-\uDF7C\uDF90-\uDFFF]|\uD809[\uDC6F\uDC75-\uDC7F\uDD44-\uDFFF]|\uD81B[\uDC00-\uDEFF\uDF45-\uDF4F\uDF7F-\uDF8E\uDFA0-\uDFFF]|\uD86E[\uDC1E\uDC1F]|\uD83D[\uDD7A\uDDA4\uDED1-\uDEDF\uDEED-\uDEEF\uDEF4-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD801[\uDC9E\uDC9F\uDCAA-\uDCFF\uDD28-\uDD2F\uDD64-\uDD6E\uDD70-\uDDFF\uDF37-\uDF3F\uDF56-\uDF5F\uDF68-\uDFFF]|\uD800[\uDC0C\uDC27\uDC3B\uDC3E\uDC4E\uDC4F\uDC5E-\uDC7F\uDCFB-\uDCFF\uDD03-\uDD06\uDD34-\uDD36\uDD8D-\uDD8F\uDD9C-\uDD9F\uDDA1-\uDDCF\uDDFE-\uDE7F\uDE9D-\uDE9F\uDED1-\uDEDF\uDEFC-\uDEFF\uDF24-\uDF2F\uDF4B-\uDF4F\uDF7B-\uDF7F\uDF9E\uDFC4-\uDFC7\uDFD6-\uDFFF]|\uD869[\uDED7-\uDEFF]|\uD83B[\uDC00-\uDDFF\uDE04\uDE20\uDE23\uDE25\uDE26\uDE28\uDE33\uDE38\uDE3A\uDE3C-\uDE41\uDE43-\uDE46\uDE48\uDE4A\uDE4C\uDE50\uDE53\uDE55\uDE56\uDE58\uDE5A\uDE5C\uDE5E\uDE60\uDE63\uDE65\uDE66\uDE6B\uDE73\uDE78\uDE7D\uDE7F\uDE8A\uDE9C-\uDEA0\uDEA4\uDEAA\uDEBC-\uDEEF\uDEF2-\uDFFF]|\uD87E[\uDE1E-\uDFFF]|\uDB40[\uDC00-\uDCFF\uDDF0-\uDFFF]|\uD804[\uDC4E-\uDC51\uDC70-\uDC7E\uDCBD\uDCC2-\uDCCF\uDCE9-\uDCEF\uDCFA-\uDCFF\uDD35\uDD44-\uDD4F\uDD77-\uDD7F\uDDCE\uDDCF\uDDE0\uDDF5-\uDDFF\uDE12\uDE3E-\uDE7F\uDE87\uDE89\uDE8E\uDE9E\uDEAA-\uDEAF\uDEEB-\uDEEF\uDEFA-\uDEFF\uDF04\uDF0D\uDF0E\uDF11\uDF12\uDF29\uDF31\uDF34\uDF3A\uDF3B\uDF45\uDF46\uDF49\uDF4A\uDF4E\uDF4F\uDF51-\uDF56\uDF58-\uDF5C\uDF64\uDF65\uDF6D-\uDF6F\uDF75-\uDFFF]|\uD83A[\uDCC5\uDCC6\uDCD7-\uDFFF]|\uD80D[\uDC2F-\uDFFF]|\uD86D[\uDF35-\uDF3F]|[\uD807\uD80A\uD80B\uD80E-\uD810\uD812-\uD819\uD81C-\uD82B\uD82D\uD82E\uD830-\uD833\uD837-\uD839\uD83F\uD874-\uD87D\uD87F-\uDB3F\uDB41-\uDBFF][\uDC00-\uDFFF]|\uD806[\uDC00-\uDC9F\uDCF3-\uDCFE\uDD00-\uDEBF\uDEF9-\uDFFF]|\uD803[\uDC49-\uDC7F\uDCB3-\uDCBF\uDCF3-\uDCF9\uDD00-\uDE5F\uDE7F-\uDFFF]|\uD835[\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]|\uD805[\uDC00-\uDC7F\uDCC8-\uDCCF\uDCDA-\uDD7F\uDDB6\uDDB7\uDDDE-\uDDFF\uDE45-\uDE4F\uDE5A-\uDE7F\uDEB8-\uDEBF\uDECA-\uDEFF\uDF1A-\uDF1C\uDF2C-\uDF2F\uDF40-\uDFFF]|\uD802[\uDC06\uDC07\uDC09\uDC36\uDC39-\uDC3B\uDC3D\uDC3E\uDC56\uDC9F-\uDCA6\uDCB0-\uDCDF\uDCF3\uDCF6-\uDCFA\uDD1C-\uDD1E\uDD3A-\uDD3E\uDD40-\uDD7F\uDDB8-\uDDBB\uDDD0\uDDD1\uDE04\uDE07-\uDE0B\uDE14\uDE18\uDE34-\uDE37\uDE3B-\uDE3E\uDE48-\uDE4F\uDE59-\uDE5F\uDEA0-\uDEBF\uDEE7-\uDEEA\uDEF7-\uDEFF\uDF36-\uDF38\uDF56\uDF57\uDF73-\uDF77\uDF92-\uDF98\uDF9D-\uDFA8\uDFB0-\uDFFF]|\uD808[\uDF9A-\uDFFF]|\uD82F[\uDC6B-\uDC6F\uDC7D-\uDC7F\uDC89-\uDC8F\uDC9A\uDC9B\uDCA0-\uDFFF]|\uD82C[\uDC02-\uDFFF]|\uD811[\uDE47-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDD0F\uDD19-\uDD7F\uDD85-\uDDBF\uDDC1-\uDFFF]|\uD873[\uDEA2-\uDFFF]'
	        },
	        {
	            name: 'Cc',
	            alias: 'Control',
	            bmp: '\0-\x1F\x7F-\x9F'
	        },
	        {
	            name: 'Cf',
	            alias: 'Format',
	            bmp: '\xAD\u0600-\u0605\u061C\u06DD\u070F\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB',
	            astral: '\uDB40[\uDC01\uDC20-\uDC7F]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uD804\uDCBD'
	        },
	        {
	            name: 'Cn',
	            alias: 'Unassigned',
	            bmp: '\u0378\u0379\u0380-\u0383\u038B\u038D\u03A2\u0530\u0557\u0558\u0560\u0588\u058B\u058C\u0590\u05C8-\u05CF\u05EB-\u05EF\u05F5-\u05FF\u061D\u070E\u074B\u074C\u07B2-\u07BF\u07FB-\u07FF\u082E\u082F\u083F\u085C\u085D\u085F-\u089F\u08B5-\u08E2\u0984\u098D\u098E\u0991\u0992\u09A9\u09B1\u09B3-\u09B5\u09BA\u09BB\u09C5\u09C6\u09C9\u09CA\u09CF-\u09D6\u09D8-\u09DB\u09DE\u09E4\u09E5\u09FC-\u0A00\u0A04\u0A0B-\u0A0E\u0A11\u0A12\u0A29\u0A31\u0A34\u0A37\u0A3A\u0A3B\u0A3D\u0A43-\u0A46\u0A49\u0A4A\u0A4E-\u0A50\u0A52-\u0A58\u0A5D\u0A5F-\u0A65\u0A76-\u0A80\u0A84\u0A8E\u0A92\u0AA9\u0AB1\u0AB4\u0ABA\u0ABB\u0AC6\u0ACA\u0ACE\u0ACF\u0AD1-\u0ADF\u0AE4\u0AE5\u0AF2-\u0AF8\u0AFA-\u0B00\u0B04\u0B0D\u0B0E\u0B11\u0B12\u0B29\u0B31\u0B34\u0B3A\u0B3B\u0B45\u0B46\u0B49\u0B4A\u0B4E-\u0B55\u0B58-\u0B5B\u0B5E\u0B64\u0B65\u0B78-\u0B81\u0B84\u0B8B-\u0B8D\u0B91\u0B96-\u0B98\u0B9B\u0B9D\u0BA0-\u0BA2\u0BA5-\u0BA7\u0BAB-\u0BAD\u0BBA-\u0BBD\u0BC3-\u0BC5\u0BC9\u0BCE\u0BCF\u0BD1-\u0BD6\u0BD8-\u0BE5\u0BFB-\u0BFF\u0C04\u0C0D\u0C11\u0C29\u0C3A-\u0C3C\u0C45\u0C49\u0C4E-\u0C54\u0C57\u0C5B-\u0C5F\u0C64\u0C65\u0C70-\u0C77\u0C80\u0C84\u0C8D\u0C91\u0CA9\u0CB4\u0CBA\u0CBB\u0CC5\u0CC9\u0CCE-\u0CD4\u0CD7-\u0CDD\u0CDF\u0CE4\u0CE5\u0CF0\u0CF3-\u0D00\u0D04\u0D0D\u0D11\u0D3B\u0D3C\u0D45\u0D49\u0D4F-\u0D56\u0D58-\u0D5E\u0D64\u0D65\u0D76-\u0D78\u0D80\u0D81\u0D84\u0D97-\u0D99\u0DB2\u0DBC\u0DBE\u0DBF\u0DC7-\u0DC9\u0DCB-\u0DCE\u0DD5\u0DD7\u0DE0-\u0DE5\u0DF0\u0DF1\u0DF5-\u0E00\u0E3B-\u0E3E\u0E5C-\u0E80\u0E83\u0E85\u0E86\u0E89\u0E8B\u0E8C\u0E8E-\u0E93\u0E98\u0EA0\u0EA4\u0EA6\u0EA8\u0EA9\u0EAC\u0EBA\u0EBE\u0EBF\u0EC5\u0EC7\u0ECE\u0ECF\u0EDA\u0EDB\u0EE0-\u0EFF\u0F48\u0F6D-\u0F70\u0F98\u0FBD\u0FCD\u0FDB-\u0FFF\u10C6\u10C8-\u10CC\u10CE\u10CF\u1249\u124E\u124F\u1257\u1259\u125E\u125F\u1289\u128E\u128F\u12B1\u12B6\u12B7\u12BF\u12C1\u12C6\u12C7\u12D7\u1311\u1316\u1317\u135B\u135C\u137D-\u137F\u139A-\u139F\u13F6\u13F7\u13FE\u13FF\u169D-\u169F\u16F9-\u16FF\u170D\u1715-\u171F\u1737-\u173F\u1754-\u175F\u176D\u1771\u1774-\u177F\u17DE\u17DF\u17EA-\u17EF\u17FA-\u17FF\u180F\u181A-\u181F\u1878-\u187F\u18AB-\u18AF\u18F6-\u18FF\u191F\u192C-\u192F\u193C-\u193F\u1941-\u1943\u196E\u196F\u1975-\u197F\u19AC-\u19AF\u19CA-\u19CF\u19DB-\u19DD\u1A1C\u1A1D\u1A5F\u1A7D\u1A7E\u1A8A-\u1A8F\u1A9A-\u1A9F\u1AAE\u1AAF\u1ABF-\u1AFF\u1B4C-\u1B4F\u1B7D-\u1B7F\u1BF4-\u1BFB\u1C38-\u1C3A\u1C4A-\u1C4C\u1C80-\u1CBF\u1CC8-\u1CCF\u1CF7\u1CFA-\u1CFF\u1DF6-\u1DFB\u1F16\u1F17\u1F1E\u1F1F\u1F46\u1F47\u1F4E\u1F4F\u1F58\u1F5A\u1F5C\u1F5E\u1F7E\u1F7F\u1FB5\u1FC5\u1FD4\u1FD5\u1FDC\u1FF0\u1FF1\u1FF5\u1FFF\u2065\u2072\u2073\u208F\u209D-\u209F\u20BF-\u20CF\u20F1-\u20FF\u218C-\u218F\u23FB-\u23FF\u2427-\u243F\u244B-\u245F\u2B74\u2B75\u2B96\u2B97\u2BBA-\u2BBC\u2BC9\u2BD2-\u2BEB\u2BF0-\u2BFF\u2C2F\u2C5F\u2CF4-\u2CF8\u2D26\u2D28-\u2D2C\u2D2E\u2D2F\u2D68-\u2D6E\u2D71-\u2D7E\u2D97-\u2D9F\u2DA7\u2DAF\u2DB7\u2DBF\u2DC7\u2DCF\u2DD7\u2DDF\u2E43-\u2E7F\u2E9A\u2EF4-\u2EFF\u2FD6-\u2FEF\u2FFC-\u2FFF\u3040\u3097\u3098\u3100-\u3104\u312E-\u3130\u318F\u31BB-\u31BF\u31E4-\u31EF\u321F\u32FF\u4DB6-\u4DBF\u9FD6-\u9FFF\uA48D-\uA48F\uA4C7-\uA4CF\uA62C-\uA63F\uA6F8-\uA6FF\uA7AE\uA7AF\uA7B8-\uA7F6\uA82C-\uA82F\uA83A-\uA83F\uA878-\uA87F\uA8C5-\uA8CD\uA8DA-\uA8DF\uA8FE\uA8FF\uA954-\uA95E\uA97D-\uA97F\uA9CE\uA9DA-\uA9DD\uA9FF\uAA37-\uAA3F\uAA4E\uAA4F\uAA5A\uAA5B\uAAC3-\uAADA\uAAF7-\uAB00\uAB07\uAB08\uAB0F\uAB10\uAB17-\uAB1F\uAB27\uAB2F\uAB66-\uAB6F\uABEE\uABEF\uABFA-\uABFF\uD7A4-\uD7AF\uD7C7-\uD7CA\uD7FC-\uD7FF\uFA6E\uFA6F\uFADA-\uFAFF\uFB07-\uFB12\uFB18-\uFB1C\uFB37\uFB3D\uFB3F\uFB42\uFB45\uFBC2-\uFBD2\uFD40-\uFD4F\uFD90\uFD91\uFDC8-\uFDEF\uFDFE\uFDFF\uFE1A-\uFE1F\uFE53\uFE67\uFE6C-\uFE6F\uFE75\uFEFD\uFEFE\uFF00\uFFBF-\uFFC1\uFFC8\uFFC9\uFFD0\uFFD1\uFFD8\uFFD9\uFFDD-\uFFDF\uFFE7\uFFEF-\uFFF8\uFFFE\uFFFF',
	            astral: '\uDB40[\uDC00\uDC02-\uDC1F\uDC80-\uDCFF\uDDF0-\uDFFF]|\uD834[\uDCF6-\uDCFF\uDD27\uDD28\uDDE9-\uDDFF\uDE46-\uDEFF\uDF57-\uDF5F\uDF72-\uDFFF]|\uD83C[\uDC2C-\uDC2F\uDC94-\uDC9F\uDCAF\uDCB0\uDCC0\uDCD0\uDCF6-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD6F\uDD9B-\uDDE5\uDE03-\uDE0F\uDE3B-\uDE3F\uDE49-\uDE4F\uDE52-\uDEFF]|\uD81A[\uDE39-\uDE3F\uDE5F\uDE6A-\uDE6D\uDE70-\uDECF\uDEEE\uDEEF\uDEF6-\uDEFF\uDF46-\uDF4F\uDF5A\uDF62\uDF78-\uDF7C\uDF90-\uDFFF]|\uD809[\uDC6F\uDC75-\uDC7F\uDD44-\uDFFF]|\uD81B[\uDC00-\uDEFF\uDF45-\uDF4F\uDF7F-\uDF8E\uDFA0-\uDFFF]|\uD86E[\uDC1E\uDC1F]|\uD83D[\uDD7A\uDDA4\uDED1-\uDEDF\uDEED-\uDEEF\uDEF4-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD801[\uDC9E\uDC9F\uDCAA-\uDCFF\uDD28-\uDD2F\uDD64-\uDD6E\uDD70-\uDDFF\uDF37-\uDF3F\uDF56-\uDF5F\uDF68-\uDFFF]|\uD800[\uDC0C\uDC27\uDC3B\uDC3E\uDC4E\uDC4F\uDC5E-\uDC7F\uDCFB-\uDCFF\uDD03-\uDD06\uDD34-\uDD36\uDD8D-\uDD8F\uDD9C-\uDD9F\uDDA1-\uDDCF\uDDFE-\uDE7F\uDE9D-\uDE9F\uDED1-\uDEDF\uDEFC-\uDEFF\uDF24-\uDF2F\uDF4B-\uDF4F\uDF7B-\uDF7F\uDF9E\uDFC4-\uDFC7\uDFD6-\uDFFF]|\uD869[\uDED7-\uDEFF]|\uD83B[\uDC00-\uDDFF\uDE04\uDE20\uDE23\uDE25\uDE26\uDE28\uDE33\uDE38\uDE3A\uDE3C-\uDE41\uDE43-\uDE46\uDE48\uDE4A\uDE4C\uDE50\uDE53\uDE55\uDE56\uDE58\uDE5A\uDE5C\uDE5E\uDE60\uDE63\uDE65\uDE66\uDE6B\uDE73\uDE78\uDE7D\uDE7F\uDE8A\uDE9C-\uDEA0\uDEA4\uDEAA\uDEBC-\uDEEF\uDEF2-\uDFFF]|[\uDBBF\uDBFF][\uDFFE\uDFFF]|\uD87E[\uDE1E-\uDFFF]|\uD82F[\uDC6B-\uDC6F\uDC7D-\uDC7F\uDC89-\uDC8F\uDC9A\uDC9B\uDCA4-\uDFFF]|\uD83A[\uDCC5\uDCC6\uDCD7-\uDFFF]|\uD80D[\uDC2F-\uDFFF]|\uD86D[\uDF35-\uDF3F]|[\uD807\uD80A\uD80B\uD80E-\uD810\uD812-\uD819\uD81C-\uD82B\uD82D\uD82E\uD830-\uD833\uD837-\uD839\uD83F\uD874-\uD87D\uD87F-\uDB3F\uDB41-\uDB7F][\uDC00-\uDFFF]|\uD806[\uDC00-\uDC9F\uDCF3-\uDCFE\uDD00-\uDEBF\uDEF9-\uDFFF]|\uD803[\uDC49-\uDC7F\uDCB3-\uDCBF\uDCF3-\uDCF9\uDD00-\uDE5F\uDE7F-\uDFFF]|\uD835[\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]|\uD836[\uDE8C-\uDE9A\uDEA0\uDEB0-\uDFFF]|\uD805[\uDC00-\uDC7F\uDCC8-\uDCCF\uDCDA-\uDD7F\uDDB6\uDDB7\uDDDE-\uDDFF\uDE45-\uDE4F\uDE5A-\uDE7F\uDEB8-\uDEBF\uDECA-\uDEFF\uDF1A-\uDF1C\uDF2C-\uDF2F\uDF40-\uDFFF]|\uD802[\uDC06\uDC07\uDC09\uDC36\uDC39-\uDC3B\uDC3D\uDC3E\uDC56\uDC9F-\uDCA6\uDCB0-\uDCDF\uDCF3\uDCF6-\uDCFA\uDD1C-\uDD1E\uDD3A-\uDD3E\uDD40-\uDD7F\uDDB8-\uDDBB\uDDD0\uDDD1\uDE04\uDE07-\uDE0B\uDE14\uDE18\uDE34-\uDE37\uDE3B-\uDE3E\uDE48-\uDE4F\uDE59-\uDE5F\uDEA0-\uDEBF\uDEE7-\uDEEA\uDEF7-\uDEFF\uDF36-\uDF38\uDF56\uDF57\uDF73-\uDF77\uDF92-\uDF98\uDF9D-\uDFA8\uDFB0-\uDFFF]|\uD808[\uDF9A-\uDFFF]|\uD804[\uDC4E-\uDC51\uDC70-\uDC7E\uDCC2-\uDCCF\uDCE9-\uDCEF\uDCFA-\uDCFF\uDD35\uDD44-\uDD4F\uDD77-\uDD7F\uDDCE\uDDCF\uDDE0\uDDF5-\uDDFF\uDE12\uDE3E-\uDE7F\uDE87\uDE89\uDE8E\uDE9E\uDEAA-\uDEAF\uDEEB-\uDEEF\uDEFA-\uDEFF\uDF04\uDF0D\uDF0E\uDF11\uDF12\uDF29\uDF31\uDF34\uDF3A\uDF3B\uDF45\uDF46\uDF49\uDF4A\uDF4E\uDF4F\uDF51-\uDF56\uDF58-\uDF5C\uDF64\uDF65\uDF6D-\uDF6F\uDF75-\uDFFF]|\uD82C[\uDC02-\uDFFF]|\uD811[\uDE47-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDD0F\uDD19-\uDD7F\uDD85-\uDDBF\uDDC1-\uDFFF]|\uD873[\uDEA2-\uDFFF]'
	        },
	        {
	            name: 'Co',
	            alias: 'Private_Use',
	            bmp: '\uE000-\uF8FF',
	            astral: '[\uDB80-\uDBBE\uDBC0-\uDBFE][\uDC00-\uDFFF]|[\uDBBF\uDBFF][\uDC00-\uDFFD]'
	        },
	        {
	            name: 'Cs',
	            alias: 'Surrogate',
	            bmp: '\uD800-\uDFFF'
	        },
	        {
	            name: 'L',
	            alias: 'Letter',
	            bmp: 'A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC',
	            astral: '\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD83A[\uDC00-\uDCC4]|\uD801[\uDC00-\uDC9D\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD80D[\uDC00-\uDC2E]|\uD87E[\uDC00-\uDE1D]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F]|[\uD80C\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD805[\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD809[\uDC80-\uDD43]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD808[\uDC00-\uDF99]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD811[\uDC00-\uDE46]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD82C[\uDC00\uDC01]|\uD873[\uDC00-\uDEA1]'
	        },
	        {
	            name: 'Ll',
	            alias: 'Lowercase_Letter',
	            bmp: 'a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7FA\uAB30-\uAB5A\uAB60-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A',
	            astral: '\uD803[\uDCC0-\uDCF2]|\uD835[\uDC1A-\uDC33\uDC4E-\uDC54\uDC56-\uDC67\uDC82-\uDC9B\uDCB6-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDCEA-\uDD03\uDD1E-\uDD37\uDD52-\uDD6B\uDD86-\uDD9F\uDDBA-\uDDD3\uDDEE-\uDE07\uDE22-\uDE3B\uDE56-\uDE6F\uDE8A-\uDEA5\uDEC2-\uDEDA\uDEDC-\uDEE1\uDEFC-\uDF14\uDF16-\uDF1B\uDF36-\uDF4E\uDF50-\uDF55\uDF70-\uDF88\uDF8A-\uDF8F\uDFAA-\uDFC2\uDFC4-\uDFC9\uDFCB]|\uD801[\uDC28-\uDC4F]|\uD806[\uDCC0-\uDCDF]'
	        },
	        {
	            name: 'Lm',
	            alias: 'Modifier_Letter',
	            bmp: '\u02B0-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0374\u037A\u0559\u0640\u06E5\u06E6\u07F4\u07F5\u07FA\u081A\u0824\u0828\u0971\u0E46\u0EC6\u10FC\u17D7\u1843\u1AA7\u1C78-\u1C7D\u1D2C-\u1D6A\u1D78\u1D9B-\u1DBF\u2071\u207F\u2090-\u209C\u2C7C\u2C7D\u2D6F\u2E2F\u3005\u3031-\u3035\u303B\u309D\u309E\u30FC-\u30FE\uA015\uA4F8-\uA4FD\uA60C\uA67F\uA69C\uA69D\uA717-\uA71F\uA770\uA788\uA7F8\uA7F9\uA9CF\uA9E6\uAA70\uAADD\uAAF3\uAAF4\uAB5C-\uAB5F\uFF70\uFF9E\uFF9F',
	            astral: '\uD81A[\uDF40-\uDF43]|\uD81B[\uDF93-\uDF9F]'
	        },
	        {
	            name: 'Lo',
	            alias: 'Other_Letter',
	            bmp: '\xAA\xBA\u01BB\u01C0-\u01C3\u0294\u05D0-\u05EA\u05F0-\u05F2\u0620-\u063F\u0641-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u0800-\u0815\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0972-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E45\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10D0-\u10FA\u10FD-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17DC\u1820-\u1842\u1844-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C77\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u2135-\u2138\u2D30-\u2D67\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3006\u303C\u3041-\u3096\u309F\u30A1-\u30FA\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA014\uA016-\uA48C\uA4D0-\uA4F7\uA500-\uA60B\uA610-\uA61F\uA62A\uA62B\uA66E\uA6A0-\uA6E5\uA78F\uA7F7\uA7FB-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9E0-\uA9E4\uA9E7-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA6F\uAA71-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB\uAADC\uAAE0-\uAAEA\uAAF2\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF66-\uFF6F\uFF71-\uFF9D\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC',
	            astral: '\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD83A[\uDC00-\uDCC4]|\uD803[\uDC00-\uDC48]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD80D[\uDC00-\uDC2E]|\uD87E[\uDC00-\uDE1D]|\uD81B[\uDF00-\uDF44\uDF50]|[\uD80C\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD805[\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCFF\uDEC0-\uDEF8]|\uD809[\uDC80-\uDD43]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD808[\uDC00-\uDF99]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF63-\uDF77\uDF7D-\uDF8F]|\uD801[\uDC50-\uDC9D\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD811[\uDC00-\uDE46]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD82C[\uDC00\uDC01]|\uD873[\uDC00-\uDEA1]'
	        },
	        {
	            name: 'Lt',
	            alias: 'Titlecase_Letter',
	            bmp: '\u01C5\u01C8\u01CB\u01F2\u1F88-\u1F8F\u1F98-\u1F9F\u1FA8-\u1FAF\u1FBC\u1FCC\u1FFC'
	        },
	        {
	            name: 'Lu',
	            alias: 'Uppercase_Letter',
	            bmp: 'A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A',
	            astral: '\uD806[\uDCA0-\uDCBF]|\uD803[\uDC80-\uDCB2]|\uD801[\uDC00-\uDC27]|\uD835[\uDC00-\uDC19\uDC34-\uDC4D\uDC68-\uDC81\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB5\uDCD0-\uDCE9\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD38\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD6C-\uDD85\uDDA0-\uDDB9\uDDD4-\uDDED\uDE08-\uDE21\uDE3C-\uDE55\uDE70-\uDE89\uDEA8-\uDEC0\uDEE2-\uDEFA\uDF1C-\uDF34\uDF56-\uDF6E\uDF90-\uDFA8\uDFCA]'
	        },
	        {
	            name: 'M',
	            alias: 'Mark',
	            bmp: '\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C03\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D01-\u0D03\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u18A9\u1920-\u192B\u1930-\u193B\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1AB0-\u1ABE\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF2-\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF5\u1DFC-\u1DFF\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA880\uA881\uA8B4-\uA8C4\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F',
	            astral: '\uD805[\uDCB0-\uDCC3\uDDAF-\uDDB5\uDDB8-\uDDC0\uDDDC\uDDDD\uDE30-\uDE40\uDEAB-\uDEB7\uDF1D-\uDF2B]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD804[\uDC00-\uDC02\uDC38-\uDC46\uDC7F-\uDC82\uDCB0-\uDCBA\uDD00-\uDD02\uDD27-\uDD34\uDD73\uDD80-\uDD82\uDDB3-\uDDC0\uDDCA-\uDDCC\uDE2C-\uDE37\uDEDF-\uDEEA\uDF00-\uDF03\uDF3C\uDF3E-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF62\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD81B[\uDF51-\uDF7E\uDF8F-\uDF92]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD82F[\uDC9D\uDC9E]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD83A[\uDCD0-\uDCD6]|\uDB40[\uDD00-\uDDEF]'
	        },
	        {
	            name: 'Mc',
	            alias: 'Spacing_Mark',
	            bmp: '\u0903\u093B\u093E-\u0940\u0949-\u094C\u094E\u094F\u0982\u0983\u09BE-\u09C0\u09C7\u09C8\u09CB\u09CC\u09D7\u0A03\u0A3E-\u0A40\u0A83\u0ABE-\u0AC0\u0AC9\u0ACB\u0ACC\u0B02\u0B03\u0B3E\u0B40\u0B47\u0B48\u0B4B\u0B4C\u0B57\u0BBE\u0BBF\u0BC1\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD7\u0C01-\u0C03\u0C41-\u0C44\u0C82\u0C83\u0CBE\u0CC0-\u0CC4\u0CC7\u0CC8\u0CCA\u0CCB\u0CD5\u0CD6\u0D02\u0D03\u0D3E-\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D57\u0D82\u0D83\u0DCF-\u0DD1\u0DD8-\u0DDF\u0DF2\u0DF3\u0F3E\u0F3F\u0F7F\u102B\u102C\u1031\u1038\u103B\u103C\u1056\u1057\u1062-\u1064\u1067-\u106D\u1083\u1084\u1087-\u108C\u108F\u109A-\u109C\u17B6\u17BE-\u17C5\u17C7\u17C8\u1923-\u1926\u1929-\u192B\u1930\u1931\u1933-\u1938\u1A19\u1A1A\u1A55\u1A57\u1A61\u1A63\u1A64\u1A6D-\u1A72\u1B04\u1B35\u1B3B\u1B3D-\u1B41\u1B43\u1B44\u1B82\u1BA1\u1BA6\u1BA7\u1BAA\u1BE7\u1BEA-\u1BEC\u1BEE\u1BF2\u1BF3\u1C24-\u1C2B\u1C34\u1C35\u1CE1\u1CF2\u1CF3\u302E\u302F\uA823\uA824\uA827\uA880\uA881\uA8B4-\uA8C3\uA952\uA953\uA983\uA9B4\uA9B5\uA9BA\uA9BB\uA9BD-\uA9C0\uAA2F\uAA30\uAA33\uAA34\uAA4D\uAA7B\uAA7D\uAAEB\uAAEE\uAAEF\uAAF5\uABE3\uABE4\uABE6\uABE7\uABE9\uABEA\uABEC',
	            astral: '\uD834[\uDD65\uDD66\uDD6D-\uDD72]|\uD804[\uDC00\uDC02\uDC82\uDCB0-\uDCB2\uDCB7\uDCB8\uDD2C\uDD82\uDDB3-\uDDB5\uDDBF\uDDC0\uDE2C-\uDE2E\uDE32\uDE33\uDE35\uDEE0-\uDEE2\uDF02\uDF03\uDF3E\uDF3F\uDF41-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF62\uDF63]|\uD805[\uDCB0-\uDCB2\uDCB9\uDCBB-\uDCBE\uDCC1\uDDAF-\uDDB1\uDDB8-\uDDBB\uDDBE\uDE30-\uDE32\uDE3B\uDE3C\uDE3E\uDEAC\uDEAE\uDEAF\uDEB6\uDF20\uDF21\uDF26]|\uD81B[\uDF51-\uDF7E]'
	        },
	        {
	            name: 'Me',
	            alias: 'Enclosing_Mark',
	            bmp: '\u0488\u0489\u1ABE\u20DD-\u20E0\u20E2-\u20E4\uA670-\uA672'
	        },
	        {
	            name: 'Mn',
	            alias: 'Nonspacing_Mark',
	            bmp: '\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C00\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D01\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF5\u1DFC-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F',
	            astral: '\uD805[\uDCB3-\uDCB8\uDCBA\uDCBF\uDCC0\uDCC2\uDCC3\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD834[\uDD67-\uDD69\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF8F-\uDF92]|\uD82F[\uDC9D\uDC9E]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDCA-\uDDCC\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3C\uDF40\uDF66-\uDF6C\uDF70-\uDF74]|\uD83A[\uDCD0-\uDCD6]|\uDB40[\uDD00-\uDDEF]'
	        },
	        {
	            name: 'N',
	            alias: 'Number',
	            bmp: '0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19',
	            astral: '\uD800[\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDEE1-\uDEFB\uDF20-\uDF23\uDF41\uDF4A\uDFD1-\uDFD5]|\uD801[\uDCA0-\uDCA9]|\uD803[\uDCFA-\uDCFF\uDE60-\uDE7E]|\uD835[\uDFCE-\uDFFF]|\uD83A[\uDCC7-\uDCCF]|\uD81A[\uDE60-\uDE69\uDF50-\uDF59\uDF5B-\uDF61]|\uD806[\uDCE0-\uDCF2]|\uD804[\uDC52-\uDC6F\uDCF0-\uDCF9\uDD36-\uDD3F\uDDD0-\uDDD9\uDDE1-\uDDF4\uDEF0-\uDEF9]|\uD834[\uDF60-\uDF71]|\uD83C[\uDD00-\uDD0C]|\uD809[\uDC00-\uDC6E]|\uD802[\uDC58-\uDC5F\uDC79-\uDC7F\uDCA7-\uDCAF\uDCFB-\uDCFF\uDD16-\uDD1B\uDDBC\uDDBD\uDDC0-\uDDCF\uDDD2-\uDDFF\uDE40-\uDE47\uDE7D\uDE7E\uDE9D-\uDE9F\uDEEB-\uDEEF\uDF58-\uDF5F\uDF78-\uDF7F\uDFA9-\uDFAF]|\uD805[\uDCD0-\uDCD9\uDE50-\uDE59\uDEC0-\uDEC9\uDF30-\uDF3B]'
	        },
	        {
	            name: 'Nd',
	            alias: 'Decimal_Number',
	            bmp: '0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19',
	            astral: '\uD801[\uDCA0-\uDCA9]|\uD835[\uDFCE-\uDFFF]|\uD805[\uDCD0-\uDCD9\uDE50-\uDE59\uDEC0-\uDEC9\uDF30-\uDF39]|\uD806[\uDCE0-\uDCE9]|\uD804[\uDC66-\uDC6F\uDCF0-\uDCF9\uDD36-\uDD3F\uDDD0-\uDDD9\uDEF0-\uDEF9]|\uD81A[\uDE60-\uDE69\uDF50-\uDF59]'
	        },
	        {
	            name: 'Nl',
	            alias: 'Letter_Number',
	            bmp: '\u16EE-\u16F0\u2160-\u2182\u2185-\u2188\u3007\u3021-\u3029\u3038-\u303A\uA6E6-\uA6EF',
	            astral: '\uD809[\uDC00-\uDC6E]|\uD800[\uDD40-\uDD74\uDF41\uDF4A\uDFD1-\uDFD5]'
	        },
	        {
	            name: 'No',
	            alias: 'Other_Number',
	            bmp: '\xB2\xB3\xB9\xBC-\xBE\u09F4-\u09F9\u0B72-\u0B77\u0BF0-\u0BF2\u0C78-\u0C7E\u0D70-\u0D75\u0F2A-\u0F33\u1369-\u137C\u17F0-\u17F9\u19DA\u2070\u2074-\u2079\u2080-\u2089\u2150-\u215F\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA830-\uA835',
	            astral: '\uD804[\uDC52-\uDC65\uDDE1-\uDDF4]|\uD803[\uDCFA-\uDCFF\uDE60-\uDE7E]|\uD83C[\uDD00-\uDD0C]|\uD806[\uDCEA-\uDCF2]|\uD83A[\uDCC7-\uDCCF]|\uD802[\uDC58-\uDC5F\uDC79-\uDC7F\uDCA7-\uDCAF\uDCFB-\uDCFF\uDD16-\uDD1B\uDDBC\uDDBD\uDDC0-\uDDCF\uDDD2-\uDDFF\uDE40-\uDE47\uDE7D\uDE7E\uDE9D-\uDE9F\uDEEB-\uDEEF\uDF58-\uDF5F\uDF78-\uDF7F\uDFA9-\uDFAF]|\uD805[\uDF3A\uDF3B]|\uD81A[\uDF5B-\uDF61]|\uD834[\uDF60-\uDF71]|\uD800[\uDD07-\uDD33\uDD75-\uDD78\uDD8A\uDD8B\uDEE1-\uDEFB\uDF20-\uDF23]'
	        },
	        {
	            name: 'P',
	            alias: 'Punctuation',
	            bmp: '\x21-\x23\x25-\\x2A\x2C-\x2F\x3A\x3B\\x3F\x40\\x5B-\\x5D\x5F\\x7B\x7D\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E42\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65',
	            astral: '\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD809[\uDC70-\uDC74]|\uD805[\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDF3C-\uDF3E]|\uD836[\uDE87-\uDE8B]|\uD801\uDD6F|\uD82F\uDC9F|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]'
	        },
	        {
	            name: 'Pc',
	            alias: 'Connector_Punctuation',
	            bmp: '\x5F\u203F\u2040\u2054\uFE33\uFE34\uFE4D-\uFE4F\uFF3F'
	        },
	        {
	            name: 'Pd',
	            alias: 'Dash_Punctuation',
	            bmp: '\\x2D\u058A\u05BE\u1400\u1806\u2010-\u2015\u2E17\u2E1A\u2E3A\u2E3B\u2E40\u301C\u3030\u30A0\uFE31\uFE32\uFE58\uFE63\uFF0D'
	        },
	        {
	            name: 'Pe',
	            alias: 'Close_Punctuation',
	            bmp: '\\x29\\x5D\x7D\u0F3B\u0F3D\u169C\u2046\u207E\u208E\u2309\u230B\u232A\u2769\u276B\u276D\u276F\u2771\u2773\u2775\u27C6\u27E7\u27E9\u27EB\u27ED\u27EF\u2984\u2986\u2988\u298A\u298C\u298E\u2990\u2992\u2994\u2996\u2998\u29D9\u29DB\u29FD\u2E23\u2E25\u2E27\u2E29\u3009\u300B\u300D\u300F\u3011\u3015\u3017\u3019\u301B\u301E\u301F\uFD3E\uFE18\uFE36\uFE38\uFE3A\uFE3C\uFE3E\uFE40\uFE42\uFE44\uFE48\uFE5A\uFE5C\uFE5E\uFF09\uFF3D\uFF5D\uFF60\uFF63'
	        },
	        {
	            name: 'Pf',
	            alias: 'Final_Punctuation',
	            bmp: '\xBB\u2019\u201D\u203A\u2E03\u2E05\u2E0A\u2E0D\u2E1D\u2E21'
	        },
	        {
	            name: 'Pi',
	            alias: 'Initial_Punctuation',
	            bmp: '\xAB\u2018\u201B\u201C\u201F\u2039\u2E02\u2E04\u2E09\u2E0C\u2E1C\u2E20'
	        },
	        {
	            name: 'Po',
	            alias: 'Other_Punctuation',
	            bmp: '\x21-\x23\x25-\x27\\x2A\x2C\\x2E\x2F\x3A\x3B\\x3F\x40\\x5C\xA1\xA7\xB6\xB7\xBF\u037E\u0387\u055A-\u055F\u0589\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u166D\u166E\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u1805\u1807-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2016\u2017\u2020-\u2027\u2030-\u2038\u203B-\u203E\u2041-\u2043\u2047-\u2051\u2053\u2055-\u205E\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00\u2E01\u2E06-\u2E08\u2E0B\u2E0E-\u2E16\u2E18\u2E19\u2E1B\u2E1E\u2E1F\u2E2A-\u2E2E\u2E30-\u2E39\u2E3C-\u2E3F\u2E41\u3001-\u3003\u303D\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFE10-\uFE16\uFE19\uFE30\uFE45\uFE46\uFE49-\uFE4C\uFE50-\uFE52\uFE54-\uFE57\uFE5F-\uFE61\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF07\uFF0A\uFF0C\uFF0E\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3C\uFF61\uFF64\uFF65',
	            astral: '\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD809[\uDC70-\uDC74]|\uD805[\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDF3C-\uDF3E]|\uD836[\uDE87-\uDE8B]|\uD801\uDD6F|\uD82F\uDC9F|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]'
	        },
	        {
	            name: 'Ps',
	            alias: 'Open_Punctuation',
	            bmp: '\\x28\\x5B\\x7B\u0F3A\u0F3C\u169B\u201A\u201E\u2045\u207D\u208D\u2308\u230A\u2329\u2768\u276A\u276C\u276E\u2770\u2772\u2774\u27C5\u27E6\u27E8\u27EA\u27EC\u27EE\u2983\u2985\u2987\u2989\u298B\u298D\u298F\u2991\u2993\u2995\u2997\u29D8\u29DA\u29FC\u2E22\u2E24\u2E26\u2E28\u2E42\u3008\u300A\u300C\u300E\u3010\u3014\u3016\u3018\u301A\u301D\uFD3F\uFE17\uFE35\uFE37\uFE39\uFE3B\uFE3D\uFE3F\uFE41\uFE43\uFE47\uFE59\uFE5B\uFE5D\uFF08\uFF3B\uFF5B\uFF5F\uFF62'
	        },
	        {
	            name: 'S',
	            alias: 'Symbol',
	            bmp: '\\x24\\x2B\x3C-\x3E\\x5E\x60\\x7C\x7E\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20BE\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u23FA\u2400-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B98-\u2BB9\u2BBD-\u2BC8\u2BCA-\u2BD1\u2BEC-\u2BEF\u2CE5-\u2CEA\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u32FE\u3300-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uFB29\uFBB2-\uFBC1\uFDFC\uFDFD\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD',
	            astral: '\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDD10-\uDD18\uDD80-\uDD84\uDDC0]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD10-\uDD2E\uDD30-\uDD6B\uDD70-\uDD9A\uDDE6-\uDE02\uDE10-\uDE3A\uDE40-\uDE48\uDE50\uDE51\uDF00-\uDFFF]|\uD83D[\uDC00-\uDD79\uDD7B-\uDDA3\uDDA5-\uDED0\uDEE0-\uDEEC\uDEF0-\uDEF3\uDF00-\uDF73\uDF80-\uDFD4]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C\uDD90-\uDD9B\uDDA0\uDDD0-\uDDFC]|\uD82F\uDC9C|\uD805\uDF3F|\uD802[\uDC77\uDC78\uDEC8]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDE8\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD83B[\uDEF0\uDEF1]'
	        },
	        {
	            name: 'Sc',
	            alias: 'Currency_Symbol',
	            bmp: '\\x24\xA2-\xA5\u058F\u060B\u09F2\u09F3\u09FB\u0AF1\u0BF9\u0E3F\u17DB\u20A0-\u20BE\uA838\uFDFC\uFE69\uFF04\uFFE0\uFFE1\uFFE5\uFFE6'
	        },
	        {
	            name: 'Sk',
	            alias: 'Modifier_Symbol',
	            bmp: '\\x5E\x60\xA8\xAF\xB4\xB8\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u309B\u309C\uA700-\uA716\uA720\uA721\uA789\uA78A\uAB5B\uFBB2-\uFBC1\uFF3E\uFF40\uFFE3',
	            astral: '\uD83C[\uDFFB-\uDFFF]'
	        },
	        {
	            name: 'Sm',
	            alias: 'Math_Symbol',
	            bmp: '\\x2B\x3C-\x3E\\x7C\x7E\xAC\xB1\xD7\xF7\u03F6\u0606-\u0608\u2044\u2052\u207A-\u207C\u208A-\u208C\u2118\u2140-\u2144\u214B\u2190-\u2194\u219A\u219B\u21A0\u21A3\u21A6\u21AE\u21CE\u21CF\u21D2\u21D4\u21F4-\u22FF\u2320\u2321\u237C\u239B-\u23B3\u23DC-\u23E1\u25B7\u25C1\u25F8-\u25FF\u266F\u27C0-\u27C4\u27C7-\u27E5\u27F0-\u27FF\u2900-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2AFF\u2B30-\u2B44\u2B47-\u2B4C\uFB29\uFE62\uFE64-\uFE66\uFF0B\uFF1C-\uFF1E\uFF5C\uFF5E\uFFE2\uFFE9-\uFFEC',
	            astral: '\uD83B[\uDEF0\uDEF1]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]'
	        },
	        {
	            name: 'So',
	            alias: 'Other_Symbol',
	            bmp: '\xA6\xA9\xAE\xB0\u0482\u058D\u058E\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u09FA\u0B70\u0BF3-\u0BF8\u0BFA\u0C7F\u0D79\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116\u2117\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u214A\u214C\u214D\u214F\u218A\u218B\u2195-\u2199\u219C-\u219F\u21A1\u21A2\u21A4\u21A5\u21A7-\u21AD\u21AF-\u21CD\u21D0\u21D1\u21D3\u21D5-\u21F3\u2300-\u2307\u230C-\u231F\u2322-\u2328\u232B-\u237B\u237D-\u239A\u23B4-\u23DB\u23E2-\u23FA\u2400-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u25B6\u25B8-\u25C0\u25C2-\u25F7\u2600-\u266E\u2670-\u2767\u2794-\u27BF\u2800-\u28FF\u2B00-\u2B2F\u2B45\u2B46\u2B4D-\u2B73\u2B76-\u2B95\u2B98-\u2BB9\u2BBD-\u2BC8\u2BCA-\u2BD1\u2BEC-\u2BEF\u2CE5-\u2CEA\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u32FE\u3300-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA828-\uA82B\uA836\uA837\uA839\uAA77-\uAA79\uFDFD\uFFE4\uFFE8\uFFED\uFFEE\uFFFC\uFFFD',
	            astral: '\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDD10-\uDD18\uDD80-\uDD84\uDDC0]|\uD83D[\uDC00-\uDD79\uDD7B-\uDDA3\uDDA5-\uDED0\uDEE0-\uDEEC\uDEF0-\uDEF3\uDF00-\uDF73\uDF80-\uDFD4]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD10-\uDD2E\uDD30-\uDD6B\uDD70-\uDD9A\uDDE6-\uDE02\uDE10-\uDE3A\uDE40-\uDE48\uDE50\uDE51\uDF00-\uDFFA]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C\uDD90-\uDD9B\uDDA0\uDDD0-\uDDFC]|\uD82F\uDC9C|\uD805\uDF3F|\uD802[\uDC77\uDC78\uDEC8]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDE8\uDE00-\uDE41\uDE45\uDF00-\uDF56]'
	        },
	        {
	            name: 'Z',
	            alias: 'Separator',
	            bmp: '\x20\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000'
	        },
	        {
	            name: 'Zl',
	            alias: 'Line_Separator',
	            bmp: '\u2028'
	        },
	        {
	            name: 'Zp',
	            alias: 'Paragraph_Separator',
	            bmp: '\u2029'
	        },
	        {
	            name: 'Zs',
	            alias: 'Space_Separator',
	            bmp: '\x20\xA0\u1680\u2000-\u200A\u202F\u205F\u3000'
	        }
	    ]);
	
	};


/***/ }),

/***/ 578:
/***/ (function(module, exports) {

	/*!
	 * XRegExp Unicode Properties 3.1.0
	 * <xregexp.com>
	 * Steven Levithan (c) 2012-2016 MIT License
	 * Unicode data by Mathias Bynens <mathiasbynens.be>
	 */
	
	/**
	 * Adds properties to meet the UTS #18 Level 1 RL1.2 requirements for Unicode regex support. See
	 * <http://unicode.org/reports/tr18/#RL1.2>. Following are definitions of these properties from UAX
	 * #44 <http://unicode.org/reports/tr44/>:
	 *
	 * - Alphabetic
	 *   Characters with the Alphabetic property. Generated from: Lowercase + Uppercase + Lt + Lm + Lo +
	 *   Nl + Other_Alphabetic.
	 *
	 * - Default_Ignorable_Code_Point
	 *   For programmatic determination of default ignorable code points. New characters that should be
	 *   ignored in rendering (unless explicitly supported) will be assigned in these ranges, permitting
	 *   programs to correctly handle the default rendering of such characters when not otherwise
	 *   supported.
	 *
	 * - Lowercase
	 *   Characters with the Lowercase property. Generated from: Ll + Other_Lowercase.
	 *
	 * - Noncharacter_Code_Point
	 *   Code points permanently reserved for internal use.
	 *
	 * - Uppercase
	 *   Characters with the Uppercase property. Generated from: Lu + Other_Uppercase.
	 *
	 * - White_Space
	 *   Spaces, separator characters and other control characters which should be treated by
	 *   programming languages as "white space" for the purpose of parsing elements.
	 *
	 * The properties ASCII, Any, and Assigned are also included but are not defined in UAX #44. UTS #18
	 * RL1.2 additionally requires support for Unicode scripts and general categories. These are
	 * included in XRegExp's Unicode Categories and Unicode Scripts addons.
	 *
	 * Token names are case insensitive, and any spaces, hyphens, and underscores are ignored.
	 *
	 * Uses Unicode 8.0.0.
	 *
	 * @requires XRegExp, Unicode Base
	 */
	module.exports = function(XRegExp) {
	    'use strict';
	
	    if (!XRegExp.addUnicodeData) {
	        throw new ReferenceError('Unicode Base must be loaded before Unicode Properties');
	    }
	
	    var unicodeData = [
	        {
	            name: 'ASCII',
	            bmp: '\0-\x7F'
	        },
	        {
	            name: 'Alphabetic',
	            bmp: 'A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0345\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05B0-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0657\u0659-\u065F\u066E-\u06D3\u06D5-\u06DC\u06E1-\u06E8\u06ED-\u06EF\u06FA-\u06FC\u06FF\u0710-\u073F\u074D-\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0817\u081A-\u082C\u0840-\u0858\u08A0-\u08B4\u08E3-\u08E9\u08F0-\u093B\u093D-\u094C\u094E-\u0950\u0955-\u0963\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD-\u09C4\u09C7\u09C8\u09CB\u09CC\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09F0\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3E-\u0A42\u0A47\u0A48\u0A4B\u0A4C\u0A51\u0A59-\u0A5C\u0A5E\u0A70-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD-\u0AC5\u0AC7-\u0AC9\u0ACB\u0ACC\u0AD0\u0AE0-\u0AE3\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D-\u0B44\u0B47\u0B48\u0B4B\u0B4C\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD0\u0BD7\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4C\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C81-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCC\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4C\u0D4E\u0D57\u0D5F-\u0D63\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E46\u0E4D\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0ECD\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F71-\u0F81\u0F88-\u0F97\u0F99-\u0FBC\u1000-\u1036\u1038\u103B-\u103F\u1050-\u1062\u1065-\u1068\u106E-\u1086\u108E\u109C\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1713\u1720-\u1733\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17B3\u17B6-\u17C8\u17D7\u17DC\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u1938\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A1B\u1A20-\u1A5E\u1A61-\u1A74\u1AA7\u1B00-\u1B33\u1B35-\u1B43\u1B45-\u1B4B\u1B80-\u1BA9\u1BAC-\u1BAF\u1BBA-\u1BE5\u1BE7-\u1BF1\u1C00-\u1C35\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1D00-\u1DBF\u1DE7-\u1DF4\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u24B6-\u24E9\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA674-\uA67B\uA67F-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA827\uA840-\uA873\uA880-\uA8C3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA92A\uA930-\uA952\uA960-\uA97C\uA980-\uA9B2\uA9B4-\uA9BF\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA60-\uAA76\uAA7A\uAA7E-\uAABE\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF5\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC',
	            astral: '\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD804[\uDC00-\uDC45\uDC82-\uDCB8\uDCD0-\uDCE8\uDD00-\uDD32\uDD50-\uDD72\uDD76\uDD80-\uDDBF\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE34\uDE37\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEE8\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D-\uDF44\uDF47\uDF48\uDF4B\uDF4C\uDF50\uDF57\uDF5D-\uDF63]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD83A[\uDC00-\uDCC4]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF36\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD801[\uDC00-\uDC9D\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD83C[\uDD30-\uDD49\uDD50-\uDD69\uDD70-\uDD89]|\uD80D[\uDC00-\uDC2E]|\uD87E[\uDC00-\uDE1D]|[\uD80C\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9E]|\uD808[\uDC00-\uDF99]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD805[\uDC80-\uDCC1\uDCC4\uDCC5\uDCC7\uDD80-\uDDB5\uDDB8-\uDDBE\uDDD8-\uDDDD\uDE00-\uDE3E\uDE40\uDE44\uDE80-\uDEB5\uDF00-\uDF19\uDF1D-\uDF2A]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD811[\uDC00-\uDE46]|\uD82C[\uDC00\uDC01]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF93-\uDF9F]|\uD873[\uDC00-\uDEA1]'
	        },
	        {
	            name: 'Any',
	            isBmpLast: true,
	            bmp: '\0-\uFFFF',
	            astral: '[\uD800-\uDBFF][\uDC00-\uDFFF]'
	        },
	        {
	            name: 'Default_Ignorable_Code_Point',
	            bmp: '\xAD\u034F\u061C\u115F\u1160\u17B4\u17B5\u180B-\u180E\u200B-\u200F\u202A-\u202E\u2060-\u206F\u3164\uFE00-\uFE0F\uFEFF\uFFA0\uFFF0-\uFFF8',
	            astral: '[\uDB40-\uDB43][\uDC00-\uDFFF]|\uD834[\uDD73-\uDD7A]|\uD82F[\uDCA0-\uDCA3]'
	        },
	        {
	            name: 'Lowercase',
	            bmp: 'a-z\xAA\xB5\xBA\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02B8\u02C0\u02C1\u02E0-\u02E4\u0345\u0371\u0373\u0377\u037A-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1D00-\u1DBF\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u2071\u207F\u2090-\u209C\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2170-\u217F\u2184\u24D0-\u24E9\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7D\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B-\uA69D\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7F8-\uA7FA\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A',
	            astral: '\uD803[\uDCC0-\uDCF2]|\uD835[\uDC1A-\uDC33\uDC4E-\uDC54\uDC56-\uDC67\uDC82-\uDC9B\uDCB6-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDCEA-\uDD03\uDD1E-\uDD37\uDD52-\uDD6B\uDD86-\uDD9F\uDDBA-\uDDD3\uDDEE-\uDE07\uDE22-\uDE3B\uDE56-\uDE6F\uDE8A-\uDEA5\uDEC2-\uDEDA\uDEDC-\uDEE1\uDEFC-\uDF14\uDF16-\uDF1B\uDF36-\uDF4E\uDF50-\uDF55\uDF70-\uDF88\uDF8A-\uDF8F\uDFAA-\uDFC2\uDFC4-\uDFC9\uDFCB]|\uD801[\uDC28-\uDC4F]|\uD806[\uDCC0-\uDCDF]'
	        },
	        {
	            name: 'Noncharacter_Code_Point',
	            bmp: '\uFDD0-\uFDEF\uFFFE\uFFFF',
	            astral: '[\uDB3F\uDB7F\uDBBF\uDBFF\uD83F\uD87F\uD8BF\uDAFF\uD97F\uD9BF\uD9FF\uDA3F\uD8FF\uDABF\uDA7F\uD93F][\uDFFE\uDFFF]'
	        },
	        {
	            name: 'Uppercase',
	            bmp: 'A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2160-\u216F\u2183\u24B6-\u24CF\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A',
	            astral: '\uD806[\uDCA0-\uDCBF]|\uD803[\uDC80-\uDCB2]|\uD835[\uDC00-\uDC19\uDC34-\uDC4D\uDC68-\uDC81\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB5\uDCD0-\uDCE9\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD38\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD6C-\uDD85\uDDA0-\uDDB9\uDDD4-\uDDED\uDE08-\uDE21\uDE3C-\uDE55\uDE70-\uDE89\uDEA8-\uDEC0\uDEE2-\uDEFA\uDF1C-\uDF34\uDF56-\uDF6E\uDF90-\uDFA8\uDFCA]|\uD801[\uDC00-\uDC27]|\uD83C[\uDD30-\uDD49\uDD50-\uDD69\uDD70-\uDD89]'
	        },
	        {
	            name: 'White_Space',
	            bmp: '\x09-\x0D\x20\x85\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000'
	        }
	    ];
	
	    // Add non-generated data
	    unicodeData.push({
	        name: 'Assigned',
	        // Since this is defined as the inverse of Unicode category Cn (Unassigned), the Unicode
	        // Categories addon is required to use this property
	        inverseOf: 'Cn'
	    });
	
	    XRegExp.addUnicodeData(unicodeData);
	
	};


/***/ }),

/***/ 579:
/***/ (function(module, exports) {

	/*!
	 * XRegExp Unicode Scripts 3.1.0
	 * <xregexp.com>
	 * Steven Levithan (c) 2010-2016 MIT License
	 * Unicode data by Mathias Bynens <mathiasbynens.be>
	 */
	
	/**
	 * Adds support for all Unicode scripts. E.g., `\p{Latin}`. Token names are case insensitive, and
	 * any spaces, hyphens, and underscores are ignored.
	 *
	 * Uses Unicode 8.0.0.
	 *
	 * @requires XRegExp, Unicode Base
	 */
	module.exports = function(XRegExp) {
	    'use strict';
	
	    if (!XRegExp.addUnicodeData) {
	        throw new ReferenceError('Unicode Base must be loaded before Unicode Scripts');
	    }
	
	    XRegExp.addUnicodeData([
	        {
	            name: 'Ahom',
	            astral: '\uD805[\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF3F]'
	        },
	        {
	            name: 'Anatolian_Hieroglyphs',
	            astral: '\uD811[\uDC00-\uDE46]'
	        },
	        {
	            name: 'Arabic',
	            bmp: '\u0600-\u0604\u0606-\u060B\u060D-\u061A\u061E\u0620-\u063F\u0641-\u064A\u0656-\u066F\u0671-\u06DC\u06DE-\u06FF\u0750-\u077F\u08A0-\u08B4\u08E3-\u08FF\uFB50-\uFBC1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFD\uFE70-\uFE74\uFE76-\uFEFC',
	            astral: '\uD803[\uDE60-\uDE7E]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB\uDEF0\uDEF1]'
	        },
	        {
	            name: 'Armenian',
	            bmp: '\u0531-\u0556\u0559-\u055F\u0561-\u0587\u058A\u058D-\u058F\uFB13-\uFB17'
	        },
	        {
	            name: 'Avestan',
	            astral: '\uD802[\uDF00-\uDF35\uDF39-\uDF3F]'
	        },
	        {
	            name: 'Balinese',
	            bmp: '\u1B00-\u1B4B\u1B50-\u1B7C'
	        },
	        {
	            name: 'Bamum',
	            bmp: '\uA6A0-\uA6F7',
	            astral: '\uD81A[\uDC00-\uDE38]'
	        },
	        {
	            name: 'Bassa_Vah',
	            astral: '\uD81A[\uDED0-\uDEED\uDEF0-\uDEF5]'
	        },
	        {
	            name: 'Batak',
	            bmp: '\u1BC0-\u1BF3\u1BFC-\u1BFF'
	        },
	        {
	            name: 'Bengali',
	            bmp: '\u0980-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09FB'
	        },
	        {
	            name: 'Bopomofo',
	            bmp: '\u02EA\u02EB\u3105-\u312D\u31A0-\u31BA'
	        },
	        {
	            name: 'Brahmi',
	            astral: '\uD804[\uDC00-\uDC4D\uDC52-\uDC6F\uDC7F]'
	        },
	        {
	            name: 'Braille',
	            bmp: '\u2800-\u28FF'
	        },
	        {
	            name: 'Buginese',
	            bmp: '\u1A00-\u1A1B\u1A1E\u1A1F'
	        },
	        {
	            name: 'Buhid',
	            bmp: '\u1740-\u1753'
	        },
	        {
	            name: 'Canadian_Aboriginal',
	            bmp: '\u1400-\u167F\u18B0-\u18F5'
	        },
	        {
	            name: 'Carian',
	            astral: '\uD800[\uDEA0-\uDED0]'
	        },
	        {
	            name: 'Caucasian_Albanian',
	            astral: '\uD801[\uDD30-\uDD63\uDD6F]'
	        },
	        {
	            name: 'Chakma',
	            astral: '\uD804[\uDD00-\uDD34\uDD36-\uDD43]'
	        },
	        {
	            name: 'Cham',
	            bmp: '\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA5C-\uAA5F'
	        },
	        {
	            name: 'Cherokee',
	            bmp: '\u13A0-\u13F5\u13F8-\u13FD\uAB70-\uABBF'
	        },
	        {
	            name: 'Common',
	            bmp: '\0-\x40\\x5B-\x60\\x7B-\xA9\xAB-\xB9\xBB-\xBF\xD7\xF7\u02B9-\u02DF\u02E5-\u02E9\u02EC-\u02FF\u0374\u037E\u0385\u0387\u0589\u0605\u060C\u061B\u061C\u061F\u0640\u06DD\u0964\u0965\u0E3F\u0FD5-\u0FD8\u10FB\u16EB-\u16ED\u1735\u1736\u1802\u1803\u1805\u1CD3\u1CE1\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u2000-\u200B\u200E-\u2064\u2066-\u2070\u2074-\u207E\u2080-\u208E\u20A0-\u20BE\u2100-\u2125\u2127-\u2129\u212C-\u2131\u2133-\u214D\u214F-\u215F\u2189-\u218B\u2190-\u23FA\u2400-\u2426\u2440-\u244A\u2460-\u27FF\u2900-\u2B73\u2B76-\u2B95\u2B98-\u2BB9\u2BBD-\u2BC8\u2BCA-\u2BD1\u2BEC-\u2BEF\u2E00-\u2E42\u2FF0-\u2FFB\u3000-\u3004\u3006\u3008-\u3020\u3030-\u3037\u303C-\u303F\u309B\u309C\u30A0\u30FB\u30FC\u3190-\u319F\u31C0-\u31E3\u3220-\u325F\u327F-\u32CF\u3358-\u33FF\u4DC0-\u4DFF\uA700-\uA721\uA788-\uA78A\uA830-\uA839\uA92E\uA9CF\uAB5B\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE66\uFE68-\uFE6B\uFEFF\uFF01-\uFF20\uFF3B-\uFF40\uFF5B-\uFF65\uFF70\uFF9E\uFF9F\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFF9-\uFFFD',
	            astral: '\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDD10-\uDD18\uDD80-\uDD84\uDDC0]|\uD82F[\uDCA0-\uDCA3]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDFCB\uDFCE-\uDFFF]|\uDB40[\uDC01\uDC20-\uDC7F]|\uD83D[\uDC00-\uDD79\uDD7B-\uDDA3\uDDA5-\uDED0\uDEE0-\uDEEC\uDEF0-\uDEF3\uDF00-\uDF73\uDF80-\uDFD4]|\uD800[\uDD00-\uDD02\uDD07-\uDD33\uDD37-\uDD3F\uDD90-\uDD9B\uDDD0-\uDDFC\uDEE1-\uDEFB]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD66\uDD6A-\uDD7A\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDE8\uDF00-\uDF56\uDF60-\uDF71]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD00-\uDD0C\uDD10-\uDD2E\uDD30-\uDD6B\uDD70-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE10-\uDE3A\uDE40-\uDE48\uDE50\uDE51\uDF00-\uDFFF]'
	        },
	        {
	            name: 'Coptic',
	            bmp: '\u03E2-\u03EF\u2C80-\u2CF3\u2CF9-\u2CFF'
	        },
	        {
	            name: 'Cuneiform',
	            astral: '\uD809[\uDC00-\uDC6E\uDC70-\uDC74\uDC80-\uDD43]|\uD808[\uDC00-\uDF99]'
	        },
	        {
	            name: 'Cypriot',
	            astral: '\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F]'
	        },
	        {
	            name: 'Cyrillic',
	            bmp: '\u0400-\u0484\u0487-\u052F\u1D2B\u1D78\u2DE0-\u2DFF\uA640-\uA69F\uFE2E\uFE2F'
	        },
	        {
	            name: 'Deseret',
	            astral: '\uD801[\uDC00-\uDC4F]'
	        },
	        {
	            name: 'Devanagari',
	            bmp: '\u0900-\u0950\u0953-\u0963\u0966-\u097F\uA8E0-\uA8FD'
	        },
	        {
	            name: 'Duployan',
	            astral: '\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9C-\uDC9F]'
	        },
	        {
	            name: 'Egyptian_Hieroglyphs',
	            astral: '\uD80C[\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]'
	        },
	        {
	            name: 'Elbasan',
	            astral: '\uD801[\uDD00-\uDD27]'
	        },
	        {
	            name: 'Ethiopic',
	            bmp: '\u1200-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u137C\u1380-\u1399\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E'
	        },
	        {
	            name: 'Georgian',
	            bmp: '\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u10FF\u2D00-\u2D25\u2D27\u2D2D'
	        },
	        {
	            name: 'Glagolitic',
	            bmp: '\u2C00-\u2C2E\u2C30-\u2C5E'
	        },
	        {
	            name: 'Gothic',
	            astral: '\uD800[\uDF30-\uDF4A]'
	        },
	        {
	            name: 'Grantha',
	            astral: '\uD804[\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]'
	        },
	        {
	            name: 'Greek',
	            bmp: '\u0370-\u0373\u0375-\u0377\u037A-\u037D\u037F\u0384\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03E1\u03F0-\u03FF\u1D26-\u1D2A\u1D5D-\u1D61\u1D66-\u1D6A\u1DBF\u1F00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FC4\u1FC6-\u1FD3\u1FD6-\u1FDB\u1FDD-\u1FEF\u1FF2-\u1FF4\u1FF6-\u1FFE\u2126\uAB65',
	            astral: '\uD800[\uDD40-\uDD8C\uDDA0]|\uD834[\uDE00-\uDE45]'
	        },
	        {
	            name: 'Gujarati',
	            bmp: '\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AF1\u0AF9'
	        },
	        {
	            name: 'Gurmukhi',
	            bmp: '\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75'
	        },
	        {
	            name: 'Han',
	            bmp: '\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u3005\u3007\u3021-\u3029\u3038-\u303B\u3400-\u4DB5\u4E00-\u9FD5\uF900-\uFA6D\uFA70-\uFAD9',
	            astral: '\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|[\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD87E[\uDC00-\uDE1D]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD873[\uDC00-\uDEA1]'
	        },
	        {
	            name: 'Hangul',
	            bmp: '\u1100-\u11FF\u302E\u302F\u3131-\u318E\u3200-\u321E\u3260-\u327E\uA960-\uA97C\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC'
	        },
	        {
	            name: 'Hanunoo',
	            bmp: '\u1720-\u1734'
	        },
	        {
	            name: 'Hatran',
	            astral: '\uD802[\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDCFF]'
	        },
	        {
	            name: 'Hebrew',
	            bmp: '\u0591-\u05C7\u05D0-\u05EA\u05F0-\u05F4\uFB1D-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFB4F'
	        },
	        {
	            name: 'Hiragana',
	            bmp: '\u3041-\u3096\u309D-\u309F',
	            astral: '\uD82C\uDC01|\uD83C\uDE00'
	        },
	        {
	            name: 'Imperial_Aramaic',
	            astral: '\uD802[\uDC40-\uDC55\uDC57-\uDC5F]'
	        },
	        {
	            name: 'Inherited',
	            bmp: '\u0300-\u036F\u0485\u0486\u064B-\u0655\u0670\u0951\u0952\u1AB0-\u1ABE\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF5\u1DFC-\u1DFF\u200C\u200D\u20D0-\u20F0\u302A-\u302D\u3099\u309A\uFE00-\uFE0F\uFE20-\uFE2D',
	            astral: '\uD834[\uDD67-\uDD69\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD]|\uD800[\uDDFD\uDEE0]|\uDB40[\uDD00-\uDDEF]'
	        },
	        {
	            name: 'Inscriptional_Pahlavi',
	            astral: '\uD802[\uDF60-\uDF72\uDF78-\uDF7F]'
	        },
	        {
	            name: 'Inscriptional_Parthian',
	            astral: '\uD802[\uDF40-\uDF55\uDF58-\uDF5F]'
	        },
	        {
	            name: 'Javanese',
	            bmp: '\uA980-\uA9CD\uA9D0-\uA9D9\uA9DE\uA9DF'
	        },
	        {
	            name: 'Kaithi',
	            astral: '\uD804[\uDC80-\uDCC1]'
	        },
	        {
	            name: 'Kannada',
	            bmp: '\u0C81-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2'
	        },
	        {
	            name: 'Katakana',
	            bmp: '\u30A1-\u30FA\u30FD-\u30FF\u31F0-\u31FF\u32D0-\u32FE\u3300-\u3357\uFF66-\uFF6F\uFF71-\uFF9D',
	            astral: '\uD82C\uDC00'
	        },
	        {
	            name: 'Kayah_Li',
	            bmp: '\uA900-\uA92D\uA92F'
	        },
	        {
	            name: 'Kharoshthi',
	            astral: '\uD802[\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F-\uDE47\uDE50-\uDE58]'
	        },
	        {
	            name: 'Khmer',
	            bmp: '\u1780-\u17DD\u17E0-\u17E9\u17F0-\u17F9\u19E0-\u19FF'
	        },
	        {
	            name: 'Khojki',
	            astral: '\uD804[\uDE00-\uDE11\uDE13-\uDE3D]'
	        },
	        {
	            name: 'Khudawadi',
	            astral: '\uD804[\uDEB0-\uDEEA\uDEF0-\uDEF9]'
	        },
	        {
	            name: 'Lao',
	            bmp: '\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF'
	        },
	        {
	            name: 'Latin',
	            bmp: 'A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A'
	        },
	        {
	            name: 'Lepcha',
	            bmp: '\u1C00-\u1C37\u1C3B-\u1C49\u1C4D-\u1C4F'
	        },
	        {
	            name: 'Limbu',
	            bmp: '\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1940\u1944-\u194F'
	        },
	        {
	            name: 'Linear_A',
	            astral: '\uD801[\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]'
	        },
	        {
	            name: 'Linear_B',
	            astral: '\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA]'
	        },
	        {
	            name: 'Lisu',
	            bmp: '\uA4D0-\uA4FF'
	        },
	        {
	            name: 'Lycian',
	            astral: '\uD800[\uDE80-\uDE9C]'
	        },
	        {
	            name: 'Lydian',
	            astral: '\uD802[\uDD20-\uDD39\uDD3F]'
	        },
	        {
	            name: 'Mahajani',
	            astral: '\uD804[\uDD50-\uDD76]'
	        },
	        {
	            name: 'Malayalam',
	            bmp: '\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D57\u0D5F-\u0D63\u0D66-\u0D75\u0D79-\u0D7F'
	        },
	        {
	            name: 'Mandaic',
	            bmp: '\u0840-\u085B\u085E'
	        },
	        {
	            name: 'Manichaean',
	            astral: '\uD802[\uDEC0-\uDEE6\uDEEB-\uDEF6]'
	        },
	        {
	            name: 'Meetei_Mayek',
	            bmp: '\uAAE0-\uAAF6\uABC0-\uABED\uABF0-\uABF9'
	        },
	        {
	            name: 'Mende_Kikakui',
	            astral: '\uD83A[\uDC00-\uDCC4\uDCC7-\uDCD6]'
	        },
	        {
	            name: 'Meroitic_Cursive',
	            astral: '\uD802[\uDDA0-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDDFF]'
	        },
	        {
	            name: 'Meroitic_Hieroglyphs',
	            astral: '\uD802[\uDD80-\uDD9F]'
	        },
	        {
	            name: 'Miao',
	            astral: '\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F]'
	        },
	        {
	            name: 'Modi',
	            astral: '\uD805[\uDE00-\uDE44\uDE50-\uDE59]'
	        },
	        {
	            name: 'Mongolian',
	            bmp: '\u1800\u1801\u1804\u1806-\u180E\u1810-\u1819\u1820-\u1877\u1880-\u18AA'
	        },
	        {
	            name: 'Mro',
	            astral: '\uD81A[\uDE40-\uDE5E\uDE60-\uDE69\uDE6E\uDE6F]'
	        },
	        {
	            name: 'Multani',
	            astral: '\uD804[\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA9]'
	        },
	        {
	            name: 'Myanmar',
	            bmp: '\u1000-\u109F\uA9E0-\uA9FE\uAA60-\uAA7F'
	        },
	        {
	            name: 'Nabataean',
	            astral: '\uD802[\uDC80-\uDC9E\uDCA7-\uDCAF]'
	        },
	        {
	            name: 'New_Tai_Lue',
	            bmp: '\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u19DE\u19DF'
	        },
	        {
	            name: 'Nko',
	            bmp: '\u07C0-\u07FA'
	        },
	        {
	            name: 'Ogham',
	            bmp: '\u1680-\u169C'
	        },
	        {
	            name: 'Ol_Chiki',
	            bmp: '\u1C50-\u1C7F'
	        },
	        {
	            name: 'Old_Hungarian',
	            astral: '\uD803[\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDCFF]'
	        },
	        {
	            name: 'Old_Italic',
	            astral: '\uD800[\uDF00-\uDF23]'
	        },
	        {
	            name: 'Old_North_Arabian',
	            astral: '\uD802[\uDE80-\uDE9F]'
	        },
	        {
	            name: 'Old_Permic',
	            astral: '\uD800[\uDF50-\uDF7A]'
	        },
	        {
	            name: 'Old_Persian',
	            astral: '\uD800[\uDFA0-\uDFC3\uDFC8-\uDFD5]'
	        },
	        {
	            name: 'Old_South_Arabian',
	            astral: '\uD802[\uDE60-\uDE7F]'
	        },
	        {
	            name: 'Old_Turkic',
	            astral: '\uD803[\uDC00-\uDC48]'
	        },
	        {
	            name: 'Oriya',
	            bmp: '\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B77'
	        },
	        {
	            name: 'Osmanya',
	            astral: '\uD801[\uDC80-\uDC9D\uDCA0-\uDCA9]'
	        },
	        {
	            name: 'Pahawh_Hmong',
	            astral: '\uD81A[\uDF00-\uDF45\uDF50-\uDF59\uDF5B-\uDF61\uDF63-\uDF77\uDF7D-\uDF8F]'
	        },
	        {
	            name: 'Palmyrene',
	            astral: '\uD802[\uDC60-\uDC7F]'
	        },
	        {
	            name: 'Pau_Cin_Hau',
	            astral: '\uD806[\uDEC0-\uDEF8]'
	        },
	        {
	            name: 'Phags_Pa',
	            bmp: '\uA840-\uA877'
	        },
	        {
	            name: 'Phoenician',
	            astral: '\uD802[\uDD00-\uDD1B\uDD1F]'
	        },
	        {
	            name: 'Psalter_Pahlavi',
	            astral: '\uD802[\uDF80-\uDF91\uDF99-\uDF9C\uDFA9-\uDFAF]'
	        },
	        {
	            name: 'Rejang',
	            bmp: '\uA930-\uA953\uA95F'
	        },
	        {
	            name: 'Runic',
	            bmp: '\u16A0-\u16EA\u16EE-\u16F8'
	        },
	        {
	            name: 'Samaritan',
	            bmp: '\u0800-\u082D\u0830-\u083E'
	        },
	        {
	            name: 'Saurashtra',
	            bmp: '\uA880-\uA8C4\uA8CE-\uA8D9'
	        },
	        {
	            name: 'Sharada',
	            astral: '\uD804[\uDD80-\uDDCD\uDDD0-\uDDDF]'
	        },
	        {
	            name: 'Shavian',
	            astral: '\uD801[\uDC50-\uDC7F]'
	        },
	        {
	            name: 'Siddham',
	            astral: '\uD805[\uDD80-\uDDB5\uDDB8-\uDDDD]'
	        },
	        {
	            name: 'SignWriting',
	            astral: '\uD836[\uDC00-\uDE8B\uDE9B-\uDE9F\uDEA1-\uDEAF]'
	        },
	        {
	            name: 'Sinhala',
	            bmp: '\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2-\u0DF4',
	            astral: '\uD804[\uDDE1-\uDDF4]'
	        },
	        {
	            name: 'Sora_Sompeng',
	            astral: '\uD804[\uDCD0-\uDCE8\uDCF0-\uDCF9]'
	        },
	        {
	            name: 'Sundanese',
	            bmp: '\u1B80-\u1BBF\u1CC0-\u1CC7'
	        },
	        {
	            name: 'Syloti_Nagri',
	            bmp: '\uA800-\uA82B'
	        },
	        {
	            name: 'Syriac',
	            bmp: '\u0700-\u070D\u070F-\u074A\u074D-\u074F'
	        },
	        {
	            name: 'Tagalog',
	            bmp: '\u1700-\u170C\u170E-\u1714'
	        },
	        {
	            name: 'Tagbanwa',
	            bmp: '\u1760-\u176C\u176E-\u1770\u1772\u1773'
	        },
	        {
	            name: 'Tai_Le',
	            bmp: '\u1950-\u196D\u1970-\u1974'
	        },
	        {
	            name: 'Tai_Tham',
	            bmp: '\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA0-\u1AAD'
	        },
	        {
	            name: 'Tai_Viet',
	            bmp: '\uAA80-\uAAC2\uAADB-\uAADF'
	        },
	        {
	            name: 'Takri',
	            astral: '\uD805[\uDE80-\uDEB7\uDEC0-\uDEC9]'
	        },
	        {
	            name: 'Tamil',
	            bmp: '\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BFA'
	        },
	        {
	            name: 'Telugu',
	            bmp: '\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C78-\u0C7F'
	        },
	        {
	            name: 'Thaana',
	            bmp: '\u0780-\u07B1'
	        },
	        {
	            name: 'Thai',
	            bmp: '\u0E01-\u0E3A\u0E40-\u0E5B'
	        },
	        {
	            name: 'Tibetan',
	            bmp: '\u0F00-\u0F47\u0F49-\u0F6C\u0F71-\u0F97\u0F99-\u0FBC\u0FBE-\u0FCC\u0FCE-\u0FD4\u0FD9\u0FDA'
	        },
	        {
	            name: 'Tifinagh',
	            bmp: '\u2D30-\u2D67\u2D6F\u2D70\u2D7F'
	        },
	        {
	            name: 'Tirhuta',
	            astral: '\uD805[\uDC80-\uDCC7\uDCD0-\uDCD9]'
	        },
	        {
	            name: 'Ugaritic',
	            astral: '\uD800[\uDF80-\uDF9D\uDF9F]'
	        },
	        {
	            name: 'Vai',
	            bmp: '\uA500-\uA62B'
	        },
	        {
	            name: 'Warang_Citi',
	            astral: '\uD806[\uDCA0-\uDCF2\uDCFF]'
	        },
	        {
	            name: 'Yi',
	            bmp: '\uA000-\uA48C\uA490-\uA4C6'
	        }
	    ]);
	
	};


/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

	var XRegExp = __webpack_require__(581);
	
	__webpack_require__(573)(XRegExp);
	__webpack_require__(574)(XRegExp);
	__webpack_require__(575)(XRegExp);
	__webpack_require__(576)(XRegExp);
	__webpack_require__(577)(XRegExp);
	__webpack_require__(578)(XRegExp);
	__webpack_require__(579)(XRegExp);
	
	module.exports = XRegExp;


/***/ }),

/***/ 581:
/***/ (function(module, exports) {

	/*!
	 * XRegExp 3.1.0
	 * <xregexp.com>
	 * Steven Levithan (c) 2007-2016 MIT License
	 */
	
	/**
	 * XRegExp provides augmented, extensible regular expressions. You get additional regex syntax and
	 * flags, beyond what browsers support natively. XRegExp is also a regex utility belt with tools to
	 * make your client-side grepping simpler and more powerful, while freeing you from related
	 * cross-browser inconsistencies.
	 */
	
	    'use strict';
	
	/* ==============================
	 * Private stuff
	 * ============================== */
	
	    // Property name used for extended regex instance data
	    var REGEX_DATA = 'xregexp';
	    // Optional features that can be installed and uninstalled
	    var features = {
	        astral: false,
	        natives: false
	    };
	    // Native methods to use and restore ('native' is an ES3 reserved keyword)
	    var nativ = {
	        exec: RegExp.prototype.exec,
	        test: RegExp.prototype.test,
	        match: String.prototype.match,
	        replace: String.prototype.replace,
	        split: String.prototype.split
	    };
	    // Storage for fixed/extended native methods
	    var fixed = {};
	    // Storage for regexes cached by `XRegExp.cache`
	    var regexCache = {};
	    // Storage for pattern details cached by the `XRegExp` constructor
	    var patternCache = {};
	    // Storage for regex syntax tokens added internally or by `XRegExp.addToken`
	    var tokens = [];
	    // Token scopes
	    var defaultScope = 'default';
	    var classScope = 'class';
	    // Regexes that match native regex syntax, including octals
	    var nativeTokens = {
	        // Any native multicharacter token in default scope, or any single character
	        'default': /\\(?:0(?:[0-3][0-7]{0,2}|[4-7][0-7]?)?|[1-9]\d*|x[\dA-Fa-f]{2}|u(?:[\dA-Fa-f]{4}|{[\dA-Fa-f]+})|c[A-Za-z]|[\s\S])|\(\?[:=!]|[?*+]\?|{\d+(?:,\d*)?}\??|[\s\S]/,
	        // Any native multicharacter token in character class scope, or any single character
	        'class': /\\(?:[0-3][0-7]{0,2}|[4-7][0-7]?|x[\dA-Fa-f]{2}|u(?:[\dA-Fa-f]{4}|{[\dA-Fa-f]+})|c[A-Za-z]|[\s\S])|[\s\S]/
	    };
	    // Any backreference or dollar-prefixed character in replacement strings
	    var replacementToken = /\$(?:{([\w$]+)}|(\d\d?|[\s\S]))/g;
	    // Check for correct `exec` handling of nonparticipating capturing groups
	    var correctExecNpcg = nativ.exec.call(/()??/, '')[1] === undefined;
	    // Check for ES6 `flags` prop support
	    var hasFlagsProp = /x/.flags !== undefined;
	    // Shortcut to `Object.prototype.toString`
	    var toString = {}.toString;
	
	    function hasNativeFlag(flag) {
	        // Can't check based on the presense of properties/getters since
	        // browsers might support such properties even when don't support the
	        // corresponding flag in regex construction (tested in Chrome 48, where
	        // `'unicode' in /x/` is true but trying to construct a regex with flag
	        // `u` throws an error).
	        var isSupported = true;
	        try {
	            new RegExp('', flag);
	        } catch (exception) {
	            isSupported = false;
	        }
	        return isSupported;
	    }
	    // Check for ES6 `u` flag support
	    var hasNativeU = hasNativeFlag('u');
	    // Check for ES6 `y` flag support
	    var hasNativeY = hasNativeFlag('y');
	    // Tracker for known flags, including addon flags
	    var registeredFlags = {
	        g: true,
	        i: true,
	        m: true,
	        u: hasNativeU,
	        y: hasNativeY
	    };
	
	/**
	 * Attaches extended data and `XRegExp.prototype` properties to a regex object.
	 *
	 * @private
	 * @param {RegExp} regex Regex to augment.
	 * @param {Array} captureNames Array with capture names, or `null`.
	 * @param {String} xSource XRegExp pattern used to generate `regex`, or `null` if N/A.
	 * @param {String} xFlags XRegExp flags used to generate `regex`, or `null` if N/A.
	 * @param {Boolean} [isInternalOnly=false] Whether the regex will be used only for internal
	 *   operations, and never exposed to users. For internal-only regexes, we can improve perf by
	 *   skipping some operations like attaching `XRegExp.prototype` properties.
	 * @returns {RegExp} Augmented regex.
	 */
	    function augment(regex, captureNames, xSource, xFlags, isInternalOnly) {
	        var p;
	
	        regex[REGEX_DATA] = {
	            captureNames: captureNames
	        };
	
	        if (isInternalOnly) {
	            return regex;
	        }
	
	        // Can't auto-inherit these since the XRegExp constructor returns a nonprimitive value
	        if (regex.__proto__) {
	            regex.__proto__ = XRegExp.prototype;
	        } else {
	            for (p in XRegExp.prototype) {
	                // An `XRegExp.prototype.hasOwnProperty(p)` check wouldn't be worth it here, since
	                // this is performance sensitive, and enumerable `Object.prototype` or
	                // `RegExp.prototype` extensions exist on `regex.prototype` anyway
	                regex[p] = XRegExp.prototype[p];
	            }
	        }
	
	        regex[REGEX_DATA].source = xSource;
	        // Emulate the ES6 `flags` prop by ensuring flags are in alphabetical order
	        regex[REGEX_DATA].flags = xFlags ? xFlags.split('').sort().join('') : xFlags;
	
	        return regex;
	    }
	
	/**
	 * Removes any duplicate characters from the provided string.
	 *
	 * @private
	 * @param {String} str String to remove duplicate characters from.
	 * @returns {String} String with any duplicate characters removed.
	 */
	    function clipDuplicates(str) {
	        return nativ.replace.call(str, /([\s\S])(?=[\s\S]*\1)/g, '');
	    }
	
	/**
	 * Copies a regex object while preserving extended data and augmenting with `XRegExp.prototype`
	 * properties. The copy has a fresh `lastIndex` property (set to zero). Allows adding and removing
	 * flags g and y while copying the regex.
	 *
	 * @private
	 * @param {RegExp} regex Regex to copy.
	 * @param {Object} [options] Options object with optional properties:
	 *   <li>`addG` {Boolean} Add flag g while copying the regex.
	 *   <li>`addY` {Boolean} Add flag y while copying the regex.
	 *   <li>`removeG` {Boolean} Remove flag g while copying the regex.
	 *   <li>`removeY` {Boolean} Remove flag y while copying the regex.
	 *   <li>`isInternalOnly` {Boolean} Whether the copied regex will be used only for internal
	 *     operations, and never exposed to users. For internal-only regexes, we can improve perf by
	 *     skipping some operations like attaching `XRegExp.prototype` properties.
	 * @returns {RegExp} Copy of the provided regex, possibly with modified flags.
	 */
	    function copyRegex(regex, options) {
	        if (!XRegExp.isRegExp(regex)) {
	            throw new TypeError('Type RegExp expected');
	        }
	
	        var xData = regex[REGEX_DATA] || {},
	            flags = getNativeFlags(regex),
	            flagsToAdd = '',
	            flagsToRemove = '',
	            xregexpSource = null,
	            xregexpFlags = null;
	
	        options = options || {};
	
	        if (options.removeG) {flagsToRemove += 'g';}
	        if (options.removeY) {flagsToRemove += 'y';}
	        if (flagsToRemove) {
	            flags = nativ.replace.call(flags, new RegExp('[' + flagsToRemove + ']+', 'g'), '');
	        }
	
	        if (options.addG) {flagsToAdd += 'g';}
	        if (options.addY) {flagsToAdd += 'y';}
	        if (flagsToAdd) {
	            flags = clipDuplicates(flags + flagsToAdd);
	        }
	
	        if (!options.isInternalOnly) {
	            if (xData.source !== undefined) {
	                xregexpSource = xData.source;
	            }
	            // null or undefined; don't want to add to `flags` if the previous value was null, since
	            // that indicates we're not tracking original precompilation flags
	            if (xData.flags != null) {
	                // Flags are only added for non-internal regexes by `XRegExp.globalize`. Flags are
	                // never removed for non-internal regexes, so don't need to handle it
	                xregexpFlags = flagsToAdd ? clipDuplicates(xData.flags + flagsToAdd) : xData.flags;
	            }
	        }
	
	        // Augment with `XRegExp.prototype` properties, but use the native `RegExp` constructor to
	        // avoid searching for special tokens. That would be wrong for regexes constructed by
	        // `RegExp`, and unnecessary for regexes constructed by `XRegExp` because the regex has
	        // already undergone the translation to native regex syntax
	        regex = augment(
	            new RegExp(regex.source, flags),
	            hasNamedCapture(regex) ? xData.captureNames.slice(0) : null,
	            xregexpSource,
	            xregexpFlags,
	            options.isInternalOnly
	        );
	
	        return regex;
	    }
	
	/**
	 * Converts hexadecimal to decimal.
	 *
	 * @private
	 * @param {String} hex
	 * @returns {Number}
	 */
	    function dec(hex) {
	        return parseInt(hex, 16);
	    }
	
	/**
	 * Returns native `RegExp` flags used by a regex object.
	 *
	 * @private
	 * @param {RegExp} regex Regex to check.
	 * @returns {String} Native flags in use.
	 */
	    function getNativeFlags(regex) {
	        return hasFlagsProp ?
	            regex.flags :
	            // Explicitly using `RegExp.prototype.toString` (rather than e.g. `String` or
	            // concatenation with an empty string) allows this to continue working predictably when
	            // `XRegExp.proptotype.toString` is overriden
	            nativ.exec.call(/\/([a-z]*)$/i, RegExp.prototype.toString.call(regex))[1];
	    }
	
	/**
	 * Determines whether a regex has extended instance data used to track capture names.
	 *
	 * @private
	 * @param {RegExp} regex Regex to check.
	 * @returns {Boolean} Whether the regex uses named capture.
	 */
	    function hasNamedCapture(regex) {
	        return !!(regex[REGEX_DATA] && regex[REGEX_DATA].captureNames);
	    }
	
	/**
	 * Converts decimal to hexadecimal.
	 *
	 * @private
	 * @param {Number|String} dec
	 * @returns {String}
	 */
	    function hex(dec) {
	        return parseInt(dec, 10).toString(16);
	    }
	
	/**
	 * Returns the first index at which a given value can be found in an array.
	 *
	 * @private
	 * @param {Array} array Array to search.
	 * @param {*} value Value to locate in the array.
	 * @returns {Number} Zero-based index at which the item is found, or -1.
	 */
	    function indexOf(array, value) {
	        var len = array.length, i;
	
	        for (i = 0; i < len; ++i) {
	            if (array[i] === value) {
	                return i;
	            }
	        }
	
	        return -1;
	    }
	
	/**
	 * Determines whether a value is of the specified type, by resolving its internal [[Class]].
	 *
	 * @private
	 * @param {*} value Object to check.
	 * @param {String} type Type to check for, in TitleCase.
	 * @returns {Boolean} Whether the object matches the type.
	 */
	    function isType(value, type) {
	        return toString.call(value) === '[object ' + type + ']';
	    }
	
	/**
	 * Checks whether the next nonignorable token after the specified position is a quantifier.
	 *
	 * @private
	 * @param {String} pattern Pattern to search within.
	 * @param {Number} pos Index in `pattern` to search at.
	 * @param {String} flags Flags used by the pattern.
	 * @returns {Boolean} Whether the next token is a quantifier.
	 */
	    function isQuantifierNext(pattern, pos, flags) {
	        return nativ.test.call(
	            flags.indexOf('x') > -1 ?
	                // Ignore any leading whitespace, line comments, and inline comments
	                /^(?:\s+|#.*|\(\?#[^)]*\))*(?:[?*+]|{\d+(?:,\d*)?})/ :
	                // Ignore any leading inline comments
	                /^(?:\(\?#[^)]*\))*(?:[?*+]|{\d+(?:,\d*)?})/,
	            pattern.slice(pos)
	        );
	    }
	
	/**
	 * Pads the provided string with as many leading zeros as needed to get to length 4. Used to produce
	 * fixed-length hexadecimal values.
	 *
	 * @private
	 * @param {String} str
	 * @returns {String}
	 */
	    function pad4(str) {
	        while (str.length < 4) {
	            str = '0' + str;
	        }
	        return str;
	    }
	
	/**
	 * Checks for flag-related errors, and strips/applies flags in a leading mode modifier. Offloads
	 * the flag preparation logic from the `XRegExp` constructor.
	 *
	 * @private
	 * @param {String} pattern Regex pattern, possibly with a leading mode modifier.
	 * @param {String} flags Any combination of flags.
	 * @returns {Object} Object with properties `pattern` and `flags`.
	 */
	    function prepareFlags(pattern, flags) {
	        var i;
	
	        // Recent browsers throw on duplicate flags, so copy this behavior for nonnative flags
	        if (clipDuplicates(flags) !== flags) {
	            throw new SyntaxError('Invalid duplicate regex flag ' + flags);
	        }
	
	        // Strip and apply a leading mode modifier with any combination of flags except g or y
	        pattern = nativ.replace.call(pattern, /^\(\?([\w$]+)\)/, function($0, $1) {
	            if (nativ.test.call(/[gy]/, $1)) {
	                throw new SyntaxError('Cannot use flag g or y in mode modifier ' + $0);
	            }
	            // Allow duplicate flags within the mode modifier
	            flags = clipDuplicates(flags + $1);
	            return '';
	        });
	
	        // Throw on unknown native or nonnative flags
	        for (i = 0; i < flags.length; ++i) {
	            if (!registeredFlags[flags.charAt(i)]) {
	                throw new SyntaxError('Unknown regex flag ' + flags.charAt(i));
	            }
	        }
	
	        return {
	            pattern: pattern,
	            flags: flags
	        };
	    }
	
	/**
	 * Prepares an options object from the given value.
	 *
	 * @private
	 * @param {String|Object} value Value to convert to an options object.
	 * @returns {Object} Options object.
	 */
	    function prepareOptions(value) {
	        var options = {};
	
	        if (isType(value, 'String')) {
	            XRegExp.forEach(value, /[^\s,]+/, function(match) {
	                options[match] = true;
	            });
	
	            return options;
	        }
	
	        return value;
	    }
	
	/**
	 * Registers a flag so it doesn't throw an 'unknown flag' error.
	 *
	 * @private
	 * @param {String} flag Single-character flag to register.
	 */
	    function registerFlag(flag) {
	        if (!/^[\w$]$/.test(flag)) {
	            throw new Error('Flag must be a single character A-Za-z0-9_$');
	        }
	
	        registeredFlags[flag] = true;
	    }
	
	/**
	 * Runs built-in and custom regex syntax tokens in reverse insertion order at the specified
	 * position, until a match is found.
	 *
	 * @private
	 * @param {String} pattern Original pattern from which an XRegExp object is being built.
	 * @param {String} flags Flags being used to construct the regex.
	 * @param {Number} pos Position to search for tokens within `pattern`.
	 * @param {Number} scope Regex scope to apply: 'default' or 'class'.
	 * @param {Object} context Context object to use for token handler functions.
	 * @returns {Object} Object with properties `matchLength`, `output`, and `reparse`; or `null`.
	 */
	    function runTokens(pattern, flags, pos, scope, context) {
	        var i = tokens.length,
	            leadChar = pattern.charAt(pos),
	            result = null,
	            match,
	            t;
	
	        // Run in reverse insertion order
	        while (i--) {
	            t = tokens[i];
	            if (
	                (t.leadChar && t.leadChar !== leadChar) ||
	                (t.scope !== scope && t.scope !== 'all') ||
	                (t.flag && flags.indexOf(t.flag) === -1)
	            ) {
	                continue;
	            }
	
	            match = XRegExp.exec(pattern, t.regex, pos, 'sticky');
	            if (match) {
	                result = {
	                    matchLength: match[0].length,
	                    output: t.handler.call(context, match, scope, flags),
	                    reparse: t.reparse
	                };
	                // Finished with token tests
	                break;
	            }
	        }
	
	        return result;
	    }
	
	/**
	 * Enables or disables implicit astral mode opt-in. When enabled, flag A is automatically added to
	 * all new regexes created by XRegExp. This causes an error to be thrown when creating regexes if
	 * the Unicode Base addon is not available, since flag A is registered by that addon.
	 *
	 * @private
	 * @param {Boolean} on `true` to enable; `false` to disable.
	 */
	    function setAstral(on) {
	        features.astral = on;
	    }
	
	/**
	 * Enables or disables native method overrides.
	 *
	 * @private
	 * @param {Boolean} on `true` to enable; `false` to disable.
	 */
	    function setNatives(on) {
	        RegExp.prototype.exec = (on ? fixed : nativ).exec;
	        RegExp.prototype.test = (on ? fixed : nativ).test;
	        String.prototype.match = (on ? fixed : nativ).match;
	        String.prototype.replace = (on ? fixed : nativ).replace;
	        String.prototype.split = (on ? fixed : nativ).split;
	
	        features.natives = on;
	    }
	
	/**
	 * Returns the object, or throws an error if it is `null` or `undefined`. This is used to follow
	 * the ES5 abstract operation `ToObject`.
	 *
	 * @private
	 * @param {*} value Object to check and return.
	 * @returns {*} The provided object.
	 */
	    function toObject(value) {
	        // null or undefined
	        if (value == null) {
	            throw new TypeError('Cannot convert null or undefined to object');
	        }
	
	        return value;
	    }
	
	/* ==============================
	 * Constructor
	 * ============================== */
	
	/**
	 * Creates an extended regular expression object for matching text with a pattern. Differs from a
	 * native regular expression in that additional syntax and flags are supported. The returned object
	 * is in fact a native `RegExp` and works with all native methods.
	 *
	 * @class XRegExp
	 * @constructor
	 * @param {String|RegExp} pattern Regex pattern string, or an existing regex object to copy.
	 * @param {String} [flags] Any combination of flags.
	 *   Native flags:
	 *     <li>`g` - global
	 *     <li>`i` - ignore case
	 *     <li>`m` - multiline anchors
	 *     <li>`u` - unicode (ES6)
	 *     <li>`y` - sticky (Firefox 3+, ES6)
	 *   Additional XRegExp flags:
	 *     <li>`n` - explicit capture
	 *     <li>`s` - dot matches all (aka singleline)
	 *     <li>`x` - free-spacing and line comments (aka extended)
	 *     <li>`A` - astral (requires the Unicode Base addon)
	 *   Flags cannot be provided when constructing one `RegExp` from another.
	 * @returns {RegExp} Extended regular expression object.
	 * @example
	 *
	 * // With named capture and flag x
	 * XRegExp('(?<year>  [0-9]{4} ) -?  # year  \n\
	 *          (?<month> [0-9]{2} ) -?  # month \n\
	 *          (?<day>   [0-9]{2} )     # day   ', 'x');
	 *
	 * // Providing a regex object copies it. Native regexes are recompiled using native (not XRegExp)
	 * // syntax. Copies maintain extended data, are augmented with `XRegExp.prototype` properties, and
	 * // have fresh `lastIndex` properties (set to zero).
	 * XRegExp(/regex/);
	 */
	    function XRegExp(pattern, flags) {
	        var context = {
	                hasNamedCapture: false,
	                captureNames: []
	            },
	            scope = defaultScope,
	            output = '',
	            pos = 0,
	            result,
	            token,
	            generated,
	            appliedPattern,
	            appliedFlags;
	
	        if (XRegExp.isRegExp(pattern)) {
	            if (flags !== undefined) {
	                throw new TypeError('Cannot supply flags when copying a RegExp');
	            }
	            return copyRegex(pattern);
	        }
	
	        // Copy the argument behavior of `RegExp`
	        pattern = pattern === undefined ? '' : String(pattern);
	        flags = flags === undefined ? '' : String(flags);
	
	        if (XRegExp.isInstalled('astral') && flags.indexOf('A') === -1) {
	            // This causes an error to be thrown if the Unicode Base addon is not available
	            flags += 'A';
	        }
	
	        if (!patternCache[pattern]) {
	            patternCache[pattern] = {};
	        }
	
	        if (!patternCache[pattern][flags]) {
	            // Check for flag-related errors, and strip/apply flags in a leading mode modifier
	            result = prepareFlags(pattern, flags);
	            appliedPattern = result.pattern;
	            appliedFlags = result.flags;
	
	            // Use XRegExp's tokens to translate the pattern to a native regex pattern.
	            // `appliedPattern.length` may change on each iteration if tokens use `reparse`
	            while (pos < appliedPattern.length) {
	                do {
	                    // Check for custom tokens at the current position
	                    result = runTokens(appliedPattern, appliedFlags, pos, scope, context);
	                    // If the matched token used the `reparse` option, splice its output into the
	                    // pattern before running tokens again at the same position
	                    if (result && result.reparse) {
	                        appliedPattern = appliedPattern.slice(0, pos) +
	                            result.output +
	                            appliedPattern.slice(pos + result.matchLength);
	                    }
	                } while (result && result.reparse);
	
	                if (result) {
	                    output += result.output;
	                    pos += (result.matchLength || 1);
	                } else {
	                    // Get the native token at the current position
	                    token = XRegExp.exec(appliedPattern, nativeTokens[scope], pos, 'sticky')[0];
	                    output += token;
	                    pos += token.length;
	                    if (token === '[' && scope === defaultScope) {
	                        scope = classScope;
	                    } else if (token === ']' && scope === classScope) {
	                        scope = defaultScope;
	                    }
	                }
	            }
	
	            patternCache[pattern][flags] = {
	                pattern: output,
	                // Strip all but native flags
	                flags: nativ.replace.call(appliedFlags, /[^gimuy]+/g, ''),
	                // `context.captureNames` has an item for each capturing group, even if unnamed
	                captures: context.hasNamedCapture ? context.captureNames : null
	            };
	        }
	
	        generated = patternCache[pattern][flags];
	        return augment(
	            new RegExp(generated.pattern, generated.flags),
	            generated.captures,
	            pattern,
	            flags
	        );
	    };
	
	// Add `RegExp.prototype` to the prototype chain
	    XRegExp.prototype = new RegExp();
	
	/* ==============================
	 * Public properties
	 * ============================== */
	
	/**
	 * The XRegExp version number as a string containing three dot-separated parts. For example,
	 * '2.0.0-beta-3'.
	 *
	 * @static
	 * @memberOf XRegExp
	 * @type String
	 */
	    XRegExp.version = '3.1.0';
	
	/* ==============================
	 * Public methods
	 * ============================== */
	
	// Intentionally undocumented
	    XRegExp._hasNativeFlag = hasNativeFlag;
	
	/**
	 * Extends XRegExp syntax and allows custom flags. This is used internally and can be used to
	 * create XRegExp addons. If more than one token can match the same string, the last added wins.
	 *
	 * @memberOf XRegExp
	 * @param {RegExp} regex Regex object that matches the new token.
	 * @param {Function} handler Function that returns a new pattern string (using native regex syntax)
	 *   to replace the matched token within all future XRegExp regexes. Has access to persistent
	 *   properties of the regex being built, through `this`. Invoked with three arguments:
	 *   <li>The match array, with named backreference properties.
	 *   <li>The regex scope where the match was found: 'default' or 'class'.
	 *   <li>The flags used by the regex, including any flags in a leading mode modifier.
	 *   The handler function becomes part of the XRegExp construction process, so be careful not to
	 *   construct XRegExps within the function or you will trigger infinite recursion.
	 * @param {Object} [options] Options object with optional properties:
	 *   <li>`scope` {String} Scope where the token applies: 'default', 'class', or 'all'.
	 *   <li>`flag` {String} Single-character flag that triggers the token. This also registers the
	 *     flag, which prevents XRegExp from throwing an 'unknown flag' error when the flag is used.
	 *   <li>`optionalFlags` {String} Any custom flags checked for within the token `handler` that are
	 *     not required to trigger the token. This registers the flags, to prevent XRegExp from
	 *     throwing an 'unknown flag' error when any of the flags are used.
	 *   <li>`reparse` {Boolean} Whether the `handler` function's output should not be treated as
	 *     final, and instead be reparseable by other tokens (including the current token). Allows
	 *     token chaining or deferring.
	 *   <li>`leadChar` {String} Single character that occurs at the beginning of any successful match
	 *     of the token (not always applicable). This doesn't change the behavior of the token unless
	 *     you provide an erroneous value. However, providing it can increase the token's performance
	 *     since the token can be skipped at any positions where this character doesn't appear.
	 * @example
	 *
	 * // Basic usage: Add \a for the ALERT control code
	 * XRegExp.addToken(
	 *   /\\a/,
	 *   function() {return '\\x07';},
	 *   {scope: 'all'}
	 * );
	 * XRegExp('\\a[\\a-\\n]+').test('\x07\n\x07'); // -> true
	 *
	 * // Add the U (ungreedy) flag from PCRE and RE2, which reverses greedy and lazy quantifiers.
	 * // Since `scope` is not specified, it uses 'default' (i.e., transformations apply outside of
	 * // character classes only)
	 * XRegExp.addToken(
	 *   /([?*+]|{\d+(?:,\d*)?})(\??)/,
	 *   function(match) {return match[1] + (match[2] ? '' : '?');},
	 *   {flag: 'U'}
	 * );
	 * XRegExp('a+', 'U').exec('aaa')[0]; // -> 'a'
	 * XRegExp('a+?', 'U').exec('aaa')[0]; // -> 'aaa'
	 */
	    XRegExp.addToken = function(regex, handler, options) {
	        options = options || {};
	        var optionalFlags = options.optionalFlags, i;
	
	        if (options.flag) {
	            registerFlag(options.flag);
	        }
	
	        if (optionalFlags) {
	            optionalFlags = nativ.split.call(optionalFlags, '');
	            for (i = 0; i < optionalFlags.length; ++i) {
	                registerFlag(optionalFlags[i]);
	            }
	        }
	
	        // Add to the private list of syntax tokens
	        tokens.push({
	            regex: copyRegex(regex, {
	                addG: true,
	                addY: hasNativeY,
	                isInternalOnly: true
	            }),
	            handler: handler,
	            scope: options.scope || defaultScope,
	            flag: options.flag,
	            reparse: options.reparse,
	            leadChar: options.leadChar
	        });
	
	        // Reset the pattern cache used by the `XRegExp` constructor, since the same pattern and
	        // flags might now produce different results
	        XRegExp.cache.flush('patterns');
	    };
	
	/**
	 * Caches and returns the result of calling `XRegExp(pattern, flags)`. On any subsequent call with
	 * the same pattern and flag combination, the cached copy of the regex is returned.
	 *
	 * @memberOf XRegExp
	 * @param {String} pattern Regex pattern string.
	 * @param {String} [flags] Any combination of XRegExp flags.
	 * @returns {RegExp} Cached XRegExp object.
	 * @example
	 *
	 * while (match = XRegExp.cache('.', 'gs').exec(str)) {
	 *   // The regex is compiled once only
	 * }
	 */
	    XRegExp.cache = function(pattern, flags) {
	        if (!regexCache[pattern]) {
	            regexCache[pattern] = {};
	        }
	        return regexCache[pattern][flags] || (
	            regexCache[pattern][flags] = XRegExp(pattern, flags)
	        );
	    };
	
	// Intentionally undocumented
	    XRegExp.cache.flush = function(cacheName) {
	        if (cacheName === 'patterns') {
	            // Flush the pattern cache used by the `XRegExp` constructor
	            patternCache = {};
	        } else {
	            // Flush the regex cache populated by `XRegExp.cache`
	            regexCache = {};
	        }
	    };
	
	/**
	 * Escapes any regular expression metacharacters, for use when matching literal strings. The result
	 * can safely be used at any point within a regex that uses any flags.
	 *
	 * @memberOf XRegExp
	 * @param {String} str String to escape.
	 * @returns {String} String with regex metacharacters escaped.
	 * @example
	 *
	 * XRegExp.escape('Escaped? <.>');
	 * // -> 'Escaped\?\ <\.>'
	 */
	    XRegExp.escape = function(str) {
	        return nativ.replace.call(toObject(str), /[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
	    };
	
	/**
	 * Executes a regex search in a specified string. Returns a match array or `null`. If the provided
	 * regex uses named capture, named backreference properties are included on the match array.
	 * Optional `pos` and `sticky` arguments specify the search start position, and whether the match
	 * must start at the specified position only. The `lastIndex` property of the provided regex is not
	 * used, but is updated for compatibility. Also fixes browser bugs compared to the native
	 * `RegExp.prototype.exec` and can be used reliably cross-browser.
	 *
	 * @memberOf XRegExp
	 * @param {String} str String to search.
	 * @param {RegExp} regex Regex to search with.
	 * @param {Number} [pos=0] Zero-based index at which to start the search.
	 * @param {Boolean|String} [sticky=false] Whether the match must start at the specified position
	 *   only. The string `'sticky'` is accepted as an alternative to `true`.
	 * @returns {Array} Match array with named backreference properties, or `null`.
	 * @example
	 *
	 * // Basic use, with named backreference
	 * var match = XRegExp.exec('U+2620', XRegExp('U\\+(?<hex>[0-9A-F]{4})'));
	 * match.hex; // -> '2620'
	 *
	 * // With pos and sticky, in a loop
	 * var pos = 2, result = [], match;
	 * while (match = XRegExp.exec('<1><2><3><4>5<6>', /<(\d)>/, pos, 'sticky')) {
	 *   result.push(match[1]);
	 *   pos = match.index + match[0].length;
	 * }
	 * // result -> ['2', '3', '4']
	 */
	    XRegExp.exec = function(str, regex, pos, sticky) {
	        var cacheKey = 'g',
	            addY = false,
	            match,
	            r2;
	
	        addY = hasNativeY && !!(sticky || (regex.sticky && sticky !== false));
	        if (addY) {
	            cacheKey += 'y';
	        }
	
	        regex[REGEX_DATA] = regex[REGEX_DATA] || {};
	
	        // Shares cached copies with `XRegExp.match`/`replace`
	        r2 = regex[REGEX_DATA][cacheKey] || (
	            regex[REGEX_DATA][cacheKey] = copyRegex(regex, {
	                addG: true,
	                addY: addY,
	                removeY: sticky === false,
	                isInternalOnly: true
	            })
	        );
	
	        r2.lastIndex = pos = pos || 0;
	
	        // Fixed `exec` required for `lastIndex` fix, named backreferences, etc.
	        match = fixed.exec.call(r2, str);
	
	        if (sticky && match && match.index !== pos) {
	            match = null;
	        }
	
	        if (regex.global) {
	            regex.lastIndex = match ? r2.lastIndex : 0;
	        }
	
	        return match;
	    };
	
	/**
	 * Executes a provided function once per regex match. Searches always start at the beginning of the
	 * string and continue until the end, regardless of the state of the regex's `global` property and
	 * initial `lastIndex`.
	 *
	 * @memberOf XRegExp
	 * @param {String} str String to search.
	 * @param {RegExp} regex Regex to search with.
	 * @param {Function} callback Function to execute for each match. Invoked with four arguments:
	 *   <li>The match array, with named backreference properties.
	 *   <li>The zero-based match index.
	 *   <li>The string being traversed.
	 *   <li>The regex object being used to traverse the string.
	 * @example
	 *
	 * // Extracts every other digit from a string
	 * var evens = [];
	 * XRegExp.forEach('1a2345', /\d/, function(match, i) {
	 *   if (i % 2) evens.push(+match[0]);
	 * });
	 * // evens -> [2, 4]
	 */
	    XRegExp.forEach = function(str, regex, callback) {
	        var pos = 0,
	            i = -1,
	            match;
	
	        while ((match = XRegExp.exec(str, regex, pos))) {
	            // Because `regex` is provided to `callback`, the function could use the deprecated/
	            // nonstandard `RegExp.prototype.compile` to mutate the regex. However, since
	            // `XRegExp.exec` doesn't use `lastIndex` to set the search position, this can't lead
	            // to an infinite loop, at least. Actually, because of the way `XRegExp.exec` caches
	            // globalized versions of regexes, mutating the regex will not have any effect on the
	            // iteration or matched strings, which is a nice side effect that brings extra safety
	            callback(match, ++i, str, regex);
	
	            pos = match.index + (match[0].length || 1);
	        }
	    };
	
	/**
	 * Copies a regex object and adds flag `g`. The copy maintains extended data, is augmented with
	 * `XRegExp.prototype` properties, and has a fresh `lastIndex` property (set to zero). Native
	 * regexes are not recompiled using XRegExp syntax.
	 *
	 * @memberOf XRegExp
	 * @param {RegExp} regex Regex to globalize.
	 * @returns {RegExp} Copy of the provided regex with flag `g` added.
	 * @example
	 *
	 * var globalCopy = XRegExp.globalize(/regex/);
	 * globalCopy.global; // -> true
	 */
	    XRegExp.globalize = function(regex) {
	        return copyRegex(regex, {addG: true});
	    };
	
	/**
	 * Installs optional features according to the specified options. Can be undone using
	 * `XRegExp.uninstall`.
	 *
	 * @memberOf XRegExp
	 * @param {Object|String} options Options object or string.
	 * @example
	 *
	 * // With an options object
	 * XRegExp.install({
	 *   // Enables support for astral code points in Unicode addons (implicitly sets flag A)
	 *   astral: true,
	 *
	 *   // DEPRECATED: Overrides native regex methods with fixed/extended versions
	 *   natives: true
	 * });
	 *
	 * // With an options string
	 * XRegExp.install('astral natives');
	 */
	    XRegExp.install = function(options) {
	        options = prepareOptions(options);
	
	        if (!features.astral && options.astral) {
	            setAstral(true);
	        }
	
	        if (!features.natives && options.natives) {
	            setNatives(true);
	        }
	    };
	
	/**
	 * Checks whether an individual optional feature is installed.
	 *
	 * @memberOf XRegExp
	 * @param {String} feature Name of the feature to check. One of:
	 *   <li>`astral`
	 *   <li>`natives`
	 * @returns {Boolean} Whether the feature is installed.
	 * @example
	 *
	 * XRegExp.isInstalled('astral');
	 */
	    XRegExp.isInstalled = function(feature) {
	        return !!(features[feature]);
	    };
	
	/**
	 * Returns `true` if an object is a regex; `false` if it isn't. This works correctly for regexes
	 * created in another frame, when `instanceof` and `constructor` checks would fail.
	 *
	 * @memberOf XRegExp
	 * @param {*} value Object to check.
	 * @returns {Boolean} Whether the object is a `RegExp` object.
	 * @example
	 *
	 * XRegExp.isRegExp('string'); // -> false
	 * XRegExp.isRegExp(/regex/i); // -> true
	 * XRegExp.isRegExp(RegExp('^', 'm')); // -> true
	 * XRegExp.isRegExp(XRegExp('(?s).')); // -> true
	 */
	    XRegExp.isRegExp = function(value) {
	        return toString.call(value) === '[object RegExp]';
	        //return isType(value, 'RegExp');
	    };
	
	/**
	 * Returns the first matched string, or in global mode, an array containing all matched strings.
	 * This is essentially a more convenient re-implementation of `String.prototype.match` that gives
	 * the result types you actually want (string instead of `exec`-style array in match-first mode,
	 * and an empty array instead of `null` when no matches are found in match-all mode). It also lets
	 * you override flag g and ignore `lastIndex`, and fixes browser bugs.
	 *
	 * @memberOf XRegExp
	 * @param {String} str String to search.
	 * @param {RegExp} regex Regex to search with.
	 * @param {String} [scope='one'] Use 'one' to return the first match as a string. Use 'all' to
	 *   return an array of all matched strings. If not explicitly specified and `regex` uses flag g,
	 *   `scope` is 'all'.
	 * @returns {String|Array} In match-first mode: First match as a string, or `null`. In match-all
	 *   mode: Array of all matched strings, or an empty array.
	 * @example
	 *
	 * // Match first
	 * XRegExp.match('abc', /\w/); // -> 'a'
	 * XRegExp.match('abc', /\w/g, 'one'); // -> 'a'
	 * XRegExp.match('abc', /x/g, 'one'); // -> null
	 *
	 * // Match all
	 * XRegExp.match('abc', /\w/g); // -> ['a', 'b', 'c']
	 * XRegExp.match('abc', /\w/, 'all'); // -> ['a', 'b', 'c']
	 * XRegExp.match('abc', /x/, 'all'); // -> []
	 */
	    XRegExp.match = function(str, regex, scope) {
	        var global = (regex.global && scope !== 'one') || scope === 'all',
	            cacheKey = ((global ? 'g' : '') + (regex.sticky ? 'y' : '')) || 'noGY',
	            result,
	            r2;
	
	        regex[REGEX_DATA] = regex[REGEX_DATA] || {};
	
	        // Shares cached copies with `XRegExp.exec`/`replace`
	        r2 = regex[REGEX_DATA][cacheKey] || (
	            regex[REGEX_DATA][cacheKey] = copyRegex(regex, {
	                addG: !!global,
	                removeG: scope === 'one',
	                isInternalOnly: true
	            })
	        );
	
	        result = nativ.match.call(toObject(str), r2);
	
	        if (regex.global) {
	            regex.lastIndex = (
	                (scope === 'one' && result) ?
	                    // Can't use `r2.lastIndex` since `r2` is nonglobal in this case
	                    (result.index + result[0].length) : 0
	            );
	        }
	
	        return global ? (result || []) : (result && result[0]);
	    };
	
	/**
	 * Retrieves the matches from searching a string using a chain of regexes that successively search
	 * within previous matches. The provided `chain` array can contain regexes and or objects with
	 * `regex` and `backref` properties. When a backreference is specified, the named or numbered
	 * backreference is passed forward to the next regex or returned.
	 *
	 * @memberOf XRegExp
	 * @param {String} str String to search.
	 * @param {Array} chain Regexes that each search for matches within preceding results.
	 * @returns {Array} Matches by the last regex in the chain, or an empty array.
	 * @example
	 *
	 * // Basic usage; matches numbers within <b> tags
	 * XRegExp.matchChain('1 <b>2</b> 3 <b>4 a 56</b>', [
	 *   XRegExp('(?is)<b>.*?</b>'),
	 *   /\d+/
	 * ]);
	 * // -> ['2', '4', '56']
	 *
	 * // Passing forward and returning specific backreferences
	 * html = '<a href="http://xregexp.com/api/">XRegExp</a>\
	 *         <a href="http://www.google.com/">Google</a>';
	 * XRegExp.matchChain(html, [
	 *   {regex: /<a href="([^"]+)">/i, backref: 1},
	 *   {regex: XRegExp('(?i)^https?://(?<domain>[^/?#]+)'), backref: 'domain'}
	 * ]);
	 * // -> ['xregexp.com', 'www.google.com']
	 */
	    XRegExp.matchChain = function(str, chain) {
	        return (function recurseChain(values, level) {
	            var item = chain[level].regex ? chain[level] : {regex: chain[level]},
	                matches = [],
	                addMatch = function(match) {
	                    if (item.backref) {
	                        /* Safari 4.0.5 (but not 5.0.5+) inappropriately uses sparse arrays to hold
	                         * the `undefined`s for backreferences to nonparticipating capturing
	                         * groups. In such cases, a `hasOwnProperty` or `in` check on its own would
	                         * inappropriately throw the exception, so also check if the backreference
	                         * is a number that is within the bounds of the array.
	                         */
	                        if (!(match.hasOwnProperty(item.backref) || +item.backref < match.length)) {
	                            throw new ReferenceError('Backreference to undefined group: ' + item.backref);
	                        }
	
	                        matches.push(match[item.backref] || '');
	                    } else {
	                        matches.push(match[0]);
	                    }
	                },
	                i;
	
	            for (i = 0; i < values.length; ++i) {
	                XRegExp.forEach(values[i], item.regex, addMatch);
	            }
	
	            return ((level === chain.length - 1) || !matches.length) ?
	                matches :
	                recurseChain(matches, level + 1);
	        }([str], 0));
	    };
	
	/**
	 * Returns a new string with one or all matches of a pattern replaced. The pattern can be a string
	 * or regex, and the replacement can be a string or a function to be called for each match. To
	 * perform a global search and replace, use the optional `scope` argument or include flag g if using
	 * a regex. Replacement strings can use `${n}` for named and numbered backreferences. Replacement
	 * functions can use named backreferences via `arguments[0].name`. Also fixes browser bugs compared
	 * to the native `String.prototype.replace` and can be used reliably cross-browser.
	 *
	 * @memberOf XRegExp
	 * @param {String} str String to search.
	 * @param {RegExp|String} search Search pattern to be replaced.
	 * @param {String|Function} replacement Replacement string or a function invoked to create it.
	 *   Replacement strings can include special replacement syntax:
	 *     <li>$$ - Inserts a literal $ character.
	 *     <li>$&, $0 - Inserts the matched substring.
	 *     <li>$` - Inserts the string that precedes the matched substring (left context).
	 *     <li>$' - Inserts the string that follows the matched substring (right context).
	 *     <li>$n, $nn - Where n/nn are digits referencing an existent capturing group, inserts
	 *       backreference n/nn.
	 *     <li>${n} - Where n is a name or any number of digits that reference an existent capturing
	 *       group, inserts backreference n.
	 *   Replacement functions are invoked with three or more arguments:
	 *     <li>The matched substring (corresponds to $& above). Named backreferences are accessible as
	 *       properties of this first argument.
	 *     <li>0..n arguments, one for each backreference (corresponding to $1, $2, etc. above).
	 *     <li>The zero-based index of the match within the total search string.
	 *     <li>The total string being searched.
	 * @param {String} [scope='one'] Use 'one' to replace the first match only, or 'all'. If not
	 *   explicitly specified and using a regex with flag g, `scope` is 'all'.
	 * @returns {String} New string with one or all matches replaced.
	 * @example
	 *
	 * // Regex search, using named backreferences in replacement string
	 * var name = XRegExp('(?<first>\\w+) (?<last>\\w+)');
	 * XRegExp.replace('John Smith', name, '${last}, ${first}');
	 * // -> 'Smith, John'
	 *
	 * // Regex search, using named backreferences in replacement function
	 * XRegExp.replace('John Smith', name, function(match) {
	 *   return match.last + ', ' + match.first;
	 * });
	 * // -> 'Smith, John'
	 *
	 * // String search, with replace-all
	 * XRegExp.replace('RegExp builds RegExps', 'RegExp', 'XRegExp', 'all');
	 * // -> 'XRegExp builds XRegExps'
	 */
	    XRegExp.replace = function(str, search, replacement, scope) {
	        var isRegex = XRegExp.isRegExp(search),
	            global = (search.global && scope !== 'one') || scope === 'all',
	            cacheKey = ((global ? 'g' : '') + (search.sticky ? 'y' : '')) || 'noGY',
	            s2 = search,
	            result;
	
	        if (isRegex) {
	            search[REGEX_DATA] = search[REGEX_DATA] || {};
	
	            // Shares cached copies with `XRegExp.exec`/`match`. Since a copy is used, `search`'s
	            // `lastIndex` isn't updated *during* replacement iterations
	            s2 = search[REGEX_DATA][cacheKey] || (
	                search[REGEX_DATA][cacheKey] = copyRegex(search, {
	                    addG: !!global,
	                    removeG: scope === 'one',
	                    isInternalOnly: true
	                })
	            );
	        } else if (global) {
	            s2 = new RegExp(XRegExp.escape(String(search)), 'g');
	        }
	
	        // Fixed `replace` required for named backreferences, etc.
	        result = fixed.replace.call(toObject(str), s2, replacement);
	
	        if (isRegex && search.global) {
	            // Fixes IE, Safari bug (last tested IE 9, Safari 5.1)
	            search.lastIndex = 0;
	        }
	
	        return result;
	    };
	
	/**
	 * Performs batch processing of string replacements. Used like `XRegExp.replace`, but accepts an
	 * array of replacement details. Later replacements operate on the output of earlier replacements.
	 * Replacement details are accepted as an array with a regex or string to search for, the
	 * replacement string or function, and an optional scope of 'one' or 'all'. Uses the XRegExp
	 * replacement text syntax, which supports named backreference properties via `${name}`.
	 *
	 * @memberOf XRegExp
	 * @param {String} str String to search.
	 * @param {Array} replacements Array of replacement detail arrays.
	 * @returns {String} New string with all replacements.
	 * @example
	 *
	 * str = XRegExp.replaceEach(str, [
	 *   [XRegExp('(?<name>a)'), 'z${name}'],
	 *   [/b/gi, 'y'],
	 *   [/c/g, 'x', 'one'], // scope 'one' overrides /g
	 *   [/d/, 'w', 'all'],  // scope 'all' overrides lack of /g
	 *   ['e', 'v', 'all'],  // scope 'all' allows replace-all for strings
	 *   [/f/g, function($0) {
	 *     return $0.toUpperCase();
	 *   }]
	 * ]);
	 */
	    XRegExp.replaceEach = function(str, replacements) {
	        var i, r;
	
	        for (i = 0; i < replacements.length; ++i) {
	            r = replacements[i];
	            str = XRegExp.replace(str, r[0], r[1], r[2]);
	        }
	
	        return str;
	    };
	
	/**
	 * Splits a string into an array of strings using a regex or string separator. Matches of the
	 * separator are not included in the result array. However, if `separator` is a regex that contains
	 * capturing groups, backreferences are spliced into the result each time `separator` is matched.
	 * Fixes browser bugs compared to the native `String.prototype.split` and can be used reliably
	 * cross-browser.
	 *
	 * @memberOf XRegExp
	 * @param {String} str String to split.
	 * @param {RegExp|String} separator Regex or string to use for separating the string.
	 * @param {Number} [limit] Maximum number of items to include in the result array.
	 * @returns {Array} Array of substrings.
	 * @example
	 *
	 * // Basic use
	 * XRegExp.split('a b c', ' ');
	 * // -> ['a', 'b', 'c']
	 *
	 * // With limit
	 * XRegExp.split('a b c', ' ', 2);
	 * // -> ['a', 'b']
	 *
	 * // Backreferences in result array
	 * XRegExp.split('..word1..', /([a-z]+)(\d+)/i);
	 * // -> ['..', 'word', '1', '..']
	 */
	    XRegExp.split = function(str, separator, limit) {
	        return fixed.split.call(toObject(str), separator, limit);
	    };
	
	/**
	 * Executes a regex search in a specified string. Returns `true` or `false`. Optional `pos` and
	 * `sticky` arguments specify the search start position, and whether the match must start at the
	 * specified position only. The `lastIndex` property of the provided regex is not used, but is
	 * updated for compatibility. Also fixes browser bugs compared to the native
	 * `RegExp.prototype.test` and can be used reliably cross-browser.
	 *
	 * @memberOf XRegExp
	 * @param {String} str String to search.
	 * @param {RegExp} regex Regex to search with.
	 * @param {Number} [pos=0] Zero-based index at which to start the search.
	 * @param {Boolean|String} [sticky=false] Whether the match must start at the specified position
	 *   only. The string `'sticky'` is accepted as an alternative to `true`.
	 * @returns {Boolean} Whether the regex matched the provided value.
	 * @example
	 *
	 * // Basic use
	 * XRegExp.test('abc', /c/); // -> true
	 *
	 * // With pos and sticky
	 * XRegExp.test('abc', /c/, 0, 'sticky'); // -> false
	 * XRegExp.test('abc', /c/, 2, 'sticky'); // -> true
	 */
	    XRegExp.test = function(str, regex, pos, sticky) {
	        // Do this the easy way :-)
	        return !!XRegExp.exec(str, regex, pos, sticky);
	    };
	
	/**
	 * Uninstalls optional features according to the specified options. All optional features start out
	 * uninstalled, so this is used to undo the actions of `XRegExp.install`.
	 *
	 * @memberOf XRegExp
	 * @param {Object|String} options Options object or string.
	 * @example
	 *
	 * // With an options object
	 * XRegExp.uninstall({
	 *   // Disables support for astral code points in Unicode addons
	 *   astral: true,
	 *
	 *   // DEPRECATED: Restores native regex methods
	 *   natives: true
	 * });
	 *
	 * // With an options string
	 * XRegExp.uninstall('astral natives');
	 */
	    XRegExp.uninstall = function(options) {
	        options = prepareOptions(options);
	
	        if (features.astral && options.astral) {
	            setAstral(false);
	        }
	
	        if (features.natives && options.natives) {
	            setNatives(false);
	        }
	    };
	
	/**
	 * Returns an XRegExp object that is the union of the given patterns. Patterns can be provided as
	 * regex objects or strings. Metacharacters are escaped in patterns provided as strings.
	 * Backreferences in provided regex objects are automatically renumbered to work correctly within
	 * the larger combined pattern. Native flags used by provided regexes are ignored in favor of the
	 * `flags` argument.
	 *
	 * @memberOf XRegExp
	 * @param {Array} patterns Regexes and strings to combine.
	 * @param {String} [flags] Any combination of XRegExp flags.
	 * @returns {RegExp} Union of the provided regexes and strings.
	 * @example
	 *
	 * XRegExp.union(['a+b*c', /(dogs)\1/, /(cats)\1/], 'i');
	 * // -> /a\+b\*c|(dogs)\1|(cats)\2/i
	 */
	    XRegExp.union = function(patterns, flags) {
	        var parts = /(\()(?!\?)|\\([1-9]\d*)|\\[\s\S]|\[(?:[^\\\]]|\\[\s\S])*]/g,
	            output = [],
	            numCaptures = 0,
	            numPriorCaptures,
	            captureNames,
	            pattern,
	            rewrite = function(match, paren, backref) {
	                var name = captureNames[numCaptures - numPriorCaptures];
	
	                // Capturing group
	                if (paren) {
	                    ++numCaptures;
	                    // If the current capture has a name, preserve the name
	                    if (name) {
	                        return '(?<' + name + '>';
	                    }
	                // Backreference
	                } else if (backref) {
	                    // Rewrite the backreference
	                    return '\\' + (+backref + numPriorCaptures);
	                }
	
	                return match;
	            },
	            i;
	
	        if (!(isType(patterns, 'Array') && patterns.length)) {
	            throw new TypeError('Must provide a nonempty array of patterns to merge');
	        }
	
	        for (i = 0; i < patterns.length; ++i) {
	            pattern = patterns[i];
	
	            if (XRegExp.isRegExp(pattern)) {
	                numPriorCaptures = numCaptures;
	                captureNames = (pattern[REGEX_DATA] && pattern[REGEX_DATA].captureNames) || [];
	
	                // Rewrite backreferences. Passing to XRegExp dies on octals and ensures patterns
	                // are independently valid; helps keep this simple. Named captures are put back
	                output.push(nativ.replace.call(XRegExp(pattern.source).source, parts, rewrite));
	            } else {
	                output.push(XRegExp.escape(pattern));
	            }
	        }
	
	        return XRegExp(output.join('|'), flags);
	    };
	
	/* ==============================
	 * Fixed/extended native methods
	 * ============================== */
	
	/**
	 * Adds named capture support (with backreferences returned as `result.name`), and fixes browser
	 * bugs in the native `RegExp.prototype.exec`. Calling `XRegExp.install('natives')` uses this to
	 * override the native method. Use via `XRegExp.exec` without overriding natives.
	 *
	 * @private
	 * @param {String} str String to search.
	 * @returns {Array} Match array with named backreference properties, or `null`.
	 */
	    fixed.exec = function(str) {
	        var origLastIndex = this.lastIndex,
	            match = nativ.exec.apply(this, arguments),
	            name,
	            r2,
	            i;
	
	        if (match) {
	            // Fix browsers whose `exec` methods don't return `undefined` for nonparticipating
	            // capturing groups. This fixes IE 5.5-8, but not IE 9's quirks mode or emulation of
	            // older IEs. IE 9 in standards mode follows the spec
	            if (!correctExecNpcg && match.length > 1 && indexOf(match, '') > -1) {
	                r2 = copyRegex(this, {
	                    removeG: true,
	                    isInternalOnly: true
	                });
	                // Using `str.slice(match.index)` rather than `match[0]` in case lookahead allowed
	                // matching due to characters outside the match
	                nativ.replace.call(String(str).slice(match.index), r2, function() {
	                    var len = arguments.length, i;
	                    // Skip index 0 and the last 2
	                    for (i = 1; i < len - 2; ++i) {
	                        if (arguments[i] === undefined) {
	                            match[i] = undefined;
	                        }
	                    }
	                });
	            }
	
	            // Attach named capture properties
	            if (this[REGEX_DATA] && this[REGEX_DATA].captureNames) {
	                // Skip index 0
	                for (i = 1; i < match.length; ++i) {
	                    name = this[REGEX_DATA].captureNames[i - 1];
	                    if (name) {
	                        match[name] = match[i];
	                    }
	                }
	            }
	
	            // Fix browsers that increment `lastIndex` after zero-length matches
	            if (this.global && !match[0].length && (this.lastIndex > match.index)) {
	                this.lastIndex = match.index;
	            }
	        }
	
	        if (!this.global) {
	            // Fixes IE, Opera bug (last tested IE 9, Opera 11.6)
	            this.lastIndex = origLastIndex;
	        }
	
	        return match;
	    };
	
	/**
	 * Fixes browser bugs in the native `RegExp.prototype.test`. Calling `XRegExp.install('natives')`
	 * uses this to override the native method.
	 *
	 * @private
	 * @param {String} str String to search.
	 * @returns {Boolean} Whether the regex matched the provided value.
	 */
	    fixed.test = function(str) {
	        // Do this the easy way :-)
	        return !!fixed.exec.call(this, str);
	    };
	
	/**
	 * Adds named capture support (with backreferences returned as `result.name`), and fixes browser
	 * bugs in the native `String.prototype.match`. Calling `XRegExp.install('natives')` uses this to
	 * override the native method.
	 *
	 * @private
	 * @param {RegExp|*} regex Regex to search with. If not a regex object, it is passed to `RegExp`.
	 * @returns {Array} If `regex` uses flag g, an array of match strings or `null`. Without flag g,
	 *   the result of calling `regex.exec(this)`.
	 */
	    fixed.match = function(regex) {
	        var result;
	
	        if (!XRegExp.isRegExp(regex)) {
	            // Use the native `RegExp` rather than `XRegExp`
	            regex = new RegExp(regex);
	        } else if (regex.global) {
	            result = nativ.match.apply(this, arguments);
	            // Fixes IE bug
	            regex.lastIndex = 0;
	
	            return result;
	        }
	
	        return fixed.exec.call(regex, toObject(this));
	    };
	
	/**
	 * Adds support for `${n}` tokens for named and numbered backreferences in replacement text, and
	 * provides named backreferences to replacement functions as `arguments[0].name`. Also fixes browser
	 * bugs in replacement text syntax when performing a replacement using a nonregex search value, and
	 * the value of a replacement regex's `lastIndex` property during replacement iterations and upon
	 * completion. Calling `XRegExp.install('natives')` uses this to override the native method. Note
	 * that this doesn't support SpiderMonkey's proprietary third (`flags`) argument. Use via
	 * `XRegExp.replace` without overriding natives.
	 *
	 * @private
	 * @param {RegExp|String} search Search pattern to be replaced.
	 * @param {String|Function} replacement Replacement string or a function invoked to create it.
	 * @returns {String} New string with one or all matches replaced.
	 */
	    fixed.replace = function(search, replacement) {
	        var isRegex = XRegExp.isRegExp(search),
	            origLastIndex,
	            captureNames,
	            result;
	
	        if (isRegex) {
	            if (search[REGEX_DATA]) {
	                captureNames = search[REGEX_DATA].captureNames;
	            }
	            // Only needed if `search` is nonglobal
	            origLastIndex = search.lastIndex;
	        } else {
	            search += ''; // Type-convert
	        }
	
	        // Don't use `typeof`; some older browsers return 'function' for regex objects
	        if (isType(replacement, 'Function')) {
	            // Stringifying `this` fixes a bug in IE < 9 where the last argument in replacement
	            // functions isn't type-converted to a string
	            result = nativ.replace.call(String(this), search, function() {
	                var args = arguments, i;
	                if (captureNames) {
	                    // Change the `arguments[0]` string primitive to a `String` object that can
	                    // store properties. This really does need to use `String` as a constructor
	                    args[0] = new String(args[0]);
	                    // Store named backreferences on the first argument
	                    for (i = 0; i < captureNames.length; ++i) {
	                        if (captureNames[i]) {
	                            args[0][captureNames[i]] = args[i + 1];
	                        }
	                    }
	                }
	                // Update `lastIndex` before calling `replacement`. Fixes IE, Chrome, Firefox,
	                // Safari bug (last tested IE 9, Chrome 17, Firefox 11, Safari 5.1)
	                if (isRegex && search.global) {
	                    search.lastIndex = args[args.length - 2] + args[0].length;
	                }
	                // ES6 specs the context for replacement functions as `undefined`
	                return replacement.apply(undefined, args);
	            });
	        } else {
	            // Ensure that the last value of `args` will be a string when given nonstring `this`,
	            // while still throwing on null or undefined context
	            result = nativ.replace.call(this == null ? this : String(this), search, function() {
	                // Keep this function's `arguments` available through closure
	                var args = arguments;
	                return nativ.replace.call(String(replacement), replacementToken, function($0, $1, $2) {
	                    var n;
	                    // Named or numbered backreference with curly braces
	                    if ($1) {
	                        // XRegExp behavior for `${n}`:
	                        // 1. Backreference to numbered capture, if `n` is an integer. Use `0` for
	                        //    for the entire match. Any number of leading zeros may be used.
	                        // 2. Backreference to named capture `n`, if it exists and is not an
	                        //    integer overridden by numbered capture. In practice, this does not
	                        //    overlap with numbered capture since XRegExp does not allow named
	                        //    capture to use a bare integer as the name.
	                        // 3. If the name or number does not refer to an existing capturing group,
	                        //    it's an error.
	                        n = +$1; // Type-convert; drop leading zeros
	                        if (n <= args.length - 3) {
	                            return args[n] || '';
	                        }
	                        // Groups with the same name is an error, else would need `lastIndexOf`
	                        n = captureNames ? indexOf(captureNames, $1) : -1;
	                        if (n < 0) {
	                            throw new SyntaxError('Backreference to undefined group ' + $0);
	                        }
	                        return args[n + 1] || '';
	                    }
	                    // Else, special variable or numbered backreference without curly braces
	                    if ($2 === '$') { // $$
	                        return '$';
	                    }
	                    if ($2 === '&' || +$2 === 0) { // $&, $0 (not followed by 1-9), $00
	                        return args[0];
	                    }
	                    if ($2 === '`') { // $` (left context)
	                        return args[args.length - 1].slice(0, args[args.length - 2]);
	                    }
	                    if ($2 === "'") { // $' (right context)
	                        return args[args.length - 1].slice(args[args.length - 2] + args[0].length);
	                    }
	                    // Else, numbered backreference without curly braces
	                    $2 = +$2; // Type-convert; drop leading zero
	                    // XRegExp behavior for `$n` and `$nn`:
	                    // - Backrefs end after 1 or 2 digits. Use `${..}` for more digits.
	                    // - `$1` is an error if no capturing groups.
	                    // - `$10` is an error if less than 10 capturing groups. Use `${1}0` instead.
	                    // - `$01` is `$1` if at least one capturing group, else it's an error.
	                    // - `$0` (not followed by 1-9) and `$00` are the entire match.
	                    // Native behavior, for comparison:
	                    // - Backrefs end after 1 or 2 digits. Cannot reference capturing group 100+.
	                    // - `$1` is a literal `$1` if no capturing groups.
	                    // - `$10` is `$1` followed by a literal `0` if less than 10 capturing groups.
	                    // - `$01` is `$1` if at least one capturing group, else it's a literal `$01`.
	                    // - `$0` is a literal `$0`.
	                    if (!isNaN($2)) {
	                        if ($2 > args.length - 3) {
	                            throw new SyntaxError('Backreference to undefined group ' + $0);
	                        }
	                        return args[$2] || '';
	                    }
	                    // `$` followed by an unsupported char is an error, unlike native JS
	                    throw new SyntaxError('Invalid token ' + $0);
	                });
	            });
	        }
	
	        if (isRegex) {
	            if (search.global) {
	                // Fixes IE, Safari bug (last tested IE 9, Safari 5.1)
	                search.lastIndex = 0;
	            } else {
	                // Fixes IE, Opera bug (last tested IE 9, Opera 11.6)
	                search.lastIndex = origLastIndex;
	            }
	        }
	
	        return result;
	    };
	
	/**
	 * Fixes browser bugs in the native `String.prototype.split`. Calling `XRegExp.install('natives')`
	 * uses this to override the native method. Use via `XRegExp.split` without overriding natives.
	 *
	 * @private
	 * @param {RegExp|String} separator Regex or string to use for separating the string.
	 * @param {Number} [limit] Maximum number of items to include in the result array.
	 * @returns {Array} Array of substrings.
	 */
	    fixed.split = function(separator, limit) {
	        if (!XRegExp.isRegExp(separator)) {
	            // Browsers handle nonregex split correctly, so use the faster native method
	            return nativ.split.apply(this, arguments);
	        }
	
	        var str = String(this),
	            output = [],
	            origLastIndex = separator.lastIndex,
	            lastLastIndex = 0,
	            lastLength;
	
	        // Values for `limit`, per the spec:
	        // If undefined: pow(2,32) - 1
	        // If 0, Infinity, or NaN: 0
	        // If positive number: limit = floor(limit); if (limit >= pow(2,32)) limit -= pow(2,32);
	        // If negative number: pow(2,32) - floor(abs(limit))
	        // If other: Type-convert, then use the above rules
	        // This line fails in very strange ways for some values of `limit` in Opera 10.5-10.63,
	        // unless Opera Dragonfly is open (go figure). It works in at least Opera 9.5-10.1 and 11+
	        limit = (limit === undefined ? -1 : limit) >>> 0;
	
	        XRegExp.forEach(str, separator, function(match) {
	            // This condition is not the same as `if (match[0].length)`
	            if ((match.index + match[0].length) > lastLastIndex) {
	                output.push(str.slice(lastLastIndex, match.index));
	                if (match.length > 1 && match.index < str.length) {
	                    Array.prototype.push.apply(output, match.slice(1));
	                }
	                lastLength = match[0].length;
	                lastLastIndex = match.index + lastLength;
	            }
	        });
	
	        if (lastLastIndex === str.length) {
	            if (!nativ.test.call(separator, '') || lastLength) {
	                output.push('');
	            }
	        } else {
	            output.push(str.slice(lastLastIndex));
	        }
	
	        separator.lastIndex = origLastIndex;
	        return output.length > limit ? output.slice(0, limit) : output;
	    };
	
	/* ==============================
	 * Built-in syntax/flag tokens
	 * ============================== */
	
	/*
	 * Letter escapes that natively match literal characters: `\a`, `\A`, etc. These should be
	 * SyntaxErrors but are allowed in web reality. XRegExp makes them errors for cross-browser
	 * consistency and to reserve their syntax, but lets them be superseded by addons.
	 */
	    XRegExp.addToken(
	        /\\([ABCE-RTUVXYZaeg-mopqyz]|c(?![A-Za-z])|u(?![\dA-Fa-f]{4}|{[\dA-Fa-f]+})|x(?![\dA-Fa-f]{2}))/,
	        function(match, scope) {
	            // \B is allowed in default scope only
	            if (match[1] === 'B' && scope === defaultScope) {
	                return match[0];
	            }
	            throw new SyntaxError('Invalid escape ' + match[0]);
	        },
	        {
	            scope: 'all',
	            leadChar: '\\'
	        }
	    );
	
	/*
	 * Unicode code point escape with curly braces: `\u{N..}`. `N..` is any one or more digit
	 * hexadecimal number from 0-10FFFF, and can include leading zeros. Requires the native ES6 `u` flag
	 * to support code points greater than U+FFFF. Avoids converting code points above U+FFFF to
	 * surrogate pairs (which could be done without flag `u`), since that could lead to broken behavior
	 * if you follow a `\u{N..}` token that references a code point above U+FFFF with a quantifier, or
	 * if you use the same in a character class.
	 */
	    XRegExp.addToken(
	        /\\u{([\dA-Fa-f]+)}/,
	        function(match, scope, flags) {
	            var code = dec(match[1]);
	            if (code > 0x10FFFF) {
	                throw new SyntaxError('Invalid Unicode code point ' + match[0]);
	            }
	            if (code <= 0xFFFF) {
	                // Converting to \uNNNN avoids needing to escape the literal character and keep it
	                // separate from preceding tokens
	                return '\\u' + pad4(hex(code));
	            }
	            // If `code` is between 0xFFFF and 0x10FFFF, require and defer to native handling
	            if (hasNativeU && flags.indexOf('u') > -1) {
	                return match[0];
	            }
	            throw new SyntaxError('Cannot use Unicode code point above \\u{FFFF} without flag u');
	        },
	        {
	            scope: 'all',
	            leadChar: '\\'
	        }
	    );
	
	/*
	 * Empty character class: `[]` or `[^]`. This fixes a critical cross-browser syntax inconsistency.
	 * Unless this is standardized (per the ES spec), regex syntax can't be accurately parsed because
	 * character class endings can't be determined.
	 */
	    XRegExp.addToken(
	        /\[(\^?)]/,
	        function(match) {
	            // For cross-browser compatibility with ES3, convert [] to \b\B and [^] to [\s\S].
	            // (?!) should work like \b\B, but is unreliable in some versions of Firefox
	            return match[1] ? '[\\s\\S]' : '\\b\\B';
	        },
	        {leadChar: '['}
	    );
	
	/*
	 * Comment pattern: `(?# )`. Inline comments are an alternative to the line comments allowed in
	 * free-spacing mode (flag x).
	 */
	    XRegExp.addToken(
	        /\(\?#[^)]*\)/,
	        function(match, scope, flags) {
	            // Keep tokens separated unless the following token is a quantifier
	            return isQuantifierNext(match.input, match.index + match[0].length, flags) ?
	                '' : '(?:)';
	        },
	        {leadChar: '('}
	    );
	
	/*
	 * Whitespace and line comments, in free-spacing mode (aka extended mode, flag x) only.
	 */
	    XRegExp.addToken(
	        /\s+|#.*/,
	        function(match, scope, flags) {
	            // Keep tokens separated unless the following token is a quantifier
	            return isQuantifierNext(match.input, match.index + match[0].length, flags) ?
	                '' : '(?:)';
	        },
	        {flag: 'x'}
	    );
	
	/*
	 * Dot, in dotall mode (aka singleline mode, flag s) only.
	 */
	    XRegExp.addToken(
	        /\./,
	        function() {
	            return '[\\s\\S]';
	        },
	        {
	            flag: 's',
	            leadChar: '.'
	        }
	    );
	
	/*
	 * Named backreference: `\k<name>`. Backreference names can use the characters A-Z, a-z, 0-9, _,
	 * and $ only. Also allows numbered backreferences as `\k<n>`.
	 */
	    XRegExp.addToken(
	        /\\k<([\w$]+)>/,
	        function(match) {
	            // Groups with the same name is an error, else would need `lastIndexOf`
	            var index = isNaN(match[1]) ? (indexOf(this.captureNames, match[1]) + 1) : +match[1],
	                endIndex = match.index + match[0].length;
	            if (!index || index > this.captureNames.length) {
	                throw new SyntaxError('Backreference to undefined group ' + match[0]);
	            }
	            // Keep backreferences separate from subsequent literal numbers
	            return '\\' + index + (
	                endIndex === match.input.length || isNaN(match.input.charAt(endIndex)) ?
	                    '' : '(?:)'
	            );
	        },
	        {leadChar: '\\'}
	    );
	
	/*
	 * Numbered backreference or octal, plus any following digits: `\0`, `\11`, etc. Octals except `\0`
	 * not followed by 0-9 and backreferences to unopened capture groups throw an error. Other matches
	 * are returned unaltered. IE < 9 doesn't support backreferences above `\99` in regex syntax.
	 */
	    XRegExp.addToken(
	        /\\(\d+)/,
	        function(match, scope) {
	            if (
	                !(
	                    scope === defaultScope &&
	                    /^[1-9]/.test(match[1]) &&
	                    +match[1] <= this.captureNames.length
	                ) &&
	                match[1] !== '0'
	            ) {
	                throw new SyntaxError('Cannot use octal escape or backreference to undefined group ' +
	                    match[0]);
	            }
	            return match[0];
	        },
	        {
	            scope: 'all',
	            leadChar: '\\'
	        }
	    );
	
	/*
	 * Named capturing group; match the opening delimiter only: `(?<name>`. Capture names can use the
	 * characters A-Z, a-z, 0-9, _, and $ only. Names can't be integers. Supports Python-style
	 * `(?P<name>` as an alternate syntax to avoid issues in some older versions of Opera which natively
	 * supported the Python-style syntax. Otherwise, XRegExp might treat numbered backreferences to
	 * Python-style named capture as octals.
	 */
	    XRegExp.addToken(
	        /\(\?P?<([\w$]+)>/,
	        function(match) {
	            // Disallow bare integers as names because named backreferences are added to match
	            // arrays and therefore numeric properties may lead to incorrect lookups
	            if (!isNaN(match[1])) {
	                throw new SyntaxError('Cannot use integer as capture name ' + match[0]);
	            }
	            if (match[1] === 'length' || match[1] === '__proto__') {
	                throw new SyntaxError('Cannot use reserved word as capture name ' + match[0]);
	            }
	            if (indexOf(this.captureNames, match[1]) > -1) {
	                throw new SyntaxError('Cannot use same name for multiple groups ' + match[0]);
	            }
	            this.captureNames.push(match[1]);
	            this.hasNamedCapture = true;
	            return '(';
	        },
	        {leadChar: '('}
	    );
	
	/*
	 * Capturing group; match the opening parenthesis only. Required for support of named capturing
	 * groups. Also adds explicit capture mode (flag n).
	 */
	    XRegExp.addToken(
	        /\((?!\?)/,
	        function(match, scope, flags) {
	            if (flags.indexOf('n') > -1) {
	                return '(?:';
	            }
	            this.captureNames.push(null);
	            return '(';
	        },
	        {
	            optionalFlags: 'n',
	            leadChar: '('
	        }
	    );
	
	/* ==============================
	 * Expose XRegExp
	 * ============================== */
	
	    module.exports = XRegExp;


/***/ })

/******/ })
});
;


// WEBPACK FOOTER //
// vendor.js